
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

parcelRegister("2Tywo", function(module, exports) {

$parcel$export(module.exports, "_config", () => _config);
$parcel$export(module.exports, "_isString", () => _isString);
$parcel$export(module.exports, "_isUndefined", () => _isUndefined);
$parcel$export(module.exports, "_numExp", () => _numExp);
$parcel$export(module.exports, "_numWithUnitExp", () => _numWithUnitExp);
$parcel$export(module.exports, "_relExp", () => _relExp);
$parcel$export(module.exports, "gsap", () => gsap);
$parcel$export(module.exports, "_missingPlugin", () => _missingPlugin);
$parcel$export(module.exports, "_plugins", () => _plugins);
$parcel$export(module.exports, "GSCache", () => GSCache);
$parcel$export(module.exports, "_getCache", () => _getCache);
$parcel$export(module.exports, "_getProperty", () => _getProperty);
$parcel$export(module.exports, "_forEachName", () => _forEachName);
$parcel$export(module.exports, "_round", () => _round);
$parcel$export(module.exports, "_parseRelative", () => _parseRelative);
$parcel$export(module.exports, "_ticker", () => _ticker);
$parcel$export(module.exports, "getUnit", () => getUnit);
$parcel$export(module.exports, "_replaceRandom", () => _replaceRandom);
$parcel$export(module.exports, "_getSetter", () => _getSetter);
$parcel$export(module.exports, "PropTween", () => PropTween);
$parcel$export(module.exports, "_colorExp", () => _colorExp);
$parcel$export(module.exports, "_colorStringFilter", () => _colorStringFilter);
$parcel$export(module.exports, "_renderComplexString", () => _renderComplexString);
$parcel$export(module.exports, "_checkPlugin", () => _checkPlugin);
$parcel$export(module.exports, "_sortPropTweensByPriority", () => _sortPropTweensByPriority);
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
/*!
 * GSAP 3.12.5
 * https://gsap.com
 *
 * @license Copyright 2008-2024, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var _config = {
    autoSleep: 120,
    force3D: "auto",
    nullTargetWarn: 1,
    units: {
        lineHeight: ""
    }
}, _defaults = {
    duration: .5,
    overwrite: false,
    delay: 0
}, _suppressOverwrites, _reverting, _context, _bigNum = 1e8, _tinyNum = 1 / _bigNum, _2PI = Math.PI * 2, _HALF_PI = _2PI / 4, _gsID = 0, _sqrt = Math.sqrt, _cos = Math.cos, _sin = Math.sin, _isString = function _isString(value) {
    return typeof value === "string";
}, _isFunction = function _isFunction(value) {
    return typeof value === "function";
}, _isNumber = function _isNumber(value) {
    return typeof value === "number";
}, _isUndefined = function _isUndefined(value) {
    return typeof value === "undefined";
}, _isObject = function _isObject(value) {
    return typeof value === "object";
}, _isNotFalse = function _isNotFalse(value) {
    return value !== false;
}, _windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, _isFuncOrString = function _isFuncOrString(value) {
    return _isFunction(value) || _isString(value);
}, _isTypedArray = typeof ArrayBuffer === "function" && ArrayBuffer.isView || function() {}, // note: IE10 has ArrayBuffer, but NOT ArrayBuffer.isView().
_isArray = Array.isArray, _strictNumExp = /(?:-?\.?\d|\.)+/gi, //only numbers (including negatives and decimals) but NOT relative values.
_numExp = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g, //finds any numbers, including ones that start with += or -=, negative numbers, and ones in scientific notation like 1e-8.
_numWithUnitExp = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g, _complexStringNumExp = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi, //duplicate so that while we're looping through matches from exec(), it doesn't contaminate the lastIndex of _numExp which we use to search for colors too.
_relExp = /[+-]=-?[.\d]+/, _delimitedValueExp = /[^,'"\[\]\s]+/gi, // previously /[#\-+.]*\b[a-z\d\-=+%.]+/gi but didn't catch special characters.
_unitExp = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i, _globalTimeline, _win, _coreInitted, _doc, _globals = {}, _installScope = {}, _coreReady, _install = function _install(scope) {
    return (_installScope = _merge(scope, _globals)) && gsap;
}, _missingPlugin = function _missingPlugin(property, value) {
    return console.warn("Invalid property", property, "set to", value, "Missing plugin? gsap.registerPlugin()");
}, _warn = function _warn(message, suppress) {
    return !suppress && console.warn(message);
}, _addGlobal = function _addGlobal(name, obj) {
    return name && (_globals[name] = obj) && _installScope && (_installScope[name] = obj) || _globals;
}, _emptyFunc = function _emptyFunc() {
    return 0;
}, _startAtRevertConfig = {
    suppressEvents: true,
    isStart: true,
    kill: false
}, _revertConfigNoKill = {
    suppressEvents: true,
    kill: false
}, _revertConfig = {
    suppressEvents: true
}, _reservedProps = {}, _lazyTweens = [], _lazyLookup = {}, _lastRenderedFrame, _plugins = {}, _effects = {}, _nextGCFrame = 30, _harnessPlugins = [], _callbackNames = "", _harness = function _harness(targets) {
    var target = targets[0], harnessPlugin, i;
    _isObject(target) || _isFunction(target) || (targets = [
        targets
    ]);
    if (!(harnessPlugin = (target._gsap || {}).harness)) {
        // find the first target with a harness. We assume targets passed into an animation will be of similar type, meaning the same kind of harness can be used for them all (performance optimization)
        i = _harnessPlugins.length;
        while(i-- && !_harnessPlugins[i].targetTest(target));
        harnessPlugin = _harnessPlugins[i];
    }
    i = targets.length;
    while(i--)targets[i] && (targets[i]._gsap || (targets[i]._gsap = new GSCache(targets[i], harnessPlugin))) || targets.splice(i, 1);
    return targets;
}, _getCache = function _getCache(target) {
    return target._gsap || _harness(toArray(target))[0]._gsap;
}, _getProperty = function _getProperty(target, property, v) {
    return (v = target[property]) && _isFunction(v) ? target[property]() : _isUndefined(v) && target.getAttribute && target.getAttribute(property) || v;
}, _forEachName = function _forEachName(names, func) {
    return (names = names.split(",")).forEach(func) || names;
}, //split a comma-delimited list of names into an array, then run a forEach() function and return the split array (this is just a way to consolidate/shorten some code).
_round = function _round(value) {
    return Math.round(value * 100000) / 100000 || 0;
}, _roundPrecise = function _roundPrecise(value) {
    return Math.round(value * 10000000) / 10000000 || 0;
}, // increased precision mostly for timing values.
_parseRelative = function _parseRelative(start, value) {
    var operator = value.charAt(0), end = parseFloat(value.substr(2));
    start = parseFloat(start);
    return operator === "+" ? start + end : operator === "-" ? start - end : operator === "*" ? start * end : start / end;
}, _arrayContainsAny = function _arrayContainsAny(toSearch, toFind) {
    //searches one array to find matches for any of the items in the toFind array. As soon as one is found, it returns true. It does NOT return all the matches; it's simply a boolean search.
    var l = toFind.length, i = 0;
    for(; toSearch.indexOf(toFind[i]) < 0 && ++i < l;);
    return i < l;
}, _lazyRender = function _lazyRender() {
    var l = _lazyTweens.length, a = _lazyTweens.slice(0), i, tween;
    _lazyLookup = {};
    _lazyTweens.length = 0;
    for(i = 0; i < l; i++){
        tween = a[i];
        tween && tween._lazy && (tween.render(tween._lazy[0], tween._lazy[1], true)._lazy = 0);
    }
}, _lazySafeRender = function _lazySafeRender(animation, time, suppressEvents, force) {
    _lazyTweens.length && !_reverting && _lazyRender();
    animation.render(time, suppressEvents, force || _reverting && time < 0 && (animation._initted || animation._startAt));
    _lazyTweens.length && !_reverting && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when someone calls seek() or time() or progress(), they expect an immediate render.
}, _numericIfPossible = function _numericIfPossible(value) {
    var n = parseFloat(value);
    return (n || n === 0) && (value + "").match(_delimitedValueExp).length < 2 ? n : _isString(value) ? value.trim() : value;
}, _passThrough = function _passThrough(p) {
    return p;
}, _setDefaults = function _setDefaults(obj, defaults) {
    for(var p in defaults)p in obj || (obj[p] = defaults[p]);
    return obj;
}, _setKeyframeDefaults = function _setKeyframeDefaults(excludeDuration) {
    return function(obj, defaults) {
        for(var p in defaults)p in obj || p === "duration" && excludeDuration || p === "ease" || (obj[p] = defaults[p]);
    };
}, _merge = function _merge(base, toMerge) {
    for(var p in toMerge)base[p] = toMerge[p];
    return base;
}, _mergeDeep = function _mergeDeep(base, toMerge) {
    for(var p in toMerge)p !== "__proto__" && p !== "constructor" && p !== "prototype" && (base[p] = _isObject(toMerge[p]) ? _mergeDeep(base[p] || (base[p] = {}), toMerge[p]) : toMerge[p]);
    return base;
}, _copyExcluding = function _copyExcluding(obj, excluding) {
    var copy = {}, p;
    for(p in obj)p in excluding || (copy[p] = obj[p]);
    return copy;
}, _inheritDefaults = function _inheritDefaults(vars) {
    var parent = vars.parent || _globalTimeline, func = vars.keyframes ? _setKeyframeDefaults(_isArray(vars.keyframes)) : _setDefaults;
    if (_isNotFalse(vars.inherit)) while(parent){
        func(vars, parent.vars.defaults);
        parent = parent.parent || parent._dp;
    }
    return vars;
}, _arraysMatch = function _arraysMatch(a1, a2) {
    var i = a1.length, match = i === a2.length;
    while(match && i-- && a1[i] === a2[i]);
    return i < 0;
}, _addLinkedListItem = function _addLinkedListItem(parent, child, firstProp, lastProp, sortBy) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = parent[lastProp], t;
    if (sortBy) {
        t = child[sortBy];
        while(prev && prev[sortBy] > t)prev = prev._prev;
    }
    if (prev) {
        child._next = prev._next;
        prev._next = child;
    } else {
        child._next = parent[firstProp];
        parent[firstProp] = child;
    }
    if (child._next) child._next._prev = child;
    else parent[lastProp] = child;
    child._prev = prev;
    child.parent = child._dp = parent;
    return child;
}, _removeLinkedListItem = function _removeLinkedListItem(parent, child, firstProp, lastProp) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = child._prev, next = child._next;
    if (prev) prev._next = next;
    else if (parent[firstProp] === child) parent[firstProp] = next;
    if (next) next._prev = prev;
    else if (parent[lastProp] === child) parent[lastProp] = prev;
    child._next = child._prev = child.parent = null; // don't delete the _dp just so we can revert if necessary. But parent should be null to indicate the item isn't in a linked list.
}, _removeFromParent = function _removeFromParent(child, onlyIfParentHasAutoRemove) {
    child.parent && (!onlyIfParentHasAutoRemove || child.parent.autoRemoveChildren) && child.parent.remove && child.parent.remove(child);
    child._act = 0;
}, _uncache = function _uncache(animation, child) {
    if (animation && (!child || child._end > animation._dur || child._start < 0)) {
        // performance optimization: if a child animation is passed in we should only uncache if that child EXTENDS the animation (its end time is beyond the end)
        var a = animation;
        while(a){
            a._dirty = 1;
            a = a.parent;
        }
    }
    return animation;
}, _recacheAncestors = function _recacheAncestors(animation) {
    var parent = animation.parent;
    while(parent && parent.parent){
        //sometimes we must force a re-sort of all children and update the duration/totalDuration of all ancestor timelines immediately in case, for example, in the middle of a render loop, one tween alters another tween's timeScale which shoves its startTime before 0, forcing the parent timeline to shift around and shiftChildren() which could affect that next tween's render (startTime). Doesn't matter for the root timeline though.
        parent._dirty = 1;
        parent.totalDuration();
        parent = parent.parent;
    }
    return animation;
}, _rewindStartAt = function _rewindStartAt(tween, totalTime, suppressEvents, force) {
    return tween._startAt && (_reverting ? tween._startAt.revert(_revertConfigNoKill) : tween.vars.immediateRender && !tween.vars.autoRevert || tween._startAt.render(totalTime, true, force));
}, _hasNoPausedAncestors = function _hasNoPausedAncestors(animation) {
    return !animation || animation._ts && _hasNoPausedAncestors(animation.parent);
}, _elapsedCycleDuration = function _elapsedCycleDuration(animation) {
    return animation._repeat ? _animationCycle(animation._tTime, animation = animation.duration() + animation._rDelay) * animation : 0;
}, // feed in the totalTime and cycleDuration and it'll return the cycle (iteration minus 1) and if the playhead is exactly at the very END, it will NOT bump up to the next cycle.
_animationCycle = function _animationCycle(tTime, cycleDuration) {
    var whole = Math.floor(tTime /= cycleDuration);
    return tTime && whole === tTime ? whole - 1 : whole;
}, _parentToChildTotalTime = function _parentToChildTotalTime(parentTime, child) {
    return (parentTime - child._start) * child._ts + (child._ts >= 0 ? 0 : child._dirty ? child.totalDuration() : child._tDur);
}, _setEnd = function _setEnd(animation) {
    return animation._end = _roundPrecise(animation._start + (animation._tDur / Math.abs(animation._ts || animation._rts || _tinyNum) || 0));
}, _alignPlayhead = function _alignPlayhead(animation, totalTime) {
    // adjusts the animation's _start and _end according to the provided totalTime (only if the parent's smoothChildTiming is true and the animation isn't paused). It doesn't do any rendering or forcing things back into parent timelines, etc. - that's what totalTime() is for.
    var parent = animation._dp;
    if (parent && parent.smoothChildTiming && animation._ts) {
        animation._start = _roundPrecise(parent._time - (animation._ts > 0 ? totalTime / animation._ts : ((animation._dirty ? animation.totalDuration() : animation._tDur) - totalTime) / -animation._ts));
        _setEnd(animation);
        parent._dirty || _uncache(parent, animation); //for performance improvement. If the parent's cache is already dirty, it already took care of marking the ancestors as dirty too, so skip the function call here.
    }
    return animation;
}, /*
_totalTimeToTime = (clampedTotalTime, duration, repeat, repeatDelay, yoyo) => {
	let cycleDuration = duration + repeatDelay,
		time = _round(clampedTotalTime % cycleDuration);
	if (time > duration) {
		time = duration;
	}
	return (yoyo && (~~(clampedTotalTime / cycleDuration) & 1)) ? duration - time : time;
},
*/ _postAddChecks = function _postAddChecks(timeline, child) {
    var t;
    if (child._time || !child._dur && child._initted || child._start < timeline._time && (child._dur || !child.add)) {
        // in case, for example, the _start is moved on a tween that has already rendered, or if it's being inserted into a timeline BEFORE where the playhead is currently. Imagine it's at its end state, then the startTime is moved WAY later (after the end of this timeline), it should render at its beginning. Special case: if it's a timeline (has .add() method) and no duration, we can skip rendering because the user may be populating it AFTER adding it to a parent timeline (unconventional, but possible, and we wouldn't want it to get removed if the parent's autoRemoveChildren is true).
        t = _parentToChildTotalTime(timeline.rawTime(), child);
        if (!child._dur || _clamp(0, child.totalDuration(), t) - child._tTime > _tinyNum) child.render(t, true);
    } //if the timeline has already ended but the inserted tween/timeline extends the duration, we should enable this timeline again so that it renders properly. We should also align the playhead with the parent timeline's when appropriate.
    if (_uncache(timeline, child)._dp && timeline._initted && timeline._time >= timeline._dur && timeline._ts) {
        //in case any of the ancestors had completed but should now be enabled...
        if (timeline._dur < timeline.duration()) {
            t = timeline;
            while(t._dp){
                t.rawTime() >= 0 && t.totalTime(t._tTime); //moves the timeline (shifts its startTime) if necessary, and also enables it. If it's currently zero, though, it may not be scheduled to render until later so there's no need to force it to align with the current playhead position. Only move to catch up with the playhead.
                t = t._dp;
            }
        }
        timeline._zTime = -_tinyNum; // helps ensure that the next render() will be forced (crossingStart = true in render()), even if the duration hasn't changed (we're adding a child which would need to get rendered). Definitely an edge case. Note: we MUST do this AFTER the loop above where the totalTime() might trigger a render() because this _addToTimeline() method gets called from the Animation constructor, BEFORE tweens even record their targets, etc. so we wouldn't want things to get triggered in the wrong order.
    }
}, _addToTimeline = function _addToTimeline(timeline, child, position, skipChecks) {
    child.parent && _removeFromParent(child);
    child._start = _roundPrecise((_isNumber(position) ? position : position || timeline !== _globalTimeline ? _parsePosition(timeline, position, child) : timeline._time) + child._delay);
    child._end = _roundPrecise(child._start + (child.totalDuration() / Math.abs(child.timeScale()) || 0));
    _addLinkedListItem(timeline, child, "_first", "_last", timeline._sort ? "_start" : 0);
    _isFromOrFromStart(child) || (timeline._recent = child);
    skipChecks || _postAddChecks(timeline, child);
    timeline._ts < 0 && _alignPlayhead(timeline, timeline._tTime); // if the timeline is reversed and the new child makes it longer, we may need to adjust the parent's _start (push it back)
    return timeline;
}, _scrollTrigger = function _scrollTrigger(animation, trigger) {
    return (_globals.ScrollTrigger || _missingPlugin("scrollTrigger", trigger)) && _globals.ScrollTrigger.create(trigger, animation);
}, _attemptInitTween = function _attemptInitTween(tween, time, force, suppressEvents, tTime) {
    _initTween(tween, time, tTime);
    if (!tween._initted) return 1;
    if (!force && tween._pt && !_reverting && (tween._dur && tween.vars.lazy !== false || !tween._dur && tween.vars.lazy) && _lastRenderedFrame !== _ticker.frame) {
        _lazyTweens.push(tween);
        tween._lazy = [
            tTime,
            suppressEvents
        ];
        return 1;
    }
}, _parentPlayheadIsBeforeStart = function _parentPlayheadIsBeforeStart(_ref) {
    var parent = _ref.parent;
    return parent && parent._ts && parent._initted && !parent._lock && (parent.rawTime() < 0 || _parentPlayheadIsBeforeStart(parent));
}, // check parent's _lock because when a timeline repeats/yoyos and does its artificial wrapping, we shouldn't force the ratio back to 0
_isFromOrFromStart = function _isFromOrFromStart(_ref2) {
    var data = _ref2.data;
    return data === "isFromStart" || data === "isStart";
}, _renderZeroDurationTween = function _renderZeroDurationTween(tween, totalTime, suppressEvents, force) {
    var prevRatio = tween.ratio, ratio = totalTime < 0 || !totalTime && (!tween._start && _parentPlayheadIsBeforeStart(tween) && !(!tween._initted && _isFromOrFromStart(tween)) || (tween._ts < 0 || tween._dp._ts < 0) && !_isFromOrFromStart(tween)) ? 0 : 1, // if the tween or its parent is reversed and the totalTime is 0, we should go to a ratio of 0. Edge case: if a from() or fromTo() stagger tween is placed later in a timeline, the "startAt" zero-duration tween could initially render at a time when the parent timeline's playhead is technically BEFORE where this tween is, so make sure that any "from" and "fromTo" startAt tweens are rendered the first time at a ratio of 1.
    repeatDelay = tween._rDelay, tTime = 0, pt, iteration, prevIteration;
    if (repeatDelay && tween._repeat) {
        // in case there's a zero-duration tween that has a repeat with a repeatDelay
        tTime = _clamp(0, tween._tDur, totalTime);
        iteration = _animationCycle(tTime, repeatDelay);
        tween._yoyo && iteration & 1 && (ratio = 1 - ratio);
        if (iteration !== _animationCycle(tween._tTime, repeatDelay)) {
            // if iteration changed
            prevRatio = 1 - ratio;
            tween.vars.repeatRefresh && tween._initted && tween.invalidate();
        }
    }
    if (ratio !== prevRatio || _reverting || force || tween._zTime === _tinyNum || !totalTime && tween._zTime) {
        if (!tween._initted && _attemptInitTween(tween, totalTime, force, suppressEvents, tTime)) // if we render the very beginning (time == 0) of a fromTo(), we must force the render (normal tweens wouldn't need to render at a time of 0 when the prevTime was also 0). This is also mandatory to make sure overwriting kicks in immediately.
        return;
        prevIteration = tween._zTime;
        tween._zTime = totalTime || (suppressEvents ? _tinyNum : 0); // when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
        suppressEvents || (suppressEvents = totalTime && !prevIteration); // if it was rendered previously at exactly 0 (_zTime) and now the playhead is moving away, DON'T fire callbacks otherwise they'll seem like duplicates.
        tween.ratio = ratio;
        tween._from && (ratio = 1 - ratio);
        tween._time = 0;
        tween._tTime = tTime;
        pt = tween._pt;
        while(pt){
            pt.r(ratio, pt.d);
            pt = pt._next;
        }
        totalTime < 0 && _rewindStartAt(tween, totalTime, suppressEvents, true);
        tween._onUpdate && !suppressEvents && _callback(tween, "onUpdate");
        tTime && tween._repeat && !suppressEvents && tween.parent && _callback(tween, "onRepeat");
        if ((totalTime >= tween._tDur || totalTime < 0) && tween.ratio === ratio) {
            ratio && _removeFromParent(tween, 1);
            if (!suppressEvents && !_reverting) {
                _callback(tween, ratio ? "onComplete" : "onReverseComplete", true);
                tween._prom && tween._prom();
            }
        }
    } else if (!tween._zTime) tween._zTime = totalTime;
}, _findNextPauseTween = function _findNextPauseTween(animation, prevTime, time) {
    var child;
    if (time > prevTime) {
        child = animation._first;
        while(child && child._start <= time){
            if (child.data === "isPause" && child._start > prevTime) return child;
            child = child._next;
        }
    } else {
        child = animation._last;
        while(child && child._start >= time){
            if (child.data === "isPause" && child._start < prevTime) return child;
            child = child._prev;
        }
    }
}, _setDuration = function _setDuration(animation, duration, skipUncache, leavePlayhead) {
    var repeat = animation._repeat, dur = _roundPrecise(duration) || 0, totalProgress = animation._tTime / animation._tDur;
    totalProgress && !leavePlayhead && (animation._time *= dur / animation._dur);
    animation._dur = dur;
    animation._tDur = !repeat ? dur : repeat < 0 ? 1e10 : _roundPrecise(dur * (repeat + 1) + animation._rDelay * repeat);
    totalProgress > 0 && !leavePlayhead && _alignPlayhead(animation, animation._tTime = animation._tDur * totalProgress);
    animation.parent && _setEnd(animation);
    skipUncache || _uncache(animation.parent, animation);
    return animation;
}, _onUpdateTotalDuration = function _onUpdateTotalDuration(animation) {
    return animation instanceof Timeline ? _uncache(animation) : _setDuration(animation, animation._dur);
}, _zeroPosition = {
    _start: 0,
    endTime: _emptyFunc,
    totalDuration: _emptyFunc
}, _parsePosition = function _parsePosition(animation, position, percentAnimation) {
    var labels = animation.labels, recent = animation._recent || _zeroPosition, clippedDuration = animation.duration() >= _bigNum ? recent.endTime(false) : animation._dur, //in case there's a child that infinitely repeats, users almost never intend for the insertion point of a new child to be based on a SUPER long value like that so we clip it and assume the most recently-added child's endTime should be used instead.
    i, offset, isPercent;
    if (_isString(position) && (isNaN(position) || position in labels)) {
        //if the string is a number like "1", check to see if there's a label with that name, otherwise interpret it as a number (absolute value).
        offset = position.charAt(0);
        isPercent = position.substr(-1) === "%";
        i = position.indexOf("=");
        if (offset === "<" || offset === ">") {
            i >= 0 && (position = position.replace(/=/, ""));
            return (offset === "<" ? recent._start : recent.endTime(recent._repeat >= 0)) + (parseFloat(position.substr(1)) || 0) * (isPercent ? (i < 0 ? recent : percentAnimation).totalDuration() / 100 : 1);
        }
        if (i < 0) {
            position in labels || (labels[position] = clippedDuration);
            return labels[position];
        }
        offset = parseFloat(position.charAt(i - 1) + position.substr(i + 1));
        if (isPercent && percentAnimation) offset = offset / 100 * (_isArray(percentAnimation) ? percentAnimation[0] : percentAnimation).totalDuration();
        return i > 1 ? _parsePosition(animation, position.substr(0, i - 1), percentAnimation) + offset : clippedDuration + offset;
    }
    return position == null ? clippedDuration : +position;
}, _createTweenType = function _createTweenType(type, params, timeline) {
    var isLegacy = _isNumber(params[1]), varsIndex = (isLegacy ? 2 : 1) + (type < 2 ? 0 : 1), vars = params[varsIndex], irVars, parent;
    isLegacy && (vars.duration = params[1]);
    vars.parent = timeline;
    if (type) {
        irVars = vars;
        parent = timeline;
        while(parent && !("immediateRender" in irVars)){
            // inheritance hasn't happened yet, but someone may have set a default in an ancestor timeline. We could do vars.immediateRender = _isNotFalse(_inheritDefaults(vars).immediateRender) but that'd exact a slight performance penalty because _inheritDefaults() also runs in the Tween constructor. We're paying a small kb price here to gain speed.
            irVars = parent.vars.defaults || {};
            parent = _isNotFalse(parent.vars.inherit) && parent.parent;
        }
        vars.immediateRender = _isNotFalse(irVars.immediateRender);
        type < 2 ? vars.runBackwards = 1 : vars.startAt = params[varsIndex - 1]; // "from" vars
    }
    return new Tween(params[0], vars, params[varsIndex + 1]);
}, _conditionalReturn = function _conditionalReturn(value, func) {
    return value || value === 0 ? func(value) : func;
}, _clamp = function _clamp(min, max, value) {
    return value < min ? min : value > max ? max : value;
}, getUnit = function getUnit(value, v) {
    return !_isString(value) || !(v = _unitExp.exec(value)) ? "" : v[1];
}, // note: protect against padded numbers as strings, like "100.100". That shouldn't return "00" as the unit. If it's numeric, return no unit.
clamp = function clamp(min, max, value) {
    return _conditionalReturn(value, function(v) {
        return _clamp(min, max, v);
    });
}, _slice = [].slice, _isArrayLike = function _isArrayLike(value, nonEmpty) {
    return value && _isObject(value) && "length" in value && (!nonEmpty && !value.length || value.length - 1 in value && _isObject(value[0])) && !value.nodeType && value !== _win;
}, _flatten = function _flatten(ar, leaveStrings, accumulator) {
    if (accumulator === void 0) accumulator = [];
    return ar.forEach(function(value) {
        var _accumulator;
        return _isString(value) && !leaveStrings || _isArrayLike(value, 1) ? (_accumulator = accumulator).push.apply(_accumulator, toArray(value)) : accumulator.push(value);
    }) || accumulator;
}, //takes any value and returns an array. If it's a string (and leaveStrings isn't true), it'll use document.querySelectorAll() and convert that to an array. It'll also accept iterables like jQuery objects.
toArray = function toArray(value, scope, leaveStrings) {
    return _context && !scope && _context.selector ? _context.selector(value) : _isString(value) && !leaveStrings && (_coreInitted || !_wake()) ? _slice.call((scope || _doc).querySelectorAll(value), 0) : _isArray(value) ? _flatten(value, leaveStrings) : _isArrayLike(value) ? _slice.call(value, 0) : value ? [
        value
    ] : [];
}, selector = function selector(value) {
    value = toArray(value)[0] || _warn("Invalid scope") || {};
    return function(v) {
        var el = value.current || value.nativeElement || value;
        return toArray(v, el.querySelectorAll ? el : el === value ? _warn("Invalid scope") || _doc.createElement("div") : value);
    };
}, shuffle = function shuffle(a) {
    return a.sort(function() {
        return .5 - Math.random();
    });
}, // alternative that's a bit faster and more reliably diverse but bigger:   for (let j, v, i = a.length; i; j = Math.floor(Math.random() * i), v = a[--i], a[i] = a[j], a[j] = v); return a;
//for distributing values across an array. Can accept a number, a function or (most commonly) a function which can contain the following properties: {base, amount, from, ease, grid, axis, length, each}. Returns a function that expects the following parameters: index, target, array. Recognizes the following
distribute = function distribute(v) {
    if (_isFunction(v)) return v;
    var vars = _isObject(v) ? v : {
        each: v
    }, //n:1 is just to indicate v was a number; we leverage that later to set v according to the length we get. If a number is passed in, we treat it like the old stagger value where 0.1, for example, would mean that things would be distributed with 0.1 between each element in the array rather than a total "amount" that's chunked out among them all.
    ease = _parseEase(vars.ease), from = vars.from || 0, base = parseFloat(vars.base) || 0, cache = {}, isDecimal = from > 0 && from < 1, ratios = isNaN(from) || isDecimal, axis = vars.axis, ratioX = from, ratioY = from;
    if (_isString(from)) ratioX = ratioY = ({
        center: .5,
        edges: .5,
        end: 1
    })[from] || 0;
    else if (!isDecimal && ratios) {
        ratioX = from[0];
        ratioY = from[1];
    }
    return function(i, target, a) {
        var l = (a || vars).length, distances = cache[l], originX, originY, x, y, d, j, max, min, wrapAt;
        if (!distances) {
            wrapAt = vars.grid === "auto" ? 0 : (vars.grid || [
                1,
                _bigNum
            ])[1];
            if (!wrapAt) {
                max = -_bigNum;
                while(max < (max = a[wrapAt++].getBoundingClientRect().left) && wrapAt < l);
                wrapAt < l && wrapAt--;
            }
            distances = cache[l] = [];
            originX = ratios ? Math.min(wrapAt, l) * ratioX - .5 : from % wrapAt;
            originY = wrapAt === _bigNum ? 0 : ratios ? l * ratioY / wrapAt - .5 : from / wrapAt | 0;
            max = 0;
            min = _bigNum;
            for(j = 0; j < l; j++){
                x = j % wrapAt - originX;
                y = originY - (j / wrapAt | 0);
                distances[j] = d = !axis ? _sqrt(x * x + y * y) : Math.abs(axis === "y" ? y : x);
                d > max && (max = d);
                d < min && (min = d);
            }
            from === "random" && shuffle(distances);
            distances.max = max - min;
            distances.min = min;
            distances.v = l = (parseFloat(vars.amount) || parseFloat(vars.each) * (wrapAt > l ? l - 1 : !axis ? Math.max(wrapAt, l / wrapAt) : axis === "y" ? l / wrapAt : wrapAt) || 0) * (from === "edges" ? -1 : 1);
            distances.b = l < 0 ? base - l : base;
            distances.u = getUnit(vars.amount || vars.each) || 0; //unit
            ease = ease && l < 0 ? _invertEase(ease) : ease;
        }
        l = (distances[i] - distances.min) / distances.max || 0;
        return _roundPrecise(distances.b + (ease ? ease(l) : l) * distances.v) + distances.u; //round in order to work around floating point errors
    };
}, _roundModifier = function _roundModifier(v) {
    //pass in 0.1 get a function that'll round to the nearest tenth, or 5 to round to the closest 5, or 0.001 to the closest 1000th, etc.
    var p = Math.pow(10, ((v + "").split(".")[1] || "").length); //to avoid floating point math errors (like 24 * 0.1 == 2.4000000000000004), we chop off at a specific number of decimal places (much faster than toFixed())
    return function(raw) {
        var n = _roundPrecise(Math.round(parseFloat(raw) / v) * v * p);
        return (n - n % 1) / p + (_isNumber(raw) ? 0 : getUnit(raw)); // n - n % 1 replaces Math.floor() in order to handle negative values properly. For example, Math.floor(-150.00000000000003) is 151!
    };
}, snap = function snap(snapTo, value) {
    var isArray = _isArray(snapTo), radius, is2D;
    if (!isArray && _isObject(snapTo)) {
        radius = isArray = snapTo.radius || _bigNum;
        if (snapTo.values) {
            snapTo = toArray(snapTo.values);
            if (is2D = !_isNumber(snapTo[0])) radius *= radius; //performance optimization so we don't have to Math.sqrt() in the loop.
        } else snapTo = _roundModifier(snapTo.increment);
    }
    return _conditionalReturn(value, !isArray ? _roundModifier(snapTo) : _isFunction(snapTo) ? function(raw) {
        is2D = snapTo(raw);
        return Math.abs(is2D - raw) <= radius ? is2D : raw;
    } : function(raw) {
        var x = parseFloat(is2D ? raw.x : raw), y = parseFloat(is2D ? raw.y : 0), min = _bigNum, closest = 0, i = snapTo.length, dx, dy;
        while(i--){
            if (is2D) {
                dx = snapTo[i].x - x;
                dy = snapTo[i].y - y;
                dx = dx * dx + dy * dy;
            } else dx = Math.abs(snapTo[i] - x);
            if (dx < min) {
                min = dx;
                closest = i;
            }
        }
        closest = !radius || min <= radius ? snapTo[closest] : raw;
        return is2D || closest === raw || _isNumber(raw) ? closest : closest + getUnit(raw);
    });
}, random = function random(min, max, roundingIncrement, returnFunction) {
    return _conditionalReturn(_isArray(min) ? !max : roundingIncrement === true ? (roundingIncrement = 0, false) : !returnFunction, function() {
        return _isArray(min) ? min[~~(Math.random() * min.length)] : (roundingIncrement = roundingIncrement || 1e-5, returnFunction = roundingIncrement < 1 ? Math.pow(10, (roundingIncrement + "").length - 2) : 1) && Math.floor(Math.round((min - roundingIncrement / 2 + Math.random() * (max - min + roundingIncrement * .99)) / roundingIncrement) * roundingIncrement * returnFunction) / returnFunction;
    });
}, pipe = function pipe() {
    for(var _len = arguments.length, functions = new Array(_len), _key = 0; _key < _len; _key++)functions[_key] = arguments[_key];
    return function(value) {
        return functions.reduce(function(v, f) {
            return f(v);
        }, value);
    };
}, unitize = function unitize(func, unit) {
    return function(value) {
        return func(parseFloat(value)) + (unit || getUnit(value));
    };
}, normalize = function normalize(min, max, value) {
    return mapRange(min, max, 0, 1, value);
}, _wrapArray = function _wrapArray(a, wrapper, value) {
    return _conditionalReturn(value, function(index) {
        return a[~~wrapper(index)];
    });
}, wrap = function wrap(min, max, value) {
    // NOTE: wrap() CANNOT be an arrow function! A very odd compiling bug causes problems (unrelated to GSAP).
    var range = max - min;
    return _isArray(min) ? _wrapArray(min, wrap(0, min.length), max) : _conditionalReturn(value, function(value) {
        return (range + (value - min) % range) % range + min;
    });
}, wrapYoyo = function wrapYoyo(min, max, value) {
    var range = max - min, total = range * 2;
    return _isArray(min) ? _wrapArray(min, wrapYoyo(0, min.length - 1), max) : _conditionalReturn(value, function(value) {
        value = (total + (value - min) % total) % total || 0;
        return min + (value > range ? total - value : value);
    });
}, _replaceRandom = function _replaceRandom(value) {
    //replaces all occurrences of random(...) in a string with the calculated random value. can be a range like random(-100, 100, 5) or an array like random([0, 100, 500])
    var prev = 0, s = "", i, nums, end, isArray;
    while(~(i = value.indexOf("random(", prev))){
        end = value.indexOf(")", i);
        isArray = value.charAt(i + 7) === "[";
        nums = value.substr(i + 7, end - i - 7).match(isArray ? _delimitedValueExp : _strictNumExp);
        s += value.substr(prev, i - prev) + random(isArray ? nums : +nums[0], isArray ? 0 : +nums[1], +nums[2] || 1e-5);
        prev = end + 1;
    }
    return s + value.substr(prev, value.length - prev);
}, mapRange = function mapRange(inMin, inMax, outMin, outMax, value) {
    var inRange = inMax - inMin, outRange = outMax - outMin;
    return _conditionalReturn(value, function(value) {
        return outMin + ((value - inMin) / inRange * outRange || 0);
    });
}, interpolate = function interpolate(start, end, progress, mutate) {
    var func = isNaN(start + end) ? 0 : function(p) {
        return (1 - p) * start + p * end;
    };
    if (!func) {
        var isString = _isString(start), master = {}, p, i, interpolators, l, il;
        progress === true && (mutate = 1) && (progress = null);
        if (isString) {
            start = {
                p: start
            };
            end = {
                p: end
            };
        } else if (_isArray(start) && !_isArray(end)) {
            interpolators = [];
            l = start.length;
            il = l - 2;
            for(i = 1; i < l; i++)interpolators.push(interpolate(start[i - 1], start[i])); //build the interpolators up front as a performance optimization so that when the function is called many times, it can just reuse them.
            l--;
            func = function func(p) {
                p *= l;
                var i = Math.min(il, ~~p);
                return interpolators[i](p - i);
            };
            progress = end;
        } else if (!mutate) start = _merge(_isArray(start) ? [] : {}, start);
        if (!interpolators) {
            for(p in end)_addPropTween.call(master, start, p, "get", end[p]);
            func = function func(p) {
                return _renderPropTweens(p, master) || (isString ? start.p : start);
            };
        }
    }
    return _conditionalReturn(progress, func);
}, _getLabelInDirection = function _getLabelInDirection(timeline, fromTime, backward) {
    //used for nextLabel() and previousLabel()
    var labels = timeline.labels, min = _bigNum, p, distance, label;
    for(p in labels){
        distance = labels[p] - fromTime;
        if (distance < 0 === !!backward && distance && min > (distance = Math.abs(distance))) {
            label = p;
            min = distance;
        }
    }
    return label;
}, _callback = function _callback(animation, type, executeLazyFirst) {
    var v = animation.vars, callback = v[type], prevContext = _context, context = animation._ctx, params, scope, result;
    if (!callback) return;
    params = v[type + "Params"];
    scope = v.callbackScope || animation;
    executeLazyFirst && _lazyTweens.length && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onUpdate on a timeline that reports/checks tweened values.
    context && (_context = context);
    result = params ? callback.apply(scope, params) : callback.call(scope);
    _context = prevContext;
    return result;
}, _interrupt = function _interrupt(animation) {
    _removeFromParent(animation);
    animation.scrollTrigger && animation.scrollTrigger.kill(!!_reverting);
    animation.progress() < 1 && _callback(animation, "onInterrupt");
    return animation;
}, _quickTween, _registerPluginQueue = [], _createPlugin = function _createPlugin(config) {
    if (!config) return;
    config = !config.name && config["default"] || config; // UMD packaging wraps things oddly, so for example MotionPathHelper becomes {MotionPathHelper:MotionPathHelper, default:MotionPathHelper}.
    if (_windowExists() || config.headless) {
        // edge case: some build tools may pass in a null/undefined value
        var name = config.name, isFunc = _isFunction(config), Plugin = name && !isFunc && config.init ? function() {
            this._props = [];
        } : config, //in case someone passes in an object that's not a plugin, like CustomEase
        instanceDefaults = {
            init: _emptyFunc,
            render: _renderPropTweens,
            add: _addPropTween,
            kill: _killPropTweensOf,
            modifier: _addPluginModifier,
            rawVars: 0
        }, statics = {
            targetTest: 0,
            get: 0,
            getSetter: _getSetter,
            aliases: {},
            register: 0
        };
        _wake();
        if (config !== Plugin) {
            if (_plugins[name]) return;
            _setDefaults(Plugin, _setDefaults(_copyExcluding(config, instanceDefaults), statics)); //static methods
            _merge(Plugin.prototype, _merge(instanceDefaults, _copyExcluding(config, statics))); //instance methods
            _plugins[Plugin.prop = name] = Plugin;
            if (config.targetTest) {
                _harnessPlugins.push(Plugin);
                _reservedProps[name] = 1;
            }
            name = (name === "css" ? "CSS" : name.charAt(0).toUpperCase() + name.substr(1)) + "Plugin"; //for the global name. "motionPath" should become MotionPathPlugin
        }
        _addGlobal(name, Plugin);
        config.register && config.register(gsap, Plugin, PropTween);
    } else _registerPluginQueue.push(config);
}, /*
 * --------------------------------------------------------------------------------------
 * COLORS
 * --------------------------------------------------------------------------------------
 */ _255 = 255, _colorLookup = {
    aqua: [
        0,
        _255,
        _255
    ],
    lime: [
        0,
        _255,
        0
    ],
    silver: [
        192,
        192,
        192
    ],
    black: [
        0,
        0,
        0
    ],
    maroon: [
        128,
        0,
        0
    ],
    teal: [
        0,
        128,
        128
    ],
    blue: [
        0,
        0,
        _255
    ],
    navy: [
        0,
        0,
        128
    ],
    white: [
        _255,
        _255,
        _255
    ],
    olive: [
        128,
        128,
        0
    ],
    yellow: [
        _255,
        _255,
        0
    ],
    orange: [
        _255,
        165,
        0
    ],
    gray: [
        128,
        128,
        128
    ],
    purple: [
        128,
        0,
        128
    ],
    green: [
        0,
        128,
        0
    ],
    red: [
        _255,
        0,
        0
    ],
    pink: [
        _255,
        192,
        203
    ],
    cyan: [
        0,
        _255,
        _255
    ],
    transparent: [
        _255,
        _255,
        _255,
        0
    ]
}, // possible future idea to replace the hard-coded color name values - put this in the ticker.wake() where we set the _doc:
// let ctx = _doc.createElement("canvas").getContext("2d");
// _forEachName("aqua,lime,silver,black,maroon,teal,blue,navy,white,olive,yellow,orange,gray,purple,green,red,pink,cyan", color => {ctx.fillStyle = color; _colorLookup[color] = splitColor(ctx.fillStyle)});
_hue = function _hue(h, m1, m2) {
    h += h < 0 ? 1 : h > 1 ? -1 : 0;
    return (h * 6 < 1 ? m1 + (m2 - m1) * h * 6 : h < .5 ? m2 : h * 3 < 2 ? m1 + (m2 - m1) * (2 / 3 - h) * 6 : m1) * _255 + .5 | 0;
}, splitColor = function splitColor(v, toHSL, forceAlpha) {
    var a = !v ? _colorLookup.black : _isNumber(v) ? [
        v >> 16,
        v >> 8 & _255,
        v & _255
    ] : 0, r, g, b, h, s, l, max, min, d, wasHSL;
    if (!a) {
        if (v.substr(-1) === ",") //sometimes a trailing comma is included and we should chop it off (typically from a comma-delimited list of values like a textShadow:"2px 2px 2px blue, 5px 5px 5px rgb(255,0,0)" - in this example "blue," has a trailing comma. We could strip it out inside parseComplex() but we'd need to do it to the beginning and ending values plus it wouldn't provide protection from other potential scenarios like if the user passes in a similar value.
        v = v.substr(0, v.length - 1);
        if (_colorLookup[v]) a = _colorLookup[v];
        else if (v.charAt(0) === "#") {
            if (v.length < 6) {
                //for shorthand like #9F0 or #9F0F (could have alpha)
                r = v.charAt(1);
                g = v.charAt(2);
                b = v.charAt(3);
                v = "#" + r + r + g + g + b + b + (v.length === 5 ? v.charAt(4) + v.charAt(4) : "");
            }
            if (v.length === 9) {
                // hex with alpha, like #fd5e53ff
                a = parseInt(v.substr(1, 6), 16);
                return [
                    a >> 16,
                    a >> 8 & _255,
                    a & _255,
                    parseInt(v.substr(7), 16) / 255
                ];
            }
            v = parseInt(v.substr(1), 16);
            a = [
                v >> 16,
                v >> 8 & _255,
                v & _255
            ];
        } else if (v.substr(0, 3) === "hsl") {
            a = wasHSL = v.match(_strictNumExp);
            if (!toHSL) {
                h = +a[0] % 360 / 360;
                s = +a[1] / 100;
                l = +a[2] / 100;
                g = l <= .5 ? l * (s + 1) : l + s - l * s;
                r = l * 2 - g;
                a.length > 3 && (a[3] *= 1); //cast as number
                a[0] = _hue(h + 1 / 3, r, g);
                a[1] = _hue(h, r, g);
                a[2] = _hue(h - 1 / 3, r, g);
            } else if (~v.indexOf("=")) {
                //if relative values are found, just return the raw strings with the relative prefixes in place.
                a = v.match(_numExp);
                forceAlpha && a.length < 4 && (a[3] = 1);
                return a;
            }
        } else a = v.match(_strictNumExp) || _colorLookup.transparent;
        a = a.map(Number);
    }
    if (toHSL && !wasHSL) {
        r = a[0] / _255;
        g = a[1] / _255;
        b = a[2] / _255;
        max = Math.max(r, g, b);
        min = Math.min(r, g, b);
        l = (max + min) / 2;
        if (max === min) h = s = 0;
        else {
            d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            h = max === r ? (g - b) / d + (g < b ? 6 : 0) : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
            h *= 60;
        }
        a[0] = ~~(h + .5);
        a[1] = ~~(s * 100 + .5);
        a[2] = ~~(l * 100 + .5);
    }
    forceAlpha && a.length < 4 && (a[3] = 1);
    return a;
}, _colorOrderData = function _colorOrderData(v) {
    // strips out the colors from the string, finds all the numeric slots (with units) and returns an array of those. The Array also has a "c" property which is an Array of the index values where the colors belong. This is to help work around issues where there's a mis-matched order of color/numeric data like drop-shadow(#f00 0px 1px 2px) and drop-shadow(0x 1px 2px #f00). This is basically a helper function used in _formatColors()
    var values = [], c = [], i = -1;
    v.split(_colorExp).forEach(function(v) {
        var a = v.match(_numWithUnitExp) || [];
        values.push.apply(values, a);
        c.push(i += a.length + 1);
    });
    values.c = c;
    return values;
}, _formatColors = function _formatColors(s, toHSL, orderMatchData) {
    var result = "", colors = (s + result).match(_colorExp), type = toHSL ? "hsla(" : "rgba(", i = 0, c, shell, d, l;
    if (!colors) return s;
    colors = colors.map(function(color) {
        return (color = splitColor(color, toHSL, 1)) && type + (toHSL ? color[0] + "," + color[1] + "%," + color[2] + "%," + color[3] : color.join(",")) + ")";
    });
    if (orderMatchData) {
        d = _colorOrderData(s);
        c = orderMatchData.c;
        if (c.join(result) !== d.c.join(result)) {
            shell = s.replace(_colorExp, "1").split(_numWithUnitExp);
            l = shell.length - 1;
            for(; i < l; i++)result += shell[i] + (~c.indexOf(i) ? colors.shift() || type + "0,0,0,0)" : (d.length ? d : colors.length ? colors : orderMatchData).shift());
        }
    }
    if (!shell) {
        shell = s.split(_colorExp);
        l = shell.length - 1;
        for(; i < l; i++)result += shell[i] + colors[i];
    }
    return result + shell[l];
}, _colorExp = function() {
    var s = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b", //we'll dynamically build this Regular Expression to conserve file size. After building it, it will be able to find rgb(), rgba(), # (hexadecimal), and named color values like red, blue, purple, etc.,
    p;
    for(p in _colorLookup)s += "|" + p + "\\b";
    return new RegExp(s + ")", "gi");
}(), _hslExp = /hsl[a]?\(/, _colorStringFilter = function _colorStringFilter(a) {
    var combined = a.join(" "), toHSL;
    _colorExp.lastIndex = 0;
    if (_colorExp.test(combined)) {
        toHSL = _hslExp.test(combined);
        a[1] = _formatColors(a[1], toHSL);
        a[0] = _formatColors(a[0], toHSL, _colorOrderData(a[1])); // make sure the order of numbers/colors match with the END value.
        return true;
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TICKER
 * --------------------------------------------------------------------------------------
 */ _tickerActive, _ticker = function() {
    var _getTime = Date.now, _lagThreshold = 500, _adjustedLag = 33, _startTime = _getTime(), _lastUpdate = _startTime, _gap = 1000 / 240, _nextTime = _gap, _listeners = [], _id, _req, _raf, _self, _delta, _i, _tick = function _tick(v) {
        var elapsed = _getTime() - _lastUpdate, manual = v === true, overlap, dispatch, time, frame;
        (elapsed > _lagThreshold || elapsed < 0) && (_startTime += elapsed - _adjustedLag);
        _lastUpdate += elapsed;
        time = _lastUpdate - _startTime;
        overlap = time - _nextTime;
        if (overlap > 0 || manual) {
            frame = ++_self.frame;
            _delta = time - _self.time * 1000;
            _self.time = time = time / 1000;
            _nextTime += overlap + (overlap >= _gap ? 4 : _gap - overlap);
            dispatch = 1;
        }
        manual || (_id = _req(_tick)); //make sure the request is made before we dispatch the "tick" event so that timing is maintained. Otherwise, if processing the "tick" requires a bunch of time (like 15ms) and we're using a setTimeout() that's based on 16.7ms, it'd technically take 31.7ms between frames otherwise.
        if (dispatch) for(_i = 0; _i < _listeners.length; _i++)// use _i and check _listeners.length instead of a variable because a listener could get removed during the loop, and if that happens to an element less than the current index, it'd throw things off in the loop.
        _listeners[_i](time, _delta, frame, v);
    };
    _self = {
        time: 0,
        frame: 0,
        tick: function tick() {
            _tick(true);
        },
        deltaRatio: function deltaRatio(fps) {
            return _delta / (1000 / (fps || 60));
        },
        wake: function wake() {
            if (_coreReady) {
                if (!_coreInitted && _windowExists()) {
                    _win = _coreInitted = window;
                    _doc = _win.document || {};
                    _globals.gsap = gsap;
                    (_win.gsapVersions || (_win.gsapVersions = [])).push(gsap.version);
                    _install(_installScope || _win.GreenSockGlobals || !_win.gsap && _win || {});
                    _registerPluginQueue.forEach(_createPlugin);
                }
                _raf = typeof requestAnimationFrame !== "undefined" && requestAnimationFrame;
                _id && _self.sleep();
                _req = _raf || function(f) {
                    return setTimeout(f, _nextTime - _self.time * 1000 + 1 | 0);
                };
                _tickerActive = 1;
                _tick(2);
            }
        },
        sleep: function sleep() {
            (_raf ? cancelAnimationFrame : clearTimeout)(_id);
            _tickerActive = 0;
            _req = _emptyFunc;
        },
        lagSmoothing: function lagSmoothing(threshold, adjustedLag) {
            _lagThreshold = threshold || Infinity; // zero should be interpreted as basically unlimited
            _adjustedLag = Math.min(adjustedLag || 33, _lagThreshold);
        },
        fps: function fps(_fps) {
            _gap = 1000 / (_fps || 240);
            _nextTime = _self.time * 1000 + _gap;
        },
        add: function add(callback, once, prioritize) {
            var func = once ? function(t, d, f, v) {
                callback(t, d, f, v);
                _self.remove(func);
            } : callback;
            _self.remove(callback);
            _listeners[prioritize ? "unshift" : "push"](func);
            _wake();
            return func;
        },
        remove: function remove(callback, i) {
            ~(i = _listeners.indexOf(callback)) && _listeners.splice(i, 1) && _i >= i && _i--;
        },
        _listeners: _listeners
    };
    return _self;
}(), _wake = function _wake() {
    return !_tickerActive && _ticker.wake();
}, //also ensures the core classes are initialized.
/*
* -------------------------------------------------
* EASING
* -------------------------------------------------
*/ _easeMap = {}, _customEaseExp = /^[\d.\-M][\d.\-,\s]/, _quotesExp = /["']/g, _parseObjectInString = function _parseObjectInString(value) {
    //takes a string like "{wiggles:10, type:anticipate})" and turns it into a real object. Notice it ends in ")" and includes the {} wrappers. This is because we only use this function for parsing ease configs and prioritized optimization rather than reusability.
    var obj = {}, split = value.substr(1, value.length - 3).split(":"), key = split[0], i = 1, l = split.length, index, val, parsedVal;
    for(; i < l; i++){
        val = split[i];
        index = i !== l - 1 ? val.lastIndexOf(",") : val.length;
        parsedVal = val.substr(0, index);
        obj[key] = isNaN(parsedVal) ? parsedVal.replace(_quotesExp, "").trim() : +parsedVal;
        key = val.substr(index + 1).trim();
    }
    return obj;
}, _valueInParentheses = function _valueInParentheses(value) {
    var open = value.indexOf("(") + 1, close = value.indexOf(")"), nested = value.indexOf("(", open);
    return value.substring(open, ~nested && nested < close ? value.indexOf(")", close + 1) : close);
}, _configEaseFromString = function _configEaseFromString(name) {
    //name can be a string like "elastic.out(1,0.5)", and pass in _easeMap as obj and it'll parse it out and call the actual function like _easeMap.Elastic.easeOut.config(1,0.5). It will also parse custom ease strings as long as CustomEase is loaded and registered (internally as _easeMap._CE).
    var split = (name + "").split("("), ease = _easeMap[split[0]];
    return ease && split.length > 1 && ease.config ? ease.config.apply(null, ~name.indexOf("{") ? [
        _parseObjectInString(split[1])
    ] : _valueInParentheses(name).split(",").map(_numericIfPossible)) : _easeMap._CE && _customEaseExp.test(name) ? _easeMap._CE("", name) : ease;
}, _invertEase = function _invertEase(ease) {
    return function(p) {
        return 1 - ease(1 - p);
    };
}, // allow yoyoEase to be set in children and have those affected when the parent/ancestor timeline yoyos.
_propagateYoyoEase = function _propagateYoyoEase(timeline, isYoyo) {
    var child = timeline._first, ease;
    while(child){
        if (child instanceof Timeline) _propagateYoyoEase(child, isYoyo);
        else if (child.vars.yoyoEase && (!child._yoyo || !child._repeat) && child._yoyo !== isYoyo) {
            if (child.timeline) _propagateYoyoEase(child.timeline, isYoyo);
            else {
                ease = child._ease;
                child._ease = child._yEase;
                child._yEase = ease;
                child._yoyo = isYoyo;
            }
        }
        child = child._next;
    }
}, _parseEase = function _parseEase(ease, defaultEase) {
    return !ease ? defaultEase : (_isFunction(ease) ? ease : _easeMap[ease] || _configEaseFromString(ease)) || defaultEase;
}, _insertEase = function _insertEase(names, easeIn, easeOut, easeInOut) {
    if (easeOut === void 0) easeOut = function easeOut(p) {
        return 1 - easeIn(1 - p);
    };
    if (easeInOut === void 0) easeInOut = function easeInOut(p) {
        return p < .5 ? easeIn(p * 2) / 2 : 1 - easeIn((1 - p) * 2) / 2;
    };
    var ease = {
        easeIn: easeIn,
        easeOut: easeOut,
        easeInOut: easeInOut
    }, lowercaseName;
    _forEachName(names, function(name) {
        _easeMap[name] = _globals[name] = ease;
        _easeMap[lowercaseName = name.toLowerCase()] = easeOut;
        for(var p in ease)_easeMap[lowercaseName + (p === "easeIn" ? ".in" : p === "easeOut" ? ".out" : ".inOut")] = _easeMap[name + "." + p] = ease[p];
    });
    return ease;
}, _easeInOutFromOut = function _easeInOutFromOut(easeOut) {
    return function(p) {
        return p < .5 ? (1 - easeOut(1 - p * 2)) / 2 : .5 + easeOut((p - .5) * 2) / 2;
    };
}, _configElastic = function _configElastic(type, amplitude, period) {
    var p1 = amplitude >= 1 ? amplitude : 1, //note: if amplitude is < 1, we simply adjust the period for a more natural feel. Otherwise the math doesn't work right and the curve starts at 1.
    p2 = (period || (type ? .3 : .45)) / (amplitude < 1 ? amplitude : 1), p3 = p2 / _2PI * (Math.asin(1 / p1) || 0), easeOut = function easeOut(p) {
        return p === 1 ? 1 : p1 * Math.pow(2, -10 * p) * _sin((p - p3) * p2) + 1;
    }, ease = type === "out" ? easeOut : type === "in" ? function(p) {
        return 1 - easeOut(1 - p);
    } : _easeInOutFromOut(easeOut);
    p2 = _2PI / p2; //precalculate to optimize
    ease.config = function(amplitude, period) {
        return _configElastic(type, amplitude, period);
    };
    return ease;
}, _configBack = function _configBack(type, overshoot) {
    if (overshoot === void 0) overshoot = 1.70158;
    var easeOut = function easeOut(p) {
        return p ? --p * p * ((overshoot + 1) * p + overshoot) + 1 : 0;
    }, ease = type === "out" ? easeOut : type === "in" ? function(p) {
        return 1 - easeOut(1 - p);
    } : _easeInOutFromOut(easeOut);
    ease.config = function(overshoot) {
        return _configBack(type, overshoot);
    };
    return ease;
}; // a cheaper (kb and cpu) but more mild way to get a parameterized weighted ease by feeding in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEase = ratio => {
// 	let y = 0.5 + ratio / 2;
// 	return p => (2 * (1 - p) * p * y + p * p);
// },
// a stronger (but more expensive kb/cpu) parameterized weighted ease that lets you feed in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEaseStrong = ratio => {
// 	ratio = .5 + ratio / 2;
// 	let o = 1 / 3 * (ratio < .5 ? ratio : 1 - ratio),
// 		b = ratio - o,
// 		c = ratio + o;
// 	return p => p === 1 ? p : 3 * b * (1 - p) * (1 - p) * p + 3 * c * (1 - p) * p * p + p * p * p;
// };
_forEachName("Linear,Quad,Cubic,Quart,Quint,Strong", function(name, i) {
    var power = i < 5 ? i + 1 : i;
    _insertEase(name + ",Power" + (power - 1), i ? function(p) {
        return Math.pow(p, power);
    } : function(p) {
        return p;
    }, function(p) {
        return 1 - Math.pow(1 - p, power);
    }, function(p) {
        return p < .5 ? Math.pow(p * 2, power) / 2 : 1 - Math.pow((1 - p) * 2, power) / 2;
    });
});
_easeMap.Linear.easeNone = _easeMap.none = _easeMap.Linear.easeIn;
_insertEase("Elastic", _configElastic("in"), _configElastic("out"), _configElastic());
(function(n, c) {
    var n1 = 1 / c, n2 = 2 * n1, n3 = 2.5 * n1, easeOut = function easeOut(p) {
        return p < n1 ? n * p * p : p < n2 ? n * Math.pow(p - 1.5 / c, 2) + .75 : p < n3 ? n * (p -= 2.25 / c) * p + .9375 : n * Math.pow(p - 2.625 / c, 2) + .984375;
    };
    _insertEase("Bounce", function(p) {
        return 1 - easeOut(1 - p);
    }, easeOut);
})(7.5625, 2.75);
_insertEase("Expo", function(p) {
    return p ? Math.pow(2, 10 * (p - 1)) : 0;
});
_insertEase("Circ", function(p) {
    return -(_sqrt(1 - p * p) - 1);
});
_insertEase("Sine", function(p) {
    return p === 1 ? 1 : -_cos(p * _HALF_PI) + 1;
});
_insertEase("Back", _configBack("in"), _configBack("out"), _configBack());
_easeMap.SteppedEase = _easeMap.steps = _globals.SteppedEase = {
    config: function config(steps, immediateStart) {
        if (steps === void 0) steps = 1;
        var p1 = 1 / steps, p2 = steps + (immediateStart ? 0 : 1), p3 = immediateStart ? 1 : 0, max = 1 - _tinyNum;
        return function(p) {
            return ((p2 * _clamp(0, max, p) | 0) + p3) * p1;
        };
    }
};
_defaults.ease = _easeMap["quad.out"];
_forEachName("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function(name) {
    return _callbackNames += name + "," + name + "Params,";
});
var GSCache = function GSCache(target, harness) {
    this.id = _gsID++;
    target._gsap = this;
    this.target = target;
    this.harness = harness;
    this.get = harness ? harness.get : _getProperty;
    this.set = harness ? harness.getSetter : _getSetter;
};
var Animation = /*#__PURE__*/ function() {
    function Animation(vars) {
        this.vars = vars;
        this._delay = +vars.delay || 0;
        if (this._repeat = vars.repeat === Infinity ? -2 : vars.repeat || 0) {
            // TODO: repeat: Infinity on a timeline's children must flag that timeline internally and affect its totalDuration, otherwise it'll stop in the negative direction when reaching the start.
            this._rDelay = vars.repeatDelay || 0;
            this._yoyo = !!vars.yoyo || !!vars.yoyoEase;
        }
        this._ts = 1;
        _setDuration(this, +vars.duration, 1, 1);
        this.data = vars.data;
        if (_context) {
            this._ctx = _context;
            _context.data.push(this);
        }
        _tickerActive || _ticker.wake();
    }
    var _proto = Animation.prototype;
    _proto.delay = function delay(value) {
        if (value || value === 0) {
            this.parent && this.parent.smoothChildTiming && this.startTime(this._start + value - this._delay);
            this._delay = value;
            return this;
        }
        return this._delay;
    };
    _proto.duration = function duration(value) {
        return arguments.length ? this.totalDuration(this._repeat > 0 ? value + (value + this._rDelay) * this._repeat : value) : this.totalDuration() && this._dur;
    };
    _proto.totalDuration = function totalDuration(value) {
        if (!arguments.length) return this._tDur;
        this._dirty = 0;
        return _setDuration(this, this._repeat < 0 ? value : (value - this._repeat * this._rDelay) / (this._repeat + 1));
    };
    _proto.totalTime = function totalTime(_totalTime, suppressEvents) {
        _wake();
        if (!arguments.length) return this._tTime;
        var parent = this._dp;
        if (parent && parent.smoothChildTiming && this._ts) {
            _alignPlayhead(this, _totalTime);
            !parent._dp || parent.parent || _postAddChecks(parent, this); // edge case: if this is a child of a timeline that already completed, for example, we must re-activate the parent.
            //in case any of the ancestor timelines had completed but should now be enabled, we should reset their totalTime() which will also ensure that they're lined up properly and enabled. Skip for animations that are on the root (wasteful). Example: a TimelineLite.exportRoot() is performed when there's a paused tween on the root, the export will not complete until that tween is unpaused, but imagine a child gets restarted later, after all [unpaused] tweens have completed. The start of that child would get pushed out, but one of the ancestors may have completed.
            while(parent && parent.parent){
                if (parent.parent._time !== parent._start + (parent._ts >= 0 ? parent._tTime / parent._ts : (parent.totalDuration() - parent._tTime) / -parent._ts)) parent.totalTime(parent._tTime, true);
                parent = parent.parent;
            }
            if (!this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && _totalTime < this._tDur || this._ts < 0 && _totalTime > 0 || !this._tDur && !_totalTime)) //if the animation doesn't have a parent, put it back into its last parent (recorded as _dp for exactly cases like this). Limit to parents with autoRemoveChildren (like globalTimeline) so that if the user manually removes an animation from a timeline and then alters its playhead, it doesn't get added back in.
            _addToTimeline(this._dp, this, this._start - this._delay);
        }
        if (this._tTime !== _totalTime || !this._dur && !suppressEvents || this._initted && Math.abs(this._zTime) === _tinyNum || !_totalTime && !this._initted && (this.add || this._ptLookup)) {
            // check for _ptLookup on a Tween instance to ensure it has actually finished being instantiated, otherwise if this.reverse() gets called in the Animation constructor, it could trigger a render() here even though the _targets weren't populated, thus when _init() is called there won't be any PropTweens (it'll act like the tween is non-functional)
            this._ts || (this._pTime = _totalTime); // otherwise, if an animation is paused, then the playhead is moved back to zero, then resumed, it'd revert back to the original time at the pause
            //if (!this._lock) { // avoid endless recursion (not sure we need this yet or if it's worth the performance hit)
            //   this._lock = 1;
            _lazySafeRender(this, _totalTime, suppressEvents); //   this._lock = 0;
        //}
        }
        return this;
    };
    _proto.time = function time(value, suppressEvents) {
        return arguments.length ? this.totalTime(Math.min(this.totalDuration(), value + _elapsedCycleDuration(this)) % (this._dur + this._rDelay) || (value ? this._dur : 0), suppressEvents) : this._time; // note: if the modulus results in 0, the playhead could be exactly at the end or the beginning, and we always defer to the END with a non-zero value, otherwise if you set the time() to the very end (duration()), it would render at the START!
    };
    _proto.totalProgress = function totalProgress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.totalDuration() * value, suppressEvents) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.rawTime() > 0 ? 1 : 0;
    };
    _proto.progress = function progress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.duration() * (this._yoyo && !(this.iteration() & 1) ? 1 - value : value) + _elapsedCycleDuration(this), suppressEvents) : this.duration() ? Math.min(1, this._time / this._dur) : this.rawTime() > 0 ? 1 : 0;
    };
    _proto.iteration = function iteration(value, suppressEvents) {
        var cycleDuration = this.duration() + this._rDelay;
        return arguments.length ? this.totalTime(this._time + (value - 1) * cycleDuration, suppressEvents) : this._repeat ? _animationCycle(this._tTime, cycleDuration) + 1 : 1;
    } // potential future addition:
    ;
    _proto.timeScale = function timeScale(value, suppressEvents) {
        if (!arguments.length) return this._rts === -_tinyNum ? 0 : this._rts; // recorded timeScale. Special case: if someone calls reverse() on an animation with timeScale of 0, we assign it -_tinyNum to remember it's reversed.
        if (this._rts === value) return this;
        var tTime = this.parent && this._ts ? _parentToChildTotalTime(this.parent._time, this) : this._tTime; // make sure to do the parentToChildTotalTime() BEFORE setting the new _ts because the old one must be used in that calculation.
        // future addition? Up side: fast and minimal file size. Down side: only works on this animation; if a timeline is reversed, for example, its childrens' onReverse wouldn't get called.
        //(+value < 0 && this._rts >= 0) && _callback(this, "onReverse", true);
        // prioritize rendering where the parent's playhead lines up instead of this._tTime because there could be a tween that's animating another tween's timeScale in the same rendering loop (same parent), thus if the timeScale tween renders first, it would alter _start BEFORE _tTime was set on that tick (in the rendering loop), effectively freezing it until the timeScale tween finishes.
        this._rts = +value || 0;
        this._ts = this._ps || value === -_tinyNum ? 0 : this._rts; // _ts is the functional timeScale which would be 0 if the animation is paused.
        this.totalTime(_clamp(-Math.abs(this._delay), this._tDur, tTime), suppressEvents !== false);
        _setEnd(this); // if parent.smoothChildTiming was false, the end time didn't get updated in the _alignPlayhead() method, so do it here.
        return _recacheAncestors(this);
    };
    _proto.paused = function paused(value) {
        if (!arguments.length) return this._ps;
        if (this._ps !== value) {
            this._ps = value;
            if (value) {
                this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()); // if the pause occurs during the delay phase, make sure that's factored in when resuming.
                this._ts = this._act = 0; // _ts is the functional timeScale, so a paused tween would effectively have a timeScale of 0. We record the "real" timeScale as _rts (recorded time scale)
            } else {
                _wake();
                this._ts = this._rts; //only defer to _pTime (pauseTime) if tTime is zero. Remember, someone could pause() an animation, then scrub the playhead and resume(). If the parent doesn't have smoothChildTiming, we render at the rawTime() because the startTime won't get updated.
                this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, this.progress() === 1 && Math.abs(this._zTime) !== _tinyNum && (this._tTime -= _tinyNum)); // edge case: animation.progress(1).pause().play() wouldn't render again because the playhead is already at the end, but the call to totalTime() below will add it back to its parent...and not remove it again (since removing only happens upon rendering at a new time). Offsetting the _tTime slightly is done simply to cause the final render in totalTime() that'll pop it off its timeline (if autoRemoveChildren is true, of course). Check to make sure _zTime isn't -_tinyNum to avoid an edge case where the playhead is pushed to the end but INSIDE a tween/callback, the timeline itself is paused thus halting rendering and leaving a few unrendered. When resuming, it wouldn't render those otherwise.
            }
        }
        return this;
    };
    _proto.startTime = function startTime(value) {
        if (arguments.length) {
            this._start = value;
            var parent = this.parent || this._dp;
            parent && (parent._sort || !this.parent) && _addToTimeline(parent, this, value - this._delay);
            return this;
        }
        return this._start;
    };
    _proto.endTime = function endTime(includeRepeats) {
        return this._start + (_isNotFalse(includeRepeats) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
    };
    _proto.rawTime = function rawTime(wrapRepeats) {
        var parent = this.parent || this._dp; // _dp = detached parent
        return !parent ? this._tTime : wrapRepeats && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : !this._ts ? this._tTime : _parentToChildTotalTime(parent.rawTime(wrapRepeats), this);
    };
    _proto.revert = function revert(config) {
        if (config === void 0) config = _revertConfig;
        var prevIsReverting = _reverting;
        _reverting = config;
        if (this._initted || this._startAt) {
            this.timeline && this.timeline.revert(config);
            this.totalTime(-0.01, config.suppressEvents);
        }
        this.data !== "nested" && config.kill !== false && this.kill();
        _reverting = prevIsReverting;
        return this;
    };
    _proto.globalTime = function globalTime(rawTime) {
        var animation = this, time = arguments.length ? rawTime : animation.rawTime();
        while(animation){
            time = animation._start + time / (Math.abs(animation._ts) || 1);
            animation = animation._dp;
        }
        return !this.parent && this._sat ? this._sat.globalTime(rawTime) : time; // the _startAt tweens for .fromTo() and .from() that have immediateRender should always be FIRST in the timeline (important for context.revert()). "_sat" stands for _startAtTween, referring to the parent tween that created the _startAt. We must discern if that tween had immediateRender so that we can know whether or not to prioritize it in revert().
    };
    _proto.repeat = function repeat(value) {
        if (arguments.length) {
            this._repeat = value === Infinity ? -2 : value;
            return _onUpdateTotalDuration(this);
        }
        return this._repeat === -2 ? Infinity : this._repeat;
    };
    _proto.repeatDelay = function repeatDelay(value) {
        if (arguments.length) {
            var time = this._time;
            this._rDelay = value;
            _onUpdateTotalDuration(this);
            return time ? this.time(time) : this;
        }
        return this._rDelay;
    };
    _proto.yoyo = function yoyo(value) {
        if (arguments.length) {
            this._yoyo = value;
            return this;
        }
        return this._yoyo;
    };
    _proto.seek = function seek(position, suppressEvents) {
        return this.totalTime(_parsePosition(this, position), _isNotFalse(suppressEvents));
    };
    _proto.restart = function restart(includeDelay, suppressEvents) {
        return this.play().totalTime(includeDelay ? -this._delay : 0, _isNotFalse(suppressEvents));
    };
    _proto.play = function play(from, suppressEvents) {
        from != null && this.seek(from, suppressEvents);
        return this.reversed(false).paused(false);
    };
    _proto.reverse = function reverse(from, suppressEvents) {
        from != null && this.seek(from || this.totalDuration(), suppressEvents);
        return this.reversed(true).paused(false);
    };
    _proto.pause = function pause(atTime, suppressEvents) {
        atTime != null && this.seek(atTime, suppressEvents);
        return this.paused(true);
    };
    _proto.resume = function resume() {
        return this.paused(false);
    };
    _proto.reversed = function reversed(value) {
        if (arguments.length) {
            !!value !== this.reversed() && this.timeScale(-this._rts || (value ? -_tinyNum : 0)); // in case timeScale is zero, reversing would have no effect so we use _tinyNum.
            return this;
        }
        return this._rts < 0;
    };
    _proto.invalidate = function invalidate() {
        this._initted = this._act = 0;
        this._zTime = -_tinyNum;
        return this;
    };
    _proto.isActive = function isActive() {
        var parent = this.parent || this._dp, start = this._start, rawTime;
        return !!(!parent || this._ts && this._initted && parent.isActive() && (rawTime = parent.rawTime(true)) >= start && rawTime < this.endTime(true) - _tinyNum);
    };
    _proto.eventCallback = function eventCallback(type, callback, params) {
        var vars = this.vars;
        if (arguments.length > 1) {
            if (!callback) delete vars[type];
            else {
                vars[type] = callback;
                params && (vars[type + "Params"] = params);
                type === "onUpdate" && (this._onUpdate = callback);
            }
            return this;
        }
        return vars[type];
    };
    _proto.then = function then(onFulfilled) {
        var self = this;
        return new Promise(function(resolve) {
            var f = _isFunction(onFulfilled) ? onFulfilled : _passThrough, _resolve = function _resolve() {
                var _then = self.then;
                self.then = null; // temporarily null the then() method to avoid an infinite loop (see https://github.com/greensock/GSAP/issues/322)
                _isFunction(f) && (f = f(self)) && (f.then || f === self) && (self.then = _then);
                resolve(f);
                self.then = _then;
            };
            if (self._initted && self.totalProgress() === 1 && self._ts >= 0 || !self._tTime && self._ts < 0) _resolve();
            else self._prom = _resolve;
        });
    };
    _proto.kill = function kill() {
        _interrupt(this);
    };
    return Animation;
}();
_setDefaults(Animation.prototype, {
    _time: 0,
    _start: 0,
    _end: 0,
    _tTime: 0,
    _tDur: 0,
    _dirty: 0,
    _repeat: 0,
    _yoyo: false,
    parent: null,
    _initted: false,
    _rDelay: 0,
    _ts: 1,
    _dp: 0,
    ratio: 0,
    _zTime: -_tinyNum,
    _prom: 0,
    _ps: false,
    _rts: 1
});
var Timeline = /*#__PURE__*/ function(_Animation) {
    _inheritsLoose(Timeline, _Animation);
    function Timeline(vars, position) {
        var _this;
        if (vars === void 0) vars = {};
        _this = _Animation.call(this, vars) || this;
        _this.labels = {};
        _this.smoothChildTiming = !!vars.smoothChildTiming;
        _this.autoRemoveChildren = !!vars.autoRemoveChildren;
        _this._sort = _isNotFalse(vars.sortChildren);
        _globalTimeline && _addToTimeline(vars.parent || _globalTimeline, _assertThisInitialized(_this), position);
        vars.reversed && _this.reverse();
        vars.paused && _this.paused(true);
        vars.scrollTrigger && _scrollTrigger(_assertThisInitialized(_this), vars.scrollTrigger);
        return _this;
    }
    var _proto2 = Timeline.prototype;
    _proto2.to = function to(targets, vars, position) {
        _createTweenType(0, arguments, this);
        return this;
    };
    _proto2.from = function from(targets, vars, position) {
        _createTweenType(1, arguments, this);
        return this;
    };
    _proto2.fromTo = function fromTo(targets, fromVars, toVars, position) {
        _createTweenType(2, arguments, this);
        return this;
    };
    _proto2.set = function set(targets, vars, position) {
        vars.duration = 0;
        vars.parent = this;
        _inheritDefaults(vars).repeatDelay || (vars.repeat = 0);
        vars.immediateRender = !!vars.immediateRender;
        new Tween(targets, vars, _parsePosition(this, position), 1);
        return this;
    };
    _proto2.call = function call(callback, params, position) {
        return _addToTimeline(this, Tween.delayedCall(0, callback, params), position);
    } //ONLY for backward compatibility! Maybe delete?
    ;
    _proto2.staggerTo = function staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.duration = duration;
        vars.stagger = vars.stagger || stagger;
        vars.onComplete = onCompleteAll;
        vars.onCompleteParams = onCompleteAllParams;
        vars.parent = this;
        new Tween(targets, vars, _parsePosition(this, position));
        return this;
    };
    _proto2.staggerFrom = function staggerFrom(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.runBackwards = 1;
        _inheritDefaults(vars).immediateRender = _isNotFalse(vars.immediateRender);
        return this.staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.staggerFromTo = function staggerFromTo(targets, duration, fromVars, toVars, stagger, position, onCompleteAll, onCompleteAllParams) {
        toVars.startAt = fromVars;
        _inheritDefaults(toVars).immediateRender = _isNotFalse(toVars.immediateRender);
        return this.staggerTo(targets, duration, toVars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._dirty ? this.totalDuration() : this._tDur, dur = this._dur, tTime = totalTime <= 0 ? 0 : _roundPrecise(totalTime), // if a paused timeline is resumed (or its _start is updated for another reason...which rounds it), that could result in the playhead shifting a **tiny** amount and a zero-duration child at that spot may get rendered at a different ratio, like its totalTime in render() may be 1e-17 instead of 0, for example.
        crossingStart = this._zTime < 0 !== totalTime < 0 && (this._initted || !dur), time, child, next, iteration, cycleDuration, prevPaused, pauseTween, timeScale, prevStart, prevIteration, yoyo, isYoyo;
        this !== _globalTimeline && tTime > tDur && totalTime >= 0 && (tTime = tDur);
        if (tTime !== this._tTime || force || crossingStart) {
            if (prevTime !== this._time && dur) {
                //if totalDuration() finds a child with a negative startTime and smoothChildTiming is true, things get shifted around internally so we need to adjust the time accordingly. For example, if a tween starts at -30 we must shift EVERYTHING forward 30 seconds and move this timeline's startTime backward by 30 seconds so that things align with the playhead (no jump).
                tTime += this._time - prevTime;
                totalTime += this._time - prevTime;
            }
            time = tTime;
            prevStart = this._start;
            timeScale = this._ts;
            prevPaused = !timeScale;
            if (crossingStart) {
                dur || (prevTime = this._zTime); //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
                (totalTime || !suppressEvents) && (this._zTime = totalTime);
            }
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                yoyo = this._yoyo;
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && totalTime < 0) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
                    iteration = this._repeat;
                    time = dur;
                } else {
                    iteration = ~~(tTime / cycleDuration);
                    if (iteration && iteration === tTime / cycleDuration) {
                        time = dur;
                        iteration--;
                    }
                    time > dur && (time = dur);
                }
                prevIteration = _animationCycle(this._tTime, cycleDuration);
                !prevTime && this._tTime && prevIteration !== iteration && this._tTime - prevIteration * cycleDuration - this._dur <= 0 && (prevIteration = iteration); // edge case - if someone does addPause() at the very beginning of a repeating timeline, that pause is technically at the same spot as the end which causes this._time to get set to 0 when the totalTime would normally place the playhead at the end. See https://gsap.com/forums/topic/23823-closing-nav-animation-not-working-on-ie-and-iphone-6-maybe-other-older-browser/?tab=comments#comment-113005 also, this._tTime - prevIteration * cycleDuration - this._dur <= 0 just checks to make sure it wasn't previously in the "repeatDelay" portion
                if (yoyo && iteration & 1) {
                    time = dur - time;
                    isYoyo = 1;
                }
                /*
        make sure children at the end/beginning of the timeline are rendered properly. If, for example,
        a 3-second long timeline rendered at 2.9 seconds previously, and now renders at 3.2 seconds (which
        would get translated to 2.8 seconds if the timeline yoyos or 0.2 seconds if it just repeats), there
        could be a callback or a short tween that's at 2.95 or 3 seconds in which wouldn't render. So
        we need to push the timeline to the end (and/or beginning depending on its yoyo value). Also we must
        ensure that zero-duration tweens at the very beginning or end of the Timeline work.
        */ if (iteration !== prevIteration && !this._lock) {
                    var rewinding = yoyo && prevIteration & 1, doesWrap = rewinding === (yoyo && iteration & 1);
                    iteration < prevIteration && (rewinding = !rewinding);
                    prevTime = rewinding ? 0 : tTime % dur ? dur : tTime; // if the playhead is landing exactly at the end of an iteration, use that totalTime rather than only the duration, otherwise it'll skip the 2nd render since it's effectively at the same time.
                    this._lock = 1;
                    this.render(prevTime || (isYoyo ? 0 : _roundPrecise(iteration * cycleDuration)), suppressEvents, !dur)._lock = 0;
                    this._tTime = tTime; // if a user gets the iteration() inside the onRepeat, for example, it should be accurate.
                    !suppressEvents && this.parent && _callback(this, "onRepeat");
                    this.vars.repeatRefresh && !isYoyo && (this.invalidate()._lock = 1);
                    if (prevTime && prevTime !== this._time || prevPaused !== !this._ts || this.vars.onRepeat && !this.parent && !this._act) // if prevTime is 0 and we render at the very end, _time will be the end, thus won't match. So in this edge case, prevTime won't match _time but that's okay. If it gets killed in the onRepeat, eject as well.
                    return this;
                    dur = this._dur; // in case the duration changed in the onRepeat
                    tDur = this._tDur;
                    if (doesWrap) {
                        this._lock = 2;
                        prevTime = rewinding ? dur : -0.0001;
                        this.render(prevTime, true);
                        this.vars.repeatRefresh && !isYoyo && this.invalidate();
                    }
                    this._lock = 0;
                    if (!this._ts && !prevPaused) return this;
                     //in order for yoyoEase to work properly when there's a stagger, we must swap out the ease in each sub-tween.
                    _propagateYoyoEase(this, isYoyo);
                }
            }
            if (this._hasPause && !this._forcing && this._lock < 2) {
                pauseTween = _findNextPauseTween(this, _roundPrecise(prevTime), _roundPrecise(time));
                if (pauseTween) tTime -= time - (time = pauseTween._start);
            }
            this._tTime = tTime;
            this._time = time;
            this._act = !timeScale; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
            if (!this._initted) {
                this._onUpdate = this.vars.onUpdate;
                this._initted = 1;
                this._zTime = totalTime;
                prevTime = 0; // upon init, the playhead should always go forward; someone could invalidate() a completed timeline and then if they restart(), that would make child tweens render in reverse order which could lock in the wrong starting values if they build on each other, like tl.to(obj, {x: 100}).to(obj, {x: 0}).
            }
            if (!prevTime && time && !suppressEvents && !iteration) {
                _callback(this, "onStart");
                if (this._tTime !== tTime) // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
                return this;
            }
            if (time >= prevTime && totalTime >= 0) {
                child = this._first;
                while(child){
                    next = child._next;
                    if ((child._act || time >= child._start) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (time - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (time - child._start) * child._ts, suppressEvents, force);
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            next && (tTime += this._zTime = -_tinyNum); // it didn't finish rendering, so flag zTime as negative so that so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            } else {
                child = this._last;
                var adjustedTime = totalTime < 0 ? totalTime : time; //when the playhead goes backward beyond the start of this timeline, we must pass that information down to the child animations so that zero-duration tweens know whether to render their starting or ending values.
                while(child){
                    next = child._prev;
                    if ((child._act || adjustedTime <= child._end) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (adjustedTime - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (adjustedTime - child._start) * child._ts, suppressEvents, force || _reverting && (child._initted || child._startAt)); // if reverting, we should always force renders of initted tweens (but remember that .fromTo() or .from() may have a _startAt but not _initted yet). If, for example, a .fromTo() tween with a stagger (which creates an internal timeline) gets reverted BEFORE some of its child tweens render for the first time, it may not properly trigger them to revert.
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            next && (tTime += this._zTime = adjustedTime ? -_tinyNum : _tinyNum); // it didn't finish rendering, so adjust zTime so that so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            }
            if (pauseTween && !suppressEvents) {
                this.pause();
                pauseTween.render(time >= prevTime ? 0 : -_tinyNum)._zTime = time >= prevTime ? 1 : -1;
                if (this._ts) {
                    //the callback resumed playback! So since we may have held back the playhead due to where the pause is positioned, go ahead and jump to where it's SUPPOSED to be (if no pause happened).
                    this._start = prevStart; //if the pause was at an earlier time and the user resumed in the callback, it could reposition the timeline (changing its startTime), throwing things off slightly, so we make sure the _start doesn't shift.
                    _setEnd(this);
                    return this.render(totalTime, suppressEvents, force);
                }
            }
            this._onUpdate && !suppressEvents && _callback(this, "onUpdate", true);
            if (tTime === tDur && this._tTime >= this.totalDuration() || !tTime && prevTime) {
                if (prevStart === this._start || Math.abs(timeScale) !== Math.abs(this._ts)) {
                    if (!this._lock) {
                        // remember, a child's callback may alter this timeline's playhead or timeScale which is why we need to add some of these checks.
                        (totalTime || !dur) && (tTime === tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                        if (!suppressEvents && !(totalTime < 0 && !prevTime) && (tTime || prevTime || !tDur)) {
                            _callback(this, tTime === tDur && totalTime >= 0 ? "onComplete" : "onReverseComplete", true);
                            this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                        }
                    }
                }
            }
        }
        return this;
    };
    _proto2.add = function add(child, position) {
        var _this2 = this;
        _isNumber(position) || (position = _parsePosition(this, position, child));
        if (!(child instanceof Animation)) {
            if (_isArray(child)) {
                child.forEach(function(obj) {
                    return _this2.add(obj, position);
                });
                return this;
            }
            if (_isString(child)) return this.addLabel(child, position);
            if (_isFunction(child)) child = Tween.delayedCall(0, child);
            else return this;
        }
        return this !== child ? _addToTimeline(this, child, position) : this; //don't allow a timeline to be added to itself as a child!
    };
    _proto2.getChildren = function getChildren(nested, tweens, timelines, ignoreBeforeTime) {
        if (nested === void 0) nested = true;
        if (tweens === void 0) tweens = true;
        if (timelines === void 0) timelines = true;
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = -_bigNum;
        var a = [], child = this._first;
        while(child){
            if (child._start >= ignoreBeforeTime) {
                if (child instanceof Tween) tweens && a.push(child);
                else {
                    timelines && a.push(child);
                    nested && a.push.apply(a, child.getChildren(true, tweens, timelines));
                }
            }
            child = child._next;
        }
        return a;
    };
    _proto2.getById = function getById(id) {
        var animations = this.getChildren(1, 1, 1), i = animations.length;
        while(i--){
            if (animations[i].vars.id === id) return animations[i];
        }
    };
    _proto2.remove = function remove(child) {
        if (_isString(child)) return this.removeLabel(child);
        if (_isFunction(child)) return this.killTweensOf(child);
        _removeLinkedListItem(this, child);
        if (child === this._recent) this._recent = this._last;
        return _uncache(this);
    };
    _proto2.totalTime = function totalTime(_totalTime2, suppressEvents) {
        if (!arguments.length) return this._tTime;
        this._forcing = 1;
        if (!this._dp && this._ts) //special case for the global timeline (or any other that has no parent or detached parent).
        this._start = _roundPrecise(_ticker.time - (this._ts > 0 ? _totalTime2 / this._ts : (this.totalDuration() - _totalTime2) / -this._ts));
        _Animation.prototype.totalTime.call(this, _totalTime2, suppressEvents);
        this._forcing = 0;
        return this;
    };
    _proto2.addLabel = function addLabel(label, position) {
        this.labels[label] = _parsePosition(this, position);
        return this;
    };
    _proto2.removeLabel = function removeLabel(label) {
        delete this.labels[label];
        return this;
    };
    _proto2.addPause = function addPause(position, callback, params) {
        var t = Tween.delayedCall(0, callback || _emptyFunc, params);
        t.data = "isPause";
        this._hasPause = 1;
        return _addToTimeline(this, t, _parsePosition(this, position));
    };
    _proto2.removePause = function removePause(position) {
        var child = this._first;
        position = _parsePosition(this, position);
        while(child){
            if (child._start === position && child.data === "isPause") _removeFromParent(child);
            child = child._next;
        }
    };
    _proto2.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        var tweens = this.getTweensOf(targets, onlyActive), i = tweens.length;
        while(i--)_overwritingTween !== tweens[i] && tweens[i].kill(targets, props);
        return this;
    };
    _proto2.getTweensOf = function getTweensOf(targets, onlyActive) {
        var a = [], parsedTargets = toArray(targets), child = this._first, isGlobalTime = _isNumber(onlyActive), // a number is interpreted as a global time. If the animation spans
        children;
        while(child){
            if (child instanceof Tween) {
                if (_arrayContainsAny(child._targets, parsedTargets) && (isGlobalTime ? (!_overwritingTween || child._initted && child._ts) && child.globalTime(0) <= onlyActive && child.globalTime(child.totalDuration()) > onlyActive : !onlyActive || child.isActive())) // note: if this is for overwriting, it should only be for tweens that aren't paused and are initted.
                a.push(child);
            } else if ((children = child.getTweensOf(parsedTargets, onlyActive)).length) a.push.apply(a, children);
            child = child._next;
        }
        return a;
    } // potential future feature - targets() on timelines
    ;
    _proto2.tweenTo = function tweenTo(position, vars) {
        vars = vars || {};
        var tl = this, endTime = _parsePosition(tl, position), _vars = vars, startAt = _vars.startAt, _onStart = _vars.onStart, onStartParams = _vars.onStartParams, immediateRender = _vars.immediateRender, initted, tween = Tween.to(tl, _setDefaults({
            ease: vars.ease || "none",
            lazy: false,
            immediateRender: false,
            time: endTime,
            overwrite: "auto",
            duration: vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale()) || _tinyNum,
            onStart: function onStart() {
                tl.pause();
                if (!initted) {
                    var duration = vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale());
                    tween._dur !== duration && _setDuration(tween, duration, 0, 1).render(tween._time, true, true);
                    initted = 1;
                }
                _onStart && _onStart.apply(tween, onStartParams || []); //in case the user had an onStart in the vars - we don't want to overwrite it.
            }
        }, vars));
        return immediateRender ? tween.render(0) : tween;
    };
    _proto2.tweenFromTo = function tweenFromTo(fromPosition, toPosition, vars) {
        return this.tweenTo(toPosition, _setDefaults({
            startAt: {
                time: _parsePosition(this, fromPosition)
            }
        }, vars));
    };
    _proto2.recent = function recent() {
        return this._recent;
    };
    _proto2.nextLabel = function nextLabel(afterTime) {
        if (afterTime === void 0) afterTime = this._time;
        return _getLabelInDirection(this, _parsePosition(this, afterTime));
    };
    _proto2.previousLabel = function previousLabel(beforeTime) {
        if (beforeTime === void 0) beforeTime = this._time;
        return _getLabelInDirection(this, _parsePosition(this, beforeTime), 1);
    };
    _proto2.currentLabel = function currentLabel(value) {
        return arguments.length ? this.seek(value, true) : this.previousLabel(this._time + _tinyNum);
    };
    _proto2.shiftChildren = function shiftChildren(amount, adjustLabels, ignoreBeforeTime) {
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = 0;
        var child = this._first, labels = this.labels, p;
        while(child){
            if (child._start >= ignoreBeforeTime) {
                child._start += amount;
                child._end += amount;
            }
            child = child._next;
        }
        if (adjustLabels) {
            for(p in labels)if (labels[p] >= ignoreBeforeTime) labels[p] += amount;
        }
        return _uncache(this);
    };
    _proto2.invalidate = function invalidate(soft) {
        var child = this._first;
        this._lock = 0;
        while(child){
            child.invalidate(soft);
            child = child._next;
        }
        return _Animation.prototype.invalidate.call(this, soft);
    };
    _proto2.clear = function clear(includeLabels) {
        if (includeLabels === void 0) includeLabels = true;
        var child = this._first, next;
        while(child){
            next = child._next;
            this.remove(child);
            child = next;
        }
        this._dp && (this._time = this._tTime = this._pTime = 0);
        includeLabels && (this.labels = {});
        return _uncache(this);
    };
    _proto2.totalDuration = function totalDuration(value) {
        var max = 0, self = this, child = self._last, prevStart = _bigNum, prev, start, parent;
        if (arguments.length) return self.timeScale((self._repeat < 0 ? self.duration() : self.totalDuration()) / (self.reversed() ? -value : value));
        if (self._dirty) {
            parent = self.parent;
            while(child){
                prev = child._prev; //record it here in case the tween changes position in the sequence...
                child._dirty && child.totalDuration(); //could change the tween._startTime, so make sure the animation's cache is clean before analyzing it.
                start = child._start;
                if (start > prevStart && self._sort && child._ts && !self._lock) {
                    //in case one of the tweens shifted out of order, it needs to be re-inserted into the correct position in the sequence
                    self._lock = 1; //prevent endless recursive calls - there are methods that get triggered that check duration/totalDuration when we add().
                    _addToTimeline(self, child, start - child._delay, 1)._lock = 0;
                } else prevStart = start;
                if (start < 0 && child._ts) {
                    //children aren't allowed to have negative startTimes unless smoothChildTiming is true, so adjust here if one is found.
                    max -= start;
                    if (!parent && !self._dp || parent && parent.smoothChildTiming) {
                        self._start += start / self._ts;
                        self._time -= start;
                        self._tTime -= start;
                    }
                    self.shiftChildren(-start, false, -Infinity);
                    prevStart = 0;
                }
                child._end > max && child._ts && (max = child._end);
                child = prev;
            }
            _setDuration(self, self === _globalTimeline && self._time > max ? self._time : max, 1, 1);
            self._dirty = 0;
        }
        return self._tDur;
    };
    Timeline.updateRoot = function updateRoot(time) {
        if (_globalTimeline._ts) {
            _lazySafeRender(_globalTimeline, _parentToChildTotalTime(time, _globalTimeline));
            _lastRenderedFrame = _ticker.frame;
        }
        if (_ticker.frame >= _nextGCFrame) {
            _nextGCFrame += _config.autoSleep || 120;
            var child = _globalTimeline._first;
            if (!child || !child._ts) {
                if (_config.autoSleep && _ticker._listeners.length < 2) {
                    while(child && !child._ts)child = child._next;
                    child || _ticker.sleep();
                }
            }
        }
    };
    return Timeline;
}(Animation);
_setDefaults(Timeline.prototype, {
    _lock: 0,
    _hasPause: 0,
    _forcing: 0
});
var _addComplexStringPropTween = function _addComplexStringPropTween(target, prop, start, end, setter, stringFilter, funcParam) {
    //note: we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    var pt = new PropTween(this._pt, target, prop, 0, 1, _renderComplexString, null, setter), index = 0, matchIndex = 0, result, startNums, color, endNum, chunk, startNum, hasRandom, a;
    pt.b = start;
    pt.e = end;
    start += ""; //ensure values are strings
    end += "";
    if (hasRandom = ~end.indexOf("random(")) end = _replaceRandom(end);
    if (stringFilter) {
        a = [
            start,
            end
        ];
        stringFilter(a, target, prop); //pass an array with the starting and ending values and let the filter do whatever it needs to the values.
        start = a[0];
        end = a[1];
    }
    startNums = start.match(_complexStringNumExp) || [];
    while(result = _complexStringNumExp.exec(end)){
        endNum = result[0];
        chunk = end.substring(index, result.index);
        if (color) color = (color + 1) % 5;
        else if (chunk.substr(-5) === "rgba(") color = 1;
        if (endNum !== startNums[matchIndex++]) {
            startNum = parseFloat(startNums[matchIndex - 1]) || 0; //these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
            pt._pt = {
                _next: pt._pt,
                p: chunk || matchIndex === 1 ? chunk : ",",
                //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                s: startNum,
                c: endNum.charAt(1) === "=" ? _parseRelative(startNum, endNum) - startNum : parseFloat(endNum) - startNum,
                m: color && color < 4 ? Math.round : 0
            };
            index = _complexStringNumExp.lastIndex;
        }
    }
    pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    pt.fp = funcParam;
    if (_relExp.test(end) || hasRandom) pt.e = 0; //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    return pt;
}, _addPropTween = function _addPropTween(target, prop, start, end, index, targets, modifier, stringFilter, funcParam, optional) {
    _isFunction(end) && (end = end(index || 0, target, targets));
    var currentValue = target[prop], parsedStart = start !== "get" ? start : !_isFunction(currentValue) ? currentValue : funcParam ? target[prop.indexOf("set") || !_isFunction(target["get" + prop.substr(3)]) ? prop : "get" + prop.substr(3)](funcParam) : target[prop](), setter = !_isFunction(currentValue) ? _setterPlain : funcParam ? _setterFuncWithParam : _setterFunc, pt;
    if (_isString(end)) {
        if (~end.indexOf("random(")) end = _replaceRandom(end);
        if (end.charAt(1) === "=") {
            pt = _parseRelative(parsedStart, end) + (getUnit(parsedStart) || 0);
            if (pt || pt === 0) // to avoid isNaN, like if someone passes in a value like "!= whatever"
            end = pt;
        }
    }
    if (!optional || parsedStart !== end || _forceAllPropTweens) {
        if (!isNaN(parsedStart * end) && end !== "") {
            // fun fact: any number multiplied by "" is evaluated as the number 0!
            pt = new PropTween(this._pt, target, prop, +parsedStart || 0, end - (parsedStart || 0), typeof currentValue === "boolean" ? _renderBoolean : _renderPlain, 0, setter);
            funcParam && (pt.fp = funcParam);
            modifier && pt.modifier(modifier, this, target);
            return this._pt = pt;
        }
        !currentValue && !(prop in target) && _missingPlugin(prop, end);
        return _addComplexStringPropTween.call(this, target, prop, parsedStart, end, setter, stringFilter || _config.stringFilter, funcParam);
    }
}, //creates a copy of the vars object and processes any function-based values (putting the resulting values directly into the copy) as well as strings with "random()" in them. It does NOT process relative values.
_processVars = function _processVars(vars, index, target, targets, tween) {
    _isFunction(vars) && (vars = _parseFuncOrString(vars, tween, index, target, targets));
    if (!_isObject(vars) || vars.style && vars.nodeType || _isArray(vars) || _isTypedArray(vars)) return _isString(vars) ? _parseFuncOrString(vars, tween, index, target, targets) : vars;
    var copy = {}, p;
    for(p in vars)copy[p] = _parseFuncOrString(vars[p], tween, index, target, targets);
    return copy;
}, _checkPlugin = function _checkPlugin(property, vars, tween, index, target, targets) {
    var plugin, pt, ptLookup, i;
    if (_plugins[property] && (plugin = new _plugins[property]()).init(target, plugin.rawVars ? vars[property] : _processVars(vars[property], index, target, targets, tween), tween, index, targets) !== false) {
        tween._pt = pt = new PropTween(tween._pt, target, property, 0, 1, plugin.render, plugin, 0, plugin.priority);
        if (tween !== _quickTween) {
            ptLookup = tween._ptLookup[tween._targets.indexOf(target)]; //note: we can't use tween._ptLookup[index] because for staggered tweens, the index from the fullTargets array won't match what it is in each individual tween that spawns from the stagger.
            i = plugin._props.length;
            while(i--)ptLookup[plugin._props[i]] = pt;
        }
    }
    return plugin;
}, _overwritingTween, //store a reference temporarily so we can avoid overwriting itself.
_forceAllPropTweens, _initTween = function _initTween(tween, time, tTime) {
    var vars = tween.vars, ease = vars.ease, startAt = vars.startAt, immediateRender = vars.immediateRender, lazy = vars.lazy, onUpdate = vars.onUpdate, runBackwards = vars.runBackwards, yoyoEase = vars.yoyoEase, keyframes = vars.keyframes, autoRevert = vars.autoRevert, dur = tween._dur, prevStartAt = tween._startAt, targets = tween._targets, parent = tween.parent, fullTargets = parent && parent.data === "nested" ? parent.vars.targets : targets, autoOverwrite = tween._overwrite === "auto" && !_suppressOverwrites, tl = tween.timeline, cleanVars, i, p, pt, target, hasPriority, gsData, harness, plugin, ptLookup, index, harnessVars, overwritten;
    tl && (!keyframes || !ease) && (ease = "none");
    tween._ease = _parseEase(ease, _defaults.ease);
    tween._yEase = yoyoEase ? _invertEase(_parseEase(yoyoEase === true ? ease : yoyoEase, _defaults.ease)) : 0;
    if (yoyoEase && tween._yoyo && !tween._repeat) {
        //there must have been a parent timeline with yoyo:true that is currently in its yoyo phase, so flip the eases.
        yoyoEase = tween._yEase;
        tween._yEase = tween._ease;
        tween._ease = yoyoEase;
    }
    tween._from = !tl && !!vars.runBackwards; //nested timelines should never run backwards - the backwards-ness is in the child tweens.
    if (!tl || keyframes && !vars.stagger) {
        //if there's an internal timeline, skip all the parsing because we passed that task down the chain.
        harness = targets[0] ? _getCache(targets[0]).harness : 0;
        harnessVars = harness && vars[harness.prop]; //someone may need to specify CSS-specific values AND non-CSS values, like if the element has an "x" property plus it's a standard DOM element. We allow people to distinguish by wrapping plugin-specific stuff in a css:{} object for example.
        cleanVars = _copyExcluding(vars, _reservedProps);
        if (prevStartAt) {
            prevStartAt._zTime < 0 && prevStartAt.progress(1); // in case it's a lazy startAt that hasn't rendered yet.
            time < 0 && runBackwards && immediateRender && !autoRevert ? prevStartAt.render(-1, true) : prevStartAt.revert(runBackwards && dur ? _revertConfigNoKill : _startAtRevertConfig); // if it's a "startAt" (not "from()" or runBackwards: true), we only need to do a shallow revert (keep transforms cached in CSSPlugin)
            // don't just _removeFromParent(prevStartAt.render(-1, true)) because that'll leave inline styles. We're creating a new _startAt for "startAt" tweens that re-capture things to ensure that if the pre-tween values changed since the tween was created, they're recorded.
            prevStartAt._lazy = 0;
        }
        if (startAt) {
            _removeFromParent(tween._startAt = Tween.set(targets, _setDefaults({
                data: "isStart",
                overwrite: false,
                parent: parent,
                immediateRender: true,
                lazy: !prevStartAt && _isNotFalse(lazy),
                startAt: null,
                delay: 0,
                onUpdate: onUpdate && function() {
                    return _callback(tween, "onUpdate");
                },
                stagger: 0
            }, startAt))); //copy the properties/values into a new object to avoid collisions, like var to = {x:0}, from = {x:500}; timeline.fromTo(e, from, to).fromTo(e, to, from);
            tween._startAt._dp = 0; // don't allow it to get put back into root timeline! Like when revert() is called and totalTime() gets set.
            tween._startAt._sat = tween; // used in globalTime(). _sat stands for _startAtTween
            time < 0 && (_reverting || !immediateRender && !autoRevert) && tween._startAt.revert(_revertConfigNoKill); // rare edge case, like if a render is forced in the negative direction of a non-initted tween.
            if (immediateRender) {
                if (dur && time <= 0 && tTime <= 0) {
                    // check tTime here because in the case of a yoyo tween whose playhead gets pushed to the end like tween.progress(1), we should allow it through so that the onComplete gets fired properly.
                    time && (tween._zTime = time);
                    return; //we skip initialization here so that overwriting doesn't occur until the tween actually begins. Otherwise, if you create several immediateRender:true tweens of the same target/properties to drop into a Timeline, the last one created would overwrite the first ones because they didn't get placed into the timeline yet before the first render occurs and kicks in overwriting.
                }
            }
        } else if (runBackwards && dur) //from() tweens must be handled uniquely: their beginning values must be rendered but we don't want overwriting to occur yet (when time is still 0). Wait until the tween actually begins before doing all the routines like overwriting. At that time, we should render at the END of the tween to ensure that things initialize correctly (remember, from() tweens go backwards)
        {
            if (!prevStartAt) {
                time && (immediateRender = false); //in rare cases (like if a from() tween runs and then is invalidate()-ed), immediateRender could be true but the initial forced-render gets skipped, so there's no need to force the render in this context when the _time is greater than 0
                p = _setDefaults({
                    overwrite: false,
                    data: "isFromStart",
                    //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
                    lazy: immediateRender && !prevStartAt && _isNotFalse(lazy),
                    immediateRender: immediateRender,
                    //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
                    stagger: 0,
                    parent: parent //ensures that nested tweens that had a stagger are handled properly, like gsap.from(".class", {y: gsap.utils.wrap([-100,100]), stagger: 0.5})
                }, cleanVars);
                harnessVars && (p[harness.prop] = harnessVars); // in case someone does something like .from(..., {css:{}})
                _removeFromParent(tween._startAt = Tween.set(targets, p));
                tween._startAt._dp = 0; // don't allow it to get put back into root timeline!
                tween._startAt._sat = tween; // used in globalTime()
                time < 0 && (_reverting ? tween._startAt.revert(_revertConfigNoKill) : tween._startAt.render(-1, true));
                tween._zTime = time;
                if (!immediateRender) _initTween(tween._startAt, _tinyNum, _tinyNum); //ensures that the initial values are recorded
                else if (!time) return;
            }
        }
        tween._pt = tween._ptCache = 0;
        lazy = dur && _isNotFalse(lazy) || lazy && !dur;
        for(i = 0; i < targets.length; i++){
            target = targets[i];
            gsData = target._gsap || _harness(targets)[i]._gsap;
            tween._ptLookup[i] = ptLookup = {};
            _lazyLookup[gsData.id] && _lazyTweens.length && _lazyRender(); //if other tweens of the same target have recently initted but haven't rendered yet, we've got to force the render so that the starting values are correct (imagine populating a timeline with a bunch of sequential tweens and then jumping to the end)
            index = fullTargets === targets ? i : fullTargets.indexOf(target);
            if (harness && (plugin = new harness()).init(target, harnessVars || cleanVars, tween, index, fullTargets) !== false) {
                tween._pt = pt = new PropTween(tween._pt, target, plugin.name, 0, 1, plugin.render, plugin, 0, plugin.priority);
                plugin._props.forEach(function(name) {
                    ptLookup[name] = pt;
                });
                plugin.priority && (hasPriority = 1);
            }
            if (!harness || harnessVars) {
                for(p in cleanVars)if (_plugins[p] && (plugin = _checkPlugin(p, cleanVars, tween, index, target, fullTargets))) plugin.priority && (hasPriority = 1);
                else ptLookup[p] = pt = _addPropTween.call(tween, target, p, "get", cleanVars[p], index, fullTargets, 0, vars.stringFilter);
            }
            tween._op && tween._op[i] && tween.kill(target, tween._op[i]);
            if (autoOverwrite && tween._pt) {
                _overwritingTween = tween;
                _globalTimeline.killTweensOf(target, ptLookup, tween.globalTime(time)); // make sure the overwriting doesn't overwrite THIS tween!!!
                overwritten = !tween.parent;
                _overwritingTween = 0;
            }
            tween._pt && lazy && (_lazyLookup[gsData.id] = 1);
        }
        hasPriority && _sortPropTweensByPriority(tween);
        tween._onInit && tween._onInit(tween); //plugins like RoundProps must wait until ALL of the PropTweens are instantiated. In the plugin's init() function, it sets the _onInit on the tween instance. May not be pretty/intuitive, but it's fast and keeps file size down.
    }
    tween._onUpdate = onUpdate;
    tween._initted = (!tween._op || tween._pt) && !overwritten; // if overwrittenProps resulted in the entire tween being killed, do NOT flag it as initted or else it may render for one tick.
    keyframes && time <= 0 && tl.render(_bigNum, true, true); // if there's a 0% keyframe, it'll render in the "before" state for any staggered/delayed animations thus when the following tween initializes, it'll use the "before" state instead of the "after" state as the initial values.
}, _updatePropTweens = function _updatePropTweens(tween, property, value, start, startIsRelative, ratio, time, skipRecursion) {
    var ptCache = (tween._pt && tween._ptCache || (tween._ptCache = {}))[property], pt, rootPT, lookup, i;
    if (!ptCache) {
        ptCache = tween._ptCache[property] = [];
        lookup = tween._ptLookup;
        i = tween._targets.length;
        while(i--){
            pt = lookup[i][property];
            if (pt && pt.d && pt.d._pt) {
                // it's a plugin, so find the nested PropTween
                pt = pt.d._pt;
                while(pt && pt.p !== property && pt.fp !== property)// "fp" is functionParam for things like setting CSS variables which require .setProperty("--var-name", value)
                pt = pt._next;
            }
            if (!pt) {
                // there is no PropTween associated with that property, so we must FORCE one to be created and ditch out of this
                // if the tween has other properties that already rendered at new positions, we'd normally have to rewind to put them back like tween.render(0, true) before forcing an _initTween(), but that can create another edge case like tweening a timeline's progress would trigger onUpdates to fire which could move other things around. It's better to just inform users that .resetTo() should ONLY be used for tweens that already have that property. For example, you can't gsap.to(...{ y: 0 }) and then tween.restTo("x", 200) for example.
                _forceAllPropTweens = 1; // otherwise, when we _addPropTween() and it finds no change between the start and end values, it skips creating a PropTween (for efficiency...why tween when there's no difference?) but in this case we NEED that PropTween created so we can edit it.
                tween.vars[property] = "+=0";
                _initTween(tween, time);
                _forceAllPropTweens = 0;
                return skipRecursion ? _warn(property + " not eligible for reset") : 1; // if someone tries to do a quickTo() on a special property like borderRadius which must get split into 4 different properties, that's not eligible for .resetTo().
            }
            ptCache.push(pt);
        }
    }
    i = ptCache.length;
    while(i--){
        rootPT = ptCache[i];
        pt = rootPT._pt || rootPT; // complex values may have nested PropTweens. We only accommodate the FIRST value.
        pt.s = (start || start === 0) && !startIsRelative ? start : pt.s + (start || 0) + ratio * pt.c;
        pt.c = value - pt.s;
        rootPT.e && (rootPT.e = _round(value) + getUnit(rootPT.e)); // mainly for CSSPlugin (end value)
        rootPT.b && (rootPT.b = pt.s + getUnit(rootPT.b)); // (beginning value)
    }
}, _addAliasesToVars = function _addAliasesToVars(targets, vars) {
    var harness = targets[0] ? _getCache(targets[0]).harness : 0, propertyAliases = harness && harness.aliases, copy, p, i, aliases;
    if (!propertyAliases) return vars;
    copy = _merge({}, vars);
    for(p in propertyAliases)if (p in copy) {
        aliases = propertyAliases[p].split(",");
        i = aliases.length;
        while(i--)copy[aliases[i]] = copy[p];
    }
    return copy;
}, // parses multiple formats, like {"0%": {x: 100}, {"50%": {x: -20}} and { x: {"0%": 100, "50%": -20} }, and an "ease" can be set on any object. We populate an "allProps" object with an Array for each property, like {x: [{}, {}], y:[{}, {}]} with data for each property tween. The objects have a "t" (time), "v", (value), and "e" (ease) property. This allows us to piece together a timeline later.
_parseKeyframe = function _parseKeyframe(prop, obj, allProps, easeEach) {
    var ease = obj.ease || easeEach || "power1.inOut", p, a;
    if (_isArray(obj)) {
        a = allProps[prop] || (allProps[prop] = []); // t = time (out of 100), v = value, e = ease
        obj.forEach(function(value, i) {
            return a.push({
                t: i / (obj.length - 1) * 100,
                v: value,
                e: ease
            });
        });
    } else for(p in obj){
        a = allProps[p] || (allProps[p] = []);
        p === "ease" || a.push({
            t: parseFloat(prop),
            v: obj[p],
            e: ease
        });
    }
}, _parseFuncOrString = function _parseFuncOrString(value, tween, i, target, targets) {
    return _isFunction(value) ? value.call(tween, i, target, targets) : _isString(value) && ~value.indexOf("random(") ? _replaceRandom(value) : value;
}, _staggerTweenProps = _callbackNames + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert", _staggerPropsToSkip = {};
_forEachName(_staggerTweenProps + ",id,stagger,delay,duration,paused,scrollTrigger", function(name) {
    return _staggerPropsToSkip[name] = 1;
});
var Tween = /*#__PURE__*/ function(_Animation2) {
    _inheritsLoose(Tween, _Animation2);
    function Tween(targets, vars, position, skipInherit) {
        var _this3;
        if (typeof vars === "number") {
            position.duration = vars;
            vars = position;
            position = null;
        }
        _this3 = _Animation2.call(this, skipInherit ? vars : _inheritDefaults(vars)) || this;
        var _this3$vars = _this3.vars, duration = _this3$vars.duration, delay = _this3$vars.delay, immediateRender = _this3$vars.immediateRender, stagger = _this3$vars.stagger, overwrite = _this3$vars.overwrite, keyframes = _this3$vars.keyframes, defaults = _this3$vars.defaults, scrollTrigger = _this3$vars.scrollTrigger, yoyoEase = _this3$vars.yoyoEase, parent = vars.parent || _globalTimeline, parsedTargets = (_isArray(targets) || _isTypedArray(targets) ? _isNumber(targets[0]) : "length" in vars) ? [
            targets
        ] : toArray(targets), tl, i, copy, l, p, curTarget, staggerFunc, staggerVarsToMerge;
        _this3._targets = parsedTargets.length ? _harness(parsedTargets) : _warn("GSAP target " + targets + " not found. https://gsap.com", !_config.nullTargetWarn) || [];
        _this3._ptLookup = []; //PropTween lookup. An array containing an object for each target, having keys for each tweening property
        _this3._overwrite = overwrite;
        if (keyframes || stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
            vars = _this3.vars;
            tl = _this3.timeline = new Timeline({
                data: "nested",
                defaults: defaults || {},
                targets: parent && parent.data === "nested" ? parent.vars.targets : parsedTargets
            }); // we need to store the targets because for staggers and keyframes, we end up creating an individual tween for each but function-based values need to know the index and the whole Array of targets.
            tl.kill();
            tl.parent = tl._dp = _assertThisInitialized(_this3);
            tl._start = 0;
            if (stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
                l = parsedTargets.length;
                staggerFunc = stagger && distribute(stagger);
                if (_isObject(stagger)) {
                    //users can pass in callbacks like onStart/onComplete in the stagger object. These should fire with each individual tween.
                    for(p in stagger)if (~_staggerTweenProps.indexOf(p)) {
                        staggerVarsToMerge || (staggerVarsToMerge = {});
                        staggerVarsToMerge[p] = stagger[p];
                    }
                }
                for(i = 0; i < l; i++){
                    copy = _copyExcluding(vars, _staggerPropsToSkip);
                    copy.stagger = 0;
                    yoyoEase && (copy.yoyoEase = yoyoEase);
                    staggerVarsToMerge && _merge(copy, staggerVarsToMerge);
                    curTarget = parsedTargets[i]; //don't just copy duration or delay because if they're a string or function, we'd end up in an infinite loop because _isFuncOrString() would evaluate as true in the child tweens, entering this loop, etc. So we parse the value straight from vars and default to 0.
                    copy.duration = +_parseFuncOrString(duration, _assertThisInitialized(_this3), i, curTarget, parsedTargets);
                    copy.delay = (+_parseFuncOrString(delay, _assertThisInitialized(_this3), i, curTarget, parsedTargets) || 0) - _this3._delay;
                    if (!stagger && l === 1 && copy.delay) {
                        // if someone does delay:"random(1, 5)", repeat:-1, for example, the delay shouldn't be inside the repeat.
                        _this3._delay = delay = copy.delay;
                        _this3._start += delay;
                        copy.delay = 0;
                    }
                    tl.to(curTarget, copy, staggerFunc ? staggerFunc(i, curTarget, parsedTargets) : 0);
                    tl._ease = _easeMap.none;
                }
                tl.duration() ? duration = delay = 0 : _this3.timeline = 0; // if the timeline's duration is 0, we don't need a timeline internally!
            } else if (keyframes) {
                _inheritDefaults(_setDefaults(tl.vars.defaults, {
                    ease: "none"
                }));
                tl._ease = _parseEase(keyframes.ease || vars.ease || "none");
                var time = 0, a, kf, v;
                if (_isArray(keyframes)) {
                    keyframes.forEach(function(frame) {
                        return tl.to(parsedTargets, frame, ">");
                    });
                    tl.duration(); // to ensure tl._dur is cached because we tap into it for performance purposes in the render() method.
                } else {
                    copy = {};
                    for(p in keyframes)p === "ease" || p === "easeEach" || _parseKeyframe(p, keyframes[p], copy, keyframes.easeEach);
                    for(p in copy){
                        a = copy[p].sort(function(a, b) {
                            return a.t - b.t;
                        });
                        time = 0;
                        for(i = 0; i < a.length; i++){
                            kf = a[i];
                            v = {
                                ease: kf.e,
                                duration: (kf.t - (i ? a[i - 1].t : 0)) / 100 * duration
                            };
                            v[p] = kf.v;
                            tl.to(parsedTargets, v, time);
                            time += v.duration;
                        }
                    }
                    tl.duration() < duration && tl.to({}, {
                        duration: duration - tl.duration()
                    }); // in case keyframes didn't go to 100%
                }
            }
            duration || _this3.duration(duration = tl.duration());
        } else _this3.timeline = 0; //speed optimization, faster lookups (no going up the prototype chain)
        if (overwrite === true && !_suppressOverwrites) {
            _overwritingTween = _assertThisInitialized(_this3);
            _globalTimeline.killTweensOf(parsedTargets);
            _overwritingTween = 0;
        }
        _addToTimeline(parent, _assertThisInitialized(_this3), position);
        vars.reversed && _this3.reverse();
        vars.paused && _this3.paused(true);
        if (immediateRender || !duration && !keyframes && _this3._start === _roundPrecise(parent._time) && _isNotFalse(immediateRender) && _hasNoPausedAncestors(_assertThisInitialized(_this3)) && parent.data !== "nested") {
            _this3._tTime = -_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)
            _this3.render(Math.max(0, -delay) || 0); //in case delay is negative
        }
        scrollTrigger && _scrollTrigger(_assertThisInitialized(_this3), scrollTrigger);
        return _this3;
    }
    var _proto3 = Tween.prototype;
    _proto3.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._tDur, dur = this._dur, isNegative = totalTime < 0, tTime = totalTime > tDur - _tinyNum && !isNegative ? tDur : totalTime < _tinyNum ? 0 : totalTime, time, pt, iteration, cycleDuration, prevIteration, isYoyo, ratio, timeline, yoyoEase;
        if (!dur) _renderZeroDurationTween(this, totalTime, suppressEvents, force);
        else if (tTime !== this._tTime || !totalTime || force || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== isNegative) {
            //this senses if we're crossing over the start time, in which case we must record _zTime and force the render, but we do it in this lengthy conditional way for performance reasons (usually we can skip the calculations): this._initted && (this._zTime < 0) !== (totalTime < 0)
            time = tTime;
            timeline = this.timeline;
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && isNegative) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
                    iteration = this._repeat;
                    time = dur;
                } else {
                    iteration = ~~(tTime / cycleDuration);
                    if (iteration && iteration === _roundPrecise(tTime / cycleDuration)) {
                        time = dur;
                        iteration--;
                    }
                    time > dur && (time = dur);
                }
                isYoyo = this._yoyo && iteration & 1;
                if (isYoyo) {
                    yoyoEase = this._yEase;
                    time = dur - time;
                }
                prevIteration = _animationCycle(this._tTime, cycleDuration);
                if (time === prevTime && !force && this._initted && iteration === prevIteration) {
                    //could be during the repeatDelay part. No need to render and fire callbacks.
                    this._tTime = tTime;
                    return this;
                }
                if (iteration !== prevIteration) {
                    timeline && this._yEase && _propagateYoyoEase(timeline, isYoyo); //repeatRefresh functionality
                    if (this.vars.repeatRefresh && !isYoyo && !this._lock && this._time !== cycleDuration && this._initted) {
                        // this._time will === cycleDuration when we render at EXACTLY the end of an iteration. Without this condition, it'd often do the repeatRefresh render TWICE (again on the very next tick).
                        this._lock = force = 1; //force, otherwise if lazy is true, the _attemptInitTween() will return and we'll jump out and get caught bouncing on each tick.
                        this.render(_roundPrecise(cycleDuration * iteration), true).invalidate()._lock = 0;
                    }
                }
            }
            if (!this._initted) {
                if (_attemptInitTween(this, isNegative ? totalTime : time, force, suppressEvents, tTime)) {
                    this._tTime = 0; // in constructor if immediateRender is true, we set _tTime to -_tinyNum to have the playhead cross the starting point but we can't leave _tTime as a negative number.
                    return this;
                }
                if (prevTime !== this._time && !(force && this.vars.repeatRefresh && iteration !== prevIteration)) // rare edge case - during initialization, an onUpdate in the _startAt (.fromTo()) might force this tween to render at a different spot in which case we should ditch this render() call so that it doesn't revert the values. But we also don't want to dump if we're doing a repeatRefresh render!
                return this;
                if (dur !== this._dur) // while initting, a plugin like InertiaPlugin might alter the duration, so rerun from the start to ensure everything renders as it should.
                return this.render(totalTime, suppressEvents, force);
            }
            this._tTime = tTime;
            this._time = time;
            if (!this._act && this._ts) {
                this._act = 1; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
                this._lazy = 0;
            }
            this.ratio = ratio = (yoyoEase || this._ease)(time / dur);
            if (this._from) this.ratio = ratio = 1 - ratio;
            if (time && !prevTime && !suppressEvents && !iteration) {
                _callback(this, "onStart");
                if (this._tTime !== tTime) // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
                return this;
            }
            pt = this._pt;
            while(pt){
                pt.r(ratio, pt.d);
                pt = pt._next;
            }
            timeline && timeline.render(totalTime < 0 ? totalTime : timeline._dur * timeline._ease(time / this._dur), suppressEvents, force) || this._startAt && (this._zTime = totalTime);
            if (this._onUpdate && !suppressEvents) {
                isNegative && _rewindStartAt(this, totalTime, suppressEvents, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.
                _callback(this, "onUpdate");
            }
            this._repeat && iteration !== prevIteration && this.vars.onRepeat && !suppressEvents && this.parent && _callback(this, "onRepeat");
            if ((tTime === this._tDur || !tTime) && this._tTime === tTime) {
                isNegative && !this._onUpdate && _rewindStartAt(this, totalTime, true, true);
                (totalTime || !dur) && (tTime === this._tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if we're rendering at exactly a time of 0, as there could be autoRevert values that should get set on the next tick (if the playhead goes backward beyond the startTime, negative totalTime). Don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                if (!suppressEvents && !(isNegative && !prevTime) && (tTime || prevTime || isYoyo)) {
                    // if prevTime and tTime are zero, we shouldn't fire the onReverseComplete. This could happen if you gsap.to(... {paused:true}).play();
                    _callback(this, tTime === tDur ? "onComplete" : "onReverseComplete", true);
                    this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                }
            }
        }
        return this;
    };
    _proto3.targets = function targets() {
        return this._targets;
    };
    _proto3.invalidate = function invalidate(soft) {
        // "soft" gives us a way to clear out everything EXCEPT the recorded pre-"from" portion of from() tweens. Otherwise, for example, if you tween.progress(1).render(0, true true).invalidate(), the "from" values would persist and then on the next render, the from() tweens would initialize and the current value would match the "from" values, thus animate from the same value to the same value (no animation). We tap into this in ScrollTrigger's refresh() where we must push a tween to completion and then back again but honor its init state in case the tween is dependent on another tween further up on the page.
        (!soft || !this.vars.runBackwards) && (this._startAt = 0);
        this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0;
        this._ptLookup = [];
        this.timeline && this.timeline.invalidate(soft);
        return _Animation2.prototype.invalidate.call(this, soft);
    };
    _proto3.resetTo = function resetTo(property, value, start, startIsRelative, skipRecursion) {
        _tickerActive || _ticker.wake();
        this._ts || this.play();
        var time = Math.min(this._dur, (this._dp._time - this._start) * this._ts), ratio;
        this._initted || _initTween(this, time);
        ratio = this._ease(time / this._dur); // don't just get tween.ratio because it may not have rendered yet.
        // possible future addition to allow an object with multiple values to update, like tween.resetTo({x: 100, y: 200}); At this point, it doesn't seem worth the added kb given the fact that most users will likely opt for the convenient gsap.quickTo() way of interacting with this method.
        // if (_isObject(property)) { // performance optimization
        // 	for (p in property) {
        // 		if (_updatePropTweens(this, p, property[p], value ? value[p] : null, start, ratio, time)) {
        // 			return this.resetTo(property, value, start, startIsRelative); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
        // 		}
        // 	}
        // } else {
        if (_updatePropTweens(this, property, value, start, startIsRelative, ratio, time, skipRecursion)) return this.resetTo(property, value, start, startIsRelative, 1); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
         //}
        _alignPlayhead(this, 0);
        this.parent || _addLinkedListItem(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0);
        return this.render(0);
    };
    _proto3.kill = function kill(targets, vars) {
        if (vars === void 0) vars = "all";
        if (!targets && (!vars || vars === "all")) {
            this._lazy = this._pt = 0;
            return this.parent ? _interrupt(this) : this;
        }
        if (this.timeline) {
            var tDur = this.timeline.totalDuration();
            this.timeline.killTweensOf(targets, vars, _overwritingTween && _overwritingTween.vars.overwrite !== true)._first || _interrupt(this); // if nothing is left tweening, interrupt.
            this.parent && tDur !== this.timeline.totalDuration() && _setDuration(this, this._dur * this.timeline._tDur / tDur, 0, 1); // if a nested tween is killed that changes the duration, it should affect this tween's duration. We must use the ratio, though, because sometimes the internal timeline is stretched like for keyframes where they don't all add up to whatever the parent tween's duration was set to.
            return this;
        }
        var parsedTargets = this._targets, killingTargets = targets ? toArray(targets) : parsedTargets, propTweenLookup = this._ptLookup, firstPT = this._pt, overwrittenProps, curLookup, curOverwriteProps, props, p, pt, i;
        if ((!vars || vars === "all") && _arraysMatch(parsedTargets, killingTargets)) {
            vars === "all" && (this._pt = 0);
            return _interrupt(this);
        }
        overwrittenProps = this._op = this._op || [];
        if (vars !== "all") {
            //so people can pass in a comma-delimited list of property names
            if (_isString(vars)) {
                p = {};
                _forEachName(vars, function(name) {
                    return p[name] = 1;
                });
                vars = p;
            }
            vars = _addAliasesToVars(parsedTargets, vars);
        }
        i = parsedTargets.length;
        while(i--)if (~killingTargets.indexOf(parsedTargets[i])) {
            curLookup = propTweenLookup[i];
            if (vars === "all") {
                overwrittenProps[i] = vars;
                props = curLookup;
                curOverwriteProps = {};
            } else {
                curOverwriteProps = overwrittenProps[i] = overwrittenProps[i] || {};
                props = vars;
            }
            for(p in props){
                pt = curLookup && curLookup[p];
                if (pt) {
                    if (!("kill" in pt.d) || pt.d.kill(p) === true) _removeLinkedListItem(this, pt, "_pt");
                    delete curLookup[p];
                }
                if (curOverwriteProps !== "all") curOverwriteProps[p] = 1;
            }
        }
        this._initted && !this._pt && firstPT && _interrupt(this); //if all tweening properties are killed, kill the tween. Without this line, if there's a tween with multiple targets and then you killTweensOf() each target individually, the tween would technically still remain active and fire its onComplete even though there aren't any more properties tweening.
        return this;
    };
    Tween.to = function to(targets, vars) {
        return new Tween(targets, vars, arguments[2]);
    };
    Tween.from = function from(targets, vars) {
        return _createTweenType(1, arguments);
    };
    Tween.delayedCall = function delayedCall(delay, callback, params, scope) {
        return new Tween(callback, 0, {
            immediateRender: false,
            lazy: false,
            overwrite: false,
            delay: delay,
            onComplete: callback,
            onReverseComplete: callback,
            onCompleteParams: params,
            onReverseCompleteParams: params,
            callbackScope: scope
        }); // we must use onReverseComplete too for things like timeline.add(() => {...}) which should be triggered in BOTH directions (forward and reverse)
    };
    Tween.fromTo = function fromTo(targets, fromVars, toVars) {
        return _createTweenType(2, arguments);
    };
    Tween.set = function set(targets, vars) {
        vars.duration = 0;
        vars.repeatDelay || (vars.repeat = 0);
        return new Tween(targets, vars);
    };
    Tween.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        return _globalTimeline.killTweensOf(targets, props, onlyActive);
    };
    return Tween;
}(Animation);
_setDefaults(Tween.prototype, {
    _targets: [],
    _lazy: 0,
    _startAt: 0,
    _op: 0,
    _onInit: 0
}); //add the pertinent timeline methods to Tween instances so that users can chain conveniently and create a timeline automatically. (removed due to concerns that it'd ultimately add to more confusion especially for beginners)
// _forEachName("to,from,fromTo,set,call,add,addLabel,addPause", name => {
// 	Tween.prototype[name] = function() {
// 		let tl = new Timeline();
// 		return _addToTimeline(tl, this)[name].apply(tl, toArray(arguments));
// 	}
// });
//for backward compatibility. Leverage the timeline calls.
_forEachName("staggerTo,staggerFrom,staggerFromTo", function(name) {
    Tween[name] = function() {
        var tl = new Timeline(), params = _slice.call(arguments, 0);
        params.splice(name === "staggerFromTo" ? 5 : 4, 0, 0);
        return tl[name].apply(tl, params);
    };
});
/*
 * --------------------------------------------------------------------------------------
 * PROPTWEEN
 * --------------------------------------------------------------------------------------
 */ var _setterPlain = function _setterPlain(target, property, value) {
    return target[property] = value;
}, _setterFunc = function _setterFunc(target, property, value) {
    return target[property](value);
}, _setterFuncWithParam = function _setterFuncWithParam(target, property, value, data) {
    return target[property](data.fp, value);
}, _setterAttribute = function _setterAttribute(target, property, value) {
    return target.setAttribute(property, value);
}, _getSetter = function _getSetter(target, property) {
    return _isFunction(target[property]) ? _setterFunc : _isUndefined(target[property]) && target.setAttribute ? _setterAttribute : _setterPlain;
}, _renderPlain = function _renderPlain(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 1000000) / 1000000, data);
}, _renderBoolean = function _renderBoolean(ratio, data) {
    return data.set(data.t, data.p, !!(data.s + data.c * ratio), data);
}, _renderComplexString = function _renderComplexString(ratio, data) {
    var pt = data._pt, s = "";
    if (!ratio && data.b) //b = beginning string
    s = data.b;
    else if (ratio === 1 && data.e) //e = ending string
    s = data.e;
    else {
        while(pt){
            s = pt.p + (pt.m ? pt.m(pt.s + pt.c * ratio) : Math.round((pt.s + pt.c * ratio) * 10000) / 10000) + s; //we use the "p" property for the text inbetween (like a suffix). And in the context of a complex string, the modifier (m) is typically just Math.round(), like for RGB colors.
            pt = pt._next;
        }
        s += data.c; //we use the "c" of the PropTween to store the final chunk of non-numeric text.
    }
    data.set(data.t, data.p, s, data);
}, _renderPropTweens = function _renderPropTweens(ratio, data) {
    var pt = data._pt;
    while(pt){
        pt.r(ratio, pt.d);
        pt = pt._next;
    }
}, _addPluginModifier = function _addPluginModifier(modifier, tween, target, property) {
    var pt = this._pt, next;
    while(pt){
        next = pt._next;
        pt.p === property && pt.modifier(modifier, tween, target);
        pt = next;
    }
}, _killPropTweensOf = function _killPropTweensOf(property) {
    var pt = this._pt, hasNonDependentRemaining, next;
    while(pt){
        next = pt._next;
        if (pt.p === property && !pt.op || pt.op === property) _removeLinkedListItem(this, pt, "_pt");
        else if (!pt.dep) hasNonDependentRemaining = 1;
        pt = next;
    }
    return !hasNonDependentRemaining;
}, _setterWithModifier = function _setterWithModifier(target, property, value, data) {
    data.mSet(target, property, data.m.call(data.tween, value, data.mt), data);
}, _sortPropTweensByPriority = function _sortPropTweensByPriority(parent) {
    var pt = parent._pt, next, pt2, first, last; //sorts the PropTween linked list in order of priority because some plugins need to do their work after ALL of the PropTweens were created (like RoundPropsPlugin and ModifiersPlugin)
    while(pt){
        next = pt._next;
        pt2 = first;
        while(pt2 && pt2.pr > pt.pr)pt2 = pt2._next;
        if (pt._prev = pt2 ? pt2._prev : last) pt._prev._next = pt;
        else first = pt;
        if (pt._next = pt2) pt2._prev = pt;
        else last = pt;
        pt = next;
    }
    parent._pt = first;
}; //PropTween key: t = target, p = prop, r = renderer, d = data, s = start, c = change, op = overwriteProperty (ONLY populated when it's different than p), pr = priority, _next/_prev for the linked list siblings, set = setter, m = modifier, mSet = modifierSetter (the original setter, before a modifier was added)
var PropTween = /*#__PURE__*/ function() {
    function PropTween(next, target, prop, start, change, renderer, data, setter, priority) {
        this.t = target;
        this.s = start;
        this.c = change;
        this.p = prop;
        this.r = renderer || _renderPlain;
        this.d = data || this;
        this.set = setter || _setterPlain;
        this.pr = priority || 0;
        this._next = next;
        if (next) next._prev = this;
    }
    var _proto4 = PropTween.prototype;
    _proto4.modifier = function modifier(func, tween, target) {
        this.mSet = this.mSet || this.set; //in case it was already set (a PropTween can only have one modifier)
        this.set = _setterWithModifier;
        this.m = func;
        this.mt = target; //modifier target
        this.tween = tween;
    };
    return PropTween;
}(); //Initialization tasks
_forEachName(_callbackNames + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", function(name) {
    return _reservedProps[name] = 1;
});
_globals.TweenMax = _globals.TweenLite = Tween;
_globals.TimelineLite = _globals.TimelineMax = Timeline;
_globalTimeline = new Timeline({
    sortChildren: false,
    defaults: _defaults,
    autoRemoveChildren: true,
    id: "root",
    smoothChildTiming: true
});
_config.stringFilter = _colorStringFilter;
var _media = [], _listeners = {}, _emptyArray = [], _lastMediaTime = 0, _contextID = 0, _dispatch = function _dispatch(type) {
    return (_listeners[type] || _emptyArray).map(function(f) {
        return f();
    });
}, _onMediaChange = function _onMediaChange() {
    var time = Date.now(), matches = [];
    if (time - _lastMediaTime > 2) {
        _dispatch("matchMediaInit");
        _media.forEach(function(c) {
            var queries = c.queries, conditions = c.conditions, match, p, anyMatch, toggled;
            for(p in queries){
                match = _win.matchMedia(queries[p]).matches; // Firefox doesn't update the "matches" property of the MediaQueryList object correctly - it only does so as it calls its change handler - so we must re-create a media query here to ensure it's accurate.
                match && (anyMatch = 1);
                if (match !== conditions[p]) {
                    conditions[p] = match;
                    toggled = 1;
                }
            }
            if (toggled) {
                c.revert();
                anyMatch && matches.push(c);
            }
        });
        _dispatch("matchMediaRevert");
        matches.forEach(function(c) {
            return c.onMatch(c, function(func) {
                return c.add(null, func);
            });
        });
        _lastMediaTime = time;
        _dispatch("matchMedia");
    }
};
var Context = /*#__PURE__*/ function() {
    function Context(func, scope) {
        this.selector = scope && selector(scope);
        this.data = [];
        this._r = []; // returned/cleanup functions
        this.isReverted = false;
        this.id = _contextID++; // to work around issues that frameworks like Vue cause by making things into Proxies which make it impossible to do something like _media.indexOf(this) because "this" would no longer refer to the Context instance itself - it'd refer to a Proxy! We needed a way to identify the context uniquely
        func && this.add(func);
    }
    var _proto5 = Context.prototype;
    _proto5.add = function add(name, func, scope) {
        // possible future addition if we need the ability to add() an animation to a context and for whatever reason cannot create that animation inside of a context.add(() => {...}) function.
        // if (name && _isFunction(name.revert)) {
        // 	this.data.push(name);
        // 	return (name._ctx = this);
        // }
        if (_isFunction(name)) {
            scope = func;
            func = name;
            name = _isFunction;
        }
        var self = this, f = function f() {
            var prev = _context, prevSelector = self.selector, result;
            prev && prev !== self && prev.data.push(self);
            scope && (self.selector = selector(scope));
            _context = self;
            result = func.apply(self, arguments);
            _isFunction(result) && self._r.push(result);
            _context = prev;
            self.selector = prevSelector;
            self.isReverted = false;
            return result;
        };
        self.last = f;
        return name === _isFunction ? f(self, function(func) {
            return self.add(null, func);
        }) : name ? self[name] = f : f;
    };
    _proto5.ignore = function ignore(func) {
        var prev = _context;
        _context = null;
        func(this);
        _context = prev;
    };
    _proto5.getTweens = function getTweens() {
        var a = [];
        this.data.forEach(function(e) {
            return e instanceof Context ? a.push.apply(a, e.getTweens()) : e instanceof Tween && !(e.parent && e.parent.data === "nested") && a.push(e);
        });
        return a;
    };
    _proto5.clear = function clear() {
        this._r.length = this.data.length = 0;
    };
    _proto5.kill = function kill(revert, matchMedia) {
        var _this4 = this;
        if (revert) (function() {
            var tweens = _this4.getTweens(), i = _this4.data.length, t;
            while(i--){
                // Flip plugin tweens are very different in that they should actually be pushed to their end. The plugin replaces the timeline's .revert() method to do exactly that. But we also need to remove any of those nested tweens inside the flip timeline so that they don't get individually reverted.
                t = _this4.data[i];
                if (t.data === "isFlip") {
                    t.revert();
                    t.getChildren(true, true, false).forEach(function(tween) {
                        return tweens.splice(tweens.indexOf(tween), 1);
                    });
                }
            } // save as an object so that we can cache the globalTime for each tween to optimize performance during the sort
            tweens.map(function(t) {
                return {
                    g: t._dur || t._delay || t._sat && !t._sat.vars.immediateRender ? t.globalTime(0) : -Infinity,
                    t: t
                };
            }).sort(function(a, b) {
                return b.g - a.g || -Infinity;
            }).forEach(function(o) {
                return o.t.revert(revert);
            }); // note: all of the _startAt tweens should be reverted in reverse order that they were created, and they'll all have the same globalTime (-1) so the " || -1" in the sort keeps the order properly.
            i = _this4.data.length;
            while(i--){
                // make sure we loop backwards so that, for example, SplitTexts that were created later on the same element get reverted first
                t = _this4.data[i];
                if (t instanceof Timeline) {
                    if (t.data !== "nested") {
                        t.scrollTrigger && t.scrollTrigger.revert();
                        t.kill(); // don't revert() the timeline because that's duplicating efforts since we already reverted all the tweens
                    }
                } else !(t instanceof Tween) && t.revert && t.revert(revert);
            }
            _this4._r.forEach(function(f) {
                return f(revert, _this4);
            });
            _this4.isReverted = true;
        })();
        else this.data.forEach(function(e) {
            return e.kill && e.kill();
        });
        this.clear();
        if (matchMedia) {
            var i = _media.length;
            while(i--)// previously, we checked _media.indexOf(this), but some frameworks like Vue enforce Proxy objects that make it impossible to get the proper result that way, so we must use a unique ID number instead.
            _media[i].id === this.id && _media.splice(i, 1);
        }
    };
    _proto5.revert = function revert(config) {
        this.kill(config || {});
    };
    return Context;
}();
var MatchMedia = /*#__PURE__*/ function() {
    function MatchMedia(scope) {
        this.contexts = [];
        this.scope = scope;
        _context && _context.data.push(this);
    }
    var _proto6 = MatchMedia.prototype;
    _proto6.add = function add(conditions, func, scope) {
        _isObject(conditions) || (conditions = {
            matches: conditions
        });
        var context = new Context(0, scope || this.scope), cond = context.conditions = {}, mq, p, active;
        _context && !context.selector && (context.selector = _context.selector); // in case a context is created inside a context. Like a gsap.matchMedia() that's inside a scoped gsap.context()
        this.contexts.push(context);
        func = context.add("onMatch", func);
        context.queries = conditions;
        for(p in conditions)if (p === "all") active = 1;
        else {
            mq = _win.matchMedia(conditions[p]);
            if (mq) {
                _media.indexOf(context) < 0 && _media.push(context);
                (cond[p] = mq.matches) && (active = 1);
                mq.addListener ? mq.addListener(_onMediaChange) : mq.addEventListener("change", _onMediaChange);
            }
        }
        active && func(context, function(f) {
            return context.add(null, f);
        });
        return this;
    } // refresh() {
    ;
    _proto6.revert = function revert(config) {
        this.kill(config || {});
    };
    _proto6.kill = function kill(revert) {
        this.contexts.forEach(function(c) {
            return c.kill(revert, true);
        });
    };
    return MatchMedia;
}();
/*
 * --------------------------------------------------------------------------------------
 * GSAP
 * --------------------------------------------------------------------------------------
 */ var _gsap = {
    registerPlugin: function registerPlugin() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        args.forEach(function(config) {
            return _createPlugin(config);
        });
    },
    timeline: function timeline(vars) {
        return new Timeline(vars);
    },
    getTweensOf: function getTweensOf(targets, onlyActive) {
        return _globalTimeline.getTweensOf(targets, onlyActive);
    },
    getProperty: function getProperty(target, property, unit, uncache) {
        _isString(target) && (target = toArray(target)[0]); //in case selector text or an array is passed in
        var getter = _getCache(target || {}).get, format = unit ? _passThrough : _numericIfPossible;
        unit === "native" && (unit = "");
        return !target ? target : !property ? function(property, unit, uncache) {
            return format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
        } : format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
    },
    quickSetter: function quickSetter(target, property, unit) {
        target = toArray(target);
        if (target.length > 1) {
            var setters = target.map(function(t) {
                return gsap.quickSetter(t, property, unit);
            }), l = setters.length;
            return function(value) {
                var i = l;
                while(i--)setters[i](value);
            };
        }
        target = target[0] || {};
        var Plugin = _plugins[property], cache = _getCache(target), p = cache.harness && (cache.harness.aliases || {})[property] || property, // in case it's an alias, like "rotate" for "rotation".
        setter = Plugin ? function(value) {
            var p = new Plugin();
            _quickTween._pt = 0;
            p.init(target, unit ? value + unit : value, _quickTween, 0, [
                target
            ]);
            p.render(1, p);
            _quickTween._pt && _renderPropTweens(1, _quickTween);
        } : cache.set(target, p);
        return Plugin ? setter : function(value) {
            return setter(target, p, unit ? value + unit : value, cache, 1);
        };
    },
    quickTo: function quickTo(target, property, vars) {
        var _merge2;
        var tween = gsap.to(target, _merge((_merge2 = {}, _merge2[property] = "+=0.1", _merge2.paused = true, _merge2), vars || {})), func = function func(value, start, startIsRelative) {
            return tween.resetTo(property, value, start, startIsRelative);
        };
        func.tween = tween;
        return func;
    },
    isTweening: function isTweening(targets) {
        return _globalTimeline.getTweensOf(targets, true).length > 0;
    },
    defaults: function defaults(value) {
        value && value.ease && (value.ease = _parseEase(value.ease, _defaults.ease));
        return _mergeDeep(_defaults, value || {});
    },
    config: function config(value) {
        return _mergeDeep(_config, value || {});
    },
    registerEffect: function registerEffect(_ref3) {
        var name = _ref3.name, effect = _ref3.effect, plugins = _ref3.plugins, defaults = _ref3.defaults, extendTimeline = _ref3.extendTimeline;
        (plugins || "").split(",").forEach(function(pluginName) {
            return pluginName && !_plugins[pluginName] && !_globals[pluginName] && _warn(name + " effect requires " + pluginName + " plugin.");
        });
        _effects[name] = function(targets, vars, tl) {
            return effect(toArray(targets), _setDefaults(vars || {}, defaults), tl);
        };
        if (extendTimeline) Timeline.prototype[name] = function(targets, vars, position) {
            return this.add(_effects[name](targets, _isObject(vars) ? vars : (position = vars) && {}, this), position);
        };
    },
    registerEase: function registerEase(name, ease) {
        _easeMap[name] = _parseEase(ease);
    },
    parseEase: function parseEase(ease, defaultEase) {
        return arguments.length ? _parseEase(ease, defaultEase) : _easeMap;
    },
    getById: function getById(id) {
        return _globalTimeline.getById(id);
    },
    exportRoot: function exportRoot(vars, includeDelayedCalls) {
        if (vars === void 0) vars = {};
        var tl = new Timeline(vars), child, next;
        tl.smoothChildTiming = _isNotFalse(vars.smoothChildTiming);
        _globalTimeline.remove(tl);
        tl._dp = 0; //otherwise it'll get re-activated when adding children and be re-introduced into _globalTimeline's linked list (then added to itself).
        tl._time = tl._tTime = _globalTimeline._time;
        child = _globalTimeline._first;
        while(child){
            next = child._next;
            if (includeDelayedCalls || !(!child._dur && child instanceof Tween && child.vars.onComplete === child._targets[0])) _addToTimeline(tl, child, child._start - child._delay);
            child = next;
        }
        _addToTimeline(_globalTimeline, tl, 0);
        return tl;
    },
    context: function context(func, scope) {
        return func ? new Context(func, scope) : _context;
    },
    matchMedia: function matchMedia(scope) {
        return new MatchMedia(scope);
    },
    matchMediaRefresh: function matchMediaRefresh() {
        return _media.forEach(function(c) {
            var cond = c.conditions, found, p;
            for(p in cond)if (cond[p]) {
                cond[p] = false;
                found = 1;
            }
            found && c.revert();
        }) || _onMediaChange();
    },
    addEventListener: function addEventListener(type, callback) {
        var a = _listeners[type] || (_listeners[type] = []);
        ~a.indexOf(callback) || a.push(callback);
    },
    removeEventListener: function removeEventListener(type, callback) {
        var a = _listeners[type], i = a && a.indexOf(callback);
        i >= 0 && a.splice(i, 1);
    },
    utils: {
        wrap: wrap,
        wrapYoyo: wrapYoyo,
        distribute: distribute,
        random: random,
        snap: snap,
        normalize: normalize,
        getUnit: getUnit,
        clamp: clamp,
        splitColor: splitColor,
        toArray: toArray,
        selector: selector,
        mapRange: mapRange,
        pipe: pipe,
        unitize: unitize,
        interpolate: interpolate,
        shuffle: shuffle
    },
    install: _install,
    effects: _effects,
    ticker: _ticker,
    updateRoot: Timeline.updateRoot,
    plugins: _plugins,
    globalTimeline: _globalTimeline,
    core: {
        PropTween: PropTween,
        globals: _addGlobal,
        Tween: Tween,
        Timeline: Timeline,
        Animation: Animation,
        getCache: _getCache,
        _removeLinkedListItem: _removeLinkedListItem,
        reverting: function reverting() {
            return _reverting;
        },
        context: function context(toAdd) {
            if (toAdd && _context) {
                _context.data.push(toAdd);
                toAdd._ctx = _context;
            }
            return _context;
        },
        suppressOverwrites: function suppressOverwrites(value) {
            return _suppressOverwrites = value;
        }
    }
};
_forEachName("to,from,fromTo,delayedCall,set,killTweensOf", function(name) {
    return _gsap[name] = Tween[name];
});
_ticker.add(Timeline.updateRoot);
_quickTween = _gsap.to({}, {
    duration: 0
}); // ---- EXTRA PLUGINS --------------------------------------------------------
var _getPluginPropTween = function _getPluginPropTween(plugin, prop) {
    var pt = plugin._pt;
    while(pt && pt.p !== prop && pt.op !== prop && pt.fp !== prop)pt = pt._next;
    return pt;
}, _addModifiers = function _addModifiers(tween, modifiers) {
    var targets = tween._targets, p, i, pt;
    for(p in modifiers){
        i = targets.length;
        while(i--){
            pt = tween._ptLookup[i][p];
            if (pt && (pt = pt.d)) {
                if (pt._pt) // is a plugin
                pt = _getPluginPropTween(pt, p);
                pt && pt.modifier && pt.modifier(modifiers[p], tween, targets[i], p);
            }
        }
    }
}, _buildModifierPlugin = function _buildModifierPlugin(name, modifier) {
    return {
        name: name,
        rawVars: 1,
        //don't pre-process function-based values or "random()" strings.
        init: function init(target, vars, tween) {
            tween._onInit = function(tween) {
                var temp, p;
                if (_isString(vars)) {
                    temp = {};
                    _forEachName(vars, function(name) {
                        return temp[name] = 1;
                    }); //if the user passes in a comma-delimited list of property names to roundProps, like "x,y", we round to whole numbers.
                    vars = temp;
                }
                if (modifier) {
                    temp = {};
                    for(p in vars)temp[p] = modifier(vars[p]);
                    vars = temp;
                }
                _addModifiers(tween, vars);
            };
        }
    };
}; //register core plugins
var gsap = _gsap.registerPlugin({
    name: "attr",
    init: function init(target, vars, tween, index, targets) {
        var p, pt, v;
        this.tween = tween;
        for(p in vars){
            v = target.getAttribute(p) || "";
            pt = this.add(target, "setAttribute", (v || 0) + "", vars[p], index, targets, 0, 0, p);
            pt.op = p;
            pt.b = v; // record the beginning value so we can revert()
            this._props.push(p);
        }
    },
    render: function render(ratio, data) {
        var pt = data._pt;
        while(pt){
            _reverting ? pt.set(pt.t, pt.p, pt.b, pt) : pt.r(ratio, pt.d); // if reverting, go back to the original (pt.b)
            pt = pt._next;
        }
    }
}, {
    name: "endArray",
    init: function init(target, value) {
        var i = value.length;
        while(i--)this.add(target, i, target[i] || 0, value[i], 0, 0, 0, 0, 0, 1);
    }
}, _buildModifierPlugin("roundProps", _roundModifier), _buildModifierPlugin("modifiers"), _buildModifierPlugin("snap", snap)) || _gsap; //to prevent the core plugins from being dropped via aggressive tree shaking, we must include them in the variable declaration in this way.
Tween.version = Timeline.version = gsap.version = "3.12.5";
_coreReady = 1;
_windowExists() && _wake();
var Power0 = _easeMap.Power0, Power1 = _easeMap.Power1, Power2 = _easeMap.Power2, Power3 = _easeMap.Power3, Power4 = _easeMap.Power4, Linear = _easeMap.Linear, Quad = _easeMap.Quad, Cubic = _easeMap.Cubic, Quart = _easeMap.Quart, Quint = _easeMap.Quint, Strong = _easeMap.Strong, Elastic = _easeMap.Elastic, Back = _easeMap.Back, SteppedEase = _easeMap.SteppedEase, Bounce = _easeMap.Bounce, Sine = _easeMap.Sine, Expo = _easeMap.Expo, Circ = _easeMap.Circ;

});

parcelRegister("gP1US", function(module, exports) {

$parcel$export(module.exports, "Browser", () => Browser$1);
$parcel$export(module.exports, "Point", () => Point);
$parcel$export(module.exports, "INTERNAL_LAYER_PREFIX", () => INTERNAL_LAYER_PREFIX);
$parcel$export(module.exports, "Size", () => Size);
$parcel$export(module.exports, "Util", () => index$6);
$parcel$export(module.exports, "BBOXUtil", () => bbox);
$parcel$export(module.exports, "math", () => index$5);
$parcel$export(module.exports, "registerWorkerAdapter", () => registerWorkerAdapter);
$parcel$export(module.exports, "MicroTask", () => MicroTask);
$parcel$export(module.exports, "LRUCache", () => LRUCache);
$parcel$export(module.exports, "Eventable", () => Eventable);
$parcel$export(module.exports, "Class", () => Class);
$parcel$export(module.exports, "Handlerable", () => Handlerable);
$parcel$export(module.exports, "Coordinate", () => Coordinate);
$parcel$export(module.exports, "Extent", () => Extent);
$parcel$export(module.exports, "PointExtent", () => PointExtent);
$parcel$export(module.exports, "measurer", () => index$4);
$parcel$export(module.exports, "projection", () => projections);
$parcel$export(module.exports, "SpatialReference", () => SpatialReference);
$parcel$export(module.exports, "Geometry", () => Geometry);
$parcel$export(module.exports, "Layer", () => Layer);
$parcel$export(module.exports, "Map", () => Map$1);
$parcel$export(module.exports, "Polygon", () => Polygon);
$parcel$export(module.exports, "Marker", () => Marker);
$parcel$export(module.exports, "LineString", () => LineString);
$parcel$export(module.exports, "MultiPoint", () => MultiPoint);
$parcel$export(module.exports, "MultiLineString", () => MultiLineString);
$parcel$export(module.exports, "MultiPolygon", () => MultiPolygon);
$parcel$export(module.exports, "Circle", () => Circle);
$parcel$export(module.exports, "Ellipse", () => Ellipse);
$parcel$export(module.exports, "Rectangle", () => Rectangle);
$parcel$export(module.exports, "Sector", () => Sector);
$parcel$export(module.exports, "Label", () => Label);
$parcel$export(module.exports, "OverlayLayer", () => OverlayLayer);
$parcel$export(module.exports, "DrawTool", () => DrawTool);
$parcel$export(module.exports, "ui", () => index$2);
$parcel$export(module.exports, "TileLayer", () => TileLayer);
$parcel$export(module.exports, "VectorLayer", () => VectorLayer);
$parcel$export(module.exports, "renderer", () => index);
$parcel$export(module.exports, "worker", () => worker);
/*!
 * maptalks v1.1.3
 * LICENSE : BSD-3-Clause
 * (c) 2016-2025 maptalks.org
 */ 
var $hPtJY = parcelRequire("hPtJY");
var version = "1.1.3";
var IS_NODE = Object.prototype.toString.call(typeof $hPtJY !== 'undefined' ? $hPtJY : 0) === '[object process]' && !$hPtJY.versions['electron'] && !$hPtJY.versions['nw'] && !$hPtJY.versions['node-webkit'];
function getGlobalThis() {
    return typeof globalThis !== 'undefined' ? globalThis : $parcel$global || self;
}
function checkMTKVersion(version) {
    var mtkversion = getGlobalThis().maptalksversion;
    if (mtkversion) throw new Error("Disallow duplicate imports of maptalks version " + version + " and " + mtkversion);
    else getGlobalThis().maptalksversion = version;
}
var GlobalConfig = {
    isTest: false,
    idleLog: false,
    idleForceTimeThreshold: 48,
    workerCount: getGlobalThis().MAPTALKS_WORKER_COUNT || 0,
    messagePostRatioPerWorker: 0.3,
    maxFPS: 0,
    crsMaxNativeZoom: 22
};
function now() {
    return Date.now();
}
function extend$2(dest, ...args) {
    for(var i = 0; i < args.length; i++){
        var src = args[i];
        for(var k in src)dest[k] = src[k];
    }
    return dest;
}
function isNil(obj) {
    return obj == null;
}
function isNumber(val) {
    return typeof val === 'number' && !isNaN(val);
}
function isInteger(n) {
    return (n | 0) === n;
}
function isObject$1(obj) {
    return typeof obj === 'object' && !!obj;
}
function isString(obj) {
    if (isNil(obj)) return false;
    return typeof obj === 'string' || obj.constructor !== null && obj.constructor === String;
}
function isFunction(obj) {
    if (isNil(obj)) return false;
    return typeof obj === 'function' || obj.constructor !== null && obj.constructor === Function;
}
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn(obj, key) {
    return hasOwnProperty.call(obj, key);
}
function join(arr, seperator) {
    if (arr.join) return arr.join(seperator || ',');
    else return Array.prototype.join.call(arr, seperator || ',');
}
function isEmpty(object) {
    var property;
    for(property in object)return false;
    return !property;
}
var pi = Math.PI / 180;
function toRadian(d) {
    return d * pi;
}
function toDegree(r) {
    return r / pi;
}
var Browser = {};
function getDevicePixelRatio() {
    return window.devicePixelRatio || window.screen.deviceXDPI / window.screen.logicalXDPI;
}
if (!IS_NODE) {
    var ua = navigator.userAgent.toLowerCase(), doc = document.documentElement || {
        style: {}
    }, ie = 'ActiveXObject' in window, webkit = ua.indexOf('webkit') !== -1, phantomjs = ua.indexOf('phantom') !== -1, android23 = ua.search('android [23]') !== -1, chrome = ua.indexOf('chrome') !== -1, gecko = ua.indexOf('gecko') !== -1 && !webkit && !window.opera && !ie, iosWeixin = /iphone/i.test(ua) && /micromessenger/i.test(ua), mobile = typeof orientation !== 'undefined' || ua.indexOf('mobile') !== -1, msPointer = !window.PointerEvent && window.MSPointerEvent, pointer = window.PointerEvent && navigator.pointerEnabled || msPointer, ie3d = ie && 'transition' in doc.style, webkit3d = 'WebKitCSSMatrix' in window && 'm11' in new window.WebKitCSSMatrix() && !android23, gecko3d = 'MozPerspective' in doc.style, opera12 = 'OTransition' in doc.style, any3d = (ie3d || webkit3d || gecko3d) && !opera12 && !phantomjs, imageBitMap = typeof window !== 'undefined' && isFunction(window.createImageBitmap), resizeObserver = typeof window !== 'undefined' && isFunction(window.ResizeObserver), btoa$1 = typeof window !== 'undefined' && isFunction(window.btoa), proxy = typeof window !== 'undefined' && isFunction(window.Proxy), requestIdleCallback$1 = typeof window !== 'undefined' && isFunction(window.requestIdleCallback);
    var chromeVersion = 0;
    if (chrome) chromeVersion = ua.match(/chrome\/([\d.]+)/)[1];
    var touch = !phantomjs && (pointer || 'ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch);
    var webgl = typeof window !== 'undefined' && 'WebGLRenderingContext' in window;
    var devicePixelRatio = getDevicePixelRatio();
    var decodeImageInWorker = false;
    try {
        var offCanvas = new OffscreenCanvas(2, 2);
        offCanvas.getContext('2d');
        decodeImageInWorker = true;
    } catch (err) {
        decodeImageInWorker = false;
    }
    var supportsPassive = false;
    try {
        var opts = Object.defineProperty({}, 'passive', {
            get: function get() {
                supportsPassive = true;
            }
        });
        window.addEventListener("testPassive", null, opts);
        window.removeEventListener("testPassive", null, opts);
    } catch (e) {}
    Browser = {
        IS_NODE: IS_NODE,
        isTest: false,
        ie: ie,
        ielt9: ie && !document.addEventListener,
        edge: 'msLaunchUri' in navigator && !('documentMode' in document),
        webkit: webkit,
        gecko: gecko,
        android: ua.indexOf('android') !== -1,
        android23: android23,
        chrome: chrome,
        chromeVersion: chromeVersion,
        safari: !chrome && ua.indexOf('safari') !== -1,
        phantomjs: phantomjs,
        ie3d: ie3d,
        webkit3d: webkit3d,
        gecko3d: gecko3d,
        opera12: opera12,
        any3d: any3d,
        iosWeixin: iosWeixin,
        mobile: mobile,
        mobileWebkit: mobile && webkit,
        mobileWebkit3d: mobile && webkit3d,
        mobileOpera: mobile && window.opera,
        mobileGecko: mobile && gecko,
        touch: !!touch,
        msPointer: !!msPointer,
        pointer: !!pointer,
        retina: devicePixelRatio > 1,
        devicePixelRatio: devicePixelRatio,
        language: navigator.browserLanguage ? navigator.browserLanguage : navigator.language,
        ie9: ie && document.documentMode === 9,
        ie10: ie && document.documentMode === 10,
        webgl: webgl,
        imageBitMap: imageBitMap,
        resizeObserver: resizeObserver,
        btoa: btoa$1,
        decodeImageInWorker: decodeImageInWorker,
        monitorDPRChange: true,
        supportsPassive: supportsPassive,
        proxy: proxy,
        requestIdleCallback: requestIdleCallback$1,
        checkDevicePixelRatio: function checkDevicePixelRatio() {
            if (typeof window !== 'undefined' && Browser.monitorDPRChange) {
                var _devicePixelRatio = getDevicePixelRatio();
                var changed = _devicePixelRatio !== Browser.devicePixelRatio;
                if (changed) Browser.devicePixelRatio = _devicePixelRatio;
                return changed;
            }
            return false;
        }
    };
}
var Browser$1 = Browser;
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function _assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
function _construct(t, e, r) {
    if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && _setPrototypeOf(p, r.prototype), p;
}
function _defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
    }
}
function _createClass(e, r, t) {
    return r && _defineProperties(e.prototype, r), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function _createForOfIteratorHelperLoose(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (t) return (t = t.call(r)).next.bind(t);
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e) {
        t && (r = t);
        var o = 0;
        return function() {
            return o >= r.length ? {
                done: !0
            } : {
                done: !1,
                value: r[o++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _getPrototypeOf(t) {
    return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, _getPrototypeOf(t);
}
function _inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
}
function _isNativeFunction(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function() {
        return !!t;
    })();
}
function _regeneratorRuntime() {
    _regeneratorRuntime = function() {
        return e;
    };
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError(typeof e + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        catch: function(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
function _setPrototypeOf(t, e) {
    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, _setPrototypeOf(t, e);
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r);
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(t);
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return _arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
    }
}
function _wrapNativeSuper(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return _wrapNativeSuper = function(t) {
        if (null === t || !_isNativeFunction(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return _construct(t, arguments, _getPrototypeOf(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), _setPrototypeOf(Wrapper, t);
    }, _wrapNativeSuper(t);
}
var Position = function() {
    function Position(x, y, z) {
        if (!isNil(x) && !isNil(y)) {
            this.x = +x;
            this.y = +y;
            this.z = z;
        } else if (!isNil(x.x) && !isNil(x.y)) {
            this.x = +x.x;
            this.y = +x.y;
            this.z = x.z;
        } else if (Array.isArray(x)) {
            this.x = +x[0];
            this.y = +x[1];
            this.z = x[2];
        }
        if (this._isNaN()) throw new Error('Position is NaN');
    }
    var _proto = Position.prototype;
    _proto.set = function set(x, y, z) {
        this.x = x;
        this.y = y;
        this.z = z || 0;
        return this;
    };
    _proto._abs = function _abs() {
        this.x = Math.abs(this.x);
        this.y = Math.abs(this.y);
        return this;
    };
    _proto._round = function _round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        return this;
    };
    _proto._ceil = function _ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        return this;
    };
    _proto.distanceTo = function distanceTo(point) {
        var x = point.x - this.x, y = point.y - this.y;
        return Math.sqrt(x * x + y * y);
    };
    _proto.mag = function mag() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    };
    _proto._floor = function _floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        return this;
    };
    _proto._add = function _add(x, y) {
        if (!isNil(x.x)) {
            this.x += x.x;
            this.y += x.y;
        } else if (!isNil(x[0])) {
            this.x += x[0];
            this.y += x[1];
        } else {
            this.x += x;
            this.y += y;
        }
        return this;
    };
    _proto._sub = function _sub(x, y) {
        if (!isNil(x.x)) {
            this.x -= x.x;
            this.y -= x.y;
        } else if (!isNil(x[0])) {
            this.x -= x[0];
            this.y -= x[1];
        } else {
            this.x -= x;
            this.y -= y;
        }
        return this;
    };
    _proto._substract = function _substract(x, y) {
        if (isNumber(y)) return this._sub(x, y);
        return this._sub(x);
    };
    _proto.substract = function substract(x, y) {
        return this.sub(x, y);
    };
    _proto._multi = function _multi(ratio) {
        this.x *= ratio;
        this.y *= ratio;
        return this;
    };
    _proto.div = function div(n) {
        return this.multi(1 / n);
    };
    _proto._div = function _div(n) {
        return this._multi(1 / n);
    };
    _proto._isNaN = function _isNaN() {
        return isNaN(this.x) || isNaN(this.y) || isNumber(this.z) && isNaN(this.z);
    };
    _proto.isZero = function isZero() {
        return this.x === 0 && this.y === 0;
    };
    _proto.toArray = function toArray() {
        if (isNumber(this.z)) return [
            this.x,
            this.y,
            this.z
        ];
        return [
            this.x,
            this.y
        ];
    };
    _proto.toJSON = function toJSON() {
        var json = {
            x: this.x,
            y: this.y
        };
        if (isNumber(this.z)) json.z = this.z;
        return json;
    };
    return Position;
}();
var Point = function(_Position) {
    function Point() {
        return _Position.apply(this, arguments) || this;
    }
    _inheritsLoose(Point, _Position);
    var _proto = Point.prototype;
    _proto.closeTo = function closeTo(p, delta) {
        if (!delta) delta = 0;
        return this.x >= p.x - delta && this.x <= p.x + delta && this.y >= p.y - delta && this.y <= p.y + delta;
    };
    _proto.unit = function unit() {
        return this.copy()._unit();
    };
    _proto._unit = function _unit() {
        this._div(this.mag());
        return this;
    };
    _proto.perp = function perp() {
        return this.copy()._perp();
    };
    _proto._perp = function _perp() {
        [this.x, this.y] = [
            -this.y,
            this.x
        ];
        return this;
    };
    _proto.angleWith = function angleWith(b) {
        return this.angleWithSep(b.x, b.y);
    };
    _proto.angleWithSep = function angleWithSep(x, y) {
        return Math.atan2(this.x * y - this.y * x, this.x * x + this.y * y);
    };
    _proto._rotate = function _rotate(angle) {
        var cos = Math.cos(angle), sin = Math.sin(angle), x = cos * this.x - sin * this.y, y = sin * this.x + cos * this.y;
        this.x = x;
        this.y = y;
        return this;
    };
    _proto.rotate = function rotate(a) {
        return this.copy()._rotate(a);
    };
    _proto.abs = function abs() {
        return new Point(Math.abs(this.x), Math.abs(this.y));
    };
    _proto.round = function round() {
        return new Point(Math.round(this.x), Math.round(this.y));
    };
    _proto.ceil = function ceil() {
        return new Point(Math.ceil(this.x), Math.ceil(this.y));
    };
    _proto.floor = function floor() {
        return new Point(Math.floor(this.x), Math.floor(this.y));
    };
    _proto.copy = function copy() {
        return new Point(this.x, this.y, this.z);
    };
    _proto.toFixed = function toFixed(n) {
        return new Point(this.x.toFixed(n), this.y.toFixed(n), isNumber(this.z) ? this.z.toFixed(n) : undefined);
    };
    _proto.add = function add(x, y) {
        var nx, ny;
        if (!isNil(x.x)) {
            nx = this.x + x.x;
            ny = this.y + x.y;
        } else if (!isNil(x[0])) {
            nx = this.x + x[0];
            ny = this.y + x[1];
        } else {
            nx = this.x + x;
            ny = this.y + y;
        }
        return new Point(nx, ny);
    };
    _proto.sub = function sub(x, y) {
        var nx, ny;
        if (!isNil(x.x)) {
            nx = this.x - x.x;
            ny = this.y - x.y;
        } else if (!isNil(x[0])) {
            nx = this.x - x[0];
            ny = this.y - x[1];
        } else {
            nx = this.x - x;
            ny = this.y - y;
        }
        return new Point(nx, ny);
    };
    _proto.multi = function multi(ratio) {
        return new Point(this.x * ratio, this.y * ratio);
    };
    _proto.equals = function equals(c) {
        if (!(c instanceof this.constructor)) return false;
        return this.x === c.x && this.y === c.y && this.z === c.z;
    };
    return Point;
}(Position);
var requestAnimFrame, cancelAnimFrame;
(function() {
    if (IS_NODE) {
        requestAnimFrame = function requestAnimFrame(fn) {
            return setTimeout(fn, 16);
        };
        cancelAnimFrame = clearTimeout;
        return;
    }
    requestAnimFrame = function requestAnimFrame(callback) {
        return requestAnimationFrame(callback);
    };
    cancelAnimFrame = function cancelAnimFrame(handle) {
        return cancelAnimationFrame(handle);
    };
})();
function isSVG(url) {
    var prefix = 'data:image/svg+xml';
    if (url.length > 4 && url.slice(-4) === '.svg') return 1;
    else if (url.slice(0, prefix.length) === prefix) return 2;
    return 0;
}
function loadImage(img, imgDesc) {
    if (IS_NODE && loadImage.node) {
        loadImage.node(img, imgDesc);
        return;
    }
    img.src = imgDesc[0];
}
var uid = 0;
function UID() {
    return uid++;
}
var GUID = UID;
function parseJSON(str) {
    if (!str || !isString(str)) return str;
    return JSON.parse(str);
}
function pushIn(...args) {
    var dest = args[0];
    for(var i = 1; i < args.length; i++){
        var src = args[i];
        if (src && src.length) for(var ii = 0, ll = src.length; ii < ll; ii++)dest.push(src[ii]);
    }
    return dest.length;
}
function mergeArray(...args) {
    var dest = [];
    var idx = -1;
    for(var i = 0; i < args.length; i++){
        var src = args[i];
        if (src && src.length) for(var ii = 0, ll = src.length; ii < ll; ii++)dest[++idx] = src[ii];
    }
    return dest;
}
function removeFromArray(obj, array) {
    var i = array.indexOf(obj);
    if (i > -1) array.splice(i, 1);
}
function forEachCoord(arr, fn, context) {
    if (!Array.isArray(arr)) return context ? fn.call(context, arr) : fn(arr);
    var result = [];
    var p, pp;
    for(var i = 0, len = arr.length; i < len; i++){
        p = arr[i];
        if (isNil(p)) {
            result.push(null);
            continue;
        }
        if (Array.isArray(p)) result.push(forEachCoord(p, fn, context));
        else {
            pp = context ? fn.call(context, p) : fn(p);
            result.push(pp);
        }
    }
    return result;
}
function getValueOrDefault(v, d) {
    return v === undefined ? d : v;
}
function sign(x) {
    if (Math.sign) return Math.sign(x);
    x = +x;
    if (x === 0 || isNaN(x)) return Number(x);
    return x > 0 ? 1 : -1;
}
function log2(x) {
    if (Math.log2) return Math.log2(x);
    var v = Math.log(x) * Math.LOG2E;
    var rounded = Math.round(v);
    if (Math.abs(rounded - v) < 1E-14) return rounded;
    else return v;
}
function interpolate$3(a, b, t) {
    return a * (1 - t) + b * t;
}
function wrap(n, min, max) {
    if (n === max || n === min) return n;
    var d = max - min;
    var w = ((n - min) % d + d) % d + min;
    return w;
}
function clamp(n, min, max) {
    return Math.min(max, Math.max(min, n));
}
function isArrayHasData(obj) {
    return Array.isArray(obj) && obj.length > 0;
}
var urlPattern = /^([a-z][a-z\d+\-.]*:)?\/\//i;
function isURL(url) {
    return urlPattern.test(url);
}
var cssUrlReWithQuote = /^url\((['"])(.+)\1\)$/i;
var cssUrlRe = /^url\(([^'"].*[^'"])\)$/i;
function isCssUrl(str) {
    if (!isString(str)) return 0;
    if (cssUrlRe.test(str)) return 1;
    if (cssUrlReWithQuote.test(str)) return 2;
    return 3;
}
function extractCssUrl(str) {
    var test = isCssUrl(str);
    var matches;
    if (test === 3) return str;
    else if (test === 1) {
        matches = cssUrlRe.exec(str);
        return matches[1];
    } else if (test === 2) {
        matches = cssUrlReWithQuote.exec(str);
        return matches[2];
    } else return str;
}
var b64chrs = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
function btoa(input) {
    if (Browser$1.btoa) return window.btoa(input);
    var str = String(input);
    var output = '';
    for(var block, charCode, idx = 0, map = b64chrs; str.charAt(idx | 0) || (map = '=', idx % 1); output += map.charAt(63 & block >> 8 - idx % 1 * 8)){
        charCode = str.charCodeAt(idx += 3 / 4);
        if (charCode > 0xFF) throw new Error('\'btoa\' failed: The string to be encoded contains characters outside of the Latin1 range.');
        block = block << 8 | charCode;
    }
    return output;
}
function b64toBlob(b64Data, contentType) {
    var byteCharacters = atob(b64Data);
    var arraybuffer = new ArrayBuffer(byteCharacters.length);
    var view = new Uint8Array(arraybuffer);
    for(var i = 0; i < byteCharacters.length; i++)view[i] = byteCharacters.charCodeAt(i) & 0xff;
    var blob = new Blob([
        arraybuffer
    ], {
        type: contentType
    });
    return blob;
}
function computeDegree(x0, y0, x1, y1) {
    var dx = x1 - x0;
    var dy = y1 - y0;
    return Math.atan2(dy, dx);
}
var emptyImageUrl = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
function equalMapView(obj1, obj2) {
    if (!obj1 && !obj2) return true;
    else if (!obj1 || !obj2) return false;
    for(var p in obj1){
        if (p === 'center') {
            if (!obj2[p] || !approx(obj1[p][0], obj2[p][0]) || !approx(obj1[p][1], obj2[p][1])) return false;
        } else if (obj1[p] !== obj2[p]) return false;
    }
    return true;
}
function approx(val, expected, delta) {
    if (delta == null) delta = 1e-6;
    return val >= expected - delta && val <= expected + delta;
}
function flash(interval = 100, count = 4, cb = null, context = null) {
    if (!interval) interval = 100;
    if (!count) count = 4;
    var me = this;
    var initVisible = this.isVisible();
    count *= 2;
    if (this._flashTimeout) clearTimeout(this._flashTimeout);
    function flashGeo() {
        if (count === 0) {
            if (initVisible) me.show();
            else me.hide();
            if (cb) {
                if (context) cb.call(context);
                else cb();
            }
            return;
        }
        if (count % 2 === 0) me.hide();
        else me.show();
        count--;
        me._flashTimeout = setTimeout(flashGeo, interval);
    }
    this._flashTimeout = setTimeout(flashGeo, interval);
    return this;
}
function _defaults(obj, defaults) {
    var keys = Object.getOwnPropertyNames(defaults);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var value = Object.getOwnPropertyDescriptor(defaults, key);
        if (value && value.configurable && obj[key] === undefined) Object.defineProperty(obj, key, value);
    }
    return obj;
}
function getPointsResultPts(points = [], ptKey = '_pt') {
    var resultPoints = [];
    for(var i = 0, len = points.length; i < len; i++){
        var point = points[i];
        if (!point) {
            resultPoints.push(null);
            continue;
        }
        if (!point[ptKey]) point[ptKey] = new Point(0, 0);
        var pt = point[ptKey];
        pt.x = 0;
        pt.y = 0;
        resultPoints.push(pt);
    }
    return resultPoints;
}
function getImageBitMap(data, cb) {
    cb(data.data);
}
function getAbsoluteURL(url) {
    if (url && url.indexOf('http://') === 0 || url.indexOf('https://') === 0) return url;
    var a = document.createElement('a');
    a.href = url;
    url = a.href;
    a = null;
    return url;
}
var CANVAS_SIZE_TEMP = {
    cssWidth: '1px',
    cssHeight: '1px',
    width: 1,
    height: 1
};
function calCanvasSize(size, devicePixelRatio = 1) {
    var { width: width, height: height } = size;
    CANVAS_SIZE_TEMP.cssWidth = width + 'px';
    CANVAS_SIZE_TEMP.cssHeight = height + 'px';
    CANVAS_SIZE_TEMP.width = Math.round(width * devicePixelRatio);
    CANVAS_SIZE_TEMP.height = Math.round(height * devicePixelRatio);
    return CANVAS_SIZE_TEMP;
}
function isNoContentHttpCode(code) {
    return code === 204 || code >= 400 && code < 500 || code === 501;
}
var INTERNAL_LAYER_PREFIX = '_maptalks__internal_layer_';
var GEOMETRY_COLLECTION_TYPES = [
    'MultiPoint',
    'MultiLineString',
    'MultiPolygon',
    'GeometryCollection'
];
var GEOJSON_TYPES = [
    'FeatureCollection',
    'Feature',
    'Point',
    'LineString',
    'Polygon'
].concat(GEOMETRY_COLLECTION_TYPES);
var RESOURCE_PROPERTIES = [
    'markerFile',
    'polygonPatternFile',
    'linePatternFile',
    'markerFillPatternFile',
    'markerLinePatternFile'
];
var RESOURCE_SIZE_PROPERTIES = [
    [
        'markerWidth',
        'markerHeight'
    ],
    [],
    [
        null,
        'lineWidth'
    ],
    [],
    [
        null,
        'markerLineWidth'
    ]
];
var NUMERICAL_PROPERTIES = {
    'lineWidth': 1,
    'lineOpacity': 1,
    'lineDx': 1,
    'lineDy': 1,
    'polygonOpacity': 1,
    'markerWidth': 1,
    'markerHeight': 1,
    'markerDx': 1,
    'markerDy': 1,
    'markerOpacity': 1,
    'markerFillOpacity': 1,
    'markerLineWidth': 1,
    'markerLineOpacity': 1,
    'textSize': 1,
    'textOpacity': 1,
    'textHaloRadius': 1,
    'textWrapWidth': 1,
    'textLineSpacing': 1,
    'textDx': 1,
    'textDy': 1
};
var COLOR_PROPERTIES = [
    'lineColor',
    'polygonFill',
    'markerFill',
    'markerLineColor',
    'textFill'
];
var DEFAULT_TEXT_SIZE = 14;
var Size = function() {
    function Size(width, height) {
        if (isNumber(width) && isNumber(height)) {
            this.width = width;
            this.height = height;
        } else if (isNumber(width['width'])) {
            this.width = width.width;
            this.height = width.height;
        } else if (Array.isArray(width)) {
            this.width = width[0];
            this.height = width[1];
        }
    }
    var _proto = Size.prototype;
    _proto.copy = function copy() {
        return new Size(this['width'], this['height']);
    };
    _proto.add = function add(x, y) {
        var w, h;
        if (x instanceof Size) {
            w = this.width + x.width;
            h = this.height + x.height;
        } else {
            w = this.width + x;
            h = this.height + y;
        }
        return new Size(w, h);
    };
    _proto.equals = function equals(size) {
        return this['width'] === size['width'] && this['height'] === size['height'];
    };
    _proto.multi = function multi(ratio) {
        return new Size(this['width'] * ratio, this['height'] * ratio);
    };
    _proto._multi = function _multi(ratio) {
        this['width'] *= ratio;
        this['height'] *= ratio;
        return this;
    };
    _proto._round = function _round() {
        this['width'] = Math.round(this['width']);
        this['height'] = Math.round(this['height']);
        return this;
    };
    _proto.toPoint = function toPoint() {
        return new Point(this['width'], this['height']);
    };
    _proto.toArray = function toArray() {
        return [
            this['width'],
            this['height']
        ];
    };
    _proto.toJSON = function toJSON() {
        return {
            'width': this['width'],
            'height': this['height']
        };
    };
    return Size;
}();
var EMPTY_STRING$1 = '';
function trim(str) {
    return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}
function replaceAll(str, key, value) {
    if (!str) return str;
    while(str.indexOf(key) > -1)str = str.replace(key, value);
    return str;
}
var specialPattern = /[\b\t\r\v\f]/igm;
function escapeSpecialChars(str) {
    if (!isString(str)) return str;
    return str.replace(specialPattern, EMPTY_STRING$1);
}
function splitWords(chr) {
    return trim(chr).split(/\s+/);
}
var rulerCtx = typeof document !== 'undefined' ? document.createElement('canvas').getContext('2d') : null;
function stringWidth(text, font) {
    if (stringWidth.node) return stringWidth.node(text, font);
    rulerCtx.font = font;
    return rulerCtx.measureText(text).width;
}
function stringLength(text, font, size) {
    var w = stringWidth(text, font);
    return new Size(w, size || DEFAULT_TEXT_SIZE);
}
function splitContent(content, font, wrapWidth, textWidth) {
    if (!content || content.length === 0) return [
        {
            'text': '',
            'width': 0
        }
    ];
    var width = isNil(textWidth) ? stringWidth(content, font) : textWidth;
    var chrWidth = width / content.length, minChrCount = Math.floor(wrapWidth / chrWidth / 2);
    if (chrWidth >= wrapWidth || minChrCount <= 0) return [
        {
            'text': '',
            'width': wrapWidth
        }
    ];
    if (width <= wrapWidth) return [
        {
            'text': content,
            'width': width
        }
    ];
    var result = [];
    var testStr = content.substring(0, minChrCount), prew = chrWidth * minChrCount;
    for(var i = minChrCount, l = content.length; i < l; i++){
        var chr = content[i];
        var w = stringWidth(testStr + chr);
        if (w >= wrapWidth) {
            result.push({
                'text': testStr,
                'width': prew
            });
            testStr = content.substring(i, minChrCount + i);
            i += minChrCount - 1;
            prew = chrWidth * minChrCount;
        } else {
            testStr += chr;
            prew = w;
        }
        if (i >= l - 1) {
            prew = stringWidth(testStr);
            result.push({
                'text': testStr,
                'width': prew
            });
        }
    }
    return result;
}
var TEMPLATE_CHARS = [
    '{',
    '}'
];
function replaceVariable(str, props) {
    if (!isString(str)) return str;
    var [left, right] = TEMPLATE_CHARS;
    if (str.indexOf(left) === -1 && str.indexOf(right) === -1) return str;
    function getValue(key) {
        if (!props) return EMPTY_STRING$1;
        var value = props[key];
        if (isNil(value)) return EMPTY_STRING$1;
        else if (Array.isArray(value)) return value.join();
        return value;
    }
    var keys = templateKeys(str);
    for(var i = 0, len = keys.length; i < len; i++){
        var key = keys[i];
        var value = getValue(key);
        str = replaceAll(str, "" + left + key + right, value);
    }
    return str;
}
function templateKeys(str) {
    str += EMPTY_STRING$1;
    var [left, right] = TEMPLATE_CHARS;
    var keys = [];
    var start = false;
    var key = EMPTY_STRING$1;
    for(var i = 0, len = str.length; i < len; i++){
        var _char = str[i];
        if (!start && _char === left) start = true;
        if (_char === left && start) key = EMPTY_STRING$1;
        if (start && _char !== left && _char !== right) key += _char;
        if (_char === right && key) {
            start = false;
            keys.push(key);
            key = EMPTY_STRING$1;
        }
    }
    return keys;
}
function describeText(textContent, symbol) {
    if (isNumber(textContent)) textContent += '';
    textContent = textContent || '';
    var maxHeight = symbol['textMaxHeight'] || 0;
    var textDesc = splitTextToRow(textContent, symbol);
    if (maxHeight && maxHeight < textDesc.size.height) textDesc.size.height = maxHeight;
    return textDesc;
}
function getAlignPoint(size, horizontalAlignment, verticalAlignment) {
    var width = size['width'], height = size['height'];
    var alignW, alignH;
    if (horizontalAlignment === 'left') alignW = -width;
    else if (horizontalAlignment === 'right') alignW = 0;
    else alignW = -width / 2;
    if (verticalAlignment === 'top') alignH = -height;
    else if (verticalAlignment === 'bottom') alignH = 0;
    else alignH = -height / 2;
    return new Point(alignW, alignH);
}
var DEFAULT_FONT = 'sans-serif';
var DEFAULT_TEXTSIZE = 14;
function getFont(style) {
    if (style['textFont']) return style['textFont'];
    else {
        var textSize = style.textSize;
        if (isNil(textSize)) textSize = DEFAULT_TEXTSIZE;
        return (style['textStyle'] && style['textStyle'] !== 'normal' ? style['textStyle'] + ' ' : '') + (style['textWeight'] && style['textWeight'] !== 'normal' ? style['textWeight'] + ' ' : '') + textSize + 'px ' + (style['textFaceName'] && formatFontFamily(style['textFaceName']) || DEFAULT_FONT);
    }
}
function formatFontFamily(font) {
    var fonts = font.split(',');
    for(var i = 0; i < fonts.length; i++){
        if (fonts[i].trim) fonts[i] = fonts[i].trim();
        if (fonts[i].indexOf(' ') > 0 && fonts[i][0] !== '"' && fonts[i][0] !== '\'') fonts[i] = '"' + fonts[i] + '"';
    }
    return fonts.join(',');
}
function splitTextToRow(text, style) {
    var font = getFont(style), lineSpacing = style['textLineSpacing'] || 0, size = stringLength(text, font, style['textSize']), textWidth = size['width'], textHeight = size['height'], wrapChar = style['textWrapCharacter'] || '\n', textRows = [];
    var wrapWidth = style['textWrapWidth'];
    if (!wrapWidth || wrapWidth > textWidth) wrapWidth = textWidth;
    if (!isString(text)) text += '';
    var actualWidth = 0;
    if (wrapChar && text.indexOf(wrapChar) >= 0) {
        var texts = text.split(wrapChar);
        for(var i = 0, l = texts.length; i < l; i++){
            var t = texts[i];
            var tWidth = stringWidth(t, font);
            if (tWidth > wrapWidth) {
                var contents = splitContent(t, font, wrapWidth, tWidth);
                for(var ii = 0, ll = contents.length; ii < ll; ii++){
                    var w = contents[ii].width;
                    if (w > actualWidth) actualWidth = w;
                    textRows.push({
                        'text': contents[ii].text,
                        'size': new Size(w, textHeight)
                    });
                }
            } else {
                if (tWidth > actualWidth) actualWidth = tWidth;
                textRows.push({
                    'text': t,
                    'size': new Size(tWidth, textHeight)
                });
            }
        }
    } else if (textWidth > wrapWidth) {
        var _contents = splitContent(text, font, wrapWidth, textWidth);
        for(var _i = 0; _i < _contents.length; _i++){
            var _w = _contents[_i].width;
            if (_w > actualWidth) actualWidth = _w;
            textRows.push({
                'text': _contents[_i].text,
                'size': new Size(_w, textHeight)
            });
        }
    } else {
        if (textWidth > actualWidth) actualWidth = textWidth;
        textRows.push({
            'text': text,
            'size': size
        });
    }
    var rowNum = textRows.length;
    var textSize = new Size(actualWidth, textHeight * rowNum + lineSpacing * (rowNum - 1));
    return {
        'total': rowNum,
        'size': textSize,
        'rows': textRows,
        'rawSize': size
    };
}
function hashCode(s) {
    var hash = 0;
    var strlen = s && s.length || 0;
    if (!strlen) return hash;
    var c;
    for(var i = 0; i < strlen; i++){
        c = s.charCodeAt(i);
        hash = (hash << 5) - hash + c;
        hash = hash & hash;
    }
    return hash;
}
var strings = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    DEFAULT_FONT: DEFAULT_FONT,
    DEFAULT_TEXTSIZE: DEFAULT_TEXTSIZE,
    EMPTY_STRING: EMPTY_STRING$1,
    describeText: describeText,
    escapeSpecialChars: escapeSpecialChars,
    getAlignPoint: getAlignPoint,
    getFont: getFont,
    hashCode: hashCode,
    replaceAll: replaceAll,
    replaceVariable: replaceVariable,
    splitContent: splitContent,
    splitTextToRow: splitTextToRow,
    splitWords: splitWords,
    stringLength: stringLength,
    stringWidth: stringWidth,
    trim: trim
});
var first = function first(props) {
    return props[0];
};
var testProp = IS_NODE ? first : function(props) {
    var style = document.documentElement && document.documentElement.style || {};
    for(var i = 0; i < props.length; i++){
        if (props[i] in style) return props[i];
    }
    return false;
};
var TRANSFORM = testProp([
    'transform',
    'WebkitTransform',
    'OTransform',
    'MozTransform',
    'msTransform'
]);
var TRANSFORMORIGIN = testProp([
    'transformOrigin',
    'WebkitTransformOrigin',
    'OTransformOrigin',
    'MozTransformOrigin',
    'msTransformOrigin'
]);
var TRANSITION = testProp([
    'transition',
    'WebkitTransition',
    'OTransition',
    'MozTransition',
    'msTransition'
]);
var CSSFILTER = testProp([
    'filter',
    'WebkitFilter',
    'OFilter',
    'MozFilter',
    'msFilter'
]);
function createEl(tagName, className) {
    var el = document.createElement(tagName);
    if (className) setClass(el, className);
    return el;
}
function createElOn(tagName, style, container) {
    var el = createEl(tagName);
    if (style) setStyle(el, style);
    if (container) container.appendChild(el);
    return el;
}
function removeDomNode(node) {
    if (!node) return this;
    if (Browser$1.ielt9 || Browser$1.ie9) {
        var d = createEl('div');
        d.appendChild(node);
        d.innerHTML = '';
        d = null;
    } else if (node.parentNode) node.parentNode.removeChild(node);
    return this;
}
function addDomEvent(obj, typeArr, handler, context) {
    if (!obj || !obj.addEventListener || !typeArr || !handler) return this;
    var eventHandler = function eventHandler(e) {
        if (!e) e = window.event;
        handler.call(context || obj, e);
        return;
    };
    var types = typeArr.split(' ');
    for(var i = types.length - 1; i >= 0; i--){
        var type = types[i];
        if (!type) continue;
        if (!obj['Z__' + type]) obj['Z__' + type] = [];
        var hit = listensDomEvent(obj, type, handler);
        if (hit >= 0) {
            console.warn(obj, "find '" + type + "' handler:", handler, ' The old listener function will be removed');
            removeDomEvent(obj, type, handler);
        }
        obj['Z__' + type].push({
            callback: eventHandler,
            src: handler
        });
        obj.addEventListener(type, eventHandler, Browser$1.supportsPassive ? {
            capture: false,
            passive: false
        } : false);
    }
    return this;
}
function removeDomEvent(obj, typeArr, handler) {
    function doRemove(type, callback) {
        if (type === 'mousewheel' && Browser$1.gecko) type = 'DOMMouseScroll';
        obj.removeEventListener(type, callback, false);
    }
    if (!obj || !obj.removeEventListener || !typeArr) return this;
    var types = typeArr.split(' ');
    for(var i = types.length - 1; i >= 0; i--){
        var type = types[i];
        if (!type) continue;
        if (!handler && obj['Z__' + type]) {
            var handlers = obj['Z__' + type];
            for(var j = 0, jlen = handlers.length; j < jlen; j++)doRemove(handlers[j].callback);
            delete obj['Z__' + type];
            return this;
        }
        var hit = listensDomEvent(obj, type, handler);
        if (hit < 0) return this;
        var hitHandler = obj['Z__' + type][hit];
        doRemove(type, hitHandler.callback);
        obj['Z__' + type].splice(hit, 1);
    }
    return this;
}
function listensDomEvent(obj, type, handler) {
    if (!obj || !obj['Z__' + type] || !handler) return -1;
    var handlers = obj['Z__' + type];
    for(var i = 0, len = handlers.length; i < len; i++){
        if (handlers[i].src === handler) return i;
    }
    return -1;
}
function preventDefault(event) {
    if (event.preventDefault) event.preventDefault();
    else event.returnValue = false;
    return this;
}
function stopPropagation(e) {
    e._cancelBubble = true;
    if (e.stopPropagation) e.stopPropagation();
    else e.cancelBubble = true;
    return this;
}
function preventSelection(dom) {
    dom.onselectstart = function() {
        return false;
    };
    dom.ondragstart = function() {
        return false;
    };
    dom.setAttribute('unselectable', 'on');
    return this;
}
function offsetDom(dom, offset) {
    if (!dom) return null;
    if (Browser$1.any3d) setTransform(dom, offset);
    else {
        dom.style.left = offset.x + 'px';
        dom.style.top = offset.y + 'px';
    }
    return offset;
}
function computeDomPosition(dom) {
    var style = window.getComputedStyle(dom);
    var padding = [
        parseInt(style['padding-left']),
        parseInt(style['padding-top'])
    ];
    var rect = dom.getBoundingClientRect();
    var offsetWidth = dom.offsetWidth, offsetHeight = dom.offsetHeight;
    var scaleX = offsetWidth ? rect.width / offsetWidth : 1, scaleY = offsetHeight ? rect.height / offsetHeight : 1;
    dom.__position = [
        rect.left + padding[0],
        rect.top + padding[1],
        scaleX,
        scaleY
    ];
    return dom.__position;
}
function getEventContainerPoint(ev, dom) {
    if (!ev) ev = window.event;
    var domPos = dom.__position;
    if (!domPos) domPos = computeDomPosition(dom);
    var toucheEvent = ev;
    if (toucheEvent.touches && toucheEvent.touches.length) ev = toucheEvent.touches[0];
    if (toucheEvent.changedTouches && toucheEvent.changedTouches.length) ev = toucheEvent.changedTouches[0];
    ev;
    return new Point((ev.clientX - domPos[0] - dom.clientLeft) / domPos[2], (ev.clientY - domPos[1] - dom.clientTop) / domPos[3]);
}
function endsWith(str, suffix) {
    var l = str.length - suffix.length;
    return l >= 0 && str.indexOf(suffix, l) === l;
}
function setStyle(dom, strCss) {
    var cssText = dom.style.cssText;
    if (!endsWith(cssText, ';')) cssText += ';';
    dom.style.cssText = cssText + strCss;
    return this;
}
function hasClass(el, name) {
    if (el.classList !== undefined) return el.classList.contains(name);
    var className = getClass(el);
    return className.length > 0 && new RegExp('(^|\\s)' + name + '(\\s|$)').test(className);
}
function addClass(el, name) {
    if (el.classList !== undefined && !hasClass(el, name)) {
        var classes = splitWords(name);
        for(var i = 0, len = classes.length; i < len; i++)el.classList.add(classes[i]);
    } else {
        var className = getClass(el);
        setClass(el, (className ? className + ' ' : '') + name);
    }
    return this;
}
function setClass(el, name) {
    if (isNil(el.className.baseVal)) el.className = name;
    else el.className.baseVal = name;
    return this;
}
function getClass(el) {
    return isNil(el.className.baseVal) ? el.className : el.className.baseVal;
}
function setOpacity(el, value) {
    el.style.opacity = value;
    return this;
}
function setTransform(el, offset) {
    var pos = offset || new Point(0, 0);
    el.style[TRANSFORM] = Browser$1.any3d ? 'translate3d(' + pos.x + 'px,' + pos.y + 'px,0px)' : 'translate(' + pos.x + 'px,' + pos.y + 'px)';
    return this;
}
function setTransformMatrix(el, m) {
    var text = 'matrix(' + (isString(m) ? m : m.join()) + ')';
    if (el.style[TRANSFORM] !== text) el.style[TRANSFORM] = text;
    return this;
}
function removeTransform(el) {
    if (el.style[TRANSFORM]) el.style[TRANSFORM] = '';
    return this;
}
function isHTML(str) {
    return /<[a-z\][\s\S]*>/i.test(str);
}
function measureDom(parentTag, dom) {
    var ruler = getDomRuler(parentTag);
    if (isString(dom)) ruler.innerHTML = dom;
    else ruler.appendChild(dom);
    var result = new Size(ruler.clientWidth, ruler.clientHeight);
    removeDomNode(ruler);
    return result;
}
function getDomRuler(tag) {
    var span = document.createElement(tag);
    span.style.cssText = 'position:absolute;left:-10000px;top:-10000px;';
    document.body.appendChild(span);
    return span;
}
var on = addDomEvent;
var off = removeDomEvent;
function isMoveEvent(type) {
    return type && (type === 'mousemove' || type === 'touchmove');
}
var MOUSEMOVE_THROTTLE_TIME = 48;
function isMousemoveEventBlocked(target, mousemoveThrottleTime) {
    var currentTime = now();
    var TIME = mousemoveThrottleTime || MOUSEMOVE_THROTTLE_TIME;
    if (target._mousemoveTime && currentTime - target._mousemoveTime < TIME) return true;
    target._mousemoveTime = currentTime;
    return false;
}
var dom = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    CSSFILTER: CSSFILTER,
    MOUSEMOVE_THROTTLE_TIME: MOUSEMOVE_THROTTLE_TIME,
    TRANSFORM: TRANSFORM,
    TRANSFORMORIGIN: TRANSFORMORIGIN,
    TRANSITION: TRANSITION,
    addClass: addClass,
    addDomEvent: addDomEvent,
    computeDomPosition: computeDomPosition,
    createEl: createEl,
    createElOn: createElOn,
    getClass: getClass,
    getDomRuler: getDomRuler,
    getEventContainerPoint: getEventContainerPoint,
    hasClass: hasClass,
    isHTML: isHTML,
    isMousemoveEventBlocked: isMousemoveEventBlocked,
    isMoveEvent: isMoveEvent,
    listensDomEvent: listensDomEvent,
    measureDom: measureDom,
    off: off,
    offsetDom: offsetDom,
    on: on,
    preventDefault: preventDefault,
    preventSelection: preventSelection,
    removeDomEvent: removeDomEvent,
    removeDomNode: removeDomNode,
    removeTransform: removeTransform,
    setClass: setClass,
    setOpacity: setOpacity,
    setStyle: setStyle,
    setTransform: setTransform,
    setTransformMatrix: setTransformMatrix,
    stopPropagation: stopPropagation
});
var Ajax = {
    jsonp: function jsonp(url, callback) {
        var name = '_maptalks_jsonp_' + UID();
        if (url.match(/\?/)) url += '&callback=' + name;
        else url += '?callback=' + name;
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = url;
        window[name] = function(data) {
            callback(null, data);
            document.getElementsByTagName('head')[0].removeChild(script);
            script = null;
            delete window[name];
        };
        document.getElementsByTagName('head')[0].appendChild(script);
        return this;
    },
    get: function get(url, options, cb) {
        if (isFunction(options)) {
            var t = cb;
            cb = options;
            options = t;
        }
        if (IS_NODE && Ajax.get.node) return Ajax.get.node(url, cb, options);
        var client = Ajax._getClient(cb);
        client.open('GET', url, true);
        if (options) {
            for(var k in options.headers)client.setRequestHeader(k, options.headers[k]);
            client.withCredentials = options.credentials === 'include';
            if (options['responseType']) client.responseType = options['responseType'];
        }
        client.send(null);
        return client;
    },
    post: function post(url, options, cb) {
        var postData;
        if (!isString(url)) {
            var t = cb;
            postData = options;
            options = url;
            url = options.url;
            cb = t;
        } else {
            if (isFunction(options)) {
                var _t = cb;
                cb = options;
                options = _t;
            }
            options = options || {};
            postData = options.postData;
        }
        if (IS_NODE && Ajax.post.node) {
            options.url = url;
            return Ajax.post.node(options, postData, cb);
        }
        var client = Ajax._getClient(cb);
        client.open('POST', options.url, true);
        if (!options.headers) options.headers = {};
        if (!options.headers['Content-Type']) options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
        if ('setRequestHeader' in client) {
            for(var p in options.headers)if (options.headers.hasOwnProperty(p)) client.setRequestHeader(p, options.headers[p]);
        }
        if (!isString(postData)) postData = JSON.stringify(postData);
        client.send(postData);
        return client;
    },
    _wrapCallback: function _wrapCallback(client, cb) {
        return function() {
            if (client.readyState === 4) {
                if (client.status === 200) {
                    if (client.responseType === 'arraybuffer') {
                        var response = client.response;
                        if (response.byteLength === 0) cb(new Error('http status 200 returned without content.'));
                        else cb(null, {
                            data: client.response,
                            cacheControl: client.getResponseHeader('Cache-Control'),
                            expires: client.getResponseHeader('Expires'),
                            contentType: client.getResponseHeader('Content-Type')
                        });
                    } else cb(null, client.responseText);
                } else cb(new Error(client.statusText + ',' + client.status));
            }
        };
    },
    _getClient: function _getClient(cb) {
        var client;
        try {
            client = new XMLHttpRequest();
        } catch (e) {
            try {
                client = new ActiveXObject('Msxml2.XMLHTTP');
            } catch (e) {
                try {
                    client = new ActiveXObject('Microsoft.XMLHTTP');
                } catch (e) {}
            }
        }
        client.onreadystatechange = Ajax._wrapCallback(client, cb);
        return client;
    },
    getArrayBuffer: function getArrayBuffer(url, options, cb) {
        if (isFunction(options)) {
            var t = cb;
            cb = options;
            options = t;
        }
        if (!options) options = {};
        options['responseType'] = 'arraybuffer';
        return Ajax.get(url, options, cb);
    },
    getImage: function getImage(img, url, options) {
        return Ajax.getArrayBuffer(url, options, function(err, imgData) {
            if (err) {
                if (img.onerror) img.onerror(err);
            } else if (imgData) {
                var URL1 = window.URL || window.webkitURL;
                var onload = img.onload;
                img.onload = function() {
                    if (onload) onload();
                    URL1.revokeObjectURL(img.src);
                };
                var blob = new Blob([
                    new Uint8Array(imgData.data)
                ], {
                    type: imgData.contentType
                });
                img.cacheControl = imgData.cacheControl;
                img.expires = imgData.expires;
                img.src = imgData.data.byteLength ? URL1.createObjectURL(blob) : emptyImageUrl;
            }
        });
    },
    getJSON: function getJSON(url, options, cb) {}
};
Ajax.getJSON = function(url, options, cb) {
    if (isFunction(options)) {
        var t = cb;
        cb = options;
        options = t;
    }
    var callback = function callback(err, resp) {
        var data = resp ? parseJSON(resp) : null;
        cb(err, data);
    };
    if (options && options['jsonp']) return Ajax.jsonp(url, callback);
    return Ajax.get(url, options, callback);
};
var EMPTY_STRING = '';
var BASE64_REG = /data:image\/.*;base64,/;
function createCanvas() {
    var canvas;
    if (Browser$1.IS_NODE) console.error('Current environment does not support canvas dom');
    else canvas = createEl('canvas');
    return canvas;
}
function createOffscreenCanvas() {
    var offscreenCanvas;
    if (Browser$1.decodeImageInWorker) offscreenCanvas = new OffscreenCanvas(2, 2);
    return offscreenCanvas;
}
function isBase64URL(path) {
    return BASE64_REG.test(path);
}
function isBlobURL(path) {
    return path.indexOf('blob:') === 0;
}
function strContains(str1, str2) {
    if (isNumber(str1)) str1 += EMPTY_STRING;
    if (isNumber(str2)) str2 += EMPTY_STRING;
    if (!str1 || !str2) return false;
    if (str1.includes) return str1.includes(str2);
    return str1.indexOf(str2) > -1;
}
function handlerURL(path, configs = {}) {
    for(var local in configs){
        var obj = configs[local];
        if (!obj || !obj.target) continue;
        if (strContains(path, local)) {
            var { target: target } = obj;
            return path.replace(local, target);
        }
    }
    return EMPTY_STRING;
}
function loadSprite(options = {
    imgUrl: '',
    jsonUrl: ''
}) {
    return new Promise(function(resolve, reject) {
        var { imgUrl: imgUrl, jsonUrl: jsonUrl } = options;
        if (!imgUrl || !jsonUrl) {
            reject(new Error('not find imgUrl/jsonUrl from options'));
            console.error(options);
            return;
        }
        function getCtx(canvas, width, height) {
            canvas.width = width;
            canvas.height = height;
            var ctx = canvas.getContext('2d');
            ctx.clearRect(0, 0, width, height);
            return ctx;
        }
        function parseSprite(json = {}, image) {
            var canvas = createCanvas();
            if (!canvas) {
                reject(new Error('can not create canvas'));
                return;
            }
            var icons = [];
            for(var name in json){
                var spriteItem = json[name];
                icons.push({
                    name: name,
                    spriteItem: spriteItem
                });
            }
            var offscreenCanvas = createOffscreenCanvas();
            var sourceName = options.sourceName || "";
            icons.forEach(function(icon) {
                var { name: name, spriteItem: spriteItem } = icon;
                var { x: x, y: y, width: width, height: height } = spriteItem;
                var resource;
                if (offscreenCanvas) {
                    var ctx = getCtx(offscreenCanvas, width, height);
                    ctx.drawImage(image, x, y, width, height, 0, 0, width, height);
                    resource = offscreenCanvas.transferToImageBitmap();
                } else {
                    var _ctx = getCtx(canvas, width, height);
                    _ctx.drawImage(image, x, y, width, height, 0, 0, width, height);
                    resource = canvas.toDataURL();
                }
                icon.resource = resource;
                ResourceProxy.addResource(sourceName + name, resource);
            });
            resolve(icons);
        }
        Ajax.getJSON(jsonUrl, {}, function(err, json) {
            if (err) {
                reject(err);
                return;
            }
            var img = new Image();
            img.onload = function() {
                parseSprite(json, img);
            };
            img.onerror = function(err) {
                reject(err);
                return;
            };
            Ajax.getImage(img, imgUrl, {});
        });
    });
}
function loadSvgs(svgs) {
    return new Promise(function(resolve, reject) {
        var url = '', symbols = [], fillColor = '', strokeColor = '', sourceName = '';
        if (Array.isArray(svgs) || svgs instanceof NodeList) symbols = svgs;
        else if (isObject$1(svgs)) {
            var opts = svgs;
            url = opts.url;
            symbols = opts.symbols;
            fillColor = opts.fill;
            strokeColor = opts.stroke;
            sourceName = opts.sourceName || '';
        } else if (isString(svgs)) url = svgs;
        if (!url && symbols && symbols.length === 0) {
            reject(new Error('not find svgs data'));
            return;
        }
        var result = [];
        var addToCache = function addToCache(name, body) {
            var paths = parseSVG(body);
            if (paths) {
                paths.forEach(function(path) {
                    if (fillColor) path.fill = fillColor;
                    if (strokeColor) path.stroke = strokeColor;
                });
                ResourceProxy.addResource(sourceName + name, paths);
            }
            var data = {
                name: name,
                paths: paths,
                body: body
            };
            result.push(data);
        };
        if (url && isString(url)) {
            fetch(url).then(function(res) {
                return res.json();
            }).then(function(json) {
                json.forEach(function(svg) {
                    var { name: name, body: body } = svg;
                    addToCache(name, body);
                });
                resolve(result);
            })["catch"](function(err) {
                console.log(err);
                reject(err);
            });
            return;
        }
        if (symbols) {
            for(var i = 0, len = symbols.length; i < len; i++){
                var symbolNode = symbols[i];
                var name = symbolNode.id;
                var html = symbolNode.innerHTML;
                var body = "<xml><svg>" + html + "</svg></xml>";
                if (name) addToCache(name, body);
            }
            resolve(result);
            return;
        }
        reject(new Error('not support svgs params type'));
    });
}
var ResourceProxy = {
    host: EMPTY_STRING,
    resources: {},
    proxy: {},
    origin: {},
    fromJSON: function fromJSON(json) {
        try {
            if (isString(json)) json = JSON.parse(json);
            if (isObject$1(json)) extend$2(ResourceProxy, json);
        } catch (error) {
            console.error(error);
        }
    },
    toJSON: function toJSON() {
        return {
            host: ResourceProxy.host,
            proxy: extend$2({}, ResourceProxy.proxy || {}),
            origin: extend$2({}, ResourceProxy.origin || {})
        };
    },
    getResource: function getResource(name) {
        return ResourceProxy.resources[name];
    },
    removeResource: function removeResource(name) {
        delete ResourceProxy.resources[name];
    },
    addResource: function addResource(name, res) {
        if (ResourceProxy.resources[name]) {
            console.warn(name + " resource Already exists,the " + name + " Cannot be added,the resource name Cannot repeat ");
            return;
        }
        ResourceProxy.resources[name] = res;
    },
    updateResource: function updateResource(name, res) {
        ResourceProxy.resources[name] = res;
    },
    allResource: function allResource() {
        return ResourceProxy.resources;
    },
    loadSprite: loadSprite,
    loadSvgs: loadSvgs
};
function formatResourceUrl(path) {
    if (isNumber(path)) path += EMPTY_STRING;
    if (!path) {
        console.error('resouce path is null,path:', path);
        return path;
    }
    if (!isString(path)) return path;
    if (isBase64URL(path) || isBlobURL(path)) return path;
    if (path[0] === '$') return ResourceProxy.getResource(path.substring(1, Infinity)) || '';
    var origin = ResourceProxy.origin || {};
    var isAbsoluteURL = isURL(path);
    if (isAbsoluteURL && isObject$1(origin)) {
        var url = handlerURL(path, origin);
        if (url) return url;
        return path;
    }
    var proxys = ResourceProxy.proxy || {};
    if (isObject$1(proxys)) {
        var _url = handlerURL(path, proxys);
        if (_url) return _url;
    }
    var { host: host } = ResourceProxy;
    if (!isAbsoluteURL && host && isString(host)) return "" + host + path;
    return getAbsoluteURL(path);
}
var parser;
function getDomParse() {
    if (!parser) parser = new DOMParser();
    return parser;
}
function getAttr(attributes, key) {
    if (!attributes) return null;
    return attributes[key] && attributes[key].value;
}
function parseSVG(str) {
    var xmlDoc = getDomParse().parseFromString(str, 'text/xml');
    var root = xmlDoc.querySelector('svg');
    if (!root) return null;
    var paths = root.childNodes;
    var data = [];
    var rootAttribute = root.attributes;
    var rootFill = getAttr(rootAttribute, 'fill');
    var rootFillOpacity = getAttr(rootAttribute, 'fill-opacity');
    var rootStroke = getAttr(rootAttribute, 'stroke');
    var rootStrokeOpacity = getAttr(rootAttribute, 'stroke-opacity');
    var rootStrokeWidth = getAttr(rootAttribute, 'stroke-width');
    for(var i = 0, len = paths.length; i < len; i++){
        var dom = paths[i];
        var attributes = dom.attributes;
        if (!attributes) continue;
        var d = void 0;
        var tagName = dom.tagName || '';
        var isPath = tagName.toLowerCase() === 'path';
        if (!isPath) d = dom;
        else d = getAttr(attributes, 'd');
        if (!d) continue;
        var fill = getAttr(attributes, 'fill') || rootFill;
        var stroke = getAttr(attributes, 'stroke') || rootStroke;
        var pathData = {
            path: d
        };
        if (fill) {
            pathData.fill = fill;
            pathData['fill-opacity'] = getAttr(attributes, 'fill-opacity') || rootFillOpacity || 1;
        }
        if (stroke) {
            pathData.stroke = stroke;
            pathData['stroke-opacity'] = getAttr(attributes, 'stroke-opacity') || rootStrokeOpacity || 1;
            pathData['stroke-width'] = getAttr(attributes, 'stroke-width') || rootStrokeWidth || 1;
        }
        data.push(pathData);
        if (!isPath) for(var p in pathData){
            if (p === 'path') continue;
            if (pathData.hasOwnProperty(p)) dom.setAttribute(p, pathData[p]);
        }
    }
    return data;
}
let canvas$1;
const OPTIONS$1 = {
    width: 100,
    height: 10
};
// const ISNODE = typeof global === 'object';
let offscreenCanvas$1 = false;
try {
    const canvas = new OffscreenCanvas(1, 1);
    const ctx = canvas.getContext('2d');
    ctx.fillText('hello', 0, 0);
    offscreenCanvas$1 = true;
} catch (err) {
    offscreenCanvas$1 = false;
}
function getCanvas$1() {
    if (!canvas$1) {
        const { width, height } = OPTIONS$1;
        if (offscreenCanvas$1) canvas$1 = new OffscreenCanvas(width, height);
        else {
            canvas$1 = document.createElement('canvas');
            canvas$1.width = width;
            canvas$1.height = height;
        }
    }
    return canvas$1;
}
let ColorIn$1 = class ColorIn {
    constructor(colors, options = {}){
        if (!Array.isArray(colors)) {
            console.error('colors is not array');
            return;
        }
        if (colors.length < 2) {
            console.error('colors.length should >1');
            return;
        }
        this.colors = colors;
        let min = Infinity, max = -Infinity;
        for(let i = 0, len = colors.length; i < len; i++){
            const value = colors[i][0];
            min = Math.min(value, min);
            max = Math.max(value, max);
        }
        this.min = min;
        this.max = max;
        this.valueOffset = this.max - this.min;
        this.options = Object.assign({}, OPTIONS$1, options);
        this._initImgData();
    }
    getImageData() {
        return this.imgData;
    }
    _initImgData() {
        const canvas = getCanvas$1();
        const { width, height } = this.options;
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        const gradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
        const { colors, valueOffset } = this;
        for(let i = 0, len = colors.length; i < len; i++){
            const [stop, color] = colors[i];
            const s = (stop - this.min) / valueOffset;
            gradient.addColorStop(s, color);
        }
        ctx.fillStyle = gradient;
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        this.imgData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    }
    getColor(stop) {
        stop = Math.max(this.min, stop);
        stop = Math.min(stop, this.max);
        const s = (stop - this.min) / this.valueOffset;
        let x = Math.round(s * this.imgData.width);
        x = Math.min(x, this.imgData.width - 1);
        const idx = x * 4;
        const r = this.imgData.data[idx];
        const g = this.imgData.data[idx + 1];
        const b = this.imgData.data[idx + 2];
        const a = this.imgData.data[idx + 3];
        return [
            r,
            g,
            b,
            a
        ];
    }
};
var isMapSupported = typeof Map === 'function';
var colorInCache;
if (isMapSupported) colorInCache = new Map();
function isNull(value) {
    return value === null || value === undefined;
}
function isNotNull(value) {
    return !isNull(value);
}
function isEmptyString(value) {
    return value === '';
}
/*eslint-disable no-var, prefer-const*/ function createFunction(parameters, defaultType) {
    var fun;
    var isFeatureConstant, isZoomConstant;
    if (!isFunctionDefinition(parameters)) {
        fun = function() {
            return parameters;
        };
        isFeatureConstant = true;
        isZoomConstant = true;
    } else {
        var zoomAndFeatureDependent = parameters.stops && typeof parameters.stops[0][0] === 'object';
        var featureDependent = zoomAndFeatureDependent || isNotNull(parameters.property);
        var zoomDependent = zoomAndFeatureDependent || !featureDependent;
        var type = parameters.type || defaultType || 'exponential';
        var innerFun;
        if (type === 'exponential') innerFun = evaluateExponentialFunction;
        else if (type === 'interval') innerFun = evaluateIntervalFunction;
        else if (type === 'categorical') innerFun = evaluateCategoricalFunction;
        else if (type === 'identity') innerFun = evaluateIdentityFunction;
        else if (type === 'color-interpolate') innerFun = evaluateColorInterpolateFunction;
        else if (type === 'calculate-expression') innerFun = evaluateCalculateExpressionFunction;
        else throw new Error('Unknown function type "' + type + '"');
        if (zoomAndFeatureDependent) {
            var featureFunctions = {};
            var featureFunctionStops = [];
            for(let s = 0; s < parameters.stops.length; s++){
                var stop = parameters.stops[s];
                if (featureFunctions[stop[0].zoom] === undefined) featureFunctions[stop[0].zoom] = {
                    zoom: stop[0].zoom,
                    type: parameters.type,
                    property: parameters.property,
                    default: parameters.default,
                    stops: []
                };
                featureFunctions[stop[0].zoom].stops.push([
                    stop[0].value,
                    stop[1]
                ]);
            }
            for(let z in featureFunctions)featureFunctionStops.push([
                featureFunctions[z].zoom,
                createFunction(featureFunctions[z])
            ]);
            fun = function(zoom, feature) {
                const value = evaluateExponentialFunction({
                    stops: featureFunctionStops,
                    base: parameters.base
                }, zoom)(zoom, feature);
                return typeof value === 'function' ? value(zoom, feature) : value;
            };
            isFeatureConstant = false;
            isZoomConstant = false;
        } else if (zoomDependent) {
            fun = function(zoom) {
                const value = innerFun(parameters, zoom);
                return typeof value === 'function' ? value(zoom) : value;
            };
            isFeatureConstant = true;
            isZoomConstant = false;
        } else {
            fun = function(zoom, feature) {
                const value = innerFun(parameters, feature ? feature[parameters.property] : null);
                return typeof value === 'function' ? value(zoom, feature) : value;
            };
            isFeatureConstant = false;
            isZoomConstant = true;
        }
    }
    fun.isZoomConstant = isZoomConstant;
    fun.isFeatureConstant = isFeatureConstant;
    return fun;
}
function coalesce(a, b, c) {
    if (isNotNull(a)) return a;
    if (isNotNull(b)) return b;
    if (isNotNull(c)) return c;
    return null;
}
function evaluateCategoricalFunction(parameters, input) {
    for(let i = 0; i < parameters.stops.length; i++){
        if (input === parameters.stops[i][0]) return parameters.stops[i][1];
    }
    return parameters.default;
}
function evaluateIntervalFunction(parameters, input) {
    for(var i = 0; i < parameters.stops.length; i++){
        if (input < parameters.stops[i][0]) break;
    }
    return parameters.stops[Math.max(i - 1, 0)][1];
}
function evaluateExponentialFunction(parameters, input) {
    var base = isNotNull(parameters.base) && !isEmptyString(parameters.base) ? parameters.base : 1;
    var i = 0;
    while(true){
        if (i >= parameters.stops.length) break;
        else if (input <= parameters.stops[i][0]) break;
        else i++;
    }
    if (i === 0) return parameters.stops[i][1];
    else if (i === parameters.stops.length) return parameters.stops[i - 1][1];
    else return interpolate$2(input, base, parameters.stops[i - 1][0], parameters.stops[i][0], parameters.stops[i - 1][1], parameters.stops[i][1]);
}
const COLORIN_OPTIONS = {
    width: 100,
    height: 1
};
function evaluateColorInterpolateFunction(parameters, input) {
    const stops = parameters.stops;
    if (stops && stops.length > 1) {
        let colorIn;
        if (colorInCache) {
            const key = JSON.stringify(stops);
            if (!colorInCache.has(key)) {
                const colorIn = new ColorIn$1(stops, COLORIN_OPTIONS);
                colorInCache.set(key, colorIn);
            }
            colorIn = colorInCache.get(key);
        } else colorIn = new ColorIn$1(stops, COLORIN_OPTIONS);
        const [r, g, b, a] = colorIn.getColor(input);
        return [
            r / 255,
            g / 255,
            b / 255,
            a / 255
        ];
    } else if (stops && stops.length === 1) return stops[0][1];
    return null;
}
function evaluateIdentityFunction(parameters, input) {
    return coalesce(input, parameters.default);
}
// 2添加修改计算函数
// 处理空字符串和未定义属性的函数
function evaluateCalculateExpressionFunction(parameters, input) {
    const targetVariable = String(parameters.property);
    const expression = parameters.expression;
    const newValue = input;
    // 定义函数来替换表达式中的变量
    function traverseAndAssign(expression, targetVariable, newValue) {
        const newValueAsNumber = Number(newValue);
        const targetVariableAsString = String(targetVariable);
        if (Array.isArray(expression)) return expression.map((subExpr)=>traverseAndAssign(subExpr, targetVariableAsString, newValueAsNumber));
        else if (expression === targetVariableAsString) return newValueAsNumber;
        else return expression;
    }
    // 定义函数来计算表达式的结果
    function evaluateExpression(expression) {
        if (Array.isArray(expression)) {
            const operator = expression[0];
            if (![
                '+',
                '-',
                '*',
                '/'
            ].includes(operator)) throw new Error(`Unknown operator: ${operator}`);
            const operands = expression.slice(1).map((op)=>evaluateExpression(op));
            switch(operator){
                case '+':
                    return operands.reduce((acc, curr)=>acc + curr, 0);
                case '-':
                    return operands.reduce((acc, curr)=>acc - curr);
                case '*':
                    return operands.reduce((acc, curr)=>acc * curr, 1);
                case '/':
                    // 如果发现有零作为除数，返回默认值
                    if (operands.some((op)=>op === 0)) return parameters.default;
                    return operands.reduce((acc, curr)=>acc / curr);
                default:
                    throw new Error(`Unsupported operator: ${operator}`);
            }
        } else if (typeof expression === 'number') return expression;
        else throw new Error('Invalid expression format');
    }
    // 使用 coalesce 函数处理结果中的默认值
    function coalesce(value) {
        return isNull(value) || isEmptyString(value) || isNaN(value) ? parameters.default : value;
    }
    // 如果 input 存在且大于0，则处理表达式
    if (isNotNull(input) && !isEmptyString(input) && !isNaN(input) && !(input < 0)) {
        const updatedExpression = traverseAndAssign(expression, targetVariable, newValue);
        return coalesce(evaluateExpression(updatedExpression));
    } else return coalesce(parameters.default);
}
function interpolate$2(input, base, inputLower, inputUpper, outputLower, outputUpper) {
    if (typeof outputLower === 'function') return function() {
        var evaluatedLower = outputLower.apply(undefined, arguments);
        var evaluatedUpper = outputUpper.apply(undefined, arguments);
        return interpolate$2(input, base, inputLower, inputUpper, evaluatedLower, evaluatedUpper);
    };
    else if (outputLower.length) return interpolateArray(input, base, inputLower, inputUpper, outputLower, outputUpper);
    else return interpolateNumber(input, base, inputLower, inputUpper, outputLower, outputUpper);
}
function interpolateNumber(input, base, inputLower, inputUpper, outputLower, outputUpper) {
    var difference = inputUpper - inputLower;
    var progress = input - inputLower;
    var ratio;
    if (base === 1) ratio = progress / difference;
    else ratio = (Math.pow(base, progress) - 1) / (Math.pow(base, difference) - 1);
    return outputLower * (1 - ratio) + outputUpper * ratio;
}
function interpolateArray(input, base, inputLower, inputUpper, outputLower, outputUpper) {
    var output = [];
    for(let i = 0; i < outputLower.length; i++)output[i] = interpolateNumber(input, base, inputLower, inputUpper, outputLower[i], outputUpper[i]);
    return output;
}
/**
 * Check if object is a definition of function type
 * @param  {Object}  obj object
 * @return {Boolean}
 * @memberOf MapboxUtil
 */ function isFunctionDefinition(obj) {
    return obj && typeof obj === 'object' && (obj.stops || obj.property && obj.type === 'identity' || obj.expression && obj.type === 'calculate-expression');
}
// export function isFunctionDefinition(obj) {
//     return obj && typeof obj === 'object' && (obj.stops || (obj.property && obj.type === 'identity'));
// }
/**
 * Check if obj's properties has function definition
 * @param  {Object}  obj object to check
 * @return {Boolean}
 * @memberOf MapboxUtil
 */ function hasFunctionDefinition(obj) {
    for(const p in obj){
        if (isFunctionDefinition(obj[p])) return true;
    }
    return false;
}
function interpolated(parameters) {
    return createFunction1(parameters, 'exponential');
}
/**
 * Load function types defined in object
 * @param  {Object[]} parameters parameters
 * @return {Object}   loaded object
 * @memberOf MapboxUtil
 */ function loadFunctionTypes(obj, argFn) {
    if (!obj) return null;
    var hit = false;
    if (Array.isArray(obj)) {
        var multResult = [], loaded;
        for(let i = 0; i < obj.length; i++){
            loaded = loadFunctionTypes(obj[i], argFn);
            if (!loaded) multResult.push(obj[i]);
            else {
                multResult.push(loaded);
                hit = true;
            }
        }
        return hit ? multResult : obj;
    }
    var result = {
        '__fn_types_loaded': true
    }, props = [], p;
    for(p in obj)if (obj.hasOwnProperty(p)) props.push(p);
    const buildFn = function(p) {
        Object.defineProperty(result, p, {
            get: function() {
                if (!this['__fn_' + p]) this['__fn_' + p] = interpolated(this['_' + p]);
                return this['__fn_' + p].apply(this, argFn());
            },
            set: function(v) {
                this['_' + p] = v;
            },
            configurable: true,
            enumerable: true
        });
    };
    for(let i = 0, len = props.length; i < len; i++){
        p = props[i];
        if (isFunctionDefinition(obj[p])) {
            hit = true;
            result['_' + p] = obj[p];
            buildFn(p);
        } else result[p] = obj[p];
    }
    return hit ? result : obj;
}
/**
 * Get external resources in the function type
 * @param  {Object} t Function type definition
 * @return {String[]}   resouces
 * @memberOf MapboxUtil
 */ function getFunctionTypeResources(t) {
    if (!t || !t.stops) return [];
    const res = [];
    for(let i = 0, l = t.stops.length; i < l; i++)res.push(t.stops[i][1]);
    return res;
}
/*eslint-enable no-var, prefer-const*/ function createFunction1(parameters, defaultType) {
    if (!isFunctionDefinition(parameters)) return function() {
        return parameters;
    };
    parameters = JSON.parse(JSON.stringify(parameters));
    let isZoomConstant = true;
    let isFeatureConstant = true;
    const stops = parameters.stops;
    if (stops) {
        for(let i = 0; i < stops.length; i++)if (isFunctionDefinition(stops[i][1])) {
            const fn = createFunction1(stops[i][1], defaultType);
            isZoomConstant = isZoomConstant && fn.isZoomConstant;
            isFeatureConstant = isFeatureConstant && fn.isFeatureConstant;
            stops[i] = [
                stops[i][0],
                fn
            ];
        }
    }
    const fn = createFunction(parameters, defaultType);
    fn.isZoomConstant = isZoomConstant && fn.isZoomConstant;
    fn.isFeatureConstant = isFeatureConstant && fn.isFeatureConstant;
    return fn;
}
/*!
    Feature Filter by

    (c) mapbox 2016 and maptalks 2018
    www.mapbox.com | www.maptalks.org
    License: MIT, header required.
*/ const types$1 = [
    'Unknown',
    'Point',
    'LineString',
    'Polygon',
    'MultiPoint',
    'MultiLineString',
    'MultiPolygon',
    'GeometryCollection'
];
function isObject(obj) {
    return typeof obj === 'object' && !!obj;
}
/**
 * Given a filter expressed as nested arrays, return a new function
 * that evaluates whether a given feature (with a .properties or .tags property)
 * passes its test.
 *
 * @param {Array} filter mapbox gl filter
 * @returns {Function} filter-evaluating function
 */ function createFilter(filter) {
    return new Function('f', `var p = (f && f.properties || {}); return ${compile(filter)}`);
}
function isFeatureFilter(filter) {
    if (filter === true || filter === false) return true;
    if (!Array.isArray(filter) || filter.length === 0) return false;
    switch(filter[0]){
        case 'has':
        case '!has':
            return filter.length === 2 && (typeof filter[1] === 'string' || filter[1].property && filter[1].op);
        case 'in':
        case '!in':
            return filter.length >= 2 && (typeof filter[1] === 'string' || filter[1].property && filter[1].op);
        case '==':
        case '!=':
        case '>':
        case '>=':
        case '<':
        case '<=':
            return filter.length === 3 && (typeof filter[1] === 'string' || filter[1].property && filter[1].op);
        case 'none':
        case 'any':
        case 'all':
            for (const f of filter.slice(1)){
                if (!isFeatureFilter(f) && typeof f !== 'boolean') return false;
            }
            return true;
        case 'contains':
            return true;
        default:
            return false;
    }
}
function compile(filter) {
    if (!filter) return 'true';
    const op = filter[0];
    if (filter.length <= 1) return op === 'any' ? 'false' : 'true';
    const str = op === '==' ? compileComparisonOp(filter[1], filter[2], '===', false) : op === '!=' ? compileComparisonOp(filter[1], filter[2], '!==', false) : op === '<' || op === '>' || op === '<=' || op === '>=' ? compileComparisonOp(filter[1], filter[2], op, true) : op === 'any' ? compileLogicalOp(filter.slice(1), '||') : op === 'all' ? compileLogicalOp(filter.slice(1), '&&') : op === 'none' ? compileNegation(compileLogicalOp(filter.slice(1), '||')) : op === 'in' ? compileInOp(filter[1], filter.slice(2)) : op === '!in' ? compileNegation(compileInOp(filter[1], filter.slice(2))) : op === 'has' ? compileHasOp(filter[1]) : op === '!has' ? compileNegation(compileHasOp(filter[1])) : // op === 'test' ? compileRegex(filter[1], filter[2]) :
    op === 'contains' ? compileContains(filter[1], filter[2], filter[3]) : 'true';
    return `(${str})`;
}
function compileFunction(propertyObj, value, op, checkType) {
    const property = propertyObj.property, funName = propertyObj.op;
    let left = compilePropertyReference(property);
    if (funName === 'length') left = `((${left}+='').length)`;
    else {
        // TODO
        //  other functions
        console.error(`not support ${funName} op`);
        return 'false';
    }
    return getComparisonCode(left, property, value, op, checkType);
}
function compileContains(property, str, index) {
    const prop = compilePropertyReference(property);
    if (index !== undefined) return `(${prop} + '').indexOf("${str}") === ${index}`;
    else return `(${prop} + '').indexOf("${str}") >= 0`;
}
// function compileRegex(property, regex) {
//     const prop = compilePropertyReference(property);
//     return `new RegExp("${regex}").test(${prop})`;
// }
function compilePropertyReference(property) {
    // const ref =
    //     property === '$type' ? 'f.type' :
    //         property === '$id' ? 'f.id' : `p[${JSON.stringify(property)}]`;
    // return ref;
    return property[0] === '$' ? 'f.' + property.substring(1) : 'p[' + JSON.stringify(property) + ']';
}
function compileComparisonOp(property, value, op, checkType) {
    if (isObject(property) && property.op) return compileFunction(property, value, op, checkType);
    const left = compilePropertyReference(property);
    return getComparisonCode(left, property, value, op, checkType);
}
function getComparisonCode(left, property, value, op, checkType) {
    const right = property === '$type' ? types$1.indexOf(value) : JSON.stringify(value);
    return (checkType ? `typeof ${left}=== typeof ${right}&&` : '') + left + op + right;
}
function compileLogicalOp(expressions, op) {
    return expressions.map(compile).join(op);
}
function compileInOp(property, values) {
    if (property === '$type') values = values.map((value)=>{
        return types$1.indexOf(value);
    });
    const left = JSON.stringify(values.sort(compare));
    const right = compilePropertyReference(property);
    if (values.length <= 200) return `${left}.indexOf(${right}) !== -1`;
    return `function(v, a, i, j) {
        while (i <= j) { var m = (i + j) >> 1;
            if (a[m] === v) return true; if (a[m] > v) j = m - 1; else i = m + 1;
        }
    return false; }(${right}, ${left},0,${values.length - 1})`;
}
function compileHasOp(property) {
    return property === '$id' ? '"id" in f' : `${JSON.stringify(property)} in p`;
}
function compileNegation(expression) {
    return `!(${expression})`;
}
// Comparison function to sort numbers and strings
function compare(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
}
/**
 * Get feature object from a geometry for filter functions.
 * @param  {Geometry} geometry geometry
 * @return {Object}          feature for filter functions
 */ function getFilterFeature(geometry) {
    const json = geometry._toJSON(), g = json['feature'];
    g['type'] = types$1.indexOf(g['geometry']['type']);
    g['subType'] = json['subType'];
    return g;
}
/**
 * Compile layer's style, styles to symbolize layer's geometries, e.g.<br>
 * <pre>
 * [
 *   {
 *     'filter' : ['==', 'foo', 'val'],
 *     'symbol' : {'markerFile':'foo.png'}
 *   }
 * ]
 * </pre>
 * @param  {Object|Object[]} styles - style to compile
 * @return {Object[]}       compiled styles
 */ function compileStyle(styles) {
    if (!Array.isArray(styles)) return compileStyle([
        styles
    ]);
    const compiled = [];
    for(let i = 0; i < styles.length; i++){
        let filter;
        if (styles[i]['filter'] === true) filter = function() {
            return true;
        };
        else filter = createFilter(styles[i]['filter']);
        compiled.push(extend$1({}, styles[i], {
            filter: filter
        }));
    }
    return compiled;
}
function extend$1(dest) {
    for(let i = 1; i < arguments.length; i++){
        const src = arguments[i];
        for(const k in src)dest[k] = src[k];
    }
    return dest;
}
var arr = [], prop = {};
function loadGeoSymbol(symbol, geo) {
    return loadFunctionTypes(symbol, function() {
        var map = geo.getMap();
        return set$1(arr, map ? map.getZoom() : 12, extend$2({}, geo.getProperties(), setProp(prop, map && map.getBearing() || 0, map && map.getPitch() || 0, map ? map.getZoom() : 10)));
    });
}
function set$1(arr, a0, a1) {
    arr[0] = a0;
    arr[1] = a1;
    return arr;
}
function setProp(prop, b, p, z) {
    prop['{bearing}'] = b;
    prop['{pitch}'] = p;
    prop['{zoom}'] = z;
    return prop;
}
var index$7 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    compileStyle: compileStyle,
    createFilter: createFilter,
    getFilterFeature: getFilterFeature,
    getFunctionTypeResources: getFunctionTypeResources,
    hasFunctionDefinition: hasFunctionDefinition,
    interpolated: interpolated,
    isFeatureFilter: isFeatureFilter,
    isFunctionDefinition: isFunctionDefinition,
    loadFunctionTypes: loadFunctionTypes,
    loadGeoSymbol: loadGeoSymbol
});
function translateToSVGStyles(s) {
    var result = {
        'stroke': {
            'stroke': s['markerLineColor'],
            'stroke-width': s['markerLineWidth'],
            'stroke-opacity': s['markerLineOpacity'],
            'stroke-dasharray': null,
            'stroke-linecap': 'butt',
            'stroke-linejoin': 'round'
        },
        'fill': {
            'fill': s['markerFill'],
            'fill-opacity': s['markerFillOpacity']
        }
    };
    if (result['stroke']['stroke-width'] === 0) result['stroke']['stroke-opacity'] = 0;
    return result;
}
function getMarkerPathBase64(symbol, width, height) {
    if (!symbol['markerPath']) return null;
    var op = 1;
    var styles = translateToSVGStyles(symbol);
    if (isNumber(symbol['markerOpacity'])) op = symbol['markerOpacity'];
    if (isNumber(symbol['opacity'])) op *= symbol['opacity'];
    var svgStyles = {};
    if (styles) {
        for(var p in styles['stroke']){
            if (styles['stroke'].hasOwnProperty(p)) {
                if (!isNil(styles['stroke'][p])) svgStyles[p] = styles['stroke'][p];
            }
        }
        for(var _p in styles['fill']){
            if (styles['fill'].hasOwnProperty(_p)) {
                if (!isNil(styles['fill'][_p])) svgStyles[_p] = styles['fill'][_p];
            }
        }
    }
    var pathes;
    var markerPath = symbol.markerPath;
    if (isString(markerPath) && markerPath[0] === '$') pathes = ResourceProxy.getResource(markerPath.substring(1, Infinity)) || [];
    else pathes = Array.isArray(symbol['markerPath']) ? symbol['markerPath'] : [
        symbol['markerPath']
    ];
    var path;
    var pathesToRender = [];
    for(var i = 0; i < pathes.length; i++){
        path = isString(pathes[i]) ? {
            'path': pathes[i]
        } : pathes[i];
        path = extend$2({}, path, svgStyles);
        path['d'] = path['path'];
        delete path['path'];
        pathesToRender.push(path);
    }
    var svg = [
        '<svg version="1.1"',
        'xmlns="http://www.w3.org/2000/svg"'
    ];
    if (op < 1) svg.push('opacity="' + op + '"');
    if (symbol['markerPathWidth'] && symbol['markerPathHeight']) svg.push('viewBox="0 0 ' + symbol['markerPathWidth'] + ' ' + symbol['markerPathHeight'] + '"');
    svg.push('preserveAspectRatio="none"');
    if (width) svg.push('width="' + width + '"');
    if (height) svg.push('height="' + height + '"');
    svg.push('><defs></defs>');
    for(var _i = 0; _i < pathesToRender.length; _i++){
        if (pathesToRender[_i].d instanceof Element) {
            svg.push(pathesToRender[_i].d.outerHTML);
            continue;
        }
        var strPath = '<path ';
        for(var _p2 in pathesToRender[_i])if (pathesToRender[_i].hasOwnProperty(_p2)) strPath += ' ' + _p2 + '="' + pathesToRender[_i][_p2] + '"';
        strPath += '></path>';
        svg.push(strPath);
    }
    svg.push('</svg>');
    var b64 = 'data:image/svg+xml;base64,' + btoa(svg.join(' '));
    return b64;
}
function getExternalResources(symbol, toAbsolute) {
    if (!symbol) return [];
    var symbols = symbol;
    if (!Array.isArray(symbol)) symbols = [
        symbol
    ];
    var resources = [];
    var props = RESOURCE_PROPERTIES;
    var res, resSizeProp;
    var w, h;
    for(var i = symbols.length - 1; i >= 0; i--){
        symbol = symbols[i];
        if (!symbol) continue;
        if (toAbsolute) symbol = convertResourceUrl(symbol);
        for(var ii = 0; ii < props.length; ii++){
            res = symbol[props[ii]];
            if (isFunctionDefinition(res)) res = getFunctionTypeResources(res);
            if (!res) continue;
            if (!Array.isArray(res)) res = [
                res
            ];
            for(var iii = 0; iii < res.length; iii++){
                if (res[iii].slice(0, 4) === 'url(') res[iii] = extractCssUrl(res[iii]);
                resSizeProp = RESOURCE_SIZE_PROPERTIES[ii];
                resources.push([
                    res[iii],
                    symbol[resSizeProp[0]],
                    symbol[resSizeProp[1]]
                ]);
            }
        }
        if (symbol['markerType'] === 'path' && symbol['markerPath']) {
            w = isFunctionDefinition(symbol['markerWidth']) ? 200 : symbol['markerWidth'];
            h = isFunctionDefinition(symbol['markerHeight']) ? 200 : symbol['markerHeight'];
            if (isFunctionDefinition(symbol['markerPath'])) {
                res = getFunctionTypeResources(symbol['markerPath']);
                var path = symbol['markerPath'];
                for(var _iii = 0; _iii < res.length; _iii++){
                    symbol['markerPath'] = res[_iii];
                    resources.push([
                        getMarkerPathBase64(symbol),
                        w,
                        h
                    ]);
                }
                symbol['markerPath'] = path;
            } else resources.push([
                getMarkerPathBase64(symbol),
                w,
                h
            ]);
        }
    }
    return resources;
}
function convertResourceUrl(symbol) {
    if (!symbol) return null;
    var s = symbol;
    if (IS_NODE) return s;
    var props = RESOURCE_PROPERTIES;
    var res;
    for(var ii = 0, len = props.length; ii < len; ii++){
        res = s[props[ii]];
        if (!res) continue;
        s[props[ii]] = _convertUrl(res);
    }
    return s;
}
function _convertUrl(res) {
    if (isFunctionDefinition(res) && res.stops) {
        var stops = res.stops;
        for(var i = 0; i < stops.length; i++)stops[i][1] = _convertUrl(stops[i][1]);
        return res;
    }
    if (res.slice(0, 4) === 'url(') res = extractCssUrl(res);
    return res;
}
function isImageBitMap(img) {
    return img && Browser$1.decodeImageInWorker && img instanceof ImageBitmap;
}
function isGradient(g) {
    return g && g['colorStops'];
}
function getGradientStamp(g) {
    var keys = [
        g['type']
    ];
    if (g['places']) keys.push(g['places'].join());
    if (g['colorStops']) {
        var stops = [];
        for(var i = g['colorStops'].length - 1; i >= 0; i--)stops.push(g['colorStops'][i].join());
        keys.push(stops.join(','));
    }
    return keys.join('_');
}
function getSymbolStamp(symbol, prefix) {
    return getSymbolHash(symbol, prefix);
}
function getSymbolHash(symbol, prefix) {
    if (!symbol) return 1;
    var keys = [];
    if (Array.isArray(symbol)) {
        for(var i = 0; i < symbol.length; i++)keys.push(getSymbolHash(symbol[i], prefix));
        return keys.sort().join(',');
    }
    var sortedKeys = Object.keys(symbol).sort();
    var sortedSymbol = sortedKeys.reduce(function(accumulator, curValue) {
        if (!prefix || curValue.indexOf(prefix) === 0) accumulator[curValue] = symbol[curValue];
        return accumulator;
    }, {});
    var hash = hashCode(JSON.stringify(sortedSymbol));
    return hash;
}
function lowerSymbolOpacity(symbol, ratio) {
    function s(_symbol, _ratio) {
        var op = _symbol['opacity'];
        if (isNil(op)) _symbol['opacity'] = _ratio;
        else _symbol['opacity'] *= _ratio;
    }
    var lower;
    if (Array.isArray(symbol)) {
        lower = [];
        for(var i = 0; i < symbol.length; i++){
            var d = extend$2({}, symbol[i]);
            s(d, ratio);
            lower.push(d);
        }
    } else {
        lower = extend$2({}, symbol);
        s(lower, ratio);
    }
    return lower;
}
function extendSymbol(...args) {
    var symbol = args[0];
    var sources = Array.prototype.slice.call(args, 1);
    if (!sources || !sources.length) sources = [
        {}
    ];
    if (Array.isArray(symbol)) {
        var s, dest;
        var result = [];
        for(var i = 0, l = symbol.length; i < l; i++){
            s = symbol[i];
            dest = {};
            for(var ii = 0, ll = sources.length; ii < ll; ii++){
                if (!Array.isArray(sources[ii])) extend$2(dest, s, sources[ii] ? sources[ii] : {});
                else if (!isNil(sources[ii][i])) extend$2(dest, s, sources[ii][i]);
                else extend$2(dest, s ? s : {});
            }
            result.push(dest);
        }
        return result;
    } else {
        var _args = [
            {},
            symbol
        ];
        _args.push.apply(_args, sources);
        return extend$2.apply(this, _args);
    }
}
function parseStyleRootPath(style) {
    if (style.symbol) style = [
        style
    ];
    if (Array.isArray(style)) return style;
    var root = style['$root'];
    var iconset = style['$iconset'];
    style = style.style;
    if (root || iconset) {
        if (root && root[root.length - 1] === '/') root = root.substring(0, root.length - 1);
        if (iconset && iconset[iconset.length - 1] === '/') iconset = iconset.substring(0, iconset.length - 1);
        var replacer = function replacer(match) {
            if (match === '{$root}') return root;
            else if (match === '{$iconset}') return iconset;
            return null;
        };
        convertStylePath(style, replacer);
    }
    return style;
}
function convertStylePath(styles, replacer) {
    for(var i = 0; i < styles.length; i++){
        var { symbol: symbol } = styles[i];
        if (symbol) parseSymbolPath(symbol, replacer);
    }
}
var URL_PATTERN$1 = /(\{\$root\}|\{\$iconset\})/g;
function parseSymbolPath(symbol, replacer) {
    for(var p in symbol)if (symbol.hasOwnProperty(p) && p !== 'textName') {
        if (isString(symbol[p]) && symbol[p].length > 2) symbol[p] = symbol[p].replace(URL_PATTERN$1, replacer);
        else if (isFunctionDefinition(symbol[p])) symbol[p] = parseStops(symbol[p], replacer);
        else if (isObject$1(symbol[p])) parseSymbolPath(symbol[p], replacer);
    }
}
function parseStops(value, replacer) {
    var defaultValue = value['default'];
    if (isString(defaultValue)) value['default'] = defaultValue.replace(URL_PATTERN$1, replacer);
    var stops = value.stops;
    if (!stops) return value;
    for(var i = 0; i < stops.length; i++){
        if (!Array.isArray(stops[i])) continue;
        if (isString(stops[i][1])) stops[i][1] = stops[i][1].replace(URL_PATTERN$1, replacer);
        else if (isFunctionDefinition(stops[i][1])) stops[i][1] = parseStops(stops[i][1], replacer);
    }
    return value;
}
function isDashLine(symbolizers = []) {
    if (!Array.isArray(symbolizers)) symbolizers = [
        symbolizers
    ];
    var len = symbolizers.length;
    for(var i = 0; i < len; i++){
        var symbolizer = symbolizers[i];
        if (!symbolizer.style) continue;
        var { lineDasharray: lineDasharray, lineWidth: lineWidth } = symbolizer.style;
        if (lineWidth && isNumber(lineWidth) && lineWidth > 0 && lineDasharray && Array.isArray(lineDasharray) && lineDasharray.length) return true;
    }
    return false;
}
function perspective(out, fovy, aspect, near, far) {
    var f = 1.0 / Math.tan(fovy / 2), nf = 1 / (near - far);
    out[0] = f / aspect;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = f;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = (far + near) * nf;
    out[11] = -1;
    out[12] = 0;
    out[13] = 0;
    out[14] = 2 * far * near * nf;
    out[15] = 0;
    return out;
}
function translate(out, a, v) {
    var x = v[0], y = v[1], z = v[2], a00, a01, a02, a03, a10, a11, a12, a13, a20, a21, a22, a23;
    if (a === out) {
        out[12] = a[0] * x + a[4] * y + a[8] * z + a[12];
        out[13] = a[1] * x + a[5] * y + a[9] * z + a[13];
        out[14] = a[2] * x + a[6] * y + a[10] * z + a[14];
        out[15] = a[3] * x + a[7] * y + a[11] * z + a[15];
    } else {
        a00 = a[0];
        a01 = a[1];
        a02 = a[2];
        a03 = a[3];
        a10 = a[4];
        a11 = a[5];
        a12 = a[6];
        a13 = a[7];
        a20 = a[8];
        a21 = a[9];
        a22 = a[10];
        a23 = a[11];
        out[0] = a00;
        out[1] = a01;
        out[2] = a02;
        out[3] = a03;
        out[4] = a10;
        out[5] = a11;
        out[6] = a12;
        out[7] = a13;
        out[8] = a20;
        out[9] = a21;
        out[10] = a22;
        out[11] = a23;
        out[12] = a00 * x + a10 * y + a20 * z + a[12];
        out[13] = a01 * x + a11 * y + a21 * z + a[13];
        out[14] = a02 * x + a12 * y + a22 * z + a[14];
        out[15] = a03 * x + a13 * y + a23 * z + a[15];
    }
    return out;
}
function scale$1(out, a, v) {
    var x = v[0], y = v[1], z = v[2];
    out[0] = a[0] * x;
    out[1] = a[1] * x;
    out[2] = a[2] * x;
    out[3] = a[3] * x;
    out[4] = a[4] * y;
    out[5] = a[5] * y;
    out[6] = a[6] * y;
    out[7] = a[7] * y;
    out[8] = a[8] * z;
    out[9] = a[9] * z;
    out[10] = a[10] * z;
    out[11] = a[11] * z;
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
    return out;
}
function rotateX(out, a, rad) {
    var s = Math.sin(rad), c = Math.cos(rad), a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7], a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    if (a !== out) {
        out[0] = a[0];
        out[1] = a[1];
        out[2] = a[2];
        out[3] = a[3];
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    }
    out[4] = a10 * c + a20 * s;
    out[5] = a11 * c + a21 * s;
    out[6] = a12 * c + a22 * s;
    out[7] = a13 * c + a23 * s;
    out[8] = a20 * c - a10 * s;
    out[9] = a21 * c - a11 * s;
    out[10] = a22 * c - a12 * s;
    out[11] = a23 * c - a13 * s;
    return out;
}
function rotateZ(out, a, rad) {
    var s = Math.sin(rad), c = Math.cos(rad), a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3], a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    if (a !== out) {
        out[8] = a[8];
        out[9] = a[9];
        out[10] = a[10];
        out[11] = a[11];
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    }
    out[0] = a00 * c + a10 * s;
    out[1] = a01 * c + a11 * s;
    out[2] = a02 * c + a12 * s;
    out[3] = a03 * c + a13 * s;
    out[4] = a10 * c - a00 * s;
    out[5] = a11 * c - a01 * s;
    out[6] = a12 * c - a02 * s;
    out[7] = a13 * c - a03 * s;
    return out;
}
function multiply(out, a, b) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3], a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7], a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11], a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
    out[0] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[1] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[2] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[3] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    b0 = b[4];
    b1 = b[5];
    b2 = b[6];
    b3 = b[7];
    out[4] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[5] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[6] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[7] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    b0 = b[8];
    b1 = b[9];
    b2 = b[10];
    b3 = b[11];
    out[8] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[9] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[10] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[11] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    b0 = b[12];
    b1 = b[13];
    b2 = b[14];
    b3 = b[15];
    out[12] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[13] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[14] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[15] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    return out;
}
function invert(out, a) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3], a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7], a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11], a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15], b00 = a00 * a11 - a01 * a10, b01 = a00 * a12 - a02 * a10, b02 = a00 * a13 - a03 * a10, b03 = a01 * a12 - a02 * a11, b04 = a01 * a13 - a03 * a11, b05 = a02 * a13 - a03 * a12, b06 = a20 * a31 - a21 * a30, b07 = a20 * a32 - a22 * a30, b08 = a20 * a33 - a23 * a30, b09 = a21 * a32 - a22 * a31, b10 = a21 * a33 - a23 * a31, b11 = a22 * a33 - a23 * a32, det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
    if (!det) return null;
    det = 1.0 / det;
    out[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
    out[1] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
    out[2] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
    out[3] = (a22 * b04 - a21 * b05 - a23 * b03) * det;
    out[4] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
    out[5] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
    out[6] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
    out[7] = (a20 * b05 - a22 * b02 + a23 * b01) * det;
    out[8] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
    out[9] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
    out[10] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
    out[11] = (a21 * b02 - a20 * b04 - a23 * b00) * det;
    out[12] = (a11 * b07 - a10 * b09 - a12 * b06) * det;
    out[13] = (a00 * b09 - a01 * b07 + a02 * b06) * det;
    out[14] = (a31 * b01 - a30 * b03 - a32 * b00) * det;
    out[15] = (a20 * b03 - a21 * b01 + a22 * b00) * det;
    return out;
}
function identity$1(out) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = 1;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 1;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function copy$1(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    out[9] = a[9];
    out[10] = a[10];
    out[11] = a[11];
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
    return out;
}
var index$6 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    DEFAULT_FONT: DEFAULT_FONT,
    DEFAULT_TEXTSIZE: DEFAULT_TEXTSIZE,
    EMPTY_STRING: EMPTY_STRING$1,
    GUID: GUID,
    IS_NODE: IS_NODE,
    UID: UID,
    _defaults: _defaults,
    b64toBlob: b64toBlob,
    btoa: btoa,
    calCanvasSize: calCanvasSize,
    get cancelAnimFrame () {
        return cancelAnimFrame;
    },
    checkMTKVersion: checkMTKVersion,
    clamp: clamp,
    computeDegree: computeDegree,
    convertResourceUrl: convertResourceUrl,
    convertStylePath: convertStylePath,
    copy: copy$1,
    describeText: describeText,
    emptyImageUrl: emptyImageUrl,
    equalMapView: equalMapView,
    escapeSpecialChars: escapeSpecialChars,
    extend: extend$2,
    extendSymbol: extendSymbol,
    extractCssUrl: extractCssUrl,
    flash: flash,
    forEachCoord: forEachCoord,
    getAbsoluteURL: getAbsoluteURL,
    getAlignPoint: getAlignPoint,
    getExternalResources: getExternalResources,
    getFont: getFont,
    getGlobalThis: getGlobalThis,
    getGradientStamp: getGradientStamp,
    getImageBitMap: getImageBitMap,
    getMarkerPathBase64: getMarkerPathBase64,
    getPointsResultPts: getPointsResultPts,
    getSymbolHash: getSymbolHash,
    getSymbolStamp: getSymbolStamp,
    getValueOrDefault: getValueOrDefault,
    hasOwn: hasOwn,
    hashCode: hashCode,
    identity: identity$1,
    interpolate: interpolate$3,
    invert: invert,
    isArrayHasData: isArrayHasData,
    isCssUrl: isCssUrl,
    isDashLine: isDashLine,
    isEmpty: isEmpty,
    isFunction: isFunction,
    isGradient: isGradient,
    isImageBitMap: isImageBitMap,
    isInteger: isInteger,
    isNil: isNil,
    isNoContentHttpCode: isNoContentHttpCode,
    isNumber: isNumber,
    isObject: isObject$1,
    isSVG: isSVG,
    isString: isString,
    isURL: isURL,
    join: join,
    loadImage: loadImage,
    log2: log2,
    lowerSymbolOpacity: lowerSymbolOpacity,
    mergeArray: mergeArray,
    multiply: multiply,
    now: now,
    parseJSON: parseJSON,
    parseStyleRootPath: parseStyleRootPath,
    parseSymbolPath: parseSymbolPath,
    perspective: perspective,
    pushIn: pushIn,
    removeFromArray: removeFromArray,
    replaceAll: replaceAll,
    replaceVariable: replaceVariable,
    get requestAnimFrame () {
        return requestAnimFrame;
    },
    rotateX: rotateX,
    rotateZ: rotateZ,
    scale: scale$1,
    sign: sign,
    splitContent: splitContent,
    splitTextToRow: splitTextToRow,
    splitWords: splitWords,
    stringLength: stringLength,
    stringWidth: stringWidth,
    toDegree: toDegree,
    toRadian: toRadian,
    translate: translate,
    translateToSVGStyles: translateToSVGStyles,
    trim: trim,
    wrap: wrap
});
var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};
function getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}
var lineclip_1 = lineclip;
lineclip.polyline = lineclip;
lineclip.polygon = polygonclip;
// Cohen-Sutherland line clippign algorithm, adapted to efficiently
// handle polylines rather than just segments
function lineclip(points, bbox, result) {
    var len = points.length, codeA = bitCode(points[0], bbox), part = [], i, a, b, codeB, lastCode;
    if (!result) result = [];
    for(i = 1; i < len; i++){
        a = points[i - 1];
        b = points[i];
        codeB = lastCode = bitCode(b, bbox);
        while(true){
            if (!(codeA | codeB)) {
                part.push(a);
                if (codeB !== lastCode) {
                    part.push(b);
                    if (i < len - 1) {
                        result.push(part);
                        part = [];
                    }
                } else if (i === len - 1) part.push(b);
                break;
            } else if (codeA & codeB) break;
            else if (codeA) {
                a = intersect(a, b, codeA, bbox);
                codeA = bitCode(a, bbox);
            } else {
                b = intersect(a, b, codeB, bbox);
                codeB = bitCode(b, bbox);
            }
        }
        codeA = lastCode;
    }
    if (part.length) result.push(part);
    return result;
}
// Sutherland-Hodgeman polygon clipping algorithm
function polygonclip(points, bbox) {
    var result, edge, prev, prevInside, i, p, inside;
    // clip against each side of the clip rectangle
    for(edge = 1; edge <= 8; edge *= 2){
        result = [];
        prev = points[points.length - 1];
        prevInside = !(bitCode(prev, bbox) & edge);
        for(i = 0; i < points.length; i++){
            p = points[i];
            inside = !(bitCode(p, bbox) & edge);
            // if segment goes through the clip window, add an intersection
            if (inside !== prevInside) result.push(intersect(prev, p, edge, bbox));
            if (inside) result.push(p); // add a point if it's inside
            prev = p;
            prevInside = inside;
        }
        points = result;
        if (!points.length) break;
    }
    return result;
}
// intersect a segment against one of the 4 lines that make up the bbox
function intersect(a, b, edge, bbox) {
    return edge & 8 ? [
        a[0] + (b[0] - a[0]) * (bbox[3] - a[1]) / (b[1] - a[1]),
        bbox[3]
    ] : edge & 4 ? [
        a[0] + (b[0] - a[0]) * (bbox[1] - a[1]) / (b[1] - a[1]),
        bbox[1]
    ] : edge & 2 ? [
        bbox[2],
        a[1] + (b[1] - a[1]) * (bbox[2] - a[0]) / (b[0] - a[0])
    ] : edge & 1 ? [
        bbox[0],
        a[1] + (b[1] - a[1]) * (bbox[0] - a[0]) / (b[0] - a[0])
    ] : null;
}
// bit code reflects the point position relative to the bbox:
//         left  mid  right
//    top  1001  1000  1010
//    mid  0001  0000  0010
// bottom  0101  0100  0110
function bitCode(p, bbox) {
    var code = 0;
    if (p[0] < bbox[0]) code |= 1; // left
    else if (p[0] > bbox[2]) code |= 2; // right
    if (p[1] < bbox[1]) code |= 4; // bottom
    else if (p[1] > bbox[3]) code |= 8; // top
    return code;
}
var lineclip$1 = /*@__PURE__*/ getDefaultExportFromCjs(lineclip_1);
var minx = Infinity, miny = Infinity, maxx = -Infinity, maxy = -Infinity;
function getDefaultBBOX() {
    return [
        minx,
        miny,
        maxx,
        maxy
    ];
}
var BBOX_TEMP = getDefaultBBOX();
function resetBBOX(bbox) {
    bbox[0] = minx;
    bbox[1] = miny;
    bbox[2] = maxx;
    bbox[3] = maxy;
}
function pointsBBOX(points, out) {
    if (!points) return;
    if (Array.isArray(points[0])) for(var i = 0, len = points.length; i < len; i++)pointsBBOX(points[i], out);
    else if (Array.isArray(points)) for(var _i = 0, _len = points.length; _i < _len; _i++){
        var { x: x, y: y } = points[_i];
        out[0] = Math.min(x, out[0]);
        out[1] = Math.min(y, out[1]);
        out[2] = Math.max(x, out[2]);
        out[3] = Math.max(y, out[3]);
    }
    else {
        var { x: _x, y: _y } = points;
        out[0] = Math.min(_x, out[0]);
        out[1] = Math.min(_y, out[1]);
        out[2] = Math.max(_x, out[2]);
        out[3] = Math.max(_y, out[3]);
    }
}
function setBBOX(bbox, x1, y1, x2, y2) {
    if (x1 !== 0 && !x1) return;
    if (Array.isArray(x1)) {
        y1 = x1[1];
        x2 = x1[2];
        y2 = x1[3];
        x1 = x1[0];
    }
    bbox[0] = Math.min(x1, bbox[0]);
    bbox[1] = Math.min(y1, bbox[1]);
    bbox[2] = Math.max(x2, bbox[2]);
    bbox[3] = Math.max(y2, bbox[3]);
}
function validateBBOX(bbox) {
    return bbox && bbox[0] !== Infinity && bbox[0] !== undefined;
}
function bufferBBOX(bbox, bufferSize = 0) {
    bbox[0] -= bufferSize;
    bbox[1] -= bufferSize;
    bbox[2] += bufferSize;
    bbox[3] += bufferSize;
}
function bboxIntersect(bbox1, bbox2) {
    if (bbox1[2] < bbox2[0]) return false;
    if (bbox1[1] > bbox2[3]) return false;
    if (bbox1[0] > bbox2[2]) return false;
    if (bbox1[3] < bbox2[1]) return false;
    return true;
}
function bboxInBBOX(bbox1, bbox2) {
    var [x1, y1, x2, y2] = bbox1;
    return x1 >= bbox2[0] && x2 <= bbox2[2] && y1 >= bbox2[1] && y2 <= bbox2[3];
}
function bboxInMask(bbox, maskGeoJSON) {
    var maskBBOX = maskGeoJSON.bbox;
    if (!maskBBOX) {
        console.error('maskGeoJSON bbox is null:', maskGeoJSON);
        return false;
    }
    if (!bboxIntersect(maskBBOX, bbox)) return false;
    else {
        var geometry = maskGeoJSON.geometry;
        if (!geometry) {
            console.error('maskGeoJSON is error,not find geometry.', maskGeoJSON);
            return false;
        }
        var { coordinates: coordinates } = geometry;
        var type = geometry.type;
        if (type === 'Polygon') coordinates = [
            coordinates
        ];
        for(var i = 0, len = coordinates.length; i < len; i++){
            var rings = coordinates[i];
            var outRing = rings[0];
            var result = lineclip$1.polygon(outRing, bbox);
            if (result.length > 0) {
                var _minx = Infinity, _maxx = -Infinity, _miny = Infinity, _maxy = -Infinity;
                for(var j = 0, len1 = result.length; j < len1; j++){
                    var [x, y] = result[j];
                    _minx = Math.min(x, _minx);
                    _miny = Math.min(y, _miny);
                    _maxx = Math.max(x, _maxx);
                    _maxy = Math.max(y, _maxy);
                }
                if (_minx !== _maxx && _miny !== _maxy) return true;
            }
        }
        return false;
    }
}
var bbox = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BBOX_TEMP: BBOX_TEMP,
    bboxInBBOX: bboxInBBOX,
    bboxInMask: bboxInMask,
    bboxIntersect: bboxIntersect,
    bufferBBOX: bufferBBOX,
    getDefaultBBOX: getDefaultBBOX,
    pointsBBOX: pointsBBOX,
    resetBBOX: resetBBOX,
    setBBOX: setBBOX,
    validateBBOX: validateBBOX
});
var ResourceCacheMap = function() {
    function ResourceCacheMap() {
        this.resources = new Map();
        this._errors = new Map();
    }
    var _proto = ResourceCacheMap.prototype;
    _proto.addResource = function addResource(url, img) {
        var _this = this;
        var imgUrl = this._getImgUrl(url);
        this.resources.set(imgUrl, {
            image: img,
            width: +url[1],
            height: +url[2],
            refCnt: 0
        });
        if (img && img.width && img.height && !img.close && Browser$1.imageBitMap && !Browser$1.safari && !Browser$1.iosWeixin) {
            if (img.src && isSVG(img.src)) return;
            createImageBitmap(img).then(function(imageBitmap) {
                if (!_this.resources.has(imgUrl)) return;
                _this.resources.get(imgUrl).image = imageBitmap;
            });
        }
    };
    _proto.isResourceLoaded = function isResourceLoaded(url, checkSVG) {
        if (!url) return false;
        var imgUrl = this._getImgUrl(url);
        if (this._errors.has(imgUrl)) return true;
        var img = this.resources.get(imgUrl);
        if (!img) return false;
        if (checkSVG && isSVG(url[0]) && (+url[1] > img.width || +url[2] > img.height)) return false;
        return true;
    };
    _proto.login = function login(url) {
        var res = this.resources.get(url);
        if (res) res.refCnt++;
    };
    _proto.logout = function logout(url) {
        var res = this.resources.get(url);
        if (res && res.refCnt-- <= 0) {
            if (res.image && res.image.close) res.image.close();
            this.resources["delete"](url);
        }
    };
    _proto.getImage = function getImage(url) {
        var imgUrl = this._getImgUrl(url);
        if (!this.isResourceLoaded(url) || this._errors.has(imgUrl)) return null;
        return this.resources.get(imgUrl).image;
    };
    _proto.markErrorResource = function markErrorResource(url) {
        var imgUrl = this._getImgUrl(url);
        this._errors.set(imgUrl, 1);
    };
    _proto.merge = function merge(res) {
        var _this2 = this;
        if (!res) return this;
        var otherResource = res.resources;
        if (otherResource) otherResource.forEach(function(value, key) {
            var img = value;
            _this2.addResource([
                key,
                img.width,
                img.height
            ], img.image);
        });
        return this;
    };
    _proto.forEach = function forEach(fn) {
        if (!this.resources) return this;
        this.resources.forEach(function(value, key) {
            fn(key, value);
        });
        return this;
    };
    _proto._getImgUrl = function _getImgUrl(url) {
        if (isImageBitMap(url)) return url;
        if (!Array.isArray(url)) return url;
        return url[0];
    };
    _proto.remove = function remove() {
        if (!this.resources) return this;
        this.resources.forEach(function(value) {
            if (value && value.image && value.image.close) value.image.close();
        });
        this.resources.clear();
        return this;
    };
    return ResourceCacheMap;
}();
var ResourceCache = function() {
    function ResourceCache() {
        this.resources = {};
        this._errors = {};
    }
    var _proto2 = ResourceCache.prototype;
    _proto2.addResource = function addResource(url, img) {
        var _this3 = this;
        this.resources[url[0]] = {
            image: img,
            width: +url[1],
            height: +url[2],
            refCnt: 0
        };
        if (img && img.width && img.height && !img.close && Browser$1.imageBitMap && !Browser$1.safari && !Browser$1.iosWeixin) {
            if (img.src && isSVG(img.src)) return;
            createImageBitmap(img).then(function(imageBitmap) {
                if (!_this3.resources[url[0]]) return;
                _this3.resources[url[0]].image = imageBitmap;
            });
        }
    };
    _proto2.isResourceLoaded = function isResourceLoaded(url, checkSVG) {
        if (!url) return false;
        var imgUrl = this._getImgUrl(url);
        if (this._errors[imgUrl]) return true;
        var img = this.resources[imgUrl];
        if (!img) return false;
        if (checkSVG && isSVG(url[0]) && (+url[1] > img.width || +url[2] > img.height)) return false;
        return true;
    };
    _proto2.login = function login(url) {
        var res = this.resources[url];
        if (res) res.refCnt++;
    };
    _proto2.logout = function logout(url) {
        var res = this.resources[url];
        if (res && res.refCnt-- <= 0) {
            if (res.image && res.image.close) res.image.close();
            delete this.resources[url];
        }
    };
    _proto2.getImage = function getImage(url) {
        var imgUrl = this._getImgUrl(url);
        if (!this.isResourceLoaded(url) || this._errors[imgUrl]) return null;
        return this.resources[imgUrl].image;
    };
    _proto2.markErrorResource = function markErrorResource(url) {
        this._errors[this._getImgUrl(url)] = 1;
    };
    _proto2.merge = function merge(res) {
        if (!res) return this;
        for(var p in res.resources){
            var img = res.resources[p];
            this.addResource([
                p,
                img.width,
                img.height
            ], img.image);
        }
        return this;
    };
    _proto2.forEach = function forEach(fn) {
        if (!this.resources) return this;
        for(var p in this.resources)if (hasOwn(this.resources, p)) fn(p, this.resources[p]);
        return this;
    };
    _proto2._getImgUrl = function _getImgUrl(url) {
        if (!Array.isArray(url)) return url;
        return url[0];
    };
    _proto2.remove = function remove() {
        for(var p in this.resources){
            var res = this.resources[p];
            if (res && res.image && res.image.close) res.image.close();
        }
        this.resources = {};
    };
    return ResourceCache;
}();
function getResouceCacheInstance() {
    if (Browser$1.decodeImageInWorker) return new ResourceCacheMap();
    return new ResourceCache();
}
function set(out, x, y, z) {
    out[0] = x;
    out[1] = y;
    out[2] = z;
    return out;
}
function add(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    return out;
}
function subtract(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    return out;
}
function sub(out, a, b) {
    return subtract(out, a, b);
}
function copy(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    return out;
}
function length(a) {
    var x = a[0], y = a[1], z = a[2];
    return Math.sqrt(x * x + y * y + z * z);
}
function normalize(out, a) {
    var x = a[0], y = a[1], z = a[2];
    var len = x * x + y * y + z * z;
    if (len > 0) {
        len = 1 / Math.sqrt(len);
        out[0] = a[0] * len;
        out[1] = a[1] * len;
        out[2] = a[2] * len;
    }
    return out;
}
function dot(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}
function scale(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    return out;
}
function cross(out, a, b) {
    var ax = a[0], ay = a[1], az = a[2], bx = b[0], by = b[1], bz = b[2];
    out[0] = ay * bz - az * by;
    out[1] = az * bx - ax * bz;
    out[2] = ax * by - ay * bx;
    return out;
}
function distance(a, b) {
    var x = b[0] - a[0];
    var y = b[1] - a[1];
    var z = b[2] - a[2];
    return Math.hypot ? Math.hypot(x, y, z) : hypot$1(x, y, z);
}
function transformMat4(out, a, m) {
    var x = a[0], y = a[1], z = a[2];
    var w = m[3] * x + m[7] * y + m[11] * z + m[15];
    w = w || 1.0;
    out[0] = (m[0] * x + m[4] * y + m[8] * z + m[12]) / w;
    out[1] = (m[1] * x + m[5] * y + m[9] * z + m[13]) / w;
    out[2] = (m[2] * x + m[6] * y + m[10] * z + m[14]) / w;
    return out;
}
function hypot$1(...args) {
    var y = 0;
    var i = args.length;
    while(i--)y += args[i] * args[i];
    return Math.sqrt(y);
}
function angle(a, b) {
    normalize(a, a);
    normalize(b, b);
    var cosine = dot(a, b);
    if (cosine > 1.0) return 0;
    else if (cosine < -1) return Math.PI;
    else return Math.acos(cosine);
}
var Plane = function() {
    function Plane(normal, constant) {
        this.normal = normal;
        this.constant = constant;
    }
    var _proto = Plane.prototype;
    _proto.distanceToPoint = function distanceToPoint(point) {
        return dot(this.normal, point) + this.constant;
    };
    return Plane;
}();
var scaledDir = [
    0,
    0,
    0
];
var _edge1 = [
    0,
    0,
    0
];
var _edge2 = [
    0,
    0,
    0
];
var _normal = [
    0,
    0,
    0
];
var _diff = [
    0,
    0,
    0
];
var Ground = new Plane([
    0,
    0,
    1
], 0);
var Ray = function() {
    function Ray(from, to) {
        this.setFromTo(from, to);
    }
    var _proto = Ray.prototype;
    _proto.setFromTo = function setFromTo(from, to) {
        this.origin = from;
        var direction = this.direction || [
            0,
            0,
            0
        ];
        this.direction = normalize(direction, sub(direction, to, from));
    };
    _proto.distanceToPlane = function distanceToPlane(plane) {
        var denominator = dot(plane.normal, this.direction);
        if (denominator === 0) {
            if (plane.distanceToPoint(this.origin) === 0) return 0;
            return null;
        }
        var t = -(dot(this.origin, plane.normal) + plane.constant) / denominator;
        return t >= 0 ? t : null;
    };
    _proto.intersectGround = function intersectGround(target) {
        return this.intersectPlane(Ground, target);
    };
    _proto.distanceToGround = function distanceToGround() {
        return this.distanceToPlane(Ground);
    };
    _proto.intersectPlane = function intersectPlane(plane, target) {
        var t = this.distanceToPlane(plane);
        if (t === null) return null;
        return this.at(t, target);
    };
    _proto.intersectBox = function intersectBox(box, target) {
        var tmin, tmax, tymin, tymax, tzmin, tzmax;
        var invdirx = 1 / this.direction[0], invdiry = 1 / this.direction[1], invdirz = 1 / this.direction[2];
        var origin = this.origin;
        if (invdirx >= 0) {
            tmin = (box[0][0] - origin[0]) * invdirx;
            tmax = (box[1][0] - origin[0]) * invdirx;
        } else {
            tmin = (box[1][0] - origin[0]) * invdirx;
            tmax = (box[0][0] - origin[0]) * invdirx;
        }
        if (invdiry >= 0) {
            tymin = (box[0][1] - origin[1]) * invdiry;
            tymax = (box[1][1] - origin[1]) * invdiry;
        } else {
            tymin = (box[1][1] - origin[1]) * invdiry;
            tymax = (box[0][1] - origin[1]) * invdiry;
        }
        if (tmin > tymax || tymin > tmax) return null;
        if (tymin > tmin || isNaN(tmin)) tmin = tymin;
        if (tymax < tmax || isNaN(tmax)) tmax = tymax;
        if (invdirz >= 0) {
            tzmin = (box[0][2] - origin[2]) * invdirz;
            tzmax = (box[1][2] - origin[2]) * invdirz;
        } else {
            tzmin = (box[1][2] - origin[2]) * invdirz;
            tzmax = (box[0][2] - origin[2]) * invdirz;
        }
        if (tmin > tzmax || tzmin > tmax) return null;
        if (tzmin > tmin || tmin !== tmin) tmin = tzmin;
        if (tzmax < tmax || tmax !== tmax) tmax = tzmax;
        if (tmax < 0) return null;
        return this.at(tmin >= 0 ? tmin : tmax, target);
    };
    _proto.intersectTriangle = function intersectTriangle(a, b, c, backfaceCulling, target) {
        sub(_edge1, b, a);
        sub(_edge2, c, a);
        cross(_normal, _edge1, _edge2);
        var DdN = dot(this.direction, _normal);
        var sign;
        if (DdN > 0) {
            if (backfaceCulling) return null;
            sign = 1;
        } else if (DdN < 0) {
            sign = -1;
            DdN = -DdN;
        } else return null;
        sub(_diff, this.origin, a);
        cross(_edge2, _diff, _edge2);
        var DdQxE2 = sign * dot(this.direction, _edge2);
        if (DdQxE2 < 0) return null;
        cross(_edge1, _edge1, _diff);
        var DdE1xQ = sign * dot(this.direction, _edge1);
        if (DdE1xQ < 0) return null;
        if (DdQxE2 + DdE1xQ > DdN) return null;
        var QdN = -sign * dot(_diff, _normal);
        if (QdN < 0) return null;
        return this.at(QdN / DdN, target);
    };
    _proto.at = function at(t, target) {
        copy(target, this.origin);
        return add(target, target, scale(scaledDir, this.direction, t));
    };
    return Ray;
}();
var index$5 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Plane: Plane,
    Ray: Ray
});
var imageFetchWorkerKey = 'core-fetch-image';
var globalWorkerPool$1;
function setWorkerPool(pool) {
    globalWorkerPool$1 = pool;
}
function getWorkerPool() {
    return globalWorkerPool$1;
}
var workersCreated = false;
function setWorkersCreated() {
    workersCreated = true;
}
function workersHasCreated() {
    return workersCreated;
}
var ADAPTER_CREATED_LIST = [];
function adapterHasCreated(workerKey) {
    return ADAPTER_CREATED_LIST.indexOf(workerKey) > -1;
}
function pushAdapterCreated(workerKey) {
    if (!adapterHasCreated(workerKey)) ADAPTER_CREATED_LIST.push(workerKey);
}
var adapters = {};
function registerWorkerAdapter(workerKey, adapter) {
    adapters[workerKey] = adapter;
}
var header = "\n    var adapters = {};\n    // Dynamic Create Adapter\n    function createAdapter(key,code){\n        if(adapters[key]||!code){\n            return;\n        }\n        var func=new Function('exports',code+'(exports)');\n        var workerExports={};\n        func(workerExports,self);\n        adapters[key]=workerExports;\n        workerExports.initialize && workerExports.initialize(self);\n\n    }\n    onmessage = function (msg) {\n        msg = msg.data;\n        //createAdapter\n        if (msg.messageType === 'createAdapter') {\n           var key=msg.key;\n           var code=msg.code;\n           createAdapter(key,code);\n           postMessage({adapterName:key});\n           return;\n        }\n        // postMessage when main thread idle\n        if(msg.messageType==='idle'){\n            var messageRatio = msg.messageRatio;\n            handleMessageQueue(messageRatio);\n            return;\n        }\n        if (msg.messageType === 'batch') {\n            const messages = msg.messages;\n            if (messages) {\n                for (let i = 0; i < messages.length; i++) {\n                    dispatch(messages[i]);\n                }\n            }\n        } else {\n            dispatch(msg);\n        }\n    };\n\n    function dispatch(msg) {\n        var workerKey = msg.workerKey;\n        var adapter = adapters[workerKey];\n        if (!adapter) {\n            post(msg.callback, 'Unregistered worker adapters for ' + workerKey);\n            return;\n        }\n        try {\n            adapter.onmessage(msg, wrap(msg.callback));\n        } catch (err) {\n            post(msg.callback, workerKey + ':' + err.message);\n            console.error(err);\n            throw err;\n        }\n    }\n\n    var messageResultQueue = [];\n\n    function handleMessageQueue(messageRatio){\n       if(messageResultQueue.length===0){\n          return;\n       }\n       var count = Math.ceil((messageRatio || 1) * messageResultQueue.length);\n       var queues = messageResultQueue.slice(0, count);\n       queues.forEach(function(queue){\n          post(queue.callback,queue.err,queue.data,queue.buffers);\n       });\n       messageResultQueue=messageResultQueue.slice(count, Infinity);\n    }\n\n    function post(callback, err, data, buffers) {\n        var msg = {\n            callback : callback\n        };\n        if (err) {\n            msg.error = err;\n        } else {\n            msg.data = data;\n        }\n        if (buffers && buffers.length > 0) {\n            postMessage(msg, buffers);\n        } else {\n            postMessage(msg);\n        }\n    }\n\n    function joinQueue(callback,err,data,buffers){\n        messageResultQueue.push({\n            callback:callback,\n            err:err,\n            data:data,\n            buffers:buffers\n        });\n    }\n\n    function wrap(callback) {\n        return function (err, data, buffers) {\n            joinQueue(callback, err, data, buffers);\n        };\n    }\n    var workerExports;\n";
var footer = "\n    workerExports = null;\n";
function compileWorkerSource() {
    var source = header;
    for(var p in adapters){
        var adapter = adapters[p];
        pushAdapterCreated(p);
        if (isFunction(adapter)) {
            if (adapter.length === 0) adapter = adapter();
        }
        source += "\n    workerExports = {};\n    (" + adapter + ")(workerExports, self);\n    adapters['" + p + "'] = workerExports";
        source += "\n    workerExports.initialize && workerExports.initialize(self);\n        ";
    }
    source += footer;
    return source;
}
var url;
function getWorkerSourcePath() {
    if (typeof window === 'undefined') return null;
    if (!url) {
        var source = compileWorkerSource();
        url = window.URL.createObjectURL(new Blob([
            source
        ], {
            type: 'text/javascript'
        }));
        adapters = {};
    }
    return url;
}
function createAdapter(key, cb) {
    if (!adapters[key]) {
        console.error("not find " + key + " adapter");
        return;
    }
    var adapter = adapters[key];
    if (isFunction(adapter)) {
        if (adapter.length === 0) adapter = adapter();
    }
    adapter = "(" + adapter + ")";
    var workerPool = getWorkerPool();
    if (!workerPool) return;
    var workers = workerPool.workers || [];
    if (workers.length === 0) console.error('workerpool workers count is 0');
    var count = 0;
    var _messageCB = function messageCB(msg) {
        msg = msg.data || {};
        if (msg.adapterName === key) {
            count++;
            if (count === workers.length) {
                workers.forEach(function(worker) {
                    worker.removeEventListener('message', _messageCB);
                });
                delete adapters[key];
                cb();
            }
        }
    };
    workers.forEach(function(worker) {
        worker.addEventListener('message', _messageCB);
        worker.postMessage({
            key: key,
            code: adapter,
            messageType: 'createAdapter'
        });
    });
}
var hardwareConcurrency = typeof window !== 'undefined' ? window.navigator.hardwareConcurrency || 4 : 0;
var hardwareWorkerCount = Math.max(Math.floor(hardwareConcurrency / 2), 1);
var MessageBatch = function() {
    function MessageBatch(limit = 50) {
        this._limit = limit;
        this._messages = [];
        this.buffers = [];
    }
    var _proto = MessageBatch.prototype;
    _proto.addMessage = function addMessage(msg, buffers) {
        this._messages.push(msg);
        if (!Array.isArray(buffers)) return;
        for(var i = 0; i < buffers.length; i++)if (this.buffers.indexOf(buffers[i]) < 0) this.buffers.push(buffers[i]);
    };
    _proto.isFull = function isFull() {
        return this._messages.length >= this._limit;
    };
    _proto.getMessage = function getMessage() {
        return {
            messageType: 'batch',
            messages: this._messages
        };
    };
    return MessageBatch;
}();
var WorkerPool = function() {
    function WorkerPool() {
        this.active = {};
        this.workerCount = typeof window !== 'undefined' ? GlobalConfig.workerCount || hardwareWorkerCount : 0;
        this._messages = [];
        this._messageBuffers = [];
    }
    var _proto2 = WorkerPool.prototype;
    _proto2.acquire = function acquire(id) {
        if (!this.workers) {
            this.workers = [];
            var url = getWorkerSourcePath();
            for(var i = 0; i < this.workerCount; i++){
                var worker = new Worker(url);
                worker.id = i;
                this.workers.push(worker);
            }
            URL.revokeObjectURL(url);
            setWorkersCreated();
        }
        this.active[id] = true;
        return this.workers.slice();
    };
    _proto2.release = function release(id) {
        delete this.active[id];
        if (Object.keys(this.active).length === 0) {
            this.workers.forEach(function(w) {
                w.terminate();
            });
            this.workers = null;
        }
    };
    _proto2.addMessage = function addMessage(workerId, data, buffers) {
        var batches = this._messages[workerId];
        if (!batches || !batches.length) batches = this._messages[workerId] = [
            new MessageBatch()
        ];
        var batch = batches[batches.length - 1];
        if (batch.isFull()) {
            batch = new MessageBatch();
            this._messages[workerId].push(batch);
        }
        batch.addMessage(data, buffers);
    };
    _proto2.commit = function commit() {
        if (!this.workers) return;
        if (this._messages.length) for(var i = 0; i < this._messages.length; i++){
            if (!this._messages[i] || !this._messages[i].length) continue;
            var batch = this._messages[i].shift();
            this.workers[i].postMessage(batch.getMessage(), batch.buffers);
        }
    };
    _proto2.getWorkers = function getWorkers() {
        return this.workers || [];
    };
    _proto2.broadcastIdleMessage = function broadcastIdleMessage(messageRatio) {
        var workers = this.getWorkers();
        workers.forEach(function(worker) {
            worker.postMessage({
                messageType: 'idle',
                messageRatio: messageRatio
            });
        });
        return this;
    };
    return WorkerPool;
}();
var globalWorkerPool;
function getGlobalWorkerPool() {
    if (!globalWorkerPool) {
        globalWorkerPool = new WorkerPool();
        setWorkerPool(globalWorkerPool);
    }
    return globalWorkerPool;
}
var tasks = [];
var loopHooks = [];
function runTaskAsync(task) {
    startTasks();
    var promise = new Promise(function(resolve, reject) {
        if (!task) {
            reject(new Error('task is null'));
            return;
        }
        if (isFunction(task)) task = {
            count: 1,
            run: task
        };
        if (!task.run) {
            reject(new Error('task.run is null'));
            return;
        }
        if (isNil(task.count)) task.count = 1;
        task.count = Math.ceil(task.count);
        if (!isNumber(task.count)) {
            reject(new Error('task.count is not number'));
            return;
        }
        var taskItem = task;
        taskItem.results = [];
        tasks.push(taskItem);
        taskItem.resolve = resolve;
    });
    return promise;
}
function executeMicroTasks() {
    if (tasks.length === 0) return;
    var runingTasks = [], endTasks = [];
    var len = tasks.length;
    for(var i = 0; i < len; i++){
        var task = tasks[i];
        task.count--;
        if (task.count === -1) endTasks.push(task);
        else {
            runingTasks.push(task);
            var result = task.run();
            task.results.push(result);
        }
    }
    tasks = runingTasks;
    len = endTasks.length;
    for(var _i = 0; _i < len; _i++){
        var _task = endTasks[_i];
        if (_task.resolve) _task.resolve(_task.results);
    }
}
function loop(isBusy) {
    var messageRatio = GlobalConfig.messagePostRatioPerWorker * (isBusy ? 0.5 : 1);
    getGlobalWorkerPool().commit();
    getGlobalWorkerPool().broadcastIdleMessage(messageRatio);
    executeMicroTasks();
    loopHooks.forEach(function(func) {
        func();
    });
}
var idleCallTime = now();
function idleFrameLoop() {
    loop();
    idleCallTime = now();
    requestIdleCallback(idleFrameLoop);
}
function animFrameLoop() {
    if (Browser$1.requestIdleCallback) {
        var { idleForceTimeThreshold: idleForceTimeThreshold, idleLog: idleLog } = GlobalConfig;
        var time = now();
        if (time - idleCallTime > idleForceTimeThreshold) {
            loop(true);
            idleCallTime = now();
            if (idleLog) console.warn("did not apply for availability, forced run idle");
        }
    } else loop();
    requestAnimFrame(animFrameLoop);
}
var started = false;
function startTasks() {
    if (started) return;
    started = true;
    if (Browser$1.requestIdleCallback) requestIdleCallback(idleFrameLoop);
    requestAnimFrame(animFrameLoop);
}
function pushLoopHook(func) {
    if (loopHooks.indexOf(func) > -1) return;
    if (isFunction(func)) loopHooks.push(func);
}
var MicroTask = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    pushLoopHook: pushLoopHook,
    runTaskAsync: runTaskAsync,
    startTasks: startTasks
});
var LRUCache = function() {
    function LRUCache(max, onRemove) {
        var nullOnRemove = function nullOnRemove() {};
        this.max = max;
        this.onRemove = onRemove || nullOnRemove;
        this.reset();
    }
    var _proto = LRUCache.prototype;
    _proto.reset = function reset() {
        if (this.data) {
            var values = this.data.values();
            for(var _iterator = _createForOfIteratorHelperLoose(values), _step; !(_step = _iterator()).done;){
                var p = _step.value;
                this.onRemove(p);
            }
        }
        this.data = new Map();
        return this;
    };
    _proto.clear = function clear() {
        this.reset();
        delete this.onRemove;
    };
    _proto.add = function add(key, data) {
        if (!data) return this;
        if (this.has(key)) {
            this.data["delete"](key);
            this.data.set(key, data);
        } else this.data.set(key, data);
        return this;
    };
    _proto.keys = function keys() {
        var keys = new Array(this.data.size);
        var i = 0;
        var iterator = this.data.keys();
        for(var _iterator2 = _createForOfIteratorHelperLoose(iterator), _step2; !(_step2 = _iterator2()).done;){
            var k = _step2.value;
            keys[i++] = k;
        }
        return keys;
    };
    _proto.shrink = function shrink() {
        var iterator = this.data.keys();
        var item = iterator.next();
        while(this.data.size > this.max){
            var removedData = this.getAndRemove(item.value);
            if (removedData) this.onRemove(removedData);
            item = iterator.next();
        }
    };
    _proto.has = function has(key) {
        return this.data.has(key);
    };
    _proto.getAndRemove = function getAndRemove(key) {
        if (!this.has(key)) return null;
        var data = this.data.get(key);
        this.data["delete"](key);
        return data;
    };
    _proto.get = function get(key) {
        if (!this.has(key)) return null;
        var data = this.data.get(key);
        return data;
    };
    _proto.remove = function remove(key) {
        if (!this.has(key)) return this;
        var data = this.data.get(key);
        this.data["delete"](key);
        this.onRemove(data);
        return this;
    };
    _proto.setMaxSize = function setMaxSize(max) {
        this.max = max;
        if (this.data.size > this.max) this.shrink();
        return this;
    };
    return LRUCache;
}();
var rbush$2 = {
    exports: {}
};
var quickselect$1 = {
    exports: {}
};
(function(module, exports) {
    (function(global1, factory) {
        module.exports = factory();
    })(commonjsGlobal, function() {
        function quickselect(arr, k, left, right, compare) {
            quickselectStep(arr, k, left || 0, right || arr.length - 1, compare || defaultCompare);
        }
        function quickselectStep(arr, k, left, right, compare) {
            while(right > left){
                if (right - left > 600) {
                    var n = right - left + 1;
                    var m = k - left + 1;
                    var z = Math.log(n);
                    var s = 0.5 * Math.exp(2 * z / 3);
                    var sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
                    var newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
                    var newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
                    quickselectStep(arr, k, newLeft, newRight, compare);
                }
                var t = arr[k];
                var i = left;
                var j = right;
                swap(arr, left, k);
                if (compare(arr[right], t) > 0) swap(arr, left, right);
                while(i < j){
                    swap(arr, i, j);
                    i++;
                    j--;
                    while(compare(arr[i], t) < 0)i++;
                    while(compare(arr[j], t) > 0)j--;
                }
                if (compare(arr[left], t) === 0) swap(arr, left, j);
                else {
                    j++;
                    swap(arr, j, right);
                }
                if (j <= k) left = j + 1;
                if (k <= j) right = j - 1;
            }
        }
        function swap(arr, i, j) {
            var tmp = arr[i];
            arr[i] = arr[j];
            arr[j] = tmp;
        }
        function defaultCompare(a, b) {
            return a < b ? -1 : a > b ? 1 : 0;
        }
        return quickselect;
    });
})(quickselect$1);
var quickselectExports = quickselect$1.exports;
rbush$2.exports = rbush;
rbush$2.exports.default = rbush;
var quickselect = quickselectExports;
function rbush(maxEntries, format) {
    if (!(this instanceof rbush)) return new rbush(maxEntries, format);
    // max entries in a node is 9 by default; min node fill is 40% for best performance
    this._maxEntries = Math.max(4, maxEntries || 9);
    this._minEntries = Math.max(2, Math.ceil(this._maxEntries * 0.4));
    if (format) this._initFormat(format);
    this.clear();
}
rbush.prototype = {
    all: function() {
        return this._all(this.data, []);
    },
    search: function(bbox) {
        var node = this.data, result = [], toBBox = this.toBBox;
        if (!intersects(bbox, node)) return result;
        var nodesToSearch = [], i, len, child, childBBox;
        while(node){
            for(i = 0, len = node.children.length; i < len; i++){
                child = node.children[i];
                childBBox = node.leaf ? toBBox(child) : child;
                if (intersects(bbox, childBBox)) {
                    if (node.leaf) result.push(child);
                    else if (contains(bbox, childBBox)) this._all(child, result);
                    else nodesToSearch.push(child);
                }
            }
            node = nodesToSearch.pop();
        }
        return result;
    },
    collides: function(bbox) {
        var node = this.data, toBBox = this.toBBox;
        if (!intersects(bbox, node)) return false;
        var nodesToSearch = [], i, len, child, childBBox;
        while(node){
            for(i = 0, len = node.children.length; i < len; i++){
                child = node.children[i];
                childBBox = node.leaf ? toBBox(child) : child;
                if (intersects(bbox, childBBox)) {
                    if (node.leaf || contains(bbox, childBBox)) return true;
                    nodesToSearch.push(child);
                }
            }
            node = nodesToSearch.pop();
        }
        return false;
    },
    load: function(data) {
        if (!(data && data.length)) return this;
        if (data.length < this._minEntries) {
            for(var i = 0, len = data.length; i < len; i++)this.insert(data[i]);
            return this;
        }
        // recursively build the tree with the given data from scratch using OMT algorithm
        var node = this._build(data.slice(), 0, data.length - 1, 0);
        if (!this.data.children.length) // save as is if tree is empty
        this.data = node;
        else if (this.data.height === node.height) // split root if trees have the same height
        this._splitRoot(this.data, node);
        else {
            if (this.data.height < node.height) {
                // swap trees if inserted one is bigger
                var tmpNode = this.data;
                this.data = node;
                node = tmpNode;
            }
            // insert the small tree into the large tree at appropriate level
            this._insert(node, this.data.height - node.height - 1, true);
        }
        return this;
    },
    insert: function(item) {
        if (item) this._insert(item, this.data.height - 1);
        return this;
    },
    clear: function() {
        this.data = createNode([]);
        return this;
    },
    remove: function(item, equalsFn) {
        if (!item) return this;
        var node = this.data, bbox = this.toBBox(item), path = [], indexes = [], i, parent, index, goingUp;
        // depth-first iterative tree traversal
        while(node || path.length){
            if (!node) {
                node = path.pop();
                parent = path[path.length - 1];
                i = indexes.pop();
                goingUp = true;
            }
            if (node.leaf) {
                index = findItem(item, node.children, equalsFn);
                if (index !== -1) {
                    // item found, remove the item and condense tree upwards
                    node.children.splice(index, 1);
                    path.push(node);
                    this._condense(path);
                    return this;
                }
            }
            if (!goingUp && !node.leaf && contains(node, bbox)) {
                path.push(node);
                indexes.push(i);
                i = 0;
                parent = node;
                node = node.children[0];
            } else if (parent) {
                i++;
                node = parent.children[i];
                goingUp = false;
            } else node = null; // nothing found
        }
        return this;
    },
    toBBox: function(item) {
        return item;
    },
    compareMinX: compareNodeMinX,
    compareMinY: compareNodeMinY,
    toJSON: function() {
        return this.data;
    },
    fromJSON: function(data) {
        this.data = data;
        return this;
    },
    _all: function(node, result) {
        var nodesToSearch = [];
        while(node){
            if (node.leaf) result.push.apply(result, node.children);
            else nodesToSearch.push.apply(nodesToSearch, node.children);
            node = nodesToSearch.pop();
        }
        return result;
    },
    _build: function(items, left, right, height) {
        var N = right - left + 1, M = this._maxEntries, node;
        if (N <= M) {
            // reached leaf level; return leaf
            node = createNode(items.slice(left, right + 1));
            calcBBox(node, this.toBBox);
            return node;
        }
        if (!height) {
            // target height of the bulk-loaded tree
            height = Math.ceil(Math.log(N) / Math.log(M));
            // target number of root entries to maximize storage utilization
            M = Math.ceil(N / Math.pow(M, height - 1));
        }
        node = createNode([]);
        node.leaf = false;
        node.height = height;
        // split the items into M mostly square tiles
        var N2 = Math.ceil(N / M), N1 = N2 * Math.ceil(Math.sqrt(M)), i, j, right2, right3;
        multiSelect(items, left, right, N1, this.compareMinX);
        for(i = left; i <= right; i += N1){
            right2 = Math.min(i + N1 - 1, right);
            multiSelect(items, i, right2, N2, this.compareMinY);
            for(j = i; j <= right2; j += N2){
                right3 = Math.min(j + N2 - 1, right2);
                // pack each entry recursively
                node.children.push(this._build(items, j, right3, height - 1));
            }
        }
        calcBBox(node, this.toBBox);
        return node;
    },
    _chooseSubtree: function(bbox, node, level, path) {
        var i, len, child, targetNode, area, enlargement, minArea, minEnlargement;
        while(true){
            path.push(node);
            if (node.leaf || path.length - 1 === level) break;
            minArea = minEnlargement = Infinity;
            for(i = 0, len = node.children.length; i < len; i++){
                child = node.children[i];
                area = bboxArea(child);
                enlargement = enlargedArea(bbox, child) - area;
                // choose entry with the least area enlargement
                if (enlargement < minEnlargement) {
                    minEnlargement = enlargement;
                    minArea = area < minArea ? area : minArea;
                    targetNode = child;
                } else if (enlargement === minEnlargement) // otherwise choose one with the smallest area
                {
                    if (area < minArea) {
                        minArea = area;
                        targetNode = child;
                    }
                }
            }
            node = targetNode || node.children[0];
        }
        return node;
    },
    _insert: function(item, level, isNode) {
        var toBBox = this.toBBox, bbox = isNode ? item : toBBox(item), insertPath = [];
        // find the best node for accommodating the item, saving all nodes along the path too
        var node = this._chooseSubtree(bbox, this.data, level, insertPath);
        // put the item into the node
        node.children.push(item);
        extend(node, bbox);
        // split on node overflow; propagate upwards if necessary
        while(level >= 0){
            if (insertPath[level].children.length > this._maxEntries) {
                this._split(insertPath, level);
                level--;
            } else break;
        }
        // adjust bboxes along the insertion path
        this._adjustParentBBoxes(bbox, insertPath, level);
    },
    // split overflowed node into two
    _split: function(insertPath, level) {
        var node = insertPath[level], M = node.children.length, m = this._minEntries;
        this._chooseSplitAxis(node, m, M);
        var splitIndex = this._chooseSplitIndex(node, m, M);
        var newNode = createNode(node.children.splice(splitIndex, node.children.length - splitIndex));
        newNode.height = node.height;
        newNode.leaf = node.leaf;
        calcBBox(node, this.toBBox);
        calcBBox(newNode, this.toBBox);
        if (level) insertPath[level - 1].children.push(newNode);
        else this._splitRoot(node, newNode);
    },
    _splitRoot: function(node, newNode) {
        // split root node
        this.data = createNode([
            node,
            newNode
        ]);
        this.data.height = node.height + 1;
        this.data.leaf = false;
        calcBBox(this.data, this.toBBox);
    },
    _chooseSplitIndex: function(node, m, M) {
        var i, bbox1, bbox2, overlap, area, minOverlap, minArea, index;
        minOverlap = minArea = Infinity;
        for(i = m; i <= M - m; i++){
            bbox1 = distBBox(node, 0, i, this.toBBox);
            bbox2 = distBBox(node, i, M, this.toBBox);
            overlap = intersectionArea(bbox1, bbox2);
            area = bboxArea(bbox1) + bboxArea(bbox2);
            // choose distribution with minimum overlap
            if (overlap < minOverlap) {
                minOverlap = overlap;
                index = i;
                minArea = area < minArea ? area : minArea;
            } else if (overlap === minOverlap) // otherwise choose distribution with minimum area
            {
                if (area < minArea) {
                    minArea = area;
                    index = i;
                }
            }
        }
        return index;
    },
    // sorts node children by the best axis for split
    _chooseSplitAxis: function(node, m, M) {
        var compareMinX = node.leaf ? this.compareMinX : compareNodeMinX, compareMinY = node.leaf ? this.compareMinY : compareNodeMinY, xMargin = this._allDistMargin(node, m, M, compareMinX), yMargin = this._allDistMargin(node, m, M, compareMinY);
        // if total distributions margin value is minimal for x, sort by minX,
        // otherwise it's already sorted by minY
        if (xMargin < yMargin) node.children.sort(compareMinX);
    },
    // total margin of all possible split distributions where each node is at least m full
    _allDistMargin: function(node, m, M, compare) {
        node.children.sort(compare);
        var toBBox = this.toBBox, leftBBox = distBBox(node, 0, m, toBBox), rightBBox = distBBox(node, M - m, M, toBBox), margin = bboxMargin(leftBBox) + bboxMargin(rightBBox), i, child;
        for(i = m; i < M - m; i++){
            child = node.children[i];
            extend(leftBBox, node.leaf ? toBBox(child) : child);
            margin += bboxMargin(leftBBox);
        }
        for(i = M - m - 1; i >= m; i--){
            child = node.children[i];
            extend(rightBBox, node.leaf ? toBBox(child) : child);
            margin += bboxMargin(rightBBox);
        }
        return margin;
    },
    _adjustParentBBoxes: function(bbox, path, level) {
        // adjust bboxes along the given tree path
        for(var i = level; i >= 0; i--)extend(path[i], bbox);
    },
    _condense: function(path) {
        // go through the path, removing empty nodes and updating bboxes
        for(var i = path.length - 1, siblings; i >= 0; i--)if (path[i].children.length === 0) {
            if (i > 0) {
                siblings = path[i - 1].children;
                siblings.splice(siblings.indexOf(path[i]), 1);
            } else this.clear();
        } else calcBBox(path[i], this.toBBox);
    },
    _initFormat: function(format) {
        // data format (minX, minY, maxX, maxY accessors)
        // uses eval-type function compilation instead of just accepting a toBBox function
        // because the algorithms are very sensitive to sorting functions performance,
        // so they should be dead simple and without inner calls
        var compareArr = [
            'return a',
            ' - b',
            ';'
        ];
        this.compareMinX = new Function('a', 'b', compareArr.join(format[0]));
        this.compareMinY = new Function('a', 'b', compareArr.join(format[1]));
        this.toBBox = new Function('a', 'return {minX: a' + format[0] + ', minY: a' + format[1] + ', maxX: a' + format[2] + ', maxY: a' + format[3] + '};');
    }
};
function findItem(item, items, equalsFn) {
    if (!equalsFn) return items.indexOf(item);
    for(var i = 0; i < items.length; i++){
        if (equalsFn(item, items[i])) return i;
    }
    return -1;
}
// calculate node's bbox from bboxes of its children
function calcBBox(node, toBBox) {
    distBBox(node, 0, node.children.length, toBBox, node);
}
// min bounding rectangle of node children from k to p-1
function distBBox(node, k, p, toBBox, destNode) {
    if (!destNode) destNode = createNode(null);
    destNode.minX = Infinity;
    destNode.minY = Infinity;
    destNode.maxX = -Infinity;
    destNode.maxY = -Infinity;
    for(var i = k, child; i < p; i++){
        child = node.children[i];
        extend(destNode, node.leaf ? toBBox(child) : child);
    }
    return destNode;
}
function extend(a, b) {
    a.minX = Math.min(a.minX, b.minX);
    a.minY = Math.min(a.minY, b.minY);
    a.maxX = Math.max(a.maxX, b.maxX);
    a.maxY = Math.max(a.maxY, b.maxY);
    return a;
}
function compareNodeMinX(a, b) {
    return a.minX - b.minX;
}
function compareNodeMinY(a, b) {
    return a.minY - b.minY;
}
function bboxArea(a) {
    return (a.maxX - a.minX) * (a.maxY - a.minY);
}
function bboxMargin(a) {
    return a.maxX - a.minX + (a.maxY - a.minY);
}
function enlargedArea(a, b) {
    return (Math.max(b.maxX, a.maxX) - Math.min(b.minX, a.minX)) * (Math.max(b.maxY, a.maxY) - Math.min(b.minY, a.minY));
}
function intersectionArea(a, b) {
    var minX = Math.max(a.minX, b.minX), minY = Math.max(a.minY, b.minY), maxX = Math.min(a.maxX, b.maxX), maxY = Math.min(a.maxY, b.maxY);
    return Math.max(0, maxX - minX) * Math.max(0, maxY - minY);
}
function contains(a, b) {
    return a.minX <= b.minX && a.minY <= b.minY && b.maxX <= a.maxX && b.maxY <= a.maxY;
}
function intersects(a, b) {
    return b.minX <= a.maxX && b.minY <= a.maxY && b.maxX >= a.minX && b.maxY >= a.minY;
}
function createNode(children) {
    return {
        children: children,
        height: 1,
        leaf: true,
        minX: Infinity,
        minY: Infinity,
        maxX: -Infinity,
        maxY: -Infinity
    };
}
// sort an array so that items come in groups of n unsorted items, with groups sorted between each other;
// combines selection algorithm with binary divide & conquer approach
function multiSelect(arr, left, right, n, compare) {
    var stack = [
        left,
        right
    ], mid;
    while(stack.length){
        right = stack.pop();
        left = stack.pop();
        if (right - left <= n) continue;
        mid = left + Math.ceil((right - left) / n / 2) * n;
        quickselect(arr, mid, left, right, compare);
        stack.push(left, mid, mid, right);
    }
}
var rbushExports = rbush$2.exports;
var rbush$1 = /*@__PURE__*/ getDefaultExportFromCjs(rbushExports);
var search = {};
var CollisionIndex = function() {
    function CollisionIndex() {
        this._tree = rbush$1(9, [
            '[0]',
            '[1]',
            '[2]',
            '[3]'
        ]);
    }
    var _proto = CollisionIndex.prototype;
    _proto.collides = function collides(box) {
        [search.minX, search.minY, search.maxX, search.maxY] = box;
        return this._tree.collides(search);
    };
    _proto.insertBox = function insertBox(box) {
        var tree = this._tree;
        tree.insert(box);
        return this;
    };
    _proto.bulkInsertBox = function bulkInsertBox(boxes) {
        this._tree.load(boxes);
        return this;
    };
    _proto.clear = function clear() {
        this._tree.clear();
        return this;
    };
    return CollisionIndex;
}();
var charTextureLRUCache = new LRUCache(50000);
function getCharTexture(tempCtx, style, _char) {
    var font = tempCtx.font;
    var fillStyle = tempCtx.fillStyle;
    var strokeStyle = tempCtx.strokeStyle;
    var textHaloFill = style.textHaloFill || DEFAULT_STROKE_COLOR;
    var textHaloRadius = style.textHaloRadius || 0;
    var textHaloOpacity = style.textHaloOpacity;
    if (!isNumber(textHaloOpacity)) textHaloOpacity = 1;
    var key = font + "_" + fillStyle + "_" + textHaloFill + "_" + textHaloRadius + "_" + textHaloOpacity + "_" + _char;
    var texture = charTextureLRUCache.get(key);
    if (!texture) {
        var drawHalo = textHaloOpacity !== 0 && textHaloRadius !== 0;
        var textSize = ((style.textSize || 14) * 1.2 + textHaloRadius) * 2;
        var canvas = Canvas.createCanvas(textSize, textSize);
        canvas.style.width = textSize / 2 + "px";
        canvas.style.height = textSize / 2 + "px";
        var x = textSize / 4, y = textSize / 4;
        var ctx = Canvas.getCanvas2DContext(canvas);
        ctx.scale(2, 2);
        ctx.font = font;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        if (drawHalo) {
            ctx.strokeStyle = strokeStyle;
            ctx.lineWidth = textHaloRadius * 2;
            ctx.globalAlpha = 1;
            ctx.globalAlpha *= textHaloOpacity;
            ctx.strokeText(_char, x, y);
            ctx.globalAlpha = 1;
        }
        ctx.fillStyle = fillStyle;
        ctx.fillText(_char, x, y);
        texture = canvas;
        charTextureLRUCache.add(key, texture);
    }
    return texture;
}
var DEFAULT_STROKE_COLOR = '#000';
var DEFAULT_FILL_COLOR = 'rgba(255,255,255,0)';
var DEFAULT_TEXT_COLOR = '#000';
var hitTesting = false;
var TEMP_CANVAS = null;
var RADIAN$1 = Math.PI / 180;
var textOffsetY = 1;
var TEXT_BASELINE = 'top';
var textCharsCollisionIndex = new CollisionIndex();
var textPathsCollisionIndex = new CollisionIndex();
function getDefaultCharacterSet() {
    var charSet = {};
    for(var i = 32; i < 128; i++){
        var _char2 = String.fromCharCode(i);
        charSet[_char2] = _char2;
    }
    return charSet;
}
var defaultChars = getDefaultCharacterSet();
function textIsDefaultChars(chars) {
    for(var i = 0, len = chars.length; i < len; i++){
        var _char3 = chars[i];
        if (!defaultChars[_char3]) return false;
    }
    return true;
}
function reverseChars(chars) {
    if (chars.toReversed) return chars.toReversed();
    var newChars = [];
    for(var i = 0, len = chars.length - 1; i <= len; i++)newChars[i] = chars[len - i];
    return newChars;
}
function getCharRotation(p1, p2, _char4, direction, isDefaultChars) {
    var x0 = p1.x, y0 = p1.y;
    var x1 = p2.x, y1 = p2.y;
    var dx = x1 - x0;
    var dy = y1 - y0;
    var rad = Math.atan2(dy, dx);
    var degree = rad / Math.PI * 180;
    if (direction === 'left') {
        degree += 180;
        rad = degree / 180 * Math.PI;
        return rad;
    }
    if (direction === 'down' && !isDefaultChars) {
        degree -= 90;
        rad = degree / 180 * Math.PI;
        return rad;
    }
    if (direction === 'up' && !isDefaultChars) {
        degree += 90;
        rad = degree / 180 * Math.PI;
        return rad;
    }
    return rad;
}
function measureCharSize(_char5, fontSize) {
    var w = fontSize, h = fontSize;
    if (defaultChars[_char5]) {
        w = fontSize / 4;
        h = fontSize;
    }
    var d = Math.sqrt(w * w + h * h);
    return d;
}
function measureTextLength(textName, fontSize) {
    var textLen = 0;
    for(var i = 0, len = textName.length; i < len; i++){
        var _char6 = textName[i];
        textLen += measureCharSize(_char6, fontSize);
    }
    return textLen;
}
function getPercentPoint(segment, dis) {
    var { distance: distance, p1: p1, p2: p2 } = segment;
    var dx = p2.x - p1.x, dy = p2.y - p1.y, dh = (p2.z || 0) - (p1.z || 0);
    var percent = dis / distance;
    var x = p1.x + percent * dx;
    var y = p1.y + percent * dy;
    var z = (p1.z || 0) + percent * dh;
    return new Point(x, y, z);
}
function lineSeg(points, options) {
    options = Object.assign({
        segDistance: 1,
        isGeo: true
    }, options);
    var segDistance = Math.max(options.segDistance, 0.00000000000000001);
    var segments = [];
    var totalLen = 0, idx = 0;
    for(var i = 0, _len = points.length; i < _len - 1; i++){
        var p1 = points[i], p2 = points[i + 1];
        var dis = p2.distanceTo(p1);
        segments[idx] = {
            p1: p1,
            distance: dis,
            p2: p2
        };
        idx++;
        totalLen += dis;
    }
    if (totalLen <= segDistance) return [
        {
            distance: totalLen,
            points: points
        }
    ];
    var len = segments.length;
    var first = segments[0];
    idx = 0;
    var currentPoint;
    var currentLen = 0;
    var lines = [];
    var tempLine = [
        first.p1
    ];
    while(idx < len){
        var { distance: distance, p2: _p } = segments[idx];
        currentLen += distance;
        if (currentLen < segDistance) {
            tempLine.push(_p);
            idx++;
            continue;
        }
        if (currentLen === segDistance) {
            tempLine.push(_p);
            currentLen = 0;
            lines.push(tempLine);
            tempLine = [
                _p
            ];
            idx++;
            continue;
        }
        if (currentLen > segDistance) {
            var offsetLen = segDistance - (currentLen - distance);
            currentPoint = getPercentPoint(segments[idx], offsetLen);
            tempLine.push(currentPoint);
            lines.push(tempLine);
            currentLen = 0;
            segments[idx].p1 = currentPoint;
            segments[idx].distance = distance - offsetLen;
            tempLine = [
                currentPoint
            ];
        }
    }
    if (tempLine.length) lines.push(tempLine);
    var result = [];
    for(var _i = 0, _len2 = lines.length; _i < _len2; _i++){
        var line = lines[_i];
        result[_i] = {
            points: line,
            distance: pathDistance(line)
        };
    }
    return result;
}
function textPathDirection(path) {
    var len = path.length;
    var first = path[0].point, last = path[len - 1].point;
    var bbox = getDefaultBBOX();
    for(var i = 0, _len3 = path.length; i < _len3; i++){
        var point = path[i].point;
        pointsBBOX(point, bbox);
    }
    var [minx, miny, maxx, maxy] = bbox;
    var dx = maxx - minx, dy = maxy - miny;
    var ishorizontal = true;
    if (dy > dx) ishorizontal = false;
    if (ishorizontal) {
        if (first.x < last.x) return 'right';
        return 'left';
    } else {
        if (first.y < last.y) return 'down';
        return 'up';
    }
}
function getTextPath(chunk, chars, fontSize, globalCollisonIndex) {
    var total = pathDistance(chunk);
    var result = [];
    var tempLen = 0;
    var hasCollision = false;
    textCharsCollisionIndex.clear();
    var idx = 1;
    for(var i = 0, len = chars.length; i < len; i++){
        var _char7 = chars[i];
        var charSize = measureCharSize(_char7, fontSize);
        var d = charSize + tempLen;
        for(var j = idx, len1 = chunk.length; j < len1; j++){
            var p1 = chunk[j - 1];
            var p2 = chunk[j];
            if (p2.distance < d) continue;
            idx = j;
            var dDistance = d - p1.distance;
            var percent = dDistance / (p2.distance - p1.distance);
            var dx = p2.x - p1.x, dy = p2.y - p1.y;
            var point = new Point(p1.x + dx * percent, p1.y + dy * percent);
            var { x: x, y: y } = point;
            var bufferSize = charSize / 3;
            var bbox = [
                x - bufferSize,
                y - bufferSize,
                x + bufferSize,
                y + bufferSize
            ];
            if (globalCollisonIndex && globalCollisonIndex.collides(bbox)) {
                hasCollision = true;
                break;
            }
            if (textCharsCollisionIndex.collides(bbox)) {
                hasCollision = true;
                break;
            } else textCharsCollisionIndex.insertBox(bbox);
            bufferSize = charSize / 2;
            result.push({
                "char": _char7,
                charSize: charSize,
                point: point,
                bbox: [
                    x - bufferSize,
                    y - bufferSize,
                    x + bufferSize,
                    y + bufferSize
                ]
            });
            tempLen += charSize;
            break;
        }
        if (hasCollision) break;
    }
    if (hasCollision) return [];
    if (total < tempLen) return [];
    return result;
}
function interpolate$1(t0, t1, x1, y1, bx1, by1, bx2, by2, x2, y2) {
    var u0 = 1.0 - t0;
    var u1 = 1.0 - t1;
    var qxa = x1 * u0 * u0 + bx1 * 2 * t0 * u0 + bx2 * t0 * t0;
    var qxb = x1 * u1 * u1 + bx1 * 2 * t1 * u1 + bx2 * t1 * t1;
    var qxc = bx1 * u0 * u0 + bx2 * 2 * t0 * u0 + x2 * t0 * t0;
    var qxd = bx1 * u1 * u1 + bx2 * 2 * t1 * u1 + x2 * t1 * t1;
    var qya = y1 * u0 * u0 + by1 * 2 * t0 * u0 + by2 * t0 * t0;
    var qyb = y1 * u1 * u1 + by1 * 2 * t1 * u1 + by2 * t1 * t1;
    var qyc = by1 * u0 * u0 + by2 * 2 * t0 * u0 + y2 * t0 * t0;
    var qyd = by1 * u1 * u1 + by2 * 2 * t1 * u1 + y2 * t1 * t1;
    var xb = qxa * u1 + qxc * t1;
    var xc = qxb * u0 + qxd * t0;
    var xd = qxb * u1 + qxd * t1;
    var yb = qya * u1 + qyc * t1;
    var yc = qyb * u0 + qyd * t0;
    var yd = qyb * u1 + qyd * t1;
    return [
        xb,
        yb,
        xc,
        yc,
        xd,
        yd
    ];
}
function getCubicControlPoints(x0, y0, x1, y1, x2, y2, x3, y3, smoothValue, t) {
    var xc1 = (x0 + x1) / 2.0, yc1 = (y0 + y1) / 2.0;
    var xc2 = (x1 + x2) / 2.0, yc2 = (y1 + y2) / 2.0;
    var xc3 = (x2 + x3) / 2.0, yc3 = (y2 + y3) / 2.0;
    var len1 = Math.sqrt((x1 - x0) * (x1 - x0) + (y1 - y0) * (y1 - y0));
    var len2 = Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
    var len3 = Math.sqrt((x3 - x2) * (x3 - x2) + (y3 - y2) * (y3 - y2));
    var k1 = len1 / (len1 + len2);
    var k2 = len2 / (len2 + len3);
    var xm1 = xc1 + (xc2 - xc1) * k1, ym1 = yc1 + (yc2 - yc1) * k1;
    var xm2 = xc2 + (xc3 - xc2) * k2, ym2 = yc2 + (yc3 - yc2) * k2;
    var ctrl1X = xm1 + (xc2 - xm1) * smoothValue + x1 - xm1, ctrl1Y = ym1 + (yc2 - ym1) * smoothValue + y1 - ym1, ctrl2X = xm2 + (xc2 - xm2) * smoothValue + x2 - xm2, ctrl2Y = ym2 + (yc2 - ym2) * smoothValue + y2 - ym2;
    var ctrlPoints = [
        ctrl1X,
        ctrl1Y,
        ctrl2X,
        ctrl2Y
    ];
    if (t < 1) return interpolate$1(0, t, x1, y1, ctrl1X, ctrl1Y, ctrl2X, ctrl2Y, x2, y2);
    else return ctrlPoints;
}
function pathDistance(points) {
    if (points.length < 2) return 0;
    var total = 0;
    points[0].distance = 0;
    for(var i = 1, len = points.length; i < len; i++){
        var p1 = points[i - 1], p2 = points[i];
        var distance = p1.distanceTo(p2);
        p2.distance = distance + p1.distance;
        total += distance;
    }
    return total;
}
function getColorInMinStep(colorIn) {
    if (isNumber(colorIn.minStep)) return colorIn.minStep;
    var colors = colorIn.colors || [];
    var len = colors.length;
    var steps = [];
    for(var i = 0; i < len; i++)steps[i] = colors[i][0];
    steps.sort(function(a, b) {
        return a - b;
    });
    var min = Infinity;
    for(var _i2 = 1; _i2 < len; _i2++){
        var step1 = steps[_i2 - 1], step2 = steps[_i2];
        var stepOffset = step2 - step1;
        min = Math.min(min, stepOffset);
    }
    colorIn.minStep = min;
    return min;
}
function getSegmentPercentPoint(p1, p2, percent) {
    var x1 = p1.x, y1 = p1.y, x2 = p2.x, y2 = p2.y;
    var dx = x2 - x1, dy = y2 - y1;
    return new Point(x1 + dx * percent, y1 + dy * percent);
}
function rgbaToCSSRGBA(r, g, b, a) {
    return "rgba(" + r + ", " + g + ", " + b + ", " + a / 255 + ")";
}
var TEMP_LAYER_CANVAS;
var Canvas = {
    getTempCanvas: function getTempCanvas() {
        if (!TEMP_LAYER_CANVAS) TEMP_LAYER_CANVAS = Canvas.createCanvas(1, 1);
        return TEMP_LAYER_CANVAS;
    },
    getCanvas2DPerformanceContext: function getCanvas2DPerformanceContext(canvas) {
        return canvas.getContext('2d', {});
    },
    getCanvas2DContext: function getCanvas2DContext(canvas) {
        return canvas.getContext('2d', {
            willReadFrequently: true
        });
    },
    setHitTesting: function setHitTesting(testing) {
        hitTesting = testing;
    },
    createCanvas: function createCanvas(width, height, canvasClass) {
        var canvas;
        if (!IS_NODE) {
            canvas = createEl('canvas');
            canvas.width = width;
            canvas.height = height;
        } else canvas = new canvasClass(width, height);
        return canvas;
    },
    prepareCanvasFont: function prepareCanvasFont(ctx, style, font) {
        if (ctx.textBaseline !== TEXT_BASELINE) ctx.textBaseline = TEXT_BASELINE;
        font = font || getFont(style);
        if (ctx.font !== font) ctx.font = font;
        var fill = style['textFill'];
        if (!fill) fill = DEFAULT_TEXT_COLOR;
        var fillStyle = Canvas.getRgba(fill, style['textOpacity']);
        if (ctx.fillStyle !== fillStyle) ctx.fillStyle = fillStyle;
    },
    prepareCanvas: function prepareCanvas(ctx, style, resources, testing) {
        if (!style) return;
        var strokeWidth = style['lineWidth'];
        if (!isNil(strokeWidth) && ctx.lineWidth !== strokeWidth) ctx.lineWidth = strokeWidth;
        var strokePattern = style['linePatternFile'];
        var strokeColor = style['lineColor'] || DEFAULT_STROKE_COLOR;
        if (testing) ctx.strokeStyle = '#000';
        else if (strokePattern && resources) {
            var patternOffset;
            if (style['linePatternDx'] || style['linePatternDy']) patternOffset = [
                style['linePatternDx'],
                style['linePatternDy']
            ];
            Canvas._setStrokePattern(ctx, strokePattern, strokeWidth, patternOffset, resources);
            style['lineDasharray'] = [];
        } else if (isGradient(strokeColor)) {
            if (style['lineGradientExtent']) ctx.strokeStyle = Canvas._createGradient(ctx, strokeColor, style['lineGradientExtent']);
            else ctx.strokeStyle = DEFAULT_STROKE_COLOR;
        } else {
            if (Array.isArray(strokeColor)) strokeColor = Canvas.normalizeColorToRGBA(strokeColor);
            ctx.strokeStyle = strokeColor;
        }
        if (style['lineJoin']) ctx.lineJoin = style['lineJoin'];
        if (style['lineCap']) ctx.lineCap = style['lineCap'];
        if (ctx.setLineDash && isArrayHasData(style['lineDasharray'])) ctx.setLineDash(style['lineDasharray']);
        var polygonPattern = style['polygonPatternFile'];
        var fill = style['polygonFill'] || DEFAULT_FILL_COLOR;
        if (testing) ctx.fillStyle = '#000';
        else if (polygonPattern && resources) {
            var fillImgUrl = extractImageUrl(polygonPattern);
            var fillTexture = resources.getImage([
                fillImgUrl,
                null,
                null
            ]);
            if (!fillTexture) fillTexture = resources.getImage([
                fillImgUrl + '-texture',
                null,
                strokeWidth
            ]);
            if (isSVG(fillImgUrl) && fillTexture instanceof Image && (Browser$1.edge || Browser$1.ie)) {
                var w = fillTexture.width || 20, h = fillTexture.height || 20;
                var canvas = Canvas.createCanvas(w, h);
                Canvas.image(canvas.getContext('2d'), fillTexture, 0, 0, w, h);
                fillTexture = canvas;
            }
            if (!fillTexture) {
                if (typeof console !== 'undefined') console.warn('img not found for', fillImgUrl);
            } else {
                ctx.fillStyle = ctx.createPattern(fillTexture, 'repeat');
                if (style['polygonPatternDx'] || style['polygonPatternDy']) ctx.fillStyle['polygonPatternOffset'] = [
                    style['polygonPatternDx'],
                    style['polygonPatternDy']
                ];
            }
        } else if (isGradient(fill)) {
            if (style['polygonGradientExtent']) ctx.fillStyle = Canvas._createGradient(ctx, fill, style['polygonGradientExtent']);
            else ctx.fillStyle = 'rgba(255,255,255,0)';
        } else {
            if (Array.isArray(fill)) fill = Canvas.normalizeColorToRGBA(fill);
            ctx.fillStyle = fill;
        }
    },
    _createGradient: function _createGradient(ctx, g, extent) {
        var gradient = null, places = g['places'];
        var min = extent.getMin(), max = extent.getMax(), width = extent.getWidth(), height = extent.getHeight();
        if (!g['type'] || g['type'] === 'linear') {
            if (!places) places = [
                min.x,
                min.y,
                max.x,
                min.y
            ];
            else {
                if (places.length !== 4) throw new Error('A linear gradient\'s places should have 4 numbers.');
                places = [
                    min.x + places[0] * width,
                    min.y + places[1] * height,
                    min.x + places[2] * width,
                    min.y + places[3] * height
                ];
            }
            gradient = ctx.createLinearGradient.apply(ctx, places);
        } else if (g['type'] === 'radial') {
            if (!places) {
                var c = extent.getCenter()._round();
                places = [
                    c.x,
                    c.y,
                    Math.abs(c.x - min.x),
                    c.x,
                    c.y,
                    0
                ];
            } else {
                if (places.length !== 6) throw new Error('A radial gradient\'s places should have 6 numbers.');
                places = [
                    min.x + places[0] * width,
                    min.y + places[1] * height,
                    width * places[2],
                    min.x + places[3] * width,
                    min.y + places[4] * height,
                    width * places[5]
                ];
            }
            gradient = ctx.createRadialGradient.apply(ctx, places);
        }
        g['colorStops'].forEach(function(stop) {
            gradient.addColorStop.apply(gradient, stop);
        });
        return gradient;
    },
    _setStrokePattern: function _setStrokePattern(ctx, strokePattern, strokeWidth, linePatternOffset, resources) {
        var imgUrl = extractImageUrl(strokePattern);
        var imageTexture;
        if (IS_NODE) imageTexture = resources.getImage([
            imgUrl,
            null,
            strokeWidth
        ]);
        else {
            var key = imgUrl + '-texture-' + strokeWidth;
            imageTexture = resources.getImage(key);
            if (!imageTexture) {
                var imageRes = resources.getImage([
                    imgUrl,
                    null,
                    null
                ]);
                if (imageRes) {
                    var w;
                    if (!imageRes.width || !imageRes.height) w = strokeWidth;
                    else w = Math.round(imageRes.width * strokeWidth / imageRes.height);
                    var patternCanvas = Canvas.createCanvas(w, strokeWidth, ctx.canvas.constructor);
                    Canvas.image(patternCanvas.getContext('2d'), imageRes, 0, 0, w, strokeWidth);
                    resources.addResource([
                        key,
                        null,
                        strokeWidth
                    ], patternCanvas);
                    imageTexture = patternCanvas;
                }
            }
        }
        if (imageTexture) {
            ctx.strokeStyle = ctx.createPattern(imageTexture, 'repeat');
            ctx.strokeStyle['linePatternOffset'] = linePatternOffset;
        } else if (typeof console !== 'undefined') console.warn('img not found for', imgUrl);
    },
    clearRect: function clearRect(ctx, x1, y1, x2, y2) {
        ctx.canvas._drawn = false;
        ctx.clearRect(x1, y1, x2, y2);
    },
    fillCanvas: function fillCanvas(ctx, fillOpacity, x, y) {
        if (hitTesting) fillOpacity = 1;
        ctx.canvas._drawn = true;
        if (fillOpacity === 0) return;
        var isPattern = Canvas._isPattern(ctx.fillStyle);
        var offset = ctx.fillStyle && ctx.fillStyle['polygonPatternOffset'];
        var dx = offset ? offset[0] : 0, dy = offset ? offset[1] : 0;
        if (isNil(fillOpacity)) fillOpacity = 1;
        var alpha;
        if (fillOpacity < 1) {
            alpha = ctx.globalAlpha;
            ctx.globalAlpha *= fillOpacity;
        }
        if (isPattern) {
            x = x || 0;
            y = y || 0;
            ctx.translate(x + dx, y + dy);
        }
        ctx.fill();
        if (isPattern) ctx.translate(-x - dx, -y - dy);
        if (fillOpacity < 1) ctx.globalAlpha = alpha;
    },
    getRgba: function getRgba(color, op) {
        if (isNil(op)) op = 1;
        if (color[0] === '#' && op === 1) return color;
        if (color[0] !== '#') {
            if (Array.isArray(color)) color = Canvas.normalizeColorToRGBA(color, op);
            return color;
        }
        var r, g, b;
        if (color.length === 7) {
            r = parseInt(color.substring(1, 3), 16);
            g = parseInt(color.substring(3, 5), 16);
            b = parseInt(color.substring(5, 7), 16);
        } else {
            r = parseInt(color.substring(1, 2), 16) * 17;
            g = parseInt(color.substring(2, 3), 16) * 17;
            b = parseInt(color.substring(3, 4), 16) * 17;
        }
        return 'rgba(' + r + ',' + g + ',' + b + ',' + op + ')';
    },
    normalizeColorToRGBA: function normalizeColorToRGBA(fill, opacity = 1) {
        return "rgba(" + fill[0] * 255 + ", " + fill[1] * 255 + ", " + fill[2] * 255 + ", " + (fill.length === 4 ? fill[3] : 1) * opacity + ")";
    },
    image: function image(ctx, img, x, y, width, height) {
        ctx.canvas._drawn = true;
        try {
            if (isNumber(width) && isNumber(height)) ctx.drawImage(img, x, y, width, height);
            else ctx.drawImage(img, x, y);
        } catch (error) {
            if (console) {
                console.warn('error when drawing image on canvas:', error);
                console.warn(img);
            }
        }
    },
    text: function text(ctx, _text, pt, style, textDesc) {
        return Canvas._textOnMultiRow(ctx, textDesc['rows'], style, pt, textDesc['size'], textDesc['rawSize']);
    },
    _textOnMultiRow: function _textOnMultiRow(ctx, texts, style, point, splitTextSize, textSize) {
        var ptAlign = getAlignPoint(splitTextSize, style['textHorizontalAlignment'], style['textVerticalAlignment']), lineHeight = textSize['height'] + style['textLineSpacing'], basePoint = point.add(0, ptAlign.y), maxHeight = style['textMaxHeight'];
        var text, rowAlign, height = 0;
        resetBBOX(BBOX_TEMP);
        for(var i = 0, len = texts.length; i < len; i++){
            text = texts[i]['text'];
            rowAlign = getAlignPoint(texts[i]['size'], style['textHorizontalAlignment'], style['textVerticalAlignment']);
            var _point = basePoint.add(rowAlign.x, i * lineHeight);
            Canvas._textOnLine(ctx, text, _point, style['textHaloRadius'], style['textHaloFill'], style['textHaloOpacity']);
            var _textSize = texts[i].size;
            var minx = _point.x, miny = _point.y, maxx = minx + _textSize.width, maxy = miny + _textSize.height;
            setBBOX(BBOX_TEMP, minx, miny, maxx, maxy);
            if (maxHeight > 0) {
                height += lineHeight;
                if (height + _textSize['height'] >= maxHeight) break;
            }
        }
        return BBOX_TEMP;
    },
    _textOnLine: function _textOnLine(ctx, text, pt, textHaloRadius, textHaloFill, textHaloAlpha) {
        if (hitTesting) textHaloAlpha = 1;
        var drawHalo = textHaloAlpha !== 0 && textHaloRadius !== 0;
        ctx.textBaseline = 'top';
        var gco, fill;
        var shadowBlur = ctx.shadowBlur, shadowOffsetX = ctx.shadowOffsetX, shadowOffsetY = ctx.shadowOffsetY;
        if (drawHalo) {
            var alpha = ctx.globalAlpha;
            ctx.globalAlpha *= textHaloAlpha;
            ctx.miterLimit = 2;
            ctx.lineJoin = 'round';
            ctx.lineCap = 'round';
            ctx.lineWidth = textHaloRadius * 2;
            if (Array.isArray(textHaloFill)) textHaloFill = Canvas.normalizeColorToRGBA(textHaloFill);
            ctx.strokeStyle = textHaloFill;
            ctx.strokeText(text, pt.x, pt.y + textOffsetY);
            ctx.miterLimit = 10;
            ctx.globalAlpha = alpha;
            gco = ctx.globalCompositeOperation;
            ctx.globalCompositeOperation = 'destination-out';
            fill = ctx.fillStyle;
            ctx.fillStyle = '#000';
        }
        if (shadowBlur && drawHalo) ctx.shadowBlur = ctx.shadowOffsetX = ctx.shadowOffsetY = 0;
        Canvas.fillText(ctx, text, pt);
        if (gco) {
            ctx.globalCompositeOperation = gco;
            Canvas.fillText(ctx, text, pt, fill);
            if (shadowBlur) {
                ctx.shadowBlur = shadowBlur;
                ctx.shadowOffsetX = shadowOffsetX;
                ctx.shadowOffsetY = shadowOffsetY;
            }
        }
    },
    fillText: function fillText(ctx, text, pt, rgba) {
        ctx.canvas._drawn = true;
        if (rgba) ctx.fillStyle = rgba;
        ctx.fillText(text, pt.x, pt.y + textOffsetY);
    },
    textAlongLine: function textAlongLine(ctx, text, paths, style, textDesc, globalCollisonIndex) {
        if (!text) return;
        var fontSize = style.textSize || 14;
        var textSpacing = style.textSpacing || 0;
        var textLen = measureTextLength(text, fontSize);
        if (textSpacing < textLen) return;
        if (!Array.isArray(paths[0])) paths = [
            paths
        ];
        var textBaseline = ctx.textBaseline;
        var textAlign = ctx.textAlign;
        var strokeStyle = ctx.strokeStyle;
        var globalAlpha = ctx.globalAlpha;
        var lineWidth = ctx.lineWidth;
        var textAlongDebug = style.textAlongDebug;
        var textHaloFill = style.textHaloFill || DEFAULT_STROKE_COLOR;
        var textHaloRadius = style.textHaloRadius || 0;
        var textHaloOpacity = style.textHaloOpacity;
        if (!isNumber(textHaloOpacity)) textHaloOpacity = 1;
        var drawHalo = textHaloOpacity !== 0 && textHaloRadius !== 0;
        ctx.textBaseline = 'middle';
        ctx.textAlign = 'center';
        if (drawHalo) {
            if (Array.isArray(textHaloFill)) textHaloFill = Canvas.normalizeColorToRGBA(textHaloFill);
            ctx.strokeStyle = textHaloFill;
            ctx.lineWidth = textHaloRadius * 2;
        }
        textPathsCollisionIndex.clear();
        var charsBBOX = getDefaultBBOX();
        var charArray = text.split('');
        var isDefaultChars = textIsDefaultChars(charArray);
        paths.forEach(function(path) {
            var pathLen = pathDistance(path);
            if (pathLen < textLen) return;
            var lines = lineSeg(path, {
                segDistance: textSpacing
            });
            if (!lines || !lines.length) return;
            for(var m = 0, len1 = lines.length; m < len1; m++){
                var chunk = lines[m];
                var chunkDistance = chunk.distance;
                if (chunkDistance < textLen) continue;
                var points = chunk.points;
                if (textAlongDebug) {
                    var fillStyle = ctx.fillStyle;
                    ctx.fillStyle = 'red';
                    var { x: x, y: y } = points[0];
                    ctx.beginPath();
                    ctx.fillRect(x - 2, y - 2, 4, 4);
                    ctx.fillStyle = fillStyle;
                }
                var chars = charArray;
                var items = getTextPath(points, chars, fontSize, globalCollisonIndex);
                if (!items.length) continue;
                var direction = textPathDirection(items);
                if (direction === 'left') {
                    chars = reverseChars(chars);
                    items = getTextPath(points, chars, fontSize, globalCollisonIndex);
                }
                if (direction === 'up' && !isDefaultChars) {
                    chars = reverseChars(chars);
                    items = getTextPath(points, chars, fontSize, globalCollisonIndex);
                }
                var hasCollision = false;
                for(var i = 0, len = items.length; i < len; i++){
                    var { bbox: bbox } = items[i];
                    if (textPathsCollisionIndex.collides(bbox)) {
                        hasCollision = true;
                        break;
                    }
                    if (globalCollisonIndex && globalCollisonIndex.collides(bbox)) {
                        hasCollision = true;
                        break;
                    }
                }
                if (hasCollision) continue;
                for(var _i3 = 0, _len4 = items.length; _i3 < _len4; _i3++){
                    var p1 = void 0, p2 = void 0;
                    if (_i3 === 0) {
                        p1 = items[_i3].point;
                        p2 = items[1].point;
                    } else if (_i3 === _len4 - 1) {
                        p1 = items[_len4 - 2].point;
                        p2 = items[_len4 - 1].point;
                    } else {
                        p1 = items[_i3 - 1].point;
                        p2 = items[_i3].point;
                    }
                    var _char8 = chars[_i3];
                    var { point: point, bbox: _bbox } = items[_i3];
                    textPathsCollisionIndex.insertBox(_bbox);
                    globalCollisonIndex && globalCollisonIndex.insertBox(_bbox);
                    var { x: _x, y: _y } = point;
                    var rad = getCharRotation(p1, p2, _char8, direction, isDefaultChars);
                    ctx.save();
                    ctx.translate(_x, _y);
                    ctx.rotate(rad);
                    var texture = getCharTexture(ctx, style, _char8);
                    var { width: width, height: height } = texture;
                    ctx.drawImage(texture, -width / 4, -height / 4, width / 2, height / 2);
                    ctx.restore();
                    setBBOX(charsBBOX, _bbox);
                    if (textAlongDebug) {
                        var _strokeStyle = ctx.strokeStyle;
                        var _lineWidth = ctx.lineWidth;
                        ctx.strokeStyle = 'red';
                        ctx.lineWidth = 0.5;
                        var [minx, miny, maxx, maxy] = _bbox;
                        ctx.beginPath();
                        ctx.rect(minx, miny, maxx - minx, maxy - miny);
                        ctx.stroke();
                        ctx.lineWidth = _lineWidth;
                        ctx.strokeStyle = _strokeStyle;
                    }
                }
            }
        });
        ctx.textBaseline = textBaseline;
        ctx.textAlign = textAlign;
        ctx.strokeStyle = strokeStyle;
        ctx.globalAlpha = globalAlpha;
        ctx.lineWidth = lineWidth;
        if (!validateBBOX(charsBBOX)) return;
        return charsBBOX;
    },
    _stroke: function _stroke(ctx, strokeOpacity, x, y) {
        if (hitTesting) strokeOpacity = 1;
        ctx.canvas._drawn = true;
        if (strokeOpacity === 0) return;
        var offset = ctx.strokeStyle && ctx.strokeStyle['linePatternOffset'];
        var dx = offset ? offset[0] : 0, dy = offset ? offset[1] : 0;
        var isPattern = Canvas._isPattern(ctx.strokeStyle) && (!isNil(x) && !isNil(y) || !isNil(dx) && !isNil(dy));
        if (isNil(strokeOpacity)) strokeOpacity = 1;
        var alpha;
        if (strokeOpacity < 1) {
            alpha = ctx.globalAlpha;
            ctx.globalAlpha *= strokeOpacity;
        }
        if (isPattern) {
            x = x || 0;
            y = y || 0;
            ctx.translate(x + dx, y + dy);
        }
        ctx.stroke();
        if (isPattern) ctx.translate(-x - dx, -y - dy);
        if (strokeOpacity < 1) ctx.globalAlpha = alpha;
    },
    _gradientPath: function _gradientPath(ctx, points, lineDashArray, lineOpacity, isRing = false) {
        if (!isNumber(lineOpacity)) lineOpacity = 1;
        if (hitTesting) lineOpacity = 1;
        if (lineOpacity === 0 || ctx.lineWidth === 0) return;
        var alpha = ctx.globalAlpha;
        ctx.globalAlpha *= lineOpacity;
        var colorIn = ctx.lineColorIn;
        var minStep = getColorInMinStep(colorIn);
        var distance = pathDistance(points);
        var step = 0;
        var preColor, color;
        var preX, preY, currentX, currentY, nextPoint;
        var [r, g, b, a] = colorIn.getColor(0);
        preColor = rgbaToCSSRGBA(r, g, b, a);
        var firstPoint = points[0];
        preX = firstPoint.x;
        preY = firstPoint.y;
        if (isRing) {
            var len = points.length;
            var lastPoint = points[len - 1];
            if (!firstPoint.equals(lastPoint)) points.push(firstPoint);
        }
        var dashArrayEnable = lineDashArray && Array.isArray(lineDashArray) && lineDashArray.length > 1;
        var drawSegment = function drawSegment() {
            if (!dashArrayEnable && nextPoint) {
                ctx.strokeStyle = color;
                ctx.beginPath();
                ctx.moveTo(preX, preY);
                ctx.lineTo(currentX, currentY);
                ctx.lineTo(nextPoint.x, nextPoint.y);
                ctx.stroke();
            }
            var grad = ctx.createLinearGradient(preX, preY, currentX, currentY);
            grad.addColorStop(0, preColor);
            grad.addColorStop(1, color);
            ctx.strokeStyle = grad;
            ctx.beginPath();
            ctx.moveTo(preX, preY);
            ctx.lineTo(currentX, currentY);
            ctx.stroke();
            preColor = color;
            preX = currentX;
            preY = currentY;
        };
        for(var i = 1, _len5 = points.length; i < _len5; i++){
            var prePoint = points[i - 1], currentPoint = points[i];
            nextPoint = points[i + 1];
            var x = currentPoint.x, y = currentPoint.y;
            var dis = currentPoint.distanceTo(prePoint);
            var percent = dis / distance;
            if (percent <= minStep) {
                var [_r, _g, _b, _a] = colorIn.getColor(step + percent);
                color = rgbaToCSSRGBA(_r, _g, _b, _a);
                currentX = x;
                currentY = y;
                drawSegment();
            } else {
                var segments = Math.ceil(percent / minStep);
                nextPoint = currentPoint;
                for(var n = 1; n <= segments; n++){
                    var tempStep = Math.min(n * minStep, percent);
                    var [_r2, _g2, _b2, _a2] = colorIn.getColor(step + tempStep);
                    color = rgbaToCSSRGBA(_r2, _g2, _b2, _a2);
                    if (color === preColor) continue;
                    var point = getSegmentPercentPoint(prePoint, currentPoint, tempStep / percent);
                    currentX = point.x;
                    currentY = point.y;
                    drawSegment();
                }
            }
            step += percent;
        }
        ctx.globalAlpha = alpha;
    },
    _path: function _path(ctx, points, lineDashArray, lineOpacity, ignoreStrokePattern) {
        if (!isArrayHasData(points)) return;
        function fillWithPattern(p1, p2) {
            var degree = computeDegree(p1.x, p1.y, p2.x, p2.y);
            ctx.save();
            var cosd = Math.cos(degree);
            if (Math.abs(cosd) < 1E-7) ctx.translate(p1.x - ctx.lineWidth / 2, p1.y);
            else ctx.translate(p1.x, p1.y - ctx.lineWidth / 2 / cosd);
            ctx.rotate(degree);
            Canvas._stroke(ctx, lineOpacity);
            ctx.restore();
        }
        var isDashed = isArrayHasData(lineDashArray);
        var isPatternLine = ignoreStrokePattern === true ? false : Canvas._isPattern(ctx.strokeStyle);
        var point, prePoint, nextPoint;
        for(var i = 0, len = points.length; i < len; i++){
            point = points[i];
            if (!isDashed || ctx.setLineDash) {
                ctx.lineTo(point.x, point.y);
                if (isPatternLine && i > 0) {
                    prePoint = points[i - 1];
                    fillWithPattern(prePoint, point);
                    ctx.beginPath();
                    ctx.moveTo(point.x, point.y);
                }
            } else if (isDashed) {
                if (i === len - 1) break;
                nextPoint = points[i + 1];
                drawDashLine(ctx, point, nextPoint, lineDashArray);
            }
        }
    },
    path: function path(ctx, points, lineOpacity, fillOpacity, lineDashArray) {
        if (!isArrayHasData(points)) return;
        if (ctx.lineColorIn) Canvas._gradientPath(ctx, points, lineDashArray, lineOpacity);
        else {
            ctx.beginPath();
            ctx.moveTo(points[0].x, points[0].y);
            Canvas._path(ctx, points, lineDashArray, lineOpacity);
        }
        Canvas._stroke(ctx, lineOpacity);
    },
    _multiClip: function _multiClip(ctx, points) {
        if (!points || points.length === 0) return;
        points.forEach(function(pts) {
            for(var i = 0, len = pts.length; i < len; i++){
                var point = pts[i];
                var x = point.x, y = point.y;
                if (i === 0) ctx.moveTo(x, y);
                else ctx.lineTo(x, y);
                if (i === len - 1) {
                    x = pts[0].x;
                    y = pts[0].y;
                    ctx.lineTo(x, y);
                }
            }
        });
    },
    polygon: function polygon(ctx, points, lineOpacity, fillOpacity, lineDashArray, smoothness) {
        if (ctx.isMultiClip) {
            Canvas._multiClip(ctx, points);
            return;
        }
        if (ctx.isClip) {
            Canvas._multiClip(ctx, Array.isArray(points[0]) ? points : [
                points
            ]);
            return;
        }
        if (!isArrayHasData(points)) return;
        var isPatternLine = Canvas._isPattern(ctx.strokeStyle), fillFirst = isArrayHasData(lineDashArray) && !ctx.setLineDash || isPatternLine && !smoothness;
        if (!isArrayHasData(points[0])) points = [
            points
        ];
        var savedCtx = ctx;
        var dpr = ctx.dpr || 1;
        var needScale = dpr !== 1;
        if (points.length > 1 && !IS_NODE) {
            if (!TEMP_CANVAS) TEMP_CANVAS = Canvas.createCanvas(1, 1);
            ctx.canvas._drawn = false;
            TEMP_CANVAS.width = ctx.canvas.width;
            TEMP_CANVAS.height = ctx.canvas.height;
            ctx = TEMP_CANVAS.getContext('2d');
            setLineDash(ctx, []);
            setLineDash(ctx, lineDashArray);
            copyProperties(ctx, savedCtx);
            if (needScale) ctx.scale(dpr, dpr);
        }
        var lineColorIn = ctx.lineColorIn;
        var lineWidth = ctx.lineWidth;
        var op, i, len;
        if (fillFirst) {
            ctx.save();
            for(i = 0, len = points.length; i < len; i++){
                if (!isArrayHasData(points[i])) continue;
                if (lineColorIn) ctx.lineWidth = 0.1;
                Canvas._ring(ctx, points[i], null, 0, true);
                op = fillOpacity;
                if (i > 0) {
                    ctx.globalCompositeOperation = 'destination-out';
                    op = 1;
                }
                Canvas.fillCanvas(ctx, op, points[i][0].x, points[i][0].y);
                if (i > 0) ctx.globalCompositeOperation = 'source-over';
                else if (len > 1) ctx.fillStyle = '#fff';
                Canvas._stroke(ctx, 0);
                ctx.lineWidth = lineWidth;
                if (lineColorIn) Canvas._gradientPath(ctx, points, null, 0, true);
            }
            ctx.restore();
        }
        var fillStyle = ctx.fillStyle;
        for(i = 0, len = points.length; i < len; i++){
            if (!isArrayHasData(points[i])) continue;
            if (lineColorIn) ctx.lineWidth = 0.1;
            if (smoothness) {
                Canvas.paintSmoothLine(ctx, points[i], lineOpacity, smoothness, true);
                ctx.closePath();
            } else Canvas._ring(ctx, points[i], lineDashArray, lineOpacity);
            if (!fillFirst) {
                op = fillOpacity;
                if (i > 0) {
                    ctx.globalCompositeOperation = 'destination-out';
                    op = 1;
                }
                Canvas.fillCanvas(ctx, op, points[i][0].x, points[i][0].y);
                if (i > 0) ctx.globalCompositeOperation = 'source-over';
                else if (len > 1) ctx.fillStyle = '#fff';
            }
            Canvas._stroke(ctx, lineOpacity);
            ctx.lineWidth = lineWidth;
            if (lineColorIn) Canvas._gradientPath(ctx, points[i], lineDashArray, lineOpacity, true);
        }
        if (ctx.fillStyle !== fillStyle) ctx.fillStyle = fillStyle;
        if (points.length > 1 && !IS_NODE) {
            if (needScale) {
                var rScale = 1 / dpr;
                savedCtx.scale(rScale, rScale);
            }
            savedCtx.drawImage(TEMP_CANVAS, 0, 0);
            if (needScale) savedCtx.scale(dpr, dpr);
            savedCtx.canvas._drawn = ctx.canvas._drawn;
            copyProperties(savedCtx, ctx);
        }
    },
    _ring: function _ring(ctx, ring, lineDashArray, lineOpacity, ignorePattern) {
        var isPattern = Canvas._isPattern(ctx.strokeStyle);
        if (!ignorePattern && isPattern && !ring[0].equals(ring[ring.length - 1])) ring = ring.concat([
            ring[0]
        ]);
        ctx.beginPath();
        ctx.moveTo(ring[0].x, ring[0].y);
        Canvas._path(ctx, ring, lineDashArray, lineOpacity, ignorePattern);
        if (!isPattern) ctx.closePath();
    },
    paintSmoothLine_bak: function paintSmoothLine_bak(ctx, points, lineOpacity, smoothValue, close, tailIdx, tailRatio) {
        if (!points) return;
        if (points.length <= 2 || !smoothValue) {
            Canvas.path(ctx, points, lineOpacity);
            return;
        }
        var count = points.length;
        var l = close ? count : count - 1;
        ctx.beginPath();
        ctx.moveTo(points[0].x, points[0].y);
        if (tailRatio !== undefined) l -= Math.max(l - tailIdx - 1, 0);
        var preCtrlPoints;
        for(var i = 0; i < l; i++){
            var x1 = points[i].x, y1 = points[i].y;
            var x0 = void 0, y0 = void 0, x2 = void 0, y2 = void 0, x3 = void 0, y3 = void 0;
            if (i - 1 < 0) {
                if (!close) {
                    x0 = points[i + 1].x;
                    y0 = points[i + 1].y;
                } else {
                    x0 = points[l - 1].x;
                    y0 = points[l - 1].y;
                }
            } else {
                x0 = points[i - 1].x;
                y0 = points[i - 1].y;
            }
            if (i + 1 < count) {
                x2 = points[i + 1].x;
                y2 = points[i + 1].y;
            } else {
                x2 = points[i + 1 - count].x;
                y2 = points[i + 1 - count].y;
            }
            if (i + 2 < count) {
                x3 = points[i + 2].x;
                y3 = points[i + 2].y;
            } else if (!close) {
                x3 = points[i].x;
                y3 = points[i].y;
            } else {
                x3 = points[i + 2 - count].x;
                y3 = points[i + 2 - count].y;
            }
            var ctrlPoints = getCubicControlPoints(x0, y0, x1, y1, x2, y2, x3, y3, smoothValue, i === l - 1 ? tailRatio : 1);
            if (i === l - 1 && tailRatio >= 0 && tailRatio < 1) {
                ctx.bezierCurveTo(ctrlPoints[0], ctrlPoints[1], ctrlPoints[2], ctrlPoints[3], ctrlPoints[4], ctrlPoints[5]);
                points.splice(l - 1, count - (l - 1) - 1);
                var lastPoint = new Point(ctrlPoints[4], ctrlPoints[5]);
                lastPoint.prevCtrlPoint = new Point(ctrlPoints[2], ctrlPoints[3]);
                points.push(lastPoint);
                count = points.length;
            } else ctx.bezierCurveTo(ctrlPoints[0], ctrlPoints[1], ctrlPoints[2], ctrlPoints[3], x2, y2);
            points[i].nextCtrlPoint = ctrlPoints.slice(0, 2);
            points[i].prevCtrlPoint = preCtrlPoints ? preCtrlPoints.slice(2) : null;
            preCtrlPoints = ctrlPoints;
        }
        if (!close && points[1].prevCtrlPoint) {
            points[0].nextCtrlPoint = points[1].prevCtrlPoint;
            delete points[0].prevCtrlPoint;
        }
        if (!points[count - 1].prevCtrlPoint) points[count - 1].prevCtrlPoint = points[count - 2].nextCtrlPoint;
        Canvas._stroke(ctx, lineOpacity);
    },
    paintSmoothLine: function paintSmoothLine(ctx, points, lineOpacity, smoothValue, close, tailIdx, tailRatio) {
        if (!points) return;
        if (points.length <= 2 || !smoothValue) {
            Canvas.path(ctx, points, lineOpacity);
            return;
        }
        var count = points.length;
        var l = close ? count : count - 1;
        ctx.beginPath();
        ctx.moveTo(points[0].x, points[0].y);
        if (tailRatio !== undefined) l -= Math.max(l - tailIdx - 1, 0);
        var preX, preY;
        for(var i = 0; i < l; i++){
            var x1 = points[i].x, y1 = points[i].y;
            var x0 = void 0, y0 = void 0, x2 = void 0, y2 = void 0, x3 = void 0, y3 = void 0;
            if (i - 1 < 0) {
                if (!close) {
                    x0 = points[i + 1].x;
                    y0 = points[i + 1].y;
                } else {
                    x0 = points[l - 1].x;
                    y0 = points[l - 1].y;
                }
            } else {
                x0 = points[i - 1].x;
                y0 = points[i - 1].y;
            }
            if (i + 1 < count) {
                x2 = points[i + 1].x;
                y2 = points[i + 1].y;
            } else {
                x2 = points[i + 1 - count].x;
                y2 = points[i + 1 - count].y;
            }
            if (i + 2 < count) {
                x3 = points[i + 2].x;
                y3 = points[i + 2].y;
            } else if (!close) {
                x3 = points[i].x;
                y3 = points[i].y;
            } else {
                x3 = points[i + 2 - count].x;
                y3 = points[i + 2 - count].y;
            }
            var point = points[i];
            var ctrlPoints = getCubicControlPoints(x0, y0, x1, y1, x2, y2, x3, y3, smoothValue, i === l - 1 ? tailRatio : 1);
            if (i === l - 1 && tailRatio >= 0 && tailRatio < 1) {
                ctx.bezierCurveTo(ctrlPoints[0], ctrlPoints[1], ctrlPoints[2], ctrlPoints[3], ctrlPoints[4], ctrlPoints[5]);
                points.splice(l - 1, count - (l - 1) - 1);
                var lastPoint = new Point(ctrlPoints[4], ctrlPoints[5]);
                points.push(lastPoint);
                count = points.length;
            } else ctx.bezierCurveTo(ctrlPoints[0], ctrlPoints[1], ctrlPoints[2], ctrlPoints[3], x2, y2);
            if (i === 0) {
                point.arrowNextPoint = point.arrowNextPoint || new Point(0, 0);
                preX = ctrlPoints[2];
                preY = ctrlPoints[3];
                point.arrowNextPoint.x = preX;
                point.arrowNextPoint.y = preY;
            } else {
                point.arrowPrePoint = point.arrowPrePoint || new Point(0, 0);
                point.arrowPrePoint.x = preX;
                point.arrowPrePoint.y = preY;
                preX = ctrlPoints[2];
                preY = ctrlPoints[3];
                if (i === l - 1 && points[i + 1]) {
                    points[i + 1].arrowPrePoint = points[i + 1].arrowPrePoint || new Point(0, 0);
                    points[i + 1].arrowPrePoint.x = ctrlPoints[0];
                    points[i + 1].arrowPrePoint.y = ctrlPoints[1];
                }
            }
        }
        Canvas._stroke(ctx, lineOpacity);
    },
    _arcBetween: function _arcBetween(ctx, p1, p2, degree) {
        var a = Math.abs(degree), dist = p1.distanceTo(p2), r = Math.abs(dist / 2 / Math.sin(a / 2));
        var p1p2 = Math.asin((p2.y - p1.y) / dist);
        if (p1.x > p2.x) p1p2 = Math.PI - p1p2;
        var cp2 = 90 * RADIAN$1 - a / 2, da = p1p2 - cp2;
        var dx = Math.cos(da) * r, dy = Math.sin(da) * r;
        var cx = p1.x + dx, cy = p1.y + dy;
        var startAngle = Math.asin((p2.y - cy) / r);
        if (cx > p2.x) startAngle = Math.PI - startAngle;
        var endAngle = startAngle + a;
        if (degree < 0) {
            startAngle += Math.PI;
            endAngle += Math.PI;
            var middleX = (p1.x + p2.x) / 2, middleY = (p1.y + p2.y) / 2;
            var _dx = cx - middleX, _dy = cy - middleY;
            cx = middleX - _dx;
            cy = middleY - _dy;
        }
        ctx.beginPath();
        ctx.arc(cx, cy, r, startAngle, endAngle);
        var aAngle = (endAngle - startAngle) / 100;
        var x1 = Math.cos(startAngle + aAngle) * r + cx;
        var y1 = Math.sin(startAngle + aAngle) * r + cy;
        var x2 = Math.cos(endAngle - aAngle) * r + cx;
        var y2 = Math.sin(endAngle - aAngle) * r + cy;
        p1.arrowNextPoint = p1.arrowNextPoint || new Point(0, 0);
        p2.arrowPrePoint = p2.arrowPrePoint || new Point(0, 0);
        if (degree < 0) {
            p1.arrowNextPoint.x = x1;
            p1.arrowNextPoint.y = y1;
            p2.arrowPrePoint.x = x2;
            p2.arrowPrePoint.y = y2;
        } else {
            p1.arrowNextPoint.x = x2;
            p1.arrowNextPoint.y = y2;
            p2.arrowPrePoint.x = x1;
            p2.arrowPrePoint.y = y1;
        }
        return [
            cx,
            cy
        ];
    },
    _lineTo: function _lineTo(ctx, p) {
        ctx.lineTo(p.x, p.y);
    },
    bezierCurveAndFill: function bezierCurveAndFill(ctx, points, lineOpacity, fillOpacity) {
        ctx.beginPath();
        var start = points[0];
        ctx.moveTo(start.x, start.y);
        var args = [
            ctx
        ];
        args.push.apply(args, points.splice(1));
        Canvas._bezierCurveTo.apply(Canvas, args);
        Canvas.fillCanvas(ctx, fillOpacity);
        Canvas._stroke(ctx, lineOpacity);
    },
    _bezierCurveTo: function _bezierCurveTo(ctx, p1, p2, p3) {
        ctx.bezierCurveTo(p1.x, p1.y, p2.x, p2.y, p3.x, p3.y);
    },
    ellipse: function ellipse(ctx, pt, width, heightTop, heightBottom, lineOpacity, fillOpacity) {
        function bezierEllipse(x, y, a, b, b1) {
            var k = 0.5522848, ox = a * k, oy = b * k, oy1 = b1 * k;
            ctx.moveTo(x - a, y);
            ctx.bezierCurveTo(x - a, y - oy, x - ox, y - b, x, y - b);
            ctx.bezierCurveTo(x + ox, y - b, x + a, y - oy, x + a, y);
            ctx.bezierCurveTo(x + a, y + oy1, x + ox, y + b1, x, y + b1);
            ctx.bezierCurveTo(x - ox, y + b1, x - a, y + oy1, x - a, y);
            ctx.closePath();
        }
        ctx.beginPath();
        if (width === heightTop && width === heightBottom) ctx.arc(pt.x, pt.y, width, 0, 2 * Math.PI);
        else if (ctx.ellipse) {
            if (heightTop !== heightBottom) {
                ctx.ellipse(pt.x, pt.y, width, heightTop, 0, RADIAN$1 * 180, RADIAN$1 * 360, false);
                ctx.ellipse(pt.x, pt.y, width, heightBottom, 0, 0, RADIAN$1 * 180, false);
            } else ctx.ellipse(pt.x, pt.y, width, heightTop, 0, 0, RADIAN$1 * 360, false);
        } else bezierEllipse(pt.x, pt.y, width, heightTop, heightBottom);
        Canvas.fillCanvas(ctx, fillOpacity, pt.x - width, pt.y - heightTop);
        Canvas._stroke(ctx, lineOpacity, pt.x - width, pt.y - heightTop);
    },
    rectangle: function rectangle(ctx, pt, size, lineOpacity, fillOpacity) {
        var { x: x, y: y } = pt;
        ctx.beginPath();
        ctx.rect(x, y, size['width'], size['height']);
        Canvas.fillCanvas(ctx, fillOpacity, x, y);
        Canvas._stroke(ctx, lineOpacity, x, y);
    },
    sector: function sector(ctx, pt, size, angles, lineOpacity, fillOpacity) {
        var rad = RADIAN$1;
        var startAngle = angles[0], endAngle = angles[1];
        function sector(ctx, x, y, radius, startAngle, endAngle) {
            var sDeg = rad * -endAngle;
            var eDeg = rad * -startAngle;
            ctx.beginPath();
            ctx.moveTo(x, y);
            ctx.arc(x, y, radius, sDeg, eDeg);
            ctx.lineTo(x, y);
            Canvas.fillCanvas(ctx, fillOpacity, x - radius, y - radius);
            Canvas._stroke(ctx, lineOpacity, x - radius, y - radius);
        }
        sector(ctx, pt.x, pt.y, size, startAngle, endAngle);
    },
    _isPattern: function _isPattern(style) {
        return !isString(style) && !('addColorStop' in style);
    },
    drawCross: function drawCross(ctx, x, y, lineWidth, color) {
        ctx.canvas._drawn = true;
        ctx.strokeStyle = color;
        ctx.lineWidth = lineWidth;
        ctx.beginPath();
        ctx.moveTo(x - 5, y);
        ctx.lineTo(x + 5, y);
        ctx.moveTo(x, y - 5);
        ctx.lineTo(x, y + 5);
        ctx.stroke();
    },
    copy: function copy(canvas, c) {
        var target = c || createEl('canvas');
        target.width = canvas.width;
        target.height = canvas.height;
        target.getContext('2d').drawImage(canvas, 0, 0);
        return target;
    },
    pixelRect: function pixelRect(ctx, point, lineOpacity, fillOpacity) {
        var lineWidth = ctx.lineWidth;
        var alpha = ctx.globalAlpha;
        var isStroke = false;
        if (lineWidth > 0 && lineOpacity > 0) {
            isStroke = true;
            if (lineOpacity < 1) ctx.globalAlpha *= lineOpacity;
        } else if (fillOpacity > 0) {
            if (fillOpacity < 1) ctx.globalAlpha *= fillOpacity;
        } else return;
        ctx.canvas._drawn = true;
        if (isStroke) ctx.strokeRect(point[0], point[1], 1, 1);
        else ctx.fillRect(point[0], point[1], 1, 1);
        if (ctx.globalAlpha !== alpha) ctx.globalAlpha = alpha;
    }
};
function drawDashLine(ctx, startPoint, endPoint, dashArray) {
    var fromX = startPoint.x, fromY = startPoint.y, toX = endPoint.x, toY = endPoint.y;
    var pattern = dashArray;
    var lt = function lt(a, b) {
        return a <= b;
    };
    var gt = function gt(a, b) {
        return a >= b;
    };
    var capmin = function capmin(a, b) {
        return Math.min(a, b);
    };
    var capmax = function capmax(a, b) {
        return Math.max(a, b);
    };
    var checkX = {
        thereYet: gt,
        cap: capmin
    };
    var checkY = {
        thereYet: gt,
        cap: capmin
    };
    if (fromY - toY > 0) {
        checkY.thereYet = lt;
        checkY.cap = capmax;
    }
    if (fromX - toX > 0) {
        checkX.thereYet = lt;
        checkX.cap = capmax;
    }
    ctx.moveTo(fromX, fromY);
    var offsetX = fromX;
    var offsetY = fromY;
    var idx = 0, dash = true;
    var ang, len;
    while(!(checkX.thereYet(offsetX, toX) && checkY.thereYet(offsetY, toY))){
        ang = Math.atan2(toY - fromY, toX - fromX);
        len = pattern[idx];
        offsetX = checkX.cap(toX, offsetX + Math.cos(ang) * len);
        offsetY = checkY.cap(toY, offsetY + Math.sin(ang) * len);
        if (dash) ctx.lineTo(offsetX, offsetY);
        else ctx.moveTo(offsetX, offsetY);
        idx = (idx + 1) % pattern.length;
        dash = !dash;
    }
}
var prefix = 'data:image/';
function extractImageUrl(url) {
    if (url.substring(0, prefix.length) === prefix) return url;
    return extractCssUrl(url);
}
function copyProperties(ctx, savedCtx) {
    ctx.filter = savedCtx.filter;
    ctx.fillStyle = savedCtx.fillStyle;
    ctx.globalAlpha = savedCtx.globalAlpha;
    ctx.lineCap = savedCtx.lineCap;
    ctx.lineDashOffset = savedCtx.lineDashOffset;
    ctx.lineJoin = savedCtx.lineJoin;
    ctx.lineWidth = savedCtx.lineWidth;
    ctx.shadowBlur = savedCtx.shadowBlur;
    ctx.shadowColor = savedCtx.shadowColor;
    ctx.shadowOffsetX = savedCtx.shadowOffsetX;
    ctx.shadowOffsetY = savedCtx.shadowOffsetY;
    ctx.strokeStyle = savedCtx.strokeStyle;
    ctx.lineColorIn = savedCtx.lineColorIn;
}
function setLineDash(ctx, lineDashArray) {
    if (!lineDashArray || !ctx.setLineDash || !Array.isArray(lineDashArray)) return;
    ctx.setLineDash(lineDashArray);
}
function generateWrapKey(eventType) {
    return 'Z__' + eventType;
}
function Eventable(Base) {
    return function(_Base) {
        function EventableMixin() {
            return _Base.apply(this, arguments) || this;
        }
        _inheritsLoose(EventableMixin, _Base);
        var _proto = EventableMixin.prototype;
        _proto.on = function on(eventsOn, handler, context) {
            if (!eventsOn) return this;
            if (!isString(eventsOn)) return this._switch('on', eventsOn, handler);
            if (!handler) return this;
            if (!this._eventMap) this._eventMap = {};
            eventsOn;
            var eventTypes = eventsOn.toLowerCase().split(' ');
            var evtType;
            if (!context) context = this;
            var isAdd = isNumber(handler._id);
            handler._id = UID();
            var handlerChain;
            for(var ii = 0, ll = eventTypes.length; ii < ll; ii++){
                evtType = eventTypes[ii];
                var wrapKey = generateWrapKey(evtType);
                if (handler[wrapKey]) handler[wrapKey]._id = handler._id;
                handlerChain = this._eventMap[evtType];
                if (!handlerChain) {
                    handlerChain = [];
                    this._eventMap[evtType] = handlerChain;
                }
                if (!isAdd) {
                    handlerChain.push({
                        handler: handler,
                        context: context
                    });
                    continue;
                }
                var l = handlerChain.length;
                if (l > 0) {
                    for(var i = 0; i < l; i++)if (handler === handlerChain[i].handler && handlerChain[i].context === context) {
                        if (!GlobalConfig.isTest) console.warn(this, "find '" + eventsOn + "' handler:", handler, ' The old listener function will be removed');
                        return this;
                    }
                }
                handlerChain.push({
                    handler: handler,
                    context: context
                });
            }
            return this;
        };
        _proto.addEventListener = function addEventListener(...args) {
            return this.on.call(this, ...args);
        };
        _proto.once = function once(eventTypes, handler, context) {
            if (!isString(eventTypes)) {
                eventTypes;
                var _once = {};
                for(var p in eventTypes)if (eventTypes.hasOwnProperty(p)) _once[p] = this._wrapOnceHandler(p, eventTypes[p], handler);
                return this._switch('on', _once);
            }
            eventTypes;
            var evetTypes = eventTypes.split(' ');
            for(var i = 0, l = evetTypes.length; i < l; i++)this.on(evetTypes[i], this._wrapOnceHandler(evetTypes[i], handler, context));
            return this;
        };
        _proto.off = function off(eventsOff, handler, context) {
            if (!this._eventMap || !eventsOff) return this;
            if (!isString(eventsOff)) return this._switch('off', eventsOff, handler);
            if (!handler) return this;
            if (!isNumber(handler._id)) return this;
            eventsOff;
            var eventTypes = eventsOff.split(' ');
            var eventType, listeners, wrapKey;
            if (!context) context = this;
            for(var j = 0, jl = eventTypes.length; j < jl; j++){
                eventType = eventTypes[j].toLowerCase();
                wrapKey = generateWrapKey(eventType);
                listeners = this._eventMap[eventType];
                if (!listeners) continue;
                for(var i = listeners.length - 1; i >= 0; i--){
                    var listener = listeners[i];
                    if ((handler === listener.handler || handler === listener.handler[wrapKey]) && listener.context === context) {
                        delete listener.handler[wrapKey];
                        listeners.splice(i, 1);
                    }
                }
                if (!listeners.length) delete this._eventMap[eventType];
            }
            return this;
        };
        _proto.removeEventListener = function removeEventListener(...args) {
            return this.off.call(this, ...args);
        };
        _proto.listens = function listens(eventType, handler, context) {
            if (!this._eventMap || !isString(eventType)) return 0;
            var handlerChain = this._eventMap[eventType.toLowerCase()];
            if (!handlerChain || !handlerChain.length) return 0;
            if (!handler) return handlerChain.length;
            for(var i = 0, len = handlerChain.length; i < len; i++){
                if (handler === handlerChain[i].handler && (isNil(context) || handlerChain[i].context === context)) return 1;
            }
            return 0;
        };
        _proto.getListeningEvents = function getListeningEvents() {
            if (!this._eventMap) return [];
            return Object.keys(this._eventMap);
        };
        _proto.copyEventListeners = function copyEventListeners(target) {
            var eventMap = target._eventMap;
            if (!eventMap) return this;
            var handlerChain;
            for(var eventType in eventMap){
                handlerChain = eventMap[eventType];
                for(var i = 0, len = handlerChain.length; i < len; i++)this.on(eventType, handlerChain[i].handler, handlerChain[i].context);
            }
            return this;
        };
        _proto.fire = function fire(eventType, param) {
            if (this._eventParent) return this._eventParent.fire.call(this._eventParent, eventType, param);
            return this._fire.call(this, eventType, param);
        };
        _proto._wrapOnceHandler = function _wrapOnceHandler(evtType, handler, context) {
            var key = generateWrapKey(evtType);
            var called = false;
            var fn = function onceHandler(...args) {
                if (called) return;
                delete fn[key];
                called = true;
                if (context) handler.call(context, ...args);
                else handler.call(this, ...args);
                onceHandler._called = true;
            };
            fn[key] = handler;
            return fn;
        };
        _proto._switch = function _switch(to, eventRecords, context) {
            for(var p in eventRecords)if (eventRecords.hasOwnProperty(p)) this[to](p, eventRecords[p], context);
            return this;
        };
        _proto._clearListeners = function _clearListeners(eventType) {
            if (!this._eventMap || !isString(eventType)) return;
            var handlerChain = this._eventMap[eventType.toLowerCase()];
            if (!handlerChain) return;
            this._eventMap[eventType] = null;
        };
        _proto._clearAllListeners = function _clearAllListeners() {
            this._eventMap = null;
        };
        _proto._setEventParent = function _setEventParent(parent) {
            this._eventParent = parent;
            return this;
        };
        _proto._setEventTarget = function _setEventTarget(target) {
            this._eventTarget = target;
            return this;
        };
        _proto._fire = function _fire(eventType, param) {
            if (!this._eventMap) return this;
            eventType = eventType.toLowerCase();
            var handlerChain = this._eventMap[eventType];
            if (!handlerChain) return this;
            if (!param) param = {
                type: eventType,
                target: this._eventTarget || this
            };
            param['type'] = eventType;
            param['target'] = this._eventTarget || this;
            var queue = handlerChain.slice(0);
            var context, bubble, passed;
            for(var i = 0, len = queue.length; i < len; i++){
                if (!queue[i]) continue;
                var handler = queue[i].handler;
                if (handler._called) continue;
                context = queue[i].context;
                bubble = true;
                passed = extend$2({}, param);
                if (context) bubble = queue[i].handler.call(context, passed);
                else bubble = queue[i].handler(passed);
                if (bubble === false) {
                    if (param['domEvent']) stopPropagation(param['domEvent']);
                }
            }
            var eventQueue = this._eventMap[eventType];
            if (eventQueue) {
                var queueExcludeOnce = [];
                for(var _i = 0, _len = eventQueue.length; _i < _len; _i++){
                    var _handler = eventQueue[_i].handler;
                    if (!_handler._called) queueExcludeOnce.push(eventQueue[_i]);
                }
                this._eventMap[eventType] = queueExcludeOnce;
            }
            return this;
        };
        return EventableMixin;
    }(Base);
}
var Base$1 = function Base() {};
var Handler = function(_Eventable) {
    function Handler(target) {
        var _this;
        _this = _Eventable.call(this) || this;
        _this._enabled = false;
        _this.target = target;
        return _this;
    }
    _inheritsLoose(Handler, _Eventable);
    var _proto = Handler.prototype;
    _proto.enable = function enable() {
        if (this._enabled) return this;
        this._enabled = true;
        this.addHooks();
        return this;
    };
    _proto.disable = function disable() {
        if (!this._enabled) return this;
        this._enabled = false;
        this.removeHooks();
        return this;
    };
    _proto.enabled = function enabled() {
        return !!this._enabled;
    };
    _proto.remove = function remove() {
        this.disable();
        delete this.target;
        delete this.dom;
    };
    return Handler;
}(Eventable(Base$1));
var Class = function() {
    function Class(options) {
        if (!this || !this._setOptions) throw new Error('Class instance is being created without "new" operator.');
        this._setOptions(options);
        this.callInitHooks();
        this._isUpdatingOptions = false;
    }
    var _proto = Class.prototype;
    _proto.proxyOptions = function proxyOptions() {
        var _this = this;
        if (!Browser$1.proxy) return this;
        this.options = new Proxy(this.options, {
            set: function set(target, key, value) {
                key;
                if (target[key] === value) return true;
                target[key] = value;
                if (_this._isUpdatingOptions) return true;
                var opts = {};
                opts[key] = value;
                _this.config(opts);
                return true;
            }
        });
        return this;
    };
    _proto.callInitHooks = function callInitHooks() {
        var proto = Object.getPrototypeOf(this);
        this._visitInitHooks(proto);
        return this;
    };
    _proto._setOptions = function _setOptions(options) {
        if (!this.hasOwnProperty('options') || isNil(this.options)) this.options = this.options ? Object.create(this.options) : {};
        if (!options) return this;
        for(var i in options)this.options[i] = options[i];
        return this;
    };
    _proto.setOptions = function setOptions(options) {
        console.warn('setOptions(options) It is a private method and deprecated, please use _setOptions(options) instead. If you want to update options, please use config(options) instead.');
        return this._setOptions(options);
    };
    _proto.config = function config(conf, value) {
        this._isUpdatingOptions = true;
        if (!conf) {
            var _config = {};
            for(var p in this.options)if (this.options.hasOwnProperty(p)) _config[p] = this.options[p];
            this._isUpdatingOptions = false;
            return _config;
        } else {
            if (arguments.length === 2 && typeof conf === 'string') {
                var t = {};
                t[conf] = value;
                conf = t;
            }
            conf;
            for(var i in conf){
                this.options[i] = conf[i];
                if (this[i] && this[i] instanceof Handler) {
                    if (conf[i]) this[i].enable();
                    else this[i].disable();
                }
            }
            this.onConfig(conf);
            this._isUpdatingOptions = false;
        }
        return this;
    };
    _proto.onConfig = function onConfig(conf) {};
    _proto._visitInitHooks = function _visitInitHooks(proto) {
        if (this._initHooksCalled) return;
        var parentProto = Object.getPrototypeOf(proto);
        if (parentProto._visitInitHooks) parentProto._visitInitHooks.call(this, parentProto);
        this._initHooksCalled = true;
        var hooks = proto._initHooks;
        if (hooks && hooks !== parentProto._initHooks) for(var i = 0; i < hooks.length; i++)hooks[i].call(this);
    };
    Class.addInitHook = function addInitHook(fn, ...args) {
        var init = typeof fn === 'function' ? fn : function() {
            this[fn].call(this, ...args);
        };
        var proto = this.prototype;
        var parentProto = Object.getPrototypeOf(proto);
        if (!proto._initHooks || proto._initHooks === parentProto._initHooks) proto._initHooks = [];
        proto._initHooks.push(init);
        return this;
    };
    Class.include = function include(...sources) {
        for(var i = 0; i < sources.length; i++)extend$2(this.prototype, sources[i]);
        return this;
    };
    Class.mergeOptions = function mergeOptions(options) {
        var proto = this.prototype;
        var parentProto = Object.getPrototypeOf(proto);
        if (!proto.options || proto.options === parentProto.options) proto.options = proto.options ? Object.create(proto.options) : {};
        extend$2(proto.options, options);
        return this;
    };
    return Class;
}();
var Base = function Base() {};
var GlobalEventable = function(_Eventable) {
    function GlobalEventable() {
        return _Eventable.apply(this, arguments) || this;
    }
    _inheritsLoose(GlobalEventable, _Eventable);
    return GlobalEventable;
}(Eventable(Base));
var GlobalEvent = new GlobalEventable();
var EVENT_DPR_CHANGE = 'dprchange';
var EVENT_DOC_VISIBILITY_CHANGE = 'docvisibilitychange';
var EVENT_DOC_DRAGSTART = 'dragstart';
var EVENT_DOC_DRAGEND = 'dragend';
if (typeof window !== 'undefined' && window.matchMedia) for(var i$1 = 1; i$1 < 500; i$1++){
    var dpi = (i$1 * 0.01).toFixed(2);
    var screen$1 = window.matchMedia("screen and (resolution: " + dpi + "dppx)");
    if (screen$1) {
        if (screen$1.addEventListener) screen$1.addEventListener('change', Browser$1.checkDevicePixelRatio);
        else if (screen$1.addListener) screen$1.addListener(Browser$1.checkDevicePixelRatio);
    }
}
if (Browser$1.devicePixelRatio) {
    var tempDPI = Browser$1.devicePixelRatio;
    Object.defineProperty(Browser$1, 'devicePixelRatio', {
        get: function get() {
            return tempDPI;
        },
        set: function set(value) {
            if (value === tempDPI) return;
            tempDPI = value;
            if (!Browser$1.monitorDPRChange) return;
            GlobalEvent.fire(EVENT_DPR_CHANGE, {
                devicePixelRatio: value
            });
        }
    });
}
if (Browser$1.webgl && typeof document !== 'undefined') {
    addDomEvent(document, 'visibilitychange', function() {
        GlobalEvent.fire(EVENT_DOC_VISIBILITY_CHANGE, {
            visibilityState: document.visibilityState
        });
    });
    addDomEvent(document, 'dragstart', function() {
        GlobalEvent.fire(EVENT_DOC_DRAGSTART);
    });
    addDomEvent(document, 'dragend', function() {
        GlobalEvent.fire(EVENT_DOC_DRAGEND);
    });
}
var registeredTypes = {};
function JSONAble(Base) {
    return function(_Base) {
        function JSONAble() {
            return _Base.apply(this, arguments) || this;
        }
        _inheritsLoose(JSONAble, _Base);
        JSONAble.registerJSONType = function registerJSONType(type) {
            if (!type) return;
            if (registeredTypes[type]) {
                console.error(type + " has register. please use Different name for:", this);
                return;
            }
            registeredTypes[type] = this;
            return;
        };
        JSONAble.getJSONClass = function getJSONClass(type) {
            if (!type) return null;
            return registeredTypes[type];
        };
        var _proto = JSONAble.prototype;
        _proto.getJSONType = function getJSONType() {
            if (this._jsonType === undefined) {
                var clazz = Object.getPrototypeOf(this).constructor;
                for(var p in registeredTypes)if (registeredTypes[p] === clazz) {
                    this._jsonType = p;
                    break;
                }
            }
            if (!this._jsonType) throw new Error('Found an unregistered Layer/Geometry class!');
            return this._jsonType;
        };
        return JSONAble;
    }(Base);
}
function Handlerable(Base) {
    return function(_Base) {
        function Handlerable() {
            return _Base.apply(this, arguments) || this;
        }
        _inheritsLoose(Handlerable, _Base);
        var _proto = Handlerable.prototype;
        _proto.addHandler = function addHandler(name, handlerClass) {
            if (!handlerClass) return this;
            if (!this._handlers) this._handlers = [];
            if (this[name]) {
                this[name].enable();
                return this;
            }
            var handler = this[name] = new handlerClass(this);
            this._handlers.push(handler);
            if (this.options[name]) handler.enable();
            return this;
        };
        _proto.removeHandler = function removeHandler(name) {
            if (!name) return this;
            var handler = this[name];
            if (handler) {
                var hit = this._handlers.indexOf(handler);
                if (hit >= 0) this._handlers.splice(hit, 1);
                this[name].remove();
                delete this[name];
            }
            return this;
        };
        _proto._clearHandlers = function _clearHandlers() {
            for(var i = 0, len = this._handlers.length; i < len; i++)this._handlers[i].remove();
            this._handlers = [];
        };
        return Handlerable;
    }(Base);
}
var START_EVENTS = 'touchstart mousedown';
var MOVE_EVENTS = {
    mousedown: 'mousemove',
    touchstart: 'touchmove',
    pointerdown: 'touchmove',
    MSPointerDown: 'touchmove'
};
var END_EVENTS = {
    mousedown: 'mouseup',
    touchstart: 'touchend',
    pointerdown: 'touchend',
    MSPointerDown: 'touchend'
};
var DragHandler = function(_Handler) {
    function DragHandler(dom, options = {}) {
        var _this;
        _this = _Handler.call(this, null) || this;
        _this.dom = dom;
        _this.options = options;
        return _this;
    }
    _inheritsLoose(DragHandler, _Handler);
    var _proto = DragHandler.prototype;
    _proto.addHooks = function addHooks() {};
    _proto.removeHooks = function removeHooks() {};
    _proto.enable = function enable() {
        if (!this.dom) return this;
        this._onMouseDown = function(e) {
            return this.onMouseDown(e);
        };
        on(this.dom, START_EVENTS, this._onMouseDown, this);
        return this;
    };
    _proto.disable = function disable() {
        if (!this.dom) return this;
        this._offEvents();
        off(this.dom, START_EVENTS, this._onMouseDown);
        delete this._onMouseDown;
        return this;
    };
    _proto.onMouseDown = function onMouseDown(event) {
        if (!this.options['rightclick'] && event.button === 2) return;
        var toucheEvent = event;
        if (toucheEvent.touches && toucheEvent.touches.length > 1) return;
        if (this.options['cancelOn'] && this.options['cancelOn'](event) === true) return;
        var dom = this.dom;
        if (dom.setCapture) dom.setCapture();
        else if (window.captureEvents) window.captureEvents();
        dom['ondragstart'] = function() {
            return false;
        };
        delete this.moved;
        var actual = toucheEvent.touches ? toucheEvent.touches[0] : event;
        this.startPos = new Point(actual.clientX, actual.clientY);
        off(document, MOVE_EVENTS[event.type], this.onMouseMove);
        off(document, END_EVENTS[event.type], this.onMouseUp);
        on(document, MOVE_EVENTS[event.type], this.onMouseMove, this);
        on(document, END_EVENTS[event.type], this.onMouseUp, this);
        if (!this.options['ignoreMouseleave']) {
            off(this.dom, 'mouseleave', this.onMouseUp);
            on(this.dom, 'mouseleave', this.onMouseUp, this);
        }
        this.fire('mousedown', {
            'domEvent': event,
            'mousePos': new Point(actual.clientX, actual.clientY)
        });
    };
    _proto.onMouseMove = function onMouseMove(event) {
        var toucheEvent = event;
        if (toucheEvent.touches && toucheEvent.touches.length > 1) {
            if (this.moved) {
                this.interupted = true;
                this.onMouseUp(event);
            }
            return;
        }
        var actual = toucheEvent.touches ? toucheEvent.touches[0] : event;
        var newPos = new Point(actual.clientX, actual.clientY), offset = newPos.sub(this.startPos);
        if (!offset.x && !offset.y) return;
        if (!this.moved) {
            this.fire('dragstart', {
                'domEvent': event,
                'mousePos': this.startPos.copy()
            });
            this.moved = true;
        } else this.fire('dragging', {
            'domEvent': event,
            'mousePos': new Point(actual.clientX, actual.clientY)
        });
    };
    _proto.onMouseUp = function onMouseUp(event) {
        var toucheEvent = event;
        var actual = toucheEvent.changedTouches ? toucheEvent.changedTouches[0] : event;
        this._offEvents();
        var param = {
            'domEvent': event
        };
        if (isNumber(actual.clientX)) param['mousePos'] = new Point(parseInt(actual.clientX + '', 0), parseInt(actual.clientY + '', 0));
        if (this.moved) {
            param.interupted = this.interupted;
            this.fire('dragend', param);
            delete this.interupted;
            delete this.moved;
        }
        this.fire('mouseup', param);
    };
    _proto._offEvents = function _offEvents() {
        var dom = this.dom;
        off(dom, 'mouseleave', this.onMouseUp);
        if (typeof document === 'undefined' || typeof window === 'undefined') return;
        for(var i in MOVE_EVENTS){
            off(document, MOVE_EVENTS[i], this.onMouseMove);
            off(document, END_EVENTS[i], this.onMouseUp);
        }
        if (dom['releaseCapture']) dom['releaseCapture']();
        else if (window.captureEvents) window.captureEvents();
    };
    return DragHandler;
}(Handler);
var Coordinate = function(_Position) {
    function Coordinate() {
        return _Position.apply(this, arguments) || this;
    }
    _inheritsLoose(Coordinate, _Position);
    Coordinate.toNumberArrays = function toNumberArrays(coordinates) {
        if (!Array.isArray(coordinates)) return coordinates.toArray();
        return forEachCoord(coordinates, function(coord) {
            return coord.toArray();
        });
    };
    Coordinate.toCoordinates = function toCoordinates(coordinates) {
        if (isNumber(coordinates[0]) && isNumber(coordinates[1])) return new Coordinate(coordinates);
        if (coordinates instanceof Coordinate) return coordinates;
        var result = [];
        for(var i = 0, len = coordinates.length; i < len; i++){
            var child = coordinates[i];
            if (Array.isArray(child)) {
                if (isNumber(child[0])) result.push(new Coordinate(child));
                else result.push(Coordinate.toCoordinates(child));
            } else if (child instanceof Coordinate) result.push(child);
            else result.push(new Coordinate(child));
        }
        return result;
    };
    var _proto = Coordinate.prototype;
    _proto.closeTo = function closeTo(p, delta) {
        if (!delta) delta = 0;
        return this.x >= p.x - delta && this.x <= p.x + delta && this.y >= p.y - delta && this.y <= p.y + delta;
    };
    _proto.abs = function abs() {
        return new Coordinate(Math.abs(this.x), Math.abs(this.y));
    };
    _proto.round = function round() {
        return new Coordinate(Math.round(this.x), Math.round(this.y));
    };
    _proto.ceil = function ceil() {
        return new Coordinate(Math.ceil(this.x), Math.ceil(this.y));
    };
    _proto.floor = function floor() {
        return new Coordinate(Math.floor(this.x), Math.floor(this.y));
    };
    _proto.copy = function copy() {
        return new Coordinate(this.x, this.y, this.z);
    };
    _proto.toFixed = function toFixed(n) {
        return new Coordinate(this.x.toFixed(n), this.y.toFixed(n), isNumber(this.z) ? this.z.toFixed(n) : undefined);
    };
    _proto.add = function add(x, y, z) {
        var nx, ny, nz = this.z;
        if (!isNil(x.x)) {
            nx = this.x + x.x;
            ny = this.y + x.y;
            if (!isNil(x.z)) nz = (this.z || 0) + x.z;
        } else if (!isNil(x[0])) {
            nx = this.x + x[0];
            ny = this.y + x[1];
            if (!isNil(x[2])) nz = (this.z || 0) + x[2];
        } else {
            nx = this.x + x;
            ny = this.y + y;
            if (!isNil(z)) nz = (this.z || 0) + z;
        }
        return new Coordinate(nx, ny, nz);
    };
    _proto.sub = function sub(x, y, z) {
        var nx, ny, nz = this.z;
        if (!isNil(x.x)) {
            nx = this.x - x.x;
            ny = this.y - x.y;
            if (!isNil(x.z)) nz = (this.z || 0) - x.z;
        } else if (!isNil(x[0])) {
            nx = this.x - x[0];
            ny = this.y - x[1];
            if (!isNil(x[2])) nz = (this.z || 0) - x[2];
        } else {
            nx = this.x - x;
            ny = this.y - y;
            if (!isNil(z)) nz = (this.z || 0) - z;
        }
        return new Coordinate(nx, ny, nz);
    };
    _proto.multi = function multi(ratio) {
        return new Coordinate(this.x * ratio, this.y * ratio, isNil(this.z) ? this.z : this.z * ratio);
    };
    _proto.equals = function equals(c) {
        if (!(c instanceof this.constructor)) return false;
        return this.x === c.x && this.y === c.y && this.z === c.z;
    };
    return Coordinate;
}(Position);
var CRS = function() {
    function CRS(type, properties) {
        this.type = type;
        this.properties = properties;
    }
    CRS.createProj4 = function createProj4(proj) {
        return new CRS('proj4', {
            'proj': proj
        });
    };
    CRS.fromProjectionCode = function fromProjectionCode(code) {
        if (!code) return null;
        code = code.toUpperCase().replace(':', '');
        return CRS[code] || null;
    };
    return CRS;
}();
CRS.WGS84 = CRS.createProj4('+proj=longlat +datum=WGS84 +no_defs');
CRS.EPSG3857 = CRS.createProj4('+proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +k=1.0 +units=m +nadgrids=@null +wktext  +no_defs');
CRS.IDENTITY = CRS.createProj4('+proj=identity +no_defs');
CRS.CGCS2000 = CRS.createProj4('+proj=longlat +datum=CGCS2000');
CRS.EPSG4490 = CRS.CGCS2000;
CRS.BD09LL = CRS.createProj4('+proj=longlat +datum=BD09');
CRS.GCJ02 = CRS.createProj4('+proj=longlat +datum=GCJ02');
var TEMP_POINT0$4 = new Point(0, 0);
var TEMP_COORD0$1 = new Coordinate(0, 0);
var TEMP_COORD1$1 = new Coordinate(0, 0);
var TEMP_COORD2 = new Coordinate(0, 0);
var TEMP_COORD3 = new Coordinate(0, 0);
var TEMP_COORD4 = new Coordinate(0, 0);
var TEMP_COORD5 = new Coordinate(0, 0);
var TEMP_COORD6 = new Coordinate(0, 0);
var TEMP_COORD7 = new Coordinate(0, 0);
var MINMAX = [];
var TEMP_EXTENT$9;
var TEMP_COMBINE = [];
var Extent = function() {
    function Extent(...args) {
        this._clazz = Coordinate;
        var l = args.length;
        var proj = l > 0 ? args[l - 1] : null;
        if (proj && proj.unproject) this.projection = args[l - 1];
        this._dirty = true;
        this.antiMeridian = false;
        this._initialize(args[0], args[1], args[2], args[3]);
    }
    var _proto = Extent.prototype;
    _proto._initialize = function _initialize(p1, p2, p3, p4) {
        this.xmin = null;
        this.xmax = null;
        this.ymin = null;
        this.ymax = null;
        if (isNil(p1)) return;
        var projection = this.projection;
        if (isNumber(p1) && isNumber(p2) && isNumber(p3) && isNumber(p4)) {
            if (projection) this.set(p1, p2, p3, p4);
            else this.set(Math.min(p1, p3), Math.min(p2, p4), Math.max(p1, p3), Math.max(p2, p4));
            return;
        } else if (Array.isArray(p1)) {
            if (projection) this.set(p1[0], p1[1], p1[2], p1[3]);
            else this.set(Math.min(p1[0], p1[2]), Math.min(p1[1], p1[3]), Math.max(p1[0], p1[2]), Math.max(p1[1], p1[3]));
        } else if (isNumber(p1.x) && isNumber(p2.x) && isNumber(p1.y) && isNumber(p2.y)) {
            var tp1 = p1;
            var tp2 = p2;
            if (projection) this.set(tp1.x, tp1.y, tp2.x, tp2.y);
            else {
                if (tp1.x > tp2.x) {
                    this['xmin'] = tp2.x;
                    this['xmax'] = tp1.x;
                } else {
                    this['xmin'] = tp1.x;
                    this['xmax'] = tp2.x;
                }
                if (tp1.y > tp2.y) {
                    this['ymin'] = tp2.y;
                    this['ymax'] = tp1.y;
                } else {
                    this['ymin'] = tp1.y;
                    this['ymax'] = tp2.y;
                }
            }
        } else if (isNumber(p1['xmin']) && isNumber(p1['xmax']) && isNumber(p1['ymin']) && isNumber(p1['ymax'])) this.set(p1['xmin'], p1['ymin'], p1['xmax'], p1['ymax']);
    };
    _proto._add = function _add(p) {
        this._dirty = true;
        if (!isNil(p.x)) {
            this['xmin'] += p.x;
            this['ymin'] += p.y;
            this['xmax'] += p.x;
            this['ymax'] += p.y;
        } else if (!isNil(p.xmin)) {
            this['xmin'] += p.xmin;
            this['ymin'] += p.ymin;
            this['xmax'] += p.xmax;
            this['ymax'] += p.ymax;
        } else if (!isNil(p[0])) {
            this['xmin'] += p[0];
            this['ymin'] += p[1];
            this['xmax'] += p[0];
            this['ymax'] += p[1];
        }
        return this;
    };
    _proto.add = function add(p) {
        var e = new this.constructor(this['xmin'], this['ymin'], this['xmax'], this['ymax'], this.projection);
        return e._add(p);
    };
    _proto._scale = function _scale(s) {
        this._dirty = true;
        this['xmin'] *= s;
        this['ymin'] *= s;
        this['xmax'] *= s;
        this['ymax'] *= s;
        return this;
    };
    _proto._sub = function _sub(p) {
        this._dirty = true;
        if (!isNil(p.x)) {
            this['xmin'] -= p.x;
            this['ymin'] -= p.y;
            this['xmax'] -= p.x;
            this['ymax'] -= p.y;
        } else if (!isNil(p.xmin)) {
            this['xmin'] -= p.xmin;
            this['ymin'] -= p.ymin;
            this['xmax'] -= p.xmax;
            this['ymax'] -= p.ymax;
        } else if (!isNil(p[0])) {
            this['xmin'] -= p[0];
            this['ymin'] -= p[1];
            this['xmax'] -= p[0];
            this['ymax'] -= p[1];
        }
        return this;
    };
    _proto._substract = function _substract(p) {
        return this._sub(p);
    };
    _proto.sub = function sub(p) {
        var e = new this.constructor(this['xmin'], this['ymin'], this['xmax'], this['ymax'], this.projection);
        return e._sub(p);
    };
    _proto.substract = function substract(p) {
        return this.sub(p);
    };
    _proto.round = function round() {
        return new this.constructor(Math.round(this['xmin']), Math.round(this['ymin']), Math.round(this['xmax']), Math.round(this['ymax']), this.projection);
    };
    _proto._round = function _round() {
        this._dirty = true;
        this['xmin'] = Math.round(this['xmin']);
        this['ymin'] = Math.round(this['ymin']);
        this['xmax'] = Math.round(this['xmax']);
        this['ymax'] = Math.round(this['ymax']);
        return this;
    };
    _proto.getMin = function getMin(out) {
        if (out) {
            out.set(this['xmin'], this['ymin']);
            return out;
        }
        return new this._clazz(this['xmin'], this['ymin']);
    };
    _proto.getMax = function getMax(out) {
        if (out) {
            out.set(this['xmax'], this['ymax']);
            return out;
        }
        return new this._clazz(this['xmax'], this['ymax']);
    };
    _proto.getCenter = function getCenter(out) {
        var x = (this['xmin'] + this['xmax']) / 2;
        var y = (this['ymin'] + this['ymax']) / 2;
        if (out) {
            out.set(x, y);
            return out;
        }
        return new this._clazz(x, y);
    };
    _proto.isValid = function isValid() {
        return !isNil(this['xmin']) && !isNil(this['ymin']) && !isNil(this['xmax']) && !isNil(this['ymax']);
    };
    _proto.equals = function equals(ext2) {
        return this['xmin'] === ext2['xmin'] && this['xmax'] === ext2['xmax'] && this['ymin'] === ext2['ymin'] && this['ymax'] === ext2['ymax'];
    };
    _proto.intersects = function intersects(ext2) {
        this._project(this);
        this._project(ext2);
        var rxmin = Math.max(this['pxmin'], ext2['pxmin']);
        var rymin = Math.max(this['pymin'], ext2['pymin']);
        var rxmax = Math.min(this['pxmax'], ext2['pxmax']);
        var rymax = Math.min(this['pymax'], ext2['pymax']);
        return !(rxmin > rxmax || rymin > rymax);
    };
    _proto.within = function within(extent) {
        this._project(this);
        this._project(extent);
        return this.pxmin >= extent.pxmin && this.pxmax <= extent.pxmax && this.pymin >= extent.pymin && this.pymax <= extent.pymax;
    };
    _proto.contains = function contains(c) {
        if (!c) return false;
        this._project(this);
        var proj = this.projection;
        if (proj) {
            var coord = TEMP_COORD0$1;
            if (Array.isArray(c)) {
                coord.x = c[0];
                coord.y = c[1];
                c = proj.project(coord, coord);
            } else if (c.x !== undefined) {
                coord.x = c.x;
                coord.y = c.y;
                c = proj.project(coord, coord);
            } else if (c.xmin !== undefined) this._project(c);
        }
        return (c.x || c.pxmin || 0) >= this.pxmin && (c.x || c.pxmax || 0) <= this.pxmax && (c.y || c.pymin || 0) >= this.pymin && (c.y || c.pymax || 0) <= this.pymax;
    };
    _proto.getWidth = function getWidth() {
        return Math.abs(this['xmax'] - this['xmin']);
    };
    _proto.getHeight = function getHeight() {
        return Math.abs(this['ymax'] - this['ymin']);
    };
    _proto.getSize = function getSize() {
        return new Size(this.getWidth(), this.getHeight());
    };
    _proto.set = function set(xmin, ymin, xmax, ymax) {
        this.xmin = xmin;
        this.ymin = ymin;
        this.xmax = xmax;
        this.ymax = ymax;
        this._dirty = true;
        return this;
    };
    _proto.__combine = function __combine(extent) {
        if (extent.x !== undefined) {
            TEMP_EXTENT$9.xmin = TEMP_EXTENT$9.xmax = extent.x;
            TEMP_EXTENT$9.ymin = TEMP_EXTENT$9.ymax = extent.y;
            extent = TEMP_EXTENT$9;
        }
        this._project(extent);
        this._project(this);
        var inited = isNumber(this.pxmin);
        var xmin, ymin, xmax, ymax;
        if (!inited) {
            xmin = extent['pxmin'];
            ymin = extent['pymin'];
            xmax = extent['pxmax'];
            ymax = extent['pymax'];
        } else {
            xmin = Math.min(this['pxmin'], extent['pxmin']);
            ymin = Math.min(this['pymin'], extent['pymin']);
            xmax = Math.max(this['pxmax'], extent['pxmax']);
            ymax = Math.max(this['pymax'], extent['pymax']);
        }
        var proj = this.projection;
        if (proj) {
            TEMP_COORD1$1.set(xmin, ymin);
            TEMP_COORD2.set(xmax, ymax);
            var min = proj.unproject(TEMP_COORD1$1, TEMP_COORD1$1), max = proj.unproject(TEMP_COORD2, TEMP_COORD2);
            xmin = min.x;
            ymin = min.y;
            xmax = max.x;
            ymax = max.y;
        }
        TEMP_COMBINE[0] = xmin;
        TEMP_COMBINE[1] = ymin;
        TEMP_COMBINE[2] = xmax;
        TEMP_COMBINE[3] = ymax;
        return TEMP_COMBINE;
    };
    _proto._combine = function _combine(extent) {
        if (!extent || extent.isValid && !extent.isValid()) return this;
        var ext = this.__combine(extent);
        this.set(ext[0], ext[1], ext[2], ext[3]);
        this._dirty = true;
        return this;
    };
    _proto.combine = function combine(extent) {
        if (!extent || extent.isValid && !extent.isValid()) return this;
        var ext = this.__combine(extent);
        return new this.constructor(ext[0], ext[1], ext[2], ext[3], this.projection);
    };
    _proto.intersection = function intersection(extent) {
        if (!this.intersects(extent)) return null;
        TEMP_COORD3.x = Math.max(this['pxmin'], extent['pxmin']);
        TEMP_COORD3.y = Math.max(this['pymin'], extent['pymin']);
        TEMP_COORD4.x = Math.min(this['pxmax'], extent['pxmax']);
        TEMP_COORD4.y = Math.min(this['pymax'], extent['pymax']);
        var min = TEMP_COORD3, max = TEMP_COORD4;
        var proj = this.projection;
        if (proj) {
            min = proj.unproject(min, min);
            max = proj.unproject(max, max);
        }
        return new this.constructor(min, max, proj);
    };
    _proto.expand = function expand(distance) {
        var w, h;
        if (!isNumber(distance)) {
            w = distance['width'] || distance['x'] || distance[0] || 0;
            h = distance['height'] || distance['y'] || distance[1] || 0;
        } else w = h = distance;
        return new this.constructor(this['xmin'] - w, this['ymin'] - h, this['xmax'] + w, this['ymax'] + h, this.projection);
    };
    _proto._expand = function _expand(distance) {
        var w, h;
        if (!isNumber(distance)) {
            w = distance['width'] || distance['x'] || distance[0] || 0;
            h = distance['height'] || distance['y'] || distance[1] || 0;
        } else w = h = distance;
        this['xmin'] -= w;
        this['ymin'] -= h;
        this['xmax'] += w;
        this['ymax'] += h;
        this._dirty = true;
        return this;
    };
    _proto.toJSON = function toJSON() {
        return {
            'xmin': this['xmin'],
            'ymin': this['ymin'],
            'xmax': this['xmax'],
            'ymax': this['ymax']
        };
    };
    _proto.toArray = function toArray(out) {
        var xmin = this['xmin'], ymin = this['ymin'], xmax = this['xmax'], ymax = this['ymax'];
        if (!out) return [
            new this._clazz([
                xmin,
                ymax
            ]),
            new this._clazz([
                xmax,
                ymax
            ]),
            new this._clazz([
                xmax,
                ymin
            ]),
            new this._clazz([
                xmin,
                ymin
            ]),
            new this._clazz([
                xmin,
                ymax
            ])
        ];
        else {
            out[0].x = xmin;
            out[0].y = ymax;
            out[1].x = xmax;
            out[1].y = ymax;
            out[2].x = xmax;
            out[2].y = ymin;
            out[3].x = xmin;
            out[3].y = ymin;
            out[4].x = xmin;
            out[4].y = ymax;
            return out;
        }
    };
    _proto.toString = function toString() {
        return this.xmin + "," + this.ymin + "," + this.xmax + "," + this.ymax;
    };
    _proto.copy = function copy() {
        return new this.constructor(this['xmin'], this['ymin'], this['xmax'], this['ymax'], this.projection);
    };
    _proto.convertTo = function convertTo(fn, out) {
        if (!this.isValid()) return null;
        var e = out || new this.constructor();
        if (out) e.set(null, null, null, null);
        var coord;
        if (this._clazz === Coordinate) coord = TEMP_COORD5;
        else if (this._clazz === Point) coord = TEMP_POINT0$4;
        coord.x = this.xmin;
        coord.y = this.ymax;
        e._combine(fn(coord));
        coord.x = this.xmax;
        e._combine(fn(coord));
        coord.y = this.ymin;
        e._combine(fn(coord));
        coord.x = this.xmin;
        e._combine(fn(coord));
        return e;
    };
    _proto._project = function _project(ext) {
        if (!ext || !ext.isValid()) {
            if (ext) ext.pxmin = ext.pxmax = ext.pymin = ext.pymax = null;
            return;
        }
        var proj = this.projection;
        if (proj) {
            if (ext._dirty) {
                TEMP_COORD6.set(ext.xmin, ext.ymin);
                TEMP_COORD7.set(ext.xmax, ext.ymax);
                MINMAX[0] = TEMP_COORD6;
                MINMAX[1] = TEMP_COORD7;
                var minmax = proj.projectCoords(MINMAX, this.antiMeridian);
                var min = minmax[0], max = minmax[1];
                ext.pxmin = Math.min(min.x, max.x);
                ext.pymin = Math.min(min.y, max.y);
                ext.pxmax = Math.max(min.x, max.x);
                ext.pymax = Math.max(min.y, max.y);
            }
            delete ext._dirty;
        } else {
            ext.pxmin = ext.xmin;
            ext.pxmax = ext.xmax;
            ext.pymin = ext.ymin;
            ext.pymax = ext.ymax;
        }
    };
    return Extent;
}();
TEMP_EXTENT$9 = new Extent(0, 0, 0, 0);
var PointExtent = function(_Extent) {
    function PointExtent(...args) {
        var _this;
        _this = _Extent.call(this, ...args) || this;
        _this._clazz = Point;
        return _this;
    }
    _inheritsLoose(PointExtent, _Extent);
    return PointExtent;
}(Extent);
var Transformation = function() {
    function Transformation(matrix) {
        this.matrix = matrix;
    }
    var _proto = Transformation.prototype;
    _proto.transform = function transform(coordinates, scale, out) {
        var x = this.matrix[0] * (coordinates.x - this.matrix[2]) / scale;
        var y = -this.matrix[1] * (coordinates.y - this.matrix[3]) / scale;
        if (out) {
            out.x = x;
            out.y = y;
            return out;
        }
        return new Point(x, y);
    };
    _proto.untransform = function untransform(point, scale, out) {
        var x = point.x * scale / this.matrix[0] + this.matrix[2];
        var y = point.y * scale / -this.matrix[1] + this.matrix[3];
        if (out) {
            out.x = x;
            out.y = y;
            return out;
        }
        return new Coordinate(x, y);
    };
    return Transformation;
}();
var CommonProjection = {
    code: '',
    is: function is(code) {
        if (this.code === code) return true;
        if (!this.aliases) return false;
        for(var i = 0; i < this.aliases.length; i++){
            if (this.aliases[i] === code) return true;
        }
        return false;
    },
    project: function project(p) {
        return p;
    },
    unproject: function unproject(p) {
        return p;
    },
    projectCoords: function projectCoords(coordinates, antiMeridian) {
        var _this = this;
        if (!coordinates) return [];
        if (!Array.isArray(coordinates)) return this.project(coordinates);
        if (coordinates.length === 0) return [];
        if (!this.isSphere()) return forEachCoord(coordinates, this.project, this);
        if (Array.isArray(coordinates[0])) return coordinates.map(function(coords) {
            return _this.projectCoords(coords, antiMeridian);
        });
        else {
            var antiMeridianEnable = antiMeridian;
            var circum = this.getCircum();
            var extent = this.getSphereExtent();
            var sy = extent.sy;
            var wrapY;
            var pre = coordinates[0], current, dx, dy, p;
            var prj = [
                this.project(pre)
            ];
            for(var i = 1, l = coordinates.length; i < l; i++){
                current = coordinates[i];
                dx = current.x - pre.x;
                dy = current.y - pre.y;
                p = this.project(current);
                var isAntiMeridian = false;
                if (Math.abs(dx) > 180 && antiMeridianEnable) {
                    if (dx < 0) current.x = 360 - Math.abs(current.x);
                    else current.x = -180 - (180 - Math.abs(current.x));
                    isAntiMeridian = true;
                }
                if (Math.abs(dy) > 90 && antiMeridianEnable) {
                    if (wrapY === undefined) wrapY = current.y < pre.y;
                    if (wrapY) {
                        p._add(0, -circum.y * sign(dy) * sy);
                        current._add(0, -180 * sign(dy));
                    }
                }
                if (isAntiMeridian) p = this.project(current);
                pre = current;
                prj.push(p);
            }
            return prj;
        }
    },
    unprojectCoords: function unprojectCoords(projCoords) {
        if (!projCoords) return [];
        if (!Array.isArray(projCoords)) return this.unproject(projCoords);
        return forEachCoord(projCoords, this.unproject, this);
    },
    isSphere: function isSphere() {
        return !!this.sphere;
    },
    isOutSphere: function isOutSphere(pcoord) {
        if (!this.isSphere()) return false;
        var extent = this.getSphereExtent();
        return !extent.contains(pcoord);
    },
    wrapCoord: function wrapCoord(pcoord) {
        if (!this.isSphere()) return pcoord;
        var extent = this.getSphereExtent();
        var wrapped = new Coordinate(pcoord);
        if (!extent.contains(wrapped)) {
            wrapped.x = wrap(pcoord.x, extent.xmin, extent.xmax);
            wrapped.y = wrap(pcoord.y, extent.ymin, extent.ymax);
        }
        return wrapped;
    },
    getCircum: function getCircum() {
        if (!this.circum && this.isSphere()) {
            var extent = this.getSphereExtent();
            this.circum = {
                x: extent.getWidth(),
                y: extent.getHeight()
            };
        }
        return this.circum;
    },
    getSphereExtent: function getSphereExtent() {
        if (!this.extent && this.isSphere()) {
            var max = this.project(new Coordinate(180, 90)), min = this.project(new Coordinate(-180, -90));
            this.extent = new Extent(min, max, this);
            this.extent.sx = max.x > min.x ? 1 : -1;
            this.extent.sy = max.y > min.y ? 1 : -1;
        }
        return this.extent;
    }
};
var common = {
    measureLength: function measureLength(c1, c2) {
        if (!Array.isArray(c1)) return this.measureLenBetween(c1, c2);
        var len = 0;
        for(var i = 0, l = c1.length; i < l - 1; i++)len += this.measureLenBetween(c1[i], c1[i + 1]);
        return len;
    }
};
var identity = {
    'measure': 'IDENTITY',
    measureLenBetween: function measureLenBetween(c1, c2, ignoreAltitude = false) {
        if (!c1 || !c2) return 0;
        try {
            var distance = Math.sqrt(Math.pow(c1.x - c2.x, 2) + Math.pow(c1.y - c2.y, 2));
            if (ignoreAltitude) return distance;
            var z1 = c1.z || 0, z2 = c2.z || 0;
            var dz = z1 - z2;
            if (dz === 0) return distance;
            return Math.sqrt(distance * distance + dz * dz);
        } catch (err) {
            return 0;
        }
    },
    measureArea: function measureArea(coordinates) {
        if (!Array.isArray(coordinates)) return 0;
        var area = 0;
        for(var i = 0, len = coordinates.length; i < len; i++){
            var c1 = coordinates[i];
            var c2 = null;
            if (i === len - 1) c2 = coordinates[0];
            else c2 = coordinates[i + 1];
            area += c1.x * c2.y - c1.y * c2.x;
        }
        return Math.abs(area / 2);
    },
    locate: function locate(c, xDist, yDist, out) {
        out = out || new Coordinate(0, 0);
        out.set(c.x, c.y);
        return this._locate(out, xDist, yDist);
    },
    _locate: function _locate(c, xDist, yDist) {
        if (!c) return null;
        if (!xDist) xDist = 0;
        if (!yDist) yDist = 0;
        if (!xDist && !yDist) return c;
        c.x = c.x + xDist;
        c.y = c.y + yDist;
        return c;
    },
    rotate: function rotate(c, pivot, angle) {
        c = new Coordinate(c.x, c.y);
        return this._rotate(c, pivot, angle);
    },
    _rotate: function() {
        var tmp = new Point(0, 0);
        return function(c, pivot, angle) {
            tmp.x = c.x - pivot.x;
            tmp.y = c.y - pivot.y;
            tmp._rotate(angle * Math.PI / 180);
            c.x = pivot.x + tmp.x;
            c.y = pivot.y + tmp.y;
            return c;
        };
    }()
};
var extended = extend$2(identity, common);
var Sphere = function() {
    function Sphere(radius) {
        this.radius = radius;
    }
    var _proto = Sphere.prototype;
    _proto.measureLenBetween = function measureLenBetween(c1, c2, ignoreAltitude = false) {
        if (!c1 || !c2) return 0;
        var b = toRadian(c1.y);
        var d = toRadian(c2.y), e = b - d, f = toRadian(c1.x) - toRadian(c2.x);
        b = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(e / 2), 2) + Math.cos(b) * Math.cos(d) * Math.pow(Math.sin(f / 2), 2)));
        b *= this.radius;
        var distance = b;
        if (ignoreAltitude) return distance;
        var z1 = c1.z || 0, z2 = c2.z || 0;
        var dz = z1 - z2;
        if (dz === 0) return distance;
        return Math.sqrt(distance * distance + dz * dz);
    };
    _proto.measureArea = function measureArea(coordinates) {
        var a = toRadian(this.radius);
        var b = 0;
        var c = coordinates;
        var d = c.length;
        if (d < 3) return 0;
        var i;
        for(i = 0; i < d - 1; i++){
            var _e = c[i], _f = c[i + 1];
            b += _e.x * a * Math.cos(toRadian(_e.y)) * _f.y * a - _f.x * a * Math.cos(toRadian(_f.y)) * _e.y * a;
        }
        var e = c[i];
        var f = c[0];
        b += e.x * a * Math.cos(toRadian(e.y)) * f.y * a - f.x * a * Math.cos(toRadian(f.y)) * e.y * a;
        return 0.5 * Math.abs(b);
    };
    _proto.locate = function locate(c, xDist, yDist, out) {
        out = out || new Coordinate(0, 0);
        out.set(c.x, c.y);
        return this._locate(out, xDist, yDist);
    };
    _proto._locate = function _locate(c, xDist, yDist) {
        if (!c) return null;
        if (!xDist) xDist = 0;
        if (!yDist) yDist = 0;
        if (!xDist && !yDist) return c;
        var x, y;
        var ry = toRadian(c.y);
        if (yDist !== 0) {
            var dy = Math.abs(yDist);
            var sy = Math.sin(dy / (2 * this.radius)) * 2;
            ry = ry + sy * (yDist > 0 ? 1 : -1);
            y = wrap(ry * 180 / Math.PI, -90, 90);
        } else y = c.y;
        if (xDist !== 0) {
            var dx = Math.abs(xDist);
            var rx = toRadian(c.x);
            var sx = 2 * Math.sqrt(Math.pow(Math.sin(dx / (2 * this.radius)), 2) / Math.pow(Math.cos(ry), 2));
            rx = rx + sx * (xDist > 0 ? 1 : -1);
            x = wrap(rx * 180 / Math.PI, -180, 180);
        } else x = c.x;
        c.x = x;
        c.y = y;
        return c;
    };
    _proto.rotate = function rotate(c, pivot, angle) {
        var coordinate = new Coordinate(c);
        return this._rotate(coordinate, pivot, angle);
    };
    _proto._rotate = function _rotate(c, pivot, angle) {
        var initialAngle = rhumbBearing(pivot, c);
        var finalAngle = initialAngle - angle;
        var distance = this.measureLenBetween(pivot, c, true);
        c.x = pivot.x;
        c.y = pivot.y;
        return calculateRhumbDestination(c, distance, finalAngle, this.radius);
    };
    return Sphere;
}();
function rhumbBearing(start, end, options = {}) {
    var bear360;
    if (options["final"]) bear360 = calculateRhumbBearing(end, start);
    else bear360 = calculateRhumbBearing(start, end);
    return bear360 > 180 ? -(360 - bear360) : bear360;
}
function calculateRhumbBearing(from, to) {
    var phi1 = toRadian(from.y);
    var phi2 = toRadian(to.y);
    var deltaLambda = toRadian(to.x - from.x);
    if (deltaLambda > Math.PI) deltaLambda -= 2 * Math.PI;
    if (deltaLambda < -Math.PI) deltaLambda += 2 * Math.PI;
    var deltaPsi = Math.log(Math.tan(phi2 / 2 + Math.PI / 4) / Math.tan(phi1 / 2 + Math.PI / 4));
    var theta = Math.atan2(deltaLambda, deltaPsi);
    return (toDegree(theta) + 360) % 360;
}
function calculateRhumbDestination(origin, distance, bearing, radius) {
    var delta = distance / radius;
    var lambda1 = origin.x * Math.PI / 180;
    var phi1 = toRadian(origin.y);
    var theta = toRadian(bearing);
    var DeltaPhi = delta * Math.cos(theta);
    var phi2 = phi1 + DeltaPhi;
    if (Math.abs(phi2) > Math.PI / 2) phi2 = phi2 > 0 ? Math.PI - phi2 : -Math.PI - phi2;
    var DeltaPsi = Math.log(Math.tan(phi2 / 2 + Math.PI / 4) / Math.tan(phi1 / 2 + Math.PI / 4));
    var q = Math.abs(DeltaPsi) > 10e-12 ? DeltaPhi / DeltaPsi : Math.cos(phi1);
    var DeltaLambda = delta * Math.sin(theta) / q;
    var lambda2 = lambda1 + DeltaLambda;
    origin.x = (lambda2 * 180 / Math.PI + 540) % 360 - 180;
    origin.y = phi2 * 180 / Math.PI;
    return origin;
}
var wgs84 = {
    'measure': 'EPSG:4326',
    sphere: new Sphere(6378137),
    measureLenBetween: function measureLenBetween(c1, c2) {
        return this.sphere.measureLenBetween(c1, c2);
    },
    measureArea: function measureArea(coordinates) {
        return this.sphere.measureArea.call(this.sphere, coordinates);
    },
    _locate: function _locate(c, xDist, yDist) {
        return this.sphere._locate.call(this.sphere, c, xDist, yDist);
    },
    locate: function locate(c, xDist, yDist, out) {
        return this.sphere.locate.call(this.sphere, c, xDist, yDist, out);
    },
    _rotate: function _rotate(c, pivot, angle) {
        return this.sphere._rotate.call(this.sphere, c, pivot, angle);
    },
    rotate: function rotate(c, pivot, angle) {
        return this.sphere.rotate.call(this.sphere, c, pivot, angle);
    }
};
var WGS84Sphere = extend$2(wgs84, common);
var baidu = {
    'measure': 'BAIDU',
    sphere: new Sphere(6370996.81),
    measureLenBetween: function measureLenBetween(c1, c2) {
        return this.sphere.measureLenBetween.call(this.sphere, c1, c2);
    },
    measureArea: function measureArea(coordinates) {
        return this.sphere.measureArea.call(this.sphere, coordinates);
    },
    _locate: function _locate(c, xDist, yDist) {
        return this.sphere._locate.call(this.sphere, c, xDist, yDist);
    },
    locate: function locate(c, xDist, yDist, out) {
        return this.sphere.locate.call(this.sphere, c, xDist, yDist, out);
    },
    _rotate: function _rotate(c, pivot, angle) {
        return this.sphere._rotate.call(this.sphere, c, pivot, angle);
    },
    rotate: function rotate(c, pivot, angle) {
        return this.sphere.rotate.call(this.sphere, c, pivot, angle);
    }
};
var BaiduSphere = extend$2(baidu, common);
var DEFAULT$1 = WGS84Sphere;
var measurers = {};
function registerMeasurer(m) {
    measurers[m.measure] = m;
}
registerMeasurer(extended);
registerMeasurer(WGS84Sphere);
registerMeasurer(BaiduSphere);
var Measurer = {
    getInstance: function getInstance(name) {
        if (!name) return DEFAULT$1;
        for(var p in measurers)if (hasOwn(measurers, p)) {
            var mName = measurers[p]['measure'];
            if (!mName) continue;
            if (name.toLowerCase() === mName.toLowerCase()) return measurers[p];
        }
        return null;
    }
};
var index$4 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BaiduSphere: BaiduSphere,
    DEFAULT: DEFAULT$1,
    Identity: extended,
    Measurer: Measurer,
    WGS84Sphere: WGS84Sphere
});
var delta = 1E-7;
var EPSG3857Projection = {
    code: 'EPSG:3857',
    rad: Math.PI / 180,
    metersPerDegree: 6378137 * Math.PI / 180,
    maxLatitude: 85.0511287798,
    project: function project(lnglat, out) {
        var rad = this.rad, metersPerDegree = this.metersPerDegree, max = this.maxLatitude;
        var lng = lnglat.x, lat = Math.max(Math.min(max, lnglat.y), -max);
        var c;
        if (lat === 0) c = 0;
        else c = Math.log(Math.tan((90 + lat) * rad / 2)) / rad;
        var x = lng * metersPerDegree;
        var y = c * metersPerDegree;
        var z = lnglat.z;
        if (out) {
            out.x = x;
            out.y = y;
            out.z = z;
            return out;
        }
        return new Coordinate(x, y, z);
    },
    unproject: function unproject(pLnglat, out) {
        var rad = this.rad;
        var metersPerDegree = this.metersPerDegree;
        var x = pLnglat.x / metersPerDegree;
        var y = pLnglat.y;
        var c;
        if (y === 0) c = 0;
        else {
            c = y / metersPerDegree;
            c = (2 * Math.atan(Math.exp(c * rad)) - Math.PI / 2) / rad;
        }
        if (Math.abs(Math.abs(x) - 180) < delta) x = sign(x) * 180;
        if (Math.abs(Math.abs(c) - this.maxLatitude) < delta) c = sign(c) * this.maxLatitude;
        var rx = x;
        var ry = c;
        var rz = pLnglat.z;
        if (out) {
            out.x = rx;
            out.y = ry;
            out.z = rz;
            return out;
        }
        return new Coordinate(rx, ry, rz);
    }
};
var EPSG3857 = extend$2({}, CommonProjection, EPSG3857Projection, WGS84Sphere);
var EPSG4326Projection = {
    code: 'EPSG:4326',
    aliases: [
        'EPSG:4490'
    ],
    project: function project(p, out) {
        if (out) {
            out.x = p.x;
            out.y = p.y;
            out.z = p.z;
            return out;
        }
        return new Coordinate(p);
    },
    unproject: function unproject(p, out) {
        if (out) {
            out.x = p.x;
            out.y = p.y;
            out.z = p.z;
            return out;
        }
        return new Coordinate(p);
    }
};
var Projection_EPSG4326 = extend$2({}, CommonProjection, EPSG4326Projection, WGS84Sphere);
var fabs = Math.abs, sin = Math.sin, cos = Math.cos, tan = Math.tan, atan = Math.atan, atan2 = Math.atan2, sqrt = Math.sqrt, log = Math.log, hypot = Math.hypot, sinh = Math.sinh, cosh = Math.cosh;
var HUGE_VAL = Infinity;
function pj_etmerc(P) {
    var cgb = [], cbg = [], utg = [], gtu = [], Qn, Zb, f, n, np, Z;
    P.es;
    f = P.es / (1 + sqrt(1 - P.es));
    np = n = f / (2 - f);
    cgb[0] = n * (2 + n * (-2 / 3 + n * (-2 + n * (116 / 45 + n * (26 / 45 + n * (-2854 / 675))))));
    cbg[0] = n * (-2 + n * (2 / 3 + n * (4 / 3 + n * (-82 / 45 + n * (32 / 45 + n * (4642 / 4725))))));
    np *= n;
    cgb[1] = np * (7 / 3 + n * (-1.6 + n * (-227 / 45 + n * (2704 / 315 + n * (2323 / 945)))));
    cbg[1] = np * (5 / 3 + n * (-16 / 15 + n * (-13 / 9 + n * (904 / 315 + n * (-1522 / 945)))));
    np *= n;
    cgb[2] = np * (56 / 15 + n * (-136 / 35 + n * (-1262 / 105 + n * (73814 / 2835))));
    cbg[2] = np * (-26 / 15 + n * (34 / 21 + n * (1.6 + n * (-12686 / 2835))));
    np *= n;
    cgb[3] = np * (4279 / 630 + n * (-332 / 35 + n * (-399572 / 14175)));
    cbg[3] = np * (1237 / 630 + n * (-2.4 + n * (-24832 / 14175)));
    np *= n;
    cgb[4] = np * (4174 / 315 + n * (-144838 / 6237));
    cbg[4] = np * (-734 / 315 + n * (109598 / 31185));
    np *= n;
    cgb[5] = np * (601676 / 22275);
    cbg[5] = np * (444337 / 155925);
    np = n * n;
    Qn = P.k0 / (1 + n) * (1 + np * (1 / 4 + np * (1 / 64 + np / 256)));
    utg[0] = n * (-0.5 + n * (2 / 3 + n * (-37 / 96 + n * (1 / 360 + n * (81 / 512 + n * (-96199 / 604800))))));
    gtu[0] = n * (0.5 + n * (-2 / 3 + n * (5 / 16 + n * (41 / 180 + n * (-127 / 288 + n * (7891 / 37800))))));
    utg[1] = np * (-1 / 48 + n * (-1 / 15 + n * (437 / 1440 + n * (-46 / 105 + n * (1118711 / 3870720)))));
    gtu[1] = np * (13 / 48 + n * (-0.6 + n * (557 / 1440 + n * (281 / 630 + n * (-1983433 / 1935360)))));
    np *= n;
    utg[2] = np * (-17 / 480 + n * (37 / 840 + n * (209 / 4480 + n * (-5569 / 90720))));
    gtu[2] = np * (61 / 240 + n * (-103 / 140 + n * (15061 / 26880 + n * (167603 / 181440))));
    np *= n;
    utg[3] = np * (-4397 / 161280 + n * (11 / 504 + n * (830251 / 7257600)));
    gtu[3] = np * (49561 / 161280 + n * (-179 / 168 + n * (6601661 / 7257600)));
    np *= n;
    utg[4] = np * (-4583 / 161280 + n * (108847 / 3991680));
    gtu[4] = np * (34729 / 80640 + n * (-3418889 / 1995840));
    np *= n;
    utg[5] = np * (-20648693 / 638668800);
    gtu[5] = np * 0.6650675310896665;
    Z = gatg(cbg, P.phi0);
    Zb = -Qn * (Z + clens(gtu, 2 * Z));
    P.fwd = e_fwd;
    P.inv = e_inv;
    function e_fwd(lp, xy) {
        var sin_Cn, cos_Cn, cos_Ce, sin_Ce, tmp;
        var Cn = lp.phi, Ce = lp.lam;
        Cn = gatg(cbg, Cn);
        sin_Cn = sin(Cn);
        cos_Cn = cos(Cn);
        sin_Ce = sin(Ce);
        cos_Ce = cos(Ce);
        Cn = atan2(sin_Cn, cos_Ce * cos_Cn);
        Ce = atan2(sin_Ce * cos_Cn, hypot(sin_Cn, cos_Cn * cos_Ce));
        Ce = asinhy(tan(Ce));
        tmp = clenS(gtu, 2 * Cn, 2 * Ce);
        Cn += tmp[0];
        Ce += tmp[1];
        if (fabs(Ce) <= 2.623395162778) {
            xy.y = Qn * Cn + Zb;
            xy.x = Qn * Ce;
        } else xy.x = xy.y = HUGE_VAL;
    }
    function e_inv(xy, lp) {
        var sin_Cn, cos_Cn, cos_Ce, sin_Ce, tmp;
        var Cn = xy.y, Ce = xy.x;
        Cn = (Cn - Zb) / Qn;
        Ce = Ce / Qn;
        if (fabs(Ce) <= 2.623395162778) {
            tmp = clenS(utg, 2 * Cn, 2 * Ce);
            Cn += tmp[0];
            Ce += tmp[1];
            Ce = atan(sinh(Ce));
            sin_Cn = sin(Cn);
            cos_Cn = cos(Cn);
            sin_Ce = sin(Ce);
            cos_Ce = cos(Ce);
            Ce = atan2(sin_Ce, cos_Ce * cos_Cn);
            Cn = atan2(sin_Cn * cos_Ce, hypot(sin_Ce, cos_Ce * cos_Cn));
            lp.phi = gatg(cgb, Cn);
            lp.lam = Ce;
        } else lp.phi = lp.lam = HUGE_VAL;
    }
    function log1py(x) {
        var y = 1 + x, z = y - 1;
        return z === 0 ? x : x * log(y) / z;
    }
    function asinhy(x) {
        var y = fabs(x);
        y = log1py(y * (1 + y / (hypot(1, y) + 1)));
        return x < 0 ? -y : y;
    }
    function gatg(pp, B) {
        var cos_2B = 2 * cos(2 * B), i = pp.length - 1, h1 = pp[i], h2 = 0, h;
        while(--i >= 0){
            h = -h2 + cos_2B * h1 + pp[i];
            h2 = h1;
            h1 = h;
        }
        return B + h * sin(2 * B);
    }
    function clens(pp, arg_r) {
        var r = 2 * cos(arg_r), i = pp.length - 1, hr1 = pp[i], hr2 = 0, hr;
        while(--i >= 0){
            hr = -hr2 + r * hr1 + pp[i];
            hr2 = hr1;
            hr1 = hr;
        }
        return sin(arg_r) * hr;
    }
    function clenS(pp, arg_r, arg_i) {
        var sin_arg_r = sin(arg_r), cos_arg_r = cos(arg_r), sinh_arg_i = sinh(arg_i), cosh_arg_i = cosh(arg_i), r = 2 * cos_arg_r * cosh_arg_i, i = -2 * sin_arg_r * sinh_arg_i, j = pp.length - 1, hr = pp[j], hi1 = 0, hr1 = 0, hi = 0, hr2, hi2;
        while(--j >= 0){
            hr2 = hr1;
            hi2 = hi1;
            hr1 = hr;
            hi1 = hi;
            hr = -hr2 + r * hr1 - i * hi1 + pp[j];
            hi = -hi2 + i * hr1 + r * hi1;
        }
        r = sin_arg_r * cosh_arg_i;
        i = cos_arg_r * sinh_arg_i;
        return [
            r * hr - i * hi,
            r * hi + i * hr
        ];
    }
}
var RAD_TO_DEG = 57.295779513082321, DEG_TO_RAD = 0.017453292519943296;
var SRS_WGS84_SEMIMAJOR = 6378137;
var SRS_WGS84_ESQUARED = 0.0066943799901413165;
var aliases = [
    'Traverse_Mercator'
];
var EPSG9807Projection = {
    code: 'EPSG:9807',
    aliases: aliases,
    centralMeridian: 0,
    create: function create(params) {
        var P = {
            a: SRS_WGS84_SEMIMAJOR,
            es: SRS_WGS84_ESQUARED,
            x0: isNil(params.falseEasting) ? 500000 : params.falseEasting,
            y0: isNil(params.falseNorthing) ? 0 : params.falseNorthing,
            k0: params.scaleFactor || 0.9996,
            lam0: (params.centralMeridian || 0) * DEG_TO_RAD,
            phi0: (params.latitudeOfOrigin || 0) * DEG_TO_RAD,
            originLam0: params.startLongtitude || 0,
            originPhi0: params.startLatitude || 0
        };
        pj_etmerc(P);
        var lp = {
            lam: 0,
            phi: 0
        };
        var xy = {};
        var originX = 0;
        var originY = 0;
        if (P.originLam0 || P.originPhi0) {
            lp.lam = P.originLam0 * DEG_TO_RAD - P.lam0;
            lp.phi = P.originPhi0 * DEG_TO_RAD;
            P.fwd(lp, xy);
            originX = P.a * xy.x + P.x0;
            originY = P.a * xy.y + P.y0;
        }
        var methods = {
            code: 'EPSG:9807',
            aliases: aliases,
            centralMeridian: params.centralMeridian,
            project: function project(p, out) {
                lp.lam = p.x * DEG_TO_RAD - P.lam0;
                lp.phi = p.y * DEG_TO_RAD;
                P.fwd(lp, xy);
                var x = P.a * xy.x + P.x0 - originX;
                var y = P.a * xy.y + P.y0 - originY;
                var z = p.z;
                if (out) {
                    out.x = x;
                    out.y = y;
                    out.z = z;
                    return out;
                }
                return new Coordinate(x, y, z);
            },
            unproject: function unproject(p, out) {
                xy.x = (p.x - P.x0 + originX) / P.a;
                xy.y = (p.y - P.y0 + originY) / P.a;
                P.inv(xy, lp);
                var x = (lp.lam + P.lam0) * RAD_TO_DEG;
                var y = lp.phi * RAD_TO_DEG;
                var z = p.z;
                if (out) {
                    out.x = x;
                    out.y = y;
                    out.z = z;
                    return out;
                }
                return new Coordinate(x, y, z);
            }
        };
        return extend$2({}, CommonProjection, methods, WGS84Sphere);
    }
};
var EPSG9807 = extend$2({}, CommonProjection, EPSG9807Projection);
var UTMProjection = {
    code: 'utm',
    aliases: [],
    create: function create(params) {
        var P = {};
        var zone = parseInt(params.zone);
        P.falseNorthing = params.south ? 10000000 : 0;
        P.falseEasting = 500000;
        if (zone > 0 && zone <= 60) zone--;
        else throw new Error('zone must be > 0 and <= 60.');
        P.centralMeridian = (zone + 0.5) * 6 - 180;
        P.scaleFactor = 0.9996;
        return EPSG9807.create(P);
    }
};
var Projection_UTM = extend$2({}, EPSG9807, UTMProjection);
var ProjectionMethods = {
    EARTHRADIUS: 6370996.81,
    MCBAND: [
        12890594.86,
        8362377.87,
        5591021,
        3481989.83,
        1678043.12,
        0
    ],
    LLBAND: [
        75,
        60,
        45,
        30,
        15,
        0
    ],
    MC2LL: [
        [
            1.410526172116255e-8,
            0.00000898305509648872,
            -1.9939833816331,
            200.9824383106796,
            -187.2403703815547,
            91.6087516669843,
            -23.38765649603339,
            2.57121317296198,
            -0.03801003308653,
            17337981.2
        ],
        [
            -0.000000007435856389565537,
            0.000008983055097726239,
            -0.78625201886289,
            96.32687599759846,
            -1.85204757529826,
            -59.36935905485877,
            47.40033549296737,
            -16.50741931063887,
            2.28786674699375,
            10260144.86
        ],
        [
            -0.00000003030883460898826,
            0.00000898305509983578,
            0.30071316287616,
            59.74293618442277,
            7.357984074871,
            -25.38371002664745,
            13.45380521110908,
            -3.29883767235584,
            0.32710905363475,
            6856817.37
        ],
        [
            -0.00000001981981304930552,
            0.000008983055099779535,
            0.03278182852591,
            40.31678527705744,
            0.65659298677277,
            -4.44255534477492,
            0.85341911805263,
            0.12923347998204,
            -0.04625736007561,
            4482777.06
        ],
        [
            3.09191371068437e-9,
            0.000008983055096812155,
            0.00006995724062,
            23.10934304144901,
            -0.00023663490511,
            -0.6321817810242,
            -0.00663494467273,
            0.03430082397953,
            -0.00466043876332,
            2555164.4
        ],
        [
            2.890871144776878e-9,
            0.000008983055095805407,
            -0.00000003068298,
            7.47137025468032,
            -0.00000353937994,
            -0.02145144861037,
            -0.00001234426596,
            0.00010322952773,
            -0.00000323890364,
            826088.5
        ]
    ],
    LL2MC: [
        [
            -0.0015702102444,
            111320.7020616939,
            1704480524535203,
            -10338987376042340,
            26112667856603880,
            -35149669176653700,
            26595700718403920,
            -10725012454188240,
            1800819912950474,
            82.5
        ],
        [
            0.0008277824516172526,
            111320.7020463578,
            647795574.6671607,
            -4082003173.641316,
            10774905663.51142,
            -15171875531.51559,
            12053065338.62167,
            -5124939663.577472,
            913311935.9512032,
            67.5
        ],
        [
            0.00337398766765,
            111320.7020202162,
            4481351.045890365,
            -23393751.19931662,
            79682215.47186455,
            -115964993.2797253,
            97236711.15602145,
            -43661946.33752821,
            8477230.501135234,
            52.5
        ],
        [
            0.00220636496208,
            111320.7020209128,
            51751.86112841131,
            3796837.749470245,
            992013.7397791013,
            -1221952.21711287,
            1340652.697009075,
            -620943.6990984312,
            144416.9293806241,
            37.5
        ],
        [
            -0.0003441963504368392,
            111320.7020576856,
            278.2353980772752,
            2485758.690035394,
            6070.750963243378,
            54821.18345352118,
            9540.606633304236,
            -2710.55326746645,
            1405.483844121726,
            22.5
        ],
        [
            -0.0003218135878613132,
            111320.7020701615,
            0.00369383431289,
            823725.6402795718,
            0.46104986909093,
            2351.343141331292,
            1.58060784298199,
            8.77738589078284,
            0.37238884252424,
            7.45
        ]
    ],
    convertMC2LL: function convertMC2LL(cB, out) {
        var cE;
        for(var cD = 0, len = this.MCBAND.length; cD < len; cD++)if (Math.abs(cB.y) >= this.MCBAND[cD]) {
            cE = this.MC2LL[cD];
            break;
        }
        var T = this.convertor(cB, cE, out);
        return T;
    },
    convertLL2MC: function convertLL2MC(T, out) {
        var cD, cC, len;
        T.x = this.getLoop(T.x, -180, 180);
        T.y = this.getRange(T.y, -74, 74);
        var cB = new Coordinate(T.x, T.y);
        for(cC = 0, len = this.LLBAND.length; cC < len; cC++)if (cB.y >= this.LLBAND[cC]) {
            cD = this.LL2MC[cC];
            break;
        }
        if (!cD) {
            for(cC = this.LLBAND.length - 1; cC >= 0; cC--)if (cB.y <= -this.LLBAND[cC]) {
                cD = this.LL2MC[cC];
                break;
            }
        }
        var cE = this.convertor(T, cD, out);
        return cE;
    },
    convertor: function convertor(cC, cD, out) {
        if (!cC || !cD) return null;
        var T = cD[0] + cD[1] * Math.abs(cC.x);
        var cB = Math.abs(cC.y) / cD[9];
        var cE = cD[2] + cD[3] * cB + cD[4] * cB * cB + cD[5] * cB * cB * cB + cD[6] * cB * cB * cB * cB + cD[7] * cB * cB * cB * cB * cB + cD[8] * cB * cB * cB * cB * cB * cB;
        T *= cC.x < 0 ? -1 : 1;
        cE *= cC.y < 0 ? -1 : 1;
        var z = cC.z;
        if (out) {
            out.x = T;
            out.y = cE;
            out.z = z;
            return out;
        }
        return new Coordinate(T, cE, z);
    },
    toRadians: function toRadians(T) {
        return Math.PI * T / 180;
    },
    toDegrees: function toDegrees(T) {
        return 180 * T / Math.PI;
    },
    getRange: function getRange(cC, cB, T) {
        if (cB != null) cC = Math.max(cC, cB);
        if (T != null) cC = Math.min(cC, T);
        return cC;
    },
    getLoop: function getLoop(cC, cB, T) {
        if (cC === Infinity) return T;
        else if (cC === -Infinity) return cB;
        while(cC > T)cC -= T - cB;
        while(cC < cB)cC += T - cB;
        return cC;
    }
};
var BAIDUProjection = {
    code: 'BAIDU',
    project: function project(p, out) {
        return this.convertLL2MC(p, out);
    },
    unproject: function unproject(p, out) {
        return this.convertMC2LL(p, out);
    }
};
var Projection_Baidu = extend$2({}, CommonProjection, BAIDUProjection, BaiduSphere, ProjectionMethods);
var IdentityProjection = {
    code: 'IDENTITY',
    project: function project(p, out) {
        if (out) {
            out.x = p.x;
            out.y = p.y;
            out.z = p.z;
            return out;
        }
        return p.copy();
    },
    unproject: function unproject(p, out) {
        if (out) {
            out.x = p.x;
            out.y = p.y;
            out.z = p.z;
            return out;
        }
        return p.copy();
    }
};
var Projection_IDENTITY = extend$2({}, CommonProjection, IdentityProjection, extended);
var DEFAULT = EPSG3857;
var projections = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BAIDU: Projection_Baidu,
    Common: CommonProjection,
    DEFAULT: DEFAULT,
    EPSG3857: EPSG3857,
    EPSG4326: Projection_EPSG4326,
    EPSG9807: EPSG9807,
    IDENTITY: Projection_IDENTITY,
    UTM: Projection_UTM
});
function Renderable(Base) {
    return function(_Base) {
        function _class() {
            return _Base.apply(this, arguments) || this;
        }
        _inheritsLoose(_class, _Base);
        _class.registerRenderer = function registerRenderer(name, clazz) {
            var proto = this.prototype;
            var parentProto = Object.getPrototypeOf(proto);
            if (!proto._rendererClasses || proto._rendererClasses === parentProto._rendererClasses) proto._rendererClasses = proto._rendererClasses ? Object.create(proto._rendererClasses) : {};
            proto._rendererClasses[name.toLowerCase()] = clazz;
            return this;
        };
        _class.getRendererClass = function getRendererClass(name) {
            var proto = this.prototype;
            if (!proto._rendererClasses) return null;
            return proto._rendererClasses[name.toLowerCase()];
        };
        return _class;
    }(Base);
}
var DEFAULT_MARKER_SYMBOLS = {
    markerWidth: 10,
    markerHeight: 10,
    markerLineWidth: 1
};
var TEMP_DXDYPOINT = new Point(0, 0);
function getDxDyRad(dxdy) {
    if (!dxdy) return 0;
    var { x: x, y: y } = dxdy;
    if (x === 0 && y === 0) return 0;
    if (x === 0 || !x) {
        if (y < 0) return -Math.PI / 2;
        if (y > 0) return Math.PI / 2;
    }
    var tan = y / x;
    if (y < 0 && x < 0) return Math.atan(tan) - Math.PI;
    else if (y > 0 && x < 0) return Math.atan(tan) + Math.PI;
    return Math.atan(tan);
}
function getImageRotateBBOX(width, height, rad) {
    var rad2 = Math.PI / 2 + rad;
    var rad3 = Math.PI / 4 + rad;
    var rad4 = rad;
    var r2 = height;
    var r3 = Math.sqrt(width * width + height * height);
    var r4 = width;
    var p1x = 0, p1y = 0;
    var p2x = Math.cos(rad2) * r2, p2y = Math.sin(rad2) * r2;
    var p3x = Math.cos(rad3) * r3, p3y = Math.sin(rad3) * r3;
    var p4x = Math.cos(rad4) * r4, p4y = Math.sin(rad4) * r4;
    var minx = Math.min(p2x, p3x, p4x, p1x);
    var miny = Math.min(p2y, p3y, p4y, p1y);
    var maxx = Math.max(p2x, p3x, p4x, p1x);
    var maxy = Math.max(p2y, p3y, p4y, p1y);
    return [
        minx,
        miny,
        maxx - minx,
        maxy - miny
    ];
}
function getMarkerRotationExtent(out, rad, width, height, dxdy, alignPoint) {
    var x = dxdy.x + alignPoint.x, y = dxdy.y + alignPoint.y;
    TEMP_DXDYPOINT.x = x;
    TEMP_DXDYPOINT.y = y;
    var dxdyRad = getDxDyRad(TEMP_DXDYPOINT);
    var radius = Math.sqrt(x * x + y * y);
    var rx = Math.cos(rad + dxdyRad) * radius, ry = Math.sin(rad + dxdyRad) * radius;
    var minx = 0, miny = 0;
    minx += rx;
    miny += ry;
    var [offsetX, offsetY, w, h] = getImageRotateBBOX(width, height, rad);
    minx += offsetX;
    miny += offsetY;
    var maxx = minx + Math.max(width, w), maxy = miny + Math.max(height, h);
    out.set(minx, miny, maxx, maxy);
    return out;
}
function getVectorPadding() {
    return 0.5;
}
var DXDY = new Point(0, 0);
function getFixedExtent(out, dx, dy, rotation, alignPoint, w, h) {
    var dxdy = DXDY.set(dx, dy);
    if (rotation) return getMarkerRotationExtent(out, rotation, w, h, dxdy, alignPoint);
    var result = out.set(dxdy.x, dxdy.y, dxdy.x + w, dxdy.y + h);
    result._add(alignPoint);
    if (rotation) rotateExtent(result, rotation);
    return result;
}
var SIZE = [];
function getVectorMarkerFixedExtent(out, symbol, size) {
    size = size || calVectorMarkerSize(SIZE, symbol);
    if (size && (size[0] === 0 || size[1] === 0)) {
        emptyExtent(out);
        return out;
    }
    var alignPoint = getVectorMarkerAnchor(symbol, size[0], size[1]);
    return getFixedExtent(out, symbol['markerDx'] || 0, symbol['markerDy'] || 0, getMarkerRotation(symbol), alignPoint, size[0], size[1]);
}
function getDefaultHAlign(markerType) {
    if (markerType === 'rectangle') return 'right';
    else return 'middle';
}
function getDefaultVAlign(markerType) {
    if (markerType === 'bar' || markerType === 'pie' || markerType === 'pin') return 'top';
    else if (markerType === 'rectangle') return 'bottom';
    else return 'middle';
}
var TEMP_SIZE$1 = new Size(0, 0);
function getVectorMarkerAnchor(symbol, w, h) {
    var padding = getVectorPadding();
    var shadow = 2 * (symbol['shadowBlur'] || 0), margin = shadow + padding;
    TEMP_SIZE$1.width = w;
    TEMP_SIZE$1.height = h;
    var markerType = symbol['markerType'];
    var p = getAlignPoint(TEMP_SIZE$1, symbol['markerHorizontalAlignment'] || getDefaultHAlign(markerType), symbol['markerVerticalAlignment'] || getDefaultVAlign(markerType));
    if (p.x !== -w / 2) p.x -= sign(p.x + w / 2) * margin;
    if (p.y !== -h / 2) p.y -= sign(p.y + h / 2) * margin;
    return p;
}
function calVectorMarkerSize(out, symbol) {
    var padding = getVectorPadding();
    var width = getValueOrDefault(symbol['markerWidth'], DEFAULT_MARKER_SYMBOLS.markerWidth);
    var height = getValueOrDefault(symbol['markerHeight'], DEFAULT_MARKER_SYMBOLS.markerHeight);
    if (width === 0 || height === 0) {
        out[0] = 0;
        out[1] = 0;
        return out;
    }
    var lineWidth = getValueOrDefault(symbol['markerLineWidth'], DEFAULT_MARKER_SYMBOLS.markerLineWidth), shadow = 2 * ((symbol['shadowBlur'] || 0) + Math.max(Math.abs(symbol['shadowOffsetX'] || 0) + Math.abs(symbol['shadowOffsetY'] || 0))), w = Math.round(width + lineWidth + shadow + padding * 2), h = Math.round(height + lineWidth + shadow + padding * 2);
    out[0] = w;
    out[1] = h;
    return out;
}
var ROTATE_EXTENT = new PointExtent();
function rotateExtent(fixedExtent, angle) {
    var { xmin: xmin, ymin: ymin, xmax: xmax, ymax: ymax } = fixedExtent;
    ROTATE_EXTENT.set(xmin, ymin, xmax, ymax);
    return ROTATE_EXTENT.convertTo(function(p) {
        return p._rotate(angle);
    }, fixedExtent);
}
function getMarkerRotation(symbol, prop = 'markerRotation') {
    var r = symbol[prop];
    if (!isNumber(r)) return 0;
    return -r * Math.PI / 180;
}
function getImageMarkerFixedExtent(out, symbol, resources) {
    var url = symbol['markerFile'], img = resources ? resources.getImage(url) : null;
    var width = symbol['markerWidth'] || (img ? img.width : 0), height = symbol['markerHeight'] || (img ? img.height : 0);
    TEMP_SIZE$1.width = width;
    TEMP_SIZE$1.height = height;
    if (symbol['markerWidth'] === 0 || symbol['markerHeight'] === 0) {
        emptyExtent(out);
        return out;
    }
    var alignPoint = getAlignPoint(TEMP_SIZE$1, symbol['markerHorizontalAlignment'] || 'middle', symbol['markerVerticalAlignment'] || 'top');
    return getFixedExtent(out, symbol['markerDx'] || 0, symbol['markerDy'] || 0, getMarkerRotation(symbol), alignPoint, width, height);
}
function getTextMarkerFixedExtent(out, symbol, textDesc) {
    var size = textDesc['size'];
    if (size && (size.width === 0 || size.height === 0)) {
        emptyExtent(out);
        return out;
    }
    var alignPoint = getAlignPoint(size, symbol['textHorizontalAlignment'], symbol['textVerticalAlignment']);
    var textHaloRadius = symbol.textHaloRadius || 0;
    var extent = getFixedExtent(out, symbol['textDx'] || 0, symbol['textDy'] || 0, getMarkerRotation(symbol, 'textRotation'), alignPoint, size.width, size.height);
    extent.xmin -= textHaloRadius;
    extent.xmax += textHaloRadius;
    extent.ymin -= textHaloRadius;
    extent.ymax += textHaloRadius;
    return extent;
}
var FIXED_EXTENT = new PointExtent();
function getMarkerFixedExtent(out, symbol, resources, textDesc) {
    var extent = out || new PointExtent();
    if (Array.isArray(symbol)) {
        var symbols = symbol;
        for(var i = 0; i < symbols.length; i++)getMarkerFixedExtent(extent, symbols[i], resources, textDesc[i]);
        return extent;
    }
    if (isTextSymbol(symbol)) extent._combine(getTextMarkerFixedExtent(FIXED_EXTENT, symbol, textDesc));
    if (isImageSymbol(symbol)) extent._combine(getImageMarkerFixedExtent(FIXED_EXTENT, symbol, resources));
    if (isVectorSymbol(symbol)) extent._combine(getVectorMarkerFixedExtent(FIXED_EXTENT, symbol));
    if (isPathSymbol(symbol)) extent._combine(getImageMarkerFixedExtent(FIXED_EXTENT, symbol));
    return extent;
}
function isTextSymbol(symbol) {
    if (!symbol) return false;
    if (!isNil(symbol['textName'])) return true;
    return false;
}
function isImageSymbol(symbol) {
    if (!symbol) return false;
    if (!isNil(symbol['markerFile'])) return true;
    return false;
}
function isVectorSymbol(symbol) {
    if (!symbol) return false;
    if (isNil(symbol['markerFile']) && !isNil(symbol['markerType']) && symbol['markerType'] !== 'path') return true;
    return false;
}
function isPathSymbol(symbol) {
    if (!symbol) return false;
    if (isNil(symbol['markerFile']) && symbol['markerType'] === 'path') return true;
    return false;
}
var DYNAMIC_SYMBOL_PROPS = [
    'markerWidth',
    'markerHeight',
    'markerHorizontalAlignment',
    'markerVerticalAlignment',
    'markerDx',
    'markerDy',
    'markerRotation',
    'textName',
    'textSize',
    'textDx',
    'textDy',
    'textVerticalAlignment',
    'textHorizontalAlignment',
    'textRotation',
    'textWrapWidth'
];
var SIZE_SYMBOL_PROPS = [
    'textName',
    'markerType',
    'markerFile',
    'textHaloRadius',
    'shadowBlur',
    'shadowOffsetX',
    'shadowOffsetY',
    'textWrapWidth'
];
function emptyExtent(extent) {
    if (!extent) return;
    extent.xmin = Infinity;
    extent.ymin = Infinity;
    extent.xmax = -Infinity;
    extent.ymax = -Infinity;
}
function clipLine(points, bounds, round, noCut) {
    var parts = [];
    var k = 0, segment;
    for(var j = 0, l = points.length; j < l - 1; j++){
        segment = clipSegment(points[j], points[j + 1], bounds, j, round, noCut);
        if (!segment) continue;
        parts[k] = parts[k] || [];
        parts[k].push({
            'point': segment[0],
            'index': j
        });
        if (segment[1] !== points[j + 1] || j === l - 2) {
            parts[k].push({
                'point': segment[1],
                'index': j + 1
            });
            k++;
        }
    }
    return parts;
}
var _lastCode;
function clipSegment(a, b, bounds, useLastCode, round, noCut) {
    var codeA = useLastCode ? _lastCode : _getBitCode(a, bounds), codeB = _getBitCode(b, bounds), codeOut, p, newCode;
    _lastCode = codeB;
    while(true){
        if (!(codeA | codeB)) return [
            a,
            b
        ];
        if (codeA & codeB) return false;
        if (noCut) return [
            a,
            b
        ];
        codeOut = codeA || codeB;
        p = _getEdgeIntersection(a, b, codeOut, bounds, round);
        newCode = _getBitCode(p, bounds);
        if (codeOut === codeA) {
            a = p;
            codeA = newCode;
        } else {
            b = p;
            codeB = newCode;
        }
    }
}
function clipPolygon(points, bounds, round) {
    var edges = [
        1,
        4,
        2,
        8
    ];
    var clippedPoints, i, j, k, a, b, len, edge, p;
    for(i = 0, len = points.length; i < len; i++)points[i]._code = _getBitCode(points[i], bounds);
    for(k = 0; k < 4; k++){
        edge = edges[k];
        clippedPoints = [];
        for(i = 0, len = points.length, j = len - 1; i < len; j = i++){
            a = points[i];
            b = points[j];
            if (!(a._code & edge)) {
                if (b._code & edge) {
                    p = _getEdgeIntersection(b, a, edge, bounds, round);
                    p._code = _getBitCode(p, bounds);
                    clippedPoints.push(p);
                }
                clippedPoints.push(a);
            } else if (!(b._code & edge)) {
                p = _getEdgeIntersection(b, a, edge, bounds, round);
                p._code = _getBitCode(p, bounds);
                clippedPoints.push(p);
            }
        }
        points = clippedPoints;
    }
    return points;
}
function _getEdgeIntersection(a, b, code, bounds, round) {
    var dx = b.x - a.x, dy = b.y - a.y, min = bounds.getMin(), max = bounds.getMax();
    var x, y;
    if (code & 8) {
        x = a.x + dx * (max.y - a.y) / dy;
        y = max.y;
    } else if (code & 4) {
        x = a.x + dx * (min.y - a.y) / dy;
        y = min.y;
    } else if (code & 2) {
        x = max.x;
        y = a.y + dy * (max.x - a.x) / dx;
    } else if (code & 1) {
        x = min.x;
        y = a.y + dy * (min.x - a.x) / dx;
    }
    var p = new Point(x, y);
    if (round) p._round();
    return p;
}
function _getBitCode(p, bounds) {
    var code = 0;
    if (p.x < bounds.getMin().x) code |= 1;
    else if (p.x > bounds.getMax().x) code |= 2;
    if (p.y < bounds.getMin().y) code |= 4;
    else if (p.y > bounds.getMax().y) code |= 8;
    return code;
}
function withInEllipse(point, center, southeast, tolerance) {
    point = new Point(point);
    var a = Math.abs(southeast.x - center.x), b = Math.abs(southeast.y - center.y), c = Math.sqrt(Math.abs(a * a - b * b)), xfocus = a >= b;
    var f1, f2, d;
    if (xfocus) {
        f1 = new Point(center.x - c, center.y);
        f2 = new Point(center.x + c, center.y);
        d = a * 2;
    } else {
        f1 = new Point(center.x, center.y - c);
        f2 = new Point(center.x, center.y + c);
        d = b * 2;
    }
    return point.distanceTo(f1) + point.distanceTo(f2) <= d + 2 * tolerance;
}
function getMinMaxAltitude(altitude) {
    if (!altitude) return [
        0,
        0
    ];
    var min = Infinity, max = -Infinity;
    if (isNumber(altitude)) {
        min = max = altitude;
        return [
            min,
            max
        ];
    }
    var pathMinMax = function pathMinMax(alts) {
        for(var i = 0, len = alts.length; i < len; i++){
            var alt = alts[i];
            min = Math.min(min, alt);
            max = Math.max(max, alt);
        }
    };
    if (!Array.isArray(altitude[0])) {
        pathMinMax(altitude);
        return [
            min,
            max
        ];
    }
    for(var i = 0, len = altitude.length; i < len; i++){
        var alts = altitude[i];
        pathMinMax(alts);
    }
    return [
        min,
        max
    ];
}
var Symbolizer = function() {
    function Symbolizer() {
        this.bbox = getDefaultBBOX();
    }
    var _proto = Symbolizer.prototype;
    _proto._setBBOX = function _setBBOX(ctx, x1, y1, x2, y2) {
        if (!ctx.isHitTesting) setBBOX(this.bbox, x1, y1, x2, y2);
        return this;
    };
    _proto._bufferBBOX = function _bufferBBOX(ctx, bufferSize) {
        if (!ctx.isHitTesting) bufferBBOX(this.bbox, bufferSize);
        return this;
    };
    _proto.getMap = function getMap() {
        return this.geometry.getMap();
    };
    _proto.getPainter = function getPainter() {
        return this.painter;
    };
    _proto.isDynamicSize = function isDynamicSize() {
        return false;
    };
    _proto.isVisible = function isVisible() {
        if (!this.style) return true;
        var visible = this.style.visible;
        if (visible === false || visible === 0) return false;
        var opacity = this.style.opacity;
        if (opacity <= 0) return false;
        return true;
    };
    Symbolizer.testColor = function testColor(prop) {
        if (!prop || !isString(prop)) return false;
        if (COLOR_PROPERTIES.indexOf(prop) >= 0) return true;
        return false;
    };
    return Symbolizer;
}();
var CanvasSymbolizer = function(_Symbolizer) {
    function CanvasSymbolizer() {
        return _Symbolizer.apply(this, arguments) || this;
    }
    _inheritsLoose(CanvasSymbolizer, _Symbolizer);
    var _proto = CanvasSymbolizer.prototype;
    _proto._prepareContext = function _prepareContext(ctx) {
        if (isFunctionDefinition(this.symbol['opacity'])) {
            if (!this._opacityFn) this._opacityFn = interpolated(this.symbol['opacity']);
        } else delete this._opacityFn;
        if (isNumber(this.symbol['opacity'])) {
            if (ctx.globalAlpha !== this.symbol['opacity']) ctx.globalAlpha = this.symbol['opacity'];
        } else if (this._opacityFn) {
            var map = this.getMap();
            ctx.globalAlpha = this._opacityFn(map.getZoom());
        } else if (ctx.globalAlpha !== 1) ctx.globalAlpha = 1;
    };
    _proto.prepareCanvas = function prepareCanvas(ctx, style, resources) {
        if (ctx.setLineDash && isArrayHasData(style['lineDasharray'])) ctx.setLineDash(style['lineDasharray']);
        var isHitTesting = this.getPainter().isHitTesting();
        Canvas.prepareCanvas(ctx, style, resources, isHitTesting);
    };
    _proto.remove = function remove() {};
    _proto.setZIndex = function setZIndex() {};
    _proto.show = function show() {};
    _proto.hide = function hide() {};
    _proto._defineStyle = function _defineStyle(style) {
        if (this.symbol) {
            style.visible = this.symbol.visible;
            style.opacity = this.symbol.opacity;
        }
        return loadGeoSymbol(style, this.geometry);
    };
    return CanvasSymbolizer;
}(Symbolizer);
function getImage(resources, url) {
    var img = resources && resources.getImage(url);
    return img || null;
}
function drawVectorMarker(ctx, point, symbol, resources, bbox) {
    var strokeAndFill = translateMarkerLineAndFill(symbol);
    var style = symbol, markerType = style['markerType'].toLowerCase(), vectorArray = getVectorMarkerPoints(markerType, style['markerWidth'], style['markerHeight']), lineOpacity = strokeAndFill['lineOpacity'], fillOpacity = strokeAndFill['polygonOpacity'];
    var gradient = isGradient(strokeAndFill['polygonFill']);
    if (gradient) {
        var gradientExtent;
        if (isGradient(strokeAndFill['polygonFill'])) {
            if (!gradientExtent) gradientExtent = getGraidentExtent(point, style.markerWidth, style.markerHeight);
            strokeAndFill['polygonGradientExtent'] = gradientExtent;
        }
    }
    Canvas.prepareCanvas(ctx, strokeAndFill, resources);
    var width = style['markerWidth'], height = style['markerHeight'], lineWidth = style['markerLineWidth'] || 0, hLineWidth = lineWidth / 2;
    if (markerType === 'ellipse') Canvas.ellipse(ctx, point, width / 2, height / 2, height / 2, lineOpacity, fillOpacity);
    else if (markerType === 'cross' || markerType === 'x') {
        for(var j = vectorArray.length - 1; j >= 0; j--)vectorArray[j]._add(point);
        Canvas.path(ctx, vectorArray.slice(0, 2), lineOpacity);
        Canvas.path(ctx, vectorArray.slice(2, 4), lineOpacity);
    } else if (markerType === 'diamond' || markerType === 'bar' || markerType === 'square' || markerType === 'rectangle' || markerType === 'triangle') {
        if (markerType === 'bar') point = point.add(0, -hLineWidth);
        else if (markerType === 'rectangle') point = point.add(hLineWidth, hLineWidth);
        for(var _j = vectorArray.length - 1; _j >= 0; _j--)vectorArray[_j]._add(point);
        Canvas.polygon(ctx, vectorArray, lineOpacity, fillOpacity);
    } else if (markerType === 'pin') {
        point = point.add(0, -hLineWidth);
        for(var _j2 = vectorArray.length - 1; _j2 >= 0; _j2--)vectorArray[_j2]._add(point);
        var lineCap = ctx.lineCap;
        ctx.lineCap = 'round';
        Canvas.bezierCurveAndFill(ctx, vectorArray, lineOpacity, fillOpacity);
        ctx.lineCap = lineCap;
    } else if (markerType === 'pie') {
        point = point.add(0, -hLineWidth);
        var angle = Math.atan(width / 2 / height) * 180 / Math.PI;
        var _lineCap = ctx.lineCap;
        ctx.lineCap = 'round';
        Canvas.sector(ctx, point, height, [
            90 - angle,
            90 + angle
        ], lineOpacity, fillOpacity);
        ctx.lineCap = _lineCap;
    } else throw new Error('unsupported markerType: ' + markerType);
    if (bbox) {
        var { x: x, y: y } = point;
        bbox[0] = x - width / 2 - lineWidth;
        bbox[1] = y - height / 2 - lineWidth;
        bbox[2] = x + width / 2 + lineWidth;
        bbox[3] = y + height / 2 + lineWidth;
    }
    return ctx.canvas;
}
function getGraidentExtent(point, w, h) {
    var e = new PointExtent();
    e._combine(point);
    e['xmin'] += -w / 2;
    e['ymin'] += -h / 2;
    e['xmax'] += w / 2;
    e['ymax'] += h / 2;
    return e;
}
function translateMarkerLineAndFill(s) {
    var result = {
        'lineColor': s['markerLineColor'],
        'linePatternFile': s['markerLinePatternFile'],
        'lineWidth': s['markerLineWidth'],
        'lineOpacity': s['markerLineOpacity'],
        'lineDasharray': s['markerLineDasharray'],
        'lineCap': 'butt',
        'lineJoin': 'round',
        'polygonFill': s['markerFill'],
        'polygonPatternFile': s['markerFillPatternFile'],
        'polygonOpacity': s['markerFillOpacity']
    };
    if (result['lineWidth'] === 0) result['lineOpacity'] = 0;
    return result;
}
function getVectorMarkerPoints(markerType, width, height) {
    var hh = height / 2, hw = width / 2;
    var left = 0, top = 0;
    var v0, v1, v2, v3;
    if (markerType === 'triangle') {
        v0 = new Point(left, top - hh);
        v1 = new Point(left - hw, top + hh);
        v2 = new Point(left + hw, top + hh);
        return [
            v0,
            v1,
            v2
        ];
    } else if (markerType === 'cross') {
        v0 = new Point(left - hw, top);
        v1 = new Point(left + hw, top);
        v2 = new Point(left, top - hh);
        v3 = new Point(left, top + hh);
        return [
            v0,
            v1,
            v2,
            v3
        ];
    } else if (markerType === 'diamond') {
        v0 = new Point(left - hw, top);
        v1 = new Point(left, top - hh);
        v2 = new Point(left + hw, top);
        v3 = new Point(left, top + hh);
        return [
            v0,
            v1,
            v2,
            v3
        ];
    } else if (markerType === 'square') {
        v0 = new Point(left - hw, top + hh);
        v1 = new Point(left + hw, top + hh);
        v2 = new Point(left + hw, top - hh);
        v3 = new Point(left - hw, top - hh);
        return [
            v0,
            v1,
            v2,
            v3
        ];
    } else if (markerType === 'rectangle') {
        v0 = new Point(left, top);
        v1 = v0.add(width, 0);
        v2 = v0.add(width, height);
        v3 = v0.add(0, height);
        return [
            v0,
            v1,
            v2,
            v3
        ];
    } else if (markerType === 'x') {
        v0 = new Point(left - hw, top + hh);
        v1 = new Point(left + hw, top - hh);
        v2 = new Point(left + hw, top + hh);
        v3 = new Point(left - hw, top - hh);
        return [
            v0,
            v1,
            v2,
            v3
        ];
    } else if (markerType === 'bar') {
        v0 = new Point(left - hw, top - height);
        v1 = new Point(left + hw, top - height);
        v2 = new Point(left + hw, top);
        v3 = new Point(left - hw, top);
        return [
            v0,
            v1,
            v2,
            v3
        ];
    } else if (markerType === 'pin' || markerType === 'pie') {
        var extWidth = height * Math.atan(hw / hh);
        v0 = new Point(left, top);
        v1 = new Point(left - extWidth, top - height);
        v2 = new Point(left + extWidth, top - height);
        v3 = new Point(left, top);
        return [
            v0,
            v1,
            v2,
            v3
        ];
    }
    return [];
}
var TEMP_POINT0$3 = new Point(0, 0);
var TEMP_POINT1$2 = new Point(0, 0);
var TEMP_POINT2$2 = new Point(0, 0);
var TEMP_POINT3$1 = new Point(0, 0);
var PointSymbolizer = function(_CanvasSymbolizer) {
    function PointSymbolizer(symbol, geometry, painter) {
        var _this;
        _this = _CanvasSymbolizer.call(this) || this;
        _this.symbol = symbol;
        _this.geometry = geometry;
        _this.painter = painter;
        _this.rotations = [];
        return _this;
    }
    _inheritsLoose(PointSymbolizer, _CanvasSymbolizer);
    var _proto = PointSymbolizer.prototype;
    _proto.get2DExtent = function get2DExtent() {
        var map = this.getMap();
        var glRes = map.getGLRes();
        var extent = new PointExtent();
        var renderPoints = this._getRenderPoints()[0];
        for(var i = renderPoints.length - 1; i >= 0; i--)if (renderPoints[i]) extent._combine(map._pointAtResToPoint(renderPoints[i], glRes));
        return extent;
    };
    _proto.isDynamicSize = function isDynamicSize() {
        var symbol = this.symbol;
        return isFunctionDefinition(symbol['markerWidth']) || isFunctionDefinition(symbol['markerHeight']) || isFunctionDefinition(symbol['textSize']);
    };
    _proto._rotateExtent = function _rotateExtent(fixedExtent, angle) {
        return fixedExtent.convertTo(function(p) {
            return p._rotate(angle);
        });
    };
    _proto._getRenderPoints = function _getRenderPoints() {
        var painter = this.getPainter();
        var placement = painter.isSpriting() ? 'center' : this.getPlacement();
        return this.getPainter().getRenderPoints(placement);
    };
    _proto._getRenderContainerPoints = function _getRenderContainerPoints(ignoreAltitude) {
        var painter = this.getPainter();
        if (painter.isSpriting()) return this._getRenderPoints()[0];
        var geometry = this.geometry;
        var dxdy = this.getDxDy();
        var cpoints;
        if (geometry._cPoint && !ignoreAltitude) {
            var p = ignoreAltitude ? TEMP_POINT2$2 : TEMP_POINT3$1;
            p.set(geometry._cPoint.x, geometry._cPoint.y);
            var containerOffset = painter.containerOffset;
            p._sub(containerOffset);
            var dx = dxdy.x, dy = dxdy.y;
            if (dx || dy) p._add(dx || 0, dy || 0);
            cpoints = [
                p
            ];
        } else {
            var points = this._getRenderPoints()[0];
            cpoints = this.painter._pointContainerPoints(points, dxdy.x, dxdy.y, ignoreAltitude, true, this.getPlacement());
        }
        if (!cpoints || !Array.isArray(cpoints[0])) return cpoints;
        var flat = [];
        for(var i = 0, l = cpoints.length; i < l; i++)for(var ii = 0, ll = cpoints[i].length; ii < ll; ii++)flat.push(cpoints[i][ii]);
        return flat;
    };
    _proto.getPlacement = function getPlacement() {
        return this.symbol['markerPlacement'];
    };
    _proto.getRotation = function getRotation() {
        return getMarkerRotation(this.style);
    };
    _proto.getDxDy = function getDxDy() {
        var s = this.style;
        var dx = s['markerDx'], dy = s['markerDy'];
        return new Point(dx, dy);
    };
    _proto._getRotationAt = function _getRotationAt(i) {
        var r = this.getRotation();
        if (!r) r = 0;
        var rotations = this._getRenderPoints()[1];
        if (!rotations || !rotations[i]) return r;
        var map = this.getMap();
        var p0 = rotations[i][0], p1 = rotations[i][1];
        if (!p0 || !p1) return r;
        if (map.isTransforming()) {
            var glRes = map.getGLRes();
            p0 = map._pointAtResToContainerPoint(rotations[i][0], glRes, 0, TEMP_POINT0$3);
            p1 = map._pointAtResToContainerPoint(rotations[i][1], glRes, 0, TEMP_POINT1$2);
            return r + computeDegree(p0.x, p0.y, p1.x, p1.y);
        } else return r + -computeDegree(p0.x, p0.y, p1.x, p1.y);
    };
    _proto._rotate = function _rotate(ctx, origin, rotation) {
        if (rotation) {
            var dxdy = this.getDxDy();
            var p = origin.sub(dxdy);
            ctx.save();
            ctx.translate(p.x, p.y);
            ctx.rotate(rotation);
            return dxdy;
        }
        return null;
    };
    return PointSymbolizer;
}(CanvasSymbolizer);
var DebugSymbolizer = function(_PointSymbolizer) {
    function DebugSymbolizer() {
        return _PointSymbolizer.apply(this, arguments) || this;
    }
    _inheritsLoose(DebugSymbolizer, _PointSymbolizer);
    var _proto = DebugSymbolizer.prototype;
    _proto.getPlacement = function getPlacement() {
        return 'point';
    };
    _proto.getDxDy = function getDxDy() {
        return new Point(0, 0);
    };
    _proto.symbolize = function symbolize(ctx) {
        var geometry = this.geometry, layer = geometry.getLayer();
        if (!geometry.options['debug'] && layer && !layer.options['debug']) return;
        var map = this.getMap();
        if (!map || map.isZooming()) return;
        var color = layer.options['debugOutline'], op = 1;
        ctx.strokeStyle = color;
        ctx.fillStyle = color;
        ctx.lineWidth = 1;
        ctx.font = '18px  serif';
        var outline = geometry.getContainerExtent().toArray();
        Canvas.polygon(ctx, [
            outline
        ], op, 0);
        var points = this._getRenderContainerPoints(), id = this.geometry.getId(), cross = getVectorMarkerPoints('cross', 10, 10);
        for(var i = 0; i < points.length; i++){
            var p = points[i];
            if (!isNil(id)) Canvas.fillText(ctx, id, p.add(8, -4), color);
            var c = [];
            for(var ii = 0; ii < cross.length; ii++)c.push(cross[ii].add(p));
            Canvas.path(ctx, c.slice(0, 2), op);
            Canvas.path(ctx, c.slice(2, 4), op);
        }
    };
    return DebugSymbolizer;
}(PointSymbolizer);
var TEMP_SIZE = new Size(1, 1);
var TEMP_EXTENT$8 = new PointExtent();
var ImageMarkerSymbolizer = function(_PointSymbolizer) {
    function ImageMarkerSymbolizer(symbol, geometry, painter) {
        var _this;
        _this = _PointSymbolizer.call(this, symbol, geometry, painter) || this;
        _this.style = _this._defineStyle(_this.translate());
        return _this;
    }
    _inheritsLoose(ImageMarkerSymbolizer, _PointSymbolizer);
    ImageMarkerSymbolizer.test = function test(symbol) {
        return isImageSymbol(symbol);
    };
    var _proto = ImageMarkerSymbolizer.prototype;
    _proto.symbolize = function symbolize(ctx, resources) {
        if (!this.isVisible()) return;
        var style = this.style;
        if (!this.painter.isHitTesting() && (style['markerWidth'] === 0 || style['markerHeight'] === 0 || style['markerOpacity'] === 0)) return;
        var cookedPoints = this._getRenderContainerPoints();
        if (!isArrayHasData(cookedPoints)) return;
        if (!style.markerFile && !this._url) {
            console.warn('not find icon url:', style);
            return;
        }
        var img = this._getImage(resources);
        if (!img) {
            if (typeof console !== 'undefined') console.warn('no img found for ' + (this.style['markerFile'] || this._url[0]));
            return;
        }
        this._prepareContext(ctx);
        var width = style['markerWidth'];
        var height = style['markerHeight'];
        if (!isNumber(width) || !isNumber(height)) {
            width = img.width;
            height = img.height;
            style['markerWidth'] = width;
            style['markerHeight'] = height;
            var imgURL = style['markerFile'];
            if (!resources.isResourceLoaded(imgURL)) resources.addResource(imgURL, img);
            var painter = this.getPainter();
            if (!painter.isSpriting()) painter.removeCache();
        }
        var alpha;
        if (this.symbol['markerType'] !== 'path' && isNumber(style['markerOpacity']) && style['markerOpacity'] < 1) {
            alpha = ctx.globalAlpha;
            ctx.globalAlpha *= style['markerOpacity'];
        }
        TEMP_SIZE.width = width;
        TEMP_SIZE.height = height;
        var alignPoint = getAlignPoint(TEMP_SIZE, style['markerHorizontalAlignment'], style['markerVerticalAlignment']);
        this.rotations = [];
        for(var i = 0, len = cookedPoints.length; i < len; i++){
            var p = cookedPoints[i];
            var origin = this._rotate(ctx, p, this._getRotationAt(i));
            var extent = void 0;
            if (origin) {
                var pixel = p.sub(origin);
                p = origin;
                var rad = this._getRotationAt(i);
                extent = getMarkerRotationExtent(TEMP_EXTENT$8, rad, width, height, p, alignPoint);
                extent._add(pixel);
                this.rotations.push(rad);
            }
            var x = p.x + alignPoint.x, y = p.y + alignPoint.y;
            Canvas.image(ctx, img, x, y, width, height);
            if (origin) ctx.restore();
            if (origin) this._setBBOX(ctx, extent.xmin, extent.ymin, extent.xmax, extent.ymax);
            else this._setBBOX(ctx, x, y, x + width, y + height);
        }
        if (alpha !== undefined) ctx.globalAlpha = alpha;
    };
    _proto._getImage = function _getImage(resources) {
        return getImage(resources, this.style['markerFile']);
    };
    _proto.getFixedExtent = function getFixedExtent(resources) {
        this._fixedExtent = this._fixedExtent || new PointExtent();
        return getImageMarkerFixedExtent(this._fixedExtent, this.style, resources);
    };
    _proto.translate = function translate() {
        var s = this.symbol;
        return {
            markerFile: s['markerFile'],
            markerOpacity: getValueOrDefault(s['markerOpacity'], 1),
            markerWidth: getValueOrDefault(s['markerWidth'], null),
            markerHeight: getValueOrDefault(s['markerHeight'], null),
            markerRotation: getValueOrDefault(s['markerRotation'], 0),
            markerDx: getValueOrDefault(s['markerDx'], 0),
            markerDy: getValueOrDefault(s['markerDy'], 0),
            markerHorizontalAlignment: getValueOrDefault(s['markerHorizontalAlignment'], 'middle'),
            markerVerticalAlignment: getValueOrDefault(s['markerVerticalAlignment'], 'top')
        };
    };
    return ImageMarkerSymbolizer;
}(PointSymbolizer);
let canvas;
const OPTIONS = {
    width: 100,
    height: 10
};
// const ISNODE = typeof global === 'object';
let offscreenCanvas = false;
try {
    const canvas = new OffscreenCanvas(1, 1);
    const ctx = canvas.getContext('2d');
    ctx.fillText('hello', 0, 0);
    offscreenCanvas = true;
} catch (err) {
    offscreenCanvas = false;
}
function getCanvas() {
    if (!canvas) {
        const { width, height } = OPTIONS;
        if (offscreenCanvas) canvas = new OffscreenCanvas(width, height);
        else {
            canvas = document.createElement('canvas');
            canvas.width = width;
            canvas.height = height;
        }
    }
    return canvas;
}
class ColorIn {
    constructor(colors, options = {}){
        if (!Array.isArray(colors)) {
            console.error('colors is not array');
            return;
        }
        if (colors.length < 2) {
            console.error('colors.length should >1');
            return;
        }
        this.colors = colors;
        let min = Infinity, max = -Infinity;
        for(let i = 0, len = colors.length; i < len; i++){
            const value = colors[i][0];
            min = Math.min(value, min);
            max = Math.max(value, max);
        }
        this.min = min;
        this.max = max;
        this.valueOffset = this.max - this.min;
        this.options = Object.assign({}, OPTIONS, options);
        this._initImgData();
    }
    getImageData() {
        return this.imgData;
    }
    _initImgData() {
        const canvas = getCanvas();
        const { width, height } = this.options;
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        const gradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
        const { colors, valueOffset } = this;
        for(let i = 0, len = colors.length; i < len; i++){
            const [stop, color] = colors[i];
            const s = (stop - this.min) / valueOffset;
            gradient.addColorStop(s, color);
        }
        ctx.fillStyle = gradient;
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        this.imgData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    }
    getColor(stop) {
        stop = Math.max(this.min, stop);
        stop = Math.min(stop, this.max);
        const s = (stop - this.min) / this.valueOffset;
        let x = Math.round(s * this.imgData.width);
        x = Math.min(x, this.imgData.width - 1);
        const idx = x * 4;
        const r = this.imgData.data[idx];
        const g = this.imgData.data[idx + 1];
        const b = this.imgData.data[idx + 2];
        const a = this.imgData.data[idx + 3];
        return [
            r,
            g,
            b,
            a
        ];
    }
}
var TEMP_COORD0 = new Coordinate(0, 0);
var TEMP_COORD1 = new Coordinate(0, 0);
var StrokeAndFillSymbolizer = function(_CanvasSymbolizer) {
    function StrokeAndFillSymbolizer(symbol, geometry, painter) {
        var _this;
        _this = _CanvasSymbolizer.call(this) || this;
        _this.symbol = symbol;
        _this.geometry = geometry;
        _this.painter = painter;
        if (geometry.isPoint) return _assertThisInitialized(_this);
        _this.style = _this._defineStyle(_this.translate());
        return _this;
    }
    _inheritsLoose(StrokeAndFillSymbolizer, _CanvasSymbolizer);
    StrokeAndFillSymbolizer.test = function test(symbol, geometry) {
        if (!symbol) return false;
        if (geometry && geometry.isPoint) return false;
        for(var p in symbol){
            var f = p.slice(0, 4);
            if (f === 'line' || f === 'poly') return true;
        }
        return false;
    };
    var _proto = StrokeAndFillSymbolizer.prototype;
    _proto.symbolize = function symbolize(ctx, resources) {
        if (!this.isVisible()) return;
        var style = this.style;
        if (style['polygonOpacity'] === 0 && style['lineOpacity'] === 0 && !this.painter.isHitTesting()) return;
        var paintParams = this._getPaintParams();
        if (!paintParams) return;
        this._prepareContext(ctx);
        var isGradient$1 = isGradient(style['lineColor']) || style['lineGradientProperty'], isPath = this.geometry.getJSONType() === 'Polygon' || this.geometry.type === 'LineString';
        if (isGradient$1 && (style['lineColor']['places'] || !isPath)) style['lineGradientExtent'] = this.geometry.getContainerExtent()._expand(style['lineWidth']);
        if (isGradient(style['polygonFill'])) style['polygonGradientExtent'] = this.geometry.getContainerExtent();
        var geometryEventTolerance = this.geometry.getLayer().options['geometryEventTolerance'] || 0;
        var tolerance = this.geometry._hitTestTolerance() + geometryEventTolerance;
        var points = paintParams[0], isSplitted = this.geometry.getJSONType() === 'Polygon' && points.length > 0 && Array.isArray(points[0][0]) || this.geometry.type === 'LineString' && points.length > 0 && Array.isArray(points[0]);
        if (isSplitted) for(var i = 0; i < points.length; i++){
            this.prepareCanvas(ctx, style, resources);
            if (isGradient$1 && isPath && !style['lineColor']['places']) this._createGradient(ctx, points[i], style['lineColor']);
            var params = [
                ctx,
                points[i]
            ];
            if (paintParams.length > 1) params.push(...paintParams.slice(1));
            params.push(style['lineOpacity'], style['polygonOpacity'], style['lineDasharray']);
            if (isGradient$1) params.push(this._lineColorIn);
            var bbox = this.geometry._paintOn(...params);
            this._setBBOX(ctx, bbox);
            this._bufferBBOX(ctx, tolerance);
        }
        else {
            this.prepareCanvas(ctx, style, resources);
            if (isGradient$1 && isPath && !style['lineColor']['places']) this._createGradient(ctx, points, style['lineColor']);
            var _params = [
                ctx
            ];
            _params.push(...paintParams);
            _params.push(style['lineOpacity'], style['polygonOpacity'], style['lineDasharray']);
            if (isGradient$1) _params.push(this._lineColorIn);
            var _bbox = this.geometry._paintOn(..._params);
            this._setBBOX(ctx, _bbox);
            this._bufferBBOX(ctx, tolerance);
        }
        if (ctx.setLineDash && Array.isArray(style['lineDasharray'])) ctx.setLineDash([]);
        this._tempRenderPoints = points;
    };
    _proto.get2DExtent = function get2DExtent() {
        var map = this.getMap();
        var extent = this.geometry._getPrjExtent();
        if (!extent) return null;
        if (!this._extMin || !this._extMax) {
            this._extMin = new Coordinate(0, 0);
            this._extMax = new Coordinate(0, 0);
        }
        this._extMin.x = extent['xmin'];
        this._extMin.y = extent['ymin'];
        this._extMax.x = extent['xmax'];
        this._extMax.y = extent['ymax'];
        var min = map._prjToPoint(this._extMin, undefined, TEMP_COORD0), max = map._prjToPoint(this._extMax, undefined, TEMP_COORD1);
        if (!this._pxExtent) this._pxExtent = new PointExtent(min, max);
        else this._pxExtent.set(Math.min(min.x, max.x), Math.min(min.y, max.y), Math.max(min.x, max.x), Math.max(min.y, max.y));
        return this._pxExtent;
    };
    _proto.getFixedExtent = function getFixedExtent() {
        var t = this.style['lineWidth'] / 2;
        return new PointExtent(-t, -t, t, t);
    };
    _proto._getPaintParams = function _getPaintParams() {
        return this.getPainter().getPaintParams(this.style['lineDx'], this.style['lineDy']);
    };
    _proto.translate = function translate() {
        var s = this.symbol;
        var result = {
            lineColor: getValueOrDefault(s['lineColor'], '#000'),
            lineWidth: getValueOrDefault(s['lineWidth'], 2),
            lineOpacity: getValueOrDefault(s['lineOpacity'], 1),
            lineDasharray: getValueOrDefault(s['lineDasharray'], []),
            lineCap: getValueOrDefault(s['lineCap'], 'butt'),
            lineJoin: getValueOrDefault(s['lineJoin'], 'miter'),
            linePatternFile: getValueOrDefault(s['linePatternFile'], null),
            lineDx: getValueOrDefault(s['lineDx'], 0),
            lineDy: getValueOrDefault(s['lineDy'], 0),
            polygonFill: getValueOrDefault(s['polygonFill'], null),
            polygonOpacity: getValueOrDefault(s['polygonOpacity'], 1),
            polygonPatternFile: getValueOrDefault(s['polygonPatternFile'], null),
            polygonPatternDx: getValueOrDefault(s['polygonPatternDx'], 0),
            polygonPatternDy: getValueOrDefault(s['polygonPatternDy'], 0),
            linePatternDx: getValueOrDefault(s['linePatternDx'], 0),
            linePatternDy: getValueOrDefault(s['linePatternDy'], 0),
            lineGradientProperty: getValueOrDefault(s['lineGradientProperty'], null)
        };
        if (result['lineWidth'] === 0) result['lineOpacity'] = 0;
        if (this.geometry.type === 'LineString' && !result['polygonFill']) result['polygonFill'] = result['lineColor'];
        return result;
    };
    _proto._createGradient = function _createGradient(ctx, points, lineColor) {
        if (!Array.isArray(points) || !points.length) return;
        var [p1, p2] = getGradientPoints(points);
        if (!p1 || !p2) {
            console.error('unable create canvas LinearGradient,error data:', points);
            return;
        }
        var colorStops;
        if (lineColor['colorStops']) colorStops = lineColor['colorStops'];
        if (!colorStops) {
            var properties = this.geometry.properties || {};
            var style = this.style || {};
            colorStops = properties[style['lineGradientProperty']];
        }
        if (!colorStops || !Array.isArray(colorStops) || colorStops.length < 2) return;
        if (!Array.isArray(colorStops[0])) {
            var colorStopsArray = [];
            var _colors = [];
            var idx = 0;
            for(var i = 0, len = colorStops.length; i < len; i += 2){
                _colors[0] = colorStops[i];
                _colors[1] = colorStops[i + 1];
                colorStopsArray[idx] = _colors;
                idx++;
                _colors = [];
            }
            colorStops = colorStopsArray;
        }
        var grad = ctx.createLinearGradient(p1.x, p1.y, p2.x, p2.y);
        colorStops.forEach(function(stop) {
            grad.addColorStop(...stop);
        });
        ctx.strokeStyle = grad;
        var key = JSON.stringify(colorStops);
        if (key === this._lineColorStopsKey) return;
        this._lineColorStopsKey = key;
        var colors = colorStops.map(function(c) {
            return [
                parseFloat(c[0]),
                c[1]
            ];
        });
        this._lineColorIn = new ColorIn(colors, {
            height: 1,
            width: 100
        });
    };
    return StrokeAndFillSymbolizer;
}(CanvasSymbolizer);
function getGradientPoints(points) {
    var pts;
    var isLine = true;
    if (Array.isArray(points[0])) {
        pts = points[0];
        isLine = false;
    } else pts = points;
    var len = pts.length;
    if (isLine) return [
        pts[0],
        pts[len - 1]
    ];
    var p1 = pts[0];
    var distance = 0, p2;
    for(var i = 1; i < len; i++){
        var p = pts[i];
        var dis = p1.distanceTo(p);
        if (dis > distance) {
            distance = dis;
            p2 = p;
        }
    }
    return [
        p1,
        p2
    ];
}
var TEMP_EXTENT$7 = new PointExtent();
function filterPathByMapSize(paths, mapSize) {
    var { width: width, height: height } = mapSize;
    var buffer = 0;
    var minx = -buffer, miny = -buffer, maxx = width + buffer, maxy = height + buffer;
    TEMP_EXTENT$7.xmin = minx;
    TEMP_EXTENT$7.ymin = miny;
    TEMP_EXTENT$7.xmax = maxx;
    TEMP_EXTENT$7.ymax = maxy;
    if (!Array.isArray(paths[0])) paths = [
        paths
    ];
    var result = [];
    paths.forEach(function(path) {
        var hasDirty = false;
        for(var i = 0, len = path.length; i < len; i++){
            var { x: x, y: y } = path[i];
            if (x < minx || x > maxx || y < miny || y > maxy) {
                hasDirty = true;
                break;
            }
        }
        if (hasDirty) {
            var parts = clipLine(path, TEMP_EXTENT$7, false, false);
            parts.forEach(function(part) {
                var line = [];
                for(var j = 0, len1 = part.length; j < len1; j++)line[j] = part[j].point;
                result.push(line);
            });
        } else result.push(path);
    });
    return result;
}
var TextMarkerSymbolizer = function(_PointSymbolizer) {
    function TextMarkerSymbolizer(symbol, geometry, painter) {
        var _this;
        _this = _PointSymbolizer.call(this, symbol, geometry, painter) || this;
        var style = _this.translate();
        _this._dynamic = hasFunctionDefinition(style);
        _this.style = _this._defineStyle(style);
        if (_this.style['textWrapWidth'] === 0) return _assertThisInitialized(_this);
        _this.strokeAndFill = _this._defineStyle(_this.translateLineAndFill(_this.style));
        return _this;
    }
    _inheritsLoose(TextMarkerSymbolizer, _PointSymbolizer);
    TextMarkerSymbolizer.test = function test(symbol) {
        return isTextSymbol(symbol);
    };
    var _proto = TextMarkerSymbolizer.prototype;
    _proto.isAlongLine = function isAlongLine() {
        var placement = this.getPlacement();
        var textSpacing = this.style.textSpacing;
        return placement === 'line' && isNumber(textSpacing) && textSpacing > 0;
    };
    _proto.symbolize = function symbolize(ctx, resources) {
        if (!this.isVisible()) return;
        var style = this.style;
        if (!this.painter.isHitTesting() && (style['textSize'] === 0 || !style['textOpacity'] && (!style['textHaloRadius'] || !style['textHaloOpacity']) || style['textWrapWidth'] === 0)) return;
        var strokeAndFill = this.strokeAndFill;
        var textContent = replaceVariable(this.style['textName'], this.geometry.getProperties());
        if (this._dynamic) delete this._textDesc;
        var textDesc = this._textDesc = this._textDesc || describeText(textContent, this.style);
        this._prepareContext(ctx);
        this.prepareCanvas(ctx, strokeAndFill, resources);
        if (!this._textFont) this._textFont = getFont(style);
        Canvas.prepareCanvasFont(ctx, style, !this._dynamic ? this._textFont : null);
        var textHaloRadius = style.textHaloRadius || 0;
        this.rotations = [];
        if (this.isAlongLine()) {
            var painter = this.getPainter();
            var paths = painter.getPathTempRenderPoints();
            if (!paths) return;
            var map = this.getMap();
            paths = filterPathByMapSize(paths, map.getSize());
            if (paths) {
                var layer = this.geometry.getLayer();
                var bbox = Canvas.textAlongLine(ctx, textContent, paths, style, textDesc, layer.options.collision ? layer.getCollisionIndex() : null);
                if (bbox) {
                    this._setBBOX(ctx, bbox);
                    this._bufferBBOX(ctx, textHaloRadius);
                }
            }
        } else {
            var cookedPoints = this._getRenderContainerPoints();
            if (!isArrayHasData(cookedPoints)) return;
            for(var i = 0, len = cookedPoints.length; i < len; i++){
                var p = cookedPoints[i];
                var origin = this._rotate(ctx, p, this._getRotationAt(i));
                var extent = void 0;
                if (origin) {
                    var pixel = p.sub(origin);
                    p = origin;
                    var rad = this._getRotationAt(i);
                    var { width: width, height: height } = textDesc.size || {
                        width: 0,
                        height: 0
                    };
                    var alignPoint = getAlignPoint(textDesc.size, style['textHorizontalAlignment'], style['textVerticalAlignment']);
                    extent = getMarkerRotationExtent(TEMP_EXTENT$7, rad, width, height, p, alignPoint);
                    extent._add(pixel);
                    this.rotations.push(rad);
                }
                var _bbox = Canvas.text(ctx, textContent, p, style, textDesc);
                if (origin) {
                    this._setBBOX(ctx, extent.xmin, extent.ymin, extent.xmax, extent.ymax);
                    ctx.restore();
                } else this._setBBOX(ctx, _bbox);
                this._bufferBBOX(ctx, textHaloRadius);
            }
        }
    };
    _proto.getPlacement = function getPlacement() {
        return this.symbol['textPlacement'];
    };
    _proto.getRotation = function getRotation() {
        var r = this.style['textRotation'];
        if (!isNumber(r)) return null;
        return -r * Math.PI / 180;
    };
    _proto.getDxDy = function getDxDy() {
        var s = this.style;
        return new Point(s['textDx'], s['textDy']);
    };
    _proto.getFixedExtent = function getFixedExtent() {
        var textDesc = this.geometry.getTextDesc();
        if (Array.isArray(textDesc)) textDesc = textDesc[this._index];
        this._fixedExtent = this._fixedExtent || new PointExtent();
        if (!textDesc) return this._fixedExtent;
        return getTextMarkerFixedExtent(this._fixedExtent, this.style, textDesc);
    };
    _proto.translate = function translate() {
        var s = this.symbol;
        var result = {
            textName: s['textName'],
            textFaceName: getValueOrDefault(s['textFaceName'], 'monospace'),
            textWeight: getValueOrDefault(s['textWeight'], 'normal'),
            textStyle: getValueOrDefault(s['textStyle'], 'normal'),
            textSize: getValueOrDefault(s['textSize'], DEFAULT_TEXT_SIZE),
            textFont: getValueOrDefault(s['textFont'], null),
            textFill: getValueOrDefault(s['textFill'], '#000'),
            textOpacity: getValueOrDefault(s['textOpacity'], 1),
            textHaloFill: getValueOrDefault(s['textHaloFill'], '#ffffff'),
            textHaloRadius: getValueOrDefault(s['textHaloRadius'], 0),
            textHaloOpacity: getValueOrDefault(s['textHaloOpacity'], 1),
            textWrapWidth: getValueOrDefault(s['textWrapWidth'], null),
            textWrapCharacter: getValueOrDefault(s['textWrapCharacter'], '\n'),
            textLineSpacing: getValueOrDefault(s['textLineSpacing'], 0),
            textDx: getValueOrDefault(s['textDx'], 0),
            textDy: getValueOrDefault(s['textDy'], 0),
            textHorizontalAlignment: getValueOrDefault(s['textHorizontalAlignment'], 'middle'),
            textVerticalAlignment: getValueOrDefault(s['textVerticalAlignment'], 'middle'),
            textAlign: getValueOrDefault(s['textAlign'], 'center'),
            textRotation: getValueOrDefault(s['textRotation'], 0),
            textMaxWidth: getValueOrDefault(s['textMaxWidth'], 0),
            textMaxHeight: getValueOrDefault(s['textMaxHeight'], 0),
            textSpacing: getValueOrDefault(s['textSpacing'], 0),
            textAlongDebug: getValueOrDefault(s['textAlongDebug'], false)
        };
        if (result['textMaxWidth'] > 0 && (!result['textWrapWidth'] || result['textWrapWidth'] > result['textMaxWidth'])) {
            if (!result['textWrapWidth']) result['textMaxHeight'] = 1;
            result['textWrapWidth'] = result['textMaxWidth'];
        }
        return result;
    };
    _proto.translateLineAndFill = function translateLineAndFill(s) {
        return {
            lineColor: s['textHaloRadius'] ? s['textHaloFill'] : s['textFill'],
            lineWidth: s['textHaloRadius'],
            lineOpacity: s['textOpacity'],
            lineDasharray: null,
            lineCap: 'butt',
            lineJoin: 'round',
            polygonFill: s['textFill'],
            polygonOpacity: s['textOpacity']
        };
    };
    return TextMarkerSymbolizer;
}(PointSymbolizer);
var MARKER_SIZE = [
    0,
    0
];
var TEMP_EXTENT$6 = new PointExtent();
var DEFAULT_ANCHOR = new Point(0, 0);
var TEMP_BBOX$1 = getDefaultBBOX();
var VectorMarkerSymbolizer = function(_PointSymbolizer) {
    function VectorMarkerSymbolizer(symbol, geometry, painter) {
        var _this;
        _this = _PointSymbolizer.call(this, symbol, geometry, painter) || this;
        var style = _this.translate();
        _this._dynamic = hasFunctionDefinition(style);
        _this.style = _this._defineStyle(style);
        _this.strokeAndFill = _this._defineStyle(translateMarkerLineAndFill(_this.style));
        _this.padding = 0;
        return _this;
    }
    _inheritsLoose(VectorMarkerSymbolizer, _PointSymbolizer);
    VectorMarkerSymbolizer.test = function test(symbol) {
        return isVectorSymbol(symbol);
    };
    var _proto = VectorMarkerSymbolizer.prototype;
    _proto.symbolize = function symbolize(ctx, resources) {
        if (!this.isVisible()) return;
        var style = this.style;
        if (!this.painter.isHitTesting() && (style['markerWidth'] === 0 || style['markerHeight'] === 0 || style['polygonOpacity'] === 0 && style['lineOpacity'] === 0)) return;
        var cookedPoints = this._getRenderContainerPoints();
        if (!isArrayHasData(cookedPoints)) return;
        this._prepareContext(ctx);
        if (this.getPainter().isSpriting() || this.geometry.getLayer().getMask() === this.geometry || this._dynamic || this.geometry.getLayer().options['cacheVectorOnCanvas'] === false) this._drawMarkersWithDynamic(ctx, cookedPoints, resources);
        else this._drawMarkersWithCache(ctx, cookedPoints, resources);
    };
    _proto._drawMarkersWithDynamic = function _drawMarkersWithDynamic(ctx, cookedPoints, resources) {
        for(var i = cookedPoints.length - 1; i >= 0; i--){
            var point = cookedPoints[i];
            var size = calVectorMarkerSize(MARKER_SIZE, this.style);
            var [width, height] = size;
            var origin = this._rotate(ctx, point, this._getRotationAt(i));
            this.rotations = [];
            var extent = void 0;
            if (origin) {
                var pixel = point.sub(origin);
                point = origin;
                var rad = this._getRotationAt(i);
                extent = getMarkerRotationExtent(TEMP_EXTENT$6, rad, width, height, point, DEFAULT_ANCHOR);
                extent._add(pixel);
                this.rotations.push(rad);
            }
            var bbox = this._drawVectorMarker(ctx, point, resources);
            if (origin) {
                ctx.restore();
                this._setBBOX(ctx, extent.xmin, extent.ymin, extent.xmax, extent.ymax);
            } else if (bbox) this._setBBOX(ctx, bbox[0], bbox[1], bbox[2], bbox[3]);
            else {
                var { x: x, y: y } = point;
                this._setBBOX(ctx, x, y, x + width, y + height);
            }
        }
    };
    _proto._drawMarkersWithCache = function _drawMarkersWithCache(ctx, cookedPoints, resources) {
        var stamp = this._stampSymbol();
        var image = resources.getImage(stamp);
        if (!image) {
            image = this._createMarkerImage(ctx, resources);
            resources.addResource([
                stamp,
                image.width,
                image.height
            ], image);
        }
        var anchor = getVectorMarkerAnchor(this.style, image.width, image.height);
        for(var i = cookedPoints.length - 1; i >= 0; i--){
            var point = cookedPoints[i];
            var origin = this._rotate(ctx, point, this._getRotationAt(i));
            this.rotations = [];
            var extent = void 0;
            if (origin) {
                var pixel = point.sub(origin);
                point = origin;
                var rad = this._getRotationAt(i);
                extent = getMarkerRotationExtent(TEMP_EXTENT$6, rad, image.width, image.height, point, anchor);
                extent._add(pixel);
                this.rotations.push(rad);
            }
            var x = point.x + anchor.x, y = point.y + anchor.y;
            Canvas.image(ctx, image, x, y);
            if (origin) {
                ctx.restore();
                this._setBBOX(ctx, extent.xmin, extent.ymin, extent.xmax, extent.ymax);
            } else this._setBBOX(ctx, x, y, x + image.width, y + image.height);
        }
    };
    _proto._createMarkerImage = function _createMarkerImage(ctx, resources) {
        var canvasClass = ctx.canvas.constructor, size = calVectorMarkerSize(MARKER_SIZE, this.style), canvas = Canvas.createCanvas(size[0], size[1], canvasClass), point = this._getCacheImageAnchor(size[0], size[1]);
        var context = canvas.getContext('2d');
        this._drawVectorMarker(context, point, resources);
        return canvas;
    };
    _proto._stampSymbol = function _stampSymbol() {
        if (!this._stamp) this._stamp = hashCode([
            this.style['markerType'],
            isGradient(this.style['markerFill']) ? getGradientStamp(this.style['markerFill']) : this.style['markerFill'],
            this.style['markerFillOpacity'],
            this.style['markerFillPatternFile'],
            isGradient(this.style['markerLineColor']) ? getGradientStamp(this.style['markerLineColor']) : this.style['markerLineColor'],
            this.style['markerLineWidth'],
            this.style['markerLineOpacity'],
            this.style['markerLineDasharray'] ? this.style['markerLineDasharray'].join(',') : '',
            this.style['markerLinePatternFile'],
            this.style['markerWidth'],
            this.style['markerHeight'],
            this.style['markerHorizontalAlignment'],
            this.style['markerVerticalAlignment']
        ].join('_'));
        return this._stamp;
    };
    _proto._getCacheImageAnchor = function _getCacheImageAnchor(w, h) {
        var shadow = 2 * (this.symbol['shadowBlur'] || 0), margin = shadow + this.padding;
        var markerType = this.style['markerType'];
        if (markerType === 'bar' || markerType === 'pie' || markerType === 'pin') return new Point(w / 2, h - margin);
        else if (markerType === 'rectangle') return new Point(margin, margin);
        else return new Point(w / 2, h / 2);
    };
    _proto._getGraidentExtent = function _getGraidentExtent(points) {
        var e = new PointExtent(), dxdy = this.getDxDy(), m = this.getFixedExtent();
        if (Array.isArray(points)) for(var i = points.length - 1; i >= 0; i--)e._combine(points[i]);
        else e._combine(points);
        e['xmin'] += m['xmin'] - dxdy.x;
        e['ymin'] += m['ymin'] - dxdy.y;
        e['xmax'] += m['xmax'] - dxdy.x;
        e['ymax'] += m['ymax'] - dxdy.y;
        return e;
    };
    _proto._drawVectorMarker = function _drawVectorMarker(ctx, point, resources) {
        resetBBOX(TEMP_BBOX$1);
        drawVectorMarker(ctx, point, this.style, resources, TEMP_BBOX$1);
        return TEMP_BBOX$1;
    };
    _proto.getFixedExtent = function getFixedExtent() {
        this._fixedExtent = this._fixedExtent || new PointExtent();
        return getVectorMarkerFixedExtent(this._fixedExtent, this.style, null);
    };
    _proto.translate = function translate() {
        var s = this.symbol;
        var result = {
            markerType: getValueOrDefault(s['markerType'], 'ellipse'),
            markerFill: getValueOrDefault(s['markerFill'], '#00f'),
            markerFillOpacity: getValueOrDefault(s['markerFillOpacity'], 1),
            markerFillPatternFile: getValueOrDefault(s['markerFillPatternFile'], null),
            markerLineColor: getValueOrDefault(s['markerLineColor'], '#000'),
            markerLineWidth: getValueOrDefault(s['markerLineWidth'], DEFAULT_MARKER_SYMBOLS.markerLineWidth),
            markerLineOpacity: getValueOrDefault(s['markerLineOpacity'], 1),
            markerLineDasharray: getValueOrDefault(s['markerLineDasharray'], []),
            markerLinePatternFile: getValueOrDefault(s['markerLinePatternFile'], null),
            markerDx: getValueOrDefault(s['markerDx'], 0),
            markerDy: getValueOrDefault(s['markerDy'], 0),
            markerWidth: getValueOrDefault(s['markerWidth'], DEFAULT_MARKER_SYMBOLS.markerWidth),
            markerHeight: getValueOrDefault(s['markerHeight'], DEFAULT_MARKER_SYMBOLS.markerHeight),
            markerRotation: getValueOrDefault(s['markerRotation'], 0),
            shadowBlur: getValueOrDefault(s['shadowBlur'], 0),
            shadowOffsetX: getValueOrDefault(s['shadowOffsetX'], 0),
            shadowOffsetY: getValueOrDefault(s['shadowOffsetY'], 0)
        };
        var markerType = result['markerType'];
        var ha = getDefaultHAlign(markerType);
        var va = getDefaultVAlign(markerType);
        result['markerHorizontalAlignment'] = getValueOrDefault(s['markerHorizontalAlignment'], ha);
        result['markerVerticalAlignment'] = getValueOrDefault(s['markerVerticalAlignment'], va);
        if (isNumber(s['markerOpacity'])) {
            if (isNumber(s['markerFillOpacity'])) result['markerFillOpacity'] *= s['markerOpacity'];
            if (isNumber(s['markerLineOpacity'])) result['markerLineOpacity'] *= s['markerOpacity'];
        }
        return result;
    };
    return VectorMarkerSymbolizer;
}(PointSymbolizer);
var VectorPathMarkerSymbolizer = function(_ImageMarkerSymbolize) {
    function VectorPathMarkerSymbolizer(symbol, geometry, painter) {
        var _this;
        if (isNil(symbol['markerWidth'])) symbol['markerWidth'] = 80;
        if (isNil(symbol['markerHeight'])) symbol['markerHeight'] = 80;
        _this = _ImageMarkerSymbolize.call(this, symbol, geometry, painter) || this;
        symbol = extend$2({}, symbol, _this.translate());
        var style = _this.style = _this._defineStyle(symbol);
        if (Browser$1.gecko) _this._url = [
            getMarkerPathBase64(style, style['markerWidth'], style['markerHeight']),
            style['markerWidth'],
            style['markerHeight']
        ];
        else _this._url = [
            getMarkerPathBase64(style),
            style['markerWidth'],
            style['markerHeight']
        ];
        return _this;
    }
    _inheritsLoose(VectorPathMarkerSymbolizer, _ImageMarkerSymbolize);
    VectorPathMarkerSymbolizer.test = function test(symbol) {
        return isPathSymbol(symbol);
    };
    var _proto = VectorPathMarkerSymbolizer.prototype;
    _proto._prepareContext = function _prepareContext() {};
    _proto._getImage = function _getImage(resources) {
        var _this2 = this;
        if (resources && resources.isResourceLoaded(this._url)) return resources.getImage(this._url);
        var painter = this.painter;
        var image = new Image();
        image.onload = function() {
            var renderer = painter.getLayer() && painter.getLayer().getRenderer();
            if (renderer) renderer.setToRedraw();
        };
        image.onerror = function(err) {
            if (err && typeof console !== 'undefined') console.warn(err);
            resources.markErrorResource(_this2._url);
        };
        image.src = this._url[0];
        if (resources) resources.addResource(this._url, image);
        return image;
    };
    return VectorPathMarkerSymbolizer;
}(ImageMarkerSymbolizer);
var defaultSymbol$1 = {
    lineWidth: 1,
    polygonFill: '#fff',
    polygonOpacity: 0.5
};
var DrawAltitudeSymbolizer = function(_PointSymbolizer) {
    function DrawAltitudeSymbolizer(symbol, geometry, painter) {
        var _this;
        _this = _PointSymbolizer.call(this, symbol, geometry, painter) || this;
        _this.style = geometry.getLayer().options['drawAltitude'];
        if (!_this.style || !isObject$1(_this.style)) _this.style = {
            lineWidth: 2
        };
        if (!_this.style['lineWidth']) _this.style['lineWidth'] = 0;
        _this.dxdy = _this._defineStyle({
            dx: symbol['textDx'] || symbol['markerDx'],
            dy: symbol['textDy'] || symbol['markerDy']
        });
        return _this;
    }
    _inheritsLoose(DrawAltitudeSymbolizer, _PointSymbolizer);
    DrawAltitudeSymbolizer.test = function test(symbol, geometry) {
        var layer = geometry.getLayer();
        if (!layer) return false;
        var type = geometry.getJSONType();
        return type === 'Marker' || type === 'LineString';
    };
    var _proto = DrawAltitudeSymbolizer.prototype;
    _proto.symbolize = function symbolize(ctx) {
        var layer = this.geometry.getLayer();
        if (!layer.options['drawAltitude']) return;
        if (!this.geometry.hasAltitude()) return;
        var style = this._getStyle();
        this._prepareContext(ctx);
        if (this.geometry.type === 'LineString') {
            var paintParams = this._getPaintParams(style['lineDx'], style['lineDy']);
            if (!paintParams) return;
            var groundPoints = this.getPainter().getPaintParams(style['lineDx'], style['lineDy'], true, true, '_groundpt')[0];
            this._drawLineAltitude(ctx, paintParams[0], groundPoints);
        } else {
            var point = this._getRenderContainerPoints(), groundPoint = this._getRenderContainerPoints(true);
            if (!point || point.length === 0) return;
            this._drawMarkerAltitude(ctx, point[0], groundPoint[0]);
        }
    };
    _proto.getDxDy = function getDxDy() {
        var s = this.dxdy;
        return new Point(s['dx'] || 0, s['dy'] || 0);
    };
    _proto.get2DExtent = function get2DExtent() {
        if (this.geometry.type === 'LineString') return StrokeAndFillSymbolizer.prototype.get2DExtent.apply(this);
        else return _PointSymbolizer.prototype.get2DExtent.call(this);
    };
    _proto.getPlacement = function getPlacement() {
        return 'point';
    };
    _proto._getPaintParams = function _getPaintParams(dx, dy) {
        return this.getPainter().getPaintParams(dx || 0, dy || 0, null, true, '_altpt');
    };
    _proto._drawMarkerAltitude = function _drawMarkerAltitude(ctx, point, groundPoint) {
        var style = this._getStyle();
        this.prepareCanvas(ctx, style);
        Canvas.path(ctx, [
            point,
            groundPoint
        ], style['lineOpacity'], null, style['lineDasharray']);
    };
    _proto._drawLineAltitude = function _drawLineAltitude(ctx, points, groundPoints) {
        var style = this._getStyle();
        var isSplitted = points.length > 0 && Array.isArray(points[0]);
        if (isSplitted) for(var i = 0; i < points.length; i++)this._drawLine(ctx, points[i], groundPoints[i]);
        else this._drawLine(ctx, points, groundPoints);
        if (ctx.setLineDash && Array.isArray(style['lineDasharray'])) ctx.setLineDash([]);
    };
    _proto._drawLine = function _drawLine(ctx, points, groundPoints) {
        var style = this._getStyle();
        this.prepareCanvas(ctx, style);
        for(var i = 0, l = points.length - 1; i < l; i++)Canvas.polygon(ctx, [
            points[i],
            points[i + 1],
            groundPoints[i + 1],
            groundPoints[i]
        ], style['lineOpacity'], style['polygonOpacity'], style['lineDasharray']);
    };
    _proto._getStyle = function _getStyle() {
        var layer = this.geometry.getLayer();
        var style = layer.options['drawAltitude'];
        if (Array.isArray(style)) {
            var geos = layer.getGeometries() || [];
            var index = geos.indexOf(this.geometry);
            if (index >= 0) style = style[index] || defaultSymbol$1;
        }
        if (!isObject$1(style)) style = defaultSymbol$1;
        if (!style['lineWidth']) {
            style['lineWidth'] = 0;
            style['lineOpacity'] = 0;
        }
        return style;
    };
    return DrawAltitudeSymbolizer;
}(PointSymbolizer);
var index$3 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    CanvasSymbolizer: CanvasSymbolizer,
    DebugSymbolizer: DebugSymbolizer,
    DrawAltitudeSymbolizer: DrawAltitudeSymbolizer,
    ImageMarkerSymbolizer: ImageMarkerSymbolizer,
    PointSymbolizer: PointSymbolizer,
    StrokeAndFillSymbolizer: StrokeAndFillSymbolizer,
    Symbolizer: Symbolizer,
    TextMarkerSymbolizer: TextMarkerSymbolizer,
    VectorMarkerSymbolizer: VectorMarkerSymbolizer,
    VectorPathMarkerSymbolizer: VectorPathMarkerSymbolizer
});
var registerSymbolizers = [
    DrawAltitudeSymbolizer,
    StrokeAndFillSymbolizer,
    ImageMarkerSymbolizer,
    VectorPathMarkerSymbolizer,
    VectorMarkerSymbolizer,
    TextMarkerSymbolizer
];
var testCanvas;
var TEMP_POINT0$2 = new Point(0, 0);
var TEMP_PAINT_EXTENT = new PointExtent();
var TEMP_FIXED_EXTENT = new PointExtent();
var TEMP_CLIP_EXTENT0 = new PointExtent();
var TEMP_CLIP_EXTENT1 = new PointExtent();
var TEMP_CLIP_EXTENT2 = new PointExtent();
var PROJECTION = {
    code: undefined
};
var TEMP_BBOX = {
    minx: Infinity,
    miny: Infinity,
    maxx: -Infinity,
    maxy: -Infinity
};
var TEMP_CANVAS_CTX = [];
var Painter = function(_Class) {
    function Painter(geometry) {
        var _this;
        _this = _Class.call(this) || this;
        _this.geometry = geometry;
        _this.symbolizers = _this._createSymbolizers();
        _this._altAtGL = _this._getGeometryAltitude();
        _this.bbox = getDefaultBBOX();
        _this._drawTime = 0;
        return _this;
    }
    _inheritsLoose(Painter, _Class);
    var _proto = Painter.prototype;
    _proto._setDrawTime = function _setDrawTime(time) {
        this._drawTime = time;
        return this;
    };
    _proto.getRenderBBOX = function getRenderBBOX() {
        var layer = this.getLayer();
        if (layer && layer._drawTime !== this._drawTime) return null;
        resetBBOX(this.bbox);
        var hasDirty = false;
        for(var i = this.symbolizers.length - 1; i >= 0; i--){
            var symbolizer = this.symbolizers[i];
            if (symbolizer instanceof DrawAltitudeSymbolizer || symbolizer instanceof DebugSymbolizer) continue;
            var bbox = symbolizer.bbox;
            if (!validateBBOX(bbox)) {
                hasDirty = true;
                break;
            }
            setBBOX(this.bbox, bbox);
        }
        if (hasDirty) return null;
        if (validateBBOX(this.bbox)) return this.bbox;
        return null;
    };
    _proto.getMap = function getMap() {
        return this.geometry.getMap();
    };
    _proto.getLayer = function getLayer() {
        return this.geometry && this.geometry.getLayer();
    };
    _proto._createSymbolizers = function _createSymbolizers() {
        var geoSymbol = this.getSymbol(), symbolizers = [], regSymbolizers = registerSymbolizers;
        var symbols = geoSymbol;
        if (!Array.isArray(geoSymbol)) symbols = [
            geoSymbol
        ];
        for(var ii = symbols.length - 1; ii >= 0; ii--){
            var symbol = symbols[ii];
            for(var i = regSymbolizers.length - 1; i >= 0; i--)if (regSymbolizers[i].test(symbol, this.geometry)) {
                var symbolizer = new regSymbolizers[i](symbol, this.geometry, this);
                symbolizer._index = ii;
                symbolizers.push(symbolizer);
                if (symbolizer instanceof PointSymbolizer) this._hasPoint = true;
            }
        }
        if (!symbolizers.length) {
            if (console) {
                var id = this.geometry.getId();
                console.warn('invalid symbol for geometry(' + (this.geometry ? this.geometry.getType() + (id ? ':' + id : '') : '') + ') to draw : ' + JSON.stringify(geoSymbol));
            }
        }
        this._debugSymbolizer = new DebugSymbolizer(geoSymbol, this.geometry, this);
        return symbolizers;
    };
    _proto.hasPoint = function hasPoint() {
        return !!this._hasPoint;
    };
    _proto.getRenderPoints = function getRenderPoints(placement) {
        this._verifyProjection();
        if (!this._renderPoints) this._renderPoints = {};
        if (!placement) placement = 'center';
        if (!this._renderPoints[placement]) this._renderPoints[placement] = this.geometry._getRenderPoints(placement);
        return this._renderPoints[placement];
    };
    _proto.getPaintParams = function getPaintParams(dx, dy, ignoreAltitude, disableClip, ptkey = '_pt') {
        var renderer = this.getLayer()._getRenderer();
        var mapStateCache = renderer.mapStateCache;
        var resolution, pitch, bearing, glScale, containerExtent;
        var map = this.getMap();
        if (mapStateCache && !this._hitPoint) {
            resolution = mapStateCache.resolution;
            pitch = mapStateCache.pitch;
            bearing = mapStateCache.bearing;
            glScale = mapStateCache.glScale;
            containerExtent = mapStateCache.containerExtent;
        } else {
            resolution = map.getResolution();
            pitch = map.getPitch();
            bearing = map.getBearing();
            glScale = map.getGLScale();
            containerExtent = map.getContainerExtent();
        }
        var geometry = this.geometry, res = resolution, pitched = pitch !== 0, rotated = bearing !== 0;
        var params = this._cachedParams;
        var paintAsPath = geometry._paintAsPath && geometry._paintAsPath();
        if (paintAsPath && this._unsimpledParams && res <= this._unsimpledParams._res) params = this._unsimpledParams;
        else if (!params || params._res !== resolution || this._pitched !== pitched && geometry._redrawWhenPitch() || this._rotated !== rotated && geometry._redrawWhenRotate()) {
            params = geometry._getPaintParams();
            if (!params) return null;
            params._res = res;
            if (!geometry._simplified && paintAsPath) {
                if (!this._unsimpledParams) this._unsimpledParams = params;
                if (res > this._unsimpledParams._res) this._unsimpledParams._res = res;
            }
            this._cachedParams = params;
        }
        if (!params) return null;
        this._pitched = pitched;
        this._rotated = rotated;
        var zoomScale = glScale, tr = [], points = params[0];
        var mapExtent = containerExtent;
        var cPoints = this._pointContainerPoints(points, dx, dy, ignoreAltitude, disableClip || this._hitPoint && !mapExtent.contains(this._hitPoint), null, ptkey);
        if (!cPoints) return null;
        tr.push(cPoints);
        for(var i = 1, l = params.length; i < l; i++)if (isNumber(params[i]) || params[i] instanceof Size) {
            if (isNumber(params[i])) tr.push(params[i] / zoomScale);
            else tr.push(params[i].multi(1 / zoomScale));
        } else tr.push(params[i]);
        return tr;
    };
    _proto._pointContainerPoints = function _pointContainerPoints(points, dx, dy, ignoreAltitude, disableClip, pointPlacement, ptkey = '_pt') {
        if (this._aboveCamera()) return null;
        var renderer = this.getLayer()._getRenderer();
        var mapStateCache = renderer.mapStateCache;
        var map = this.getMap(), geometry = this.geometry, containerOffset = this.containerOffset;
        var glRes, containerExtent;
        if (mapStateCache) {
            glRes = mapStateCache.glRes;
            containerExtent = mapStateCache.containerExtent;
        } else {
            glRes = map.getGLRes();
            containerExtent = map.getContainerExtent();
        }
        var cPoints;
        var roundPoint = this.getLayer().options['roundPoint'];
        var minx = Infinity, miny = Infinity, maxx = -Infinity, maxy = -Infinity;
        var needClip = !disableClip;
        var clipBBoxBufferSize = renderer.layer.options['clipBBoxBufferSize'] || 3;
        var symbolizers = this.symbolizers;
        var enableClip = geometry.options.enableClip;
        function pointsContainerPoints(viewPoints = [], alts = []) {
            var pts = getPointsResultPts(viewPoints, ptkey);
            pts = map._pointsAtResToContainerPoints(viewPoints, glRes, alts, pts);
            for(var i = 0, len = pts.length; i < len; i++){
                var p = pts[i];
                p._sub(containerOffset);
                if (dx || dy) p._add(dx || 0, dy || 0);
                if (roundPoint) {
                    p.x = Math.ceil(p.x);
                    p.y = Math.ceil(p.y);
                }
                minx = Math.min(p.x, minx);
                miny = Math.min(p.y, miny);
                maxx = Math.max(p.x, maxx);
                maxy = Math.max(p.y, maxy);
            }
            if (enableClip && needClip && isDashLine(symbolizers)) {
                TEMP_CLIP_EXTENT2.ymin = containerExtent.ymin;
                if (TEMP_CLIP_EXTENT2.ymin < clipBBoxBufferSize) TEMP_CLIP_EXTENT2.ymin = containerExtent.ymin - clipBBoxBufferSize;
                TEMP_CLIP_EXTENT2.xmin = containerExtent.xmin - clipBBoxBufferSize;
                TEMP_CLIP_EXTENT2.xmax = containerExtent.xmax + clipBBoxBufferSize;
                TEMP_CLIP_EXTENT2.ymax = containerExtent.ymax + clipBBoxBufferSize;
                if (geometry.getShell && geometry.getHoles) return clipPolygon(pts, TEMP_CLIP_EXTENT2);
                var clipPts = clipLine(pts, TEMP_CLIP_EXTENT2, false);
                if (clipPts.length) {
                    var _points = [];
                    clipPts.forEach(function(clipPt) {
                        for(var _i = 0, _len = clipPt.length; _i < _len; _i++)_points.push(clipPt[_i].point);
                    });
                    return _points;
                }
            }
            return pts;
        }
        var altitude = this.getAltitude();
        if (Array.isArray(points)) {
            var _geometry = this.geometry;
            var clipped;
            if (!disableClip && _geometry.options['enableClip']) {
                clipped = this._clip(points, altitude);
                if (clipped.inView) needClip = false;
            } else clipped = {
                points: points,
                altitude: altitude
            };
            var clipPoints = clipped.points;
            altitude = clipped.altitude;
            if (ignoreAltitude) altitude = 0;
            var alt = altitude;
            cPoints = [];
            var alts = [];
            var altitudeIsNumber = isNumber(altitude);
            for(var i = 0, l = clipPoints.length; i < l; i++){
                var c = clipPoints[i];
                if (Array.isArray(c)) {
                    if (altitudeIsNumber) {
                        var _cring = pointsContainerPoints(c, altitude);
                        cPoints.push(_cring);
                        continue;
                    }
                    var altArray = [];
                    for(var ii = 0, ll = c.length; ii < ll; ii++){
                        if (Array.isArray(altitude)) {
                            if (altitude[i]) alt = altitude[i][ii];
                            else alt = 0;
                        }
                        altArray.push(alt);
                    }
                    var cring = pointsContainerPoints(c, altArray);
                    cPoints.push(cring);
                } else {
                    if (Array.isArray(altitude)) {
                        if (pointPlacement === 'vertex-last') alt = altitude[altitude.length - 1 - i];
                        else if (pointPlacement === 'line') alt = (altitude[i] + altitude[i + 1]) / 2;
                        else alt = altitude[i];
                    }
                    alts.push(alt);
                }
            }
            if (alts.length) cPoints = pointsContainerPoints(clipPoints, alts);
        } else if (points instanceof Point) {
            if (ignoreAltitude) altitude = 0;
            cPoints = map._pointAtResToContainerPoint(points, glRes, altitude)._sub(containerOffset);
            if (dx || dy) cPoints._add(dx, dy);
        }
        TEMP_BBOX.minx = minx;
        TEMP_BBOX.miny = miny;
        TEMP_BBOX.maxx = maxx;
        TEMP_BBOX.maxy = maxy;
        this._containerBbox = TEMP_BBOX;
        return cPoints;
    };
    _proto._clip = function _clip(points, altitude) {
        if (isNumber(altitude) && altitude !== 0) return {
            points: points,
            altitude: altitude
        };
        if (Array.isArray(altitude)) {
            var hasAltitude = false;
            for(var i = 0, len = altitude.length; i < len; i++)if (altitude[i] !== 0) {
                hasAltitude = true;
                break;
            }
            if (hasAltitude) return {
                points: points,
                altitude: altitude
            };
        }
        var map = this.getMap(), geometry = this.geometry;
        var lineWidth = this.getSymbol()['lineWidth'];
        if (!isNumber(lineWidth)) lineWidth = 4;
        var renderer = this.getLayer()._getRenderer();
        var mapStateCache = renderer.mapStateCache;
        var _2DExtent, glExtent, pitch;
        if (mapStateCache) {
            _2DExtent = mapStateCache._2DExtent;
            glExtent = mapStateCache.glExtent;
            pitch = mapStateCache.pitch;
        } else {
            _2DExtent = map.get2DExtent();
            glExtent = map.get2DExtentAtRes(map.getGLRes());
            pitch = map.getPitch();
        }
        var extent2D = _2DExtent._expand(lineWidth);
        if (pitch > 0 && altitude) {
            var c = map.cameraLookAt;
            var pos = map.cameraPosition;
            TEMP_POINT0$2.set(pos[0], pos[1]);
            extent2D = extent2D._combine(TEMP_POINT0$2._add(sign(c[0] - pos[0]), sign(c[1] - pos[1])));
        }
        var e = this.get2DExtent(null, TEMP_CLIP_EXTENT1);
        var clipPoints = points;
        if (e.within(extent2D)) return {
            points: clipPoints,
            altitude: altitude,
            inView: true
        };
        var glExtent2D = glExtent._expand(lineWidth * map.getGLScale());
        TEMP_CLIP_EXTENT0.xmin = glExtent2D.xmin;
        TEMP_CLIP_EXTENT0.xmax = glExtent2D.xmax;
        TEMP_CLIP_EXTENT0.ymin = glExtent2D.ymin;
        TEMP_CLIP_EXTENT0.ymax = glExtent2D.ymax;
        var smoothness = geometry.options['smoothness'];
        if (geometry.getShell && this.geometry.getHoles && !smoothness) {
            var { xmin: xmin, ymin: ymin, xmax: xmax, ymax: ymax } = glExtent2D;
            var dx = Math.abs(xmax - xmin), dy = Math.abs(ymax - ymin);
            var r = Math.sqrt(dx * dx + dy * dy);
            var rx = (r - dx) / 2, ry = (r - dy) / 2;
            TEMP_CLIP_EXTENT0.xmin = glExtent2D.xmin - rx;
            TEMP_CLIP_EXTENT0.xmax = glExtent2D.xmax + rx;
            TEMP_CLIP_EXTENT0.ymin = glExtent2D.ymin - ry;
            TEMP_CLIP_EXTENT0.ymax = glExtent2D.ymax + ry;
            if (!Array.isArray(points[0])) clipPoints = clipPolygon(points, TEMP_CLIP_EXTENT0);
            else {
                clipPoints = [];
                for(var _i2 = 0; _i2 < points.length; _i2++){
                    var part = clipPolygon(points[_i2], TEMP_CLIP_EXTENT0);
                    if (part.length) clipPoints.push(part);
                }
            }
        } else if (geometry.getJSONType() === 'LineString' && !smoothness) {
            if (!Array.isArray(points[0])) clipPoints = clipLine(points, TEMP_CLIP_EXTENT0, false, !!smoothness);
            else {
                clipPoints = [];
                for(var _i3 = 0; _i3 < points.length; _i3++)pushIn(clipPoints, clipLine(points[_i3], TEMP_CLIP_EXTENT0, false, !!smoothness));
            }
            return this._interpolateSegAlt(clipPoints, points, altitude);
        }
        return {
            points: clipPoints,
            altitude: altitude
        };
    };
    _proto._interpolateSegAlt = function _interpolateSegAlt(clipSegs, orig, altitude) {
        if (!Array.isArray(altitude)) {
            var fn = function fn(cc) {
                return cc.point;
            };
            return {
                points: clipSegs.map(function(c) {
                    if (Array.isArray(c)) return c.map(fn);
                    return c.point;
                }),
                altitude: altitude
            };
        }
        var segsWithAlt = interpolateAlt(clipSegs, orig, altitude);
        altitude = [];
        var points = segsWithAlt.map(function(p) {
            if (Array.isArray(p)) {
                var alt = [];
                var cp = p.map(function(pp) {
                    alt.push(pp.altitude);
                    return pp.point;
                });
                altitude.push(alt);
                return cp;
            }
            altitude.push(p.altitude);
            return p.point;
        });
        return {
            points: points,
            altitude: altitude
        };
    };
    _proto.getSymbol = function getSymbol() {
        return this.geometry._getInternalSymbol();
    };
    _proto._resetSymbolizersBBOX = function _resetSymbolizersBBOX() {
        for(var i = this.symbolizers.length - 1; i >= 0; i--){
            var symbolizer = this.symbolizers[i];
            var bbox = symbolizer.bbox;
            resetBBOX(bbox);
        }
        return this;
    };
    _proto.paint = function paint(extent, context, offset) {
        if (!this.symbolizers) return;
        var layer = this.getLayer();
        var renderer = layer._getRenderer();
        if (!renderer || !renderer.context && !context) return;
        var mapStateCache = renderer.mapStateCache || {
            offset: undefined
        };
        if (!this.geometry._isCheck) {
            if (extent && !extent.intersects(this.get2DExtent(renderer.resources, TEMP_PAINT_EXTENT))) return;
        }
        if (this._aboveCamera()) return;
        this.containerOffset = offset || mapStateCache.offset;
        if (!this.containerOffset) {
            var map = this.getMap();
            this.containerOffset = map._pointToContainerPoint(renderer.middleWest)._add(0, -map.height / 2);
        }
        this._beforePaint();
        var ctx = context || renderer.context;
        if (!ctx.isHitTesting) this._resetSymbolizersBBOX();
        TEMP_CANVAS_CTX[0] = ctx;
        TEMP_CANVAS_CTX[1] = renderer.resources;
        for(var i = this.symbolizers.length - 1; i >= 0; i--){
            if (ctx.shadowBlur || this.symbolizers[i].symbol['shadowBlur']) this._prepareShadow(ctx, this.symbolizers[i].symbol);
            this.symbolizers[i].symbolize(...TEMP_CANVAS_CTX);
        }
        this._afterPaint();
        this._painted = true;
        if (this.geometry.options['debug'] || layer.options['debug']) this._debugSymbolizer.symbolize(ctx);
    };
    _proto.getSprite = function getSprite(resources, canvasClass) {
        if (!this.geometry.isPoint) return null;
        this._spriting = true;
        if (!this._sprite && this.symbolizers.length > 0) {
            var extent = new PointExtent();
            this.symbolizers.forEach(function(s) {
                var markerExtent = s.getFixedExtent(resources);
                extent._combine(markerExtent);
            });
            var origin = extent.getMin().multi(-1);
            var clazz = canvasClass || (this.getMap() ? this.getMap().CanvasClass : null);
            var canvas = Canvas.createCanvas(extent.getWidth(), extent.getHeight(), clazz);
            var bak;
            if (this._renderPoints) bak = this._renderPoints;
            var ctx = canvas.getContext('2d');
            var contexts = [
                ctx,
                resources
            ];
            for(var i = this.symbolizers.length - 1; i >= 0; i--){
                var dxdy = this.symbolizers[i].getDxDy();
                this._renderPoints = {
                    'center': [
                        [
                            origin.add(dxdy)
                        ]
                    ]
                };
                this._prepareShadow(ctx, this.symbolizers[i].symbol);
                this.symbolizers[i].symbolize(...contexts);
            }
            if (bak) this._renderPoints = bak;
            this._sprite = {
                'canvas': canvas,
                'offset': extent.getCenter()
            };
        }
        this._spriting = false;
        return this._sprite;
    };
    _proto.isSpriting = function isSpriting() {
        return !!this._spriting;
    };
    _proto.hitTest = function hitTest(cp, tolerance) {
        if (!tolerance || tolerance < 0.5) tolerance = 0.5;
        this._hitPoint = cp.sub(tolerance, tolerance);
        if (!testCanvas) {
            var canvasClass = this.getMap() ? this.getMap().CanvasClass : null;
            testCanvas = Canvas.createCanvas(1, 1, canvasClass);
        }
        Canvas.setHitTesting(true);
        testCanvas.width = testCanvas.height = 2 * tolerance;
        var ctx = Canvas.getCanvas2DContext(testCanvas);
        ctx.isHitTesting = true;
        try {
            this.paint(null, ctx, this._hitPoint);
        } finally{
            Canvas.setHitTesting(false);
        }
        delete this._hitPoint;
        try {
            var imgData = ctx.getImageData(0, 0, testCanvas.width, testCanvas.height).data;
            for(var i = 3, l = imgData.length; i < l; i += 4){
                if (imgData[i] > 0) return true;
            }
        } catch (error) {
            console.error(error);
        }
        return false;
    };
    _proto.isHitTesting = function isHitTesting() {
        return !!this._hitPoint;
    };
    _proto._prepareShadow = function _prepareShadow(ctx, symbol) {
        if (symbol['shadowBlur']) {
            ctx.shadowBlur = this.isHitTesting() ? 0 : symbol['shadowBlur'];
            ctx.shadowColor = symbol['shadowColor'] || '#000';
            ctx.shadowOffsetX = symbol['shadowOffsetX'] || 0;
            ctx.shadowOffsetY = symbol['shadowOffsetY'] || 0;
        } else if (ctx.shadowBlur) {
            ctx.shadowBlur = null;
            ctx.shadowColor = null;
            ctx.shadowOffsetX = null;
            ctx.shadowOffsetY = null;
        }
    };
    _proto._eachSymbolizer = function _eachSymbolizer(fn, context) {
        if (!this.symbolizers) return;
        if (!context) context = this;
        for(var i = this.symbolizers.length - 1; i >= 0; i--)fn.apply(context, [
            this.symbolizers[i]
        ]);
    };
    _proto.get2DExtent = function get2DExtent(resources, out) {
        this._verifyProjection();
        var map = this.getMap();
        resources = resources || this.getLayer()._getRenderer().resources;
        var zoom = map.getZoom();
        var isDynamicSize = this._isDynamicSize();
        if (!this._extent2D || this._extent2D._zoom !== zoom || !this._fixedExtent) {
            if (this._extent2D && this._extent2D._zoom !== zoom) delete this._extent2D;
            if (this.symbolizers) {
                if (!this._extent2D) {
                    this._extent2D = this._computeExtent2D(new PointExtent());
                    this._extent2D._zoom = zoom;
                }
                if (!this._fixedExtent) this._fixedExtent = this._computeFixedExtent(resources, new PointExtent());
            }
        }
        if (!this._extent2D) {
            if (isDynamicSize) delete this._fixedExtent;
            return null;
        }
        var { xmin: xmin, ymin: ymin, xmax: xmax, ymax: ymax } = this._fixedExtent;
        if (isDynamicSize) delete this._fixedExtent;
        TEMP_FIXED_EXTENT.set(xmin, -ymax, xmax, -ymin);
        if (out) {
            out.set(this._extent2D['xmin'], this._extent2D['ymin'], this._extent2D['xmax'], this._extent2D['ymax']);
            out._add(TEMP_FIXED_EXTENT);
            return out;
        }
        return this._extent2D.add(TEMP_FIXED_EXTENT);
    };
    _proto._computeExtent2D = function _computeExtent2D(extent) {
        for(var i = this.symbolizers.length - 1; i >= 0; i--){
            var symbolizer = this.symbolizers[i];
            extent._combine(symbolizer.get2DExtent());
        }
        return extent;
    };
    _proto._computeFixedExtent = function _computeFixedExtent(resources, extent) {
        for(var i = this.symbolizers.length - 1; i >= 0; i--){
            var symbolizer = this.symbolizers[i];
            if (symbolizer.getFixedExtent) extent._combine(symbolizer.getFixedExtent(resources));
        }
        return extent;
    };
    _proto._isDynamicSize = function _isDynamicSize() {
        for(var i = this.symbolizers.length - 1; i >= 0; i--){
            var symbolizer = this.symbolizers[i];
            if (symbolizer.isDynamicSize()) return true;
        }
        return false;
    };
    _proto._aboveCamera = function _aboveCamera() {
        var altitude = this.getMinAltitude();
        var map = this.getMap();
        var glRes = map.getGLRes();
        altitude = map.altitudeToPoint(altitude, glRes) * sign(altitude);
        var frustumAlt = map.getFrustumAltitude();
        return altitude && frustumAlt && frustumAlt < altitude;
    };
    _proto.getFixedExtent = function getFixedExtent() {
        var map = this.getMap();
        var zoom = map.getZoom();
        if (this._isDynamicSize()) return this._computeFixedExtent(null, new PointExtent());
        if (!this._extent2D || this._extent2D._zoom !== zoom) this.get2DExtent(null, TEMP_FIXED_EXTENT);
        return this._fixedExtent;
    };
    _proto.setZIndex = function setZIndex(change) {
        this._eachSymbolizer(function(symbolizer) {
            symbolizer.setZIndex(change);
        });
    };
    _proto.show = function show() {
        if (!this._painted) {
            var layer = this.getLayer();
            if (!layer.isCanvasRender()) this.paint();
        } else {
            this.removeCache();
            this._eachSymbolizer(function(symbolizer) {
                symbolizer.show();
            });
        }
    };
    _proto.hide = function hide() {
        this._eachSymbolizer(function(symbolizer) {
            symbolizer.hide();
        });
    };
    _proto.repaint = function repaint() {
        this._altAtGL = this._getGeometryAltitude();
        this.removeCache();
        var layer = this.getLayer();
        if (!layer) return;
        var renderer = layer.getRenderer();
        if (!renderer || !renderer.setToRedraw()) return;
        renderer.setToRedraw();
    };
    _proto.refreshSymbol = function refreshSymbol() {
        this.removeCache();
        this._removeSymbolizers();
        this.symbolizers = this._createSymbolizers();
    };
    _proto.remove = function remove() {
        this.removeCache();
        this._removeSymbolizers();
    };
    _proto._removeSymbolizers = function _removeSymbolizers() {
        this._eachSymbolizer(function(symbolizer) {
            delete symbolizer.painter;
            symbolizer.remove();
        });
        delete this.symbolizers;
    };
    _proto.removeCache = function removeCache() {
        delete this._renderPoints;
        delete this._paintParams;
        delete this._sprite;
        delete this._extent2D;
        delete this._fixedExtent;
        delete this._cachedParams;
        delete this._unsimpledParams;
    };
    _proto.getAltitude = function getAltitude() {
        var propAlt = this.geometry._getAltitude();
        if (propAlt !== this._propAlt) this._altAtGL = this._getGeometryAltitude();
        if (!this._altAtGL) return 0;
        return this._altAtGL;
    };
    _proto.getMinAltitude = function getMinAltitude() {
        if (!this.minAltitude) return 0;
        return this.minAltitude;
    };
    _proto.getMaxAltitude = function getMaxAltitude() {
        if (!this.maxAltitude) return 0;
        return this.maxAltitude;
    };
    _proto._getGeometryAltitude = function _getGeometryAltitude() {
        var map = this.getMap();
        if (!map) return 0;
        var altitude = this.geometry._getAltitude();
        this._propAlt = altitude;
        var [min, max] = getMinMaxAltitude(altitude);
        this.minAltitude = min;
        this.maxAltitude = max;
        if (!altitude) return 0;
        var center = this.geometry.getCenter();
        if (!center) return 0;
        return altitude;
    };
    _proto._verifyProjection = function _verifyProjection() {
        var projection = this.geometry._getProjection() || PROJECTION;
        if (this._projCode && this._projCode !== projection.code) this.removeCache();
        this._projCode = projection.code;
    };
    _proto._beforePaint = function _beforePaint() {};
    _proto._afterPaint = function _afterPaint() {};
    _proto.getPathTempRenderPoints = function getPathTempRenderPoints() {
        var symbolizers = this.symbolizers || [];
        for(var i = 0, len = symbolizers.length; i < len; i++){
            var symbolizer = this.symbolizers[i];
            if (symbolizer instanceof StrokeAndFillSymbolizer && symbolizer._tempRenderPoints) return symbolizer._tempRenderPoints;
        }
    };
    return Painter;
}(Class);
function interpolateAlt(points, orig, altitude) {
    if (!Array.isArray(altitude)) return points;
    var parts = [];
    for(var i = 0, l = points.length; i < l; i++)if (Array.isArray(points[i])) parts.push(interpolateAlt(points[i], orig, altitude));
    else {
        var p = points[i];
        if (!p.point.equals(orig[p.index])) {
            var w0 = void 0, w1 = void 0;
            if (p.index === 0) {
                w0 = p.index;
                w1 = p.index + 1;
            } else {
                w0 = p.index - 1;
                w1 = p.index;
            }
            var t0 = p.point.distanceTo(orig[w1]);
            var t = t0 / (t0 + orig[w0].distanceTo(p.point));
            var alt = interpolate$3(altitude[w0], altitude[w1], 1 - t);
            p.altitude = alt;
            parts.push(p);
        } else {
            p.altitude = altitude[p.index];
            parts.push(p);
        }
    }
    return parts;
}
var TEMP_EXTENT$5 = new PointExtent();
var CollectionPainter = function(_Class) {
    function CollectionPainter(geometry, isMask) {
        var _this;
        _this = _Class.call(this) || this;
        _this.geometry = geometry;
        _this.isMask = isMask;
        _this.bbox = getDefaultBBOX();
        _this._drawTime = 0;
        return _this;
    }
    _inheritsLoose(CollectionPainter, _Class);
    var _proto = CollectionPainter.prototype;
    _proto._setDrawTime = function _setDrawTime(time) {
        this._drawTime = time;
        this._eachPainter(function(painter) {
            painter._setDrawTime(time);
        });
        return this;
    };
    _proto.getRenderBBOX = function getRenderBBOX() {
        var _this2 = this;
        var layer = this.getLayer();
        if (layer && layer._drawTime !== this._drawTime) return null;
        resetBBOX(this.bbox);
        var hasDirty = false;
        this._eachPainter(function(painter) {
            var bbox = painter.getRenderBBOX();
            if (!validateBBOX(bbox)) {
                hasDirty = true;
                return;
            }
            setBBOX(_this2.bbox, bbox);
        });
        if (hasDirty) return null;
        if (validateBBOX(this.bbox)) return this.bbox;
        return null;
    };
    _proto._eachPainter = function _eachPainter(fn) {
        var geometries = this.geometry.getGeometries();
        var painter;
        for(var i = 0, len = geometries.length; i < len; i++){
            painter = this.isMask ? geometries[i]._getMaskPainter() : geometries[i]._getPainter();
            if (!painter) continue;
            if (painter) {
                if (fn.call(this, painter) === false) break;
            }
        }
    };
    _proto.getLayer = function getLayer() {
        return this.geometry && this.geometry.getLayer();
    };
    _proto.paint = function paint(extent) {
        if (!this.geometry) return;
        this._eachPainter(function(painter) {
            painter.paint(extent);
        });
    };
    _proto.get2DExtent = function get2DExtent(resources, out) {
        if (out) out.set(null, null, null, null);
        var extent = out || new PointExtent();
        this._eachPainter(function(painter) {
            extent = extent._combine(painter.get2DExtent(resources, TEMP_EXTENT$5));
        });
        return extent;
    };
    _proto.remove = function remove() {
        this._eachPainter(function(painter) {
            painter.remove();
        });
    };
    _proto.setZIndex = function setZIndex(index) {
        this._eachPainter(function(painter) {
            painter.setZIndex(index);
        });
    };
    _proto.show = function show() {
        this._eachPainter(function(painter) {
            painter.show();
        });
    };
    _proto.hide = function hide() {
        this._eachPainter(function(painter) {
            painter.hide();
        });
    };
    _proto.repaint = function repaint() {
        this._eachPainter(function(painter) {
            painter.repaint();
        });
    };
    _proto.refreshSymbol = function refreshSymbol() {
        this._eachPainter(function(painter) {
            painter.refreshSymbol();
        });
    };
    _proto.hasPoint = function hasPoint() {
        var result = false;
        this._eachPainter(function(painter) {
            if (painter.hasPoint()) {
                result = true;
                return false;
            }
            return true;
        });
        return result;
    };
    _proto.getMinAltitude = function getMinAltitude() {
        var first = true;
        var result = 0;
        this._eachPainter(function(painter) {
            var alt = painter.getMinAltitude();
            if (first || alt < result) {
                first = false;
                result = alt;
            }
        });
        return result;
    };
    _proto.getMaxAltitude = function getMaxAltitude() {
        var result = 0;
        this._eachPainter(function(painter) {
            var alt = painter.getMaxAltitude();
            if (alt > result) result = alt;
        });
        return result;
    };
    return CollectionPainter;
}(Class);
function getProjectionCode(code) {
    var newcode = '';
    var codeArray = code.split('');
    for(var len = codeArray.length, i = len - 1; i >= 0; i--){
        if (!isNaN(codeArray[i])) newcode = codeArray[i] + newcode;
        else break;
    }
    return newcode;
}
function getProjection(projection) {
    var prj = projection.indexOf('EPSG') > -1 ? projection : 'EPSG:' + projection;
    prj = strReplace(prj, [
        [
            '4490',
            '4326'
        ],
        [
            '102100',
            '3857'
        ],
        [
            '900913',
            '3857'
        ]
    ]);
    return prj;
}
function strReplace(str, repArray = []) {
    repArray.forEach(function(rep) {
        var [template, value] = rep;
        str = str.replace(template, value);
    });
    return str;
}
function getTransformValue(options) {
    var { projection: projection, isArcgis: isArcgis, isGeoServer: isGeoServer, isSuperMap: isSuperMap } = options;
    var transformValue = 0.0002645833333333333;
    if (isArcgis || isGeoServer || isSuperMap) transformValue = 0.00028;
    if (projection && projection.indexOf('4326') > -1) {
        transformValue = 2.3767925226029154e-9;
        if (isArcgis || isSuperMap) transformValue = 2.518101729011901e-9;
        if (isGeoServer) transformValue = 2.51528279553466e-9;
    }
    return transformValue;
}
var ns = 'wmts';
function getElementsByTagName(element, localName) {
    var result = element.getElementsByTagName(localName);
    if (result && result.length) return result;
    var name = ns + ':' + localName;
    return element.getElementsByTagName(name);
}
function getTileMatrixSet(TileMatrixSets, TileMatrixSetLink) {
    for(var i = 0; i < TileMatrixSets.length; i++){
        var TileMatrixSet = TileMatrixSets[i];
        TileMatrixSet = TileMatrixSet.getElementsByTagName('ows:Identifier')[0];
        if (TileMatrixSet) {
            if (TileMatrixSet.textContent === TileMatrixSetLink) return TileMatrixSets[i];
        }
    }
    return null;
}
function parseWMTSXML(str, requestUrl, options) {
    var serviceType = [
        "isArcgis",
        "isSuperMap",
        "isGeoServer"
    ];
    if (serviceType.every(function(key) {
        return options[key] == null;
    })) console.warn("Please specify the server type, such as isArcgis, isSuperMap, isGeoServer, Otherwise, the system will determine by itself");
    if (options.isArcgis == null) options.isArcgis = [
        "arcgis",
        "geoscene"
    ].some(function(key) {
        return str.indexOf(key) > -1;
    });
    if (options.isSuperMap == null) options.isSuperMap = str.indexOf('supermap') > -1;
    var parser = new DOMParser();
    var xmlDoc = parser.parseFromString(str, 'text/xml');
    var content = xmlDoc.querySelectorAll('Contents')[0];
    if (!content) return [];
    var layers = getElementsByTagName(content, 'Layer');
    if (!layers.length) return [];
    var TileMatrixSets = [];
    for(var i = 0, len = content.childNodes.length; i < len; i++)if (content.childNodes[i].localName === 'TileMatrixSet') TileMatrixSets.push(content.childNodes[i]);
    if (!TileMatrixSets.length) return [];
    var result = [];
    for(var _i = 0, _len = layers.length; _i < _len; _i++){
        var layer = layers[_i];
        var style = layer.querySelectorAll('Style')[0];
        if (style) {
            style = style.getElementsByTagName('ows:Identifier')[0];
            if (style) style = style.textContent;
        }
        var layerName = layer.getElementsByTagName('ows:Identifier')[0];
        if (layerName) layerName = layerName.textContent;
        var tileMatrixSetLinks = getElementsByTagName(layer, 'TileMatrixSetLink');
        if (tileMatrixSetLinks.length === 0) continue;
        for(var j = 0, len1 = tileMatrixSetLinks.length; j < len1; j++){
            var tileMatrixSetLink = tileMatrixSetLinks[j];
            tileMatrixSetLink = getElementsByTagName(tileMatrixSetLink, 'TileMatrixSet')[0];
            if (tileMatrixSetLink) tileMatrixSetLink = tileMatrixSetLink.textContent;
            var tileMatrixSet = getTileMatrixSet(TileMatrixSets, tileMatrixSetLink);
            if (!tileMatrixSet) continue;
            var resourceURL = layer.querySelectorAll('ResourceURL')[0];
            var url = '';
            if (resourceURL) url = resourceURL.attributes.template.value;
            var { resolutions: resolutions, tileSize: tileSize, tileSystem: tileSystem, projection: projection, TileMatrixSet: TileMatrixSet, isGeoServer: isGeoServer, levelStr: levelStr } = parseTileMatrixSet(tileMatrixSet, options);
            if (!url.length) {
                url = requestUrl.substr(0, requestUrl.lastIndexOf('?'));
                url += '?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER={LAYER}&STYLE={Style}&TILEMATRIXSET={TileMatrixSet}&FORMAT={tiles}&TILEMATRIX={TileMatrix}&TILEROW={TileRow}&TILECOL={TileCol}';
            }
            var urlTemplate = strReplace(url, [
                [
                    '{LAYER}',
                    layerName
                ],
                [
                    '{Layer}',
                    layerName
                ],
                [
                    '{layer}',
                    layerName
                ],
                [
                    '{STYLE}',
                    style
                ],
                [
                    '{Style}',
                    style
                ],
                [
                    '{style}',
                    style
                ],
                [
                    '{TileMatrixSet}',
                    TileMatrixSet
                ],
                [
                    '{TileMatrix}',
                    isGeoServer ? levelStr + ":{z}" : '{z}'
                ],
                [
                    '{TileRow}',
                    '{y}'
                ],
                [
                    '{TileCol}',
                    '{x}'
                ],
                [
                    '{tiles}',
                    isGeoServer ? 'image/png' : 'tiles'
                ]
            ]);
            result.push({
                tileSize: tileSize,
                tileSystem: tileSystem,
                spatialReference: {
                    resolutions: resolutions,
                    projection: projection
                },
                urlTemplate: urlTemplate,
                info: {
                    layerName: layerName,
                    TileMatrixSet: TileMatrixSet,
                    style: style,
                    tileSize: tileSize,
                    tileSystem: tileSystem,
                    resolutions: resolutions,
                    projection: projection,
                    urlTemplate: urlTemplate
                }
            });
        }
    }
    return result;
}
function parseTileMatrixSet(TileMatrixSet, options = {}) {
    var TileMatrixs = getElementsByTagName(TileMatrixSet, 'TileMatrix');
    var resolutions = [], tileSystem = [], tileSize = [];
    var projection, tset, isGeoServer = false, levelStr;
    if (!projection) {
        var supportedCRS = TileMatrixSet.getElementsByTagName('ows:SupportedCRS')[0];
        if (supportedCRS) {
            projection = supportedCRS.textContent;
            projection = projection.split('EPSG')[1];
            projection = getProjectionCode(projection);
            projection = getProjection(projection);
        }
    }
    if (!tset) {
        tset = TileMatrixSet.getElementsByTagName('ows:Identifier')[0];
        if (tset) tset = tset.textContent;
    }
    options.projection = projection;
    var minLevel = Infinity;
    for(var index = 0; index < TileMatrixs.length; index++){
        var TileMatrix = TileMatrixs[index];
        var level = TileMatrix.getElementsByTagName('ows:Identifier')[0].textContent;
        if (isNaN(parseInt(level))) {
            levelStr = level.substr(0, level.lastIndexOf(':'));
            level = level.split(':');
            level = level[level.length - 1];
            level = parseInt(level);
            isGeoServer = true;
            options.isGeoServer = true;
        } else level = parseInt(level);
        minLevel = Math.min(minLevel, level);
        var ScaleDenominator = getElementsByTagName(TileMatrix, 'ScaleDenominator')[0].textContent;
        var TopLeftCorner = getElementsByTagName(TileMatrix, 'TopLeftCorner')[0].textContent;
        var TileWidth = getElementsByTagName(TileMatrix, 'TileWidth')[0].textContent;
        var TileHeight = getElementsByTagName(TileMatrix, 'TileHeight')[0].textContent;
        if (tileSize.length === 0) tileSize.push(parseInt(TileWidth), parseInt(TileHeight));
        if (tileSystem.length === 0) {
            var [x, y] = TopLeftCorner.split(' ').filter(function(s) {
                return s !== '';
            }).map(function(v) {
                return parseFloat(v);
            });
            if (x > 0) tileSystem.push(1, -1, y, x);
            else tileSystem.push(1, -1, x, y);
        }
        var transformValue = getTransformValue(options);
        var res = parseFloat(ScaleDenominator) * transformValue;
        resolutions.push(res);
    }
    if (minLevel > 0) {
        var _res = resolutions[0];
        for(var i = minLevel - 1; i >= 0; i--){
            _res = _res * 2;
            resolutions.splice(0, 0, _res);
        }
    }
    return {
        resolutions: resolutions,
        tileSize: tileSize,
        tileSystem: tileSystem,
        projection: projection,
        TileMatrixSet: tset,
        isGeoServer: isGeoServer,
        levelStr: levelStr
    };
}
var loadWMTS = function loadWMTS(url, cb, options = {
    'jsonp': true
}) {
    if (isString(url)) Ajax.get(url, function(err, xml) {
        if (err) {
            cb(err);
            return;
        }
        var layers = parseWMTSXML(xml, url, options);
        cb(null, layers);
    }, options);
};
function parse(arcConf) {
    var tileInfo = arcConf['tileInfo'], tileSize = [
        tileInfo['cols'],
        tileInfo['rows']
    ], resolutions = [], lods = tileInfo['lods'];
    for(var i = 0, len = lods.length; i < len; i++)resolutions.push(lods[i]['resolution']);
    var fullExtent = arcConf['fullExtent'], origin = tileInfo['origin'], tileSystem = [
        1,
        -1,
        origin['x'],
        origin['y']
    ];
    delete fullExtent['spatialReference'];
    return {
        'spatialReference': {
            'resolutions': resolutions,
            'fullExtent': fullExtent
        },
        'tileSystem': tileSystem,
        'tileSize': tileSize
    };
}
var loadArcgis = function loadArcgis(url, cb, options = {
    'jsonp': true
}) {
    if (isString(url) && url.substring(0, 1) !== '{') Ajax.getJSON(url, function(err, json) {
        if (err) {
            cb(err);
            return;
        }
        var spatialRef = parse(json);
        cb(null, spatialRef);
    }, options);
    else {
        if (isString(url)) url = parseJSON(url);
        var spatialRef = parse(url);
        cb(null, spatialRef);
    }
};
var DEFAULT_CRS;
function createOrGetDefaultSpatialReferences() {
    if (!DEFAULT_CRS) {
        var crsMaxNativeZoom = Math.round(GlobalConfig.crsMaxNativeZoom || 22);
        DEFAULT_CRS = {
            'EPSG:3857': {
                'projection': 'EPSG:3857',
                'resolutions': function() {
                    var resolutions = [];
                    var d = 12756274 * Math.PI;
                    for(var i = 0; i <= crsMaxNativeZoom; i++)resolutions[i] = d / (256 * Math.pow(2, i));
                    return resolutions;
                }(),
                'fullExtent': {
                    'top': 6378137 * Math.PI,
                    'left': -6378137 * Math.PI,
                    'bottom': -6378137 * Math.PI,
                    'right': 6378137 * Math.PI
                }
            },
            'EPSG:4326': {
                'projection': 'EPSG:4326',
                'fullExtent': {
                    'top': 90,
                    'left': -180,
                    'bottom': -90,
                    'right': 180
                },
                'resolutions': function() {
                    var resolutions = [];
                    for(var i = 0; i <= crsMaxNativeZoom; i++)resolutions[i] = 180 / (Math.pow(2, i) * 128);
                    return resolutions;
                }()
            },
            'BAIDU': {
                'projection': 'baidu',
                'resolutions': function() {
                    var res = Math.pow(2, 18);
                    var resolutions = [];
                    for(var i = 0; i <= crsMaxNativeZoom; i++){
                        resolutions[i] = res;
                        res *= 0.5;
                    }
                    return resolutions;
                }(),
                'fullExtent': {
                    'top': 33554432,
                    'left': -33554432,
                    'bottom': -33554432,
                    'right': 33554432
                }
            },
            'IDENTITY': {
                'projection': 'identity',
                'resolutions': function() {
                    var res = Math.pow(2, 8);
                    var resolutions = [];
                    for(var i = 0; i <= crsMaxNativeZoom; i++){
                        resolutions[i] = res;
                        res *= 0.5;
                    }
                    return resolutions;
                }(),
                'fullExtent': {
                    'top': 200000,
                    'left': -200000,
                    'bottom': -200000,
                    'right': 200000
                }
            },
            'PRESET-VT-3857': {
                'projection': 'EPSG:3857',
                'resolutions': function() {
                    var resolutions = [];
                    var d = 6378137 * Math.PI;
                    for(var i = 0; i <= crsMaxNativeZoom; i++)resolutions[i] = d / (256 * Math.pow(2, i));
                    return resolutions;
                }(),
                'fullExtent': {
                    'top': 6378137 * Math.PI,
                    'left': -6378137 * Math.PI,
                    'bottom': -6378137 * Math.PI,
                    'right': 6378137 * Math.PI
                }
            },
            'PRESET-VT-4326': {
                'projection': 'EPSG:4326',
                'fullExtent': {
                    'top': 90,
                    'left': -180,
                    'bottom': -90,
                    'right': 180
                },
                'resolutions': function() {
                    var resolutions = [];
                    for(var i = 0; i <= crsMaxNativeZoom; i++)resolutions[i] = 45 / (Math.pow(2, i) * 128);
                    return resolutions;
                }()
            }
        };
        DEFAULT_CRS['EPSG:4490'] = DEFAULT_CRS['EPSG:4326'];
        DEFAULT_CRS['PRESET-3857-512'] = DEFAULT_CRS['PRESET-VT-3857'];
        DEFAULT_CRS['PRESET-4326-512'] = DEFAULT_CRS['PRESET-VT-4326'];
        DEFAULT_CRS['PRESET-4490-512'] = DEFAULT_CRS['PRESET-VT-4326'];
    }
    return DEFAULT_CRS;
}
var SpatialReference = function() {
    function SpatialReference(options = {}) {
        this.options = options;
        this._initSpatialRef();
    }
    SpatialReference.registerPreset = function registerPreset(name, value) {
        name = name && name.toUpperCase();
        var defaultRefs = createOrGetDefaultSpatialReferences();
        if (defaultRefs[name]) console.warn("Spatial reference " + name + " already registered.");
        defaultRefs[name] = value;
    };
    SpatialReference.getPreset = function getPreset(preset) {
        return createOrGetDefaultSpatialReferences()[preset.toUpperCase()];
    };
    SpatialReference.getAllPresets = function getAllPresets() {
        return Object.keys(createOrGetDefaultSpatialReferences());
    };
    SpatialReference.loadArcgis = function loadArcgis$1(url, cb, options) {
        loadArcgis(url, cb, options);
        return this;
    };
    SpatialReference.loadWMTS = function loadWMTS$1(url, cb, options) {
        loadWMTS(url, cb, options);
        return this;
    };
    SpatialReference.getProjectionInstance = function getProjectionInstance(projection) {
        var proj;
        if (!projection) return null;
        if (isString(projection)) proj = {
            code: projection
        };
        else proj = projection;
        if (proj.project) {
            if (!proj.locate) {
                proj = extend$2({}, proj);
                if (proj.measure === 'identity') extend$2(proj, Measurer.getInstance('IDENTITY'));
                else extend$2(proj, Measurer.getInstance('EPSG:4326'));
            }
            return proj;
        }
        var prjName = (proj.code + '').toLowerCase();
        for(var p in projections)if (hasOwn(projections, p)) {
            var names = projections[p].aliases || [];
            var code = projections[p]['code'];
            if (code) names.push(code);
            for(var i = 0; i < names.length; i++)if (names[i].toLowerCase() === prjName) {
                if (projections[p].create) {
                    var instance = projections[p].create(projection);
                    instance.code = names[i];
                    return instance;
                } else {
                    if (projections[p].code === names[i]) return projections[p];
                    var _instance = extend$2({}, projections[p]);
                    _instance.code = names[i];
                    return _instance;
                }
            }
        }
        return null;
    };
    SpatialReference.equals = function equals(sp1, sp2) {
        if (isString(sp1) || isString(sp2)) return sp1 === sp2;
        if (!sp1 && !sp2) return true;
        else if (!sp1 || !sp2) return false;
        if (sp1.projection !== sp2.projection) return false;
        var f1 = sp1.fullExtent, f2 = sp2.fullExtent;
        if (f1 && !f2 || !f1 && f2) return false;
        if (f1 && f2) {
            if (f1.top !== f2.top || f1.bottom !== f2.bottom || f1.left !== f2.left || f1.right !== f2.right) return false;
        }
        var r1 = sp1.resolutions, r2 = sp2.resolutions;
        if (r1 && r2) {
            if (r1.length !== r2.length) return false;
            for(var i = 0; i < r1.length; i++){
                if (r1[i] !== r2[i]) return false;
            }
        } else if (r1 || r2) return false;
        return true;
    };
    var _proto = SpatialReference.prototype;
    _proto._initSpatialRef = function _initSpatialRef() {
        var projection;
        if (this.options['projection']) projection = SpatialReference.getProjectionInstance(this.options['projection']);
        else projection = DEFAULT;
        if (!projection) throw new Error('must provide a valid projection in map\'s spatial reference.');
        projection = extend$2({}, CommonProjection, projection);
        if (!projection.measureLength) extend$2(projection, DEFAULT$1);
        this._projection = projection;
        var systemSpatialRefs = createOrGetDefaultSpatialReferences();
        var defaultSpatialRef, resolutions = this.options['resolutions'];
        if (!resolutions) {
            if (projection['code']) {
                defaultSpatialRef = systemSpatialRefs[projection['code'].toUpperCase()];
                if (defaultSpatialRef) {
                    resolutions = defaultSpatialRef['resolutions'];
                    this.isEPSG = projection['code'] !== 'IDENTITY';
                }
            }
            if (!resolutions) throw new Error('must provide valid resolutions in map\'s spatial reference.');
        }
        this._resolutions = resolutions;
        this._pyramid = true;
        if (this._pyramid) {
            var delta = 1E4;
            for(var i = 0; i < resolutions.length; i++){
                if (resolutions[i] && resolutions[i - 1]) {
                    if (Math.round(resolutions[i - 1] / resolutions[i] * delta) / delta !== 2) {
                        this._pyramid = false;
                        break;
                    }
                }
            }
        }
        var fullExtent = this.options['fullExtent'];
        if (!fullExtent) {
            if (projection['code']) {
                defaultSpatialRef = systemSpatialRefs[projection['code'].toUpperCase()];
                if (defaultSpatialRef) fullExtent = defaultSpatialRef['fullExtent'];
            }
            if (!fullExtent) throw new Error('must provide a valid fullExtent in map\'s spatial reference.');
        }
        if (!isNil(fullExtent['left'])) this._fullExtent = new Extent(new Coordinate(fullExtent['left'], fullExtent['top']), new Coordinate(fullExtent['right'], fullExtent['bottom']));
        else {
            this._fullExtent = new Extent(fullExtent);
            fullExtent['left'] = fullExtent['xmin'];
            fullExtent['right'] = fullExtent['xmax'];
            fullExtent['top'] = fullExtent['ymax'];
            fullExtent['bottom'] = fullExtent['ymin'];
        }
        if (isNil(fullExtent['top']) || isNil(fullExtent['bottom']) || isNil(fullExtent['left']) || isNil(fullExtent['right'])) throw new Error('must provide valid top/bottom/left/right in fullExtent.');
        extend$2(this._fullExtent, fullExtent);
        this._projection.fullExtent = fullExtent;
        var a = fullExtent['right'] >= fullExtent['left'] ? 1 : -1, b = fullExtent['top'] >= fullExtent['bottom'] ? -1 : 1;
        this._transformation = new Transformation([
            a,
            b,
            0,
            0
        ]);
    };
    _proto.getResolutions = function getResolutions() {
        return this._resolutions || [];
    };
    _proto.getResolution = function getResolution(zoom) {
        var z = zoom | 0;
        if (z < 0) z = 0;
        else if (z > this._resolutions.length - 1) z = this._resolutions.length - 1;
        var res = this._resolutions[z];
        if (z !== zoom && zoom > 0 && z < this._resolutions.length - 1) {
            var next = this._resolutions[z + 1];
            return res + (next - res) * (zoom - z);
        }
        return res;
    };
    _proto.getProjection = function getProjection() {
        return this._projection;
    };
    _proto.getFullExtent = function getFullExtent() {
        return this._fullExtent;
    };
    _proto.getTransformation = function getTransformation() {
        return this._transformation;
    };
    _proto.getMinZoom = function getMinZoom() {
        for(var i = 0; i < this._resolutions.length; i++){
            if (!isNil(this._resolutions[i])) return i;
        }
        return 0;
    };
    _proto.getMaxZoom = function getMaxZoom() {
        for(var i = this._resolutions.length - 1; i >= 0; i--){
            if (!isNil(this._resolutions[i])) return i;
        }
        return this._resolutions.length - 1;
    };
    _proto.getZoomDirection = function getZoomDirection() {
        return sign(this._resolutions[this.getMinZoom()] - this._resolutions[this.getMaxZoom()]);
    };
    _proto.toJSON = function toJSON() {
        if (!this.json) this.json = {
            'resolutions': this._resolutions,
            'fullExtent': {
                'top': this._fullExtent.top,
                'left': this._fullExtent.left,
                'bottom': this._fullExtent.bottom,
                'right': this._fullExtent.right
            },
            'projection': this._projection.code
        };
        return this.json;
    };
    _proto.isPyramid = function isPyramid() {
        return this._pyramid;
    };
    return SpatialReference;
}();
function getDefaultSpatialReference() {
    return JSON.parse(JSON.stringify(createOrGetDefaultSpatialReferences()));
}
var TEMP_POINT0$1 = new Point(0, 0);
var TEMP_EXTENT$4 = new PointExtent();
var TEMP_PROPERTIES = {};
function validateExtent(extent) {
    if (!extent) return false;
    var { xmin: xmin, ymin: ymin, xmax: xmax, ymax: ymax } = extent;
    return xmax - xmin > 0 && ymax - ymin > 0;
}
var options$D = {
    'id': null,
    'visible': true,
    'interactive': true,
    'editable': true,
    'cursor': null,
    'antiMeridian': false,
    'defaultProjection': 'EPSG:4326'
};
var Geometry = function(_JSONAble) {
    function Geometry(options) {
        var _this;
        var opts = extend$2({}, options);
        var symbol = opts['symbol'];
        var properties = opts['properties'];
        var id = opts['id'];
        delete opts['symbol'];
        delete opts['id'];
        delete opts['properties'];
        _this = _JSONAble.call(this, opts) || this;
        if (symbol) _this.setSymbol(symbol);
        else _this._genSizeSymbol();
        if (properties) _this.setProperties(properties);
        if (!isNil(id)) _this.setId(id);
        if (options && isNumber(options.rotateAngle)) _this._dirtyRotate = true;
        return _this;
    }
    _inheritsLoose(Geometry, _JSONAble);
    Geometry.fromJSON = function fromJSON(json) {
        return json;
    };
    var _proto = Geometry.prototype;
    _proto.getFirstCoordinate = function getFirstCoordinate() {
        if (this.type === 'GeometryCollection') {
            var geometries = this.getGeometries();
            if (!geometries.length) return null;
            return geometries[0].getFirstCoordinate();
        }
        var coordinates = this.getCoordinates();
        if (!Array.isArray(coordinates)) return coordinates;
        do coordinates = coordinates[0];
        while (Array.isArray(coordinates) && coordinates.length > 0);
        return coordinates;
    };
    _proto.getLastCoordinate = function getLastCoordinate() {
        if (this.type === 'GeometryCollection') {
            var geometries = this.getGeometries();
            if (!geometries.length) return null;
            return geometries[geometries.length - 1].getLastCoordinate();
        }
        var coordinates = this.getCoordinates();
        if (!Array.isArray(coordinates)) return coordinates;
        do coordinates = coordinates[coordinates.length - 1];
        while (Array.isArray(coordinates) && coordinates.length > 0);
        return coordinates;
    };
    _proto.addTo = function addTo(layer, fitview) {
        layer.addGeometry(this, fitview);
        return this;
    };
    _proto.getLayer = function getLayer() {
        if (!this._layer) return null;
        return this._layer;
    };
    _proto.getMap = function getMap() {
        if (!this._layer) return null;
        return this._layer.getMap();
    };
    _proto.getId = function getId() {
        return this._id;
    };
    _proto.setId = function setId(id) {
        var oldId = this.getId();
        this._id = id;
        this._fireEvent('idchange', {
            'old': oldId,
            'new': id
        });
        return this;
    };
    _proto.getProperties = function getProperties() {
        if (!this.properties) {
            if (this._getParent()) return this._getParent().getProperties();
            return null;
        }
        return this.properties;
    };
    _proto.setProperties = function setProperties(properties) {
        var old = this.properties;
        this.properties = isObject$1(properties) ? extend$2({}, properties) : properties;
        this._clearAltitudeCache();
        this._repaint();
        this._fireEvent('propertieschange', {
            'old': old,
            'new': properties
        });
        return this;
    };
    _proto.getType = function getType() {
        return this.type;
    };
    _proto.getSymbol = function getSymbol() {
        var s = this._symbol;
        if (s) {
            if (!Array.isArray(s)) return extend$2({}, s);
            else return extendSymbol(s);
        }
        return null;
    };
    _proto.setSymbol = function setSymbol(symbol) {
        this._symbolUpdated = symbol;
        this._symbol = this._prepareSymbol(symbol);
        this.onSymbolChanged();
        delete this._compiledSymbol;
        delete this._symbolHash;
        return this;
    };
    _proto.getSymbolHash = function getSymbolHash$1() {
        if (!this._symbolHash) this._symbolHash = getSymbolHash(this._symbolUpdated);
        return this._symbolHash;
    };
    _proto.updateSymbol = function updateSymbol(props) {
        if (!props) return this;
        var s = this._getSymbol();
        if (Array.isArray(s)) {
            if (!Array.isArray(props)) throw new Error('Parameter of updateSymbol is not an array.');
            for(var i = 0; i < props.length; i++){
                if (isTextSymbol(props[i])) delete this._textDesc;
                if (s[i] && props[i]) s[i] = extendSymbol(s[i], props[i]);
            }
        } else if (Array.isArray(props)) throw new Error('Geometry\'s symbol is not an array to update.');
        else {
            if (isTextSymbol(s)) delete this._textDesc;
            if (s) s = extendSymbol(s, props);
            else s = extendSymbol(this._getInternalSymbol(), props);
        }
        this._eventSymbolProperties = props;
        delete this._compiledSymbol;
        return this.setSymbol(s);
    };
    _proto.getTextContent = function getTextContent() {
        var symbol = this._getInternalSymbol();
        if (Array.isArray(symbol)) {
            var contents = [];
            var has = false;
            for(var i = 0; i < symbol.length; i++){
                contents[i] = replaceVariable(symbol[i] && symbol[i]['textName'], this.getProperties());
                if (!isNil(contents[i])) has = true;
            }
            return has ? contents : null;
        }
        return replaceVariable(symbol && symbol['textName'], this.getProperties());
    };
    _proto.getTextDesc = function getTextDesc() {
        if (!this._textDesc) {
            var textContent = this.getTextContent();
            var symbol = this._sizeSymbol;
            var isArray = Array.isArray(textContent);
            if (Array.isArray(symbol)) this._textDesc = symbol.map(function(s, i) {
                return describeText(isArray ? textContent[i] : '', s);
            });
            else this._textDesc = describeText(textContent, symbol);
        }
        return this._textDesc;
    };
    _proto.getCenter = function getCenter() {
        return this._computeCenter(this._getMeasurer());
    };
    _proto.getExtent = function getExtent() {
        var prjExt = this._getPrjExtent();
        var projection = this._getProjection();
        if (prjExt && projection) {
            var min = projection.unproject(new Coordinate(prjExt['xmin'], prjExt['ymin'])), max = projection.unproject(new Coordinate(prjExt['xmax'], prjExt['ymax']));
            return new Extent(min, max, projection);
        } else return this._computeExtent(this._getMeasurer());
    };
    _proto.getContainerExtent = function getContainerExtent(out) {
        var extent2d = this.get2DExtent();
        if (!extent2d || !extent2d.isValid()) return null;
        var map = this.getMap();
        var glRes = map.getGLRes();
        var minAltitude = this.getMinAltitude();
        var extent = extent2d.convertTo(function(c) {
            return map._pointAtResToContainerPoint(c, glRes, minAltitude, TEMP_POINT0$1);
        }, out);
        var maxAltitude = this.getMaxAltitude();
        if (maxAltitude !== minAltitude) {
            var extent2 = extent2d.convertTo(function(c) {
                return map._pointAtResToContainerPoint(c, glRes, maxAltitude, TEMP_POINT0$1);
            }, TEMP_EXTENT$4);
            extent._combine(extent2);
        }
        var layer = this.getLayer();
        if (layer && this.type === 'LineString' && maxAltitude && layer.options['drawAltitude']) {
            var groundExtent = extent2d.convertTo(function(c) {
                return map._pointAtResToContainerPoint(c, glRes, 0, TEMP_POINT0$1);
            }, TEMP_EXTENT$4);
            extent._combine(groundExtent);
        }
        if (extent) {
            var fixedExtent = this._getFixedExtent();
            if (validateExtent(fixedExtent)) extent._add(fixedExtent);
        }
        var smoothness = this.options['smoothness'];
        if (smoothness) extent._expand(extent.getWidth() * 0.15);
        return extent;
    };
    _proto._getFixedExtent = function _getFixedExtent() {
        if (!this._fixedExtent) this._fixedExtent = new PointExtent();
        var symbol = this._sizeSymbol;
        var t = (symbol && symbol['lineWidth'] || 1) / 2;
        this._fixedExtent.set(-t, -t, t, t);
        var dx = symbol && symbol['lineDx'] || 0;
        this._fixedExtent._add([
            dx,
            0
        ]);
        var dy = symbol && symbol['lineDy'] || 0;
        this._fixedExtent._add([
            0,
            dy
        ]);
        return this._fixedExtent;
    };
    _proto.get2DExtent = function get2DExtent() {
        var map = this.getMap();
        if (!map) return null;
        if (this._extent2d) return this._extent2d;
        var extent = this._getPrjExtent();
        if (!extent || !extent.isValid()) return null;
        var min = extent.getMin();
        var max = extent.getMax();
        var glRes = map.getGLRes();
        map._prjToPointAtRes(min, glRes, min);
        map._prjToPointAtRes(max, glRes, max);
        this._extent2d = new PointExtent(min, max);
        this._extent2d.z = map.getZoom();
        return this._extent2d;
    };
    _proto.getSize = function getSize() {
        var extent = this.getContainerExtent();
        return extent ? extent.getSize() : null;
    };
    _proto.containsPoint = function containsPoint(containerPoint, t) {
        if (!this.getMap()) throw new Error('The geometry is required to be added on a map to perform "containsPoint".');
        if (containerPoint instanceof Coordinate) containerPoint = this.getMap().coordToContainerPoint(containerPoint);
        return this._containsPoint(containerPoint, t);
    };
    _proto._containsPoint = function _containsPoint(containerPoint, t) {
        var painter = this._getPainter();
        if (!painter) return false;
        t = t || 0;
        if (this._hitTestTolerance) t += this._hitTestTolerance();
        return painter.hitTest(containerPoint, t);
    };
    _proto.show = function show() {
        this.options['visible'] = true;
        if (this.getMap()) {
            var painter = this._getPainter();
            if (painter) painter.show();
            this._fireEvent('show');
        }
        return this;
    };
    _proto.hide = function hide() {
        this.options['visible'] = false;
        if (this.getMap()) {
            this.onHide();
            var painter = this._getPainter();
            if (painter) painter.hide();
            this._fireEvent('hide');
        }
        return this;
    };
    _proto.isVisible = function isVisible() {
        if (!this.options['visible']) return false;
        var symbol = this._getInternalSymbol();
        if (!symbol) return true;
        if (!this.symbolIsVisible()) return false;
        if (Array.isArray(symbol)) {
            if (!symbol.length) return true;
            for(var i = 0, l = symbol.length; i < l; i++){
                if (isNil(symbol[i]['opacity']) || symbol[i]['opacity'] > 0) return true;
            }
            return false;
        } else return isNil(symbol['opacity']) || isObject$1(symbol['opacity']) || isNumber(symbol['opacity']) && symbol['opacity'] > 0;
    };
    _proto.symbolIsVisible = function symbolIsVisible() {
        var symbols = this._getCompiledSymbol();
        if (!symbols) return true;
        if (!Array.isArray(symbols)) symbols = [
            symbols
        ];
        for(var i = 0, len = symbols.length; i < len; i++){
            var symbol = symbols[i];
            if (!symbol) continue;
            var isVisible = symbol.visible;
            if (isVisible !== false && isVisible !== 0) return true;
        }
        return false;
    };
    _proto.getZIndex = function getZIndex() {
        return this.options['zIndex'] || 0;
    };
    _proto.setZIndex = function setZIndex(zIndex) {
        var old = this.options['zIndex'];
        this.options['zIndex'] = zIndex;
        this._fireEvent('zindexchange', {
            'old': old,
            'new': zIndex
        });
        return this;
    };
    _proto.setZIndexSilently = function setZIndexSilently(zIndex) {
        this.options['zIndex'] = zIndex;
        return this;
    };
    _proto.bringToFront = function bringToFront() {
        var layer = this.getLayer();
        if (!layer || !layer.getGeoMaxZIndex) return this;
        var topZ = layer.getGeoMaxZIndex();
        this.setZIndex(topZ + 1);
        return this;
    };
    _proto.bringToBack = function bringToBack() {
        var layer = this.getLayer();
        if (!layer || !layer.getGeoMinZIndex) return this;
        var bottomZ = layer.getGeoMinZIndex();
        this.setZIndex(bottomZ - 1);
        return this;
    };
    _proto.translate = function translate(x, y, z) {
        if (isNil(x)) return this;
        var offset = new Coordinate(x, y, z);
        if (offset.x === 0 && offset.y === 0 && (isNil(offset.z) || offset.z === 0)) return this;
        var coordinates = this.getCoordinates();
        this._silence = true;
        if (coordinates) {
            if (Array.isArray(coordinates)) {
                var translated = forEachCoord(coordinates, function(coord) {
                    return coord.add(offset);
                });
                this.setCoordinates(translated);
            } else this.setCoordinates(coordinates.add(offset));
        }
        this._silence = false;
        this._fireEvent('positionchange');
        return this;
    };
    _proto._translateRotatePivot = function _translateRotatePivot(newCoordinate) {
        if (!this._pivot || !newCoordinate) return this;
        if (this.options.rotatePivot) {
            var oldCoordinate = this.getCoordinates();
            if (!oldCoordinate) return this;
            if (!(newCoordinate instanceof Coordinate)) newCoordinate = new Coordinate(newCoordinate);
            var offset = newCoordinate.sub(oldCoordinate);
            if (offset.x === 0 && offset.y === 0) return this;
            this._pivot._add(offset);
            this.options.rotatePivot = this._pivot.toArray();
        }
        return this;
    };
    _proto.flash = function flash$1(interval, count, cb, context) {
        return flash.call(this, interval, count, cb, context);
    };
    _proto.copy = function copy() {
        var json = this.toJSON();
        var ret = Geometry.fromJSON(json);
        ret.options['visible'] = true;
        return ret;
    };
    _proto.remove = function remove() {
        var layer = this.getLayer();
        if (!layer) return this;
        this._fireEvent('removestart');
        this._unbind();
        this._fireEvent('removeend');
        this._fireEvent('remove');
        return this;
    };
    _proto.toGeoJSONGeometry = function toGeoJSONGeometry() {
        var gJson = this._exportGeoJSONGeometry();
        return gJson;
    };
    _proto.toGeoJSON = function toGeoJSON(opts) {
        if (!opts) opts = {};
        var feature = {
            'type': 'Feature',
            'geometry': null
        };
        if (isNil(opts['geometry']) || opts['geometry']) {
            var geoJSON = this._exportGeoJSONGeometry();
            feature['geometry'] = geoJSON;
        }
        var id = this.getId();
        if (!isNil(id)) feature['id'] = id;
        var properties;
        if (isNil(opts['properties']) || opts['properties']) properties = this._exportProperties();
        feature['properties'] = properties;
        return feature;
    };
    _proto.toJSON = function toJSON(options) {
        if (!options) options = {};
        var json = this._toJSON(options);
        var other = this._exportGraphicOptions(options);
        extend$2(json, other);
        return json;
    };
    _proto.getLength = function getLength() {
        return this._computeGeodesicLength(this._getMeasurer());
    };
    _proto.getArea = function getArea() {
        return this._computeGeodesicArea(this._getMeasurer());
    };
    _proto.rotate = function rotate(angle, pivot) {
        if (!isNumber(angle)) {
            console.error("angle:" + angle + " is not number");
            return this;
        }
        if (!this._painter) this._dirtyRotate = true;
        if (this.type === 'GeometryCollection') {
            var geometries = this.getGeometries();
            geometries.forEach(function(g) {
                return g.rotate(angle, pivot);
            });
            return this;
        }
        if (!pivot) pivot = this.getCenter();
        else pivot = new Coordinate(pivot);
        this._angle = angle;
        this._pivot = pivot;
        var measurer = this._getMeasurer();
        var coordinates = this.getCoordinates();
        if (!Array.isArray(coordinates)) {
            if ((pivot.x !== coordinates.x || pivot.y !== coordinates.y) && !this.getShell) {
                var c = measurer._rotate(coordinates, pivot, angle);
                this.setCoordinates(c);
            } else this.onPositionChanged();
            if (this.getShell) {
                this.options.rotateAngle = angle;
                this.options.rotatePivot = pivot.toArray();
            }
            return this;
        }
        forEachCoord(coordinates, function(c) {
            return measurer._rotate(c, pivot, angle);
        });
        this.setCoordinates(coordinates);
        return this;
    };
    _proto._rotatePrjCoordinates = function _rotatePrjCoordinates(coordinates) {
        if (!coordinates || this._angle === 0 || !this._pivot) return coordinates;
        var projection = this._getProjection();
        if (!projection) return coordinates;
        var offsetAngle = 0;
        var isArray = Array.isArray(coordinates);
        var coord = isArray ? coordinates : [
            coordinates
        ];
        var rotatePrjCoordinates = [];
        var cx, cy;
        if (this.getRotateOffsetAngle) {
            offsetAngle = this.getRotateOffsetAngle();
            var center = coord[coord.length - 1];
            cx = center.x;
            cy = center.y;
        } else {
            var bbox = getDefaultBBOX();
            pointsBBOX(coord, bbox);
            var [minx, miny, maxx, maxy] = bbox;
            cx = (minx + maxx) / 2;
            cy = (miny + maxy) / 2;
        }
        for(var i = 0, len = coord.length; i < len; i++){
            var c = coord[i];
            var { x: x, y: y } = c;
            var dx = x - cx, dy = y - cy;
            var r = Math.sqrt(dx * dx + dy * dy);
            var sAngle = getSegmentAngle(cx, cy, x, y);
            var rad = (sAngle - this._angle + offsetAngle) / 180 * Math.PI;
            var _rx = Math.cos(rad) * r, _ry = Math.sin(rad) * r;
            var rc = new Coordinate(cx + _rx, cy + _ry);
            rotatePrjCoordinates.push(rc);
        }
        var prjCenter = projection.project(this._pivot);
        var rx = prjCenter.x, ry = prjCenter.y;
        var translateX = cx - rx, translateY = cy - ry;
        for(var _i = 0, _len = rotatePrjCoordinates.length; _i < _len; _i++){
            var _c = rotatePrjCoordinates[_i];
            _c.x -= translateX;
            _c.y -= translateY;
        }
        if (isArray) return rotatePrjCoordinates;
        return rotatePrjCoordinates[0];
    };
    _proto.isRotated = function isRotated() {
        return !!(isNumber(this._angle) && this._pivot);
    };
    _proto._getConnectPoints = function _getConnectPoints() {
        return [
            this.getCenter()
        ];
    };
    _proto._initOptions = function _initOptions(options) {
        var opts = extend$2({}, options);
        var symbol = opts['symbol'];
        var properties = opts['properties'];
        var id = opts['id'];
        delete opts['symbol'];
        delete opts['id'];
        delete opts['properties'];
        this._setOptions(opts);
        if (symbol) this.setSymbol(symbol);
        if (properties) this.setProperties(properties);
        if (!isNil(id)) this.setId(id);
    };
    _proto._bindLayer = function _bindLayer(layer) {
        if (layer === this.getLayer()) return;
        if (this.getLayer()) throw new Error('Geometry cannot be added to two or more layers at the same time.');
        this._layer = layer;
        this._clearCache();
        this._bindInfoWindow();
        this._bindMenu();
    };
    _proto._prepareSymbol = function _prepareSymbol(symbol) {
        if (Array.isArray(symbol)) {
            var cookedSymbols = [];
            for(var i = 0; i < symbol.length; i++)cookedSymbols.push(convertResourceUrl(this._checkAndCopySymbol(symbol[i])));
            return cookedSymbols;
        } else if (symbol) {
            symbol = this._checkAndCopySymbol(symbol);
            return convertResourceUrl(symbol);
        }
        return null;
    };
    _proto._checkAndCopySymbol = function _checkAndCopySymbol(symbol) {
        var s = {};
        for(var i in symbol)if (NUMERICAL_PROPERTIES[i] && isString(symbol[i])) s[i] = +symbol[i];
        else s[i] = symbol[i];
        return s;
    };
    _proto._getSymbol = function _getSymbol() {
        return this._symbol;
    };
    _proto._setExternSymbol = function _setExternSymbol(symbol) {
        this._eventSymbolProperties = symbol;
        if (!this._symbol) delete this._textDesc;
        this._externSymbol = this._prepareSymbol(symbol);
        this.onSymbolChanged();
        return this;
    };
    _proto._getInternalSymbol = function _getInternalSymbol() {
        if (this._symbol) return this._symbol;
        else if (this._externSymbol) return this._externSymbol;
        else if (this.options['symbol']) return this.options['symbol'];
        return null;
    };
    _proto._getPrjExtent = function _getPrjExtent() {
        var p = this._getProjection();
        this._verifyProjection();
        if (!this._extent && p) this._extent = this._computePrjExtent(p);
        return this._extent;
    };
    _proto._unbind = function _unbind() {
        var layer = this.getLayer();
        if (!layer) return;
        if (this._animPlayer) this._animPlayer.finish();
        this._unbindMenu();
        this._unbindInfoWindow();
        if (this.isEditing()) this.endEdit();
        this._removePainter();
        if (this.onRemove) this.onRemove();
        if (layer.onRemoveGeometry) layer.onRemoveGeometry(this);
        delete this._layer;
        delete this._internalId;
        delete this._extent;
    };
    _proto._getInternalId = function _getInternalId() {
        return this._internalId;
    };
    _proto._setInternalId = function _setInternalId(id) {
        this._internalId = id;
    };
    _proto._getMeasurer = function _getMeasurer() {
        if (this._getProjection()) return this._getProjection();
        return SpatialReference.getProjectionInstance(this.options['defaultProjection']);
    };
    _proto._getProjection = function _getProjection() {
        var map = this.getMap();
        if (map) return map.getProjection();
        return null;
    };
    _proto._verifyProjection = function _verifyProjection() {
        var projection = this._getProjection();
        if (this._projCode && projection && this._projCode !== projection.code) this._clearProjection();
        this._projCode = projection ? projection.code : this._projCode;
    };
    _proto._getExternalResources = function _getExternalResources() {
        var symbol = this._getInternalSymbol();
        return getExternalResources(symbol);
    };
    _proto._getPainter = function _getPainter() {
        if (this._painter) return this._painter;
        var layer = this.getLayer();
        if (!this._painter && layer) {
            if (GEOMETRY_COLLECTION_TYPES.indexOf(this.type) !== -1) {
                if (layer.constructor.getCollectionPainterClass) {
                    var clazz = layer.constructor.getCollectionPainterClass();
                    if (clazz) this._painter = new clazz(this);
                }
            } else if (layer.constructor.getPainterClass) {
                var _clazz = layer.constructor.getPainterClass();
                if (_clazz) this._painter = new _clazz(this);
            }
        }
        return this._painter;
    };
    _proto._getMaskPainter = function _getMaskPainter() {
        if (this._maskPainter) return this._maskPainter;
        this._maskPainter = this.getGeometries && this.getGeometries() ? new CollectionPainter(this, true) : new Painter(this);
        return this._maskPainter;
    };
    _proto._removePainter = function _removePainter() {
        if (this._painter) this._painter.remove();
        delete this._painter;
    };
    _proto._paint = function _paint(extent) {
        if (!this.symbolIsVisible()) return;
        if (this._painter) {
            if (this._dirtyCoords) {
                delete this._dirtyCoords;
                var projection = this._getProjection();
                if (projection) {
                    this._pcenter = projection.project(this._coordinates);
                    this._clearCache();
                }
            }
            if (this._dirtyRotate && isNumber(this.options.rotateAngle)) this.rotate(this.options.rotateAngle, this.options.rotatePivot);
            this._dirtyRotate = false;
            this._painter.paint(extent);
        }
    };
    _proto._clearCache = function _clearCache() {
        delete this._extent;
        delete this._extent2d;
        this._clearAltitudeCache();
    };
    _proto._clearProjection = function _clearProjection() {
        delete this._extent;
        delete this._extent2d;
    };
    _proto._repaint = function _repaint() {
        if (this._painter) this._painter.repaint();
    };
    _proto.onHide = function onHide() {
        this.closeMenu();
        this.closeInfoWindow();
    };
    _proto.onShapeChanged = function onShapeChanged() {
        this._clearCache();
        this._repaint();
        this._fireEvent('shapechange');
    };
    _proto.onPositionChanged = function onPositionChanged() {
        this._clearCache();
        this._repaint();
        this._fireEvent('positionchange');
    };
    _proto.onSymbolChanged = function onSymbolChanged() {
        if (this._painter) this._painter.refreshSymbol();
        var e = {};
        if (this._eventSymbolProperties) {
            e.properties = JSON.parse(JSON.stringify(this._eventSymbolProperties));
            delete this._eventSymbolProperties;
        } else delete this._textDesc;
        this._genSizeSymbol();
        this._fireEvent('symbolchange', e);
    };
    _proto._genSizeSymbol = function _genSizeSymbol() {
        var symbol = this._getInternalSymbol();
        if (!symbol) {
            delete this._sizeSymbol;
            return;
        }
        if (Array.isArray(symbol)) {
            this._sizeSymbol = [];
            var dynamicSize = false;
            for(var i = 0; i < symbol.length; i++){
                var s = this._sizeSymbol[i] = this._getSizeSymbol(symbol[i]);
                if (!dynamicSize && s && s._dynamic) dynamicSize = true;
            }
            this._sizeSymbol._dynamic = dynamicSize;
        } else this._sizeSymbol = this._getSizeSymbol(symbol);
    };
    _proto._getSizeSymbol = function _getSizeSymbol(symbol) {
        var symbolSize = loadGeoSymbol({
            lineWidth: symbol['lineWidth'],
            lineDx: symbol['lineDx'],
            lineDy: symbol['lineDy']
        }, this);
        if (isFunctionDefinition(symbol['lineWidth']) || isFunctionDefinition(symbol['lineDx']) || isFunctionDefinition(symbol['lineDy'])) symbolSize._dynamic = true;
        return symbolSize;
    };
    _proto._getCompiledSymbol = function _getCompiledSymbol() {
        if (this._compiledSymbol) return this._compiledSymbol;
        this._compiledSymbol = loadGeoSymbol(this._getInternalSymbol(), this);
        return this._compiledSymbol;
    };
    _proto.onConfig = function onConfig(conf) {
        var properties;
        if (conf['properties']) {
            properties = conf['properties'];
            delete conf['properties'];
        }
        var needRepaint = false;
        for(var p in conf)if (conf.hasOwnProperty(p)) {
            var prefix = p.slice(0, 5);
            if (prefix === 'arrow' || prefix === 'smoot') {
                needRepaint = true;
                break;
            }
        }
        if (properties) {
            this.setProperties(properties);
            this._repaint();
        } else if (needRepaint) this._repaint();
    };
    _proto._setParent = function _setParent(geometry) {
        if (geometry) this._parent = geometry;
    };
    _proto._getParent = function _getParent() {
        return this._parent;
    };
    _proto._fireEvent = function _fireEvent(eventName, param) {
        if (this._silence) return;
        if (this.getLayer() && this.getLayer()._onGeometryEvent) {
            if (!param) param = {};
            param['type'] = eventName;
            param['target'] = this;
            this.getLayer()._onGeometryEvent(param);
        }
        this.fire(eventName, param);
    };
    _proto._toJSON = function _toJSON(options) {
        return {
            'feature': this.toGeoJSON(options)
        };
    };
    _proto._recordVisible = function _recordVisible() {
        var visible = this.options.visible;
        if (isNil(visible)) visible = true;
        this._savedVisible = visible;
    };
    _proto._recoveryVisible = function _recoveryVisible() {
        delete this._savedVisible;
    };
    _proto._exportGraphicOptions = function _exportGraphicOptions(options) {
        var json = {};
        if (isNil(options['options']) || options['options']) json['options'] = this.config();
        if (json['options'] && this.isEditing && this.isEditing()) json['options'].visible = this._savedVisible;
        if (isNil(options['symbol']) || options['symbol']) json['symbol'] = this.getSymbol();
        if (isNil(options['infoWindow']) || options['infoWindow']) {
            if (this._infoWinOptions) json['infoWindow'] = this._infoWinOptions;
        }
        return json;
    };
    _proto._exportGeoJSONGeometry = function _exportGeoJSONGeometry() {
        var points = this.getCoordinates();
        var coordinates = Coordinate.toNumberArrays(points);
        return {
            'type': this.getType(),
            'coordinates': coordinates
        };
    };
    _proto._exportProperties = function _exportProperties() {
        var properties = null;
        var geoProperties = this.getProperties();
        if (!isNil(geoProperties)) {
            if (isObject$1(geoProperties)) properties = extend$2({}, geoProperties);
            else properties = geoProperties;
        }
        return properties;
    };
    _proto._hitTestTolerance = function _hitTestTolerance() {
        return 0;
    };
    _proto._getAltitude = function _getAltitude() {
        var layer = this.getLayer();
        if (!layer) return 0;
        var layerOpts = layer.options;
        var layerAltitude = layer.getAltitude ? layer.getAltitude() : 0;
        var enableAltitude = layerOpts['enableAltitude'];
        if (!enableAltitude && layer.isVectorLayer) return layerAltitude;
        var altitudeProperty = getAltitudeProperty(layer);
        var properties = this.properties || TEMP_PROPERTIES;
        var altitude = properties[altitudeProperty];
        if (isNil(altitude)) {
            var alts = getGeometryCoordinatesAlts(this, layerAltitude, enableAltitude);
            if (!isNil(alts)) return alts;
            return layerAltitude;
        }
        if (Array.isArray(altitude)) return altitude.map(function(alt) {
            return alt + layerAltitude;
        });
        return altitude + layerAltitude;
    };
    _proto.getAltitude = function getAltitude() {
        var layer = this.getLayer();
        var altitudeProperty = getAltitudeProperty(layer);
        var properties = this.properties || TEMP_PROPERTIES;
        var altitude = properties[altitudeProperty];
        if (!isNil(altitude)) return altitude;
        var alts = getGeometryCoordinatesAlts(this, 0, false);
        if (!isNil(alts)) return alts;
        return 0;
    };
    _proto.hasAltitude = function hasAltitude() {
        this._genMinMaxAlt();
        return !!this._minAlt || !!this._maxAlt;
    };
    _proto.setAltitude = function setAltitude(alt) {
        if (!isNumber(alt)) return this;
        var layer = this.getLayer();
        var altitudeProperty = getAltitudeProperty(layer);
        var properties = this.properties || TEMP_PROPERTIES;
        var altitude = properties[altitudeProperty];
        if (!isNil(altitude)) {
            if (Array.isArray(altitude)) for(var i = 0, len = altitude.length; i < len; i++)altitude[i] = alt;
            else properties[altitudeProperty] = alt;
        }
        var coordinates = this.getCoordinates ? this.getCoordinates() : null;
        if (!coordinates) return this;
        setCoordinatesAlt(coordinates, alt);
        if (layer) {
            var renderer = layer.getRenderer();
            if (renderer && (renderer.gl || renderer.device)) this.setCoordinates(coordinates);
            else if (renderer) this._repaint();
        }
        this._clearAltitudeCache();
        this.onPositionChanged();
        return this;
    };
    _proto._genMinMaxAlt = function _genMinMaxAlt() {
        if (this._minAlt === undefined || this._maxAlt === undefined) {
            var altitude = this._getAltitude();
            var [min, max] = getMinMaxAltitude(altitude);
            this._minAlt = min;
            this._maxAlt = max;
        }
    };
    _proto.getMinAltitude = function getMinAltitude() {
        this._genMinMaxAlt();
        return this._minAlt;
    };
    _proto.getMaxAltitude = function getMaxAltitude() {
        this._genMinMaxAlt();
        return this._maxAlt;
    };
    _proto._clearAltitudeCache = function _clearAltitudeCache() {
        this._minAlt = undefined;
        this._maxAlt = undefined;
        return this;
    };
    _proto._getEditCenter = function _getEditCenter() {
        var center = this.getCenter().copy();
        center.z = 0;
        var altitude = this.getAltitude();
        if (isNumber(altitude)) {
            center.z = altitude;
            return center;
        }
        var total = 0, count = 0;
        var _checkArray = function checkArray(altitudeArray) {
            for(var i = 0, len = altitudeArray.length; i < len; i++)if (Array.isArray(altitudeArray[i])) _checkArray(altitudeArray[i]);
            else {
                count++;
                total += altitudeArray[i];
            }
        };
        if (Array.isArray(altitude)) {
            _checkArray(altitude);
            center.z = total / count;
        }
        return center;
    };
    return Geometry;
}(JSONAble(Eventable(Handlerable(Class))));
Geometry.mergeOptions(options$D);
function getAltitudeProperty(layer) {
    var altitudeProperty = 'altitude';
    if (layer) {
        if (!layer.isVectorLayer) return null;
        var layerOpts = layer.options;
        altitudeProperty = layerOpts['altitudeProperty'];
    }
    return altitudeProperty;
}
function getGeometryCoordinatesAlts(geometry, layerAlt, enableAltitude) {
    var coordinates = geometry.getCoordinates ? geometry.getCoordinates() : null;
    if (coordinates) {
        var tempAlts = [];
        coordinatesHasAlt(coordinates, tempAlts);
        if (tempAlts.length) {
            var alts = getCoordinatesAlts(coordinates, layerAlt, enableAltitude);
            return alts;
        }
    }
    return null;
}
function setCoordinatesAlt(coordinates, alt) {
    if (Array.isArray(coordinates)) for(var i = 0, len = coordinates.length; i < len; i++)setCoordinatesAlt(coordinates[i], alt);
    else coordinates.z = alt;
}
function coordinatesHasAlt(coordinates, tempAlts) {
    if (tempAlts.length) return;
    if (Array.isArray(coordinates)) for(var i = 0, len = coordinates.length; i < len; i++)coordinatesHasAlt(coordinates[i], tempAlts);
    else if (isNumber(coordinates.z)) tempAlts.push(coordinates.z);
}
function getCoordinatesAlts(coordinates, layerAlt, enableAltitude) {
    if (Array.isArray(coordinates)) {
        var alts = [];
        for(var i = 0, len = coordinates.length; i < len; i++)alts.push(getCoordinatesAlts(coordinates[i], layerAlt, enableAltitude));
        return alts;
    }
    if (isNumber(coordinates.z)) return enableAltitude ? layerAlt + coordinates.z : coordinates.z;
    else if (enableAltitude) return layerAlt;
    else return 0;
}
function getSegmentAngle(cx, cy, x, y) {
    if (cx === x) {
        if (y > cy) return -90;
        return 90;
    }
    x -= cx;
    y -= cy;
    y = -y;
    var rad = Math.atan2(y, x);
    return rad / Math.PI * 180;
}
var CHECK_FPS_WORKER_KEY = 'check_browser_max_fps';
var CHECK_FPS_WORKER_CODE = "function (exports) {\n    exports.initialize = function () {};\n    function now(){\n        return  new Date().getTime();\n    }\n    function checkFPS(cb) {\n        if (!requestAnimationFrame) {\n            cb(-1);\n            return;\n        }\n        const count = 100;\n        let idx = 0;\n        let id;\n        let startTime;\n        function loop() {\n            idx++;\n            if (idx === count) {\n                cancelAnimationFrame(id);\n                const endTime = now();\n                const timePerFPS = (endTime - startTime) / count;\n                const fps = Math.floor(1000 / timePerFPS);\n                cb(fps);\n            } else {\n                id = requestAnimationFrame(loop);\n            }\n        }\n        startTime = now();\n        id = requestAnimationFrame(loop);\n    }\n    //recive message\n    exports.onmessage = function (msg, postResponse) {\n        checkFPS((fps) => {\n            if (fps < -1) {\n                postResponse('check fps fail');\n            } else {\n                postResponse(null, { fps });\n            }\n        })\n    }\n}";
registerWorkerAdapter(CHECK_FPS_WORKER_KEY, function() {
    return CHECK_FPS_WORKER_CODE;
});
var dedicatedWorker = 0;
var EMPTY_BUFFERS = [];
var Actor = function() {
    function Actor(workerKey) {
        var _this = this;
        startTasks();
        this._delayMessages = [];
        this.initializing = false;
        var hasCreated = adapterHasCreated(workerKey);
        if (workersHasCreated() && !hasCreated) {
            this.initializing = true;
            console.log("Injecting codes in worker with worker key: :" + workerKey);
            createAdapter(workerKey, function() {
                _this.initializing = false;
                _this.created();
            });
        }
        this.workerKey = workerKey;
        this.workerPool = getGlobalWorkerPool();
        this.currentActor = 0;
        this.actorId = UID();
        this.workers = this.workerPool.acquire(this.actorId);
        this.callbacks = {};
        this.callbackID = 0;
        this.receiveFn = this.receive.bind(this);
        this.workers.forEach(function(w) {
            w.addEventListener('message', _this.receiveFn, false);
        });
        pushAdapterCreated(workerKey);
    }
    var _proto = Actor.prototype;
    _proto.created = function created() {
        var _this2 = this;
        this._delayMessages.forEach(function(message) {
            var { command: command, data: data, buffers: buffers, cb: cb, workerId: workerId } = message;
            _this2[command](data, buffers, cb, workerId);
        });
        this._delayMessages = [];
    };
    _proto.isActive = function isActive() {
        return !!this.workers;
    };
    _proto.broadcast = function broadcast(data, buffers, cb) {
        var _this3 = this;
        if (this.initializing) {
            this._delayMessages.push({
                command: 'broadcast',
                data: data,
                buffers: buffers,
                cb: cb
            });
            return this;
        }
        cb = cb || function() {};
        asyncAll(this.workers, function(worker, done) {
            _this3.send(data, buffers, done, worker.id);
        }, cb);
        return this;
    };
    _proto.send = function send(data, buffers, cb, workerId) {
        if (this.initializing) {
            this._delayMessages.push({
                command: 'send',
                data: data,
                buffers: buffers,
                cb: cb,
                workerId: workerId
            });
            return this;
        }
        var id = cb ? this.actorId + ":" + this.callbackID++ : null;
        if (cb) this.callbacks[id] = cb;
        this.post({
            data: data,
            callback: String(id)
        }, buffers, workerId);
        return this;
    };
    _proto.receive = function receive(message) {
        var _this4 = this;
        var data = message.data, id = data.callback;
        var callback = this.callbacks[id];
        delete this.callbacks[id];
        if (data.type === '<request>') {
            if (this.actorId === data.actorId) this[data.command](data.params, function(err, cbData, buffers) {
                var message = {
                    type: '<response>',
                    callback: data.callback
                };
                if (err) message.error = err.message;
                else message.data = cbData;
                _this4.post(message, buffers || EMPTY_BUFFERS, data.workerId);
            });
        } else if (callback && data.error) callback(data.error);
        else if (callback) callback(null, data.data);
    };
    _proto.remove = function remove() {
        var _this5 = this;
        this.workers.forEach(function(w) {
            w.removeEventListener('message', _this5.receiveFn, false);
        });
        delete this.receiveFn;
        delete this.workers;
        delete this.callbacks;
        delete this.workerPool;
    };
    _proto.post = function post(data, buffers, targetID) {
        if (typeof targetID !== 'number' || isNaN(targetID)) targetID = this.currentActor = (this.currentActor + 1) % this.workerPool.workerCount;
        data.workerId = targetID;
        data.workerKey = this.workerKey;
        data.actorId = this.actorId;
        this.workerPool.addMessage(targetID, data, buffers || EMPTY_BUFFERS);
        return targetID;
    };
    _proto.getDedicatedWorker = function getDedicatedWorker() {
        dedicatedWorker = (dedicatedWorker + 1) % this.workerPool.workerCount;
        return dedicatedWorker;
    };
    return Actor;
}();
function asyncAll(array, fn, callback) {
    if (!array.length) callback(null, []);
    var remaining = array.length;
    var results = new Array(array.length);
    var error = null;
    array.forEach(function(item, i) {
        fn(item, function(err, result) {
            if (err) error = err;
            results[i] = result;
            if (--remaining === 0) callback(error, results);
        });
    });
}
var actor;
var FPSCheckActor = function(_Actor) {
    function FPSCheckActor() {
        return _Actor.call(this, CHECK_FPS_WORKER_KEY) || this;
    }
    _inheritsLoose(FPSCheckActor, _Actor);
    return FPSCheckActor;
}(Actor);
function checkFPS(cb) {
    if (!actor) actor = new FPSCheckActor();
    actor.send({}, [], function(err, data) {
        if (err) {
            console.error(err);
            cb();
        } else cb(data.fps);
    });
}
var checkFPSing = false;
function checkBrowserMaxFPS() {
    if (checkFPSing) return;
    if (GlobalConfig.maxFPS <= 0) {
        checkFPSing = true;
        checkFPS(function(fps) {
            if (isNumber(fps) && fps > 0 && GlobalConfig.maxFPS <= 0) GlobalConfig.maxFPS = fps;
            checkFPSing = false;
        });
    }
}
pushLoopHook(checkBrowserMaxFPS);
var EMPTY_ARRAY$2 = [];
var ResourceWorkerConnection = function(_Actor) {
    function ResourceWorkerConnection() {
        return _Actor.call(this, imageFetchWorkerKey) || this;
    }
    _inheritsLoose(ResourceWorkerConnection, _Actor);
    var _proto = ResourceWorkerConnection.prototype;
    _proto.fetchImage = function fetchImage(url, cb) {
        var data = {
            url: url
        };
        this.send(data, EMPTY_ARRAY$2, cb);
    };
    return ResourceWorkerConnection;
}(Actor);
var LayerAbstractRenderer = function(_Class) {
    function LayerAbstractRenderer(layer) {
        var _this;
        _this = _Class.call(this) || this;
        _this.layer = layer;
        _this._painted = false;
        _this._drawTime = 0;
        if (Browser$1.decodeImageInWorker && !Browser$1.safari && !Browser$1.iosWeixin) _this._resWorkerConn = new ResourceWorkerConnection();
        _this.setToRedraw();
        return _this;
    }
    _inheritsLoose(LayerAbstractRenderer, _Class);
    var _proto2 = LayerAbstractRenderer.prototype;
    _proto2.render = function render(framestamp) {
        this.prepareRender();
        if (!this.getMap() || !this.layer.isVisible()) return;
        if (!this.resources) this.resources = getResouceCacheInstance();
        this.checkAndDraw(this._tryToDraw, framestamp);
        this._frameTime = framestamp;
    };
    _proto2.getFrameTimestamp = function getFrameTimestamp() {
        return this._frameTime || 0;
    };
    _proto2.checkAndDraw = function checkAndDraw(drawFn, ...args) {
        var _this2 = this;
        this._toRedraw = false;
        if (this.checkResources) {
            var resources = this.checkResources();
            if (resources.length > 0) {
                this._loadingResource = true;
                this.loadResources(resources).then(function() {
                    _this2._loadingResource = false;
                    if (_this2.layer) {
                        _this2.layer.fire('resourceload');
                        var map = _this2.layer.getMap();
                        _this2.setToRedraw();
                        map.getRenderer().callInNextFrame(function() {
                            _this2.setToRedraw();
                        });
                    }
                });
            } else drawFn.call(this, ...args);
        } else drawFn.call(this, ...args);
    };
    _proto2.testIfNeedRedraw = function testIfNeedRedraw() {
        var map = this.getMap();
        if (this._loadingResource) return false;
        if (this._toRedraw) return true;
        if (map.isInteracting() && !this.drawOnInteracting) return false;
        if (this.needToRedraw()) return true;
        return false;
    };
    _proto2.needToRedraw = function needToRedraw() {
        var map = this.getMap();
        if (map.isInteracting() || map.getRenderer().isViewChanged()) return true;
        return false;
    };
    _proto2.onSkipDrawOnInteracting = function onSkipDrawOnInteracting() {};
    _proto2.isLoadingResource = function isLoadingResource() {
        return this._loadingResource;
    };
    _proto2.isRenderComplete = function isRenderComplete() {
        return !!this._renderComplete;
    };
    _proto2.mustRenderOnInteracting = function mustRenderOnInteracting() {
        return !this._painted;
    };
    _proto2.setToRedraw = function setToRedraw() {
        this._toRedraw = true;
        return this;
    };
    _proto2.remove = function remove() {
        this.onRemove();
        delete this._loadingResource;
        delete this.middleWest;
        delete this.canvas;
        delete this.context;
        delete this.canvasExtent2D;
        delete this._extent2D;
        if (this.resources) this.resources.remove();
        delete this.resources;
        if (this._resWorkerConn) {
            this._resWorkerConn.remove();
            delete this._resWorkerConn;
        }
        delete this.layer;
    };
    _proto2.onRemove = function onRemove() {};
    _proto2.onAdd = function onAdd() {};
    _proto2.getMap = function getMap() {
        if (!this.layer) return null;
        return this.layer.getMap();
    };
    _proto2.getCanvasImage = function getCanvasImage() {
        var map = this.getMap();
        if (this._renderZoom !== map.getZoom() || !this.canvas || !this._extent2D) return null;
        if (this.isBlank()) return null;
        if (this.layer.isEmpty && this.layer.isEmpty()) return null;
        var containerPoint = map._pointToContainerPoint(this.middleWest)._add(0, -map.height / 2);
        return {
            'image': this.canvas,
            'layer': this.layer,
            'point': containerPoint
        };
    };
    _proto2.clear = function clear() {};
    _proto2.isBlank = function isBlank() {
        return !this._painted;
    };
    _proto2.show = function show() {
        this.setToRedraw();
    };
    _proto2.hide = function hide() {
        this.clear();
        this.setToRedraw();
    };
    _proto2.setZIndex = function setZIndex(_z) {
        this.setToRedraw();
    };
    _proto2.screenshotRenderResult = function screenshotRenderResult(x, y, width, height) {
        if (this.canvas) {
            var tempCanvas = Canvas.getTempCanvas();
            tempCanvas.width = width;
            tempCanvas.height = height;
            var context = Canvas.getCanvas2DContext(tempCanvas);
            context.clearRect(0, 0, width, height);
            context.drawImage(this.canvas, x, y, width, height, 0, 0, width, height);
            return context;
        } else console.warn('not find layer canvas for screenshotRenderResult,the layerId:', this.layer.getId());
    };
    _proto2.hitDetect = function hitDetect(point) {
        if (!this.context || this.layer.isEmpty && this.layer.isEmpty() || this.isBlank() || this._errorThrown || this.layer.isVisible && !this.layer.isVisible()) return false;
        var map = this.getMap();
        var r = this.mapDPR || map.getDevicePixelRatio();
        var size = map.getSize();
        if (point.x < 0 || point.x > size['width'] * r || point.y < 0 || point.y > size['height'] * r) return false;
        var x = Math.round(r * point.x), y = Math.round(r * point.y);
        var imageData = this.getImageData && this.getImageData();
        if (imageData) {
            var idx = y * imageData.width * 4 + x * 4;
            return imageData.data[idx + 3] > 0;
        }
        try {
            var ctx = this.screenshotRenderResult(x, y, 2, 2);
            if (ctx) {
                var imgData = ctx.getImageData(x, y, 1, 1).data;
                if (imgData[3] > 0) return true;
            }
        } catch (error) {
            if (!this._errorThrown) {
                if (console) console.warn('hit detect failed with tainted canvas, some geometries have external resources in another domain:\n', error);
                this._errorThrown = true;
            }
            return false;
        }
        return false;
    };
    _proto2.loadResources = function loadResources(resourceUrls) {
        if (!this.resources) this.resources = new ResourceCache();
        var resources = this.resources, promises = [];
        if (isArrayHasData(resourceUrls)) {
            var cache = {};
            for(var i = resourceUrls.length - 1; i >= 0; i--){
                var url = resourceUrls[i];
                if (!url || !url.length) continue;
                var key = url.join('-');
                if (!isImageBitMap(url[0])) {
                    if (cache[key]) continue;
                    cache[key] = 1;
                }
                if (!resources.isResourceLoaded(url, true)) promises.push(new Promise(this._promiseResource(url)));
            }
        }
        return Promise.all(promises);
    };
    _proto2.prepareRender = function prepareRender() {
        delete this._renderComplete;
        var map = this.getMap();
        this._renderZoom = map.getZoom();
        this.canvasExtent2D = this._extent2D = map.get2DExtent();
        this.middleWest = map._containerPointToPoint(new Point(0, map.height / 2));
    };
    _proto2.prepareCanvas = function prepareCanvas() {
        if (!this.context) {
            var map = this.getMap();
            this.canvas = map.getRenderer().canvas;
            this.context = map.getRenderer().context;
            this.initContext();
        }
        this.prepareContext();
        delete this._maskExtent;
        var mask = this.layer.getMask();
        if (!mask) {
            this.layer.fire('renderstart', {
                'context': this.context
            });
            return null;
        }
        var maskExtent2D = this._maskExtent = mask._getMaskPainter().get2DExtent();
        if (maskExtent2D && this._extent2D && !maskExtent2D.intersects(this._extent2D)) {
            this.layer.fire('renderstart', {
                'context': this.context
            });
            return maskExtent2D;
        }
        this.layer.fire('renderstart', {
            'context': this.context
        });
        return maskExtent2D;
    };
    _proto2.initContext = function initContext() {};
    _proto2.prepareContext = function prepareContext() {};
    _proto2.clearContext = function clearContext() {};
    _proto2.getViewExtent = function getViewExtent() {
        return {
            'extent': this._extent2D,
            'maskExtent': this._maskExtent,
            'zoom': this._renderZoom,
            'middleWest': this.middleWest
        };
    };
    _proto2.completeRender = function completeRender() {
        if (this.getMap()) {
            this._renderComplete = true;
            this.layer.fire('renderend', {
                'context': this.context
            });
        }
    };
    _proto2.getEvents = function getEvents() {
        return {
            '_zoomstart': this.onZoomStart,
            '_zooming': this.onZooming,
            '_zoomend': this.onZoomEnd,
            '_resize': this.onResize,
            '_movestart': this.onMoveStart,
            '_moving': this.onMoving,
            '_moveend': this.onMoveEnd,
            '_dragrotatestart': this.onDragRotateStart,
            '_dragrotating': this.onDragRotating,
            '_dragrotateend': this.onDragRotateEnd,
            '_spatialreferencechange': this.onSpatialReferenceChange
        };
    };
    _proto2.onZoomStart = function onZoomStart(param) {};
    _proto2.onZoomEnd = function onZoomEnd(param) {
        this.setToRedraw();
    };
    _proto2.onZooming = function onZooming(param) {};
    _proto2.onMoveStart = function onMoveStart(param) {};
    _proto2.onMoving = function onMoving(param) {};
    _proto2.onMoveEnd = function onMoveEnd(param) {
        this.setToRedraw();
    };
    _proto2.onResize = function onResize(param) {
        delete this._extent2D;
        this.setToRedraw();
    };
    _proto2.onDragRotateStart = function onDragRotateStart(param) {};
    _proto2.onDragRotating = function onDragRotating(param) {};
    _proto2.onDragRotateEnd = function onDragRotateEnd(param) {
        this.setToRedraw();
    };
    _proto2.onSpatialReferenceChange = function onSpatialReferenceChange(param) {};
    _proto2.getDrawTime = function getDrawTime() {
        return this._drawTime;
    };
    _proto2._tryToDraw = function _tryToDraw(framestamp) {
        this._toRedraw = false;
        if (!this.canvas && this.layer.isEmpty && this.layer.isEmpty()) {
            this._renderComplete = true;
            return;
        }
        this._drawAndRecord(framestamp);
    };
    _proto2._drawAndRecord = function _drawAndRecord(framestamp) {
        var map = this.getMap();
        if (!map) return;
        var painted = this._painted;
        this._painted = true;
        var t = now();
        this.mapDPR = map.getDevicePixelRatio();
        this.draw(framestamp);
        t = now() - t;
        this._drawTime = painted ? t : t / 2;
        if (painted && this.layer && this.layer.options['logDrawTime']) console.log(this.layer.getId(), 'frameTimeStamp:', framestamp, 'drawTime:', this._drawTime);
    };
    _proto2._promiseResource = function _promiseResource(url) {
        var _this3 = this;
        var layer = this.layer;
        var resources = this.resources;
        var crossOrigin = layer.options['crossOrigin'];
        var renderer = layer.options['renderer'] || '';
        return function(resolve) {
            if (resources.isResourceLoaded(url, true)) {
                resolve(url);
                return;
            }
            var imageURL = formatResourceUrl(url[0]);
            if (isImageBitMap(imageURL)) {
                createImageBitmap(imageURL).then(function(newbitmap) {
                    _this3._cacheResource(url, newbitmap);
                    resolve(url);
                })["catch"](function(err) {
                    console.error(err);
                    resolve(url);
                });
                return;
            }
            var fetchInWorker = !isSVG(url[0]) && _this3._resWorkerConn && (layer.options['renderer'] !== 'canvas' || layer.options['decodeImageInWorker']);
            if (fetchInWorker) _this3._resWorkerConn.fetchImage(imageURL, function(err, data) {
                if (err) {
                    if (err && typeof console !== 'undefined') console.warn(err);
                    resolve(url);
                    return;
                }
                getImageBitMap(data, function(bitmap) {
                    _this3._cacheResource(url, bitmap);
                    resolve(url);
                });
            });
            else {
                var img = new Image();
                if (!isNil(crossOrigin)) img['crossOrigin'] = crossOrigin;
                else if (renderer !== 'canvas') img['crossOrigin'] = '';
                if (isSVG(url[0]) && !IS_NODE) {
                    if (url[1]) url[1] *= 2;
                    if (url[2]) url[2] *= 2;
                }
                img.onload = function() {
                    _this3._cacheResource(url, img);
                    resolve(url);
                };
                img.onabort = function(err) {
                    if (console) console.warn('image loading aborted: ' + url[0]);
                    if (err) {
                        if (console) console.warn(err);
                    }
                    resolve(url);
                };
                img.onerror = function(err) {
                    if (err && typeof console !== 'undefined') console.warn(err);
                    resources.markErrorResource(url);
                    resolve(url);
                };
                loadImage(img, [
                    imageURL
                ]);
            }
        };
    };
    _proto2._cacheResource = function _cacheResource(url, img) {
        if (!this.layer || !this.resources) return;
        var w = url[1], h = url[2];
        if (this.layer.options['cacheSvgOnCanvas'] && isSVG(url[0]) === 1 && (Browser$1.edge || Browser$1.ie)) {
            if (isNil(w)) w = img.width || this.layer.options['defaultIconSize'][0];
            if (isNil(h)) h = img.height || this.layer.options['defaultIconSize'][1];
            var canvas = Canvas.createCanvas(w, h);
            Canvas.image(canvas.getContext('2d'), img, 0, 0, w, h);
            img = canvas;
        }
        this.resources.addResource(url, img);
    };
    return LayerAbstractRenderer;
}(Class);
var workerSource = "\nfunction (exports) {\n    exports.onmessage = function (msg, postResponse) {\n        var url = msg.data.url;\n        var fetchOptions = msg.data.fetchOptions;\n        requestImageOffscreen(url, function (err, data) {\n            var buffers = [];\n            if (data && data.data) {\n                buffers.push(data.data);\n            }\n            postResponse(err, data, buffers);\n        }, fetchOptions);\n    };\n\n    function requestImageOffscreen(url, cb, fetchOptions) {\n        fetch(url, fetchOptions ? fetchOptions : {})\n            .then(response => response.arrayBuffer())\n            .then(arrayBuffer => {\n                const blob=new Blob([arrayBuffer]);\n                return createImageBitmap(blob);\n            })\n            .then(bitmap => {\n                cb(null, {data:bitmap});\n            }).catch(err => {\n                console.warn('error when loading tile:', url);\n                console.warn(err);\n                cb(err);\n            });\n    }\n}";
function registerWorkerSource() {
    if (!Browser$1.decodeImageInWorker) return;
    registerWorkerAdapter(imageFetchWorkerKey, function() {
        return workerSource;
    });
}
registerWorkerSource();
var options$C = {
    'attribution': null,
    'minZoom': null,
    'maxZoom': null,
    'visible': true,
    'opacity': 1,
    'globalCompositeOperation': null,
    'renderer': 'canvas',
    'debugOutline': '#0f0',
    'cssFilter': null,
    'forceRenderOnMoving': false,
    'forceRenderOnZooming': false,
    'forceRenderOnRotating': false,
    'collision': false,
    'collisionScope': 'layer',
    'hitDetect': function() {
        return !Browser$1.mobile;
    }(),
    'maskClip': true
};
var Layer = function(_JSONAble) {
    function Layer(id, options) {
        var _this;
        var canvas;
        if (options) {
            canvas = options.canvas;
            delete options.canvas;
        }
        _this = _JSONAble.call(this, options) || this;
        _this._canvas = canvas;
        _this.setId(id);
        if (options) {
            _this.setZIndex(options.zIndex);
            if (options.mask) _this.setMask(Geometry.fromJSON(options.mask));
        }
        _this.proxyOptions();
        return _this;
    }
    _inheritsLoose(Layer, _JSONAble);
    var _proto = Layer.prototype;
    _proto.load = function load() {
        if (!this.getMap()) return this;
        if (this.onLoad()) {
            this._initRenderer();
            var zIndex = this.getZIndex();
            if (!isNil(zIndex)) {
                if (this._renderer) {
                    this._renderer.setZIndex(zIndex);
                    if (!this.isCanvasRender()) this._renderer.render();
                }
            }
            this.onLoadEnd();
        }
        return this;
    };
    _proto.getId = function getId() {
        return this._id;
    };
    _proto.setId = function setId(id) {
        var old = this._id;
        if (!isNil(id)) id = id + '';
        this._id = id;
        this.fire('idchange', {
            'type': 'idchange',
            'target': this,
            'old': old,
            'new': id
        });
        return this;
    };
    _proto.addTo = function addTo(map) {
        map.addLayer(this);
        return this;
    };
    _proto.setZIndex = function setZIndex(zIndex) {
        this._zIndex = zIndex;
        if (isNil(zIndex)) delete this.options['zIndex'];
        else this.options.zIndex = zIndex;
        if (this.map) this.map._sortLayersByZIndex();
        if (this._renderer) this._renderer.setZIndex(zIndex);
        this.fire('setzindex', {
            'type': 'setzindex',
            'target': this,
            zIndex: zIndex
        });
        return this;
    };
    _proto.getZIndex = function getZIndex() {
        return this._zIndex || 0;
    };
    _proto.getMinZoom = function getMinZoom() {
        var map = this.getMap();
        var minZoom = this.options['minZoom'];
        return map ? Math.max(map.getMinZoom(), minZoom || 0) : minZoom;
    };
    _proto.getMaxZoom = function getMaxZoom() {
        var map = this.getMap();
        var maxZoom = this.options['maxZoom'];
        return map ? Math.min(map.getMaxZoom(), isNil(maxZoom) ? Infinity : maxZoom) : maxZoom;
    };
    _proto.getOpacity = function getOpacity() {
        return this.options['opacity'];
    };
    _proto.setOpacity = function setOpacity(op) {
        this.config('opacity', op);
        this.fire('setopacity', {
            type: 'setopacity',
            target: this,
            opacity: op
        });
        return this;
    };
    _proto.isCanvasRender = function isCanvasRender() {
        var renderer = this._getRenderer();
        return renderer && renderer instanceof LayerAbstractRenderer;
    };
    _proto.getMap = function getMap() {
        if (this.map) return this.map;
        return null;
    };
    _proto.getProjection = function getProjection() {
        var map = this.getMap();
        return map ? map.getProjection() : null;
    };
    _proto.bringToFront = function bringToFront() {
        var layers = this._getLayerList();
        if (!layers.length) return this;
        var topLayer = layers[layers.length - 1];
        if (layers.length === 1 || topLayer === this) return this;
        var max = topLayer.getZIndex();
        this.setZIndex(max + 1);
        return this;
    };
    _proto.bringToBack = function bringToBack() {
        var layers = this._getLayerList();
        if (!layers.length) return this;
        var bottomLayer = layers[0];
        if (layers.length === 1 || bottomLayer === this) return this;
        var min = bottomLayer.getZIndex();
        this.setZIndex(min - 1);
        return this;
    };
    _proto.show = function show() {
        var _this2 = this;
        if (!this.options['visible']) {
            this.options['visible'] = true;
            var renderer = this.getRenderer();
            if (renderer) renderer.show();
            var map = this.getMap();
            if (renderer && map && map.getRenderer()) map.getRenderer().callInNextFrame(function() {
                map.getRenderer().callInNextFrame(function() {
                    _this2.fire('show');
                });
            });
            else this.fire('show');
        }
        return this;
    };
    _proto.hide = function hide() {
        var _this3 = this;
        if (this.options['visible']) {
            this.options['visible'] = false;
            var renderer = this.getRenderer();
            if (renderer) renderer.hide();
            var map = this.getMap();
            if (renderer && map && map.getRenderer()) map.getRenderer().callInNextFrame(function() {
                map.getRenderer().callInNextFrame(function() {
                    _this3.fire('hide');
                });
            });
            else this.fire('hide');
        }
        return this;
    };
    _proto.isVisible = function isVisible() {
        var opacity = this.options['opacity'];
        if (isNumber(opacity) && opacity <= 0) return false;
        var map = this.map;
        if (map) {
            var zoom = map.getZoom();
            var minZoom = this.options.minZoom, maxZoom = this.options.maxZoom;
            if (!isNil(maxZoom) && maxZoom < zoom || !isNil(minZoom) && minZoom > zoom) return false;
        }
        if (isNil(this.options['visible'])) this.options['visible'] = true;
        return this.options['visible'];
    };
    _proto.remove = function remove() {
        if (this.map) {
            var renderer = this.map.getRenderer();
            this.map.removeLayer(this);
            if (renderer) renderer.setToRedraw();
        } else this.fire('remove');
        return this;
    };
    _proto.getMask = function getMask() {
        return this._mask;
    };
    _proto.setMask = function setMask(mask) {
        if (!(mask.type === 'Point' && mask._isVectorMarker() || mask.type === 'Polygon' || mask.type === 'MultiPolygon')) throw new Error('Mask for a layer must be a marker with vector marker symbol or a Polygon(MultiPolygon).');
        mask._bindLayer(this);
        if (mask.type === 'Point') mask.updateSymbol({
            'markerLineColor': 'rgba(0, 0, 0, 0)',
            'markerFillOpacity': 0
        });
        else mask.setSymbol({
            'lineColor': 'rgba(0, 0, 0, 0)',
            'polygonOpacity': 0
        });
        this._mask = mask;
        if (mask && mask.toGeoJSON) try {
            this._maskGeoJSON = mask.toGeoJSON();
        } catch (error) {
            delete this._maskGeoJSON;
            console.error(error);
        }
        this.options.mask = mask.toJSON();
        if (!this.getMap() || this.getMap().isZooming()) return this;
        var renderer = this._getRenderer();
        if (renderer && renderer.setToRedraw) this._getRenderer().setToRedraw();
        return this;
    };
    _proto.removeMask = function removeMask() {
        delete this._mask;
        delete this._maskGeoJSON;
        delete this.options.mask;
        if (!this.getMap() || this.getMap().isZooming()) return this;
        var renderer = this._getRenderer();
        if (renderer && renderer.setToRedraw) this._getRenderer().setToRedraw();
        return this;
    };
    _proto.onLoad = function onLoad() {
        return true;
    };
    _proto.onLoadEnd = function onLoadEnd() {};
    _proto.isLoaded = function isLoaded() {
        return !!this._loaded;
    };
    _proto.getCollisionIndex = function getCollisionIndex() {
        if (this.options['collisionScope'] === 'layer') {
            if (!this._collisionIndex) this._collisionIndex = new CollisionIndex();
            return this._collisionIndex;
        }
        var map = this.getMap();
        if (!map) return null;
        return map.getCollisionIndex();
    };
    _proto.clearCollisionIndex = function clearCollisionIndex() {
        if (this.options['collisionScope'] === 'layer' && this._collisionIndex) this._collisionIndex.clear();
        return this;
    };
    _proto.getRenderer = function getRenderer() {
        return this._getRenderer();
    };
    _proto.onConfig = function onConfig(conf) {
        var needUpdate = conf && Object.keys && Object.keys(conf).length > 0;
        if (needUpdate && isNil(conf['animation'])) {
            if (this._optionsHook && isFunction(this._optionsHook)) this._optionsHook(conf);
            if (this._silentConfig) return;
            var renderer = this.getRenderer();
            if (renderer && renderer.setToRedraw) renderer.setToRedraw();
            if ('attribution' in conf) {
                var map = this.getMap();
                if (map && map.attributionControl && map.attributionControl._update) map.attributionControl._update();
            }
        }
    };
    _proto.onAdd = function onAdd() {};
    _proto.onRendererCreate = function onRendererCreate() {};
    _proto.onCanvasCreate = function onCanvasCreate() {};
    _proto.onRemove = function onRemove() {};
    _proto._bindMap = function _bindMap(map, zIndex) {
        if (!map) return;
        this.map = map;
        if (!isNil(zIndex)) this.setZIndex(zIndex);
        this._switchEvents('on', this);
        this.onAdd();
        this.fire('add');
    };
    _proto._initRenderer = function _initRenderer() {
        var renderer = this.options['renderer'];
        if (!this.constructor.getRendererClass || !renderer) return;
        var clazz = this.constructor.getRendererClass(renderer);
        if (!clazz) throw new Error('Invalid renderer for Layer(' + this.getId() + '):' + renderer);
        this._renderer = new clazz(this);
        this._renderer.layer = this;
        this._renderer.setZIndex(this.getZIndex());
        this._switchEvents('on', this._renderer);
        if (this._renderer.onAdd) this._renderer.onAdd();
        this.onRendererCreate();
        this.fire('renderercreate', {
            'type': 'renderercreate',
            'target': this,
            'renderer': this._renderer
        });
    };
    _proto._doRemove = function _doRemove() {
        this._loaded = false;
        this._switchEvents('off', this);
        this.onRemove();
        if (this._renderer) {
            this._switchEvents('off', this._renderer);
            this._renderer.remove();
            delete this._renderer;
        }
        delete this.map;
        delete this._collisionIndex;
    };
    _proto._switchEvents = function _switchEvents(to, emitter) {
        if (emitter && emitter.getEvents && this.getMap()) this.getMap()[to](emitter.getEvents(), emitter);
    };
    _proto._getRenderer = function _getRenderer() {
        return this._renderer;
    };
    _proto._getLayerList = function _getLayerList() {
        if (!this.map) return [];
        var beginIndex = +!!this.map.getBaseLayer();
        return this.map.getLayers().slice(beginIndex);
    };
    _proto._getMask2DExtent = function _getMask2DExtent() {
        if (!this._mask || !this.getMap()) return null;
        var painter = this._mask._getMaskPainter();
        if (!painter) return null;
        return painter.get2DExtent();
    };
    _proto.toJSON = function toJSON(options) {
        return {
            type: 'Layer',
            id: this.getId(),
            options: options || this.config()
        };
    };
    Layer.fromJSON = function fromJSON(layerJSON) {
        if (!layerJSON) return null;
        var layerType = layerJSON['type'];
        var clazz = Layer.getJSONClass(layerType);
        if (!clazz || !clazz.fromJSON) throw new Error('unsupported layer type:' + layerType);
        return clazz.fromJSON(layerJSON);
    };
    _proto.identify = function identify(_coordinate, _options) {};
    _proto.identifyAtPoint = function identifyAtPoint(_containerPoint, _options) {};
    return Layer;
}(JSONAble(Eventable(Renderable(Class))));
Layer.mergeOptions(options$C);
var fire = Layer.prototype.fire;
Layer.prototype.fire = function(eventType, param) {
    if (eventType === 'layerload') this._loaded = true;
    if (this.map) {
        if (!param) param = {
            'type': null,
            'target': null
        };
        param['type'] = eventType;
        param['target'] = this;
        this.map._onLayerEvent(param);
    }
    fire.apply(this, arguments);
    if ([
        'show',
        'hide'
    ].indexOf(eventType) > -1) this.fire('visiblechange', Object.assign({}, param, {
        visible: this.options.visible
    }));
    return this;
};
var TEMP_COORD$2 = new Coordinate(0, 0);
var TEMP_POINT$5 = new Point(0, 0);
var REDRAW_OPTIONS_PROPERTIES = [
    'centerCross',
    'fog',
    'fogColor',
    'debugSky'
];
var options$B = {
    'maxVisualPitch': 70,
    'maxPitch': 80,
    'centerCross': false,
    'zoomInCenter': false,
    'zoomOrigin': null,
    'zoomAnimation': function() {
        return !IS_NODE;
    }(),
    'zoomAnimationDuration': 330,
    'panAnimation': function() {
        return !IS_NODE;
    }(),
    'panAnimationDuration': 600,
    'rotateAnimation': function() {
        return !IS_NODE;
    }(),
    'zoomable': true,
    'enableInfoWindow': true,
    'hitDetect': function() {
        return !Browser$1.mobile;
    }(),
    'hitDetectLimit': 5,
    'fpsOnInteracting': 25,
    'layerCanvasLimitOnInteracting': -1,
    'maxZoom': null,
    'minZoom': null,
    'maxExtent': null,
    'limitExtentOnMaxExtent': false,
    'fixCenterOnResize': true,
    'checkSize': true,
    'checkSizeInterval': 1000,
    'renderer': [
        'canvas',
        'gl',
        'gpu'
    ],
    'cascadePitches': [
        10,
        60
    ],
    'renderable': true,
    'clickTimeThreshold': 280,
    'stopRenderOnOffscreen': true,
    'preventWheelScroll': true,
    'preventTouch': true,
    'supportPluginEvent': true,
    'switchDragButton': false,
    'mousemoveThrottleTime': MOUSEMOVE_THROTTLE_TIME,
    'maxFPS': 0,
    'debug': false,
    'cameraFarUndergroundInMeter': 2000,
    'onlyWebGL1': false,
    'forceRedrawPerFrame': false,
    'preserveDrawingBuffer': true,
    'extensions': [],
    'optionalExtensions': [
        'ANGLE_instanced_arrays',
        'OES_element_index_uint',
        'OES_standard_derivatives',
        'OES_vertex_array_object',
        'OES_texture_half_float',
        'OES_texture_half_float_linear',
        'OES_texture_float',
        'OES_texture_float_linear',
        'WEBGL_depth_texture',
        'EXT_shader_texture_lod',
        'EXT_frag_depth',
        'EXT_texture_filter_anisotropic',
        'WEBGL_compressed_texture_astc',
        'WEBGL_compressed_texture_etc',
        'WEBGL_compressed_texture_etc1',
        'WEBGL_compressed_texture_pvrtc',
        'WEBGL_compressed_texture_s3tc',
        'WEBGL_compressed_texture_s3tc_srgb'
    ]
};
var Map$1 = function(_Handlerable) {
    function Map1(container, options) {
        var _this;
        if (!options) throw new Error('Invalid options when creating map.');
        if (!options['center']) throw new Error('Invalid center when creating map.');
        var opts = extend$2({}, options);
        var zoom = opts['zoom'];
        delete opts['zoom'];
        var center = new Coordinate(opts['center']);
        delete opts['center'];
        var baseLayer = opts['baseLayer'];
        delete opts['baseLayer'];
        var layers = opts['layers'];
        delete opts['layers'];
        _this = _Handlerable.call(this, opts) || this;
        _this.VERSION = Map1.VERSION;
        Object.defineProperty(_this, 'id', {
            value: UID(),
            writable: false
        });
        _this._loaded = false;
        _this._initContainer(container);
        _this._panels = {};
        _this._baseLayer = null;
        _this._layers = [];
        _this._zoomLevel = zoom;
        _this._center = center;
        _this._centerZ = center.z;
        _this.setSpatialReference(opts['spatialReference'] || opts['view']);
        _this._mapViewPoint = new Point(0, 0);
        _this._initRenderer();
        _this._updateMapSize(_this._getContainerDomSize());
        if (baseLayer) _this.setBaseLayer(baseLayer);
        if (layers) _this.addLayer(layers);
        _this.setMaxExtent(opts['maxExtent']);
        _this._Load();
        _this.proxyOptions();
        _this.isMap = true;
        return _this;
    }
    _inheritsLoose(Map1, _Handlerable);
    Map1.addOnLoadHook = function addOnLoadHook(fn, ...args) {
        var onload = typeof fn === 'function' ? fn : function() {
            this[fn].call(this, ...args);
        };
        this.prototype._onLoadHooks = this.prototype._onLoadHooks || [];
        this.prototype._onLoadHooks.push(onload);
        return this;
    };
    var _proto = Map1.prototype;
    _proto.isLoaded = function isLoaded() {
        return !!this._loaded;
    };
    _proto.getContainer = function getContainer() {
        return this._containerDOM;
    };
    _proto.getSpatialReference = function getSpatialReference() {
        return this._spatialReference;
    };
    _proto.setSpatialReference = function setSpatialReference(ref) {
        var oldRef = this.options['spatialReference'];
        if (this._loaded && SpatialReference.equals(oldRef, ref)) return this;
        this._updateSpatialReference(ref, oldRef);
        return this;
    };
    _proto._updateSpatialReference = function _updateSpatialReference(ref, oldRef) {
        if (isString(ref)) ref = SpatialReference.getPreset(ref);
        ref = extend$2({}, ref);
        this._center = this.getCenter();
        this.options['spatialReference'] = ref;
        this._spatialReference = new SpatialReference(ref);
        var projection = this._spatialReference.getProjection();
        if (this.options['spatialReference'] && isFunction(this.options['spatialReference']['projection'])) this.options['spatialReference']['projection'] = projection['code'];
        this._resetMapStatus();
        if (EPSG9807.is(projection.code)) {
            this._originLng = projection.centralMeridian;
            this._altitudeOriginDirty = true;
        }
        this._fireEvent('spatialreferencechange', {
            'old': oldRef,
            'new': extend$2({}, this.options['spatialReference'])
        });
        return this;
    };
    _proto.onConfig = function onConfig(conf) {
        var ref = conf['spatialReference'] || conf['view'];
        if (!isNil(ref)) this._updateSpatialReference(ref, null);
        if (this.options.renderer === 'canvas') {
            var needUpdate = false;
            for(var i = 0, len = REDRAW_OPTIONS_PROPERTIES.length; i < len; i++){
                var key = REDRAW_OPTIONS_PROPERTIES[i];
                if (!isNil(conf[key])) {
                    needUpdate = true;
                    break;
                }
            }
            if (!needUpdate) return this;
        }
        var renderer = this.getRenderer();
        if (renderer) renderer.setToRedraw();
        return this;
    };
    _proto.getProjection = function getProjection() {
        if (!this._spatialReference) return null;
        return this._spatialReference.getProjection();
    };
    _proto.getFullExtent = function getFullExtent() {
        if (!this._spatialReference) return null;
        return this._spatialReference.getFullExtent();
    };
    _proto.setCursor = function setCursor(cursor) {
        delete this._cursor;
        this._trySetCursor(cursor);
        this._cursor = cursor;
        return this;
    };
    _proto.resetCursor = function resetCursor() {
        return this.setCursor(null);
    };
    _proto.getCenter = function getCenter() {
        if (!this._loaded || !this._prjCenter) return this._center;
        var projection = this.getProjection();
        var center = projection.unproject(this._prjCenter);
        center.x = Math.round(center.x * 1E8) / 1E8;
        center.y = Math.round(center.y * 1E8) / 1E8;
        center.z = this._centerZ;
        if (this.centerAltitude) center.z = this.centerAltitude;
        return center;
    };
    _proto.setCenter = function setCenter(center, padding) {
        if (!center) return this;
        center = new Coordinate(center);
        if (padding) center = this._getCenterByPadding(center, this.getZoom(), padding);
        var projection = this.getProjection();
        var pcenter = projection.project(center);
        if (!this._verifyExtent(pcenter) && !this.options.limitExtentOnMaxExtent) return this;
        if (!this._loaded) {
            this._center = center;
            return this;
        }
        this._centerZ = center.z;
        this.onMoveStart();
        this._setPrjCenter(pcenter);
        this.onMoveEnd(this._parseEventFromCoord(this.getCenter()));
        return this;
    };
    _proto.getSize = function getSize() {
        if (isNil(this.width) || isNil(this.height)) return this._getContainerDomSize();
        return new Size(this.width, this.height);
    };
    _proto.getContainerExtent = function getContainerExtent() {
        var visualHeight = this.height;
        var pitch = this.getPitch(), maxVisualPitch = this.options['maxVisualPitch'];
        if (maxVisualPitch && pitch > maxVisualPitch) visualHeight = this._getVisualHeight(maxVisualPitch);
        return new PointExtent(0, this.height - visualHeight, this.width, this.height);
    };
    _proto._getVisualHeight = function _getVisualHeight(visualPitch) {
        visualPitch = visualPitch || 1E-2;
        var pitch = (90 - this.getPitch()) * Math.PI / 180;
        var fov = this.getFov() * Math.PI / 180;
        visualPitch *= Math.PI / 180;
        var cameraToCenter = this.cameraCenterDistance / this.getGLScale();
        var tanB = Math.tan(fov / 2);
        var tanP = Math.tan(visualPitch);
        var visualDistance = cameraToCenter * tanB / (1 / tanP - tanB) / Math.sin(visualPitch);
        var x = cameraToCenter * (Math.sin(pitch) * visualDistance / (cameraToCenter + Math.cos(pitch) * visualDistance));
        return this.height / 2 + x;
    };
    _proto.getExtent = function getExtent() {
        return this.pointToExtent(this.get2DExtent());
    };
    _proto.getProjExtent = function getProjExtent() {
        var extent2D = this.get2DExtent();
        return new Extent(this._pointToPrj(extent2D.getMin()), this._pointToPrj(extent2D.getMax()));
    };
    _proto.getPrjExtent = function getPrjExtent() {
        return this.getProjExtent();
    };
    _proto.getMaxExtent = function getMaxExtent() {
        if (!this.options['maxExtent']) return null;
        return new Extent(this.options['maxExtent'], this.getProjection());
    };
    _proto.setMaxExtent = function setMaxExtent(extent) {
        if (extent) {
            var maxExt = new Extent(extent, this.getProjection());
            this.options['maxExtent'] = maxExt;
            var projection = this.getProjection();
            this._prjMaxExtent = maxExt.convertTo(function(c) {
                return projection.project(c);
            });
            if (!this._verifyExtent(this._getPrjCenter())) {
                if (this._loaded) this._panTo(this._prjMaxExtent.getCenter());
                else this._center = projection.unproject(this._prjMaxExtent.getCenter());
            }
        } else {
            delete this.options['maxExtent'];
            delete this._prjMaxExtent;
        }
        return this;
    };
    _proto.getZoom = function getZoom() {
        return this._zoomLevel;
    };
    _proto.getZoomForScale = function getZoomForScale(scale, fromZoom, isFraction) {
        var zoom = this.getZoom();
        if (isNil(fromZoom)) fromZoom = zoom;
        if (scale === 1 && fromZoom === zoom) return zoom;
        var res = this._getResolution(fromZoom), targetRes = res / scale;
        var scaleZoom = this.getZoomFromRes(targetRes);
        if (isFraction) return scaleZoom;
        else {
            var delta = 1E-6;
            return this.getSpatialReference().getZoomDirection() < 0 ? Math.ceil(scaleZoom - delta) : Math.floor(scaleZoom + delta);
        }
    };
    _proto.getZoomFromRes = function getZoomFromRes(res) {
        var resolutions = this._getResolutions(), minRes = this._getResolution(this.getMinZoom()), maxRes = this._getResolution(this.getMaxZoom());
        if (minRes <= maxRes) {
            if (res <= minRes) return this.getMinZoom();
            else if (res >= maxRes) return this.getMaxZoom();
        } else if (res >= minRes) return this.getMinZoom();
        else if (res <= maxRes) return this.getMaxZoom();
        var l = resolutions.length;
        for(var i = 0; i < l - 1; i++){
            if (!resolutions[i]) continue;
            var gap = resolutions[i + 1] - resolutions[i];
            var test = res - resolutions[i];
            if (sign(gap) === sign(test) && Math.abs(gap) >= Math.abs(test)) return i + test / gap;
        }
        return l - 1;
    };
    _proto.setZoom = function setZoom(zoom, options = {
        'animation': true
    }) {
        if (isNaN(zoom) || isNil(zoom)) return this;
        zoom = +zoom;
        if (this._loaded && this.options['zoomAnimation'] && options['animation']) this._zoomAnimation(zoom);
        else this._zoom(zoom);
        return this;
    };
    _proto.getMaxZoom = function getMaxZoom() {
        if (!isNil(this.options['maxZoom'])) return this.options['maxZoom'];
        return this.getMaxNativeZoom();
    };
    _proto.setMaxZoom = function setMaxZoom(maxZoom) {
        var viewMaxZoom = this.getMaxNativeZoom();
        if (maxZoom > viewMaxZoom) maxZoom = viewMaxZoom;
        if (maxZoom !== null && maxZoom < this._zoomLevel) {
            this.setZoom(maxZoom);
            maxZoom = +maxZoom;
        }
        this.options['maxZoom'] = maxZoom;
        return this;
    };
    _proto.getMinZoom = function getMinZoom() {
        if (!isNil(this.options['minZoom'])) return this.options['minZoom'];
        return this._spatialReference.getMinZoom();
    };
    _proto.setMinZoom = function setMinZoom(minZoom) {
        if (minZoom !== null) {
            minZoom = +minZoom;
            var viewMinZoom = this._spatialReference.getMinZoom();
            if (minZoom < viewMinZoom) minZoom = viewMinZoom;
            if (minZoom > this._zoomLevel) this.setZoom(minZoom);
        }
        this.options['minZoom'] = minZoom;
        return this;
    };
    _proto.getMaxNativeZoom = function getMaxNativeZoom() {
        var ref = this.getSpatialReference();
        if (!ref) return null;
        return ref.getMaxZoom();
    };
    _proto.getGLRes = function getGLRes() {
        if (this._glRes) return this._glRes;
        var fullExtent = this.getSpatialReference().getFullExtent();
        this._glRes = (fullExtent.right - fullExtent.left) / Math.pow(2, 19);
        return this._glRes;
    };
    _proto.getGLScale = function getGLScale(zoom) {
        if (isNil(zoom)) zoom = this.getZoom();
        return this._getResolution(zoom) / this.getGLRes();
    };
    _proto.zoomIn = function zoomIn() {
        return this.setZoom(this.getZoom() + 1);
    };
    _proto.zoomOut = function zoomOut() {
        return this.setZoom(this.getZoom() - 1);
    };
    _proto.isZooming = function isZooming() {
        return !!this._zooming;
    };
    _proto.isInteracting = function isInteracting() {
        return this.isZooming() || this.isMoving() || this.isRotating();
    };
    _proto.setCenterAndZoom = function setCenterAndZoom(center, zoom) {
        if (!isNil(zoom) && this._zoomLevel !== zoom) {
            this.setCenter(center);
            this.setZoom(zoom, {
                animation: false
            });
        } else this.setCenter(center);
        return this;
    };
    _proto._getPaddingSize = function _getPaddingSize(options = {}) {
        if (options['paddingLeft'] || options['paddingTop'] || options['paddingRight'] || options['paddingBottom']) return {
            width: (options['paddingLeft'] || 0) + (options['paddingRight'] || 0),
            height: (options['paddingTop'] || 0) + (options['paddingBottom'] || 0)
        };
        return null;
    };
    _proto.getFitZoom = function getFitZoom(extent, isFraction, padding) {
        var _this2 = this;
        if (!extent || !(extent instanceof Extent)) return this._zoomLevel;
        if (extent['xmin'] === extent['xmax'] && extent['ymin'] === extent['ymax']) return this.getMaxZoom();
        var size = this.getSize();
        var paddingSize = this._getPaddingSize(padding);
        if (paddingSize) {
            var rect = {
                width: size.width - (paddingSize.width || 0),
                height: size.height - (paddingSize.height || 0)
            };
            size = new Size(rect.width, rect.height);
        }
        var containerExtent = extent.convertTo(function(p) {
            return _this2.coordToPoint(p);
        });
        var w = containerExtent.getWidth(), h = containerExtent.getHeight();
        var scaleX = size['width'] / w, scaleY = size['height'] / h;
        var scale = this.getSpatialReference().getZoomDirection() < 0 ? Math.max(scaleX, scaleY) : Math.min(scaleX, scaleY);
        var zoom = this.getZoomForScale(scale, null, isFraction);
        return zoom;
    };
    _proto.getView = function getView() {
        return {
            'center': this.getCenter().toArray(),
            'zoom': this.getZoom(),
            'pitch': this.getPitch(),
            'bearing': this.getBearing()
        };
    };
    _proto._validateView = function _validateView(view) {
        if (!view || !isObject$1(view)) return;
        if (isNumber(view.bearing)) {
            var bearing = view.bearing;
            bearing = bearing % 360;
            if (bearing > 180) bearing = -180 + Math.abs(bearing - 180);
            if (bearing < -180) bearing = 180 - Math.abs(bearing + 180);
            view.bearing = bearing;
        }
        if (isNumber(view.pitch)) {
            view.pitch = Math.max(0, view.pitch);
            view.pitch = Math.min(this.options.maxPitch, view.pitch);
        }
        var maxZoom = this.getMaxZoom();
        if (isNumber(view.zoom)) {
            view.zoom = Math.max(0, view.zoom);
            view.zoom = Math.min(maxZoom, view.zoom);
        }
        return;
    };
    _proto.setView = function setView(view) {
        if (!view) return this;
        this._validateView(view);
        if (view['center']) this.setCenter(view['center']);
        if (view['zoom'] !== null && !isNaN(+view['zoom'])) this.setZoom(+view['zoom'], {
            'animation': false
        });
        if (view['pitch'] !== null && !isNaN(+view['pitch'])) this.setPitch(+view['pitch']);
        if (view['bearing'] !== null && !isNaN(+view['bearing'])) this.setBearing(+view['bearing']);
        return this;
    };
    _proto.getResolution = function getResolution(zoom) {
        return this._getResolution(zoom);
    };
    _proto.getScale = function getScale(zoom) {
        var z = isNil(zoom) ? this.getZoom() : zoom;
        var max = this._getResolution(this.getMaxNativeZoom()), res = this._getResolution(z);
        return res / max;
    };
    _proto._getCenterByPadding = function _getCenterByPadding(center, zoom, padding) {
        var point = this.coordinateToPoint(center, zoom);
        var { paddingLeft = 0, paddingRight = 0, paddingTop = 0, paddingBottom = 0 } = padding || {};
        var pX = 0;
        var pY = 0;
        if (paddingLeft || paddingRight) pX = (paddingRight - paddingLeft) / 2;
        if (paddingTop || paddingBottom) pY = (paddingTop - paddingBottom) / 2;
        var newPoint = new Point({
            x: point.x + pX,
            y: point.y + pY
        });
        return this.pointToCoordinate(newPoint, zoom);
    };
    _proto.fitExtent = function fitExtent(extent, zoomOffset, options, step) {
        var _this3 = this;
        options = options || {};
        if (!extent) return this;
        var syncExtent = new Extent(extent);
        var zoom = this.getFitZoom(syncExtent, options.isFraction || false, options) + (zoomOffset || 0);
        var containerExtent = syncExtent.convertTo(function(p) {
            return _this3.coordToPoint(p);
        });
        var center = this.pointToCoord(containerExtent.getCenter());
        if (this._getPaddingSize(options)) center = this._getCenterByPadding(center, zoom, options);
        if (typeof options['animation'] === 'undefined' || options['animation']) return this._animateTo({
            center: center,
            zoom: zoom
        }, {
            'duration': options['duration'] || this.options['zoomAnimationDuration'],
            'easing': options['easing'] || 'out'
        }, step);
        else return this.setCenterAndZoom(center, zoom);
    };
    _proto.getBaseLayer = function getBaseLayer() {
        return this._baseLayer;
    };
    _proto.setBaseLayer = function setBaseLayer(baseLayer) {
        var isChange = false;
        if (this._baseLayer) {
            isChange = true;
            this._fireEvent('baselayerchangestart');
            this._baseLayer.remove();
        }
        if (!baseLayer) {
            delete this._baseLayer;
            this._fireEvent('baselayerchangeend');
            this._fireEvent('setbaselayer');
            return this;
        }
        this._baseLayer = baseLayer;
        baseLayer._bindMap(this, -1);
        function onbaseLayerload() {
            this._fireEvent('baselayerload');
            if (isChange) {
                isChange = false;
                this._fireEvent('baselayerchangeend');
            }
        }
        this._baseLayer.on('layerload', onbaseLayerload, this);
        if (this._loaded) this._baseLayer.load();
        this._fireEvent('setbaselayer');
        return this;
    };
    _proto.removeBaseLayer = function removeBaseLayer() {
        if (this._baseLayer) {
            this._baseLayer.remove();
            delete this._baseLayer;
            this._fireEvent('baselayerremove');
        }
        return this;
    };
    _proto.getLayers = function getLayers(filter) {
        return this._getLayers(function(layer) {
            if (layer === this._baseLayer || layer.getId().indexOf(INTERNAL_LAYER_PREFIX) >= 0) return false;
            if (filter) return filter(layer);
            return true;
        });
    };
    _proto.getLayer = function getLayer(id) {
        if (!id) return null;
        var layer = this._layerCache ? this._layerCache[id] : null;
        if (layer) return layer;
        var baseLayer = this.getBaseLayer();
        if (baseLayer && baseLayer.getId() === id) return baseLayer;
        return null;
    };
    _proto.addLayer = function addLayer(layers, ...otherLayers) {
        if (!layers) return this;
        if (!Array.isArray(layers)) layers = [
            layers
        ];
        if (otherLayers && otherLayers.length) layers = layers.concat(otherLayers);
        if (!this._layerCache) this._layerCache = {};
        var mapLayers = this._layers;
        for(var i = 0, len = layers.length; i < len; i++){
            var layer = layers[i];
            var id = layer.getId();
            if (isNil(id)) throw new Error('Invalid id for the layer: ' + id);
            if (layer.getMap() === this) continue;
            if (this._layerCache[id]) throw new Error('Duplicate layer id in the map: ' + id);
            this._layerCache[id] = layer;
            layer._bindMap(this);
            mapLayers.push(layer);
            if (this._loaded) layer.load();
        }
        this._sortLayersByZIndex();
        this._fireEvent('addlayer', {
            'layers': layers
        });
        return this;
    };
    _proto.removeLayer = function removeLayer(layers) {
        if (!layers) return this;
        if (!Array.isArray(layers)) return this.removeLayer([
            layers
        ]);
        var removed = [];
        for(var i = 0, len = layers.length; i < len; i++){
            var layer = layers[i];
            if (!(layer instanceof Layer)) layer = this.getLayer(layer);
            if (!layer) continue;
            var map = layer.getMap();
            if (!map || map !== this) continue;
            removed.push(layer);
            this._removeLayer(layer, this._layers);
            if (this._loaded) layer._doRemove();
            var id = layer.getId();
            if (this._layerCache) delete this._layerCache[id];
        }
        if (removed.length > 0) {
            var renderer = this.getRenderer();
            if (renderer) {
                if (this.options.renderer === 'canvas') renderer.setLayerCanvasUpdated();
                else renderer.setToRedraw();
            }
            this.once('frameend', function() {
                removed.forEach(function(layer) {
                    layer.fire('remove');
                });
            });
        }
        this._fireEvent('removelayer', {
            'layers': layers
        });
        return this;
    };
    _proto.sortLayers = function sortLayers(layers) {
        if (!layers || !Array.isArray(layers)) return this;
        var layersToOrder = [];
        var minZ = Number.MAX_VALUE;
        for(var i = 0, l = layers.length; i < l; i++){
            var layer = layers[i];
            if (isString(layers[i])) layer = this.getLayer(layer);
            if (!(layer instanceof Layer) || !layer.getMap() || layer.getMap() !== this) throw new Error('It must be a layer added to this map to order.');
            if (layer.getZIndex() < minZ) minZ = layer.getZIndex();
            layersToOrder.push(layer);
        }
        for(var _i = 0, _l = layersToOrder.length; _i < _l; _i++)layersToOrder[_i].setZIndex(minZ + _i);
        return this;
    };
    _proto.toDataURL = function toDataURL(options) {
        if (!options) options = {};
        var mimeType = options['mimeType'];
        if (!mimeType) mimeType = 'image/png';
        var save = options['save'];
        var renderer = this._getRenderer();
        if (renderer && renderer.toDataURL) {
            var file = options['fileName'];
            if (!file) file = 'export';
            var dataURL = renderer.toDataURL(mimeType, options.quality || 0.92);
            if (save && dataURL) {
                var imgURL;
                if (typeof Blob !== 'undefined' && typeof atob !== 'undefined') {
                    var blob = b64toBlob(dataURL.replace(/^data:image\/(png|jpeg|jpg|webp);base64,/, ''), mimeType);
                    imgURL = URL.createObjectURL(blob);
                } else imgURL = dataURL;
                var dlLink = document.createElement('a');
                dlLink.download = file;
                dlLink.href = imgURL;
                document.body.appendChild(dlLink);
                dlLink.click();
                document.body.removeChild(dlLink);
            }
            return dataURL;
        }
        return null;
    };
    _proto.coordToPoint = function coordToPoint(coordinate, zoom, out) {
        return this.coordinateToPoint(coordinate, zoom, out);
    };
    _proto.coordToPointAtRes = function coordToPointAtRes(coordinate, res, out) {
        return this.coordinateToPointAtRes(coordinate, res, out);
    };
    _proto.pointToCoord = function pointToCoord(point, zoom, out) {
        return this.pointToCoordinate(point, zoom, out);
    };
    _proto.pointAtResToCoord = function pointAtResToCoord(point, res, out) {
        return this.pointAtResToCoordinate(point, res, out);
    };
    _proto.coordToViewPoint = function coordToViewPoint(coordinate, out, altitude) {
        return this.coordinateToViewPoint(coordinate, out, altitude);
    };
    _proto.viewPointToCoord = function viewPointToCoord(viewPoint, out) {
        return this.viewPointToCoordinate(viewPoint, out);
    };
    _proto.coordToContainerPoint = function coordToContainerPoint(coordinate, zoom, out) {
        return this.coordinateToContainerPoint(coordinate, zoom, out);
    };
    _proto.containerPointToCoord = function containerPointToCoord(containerPoint, out) {
        return this.containerPointToCoordinate(containerPoint, out);
    };
    _proto.containerPointToViewPoint = function containerPointToViewPoint(containerPoint, out) {
        if (out) out.set(containerPoint.x, containerPoint.y);
        else out = containerPoint.copy();
        return out._sub(this.getViewPoint());
    };
    _proto.viewPointToContainerPoint = function viewPointToContainerPoint(viewPoint, out) {
        if (out) out.set(viewPoint.x, viewPoint.y);
        else out = viewPoint.copy();
        return out._add(this.getViewPoint());
    };
    _proto.checkSize = function checkSize(force) {
        var justStart = now() - this._initTime < 1500 && this.width === 0 || this.height === 0;
        var watched = this._getContainerDomSize(), oldHeight = this.height, oldWidth = this.width;
        if (!force && watched['width'] === oldWidth && watched['height'] === oldHeight) return this;
        computeDomPosition(this._containerDOM);
        var center = this.getCenter();
        if (!this.options['fixCenterOnResize']) {
            var vh = this._getVisualHeight(this.getPitch());
            var nwCP = new Point(0, this.height - vh);
            var nwCoord = this._containerPointToPrj(nwCP);
            this._updateMapSize(watched);
            var vhAfter = this._getVisualHeight(this.getPitch());
            var nwCPAfter = new Point(0, this.height - vhAfter);
            this._setPrjCoordAtContainerPoint(nwCoord, nwCPAfter);
            this._mapViewCoord = this._getPrjCenter();
        } else this._updateMapSize(watched);
        var hided = watched['width'] === 0 || watched['height'] === 0 || oldWidth === 0 || oldHeight === 0;
        if (justStart || hided) {
            this._eventSilence = true;
            this.setCenter(center);
            delete this._eventSilence;
        }
        this._fireEvent('resize');
        return this;
    };
    _proto.locate = function locate(coordinate, dx, dy) {
        return this.getProjection()._locate(new Coordinate(coordinate), dx, dy);
    };
    _proto.getMainPanel = function getMainPanel() {
        var renderer = this._getRenderer();
        if (!renderer) return null;
        return renderer.getMainPanel();
    };
    _proto.getPanels = function getPanels() {
        return this._panels;
    };
    _proto.remove = function remove() {
        var _this4 = this;
        if (this.isRemoved()) return this;
        this._fireEvent('removestart');
        var animationPlayerList = [
            this._animPlayer,
            this._mapAnimPlayer
        ];
        animationPlayerList.forEach(function(player) {
            if (player && player.finish) _this4._stopAnim(player);
        });
        this._removeDomEvents();
        this._clearHandlers();
        this.removeBaseLayer();
        var layers = this.getLayers();
        for(var i = 0; i < layers.length; i++)layers[i].remove();
        if (this._getRenderer()) this._getRenderer().remove();
        if (this._containerDOM.childNodes && this._containerDOM.childNodes.length > 0) Array.prototype.slice.call(this._containerDOM.childNodes, 0).filter(function(node) {
            return node.className === 'maptalks-wrapper';
        }).forEach(function(node) {
            return _this4._containerDOM.removeChild(node);
        });
        delete this._panels;
        delete this._containerDOM;
        delete this._renderer;
        this._fireEvent('removeend');
        this._clearAllListeners();
        return this;
    };
    _proto.isRemoved = function isRemoved() {
        return !this._containerDOM;
    };
    _proto.isMoving = function isMoving() {
        return !!this._moving;
    };
    _proto.onMoveStart = function onMoveStart(param) {
        if (this._mapAnimPlayer) this._stopAnim(this._mapAnimPlayer);
        var prjCenter = this._getPrjCenter();
        if (!this._originCenter || this._verifyExtent(prjCenter)) this._originCenter = prjCenter;
        this._moving = true;
        this._trySetCursor('move');
        this._fireEvent('movestart', this._parseEvent(param ? param['domEvent'] : null, 'movestart'));
    };
    _proto.onMoving = function onMoving(param) {
        this._fireEvent('moving', this._parseEvent(param ? param['domEvent'] : null, 'moving'));
        this._limitMaxExtent();
    };
    _proto.onMoveEnd = function onMoveEnd(param) {
        this._moving = false;
        if (!this._suppressRecenter) this._recenterOnTerrain();
        this._trySetCursor('default');
        this._fireEvent('moveend', param && param['domEvent'] ? this._parseEvent(param['domEvent'], 'moveend') : param);
        if (!this._verifyExtent(this._getPrjCenter()) && this._originCenter && !this.options.limitExtentOnMaxExtent) {
            var moveTo = this._originCenter;
            this._panTo(moveTo);
        }
        this._limitMaxExtent();
    };
    _proto.onDragRotateStart = function onDragRotateStart(param) {
        this._dragRotating = true;
        this._fireEvent('dragrotatestart', this._parseEvent(param ? param['domEvent'] : null, 'dragrotatestart'));
    };
    _proto.onDragRotating = function onDragRotating(param) {
        this._fireEvent('dragrotating', this._parseEvent(param ? param['domEvent'] : null, 'dragrotating'));
    };
    _proto.onDragRotateEnd = function onDragRotateEnd(param) {
        this._dragRotating = false;
        this._fireEvent('dragrotateend', this._parseEvent(param ? param['domEvent'] : null, 'dragrotateend'));
    };
    _proto.isDragRotating = function isDragRotating() {
        return !!this._dragRotating;
    };
    _proto.isOffscreen = function isOffscreen(box, viewportPadding = 0) {
        var { width: width, height: height } = this;
        var screenRightBoundary = width + viewportPadding;
        var screenBottomBoundary = height + viewportPadding;
        var { xmin: xmin, ymin: ymin, xmax: xmax, ymax: ymax } = box;
        if (Array.isArray(box)) [xmin, ymin, xmax, ymax] = box;
        return xmax < viewportPadding || xmin >= screenRightBoundary || ymax < viewportPadding || ymin > screenBottomBoundary;
    };
    _proto.getRenderer = function getRenderer() {
        return this._getRenderer();
    };
    _proto.getDevicePixelRatio = function getDevicePixelRatio() {
        return this.options['devicePixelRatio'] || Browser$1.devicePixelRatio || 1;
    };
    _proto.setDevicePixelRatio = function setDevicePixelRatio(dpr) {
        if (isNumber(dpr) && dpr > 0 && dpr !== this.options['devicePixelRatio']) {
            this.options['devicePixelRatio'] = dpr;
            this.checkSize(true);
        }
        return this;
    };
    _proto._initContainer = function _initContainer(container) {
        if (isString(container)) {
            this._containerDOM = document.getElementById(container);
            if (!this._containerDOM) throw new Error('Invalid container when creating map: \'' + container + '\'');
        } else {
            this._containerDOM = container;
            if (IS_NODE) this.CanvasClass = this._containerDOM.constructor;
        }
        if (this._containerDOM.childNodes && this._containerDOM.childNodes.length > 0) {
            if (this._containerDOM.childNodes[0].className === 'maptalks-wrapper') throw new Error('Container is already loaded with another map instance, use map.remove() to clear it.');
        }
    };
    _proto._trySetCursor = function _trySetCursor(cursor) {
        if (!this._cursor && !this._priorityCursor) {
            if (!cursor) cursor = 'default';
            this._setCursorToPanel(cursor);
        }
        return this;
    };
    _proto._setPriorityCursor = function _setPriorityCursor(cursor) {
        if (!cursor) {
            var hasCursor = false;
            if (this._priorityCursor) hasCursor = true;
            delete this._priorityCursor;
            if (hasCursor) this.setCursor(this._cursor);
        } else {
            this._priorityCursor = cursor;
            this._setCursorToPanel(cursor);
        }
        return this;
    };
    _proto._setCursorToPanel = function _setCursorToPanel(cursor) {
        var panel = this.getMainPanel();
        if (panel && panel.style && panel.style.cursor !== cursor) panel.style.cursor = cursor;
    };
    _proto._removeLayer = function _removeLayer(layer, layerList) {
        if (!layer || !layerList) return;
        var index = layerList.indexOf(layer);
        if (index > -1) layerList.splice(index, 1);
    };
    _proto._sortLayersByZIndex = function _sortLayersByZIndex() {
        if (!this._layers) return;
        for(var i = 0, l = this._layers.length; i < l; i++){
            var layer = this._layers[i];
            layer._order = i;
            if (layer.sortLayersByZIndex) layer.sortLayersByZIndex();
        }
        this._layers.sort(function(a, b) {
            var c = a.getZIndex() - b.getZIndex();
            if (c === 0) return a._order - b._order;
            return c;
        });
    };
    _proto._fireEvent = function _fireEvent(eventName, param) {
        if (this._eventSilence) return;
        var underline = '_';
        if (eventName[0] !== underline) this.fire(underline + eventName, param);
        this.fire(eventName, param);
    };
    _proto._Load = function _Load() {
        this._resetMapStatus();
        if (this.options['pitch']) {
            this.setPitch(this.options['pitch']);
            delete this.options['pitch'];
        }
        if (this.options['bearing']) {
            this.setBearing(this.options['bearing']);
            delete this.options['bearing'];
        }
        delete this._glRes;
        this._loadAllLayers();
        this._getRenderer().onLoad();
        this._loaded = true;
        this._callOnLoadHooks();
        this._initTime = now();
    };
    _proto._initRenderer = function _initRenderer() {
        var renderer = this.options['renderer'];
        if (!Array.isArray(renderer)) renderer = [
            renderer
        ];
        for(var i = 0; i < renderer.length; i++){
            var clazz = Map1.getRendererClass(renderer[i]);
            if (clazz) {
                this._renderer = new clazz(this);
                this._renderer.load();
                break;
            }
        }
    };
    _proto._getRenderer = function _getRenderer() {
        return this._renderer;
    };
    _proto._loadAllLayers = function _loadAllLayers() {
        function loadLayer(layer) {
            if (layer) layer.load();
        }
        if (this._baseLayer) this._baseLayer.load();
        this._eachLayer(loadLayer, this.getLayers());
    };
    _proto._getLayers = function _getLayers(filter) {
        var layers = this._baseLayer ? [
            this._baseLayer
        ].concat(this._layers) : this._layers;
        var result = [];
        for(var i = 0; i < layers.length; i++)if (!filter || filter.call(this, layers[i])) result.push(layers[i]);
        return result;
    };
    _proto._eachLayer = function _eachLayer(fn, ...layerLists) {
        if (arguments.length < 2) return;
        if (layerLists && !Array.isArray(layerLists)) layerLists = [
            layerLists
        ];
        var layers = [];
        for(var i = 0, len = layerLists.length; i < len; i++)layers = layers.concat(layerLists[i]);
        for(var j = 0, jlen = layers.length; j < jlen; j++)fn.call(fn, layers[j]);
    };
    _proto._onLayerEvent = function _onLayerEvent(param) {
        if (!param) return;
        if (param['type'] === 'idchange') {
            delete this._layerCache[param['old']];
            this._layerCache[param['new']] = param['target'];
        }
    };
    _proto._resetMapStatus = function _resetMapStatus() {
        var maxZoom = this.getMaxZoom(), minZoom = this.getMinZoom();
        var viewMaxZoom = this._spatialReference.getMaxZoom(), viewMinZoom = this._spatialReference.getMinZoom();
        if (isNil(maxZoom) || maxZoom === -1 || maxZoom > viewMaxZoom) this.setMaxZoom(viewMaxZoom);
        if (isNil(minZoom) || minZoom === -1 || minZoom < viewMinZoom) this.setMinZoom(viewMinZoom);
        maxZoom = this.getMaxZoom();
        minZoom = this.getMinZoom();
        if (maxZoom < minZoom) this.setMaxZoom(minZoom);
        if (isNil(this._zoomLevel) || this._zoomLevel > maxZoom) this._zoomLevel = maxZoom;
        if (this._zoomLevel < minZoom) this._zoomLevel = minZoom;
        delete this._prjCenter;
        delete this._glRes;
        var projection = this.getProjection();
        this._prjCenter = projection.project(this._center);
        this._prjCenter.z = this._center.z;
        this._calcMatrices();
        var renderer = this._getRenderer();
        if (renderer) renderer.resetContainer();
    };
    _proto.setContainerDomRect = function setContainerDomRect(domRect) {
        this._containerDomContentRect = domRect;
    };
    _proto._getContainerDomSize = function _getContainerDomSize() {
        if (!this._containerDOM) return null;
        var containerDOM = this._containerDOM;
        var width, height;
        if (this._containerDomContentRect) {
            width = this._containerDomContentRect.width;
            height = this._containerDomContentRect.height;
            return new Size(width, height);
        }
        var canvasDom = containerDOM;
        if (!isNil(canvasDom.width) && !isNil(canvasDom.height)) {
            width = canvasDom.width;
            height = canvasDom.height;
            var dpr = this.getDevicePixelRatio();
            if (dpr !== 1 && containerDOM['layer']) {
                width /= dpr;
                height /= dpr;
            }
        } else if (!isNil(containerDOM.clientWidth) && !isNil(containerDOM.clientHeight)) {
            width = parseInt(containerDOM.clientWidth + '', 0);
            height = parseInt(containerDOM.clientHeight + '', 0);
        } else throw new Error('can not get size of container');
        return new Size(width, height);
    };
    _proto._updateMapSize = function _updateMapSize(mSize) {
        this.width = mSize['width'];
        this.height = mSize['height'];
        var renderer = this._getRenderer();
        if (renderer) renderer.updateMapSize(mSize);
        this._calcMatrices();
        return this;
    };
    _proto._getPrjCenter = function _getPrjCenter() {
        return this._prjCenter;
    };
    _proto._setPrjCenter = function _setPrjCenter(pcenter) {
        this._prjCenter = pcenter;
        if (this.isInteracting() && !this.isMoving()) this._mapViewCoord = pcenter;
        this._calcMatrices();
    };
    _proto._setPrjCoordAtContainerPoint = function _setPrjCoordAtContainerPoint(coordinate, point) {
        if (!this.centerAltitude && point.x === this.width / 2 && point.y === this.height / 2) return this;
        var p = this._containerPointToPoint(point);
        var t = p._sub(this._prjToPoint(this._getPrjCenter()));
        var pcenter = this._pointToPrj(this._prjToPoint(coordinate)._sub(t));
        this._setPrjCenter(pcenter);
        return this;
    };
    _proto._setPrjCoordAtOffsetToCenter = function _setPrjCoordAtOffsetToCenter(prjCoord, offset) {
        var pcenter = this._pointToPrj(this._prjToPoint(prjCoord)._sub(offset));
        this._setPrjCenter(pcenter);
        return this;
    };
    _proto._verifyExtent = function _verifyExtent(prjCenter) {
        if (!prjCenter) return false;
        var maxExt = this._prjMaxExtent;
        if (!maxExt) return true;
        return maxExt.contains(prjCenter);
    };
    _proto._limitMaxExtent = function _limitMaxExtent() {
        var _this5 = this;
        if (this._limitMaxExtenting || !this.options.limitExtentOnMaxExtent) return this;
        var maxPrjExtent = this._prjMaxExtent;
        var maxExtent = this.getMaxExtent();
        if (!maxPrjExtent || !maxExtent) return this;
        var prjCoords = maxPrjExtent.toArray();
        var points = prjCoords.map(function(prjCoord) {
            return _this5.prjToContainerPoint(prjCoord);
        });
        var maxExtentBBOX = getDefaultBBOX();
        pointsBBOX(points, maxExtentBBOX);
        var { width: width, height: height } = this.getSize();
        var mapBBOX = [
            0,
            0,
            width,
            height
        ];
        if (bboxInBBOX(mapBBOX, maxExtentBBOX)) return this;
        if (bboxInBBOX(maxExtentBBOX, mapBBOX)) return this;
        var translateX = 0, translateY = 0;
        var offsetleft = 0, offsetright = 0, offsettop = 0, offsetbottom = 0;
        var abs = Math.abs;
        var [left, top, right, bottom] = maxExtentBBOX;
        if (left > 0 && right > width) translateX = offsetleft = abs(left);
        if (left < 0 && right < width) translateX = offsetleft = -abs(left);
        if (left < 0 && right < width) translateX = offsetright = -abs(width - right);
        if (left > 0 && right > width) translateX = offsetright = abs(width - right);
        if (top > 0 && bottom > height) translateY = offsettop = abs(top);
        if (top < 0 && bottom < height) translateY = offsettop = -abs(top);
        if (top < 0 && bottom < height) translateY = offsetbottom = -abs(height - bottom);
        if (top > 0 && bottom > height) translateY = offsetbottom = abs(height - bottom);
        if (offsetleft !== 0 && offsetright !== 0) {
            translateX = offsetleft;
            if (abs(offsetright) < abs(offsetleft)) translateX = offsetright;
        }
        if (offsettop !== 0 && offsetbottom !== 0) {
            translateY = offsettop;
            if (abs(offsetbottom) < abs(offsettop)) translateY = offsetbottom;
        }
        if (translateX !== 0 || translateY !== 0) {
            var point = new Point(width / 2 + translateX, height / 2 + translateY);
            var center = this.containerPointToCoord(point);
            this._limitMaxExtenting = true;
            this.setCenter(center);
            this._limitMaxExtenting = false;
        }
        return this;
    };
    _proto._offsetCenterByPixel = function _offsetCenterByPixel(pixel) {
        var pos = TEMP_POINT$5.set(this.width / 2 - pixel.x, this.height / 2 - pixel.y);
        var coord = this._containerPointToPrj(pos, TEMP_COORD$2);
        var containerCenter = TEMP_POINT$5.set(this.width / 2, this.height / 2);
        this._setPrjCoordAtContainerPoint(coord, containerCenter);
    };
    _proto.offsetPlatform = function offsetPlatform(offset) {
        if (!offset) return this._mapViewPoint;
        else {
            this._getRenderer().offsetPlatform(offset);
            this._mapViewCoord = this._getPrjCenter();
            this._mapViewPoint = this._mapViewPoint.add(offset);
            return this._mapViewPoint;
        }
    };
    _proto.getViewPoint = function getViewPoint() {
        var offset = this.getViewPointFrameOffset();
        var panelOffset = this.offsetPlatform();
        if (offset) panelOffset = panelOffset.add(offset);
        return panelOffset;
    };
    _proto._resetMapViewPoint = function _resetMapViewPoint() {
        this._mapViewPoint = new Point(0, 0);
        this._mapViewCoord = this._getPrjCenter();
    };
    _proto._getResolution = function _getResolution(zoom) {
        if ((zoom === undefined || zoom === this._zoomLevel) && this._mapRes !== undefined) return this._mapRes;
        if (isNil(zoom)) zoom = this._zoomLevel;
        return this._spatialReference.getResolution(zoom);
    };
    _proto._getResolutions = function _getResolutions() {
        return this._spatialReference.getResolutions();
    };
    _proto._prjToPoint = function _prjToPoint(pCoord, zoom, out) {
        zoom = isNil(zoom) ? this.getZoom() : zoom;
        var res = this._getResolution(zoom);
        return this._prjToPointAtRes(pCoord, res, out);
    };
    _proto._prjToPointAtRes = function _prjToPointAtRes(pCoord, res, out) {
        return this._spatialReference.getTransformation().transform(pCoord, res, out);
    };
    _proto._prjsToPointsAtRes = function _prjsToPointsAtRes(pCoords, res, resultPoints = []) {
        var transformation = this._spatialReference.getTransformation();
        var pts = [];
        for(var i = 0, len = pCoords.length; i < len; i++){
            var pt = transformation.transform(pCoords[i], res, resultPoints[i]);
            pts.push(pt);
        }
        return pts;
    };
    _proto._pointToPrj = function _pointToPrj(point, zoom, out) {
        zoom = isNil(zoom) ? this.getZoom() : zoom;
        var res = this._getResolution(zoom);
        return this._pointToPrjAtRes(point, res, out);
    };
    _proto._pointToPrjAtRes = function _pointToPrjAtRes(point, res, out) {
        return this._spatialReference.getTransformation().untransform(point, res, out);
    };
    _proto._pointToPoint = function _pointToPoint(point, zoom, out) {
        if (!isNil(zoom)) return this._pointAtResToPoint(point, this._getResolution(zoom), out);
        if (out) {
            out.x = point.x;
            out.y = point.y;
        } else out = point.copy();
        return out;
    };
    _proto._pointAtResToPoint = function _pointAtResToPoint(point, res, out) {
        if (out) {
            out.x = point.x;
            out.y = point.y;
        } else out = point.copy();
        return out._multi(res / this._getResolution());
    };
    _proto._pointToPointAtRes = function _pointToPointAtRes(point, res, out) {
        if (out) {
            out.x = point.x;
            out.y = point.y;
        } else out = point.copy();
        return out._multi(this._getResolution() / res);
    };
    _proto._containerPointToPrj = function _containerPointToPrj(containerPoint, out) {
        return this._pointToPrj(this._containerPointToPoint(containerPoint, undefined, out), undefined, out);
    };
    _proto._callOnLoadHooks = function _callOnLoadHooks() {
        var proto = Map1.prototype;
        if (!proto._onLoadHooks) return;
        for(var i = 0, l = proto._onLoadHooks.length; i < l; i++)proto._onLoadHooks[i].call(this);
    };
    _proto._fixPrjOnWorldWide = function _fixPrjOnWorldWide(prjCoord) {
        var projection = this.getProjection();
        if (projection && projection.fullExtent && prjCoord) {
            var { left: left, bottom: bottom, top: top, right: right } = projection.fullExtent || {};
            if (isNumber(left)) prjCoord.x = Math.max(left, prjCoord.x);
            if (isNumber(right)) prjCoord.x = Math.min(right, prjCoord.x);
            if (isNumber(bottom)) prjCoord.y = Math.max(bottom, prjCoord.y);
            if (isNumber(top)) prjCoord.y = Math.min(top, prjCoord.y);
        }
        return this;
    };
    _proto.toJSON = function toJSON(options) {
        if (!options) options = {};
        var json = {
            'jsonVersion': this['JSON_VERSION'],
            'version': this.VERSION,
            'extent': this.getExtent().toJSON()
        };
        json['options'] = this.config();
        json['options']['center'] = this.getCenter();
        json['options']['zoom'] = this.getZoom();
        json['options']['bearing'] = this.getBearing();
        json['options']['pitch'] = this.getPitch();
        var baseLayer = this.getBaseLayer();
        if ((isNil(options['baseLayer']) || options['baseLayer']) && baseLayer) json['baseLayer'] = baseLayer.toJSON(options['baseLayer']);
        var extraLayerOptions = {};
        if (options['clipExtent']) {
            if (options['clipExtent'] === true) extraLayerOptions['clipExtent'] = this.getExtent();
            else extraLayerOptions['clipExtent'] = options['clipExtent'];
        }
        var layersJSON = [];
        if (isNil(options['layers']) || options['layers'] && !Array.isArray(options['layers'])) {
            var layers = this.getLayers();
            for(var i = 0, len = layers.length; i < len; i++){
                if (!layers[i].toJSON) continue;
                var opts = extend$2({}, isObject$1(options['layers']) ? options['layers'] : {}, extraLayerOptions);
                layersJSON.push(layers[i].toJSON(opts));
            }
            json['layers'] = layersJSON;
        } else if (isArrayHasData(options['layers'])) {
            var _layers = options['layers'];
            for(var _i2 = 0; _i2 < _layers.length; _i2++){
                var exportOption = _layers[_i2];
                var layer = this.getLayer(exportOption['id']);
                if (!layer.toJSON) continue;
                var _opts = extend$2({}, exportOption['options'], extraLayerOptions);
                layersJSON.push(layer.toJSON(_opts));
            }
            json['layers'] = layersJSON;
        } else json['layers'] = [];
        return json;
    };
    Map1.fromJSON = function fromJSON(container, profile, options) {
        if (!container || !profile) return null;
        if (!options) options = {};
        var map = new Map1(container, profile['options']);
        if (isNil(options['baseLayer']) || options['baseLayer']) {
            var baseLayer = Layer.fromJSON(profile['baseLayer']);
            if (baseLayer) map.setBaseLayer(baseLayer);
        }
        if (isNil(options['layers']) || options['layers']) {
            var layers = [];
            var layerJSONs = profile['layers'];
            for(var i = 0; i < layerJSONs.length; i++){
                var layer = Layer.fromJSON(layerJSONs[i]);
                layers.push(layer);
            }
            map.addLayer(layers);
        }
        return map;
    };
    return Map1;
}(Handlerable(Eventable(Renderable(Class))));
Map$1.mergeOptions(options$B);
var MapDoubleClickZoomHandler = function(_Handler) {
    function MapDoubleClickZoomHandler() {
        return _Handler.apply(this, arguments) || this;
    }
    _inheritsLoose(MapDoubleClickZoomHandler, _Handler);
    var _proto = MapDoubleClickZoomHandler.prototype;
    _proto.addHooks = function addHooks() {
        if (!this.target) return;
        this.target.on('_dblclick', this._onDoubleClick, this);
    };
    _proto.removeHooks = function removeHooks() {
        if (!this.target) return;
        this.target.off('_dblclick', this._onDoubleClick, this);
    };
    _proto._onDoubleClick = function _onDoubleClick(param) {
        var map = this.target;
        if (map.options['doubleClickZoom']) {
            var oldZoom = map.getZoom(), zoom = param['domEvent']['shiftKey'] ? Math.ceil(oldZoom) - 1 : Math.floor(oldZoom) + 1;
            map._zoomAnimation(zoom, param['containerPoint']);
        }
    };
    return MapDoubleClickZoomHandler;
}(Handler);
Map$1.mergeOptions({
    'doubleClickZoom': true
});
Map$1.addOnLoadHook('addHandler', 'doubleClickZoom', MapDoubleClickZoomHandler);
var MapDragHandler = function(_Handler) {
    function MapDragHandler() {
        return _Handler.apply(this, arguments) || this;
    }
    _inheritsLoose(MapDragHandler, _Handler);
    var _proto = MapDragHandler.prototype;
    _proto.addHooks = function addHooks() {
        var map = this.target;
        if (!map) return;
        var dom = map.getPanels().mapWrapper || map.getContainer();
        this._dragHandler = new DragHandler(dom, {
            'cancelOn': this._cancelOn.bind(this),
            'rightclick': true
        });
        this._dragHandler.on('mousedown', this._onMouseDown, this).on('dragstart', this._onDragStart, this).on('dragging', this._onDragging, this).on('dragend', this._onDragEnd, this).enable();
    };
    _proto.removeHooks = function removeHooks() {
        this._dragHandler.off('mousedown', this._onMouseDown, this).off('dragstart', this._onDragStart, this).off('dragging', this._onDragging, this).off('dragend', this._onDragEnd, this);
        this._dragHandler.remove();
        delete this._dragHandler;
    };
    _proto._cancelOn = function _cancelOn(domEvent) {
        if (this.target.isZooming() || this._ignore(domEvent)) return true;
        return false;
    };
    _proto._ignore = function _ignore(param) {
        if (!param) return false;
        if (param.domEvent) param = param.domEvent;
        return this.target._ignoreEvent(param);
    };
    _proto._onMouseDown = function _onMouseDown(param) {
        delete this.startDragTime;
        delete this._mode;
        var switchDragButton = this.target.options['switchDragButton'];
        var rotateModeButton = switchDragButton ? 0 : 2;
        var isTouch = param.domEvent.type === 'touchstart';
        var isRotatonMode = switchDragButton && isTouch || param.domEvent.button === rotateModeButton || param.domEvent.ctrlKey;
        if (isRotatonMode) {
            if (this.target.options['dragRotate'] || this.target.options['dragPitch']) this._mode = 'rotatePitch';
        } else if (this.target.options['dragPan']) this._mode = 'move';
        this.target._stopAnim(this.target._mapAnimPlayer);
        preventDefault(param['domEvent']);
    };
    _proto._onDragStart = function _onDragStart(param) {
        this.startDragTime = now();
        if (this._mode === 'move') this._moveStart(param);
        else if (this._mode === 'rotatePitch') this._rotateStart(param);
    };
    _proto._onDragging = function _onDragging(param) {
        if (this._mode === 'move') this._moving(param);
        else if (this._mode === 'rotatePitch') this._rotating(param);
    };
    _proto._onDragEnd = function _onDragEnd(param) {
        if (this._mode === 'move') this._moveEnd(param);
        else if (this._mode === 'rotatePitch') this._rotateEnd(param);
        delete this.startDragTime;
        delete this.startBearing;
    };
    _proto._start = function _start(param) {
        this.preX = param['mousePos'].x;
        this.preY = param['mousePos'].y;
        this.startX = this.preX;
        this.startY = this.preY;
        this._startPrjCenter = this.target._getPrjCenter().copy();
    };
    _proto._moveStart = function _moveStart(param) {
        delete this.startContainerPoint;
        this._start(param);
        var map = this.target;
        map.onMoveStart(param);
        var p = getEventContainerPoint(map._getActualEvent(param.domEvent), map.getContainer());
        this.startPrjCoord = map.queryPrjCoordAtContainerPoint(p);
        if (map._isContainerPointOutOfMap(p) && this.startPrjCoord.z === undefined) this.startContainerPoint = p;
    };
    _proto._moving = function _moving(param) {
        if (!this.startDragTime) return;
        var map = this.target;
        var p = getEventContainerPoint(map._getActualEvent(param.domEvent), map.getContainer());
        if (this.startContainerPoint) {
            var _offset = p._sub(this.startContainerPoint);
            p.set(map.width / 2 + _offset.x, map.height / 2 + _offset.y);
        }
        var movingPoint = map._containerPointToPoint(p, undefined, undefined, this.startPrjCoord.z);
        var offset = movingPoint._sub(map._prjToPoint(map._getPrjCenter()));
        map._setPrjCoordAtOffsetToCenter(this.startPrjCoord, offset);
        map.onMoving(param);
    };
    _proto._moveEnd = function _moveEnd(param) {
        if (!this.startDragTime) return;
        var isTouch = param.domEvent.type === 'touchend';
        var map = this.target;
        var t = now() - this.startDragTime;
        var mx = param['mousePos'].x, my = param['mousePos'].y;
        var dx = mx - this.startX;
        var dy = my - this.startY;
        var currentCenter = map._getPrjCenter();
        var dxy = currentCenter.sub(this._startPrjCenter);
        this._clear();
        if (map.options['panAnimation'] && !param.interupted && map._verifyExtent(map._getPrjCenter()) && t < 280 && Math.abs(dy) + Math.abs(dx) > 5) {
            t = 5 * t;
            var dscale = isTouch ? 5 : 2.8;
            var targetPrjCoord = currentCenter.add(dxy._multi(dscale));
            map._panTo(targetPrjCoord, {
                'duration': isTouch ? t * 3 : t * 2,
                'easing': map.options.dragPanEasing || 'outExpo'
            });
        } else map.onMoveEnd(param);
    };
    _proto._rotateStart = function _rotateStart(param) {
        this._start(param);
        delete this._rotateMode;
        this.startBearing = this.target.getBearing();
        this.target.onDragRotateStart(param);
        this._db = 0;
    };
    _proto._rotating = function _rotating(param) {
        var map = this.target;
        var mx = param['mousePos'].x, my = param['mousePos'].y;
        var prePitch = map.getPitch(), preBearing = map.getBearing();
        var dx = Math.abs(mx - this.preX), dy = Math.abs(my - this.preY);
        if (!this._rotateMode) {
            if (map.options['dragRotatePitch']) this._rotateMode = 'rotate_pitch';
            else if (dx > dy) this._rotateMode = 'rotate';
            else if (dx < dy) this._rotateMode = 'pitch';
            else this._rotateMode = 'rotate';
        }
        if (this._rotateMode === 'pitch' && prePitch === 0 && dy < 10) return;
        if (this._rotateMode.indexOf('rotate') >= 0 && map.options['dragRotate']) {
            var factor = 0.15;
            var db = 0;
            if (map.options['dragPitch'] || dx > dy) db = -factor * (this.preX - mx);
            else if (mx > map.width / 2) db = factor * (this.preY - my);
            else db = -factor * (this.preY - my);
            var bearing = map.getBearing() + db;
            this._db = this._db || 0;
            this._db += db;
            map._setBearing(bearing);
        }
        if (this._rotateMode.indexOf('pitch') >= 0 && map.options['dragPitch']) map._setPitch(map.getPitch() + (this.preY - my) * 0.15);
        this.preX = mx;
        this.preY = my;
        if (map.getBearing() !== preBearing || map.getPitch() !== prePitch) map.onDragRotating(param);
    };
    _proto._rotateEnd = function _rotateEnd(param) {
        var map = this.target;
        var bearing = map.getBearing();
        this._clear();
        var t = now() - this.startDragTime;
        map.onDragRotateEnd(param);
        if (map.options['rotateAnimation'] && Math.abs(bearing - this.startBearing) > 20 && (this._rotateMode === 'rotate' || this._rotateMode === 'rotate_pitch') && !param.interupted && t < 400) {
            var _bearing = map.getBearing();
            map._animateTo({
                'bearing': _bearing + this._db / 1.5
            }, {
                'easing': 'outQuint',
                'duration': 1600
            });
        }
    };
    _proto._clear = function _clear() {
        delete this.startPrjCoord;
        delete this.preX;
        delete this.preY;
        delete this.startX;
        delete this.startY;
    };
    return MapDragHandler;
}(Handler);
Map$1.mergeOptions({
    'draggable': true,
    'dragPan': true,
    'dragRotatePitch': true,
    'dragRotate': true,
    'dragPitch': true
});
Map$1.addOnLoadHook('addHandler', 'draggable', MapDragHandler);
var EVENTS$3 = "mousedown mouseup mousemove click dblclick contextmenu touchstart touchmove touchend mouseout";
var MOUSEEVENT_ASSOCIATION_TABLE = {
    'mousemove': [
        'mousemove',
        'mouseover',
        'mouseout',
        'mouseenter'
    ],
    'touchend': [
        'touchend',
        'click'
    ]
};
var isGeo = function isGeo(geometry) {
    return geometry && geometry.getLayer && geometry.on && geometry.fire;
};
var getGeoId = function getGeoId(geometry) {
    if (geometry._getInternalId) return geometry._getInternalId();
    else if (geometry.getId) return geometry.getId();
    return null;
};
var fireGeoEvent = function fireGeoEvent(geometry, domEvent, type) {
    if (geometry._onEvent) return geometry._onEvent(domEvent, type);
    var layer = geometry.getLayer();
    if (layer && layer.fireGeoEvent) return layer.fireGeoEvent(geometry, domEvent, type);
    return null;
};
var MapGeometryEventsHandler = function(_Handler) {
    function MapGeometryEventsHandler() {
        return _Handler.apply(this, arguments) || this;
    }
    _inheritsLoose(MapGeometryEventsHandler, _Handler);
    var _proto = MapGeometryEventsHandler.prototype;
    _proto.addHooks = function addHooks() {
        var map = this.target;
        var dom = map.getPanels().allLayers || map.getContainer();
        on(dom, EVENTS$3, this._identifyGeometryEvents, this);
    };
    _proto.removeHooks = function removeHooks() {
        var map = this.target;
        var dom = map.getPanels().allLayers || map.getContainer();
        off(dom, EVENTS$3, this._identifyGeometryEvents);
    };
    _proto._identifyGeometryEvents = function _identifyGeometryEvents(domEvent, type) {
        var map = this.target;
        if (map.isInteracting() || map._ignoreEvent(domEvent)) return;
        var oneMoreEvent = null;
        var eventType = type || domEvent.type;
        if (isMoveEvent(eventType) && !GlobalConfig.isTest && isMousemoveEventBlocked(this, map.options['mousemoveThrottleTime'])) {
            stopPropagation(domEvent);
            return;
        }
        var isMousedown = eventType === 'mousedown' || eventType === 'touchstart' && domEvent.touches && domEvent.touches.length === 1;
        if (isMousedown) this._mouseDownTime = now();
        else if ((eventType === 'click' || eventType === 'touchend') && this._mouseDownTime) {
            var downTime = this._mouseDownTime;
            delete this._mouseDownTime;
            var time = now();
            if (time - downTime > 300) {
                if (eventType === 'click') return;
            } else if (eventType === 'touchend') oneMoreEvent = 'click';
        }
        var actual = domEvent.touches && domEvent.touches.length > 0 ? domEvent.touches[0] : domEvent.changedTouches && domEvent.changedTouches.length > 0 ? domEvent.changedTouches[0] : domEvent;
        if (!actual) return;
        var containerPoint = getEventContainerPoint(actual, map.getContainer());
        if (eventType === 'touchstart') {
            if (map.options['preventTouch']) preventDefault(domEvent);
        }
        var geometryCursorStyle = null;
        var tops = this.target.getRenderer().getTopElements();
        var topOnlyEvent = isMousedown && domEvent.button !== 2;
        for(var i = 0; i < tops.length; i++)if (tops[i].hitTest(containerPoint)) {
            var cursor = tops[i].options['cursor'];
            if (cursor) geometryCursorStyle = cursor;
            if (topOnlyEvent || tops[i].events && tops[i].events.indexOf(eventType) >= 0) {
                var e = {
                    target: map,
                    type: eventType,
                    domEvent: domEvent,
                    containerPoint: containerPoint
                };
                if (topOnlyEvent) {
                    map._setPriorityCursor(geometryCursorStyle);
                    tops[i].mousedown(e);
                    return;
                } else tops[i].onEvent(e);
            }
        }
        var layers = map._getLayers(function(layer) {
            if (layer.identify && layer.options['geometryEvents']) return true;
            return false;
        });
        if (!layers.length) return;
        var eventTypes = MOUSEEVENT_ASSOCIATION_TABLE[eventType] || [
            eventType
        ];
        var identifyOptions = {
            'includeInternals': true,
            'filter': function filter(geometry) {
                if (geometry instanceof Geometry) {
                    var eventToFire = geometry._getEventTypeToFire(domEvent);
                    if (eventType === 'mousemove') {
                        if (!geometryCursorStyle && geometry.options['cursor']) geometryCursorStyle = geometry.options['cursor'];
                        return true;
                    } else if (!geometry.listens(eventToFire) && !geometry.listens(oneMoreEvent)) return false;
                    return true;
                } else if (isGeo(geometry)) return true;
                return false;
            },
            'count': 1,
            'onlyVisible': map.options['onlyVisibleGeometryEvents'],
            containerPoint: containerPoint,
            layers: layers,
            eventTypes: eventTypes,
            domEvent: domEvent
        };
        var callback = fireGeometryEvent.bind(this);
        if (isMoveEvent(eventType)) this._queryIdentifyTimeout = map.getRenderer().callInNextFrame(function() {
            if (map.isInteracting()) return;
            map.identifyAtPoint(identifyOptions, callback);
        });
        else map.identifyAtPoint(identifyOptions, callback);
        function fireGeometryEvent(geometries) {
            var _this = this;
            var propagation = true;
            var getOldGeos = function getOldGeos() {
                var geos = _this._prevOverGeos && _this._prevOverGeos.geos;
                return geos || [];
            };
            var oldGeosMouseout = function oldGeosMouseout(oldTargets = [], newTargets = []) {
                if (oldTargets && oldTargets.length > 0) for(var _i = oldTargets.length - 1; _i >= 0; _i--){
                    var oldTarget = oldTargets[_i];
                    if (!isGeo(oldTarget)) continue;
                    if (newTargets.indexOf(oldTarget) === -1) propagation = fireGeoEvent(oldTarget, domEvent, 'mouseout');
                }
            };
            if (eventType === 'mouseout') {
                var oldTargets = getOldGeos();
                this._prevOverGeos = {
                    'geos': [],
                    'geomap': {}
                };
                oldGeosMouseout(oldTargets, []);
            } else if (eventType === 'mousemove') {
                var geoMap = {};
                if (geometries.length > 0) for(var _i2 = geometries.length - 1; _i2 >= 0; _i2--){
                    var geo = geometries[_i2];
                    if (!isGeo(geo)) continue;
                    var iid = getGeoId(geo);
                    geoMap[iid] = geo;
                    fireGeoEvent(geo, domEvent);
                    if (!this._prevOverGeos || !this._prevOverGeos.geomap[iid]) fireGeoEvent(geo, domEvent, 'mouseenter');
                    propagation = fireGeoEvent(geo, domEvent, 'mouseover');
                }
                map._setPriorityCursor(geometryCursorStyle);
                var _oldTargets = getOldGeos();
                this._prevOverGeos = {
                    'geos': geometries,
                    'geomap': geoMap
                };
                oldGeosMouseout(_oldTargets, geometries);
            } else {
                if (!geometries || !geometries.length) return;
                for(var _i3 = geometries.length - 1; _i3 >= 0; _i3--){
                    if (!isGeo(geometries[_i3])) continue;
                    propagation = fireGeoEvent(geometries[_i3], domEvent);
                    if (oneMoreEvent) fireGeoEvent(geometries[_i3], domEvent, oneMoreEvent);
                    break;
                }
            }
            if (propagation === false) stopPropagation(domEvent);
        }
    };
    return MapGeometryEventsHandler;
}(Handler);
Map$1.mergeOptions({
    'geometryEvents': true,
    'onlyVisibleGeometryEvents': true
});
Map$1.addOnLoadHook('addHandler', 'geometryEvents', MapGeometryEventsHandler);
var wheelZoomDelta = 4.000244140625;
var defaultZoomRate = 0.01;
var wheelZoomRate = 1 / 450;
var maxScalePerFrame = 2;
var MapScrollWheelZoomHandler = function(_Handler) {
    function MapScrollWheelZoomHandler(target) {
        var _this;
        _this = _Handler.call(this, target) || this;
        _this._thisScrollZoom = _this._scrollZoom.bind(_this);
        _this._thisCheckIfEndZoom = _this._checkIfEndZoom.bind(_this);
        _this._wheelZoomRate = wheelZoomRate;
        _this._defaultZoomRate = defaultZoomRate;
        _this._delta = 0;
        return _this;
    }
    _inheritsLoose(MapScrollWheelZoomHandler, _Handler);
    var _proto = MapScrollWheelZoomHandler.prototype;
    _proto.addHooks = function addHooks() {
        addDomEvent(this.target._containerDOM, 'wheel', this._onWheelScroll, this);
    };
    _proto.removeHooks = function removeHooks() {
        removeDomEvent(this.target._containerDOM, 'wheel', this._onWheelScroll);
    };
    _proto._currentZoomCanScroll = function _currentZoomCanScroll(value) {
        if (isNumber(value)) {
            var map = this.target;
            var zoom = map.getZoom();
            var minZoom = map.getMinZoom();
            var maxZoom = map.getMaxZoom();
            if (zoom === minZoom && value > 0) return false;
            if (zoom === maxZoom && value < 0) return false;
        }
        return true;
    };
    _proto._onWheelScroll = function _onWheelScroll(evt) {
        var map = this.target;
        if (map.options['preventWheelScroll']) {
            preventDefault(evt);
            stopPropagation(evt);
        }
        if (map._ignoreEvent(evt) || !map.options['zoomable']) return false;
        var container = map.getContainer();
        var origin = map._checkZoomOrigin(getEventContainerPoint(evt, container));
        if (map.options['seamlessZoom']) {
            if (!this._zooming) {
                this._trackPadSuspect = 0;
                this._ensureTrackpad = false;
            }
            return this._seamless(evt, origin);
        } else return this._interval(evt, origin);
    };
    _proto._seamless = function _seamless(evt, origin) {
        var value = evt.deltaMode === window.WheelEvent.DOM_DELTA_LINE ? evt.deltaY * 60 : evt.deltaY;
        if (value % wheelZoomDelta !== 0) {
            if (!this._ensureTrackpad) {
                if (Math.abs(value) < 60) this._trackPadSuspect++;
                else this._trackPadSuspect = 0;
                if (this._trackPadSuspect >= 2) this._ensureTrackpad = true;
            }
            if (this._ensureTrackpad) value *= 14;
        }
        if (evt.shiftKey && value) value = value / 4;
        this._lastWheelEvent = evt;
        if (isNil(this._delta)) this._delta = 0;
        this._delta -= value;
        if (!this._currentZoomCanScroll(value)) return;
        if (!this._zooming && this._delta) {
            var map = this.target;
            this._zoomOrigin = origin;
            map.onZoomStart(null, origin);
        }
        this._start();
    };
    _proto._start = function _start() {
        if (!this._delta) return;
        this._zooming = true;
        var map = this.target;
        if (!this._active) {
            map.getRenderer().callInNextFrame(this._thisScrollZoom);
            this._active = true;
        }
    };
    _proto._scrollZoom = function _scrollZoom() {
        this._active = false;
        if (!this._delta) return;
        var zoomRate = Math.abs(this._delta) > wheelZoomDelta ? this._wheelZoomRate : this._defaultZoomRate;
        var scale = maxScalePerFrame / (1 + Math.exp(-Math.abs(this._delta * zoomRate)));
        if (this._delta < 0 && scale !== 0) scale = 1 / scale;
        var map = this.target;
        var zoom = map.getZoom();
        var targetZoom = map.getZoomForScale(scale, zoom, true);
        this._delta = 0;
        map.onZooming(targetZoom, this._zoomOrigin);
        this._scrollTime = performance.now();
        map.getRenderer().callInNextFrame(this._thisCheckIfEndZoom);
    };
    _proto._checkIfEndZoom = function _checkIfEndZoom() {
        if (!this._zooming) return;
        var map = this.target;
        var currentTime = performance.now();
        if (currentTime - this._scrollTime > 210) {
            this._zooming = false;
            map.onZoomEnd(map.getZoom(), this._zoomOrigin);
        } else map.getRenderer().callInNextFrame(this._thisCheckIfEndZoom);
    };
    _proto._interval = function _interval(evt, origin) {
        var _this2 = this;
        var map = this.target;
        if (this._zooming) {
            this._requesting++;
            return false;
        }
        this._requesting = 0;
        var levelValue = (evt.deltaY ? evt.deltaY * -1 : evt.wheelDelta ? evt.wheelDelta : evt.detail) > 0 ? 1 : -1;
        if (evt.detail) levelValue *= -1;
        var zoom = map.getZoom();
        var nextZoom = zoom + levelValue;
        nextZoom = map._checkZoom(levelValue > 0 ? Math.ceil(nextZoom) : Math.floor(nextZoom));
        if (nextZoom === zoom) return false;
        this._zooming = true;
        if (!this._delta) {
            map.onZoomStart(null, origin);
            this._origin = origin;
            this._delta = levelValue;
            this._startZoom = map.getZoom();
        }
        var duration = 90;
        map._animateTo({
            'zoom': nextZoom - this._delta * 1 / 2,
            'around': this._origin
        }, {
            'continueOnViewChanged': true,
            'easing': 'linear',
            'duration': duration,
            'wheelZoom': true
        }, function(frame) {
            if (frame.state.playState !== 'finished') {
                if (frame.state.playState !== 'running') {
                    delete _this2._zooming;
                    delete _this2._requesting;
                }
                return;
            }
            if (_this2._requesting < 1 || Math.abs(nextZoom - _this2._startZoom) > 2 || nextZoom === map.getMaxZoom() || nextZoom === map.getMinZoom()) {
                map._animateTo({
                    'zoom': nextZoom,
                    'around': _this2._origin
                }, {
                    'continueOnViewChanged': true,
                    'duration': 100
                }, function(frame) {
                    if (frame.state.playState !== 'running') {
                        delete _this2._zooming;
                        delete _this2._requesting;
                    }
                });
                delete _this2._startZoom;
                delete _this2._origin;
                delete _this2._delta;
                _this2._requesting = 0;
            } else if (!isNil(_this2._requesting)) {
                delete _this2._zooming;
                _this2._onWheelScroll(evt);
            }
        });
        return false;
    };
    return MapScrollWheelZoomHandler;
}(Handler);
Map$1.mergeOptions({
    'scrollWheelZoom': true,
    'seamlessZoom': true
});
Map$1.addOnLoadHook('addHandler', 'scrollWheelZoom', MapScrollWheelZoomHandler);
var MapTouchZoomHandler = function(_Handler) {
    function MapTouchZoomHandler() {
        return _Handler.apply(this, arguments) || this;
    }
    _inheritsLoose(MapTouchZoomHandler, _Handler);
    var _proto = MapTouchZoomHandler.prototype;
    _proto.addHooks = function addHooks() {
        addDomEvent(this.target.getContainer(), 'touchstart', this._onTouchStart, this);
    };
    _proto.removeHooks = function removeHooks() {
        removeDomEvent(this.target.getContainer(), 'touchstart', this._onTouchStart);
    };
    _proto._onTouchStart = function _onTouchStart(event) {
        var map = this.target;
        if (!event.touches || event.touches.length < 2) return;
        var container = map.getContainer();
        var p1 = getEventContainerPoint(event.touches[0], container), p2 = getEventContainerPoint(event.touches[1], container);
        this.preY = p1.y;
        this._startP1 = p1;
        this._startP2 = p2;
        this._startDist = p1.distanceTo(p2);
        this._startVector = p1.sub(p2);
        this._startZoom = map.getZoom();
        this._startBearing = map.getBearing();
        off(document, 'touchmove', this._onTouchMove);
        off(document, 'touchend', this._onTouchEnd);
        addDomEvent(document, 'touchmove', this._onTouchMove, this);
        addDomEvent(document, 'touchend', this._onTouchEnd, this);
        if (map.options['preventTouch']) preventDefault(event);
        map._fireEvent('touchactstart');
    };
    _proto._onTouchMove = function _onTouchMove(event) {
        var map = this.target;
        if (!event.touches || event.touches.length < 2) return;
        var container = map.getContainer(), p1 = getEventContainerPoint(event.touches[0], container), p2 = getEventContainerPoint(event.touches[1], container), d1 = p1.sub(this._startP1), d2 = p2.sub(this._startP2), vector = p1.sub(p2), scale = p1.distanceTo(p2) / this._startDist, bearing = vector.angleWith(this._startVector) * 180 / Math.PI, preY = this.preY || p1.y, pitch = (preY - p1.y) * 0.4;
        this.preY = p1.y;
        var param = {
            'domEvent': event,
            'mousePos': [
                p1,
                p2
            ]
        };
        if (!this.mode) {
            if (map.options['touchRotate'] && Math.abs(bearing) > 8) this.mode = map.options['touchZoomRotate'] ? 'rotate_zoom' : 'rotate';
            else if (map.options['touchPitch'] && d1.y * d2.y > 0 && Math.abs(d1.y) > 10 && Math.abs(d2.y) > 10) this.mode = 'pitch';
            else if (map.options['zoomable'] && map.options['touchZoom'] && Math.abs(1 - scale) > 0.15) this.mode = map.options['touchZoomRotate'] && map.options['touchRotate'] ? 'rotate_zoom' : 'zoom';
            this._startTouching(param);
        }
        if (this.mode === 'zoom' || this.mode === 'rotate_zoom') {
            this._scale = scale;
            var res = map._getResolution(this._startZoom) / scale;
            var zoom = map.getZoomFromRes(res);
            map.onZooming(zoom, this._Origin);
        }
        if (this.mode === 'rotate' || this.mode === 'rotate_zoom') {
            map._setBearing(this._startBearing + bearing);
            map.onDragRotating(param);
        } else if (this.mode === 'pitch') {
            map._setPitch(map.getPitch() + pitch);
            map.onDragRotating(param);
        }
        map._fireEvent('touchactinging');
    };
    _proto._startTouching = function _startTouching(param) {
        var map = this.target;
        if (this.mode === 'zoom' || this.mode === 'rotate_zoom') {
            var size = map.getSize();
            this._Origin = new Point(size['width'] / 2, size['height'] / 2);
            map.onZoomStart(null, this._Origin);
        }
        if (this.mode === 'rotate' || this.mode === 'pitch' || this.mode === 'rotate_zoom') map.onDragRotateStart(param);
    };
    _proto._onTouchEnd = function _onTouchEnd(event) {
        delete this.preY;
        var map = this.target;
        off(document, 'touchmove', this._onTouchMove);
        off(document, 'touchend', this._onTouchEnd);
        if (this.mode === 'zoom' || this.mode === 'rotate_zoom') {
            var scale = this._scale;
            var res = map._getResolution(this._startZoom) / scale;
            var zoom = map.getZoomFromRes(res);
            map.onZoomEnd(zoom, this._Origin);
        }
        if (this.mode === 'pitch' || this.mode === 'rotate' || this.mode === 'rotate_zoom') map.onDragRotateEnd({
            'domEvent': event
        });
        delete this.mode;
        map._fireEvent('touchactend');
    };
    return MapTouchZoomHandler;
}(Handler);
Map$1.mergeOptions({
    'touchGesture': true,
    'touchZoom': true,
    'touchPitch': true,
    'touchRotate': true,
    'touchZoomRotate': false
});
Map$1.addOnLoadHook('addHandler', 'touchGesture', MapTouchZoomHandler);
var KEY = '__anim_player';
var Easing = {
    outExpo: function outExpo(x) {
        return x === 1 ? 1 : 1 - Math.pow(2, -10 * x);
    },
    outQuint: function outQuint(x) {
        return 1 - Math.pow(1 - x, 5);
    },
    "in": function _in(t) {
        return Math.pow(t, 2);
    },
    out: function out(t) {
        return 1 - Easing["in"](1 - t);
    },
    inAndOut: function inAndOut(t) {
        return 3 * t * t - 2 * t * t * t;
    },
    linear: function linear(t) {
        return t;
    },
    upAndDown: function upAndDown(t) {
        if (t < 0.5) return Easing.inAndOut(2 * t);
        else return 1 - Easing.inAndOut(2 * (t - 0.5));
    }
};
var Frame = function() {
    function Frame(state, styles) {
        this.state = state;
        this.styles = styles;
    }
    return _createClass(Frame, [
        {
            key: "playState",
            get: function get() {
                return this.state.playState;
            }
        },
        {
            key: "symbol",
            get: function get() {
                return this.styles.symbol;
            }
        }
    ]);
}();
var Player = function() {
    function Player(animation, options, onFrame, target) {
        this._animation = animation;
        this.options = options;
        this._onFrame = onFrame;
        this.playState = 'idle';
        this.ready = true;
        this.finished = false;
        this.target = target;
    }
    var _proto = Player.prototype;
    _proto._prepare = function _prepare() {
        var options = this.options;
        var duration = options['speed'] || options['duration'];
        if (isString(duration)) {
            duration = Animation.speed[duration];
            if (!duration) duration = +duration;
        }
        if (!duration) duration = Animation.speed['normal'];
        this.duration = duration;
        this._framer = options['framer'] || Animation._requestAnimFrame.bind(Animation);
    };
    _proto.play = function play() {
        if (this.playState !== 'idle' && this.playState !== 'paused' || this.target && this.target[KEY]) return this;
        if (this.target) this.target[KEY] = 1;
        if (this.playState === 'idle') {
            this.currentTime = 0;
            this._prepare();
        }
        var t = now();
        if (!this.startTime) {
            var options = this.options;
            this.startTime = options['startTime'] ? options['startTime'] : t;
        }
        this._playStartTime = Math.max(t, this.startTime);
        if (this.playState === 'paused') this._playStartTime -= this.currentTime;
        this.playState = 'running';
        this._run();
        return this;
    };
    _proto.pause = function pause() {
        if (this.playState === 'paused') return this;
        this.playState = 'paused';
        this._run();
        return this;
    };
    _proto.cancel = function cancel() {
        if (this.playState === 'idle') return this;
        this.playState = 'idle';
        this.finished = false;
        this._run();
        return this;
    };
    _proto.finish = function finish() {
        if (this.playState === 'finished') return this;
        this.playState = 'finished';
        this.finished = true;
        this._run();
        return this;
    };
    _proto.reverse = function reverse() {};
    _proto._run = function _run() {
        var _this = this;
        var onFrame = this._onFrame;
        var t = now();
        var elapsed = t - this._playStartTime;
        if (this.options['repeat'] && elapsed >= this.duration) {
            this._playStartTime = t;
            elapsed = 0;
        }
        if (this.playState !== 'running') {
            if (this.target) delete this.target[KEY];
            if (onFrame) {
                if (this.playState === 'finished') elapsed = this.duration;
                else if (this.playState === 'idle') elapsed = 0;
                var _frame = this._animation(elapsed, this.duration);
                _frame.state.playState = this.playState;
                onFrame(_frame);
            }
            return;
        }
        var frame = this._animation(elapsed, this.duration);
        this.playState = frame.state['playState'];
        if (this.playState !== 'running' && this.target) delete this.target[KEY];
        if (this.playState === 'idle') {
            if (this.startTime > t) setTimeout(this._run.bind(this), this.startTime - t);
        } else if (this.playState === 'running') this._framer(function() {
            if (_this.playState !== 'running') return;
            _this.currentTime = elapsed;
            if (onFrame) onFrame(frame);
            _this._run();
        });
        else if (this.playState === 'finished') {
            this.finished = true;
            if (onFrame) onFrame(frame);
        }
    };
    return Player;
}();
var Animation = {
    speed: {
        'slow': 2000,
        'normal': 1000,
        'fast': 500
    },
    _resolveStyles: function _resolveStyles(styles) {
        if (!styles) return null;
        function resolveChild(child) {
            if (!Array.isArray(child)) return Animation._resolveStyles(child);
            var start = [], d = [], dest = [];
            for(var i = 0; i < child.length; i++){
                var _styles = Animation._resolveStyles(child[i]);
                if (_styles) {
                    start.push(_styles[0]);
                    d.push(_styles[1]);
                    dest.push(_styles[2]);
                }
            }
            if (!start.length) return null;
            else return [
                start,
                d,
                dest
            ];
        }
        function resolveVal(val) {
            var values = val;
            var clazz;
            if (!Array.isArray(val)) {
                if (isNumber(val)) values = [
                    0,
                    val
                ];
                else if (val instanceof Point || val instanceof Coordinate) {
                    clazz = val.constructor;
                    values = [
                        new clazz(0, 0),
                        val
                    ];
                } else values = [
                    val,
                    val
                ];
            }
            var v1 = values[0], v2 = values[1];
            if (isNumber(v1) && isNumber(v2)) {
                if (v1 === v2) return null;
                return [
                    v1,
                    v2 - v1,
                    v2
                ];
            } else if (Array.isArray(v1) && isNumber(v1[0]) || v1 instanceof Coordinate || v1 instanceof Point) {
                if (Array.isArray(v1)) {
                    v1 = new Coordinate(v1);
                    v2 = new Coordinate(v2);
                } else {
                    clazz = v1.constructor;
                    v1 = new clazz(v1);
                    v2 = new clazz(v2);
                }
                if (v1.equals(v2)) return null;
                return [
                    v1,
                    v2.sub(v1),
                    v2
                ];
            } else return [
                v1,
                v2,
                v2
            ];
        }
        function isChild(val) {
            if (!Array.isArray(val) && val.constructor === Object) return true;
            else if (Array.isArray(val) && val[0].constructor === Object) return true;
            return false;
        }
        var d = {}, start = {}, dest = {};
        for(var p in styles)if (styles.hasOwnProperty(p)) {
            var values = styles[p];
            if (!values) continue;
            else if (Array.isArray(values)) {
                if (isNil(values[0]) || isNil(values[1])) continue;
            }
            var childStyles = void 0;
            if (isChild(values)) childStyles = resolveChild(values);
            else childStyles = resolveVal(values);
            if (childStyles) {
                start[p] = childStyles[0];
                d[p] = childStyles[1];
                dest[p] = childStyles[2];
            }
        }
        return [
            start,
            d,
            dest
        ];
    },
    framing: function framing(styles, options) {
        if (!options) options = {};
        var easing;
        if (isFunction(options.easing)) easing = options['easing'];
        else easing = options['easing'] ? Easing[options['easing']] : Easing.linear;
        if (!easing || !isFunction(easing)) easing = Easing.linear;
        var dStyles, startStyles, destStyles;
        styles = Animation._resolveStyles(styles);
        if (styles) {
            startStyles = styles[0];
            dStyles = styles[1];
            destStyles = styles[2];
        }
        var _deltaStyles = function deltaStyles(delta, _startStyles, _dStyles) {
            if (!_startStyles || !_dStyles) return null;
            var result = {};
            for(var p in _dStyles)if (_dStyles.hasOwnProperty(p)) {
                if (_startStyles[p] === destStyles[p]) {
                    result[p] = _startStyles[p];
                    continue;
                }
                var s = _startStyles[p], d = _dStyles[p];
                if (isNumber(d)) result[p] = s + delta * d;
                else if (Array.isArray(d)) {
                    var children = [];
                    for(var i = 0; i < d.length; i++)children.push(_deltaStyles(delta, s[i], d[i]));
                    result[p] = children;
                } else {
                    var clazz = d.constructor;
                    if (clazz === Object) result[p] = _deltaStyles(delta, s, d);
                    else if (s instanceof Point || s instanceof Coordinate) result[p] = s.add(d.multi(delta));
                    else result[p] = d;
                }
            }
            return result;
        };
        return function(elapsed, duration) {
            var state, d;
            if (elapsed < 0) {
                state = {
                    'playState': 'idle',
                    'delta': 0
                };
                d = startStyles;
            } else if (elapsed < duration) {
                var delta = easing(elapsed / duration);
                state = {
                    'playState': 'running',
                    'delta': delta
                };
                d = _deltaStyles(delta, startStyles, dStyles);
            } else {
                state = {
                    'playState': 'finished',
                    'delta': 1
                };
                d = destStyles;
            }
            state['startStyles'] = startStyles;
            state['destStyles'] = destStyles;
            state['progress'] = elapsed;
            state['remainingMs'] = duration - elapsed;
            return new Frame(state, d);
        };
    },
    _requestAnimFrame: function _requestAnimFrame(fn) {
        if (!this._frameQueue) this._frameQueue = [];
        this._frameQueue.push(fn);
        this._a();
    },
    _a: function _a() {
        if (!this._animationFrameId) this._animationFrameId = requestAnimFrame(Animation._frameFn);
    },
    _run: function _run() {
        if (this._frameQueue.length) {
            var running = this._frameQueue;
            this._frameQueue = [];
            for(var i = 0, len = running.length; i < len; i++)running[i]();
            if (this._frameQueue.length) this._animationFrameId = requestAnimFrame(Animation._frameFn);
            else delete this._animationFrameId;
        }
    },
    animate: function animate(styles, options, step, target) {
        if (!options) options = {};
        var animation = Animation.framing(styles, options);
        var player = new Player(animation, options, step, target);
        return player;
    },
    _frameFn: function _frameFn() {}
};
Animation._frameFn = Animation._run.bind(Animation);
var animate = Animation.animate;
var Animation$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Animation: Animation,
    Easing: Easing,
    Frame: Frame,
    Player: Player,
    animate: animate
});
var simplify$1 = {
    exports: {}
};
/*
 (c) 2017, Vladimir Agafonkin
 Simplify.js, a high-performance JS polyline simplification library
 mourner.github.io/simplify-js
*/ (function(module) {
    (function() {
        // to suit your point format, run search/replace for '.x' and '.y';
        // for 3D version, see 3d branch (configurability would draw significant performance overhead)
        // square distance between 2 points
        function getSqDist(p1, p2) {
            var dx = p1.x - p2.x, dy = p1.y - p2.y;
            return dx * dx + dy * dy;
        }
        // square distance from a point to a segment
        function getSqSegDist(p, p1, p2) {
            var x = p1.x, y = p1.y, dx = p2.x - x, dy = p2.y - y;
            if (dx !== 0 || dy !== 0) {
                var t = ((p.x - x) * dx + (p.y - y) * dy) / (dx * dx + dy * dy);
                if (t > 1) {
                    x = p2.x;
                    y = p2.y;
                } else if (t > 0) {
                    x += dx * t;
                    y += dy * t;
                }
            }
            dx = p.x - x;
            dy = p.y - y;
            return dx * dx + dy * dy;
        }
        // rest of the code doesn't care about point format
        // basic distance-based simplification
        function simplifyRadialDist(points, sqTolerance) {
            var prevPoint = points[0], newPoints = [
                prevPoint
            ], point;
            for(var i = 1, len = points.length; i < len; i++){
                point = points[i];
                if (getSqDist(point, prevPoint) > sqTolerance) {
                    newPoints.push(point);
                    prevPoint = point;
                }
            }
            if (prevPoint !== point) newPoints.push(point);
            return newPoints;
        }
        function simplifyDPStep(points, first, last, sqTolerance, simplified) {
            var maxSqDist = sqTolerance, index;
            for(var i = first + 1; i < last; i++){
                var sqDist = getSqSegDist(points[i], points[first], points[last]);
                if (sqDist > maxSqDist) {
                    index = i;
                    maxSqDist = sqDist;
                }
            }
            if (maxSqDist > sqTolerance) {
                if (index - first > 1) simplifyDPStep(points, first, index, sqTolerance, simplified);
                simplified.push(points[index]);
                if (last - index > 1) simplifyDPStep(points, index, last, sqTolerance, simplified);
            }
        }
        // simplification using Ramer-Douglas-Peucker algorithm
        function simplifyDouglasPeucker(points, sqTolerance) {
            var last = points.length - 1;
            var simplified = [
                points[0]
            ];
            simplifyDPStep(points, 0, last, sqTolerance, simplified);
            simplified.push(points[last]);
            return simplified;
        }
        // both algorithms combined for awesome performance
        function simplify(points, tolerance, highestQuality) {
            if (points.length <= 2) return points;
            var sqTolerance = tolerance !== undefined ? tolerance * tolerance : 1;
            points = highestQuality ? points : simplifyRadialDist(points, sqTolerance);
            points = simplifyDouglasPeucker(points, sqTolerance);
            return points;
        }
        module.exports = simplify;
        module.exports.default = simplify;
    })();
})(simplify$1);
var simplifyExports = simplify$1.exports;
var simplify = /*@__PURE__*/ getDefaultExportFromCjs(simplifyExports);
var GEOMETRY_NOT_FIND_PROJECTION = 'not find Geometry\' Projection. please add Geometry to Layer and add Layer to Map';
var options$A = {
    'smoothness': false,
    'enableClip': true,
    'enableSimplify': true,
    'simplifyTolerance': 2,
    'symbol': {
        'lineColor': '#000',
        'lineWidth': 2,
        'lineOpacity': 1,
        'polygonFill': '#fff',
        'polygonOpacity': 1,
        'opacity': 1
    }
};
var Path = function(_Geometry) {
    function Path() {
        return _Geometry.apply(this, arguments) || this;
    }
    _inheritsLoose(Path, _Geometry);
    var _proto = Path.prototype;
    _proto.animateShow = function animateShow(options = {}, cb) {
        var _this = this;
        if (this._showPlayer) this._showPlayer.finish();
        if (isFunction(options)) {
            options = {};
            cb = options;
        }
        var coordinates = this.getCoordinates();
        if (coordinates.length === 0) return;
        this._animIdx = 0;
        this._animLenSoFar = 0;
        this.show();
        var isPolygon = !!this.getShell;
        var animCoords = isPolygon ? this.getShell().concat(this.getShell()[0]) : coordinates;
        var projection = this._getProjection();
        if (!projection) {
            console.error(GEOMETRY_NOT_FIND_PROJECTION);
            return;
        }
        var prjAnimCoords = projection.projectCoords(animCoords, this.options['antiMeridian']);
        this._prjAniShowCenter = this._getPrjExtent().getCenter();
        this._aniShowCenter = projection.unproject(this._prjAniShowCenter);
        var duration = options['duration'] || 1000, easing = options['easing'] || 'out';
        this.setCoordinates([]);
        var length = 0;
        if (prjAnimCoords.length) prjAnimCoords[0]._distance = 0;
        for(var i = 1; i < prjAnimCoords.length; i++){
            var distance = prjAnimCoords[i].distanceTo(prjAnimCoords[i - 1]);
            prjAnimCoords[i]._distance = distance;
            length += distance;
        }
        this._tempCoord = new Coordinate(0, 0);
        this._tempPrjCoord = new Point(0, 0);
        var player = this._showPlayer = Animation.animate({
            't': duration
        }, {
            'duration': duration,
            'easing': easing
        }, function(frame) {
            if (!_this.getMap()) {
                if (player.playState !== 'finished') {
                    player.finish();
                    if (cb) {
                        var _coordinates = _this.getCoordinates();
                        cb(frame, _coordinates[_coordinates.length - 1]);
                    }
                }
                return;
            }
            var currentCoord = _this._drawAnimShowFrame(frame.styles.t, duration, length, animCoords, prjAnimCoords);
            if (frame.state.playState === 'finished') {
                delete _this._showPlayer;
                delete _this._aniShowCenter;
                delete _this._prjAniShowCenter;
                delete _this._animIdx;
                delete _this._animLenSoFar;
                delete _this._animTailRatio;
                delete _this._tempCoord;
                delete _this._tempPrjCoord;
                _this.setCoordinates(coordinates);
            }
            if (cb) cb(frame, currentCoord);
        }, this);
        player.play();
        return player;
    };
    _proto._drawAnimShowFrame = function _drawAnimShowFrame(t, duration, length, coordinates, prjCoords) {
        if (t === 0) return coordinates[0];
        var targetLength = t / duration * length;
        var segLen = 0;
        var i, l;
        for(i = this._animIdx + 1, l = prjCoords.length; i < l; i++){
            segLen = prjCoords[i]._distance;
            if (this._animLenSoFar + segLen > targetLength) break;
            this._animLenSoFar += segLen;
        }
        this._animIdx = i - 1;
        if (this._animIdx >= l - 1) {
            this.setCoordinates(coordinates);
            return coordinates[coordinates.length - 1];
        }
        var idx = this._animIdx;
        var p1 = prjCoords[idx], p2 = prjCoords[idx + 1], span = targetLength - this._animLenSoFar, r = span / segLen;
        this._animTailRatio = r;
        var x = p1.x + (p2.x - p1.x) * r, y = p1.y + (p2.y - p1.y) * r;
        this._tempPrjCoord.x = x;
        this._tempPrjCoord.y = y;
        var lastCoord = this._tempPrjCoord;
        var c1 = coordinates[idx], c2 = coordinates[idx + 1];
        var cx = c1.x + (c2.x - c1.x) * r, cy = c1.y + (c2.y - c1.y) * r;
        this._tempCoord.x = cx;
        this._tempCoord.y = cy;
        var targetCoord = this._tempCoord;
        var isPolygon = !!this.getShell;
        if (!isPolygon && this.options['smoothness'] > 0) {
            var animCoords = [], prjAnimCoords = [];
            for(var _i = 0; _i <= this._animIdx; _i++){
                animCoords.push(coordinates[_i]);
                prjAnimCoords.push(prjCoords[_i]);
            }
            animCoords.push(targetCoord, targetCoord);
            prjAnimCoords.push(lastCoord, lastCoord);
            this.setCoordinates(animCoords);
            this._setPrjCoordinates(prjAnimCoords);
        } else {
            var _animCoords = coordinates.slice(0, this._animIdx + 1);
            _animCoords.push(targetCoord);
            var _prjAnimCoords = prjCoords.slice(0, this._animIdx + 1);
            _prjAnimCoords.push(lastCoord);
            if (isPolygon) {
                this.setCoordinates([
                    this._aniShowCenter
                ].concat(_animCoords));
                this._setPrjCoordinates([
                    this._prjAniShowCenter
                ].concat(_prjAnimCoords));
            } else {
                this.setCoordinates(_animCoords);
                this._setPrjCoordinates(_prjAnimCoords);
            }
        }
        return targetCoord;
    };
    _proto._getCenterInExtent = function _getCenterInExtent(extent, coordinates, clipFn) {
        var meExtent = this.getExtent();
        if (!extent.intersects(meExtent)) return null;
        var clipped = clipFn(coordinates, extent);
        if (clipped.length === 0) return null;
        var [sumx, sumy, counter] = [
            0,
            0,
            0
        ];
        clipped.forEach(function(part) {
            if (Array.isArray(part)) part.forEach(function(c) {
                if (c.point) c = c.point;
                sumx += c.x;
                sumy += c.y;
                counter++;
            });
            else {
                if (part.point) part = part.point;
                sumx += part.x;
                sumy += part.y;
                counter++;
            }
        });
        var c = new Coordinate(sumx, sumy)._multi(1 / counter);
        c.count = counter;
        return c;
    };
    _proto._getPath2DPoints = function _getPath2DPoints(prjCoords, disableSimplify, res) {
        if (!isArrayHasData(prjCoords)) return [];
        var map = this.getMap(), isSimplify = !disableSimplify && this._shouldSimplify(), tolerance = this.options['simplifyTolerance'] * map._getResolution(), isMulti = Array.isArray(prjCoords[0]);
        delete this._simplified;
        if (isSimplify && !isMulti) {
            var count = prjCoords.length;
            prjCoords = simplify(prjCoords, tolerance, false);
            this._simplified = prjCoords.length < count;
        }
        if (!res) res = map._getResolution();
        if (!Array.isArray(prjCoords)) return map._prjToPointAtRes(prjCoords, res);
        else {
            var resultPoints = [];
            var glPointKey = '_glPt';
            if (!Array.isArray(prjCoords[0])) {
                resultPoints = getPointsResultPts(prjCoords, glPointKey);
                return map._prjsToPointsAtRes(prjCoords, res, resultPoints);
            }
            var pts = [];
            for(var i = 0, len = prjCoords.length; i < len; i++){
                var prjCoord = prjCoords[i];
                resultPoints = getPointsResultPts(prjCoord, glPointKey);
                var pt = map._prjsToPointsAtRes(prjCoord, res, resultPoints);
                pts.push(pt);
            }
            return pts;
        }
    };
    _proto._shouldSimplify = function _shouldSimplify() {
        var layer = this.getLayer();
        var hasAltitude = layer.options['enableAltitude'];
        return layer && layer.options['enableSimplify'] && !hasAltitude && this.options['enableSimplify'] && !this._showPlayer;
    };
    _proto._setPrjCoordinates = function _setPrjCoordinates(prjPoints) {
        this._prjCoords = prjPoints;
        this.onShapeChanged();
    };
    _proto._getPrjCoordinates = function _getPrjCoordinates() {
        this._verifyProjection();
        if (!this._prjCoords && this._getProjection()) this._prjCoords = this._projectCoords(this._coordinates);
        return this._prjCoords;
    };
    _proto._updateCache = function _updateCache() {
        this._clearCache();
        var projection = this._getProjection();
        if (!projection) return;
        if (this._prjCoords) this._coordinates = this._unprojectCoords(this._getPrjCoordinates());
    };
    _proto._clearProjection = function _clearProjection() {
        this._prjCoords = null;
        _Geometry.prototype._clearProjection.call(this);
    };
    _proto._projectCoords = function _projectCoords(points) {
        var projection = this._getProjection();
        if (projection) return projection.projectCoords(points, this.options['antiMeridian']);
        return [];
    };
    _proto._unprojectCoords = function _unprojectCoords(prjPoints) {
        var projection = this._getProjection();
        if (projection) return projection.unprojectCoords(prjPoints);
        return [];
    };
    _proto._computeCenter = function _computeCenter() {
        var ring = this._coordinates;
        if (!isArrayHasData(ring)) return null;
        var sumx = 0, sumy = 0, counter = 0;
        var size = ring.length;
        for(var i = 0; i < size; i++){
            if (ring[i]) {
                if (isNumber(ring[i].x) && isNumber(ring[i].y)) {
                    sumx += ring[i].x;
                    sumy += ring[i].y;
                    counter++;
                }
            }
        }
        return new Coordinate(sumx / counter, sumy / counter);
    };
    _proto._computeExtent = function _computeExtent(_) {
        var shell = this._coordinates;
        if (!isArrayHasData(shell)) return null;
        var rings = [
            shell
        ];
        if (this.hasHoles && this.hasHoles()) rings.push.call(rings, ...this.getHoles());
        return this._coords2Extent(rings, this._getProjection());
    };
    _proto._computePrjExtent = function _computePrjExtent(_) {
        var coords = [
            this._getPrjCoordinates()
        ];
        if (this.hasHoles && this.hasHoles()) coords.push.call(coords, ...this._getPrjHoles());
        return this._coords2Extent(coords);
    };
    _proto._get2DLength = function _get2DLength() {
        var vertexes = this._getPath2DPoints(this._getPrjCoordinates(), true);
        var len = 0;
        for(var i = 1, l = vertexes.length; i < l; i++)len += vertexes[i].distanceTo(vertexes[i - 1]);
        return len;
    };
    _proto._hitTestTolerance = function _hitTestTolerance() {
        var symbol = this._getInternalSymbol();
        var w;
        if (Array.isArray(symbol)) {
            w = 0;
            for(var i = 0; i < symbol.length; i++){
                if (isNumber(symbol[i]['lineWidth'])) {
                    if (symbol[i]['lineWidth'] > w) w = symbol[i]['lineWidth'];
                }
            }
        } else w = symbol['lineWidth'];
        return _Geometry.prototype._hitTestTolerance.call(this) + (isNumber(w) ? w / 2 : 1.5);
    };
    _proto._coords2Extent = function _coords2Extent(coords, proj) {
        if (!coords || coords.length === 0 || Array.isArray(coords[0]) && coords[0].length === 0) return null;
        var result = new Extent(proj);
        for(var i = 0, l = coords.length; i < l; i++)for(var j = 0, ll = coords[i].length; j < ll; j++)result._combine(coords[i][j]);
        return result;
    };
    return Path;
}(Geometry);
Path.mergeOptions(options$A);
var JSON_TYPE = 'Polygon';
var Polygon = function(_Path) {
    function Polygon(coordinates, options) {
        var _this;
        _this = _Path.call(this, options) || this;
        _this.type = 'Polygon';
        if (coordinates) _this.setCoordinates(coordinates);
        return _this;
    }
    _inheritsLoose(Polygon, _Path);
    var _proto = Polygon.prototype;
    _proto.getOutline = function getOutline() {
        var painter = this._getPainter();
        if (!painter) return null;
        var extent = this.getExtent();
        return new Polygon(extent.toArray(), {
            symbol: {
                'lineWidth': 1,
                'lineColor': '6b707b'
            }
        });
    };
    _proto.setCoordinates = function setCoordinates(coordinates) {
        if (!coordinates) {
            this._coordinates = null;
            this._holes = null;
            this._projectRings();
            return this;
        }
        var rings = Coordinate.toCoordinates(coordinates);
        var len = rings.length;
        if (!Array.isArray(rings[0])) this._coordinates = this._trimRing(rings);
        else {
            this._coordinates = this._trimRing(rings[0]);
            if (len > 1) {
                var holes = [];
                for(var i = 1; i < len; i++){
                    if (!rings[i]) continue;
                    holes.push(this._trimRing(rings[i]));
                }
                this._holes = holes;
            } else this._holes = null;
        }
        this._projectRings();
        return this;
    };
    _proto.getCoordinates = function getCoordinates() {
        if (!this._coordinates) return [];
        var holes = this.getHoles();
        var rings = [
            this._copyAndCloseRing(this._coordinates)
        ];
        for(var i = 0, l = holes.length; i < l; i++)rings.push(this._copyAndCloseRing(holes[i]));
        return rings;
    };
    _proto.getCenterInExtent = function getCenterInExtent(extent) {
        return this._getCenterInExtent(extent, this.getShell(), clipPolygon);
    };
    _proto.getShell = function getShell() {
        return this._coordinates || [];
    };
    _proto.getHoles = function getHoles() {
        return this._holes || [];
    };
    _proto.hasHoles = function hasHoles() {
        return this.getHoles().length > 0;
    };
    _proto._projectRings = function _projectRings() {
        if (!this.getMap()) {
            this.onShapeChanged();
            return;
        }
        this._prjCoords = this._projectCoords(this._coordinates);
        this._prjHoles = this._projectCoords(this._holes);
        this.onShapeChanged();
    };
    _proto._setPrjCoordinates = function _setPrjCoordinates(prjCoords) {
        this._prjCoords = prjCoords;
        this.onShapeChanged();
    };
    _proto._cleanRing = function _cleanRing(ring) {
        for(var i = ring.length - 1; i >= 0; i--)if (!ring[i]) ring.splice(i, 1);
    };
    _proto._checkRing = function _checkRing(ring) {
        this._cleanRing(ring);
        if (!ring || !isArrayHasData(ring)) return false;
        var lastPoint = ring[ring.length - 1];
        var isClose = true;
        if (ring[0].x !== lastPoint.x || ring[0].y !== lastPoint.y) isClose = false;
        return isClose;
    };
    _proto._trimRing = function _trimRing(ring) {
        var isClose = this._checkRing(ring);
        if (isArrayHasData(ring) && isClose) ring.splice(ring.length - 1, 1);
        return ring;
    };
    _proto._copyAndCloseRing = function _copyAndCloseRing(ring) {
        ring = ring.slice(0);
        var isClose = this._checkRing(ring);
        if (isArrayHasData(ring) && !isClose) {
            ring.push(ring[0].copy());
            return ring;
        } else return ring;
    };
    _proto._getPrjShell = function _getPrjShell() {
        if (this.getJSONType() === JSON_TYPE) return this._getPrjCoordinates();
        this._verifyProjection();
        if (this._getProjection() && !this._prjShell) this._prjShell = this._projectCoords(this._getShell ? this._getShell() : this.getShell());
        return this._prjShell;
    };
    _proto._getPrjHoles = function _getPrjHoles() {
        var projection = this._getProjection();
        this._verifyProjection();
        if (projection && !this._prjHoles) this._prjHoles = this._projectCoords(this.getHoles());
        return this._prjHoles;
    };
    _proto._computeGeodesicLength = function _computeGeodesicLength(measurer) {
        var rings = this.getCoordinates();
        if (!isArrayHasData(rings)) return 0;
        var result = 0;
        for(var i = 0, len = rings.length; i < len; i++)result += measurer.measureLength(rings[i]);
        return result;
    };
    _proto._computeGeodesicArea = function _computeGeodesicArea(measurer) {
        var rings = this.getCoordinates();
        if (!isArrayHasData(rings)) return 0;
        var result = measurer.measureArea(rings[0]);
        for(var i = 1, len = rings.length; i < len; i++)result -= measurer.measureArea(rings[i]);
        return result;
    };
    _proto._updateCache = function _updateCache() {
        _Path.prototype._updateCache.call(this);
        if (this._prjHoles) this._holes = this._unprojectCoords(this._getPrjHoles());
    };
    _proto._clearCache = function _clearCache() {
        delete this._prjShell;
        return _Path.prototype._clearCache.call(this);
    };
    _proto._clearProjection = function _clearProjection() {
        if (this._prjHoles) this._prjHoles = null;
        if (this._prjShell) this._prjShell = null;
        _Path.prototype._clearProjection.call(this);
    };
    return Polygon;
}(Path);
Polygon.registerJSONType(JSON_TYPE);
function CenterMixin(Base) {
    return function(_Base) {
        function _class() {
            return _Base.apply(this, arguments) || this;
        }
        _inheritsLoose(_class, _Base);
        var _proto = _class.prototype;
        _proto.getCoordinates = function getCoordinates() {
            return this._coordinates;
        };
        _proto.setCoordinates = function setCoordinates(coordinates) {
            var center = coordinates instanceof Coordinate ? coordinates : new Coordinate(coordinates);
            this._translateRotatePivot(center);
            this._coordinates = center;
            if (!this.getMap()) {
                this._dirtyCoords = true;
                this.onPositionChanged();
                return this;
            }
            var projection = this._getProjection();
            this._setPrjCoordinates(projection.project(this._coordinates));
            return this;
        };
        _proto._getCenter2DPoint = function _getCenter2DPoint(res) {
            var map = this.getMap();
            if (!map) return null;
            var pcenter = this._getPrjCoordinates();
            if (!pcenter) return null;
            if (!res) res = map._getResolution();
            return map._prjToPointAtRes(pcenter, res);
        };
        _proto._getPrjCoordinates = function _getPrjCoordinates() {
            var projection = this._getProjection();
            this._verifyProjection();
            if (!this._pcenter && projection) {
                if (this._coordinates) this._pcenter = projection.project(this._coordinates);
            }
            return this._pcenter;
        };
        _proto._setPrjCoordinates = function _setPrjCoordinates(pcenter) {
            this._pcenter = pcenter;
            this.onPositionChanged();
        };
        _proto._updateCache = function _updateCache() {
            this._clearCache();
            var projection = this._getProjection();
            if (this._pcenter && projection) this._coordinates = projection.unproject(this._pcenter);
        };
        _proto._clearProjection = function _clearProjection() {
            this._pcenter = null;
            _Base.prototype._clearProjection.call(this);
        };
        _proto._computeCenter = function _computeCenter() {
            return this._coordinates ? this._coordinates.copy() : null;
        };
        return _class;
    }(Base);
}
var TEMP_EXTENT$3 = new PointExtent();
var options$z = {
    'symbol': {
        'markerType': 'path',
        'markerPath': [
            {
                'path': 'M8 23l0 0 0 0 0 0 0 0 0 0c-4,-5 -8,-10 -8,-14 0,-5 4,-9 8,-9l0 0 0 0c4,0 8,4 8,9 0,4 -4,9 -8,14z M3,9 a5,5 0,1,0,0,-0.9Z',
                'fill': '#DE3333'
            }
        ],
        'markerPathWidth': 16,
        'markerPathHeight': 23,
        'markerWidth': 24,
        'markerHeight': 34
    },
    'hitTestForEvent': false,
    'collision': true
};
var Marker = function(_CenterMixin) {
    function Marker(coordinates, options) {
        var _this;
        _this = _CenterMixin.call(this, options) || this;
        _this.type = 'Point';
        _this.isPoint = true;
        if (coordinates) _this.setCoordinates(coordinates);
        return _this;
    }
    _inheritsLoose(Marker, _CenterMixin);
    var _proto = Marker.prototype;
    _proto.getOutline = function getOutline() {
        var coord = this.getCoordinates();
        var extent = this.getContainerExtent();
        var anchor = this.getMap().coordToContainerPoint(coord);
        return new Marker(coord, {
            'symbol': {
                'markerType': 'square',
                'markerWidth': extent.getWidth(),
                'markerHeight': extent.getHeight(),
                'markerLineWidth': 1,
                'markerLineColor': '6b707b',
                'markerFill': 'rgba(0, 0, 0, 0)',
                'markerDx': extent.xmin - (anchor.x - extent.getWidth() / 2),
                'markerDy': extent.ymin - (anchor.y - extent.getHeight() / 2)
            }
        });
    };
    _proto.setSymbol = function setSymbol(symbol) {
        delete this._fixedExtent;
        return _CenterMixin.prototype.setSymbol.call(this, symbol);
    };
    _proto._getSizeSymbol = function _getSizeSymbol(symbol) {
        var s = {};
        var dynamic = false;
        var dynamicSize = false;
        for(var i = 0; i < DYNAMIC_SYMBOL_PROPS.length; i++){
            var v = symbol[DYNAMIC_SYMBOL_PROPS[i]];
            if (isNil(v)) continue;
            if (!dynamic && isFunctionDefinition(v)) {
                dynamic = true;
                dynamicSize = true;
            }
            s[DYNAMIC_SYMBOL_PROPS[i]] = v;
        }
        for(var _i = 0; _i < SIZE_SYMBOL_PROPS.length; _i++){
            var _v = symbol[SIZE_SYMBOL_PROPS[_i]];
            if (isNil(_v)) continue;
            if (!dynamic && isFunctionDefinition(_v)) dynamic = true;
            s[SIZE_SYMBOL_PROPS[_i]] = _v;
        }
        var sizeSymbol;
        if (dynamic) {
            sizeSymbol = loadGeoSymbol(s, this);
            if (dynamicSize) sizeSymbol._dynamic = true;
        } else sizeSymbol = s;
        return sizeSymbol;
    };
    _proto._setExternSymbol = function _setExternSymbol(symbol) {
        if (!this._symbol) delete this._fixedExtent;
        return _CenterMixin.prototype._setExternSymbol.call(this, symbol);
    };
    _proto._isDynamicSize = function _isDynamicSize() {
        return this._sizeSymbol && this._sizeSymbol._dynamic;
    };
    _proto._getFixedExtent = function _getFixedExtent() {
        if (this._fixedExtent && !this._isDynamicSize()) return this._fixedExtent;
        this._fixedExtent = this._fixedExtent || new PointExtent();
        this._fixedExtent.set(null, null, null, null);
        var symbol = this._sizeSymbol;
        if (!symbol) return this._fixedExtent;
        var renderer = this.getLayer() && this.getLayer().getRenderer();
        var resources = renderer && renderer.resources;
        var textDesc = this.getTextDesc();
        if (Array.isArray(symbol)) {
            TEMP_EXTENT$3.set(Infinity, Infinity, -Infinity, -Infinity);
            for(var i = 0; i < symbol.length; i++){
                if (!symbol[i]) continue;
                this._fixedExtent._combine(getMarkerFixedExtent(TEMP_EXTENT$3, symbol[i], resources, textDesc && textDesc[i]));
            }
        } else this._fixedExtent = getMarkerFixedExtent(this._fixedExtent, symbol, resources, textDesc);
        return this._fixedExtent;
    };
    _proto._isVectorMarker = function _isVectorMarker() {
        var symbol = this._getInternalSymbol();
        if (Array.isArray(symbol)) return false;
        return isVectorSymbol(symbol);
    };
    _proto._canEdit = function _canEdit() {
        var symbol = this._getInternalSymbol();
        if (Array.isArray(symbol)) return false;
        return isVectorSymbol(symbol) || isPathSymbol(symbol) || isImageSymbol(symbol);
    };
    _proto._containsPoint = function _containsPoint(point, t) {
        var extent = this.getContainerExtent();
        if (t) extent = extent.expand(t);
        if (extent.contains(point)) {
            if (this.options['hitTestForEvent']) return _CenterMixin.prototype._containsPoint.call(this, point, t);
            else return true;
        } else return false;
    };
    _proto._computeExtent = function _computeExtent() {
        return computeExtent$1.call(this, 'getCenter');
    };
    _proto._computePrjExtent = function _computePrjExtent() {
        return computeExtent$1.call(this, '_getPrjCoordinates');
    };
    _proto._computeGeodesicLength = function _computeGeodesicLength() {
        return 0;
    };
    _proto._computeGeodesicArea = function _computeGeodesicArea() {
        return 0;
    };
    _proto._getSprite = function _getSprite(resources, canvasClass) {
        if (this._getPainter()) return this._getPainter().getSprite(resources, canvasClass);
        return new Painter(this).getSprite(resources, canvasClass);
    };
    return Marker;
}(CenterMixin(Geometry));
Marker.mergeOptions(options$z);
Marker.registerJSONType('Marker');
function computeExtent$1(fn) {
    var coordinates = this[fn]();
    if (!coordinates) return null;
    return new Extent(coordinates, coordinates, this._getProjection());
}
var options$y = {
    'arrowStyle': null,
    'arrowPlacement': 'vertex-last'
};
var LineString = function(_Path) {
    function LineString(coordinates, options) {
        var _this;
        _this = _Path.call(this, options) || this;
        _this.type = 'LineString';
        if (coordinates) _this.setCoordinates(coordinates);
        return _this;
    }
    _inheritsLoose(LineString, _Path);
    var _proto = LineString.prototype;
    _proto.getOutline = function getOutline() {
        return Polygon.prototype.getOutline.call(this);
    };
    _proto.setCoordinates = function setCoordinates(coordinates) {
        if (!coordinates) {
            this._coordinates = null;
            this._setPrjCoordinates(null);
            return this;
        }
        this._coordinates = Coordinate.toCoordinates(coordinates);
        if (this.getMap()) this._setPrjCoordinates(this._projectCoords(this._coordinates));
        else this.onShapeChanged();
        return this;
    };
    _proto.getCoordinates = function getCoordinates() {
        return this._coordinates || [];
    };
    _proto.getCenterInExtent = function getCenterInExtent(extent) {
        return this._getCenterInExtent(extent, this.getCoordinates(), clipLine);
    };
    _proto._computeGeodesicLength = function _computeGeodesicLength(measurer) {
        return measurer.measureLength(this.getCoordinates());
    };
    _proto._computeGeodesicArea = function _computeGeodesicArea() {
        return 0;
    };
    return LineString;
}(Path);
LineString.mergeOptions(options$y);
LineString.registerJSONType('LineString');
var TEMP_EXTENT$2 = new PointExtent();
var GeometryCollection = function(_Geometry) {
    function GeometryCollection(geometries, opts) {
        var _this;
        _this = _Geometry.call(this, opts) || this;
        _this.type = 'GeometryCollection';
        _this._lastUndoEditIndex = 0;
        _this._lastRedoEditIndex = 0;
        _this.setGeometries(geometries);
        return _this;
    }
    _inheritsLoose(GeometryCollection, _Geometry);
    var _proto = GeometryCollection.prototype;
    _proto.getContainerExtent = function getContainerExtent(out) {
        var extent = out || new PointExtent();
        this.forEach(function(geo) {
            extent._combine(geo.getContainerExtent(TEMP_EXTENT$2));
        });
        return extent;
    };
    _proto.setGeometries = function setGeometries(_geometries) {
        var geometries = this._checkGeometries(_geometries || []);
        var symbol = this._getSymbol();
        var options = this.config();
        var properties = this.getProperties();
        for(var i = geometries.length - 1; i >= 0; i--){
            geometries[i]._initOptions(options);
            geometries[i]._setParent(this);
            geometries[i]._setEventParent(this);
            if (symbol) geometries[i].setSymbol(symbol);
            if (properties) geometries[i].setProperties(properties);
        }
        this._geometries = geometries;
        if (this.getLayer()) {
            this._bindGeometriesToLayer();
            this.onShapeChanged();
        }
        return this;
    };
    _proto.getGeometries = function getGeometries() {
        return this._geometries || [];
    };
    _proto.forEach = function forEach(fn, context) {
        var geometries = this.getGeometries();
        for(var i = 0, l = geometries.length; i < l; i++){
            if (!geometries[i]) continue;
            if (!context) fn(geometries[i], i);
            else fn.call(context, geometries[i], i);
        }
        return this;
    };
    _proto.filter = function filter(fn, context) {
        if (!fn) return new GeometryCollection();
        var selected = [];
        var isFn = isFunction(fn);
        var filter = isFn ? fn : createFilter(fn);
        this.forEach(function(geometry) {
            var g = isFn ? geometry : getFilterFeature(geometry);
            if (context ? filter.call(context, g) : filter(g)) selected.push(geometry);
        }, this);
        return new GeometryCollection(selected);
    };
    _proto.translate = function translate(offset) {
        if (!offset) return this;
        if (this.isEmpty()) return this;
        var args = arguments;
        this.forEach(function(geometry) {
            if (geometry && geometry.translate) geometry.translate.apply(geometry, args);
        });
        return this;
    };
    _proto.isEmpty = function isEmpty() {
        return !isArrayHasData(this.getGeometries());
    };
    _proto.remove = function remove() {
        this.forEach(function(geometry) {
            geometry._unbind();
        });
        return Geometry.prototype.remove.apply(this, arguments);
    };
    _proto.show = function show() {
        this.options['visible'] = true;
        this.forEach(function(geometry) {
            geometry.show();
        });
        return this;
    };
    _proto.hide = function hide() {
        this.options['visible'] = false;
        this.forEach(function(geometry) {
            geometry.hide();
        });
        return this;
    };
    _proto.onConfig = function onConfig(config) {
        this.forEach(function(geometry) {
            geometry.config(config);
        });
    };
    _proto.getSymbol = function getSymbol() {
        var s = _Geometry.prototype.getSymbol.call(this);
        if (!s) {
            var symbols = [];
            var is = false;
            this.forEach(function(g) {
                var symbol = g.getSymbol();
                if (symbol && !is) is = true;
                symbols.push(g.getSymbol());
            });
            if (is) s = {
                'children': symbols
            };
        }
        return s;
    };
    _proto.setSymbol = function setSymbol(s) {
        var _this2 = this;
        if (s && s['children']) {
            this._symbol = null;
            this.forEach(function(g, i) {
                g._eventSymbolProperties = _this2._eventSymbolProperties;
                g.setSymbol(s['children'][i]);
            });
        } else {
            var symbol = this._prepareSymbol(s);
            this._symbol = symbol;
            this.forEach(function(g) {
                g._eventSymbolProperties = _this2._eventSymbolProperties;
                g.setSymbol(symbol);
            });
        }
        this.onSymbolChanged();
        return this;
    };
    _proto._setExternSymbol = function _setExternSymbol(symbol) {
        symbol = this._prepareSymbol(symbol);
        this._externSymbol = symbol;
        this.forEach(function(geometry) {
            geometry._setExternSymbol(symbol);
        });
        this.onSymbolChanged();
        return this;
    };
    _proto._bindLayer = function _bindLayer() {
        _Geometry.prototype._bindLayer.apply(this, arguments);
        this._bindGeometriesToLayer();
    };
    _proto._bindGeometriesToLayer = function _bindGeometriesToLayer() {
        var layer = this.getLayer();
        this.forEach(function(geometry) {
            geometry._bindLayer(layer);
        });
    };
    _proto._checkGeometries = function _checkGeometries(geometries) {
        var invalidGeoError = 'The geometry added to collection is invalid.';
        geometries = Array.isArray(geometries) ? geometries : [
            geometries
        ];
        var filterGeometries = [];
        for(var i = 0, l = geometries.length; i < l; i++){
            var geometry = geometries[i];
            if (!geometry) continue;
            if (!this._checkGeo(geometry)) {
                console.error(invalidGeoError + ' Index: ' + i);
                continue;
            }
            if (isSelf(geometry)) {
                if (!GlobalConfig.isTest) console.error(geometry, ' is GeometryCollection sub class,it Cannot be placed in GeometryCollection');
                continue;
            }
            filterGeometries.push(geometry);
        }
        return filterGeometries;
    };
    _proto._checkGeo = function _checkGeo(geo) {
        return geo instanceof Geometry;
    };
    _proto._updateCache = function _updateCache() {
        this._clearCache();
        if (this.isEmpty()) return;
        this.forEach(function(geometry) {
            if (geometry && geometry._updateCache) geometry._updateCache();
        });
    };
    _proto._removePainter = function _removePainter() {
        if (this._painter) this._painter.remove();
        delete this._painter;
        this.forEach(function(geometry) {
            geometry._removePainter();
        });
    };
    _proto._computeCenter = function _computeCenter(projection) {
        if (!projection || this.isEmpty()) return null;
        var sumX = 0, sumY = 0, counter = 0;
        var geometries = this.getGeometries();
        for(var i = 0, l = geometries.length; i < l; i++){
            if (!geometries[i]) continue;
            var center = geometries[i]._computeCenter(projection);
            if (center) {
                sumX += center.x;
                sumY += center.y;
                counter++;
            }
        }
        if (counter === 0) return null;
        return new Coordinate(sumX / counter, sumY / counter);
    };
    _proto._containsPoint = function _containsPoint(point, t) {
        if (this.isEmpty()) return false;
        delete this._pickGeometryIndex;
        var geometries = this.getGeometries();
        for(var i = 0, l = geometries.length; i < l; i++)if (geometries[i]._containsPoint(point, t)) {
            this._pickGeometryIndex = i;
            return true;
        }
        return false;
    };
    _proto._hitTestTolerance = function _hitTestTolerance() {
        var geometries = this.getGeometries();
        var hitTolerance = 0;
        for(var i = 0, len = geometries.length; i < len; i++){
            var t = geometries[i]._hitTestTolerance();
            hitTolerance = Math.max(hitTolerance, t);
        }
        return hitTolerance;
    };
    _proto._computeExtent = function _computeExtent(projection) {
        return computeExtent.call(this, projection, '_computeExtent');
    };
    _proto._computePrjExtent = function _computePrjExtent(projection) {
        return computeExtent.call(this, projection, '_computePrjExtent');
    };
    _proto._computeGeodesicLength = function _computeGeodesicLength(projection) {
        if (!projection || this.isEmpty()) return 0;
        var geometries = this.getGeometries();
        var result = 0;
        for(var i = 0, l = geometries.length; i < l; i++){
            if (!geometries[i]) continue;
            result += geometries[i]._computeGeodesicLength(projection);
        }
        return result;
    };
    _proto._computeGeodesicArea = function _computeGeodesicArea(projection) {
        if (!projection || this.isEmpty()) return 0;
        var geometries = this.getGeometries();
        var result = 0;
        for(var i = 0, l = geometries.length; i < l; i++){
            if (!geometries[i]) continue;
            result += geometries[i]._computeGeodesicArea(projection);
        }
        return result;
    };
    _proto._exportGeoJSONGeometry = function _exportGeoJSONGeometry() {
        var children = [];
        if (!this.isEmpty()) {
            var geometries = this.getGeometries();
            for(var i = 0, l = geometries.length; i < l; i++){
                if (!geometries[i]) continue;
                children.push(geometries[i]._exportGeoJSONGeometry());
            }
        }
        return {
            'type': 'GeometryCollection',
            'geometries': children
        };
    };
    _proto._toJSON = function _toJSON(options) {
        options = extend$2({}, options);
        var feature = {
            'type': 'Feature',
            'geometry': {
                'type': 'GeometryCollection',
                'geometries': this.getGeometries().filter(function(geo) {
                    return geo && geo._toJSON;
                }).map(function(geo) {
                    var json = geo._toJSON();
                    if (json.subType) return json;
                    return geo._exportGeoJSONGeometry();
                })
            }
        };
        var id = this.getId();
        if (!isNil(id)) feature['id'] = id;
        var properties;
        if (isNil(options['properties']) || options['properties']) properties = this._exportProperties();
        feature['properties'] = properties;
        options.feature = feature;
        return options;
    };
    _proto._clearProjection = function _clearProjection() {
        if (this.isEmpty()) return;
        var geometries = this.getGeometries();
        for(var i = 0, l = geometries.length; i < l; i++){
            if (!geometries[i]) continue;
            geometries[i]._clearProjection();
        }
    };
    _proto._getConnectPoints = function _getConnectPoints() {
        var extent = this.getExtent();
        var anchors = [
            new Coordinate(extent.xmin, extent.ymax),
            new Coordinate(extent.xmax, extent.ymin),
            new Coordinate(extent.xmin, extent.ymin),
            new Coordinate(extent.xmax, extent.ymax)
        ];
        return anchors;
    };
    _proto._getExternalResources = function _getExternalResources() {
        if (this.isEmpty()) return [];
        var geometries = this.getGeometries(), resources = [];
        var cache = {};
        var symbol, res, key;
        for(var i = 0, l = geometries.length; i < l; i++){
            if (!geometries[i]) continue;
            symbol = geometries[i]._getInternalSymbol();
            res = getExternalResources(symbol);
            for(var ii = 0, ll = res.length; ii < ll; ii++){
                key = res[ii].join();
                if (!cache[key]) {
                    resources.push(res[ii]);
                    cache[key] = 1;
                }
            }
        }
        return resources;
    };
    _proto.startEdit = function startEdit(opts) {
        var _this3 = this;
        if (this.isEmpty()) return this;
        if (!opts) opts = {};
        if (opts['symbol']) {
            this._originalSymbol = this.getSymbol();
            this.setSymbol(opts['symbol']);
        }
        this._draggbleBeforeEdit = this.options['draggable'];
        this.config('draggable', false);
        this._recordVisible();
        var geometries = this.getGeometries();
        for(var i = 0, l = geometries.length; i < l; i++)geometries[i].startEdit(opts);
        this._editing = true;
        var layer = this.getLayer();
        var needShadow = layer && layer.options['renderer'] === 'canvas';
        if (needShadow) this.hide();
        setTimeout(function() {
            _this3.fire('editstart');
        }, 1);
        return this;
    };
    _proto.endEdit = function endEdit() {
        if (this.isEmpty()) return this;
        this._recoveryVisible();
        var geometries = this.getGeometries();
        for(var i = 0, l = geometries.length; i < l; i++)geometries[i].endEdit();
        if (this._originalSymbol) {
            this.setSymbol(this._originalSymbol);
            delete this._originalSymbol;
        }
        this._editing = false;
        this.show();
        this.config('draggable', this._draggbleBeforeEdit);
        this.fire('editend');
        return this;
    };
    _proto.isEditing = function isEditing() {
        if (!this._editing) return false;
        return true;
    };
    _proto.undoEdit = function undoEdit() {
        if (this.isEmpty()) return this;
        this._recoveryVisible();
        var geometries = this.getGeometries();
        var i = this._lastUndoEditIndex;
        for(; i < geometries.length; i++)if (!geometries[i].undoEditcheck()) {
            geometries[i].undoEdit();
            this._lastUndoEditIndex = i;
            break;
        }
        if (i === geometries.length) this._lastUndoEditIndex = 0;
        this.fire('undoedit');
        return this;
    };
    _proto.redoEdit = function redoEdit() {
        if (this.isEmpty()) return this;
        this._recoveryVisible();
        var geometries = this.getGeometries();
        var i = this._lastRedoEditIndex;
        for(; i < geometries.length; i++)if (!geometries[i].redoEditcheck()) {
            geometries[i].redoEdit();
            this._lastRedoEditIndex = i;
            break;
        }
        if (i === geometries.length) this._lastRedoEditIndex = 0;
        this.fire('redoedit');
        return this;
    };
    _proto.undoEditcheck = function undoEditcheck() {
        var geometries = this.getGeometries();
        for(var i = 0; i < geometries.length; i++){
            if (!geometries[i].undoEditcheck()) return false;
        }
        return true;
    };
    _proto.redoEditcheck = function redoEditcheck() {
        var geometries = this.getGeometries();
        for(var i = 0; i < geometries.length; i++){
            if (!geometries[i].redoEditcheck()) return false;
        }
        return true;
    };
    return GeometryCollection;
}(Geometry);
GeometryCollection.registerJSONType('GeometryCollection');
function computeExtent(projection, fn) {
    if (this.isEmpty()) return null;
    var extent = new Extent();
    var geometries = this.getGeometries();
    for(var i = 0, l = geometries.length; i < l; i++){
        if (!geometries[i]) continue;
        var e = geometries[i][fn](projection);
        if (e) extent._combine(e);
    }
    return extent;
}
function isSelf(geom) {
    return geom instanceof GeometryCollection;
}
var MultiGeometry = function(_GeometryCollection) {
    function MultiGeometry(geoType, type, data, options) {
        var _this;
        _this = _GeometryCollection.call(this, null, options) || this;
        _this.GeometryType = geoType;
        _this.type = type;
        _this._initData(data);
        return _this;
    }
    _inheritsLoose(MultiGeometry, _GeometryCollection);
    var _proto = MultiGeometry.prototype;
    _proto.getCoordinates = function getCoordinates() {
        var coordinates = [];
        var geometries = this.getGeometries();
        for(var i = 0, l = geometries.length; i < l; i++){
            var child = geometries[i];
            coordinates.push(child.getShell && child.getJSONType() !== 'Polygon' ? [
                child.getShell()
            ] : child.getCoordinates());
        }
        return coordinates;
    };
    _proto.setCoordinates = function setCoordinates(coordinates) {
        coordinates = coordinates || [];
        var geometries = [];
        for(var i = 0, l = coordinates.length; i < l; i++){
            var g = new this.GeometryType(coordinates[i], this.config());
            geometries.push(g);
        }
        this.setGeometries(geometries);
        return this;
    };
    _proto._initData = function _initData(data) {
        data = data || [];
        if (data.length) {
            if (data[0] instanceof this.GeometryType) this.setGeometries(data);
            else this.setCoordinates(data);
        }
    };
    _proto._checkGeo = function _checkGeo(geo) {
        return geo instanceof this.GeometryType;
    };
    _proto._exportGeoJSONGeometry = function _exportGeoJSONGeometry() {
        var points = this.getCoordinates();
        var coordinates = Coordinate.toNumberArrays(points);
        return {
            'type': this.getType(),
            'coordinates': coordinates
        };
    };
    _proto._toJSON = function _toJSON(options) {
        return {
            'feature': this.toGeoJSON(options)
        };
    };
    return MultiGeometry;
}(GeometryCollection);
var MultiPoint = function(_MultiGeometry) {
    function MultiPoint(data, opts) {
        return _MultiGeometry.call(this, Marker, 'MultiPoint', data, opts) || this;
    }
    _inheritsLoose(MultiPoint, _MultiGeometry);
    var _proto = MultiPoint.prototype;
    _proto.findClosest = function findClosest(coordinate) {
        if (!coordinate) return null;
        var coords = this.getCoordinates();
        var hit = null;
        var max = Infinity;
        coords.forEach(function(c) {
            var dist = distanceTo(c, coordinate);
            if (dist < max) {
                hit = c;
                max = dist;
            }
        });
        return hit;
    };
    return MultiPoint;
}(MultiGeometry);
MultiPoint.registerJSONType('MultiPoint');
function distanceTo(p0, p1) {
    var x = p1.x - p0.x, y = p1.y - p0.y;
    return Math.sqrt(x * x + y * y);
}
var MultiPath = function(_MultiGeometry) {
    function MultiPath() {
        return _MultiGeometry.apply(this, arguments) || this;
    }
    _inheritsLoose(MultiPath, _MultiGeometry);
    var _proto = MultiPath.prototype;
    _proto.getCenterInExtent = function getCenterInExtent(extent) {
        var children = this.getGeometries();
        var [sumx, sumy, counter] = [
            0,
            0,
            0
        ];
        children.forEach(function(l) {
            var c = l.getCenterInExtent(extent);
            if (c) {
                sumx += c.x * c.count;
                sumy += c.y * c.count;
                counter += c.count;
            }
        });
        if (counter === 0) return null;
        return new Coordinate(sumx, sumy)._multi(1 / counter);
    };
    return MultiPath;
}(MultiGeometry);
var MultiLineString = function(_MultiPath) {
    function MultiLineString(data, options) {
        return _MultiPath.call(this, LineString, 'MultiLineString', data, options) || this;
    }
    _inheritsLoose(MultiLineString, _MultiPath);
    return MultiLineString;
}(MultiPath);
MultiLineString.registerJSONType('MultiLineString');
var MultiPolygon = function(_MultiPath) {
    function MultiPolygon(data, opts) {
        return _MultiPath.call(this, Polygon, 'MultiPolygon', data, opts) || this;
    }
    _inheritsLoose(MultiPolygon, _MultiPath);
    return MultiPolygon;
}(MultiPath);
MultiPolygon.registerJSONType('MultiPolygon');
var types = {
    'Marker': Marker,
    'LineString': LineString,
    'Polygon': Polygon,
    'MultiPoint': MultiPoint,
    'MultiLineString': MultiLineString,
    'MultiPolygon': MultiPolygon
};
var WORKER_KEY = 'geojson-fetch-worker-page-async';
var WORKER_CODE = "\nfunction (exports) {\n    const resultMap = {};\n\n    function handleResult(msg, postResponse) {\n        const data = msg.data || {};\n        const { taskId } = data;\n        const features = resultMap[taskId];\n        if (!features) {\n            postResponse('not find geojson dataset the taskId:' + taskId);\n            return;\n        }\n        if (features.length === 0) {\n            delete resultMap[taskId];\n            postResponse(null, []);\n            return;\n        }\n        const pageSize = data.pageSize || 2000;\n        const pageFeatures = features.slice(0, pageSize);\n        resultMap[taskId] = features.slice(pageSize, Infinity);\n        postResponse(null, pageFeatures);\n    }\n    //worker init\n    exports.initialize = function () {\n        // console.log(\"geojson fetch init\");\n    };\n    //recive message\n    exports.onmessage = function (msg, postResponse) {\n        const { taskId, type, url } = msg.data || {};\n        if (!taskId) {\n            postResponse('not find task id for get geojson dataset,taskId=' + taskId);\n            return;\n        }\n        if (type === 'fetchdata') {\n            if (!url) {\n                postResponse('url is null,url=' + url);\n                return;\n            }\n            fetch(url).then(res => res.json()).then(geojson => {\n                let features;\n                if (Array.isArray(geojson)) {\n                    features = geojson;\n                } else if (geojson.features) {\n                    features = geojson.features;\n                } else {\n                    features = [geojson];\n                }\n                resultMap[taskId] = features;\n                handleResult(msg, postResponse);\n            }).catch(errror => {\n                postResponse(errror.message);\n            });\n        } else if (type === 'pagefeatures') {\n            handleResult(msg, postResponse);\n        } else {\n            postResponse('not support task type:' + type);\n        }\n    };\n}";
var GeoJSONFetchActor = function(_Actor) {
    function GeoJSONFetchActor() {
        return _Actor.call(this, WORKER_KEY) || this;
    }
    _inheritsLoose(GeoJSONFetchActor, _Actor);
    var _proto = GeoJSONFetchActor.prototype;
    _proto._sendMsg = function _sendMsg(options, featuresList, cb) {
        var _this = this;
        this.send(options, [], function(error, data) {
            if (error) cb(error);
            else _this._pageFeatures(options, data, featuresList, cb);
        }, options.workerId);
    };
    _proto._fetchGeoJSON = function _fetchGeoJSON(url, options, featuresList = [], cb) {
        var opts = extend$2({}, options);
        opts.type = 'fetchdata';
        opts.url = url;
        this._sendMsg(opts, featuresList, cb);
    };
    _proto._pageFeatures = function _pageFeatures(options, features, featuresList, cb) {
        featuresList.push(features);
        if (features.length === 0) {
            cb(null, featuresList);
            return;
        }
        var opts = extend$2({}, options);
        opts.type = 'pagefeatures';
        this._sendMsg(opts, featuresList, cb);
    };
    return GeoJSONFetchActor;
}(Actor);
registerWorkerAdapter(WORKER_KEY, function() {
    return WORKER_CODE;
});
var fetchActor;
var GeoJSON = {
    toGeometry: function toGeometry(geoJSON, foreachFn, filterFn) {
        if (isString(geoJSON)) geoJSON = parseJSON(geoJSON);
        var resultGeos;
        if (Array.isArray(geoJSON)) {
            resultGeos = [];
            for(var i = 0, len = geoJSON.length; i < len; i++){
                var geo = GeoJSON._convert(geoJSON[i], foreachFn);
                if (Array.isArray(geo)) pushIn(resultGeos, geo);
                else resultGeos.push(geo);
            }
        } else resultGeos = GeoJSON._convert(geoJSON, foreachFn);
        if (filterFn && isFunction(filterFn) && Array.isArray(resultGeos)) return resultGeos.filter(filterFn);
        else return resultGeos;
    },
    toGeometryAsync: function toGeometryAsync(geoJSON, foreachFn, countPerTime, filterFn) {
        if (isString(geoJSON)) geoJSON = parseJSON(geoJSON);
        return new Promise(function(resolve) {
            var resultGeos = [];
            if (geoJSON && (Array.isArray(geoJSON) || Array.isArray(geoJSON.features))) {
                var pageSize = isNumber(countPerTime) ? Math.round(countPerTime) : 2000;
                var features = geoJSON.features || geoJSON;
                var count = Math.ceil(features.length / pageSize);
                var page = 1;
                var run = function run() {
                    var startIndex = (page - 1) * pageSize, endIndex = page * pageSize;
                    var fs = features.slice(startIndex, endIndex);
                    var geos = GeoJSON.toGeometry(fs, foreachFn, filterFn);
                    page++;
                    return geos;
                };
                runTaskAsync({
                    count: count,
                    run: run
                }).then(function(geoList) {
                    for(var i = 0, len = geoList.length; i < len; i++){
                        var geo = geoList[i];
                        if (!geo) continue;
                        if (Array.isArray(geo)) pushIn(resultGeos, geo);
                        else resultGeos.push(geo);
                    }
                    resolve(resultGeos);
                });
            } else {
                var geo = GeoJSON.toGeometry(geoJSON, foreachFn);
                resolve(geo);
            }
        });
    },
    _convert: function _convert(json, foreachFn) {
        if (!json || isNil(json['type'])) return null;
        var type = json['type'];
        if (type === 'Feature') {
            var g = json['geometry'];
            var geometry = GeoJSON._convert(g);
            if (!geometry) return null;
            geometry.setId(json['id']);
            geometry.setProperties(json['properties']);
            if (foreachFn) foreachFn(geometry);
            return geometry;
        } else if (type === 'FeatureCollection') {
            var features = json['features'];
            if (!features) return null;
            return GeoJSON.toGeometry(features, foreachFn);
        } else if ([
            'Point',
            'LineString',
            'Polygon',
            'MultiPoint',
            'MultiLineString',
            'MultiPolygon'
        ].indexOf(type) >= 0) {
            var clazz = type === 'Point' ? 'Marker' : type;
            var result = new types[clazz](json['coordinates']);
            if (foreachFn) foreachFn(result);
            return result;
        } else if (type === 'GeometryCollection') {
            var geometries = json['geometries'];
            if (!isArrayHasData(geometries)) {
                var _result = new GeometryCollection();
                if (foreachFn) foreachFn(_result);
                return _result;
            }
            var mGeos = [];
            var size = geometries.length;
            for(var i = 0; i < size; i++)if (geometries[i].subType) mGeos.push(Geometry.getJSONClass(geometries[i].subType).fromJSON(geometries[i]));
            else mGeos.push(GeoJSON._convert(geometries[i]));
            var _result2 = new GeometryCollection(mGeos);
            if (foreachFn) foreachFn(_result2);
            return _result2;
        }
        return null;
    },
    _isGeoJSON: function _isGeoJSON(json) {
        if (!json) return false;
        json = json || {};
        if (Array.isArray(json) && json.length) return GeoJSON.isGeoJSON(json[0]);
        var type = json.type;
        if (!type) return false;
        if (GEOJSON_TYPES.indexOf(type) === -1) return false;
        var { features: features, geometries: geometries, geometry: geometry, coordinates: coordinates } = json;
        if (coordinates && Array.isArray(coordinates)) return true;
        if (Array.isArray(geometries)) return true;
        if (Array.isArray(features)) return true;
        if (geometry) {
            var _coordinates = geometry.coordinates;
            if (_coordinates && Array.isArray(_coordinates)) return true;
        }
        return false;
    },
    fetch: function fetch1(url, countPerTime = 2000) {
        return new Promise(function(resolve, reject) {
            if (!url || !isString(url)) {
                reject('url is error,It should be string');
                return;
            }
            var options = extend$2({
                pageSize: 2000
            }, {
                pageSize: countPerTime
            });
            url = getAbsoluteURL(url);
            if (!fetchActor) fetchActor = new GeoJSONFetchActor();
            var workerCount = fetchActor.workers.length;
            var workerId = Math.floor(Math.random() * workerCount);
            workerId = Math.min(workerCount - 1, workerId);
            options.workerId = workerId;
            options.taskId = GUID();
            fetchActor._fetchGeoJSON(url, options, [], function(error, featuresList) {
                if (error) {
                    reject(error);
                    return;
                }
                var result = [];
                featuresList.forEach(function(features) {
                    for(var i = 0, len = features.length; i < len; i++)result.push(features[i]);
                });
                resolve({
                    type: 'FeatureCollection',
                    features: result
                });
            });
        });
    }
};
var options$x = {
    'numberOfShellPoints': 60
};
var Circle = function(_CenterMixin) {
    function Circle(coordinates, radius, options) {
        var _this;
        _this = _CenterMixin.call(this, null, options) || this;
        if (coordinates) _this.setCoordinates(coordinates);
        _this._radius = radius;
        return _this;
    }
    _inheritsLoose(Circle, _CenterMixin);
    Circle.fromJSON = function fromJSON(json) {
        var feature = json['feature'];
        var circle = new Circle(json['coordinates'], json['radius'], json['options']);
        circle.setProperties(feature['properties']);
        return circle;
    };
    var _proto = Circle.prototype;
    _proto.getRadius = function getRadius() {
        return this._radius;
    };
    _proto.setRadius = function setRadius(radius) {
        this._radius = radius;
        this.onShapeChanged();
        return this;
    };
    _proto.getShell = function getShell() {
        var measurer = this._getMeasurer(), center = this.getCoordinates(), numberOfPoints = this.options['numberOfShellPoints'], radius = this.getRadius();
        var shell = [];
        var rad, dx, dy;
        for(var i = 0, len = numberOfPoints - 1; i < len; i++){
            rad = 360 * i / len * Math.PI / 180;
            dx = radius * Math.cos(rad);
            dy = radius * Math.sin(rad);
            var vertex = measurer.locate(center, dx, dy);
            vertex.z = center.z;
            shell.push(vertex);
        }
        shell.push(shell[0]);
        return shell;
    };
    _proto.getHoles = function getHoles() {
        return [];
    };
    _proto.animateShow = function animateShow() {
        return this.show();
    };
    _proto._containsPoint = function _containsPoint(point, tolerance) {
        var map = this.getMap();
        if (map.getPitch()) return _CenterMixin.prototype._containsPoint.call(this, point, tolerance);
        var center = map._pointToContainerPoint(this._getCenter2DPoint()), size = this.getSize(), t = this._hitTestTolerance() + (tolerance || 0), se = center.add(size.width / 2, size.height / 2);
        return withInEllipse(point, center, se, t);
    };
    _proto._computePrjExtent = function _computePrjExtent(projection) {
        var minmax = this._getMinMax(projection);
        if (!minmax) return null;
        var pcenter = this._getPrjCoordinates();
        var pminmax = minmax.map(function(c) {
            return projection.project(c);
        });
        var leftx = pminmax[0].x - pcenter.x;
        var rightx = pminmax[1].x - pcenter.x;
        var topy = pminmax[2].y - pcenter.y;
        var bottomy = pminmax[3].y - pcenter.y;
        return new Extent(pcenter.add(leftx, topy), pcenter.add(rightx, bottomy));
    };
    _proto._computeExtent = function _computeExtent(measurer) {
        var minmax = this._getMinMax(measurer);
        if (!minmax) return null;
        return new Extent(minmax[0].x, minmax[2].y, minmax[1].x, minmax[3].y, this._getProjection());
    };
    _proto._getMinMax = function _getMinMax(measurer) {
        if (!measurer || !this._coordinates || isNil(this._radius)) return null;
        var radius = this._radius;
        var p1 = measurer.locate(this._coordinates, -radius, 0), p2 = measurer.locate(this._coordinates, radius, 0), p3 = measurer.locate(this._coordinates, 0, radius), p4 = measurer.locate(this._coordinates, 0, -radius);
        return [
            p1,
            p2,
            p3,
            p4
        ];
    };
    _proto._computeGeodesicLength = function _computeGeodesicLength() {
        if (isNil(this._radius)) return 0;
        return Math.PI * 2 * this._radius;
    };
    _proto._computeGeodesicArea = function _computeGeodesicArea() {
        if (isNil(this._radius)) return 0;
        return Math.PI * Math.pow(this._radius, 2);
    };
    _proto._exportGeoJSONGeometry = function _exportGeoJSONGeometry() {
        var coordinates = Coordinate.toNumberArrays([
            this.getShell()
        ]);
        return {
            'type': 'Polygon',
            'coordinates': coordinates
        };
    };
    _proto._toJSON = function _toJSON(options) {
        var center = this.getCenter();
        var opts = extend$2({}, options);
        opts.geometry = false;
        var feature = this.toGeoJSON(opts);
        feature['geometry'] = {
            'type': 'Polygon'
        };
        return {
            'feature': feature,
            'subType': 'Circle',
            'coordinates': center.toArray(),
            'radius': this.getRadius()
        };
    };
    return Circle;
}(CenterMixin(Polygon));
Circle.mergeOptions(options$x);
Circle.registerJSONType('Circle');
function quarticIn(k) {
    return k * k * k * k;
}
function angleT(numberOfShellPoints) {
    var fs = [];
    var ts1 = [];
    for(var i = 0; i < numberOfShellPoints; i++)ts1.push(quarticIn(i / numberOfShellPoints));
    var ts2 = ts1.map(function(t) {
        return t;
    }).reverse();
    var ts = [];
    pushIn(ts, ts1, ts2, ts1, ts2);
    var sum = 0;
    for(var _i = 0, len = ts.length; _i < len; _i += 4){
        fs.push(ts[_i]);
        sum += ts[_i];
    }
    return {
        fs: fs,
        sum: sum
    };
}
var options$w = {
    'numberOfShellPoints': 81
};
var Ellipse = function(_CenterMixin) {
    function Ellipse(coordinates, width, height, options) {
        var _this;
        _this = _CenterMixin.call(this, null, options) || this;
        if (coordinates) _this.setCoordinates(coordinates);
        _this.width = width;
        _this.height = height;
        return _this;
    }
    _inheritsLoose(Ellipse, _CenterMixin);
    Ellipse.fromJSON = function fromJSON(json) {
        var feature = json['feature'];
        var ellipse = new Ellipse(json['coordinates'], json['width'], json['height'], json['options']);
        ellipse.setProperties(feature['properties']);
        return ellipse;
    };
    var _proto = Ellipse.prototype;
    _proto.getWidth = function getWidth() {
        return this.width;
    };
    _proto.setWidth = function setWidth(width) {
        this.width = width;
        this.onShapeChanged();
        return this;
    };
    _proto.getHeight = function getHeight() {
        return this.height;
    };
    _proto.setHeight = function setHeight(height) {
        this.height = height;
        this.onShapeChanged();
        return this;
    };
    _proto.getShell = function getShell() {
        if (this.isRotated()) return this.getRotatedShell();
        return this._getShell();
    };
    _proto._getShell = function _getShell() {
        var measurer = this._getMeasurer(), center = this.getCoordinates(), numberOfPoints = this.options['numberOfShellPoints'] - 1, width = this.getWidth(), height = this.getHeight();
        var shell = [];
        var s = Math.pow(width / 2, 2) * Math.pow(height / 2, 2), sx = Math.pow(width / 2, 2), sy = Math.pow(height / 2, 2);
        var angles = [];
        if (Math.max(width / height, height / width) > 2) {
            var { fs: fs, sum: sum } = angleT(numberOfPoints);
            var dt = 360 / sum;
            var offsetAngle = 0;
            if (height > width) offsetAngle = 90;
            var angle = 0;
            for(var i = 0, len = fs.length; i < len; i++){
                angle += dt * fs[i];
                angles.push(angle + offsetAngle);
            }
        } else for(var _i2 = 0; _i2 < numberOfPoints; _i2++){
            var _angle = 360 * _i2 / numberOfPoints;
            angles.push(_angle);
        }
        if (this.options.debug) console.log(angles);
        var deg, rad, dx, dy;
        for(var _i3 = 0; _i3 < angles.length; _i3++){
            deg = angles[_i3];
            rad = deg * Math.PI / 180;
            dx = Math.sqrt(s / (sx * Math.pow(Math.tan(rad), 2) + sy));
            dy = Math.sqrt(s / (sy * Math.pow(1 / Math.tan(rad), 2) + sx));
            if (deg > 90 && deg < 270) dx *= -1;
            if (deg > 180 && deg < 360) dy *= -1;
            var vertex = measurer.locate(center, dx, dy);
            vertex.z = center.z;
            shell.push(vertex);
        }
        shell.push(shell[0].copy());
        return shell;
    };
    _proto._getPrjShell = function _getPrjShell() {
        var shell = _CenterMixin.prototype._getPrjShell.call(this);
        return this._rotatePrjCoordinates(shell);
    };
    _proto.getHoles = function getHoles() {
        return [];
    };
    _proto.animateShow = function animateShow() {
        return this.show();
    };
    _proto._containsPoint = function _containsPoint(point, tolerance) {
        var map = this.getMap();
        if (map.isTransforming()) return _CenterMixin.prototype._containsPoint.call(this, point, tolerance);
        var projection = map.getProjection();
        var t = this._hitTestTolerance() + (tolerance || 0), pps = projection.projectCoords([
            this._coordinates,
            map.locate(this._coordinates, this.getWidth() / 2, this.getHeight() / 2)
        ], this.options['antiMeridian']), p0 = map.prjToContainerPoint(pps[0]), p1 = map.prjToContainerPoint(pps[1]);
        return withInEllipse(point, p0, p1, t);
    };
    _proto._computePrjExtent = function _computePrjExtent() {
        if (this.isRotated()) return this._computeRotatedPrjExtent();
        return Circle.prototype._computePrjExtent.apply(this, arguments);
    };
    _proto._computeExtent = function _computeExtent() {
        return Circle.prototype._computeExtent.apply(this, arguments);
    };
    _proto._getMinMax = function _getMinMax(measurer) {
        if (!measurer || !this._coordinates || isNil(this.width) || isNil(this.height)) return null;
        var width = this.getWidth(), height = this.getHeight();
        var p1 = measurer.locate(this._coordinates, -width / 2, 0), p2 = measurer.locate(this._coordinates, width / 2, 0), p3 = measurer.locate(this._coordinates, 0, -height / 2), p4 = measurer.locate(this._coordinates, 0, height / 2);
        return [
            p1,
            p2,
            p3,
            p4
        ];
    };
    _proto._computeGeodesicLength = function _computeGeodesicLength() {
        if (isNil(this.width) || isNil(this.height)) return 0;
        var longer = this.width > this.height ? this.width : this.height;
        return 2 * Math.PI * longer / 2 - 4 * Math.abs(this.width - this.height);
    };
    _proto._computeGeodesicArea = function _computeGeodesicArea() {
        if (isNil(this.width) || isNil(this.height)) return 0;
        return Math.PI * this.width * this.height / 4;
    };
    _proto._exportGeoJSONGeometry = function _exportGeoJSONGeometry() {
        var coordinates = Coordinate.toNumberArrays([
            this.getShell()
        ]);
        return {
            'type': 'Polygon',
            'coordinates': coordinates
        };
    };
    _proto._toJSON = function _toJSON(options) {
        var opts = extend$2({}, options);
        var center = this.getCenter();
        opts.geometry = false;
        var feature = this.toGeoJSON(opts);
        feature['geometry'] = {
            'type': 'Polygon'
        };
        return {
            'feature': feature,
            'subType': 'Ellipse',
            'coordinates': center.toArray(),
            'width': this.getWidth(),
            'height': this.getHeight()
        };
    };
    return Ellipse;
}(CenterMixin(Polygon));
Ellipse.mergeOptions(options$w);
Ellipse.registerJSONType('Ellipse');
var Rectangle = function(_Polygon) {
    function Rectangle(coordinates, width, height, opts) {
        var _this;
        _this = _Polygon.call(this, null, opts) || this;
        if (coordinates) _this.setCoordinates(coordinates);
        _this._width = width;
        _this._height = height;
        return _this;
    }
    _inheritsLoose(Rectangle, _Polygon);
    Rectangle.fromJSON = function fromJSON(json) {
        var feature = json['feature'];
        var rect = new Rectangle(json['coordinates'], json['width'], json['height'], json['options']);
        rect.setProperties(feature['properties']);
        return rect;
    };
    var _proto = Rectangle.prototype;
    _proto.getCoordinates = function getCoordinates() {
        return this._coordinates;
    };
    _proto.setCoordinates = function setCoordinates(nw) {
        var newCoordinate = nw instanceof Coordinate ? nw : new Coordinate(nw);
        this._translateRotatePivot(newCoordinate);
        this._coordinates = newCoordinate;
        if (!this._coordinates || !this.getMap()) {
            this.onPositionChanged();
            return this;
        }
        var projection = this._getProjection();
        this._setPrjCoordinates(projection.project(this._coordinates));
        return this;
    };
    _proto.getWidth = function getWidth() {
        return this._width;
    };
    _proto.setWidth = function setWidth(width) {
        this._width = width;
        this.onShapeChanged();
        return this;
    };
    _proto.getHeight = function getHeight() {
        return this._height;
    };
    _proto.setHeight = function setHeight(height) {
        this._height = height;
        this.onShapeChanged();
        return this;
    };
    _proto.getShell = function getShell() {
        if (this.isRotated()) return this.getRotatedShell();
        return this._getShell();
    };
    _proto._getShell = function _getShell() {
        var measurer = this._getMeasurer();
        var nw = this._coordinates;
        var map = this.getMap();
        var sx = 1, sy = -1;
        if (map) {
            var fExt = map.getFullExtent();
            if (fExt['left'] > fExt['right']) sx = -1;
            if (fExt['bottom'] > fExt['top']) sy = 1;
        }
        var points = [];
        points.push(nw);
        var p0 = measurer.locate(nw, sx * this._width, 0);
        p0.z = nw.z;
        points.push(p0);
        var p1 = measurer.locate(nw, sx * this._width, sy * this._height);
        p1.z = nw.z;
        points.push(p1);
        var p2 = measurer.locate(nw, 0, sy * this._height);
        points.push(p2);
        p2.z = nw.z;
        points.push(nw);
        return points;
    };
    _proto.getHoles = function getHoles() {
        return [];
    };
    _proto.animateShow = function animateShow() {
        return this.show();
    };
    _proto._getPrjCoordinates = function _getPrjCoordinates() {
        var projection = this._getProjection();
        this._verifyProjection();
        if (!this._pnw && projection) {
            if (this._coordinates) this._pnw = projection.project(this._coordinates);
        }
        return this._pnw;
    };
    _proto._setPrjCoordinates = function _setPrjCoordinates(pnw) {
        this._pnw = pnw;
        this.onPositionChanged();
    };
    _proto._getPrjShell = function _getPrjShell() {
        var shell = _Polygon.prototype._getPrjShell.call(this);
        var projection = this._getProjection();
        if (!projection.isSphere()) return this._rotatePrjCoordinates(shell);
        var sphereExtent = projection.getSphereExtent(), sx = sphereExtent.sx, sy = sphereExtent.sy;
        var circum = this._getProjection().getCircum();
        var nw = shell[0];
        for(var i = 1, l = shell.length; i < l; i++){
            var p = shell[i];
            var dx = 0, dy = 0;
            if (sx * (nw.x - p.x) > 0) dx = circum.x * sx;
            if (sy * (nw.y - p.y) < 0) dy = circum.y * sy;
            shell[i]._add(dx, dy);
        }
        return this._rotatePrjCoordinates(shell);
    };
    _proto._updateCache = function _updateCache() {
        this._clearCache();
        var projection = this._getProjection();
        if (this._pnw && projection) this._coordinates = projection.unproject(this._pnw);
    };
    _proto._clearProjection = function _clearProjection() {
        this._pnw = null;
        _Polygon.prototype._clearProjection.call(this);
    };
    _proto._computeCenter = function _computeCenter(measurer) {
        return measurer.locate(this._coordinates, this._width / 2, -this._height / 2);
    };
    _proto._containsPoint = function _containsPoint(point, tolerance) {
        var map = this.getMap();
        if (map.isTransforming()) return _Polygon.prototype._containsPoint.call(this, point, tolerance);
        var t = isNil(tolerance) ? this._hitTestTolerance() : tolerance, r = map._getResolution() * t;
        var extent = this._getPrjExtent().expand(r);
        var p = map._containerPointToPrj(point);
        return extent.contains(p);
    };
    _proto._computePrjExtent = function _computePrjExtent(projection) {
        if (this.isRotated()) return this._computeRotatedPrjExtent();
        var se = this._getSouthEast(projection);
        if (!se) return null;
        var prjs = projection.projectCoords([
            new Coordinate(this._coordinates.x, se.y),
            new Coordinate(se.x, this._coordinates.y)
        ], this.options['antiMeridian']);
        return new Extent(prjs[0], prjs[1]);
    };
    _proto._computeExtent = function _computeExtent(measurer) {
        var se = this._getSouthEast(measurer);
        if (!se) return null;
        return new Extent(this._coordinates, se, this._getProjection());
    };
    _proto._getSouthEast = function _getSouthEast(measurer) {
        if (!measurer || !this._coordinates || isNil(this._width) || isNil(this._height)) return null;
        var width = this.getWidth(), height = this.getHeight();
        var w = width, h = -height;
        if (measurer.fullExtent) {
            var fullExtent = measurer.fullExtent, sx = fullExtent.right > fullExtent.left ? 1 : -1, sy = fullExtent.top > fullExtent.bottom ? 1 : -1;
            w *= sx;
            h *= sy;
        }
        var rightPoint = measurer.locate(this._coordinates, w, 0);
        var bottomPoint = measurer.locate(this._coordinates, 0, h);
        rightPoint.y = bottomPoint.y;
        return rightPoint;
    };
    _proto._computeGeodesicLength = function _computeGeodesicLength() {
        if (isNil(this._width) || isNil(this._height)) return 0;
        return 2 * (this._width + this._height);
    };
    _proto._computeGeodesicArea = function _computeGeodesicArea() {
        if (isNil(this._width) || isNil(this._height)) return 0;
        return this._width * this._height;
    };
    _proto._exportGeoJSONGeometry = function _exportGeoJSONGeometry() {
        var coordinates = Coordinate.toNumberArrays([
            this.getShell()
        ]);
        return {
            'type': 'Polygon',
            'coordinates': coordinates
        };
    };
    _proto._toJSON = function _toJSON(options) {
        var opts = extend$2({}, options);
        var nw = this.getCoordinates();
        opts.geometry = false;
        var feature = this.toGeoJSON(opts);
        feature['geometry'] = {
            'type': 'Polygon'
        };
        return {
            'feature': feature,
            'subType': 'Rectangle',
            'coordinates': nw.toArray(),
            'width': this.getWidth(),
            'height': this.getHeight()
        };
    };
    return Rectangle;
}(Polygon);
Rectangle.registerJSONType('Rectangle');
var options$v = {
    'numberOfShellPoints': 60
};
var Sector = function(_Circle) {
    function Sector(coordinates, radius, startAngle, endAngle, opts) {
        var _this;
        _this = _Circle.call(this, coordinates, radius, opts) || this;
        _this.startAngle = startAngle;
        _this.endAngle = endAngle;
        return _this;
    }
    _inheritsLoose(Sector, _Circle);
    Sector.fromJSON = function fromJSON(json) {
        var feature = json['feature'];
        var sector = new Sector(json['coordinates'], json['radius'], json['startAngle'], json['endAngle'], json['options']);
        sector.setProperties(feature['properties']);
        return sector;
    };
    var _proto = Sector.prototype;
    _proto.getStartAngle = function getStartAngle() {
        return this.startAngle;
    };
    _proto.setStartAngle = function setStartAngle(startAngle) {
        this.startAngle = startAngle;
        this.onShapeChanged();
        return this;
    };
    _proto.getEndAngle = function getEndAngle() {
        return this.endAngle;
    };
    _proto.setEndAngle = function setEndAngle(endAngle) {
        this.endAngle = endAngle;
        this.onShapeChanged();
        return this;
    };
    _proto._correctAngles = function _correctAngles() {
        var startAngle = this.getStartAngle(), endAngle = this.getEndAngle();
        if (endAngle < startAngle) {
            console.error('The ending angle should be greater than the starting angle ', startAngle, endAngle);
            return [
                0,
                0
            ];
        }
        var angle = 360;
        if (endAngle - startAngle > angle) {
            console.error('The difference between the end angle and the start angle is greater than 360 degrees ', startAngle, endAngle);
            return [
                0,
                0
            ];
        }
        if (startAngle < 0) {
            startAngle += angle;
            endAngle += angle;
        }
        return [
            startAngle,
            endAngle
        ];
    };
    _proto.getShell = function getShell() {
        if (this.isRotated()) return this.getRotatedShell();
        return this._getShell();
    };
    _proto._getShell = function _getShell() {
        var [startAngle, endAngle] = this._correctAngles();
        var measurer = this._getMeasurer(), center = this.getCoordinates(), numberOfPoints = this.options['numberOfShellPoints'] - 2, radius = this.getRadius(), shell = [
            center.copy()
        ], angle = endAngle - startAngle;
        var rad, dx, dy;
        for(var i = 0; i < numberOfPoints; i++){
            rad = (angle * i / (numberOfPoints - 1) + startAngle) * Math.PI / 180;
            dx = radius * Math.cos(rad);
            dy = radius * Math.sin(rad);
            var vertex = measurer.locate(center, dx, dy);
            vertex.z = center.z;
            shell.push(vertex);
        }
        shell.push(center.copy());
        return shell;
    };
    _proto.getRotateOffsetAngle = function getRotateOffsetAngle() {
        return 90;
    };
    _proto._getPrjShell = function _getPrjShell() {
        var shell = _Circle.prototype._getPrjShell.call(this);
        return this._rotatePrjCoordinates(shell);
    };
    _proto._computePrjExtent = function _computePrjExtent() {
        if (this.isRotated()) return this._computeRotatedPrjExtent();
        return Circle.prototype._computePrjExtent.apply(this, arguments);
    };
    _proto._containsPoint = function _containsPoint(point, tolerance) {
        var map = this.getMap();
        if (map.isTransforming()) return _Circle.prototype._containsPoint.call(this, point, tolerance);
        var center = map._pointToContainerPoint(this._getCenter2DPoint()), t = this._hitTestTolerance() + (tolerance || 0), size = this.getSize(), pc = center, pp = point, x = pp.x - pc.x, y = pc.y - pp.y, atan2 = Math.atan2(y, x), angle = atan2 < 0 ? (atan2 + 2 * Math.PI) * 360 / (2 * Math.PI) : atan2 * 360 / (2 * Math.PI);
        var [startAngle, endAngle] = this._correctAngles();
        var sAngle = startAngle % 360, eAngle = endAngle % 360;
        var between = false;
        if (sAngle > eAngle) between = !(angle > eAngle && angle < sAngle);
        else between = angle >= sAngle && angle <= eAngle;
        return pp.distanceTo(pc) <= size.width / 2 + t && between;
    };
    _proto._computeGeodesicLength = function _computeGeodesicLength() {
        if (isNil(this._radius)) return 0;
        var [startAngle, endAngle] = this._correctAngles();
        return Math.PI * 2 * this._radius * Math.abs(startAngle - endAngle) / 360 + 2 * this._radius;
    };
    _proto._computeGeodesicArea = function _computeGeodesicArea() {
        if (isNil(this._radius)) return 0;
        var [startAngle, endAngle] = this._correctAngles();
        return Math.PI * Math.pow(this._radius, 2) * Math.abs(startAngle - endAngle) / 360;
    };
    _proto._toJSON = function _toJSON(options) {
        var opts = extend$2({}, options);
        var center = this.getCenter();
        opts.geometry = false;
        var feature = this.toGeoJSON(opts);
        feature['geometry'] = {
            'type': 'Polygon'
        };
        return {
            'feature': feature,
            'subType': 'Sector',
            'coordinates': center.toArray(),
            'radius': this.getRadius(),
            'startAngle': this.getStartAngle(),
            'endAngle': this.getEndAngle()
        };
    };
    return Sector;
}(Circle);
Sector.mergeOptions(options$v);
Sector.registerJSONType('Sector');
var options$u = {
    'enableSimplify': false,
    'enableClip': false
};
var Curve = function(_LineString) {
    function Curve() {
        return _LineString.apply(this, arguments) || this;
    }
    _inheritsLoose(Curve, _LineString);
    var _proto = Curve.prototype;
    _proto._arc = function _arc(ctx, points, lineOpacity) {
        var arcDegree = this.options['arcDegree'];
        if (arcDegree === 0) arcDegree = 1;
        var degree = arcDegree * Math.PI / 180;
        for(var i = 1, l = points.length; i < l; i++){
            Canvas._arcBetween(ctx, points[i - 1], points[i], degree);
            Canvas._stroke(ctx, lineOpacity);
        }
    };
    _proto._quadraticCurve = function _quadraticCurve(ctx, points) {
        if (points.length <= 2) {
            Canvas._path(ctx, points);
            return;
        }
        var i, l;
        for(i = 2, l = points.length; i < l; i += 2)ctx.quadraticCurveTo(points[i - 1].x, points[i - 1].y, points[i].x, points[i].y);
        i -= 1;
        if (i < l) for(; i < l; i++)ctx.lineTo(points[i].x, points[i].y);
    };
    _proto._bezierCurve = function _bezierCurve(ctx, points) {
        if (points.length <= 3) {
            Canvas._path(ctx, points);
            return;
        }
        var i, l;
        for(i = 1, l = points.length; i + 2 < l; i += 3)ctx.bezierCurveTo(points[i].x, points[i].y, points[i + 1].x, points[i + 1].y, points[i + 2].x, points[i + 2].y);
        if (i < l) for(; i < l; i++)ctx.lineTo(points[i].x, points[i].y);
    };
    _proto._getCurveArrowPoints = function _getCurveArrowPoints(arrows, segments, lineWidth, arrowStyle, tolerance, step) {
        var l = segments.length;
        var i;
        for(i = step; i < l; i += step){
            var arrow = this._getArrowShape(segments[i - 1], segments[i], lineWidth, arrowStyle, tolerance);
            if (arrow) arrows.push(arrow);
        }
        i -= step;
        if (i < l - 1) for(i += 1; i < l; i++){
            var _arrow = this._getArrowShape(segments[i - 1], segments[i], lineWidth, arrowStyle, tolerance);
            if (_arrow) arrows.push(_arrow);
        }
    };
    return Curve;
}(LineString);
Curve.mergeOptions(options$u);
var options$t = {
    'arcDegree': 90
};
var ArcCurve = function(_Curve) {
    function ArcCurve() {
        return _Curve.apply(this, arguments) || this;
    }
    _inheritsLoose(ArcCurve, _Curve);
    var _proto = ArcCurve.prototype;
    _proto._toJSON = function _toJSON(options) {
        return {
            'feature': this.toGeoJSON(options),
            'subType': 'ArcCurve'
        };
    };
    _proto._paintOn = function _paintOn(ctx, points, lineOpacity) {
        ctx.beginPath();
        this._arc(ctx, points, lineOpacity);
        Canvas._stroke(ctx, lineOpacity);
        this._paintArrow(ctx, points, lineOpacity);
    };
    ArcCurve.fromJSON = function fromJSON(json) {
        var feature = json['feature'];
        var arc = new ArcCurve(feature['geometry']['coordinates'], json['options']);
        arc.setProperties(feature['properties']);
        return arc;
    };
    return ArcCurve;
}(Curve);
ArcCurve.registerJSONType('ArcCurve');
ArcCurve.mergeOptions(options$t);
var CubicBezierCurve = function(_Curve) {
    function CubicBezierCurve() {
        return _Curve.apply(this, arguments) || this;
    }
    _inheritsLoose(CubicBezierCurve, _Curve);
    CubicBezierCurve.fromJSON = function fromJSON(json) {
        var feature = json['feature'];
        var curve = new CubicBezierCurve(feature['geometry']['coordinates'], json['options']);
        curve.setProperties(feature['properties']);
        return curve;
    };
    var _proto = CubicBezierCurve.prototype;
    _proto._toJSON = function _toJSON(options) {
        return {
            'feature': this.toGeoJSON(options),
            'subType': 'CubicBezierCurve'
        };
    };
    _proto._paintOn = function _paintOn(ctx, points, lineOpacity) {
        ctx.beginPath();
        ctx.moveTo(points[0].x, points[0].y);
        this._bezierCurve(ctx, points);
        Canvas._stroke(ctx, lineOpacity);
        this._paintArrow(ctx, points, lineOpacity);
    };
    _proto._getArrowPoints = function _getArrowPoints(arrows, segments, lineWidth, arrowStyle, tolerance) {
        return this._getCurveArrowPoints(arrows, segments, lineWidth, arrowStyle, tolerance, 3);
    };
    return CubicBezierCurve;
}(Curve);
CubicBezierCurve.registerJSONType('CubicBezierCurve');
var QuadBezierCurve = function(_Curve) {
    function QuadBezierCurve() {
        return _Curve.apply(this, arguments) || this;
    }
    _inheritsLoose(QuadBezierCurve, _Curve);
    QuadBezierCurve.fromJSON = function fromJSON(json) {
        var feature = json['feature'];
        var curve = new QuadBezierCurve(feature['geometry']['coordinates'], json['options']);
        curve.setProperties(feature['properties']);
        return curve;
    };
    var _proto = QuadBezierCurve.prototype;
    _proto._toJSON = function _toJSON(options) {
        return {
            'feature': this.toGeoJSON(options),
            'subType': 'QuadBezierCurve'
        };
    };
    _proto._paintOn = function _paintOn(ctx, points, lineOpacity) {
        ctx.beginPath();
        ctx.moveTo(points[0].x, points[0].y);
        this._quadraticCurve(ctx, points, lineOpacity);
        Canvas._stroke(ctx, lineOpacity);
        this._paintArrow(ctx, points, lineOpacity);
    };
    _proto._getArrowPoints = function _getArrowPoints(arrows, segments, lineWidth, arrowStyle, tolerance) {
        return this._getCurveArrowPoints(arrows, segments, lineWidth, arrowStyle, tolerance, 2);
    };
    return QuadBezierCurve;
}(Curve);
QuadBezierCurve.registerJSONType('QuadBezierCurve');
var defaultSymbol = {
    'textFaceName': 'monospace',
    'textSize': 12,
    'textLineSpacing': 8,
    'textWrapCharacter': '\n',
    'textHorizontalAlignment': 'middle',
    'textVerticalAlignment': 'middle'
};
var defaultBoxSymbol = {
    'markerType': 'square',
    'markerLineColor': '#000',
    'markerLineWidth': 2,
    'markerLineOpacity': 1,
    'markerFill': '#fff',
    'markerOpacity': 1
};
var TextMarker = function(_Marker) {
    function TextMarker() {
        return _Marker.apply(this, arguments) || this;
    }
    _inheritsLoose(TextMarker, _Marker);
    var _proto = TextMarker.prototype;
    _proto.getContent = function getContent() {
        return this._content;
    };
    _proto.setContent = function setContent(content) {
        var old = this._content;
        this._content = escapeSpecialChars(content);
        this._refresh();
        this._fireEvent('contentchange', {
            'old': old,
            'new': content
        });
        return this;
    };
    _proto.onAdd = function onAdd() {
        this._refresh();
    };
    _proto.toJSON = function toJSON() {
        var json = _Marker.prototype.toJSON.call(this);
        delete json['symbol'];
        return json;
    };
    _proto.setSymbol = function setSymbol(symbol) {
        if (this._refreshing || !symbol) return _Marker.prototype.setSymbol.call(this, symbol);
        var s = this._parseSymbol(symbol);
        if (this.setTextStyle) {
            var style = this.getTextStyle() || {};
            style.symbol = s[0];
            this.setTextStyle(style);
        } else if (this.setTextSymbol) this.setTextSymbol(s[0]);
        if (this.setBoxStyle) {
            var _style = this.getBoxStyle() || {};
            _style.symbol = s[1];
            this.setBoxStyle(_style);
        } else if (this.setBoxSymbol) this.setBoxSymbol(s[1]);
        return this;
    };
    _proto._parseSymbol = function _parseSymbol(symbol) {
        var t = {};
        var b = {};
        for(var p in symbol)if (hasOwn(symbol, p)) {
            if (p.indexOf('text') === 0) t[p] = symbol[p];
            else b[p] = symbol[p];
        }
        return [
            t,
            b
        ];
    };
    _proto._getTextSize = function _getTextSize(symbol) {
        return splitTextToRow(this._content, symbol)['size'];
    };
    _proto._getInternalSymbol = function _getInternalSymbol() {
        return this._symbol;
    };
    _proto._getDefaultTextSymbol = function _getDefaultTextSymbol() {
        return extend$2({}, defaultSymbol);
    };
    _proto._getDefaultBoxSymbol = function _getDefaultBoxSymbol() {
        return extend$2({}, defaultBoxSymbol);
    };
    _proto._getDefaultPadding = function _getDefaultPadding() {
        return [
            12,
            8
        ];
    };
    return TextMarker;
}(Marker);
var options$s = {
    'textStyle': {
        'wrap': true,
        'padding': [
            12,
            8
        ],
        'verticalAlignment': 'middle',
        'horizontalAlignment': 'middle'
    },
    'boxSymbol': null
};
var TextBox = function(_TextMarker) {
    function TextBox(content, coordinates, width, height, options = {}) {
        var _this;
        _this = _TextMarker.call(this, coordinates, options) || this;
        _this._content = escapeSpecialChars(content);
        _this._width = isNil(width) ? 100 : width;
        _this._height = isNil(height) ? 40 : height;
        if (options.boxSymbol) _this.setBoxSymbol(options.boxSymbol);
        if (options.textStyle) _this.setTextStyle(options.textStyle);
        _this._refresh();
        return _this;
    }
    _inheritsLoose(TextBox, _TextMarker);
    var _proto = TextBox.prototype;
    _proto.getWidth = function getWidth() {
        return this._width;
    };
    _proto.setWidth = function setWidth(width) {
        this._width = width;
        this._refresh();
        return this;
    };
    _proto.getHeight = function getHeight() {
        return this._height;
    };
    _proto.setHeight = function setHeight(height) {
        this._height = height;
        this._refresh();
        return this;
    };
    _proto.getBoxSymbol = function getBoxSymbol() {
        return extend$2({}, this.options.boxSymbol);
    };
    _proto.setBoxSymbol = function setBoxSymbol(symbol) {
        this.options.boxSymbol = symbol ? extend$2({}, symbol) : symbol;
        if (this.getSymbol()) this._refresh();
        return this;
    };
    _proto.getTextStyle = function getTextStyle() {
        if (!this.options.textStyle) return null;
        return extend$2({}, this.options.textStyle);
    };
    _proto.setTextStyle = function setTextStyle(style) {
        this.options.textStyle = style ? extend$2({}, style) : style;
        if (this.getSymbol()) this._refresh();
        return this;
    };
    TextBox.fromJSON = function fromJSON(json) {
        var feature = json['feature'];
        var textBox = new TextBox(json['content'], feature['geometry']['coordinates'], json['width'], json['height'], json['options']);
        textBox.setProperties(feature['properties']);
        textBox.setId(feature['id']);
        if (json['symbol']) textBox.setSymbol(json['symbol']);
        return textBox;
    };
    _proto._toJSON = function _toJSON(options) {
        return {
            'feature': this.toGeoJSON(options),
            'width': this.getWidth(),
            'height': this.getHeight(),
            'subType': 'TextBox',
            'content': this._content
        };
    };
    _proto._refresh = function _refresh() {
        var textStyle = this.getTextStyle() || {}, padding = textStyle['padding'] || [
            12,
            8
        ];
        var maxWidth, maxHeight;
        if (isFunctionDefinition(this._width)) {
            maxWidth = JSON.parse(JSON.stringify(this._width));
            var stops = maxWidth.stops;
            if (stops) for(var i = 0; i < stops.length; i++)stops[i][1] = stops[i][1] - 2 * padding[0];
        } else maxWidth = this._width - 2 * padding[0];
        if (isFunctionDefinition(this._height)) {
            maxHeight = JSON.parse(JSON.stringify(this._height));
            var _stops = maxHeight.stops;
            if (_stops) for(var _i = 0; _i < _stops.length; _i++)_stops[_i][1] = _stops[_i][1] - 2 * padding[1];
        } else maxHeight = this._height - 2 * padding[1];
        var symbol = extend$2({}, textStyle.symbol || this._getDefaultTextSymbol(), this.options.boxSymbol || this._getDefaultBoxSymbol(), {
            'textName': this._content,
            'markerWidth': this._width,
            'markerHeight': this._height,
            'textHorizontalAlignment': 'middle',
            'textVerticalAlignment': 'middle',
            'textMaxWidth': maxWidth,
            'textMaxHeight': maxHeight
        });
        if (textStyle['wrap'] && !symbol['textWrapWidth']) symbol['textWrapWidth'] = maxWidth;
        var hAlign = textStyle['horizontalAlignment'];
        symbol['textDx'] = symbol['markerDx'] || 0;
        var offsetX;
        if (isFunctionDefinition(this._width)) {
            offsetX = JSON.parse(JSON.stringify(this._width));
            var _stops2 = offsetX.stops;
            if (_stops2) for(var _i2 = 0; _i2 < _stops2.length; _i2++){
                _stops2[_i2][1] = _stops2[_i2][1] / 2 - padding[0];
                if (hAlign === 'left') _stops2[_i2][1] *= -1;
            }
        } else {
            offsetX = symbol['markerWidth'] / 2 - padding[0];
            if (hAlign === 'left') offsetX *= -1;
        }
        if (hAlign === 'left') {
            symbol['textHorizontalAlignment'] = 'right';
            symbol['textDx'] = offsetX;
        } else if (hAlign === 'right') {
            symbol['textHorizontalAlignment'] = 'left';
            symbol['textDx'] = offsetX;
        }
        var vAlign = textStyle['verticalAlignment'];
        symbol['textDy'] = symbol['markerDy'] || 0;
        var offsetY;
        if (isFunctionDefinition(this._height)) {
            offsetY = JSON.parse(JSON.stringify(this._height));
            var _stops3 = offsetY.stops;
            if (_stops3) for(var _i3 = 0; _i3 < _stops3.length; _i3++){
                _stops3[_i3][1] = _stops3[_i3][1] / 2 - padding[1];
                if (vAlign === 'top') _stops3[_i3][1] *= -1;
            }
        } else {
            offsetY = symbol['markerHeight'] / 2 - padding[1];
            if (vAlign === 'top') offsetY *= -1;
        }
        if (vAlign === 'top') {
            symbol['textVerticalAlignment'] = 'bottom';
            symbol['textDy'] = offsetY;
        } else if (vAlign === 'bottom') {
            symbol['textVerticalAlignment'] = 'top';
            symbol['textDy'] = offsetY;
        }
        this._refreshing = true;
        this.updateSymbol(symbol);
        delete this._refreshing;
    };
    _proto.startEdit = function startEdit(opts) {
        var symbol = this._getCompiledSymbol();
        if (isFunctionDefinition(this._width)) {
            var markerWidth = symbol['markerWidth'];
            this._oldWidth = this._width;
            this.setWidth(markerWidth);
        }
        if (isFunctionDefinition(this._height)) {
            var markerHeight = symbol['markerHeight'];
            this._oldHeight = this._height;
            this.setHeight(markerHeight);
        }
        return _TextMarker.prototype.startEdit.call(this, opts);
    };
    _proto.endEdit = function endEdit() {
        var map = this.getMap();
        var zoom = map && map.getZoom();
        if (this._oldWidth) {
            var markerWidth = this._width;
            var widthFn = interpolated(this._oldWidth);
            var oldExpectedWidth = widthFn(zoom);
            var scale = markerWidth / oldExpectedWidth;
            var stops = this._oldWidth.stops;
            for(var i = 0; i < stops.length; i++)stops[i][1] *= scale;
            this.setWidth(this._oldWidth);
            delete this._oldWidth;
        }
        if (this._oldHeight) {
            var markerHeight = this._height;
            var heightFn = interpolated(this._oldHeight);
            var oldExpectedHeight = heightFn(zoom);
            var _scale = markerHeight / oldExpectedHeight;
            var _stops4 = this._oldHeight.stops;
            for(var _i4 = 0; _i4 < _stops4.length; _i4++)_stops4[_i4][1] *= _scale;
            this.setHeight(this._oldHeight);
            delete this._oldHeight;
        }
        return _TextMarker.prototype.endEdit.call(this);
    };
    return TextBox;
}(TextMarker);
TextBox.mergeOptions(options$s);
TextBox.registerJSONType('TextBox');
var options$r = {
    'boxStyle': null,
    textSymbol: null
};
var Label = function(_TextMarker) {
    function Label(content, coordinates, options = {}) {
        var _this;
        _this = _TextMarker.call(this, coordinates, options) || this;
        if (options.textSymbol) _this.setTextSymbol(options.textSymbol);
        if (options.boxStyle) _this.setBoxStyle(options.boxStyle);
        _this._content = escapeSpecialChars(content);
        _this._refresh();
        return _this;
    }
    _inheritsLoose(Label, _TextMarker);
    var _proto = Label.prototype;
    _proto.getBoxStyle = function getBoxStyle() {
        if (!this.options.boxStyle) return null;
        return extend$2({}, this.options.boxStyle);
    };
    _proto.setBoxStyle = function setBoxStyle(style) {
        this.options.boxStyle = style ? extend$2({}, style) : style;
        this._refresh();
        return this;
    };
    _proto.getTextSymbol = function getTextSymbol() {
        return extend$2({}, this._getDefaultTextSymbol(), this.options.textSymbol);
    };
    _proto.setTextSymbol = function setTextSymbol(symbol) {
        this.options.textSymbol = symbol ? extend$2({}, symbol) : symbol;
        this._refresh();
        return this;
    };
    Label.fromJSON = function fromJSON(json) {
        var feature = json['feature'];
        var label = new Label(json['content'], feature['geometry']['coordinates'], json['options']);
        label.setProperties(feature['properties']);
        label.setId(feature['id']);
        if (json['symbol']) label.setSymbol(json['symbol']);
        return label;
    };
    _proto._canEdit = function _canEdit() {
        return false;
    };
    _proto._toJSON = function _toJSON(options) {
        return {
            'feature': this.toGeoJSON(options),
            'subType': 'Label',
            'content': this._content
        };
    };
    _proto._refresh = function _refresh() {
        var symbol = extend$2({}, this.getTextSymbol(), {
            'textName': this._content
        });
        var boxStyle = this.getBoxStyle();
        if (boxStyle) {
            extend$2(symbol, boxStyle.symbol);
            var sizes = this._getBoxSize(symbol), textSize = sizes[1], padding = boxStyle['padding'] || this._getDefaultPadding();
            var boxSize = sizes[0];
            symbol['markerWidth'] = boxSize['width'];
            symbol['markerHeight'] = boxSize['height'];
            var dx = symbol['textDx'] || 0, dy = symbol['textDy'] || 0, textAlignPoint = getAlignPoint(textSize, symbol['textHorizontalAlignment'], symbol['textVerticalAlignment'])._add(dx, dy);
            var hAlign = boxStyle['horizontalAlignment'] || 'middle';
            symbol['markerDx'] = textAlignPoint.x;
            if (hAlign === 'left') symbol['markerDx'] += symbol['markerWidth'] / 2 - padding[0];
            else if (hAlign === 'right') symbol['markerDx'] -= symbol['markerWidth'] / 2 - textSize['width'] - padding[0];
            else symbol['markerDx'] += textSize['width'] / 2;
            var vAlign = boxStyle['verticalAlignment'] || 'middle';
            symbol['markerDy'] = textAlignPoint.y;
            if (vAlign === 'top') symbol['markerDy'] += symbol['markerHeight'] / 2 - padding[1];
            else if (vAlign === 'bottom') symbol['markerDy'] -= symbol['markerHeight'] / 2 - textSize['height'] - padding[1];
            else symbol['markerDy'] += textSize['height'] / 2;
        }
        this._refreshing = true;
        this.updateSymbol(symbol);
        delete this._refreshing;
    };
    _proto._getBoxSize = function _getBoxSize(symbol) {
        if (!symbol['markerType']) symbol['markerType'] = 'square';
        var boxStyle = this.getBoxStyle();
        var size = this._getTextSize(symbol);
        var width, height;
        var padding = boxStyle['padding'] || this._getDefaultPadding();
        width = size['width'] + padding[0] * 2;
        height = size['height'] + padding[1] * 2;
        if (boxStyle['minWidth']) {
            if (!width || width < boxStyle['minWidth']) width = boxStyle['minWidth'];
        }
        if (boxStyle['minHeight']) {
            if (!height || height < boxStyle['minHeight']) height = boxStyle['minHeight'];
        }
        return [
            new Size(width, height),
            size
        ];
    };
    return Label;
}(TextMarker);
Label.mergeOptions(options$r);
Label.registerJSONType('Label');
var Connectable = function Connectable(Base) {
    return function(_Base) {
        function _class(...args) {
            return _Base.call(this, ...args) || this;
        }
        _inheritsLoose(_class, _Base);
        _class._hasConnectors = function _hasConnectors(geometry) {
            return !isNil(geometry.__connectors) && geometry.__connectors.length > 0;
        };
        _class._getConnectors = function _getConnectors(geometry) {
            return geometry.__connectors;
        };
        var _proto = _class.prototype;
        _proto.getConnectSource = function getConnectSource() {
            return this._connSource;
        };
        _proto.setConnectSource = function setConnectSource(src) {
            var target = this._connTarget;
            this.onRemove();
            this._connSource = src;
            this._connTarget = target;
            this.onAdd();
            return this;
        };
        _proto.getConnectTarget = function getConnectTarget() {
            return this._connTarget;
        };
        _proto.setConnectTarget = function setConnectTarget(target) {
            var src = this._connSource;
            this.onRemove();
            this._connSource = src;
            this._connTarget = target;
            this._updateCoordinates();
            this._registerEvents();
            return this;
        };
        _proto._updateCoordinates = function _updateCoordinates() {
            var map = this.getMap();
            if (!map && this._connSource) map = this._connSource.getMap();
            if (!map && this._connTarget) map = this._connTarget.getMap();
            if (!map) return;
            if (!this._connSource || !this._connTarget) return;
            var srcPoints = this._connSource._getConnectPoints();
            var targetPoints = this._connTarget._getConnectPoints();
            var minDist = 0;
            var oldCoordinates = this.getCoordinates();
            var c1, c2;
            for(var i = 0, len = srcPoints.length; i < len; i++){
                var p1 = srcPoints[i];
                for(var j = 0, length = targetPoints.length; j < length; j++){
                    var p2 = targetPoints[j];
                    var dist = map.computeLength(p1, p2);
                    if (i === 0 && j === 0) {
                        c1 = p1;
                        c2 = p2;
                        minDist = dist;
                    } else if (dist < minDist) {
                        c1 = p1;
                        c2 = p2;
                    }
                }
            }
            if (!isArrayHasData(oldCoordinates) || !oldCoordinates[0].equals(c1) || !oldCoordinates[1].equals(c2)) this.setCoordinates([
                c1,
                c2
            ]);
        };
        _proto.onAdd = function onAdd() {
            this._registerEvents();
            this._updateCoordinates();
        };
        _proto.onRemove = function onRemove() {
            if (this._connSource) {
                if (this._connSource.__connectors) removeFromArray(this, this._connSource.__connectors);
                this._connSource.off('dragging positionchange', this._updateCoordinates, this).off('remove', this.onRemove, this);
                this._connSource.off('dragstart mousedown mouseover', this._showConnect, this);
                this._connSource.off('dragend mouseup mouseout', this.hide, this);
                this._connSource.off('show', this._showConnect, this).off('hide', this.hide, this);
                delete this._connSource;
            }
            if (this._connTarget) {
                removeFromArray(this, this._connTarget.__connectors);
                this._connTarget.off('dragging positionchange', this._updateCoordinates, this).off('remove', this.onRemove, this);
                this._connTarget.off('show', this._showConnect, this).off('hide', this.hide, this);
                delete this._connTarget;
            }
            if (!(this._connSource instanceof Geometry) || !(this._connTarget instanceof Geometry)) {
                var map = this.getMap();
                if (map) map.off('movestart moving moveend zoomstart zooming zoomend rotate pitch fovchange spatialreferencechange', this._updateCoordinates, this);
            }
        };
        _proto._showConnect = function _showConnect() {
            if (!this._connSource || !this._connTarget) return;
            if (this._connSource.isVisible() && this._connTarget.isVisible()) {
                this._updateCoordinates();
                this.show();
            }
        };
        _proto._registerEvents = function _registerEvents() {
            if (!this._connSource || !this._connTarget) return;
            if (!this._connSource.__connectors) this._connSource.__connectors = [];
            if (!this._connTarget.__connectors) this._connTarget.__connectors = [];
            this._connSource.__connectors.push(this);
            this._connTarget.__connectors.push(this);
            this._connSource.on('dragging positionchange', this._updateCoordinates, this).on('remove', this.remove, this);
            this._connTarget.on('dragging positionchange', this._updateCoordinates, this).on('remove', this.remove, this);
            this._connSource.on('show', this._showConnect, this).on('hide', this.hide, this);
            this._connTarget.on('show', this._showConnect, this).on('hide', this.hide, this);
            var trigger = this.options['showOn'];
            this.hide();
            if (trigger === 'moving') {
                this._connSource.on('dragstart', this._showConnect, this).on('dragend', this.hide, this);
                this._connTarget.on('dragstart', this._showConnect, this).on('dragend', this.hide, this);
            } else if (trigger === 'click') {
                this._connSource.on('mousedown', this._showConnect, this).on('mouseup', this.hide, this);
                this._connTarget.on('mousedown', this._showConnect, this).on('mouseup', this.hide, this);
            } else if (trigger === 'mouseover') {
                this._connSource.on('mouseover', this._showConnect, this).on('mouseout', this.hide, this);
                this._connTarget.on('mouseover', this._showConnect, this).on('mouseout', this.hide, this);
            } else this._showConnect();
            if (!(this._connSource instanceof Geometry) || !(this._connTarget instanceof Geometry)) {
                var map = this.getMap();
                if (map) map.on('movestart moving moveend zoomstart zooming zoomend rotate pitch fovchange spatialreferencechange', this._updateCoordinates, this);
            }
        };
        return _class;
    }(Base);
};
var options$q = {
    showOn: 'always'
};
var ConnectorLine = function(_Connectable) {
    function ConnectorLine(src, target, options) {
        var _this;
        _this = _Connectable.call(this, null, options) || this;
        if (arguments.length === 1) {
            options = src;
            src = null;
            target = null;
        }
        _this._connSource = src;
        _this._connTarget = target;
        return _this;
    }
    _inheritsLoose(ConnectorLine, _Connectable);
    return ConnectorLine;
}(Connectable(LineString));
ConnectorLine.mergeOptions(options$q);
ConnectorLine.registerJSONType('ConnectorLine');
var ArcConnectorLine = function(_Connectable2) {
    function ArcConnectorLine(src, target, options) {
        var _this2;
        _this2 = _Connectable2.call(this, null, options) || this;
        if (arguments.length === 1) {
            options = src;
            src = null;
            target = null;
        }
        _this2._connSource = src;
        _this2._connTarget = target;
        return _this2;
    }
    _inheritsLoose(ArcConnectorLine, _Connectable2);
    return ArcConnectorLine;
}(Connectable(ArcCurve));
ArcConnectorLine.mergeOptions(options$q);
ArcConnectorLine.registerJSONType('ArcConnectorLine');
function isGeometry(geo) {
    return geo && geo instanceof Geometry;
}
var options$p = {
    'drawImmediate': false,
    'geometryEvents': true,
    'geometryEventTolerance': 1
};
var TMP_EVENTS_ARR = [];
var OverlayLayer = function(_Layer) {
    function OverlayLayer(id, geometries, options) {
        var _this;
        if (geometries && !isGeometry(geometries) && !Array.isArray(geometries) && GEOJSON_TYPES.indexOf(geometries.type) < 0) {
            options = geometries;
            geometries = null;
        }
        _this = _Layer.call(this, id, options) || this;
        _this._maxZIndex = 0;
        _this._minZIndex = 0;
        _this._initCache();
        if (geometries) _this.addGeometry(geometries);
        var style = _this.options['style'];
        if (style) _this.setStyle(style);
        return _this;
    }
    _inheritsLoose(OverlayLayer, _Layer);
    var _proto = OverlayLayer.prototype;
    _proto.getAltitude = function getAltitude() {
        return 0;
    };
    _proto.getGeometryById = function getGeometryById(id) {
        if (isNil(id) || id === '') return null;
        if (!this._geoMap[id]) return null;
        return this._geoMap[id];
    };
    _proto.getGeometries = function getGeometries(filter, context) {
        if (!filter) return this._geoList.slice(0);
        var result = [];
        var geometry, filtered;
        for(var i = 0, l = this._geoList.length; i < l; i++){
            geometry = this._geoList[i];
            if (context) filtered = filter.call(context, geometry);
            else filtered = filter(geometry);
            if (filtered) result.push(geometry);
        }
        return result;
    };
    _proto.getFirstGeometry = function getFirstGeometry() {
        if (!this._geoList.length) return null;
        return this._geoList[0];
    };
    _proto.getLastGeometry = function getLastGeometry() {
        var len = this._geoList.length;
        if (len === 0) return null;
        return this._geoList[len - 1];
    };
    _proto.getCount = function getCount() {
        return this._geoList.length;
    };
    _proto.getExtent = function getExtent() {
        if (this.getCount() === 0) return null;
        var extent = new Extent(this.getProjection());
        this.forEach(function(g) {
            extent._combine(g.getExtent());
        });
        return extent;
    };
    _proto.forEach = function forEach(fn, context) {
        var copyOnWrite = this._geoList.slice(0);
        for(var i = 0, l = copyOnWrite.length; i < l; i++)if (!context) fn(copyOnWrite[i], i);
        else fn.call(context, copyOnWrite[i], i);
        return this;
    };
    _proto.filter = function filter(fn, context) {
        var selected = [];
        var isFn = isFunction(fn);
        var filter = isFn ? fn : createFilter(fn);
        this.forEach(function(geometry) {
            var g = isFn ? geometry : getFilterFeature(geometry);
            if (context ? filter.call(context, g) : filter(g)) selected.push(geometry);
        }, this);
        return selected;
    };
    _proto.isEmpty = function isEmpty() {
        return !this._geoList.length;
    };
    _proto.addGeometry = function addGeometry(geometries, fitView) {
        if (!geometries) return this;
        if (geometries.type === 'FeatureCollection') return this.addGeometry(GeoJSON.toGeometry(geometries), fitView);
        else if (!Array.isArray(geometries)) {
            var count = arguments.length;
            var last = arguments[count - 1];
            geometries = Array.prototype.slice.call(arguments, 0, count - 1);
            fitView = last;
            if (last && isObject$1(last) && ('type' in last || isGeometry(last))) {
                geometries.push(last);
                fitView = false;
            }
            return this.addGeometry(geometries, fitView);
        } else if (geometries.length === 0) return this;
        this._initCache();
        var extent;
        if (fitView) extent = new Extent();
        this._toSort = this._maxZIndex > 0;
        var geos = [];
        for(var i = 0, l = geometries.length; i < l; i++){
            var geo = geometries[i];
            if (!(geo && (GeoJSON._isGeoJSON(geo) || isGeometry(geo)))) throw new Error('Invalid geometry to add to layer(' + this.getId() + ') at index:' + i);
            if (geo.getLayer && geo.getLayer() === this) continue;
            if (!isGeometry(geo)) {
                geo = Geometry.fromJSON(geo);
                if (Array.isArray(geo)) for(var ii = 0, ll = geo.length; ii < ll; ii++){
                    this._add(geo[ii], extent, i);
                    geos.push(geo[ii]);
                }
            }
            if (!geo) throw new Error('Invalid geometry to add to layer(' + this.getId() + ') at index:' + i);
            if (!Array.isArray(geo)) {
                this._add(geo, extent, i);
                geos.push(geo);
            }
        }
        var map = this.getMap();
        if (map) {
            this._getRenderer().onGeometryAdd(geos);
            if (extent && !isNil(extent.xmin)) {
                var center = extent.getCenter();
                var z = map.getFitZoom(extent);
                if (isObject$1(fitView)) {
                    var step = isFunction(fitView.step) ? fitView.step : function() {
                        return undefined;
                    };
                    map.animateTo({
                        center: center,
                        zoom: z
                    }, extend$2({
                        duration: map.options.zoomAnimationDuration,
                        easing: 'out'
                    }, fitView), step);
                } else if (fitView === true) map.setCenterAndZoom(center, z);
            }
        }
        this.fire('addgeo', {
            'type': 'addgeo',
            'target': this,
            'geometries': geometries
        });
        return this;
    };
    _proto.getGeoMinZIndex = function getGeoMinZIndex() {
        return this._minZIndex;
    };
    _proto.getGeoMaxZIndex = function getGeoMaxZIndex() {
        return this._maxZIndex;
    };
    _proto._add = function _add(geo, extent, i) {
        if (!this._toSort) this._toSort = geo.getZIndex() !== 0;
        this._updateZIndex(geo.getZIndex());
        var geoId = geo.getId();
        if (!isNil(geoId)) {
            if (!isNil(this._geoMap[geoId])) throw new Error('Duplicate geometry id in layer(' + this.getId() + '):' + geoId + ', at index:' + i);
            this._geoMap[geoId] = geo;
        }
        var internalId = UID();
        geo._setInternalId(internalId);
        this._geoList.push(geo);
        this.onAddGeometry(geo);
        geo._bindLayer(this);
        if (geo.onAdd) geo.onAdd();
        if (extent) extent._combine(geo.getExtent());
        geo._fireEvent('add', {
            'layer': this
        });
        if (this._cookedStyles) this._styleGeometry(geo);
    };
    _proto.removeGeometry = function removeGeometry(geometries) {
        if (!Array.isArray(geometries)) return this.removeGeometry([
            geometries
        ]);
        for(var i = geometries.length - 1; i >= 0; i--){
            if (!(geometries[i] instanceof Geometry)) geometries[i] = this.getGeometryById(geometries[i]);
            if (!geometries[i] || this !== geometries[i].getLayer()) continue;
            geometries[i].remove();
        }
        return this;
    };
    _proto.clear = function clear() {
        this._clearing = true;
        this.forEach(function(geo) {
            geo.remove();
        });
        this._geoMap = {};
        var old = this._geoList;
        this._geoList = [];
        var renderer = this._getRenderer();
        if (renderer) {
            renderer.onGeometryRemove(old);
            if (renderer.clearImageData) {
                renderer.clearImageData();
                delete renderer._lastGeosToDraw;
            }
        }
        this._clearing = false;
        this.fire('clear');
        return this;
    };
    _proto.onRemoveGeometry = function onRemoveGeometry(geometry) {
        if (!geometry || this._clearing) return;
        if (this !== geometry.getLayer()) return;
        var internalId = geometry._getInternalId();
        if (isNil(internalId)) return;
        var geoId = geometry.getId();
        if (!isNil(geoId)) delete this._geoMap[geoId];
        var idx = this._findInList(geometry);
        if (idx >= 0) this._geoList.splice(idx, 1);
        if (this._getRenderer()) this._getRenderer().onGeometryRemove([
            geometry
        ]);
    };
    _proto.getStyle = function getStyle() {
        if (!this.options['style']) return null;
        return this.options['style'];
    };
    _proto.setStyle = function setStyle(style) {
        this.options.style = style;
        style = parseStyleRootPath(style);
        this._cookedStyles = compileStyle(style);
        this.forEach(function(geometry) {
            this._styleGeometry(geometry);
        }, this);
        this.fire('setstyle', {
            'type': 'setstyle',
            'target': this,
            'style': style
        });
        return this;
    };
    _proto._styleGeometry = function _styleGeometry(geometry) {
        if (!this._cookedStyles) return false;
        var g = getFilterFeature(geometry);
        for(var i = 0, len = this._cookedStyles.length; i < len; i++)if (this._cookedStyles[i]['filter'](g) === true) {
            geometry._setExternSymbol(this._cookedStyles[i]['symbol']);
            return true;
        }
        return false;
    };
    _proto.removeStyle = function removeStyle() {
        if (!this.options.style) return this;
        delete this.options.style;
        delete this._cookedStyles;
        this.forEach(function(geometry) {
            geometry._setExternSymbol(null);
        }, this);
        this.fire('removestyle');
        return this;
    };
    _proto.onAddGeometry = function onAddGeometry(geo) {
        var style = this.getStyle();
        if (style) this._styleGeometry(geo);
    };
    _proto.hide = function hide() {
        for(var i = 0, l = this._geoList.length; i < l; i++)this._geoList[i].onHide();
        return Layer.prototype.hide.call(this);
    };
    _proto._initCache = function _initCache() {
        if (!this._geoList) {
            this._geoList = [];
            this._geoMap = {};
        }
    };
    _proto._updateZIndex = function _updateZIndex(...zIndex) {
        this._maxZIndex = Math.max(this._maxZIndex, Math.max(...zIndex));
        this._minZIndex = Math.min(this._minZIndex, Math.min(...zIndex));
    };
    _proto._sortGeometries = function _sortGeometries() {
        var _this2 = this;
        if (!this._toSort) return;
        this._maxZIndex = 0;
        this._minZIndex = 0;
        this._geoList.sort(function(a, b) {
            _this2._updateZIndex(a.getZIndex(), b.getZIndex());
            return _this2._compare(a, b);
        });
        this._toSort = false;
    };
    _proto._compare = function _compare(a, b) {
        if (a.getZIndex() === b.getZIndex()) return a._getInternalId() - b._getInternalId();
        return a.getZIndex() - b.getZIndex();
    };
    _proto._findInList = function _findInList(geo) {
        var len = this._geoList.length;
        if (len === 0) return -1;
        this._sortGeometries();
        var low = 0, high = len - 1, middle;
        while(low <= high){
            middle = Math.floor((low + high) / 2);
            if (this._geoList[middle] === geo) return middle;
            else if (this._compare(this._geoList[middle], geo) > 0) high = middle - 1;
            else low = middle + 1;
        }
        return -1;
    };
    _proto.onGeometryEvent = function onGeometryEvent(param) {
        return this._onGeometryEvent(param);
    };
    _proto._onGeometryEvent = function _onGeometryEvent(param) {
        if (!param || !param['target']) return;
        var type = param['type'];
        if (type === 'idchange') this._onGeometryIdChange(param);
        else if (type === 'zindexchange') this._onGeometryZIndexChange(param);
        else if (type === 'positionchange') this._onGeometryPositionChange(param);
        else if (type === 'shapechange') this._onGeometryShapeChange(param);
        else if (type === 'symbolchange') this._onGeometrySymbolChange(param);
        else if (type === 'show') this._onGeometryShow(param);
        else if (type === 'hide') this._onGeometryHide(param);
        else if (type === 'propertieschange') this._onGeometryPropertiesChange(param);
    };
    _proto._onGeometryIdChange = function _onGeometryIdChange(param) {
        if (param['new'] === param['old']) {
            if (this._geoMap[param['old']] && this._geoMap[param['old']] === param['target']) return;
        }
        if (!isNil(param['new'])) {
            if (this._geoMap[param['new']]) throw new Error('Duplicate geometry id in layer(' + this.getId() + '):' + param['new']);
            this._geoMap[param['new']] = param['target'];
        }
        if (!isNil(param['old']) && param['new'] !== param['old']) delete this._geoMap[param['old']];
    };
    _proto._onGeometryZIndexChange = function _onGeometryZIndexChange(param) {
        if (param['old'] !== param['new']) {
            this._updateZIndex(param['new']);
            this._toSort = true;
            if (this._getRenderer()) this._getRenderer().onGeometryZIndexChange(param);
        }
    };
    _proto._onGeometryPositionChange = function _onGeometryPositionChange(param) {
        if (this._getRenderer()) this._getRenderer().onGeometryPositionChange(param);
    };
    _proto._onGeometryShapeChange = function _onGeometryShapeChange(param) {
        if (this._getRenderer()) this._getRenderer().onGeometryShapeChange(param);
    };
    _proto._onGeometrySymbolChange = function _onGeometrySymbolChange(param) {
        if (this._getRenderer()) this._getRenderer().onGeometrySymbolChange(param);
    };
    _proto._onGeometryShow = function _onGeometryShow(param) {
        if (this._getRenderer()) this._getRenderer().onGeometryShow(param);
    };
    _proto._onGeometryHide = function _onGeometryHide(param) {
        if (this._getRenderer()) this._getRenderer().onGeometryHide(param);
    };
    _proto._onGeometryPropertiesChange = function _onGeometryPropertiesChange(param) {
        if (this._getRenderer()) this._getRenderer().onGeometryPropertiesChange(param);
    };
    _proto._hasGeoListeners = function _hasGeoListeners(eventTypes) {
        if (!eventTypes) return false;
        if (!Array.isArray(eventTypes)) {
            TMP_EVENTS_ARR[0] = eventTypes;
            eventTypes = TMP_EVENTS_ARR;
        }
        var geos = this.getGeometries() || [];
        for(var i = 0, len = geos.length; i < len; i++){
            var geometry = geos[i];
            if (!geometry) continue;
            if (geometry.options.cursor) return true;
            for(var j = 0, len1 = eventTypes.length; j < len1; j++){
                var eventType = eventTypes[j];
                var listens = geometry.listens(eventType);
                if (listens > 0) return true;
            }
        }
        return false;
    };
    _proto._getRenderer = function _getRenderer() {
        return _Layer.prototype._getRenderer.call(this);
    };
    return OverlayLayer;
}(Layer);
OverlayLayer.mergeOptions(options$p);
var options$o = {
    renderer: null
};
var DrawToolLayer = function(_OverlayLayer) {
    function DrawToolLayer(id, geometries, options = {}) {
        var _this;
        if (geometries && !isGeometry(geometries) && !Array.isArray(geometries) && GEOJSON_TYPES.indexOf(geometries.type) < 0) {
            options = geometries;
            geometries = null;
        }
        _this = _OverlayLayer.call(this, id, options) || this;
        var depthFunc = _this.options.depthFunc || 'always';
        options.sceneConfig = {
            depthFunc: depthFunc
        };
        _this._markerLayer = new DrawToolLayer.markerLayerClazz(id + '_marker', options);
        _this._lineLayer = new DrawToolLayer.lineLayerClazz(id + '_line', options);
        _this._polygonLayer = new DrawToolLayer.polygonLayerClazz(id + '_polygon', options);
        if (geometries) _this.addGeometry(geometries);
        return _this;
    }
    _inheritsLoose(DrawToolLayer, _OverlayLayer);
    DrawToolLayer.setLayerClass = function setLayerClass(markerLayerClass, lineLayerClass, polygonLayerClass) {
        DrawToolLayer.markerLayerClazz = markerLayerClass;
        DrawToolLayer.lineLayerClazz = lineLayerClass;
        DrawToolLayer.polygonLayerClazz = polygonLayerClass;
    };
    var _proto = DrawToolLayer.prototype;
    _proto.bringToFront = function bringToFront() {
        this._polygonLayer.bringToFront();
        this._lineLayer.bringToFront();
        this._markerLayer.bringToFront();
        return this;
    };
    _proto.addGeometry = function addGeometry(geometries) {
        if (!Array.isArray(geometries)) geometries = [
            geometries
        ];
        pushIn(this._geoList, geometries);
        for(var i = 0; i < geometries.length; i++){
            if (this._markerLayer.isVectorLayer) {
                this._markerLayer.addGeometry(geometries[i]);
                continue;
            }
            if (geometries[i] instanceof Marker || geometries[i] instanceof MultiPoint) this._markerLayer.addGeometry(geometries[i]);
            else if (geometries[i] instanceof LineString || geometries[i] instanceof MultiLineString) this._lineLayer.addGeometry(geometries[i]);
            else if (geometries[i] instanceof Polygon || geometries[i] instanceof MultiPolygon) this._polygonLayer.addGeometry(geometries[i]);
        }
    };
    _proto.removeGeometry = function removeGeometry(geometries) {
        if (!Array.isArray(geometries)) geometries = [
            geometries
        ];
        for(var i = 0; i < geometries.length; i++){
            this._geoList.splice(geometries[i], 1);
            if (this._markerLayer.isVectorLayer) {
                this._markerLayer.removeGeometry(geometries[i]);
                continue;
            }
            if (geometries[i] instanceof Marker || geometries[i] instanceof MultiPoint) this._markerLayer.removeGeometry(geometries[i]);
            else if (geometries[i] instanceof LineString || geometries[i] instanceof MultiLineString) this._lineLayer.removeGeometry(geometries[i]);
            else if (geometries[i] instanceof Polygon || geometries[i] instanceof MultiPolygon) this._polygonLayer.removeGeometry(geometries[i]);
        }
    };
    _proto._onRemoveDrawToolGeo = function _onRemoveDrawToolGeo(params) {
        var geometries = params.geometries;
        for(var i = 0; i < geometries.length; i++)if (geometries[i]) this._geoList.splice(geometries[i], 1);
    };
    _proto.onRemove = function onRemove() {
        this._geoList = [];
        this._markerLayer.off('removegeo', this._onRemoveDrawToolGeo, this);
        this._lineLayer.off('removegeo', this._onRemoveDrawToolGeo, this);
        this._polygonLayer.off('removegeo', this._onRemoveDrawToolGeo, this);
        this._markerLayer.remove();
        this._lineLayer.remove();
        this._polygonLayer.remove();
        delete this._markerLayer;
        delete this._lineLayer;
        delete this._polygonLayer;
        return _OverlayLayer.prototype.onRemove.call(this);
    };
    _proto.onAdd = function onAdd() {
        var map = this.getMap();
        this._polygonLayer.addTo(map);
        this._lineLayer.addTo(map);
        this._markerLayer.addTo(map);
        this._markerLayer.on('removegeo', this._onRemoveDrawToolGeo, this);
        this._lineLayer.on('removegeo', this._onRemoveDrawToolGeo, this);
        this._polygonLayer.on('removegeo', this._onRemoveDrawToolGeo, this);
        return _OverlayLayer.prototype.onAdd.call(this);
    };
    _proto.getRenderer = function getRenderer() {
        return this._getRenderer();
    };
    _proto._getRenderer = function _getRenderer() {
        return this._markerLayer.getRenderer();
    };
    return DrawToolLayer;
}(OverlayLayer);
DrawToolLayer.mergeOptions(options$o);
var key = '_map_tool';
var MapTool = function(_Eventable) {
    function MapTool() {
        return _Eventable.apply(this, arguments) || this;
    }
    _inheritsLoose(MapTool, _Eventable);
    var _proto = MapTool.prototype;
    _proto.addTo = function addTo(map) {
        if (!map) return this;
        this._map = map;
        if (map[key]) map[key].disable();
        if (this.onAdd) this.onAdd();
        this.enable();
        map[key] = this;
        this._fireEvent('add');
        return this;
    };
    _proto.getMap = function getMap() {
        return this._map;
    };
    _proto.enable = function enable() {
        var map = this._map;
        if (!map || this._enabled) return this;
        this._enabled = true;
        this._switchEvents('off');
        this._registerEvents();
        if (this.onEnable) this.onEnable();
        this._fireEvent('enable');
        return this;
    };
    _proto.disable = function disable() {
        if (!this._enabled || !this._map) return this;
        this._enabled = false;
        this._switchEvents('off');
        if (this.onDisable) this.onDisable();
        this._fireEvent('disable');
        return this;
    };
    _proto.isEnabled = function isEnabled() {
        if (!this._enabled) return false;
        return true;
    };
    _proto.remove = function remove() {
        if (!this._map) return this;
        this.disable();
        if (this._map) {
            delete this._map[key];
            delete this._map;
        }
        this._fireEvent('remove');
        return this;
    };
    _proto._registerEvents = function _registerEvents() {
        this._switchEvents('on');
    };
    _proto._switchEvents = function _switchEvents(to) {
        var events = this.getEvents();
        if (events) this._map[to](events, this);
    };
    _proto._fireEvent = function _fireEvent(eventName, param) {
        if (!param) param = {};
        this.fire(eventName, param);
    };
    return MapTool;
}(Eventable(Class));
var options$n = {
    'symbol': {
        'lineColor': '#000',
        'lineWidth': 2,
        'lineOpacity': 1,
        'polygonFill': '#fff',
        'polygonOpacity': 0.3
    },
    'doubleClickZoom': false,
    'mode': null,
    'once': false,
    'autoPanAtEdge': false,
    'ignoreMouseleave': true,
    'blockGeometryEvents': false,
    'zIndex': Number.MAX_VALUE,
    'enableAltitude': true,
    'interactive': true,
    'transformCoordinate': null
};
var registeredMode = {};
var DrawTool = function(_MapTool) {
    function DrawTool(options) {
        var _this;
        _this = _MapTool.call(this, options) || this;
        _this._checkMode();
        _this._events = {
            'click': _this._clickHandler,
            'mousemove touchmove': _this._mouseMoveHandler,
            'dblclick': _this._doubleClickHandler,
            'mousedown touchstart': _this._mouseDownHandler,
            'mouseup touchend': _this._mouseUpHandler,
            'mousemove': _this._mouseMoveHandler,
            'mousedown': _this._mouseDownHandler,
            'mouseup': _this._mouseUpHandler
        };
        return _this;
    }
    _inheritsLoose(DrawTool, _MapTool);
    DrawTool.registerMode = function registerMode(name, modeAction) {
        registeredMode[name.toLowerCase()] = modeAction;
    };
    DrawTool.getRegisterMode = function getRegisterMode(name) {
        return registeredMode[name.toLowerCase()];
    };
    var _proto = DrawTool.prototype;
    _proto.getMode = function getMode() {
        if (this.options['mode']) return this.options['mode'].toLowerCase();
        return null;
    };
    _proto.setMode = function setMode(mode) {
        if (this._geometry) {
            this._geometry.remove();
            delete this._geometry;
        }
        this._clearStage();
        this._switchEvents('off');
        this.options['mode'] = mode;
        this._checkMode();
        if (this.isEnabled()) {
            this._switchEvents('on');
            this._restoreMapCfg();
            this._saveMapCfg();
        }
        return this;
    };
    _proto.getSymbol = function getSymbol() {
        var symbol = this.options['symbol'];
        if (symbol) return extendSymbol(symbol);
        else return extendSymbol(this.options['symbol']);
    };
    _proto.setSymbol = function setSymbol(symbol) {
        if (!symbol) return this;
        this.options['symbol'] = symbol;
        if (this._geometry) this._geometry.setSymbol(symbol);
        return this;
    };
    _proto.getCurrentGeometry = function getCurrentGeometry() {
        return this._geometry;
    };
    _proto.onAdd = function onAdd() {
        this._checkMode();
    };
    _proto.onEnable = function onEnable() {
        this._saveMapCfg();
        this._drawToolLayer = this._getDrawLayer();
        this._clearStage();
        this._loadResources();
        var map = this.getMap();
        if (this.options['autoPanAtEdge']) {
            this._mapAutoPanAtEdge = map.options['autoPanAtEdge'];
            if (!this._mapAutoPanAtEdge) map.config({
                autoPanAtEdge: true
            });
        }
        this._geometryEvents = map.options['geometryEvents'];
        if (this.options['blockGeometryEvents']) map.config('geometryEvents', false);
        return this;
    };
    _proto.onDisable = function onDisable() {
        var map = this.getMap();
        this._restoreMapCfg();
        this.endDraw({
            ignoreEndEvent: true
        });
        if (this._map) {
            map.removeLayer(this._getDrawLayer());
            if (this.options['autoPanAtEdge']) {
                if (!this._mapAutoPanAtEdge) map.config({
                    autoPanAtEdge: false
                });
            }
        }
        if (this.options['blockGeometryEvents']) map.config('geometryEvents', this._geometryEvents);
        return this;
    };
    _proto.undo = function undo() {
        var registerMode = this._getRegisterMode();
        var action = registerMode.action;
        if (!this._shouldRecordHistory(action) || !this._historyPointer) return this;
        var coords = this._clickCoords.slice(0, --this._historyPointer);
        registerMode.update(this.getMap().getProjection(), coords, this._geometry);
        return this;
    };
    _proto.redo = function redo() {
        var registerMode = this._getRegisterMode();
        var action = registerMode.action;
        if (!this._shouldRecordHistory(action) || isNil(this._historyPointer) || this._historyPointer === this._clickCoords.length) return this;
        var coords = this._clickCoords.slice(0, ++this._historyPointer);
        registerMode.update(this.getMap().getProjection(), coords, this._geometry);
        return this;
    };
    _proto._shouldRecordHistory = function _shouldRecordHistory(actions) {
        return Array.isArray(actions) && actions[0] === 'click' && actions[1] === 'mousemove' && actions[2] === 'dblclick';
    };
    _proto._checkMode = function _checkMode() {
        this._getRegisterMode();
    };
    _proto._saveMapCfg = function _saveMapCfg() {
        var map = this.getMap();
        this._mapDoubleClickZoom = map.options['doubleClickZoom'];
        map.config({
            'doubleClickZoom': this.options['doubleClickZoom']
        });
        var actions = this._getRegisterMode()['action'];
        var dragging = false;
        for(var i = 0; i < actions.length; i++)if (actions[i].indexOf('mousedown') >= 0 || actions[i].indexOf('touchstart') >= 0) {
            dragging = true;
            break;
        }
        if (dragging) {
            var _map = this.getMap();
            this._mapDraggable = _map.options['draggable'];
            _map.config({
                'draggable': false
            });
        }
    };
    _proto._restoreMapCfg = function _restoreMapCfg() {
        var map = this.getMap();
        map.config({
            'doubleClickZoom': this._mapDoubleClickZoom
        });
        if (!isNil(this._mapDraggable)) map.config('draggable', this._mapDraggable);
        delete this._mapDraggable;
        delete this._mapDoubleClickZoom;
    };
    _proto._loadResources = function _loadResources() {
        var symbol = this.getSymbol();
        var resources = getExternalResources(symbol);
        if (resources.length > 0) this._drawToolLayer.getRenderer().loadResources(resources);
    };
    _proto._getProjection = function _getProjection() {
        return this._map.getProjection();
    };
    _proto._getRegisterMode = function _getRegisterMode() {
        var mode = this.getMode();
        var registerMode = DrawTool.getRegisterMode(mode);
        if (!registerMode) throw new Error(mode + ' is not a valid mode of DrawTool.');
        return registerMode;
    };
    _proto.getEvents = function getEvents() {
        var action = this._getRegisterMode()['action'];
        var _events = {};
        if (Array.isArray(action)) {
            for(var i = 0; i < action.length; i++)_events[action[i]] = this._events[action[i]];
            return _events;
        }
        return null;
    };
    _proto._mouseDownHandler = function _mouseDownHandler(event) {
        if (!(event === null || event === void 0 ? void 0 : event.coordinate)) return;
        this._createGeometry(event);
    };
    _proto._mouseUpHandler = function _mouseUpHandler(event) {
        if (!(event === null || event === void 0 ? void 0 : event.coordinate)) return;
        this.endDraw(event);
    };
    _proto._clickHandler = function _clickHandler(event) {
        if (!(event === null || event === void 0 ? void 0 : event.coordinate)) return;
        if (!this.options.interactive) return this;
        event.enableAltitude = this.options.enableAltitude;
        var map = this.getMap();
        var registerMode = this._getRegisterMode();
        if (this._clickCoords && this._clickCoords.length) {
            var len = this._clickCoords.length;
            var prjCoord = map._pointToPrj(event['point2d']);
            if (this._clickCoords[len - 1].equals(prjCoord)) return;
        }
        if (!this._geometry) this._createGeometry(event);
        else {
            var _prjCoord = map._pointToPrj(event['point2d']);
            if (!isNil(this._historyPointer)) this._clickCoords = this._clickCoords.slice(0, this._historyPointer);
            var snapTo = this._geometry.snapTo;
            if (snapTo && isFunction(snapTo)) {
                var snapResult = this._getSnapResult(snapTo, event.containerPoint);
                _prjCoord = snapResult.prjCoord;
                this._clickCoords = this._clickCoords.concat(snapResult.effectedVertex);
                if (this._clickCoords[this._clickCoords.length - 1].equals(_prjCoord)) return;
            }
            this._clickCoords.push(_prjCoord);
            this._historyPointer = this._clickCoords.length;
            event.drawTool = this;
            registerMode['update'](map.getProjection(), this._clickCoords, this._geometry, event);
            if (this.getMode() === 'point') {
                this.endDraw(event);
                return;
            }
            if (this._clickCoords.length <= 1) this._fireEvent('drawstart', event);
            else this._fireEvent('drawvertex', event);
            if (registerMode['clickLimit'] && registerMode['clickLimit'] === this._historyPointer) this.endDraw(event);
        }
    };
    _proto._createGeometry = function _createGeometry(event) {
        var mode = this.getMode();
        var map = this.getMap();
        var registerMode = this._getRegisterMode();
        var prjCoord = map._pointToPrj(event['point2d']);
        var symbol = this.getSymbol();
        if (!this._geometry) {
            this._fireEvent('drawprepare', event);
            this._clickCoords = [
                prjCoord
            ];
            event.drawTool = this;
            this._geometry = registerMode['create'](this.getMap().getProjection(), this._clickCoords, event);
            if (symbol && mode !== 'point') this._geometry.setSymbol(symbol);
            else if (this.options.hasOwnProperty('symbol')) this._geometry.setSymbol(this.options['symbol']);
            this._addGeometryToStage(this._geometry);
            this._fireEvent('drawstart', event);
            var snapTo = this._geometry.snapTo;
            if (snapTo && isFunction(snapTo)) {
                var snapResult = this._getSnapResult(snapTo, event.containerPoint);
                var _map2 = this.getMap();
                if (_map2 && snapResult) {
                    var _prjCoord2 = snapResult.prjCoord;
                    this._clickCoords = [
                        _prjCoord2
                    ];
                    registerMode['update'](_map2.getProjection(), this._clickCoords, this._geometry, event);
                }
            }
        }
        if (mode === 'point' && event.type !== 'mousemove') this.endDraw(event);
    };
    _proto._mouseMoveHandler = function _mouseMoveHandler(event) {
        if (!(event === null || event === void 0 ? void 0 : event.coordinate)) return;
        if (!this.options.interactive) return this;
        event.enableAltitude = this.options.enableAltitude;
        var map = this.getMap();
        if (!map || map.isInteracting()) return;
        if (this.getMode() === 'point' && !this._geometry) {
            this._createGeometry(event);
            return;
        }
        if (!this._geometry) return;
        var containerPoint = this._getMouseContainerPoint(event);
        if (!this._isValidContainerPoint(containerPoint)) return;
        var prjCoord = map._pointToPrj(event['point2d']);
        var snapAdditionVertex = [];
        var snapTo = this._geometry.snapTo;
        if (snapTo && isFunction(snapTo)) {
            var snapResult = this._getSnapResult(snapTo, containerPoint);
            prjCoord = snapResult.prjCoord;
            snapAdditionVertex = snapResult.effectedVertex;
        }
        var projection = map.getProjection();
        event.drawTool = this;
        var registerMode = this._getRegisterMode();
        if (this._shouldRecordHistory(registerMode.action)) {
            var path = this._clickCoords.slice(0, this._historyPointer);
            if (path && path.length > 0 && prjCoord.equals(path[path.length - 1])) return;
            registerMode['update'](projection, path.concat(snapAdditionVertex, [
                prjCoord
            ]), this._geometry, event);
        } else registerMode['update'](projection, prjCoord, this._geometry, event);
        this._fireEvent('mousemove', event);
    };
    _proto._doubleClickHandler = function _doubleClickHandler(event) {
        if (!(event === null || event === void 0 ? void 0 : event.coordinate)) return;
        if (!this.options.interactive) return this;
        event.enableAltitude = this.options.enableAltitude;
        if (!this._geometry) return;
        var containerPoint = this._getMouseContainerPoint(event);
        if (!this._isValidContainerPoint(containerPoint)) return;
        var registerMode = this._getRegisterMode();
        var clickCoords = this._clickCoords;
        if (!clickCoords || clickCoords.length < 2) return;
        var mode = this.getMode();
        if (mode && mode.indexOf('polygon') > -1 && clickCoords.length < 3) return;
        var projection = this.getMap().getProjection();
        var path = [
            clickCoords[0]
        ];
        for(var i = 1, len = clickCoords.length; i < len; i++)if (clickCoords[i].x !== clickCoords[i - 1].x || clickCoords[i].y !== clickCoords[i - 1].y) path.push(clickCoords[i]);
        if (path.length < 2 || this._geometry && this._geometry instanceof Polygon && path.length < 3) return;
        event.drawTool = this;
        registerMode['update'](projection, path, this._geometry, event);
        this.endDraw(event);
    };
    _proto._addGeometryToStage = function _addGeometryToStage(geometry) {
        var drawLayer = this._getDrawLayer();
        drawLayer.addGeometry(geometry);
    };
    _proto.endDraw = function endDraw(param) {
        if (!this._geometry || this._ending) return this;
        this._ending = true;
        var geometry = this._geometry;
        this._clearStage();
        param = param || {};
        this._geometry = geometry;
        if (!param.ignoreEndEvent) this._fireEvent('drawend', param);
        delete this._geometry;
        if (this.options['once']) this.disable();
        delete this._ending;
        delete this._historyPointer;
        if (this._vertexes) this._vertexes = [];
        return this;
    };
    _proto._clearStage = function _clearStage() {
        this._getDrawLayer().clear();
        delete this._geometry;
        delete this._clickCoords;
    };
    _proto._getMouseContainerPoint = function _getMouseContainerPoint(event) {
        var action = this._getRegisterMode()['action'];
        if (action[0].indexOf('mousedown') >= 0 || action[0].indexOf('touchstart') >= 0) stopPropagation(event['domEvent']);
        return event['containerPoint'];
    };
    _proto._isValidContainerPoint = function _isValidContainerPoint(containerPoint) {
        var mapSize = this._map.getSize();
        var w = mapSize['width'], h = mapSize['height'];
        if (containerPoint.x < 0 || containerPoint.y < 0) return false;
        else if (containerPoint.x > w || containerPoint.y > h) return false;
        return true;
    };
    _proto._getSnapResult = function _getSnapResult(snapTo, containerPoint) {
        var map = this.getMap();
        var lastContainerPoints = [];
        if (this.options.edgeAutoComplete) {
            var lastCoord = this._clickCoords[(this._historyPointer || 1) - 1];
            lastContainerPoints.push(map.prjToContainerPoint(lastCoord));
            var beforeLastCoord = this._clickCoords[(this._historyPointer || 1) - 2];
            if (beforeLastCoord) lastContainerPoints.push(map.prjToContainerPoint(beforeLastCoord));
        }
        var snapResult = snapTo(containerPoint, lastContainerPoints);
        containerPoint = (snapResult.effectedVertex ? snapResult.point : snapResult) || containerPoint;
        var prjCoord = map._containerPointToPrj(containerPoint);
        if (snapResult.effectedVertex) snapResult.effectedVertex = snapResult.effectedVertex.map(function(vertex) {
            return map._containerPointToPrj(vertex);
        });
        return {
            prjCoord: prjCoord,
            effectedVertex: snapResult.effectedVertex || []
        };
    };
    _proto._getDrawLayer = function _getDrawLayer() {
        var drawLayerId = INTERNAL_LAYER_PREFIX + 'drawtool';
        var drawToolLayer = this._map.getLayer(drawLayerId);
        if (!drawToolLayer) {
            drawToolLayer = new DrawToolLayer(drawLayerId, {
                'enableSimplify': false,
                'enableAltitude': this.options['enableAltitude'],
                'zIndex': this.options.zIndex
            });
            this._map.addLayer(drawToolLayer);
        }
        this._pushLayers(drawToolLayer);
        return drawToolLayer;
    };
    _proto._fireEvent = function _fireEvent(eventName, param) {
        if (!param) param = {};
        param = extend$2({}, param);
        if (this._geometry) {
            param['geometry'] = this._getRegisterMode()['generate'](this._geometry, {
                drawTool: this
            });
            param.tempGeometry = this._geometry;
        }
        MapTool.prototype._fireEvent.call(this, eventName, param);
    };
    _proto._pushLayers = function _pushLayers(layers) {
        var _this2 = this;
        if (!layers) return this;
        if (!Array.isArray(layers)) layers = [
            layers
        ];
        this._layers = this._layers || [];
        layers.forEach(function(layer) {
            if (_this2._layers.indexOf(layer) === -1) _this2._layers.push(layer);
        });
        return this;
    };
    _proto._outLayers = function _outLayers(layers) {
        var _this3 = this;
        if (!layers) return this;
        if (!Array.isArray(layers)) layers = [
            layers
        ];
        this._layers = this._layers || [];
        layers.forEach(function(layer) {
            for(var i = 0, len = _this3._layers.length; i < len; i++)if (layer === _this3._layers[i]) {
                _this3._layers.splice(i, 1);
                break;
            }
        });
        return this;
    };
    _proto.setLayerZIndex = function setLayerZIndex(zIndex) {
        if (!isNumber(zIndex)) return this;
        this.options.zIndex = zIndex;
        this._layers = this._layers || [];
        this._layers.forEach(function(layer) {
            if (layer && layer.setZIndex) layer.setZIndex(zIndex);
        });
        return this;
    };
    _proto.addCoordinate = function addCoordinate(coordinate) {
        if (!this.isEnabled()) return this;
        var map = this.getMap();
        if (!map) return this;
        coordinate = new Coordinate(coordinate);
        var eventParam = map._parseEventFromCoord(coordinate);
        this._clickHandler(eventParam);
        return this;
    };
    _proto.getTempGeometry = function getTempGeometry() {
        return this._geometry;
    };
    return DrawTool;
}(MapTool);
DrawTool.mergeOptions(options$n);
var MapBoxZoomHander = function(_Handler) {
    function MapBoxZoomHander(target) {
        var _this;
        _this = _Handler.call(this, target) || this;
        _this.drawTool = new DrawTool({
            'mode': 'boxZoom',
            'ignoreMouseleave': false
        });
        return _this;
    }
    _inheritsLoose(MapBoxZoomHander, _Handler);
    var _proto = MapBoxZoomHander.prototype;
    _proto.addHooks = function addHooks() {
        this.target.on('_mousedown', this._onMouseDown, this);
    };
    _proto.removeHooks = function removeHooks() {
        this.target.off('_mousedown', this._onMouseDown, this);
        if (this.drawTool.isEnabled()) this.drawTool.remove();
    };
    _proto._onMouseDown = function _onMouseDown(param) {
        if (!this.target.options['boxZoom']) return;
        if (param.domEvent.shiftKey) this.drawTool.setSymbol(this.target.options['boxZoomSymbol']).on('drawend', this._boxZoom, this).addTo(this.target);
    };
    _proto._boxZoom = function _boxZoom(param) {
        var map = this.target;
        this.drawTool.remove();
        var geometry = param.geometry, center = geometry.getCenter(), symbol = geometry.getSymbol(), w = symbol.markerWidth, h = symbol.markerHeight;
        var extent = new Extent(center, map.locateByPoint(center, w, h), map.getProjection());
        var zoom = map.getFitZoom(extent);
        map._animateTo({
            center: extent.getCenter(),
            zoom: zoom
        });
    };
    return MapBoxZoomHander;
}(Handler);
Map$1.mergeOptions({
    'boxZoom': true,
    'boxZoomSymbol': {
        'markerType': 'rectangle',
        'markerLineWidth': 3,
        'markerLineColor': '#1bbc9b',
        'markerLineDasharray': [
            10,
            5
        ],
        'markerFillOpacity': 0.1,
        'markerFill': '#1bbc9b',
        'markerWidth': 1,
        'markerHeight': 1
    }
});
Map$1.addOnLoadHook('addHandler', 'boxZoom', MapBoxZoomHander);
var PANOFFSET = 30;
var MapAutoPanAtEdgeHandler = function(_Handler) {
    function MapAutoPanAtEdgeHandler() {
        return _Handler.apply(this, arguments) || this;
    }
    _inheritsLoose(MapAutoPanAtEdgeHandler, _Handler);
    var _proto = MapAutoPanAtEdgeHandler.prototype;
    _proto.addHooks = function addHooks() {
        if (!this.target) return;
        this.target.on('_mousemove', this._onMouseMove, this);
    };
    _proto.removeHooks = function removeHooks() {
        if (!this.target) return;
        this.target.off('_mousemove', this._onMouseMove, this);
    };
    _proto._onMouseMove = function _onMouseMove(event) {
        var map = this.target;
        if (map.options['autoPanAtEdge']) {
            var { containerPoint: containerPoint } = event;
            var containerExtent = map.getContainerExtent();
            if (containerExtent) {
                var { x: x, y: y } = containerPoint;
                var { xmax: xmax, ymax: ymax } = containerExtent;
                var p;
                if (x < PANOFFSET) p = [
                    Math.abs(x - PANOFFSET),
                    0
                ];
                if (y < PANOFFSET) p = [
                    0,
                    Math.abs(y - PANOFFSET)
                ];
                if (x + PANOFFSET > xmax) p = [
                    -Math.abs(x + PANOFFSET - xmax),
                    0
                ];
                if (y + PANOFFSET > ymax) p = [
                    0,
                    -Math.abs(y + PANOFFSET - ymax)
                ];
                if (p) map.panBy(p, {
                    duration: 1
                });
            }
        }
    };
    return MapAutoPanAtEdgeHandler;
}(Handler);
Map$1.mergeOptions({
    'autoPanAtEdge': false
});
Map$1.addOnLoadHook('addHandler', 'autoPanAtEdge', MapAutoPanAtEdgeHandler);
function needValidateView(view, map) {
    var bearing = view.bearing;
    var currentBearing = map.getBearing();
    if (currentBearing >= 0 && bearing > 180) return false;
    if (currentBearing <= 0 && bearing < -180) return false;
    return true;
}
function reverseBearing(view, map) {
    var bearing = view.bearing;
    var currentBearing = map.getBearing();
    if (currentBearing >= 0 && bearing < 0) view.bearing = 180 + (180 - Math.abs(bearing));
    if (currentBearing <= 0 && bearing > 0) view.bearing = -180 - (180 - Math.abs(bearing));
    if (currentBearing >= 0 && bearing > 0) view.bearing = -180 - (180 - Math.abs(bearing));
    if (currentBearing <= 0 && bearing < 0) view.bearing = 180 + (180 - Math.abs(bearing));
}
Map$1.include({
    animateTo: function animateTo(view, options = {}, step) {
        var _this = this;
        view = extend$2({}, this.getView(), view);
        view.bearing = view.bearing % 360;
        if (isFunction(options)) {
            step = options;
            options = {};
        }
        if (options.counterclockwise) reverseBearing(view, this);
        if (needValidateView(view, this)) this._validateView(view);
        var projection = this.getProjection(), currView = this.getView(), props = {};
        var empty = true;
        for(var p in view)if (hasOwn(view, p) && !isNil(view[p]) && (p === 'prjCenter' || !isNil(currView[p]))) {
            empty = false;
            if (p === 'center') {
                var from = new Coordinate(currView[p]), to = new Coordinate(view[p]);
                if (!from.equals(to)) props['center'] = [
                    from,
                    to
                ];
            } else if (p === 'prjCenter') {
                var _from = new Coordinate(this._getPrjCenter());
                var _to = new Coordinate(view[p]);
                if (!_from.equals(_to)) props['prjCenter'] = [
                    _from,
                    _to
                ];
            } else if (currView[p] !== view[p] && p !== 'around') props[p] = [
                currView[p],
                view[p]
            ];
        }
        if (empty) return null;
        if (this._animPlayer) {
            if (this._isInternalAnimation) {
                if (this._animPlayer.playState === 'running') {
                    this._animPlayer.pause();
                    this._prevAnimPlayer = this._animPlayer;
                }
            } else {
                delete this._prevAnimPlayer;
                this._stopAnim(this._animPlayer);
            }
        }
        var zoomOrigin = view['around'] || null;
        var renderer = this._getRenderer(), framer = function framer(fn) {
            renderer.callInNextFrame(fn);
        };
        var player = this._animPlayer = Animation.animate(props, {
            'easing': options['easing'] || 'out',
            'duration': options['duration'] || this.options['zoomAnimationDuration'],
            'framer': framer,
            'repeat': options['repeat']
        }, function(frame) {
            if (_this.isRemoved()) {
                player.finish();
                return;
            }
            if (player.playState === 'running') {
                if (frame.styles['center']) {
                    var center = frame.styles['center'];
                    _this._setPrjCenter(projection.project(center));
                    _this._centerZ = center.z;
                    _this.onMoving(_this._parseEventFromCoord(_this.getCenter()));
                } else if (frame.styles['prjCenter']) {
                    var _center = frame.styles['prjCenter'];
                    _this._setPrjCenter(_center);
                    _this.onMoving(_this._parseEventFromCoord(_this.getCenter()));
                }
                if (!isNil(frame.styles['zoom'])) _this.onZooming(frame.styles['zoom'], zoomOrigin);
                if (!isNil(frame.styles['pitch'])) _this._setPitch(frame.styles['pitch']);
                if (!isNil(frame.styles['bearing'])) _this._setBearing(frame.styles['bearing']);
                _this._fireEvent('animating');
            } else if (player.playState !== 'paused' || player === _this._mapAnimPlayer) {
                if (!player._interupted) {
                    if (props['center']) _this._setPrjCenter(projection.project(props['center'][1]));
                    else if (props['prjCenter']) _this._setPrjCenter(props['prjCenter'][1]);
                    if (!isNil(props['pitch'])) _this._setPitch(props['pitch'][1]);
                    if (!isNil(props['bearing'])) _this._setBearing(props['bearing'][1]);
                }
                _this._endAnim(player, props, zoomOrigin, options);
            }
            if (step) step(frame);
        }, this);
        this._startAnim(props, zoomOrigin);
        return player;
    },
    _animateTo: function _animateTo(view, options = {}, step) {
        if (this._mapAnimPlayer) this._stopAnim(this._mapAnimPlayer);
        this._isInternalAnimation = true;
        this._mapAnimPlayer = this.animateTo(view, options, step);
        delete this._isInternalAnimation;
        return this._mapAnimPlayer;
    },
    flyTo: function flyTo(view, options = {}, step) {
        var _this2 = this;
        view = extend$2({}, this.getView(), view);
        view.bearing = view.bearing % 360;
        if (options.counterclockwise) reverseBearing(view, this);
        if (needValidateView(view, this)) this._validateView(view);
        if (this._animPlayer) {
            if (this._isInternalAnimation) {
                if (this._animPlayer.playState === 'running') {
                    this._animPlayer.pause();
                    this._prevAnimPlayer = this._animPlayer;
                }
            } else {
                delete this._prevAnimPlayer;
                this._stopAnim(this._animPlayer);
            }
        }
        if (isFunction(options)) {
            step = options;
            options = {};
        }
        options = extend$2({
            curve: 1.42
        }, options);
        var map = this;
        function zoomScale(z0, z1) {
            return map.getResolution(z1) / map.getResolution(z0);
        }
        var zoomOrigin = view['around'] || new Point(this.width / 2, this.height / 2);
        var minZoom = this.getMinZoom();
        var maxZoom = this.getMaxZoom();
        var projection = this.getProjection();
        var currView = this.getView();
        var startZoom = currView.zoom;
        var startBearing = currView.bearing;
        var startPitch = currView.pitch;
        var zoom = 'zoom' in view ? clamp(+view.zoom, minZoom, maxZoom) : startZoom;
        var bearing = 'bearing' in view ? +view.bearing : startBearing;
        var pitch = 'pitch' in view ? +view.pitch : startPitch;
        var center = projection.project(view.center && new Coordinate(view.center) || this.getCenter());
        var scale = zoomScale(zoom, startZoom);
        var from = projection.project(this.getCenter());
        var delta = center.sub(from);
        var rho = options.curve;
        var w0 = Math.max(this.width, this.height), w1 = w0 / scale, u1 = delta.mag();
        if ('minZoom' in options) {
            var animMinZoom = clamp(Math.min(options.minZoom, startZoom, zoom), minZoom, maxZoom);
            var wMax = w0 / zoomScale(animMinZoom, startZoom);
            rho = Math.sqrt(wMax / u1 * 2);
        }
        var rho2 = rho * rho;
        function r(i) {
            var b = (w1 * w1 - w0 * w0 + (i ? -1 : 1) * rho2 * rho2 * u1 * u1) / (2 * (i ? w1 : w0) * rho2 * u1);
            return Math.log(Math.sqrt(b * b + 1) - b);
        }
        function sinh(n) {
            return (Math.exp(n) - Math.exp(-n)) / 2;
        }
        function cosh(n) {
            return (Math.exp(n) + Math.exp(-n)) / 2;
        }
        function tanh(n) {
            return sinh(n) / cosh(n);
        }
        var r0 = r(0);
        var w = function w(s) {
            return cosh(r0) / cosh(r0 + rho * s);
        };
        var u = function u(s) {
            return w0 * ((cosh(r0) * tanh(r0 + rho * s) - sinh(r0)) / rho2) / u1;
        };
        var S = (r(1) - r0) / rho;
        if (Math.abs(u1) < 0.000001 || !isFinite(S)) {
            if (Math.abs(w0 - w1) < 0.000001) return this.animateTo(view, options, step);
            var k = w1 < w0 ? -1 : 1;
            S = Math.abs(Math.log(w1 / w0)) / rho;
            u = function u() {
                return 0;
            };
            w = function w(s) {
                return Math.exp(k * rho * s);
            };
        }
        var renderer = this._getRenderer();
        var framer = function framer(fn) {
            renderer.callInNextFrame(fn);
        };
        var player = this._animPlayer = Animation.animate({
            k: [
                0,
                1
            ]
        }, {
            'easing': options['easing'] || 'out',
            'duration': options['duration'] || 8,
            'framer': framer
        }, function(frame) {
            if (_this2.isRemoved()) {
                player.finish();
                return;
            }
            var k = frame.styles.k;
            var s = k * S;
            var scale = 1 / w(s);
            var props = {};
            if (view.center) {
                var newCenter = k === 1 ? center : from.add(delta.multi(u(s)));
                props.prjCenter = [
                    center,
                    newCenter
                ];
            }
            if (startZoom !== zoom) {
                var newZoom = k === 1 ? zoom : _this2.getZoomForScale(scale, startZoom, true);
                props.zoom = [
                    startZoom,
                    newZoom
                ];
            }
            if (startPitch !== pitch) {
                var newPitch = interpolate(startPitch, pitch, k);
                props.pitch = [
                    pitch,
                    newPitch
                ];
            }
            if (startBearing !== bearing) {
                var newBearing = interpolate(startBearing, bearing, k);
                props.bearing = [
                    bearing,
                    newBearing
                ];
            }
            if (player.playState === 'running') {
                if (props['prjCenter']) {
                    var _center2 = props['prjCenter'];
                    _this2._setPrjCenter(_center2[1]);
                    _this2.onMoving(_this2._parseEventFromCoord(_this2.getCenter()));
                }
                if (props['zoom']) _this2.onZooming(props['zoom'][1], zoomOrigin);
                if (props['pitch']) _this2._setPitch(props['pitch'][1]);
                if (props['bearing']) _this2._setBearing(props['bearing'][1]);
                _this2._fireEvent('animating');
            } else if (player.playState !== 'paused' || player === _this2._mapAnimPlayer) {
                if (!player._interupted) {
                    if (props['prjCenter']) _this2._setPrjCenter(props['prjCenter'][1]);
                    if (props['pitch']) _this2._setPitch(props['pitch'][1]);
                    if (props['bearing']) _this2._setBearing(props['bearing'][1]);
                }
                _this2._endAnim(player, props, zoomOrigin, options);
            }
            if (step) step(frame);
        }, {});
        this._startAnim({
            center: view.center,
            zoom: view.zoom !== startZoom,
            pitch: pitch !== startPitch,
            bearing: bearing !== startBearing
        }, zoomOrigin);
        return this;
    },
    isAnimating: function isAnimating() {
        return !!this._animPlayer;
    },
    isRotating: function isRotating() {
        return this.isDragRotating() || !!this._animRotating;
    },
    _endAnim: function _endAnim(player, props, zoomOrigin, options) {
        delete this._animRotating;
        var evtType = player._interupted ? 'animateinterrupted' : 'animateend';
        if (player === this._animPlayer) delete this._animPlayer;
        if (player === this._mapAnimPlayer) delete this._mapAnimPlayer;
        if (props['center']) {
            var endCoord;
            if (player._interupted) endCoord = this.getCenter();
            else endCoord = props['center'][1];
            this.onMoveEnd(this._parseEventFromCoord(endCoord));
        } else if (props['prjCenter']) {
            var _endCoord;
            if (player._interupted) _endCoord = this._getPrjCenter();
            else _endCoord = props['prjCenter'][1];
            var event = this._parseEventFromCoord(this.getProjection().unproject(_endCoord));
            event['point2d'] = this._prjToPoint(_endCoord);
            this.onMoveEnd(event);
        }
        if (!isNil(props['zoom'])) {
            if (player._interupted) this.onZoomEnd(this.getZoom());
            else if (!options['wheelZoom']) this.onZoomEnd(props['zoom'][1]);
            else this.onZooming(props['zoom'][1], zoomOrigin);
        }
        if (evtType) this._fireEvent(evtType);
        if (!isNil(props['pitch']) && !this.getPitch()) this.getRenderer().setToRedraw();
        if (!options['wheelZoom']) this._resumePrev(player);
    },
    _startAnim: function _startAnim(props, zoomOrigin) {
        if (!this._animPlayer) return;
        if (props['center'] || props['prjCenter']) this.onMoveStart();
        if (props['zoom'] && !this.isZooming()) this.onZoomStart(props['zoom'][1], zoomOrigin);
        if (props['pitch'] || props['bearing']) this._animRotating = true;
        this._fireEvent('animatestart');
        this._animPlayer.play();
    },
    _stopAnim: function _stopAnim(player) {
        if (!player) return;
        delete this._animRotating;
        if (player.playState !== 'finished') {
            player._interupted = true;
            player.cancel();
        }
        if (player === this._animPlayer) delete this._animPlayer;
        if (player === this._mapAnimPlayer) delete this._mapAnimPlayer;
    },
    _resumePrev: function _resumePrev(player) {
        if (!this._prevAnimPlayer) return;
        var prevPlayer = this._prevAnimPlayer;
        if (prevPlayer.playState !== 'paused') delete this._prevAnimPlayer;
        if (player !== prevPlayer) {
            this._animPlayer = prevPlayer;
            prevPlayer.play();
        }
    }
});
function interpolate(a, b, t) {
    return a * (1 - t) + b * t;
}
var PITCH_TO_CHECK = [
    60,
    120
];
function dragEventHanlder(event) {
    event.stopPropagation();
    event.preventDefault();
}
var DRAGEVENTS = [
    'dragstart',
    'dragenter',
    'dragend',
    'dragleave',
    'dragover'
].join(' ').toString();
var events = "mousedown mouseup mouseover mouseout mouseenter mouseleave mousemove click dblclick contextmenu keypress touchstart touchmove touchend drop ";
Map$1.include({
    _registerDomEvents: function _registerDomEvents() {
        var dom = this._panels.mapWrapper || this._containerDOM;
        addDomEvent(dom, events, this._handleDOMEvent, this);
        addDomEvent(dom, DRAGEVENTS, dragEventHanlder, this);
    },
    _removeDomEvents: function _removeDomEvents() {
        var dom = this._panels.mapWrapper || this._containerDOM;
        removeDomEvent(dom, events, this._handleDOMEvent);
        removeDomEvent(dom, DRAGEVENTS, dragEventHanlder);
    },
    _handleDOMEvent: function _handleDOMEvent(e) {
        if (e && e.type === 'drop') {
            e.stopPropagation();
            e.preventDefault();
            var eventParam = this._parseEvent(e, e.type);
            eventParam = extend$2({}, eventParam, {
                dataTransfer: e.dataTransfer
            });
            this._fireEvent(e.type, eventParam);
            return;
        }
        var clickTimeThreshold = this.options['clickTimeThreshold'];
        var type = e.type;
        if (isMoveEvent(type) && !GlobalConfig.isTest && isMousemoveEventBlocked(this, this.options['mousemoveThrottleTime'])) return;
        var isMouseDown = type === 'mousedown' || type === 'touchstart' && (!e.touches || e.touches.length === 1);
        if (isMouseDown) {
            this._domMouseDownTime = now();
            this._domMouseDownView = this.getView();
        }
        var isRotating = type === 'contextmenu' && isRotatingMap(this);
        if (type === 'contextmenu') {
            preventDefault(e);
            var downTime = this._domMouseDownTime;
            var time = now();
            if (time - downTime <= clickTimeThreshold && !isRotating) this._fireDOMEvent(this, e, 'dom:' + e.type);
        } else this._fireDOMEvent(this, e, 'dom:' + e.type);
        if (this._ignoreEvent(e)) return;
        var mimicClick = false;
        if (isMouseDown) this._mouseDownTime = now();
        else if (type === 'click' || type === 'touchend' || type === 'contextmenu') {
            if (!this._mouseDownTime) return;
            else {
                var _downTime = this._mouseDownTime;
                delete this._mouseDownTime;
                var _time = now();
                if (_time - _downTime > clickTimeThreshold) {
                    if (type === 'click' || type === 'contextmenu') return;
                } else if (type === 'contextmenu') {
                    if (isRotating) return;
                } else if (type === 'touchend') mimicClick = true;
            }
        }
        var mimicEvent;
        if (mimicClick) {
            if (this._clickTime && now() - this._clickTime <= clickTimeThreshold) {
                delete this._clickTime;
                mimicEvent = 'dblclick';
                this._fireDOMEvent(this, e, 'dom:dblclick');
            } else {
                this._clickTime = now();
                mimicEvent = 'click';
                this._fireDOMEvent(this, e, 'dom:click');
            }
        }
        if (this._ignoreEvent(e)) return;
        this._fireDOMEvent(this, e, type);
        if (mimicEvent) this._fireDOMEvent(this, e, mimicEvent);
    },
    _ignoreEvent: function _ignoreEvent(domEvent) {
        if (!domEvent || !this._panels.control) return false;
        var target = domEvent.srcElement || domEvent.target;
        var preTarget;
        if (target) while(target && target !== this._containerDOM){
            if (target.className && target.className.indexOf && (target.className.indexOf('maptalks-control') >= 0 || target.className.indexOf('maptalks-ui') >= 0 && preTarget && !preTarget['eventsPropagation'])) return true;
            preTarget = target;
            target = target.parentNode;
        }
        return false;
    },
    _isEventOutMap: function _isEventOutMap(domEvent) {
        var actualEvent = this._getActualEvent(domEvent);
        var cp = getEventContainerPoint(actualEvent, this._containerDOM);
        return this._isContainerPointOutOfMap(cp);
    },
    _isContainerPointOutOfMap: function() {
        var from = [
            0,
            0,
            0
        ];
        var to = [
            0,
            0,
            0
        ];
        var ray = new Ray(from, to);
        var rayOnGround = [
            0,
            0,
            0
        ];
        return function(containerPoint) {
            var pitch = this.getPitch();
            if (pitch > PITCH_TO_CHECK[0] && pitch < PITCH_TO_CHECK[1]) {
                this.getContainerPointRay(from, to, containerPoint, 0, 0.5);
                ray.setFromTo(from, to);
                var intersection = ray.intersectGround(rayOnGround);
                if (!intersection) return true;
                var t = ray.distanceToGround();
                if (t <= 0) return true;
            }
            return false;
        };
    }(),
    _wrapTerrainData: function _wrapTerrainData(eventParam) {
        if (this.options['queryTerrainInMapEvents'] && eventParam.containerPoint && !eventParam.terrain) eventParam.terrain = this._queryTerrainInfo(eventParam.containerPoint);
    },
    _parseEvent: function _parseEvent(e, type) {
        if (!e) return null;
        var eventParam = {
            'domEvent': e
        };
        if (type !== 'keypress') {
            var actual = this._getActualEvent(e);
            if (actual && actual.clientX !== undefined) {
                var containerPoint = getEventContainerPoint(actual, this._containerDOM);
                eventParam = extend$2(eventParam, {
                    'containerPoint': containerPoint,
                    'viewPoint': this.containerPointToViewPoint(containerPoint)
                });
                if (!this._isContainerPointOutOfMap(containerPoint)) eventParam = extend$2(eventParam, {
                    'coordinate': this.containerPointToCoord(containerPoint),
                    'point2d': this._containerPointToPoint(containerPoint)
                });
            }
        }
        this._wrapTerrainData(eventParam);
        return eventParam;
    },
    _parseEventFromCoord: function _parseEventFromCoord(coord) {
        var containerPoint = this.coordToContainerPoint(coord), viewPoint = this.containerPointToViewPoint(containerPoint);
        var e = {
            'coordinate': coord,
            'containerPoint': containerPoint,
            'viewPoint': viewPoint,
            'point2d': this.coordToPoint(coord)
        };
        return e;
    },
    _getActualEvent: function _getActualEvent(e) {
        e;
        return e.touches && e.touches.length > 0 ? e.touches[0] : e.changedTouches && e.changedTouches.length > 0 ? e.changedTouches[0] : e;
    },
    _fireDOMEvent: function _fireDOMEvent(target, e, type) {
        var _this = this;
        if (this.isRemoved()) return;
        var eventParam = this._parseEvent(e, type);
        if (!eventParam.coordinate && type !== 'keypress' && type.indexOf('dom:') === -1) return;
        this._wrapTerrainData(eventParam);
        if (isMoveEvent(type)) this.getRenderer().callInNextFrame(function() {
            if (eventParam.domEvent && eventParam.domEvent._cancelBubble) {
                _this._fireEvent('_' + type, eventParam);
                return;
            }
            _this._fireEvent(type, eventParam);
        });
        else this._fireEvent(type, eventParam);
    },
    _getEventParams: function _getEventParams(e) {
        var map = this;
        var eventParam = {
            'domEvent': e
        };
        var actual = e.touches && e.touches.length > 0 ? e.touches[0] : e.changedTouches && e.changedTouches.length > 0 ? e.changedTouches[0] : e;
        if (actual) {
            var containerPoint = getEventContainerPoint(actual, map.getContainer());
            eventParam['coordinate'] = map.containerPointToCoordinate(containerPoint);
            eventParam['containerPoint'] = containerPoint;
            eventParam['viewPoint'] = map.containerPointToViewPoint(containerPoint);
            eventParam['point2d'] = map._containerPointToPoint(containerPoint);
        }
        this._wrapTerrainData(eventParam);
        return eventParam;
    }
});
Map$1.addOnLoadHook('_registerDomEvents');
Map$1.mergeOptions({
    'queryTerrainInMapEvents': true
});
function isRotatingMap(map) {
    if (!map._domMouseDownView) return true;
    var view = map.getView(), mouseDownView = map._domMouseDownView;
    return view.bearing !== mouseDownView.bearing || view.pitch !== mouseDownView.pitch;
}
Map$1.include({
    isFullScreen: function isFullScreen() {
        var doc = document;
        return !!(doc.webkitIsFullScreen || doc.mozFullScreen || doc.msFullscreenElement || doc.fullscreenElement);
    },
    requestFullScreen: function requestFullScreen(dom) {
        this._fireEvent('fullscreenstart');
        this._requestFullScreen(dom || this._containerDOM);
        this._fireEvent('fullscreenend');
        return this;
    },
    cancelFullScreen: function cancelFullScreen() {
        this._cancelFullScreen();
        this._fireEvent('cancelfullscreen');
        return this;
    },
    _requestFullScreen: function _requestFullScreen(dom) {
        if (dom.requestFullscreen) dom.requestFullscreen();
        else if (dom.mozRequestFullScreen) dom.mozRequestFullScreen();
        else if (dom.webkitRequestFullScreen) dom.webkitRequestFullScreen();
        else if (dom.msRequestFullScreen) dom.msRequestFullScreen();
        else {
            var features = "fullscreen=1,status=no,resizable=yes,top=0,left=0,scrollbars=no,titlebar=no,menubar=no,location=no,toolbar=no,z-look=yes,width=" + (screen.availWidth - 8) + ',height=' + (screen.availHeight - 45);
            var newWin = window.open(location.href, '_blank', features);
            if (newWin !== null) {
                window.opener = null;
                window.close();
            }
        }
    },
    _cancelFullScreen: function _cancelFullScreen() {
        var doc = document;
        if (document.exitFullscreen) document.exitFullscreen();
        else if (doc.mozCancelFullScreen) doc.mozCancelFullScreen();
        else if (doc.webkitCancelFullScreen) doc.webkitCancelFullScreen();
        else {
            var features = "fullscreen=no,status=yes,resizable=yes,scrollbars=no,titlebar=no,menubar=yes,location=yes,toolbar=yes,z-look=yes";
            var newWin = window.open(location.href, '_blank', features);
            if (newWin !== null) {
                window.opener = null;
                window.close();
            }
        }
    }
});
Map$1.include({
    panTo: function panTo(coordinate, options = {}, step) {
        if (!coordinate) return this;
        if (isFunction(options)) {
            step = options;
            options = {};
        }
        coordinate = new Coordinate(coordinate);
        if (typeof options['animation'] === 'undefined' || options['animation']) {
            var prjCoord = this.getProjection().project(coordinate);
            return this._panAnimation(prjCoord, options['duration'], step);
        } else this.setCenter(coordinate);
        return this;
    },
    _panTo: function _panTo(prjCoord, options = {}) {
        if (typeof options['animation'] === 'undefined' || options['animation']) return this._panAnimation(prjCoord, options['duration']);
        else {
            this.onMoveStart();
            this._setPrjCenter(prjCoord);
            this.onMoveEnd(this._parseEventFromCoord(this.getCenter()));
            return this;
        }
    },
    panBy: function panBy(offset, options = {}, step) {
        if (!offset) return this;
        if (isFunction(options)) {
            step = options;
            options = {};
        }
        offset = new Point(offset);
        var containerExtent = this.getContainerExtent();
        var ymin = containerExtent.ymin;
        if (ymin > 0 && offset.y > 30) {
            var y = offset.y;
            offset.y = 30;
            offset.x = offset.x * 30 / y;
            console.warn('offset is limited to panBy when pitch is above maxPitch');
        }
        if (typeof options['animation'] === 'undefined' || options['animation']) {
            offset = offset.multi(-1);
            var target = this._containerPointToPrj(new Point(this.width / 2 + offset.x, this.height / 2 + offset.y));
            this._panAnimation(target, options['duration'], step);
        } else {
            this.onMoveStart();
            this._offsetCenterByPixel(offset);
            var endCoord = this.containerPointToCoord(new Point(this.width / 2, this.height / 2));
            this.onMoveEnd(this._parseEventFromCoord(endCoord));
        }
        return this;
    },
    _panAnimation: function _panAnimation(target, t, cb) {
        return this._animateTo({
            'prjCenter': target
        }, {
            'duration': t || this.options['panAnimationDuration']
        }, cb);
    }
});
Map$1.include({
    computeLength: function computeLength(coord1, coord2) {
        if (!this.getProjection()) return null;
        var p1 = new Coordinate(coord1), p2 = new Coordinate(coord2);
        if (p1.equals(p2)) return 0;
        return this.getProjection().measureLength(p1, p2);
    },
    computeGeometryLength: function computeGeometryLength(geometry) {
        return geometry._computeGeodesicLength(this.getProjection());
    },
    computeGeometryArea: function computeGeometryArea(geometry) {
        return geometry._computeGeodesicArea(this.getProjection());
    },
    identify: function identify(opts, callback) {
        opts = opts || {};
        var coordinate = new Coordinate(opts.coordinate);
        return this._identify(opts, callback, function(layer) {
            return layer.identify(coordinate, opts);
        });
    },
    identifyAtPoint: function identifyAtPoint(opts, callback) {
        var isMapGeometryEvent = opts.includeInternals;
        var tolerance = opts.tolerance;
        opts = opts || {};
        var containerPoint = new Point(opts['containerPoint']);
        var coordinate = this.containerPointToCoord(containerPoint);
        return this._identify(opts, callback, function(layer) {
            var result;
            var containerPoint = opts.containerPoint;
            if (isMapGeometryEvent && !isNil(layer.options.geometryEventTolerance)) {
                opts.tolerance = opts.tolerance || 0;
                opts.tolerance += layer.options.geometryEventTolerance;
            }
            if (layer._hasGeoListeners && isMapGeometryEvent && opts.eventTypes.indexOf('mousemove') >= 0) {
                if (!layer._hasGeoListeners(opts.eventTypes)) return [];
            }
            if (layer.identifyAtPoint) result = layer.identifyAtPoint(containerPoint, opts);
            else if (coordinate && layer.identify) result = layer.identify(coordinate, opts);
            else result = [];
            if (isMapGeometryEvent) {
                if (isNil(tolerance)) delete opts.tolerance;
                else opts.tolerance = tolerance;
            }
            if (!result || !result.length) {
                layer.fire('identifyempty', opts);
                if (layer.getLayers && isFunction(layer.getLayers)) {
                    var layers = (layer.getLayers() || []).filter(function(childLayer) {
                        return childLayer;
                    });
                    layers.forEach(function(childLayer) {
                        childLayer.fire('identifyempty', opts);
                    });
                }
            }
            return result;
        });
    },
    _identify: function _identify(opts, callback, fn) {
        var reqLayers = opts['layers'];
        if (!isArrayHasData(reqLayers)) return this;
        var eventTypes = opts.eventTypes;
        var layers = [];
        for(var i = 0, len = reqLayers.length; i < len; i++)if (isString(reqLayers[i])) layers.push(this.getLayer(reqLayers[i]));
        else layers.push(reqLayers[i]);
        if (eventTypes) layers = layers.filter(function(layer) {
            if (!layer._hasGeoListeners) return true;
            return layer._hasGeoListeners(eventTypes);
        });
        var hits = [];
        for(var _i = layers.length - 1; _i >= 0; _i--){
            if (opts['count'] && hits.length >= opts['count']) break;
            var layer = layers[_i];
            if (!layer || !layer.getMap() || !opts['includeInvisible'] && !layer.isVisible() || !opts['includeInternals'] && layer.getId().indexOf(INTERNAL_LAYER_PREFIX) >= 0) continue;
            var layerHits = fn(layer);
            var layerId = layer.getId();
            if (layerHits) {
                if (Array.isArray(layerHits)) {
                    for(var _i2 = 0; _i2 < layerHits.length; _i2++)if (layerHits[_i2] && !layerHits[_i2].getLayer && isNil(layerHits[_i2].layer)) layerHits[_i2].layer = layerId;
                    pushIn(hits, layerHits);
                } else {
                    if (!layerHits.getLayer && isNil(layerHits.layer)) layerHits.layer = layerId;
                    hits.push(layerHits);
                }
            }
        }
        callback.call(this, hits);
        return this;
    }
});
Map$1.include({
    _zoom: function _zoom(nextZoom, origin) {
        if (!this.options['zoomable'] || this.isZooming()) return;
        origin = this._checkZoomOrigin(origin);
        nextZoom = this._checkZoom(nextZoom);
        this.onZoomStart(nextZoom, origin);
        this._frameZoom = this.getZoom();
        this.onZoomEnd(nextZoom, origin);
    },
    _zoomAnimation: function _zoomAnimation(nextZoom, origin, startScale) {
        if (!this.options['zoomable'] || this.isZooming()) return;
        nextZoom = this._checkZoom(nextZoom);
        if (this.getZoom() === nextZoom) return;
        origin = this._checkZoomOrigin(origin);
        this._startZoomAnim(nextZoom, origin, startScale);
    },
    _checkZoomOrigin: function _checkZoomOrigin(origin) {
        if (!origin || this.options['zoomInCenter'] || this._isContainerPointOutOfMap(origin)) origin = new Point(this.width / 2, this.height / 2);
        if (this.options['zoomOrigin']) origin = new Point(this.options['zoomOrigin']);
        return origin;
    },
    _startZoomAnim: function _startZoomAnim(nextZoom, origin, startScale) {
        if (isNil(startScale)) startScale = 1;
        var endScale = this._getResolution(this._startZoomVal) / this._getResolution(nextZoom);
        var duration = this.options['zoomAnimationDuration'] * Math.abs(endScale - startScale) / Math.abs(endScale - 1);
        this._frameZoom = this._startZoomVal;
        this._animateTo({
            'zoom': nextZoom,
            'around': origin
        }, {
            'continueOnViewChanged': true,
            'duration': duration
        });
    },
    onZoomStart: function onZoomStart(nextZoom, origin) {
        if (!this.options['zoomable'] || this.isZooming()) return;
        if (this._mapAnimPlayer) this._stopAnim(this._mapAnimPlayer);
        delete this.cameraZenithDistance;
        this._zooming = true;
        this._startZoomVal = this.getZoom();
        this._startZoomCoord = origin && this._containerPointToPrj(origin);
        this._fireEvent('zoomstart', {
            'from': this._startZoomVal,
            'to': nextZoom
        });
    },
    onZooming: function onZooming(nextZoom, origin, startScale) {
        if (!this.options['zoomable']) return;
        var frameZoom = this._frameZoom;
        if (frameZoom === nextZoom) return;
        if (isNil(startScale)) startScale = 1;
        this._zoomTo(nextZoom, origin);
        var res = this.getResolution(nextZoom), fromRes = this.getResolution(this._startZoomVal), scale = fromRes / res / startScale, startPoint = this._startZoomCoord && this.prjToContainerPoint(this._startZoomCoord, this._startZoomVal);
        var offset = this.getViewPoint();
        if (!this.isRotating() && startPoint && origin && !startPoint.equals(origin) && scale !== 1) {
            var pitch = this.getPitch();
            var originOffset = startPoint._sub(origin)._multi(1 / (1 - scale));
            if (pitch) originOffset.y /= Math.cos(pitch * Math.PI / 180);
            origin = origin.add(originOffset);
        }
        var originX = origin && origin.x || this.width / 2;
        var originY = origin && origin.y || this.height / 2;
        var matrix = {
            'view': [
                scale,
                0,
                0,
                scale,
                (originX - offset.x) * (1 - scale),
                (originY - offset.y) * (1 - scale)
            ]
        };
        var dpr = this.getDevicePixelRatio();
        matrix['container'] = [
            scale,
            0,
            0,
            scale,
            originX * dpr * (1 - scale),
            originY * dpr * (1 - scale)
        ];
        this._fireEvent('zooming', {
            'from': this._startZoomVal,
            'to': nextZoom,
            'origin': new Point(originX, originY),
            'matrix': matrix
        });
        this._frameZoom = nextZoom;
    },
    onZoomEnd: function onZoomEnd(nextZoom, origin) {
        if (!this.options['zoomable']) return;
        var startZoomVal = this._startZoomVal;
        this._zoomTo(nextZoom, origin);
        this._zooming = false;
        this._getRenderer().onZoomEnd();
        if (!this._suppressRecenter) this._recenterOnTerrain();
        this._fireEvent('zoomend', {
            'from': startZoomVal,
            'to': nextZoom
        });
        if (!this._verifyExtent(this._getPrjCenter()) && !this.options.limitExtentOnMaxExtent) this._panTo(this._prjMaxExtent.getCenter());
    },
    _zoomTo: function _zoomTo(nextZoom, origin) {
        this._zoomLevel = nextZoom;
        this._calcMatrices();
        if (origin && this._startZoomCoord) {
            var p = this._containerPointToPoint(origin);
            var offset = p._sub(this._prjToPoint(this._getPrjCenter()));
            this._setPrjCoordAtOffsetToCenter(this._startZoomCoord, offset);
        }
    },
    _checkZoom: function _checkZoom(nextZoom) {
        var maxZoom = this.getMaxZoom(), minZoom = this.getMinZoom();
        if (nextZoom < minZoom) nextZoom = minZoom;
        if (nextZoom > maxZoom) nextZoom = maxZoom;
        return nextZoom;
    }
});
function applyMatrix(out, v, e) {
    var x = v[0], y = v[1], z = v[2];
    var w = 1 / (e[3] * x + e[7] * y + e[11] * z + e[15]);
    out[0] = (e[0] * x + e[4] * y + e[8] * z + e[12]) * w;
    out[1] = (e[1] * x + e[5] * y + e[9] * z + e[13]) * w;
    out[2] = (e[2] * x + e[6] * y + e[10] * z + e[14]) * w;
    return out;
}
function matrixToQuaternion(out, te) {
    var m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10], trace = m11 + m22 + m33;
    var s;
    if (trace > 0) {
        s = 0.5 / Math.sqrt(trace + 1.0);
        out.w = 0.25 / s;
        out.x = (m32 - m23) * s;
        out.y = (m13 - m31) * s;
        out.z = (m21 - m12) * s;
    } else if (m11 > m22 && m11 > m33) {
        s = 2.0 * Math.sqrt(1.0 + m11 - m22 - m33);
        out.w = (m32 - m23) / s;
        out.x = 0.25 * s;
        out.y = (m12 + m21) / s;
        out.z = (m13 + m31) / s;
    } else if (m22 > m33) {
        s = 2.0 * Math.sqrt(1.0 + m22 - m11 - m33);
        out.w = (m13 - m31) / s;
        out.x = (m12 + m21) / s;
        out.y = 0.25 * s;
        out.z = (m23 + m32) / s;
    } else {
        s = 2.0 * Math.sqrt(1.0 + m33 - m11 - m22);
        out.w = (m21 - m12) / s;
        out.x = (m13 + m31) / s;
        out.y = (m23 + m32) / s;
        out.z = 0.25 * s;
    }
    return this;
}
function quaternionToMatrix(out, q) {
    var te = out;
    var x = q.x, y = q.y, z = q.z, w = q.w;
    var x2 = x + x, y2 = y + y, z2 = z + z;
    var xx = x * x2, xy = x * y2, xz = x * z2;
    var yy = y * y2, yz = y * z2, zz = z * z2;
    var wx = w * x2, wy = w * y2, wz = w * z2;
    te[0] = 1 - (yy + zz);
    te[4] = xy - wz;
    te[8] = xz + wy;
    te[1] = xy + wz;
    te[5] = 1 - (xx + zz);
    te[9] = yz - wx;
    te[2] = xz - wy;
    te[6] = yz + wx;
    te[10] = 1 - (xx + yy);
    te[3] = 0;
    te[7] = 0;
    te[11] = 0;
    te[12] = 0;
    te[13] = 0;
    te[14] = 0;
    te[15] = 1;
    return te;
}
function setPosition(out, v) {
    var te = out;
    te[12] = v[0];
    te[13] = v[1];
    te[14] = v[2];
    return out;
}
function lookAt(te, eye, target, up) {
    var x = [
        0,
        0,
        0
    ];
    var y = [
        0,
        0,
        0
    ];
    var z = [
        0,
        0,
        0
    ];
    subtract(z, eye, target);
    if (length(z) === 0) z[2] = 1;
    normalize(z, z);
    cross(x, up, z);
    if (length(z) === 0) {
        if (Math.abs(up[2]) === 1) z[0] += 0.0001;
        else z[2] += 0.0001;
        normalize(z, z);
        cross(x, up, z);
    }
    normalize(x, x);
    cross(y, z, x);
    te[0] = x[0];
    te[4] = y[0];
    te[8] = z[0];
    te[1] = x[1];
    te[5] = y[1];
    te[9] = z[1];
    te[2] = x[2];
    te[6] = y[2];
    te[10] = z[2];
    return te;
}
var RADIAN = Math.PI / 180;
var DEFAULT_FOV = 0.6435011087932844;
var TEMP_COORD$1 = new Coordinate(0, 0);
var TEMP_POINT$4 = new Point(0, 0);
var SOUTH = [
    0,
    -1,
    0
], BEARING = [];
var altitudesHasData = function altitudesHasData(altitudes) {
    if (isNumber(altitudes)) return altitudes !== 0;
    else if (Array.isArray(altitudes) && altitudes.length > 0) for(var i = 0, len = altitudes.length; i < len; i++){
        if (isNumber(altitudes[i]) && altitudes[i] !== 0) return true;
    }
    return false;
};
Map$1.include({
    getFov: function getFov() {
        if (!this._fov) this._fov = DEFAULT_FOV;
        return this._fov / RADIAN;
    },
    setFov: function setFov(fov) {
        if (this.isZooming()) return this;
        fov = Math.max(0.01, Math.min(60, fov));
        if (this._fov === fov) return this;
        var from = this.getFov();
        this._fov = fov * RADIAN;
        this._calcMatrices();
        this._renderLayers();
        this._fireEvent('fovchange', {
            'from': from,
            'to': this.getFov()
        });
        return this;
    },
    getBearing: function getBearing() {
        if (!this._angle) return 0;
        return -this._angle / RADIAN;
    },
    setBearing: function setBearing(bearing) {
        var view = {
            bearing: bearing
        };
        this._validateView(view);
        if (this._mapAnimPlayer) this._stopAnim(this._mapAnimPlayer);
        return this._setBearing(view.bearing);
    },
    _setBearing: function _setBearing(bearing) {
        if (Browser$1.ie9) throw new Error('map can\'t rotate in IE9.');
        var b = -wrap(bearing, -180, 180) * RADIAN;
        if (this._angle === b) return this;
        var from = this.getBearing();
        this._fireEvent('rotatestart', {
            'from': from,
            'to': b
        });
        this._angle = b;
        this._calcMatrices();
        this._renderLayers();
        this._fireEvent('rotate', {
            'from': from,
            'to': b
        });
        this._fireEvent('rotateend', {
            'from': from,
            'to': b
        });
        return this;
    },
    getPitch: function getPitch() {
        if (!this._pitch) return 0;
        return this._pitch / Math.PI * 180;
    },
    setPitch: function setPitch(pitch) {
        var view = {
            pitch: pitch
        };
        this._validateView(view);
        if (this._mapAnimPlayer) this._stopAnim(this._mapAnimPlayer);
        return this._setPitch(view.pitch);
    },
    _setPitch: function _setPitch(pitch) {
        if (Browser$1.ie9) throw new Error('map can\'t tilt in IE9.');
        var p = clamp(pitch, 0, this.options['maxPitch']) * RADIAN;
        if (this._pitch === p) return this;
        var from = this.getPitch();
        this._fireEvent('pitchstart', {
            'from': from,
            'to': p
        });
        this._pitch = p;
        this._calcMatrices();
        this._renderLayers();
        this._fireEvent('pitch', {
            'from': from,
            'to': p
        });
        this._fireEvent('pitchend', {
            'from': from,
            'to': p
        });
        return this;
    },
    setCameraMovements: function setCameraMovements(frameOptions, extraOptions) {
        var _this = this;
        if (!Array.isArray(frameOptions) || !frameOptions.length) return this;
        frameOptions.forEach(function(frameOption) {
            _this._validateView(frameOption);
        });
        this.setView({
            center: frameOptions[0].center,
            zoom: frameOptions[0].zoom,
            pitch: frameOptions[0].pitch,
            bearing: frameOptions[0].bearing
        });
        if (frameOptions.length === 1) return this;
        var index = 1;
        var _onFrame = function onFrame(frame) {
            if (frame.state.playState === 'finished') {
                index++;
                if (index === frameOptions.length - 1) _onFrame = null;
                var frameOption = frameOptions[index];
                frameOption.duration = frameOption.timestamp - frameOptions[index - 1].timestamp;
                if (extraOptions && extraOptions.autoRotate) frameOption.bearing = calculateBearing(frameOptions[index - 1].center, frameOption.center);
                _this._setCameraMovement(frameOption, _onFrame);
            }
        };
        if (frameOptions.length === 2) _onFrame = null;
        var currentBearing = this.getBearing();
        this._setCameraMovement(Object.assign({
            bearing: currentBearing,
            duration: frameOptions[index].timestamp - frameOptions[index - 1].timestamp
        }, frameOptions[index]), _onFrame);
        var play = function play() {
            _this._animPlayer.play();
        };
        var pause = function pause() {
            _this._animPlayer.pause();
        };
        var cancel = function cancel() {
            _this._animPlayer.cancel();
        };
        var finish = function finish() {
            _this._animPlayer.finish();
        };
        var reverse = function reverse() {
            _this._animPlayer.reverse();
        };
        return {
            play: play,
            pause: pause,
            cancel: cancel,
            finish: finish,
            reverse: reverse
        };
    },
    _setCameraMovement: function _setCameraMovement(frameOption, frame) {
        this.animateTo({
            zoom: frameOption.zoom,
            center: frameOption.center,
            pitch: frameOption.pitch,
            bearing: frameOption.bearing
        }, {
            duration: frameOption.duration,
            easing: 'out'
        }, frame);
    },
    setCameraOrientation: function setCameraOrientation(params) {
        var { position: position } = params;
        this._validateView(params);
        var { pitch: pitch, bearing: bearing } = params;
        pitch = pitch || 0;
        bearing = bearing || 0;
        var { zoom: zoom, cameraToGroundDistance: cameraToGroundDistance } = this.getFitZoomForCamera(position, pitch);
        var dist = Math.sin(pitch * RADIAN) * cameraToGroundDistance;
        var wrapBearing = wrap(bearing, -180, 180);
        var bearingRadian = wrapBearing * RADIAN;
        var glRes = this.getGLRes();
        var tempCoord = new Coordinate(position[0], position[1]);
        var tempPoint = this.coordToPointAtRes(tempCoord, glRes);
        var point = new Point(0, 0);
        point.x = tempPoint.x + dist * Math.sin(bearingRadian);
        point.y = tempPoint.y + dist * Math.cos(bearingRadian);
        var prjCenter = this._pointToPrjAtRes(point, this.getGLRes());
        this._setPrjCenter(prjCenter);
        this.setView({
            bearing: bearing,
            pitch: pitch,
            zoom: zoom
        });
        return this;
    },
    setCameraPosition: function setCameraPosition(coordinate) {
        var glRes = this.getGLRes();
        var cameraPoint = this.coordToPointAtRes(coordinate, glRes);
        cameraPoint.z = this.altitudeToPoint(coordinate.z || 0, glRes);
        var center = this.getCenter();
        var centerPoint = this.coordToPointAtRes(center, glRes);
        centerPoint.z = this.altitudeToPoint(center.z, glRes);
        var direction = subtract([], cameraPoint.toArray(), centerPoint.toArray());
        set(this.cameraUp || [
            0,
            0,
            0
        ], 0, 0, 1);
        this._pitch = angle(direction, this.cameraUp);
        set(BEARING, direction[0], direction[1], 0);
        this._angle = -angle(BEARING, SOUTH);
        this._zoomLevel = this.getFitZoomForCamera(coordinate, this._pitch).zoom;
        this._calcMatrices();
    },
    getFitZoomForCamera: function getFitZoomForCamera(cameraPosition, pitch) {
        var z = Array.isArray(cameraPosition) ? cameraPosition[2] : cameraPosition.z;
        var cameraAltitude = z * this._meterToGLPoint;
        var centerAltitude = this.centerAltitude || 0;
        var centerPointZ = centerAltitude * this._meterToGLPoint;
        var cz = cameraAltitude - centerPointZ;
        var pitchRadian = pitch * RADIAN;
        var cameraToGroundDistance = cz / Math.cos(pitchRadian);
        var cameraToCenterDistance = cameraToGroundDistance + centerPointZ;
        var zoom = this.getFitZoomForAltitude(cameraToCenterDistance);
        return {
            zoom: zoom,
            cameraToGroundDistance: cameraToGroundDistance
        };
    },
    getFitZoomForAltitude: function getFitZoomForAltitude(distance) {
        var ratio = this._getFovRatio();
        var scale = distance * ratio * 2 / (this.height || 1) * this.getGLRes();
        var resolutions = this._getResolutions();
        var z = 0;
        for(z; z < resolutions.length - 1; z++){
            if (resolutions[z] === scale) return z;
            else if (resolutions[z + 1] === scale) return z + 1;
            else if (scale < resolutions[z] && scale > resolutions[z + 1]) {
                z = (scale - resolutions[z]) / (resolutions[z + 1] - resolutions[z]) + z;
                return z - 1;
            } else continue;
        }
        return z;
    },
    isTransforming: function isTransforming() {
        return !!(this._pitch || this._angle);
    },
    getFrustumAltitude: function getFrustumAltitude() {
        return this._frustumAltitude;
    },
    _calcFrustumAltitude: function _calcFrustumAltitude() {
        var pitch = 90 - this.getPitch();
        var fov = this.getFov() / 2;
        var cameraAlt = this.cameraPosition ? this.cameraPosition[2] : 0;
        if (fov <= pitch) return cameraAlt;
        fov = Math.PI * fov / 180;
        var d1 = new Point(this.cameraPosition).distanceTo(new Point(this.cameraLookAt)), d2 = cameraAlt * Math.tan(fov * 2);
        var d = Math.tan(fov) * (d1 + d2);
        return cameraAlt + d;
    },
    _pointToContainerPoint: function _pointToContainerPoint(point, zoom, altitude = 0, out) {
        var res = this._getResolution(zoom);
        return this._pointAtResToContainerPoint(point, res, altitude, out);
    },
    _pointAtResToContainerPoint: function _pointAtResToContainerPoint(point, res, altitude = 0, out) {
        if (!out) out = new Point(0, 0);
        point = this._pointAtResToPoint(point, res, out);
        var isTransforming = this.isTransforming();
        var centerPoint;
        if (!isTransforming && !altitude) centerPoint = this._prjToPoint(this._getPrjCenter(), undefined, TEMP_COORD$1);
        this._toContainerPoint(out, isTransforming, altitude, centerPoint);
        return out;
    },
    _pointsAtResToContainerPoints: function _pointsAtResToContainerPoints(points, targetRes, altitudes = [], resultPoints = []) {
        var pitch = this.getPitch(), bearing = this.getBearing();
        var scale = targetRes / this._getResolution();
        if (pitch === 0 && bearing === 0 && !altitudesHasData(altitudes)) {
            var { xmin: xmin, ymin: ymin, xmax: xmax, ymax: ymax } = this.get2DExtent();
            if (xmax > xmin && ymax > ymin) {
                var { width: width, height: height } = this.getSize();
                var dxPerPixel = (xmax - xmin) / width, dyPerPixel = (ymax - ymin) / height;
                for(var i = 0, len = points.length; i < len; i++){
                    if (!points[i]) {
                        resultPoints[i] = null;
                        continue;
                    }
                    var pt = resultPoints[i];
                    pt.x = points[i].x;
                    pt.y = points[i].y;
                    pt._multi(scale);
                    pt.x = (pt.x - xmin) * dxPerPixel;
                    pt.y = height - (pt.y - ymin) * dyPerPixel;
                }
                return resultPoints;
            }
        }
        var altitudeIsArray = Array.isArray(altitudes);
        var isTransforming = this.isTransforming();
        var centerPoint = this._prjToPoint(this._getPrjCenter(), undefined, TEMP_COORD$1);
        for(var _i = 0, _len = points.length; _i < _len; _i++){
            if (!points[_i]) {
                resultPoints[_i] = null;
                continue;
            }
            var _pt = resultPoints[_i];
            _pt.x = points[_i].x;
            _pt.y = points[_i].y;
            _pt._multi(scale);
            var altitude = altitudeIsArray ? altitudes[_i] || 0 : altitudes;
            this._toContainerPoint(_pt, isTransforming, altitude, centerPoint);
        }
        return resultPoints;
    },
    _toContainerPoint: function() {
        var a = [
            0,
            0,
            0
        ];
        return function(out, isTransforming, altitude, centerPoint) {
            var w2 = this.width / 2, h2 = this.height / 2;
            if (isTransforming || altitude) {
                if (!this._altitudeScale) this._altitudeScale = this.altitudeToPoint(100, this.getGLRes()) / 100;
                var _scale = this._glScale;
                set(a, out.x * _scale, out.y * _scale, altitude * this._altitudeScale);
                var t = this._projIfBehindCamera(a, this.cameraPosition, this.cameraForward);
                applyMatrix(t, t, this.projViewMatrix);
                out.x = t[0] * w2 + w2;
                out.y = -(t[1] * h2) + h2;
            } else {
                out._sub(centerPoint.x, centerPoint.y);
                out.set(out.x, -out.y);
                out._add(w2, h2);
            }
        };
    }(),
    _projIfBehindCamera: function() {
        var vectorFromCam = new Array(3);
        var proj = new Array(3);
        var sub = new Array(3);
        return function(position, cameraPos, camForward) {
            subtract(vectorFromCam, position, cameraPos);
            var camNormDot = dot(camForward, vectorFromCam);
            if (camNormDot <= 0) {
                scale(proj, camForward, camNormDot * 1.01);
                add(position, cameraPos, subtract(sub, vectorFromCam, proj));
            }
            return position;
        };
    }(),
    _containerPointToPoint: function _containerPointToPoint(p, zoom, out, height) {
        var res = this._getResolution(zoom);
        return this._containerPointToPointAtRes(p, res, out, height);
    },
    _containerPointToPointAtRes: function() {
        var coord0 = [
            0,
            0,
            0
        ], coord1 = [
            0,
            0,
            0
        ];
        return function(p, res, out, height) {
            if (this.isTransforming()) {
                this.getContainerPointRay(coord0, coord1, p);
                var x0 = coord0[0];
                var x1 = coord1[0];
                var y0 = coord0[1];
                var y1 = coord1[1];
                var z0 = coord0[2];
                var z1 = coord1[2];
                var altitudePoint = !height ? 0 : this.altitudeToPoint(height, res) * this._glScale;
                var t = z0 === z1 ? altitudePoint : (altitudePoint - z0) / (z1 - z0);
                var _x = interpolate$3(x0, x1, t);
                var _y = interpolate$3(y0, y1, t);
                if (out) {
                    out.x = _x;
                    out.y = _y;
                } else out = new Point(_x, _y);
                out._multi(1 / this._glScale);
                return this._getResolution() === res ? out : this._pointToPointAtRes(out, res, out);
            }
            var centerPoint = this._prjToPointAtRes(this._getPrjCenter(), res, out), scale = this._getResolution() / res;
            var x = scale * (p.x - this.width / 2), y = scale * (p.y - this.height / 2);
            return centerPoint._add(x, -y);
        };
    }(),
    getContainerPointRay: function() {
        var cp = [
            0,
            0,
            0
        ], coord0 = [
            0,
            0,
            0,
            1
        ], coord1 = [
            0,
            0,
            0,
            1
        ];
        return function(from, to, containerPoint, near = 0, far = 1) {
            var w2 = this.width / 2 || 1, h2 = this.height / 2 || 1;
            var p = containerPoint;
            set(cp, (p.x - w2) / w2, (h2 - p.y) / h2, 0);
            set(coord0, cp[0], cp[1], near);
            set(coord1, cp[0], cp[1], far);
            coord0[3] = coord1[3] = 1;
            applyMatrix(from, coord0, this.projViewMatrixInverse);
            applyMatrix(to, coord1, this.projViewMatrixInverse);
        };
    }(),
    _calcMatrices: function() {
        var m1 = createMat4();
        return function() {
            delete this._mapRes;
            delete this._mapGlRes;
            delete this._mapExtent2D;
            delete this._mapGlExtent2D;
            var size = this.getSize();
            var w = size.width || 1, h = size.height || 1;
            this._glScale = this.getGLScale();
            var worldMatrix = this._getCameraWorldMatrix();
            var fov = this.getFov() * Math.PI / 180;
            var farZ = this._getCameraFar(fov, this.getPitch());
            this.cameraFar = farZ;
            this.cameraNear = this.cameraCenterDistance / 20;
            var projMatrix = this.projMatrix || createMat4();
            perspective(projMatrix, fov, w / h, this.cameraNear, farZ);
            this.projMatrix = projMatrix;
            this.viewMatrix = invert(this.viewMatrix || createMat4(), worldMatrix);
            this.projViewMatrix = multiply(this.projViewMatrix || createMat4(), projMatrix, this.viewMatrix);
            this._calcCascadeMatrixes();
            this.projViewMatrixInverse = multiply(this.projViewMatrixInverse || createMat4(), worldMatrix, invert(m1, projMatrix));
            this.domCssMatrix = this._calcDomMatrix();
            this._frustumAltitude = this._calcFrustumAltitude();
            this._mapRes = this._getResolution();
            this._mapGlRes = this.getGLRes();
            this._mapExtent2D = this.get2DExtent();
            this._mapGlExtent2D = this.get2DExtentAtRes(this._mapGlRes);
        };
    }(),
    _getCameraFar: function _getCameraFar(fov, pitch) {
        var cameraCenterDistance = this.cameraCenterDistance = distance(this.cameraPosition, this.cameraLookAt);
        var distanceInMeter = cameraCenterDistance / this._meterToGLPoint;
        pitch = Math.min(pitch, 85);
        pitch = pitch * Math.PI / 180;
        var cameraFarDistance = distanceInMeter + this.options['cameraFarUndergroundInMeter'] / Math.cos(pitch);
        return Math.max(cameraFarDistance * this._meterToGLPoint, cameraCenterDistance * 5);
    },
    _calcCascadeMatrixes: function() {
        var projMatrix = createMat4();
        function cal(curPitch, pitch, out) {
            var w = this.width;
            var h = this.height;
            var fov = this.getFov() * Math.PI / 180;
            var farZ = this._getCameraFar(fov, pitch);
            var cameraCenterDistance = this.cameraCenterDistance;
            farZ = cameraCenterDistance + (farZ - cameraCenterDistance) / Math.cos((90 - pitch) * Math.PI / 180) * Math.cos((90 - curPitch) * Math.PI / 180);
            perspective(projMatrix, fov, w / h, 0.1, farZ);
            var viewMatrix = this.viewMatrix;
            return multiply(out, projMatrix, viewMatrix);
        }
        return function() {
            var pitch = this.getPitch();
            var cascadePitch0 = this.options['cascadePitches'][0];
            var cascadePitch1 = this.options['cascadePitches'][1];
            var projViewMatrix0 = this.cascadeFrustumMatrix0 = this.cascadeFrustumMatrix0 || createMat4();
            var projViewMatrix1 = this.cascadeFrustumMatrix1 = this.cascadeFrustumMatrix1 || createMat4();
            if (pitch > cascadePitch0) cal.call(this, pitch, cascadePitch0, projViewMatrix0);
            else copy$1(this.cascadeFrustumMatrix0, this.projViewMatrix);
            if (pitch > cascadePitch1) cal.call(this, pitch, cascadePitch1, projViewMatrix1);
            else copy$1(this.cascadeFrustumMatrix1, this.cascadeFrustumMatrix0);
        };
    }(),
    _calcDomMatrix: function() {
        var m = createMat4(), m1 = createMat4(), minusY = [
            1,
            -1,
            1
        ], arr = [
            0,
            0,
            0
        ];
        return function() {
            var width = this.width || 1;
            var height = this.height || 1;
            var cameraToCenterDistance = 0.5 / Math.tan(this._fov / 2) * height;
            scale$1(m, this.projMatrix, minusY);
            translate(m, m, set(arr, 0, 0, -cameraToCenterDistance));
            if (this._pitch) rotateX(m, m, this._pitch);
            if (this._angle) rotateZ(m, m, this._angle);
            identity$1(m1);
            scale$1(m1, m1, set(arr, width / 2, -height / 2, 1));
            return multiply(this.domCssMatrix || createMat4(), m1, m);
        };
    }(),
    _getFovZ: function _getFovZ(zoom) {
        var scale = this.getGLScale(zoom);
        var ratio = this._getFovRatio();
        return scale * (this.height || 1) / 2 / ratio;
    },
    _getCameraWorldMatrix: function() {
        var q = {};
        return function() {
            var glRes = this.getGLRes();
            if (!this._meterToGLPoint) this._meterToGLPoint = this.distanceToPointAtRes(100, 0, glRes).x / 100;
            var center2D = this._prjToPointAtRes(this._prjCenter, glRes, TEMP_POINT$4);
            var altitude = this.getCenter().z;
            var centerAltitude = altitude !== undefined ? altitude : this.centerAltitude || 0;
            var centerPointZ = centerAltitude * this._meterToGLPoint;
            this.cameraLookAt = set(this.cameraLookAt || [
                0,
                0,
                0
            ], center2D.x, center2D.y, centerPointZ);
            var pitch = this.getPitch() * RADIAN;
            var bearing = this.getBearing() * RADIAN;
            var cameraToCenterDistance = this._getFovZ();
            var cameraZenithDistance = this.cameraZenithDistance === undefined ? cameraToCenterDistance : this.cameraZenithDistance;
            var cameraToGroundDistance = cameraZenithDistance - centerPointZ;
            var cz = cameraToGroundDistance * Math.cos(pitch);
            var dist = Math.sin(pitch) * cameraToGroundDistance;
            var cx = center2D.x - dist * Math.sin(bearing);
            var cy = center2D.y - dist * Math.cos(bearing);
            this.cameraPosition = set(this.cameraPosition || [
                0,
                0,
                0
            ], cx, cy, cz + centerPointZ);
            this.cameraToCenterDistance = cameraToCenterDistance;
            this.cameraUp = this.cameraUp || [
                0,
                0,
                0
            ];
            this.cameraUp = this._getCameraUp(this.cameraUp, this.cameraLookAt, this.cameraPosition, pitch, bearing);
            var m = this.cameraWorldMatrix = this.cameraWorldMatrix || createMat4();
            lookAt(m, this.cameraPosition, this.cameraLookAt, this.cameraUp);
            var cameraForward = this.cameraForward || [
                0,
                0,
                0
            ];
            subtract(cameraForward, this.cameraLookAt, this.cameraPosition);
            this.cameraForward = normalize(cameraForward, cameraForward);
            matrixToQuaternion(q, m);
            quaternionToMatrix(m, q);
            setPosition(m, this.cameraPosition);
            return m;
        };
    }(),
    _getCameraUp: function() {
        var q = [
            0,
            0,
            0
        ];
        var c = [
            0,
            0,
            0
        ];
        var axis = [
            0,
            0,
            0
        ];
        return function(out, cameraPosition, cameraLookAt, pitch, bearing) {
            set(axis, 0, 0, 1);
            if (pitch === 0) set(axis, Math.sin(bearing), Math.cos(bearing), 0);
            else if (pitch === Math.PI) set(axis, -Math.sin(bearing), -Math.cos(bearing), 0);
            var lookAt = subtract(q, cameraPosition, cameraLookAt);
            normalize(lookAt, lookAt);
            var right = cross(c, lookAt, axis);
            return cross(out, right, lookAt);
        };
    }(),
    updateCenterAltitude: function updateCenterAltitude() {
        this.getRenderer().setToRedraw();
        if (!this.centerAltitude && this._hasAltitudeLayer()) this.centerAltitude = 0;
        this._recenterOnTerrain();
    },
    _recenterOnTerrain: function _recenterOnTerrain() {
        if (this.centerAltitude === undefined || this._centerZ !== undefined) return;
        var queriedAltitude = this._queryTerrainByProjCoord(this._prjCenter);
        if (isNil(queriedAltitude) && this._hasAltitudeLayer()) queriedAltitude = this.centerAltitude;
        var centerAltitude = queriedAltitude || 0;
        var pitch = this.getPitch() * RADIAN;
        var bearing = this.getBearing() * RADIAN;
        var altDist = (centerAltitude - this.centerAltitude) * this._meterToGLPoint;
        var cameraToCenterDistance = this._getFovZ();
        var cameraZenithDistance = this.cameraZenithDistance === undefined ? cameraToCenterDistance : this.cameraZenithDistance;
        var cameraToGroundDistance = cameraZenithDistance - this.centerAltitude * this._meterToGLPoint;
        var newCameraToGroundDistance = cameraToGroundDistance - altDist / Math.cos(pitch);
        var cameraPosition = this.cameraPosition;
        var dist = Math.sin(pitch) * newCameraToGroundDistance;
        var center2D = TEMP_POINT$4;
        center2D.x = cameraPosition[0] + dist * Math.sin(bearing);
        center2D.y = cameraPosition[1] + dist * Math.cos(bearing);
        var centerPointZ = centerAltitude * this._meterToGLPoint;
        this.cameraZenithDistance = (cameraPosition[2] - centerPointZ) / Math.cos(pitch) + centerPointZ;
        this.centerAltitude = centerAltitude;
        var newCenter = this.pointAtResToCoordinate(center2D, this.getGLRes(), TEMP_COORD$1);
        this._eventSilence = true;
        this._suppressRecenter = true;
        this.setCenter(newCenter);
        delete this._suppressRecenter;
        delete this._eventSilence;
        if (isNil(queriedAltitude)) delete this.centerAltitude;
    },
    _queryTerrainByProjCoord: function _queryTerrainByProjCoord(coord) {
        var layers = this._getLayers();
        for(var i = 0; i < layers.length; i++){
            if (layers[i].queryTerrainByProjCoord) return layers[i].queryTerrainByProjCoord(coord)[0];
        }
        return 0;
    },
    _hasAltitudeLayer: function _hasAltitudeLayer() {
        var layers = this._getLayers();
        for(var i = 0; i < layers.length; i++){
            if (layers[i].getTerrainLayer && layers[i].getTerrainLayer()) return true;
        }
        return false;
    },
    _queryTerrainInfo: function _queryTerrainInfo(containerPoint) {
        var layers = this._getLayers() || [];
        for(var i = 0; i < layers.length; i++){
            var layer = layers[i];
            if (containerPoint && layer && layer.queryTerrainAtPoint && layer.getTerrainLayer && layer.getTerrainLayer()) {
                var coordinate = layer.queryTerrainAtPoint(containerPoint);
                if (coordinate) return {
                    coordinate: coordinate,
                    altitude: coordinate.z
                };
                else break;
            }
        }
        return null;
    },
    _query3DTilesInfo: function _query3DTilesInfo(containerPoint) {
        var layers = this._getLayers() || [];
        for(var i = 0; i < layers.length; i++){
            var layer = layers[i];
            if (containerPoint && layer && layer.query3DTilesAtPoint) {
                var coordinate = layer.query3DTilesAtPoint(containerPoint);
                if (coordinate) return {
                    coordinate: coordinate,
                    altitude: coordinate.z
                };
                else break;
            }
        }
        return null;
    },
    queryPrjCoordAtContainerPoint: function queryPrjCoordAtContainerPoint(p) {
        var queryCoord = this._query3DTilesInfo(p);
        if (!queryCoord) queryCoord = this._queryTerrainInfo(p);
        if (queryCoord) {
            var prjCoord = this.getProjection().project(queryCoord.coordinate);
            prjCoord.z = queryCoord.altitude;
            return prjCoord;
        }
        if (this._isContainerPointOutOfMap(p)) p = new Point(this.width / 2, this.height / 2);
        return this._containerPointToPrj(p);
    },
    _getFovRatio: function _getFovRatio() {
        var fov = this.getFov();
        return Math.tan(fov / 2 * RADIAN);
    },
    _renderLayers: function _renderLayers() {
        if (this.isInteracting()) return;
        var layers = this._getLayers();
        layers.forEach(function(layer) {
            if (!layer) return;
            var renderer = layer._getRenderer();
            if (renderer && renderer.setToRedraw) renderer.setToRedraw();
        });
    }
});
function createMat4() {
    return identity$1(new Array(16));
}
function calculateBearing(start, end) {
    var lon1 = toRadian(start[0]);
    var lon2 = toRadian(end[0]);
    var lat1 = toRadian(start[1]);
    var lat2 = toRadian(end[1]);
    var a = Math.sin(lon2 - lon1) * Math.cos(lat2);
    var b = Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2) * Math.cos(lon2 - lon1);
    return toDegree(Math.atan2(a, b));
}
Map$1.include({
    _onViewChange: function _onViewChange(view) {
        if (!this._viewHistory) {
            this._viewHistory = [];
            this._viewHistoryPointer = 0;
        }
        var old = this._getCurrentView();
        for(var i = this._viewHistory.length - 1; i >= 0; i--)if (equalMapView(view, this._viewHistory[i])) {
            this._viewHistoryPointer = i;
            this._fireViewChange(old, view);
            return;
        }
        if (this._viewHistoryPointer < this._viewHistory.length - 1) this._viewHistory.splice(this._viewHistoryPointer + 1);
        this._viewHistory.push(view);
        var count = this.options['viewHistoryCount'];
        if (count > 0 && this._viewHistory.length > count) this._viewHistory.splice(0, this._viewHistory.length - count);
        this._viewHistoryPointer = this._viewHistory.length - 1;
        this._fireViewChange(old, view);
    },
    zoomToPreviousView: function zoomToPreviousView(options = {}) {
        if (!this.hasPreviousView()) return null;
        var view = this._viewHistory[--this._viewHistoryPointer];
        this._zoomToView(view, options);
        return view;
    },
    hasPreviousView: function hasPreviousView() {
        if (!this._viewHistory || this._viewHistoryPointer === 0) return false;
        return true;
    },
    zoomToNextView: function zoomToNextView(options = {}) {
        if (!this.hasNextView()) return null;
        var view = this._viewHistory[++this._viewHistoryPointer];
        this._zoomToView(view, options);
        return view;
    },
    hasNextView: function hasNextView() {
        if (!this._viewHistory || this._viewHistoryPointer === this._viewHistory.length - 1) return false;
        return true;
    },
    _zoomToView: function _zoomToView(view, options) {
        var _this = this;
        var old = this.getView();
        if (options['animation']) this._animateTo(view, {
            'duration': options['duration']
        }, function(frame) {
            if (frame.state.playState === 'finished') _this._fireViewChange(old, view);
        });
        else {
            this.setView(view);
            this._fireViewChange(old, view);
        }
    },
    getViewHistory: function getViewHistory() {
        return this._viewHistory;
    },
    _fireViewChange: function _fireViewChange(old, view) {
        this._fireEvent('viewchange', {
            'old': old,
            'new': view
        });
        this._insertUICollidesQueue();
    },
    _getCurrentView: function _getCurrentView() {
        if (!this._viewHistory) return null;
        return this._viewHistory[this._viewHistoryPointer];
    }
});
Map$1.mergeOptions({
    'viewHistory': true,
    'viewHistoryCount': 10
});
var UICollisionIndex = new CollisionIndex();
Map$1.include({
    getCollisionIndex: function getCollisionIndex() {
        if (!this._collisionIndex) this.createCollisionIndex();
        return this._collisionIndex || this.createCollisionIndex();
    },
    createCollisionIndex: function createCollisionIndex() {
        this.clearCollisionIndex();
        this._collisionIndex = new CollisionIndex();
        return this._collisionIndex;
    },
    clearCollisionIndex: function clearCollisionIndex() {
        this.collisionFrameTime = 0;
        if (this._collisionIndex) this._collisionIndex.clear();
        return this;
    },
    _insertUICollidesQueue: function _insertUICollidesQueue() {
        if (!this._uiCollidesQueue) this._uiCollidesQueue = [];
        this._uiCollidesQueue.push(1);
        return this;
    },
    uiCollides: function uiCollides() {
        if (!this.uiList || this.uiList.length === 0 || !this._uiCollidesQueue || this._uiCollidesQueue.length === 0) return this;
        var collisionIndex = UICollisionIndex;
        collisionIndex.clear();
        var uiList = this.uiList;
        for(var i = 0, len = uiList.length; i < len; i++){
            var ui = uiList[i];
            var { collisionBufferSize: collisionBufferSize, collision: collision } = ui.options;
            if (!collision) continue;
            var dom = ui.getDOM();
            if (!ui.isVisible() || !dom) continue;
            if (!dom.getBoundingClientRect) continue;
            if (!ui.bbox) ui.bbox = [
                0,
                0,
                0,
                0
            ];
            var bcRect = dom.getBoundingClientRect();
            var { x: x, y: y } = bcRect;
            var { width: width, height: height } = bcRect;
            if (width === 0 || height === 0) {
                var size = ui.getSize();
                if (size) {
                    width = size.width;
                    height = size.height;
                }
            }
            var minX = x - collisionBufferSize, maxX = x + width + collisionBufferSize;
            var minY = y - collisionBufferSize, maxY = y + height + collisionBufferSize;
            ui.bbox[0] = minX;
            ui.bbox[1] = minY;
            ui.bbox[2] = maxX;
            ui.bbox[3] = maxY;
            if (collisionIndex.collides(ui.bbox)) {
                ui._collidesEffect(false);
                continue;
            }
            collisionIndex.insertBox(ui.bbox);
            ui._collidesEffect(true);
        }
        this._uiCollidesQueue = [];
        return this;
    },
    _addUI: function _addUI(ui) {
        if (!this.uiList) this.uiList = [];
        var index = this.uiList.indexOf(ui);
        if (index > -1) return this;
        this.uiList.push(ui);
        this.uiList = this.uiList.sort(function(a, b) {
            return b.options['collisionWeight'] - a.options['collisionWeight'];
        });
        return this;
    },
    _removeUI: function _removeUI(ui) {
        if (!this.uiList) return -1;
        var index = this.uiList.indexOf(ui);
        if (index < 0) return index;
        this.uiList.splice(index, 1);
        return index;
    }
});
var TEMP_COORD = new Coordinate(0, 0);
Map$1.include({
    coordinateToPoint: function coordinateToPoint(coordinate, zoom, out) {
        var res = this._getResolution(zoom);
        return this.coordinateToPointAtRes(coordinate, res, out);
    },
    coordinateToPointAtRes: function() {
        var COORD = new Coordinate(0, 0);
        return function(coordinate, res, out) {
            var prjCoord = this.getProjection().project(coordinate, COORD);
            return this._prjToPointAtRes(prjCoord, res, out);
        };
    }(),
    pointToCoordinate: function() {
        var COORD = new Coordinate(0, 0);
        return function(point, zoom, out) {
            var prjCoord = this._pointToPrj(point, zoom, COORD);
            return this.getProjection().unproject(prjCoord, out);
        };
    }(),
    pointAtResToCoordinate: function() {
        var COORD = new Coordinate(0, 0);
        return function(point, res, out) {
            var prjCoord = this._pointToPrjAtRes(point, res, COORD);
            return this.getProjection().unproject(prjCoord, out);
        };
    }(),
    coordinateToViewPoint: function() {
        var COORD = new Coordinate(0, 0);
        return function(coordinate, out, altitude) {
            return this._prjToViewPoint(this.getProjection().project(coordinate, COORD), out, altitude);
        };
    }(),
    viewPointToCoordinate: function() {
        var COORD = new Coordinate(0, 0);
        return function(viewPoint, out) {
            return this.getProjection().unproject(this._viewPointToPrj(viewPoint, COORD), out);
        };
    }(),
    coordinateToContainerPoint: function coordinateToContainerPoint(coordinate, zoom, out) {
        var res = this._getResolution(zoom);
        return this.coordinateToContainerPointAtRes(coordinate, res, out);
    },
    coordinateToContainerPointAtRes: function() {
        var COORD = new Coordinate(0, 0);
        return function(coordinate, res, out) {
            var pCoordinate = this.getProjection().project(coordinate, COORD);
            return this._prjToContainerPointAtRes(pCoordinate, res, out, pCoordinate.z);
        };
    }(),
    coordinatesToContainerPoints: function coordinatesToContainerPoints(coordinates, zoom) {
        var res = this._getResolution(zoom);
        return this.coordinatesToContainerPointsAtRes(coordinates, res);
    },
    coordinatesToContainerPointsAtRes: function() {
        return function(coordinates, resolution) {
            var pts = [];
            var transformation = this._spatialReference.getTransformation();
            var res = resolution / this._getResolution();
            var projection = this.getProjection();
            var prjOut = new Coordinate(0, 0);
            var isTransforming = this.isTransforming();
            var centerPoint = this._prjToPoint(this._getPrjCenter(), undefined, TEMP_COORD);
            for(var i = 0, len = coordinates.length; i < len; i++){
                var pCoordinate = projection.project(coordinates[i], prjOut);
                var point = transformation.transform(pCoordinate, resolution);
                point = point._multi(res);
                this._toContainerPoint(point, isTransforming, coordinates[i].z, centerPoint);
                pts.push(point);
            }
            return pts;
        };
    }(),
    containerPointToCoordinate: function() {
        var COORD = new Coordinate(0, 0);
        return function(containerPoint, out) {
            var pCoordinate = this._containerPointToPrj(containerPoint, COORD);
            return this.getProjection().unproject(pCoordinate, out);
        };
    }(),
    containerToExtent: function() {
        var POINT0 = new Point(0, 0);
        var POINT1 = new Point(0, 0);
        return function(containerExtent) {
            var extent2D = new PointExtent(this._containerPointToPoint(containerExtent.getMin(POINT0), undefined, POINT0), this._containerPointToPoint(containerExtent.getMax(POINT1), undefined, POINT1));
            return this._pointToExtent(extent2D);
        };
    }(),
    distanceToPixel: function() {
        var POINT0 = new Point(0, 0);
        var POINT1 = new Point(0, 0);
        return function(xDist, yDist, zoom) {
            var projection = this.getProjection();
            if (!projection) return null;
            var scale = this.getScale() / this.getScale(zoom);
            var center = this.getCenter(), target = projection.locate(center, xDist, yDist);
            var p0 = this.coordToContainerPoint(center, undefined, POINT0), p1 = this.coordToContainerPoint(target, undefined, POINT1);
            p1._sub(p0)._multi(scale)._abs();
            return new Size(p1.x, p1.y);
        };
    }(),
    distanceToPoint: function distanceToPoint(xDist, yDist, zoom, paramCenter) {
        var res = this._getResolution(zoom);
        return this.distanceToPointAtRes(xDist, yDist, res, paramCenter);
    },
    distanceToPointAtRes: function() {
        var POINT = new Point(0, 0);
        var COORD = new Coordinate(0, 0);
        return function(xDist, yDist, res, paramCenter, out) {
            var projection = this.getProjection();
            if (!projection) return null;
            var center = paramCenter || this.getCenter(), target = projection.locate(center, xDist, yDist, COORD);
            var p0 = this.coordToPointAtRes(center, res, POINT), p1 = this.coordToPointAtRes(target, res, out);
            p1._sub(p0)._abs();
            return p1;
        };
    }(),
    altitudeToPoint: function() {
        var DEFAULT_CENTER = new Coordinate(0, 40);
        var POINT = new Point(0, 0);
        return function(altitude = 0, res, originCenter) {
            if (this._altitudeOriginDirty) {
                DEFAULT_CENTER.x = this._originLng;
                this._altitudeOriginDirty = false;
            }
            var p = this.distanceToPointAtRes(altitude, altitude, res, originCenter || DEFAULT_CENTER, POINT);
            if (altitude < 0 && p.x > 0) p.x = -p.x;
            var heightFactor = this.options['heightFactor'];
            if (heightFactor && heightFactor !== 1) {
                p.x *= heightFactor;
                p.y *= heightFactor;
            }
            return p.x;
        };
    }(),
    pointAtResToAltitude: function() {
        var DEFAULT_CENTER = new Coordinate(0, 40);
        return function(point = 0, res, originCenter) {
            var altitude = this.pointAtResToDistance(point, 0, res, originCenter || DEFAULT_CENTER);
            return altitude;
        };
    }(),
    pixelToDistance: function() {
        var COORD0 = new Coordinate(0, 0);
        var COORD1 = new Coordinate(0, 0);
        var TARGET0 = new Coordinate(0, 0);
        var TARGET1 = new Coordinate(0, 0);
        return function(width, height) {
            var projection = this.getProjection();
            if (!projection) return null;
            var fullExt = this.getFullExtent();
            var d = fullExt['top'] > fullExt['bottom'] ? -1 : 1;
            var coord0 = COORD0.set(this.width / 2, this.height / 2);
            var coord1 = COORD1.set(this.width / 2 + width, this.height / 2 + d * height);
            var target0 = this.containerPointToCoord(coord0, TARGET0);
            var target1 = this.containerPointToCoord(coord1, TARGET1);
            return projection.measureLength(target0, target1);
        };
    }(),
    pointToDistance: function pointToDistance(dx, dy, zoom) {
        var res = this.getResolution(zoom);
        return this.pointAtResToDistance(dx, dy, res);
    },
    pointAtResToDistance: function() {
        var POINT = new Point(0, 0);
        var PRJ_COORD = new Coordinate(0, 0);
        var COORD0 = new Coordinate(0, 0);
        var COORD1 = new Coordinate(0, 0);
        return function(dx, dy, res, paramCenter) {
            var projection = this.getProjection();
            if (!projection) return null;
            var prjCoord = paramCenter ? projection.project(paramCenter, PRJ_COORD) : this._getPrjCenter();
            var c = this._prjToPointAtRes(prjCoord, res, POINT);
            c._add(dx, dy);
            var target = this.pointAtResToCoord(c, res, COORD0);
            var src = paramCenter ? paramCenter : projection.unproject(prjCoord, COORD1);
            src.z = 0;
            target.z = 0;
            return projection.measureLength(src, target);
        };
    }(),
    locateByPoint: function() {
        var POINT = new Point(0, 0);
        return function(coordinate, px, py) {
            var point = this.coordToContainerPoint(coordinate, undefined, POINT);
            return this.containerPointToCoord(point._add(px, py));
        };
    }(),
    _get2DExtent: function _get2DExtent(zoom, out) {
        var cached;
        if ((zoom === undefined || zoom === this._zoomLevel) && this._mapExtent2D) cached = this._mapExtent2D;
        if (cached) {
            if (out) {
                out.set(cached['xmin'], cached['ymin'], cached['xmax'], cached['ymax']);
                return out;
            }
            return cached.copy();
        }
        var res = this._getResolution(zoom);
        return this._get2DExtentAtRes(res, out);
    },
    get2DExtent: function get2DExtent(zoom, out) {
        return this._get2DExtent(zoom, out);
    },
    _get2DExtentAtRes: function() {
        var POINT = new Point(0, 0);
        return function(res, out) {
            var _this = this;
            if (res === this._mapGlRes && this._mapGlExtent2D) return this._mapGlExtent2D;
            var cExtent = this.getContainerExtent();
            return cExtent.convertTo(function(c) {
                return _this._containerPointToPointAtRes(c, res, POINT);
            }, out);
        };
    }(),
    get2DExtentAtRes: function get2DExtentAtRes(res, out) {
        return this._get2DExtentAtRes(res, out);
    },
    pointToExtent: function pointToExtent(extent2D) {
        return this._pointToExtent(extent2D);
    },
    _pointToExtent: function() {
        var COORD0 = new Coordinate(0, 0);
        var COORD1 = new Coordinate(0, 0);
        return function(extent2D) {
            var min2d = extent2D.getMin(), max2d = extent2D.getMax();
            var fullExtent = this.getFullExtent();
            var [minx, maxx] = !fullExtent || fullExtent.left <= fullExtent.right ? [
                min2d.x,
                max2d.x
            ] : [
                max2d.x,
                min2d.x
            ];
            var [miny, maxy] = !fullExtent || fullExtent.top > fullExtent.bottom ? [
                max2d.y,
                min2d.y
            ] : [
                min2d.y,
                max2d.y
            ];
            var min = min2d.set(minx, maxy);
            var max = max2d.set(maxx, miny);
            return new Extent(this.pointToCoord(min, undefined, COORD0), this.pointToCoord(max, undefined, COORD1), this.getProjection());
        };
    }(),
    getViewPointFrameOffset: function() {
        var POINT = new Point(0, 0);
        return function() {
            if (this.isZooming()) return null;
            var pcenter = this._getPrjCenter();
            if (this._mapViewCoord && !this._mapViewCoord.equals(pcenter)) return this._prjToContainerPoint(this._mapViewCoord)._sub(this._prjToContainerPoint(pcenter, undefined, POINT));
            return null;
        };
    }(),
    _viewPointToPrj: function() {
        var POINT = new Point(0, 0);
        return function(viewPoint, out) {
            return this._containerPointToPrj(this.viewPointToContainerPoint(viewPoint, POINT), out);
        };
    }(),
    viewPointToPrj: function viewPointToPrj(viewPoint, out) {
        return this._viewPointToPrj(viewPoint, out);
    },
    _prjToContainerPoint: function _prjToContainerPoint(pCoordinate, zoom, out, altitude) {
        var res = this._getResolution(zoom);
        return this._prjToContainerPointAtRes(pCoordinate, res, out, altitude);
    },
    prjToContainerPoint: function prjToContainerPoint(pCoordinate, zoom, out, altitude) {
        return this._prjToContainerPoint(pCoordinate, zoom, out, altitude);
    },
    _prjToContainerPointAtRes: function() {
        var POINT = new Point(0, 0);
        return function(pCoordinate, res, out, altitude) {
            return this._pointAtResToContainerPoint(this._prjToPointAtRes(pCoordinate, res, POINT), res, altitude || 0, out);
        };
    }(),
    prjToContainerPointAtRes: function prjToContainerPointAtRes(pCoordinate, res, out, altitude) {
        return this.prjToContainerPointAtRes(pCoordinate, res, out, altitude);
    },
    _prjToViewPoint: function() {
        var POINT = new Point(0, 0);
        return function(pCoordinate, out, altitude) {
            var containerPoint = this._prjToContainerPoint(pCoordinate, undefined, POINT, altitude);
            return this.containerPointToViewPoint(containerPoint, out);
        };
    }(),
    prjToViewPoint: function prjToViewPoint(pCoordinate, out, altitude) {
        return this._prjToViewPoint(pCoordinate, out, altitude);
    },
    _viewPointToPoint: function() {
        var POINT = new Point(0, 0);
        return function(viewPoint, zoom, out) {
            return this._containerPointToPoint(this.viewPointToContainerPoint(viewPoint, POINT), zoom, out);
        };
    }(),
    viewPointToPoint: function viewPointToPoint(viewPoint, zoom, out) {
        return this._viewPointToPoint(viewPoint, zoom, out);
    },
    _pointToViewPoint: function() {
        var COORD = new Coordinate(0, 0);
        return function(point, zoom, out) {
            return this._prjToViewPoint(this._pointToPrj(point, zoom, COORD), out);
        };
    }(),
    pointToViewPoint: function pointToViewPoint(point, zoom, out) {
        return this._pointToViewPoint(point, zoom, out);
    }
});
var distancetool$2 = {
    start: "\u8D77\u70B9",
    units: {
        mile: " \u82F1\u91CC",
        feet: " \u82F1\u5C3A",
        kilometer: " \u516C\u91CC",
        meter: " \u7C73"
    }
};
var areatool$2 = {
    units: {
        mile: " \u5E73\u65B9\u82F1\u91CC",
        feet: " \u5E73\u65B9\u82F1\u5C3A",
        kilometer: " \u5E73\u65B9\u516C\u91CC",
        meter: " \u5E73\u65B9\u7C73"
    }
};
var zhCn = {
    distancetool: distancetool$2,
    areatool: areatool$2
};
var distancetool$1 = {
    start: "Inicio",
    units: {
        mile: " mi",
        feet: " ft",
        kilometer: " km",
        meter: " m"
    }
};
var areatool$1 = {
    units: {
        mile: " mi\xb2",
        feet: " ft\xb2",
        kilometer: " km\xb2",
        meter: " m\xb2"
    }
};
var esMX = {
    distancetool: distancetool$1,
    areatool: areatool$1
};
var distancetool = {
    start: "Start",
    units: {
        mile: " mi",
        feet: " ft",
        kilometer: " km",
        meter: " m"
    }
};
var areatool = {
    units: {
        mile: " mi\xb2",
        feet: " ft\xb2",
        kilometer: " km\xb2",
        meter: " m\xb2"
    }
};
var enUS = {
    distancetool: distancetool,
    areatool: areatool
};
var TranslatorError = function(_Error) {
    function TranslatorError(msg) {
        var _this;
        _this = _Error.call(this, 'Translator: ' + msg) || this;
        _this.name = 'TranslatorError';
        return _this;
    }
    _inheritsLoose(TranslatorError, _Error);
    return TranslatorError;
}(_wrapNativeSuper(Error));
var Translator = function(_Class) {
    function Translator(lang) {
        var _this2;
        _this2 = _Class.call(this) || this;
        _this2.languages = {
            'zh-CN': zhCn,
            'es-MX': esMX,
            'en-US': enUS
        };
        _this2.setLang(lang || 'zh-CN');
        return _this2;
    }
    _inheritsLoose(Translator, _Class);
    var _proto = Translator.prototype;
    _proto.setLang = function setLang(lang) {
        var newLanguageNodes = this.languages[lang];
        if (!newLanguageNodes) throw new TranslatorError('Setted Lang does not exist');
        this.nodes = newLanguageNodes;
    };
    _proto._validateNestedProps = function _validateNestedProps(nestedProps) {
        nestedProps.forEach(function(p) {
            if (p === '') throw new TranslatorError('Any of sides of a dot "." cannot be empty');
        });
    };
    _proto.translate = function translate(textNode = null) {
        if (textNode == null) throw new TranslatorError('Missing parameter textNode');
        if (typeof textNode === 'string') {
            var translatedText = null;
            if (textNode.includes('.')) {
                var nestedProps = textNode.split('.');
                if (nestedProps.length > 3) throw new TranslatorError("Translate function can only access through 3 nested properties, trying to access -> " + nestedProps.length);
                this._validateNestedProps(nestedProps);
                try {
                    var _translatedText = null;
                    switch(nestedProps.length){
                        case 2:
                            _translatedText = this.nodes[nestedProps[0]][nestedProps[1]];
                            break;
                        case 3:
                            _translatedText = this.nodes[nestedProps[0]][nestedProps[1]][nestedProps[2]];
                            break;
                    }
                    return _translatedText;
                } catch (err) {
                    throw new TranslatorError('Unable to find the text translated in lang json' + err.message);
                }
            } else {
                translatedText = this.nodes[textNode];
                return translatedText;
            }
        } else throw new TranslatorError('Param passed has to be a String');
    };
    return Translator;
}(Class);
var options$m = {
    'formatLabelContent': null,
    'decimalPlaces': 2,
    'mode': 'LineString',
    'language': 'zh-CN',
    'metric': true,
    'imperial': false,
    'symbol': {
        'lineColor': '#000',
        'lineWidth': 3,
        'lineOpacity': 1
    },
    'vertexSymbol': {
        'markerType': 'ellipse',
        'markerFill': '#fff',
        'markerLineColor': '#000',
        'markerLineWidth': 3,
        'markerWidth': 11,
        'markerHeight': 11
    },
    'labelOptions': {
        'textSymbol': {
            'textFaceName': 'monospace',
            'textLineSpacing': 1,
            'textHorizontalAlignment': 'right',
            'textDx': 15
        },
        'boxStyle': {
            'padding': [
                6,
                2
            ],
            'symbol': {
                'markerType': 'square',
                'markerFill': '#fff',
                'markerFillOpacity': 0.9,
                'markerLineColor': '#b4b3b3'
            }
        }
    },
    'clearButtonSymbol': [
        {
            'markerType': 'square',
            'markerFill': '#fff',
            'markerLineColor': '#b4b3b3',
            'markerLineWidth': 2,
            'markerWidth': 15,
            'markerHeight': 15,
            'markerDx': 20
        },
        {
            'markerType': 'x',
            'markerWidth': 10,
            'markerHeight': 10,
            'markerDx': 20
        }
    ]
};
var DistanceTool = function(_DrawTool) {
    function DistanceTool(options) {
        var _this;
        _this = _DrawTool.call(this, options) || this;
        _this.on('enable', _this._afterEnable, _this).on('disable', _this._afterDisable, _this);
        _this._measureLayers = [];
        _this.translator = new Translator(_this.options['language']);
        return _this;
    }
    _inheritsLoose(DistanceTool, _DrawTool);
    var _proto = DistanceTool.prototype;
    _proto.clear = function clear() {
        if (isArrayHasData(this._measureLayers)) for(var i = 0; i < this._measureLayers.length; i++)this._measureLayers[i].remove();
        delete this._lastMeasure;
        delete this._lastVertex;
        this._outLayers(this._measureLayers);
        this._measureLayers = [];
        return this;
    };
    _proto.getMeasureLayers = function getMeasureLayers() {
        return this._measureLayers;
    };
    _proto.getLastMeasure = function getLastMeasure() {
        if (!this._lastMeasure) return 0;
        return this._lastMeasure;
    };
    _proto.undo = function undo() {
        _DrawTool.prototype.undo.call(this);
        var pointer = this._historyPointer;
        if (pointer !== this._vertexes.length) for(var i = pointer; i < this._vertexes.length; i++){
            if (this._vertexes[i].label) this._vertexes[i].label.remove();
            this._vertexes[i].marker.remove();
        }
        return this;
    };
    _proto.redo = function redo() {
        _DrawTool.prototype.redo.call(this);
        var i = this._historyPointer - 1;
        if (this._vertexes[i]) {
            if (!this._vertexes[i].marker.getLayer()) {
                if (this._vertexes[i].label) this._vertexes[i].label.addTo(this._measureMarkerLayer);
                this._vertexes[i].marker.addTo(this._measureMarkerLayer);
            }
        }
        return this;
    };
    _proto._formatLabelContent = function _formatLabelContent(params) {
        var formatLabelContent = this.options.formatLabelContent;
        if (formatLabelContent && isFunction(formatLabelContent)) return formatLabelContent.call(this, params) + '';
        return null;
    };
    _proto._measure = function _measure(toMeasure) {
        var map = this.getMap();
        var length;
        if (toMeasure instanceof Geometry) length = map.computeGeometryLength(toMeasure);
        else if (Array.isArray(toMeasure)) length = map.getProjection().measureLength(toMeasure);
        this._lastMeasure = length;
        var result = this._formatLabelContent(length);
        if (result) return result;
        var units = [
            this.translator.translate('distancetool.units.meter'),
            this.translator.translate('distancetool.units.kilometer'),
            this.translator.translate('distancetool.units.feet'),
            this.translator.translate('distancetool.units.mile')
        ];
        var content = '';
        var decimals = this.options['decimalPlaces'];
        if (this.options['metric']) content += length < 1000 ? length.toFixed(decimals) + units[0] : (length / 1000).toFixed(decimals) + units[1];
        if (this.options['imperial']) {
            length *= 3.2808399;
            if (content.length > 0) content += '\n';
            content += length < 5280 ? length.toFixed(decimals) + units[2] : (length / 5280).toFixed(decimals) + units[3];
        }
        return content;
    };
    _proto._registerMeasureEvents = function _registerMeasureEvents() {
        this.on('drawstart', this._msOnDrawStart, this).on('drawvertex', this._msOnDrawVertex, this).on('mousemove', this._msOnMouseMove, this).on('drawend', this._msOnDrawEnd, this);
    };
    _proto._afterEnable = function _afterEnable() {
        this._registerMeasureEvents();
    };
    _proto._afterDisable = function _afterDisable() {
        this.off('drawstart', this._msOnDrawStart, this).off('drawvertex', this._msOnDrawVertex, this).off('mousemove', this._msOnMouseMove, this).off('drawend', this._msOnDrawEnd, this);
    };
    _proto._msOnDrawStart = function _msOnDrawStart(param) {
        var map = this.getMap();
        var uid = UID();
        var layerId = 'distancetool_' + uid;
        var markerLayerId = 'distancetool_markers_' + uid;
        var zIndex = this.options.zIndex;
        var enableAltitude = this.options.enableAltitude;
        if (!map.getLayer(layerId)) {
            this._measureLineLayer = new DrawToolLayer(layerId, {
                zIndex: zIndex,
                enableAltitude: enableAltitude
            }).addTo(map);
            this._measureMarkerLayer = new DrawToolLayer(markerLayerId, {
                zIndex: zIndex,
                enableAltitude: enableAltitude
            }).addTo(map);
        } else {
            this._measureLineLayer = map.getLayer(layerId);
            this._measureMarkerLayer = map.getLayer(markerLayerId);
        }
        this._measureLayers.push(this._measureLineLayer);
        this._measureLayers.push(this._measureMarkerLayer);
        this._pushLayers([
            this._measureLineLayer,
            this._measureMarkerLayer
        ]);
        var firstCoordinate = this._getFirstCoordinate() || param.coordinate;
        var marker = new Marker(firstCoordinate.copy(), {
            'symbol': this.options['vertexSymbol']
        });
        var content = this.translator.translate('distancetool.start');
        var startLabel = new Label(content, firstCoordinate.copy(), this.options['labelOptions']);
        this._lastVertex = startLabel;
        this._addVertexMarker(marker, startLabel);
    };
    _proto._msOnMouseMove = function _msOnMouseMove(param) {
        var ms = this._measure(this._msGetCoordsToMeasure(param));
        if (!this._tailMarker) {
            var symbol = extendSymbol(this.options['vertexSymbol']);
            symbol['markerWidth'] /= 2;
            symbol['markerHeight'] /= 2;
            this._tailMarker = new Marker(param['coordinate'], {
                'symbol': symbol
            }).addTo(this._measureMarkerLayer);
            this._tailLabel = new Label(ms, param['coordinate'], this.options['labelOptions']).addTo(this._measureMarkerLayer);
        }
        var lastCoordinate = this._getLasttCoordinate() || param.coordinate;
        this._tailMarker.setCoordinates(lastCoordinate.copy());
        this._tailLabel.setContent(ms);
        this._tailLabel.setCoordinates(lastCoordinate.copy());
    };
    _proto._msGetCoordsToMeasure = function _msGetCoordsToMeasure(param) {
        return param['geometry'].getCoordinates().concat([
            param['coordinate']
        ]);
    };
    _proto._msOnDrawVertex = function _msOnDrawVertex(param) {
        var lastCoordinate = this._getLasttCoordinate() || param.coordinate;
        var geometry = param['geometry'];
        var marker = new Marker(lastCoordinate.copy(), {
            'symbol': this.options['vertexSymbol']
        });
        var length = this._measure(geometry);
        var vertexLabel = new Label(length, lastCoordinate.copy(), this.options['labelOptions']);
        this._addVertexMarker(marker, vertexLabel);
        this._lastVertex = vertexLabel;
    };
    _proto._addVertexMarker = function _addVertexMarker(marker, vertexLabel) {
        if (!this._vertexes) this._vertexes = [];
        if (this._historyPointer !== undefined && this._vertexes.length > this._historyPointer - 1) this._vertexes.length = this._historyPointer - 1;
        this._vertexes.push({
            label: vertexLabel,
            marker: marker
        });
        this._measureMarkerLayer.addGeometry(marker);
        if (vertexLabel) this._measureMarkerLayer.addGeometry(vertexLabel);
    };
    _proto._msOnDrawEnd = function _msOnDrawEnd(param) {
        this._clearTailMarker();
        if (param['geometry'].getCoordinates().length < 2) {
            this._lastMeasure = 0;
            this._clearMeasureLayers();
            return;
        }
        var size = this._lastVertex.getSize();
        if (!size) size = new Size(10, 10);
        this._addClearMarker(this._lastVertex.getCoordinates(), this._lastVertex._getPrjCoordinates(), size['width']);
        var geo = param['geometry'].copy();
        geo.setCoordinates(param.geometry.getCoordinates());
        geo.addTo(this._measureLineLayer);
        this._lastMeasure = geo.getLength();
    };
    _proto._addClearMarker = function _addClearMarker(coordinates, prjCoord, dx) {
        var symbol = this.options['clearButtonSymbol'];
        var dxSymbol = {
            'markerDx': (symbol['markerDx'] || 0) + dx,
            'textDx': (symbol['textDx'] || 0) + dx
        };
        if (Array.isArray(symbol)) dxSymbol = symbol.map(function(s) {
            if (s) return {
                'markerDx': (s['markerDx'] || 0) + dx,
                'textDx': (s['textDx'] || 0) + dx
            };
            return null;
        });
        symbol = extendSymbol(symbol, dxSymbol);
        var endMarker = new Marker(coordinates, {
            'symbol': symbol
        });
        var measureLineLayer = this._measureLineLayer, measureMarkerLayer = this._measureMarkerLayer;
        endMarker.on('click', function() {
            measureLineLayer.remove();
            measureMarkerLayer.remove();
            return false;
        }, this);
        endMarker.addTo(this._measureMarkerLayer);
    };
    _proto._clearTailMarker = function _clearTailMarker() {
        if (this._tailMarker) {
            this._tailMarker.remove();
            delete this._tailMarker;
        }
        if (this._tailLabel) {
            this._tailLabel.remove();
            delete this._tailLabel;
        }
    };
    _proto._clearMeasureLayers = function _clearMeasureLayers() {
        this._measureLineLayer.remove();
        this._measureMarkerLayer.remove();
    };
    _proto._getFirstCoordinate = function _getFirstCoordinate() {
        if (!this._geometry) return null;
        var coordinates = this._geometry.getCoordinates() || [];
        return coordinates[0];
    };
    _proto._getLasttCoordinate = function _getLasttCoordinate() {
        if (!this._geometry) return null;
        var coordinates = this._geometry.getCoordinates() || [];
        return coordinates[coordinates.length - 1];
    };
    return DistanceTool;
}(DrawTool);
DistanceTool.mergeOptions(options$m);
var options$l = {
    'mode': 'Polygon',
    'symbol': {
        'lineColor': '#000000',
        'lineWidth': 2,
        'lineOpacity': 1,
        'lineDasharray': '',
        'polygonFill': '#ffffff',
        'polygonOpacity': 0.5
    },
    'language': 'zh-CN'
};
var AreaTool = function(_DistanceTool) {
    function AreaTool(options) {
        var _this;
        _this = _DistanceTool.call(this, options) || this;
        _this.translator = new Translator(_this.options['language']);
        _this._measureLayers = [];
        return _this;
    }
    _inheritsLoose(AreaTool, _DistanceTool);
    var _proto = AreaTool.prototype;
    _proto._measure = function _measure(toMeasure) {
        var map = this.getMap();
        var area;
        if (toMeasure instanceof Geometry) area = map.computeGeometryArea(toMeasure);
        else if (Array.isArray(toMeasure)) area = map.getProjection().measureArea(toMeasure);
        this._lastMeasure = area;
        var result = this._formatLabelContent(area);
        if (result) return result;
        var units = [
            this.translator.translate('areatool.units.meter'),
            this.translator.translate('areatool.units.kilometer'),
            this.translator.translate('areatool.units.feet'),
            this.translator.translate('areatool.units.mile')
        ];
        var content = '';
        var decimals = this.options['decimalPlaces'];
        if (this.options['metric']) content += area < 1E6 ? area.toFixed(decimals) + units[0] : (area / 1E6).toFixed(decimals) + units[1];
        if (this.options['imperial']) {
            area *= Math.pow(3.2808399, 2);
            if (content.length > 0) content += '\n';
            var sqmi = 27878400;
            content += area < sqmi ? area.toFixed(decimals) + units[2] : (area / sqmi).toFixed(decimals) + units[3];
        }
        return content;
    };
    _proto._msGetCoordsToMeasure = function _msGetCoordsToMeasure(param) {
        return param['geometry'].getShell().concat([
            param['coordinate']
        ]);
    };
    _proto._msOnDrawVertex = function _msOnDrawVertex(param) {
        var lastCoordinate = this._getLasttCoordinate() || param.coordinate;
        var vertexMarker = new Marker(lastCoordinate.copy(), {
            'symbol': this.options['vertexSymbol']
        });
        this._measure(param['geometry']);
        this._lastVertex = vertexMarker;
        this._addVertexMarker(vertexMarker);
    };
    _proto._msOnDrawEnd = function _msOnDrawEnd(param) {
        this._clearTailMarker();
        var prjCoord;
        var map = this.getMap();
        if (param['point2d']) prjCoord = map._pointToPrj(param['point2d']);
        else {
            var prjCoords = param['geometry']._getPrjCoordinates() || [];
            prjCoords = prjCoords.slice(0, prjCoords.length - 1);
            prjCoord = prjCoords[prjCoords.length - 1];
        }
        if (param['geometry'].getShell().length < 3) {
            this._lastMeasure = 0;
            this._clearMeasureLayers();
            return;
        }
        var ms = this._measure(param['geometry']);
        var lastCoordinate = this._getLasttCoordinate();
        var endLabel = new Label(ms, lastCoordinate.copy(), this.options['labelOptions']).addTo(this._measureMarkerLayer);
        var size = endLabel.getSize();
        if (!size) size = new Size(10, 10);
        this._addClearMarker(lastCoordinate.copy(), prjCoord, size['width']);
        var geo = param['geometry'].copy();
        geo.setCoordinates(param.geometry.getCoordinates());
        geo.addTo(this._measureLineLayer);
        this._lastMeasure = geo.getArea();
    };
    return AreaTool;
}(DistanceTool);
AreaTool.mergeOptions(options$l);
function queryTerrainCoordinates(projection, prjCoords, mapEvent) {
    var isArray = Array.isArray(prjCoords);
    if (!isArray) prjCoords = [
        prjCoords
    ];
    var coordinates;
    var transformCoordinate;
    if (mapEvent && mapEvent.drawTool && mapEvent.drawTool.options) transformCoordinate = mapEvent.drawTool.options.transformCoordinate;
    if (transformCoordinate && isFunction(transformCoordinate)) {
        coordinates = prjCoords.map(function(c) {
            return projection.unproject(c);
        });
        coordinates = coordinates.map(function(c) {
            var newCoordinata = transformCoordinate(c, mapEvent);
            return newCoordinata || c;
        });
    } else {
        if (!mapEvent || !mapEvent.target || !mapEvent.target._queryTerrainInfo) {
            coordinates = prjCoords.map(function(c) {
                return projection.unproject(c);
            });
            return isArray ? coordinates : coordinates[0];
        }
        var map = mapEvent.target;
        var enableAltitude = mapEvent.enableAltitude;
        coordinates = prjCoords.map(function(c) {
            if (enableAltitude) {
                var point = map.prjToContainerPoint(c);
                var terrain = map._queryTerrainInfo(point);
                if (terrain && terrain.coordinate) return terrain.coordinate;
            }
            return projection.unproject(c);
        });
    }
    return isArray ? coordinates : coordinates[0];
}
var circleHooks = {
    'create': function create(projection, prjCoord, mapEvent) {
        var center = queryTerrainCoordinates(projection, prjCoord[0], mapEvent);
        var circle = new Circle(center, 0);
        return circle;
    },
    'update': function update(projection, prjPath, geometry, mapEvent) {
        var map = geometry.getMap();
        var prjCoord = Array.isArray(prjPath) ? prjPath[prjPath.length - 1] : prjPath;
        var nextCoord = queryTerrainCoordinates(projection, prjCoord, mapEvent);
        var radius = map.computeLength(geometry.getCenter(), nextCoord);
        geometry.setRadius(radius);
    },
    'generate': function generate(geometry) {
        return geometry;
    }
};
DrawTool.registerMode('circle', extend$2({
    'clickLimit': 2,
    'action': [
        'click',
        'mousemove',
        'click'
    ]
}, circleHooks));
DrawTool.registerMode('freeHandCircle', extend$2({
    'action': [
        'mousedown touchstart',
        'mousemove touchmove',
        'mouseup touchend'
    ]
}, circleHooks));
var ellipseHooks = {
    'create': function create(projection, prjCoord, mapEvent) {
        var center = queryTerrainCoordinates(projection, prjCoord[0], mapEvent);
        var ellipse = new Ellipse(center, 0, 0);
        return ellipse;
    },
    'update': function update(projection, prjPath, geometry, mapEvent) {
        var map = geometry.getMap();
        var center = geometry.getCenter();
        var prjCoord = Array.isArray(prjPath) ? prjPath[prjPath.length - 1] : prjPath;
        var nextCoord = queryTerrainCoordinates(projection, prjCoord, mapEvent);
        var rx = map.computeLength(center, new Coordinate({
            x: nextCoord.x,
            y: center.y
        }));
        var ry = map.computeLength(center, new Coordinate({
            x: center.x,
            y: nextCoord.y
        }));
        geometry.setWidth(rx * 2);
        geometry.setHeight(ry * 2);
    },
    'generate': function generate(geometry) {
        return geometry;
    }
};
DrawTool.registerMode('ellipse', extend$2({
    'clickLimit': 2,
    'action': [
        'click',
        'mousemove',
        'click'
    ]
}, ellipseHooks));
DrawTool.registerMode('freeHandEllipse', extend$2({
    'action': [
        'mousedown touchstart',
        'mousemove touchmove',
        'mouseup touchend'
    ]
}, ellipseHooks));
var rectangleHooks = {
    'create': function create(projection, prjCoords) {
        var rect = new Polygon([]);
        rect._firstClick = prjCoords[0];
        return rect;
    },
    'update': function update(projection, prjCoords, geometry, mapEvent) {
        var map = geometry.getMap();
        var containerPoint = mapEvent['containerPoint'];
        var firstClick = map.prjToContainerPoint(geometry._firstClick);
        var ring = [
            [
                firstClick.x,
                firstClick.y
            ],
            [
                containerPoint.x,
                firstClick.y
            ],
            [
                containerPoint.x,
                containerPoint.y
            ],
            [
                firstClick.x,
                containerPoint.y
            ]
        ];
        var prjs = ring.map(function(c) {
            return map._containerPointToPrj(new Point(c));
        });
        var coordinates = queryTerrainCoordinates(projection, prjs, mapEvent);
        geometry.setCoordinates(coordinates);
    },
    'generate': function generate(geometry) {
        return geometry;
    }
};
DrawTool.registerMode('rectangle', extend$2({
    'clickLimit': 2,
    'action': [
        'click',
        'mousemove',
        'click'
    ]
}, rectangleHooks));
DrawTool.registerMode('freeHandRectangle', extend$2({
    'action': [
        'mousedown touchstart',
        'mousemove touchmove',
        'mouseup touchend'
    ]
}, rectangleHooks));
DrawTool.registerMode('point', {
    'clickLimit': 1,
    'action': [
        'click',
        'mousemove'
    ],
    'create': function create(projection, prjCoord, mapEvent) {
        var center = queryTerrainCoordinates(projection, prjCoord[0], mapEvent);
        var marker = new Marker(center);
        return marker;
    },
    'generate': function generate(geometry) {
        return geometry;
    },
    'update': function update(projection, prjCoord, geometry, mapEvent) {
        if (Array.isArray(prjCoord)) prjCoord = prjCoord[prjCoord.length - 1];
        if (!prjCoord) return geometry;
        var coordinate = queryTerrainCoordinates(projection, prjCoord, mapEvent);
        geometry.setCoordinates(coordinate);
        return geometry;
    }
});
var polygonHooks = {
    'create': function create(projection, prjPath, mapEvent) {
        var path = queryTerrainCoordinates(projection, prjPath, mapEvent);
        var line = new LineString(path);
        line.setCoordinates(path);
        return line;
    },
    'update': function update(projection, path, geometry, mapEvent) {
        var symbol = geometry.getSymbol();
        var prjCoords;
        if (Array.isArray(path)) prjCoords = path;
        else {
            prjCoords = geometry._drawPrjs || [];
            prjCoords.push(path);
        }
        geometry._drawPrjs = prjCoords;
        var coordinates = queryTerrainCoordinates(projection, prjCoords, mapEvent);
        geometry.setCoordinates(coordinates);
        var layer = geometry.getLayer();
        if (layer) {
            var polygon = layer.getGeometryById('polygon');
            if (!polygon && prjCoords.length >= 3) {
                polygon = new Polygon([
                    coordinates
                ], {
                    'id': 'polygon',
                    'zIndex': -1
                });
                if (symbol) {
                    var pSymbol = extendSymbol(symbol, {
                        'lineOpacity': 0
                    });
                    polygon.setSymbol(pSymbol);
                }
                polygon.addTo(layer);
            }
            if (polygon) polygon.setCoordinates([
                coordinates
            ]);
        }
    },
    'generate': function generate(geometry) {
        var polygon = new Polygon(geometry.getCoordinates(), {
            'symbol': geometry.getSymbol(),
            'properties': geometry.getProperties()
        });
        polygon._projCode = geometry._projCode;
        return polygon;
    }
};
DrawTool.registerMode('polygon', extend$2({
    'action': [
        'click',
        'mousemove',
        'dblclick'
    ]
}, polygonHooks));
DrawTool.registerMode('freeHandPolygon', extend$2({
    'action': [
        'mousedown touchstart',
        'mousemove touchmove',
        'mouseup touchend'
    ]
}, polygonHooks));
var lineStringHooks = {
    'create': function create(projection, prjPath, mapEvent) {
        var path = queryTerrainCoordinates(projection, prjPath, mapEvent);
        var line = new LineString(path);
        line.setCoordinates(path);
        return line;
    },
    'update': function update(projection, prjPath, geometry, mapEvent) {
        var prjCoords;
        if (Array.isArray(prjPath)) prjCoords = prjPath;
        else {
            prjCoords = geometry._drawPrjs || [];
            prjCoords.push(prjPath);
        }
        geometry._drawPrjs = prjCoords;
        var path = queryTerrainCoordinates(projection, prjCoords, mapEvent);
        geometry.setCoordinates(path);
    },
    'generate': function generate(geometry) {
        return geometry;
    }
};
DrawTool.registerMode('linestring', extend$2({
    'action': [
        'click',
        'mousemove',
        'dblclick'
    ]
}, lineStringHooks));
DrawTool.registerMode('freeHandLinestring', extend$2({
    'action': [
        'mousedown touchstart',
        'mousemove touchmove',
        'mouseup touchend'
    ]
}, lineStringHooks));
DrawTool.registerMode('arccurve', {
    'action': [
        'click',
        'mousemove',
        'dblclick'
    ],
    'create': function create(projection, prjPath) {
        var path = prjPath.map(function(c) {
            return projection.unproject(c);
        });
        var arc = new ArcCurve(path);
        arc._setPrjCoordinates(prjPath);
        return arc;
    },
    'update': lineStringHooks.update,
    'generate': function generate(geometry) {
        return geometry;
    }
});
DrawTool.registerMode('quadbeziercurve', {
    'action': [
        'click',
        'mousemove',
        'dblclick'
    ],
    'create': function create(projection, prjPath) {
        var path = prjPath.map(function(c) {
            return projection.unproject(c);
        });
        var curve = new QuadBezierCurve(path);
        curve._setPrjCoordinates(prjPath);
        return curve;
    },
    'update': lineStringHooks.update,
    'generate': function generate(geometry) {
        return geometry;
    }
});
DrawTool.registerMode('cubicbeziercurve', {
    'action': [
        'click',
        'mousemove',
        'dblclick'
    ],
    'create': function create(projection, prjPath) {
        var path = prjPath.map(function(c) {
            return projection.unproject(c);
        });
        var curve = new CubicBezierCurve(path);
        curve._setPrjCoordinates(prjPath);
        return curve;
    },
    'update': lineStringHooks.update,
    'generate': function generate(geometry) {
        return geometry;
    }
});
DrawTool.registerMode('boxZoom', {
    'action': [
        'mousedown',
        'mousemove',
        'mouseup'
    ],
    'create': function create(projection, prjCoord) {
        prjCoord = prjCoord[0];
        var center = projection.unproject(prjCoord);
        var marker = new Marker(center);
        marker._firstClick = prjCoord;
        return marker;
    },
    'update': function update(projection, prjCoord, geometry, param) {
        var map = geometry.getMap();
        var p1 = map.prjToContainerPoint(geometry._firstClick), p2 = param['containerPoint'];
        prjCoord = map._containerPointToPrj(new Coordinate(Math.min(p1.x, p2.x), Math.min(p1.y, p2.y)));
        var center = projection.unproject(prjCoord);
        geometry.setCoordinates(center)._setPrjCoordinates(prjCoord);
        geometry.updateSymbol({
            markerWidth: Math.abs(p1.x - p2.x),
            markerHeight: Math.abs(p1.y - p2.y)
        });
    },
    'generate': function generate(geometry) {
        return geometry;
    }
});
var options$k = {
    'eventsPropagation': false,
    'eventsToStop': null,
    'dx': 0,
    'dy': 0,
    'autoPan': false,
    'autoPanDuration': 600,
    'single': true,
    'animation': 'scale',
    'animationOnHide': false,
    'animationDuration': 500,
    'pitchWithMap': false,
    'rotateWithMap': false,
    'visible': true,
    'roundPoint': false,
    'collision': false,
    'collisionBufferSize': 2,
    'collisionWeight': 0,
    'collisionFadeIn': false,
    'zIndex': 0
};
var UIComponent = function(_Eventable) {
    function UIComponent(options) {
        var _this;
        _this = _Eventable.call(this, options) || this;
        _this.proxyOptions();
        return _this;
    }
    _inheritsLoose(UIComponent, _Eventable);
    var _proto = UIComponent.prototype;
    _proto._appendCustomClass = function _appendCustomClass(dom) {
        if (!dom) {
            console.warn('dom is null:', dom);
            return this;
        }
        if (this.options.cssName) {
            var cssName = this.options.cssName;
            if (!Array.isArray(cssName)) cssName = [
                cssName
            ];
            cssName.forEach(function(name) {
                dom.classList.add(name);
            });
        }
        return this;
    };
    _proto.onAdd = function onAdd() {};
    _proto.onRemove = function onRemove() {};
    _proto.onDomRemove = function onDomRemove() {};
    _proto.getEvents = function getEvents() {
        return {};
    };
    _proto.getOwnerEvents = function getOwnerEvents() {
        return {};
    };
    _proto.buildOn = function buildOn() {
        return null;
    };
    _proto.addTo = function addTo(owner) {
        this._owner = owner;
        this._switchEvents('on');
        if (this.onAdd) this.onAdd();
        this.fire('add');
        return this;
    };
    _proto.getMap = function getMap() {
        if (!this._owner) return null;
        if (this._owner.getBaseLayer) return this._owner;
        return this._owner.getMap();
    };
    _proto._collides = function _collides() {
        var map = this.getMap();
        if (!map) return this;
        map._addUI(this);
        map._insertUICollidesQueue();
        return this;
    };
    _proto._collidesEffect = function _collidesEffect(show) {
        var dom = this.getDOM();
        if (!dom) return this;
        var visibility = show ? 'visible' : 'hidden';
        dom.style.visibility = visibility;
        if (!dom.classList || !dom.classList.add) return this;
        if (!this.options['collisionFadeIn']) return this;
        var classList = dom.classList;
        var className = 'mtk-ui-fadein';
        var hasClass = classList.contains(className);
        if (show && !hasClass) dom.classList.add(className);
        else if (!show && hasClass) dom.classList.remove(className);
        return this;
    };
    _proto.show = function show(coordinate) {
        var _this2 = this;
        var map = this.getMap();
        if (!map) return this;
        this.options['visible'] = true;
        coordinate = coordinate || this._coordinate || this._owner.getCenter();
        if (!(coordinate instanceof Coordinate)) coordinate = new Coordinate(coordinate);
        var visible = this.isVisible();
        if (!this._onlyUpdatePosition) this.fire('showstart');
        var container = this._getUIContainer();
        this._coordinate = coordinate;
        if (!this._onlyUpdatePosition) this._removePrevDOM();
        if (!this._mapEventsOn) this._switchMapEvents('on');
        var dom;
        if (!this._onlyUpdatePosition) dom = this.__uiDOM = this.buildOn();
        else dom = this.__uiDOM;
        dom['eventsPropagation'] = this.options['eventsPropagation'];
        this._observerDomSize(dom);
        var zIndex = this.options.zIndex;
        if (!dom) {
            if (!this._onlyUpdatePosition) this.fire('showend');
            this._collides();
            this.setZIndex(zIndex);
            return this;
        }
        if (!this._onlyUpdatePosition) this._measureSize(dom);
        if (this._singleton()) {
            dom._uiComponent = this;
            map[this._uiDomKey()] = dom;
        }
        this._setPosition();
        dom.style[TRANSITION] = null;
        if (!this._onlyUpdatePosition) container.appendChild(dom);
        var anim = this._getAnimation();
        if (visible) anim.ok = false;
        if (anim.ok) {
            if (anim.fade) dom.style.opacity = "0";
            if (anim.scale) {
                if (this.getTransformOrigin) {
                    var origin = this.getTransformOrigin();
                    dom.style[TRANSFORMORIGIN] = origin;
                }
                dom.style[TRANSFORM] = this._toCSSTranslate(this._pos) + ' scale(0)';
            }
        }
        if (!this.isSupportZoomFilter()) dom.style.display = '';
        if (this.options['eventsToStop']) on(dom, this.options['eventsToStop'], stopPropagation);
        var transition = anim.transition;
        if (anim.ok && transition) {
            dom.offsetHeight;
            if (transition) dom.style[TRANSITION] = transition;
            if (anim.fade) dom.style.opacity = "1";
            if (anim.scale) dom.style[TRANSFORM] = this._toCSSTranslate(this._pos) + ' scale(1)';
        }
        if (!this._onlyUpdatePosition) this.fire('showend');
        this._collides();
        clearTimeout(this._autoPanId);
        if (this.options['autoPan']) this._autoPanId = setTimeout(function() {
            _this2._autoPan();
        }, 32);
        this.setZIndex(zIndex);
        return this;
    };
    _proto.hide = function hide() {
        var _this3 = this;
        if (!this.getDOM()) return this;
        if (this._onDomMouseout) this._onDomMouseout();
        this.options['visible'] = false;
        var anim = this._getAnimation(), dom = this.getDOM();
        if (!this.options['animationOnHide']) anim.ok = false;
        if (!anim.ok) {
            dom.style.display = 'none';
            this.fire('hide');
        } else {
            dom.offsetHeight;
            dom.style[TRANSITION] = anim.transition;
            setTimeout(function() {
                dom.style.display = 'none';
                _this3.fire('hide');
            }, this.options['animationDuration']);
        }
        if (anim.fade) dom.style.opacity = "0";
        if (anim.scale) dom.style[TRANSFORM] = this._toCSSTranslate(this._pos) + ' scale(0)';
        this._switchMapEvents('off');
        this._collides();
        return this;
    };
    _proto.isVisible = function isVisible() {
        if (!this.options['visible']) return false;
        var dom = this.getDOM();
        return this.getMap() && dom && dom.parentNode && dom.style.display !== 'none';
    };
    _proto.remove = function remove() {
        delete this._mapEventsOn;
        if (!this._owner) return this;
        var map = this.getMap();
        if (map) map._removeUI(this);
        this.hide();
        this._switchEvents('off');
        if (this.onRemove) this.onRemove();
        if (!this._singleton() && this.__uiDOM) this._removePrevDOM();
        delete this._owner;
        this.fire('remove');
        this._collides();
        return this;
    };
    _proto.getSize = function getSize() {
        if (this._domContentRect && this._size) {
            this._size.width = this._domContentRect.width;
            this._size.height = this._domContentRect.height;
        }
        if (this._size) return this._size.copy();
        else return null;
    };
    _proto.getOwner = function getOwner() {
        return this._owner;
    };
    _proto.getDOM = function getDOM() {
        return this.__uiDOM;
    };
    _proto.setZIndex = function setZIndex(zIndex) {
        if (!isNumber(zIndex)) return this;
        var dom = this.getDOM();
        if (!dom) return this;
        dom.style.zIndex = zIndex + '';
        if (zIndex !== this.options.zIndex) this.options.zIndex = zIndex;
        return this;
    };
    _proto._roundPoint = function _roundPoint(point) {
        if (this.options.roundPoint) point = point._round();
        return point;
    };
    _proto.getPosition = function getPosition() {
        if (!this.getMap()) return null;
        var p = this._roundPoint(this._getViewPoint());
        if (this.getOffset) {
            var o = this._roundPoint(this.getOffset());
            if (o) p._add(o);
        }
        return p;
    };
    _proto._getAnimation = function _getAnimation() {
        var anim = {
            'fade': false,
            'scale': false,
            'ok': false,
            'transition': ''
        };
        var animations = this.options['animation'] ? this.options['animation'].split(',') : [];
        for(var i = 0; i < animations.length; i++){
            var trimed = trim(animations[i]);
            if (trimed === 'fade') anim.fade = true;
            else if (trimed === 'scale') anim.scale = true;
        }
        var transition = null;
        if (anim.fade) transition = 'opacity ' + this.options['animationDuration'] + 'ms';
        if (anim.scale) {
            transition = transition ? transition + ',' : '';
            transition += TRANSFORM + ' ' + this.options['animationDuration'] + 'ms';
        }
        anim.transition = transition;
        anim.ok = transition !== null;
        return anim;
    };
    _proto._getViewPoint = function _getViewPoint() {
        var altitude = 0;
        var coordinates = this._coordinate || {};
        if (isNumber(coordinates.z)) altitude = coordinates.z;
        else if (this._owner && this._owner.getAltitude) {
            altitude = this._owner.getAltitude() || 0;
            if (!isNumber(altitude)) altitude = 0;
        }
        if (this._owner.getLayer) {
            var layer = this._owner.getLayer();
            if (layer && layer.isVectorLayer) {
                altitude = this._owner._getAltitude() || 0;
                if (!isNumber(altitude)) altitude = 0;
            }
        }
        var alt = this._meterToPoint(this._coordinate, altitude);
        return this.getMap().coordToViewPoint(this._coordinate, undefined, alt)._add(this.options['dx'], this.options['dy']);
    };
    _proto._meterToPoint = function _meterToPoint(center, altitude) {
        return altitude;
    };
    _proto._autoPan = function _autoPan() {
        var map = this.getMap(), dom = this.getDOM();
        if (!dom || !map || map.isMoving()) return;
        var point = this._getViewPoint()._round();
        var mapWidth = map.width;
        var mapHeight = map.height;
        var mapContainer = map.getContainer();
        if (dom && mapContainer && dom.getBoundingClientRect) {
            var mapRect = mapContainer.getBoundingClientRect();
            var mapLeft = mapRect.left;
            var mapTop = mapRect.top;
            var _margin = 50;
            var rect = dom.getBoundingClientRect();
            var offsetX = 0, offsetY = 0;
            var { left: _left, right: right, top: _top, bottom: bottom } = rect;
            var { width: width, height: height } = rect;
            _left -= mapLeft;
            right -= mapLeft;
            _top -= mapTop;
            bottom -= mapTop;
            if (width > 0 && height > 0) {
                if (_left < _margin) offsetX = _margin - _left;
                if (offsetX === 0 && right + _margin > mapWidth) offsetX = -(right + _margin - mapWidth);
                if (_top < _margin) offsetY = _margin - _top;
                if (offsetY === 0 && bottom + _margin > mapHeight) offsetY = -(bottom + _margin - mapHeight);
                if (offsetX !== 0 || offsetY !== 0) {
                    var pitch = map.getPitch();
                    if (pitch > 40 && offsetY !== 0 && this._coordinate) map.animateTo({
                        center: this._coordinate
                    }, {
                        duration: map.options['panAnimationDuration']
                    });
                    else map.panBy([
                        Math.ceil(offsetX),
                        Math.ceil(offsetY)
                    ]);
                }
                return;
            }
        }
        var containerPoint0 = map.viewPointToContainerPoint(point);
        var offset = this.getOffset();
        var containerPoint = containerPoint0.add(offset);
        var prjCoord = map.viewPointToPrj(point);
        var domWidth = parseInt(dom.clientWidth + '');
        var domHeight = parseInt(dom.clientHeight + '');
        var margin = 50;
        var left = 0, top = 0;
        if (containerPoint.x < 0) left = -containerPoint.x + margin;
        else if (containerPoint.x + domWidth > mapWidth) left = -(containerPoint.x + domWidth - mapWidth) - margin;
        if (containerPoint.y - domHeight < 0) top = Math.abs(containerPoint.y - domHeight) + margin;
        else if (containerPoint.y + domHeight > mapHeight) top = mapHeight - (containerPoint.y + domHeight) - margin;
        if (domWidth >= mapWidth) left = mapWidth / 2 - containerPoint0.x;
        if (top !== 0 || left !== 0) {
            var newContainerPoint = containerPoint0.add(left, top);
            var t = map._containerPointToPoint(newContainerPoint)._sub(map._prjToPoint(map._getPrjCenter()));
            var target = map._pointToPrj(map._prjToPoint(prjCoord).sub(t));
            map._panAnimation(target);
        }
    };
    _proto._measureSize = function _measureSize(dom) {
        var container = this._getUIContainer();
        dom.style.position = 'absolute';
        var anchor = dom.style.bottom ? 'bottom' : 'top';
        dom.style.display = '';
        container.appendChild(dom);
        if (dom.getBoundingClientRect) {
            var rect = dom.getBoundingClientRect();
            this._size = new Size(rect.width, rect.height);
        } else this._size = new Size(dom.clientWidth, dom.clientHeight);
        dom.style.display = 'none';
        dom.style.left = '0px';
        dom.style[anchor] = '0px';
        return this._size;
    };
    _proto._removePrevDOM = function _removePrevDOM() {
        if (this.onDomRemove) this.onDomRemove();
        var eventsToStop = this.options['eventsToStop'];
        if (this._singleton()) {
            var map = this.getMap(), key = this._uiDomKey();
            if (map[key]) {
                if (eventsToStop) off(map[key], eventsToStop, stopPropagation);
                var uiComponent = map[key]._uiComponent;
                if (uiComponent && uiComponent !== this && uiComponent.isVisible()) uiComponent.fire('hide');
                removeDomNode(map[key]);
                if (uiComponent && !this.hideDom) uiComponent._switchMapEvents('off');
                delete map[key];
            }
            delete this.__uiDOM;
        } else if (this.__uiDOM) {
            if (eventsToStop) off(this.__uiDOM, eventsToStop, stopPropagation);
            removeDomNode(this.__uiDOM);
            delete this.__uiDOM;
        }
        if (this._resizeObserver) {
            this._resizeObserver.disconnect();
            delete this._resizeObserver;
            delete this._domContentRect;
        }
    };
    _proto._uiDomKey = function _uiDomKey() {
        return '__ui_' + this._getClassName();
    };
    _proto._singleton = function _singleton() {
        return this.options['single'];
    };
    _proto._getUIContainer = function _getUIContainer() {
        return this.getMap().getPanels()['ui'];
    };
    _proto._getClassName = function _getClassName() {
        return 'UIComponent';
    };
    _proto._switchMapEvents = function _switchMapEvents(to) {
        var map = this.getMap();
        if (!map) return;
        this._mapEventsOn = to === 'on';
        var events = this._getDefaultEvents();
        if (this.getEvents) extend$2(events, this.getEvents());
        if (events) {
            for(var p in events)if (events.hasOwnProperty(p)) map[to](p, events[p], this);
        }
    };
    _proto._switchEvents = function _switchEvents(to) {
        var ownerEvents = this._getOwnerEvents();
        if (this._owner) {
            for(var p in ownerEvents)if (ownerEvents.hasOwnProperty(p)) this._owner[to](p, ownerEvents[p], this);
        }
    };
    _proto._getDefaultEvents = function _getDefaultEvents() {
        return {
            'zooming rotate pitch': this.onEvent,
            'zoomend': this.onZoomEnd,
            'moving': this.onMoving,
            'moveend': this.onMoving,
            'resize': this.onResize
        };
    };
    _proto._getOwnerEvents = function _getOwnerEvents() {
        var events = {};
        if (this._owner && this._owner instanceof Geometry) {
            events.positionchange = this.onGeometryPositionChange;
            events.symbolchange = this._updatePosition;
        }
        if (this.getOwnerEvents) extend$2(events, this.getOwnerEvents());
        return events;
    };
    _proto.onGeometryPositionChange = function onGeometryPositionChange(param) {
        if (this._owner && this.isVisible()) {
            this._onlyUpdatePosition = true;
            var target = param.target;
            var center = target.getCenter();
            if (target._getAltitude) {
                var altitude = target._getAltitude();
                if (isNumber(altitude)) center.z = altitude;
            }
            this.show(center);
            this._onlyUpdatePosition = false;
        }
    };
    _proto.onMoving = function onMoving() {
        if (this.isVisible() && this.getMap().isTransforming()) this._updatePosition();
    };
    _proto.onEvent = function onEvent() {
        if (this.isVisible()) this._updatePosition();
    };
    _proto.onZoomEnd = function onZoomEnd() {
        if (this.isVisible()) this._setPosition();
    };
    _proto.onResize = function onResize() {
        if (this.isVisible()) this._setPosition();
    };
    _proto.onDomSizeChange = function onDomSizeChange() {
        if (this.isVisible()) {
            this._setPosition();
            this._collides();
        }
    };
    _proto._updatePosition = function _updatePosition() {
        if (!this.getMap()) return this;
        var renderer = this.getMap()._getRenderer();
        renderer.callInNextFrame(this._setPosition.bind(this));
        return this;
    };
    _proto._setPosition = function _setPosition() {
        var dom = this.getDOM();
        if (!dom) return;
        dom.style[TRANSITION] = null;
        var p = this.getPosition();
        this._pos = p;
        dom.style[TRANSFORM] = this._toCSSTranslate(p) + ' scale(1)';
    };
    _proto._toCSSTranslate = function _toCSSTranslate(p) {
        if (!p) return '';
        if (Browser$1.any3d) {
            var map = this.getMap(), bearing = map ? map.getBearing() : 0, pitch = map ? map.getPitch() : 0;
            var r = '';
            if (this.options['pitchWithMap'] && pitch) r += " rotateX(" + Math.round(pitch) + "deg)";
            if (this.options['rotateWithMap'] && bearing) r += " rotateZ(" + Math.round(-bearing) + "deg)";
            return 'translate3d(' + Math.round(p.x) + 'px,' + Math.round(p.y) + 'px, 0px)' + r;
        } else return 'translate(' + Math.round(p.x) + 'px,' + Math.round(p.y) + 'px)';
    };
    _proto._observerDomSize = function _observerDomSize(dom) {
        var _this4 = this;
        if (!dom || !Browser$1.resizeObserver || this._resizeObserver) return this;
        this._resizeObserver = new ResizeObserver(function(entries) {
            if (entries.length) {
                var borderBoxSize = entries[0].borderBoxSize;
                if (borderBoxSize && borderBoxSize.length) _this4._domContentRect = {
                    width: borderBoxSize[0].inlineSize,
                    height: borderBoxSize[0].blockSize
                };
                else _this4._domContentRect = entries[0].contentRect;
            } else delete _this4._domContentRect;
            if (_this4.onDomSizeChange) _this4.onDomSizeChange();
        });
        this._resizeObserver.observe(dom);
        return this;
    };
    _proto.isSupportZoomFilter = function isSupportZoomFilter() {
        return false;
    };
    _proto.onConfig = function onConfig() {
        this._updatePosition();
        return this;
    };
    UIComponent.isSupport = function isSupport(owner) {
        if (owner && isFunction(owner.on) && isFunction(owner.off) && isFunction(owner.getCenter)) return true;
        return false;
    };
    _proto._bindDomEvents = function _bindDomEvents(dom, to) {
        if (!dom) return;
        var events = this._getDomEvents() || {};
        var bindEvent = to === 'on' ? on : off;
        for(var eventName in events){
            if (to === 'on') off(dom, eventName, events[eventName]);
            bindEvent(dom, eventName, events[eventName], this);
        }
    };
    _proto._getDomEvents = function _getDomEvents() {
        return {
            'mouseover': this._onDomMouseover,
            'mouseout': this._onDomMouseout
        };
    };
    _proto._configMapPreventWheelScroll = function _configMapPreventWheelScroll(preventWheelScroll) {
        var map = this.getMap();
        if (!map) return;
        if (this.options.eventsPropagation) return;
        map.options['preventWheelScroll'] = preventWheelScroll;
    };
    _proto._onDomMouseover = function _onDomMouseover() {
        this._configMapPreventWheelScroll(false);
        this.fire('mouseover');
    };
    _proto._onDomMouseout = function _onDomMouseout() {
        this._configMapPreventWheelScroll(true);
        this.fire('mouseout');
    };
    return UIComponent;
}(Eventable(Class));
UIComponent.mergeOptions(options$k);
var options$j = {
    'containerClass': null,
    'eventsPropagation': true,
    'draggable': false,
    'single': false,
    'content': null,
    'altitude': 0,
    'minZoom': 0,
    'maxZoom': null,
    'horizontalAlignment': 'middle',
    'verticalAlignment': 'middle'
};
var domEvents = "mousedown mouseup mouseenter mouseover mouseout mousemove click dblclick contextmenu keypress touchstart touchmove touchend";
var UIMarker = function(_Handlerable) {
    function UIMarker(coordinate, options) {
        var _this;
        _this = _Handlerable.call(this, options) || this;
        _this._markerCoord = new Coordinate(coordinate);
        return _this;
    }
    _inheritsLoose(UIMarker, _Handlerable);
    var _proto = UIMarker.prototype;
    _proto._getClassName = function _getClassName() {
        return 'UIMarker';
    };
    _proto.setCoordinates = function setCoordinates(coordinates) {
        this._markerCoord = coordinates;
        this.fire('positionchange');
        if (this.isVisible()) {
            this._onlyUpdatePosition = true;
            this._coordinate = this._markerCoord;
            this._setPosition();
            this._collides();
            this._onlyUpdatePosition = false;
        }
        return this;
    };
    _proto.getCoordinates = function getCoordinates() {
        return this._markerCoord;
    };
    _proto.getCenter = function getCenter() {
        return this.getCoordinates();
    };
    _proto.getAltitude = function getAltitude() {
        var coordinates = this.getCoordinates() || {};
        if (isNumber(coordinates.z)) return coordinates.z;
        return this.options.altitude || 0;
    };
    _proto.setAltitude = function setAltitude(alt) {
        if (isNumber(alt) && this._markerCoord) {
            this._markerCoord.z = alt;
            if (this._updatePosition) {
                this._updatePosition();
                this._collides();
            }
        }
        return this;
    };
    _proto.setContent = function setContent(content) {
        var old = this.options['content'];
        this.options['content'] = content;
        this.fire('contentchange', {
            'old': old,
            'new': content
        });
        if (this.isVisible()) this.show();
        return this;
    };
    _proto.getContent = function getContent() {
        return this.options['content'];
    };
    _proto.onAdd = function onAdd() {
        if (this._owner && !this._owner.isMap) {
            var owner = this._owner;
            throw new Error((owner.getJSONType, owner.getJSONType()));
        }
        this.show();
        return this;
    };
    _proto.show = function show() {
        return _Handlerable.prototype.show.call(this, this._markerCoord);
    };
    _proto.flash = function flash$1(interval, count, cb, context) {
        return flash.call(this, interval, count, cb, context);
    };
    _proto.buildOn = function buildOn() {
        var oldDom = this.getDOM();
        this._bindDomEvents(oldDom, 'off');
        var dom;
        var content = this.options['content'];
        var isStr = isString(content);
        if (isStr || isFunction(content)) {
            dom = createEl('div');
            if (isStr) dom.innerHTML = this.options['content'];
            else content.bind(this)(dom);
        } else dom = this.options['content'];
        if (this.options['containerClass']) dom.className = this.options['containerClass'];
        this._registerDOMEvents(dom);
        this._bindDomEvents(dom, 'on');
        this._appendCustomClass(dom);
        return dom;
    };
    _proto.getOffset = function getOffset() {
        var size = this.getSize();
        var offsetX = -size.width / 2, offsetY = -size.height / 2;
        var { horizontalAlignment: horizontalAlignment, verticalAlignment: verticalAlignment } = this.options;
        if (horizontalAlignment === 'left') offsetX = -size.width;
        else if (horizontalAlignment === 'right') offsetX = 0;
        if (verticalAlignment === 'top') offsetY = -size.height;
        else if (verticalAlignment === 'bottom') offsetY = 0;
        return new Point(offsetX, offsetY);
    };
    _proto.getTransformOrigin = function getTransformOrigin() {
        return 'center center';
    };
    _proto.onDomRemove = function onDomRemove() {
        var dom = this.getDOM();
        this._removeDOMEvents(dom);
    };
    _proto.isDragging = function isDragging() {
        if (this['draggable']) return this['draggable'].isDragging();
        return false;
    };
    _proto._registerDOMEvents = function _registerDOMEvents(dom) {
        on(dom, domEvents, this._onDomEvents, this);
    };
    _proto._onDomEvents = function _onDomEvents(e, type) {
        var event = this.getMap()._parseEvent(e, e.type);
        type = type || e.type;
        if (type === 'mousedown') this._mousedownEvent = e;
        if (type === 'mouseup') this._mouseupEvent = e;
        if (type === 'click' && this._mouseClickPositionIsChange()) return;
        if (type === 'touchstart') this._touchstartTime = now();
        this.fire(type, event);
        if (type === 'touchend' && Browser$1.touch) {
            var clickTimeThreshold = this.getMap().options.clickTimeThreshold || 280;
            if (now() - this._touchstartTime < clickTimeThreshold) this._onDomEvents(e, 'click');
        }
    };
    _proto._removeDOMEvents = function _removeDOMEvents(dom) {
        off(dom, domEvents, this._onDomEvents);
    };
    _proto._mouseClickPositionIsChange = function _mouseClickPositionIsChange() {
        var { x: x1, y: y1 } = this._mousedownEvent || {};
        var { x: x2, y: y2 } = this._mouseupEvent || {};
        return x1 !== x2 || y1 !== y2;
    };
    _proto._getConnectPoints = function _getConnectPoints() {
        var map = this.getMap();
        var containerPoint = map.coordToContainerPoint(this.getCoordinates());
        var size = this.getSize(), width = size.width, height = size.height;
        var anchors = [
            map.containerPointToCoordinate(containerPoint.add(-width / 2, 0)),
            map.containerPointToCoordinate(containerPoint.add(width / 2, 0)),
            map.containerPointToCoordinate(containerPoint.add(0, height / 2)),
            map.containerPointToCoordinate(containerPoint.add(0, -height / 2))
        ];
        return anchors;
    };
    _proto._getViewPoint = function _getViewPoint() {
        var alt = 0;
        if (this._owner) {
            var altitude = this.getAltitude();
            if (altitude > 0) alt = this._meterToPoint(this._coordinate, altitude);
        }
        return this.getMap().coordToViewPoint(this._coordinate, undefined, alt)._add(this.options['dx'], this.options['dy']);
    };
    _proto._getDefaultEvents = function _getDefaultEvents() {
        return extend$2({}, _Handlerable.prototype._getDefaultEvents.call(this), {
            'zooming zoomend': this.onZoomFilter
        });
    };
    _proto._setPosition = function _setPosition() {
        this.onZoomFilter();
        _Handlerable.prototype._setPosition.call(this);
    };
    _proto.onZoomFilter = function onZoomFilter() {
        var dom = this.getDOM();
        if (!dom) return;
        if (!this.isVisible() && dom.style.display !== 'none') dom.style.display = 'none';
        else if (this.isVisible() && dom.style.display === 'none') dom.style.display = '';
    };
    _proto.isVisible = function isVisible() {
        var map = this.getMap();
        if (!map) return false;
        if (!this.options['visible']) return false;
        var zoom = map.getZoom();
        var { minZoom: minZoom, maxZoom: maxZoom } = this.options;
        if (!isNil(minZoom) && zoom < minZoom || !isNil(maxZoom) && zoom > maxZoom) return false;
        var dom = this.getDOM();
        return dom && true;
    };
    _proto.isSupportZoomFilter = function isSupportZoomFilter() {
        return true;
    };
    return UIMarker;
}(Handlerable(UIComponent));
UIMarker.mergeOptions(options$j);
var EVENTS$2 = Browser$1.touch ? 'touchstart mousedown' : 'mousedown';
var UIMarkerDragHandler = function(_Handler) {
    function UIMarkerDragHandler(target) {
        return _Handler.call(this, target) || this;
    }
    _inheritsLoose(UIMarkerDragHandler, _Handler);
    var _proto2 = UIMarkerDragHandler.prototype;
    _proto2.addHooks = function addHooks() {
        this.target.on(EVENTS$2, this._startDrag, this);
    };
    _proto2.removeHooks = function removeHooks() {
        this.target.off(EVENTS$2, this._startDrag, this);
    };
    _proto2._startDrag = function _startDrag(param) {
        var domEvent = param['domEvent'];
        if (domEvent.touches && domEvent.touches.length > 1 || domEvent.button === 2) return;
        if (this.isDragging()) return;
        this.target.on('click', this._endDrag, this);
        this._lastCoord = param['coordinate'];
        this._lastPoint = param['containerPoint'];
        this._prepareDragHandler();
        this._dragHandler.onMouseDown(param['domEvent']);
        this.target.fire('dragstart', param);
    };
    _proto2._prepareDragHandler = function _prepareDragHandler() {
        this._dragHandler = new DragHandler(this.target.getDOM(), {
            'cancelOn': this._cancelOn.bind(this),
            'ignoreMouseleave': true
        });
        this._dragHandler.on('mousedown', this._onMouseDown, this);
        this._dragHandler.on('dragging', this._dragging, this);
        this._dragHandler.on('mouseup', this._endDrag, this);
        this._dragHandler.enable();
    };
    _proto2._cancelOn = function _cancelOn(domEvent) {
        var target = domEvent.srcElement || domEvent.target, tagName = target.tagName.toLowerCase();
        if (tagName === 'button' || tagName === 'input' || tagName === 'select' || tagName === 'option' || tagName === 'textarea') return true;
        return false;
    };
    _proto2._onMouseDown = function _onMouseDown(param) {
        stopPropagation(param['domEvent']);
    };
    _proto2._dragging = function _dragging(param) {
        var target = this.target, map = target.getMap(), eventParam = map._parseEvent(param['domEvent']), domEvent = eventParam['domEvent'];
        var touchEvent = domEvent;
        if (touchEvent.touches && touchEvent.touches.length > 1) return;
        if (!this._isDragging) {
            this._isDragging = true;
            return;
        }
        var coord = eventParam['coordinate'], point = eventParam['containerPoint'];
        if (!this._lastCoord) this._lastCoord = coord;
        if (!this._lastPoint) this._lastPoint = point;
        var coordOffset = coord.sub(this._lastCoord), pointOffset = point.sub(this._lastPoint);
        this._lastCoord = coord;
        this._lastPoint = point;
        this.target.setCoordinates(this.target.getCoordinates().add(coordOffset));
        eventParam['coordOffset'] = coordOffset;
        eventParam['pointOffset'] = pointOffset;
        target.fire('dragging', eventParam);
    };
    _proto2._endDrag = function _endDrag(param) {
        var target = this.target, map = target.getMap();
        if (this._dragHandler) {
            target.off('click', this._endDrag, this);
            this._dragHandler.disable();
            delete this._dragHandler;
        }
        delete this._lastCoord;
        delete this._lastPoint;
        this._isDragging = false;
        if (!map) return;
        var eventParam = map._parseEvent(param['domEvent']);
        if (target && target._mouseClickPositionIsChange && target._mouseClickPositionIsChange()) target.fire('dragend', eventParam);
    };
    _proto2.isDragging = function isDragging() {
        if (!this._isDragging) return false;
        return true;
    };
    return UIMarkerDragHandler;
}(Handler);
UIMarker.addInitHook('addHandler', 'draggable', UIMarkerDragHandler);
var PROPERTY_PATTERN = /\{ *([\w_]+) *\}/g;
var options$i = {
    'containerClass': 'maptalks-msgBox',
    'autoPan': true,
    'autoCloseOn': null,
    'autoOpenOn': 'click',
    'width': 'auto',
    'minHeight': 120,
    'custom': false,
    'title': null,
    'content': null,
    'enableTemplate': false
};
var EMPTY_SIZE = new Size(0, 0);
var InfoWindow = function(_UIComponent) {
    function InfoWindow() {
        return _UIComponent.apply(this, arguments) || this;
    }
    _inheritsLoose(InfoWindow, _UIComponent);
    var _proto = InfoWindow.prototype;
    _proto._getClassName = function _getClassName() {
        return 'InfoWindow';
    };
    _proto.addTo = function addTo(owner) {
        if (owner instanceof Geometry) {
            if (owner.getInfoWindow() && owner.getInfoWindow() !== this) owner.removeInfoWindow();
            owner._infoWindow = this;
        }
        return _UIComponent.prototype.addTo.call(this, owner);
    };
    _proto.setContent = function setContent(content) {
        var old = this.options['content'];
        this.options['content'] = content;
        this.fire('contentchange', {
            'old': old,
            'new': content
        });
        if (this.isVisible()) this.show(this._coordinate);
        return this;
    };
    _proto.getContent = function getContent() {
        return this.options['content'];
    };
    _proto.setTitle = function setTitle(title) {
        var old = title;
        this.options['title'] = title;
        this.fire('contentchange', {
            'old': old,
            'new': title
        });
        if (this.isVisible()) this.show(this._coordinate);
        return this;
    };
    _proto.getTitle = function getTitle() {
        return this.options['title'];
    };
    _proto.buildOn = function buildOn() {
        var _this = this;
        var isFunc = isFunction(this.options['content']);
        var isStr = isString(this.options['content']);
        if (this.options['custom']) {
            var oldDom = this.getDOM();
            var newDom;
            this._bindDomEvents(oldDom, 'off');
            if (isStr || isFunc) {
                var _dom = createEl('div');
                if (isStr) {
                    _dom.innerHTML = this.options['content'];
                    this._replaceTemplate(_dom);
                } else this.options['content'].bind(this)(_dom);
                newDom = _dom;
            } else {
                this._replaceTemplate(this.options['content']);
                newDom = this.options['content'];
            }
            this._bindDomEvents(newDom, 'on');
            this._appendCustomClass(newDom);
            return newDom;
        }
        this._bindDomEvents(this.getDOM(), 'off');
        var dom = createEl('div');
        if (this.options['containerClass']) dom.className = this.options['containerClass'];
        var width = this._getWindowWidth();
        dom.style.width = isNumber(width) ? width + 'px' : 'auto';
        dom.style.bottom = '0px';
        var content = '<em class="maptalks-ico"></em>';
        if (this.options['title']) content += '<h2>' + this.options['title'] + '</h2>';
        content += '<a href="javascript:void(0);" class="maptalks-close">\xd7</a><div class="maptalks-msgContent"></div>';
        dom.innerHTML = content;
        this._replaceTemplate(dom);
        var msgContent = dom.querySelector('.maptalks-msgContent');
        if (isStr || isFunc) {
            if (isStr) msgContent.innerHTML = this.options['content'];
            else this.options['content'].bind(this)(msgContent);
        } else msgContent.appendChild(this.options['content']);
        this._onCloseBtnClick = function(event) {
            if (!_this.options.eventsPropagation) {
                preventDefault(event);
                stopPropagation(event);
            }
            _this.hide();
        };
        var closeBtn = dom.querySelector('.maptalks-close');
        addDomEvent(closeBtn, 'click touchend', this._onCloseBtnClick);
        if (!isFunc) this._replaceTemplate(msgContent);
        this._bindDomEvents(dom, 'on');
        this._appendCustomClass(dom);
        return dom;
    };
    _proto._replaceTemplate = function _replaceTemplate(dom) {
        var geo = this._owner;
        if (this.options['enableTemplate'] && geo && geo.getProperties && dom && dom.innerHTML) {
            var properties = geo.getProperties() || {};
            if (isObject$1(properties)) {
                var html = dom.innerHTML;
                dom.innerHTML = html.replace(PROPERTY_PATTERN, function(str, key) {
                    return properties[key];
                });
            }
        }
        return this;
    };
    _proto.getTransformOrigin = function getTransformOrigin() {
        var size = this.getSize();
        return size.width / 2 + 'px bottom';
    };
    _proto.getOffset = function getOffset() {
        var size = this.getSize();
        var o = new Point(-size['width'] / 2, 0);
        if (!this.options['custom']) o._sub(4, 12);
        else o._sub(0, size['height']);
        var owner = this.getOwner();
        if (owner instanceof Marker || owner instanceof MultiPoint) {
            var painter, markerSize;
            if (owner instanceof Marker) {
                painter = owner._getPainter();
                markerSize = owner.getSize();
            } else {
                var children = owner.getGeometries();
                if (!children || !children.length) return o;
                painter = children[0]._getPainter();
                markerSize = children[0].getSize();
            }
            if (!markerSize) markerSize = EMPTY_SIZE;
            if (painter) {
                var fixExtent = painter.getFixedExtent();
                o._add(fixExtent.xmax - markerSize.width / 2, fixExtent.ymin);
            } else o._add(0, -markerSize.height);
        }
        return o;
    };
    _proto.show = function show(coordinate) {
        if (!this.getMap()) return this;
        if (!this.getMap().options['enableInfoWindow']) return this;
        return _UIComponent.prototype.show.call(this, coordinate);
    };
    _proto.getEvents = function getEvents() {
        if (!this.options['autoCloseOn']) return null;
        var events = {};
        events[this.options['autoCloseOn']] = this.hide;
        return events;
    };
    _proto.getOwnerEvents = function getOwnerEvents() {
        var owner = this.getOwner();
        if (!this.options['autoOpenOn'] || !owner) return null;
        var events = {};
        events[this.options['autoOpenOn']] = this._onAutoOpen;
        return events;
    };
    _proto.onRemove = function onRemove() {
        this._onDomMouseout();
        this.onDomRemove();
    };
    _proto.onDomRemove = function onDomRemove() {
        if (this._onCloseBtnClick) {
            var dom = this.getDOM();
            var closeBtn = dom.childNodes[2];
            removeDomEvent(closeBtn, 'click touchend', this._onCloseBtnClick);
            delete this._onCloseBtnClick;
        }
    };
    _proto._onAutoOpen = function _onAutoOpen(e) {
        var _this2 = this;
        var owner = this.getOwner();
        setTimeout(function() {
            if (owner instanceof Marker || owner instanceof UIComponent) _this2.show(owner.getCoordinates());
            else if (owner instanceof MultiPoint) _this2.show(owner.findClosest(e.coordinate));
            else if (owner instanceof LineString || owner instanceof MultiLineString) {
                if (_this2.getMap().getScale() >= 8) e.coordinate = _this2._rectifyMouseCoordinte(owner, e.coordinate);
                _this2.show(e.coordinate);
            } else _this2.show(e.coordinate);
        }, 1);
    };
    _proto._rectifyMouseCoordinte = function _rectifyMouseCoordinte(owner, mouseCoordinate) {
        var _this3 = this;
        if (owner instanceof LineString) return this._rectifyLineStringMouseCoordinate(owner, mouseCoordinate).coordinate;
        else if (owner instanceof MultiLineString) return owner.getGeometries().map(function(lineString) {
            return _this3._rectifyLineStringMouseCoordinate(lineString, mouseCoordinate);
        }).sort(function(a, b) {
            return a.dis - b.dis;
        })[0].coordinate;
        return mouseCoordinate;
    };
    _proto._rectifyLineStringMouseCoordinate = function _rectifyLineStringMouseCoordinate(lineString, mouseCoordinate) {
        var map = this.getMap();
        var coordinates = lineString.getCoordinates() || [];
        var glRes = map.getGLRes();
        var pts = coordinates.map(function(coordinate) {
            var renderPoints = map.coordToPointAtRes(coordinate, glRes);
            var altitude = coordinate.z || 0;
            return map._pointAtResToContainerPoint(renderPoints, glRes, altitude);
        });
        var mousePt = map.coordToContainerPoint(mouseCoordinate);
        var minDis = Infinity, coordinateIndex = -1;
        for(var i = 0, len = pts.length; i < len; i++){
            var pt = pts[i];
            var dis = mousePt.distanceTo(pt);
            if (dis < minDis) {
                minDis = dis;
                coordinateIndex = i;
            }
        }
        var indexs = [
            coordinateIndex - 1,
            coordinateIndex,
            coordinateIndex + 1
        ].filter(function(index) {
            return index >= 0 && index <= pts.length - 1;
        });
        var filterPts = indexs.map(function(index) {
            return pts[index];
        });
        var xys = [];
        var { width: width, height: height } = map.getSize();
        for(var _i = 0, _len = filterPts.length - 1; _i < _len; _i++){
            var _coordinateIndex = _i;
            var pt1 = filterPts[_i], pt2 = filterPts[_i + 1];
            if (pt1.x === pt2.x) {
                var miny = Math.max(0, Math.min(pt1.y, pt2.y));
                var maxy = Math.min(height, Math.max(pt1.y, pt2.y));
                for(var _y = miny; _y <= maxy; _y++)xys.push({
                    point: new Point(pt1.x, _y),
                    coordinateIndex: _coordinateIndex
                });
            } else {
                var k = (pt2.y - pt1.y) / (pt2.x - pt1.x);
                var minx = Math.max(0, Math.min(pt1.x, pt2.x));
                var maxx = Math.min(width, Math.max(pt1.x, pt2.x));
                for(var _x = minx; _x <= maxx; _x++){
                    var _y2 = k * (_x - pt1.x) + pt1.y;
                    xys.push({
                        point: new Point(_x, _y2),
                        coordinateIndex: _coordinateIndex
                    });
                }
            }
        }
        var minPtDis = Infinity, ptIndex = -1, index = -1, containerPoint;
        for(var _i2 = 0, _len2 = xys.length; _i2 < _len2; _i2++){
            var { point: point, coordinateIndex: _coordinateIndex2 } = xys[_i2];
            var _dis = mousePt.distanceTo(point);
            if (_dis < minPtDis) {
                minPtDis = _dis;
                ptIndex = _i2;
                index = _coordinateIndex2;
                containerPoint = point;
            }
        }
        if (ptIndex < 0) return {
            dis: minPtDis,
            coordinate: mouseCoordinate
        };
        var p1 = filterPts[index], p2 = filterPts[index + 1];
        var distance = p1.distanceTo(p2);
        var d = containerPoint.distanceTo(p1);
        var percent = d / distance;
        var filterCoordinates = indexs.map(function(index) {
            return coordinates[index];
        });
        var c1 = filterCoordinates[index], c2 = filterCoordinates[index + 1];
        var x1 = c1.x, y1 = c1.y, z1 = c1.z || 0;
        var x2 = c2.x, y2 = c2.y, z2 = c2.z || 0;
        var dx = x2 - x1, dy = y2 - y1, dz = z2 - z1;
        var x = x1 + dx * percent, y = y1 + dy * percent, z = z1 + dz * percent;
        return {
            dis: minPtDis,
            coordinate: new Coordinate(x, y, z)
        };
    };
    _proto._getWindowWidth = function _getWindowWidth() {
        var defaultWidth = options$i.width;
        var width = this.options['width'];
        if (!width) width = defaultWidth;
        return width;
    };
    return InfoWindow;
}(UIComponent);
InfoWindow.mergeOptions(options$i);
var HIDEDOMEVENTS = 'remove hide shapechange positionchange dragend animatestart';
var options$h = {
    'width': 0,
    'height': 0,
    'animation': 'fade',
    'containerClass': 'maptalks-tooltip',
    'showTimeout': 400
};
var ToolTip = function(_UIComponent) {
    function ToolTip(content, options = {}) {
        var _this;
        _this = _UIComponent.call(this, options) || this;
        _this._content = content;
        return _this;
    }
    _inheritsLoose(ToolTip, _UIComponent);
    var _proto = ToolTip.prototype;
    _proto._getClassName = function _getClassName() {
        return 'ToolTip';
    };
    _proto.addTo = function addTo(owner) {
        if (ToolTip.isSupport(owner)) {
            owner.on('mousemove', this.onMouseMove, this);
            owner.on('mouseout', this.onMouseOut, this);
            owner.on(HIDEDOMEVENTS, this.hideDom, this);
            return _UIComponent.prototype.addTo.call(this, owner);
        } else throw new Error('Invalid geometry or UIMarker the tooltip is added to.');
    };
    _proto.setStyle = function setStyle(cssName) {
        this.options.containerClass = cssName;
        return this;
    };
    _proto.getStyle = function getStyle() {
        return this.options.containerClass;
    };
    _proto.getContent = function getContent() {
        return this._content;
    };
    _proto.buildOn = function buildOn() {
        var dom = createEl('div');
        var options = this.options || {};
        if (options.height) dom.style.height = options.height + 'px';
        if (options.width) dom.style.width = options.width + 'px';
        var cssName = options.containerClass || options.cssName;
        if (!cssName && options.height) dom.style.lineHeight = options.height + 'px';
        if (isFunction(this._content)) this._content.bind(this)(dom);
        else dom.innerHTML = "<div class=\"" + cssName + "\">" + this._content + "</div>";
        this._appendCustomClass(dom);
        return dom;
    };
    _proto.onMouseOut = function onMouseOut() {
        clearTimeout(this._timeout);
        if (this.isVisible()) this._removePrevDOM();
        this._switchMapEvents('off');
    };
    _proto.onMouseMove = function onMouseMove(e) {
        var _this2 = this;
        clearTimeout(this._timeout);
        var map = this.getMap();
        if (!map) return;
        var coord = map.locateByPoint(e.coordinate, -5, 25);
        if (this.options['showTimeout'] === 0) this.show(coord);
        else this._timeout = setTimeout(function() {
            if (map) _this2.show(coord);
        }, this.options['showTimeout']);
    };
    _proto.onRemove = function onRemove() {
        clearTimeout(this._timeout);
        if (this._owner) {
            this._owner.off('mousemove', this.onMouseMove, this);
            this._owner.off('mouseout', this.onMouseOut, this);
            this._owner.off(HIDEDOMEVENTS, this.hideDom, this);
        }
    };
    _proto.hideDom = function hideDom() {
        this.hide();
    };
    _proto.onEvent = function onEvent() {
        _UIComponent.prototype.onEvent.call(this);
        this.hideDom();
        return this;
    };
    _proto._getViewPoint = function _getViewPoint() {
        return this.getMap().coordToViewPoint(this._coordinate, undefined, 0)._add(this.options['dx'], this.options['dy']);
    };
    return ToolTip;
}(UIComponent);
ToolTip.mergeOptions(options$h);
var defaultOptions = {
    'containerClass': 'maptalks-menu',
    'animation': null,
    'animationDelay': 10,
    'animationOnHide': false,
    'autoPan': false,
    'width': 160,
    'maxHeight': 0,
    'custom': false,
    'items': []
};
var Menu = function(_UIComponent) {
    function Menu(options) {
        return _UIComponent.call(this, options) || this;
    }
    _inheritsLoose(Menu, _UIComponent);
    var _proto = Menu.prototype;
    _proto._getClassName = function _getClassName() {
        return 'Menu';
    };
    _proto.addTo = function addTo(owner) {
        if (owner._menu && owner._menu !== this) owner.removeMenu();
        owner._menu = this;
        this._owner = owner;
        return UIComponent.prototype.addTo.apply(this, [
            owner
        ]);
    };
    _proto.setItems = function setItems(items) {
        this.options['items'] = items;
        return this;
    };
    _proto.getItems = function getItems() {
        return this.options['items'] || [];
    };
    _proto.buildOn = function buildOn() {
        var dom;
        if (this.options['custom']) {
            if (isString(this.options['items'])) {
                var container = createEl('div');
                container.innerHTML = this.options['items'];
                this._appendCustomClass(container);
                dom = container;
            } else dom = this.options['items'];
        } else {
            dom = createEl('div');
            if (this.options['containerClass']) addClass(dom, this.options['containerClass']);
            dom.style.width = this._getMenuWidth() + 'px';
            var menuItems = this._createMenuItemDom();
            dom.appendChild(menuItems);
            on(dom, 'contextmenu', preventDefault);
            this._appendCustomClass(dom);
        }
        if (dom) {
            this._bindDomEvents(dom, 'off');
            this._bindDomEvents(dom, 'on');
        }
        return dom;
    };
    _proto.getOffset = function getOffset() {
        if (!this.getMap()) return null;
        var mapSize = this.getMap().getSize(), p = this.getMap().viewPointToContainerPoint(this._getViewPoint()), size = this.getSize();
        var dx = 0, dy = 0;
        if (p.x + size['width'] > mapSize['width']) dx = -size['width'];
        if (p.y + size['height'] > mapSize['height']) dy = -size['height'];
        return new Point(dx, dy);
    };
    _proto.getTransformOrigin = function getTransformOrigin() {
        var p = this.getOffset()._multi(-1);
        return p.x + 'px ' + p.y + 'px';
    };
    _proto.getEvents = function getEvents() {
        return {
            '_zoomstart _zoomend _movestart _dblclick _click': this._removePrevDOM
        };
    };
    _proto._createMenuItemDom = function _createMenuItemDom() {
        var me = this;
        var map = this.getMap();
        var ul = createEl('ul');
        addClass(ul, 'maptalks-menu-items');
        var items = this.getItems();
        function onMenuClick(index) {
            return function(e) {
                var param = map._parseEvent(e, 'click');
                param['target'] = me;
                param['owner'] = me._owner;
                param['index'] = index;
                var result = this._callback(param);
                if (result === false) return;
                me.hide();
                if (me._owner) me._owner.fire('closemenu');
            };
        }
        var item, itemDOM;
        for(var i = 0, len = items.length; i < len; i++){
            item = items[i];
            if (item === '-' || item === '_') {
                itemDOM = createEl('li');
                addClass(itemDOM, 'maptalks-menu-splitter');
            } else {
                itemDOM = createEl('li');
                var itemTitle = item['item'];
                if (isFunction(itemTitle)) itemTitle = itemTitle({
                    'owner': this._owner,
                    'index': i
                });
                itemDOM.innerHTML = itemTitle;
                itemDOM._callback = item['click'];
                on(itemDOM, 'click', onMenuClick(i));
            }
            ul.appendChild(itemDOM);
        }
        var maxHeight = this.options['maxHeight'] || 0;
        if (maxHeight > 0) setStyle(ul, 'max-height: ' + maxHeight + 'px; overflow-y: auto;');
        return ul;
    };
    _proto._getMenuWidth = function _getMenuWidth() {
        var defaultWidth = 160;
        var width = this.options['width'] || defaultWidth;
        return width;
    };
    return Menu;
}(UIComponent);
Menu.mergeOptions(defaultOptions);
var Menuable = {
    setMenu: function setMenu(options) {
        this._menuOptions = options;
        if (this._menu) this._menu._setOptions(options);
        else this.on('contextmenu', this._defaultOpenMenu, this);
        return this;
    },
    getMenu: function getMenu() {
        return this._menu;
    },
    openMenu: function openMenu(coordinate) {
        var map = this instanceof Map$1 ? this : this.getMap();
        if (!coordinate) coordinate = this.getCenter();
        if (!this._menu) {
            if (this._menuOptions && map) {
                this._bindMenu();
                this._menu.show(coordinate);
            }
        } else this._menu.show(coordinate);
        this.fire('openmenu', {
            coordinate: coordinate
        });
        return this;
    },
    setMenuItems: function setMenuItems(items) {
        if (!this._menuOptions) this._menuOptions = {};
        if (Array.isArray(items)) this._menuOptions['custom'] = false;
        this._menuOptions['items'] = items;
        this.setMenu(this._menuOptions);
        return this;
    },
    getMenuItems: function getMenuItems() {
        if (this._menu) return this._menu.getItems();
        else if (this._menuOptions) return this._menuOptions['items'] || [];
        return [];
    },
    closeMenu: function closeMenu() {
        if (this._menu) this._menu.hide();
        this.fire('closemenu', {});
        return this;
    },
    removeMenu: function removeMenu() {
        this.off('contextmenu', this._defaultOpenMenu, this);
        this._unbindMenu();
        delete this._menuOptions;
        this.fire('removemenu', {});
        return this;
    },
    _bindMenu: function _bindMenu() {
        if (!this._menuOptions) return this;
        this._menu = new Menu(this._menuOptions);
        this._menu.addTo(this);
        return this;
    },
    _unbindMenu: function _unbindMenu() {
        if (this._menu) {
            this.closeMenu();
            this._menu.remove();
            delete this._menu;
        }
        return this;
    },
    _defaultOpenMenu: function _defaultOpenMenu(param) {
        this.openMenu(param['coordinate']);
        return false;
    }
};
Map$1.include(Menuable);
Geometry.include(Menuable);
var index$2 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    InfoWindow: InfoWindow,
    Menu: Menu,
    Menuable: Menuable,
    ToolTip: ToolTip,
    UIComponent: UIComponent,
    UIMarker: UIMarker
});
var Control = function(_Eventable) {
    function Control(options) {
        if (options && options['position'] && !isString(options['position'])) options['position'] = extend$2({}, options['position']);
        return _Eventable.call(this, options) || this;
    }
    _inheritsLoose(Control, _Eventable);
    var _proto = Control.prototype;
    _proto._appendCustomClass = function _appendCustomClass(dom) {
        if (!dom) {
            console.warn('dom is null:', dom);
            return this;
        }
        if (this.options.cssName) {
            var cssName = this.options.cssName;
            if (!Array.isArray(cssName)) cssName = [
                cssName
            ];
            cssName.forEach(function(name) {
                dom.classList.add(name);
            });
        }
        return this;
    };
    _proto.onAdd = function onAdd() {};
    _proto.onRemove = function onRemove() {};
    _proto.addTo = function addTo(map) {
        this.remove();
        if (!map.options['control']) return this;
        this._map = map;
        var controlContainer = map.getPanels().control;
        this.__ctrlContainer = createEl('div');
        setStyle(this.__ctrlContainer, 'position:absolute;overflow:visible;');
        this.update();
        controlContainer.appendChild(this.__ctrlContainer);
        if (this.onAdd) this.onAdd();
        this.fire('add', {
            'dom': controlContainer
        });
        return this;
    };
    _proto.update = function update() {
        this.__ctrlContainer.innerHTML = '';
        this._controlDom = this.buildOn(this.getMap());
        if (this._controlDom) {
            this._updatePosition();
            this.__ctrlContainer.appendChild(this._controlDom);
        }
        return this;
    };
    _proto.getMap = function getMap() {
        return this._map;
    };
    _proto.getPosition = function getPosition() {
        return extend$2({}, this._parse(this.options['position']));
    };
    _proto.setPosition = function setPosition(position) {
        if (isString(position)) this.options['position'] = position;
        else this.options['position'] = extend$2({}, position);
        this._updatePosition();
        return this;
    };
    _proto.getContainerPoint = function getContainerPoint() {
        var position = this.getPosition();
        var size = this.getMap().getSize();
        var x, y;
        if (!isNil(position['left'])) x = parseInt(position['left'] + '');
        else if (!isNil(position['right'])) x = size['width'] - parseInt(position['right'] + '');
        if (!isNil(position['top'])) y = parseInt(position['top'] + '');
        else if (!isNil(position['bottom'])) y = size['height'] - parseInt(position['bottom'] + '');
        return new Point(x, y);
    };
    _proto.getContainer = function getContainer() {
        return this.__ctrlContainer;
    };
    _proto.getDOM = function getDOM() {
        return this._controlDom;
    };
    _proto.show = function show() {
        this.__ctrlContainer.style.display = '';
        return this;
    };
    _proto.hide = function hide() {
        this.__ctrlContainer.style.display = 'none';
        return this;
    };
    _proto.isVisible = function isVisible() {
        return this.__ctrlContainer && this.__ctrlContainer.style.display === '';
    };
    _proto.remove = function remove() {
        if (!this._map) return this;
        removeDomNode(this.__ctrlContainer);
        if (this.onRemove) this.onRemove();
        delete this._map;
        delete this.__ctrlContainer;
        delete this._controlDom;
        this.fire('remove');
        return this;
    };
    _proto._parse = function _parse(position) {
        var p = position;
        if (isString(position)) p = Control['positions'][p];
        return p;
    };
    _proto._updatePosition = function _updatePosition() {
        var position = this.getPosition();
        if (!position) position = {
            'top': 20,
            'left': 20
        };
        if (this.__ctrlContainer) Object.assign(this.__ctrlContainer.style, {
            top: null,
            bottom: null,
            right: null,
            left: null
        });
        for(var p in position)if (position.hasOwnProperty(p)) {
            var v = position[p] || 0;
            if (isNumber(v)) v += 'px';
            this.__ctrlContainer.style[p] = v;
        }
        this.fire('positionchange', {
            'position': extend$2({}, position)
        });
    };
    _proto.onConfig = function onConfig(conf) {
        if (conf && 'position' in conf) this._updatePosition();
    };
    return Control;
}(Eventable(Class));
Control.positions = {
    'top-left': {
        'top': 20,
        'left': 20
    },
    'top-right': {
        'top': 20,
        'right': 20
    },
    'bottom-left': {
        'bottom': 20,
        'left': 20
    },
    'bottom-right': {
        'bottom': 20,
        'right': 20
    }
};
Map$1.mergeOptions({
    'control': true
});
Map$1.include({
    addControl: function addControl(control) {
        if (this._containerDOM.getContext) return this;
        control.addTo(this);
        return this;
    },
    removeControl: function removeControl(control) {
        if (!control || control.getMap() !== this) return this;
        control.remove();
        return this;
    }
});
var options$g = {
    'position': {
        'bottom': 0,
        'left': 0
    },
    'content': '<a href="http://maptalks.org" target="_blank">maptalks</a>',
    'custom': false
};
var layerEvents = 'addlayer removelayer setbaselayer baselayerremove';
var Attribution = function(_Control) {
    function Attribution() {
        return _Control.apply(this, arguments) || this;
    }
    _inheritsLoose(Attribution, _Control);
    var _proto = Attribution.prototype;
    _proto.buildOn = function buildOn() {
        this._attributionContainer = createEl('div');
        this._attributionContainer.className = 'maptalks-attribution';
        this._appendCustomClass(this._attributionContainer);
        this._update();
        return this._attributionContainer;
    };
    _proto.getContent = function getContent() {
        return this.options.content;
    };
    _proto.setContent = function setContent(content) {
        this.options.content = content;
        this._update();
        return this;
    };
    _proto.onAdd = function onAdd() {
        this.getMap().on(layerEvents, this._update, this);
    };
    _proto.onRemove = function onRemove() {
        this.getMap().off(layerEvents, this._update, this);
    };
    _proto._updateContent = function _updateContent() {
        var container = this._attributionContainer;
        var content = this.options.content || '';
        if (container) {
            container.innerHTML = '';
            if (isString(content)) container.innerHTML = content;
            else if (content instanceof HTMLElement) container.appendChild(container);
        }
        return this;
    };
    _proto._update = function _update() {
        if (this.options.custom) {
            this._updateContent();
            return;
        }
        var map = this.getMap();
        if (!map) return;
        var attributions = map._getLayers(function(layer) {
            return !!layer.options['attribution'];
        }).reverse().map(function(layer) {
            return layer.options['attribution'];
        });
        var content = this.options['content'] + (attributions.length > 0 ? ' - ' + attributions.join(', ') : '');
        this._attributionContainer.innerHTML = '<span style="padding:0px 4px">' + content + '</span>';
    };
    return Attribution;
}(Control);
Attribution.mergeOptions(options$g);
Map$1.mergeOptions({
    'attribution': true
});
Map$1.addOnLoadHook(function() {
    var a = this.options['attribution'] || this.options['attributionControl'];
    if (a) {
        this.attributionControl = new Attribution(a);
        this.addControl(this.attributionControl);
    }
});
var options$f = {
    position: {
        'top': 120,
        'left': 20
    }
};
var Compass = function(_Control) {
    function Compass() {
        return _Control.apply(this, arguments) || this;
    }
    _inheritsLoose(Compass, _Control);
    var _proto = Compass.prototype;
    _proto.buildOn = function buildOn(map) {
        var compass = this._getCompass();
        this._appendCustomClass(compass);
        this._compass = compass;
        this._registerDomEvents();
        map.on('resize moving moveend zooming zoomend rotate rotateend dragrotating dragrotateend viewchange', this._rotateCompass, this);
        return compass;
    };
    _proto.onAdd = function onAdd() {
        this._rotateCompass();
    };
    _proto._getCompass = function _getCompass() {
        var compass = createEl('div', 'maptalks-compass');
        return compass;
    };
    _proto._registerDomEvents = function _registerDomEvents() {
        on(this._compass, 'click', this._resetView, this);
    };
    _proto._rotateCompass = function _rotateCompass() {
        var b = this.getMap().getBearing().toFixed(1);
        var bearing = parseFloat(b);
        if (bearing <= 180) bearing *= -1;
        if (bearing !== this._bearing) {
            this._bearing = bearing;
            setStyle(this._compass, "transform: rotate(" + this._bearing + "deg);");
        }
    };
    _proto.onRemove = function onRemove() {
        this.getMap().off('resize moving moveend zooming zoomend rotate rotateend dragrotating dragrotateend viewchange', this._rotateCompass, this);
        delete this._compass;
        delete this._bearing;
    };
    _proto._resetView = function _resetView() {
        var view = {
            bearing: 0
        };
        this.getMap().animateTo(view);
    };
    return Compass;
}(Control);
Compass.mergeOptions(options$f);
Map$1.mergeOptions({
    'compassControl': false
});
Map$1.addOnLoadHook(function() {
    if (this.options['compassControl']) {
        this.compassControl = new Compass(this.options['compassControl']);
        this.addControl(this.compassControl);
    }
});
var options$e = {
    'position': 'top-right',
    'baseTitle': 'Base Layers',
    'overlayTitle': 'Layers',
    'excludeLayers': [],
    'containerClass': 'maptalks-layer-switcher'
};
var LayerSwitcher = function(_Control) {
    function LayerSwitcher() {
        return _Control.apply(this, arguments) || this;
    }
    _inheritsLoose(LayerSwitcher, _Control);
    var _proto = LayerSwitcher.prototype;
    _proto.buildOn = function buildOn() {
        var container = this.container = createEl('div', this.options['containerClass']), panel = this.panel = createEl('div', 'panel'), button = this.button = createEl('button');
        container.appendChild(button);
        container.appendChild(panel);
        this._appendCustomClass(container);
        return container;
    };
    _proto.onAdd = function onAdd() {
        on(this.button, 'mouseover', this._show, this);
        on(this.panel, 'mouseleave', this._hide, this);
    };
    _proto.onRemove = function onRemove() {
        if (this.panel) {
            off(this.button, 'mouseover', this._show);
            off(this.panel, 'mouseleave', this._hide);
            removeDomNode(this.panel);
            removeDomNode(this.button);
            delete this.panel;
            delete this.button;
            delete this.container;
        }
    };
    _proto._show = function _show() {
        if (!hasClass(this.container, 'shown')) {
            addClass(this.container, 'shown');
            this._createPanel();
        }
    };
    _proto._hide = function _hide(e) {
        if (!this.panel.contains(e.toElement || e.relatedTarget)) setClass(this.container, this.options['containerClass']);
    };
    _proto._createPanel = function _createPanel() {
        this.panel.innerHTML = '';
        var ul = createEl('ul');
        this.panel.appendChild(ul);
        this._renderLayers(this.getMap(), ul);
    };
    _proto._renderLayers = function _renderLayers(map, elm) {
        var _this = this;
        var base = map.getBaseLayer(), layers = map.getLayers(), len = layers.length;
        if (base) {
            var baseLayers = base.layers || [
                base
            ], li = createEl('li', 'group'), ul = createEl('ul'), label = createEl('label');
            label.innerHTML = this.options['baseTitle'];
            li.appendChild(label);
            for(var i = 0, _len = baseLayers.length; i < _len; i++){
                var layer = baseLayers[i];
                if (this._isExcluded(layer)) {
                    ul.appendChild(this._renderLayer(baseLayers[i], true));
                    li.appendChild(ul);
                    elm.appendChild(li);
                }
            }
        }
        if (len) {
            var _li = createEl('li', 'group'), _ul = createEl('ul'), _label = createEl('label'), input = createEl('input');
            input.type = 'checkbox';
            input.checked = true;
            _label.innerHTML = this.options['overlayTitle'];
            _li.appendChild(input);
            _li.appendChild(_label);
            var groupInputOnChange = function groupInputOnChange(e) {
                var checked = e.target.checked;
                var parentNode = e.target.parentNode;
                if (!parentNode) return;
                var ul = parentNode.getElementsByTagName('ul')[0];
                if (!ul) return;
                var parentLayerShow = function parentLayerShow(node) {
                    var layer = node._layer;
                    if (layer) layer[checked ? 'show' : 'hide']();
                };
                var layerShow = function layerShow(li) {
                    var layer = li._layer, checkbox = li.childNodes[0];
                    if (checkbox) checkbox.checked = checked;
                    if (layer) layer[checked ? 'show' : 'hide']();
                };
                parentLayerShow(parentNode);
                ul.childNodes.forEach(function(li) {
                    layerShow(li);
                    var childUl = li.getElementsByTagName('ul')[0];
                    if (!childUl) return;
                    parentLayerShow(li);
                    childUl.childNodes.forEach(function(li) {
                        layerShow(li);
                    });
                });
            };
            var _loop = function _loop() {
                var layer = layers[_i];
                if (_this._isExcluded(layer)) {
                    if (layer.getLayers) {
                        var groupLi = createEl('li', 'group'), groupUl = createEl('ul'), groupLabel = createEl('label'), groupInput = createEl('input');
                        groupLabel.innerHTML = layer.getId();
                        groupInput.type = 'checkbox';
                        groupInput.checked = layer.isVisible();
                        groupInput.onchange = groupInputOnChange;
                        groupLi.appendChild(groupInput);
                        groupLi.appendChild(groupLabel);
                        groupLi.appendChild(groupUl);
                        groupLi._layer = layer;
                        _ul.appendChild(groupLi);
                        var groupLayers = layer.getLayers() || [];
                        groupLayers.forEach(function(layer) {
                            groupUl.appendChild(_this._renderLayer(layer, false, groupInput.checked));
                        });
                    } else _ul.appendChild(_this._renderLayer(layer));
                    if (layer && !layer.isVisible()) input.checked = false;
                }
            };
            for(var _i = 0; _i < len; _i++)_loop();
            _li.appendChild(_ul);
            elm.appendChild(_li);
            input.onchange = groupInputOnChange;
        }
    };
    _proto._isExcluded = function _isExcluded(layer) {
        var id = layer.getId(), excludeLayers = this.options['excludeLayers'];
        return !(excludeLayers.length && excludeLayers.indexOf(id) >= 0);
    };
    _proto._renderLayer = function _renderLayer(layer, isBase, parentChecked = true) {
        var _this2 = this;
        var li = createEl('li', 'layer'), label = createEl('label'), input = createEl('input'), map = this.getMap();
        var visible = layer.options['visible'];
        layer.options['visible'] = true;
        var enabled = layer.isVisible();
        layer.options['visible'] = visible;
        li.className = 'layer';
        var radioInput = input;
        if (isBase) {
            radioInput.type = 'radio';
            radioInput.name = 'base';
        } else radioInput.type = 'checkbox';
        radioInput.checked = visible && enabled;
        if (!parentChecked) radioInput.checked = false;
        if (!enabled) radioInput.setAttribute('disabled', 'disabled');
        radioInput.onchange = function(e) {
            if (e.target.type === 'radio') {
                var baseLayer = map.getBaseLayer(), baseLayers = baseLayer.layers;
                if (baseLayers) for(var i = 0, len = baseLayers.length; i < len; i++){
                    var childLayer = baseLayers[i];
                    childLayer[childLayer === layer ? 'show' : 'hide']();
                }
                else if (!baseLayer.isVisible()) baseLayer.show();
                map._fireEvent('setbaselayer');
            } else layer[e.target.checked ? 'show' : 'hide']();
            _this2.fire('layerchange', {
                target: layer
            });
        };
        li.appendChild(input);
        label.innerHTML = layer.getId();
        li.appendChild(label);
        li._layer = layer;
        return li;
    };
    return LayerSwitcher;
}(Control);
LayerSwitcher.mergeOptions(options$e);
Map$1.mergeOptions({
    'layerSwitcherControl': false
});
Map$1.addOnLoadHook(function() {
    if (this.options['layerSwitcherControl']) {
        this.layerSwitcherControl = new LayerSwitcher(this.options['layerSwitcherControl']);
        this.addControl(this.layerSwitcherControl);
    }
});
var options$d = {
    'level': 4,
    'position': {
        'right': 1,
        'bottom': 1
    },
    'size': [
        300,
        200
    ],
    'maximize': true,
    'symbol': {
        'lineWidth': 3,
        'lineColor': '#1bbc9b',
        'polygonFill': '#1bbc9b',
        'polygonOpacity': 0.4
    },
    'containerClass': 'maptalks-overview',
    'buttonClass': 'maptalks-overview-button'
};
var Overview = function(_Control) {
    function Overview() {
        return _Control.apply(this, arguments) || this;
    }
    _inheritsLoose(Overview, _Control);
    var _proto = Overview.prototype;
    _proto.buildOn = function buildOn() {
        var size = this.options['size'];
        if (!this.options['maximize']) size = [
            0,
            0
        ];
        var container = createEl('div');
        this._appendCustomClass(container);
        var mapContainer = this.mapContainer = createEl('div');
        mapContainer.style.width = size[0] + 'px';
        mapContainer.style.height = size[1] + 'px';
        mapContainer.className = this.options['containerClass'];
        var button = this.button = createEl('div');
        button.className = this.options['buttonClass'];
        container.appendChild(mapContainer);
        container.appendChild(button);
        return container;
    };
    _proto.onAdd = function onAdd() {
        if (this.options['maximize']) this._createOverview();
        this.getMap().on('resize moving zooming rotate dragrotating viewchange', this._update, this).on('setbaselayer', this._updateBaseLayer, this).on('spatialreferencechange', this._updateSpatialReference, this);
        on(this.button, 'click', this._onButtonClick, this);
        this._updateButtonText();
    };
    _proto.onRemove = function onRemove() {
        this.getMap().off('resize moving zooming rotate dragrotating viewchange', this._update, this).off('setbaselayer', this._updateBaseLayer, this).off('spatialreferencechange', this._updateSpatialReference, this);
        if (this._overview) {
            this._overview.remove();
            delete this._overview;
            delete this._perspective;
        }
        off(this.button, 'click', this._onButtonClick);
    };
    _proto.maxmize = function maxmize() {
        var size = this.options['size'];
        var dom = this.mapContainer;
        dom.style.width = size[0] + 'px';
        dom.style.height = size[1] + 'px';
        this._createOverview();
        return this;
    };
    _proto.minimize = function minimize() {
        if (this._overview) this._overview.remove();
        delete this._overview;
        delete this._perspective;
        var dom = this.mapContainer;
        dom.style.width = "0px";
        dom.style.height = "0px";
        return this;
    };
    _proto.getOverviewMap = function getOverviewMap() {
        return this._overview;
    };
    _proto._onButtonClick = function _onButtonClick() {
        if (!this._overview) this.maxmize();
        else this.minimize();
        this._updateButtonText();
    };
    _proto._updateButtonText = function _updateButtonText() {
        if (this._overview) this.button.innerHTML = '-';
        else this.button.innerHTML = '+';
    };
    _proto._createOverview = function _createOverview() {
        var map = this.getMap(), dom = this.mapContainer;
        var options = map.config();
        extend$2(options, {
            'center': map.getCenter(),
            'zoom': this._getOverviewZoom(),
            'zoomAnimationDuration': 150,
            'pitch': 0,
            'bearing': 0,
            'scrollWheelZoom': false,
            'checkSize': false,
            'doubleClickZoom': false,
            'touchZoom': false,
            'control': false,
            'draggable': false,
            'maxExtent': null
        });
        this._overview = new Map$1(dom, options);
        this._updateBaseLayer();
        this._perspective = new Polygon(this._getPerspectiveCoords(), {
            'draggable': true,
            'cursor': 'move',
            'symbol': this.options['symbol']
        }).on('dragend', this._onDragEnd, this);
        new DrawToolLayer('perspective_layer', this._perspective).addTo(this._overview);
        this.fire('load');
    };
    _proto._getOverviewZoom = function _getOverviewZoom() {
        var map = this.getMap(), zoom = map.getZoom(), minZoom = map.getMinZoom(), level = this.options['level'];
        if (level > 0) for(var i = level; i > 0; i--){
            if (zoom - i >= minZoom) return zoom - i;
        }
        else for(var _i = level; _i < 0; _i++){
            if (zoom - _i >= minZoom) return zoom - _i;
        }
        return zoom;
    };
    _proto._onDragEnd = function _onDragEnd() {
        var center = this._perspective.getCenter();
        this._overview.setCenter(center);
        this.getMap().panTo(center);
    };
    _proto._getPerspectiveCoords = function _getPerspectiveCoords() {
        var map = this.getMap();
        var projection = map.getProjection();
        return map.getContainerExtent().toArray().map(function(c) {
            if (projection) {
                var prjCoord = map._containerPointToPrj(c);
                map._fixPrjOnWorldWide(prjCoord);
                return projection.unproject(prjCoord);
            }
            return map.containerPointToCoordinate(c);
        });
    };
    _proto._update = function _update() {
        if (!this._overview) return;
        computeDomPosition(this._overview.getContainer());
        var coords = this._getPerspectiveCoords();
        this._perspective.setCoordinates(coords);
        this._overview.setCenterAndZoom(this.getMap().getCenter(), this._getOverviewZoom());
    };
    _proto._updateSpatialReference = function _updateSpatialReference() {
        if (!this._overview) return;
        var map = this.getMap();
        var spatialRef = map.options['spatialReference'];
        this._overview.setSpatialReference(spatialRef);
    };
    _proto._updateBaseLayer = function _updateBaseLayer() {
        if (!this._overview) return;
        var map = this.getMap(), baseLayer = map.getBaseLayer();
        if (!baseLayer) {
            this._overview.setBaseLayer(null);
            return;
        }
        var layers = baseLayer.layers;
        var showIndex = 0;
        if (layers) for(var i = 0, l = layers.length; i < l; i++){
            var _layer = layers[i];
            if (_layer.isVisible()) {
                showIndex = i;
                break;
            }
        }
        var json = baseLayer.toJSON();
        var options = null;
        if (layers) {
            options = json.layers[showIndex].options;
            options.visible = true;
        } else options = json.options;
        this._overview.setMinZoom(options.minZoom || null).setMaxZoom(options.maxZoom || null);
        delete options.minZoom;
        delete options.maxZoom;
        delete json.options.canvas;
        json.options.visible = true;
        json.options.renderer = 'canvas';
        var layer = Layer.fromJSON(json);
        for(var p in baseLayer)if (isFunction(baseLayer[p]) && baseLayer.hasOwnProperty(p) && baseLayer[p] !== baseLayer.constructor.prototype[p]) layer[p] = baseLayer[p];
        this._overview.setBaseLayer(layer);
    };
    return Overview;
}(Control);
Overview.mergeOptions(options$d);
Map$1.mergeOptions({
    'overviewControl': false
});
Map$1.addOnLoadHook(function() {
    if (this.options['overviewControl']) {
        this.overviewControl = new Overview(this.options['overviewControl']);
        this.addControl(this.overviewControl);
    }
});
var options$c = {
    position: "top-right",
    draggable: true,
    custom: false,
    content: "",
    closeButton: true
};
var Panel = function(_Control) {
    function Panel() {
        return _Control.apply(this, arguments) || this;
    }
    _inheritsLoose(Panel, _Control);
    var _proto = Panel.prototype;
    _proto.buildOn = function buildOn() {
        var _this = this;
        var dom;
        if (this.options["custom"]) {
            if (isString(this.options["content"])) {
                dom = createEl("div");
                dom.innerHTML = this.options["content"];
                this._appendCustomClass(dom);
            } else dom = this.options["content"];
        } else {
            dom = createEl("div", "maptalks-panel");
            this._appendCustomClass(dom);
            if (this.options["closeButton"]) {
                var closeButton = createEl("a", "maptalks-close");
                closeButton.innerText = "\xd7";
                closeButton.href = "javascript:;";
                closeButton.onclick = function() {
                    dom.style.display = "none";
                    _this.fire("close");
                };
                dom.appendChild(closeButton);
            }
            var panelContent = createEl("div", "maptalks-panel-content");
            if (isString(this.options["content"])) panelContent.innerHTML = this.options["content"];
            else panelContent.appendChild(this.options.content);
            dom.appendChild(panelContent);
        }
        this.draggable = new DragHandler(dom, {
            cancelOn: this._cancelOn.bind(this),
            ignoreMouseleave: true
        });
        this.draggable.on("dragstart", this._onDragStart, this).on("dragging", this._onDragging, this).on("dragend", this._onDragEnd, this);
        if (this.options["draggable"]) this.draggable.enable();
        return dom;
    };
    _proto.update = function update() {
        if (this.draggable) {
            this.draggable.disable();
            delete this.draggable;
        }
        return Control.prototype.update.call(this);
    };
    _proto.setContent = function setContent(content) {
        var old = this.options["content"];
        this.options["content"] = content;
        this.fire("contentchange", {
            old: old,
            "new": content
        });
        if (this.isVisible()) this.update();
        return this;
    };
    _proto.getContent = function getContent() {
        return this.options["content"];
    };
    _proto._cancelOn = function _cancelOn(domEvent) {
        var target = domEvent.srcElement || domEvent.target, tagName = target.tagName.toLowerCase();
        if (tagName === "button" || tagName === "input" || tagName === "select" || tagName === "option" || tagName === "textarea") return true;
        return false;
    };
    _proto._onDragStart = function _onDragStart(param) {
        this._startPos = param["mousePos"];
        this._startPosition = extend$2({}, this.getPosition());
        this.fire("dragstart", param);
    };
    _proto._onDragging = function _onDragging(param) {
        var pos = param["mousePos"];
        var offset = pos.sub(this._startPos);
        var startPosition = this._startPosition;
        var position = this.getPosition();
        if (!isNil(position["top"])) position["top"] = parseInt(startPosition["top"]) + offset.y;
        if (!isNil(position["bottom"])) position["bottom"] = parseInt(startPosition["bottom"]) - offset.y;
        if (!isNil(position["left"])) position["left"] = parseInt(startPosition["left"]) + offset.x;
        if (!isNil(position["right"])) position["right"] = parseInt(startPosition["right"]) - offset.x;
        this.setPosition(position);
        this.fire("dragging", param);
    };
    _proto._onDragEnd = function _onDragEnd(param) {
        delete this._startPos;
        delete this._startPosition;
        this.fire("dragend", param);
    };
    _proto._getConnectPoints = function _getConnectPoints() {
        var map = this.getMap();
        var containerPoint = this.getContainerPoint();
        var dom = this.getDOM(), width = parseInt(dom.clientWidth + ""), height = parseInt(dom.clientHeight + "");
        var anchors = [
            map.containerPointToCoordinate(containerPoint.add(width / 2, 0)),
            map.containerPointToCoordinate(containerPoint.add(width, height / 2)),
            map.containerPointToCoordinate(containerPoint.add(width / 2, height)),
            map.containerPointToCoordinate(containerPoint.add(0, height / 2))
        ];
        return anchors;
    };
    return Panel;
}(Control);
Panel.mergeOptions(options$c);
var options$b = {
    position: {
        'top': 156,
        'left': 20
    },
    view: null
};
var Reset = function(_Control) {
    function Reset() {
        return _Control.apply(this, arguments) || this;
    }
    _inheritsLoose(Reset, _Control);
    var _proto = Reset.prototype;
    _proto.buildOn = function buildOn() {
        var reset = this._getReset();
        this._appendCustomClass(reset);
        this._reset = reset;
        this._registerDomEvents();
        return reset;
    };
    _proto.onAdd = function onAdd() {
        this._view = !this.options.view ? this.getMap().getView() : this.options.view;
    };
    _proto.setView = function setView(view) {
        this._view = view;
    };
    _proto._getReset = function _getReset() {
        var reset = createEl('div', 'maptalks-reset');
        return reset;
    };
    _proto._registerDomEvents = function _registerDomEvents() {
        on(this._reset, 'click', this._resetView, this);
    };
    _proto.onRemove = function onRemove() {
        delete this._reset;
        delete this._view;
    };
    _proto._resetView = function _resetView() {
        this.getMap().setView(this._view);
    };
    return Reset;
}(Control);
Reset.mergeOptions(options$b);
Map$1.mergeOptions({
    'resetControl': false
});
Map$1.addOnLoadHook(function() {
    if (this.options['resetControl']) {
        this.resetControl = new Reset(this.options['resetControl']);
        this.addControl(this.resetControl);
    }
});
var options$a = {
    'position': 'bottom-left',
    'maxWidth': 100,
    'metric': true,
    'imperial': false,
    'containerClass': null
};
var EVENTS_TO_LISTEN = 'zoomend moving moveend';
var Scale = function(_Control) {
    function Scale() {
        return _Control.apply(this, arguments) || this;
    }
    _inheritsLoose(Scale, _Control);
    var _proto = Scale.prototype;
    _proto.buildOn = function buildOn(map) {
        this._map = map;
        this._scaleContainer = createEl('div', this.options['containerClass']);
        this._addScales();
        map.on(EVENTS_TO_LISTEN, this._update, this);
        if (this._map.isLoaded()) this._update();
        this._appendCustomClass(this._scaleContainer);
        return this._scaleContainer;
    };
    _proto.onRemove = function onRemove() {
        this.getMap().off(EVENTS_TO_LISTEN, this._update, this);
    };
    _proto._addScales = function _addScales() {
        var css = "border: 2px solid #000000;border-top: none;line-height: 1.1;padding: 0px;color: #000000;font-size: 11px;text-align:center;white-space: nowrap;overflow: hidden;-moz-box-sizing: content-box;box-sizing: content-box;background: #fff; background: rgba(255, 255, 255, 0);";
        if (this.options['metric']) this._mScale = createElOn('div', this.options['containerClass'] ? null : css, this._scaleContainer);
        if (this.options['imperial']) this._iScale = createElOn('div', this.options['containerClass'] ? null : css, this._scaleContainer);
    };
    _proto._update = function _update() {
        var map = this._map;
        var maxMeters = map.pixelToDistance(this.options['maxWidth'], 0);
        this._updateScales(maxMeters);
    };
    _proto._updateScales = function _updateScales(maxMeters) {
        if (this.options['metric'] && maxMeters) this._updateMetric(maxMeters);
        if (this.options['imperial'] && maxMeters) this._updateImperial(maxMeters);
    };
    _proto._updateMetric = function _updateMetric(maxMeters) {
        var meters = this._getRoundNum(maxMeters), label = meters < 1000 ? meters + ' m' : meters / 1000 + ' km';
        this._updateScale(this._mScale, label, meters / maxMeters);
    };
    _proto._updateImperial = function _updateImperial(maxMeters) {
        var maxFeet = maxMeters * 3.2808399;
        var maxMiles, miles, feet;
        if (maxFeet > 5280) {
            maxMiles = maxFeet / 5280;
            miles = this._getRoundNum(maxMiles);
            this._updateScale(this._iScale, miles + ' mile', miles / maxMiles);
        } else {
            feet = this._getRoundNum(maxFeet);
            this._updateScale(this._iScale, feet + ' feet', feet / maxFeet);
        }
    };
    _proto._updateScale = function _updateScale(scale, text, ratio) {
        scale['style']['width'] = Math.round(this.options['maxWidth'] * ratio) + 'px';
        scale['innerHTML'] = text;
    };
    _proto._getRoundNum = function _getRoundNum(num) {
        var pow10 = Math.pow(10, (Math.floor(num) + '').length - 1);
        var d = num / pow10;
        d = d >= 10 ? 10 : d >= 5 ? 5 : d >= 3 ? 3 : d >= 2 ? 2 : 1;
        return pow10 * d;
    };
    return Scale;
}(Control);
Scale.mergeOptions(options$a);
Map$1.mergeOptions({
    'scaleControl': false
});
Map$1.addOnLoadHook(function() {
    if (this.options['scaleControl']) {
        this.scaleControl = new Scale(this.options['scaleControl']);
        this.addControl(this.scaleControl);
    }
});
var options$9 = {
    'height': 28,
    'vertical': false,
    'position': 'top-right',
    'reverseMenu': false,
    'items': []
};
var Toolbar = function(_Control) {
    function Toolbar() {
        return _Control.apply(this, arguments) || this;
    }
    _inheritsLoose(Toolbar, _Control);
    var _proto = Toolbar.prototype;
    _proto.buildOn = function buildOn(map) {
        this._map = map;
        var dom = createEl('div');
        var ul = createEl('ul', 'maptalks-toolbar-hx');
        dom.appendChild(ul);
        if (this.options['vertical']) addClass(dom, 'maptalks-toolbar-vertical');
        else addClass(dom, 'maptalks-toolbar-horizonal');
        var me = this;
        function onButtonClick(fn, index, childIndex, targetDom) {
            var item = me._getItems()[index];
            return function(e) {
                stopPropagation(e);
                return fn({
                    'target': item,
                    'index': index,
                    'childIndex': childIndex,
                    'dom': targetDom
                });
            };
        }
        var items = this.options['items'];
        if (isArrayHasData(items)) for(var i = 0, len = items.length; i < len; i++){
            var item = items[i];
            var li = createEl('li');
            if (this.options['height'] !== 28) li.style.lineHeight = this.options['height'] + 'px';
            li.style.height = this.options['height'] + 'px';
            li.style.cursor = 'pointer';
            if (isHTML(item['item'])) {
                li.style.textAlign = 'center';
                var itemSize = measureDom('div', item['item']);
                li.innerHTML = '<div style="margin-top:' + (this.options['height'] - itemSize['height']) / 2 + 'px;">' + item['item'] + '</div>';
            } else li.innerHTML = item['item'];
            if (item['click']) on(li, 'click', onButtonClick(item['click'], i, null, li));
            if (isArrayHasData(item['children'])) {
                var dropMenu = this._createDropMenu(i);
                li.appendChild(dropMenu);
                li._menu = dropMenu;
                on(li, 'mouseover', function() {
                    this._menu.style.display = '';
                });
                on(li, 'mouseout', function() {
                    this._menu.style.display = 'none';
                });
            }
            ul.appendChild(li);
        }
        this._appendCustomClass(dom);
        return dom;
    };
    _proto._createDropMenu = function _createDropMenu(index) {
        var me = this;
        function onButtonClick(fn, index, childIndex) {
            var item = me._getItems()[index]['children'][childIndex];
            return function(e) {
                stopPropagation(e);
                return fn({
                    'target': item,
                    'index': index,
                    'childIndex': childIndex
                });
            };
        }
        var menuDom = createEl('div', 'maptalks-dropMenu'), items = this._getItems(), len = items.length, menuUL = createEl('ul'), children = items[index]['children'];
        if (index === len - 1 && children) {
            menuDom.style.cssText = 'right: 0px;';
            menuUL.style.cssText = 'right: 0px;position: absolute;';
            if (this.options['reverseMenu']) menuUL.style.bottom = "0";
        }
        menuDom.appendChild(createEl('em', 'maptalks-ico'));
        var liWidth = 0;
        for(var i = 0, l = children.length; i < l; i++){
            var size = stringLength(children[i]['item'], '12px');
            if (size.width > liWidth) liWidth = size.width;
        }
        for(var _i = 0, _l = children.length; _i < _l; _i++){
            var child = children[_i];
            var li = createEl('li');
            li.innerHTML = '<a href="javascript:;">' + child['item'] + '</a>';
            li.style.cursor = 'pointer';
            li.style.width = liWidth + 24 + 'px';
            on(li.childNodes[0], 'click', onButtonClick(child['click'], index, _i));
            menuUL.appendChild(li);
        }
        if (this.options['vertical']) {
            var width = liWidth < 95 ? 95 : liWidth;
            if (this.options['reverseMenu']) menuDom.style.right = -(width + 20 + 2) + 'px';
            else menuDom.style.left = -(width + 20 + 2) + 'px';
        } else if (this.options['reverseMenu']) menuDom.style.bottom = '28px';
        else menuDom.style.top = '29px';
        menuDom.appendChild(menuUL);
        menuDom.style.display = 'none';
        return menuDom;
    };
    _proto._getItems = function _getItems() {
        return this.options['items'] || [];
    };
    return Toolbar;
}(Control);
Toolbar.mergeOptions(options$9);
var options$8 = {
    'position': 'top-left',
    'zoomLevel': true,
    'seamless': false
};
var Zoom = function(_Control) {
    function Zoom() {
        return _Control.apply(this, arguments) || this;
    }
    _inheritsLoose(Zoom, _Control);
    var _proto = Zoom.prototype;
    _proto.buildOn = function buildOn(map) {
        var options = this.options;
        var dom = createEl('div', 'maptalks-zoom');
        this._appendCustomClass(dom);
        if (options['zoomLevel']) {
            var levelWrapper = createEl('span', 'maptalks-zoom-zoomlevel');
            var levelDOM = createEl('span', 'maptalks-zoom-zoomlevel-text');
            levelWrapper.appendChild(levelDOM);
            dom.appendChild(levelWrapper);
            this._levelDOM = levelDOM;
        }
        var zoomDOM = createEl('div', 'maptalks-zoom-slider');
        var zoomInButton = createEl('a', 'maptalks-zoom-zoomin');
        zoomInButton.href = 'javascript:;';
        zoomDOM.appendChild(zoomInButton);
        this._zoomInButton = zoomInButton;
        var zoomOutButton = createEl('a', 'maptalks-zoom-zoomout');
        zoomOutButton.href = 'javascript:;';
        zoomDOM.appendChild(zoomOutButton);
        this._zoomOutButton = zoomOutButton;
        dom.appendChild(zoomDOM);
        map.on('_zoomend _zooming _zoomstart _spatialreferencechange', this._update, this);
        this._update();
        this._registerDomEvents();
        return dom;
    };
    _proto.onRemove = function onRemove() {
        this.getMap().off('_zoomend _zooming _zoomstart _spatialreferencechange', this._update, this);
    };
    _proto._update = function _update() {
        this._updateText();
    };
    _proto._updateText = function _updateText() {
        if (this._levelDOM) {
            var map = this.getMap();
            var zoom = map.getZoom();
            if (!isInteger(zoom)) zoom = Math.floor(zoom * 10) / 10;
            this._levelDOM.innerHTML = zoom + '';
        }
    };
    _proto._registerDomEvents = function _registerDomEvents() {
        if (this._zoomInButton) on(this._zoomInButton, 'click', this._onZoomInClick, this);
        if (this._zoomOutButton) on(this._zoomOutButton, 'click', this._onZoomOutClick, this);
    };
    _proto._onZoomInClick = function _onZoomInClick(e) {
        preventDefault(e);
        this.getMap().zoomIn();
    };
    _proto._onZoomOutClick = function _onZoomOutClick(e) {
        preventDefault(e);
        this.getMap().zoomOut();
    };
    return Zoom;
}(Control);
Zoom.mergeOptions(options$8);
Map$1.mergeOptions({
    'zoomControl': false
});
Map$1.addOnLoadHook(function() {
    if (this.options['zoomControl']) {
        this.zoomControl = new Zoom(this.options['zoomControl']);
        this.addControl(this.zoomControl);
    }
});
var index$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Attribution: Attribution,
    Compass: Compass,
    Control: Control,
    LayerSwitcher: LayerSwitcher,
    Overview: Overview,
    Panel: Panel,
    Reset: Reset,
    Scale: Scale,
    Toolbar: Toolbar,
    Zoom: Zoom
});
var TileSystem = function() {
    function TileSystem(sx, sy, ox, oy) {
        if (Array.isArray(sx)) {
            this.scale = {
                x: sx[0],
                y: sx[1]
            };
            this.origin = {
                x: sx[2],
                y: sx[3]
            };
        } else {
            this.scale = {
                x: sx,
                y: sy
            };
            this.origin = {
                x: ox,
                y: oy
            };
        }
    }
    TileSystem.getDefault = function getDefault(projection) {
        var code = projection['code'].toLowerCase();
        if (code === 'baidu') return 'baidu';
        else if (code === 'EPSG:4326'.toLowerCase() || code === 'EPSG:4490'.toLowerCase()) return 'tms-global-geodetic';
        else if (code === 'identity') return [
            1,
            -1,
            0,
            0
        ];
        else return 'web-mercator';
    };
    return TileSystem;
}();
var semiCircum = 6378137 * Math.PI;
extend$2(TileSystem, {
    'web-mercator': new TileSystem([
        1,
        -1,
        -semiCircum,
        semiCircum
    ]),
    'tms-global-mercator': new TileSystem([
        1,
        1,
        -semiCircum,
        -semiCircum
    ]),
    'tms-global-geodetic': new TileSystem([
        1,
        1,
        -180,
        -90
    ]),
    'baidu': new TileSystem([
        1,
        1,
        0,
        0
    ])
});
var TileConfig = function() {
    function TileConfig(map, tileSystem, fullExtent, tileSize) {
        this.map = map;
        this.tileSize = tileSize;
        this.fullExtent = fullExtent;
        this.prepareTileInfo(tileSystem, fullExtent);
        this._xScale = fullExtent['right'] >= fullExtent['left'] ? 1 : -1;
        this._yScale = fullExtent['top'] >= fullExtent['bottom'] ? 1 : -1;
        var glRes = map.getGLRes();
        this._pointOrigin = map._prjToPointAtRes(new Point(this.tileSystem['origin']), glRes);
        this._glRes = glRes;
    }
    var _proto = TileConfig.prototype;
    _proto.prepareTileInfo = function prepareTileInfo(tileSystem, fullExtent) {
        if (isString(tileSystem)) tileSystem = TileSystem[tileSystem.toLowerCase()];
        else if (Array.isArray(tileSystem)) tileSystem = new TileSystem(tileSystem);
        if (!tileSystem) throw new Error('Invalid TileSystem');
        this.tileSystem = tileSystem;
        var a = fullExtent['right'] > fullExtent['left'] ? 1 : -1, b = fullExtent['top'] > fullExtent['bottom'] ? -1 : 1, c = tileSystem['origin']['x'], d = tileSystem['origin']['y'];
        this.transformation = new Transformation([
            a,
            b,
            c,
            d
        ]);
    };
    _proto._getTileNum = function _getTileNum(point, res) {
        var tileSystem = this.tileSystem, tileSize = this['tileSize'], delta = 1E-7;
        var tileX = Math.floor(delta * tileSystem['scale']['x'] + point.x / (tileSize['width'] * res));
        var tileY = Math.ceil(delta * tileSystem['scale']['y'] + point.y / (tileSize['height'] * res));
        return {
            'x': tileSystem['scale']['x'] * tileX,
            'y': tileSystem['scale']['y'] * tileY
        };
    };
    _proto.getTileIndex = function getTileIndex(pCoord, res, repeatWorld) {
        var tileSystem = this.tileSystem;
        var point = this.transformation.transform(pCoord, 1);
        var tileIndex = this._getTileNum(point, res);
        if (tileSystem['scale']['x'] < 0) tileIndex['x'] -= 1;
        if (tileSystem['scale']['y'] > 0) tileIndex['y'] -= 1;
        return this.getNeighorTileIndex(tileIndex['x'], tileIndex['y'], 0, 0, res, repeatWorld);
    };
    _proto.getNeighorTileIndex = function getNeighorTileIndex(tileX, tileY, offsetX, offsetY, res, repeatWorld) {
        var tileSystem = this.tileSystem;
        var x = tileX + tileSystem['scale']['x'] * offsetX;
        var y = tileY - tileSystem['scale']['y'] * offsetY;
        var out = false;
        var idx = x;
        var idy = y;
        var ext = this._getTileFullIndex(res);
        if (repeatWorld) {
            if (repeatWorld === true || repeatWorld === 'x') {
                if (ext['xmax'] === ext['xmin']) x = ext['xmin'];
                else if (x < ext['xmin']) {
                    x = ext['xmax'] - (ext['xmin'] - x) % (ext['xmax'] - ext['xmin']);
                    if (x === ext['xmax']) x = ext['xmin'];
                } else if (x >= ext['xmax']) x = ext['xmin'] + (x - ext['xmin']) % (ext['xmax'] - ext['xmin']);
            }
            if (repeatWorld === true || repeatWorld === 'y') {
                if (ext['ymax'] === ext['ymin']) y = ext['ymin'];
                else if (y >= ext['ymax']) y = ext['ymin'] + (y - ext['ymin']) % (ext['ymax'] - ext['ymin']);
                else if (y < ext['ymin']) {
                    y = ext['ymax'] - (ext['ymin'] - y) % (ext['ymax'] - ext['ymin']);
                    if (y === ext['ymax']) y = ext['ymin'];
                }
            }
        }
        if (x < ext['xmin'] || x > ext['xmax'] || y > ext['ymax'] || y < ext['ymin']) out = true;
        return {
            'x': x,
            'y': y,
            'idx': idx,
            'idy': idy,
            out: out
        };
    };
    _proto._getTileFullIndex = function _getTileFullIndex(res) {
        if (!this._tileFullIndex) this._tileFullIndex = {};
        if (this._tileFullIndex[res]) return this._tileFullIndex[res];
        var ext = this.fullExtent;
        var transformation = this.transformation;
        var nwIndex = this._getTileNum(transformation.transform(new Coordinate(ext['left'], ext['top']), 1), res);
        var seIndex = this._getTileNum(transformation.transform(new Coordinate(ext['right'], ext['bottom']), 1), res);
        var tileSystem = this.tileSystem;
        if (tileSystem['scale']['x'] < 0) {
            nwIndex.x -= 1;
            seIndex.x -= 1;
        }
        if (tileSystem['scale']['y'] > 0) {
            nwIndex.y -= 1;
            seIndex.y -= 1;
        }
        this._tileFullIndex[res] = new Extent(nwIndex, seIndex, null);
        return this._tileFullIndex[res];
    };
    _proto.getTilePrjNW = function getTilePrjNW(tileX, tileY, res, out) {
        var tileSystem = this.tileSystem;
        var tileSize = this['tileSize'];
        var y = tileSystem['origin']['y'] + this._yScale * tileSystem['scale']['y'] * (tileY + (tileSystem['scale']['y'] === 1 ? 1 : 0)) * res * tileSize['height'];
        var x = tileSystem['origin']['x'] + this._xScale * tileSystem['scale']['x'] * (tileX + (tileSystem['scale']['x'] === 1 ? 0 : 1)) * res * tileSize['width'];
        if (out) {
            out.set(x, y);
            return out;
        }
        return new Coordinate(x, y);
    };
    _proto.getTilePointNW = function getTilePointNW(tileX, tileY, res, out) {
        var scale = this._glRes / res;
        var tileSystem = this.tileSystem;
        var tileSize = this['tileSize'];
        var y = this._pointOrigin.y * scale + this._yScale * tileSystem['scale']['y'] * (tileY + (tileSystem['scale']['y'] === 1 ? 1 : 0)) * tileSize['height'];
        var x = this._pointOrigin.x * scale + this._xScale * tileSystem['scale']['x'] * (tileX + (tileSystem['scale']['x'] === 1 ? 0 : 1)) * tileSize['width'];
        if (out) {
            out.set(x, y);
            return out;
        }
        return new Point(x, y);
    };
    _proto.getTilePrjSE = function getTilePrjSE(tileX, tileY, res, out) {
        var tileSystem = this.tileSystem;
        var tileSize = this['tileSize'];
        var y = tileSystem['origin']['y'] + this._yScale * tileSystem['scale']['y'] * (tileY + (tileSystem['scale']['y'] === 1 ? 0 : 1)) * res * tileSize['height'];
        var x = tileSystem['origin']['x'] + this._xScale * tileSystem['scale']['x'] * (tileX + (tileSystem['scale']['x'] === 1 ? 1 : 0)) * res * tileSize['width'];
        if (out) {
            out.set(x, y);
            return out;
        }
        return new Coordinate(x, y);
    };
    _proto.getTilePointSE = function getTilePointSE(tileX, tileY, res, out) {
        var scale = this._glRes / res;
        var tileSystem = this.tileSystem;
        var tileSize = this['tileSize'];
        var y = this._pointOrigin.y * scale + this._yScale * tileSystem['scale']['y'] * (tileY + (tileSystem['scale']['y'] === 1 ? 0 : 1)) * tileSize['height'];
        var x = this._pointOrigin.x * scale + this._xScale * tileSystem['scale']['x'] * (tileX + (tileSystem['scale']['x'] === 1 ? 1 : 0)) * tileSize['width'];
        if (out) {
            out.set(x, y);
            return out;
        }
        return new Point(x, y);
    };
    _proto.getTilePrjExtent = function getTilePrjExtent(tileX, tileY, res) {
        var nw = this.getTilePrjNW(tileX, tileY, res), se = this.getTilePrjSE(tileX, tileY, res);
        return new Extent(nw, se);
    };
    return TileConfig;
}();
/*!
* Contains code from THREE.js
* MIT License
* https://github.com/mrdoob/three.js
*/ var planes = [];
for(var i = 0; i < 6; i++)planes[i] = [];
var p = [];
function intersectsBox(matrix, box, mask) {
    setPlanes(matrix);
    for(var i = 0; i < 6; i++){
        var plane = planes[i];
        // corner at max distance
        p[0] = plane[0] > 0 ? box[1][0] : box[0][0];
        p[1] = plane[1] > 0 ? box[1][1] : box[0][1];
        p[2] = plane[2] > 0 ? box[1][2] : box[0][2];
        if (distanceToPoint(plane, p) < 0) return false;
    }
    return true;
}
function setPlanes(m) {
    var me = m;
    var me0 = me[0], me1 = me[1], me2 = me[2], me3 = me[3];
    var me4 = me[4], me5 = me[5], me6 = me[6], me7 = me[7];
    var me8 = me[8], me9 = me[9], me10 = me[10], me11 = me[11];
    var me12 = me[12], me13 = me[13], me14 = me[14], me15 = me[15];
    //right
    setComponents(planes[0], me3 - me0, me7 - me4, me11 - me8, me15 - me12);
    //left
    setComponents(planes[1], me3 + me0, me7 + me4, me11 + me8, me15 + me12);
    //bottom
    setComponents(planes[2], me3 + me1, me7 + me5, me11 + me9, me15 + me13);
    //top
    setComponents(planes[3], me3 - me1, me7 - me5, me11 - me9, me15 - me13);
    //z-far
    setComponents(planes[4], me3 - me2, me7 - me6, me11 - me10, me15 - me14);
    //z-near
    setComponents(planes[5], me3 + me2, me7 + me6, me11 + me10, me15 + me14);
}
var normalLength = 1.0 / 6;
function setComponents(out, x, y, z, w) {
    out[0] = x * normalLength;
    out[1] = y * normalLength;
    out[2] = z * normalLength;
    out[3] = w * normalLength;
    return out;
}
function distanceToPoint(plane, p) {
    return plane[0] * p[0] + plane[1] * p[1] + plane[2] * p[2] + plane[3];
}
var DEFAULT_MAXERROR = 1;
var TEMP_POINT$3 = new Point(0, 0);
var MAX_ROOT_NODES = 32;
var isSetAvailable = typeof Set !== 'undefined';
var TileHashset = function() {
    function TileHashset() {
        this._table = isSetAvailable ? new Set() : {};
    }
    var _proto = TileHashset.prototype;
    _proto.add = function add(key) {
        if (isSetAvailable) this._table.add(key);
        else this._table[key] = true;
    };
    _proto.has = function has(key) {
        if (isSetAvailable) return this._table.has(key);
        else return this._table[key];
    };
    _proto.reset = function reset() {
        if (isSetAvailable) this._table.clear();
        else this._table = {};
    };
    return TileHashset;
}();
var options$7 = {
    'urlTemplate': null,
    'subdomains': null,
    'errorUrl': null,
    'repeatWorld': true,
    'background': true,
    'loadingLimitOnInteracting': 3,
    'loadingLimit': 0,
    'placeholder': false,
    'crossOrigin': null,
    'tileSize': [
        256,
        256
    ],
    'offset': [
        0,
        0
    ],
    'tileSystem': null,
    'fadeAnimation': !IS_NODE,
    'fadeDuration': 1000 / 60 * 10,
    'debug': false,
    'spatialReference': null,
    'maxCacheSize': 256,
    'renderer': function() {
        return Browser$1.webgl ? 'gl' : 'canvas';
    }(),
    'clipByPitch': true,
    'maxAvailableZoom': null,
    'cascadeTiles': true,
    'zoomOffset': 0,
    'pyramidMode': 1,
    'decodeImageInWorker': false,
    'tileLimitPerFrame': 0,
    'tileStackStartDepth': 7,
    'tileStackDepth': 6,
    'awareOfTerrain': true,
    'bufferPixel': 0.5,
    'mipmapTexture': true,
    'depthMask': true,
    'currentTilesFirst': true,
    'forceRenderOnMoving': true,
    'tileErrorScale': 1
};
var URL_PATTERN = /\{ *([\w_]+) *\}/g;
var TEMP_POINT0 = new Point(0, 0);
var TEMP_POINT1$1 = new Point(0, 0);
var TEMP_POINT2$1 = new Point(0, 0);
var TEMP_POINT3 = new Point(0, 0);
var TEMP_POINT4 = new Point(0, 0);
var TEMP_POINT6 = new Point(0, 0);
var TILE_BOX = [
    [
        0,
        0,
        0
    ],
    [
        0,
        0,
        0
    ]
];
var TILE_MIN = [
    0,
    0,
    0
];
var TILE_MAX = [
    0,
    0,
    0
];
var ARR3 = [
    0,
    0,
    0
];
var TileLayer = function(_Layer) {
    function TileLayer(id, options) {
        return _Layer.call(this, id, options) || this;
    }
    _inheritsLoose(TileLayer, _Layer);
    TileLayer.fromJSON = function fromJSON(layerJSON) {
        if (!layerJSON || layerJSON['type'] !== 'TileLayer') return null;
        return new TileLayer(layerJSON['id'], layerJSON['options']);
    };
    var _proto2 = TileLayer.prototype;
    _proto2.forceReload = function forceReload() {
        this.fire('forcereloadstart');
        this.clear();
        if (this._renderer) this._renderer.setToRedraw();
        this.fire('forcereloadend');
        return this;
    };
    _proto2.getTileSize = function getTileSize(id) {
        if (this._tileSize) return this._tileSize;
        var size = this.options['tileSize'];
        if (isNumber(size)) size = [
            size,
            size
        ];
        this._tileSize = new Size(size);
        return this._tileSize;
    };
    _proto2.getTiles = function getTiles(z, parentLayer) {
        var _this = this;
        this._coordCache = {};
        var result;
        if (this._isPyramidMode()) result = this._getPyramidTiles(z, parentLayer);
        else result = this._getCascadeTiles(z, parentLayer);
        if (!this._maskGeoJSON) return result;
        var tileGrids = result.tileGrids || [];
        var count = 0;
        tileGrids.forEach(function(tileGrid) {
            var tiles = tileGrid.tiles || [];
            tileGrid.tiles = tiles.filter(function(tile) {
                return _this._tileInMask(tile);
            });
            count += tileGrid.tiles.length;
            var parentIds = tileGrid.tiles.map(function(tile) {
                return tile.parent;
            });
            tileGrid.parents = (tileGrid.parents || []).filter(function(parent) {
                return parentIds.indexOf(parent.id) > -1;
            });
        });
        result.count = count;
        return result;
    };
    _proto2._isPyramidMode = function _isPyramidMode() {
        var sr = this._spatialRef || this.getSpatialReference();
        return !this._disablePyramid && !this._hasOwnSR && this.options['pyramidMode'] && sr && sr.isPyramid();
    };
    _proto2._getTileFullExtent = function _getTileFullExtent() {
        if (this._tileFullExtent) return this._tileFullExtent;
        var sr = this.getSpatialReference();
        var fullExtent = sr.getFullExtent();
        var res = sr.getResolution(0);
        var map = this.getMap();
        this._tileFullExtent = fullExtent.convertTo(function(c) {
            return map._prjToPointAtRes(c, res, TEMP_POINT$3);
        });
        return this._tileFullExtent;
    };
    _proto2._getRootNodes = function _getRootNodes(offset0) {
        var map = this.getMap();
        if (this._rootNodes) {
            var { tiles: _tiles, mapWidth: mapWidth, mapHeight: mapHeight } = this._rootNodes;
            if (map.width !== mapWidth || map.height !== mapHeight) {
                var _error = this._getRootError();
                for(var i = 0; i < _tiles.length; i++)_tiles[i].error = _error;
                this._rootNodes.mapWidth = map.width;
                this._rootNodes.mapHeight = map.height;
            }
            for(var _i = 0; _i < _tiles.length; _i++){
                _tiles[_i].offset[0] = offset0[0];
                _tiles[_i].offset[1] = offset0[1];
            }
            return this._rootNodes;
        }
        var sr = this._spatialRef || this.getSpatialReference();
        var res = sr.getResolution(0);
        var tileConfig = this._getTileConfig();
        var fullExtent = sr.getFullExtent();
        var { origin: origin, scale: scale } = tileConfig.tileSystem;
        var extent000 = tileConfig.getTilePrjExtent(0, 0, res);
        var w = extent000.getWidth();
        var h = extent000.getHeight();
        var delta = 1E-5;
        var left = Math.abs((origin.x - fullExtent.left) / w);
        left = Math.ceil(left - delta);
        var right = Math.abs((fullExtent.right - origin.x) / w);
        right = Math.ceil(right - delta);
        var top = Math.ceil(Math.abs(fullExtent.top - origin.y) / h);
        top = Math.ceil(top - delta);
        var bottom = Math.ceil(Math.abs(fullExtent.bottom - origin.y) / h);
        bottom = Math.ceil(bottom - delta);
        if ((right + left) * (bottom + top) > MAX_ROOT_NODES) return {
            status: 0,
            error: 'Too many root nodes'
        };
        var error = this._getRootError();
        var tiles = [];
        var z = 0;
        for(var _i2 = -left; _i2 < right; _i2++)for(var j = -top; j < bottom; j++){
            var y = scale.y < 0 ? j : -(j + 1);
            tiles.push(this.createTileNode(_i2, y, z, _i2, y, res, error));
        }
        this._rootNodes = {
            status: 1,
            tiles: tiles,
            mapWidth: map.width,
            mapHeight: map.height
        };
        return this._getRootNodes(offset0);
    };
    _proto2.createTileNode = function createTileNode(x, y, z, idx, idy, res, error, parentId, extent2d, tileId) {
        var map = this.map;
        var zoomOffset = this.options['zoomOffset'];
        if (!extent2d) {
            var tileConfig = this._getTileConfig();
            extent2d = tileConfig.getTilePrjExtent(x, y, res).convertTo(function(c) {
                return map._prjToPointAtRes(c, res, TEMP_POINT$3);
            });
        }
        var offset = this._getTileOffset(z);
        var url = this.getTileUrl(x, y, z + zoomOffset);
        return {
            parent: parentId,
            layer: this.getId(),
            x: x,
            y: y,
            z: z,
            idx: idx,
            idy: idy,
            res: res,
            extent2d: extent2d,
            id: tileId || this._getTileId(x, y, z),
            url: formatResourceUrl(url),
            offset: offset,
            error: error,
            children: []
        };
    };
    _proto2._getRootError = function _getRootError() {
        var map = this.getMap();
        var fov = toRadian(map.getFov());
        var aspectRatio = map.width / map.height;
        var cameraZ = map.cameraPosition[2];
        var heightZ = cameraZ * Math.tan(0.5 * fov);
        var widthZ = heightZ * aspectRatio;
        var diagonalZ = Math.sqrt(cameraZ * cameraZ + heightZ * heightZ + widthZ * widthZ);
        var fov0 = map._getFovZ(0);
        var error = fov0 * (diagonalZ / cameraZ);
        var sr = this._spatialRef || this.getSpatialReference();
        var res = sr.getResolution(0);
        return error * res / map.getResolution(0);
    };
    _proto2._getPyramidTiles = function _getPyramidTiles(z, layer) {
        var map = this.map;
        if (isNaN(+z)) z = this._getTileZoom(map.getZoom());
        var sr = this._spatialRef || this.getSpatialReference();
        var maxZoom = Math.min(z, this.getMaxZoom(), this.getMaxAvailableZoom() || Infinity);
        var projectionView = map.projViewMatrix;
        var fullExtent = this._getTileFullExtent();
        var offset0 = this._getTileOffset(0);
        var queue;
        if (this.options['repeatWorld']) {
            var mapContainerExtent = map.getContainerExtent();
            var mapExtent2D = this._convertToExtent2d(mapContainerExtent);
            var scale = sr.getResolution(0) / map.getResolution();
            if (!mapExtent2D.within(fullExtent.copy()._scale(scale))) {
                var pitch = map.getPitch();
                var cascadePitch1 = map.options['cascadePitches'][1];
                var visualHeight1 = Math.floor(map._getVisualHeight(cascadePitch1));
                var visualContainerExtent = pitch <= cascadePitch1 ? mapContainerExtent : new PointExtent(0, map.height - visualHeight1, map.width, map.height);
                this._visitedTiles = new TileHashset();
                var tileGrid = this._getTiles(0 - this.options['zoomOffset'], visualContainerExtent, 2, layer && layer.getRenderer(), true);
                var error = this._getRootError() * Math.pow(2, this.options['zoomOffset']);
                tileGrid.tiles.forEach(function(t) {
                    t.error = error;
                });
                queue = tileGrid.tiles;
            } else {
                var rootNodes = this._getRootNodes(offset0);
                if (rootNodes.status !== 1) {
                    console.warn(rootNodes.error);
                    this._disablePyramid = true;
                    return this.getTiles(z, layer);
                }
                queue = [
                    ...rootNodes.tiles
                ];
            }
        } else {
            var _rootNodes = this._getRootNodes(offset0);
            if (_rootNodes.status !== 1) {
                console.warn(_rootNodes.error);
                this._disablePyramid = true;
                return this.getTiles(z, layer);
            }
            queue = [
                ..._rootNodes.tiles
            ];
        }
        var glRes = map.getGLRes();
        var offsets = {
            0: offset0
        };
        var extent = new PointExtent();
        var tiles = [];
        var parents = [];
        var parentRenderer = layer && layer.getRenderer();
        while(queue.length > 0){
            var node = queue.pop();
            if (node.z === maxZoom) {
                extent._combine(node.extent2d);
                tiles.push(node);
                continue;
            }
            if (!offsets[node.z + 1]) offsets[node.z + 1] = this._getTileOffset(node.z + 1);
            this._splitNode(node, projectionView, queue, tiles, extent, maxZoom, offsets[node.z + 1], parentRenderer, glRes);
            if (this.isParentTile(z, maxZoom, node)) parents.push(node);
        }
        parents.sort(sortingTiles);
        return {
            tileGrids: [
                {
                    extent: extent,
                    count: tiles.length,
                    tiles: tiles,
                    parents: parents,
                    offset: [
                        0,
                        0
                    ],
                    zoom: z
                }
            ],
            count: tiles.length
        };
    };
    _proto2.isParentTile = function isParentTile(z, maxZoom, tile) {
        var stackMinZoom = Math.max(this.getMinZoom(), z - this.options['tileStackStartDepth']);
        var stackMaxZoom = Math.min(maxZoom, stackMinZoom + this.options['tileStackDepth']);
        return tile.z >= stackMinZoom && tile.z < stackMaxZoom;
    };
    _proto2._splitNode = function _splitNode(node, projectionView, queue, tiles, gridExtent, maxZoom, offset, parentRenderer, glRes) {
        var z = node.z + 1;
        var sr = this._spatialRef || this.getSpatialReference();
        var { idx: idx, idy: idy } = node;
        var renderer = parentRenderer || this.getRenderer();
        var hasCurrentIn = false;
        var children = [];
        var res = sr.getResolution(z);
        var glScale = res / glRes;
        if (!this.tileInfoCache) this.tileInfoCache = new LRUCache(this.options['maxCacheSize'] * 4);
        for(var i = 0; i < 4; i++){
            var dx = i % 2;
            var dy = i >> 1;
            if (!node.children) node.children = [];
            var tileId = node.children[i];
            if (!tileId) {
                var childIdx = (idx << 1) + dx;
                var childIdy = (idy << 1) + dy;
                tileId = this._getTileId(childIdx, childIdy, z);
                node.children[i] = tileId;
            }
            var cached = renderer.isTileCachedOrLoading(tileId);
            var childNode = cached && cached.info;
            if (!childNode) {
                childNode = this.tileInfoCache.get(tileId);
                if (!childNode) childNode = this._createChildNode(node, dx, dy, offset, tileId);
            }
            childNode.error = node.error / 2;
            childNode.offset[0] = offset[0];
            childNode.offset[1] = offset[1];
            var visible = this._isTileVisible(childNode, projectionView, glScale, maxZoom, offset);
            if (visible === 1) hasCurrentIn = true;
            else if (visible === -1) continue;
            else if (visible === 0 && z !== maxZoom) {
                tiles.push(node);
                gridExtent._combine(node.extent2d);
                return;
            }
            children.push(childNode);
        }
        if (z === maxZoom) {
            if (hasCurrentIn) pushIn(queue, children);
            else {
                tiles.push(node);
                gridExtent._combine(node.extent2d);
            }
        } else pushIn(queue, children);
    };
    _proto2._createChildNode = function _createChildNode(node, dx, dy, offset, tileId) {
        var { x: x, y: y, idx: idx, idy: idy, extent2d: extent2d } = node;
        var z = node.z + 1;
        var childX = (x << 1) + dx;
        var childY = (y << 1) + dy;
        var childIdx = (idx << 1) + dx;
        var childIdy = (idy << 1) + dy;
        var childScale = 2;
        var width = extent2d.getWidth() / 2 * childScale;
        var height = extent2d.getHeight() / 2 * childScale;
        var minx = extent2d.xmin * childScale;
        var maxy = extent2d.ymax * childScale;
        var miny = extent2d.ymin * childScale;
        var tileSystem = this._getTileConfig().tileSystem;
        var scaleY = tileSystem.scale.y;
        tileId = tileId || this._getTileId(childIdx, childIdy, z);
        var extent;
        if (scaleY < 0) {
            var nwx = minx + dx * width;
            var nwy = maxy - dy * height;
            extent = new PointExtent(nwx, nwy - height, nwx + width, nwy);
        } else {
            var swx = minx + dx * width;
            var swy = miny + dy * height;
            extent = new PointExtent(swx, swy, swx + width, swy + height);
        }
        var childNode = this.createTileNode(childX, childY, z, childIdx, childIdy, node.res / 2, node.error / 2, node.id, extent, tileId);
        this.tileInfoCache.add(tileId, childNode);
        return childNode;
    };
    _proto2._isTileVisible = function _isTileVisible(node, projectionView, glScale, maxZoom, offset) {
        if (node.z === 0) return 1;
        if (!this._isTileInFrustum(node, projectionView, glScale, offset)) return -1;
        var maxError = this.options['maxError'];
        if (isNil(maxError)) maxError = DEFAULT_MAXERROR;
        var error = this._getScreenSpaceError(node, glScale, maxZoom, offset);
        return error >= maxError ? 1 : 0;
    };
    _proto2._isTileInFrustum = function _isTileInFrustum(node, projectionView, glScale, offset) {
        if (!this._zScale) {
            var map = this.getMap();
            var glRes = map.getGLRes();
            this._zScale = map.altitudeToPoint(100, glRes) / 100;
        }
        var renderer = this.getRenderer();
        var { xmin: xmin, ymin: ymin, xmax: xmax, ymax: ymax } = node.extent2d;
        if (node.offset && node.offset[0] !== 0 && node.offset[1] !== 0 && !isFunction(this.options.offset)) {
            var [x, y] = node.offset;
            xmin += x;
            xmax += x;
            ymin += y;
            ymax += y;
        }
        TILE_BOX[0][0] = (xmin - offset[0]) * glScale;
        TILE_BOX[0][1] = (ymin - offset[1]) * glScale;
        var minAltitude = node.minAltitude || renderer && renderer.avgMinAltitude || 0;
        TILE_BOX[0][2] = minAltitude * this._zScale;
        TILE_BOX[1][0] = (xmax - offset[0]) * glScale;
        TILE_BOX[1][1] = (ymax - offset[1]) * glScale;
        var maxAltitude = node.maxAltitude || renderer && renderer.avgMaxAltitude || 0;
        TILE_BOX[1][2] = maxAltitude * this._zScale;
        return intersectsBox(projectionView, TILE_BOX);
    };
    _proto2._getScreenSpaceError = function _getScreenSpaceError(node, glScale, maxZoom, offset) {
        var geometricError = node.error;
        var map = this.map;
        var { xmin: xmin, ymin: ymin, xmax: xmax, ymax: ymax } = node.extent2d;
        TILE_MIN[0] = (xmin - offset[0]) * glScale;
        TILE_MIN[1] = (ymin - offset[1]) * glScale;
        TILE_MAX[0] = (xmax - offset[0]) * glScale;
        TILE_MAX[1] = (ymax - offset[1]) * glScale;
        var distanceToCamera = distanceToRect(TILE_MIN, TILE_MAX, map.cameraPosition);
        var distance = Math.max(Math.abs(distanceToCamera), 1E-7);
        var gap = Math.abs(node.z - maxZoom);
        var r;
        if (map.height < 1000) r = 1;
        else r = gap <= 1 ? 1 : gap <= 2 ? 0.7 : 0.605;
        var error = geometricError * r / distance * this.options['tileErrorScale'];
        var pitch = map.getPitch();
        if (pitch <= 60) return error * 1.45;
        return error;
    };
    _proto2._getCascadeTiles = function _getCascadeTiles(z, parentLayer) {
        var map = this.getMap();
        var pitch = map.getPitch();
        var parentRenderer = parentLayer && parentLayer.getRenderer();
        var mapExtent = map.getContainerExtent();
        var tileGrids = [];
        var count = 0;
        var minZoom = this.getMinZoom();
        var cascadePitch0 = map.options['cascadePitches'][0];
        var cascadePitch1 = map.options['cascadePitches'][1];
        var visualHeight1 = Math.floor(map._getVisualHeight(cascadePitch1));
        var tileZoom = isNil(z) ? this._getTileZoom(map.getZoom()) : z;
        this._visitedTiles = new TileHashset();
        if (!isNil(z) || !this.options['cascadeTiles'] || pitch <= cascadePitch0 || !isNil(minZoom) && tileZoom <= minZoom) {
            var containerExtent = pitch <= cascadePitch1 ? mapExtent : new PointExtent(0, map.height - visualHeight1, map.width, map.height);
            var _currentTiles = this._getTiles(tileZoom, containerExtent, 2, parentRenderer);
            if (_currentTiles) {
                count += _currentTiles.tiles.length;
                tileGrids.push(_currentTiles);
            }
            return {
                tileGrids: tileGrids,
                count: count
            };
        }
        var visualHeight0 = Math.floor(map._getVisualHeight(cascadePitch0));
        var extent0 = new PointExtent(0, map.height - visualHeight0, map.width, map.height);
        var currentTiles = this._getTiles(tileZoom, extent0, 0, parentRenderer);
        count += currentTiles ? currentTiles.tiles.length : 0;
        tileGrids.push(currentTiles);
        var cascadeHeight = extent0.ymin;
        var d = map.getSpatialReference().getZoomDirection();
        var cascadeLevels = d;
        var cascadeTiles1;
        if (pitch > cascadePitch1) {
            if (tileZoom - cascadeLevels <= minZoom) cascadeLevels = 0;
            var extent1 = new PointExtent(0, map.height - visualHeight1, map.width, cascadeHeight);
            cascadeTiles1 = this._getTiles(tileZoom - cascadeLevels, extent1, 1, parentRenderer);
            count += cascadeTiles1 ? cascadeTiles1.tiles.length : 0;
            cascadeHeight = extent1.ymin;
            cascadeLevels += 4 * d;
            tileGrids.push(cascadeTiles1);
        }
        var cascadeTiles2;
        if (tileZoom - cascadeLevels >= minZoom) {
            var extent2 = new PointExtent(0, mapExtent.ymin, map.width, cascadeHeight);
            cascadeTiles2 = this._getTiles(tileZoom - cascadeLevels, extent2, 2, parentRenderer);
            count += cascadeTiles2 ? cascadeTiles2.tiles.length : 0;
            tileGrids.push(cascadeTiles2);
        }
        if (cascadeTiles1 && cascadeTiles2) {
            tileGrids[1] = cascadeTiles2;
            tileGrids[2] = cascadeTiles1;
        }
        return {
            tileGrids: tileGrids,
            count: count
        };
    };
    _proto2.getTileUrl = function getTileUrl(x, y, z) {
        var urlTemplate = this.options['urlTemplate'];
        var domain = '';
        var subdomains = this.options['subdomains'];
        if (subdomains) {
            if (isArrayHasData(subdomains)) {
                var length = subdomains.length;
                var s = (x + y) % length;
                if (s < 0) s = 0;
                domain = subdomains[s];
            }
        }
        if (isFunction(urlTemplate)) return urlTemplate(x, y, z, domain);
        var data = {
            'x': x,
            'y': y,
            'z': z,
            's': domain
        };
        if (this.options.token) data.token = this.options.token;
        if (this.options.customTags) extend$2(data, this.options.customTags);
        return urlTemplate.replace(URL_PATTERN, function(str, key) {
            var value = data[key];
            if (value === undefined) throw new Error('No value provided for variable ' + str);
            else if (typeof value === 'function') value = value(data);
            return value;
        });
    };
    _proto2.clear = function clear() {
        if (this._renderer) this._renderer.clear();
        if (this.tileInfoCache) this.tileInfoCache.reset();
        this.fire('clear');
        return this;
    };
    _proto2.toJSON = function toJSON() {
        var profile = {
            'type': this.getJSONType(),
            'id': this.getId(),
            'options': this.config()
        };
        return profile;
    };
    _proto2.getSpatialReference = function getSpatialReference() {
        var map = this.getMap();
        if (map && (!this.options['spatialReference'] || SpatialReference.equals(this.options['spatialReference'], map.options['spatialReference']))) return map.getSpatialReference();
        if (this._sr) return this._sr;
        var config = this.options['spatialReference'];
        if (isString(config)) {
            config = SpatialReference.getPreset(config);
            if (!config) throw new Error("Unsupported spatial reference: " + this.options['spatialReference'] + ", possible values: " + SpatialReference.getAllPresets().join());
        }
        this._sr = new SpatialReference(config);
        this._srMinZoom = this._sr.getMinZoom();
        this._srMaxZoom = this._sr.getMaxZoom();
        this._hasOwnSR = this._sr.toJSON().projection !== map.getSpatialReference().toJSON().projection;
        return this._sr;
    };
    _proto2.getMinZoom = function getMinZoom() {
        var minZoom = this.options['minZoom'] || 0;
        var sr = this._spatialRef || this.getSpatialReference();
        if (sr !== this.getMap().getSpatialReference()) return Math.max(minZoom, this._srMinZoom);
        return minZoom;
    };
    _proto2.getMaxZoom = function getMaxZoom() {
        var sr = this._spatialRef || this.getSpatialReference();
        if (sr !== this.getMap().getSpatialReference()) return Math.min(_Layer.prototype.getMaxZoom.call(this), this._srMaxZoom);
        return _Layer.prototype.getMaxZoom.call(this);
    };
    _proto2._getTileZoom = function _getTileZoom(zoom) {
        if (!this._hasOwnSR) {
            var res0 = this.getMap().getResolution(zoom);
            var res1 = this.getSpatialReference().getResolution(zoom);
            var dz = Math.log(res1 / res0) * Math.LOG2E;
            zoom += dz;
        }
        var maxZoom = this.getMaxAvailableZoom();
        if (!isNil(maxZoom) && zoom > maxZoom) zoom = maxZoom;
        if (!isInteger(zoom)) zoom = Math.round(zoom);
        zoom = Math.max(0, zoom);
        return zoom;
    };
    _proto2.getMaxAvailableZoom = function getMaxAvailableZoom() {
        var sr = this._spatialRef || this.getSpatialReference();
        return this.options['maxAvailableZoom'] || sr && sr.getMaxZoom();
    };
    _proto2._getTiles = function _getTiles(tileZoom, containerExtent, cascadeLevel, parentRenderer, ignoreMinZoom) {
        var map = this.getMap();
        var z = tileZoom;
        var frustumMatrix = map.projViewMatrix;
        var canSplitTile = map.getResolution(tileZoom) / map.getResolution(tileZoom - 1) === 0.5;
        if (cascadeLevel < 2) {
            if (cascadeLevel === 0 && canSplitTile) z -= 1;
            frustumMatrix = cascadeLevel === 0 ? map.cascadeFrustumMatrix0 : cascadeLevel === 1 ? map.cascadeFrustumMatrix1 : map.projViewMatrix;
        }
        var zoom = z + this.options['zoomOffset'];
        var offset = this._getTileOffset(z), hasOffset = offset[0] || offset[1];
        var emptyGrid = {
            'zoom': z,
            'extent': null,
            'offset': offset,
            'tiles': []
        };
        if (zoom < 0) return emptyGrid;
        if (!map || !this.isVisible() || !map.width || !map.height) return emptyGrid;
        if (!ignoreMinZoom) {
            var minZoom = this.getMinZoom(), maxZoom = this.getMaxZoom();
            if (!isNil(minZoom) && z < minZoom || !isNil(maxZoom) && z > maxZoom) return emptyGrid;
        }
        var tileConfig = this._getTileConfig();
        if (!tileConfig) return emptyGrid;
        var tileOffsets = {
            zoom: offset
        };
        var sr = this._spatialRef || this.getSpatialReference();
        var res = sr.getResolution(z);
        var glScale;
        if (this._hasOwnSR) glScale = map.getGLScale(z);
        else glScale = res / map.getGLRes();
        var repeatWorld = !this._hasOwnSR && this.options['repeatWorld'];
        var extent2d = this._convertToExtent2d(containerExtent);
        var maskExtent = this._getMask2DExtent();
        if (maskExtent) {
            var intersection = maskExtent.intersection(extent2d);
            if (!intersection) return emptyGrid;
            containerExtent = intersection.convertTo(function(c) {
                return map._pointToContainerPoint(c, undefined, 0, TEMP_POINT$3);
            });
        }
        var prjCenter = map._containerPointToPrj(containerExtent.getCenter(), TEMP_POINT0);
        var centerPoint = map._prjToPoint(prjCenter, z, TEMP_POINT1$1);
        var c;
        if (hasOffset) c = this._project(map._pointToPrj(centerPoint._add(offset), z, TEMP_POINT1$1), TEMP_POINT1$1);
        else c = this._project(prjCenter, TEMP_POINT1$1);
        var extentScale = map.getGLScale() / map.getGLScale(z);
        TEMP_POINT2$1.x = extent2d.xmin * extentScale;
        TEMP_POINT2$1.y = extent2d.ymax * extentScale;
        TEMP_POINT3.x = extent2d.xmax * extentScale;
        TEMP_POINT3.y = extent2d.ymin * extentScale;
        var pmin = this._project(map._pointToPrj(TEMP_POINT2$1._add(offset), z, TEMP_POINT2$1), TEMP_POINT2$1);
        var pmax = this._project(map._pointToPrj(TEMP_POINT3._add(offset), z, TEMP_POINT3), TEMP_POINT3);
        var centerTile = tileConfig.getTileIndex(c, res, repeatWorld);
        var ltTile = tileConfig.getTileIndex(pmin, res, repeatWorld);
        var rbTile = tileConfig.getTileIndex(pmax, res, repeatWorld);
        var top = Math.ceil(Math.abs(centerTile.idy - ltTile.idy)), left = Math.ceil(Math.abs(centerTile.idx - ltTile.idx)), bottom = Math.ceil(Math.abs(centerTile.idy - rbTile.idy)), right = Math.ceil(Math.abs(centerTile.idx - rbTile.idx));
        var allCount = (top + bottom + 1) * (left + right + 1);
        var tileSize = this.getTileSize();
        var renderer = this.getRenderer() || parentRenderer, scale = this._getTileConfig().tileSystem.scale;
        var tiles = [], extent = new PointExtent();
        var tilePoint = new Point(0, 0);
        for(var i = -top; i <= bottom; i++){
            var j = -left;
            var leftVisitEnd = -Infinity;
            var rightVisitEnd = false;
            while(j >= leftVisitEnd && j <= right){
                var idx = tileConfig.getNeighorTileIndex(centerTile.idx, centerTile.idy, j, i, res, repeatWorld);
                if (leftVisitEnd === -Infinity) j++;
                else j--;
                var tileId = this._getTileId(idx.idx, idx.idy, z);
                if (idx.out || this._visitedTiles && this._visitedTiles.has(tileId)) continue;
                var tileInfo = renderer && renderer.isTileCachedOrLoading(tileId);
                if (tileInfo) tileInfo = tileInfo.info;
                var p = void 0;
                if (tileInfo) {
                    var { extent2d: _extent2d } = tileInfo;
                    tilePoint.set(_extent2d.xmin, _extent2d.ymax);
                    p = tilePoint;
                } else if (!this._hasOwnSR) p = tileConfig.getTilePointNW(idx.x, idx.y, res);
                else {
                    var pnw = tileConfig.getTilePrjNW(idx.x, idx.y, res);
                    p = map._prjToPoint(this._unproject(pnw, TEMP_POINT3), z);
                }
                var width = void 0, height = void 0;
                if (!this._hasOwnSR) {
                    width = tileSize.width;
                    height = tileSize.height;
                } else {
                    var pp = void 0;
                    if (!this._hasOwnSR) pp = tileConfig.getTilePointSE(idx.x, idx.y, res);
                    else {
                        var pse = tileConfig.getTilePrjSE(idx.x, idx.y, res);
                        pp = map._prjToPoint(this._unproject(pse, TEMP_POINT3), z, TEMP_POINT3);
                    }
                    width = Math.ceil(Math.abs(pp.x - p.x));
                    height = Math.ceil(Math.abs(pp.y - p.y));
                }
                var dx = scale.x * (idx.idx - idx.x) * width, dy = scale.y * (idx.idy - idx.y) * height;
                if (!tileInfo && (dx || dy)) p._add(dx, dy);
                var tileExtent = tileInfo && tileInfo.extent2d || new PointExtent(p.x, p.y - height, p.x + width, p.y);
                if (allCount <= 4 || rightVisitEnd || this._isTileInExtent(frustumMatrix, tileExtent, offset, glScale)) {
                    var tileRes = this._hasOwnSR ? map._getResolution(z) : res;
                    if (this._visitedTiles && cascadeLevel === 0) this._visitedTiles.add(tileId);
                    if (canSplitTile && cascadeLevel === 0) {
                        this._splitTiles(frustumMatrix, tiles, renderer, idx, z + 1, tileRes, tileExtent, dx, dy, tileOffsets);
                        extent._combine(tileExtent);
                    } else {
                        if (!tileInfo) tileInfo = this.createTileNode(idx.x, idx.y, z, idx.idx, idx.idy, tileRes, 0, null, tileExtent, tileId);
                        else {
                            tileInfo.offset[0] = offset[0];
                            tileInfo.offset[1] = offset[1];
                        }
                        tiles.push(tileInfo);
                        extent._combine(tileExtent);
                    }
                    if (leftVisitEnd === -Infinity) {
                        leftVisitEnd = j;
                        j = right;
                    } else if (!rightVisitEnd) rightVisitEnd = true;
                }
            }
        }
        if (tiles.length) {
            var center = map._containerPointToPoint(containerExtent.getCenter(), z, TEMP_POINT$3)._add(offset);
            var point0 = new Point(0, 0);
            var point1 = new Point(0, 0);
            tiles.sort(function(a, b) {
                point0.set((a.extent2d.xmin + a.extent2d.xmax) / 2, (a.extent2d.ymin + a.extent2d.ymax) / 2);
                point1.set((b.extent2d.xmin + b.extent2d.xmax) / 2, (b.extent2d.ymin + b.extent2d.ymax) / 2);
                return point0.distanceTo(center) - point1.distanceTo(center);
            });
        }
        return {
            'offset': offset,
            'zoom': tileZoom,
            'extent': extent,
            'tiles': tiles
        };
    };
    _proto2._convertToExtent2d = function _convertToExtent2d(containerExtent) {
        var _this2 = this;
        var map = this.getMap();
        return containerExtent.convertTo(function(c) {
            var result;
            if (c.y > 0 && c.y < map.height) {
                var key = (c.x === 0 ? 0 : 1) + c.y;
                if (!_this2._coordCache[key]) _this2._coordCache[key] = map._containerPointToPoint(c);
                result = _this2._coordCache[key];
            }
            result = map._containerPointToPoint(c, undefined, TEMP_POINT$3);
            return result;
        });
    };
    _proto2._splitTiles = function _splitTiles(frustumMatrix, tiles, renderer, tileIdx, z, res, tileExtent, dx, dy, tileOffsets) {
        var yOrder = this._getTileConfig().tileSystem.scale.y;
        var glScale = this.getMap().getGLScale(z);
        var corner = TEMP_POINT4.set(tileExtent.xmin * 2, yOrder < 0 ? tileExtent.ymax * 2 : tileExtent.ymin * 2);
        var w = tileExtent.getWidth();
        var h = tileExtent.getHeight();
        var idx = tileIdx.idx * 2;
        var idy = tileIdx.idy * 2;
        var x = tileIdx.x * 2;
        var y = tileIdx.y * 2;
        var tile = this._checkAndAddTile(frustumMatrix, renderer, idx, idy, x, y, z, res, 0, 0, w, h, corner, glScale, tileOffsets);
        if (tile) tiles.push(tile);
        tile = this._checkAndAddTile(frustumMatrix, renderer, idx, idy, x, y, z, res, 0, 1, w, h, corner, glScale, tileOffsets);
        if (tile) tiles.push(tile);
        tile = this._checkAndAddTile(frustumMatrix, renderer, idx, idy, x, y, z, res, 1, 0, w, h, corner, glScale, tileOffsets);
        if (tile) tiles.push(tile);
        tile = this._checkAndAddTile(frustumMatrix, renderer, idx, idy, x, y, z, res, 1, 1, w, h, corner, glScale, tileOffsets);
        if (tile) tiles.push(tile);
    };
    _proto2._checkAndAddTile = function _checkAndAddTile(frustumMatrix, renderer, idx, idy, x, y, z, res, i, j, w, h, corner, glScale, tileOffsets) {
        var tileId = this._getTileId(idx + i, idy + j, z);
        if (this._visitedTiles && this._visitedTiles.has(tileId)) return null;
        var offset = tileOffsets[z];
        if (!offset) offset = tileOffsets[z] = this._getTileOffset(z);
        var yOrder = this._getTileConfig().tileSystem.scale.y;
        var childExtent = new PointExtent(corner.x + i * w, corner.y + yOrder * j * h, corner.x + (i + 1) * w, corner.y + yOrder * (j + 1) * h);
        if (!this._isSplittedTileInExtent(frustumMatrix, childExtent, offset, glScale)) return null;
        var childRes = res / 2;
        var tileCache = renderer && renderer.isTileCachedOrLoading(tileId);
        var tileInfo;
        if (!tileCache) tileInfo = this.createTileNode(x + i, y + j, z, idx + i, idx + y, childRes, 0, null, childExtent, tileId);
        else tileInfo = tileCache.info;
        return tileInfo;
    };
    _proto2._getTileOffset = function _getTileOffset(...params) {
        var offset = this.options['offset'];
        if (!offset) return [
            0,
            0
        ];
        if (isFunction(offset)) offset = offset.call(this, ...params);
        if (isNumber(offset)) offset = [
            offset,
            offset
        ];
        return offset || [
            0,
            0
        ];
    };
    _proto2.getTileId = function getTileId(x, y, zoom, id) {
        return this._getTileId(x, y, zoom, id);
    };
    _proto2._getTileId = function _getTileId(x, y, zoom, id) {
        return (id || this.getId()) + "_" + x + "_" + y + "_" + zoom;
    };
    _proto2._project = function _project(pcoord, out) {
        if (this._hasOwnSR) {
            var map = this.getMap();
            var mapProjection = map.getProjection();
            var sr = this._spatialRef || this.getSpatialReference();
            var projection = sr.getProjection();
            return projection.project(mapProjection.unproject(pcoord, out), out);
        } else return pcoord;
    };
    _proto2._unproject = function _unproject(pcoord, out) {
        if (this._hasOwnSR) {
            var map = this.getMap();
            var sr = this._spatialRef || this.getSpatialReference();
            var mapProjection = map.getProjection();
            var projection = sr.getProjection();
            return mapProjection.project(projection.unproject(pcoord, out), out);
        } else return pcoord;
    };
    _proto2._initTileConfig = function _initTileConfig() {
        var map = this.getMap(), tileSize = this.getTileSize();
        var sr = this.getSpatialReference();
        var projection = sr.getProjection(), fullExtent = sr.getFullExtent();
        this._defaultTileConfig = new TileConfig(map, TileSystem.getDefault(projection), fullExtent, tileSize);
        if (this.options.hasOwnProperty('tileSystem')) this._tileConfig = new TileConfig(map, this.options['tileSystem'], fullExtent, tileSize);
        delete this._rootNodes;
        delete this._tileFullExtent;
        delete this._disablePyramid;
    };
    _proto2._getTileConfig = function _getTileConfig() {
        if (!this._defaultTileConfig) this._initTileConfig();
        return this._tileConfig || this._defaultTileConfig;
    };
    _proto2._bindMap = function _bindMap(args) {
        this._onSpatialReferenceChange();
        return _Layer.prototype._bindMap.apply(this, arguments);
    };
    _proto2._isTileInExtent = function _isTileInExtent(frustumMatrix, tileExtent, offset, glScale) {
        var map = this.getMap();
        var matrix;
        if (frustumMatrix !== map.projViewMatrix) {
            var tileCenter = tileExtent.getCenter(TEMP_POINT6)._sub(offset[0], offset[1])._multi(glScale);
            set(ARR3, tileCenter.x, tileCenter.y, 0);
            var ndc = transformMat4(ARR3, ARR3, map.projViewMatrix);
            matrix = ndc[1] < 0 ? map.projViewMatrix : frustumMatrix;
        } else matrix = map.projViewMatrix;
        TILE_BOX[0][0] = (tileExtent.xmin - offset[0]) * glScale;
        TILE_BOX[0][1] = (tileExtent.ymin - offset[1]) * glScale;
        TILE_BOX[1][0] = (tileExtent.xmax - offset[0]) * glScale;
        TILE_BOX[1][1] = (tileExtent.ymax - offset[1]) * glScale;
        return intersectsBox(matrix, TILE_BOX);
    };
    _proto2._isSplittedTileInExtent = function _isSplittedTileInExtent(frustumMatrix, tileExtent, offset, glScale) {
        var map = this.getMap();
        TILE_BOX[0][0] = (tileExtent.xmin - offset[0]) * glScale;
        TILE_BOX[0][1] = (tileExtent.ymin - offset[1]) * glScale;
        TILE_BOX[1][0] = (tileExtent.xmax - offset[0]) * glScale;
        TILE_BOX[1][1] = (tileExtent.ymax - offset[1]) * glScale;
        return intersectsBox(map.projViewMatrix, TILE_BOX);
    };
    _proto2.getEvents = function getEvents() {
        return {
            'spatialreferencechange': this._onSpatialReferenceChange
        };
    };
    _proto2._onSpatialReferenceChange = function _onSpatialReferenceChange() {
        delete this._tileConfig;
        delete this._defaultTileConfig;
        delete this._sr;
        delete this._srMinZoom;
        delete this._hasOwnSR;
        delete this._rootNodes;
        if (this.tileInfoCache) this.tileInfoCache.reset();
        var renderer = this.getRenderer();
        if (renderer) renderer.clear();
    };
    _proto2.getPolygonOffsetCount = function getPolygonOffsetCount() {
        return 2;
    };
    _proto2.getPolygonOffset = function getPolygonOffset() {
        return this._polygonOffset || 0;
    };
    _proto2.setPolygonOffset = function setPolygonOffset(offset) {
        this._polygonOffset = offset;
        return this;
    };
    _proto2.getRenderer = function getRenderer() {
        return _Layer.prototype.getRenderer.call(this);
    };
    _proto2._getTileBBox = function _getTileBBox(tile) {
        var map = this.getMap();
        if (!map) return;
        var extent2d = tile.extent2d;
        var offset = tile.offset || [
            0,
            0
        ];
        if (!extent2d) return;
        var res = tile.res;
        var [offsetX, offsetY] = offset;
        var { xmin: xmin, ymin: ymin, xmax: xmax, ymax: ymax } = extent2d;
        xmin -= offsetX;
        xmax -= offsetX;
        ymin -= offsetY;
        ymax -= offsetY;
        var pmin = new Point(xmin, ymin), pmax = new Point(xmax, ymax);
        var min = map.pointAtResToCoordinate(pmin, res, TEMP_POINT0), max = map.pointAtResToCoordinate(pmax, res, TEMP_POINT1$1);
        return [
            min.x,
            min.y,
            max.x,
            max.y
        ];
    };
    _proto2._tileInMask = function _tileInMask(tile) {
        var mask = this.getMask();
        if (!mask) return true;
        var maskType = mask.type;
        if (!maskType || maskType.indexOf('Polygon') === -1) return true;
        var maskGeoJSON = this._maskGeoJSON;
        if (!maskGeoJSON || !maskGeoJSON.geometry) return true;
        var { coordinates: coordinates, type: type } = maskGeoJSON.geometry;
        if (!coordinates || !type) return true;
        if (type.indexOf('Polygon') === -1) return true;
        if (!maskGeoJSON.bbox) {
            var extent = mask.getExtent();
            if (!extent) return true;
            maskGeoJSON.bbox = [
                extent.xmin,
                extent.ymin,
                extent.xmax,
                extent.ymax
            ];
        }
        var tileBBOX = this._getTileBBox(tile);
        if (!tileBBOX) return true;
        return bboxInMask(tileBBOX, this._maskGeoJSON);
    };
    return TileLayer;
}(Layer);
TileLayer.registerJSONType('TileLayer');
TileLayer.mergeOptions(options$7);
function distanceToRect(min, max, xyz) {
    var dx = Math.max(min[0] - xyz[0], 0, xyz[0] - max[0]);
    var dy = Math.max(min[1] - xyz[1], 0, xyz[1] - max[1]);
    var dz = Math.max(min[2] - xyz[2], 0, xyz[2] - max[2]);
    return Math.sqrt(dx * dx + dy * dy + dz * dz);
}
function sortingTiles(t0, t1) {
    return t0.z - t1.z;
}
var options$6 = {
    urlTemplate: '',
    'maxCacheSize': 1024
};
var DEFAULT_TILESIZE = new Size(256, 256);
var EVENTS$1 = 'show hide remove setzindex forcereloadstart';
function checkLayers(tileLayers) {
    if (!Array.isArray(tileLayers)) tileLayers = [
        tileLayers
    ];
    return tileLayers;
}
var GroupTileLayer = function(_TileLayer) {
    function GroupTileLayer(id, layers, options) {
        var _this;
        _this = _TileLayer.call(this, id, options) || this;
        _this.layers = layers || [];
        _this._checkChildren();
        _this.layerMap = {};
        _this._groupChildren = [];
        return _this;
    }
    _inheritsLoose(GroupTileLayer, _TileLayer);
    GroupTileLayer.fromJSON = function fromJSON(layerJSON) {
        if (!layerJSON || layerJSON['type'] !== 'GroupTileLayer') return null;
        var layers = layerJSON['layers'].map(function(json) {
            return Layer.fromJSON(json);
        });
        return new GroupTileLayer(layerJSON['id'], layers, layerJSON['options']);
    };
    var _proto = GroupTileLayer.prototype;
    _proto.getLayers = function getLayers() {
        return this.layers;
    };
    _proto.addLayer = function addLayer(tileLayers = []) {
        var _this2 = this;
        tileLayers = checkLayers(tileLayers);
        var len = this.layers.length;
        tileLayers.forEach(function(tileLayer) {
            if (!(tileLayer instanceof TileLayer)) return;
            if (_this2.layers.indexOf(tileLayer) === -1 && !_this2.layerMap[tileLayer.getId()]) _this2.layers.push(tileLayer);
        });
        if (len !== this.layers.length) {
            this._sortLayers();
            this._refresh();
            this._renderLayers();
        }
        return this;
    };
    _proto.removeLayer = function removeLayer(tileLayers = []) {
        var _this3 = this;
        tileLayers = checkLayers(tileLayers);
        var len = this.layers.length;
        tileLayers.forEach(function(tileLayer) {
            if (!(tileLayer instanceof TileLayer)) tileLayer = _this3.layerMap[tileLayer];
            if (!(tileLayer instanceof TileLayer)) return;
            var index = _this3.layers.indexOf(tileLayer);
            if (index >= 0) {
                _this3.layers.splice(index, 1);
                tileLayer._doRemove();
                tileLayer.off(EVENTS$1, _this3._onLayerShowHide, _this3);
            }
        });
        if (len !== this.layers.length) {
            this._refresh();
            this._renderLayers();
        }
        return this;
    };
    _proto.clearLayers = function clearLayers() {
        var _this4 = this;
        this.layers.forEach(function(layer) {
            layer._doRemove();
            layer.off(EVENTS$1, _this4._onLayerShowHide, _this4);
        });
        this.layers = [];
        this._refresh();
        this._renderLayers();
        return this;
    };
    _proto.toJSON = function toJSON() {
        var profile = {
            'type': this.getJSONType(),
            'id': this.getId(),
            'layers': this.layers.map(function(layer) {
                return layer.toJSON();
            }),
            'options': this.config()
        };
        return profile;
    };
    _proto.getTileSize = function getTileSize(id) {
        var layer = this.getLayer(id);
        if (!layer) return DEFAULT_TILESIZE;
        return layer.getTileSize();
    };
    _proto.getTiles = function getTiles(z, parentLayer) {
        var layers = this.layers;
        var tiles = [];
        var count = 0;
        for(var i = 0, l = layers.length; i < l; i++){
            var layer = layers[i];
            if (!layer || !layer.options['visible'] || !layer.isVisible() || !layer.getMap()) continue;
            var childGrid = layer.getTiles(z, parentLayer || this);
            if (!childGrid || childGrid.count === 0) continue;
            count += childGrid.count;
            pushIn(tiles, childGrid.tileGrids);
        }
        return {
            count: count,
            tileGrids: tiles
        };
    };
    _proto.onAdd = function onAdd() {
        this._sortLayers();
        this._refresh();
        _TileLayer.prototype.onAdd.call(this);
    };
    _proto.onRemove = function onRemove() {
        var _this5 = this;
        this.layers.forEach(function(layer) {
            layer._doRemove();
            layer.off(EVENTS$1, _this5._onLayerShowHide, _this5);
        });
        this.layerMap = {};
        this._groupChildren = [];
        _TileLayer.prototype.onRemove.call(this);
    };
    _proto.getLayer = function getLayer(id) {
        return this.getChildLayer(id);
    };
    _proto.getChildLayer = function getChildLayer(id) {
        var layer = this.layerMap[id];
        if (layer) return layer;
        for(var i = 0; i < this._groupChildren.length; i++){
            var child = this._groupChildren[i].getChildLayer(id);
            if (child) return child;
        }
        return null;
    };
    _proto._removeChildTileCache = function _removeChildTileCache(layer) {
        if (!layer) return this;
        var renderer = this.getRenderer();
        if (!renderer) return this;
        var cache;
        var id = layer.getId();
        var validateCache = function validateCache() {
            return cache && cache.info && cache.info.layer === id;
        };
        if (renderer.tileCache) {
            var keys = renderer.tileCache.keys();
            keys.forEach(function(key) {
                cache = renderer.tileCache.get(key);
                if (validateCache()) renderer.tileCache.remove(key);
            });
        }
        var tilesInView = renderer.tilesInView || {};
        for(var key in tilesInView){
            cache = tilesInView[key];
            if (validateCache()) delete tilesInView[key];
        }
        var tilesLoading = renderer.tilesLoading || {};
        for(var _key in tilesLoading){
            cache = tilesLoading[_key];
            if (validateCache()) renderer.abortTileLoading(cache.image, cache.info);
        }
        return this;
    };
    _proto._onLayerShowHide = function _onLayerShowHide(e) {
        var { type: type, target: target } = e || {};
        if (type === 'remove' && target) {
            this.layers.splice(this.layers.indexOf(target), 1);
            target._doRemove();
            target.off(EVENTS$1, this._onLayerShowHide, this);
            this._refresh();
        } else if (type === 'setzindex') this._sortLayers();
        else if (type === 'forcereloadstart') this._removeChildTileCache(target);
        this._renderLayers();
    };
    _proto._renderLayers = function _renderLayers() {
        var renderer = this.getRenderer();
        if (renderer) renderer.setToRedraw();
        return this;
    };
    _proto._refresh = function _refresh() {
        var _this6 = this;
        var map = this.getMap();
        this._groupChildren = [];
        this.layerMap = {};
        this.layers.forEach(function(layer) {
            _this6.layerMap[layer.getId()] = layer;
            if (layer.getChildLayer) _this6._groupChildren.push(layer);
            if (!layer.getMap()) layer._bindMap(map);
            layer.off(EVENTS$1, _this6._onLayerShowHide, _this6);
            layer.on(EVENTS$1, _this6._onLayerShowHide, _this6);
        });
        return this;
    };
    _proto.isVisible = function isVisible() {
        if (!_TileLayer.prototype.isVisible.call(this)) return false;
        var children = this.layers;
        for(var i = 0, l = children.length; i < l; i++){
            if (children[i].isVisible()) return true;
        }
        return false;
    };
    _proto._checkChildren = function _checkChildren() {
        var _this7 = this;
        var ids = {};
        this.layers.forEach(function(layer) {
            var layerId = layer.getId();
            if (ids[layerId]) throw new Error("Duplicate child layer id (" + layerId + ") in the GroupTileLayer (" + _this7.getId() + ")");
            else ids[layerId] = 1;
        });
    };
    _proto._sortLayers = function _sortLayers() {
        this.layers.sort(function(a, b) {
            return a.options.zIndex - b.options.zIndex;
        });
    };
    return GroupTileLayer;
}(TileLayer);
GroupTileLayer.registerJSONType('GroupTileLayer');
GroupTileLayer.mergeOptions(options$6);
var options$5 = {
    urlTemplate: '',
    crs: null,
    uppercase: false,
    detectRetina: false
};
var defaultWmsParams = {
    service: 'WMS',
    request: 'GetMap',
    layers: '',
    styles: '',
    format: 'image/jpeg',
    transparent: false,
    version: '1.1.1'
};
var wmsExcludeParams;
var WMSTileLayer = function(_TileLayer) {
    function WMSTileLayer(id, options) {
        var _this;
        _this = _TileLayer.call(this, id) || this;
        if (!wmsExcludeParams) wmsExcludeParams = extend$2({}, _this.options);
        _this.wmsParams = extend$2({}, defaultWmsParams);
        _this._setOptions(options);
        _this.setZIndex(options.zIndex);
        if (!Browser$1.proxy) _this._optionsHook(options);
        return _this;
    }
    _inheritsLoose(WMSTileLayer, _TileLayer);
    var _proto = WMSTileLayer.prototype;
    _proto._optionsHook = function _optionsHook(options = {}) {
        for(var p in options){
            if (p === 'tileSize') this._tileSize = null;
            if (!(p in wmsExcludeParams)) this.wmsParams[p] = options[p];
        }
        var tileSize = this.getTileSize();
        this.wmsParams.width = tileSize.width;
        this.wmsParams.height = tileSize.height;
        this._wmsVersion = parseFloat(this.wmsParams.version);
        return this;
    };
    _proto.onAdd = function onAdd() {
        var dpr = this.getMap().getDevicePixelRatio();
        var r = options$5.detectRetina ? dpr : 1;
        this.wmsParams.width *= r;
        this.wmsParams.height *= r;
        var crs = this.options.crs || this.getMap().getProjection().code;
        var projectionKey = this._wmsVersion >= 1.3 ? 'crs' : 'srs';
        this.wmsParams[projectionKey] = crs;
        _TileLayer.prototype.onAdd.call(this);
    };
    _proto.getTileUrl = function getTileUrl(x, y, z) {
        var res = this.getSpatialReference().getResolution(z), tileConfig = this._getTileConfig(), tileExtent = tileConfig.getTilePrjExtent(x, y, res);
        var max = tileExtent.getMax(), min = tileExtent.getMin();
        var bbox = (this._wmsVersion >= 1.3 && (this.wmsParams.crs === 'EPSG:4326' || this.wmsParams.crs === 'EPSG:4490') ? [
            min.y,
            min.x,
            max.y,
            max.x
        ] : [
            min.x,
            min.y,
            max.x,
            max.y
        ]).join(',');
        var url = _TileLayer.prototype.getTileUrl.call(this, x, y, z);
        return url + getParamString(this.wmsParams, url, this.options.uppercase) + (this.options.uppercase ? '&BBOX=' : '&bbox=') + bbox;
    };
    _proto.toJSON = function toJSON() {
        return {
            'type': 'WMSTileLayer',
            'id': this.getId(),
            'options': this.config()
        };
    };
    WMSTileLayer.fromJSON = function fromJSON(layerJSON) {
        if (!layerJSON || layerJSON['type'] !== 'WMSTileLayer') return null;
        return new WMSTileLayer(layerJSON['id'], layerJSON['options']);
    };
    return WMSTileLayer;
}(TileLayer);
WMSTileLayer.registerJSONType('WMSTileLayer');
WMSTileLayer.mergeOptions(options$5);
function getParamString(obj, existingUrl, uppercase) {
    var params = [];
    for(var i in obj)params.push(encodeURIComponent(uppercase ? i.toUpperCase() : i) + '=' + encodeURIComponent(obj[i]));
    return (!existingUrl || existingUrl.indexOf('?') === -1 ? '?' : '&') + params.join('&');
}
var CanvasTileLayer = function(_TileLayer) {
    function CanvasTileLayer(id, options) {
        var _this;
        _this = _TileLayer.call(this, id, options) || this;
        if (!_this.options.hasOwnProperty('forceRenderOnMoving')) _this.options['forceRenderOnMoving'] = false;
        return _this;
    }
    _inheritsLoose(CanvasTileLayer, _TileLayer);
    var _proto = CanvasTileLayer.prototype;
    _proto.drawTile = function drawTile() {};
    _proto.toJSON = function toJSON() {
        return {
            'type': 'CanvasTileLayer',
            'id': this.getId(),
            'options': this.config()
        };
    };
    CanvasTileLayer.fromJSON = function fromJSON(layerJSON) {
        if (!layerJSON || layerJSON['type'] !== 'CanvasTileLayer') return null;
        return new CanvasTileLayer(layerJSON['id'], layerJSON['options']);
    };
    return CanvasTileLayer;
}(TileLayer);
CanvasTileLayer.registerJSONType('CanvasTileLayer');
function createGLContext(canvas, options) {
    var attributes = {
        'alpha': true,
        'stencil': true,
        'preserveDrawingBuffer': true,
        'antialias': false
    };
    var names = [
        'webgl',
        'experimental-webgl'
    ];
    var context = null;
    for(var i = 0; i < names.length; ++i){
        try {
            context = canvas.getContext(names[i], options || attributes);
        } catch (e) {}
        if (context) break;
    }
    return context;
}
function compileShader(gl, type, source) {
    var shader = gl.createShader(type);
    gl.shaderSource(shader, source);
    gl.compileShader(shader);
    var compiled = gl.getShaderParameter(shader, gl.COMPILE_STATUS);
    if (!compiled) {
        var error = gl.getShaderInfoLog(shader);
        gl.deleteShader(shader);
        throw new Error('Failed to compile shader: ' + error);
    }
    return shader;
}
function createProgram(gl, vert, frag) {
    var vertexShader = compileShader(gl, gl.VERTEX_SHADER, vert);
    var fragmentShader = compileShader(gl, gl.FRAGMENT_SHADER, frag);
    if (!vertexShader || !fragmentShader) return null;
    var program = gl.createProgram();
    if (!program) return null;
    gl.attachShader(program, vertexShader);
    gl.attachShader(program, fragmentShader);
    gl.linkProgram(program);
    return {
        program: program,
        vertexShader: vertexShader,
        fragmentShader: fragmentShader
    };
}
function enableVertexAttrib(gl, program, attributes) {
    if (Array.isArray(attributes[0])) {
        var FSIZE = Float32Array.BYTES_PER_ELEMENT;
        var STRIDE = 0;
        for(var i = 0; i < attributes.length; i++)STRIDE += attributes[i][1] || 0;
        var offset = 0;
        for(var _i = 0; _i < attributes.length; _i++){
            var attr = gl.getAttribLocation(program, attributes[_i][0]);
            if (attr < 0) throw new Error('Failed to get the storage location of ' + attributes[_i][0]);
            gl.vertexAttribPointer(attr, attributes[_i][1], gl[attributes[_i][2] || 'FLOAT'], false, FSIZE * STRIDE, FSIZE * offset);
            offset += attributes[_i][1] || 0;
            gl.enableVertexAttribArray(attr);
        }
    } else {
        var _attr = gl.getAttribLocation(program, attributes[0]);
        gl.vertexAttribPointer(_attr, attributes[1], gl[attributes[2] || 'FLOAT'], false, 0, 0);
        gl.enableVertexAttribArray(_attr);
    }
}
var DEPTH_FUNC_CONSTANTS = {
    'never': 0x0200,
    '<': 0x0201,
    '=': 0x0202,
    '<=': 0x0203,
    '>': 0x0204,
    '!=': 0x0205,
    '>=': 0x0206,
    'always': 0x0207
};
function getDepthFunc(v) {
    return DEPTH_FUNC_CONSTANTS[v];
}
var DEFAULT_BASE_COLOR = [
    1,
    1,
    1,
    1
];
var TEMP_FLOAT32ARRAY = new Float32Array(8);
var TEMP_INT16ARRAY = new Int16Array(8);
var shaders = {
    'vertexShader': "\n        attribute vec2 a_position;\n\n        attribute vec2 a_texCoord;\n\n        uniform mat4 u_matrix;\n\n        varying vec2 v_texCoord;\n\n        void main() {\n            gl_Position = u_matrix * vec4(a_position, 0., 1.);\n\n            v_texCoord = a_texCoord;\n        }\n    ",
    'fragmentShader': "\n        precision mediump float;\n\n        uniform sampler2D u_image;\n\n        uniform float u_opacity;\n        uniform float u_debug_line;\n        uniform vec4 u_base_color;\n        uniform float u_alpha_test;\n        varying vec2 v_texCoord;\n\n        void main() {\n            if (u_debug_line == 1.) {\n                gl_FragColor = vec4(0., 1., 0., 1.);\n            } else {\n                gl_FragColor = texture2D(u_image, v_texCoord) * u_opacity;\n            }\n            gl_FragColor *= u_base_color;\n            if (gl_FragColor.a < u_alpha_test) {\n                discard;\n            }\n        }\n    "
};
var v2 = [
    '',
    0
], v3 = [
    0,
    0,
    0
], arr16 = new Array(16);
var DEBUG_POINT = new Point(20, 20);
var ImageGLRenderable = function ImageGLRenderable(Base) {
    var renderable = function(_Base) {
        function renderable() {
            var _this;
            _this = _Base.apply(this, arguments) || this;
            _this._layerAlt = 0;
            _this._layerAltitude = 0;
            return _this;
        }
        _inheritsLoose(renderable, _Base);
        var _proto = renderable.prototype;
        _proto.drawGLImage = function drawGLImage(image, x, y, w, h, scale, opacity, resized, debugInfo, baseColor) {
            if (this.gl.program !== this.program) this.useProgram(this.program);
            var gl = this.gl;
            this.loadTexture(image, resized);
            var inGroup = this.canvas.gl && this.canvas.gl.wrap;
            if (inGroup) {
                var layerOpacity = this.layer && this.layer.options['opacity'];
                if (isNil(layerOpacity)) layerOpacity = 1;
                opacity *= layerOpacity;
            }
            v3[0] = x || 0;
            v3[1] = y || 0;
            v3[2] = 0;
            var layer = this.layer;
            var map = this.getMap();
            if (layer) {
                var { altitude: altitude } = layer.options;
                var altIsNumber = isNumber(altitude);
                if (!altIsNumber) this._layerAlt = 0;
                if (this._layerAltitude !== altitude && altIsNumber) {
                    var z = map.altitudeToPoint(altitude, map.getGLRes());
                    this._layerAltitude = altitude;
                    this._layerAlt = z;
                }
            }
            v3[2] = this._layerAlt || 0;
            var uMatrix = identity$1(arr16);
            translate(uMatrix, uMatrix, v3);
            scale$1(uMatrix, uMatrix, [
                scale,
                scale,
                1
            ]);
            multiply(uMatrix, map.projViewMatrix, uMatrix);
            gl.uniformMatrix4fv(this.program['u_matrix'], false, uMatrix);
            gl.uniform1f(this.program['u_opacity'], opacity);
            gl.uniform1f(this.program['u_debug_line'], 0);
            gl.uniform4fv(this.program['u_base_color'], baseColor || DEFAULT_BASE_COLOR);
            gl.uniform1f(this.program['u_alpha_test'], this.layer.options['alphaTest'] || 0);
            var { glBuffer: glBuffer } = image;
            if (glBuffer && (glBuffer.width !== w || glBuffer.height !== h)) {
                this.saveImageBuffer(glBuffer);
                delete image.glBuffer;
            }
            if (!image.glBuffer) image.glBuffer = this.bufferTileData(0, 0, w, h);
            else gl.bindBuffer(gl.ARRAY_BUFFER, glBuffer);
            v2[0] = 'a_position';
            v2[1] = 2;
            v2[2] = image.glBuffer.type;
            this.enableVertexAttrib(v2);
            gl.bindBuffer(gl.ARRAY_BUFFER, this.texBuffer);
            v2[0] = 'a_texCoord';
            v2[1] = 2;
            v2[2] = 'UNSIGNED_BYTE';
            this.enableVertexAttrib(v2);
            gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
            if (debugInfo) this.drawDebug(uMatrix, 0, 0, w, h, debugInfo);
        };
        _proto.drawDebug = function drawDebug(uMatrix, x, y, w, h, debugInfo) {
            var gl = this.gl;
            gl.disable(gl.DEPTH_TEST);
            gl.bindBuffer(gl.ARRAY_BUFFER, this._debugBuffer);
            this.enableVertexAttrib([
                'a_position',
                2,
                'FLOAT'
            ]);
            gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([
                x,
                y,
                x + w,
                y,
                x + w,
                y - h,
                x,
                y - h,
                x,
                y
            ]), gl.DYNAMIC_DRAW);
            gl.uniformMatrix4fv(this.program['u_matrix'], false, uMatrix);
            gl.uniform1f(this.program['u_opacity'], 1);
            gl.uniform1f(this.program['u_debug_line'], 1);
            gl.uniform4fv(this.program['u_base_color'], DEFAULT_BASE_COLOR);
            gl.uniform1f(this.program['u_alpha_test'], this.layer.options['alphaTest'] || 0);
            gl.drawArrays(gl.LINE_STRIP, 0, 5);
            var canvas = this._debugInfoCanvas;
            if (!canvas) {
                var dpr = this.mapDPR || this.getMap().getDevicePixelRatio() > 1 ? 2 : 1;
                canvas = this._debugInfoCanvas = document.createElement('canvas');
                canvas.width = 256 * dpr;
                canvas.height = 32 * dpr;
                var _ctx = canvas.getContext('2d');
                _ctx.font = '20px monospace';
                _ctx.scale(dpr, dpr);
            }
            var ctx = canvas.getContext('2d');
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            var color = this.layer.options['debugOutline'];
            Canvas.fillText(ctx, debugInfo, DEBUG_POINT, color);
            this.loadTexture(canvas);
            gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, canvas);
            w = 256;
            var x1 = x;
            var x2 = x + w;
            var y1 = y - h + 32;
            var y2 = y - h;
            gl.bufferData(gl.ARRAY_BUFFER, this.set8(x1, y1, x1, y2, x2, y1, x2, y2), gl.DYNAMIC_DRAW);
            gl.uniform1f(this.program['u_debug_line'], 0);
            gl.bindBuffer(gl.ARRAY_BUFFER, this.texBuffer);
            this.enableVertexAttrib([
                'a_texCoord',
                2,
                'UNSIGNED_BYTE'
            ]);
            gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
            gl.enable(gl.DEPTH_TEST);
        };
        _proto.bufferTileData = function bufferTileData(x, y, w, h, buffer) {
            var x1 = x;
            var x2 = x + w;
            var y1 = y;
            var y2 = y - h;
            var data;
            if (isInteger(x1) && isInteger(x2) && isInteger(y1) && isInteger(y2)) data = this.set8Int(x1, y1, x1, y2, x2, y1, x2, y2);
            else data = this.set8(x1, y1, x1, y2, x2, y1, x2, y2);
            var glBuffer = this.loadImageBuffer(data, buffer);
            glBuffer.width = w;
            glBuffer.height = h;
            glBuffer.type = data instanceof Int16Array ? 'SHORT' : 'FLOAT';
            return glBuffer;
        };
        _proto.createCanvas2 = function createCanvas2() {
            this.canvas2 = Canvas.createCanvas(this.canvas.width, this.canvas.height);
        };
        _proto.createGLContext = function createGLContext$1() {
            if (this.canvas.gl && this.canvas.gl.wrap) this.gl = this.canvas.gl.wrap();
            else this.gl = createGLContext(this.canvas2 || this.canvas, this.layer.options['glOptions']);
            var gl = this.gl;
            gl.clearColor(0.0, 0.0, 0.0, 0.0);
            gl.enable(gl.DEPTH_TEST);
            gl.enable(gl.STENCIL_TEST);
            gl.enable(gl.BLEND);
            gl.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
            this.program = this.createProgram(shaders['vertexShader'], this.layer.options['fragmentShader'] || shaders['fragmentShader']);
            this._debugBuffer = this.createBuffer();
            this.useProgram(this.program);
            this.texBuffer = this.createBuffer();
            gl.bindBuffer(gl.ARRAY_BUFFER, this.texBuffer);
            this.enableVertexAttrib([
                'a_texCoord',
                2,
                'UNSIGNED_BYTE'
            ]);
            gl.bufferData(gl.ARRAY_BUFFER, new Uint8Array([
                0.0,
                0.0,
                0.0,
                1.0,
                1.0,
                0.0,
                1.0,
                1.0
            ]), gl.STATIC_DRAW);
            this.enableSampler('u_image');
            gl.activeTexture(gl['TEXTURE0']);
            gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, true);
        };
        _proto.resizeGLCanvas = function resizeGLCanvas() {
            if (this.gl) this.gl.viewport(0, 0, this.canvas.width, this.canvas.height);
            if (!this.canvas2) return;
            if (this.canvas2.width !== this.canvas.width || this.canvas2.height !== this.canvas.height) {
                this.canvas2.width = this.canvas.width;
                this.canvas2.height = this.canvas.height;
            }
        };
        _proto.clearGLCanvas = function clearGLCanvas() {
            if (this.gl) {
                this.gl.clearStencil(0xFF);
                this.gl.clear(this.gl.COLOR_BUFFER_BIT | this.gl.STENCIL_BUFFER_BIT);
            }
            if (!this.gl.wrap) this.gl.clear(this.gl.DEPTH_BUFFER_BIT);
        };
        _proto.disposeImage = function disposeImage(image) {
            if (!image) return;
            if (image.texture) this.saveTexture(image.texture);
            if (image.glBuffer) this.saveImageBuffer(image.glBuffer);
            delete image.texture;
            delete image.glBuffer;
        };
        _proto._createTexture = function _createTexture(image) {
            var gl = this.gl;
            var texture = this.getTexture() || gl.createTexture();
            gl.bindTexture(gl.TEXTURE_2D, texture);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
            var genMipmap = this.layer.options['mipmapTexture'];
            if (genMipmap && (!isPowerOfTwo(image.width) || !isPowerOfTwo(image.height))) image = resize(image);
            gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, image);
            if (genMipmap) gl.generateMipmap(gl.TEXTURE_2D);
            return texture;
        };
        _proto.getTexture = function getTexture() {
            if (!this._textures) this._textures = [];
            var textures = this._textures;
            return textures && textures.length > 0 ? textures.pop() : null;
        };
        _proto.saveTexture = function saveTexture(texture) {
            this._textures.push(texture);
        };
        _proto.loadTexture = function loadTexture(image, resized = false) {
            var gl = this.gl;
            var texture = image.texture;
            if (!texture) {
                texture = this._createTexture(image);
                image.texture = texture;
            }
            gl.bindTexture(gl.TEXTURE_2D, texture);
            var genMipmap = this.layer.options['mipmapTexture'];
            if (genMipmap) {
                var map = this.getMap();
                var dpr = this.mapDPR || map.getDevicePixelRatio();
                if (map.isMoving() && map.getRenderer().isViewChanged()) gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR_MIPMAP_LINEAR);
                else gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
                if (dpr !== 1 || resized) gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
                else gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
            }
            return texture;
        };
        _proto.getImageBuffer = function getImageBuffer() {
            if (!this._imageBuffers) this._imageBuffers = [];
            var imageBuffers = this._imageBuffers;
            return imageBuffers && imageBuffers.length > 0 ? imageBuffers.pop() : null;
        };
        _proto.saveImageBuffer = function saveImageBuffer(buffer) {
            if (!this._imageBuffers) this._imageBuffers = [];
            this._imageBuffers.push(buffer);
        };
        _proto.loadImageBuffer = function loadImageBuffer(data, glBuffer) {
            var gl = this.gl;
            var buffer = glBuffer || this.createImageBuffer();
            gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
            gl.bufferData(gl.ARRAY_BUFFER, data, gl.STATIC_DRAW);
            return buffer;
        };
        _proto.createImageBuffer = function createImageBuffer() {
            return this.getImageBuffer() || this.createBuffer();
        };
        _proto.removeGLCanvas = function removeGLCanvas() {
            var gl = this.gl;
            if (!gl) return;
            if (this._debugBuffer) {
                gl.deleteBuffer(this._debugBuffer);
                delete this._debugBuffer;
            }
            if (this._buffers) {
                this._buffers.forEach(function(b) {
                    gl.deleteBuffer(b);
                });
                delete this._buffers;
            }
            if (this._textures) {
                this._textures.forEach(function(t) {
                    return gl.deleteTexture(t);
                });
                delete this._textures;
            }
            if (this._debugInfoCanvas) {
                var texture = this._debugInfoCanvas.texture;
                if (texture) gl.deleteTexture(texture);
                delete this._debugInfoCanvas.texture;
                delete this._debugInfoCanvas;
            }
            var program = gl.program;
            gl.deleteShader(program.fragmentShader);
            gl.deleteShader(program.vertexShader);
            gl.deleteProgram(program);
            delete this.gl;
            delete this.canvas2;
        };
        _proto.createBuffer = function createBuffer() {
            var gl = this.gl;
            var buffer = gl.createBuffer();
            if (!buffer) throw new Error('Failed to create the buffer object');
            if (!this._buffers) this._buffers = [];
            this._buffers.push(buffer);
            return buffer;
        };
        _proto.enableVertexAttrib = function enableVertexAttrib$1(attributes) {
            enableVertexAttrib(this.gl, this.gl.program, attributes);
        };
        _proto.createProgram = function createProgram$1(vert, frag) {
            var gl = this.gl;
            var { program: program, vertexShader: vertexShader, fragmentShader: fragmentShader } = createProgram(gl, vert, frag);
            var numUniforms = gl.getProgramParameter(program, 0x8B86);
            var activeUniforms = [];
            for(var i = 0; i < numUniforms; ++i){
                var info = gl.getActiveUniform(program, i);
                activeUniforms.push(info.name);
            }
            program.vertexShader = vertexShader;
            program.fragmentShader = fragmentShader;
            this._initUniforms(program, activeUniforms);
            return program;
        };
        _proto.useProgram = function useProgram(program) {
            var gl = this.gl;
            gl.useProgram(program);
            gl.program = program;
            return this;
        };
        _proto.enableSampler = function enableSampler(sampler, texIdx) {
            var gl = this.gl;
            var uSampler = this._getUniform(gl.program, sampler);
            if (!texIdx) texIdx = 0;
            gl.uniform1i(uSampler, texIdx);
            return uSampler;
        };
        _proto._initUniforms = function _initUniforms(program, uniforms) {
            for(var i = 0; i < uniforms.length; i++){
                var name = uniforms[i];
                var uniform = uniforms[i];
                var b = name.indexOf('[');
                if (b >= 0) {
                    name = name.substring(0, b);
                    if (!IS_NODE) uniform = uniform.substring(0, b);
                }
                program[name] = this._getUniform(program, uniform);
            }
        };
        _proto._getUniform = function _getUniform(program, uniformName) {
            var gl = this.gl;
            var uniform = gl.getUniformLocation(program, uniformName);
            if (!uniform) throw new Error('Failed to get the storage location of ' + uniformName);
            return uniform;
        };
        _proto.set8 = function set8(a0, a1, a2, a3, a4, a5, a6, a7) {
            var out = TEMP_FLOAT32ARRAY;
            out[0] = a0;
            out[1] = a1;
            out[2] = a2;
            out[3] = a3;
            out[4] = a4;
            out[5] = a5;
            out[6] = a6;
            out[7] = a7;
            return out;
        };
        _proto.set8Int = function set8Int(a0, a1, a2, a3, a4, a5, a6, a7) {
            var out = TEMP_INT16ARRAY;
            out[0] = a0;
            out[1] = a1;
            out[2] = a2;
            out[3] = a3;
            out[4] = a4;
            out[5] = a5;
            out[6] = a6;
            out[7] = a7;
            return out;
        };
        return renderable;
    }(Base);
    return renderable;
};
function resize(image) {
    if (isPowerOfTwo(image.width) && isPowerOfTwo(image.height)) return image;
    var width = image.width;
    var height = image.height;
    if (!isPowerOfTwo(width)) width = ceilPowerOfTwo(width);
    if (!isPowerOfTwo(height)) height = ceilPowerOfTwo(height);
    var canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    var ctx = canvas.getContext('2d');
    ctx.imageSmoothingEnabled = false;
    ctx.drawImage(image, 0, 0, width, height);
    return canvas;
}
function isPowerOfTwo(value) {
    return (value & value - 1) === 0 && value !== 0;
}
function ceilPowerOfTwo(value) {
    return Math.pow(2, Math.ceil(Math.log(value) / Math.LN2));
}
var CanvasRenderer$1 = function(_LayerAbstractRendere) {
    function CanvasRenderer() {
        return _LayerAbstractRendere.apply(this, arguments) || this;
    }
    _inheritsLoose(CanvasRenderer, _LayerAbstractRendere);
    var _proto = CanvasRenderer.prototype;
    _proto.needToRedraw = function needToRedraw() {
        var map = this.getMap();
        if (map.isInteracting() || map.getRenderer().isViewChanged()) return !(!map.getPitch() && map.isMoving() && !map.isZooming() && !map.isRotating() && !this.layer.options['forceRenderOnMoving']);
        return false;
    };
    _proto.setCanvasUpdated = function setCanvasUpdated() {
        this._canvasUpdated = true;
        return this;
    };
    _proto.isCanvasUpdated = function isCanvasUpdated() {
        return !!this._canvasUpdated;
    };
    _proto.getCanvasImage = function getCanvasImage() {
        var map = this.getMap();
        this._canvasUpdated = false;
        if (this._renderZoom !== map.getZoom() || !this.canvas || !this._extent2D) return null;
        if (this.isBlank()) return null;
        if (this.layer.isEmpty && this.layer.isEmpty()) return null;
        var containerPoint = map._pointToContainerPoint(this.middleWest)._add(0, -map.height / 2);
        return {
            'image': this.canvas,
            'layer': this.layer,
            'point': containerPoint
        };
    };
    _proto.clear = function clear() {
        this.clearCanvas();
    };
    _proto.createCanvas = function createCanvas() {
        if (this.canvas) return;
        var map = this.getMap();
        var size = map.getSize();
        var r = map.getDevicePixelRatio(), w = Math.round(r * size.width), h = Math.round(r * size.height);
        if (this.layer._canvas) {
            var canvas = this.layer._canvas;
            canvas.width = w;
            canvas.height = h;
            if (canvas.style) {
                canvas.style.width = size.width + 'px';
                canvas.style.height = size.height + 'px';
            }
            this.canvas = this.layer._canvas;
        } else this.canvas = Canvas.createCanvas(w, h, map.CanvasClass);
        this.onCanvasCreate();
    };
    _proto.onCanvasCreate = function onCanvasCreate() {};
    _proto._canvasContextScale = function _canvasContextScale(context, dpr) {
        context.scale(dpr, dpr);
        context.dpr = dpr;
        return this;
    };
    _proto.createContext = function createContext() {
        if (this.gl && this.gl.canvas === this.canvas || this.context) return;
        this.context = Canvas.getCanvas2DPerformanceContext(this.canvas);
        if (!this.context) return;
        this.context.dpr = 1;
        if (this.layer.options['globalCompositeOperation']) this.context.globalCompositeOperation = this.layer.options['globalCompositeOperation'];
        var dpr = this.getMap().getDevicePixelRatio();
        if (dpr !== 1) this._canvasContextScale(this.context, dpr);
    };
    _proto.resetCanvasTransform = function resetCanvasTransform() {
        if (!this.context) return;
        var dpr = this.getMap().getDevicePixelRatio();
        this.context.setTransform(dpr, 0, 0, dpr, 0, 0);
    };
    _proto.resizeCanvas = function resizeCanvas(canvasSize) {
        var canvas = this.canvas;
        if (!canvas) return;
        var map = this.getMap();
        var size = canvasSize || map.getSize();
        var r = map.getDevicePixelRatio();
        var { width: width, height: height, cssWidth: cssWidth, cssHeight: cssHeight } = calCanvasSize(size, r);
        if (this.layer._canvas && (canvas.style.width !== cssWidth || canvas.style.height !== cssHeight)) {
            canvas.style.width = cssWidth;
            canvas.style.height = cssHeight;
        }
        if (canvas.width === width && canvas.height === height) return;
        canvas.height = height;
        canvas.width = width;
        if (this.context) this.context.dpr = 1;
        if (r !== 1 && this.context) this._canvasContextScale(this.context, r);
    };
    _proto.clearCanvas = function clearCanvas() {
        if (!this.context) return;
        var map = this.getMap();
        if (!map) return;
        var r = this.mapDPR || map.getDevicePixelRatio();
        var rScale = 1 / r;
        var w = this.canvas.width * rScale, h = this.canvas.height * rScale;
        Canvas.clearRect(this.context, 0, 0, Math.max(w, this.canvas.width), Math.max(h, this.canvas.height));
    };
    _proto.prepareCanvas = function prepareCanvas() {
        if (!this.canvas) {
            this.createCanvas();
            this.createContext();
            this.layer.onCanvasCreate();
            this.layer.fire('canvascreate', {
                'context': this.context,
                'gl': this.gl
            });
        } else {
            this.resetCanvasTransform();
            this.clearCanvas();
            this.resizeCanvas();
        }
        delete this._maskExtent;
        var mask = this.layer.getMask();
        if (!mask) {
            this.layer.fire('renderstart', {
                'context': this.context,
                'gl': this.gl
            });
            return null;
        }
        var maskExtent2D = this._maskExtent = mask._getMaskPainter().get2DExtent();
        if (maskExtent2D && this._extent2D && !maskExtent2D.intersects(this._extent2D)) {
            this.layer.fire('renderstart', {
                'context': this.context,
                'gl': this.gl
            });
            return maskExtent2D;
        }
        this.layer.fire('renderstart', {
            'context': this.context,
            'gl': this.gl
        });
        return maskExtent2D;
    };
    _proto.clipCanvas = function clipCanvas(context) {
        var mask = this.layer.getMask();
        if (!mask) return false;
        if (!this.layer.options.maskClip) return false;
        var old = this.middleWest;
        var map = this.getMap();
        this.middleWest = map._containerPointToPoint(new Point(0, map.height / 2));
        var alpha = context.globalAlpha;
        context.save();
        var dpr = this.mapDPR || map.getDevicePixelRatio();
        if (dpr !== 1) {
            context.save();
            this._canvasContextScale(context, dpr);
        }
        if (mask.getGeometries) {
            context.isMultiClip = true;
            var masks = mask.getGeometries() || [];
            context.beginPath();
            masks.forEach(function(_mask) {
                var painter = _mask._getMaskPainter();
                painter.paint(null, context);
            });
            context.stroke();
            context.isMultiClip = false;
        } else {
            context.isClip = true;
            context.beginPath();
            var painter = mask._getMaskPainter();
            painter.paint(null, context);
            context.isClip = false;
        }
        if (dpr !== 1) context.restore();
        try {
            context.clip('evenodd');
        } catch (error) {
            console.error(error);
        }
        this.middleWest = old;
        context.globalAlpha = alpha;
        return true;
    };
    _proto.completeRender = function completeRender() {
        if (this.getMap()) {
            this._renderComplete = true;
            this.layer.fire('renderend', {
                'context': this.context,
                'gl': this.gl
            });
            this.setCanvasUpdated();
        }
    };
    _proto.onResize = function onResize(_param) {
        delete this._extent2D;
        this.resizeCanvas();
        this.setToRedraw();
    };
    return CanvasRenderer;
}(LayerAbstractRenderer);
var options$4 = {
    renderer: Browser$1.webgl ? 'gl' : 'canvas',
    crossOrigin: null,
    alphaTest: false,
    depthMask: true,
    depthFunc: '<='
};
var TEMP_POINT$2 = new Point(0, 0);
var ImageLayer = function(_Layer) {
    function ImageLayer(id, images, options) {
        var _this;
        if (images && !Array.isArray(images) && !images.url) {
            options = images;
            images = null;
        }
        _this = _Layer.call(this, id, options) || this;
        _this._images = images;
        return _this;
    }
    _inheritsLoose(ImageLayer, _Layer);
    var _proto = ImageLayer.prototype;
    _proto.onAdd = function onAdd() {
        this._prepareImages(this._images);
    };
    _proto.setImages = function setImages(images) {
        this._images = images;
        this._prepareImages(images);
        return this;
    };
    _proto.getImages = function getImages() {
        return this._images;
    };
    _proto._prepareImages = function _prepareImages(images) {
        images = images || [];
        if (!Array.isArray(images)) images = [
            images
        ];
        var map = this.getMap();
        var glRes = map.getGLRes();
        this._imageData = images.map(function(img) {
            var extent = new Extent(img.extent);
            return extend$2({}, img, {
                extent: extent,
                extent2d: extent.convertTo(function(c) {
                    return map.coordToPointAtRes(c, glRes);
                })
            });
        });
        this._images = images;
        var renderer = this.getRenderer();
        if (renderer) renderer.refreshImages();
    };
    _proto.getRenderer = function getRenderer() {
        return _Layer.prototype.getRenderer.call(this);
    };
    return ImageLayer;
}(Layer);
ImageLayer.mergeOptions(options$4);
var EMPTY_ARRAY$1 = [];
var ImageLayerCanvasRenderer = function(_CanvasRenderer) {
    function ImageLayerCanvasRenderer() {
        return _CanvasRenderer.apply(this, arguments) || this;
    }
    _inheritsLoose(ImageLayerCanvasRenderer, _CanvasRenderer);
    var _proto2 = ImageLayerCanvasRenderer.prototype;
    _proto2.isDrawable = function isDrawable() {
        if (this.getMap().getPitch()) {
            if (console) console.warn('ImageLayer with canvas renderer can\'t be pitched, use gl renderer (\'renderer\' : \'gl\') instead.');
            return false;
        }
        return true;
    };
    _proto2.checkResources = function checkResources() {
        var _this2 = this;
        if (this._imageLoaded) return EMPTY_ARRAY$1;
        var layer = this.layer;
        var urls = layer._imageData.map(function(img) {
            return [
                img.url,
                null,
                null
            ];
        });
        if (this.resources) {
            var unloaded = [];
            var resources = getResouceCacheInstance();
            urls.forEach(function(url) {
                if (_this2.resources.isResourceLoaded(url)) {
                    var img = _this2.resources.getImage(url);
                    resources.addResource(url, img);
                } else unloaded.push(url);
            });
            this.resources.forEach(function(url, res) {
                if (!resources.isResourceLoaded(url)) _this2.retireImage(res.image);
            });
            this.resources = resources;
            urls = unloaded;
        }
        this._imageLoaded = true;
        return urls;
    };
    _proto2.retireImage = function retireImage(image) {
        var img = image;
        if (img.close) img.close();
    };
    _proto2.refreshImages = function refreshImages() {
        this._imageLoaded = false;
        this.setToRedraw();
    };
    _proto2.draw = function draw(timestamp, context) {
        if (!this.isDrawable()) return;
        this.prepareCanvas();
        this._painted = false;
        this._drawImages(timestamp, context);
        this.completeRender();
    };
    _proto2._drawImages = function _drawImages(timestamp, context) {
        var imgData = this.layer._imageData;
        var map = this.getMap();
        var mapExtent = map.get2DExtentAtRes(map.getGLRes());
        if (imgData && imgData.length) for(var i = 0; i < imgData.length; i++){
            var extent = imgData[i].extent2d;
            var image = this.resources && this.resources.getImage(imgData[i].url);
            if (image && mapExtent.intersects(extent)) {
                this._painted = true;
                var opacity = imgData[i].opacity;
                if (!isNumber(opacity)) opacity = 1;
                this._drawImage(image, extent, opacity);
            }
        }
    };
    _proto2._drawImage = function _drawImage(image, extent, opacity) {
        var globalAlpha = 0;
        var ctx = this.context;
        if (opacity < 1) {
            globalAlpha = ctx.globalAlpha;
            ctx.globalAlpha = opacity;
        }
        var map = this.getMap();
        var nw = TEMP_POINT$2.set(extent.xmin, extent.ymax);
        var point = map._pointAtResToContainerPoint(nw, map.getGLRes());
        var x = point.x, y = point.y;
        var bearing = map.getBearing();
        if (bearing) {
            ctx.save();
            ctx.translate(x, y);
            if (bearing) ctx.rotate(-bearing * Math.PI / 180);
            x = y = 0;
        }
        var scale = map.getGLScale();
        ctx.drawImage(image, x, y, extent.getWidth() / scale, extent.getHeight() / scale);
        if (bearing) ctx.restore();
        if (globalAlpha) ctx.globalAlpha = globalAlpha;
    };
    _proto2.drawOnInteracting = function drawOnInteracting(event, timestamp, context) {
        this.draw();
    };
    return ImageLayerCanvasRenderer;
}(CanvasRenderer$1);
var ImageLayerGLRenderer = function(_ImageGLRenderable) {
    function ImageLayerGLRenderer() {
        return _ImageGLRenderable.apply(this, arguments) || this;
    }
    _inheritsLoose(ImageLayerGLRenderer, _ImageGLRenderable);
    var _proto3 = ImageLayerGLRenderer.prototype;
    _proto3.drawOnInteracting = function drawOnInteracting(event, timestamp, context) {
        this.draw(timestamp, context);
    };
    _proto3._prepareGLContext = function _prepareGLContext() {
        var gl = this.gl;
        if (gl) {
            gl.disable(gl.STENCIL_TEST);
            gl.disable(gl.POLYGON_OFFSET_FILL);
            gl.enable(gl.DEPTH_TEST);
            gl.enable(gl.BLEND);
            gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);
            gl.depthFunc(getDepthFunc(this.layer.options['depthFunc']));
            var depthMask = !!this.layer.options['depthMask'];
            gl.depthMask(depthMask);
        }
    };
    _proto3._drawImages = function _drawImages(timestamp, parentContext) {
        var gl = this.gl;
        if (parentContext && parentContext.renderTarget) {
            var fbo = parentContext.renderTarget.fbo;
            if (fbo) {
                var framebuffer = parentContext.renderTarget.getFramebuffer(fbo);
                gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer);
            }
        }
        this._prepareGLContext();
        _ImageGLRenderable.prototype._drawImages.call(this);
        if (parentContext && parentContext.renderTarget) {
            var _fbo = parentContext.renderTarget.fbo;
            if (_fbo) gl.bindFramebuffer(gl.FRAMEBUFFER, null);
        }
    };
    _proto3.isDrawable = function isDrawable() {
        return true;
    };
    _proto3._drawImage = function _drawImage(image, extent, opacity) {
        var width = extent.getWidth();
        this.drawGLImage(image, extent.xmin, extent.ymax, width, extent.getHeight(), 1, opacity, image.width !== width);
    };
    _proto3.createContext = function createContext() {
        this.createGLContext();
    };
    _proto3.resizeCanvas = function resizeCanvas(canvasSize) {
        if (!this.canvas) return;
        _ImageGLRenderable.prototype.resizeCanvas.call(this, canvasSize);
        this.resizeGLCanvas();
    };
    _proto3.clearCanvas = function clearCanvas() {
        if (!this.canvas) return;
        _ImageGLRenderable.prototype.clearCanvas.call(this);
        this.clearGLCanvas();
    };
    _proto3.retireImage = function retireImage(image) {
        var img = image;
        if (img.close) img.close();
        this.disposeImage(image);
    };
    _proto3.onRemove = function onRemove() {
        this.removeGLCanvas();
        _ImageGLRenderable.prototype.onRemove.call(this);
    };
    return ImageLayerGLRenderer;
}(ImageGLRenderable(ImageLayerCanvasRenderer));
ImageLayer.registerRenderer('canvas', ImageLayerCanvasRenderer);
ImageLayer.registerRenderer('gl', ImageLayerGLRenderer);
var depthFuncEnum;
(function(depthFuncEnum) {
    depthFuncEnum[depthFuncEnum["never"] = 0] = "never";
    depthFuncEnum[depthFuncEnum["<"] = 1] = "<";
    depthFuncEnum[depthFuncEnum["="] = 2] = "=";
    depthFuncEnum[depthFuncEnum["<="] = 3] = "<=";
    depthFuncEnum[depthFuncEnum[" >"] = 4] = " >";
    depthFuncEnum[depthFuncEnum["!="] = 5] = "!=";
    depthFuncEnum[depthFuncEnum[">="] = 6] = ">=";
    depthFuncEnum[depthFuncEnum["always"] = 7] = "always";
})(depthFuncEnum || (depthFuncEnum = {}));
var TEMP_EXTENT$1 = new PointExtent();
var options$3 = {
    'debug': false,
    'enableSimplify': true,
    'defaultIconSize': [
        20,
        20
    ],
    'cacheVectorOnCanvas': true,
    'cacheSvgOnCanvas': Browser$1.gecko,
    'enableAltitude': true,
    'altitudeProperty': 'altitude',
    'drawAltitude': false,
    'sortByDistanceToCamera': false,
    'roundPoint': false,
    'altitude': 0,
    'clipBBoxBufferSize': 3,
    'collision': false,
    'collisionBufferSize': 2,
    'collisionDelay': 250,
    'collisionScope': 'layer',
    'progressiveRender': false,
    'progressiveRenderCount': 1000,
    'progressiveRenderDebug': false
};
var VectorLayer = function(_OverlayLayer) {
    function VectorLayer(id, geometries, options) {
        var _this;
        _this = _OverlayLayer.call(this, id, geometries, options) || this;
        _this.isVectorLayer = true;
        return _this;
    }
    _inheritsLoose(VectorLayer, _OverlayLayer);
    var _proto = VectorLayer.prototype;
    _proto.onConfig = function onConfig(conf) {
        _OverlayLayer.prototype.onConfig.call(this, conf);
        if (!isNil(conf['enableAltitude'])) {
            var geos = this.getGeometries() || [];
            for(var i = 0, len = geos.length; i < len; i++){
                var geo = geos[i];
                if (geo) {
                    geo._clearAltitudeCache();
                    geo.fire('positionchange');
                }
            }
        }
        if (conf['enableAltitude'] || conf['drawAltitude'] || conf['altitudeProperty']) {
            var renderer = this.getRenderer();
            if (renderer && renderer.setToRedraw) renderer.setToRedraw();
        }
    };
    _proto.identify = function identify(coordinate, options) {
        options = options || {};
        var renderer = this.getRenderer();
        if (!(coordinate instanceof Coordinate)) coordinate = new Coordinate(coordinate);
        var cp = this.getMap().coordToContainerPoint(coordinate);
        if (options['onlyVisible'] && renderer && renderer.identifyAtPoint) return renderer.identifyAtPoint(cp, options);
        return this._hitGeos(this._geoList, cp, options);
    };
    _proto.identifyAtPoint = function identifyAtPoint(point, options) {
        options = options || {};
        var renderer = this.getRenderer();
        if (!(point instanceof Point)) point = new Point(point);
        if (options['onlyVisible'] && renderer && renderer.identifyAtPoint) return renderer.identifyAtPoint(point, options);
        return this._hitGeos(this._geoList, point, options);
    };
    _proto._hitGeos = function _hitGeos(geometries, cp, options = {}) {
        if (!geometries || !geometries.length) return [];
        var filterGeos = [];
        var idx = 0;
        for(var i = 0, len = geometries.length; i < len; i++){
            var geo = geometries[i];
            if (geo.isPoint && geo._collided === true) continue;
            filterGeos[idx] = geo;
            idx++;
        }
        geometries = filterGeos;
        var filter = options['filter'], hits = [];
        var tolerance = options['tolerance'];
        var map = this.getMap();
        var renderer = this.getRenderer();
        var imageData = renderer && renderer.getImageData && renderer.getImageData();
        if (imageData) {
            var hitTolerance = 0;
            var maxTolerance = renderer.maxTolerance;
            if (isNumber(maxTolerance)) hitTolerance = maxTolerance;
            else for(var _i = geometries.length - 1; _i >= 0; _i--){
                var t = geometries[_i]._hitTestTolerance() + (tolerance || 0);
                if (t > hitTolerance) hitTolerance = t;
            }
            var r = map.getDevicePixelRatio();
            imageData.r = r;
            var hit = false;
            var cpx = cp.x - hitTolerance;
            var cpy = cp.y - hitTolerance;
            for(var _i2 = -hitTolerance; _i2 <= hitTolerance; _i2++){
                for(var j = -hitTolerance; j <= hitTolerance; j++){
                    var x = Math.round((cpx + _i2) * r), y = Math.round((cpy + j) * r);
                    var _idx = y * imageData.width * 4 + x * 4;
                    if (imageData.data[_idx + 3] > 0) {
                        hit = true;
                        break;
                    }
                }
                if (hit) break;
            }
            if (!hit) return hits;
        }
        var onlyVisible = options.onlyVisible;
        for(var _i3 = geometries.length - 1; _i3 >= 0; _i3--){
            var _geo = geometries[_i3];
            if (!_geo || !_geo.options['interactive']) continue;
            if (!onlyVisible && !_geo.isVisible()) continue;
            var painter = _geo._getPainter();
            if (!painter) continue;
            var bbox = painter.getRenderBBOX && painter.getRenderBBOX();
            if (bbox) {
                var { x: _x, y: _y } = cp;
                if (_x < bbox[0] || _y < bbox[1] || _x > bbox[2] || _y > bbox[3]) continue;
            }
            if (!(_geo instanceof LineString) || !_geo._getArrowStyle() && !(_geo instanceof Curve)) {
                var extent = _geo.getContainerExtent(TEMP_EXTENT$1);
                if (tolerance) extent = extent._expand(tolerance);
                if (!extent || !extent.contains(cp)) continue;
            }
            if (_geo._containsPoint(cp, tolerance) && (!filter || filter(_geo))) {
                hits.push(_geo);
                if (options['count']) {
                    if (hits.length >= options['count']) break;
                }
            }
        }
        return hits;
    };
    _proto.getAltitude = function getAltitude() {
        return this.options['altitude'] || 0;
    };
    _proto.toJSON = function toJSON(options) {
        if (!options) options = {
            'clipExtent': null,
            'geometries': null
        };
        var profile = {
            'type': this.getJSONType(),
            'id': this.getId(),
            'options': this.config()
        };
        if (isNil(options['geometries']) || options['geometries']) {
            var clipExtent;
            if (options['clipExtent']) {
                var map = this.getMap();
                var projection = map ? map.getProjection() : null;
                clipExtent = new Extent(options['clipExtent'], projection);
            }
            var geoJSONs = [];
            var geometries = this.getGeometries();
            for(var i = 0, len = geometries.length; i < len; i++){
                var geo = geometries[i];
                var geoExt = geo.getExtent();
                if (!geoExt || clipExtent && !clipExtent.intersects(geoExt)) continue;
                var json = geo.toJSON(options['geometries']);
                geoJSONs.push(json);
            }
            profile['geometries'] = geoJSONs;
        }
        return profile;
    };
    _proto.getRenderer = function getRenderer() {
        return _OverlayLayer.prototype.getRenderer.call(this);
    };
    VectorLayer.fromJSON = function fromJSON(json) {
        if (!json || json['type'] !== 'VectorLayer') return null;
        var layer = new VectorLayer(json['id'], json['options']);
        var geoJSONs = json['geometries'];
        var geometries = [];
        for(var i = 0; i < geoJSONs.length; i++){
            var geo = Geometry.fromJSON(geoJSONs[i]);
            if (geo) geometries.push(geo);
        }
        layer.addGeometry(geometries);
        return layer;
    };
    VectorLayer.getPainterClass = function getPainterClass() {
        return Painter;
    };
    VectorLayer.getCollectionPainterClass = function getCollectionPainterClass() {
        return CollectionPainter;
    };
    return VectorLayer;
}(OverlayLayer);
VectorLayer.mergeOptions(options$3);
VectorLayer.registerJSONType('VectorLayer');
DrawToolLayer.setLayerClass(VectorLayer, VectorLayer, VectorLayer);
var CanvasLayerRenderer = function(_CanvasRenderer) {
    function CanvasLayerRenderer() {
        return _CanvasRenderer.apply(this, arguments) || this;
    }
    _inheritsLoose(CanvasLayerRenderer, _CanvasRenderer);
    var _proto = CanvasLayerRenderer.prototype;
    _proto.getPrepareParams = function getPrepareParams() {
        return [];
    };
    _proto.getDrawParams = function getDrawParams() {
        return [];
    };
    _proto.onCanvasCreate = function onCanvasCreate() {
        if (this.canvas && this.layer.options['doubleBuffer']) this.buffer = Canvas.createCanvas(this.canvas.width, this.canvas.height, this.getMap().CanvasClass);
    };
    _proto.needToRedraw = function needToRedraw() {
        if (this.layer.options['animation']) return true;
        var map = this.getMap();
        if (map.isInteracting() && !this.layer.drawOnInteracting) return false;
        return _CanvasRenderer.prototype.needToRedraw.call(this);
    };
    _proto.draw = function draw(...args) {
        this.prepareCanvas();
        this.prepareDrawContext();
        this._drawLayer(...args);
    };
    _proto.drawOnInteracting = function drawOnInteracting(...args) {
        this._drawLayerOnInteracting(...args);
    };
    _proto.getCanvasImage = function getCanvasImage() {
        var canvasImg = _CanvasRenderer.prototype.getCanvasImage.call(this);
        if (canvasImg && canvasImg.image && this.layer.options['doubleBuffer']) {
            var canvas = canvasImg.image;
            if (this.buffer.width !== canvas.width || this.buffer.height !== canvas.height) {
                this.buffer.width = canvas.width;
                this.buffer.height = canvas.height;
            }
            var bufferContext = this.buffer.getContext('2d');
            var prevent = this.layer.doubleBuffer(bufferContext, this.context);
            if (prevent === undefined || prevent) {
                Canvas.image(bufferContext, canvas, 0, 0);
                canvasImg.image = this.buffer;
            }
        }
        return canvasImg;
    };
    _proto.remove = function remove() {
        delete this._drawContext;
        return _CanvasRenderer.prototype.remove.call(this);
    };
    _proto.onZoomStart = function onZoomStart(param) {
        this.layer.onZoomStart(param);
        _CanvasRenderer.prototype.onZoomStart.call(this, param);
    };
    _proto.onZooming = function onZooming(param) {
        this.layer.onZooming(param);
        _CanvasRenderer.prototype.onZooming.call(this, param);
    };
    _proto.onZoomEnd = function onZoomEnd(param) {
        this.layer.onZoomEnd(param);
        _CanvasRenderer.prototype.onZoomEnd.call(this, param);
    };
    _proto.onMoveStart = function onMoveStart(param) {
        this.layer.onMoveStart(param);
        _CanvasRenderer.prototype.onMoveStart.call(this, param);
    };
    _proto.onMoving = function onMoving(param) {
        this.layer.onMoving(param);
        _CanvasRenderer.prototype.onMoving.call(this, param);
    };
    _proto.onMoveEnd = function onMoveEnd(param) {
        this.layer.onMoveEnd(param);
        _CanvasRenderer.prototype.onMoveEnd.call(this, param);
    };
    _proto.onResize = function onResize(param) {
        this.layer.onResize(param);
        _CanvasRenderer.prototype.onResize.call(this, param);
    };
    _proto.prepareDrawContext = function prepareDrawContext() {
        if (!this._predrawed) {
            var params = ensureParams(this.getPrepareParams());
            this._drawContext = this.layer.prepareToDraw(this.context, ...params);
            if (!this._drawContext) this._drawContext = [];
            if (!Array.isArray(this._drawContext)) this._drawContext = [
                this._drawContext
            ];
            this._predrawed = true;
        }
    };
    _proto._prepareDrawParams = function _prepareDrawParams() {
        if (!this.getMap()) return null;
        var view = this.getViewExtent();
        if (view['maskExtent'] && !view['extent'].intersects(view['maskExtent'])) {
            this.completeRender();
            return null;
        }
        var args = [
            this.context,
            view
        ];
        var params = ensureParams(this.getDrawParams());
        return [
            ...args,
            ...params,
            ...this._drawContext
        ];
    };
    _proto._drawLayer = function _drawLayer(...args) {
        var params = this._prepareDrawParams();
        if (!params) return;
        this.layer.draw.apply(this.layer, params.concat(args));
        this.completeRender();
    };
    _proto._drawLayerOnInteracting = function _drawLayerOnInteracting(...args) {
        if (!this.layer.drawOnInteracting) return;
        var params = this._prepareDrawParams();
        if (!params) return;
        this.layer.drawOnInteracting(...params, ...args);
        this.completeRender();
    };
    return CanvasLayerRenderer;
}(CanvasRenderer$1);
function ensureParams(params) {
    if (!params) params = [];
    if (!Array.isArray(params)) params = [
        params
    ];
    return params;
}
var options$2 = {
    'doubleBuffer': false,
    'animation': false
};
var CanvasLayer = function(_Layer) {
    function CanvasLayer() {
        return _Layer.apply(this, arguments) || this;
    }
    _inheritsLoose(CanvasLayer, _Layer);
    var _proto = CanvasLayer.prototype;
    _proto.isCanvasRender = function isCanvasRender() {
        return true;
    };
    _proto.prepareToDraw = function prepareToDraw() {};
    _proto.draw = function draw(...params) {};
    _proto.redraw = function redraw() {
        if (this._getRenderer()) this._getRenderer().setToRedraw();
        return this;
    };
    _proto.play = function play() {
        this.config('animation', true);
        return this;
    };
    _proto.pause = function pause() {
        this.config('animation', false);
        return this;
    };
    _proto.isPlaying = function isPlaying() {
        return this.options['animation'];
    };
    _proto.clearCanvas = function clearCanvas() {
        if (this._getRenderer()) this._getRenderer().clearCanvas();
        return this;
    };
    _proto.requestMapToRender = function requestMapToRender() {
        var renderer = this._getRenderer();
        if (renderer && renderer.requestMapToRender) renderer.requestMapToRender();
        return this;
    };
    _proto.completeRender = function completeRender() {
        if (this._getRenderer()) this._getRenderer().completeRender();
        return this;
    };
    _proto.onCanvasCreate = function onCanvasCreate() {
        return this;
    };
    _proto.onZoomStart = function onZoomStart() {};
    _proto.onZooming = function onZooming() {};
    _proto.onZoomEnd = function onZoomEnd() {};
    _proto.onMoveStart = function onMoveStart() {};
    _proto.onMoving = function onMoving() {};
    _proto.onMoveEnd = function onMoveEnd() {};
    _proto.onResize = function onResize() {};
    _proto.doubleBuffer = function doubleBuffer(bufferContext) {
        bufferContext.clearRect(0, 0, bufferContext.canvas.width, bufferContext.canvas.height);
        return this;
    };
    _proto._getRenderer = function _getRenderer() {
        return _Layer.prototype._getRenderer.call(this);
    };
    return CanvasLayer;
}(Layer);
CanvasLayer.mergeOptions(options$2);
CanvasLayer.registerRenderer('canvas', CanvasLayerRenderer);
var TEMP_POINT$1 = new Point(0, 0);
var options$1 = {
    'animation': true
};
var ParticleLayer = function(_CanvasLayer) {
    function ParticleLayer() {
        return _CanvasLayer.apply(this, arguments) || this;
    }
    _inheritsLoose(ParticleLayer, _CanvasLayer);
    var _proto = ParticleLayer.prototype;
    _proto.getParticles = function getParticles(t) {};
    _proto.draw = function draw(context, view) {
        var points = this.getParticles(now());
        if (!points || points.length === 0) {
            var renderer = this._getRenderer();
            if (renderer) this._getRenderer()._shouldClear = true;
            return;
        }
        var map = this.getMap();
        var extent = view.extent;
        if (view.maskExtent) extent = view.extent.intersection(view.maskExtent);
        extent = extent.convertTo(function(c) {
            return map._pointToContainerPoint(c, undefined, 0, TEMP_POINT$1);
        });
        var e = 2 * Math.PI;
        for(var i = 0, l = points.length; i < l; i++){
            var pos = points[i].point;
            if (extent.contains(pos)) {
                var color = points[i].color || this.options['lineColor'] || '#fff', r = points[i].r;
                if (context.fillStyle !== color) context.fillStyle = color;
                if (r <= 2) context.fillRect(pos.x - r / 2, pos.y - r / 2, r, r);
                else {
                    context.beginPath();
                    context.arc(pos.x, pos.y, r / 2, 0, e);
                    context.fill();
                }
            }
        }
        this._fillCanvas(context);
    };
    _proto._fillCanvas = function _fillCanvas(context) {
        var g = context.globalCompositeOperation;
        context.globalCompositeOperation = 'destination-out';
        var trail = this.options['trail'] || 30;
        context.fillStyle = 'rgba(0, 0, 0, ' + 1 / trail + ')';
        context.fillRect(0, 0, context.canvas.width, context.canvas.height);
        context.globalCompositeOperation = g;
    };
    return ParticleLayer;
}(CanvasLayer);
ParticleLayer.mergeOptions(options$1);
ParticleLayer.registerRenderer('canvas', function(_CanvasLayerRenderer) {
    function _class() {
        return _CanvasLayerRenderer.apply(this, arguments) || this;
    }
    _inheritsLoose(_class, _CanvasLayerRenderer);
    var _proto2 = _class.prototype;
    _proto2.draw = function draw() {
        if (!this.canvas || !this.layer.options['animation'] || this._shouldClear) {
            this.prepareCanvas();
            this._shouldClear = false;
        }
        this.prepareDrawContext();
        this._drawLayer();
    };
    _proto2.drawOnInteracting = function drawOnInteracting() {
        this.draw();
        this._shouldClear = false;
    };
    _proto2.onSkipDrawOnInteracting = function onSkipDrawOnInteracting() {
        this._shouldClear = true;
    };
    return _class;
}(CanvasLayerRenderer));
var resources = getResouceCacheInstance();
var prevX, prevY;
var EditHandle = function(_Eventable) {
    function EditHandle(target, map, options) {
        var _this;
        _this = _Eventable.call(this, options || {}) || this;
        _this.target = target;
        target.once('remove', _this["delete"], _this);
        var symbol = _this.options['symbol'];
        var lineWidth = symbol['markerLineWidth'] || 1;
        _this.w = symbol['markerWidth'] + lineWidth;
        _this.h = symbol['markerHeight'] + lineWidth;
        _this.opacity = isNil(symbol['opacity']) ? 1 : symbol['opacity'];
        _this.map = map;
        _this.events = options.events;
        _this._fetchImage();
        _this.addTo(map);
        return _this;
    }
    _inheritsLoose(EditHandle, _Eventable);
    var _proto = EditHandle.prototype;
    _proto.getCursor = function getCursor() {
        return this.options['cursor'] || 'default';
    };
    _proto._fetchImage = function _fetchImage() {
        var map = this.map;
        var symbol = this.options.symbol;
        var { markerFile: markerFile } = symbol;
        this.url = markerFile || getSymbolHash(symbol);
        var img = resources.getImage(this.url);
        if (!img) {
            var w = this.w;
            var h = this.h;
            if (markerFile) {
                img = new Image();
                img.onload = function() {
                    var renderer = map.getRenderer();
                    if (renderer) renderer.setToRedraw();
                };
                img.src = this.url;
            } else {
                var canvas = document.createElement('canvas');
                canvas.width = w;
                canvas.height = h;
                var ctx = canvas.getContext('2d');
                img = drawVectorMarker(ctx, {
                    x: w / 2,
                    y: h / 2
                }, symbol, resources);
            }
            resources.addResource([
                this.url,
                w,
                h
            ], img);
        }
        resources.login(this.url);
        this._img = img;
    };
    _proto.setContainerPoint = function setContainerPoint(cp) {
        this._point = cp;
        this._point._sub(this.w / 2, this.h / 2);
    };
    _proto.getContainerPoint = function getContainerPoint() {
        return this._point.add(this.w / 2, this.h / 2);
    };
    _proto.offset = function offset(p) {
        this._point._add(p);
    };
    _proto.render = function render(ctx) {
        if (!this._img) return false;
        var symbol = this.options['symbol'];
        var dx = symbol['markerDx'] || 0;
        var dy = symbol['markerDy'] || 0;
        var map = this.map;
        var { x: x, y: y } = this._point;
        var w = this.w;
        var h = this.h;
        if (x + w > 0 && x < map.width && y + h > 0 && y < map.height) {
            var dpr = map.getDevicePixelRatio();
            ctx.globalAlpha = this.opacity;
            ctx.drawImage(this._img, Math.round((x + dx) * dpr), Math.round((y + dy) * dpr), Math.round(w * dpr), Math.round(h * dpr));
            return true;
        }
        return false;
    };
    _proto["delete"] = function _delete() {
        if (this.map) {
            var renderer = this.map.getRenderer();
            if (renderer) renderer.removeTopElement(this);
        }
        resources.logout(this.url);
        if (this._dragger) {
            this._dragger.disable();
            delete this._dragger;
        }
        delete this.map;
    };
    _proto.hitTest = function hitTest(p) {
        var symbol = this.options['symbol'];
        var dx = symbol['markerDx'] || 0;
        var dy = symbol['markerDy'] || 0;
        var w = this.w;
        var h = this.h;
        var x = this._point.x + dx;
        var y = this._point.y + dy;
        return p.x >= x && p.x <= x + w && p.y >= y && p.y <= y + h;
    };
    _proto.addTo = function addTo(map) {
        this.map = map;
        var renderer = map.getRenderer();
        renderer.addTopElement(this);
    };
    _proto.onEvent = function onEvent(e) {
        this.fire(e.type, e);
    };
    _proto.mousedown = function mousedown(e) {
        var map = e.target;
        var cursor = this.options['cursor'];
        if (cursor) map.setCursor(cursor);
        this.onDragstart(e);
    };
    _proto.onDragstart = function onDragstart(e) {
        var { containerPoint: containerPoint, target: map } = e;
        var dom = map.getPanels().mapWrapper || map.getContainer();
        var dragHandler = this._dragger = new DragHandler(dom);
        dragHandler.on('dragging', this.onDragging, this).on('mouseup', this.onDragend, this).enable();
        dragHandler.onMouseDown(e['domEvent']);
        prevX = containerPoint.x;
        prevY = containerPoint.y;
        this.fire('dragstart', {
            containerPoint: containerPoint
        });
    };
    _proto.onDragging = function onDragging(e) {
        if (!this._dragger) return;
        var activeMap = this.map;
        var containerPoint = getEventContainerPoint(e.domEvent, activeMap.getContainer());
        var offset = {
            x: containerPoint.x - prevX,
            y: containerPoint.y - prevY
        };
        var prevCoord = activeMap.containerPointToCoord(new Point(prevX, prevY));
        var currentCoord = activeMap.containerPointToCoord(containerPoint);
        prevX = containerPoint.x;
        prevY = containerPoint.y;
        this.offset(offset);
        this.fire('dragging', {
            containerPoint: containerPoint,
            coordOffset: currentCoord._sub(prevCoord)
        });
    };
    _proto.onDragend = function onDragend(e) {
        if (!this._dragger) return;
        var map = this.map;
        map.resetCursor();
        var containerPoint = getEventContainerPoint(e.domEvent, map.getContainer());
        var offset = {
            x: containerPoint.x - prevX,
            y: containerPoint.y - prevY
        };
        this.offset(offset);
        this._dragger.disable();
        delete this._dragger;
        this.fire('dragend', {
            containerPoint: containerPoint
        });
    };
    _proto.needCollision = function needCollision() {
        var { target: target } = this;
        if (this.options.ignoreCollision) return false;
        return target && target.options && target.options.collision;
    };
    _proto.getRenderBBOX = function getRenderBBOX(dpr) {
        var { target: target, map: map } = this;
        if (!target || !target.options || !map) return null;
        var symbol = this.options['symbol'];
        var dx = symbol['markerDx'] || 0;
        var dy = symbol['markerDy'] || 0;
        var { x: x, y: y } = this._point;
        var w = this.w;
        var h = this.h;
        dpr = dpr || map.getDevicePixelRatio();
        this.bbox = this.bbox || getDefaultBBOX();
        var x1 = Math.round((x + dx) * dpr);
        var y1 = Math.round((y + dy) * dpr);
        var width = Math.round(w * dpr);
        var height = Math.round(h * dpr);
        this.bbox[0] = x1;
        this.bbox[1] = y1;
        this.bbox[2] = x1 + width;
        this.bbox[3] = y1 + height;
        var { options: options } = target;
        var collisionBufferSize = options.collisionBufferSize || 0;
        bufferBBOX(this.bbox, collisionBufferSize);
        return this.bbox;
    };
    _proto.setZIndex = function setZIndex(zIndex) {
        this.options.zIndex = zIndex;
    };
    return EditHandle;
}(Eventable(Class));
var EditOutline = function() {
    function EditOutline(target, map, options) {
        this.target = target;
        target.once('remove', this["delete"], this);
        this.map = map;
        this.options = options || {};
        this.addTo(map);
    }
    var _proto = EditOutline.prototype;
    _proto.setPoints = function setPoints(points) {
        this.points = points;
        var allX = points.map(function(p) {
            return p.x;
        });
        var allY = points.map(function(p) {
            return p.y;
        });
        this.xmin = Math.min(...allX);
        this.xmax = Math.max(...allX);
        this.ymin = Math.min(...allY);
        this.ymax = Math.max(...allY);
    };
    _proto.hitTest = function hitTest() {
        return false;
    };
    _proto.render = function render(ctx) {
        var map = this.map;
        if (this.xmax <= 0 || this.xmin >= map.width || this.ymax <= 0 || this.ymin >= map.height) return;
        var dpr = map.getDevicePixelRatio();
        var padding = 0.5;
        function c(v) {
            return Math.round(v) * dpr + padding;
        }
        ctx.lineWidth = 1;
        ctx.strokeStyle = '#000';
        ctx.globalAlpha = 1;
        ctx.beginPath();
        var points = this.points;
        ctx.moveTo(c(points[0].x), c(points[0].y));
        for(var i = 1; i < this.points.length; i++)ctx.lineTo(c(points[i].x), c(points[i].y));
        ctx.closePath();
        ctx.stroke();
    };
    _proto.addTo = function addTo(map) {
        this.map = map;
        var renderer = map.getRenderer();
        renderer.addTopElement(this);
    };
    _proto["delete"] = function _delete() {
        if (this.map) {
            var renderer = this.map.getRenderer();
            if (renderer) renderer.removeTopElement(this);
        }
    };
    return EditOutline;
}();
var EDIT_STAGE_LAYER_PREFIX = INTERNAL_LAYER_PREFIX + '_edit_stage_';
function createHandleSymbol(markerType, opacity) {
    return {
        'markerType': markerType,
        'markerFill': '#fff',
        'markerLineColor': '#000',
        'markerLineWidth': 2,
        'markerWidth': 10,
        'markerHeight': 10,
        'opacity': opacity
    };
}
function coordinatesToContainerPoint(map, coordinate) {
    var glRes = map.getGLRes();
    var renderPoints = map.coordToPointAtRes(coordinate, glRes);
    var altitude = coordinate.z || 0;
    var point = map._pointAtResToContainerPoint(renderPoints, glRes, altitude);
    return point;
}
function fixHandlePointCoordinates(geometry, vertex, dragContainerPoint) {
    var map = geometry.getMap();
    if (!vertex || vertex.z === 0) return map.containerPointToCoord(dragContainerPoint);
    var altitude = vertex.z;
    var glRes = map.getGLRes();
    var renderPoints = map.coordToPointAtRes(vertex, glRes);
    var point1 = map._pointAtResToContainerPoint(renderPoints, glRes, 0);
    var point2 = map._pointAtResToContainerPoint(renderPoints, glRes, altitude);
    var offset = point2.sub(point1);
    var containerPoint = dragContainerPoint.sub(offset);
    var coordinates = map.containerPointToCoord(containerPoint);
    coordinates.z = 0;
    var isPoint = !geometry.getGeometries && geometry.isPoint;
    if (isPoint) coordinates.z = altitude;
    return coordinates;
}
function onHandleDragstart(param) {
    var geometryEditor = this.target;
    var opts = this.paramOptions;
    geometryEditor._updating = true;
    if (opts.onDown) {
        opts.onDown.call(geometryEditor, param['containerPoint'], param);
        geometryEditor._geometry.fire('handledragstart');
    }
    return false;
}
function onHandleDragging(param) {
    var geometryEditor = this.target;
    var opts = this.paramOptions;
    geometryEditor._hideContext();
    if (opts.onMove) {
        opts.onMove.call(geometryEditor, param);
        geometryEditor._geometry.fire('handledragging');
    }
    return false;
}
function onHandleDragEnd(ev) {
    var geometryEditor = this.target;
    var opts = this.paramOptions;
    if (opts.onUp) {
        opts.onUp.call(geometryEditor, ev);
        geometryEditor._geometry.fire('handledragend');
    }
    geometryEditor._updating = false;
    return false;
}
var options = {
    'fixAspectRatio': false,
    'symbol': null,
    'removeVertexOn': 'contextmenu',
    'centerHandleSymbol': createHandleSymbol('ellipse', 1),
    'vertexHandleSymbol': createHandleSymbol('square', 1),
    'newVertexHandleSymbol': createHandleSymbol('square', 0.4),
    'collision': false,
    'collisionBufferSize': 0,
    'vertexZIndex': 0,
    'newVertexZIndex': 0
};
var GeometryEditor = function(_Eventable) {
    function GeometryEditor(geometry, opts) {
        var _this;
        _this = _Eventable.call(this, opts) || this;
        _this._geometry = geometry;
        if (!_this._geometry) return _assertThisInitialized(_this);
        return _this;
    }
    _inheritsLoose(GeometryEditor, _Eventable);
    var _proto = GeometryEditor.prototype;
    _proto.getMap = function getMap() {
        return this._geometry.getMap();
    };
    _proto.prepare = function prepare() {
        var map = this.getMap();
        if (!map) return;
        map.on('drawtopstart', this._refresh, this);
        if (this.options['symbol']) {
            this._originalSymbol = this._geometry.getSymbol();
            this._geometry.setSymbol(this.options['symbol']);
        }
        this._prepareEditStageLayer();
    };
    _proto._prepareEditStageLayer = function _prepareEditStageLayer() {
        var layer = this._geometry.getLayer();
        if (layer.options['renderer'] !== 'canvas') return;
        var map = this.getMap();
        var uid = UID();
        var shadowId = EDIT_STAGE_LAYER_PREFIX + uid + '_shadow';
        this._shadowLayer = map.getLayer(shadowId);
        if (!this._shadowLayer) {
            var LayerType = layer.constructor;
            this._shadowLayer = new LayerType(shadowId);
            map.addLayer(this._shadowLayer);
        }
    };
    _proto.start = function start() {
        if (!this._geometry || !this._geometry.getMap() || this._geometry.editing) return;
        this.editing = true;
        this.prepare();
        var geometry = this._geometry;
        var shadow;
        var layer = this._geometry.getLayer();
        var needShadow = layer.options['renderer'] === 'canvas';
        this._geometryDraggble = geometry.options['draggable'];
        if (needShadow) {
            geometry.config('draggable', false);
            shadow = geometry.copy();
            shadow.setSymbol(geometry._getInternalSymbol());
            shadow.copyEventListeners(geometry);
            if (geometry._getParent()) shadow.copyEventListeners(geometry._getParent());
            shadow._setEventTarget(geometry);
            shadow.setId(null).config({
                'draggable': false
            });
            this._shadow = shadow;
            geometry.hide();
        } else if (geometry instanceof Marker) geometry.config('draggable', true);
        this._switchGeometryEvents('on');
        if (geometry instanceof Marker || geometry instanceof Circle || geometry instanceof Rectangle || geometry instanceof Ellipse) this._createOrRefreshOutline();
        if (this._shadowLayer) this._shadowLayer.bringToFront().addGeometry(shadow);
        if (!(geometry instanceof Marker)) this._createCenterHandle();
        else if (shadow) {
            shadow.config('draggable', true);
            shadow.on('dragend', this._onMarkerDragEnd, this);
        }
        if (geometry instanceof Marker && this.options['resize'] !== false) this.createMarkerEditor();
        else if (geometry instanceof Circle) this.createCircleEditor();
        else if (geometry instanceof Rectangle) this.createEllipseOrRectEditor();
        else if (geometry instanceof Ellipse) this.createEllipseOrRectEditor();
        else if (geometry instanceof Sector) ;
        else if (geometry instanceof Polygon || geometry instanceof LineString) this.createPolygonEditor();
    };
    _proto.stop = function stop() {
        delete this._history;
        delete this._historyPointer;
        delete this._editOutline;
        this._switchGeometryEvents('off');
        var map = this.getMap();
        if (!map) {
            this.fire('remove');
            return;
        }
        this._geometry.config('draggable', this._geometryDraggble);
        if (this._shadow) {
            delete this._shadow;
            delete this._geometryDraggble;
            this._geometry.show();
        }
        if (this._shadowLayer) {
            this._shadowLayer.remove();
            delete this._shadowLayer;
        }
        this._refreshHooks = [];
        if (this.options['symbol']) {
            this._geometry.setSymbol(this._originalSymbol);
            delete this._originalSymbol;
        }
        this.editing = false;
        this.fire('remove');
    };
    _proto.isEditing = function isEditing() {
        if (isNil(this.editing)) return false;
        return this.editing;
    };
    _proto._getGeometryEvents = function _getGeometryEvents() {
        return {
            'symbolchange': this._onGeoSymbolChange,
            'dragstart': this._onDragStart,
            'dragend': this._onDragEnd,
            'positionchange shapechange': this._exeAndReset
        };
    };
    _proto._switchGeometryEvents = function _switchGeometryEvents(oper) {
        if (this._geometry) {
            var events = this._getGeometryEvents();
            for(var p in events)this._geometry[oper](p, events[p], this);
        }
    };
    _proto._onGeoSymbolChange = function _onGeoSymbolChange(param) {
        if (this._shadow) this._shadow.setSymbol(param.target._getInternalSymbol());
    };
    _proto._onMarkerDragEnd = function _onMarkerDragEnd() {
        this._update('setCoordinates', this._shadow.getCoordinates().toArray());
    };
    _proto._createOrRefreshOutline = function _createOrRefreshOutline() {
        var geometry = this._geometry;
        var outline = this._editOutline;
        if (!outline) {
            this._editOutline = new EditOutline(this, this.getMap());
            this._addRefreshHook(this._createOrRefreshOutline);
        }
        var points = this._editOutline.points;
        if (geometry instanceof Marker) this._editOutline.setPoints(geometry.getContainerExtent().toArray(points));
        else {
            var coordinates = geometry.getShell();
            var editCenter = geometry._getEditCenter();
            var bbox = getDefaultBBOX();
            pointsBBOX(coordinates, bbox);
            var extent = new Extent(bbox[0], bbox[1], bbox[2], bbox[3]);
            var map = this.getMap();
            var _points = extent.toArray().map(function(c) {
                c.z = editCenter.z;
                return coordinatesToContainerPoint(map, c);
            });
            this._editOutline.setPoints(_points);
        }
        return outline;
    };
    _proto._createCenterHandle = function _createCenterHandle() {
        var _this2 = this;
        var map = this.getMap();
        var symbol = this.options['centerHandleSymbol'];
        var shadow;
        var cointainerPoint = coordinatesToContainerPoint(map, this._geometry._getEditCenter());
        var handle = this.createHandle(cointainerPoint, {
            ignoreCollision: true,
            'symbol': symbol,
            'cursor': 'move',
            onDown: function onDown() {
                if (_this2._shadow) {
                    shadow = _this2._shadow.copy();
                    var _symbol = lowerSymbolOpacity(shadow._getInternalSymbol(), 0.5);
                    shadow.setSymbol(_symbol).addTo(_this2._geometry.getLayer());
                }
            },
            onMove: function onMove(param) {
                var offset = param['coordOffset'];
                if (shadow) shadow.translate(offset);
                else _this2._geometry.translate(offset);
            },
            onUp: function onUp() {
                if (shadow) {
                    var shadowFirst = shadow.getFirstCoordinate();
                    var first = _this2._geometry.getFirstCoordinate();
                    var offset = shadowFirst.sub(first);
                    _this2._update('translate', offset);
                    shadow.remove();
                }
            }
        });
        this._addRefreshHook(function() {
            var center = _this2._geometry._getEditCenter();
            handle.setContainerPoint(coordinatesToContainerPoint(map, center));
        });
    };
    _proto._createHandleInstance = function _createHandleInstance(containerPoint, opts) {
        opts = opts || {};
        var map = this.getMap();
        var symbol = loadFunctionTypes(opts['symbol'], function() {
            return [
                map.getZoom(),
                {
                    '{bearing}': map.getBearing(),
                    '{pitch}': map.getPitch(),
                    '{zoom}': map.getZoom()
                }
            ];
        });
        var removeVertexOn = this.options['removeVertexOn'];
        var handle = new EditHandle(this, map, {
            symbol: symbol,
            cursor: opts['cursor'],
            events: removeVertexOn,
            ignoreCollision: opts.ignoreCollision
        });
        handle.setContainerPoint(containerPoint);
        return handle;
    };
    _proto.createHandle = function createHandle(containerPoint, opts) {
        if (!opts) opts = {};
        var handle = this._createHandleInstance(containerPoint, opts);
        handle.paramOptions = opts;
        handle.on('dragstart', onHandleDragstart);
        handle.on('dragging', onHandleDragging);
        handle.on('dragend', onHandleDragEnd);
        if (opts.onRefresh) handle.refresh = opts.onRefresh;
        return handle;
    };
    _proto._createResizeHandles = function _createResizeHandles(blackList, onHandleMove, onHandleUp) {
        var _this3 = this;
        var cursors = [
            'nw-resize',
            'n-resize',
            'ne-resize',
            'w-resize',
            'e-resize',
            'sw-resize',
            's-resize',
            'se-resize'
        ];
        var axis = [
            null,
            'y',
            null,
            'x',
            'x',
            null,
            'y',
            null
        ];
        var geometry = this._geometry;
        var isMarker = geometry instanceof Marker;
        var coords = [];
        function getResizeAnchors() {
            if (isMarker) {
                var ext = geometry.getContainerExtent();
                return [
                    new Point(ext['xmin'], ext['ymin']),
                    new Point((ext['xmax'] + ext['xmin']) / 2, ext['ymin']),
                    new Point(ext['xmax'], ext['ymin']),
                    new Point(ext['xmin'], (ext['ymin'] + ext['ymax']) / 2),
                    new Point(ext['xmax'], (ext['ymin'] + ext['ymax']) / 2),
                    new Point(ext['xmin'], ext['ymax']),
                    new Point((ext['xmax'] + ext['xmin']) / 2, ext['ymax']),
                    new Point(ext['xmax'], ext['ymax'])
                ];
            }
            var coordinates = geometry.getShell();
            var editCenter = geometry._getEditCenter();
            var bbox = getDefaultBBOX();
            pointsBBOX(coordinates, bbox);
            var extent = new Extent(bbox[0], bbox[1], bbox[2], bbox[3]);
            coords = [
                new Coordinate(extent['xmin'], extent['ymax']),
                new Coordinate((extent['xmax'] + extent['xmin']) / 2, extent['ymax']),
                new Coordinate(extent['xmax'], extent['ymax']),
                new Coordinate(extent['xmin'], (extent['ymax'] + extent['ymin']) / 2),
                new Coordinate(extent['xmax'], (extent['ymax'] + extent['ymin']) / 2),
                new Coordinate(extent['xmin'], extent['ymin']),
                new Coordinate((extent['xmax'] + extent['xmin']) / 2, extent['ymin']),
                new Coordinate(extent['xmax'], extent['ymin'])
            ];
            return coords.map(function(c) {
                c.z = editCenter.z;
                return coordinatesToContainerPoint(map, c);
            });
        }
        if (!blackList) blackList = [];
        var me = this;
        var resizeHandles = [], anchorIndexes = {}, map = this.getMap(), handleSymbol = this.options['vertexHandleSymbol'];
        var fnLocateHandles = function fnLocateHandles() {
            var anchors = getResizeAnchors();
            var _loop = function _loop(i) {
                if (Array.isArray(blackList)) {
                    var isBlack = blackList.some(function(ele) {
                        return ele === i;
                    });
                    if (isBlack) return 1;
                }
                var anchor = anchors[i], point = anchor, coord = coords[i];
                if (resizeHandles.length < anchors.length - blackList.length) {
                    var handle = _this3.createHandle(point, {
                        'symbol': handleSymbol,
                        'cursor': cursors[i],
                        'axis': axis[i],
                        onMove: function(_index) {
                            return function(e) {
                                me._updating = true;
                                onHandleMove(e.containerPoint, _index);
                                geometry.fire('resizing');
                            };
                        }(i),
                        onUp: function onUp() {
                            me._updating = false;
                            onHandleUp();
                        }
                    });
                    anchorIndexes[i] = resizeHandles.length;
                    resizeHandles.push(handle);
                    handle.coord = coord;
                } else {
                    resizeHandles[anchorIndexes[i]].coord = coord;
                    resizeHandles[anchorIndexes[i]].setContainerPoint(point);
                }
            };
            for(var i = 0; i < anchors.length; i++){
                if (_loop(i)) continue;
            }
        };
        fnLocateHandles();
        this._addRefreshHook(fnLocateHandles);
        return resizeHandles;
    };
    _proto.createMarkerEditor = function createMarkerEditor() {
        var _this4 = this;
        var geometryToEdit = this._shadow || this._geometry, map = this.getMap();
        if (!geometryToEdit._canEdit()) {
            if (console) console.warn('A marker can\'t be resized with symbol:', geometryToEdit.getSymbol());
            return;
        }
        if (!this._history) this._recordHistory(getUpdates());
        var symbol = geometryToEdit._getInternalSymbol();
        var dxdy = new Point(0, 0);
        if (isNumber(symbol['markerDx'])) dxdy.x = symbol['markerDx'];
        if (isNumber(symbol['markerDy'])) dxdy.y = symbol['markerDy'];
        var blackList = null;
        var verticalAnchor = 'middle';
        var horizontalAnchor = 'middle';
        if (VectorMarkerSymbolizer.test(symbol)) {
            var type = symbol['markerType'];
            if (type === 'pin' || type === 'pie' || type === 'bar') {
                blackList = [
                    5,
                    6,
                    7
                ];
                verticalAnchor = 'bottom';
            } else if (type === 'rectangle') {
                blackList = [
                    0,
                    1,
                    2,
                    3,
                    5
                ];
                verticalAnchor = 'top';
                horizontalAnchor = 'left';
            }
        } else if (ImageMarkerSymbolizer.test(symbol) || VectorPathMarkerSymbolizer.test(symbol)) {
            verticalAnchor = 'bottom';
            blackList = [
                5,
                6,
                7
            ];
        }
        var resizeAbilities = [
            2,
            1,
            2,
            0,
            0,
            2,
            1,
            2
        ];
        var aspectRatio;
        if (this.options['fixAspectRatio']) {
            var size = geometryToEdit.getSize();
            aspectRatio = size.width / size.height;
        }
        var resizeHandles = this._createResizeHandles(blackList, function(containerPoint, i) {
            if (blackList && blackList.indexOf(i) >= 0) {
                var newCoordinates = map.containerPointToCoordinate(containerPoint.sub(dxdy));
                var coordinates = geometryToEdit.getCoordinates();
                newCoordinates.x = coordinates.x;
                geometryToEdit.setCoordinates(newCoordinates);
                _this4._updateCoordFromShadow(true);
                var mirrorHandle = resizeHandles[resizeHandles.length - 1 - i];
                var mirror = mirrorHandle.getContainerPoint();
                containerPoint = mirror;
            }
            var viewCenter = coordinatesToContainerPoint(map, geometryToEdit._getEditCenter()).add(dxdy), symbol = geometryToEdit._getInternalSymbol();
            var wh = containerPoint.sub(viewCenter);
            if (verticalAnchor === 'bottom' && containerPoint.y > viewCenter.y) wh.y = 0;
            var vr = verticalAnchor === 'middle' ? 2 : 1;
            var hr = horizontalAnchor === 'left' ? 1 : 2;
            var width = Math.abs(wh.x) * hr, height = Math.abs(wh.y) * vr;
            if (aspectRatio) {
                width = Math.max(width, height * aspectRatio);
                height = width / aspectRatio;
            }
            var ability = resizeAbilities[i];
            if (!(geometryToEdit instanceof TextBox)) {
                if (aspectRatio || ability === 0 || ability === 2) symbol['markerWidth'] = Math.min(width, _this4._geometry.options['maxMarkerWidth'] || Infinity);
                if (aspectRatio || ability === 1 || ability === 2) symbol['markerHeight'] = Math.min(height, _this4._geometry.options['maxMarkerHeight'] || Infinity);
                geometryToEdit.setSymbol(symbol);
                if (geometryToEdit !== _this4._geometry) _this4._geometry.setSymbol(symbol);
            } else {
                if (aspectRatio || ability === 0 || ability === 2) {
                    geometryToEdit.setWidth(width);
                    if (geometryToEdit !== _this4._geometry) _this4._geometry.setWidth(width);
                }
                if (aspectRatio || ability === 1 || ability === 2) {
                    geometryToEdit.setHeight(height);
                    if (geometryToEdit !== _this4._geometry) _this4._geometry.setHeight(height);
                }
            }
        }, function() {
            _this4._update(getUpdates());
        });
        function getUpdates() {
            var updates = [
                [
                    'setCoordinates',
                    geometryToEdit.getCoordinates().toArray()
                ]
            ];
            if (geometryToEdit instanceof TextBox) {
                updates.push([
                    'setWidth',
                    geometryToEdit.getWidth()
                ]);
                updates.push([
                    'setHeight',
                    geometryToEdit.getHeight()
                ]);
            } else updates.push([
                'setSymbol',
                geometryToEdit.getSymbol()
            ]);
            return updates;
        }
    };
    _proto.createCircleEditor = function createCircleEditor() {
        var _this5 = this;
        var geo = this._shadow || this._geometry;
        var map = this.getMap();
        if (!this._history) this._recordHistory([
            [
                'setCoordinates',
                geo.getCoordinates().toArray()
            ],
            [
                'setRadius',
                geo.getRadius()
            ]
        ]);
        this._createResizeHandles(null, function(handleContainerPoint) {
            var center = geo.getCenter();
            var mouseCoordinate = fixHandlePointCoordinates(geo, center, handleContainerPoint);
            var wline = new LineString([
                [
                    center.x,
                    center.y
                ],
                [
                    mouseCoordinate.x,
                    center.y
                ]
            ]);
            var hline = new LineString([
                [
                    center.x,
                    center.y
                ],
                [
                    center.x,
                    mouseCoordinate.y
                ]
            ]);
            var r = Math.max(map.computeGeometryLength(wline), map.computeGeometryLength(hline));
            geo.setRadius(r);
            if (geo !== _this5._geometry) _this5._geometry.setRadius(r);
        }, function() {
            _this5._update('setRadius', geo.getRadius());
        });
    };
    _proto.createEllipseOrRectEditor = function createEllipseOrRectEditor() {
        var _this6 = this;
        var resizeAbilities = [
            2,
            1,
            2,
            0,
            0,
            2,
            1,
            2
        ];
        var geometryToEdit = this._shadow || this._geometry;
        if (!this._history) this._recordHistory(getUpdates());
        var map = this.getMap();
        var isRect = this._geometry instanceof Rectangle;
        var aspectRatio;
        if (this.options['fixAspectRatio']) aspectRatio = geometryToEdit.getWidth() / geometryToEdit.getHeight();
        var resizeHandles = this._createResizeHandles(null, function(mouseContainerPoint, i) {
            var r = isRect ? 1 : 2;
            var pointSub, w, h;
            var handle = resizeHandles[i];
            var targetPoint = handle.getContainerPoint();
            var ability = resizeAbilities[i];
            if (isRect) {
                var mirror = resizeHandles[7 - i];
                var mirrorContainerPoint = mirror.getContainerPoint();
                pointSub = targetPoint.sub(mirrorContainerPoint);
                var absSub = pointSub.abs();
                w = map.pixelToDistance(absSub.x, 0);
                h = map.pixelToDistance(0, absSub.y);
                var size = geometryToEdit.getSize();
                var geoCoord = geometryToEdit.getCoordinates();
                var width = geometryToEdit.getWidth();
                var height = geometryToEdit.getHeight();
                var mirrorCoordinate = mirror.coord;
                var mouseCoordinate = fixHandlePointCoordinates(geometryToEdit, geoCoord, mouseContainerPoint);
                var wline = new LineString([
                    [
                        mirrorCoordinate.x,
                        mirrorCoordinate.y
                    ],
                    [
                        mouseCoordinate.x,
                        mirrorCoordinate.y
                    ]
                ]);
                var hline = new LineString([
                    [
                        mirrorCoordinate.x,
                        mirrorCoordinate.y
                    ],
                    [
                        mirrorCoordinate.x,
                        mouseCoordinate.y
                    ]
                ]);
                w = map.computeGeometryLength(wline);
                h = map.computeGeometryLength(hline);
                if (ability === 0) {
                    if (aspectRatio) {
                        absSub.y = absSub.x / aspectRatio;
                        size.height = Math.abs(absSub.y);
                        h = w / aspectRatio;
                    }
                    targetPoint.y = mirrorContainerPoint.y - size.height / 2;
                    mouseCoordinate.y = geoCoord.y;
                    if (i === 4) mouseCoordinate.x = Math.min(mouseCoordinate.x, geoCoord.x);
                    else {
                        var mirrorCoord = map.locate(geoCoord, width, 0);
                        mouseCoordinate.x = map.locate(new Coordinate(mirrorCoord.x, mouseCoordinate.y), -w, 0).x;
                    }
                } else if (ability === 1) {
                    if (aspectRatio) {
                        absSub.x = absSub.y * aspectRatio;
                        size.width = Math.abs(absSub.x);
                        w = h * aspectRatio;
                    }
                    targetPoint.x = mirrorContainerPoint.x - size.width / 2;
                    mouseCoordinate.x = geoCoord.x;
                    mouseCoordinate.y = Math.max(mouseCoordinate.y, mirrorCoordinate.y);
                } else {
                    if (aspectRatio) {
                        if (w > h * aspectRatio) {
                            h = w / aspectRatio;
                            targetPoint.y = mirrorContainerPoint.y + absSub.x * sign(pointSub.y) / aspectRatio;
                        } else {
                            w = h * aspectRatio;
                            targetPoint.x = mirrorContainerPoint.x + absSub.y * sign(pointSub.x) * aspectRatio;
                        }
                    }
                    if (i === 0 || i === 5) {
                        var _mirrorCoord = i === 0 ? map.locate(geoCoord, width, 0) : map.locate(geoCoord, width, -height);
                        mouseCoordinate.x = map.locate(new Coordinate(_mirrorCoord.x, mouseCoordinate.y), -w, 0).x;
                    } else mouseCoordinate.x = Math.min(mouseCoordinate.x, mirrorCoordinate.x);
                    mouseCoordinate.y = Math.max(mouseCoordinate.y, mirrorCoordinate.y);
                }
                mouseCoordinate.z = geoCoord.z;
                geometryToEdit.setCoordinates(mouseCoordinate);
                _this6._updateCoordFromShadow(true);
            } else {
                var center = geometryToEdit.getCenter();
                var _mouseCoordinate = fixHandlePointCoordinates(geometryToEdit, center, mouseContainerPoint);
                var _wline = new LineString([
                    [
                        center.x,
                        center.y
                    ],
                    [
                        _mouseCoordinate.x,
                        center.y
                    ]
                ]);
                var _hline = new LineString([
                    [
                        center.x,
                        center.y
                    ],
                    [
                        center.x,
                        _mouseCoordinate.y
                    ]
                ]);
                w = map.computeGeometryLength(_wline);
                h = map.computeGeometryLength(_hline);
                if (aspectRatio) {
                    w = Math.max(w, h * aspectRatio);
                    h = w / aspectRatio;
                }
            }
            if (aspectRatio || ability === 0 || ability === 2) {
                geometryToEdit.setWidth(w * r);
                if (geometryToEdit !== _this6._geometry) _this6._geometry.setWidth(w * r);
            }
            if (aspectRatio || ability === 1 || ability === 2) {
                geometryToEdit.setHeight(h * r);
                if (geometryToEdit !== _this6._geometry) _this6._geometry.setHeight(h * r);
            }
        }, function() {
            _this6._update(getUpdates());
        });
        function getUpdates() {
            return [
                [
                    'setCoordinates',
                    geometryToEdit.getCoordinates().toArray()
                ],
                [
                    'setWidth',
                    geometryToEdit.getWidth()
                ],
                [
                    'setHeight',
                    geometryToEdit.getHeight()
                ]
            ];
        }
    };
    _proto.createPolygonEditor = function createPolygonEditor() {
        var map = this.getMap(), geoToEdit = this._shadow || this._geometry, me = this;
        if (!this._history) this._recordHistory('setCoordinates', Coordinate.toNumberArrays(geoToEdit.getCoordinates()));
        var verticeLimit = geoToEdit instanceof Polygon ? 3 : 2;
        var propertyOfVertexIndex = 'maptalks--editor-vertex-index';
        var { vertexZIndex: vertexZIndex, newVertexZIndex: newVertexZIndex } = this.options;
        var vertexHandles = {
            0: []
        }, newVertexHandles = {
            0: []
        };
        function updatePolyCoordinates(coordinates, ringIndex) {
            if (geoToEdit instanceof Polygon) {
                var rings = geoToEdit.getCoordinates();
                rings[ringIndex] = coordinates;
                geoToEdit.setCoordinates(rings);
            } else geoToEdit.setCoordinates(coordinates);
        }
        function getVertexCoordinates(ringIndex = 0) {
            if (geoToEdit instanceof Polygon) {
                var coordinates = geoToEdit.getCoordinates()[ringIndex] || [];
                return coordinates.slice(0, coordinates.length - 1);
            } else return geoToEdit.getCoordinates();
        }
        function onVertexAddOrRemove() {
            for(var ringIndex in vertexHandles){
                for(var i = vertexHandles[ringIndex].length - 1; i >= 0; i--)vertexHandles[ringIndex][i][propertyOfVertexIndex] = i;
                for(var _i = newVertexHandles[ringIndex].length - 1; _i >= 0; _i--)newVertexHandles[ringIndex][_i][propertyOfVertexIndex] = _i;
            }
            me._updateCoordFromShadow();
        }
        function removeVertex(param) {
            me._updating = true;
            var handle = param['target'], index = handle[propertyOfVertexIndex];
            var ringIndex = isNumber(handle._ringIndex) ? handle._ringIndex : 0;
            var coordinates = getVertexCoordinates(ringIndex);
            if (coordinates.length <= verticeLimit) {
                console.warn(" Geometry." + geoToEdit.type + " Require at least " + verticeLimit + " vertices,Geometry: ", geoToEdit);
                return;
            }
            coordinates.splice(index, 1);
            updatePolyCoordinates(coordinates, ringIndex);
            if (index === 0) {
                newVertexHandles[ringIndex][0]["delete"]();
                newVertexHandles[ringIndex].splice(0, 1);
            } else if (index === vertexHandles[ringIndex].length - 1) {
                var len = newVertexHandles[ringIndex].length;
                newVertexHandles[ringIndex][len - 1]["delete"]();
                newVertexHandles[ringIndex].splice(len - 1, 1);
            } else {
                newVertexHandles[ringIndex][index - 1]["delete"]();
                newVertexHandles[ringIndex].splice(index - 1, 1);
                newVertexHandles[ringIndex][index - 1]["delete"]();
                newVertexHandles[ringIndex].splice(index - 1, 1);
                newVertexHandles[ringIndex].splice(index - 1, 0, createNewVertexHandle.call(me, index - 1, ringIndex));
            }
            vertexHandles[ringIndex].splice(index, 1)[0]["delete"]();
            if (ringIndex > 0) {
                var coordiantes = geoToEdit.getCoordinates();
                var ring = coordiantes[ringIndex];
                if (ring && Array.isArray(ring) && ring.length > 1) {
                    if (geoToEdit !== this._geometry) geoToEdit.setCoordinates(coordiantes);
                }
            }
            onVertexAddOrRemove();
            me._updating = false;
            me._geometry.fire('handleremove', Object.assign({}, param, {
                coordinate: map.containerPointToCoordinate(param.containerPoint),
                vertex: param.target
            }));
        }
        function moveVertexHandle(handleConatainerPoint, index, ringIndex = 0) {
            var snapTo = me._geometry.snapTo;
            if (snapTo && isFunction(snapTo)) handleConatainerPoint = me._geometry.snapTo(handleConatainerPoint) || handleConatainerPoint;
            var coordinates = getVertexCoordinates(ringIndex);
            var containerPoint = handleConatainerPoint.sub(getDxDy());
            var coordinate = fixHandlePointCoordinates(me._geometry, coordinates[index], containerPoint);
            var vertex = coordinates[index];
            vertex.x = coordinate.x;
            vertex.y = coordinate.y;
            geoToEdit.setCoordinates(geoToEdit.getCoordinates());
            me._updateCoordFromShadow(true);
            var nextIndex;
            if (index === 0) nextIndex = newVertexHandles[ringIndex].length - 1;
            else nextIndex = index - 1;
            if (newVertexHandles[ringIndex][index]) newVertexHandles[ringIndex][index].refresh();
            if (newVertexHandles[ringIndex][nextIndex]) newVertexHandles[ringIndex][nextIndex].refresh();
        }
        var hanldeDxdy = new Point(0, 0);
        function getDxDy() {
            var compiledSymbol = geoToEdit._getCompiledSymbol();
            hanldeDxdy.x = compiledSymbol.lineDx || 0;
            hanldeDxdy.y = compiledSymbol.lineDy || 0;
            return hanldeDxdy;
        }
        function createVertexHandle(index, ringIndex = 0, ringCoordinates) {
            var vertex = (ringCoordinates || getVertexCoordinates(ringIndex))[index];
            var containerPoint = coordinatesToContainerPoint(map, vertex)._add(getDxDy());
            var handle = me.createHandle(containerPoint, {
                'symbol': me.options['vertexHandleSymbol'],
                'cursor': 'pointer',
                'axis': null,
                onMove: function onMove() {
                    moveVertexHandle(handle.getContainerPoint(), handle[propertyOfVertexIndex], ringIndex);
                },
                onRefresh: function onRefresh(rIndex, ringCoordinates) {
                    vertex = (ringCoordinates || getVertexCoordinates(ringIndex))[handle[propertyOfVertexIndex]];
                    if (vertex) {
                        var _containerPoint = coordinatesToContainerPoint(map, vertex);
                        handle.setContainerPoint(_containerPoint._add(getDxDy()));
                    }
                },
                onUp: function onUp() {
                    me._updateCoordFromShadow();
                },
                onDown: function onDown(param, e) {
                    if (e && e.domEvent && e.domEvent.button === 2) return;
                }
            });
            handle[propertyOfVertexIndex] = index;
            handle._ringIndex = ringIndex;
            handle.on(me.options['removeVertexOn'], removeVertex);
            handle.setZIndex(vertexZIndex);
            return handle;
        }
        var pauseRefresh = false;
        function createNewVertexHandle(index, ringIndex = 0, ringCoordinates) {
            var vertexCoordinates = ringCoordinates || getVertexCoordinates(ringIndex);
            var nextVertex;
            if (index + 1 >= vertexCoordinates.length) nextVertex = vertexCoordinates[0];
            else nextVertex = vertexCoordinates[index + 1];
            var vertex = vertexCoordinates[index].add(nextVertex).multi(0.5);
            var handle = me.createHandle(vertex, {
                'symbol': me.options['newVertexHandleSymbol'],
                'cursor': 'pointer',
                'axis': null,
                onDown: function onDown(param, e) {
                    if (e && e.domEvent && e.domEvent.button === 2) return;
                    var coordinates = getVertexCoordinates(ringIndex);
                    var vertexIndex = handle[propertyOfVertexIndex];
                    var preCoordinate = coordinates[vertexIndex];
                    var nextCoordinate = coordinates[vertexIndex + 1] || coordinates[0];
                    var middleCoordinate = preCoordinate.add(nextCoordinate).multi(0.5);
                    coordinates.splice(vertexIndex + 1, 0, middleCoordinate);
                    updatePolyCoordinates(coordinates, ringIndex);
                    handle.opacity = 1;
                    newVertexHandles[ringIndex].splice(vertexIndex, 0, createNewVertexHandle.call(me, vertexIndex, ringIndex), createNewVertexHandle.call(me, vertexIndex + 1, ringIndex));
                    pauseRefresh = true;
                },
                onMove: function onMove() {
                    moveVertexHandle(handle.getContainerPoint(), handle[propertyOfVertexIndex] + 1, ringIndex);
                },
                onUp: function onUp(e) {
                    if (e && e.domEvent && e.domEvent.button === 2) {
                        pauseRefresh = false;
                        return;
                    }
                    var vertexIndex = handle[propertyOfVertexIndex];
                    removeFromArray(handle, newVertexHandles[ringIndex]);
                    handle["delete"]();
                    vertexHandles[ringIndex].splice(vertexIndex, 0, createVertexHandle.call(me, vertexIndex, ringIndex));
                    onVertexAddOrRemove();
                    me._updateCoordFromShadow();
                    pauseRefresh = false;
                },
                onRefresh: function onRefresh(rIndex, ringCoordinates) {
                    vertexCoordinates = ringCoordinates || getVertexCoordinates(rIndex);
                    var vertexIndex = handle[propertyOfVertexIndex];
                    var nextIndex;
                    if (vertexIndex === vertexCoordinates.length - 1) nextIndex = 0;
                    else nextIndex = vertexIndex + 1;
                    if (vertexCoordinates[vertexIndex] && vertexCoordinates[nextIndex]) {
                        var refreshVertex = vertexCoordinates[vertexIndex].add(vertexCoordinates[nextIndex]).multi(0.5);
                        var containerPoint = coordinatesToContainerPoint(map, refreshVertex);
                        handle.setContainerPoint(containerPoint._add(getDxDy()));
                    }
                }
            });
            handle[propertyOfVertexIndex] = index;
            handle.setZIndex(newVertexZIndex);
            return handle;
        }
        if (geoToEdit instanceof Polygon) {
            var rings = geoToEdit.getHoles().length + 1;
            for(var ringIndex = 0; ringIndex < rings; ringIndex++){
                vertexHandles[ringIndex] = [];
                newVertexHandles[ringIndex] = [];
                var vertexCoordinates = getVertexCoordinates(ringIndex);
                for(var i = 0, len = vertexCoordinates.length; i < len; i++){
                    vertexHandles[ringIndex].push(createVertexHandle.call(this, i, ringIndex, vertexCoordinates));
                    if (i < len - 1) newVertexHandles[ringIndex].push(createNewVertexHandle.call(this, i, ringIndex, vertexCoordinates));
                }
                newVertexHandles[ringIndex].push(createNewVertexHandle.call(this, vertexCoordinates.length - 1, ringIndex, vertexCoordinates));
            }
        } else {
            var _ringIndex = 0;
            var _vertexCoordinates = getVertexCoordinates(_ringIndex);
            for(var _i2 = 0, _len = _vertexCoordinates.length; _i2 < _len; _i2++){
                vertexHandles[_ringIndex].push(createVertexHandle.call(this, _i2, _ringIndex, _vertexCoordinates));
                if (_i2 < _len - 1) newVertexHandles[_ringIndex].push(createNewVertexHandle.call(this, _i2, _ringIndex, _vertexCoordinates));
            }
            if (newVertexHandles[_ringIndex].length && geoToEdit.getCoordinates().length === 2) newVertexHandles[_ringIndex][0].options.symbol['markerDx'] = 12;
        }
        var renderer = map.getRenderer();
        if (renderer) renderer.sortTopElements();
        this._addRefreshHook(function() {
            if (pauseRefresh) return;
            for(var _ringIndex2 in newVertexHandles){
                var ringCoordinates = getVertexCoordinates(_ringIndex2);
                for(var _i3 = newVertexHandles[_ringIndex2].length - 1; _i3 >= 0; _i3--)newVertexHandles[_ringIndex2][_i3].refresh(_ringIndex2, ringCoordinates);
            }
            if (newVertexHandles[0].length && geoToEdit instanceof LineString) {
                if (geoToEdit.getCoordinates().length === 2) newVertexHandles[0][0].options.symbol['markerDx'] = 12;
                else if (geoToEdit.getCoordinates().length > 2) newVertexHandles[0][0].options.symbol['markerDx'] = 0;
            }
            for(var _ringIndex3 in vertexHandles){
                var _ringCoordinates = getVertexCoordinates(_ringIndex3);
                for(var _i4 = vertexHandles[_ringIndex3].length - 1; _i4 >= 0; _i4--)vertexHandles[_ringIndex3][_i4].refresh(_ringIndex3, _ringCoordinates);
            }
        });
    };
    _proto._refresh = function _refresh() {
        if (this._refreshHooks) for(var i = this._refreshHooks.length - 1; i >= 0; i--)this._refreshHooks[i].call(this);
    };
    _proto._hideContext = function _hideContext() {
        if (this._geometry) {
            this._geometry.closeMenu();
            this._geometry.closeInfoWindow();
        }
    };
    _proto._addRefreshHook = function _addRefreshHook(fn) {
        if (!fn) return;
        if (!this._refreshHooks) this._refreshHooks = [];
        this._refreshHooks.push(fn);
    };
    _proto._update = function _update(method, ...args) {
        this._exeHistory([
            method,
            args
        ]);
        this._recordHistory(method, ...args);
    };
    _proto._updateCoordFromShadow = function _updateCoordFromShadow(ignoreRecord) {
        var geoToEdit = this._shadow || this._geometry;
        var coords = geoToEdit.getCoordinates();
        var geo = this._geometry;
        var updating = this._updating;
        this._updating = true;
        geo.setCoordinates(coords);
        if (!ignoreRecord) this._recordHistory('setCoordinates', Coordinate.toNumberArrays(geo.getCoordinates()));
        this._updating = updating;
    };
    _proto._recordHistory = function _recordHistory(method, ...args) {
        if (!this._history) {
            this._history = [];
            this._historyPointer = 0;
        }
        if (this._history.length) {
            var lastOperation = this._history[this._history.length - 1];
            if (lastOperation[0] === method && JSON.stringify(lastOperation[1]) === JSON.stringify(args)) return;
        }
        if (this._historyPointer < this._history.length - 1) this._history.splice(this._historyPointer + 1);
        this._history.push([
            method,
            args
        ]);
        this._historyPointer = this._history.length - 1;
        this._geometry.fire('editrecord');
    };
    _proto.cancel = function cancel() {
        if (!this._history || this._historyPointer === 0) return this;
        this._historyPointer = 0;
        var record = this._history[0];
        this._exeAndReset(record);
        return this;
    };
    _proto.undo = function undo() {
        if (this._isundoEdit()) return this;
        var record = this._history[--this._historyPointer];
        this._exeAndReset(record);
        return this;
    };
    _proto.redo = function redo() {
        if (this._isRedoEdit()) return this;
        var record = this._history[++this._historyPointer];
        this._exeAndReset(record);
        return this;
    };
    _proto._exeAndReset = function _exeAndReset(record) {
        if (this._updating) return;
        this._exeHistory(record);
        var history = this._history, pointer = this._historyPointer;
        this.stop();
        this._history = history;
        this._historyPointer = pointer;
        this.start();
    };
    _proto._onDragStart = function _onDragStart() {
        this._updating = true;
    };
    _proto._onDragEnd = function _onDragEnd() {
        this._updating = false;
    };
    _proto._exeHistory = function _exeHistory(record) {
        if (!Array.isArray(record)) return;
        var updating = this._updating;
        this._updating = true;
        var geoToEdit = this._shadow || this._geometry;
        var geo = this._geometry;
        if (Array.isArray(record[0])) record[0].forEach(function(o) {
            var m = o[0], args = o.slice(1);
            geoToEdit[m].call(geoToEdit, ...args);
            if (geoToEdit !== geo) geo[m].call(geo, ...args);
        });
        else {
            geoToEdit[record[0]].call(geoToEdit, ...record[1]);
            if (geoToEdit !== geo) geo[record[0]].call(geo, ...record[1]);
        }
        this._updating = updating;
    };
    _proto._isRedoEdit = function _isRedoEdit() {
        if (!this._history || this._historyPointer === this._history.length - 1) return true;
        return false;
    };
    _proto._isundoEdit = function _isundoEdit() {
        if (!this._history || this._historyPointer === 0) return true;
        return false;
    };
    return GeometryEditor;
}(Eventable(Class));
GeometryEditor.mergeOptions(options);
var TextEditable = {
    startEditText: function startEditText() {
        if (!this.getMap()) return this;
        this._recordVisible();
        this.hide();
        this.endEditText();
        this._prepareEditor();
        this._fireEvent('edittextstart');
        return this;
    },
    endEditText: function endEditText() {
        if (this._textEditor) {
            var html = this._textEditor.innerHTML;
            html = html.replace(/<p>/ig, '').replace(/<\/p>/ig, '<br/>');
            this._textEditor.innerHTML = html;
            var content = this._textEditor.innerText.replace(/[\r\n]+$/gi, '');
            this.setContent(content);
            off(this._textEditor, 'mousedown dblclick', stopPropagation);
            this.getMap().off('mousedown', this.endEditText, this);
            this._editUIMarker.remove();
            delete this._editUIMarker;
            this._textEditor.onkeyup = null;
            delete this._textEditor;
            this._recoveryVisible();
            this.show();
            this._fireEvent('edittextend');
        }
        return this;
    },
    isEditingText: function isEditingText() {
        if (this._textEditor) return true;
        return false;
    },
    getTextEditor: function getTextEditor() {
        return this._editUIMarker;
    },
    _prepareEditor: function _prepareEditor() {
        var map = this.getMap();
        var editContainer = this._createEditor();
        this._textEditor = editContainer;
        map.on('mousedown', this.endEditText, this);
        var offset = this._getEditorOffset();
        this._editUIMarker = new UIMarker(this.getCoordinates(), {
            'animation': null,
            'content': editContainer,
            'dx': offset.dx,
            'dy': offset.dy
        }).addTo(map);
        this._setCursorToLast(this._textEditor);
    },
    _getEditorOffset: function _getEditorOffset() {
        var symbol = this._getInternalSymbol() || {};
        var dx = 0, dy = 0;
        var textAlign = symbol['textHorizontalAlignment'];
        if (textAlign === 'middle' || isNil(textAlign)) {
            dx = (symbol['textDx'] || 0) - 2;
            dy = (symbol['textDy'] || 0) - 2;
        } else {
            dx = (symbol['markerDx'] || 0) - 2;
            dy = (symbol['markerDy'] || 0) - 2;
        }
        return {
            'dx': dx,
            'dy': dy
        };
    },
    _createEditor: function _createEditor() {
        var content = this.getContent();
        var labelSize = this.getSize(), symbol = this._getInternalSymbol() || {}, width = labelSize.width, textColor = symbol['textFill'] || '#000000', textSize = symbol['textSize'] || 12, height = labelSize.height, lineColor = symbol['markerLineColor'] || '#000', fill = symbol['markerFill'] || '#3398CC', spacing = symbol['textLineSpacing'] || 0;
        var editor = createEl('div');
        editor.contentEditable = true;
        editor.style.cssText = "background:" + fill + "; border:1px solid " + lineColor + ";\n            color:" + textColor + ";font-size:" + textSize + "px;width:" + (width - 2) + "px;height:" + (height - 2) + "px;margin: auto;\n            line-height:" + (textSize + spacing) + "px;outline: 0; padding:0; margin:0;word-wrap: break-word;\n            overflow: hidden;-webkit-user-modify: read-write-plaintext-only;";
        editor.innerText = content;
        on(editor, 'mousedown dblclick', stopPropagation);
        editor.onkeyup = function(event) {
            var h = editor.style.height || 0;
            if (event.keyCode === 13) editor.style.height = parseInt(h) + textSize / 2 + 'px';
        };
        return editor;
    },
    _setCursorToLast: function _setCursorToLast(obj) {
        var range;
        if (window.getSelection) {
            obj.focus();
            range = window.getSelection();
            range.selectAllChildren(obj);
            range.collapseToEnd();
        } else if (document.selection) {
            range = document.selection.createRange();
            range.moveToElementText(obj);
            range.collapse(false);
            range.select();
        }
    }
};
TextMarker.include(TextEditable);
Geometry.include({
    animate: function animate(styles, options, step) {
        var _this = this;
        if (this._animPlayer) this._animPlayer.finish();
        if (isFunction(options)) step = options;
        if (!options) options = {};
        var map = this.getMap(), projection = this._getProjection(), stylesToAnimate = this._prepareAnimationStyles(styles);
        var preTranslate;
        var isFocusing = options['focus'];
        delete this._animationStarted;
        if (map) {
            var renderer = map._getRenderer();
            var framer = function framer(fn) {
                renderer.callInNextFrame(fn);
            };
            options['framer'] = framer;
        }
        if (!projection && isFocusing) {
            console.error(GEOMETRY_NOT_FIND_PROJECTION);
            return;
        }
        var player = Animation.animate(stylesToAnimate, options, function(frame) {
            if (map && map.isRemoved()) {
                player.finish();
                return;
            }
            if (map && !_this._animationStarted && isFocusing) map.onMoveStart();
            var styles = frame.styles;
            for(var p in styles)if (p !== 'symbol' && p !== 'translate' && styles.hasOwnProperty(p)) {
                var fnName = 'set' + p[0].toUpperCase() + p.slice(1);
                _this[fnName](styles[p]);
            }
            var translate = styles['translate'];
            if (translate) {
                var toTranslate = translate;
                if (preTranslate) toTranslate = translate.sub(preTranslate);
                preTranslate = translate;
                _this.translate(toTranslate);
            }
            var dSymbol = styles['symbol'];
            if (dSymbol) {
                var symbol = _this.getSymbol() || {};
                _this.setSymbol(extendSymbol(symbol, dSymbol));
            }
            if (map && isFocusing) {
                var pcenter = projection.project(_this.getCenter());
                map._setPrjCenter(pcenter);
                var e = map._parseEventFromCoord(projection.unproject(pcenter));
                if (player.playState !== 'running') map.onMoveEnd(e);
                else map.onMoving(e);
            }
            _this._fireAnimateEvent(player.playState);
            if (step) step(frame);
        }, this);
        this._animPlayer = player;
        return this._animPlayer.play();
    },
    _prepareAnimationStyles: function _prepareAnimationStyles(styles) {
        var symbol = this._getInternalSymbol();
        var stylesToAnimate = {};
        for(var p in styles)if (styles.hasOwnProperty(p)) {
            var v = styles[p];
            if (p !== 'translate' && p !== 'symbol') {
                var fnName = 'get' + p[0].toUpperCase() + p.substring(1);
                var current = this[fnName]();
                stylesToAnimate[p] = [
                    current,
                    v
                ];
            } else if (p === 'symbol') {
                var symbolToAnimate = void 0;
                if (Array.isArray(styles['symbol'])) {
                    if (!Array.isArray(symbol)) throw new Error('geometry\'symbol isn\'t a composite symbol, while the symbol in styles is.');
                    symbolToAnimate = [];
                    var symbolInStyles = styles['symbol'];
                    for(var i = 0; i < symbolInStyles.length; i++){
                        if (!symbolInStyles[i]) {
                            symbolToAnimate.push(null);
                            continue;
                        }
                        var a = {};
                        for(var sp in symbolInStyles[i])if (symbolInStyles[i].hasOwnProperty(sp)) a[sp] = [
                            symbol[i][sp],
                            symbolInStyles[i][sp]
                        ];
                        symbolToAnimate.push(a);
                    }
                } else {
                    if (Array.isArray(symbol)) throw new Error('geometry\'symbol is a composite symbol, while the symbol in styles isn\'t.');
                    symbolToAnimate = {};
                    for(var _sp in v)if (v.hasOwnProperty(_sp)) symbolToAnimate[_sp] = [
                        symbol[_sp],
                        v[_sp]
                    ];
                }
                stylesToAnimate['symbol'] = symbolToAnimate;
            } else if (p === 'translate') stylesToAnimate['translate'] = new Coordinate(v);
        }
        return stylesToAnimate;
    },
    _fireAnimateEvent: function _fireAnimateEvent(playState) {
        if (playState === 'finished') {
            delete this._animationStarted;
            this._fireEvent('animateend');
        } else if (playState === 'running') {
            if (this._animationStarted) this._fireEvent('animating');
            else {
                this._fireEvent('animatestart');
                this._animationStarted = true;
            }
        }
    }
});
var DRAG_STAGE_LAYER_ID = INTERNAL_LAYER_PREFIX + '_drag_stage';
var EVENTS = Browser$1.touch ? 'touchstart mousedown' : 'mousedown';
function fixDragPointCoordinates(geometry, dragContainerPoint, dragCoordinates) {
    var editCenter = geometry._getEditCenter();
    var map = geometry.getMap();
    if (!editCenter || editCenter.z === 0) return dragCoordinates || map.containerPointToCoord(dragContainerPoint);
    var altitude = editCenter.z;
    var glRes = map.getGLRes();
    var renderPoints = map.coordToPointAtRes(editCenter, glRes);
    var point1 = map._pointAtResToContainerPoint(renderPoints, glRes, 0);
    var point2 = map._pointAtResToContainerPoint(renderPoints, glRes, altitude);
    var offset = point2.sub(point1);
    var containerPoint = dragContainerPoint.sub(offset);
    var coordiantes = map.containerPointToCoord(containerPoint);
    coordiantes.z = 0;
    var isPoint = !geometry.getGeometries && geometry.isPoint;
    if (isPoint) coordiantes.z = altitude;
    return coordiantes;
}
var GeometryDragHandler = function(_Handler) {
    function GeometryDragHandler(target) {
        return _Handler.call(this, target) || this;
    }
    _inheritsLoose(GeometryDragHandler, _Handler);
    var _proto = GeometryDragHandler.prototype;
    _proto.addHooks = function addHooks() {
        this.target.on(EVENTS, this._startDrag, this);
    };
    _proto.removeHooks = function removeHooks() {
        this._endDrag();
        this.target.off(EVENTS, this._startDrag, this);
        delete this.container;
    };
    _proto._prepareDragHandler = function _prepareDragHandler() {
        this._dragHandler = new DragHandler(this.container);
        this._dragHandler.on('dragging', this._dragging, this).on('mouseup', this._endDrag, this).enable();
    };
    _proto._prepareShadow = function _prepareShadow() {
        var _this = this;
        var target = this.target;
        var needShadow = target.getLayer().options['renderer'] === 'canvas';
        if (!needShadow) return;
        if (!target.options.dragShadow) return;
        this._prepareDragStageLayer();
        if (this._shadow) this._shadow.remove();
        var shadow = this._shadow = target.copy();
        if (shadow.getGeometries) {
            var shadows = shadow.getGeometries();
            var geos = target.getGeometries();
            shadows.forEach(function(g, i) {
                _this._updateShadowSymbol(g, geos[i]);
            });
        } else this._updateShadowSymbol(shadow, target);
        shadow.setId(null);
        this._prepareShadowConnectors();
    };
    _proto._updateShadowSymbol = function _updateShadowSymbol(shadow, target) {
        shadow.setSymbol(target._getInternalSymbol());
        if (target.options['dragShadow']) {
            var symbol = lowerSymbolOpacity(shadow._getInternalSymbol(), 0.5);
            shadow.setSymbol(symbol);
        }
    };
    _proto._prepareShadowConnectors = function _prepareShadowConnectors() {
        var target = this.target;
        var shadow = this._shadow;
        var resources = this._dragStageLayer._getRenderer().resources;
        var shadowConnectors = [];
        if (ConnectorLine._hasConnectors(target)) {
            var connectors = ConnectorLine._getConnectors(target);
            for(var i = 0, l = connectors.length; i < l; i++){
                var targetConn = connectors[i];
                var connOptions = targetConn.config(), connSymbol = targetConn._getInternalSymbol();
                connOptions['symbol'] = lowerSymbolOpacity(connSymbol, 0.5);
                var conn = void 0;
                if (targetConn.getConnectSource() === target) conn = new targetConn.constructor(shadow, targetConn.getConnectTarget(), connOptions);
                else conn = new targetConn.constructor(targetConn.getConnectSource(), shadow, connOptions);
                shadowConnectors.push(conn);
                if (targetConn.getLayer() && targetConn.getLayer()._getRenderer()) resources.merge(targetConn.getLayer()._getRenderer().resources);
            }
        }
        this._shadowConnectors = shadowConnectors;
        shadowConnectors.push(shadow);
        this._dragStageLayer.bringToFront().addGeometry(shadowConnectors);
    };
    _proto._onTargetUpdated = function _onTargetUpdated() {
        if (this._shadow) this._shadow.setSymbol(this.target._getSymbol());
    };
    _proto._prepareDragStageLayer = function _prepareDragStageLayer() {
        var map = this.target.getMap(), layer = this.target.getLayer();
        var prevLayer = map.getLayer(DRAG_STAGE_LAYER_ID);
        if (prevLayer) prevLayer.remove();
        var layerClazz = layer.constructor;
        this._dragStageLayer = new layerClazz(DRAG_STAGE_LAYER_ID, {
            enableAltitude: layer.options['enableAltitude'],
            altitudeProperty: layer.options['altitudeProperty']
        });
        map.addLayer(this._dragStageLayer);
        var resources = getResouceCacheInstance();
        resources.merge(layer._getRenderer().resources);
        this._dragStageLayer._getRenderer().resources = resources;
    };
    _proto._startDrag = function _startDrag(param) {
        var map = this.target.getMap();
        if (!map) return;
        var parent = this.target._getParent();
        if (parent) return;
        if (this.isDragging()) return;
        var domEvent = param['domEvent'];
        if (domEvent.touches && domEvent.touches.length > 1 || domEvent.button === 2) return;
        this.container = map.getPanels().mapWrapper || map.getContainer();
        this.target.on('click', this._endDrag, this);
        var coordinates = this._correctCoord(param['coordinate']);
        this._lastCoord = fixDragPointCoordinates(this.target, param['containerPoint'], coordinates);
        this._lastPoint = param['containerPoint'];
        this._prepareDragHandler();
        this._dragHandler.onMouseDown(param['domEvent']);
        on(this.container, 'mouseleave', this._endDrag, this);
        this._startParam = param;
        this._moved = false;
        return;
    };
    _proto._dragging = function _dragging(param) {
        var target = this.target;
        var map = target.getMap();
        if (map._isEventOutMap(param['domEvent'])) return;
        var e = map._parseEvent(param['domEvent']);
        var domEvent = e['domEvent'];
        if (domEvent.touches && domEvent.touches.length > 1) return;
        if (map._isContainerPointOutOfMap(e.containerPoint)) return;
        if (!this._moved) {
            this._moved = true;
            target.on('symbolchange', this._onTargetUpdated, this);
            this._isDragging = true;
            this._prepareShadow();
            if (this._shadow) {
                if (!target.options['dragShadow']) target.hide();
                this._shadow._fireEvent('dragstart', e);
            }
            this.target._fireEvent('dragstart', this._startParam || e);
            delete this._startParam;
            return;
        }
        var geo = this._shadow || target;
        var axis = geo.options['dragOnAxis'], dragOnScreenAxis = geo.options['dragOnScreenAxis'], point = e['containerPoint'];
        var coord = e['coordinate'];
        this._lastPoint = this._lastPoint || point;
        this._lastCoord = this._lastCoord || coord;
        if (dragOnScreenAxis) {
            if (axis === 'x') point.y = this._lastPoint.y;
            else if (axis === 'y') point.x = this._lastPoint.x;
            coord = map.containerPointToCoord(point);
        } else coord = this._correctCoord(coord);
        coord = fixDragPointCoordinates(target, e['containerPoint'], coord);
        var pointOffset = point.sub(this._lastPoint);
        var coordOffset = coord.sub(this._lastCoord);
        if (!dragOnScreenAxis) {
            if (axis === 'x') pointOffset.y = coordOffset.y = 0;
            else if (axis === 'y') pointOffset.x = coordOffset.x = 0;
        }
        this._lastPoint = point;
        this._lastCoord = coord;
        var isPoint = !geo.getGeometries && geo.isPoint;
        isPoint ? geo.setCoordinates(coord) : geo.translate(coordOffset);
        if (geo !== target && !target.options['dragShadow']) isPoint ? target.setCoordinates(coord) : target.translate(coordOffset);
        e['coordOffset'] = coordOffset;
        e['pointOffset'] = pointOffset;
        geo._fireEvent('dragging', e);
        if (geo !== target) target._fireEvent('dragging', e);
    };
    _proto._endDrag = function _endDrag(param) {
        if (this._dragHandler) {
            this._dragHandler.disable();
            delete this._dragHandler;
        }
        if (this.container) off(this.container, 'mouseleave', this._endDrag);
        if (!this.target) return;
        var target = this.target;
        target.off('click', this._endDrag, this);
        target.off('symbolchange', this._onTargetUpdated, this);
        delete this._lastCoord;
        delete this._lastPoint;
        this._isDragging = false;
        var map = target.getMap();
        if (this.enabled() && map) {
            var e = map._parseEvent(param ? param['domEvent'] : null);
            this._updateTargetAndRemoveShadow(e);
            if (this._moved) target._fireEvent('dragend', e);
        }
    };
    _proto.isDragging = function isDragging() {
        if (!this._isDragging) return false;
        return true;
    };
    _proto._updateTargetAndRemoveShadow = function _updateTargetAndRemoveShadow(eventParam) {
        if (!this._shadow) return;
        var target = this.target, map = target.getMap();
        if (!target.options['dragShadow']) target.show();
        var shadow = this._shadow;
        if (shadow) {
            if (target.options['dragShadow']) {
                var shadowFirst = shadow.getFirstCoordinate();
                var first = target.getFirstCoordinate();
                var offset = shadowFirst.sub(first);
                target.translate(offset);
            }
            shadow._fireEvent('dragend', eventParam);
            shadow.remove();
            delete this._shadow;
        }
        if (this._shadowConnectors) {
            map.getLayer(DRAG_STAGE_LAYER_ID).removeGeometry(this._shadowConnectors);
            delete this._shadowConnectors;
        }
        if (this._dragStageLayer) {
            this._dragStageLayer._getRenderer().resources = getResouceCacheInstance();
            this._dragStageLayer.remove();
        }
    };
    _proto._correctCoord = function _correctCoord(coord) {
        var map = this.target.getMap();
        if (!map.getPitch()) return coord;
        var target = this.target;
        if (!target.getMinAltitude()) return coord;
        var alt = (target.getMinAltitude() + target.getMaxAltitude()) / 2;
        return map.locateByPoint(coord, 0, -alt);
    };
    return GeometryDragHandler;
}(Handler);
Geometry.mergeOptions({
    'draggable': false,
    'dragShadow': true,
    'dragOnAxis': null,
    'dragOnScreenAxis': false
});
Geometry.addInitHook('addHandler', 'draggable', GeometryDragHandler);
Geometry.include({
    isDragging: function isDragging() {
        if (this._getParent()) return this._getParent().isDragging();
        if (this['draggable']) return this['draggable'].isDragging();
        return false;
    }
});
Geometry.include({
    startEdit: function startEdit(opts) {
        var map = this.getMap();
        if (!map || !this.options['editable']) return this;
        if (this._editor) this.endEdit();
        this._recordVisible();
        this._editor = new GeometryEditor(this, opts);
        this._editor.start();
        if (!this._getParent()) this.fire('editstart');
        map.getRenderer().setToRedraw();
        return this;
    },
    endEdit: function endEdit() {
        if (this._editor) {
            this._editor.stop();
            delete this._editor;
            this._recoveryVisible();
            if (!this._getParent()) this.fire('editend');
            var map = this.getMap();
            if (map) map.getRenderer().setToRedraw();
        }
        return this;
    },
    redoEdit: function redoEdit() {
        if (!this.isEditing()) return this;
        this._editor.redo();
        if (!this._getParent()) this.fire('redoedit');
        return this;
    },
    undoEdit: function undoEdit() {
        if (!this.isEditing()) return this;
        this._editor.undo();
        if (!this._getParent()) this.fire('undoedit');
        return this;
    },
    cancelEdit: function cancelEdit() {
        if (!this.isEditing()) return this;
        this._recoveryVisible();
        this._editor.cancel();
        if (!this._getParent()) this.fire('canceledit');
        return this;
    },
    isEditing: function isEditing() {
        if (this._editor) return this._editor.isEditing();
        return false;
    },
    undoEditcheck: function undoEditcheck() {
        if (this.isEditing()) return this._editor._isundoEdit();
    },
    redoEditcheck: function redoEditcheck() {
        if (this.isEditing()) return this._editor._isRedoEdit();
    }
});
Geometry.include({
    _onEvent: function _onEvent(event, type) {
        var map = this.getMap();
        if (!map) return;
        var eventType = type || this._getEventTypeToFire(event);
        if (eventType === 'contextmenu' && this.listens('contextmenu')) {
            stopPropagation(event);
            preventDefault(event);
        }
        var params = map._getEventParams(event);
        if (isNumber(this._pickGeometryIndex)) params.pickGeometryIndex = this._pickGeometryIndex;
        this._fireEvent(eventType, params);
    },
    _getEventTypeToFire: function _getEventTypeToFire(domEvent) {
        return domEvent.type;
    }
});
Geometry.include({
    setInfoWindow: function setInfoWindow(options) {
        this.removeInfoWindow();
        if (options instanceof InfoWindow) {
            this._infoWindow = options;
            this._infoWinOptions = extend$2({}, this._infoWindow.options);
            this._infoWindow.addTo(this);
            return this;
        }
        this._infoWinOptions = extend$2({}, options);
        if (this._infoWindow) this._infoWindow._setOptions(options);
        else if (this.getMap()) this._bindInfoWindow();
        return this;
    },
    getInfoWindow: function getInfoWindow() {
        if (!this._infoWindow) return null;
        return this._infoWindow;
    },
    openInfoWindow: function openInfoWindow(coordinate) {
        if (!this.getMap()) return this;
        if (!coordinate) coordinate = this.getCenter();
        if (!this._infoWindow) {
            if (this._infoWinOptions && this.getMap()) {
                this._bindInfoWindow();
                this._infoWindow.show(coordinate);
            }
        } else this._infoWindow.show(coordinate);
        return this;
    },
    closeInfoWindow: function closeInfoWindow() {
        if (this._infoWindow) this._infoWindow.hide();
        return this;
    },
    removeInfoWindow: function removeInfoWindow() {
        this._unbindInfoWindow();
        delete this._infoWinOptions;
        delete this._infoWindow;
        return this;
    },
    _bindInfoWindow: function _bindInfoWindow() {
        var options = this._infoWinOptions;
        if (!options) return this;
        this._infoWindow = new InfoWindow(options);
        this._infoWindow.addTo(this);
        return this;
    },
    _unbindInfoWindow: function _unbindInfoWindow() {
        if (this._infoWindow) {
            this.closeInfoWindow();
            this._infoWindow.remove();
            delete this._infoWindow;
        }
        return this;
    }
});
Geometry.fromJSON = function(json) {
    if (Array.isArray(json)) {
        var result = [];
        for(var i = 0, len = json.length; i < len; i++){
            var c = Geometry.fromJSON(json[i]);
            if (Array.isArray(json)) result = result.concat(c);
            else result.push(c);
        }
        return result;
    }
    if (json && !json['feature']) return GeoJSON.toGeometry(json);
    var geometry;
    if (json['subType']) {
        geometry = Geometry.getJSONClass(json['subType']).fromJSON(json);
        if (!isNil(json['feature']['id'])) geometry.setId(json['feature']['id']);
    } else {
        geometry = GeoJSON.toGeometry(json['feature']);
        if (json['options']) geometry.config(json['options']);
    }
    if (json['symbol']) geometry.setSymbol(json['symbol']);
    if (json['infoWindow']) geometry.setInfoWindow(json['infoWindow']);
    return geometry;
};
var TEMP_POINT1 = new Point(0, 0);
var TEMP_POINT2 = new Point(0, 0);
var EMPTY_ARRAY = [];
var TileWorkerConnection = function(_Actor) {
    function TileWorkerConnection() {
        return _Actor.call(this, imageFetchWorkerKey) || this;
    }
    _inheritsLoose(TileWorkerConnection, _Actor);
    var _proto = TileWorkerConnection.prototype;
    _proto.checkUrl = function checkUrl(url) {
        if (!url || !isString(url)) return url;
        return getAbsoluteURL(url);
    };
    _proto.fetchImage = function fetchImage(url, workerId, cb, fetchOptions) {
        url = this.checkUrl(url);
        var data = {
            url: url,
            fetchOptions: fetchOptions
        };
        this.send(data, EMPTY_ARRAY, cb, workerId);
    };
    return TileWorkerConnection;
}(Actor);
var TileLayerRenderable = function TileLayerRenderable(Base) {
    var renderable = function(_Base) {
        function renderable() {
            return _Base.apply(this, arguments) || this;
        }
        _inheritsLoose(renderable, _Base);
        var _proto2 = renderable.prototype;
        _proto2.init = function init() {
            var _this = this;
            this.tilesInView = {};
            this.tilesLoading = {};
            this._parentTiles = [];
            this._childTiles = [];
            this._tileQueue = [];
            this._tileQueueIds = new Set();
            var tileSize = this.layer.getTileSize().width;
            this.tileCache = new LRUCache(this.layer.options['maxCacheSize'] * tileSize / 512 * tileSize / 512, function(tile) {
                _this.deleteTile(tile);
            });
            if (Browser$1.decodeImageInWorker && this.layer.options['decodeImageInWorker'] && (this.layer.options['renderer'] === 'gl' || !Browser$1.safari && !Browser$1.iosWeixin)) this._tileImageWorkerConn = new TileWorkerConnection();
            this._compareTiles = compareTiles.bind(this);
        };
        _proto2.getCurrentTileZoom = function getCurrentTileZoom() {
            return this._tileZoom;
        };
        _proto2.draw = function draw(timestamp, context) {
            var map = this.getMap();
            if (this.isDrawable && !this.isDrawable()) return;
            var mask2DExtent = this.prepareCanvas();
            if (mask2DExtent) {
                if (!mask2DExtent.intersects(this.canvasExtent2D)) {
                    this.completeRender();
                    return;
                }
            }
            if (this._renderTimestamp !== timestamp) {
                this._consumeTileQueue();
                this._computeAvgTileAltitude();
                this._renderTimestamp = timestamp;
            }
            var currentTiles;
            var hasFreshTiles = false;
            var frameTiles = this._frameTiles;
            if (frameTiles && timestamp === frameTiles.timestamp) {
                if (frameTiles.empty) return;
                currentTiles = frameTiles;
            } else {
                currentTiles = this._getTilesInCurrentFrame();
                if (!currentTiles) {
                    this._frameTiles = {
                        empty: true,
                        timestamp: timestamp
                    };
                    this.completeRender();
                    return;
                }
                hasFreshTiles = true;
                this._frameTiles = currentTiles;
                this._frameTiles.timestamp = timestamp;
                if (currentTiles.loadingCount) this.loadTileQueue(currentTiles.tileQueue);
            }
            var { tiles: tiles, childTiles: childTiles, parentTiles: parentTiles, placeholders: placeholders, loading: loading, loadingCount: loadingCount, missedTiles: missedTiles, incompleteTiles: incompleteTiles } = currentTiles;
            this._drawTiles(tiles, parentTiles, childTiles, placeholders, context, missedTiles, incompleteTiles);
            if (!loadingCount) {
                if (!loading) {
                    if (!map.isAnimating() && (this._parentTiles.length || this._childTiles.length)) {
                        this._parentTiles = [];
                        this._childTiles = [];
                        this.setToRedraw();
                    }
                    this.completeRender();
                }
            }
            if (hasFreshTiles) this.retireTiles();
        };
        _proto2.getTileGridsInCurrentFrame = function getTileGridsInCurrentFrame() {
            return this._frameTileGrids;
        };
        _proto2.getCurrentTimestamp = function getCurrentTimestamp() {
            return this._renderTimestamp || 0;
        };
        _proto2._getTilesInCurrentFrame = function _getTilesInCurrentFrame() {
            var map = this.getMap();
            this.map = map;
            var layer = this.layer;
            layer._spatialRef = layer.getSpatialReference();
            var terrainTileMode = layer._isPyramidMode() && layer.options['terrainTileMode'];
            var tileGrids = layer.getTiles();
            this._frameTileGrids = tileGrids;
            tileGrids = tileGrids.tileGrids;
            if (!tileGrids || !tileGrids.length) {
                layer._spatialRef = null;
                this.map = null;
                return null;
            }
            var count = tileGrids.reduce(function(acc, curr) {
                return acc + (curr && curr.tiles && curr.tiles.length || 0);
            }, 0);
            if (count >= this.tileCache.max / 2) this.tileCache.setMaxSize(count * 2 + 1);
            var loadingCount = 0;
            var loading = false;
            var checkedTiles = {};
            var tiles = [], parentTiles = [], parentKeys = {}, childTiles = [], childKeys = {}, placeholders = [], placeholderKeys = {};
            var tileQueue = {};
            var preLoadingCount = this.markTiles();
            var loadingLimit = this._getLoadLimit();
            var l = tileGrids.length;
            var isFirstRender = this._tileZoom === undefined && layer.options['currentTilesFirst'] && !this._terrainHelper;
            this._tileZoom = tileGrids[0]['zoom'];
            var missingTiles = null;
            var incompleteTiles = null;
            if (terrainTileMode) {
                missingTiles = [];
                incompleteTiles = new Map();
            }
            for(var i = 0; i < l; i++){
                var tileGrid = tileGrids[i];
                var gridTiles = tileGrid['tiles'];
                var parents = tileGrid['parents'] || EMPTY_ARRAY;
                var parentCount = parents.length;
                var allTiles = isFirstRender ? gridTiles : mergeArray(parents, gridTiles);
                var placeholder = void 0;
                if (allTiles.length) placeholder = this._generatePlaceHolder(allTiles[0].res);
                for(var j = 0, _l = allTiles.length; j < _l; j++){
                    var tile = allTiles[j];
                    var tileId = tile.id;
                    var isParentTile = !isFirstRender && j < parentCount;
                    var tileLoading = false;
                    var tilesCount = tiles.length;
                    if (this._isLoadingTile(tileId)) {
                        tileLoading = loading = true;
                        this.markCurrent(this.tilesLoading[tileId], true);
                    } else {
                        var cached = this.getCachedTile(tile, isParentTile);
                        if (cached) {
                            if (!isParentTile) {
                                if (cached.image && this.isTileFadingIn(cached.image)) {
                                    tileLoading = loading = true;
                                    this.setToRedraw();
                                }
                                if (this.isTileComplete(cached)) tiles.push(cached);
                                else {
                                    tileLoading = true;
                                    if (terrainTileMode) incompleteTiles.set(tileId, cached);
                                }
                            }
                        } else {
                            tileLoading = loading = true;
                            var hitLimit = loadingLimit && loadingCount + preLoadingCount[0] > loadingLimit;
                            if (!this._tileQueueIds.has(tile.id) && !hitLimit && (!map.isInteracting() || map.isMoving() || map.isRotating())) {
                                loadingCount++;
                                var key = tileId;
                                tileQueue[key] = tile;
                            }
                        }
                    }
                    if (terrainTileMode && !isParentTile) {
                        if (tiles.length === tilesCount) missingTiles.push(tile);
                        else checkedTiles[tile.id] = 1;
                    }
                    if (terrainTileMode) continue;
                    if (isParentTile) continue;
                    if (!tileLoading) continue;
                    if (checkedTiles[tileId]) continue;
                    checkedTiles[tileId] = 1;
                    if (placeholder && !placeholderKeys[tileId]) {
                        tile.cache = false;
                        placeholders.push({
                            image: placeholder,
                            info: tile
                        });
                        placeholderKeys[tileId] = 1;
                    }
                    var children = this._findChildTiles(tile);
                    if (children.length) children.forEach(function(c) {
                        if (!childKeys[c.info.id]) {
                            childTiles.push(c);
                            childKeys[c.info.id] = 1;
                        }
                    });
                    if (!children.length || children.length !== 4) {
                        var parentTile = this._findParentTile(tile);
                        if (parentTile) {
                            var parentId = parentTile.info.id;
                            if (parentKeys[parentId] === undefined) {
                                parentKeys[parentId] = parentTiles.length;
                                parentTiles.push(parentTile);
                            }
                        }
                    }
                }
            }
            var missedTiles = [];
            if (terrainTileMode) for(var _i = 0; _i < missingTiles.length; _i++){
                var _tile = missingTiles[_i].info ? missingTiles[_i].info : missingTiles[_i];
                if (!_tile.parent || checkedTiles[_tile.id]) continue;
                var { tiles: _children, missedTiles: childMissedTiles } = this._findChildTiles(_tile);
                if (_children.length) {
                    pushIn(tiles, _children);
                    pushIn(missedTiles, childMissedTiles);
                    continue;
                } else if (incompleteTiles.has(_tile.id)) {
                    tiles.push(incompleteTiles.get(_tile.id));
                    incompleteTiles["delete"](_tile.id);
                    continue;
                }
                checkedTiles[_tile.id] = 1;
                missedTiles.push(_tile);
            }
            this.tileCache.shrink();
            layer._spatialRef = null;
            this.map = null;
            return {
                childTiles: childTiles,
                missedTiles: missedTiles,
                parentTiles: parentTiles,
                tiles: tiles,
                incompleteTiles: incompleteTiles && Array.from(incompleteTiles.values()),
                placeholders: placeholders,
                loading: loading,
                loadingCount: loadingCount,
                tileQueue: tileQueue
            };
        };
        _proto2.removeTileCache = function removeTileCache(tileId) {
            delete this.tilesInView[tileId];
            this.tileCache.remove(tileId);
        };
        _proto2.isTileCachedOrLoading = function isTileCachedOrLoading(tileId) {
            return this.tileCache.get(tileId) || this.tilesInView[tileId] || this.tilesLoading[tileId];
        };
        _proto2.isTileCached = function isTileCached(tileId) {
            return !!(this.tileCache.get(tileId) || this.tilesInView[tileId]);
        };
        _proto2.isTileFadingIn = function isTileFadingIn(tileImage) {
            return this.getTileFadingOpacity(tileImage) < 1;
        };
        _proto2._drawTiles = function _drawTiles(tiles, parentTiles, childTiles, placeholders, parentContext, missedTiles, incompleteTiles) {
            if (parentTiles.length) {
                parentTiles.sort(this._compareTiles);
                this._parentTiles = parentTiles;
            }
            if (childTiles.length) {
                this._childTiles = childTiles;
                this._childTiles.sort(this._compareTiles);
            }
            var drawBackground = true;
            var backgroundTimestamp = this.canvas._parentTileTimestamp;
            if (this.layer.constructor === TileLayer || this.layer.constructor === WMSTileLayer) {
                if (this._renderTimestamp === backgroundTimestamp) drawBackground = false;
                else this.canvas._parentTileTimestamp = this._renderTimestamp;
            }
            var context = {
                tiles: tiles,
                parentTiles: this._parentTiles,
                childTiles: this._childTiles,
                parentContext: parentContext
            };
            this.onDrawTileStart(context, parentContext);
            if (drawBackground && this.layer.options['opacity'] === 1) {
                this.layer._silentConfig = true;
                var fadingAnimation = this.layer.options['fadeAnimation'];
                this.layer.options['fadeAnimation'] = false;
                this._drawChildTiles(childTiles, parentContext);
                this._drawParentTiles(this._parentTiles, parentContext);
                this.layer.options['fadeAnimation'] = fadingAnimation;
                this.layer._silentConfig = false;
            }
            this.drawingCurrentTiles = true;
            tiles.sort(this._compareTiles);
            for(var i = 0, l = tiles.length; i < l; i++)this._drawTileAndCache(tiles[i], parentContext);
            delete this.drawingCurrentTiles;
            if (drawBackground && this.layer.options['opacity'] < 1) {
                this.layer._silentConfig = true;
                var _fadingAnimation = this.layer.options['fadeAnimation'];
                this.layer.options['fadeAnimation'] = false;
                this._drawChildTiles(childTiles, parentContext);
                this._drawParentTiles(this._parentTiles, parentContext);
                this.layer.options['fadeAnimation'] = _fadingAnimation;
                this.layer._silentConfig = false;
            }
            this.onDrawTileEnd(context, parentContext);
        };
        _proto2._drawChildTiles = function _drawChildTiles(childTiles, parentContext) {
            var _this2 = this;
            this.drawingChildTiles = true;
            childTiles.forEach(function(t) {
                return _this2._drawTile(t.info, t.image, parentContext);
            });
            delete this.drawingChildTiles;
        };
        _proto2._drawParentTiles = function _drawParentTiles(parentTiles, parentContext) {
            var _this3 = this;
            this.drawingParentTiles = true;
            parentTiles.forEach(function(t) {
                return _this3._drawTile(t.info, t.image, parentContext);
            });
            delete this.drawingParentTiles;
        };
        _proto2.onDrawTileStart = function onDrawTileStart(context, parentContext) {};
        _proto2.onDrawTileEnd = function onDrawTileEnd(context, parentContext) {};
        _proto2._drawTile = function _drawTile(info, image, parentContext) {
            if (image) this.drawTile(info, image, parentContext);
        };
        _proto2.drawTile = function drawTile(tileInfo, tileImage, parentContext) {};
        _proto2._drawTileAndCache = function _drawTileAndCache(tile, parentContext) {
            if (this.isValidCachedTile(tile)) this.tilesInView[tile.info.id] = tile;
            this._drawTile(tile.info, tile.image, parentContext);
        };
        _proto2.drawOnInteracting = function drawOnInteracting(event, timestamp, context) {
            this.draw(timestamp, context);
        };
        _proto2.checkIfNeedRedraw = function checkIfNeedRedraw() {
            return !!this._tileQueue.length;
        };
        _proto2.hitDetect = function hitDetect() {
            return false;
        };
        _proto2._getLoadLimit = function _getLoadLimit() {
            var map = this.map || this.getMap();
            if (map.isInteracting()) return this.layer.options['loadingLimitOnInteracting'];
            return this.layer.options['loadingLimit'] || 0;
        };
        _proto2._isLoadingTile = function _isLoadingTile(tileId) {
            return !!this.tilesLoading[tileId];
        };
        _proto2.loadTileQueue = function loadTileQueue(tileQueue) {
            for(var p in tileQueue)if (tileQueue.hasOwnProperty(p)) {
                var tile = tileQueue[p];
                var tileImage = this.loadTile(tile);
                if (tileImage.loadTime === undefined) this.tilesLoading[tile['id']] = {
                    image: tileImage,
                    current: true,
                    info: tile
                };
            }
        };
        _proto2.loadTile = function loadTile(tile) {
            var _this4 = this;
            var tileImage = {};
            if (this.loadTileBitmap) {
                var onLoad = function onLoad(bitmap) {
                    _this4.onTileLoad(bitmap, tile);
                };
                var onError = function onError(error, image) {
                    _this4.onTileError(image, tile, error);
                };
                this.loadTileBitmap(tile['url'], tile, onLoad, onError);
            } else if (this._tileImageWorkerConn && this.loadTileImage === this.constructor.prototype.loadTileImage) this._fetchImage(tileImage, tile);
            else {
                var tileSize = this.layer.getTileSize(tile.layer);
                tileImage = new Image();
                tileImage.width = tileSize['width'];
                tileImage.height = tileSize['height'];
                tileImage.onload = this.onTileLoad.bind(this, tileImage, tile);
                tileImage.onerror = this.onTileError.bind(this, tileImage, tile);
                this.loadTileImage(tileImage, tile['url'], tile);
            }
            return tileImage;
        };
        _proto2._fetchImage = function _fetchImage(image, tile) {
            var _this5 = this;
            if (image instanceof Image) image.src = tile.url;
            else {
                var { x: x, y: y } = tile;
                var workerId = Math.abs(x + y) % this._tileImageWorkerConn.workers.length;
                this._tileImageWorkerConn.fetchImage(tile.url, workerId, function(err, data) {
                    if (err) _this5.onTileError(image, tile, err);
                    else getImageBitMap(data, function(bitmap) {
                        _this5.onTileLoad(bitmap, tile);
                    });
                }, this.layer.options['fetchOptions'] || {
                    referrer: document.location.href,
                    headers: {
                        accept: 'image/webp,image/apng,image/svg+xml,image/*,*/*;q=0.8'
                    }
                });
            }
        };
        _proto2.loadTileImage = function loadTileImage(tileImage, url, tile) {
            var crossOrigin = this.layer.options['crossOrigin'];
            if (!isNil(crossOrigin)) tileImage.crossOrigin = crossOrigin;
            return loadImage(tileImage, [
                url
            ]);
        };
        _proto2.abortTileLoading = function abortTileLoading(tileImage, tileInfo) {
            if (tileInfo && tileInfo.id !== undefined) this.removeTileLoading(tileInfo);
            if (!tileImage) return;
            if (tileImage instanceof Image) {
                tileImage.onload = falseFn;
                tileImage.onerror = falseFn;
                tileImage.src = emptyImageUrl;
            }
        };
        _proto2.onTileLoad = function onTileLoad(tileImage, tileInfo) {
            this.removeTileLoading(tileInfo);
            this._tileQueue.push({
                tileInfo: tileInfo,
                tileData: tileImage
            });
            this._tileQueueIds.add(tileInfo.id);
            this.setToRedraw();
        };
        _proto2.removeTileLoading = function removeTileLoading(tileInfo) {
            delete this.tilesLoading[tileInfo.id];
            this.setToRedraw();
        };
        _proto2._consumeTileQueue = function _consumeTileQueue() {
            var count = 0;
            var limit = this.layer.options['tileLimitPerFrame'];
            var queue = this._tileQueue;
            while(queue.length && (limit <= 0 || count < limit)){
                var { tileData: tileData, tileInfo: tileInfo } = queue.shift();
                if (!this._tileQueueIds.has(tileInfo.id)) continue;
                this._tileQueueIds["delete"](tileInfo.id);
                if (!this.checkTileInQueue(tileData, tileInfo)) continue;
                this.consumeTile(tileData, tileInfo);
                count++;
            }
        };
        _proto2._computeAvgTileAltitude = function _computeAvgTileAltitude() {
            var sumMin = 0;
            var sumMax = 0;
            var count = 0;
            for(var p in this.tilesInView){
                var info = this.tilesInView[p] && this.tilesInView[p].info;
                if (info) {
                    sumMin += info.minAltitude || 0;
                    sumMax += info.maxAltitude || 0;
                    count++;
                }
            }
            this.avgMinAltitude = sumMin / count;
            this.avgMaxAltitude = sumMax / count;
        };
        _proto2.checkTileInQueue = function checkTileInQueue(tileImage, tileInfo) {
            return true;
        };
        _proto2.consumeTile = function consumeTile(tileImage, tileInfo) {
            if (!this.layer) return;
            if (!this.tilesInView) return;
            var e = {
                tile: tileInfo,
                tileImage: tileImage
            };
            tileImage = e.tileImage;
            this.resetTileLoadTime(tileImage);
            this.removeTileLoading(tileInfo);
            this._addTileToCache(tileInfo, tileImage);
            this.layer.fire('tileload', e);
            this.setToRedraw();
        };
        _proto2.resetTileLoadTime = function resetTileLoadTime(tileImage) {
            if (tileImage.loadTime !== 0) tileImage.loadTime = now();
        };
        _proto2.onTileError = function onTileError(tileImage, tileInfo, error) {
            if (!this.layer) return;
            var reloadErrorTileFunction = this.layer.options['reloadErrorTileFunction'];
            if (reloadErrorTileFunction) {
                reloadErrorTileFunction.call(this, this.layer, this, tileInfo, tileImage);
                return;
            }
            var errorUrl = this.layer.options['errorUrl'];
            if (errorUrl) {
                if (tileImage instanceof Image && tileImage.src !== errorUrl) {
                    tileImage.src = errorUrl;
                    this.removeTileLoading(tileInfo);
                    return;
                } else {
                    tileImage = new Image();
                    tileImage.src = errorUrl;
                }
            }
            this.abortTileLoading(tileImage, tileInfo);
            tileImage.loadTime = 0;
            this.removeTileLoading(tileInfo);
            this._addTileToCache(tileInfo, tileImage);
            this.setToRedraw();
            this.layer.fire('tileerror', {
                tile: tileInfo
            });
        };
        _proto2.getDebugInfo = function getDebugInfo(tileId) {
            var xyz = tileId.split('_');
            var length = xyz.length;
            return xyz[length - 3] + '/' + xyz[length - 2] + '/' + xyz[length - 1];
        };
        _proto2.findChildTiles = function findChildTiles(info) {
            return this._findChildTiles(info);
        };
        _proto2._findChildTiles = function _findChildTiles(info) {
            var layer = this._getLayerOfTile(info.layer);
            var isPyramidMode = layer._isPyramidMode();
            var terrainTileMode = layer && layer.options['terrainTileMode'] && isPyramidMode;
            if (!layer || !layer.options['background'] && !terrainTileMode || info.z > this.layer.getMaxZoom()) return EMPTY_ARRAY;
            var map = this.map || this.getMap();
            var children = [];
            if (isPyramidMode) {
                if (!terrainTileMode) {
                    var _zoomDiff = 2;
                    var _cx = info.x * 2;
                    var _cy = info.y * 2;
                    var _cz = info.z + 1;
                    var queue = [];
                    for(var j = 0; j < 2; j++)for(var jj = 0; jj < 2; jj++)queue.push(_cx + j, _cy + jj, _cz);
                    while(queue.length){
                        var z = queue.pop();
                        var y = queue.pop();
                        var x = queue.pop();
                        var id = layer._getTileId(x, y, z, info.layer);
                        var canVisit = z + 1 <= info.z + _zoomDiff;
                        var tile = this.tileCache.getAndRemove(id);
                        if (tile) {
                            if (this.isValidCachedTile(tile)) {
                                children.push(tile);
                                this.tileCache.add(id, tile);
                            } else if (canVisit) {
                                for(var _j = 0; _j < 2; _j++)for(var _jj = 0; _jj < 2; _jj++)queue.push(x * 2 + _j, y * 2 + _jj, z + 1);
                            }
                        } else if (canVisit) {
                            for(var _j2 = 0; _j2 < 2; _j2++)for(var _jj2 = 0; _jj2 < 2; _jj2++)queue.push(x * 2 + _j2, y * 2 + _jj2, z + 1);
                        }
                    }
                    return children;
                }
                var missedTiles;
                if (terrainTileMode) missedTiles = [];
                var cx = info.x * 2;
                var cy = info.y * 2;
                var cz = info.z + 1;
                var candidates = [];
                for(var i = 0; i < 2; i++)for(var ii = 0; ii < 2; ii++){
                    var _x = cx + i;
                    var _y = cy + ii;
                    var _z = cz;
                    var _id = layer._getTileId(_x, _y, _z, info.layer);
                    var _tile2 = this.tileCache.getAndRemove(_id);
                    if (_tile2 && this.isValidCachedTile(_tile2)) {
                        children.push(_tile2);
                        this.tileCache.add(_id, _tile2);
                        candidates.push(null);
                    } else candidates.push(_id);
                }
                if (children.length < 4) {
                    var index = 0;
                    for(var _i2 = 0; _i2 < 2; _i2++)for(var _ii = 0; _ii < 2; _ii++){
                        var _id2 = candidates[index++];
                        if (!_id2) continue;
                        var _x2 = cx + _i2;
                        var _y2 = cy + _ii;
                        var _z2 = cz;
                        var childrenCount = children.length;
                        var childCandidates = [];
                        for(var _j3 = 0; _j3 < 2; _j3++)for(var _jj3 = 0; _jj3 < 2; _jj3++){
                            var xx = _x2 * 2 + _j3;
                            var yy = _y2 * 2 + _jj3;
                            var zz = _z2 + 1;
                            var _id3 = layer._getTileId(xx, yy, zz, info.layer);
                            var childTile = this.tileCache.getAndRemove(_id3);
                            if (childTile && this.isValidCachedTile(childTile)) {
                                children.push(childTile);
                                this.tileCache.add(_id3, childTile);
                                childCandidates.push(null);
                            } else childCandidates.push(_id3);
                        }
                        if (!terrainTileMode) continue;
                        if (children.length - childrenCount < 4) {
                            var childTileInfo = layer.tileInfoCache.get(_id2) || layer._createChildNode(info, _i2, _ii, [
                                0,
                                0
                            ], _id2);
                            if (children.length - childrenCount === 0) missedTiles.push(childTileInfo);
                            else {
                                var _index = 0;
                                for(var _j4 = 0; _j4 < 2; _j4++)for(var _jj4 = 0; _jj4 < 2; _jj4++){
                                    var _id4 = childCandidates[_index++];
                                    if (!_id4) continue;
                                    var grandsonTileInfo = this.layer.tileInfoCache.get(_id4) || layer._createChildNode(childTileInfo, _j4, _jj4, [
                                        0,
                                        0
                                    ], _id4);
                                    missedTiles.push(grandsonTileInfo);
                                }
                            }
                        }
                    }
                }
                return terrainTileMode ? {
                    tiles: children,
                    missedTiles: missedTiles
                } : children;
            }
            var zoomDiff = 1;
            var res = info.res;
            var min = info.extent2d.getMin(), max = info.extent2d.getMax(), pmin = layer._project(map._pointToPrjAtRes(min, res, TEMP_POINT1), TEMP_POINT1), pmax = layer._project(map._pointToPrjAtRes(max, res, TEMP_POINT2), TEMP_POINT2);
            for(var _i3 = 1; _i3 < zoomDiff; _i3++)this._findChildTilesAt(children, pmin, pmax, layer, info.z + _i3);
            return children;
        };
        _proto2._findChildTilesAt = function _findChildTilesAt(children, pmin, pmax, layer, childZoom) {
            var sr = layer._spatialRef || layer.getSpatialReference();
            var layerId = layer.getId(), res = sr.getResolution(childZoom);
            if (!res) return;
            var getTileConfig = layer._getTileConfig();
            var dmin = getTileConfig.getTileIndex(pmin, res), dmax = getTileConfig.getTileIndex(pmax, res);
            var sx = Math.min(dmin.idx, dmax.idx), ex = Math.max(dmin.idx, dmax.idx);
            var sy = Math.min(dmin.idy, dmax.idy), ey = Math.max(dmin.idy, dmax.idy);
            var id, tile;
            for(var i = sx; i < ex; i++)for(var ii = sy; ii < ey; ii++){
                id = layer._getTileId(i, ii, childZoom, layerId);
                tile = this.tileCache.getAndRemove(id);
                if (tile) {
                    if (this.isValidCachedTile(tile)) {
                        children.push(tile);
                        this.tileCache.add(id, tile);
                    }
                }
            }
        };
        _proto2.findParentTile = function findParentTile(info, targetDiff) {
            return this._findParentTile(info, targetDiff);
        };
        _proto2._findParentTile = function _findParentTile(info, targetDiff) {
            var map = this.map || this.getMap(), layer = this._getLayerOfTile(info.layer);
            if (!layer || !layer.options['background'] && !layer.options['terrainTileMode']) return null;
            var minZoom = layer.getMinZoom();
            var zoomDiff = targetDiff || info.z - minZoom;
            if (layer._isPyramidMode()) {
                var endZoom = info.z - zoomDiff;
                for(var z = info.z - 1; z >= endZoom; z--){
                    var diff = info.z - z;
                    var scale = Math.pow(2, diff);
                    var x = Math.floor(info.x / scale);
                    var y = Math.floor(info.y / scale);
                    var id = void 0;
                    if (z === info.z - 1) id = info.parent;
                    else id = layer._getTileId(x, y, z, info.layer);
                    var tile = this.tileCache.getAndRemove(id);
                    if (tile) {
                        if (this.isValidCachedTile(tile)) {
                            this.tileCache.add(id, tile);
                            return tile;
                        }
                    }
                }
                return null;
            }
            var sr = layer.getSpatialReference();
            var d = sr.getZoomDirection();
            var res = info.res;
            var center = info.extent2d.getCenter(), prj = layer._project(map._pointToPrjAtRes(center, res));
            for(var _diff = 1; _diff <= zoomDiff; _diff++){
                var _z3 = info.z - d * _diff;
                var _res = sr.getResolution(_z3);
                if (!_res) continue;
                var tileIndex = layer._getTileConfig().getTileIndex(prj, _res);
                var _id5 = layer._getTileId(tileIndex.x, tileIndex.y, _z3, info.layer);
                var _tile3 = this.tileCache.getAndRemove(_id5);
                if (_tile3) {
                    this.tileCache.add(_id5, _tile3);
                    return _tile3;
                }
            }
            return null;
        };
        _proto2.isValidCachedTile = function isValidCachedTile(tile) {
            return !!tile.image;
        };
        _proto2.isTileComplete = function isTileComplete(tile) {
            return true;
        };
        _proto2._getLayerOfTile = function _getLayerOfTile(layerId) {
            return this.layer.getChildLayer ? this.layer.getChildLayer(layerId) : this.layer;
        };
        _proto2.getCachedTile = function getCachedTile(tile, isParent) {
            var tileId = tile.id;
            var tilesInView = this.tilesInView;
            var cached = this.tileCache.getAndRemove(tileId);
            if (cached) {
                if (!isParent) tilesInView[tileId] = cached;
                var tilesLoading = this.tilesLoading;
                if (tilesLoading && tilesLoading[tileId]) {
                    this.markCurrent(tilesLoading[tileId], false);
                    var { image: image, info: info } = tilesLoading[tileId];
                    this.abortTileLoading(image, info);
                    delete tilesLoading[tileId];
                }
            } else cached = tilesInView[tileId];
            if (cached) {
                cached.current = true;
                if (this.isValidCachedTile(cached)) this.tileCache.add(tileId, cached);
            }
            return cached;
        };
        _proto2._addTileToCache = function _addTileToCache(tileInfo, tileImage) {
            if (this.isValidCachedTile({
                info: tileInfo,
                image: tileImage
            })) {
                var cached = {
                    image: tileImage,
                    info: tileInfo
                };
                this.tileCache.add(tileInfo.id, cached);
            }
        };
        _proto2.getTileOpacity = function getTileOpacity(tileImage, tileInfo) {
            var opacity = this.getTileFadingOpacity(tileImage);
            if (this.layer.getChildLayer) {
                var childLayer = this.layer.getLayer(tileInfo.layer);
                if (childLayer) opacity *= childLayer.options['opacity'];
            }
            return opacity;
        };
        _proto2.getTileFadingOpacity = function getTileFadingOpacity(tileImage) {
            if (!this.layer.options['fadeAnimation'] || !tileImage.loadTime) return 1;
            return Math.min(1, (now() - tileImage.loadTime) / this.layer.options['fadeDuration']);
        };
        _proto2.clearTileCaches = function clearTileCaches() {
            this.retireTiles(true);
            this.tileCache.reset();
            this.tilesInView = {};
            this.tilesLoading = {};
            this._tileQueue = [];
            this._tileQueueIds.clear();
            this._parentTiles = [];
            this._childTiles = [];
        };
        _proto2.removeTileCaches = function removeTileCaches() {
            delete this.tileCache;
            delete this._tilePlaceHolder;
            delete this._tileZoom;
        };
        _proto2.markCurrent = function markCurrent(tile, isCurrent) {
            tile.current = isCurrent;
        };
        _proto2.markTiles = function markTiles() {
            var a = 0, b = 0;
            if (this.tilesLoading) for(var p in this.tilesLoading){
                this.markCurrent(this.tilesLoading[p], false);
                a++;
            }
            if (this.tilesInView) for(var _p in this.tilesInView){
                this.markCurrent(this.tilesInView[_p], false);
                b++;
            }
            return [
                a,
                b
            ];
        };
        _proto2.retireTiles = function retireTiles(force) {
            for(var i in this.tilesLoading){
                var tile = this.tilesLoading[i];
                if (force || !tile.current) {
                    if (tile.image) this.abortTileLoading(tile.image, tile.info);
                    this.deleteTile(tile);
                    this.removeTileLoading(tile.info);
                }
            }
            for(var _i4 in this.tilesInView){
                var _tile4 = this.tilesInView[_i4];
                if (!_tile4.current) {
                    delete this.tilesInView[_i4];
                    if (!this.tileCache.has(_i4)) this.deleteTile(_tile4);
                }
            }
        };
        _proto2.deleteTile = function deleteTile(tile) {
            if (!tile || !tile.image) return;
            var tileId = tile.info.id;
            if (this._tileQueueIds.has(tileId)) this._tileQueueIds["delete"](tileId);
            if (tile.image.close) tile.image.close();
            if (tile.image instanceof Image) {
                tile.image.onload = null;
                tile.image.onerror = null;
            }
            var layer = this.layer;
            if (layer) layer.fire('tiledelete', {
                tile: tile.info,
                tileImage: tile.image
            });
        };
        _proto2._generatePlaceHolder = function _generatePlaceHolder(res) {
            var map = this.map || this.getMap();
            var placeholder = this.layer.options['placeholder'];
            if (!placeholder || map.getPitch()) return null;
            var tileSize = this.layer.getTileSize();
            var scale = res / map._getResolution();
            var canvas = this._tilePlaceHolder = this._tilePlaceHolder || Canvas.createCanvas(1, 1, map.CanvasClass);
            canvas.width = tileSize.width * scale;
            canvas.height = tileSize.height * scale;
            if (isFunction(placeholder)) placeholder(canvas);
            else defaultPlaceholder(canvas);
            return canvas;
        };
        _proto2.setTerrainHelper = function setTerrainHelper(helper) {
            this._terrainHelper = helper;
        };
        return renderable;
    }(Base);
    return renderable;
};
function falseFn() {
    return false;
}
function defaultPlaceholder(canvas) {
    var ctx = canvas.getContext('2d'), cw = canvas.width, ch = canvas.height, w = cw / 16, h = ch / 16;
    ctx.beginPath();
    for(var i = 0; i < 16; i++){
        ctx.moveTo(0, i * h);
        ctx.lineTo(cw, i * h);
        ctx.moveTo(i * w, 0);
        ctx.lineTo(i * w, ch);
    }
    ctx.strokeStyle = 'rgba(180, 180, 180, 0.1)';
    ctx.lineWidth = 1;
    ctx.stroke();
    ctx.beginPath();
    var path = [
        [
            0,
            0
        ],
        [
            cw,
            0
        ],
        [
            0,
            ch
        ],
        [
            cw,
            ch
        ],
        [
            0,
            0
        ],
        [
            0,
            ch
        ],
        [
            cw,
            0
        ],
        [
            cw,
            ch
        ],
        [
            0,
            ch / 2
        ],
        [
            cw,
            ch / 2
        ],
        [
            cw / 2,
            0
        ],
        [
            cw / 2,
            ch
        ]
    ];
    for(var _i5 = 1; _i5 < path.length; _i5 += 2){
        ctx.moveTo(path[_i5 - 1][0], path[_i5 - 1][1]);
        ctx.lineTo(path[_i5][0], path[_i5][1]);
    }
    ctx.lineWidth = 4;
    ctx.stroke();
}
function compareTiles(a, b) {
    return Math.abs(this._tileZoom - a.info.z) - Math.abs(this._tileZoom - b.info.z);
}
var TILE_POINT$1 = new Point(0, 0);
var TEMP_POINT = new Point(0, 0);
var TileLayerCanvasRenderer = function(_TileLayerRenderable) {
    function TileLayerCanvasRenderer(layer) {
        var _this;
        _this = _TileLayerRenderable.call(this, layer) || this;
        _this.init();
        return _this;
    }
    _inheritsLoose(TileLayerCanvasRenderer, _TileLayerRenderable);
    var _proto = TileLayerCanvasRenderer.prototype;
    _proto._drawTiles = function _drawTiles(tiles, parentTiles, childTiles, placeholders, parentContext, missedTiles, incompleteTiles) {
        var _this2 = this;
        if (parentTiles.length) {
            parentTiles.sort(this._compareTiles);
            this._parentTiles = parentTiles;
        }
        if (childTiles.length) {
            this._childTiles = childTiles;
            this._childTiles.sort(this._compareTiles);
        }
        var drawBackground = true;
        var backgroundTimestamp = this.canvas._parentTileTimestamp;
        if (this.layer.constructor === TileLayer || this.layer.constructor === WMSTileLayer) {
            if (this._renderTimestamp === backgroundTimestamp) drawBackground = false;
            else this.canvas._parentTileTimestamp = this._renderTimestamp;
        }
        var renderInGL = this.layer.options.renderer === 'gl' && (!this.isGL || this.isGL());
        var context = {
            tiles: tiles,
            parentTiles: this._parentTiles,
            childTiles: this._childTiles,
            parentContext: parentContext
        };
        this.onDrawTileStart(context, parentContext);
        if (drawBackground && this.layer.options['opacity'] === 1) {
            this.layer._silentConfig = true;
            var fadingAnimation = this.layer.options['fadeAnimation'];
            this.layer.options['fadeAnimation'] = false;
            if (renderInGL) {
                this._drawChildTiles(childTiles, parentContext);
                this._drawParentTiles(this._parentTiles, parentContext);
            } else {
                this._drawParentTiles(this._parentTiles, parentContext);
                this._drawChildTiles(childTiles, parentContext);
            }
            this.layer.options['fadeAnimation'] = fadingAnimation;
            this.layer._silentConfig = false;
        }
        this.drawingCurrentTiles = true;
        tiles.sort(this._compareTiles);
        for(var i = 0, l = tiles.length; i < l; i++)this._drawTileAndCache(tiles[i], parentContext);
        delete this.drawingCurrentTiles;
        if (drawBackground && this.layer.options['opacity'] < 1) {
            this.layer._silentConfig = true;
            var _fadingAnimation = this.layer.options['fadeAnimation'];
            this.layer.options['fadeAnimation'] = false;
            if (renderInGL) {
                this._drawChildTiles(childTiles, parentContext);
                this._drawParentTiles(this._parentTiles, parentContext);
            } else {
                this._drawParentTiles(this._parentTiles, parentContext);
                this._drawChildTiles(childTiles, parentContext);
            }
            this.layer.options['fadeAnimation'] = _fadingAnimation;
            this.layer._silentConfig = false;
        }
        placeholders.forEach(function(t) {
            return _this2._drawTile(t.info, t.image, parentContext);
        });
        this.onDrawTileEnd(context, parentContext);
    };
    _proto.needToRedraw = function needToRedraw() {
        var map = this.getMap();
        if (this.checkIfNeedRedraw()) return true;
        if (map.getPitch()) return _TileLayerRenderable.prototype.needToRedraw.call(this);
        if (map.isRotating() || map.isZooming()) return true;
        if (map.isMoving()) return !!this.layer.options['forceRenderOnMoving'];
        return _TileLayerRenderable.prototype.needToRedraw.call(this);
    };
    _proto.isDrawable = function isDrawable() {
        if (this.getMap().getPitch()) {
            if (console) console.warn('TileLayer with canvas renderer can\'t be pitched, use gl renderer (\'renderer\' : \'gl\') instead.');
            this.clear();
            return false;
        }
        return true;
    };
    _proto.clipCanvas = function clipCanvas(context) {
        return _TileLayerRenderable.prototype.clipCanvas.call(this, context);
    };
    _proto.clear = function clear() {
        this.clearTileCaches();
        _TileLayerRenderable.prototype.clear.call(this);
    };
    _proto.onRemove = function onRemove() {
        this.clear();
        this.removeTileCaches();
        _TileLayerRenderable.prototype.onRemove.call(this);
    };
    _proto.drawTile = function drawTile(tileInfo, tileImage, parentContext) {
        if (!tileImage) return;
        var map = this.getMap();
        if (!map) return;
        var { extent2d: extent2d, offset: offset } = tileInfo;
        var point = TILE_POINT$1.set(extent2d.xmin - offset[0], extent2d.ymax - offset[1]), tileZoom = tileInfo.z, tileId = tileInfo.id;
        var zoom = map.getZoom(), ctx = this.context, cp = map._pointAtResToContainerPoint(point, tileInfo.res, 0, TEMP_POINT), bearing = map.getBearing(), transformed = bearing || zoom !== tileZoom;
        var opacity = this.getTileOpacity(tileImage, tileInfo);
        var alpha = ctx.globalAlpha;
        if (opacity < 1) ctx.globalAlpha = opacity;
        if (!transformed) cp._round();
        var x = cp.x, y = cp.y;
        var w = tileInfo.extent2d.xmax - tileInfo.extent2d.xmin;
        var h = tileInfo.extent2d.ymax - tileInfo.extent2d.ymin;
        var layer = this.layer;
        var bufferPixel = layer ? layer.options.bufferPixel : 0;
        if (transformed) {
            ctx.save();
            ctx.translate(x, y);
            if (bearing) ctx.rotate(-bearing * Math.PI / 180);
            w += bufferPixel;
            h += bufferPixel;
            var res = map._getResolution();
            if (res !== tileInfo.res) {
                var scale = tileInfo.res / res;
                ctx.scale(scale, scale);
            }
            x = y = 0;
        }
        Canvas.image(ctx, tileImage, x, y, w, h);
        if (this.layer.options['debug']) {
            var color = this.layer.options['debugOutline'];
            ctx.save();
            ctx.strokeStyle = color;
            ctx.fillStyle = color;
            ctx.font = '20px monospace';
            var _point = new Point(x, y);
            Canvas.rectangle(ctx, _point, {
                width: w,
                height: h
            }, 1, 0);
            Canvas.fillText(ctx, this.getDebugInfo(tileId), _point._add(32, h - 14), color);
            Canvas.drawCross(ctx, x + w / 2, y + h / 2, 2, color);
            ctx.restore();
        }
        if (transformed) ctx.restore();
        if (ctx.globalAlpha !== alpha) ctx.globalAlpha = alpha;
        this.setCanvasUpdated();
    };
    return TileLayerCanvasRenderer;
}(TileLayerRenderable(CanvasRenderer$1));
TileLayer.registerRenderer('canvas', TileLayerCanvasRenderer);
var TILE_POINT = new Point(0, 0);
var MESH_TO_TEST = {
    properties: {}
};
var TileLayerGLRenderer = function(_ImageGLRenderable) {
    function TileLayerGLRenderer() {
        return _ImageGLRenderable.apply(this, arguments) || this;
    }
    _inheritsLoose(TileLayerGLRenderer, _ImageGLRenderable);
    var _proto = TileLayerGLRenderer.prototype;
    _proto.isDrawable = function isDrawable() {
        return true;
    };
    _proto.needToRedraw = function needToRedraw() {
        var map = this.getMap();
        if (this.isGL() && !map.getPitch() && map.isZooming() && !map.isMoving() && !map.isRotating()) return true;
        return _ImageGLRenderable.prototype.needToRedraw.call(this);
    };
    _proto.onDrawTileStart = function onDrawTileStart(context, parentContext) {
        var gl = this.gl;
        gl.enable(gl.DEPTH_TEST);
        gl.depthFunc(gl.LEQUAL);
        gl.enable(gl.POLYGON_OFFSET_FILL);
        gl.enable(gl.STENCIL_TEST);
        gl.stencilOp(gl.KEEP, gl.KEEP, gl.REPLACE);
        var depthMask = !!this.layer.options['depthMask'];
        gl.depthMask(depthMask);
        if (parentContext && parentContext.renderTarget) {
            var fbo = parentContext.renderTarget.fbo;
            if (fbo) {
                var framebuffer = parentContext.renderTarget.getFramebuffer(fbo);
                gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer);
            }
        }
    };
    _proto.onDrawTileEnd = function onDrawTileEnd(context, parentContext) {
        var gl = this.gl;
        if (parentContext && parentContext.renderTarget) {
            var fbo = parentContext.renderTarget.fbo;
            if (fbo) gl.bindFramebuffer(gl.FRAMEBUFFER, null);
        }
    };
    _proto.drawTile = function drawTile(tileInfo, tileImage, parentContext) {
        if (parentContext && parentContext.sceneFilter) {
            if (!parentContext.sceneFilter(MESH_TO_TEST)) return;
        }
        var map = this.getMap();
        if (!tileInfo || !map || !tileImage) return;
        var scale = tileInfo._glScale = tileInfo._glScale || tileInfo.res / map.getGLRes();
        var w = tileInfo.extent2d.xmax - tileInfo.extent2d.xmin;
        var h = tileInfo.extent2d.ymax - tileInfo.extent2d.ymin;
        if (tileInfo.cache !== false) this._bindGLBuffer(tileImage, w, h);
        if (!this.isGL()) {
            _ImageGLRenderable.prototype.drawTile.call(this, tileInfo, tileImage);
            return;
        }
        var { extent2d: extent2d, offset: offset } = tileInfo;
        var point = TILE_POINT.set(extent2d.xmin - offset[0], tileInfo.extent2d.ymax - offset[1]);
        var x = point.x * scale, y = point.y * scale;
        var opacity = this.getTileOpacity(tileImage, tileInfo);
        var debugInfo = null;
        if (this.layer.options['debug']) debugInfo = this.getDebugInfo(tileInfo.id);
        var gl = this.gl;
        gl.stencilFunc(gl.LEQUAL, Math.abs(this.getCurrentTileZoom() - tileInfo.z), 0xFF);
        var layerPolygonOffset = this.layer.getPolygonOffset();
        var polygonOffset = this.drawingCurrentTiles ? layerPolygonOffset : layerPolygonOffset + 1;
        gl.polygonOffset(polygonOffset, polygonOffset);
        this.drawGLImage(tileImage, x, y, w, h, scale, opacity, map._getResolution() !== tileInfo.res, debugInfo);
        if (this.getTileFadingOpacity(tileImage) < 1) this.setToRedraw();
        else this.setCanvasUpdated();
    };
    _proto._bindGLBuffer = function _bindGLBuffer(image, w, h) {
        if (!image.glBuffer) image.glBuffer = this.bufferTileData(0, 0, w, h);
    };
    _proto.loadTileImage = function loadTileImage(tileImage, url) {
        var crossOrigin = this.layer.options['crossOrigin'];
        tileImage.crossOrigin = crossOrigin !== null ? crossOrigin : '';
        tileImage.src = url;
        return;
    };
    _proto.onCanvasCreate = function onCanvasCreate() {
        if (!this.canvas.gl || !this.canvas.gl.wrap) this.createCanvas2();
    };
    _proto.createContext = function createContext() {
        _ImageGLRenderable.prototype.createContext.call(this);
        this.createGLContext();
    };
    _proto.resizeCanvas = function resizeCanvas(canvasSize) {
        if (!this.canvas) return;
        _ImageGLRenderable.prototype.resizeCanvas.call(this, canvasSize);
        this.resizeGLCanvas();
    };
    _proto.clearCanvas = function clearCanvas() {
        if (!this.canvas) return;
        _ImageGLRenderable.prototype.clearCanvas.call(this);
        this.clearGLCanvas();
    };
    _proto.getCanvasImage = function getCanvasImage() {
        if (!this.isGL() || !this.canvas2) return _ImageGLRenderable.prototype.getCanvasImage.call(this);
        var img = _ImageGLRenderable.prototype.getCanvasImage.call(this);
        if (img) img.image = this.canvas2;
        return img;
    };
    _proto.isGL = function isGL() {
        return true;
    };
    _proto.deleteTile = function deleteTile(tile) {
        _ImageGLRenderable.prototype.deleteTile.call(this, tile);
        if (tile && tile.image) this.disposeImage(tile.image);
        delete tile.image;
    };
    _proto.onRemove = function onRemove() {
        _ImageGLRenderable.prototype.onRemove.call(this);
        this.removeGLCanvas();
    };
    return TileLayerGLRenderer;
}(ImageGLRenderable(TileLayerCanvasRenderer));
TileLayer.registerRenderer('gl', TileLayerGLRenderer);
function _loadTile(tile) {
    var _this = this;
    var tileSize = this.layer.getTileSize();
    var canvasClass = this.canvas.constructor;
    var map = this.getMap();
    var r = map.getDevicePixelRatio();
    var tileCanvas = Canvas.createCanvas(tileSize['width'] * r, tileSize['height'] * r, canvasClass);
    tileCanvas['layer'] = this.layer;
    var point = new Point(tile['extent2d'].xmin, tile['extent2d'].ymax);
    var extent = new Extent(map.pointToCoordinate(point), map.pointToCoordinate(point.add(tileSize.width, tileSize.height)), map.getProjection());
    this.layer.drawTile(tileCanvas, {
        'url': tile['url'],
        'point': point,
        'center': map.pointToCoordinate(point.add(tileSize['width'] / 2, tileSize['height'] / 2)),
        'extent': extent,
        'z': tile['z'],
        'x': tile['x'],
        'y': tile['y']
    }, function(error) {
        if (error) {
            _this.onTileError(tileCanvas, tile);
            return;
        }
        _this.onTileLoad(tileCanvas, tile);
    });
    return tileCanvas;
}
var CanvasRenderer = function(_TileLayerCanvasRende) {
    function CanvasRenderer() {
        return _TileLayerCanvasRende.apply(this, arguments) || this;
    }
    _inheritsLoose(CanvasRenderer, _TileLayerCanvasRende);
    var _proto = CanvasRenderer.prototype;
    _proto.loadTile = function loadTile(...args) {
        return _loadTile.apply(this, args);
    };
    return CanvasRenderer;
}(TileLayerCanvasRenderer);
var GLRenderer = function(_TileLayerGLRenderer) {
    function GLRenderer() {
        return _TileLayerGLRenderer.apply(this, arguments) || this;
    }
    _inheritsLoose(GLRenderer, _TileLayerGLRenderer);
    var _proto2 = GLRenderer.prototype;
    _proto2.loadTile = function loadTile(...args) {
        return _loadTile.apply(this, args);
    };
    return GLRenderer;
}(TileLayerGLRenderer);
CanvasTileLayer.registerRenderer('canvas', CanvasRenderer);
CanvasTileLayer.registerRenderer('gl', GLRenderer);
var quadVertices = typeof Int8Array !== 'undefined' ? new Int8Array([
    -1,
    1,
    0,
    -1,
    -1,
    0,
    1,
    1,
    0,
    1,
    -1,
    0
]) : [];
var vert = "\n    attribute vec3 a_position;\n    uniform mat4 transform;\n\n    void main()\n    {\n        gl_Position = transform * vec4(a_position, 1.0);\n    }\n";
var frag = "\n    precision mediump float;\n    uniform vec3 color;\n    void main()\n    {\n        gl_FragColor = vec4(color, 1.0);\n    }\n";
var QuadStencil = function() {
    function QuadStencil(gl, vertices, debug) {
        this.gl = gl;
        this.quadVertices = vertices || quadVertices;
        this.attributes = [
            'a_position',
            3,
            getType(vertices)
        ];
        this.debug = debug;
    }
    var _proto = QuadStencil.prototype;
    _proto.start = function start() {
        var gl = this.gl;
        gl.enable(gl.STENCIL_TEST);
        gl.stencilMask(0xFF);
        gl.stencilOp(gl.KEEP, gl.REPLACE, gl.REPLACE);
        gl.depthMask(false);
        this._save();
        if (!this.buffer) {
            this._createBuffer();
            this._createProgram();
        }
        gl.useProgram(this.program);
        gl.bindBuffer(gl.ARRAY_BUFFER, this.buffer);
        enableVertexAttrib(gl, this.program, this.attributes);
        if (!this.transformLoc) this.transformLoc = gl.getUniformLocation(this.program, 'transform');
        if (!this.colorLoc) this.colorLoc = gl.getUniformLocation(this.program, 'color');
        if (this.debug) return;
        gl.colorMask(false, false, false, false);
    };
    _proto.end = function end() {
        var gl = this.gl;
        gl.depthMask(true);
        this._restore();
        if (this.debug) return;
        gl.colorMask(true, true, true, true);
    };
    _proto.draw = function draw(transform) {
        var gl = this.gl;
        gl.uniformMatrix4fv(this.transformLoc, false, transform);
        gl.uniform3fv(this.colorLoc, [
            Math.random(),
            Math.random(),
            Math.random()
        ]);
        gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
    };
    _proto.remove = function remove() {
        var gl = this.gl;
        if (this.buffer) gl.deleteBuffer(this.buffer);
        if (this.program) {
            gl.deleteShader(this.program.fragmentShader);
            gl.deleteShader(this.program.vertexShader);
            gl.deleteProgram(this.program);
        }
        delete this.transformLoc;
        delete this.gl;
        return this;
    };
    _proto.stencilMask = function stencilMask(mask) {
        this.gl.stencilMask(mask);
        return this;
    };
    _proto.stencilFunc = function stencilFunc(func, ref, mask) {
        this.ref = ref;
        this.gl.stencilFunc(func, ref, mask);
        return this;
    };
    _proto.stencilOp = function stencilOp(fail, zfail, zpass) {
        this.gl.stencilOp(fail, zfail, zpass);
        return this;
    };
    _proto.resetFunc = function resetFunc() {
        this.ref = 1;
        this.gl.stencilFunc(this.gl.ALWAYS, 1, 0xFF);
        return this;
    };
    _proto._save = function _save() {
        var gl = this.gl;
        this._savedProgram = gl.program;
    };
    _proto._restore = function _restore() {
        var gl = this.gl;
        gl.program = this._savedProgram;
        if (gl.program) gl.useProgram(gl.program);
    };
    _proto._createBuffer = function _createBuffer() {
        var gl = this.gl;
        this.buffer = gl.createBuffer();
        if (!this.buffer) throw new Error('Failed to create the buffer object');
        gl.bindBuffer(gl.ARRAY_BUFFER, this.buffer);
        gl.bufferData(gl.ARRAY_BUFFER, this.quadVertices, gl.STATIC_DRAW);
    };
    _proto._createProgram = function _createProgram() {
        var { program: program, vertexShader: vertexShader, fragmentShader: fragmentShader } = createProgram(this.gl, vert, frag);
        program.vertexShader = vertexShader;
        program.fragmentShader = fragmentShader;
        this.program = program;
    };
    return QuadStencil;
}();
function getType(arr) {
    if (arr instanceof Float32Array) return 'FLOAT';
    else if (arr instanceof Int16Array) return 'SHORT';
    else if (arr instanceof Uint16Array) return 'UNSIGNED_SHORT';
    else if (arr instanceof Int8Array) return 'BYTE';
    else if (arr instanceof Uint8Array || arr instanceof Uint8ClampedArray) return 'UNSIGNED_BYTE';
    return 'FLOAT';
}
var OverlayLayerRenderable = function OverlayLayerRenderable(Base) {
    var renderable = function(_Base) {
        function renderable() {
            return _Base.apply(this, arguments) || this;
        }
        _inheritsLoose(renderable, _Base);
        var _proto = renderable.prototype;
        _proto.checkResources = function checkResources() {
            var geometries = this._geosToCheck || [];
            if (!this._resourceChecked && this.layer._geoList) pushIn(geometries, this.layer._geoList);
            if (!isArrayHasData(geometries)) return [];
            var resources = [];
            var cache = {};
            for(var i = geometries.length - 1; i >= 0; i--){
                var geo = geometries[i];
                var res = geo._getExternalResources();
                if (!res.length) continue;
                if (!this.resources) resources.push(...res);
                else for(var _i = 0; _i < res.length; _i++){
                    var url = res[_i][0];
                    if (!this.resources.isResourceLoaded(res[_i]) && !cache[url]) {
                        resources.push(res[_i]);
                        cache[url] = 1;
                    }
                }
            }
            this._resourceChecked = true;
            delete this._geosToCheck;
            return resources;
        };
        _proto._addGeoToCheckRes = function _addGeoToCheckRes(res) {
            if (!res) return;
            if (!Array.isArray(res)) res = [
                res
            ];
            if (!this._geosToCheck) this._geosToCheck = [];
            pushIn(this._geosToCheck, res);
        };
        _proto.onGeometryAdd = function onGeometryAdd(geometries) {
            this._addGeoToCheckRes(geometries);
            redraw(this);
        };
        _proto.onGeometryRemove = function onGeometryRemove(params) {
            this.layer.fire('removegeo', {
                'type': 'removegeo',
                'target': this,
                'geometries': params
            });
            redraw(this);
        };
        _proto.onGeometrySymbolChange = function onGeometrySymbolChange(e) {
            this._addGeoToCheckRes(e.target);
            redraw(this);
        };
        _proto.onGeometryShapeChange = function onGeometryShapeChange(params) {
            redraw(this);
        };
        _proto.onGeometryPositionChange = function onGeometryPositionChange(params) {
            redraw(this);
        };
        _proto.onGeometryZIndexChange = function onGeometryZIndexChange(params) {
            redraw(this);
        };
        _proto.onGeometryShow = function onGeometryShow(params) {
            redraw(this);
        };
        _proto.onGeometryHide = function onGeometryHide(params) {
            redraw(this);
        };
        _proto.onGeometryPropertiesChange = function onGeometryPropertiesChange(_) {
            redraw(this);
        };
        return renderable;
    }(Base);
    return renderable;
};
var OverlayLayerCanvasRenderer = function(_OverlayLayerRenderab) {
    function OverlayLayerCanvasRenderer() {
        return _OverlayLayerRenderab.apply(this, arguments) || this;
    }
    _inheritsLoose(OverlayLayerCanvasRenderer, _OverlayLayerRenderab);
    var _proto2 = OverlayLayerCanvasRenderer.prototype;
    _proto2.render = function render(...args) {
        this.layer._sortGeometries();
        return _OverlayLayerRenderab.prototype.render.apply(this, args);
    };
    return OverlayLayerCanvasRenderer;
}(OverlayLayerRenderable(CanvasRenderer$1));
var OverlayLayerGLRenderer = function(_OverlayLayerRenderab2) {
    function OverlayLayerGLRenderer() {
        return _OverlayLayerRenderab2.apply(this, arguments) || this;
    }
    _inheritsLoose(OverlayLayerGLRenderer, _OverlayLayerRenderab2);
    var _proto3 = OverlayLayerGLRenderer.prototype;
    _proto3.render = function render(...args) {
        this.layer._sortGeometries();
        return _OverlayLayerRenderab2.prototype.render.apply(this, args);
    };
    return OverlayLayerGLRenderer;
}(OverlayLayerRenderable(LayerAbstractRenderer));
function redraw(renderer) {
    if (renderer instanceof OverlayLayerCanvasRenderer && renderer.layer.options['drawImmediate']) renderer.render();
    renderer.setToRedraw();
}
var TEMP_EXTENT = new PointExtent();
var TEMP_VEC3 = [];
var TEMP_FIXEDEXTENT = new PointExtent();
var PLACEMENT_CENTER = 'center';
function clearCanvas(canvas) {
    if (!canvas) return null;
    var ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    return ctx;
}
function isDebug(layer) {
    return layer && layer.options.progressiveRender && layer.options.progressiveRenderDebug;
}
var VectorLayerRenderer = function(_OverlayLayerCanvasRe) {
    function VectorLayerRenderer() {
        return _OverlayLayerCanvasRe.apply(this, arguments) || this;
    }
    _inheritsLoose(VectorLayerRenderer, _OverlayLayerCanvasRe);
    var _proto = VectorLayerRenderer.prototype;
    _proto.setToRedraw = function setToRedraw() {
        _OverlayLayerCanvasRe.prototype.setToRedraw.call(this);
        this._resetProgressiveRender();
        return this;
    };
    _proto._geoIsCollision = function _geoIsCollision(geo, collisionIndex) {
        if (!geo) return false;
        var collision = geo.options.collision;
        if (!collision) return false;
        if (geo.isPoint && geo.getContainerExtent) {
            if (!geo.bbox) geo.bbox = [
                0,
                0,
                0,
                0
            ];
            var bufferSize = this.layer.options['collisionBufferSize'];
            var extent = geo.getContainerExtent();
            if (!extent) return false;
            geo.bbox[0] = extent.xmin - bufferSize;
            geo.bbox[1] = extent.ymin - bufferSize;
            geo.bbox[2] = extent.xmax + bufferSize;
            geo.bbox[3] = extent.ymax + bufferSize;
            if (collisionIndex.collides(geo.bbox)) {
                geo._collided = true;
                return true;
            }
            collisionIndex.insertBox(geo.bbox);
        }
        return false;
    };
    _proto.getImageData = function getImageData() {
        if (!this._lastRenderTime || now() - this._lastRenderTime < 32) return null;
        if (!this.context || !this.context.canvas) return null;
        if (!this._imageData) {
            var { width: width, height: height } = this.context.canvas;
            try {
                var ctx = this.screenshotRenderResult(0, 0, width, height);
                if (ctx) this._imageData = ctx.getImageData(0, 0, width, height);
            } catch (error) {
                console.warn('hit detect failed with tainted canvas, some geometries have external resources in another domain:\n', error);
            }
        }
        return this._imageData;
    };
    _proto.clearImageData = function clearImageData() {
        this._imageData = null;
        delete this._imageData;
        this._lastRenderTime = now();
    };
    _proto.checkResources = function checkResources(...args) {
        var _this = this;
        var resources = _OverlayLayerCanvasRe.prototype.checkResources.apply(this, args);
        var style = this.layer.getStyle();
        if (style) {
            if (!Array.isArray(style)) style = [
                style
            ];
            style.forEach(function(s) {
                var res = getExternalResources(s['symbol'], true);
                for(var i = 0, l = res.length; i < l; i++)if (!_this.resources.isResourceLoaded(res[i])) resources.push(res[i]);
            });
        }
        return resources;
    };
    _proto.needToRedraw = function needToRedraw() {
        if (this.isProgressiveRender() && !this.renderEnd) return true;
        var map = this.getMap();
        if (map.isInteracting() && this.layer.options['enableAltitude']) return true;
        if (map.isZooming() && !map.isRotating() && !map.getPitch() && !this._hasPoint && this.layer.constructor === VectorLayer) return false;
        return _OverlayLayerCanvasRe.prototype.needToRedraw.call(this);
    };
    _proto.draw = function draw() {
        if (!this.getMap()) return;
        if (!this.layer.isVisible() || this.layer.isEmpty()) {
            this.clearCanvas();
            this.completeRender();
            return;
        }
        this.prepareCanvas();
        this.drawGeos();
        this.completeRender();
    };
    _proto.isBlank = function isBlank() {
        if (!this.context) return false;
        if (this.isProgressiveRender()) return false;
        return !this.context.canvas._drawn;
    };
    _proto.drawOnInteracting = function drawOnInteracting() {
        if (!this._geosToDraw) return;
        this._updateMapStateCache();
        this._updateDisplayExtent();
        var map = this.getMap();
        var count = this.layer.getCount();
        var res = this.mapStateCache.resolution;
        if (map.isZooming() && map.options['seamlessZoom'] && this._drawnRes !== undefined && res > this._drawnRes * 1.5 && this._geosToDraw.length < count || map.isMoving() || map.isInteracting()) {
            this.prepareToDraw();
            this._batchConversionMarkers(this.mapStateCache.glRes);
            if (!this._onlyHasPoint) this._checkGeos();
            this._drawnRes = res;
        }
        this._sortByDistanceToCamera(map.cameraPosition);
        var { collision: collision, collisionDelay: collisionDelay } = this.layer.options;
        if (collision) {
            var time = now();
            if (!this._lastCollisionTime) this._lastCollisionTime = time;
            if (time - this._lastCollisionTime <= collisionDelay) this._geosToDraw = this._lastGeosToDraw || this._geosToDraw;
            else {
                this._collidesGeos();
                this._lastCollisionTime = time;
            }
        }
        for(var i = 0, l = this._geosToDraw.length; i < l; i++){
            var geo = this._geosToDraw[i];
            if (!geo._isCheck) {
                if (!geo.isVisible()) {
                    delete geo._cPoint;
                    delete geo._inCurrentView;
                    continue;
                }
            }
            geo._paint(this._displayExtent);
            this._geosToDraw[i]._cPoint = undefined;
            this._geosToDraw[i]._inCurrentView = undefined;
        }
        this.clearImageData();
        this._lastGeosToDraw = this._geosToDraw;
        if (isDebug(this.layer)) console.log('progressiveRender on drawOnInteracting page:', this.page);
    };
    _proto.show = function show(...args) {
        this.layer.forEach(function(geo) {
            geo._repaint();
        });
        _OverlayLayerCanvasRe.prototype.show.apply(this, args);
    };
    _proto.forEachGeo = function forEachGeo(fn, context) {
        this.layer.forEach(fn, context);
    };
    _proto._checkGeos = function _checkGeos() {
        var geos = this._getCurrentNeedRenderGeos();
        for(var i = 0, len = geos.length; i < len; i++)this.checkGeo(geos[i]);
        return this;
    };
    _proto.drawGeos = function drawGeos() {
        this._drawSnapshot();
        this._updateMapStateCache();
        this._drawnRes = this.mapStateCache.resolution;
        this._updateDisplayExtent();
        this.prepareToDraw();
        this._batchConversionMarkers(this.mapStateCache.glRes);
        if (!this._onlyHasPoint) this._checkGeos();
        this._sortByDistanceToCamera(this.getMap().cameraPosition);
        this._collidesGeos();
        for(var i = 0, len = this._geosToDraw.length; i < len; i++){
            this._geosToDraw[i]._paint();
            this._geosToDraw[i]._cPoint = undefined;
            this._geosToDraw[i]._inCurrentView = undefined;
        }
        this.clearImageData();
        this._lastGeosToDraw = this._geosToDraw;
        if (isDebug(this.layer)) console.log('progressiveRender drawGeos page:', this.page);
        this._snapshot();
        this._setDrawGeosDrawTime();
    };
    _proto.prepareToDraw = function prepareToDraw() {
        this.layer._drawTime = now();
        this._hasPoint = false;
        this._geosToDraw = [];
        return this;
    };
    _proto._setDrawGeosDrawTime = function _setDrawGeosDrawTime() {
        var time = now();
        var drawTime = this.layer._drawTime;
        var painterList = this.getGeoPainterList();
        for(var i = 0, len = painterList.length; i < len; i++){
            var painter = painterList[i];
            if (painter && painter._setDrawTime) painter._setDrawTime(drawTime);
        }
        if (isDebug(this.layer)) console.log('_setDrawGeosDrawTime time:', now() - time + 'ms');
        return this;
    };
    _proto.checkGeo = function checkGeo(geo) {
        if (geo.isPoint && this._onlyHasPoint !== undefined) {
            if (geo._inCurrentView || geo.hasAltitude()) {
                this._hasPoint = true;
                geo._isCheck = true;
                this._geosToDraw.push(geo);
            }
            return;
        }
        geo._isCheck = false;
        if (!geo || !geo.isVisible() || !geo.getMap() || !geo.getLayer() || !geo.getLayer().isCanvasRender()) return;
        var painter = geo._getPainter();
        var inCurrentView = true;
        if (geo._inCurrentView || !isNil(geo.options.arcDegree) || geo.hasAltitude()) inCurrentView = true;
        else if (geo._inCurrentView === false) inCurrentView = false;
        else {
            var extent2D = painter.get2DExtent(this.resources, TEMP_EXTENT);
            if (!extent2D || !extent2D.intersects(this._displayExtent)) inCurrentView = false;
        }
        if (!inCurrentView) return;
        if (painter.hasPoint()) this._hasPoint = true;
        geo._isCheck = true;
        this._geosToDraw.push(geo);
    };
    _proto._collidesGeos = function _collidesGeos() {
        var geos = this._geosToDraw;
        var collision = this.layer.options['collision'];
        if (!collision) {
            for(var i = 0, len = geos.length; i < len; i++){
                var geo = geos[i];
                if (geo.isPoint) geo._collided = false;
            }
            return this;
        }
        var collisionScope = this.layer.options['collisionScope'];
        var collisionIndex = this.layer.getCollisionIndex();
        if (collisionScope === 'layer') collisionIndex.clear();
        this._geosToDraw = [];
        for(var _i = 0, _len = geos.length; _i < _len; _i++){
            var _geo = geos[_i];
            if (_geo.isPoint) {
                _geo._collided = false;
                if (this._geoIsCollision(_geo, collisionIndex)) {
                    _geo._collided = true;
                    continue;
                }
            }
            this._geosToDraw.push(geos[_i]);
        }
        return this;
    };
    _proto.onZoomEnd = function onZoomEnd(...args) {
        delete this.canvasExtent2D;
        _OverlayLayerCanvasRe.prototype.onZoomEnd.apply(this, args);
    };
    _proto.onRemove = function onRemove() {
        this.forEachGeo(function(g) {
            g.onHide();
        });
        delete this._geosToDraw;
        delete this.snapshotCanvas;
        delete this.pageGeos;
        delete this.geoPainterList;
    };
    _proto.onGeometryPropertiesChange = function onGeometryPropertiesChange(param) {
        if (param) this.layer._styleGeometry(param['target']);
        _OverlayLayerCanvasRe.prototype.onGeometryPropertiesChange.call(this, param);
    };
    _proto._updateDisplayExtent = function _updateDisplayExtent() {
        var extent2D = this.canvasExtent2D;
        if (this._maskExtent) {
            if (!this._maskExtent.intersects(extent2D)) {
                this.completeRender();
                return;
            }
            extent2D = extent2D.intersection(this._maskExtent);
        }
        this._displayExtent = extent2D;
    };
    _proto.identifyAtPoint = function identifyAtPoint(point, options = {}) {
        var geometries = this.getGeosForIdentify();
        if (!geometries) return [];
        return this.layer._hitGeos(geometries, point, options);
    };
    _proto._updateMapStateCache = function _updateMapStateCache() {
        var map = this.getMap();
        var offset = map._pointToContainerPoint(this.middleWest)._add(0, -map.height / 2);
        var resolution = map.getResolution();
        var pitch = map.getPitch();
        var bearing = map.getBearing();
        var glScale = map.getGLScale();
        var glRes = map.getGLRes();
        var containerExtent = map.getContainerExtent();
        var _2DExtent = map.get2DExtent();
        var glExtent = map.get2DExtentAtRes(glRes);
        this.mapStateCache = {
            resolution: resolution,
            pitch: pitch,
            bearing: bearing,
            glScale: glScale,
            glRes: glRes,
            _2DExtent: _2DExtent,
            glExtent: glExtent,
            containerExtent: containerExtent,
            offset: offset
        };
        return this;
    };
    _proto._batchConversionMarkers = function _batchConversionMarkers(glRes) {
        this._onlyHasPoint = undefined;
        if (!this._constructorIsThis()) return [];
        var cPoints = [];
        var markers = [];
        var altitudes = [];
        var altitudeCache = {};
        var layer = this.layer;
        var layerOpts = layer.options;
        var layerAltitude = layer.getAltitude ? layer.getAltitude() : 0;
        var isCanvasRender = layer.isCanvasRender();
        this._onlyHasPoint = true;
        var idx = 0;
        var geos = this._getCurrentNeedRenderGeos();
        for(var i = 0, len = geos.length; i < len; i++){
            var geo = geos[i];
            if (geo.isPoint) {
                var painter = geo._painter;
                if (!painter) painter = geo._getPainter();
                var point = painter.getRenderPoints(PLACEMENT_CENTER)[0][0];
                var altitude = layerOpts['enableAltitude'] ? geo._getAltitude() : layerAltitude;
                if (altitudeCache[altitude] === undefined) altitudeCache[altitude] = painter.getAltitude();
                cPoints[idx] = point;
                altitudes[idx] = altitudeCache[altitude];
                markers[idx] = geo;
                idx++;
            } else this._onlyHasPoint = false;
        }
        if (idx === 0) return [];
        var map = this.getMap();
        var pts = getPointsResultPts(cPoints, '_pt');
        pts = map._pointsAtResToContainerPoints(cPoints, glRes, altitudes, pts);
        var containerExtent = map.getContainerExtent();
        var { xmax: xmax, ymax: ymax, xmin: xmin, ymin: ymin } = containerExtent;
        var extentCache = {};
        for(var _i2 = 0, _len2 = markers.length; _i2 < _len2; _i2++){
            var _geo2 = markers[_i2];
            _geo2._cPoint = pts[_i2];
            if (!_geo2._cPoint) {
                _geo2._inCurrentView = false;
                continue;
            }
            var { x: x, y: y } = pts[_i2];
            _geo2._inCurrentView = x >= xmin && y >= ymin && x <= xmax && y <= ymax || _geo2.hasAltitude();
            if (!_geo2._inCurrentView) {
                var symbolkey = _geo2.getSymbolHash();
                var fixedExtent = void 0;
                if (symbolkey) fixedExtent = extentCache[symbolkey] = extentCache[symbolkey] || _geo2._painter.getFixedExtent();
                else fixedExtent = _geo2._painter.getFixedExtent();
                TEMP_FIXEDEXTENT.set(fixedExtent.xmin, fixedExtent.ymin, fixedExtent.xmax, fixedExtent.ymax);
                TEMP_FIXEDEXTENT._add(pts[_i2]);
                _geo2._inCurrentView = TEMP_FIXEDEXTENT.intersects(containerExtent);
            }
            if (_geo2._inCurrentView) {
                if (!_geo2.isVisible() || !isCanvasRender) _geo2._inCurrentView = false;
                if (this._onlyHasPoint && _geo2._inCurrentView) {
                    this._hasPoint = true;
                    _geo2._isCheck = true;
                    this._geosToDraw.push(_geo2);
                }
            }
        }
        return pts;
    };
    _proto._sortByDistanceToCamera = function _sortByDistanceToCamera(cameraPosition) {
        if (!this.layer.options['sortByDistanceToCamera']) return;
        if (!this._geosToDraw.length) return;
        var map = this.getMap();
        var p = map.distanceToPoint(1000, 0, map.getGLScale()).x;
        var meterScale = p / 1000;
        var placement = 'center';
        this._geosToDraw.sort(function(a, b) {
            if (!a.isPoint || !b.isPoint) return 0;
            var painter0 = a._painter;
            var painter1 = b._painter;
            if (!painter0 || !painter1) return 0;
            var point0 = painter0.getRenderPoints(placement)[0][0];
            var point1 = painter1.getRenderPoints(placement)[0][0];
            var alt0 = painter0.getAltitude() * meterScale;
            var alt1 = painter1.getAltitude() * meterScale;
            set(TEMP_VEC3, point0.x, point0.y, alt0);
            var dist0 = distance(TEMP_VEC3, cameraPosition);
            set(TEMP_VEC3, point1.x, point1.y, alt1);
            var dist1 = distance(TEMP_VEC3, cameraPosition);
            return dist1 - dist0;
        });
    };
    _proto._constructorIsThis = function _constructorIsThis() {
        return this.constructor === VectorLayerRenderer;
    };
    _proto.isProgressiveRender = function isProgressiveRender() {
        var layer = this.layer;
        if (!layer) return false;
        var { progressiveRender: progressiveRender, collision: collision } = layer.options || {};
        if (collision) return false;
        return progressiveRender;
    };
    _proto.getGeosForIdentify = function getGeosForIdentify() {
        if (!this.isProgressiveRender()) return this._geosToDraw || [];
        return this.pageGeos || [];
    };
    _proto.getGeoPainterList = function getGeoPainterList() {
        if (!this.isProgressiveRender()) {
            var list = [];
            var geos = this._geosToDraw || [];
            for(var i = 0, len = geos.length; i < len; i++)list.push(geos[i]._painter);
            return list;
        }
        return this.geoPainterList || [];
    };
    _proto._checkSnapshotCanvas = function _checkSnapshotCanvas() {
        if (!this.isProgressiveRender()) {
            delete this.snapshotCanvas;
            return null;
        }
        var canvas = this.canvas;
        if (!canvas) {
            delete this.snapshotCanvas;
            return null;
        }
        if (!this.snapshotCanvas) this.snapshotCanvas = Canvas.createCanvas(1, 1);
        var snapshotCanvas = this.snapshotCanvas;
        var { width: width, height: height, style: style } = canvas;
        if (snapshotCanvas.width !== width || snapshotCanvas.height !== height) {
            snapshotCanvas.width = width;
            snapshotCanvas.height = height;
        }
        if (snapshotCanvas.style.width !== style.width || snapshotCanvas.style.height !== style.height) {
            snapshotCanvas.style.width = style.width;
            snapshotCanvas.style.height = style.height;
        }
        return snapshotCanvas;
    };
    _proto._getCurrentNeedRenderGeos = function _getCurrentNeedRenderGeos() {
        var geos = this.layer._geoList || [];
        if (!this.isProgressiveRender()) return geos;
        var layer = this.layer;
        var { progressiveRenderCount: progressiveRenderCount } = layer.options;
        var pageSize = progressiveRenderCount;
        var page = this.page;
        var start = (page - 1) * pageSize, end = page * pageSize;
        var pageGeos = geos.slice(start, end);
        return pageGeos;
    };
    _proto._resetProgressiveRender = function _resetProgressiveRender() {
        if (isDebug(this.layer)) console.log('progressiveRender resetProgressiveRender');
        this.renderEnd = false;
        this.page = 1;
        this.pageGeos = [];
        this.geoPainterList = [];
        this.maxTolerance = 0;
        this._clearSnapshotCanvas();
    };
    _proto._clearSnapshotCanvas = function _clearSnapshotCanvas() {
        var snapshotCanvas = this._checkSnapshotCanvas();
        if (snapshotCanvas) clearCanvas(snapshotCanvas);
    };
    _proto._snapshot = function _snapshot() {
        var progressiveRender = this.isProgressiveRender();
        var geosToDraw = this._geosToDraw || [];
        for(var i = 0, len = geosToDraw.length; i < len; i++){
            var geo = geosToDraw[i];
            var t = geo._hitTestTolerance() || 0;
            this.maxTolerance = Math.max(this.maxTolerance, t);
            if (progressiveRender) {
                this.pageGeos.push(geo);
                var painter = geo._painter;
                this.geoPainterList.push(painter);
            }
        }
        if (!progressiveRender) return this;
        var time = now();
        var snapshotCanvas = this._checkSnapshotCanvas();
        if (snapshotCanvas && this.canvas) {
            var ctx = clearCanvas(snapshotCanvas);
            ctx.drawImage(this.canvas, 0, 0);
        }
        var layer = this.layer;
        var { progressiveRenderCount: progressiveRenderCount } = layer.options;
        var geos = layer._geoList || [];
        var pages = Math.ceil(geos.length / progressiveRenderCount);
        this.renderEnd = this.page >= pages;
        if (this.renderEnd) this._setDrawGeosDrawTime();
        if (isDebug(this.layer)) console.log('snapshot time:', now() - time + 'ms');
        if (!this.renderEnd) this.page++;
        return this;
    };
    _proto._drawSnapshot = function _drawSnapshot() {
        if (!this.isProgressiveRender()) return this;
        var { snapshotCanvas: snapshotCanvas, context: context } = this;
        if (!snapshotCanvas || !context) return this;
        var map = this.getMap();
        if (!map) return this;
        var dpr = this.mapDPR || map.getDevicePixelRatio() || 1;
        var rScale = 1 / dpr;
        this._canvasContextScale(context, rScale);
        context.drawImage(snapshotCanvas, 0, 0);
        this._canvasContextScale(context, dpr);
        return this;
    };
    return VectorLayerRenderer;
}(OverlayLayerCanvasRenderer);
VectorLayer.registerRenderer('canvas', VectorLayerRenderer);
var MapRenderer = function(_Class) {
    function MapRenderer(map) {
        var _this;
        _this = _Class.call(this) || this;
        _this.map = map;
        _this._handlerQueue = [];
        _this._thisDocVisibilitychange = _this._onDocVisibilitychange.bind(_this);
        _this._thisDocDragStart = _this._onDocDragStart.bind(_this);
        _this._thisDocDragEnd = _this._onDocDragEnd.bind(_this);
        _this._thisDocDPRChange = _this._onDocDPRChange.bind(_this);
        return _this;
    }
    _inheritsLoose(MapRenderer, _Class);
    var _proto = MapRenderer.prototype;
    _proto._getAllLayerToRender = function _getAllLayerToRender() {
        return this.map._getLayers();
    };
    _proto.setToRedraw = function setToRedraw() {
        var layers = this._getAllLayerToRender();
        for(var i = 0, l = layers.length; i < l; i++){
            var renderer = layers[i].getRenderer();
            if (renderer && renderer.canvas && renderer.setToRedraw) renderer.setToRedraw();
        }
    };
    _proto.callInNextFrame = function callInNextFrame(fn) {
        this._handlerQueue.push(fn);
    };
    _proto.executeFrameCallbacks = function executeFrameCallbacks() {
        var running = this._handlerQueue;
        this._handlerQueue = [];
        for(var i = 0, l = running.length; i < l; i++)running[i]();
    };
    _proto.offsetPlatform = function offsetPlatform(offset, force) {
        if (!this.map.getPanels().front) return this;
        if (!force && offset.x === 0 && offset.y === 0) return this;
        var panels = this.map.getPanels();
        var hasFront = this._frontCount = panels.back.layerDOM.childElementCount;
        var hasBack = this._backCount = panels.front.layerDOM.childElementCount;
        var hasUI = this._uiCount = panels.front.uiDOM.childElementCount;
        if (hasFront || hasBack || hasUI) {
            var pos = this.map.offsetPlatform();
            if (offset) pos = pos.add(offset)._round();
            else pos = pos.round();
            if (hasBack) offsetDom(panels.back, pos);
            if (hasFront || hasUI) offsetDom(panels.front, pos);
        }
        return this;
    };
    _proto.domChanged = function domChanged() {
        var panels = this.map.getPanels();
        if (!panels.front) return false;
        var frontCount = panels.back.layerDOM.childElementCount;
        if (this._frontCount === undefined || this._frontCount !== frontCount) return true;
        var backCount = panels.front.layerDOM.childElementCount;
        if (this._backCount === undefined || this._backCount !== backCount) return true;
        var uiCount = panels.front.uiDOM.childElementCount;
        if (this._uiCount === undefined || this._uiCount !== uiCount) return true;
        return false;
    };
    _proto.resetContainer = function resetContainer() {
        if (!this.map) return;
        this.map._resetMapViewPoint();
        if (this.map.getPanels().front) {
            var pos = new Point(0, 0);
            offsetDom(this.map.getPanels().back, pos);
            offsetDom(this.map.getPanels().front, pos);
        }
    };
    _proto.onZoomEnd = function onZoomEnd() {
        this.resetContainer();
    };
    _proto._onDocVisibilitychange = function _onDocVisibilitychange() {
        if (document.visibilityState !== 'visible') return;
        this.setToRedraw();
    };
    _proto._getWrapPanel = function _getWrapPanel() {
        if (!this.map) return null;
        var panels = this.map.getPanels();
        return panels && panels.mapWrapper;
    };
    _proto._onDocDragStart = function _onDocDragStart() {
        var wrapPanel = this._getWrapPanel();
        if (wrapPanel) wrapPanel.style.overflow = 'visible';
        return;
    };
    _proto._onDocDragEnd = function _onDocDragEnd() {
        var wrapPanel = this._getWrapPanel();
        if (wrapPanel) wrapPanel.style.overflow = 'hidden';
        return;
    };
    _proto._onDocDPRChange = function _onDocDPRChange() {
        var map = this.map;
        if (!map || !map.options || map.options['devicePixelRatio'] || !map.checkSize || !map.getRenderer) return;
        var renderer = map.getRenderer();
        if (renderer) map.checkSize(true);
    };
    _proto._containerIsOffscreen = function _containerIsOffscreen() {
        var container = this.map.getContainer();
        if (!container || !container.style || container.style.display === 'none') return true;
        var minSize = Math.min(container.clientWidth, container.clientHeight);
        return minSize <= 0;
    };
    return MapRenderer;
}(Class);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
typeof SuppressedError === "function" && SuppressedError;
var tempCollisionIndex = new CollisionIndex();
var MapAbstractRenderer = function(_MapRenderer) {
    function MapAbstractRenderer(map) {
        var _this;
        _this = _MapRenderer.call(this, map) || this;
        _this.ready = false;
        _this._containerIsCanvas = !!map.getContainer().getContext;
        _this._registerEvents();
        _this._loopTime = 0;
        _this._resizeEventList = [];
        _this._resizeTime = -Infinity;
        _this._frameCycleRenderCount = 0;
        return _this;
    }
    _inheritsLoose(MapAbstractRenderer, _MapRenderer);
    var _proto = MapAbstractRenderer.prototype;
    _proto.load = function load() {
        this.initContainer();
    };
    _proto.renderFrame = function renderFrame(framestamp) {
        var map = this.map;
        if (!map || !map.options['renderable']) return false;
        this._handleResizeEventList(framestamp);
        if (map.options['stopRenderOnOffscreen'] && this._containerIsOffscreen()) return false;
        this._updateDomPosition(framestamp);
        delete this._isViewChanged;
        map._fireEvent('framestart');
        this.updateMapDOM();
        map.clearCollisionIndex();
        var layers = this._getAllLayerToRender();
        var updated = this.drawLayers(layers, framestamp);
        if (updated) this.drawTops();
        map._fireEvent('frameend');
        this._recordView();
        this._mapview = this._getMapView();
        delete this._spatialRefChanged;
        this._fireLayerLoadEvents(layers);
        this.executeFrameCallbacks();
        map.uiCollides();
        return true;
    };
    _proto.getFrameTimestamp = function getFrameTimestamp() {
        return this._frameTimestamp || 0;
    };
    _proto.updateMapDOM = function updateMapDOM() {
        var map = this.map;
        if (map.isZooming()) return;
        var offset = map.getViewPointFrameOffset();
        if (offset) map.offsetPlatform(offset);
        else if (this.domChanged()) this.offsetPlatform(null, true);
    };
    _proto.checkIfNeedToRedrawLayers = function checkIfNeedToRedrawLayers(layers) {
        if (this.isSpatialReferenceChanged()) return true;
        for(var i = 0, len = layers.length; i < len; i++){
            if (this._checkLayerRedraw(layers[i])) return true;
        }
        return false;
    };
    _proto.drawLayers = function drawLayers(layers, framestamp) {
        var needRedraw = this.checkIfNeedToRedrawLayers(layers);
        if (!needRedraw && !this.map.options['forceRedrawPerFrame']) return false;
        this.clearCanvas();
        var map = this.map, isInteracting = map.isInteracting(), l = layers.length;
        for(var i = 0; i < l; i++){
            var layer = layers[i];
            if (!layer.isVisible()) continue;
            var isCanvas = layer.isCanvasRender();
            var renderer = layer._getRenderer();
            if (!renderer) continue;
            if (isCanvas) this.clearLayerCanvasContext(layer);
            if (isInteracting && isCanvas) this._drawCanvasLayerOnInteracting(layer, 0, 0, framestamp);
            else if (isInteracting && renderer.drawOnInteracting) {
                if (renderer.prepareRender) renderer.prepareRender();
                if (renderer.checkAndDraw) renderer.checkAndDraw(renderer.drawOnInteracting, this._eventParam, framestamp);
                else renderer.drawOnInteracting(this._eventParam, framestamp);
            } else renderer.render(framestamp);
        }
        return true;
    };
    _proto._checkLayerRedraw = function _checkLayerRedraw(layer) {
        if (this.isSpatialReferenceChanged()) return true;
        var map = this.map;
        var renderer = layer._getRenderer();
        if (!renderer) return false;
        if (layer.isCanvasRender()) return renderer.testIfNeedRedraw();
        else {
            if (renderer.needToRedraw && renderer.needToRedraw()) return true;
            return map.isInteracting() || this.isViewChanged();
        }
    };
    _proto._drawCanvasLayerOnInteracting = function _drawCanvasLayerOnInteracting(layer, t, timeLimit, framestamp) {
        var renderer = layer._getRenderer();
        if (renderer.mustRenderOnInteracting && renderer.mustRenderOnInteracting()) renderer.render(framestamp);
        else if (renderer.drawOnInteracting) {
            renderer.prepareRender();
            var canvas = renderer.prepareCanvas();
            if (renderer.checkAndDraw) renderer.checkAndDraw(renderer.drawOnInteracting, this._eventParam, framestamp);
            else renderer.drawOnInteracting(this._eventParam, framestamp);
            return canvas;
        }
        return null;
    };
    _proto._fireLayerLoadEvents = function _fireLayerLoadEvents(layers) {
        for(var i = layers.length - 1; i >= 0; i--){
            var layer = layers[i];
            var renderer = layer._getRenderer();
            if (!renderer || !renderer.isRenderComplete()) continue;
            layer.fire('layerload');
        }
    };
    _proto.updateMapSize = function updateMapSize(size) {
        if (!size || this._containerIsCanvas) return;
        var width = size['width'] + 'px', height = size['height'] + 'px';
        var panels = this.map.getPanels();
        panels.mapWrapper.style.width = width;
        panels.mapWrapper.style.height = height;
        this._updateCanvasSize();
    };
    _proto.getMainPanel = function getMainPanel() {
        if (!this.map) return null;
        if (this._containerIsCanvas) return this.map.getContainer();
        if (this.map.getPanels()) return this.map.getPanels().mapWrapper;
        return null;
    };
    _proto.toDataURL = function toDataURL(mimeType, quality) {
        if (!this.canvas) return null;
        return this.canvas.toDataURL(mimeType, quality);
    };
    _proto.remove = function remove() {
        if (Browser$1.webgl && typeof document !== 'undefined') {
            GlobalEvent.off(EVENT_DPR_CHANGE, this._thisDocDPRChange, this);
            GlobalEvent.off(EVENT_DOC_VISIBILITY_CHANGE, this._thisDocVisibilitychange, this);
            GlobalEvent.off(EVENT_DOC_DRAGSTART, this._thisDocDragStart, this);
            GlobalEvent.off(EVENT_DOC_DRAGEND, this._thisDocDragEnd, this);
        }
        if (this._resizeInterval) clearInterval(this._resizeInterval);
        if (this._resizeObserver) this._resizeObserver.disconnect();
        delete this.canvas;
        delete this.map;
        delete this._spatialRefChanged;
        this._cancelFrameLoop();
    };
    _proto.hitDetect = function hitDetect(point) {
        var map = this.map;
        if (!map || !map.options['hitDetect'] || map.isInteracting()) return;
        var layers = map._getLayers();
        var cursor = 'default';
        var limit = map.options['hitDetectLimit'] || 0;
        var counter = 0;
        if (point && point._round) point._round();
        for(var i = layers.length - 1; i >= 0; i--){
            var layer = layers[i];
            if (!layer.options['hitDetect'] || layer.isEmpty && layer.isEmpty() || !layer.options['geometryEvents']) continue;
            var renderer = layer._getRenderer();
            if (!renderer || !renderer.hitDetect) continue;
            if (renderer.isBlank && renderer.isBlank()) continue;
            if (layer.options['cursor'] !== 'default' && renderer.hitDetect(point)) {
                cursor = layer.options['cursor'] || 'pointer';
                break;
            }
            counter++;
            if (limit > 0 && counter > limit) break;
        }
        map._trySetCursor(cursor);
    };
    _proto.initContainer = function initContainer() {
        var panels = this.map.getPanels();
        function createContainer(name, className, cssText, enableSelect) {
            var c = createEl('div', className);
            if (cssText) c.style.cssText = cssText;
            panels[name] = c;
            if (!enableSelect) preventSelection(c);
            return c;
        }
        var containerDOM = this.map.getContainer();
        if (this._containerIsCanvas) {
            this.createCanvas();
            return;
        }
        containerDOM.innerHTML = '';
        var POSITION0 = 'position:absolute;top:0px;left:0px;';
        var mapWrapper = createContainer('mapWrapper', 'maptalks-wrapper', 'position:absolute;overflow:hidden;', true), mapAllLayers = createContainer('allLayers', 'maptalks-all-layers', POSITION0 + 'padding:0px;margin:0px;z-index:0;overflow:visible;', true), backStatic = createContainer('backStatic', 'maptalks-back-static', POSITION0 + 'z-index:0;', true), back = createContainer('back', 'maptalks-back', POSITION0 + 'z-index:1;'), backLayer = createContainer('backLayer', 'maptalks-back-layer', POSITION0), canvasContainer = createContainer('canvasContainer', 'maptalks-canvas-layer', POSITION0 + 'border:none;z-index:2;'), frontStatic = createContainer('frontStatic', 'maptalks-front-static', POSITION0 + 'z-index:3;', true), front = createContainer('front', 'maptalks-front', POSITION0 + 'z-index:4;', true), frontLayer = createContainer('frontLayer', 'maptalks-front-layer', POSITION0 + 'z-index:0;'), ui = createContainer('ui', 'maptalks-ui', POSITION0 + 'border:none;z-index:1;', true), control = createContainer('control', 'maptalks-control', 'z-index:1', true);
        containerDOM.appendChild(mapWrapper);
        mapAllLayers.appendChild(backStatic);
        back.appendChild(backLayer);
        back.layerDOM = backLayer;
        mapAllLayers.appendChild(back);
        mapAllLayers.appendChild(canvasContainer);
        front.appendChild(frontLayer);
        front.layerDOM = frontLayer;
        front.uiDOM = ui;
        mapAllLayers.appendChild(frontStatic);
        mapAllLayers.appendChild(front);
        front.appendChild(ui);
        mapWrapper.appendChild(mapAllLayers);
        mapWrapper.appendChild(control);
        this.createCanvas();
        this.resetContainer();
        var mapSize = this.map._getContainerDomSize();
        this.updateMapSize(mapSize);
    };
    _proto.isViewChanged = function isViewChanged() {
        if (this._isViewChanged !== undefined) return this._isViewChanged;
        var previous = this._mapview;
        var view = this._getMapView();
        this._isViewChanged = !previous || !equalMapView(previous, view);
        return this._isViewChanged;
    };
    _proto._recordView = function _recordView() {
        var map = this.map;
        if (!map._onViewChange || map.isInteracting() || map.isAnimating()) return;
        if (!equalMapView(map.getView(), map._getCurrentView())) map._onViewChange(map.getView());
    };
    _proto.isSpatialReferenceChanged = function isSpatialReferenceChanged() {
        return this._spatialRefChanged;
    };
    _proto._getMapView = function _getMapView() {
        var map = this.map;
        var center = map._getPrjCenter();
        return {
            x: center.x,
            y: center.y,
            zoom: map.getZoom(),
            pitch: map.getPitch(),
            bearing: map.getBearing(),
            width: map.width,
            height: map.height
        };
    };
    _proto._lockFrameRenderEnable = function _lockFrameRenderEnable() {
        var { maxFPS: maxFPS } = this.map.options || {};
        if (maxFPS <= 0 || GlobalConfig.maxFPS <= maxFPS) return true;
        var count = Math.ceil(GlobalConfig.maxFPS / maxFPS);
        return this._frameCycleRenderCount >= count;
    };
    _proto.onLoad = function onLoad() {
        this._frameLoop(0);
    };
    _proto._frameLoop = function _frameLoop(framestamp) {
        if (!this.map) {
            this._cancelFrameLoop();
            return;
        }
        if (!this._bindFrameLoop) this._bindFrameLoop = this._frameLoop.bind(this);
        if (!this.ready) {
            this._animationFrame = requestAnimFrame(this._bindFrameLoop);
            return;
        }
        this._frameCycleRenderCount++;
        if (this._lockFrameRenderEnable()) {
            framestamp = framestamp || 0;
            this._frameTimestamp = framestamp;
            this._resizeCount = 0;
            this.renderFrame(framestamp);
            this._frameCycleRenderCount = 0;
        } else if (this.map.options.debug) console.log('skip framing, frameCycleRenderCount:', this._frameCycleRenderCount);
        this._animationFrame = requestAnimFrame(this._bindFrameLoop);
    };
    _proto._cancelFrameLoop = function _cancelFrameLoop() {
        delete this._bindFrameLoop;
        if (this._animationFrame) cancelAnimFrame(this._animationFrame);
    };
    _proto._updateCanvasSize = function _updateCanvasSize() {
        if (!this.canvas || this._containerIsCanvas) return;
        var map = this.map, mapSize = map.getSize(), canvas = this.canvas, r = map.getDevicePixelRatio();
        var { width: width, height: height, cssWidth: cssWidth, cssHeight: cssHeight } = calCanvasSize(mapSize, r);
        if (canvas.style && (canvas.style.width !== cssWidth || canvas.style.height !== cssHeight)) {
            canvas.style.width = cssWidth;
            canvas.style.height = cssHeight;
        }
        if (width !== canvas.width || height !== canvas.height) {
            canvas.width = width;
            canvas.height = height;
        }
        var topLayer = this.topLayer;
        if (topLayer && (width !== topLayer.width || height !== topLayer.height)) {
            topLayer.width = width;
            topLayer.height = height;
            topLayer.style.width = cssWidth;
            topLayer.style.height = cssHeight;
        }
    };
    _proto.createCanvas = function createCanvas() {
        var _this2 = this;
        if (this._containerIsCanvas) this.canvas = this.map.getContainer();
        else {
            this.canvas = createEl('canvas');
            var panels = this.map.getPanels();
            var canvasContainer = panels.canvasContainer;
            canvasContainer.appendChild(this.canvas);
            this._updateCanvasSize();
        }
        this.createContext().then(function() {
            _this2.ready = true;
        });
    };
    _proto.createContext = function createContext() {
        return __awaiter(this, void 0, void 0, _regeneratorRuntime().mark(function _callee() {
            return _regeneratorRuntime().wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                    case "end":
                        return _context.stop();
                }
            }, _callee);
        }));
    };
    _proto.clearLayerCanvasContext = function clearLayerCanvasContext(_layer) {};
    _proto.clearCanvas = function clearCanvas() {};
    _proto.createTopCanvas = function createTopCanvas() {
        this.topLayer = createEl('canvas');
        var panels = this.map.getPanels();
        var canvasContainer = panels.canvasContainer;
        canvasContainer.insertBefore(this.topLayer, this.canvas);
        this.topCtx = this.topLayer.getContext('2d');
    };
    _proto.removeTopCanvas = function removeTopCanvas() {
        removeDomNode(this.topLayer);
        delete this.topLayer;
        delete this.topCtx;
    };
    _proto._updateDomPosition = function _updateDomPosition(framestamp) {
        if (this._checkPositionTime === undefined) this._checkPositionTime = 0;
        var dTime = Math.abs(framestamp - this._checkPositionTime);
        if (dTime >= 500) {
            computeDomPosition(this.map.getContainer());
            this._checkPositionTime = framestamp;
        }
        return this;
    };
    _proto._handleResizeEventList = function _handleResizeEventList(time) {
        if (!this._resizeEventList) return this;
        var len = this._resizeEventList.length;
        if (len === 0) return this;
        if (this._resizeTime && time - this._resizeTime < 60) return this;
        var contentRect = this._resizeEventList[len - 1].contentRect;
        this.map.setContainerDomRect(contentRect);
        this._resizeEventList = [];
        this._checkSize();
        this._resizeCount = this._resizeCount || 0;
        this.renderFrame((this._frameTimestamp || 0) + ++this._resizeCount / 100);
        this._resizeTime = time;
        return this;
    };
    _proto._checkSize = function _checkSize() {
        if (!this.map) return;
        this.map.checkSize();
    };
    _proto._setCheckSizeInterval = function _setCheckSizeInterval(interval) {
        var _this3 = this;
        if (Browser$1.resizeObserver) {
            if (this._resizeObserver) this._resizeObserver.disconnect();
            if (this.map) {
                this._resizeObserver = new ResizeObserver(function(entries) {
                    if (!_this3.map || _this3.map.isRemoved()) _this3._resizeObserver.disconnect();
                    else if (entries.length) {
                        _this3._resizeEventList = _this3._resizeEventList || [];
                        _this3._resizeEventList.push(entries[0]);
                    }
                });
                this._resizeObserver.observe(this.map.getContainer());
            }
        } else {
            clearInterval(this._resizeInterval);
            this._checkSizeInterval = interval;
            this._resizeInterval = setInterval(function() {
                if (!_this3.map || _this3.map.isRemoved()) clearInterval(_this3._resizeInterval);
                else _this3._checkSize();
            }, this._checkSizeInterval);
        }
    };
    _proto._registerEvents = function _registerEvents() {
        var _this4 = this;
        var map = this.map;
        if (map.options['checkSize'] && !IS_NODE && typeof window !== 'undefined') this._setCheckSizeInterval(map.options['checkSizeInterval']);
        if (!Browser$1.mobile) map.on('_mousemove', this._onMapMouseMove, this);
        map.on('_dragrotatestart _dragrotating _dragrotateend _movestart _moving _moveend _zoomstart', function(param) {
            _this4._eventParam = param;
        });
        map.on('_zooming', function(param) {
            if (!map.getPitch()) _this4._zoomMatrix = param['matrix']['container'];
            _this4._eventParam = param;
        });
        map.on('_zoomend', function(param) {
            _this4._eventParam = param;
            delete _this4._zoomMatrix;
        });
        map.on('_spatialreferencechange', function() {
            _this4._spatialRefChanged = true;
        });
        if (Browser$1.webgl && typeof document !== 'undefined') {
            GlobalEvent.on(EVENT_DPR_CHANGE, this._thisDocDPRChange, this);
            GlobalEvent.on(EVENT_DOC_VISIBILITY_CHANGE, this._thisDocVisibilitychange, this);
            GlobalEvent.on(EVENT_DOC_DRAGSTART, this._thisDocDragStart, this);
            GlobalEvent.on(EVENT_DOC_DRAGEND, this._thisDocDragEnd, this);
        }
    };
    _proto._onMapMouseMove = function _onMapMouseMove(param) {
        var _this5 = this;
        var map = this.map;
        if (map.isInteracting() || !map.options['hitDetect']) return;
        if (this._hitDetectFrame) cancelAnimFrame(this._hitDetectFrame);
        this._hitDetectFrame = requestAnimFrame(function() {
            _this5.hitDetect(param['containerPoint']);
        });
    };
    _proto._getCanvasLayers = function _getCanvasLayers() {
        return this.map._getLayers(function(layer) {
            return layer.isCanvasRender();
        });
    };
    _proto.addTopElement = function addTopElement(e) {
        if (!this._tops) this._tops = [];
        this._tops.push(e);
    };
    _proto.removeTopElement = function removeTopElement(e) {
        if (!this._tops) return;
        var idx = this._tops.indexOf(e);
        if (idx >= 0) this._tops.splice(idx, 1);
    };
    _proto.getTopElements = function getTopElements() {
        return this._tops || [];
    };
    _proto.sortTopElements = function sortTopElements() {
        this._tops = this._tops.sort(function(top1, top2) {
            var zIndex1 = (top1.options || {}).zIndex || 0;
            var zIndex2 = (top2.options || {}).zIndex || 0;
            return zIndex2 - zIndex1;
        });
    };
    _proto.drawTops = function drawTops() {
        var tops = this.getTopElements();
        if (tops.length) {
            if (!this.topCtx) this.createTopCanvas();
        } else {
            if (this.topCtx) this.removeTopCanvas();
            return;
        }
        this.drawTopElements();
    };
    _proto.drawTopElements = function drawTopElements() {
        var tops = this.getTopElements();
        this.topCtx.clearRect(0, 0, this.topLayer.width, this.topLayer.height);
        var collisionIndex = tempCollisionIndex;
        collisionIndex.clear();
        this.map.fire('drawtopstart');
        this.map.fire('drawtops');
        var updated = false;
        var dpr = this.map.getDevicePixelRatio();
        var geos = [];
        for(var i = 0; i < tops.length; i++){
            var top = tops[i];
            if (top.needCollision && top.needCollision()) {
                var bbox = top.getRenderBBOX(dpr);
                if (bbox) {
                    if (collisionIndex.collides(bbox)) {
                        var geometry = top.target && top.target._geometry;
                        if (geometry && geos.indexOf(geometry) === -1) {
                            geos.push(geometry);
                            geometry.fire('handlecollision');
                        }
                        continue;
                    } else collisionIndex.insertBox(bbox);
                }
            }
            if (top.render(this.topCtx)) updated = true;
        }
        if (updated) this.context.drawImage(this.topLayer, 0, 0);
        this.map.fire('drawtopsend');
    };
    return MapAbstractRenderer;
}(MapRenderer);
var MapCanvasRenderer = function(_MapAbstractRenderer) {
    function MapCanvasRenderer() {
        return _MapAbstractRenderer.apply(this, arguments) || this;
    }
    _inheritsLoose(MapCanvasRenderer, _MapAbstractRenderer);
    var _proto = MapCanvasRenderer.prototype;
    _proto.renderFrame = function renderFrame(framestamp) {
        var map = this.map;
        if (!map || !map.options['renderable']) return false;
        this._handleResizeEventList(framestamp);
        if (map.options['stopRenderOnOffscreen'] && this._containerIsOffscreen()) return true;
        this._updateDomPosition(framestamp);
        delete this._isViewChanged;
        map._fireEvent('framestart');
        this.updateMapDOM();
        map.clearCollisionIndex();
        var layers = this._getAllLayerToRender();
        this.drawLayers(layers, framestamp);
        var updated = this.drawLayerCanvas(layers);
        if (updated) {
            this.drawTops();
            this._drawCenterCross();
            if (map.options['debugSky']) this._debugSky();
        }
        this._needClear = false;
        map._fireEvent('frameend');
        this._recordView();
        this._mapview = this._getMapView();
        delete this._spatialRefChanged;
        this._fireLayerLoadEvents();
        this.executeFrameCallbacks();
        this._canvasUpdated = false;
        map.uiCollides();
        return true;
    };
    _proto._needRedrawAllLayers = function _needRedrawAllLayers(layers) {
        var _this = this;
        if (this.isSpatialReferenceChanged()) return true;
        var needRedrawLayers = [];
        layers.forEach(function(layer) {
            if (!layer) return;
            var needsRedraw = layer._toRedraw = _this._checkLayerRedraw(layer);
            if (needsRedraw) {
                needRedrawLayers.push(layer);
                var childLayers = layer.getLayers && layer.getLayers();
                if (childLayers && Array.isArray(childLayers)) pushIn(needRedrawLayers, childLayers);
            }
        });
        for(var i = 0, len = needRedrawLayers.length; i < len; i++){
            var layer = needRedrawLayers[i];
            var layerOptions = layer && layer.options;
            if (layerOptions && layerOptions.collision && layerOptions.collisionScope === 'map') return true;
        }
        return false;
    };
    _proto.drawLayers = function drawLayers(layers, framestamp) {
        var needRedrawAllLayers = this._needRedrawAllLayers(layers);
        var map = this.map, isInteracting = map.isInteracting(), canvasIds = [], updatedIds = [], fps = map.options['fpsOnInteracting'] || 0, timeLimit = fps === 0 ? 0 : 1000 / fps, layerLimit = this.map.options['layerCanvasLimitOnInteracting'], l = layers.length;
        var baseLayer = map.getBaseLayer();
        var t = 0;
        for(var i = 0; i < l; i++){
            var layer = layers[i];
            if (!layer.isVisible()) continue;
            var isCanvas = layer.isCanvasRender();
            if (isCanvas) canvasIds.push(layer.getId());
            var renderer = layer._getRenderer();
            if (!renderer) continue;
            var needsRedraw = needRedrawAllLayers || layer._toRedraw;
            if (isCanvas && renderer.isCanvasUpdated()) {
                if (!needsRedraw) updatedIds.push(layer.getId());
                this.setLayerCanvasUpdated();
            }
            var transformMatrix = renderer.__zoomTransformMatrix;
            delete renderer.__zoomTransformMatrix;
            if (!needsRedraw) {
                if (isCanvas && isInteracting) {
                    if (map.isZooming() && !map.getPitch()) {
                        renderer.prepareRender();
                        renderer.__zoomTransformMatrix = this._zoomMatrix;
                    } else if (map.getPitch() || map.isRotating()) renderer.clearCanvas();
                }
                continue;
            }
            if (isInteracting && isCanvas) {
                if (layerLimit > 0 && l - 1 - i > layerLimit && layer !== baseLayer) {
                    layer._getRenderer().clearCanvas();
                    continue;
                }
                t += this._drawCanvasLayerOnInteracting(layer, t, timeLimit, framestamp);
            } else if (isInteracting && renderer.drawOnInteracting) {
                if (renderer.prepareRender) renderer.prepareRender();
                if (renderer.checkAndDraw) renderer.checkAndDraw(renderer.drawOnInteracting, this._eventParam, framestamp);
                else renderer.drawOnInteracting(this._eventParam, framestamp);
            } else {
                renderer.render(framestamp);
                if (isCanvas && transformMatrix && renderer.isLoadingResource()) renderer.__zoomTransformMatrix = transformMatrix;
            }
            if (isCanvas) {
                updatedIds.push(layer.getId());
                this.setLayerCanvasUpdated();
            }
        }
        var preCanvasIds = this._canvasIds || [];
        var preUpdatedIds = this._updatedIds || [];
        this._canvasIds = canvasIds;
        this._updatedIds = updatedIds;
        if (!this.isLayerCanvasUpdated()) {
            var sep = '---';
            if (preCanvasIds.join(sep) !== canvasIds.join(sep) || preUpdatedIds.join(sep) !== updatedIds.join(sep)) this.setLayerCanvasUpdated();
        }
        return true;
    };
    _proto._drawCanvasLayerOnInteracting = function _drawCanvasLayerOnInteracting(layer, t, timeLimit, framestamp) {
        var map = this.map, renderer = layer._getRenderer(), drawTime = renderer.getDrawTime(), inTime = timeLimit === 0 || timeLimit > 0 && t + drawTime <= timeLimit;
        if (renderer.mustRenderOnInteracting && renderer.mustRenderOnInteracting()) renderer.render(framestamp);
        else if (renderer.drawOnInteracting && (layer === map.getBaseLayer() || inTime || map.isZooming() && layer.options['forceRenderOnZooming'] || map.isMoving() && layer.options['forceRenderOnMoving'] || map.isRotating() && layer.options['forceRenderOnRotating'])) {
            renderer.prepareRender();
            renderer.prepareCanvas();
            if (renderer.checkAndDraw) renderer.checkAndDraw(renderer.drawOnInteracting, this._eventParam, framestamp);
            else renderer.drawOnInteracting(this._eventParam, framestamp);
            return drawTime;
        } else if (map.isZooming() && !map.getPitch() && !map.isRotating()) {
            renderer.prepareRender();
            renderer.__zoomTransformMatrix = this._zoomMatrix;
        } else if (map.getPitch() || map.isRotating()) renderer.clearCanvas();
        if (renderer.drawOnInteracting && !inTime) renderer.onSkipDrawOnInteracting(this._eventParam, framestamp);
        return 0;
    };
    _proto._fireLayerLoadEvents = function _fireLayerLoadEvents() {
        if (this._updatedIds && this._updatedIds.length > 0) {
            var map = this.map;
            this._updatedIds.reverse().forEach(function(id) {
                var layer = map.getLayer(id);
                if (!layer) return;
                var renderer = layer._getRenderer();
                if (!renderer || !renderer.isRenderComplete()) return;
                layer.fire('layerload');
            });
        }
    };
    _proto.isLayerCanvasUpdated = function isLayerCanvasUpdated() {
        return this._canvasUpdated;
    };
    _proto.setLayerCanvasUpdated = function setLayerCanvasUpdated() {
        this._canvasUpdated = true;
    };
    _proto.drawLayerCanvas = function drawLayerCanvas(layers) {
        var map = this.map;
        if (!map) return false;
        if (!this.isLayerCanvasUpdated() && !this.isViewChanged() && this._needClear === false) return false;
        if (!this.canvas) this.createCanvas();
        map._fireEvent('renderstart', {
            'context': this.context
        });
        if (!this._updateCanvasSize()) this.clearCanvas();
        var interacting = map.isInteracting(), limit = map.options['layerCanvasLimitOnInteracting'];
        var len = layers.length;
        var baseLayerImage;
        var images = [];
        for(var i = 0; i < len; i++){
            if (!layers[i].isVisible() || !layers[i].isCanvasRender()) continue;
            var renderer = layers[i]._getRenderer();
            if (!renderer) continue;
            var layerImage = this._getLayerImage(layers[i]);
            if (layerImage && layerImage['image']) {
                if (layers[i] === map.getBaseLayer()) baseLayerImage = [
                    layers[i],
                    layerImage
                ];
                else images.push([
                    layers[i],
                    layerImage
                ]);
            }
        }
        var targetWidth = this.canvas.width;
        var targetHeight = this.canvas.height;
        if (baseLayerImage) {
            this._drawLayerCanvasImage(baseLayerImage[0], baseLayerImage[1], targetWidth, targetHeight);
            this._drawFog();
        }
        len = images.length;
        var start = interacting && limit >= 0 && len > limit ? len - limit : 0;
        for(var _i = start; _i < len; _i++)this._drawLayerCanvasImage(images[_i][0], images[_i][1], targetWidth, targetHeight);
        map._fireEvent('renderend', {
            'context': this.context
        });
        return true;
    };
    _proto.setToRedraw = function setToRedraw() {
        var layers = this._getAllLayerToRender();
        this._needClear = true;
        for(var i = 0, l = layers.length; i < l; i++){
            var renderer = layers[i].getRenderer();
            if (renderer && renderer.canvas && renderer.setToRedraw) renderer.setToRedraw();
        }
    };
    _proto.remove = function remove() {
        delete this.context;
        _MapAbstractRenderer.prototype.remove.call(this);
    };
    _proto.hitDetect = function hitDetect(point) {
        var map = this.map;
        if (!map || !map.options['hitDetect'] || map.isInteracting()) return;
        var layers = map._getLayers();
        var cursor = 'default';
        var limit = map.options['hitDetectLimit'] || 0;
        var counter = 0;
        if (point && point._round) point._round();
        for(var i = layers.length - 1; i >= 0; i--){
            var layer = layers[i];
            if (!layer.options['hitDetect'] || layer.isEmpty && layer.isEmpty() || !layer.options['geometryEvents']) continue;
            var renderer = layer._getRenderer();
            if (!renderer || !renderer.hitDetect) continue;
            if (renderer.isBlank && renderer.isBlank()) continue;
            if (layer.options['cursor'] !== 'default' && renderer.hitDetect(point)) {
                cursor = layer.options['cursor'] || 'pointer';
                break;
            }
            counter++;
            if (limit > 0 && counter > limit) break;
        }
        map._trySetCursor(cursor);
    };
    _proto._getLayerImage = function _getLayerImage(layer) {
        var renderer = layer._getRenderer();
        if (renderer.getCanvasImage) return renderer.getCanvasImage();
        return null;
    };
    _proto._drawLayerCanvasImage = function _drawLayerCanvasImage(layer, layerImage, targetWidth, targetHeight) {
        var ctx = this.context;
        var point = layerImage['point'].round();
        var dpr = this.map.getDevicePixelRatio();
        if (dpr !== 1) point._multi(dpr);
        var canvasImage = layerImage['image'];
        var width = canvasImage.width, height = canvasImage.height;
        if (point.x + width <= 0 || point.y + height <= 0) return;
        var op = layer.options['opacity'];
        if (!isNumber(op)) op = 1;
        if (op <= 0) return;
        var imgOp = layerImage['opacity'];
        if (!isNumber(imgOp)) imgOp = 1;
        if (imgOp <= 0) return;
        var alpha = ctx.globalAlpha;
        if (op < 1) ctx.globalAlpha *= op;
        if (imgOp < 1) ctx.globalAlpha *= imgOp;
        if (layer.options['cssFilter']) ctx.filter = layer.options['cssFilter'];
        var renderer = layer.getRenderer();
        var matrix = renderer.__zoomTransformMatrix;
        var clipped = renderer.clipCanvas(this.context);
        if (matrix) {
            ctx.save();
            ctx.setTransform(...matrix);
        }
        ctx.drawImage(canvasImage, 0, 0, width, height, point.x, point.y, targetWidth, targetHeight);
        if (matrix) ctx.restore();
        if (clipped) ctx.restore();
        if (ctx.filter !== 'none') ctx.filter = 'none';
        ctx.globalAlpha = alpha;
    };
    _proto._drawCenterCross = function _drawCenterCross() {
        var cross = this.map.options['centerCross'];
        if (cross) {
            var ctx = this.context;
            var p = new Point(this.canvas.width / 2, this.canvas.height / 2);
            if (isFunction(cross)) cross(ctx, p);
            else Canvas.drawCross(this.context, p.x, p.y, 2, '#f00');
        }
    };
    _proto._drawContainerExtent = function _drawContainerExtent() {
        var { cascadePitches: cascadePitches } = this.map.options;
        var h30 = this.map.height - this.map._getVisualHeight(cascadePitches[0]);
        var h60 = this.map.height - this.map._getVisualHeight(cascadePitches[1]);
        var extent = this.map.getContainerExtent();
        var ctx = this.context;
        ctx.beginPath();
        ctx.moveTo(0, extent.ymin);
        ctx.lineTo(extent.xmax, extent.ymin);
        ctx.stroke();
        ctx.beginPath();
        ctx.moveTo(0, h30);
        ctx.lineTo(extent.xmax, h30);
        ctx.stroke();
        ctx.beginPath();
        ctx.moveTo(0, h60);
        ctx.lineTo(extent.xmax, h60);
        ctx.stroke();
    };
    _proto._drawFog = function _drawFog() {
        var map = this.map;
        if (map.getPitch() <= map.options['maxVisualPitch'] || !map.options['fog']) return;
        var fogThickness = 30;
        var r = map.getDevicePixelRatio();
        var ctx = this.context, clipExtent = map.getContainerExtent();
        var top = (map.height - map._getVisualHeight(75)) * r;
        if (top < 0) top = 0;
        var bottom = clipExtent.ymin * r, h = Math.ceil(bottom - top), color = map.options['fogColor'].join();
        var gradient = ctx.createLinearGradient(0, top, 0, bottom + fogThickness);
        var landscape = 1 - fogThickness / (h + fogThickness);
        gradient.addColorStop(0, "rgba(" + color + ", 0)");
        gradient.addColorStop(0.3, "rgba(" + color + ", 0.3)");
        gradient.addColorStop(landscape, "rgba(" + color + ", 1)");
        gradient.addColorStop(1, "rgba(" + color + ", 0)");
        ctx.beginPath();
        ctx.fillStyle = gradient;
        ctx.fillRect(0, top, Math.ceil(clipExtent.getWidth()) * r, Math.ceil(h + fogThickness));
    };
    _proto._debugSky = function _debugSky() {
        var map = this.map;
        if (!map) return this;
        var height = map.getContainerExtent().ymin;
        if (height <= 0) return this;
        var ctx = this.context;
        ctx.strokeStyle = 'red';
        ctx.strokeRect(0, 0, map.width, height);
        return this;
    };
    _proto.clearCanvas = function clearCanvas() {
        if (!this.canvas) return;
        Canvas.clearRect(this.context, 0, 0, this.canvas.width, this.canvas.height);
    };
    _proto._updateCanvasSize = function _updateCanvasSize() {
        if (!this.canvas || this._containerIsCanvas) return false;
        var map = this.map, mapSize = map.getSize(), canvas = this.canvas, r = map.getDevicePixelRatio();
        var { width: width, height: height, cssWidth: cssWidth, cssHeight: cssHeight } = calCanvasSize(mapSize, r);
        if (canvas.style && (canvas.style.width !== cssWidth || canvas.style.height !== cssHeight)) {
            canvas.style.width = cssWidth;
            canvas.style.height = cssHeight;
        }
        if (width === canvas.width && height === canvas.height) return false;
        canvas.height = height;
        canvas.width = width;
        this.topLayer.width = canvas.width;
        this.topLayer.height = canvas.height;
        return true;
    };
    _proto.createCanvas = function createCanvas() {
        this.topLayer = createEl('canvas');
        this.topCtx = this.topLayer.getContext('2d');
        if (this._containerIsCanvas) this.canvas = this.map.getContainer();
        else {
            this.canvas = createEl('canvas');
            this._updateCanvasSize();
            this.map.getPanels().canvasContainer.appendChild(this.canvas);
        }
        this.context = this.canvas.getContext('2d');
        this.ready = true;
    };
    _proto.drawTops = function drawTops() {
        _MapAbstractRenderer.prototype.drawTopElements.call(this);
    };
    return MapCanvasRenderer;
}(MapAbstractRenderer);
Map$1.registerRenderer('canvas', MapCanvasRenderer);
Map$1.mergeOptions({
    'fog': false,
    'fogColor': [
        233,
        233,
        233
    ]
});
var index = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    CanvasLayerRenderer: CanvasLayerRenderer,
    CanvasRenderer: CanvasRenderer$1,
    CanvasTileLayerCanvasRenderer: CanvasRenderer,
    CanvasTileLayerGLRenderer: GLRenderer,
    ImageGLRenderable: ImageGLRenderable,
    ImageLayerCanvasRenderer: ImageLayerCanvasRenderer,
    ImageLayerGLRenderer: ImageLayerGLRenderer,
    LayerAbstractRenderer: LayerAbstractRenderer,
    MapAbstractRenderer: MapAbstractRenderer,
    MapCanvasRenderer: MapCanvasRenderer,
    MapRenderer: MapRenderer,
    OverlayLayerCanvasRenderer: OverlayLayerCanvasRenderer,
    OverlayLayerGLRenderer: OverlayLayerGLRenderer,
    QuadStencil: QuadStencil,
    Renderable: Renderable,
    ResourceCache: ResourceCache,
    TileLayerCanvasRenderer: TileLayerCanvasRenderer,
    TileLayerGLRenderer: TileLayerGLRenderer,
    TileLayerRendererable: TileLayerRenderable,
    VectorLayerCanvasRenderer: VectorLayerRenderer
});
var CenterPointRenderer = {
    _getRenderPoints: function _getRenderPoints() {
        return [
            [
                this._getCenter2DPoint(this.getMap().getGLRes())
            ],
            null
        ];
    }
};
Marker.include(CenterPointRenderer);
Ellipse.include(CenterPointRenderer);
Circle.include(CenterPointRenderer);
Sector.include(CenterPointRenderer);
Rectangle.include({
    _getRenderPoints: function _getRenderPoints(placement) {
        var map = this.getMap();
        var glRes = map.getGLRes();
        if (placement === 'vertex') {
            var shell = this._trimRing(this.getShell());
            var points = [];
            for(var i = 0, len = shell.length; i < len; i++)points.push(map.coordToPointAtRes(shell[i], glRes));
            return [
                points,
                null
            ];
        } else {
            var c = map.coordToPointAtRes(this.getCenter(), glRes);
            return [
                [
                    c
                ],
                null
            ];
        }
    }
});
var PolyRenderer = {
    _getRenderPoints: function _getRenderPoints(placement) {
        var map = this.getMap();
        var glRes = map.getGLRes();
        var points, rotations = null;
        if (placement === 'point') {
            points = this._getPath2DPoints(this._getPrjCoordinates(), false, glRes);
            if (points && points.length > 0 && Array.isArray(points[0])) points = points[0].concat(points[1]);
        } else if (placement === 'vertex') {
            points = this._getPath2DPoints(this._getPrjCoordinates(), false, glRes);
            rotations = [];
            if (points && points.length > 0 && Array.isArray(points[0])) {
                for(var i = 0, l = points.length; i < l; i++){
                    for(var ii = 0, ll = points[i].length; ii < ll; ii++)if (ii === 0) rotations.push([
                        points[i][ii],
                        points[i][ii + 1]
                    ]);
                    else rotations.push([
                        points[i][ii - 1],
                        points[i][ii]
                    ]);
                }
                points = points[0].concat(points[1]);
            } else {
                for(var _i = 0, _l = points.length; _i < _l; _i++)if (_i === 0) rotations.push([
                    points[_i],
                    points[_i + 1]
                ]);
                else rotations.push([
                    points[_i - 1],
                    points[_i]
                ]);
            }
        } else if (placement === 'line') {
            points = [];
            rotations = [];
            var vertice = this._getPath2DPoints(this._getPrjCoordinates(), false, glRes), isSplitted = vertice.length > 0 && Array.isArray(vertice[0]);
            if (isSplitted) {
                var ring;
                for(var _i2 = 1, _l2 = vertice.length; _i2 < _l2; _i2++){
                    ring = vertice[_i2];
                    if (this instanceof Polygon && ring.length > 0 && !ring[0].equals(ring[ring.length - 1])) ring.push(ring[0]);
                    for(var _ii = 1, _ll = ring.length; _ii < _ll; _ii++){
                        points.push(ring[_ii].add(ring[_ii - 1])._multi(0.5));
                        rotations.push([
                            ring[_ii - 1],
                            ring[_ii]
                        ]);
                    }
                }
            } else {
                if (this instanceof Polygon && vertice.length > 0 && !vertice[0].equals(vertice[vertice.length - 1])) vertice.push(vertice[0]);
                for(var _i3 = 1, _l3 = vertice.length; _i3 < _l3; _i3++){
                    points.push(vertice[_i3].add(vertice[_i3 - 1])._multi(0.5));
                    rotations.push([
                        vertice[_i3 - 1],
                        vertice[_i3]
                    ]);
                }
            }
        } else if (placement === 'vertex-first') {
            var coords = this._getPrjCoordinates();
            var _l4 = coords.length;
            var point0 = _l4 ? map._prjToPointAtRes(coords[0], glRes) : null;
            points = _l4 ? [
                point0
            ] : [];
            rotations = _l4 ? [
                [
                    point0,
                    coords[1] ? map._prjToPointAtRes(coords[1], glRes) : point0
                ]
            ] : [];
        } else if (placement === 'vertex-last') {
            var _coords = this._getPrjCoordinates();
            var _l5 = _coords.length;
            var curretPoint = _l5 ? map._prjToPointAtRes(_coords[_l5 - 1], glRes) : null;
            points = _l5 ? [
                curretPoint
            ] : [];
            var previous = _l5 > 1 ? _l5 - 2 : _l5 - 1;
            rotations = _l5 ? [
                [
                    _coords[previous] ? map._prjToPointAtRes(_coords[previous], glRes) : curretPoint,
                    curretPoint
                ]
            ] : [];
        } else if (placement === 'vertex-firstlast') {
            points = [];
            rotations = [];
            var _coords2 = this._getPrjCoordinates();
            var _l6 = _coords2.length;
            if (_l6) {
                var _point = map._prjToPointAtRes(_coords2[0], glRes);
                points = [
                    _point
                ];
                if (_l6 > 1) {
                    rotations = [
                        [
                            _point,
                            map._prjToPointAtRes(_coords2[1], glRes)
                        ]
                    ];
                    var point1 = map._prjToPointAtRes(_coords2[_l6 - 1], glRes);
                    points.push(point1);
                    var _previous = _l6 > 1 ? _l6 - 2 : _l6 - 1;
                    rotations.push([
                        map._prjToPointAtRes(_coords2[_previous], glRes),
                        point1
                    ]);
                }
            }
        } else {
            var center = this.getCenter();
            if (!center) points = [];
            else {
                var pcenter = this._getProjection().project(center);
                points = [
                    map._prjToPointAtRes(pcenter, glRes)
                ];
            }
        }
        return [
            points,
            rotations
        ];
    }
};
LineString.include(PolyRenderer);
Polygon.include(PolyRenderer);
var TEMP_WITHIN = {
    within: false,
    center: [
        0,
        0
    ]
};
function isWithinPixel(painter) {
    if (!painter || !painter._containerBbox) TEMP_WITHIN.within = false;
    else {
        TEMP_WITHIN.within = false;
        var { minx: minx, miny: miny, maxx: maxx, maxy: maxy } = painter._containerBbox;
        var offsetx = Math.abs(maxx - minx);
        var offsety = Math.abs(maxy - miny);
        if (offsetx <= 1 && offsety <= 1) {
            TEMP_WITHIN.within = true;
            TEMP_WITHIN.center[0] = (minx + maxx) / 2;
            TEMP_WITHIN.center[1] = (miny + maxy) / 2;
        }
        delete painter._containerBbox;
    }
    return TEMP_WITHIN;
}
var geometryInclude = {
    _redrawWhenPitch: function _redrawWhenPitch() {
        return false;
    },
    _redrawWhenRotate: function _redrawWhenRotate() {
        return false;
    },
    _getRenderBBOX: function _getRenderBBOX(ctx, points) {
        if (!ctx.isHitTesting) {
            resetBBOX(BBOX_TEMP);
            pointsBBOX(points, BBOX_TEMP);
            return BBOX_TEMP;
        }
        return null;
    }
};
Geometry.include(geometryInclude);
function _computeRotatedPrjExtent() {
    var coord = this._getPrjShell();
    var bbox = getDefaultBBOX();
    pointsBBOX(coord, bbox);
    var [minx, miny, maxx, maxy] = bbox;
    return new Extent(minx, miny, maxx, maxy);
}
function getRotatedShell() {
    var prjs = this._getPrjShell();
    if (!prjs || !Array.isArray(prjs)) return [];
    var projection = this._getProjection();
    var coordinates = this.getCoordinates() || {};
    return prjs.map(function(prj) {
        var c = projection.unproject(prj);
        c.z = coordinates.z || 0;
        return c;
    });
}
var el = {
    _redrawWhenPitch: function _redrawWhenPitch() {
        return true;
    },
    _redrawWhenRotate: function _redrawWhenRotate() {
        return this instanceof Ellipse || this instanceof Sector;
    },
    _computeRotatedPrjExtent: _computeRotatedPrjExtent,
    getRotatedShell: getRotatedShell,
    _paintAsPath: function _paintAsPath() {
        if (this.isRotated()) return true;
        var map = this.getMap();
        var altitude = this._getAltitude();
        return altitude > 0 || map.getPitch() || this instanceof Ellipse && map.getBearing();
    },
    _getPaintParams: function _getPaintParams() {
        var map = this.getMap();
        if (this._paintAsPath()) return Polygon.prototype._getPaintParams.call(this, true);
        var pcenter = this._getPrjCoordinates();
        var pt = map._prjToPointAtRes(pcenter, map.getGLRes());
        var size = this._getRenderSize(pt);
        return [
            pt,
            ...size
        ];
    },
    _paintOn: function _paintOn(...args) {
        if (this._paintAsPath()) return Canvas.polygon(...args);
        else return Canvas.ellipse(...args);
    },
    _getRenderSize: function _getRenderSize(pt) {
        var map = this.getMap(), glRes = map.getGLRes();
        var prjExtent = this._getPrjExtent();
        var pmin = map._prjToPointAtRes(prjExtent.getMin(), glRes), pmax = map._prjToPointAtRes(prjExtent.getMax(), glRes);
        return [
            Math.abs(pmax.x - pmin.x) / 2,
            Math.abs(pmax.y - pt.y),
            Math.abs(pt.y - pmin.y)
        ];
    }
};
Ellipse.include(el);
Circle.include(el);
var rectangleInclude = {
    _getPaintParams: function _getPaintParams() {
        var map = this.getMap();
        var shell = this._getPrjShell();
        var points = this._getPath2DPoints(shell, false, map.getGLRes());
        return [
            points
        ];
    },
    _paintOn: Canvas.polygon,
    _computeRotatedPrjExtent: _computeRotatedPrjExtent,
    getRotatedShell: getRotatedShell
};
Rectangle.include(rectangleInclude);
var sectorInclude = {
    _redrawWhenPitch: function _redrawWhenPitch() {
        return true;
    },
    _getPaintParams: function _getPaintParams() {
        if (this._paintAsPath()) return Polygon.prototype._getPaintParams.call(this, true);
        var map = this.getMap();
        var pt = map._prjToPointAtRes(this._getPrjCoordinates(), map.getGLRes());
        var size = this._getRenderSize(pt);
        var [startAngle, endAngle] = this._correctAngles();
        return [
            pt,
            size[0],
            [
                startAngle,
                endAngle
            ]
        ];
    },
    _paintOn: function _paintOn(...args) {
        if (this._paintAsPath()) return Canvas.polygon(...args);
        else {
            var r = this.getMap().getBearing();
            if (r) {
                args[3] = args[3].slice(0);
                args[3][0] += r;
                args[3][1] += r;
            }
            return Canvas.sector(...args);
        }
    }
};
Sector.include(el, sectorInclude);
Path.include({
    _paintAsPath: function _paintAsPath() {
        return true;
    }
});
var lineStringInclude = {
    arrowStyles: {
        'classic': [
            3,
            4
        ]
    },
    _getArrowShape: function _getArrowShape(prePoint, point, lineWidth, arrowStyle, tolerance) {
        if (!prePoint || !point || prePoint.equals(point)) return null;
        if (!tolerance) tolerance = 0;
        var width = lineWidth * arrowStyle[0], height = lineWidth * arrowStyle[1] + tolerance, hw = width / 2 + tolerance;
        var normal;
        if (point.nextCtrlPoint || point.prevCtrlPoint) {
            if (point.prevCtrlPoint) normal = point.sub(new Point(point.prevCtrlPoint));
            else normal = point.sub(new Point(point.nextCtrlPoint));
        } else normal = point.sub(prePoint);
        normal._unit();
        var p1 = point.sub(normal.multi(height));
        normal._perp();
        var p0 = p1.add(normal.multi(hw));
        normal._multi(-1);
        var p2 = p1.add(normal.multi(hw));
        return [
            p0,
            point,
            p2,
            p0
        ];
    },
    _getPaintParams: function _getPaintParams() {
        var prjVertexes = this._getPrjCoordinates();
        var points = this._getPath2DPoints(prjVertexes, false, this.getMap().getGLRes());
        return [
            points
        ];
    },
    _paintOn: function _paintOn(ctx, points, lineOpacity, fillOpacity, dasharray, lineColorIn) {
        var r = isWithinPixel(this._painter);
        if (r.within) Canvas.pixelRect(ctx, r.center, lineOpacity, fillOpacity);
        else if (this.options['smoothness']) Canvas.paintSmoothLine(ctx, points, lineOpacity, this.options['smoothness'], false, this._animIdx, this._animTailRatio);
        else {
            ctx.lineColorIn = lineColorIn;
            Canvas.path(ctx, points, lineOpacity, null, dasharray);
        }
        this._paintArrow(ctx, points, lineOpacity);
        return this._getRenderBBOX(ctx, points);
    },
    _getArrowPlacement: function _getArrowPlacement() {
        return this.options['arrowPlacement'];
    },
    _getArrowStyle: function _getArrowStyle() {
        var arrowStyle = this.options['arrowStyle'];
        if (arrowStyle) return Array.isArray(arrowStyle) ? arrowStyle : this.arrowStyles[arrowStyle];
        return null;
    },
    _getArrows: function _getArrows(points, lineWidth, tolerance) {
        var _this = this;
        var arrowStyle = this._getArrowStyle();
        if (!arrowStyle || points.length < 2) return [];
        var isSplitted = points.length > 0 && Array.isArray(points[0]);
        var segments = isSplitted ? points : [
            points
        ];
        var placement = this._getArrowPlacement();
        var arrows = [];
        var p1, p2;
        var createArrow = function createArrow() {
            if (p1 && p2) {
                var arrow = _this._getArrowShape(p1, p2, lineWidth, arrowStyle, tolerance);
                if (arrow) arrows.push(arrow);
            }
        };
        for(var i = segments.length - 1; i >= 0; i--){
            var path = segments[i];
            var len = path.length;
            var first = path[0];
            var last = path[len - 1];
            if (placement === 'vertex-first') {
                p1 = first.arrowNextPoint || path[1];
                p2 = first;
            } else if (placement === 'vertex-last') {
                p1 = last.arrowPrePoint || path[len - 2];
                p2 = last;
            }
            createArrow();
            if (placement === 'vertex-firstlast') {
                p1 = first.arrowNextPoint || path[1];
                p2 = first;
                createArrow();
                p1 = last.arrowPrePoint || path[len - 2];
                p2 = last;
                createArrow();
            }
            if (placement === 'point') this._getArrowPoints(arrows, path, lineWidth, arrowStyle, tolerance);
        }
        return arrows;
    },
    _getArrowPoints: function _getArrowPoints(arrows, segments, lineWidth, arrowStyle, tolerance) {
        for(var ii = 0, ll = segments.length - 1; ii < ll; ii++){
            var pre = segments[ii];
            var next = segments[ii + 1];
            var arrow = this._getArrowShape(next.arrowPrePoint || pre, next, lineWidth, arrowStyle, tolerance);
            if (arrow) arrows.push(arrow);
        }
    },
    _paintArrow: function _paintArrow(ctx, points, lineOpacity) {
        var lineWidth = this._getInternalSymbol()['lineWidth'];
        if (!isNumber(lineWidth) || lineWidth < 3) lineWidth = 3;
        var arrows = this._getArrows(points, lineWidth);
        if (!arrows.length) return;
        if (ctx.setLineDash) ctx.setLineDash([]);
        for(var i = arrows.length - 1; i >= 0; i--){
            ctx.fillStyle = ctx.strokeStyle;
            Canvas.polygon(ctx, arrows[i], lineOpacity, lineOpacity);
        }
    }
};
LineString.include(lineStringInclude);
var polygonInclude = {
    _getPaintParams: function _getPaintParams(disableSimplify) {
        var glRes = this.getMap().getGLRes();
        var prjVertexes = this._getPrjShell();
        var points = this._getPath2DPoints(prjVertexes, disableSimplify, glRes);
        var isSplitted = points.length > 0 && Array.isArray(points[0]);
        if (isSplitted) points = [
            [
                points[0]
            ],
            [
                points[1]
            ]
        ];
        var prjHoles = this._getPrjHoles();
        var holePoints = [];
        if (prjHoles && prjHoles.length > 0) {
            var simplified = this._simplified;
            for(var i = 0; i < prjHoles.length; i++){
                var hole = this._getPath2DPoints(prjHoles[i], disableSimplify, glRes);
                if (Array.isArray(hole) && isSplitted) {
                    if (Array.isArray(hole[0])) {
                        points[0].push(hole[0]);
                        points[1].push(hole[1]);
                    } else points[0].push(hole);
                } else holePoints.push(hole);
            }
            if (simplified) this._simplified = simplified;
        }
        if (!isSplitted) {
            points = [
                points
            ];
            pushIn(points, holePoints);
        }
        return [
            points
        ];
    },
    _paintOn: function _paintOn(ctx, points, lineOpacity, fillOpacity, dasharray, lineColorIn) {
        var r = isWithinPixel(this._painter);
        if (r.within) Canvas.pixelRect(ctx, r.center, lineOpacity, fillOpacity);
        else {
            ctx.lineColorIn = lineColorIn;
            Canvas.polygon(ctx, points, lineOpacity, fillOpacity, dasharray, this.options['smoothness']);
        }
        return this._getRenderBBOX(ctx, points);
    }
};
Polygon.include(polygonInclude);
Map$1.VERSION = version;
var worker = {
    Actor: Actor
};
checkMTKVersion(version);

});
parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = 'browser';
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ''; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return '/';
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});


parcelRegister("9e7Ip", function(module, exports) {

$parcel$export(module.exports, "transcoders", () => transcoders);
$parcel$export(module.exports, "GroundPainter", () => GroundPainter);
$parcel$export(module.exports, "ContextUtil", () => context);
$parcel$export(module.exports, "MaskRendererMixin", () => MaskRendererMixin);
$parcel$export(module.exports, "MaskLayerMixin", () => MaskLayerMixin);
$parcel$export(module.exports, "HighlightUtil", () => highlight);
$parcel$export(module.exports, "HeatmapProcess", () => HeatmapProcess);
$parcel$export(module.exports, "ClipOutsideMask", () => ClipOutsideMask);
$parcel$export(module.exports, "createREGL", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("9I15V")))));
$parcel$export(module.exports, "reshader", () => (parcelRequire("2wazW")));
$parcel$export(module.exports, "mat2", () => (parcelRequire("iLdEy")));
$parcel$export(module.exports, "mat3", () => (parcelRequire("bDSmI")));
$parcel$export(module.exports, "mat4", () => (parcelRequire("3iqbd")));
$parcel$export(module.exports, "quat", () => (parcelRequire("k1dpP")));
$parcel$export(module.exports, "vec2", () => (parcelRequire("6BoVD")));
$parcel$export(module.exports, "vec3", () => (parcelRequire("eIStk")));
$parcel$export(module.exports, "vec4", () => (parcelRequire("jxhwV")));
/*!
 * @maptalks/gl v0.107.0
 * LICENSE : UNLICENSED
 * (c) 2016-2025 maptalks.com
 */ 
var $9I15V = parcelRequire("9I15V");
parcelRequire("2wazW");
var $3iqbd = parcelRequire("3iqbd");
var $eIStk = parcelRequire("eIStk");
var $2wazW = parcelRequire("2wazW");
var $6BoVD = parcelRequire("6BoVD");
var $bDSmI = parcelRequire("bDSmI");
var $k1dpP = parcelRequire("k1dpP");
var $jxhwV = parcelRequire("jxhwV");
var $amnUE = parcelRequire("amnUE");
var $iLdEy = parcelRequire("iLdEy");
var $caQGJ = parcelRequire("caQGJ");
var $1vSaR = parcelRequire("1vSaR");

var $gP1US = parcelRequire("gP1US");

var $KTgK2 = parcelRequire("KTgK2");
const getGlobal = function() {
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    throw new Error('unable to locate global object');
};
const globals = getGlobal();
const transcoders = globals['gl_trans__coders'] = globals['gl_trans__coders'] || {};
function inject(chunk) {
    // 奇怪的变量名是为了避免与worker源代码中的变量名冲突
    const fnString = chunk.toString();
    const prefixIndex = fnString.indexOf('{') + 1;
    const prefix = fnString.substring(0, prefixIndex);
    const transcoders = globals['gl_trans__coders'] = globals['gl_trans__coders'] || {};
    let injected = `${prefix}
    const _____getGlobal = ${getGlobal.toString()};
    const g___lobals = _____getGlobal()
    const tran_____scoders = g___lobals['gl_trans__coders'] = g___lobals['gl_trans__coders'] || {};`;
    for(const p in transcoders){
        if (p === 'inject' || p === 'getTranscoder' || p === 'registerTranscoder') continue;
        injected += 'tran_____scoders["' + p + '"] =' + transcoders[p].toString() + '\n;';
    }
    const gltfBundle = getGlobal()['maptalks_gltf_loader_bundle'];
    injected += '\n(' + gltfBundle.toString() + ')({});\n';
    injected += '\n' + fnString.substring(prefix.length);
    return injected;
}
transcoders['inject'] = inject;
function getTranscoder(name /*, options*/ ) {
    return transcoders[name];
}
function registerTranscoder(name, fn) {
    transcoders[name] = fn;
}
function registerGLTFLoaderBundle(fn) {
    getGlobal()['maptalks_gltf_loader_bundle'] = fn;
}
transcoders.registerTranscoder = registerTranscoder;
transcoders.getTranscoder = getTranscoder;
function gltfLoaderExport(t) {
    var e = function() {
        return "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : void 0;
    };
    if (e().maptalks_gltf_loader) return;
    /*!
	 * @maptalks/gltf-loader v0.102.3
	 * LICENSE : UNLICENSED
	 * (c) 2016-2025 maptalks.org
	 */ var n = "undefined" != typeof Float32Array ? Float32Array : Array;
    function s(t, e, n) {
        var s = e[0], r = e[1], i = e[2], o = e[3], h = e[4], u = e[5], c = e[6], a = e[7], f = e[8], l = e[9], d = e[10], m = e[11], p = e[12], w = e[13], y = e[14], g = e[15], b = n[0], _ = n[1], A = n[2], x = n[3];
        return t[0] = b * s + _ * h + A * f + x * p, t[1] = b * r + _ * u + A * l + x * w, t[2] = b * i + _ * c + A * d + x * y, t[3] = b * o + _ * a + A * m + x * g, b = n[4], _ = n[5], A = n[6], x = n[7], t[4] = b * s + _ * h + A * f + x * p, t[5] = b * r + _ * u + A * l + x * w, t[6] = b * i + _ * c + A * d + x * y, t[7] = b * o + _ * a + A * m + x * g, b = n[8], _ = n[9], A = n[10], x = n[11], t[8] = b * s + _ * h + A * f + x * p, t[9] = b * r + _ * u + A * l + x * w, t[10] = b * i + _ * c + A * d + x * y, t[11] = b * o + _ * a + A * m + x * g, b = n[12], _ = n[13], A = n[14], x = n[15], t[12] = b * s + _ * h + A * f + x * p, t[13] = b * r + _ * u + A * l + x * w, t[14] = b * i + _ * c + A * d + x * y, t[15] = b * o + _ * a + A * m + x * g, t;
    }
    function r() {
        var t = new n(3);
        return n != Float32Array && (t[0] = 0, t[1] = 0, t[2] = 0), t;
    }
    function i(t, e, s) {
        var r = new n(3);
        return r[0] = t, r[1] = e, r[2] = s, r;
    }
    function o(t, e) {
        return t[0] = e[0], t[1] = e[1], t[2] = e[2], t;
    }
    function h(t, e, n, s) {
        return t[0] = e, t[1] = n, t[2] = s, t;
    }
    function u(t, e, n) {
        return t[0] = e[0] + n[0], t[1] = e[1] + n[1], t[2] = e[2] + n[2], t;
    }
    function c(t, e, n) {
        return t[0] = e[0] * n, t[1] = e[1] * n, t[2] = e[2] * n, t;
    }
    function a(t, e, n, s, r) {
        return t[0] = e, t[1] = n, t[2] = s, t[3] = r, t;
    }
    function f(t, e, n) {
        var s = e[0], r = e[1], i = e[2], o = e[3];
        return t[0] = n[0] * s + n[4] * r + n[8] * i + n[12] * o, t[1] = n[1] * s + n[5] * r + n[9] * i + n[13] * o, t[2] = n[2] * s + n[6] * r + n[10] * i + n[14] * o, t[3] = n[3] * s + n[7] * r + n[11] * i + n[15] * o, t;
    }
    function l() {
        var t = new n(4);
        return n != Float32Array && (t[0] = 0, t[1] = 0, t[2] = 0), t[3] = 1, t;
    }
    Math.hypot || (Math.hypot = function() {
        for(var t = 0, e = arguments.length; e--;)t += arguments[e] * arguments[e];
        return Math.sqrt(t);
    }), r(), function() {
        var t;
        t = new n(4), n != Float32Array && (t[0] = 0, t[1] = 0, t[2] = 0, t[3] = 0);
    }();
    var d, m = function(t, e) {
        return t[0] = e[0], t[1] = e[1], t[2] = e[2], t[3] = e[3], t;
    };
    r(), i(1, 0, 0), i(0, 1, 0), l(), l(), d = new n(9), n != Float32Array && (d[1] = 0, d[2] = 0, d[3] = 0, d[5] = 0, d[6] = 0, d[7] = 0), d[0] = 1, d[4] = 1, d[8] = 1;
    let p = 0;
    function w(t) {
        return null == t;
    }
    function y(t) {
        return !w(t);
    }
    function g(t) {
        return !w(t) && ("string" == typeof t || null !== t.constructor && t.constructor === String);
    }
    function b(t) {
        for(let e = 1; e < arguments.length; e++){
            const n = arguments[e];
            for(const e in n)t[e] = n[e];
        }
        return t;
    }
    function _(t) {
        switch(t){
            case 5120:
                return Int8Array;
            case 5121:
                return Uint8Array;
            case 5122:
                return Int16Array;
            case 5123:
                return Uint16Array;
            case 5124:
                return Int32Array;
            case 5125:
                return Uint32Array;
            case 5126:
                return Float32Array;
        }
        throw new Error("unsupported bufferView's component type: " + t);
    }
    function A(t) {
        return 0 === t.indexOf("data:") && t.indexOf("base64,") > 0;
    }
    function x(t) {
        const e = function(t) {
            return "undefined" != typeof self ? self.atob(t) : window.atob(t);
        }(t.substring(t.indexOf(",") + 1)), n = e.length, s = new Uint8Array(n);
        for(let t = 0; t < n; t++)s[t] = e.charCodeAt(t);
        return s.buffer;
    }
    const T = [], M = [], I = [], E = [
        0,
        0,
        0
    ], v = function(t) {
        return t[0] = 0, t[1] = 0, t[2] = 0, t[3] = 1, t;
    }([]), P = [
        1,
        1,
        1
    ];
    function O(t, e, n, s, r, i, o) {
        const h = _(o), u = h.BYTES_PER_ELEMENT;
        if ((0 === r || r === s * u) && i % u == 0) {
            const r = new h(e, i, n * s);
            return t.set(r), t;
        }
        0 === r && (r = s * u);
        const c = new Uint8Array(s * u);
        for(let o = 0; o < n; o++){
            let n = null;
            const a = new Uint8Array(e, r * o + i, s * u);
            c.set(a), n = new h(c.buffer, 0, s);
            for(let e = 0; e < s; e++)t[o * s + e] = n[e];
        }
        return t;
    }
    const N = "undefined" != typeof TextDecoder ? new TextDecoder("utf-8") : null;
    function S(t, e, n) {
        const s = new Uint8Array(t, e, n);
        return N.decode(s);
    }
    const B = {
        get: function(t, e = {}, n) {
            e || (e = {});
            const s = new AbortController, r = s.signal, i = b({}, e);
            i.signal = r, i.method || (i.method = "GET"), i.referrerPolicy = i.referrerPolicy || "origin", "undefined" == typeof window || i.referrer || (i.referrer = window.location.href), n && (t = n(t));
            const o = fetch(t, i).then((t)=>{
                const n = this.t(t, e.responseType);
                return n.message ? n : n.then((n)=>"arraybuffer" === e.responseType ? {
                        data: n,
                        cacheControl: t.headers.get("Cache-Control"),
                        expires: t.headers.get("Expires"),
                        contentType: t.headers.get("Content-Type")
                    } : n).catch((t)=>{
                    if (!t.code || t.code !== DOMException.ABORT_ERR) throw t;
                });
            }).catch((t)=>{
                if (!t.code || t.code !== DOMException.ABORT_ERR) throw t;
            });
            return o.xhr = s, o;
        },
        t: (t, e)=>200 !== t.status ? {
                status: t.status,
                statusText: t.statusText,
                message: `incorrect http request with status code(${t.status}): ${t.statusText}`
            } : "arraybuffer" === e ? t.arrayBuffer() : "json" === e ? t.json() : t.text(),
        getArrayBuffer: (t, e = {}, n)=>(e || (e = {}), e.responseType = "arraybuffer", B.get(t, e, n)),
        getJSON: function(t, e = {}, n) {
            return e && e.jsonp ? B.jsonp(t) : ((e = e || {}).responseType = "json", B.get(t, e, n));
        },
        jsonp: function(t) {
            const e = "_maptalks_jsonp_" + p++;
            t.match(/\?/) ? t += "&callback=" + e : t += "?callback=" + e;
            let n = document.createElement("script");
            return n.type = "text/javascript", n.src = t, new Promise((t)=>{
                window[e] = function(s) {
                    document.getElementsByTagName("head")[0].removeChild(n), n = null, delete window[e], t(s);
                }, document.getElementsByTagName("head")[0].appendChild(n);
            });
        }
    };
    class R {
        constructor(t, e, n, s, r){
            this.i = t, this.decoders = e, this.o = n, this.images = {}, this.h = {}, this.u = s || {}, this.l = r;
        }
        requestImageFromBufferURI(t, e, n) {
            if (this.buffers[t.id]) {
                const s = this.buffers[t.id], r = this.m(e, s);
                return this.getImageByBuffer(r, n);
            }
            if (this.h[t.id]) return this.h[t.id].then(()=>{
                const s = this.buffers[t.id], r = this.m(e, s);
                return this.getImageByBuffer(r, n);
            });
            if (A(t.uri)) {
                const s = this.buffers[t.id] = x(t.uri), r = this.m(e, s);
                return this.getImageByBuffer(r, n);
            }
            let s;
            const r = t.uri.indexOf("blob:") >= 0;
            return s = t.uri.indexOf("://") > 0 || r ? t.uri : this.rootPath + "/" + t.uri, this.h[t.id] = B.getArrayBuffer(s, this.u, this.l).then((s)=>{
                const r = this.buffers[t.id] = s.data, i = this.m(e, r);
                return this.getImageByBuffer(i, n);
            });
        }
        getImageByBuffer(t, e) {
            if (this.images[e.id]) return Promise.resolve(this.images[e.id]);
            const n = this.decoders;
            if (n[e.mimeType]) return n[e.mimeType](t, {
                supportedFormats: this.o
            });
            if ("image/crn" === e.mimeType || "image/ktx2" === e.mimeType || "image/cttf" === e.mimeType) throw new Error("missing transcoder for " + e.mimeType, "");
            return this.p(e.id, t);
        }
        requestExternalImage(t) {
            if (this.images[t.id]) return Promise.resolve(this.images[t.id]);
            const e = 0 === t.uri.indexOf("data:image/") ? t.uri : this.rootPath + "/" + t.uri;
            return this.h[t.id] ? this.h[t.id].then(()=>this.images[t.id]) : this.h[t.id] = this.p(t.id, e);
        }
        p(t, e) {
            return new Promise((n, s)=>{
                let r = e;
                this.l && (r = this.l(e)), this.i(r, this.u, (r, i)=>{
                    r ? s(r) : (URL.revokeObjectURL(e), this.images[t] = i, n(this.images[t]));
                });
            });
        }
    }
    const C = [
        "SCALAR",
        1,
        "VEC2",
        2,
        "VEC3",
        3,
        "VEC4",
        4,
        "MAT2",
        4,
        "MAT3",
        9,
        "MAT4",
        16
    ], U = [];
    class k {
        constructor(t, e, n, s, r){
            this.rootPath = t, this.gltf = e, this._ = !1, this.glbBuffer = n, this.buffers = {}, this.requests = {}, this.accessors = {}, this.A(), this.u = s, this.l = r;
        }
        T(t, e) {
            const n = this.gltf, s = n.accessors[e];
            if (void 0 === s.bufferView) return this.accessors[s.id] = this.M(t, e, null, 0), Promise.resolve(this.accessors[s.id]);
            if (s && this.accessors[s.id]) return Promise.resolve(this.accessors[s.id]);
            const r = n.bufferViews[s.bufferView];
            return this.I(r).then((n)=>{
                const { buffer: r, byteOffset: i } = n;
                return this.accessors[s.id] = this.M(t, e, r, i);
            });
        }
        I(t) {
            const e = this.gltf.buffers[t.buffer];
            if (this.buffers[e.id]) {
                const t = this.buffers[e.id];
                return Promise.resolve({
                    buffer: t,
                    byteOffset: 0
                });
            }
            if (this.requests[e.id]) return this.requests[e.id].then(()=>{
                const t = this.buffers[e.id];
                return Promise.resolve({
                    buffer: t,
                    byteOffset: 0
                });
            });
            if ("binary_glTF" !== t.buffer && "KHR_binary_glTF" !== t.buffer && e.uri) {
                if (A(e.uri)) {
                    const t = this.buffers[e.id] = x(e.uri);
                    return Promise.resolve({
                        buffer: t,
                        byteOffset: 0
                    });
                }
                let t;
                const n = e.uri.indexOf("blob:") >= 0;
                return t = e.uri.indexOf("://") > 0 || n ? e.uri : this.rootPath + "/" + e.uri, this.requests[e.id] = B.getArrayBuffer(t, this.u, !n && this.l).then((s)=>(n && URL.revokeObjectURL(t), {
                        buffer: this.buffers[e.id] = s.data,
                        byteOffset: 0
                    }));
            }
            return Promise.resolve({
                buffer: this.glbBuffer.buffer,
                byteOffset: this.glbBuffer.byteOffset
            });
        }
        M(t, e, n, s = 0) {
            const r = this.gltf, i = r.accessors[e], o = void 0 !== i.bufferView ? r.bufferViews[i.bufferView] : {}, h = (o.byteOffset || 0) + s, u = this.v(i.type), c = _(i.componentType), a = o.byteStride || 0, l = {
                array: void 0,
                name: t,
                accessorName: e,
                byteLength: i.count * u * c.BYTES_PER_ELEMENT,
                componentType: i.componentType,
                count: i.count,
                type: i.type,
                itemSize: u,
                max: i.max,
                min: i.min,
                extensions: i.extensions
            };
            if (i.min && (l.min = i.min), i.max && (l.max = i.max), n) {
                if (this._) l.byteStride = a, l.byteOffset = h + (i.byteOffset || 0), !a || a === u * c.BYTES_PER_ELEMENT || "indices" === t || "input" === t || "output" === t || t.indexOf("morph") >= 0 ? (l.array = this.P(n, i.count, u, h + (i.byteOffset || 0), c), l.array.buffer.byteLength === l.byteLength && (l.byteOffset = 0)) : l.array = new Uint8Array(n, h, o.byteLength);
                else if (i.interleaved) {
                    l.byteStride = 0, l.byteOffset = 0;
                    const t = new c(i.count * u);
                    if (l.array = O(t, n, i.count, u, a, h + (i.byteOffset || 0), i.componentType), l.extensions && l.extensions.WEB3D_quantized_attributes && u > 2) {
                        const t = new Float32Array(l.array.length), { decodeMatrix: e } = l.extensions.WEB3D_quantized_attributes;
                        for(let n = 0; n < l.array.length; n += u){
                            U[0] = l.array[n], U[1] = l.array[n + 1], U[2] = l.array[n + 2], U[3] = 1;
                            const s = f(U, U, e);
                            t[n] = s[0], t[n + 1] = s[1], t[n + 2] = s[2];
                        }
                        l.componentType = 5126, l.array = t;
                    }
                } else l.byteStride = 0, l.array = this.P(n, i.count, u, h + (i.byteOffset || 0), c), l.byteOffset = l.array.byteOffset;
            } else {
                l.array = new c(i.count);
                const t = l.min || l.max;
                t && (l.array[0] = t[0], l.array[1] = t[1], l.array[2] = t[2]);
            }
            return l;
        }
        A() {
            const t = this.gltf.accessors;
            if (Array.isArray(t)) for(let e = 0; e < t.length; e++)for(let n = 0; n < t.length; n++)e !== n && t[e].bufferView === t[n].bufferView && (t[e].interleaved = t[n].interleaved = !0);
            else for(const e in t)for(const n in t)e !== n && t[e].bufferView === t[n].bufferView && (t[e].interleaved = t[n].interleaved = !0);
        }
        P(t, e, n, s, r) {
            return s % r.BYTES_PER_ELEMENT != 0 && (t = t.slice(s, s + e * n * r.BYTES_PER_ELEMENT), s = 0), new r(t, s, n * e);
        }
        v(t) {
            const e = C.indexOf(t);
            return C[e + 1];
        }
        requestKHRTechniquesWebgl(t) {
            const { shaders: e } = t, n = e.map((t)=>{
                if (void 0 !== t.bufferView) {
                    const e = this.gltf.bufferViews[t.bufferView], { byteLength: n } = e;
                    return this.I(e).then((s)=>{
                        const { buffer: r, byteOffset: i } = s, o = S(r, i + (e.byteOffset || 0), n);
                        return t.content = o, t;
                    });
                }
                if (t.uri) {
                    if (A(t.uri)) {
                        const e = x(t.uri), n = S(e, 0, e.byteLength);
                        return t.content = n, Promise.resolve(t);
                    }
                    {
                        const e = this.rootPath + "/" + t.uri;
                        return B.get(e, this.u, this.l).then((e)=>(t.content = e, t));
                    }
                }
                return Promise.resolve(t);
            });
            return Promise.all(n).then(()=>t);
        }
    }
    class L extends R {
        constructor(t, e, n, s, r, i, o, h){
            super(s, r, i, o, h), this.rootPath = t, this.gltf = e, this.requests = {}, this.buffers = {}, this.glbBuffer = n, this.accessor = new k(t, e, n, o, h);
        }
        iterate(t, e) {
            const n = this.gltf[e];
            if (!n) return;
            let s = 0;
            for(const e in n)t(e, n[e], s++);
        }
        createNode(t) {
            const e = {};
            if (y(t.name) && (e.name = t.name), y(t.children) && (e.children = t.children), y(t.jointName) && (e.jointName = t.jointName), y(t.matrix) && (e.matrix = t.matrix), y(t.rotation) && (e.rotation = t.rotation), y(t.scale) && (e.scale = t.scale), y(t.translation) && (e.translation = t.translation), y(t.extras) && (e.extras = t.extras), y(t.meshes) && (e.mesh = t.meshes[0]), e.translation || e.rotation || e.scale) {
                const t = function(t, e) {
                    if (e.matrix) return e.matrix;
                    if (e.translation || e.scale || e.rotation) {
                        const n = function(t, e) {
                            return t[0] = 1, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = 1, t[6] = 0, t[7] = 0, t[8] = 0, t[9] = 0, t[10] = 1, t[11] = 0, t[12] = e[0], t[13] = e[1], t[14] = e[2], t[15] = 1, t;
                        }(T, e.translation || E), r = function(t, e) {
                            var n = e[0], s = e[1], r = e[2], i = e[3], o = n + n, h = s + s, u = r + r, c = n * o, a = s * o, f = s * h, l = r * o, d = r * h, m = r * u, p = i * o, w = i * h, y = i * u;
                            return t[0] = 1 - f - m, t[1] = a + y, t[2] = l - w, t[3] = 0, t[4] = a - y, t[5] = 1 - c - m, t[6] = d + p, t[7] = 0, t[8] = l + w, t[9] = d - p, t[10] = 1 - c - f, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, t;
                        }(M, e.rotation || v), i = function(t, e) {
                            return t[0] = e[0], t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = e[1], t[6] = 0, t[7] = 0, t[8] = 0, t[9] = 0, t[10] = e[2], t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, t;
                        }(I, e.scale || P);
                        return s(i, r, i), s(t, n, i);
                    }
                    return function(t) {
                        return t[0] = 1, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = 1, t[6] = 0, t[7] = 0, t[8] = 0, t[9] = 0, t[10] = 1, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, t;
                    }(t);
                }([], e);
                delete e.translation, delete e.rotation, delete e.scale, e.matrix = t;
            }
            return e;
        }
        O(t) {
            const e = {};
            for(const n in t){
                const s = t[n];
                let r, i;
                s.instanceTechnique && s.instanceTechnique.values ? (r = s.instanceTechnique, i = r.values.diffuse) : (r = s, i = r.values.tex || r.values.diffuseTex || r.values.diffuse);
                const o = {
                    baseColorTexture: {
                        index: i
                    }
                };
                s.name && (o.name = s.name), s.extensions && (o.extensions = s.extensions), s.extras && (o.extras = s.extras), e[n] = o;
            }
            return e;
        }
        N(t) {
            if (t.bufferView || t.extensions && (t.extensions.KHR_binary_glTF || t.extensions.binary_glTF)) {
                const e = t.bufferView ? t : t.extensions.KHR_binary_glTF || t.extensions.binary_glTF;
                t.extensions && (t.mimeType = e.mimeType, t.width = e.width, t.height = e.height);
                const n = this.gltf.bufferViews[e.bufferView], s = (n.byteOffset || 0) + this.glbBuffer.byteOffset, r = n.byteLength, i = this.buffers[e.bufferView] = new Uint8Array(this.glbBuffer.buffer, s, r);
                return this.getImageByBuffer(i, t);
            }
            return this.requestExternalImage(t);
        }
        S(t) {
            const e = this.gltf.textures[t];
            if (!e) return null;
            const n = this.gltf.images[e.source];
            return this.N(n).then((t)=>{
                const s = this.gltf.samplers[e.sampler];
                return {
                    image: {
                        array: t.data,
                        width: t.width,
                        height: t.height,
                        index: e.source,
                        mimeType: n.mimeType,
                        name: n.name,
                        extras: n.extras
                    },
                    sampler: s
                };
            });
        }
        getBaseColorTexture(t) {
            const e = this.gltf.materials[t];
            let n, s;
            if (e.instanceTechnique && e.instanceTechnique.values ? (n = e.instanceTechnique, s = n.values.diffuse) : (n = e, s = n.values.tex || n.values.diffuseTex || n.values.diffuse), void 0 === s || void 0 === this.gltf.textures) return null;
            const r = this.gltf.textures[s];
            if (!r) return null;
            const i = this.gltf.samplers[r.sampler];
            return {
                format: r.format || 6408,
                internalFormat: r.internalFormat || 6408,
                type: r.type || 5121,
                sampler: i,
                source: this.gltf.images[r.source]
            };
        }
        getMaterial() {
            return null;
        }
        getAnimations() {
            return null;
        }
    }
    const q = 9729;
    class F extends R {
        constructor(t, e, n, s, r, i, o, h){
            super(s, r, i, o, h), this.rootPath = t, this.gltf = e, this.glbBuffer = n, this.buffers = {}, this.requests = {}, this.accessor = new k(t, e, n, o, h);
        }
        iterate(t, e) {
            const n = this.gltf[e];
            if (n) for(let e = 0; e < n.length; e++)t(e, n[e], e);
        }
        createNode(t) {
            const e = {};
            return b(e, t), !y(t.weights) && this.gltf.meshes && y(e.mesh) ? e.weights = this.gltf.meshes[e.mesh].weights : t.weights && (e.weights = t.weights), e;
        }
        S(t) {
            const e = this.gltf.textures[t];
            if (!e) return null;
            let n = e.source;
            if (e.extensions && e.extensions.EXT_texture_webp ? n = e.extensions.EXT_texture_webp.source : e.extensions && e.extensions.KHR_texture_basisu && (n = e.extensions.KHR_texture_basisu.source), !y(n)) return null;
            const s = this.gltf.images[n];
            return this.N(s).then((t)=>{
                if (!t) return null;
                const n = {
                    image: {
                        array: t.data,
                        mipmap: t.mipmap,
                        width: t.width,
                        height: t.height,
                        index: e.source,
                        mimeType: s.mimeType,
                        name: s.name,
                        extensions: s.extensions,
                        extras: s.extras
                    }
                };
                b(n, e);
                const r = y(e.sampler) ? this.gltf.samplers[e.sampler] : void 0;
                if (r && (n.sampler = r, n.sampler.magFilter = r.magFilter || q, n.sampler.minFilter = r.minFilter || 9987, n.sampler.wrapS = r.wrapS || 10497, n.sampler.wrapT = r.wrapT || 10497), "image/ktx2" === n.image.mimeType && !n.image.mipmap && n.sampler && n.sampler.minFilter !== q && 9728 !== n.sampler.minFilter) {
                    const t = n.sampler.minFilter;
                    n.sampler.minFilter = 9984 === t || 9986 === t ? 9728 : q;
                }
                return t.format && (n.format = t.format), n;
            });
        }
        N(t) {
            if (!y(t.bufferView)) return this.requestExternalImage(t);
            {
                const e = this.gltf.bufferViews[t.bufferView], n = this.gltf.buffers[e.buffer];
                if (n.uri) return this.requestImageFromBufferURI(n, e, t);
                if (this.glbBuffer) return this.B(e, t);
            }
            return null;
        }
        B(t, e) {
            const n = this.m(t, this.glbBuffer.buffer, this.glbBuffer.byteOffset);
            return this.getImageByBuffer(n, e);
        }
        m(t, e, n) {
            n = n || 0;
            const s = (t.byteOffset || 0) + n, r = t.byteLength;
            return new Uint8Array(e, s, r);
        }
        R(t, e) {
            const n = new Array(t.byteLength);
            for(let e = 0; e < t.byteLength; e++)n[e] = String.fromCharCode(t[e]);
            n.join("");
            const s = "data:" + (e = e || "image/png") + ";base64," + function(t) {
                return "undefined" != typeof self ? self.btoa(t) : window.btoa(t);
            }(unescape(encodeURIComponent(n)));
            return s;
        }
        getAnimations(t) {
            const e = [];
            return t.forEach((t)=>{
                e.push(this.getSamplers(t.samplers));
            }), Promise.all(e).then((e)=>{
                for(let n = 0; n < e.length; n++)t[n].samplers = e[n];
                return t;
            });
        }
        getSamplers(t) {
            const e = [];
            for(let n = 0; n < t.length; n++)(y(t[n].input) || y(t[n].output)) && (e.push(this.accessor.T("input", t[n].input)), e.push(this.accessor.T("output", t[n].output)));
            return Promise.all(e).then((e)=>{
                for(let n = 0; n < e.length / 2; n++)t[n].input = e[2 * n], t[n].output = e[2 * n + 1], t[n].interpolation || (t[n].interpolation = "LINEAR");
                return t;
            });
        }
    }
    const D = "undefined" != typeof TextDecoder ? new TextDecoder("utf-8") : null;
    class V {
        static read(t, e = 0, n = 0) {
            n || (n = t.byteLength);
            const s = new DataView(t, e, n), r = s.getUint32(4, !0);
            if (1 === r) return V.readV1(s, e);
            if (2 === r) return V.readV2(t, e);
            throw new Error("Unsupported glb version : " + r);
        }
        static readV1(t, e) {
            const n = t.getUint32(8, !0), s = t.getUint32(12, !0);
            if (n !== t.byteLength) throw new Error("Length in GLB header is inconsistent with glb's byte length.");
            const r = j(t.buffer, 20 + e, s);
            return {
                json: JSON.parse(r),
                glbBuffer: {
                    byteOffset: 20 + e + s,
                    buffer: t.buffer,
                    byteLength: n
                }
            };
        }
        static readV2(t, e) {
            let n, s, r;
            const i = new DataView(t, e + 12);
            let o = 0;
            for(; o + 8 < i.byteLength;){
                const h = i.getUint32(o, !0);
                o += 4;
                const u = i.getUint32(o, !0);
                if (o += 4, 1313821514 === u) n = j(t, e + 12 + o, h);
                else if (5130562 === u) {
                    r = e + 12 + o, s = h;
                    break;
                }
                o += h;
            }
            return {
                json: JSON.parse(n),
                glbBuffer: {
                    byteOffset: r,
                    buffer: t,
                    byteLength: s
                }
            };
        }
    }
    function j(t, e, n) {
        if (D) {
            const s = new Uint8Array(t, e, n);
            return D.decode(s);
        }
        return function(t) {
            const e = t.length;
            let n = "";
            for(let s = 0; s < e;){
                let r = t[s++];
                if (128 & r) {
                    let n = K[r >> 3 & 7];
                    if (!(64 & r) || !n || s + n > e) return null;
                    for(r &= 63 >> n; n > 0; n -= 1){
                        const e = t[s++];
                        if (128 != (192 & e)) return null;
                        r = r << 6 | 63 & e;
                    }
                }
                n += String.fromCharCode(r);
            }
            return n;
        }(new Uint8Array(t, e, n));
    }
    const K = [
        1,
        1,
        1,
        1,
        2,
        2,
        3,
        0
    ], H = [
        0,
        0,
        0
    ], X = [
        0,
        0,
        0,
        1
    ], $ = [
        1,
        1,
        1
    ], z = {
        TRANSLATION: [
            0,
            0,
            0
        ],
        ROTATION: [
            0,
            0,
            0,
            1
        ],
        SCALE: [
            1,
            1,
            1
        ]
    }, G = {
        PREVIOUS: null,
        NEXT: null,
        PREINDEX: null,
        NEXTINDEX: null,
        INTERPOLATION: null
    }, J = {
        C (t, e, n, s, r, i, h, u) {
            const c = y(t) ? e.animations : [
                e.animations[0]
            ], a = {};
            for(let e = 0; e < c.length; e++){
                const f = c[e], l = f.name || e;
                if (y(t) && l !== t) continue;
                const d = f.channelsMap[n];
                if (d) for(let t = 0; t < d.length; t++){
                    const e = d[t];
                    "translation" === e.target.path ? (this.U(r, f.samplers[e.sampler], s, 1), a.translation = o(H, r)) : "rotation" === e.target.path ? (this.k(i, f.samplers[e.sampler], s, 1), a.rotation = m(X, i)) : "scale" === e.target.path ? (this.U(h, f.samplers[e.sampler], s, 1), a.scale = o($, h)) : "weights" === e.target.path && u && (this.U(u, f.samplers[e.sampler], s, u.length), a.weights = u);
                }
            }
            return a;
        },
        U (t, e, n, s) {
            switch(e.interpolation){
                case "LINEAR":
                    {
                        const r = this.L(G, e, n, 1 * s);
                        r && (t = function(t, e, n, s) {
                            for(let r = 0; r < t.length; r++)t[r] = e[r] + s * (n[r] - e[r]);
                            return t;
                        }(t, r.PREVIOUS, r.NEXT, r.INTERPOLATION));
                        break;
                    }
                case "STEP":
                    {
                        const r = this.L(G, e, n, 1 * s);
                        r && (t = function(t, e) {
                            for(let n = 0; n < t.length; n++)t[n] = e[n];
                            return t;
                        }(t, ...r.PREVIOUS));
                        break;
                    }
                case "CUBICSPLINE":
                    {
                        const r = this.L(G, e, n, 3 * s);
                        r && (t = this.q(t, r, e.input.array, 3 * s));
                        break;
                    }
            }
            return t;
        },
        k (t, e, n) {
            switch(e.interpolation){
                case "LINEAR":
                    {
                        const s = this.L(G, e, n, 1);
                        s && function(t, e, n, s) {
                            var r, i, o, h, u, c = e[0], a = e[1], f = e[2], l = e[3], d = n[0], m = n[1], p = n[2], w = n[3];
                            (i = c * d + a * m + f * p + l * w) < 0 && (i = -i, d = -d, m = -m, p = -p, w = -w), 1 - i > 1e-6 ? (r = Math.acos(i), o = Math.sin(r), h = Math.sin((1 - s) * r) / o, u = Math.sin(s * r) / o) : (h = 1 - s, u = s), t[0] = h * c + u * d, t[1] = h * a + u * m, t[2] = h * f + u * p, t[3] = h * l + u * w;
                        }(t, s.PREVIOUS, s.NEXT, s.INTERPOLATION);
                        break;
                    }
                case "STEP":
                    {
                        const s = this.L(G, e, n, 1);
                        s && (t = a(t, ...s.PREVIOUS));
                        break;
                    }
                case "CUBICSPLINE":
                    {
                        const s = this.L(G, e, n, 3);
                        if (s) {
                            for(let t = 0; t < s.PREVIOUS.length; t++)s.PREVIOUS[t] = Math.acos(s.PREVIOUS[t]), s.NEXT[t] = Math.acos(s.NEXT[t]);
                            t = this.q(t, s, e.input.array, 3);
                            for(let e = 0; e < t.length; e++)t[e] = Math.cos(t[e]);
                        }
                        break;
                    }
            }
            return t;
        },
        F (t, e) {
            const n = t.length;
            let s, r, i, o = 0, h = n - 1, u = Math.floor((o + h) / 2);
            for(; o <= n - 1 && h >= 0;){
                if (o === h) return null;
                if (t[u] <= e && e <= t[u + 1]) {
                    const n = t[u];
                    return s = u, r = u + 1, i = (e - n) / (t[u + 1] - n), {
                        preIndx: s,
                        nextIndex: r,
                        interpolation: i
                    };
                }
                e < t[u] ? (h = u, u = Math.floor((o + h) / 2)) : t[u + 1] < e && (o = u, u = Math.floor((o + h) / 2));
            }
            return null;
        },
        L (t, e, n, s) {
            const r = e.input.array, i = e.output.array, o = e.output.itemSize;
            (n < r[0] || n > r[r.length - 1]) && (n = Math.max(r[0], Math.min(r[r.length - 1], n))), n === r[r.length - 1] && (n = r[0]);
            const h = this.F(r, n);
            if (!h || !h.nextIndex) return null;
            const { preIndx: u, nextIndex: c, interpolation: a } = h;
            t.PREINDEX = u, t.NEXTINDEX = c, t.INTERPOLATION = a;
            const f = o * s;
            return t.PREVIOUS = i.subarray(t.PREINDEX * f, (t.PREINDEX + 1) * f), t.NEXT = i.subarray(t.NEXTINDEX * f, (t.NEXTINDEX + 1) * f), t;
        },
        q (t, e, n, s) {
            const r = e.INTERPOLATION, i = n[e.PREINDEX], o = n[e.NEXTINDEX];
            for(let n = 0; n < 3; n++){
                const h = e.PREVIOUS[s + n], u = (o - i) * e.PREVIOUS[2 * s + n], c = e.NEXT[3 + n], a = (o - i) * e.NEXT[n], f = (2 * Math.pow(r, 3) - 3 * Math.pow(r, 2) + 1) * h + (Math.pow(r, 3) - 2 * Math.pow(r, 2) + r) * u + (2 * -Math.pow(r, 3) + 3 * Math.pow(r, 2)) * c + (Math.pow(r, 3) - Math.pow(r, 2)) * a;
                t[n] = f;
            }
            return t;
        },
        getAnimationClip (t, e, n, s) {
            const r = t.nodes[e] && t.nodes[e].weights;
            return h(H, ...z.TRANSLATION), a(X, ...z.ROTATION), h($, ...z.SCALE), this.C(s, t, e, n, H, X, $, r);
        },
        getTimeSpan (t) {
            if (!t.animations) return null;
            if (t.timeSpan) return t.timeSpan;
            const e = t.animations;
            return t.timeSpan = {}, e.forEach((e, n)=>{
                let s = -1 / 0, r = 1 / 0;
                const i = e.channels;
                for(let t = 0; t < i.length; t++){
                    const n = i[t], o = e.samplers[n.sampler].input.array;
                    o[o.length - 1] > s && (s = o[o.length - 1]), o[0] < r && (r = o[0]);
                }
                const o = e.name || n;
                t.timeSpan[o] = {
                    max: s,
                    min: r
                };
            }), t.timeSpan;
        },
        getTimeSpanByName (t, e) {
            const n = this.getTimeSpan(t);
            return n ? y(e) ? n[e] : n[Object.keys(n)[0]] : null;
        }
    };
    let W = !1;
    if ("undefined" != typeof OffscreenCanvas) {
        let t;
        try {
            t = new OffscreenCanvas(2, 2).getContext("2d");
        } catch (n) {}
        t && "undefined" != typeof createImageBitmap && (W = !0);
    }
    const Q = "undefined" == typeof document ? null : document.createElement("canvas");
    function Y(t, e, n) {
        const s = new Image;
        s.crossOrigin = "", s.onload = ()=>{
            if (!Q) return void n(new Error("There is no canvas to draw image!"));
            Q.width = s.width, Q.height = s.height;
            const t = Q.getContext("2d", {
                willReadFrequently: !0
            });
            t.drawImage(s, 0, 0, s.width, s.height);
            const e = t.getImageData(0, 0, s.width, s.height), r = {
                width: s.width,
                height: s.height,
                data: new Uint8Array(e.data)
            };
            n(null, r);
        }, s.onerror = function(t) {
            n(t);
        }, s.src = t;
    }
    const Z = [], tt = [], et = 30;
    let nt, st;
    function rt(t, e, n) {
        nt || (nt = new OffscreenCanvas(2, 2), st = nt.getContext("2d", {
            willReadFrequently: !0
        }));
        let s = null;
        if (g(t)) this.options.urlModifier && (t = this.options.urlModifier(t)), Z.push([
            t,
            e,
            n,
            this
        ]), it();
        else {
            const e = new Blob([
                t
            ]);
            s = createImageBitmap(e), s.then(ot.bind(this)).then((t)=>{
                n(null, t);
            }).catch((t)=>{
                console.warn(t), n(t);
            });
        }
    }
    function it() {
        if (!Z.length || tt.length > et) return;
        const t = Z.shift(), [e, n, s, r] = t;
        tt.push(t), fetch(e, n).then((t)=>t.arrayBuffer()).then((t)=>{
            const e = new Blob([
                new Uint8Array(t)
            ]);
            return createImageBitmap(e);
        }).then(ot.bind(r)).then((e)=>{
            s.call(r, null, e);
            const n = tt.indexOf(t);
            tt.splice(n, 1), it();
        }).catch((e)=>{
            console.warn(e), s.call(r, e);
            const n = tt.indexOf(t);
            tt.splice(n, 1), it();
        });
    }
    function ot(t) {
        let { width: e, height: n } = t;
        ht(e) || (e = ut(e)), ht(n) || (n = ut(n));
        const s = this.options.maxTextureSize;
        s && (e = Math.min(s, e), n = Math.min(s, n)), nt.width = e, nt.height = n, st.drawImage(t, 0, 0, e, n), t.close();
        const r = st.getImageData(0, 0, e, n);
        return {
            width: e,
            height: n,
            data: new Uint8Array(r.data)
        };
    }
    function ht(t) {
        return !(t & t - 1) && 0 !== t;
    }
    function ut(t) {
        return Math.pow(2, Math.floor(Math.log(t) / Math.LN2));
    }
    function ct(t, e) {
        for(const n in t)if (t[n] === e) return n;
        return e;
    }
    t.Ajax = B, t.GLTFLoader = class {
        constructor(t, e, n){
            if (this.options = n || {}, this.options.decoders || (this.options.decoders = {}), this.u = this.options.fetchOptions || {}, e.buffer instanceof ArrayBuffer) {
                const { json: n, glbBuffer: s } = V.read(e.buffer, e.byteOffset, e.byteLength);
                this.D(t, n, s);
            } else this.D(t, e);
            this.V = new k(this.rootPath, this.gltf, this.glbBuffer, this.u, this.options.urlModifier), this.j();
        }
        j() {
            const t = this.gltf.extensionsRequired;
            if (t) {
                if (t.indexOf("KHR_draco_mesh_compression") >= 0 && !this.options.decoders.draco) throw new Error("KHR_draco_mesh_compression is required but @maptalks/transcoders.draco is not loaded");
                if (t.indexOf("KHR_texture_basisu") >= 0 && !this.options.decoders["image/ktx2"]) throw new Error("KHR_texture_basisu is required but @maptalks/transcoders.ktx2 is not loaded");
                if (t.indexOf("EXT_meshopt_compression") >= 0) throw new Error("EXT_meshopt_compression extension is not supported yet.");
            }
        }
        K() {
            const t = this.gltf.extensions;
            return t && t.KHR_techniques_webgl ? this.V.requestKHRTechniquesWebgl(t.KHR_techniques_webgl).then((e)=>(t.KHR_techniques_webgl = e, t)) : Promise.resolve(t);
        }
        H() {
            if (!Array.isArray(this.gltf.programs)) return;
            const t = this.gltf.materials;
            for(let e = 0; e < t.length; e++)t[e] && t[e].extensions && t[e].extensions.KHR_technique_webgl && (t[e].extensions.KHR_techniques_webgl = t[e].extensions.KHR_technique_webgl, delete t[e].extensions.KHR_technique_webgl);
            const e = this.gltf.extensions || {}, n = this.gltf.techniques;
            e.KHR_techniques_webgl = {
                programs: this.gltf.programs,
                shaders: this.gltf.shaders,
                techniques: n
            };
            for(let e = 0; e < t.length; e++){
                const r = (s = t[e]) && s.extensions && s.extensions.KHR_techniques_webgl;
                if (r) {
                    const { values: t, technique: e } = r, s = n[e];
                    if (!s || !t) continue;
                    const { uniforms: i, parameters: o } = s, h = {};
                    for(const e in t){
                        const n = ct(i, e);
                        h[n] = t[e], o[e] && 35678 === o[e].type && (h[n] = {
                            index: t[e]
                        });
                    }
                    r.values = h;
                }
            }
            var s;
            for(let t = 0; t < n.length; t++){
                const e = n[t];
                if (!e) continue;
                const { attributes: s, uniforms: r, parameters: i } = e;
                if (s) for(const t in s){
                    const e = s[t];
                    s[t] = i[e];
                }
                if (r) for(const t in r){
                    const e = r[t];
                    r[t] = i[e];
                }
                delete e.parameters;
            }
            return delete this.gltf.programs, delete this.gltf.shaders, delete this.gltf.techniques, this.gltf.extensions = e, e;
        }
        load(t) {
            t = t || {}, this.H();
            const e = this.X(t), n = this.$(), s = this.G(), r = this.K();
            return Promise.all([
                e,
                n,
                s,
                r
            ]).then((t)=>(t[0].animations = t[1], t[0].textures = t[2], t[0].extensions = t[3], t[0].transferables = this.transferables || [], this.createChannelsMap(t[0]), t[0]));
        }
        createChannelsMap(t) {
            const e = t.animations;
            if (e) for(let t = 0; t < e.length; t++){
                const n = e[t];
                n.channelsMap = {};
                for(let t = 0; t < n.channels.length; t++){
                    const e = n.channels[t];
                    n.channelsMap[e.target.node] || (n.channelsMap[e.target.node] = []), n.channelsMap[e.target.node].push(e);
                }
            }
        }
        getExternalResources() {
            const t = [];
            if (this.gltf) {
                const { buffers: e, images: n } = this.gltf;
                for(let n = 0; n < e.length; n++)e[n].uri && e[n].uri.indexOf("data:application/octet-stream;base64") < 0 && t.push({
                    type: "buffer",
                    uri: e[n].uri
                });
                for(let e = 0; e < n.length; e++)n[e].uri && n[e].uri.indexOf("data:image/") < 0 && t.push({
                    type: "image",
                    uri: n[e].uri
                });
            }
            return t;
        }
        static getAnimationClip(t, e, n, s) {
            return J.getAnimationClip(t, e, n, s);
        }
        static getAnimationTimeSpan(t, e) {
            return J.getTimeSpanByName(t, e);
        }
        static getTypedArrayCtor(t) {
            return _(t);
        }
        static readInterleavedArray(t, e, n, s, r, i, o) {
            return O(t, e, n, s, r, i, o);
        }
        D(t, e, n) {
            this.gltf = e, this.glbBuffer = n, this.version = e.asset ? +e.asset.version : 1, this.rootPath = t, this.buffers = {}, this.requests = {}, this.options.requestImage = W ? rt.bind(this) : this.options.requestImage || Y, this.options.transferable && (this.transferables = []), 2 === this.version ? (this.adapter = new F(t, e, n, this.options.requestImage, this.options.decoders || {}, this.options.supportedFormats || {}, this.u, this.options.urlModifier), this.adapter.iterate((t, e, n)=>{
                e.id = "buffer_" + n;
            }, "buffers"), this.adapter.iterate((t, e, n)=>{
                e.id = "image_" + n;
            }, "images"), this.adapter.iterate((t, e, n)=>{
                e.id = "accessor_" + n;
            }, "accessors")) : (this.adapter = new L(t, e, n, this.options.requestImage, this.options.decoders || {}, this.options.supportedFormats || {}, this.u, this.options.urlModifier), this.adapter.iterate((t, e, n)=>{
                e.id = "accessor_" + n;
            }, "accessors"), this.adapter.iterate((t, e, n)=>{
                e.id = "image_" + n;
            }, "images"));
        }
        J(t, e) {
            if (t.children && t.children.length > 0) {
                if (!("number" == typeof (n = t.children[0]) && isFinite(n) || g(t.children[0]))) return t;
                const s = t.children.map((t)=>{
                    const n = e[t];
                    return n.nodeIndex = t, this.J(n, e);
                });
                t.children = s;
            }
            var n;
            return t;
        }
        X(t) {
            return this.W(t).then((t)=>{
                const e = this.scenes = [];
                let n;
                for(const e in t)t[e] = this.J(t[e], t), t[e].nodeIndex = Number(e) ? Number(e) : e;
                this.adapter.iterate((s, r, i)=>{
                    const o = {};
                    r.name && (o.name = r.name), r.nodes && (o.nodes = r.nodes.map((e)=>t[e])), this.gltf.scene === s && (n = i), e.push(o);
                }, "scenes");
                const s = {
                    textures: this.gltf.textures,
                    asset: this.gltf.asset,
                    scene: n,
                    scenes: e,
                    nodes: t,
                    meshes: this.meshes,
                    materials: this.gltf.materials,
                    skins: this.skins,
                    extensionsRequired: this.gltf.extensionsRequired,
                    extensionsUsed: this.gltf.extensionsUsed
                };
                if (this.gltf.extensions && (s.extensions = this.gltf.extensions), 1 === this.version) {
                    const t = this.adapter.O(this.gltf.materials);
                    s.materials = t;
                }
                return delete this.gltf.buffers, s.json = this.gltf, s;
            });
        }
        W(t) {
            return this.Y(t).then(()=>{
                const t = this.nodes = {};
                return this.adapter.iterate((e, n)=>{
                    const s = this.adapter.createNode(n, this.meshes, this.skins);
                    t[e] = s;
                }, "nodes"), t;
            });
        }
        Z() {
            this.skins = [];
            const t = [];
            return this.adapter.iterate((e, n, s)=>{
                t.push(this.tt(n).then((t)=>{
                    t.index = s, this.skins.push(t);
                }));
            }, "skins"), t;
        }
        tt(t) {
            const e = t.inverseBindMatrices;
            return this.adapter.accessor.T("inverseBindMatrices", e).then((e)=>(t.inverseBindMatrices = e, e && e.buffer && this.transferables && this.transferables.indexOf(e.buffer) < 0 && this.transferables.push(e.buffer), t));
        }
        $() {
            const t = this.gltf.animations;
            return y(t) ? this.adapter.getAnimations(t) : null;
        }
        Y(t) {
            this.meshes = {};
            let e = [];
            return this.adapter.iterate((n, s, r)=>{
                e.push(this.et(s, t).then((t)=>{
                    t.index = r, this.meshes[n] = t;
                }));
            }, "meshes"), e = e.concat(this.Z()), Promise.all(e);
        }
        et(t, e) {
            const n = t.primitives.map((t)=>this.nt(t, e)).filter((t)=>!!t);
            return Promise.all(n).then((e)=>{
                const n = {};
                return b(n, t), n.primitives = e, n;
            });
        }
        G() {
            const t = this.gltf.textures;
            if (!t) return null;
            const e = [];
            for(const n in t)e.push(this.adapter.S(n));
            return Promise.all(e).then((e)=>{
                if (this.transferables) for(let t = 0; t < e.length; t++){
                    const n = e[t] && e[t].image.array;
                    if (n) {
                        let t;
                        t = n instanceof ImageBitmap ? n : n.buffer, t && this.transferables.indexOf(t) < 0 && this.transferables.push(t);
                    }
                }
                if (!Array.isArray(t)) {
                    const n = {}, s = Object.keys(t);
                    for(let t = 0; t < e.length; t++)e[t] && (n[s[t]] = e[t]);
                    return n;
                }
                return e;
            });
        }
        nt(t, e) {
            let n;
            const s = [], r = t.extensions;
            if (y(t.targets)) for(let e = 0; e < t.targets.length; e++){
                const n = t.targets[e];
                for(const t in n){
                    const r = this.adapter.accessor.T(`morphTargets_${t}_${e}`, n[t]);
                    r && s.push(r);
                }
            }
            if (r && r.KHR_draco_mesh_compression) {
                if (!this.options.decoders.draco && (!this.gltf.extensionsRequired || !this.gltf.extensionsRequired.indexOf("KHR_draco_mesh_compression") < 0)) return null;
                const t = this.options.decoders.draco, { bufferView: i, attributes: o } = r.KHR_draco_mesh_compression, h = this.gltf.bufferViews[i], u = this.V.I(h).then((n)=>{
                    const { buffer: s, byteOffset: r } = n;
                    let { byteOffset: i } = h;
                    const u = h.byteLength;
                    i || (i = 0);
                    const c = new DataView(s, r + i, u), a = {
                        attributes: o,
                        useUniqueIDs: !1,
                        skipAttributeTransform: e.skipAttributeTransform
                    };
                    return t(c, a).then((t)=>{
                        const e = Object.values(t.attributes);
                        return t.indices && e.push(t.indices), e;
                    });
                });
                s.push(u), n = Promise.all(s);
            } else {
                const e = t.attributes;
                for(const t in e){
                    const n = this.adapter.accessor.T(t, e[t]);
                    n && s.push(n);
                }
                if (y(t.indices)) {
                    const e = this.adapter.accessor.T("indices", t.indices);
                    e && s.push(e);
                }
                n = Promise.all(s);
            }
            return n.then((e)=>{
                if (r && r.KHR_draco_mesh_compression) {
                    const n = t.targets ? t.targets.length : 0;
                    e[n] = e[n].concat(e.slice(0, n)), e = e[n];
                }
                let n, s;
                const i = {
                    attributes: e.reduce((t, e)=>{
                        if ("indices" === e.name) n = e;
                        else if (e.name.indexOf("morphTargets_") > -1) s = s || {}, s[e.name.slice(13)] = e;
                        else {
                            if (!("POSITION" !== e.name || e.min && e.max)) {
                                const t = [
                                    1 / 0,
                                    1 / 0,
                                    1 / 0
                                ], n = [
                                    -1 / 0,
                                    -1 / 0,
                                    -1 / 0
                                ], { itemSize: s, array: r } = e, i = r.length / s;
                                for(let e = 0; e < i; e++)for(let i = 0; i < s; i++){
                                    const o = e * s + i;
                                    r[o] < t[i] && (t[i] = r[o]), r[o] > n[i] && (n[i] = r[o]);
                                }
                                if (e.quantization) {
                                    const s = e.quantization, r = s.range / (1 << s.quantizationBits), i = s.minValues;
                                    c(t, t, r), u(t, t, i), c(n, n, r), u(n, n, i);
                                }
                                e.min = t, e.max = n;
                            }
                            t[e.name] = e;
                        }
                        return this.transferables && e.array.buffer && this.transferables.indexOf(e.array.buffer) < 0 && this.transferables.push(e.array.buffer), t;
                    }, {}),
                    material: t.material
                };
                return n && (i.indices = n), s && (i.morphTargets = s), i.mode = y(t.mode) ? t.mode : 4, y(t.extras) && (i.extras = t.extras), i;
            });
        }
    }, e().maptalks_gltf_loader = t;
}
gltfLoaderExport({});
function getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}
var colorString$1 = {
    exports: {}
};
var colorName$1 = {
    "aliceblue": [
        240,
        248,
        255
    ],
    "antiquewhite": [
        250,
        235,
        215
    ],
    "aqua": [
        0,
        255,
        255
    ],
    "aquamarine": [
        127,
        255,
        212
    ],
    "azure": [
        240,
        255,
        255
    ],
    "beige": [
        245,
        245,
        220
    ],
    "bisque": [
        255,
        228,
        196
    ],
    "black": [
        0,
        0,
        0
    ],
    "blanchedalmond": [
        255,
        235,
        205
    ],
    "blue": [
        0,
        0,
        255
    ],
    "blueviolet": [
        138,
        43,
        226
    ],
    "brown": [
        165,
        42,
        42
    ],
    "burlywood": [
        222,
        184,
        135
    ],
    "cadetblue": [
        95,
        158,
        160
    ],
    "chartreuse": [
        127,
        255,
        0
    ],
    "chocolate": [
        210,
        105,
        30
    ],
    "coral": [
        255,
        127,
        80
    ],
    "cornflowerblue": [
        100,
        149,
        237
    ],
    "cornsilk": [
        255,
        248,
        220
    ],
    "crimson": [
        220,
        20,
        60
    ],
    "cyan": [
        0,
        255,
        255
    ],
    "darkblue": [
        0,
        0,
        139
    ],
    "darkcyan": [
        0,
        139,
        139
    ],
    "darkgoldenrod": [
        184,
        134,
        11
    ],
    "darkgray": [
        169,
        169,
        169
    ],
    "darkgreen": [
        0,
        100,
        0
    ],
    "darkgrey": [
        169,
        169,
        169
    ],
    "darkkhaki": [
        189,
        183,
        107
    ],
    "darkmagenta": [
        139,
        0,
        139
    ],
    "darkolivegreen": [
        85,
        107,
        47
    ],
    "darkorange": [
        255,
        140,
        0
    ],
    "darkorchid": [
        153,
        50,
        204
    ],
    "darkred": [
        139,
        0,
        0
    ],
    "darksalmon": [
        233,
        150,
        122
    ],
    "darkseagreen": [
        143,
        188,
        143
    ],
    "darkslateblue": [
        72,
        61,
        139
    ],
    "darkslategray": [
        47,
        79,
        79
    ],
    "darkslategrey": [
        47,
        79,
        79
    ],
    "darkturquoise": [
        0,
        206,
        209
    ],
    "darkviolet": [
        148,
        0,
        211
    ],
    "deeppink": [
        255,
        20,
        147
    ],
    "deepskyblue": [
        0,
        191,
        255
    ],
    "dimgray": [
        105,
        105,
        105
    ],
    "dimgrey": [
        105,
        105,
        105
    ],
    "dodgerblue": [
        30,
        144,
        255
    ],
    "firebrick": [
        178,
        34,
        34
    ],
    "floralwhite": [
        255,
        250,
        240
    ],
    "forestgreen": [
        34,
        139,
        34
    ],
    "fuchsia": [
        255,
        0,
        255
    ],
    "gainsboro": [
        220,
        220,
        220
    ],
    "ghostwhite": [
        248,
        248,
        255
    ],
    "gold": [
        255,
        215,
        0
    ],
    "goldenrod": [
        218,
        165,
        32
    ],
    "gray": [
        128,
        128,
        128
    ],
    "green": [
        0,
        128,
        0
    ],
    "greenyellow": [
        173,
        255,
        47
    ],
    "grey": [
        128,
        128,
        128
    ],
    "honeydew": [
        240,
        255,
        240
    ],
    "hotpink": [
        255,
        105,
        180
    ],
    "indianred": [
        205,
        92,
        92
    ],
    "indigo": [
        75,
        0,
        130
    ],
    "ivory": [
        255,
        255,
        240
    ],
    "khaki": [
        240,
        230,
        140
    ],
    "lavender": [
        230,
        230,
        250
    ],
    "lavenderblush": [
        255,
        240,
        245
    ],
    "lawngreen": [
        124,
        252,
        0
    ],
    "lemonchiffon": [
        255,
        250,
        205
    ],
    "lightblue": [
        173,
        216,
        230
    ],
    "lightcoral": [
        240,
        128,
        128
    ],
    "lightcyan": [
        224,
        255,
        255
    ],
    "lightgoldenrodyellow": [
        250,
        250,
        210
    ],
    "lightgray": [
        211,
        211,
        211
    ],
    "lightgreen": [
        144,
        238,
        144
    ],
    "lightgrey": [
        211,
        211,
        211
    ],
    "lightpink": [
        255,
        182,
        193
    ],
    "lightsalmon": [
        255,
        160,
        122
    ],
    "lightseagreen": [
        32,
        178,
        170
    ],
    "lightskyblue": [
        135,
        206,
        250
    ],
    "lightslategray": [
        119,
        136,
        153
    ],
    "lightslategrey": [
        119,
        136,
        153
    ],
    "lightsteelblue": [
        176,
        196,
        222
    ],
    "lightyellow": [
        255,
        255,
        224
    ],
    "lime": [
        0,
        255,
        0
    ],
    "limegreen": [
        50,
        205,
        50
    ],
    "linen": [
        250,
        240,
        230
    ],
    "magenta": [
        255,
        0,
        255
    ],
    "maroon": [
        128,
        0,
        0
    ],
    "mediumaquamarine": [
        102,
        205,
        170
    ],
    "mediumblue": [
        0,
        0,
        205
    ],
    "mediumorchid": [
        186,
        85,
        211
    ],
    "mediumpurple": [
        147,
        112,
        219
    ],
    "mediumseagreen": [
        60,
        179,
        113
    ],
    "mediumslateblue": [
        123,
        104,
        238
    ],
    "mediumspringgreen": [
        0,
        250,
        154
    ],
    "mediumturquoise": [
        72,
        209,
        204
    ],
    "mediumvioletred": [
        199,
        21,
        133
    ],
    "midnightblue": [
        25,
        25,
        112
    ],
    "mintcream": [
        245,
        255,
        250
    ],
    "mistyrose": [
        255,
        228,
        225
    ],
    "moccasin": [
        255,
        228,
        181
    ],
    "navajowhite": [
        255,
        222,
        173
    ],
    "navy": [
        0,
        0,
        128
    ],
    "oldlace": [
        253,
        245,
        230
    ],
    "olive": [
        128,
        128,
        0
    ],
    "olivedrab": [
        107,
        142,
        35
    ],
    "orange": [
        255,
        165,
        0
    ],
    "orangered": [
        255,
        69,
        0
    ],
    "orchid": [
        218,
        112,
        214
    ],
    "palegoldenrod": [
        238,
        232,
        170
    ],
    "palegreen": [
        152,
        251,
        152
    ],
    "paleturquoise": [
        175,
        238,
        238
    ],
    "palevioletred": [
        219,
        112,
        147
    ],
    "papayawhip": [
        255,
        239,
        213
    ],
    "peachpuff": [
        255,
        218,
        185
    ],
    "peru": [
        205,
        133,
        63
    ],
    "pink": [
        255,
        192,
        203
    ],
    "plum": [
        221,
        160,
        221
    ],
    "powderblue": [
        176,
        224,
        230
    ],
    "purple": [
        128,
        0,
        128
    ],
    "rebeccapurple": [
        102,
        51,
        153
    ],
    "red": [
        255,
        0,
        0
    ],
    "rosybrown": [
        188,
        143,
        143
    ],
    "royalblue": [
        65,
        105,
        225
    ],
    "saddlebrown": [
        139,
        69,
        19
    ],
    "salmon": [
        250,
        128,
        114
    ],
    "sandybrown": [
        244,
        164,
        96
    ],
    "seagreen": [
        46,
        139,
        87
    ],
    "seashell": [
        255,
        245,
        238
    ],
    "sienna": [
        160,
        82,
        45
    ],
    "silver": [
        192,
        192,
        192
    ],
    "skyblue": [
        135,
        206,
        235
    ],
    "slateblue": [
        106,
        90,
        205
    ],
    "slategray": [
        112,
        128,
        144
    ],
    "slategrey": [
        112,
        128,
        144
    ],
    "snow": [
        255,
        250,
        250
    ],
    "springgreen": [
        0,
        255,
        127
    ],
    "steelblue": [
        70,
        130,
        180
    ],
    "tan": [
        210,
        180,
        140
    ],
    "teal": [
        0,
        128,
        128
    ],
    "thistle": [
        216,
        191,
        216
    ],
    "tomato": [
        255,
        99,
        71
    ],
    "turquoise": [
        64,
        224,
        208
    ],
    "violet": [
        238,
        130,
        238
    ],
    "wheat": [
        245,
        222,
        179
    ],
    "white": [
        255,
        255,
        255
    ],
    "whitesmoke": [
        245,
        245,
        245
    ],
    "yellow": [
        255,
        255,
        0
    ],
    "yellowgreen": [
        154,
        205,
        50
    ]
};
var simpleSwizzle = {
    exports: {}
};
var isArrayish$1 = function isArrayish(obj) {
    if (!obj || typeof obj === 'string') return false;
    return obj instanceof Array || Array.isArray(obj) || obj.length >= 0 && (obj.splice instanceof Function || Object.getOwnPropertyDescriptor(obj, obj.length - 1) && obj.constructor.name !== 'String');
};
var isArrayish = isArrayish$1;
var concat = Array.prototype.concat;
var slice = Array.prototype.slice;
var swizzle$1 = simpleSwizzle.exports = function swizzle(args) {
    var results = [];
    for(var i = 0, len = args.length; i < len; i++){
        var arg = args[i];
        if (isArrayish(arg)) // http://jsperf.com/javascript-array-concat-vs-push/98
        results = concat.call(results, slice.call(arg));
        else results.push(arg);
    }
    return results;
};
swizzle$1.wrap = function(fn) {
    return function() {
        return fn(swizzle$1(arguments));
    };
};
var simpleSwizzleExports = simpleSwizzle.exports;
/* MIT license */ var colorNames = colorName$1;
var swizzle = simpleSwizzleExports;
var hasOwnProperty = Object.hasOwnProperty;
var reverseNames = Object.create(null);
// create a list of reverse color names
for(var name in colorNames)if (hasOwnProperty.call(colorNames, name)) reverseNames[colorNames[name]] = name;
var cs = colorString$1.exports = {
    to: {},
    get: {}
};
cs.get = function(string) {
    var prefix = string.substring(0, 3).toLowerCase();
    var val;
    var model;
    switch(prefix){
        case 'hsl':
            val = cs.get.hsl(string);
            model = 'hsl';
            break;
        case 'hwb':
            val = cs.get.hwb(string);
            model = 'hwb';
            break;
        default:
            val = cs.get.rgb(string);
            model = 'rgb';
            break;
    }
    if (!val) return null;
    return {
        model: model,
        value: val
    };
};
cs.get.rgb = function(string) {
    if (!string) return null;
    var abbr = /^#([a-f0-9]{3,4})$/i;
    var hex = /^#([a-f0-9]{6})([a-f0-9]{2})?$/i;
    var rgba = /^rgba?\(\s*([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/;
    var per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/;
    var keyword = /^(\w+)$/;
    var rgb = [
        0,
        0,
        0,
        1
    ];
    var match;
    var i;
    var hexAlpha;
    if (match = string.match(hex)) {
        hexAlpha = match[2];
        match = match[1];
        for(i = 0; i < 3; i++){
            // https://jsperf.com/slice-vs-substr-vs-substring-methods-long-string/19
            var i2 = i * 2;
            rgb[i] = parseInt(match.slice(i2, i2 + 2), 16);
        }
        if (hexAlpha) rgb[3] = parseInt(hexAlpha, 16) / 255;
    } else if (match = string.match(abbr)) {
        match = match[1];
        hexAlpha = match[3];
        for(i = 0; i < 3; i++)rgb[i] = parseInt(match[i] + match[i], 16);
        if (hexAlpha) rgb[3] = parseInt(hexAlpha + hexAlpha, 16) / 255;
    } else if (match = string.match(rgba)) {
        for(i = 0; i < 3; i++)rgb[i] = parseInt(match[i + 1], 0);
        if (match[4]) {
            if (match[5]) rgb[3] = parseFloat(match[4]) * 0.01;
            else rgb[3] = parseFloat(match[4]);
        }
    } else if (match = string.match(per)) {
        for(i = 0; i < 3; i++)rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
        if (match[4]) {
            if (match[5]) rgb[3] = parseFloat(match[4]) * 0.01;
            else rgb[3] = parseFloat(match[4]);
        }
    } else if (match = string.match(keyword)) {
        if (match[1] === 'transparent') return [
            0,
            0,
            0,
            0
        ];
        if (!hasOwnProperty.call(colorNames, match[1])) return null;
        rgb = colorNames[match[1]];
        rgb[3] = 1;
        return rgb;
    } else return null;
    for(i = 0; i < 3; i++)rgb[i] = clamp(rgb[i], 0, 255);
    rgb[3] = clamp(rgb[3], 0, 1);
    return rgb;
};
cs.get.hsl = function(string) {
    if (!string) return null;
    var hsl = /^hsla?\(\s*([+-]?(?:\d{0,3}\.)?\d+)(?:deg)?\s*,?\s*([+-]?[\d\.]+)%\s*,?\s*([+-]?[\d\.]+)%\s*(?:[,|\/]\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/;
    var match = string.match(hsl);
    if (match) {
        var alpha = parseFloat(match[4]);
        var h = (parseFloat(match[1]) % 360 + 360) % 360;
        var s = clamp(parseFloat(match[2]), 0, 100);
        var l = clamp(parseFloat(match[3]), 0, 100);
        var a = clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
        return [
            h,
            s,
            l,
            a
        ];
    }
    return null;
};
cs.get.hwb = function(string) {
    if (!string) return null;
    var hwb = /^hwb\(\s*([+-]?\d{0,3}(?:\.\d+)?)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/;
    var match = string.match(hwb);
    if (match) {
        var alpha = parseFloat(match[4]);
        var h = (parseFloat(match[1]) % 360 + 360) % 360;
        var w = clamp(parseFloat(match[2]), 0, 100);
        var b = clamp(parseFloat(match[3]), 0, 100);
        var a = clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
        return [
            h,
            w,
            b,
            a
        ];
    }
    return null;
};
cs.to.hex = function() {
    var rgba = swizzle(arguments);
    return '#' + hexDouble(rgba[0]) + hexDouble(rgba[1]) + hexDouble(rgba[2]) + (rgba[3] < 1 ? hexDouble(Math.round(rgba[3] * 255)) : '');
};
cs.to.rgb = function() {
    var rgba = swizzle(arguments);
    return rgba.length < 4 || rgba[3] === 1 ? 'rgb(' + Math.round(rgba[0]) + ', ' + Math.round(rgba[1]) + ', ' + Math.round(rgba[2]) + ')' : 'rgba(' + Math.round(rgba[0]) + ', ' + Math.round(rgba[1]) + ', ' + Math.round(rgba[2]) + ', ' + rgba[3] + ')';
};
cs.to.rgb.percent = function() {
    var rgba = swizzle(arguments);
    var r = Math.round(rgba[0] / 255 * 100);
    var g = Math.round(rgba[1] / 255 * 100);
    var b = Math.round(rgba[2] / 255 * 100);
    return rgba.length < 4 || rgba[3] === 1 ? 'rgb(' + r + '%, ' + g + '%, ' + b + '%)' : 'rgba(' + r + '%, ' + g + '%, ' + b + '%, ' + rgba[3] + ')';
};
cs.to.hsl = function() {
    var hsla = swizzle(arguments);
    return hsla.length < 4 || hsla[3] === 1 ? 'hsl(' + hsla[0] + ', ' + hsla[1] + '%, ' + hsla[2] + '%)' : 'hsla(' + hsla[0] + ', ' + hsla[1] + '%, ' + hsla[2] + '%, ' + hsla[3] + ')';
};
// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
// (hwb have alpha optional & 1 is default value)
cs.to.hwb = function() {
    var hwba = swizzle(arguments);
    var a = '';
    if (hwba.length >= 4 && hwba[3] !== 1) a = ', ' + hwba[3];
    return 'hwb(' + hwba[0] + ', ' + hwba[1] + '%, ' + hwba[2] + '%' + a + ')';
};
cs.to.keyword = function(rgb) {
    return reverseNames[rgb.slice(0, 3)];
};
// helpers
function clamp(num, min, max) {
    return Math.min(Math.max(min, num), max);
}
function hexDouble(num) {
    var str = Math.round(num).toString(16).toUpperCase();
    return str.length < 2 ? '0' + str : str;
}
var colorStringExports = colorString$1.exports;
var conversions$2 = {
    exports: {}
};
var colorName = {
    "aliceblue": [
        240,
        248,
        255
    ],
    "antiquewhite": [
        250,
        235,
        215
    ],
    "aqua": [
        0,
        255,
        255
    ],
    "aquamarine": [
        127,
        255,
        212
    ],
    "azure": [
        240,
        255,
        255
    ],
    "beige": [
        245,
        245,
        220
    ],
    "bisque": [
        255,
        228,
        196
    ],
    "black": [
        0,
        0,
        0
    ],
    "blanchedalmond": [
        255,
        235,
        205
    ],
    "blue": [
        0,
        0,
        255
    ],
    "blueviolet": [
        138,
        43,
        226
    ],
    "brown": [
        165,
        42,
        42
    ],
    "burlywood": [
        222,
        184,
        135
    ],
    "cadetblue": [
        95,
        158,
        160
    ],
    "chartreuse": [
        127,
        255,
        0
    ],
    "chocolate": [
        210,
        105,
        30
    ],
    "coral": [
        255,
        127,
        80
    ],
    "cornflowerblue": [
        100,
        149,
        237
    ],
    "cornsilk": [
        255,
        248,
        220
    ],
    "crimson": [
        220,
        20,
        60
    ],
    "cyan": [
        0,
        255,
        255
    ],
    "darkblue": [
        0,
        0,
        139
    ],
    "darkcyan": [
        0,
        139,
        139
    ],
    "darkgoldenrod": [
        184,
        134,
        11
    ],
    "darkgray": [
        169,
        169,
        169
    ],
    "darkgreen": [
        0,
        100,
        0
    ],
    "darkgrey": [
        169,
        169,
        169
    ],
    "darkkhaki": [
        189,
        183,
        107
    ],
    "darkmagenta": [
        139,
        0,
        139
    ],
    "darkolivegreen": [
        85,
        107,
        47
    ],
    "darkorange": [
        255,
        140,
        0
    ],
    "darkorchid": [
        153,
        50,
        204
    ],
    "darkred": [
        139,
        0,
        0
    ],
    "darksalmon": [
        233,
        150,
        122
    ],
    "darkseagreen": [
        143,
        188,
        143
    ],
    "darkslateblue": [
        72,
        61,
        139
    ],
    "darkslategray": [
        47,
        79,
        79
    ],
    "darkslategrey": [
        47,
        79,
        79
    ],
    "darkturquoise": [
        0,
        206,
        209
    ],
    "darkviolet": [
        148,
        0,
        211
    ],
    "deeppink": [
        255,
        20,
        147
    ],
    "deepskyblue": [
        0,
        191,
        255
    ],
    "dimgray": [
        105,
        105,
        105
    ],
    "dimgrey": [
        105,
        105,
        105
    ],
    "dodgerblue": [
        30,
        144,
        255
    ],
    "firebrick": [
        178,
        34,
        34
    ],
    "floralwhite": [
        255,
        250,
        240
    ],
    "forestgreen": [
        34,
        139,
        34
    ],
    "fuchsia": [
        255,
        0,
        255
    ],
    "gainsboro": [
        220,
        220,
        220
    ],
    "ghostwhite": [
        248,
        248,
        255
    ],
    "gold": [
        255,
        215,
        0
    ],
    "goldenrod": [
        218,
        165,
        32
    ],
    "gray": [
        128,
        128,
        128
    ],
    "green": [
        0,
        128,
        0
    ],
    "greenyellow": [
        173,
        255,
        47
    ],
    "grey": [
        128,
        128,
        128
    ],
    "honeydew": [
        240,
        255,
        240
    ],
    "hotpink": [
        255,
        105,
        180
    ],
    "indianred": [
        205,
        92,
        92
    ],
    "indigo": [
        75,
        0,
        130
    ],
    "ivory": [
        255,
        255,
        240
    ],
    "khaki": [
        240,
        230,
        140
    ],
    "lavender": [
        230,
        230,
        250
    ],
    "lavenderblush": [
        255,
        240,
        245
    ],
    "lawngreen": [
        124,
        252,
        0
    ],
    "lemonchiffon": [
        255,
        250,
        205
    ],
    "lightblue": [
        173,
        216,
        230
    ],
    "lightcoral": [
        240,
        128,
        128
    ],
    "lightcyan": [
        224,
        255,
        255
    ],
    "lightgoldenrodyellow": [
        250,
        250,
        210
    ],
    "lightgray": [
        211,
        211,
        211
    ],
    "lightgreen": [
        144,
        238,
        144
    ],
    "lightgrey": [
        211,
        211,
        211
    ],
    "lightpink": [
        255,
        182,
        193
    ],
    "lightsalmon": [
        255,
        160,
        122
    ],
    "lightseagreen": [
        32,
        178,
        170
    ],
    "lightskyblue": [
        135,
        206,
        250
    ],
    "lightslategray": [
        119,
        136,
        153
    ],
    "lightslategrey": [
        119,
        136,
        153
    ],
    "lightsteelblue": [
        176,
        196,
        222
    ],
    "lightyellow": [
        255,
        255,
        224
    ],
    "lime": [
        0,
        255,
        0
    ],
    "limegreen": [
        50,
        205,
        50
    ],
    "linen": [
        250,
        240,
        230
    ],
    "magenta": [
        255,
        0,
        255
    ],
    "maroon": [
        128,
        0,
        0
    ],
    "mediumaquamarine": [
        102,
        205,
        170
    ],
    "mediumblue": [
        0,
        0,
        205
    ],
    "mediumorchid": [
        186,
        85,
        211
    ],
    "mediumpurple": [
        147,
        112,
        219
    ],
    "mediumseagreen": [
        60,
        179,
        113
    ],
    "mediumslateblue": [
        123,
        104,
        238
    ],
    "mediumspringgreen": [
        0,
        250,
        154
    ],
    "mediumturquoise": [
        72,
        209,
        204
    ],
    "mediumvioletred": [
        199,
        21,
        133
    ],
    "midnightblue": [
        25,
        25,
        112
    ],
    "mintcream": [
        245,
        255,
        250
    ],
    "mistyrose": [
        255,
        228,
        225
    ],
    "moccasin": [
        255,
        228,
        181
    ],
    "navajowhite": [
        255,
        222,
        173
    ],
    "navy": [
        0,
        0,
        128
    ],
    "oldlace": [
        253,
        245,
        230
    ],
    "olive": [
        128,
        128,
        0
    ],
    "olivedrab": [
        107,
        142,
        35
    ],
    "orange": [
        255,
        165,
        0
    ],
    "orangered": [
        255,
        69,
        0
    ],
    "orchid": [
        218,
        112,
        214
    ],
    "palegoldenrod": [
        238,
        232,
        170
    ],
    "palegreen": [
        152,
        251,
        152
    ],
    "paleturquoise": [
        175,
        238,
        238
    ],
    "palevioletred": [
        219,
        112,
        147
    ],
    "papayawhip": [
        255,
        239,
        213
    ],
    "peachpuff": [
        255,
        218,
        185
    ],
    "peru": [
        205,
        133,
        63
    ],
    "pink": [
        255,
        192,
        203
    ],
    "plum": [
        221,
        160,
        221
    ],
    "powderblue": [
        176,
        224,
        230
    ],
    "purple": [
        128,
        0,
        128
    ],
    "rebeccapurple": [
        102,
        51,
        153
    ],
    "red": [
        255,
        0,
        0
    ],
    "rosybrown": [
        188,
        143,
        143
    ],
    "royalblue": [
        65,
        105,
        225
    ],
    "saddlebrown": [
        139,
        69,
        19
    ],
    "salmon": [
        250,
        128,
        114
    ],
    "sandybrown": [
        244,
        164,
        96
    ],
    "seagreen": [
        46,
        139,
        87
    ],
    "seashell": [
        255,
        245,
        238
    ],
    "sienna": [
        160,
        82,
        45
    ],
    "silver": [
        192,
        192,
        192
    ],
    "skyblue": [
        135,
        206,
        235
    ],
    "slateblue": [
        106,
        90,
        205
    ],
    "slategray": [
        112,
        128,
        144
    ],
    "slategrey": [
        112,
        128,
        144
    ],
    "snow": [
        255,
        250,
        250
    ],
    "springgreen": [
        0,
        255,
        127
    ],
    "steelblue": [
        70,
        130,
        180
    ],
    "tan": [
        210,
        180,
        140
    ],
    "teal": [
        0,
        128,
        128
    ],
    "thistle": [
        216,
        191,
        216
    ],
    "tomato": [
        255,
        99,
        71
    ],
    "turquoise": [
        64,
        224,
        208
    ],
    "violet": [
        238,
        130,
        238
    ],
    "wheat": [
        245,
        222,
        179
    ],
    "white": [
        255,
        255,
        255
    ],
    "whitesmoke": [
        245,
        245,
        245
    ],
    "yellow": [
        255,
        255,
        0
    ],
    "yellowgreen": [
        154,
        205,
        50
    ]
};
/* MIT license */ var cssKeywords = colorName;
// NOTE: conversions should only return primitive values (i.e. arrays, or
//       values that give correct `typeof` results).
//       do not use box values types (i.e. Number(), String(), etc.)
var reverseKeywords = {};
for(var key in cssKeywords)if (cssKeywords.hasOwnProperty(key)) reverseKeywords[cssKeywords[key]] = key;
var convert$2 = conversions$2.exports = {
    rgb: {
        channels: 3,
        labels: 'rgb'
    },
    hsl: {
        channels: 3,
        labels: 'hsl'
    },
    hsv: {
        channels: 3,
        labels: 'hsv'
    },
    hwb: {
        channels: 3,
        labels: 'hwb'
    },
    cmyk: {
        channels: 4,
        labels: 'cmyk'
    },
    xyz: {
        channels: 3,
        labels: 'xyz'
    },
    lab: {
        channels: 3,
        labels: 'lab'
    },
    lch: {
        channels: 3,
        labels: 'lch'
    },
    hex: {
        channels: 1,
        labels: [
            'hex'
        ]
    },
    keyword: {
        channels: 1,
        labels: [
            'keyword'
        ]
    },
    ansi16: {
        channels: 1,
        labels: [
            'ansi16'
        ]
    },
    ansi256: {
        channels: 1,
        labels: [
            'ansi256'
        ]
    },
    hcg: {
        channels: 3,
        labels: [
            'h',
            'c',
            'g'
        ]
    },
    apple: {
        channels: 3,
        labels: [
            'r16',
            'g16',
            'b16'
        ]
    },
    gray: {
        channels: 1,
        labels: [
            'gray'
        ]
    }
};
// hide .channels and .labels properties
for(var model in convert$2)if (convert$2.hasOwnProperty(model)) {
    if (!('channels' in convert$2[model])) throw new Error('missing channels property: ' + model);
    if (!('labels' in convert$2[model])) throw new Error('missing channel labels property: ' + model);
    if (convert$2[model].labels.length !== convert$2[model].channels) throw new Error('channel and label counts mismatch: ' + model);
    var channels = convert$2[model].channels;
    var labels = convert$2[model].labels;
    delete convert$2[model].channels;
    delete convert$2[model].labels;
    Object.defineProperty(convert$2[model], 'channels', {
        value: channels
    });
    Object.defineProperty(convert$2[model], 'labels', {
        value: labels
    });
}
convert$2.rgb.hsl = function(rgb) {
    var r = rgb[0] / 255;
    var g = rgb[1] / 255;
    var b = rgb[2] / 255;
    var min = Math.min(r, g, b);
    var max = Math.max(r, g, b);
    var delta = max - min;
    var h;
    var s;
    var l;
    if (max === min) h = 0;
    else if (r === max) h = (g - b) / delta;
    else if (g === max) h = 2 + (b - r) / delta;
    else if (b === max) h = 4 + (r - g) / delta;
    h = Math.min(h * 60, 360);
    if (h < 0) h += 360;
    l = (min + max) / 2;
    if (max === min) s = 0;
    else if (l <= 0.5) s = delta / (max + min);
    else s = delta / (2 - max - min);
    return [
        h,
        s * 100,
        l * 100
    ];
};
convert$2.rgb.hsv = function(rgb) {
    var rdif;
    var gdif;
    var bdif;
    var h;
    var s;
    var r = rgb[0] / 255;
    var g = rgb[1] / 255;
    var b = rgb[2] / 255;
    var v = Math.max(r, g, b);
    var diff = v - Math.min(r, g, b);
    var diffc = function(c) {
        return (v - c) / 6 / diff + 0.5;
    };
    if (diff === 0) h = s = 0;
    else {
        s = diff / v;
        rdif = diffc(r);
        gdif = diffc(g);
        bdif = diffc(b);
        if (r === v) h = bdif - gdif;
        else if (g === v) h = 1 / 3 + rdif - bdif;
        else if (b === v) h = 2 / 3 + gdif - rdif;
        if (h < 0) h += 1;
        else if (h > 1) h -= 1;
    }
    return [
        h * 360,
        s * 100,
        v * 100
    ];
};
convert$2.rgb.hwb = function(rgb) {
    var r = rgb[0];
    var g = rgb[1];
    var b = rgb[2];
    var h = convert$2.rgb.hsl(rgb)[0];
    var w = 1 / 255 * Math.min(r, Math.min(g, b));
    b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));
    return [
        h,
        w * 100,
        b * 100
    ];
};
convert$2.rgb.cmyk = function(rgb) {
    var r = rgb[0] / 255;
    var g = rgb[1] / 255;
    var b = rgb[2] / 255;
    var c;
    var m;
    var y;
    var k;
    k = Math.min(1 - r, 1 - g, 1 - b);
    c = (1 - r - k) / (1 - k) || 0;
    m = (1 - g - k) / (1 - k) || 0;
    y = (1 - b - k) / (1 - k) || 0;
    return [
        c * 100,
        m * 100,
        y * 100,
        k * 100
    ];
};
/**
 * See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
 * */ function comparativeDistance(x, y) {
    return Math.pow(x[0] - y[0], 2) + Math.pow(x[1] - y[1], 2) + Math.pow(x[2] - y[2], 2);
}
convert$2.rgb.keyword = function(rgb) {
    var reversed = reverseKeywords[rgb];
    if (reversed) return reversed;
    var currentClosestDistance = Infinity;
    var currentClosestKeyword;
    for(var keyword in cssKeywords)if (cssKeywords.hasOwnProperty(keyword)) {
        var value = cssKeywords[keyword];
        // Compute comparative distance
        var distance = comparativeDistance(rgb, value);
        // Check if its less, if so set as closest
        if (distance < currentClosestDistance) {
            currentClosestDistance = distance;
            currentClosestKeyword = keyword;
        }
    }
    return currentClosestKeyword;
};
convert$2.keyword.rgb = function(keyword) {
    return cssKeywords[keyword];
};
convert$2.rgb.xyz = function(rgb) {
    var r = rgb[0] / 255;
    var g = rgb[1] / 255;
    var b = rgb[2] / 255;
    // assume sRGB
    r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
    g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
    b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
    var x = r * 0.4124 + g * 0.3576 + b * 0.1805;
    var y = r * 0.2126 + g * 0.7152 + b * 0.0722;
    var z = r * 0.0193 + g * 0.1192 + b * 0.9505;
    return [
        x * 100,
        y * 100,
        z * 100
    ];
};
convert$2.rgb.lab = function(rgb) {
    var xyz = convert$2.rgb.xyz(rgb);
    var x = xyz[0];
    var y = xyz[1];
    var z = xyz[2];
    var l;
    var a;
    var b;
    x /= 95.047;
    y /= 100;
    z /= 108.883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    l = 116 * y - 16;
    a = 500 * (x - y);
    b = 200 * (y - z);
    return [
        l,
        a,
        b
    ];
};
convert$2.hsl.rgb = function(hsl) {
    var h = hsl[0] / 360;
    var s = hsl[1] / 100;
    var l = hsl[2] / 100;
    var t1;
    var t2;
    var t3;
    var rgb;
    var val;
    if (s === 0) {
        val = l * 255;
        return [
            val,
            val,
            val
        ];
    }
    if (l < 0.5) t2 = l * (1 + s);
    else t2 = l + s - l * s;
    t1 = 2 * l - t2;
    rgb = [
        0,
        0,
        0
    ];
    for(var i = 0; i < 3; i++){
        t3 = h + 1 / 3 * -(i - 1);
        if (t3 < 0) t3++;
        if (t3 > 1) t3--;
        if (6 * t3 < 1) val = t1 + (t2 - t1) * 6 * t3;
        else if (2 * t3 < 1) val = t2;
        else if (3 * t3 < 2) val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
        else val = t1;
        rgb[i] = val * 255;
    }
    return rgb;
};
convert$2.hsl.hsv = function(hsl) {
    var h = hsl[0];
    var s = hsl[1] / 100;
    var l = hsl[2] / 100;
    var smin = s;
    var lmin = Math.max(l, 0.01);
    var sv;
    var v;
    l *= 2;
    s *= l <= 1 ? l : 2 - l;
    smin *= lmin <= 1 ? lmin : 2 - lmin;
    v = (l + s) / 2;
    sv = l === 0 ? 2 * smin / (lmin + smin) : 2 * s / (l + s);
    return [
        h,
        sv * 100,
        v * 100
    ];
};
convert$2.hsv.rgb = function(hsv) {
    var h = hsv[0] / 60;
    var s = hsv[1] / 100;
    var v = hsv[2] / 100;
    var hi = Math.floor(h) % 6;
    var f = h - Math.floor(h);
    var p = 255 * v * (1 - s);
    var q = 255 * v * (1 - s * f);
    var t = 255 * v * (1 - s * (1 - f));
    v *= 255;
    switch(hi){
        case 0:
            return [
                v,
                t,
                p
            ];
        case 1:
            return [
                q,
                v,
                p
            ];
        case 2:
            return [
                p,
                v,
                t
            ];
        case 3:
            return [
                p,
                q,
                v
            ];
        case 4:
            return [
                t,
                p,
                v
            ];
        case 5:
            return [
                v,
                p,
                q
            ];
    }
};
convert$2.hsv.hsl = function(hsv) {
    var h = hsv[0];
    var s = hsv[1] / 100;
    var v = hsv[2] / 100;
    var vmin = Math.max(v, 0.01);
    var lmin;
    var sl;
    var l;
    l = (2 - s) * v;
    lmin = (2 - s) * vmin;
    sl = s * vmin;
    sl /= lmin <= 1 ? lmin : 2 - lmin;
    sl = sl || 0;
    l /= 2;
    return [
        h,
        sl * 100,
        l * 100
    ];
};
// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
convert$2.hwb.rgb = function(hwb) {
    var h = hwb[0] / 360;
    var wh = hwb[1] / 100;
    var bl = hwb[2] / 100;
    var ratio = wh + bl;
    var i;
    var v;
    var f;
    var n;
    // wh + bl cant be > 1
    if (ratio > 1) {
        wh /= ratio;
        bl /= ratio;
    }
    i = Math.floor(6 * h);
    v = 1 - bl;
    f = 6 * h - i;
    if ((i & 0x01) !== 0) f = 1 - f;
    n = wh + f * (v - wh); // linear interpolation
    var r;
    var g;
    var b;
    switch(i){
        default:
        case 6:
        case 0:
            r = v;
            g = n;
            b = wh;
            break;
        case 1:
            r = n;
            g = v;
            b = wh;
            break;
        case 2:
            r = wh;
            g = v;
            b = n;
            break;
        case 3:
            r = wh;
            g = n;
            b = v;
            break;
        case 4:
            r = n;
            g = wh;
            b = v;
            break;
        case 5:
            r = v;
            g = wh;
            b = n;
            break;
    }
    return [
        r * 255,
        g * 255,
        b * 255
    ];
};
convert$2.cmyk.rgb = function(cmyk) {
    var c = cmyk[0] / 100;
    var m = cmyk[1] / 100;
    var y = cmyk[2] / 100;
    var k = cmyk[3] / 100;
    var r;
    var g;
    var b;
    r = 1 - Math.min(1, c * (1 - k) + k);
    g = 1 - Math.min(1, m * (1 - k) + k);
    b = 1 - Math.min(1, y * (1 - k) + k);
    return [
        r * 255,
        g * 255,
        b * 255
    ];
};
convert$2.xyz.rgb = function(xyz) {
    var x = xyz[0] / 100;
    var y = xyz[1] / 100;
    var z = xyz[2] / 100;
    var r;
    var g;
    var b;
    r = x * 3.2406 + y * -1.5372 + z * -0.4986;
    g = x * -0.9689 + y * 1.8758 + z * 0.0415;
    b = x * 0.0557 + y * -0.204 + z * 1.0570;
    // assume sRGB
    r = r > 0.0031308 ? 1.055 * Math.pow(r, 1.0 / 2.4) - 0.055 : r * 12.92;
    g = g > 0.0031308 ? 1.055 * Math.pow(g, 1.0 / 2.4) - 0.055 : g * 12.92;
    b = b > 0.0031308 ? 1.055 * Math.pow(b, 1.0 / 2.4) - 0.055 : b * 12.92;
    r = Math.min(Math.max(0, r), 1);
    g = Math.min(Math.max(0, g), 1);
    b = Math.min(Math.max(0, b), 1);
    return [
        r * 255,
        g * 255,
        b * 255
    ];
};
convert$2.xyz.lab = function(xyz) {
    var x = xyz[0];
    var y = xyz[1];
    var z = xyz[2];
    var l;
    var a;
    var b;
    x /= 95.047;
    y /= 100;
    z /= 108.883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    l = 116 * y - 16;
    a = 500 * (x - y);
    b = 200 * (y - z);
    return [
        l,
        a,
        b
    ];
};
convert$2.lab.xyz = function(lab) {
    var l = lab[0];
    var a = lab[1];
    var b = lab[2];
    var x;
    var y;
    var z;
    y = (l + 16) / 116;
    x = a / 500 + y;
    z = y - b / 200;
    var y2 = Math.pow(y, 3);
    var x2 = Math.pow(x, 3);
    var z2 = Math.pow(z, 3);
    y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
    x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
    z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;
    x *= 95.047;
    y *= 100;
    z *= 108.883;
    return [
        x,
        y,
        z
    ];
};
convert$2.lab.lch = function(lab) {
    var l = lab[0];
    var a = lab[1];
    var b = lab[2];
    var hr;
    var h;
    var c;
    hr = Math.atan2(b, a);
    h = hr * 360 / 2 / Math.PI;
    if (h < 0) h += 360;
    c = Math.sqrt(a * a + b * b);
    return [
        l,
        c,
        h
    ];
};
convert$2.lch.lab = function(lch) {
    var l = lch[0];
    var c = lch[1];
    var h = lch[2];
    var a;
    var b;
    var hr;
    hr = h / 360 * 2 * Math.PI;
    a = c * Math.cos(hr);
    b = c * Math.sin(hr);
    return [
        l,
        a,
        b
    ];
};
convert$2.rgb.ansi16 = function(args) {
    var r = args[0];
    var g = args[1];
    var b = args[2];
    var value = 1 in arguments ? arguments[1] : convert$2.rgb.hsv(args)[2]; // hsv -> ansi16 optimization
    value = Math.round(value / 50);
    if (value === 0) return 30;
    var ansi = 30 + (Math.round(b / 255) << 2 | Math.round(g / 255) << 1 | Math.round(r / 255));
    if (value === 2) ansi += 60;
    return ansi;
};
convert$2.hsv.ansi16 = function(args) {
    // optimization here; we already know the value and don't need to get
    // it converted for us.
    return convert$2.rgb.ansi16(convert$2.hsv.rgb(args), args[2]);
};
convert$2.rgb.ansi256 = function(args) {
    var r = args[0];
    var g = args[1];
    var b = args[2];
    // we use the extended greyscale palette here, with the exception of
    // black and white. normal palette only has 4 greyscale shades.
    if (r === g && g === b) {
        if (r < 8) return 16;
        if (r > 248) return 231;
        return Math.round((r - 8) / 247 * 24) + 232;
    }
    var ansi = 16 + 36 * Math.round(r / 255 * 5) + 6 * Math.round(g / 255 * 5) + Math.round(b / 255 * 5);
    return ansi;
};
convert$2.ansi16.rgb = function(args) {
    var color = args % 10;
    // handle greyscale
    if (color === 0 || color === 7) {
        if (args > 50) color += 3.5;
        color = color / 10.5 * 255;
        return [
            color,
            color,
            color
        ];
    }
    var mult = (~~(args > 50) + 1) * 0.5;
    var r = (color & 1) * mult * 255;
    var g = (color >> 1 & 1) * mult * 255;
    var b = (color >> 2 & 1) * mult * 255;
    return [
        r,
        g,
        b
    ];
};
convert$2.ansi256.rgb = function(args) {
    // handle greyscale
    if (args >= 232) {
        var c = (args - 232) * 10 + 8;
        return [
            c,
            c,
            c
        ];
    }
    args -= 16;
    var rem;
    var r = Math.floor(args / 36) / 5 * 255;
    var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
    var b = rem % 6 / 5 * 255;
    return [
        r,
        g,
        b
    ];
};
convert$2.rgb.hex = function(args) {
    var integer = ((Math.round(args[0]) & 0xFF) << 16) + ((Math.round(args[1]) & 0xFF) << 8) + (Math.round(args[2]) & 0xFF);
    var string = integer.toString(16).toUpperCase();
    return '000000'.substring(string.length) + string;
};
convert$2.hex.rgb = function(args) {
    var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
    if (!match) return [
        0,
        0,
        0
    ];
    var colorString = match[0];
    if (match[0].length === 3) colorString = colorString.split('').map(function(char) {
        return char + char;
    }).join('');
    var integer = parseInt(colorString, 16);
    var r = integer >> 16 & 0xFF;
    var g = integer >> 8 & 0xFF;
    var b = integer & 0xFF;
    return [
        r,
        g,
        b
    ];
};
convert$2.rgb.hcg = function(rgb) {
    var r = rgb[0] / 255;
    var g = rgb[1] / 255;
    var b = rgb[2] / 255;
    var max = Math.max(Math.max(r, g), b);
    var min = Math.min(Math.min(r, g), b);
    var chroma = max - min;
    var grayscale;
    var hue;
    if (chroma < 1) grayscale = min / (1 - chroma);
    else grayscale = 0;
    if (chroma <= 0) hue = 0;
    else if (max === r) hue = (g - b) / chroma % 6;
    else if (max === g) hue = 2 + (b - r) / chroma;
    else hue = 4 + (r - g) / chroma + 4;
    hue /= 6;
    hue %= 1;
    return [
        hue * 360,
        chroma * 100,
        grayscale * 100
    ];
};
convert$2.hsl.hcg = function(hsl) {
    var s = hsl[1] / 100;
    var l = hsl[2] / 100;
    var c = 1;
    var f = 0;
    if (l < 0.5) c = 2.0 * s * l;
    else c = 2.0 * s * (1.0 - l);
    if (c < 1.0) f = (l - 0.5 * c) / (1.0 - c);
    return [
        hsl[0],
        c * 100,
        f * 100
    ];
};
convert$2.hsv.hcg = function(hsv) {
    var s = hsv[1] / 100;
    var v = hsv[2] / 100;
    var c = s * v;
    var f = 0;
    if (c < 1.0) f = (v - c) / (1 - c);
    return [
        hsv[0],
        c * 100,
        f * 100
    ];
};
convert$2.hcg.rgb = function(hcg) {
    var h = hcg[0] / 360;
    var c = hcg[1] / 100;
    var g = hcg[2] / 100;
    if (c === 0.0) return [
        g * 255,
        g * 255,
        g * 255
    ];
    var pure = [
        0,
        0,
        0
    ];
    var hi = h % 1 * 6;
    var v = hi % 1;
    var w = 1 - v;
    var mg = 0;
    switch(Math.floor(hi)){
        case 0:
            pure[0] = 1;
            pure[1] = v;
            pure[2] = 0;
            break;
        case 1:
            pure[0] = w;
            pure[1] = 1;
            pure[2] = 0;
            break;
        case 2:
            pure[0] = 0;
            pure[1] = 1;
            pure[2] = v;
            break;
        case 3:
            pure[0] = 0;
            pure[1] = w;
            pure[2] = 1;
            break;
        case 4:
            pure[0] = v;
            pure[1] = 0;
            pure[2] = 1;
            break;
        default:
            pure[0] = 1;
            pure[1] = 0;
            pure[2] = w;
    }
    mg = (1.0 - c) * g;
    return [
        (c * pure[0] + mg) * 255,
        (c * pure[1] + mg) * 255,
        (c * pure[2] + mg) * 255
    ];
};
convert$2.hcg.hsv = function(hcg) {
    var c = hcg[1] / 100;
    var g = hcg[2] / 100;
    var v = c + g * (1.0 - c);
    var f = 0;
    if (v > 0.0) f = c / v;
    return [
        hcg[0],
        f * 100,
        v * 100
    ];
};
convert$2.hcg.hsl = function(hcg) {
    var c = hcg[1] / 100;
    var g = hcg[2] / 100;
    var l = g * (1.0 - c) + 0.5 * c;
    var s = 0;
    if (l > 0.0 && l < 0.5) s = c / (2 * l);
    else if (l >= 0.5 && l < 1.0) s = c / (2 * (1 - l));
    return [
        hcg[0],
        s * 100,
        l * 100
    ];
};
convert$2.hcg.hwb = function(hcg) {
    var c = hcg[1] / 100;
    var g = hcg[2] / 100;
    var v = c + g * (1.0 - c);
    return [
        hcg[0],
        (v - c) * 100,
        (1 - v) * 100
    ];
};
convert$2.hwb.hcg = function(hwb) {
    var w = hwb[1] / 100;
    var b = hwb[2] / 100;
    var v = 1 - b;
    var c = v - w;
    var g = 0;
    if (c < 1) g = (v - c) / (1 - c);
    return [
        hwb[0],
        c * 100,
        g * 100
    ];
};
convert$2.apple.rgb = function(apple) {
    return [
        apple[0] / 65535 * 255,
        apple[1] / 65535 * 255,
        apple[2] / 65535 * 255
    ];
};
convert$2.rgb.apple = function(rgb) {
    return [
        rgb[0] / 255 * 65535,
        rgb[1] / 255 * 65535,
        rgb[2] / 255 * 65535
    ];
};
convert$2.gray.rgb = function(args) {
    return [
        args[0] / 100 * 255,
        args[0] / 100 * 255,
        args[0] / 100 * 255
    ];
};
convert$2.gray.hsl = convert$2.gray.hsv = function(args) {
    return [
        0,
        0,
        args[0]
    ];
};
convert$2.gray.hwb = function(gray) {
    return [
        0,
        100,
        gray[0]
    ];
};
convert$2.gray.cmyk = function(gray) {
    return [
        0,
        0,
        0,
        gray[0]
    ];
};
convert$2.gray.lab = function(gray) {
    return [
        gray[0],
        0,
        0
    ];
};
convert$2.gray.hex = function(gray) {
    var val = Math.round(gray[0] / 100 * 255) & 0xFF;
    var integer = (val << 16) + (val << 8) + val;
    var string = integer.toString(16).toUpperCase();
    return '000000'.substring(string.length) + string;
};
convert$2.rgb.gray = function(rgb) {
    var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
    return [
        val / 255 * 100
    ];
};
var conversionsExports = conversions$2.exports;
var conversions$1 = conversionsExports;
/*
	this function routes a model to all other models.

	all functions that are routed have a property `.conversion` attached
	to the returned synthetic function. This property is an array
	of strings, each with the steps in between the 'from' and 'to'
	color models (inclusive).

	conversions that are not possible simply are not included.
*/ function buildGraph() {
    var graph = {};
    // https://jsperf.com/object-keys-vs-for-in-with-closure/3
    var models = Object.keys(conversions$1);
    for(var len = models.length, i = 0; i < len; i++)graph[models[i]] = {
        // http://jsperf.com/1-vs-infinity
        // micro-opt, but this is simple.
        distance: -1,
        parent: null
    };
    return graph;
}
// https://en.wikipedia.org/wiki/Breadth-first_search
function deriveBFS(fromModel) {
    var graph = buildGraph();
    var queue = [
        fromModel
    ]; // unshift -> queue -> pop
    graph[fromModel].distance = 0;
    while(queue.length){
        var current = queue.pop();
        var adjacents = Object.keys(conversions$1[current]);
        for(var len = adjacents.length, i = 0; i < len; i++){
            var adjacent = adjacents[i];
            var node = graph[adjacent];
            if (node.distance === -1) {
                node.distance = graph[current].distance + 1;
                node.parent = current;
                queue.unshift(adjacent);
            }
        }
    }
    return graph;
}
function link(from, to) {
    return function(args) {
        return to(from(args));
    };
}
function wrapConversion(toModel, graph) {
    var path = [
        graph[toModel].parent,
        toModel
    ];
    var fn = conversions$1[graph[toModel].parent][toModel];
    var cur = graph[toModel].parent;
    while(graph[cur].parent){
        path.unshift(graph[cur].parent);
        fn = link(conversions$1[graph[cur].parent][cur], fn);
        cur = graph[cur].parent;
    }
    fn.conversion = path;
    return fn;
}
var route$1 = function(fromModel) {
    var graph = deriveBFS(fromModel);
    var conversion = {};
    var models = Object.keys(graph);
    for(var len = models.length, i = 0; i < len; i++){
        var toModel = models[i];
        var node = graph[toModel];
        if (node.parent === null) continue;
        conversion[toModel] = wrapConversion(toModel, graph);
    }
    return conversion;
};
var conversions = conversionsExports;
var route = route$1;
var convert$1 = {};
var models = Object.keys(conversions);
function wrapRaw(fn) {
    var wrappedFn = function(args) {
        if (args === undefined || args === null) return args;
        if (arguments.length > 1) args = Array.prototype.slice.call(arguments);
        return fn(args);
    };
    // preserve .conversion property if there is one
    if ('conversion' in fn) wrappedFn.conversion = fn.conversion;
    return wrappedFn;
}
function wrapRounded(fn) {
    var wrappedFn = function(args) {
        if (args === undefined || args === null) return args;
        if (arguments.length > 1) args = Array.prototype.slice.call(arguments);
        var result = fn(args);
        // we're assuming the result is an array here.
        // see notice in conversions.js; don't use box types
        // in conversion functions.
        if (typeof result === 'object') for(var len = result.length, i = 0; i < len; i++)result[i] = Math.round(result[i]);
        return result;
    };
    // preserve .conversion property if there is one
    if ('conversion' in fn) wrappedFn.conversion = fn.conversion;
    return wrappedFn;
}
models.forEach(function(fromModel) {
    convert$1[fromModel] = {};
    Object.defineProperty(convert$1[fromModel], 'channels', {
        value: conversions[fromModel].channels
    });
    Object.defineProperty(convert$1[fromModel], 'labels', {
        value: conversions[fromModel].labels
    });
    var routes = route(fromModel);
    var routeModels = Object.keys(routes);
    routeModels.forEach(function(toModel) {
        var fn = routes[toModel];
        convert$1[fromModel][toModel] = wrapRounded(fn);
        convert$1[fromModel][toModel].raw = wrapRaw(fn);
    });
});
var colorConvert = convert$1;
var colorString = colorStringExports;
var convert = colorConvert;
var _slice = [].slice;
var skippedModels = [
    // to be honest, I don't really feel like keyword belongs in color convert, but eh.
    'keyword',
    // gray conflicts with some method names, and has its own method defined.
    'gray',
    // shouldn't really be in color-convert either...
    'hex'
];
var hashedModelKeys = {};
Object.keys(convert).forEach(function(model) {
    hashedModelKeys[_slice.call(convert[model].labels).sort().join('')] = model;
});
var limiters = {};
function Color(obj, model) {
    if (!(this instanceof Color)) return new Color(obj, model);
    if (model && model in skippedModels) model = null;
    if (model && !(model in convert)) throw new Error('Unknown model: ' + model);
    var i;
    var channels;
    if (obj == null) {
        this.model = 'rgb';
        this.color = [
            0,
            0,
            0
        ];
        this.valpha = 1;
    } else if (obj instanceof Color) {
        this.model = obj.model;
        this.color = obj.color.slice();
        this.valpha = obj.valpha;
    } else if (typeof obj === 'string') {
        var result = colorString.get(obj);
        if (result === null) throw new Error('Unable to parse color from string: ' + obj);
        this.model = result.model;
        channels = convert[this.model].channels;
        this.color = result.value.slice(0, channels);
        this.valpha = typeof result.value[channels] === 'number' ? result.value[channels] : 1;
    } else if (obj.length) {
        this.model = model || 'rgb';
        channels = convert[this.model].channels;
        var newArr = _slice.call(obj, 0, channels);
        this.color = zeroArray(newArr, channels);
        this.valpha = typeof obj[channels] === 'number' ? obj[channels] : 1;
    } else if (typeof obj === 'number') {
        // this is always RGB - can be converted later on.
        obj &= 0xFFFFFF;
        this.model = 'rgb';
        this.color = [
            obj >> 16 & 0xFF,
            obj >> 8 & 0xFF,
            obj & 0xFF
        ];
        this.valpha = 1;
    } else {
        this.valpha = 1;
        var keys = Object.keys(obj);
        if ('alpha' in obj) {
            keys.splice(keys.indexOf('alpha'), 1);
            this.valpha = typeof obj.alpha === 'number' ? obj.alpha : 0;
        }
        var hashedKeys = keys.sort().join('');
        if (!(hashedKeys in hashedModelKeys)) throw new Error('Unable to parse color from object: ' + JSON.stringify(obj));
        this.model = hashedModelKeys[hashedKeys];
        var labels = convert[this.model].labels;
        var color = [];
        for(i = 0; i < labels.length; i++)color.push(obj[labels[i]]);
        this.color = zeroArray(color);
    }
    // perform limitations (clamping, etc.)
    if (limiters[this.model]) {
        channels = convert[this.model].channels;
        for(i = 0; i < channels; i++){
            var limit = limiters[this.model][i];
            if (limit) this.color[i] = limit(this.color[i]);
        }
    }
    this.valpha = Math.max(0, Math.min(1, this.valpha));
    if (Object.freeze) Object.freeze(this);
}
Color.prototype = {
    toString: function() {
        return this.string();
    },
    toJSON: function() {
        return this[this.model]();
    },
    string: function(places) {
        var self1 = this.model in colorString.to ? this : this.rgb();
        self1 = self1.round(typeof places === 'number' ? places : 1);
        var args = self1.valpha === 1 ? self1.color : self1.color.concat(this.valpha);
        return colorString.to[self1.model](args);
    },
    percentString: function(places) {
        var self1 = this.rgb().round(typeof places === 'number' ? places : 1);
        var args = self1.valpha === 1 ? self1.color : self1.color.concat(this.valpha);
        return colorString.to.rgb.percent(args);
    },
    array: function() {
        return this.valpha === 1 ? this.color.slice() : this.color.concat(this.valpha);
    },
    object: function() {
        var result = {};
        var channels = convert[this.model].channels;
        var labels = convert[this.model].labels;
        for(var i = 0; i < channels; i++)result[labels[i]] = this.color[i];
        if (this.valpha !== 1) result.alpha = this.valpha;
        return result;
    },
    unitArray: function() {
        var rgb = this.rgb().color;
        rgb[0] /= 255;
        rgb[1] /= 255;
        rgb[2] /= 255;
        if (this.valpha !== 1) rgb.push(this.valpha);
        return rgb;
    },
    unitObject: function() {
        var rgb = this.rgb().object();
        rgb.r /= 255;
        rgb.g /= 255;
        rgb.b /= 255;
        if (this.valpha !== 1) rgb.alpha = this.valpha;
        return rgb;
    },
    round: function(places) {
        places = Math.max(places || 0, 0);
        return new Color(this.color.map(roundToPlace(places)).concat(this.valpha), this.model);
    },
    alpha: function(val) {
        if (arguments.length) return new Color(this.color.concat(Math.max(0, Math.min(1, val))), this.model);
        return this.valpha;
    },
    // rgb
    red: getset('rgb', 0, maxfn(255)),
    green: getset('rgb', 1, maxfn(255)),
    blue: getset('rgb', 2, maxfn(255)),
    hue: getset([
        'hsl',
        'hsv',
        'hsl',
        'hwb',
        'hcg'
    ], 0, function(val) {
        return (val % 360 + 360) % 360;
    }),
    saturationl: getset('hsl', 1, maxfn(100)),
    lightness: getset('hsl', 2, maxfn(100)),
    saturationv: getset('hsv', 1, maxfn(100)),
    value: getset('hsv', 2, maxfn(100)),
    chroma: getset('hcg', 1, maxfn(100)),
    gray: getset('hcg', 2, maxfn(100)),
    white: getset('hwb', 1, maxfn(100)),
    wblack: getset('hwb', 2, maxfn(100)),
    cyan: getset('cmyk', 0, maxfn(100)),
    magenta: getset('cmyk', 1, maxfn(100)),
    yellow: getset('cmyk', 2, maxfn(100)),
    black: getset('cmyk', 3, maxfn(100)),
    x: getset('xyz', 0, maxfn(100)),
    y: getset('xyz', 1, maxfn(100)),
    z: getset('xyz', 2, maxfn(100)),
    l: getset('lab', 0, maxfn(100)),
    a: getset('lab', 1),
    b: getset('lab', 2),
    keyword: function(val) {
        if (arguments.length) return new Color(val);
        return convert[this.model].keyword(this.color);
    },
    hex: function(val) {
        if (arguments.length) return new Color(val);
        return colorString.to.hex(this.rgb().round().color);
    },
    rgbNumber: function() {
        var rgb = this.rgb().color;
        return (rgb[0] & 0xFF) << 16 | (rgb[1] & 0xFF) << 8 | rgb[2] & 0xFF;
    },
    luminosity: function() {
        // http://www.w3.org/TR/WCAG20/#relativeluminancedef
        var rgb = this.rgb().color;
        var lum = [];
        for(var i = 0; i < rgb.length; i++){
            var chan = rgb[i] / 255;
            lum[i] = chan <= 0.03928 ? chan / 12.92 : Math.pow((chan + 0.055) / 1.055, 2.4);
        }
        return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
    },
    contrast: function(color2) {
        // http://www.w3.org/TR/WCAG20/#contrast-ratiodef
        var lum1 = this.luminosity();
        var lum2 = color2.luminosity();
        if (lum1 > lum2) return (lum1 + 0.05) / (lum2 + 0.05);
        return (lum2 + 0.05) / (lum1 + 0.05);
    },
    level: function(color2) {
        var contrastRatio = this.contrast(color2);
        if (contrastRatio >= 7.1) return 'AAA';
        return contrastRatio >= 4.5 ? 'AA' : '';
    },
    isDark: function() {
        // YIQ equation from http://24ways.org/2010/calculating-color-contrast
        var rgb = this.rgb().color;
        var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
        return yiq < 128;
    },
    isLight: function() {
        return !this.isDark();
    },
    negate: function() {
        var rgb = this.rgb();
        for(var i = 0; i < 3; i++)rgb.color[i] = 255 - rgb.color[i];
        return rgb;
    },
    lighten: function(ratio) {
        var hsl = this.hsl();
        hsl.color[2] += hsl.color[2] * ratio;
        return hsl;
    },
    darken: function(ratio) {
        var hsl = this.hsl();
        hsl.color[2] -= hsl.color[2] * ratio;
        return hsl;
    },
    saturate: function(ratio) {
        var hsl = this.hsl();
        hsl.color[1] += hsl.color[1] * ratio;
        return hsl;
    },
    desaturate: function(ratio) {
        var hsl = this.hsl();
        hsl.color[1] -= hsl.color[1] * ratio;
        return hsl;
    },
    whiten: function(ratio) {
        var hwb = this.hwb();
        hwb.color[1] += hwb.color[1] * ratio;
        return hwb;
    },
    blacken: function(ratio) {
        var hwb = this.hwb();
        hwb.color[2] += hwb.color[2] * ratio;
        return hwb;
    },
    grayscale: function() {
        // http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
        var rgb = this.rgb().color;
        var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
        return Color.rgb(val, val, val);
    },
    fade: function(ratio) {
        return this.alpha(this.valpha - this.valpha * ratio);
    },
    opaquer: function(ratio) {
        return this.alpha(this.valpha + this.valpha * ratio);
    },
    rotate: function(degrees) {
        var hsl = this.hsl();
        var hue = hsl.color[0];
        hue = (hue + degrees) % 360;
        hue = hue < 0 ? 360 + hue : hue;
        hsl.color[0] = hue;
        return hsl;
    },
    mix: function(mixinColor, weight) {
        // ported from sass implementation in C
        // https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
        if (!mixinColor || !mixinColor.rgb) throw new Error('Argument to "mix" was not a Color instance, but rather an instance of ' + typeof mixinColor);
        var color1 = mixinColor.rgb();
        var color2 = this.rgb();
        var p = weight === undefined ? 0.5 : weight;
        var w = 2 * p - 1;
        var a = color1.alpha() - color2.alpha();
        var w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
        var w2 = 1 - w1;
        return Color.rgb(w1 * color1.red() + w2 * color2.red(), w1 * color1.green() + w2 * color2.green(), w1 * color1.blue() + w2 * color2.blue(), color1.alpha() * p + color2.alpha() * (1 - p));
    }
};
// model conversion methods and static constructors
Object.keys(convert).forEach(function(model) {
    if (skippedModels.indexOf(model) !== -1) return;
    var channels = convert[model].channels;
    // conversion methods
    Color.prototype[model] = function() {
        if (this.model === model) return new Color(this);
        if (arguments.length) return new Color(arguments, model);
        var newAlpha = typeof arguments[channels] === 'number' ? channels : this.valpha;
        return new Color(assertArray(convert[this.model][model].raw(this.color)).concat(newAlpha), model);
    };
    // 'static' construction methods
    Color[model] = function(color) {
        if (typeof color === 'number') color = zeroArray(_slice.call(arguments), channels);
        return new Color(color, model);
    };
});
function roundTo(num, places) {
    return Number(num.toFixed(places));
}
function roundToPlace(places) {
    return function(num) {
        return roundTo(num, places);
    };
}
function getset(model, channel, modifier) {
    model = Array.isArray(model) ? model : [
        model
    ];
    model.forEach(function(m) {
        (limiters[m] || (limiters[m] = []))[channel] = modifier;
    });
    model = model[0];
    return function(val) {
        var result;
        if (arguments.length) {
            if (modifier) val = modifier(val);
            result = this[model]();
            result.color[channel] = val;
            return result;
        }
        result = this[model]().color[channel];
        if (modifier) result = modifier(result);
        return result;
    };
}
function maxfn(max) {
    return function(v) {
        return Math.max(0, Math.min(max, v));
    };
}
function assertArray(val) {
    return Array.isArray(val) ? val : [
        val
    ];
}
function zeroArray(arr, length) {
    for(var i = 0; i < length; i++)if (typeof arr[i] !== 'number') arr[i] = 0;
    return arr;
}
var color = Color;
var Color$1 = /*@__PURE__*/ getDefaultExportFromCjs(color);
const supportAssign = typeof Object.assign === 'function';
/**
 * Merges the properties of sources into destination object.
 * @param  {Object} dest   - object to extend
 * @param  {...Object} src - sources
 * @return {Object}
 */ const TEMP_VEC = [];
function extend(dest) {
    if (supportAssign) Object.assign.apply(Object, arguments);
    else for(let i = 1; i < arguments.length; i++){
        const src = arguments[i];
        for(const k in src)dest[k] = src[k];
    }
    return dest;
}
function isNil$1(v) {
    return v === undefined || v === null;
}
function isNumber$1(val) {
    return typeof val === 'number' && !isNaN(val);
}
const SCALE$1 = [];
function getGroundTransform(out, map) {
    const extent = map['_get2DExtentAtRes'](map.getGLRes());
    const scaleX = extent.getWidth(), scaleY = extent.getHeight();
    const localTransform = out;
    (0, $3iqbd).identity(localTransform);
    const trans = (0, $eIStk).copy(TEMP_VEC, map.cameraLookAt);
    trans[2] = 0; //避免地图中心点存在高度情况下，地面跟着抬升
    (0, $3iqbd).translate(localTransform, localTransform, trans);
    (0, $3iqbd).scale(localTransform, localTransform, (0, $eIStk).set(SCALE$1, scaleX, scaleY, 1));
    return localTransform;
}
function hasOwn(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
function pushIn(dest) {
    for(let i = 1; i < arguments.length; i++){
        const src = arguments[i];
        if (src) for(let ii = 0, ll = src.length; ii < ll; ii++)dest.push(src[ii]);
    }
    return dest.length;
}
const colorCache = {};
function normalizeColor(out, color) {
    if (!Array.isArray(color)) {
        const key = color;
        color = colorCache[key] = colorCache[key] || Color$1(color).array();
    }
    for(let i = 0; i < color.length; i++)out[i] = color[i];
    if (color.length === 3) out[3] = 1;
    return out;
}
function normalizeColor255(out, color) {
    if (!Array.isArray(color)) {
        const key = color;
        color = colorCache[key] = colorCache[key] || Color$1(color).array();
        for(let i = 0; i < color.length; i++)out[i] = color[i];
    } else for(let i = 0; i < color.length; i++)out[i] = color[i] * 255;
    if (out.length === 3) out.push(255);
    return out;
}
function coordinateToWorld$2(map, coordinate, z = 0) {
    if (!map || !(coordinate instanceof (0, $gP1US.Coordinate))) return null;
    const p = map.coordinateToPointAtRes(coordinate, map.getGLRes());
    return [
        p.x,
        p.y,
        z
    ];
}
function createGLContext(canvas, options, onlyWebGL1) {
    const names = onlyWebGL1 ? [
        'webgl',
        'experimental-webgl'
    ] : [
        'webgl2',
        'webgl',
        'experimental-webgl'
    ];
    let gl = null;
    /* eslint-disable no-empty */ for(let i = 0; i < names.length; ++i){
        try {
            gl = canvas.getContext(names[i], options);
        } catch (e) {}
        if (gl) break;
    }
    if (!gl) console.error('Browser doesn\'t support WebGL.');
    return gl;
/* eslint-enable no-empty */ }
const EMPTY_HALTON = [
    0,
    0
];
const DEFAULT_SHADOW_COLOR = [
    0,
    0,
    0
];
//阴影覆盖的pitch范围
const SHADOW_MAX_PITCH = 62;
let VISUAL_EXTENT;
class ShadowProcess {
    static getUniformDeclares() {
        const shadowLightProjViewModelMatrix = [];
        const uniforms = [];
        uniforms.push({
            name: 'shadow_lightProjViewModelMatrix',
            type: 'function',
            fn: function(context, props) {
                const lightProjViews = props['shadow_lightProjViewMatrix'];
                const model = props['modelMatrix'];
                return (0, $3iqbd).multiply(shadowLightProjViewModelMatrix, lightProjViews, model);
            }
        });
        return uniforms;
    }
    constructor(regl, layer){
        this.renderer = new $2wazW.Renderer(regl);
        this._esmShadowThreshold = 0.3;
        this._layer = layer;
        this._init();
    }
    resize() {
        const canvas = this.canvas;
        canvas.width = this._layer.getRenderer().canvas.width;
        canvas.height = this._layer.getRenderer().canvas.height;
    }
    _init() {
        const sceneConfig = this._layer._getSceneConfig() || {};
        const shadowConfig = sceneConfig.shadow || {};
        const shadowRes = this._getShadowRes();
        const defines = this.getDefines();
        this._shadowPass = new $2wazW.ShadowPass(this.renderer, {
            width: shadowRes,
            height: shadowRes,
            blurOffset: shadowConfig.blurOffset,
            defines: defines
        });
        this._shadowDisplayShader = new $2wazW.ShadowDisplayShader(defines);
        this._createGround();
    }
    _getShadowRes() {
        const sceneConfig = this._layer._getSceneConfig() || {};
        const shadowConfig = sceneConfig.shadow || {};
        let shadowRes = 2048;
        const quality = shadowConfig.quality;
        if (quality === 'medium') shadowRes = 1024;
        else if (quality === 'low') shadowRes = 512;
        return shadowRes;
    }
    getDefines() {
        const defines = {
            'HAS_SHADOWING': 1,
            'PACK_FLOAT': 1,
            'USE_ESM': 1
        };
        return defines;
    }
    render(displayShadow, projMatrix, viewMatrix, color, opacity, lightDirection, scene, halton, framebuffer, forceRefresh) {
        this._transformGround();
        const map = this._layer.getMap();
        const shadowRes = this._getShadowRes();
        const changed = forceRefresh || shadowRes !== this._shadowPass.width || this._shadowChanged(map, scene, !!displayShadow);
        let matrix, smap;
        if (changed) {
            if (shadowRes !== this._shadowPass.width) this._shadowPass.resize(shadowRes, shadowRes);
            this._tempMat0 = this._tempMat0 || [];
            this._tempMat1 = this._tempMat1 || [];
            const cameraProjViewMatrix = (0, $3iqbd).multiply(this._tempMat0, projMatrix, viewMatrix);
            const lightDir = (0, $eIStk).normalize(this._tempMat1, lightDirection);
            if (!VISUAL_EXTENT) VISUAL_EXTENT = map.getContainerExtent();
            //只渲染pitch < SHADOW_MAX_PITCH的范围内的mesh，提高shadowmap精度
            let visualHeight = map.height;
            if (map.getPitch() > SHADOW_MAX_PITCH) visualHeight = map['_getVisualHeight'](SHADOW_MAX_PITCH);
            const containerExtent = VISUAL_EXTENT.set(0, map.height - visualHeight, map.width, map.height);
            const extent = containerExtent.convertTo((c)=>map['_containerPointToPointAtRes'](c, map.getGLRes()));
            const arr = extent.toArray();
            if (displayShadow) scene.addMesh(this._ground);
            const farPlane = arr.map((c)=>[
                    c.x,
                    c.y,
                    0,
                    1
                ]);
            const { lightProjViewMatrix, shadowMap, /* depthFBO, */ blurFBO } = this._shadowPass.render(scene, {
                cameraProjViewMatrix: cameraProjViewMatrix,
                lightDir: lightDir,
                farPlane: farPlane,
                cameraLookAt: map.cameraLookAt
            });
            matrix = this._lightProjViewMatrix = lightProjViewMatrix;
            smap = this._shadowMap = shadowMap;
            this._blurFBO = blurFBO;
            this._renderedShadows = scene.getMeshes().reduce((ids, m)=>{
                if (m.castShadow && m.geometry) ids[m.uuid] = {
                    v0: m.version,
                    v1: m.geometry.version
                };
                return ids;
            }, {});
            this._renderedView = {
                count: scene.getMeshes().length - +!!displayShadow,
                displayShadow: !!displayShadow
            };
            this._updated = true;
        } else {
            matrix = this._lightProjViewMatrix;
            smap = this._shadowMap;
            // fbo = this._blurFBO;
            this._updated = false;
        }
        this._projMatrix = projMatrix;
        this._viewMatrix = viewMatrix;
        if (isNil$1(opacity)) opacity = 1;
        if (displayShadow && scene.getMeshes().length) this.displayShadow(color, opacity, halton, framebuffer);
        const uniforms = {
            'shadow_lightProjViewMatrix': matrix,
            'shadow_shadowMap': smap,
            'shadow_opacity': opacity,
            'shadow_color': color || DEFAULT_SHADOW_COLOR,
            'esm_shadow_threshold': this._esmShadowThreshold
        };
        return uniforms;
    }
    displayShadow(color, opacity, halton, framebuffer) {
        const matrix = this._lightProjViewMatrix;
        const ground = this._ground;
        const groundLightProjViewModelMatrix = this._groundLightProjViewModelMatrix || [];
        const canvas = this._layer.getRenderer().canvas;
        const texSize = this._texSize = this._texSize || [];
        texSize[0] = canvas.width;
        texSize[1] = canvas.height;
        //display ground shadows
        this.renderer.render(this._shadowDisplayShader, {
            'halton': halton || EMPTY_HALTON,
            'globalTexSize': texSize,
            'projMatrix': this._projMatrix,
            'viewMatrix': this._viewMatrix,
            'shadow_lightProjViewModelMatrix': (0, $3iqbd).multiply(groundLightProjViewModelMatrix, matrix, ground.localTransform),
            'shadow_shadowMap': this._shadowMap,
            'esm_shadow_threshold': this._esmShadowThreshold,
            'shadow_opacity': opacity,
            'color': color || DEFAULT_SHADOW_COLOR
        }, this._groundScene, framebuffer);
    }
    dispose() {
        this._shadowPass.dispose();
        this._shadowDisplayShader.dispose();
        // if (this._shadowMap) {
        // //已经在shadowPass中destroy了
        //     this._shadowMap.destroy();
        // }
        // if (this._blurFBO) {
        //     this._blurFBO.destroy();
        // }
        if (this._ground) {
            this._ground.geometry.dispose();
            this._ground.dispose();
        }
        delete this.renderer;
    }
    isUpdated() {
        return this._updated !== false;
    }
    _shadowChanged(map, scene, displayShadow) {
        // if (this._rendered || !this._rendered && scene.getMeshes().length > 5) {
        //     this._rendered = true;
        //     return false;
        // }
        if (!this._renderedShadows) return true;
        const renderedView = this._renderedView;
        if (scene.getMeshes().length !== renderedView.count || displayShadow !== renderedView.displayShadow) return true;
        const meshes = scene.getMeshes();
        const changed = false;
        for(let i = 0; i < meshes.length; i++){
            const saved = this._renderedShadows[meshes[i].uuid];
            if (meshes[i].castShadow && (meshes[i].hasSkinAnimation() || !saved || saved.v0 !== meshes[i].version || saved.v1 !== meshes[i].geometry.version)) return true;
        }
        return changed;
    }
    _createGround() {
        const planeGeo = new $2wazW.Plane();
        planeGeo.generateBuffers(this.renderer.regl);
        this._ground = new $2wazW.Mesh(planeGeo);
        this._groundScene = new $2wazW.Scene([
            this._ground
        ]);
    }
    _transformGround() {
        const map = this._layer.getMap();
        const localTransform = getGroundTransform(this._ground.localTransform, map);
        this._ground.setLocalTransform(localTransform);
    }
}
var fillVert = "attribute vec3 aPosition;\nuniform mat4 projViewModelMatrix;\nuniform mat4 modelMatrix;\n#ifdef HAS_PATTERN\n    attribute vec2 aTexCoord;\n    uniform vec2 uvScale;\n    uniform vec2 uvOffset;\n    varying vec2 vTexCoord;\n#endif\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n    #include <vsm_shadow_vert>\n#endif\nvoid main () {\n    #ifdef HAS_PATTERN\n        vTexCoord = aTexCoord * uvScale + uvOffset;\n    #endif\n    vec3 position = vec3(aPosition);\n    gl_Position = projViewModelMatrix * vec4(position, 1.0);\n    #if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n        shadow_computeShadowPars(vec4(position, 1.0));\n    #endif\n}";
var fillFrag = "precision mediump float;\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n    #include <vsm_shadow_frag>\n#endif\n#ifdef HAS_PATTERN\n    uniform sampler2D polygonPatternFile;\n    varying vec2 vTexCoord;\n#endif\nuniform vec4 polygonFill;\nuniform float polygonOpacity;\nvoid main() {\n    #ifdef HAS_PATTERN\n        vec4 color = texture2D(polygonPatternFile, vTexCoord);\n    #else\n        vec4 color = polygonFill;\n    #endif\n    gl_FragColor = color * polygonOpacity;\n    #if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n        float shadowCoeff = shadow_computeShadow();\n        gl_FragColor.rgb = shadow_blend(gl_FragColor.rgb, shadowCoeff);\n    #endif\n}";
const DEFAULT_TEX_OFFSET$1 = [
    0,
    0
];
const COORD0$1 = new $gP1US.Coordinate(0, 0);
const COORD1 = new $gP1US.Coordinate(0, 0);
const ARR2_0 = [];
const ARR2_1$1 = [];
const UNIFORMS = [];
function computeUVUniforms(map, xmin, ymin, patternOrigin, patternWidth, patternHeight, texAspect, uvScale, isOffsetInMeter, offsetValue, uvOffsetAnim) {
    const glRes = map.getGLRes();
    if (patternOrigin) {
        COORD0$1.set(patternOrigin[0], patternOrigin[1]);
        map.coordToPointAtRes(COORD0$1, glRes, COORD1);
        xmin = xmin - COORD1.x;
        ymin = ymin - COORD1.y;
    }
    const pointOrigin = patternOrigin ? COORD0$1 : null;
    // compute uv offset
    offsetValue = (0, $6BoVD).copy(ARR2_1$1, offsetValue);
    const uvOffset = !isOffsetInMeter && offsetValue || DEFAULT_TEX_OFFSET$1;
    let meterOffset = isOffsetInMeter && offsetValue || DEFAULT_TEX_OFFSET$1;
    meterOffset = (0, $6BoVD).copy(ARR2_0, meterOffset);
    if (meterOffset[0]) meterOffset[0] = meterToPoint(map, meterOffset[0], pointOrigin);
    if (meterOffset[1]) meterOffset[1] = meterToPoint(map, meterOffset[1], pointOrigin, 1);
    // compute uv scale
    let texWidth = 0.5;
    if (patternWidth) texWidth = meterToPoint(map, patternWidth, pointOrigin);
    let texHeight = texWidth / texAspect;
    if (patternHeight) texHeight = meterToPoint(map, patternHeight, pointOrigin, 1);
    const hasUVAnim = uvOffsetAnim && (uvOffsetAnim[0] || uvOffsetAnim[1]);
    if (hasUVAnim) {
        const timeStamp = performance.now() / 1000;
        // 256 是noiseTexture的高宽，乘以256可以保证动画首尾平滑过渡，不会出现跳跃
        // const speed = hasNoise ? 50000 : 1000;
        // const scale = (hasNoise ? 256 : 1);
        let animX = uvOffsetAnim[0];
        let animY = uvOffsetAnim[1];
        if (isOffsetInMeter) {
            animX = -meterToPoint(map, uvOffsetAnim[0], pointOrigin);
            animY = -meterToPoint(map, uvOffsetAnim[1], pointOrigin, 1);
        }
        if (uvOffsetAnim[0]) {
            if (isOffsetInMeter) meterOffset[0] = timeStamp * animX;
            else uvOffset[0] = timeStamp * animX;
        }
        if (uvOffsetAnim[1]) {
            if (isOffsetInMeter) meterOffset[1] = timeStamp * animY;
            else uvOffset[1] = timeStamp * animY;
        }
    }
    const uvStartX = (xmin + meterOffset[0]) / (texWidth / uvScale[0]);
    const uvStartY = (ymin - meterOffset[1]) / (texHeight / uvScale[1]);
    UNIFORMS[0] = texWidth / uvScale[0];
    UNIFORMS[1] = texHeight / uvScale[1];
    UNIFORMS[2] = uvStartX;
    UNIFORMS[3] = uvStartY;
    UNIFORMS[4] = uvOffset;
    return UNIFORMS;
}
function meterToPoint(map, meter, patternOrigin, isYAxis) {
    const glRes = map.getGLRes();
    const point = map.distanceToPointAtRes(meter, meter, glRes, patternOrigin ? COORD0$1 : null, COORD1);
    return isYAxis ? point.y : point.x;
}
const { getIBLResOnCanvas: getIBLResOnCanvas$1, logoutIBLResOnCanvas: logoutIBLResOnCanvas$1, getPBRUniforms: getPBRUniforms$1, loginIBLResOnCanvas: loginIBLResOnCanvas$1 } = $2wazW.pbr.PBRUtils;
const DEFAULT_TEX_OFFSET = [
    0,
    0
];
const DEFAULT_TEX_SCALE = [
    1,
    1
];
const ARR2_1 = [];
const ARR2_2 = [];
const ARR2_3 = [];
const ARR2_4 = [];
const ARR2_5 = [];
class GroundPainter {
    static getGroundTransform(out, map) {
        return getGroundTransform(out, map);
    }
    constructor(regl, layer){
        this._regl = regl;
        this.renderer = new $2wazW.Renderer(regl);
        this._layer = layer;
        this._loader = new $2wazW.ResourceLoader();
        this._bindOnMaterialComplete = (...args)=>{
            return this._onMaterialComplete.call(this, ...args);
        };
        this._init();
        const canvas = this.getMap().getRenderer().canvas;
        loginIBLResOnCanvas$1(canvas, regl, this.getMap());
    }
    needToRedraw() {
        const uvOffsetAnim = this._getUVOffsetAnim();
        return uvOffsetAnim && (uvOffsetAnim[0] || uvOffsetAnim[1]);
    }
    getMap() {
        return this._layer && this._layer.getMap();
    }
    getSymbol() {
        const ground = this._layer.getGroundConfig();
        return ground && ground.symbol;
    }
    isEnable() {
        const ground = this._layer.getGroundConfig();
        return ground && ground.enable;
    }
    paint(context) {
        if (!this.isEnable()) return false;
        const shader = this._getShader();
        if (this._isInSSRPhase(context) && shader === this._fillShader) return false;
        const defines = this._getGroundDefines(context);
        if (defines) this._ground.setDefines(defines);
        if (this._ground.material !== this.material) this._ground.setMaterial(this.material);
        const groundConfig = this._layer.getGroundConfig();
        const symbol = groundConfig && groundConfig.symbol;
        if (symbol.ssr) this._ground.ssr = 1;
        else this._ground.ssr = 0;
        this._transformGround();
        const uniforms = this._getUniformValues(context);
        uniforms['offsetFactor'] = context.offsetFactor;
        uniforms['offsetUnits'] = context.offsetUnits;
        const fbo = context && context.renderTarget && context.renderTarget.fbo;
        if (shader === this._fillShader) {
            //如果是drawSSR阶段不绘制fill ground，fuzhenn/maptalks-studio#461
            this.renderer.render(shader, uniforms, this._groundScene, fbo);
            this._layer.getRenderer().setCanvasUpdated();
            return true;
        }
        shader.filter = context.sceneFilter;
        this.renderer.render(shader, uniforms, this._groundScene, fbo);
        this._layer.getRenderer().setCanvasUpdated();
        return true;
    }
    _isInSSRPhase(context) {
        const enableSSR = this._layer.getRenderer().isEnableSSR && this._layer.getRenderer().isEnableSSR();
        if (!enableSSR) return false;
        return !!(context && context.ssr);
    }
    update() {
        const groundConfig = this._layer.getGroundConfig();
        if (!groundConfig) return;
        const symbol = groundConfig && groundConfig.symbol;
        const urlModifier = groundConfig.urlModifier;
        if (!symbol) {
            this._polygonFill = [
                1,
                1,
                1,
                1
            ];
            this._polygonOpacity = 1;
            if (this._polygonPatternFile) {
                this._polygonPatternFile.destroy();
                delete this._polygonPatternFile;
            }
        } else {
            this._polygonFill = this._parseColor(symbol['polygonFill'] || [
                1,
                1,
                1,
                1
            ]);
            this._polygonOpacity = symbol['polygonOpacity'] === undefined ? 1 : symbol['polygonOpacity'];
            const polygonPatternFile = symbol.polygonPatternFile;
            if (polygonPatternFile) {
                if (!this._polygonPatternFile || this._polygonPatternFile['_pattern_src'] !== polygonPatternFile) {
                    const image = new Image();
                    image.onload = ()=>{
                        if (this._polygonPatternFile) this._polygonPatternFile.destroy();
                        this._polygonPatternFile = this._createPatternTexture(image);
                        this._polygonPatternFile['_pattern_src'] = polygonPatternFile;
                        this.setToRedraw();
                    };
                    image.src = urlModifier && urlModifier(polygonPatternFile) || polygonPatternFile;
                }
            } else if (this._polygonPatternFile) {
                this._polygonPatternFile.destroy();
                delete this._polygonPatternFile;
            }
        }
        this._updateMaterial();
    }
    setToRedraw() {
        const renderer = this._layer.getRenderer();
        if (!renderer) return;
        renderer.setToRedraw();
    }
    dispose() {
        if (this.material) {
            this.material.dispose();
            delete this.material;
        }
        if (this._ground) {
            this._ground.geometry.dispose();
            if (this._ground.material) this._ground.material.dispose();
            this._ground.dispose();
            delete this._ground;
        }
        if (this._polygonPatternFile) {
            this._polygonPatternFile.destroy();
            delete this._polygonPatternFile;
        }
        if (this._fillShader) {
            this._fillShader.dispose();
            delete this._fillShader;
        }
        if (this._standardShader) {
            this._standardShader.dispose();
            delete this._standardShader;
        }
        this._disposeIblTextures();
    }
    _getShader() {
        const groundConfig = this._layer.getGroundConfig();
        if (!groundConfig || !groundConfig.renderPlugin) return this._fillShader;
        const type = groundConfig.renderPlugin.type;
        if (type === 'lit') return this._standardShader;
        else if (type === 'fill') return this._fillShader;
        else throw new Error('unsupported render plugin of ' + type + ' for layer ground');
    }
    _getUniformValues(context) {
        const uniforms = this._getCommonUniforms(context);
        uniforms.polygonFill = this._polygonFill;
        uniforms.polygonOpacity = this._polygonOpacity;
        const shader = this._getShader();
        if (shader === this._fillShader && this._polygonPatternFile) uniforms.polygonPatternFile = this._polygonPatternFile;
        return uniforms;
    }
    _getCommonUniforms(context) {
        const groundConfig = this._layer.getGroundConfig();
        const type = groundConfig.renderPlugin.type;
        let uniforms;
        if (type === 'lit') {
            const canvas = this.getMap().getRenderer().canvas;
            const { iblTexes, dfgLUT } = getIBLResOnCanvas$1(canvas);
            uniforms = getPBRUniforms$1(this.getMap(), iblTexes, dfgLUT, context && context.ssr, context && context.jitter);
        } else {
            const map = this.getMap();
            uniforms = {
                projViewMatrix: map.projViewMatrix
            };
        }
        this._setIncludeUniformValues(uniforms, context);
        return uniforms;
    }
    _setIncludeUniformValues(uniforms, context) {
        const includes = context && context.includes;
        if (includes) for(const p in includes){
            if (includes[p]) {
                if (context[p].renderUniforms) extend(uniforms, context[p].renderUniforms);
            }
        }
    }
    _disposeIblTextures() {
        const canvas = this.getMap().getRenderer().canvas;
        logoutIBLResOnCanvas$1(canvas, this.getMap());
    }
    _init() {
        //fill shader
        const extraCommandProps = this._getExtraCommandProps();
        const fillUniforms = ShadowProcess.getUniformDeclares();
        const projViewModelMatrix = [];
        fillUniforms.push({
            name: 'projViewModelMatrix',
            type: 'function',
            fn: function(context, props) {
                return (0, $3iqbd).multiply(projViewModelMatrix, props['projViewMatrix'], props['modelMatrix']);
            }
        });
        this._fillShader = new $2wazW.MeshShader({
            vert: fillVert,
            frag: fillFrag,
            uniforms: fillUniforms,
            extraCommandProps: extraCommandProps
        });
        //standard shader
        const uniforms = ShadowProcess.getUniformDeclares();
        uniforms.push(...$2wazW.SsrPass.getUniformDeclares());
        this._standardShader = new $2wazW.pbr.StandardShader({
            uniforms: uniforms,
            extraCommandProps: extraCommandProps
        });
        this._createGround();
        this.update();
    }
    _getExtraCommandProps() {
        const defaultRange = [
            0,
            1
        ];
        const canvas = this._layer.getRenderer().canvas;
        return {
            viewport: {
                x: 0,
                y: 0,
                width: ()=>{
                    return canvas.width;
                },
                height: ()=>{
                    return canvas.height;
                }
            },
            cull: {
                enable: true
            },
            depth: {
                enable: true,
                mask: ()=>{
                    const ground = this._layer.getGroundConfig();
                    return ground.depth || ground.depth === undefined;
                },
                range: ()=>{
                    const groundConfig = this._layer.getGroundConfig();
                    const groundSceneConfig = groundConfig && groundConfig.renderPlugin.sceneConfig;
                    return groundSceneConfig && groundSceneConfig['depthRange'] || defaultRange;
                },
                //如果设成'<'，会有低级别下地面消失的问题，fuzhenn/maptalks-studio#460
                func: '<='
            },
            blend: {
                enable: true,
                func: {
                    src: 'src alpha',
                    dst: 'one minus src alpha'
                },
                equation: 'add'
            },
            polygonOffset: {
                enable: true,
                offset: {
                    factor: (context, props)=>{
                        return props['offsetFactor'];
                    },
                    units: (context, props)=>{
                        return props['offsetUnits'];
                    }
                }
            }
        };
    }
    _hasIBL() {
        const lightManager = this.getMap().getLightManager();
        const resource = lightManager && lightManager.getAmbientResource();
        return !!resource;
    }
    _createGround() {
        const planeGeo = new $2wazW.Plane();
        planeGeo.data.aTexCoord = new Uint8Array([
            0,
            0,
            1,
            0,
            0,
            1,
            1,
            1
        ]);
        planeGeo.createTangent();
        planeGeo.generateBuffers(this.renderer.regl);
        //TODO 还需要构造 tangent
        this._ground = new $2wazW.Mesh(planeGeo, null, {
            castShadow: false
        });
        const defines = this._standardShader.getGeometryDefines(planeGeo);
        this._ground.setDefines(defines);
        this._groundScene = new $2wazW.Scene([
            this._ground
        ]);
    }
    _transformGround() {
        const map = this.getMap();
        const localTransform = GroundPainter.getGroundTransform(this._ground.localTransform, map);
        this._ground.setLocalTransform(localTransform);
        const glRes = map.getGLRes();
        const extent = map['_get2DExtentAtRes'](glRes);
        const width = extent.getWidth();
        const height = extent.getHeight();
        const center = map.cameraLookAt;
        const xmin = center[0] - width;
        const ymin = center[1] - height;
        const texAspect = this._polygonPatternFile ? this._polygonPatternFile.width / this._polygonPatternFile.height : 1;
        const symbol = this.getSymbol();
        const patternOrigin = this.material ? this.material.get('textureOrigin') : symbol.polygonPatternFileOrigin;
        const isOffsetInMeter = !!(this.material ? this.material.get('uvOffsetInMeter') : symbol.uvOffsetInMeter);
        const offsetValue = (this.material ? this.material.get('uvOffset') : symbol.uvOffset) || DEFAULT_TEX_OFFSET;
        const uvScale = this.material && this.material.get('uvScale') || DEFAULT_TEX_SCALE;
        const patternWidth = this.material ? this.material.get('textureWidth') : symbol.polygonPatternFileWidth;
        const patternHeight = this.material ? patternWidth * (uvScale[1] / uvScale[0]) : symbol.polygonPatternFileHeight;
        const uvOffsetAnim = this._getUVOffsetAnim();
        const [textureWidth, textureHeight, uvStartX, uvStartY, uvOffset] = computeUVUniforms(map, xmin, ymin, patternOrigin, patternWidth, patternHeight, texAspect, uvScale, isOffsetInMeter, offsetValue, uvOffsetAnim);
        // 乘以2是因为plane的长宽是extent的2倍
        const scaleX = extent.getWidth() * 2 / textureWidth;
        const scaleY = extent.getHeight() * 2 / textureHeight;
        if (!this.material) {
            // fill
            this._ground.setUniform('uvScale', (0, $6BoVD).set(ARR2_1, scaleX, scaleY));
            this._ground.setUniform('uvOffset', (0, $6BoVD).set(ARR2_2, uvStartX % 1 + uvOffset[0], uvStartY % 1 + uvOffset[1]));
            return;
        }
        this._ground.setUniform('uvScale', (0, $6BoVD).set(ARR2_5, scaleX, scaleY));
        this._ground.setUniform('uvOffset', (0, $6BoVD).set(ARR2_3, uvStartX % 1 + uvOffset[0], uvStartY % 1 + uvOffset[1]));
        // uvOrigin 是 uvStart的整数部分
        this._ground.setUniform('uvOrigin', (0, $6BoVD).set(ARR2_4, uvStartX - uvStartX % 1, uvStartY - uvStartY % 1));
        this._ground.setUniform('uvRotation', 0);
    }
    _getGroundDefines(context) {
        let updated = false;
        const defines = this._ground.defines;
        const sceneConfig = this._layer._getSceneConfig && this._layer._getSceneConfig();
        const groundConfig = this._layer.getGroundConfig();
        function update(has, name) {
            if (has) {
                if (!defines[name]) {
                    defines[name] = 1;
                    updated = true;
                }
            } else if (defines[name]) {
                delete defines[name];
                updated = true;
            }
        }
        update(this._hasIBL(), 'HAS_IBL_LIGHTING');
        const hasSSR = context && context.ssr && groundConfig && groundConfig.symbol && groundConfig.symbol.ssr;
        update(hasSSR, 'HAS_SSR');
        const hasShadow = context && sceneConfig && sceneConfig.shadow && sceneConfig.shadow.enable;
        update(hasShadow, 'HAS_SHADOWING');
        update(hasShadow, 'USE_ESM');
        const hasPattern = !!this._polygonPatternFile;
        update(hasPattern, 'HAS_PATTERN');
        // const hasSSAO = context && context.ssao;
        // update(hasSSAO, 'HAS_SSAO');
        if (!updated) return null;
        return defines;
    }
    _updateMaterial() {
        const materialConfig = this.getSymbol() && this.getSymbol().material;
        if (!materialConfig) return;
        const material = {};
        let hasTexture = false;
        const ground = this._layer.getGroundConfig();
        this._loader.setURLModifier(ground.urlModifier);
        for(const p in materialConfig)if (hasOwn(materialConfig, p)) {
            if (p.indexOf('Texture') > 0) {
                //纹理图片
                let texConf = materialConfig[p];
                if (!texConf) continue;
                texConf = typeof texConf === 'string' ? {
                    url: texConf,
                    wrap: 'repeat'
                } : texConf;
                texConf.flipY = true;
                texConf.min = 'linear mipmap linear';
                texConf.mag = 'linear';
                texConf.flipY = true;
                // texConf.aniso = 4;
                material[p] = new $2wazW.Texture2D(texConf, this._loader);
                hasTexture = true;
            } else material[p] = materialConfig[p];
        }
        if (!this.material) {
            this.material = new $2wazW.pbr.StandardMaterial(material);
            this.material.once('complete', this._bindOnMaterialComplete, this);
        } else {
            this._loadingMaterial = new $2wazW.pbr.StandardMaterial(material);
            if (this._loadingMaterial.isReady()) this._onMaterialComplete();
            else this._loadingMaterial.once('complete', this._bindOnMaterialComplete);
        }
        if (!hasTexture) this._onMaterialComplete();
    }
    _onMaterialComplete() {
        if (this._loadingMaterial) {
            this.material.dispose();
            this.material = this._loadingMaterial;
            delete this._loadingMaterial;
        }
        this.setToRedraw(true);
    }
    _createPatternTexture(image) {
        image = $2wazW.Util.resizeToPowerOfTwo(image);
        const regl = this._regl;
        const config = {
            width: image.width,
            height: image.height,
            data: image,
            mag: 'linear',
            min: 'linear mipmap linear',
            flipY: true,
            wrap: 'repeat'
        };
        return regl.texture(config);
    }
    _parseColor(c) {
        return normalizeColor([], c);
    }
    _getUVOffsetAnim() {
        return this.material && this.material.get('uvOffsetAnim');
    }
    getRenderMeshes() {
        return this._groundScene.getMeshes();
    }
}
const { createIBLTextures, disposeIBLTextures } = $2wazW.pbr.PBRUtils;
const EMPTY_HSV = [
    0,
    0,
    0
];
const HSV = [];
const OUTSIZE = [];
class EnvironmentPainter {
    constructor(regl, layer){
        this._maxLevel = 4;
        this._regl = regl;
        this.renderer = new $2wazW.Renderer(regl);
        this._layer = layer;
        this._init();
        this._updateMode();
    }
    paint(context) {
        if (!this.isEnable() || !this._resource) return;
        const uniforms = this._getUniformValues(context);
        const fbo = context && context.renderTarget && context.renderTarget.fbo;
        this.renderer.render(this._shader, uniforms, null, fbo);
    }
    update() {
        const map = this.getMap();
        if (!map || !this.isEnable()) return;
        const lightManager = map.getLightManager();
        const resource = lightManager && lightManager.getAmbientResource();
        if (resource !== this._resource && this._iblTexes) {
            disposeIBLTextures(this._iblTexes);
            delete this._iblTexes;
        }
        this._resource = resource;
        this._updateMode();
    }
    dispose() {
        this._shader.dispose();
        disposeIBLTextures(this._iblTexes);
        delete this._shader;
        delete this._iblTexes;
        delete this._resource;
    }
    getMap() {
        return this._layer.getMap();
    }
    _updateMode() {
        if (!this._resource) return;
        const sceneConfig = this._layer._getSceneConfig();
        const environment = sceneConfig.environment || {};
        this._shader.setMode(environment.toneMapping, environment.mode ? 1 : 0);
    }
    isEnable() {
        const sceneConfig = this._layer._getSceneConfig();
        return this._hasIBL() && sceneConfig && sceneConfig.environment && sceneConfig.environment.enable;
    }
    _hasIBL() {
        const lightManager = this.getMap().getLightManager();
        const resource = lightManager && lightManager.getAmbientResource();
        return !!resource;
    }
    _getUniformValues() {
        const map = this.getMap();
        const lightManager = this.getMap().getLightManager();
        const ambient = lightManager && lightManager.getAmbientLight();
        let iblTexes = this._iblTexes;
        if (!iblTexes) iblTexes = this._iblTexes = createIBLTextures(this._regl, map);
        const canvas = this._layer.getRenderer().canvas;
        const envConfig = this._layer._getSceneConfig().environment || {};
        const level = envConfig.level || 0;
        const cubeSize = iblTexes.prefilterMap.width;
        const transform = this._transform = this._transform || [];
        const hsv = ambient && ambient.hsv || EMPTY_HSV;
        const brightness = envConfig.brightness || 0;
        const intensity = envConfig.intensity || 1;
        (0, $eIStk).copy(HSV, hsv);
        if (brightness) HSV[2] += brightness;
        OUTSIZE[0] = canvas.width;
        OUTSIZE[1] = canvas.height;
        return {
            'cubeMap': iblTexes.prefilterMap,
            'bias': level,
            'size': cubeSize / Math.pow(2, Math.max(0, level - 1)),
            'environmentExposure': isNumber$1(ambient && ambient.exposure) ? ambient.exposure : 1,
            'backgroundIntensity': intensity,
            'diffuseSPH': iblTexes.sh,
            'viewMatrix': map.viewMatrix,
            'projMatrix': map.projMatrix,
            'resolution': OUTSIZE,
            'hsv': HSV,
            'transformMatrix': (0, $bDSmI).fromRotation(transform, ambient && Math.PI / 180 * -ambient.orientation || 0)
        };
    }
    _init() {
        const map = this.getMap();
        map.on('updatelights', this.update, this);
        this._shader = new $2wazW.SkyboxShader();
        if (map.options.lights) {
            const lightManager = this.getMap().getLightManager();
            const resource = lightManager.getAmbientResource();
            this._resource = resource;
        }
    }
}
var rainVert = "attribute vec3 aPosition;\nattribute vec3 aNormal;\nattribute vec2 aTexCoord;\nuniform mat4 projMatrix;\nuniform mat4 modelMatrix;\nuniform mat4 modelViewMatrix;\nuniform mat4 positionMatrix;\nuniform vec3 cameraPosition;\nuniform float top;\nuniform float bottom;\nuniform float time;\nvarying vec2 vTexCoord;\n#include <get_output>\nfloat angle(float x, float y){\n    return atan(y, x);\n}\nvec2 getFoot(vec2 camera, vec2 normal, vec2 pos) {\n    vec2 position = vec2(0.0, 0.0);\n    float distanceLen = distance(pos, normal);\n    float a = angle(camera.x - normal.x, camera.y - normal.y);\n    pos.x > normal.x ? a -= 0.785 : a += 0.785;\n    position.x = cos(a) * distanceLen;\n    position.y = sin(a) * distanceLen;\n    return position + normal;\n    return position;\n}\nvoid main()\n{\n    vec4 localPosition = getPosition(aPosition);\n    mat4 localPositionMatrix = getPositionMatrix();\n    vec2 foot = getFoot(vec2(cameraPosition.x, cameraPosition.z), vec2(aNormal.x, aNormal.z), vec2(localPosition.x, localPosition.z));\n    float height = top - bottom;\n    float y = aNormal.y - bottom - height * time;\n    y = y + (y < 0.0 ? height : 0.0);\n    float ratio = (1.0 - y / height) * (1.0 - y / height);\n    y = height * (1.0 - ratio);\n    y += bottom;\n    y += aPosition.y - aNormal.y;\n    localPosition = vec4( foot.x, y, foot.y , 1.0);\n    gl_Position = projMatrix * modelViewMatrix * localPositionMatrix * localPosition;\n    vTexCoord = aTexCoord;\n}";
var rainFrag = "precision mediump float;\nvarying vec2 vTexCoord;\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D rainMap;\nvoid main() {\n    vec4 rainColor = texture2D(rainMap, vTexCoord);\n    vec4 diffuseColor = vec4(diffuse, opacity);\n    diffuseColor *= rainColor;\n    gl_FragColor = diffuseColor;\n}";
const modelViewMatrix$1 = [];
const DEFALUT_SCALE$1 = [
    0.03,
    0.03,
    0.03
];
const TEMP_ROTATE$1 = [], TEMP_SCALE$1 = [], TEMP_MAT$1 = [];
const DEFAULT_COLOR = [
    1,
    1,
    1
];
const DEFAULT_EXTENT = {
    min: [
        -1200,
        -1200,
        0
    ],
    max: [
        1200,
        1200,
        1000
    ]
}, DEFAULT_ZOOM$2 = 16.685648411389433, extent = {
    min: [],
    max: []
};
const Y_UP_TO_Z_UP$1 = (0, $3iqbd).fromRotationTranslation([], (0, $k1dpP).fromEuler([], 90, 0, 0), [
    0,
    0,
    0
]);
class RainPainer {
    constructor(regl, layer){
        this._regl = regl;
        this.renderer = new $2wazW.Renderer(regl);
        this._layer = layer;
        this._timer = new Clock();
        this._init();
    }
    getMap() {
        return this._layer && this._layer.getMap();
    }
    _init() {
        const canvas = this._layer.getRenderer().canvas;
        const viewport = {
            x: 0,
            y: 0,
            width: ()=>{
                return canvas.width;
            },
            height: ()=>{
                return canvas.height;
            }
        };
        this._shader = new $2wazW.MeshShader({
            vert: rainVert,
            frag: rainFrag,
            uniforms: [
                {
                    name: 'modelViewMatrix',
                    type: 'function',
                    fn: function(context, props) {
                        return (0, $3iqbd).multiply(modelViewMatrix$1, props['viewMatrix'], props['modelMatrix']);
                    }
                }
            ],
            extraCommandProps: {
                viewport: viewport,
                depth: {
                    enable: true,
                    mask: false,
                    func: 'less',
                    range: [
                        0,
                        1
                    ]
                },
                blend: {
                    enable: true,
                    func: {
                        src: 'src alpha',
                        dst: 'one minus src alpha'
                    },
                    equation: 'add'
                }
            }
        });
        this._createScene();
    }
    _createScene() {
        const emptyTexture = this._regl.texture({
            width: 2,
            height: 2
        });
        this._mesh = this._createRain();
        if (!this._mesh) return;
        this._scene = new $2wazW.Scene(this._mesh);
        const rainConfig = this._getRainConfig();
        if (!rainConfig.rainTexture) {
            this._mesh.material.set('rainMap', emptyTexture);
            console.warn('should set rain texture.');
        } else this._creatRainTexture(rainConfig.rainTexture).then((rainMap)=>{
            this._mesh.material.set('rainMap', rainMap);
        });
    }
    _createRain() {
        const map = this.getMap();
        const rainConfig = this._getRainConfig();
        if (!rainConfig) return null;
        this._fixZoom = map.getZoom();
        const box = this._getFixExtent();
        // const box = DEFAULT_EXTENT;
        const rainDensity = this._rainDensity = rainConfig.density;
        const rainWidth = this._rainWidth = rainConfig.rainWidth || 1;
        const rainHeight = this._rainHeight = rainConfig.rainHeight || 1;
        const vertices = [];
        const normals = [];
        const uvs = [];
        const indices = [];
        for(let i = 0; i < rainDensity; i++){
            const pos = {};
            pos.x = Math.random() * (box.max[0] - box.min[0]) + box.min[0];
            pos.y = Math.random() * (box.max[2] - box.min[2]) + box.min[2];
            pos.z = Math.random() * (box.max[1] - box.min[1]) + box.min[1];
            //雨滴的高宽比3:1
            const height = (box.max[2] - box.min[2]) / 37.5 * rainHeight;
            const width = height / 3 * rainWidth;
            vertices.push(pos.x + width, pos.y + height, pos.z, pos.x - width, pos.y + height, pos.z, pos.x - width, pos.y, pos.z, pos.x + width, pos.y, pos.z);
            normals.push(pos.x, pos.y - height / 2, pos.z, pos.x, pos.y - height / 2, pos.z, pos.x, pos.y - height / 2, pos.z, pos.x, pos.y - height / 2, pos.z);
            uvs.push(1, 1, 0, 1, 0, 0, 1, 0);
            indices.push(i * 4 + 0, i * 4 + 1, i * 4 + 2, i * 4 + 0, i * 4 + 2, i * 4 + 3);
        }
        const attributes = {};
        attributes['POSITION'] = vertices;
        attributes['NORMAL'] = normals;
        attributes['TEXCOORD_0'] = uvs;
        const geometry = new $2wazW.Geometry(attributes, indices, 0, {
            primitive: 'triangles',
            positionAttribute: 'POSITION',
            normalAttribute: 'NORMAL',
            uv0Attribute: 'TEXCOORD_0'
        });
        geometry.generateBuffers(this.renderer.regl);
        const material = new $2wazW.Material({
            rainMap: this._regl.texture({
                width: 2,
                height: 2
            }),
            diffuse: rainConfig.color || [
                1,
                1,
                1
            ],
            opacity: rainConfig.opacity || 1
        });
        const modelMesh = new $2wazW.Mesh(geometry, material);
        modelMesh.setUniform('top', box.max[2]);
        modelMesh.setUniform('bottom', box.min[2]);
        this._transformRain(modelMesh);
        modelMesh.transparent = true;
        return modelMesh;
    }
    _creatRainTexture(rainTexture) {
        const rainImage = new Image();
        rainImage.src = this._rainTexture = rainTexture;
        return new Promise((resolve, reject)=>{
            rainImage.onload = ()=>{
                const rainMap = this._regl.texture({
                    mag: 'linear',
                    min: 'linear mipmap nearest',
                    wrapS: 'clamp',
                    wrapT: 'clamp',
                    data: rainImage
                });
                resolve(rainMap);
            };
            rainImage.onerror = (err)=>{
                reject(err);
            };
        });
    }
    paint(context) {
        if (!this._scene) return;
        const rainConfig = this._getRainConfig();
        const uniforms = {};
        const map = this.getMap();
        uniforms['projMatrix'] = map.projMatrix;
        uniforms['viewMatrix'] = map.viewMatrix;
        uniforms['cameraPosition'] = map.cameraPosition;
        const speed = rainConfig.speed || 1.0;
        const time = this._timer.getElapsedTime() / (2 / speed) % 1;
        uniforms['time'] = time;
        this._mesh.material.set('diffuse', rainConfig.color || DEFAULT_COLOR);
        this._mesh.material.set('opacity', rainConfig.opacity || 1);
        this._transformRain(this._mesh);
        const fbo = context && context.renderTarget && context.renderTarget.fbo;
        this.renderer.render(this._shader, uniforms, this._scene, fbo);
        this._layer.getRenderer().setCanvasUpdated();
    }
    _transformRain(mesh) {
        const map = this.getMap();
        const center = map.coordinateToPointAtRes(map.getCenter(), map.getGLRes());
        const ratio = map.getGLScale() / map.getGLScale(this._fixZoom);
        const v3 = (0, $eIStk).set(TEMP_SCALE$1, ratio, ratio, ratio);
        const scale = (0, $eIStk).multiply(v3, DEFALUT_SCALE$1, v3);
        const transformat = (0, $3iqbd).identity(TEMP_MAT$1);
        const config = this._getRainConfig();
        const bearing = map.getBearing();
        (0, $3iqbd).fromRotationTranslationScale(transformat, (0, $k1dpP).fromEuler(TEMP_ROTATE$1, config.windDirectionX || 0, config.windDirectionY || 0, -bearing + 90), [
            center.x,
            center.y,
            0
        ], scale);
        (0, $3iqbd).multiply(transformat, transformat, Y_UP_TO_Z_UP$1);
        mesh.setLocalTransform(transformat);
    }
    setToRedraw() {
        const renderer = this._layer.getRenderer();
        if (!renderer) return;
        renderer.setToRedraw();
    }
    update() {
        const rainConfig = this._getRainConfig();
        if (!rainConfig) return;
        if (!this._mesh) this._createScene();
        //更改雨量大小，需要重新创建mesh
        if (rainConfig.density !== this._rainDensity || rainConfig.rainWidth !== this._rainWidth || rainConfig.rainHeight !== this._rainHeight) {
            const rainMap = this._mesh.material.get('rainMap');
            this._mesh.geometry.dispose();
            this._mesh.dispose();
            this._scene.clear();
            this._mesh = this._createRain();
            this._mesh.material.set('rainMap', rainMap);
            this._scene.setMeshes(this._mesh);
        }
        if (rainConfig.rainTexture !== this._rainTexture) this._creatRainTexture(rainConfig.rainTexture).then((rainMap)=>{
            this._mesh.material.set('rainMap', rainMap);
        });
    }
    dispose() {
        if (this._mesh) {
            this._mesh.geometry.dispose();
            if (this._mesh.material) this._mesh.material.dispose();
            this._mesh.dispose();
            delete this._mesh;
        }
        if (this._shader) {
            this._shader.dispose();
            delete this._shader;
        }
    }
    isEnable() {
        const config = this._getRainConfig();
        return config && config.enable;
    }
    _getRainConfig() {
        const weatherConfig = this._layer.getWeatherConfig();
        return weatherConfig && weatherConfig.rain;
    }
    _getFixExtent() {
        const map = this.getMap();
        const zoom = map.getZoom();
        const ratio = DEFAULT_ZOOM$2 - zoom;
        (0, $eIStk).scale(extent.min, DEFAULT_EXTENT.min, Math.pow(2, ratio));
        (0, $eIStk).scale(extent.max, DEFAULT_EXTENT.max, Math.pow(2, ratio));
        return extent;
    }
}
class Clock {
    constructor(autoStart){
        this.autoStart = autoStart !== undefined ? autoStart : true;
        this.startTime = 0;
        this.oldTime = 0;
        this.elapsedTime = 0;
        this.running = false;
    }
    start() {
        this.startTime = (typeof performance === 'undefined' ? Date : performance).now();
        this.oldTime = this.startTime;
        this.elapsedTime = 0;
        this.running = true;
    }
    stop() {
        this.getElapsedTime();
        this.running = false;
        this.autoStart = false;
    }
    getElapsedTime() {
        this.getDelta();
        return this.elapsedTime;
    }
    getDelta() {
        let diff = 0;
        if (this.autoStart && !this.running) {
            this.start();
            return 0;
        }
        if (this.running) {
            const newTime = (typeof performance === 'undefined' ? Date : performance).now();
            diff = (newTime - this.oldTime) / 1000;
            this.oldTime = newTime;
            this.elapsedTime += diff;
        }
        return 0;
    }
}
var snowVert = "#include <gl2_vert>\nattribute vec3 aPosition;\nattribute vec2 aTexCoord;\nvarying vec2 vTexCoord;\nuniform mat4 projMatrix;\nuniform mat4 modelMatrix;\nuniform mat4 modelViewMatrix;\nuniform mat4 positionMatrix;\n#include <get_output>\nvoid main()\n{\n    mat4 localPositionMatrix = getPositionMatrix();\n    vec4 localPosition = getPosition(aPosition);\n    gl_Position = projMatrix * modelViewMatrix * localPositionMatrix * localPosition;\n    vTexCoord = aTexCoord;\n}";
var snowFrag = "#if __VERSION__ == 100\n  #ifdef GL_OES_standard_derivatives\n    #extension GL_OES_standard_derivatives : enable\n  #endif\n#endif\nprecision mediump float;\n#include <gl2_frag>\nprecision mediump float;\nuniform sampler2D perlinTexture;\nvarying vec2 vTexCoord;\nfloat lerp(float a, float b, float w) {\n    return a + w * (b - a);\n}\nvoid main() {\n    float snowIntense = texture2D(perlinTexture, vTexCoord).r;\n    vec3 fixedC = vec3(1.0, 1.0, 1.0);\n    float r = lerp(0.5, fixedC.x, snowIntense);\n    float g = lerp(0.5, fixedC.y, snowIntense);\n    float b = lerp(0.5, fixedC.z, snowIntense);\n    glFragColor = vec4(r, g, b, 1.0);\n    #if __VERSION__ == 100\n        gl_FragColor = glFragColor;\n    #endif\n}";
const modelViewMatrix = [];
const DEFALUT_SCALE = [
    0.03,
    0.03,
    0.03
];
const TEMP_ROTATE = [], TEMP_SCALE = [], TEMP_MAT = [], DEFAULT_ZOOM$1 = 16.685648411389433;
const Y_UP_TO_Z_UP = (0, $3iqbd).fromRotationTranslation([], (0, $k1dpP).fromEuler([], 90, 0, 0), [
    0,
    0,
    0
]);
class SnowPainter {
    constructor(regl, layer){
        this._regl = regl;
        this._layer = layer;
        this._init();
    }
    _init() {
        const canvas = this._layer.getRenderer().canvas;
        const viewport = {
            x: 0,
            y: 0,
            width: ()=>{
                return canvas.width;
            },
            height: ()=>{
                return canvas.height;
            }
        };
        this._shader = new $2wazW.MeshShader({
            vert: snowVert,
            frag: snowFrag,
            uniforms: [
                {
                    name: 'modelViewMatrix',
                    type: 'function',
                    fn: function(context, props) {
                        return (0, $3iqbd).multiply(modelViewMatrix, props['viewMatrix'], props['modelMatrix']);
                    }
                }
            ],
            extraCommandProps: {
                viewport: viewport
            }
        });
        this._shader.version = 300;
        this._scene = new $2wazW.Scene();
        this._groundMask = this._createGroundMask();
        this._scene.setMeshes(this._groundMask);
        this.renderer = new $2wazW.Renderer(this._regl);
        const snowConfig = this._getSnowConfig();
        if (!snowConfig) return;
        if (!snowConfig.snowGroundTexture) {
            this._groundNormal = this._regl.texture({
                width: 2,
                height: 2
            });
            console.warn('should set snow ground texture.');
        } else this._createSnowTexture(snowConfig.snowGroundTexture);
    }
    render(context) {
        if (this._groundNormal) this._groundMask.material.set('perlinTexture', this._groundNormal);
        const map = this._layer.getMap();
        this._transformMask(map);
        const uniforms = {
            projMatrix: map.projMatrix,
            viewMatrix: map.viewMatrix,
            cameraPosition: map.cameraPosition
        };
        const fbo = context && context.renderTarget && context.renderTarget.fbo;
        this.renderer.render(this._shader, uniforms, this._scene, fbo);
        this._layer.getRenderer().setCanvasUpdated();
    }
    _transformMask(map) {
        const center = map.coordinateToPointAtRes(map.getCenter(), map.getGLRes());
        const ratio = map.getGLScale() / map.getGLScale(this._fixZoom);
        const v3 = (0, $eIStk).set(TEMP_SCALE, ratio, ratio, ratio);
        const scale = (0, $eIStk).multiply(v3, DEFALUT_SCALE, v3);
        const transformat = (0, $3iqbd).identity(TEMP_MAT);
        (0, $3iqbd).fromRotationTranslationScale(transformat, (0, $k1dpP).fromEuler(TEMP_ROTATE, 0, 0, 0), [
            center.x,
            center.y,
            0.005
        ], scale);
        (0, $3iqbd).multiply(transformat, transformat, Y_UP_TO_Z_UP);
        this._groundMask.setLocalTransform(transformat);
    }
    _createSnowTexture(snowGroundTexture) {
        const image = new Image();
        image.onload = ()=>{
            this._groundNormal = this._regl.texture({
                mag: 'linear',
                min: 'linear mipmap nearest',
                wrapS: 'repeat',
                wrapT: 'repeat',
                data: image
            });
        };
        image.onerror = (err)=>{
            console.log(err);
        };
        image.src = this._snowGroundTexture = snowGroundTexture;
    }
    _createGroundMask() {
        const map = this._layer.getMap();
        this._fixZoom = map.getZoom();
        const pos = Math.pow(2, DEFAULT_ZOOM$1 - this._fixZoom) * 16000;
        const vertices = [
            -pos,
            0,
            -pos,
            pos,
            0,
            -pos,
            -pos,
            0,
            pos,
            pos,
            0,
            pos
        ];
        const normals = [
            0,
            1,
            0,
            0,
            1,
            0,
            0,
            1,
            0,
            0,
            1,
            0
        ];
        const uvs = [
            0.0,
            0.0,
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            1.0
        ];
        const indices = [
            3,
            1,
            0,
            0,
            2,
            3
        ];
        const attributes = {};
        attributes['POSITION'] = vertices;
        attributes['NORMAL'] = normals;
        attributes['TEXCOORD_0'] = uvs;
        const geometry = new $2wazW.Geometry(attributes, indices, 0, {
            positionAttribute: 'POSITION',
            normalAttribute: 'NORMAL',
            uv0Attribute: 'TEXCOORD_0'
        });
        geometry.generateBuffers(this._regl);
        const material = new $2wazW.Material({
            perlinTexture: this._regl.texture({
                with: 2,
                height: 2
            })
        });
        const mesh = new $2wazW.Mesh(geometry, material);
        return mesh;
    }
    getMeshes() {
        return this._groundMask;
    }
    dispose() {
        if (this._groundMask) {
            this._groundMask.geometry.dispose();
            if (this._groundMask.material) this._groundMask.material.dispose();
            this._groundMask.dispose();
            delete this._groundMask;
        }
        if (this._shader) {
            this._shader.dispose();
            delete this._shader;
        }
    }
    update() {
        const snowConfig = this._getSnowConfig();
        if (!snowConfig) return;
        if (snowConfig.snowGroundTexture === !this._snowGroundTexture) this._createSnowTexture(snowConfig.snowGroundTexture);
    }
    isEnable() {
        const config = this._getSnowConfig();
        return config && config.enable;
    }
    _getSnowConfig() {
        const weatherConfig = this._layer.getWeatherConfig();
        return weatherConfig && weatherConfig.snow;
    }
}
const RESOLUTION$1 = [], DEFAULT_ZOOM = 16.685648411389433;
class WeatherPainter {
    constructor(regl, layer, config){
        this._regl = regl;
        this._layer = layer;
        this._config = config;
        this._init();
    }
    _init() {
        this.renderer = new $2wazW.Renderer(this._regl);
        const layerRenderer = this._layer.getRenderer();
        const viewport = this._viewport = {
            x: 0,
            y: 0,
            width: ()=>{
                return layerRenderer.canvas ? layerRenderer.canvas.width : 1;
            },
            height: ()=>{
                return layerRenderer.canvas ? layerRenderer.canvas.height : 1;
            }
        };
        this._width = viewport.width, this._height = viewport.height;
        this._fbo = this._regl.framebuffer({
            color: this._regl.texture({
                width: layerRenderer.canvas ? layerRenderer.canvas.width : 1,
                height: layerRenderer.canvas ? layerRenderer.canvas.height : 1,
                wrap: 'clamp',
                mag: 'linear',
                min: 'linear'
            }),
            depth: true
        });
        this.EMPTY_TEXTURE = this._regl.texture({
            with: 2,
            height: 2
        });
        this._rainPainter = new RainPainer(this._regl, this._layer);
        this._rainRipplesPass = new $2wazW.RainRipplesPass(this._regl, viewport);
        this._snowPainter = new SnowPainter(this._regl, this._layer);
        this._fogPass = new $2wazW.FogPass(this._regl, viewport, this._layer);
        this._weatherShader = new $2wazW.FogShader();
        this._weatherShader.version = 300;
    }
    getMap() {
        return this._layer && this._layer.getMap();
    }
    renderScene(drawContext) {
        this.renderSnowMask(drawContext);
        this.renderRain(drawContext);
    }
    renderRain(drawContext) {
        if (!this.isEnableRain()) return;
        this._rainPainter.paint(drawContext);
    }
    renderSnowMask(drawContext) {
        if (!this.isEnableSnow() || !this._showSnowGround()) return;
        const map = this.getMap();
        this._snowPainter.render(drawContext, map);
    }
    paint(tex, meshes) {
        if (!meshes || !meshes.length) return tex;
        this._resize();
        const config = this._layer.getWeatherConfig();
        const uniforms = {};
        if (this.isEnableRain()) {
            uniforms['ripplesMap'] = this._renderRainRipples();
            this._weatherShader.shaderDefines['HAS_RAIN'] = 1;
        } else delete this._weatherShader.shaderDefines['HAS_RAIN'];
        if (this.isEnableSnow()) {
            this._weatherShader.shaderDefines['HAS_SNOW'] = 1;
            uniforms['snowIntensity'] = $2wazW.Util.isNumber(config.snow.snowIntensity) ? config.snow.snowIntensity : 0.5;
            meshes.forEach((mesh)=>{
                mesh.defines['HAS_SNOW'] = 1;
            });
        } else {
            delete this._weatherShader.shaderDefines['HAS_SNOW'];
            meshes.forEach((mesh)=>{
                delete mesh.defines['HAS_SNOW'];
            });
        }
        if (this.isEnableFog()) {
            const fogConfig = config.fog;
            uniforms['fogColor'] = fogConfig.color || [
                0.9,
                0.9,
                0.9
            ];
            this._weatherShader.shaderDefines['HAS_FOG'] = 1;
        } else delete this._weatherShader.shaderDefines['HAS_FOG'];
        this._weatherShader.setDefines(this._weatherShader.shaderDefines);
        uniforms['mixFactorMap'] = this._renderMixFactor(meshes) || this.EMPTY_TEXTURE;
        uniforms['sceneMap'] = tex;
        uniforms['time'] = this._getTimeSpan() / 1000;
        uniforms['resolution'] = (0, $6BoVD).set(RESOLUTION$1, this._fbo.width, this._fbo.height);
        this.renderer.render(this._weatherShader, uniforms, null, this._fbo);
        this._renderMeshes = meshes;
        return this._fbo;
    }
    _renderMixFactor(meshes) {
        const options = {};
        const map = this.getMap();
        const zoom = map.getZoom();
        const ratio = Math.pow(2, DEFAULT_ZOOM - zoom);
        const config = this._layer.getWeatherConfig();
        const fogConfig = config.fog;
        if (!fogConfig || !fogConfig.enable) return null;
        const start = fogConfig.start || 0.1, end = fogConfig.end || 100;
        options['projMatrix'] = map.projMatrix;
        options['viewMatrix'] = map.viewMatrix;
        options['cameraPosition'] = map.cameraPosition;
        options['fogDist'] = [
            start * ratio,
            end * ratio
        ];
        options['rainDepth'] = map.altitudeToPoint(config.rain && config.rain.rainDepth || 0.1, map.getGLRes());
        const mixFactorMap = this._fogPass.render(meshes, options);
        const layerRenderer = this._layer.getRenderer();
        return layerRenderer._getFBOColor(mixFactorMap);
    }
    _renderRainRipples() {
        const map = this.getMap();
        const weatherConfig = this._layer.getWeatherConfig();
        const rippleRadius = weatherConfig.rain.rippleRadius || 24;
        const options = {};
        options['projMatrix'] = map.projMatrix;
        options['viewMatrix'] = map.viewMatrix;
        options['time'] = this._getTimeSpan() / 1000;
        options['rippleRadius'] = rippleRadius;
        options['density'] = weatherConfig.rain.density || 2000;
        const ripplesMap = this._rainRipplesPass.render(map, options);
        return ripplesMap;
    }
    _getTimeSpan() {
        if (!this._layer) return 0;
        if (this._currentFrameTime === undefined) this._currentFrameTime = 0;
        if (this.isPlaying()) {
            const render = this._layer.getRenderer();
            this._currentFrameTime = render.getFrameTime();
        }
        return this._currentFrameTime;
    }
    isEnable() {
        const weatherConfig = this._layer.getWeatherConfig();
        return weatherConfig && weatherConfig.enable;
    }
    isEnableRain() {
        const weatherConfig = this._layer.getWeatherConfig();
        return weatherConfig && weatherConfig.enable && weatherConfig.rain && weatherConfig.rain.enable;
    }
    isEnableFog() {
        const weatherConfig = this._layer.getWeatherConfig();
        return weatherConfig && weatherConfig.enable && weatherConfig.fog && weatherConfig.fog.enable;
    }
    isEnableSnow() {
        const weatherConfig = this._layer.getWeatherConfig();
        return weatherConfig && weatherConfig.enable && weatherConfig.snow && weatherConfig.snow.enable;
    }
    _showSnowGround() {
        const weatherConfig = this._layer.getWeatherConfig();
        return this.isEnableSnow() && weatherConfig.snow.showGround === false;
    }
    isPlaying() {
        const weatherConfig = this._layer.getWeatherConfig();
        if (weatherConfig) {
            if (weatherConfig.playing === false) return false;
            return true;
        }
        return false;
    }
    _hasWeather() {
        return this.isEnableRain() || this.isEnableFog() || this.isEnableSnow();
    }
    update() {
        if (!this.isEnable() && this._renderMeshes) this._renderMeshes.forEach((mesh)=>{
            delete mesh.defines['HAS_SNOW'];
            delete mesh.defines['HAS_RAIN'];
            delete mesh.defines['HAS_FOG'];
        });
        if (this.isEnableRain()) {
            this._rainPainter = this._rainPainter || new RainPainer(this._regl, this._layer);
            this._rainPainter.update();
        }
        if (this.isEnableSnow()) {
            this._snowPainter = this._snowPainter || new SnowPainter(this._regl, this._layer);
            this._snowPainter.update();
        }
    }
    getShadowMeshes() {
        return this._snowPainter.getMeshes();
    }
    _resize() {
        const width = this._width(), height = this._height();
        if (this._fbo && (this._fbo.width !== width || this._fbo.height !== height)) this._fbo.resize(width, height);
    }
    dispose() {
        if (this._fbo) this._fbo.destroy();
        if (this._weatherShader) {
            this._weatherShader.dispose();
            delete this._weatherShader;
        }
        if (this._rainPainter) {
            this._rainPainter.dispose();
            delete this._rainPainter;
        }
        if (this._snowPainter) {
            this._snowPainter.dispose();
            delete this._snowPainter;
        }
    }
}
const RESOLUTION = [];
const bloomFilter = (m)=>!!m.bloom;
const ssrFilter = (m)=>!!m.ssr;
class PostProcess {
    constructor(regl, layer){
        this._regl = regl;
        this._layer = layer;
        this._renderer = new $2wazW.Renderer(regl);
        this._fxaaShader = new $2wazW.FxaaShader();
        // this._taaPass = new reshader.TaaPass(this._renderer, jitter);
        this._copyShader = new $2wazW.CopyShader();
        this._ssrPass = new $2wazW.SsrPass(this._regl);
    }
    setContextIncludes() {
    // if (this._layer.getRenderer().isEnableSSAO() && this._ssaoPass && !context.ssao) {
    //     const ssao = {
    //         defines: reshader.SsrPass.getDefines(),
    //         uniformDeclares: reshader.SsrPass.getUniformDeclares()
    //     };
    //     ssao.renderUniforms = {
    //         prevProjViewMatrix: this._ssaoPass.getPrevProjViewMatrix(),
    //         sSsaoTexture: this._ssaoPass.getSsaoTexture()
    //     };
    //     context.ssao = ssao;
    //     context.includes.ssao = 1;
    // }
    }
    bloom(curTex, noAaTex, pointTex, threshold, bloomFactor, bloomRadius, enableAA) {
        if (!this._bloomPass) this._bloomPass = new $2wazW.BloomPass(this._regl);
        const renderer = this._layer.getRenderer();
        const bloomTex = renderer._getFBOColor(this._bloomFBO);
        return this._bloomPass.render(curTex, bloomTex, threshold, bloomFactor, bloomRadius, noAaTex, pointTex, enableAA);
    }
    drawBloom(depthTex) {
        const layerRenderer = this._layer.getRenderer();
        const regl = this._regl;
        const bloomFBO = this._bloomFBO;
        if (!bloomFBO) {
            const info = this._createFBOInfo(depthTex);
            this._bloomFBO = regl.framebuffer(info);
        } else {
            const { width, height } = depthTex;
            if (bloomFBO.width !== width || bloomFBO.height !== height) bloomFBO.resize(width, height);
            regl.clear({
                color: [
                    0,
                    0,
                    0,
                    0
                ],
                framebuffer: bloomFBO
            });
        }
        const timestamp = layerRenderer.getFrameTime();
        const event = layerRenderer.getFrameEvent();
        const context = layerRenderer.getFrameContext();
        const renderMode = context.renderMode;
        const sceneFilter = context.sceneFilter;
        const renderTarget = context.renderTarget;
        context.isPostProcess = true;
        context.renderMode = 'default';
        context['sceneFilter'] = bloomFilter;
        context.renderTarget = {
            fbo: this._bloomFBO,
            getFramebuffer: getFramebuffer$1,
            getDepthTexture: getDepthTexture$1
        };
        const fGL = layerRenderer.glCtx;
        fGL.resetDrawCalls();
        if (event) layerRenderer.forEachRenderer((renderer)=>{
            layerRenderer.clearStencil(renderer, bloomFBO);
            renderer.drawOnInteracting(event, timestamp, context);
        });
        else layerRenderer.forEachRenderer((renderer)=>{
            layerRenderer.clearStencil(renderer, bloomFBO);
            renderer.draw(timestamp, context);
        });
        delete context.isPostProcess;
        context.renderMode = renderMode;
        context.sceneFilter = sceneFilter;
        context.renderTarget = renderTarget;
        return fGL.getDrawCalls();
    }
    genSsrMipmap(tex, depthTex) {
        const projViewMatrix = this._layer.getMap().projViewMatrix;
        this._ssrPass.genMipMap(tex, depthTex, projViewMatrix);
    }
    getPrevSsrProjViewMatrix() {
        return this._ssrPass && this._ssrPass.getPrevProjViewMatrix();
    }
    drawSSR(depthTex, fbo, isCopyDepth) {
        if (isCopyDepth) this._ssrPass.copyDepthTex(depthTex);
        //遍历开启了ssr的mesh重新绘制一遍，并只绘制有ssr的像素，discard掉其他像素
        const layerRenderer = this._layer.getRenderer();
        const timestamp = layerRenderer.getFrameTime();
        const event = layerRenderer.getFrameEvent();
        const context = layerRenderer.getFrameContext();
        context.isPostProcess = true;
        context.ssr = this.getSSRContext();
        const renderMode = context.renderMode;
        const filter = context['sceneFilter'];
        context.renderMode = 'default';
        context['sceneFilter'] = ssrFilter;
        context.renderTarget.fbo = fbo;
        const fGL = layerRenderer.glCtx;
        let cleared = false;
        if (event) layerRenderer.forEachRenderer((renderer)=>{
            layerRenderer.clearStencil(renderer, fbo);
            if (!cleared) {
                fGL.resetDrawCalls();
                cleared = true;
            }
            renderer.drawOnInteracting(event, timestamp, context);
        });
        else layerRenderer.forEachRenderer((renderer)=>{
            layerRenderer.clearStencil(renderer, fbo);
            if (!cleared) {
                fGL.resetDrawCalls();
                cleared = true;
            }
            renderer.draw(timestamp, context);
        });
        const groundPainted = layerRenderer.drawGround();
        //以免和bloom冲突
        delete context.ssr;
        delete context.isPostProcess;
        context.renderMode = renderMode;
        context['sceneFilter'] = filter;
        this._ssrPainted = fGL.getDrawCalls() > 0;
        return groundPainted;
    }
    getSSRUniforms() {
        const sceneConfig = this._layer._getSceneConfig();
        const config = sceneConfig && sceneConfig.postProcess;
        const map = this._layer.getMap();
        return this._ssrPass.getSSRUniforms(map, config.ssr.factor, config.ssr.quality);
    }
    getSSRContext() {
        const sceneConfig = this._layer._getSceneConfig();
        const config = sceneConfig && sceneConfig.postProcess;
        const map = this._layer.getMap();
        const uniforms = this._ssrPass.getSSRUniforms(map, config.ssr.factor, config.ssr.quality);
        if (!uniforms) return null;
        const context = {
            renderUniforms: uniforms,
            defines: {
                'HAS_SSR': 1
            }
        };
        return context;
    }
    // taa(curTex, depthTex, {
    //     projMatrix, needClear
    // }) {
    //     const pass = this._taaPass;
    //     const outputTex = pass.render(
    //         curTex, depthTex,
    //         projMatrix, needClear
    //     );
    //     const redraw = pass.needToRedraw();
    //     return {
    //         outputTex,
    //         redraw
    //     };
    // }
    // isTaaNeedRedraw() {
    //     return this._taaPass.needToRedraw();
    // }
    // ssao(sourceTex, depthTex, uniforms) {
    //     if (!this._ssaoPass) {
    //         this._ssaoPass = new reshader.SsaoPass(this._renderer);
    //         this._layer.getRenderer().setToRedraw();
    //     }
    //     return this._ssaoPass.render({
    //         projMatrix: uniforms['projMatrix'],
    //         cameraNear: uniforms['cameraNear'],
    //         cameraFar: uniforms['cameraFar'],
    //         bias: uniforms['ssaoBias'],
    //         radius: uniforms['ssaoRadius'],
    //         intensity: uniforms['ssaoIntensity'],
    //         quality: 0.6
    //     }, sourceTex, depthTex);
    // }
    fxaa(fbo, source, enableFXAA, enableToneMapping, enableSharpen, pixelRatio, sharpFactor, textureOutline, highlightFactor, outlineFactor, outlineWidth, outlineColor) {
        if (fbo && (fbo.width !== source.fbo || fbo.height !== source.height)) fbo.resize(source.width, source.height);
        const shaderDefines = {};
        // if (taaTextureSource) {
        //     shaderDefines['HAS_TAA_TEX'] = 1;
        // } else {
        //     delete shaderDefines['HAS_TAA_TEX'];
        // }
        // if (fxaaTextureSource) {
        //     shaderDefines['HAS_FXAA_TEX'] = 1;
        // } else {
        //     delete shaderDefines['HAS_FXAA_TEX'];
        // }
        if (textureOutline) shaderDefines['HAS_OUTLINE_TEX'] = 1;
        else delete shaderDefines['HAS_OUTLINE_TEX'];
        // if (noAaSource) {
        //     shaderDefines['HAS_NOAA_TEX'] = 1;
        // } else {
        //     delete shaderDefines['HAS_NOAA_TEX'];
        // }
        // if (pointSource) {
        //     shaderDefines['HAS_POINT_TEX'] = 1;
        // } else {
        //     delete shaderDefines['HAS_POINT_TEX'];
        // }
        this._fxaaShader.setDefines(shaderDefines);
        this._renderer.render(this._fxaaShader, {
            textureSource: source,
            resolution: (0, $6BoVD).set(RESOLUTION, source.width, source.height),
            enableFXAA: enableFXAA,
            enableToneMapping: enableToneMapping,
            enableSharpen: enableSharpen,
            pixelRatio: pixelRatio,
            sharpFactor: sharpFactor,
            textureOutline: textureOutline,
            highlightFactor: highlightFactor,
            outlineFactor: outlineFactor,
            outlineWidth: outlineWidth,
            outlineColor: outlineColor
        }, null, fbo);
    }
    renderFBOToScreen(fbo, enableSharpen, sharpFactor, pixelRatio) {
        if (!this._copyFBOSize) this._copyFBOSize = [];
        this._copyFBOSize[0] = fbo.width;
        this._copyFBOSize[1] = fbo.height;
        const renderer = this._layer.getRenderer();
        this._renderer.render(this._copyShader, {
            texture: fbo.color && renderer._getFBOColor(fbo) || fbo,
            size: this._copyFBOSize,
            enableSharpen: +!!enableSharpen,
            sharpFactor: sharpFactor,
            pixelRatio: pixelRatio
        });
    }
    //filmic grain + vigenett
    postprocess(fbo, uniforms, src) {
        if (!this._postProcessShader) this._postProcessShader = new $2wazW.PostProcessShader();
        const renderer = this._layer && this._layer.getRenderer();
        const source = src || renderer._getFBOColor(fbo);
        uniforms['resolution'] = (0, $6BoVD).set(RESOLUTION, source.width, source.height);
        uniforms['textureSource'] = source;
        uniforms['timeGrain'] = performance.now();
        this._renderer.render(this._postProcessShader, uniforms);
        return this._target;
    }
    dispose() {
        if (this._bloomFBO) {
            this._bloomFBO.destroy();
            delete this._bloomFBO;
        }
        // if (this._taaPass) {
        //     this._taaPass.dispose();
        //     delete this._taaPass;
        // }
        // if (this._ssaoPass) {
        //     this._ssaoPass.dispose();
        //     delete this._ssaoPass;
        // }
        if (this._bloomPass) {
            this._bloomPass.dispose();
            delete this._bloomPass;
        }
        if (this._postProcessShader) {
            this._postProcessShader.dispose();
            delete this._postProcessShader;
        }
        if (this._fxaaShader) {
            this._fxaaShader.dispose();
            delete this._fxaaShader;
        }
        if (this._copyShader) {
            this._copyShader.dispose();
            delete this._copyShader;
        }
    }
    _createFBOInfo(depthTex, colorFormat) {
        const { width, height } = this._layer.getRenderer().canvas;
        const regl = this._regl;
        const renderer = this._layer.getRenderer();
        let color;
        if (renderer._isUseMultiSample()) color = regl.renderbuffer({
            width: width,
            height: height,
            samples: this._layer.options['multiSamples'],
            format: 'rgba8'
        });
        else color = regl.texture({
            min: 'nearest',
            mag: 'nearest',
            format: colorFormat || 'rgba',
            width: width,
            height: height
        });
        const fboInfo = {
            width: width,
            height: height,
            colors: [
                color
            ]
        };
        if (depthTex) fboInfo.depthStencil = depthTex;
        return fboInfo;
    }
}
function getFramebuffer$1(fbo) {
    return fbo['_framebuffer'].framebuffer;
}
function getDepthTexture$1(fbo) {
    //TODO 也可能是renderbuffer
    return fbo.depthStencil._texture.texture;
}
var vert$1 = "#if __VERSION__ == 300\n\t#define attribute in\n\t#define varying out\n#endif\nattribute vec2 aPosition;\nattribute vec2 aTexCoord;\nvarying vec2 vTexCoord;\nvoid main()\n{\n  gl_Position = vec4(aPosition, 0., 1.);\n  vTexCoord = aTexCoord;\n}";
var frag$1 = "#if __VERSION__ == 100\n  #ifdef GL_OES_standard_derivatives\n    #extension GL_OES_standard_derivatives : enable\n  #endif\n#endif\nprecision mediump float;\n#include <gl2_frag>\nvarying vec2 vTexCoord;\n#ifdef HAS_FLOODANALYSE\n    uniform vec3 flood_waterColor;\n    uniform float flood_waterOpacity;\n    uniform sampler2D floodMap;\n#endif\n#ifdef HAS_SKYLINE\n    uniform sampler2D skylineMap;\n#endif\n#ifdef HAS_VIEWSHED\n    uniform vec4 viewshed_visibleColor;\n    uniform vec4 viewshed_invisibleColor;\n    uniform sampler2D viewshedMap;\n#endif\n#ifdef HAS_INSIGHT\n    uniform vec4 insight_visibleColor;\n    uniform vec4 insight_invisibleColor;\n    uniform sampler2D insightMap;\n#endif\n#ifdef HAS_CUT\n    uniform sampler2D meshesMap;\n    uniform sampler2D invisibleMap;\n#endif\n#ifdef HAS_EXCAVATE\n    uniform sampler2D excavateMap;\n#endif\n#ifdef HAS_CROSSCUT\n    uniform sampler2D crosscutMap;\n    uniform vec4 cutLineColor;\n#endif\n#ifdef HAS_HEIGHTLIMIT\n    uniform vec3 limitColor;\n    uniform sampler2D heightLimitMap;\n#endif\nuniform sampler2D sceneMap;\nvoid main() {\n    vec4 sceneColor = texture2D(sceneMap, vTexCoord);\n    glFragColor = sceneColor;\n    #ifdef HAS_VIEWSHED\n        vec4 viewshedColor = texture2D(viewshedMap, vTexCoord);\n        if (viewshedColor.r > 0.99) {\n            glFragColor = vec4(mix(viewshed_invisibleColor.rgb, sceneColor.rgb, viewshed_invisibleColor.a), sceneColor.a);\n        } else if (viewshedColor.g > 0.99) {\n            glFragColor = vec4(mix(viewshed_visibleColor.rgb, sceneColor.rgb, viewshed_visibleColor.a), sceneColor.a);\n        } else if (viewshedColor.a < 0.01) {\n            glFragColor = vec4(viewshedColor.rgb, 1.0);\n        }\n    #endif\n    #ifdef HAS_FLOODANALYSE\n        vec4 floodColor = texture2D(floodMap, vTexCoord);\n        if (floodColor.r > 0.0) {\n            glFragColor = vec4(mix(glFragColor.rgb, flood_waterColor, flood_waterOpacity), glFragColor.a);\n        }\n    #endif\n    #ifdef HAS_SKYLINE\n        vec4 skylineColor = texture2D(skylineMap, vTexCoord);\n        if (skylineColor.r > 0.0 || skylineColor.g > 0.0 || skylineColor.b > 0.0) {\n            glFragColor = skylineColor;\n        }\n    #endif\n    #ifdef HAS_INSIGHT\n        vec4 insightColor = texture2D(insightMap, vTexCoord);\n        if (insightColor.g > 0.0) {\n            glFragColor = insight_visibleColor;\n        } else if (insightColor.r > 0.0) {\n            glFragColor = insight_invisibleColor;\n        }\n    #endif\n    #ifdef HAS_CUT\n        vec4 cutColor = texture2D(invisibleMap, vTexCoord);\n        vec4 meshesMapColor = texture2D(meshesMap, vTexCoord);\n        if (cutColor.r == 1.0 && cutColor.g == 0.0 && cutColor.b == 0.0) {\n            glFragColor = meshesMapColor;\n        } else if (cutColor.r == 0.0 && cutColor.g == 1.0 && cutColor.b == 0.0) {\n            glFragColor = meshesMapColor;\n        } else if (cutColor.r == 0.0 && cutColor.g == 0.0 && cutColor.b == 1.0) {\n          glFragColor = sceneColor;\n        }\n    #endif\n    #ifdef HAS_EXCAVATE\n        vec4 excavateColor = texture2D(excavateMap, vTexCoord);\n        if (excavateColor.r == 1.0 && excavateColor.g == 0.0 && excavateColor.b == 0.0) {\n          glFragColor = sceneColor;\n        }  else {\n          glFragColor = excavateColor;\n        }\n    #endif\n    #ifdef HAS_CROSSCUT\n        vec4 crosscutColor = texture2D(crosscutMap, vTexCoord);\n        if (crosscutColor.r > 0.0) {\n            glFragColor = vec4(mix(cutLineColor.rgb, glFragColor.rgb, 0.99), glFragColor.a);\n        }\n    #endif\n    #ifdef HAS_HEIGHTLIMIT\n        vec4 heightLimitColor = texture2D(heightLimitMap, vTexCoord);\n        if (heightLimitColor.r > 0.0) {\n            glFragColor = vec4(mix(limitColor, glFragColor.rgb, 0.6), glFragColor.a);\n        }\n    #endif\n    #if __VERSION__ == 100\n        gl_FragColor = glFragColor;\n    #endif\n}";
// import QuadShader from '../shader/QuadShader.js';
class AnalysisShader extends $2wazW.QuadShader {
    constructor(viewport){
        super({
            vert: vert$1,
            frag: frag$1,
            extraCommandProps: {
                viewport: viewport,
                cull: {
                    enable: true
                },
                blend: {
                    enable: true,
                    func: {
                        srcRGB: 'src alpha',
                        srcAlpha: 1,
                        dstRGB: 'one minus src alpha',
                        dstAlpha: 'one minus src alpha'
                    },
                    equation: 'add'
                }
            }
        });
    }
}
class AnalysisPainter {
    constructor(regl, layer, config){
        this._regl = regl;
        this._layer = layer;
        this._config = config;
        this._init();
    }
    _init() {
        this.renderer = new $2wazW.Renderer(this._regl);
        const layerRenderer = this._layer.getRenderer();
        const viewport = this._viewport = {
            x: 0,
            y: 0,
            width: ()=>{
                return layerRenderer.canvas ? layerRenderer.canvas.width : 1;
            },
            height: ()=>{
                return layerRenderer.canvas ? layerRenderer.canvas.height : 1;
            }
        };
        this._fbo = this._regl.framebuffer({
            color: this._regl.texture({
                width: layerRenderer.canvas ? layerRenderer.canvas.width : 1,
                height: layerRenderer.canvas ? layerRenderer.canvas.height : 1,
                wrap: 'clamp',
                mag: 'linear',
                min: 'linear'
            }),
            depth: true
        });
        this._shader = new AnalysisShader(viewport);
    }
    getMap() {
        return this._layer && this._layer.getMap();
    }
    paint(tex, layers) {
        if (!layers && layers.length) return tex;
        this._resize();
        const uniforms = {};
        const analysisTaskList = this._layer._analysisTaskList;
        if (!this._hasAnalysis()) return tex;
        this._regl.clear({
            color: [
                0,
                0,
                0,
                0
            ],
            depth: 1,
            stencil: 0,
            framebuffer: this._fbo
        });
        delete this._shader.shaderDefines['HAS_FLOODANALYSE'];
        delete this._shader.shaderDefines['HAS_VIEWSHED'];
        delete this._shader.shaderDefines['HAS_SKYLINE'];
        delete this._shader.shaderDefines['HAS_INSIGHT'];
        delete this._shader.shaderDefines['HAS_CUT'];
        delete this._shader.shaderDefines['HAS_CROSSCUT'];
        delete this._shader.shaderDefines['HAS_HEIGHTLIMIT'];
        for(let i = 0; i < analysisTaskList.length; i++){
            const task = analysisTaskList[i];
            if (!task.isEnable()) continue;
            const defines = task.getDefines();
            extend(this._shader.shaderDefines, defines);
            const map = this.getMap();
            const width = map.width, height = map.height;
            const toAanalysisMeshes = this._getToAnalysisMeshes(layers, task.getExcludeLayers());
            const analysisUniforms = task.renderAnalysis(toAanalysisMeshes, width, height);
            if (analysisUniforms) extend(uniforms, analysisUniforms);
        }
        uniforms['sceneMap'] = tex;
        this._shader.setDefines(this._shader.shaderDefines);
        this.renderer.render(this._shader, uniforms, null, this._fbo);
        return this._fbo;
    }
    _getToAnalysisMeshes(layers, excludeLayers) {
        let toAnalysisMeshes = [];
        for(let i = 0; i < layers.length; i++){
            if (excludeLayers.indexOf(layers[i].getId()) > -1) continue;
            const renderder = layers[i].getRenderer();
            if (renderder && renderder.getAnalysisMeshes) {
                const meshes = renderder.getAnalysisMeshes();
                meshes.forEach((mesh)=>{
                    mesh.setUniform('useAnalysis', 1);
                });
                toAnalysisMeshes = toAnalysisMeshes.concat(meshes);
            }
        }
        return toAnalysisMeshes;
    }
    _resize() {
        const width = (0, $gP1US.Util).isFunction(this._viewport.width.data) ? this._viewport.width.data() : this._viewport.width;
        const height = (0, $gP1US.Util).isFunction(this._viewport.height.data) ? this._viewport.height.data() : this._viewport.height;
        if (this._fbo && (this._fbo.width !== width || this._fbo.height !== height)) this._fbo.resize(width, height);
    }
    _hasAnalysis() {
        const tasks = this._layer && this._layer._analysisTaskList;
        if (!tasks) return false;
        for(let i = 0; i < tasks.length; i++){
            if (tasks[i].isEnable()) return true;
        }
        return false;
    }
}
const EMPTY_COLOR$1 = [
    0,
    0,
    0,
    0
];
const DEFAULT_LIGHT_DIRECTION = [
    1,
    1,
    -1
];
const MIN_SSR_PITCH = -0.001;
const NO_JITTER = [
    0,
    0
];
const noPostFilter = (m)=>!m.bloom && !m.ssr;
const noBloomFilter = (m)=>!m.bloom;
const noSsrFilter = (m)=>!m.ssr;
const SSR_STATIC = 1;
const SSR_IN_ONE_FRAME = 2;
class GroupGLLayerRenderer extends $gP1US.renderer.CanvasRenderer {
    setToRedraw() {
        this.setRetireFrames();
        super.setToRedraw();
    }
    onAdd() {
        super.onAdd();
        this.prepareCanvas();
    }
    updateSceneConfig() {
        if (this._groundPainter) this._groundPainter.update();
        if (this._envPainter) this._envPainter.update();
        if (this._weatherPainter) this._weatherPainter.update();
        this.setToRedraw();
    }
    render(...args) {
        if (!this.getMap() || !this.layer.isVisible()) return;
        this.forEachRenderer((renderer)=>{
            if (renderer['_replacedDrawFn']) return;
            renderer.draw = this._buildDrawFn(renderer.draw);
            renderer.drawOnInteracting = this._buildDrawOnInteractingFn(renderer.drawOnInteracting);
            renderer.setToRedraw = this._buildSetToRedrawFn(renderer.setToRedraw);
            renderer['_replacedDrawFn'] = true;
        });
        this.prepareRender();
        this.prepareCanvas();
        this.layer._updatePolygonOffset();
        this['_toRedraw'] = false;
        this._renderChildLayers('render', args);
        this._renderOutlines();
        this._postProcess();
    }
    prepareCanvas() {
        super.prepareCanvas();
        this.forEachRenderer((renderer)=>{
            renderer.prepareCanvas();
        });
    }
    drawOnInteracting(...args) {
        if (!this.getMap() || !this.layer.isVisible()) return;
        this.layer._updatePolygonOffset();
        this['_toRedraw'] = false;
        this._renderChildLayers('drawOnInteracting', args);
        this._renderOutlines();
        this._postProcess();
    }
    _renderChildLayers(methodName, args) {
        this._renderMode = 'default';
        const hasRenderTarget = this.hasRenderTarget();
        const drawContext = this._getDrawContext(args);
        if (hasRenderTarget) // reset renderTarget before drawing ground and child layers
        this._drawContext.renderTarget = this._getFramebufferTarget();
        this._envPainter.paint(drawContext);
        //如果放到图层后画，会出现透明图层下的ground消失的问题，#145
        this.drawGround(true);
        if (!hasRenderTarget) {
            this._renderInMode('default', null, methodName, args, true);
            return;
        }
        const fGL = this.glCtx;
        const sceneConfig = this.layer._getSceneConfig();
        const config = sceneConfig && sceneConfig.postProcess;
        const ssrMode = this.isSSROn();
        // const enableTAA = this.isEnableTAA();
        // const jitter = drawContext.jitter;
        drawContext.jitter = NO_JITTER;
        const groundConfig = this.layer.getGroundConfig();
        drawContext.hasSSRGround = !!(ssrMode && groundConfig && groundConfig.enable && groundConfig.symbol && groundConfig.symbol.ssr);
        fGL.resetDrawCalls();
        // this._renderInMode(enableTAA ? 'fxaaBeforeTaa' : 'fxaa', this._targetFBO, methodName, args);
        this._renderInMode('default', this._targetFBO, methodName, args);
        // this._fxaaDrawCount = fGL.getDrawCalls();
        // 重用上一帧的深度纹理，先绘制ssr图形
        // 解决因TAA jitter偏转，造成的ssr图形与taa图形的空白缝隙问题
        // #1545 SSR_ONE_FRAME模式里，建筑透明时，ssr后画会造成建筑后的ssr图形丢失，改为永远在每帧的开始，都绘制ssr图形
        if (ssrMode) this._postProcessor.drawSSR(this._blitDepthTex(), this._targetFBO);
        // if (enableTAA) {
        //     const map = this.getMap();
        //     const needRefresh = this._postProcessor.isTaaNeedRedraw() || this._needRetireFrames || map.getRenderer().isViewChanged();
        //     drawContext.jitter = needRefresh ? jitter : this._jitGetter.getAverage();
        //     drawContext.onlyUpdateDepthInTaa = !needRefresh;
        //     let taaFBO = this._taaFBO;
        //     if (!taaFBO) {
        //         const regl = this.regl;
        //         const info = this.createFBOInfo(config, this._depthTex);
        //         taaFBO = this._taaFBO = regl.framebuffer(info);
        //     } else if (taaFBO.width !== this._targetFBO.width || taaFBO.height !== this._targetFBO.height) {
        //         taaFBO.resize(this._targetFBO.width, this._targetFBO.height);
        //     }
        //     fGL.resetDrawCalls();
        //     this._renderInMode('taa', taaFBO, methodName, args);
        //     this._taaDrawCount = fGL.getDrawCalls();
        //     delete drawContext.onlyUpdateDepthInTaa;
        //     drawContext.jitter = NO_JITTER;
        //     let fxaaFBO = this._fxaaFBO;
        //     if (!fxaaFBO) {
        //         const regl = this.regl;
        //         const info = this.createFBOInfo(config, this._depthTex);
        //         fxaaFBO = this._fxaaFBO = regl.framebuffer(info);
        //     } else if (fxaaFBO.width !== this._targetFBO.width || fxaaFBO.height !== this._targetFBO.height) {
        //         fxaaFBO.resize(this._targetFBO.width, this._targetFBO.height);
        //     }
        //     fGL.resetDrawCalls();
        //     this._renderInMode('fxaaAfterTaa', this._fxaaFBO, methodName, args);
        //     this._fxaaAfterTaaDrawCount = fGL.getDrawCalls();
        // } else if (this._taaFBO) {
        //     this._taaFBO.destroy();
        //     this._fxaaFBO.destroy();
        //     delete this._taaFBO;
        //     delete this._fxaaFBO;
        //     delete this._fxaaAfterTaaDrawCount;
        // }
        // let tex = this._fxaaFBO ? this._getFBOColor(this._fxaaFBO) : this._getFBOColor(this._targetFBO);
        // bloom的绘制放在ssr之前，更新深度缓冲，避免ssr绘制时，深度值不正确
        const enableBloom = config.bloom && config.bloom.enable;
        if (enableBloom) this._bloomPainted = this._postProcessor.drawBloom(this._depthTex);
        // ssr如果放到noAa之后，ssr图形会遮住noAa中的图形
        if (ssrMode === SSR_IN_ONE_FRAME) this._postProcessor.drawSSR(this._blitDepthTex(), this._targetFBO, true);
        // noAa的绘制放在bloom后，避免noAa的数据覆盖了bloom效果
        fGL.resetDrawCalls();
        // this._renderInMode('noAa', this._noAaFBO, methodName, args);
        // this._noaaDrawCount = fGL.getDrawCalls();
        // fGL.resetDrawCalls();
        // this._renderInMode('point', this._pointFBO, methodName, args, true);
        this._weatherPainter.renderScene(drawContext);
        this._pointDrawCount = fGL.getDrawCalls();
    // return tex;
    }
    _renderInMode(mode, fbo, methodName, args, isFinalRender) {
        //noAA需要最后绘制，如果有noAa的图层，分为aa和noAa两个阶段分别绘制
        this._renderMode = mode;
        const drawContext = this._getDrawContext(args);
        drawContext.renderMode = this._renderMode;
        if (drawContext.renderTarget) drawContext.renderTarget.fbo = fbo;
        if (isFinalRender) drawContext.isFinalRender = true;
        this.forEachRenderer((renderer, layer)=>{
            if (!layer.isVisible()) return;
            // if (mode === 'default' ||
            //     !renderer.supportRenderMode && (mode === 'fxaa' || mode === 'fxaaAfterTaa') ||
            //     renderer.supportRenderMode && renderer.supportRenderMode(mode)) {
            //     this.clearStencil(renderer, fbo);
            //     renderer[methodName].apply(renderer, args);
            // }
            this.clearStencil(renderer, fbo);
            renderer[methodName].apply(renderer, args);
        });
    }
    _getDrawContext(args) {
        let timestamp = args[0];
        if (!isNumber(timestamp)) timestamp = args[1];
        if (timestamp !== this._contextFrameTime) {
            this.forEachRenderer((renderer, layer)=>{
                if (!layer.isVisible()) return;
                if (renderer.needRetireFrames && renderer.needRetireFrames()) this.setRetireFrames();
            });
            this._drawContext = this._prepareDrawContext(timestamp);
            this._contextFrameTime = timestamp;
            this._frameEvent = isNumber(args[0]) ? null : args[0];
        }
        return this._drawContext;
    }
    _renderOutlines() {
        if (!this.isEnableOutline()) return;
        const fbo = this._getOutlineFBO();
        const fGl = this.glCtx;
        fGl.resetDrawCalls();
        this.forEachRenderer((renderer, layer)=>{
            if (!layer.isVisible()) return;
            if (renderer.drawOutline) renderer.drawOutline(fbo);
        });
        this._outlineCounts = fGl.getDrawCalls();
    }
    _getOutlineFBO() {
        const { width, height } = this.canvas;
        let fbo = this._outlineFBO;
        if (!fbo) {
            const outlineTex = this.regl.texture({
                width: width,
                height: height,
                format: 'rgba4'
            });
            fbo = this._outlineFBO = this.regl.framebuffer({
                width: width,
                height: height,
                colors: [
                    outlineTex
                ],
                depth: false,
                stencil: false
            });
        } else if (width !== fbo.width || height !== fbo.height) fbo.resize(width, height);
        return fbo;
    }
    _getFBOColor(fbo) {
        if (this._isUseMultiSample()) {
            const blitFBO = this._getBlitFBO(fbo);
            if (blitFBO.width !== fbo.width || blitFBO.height !== fbo.height) blitFBO.resize(fbo.width, fbo.height);
            else this.regl.clear({
                color: [
                    0,
                    0,
                    0,
                    0
                ],
                fbo: blitFBO
            });
            blitFBO.blit(fbo);
            return blitFBO.color[0];
        } else return fbo.color[0];
    }
    _blitDepthTex() {
        if (this._depthTex.subimage) return this._depthTex;
        const { width, height } = this._depthTex;
        // multi sampled depth stencil renderbuffer
        if (!this._blitDepthFBO) {
            const regl = this.regl;
            const depthStencilTexture = regl.texture({
                min: 'nearest',
                mag: 'nearest',
                mipmap: false,
                type: 'depth stencil',
                width: width,
                height: height,
                format: 'depth stencil'
            });
            const rb = regl.renderbuffer({
                width: width,
                height: height,
                format: 'rgba4'
            });
            const info = {
                depthStencil: depthStencilTexture,
                colors: [
                    rb
                ],
                colorFormat: 'rgba4',
                width: width,
                height: height
            };
            this._blitDepthFBO = regl.framebuffer(info);
        }
        if (this._blitDepthFBO.width !== width || this._blitDepthFBO.height !== height) this._blitDepthFBO.resize(width, height);
        this.regl.clear({
            color: [
                0,
                0,
                0,
                0
            ],
            depth: 1,
            fbo: this._blitDepthFBO
        });
        this._blitDepthFBO.blit(this._targetFBO, 0x00000100, 'nearest');
        return this._blitDepthFBO.depthStencil;
    }
    _getBlitFBO(fbo) {
        if (!this._blitFBOs) this._blitFBOs = [];
        if (!fbo._blitFBO) {
            const info = this._createSimpleFBOInfo(true, fbo.width, fbo.height);
            const blitFbo = this.regl.framebuffer(info);
            this._blitFBOs.push(blitFbo);
            fbo._blitFBO = blitFbo;
        }
        return fbo._blitFBO;
    }
    _isUseMultiSample() {
        const regl = this.regl;
        const isWebGL2 = regl.limits['version'].indexOf('WebGL 2.0') === 0;
        return isWebGL2 && this.layer.options.antialias;
    }
    hasRenderTarget() {
        const sceneConfig = this.layer._getSceneConfig();
        const config = sceneConfig && sceneConfig.postProcess;
        if (!config || !config.enable) return false;
        return true;
    }
    testIfNeedRedraw() {
        if (this.layer.options['forceRedrawPerFrame']) return true;
        if (this['_toRedraw']) {
            this['_toRedraw'] = false;
            return true;
        }
        const map = this.getMap();
        if (map.isInteracting() && (this._groundPainter && this._groundPainter.isEnable() || this._envPainter && this._envPainter.isEnable())) return true;
        if (this._weatherPainter && this._weatherPainter.isEnable()) return true;
        const terrainLayer = this.layer.getTerrainLayer();
        if (terrainLayer) {
            const renderer = terrainLayer.getRenderer();
            if (renderer && renderer.testIfNeedRedraw()) {
                this._needUpdateSSR = true;
                return true;
            }
        }
        const layers = this._getLayers();
        for (const layer of layers){
            if (!layer) continue;
            const renderer = layer.getRenderer();
            if (renderer && renderer.testIfNeedRedraw()) {
                // 如果图层发生变化，保存的depthTexture可能发生变化，所以ssr需要多重绘一次，更新depthTexture
                this._needUpdateSSR = true;
                return true;
            }
        }
        return false;
    }
    // _isLayerEnableTAA(renderer) {
    //     return this.isEnableTAA() && renderer.supportRenderMode && renderer.supportRenderMode('taa');
    // }
    isRenderComplete() {
        const layers = this._getLayers();
        for (const layer of layers){
            const renderer = layer.getRenderer();
            if (renderer && !renderer.isRenderComplete()) return false;
        }
        return true;
    }
    mustRenderOnInteracting() {
        const layers = this._getLayers();
        for (const layer of layers){
            const renderer = layer.getRenderer();
            if (renderer && renderer.mustRenderOnInteracting()) return true;
        }
        return false;
    }
    isCanvasUpdated() {
        if (super.isCanvasUpdated()) return true;
        const layers = this._getLayers();
        for (const layer of layers){
            const renderer = layer.getRenderer();
            if (renderer && renderer.isCanvasUpdated()) return true;
        }
        return false;
    }
    isBlank() {
        if (this._groundPainter && this._groundPainter.isEnable()) return false;
        if (this._envPainter && this._envPainter.isEnable()) return false;
        const terrainLayer = this.layer.getTerrainLayer();
        if (terrainLayer) {
            const renderer = terrainLayer.getRenderer();
            if (renderer && !renderer.isBlank()) return false;
        }
        const layers = this._getLayers();
        for (const layer of layers){
            const renderer = layer.getRenderer();
            if (renderer && !renderer.isBlank()) return false;
        }
        return true;
    }
    createContext() {
        const layer = this.layer;
        const attributes = layer.options['glOptions'] || {
            alpha: true,
            depth: true,
            stencil: true
        };
        attributes.preserveDrawingBuffer = true;
        attributes.antialias = !!layer.options['antialias'];
        this.glOptions = attributes;
        const gl = this.gl = createGLContext(this.canvas, attributes, layer.options['onlyWebGL1']); // this.gl = gl;
        this._initGL(gl);
        gl.wrap = ()=>{
            return new (0, $KTgK2.GLContext)(this.gl);
        };
        this.glCtx = gl.wrap();
        this.canvas.gl = this.gl;
        this.reglGL = gl.wrap();
        this.regl = (0, (/*@__PURE__*/$parcel$interopDefault($9I15V)))({
            gl: this.reglGL,
            attributes: attributes,
            extensions: layer.options['extensions'],
            optionalExtensions: layer.options['optionalExtensions']
        });
        this.gl.regl = this.regl;
        this._jitter = [
            0,
            0
        ];
        this._groundPainter = new GroundPainter(this.regl, this.layer);
        this._envPainter = new EnvironmentPainter(this.regl, this.layer);
        const weatherConfig = this.layer.getWeatherConfig();
        this._weatherPainter = new WeatherPainter(this.regl, layer, weatherConfig);
        this._analysisPainter = new AnalysisPainter(this.regl, layer);
        const sceneConfig = this.layer._getSceneConfig() || {};
        const config = sceneConfig && sceneConfig.postProcess;
        const ratio = config && config.antialias && config.antialias.jitterRatio || 0.2;
        this._jitGetter = new $2wazW.Jitter(ratio);
        this._postProcessor = new PostProcess(this.regl, this.layer, this._jitGetter);
        this._shadowProcess = new ShadowProcess(this.regl, this.layer);
    }
    _initGL() {
        const layer = this.layer;
        const gl = this.gl;
        const extensions = layer.options['extensions'];
        if (extensions) extensions.forEach((ext)=>{
            gl.getExtension(ext);
        });
        const optionalExtensions = layer.options['optionalExtensions'];
        if (optionalExtensions) optionalExtensions.forEach((ext)=>{
            gl.getExtension(ext);
        });
        this.gl.clearColor(0.0, 0.0, 0.0, 0.0);
    }
    clearCanvas() {
        super.clearCanvas();
        this._clearFramebuffers();
    }
    _clearFramebuffers() {
        const regl = this.regl;
        if (this._targetFBO) regl.clear({
            color: EMPTY_COLOR$1,
            depth: 1,
            stencil: 0xFF,
            framebuffer: this._targetFBO
        });
        if (this._outlineFBO) regl.clear({
            color: EMPTY_COLOR$1,
            framebuffer: this._outlineFBO
        });
        regl.clear({
            color: EMPTY_COLOR$1,
            depth: 1,
            stencil: 0xFF
        });
    }
    resizeCanvas() {
        const width = this.canvas.width;
        const height = this.canvas.height;
        if (this._targetFBO && (this._targetFBO.width !== width || this._targetFBO.height !== height)) {
            super.resizeCanvas();
            this._targetFBO.resize(width, height);
            // this._noAaFBO.resize(width, height);
            // this._pointFBO.resize(width, height);
            // if (this._taaFBO) {
            //     this._taaFBO.resize(width, height);
            // }
            // if (this._fxaaFBO) {
            //     this._fxaaFBO.resize(width, height);
            // }
            this._clearFramebuffers();
            this.forEachRenderer((renderer)=>{
                if (renderer.canvas) renderer.resizeCanvas();
            });
        }
    }
    getCanvasImage() {
        this.forEachRenderer((renderer)=>{
            renderer.getCanvasImage();
        });
        return super.getCanvasImage();
    }
    _getLayers() {
        return this.layer._getLayers();
    }
    forEachRenderer(fn) {
        const layers = this._getLayers();
        for (const layer of layers){
            if (!layer.isVisible() || !layer.options['beneathTerrain']) continue;
            const renderer = layer.getRenderer();
            if (renderer) fn(renderer, layer);
        }
        const terrainLayer = this.layer.getTerrainLayer();
        if (terrainLayer) {
            const renderer = terrainLayer.getRenderer();
            if (renderer) fn(renderer, terrainLayer);
        }
        for (const layer of layers){
            if (!layer.isVisible() || layer.options['beneathTerrain']) continue;
            const renderer = layer.getRenderer();
            if (renderer) fn(renderer, layer);
        }
    }
    clearStencil(renderer, fbo) {
        const stencilValue = renderer.getStencilValue ? renderer.getStencilValue() : 0xFF;
        const config = {
            stencil: stencilValue
        };
        if (fbo) config['framebuffer'] = fbo;
        this.regl.clear(config);
    }
    onRemove() {
        //regl framebuffer for picking created by children layers
        if (this.canvas.pickingFBO && this.canvas.pickingFBO.destroy) this.canvas.pickingFBO.destroy();
        this._destroyFramebuffers();
        if (this._groundPainter) {
            this._groundPainter.dispose();
            delete this._groundPainter;
        }
        if (this._envPainter) {
            this._envPainter.dispose();
            delete this._envPainter;
        }
        if (this._shadowProcess) {
            this._shadowProcess.dispose();
            delete this._shadowProcess;
        }
        if (this._postProcessor) {
            this._postProcessor.dispose();
            delete this._postProcessor;
        }
        if (this._outlineFBO) {
            this._outlineFBO.destroy();
            delete this._outlineFBO;
        }
        if (this._weatherPainter) {
            this._weatherPainter.dispose();
            delete this._weatherPainter;
        }
        super.onRemove();
    }
    _destroyFramebuffers() {
        if (this._targetFBO) {
            this._targetFBO.destroy();
            // this._noAaFBO.destroy();
            // this._pointFBO.destroy();
            // if (this._taaFBO) {
            //     this._taaFBO.destroy();
            //     delete this._taaFBO;
            // }
            // if (this._fxaaFBO) {
            //     this._fxaaFBO.destroy();
            //     delete this._fxaaFBO;
            // }
            delete this._targetFBO;
            // delete this._noAaFBO;
            // delete this._pointFBO;
            if (this._postFBO) {
                this._postFBO.destroy();
                delete this._postFBO;
            }
            if (this._blitDepthFBO) {
                this._blitDepthFBO.destroy();
                delete this._blitDepthFBO;
            }
            if (this._blitFBOs) {
                for(let i = 0; i < this._blitFBOs.length; i++)if (this._blitFBOs[i]) this._blitFBOs[i].destroy();
                delete this._blitFBOs;
            }
        }
    }
    setRetireFrames() {
        this._needRetireFrames = true;
    }
    getFrameTime() {
        return this._contextFrameTime;
    }
    getFrameEvent() {
        return this._frameEvent;
    }
    getFrameContext() {
        return this._drawContext;
    }
    drawGround(forceRender) {
        const config = this.layer.getGroundConfig();
        if (!config || !config.enable) return false;
        if (!this._groundPainter) return false;
        const context = this.getFrameContext();
        const jitter = context.jitter;
        //地面绘制不用引入jitter，会导致地面的晃动
        context.jitter = NO_JITTER;
        // 1 是留给开启了ssr的图形的
        const polygonOffsetCount = this.layer.getPolygonOffsetCount();
        // 加一是为了防止有ssr的图形的polygonOffset被设置成1
        context.offsetFactor = polygonOffsetCount + 1;
        context.offsetUnits = polygonOffsetCount + 1;
        let sceneFilter;
        if (forceRender) {
            // 第一次绘制 ground 应该忽略 sceneFilter
            // 否则 noSSRFilter 会把 ground 过滤掉
            // 但当场景有透明物体时，物体背后没画ground，出现绘制问题。
            sceneFilter = context.sceneFilter;
            delete context.sceneFilter;
        }
        const drawn = this._groundPainter.paint(context);
        if (this._groundPainter.needToRedraw()) this.setToRedraw();
        if (sceneFilter) context.sceneFilter = sceneFilter;
        context.jitter = jitter;
        return drawn;
    }
    _buildDrawFn(drawMethod) {
        const me = this;
        //drawBloom中会手动创建context
        return function(timestamp, context) {
            context = context || me._drawContext;
            const hasRenderTarget = context && context.renderTarget;
            if (hasRenderTarget) {
                context.renderTarget.getFramebuffer = getFramebuffer;
                context.renderTarget.getDepthTexture = getDepthTexture;
            }
            return drawMethod.call(this, timestamp, context);
        };
    }
    _buildDrawOnInteractingFn(drawMethod) {
        const me = this;
        //drawBloom中会手动创建context
        return function(event, timestamp, context) {
            context = context || me._drawContext;
            const hasRenderTarget = context && context.renderTarget;
            if (hasRenderTarget) {
                context.renderTarget.getFramebuffer = getFramebuffer;
                context.renderTarget.getDepthTexture = getDepthTexture;
            }
            return drawMethod.call(this, event, timestamp, context);
        };
    }
    _buildSetToRedrawFn(fn) {
        return function(...args) {
            return fn.apply(this, args);
        };
    }
    isEnableSSR() {
        const sceneConfig = this.layer._getSceneConfig();
        const config = sceneConfig && sceneConfig.postProcess;
        return config && config.enable && config.ssr && config.ssr.enable;
    }
    isSSROn() {
        const enable = this.isEnableSSR();
        const map = this.getMap();
        if (!enable || map.getPitch() <= MIN_SSR_PITCH) return 0;
        const projViewMat = map.projViewMatrix;
        const prevSsrMat = this._postProcessor.getPrevSsrProjViewMatrix();
        return prevSsrMat && (0, $3iqbd).exactEquals(prevSsrMat, projViewMat) ? SSR_STATIC : SSR_IN_ONE_FRAME;
    // return SSR_IN_ONE_FRAME;
    // SSR_STATIC的思路是直接利用上一帧的深度纹理，来绘制ssr，这样无需额外的ssr pass。
    // 但当场景里有透明的物体时，被物体遮住的倒影会在SSR_STATIC阶段中绘制，但在SSR_IN_ONE_FRAME中不绘制，出现闪烁，故取消SSR_STATIC
    // 2021-01-11 fuzhen 该问题通过在ssr shader中，通过手动比较深度值，决定是否绘制解决
    // 2021-02-05 fuzhen 通过在drawSSR前copyDepth，ssr统一在StandardShader中绘制，不再需要ssr后处理, 之后SSR_IN_ONE_FRAME相比SSR_STATIC，只是多了drawSSR
    // 2021-02-07 fuzhen ssr绘制顺序不同，会导致一些绘制问题，改为统一用SSR_IN_ONE_FRAME
    // 2021-02-11 fuzhen 重新分为SSR_STATIC和SSR_IN_ONE_FRAME，SSR_STATIC时重用上一帧depth纹理，在taa前绘制ssr图形，解决taa抖动造成的ssr图形边缘缝隙问题
    }
    isEnableTAA() {
        // const sceneConfig =  this.layer._getSceneConfig();
        // const config = sceneConfig && sceneConfig.postProcess;
        // return config && config.antialias && config.antialias.enable && config.antialias.taa;
        return false;
    }
    isEnableSSAO() {
        // const sceneConfig =  this.layer._getSceneConfig();
        // const config = sceneConfig && sceneConfig.postProcess;
        // return config && config.enable && config.ssao && config.ssao.enable;
        return false;
    }
    isEnableOutline() {
        const sceneConfig = this.layer._getSceneConfig();
        const config = sceneConfig && sceneConfig.postProcess;
        return config && config.enable && config.outline && config.outline.enable;
    }
    isEnableWeather() {
        const sceneConfig = this.layer._getSceneConfig();
        const config = sceneConfig && sceneConfig.weather;
        return config && config.enable;
    }
    _getViewStates() {
        const map = this.layer.getMap();
        const renderedView = this._renderedView;
        if (!renderedView) {
            this._renderedView = {
                center: map.getCenter(),
                bearing: map.getBearing(),
                pitch: map.getPitch(),
                res: map.getResolution()
            };
            let lightDirectionChanged = false;
            if (map.options.lights) {
                const lightManager = map.getLightManager();
                const lightDirection = lightManager.getDirectionalLight().direction || DEFAULT_LIGHT_DIRECTION;
                this._renderedView.lightDirection = (0, $eIStk).copy([], lightDirection);
                lightDirectionChanged = true;
            }
            return {
                viewChanged: true,
                lightDirectionChanged: lightDirectionChanged
            };
        }
        const res = map.getResolution();
        const scale = res / this._renderedView.res;
        // const maxPitch = map.options['cascadePitches'][2];
        // const pitch = map.getPitch();
        const cp = map.coordToContainerPoint(this._renderedView.center);
        const viewMoveThreshold = this.layer.options['viewMoveThreshold'];
        // const viewPitchThreshold = this.layer.options['viewPitchThreshold'];
        const viewChanged = cp['_sub'](map.width / 2, map.height / 2).mag() > viewMoveThreshold || scale < 0.95 || scale > 1.05;
        // Math.abs(renderedView.bearing - map.getBearing()) > 30 ||
        // (renderedView.pitch < maxPitch || pitch < maxPitch) && Math.abs(renderedView.pitch - pitch) > viewPitchThreshold;
        let lightDirectionChanged = false;
        if (map.options.lights) {
            const lightManager = map.getLightManager();
            const lightDirection = lightManager.getDirectionalLight().direction || DEFAULT_LIGHT_DIRECTION;
            lightDirectionChanged = !(0, $eIStk).equals(this._renderedView.lightDirection, lightDirection);
            if (lightDirectionChanged) this._renderedView.lightDirection = (0, $eIStk).copy([], lightDirection);
        }
        //update renderView
        if (viewChanged) {
            this._renderedView.center = map.getCenter();
            this._renderedView.bearing = map.getBearing();
            this._renderedView.pitch = map.getPitch();
            this._renderedView.res = map.getResolution();
        }
        return {
            viewChanged: viewChanged,
            lightDirectionChanged: lightDirectionChanged
        };
    }
    _prepareDrawContext(timestamp) {
        const sceneConfig = this.layer._getSceneConfig();
        const config = sceneConfig && sceneConfig.postProcess;
        const weatherConfig = sceneConfig && sceneConfig.weather;
        const context = {
            timestamp: timestamp,
            renderMode: this._renderMode || 'default',
            includes: {},
            states: this._getViewStates(),
            testSceneFilter: (mesh)=>{
                return !context.sceneFilter || context.sceneFilter(mesh);
            },
            isFinalRender: false,
            weather: {
                fog: weatherConfig && weatherConfig.fog
            }
        };
        const ratio = config && config.antialias && config.antialias.jitterRatio || 0.2;
        const jitGetter = this._jitGetter;
        if (jitGetter) jitGetter.setRatio(ratio);
        const ssrMode = this.isSSROn();
        let renderTarget;
        if (!config || !config.enable) this._destroyFramebuffers();
        else {
            const hasJitter = this.isEnableTAA();
            if (hasJitter) {
                const map = this.getMap();
                if (map.isInteracting() || this._needRetireFrames) jitGetter.reset();
                jitGetter.getJitter(this._jitter);
                jitGetter.frame();
            } else (0, $6BoVD).set(this._jitter, 0, 0);
            context['jitter'] = this._jitter;
            const enableBloom = config.bloom && config.bloom.enable;
            if (enableBloom && ssrMode) {
                context['bloom'] = 1;
                context['sceneFilter'] = noPostFilter;
            } else if (enableBloom) {
                context['bloom'] = 1;
                context['sceneFilter'] = noBloomFilter;
            } else if (ssrMode) context['sceneFilter'] = noSsrFilter;
            renderTarget = this._getFramebufferTarget();
            if (renderTarget) context.renderTarget = renderTarget;
        }
        if (this._renderMode !== 'noAa') {
            this._shadowContext = this._prepareShadowContext(context);
            if (this._shadowContext) context.includes.shadow = 1;
            this._includesState = this._updateIncludesState(context);
        }
        if (this._shadowContext) {
            context.shadow = this._shadowContext;
            context.includes.shadow = 1;
        }
        context.states.includesChanged = this._includesState;
        if (config && config.enable && this._postProcessor) this._postProcessor.setContextIncludes(context);
        // 2021-02-20 ssr的绘制全部统一到了drawSSR中，而不会在平时的绘制阶段绘制ssr了
        // if (ssrMode === SSR_STATIC) {
        //     const ssr = this._postProcessor.getSSRContext();
        //     if (ssr) {
        //         context.ssr = ssr;
        //     }
        // }
        return context;
    }
    _renderAnalysis(tex) {
        const layers = this._getLayers().filter((layer)=>{
            return layer.isVisible();
        });
        if (this.layer.getTerrainLayer()) layers.push(this.layer.getTerrainLayer());
        return this._analysisPainter.paint(tex, layers);
    }
    _updateIncludesState(context) {
        let state = false;
        const includeKeys = Object.keys(context.includes);
        const prevKeys = this._prevIncludeKeys;
        if (prevKeys) {
            const difference = includeKeys.filter((x)=>prevKeys.indexOf(x) === -1).concat(prevKeys.filter((x)=>includeKeys.indexOf(x) === -1));
            if (difference.length) state = difference.reduce((accumulator, currentValue)=>{
                accumulator[currentValue] = 1;
                return accumulator;
            }, {});
        }
        this._prevIncludeKeys = includeKeys;
        return state;
    }
    _prepareShadowContext(context) {
        const sceneConfig = this.layer._getSceneConfig();
        if (!sceneConfig || !sceneConfig.shadow || !sceneConfig.shadow.enable) {
            if (this._shadowProcess) {
                this._shadowProcess.dispose();
                delete this._shadowProcess;
            }
            return null;
        }
        if (!this._shadowProcess) this._shadowProcess = new ShadowProcess(this.regl, this.layer);
        const shadow = {
            config: sceneConfig.shadow,
            defines: this._shadowProcess.getDefines(),
            uniformDeclares: ShadowProcess.getUniformDeclares()
        };
        shadow.renderUniforms = this._renderShadow(context);
        return shadow;
    }
    _renderShadow(context) {
        const fbo = context.renderTarget && context.renderTarget.fbo;
        const sceneConfig = this.layer._getSceneConfig();
        const meshes = [];
        let forceUpdate = context.states.lightDirectionChanged || context.states.viewChanged;
        this.forEachRenderer((renderer, layer)=>{
            if (!renderer.getShadowMeshes || !layer.isVisible()) return;
            const shadowMeshes = renderer.getShadowMeshes();
            if (Array.isArray(shadowMeshes)) for(let i = 0; i < shadowMeshes.length; i++){
                if (!shadowMeshes[i]) continue;
                if (shadowMeshes[i].needUpdateShadow) {
                    forceUpdate = true;
                    shadowMeshes[i].needUpdateShadow = false;
                }
                if (shadowMeshes[i].hasFunctionUniform) {
                    if (!shadowMeshes[i].hasFunctionUniform('minAltitude')) shadowMeshes[i].setFunctionUniform('minAltitude', ()=>{
                        return layer && layer.options.altitude || 0;
                    });
                    meshes.push(shadowMeshes[i]);
                }
            }
        });
        // if (!meshes.length) {
        //     return null;
        // }
        if (!this._shadowScene) this._shadowScene = new $2wazW.Scene();
        this._shadowScene.setMeshes(meshes);
        const map = this.getMap();
        const shadowConfig = sceneConfig.shadow;
        const lightManager = map.getLightManager();
        const lightDirection = lightManager && lightManager.getDirectionalLight().direction || DEFAULT_LIGHT_DIRECTION;
        const displayShadow = !sceneConfig.ground || !sceneConfig.ground.enable;
        const uniforms = this._shadowProcess.render(displayShadow, map.projMatrix, map.viewMatrix, shadowConfig.color, shadowConfig.opacity, lightDirection, this._shadowScene, this._jitter, fbo, forceUpdate);
        // if (this._shadowProcess.isUpdated()) {
        //     this.setRetireFrames();
        // }
        return uniforms;
    }
    _renderWeather(tex) {
        let meshes = [];
        this.forEachRenderer((renderer, layer)=>{
            if (!renderer.getAnalysisMeshes || !layer.isVisible()) return;
            const renderMeshes = renderer.getAnalysisMeshes();
            meshes = meshes.concat(renderMeshes);
        });
        if (this._groundPainter) {
            const groundMesh = this._groundPainter.getRenderMeshes();
            meshes = meshes.concat(groundMesh);
        }
        const weatherConfig = this.layer.getWeatherConfig();
        return this._weatherPainter.paint(tex, meshes, weatherConfig);
    }
    getGroundMesh() {
        if (this._groundPainter) {
            const groundMesh = this._groundPainter.getRenderMeshes();
            return groundMesh;
        }
        return [];
    }
    _getFramebufferTarget() {
        const sceneConfig = this.layer._getSceneConfig();
        const config = sceneConfig && sceneConfig.postProcess;
        if (!this._targetFBO) {
            const regl = this.regl;
            let depthTex = this._depthTex;
            if (!depthTex || !depthTex['_texture'] || depthTex['_texture'].refCount <= 0) depthTex = null;
            const fboInfo = this.createFBOInfo(config, depthTex);
            this._depthTex = fboInfo.depth || fboInfo.depthStencil;
            this._targetFBO = regl.framebuffer(fboInfo);
            // const noAaInfo = this.createFBOInfo(config, this._depthTex);
            // this._noAaFBO = regl.framebuffer(noAaInfo);
            // const pointInfo = this.createFBOInfo(config, this._depthTex);
            // this._pointFBO = regl.framebuffer(pointInfo);
            this._clearFramebuffers();
        }
        return {
            fbo: this._targetFBO
        };
    }
    _createSimpleFBOInfo(forceTexture, width, height) {
        width = width || this.canvas.width, height = height || this.canvas.height;
        const regl = this.regl;
        const useMultiSamples = this._isUseMultiSample();
        let color;
        if (!forceTexture && useMultiSamples) color = regl.renderbuffer({
            width: width,
            height: height,
            samples: this.layer.options['multiSamples'],
            format: 'rgba8'
        });
        else {
            const type = 'uint8'; //colorType || regl.hasExtension('OES_texture_half_float') ? 'float16' : 'float';
            color = regl.texture({
                min: 'nearest',
                mag: 'nearest',
                type: type,
                width: width,
                height: height
            });
        }
        const fboInfo = {
            width: width,
            height: height,
            colors: [
                color
            ],
            // stencil: true,
            // colorCount,
            colorFormat: useMultiSamples ? 'rgba8' : 'rgba'
        };
        return fboInfo;
    }
    createFBOInfo(config, depthTex) {
        let { width, height } = this.canvas;
        width = width || 1;
        height = height || 1;
        const regl = this.regl;
        const fboInfo = this._createSimpleFBOInfo();
        const useMultiSamples = this._isUseMultiSample();
        const enableDepthTex = regl.hasExtension('WEBGL_depth_texture');
        if (useMultiSamples) {
            const renderbuffer = depthTex || regl.renderbuffer({
                width: width,
                height: height,
                format: 'depth24 stencil8',
                samples: this.layer.options['multiSamples']
            });
            fboInfo.depthStencil = renderbuffer;
        } else //depth(stencil) buffer 是可以共享的
        if (enableDepthTex) {
            const depthStencilTexture = depthTex || regl.texture({
                min: 'nearest',
                mag: 'nearest',
                mipmap: false,
                type: 'depth stencil',
                width: width,
                height: height,
                format: 'depth stencil'
            });
            fboInfo.depthStencil = depthStencilTexture;
        } else {
            const renderbuffer = depthTex || regl.renderbuffer({
                width: width,
                height: height,
                format: 'depth stencil'
            });
            fboInfo.depthStencil = renderbuffer;
        }
        return fboInfo;
    }
    _postProcess() {
        if (!this._targetFBO) {
            this._needRetireFrames = false;
            return;
        }
        const sceneConfig = this.layer._getSceneConfig();
        const config = sceneConfig && sceneConfig.postProcess;
        if (!config || !config.enable) {
            if (this.isEnableWeather()) throw new Error('you must enable the post process to turn on weather');
            return;
        }
        this.layer.fire('postprocessstart');
        const map = this.layer.getMap();
        // const enableTAA = this.isEnableTAA();
        // let taaTex;
        // if (enableTAA) {
        //     const needClear = this._needRetireFrames || map.getRenderer().isViewChanged();
        //     if (needClear) {
        //         this.layer.fire('taastart');
        //     }
        //     const { outputTex, redraw } = this._postProcessor.taa(this._getFBOColor(this._taaFBO), this._blitDepthTex(), {
        //         projMatrix: map.projMatrix,
        //         needClear
        //     });
        //     taaTex = outputTex;
        //     if (redraw) {
        //         this.setToRedraw();
        //     } else {
        //         this.layer.fire('taaend');
        //     }
        //     this._needRetireFrames = false;
        // }
        let sharpFactor = config.sharpen && config.sharpen.factor;
        if (!sharpFactor && sharpFactor !== 0) sharpFactor = 0.2; // 0 - 5
        let enableOutline = 0;
        let highlightFactor = 0.2;
        let outlineFactor = 0.3;
        let outlineWidth = 1;
        let outlineColor = [
            1,
            1,
            0
        ];
        if (config.outline) {
            enableOutline = +!!config.outline.enable;
            highlightFactor = getValueOrDefault(config.outline, 'highlightFactor', highlightFactor);
            outlineFactor = getValueOrDefault(config.outline, 'outlineFactor', outlineFactor);
            outlineWidth = getValueOrDefault(config.outline, 'outlineWidth', outlineWidth);
            outlineColor = getValueOrDefault(config.outline, 'outlineColor', outlineColor);
        }
        // const enableSSAO = this.isEnableSSAO();
        const enableSSR = config.ssr && config.ssr.enable;
        const enableBloom = config.bloom && config.bloom.enable;
        // const bloomPainted = enableBloom && this._bloomPainted;
        // const enableAntialias = +!!(config.antialias && config.antialias.enable);
        const enableAnalysis = this._analysisPainter._hasAnalysis();
        const enableWeather = this._weatherPainter._hasWeather();
        const hasPost = /* enableSSAO ||  */ enableBloom || enableSSR || enableAnalysis || enableWeather;
        let postFBO = this._postFBO;
        if (hasPost) {
            if (!postFBO) {
                const info = this._createSimpleFBOInfo();
                if (this._isUseMultiSample()) info.depthStencil = this.regl.renderbuffer({
                    width: this.canvas.width,
                    height: this.canvas.height,
                    samples: this.layer.options['multiSamples'],
                    format: 'depth24 stencil8'
                });
                postFBO = this._postFBO = this.regl.framebuffer(info);
            }
            const { width, height } = this.canvas;
            if (postFBO.width !== width || postFBO.height !== height) postFBO.resize(width, height);
        } else {
            postFBO = null;
            if (this._postFBO) {
                this._postFBO.destroy();
                delete this._postFBO;
            }
        }
        let tex = this._getFBOColor(this._targetFBO);
        // const noAaTex = this._noaaDrawCount && this._getFBOColor(this._noAaFBO);
        // const pointTex = this._pointDrawCount && this._getFBOColor(this._pointFBO);
        // const enableFXAA = config.antialias && config.antialias.enable && (config.antialias.fxaa || config.antialias.fxaa === undefined);
        // 2024-10-09 disable fxaa to ensure layer's render order except for ssr/bloom/outline, maptalks/issues#750
        this._postProcessor.fxaa(postFBO, tex, 0, // +!!enableFXAA,
        // 1,
        +!!(config.toneMapping && config.toneMapping.enable), +!!(!hasPost && config.sharpen && config.sharpen.enable), map.getDevicePixelRatio(), sharpFactor, enableOutline && this._outlineCounts > 0 && this._getOutlineFBO(), highlightFactor, outlineFactor, outlineWidth, outlineColor);
        if (postFBO) tex = this._getFBOColor(postFBO);
        // if (enableSSAO && (this._fxaaAfterTaaDrawCount || this._taaDrawCount || this._fxaaDrawCount)) {
        //     //TODO 合成时，SSAO可能会被fxaaFBO上的像素遮住
        //     //generate ssao texture for the next frame
        //     tex = this._postProcessor.ssao(tex, this._blitDepthTex(), {
        //         projMatrix: map.projMatrix,
        //         cameraNear: map.cameraNear,
        //         cameraFar: map.cameraFar,
        //         ssaoBias: config.ssao && config.ssao.bias || 10,
        //         ssaoRadius: config.ssao && config.ssao.radius || 100,
        //         ssaoIntensity: config.ssao && config.ssao.intensity || 0.5
        //     });
        // }
        if (enableBloom && this._bloomPainted) {
            const bloomConfig = config.bloom;
            const threshold = +bloomConfig.threshold || 0;
            const factor = getValueOrDefault(bloomConfig, 'factor', 1);
            const radius = getValueOrDefault(bloomConfig, 'radius', 1);
            tex = this._postProcessor.bloom(tex, null, null, threshold, factor, radius, 0);
        }
        if (enableSSR) {
            this._postProcessor.genSsrMipmap(tex, this._blitDepthTex());
            if (this._needUpdateSSR) {
                const needRetireFrames = this._needRetireFrames;
                this.setToRedraw();
                this._needRetireFrames = needRetireFrames;
                this._needUpdateSSR = false;
            }
        }
        if (this._analysisPainter) tex = this._renderAnalysis(tex);
        if (this.isEnableWeather()) tex = this._renderWeather(tex);
        if (hasPost) this._postProcessor.renderFBOToScreen(tex, +!!(config.sharpen && config.sharpen.enable), sharpFactor, map.getDevicePixelRatio());
        this.layer.fire('postprocessend');
    }
}
function isNil(obj) {
    return obj == null;
}
function isNumber(val) {
    return typeof val === 'number' && !isNaN(val);
}
function getFramebuffer(fbo) {
    return fbo['_framebuffer'].framebuffer;
}
function getDepthTexture(fbo) {
    //TODO 也可能是renderbuffer
    return fbo.depthStencil._texture.texture;
}
function getValueOrDefault(v, key, defaultValue) {
    if (isNil(v[key])) return defaultValue;
    return v[key];
}
class TerrainWorkerConnection extends $gP1US.worker.Actor {
    constructor(mapId){
        super('@maptalks/terrain');
        this.mapId = mapId;
    }
    checkUrl(url) {
        if (!url || !$gP1US.Util.isString(url)) return url;
        //The URL is processed. Here, only the relative protocol is processed
        return $gP1US.Util.getAbsoluteURL(url);
    }
    fetchTerrain(url, options, cb) {
        url = this.checkUrl(url);
        const data = {
            actorId: this.actorId,
            mapId: this.mapId,
            command: 'fetchTerrain',
            params: {
                url: url,
                origin: location.origin,
                terrainWidth: options.terrainWidth,
                type: options.type,
                accessToken: options.accessToken,
                cesiumIonTokenURL: options.cesiumIonTokenURL,
                error: options.error,
                colors: options.colors,
                tileSize: options.tileSize
            }
        };
        this.send(data, null, (err, data)=>{
            if (err) {
                cb(err);
                return;
            }
            cb(err, data);
        });
    }
    abortTerrain(url, cb) {
        const data = {
            actorId: this.actorId,
            mapId: this.mapId,
            command: 'abortTerrain',
            params: {
                url: url
            }
        };
        this.broadcast(data, null, cb);
    }
    addLayer(layerId, options, cb) {
        const data = {
            actorId: this.actorId,
            mapId: this.mapId,
            layerId: layerId,
            command: 'addLayer',
            params: {}
        };
        this.broadcast(data, null, cb);
    }
    createTerrainMesh(params, cb) {
        const data = {
            actorId: this.actorId,
            command: 'createTerrainMesh',
            params: params
        };
        this.send(data, [
            params.terrainHeights.data.buffer
        ], (err, data)=>{
            if (err) {
                cb(err);
                return;
            }
            cb(err, data);
        });
    }
    removeLayer(layerId, options, cb) {
        const data = {
            mapId: this.mapId,
            layerId: layerId,
            command: 'removeLayer'
        };
        this.broadcast(data, null, cb);
    }
}
var skinVert = "#define SHADER_NAME TERRAIN_SKIN\nattribute vec2 aPosition;\nvoid main() {\n    gl_Position = vec4(aPosition, 0.0, 1.0);\n}";
var skinFrag = "#define SHADER_NAME TERRAIN_SKIN\nprecision mediump float;\nuniform float tileSize;\nuniform sampler2D skinTexture;\nuniform vec3 skinDim;\nuniform float opacity;\nvoid main() {\n    vec2 fragCoord = gl_FragCoord.xy / 2.0;\n    vec2 resolution = vec2(tileSize);\n    vec2 uv = (fragCoord - skinDim.xy) /  (resolution * skinDim.z);\n    if (uv.x >= 0.0 && uv.x <= 1.0 && uv.y >= 0.0 && uv.y <= 1.0) {\n        gl_FragColor = texture2D(skinTexture, uv) * opacity;\n    } else {\n        gl_FragColor = vec4(0.0);\n    }\n}";
class Martini {
    constructor(gridSize = 257){
        this.gridSize = gridSize;
        const tileSize = gridSize - 1;
        if (tileSize & tileSize - 1) throw new Error(`Expected grid size to be 2^n+1, got ${gridSize}.`);
        this.numTriangles = tileSize * tileSize * 2 - 2;
        this.numParentTriangles = this.numTriangles - tileSize * tileSize;
        this.indices = new Uint32Array(this.gridSize * this.gridSize);
        // coordinates for all possible triangles in an RTIN tile
        this.coords = new Uint16Array(this.numTriangles * 4);
        // get triangle coordinates from its index in an implicit binary tree
        for(let i = 0; i < this.numTriangles; i++){
            let id = i + 2;
            let ax = 0, ay = 0, bx = 0, by = 0, cx = 0, cy = 0;
            if (id & 1) bx = by = cx = tileSize; // bottom-left triangle
            else ax = ay = cy = tileSize; // top-right triangle
            while((id >>= 1) > 1){
                const mx = ax + bx >> 1;
                const my = ay + by >> 1;
                if (id & 1) {
                    bx = ax;
                    by = ay;
                    ax = cx;
                    ay = cy;
                } else {
                    ax = bx;
                    ay = by;
                    bx = cx;
                    by = cy;
                }
                cx = mx;
                cy = my;
            }
            const k = i * 4;
            this.coords[k + 0] = ax;
            this.coords[k + 1] = ay;
            this.coords[k + 2] = bx;
            this.coords[k + 3] = by;
        }
    }
    createTile(terrain) {
        return new Tile(terrain, this);
    }
}
class Tile {
    constructor(terrain, martini){
        const size = martini.gridSize;
        if (terrain.length !== size * size) throw new Error(`Expected terrain data of length ${size * size} (${size} x ${size}), got ${terrain.length}.`);
        this.terrain = terrain;
        this.martini = martini;
        this.errors = new Float32Array(terrain.length);
        this.update();
    }
    update() {
        const { numTriangles, numParentTriangles, coords, gridSize: size } = this.martini;
        const { terrain, errors } = this;
        // iterate over all possible triangles, starting from the smallest level
        for(let i = numTriangles - 1; i >= 0; i--){
            const k = i * 4;
            const ax = coords[k + 0];
            const ay = coords[k + 1];
            const bx = coords[k + 2];
            const by = coords[k + 3];
            const mx = ax + bx >> 1;
            const my = ay + by >> 1;
            const cx = mx + my - ay;
            const cy = my + ax - mx;
            // calculate error in the middle of the long edge of the triangle
            const interpolatedHeight = (terrain[ay * size + ax] + terrain[by * size + bx]) / 2;
            const middleIndex = my * size + mx;
            const middleError = Math.abs(interpolatedHeight - terrain[middleIndex]);
            errors[middleIndex] = Math.max(errors[middleIndex], middleError);
            if (i < numParentTriangles) {
                const leftChildIndex = (ay + cy >> 1) * size + (ax + cx >> 1);
                const rightChildIndex = (by + cy >> 1) * size + (bx + cx >> 1);
                errors[middleIndex] = Math.max(errors[middleIndex], errors[leftChildIndex], errors[rightChildIndex]);
            }
        }
    }
    getMesh(maxError = 0) {
        const { gridSize: size, indices } = this.martini;
        const { errors } = this;
        let numVertices = 0;
        let numTriangles = 0;
        const max = size - 1;
        // use an index grid to keep track of vertices that were already used to avoid duplication
        indices.fill(0);
        // retrieve mesh in two stages that both traverse the error map:
        // - countElements: find used vertices (and assign each an index), and count triangles (for minimum allocation)
        // - processTriangle: fill the allocated vertices & triangles typed arrays
        function countElements(ax, ay, bx, by, cx, cy) {
            const mx = ax + bx >> 1;
            const my = ay + by >> 1;
            if (Math.abs(ax - cx) + Math.abs(ay - cy) > 1 && errors[my * size + mx] > maxError) {
                countElements(cx, cy, ax, ay, mx, my);
                countElements(bx, by, cx, cy, mx, my);
            } else {
                indices[ay * size + ax] = indices[ay * size + ax] || ++numVertices;
                indices[by * size + bx] = indices[by * size + bx] || ++numVertices;
                indices[cy * size + cx] = indices[cy * size + cx] || ++numVertices;
                numTriangles++;
            }
        }
        countElements(0, 0, max, max, max, 0);
        countElements(max, max, 0, 0, 0, max);
        const vertices = new Uint16Array(numVertices * 2);
        const triangles = new Uint32Array(numTriangles * 3);
        let triIndex = 0;
        function processTriangle(ax, ay, bx, by, cx, cy) {
            const mx = ax + bx >> 1;
            const my = ay + by >> 1;
            if (Math.abs(ax - cx) + Math.abs(ay - cy) > 1 && errors[my * size + mx] > maxError) {
                // triangle doesn't approximate the surface well enough; drill down further
                processTriangle(cx, cy, ax, ay, mx, my);
                processTriangle(bx, by, cx, cy, mx, my);
            } else {
                // add a triangle
                const a = indices[ay * size + ax] - 1;
                const b = indices[by * size + bx] - 1;
                const c = indices[cy * size + cx] - 1;
                vertices[2 * a] = ax;
                vertices[2 * a + 1] = ay;
                vertices[2 * b] = bx;
                vertices[2 * b + 1] = by;
                vertices[2 * c] = cx;
                vertices[2 * c + 1] = cy;
                triangles[triIndex++] = a;
                triangles[triIndex++] = b;
                triangles[triIndex++] = c;
            }
        }
        processTriangle(0, 0, max, max, max, 0);
        processTriangle(max, max, 0, 0, 0, max);
        return {
            vertices: vertices,
            triangles: triangles
        };
    }
    // isolateSkirtVertices for correct normal values
    getMeshWithSkirts(maxError = 0, isolateSkirtVertices) {
        const { gridSize: size, indices } = this.martini;
        const { errors } = this;
        let numVertices = 0;
        let numTriangles = 0;
        const max = size - 1;
        let aIndex, bIndex, cIndex = 0;
        // Skirt indices
        const leftSkirtIndices = [];
        const rightSkirtIndices = [];
        const bottomSkirtIndices = [];
        const topSkirtIndices = [];
        // use an index grid to keep track of vertices that were already used to avoid duplication
        indices.fill(0);
        // retrieve mesh in two stages that both traverse the error map:
        // - countElements: find used vertices (and assign each an index), and count triangles (for minimum allocation)
        // - processTriangle: fill the allocated vertices & triangles typed arrays
        function countElements(ax, ay, bx, by, cx, cy) {
            const mx = ax + bx >> 1;
            const my = ay + by >> 1;
            if (Math.abs(ax - cx) + Math.abs(ay - cy) > 1 && errors[my * size + mx] > maxError) {
                countElements(cx, cy, ax, ay, mx, my);
                countElements(bx, by, cx, cy, mx, my);
            } else {
                aIndex = ay * size + ax;
                bIndex = by * size + bx;
                cIndex = cy * size + cx;
                if (indices[aIndex] === 0) {
                    if (ax === 0) leftSkirtIndices.push(numVertices);
                    else if (ax === max) rightSkirtIndices.push(numVertices);
                    if (ay === 0) bottomSkirtIndices.push(numVertices);
                    else if (ay === max) topSkirtIndices.push(numVertices);
                    indices[aIndex] = ++numVertices;
                }
                if (indices[bIndex] === 0) {
                    if (bx === 0) leftSkirtIndices.push(numVertices);
                    else if (bx === max) rightSkirtIndices.push(numVertices);
                    if (by === 0) bottomSkirtIndices.push(numVertices);
                    else if (by === max) topSkirtIndices.push(numVertices);
                    indices[bIndex] = ++numVertices;
                }
                if (indices[cIndex] === 0) {
                    if (cx === 0) leftSkirtIndices.push(numVertices);
                    else if (cx === max) rightSkirtIndices.push(numVertices);
                    if (cy === 0) bottomSkirtIndices.push(numVertices);
                    else if (cy === max) topSkirtIndices.push(numVertices);
                    indices[cIndex] = ++numVertices;
                }
                numTriangles++;
            }
        }
        countElements(0, 0, max, max, max, 0);
        countElements(max, max, 0, 0, 0, max);
        let numTotalVertices;
        if (isolateSkirtVertices) numTotalVertices = (numVertices + leftSkirtIndices.length * 3 - 2 + rightSkirtIndices.length * 3 - 2 + bottomSkirtIndices.length * 3 - 2 + topSkirtIndices.length * 3 - 2) * 2;
        else numTotalVertices = (numVertices + leftSkirtIndices.length + rightSkirtIndices.length + bottomSkirtIndices.length + topSkirtIndices.length) * 2;
        const numTotalTriangles = (numTriangles + (leftSkirtIndices.length - 1) * 2 + (rightSkirtIndices.length - 1) * 2 + (bottomSkirtIndices.length - 1) * 2 + (topSkirtIndices.length - 1) * 2) * 3;
        const vertices = new Uint16Array(numTotalVertices);
        const triangles = new Uint32Array(numTotalTriangles);
        let triIndex = 0;
        function processTriangle(ax, ay, bx, by, cx, cy) {
            const mx = ax + bx >> 1;
            const my = ay + by >> 1;
            if (Math.abs(ax - cx) + Math.abs(ay - cy) > 1 && errors[my * size + mx] > maxError) {
                // triangle doesn't approximate the surface well enough; drill down further
                processTriangle(cx, cy, ax, ay, mx, my);
                processTriangle(bx, by, cx, cy, mx, my);
            } else {
                // add a triangle
                const a = indices[ay * size + ax] - 1;
                const b = indices[by * size + bx] - 1;
                const c = indices[cy * size + cx] - 1;
                vertices[2 * a] = ax;
                vertices[2 * a + 1] = ay;
                vertices[2 * b] = bx;
                vertices[2 * b + 1] = by;
                vertices[2 * c] = cx;
                vertices[2 * c + 1] = cy;
                triangles[triIndex++] = a;
                triangles[triIndex++] = b;
                triangles[triIndex++] = c;
            }
        }
        processTriangle(0, 0, max, max, max, 0);
        processTriangle(max, max, 0, 0, 0, max);
        // Sort skirt indices to create adjacent triangles
        leftSkirtIndices.sort((a, b)=>vertices[2 * a + 1] - vertices[2 * b + 1]);
        // Reverse (b - a) to match triangle winding
        rightSkirtIndices.sort((a, b)=>vertices[2 * b + 1] - vertices[2 * a + 1]);
        bottomSkirtIndices.sort((a, b)=>vertices[2 * b] - vertices[2 * a]);
        // Reverse (b - a) to match triangle winding
        topSkirtIndices.sort((a, b)=>vertices[2 * a] - vertices[2 * b]);
        let skirtIndex = numVertices * 2;
        let currIndex, nextIndex, currentSkirt, nextSkirt, skirtLength = 0;
        // Add skirt vertices from index of last mesh vertex
        function constructSkirt(skirt) {
            skirtLength = skirt.length;
            // Loop through indices in groups of two to generate triangles
            for(let i = 0; i < skirtLength - 1; i++){
                currIndex = skirt[i];
                nextIndex = skirt[i + 1];
                currentSkirt = skirtIndex / 2;
                nextSkirt = (skirtIndex + (isolateSkirtVertices ? 6 : 2)) / 2;
                vertices[skirtIndex++] = 2 * currIndex;
                vertices[skirtIndex++] = 2 * currIndex + 1;
                if (isolateSkirtVertices) {
                    vertices[skirtIndex++] = 2 * currIndex;
                    vertices[skirtIndex++] = 2 * currIndex + 1;
                    vertices[skirtIndex++] = 2 * nextIndex;
                    vertices[skirtIndex++] = 2 * nextIndex + 1;
                }
                if (isolateSkirtVertices) {
                    triangles[triIndex++] = currentSkirt + 1;
                    triangles[triIndex++] = currentSkirt;
                    triangles[triIndex++] = currentSkirt + 2;
                    triangles[triIndex++] = currentSkirt;
                    triangles[triIndex++] = nextSkirt;
                    triangles[triIndex++] = currentSkirt + 2;
                } else {
                    triangles[triIndex++] = currIndex;
                    triangles[triIndex++] = currentSkirt;
                    triangles[triIndex++] = nextIndex;
                    triangles[triIndex++] = currentSkirt;
                    triangles[triIndex++] = nextSkirt;
                    triangles[triIndex++] = nextIndex;
                }
            }
            // Add vertices of last skirt not added above (i < skirtLength - 1)
            vertices[skirtIndex++] = 2 * skirt[skirtLength - 1];
            vertices[skirtIndex++] = 2 * skirt[skirtLength - 1] + 1;
        }
        constructSkirt(leftSkirtIndices);
        const leftSkirtIndex = skirtIndex;
        constructSkirt(rightSkirtIndices);
        const rightSkirtIndex = skirtIndex;
        constructSkirt(bottomSkirtIndices);
        const bottomSkirtIndex = skirtIndex;
        constructSkirt(topSkirtIndices);
        const topSkirtIndex = skirtIndex;
        // Return vertices and triangles and index into vertices array where skirts start
        return {
            vertices: vertices,
            triangles: triangles,
            numVerticesWithoutSkirts: numVertices,
            numTrianglesWithoutSkirts: numTriangles,
            leftSkirtIndex: leftSkirtIndex,
            rightSkirtIndex: rightSkirtIndex,
            bottomSkirtIndex: bottomSkirtIndex,
            topSkirtIndex: topSkirtIndex
        };
    }
}
const martinis = {};
function createMartiniData(error, heights, width, hasSkirts) {
    let martini = martinis[width];
    if (!martini) martini = martinis[width] = new Martini(width);
    const terrainTile = martini.createTile(heights);
    //TODO 需要增加判断，只有pbr渲染时，才需要把isolateSkirtVertices设成true
    const isolateSkirtVertices = true;
    const mesh = terrainTile.getMeshWithSkirts(error, isolateSkirtVertices);
    const { triangles, vertices, leftSkirtIndex, rightSkirtIndex, bottomSkirtIndex, topSkirtIndex } = mesh;
    let { numVerticesWithoutSkirts, numTrianglesWithoutSkirts } = mesh;
    if (!numVerticesWithoutSkirts) {
        numVerticesWithoutSkirts = vertices.legnth / 3;
        numTrianglesWithoutSkirts = triangles.length / 3;
    }
    const count = vertices.length / 2;
    const positions = new Float32Array(count * 3), texcoords = new Float32Array(count * 2);
    const skirtOffset = 0; //terrainStructure.skirtOffset;
    let minHeight = Infinity;
    let maxHeight = -Infinity;
    const maxWidth = width - 1;
    for(let i = 0; i < count; i++){
        const x = vertices[i * 2], y = vertices[i * 2 + 1];
        if (i >= numVerticesWithoutSkirts) {
            // positions.push(0);
            const index = x / 2 * 3;
            let height;
            // 侧面因为顶底uv[1]相等，导致和normal合并计算tangent时会出现NaN，导致侧面的normal结果错误
            // 给skirt顶面的uv的x和y都增加一点偏移量即能解决该问题
            let texOffset = 0.001;
            {
                const start = i < leftSkirtIndex / 2 ? numVerticesWithoutSkirts : i < rightSkirtIndex / 2 ? leftSkirtIndex / 2 : i < bottomSkirtIndex / 2 ? rightSkirtIndex / 2 : bottomSkirtIndex / 2;
                if ((i - start) % 3 === 0) {
                    height = 0;
                    texOffset = 0;
                } else height = positions[index + 2];
            }
            positions[i * 3] = positions[index];
            positions[i * 3 + 1] = positions[index + 1];
            positions[i * 3 + 2] = height;
            texcoords[i * 2] = positions[index] / maxWidth + texOffset;
            texcoords[i * 2 + 1] = -positions[index + 1] / maxWidth + texOffset;
        } else {
            positions[i * 3] = x * (1 + skirtOffset);
            positions[i * 3 + 1] = -y * (1 + skirtOffset);
            positions[i * 3 + 2] = heights[y * width + x];
            texcoords[i * 2] = x / maxWidth;
            texcoords[i * 2 + 1] = y / maxWidth;
        }
        const height = positions[positions.length - 1];
        if (height < minHeight) minHeight = height;
        if (height > maxHeight) maxHeight = height;
    }
    const terrain = {
        positions: positions,
        texcoords: texcoords,
        triangles: triangles,
        leftSkirtIndex: leftSkirtIndex,
        rightSkirtIndex: rightSkirtIndex,
        bottomSkirtIndex: bottomSkirtIndex,
        topSkirtIndex: topSkirtIndex,
        numTrianglesWithoutSkirts: numTrianglesWithoutSkirts,
        numVerticesWithoutSkirts: numVerticesWithoutSkirts,
        minHeight: minHeight,
        maxHeight: maxHeight,
        terrainWidth: width
    };
    return terrain;
}
function getCascadeTileIds(layer, x, y, z, center, offset, terrainTileScaleY, scale, levelLimit) {
    const result = {};
    for(let i = 0; i < levelLimit; i++)result[i + ''] = getTileIdsAtLevel(layer, x, y, z, center, offset, terrainTileScaleY, scale, i);
    return result;
}
const EMPTY_ARRAY$1 = [];
function getTileIdsAtLevel(layer, x, y, z, center, offset, terrainTileScaleY, scale, level) {
    z -= level;
    if (z <= 0) return EMPTY_ARRAY$1;
    // 这里假设 tile offset 还在tileSize范围内，而不是跨越或超过1整张瓦片的那种偏移方式
    const tileSize = layer.getTileSize().width;
    const layerOffset = layer['_getTileOffset'](z, center);
    const tileOffsetX = offset[0] - layerOffset[0];
    const tileOffsetY = layerOffset[1] - offset[1];
    const tileConfig = layer['_getTileConfig']();
    const sr = layer.getSpatialReference();
    const tileRes = sr.getResolution(z);
    const tileYScale = tileConfig.tileSystem.scale.y;
    const delta = 1E-7;
    scale = scale / Math.pow(2, level);
    let xStart = 0;
    let yStart = 0;
    let xEnd = scale;
    let yEnd = scale;
    if (tileOffsetX < 0) xEnd += Math.ceil(-tileOffsetX / tileSize - delta);
    else if (tileOffsetX > 0) xStart -= Math.ceil(tileOffsetX / tileSize - delta);
    if (tileOffsetY > 0) yStart -= Math.ceil(tileOffsetY / tileSize - delta);
    else if (tileOffsetY < 0) yEnd += Math.ceil(-tileOffsetY / tileSize - delta);
    if (xStart === 0 && yStart === 0 && xEnd <= 1 && yEnd <= 1) {
        const tx = Math.floor(x * scale);
        let ty = Math.floor(y * scale);
        const skinY = ty;
        if (tileYScale !== terrainTileScaleY) ty = getReverseY(tileConfig, ty, tileRes);
        return [
            {
                x: tx,
                y: ty,
                skinY: skinY,
                z: z,
                offset: layerOffset,
                tileSize: tileSize,
                id: layer['_getTileId'](tx, ty, z)
            }
        ];
    }
    const result = [];
    for(let i = xStart; i < xEnd; i++)for(let j = yStart; j < yEnd; j++){
        const tx = x * scale + i;
        let ty = y * scale + j;
        const skinY = ty;
        if (tileYScale !== terrainTileScaleY) ty = getReverseY(tileConfig, ty, tileRes);
        result.push({
            x: tx,
            y: ty,
            skinY: skinY,
            z: z,
            offset: layerOffset,
            tileSize: tileSize,
            id: layer['_getTileId'](tx, ty, z)
        });
    }
    return result;
}
// 地形瓦片与skin瓦片编号的scale
function getSkinTileScale(res, size, terrainRes, terrainSize) {
    let scale = res / terrainRes * terrainSize / size;
    if (scale < 1) {
        scale = 1 / scale;
        scale = 1 / Math.round(scale);
    } else scale = Math.round(scale);
    return scale;
}
function getSkinTileRes(sr, z, terrainRes) {
    const resAtZ = sr.getResolution(z);
    const zoom = z - Math.log(terrainRes / resAtZ) * Math.LOG2E;
    const myRes = sr.getResolution(zoom);
    return {
        zoom: zoom,
        res: myRes
    };
}
new $gP1US.Point(0, 0);
// from Leaflet's GridLayer.js
function getReverseY(tileConfig, y, res) {
    const fullExtent = tileConfig.fullExtent;
    const tileSize = tileConfig.tileSize.width;
    const max = Math.max(fullExtent.top, fullExtent.bottom);
    const min = Math.min(fullExtent.top, fullExtent.bottom);
    const top = Math.ceil(max / tileSize / res) - 1;
    const bottom = Math.floor(min / tileSize / res);
    return top - bottom - y;
}
function createEmtpyTerrainHeights(height, size) {
    const length = size * size;
    const data = height !== 0 ? new Float32Array(length) : new Uint8Array(length);
    data.fill(height);
    return {
        data: data,
        width: size,
        height: size,
        max: height,
        min: height
    };
}
const emptyHeights = createEmtpyTerrainHeights(0, 5);
const EMPTY_TERRAIN_GEO = createMartiniData(1, emptyHeights.data, emptyHeights.width);
EMPTY_TERRAIN_GEO.empty = true;
function fillIncludes(defines, uniformDeclares, context) {
    const includes = context && context.includes;
    if (includes) {
        for(const p in includes)if (includes[p]) {
            if (context[p].uniformDeclares) uniformDeclares.push(...context[p].uniformDeclares);
            if (context[p].defines) extend(defines, context[p].defines);
        }
    }
}
function setIncludeUniformValues(uniforms, context) {
    const includes = context && context.includes;
    if (includes) for(const p in includes){
        if (includes[p]) {
            if (context[p].renderUniforms) extend(uniforms, context[p].renderUniforms);
        }
    }
}
var context = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    fillIncludes: fillIncludes,
    setIncludeUniformValues: setIncludeUniformValues
});
var vert = "#define SHADER_NAME TERRAIN_MESH\nattribute vec3 aPosition;\nattribute vec2 aTexCoord;\nuniform float minAltitude;\nuniform mat4 projViewModelMatrix;\nuniform mat4 projMatrix;\nuniform mat4 modelMatrix;\nuniform mat4 modelViewMatrix;\nuniform mat4 positionMatrix;\nuniform float heightScale;\nvarying vec2 vUv;\n#include <mask_vert>\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n    #include <vsm_shadow_vert>\n#endif\nvoid main() {\n    vec4 position = vec4(aPosition.xy, (aPosition.z + minAltitude) * heightScale, 1.0);\n    position = positionMatrix * position;\n    #ifdef HAS_MASK_EXTENT\n        gl_Position = projMatrix * getMaskPosition(position, modelMatrix);\n    #else\n        gl_Position = projViewModelMatrix * position;\n    #endif\n    vUv = aTexCoord;\n    #if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n        shadow_computeShadowPars(position);\n    #endif\n}";
var frag = "#define SHADER_NAME TERRAIN_MESH\nprecision mediump float;\nuniform sampler2D skin;\nuniform float polygonOpacity;\nvarying vec2 vUv;\n#include <mask_frag>\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n    #include <vsm_shadow_frag>\n#endif\nvoid main() {\n    vec2 uv = vec2(vUv);\n    uv.y = 1.0 - uv.y;\n    vec4 color = texture2D(skin, uv);\n    #if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n        float shadowCoeff = shadow_computeShadow();\n        color.rgb = shadow_blend(color.rgb, shadowCoeff).rgb;\n    #endif\n    gl_FragColor = color * polygonOpacity;\n    #ifdef HAS_MASK_EXTENT\n      gl_FragColor = setMask(gl_FragColor);\n    #endif\n}";
const V3 = [];
const SCALE3 = [];
class TerrainPainter {
    constructor(layer){
        this.layer = layer;
        this.regl = layer.getRenderer().regl;
        this.renderer = new $2wazW.Renderer(this.regl);
        this._leafScene = new $2wazW.Scene();
        const pixels = new Uint8Array(16);
        pixels.fill(255);
        this._emptyTileTexture = this.regl.texture({
            width: 2,
            height: 2,
            data: pixels
        });
        this._resLoader = new $2wazW.ResourceLoader(this._emptyTileTexture);
        this._createEmptyTerrainGeo();
    }
    setToRedraw() {
        this.layer.getRenderer().setToRedraw();
    }
    getMap() {
        return this.layer.getMap();
    }
    startFrame(context) {
        if (context && context.states && context.states.includesChanged) {
            this.shader.dispose();
            delete this.shader;
        }
        if (!this.shader) this.initShader(context);
        this._leafScene.clear();
    }
    createTerrainMesh(tileInfo, terrainImage) {
        const { mesh: terrainGeo, image: heightTexture } = terrainImage;
        let mesh = terrainImage.terrainMesh;
        const { positions, texcoords, triangles, empty } = terrainGeo;
        if (mesh && mesh.geometry !== this._emptyTerrainGeometry) {
            mesh.geometry.updateData('aPosition', positions);
            mesh.geometry.updateData('aTexCoord', texcoords);
            mesh.geometry.setElements(triangles);
        } else {
            const geo = empty ? this._emptyTerrainGeometry : new $2wazW.Geometry({
                aPosition: positions,
                aTexCoord: texcoords
            }, triangles, 0);
            if (mesh) mesh.geometry = geo;
            else {
                mesh = new $2wazW.Mesh(geo, null, {
                    disableVAO: true
                });
                geo.generateBuffers(this.regl);
            }
        }
        if (!mesh.uniforms.skin) {
            const emptyTexture = this.getEmptyTexture();
            mesh.setUniform('skin', emptyTexture);
        }
        mesh.setUniform('heightTexture', heightTexture);
        this.prepareMesh(mesh, tileInfo, terrainImage);
        return mesh;
    }
    _updateMaskDefines(mesh) {
        const renderer = this.layer.getRenderer();
        if (renderer) renderer.updateMaskDefines(mesh);
    }
    _getPositionMatrix(out) {
        const heightScale = this._getPointZ(100) / 100;
        const positionMatrix = (0, $3iqbd).identity(out);
        (0, $3iqbd).scale(positionMatrix, positionMatrix, [
            1,
            1,
            heightScale
        ]);
        return positionMatrix;
    }
    _getLocalTransform(out, tileInfo, terrainWidth) {
        const map = this.getMap();
        const tileSize = this.layer.getTileSize().width;
        const scale = tileInfo.res / map.getGLRes();
        const terrainScale = tileSize / (terrainWidth - 1);
        const { extent2d, offset } = tileInfo;
        (0, $eIStk).set(V3, (extent2d.xmin - offset[0]) * scale, (tileInfo.extent2d.ymax - offset[1]) * scale, 0);
        const localTransform = (0, $3iqbd).identity(out);
        (0, $3iqbd).translate(localTransform, localTransform, V3);
        (0, $eIStk).set(SCALE3, scale * terrainScale, scale * terrainScale, 1);
        (0, $3iqbd).scale(localTransform, localTransform, SCALE3);
        return localTransform;
    }
    prepareMesh(mesh, tileInfo, terrainImage) {
        if (!mesh.isValid()) return;
        const { mesh: terrainGeo } = terrainImage;
        this._updateMaskDefines(mesh);
        const { triangles, numTrianglesWithoutSkirts, terrainWidth } = terrainGeo;
        mesh.localTransform = this._getLocalTransform(mesh.localTransform || [], tileInfo, terrainWidth);
        mesh.positionMatrix = this._getPositionMatrix(mesh.positionMatrix || []);
        mesh.properties.skirtOffset = numTrianglesWithoutSkirts * 3;
        mesh.properties.skirtCount = triangles.length - numTrianglesWithoutSkirts * 3;
        mesh.properties.z = tileInfo.z;
        mesh.properties.minHeight = terrainGeo.minHeight;
        mesh.properties.maxHeight = terrainGeo.maxHeight;
        mesh.properties.terrainWidth = terrainWidth;
        mesh.castShadow = false;
        if (!hasOwn(mesh.uniforms, 'minAltitude')) Object.defineProperty(mesh.uniforms, 'minAltitude', {
            enumerable: true,
            get: ()=>{
                return terrainImage.minAltitude || 0;
            }
        });
    }
    addTerrainImage(tileInfo, tileImage) {
        const mesh = tileImage.terrainMesh;
        if (mesh && mesh.geometry && tileImage.skin) {
            mesh.setUniform('skin', tileImage.skin.color[0]);
            mesh.setUniform('polygonOpacity', 1.0);
            // const { skirtOffset, skirtCount } = mesh.properties;
            // mesh.geometry.setDrawOffset(skirtOffset);
            // mesh.geometry.setDrawCount(skirtCount);
            this._leafScene.addMesh(mesh);
        }
    }
    endFrame(context$1) {
        this.updateIBLDefines(this.shader);
        let renderCount = 0;
        const uniforms = this.getUniformValues();
        const fbo = this._getRenderFBO(context$1);
        this.shader.filter = context$1 && context$1.sceneFilter;
        setIncludeUniformValues(uniforms, context$1);
        this._leafScene.getMeshes().forEach((mesh)=>{
            this._updateMaskDefines(mesh);
        });
        renderCount += this.renderer.render(this.shader, uniforms, this._leafScene, fbo);
        return renderCount;
    }
    delete() {
        if (this.shader) {
            this.shader.dispose();
            delete this.shader;
        }
        if (this._emptyTileTexture) {
            this._emptyTileTexture.destroy();
            delete this._emptyTileTexture;
        }
        if (this._emptyTerrainGeometry) {
            this._emptyTerrainGeometry.dispose();
            delete this._emptyTerrainGeometry;
        }
    }
    deleteMesh(terrainMesh) {
        if (!terrainMesh) return;
        const geo = terrainMesh.geometry;
        terrainMesh.dispose();
        if (geo !== this._emptyTerrainGeometry) geo.dispose();
    }
    initShader(context$1) {
        const projViewModelMatrix = [], modelViewMatrix = [];
        const defines = {};
        const uniformDeclares = [];
        fillIncludes(defines, uniformDeclares, context$1);
        this.shader = new $2wazW.MeshShader({
            vert: vert,
            frag: frag,
            uniforms: uniformDeclares.concat([
                {
                    name: 'modelViewMatrix',
                    type: 'function',
                    fn: function(context, props) {
                        return (0, $3iqbd).multiply(modelViewMatrix, props['viewMatrix'], props['modelMatrix']);
                    }
                },
                {
                    name: 'projViewModelMatrix',
                    type: 'function',
                    fn: function(context, props) {
                        return (0, $3iqbd).multiply(projViewModelMatrix, props['projViewMatrix'], props['modelMatrix']);
                    }
                }
            ]),
            defines: defines,
            extraCommandProps: this.getExtraCommandProps()
        });
    }
    getExtraCommandProps() {
        const canvas = this.layer.getRenderer().canvas;
        const extraCommandProps = {
            viewport: {
                x: 0,
                y: 0,
                width: ()=>{
                    return canvas ? canvas.width : 1;
                },
                height: ()=>{
                    return canvas ? canvas.height : 1;
                }
            },
            stencil: {
                enable: false
            },
            cull: {
                enable: true,
                face: 'back'
            },
            depth: {
                enable: true,
                mask: ()=>{
                    const depthMask = this.layer.options['depthMask'];
                    return !!depthMask;
                },
                func: this.layer.options['depthFunc'] || '<='
            },
            blend: {
                enable: true,
                func: {
                    src: this.layer.options.blendSrc,
                    dst: this.layer.options.blendDst
                },
                equation: 'add'
            }
        };
        return extraCommandProps;
    }
    _getRenderFBO(context) {
        //优先采用不aa的fbo
        return context && context.renderTarget && context.renderTarget.fbo;
    }
    getUniformValues() {
        const map = this.getMap();
        const projViewMatrix = map.projViewMatrix;
        const renderer = this.layer.getRenderer();
        const maskUniforms = renderer.getMaskUniforms();
        const uniforms = {
            viewMatrix: map.viewMatrix,
            projMatrix: map.projMatrix,
            projViewMatrix: projViewMatrix,
            heightScale: 1
        };
        extend(uniforms, maskUniforms);
        return uniforms;
    }
    _getPointZ(height) {
        const map = this.layer.getMap();
        if (!map) return null;
        const altitude = map.altitudeToPoint(height, map.getGLRes());
        return altitude;
    }
    getEmptyTexture() {
        return this._emptyTileTexture;
    }
    hasIBL() {
        const lightManager = this.getMap().getLightManager();
        const resource = lightManager && lightManager.getAmbientResource();
        return !!resource;
    }
    updateIBLDefines(shader) {
        const shaderDefines = shader.shaderDefines;
        let updated = false;
        if (this.hasIBL()) {
            if (!shaderDefines[[
                'HAS_IBL_LIGHTING'
            ]]) {
                shaderDefines['HAS_IBL_LIGHTING'] = 1;
                updated = true;
            }
        } else if (shaderDefines[[
            'HAS_IBL_LIGHTING'
        ]]) {
            delete shaderDefines['HAS_IBL_LIGHTING'];
            updated = true;
        }
        if (updated) shader.shaderDefines = shaderDefines;
    }
    _createEmptyTerrainGeo() {
        const emptyTerrainGeo = EMPTY_TERRAIN_GEO;
        const { positions, texcoords, triangles } = emptyTerrainGeo;
        this._emptyTerrainGeometry = new $2wazW.Geometry({
            aPosition: positions,
            aTexCoord: texcoords
        }, triangles, 0);
        this._emptyTerrainGeometry.generateBuffers(this.regl);
    }
}
// function terrainMeshCompare(m0, m1) {
//     return m1.properties.z - m0.properties.z;
// }
const { getIBLResOnCanvas, getPBRUniforms, loginIBLResOnCanvas, logoutIBLResOnCanvas } = $2wazW.pbr.PBRUtils;
const DEFAULT_MATERIAL = {
    baseColorFactor: [
        1,
        1,
        1,
        1
    ],
    emissiveFactor: [
        0,
        0,
        0
    ],
    baseColorIntensity: 1,
    emitColorFactor: 1,
    roughnessFactor: 1,
    metallicFactor: 0,
    emitMultiplicative: 1,
    outputSRGB: 1,
    hsv: [
        0,
        0,
        0
    ],
    contrast: 1,
    alphaTest: 0
};
class TerrainLitPainter extends TerrainPainter {
    constructor(...args){
        super(...args);
        this.createIBLTextures();
        this._matVer = 0;
    }
    updateMaterial(mat, matVer) {
        this._matVer = matVer;
        this._material = this._material || {};
        extend(this._material, mat);
        this.setToRedraw();
    }
    setMaterial(mat, matVer) {
        this._matVer = matVer;
        this._material = extend({}, DEFAULT_MATERIAL, mat);
        this.setToRedraw();
    }
    createIBLTextures() {
        const canvas = this.getMap().getRenderer().canvas;
        loginIBLResOnCanvas(canvas, this.regl, this.getMap());
        this.layer.fire('iblupdated');
    }
    disposeIBLTextures() {
        const canvas = this.getMap().getRenderer().canvas;
        logoutIBLResOnCanvas(canvas, this.getMap());
    }
    createTerrainMesh(tileInfo, terrainImage) {
        const { mesh: terrainGeo, image: heightTexture } = terrainImage;
        const { positions, texcoords, triangles, leftSkirtIndex, rightSkirtIndex, bottomSkirtIndex, numVerticesWithoutSkirts } = terrainGeo;
        const normals = new Int8Array(positions.length);
        for(let i = 2; i < normals.length; i += 3){
            if (i < numVerticesWithoutSkirts * 3) normals[i] = 1;
            else if (i < leftSkirtIndex / 2 * 3) normals[i - 2] = -1;
            else if (i < rightSkirtIndex / 2 * 3) normals[i - 2] = 1;
            else if (i < bottomSkirtIndex / 2 * 3) normals[i - 1] = -1;
            else // top
            normals[i - 1] = 1;
        }
        const geo = new $2wazW.Geometry({
            aPosition: positions,
            aTexCoord: texcoords,
            aNormal: normals
        }, triangles, 0);
        // 共用端点时，法线值会出现错误，造成视觉上不连续，所以需要唯一化
        // 唯一化后，三角形数量不变，但端点数组大概会膨胀5倍以上
        // geo.buildUniqueVertex();
        // geo.createNormal();
        geo.createTangent();
        delete geo.data.aNormal;
        geo.generateBuffers(this.regl);
        let terrainHeightTexture;
        if (heightTexture) terrainHeightTexture = this.regl.texture({
            width: heightTexture.width,
            height: heightTexture.height,
            data: heightTexture,
            min: 'linear',
            mag: 'linear'
        });
        else terrainHeightTexture = this.getEmptyTexture();
        const emptyTexture = this.getEmptyTexture();
        const matInfo = extend({}, DEFAULT_MATERIAL, this.layer.options['material'] || {});
        matInfo.skinTexture = emptyTexture;
        matInfo.terrainHeightTexture = terrainHeightTexture;
        const material = new $2wazW.pbr.StandardMaterial(matInfo);
        const mesh = new $2wazW.Mesh(geo, material);
        mesh.properties.matVer = this._matVer;
        const defines = mesh.defines;
        defines['HAS_UV_FLIP'] = 1;
        defines['HAS_TERRAIN_NORMAL'] = 1;
        defines['HAS_MAP'] = 1;
        mesh.defines = defines;
        mesh.setUniform('terrainTileResolution', tileInfo.res);
        this.prepareMesh(mesh, tileInfo, terrainImage);
        return mesh;
    }
    addTerrainImage(tileInfo, tileImage) {
        const mesh = tileImage.terrainMesh;
        if (mesh) {
            if (this._material && mesh.properties.matVer !== this._matVer) {
                for(const p in this._material)mesh.material.set(p, this._material[p]);
                mesh.properties.matVer = this._matVer;
            }
            if (tileImage.skin) mesh.material.set('skinTexture', tileImage.skin);
            mesh.setUniform('polygonOpacity', 1.0);
            // const { skirtOffset, skirtCount } = mesh.properties;
            // mesh.geometry.setDrawOffset(skirtOffset);
            // mesh.geometry.setDrawCount(skirtCount);
            this._leafScene.addMesh(mesh);
        }
    }
    getUniformValues() {
        const map = this.getMap();
        // const layer = this.layer;
        const canvas = map.getRenderer().canvas;
        const { iblTexes, dfgLUT } = getIBLResOnCanvas(canvas);
        const uniforms = getPBRUniforms(map, iblTexes, dfgLUT);
        const tileSize = this.layer.getTileSize().width;
        const renderer = this.layer.getRenderer();
        const maskUniforms = renderer.getMaskUniforms();
        const terrainHeightScale = this._getPointZ(100) / 100;
        extend(uniforms, {
            viewMatrix: map.viewMatrix,
            projMatrix: map.projMatrix,
            projViewMatrix: map.projViewMatrix,
            outSize: [
                canvas.width,
                canvas.height
            ],
            polygonFill: [
                1,
                1,
                1,
                1
            ],
            terrainHeightMapResolution: [
                tileSize,
                tileSize
            ],
            terrainResolution: [
                canvas.width,
                canvas.height
            ],
            terrainHeightScale: terrainHeightScale,
            terrainUnpackFactors: [
                6553.6,
                25.6,
                0.1,
                10000.0
            ]
        });
        extend(uniforms, maskUniforms);
        return uniforms;
    }
    initShader(context$1) {
        const defines = {};
        const uniformDeclares = [];
        fillIncludes(defines, uniformDeclares, context$1);
        this.shader = new $2wazW.pbr.StandardShader({
            uniforms: uniformDeclares,
            defines: defines,
            extraCommandProps: this.getExtraCommandProps()
        });
    }
    delete() {
        this.disposeIBLTextures();
        return super.delete();
    }
}
function renderExtentMap(extent, projViewMatrix, ratio, minHeight) {
    const maskMeshes = getMaskMeshes.call(this, ratio, minHeight);
    this['_projViewMatrix'] = projViewMatrix;
    const { colorExtent, modeExtent } = this['_extentPass'].render(maskMeshes, projViewMatrix);
    this['_maskUniforms'] = this['_maskUniforms'] || {};
    this['_maskUniforms']['mask_colorExtent'] = colorExtent;
    this['_maskUniforms']['mask_extent'] = extent;
    this['_maskUniforms']['mask_modeExtent'] = modeExtent;
    this['_maskUniforms']['mask_hasFlatOut'] = hasOutMask.call(this, 'flat-outside');
    this['_maskUniforms']['mask_hasClipOut'] = hasOutMask.call(this, 'clip-outside');
    this['_maskUniforms']['mask_hasVideo'] = hasOutMask.call(this, 'video');
    this['_maskUniforms']['mask_heightRatio'] = ratio;
    this['_maskUniforms']['mask_heightOffset'] = minHeight;
    this.setToRedraw();
}
function getMaskMeshes(ratio, minHeight) {
    const meshes = [];
    const masks = this.layer.getMasks();
    for(let i = 0; i < masks.length; i++){
        const mesh = masks[i].getMesh(this.regl, ratio, minHeight);
        if (mesh) meshes.push(mesh);
    }
    return meshes;
}
function updateVideoMask() {
    if (!this['_extentPass'] || !this['_maskUniforms']) return;
    const ratio = this['_maskUniforms']['mask_heightRatio'];
    const minHeight = this['_maskUniforms']['mask_heightOffset'];
    const maskMeshes = getMaskMeshes.call(this, ratio, minHeight);
    this['_extentPass'].render(maskMeshes, this['_projViewMatrix']);
    const masks = this.layer.getMasks();
    for(let i = 0; i < masks.length; i++)if (masks[i]._update) masks[i]._update();
}
function hasOutMask(outType) {
    const masks = this.layer.getMasks();
    for(let i = 0; i < masks.length; i++){
        if (masks[i].getMode() === outType) return 1;
    }
    return 0;
}
function hasPlayingVideoMask() {
    const masks = this.layer.getMasks();
    if (!masks) return false;
    for(let i = 0; i < masks.length; i++){
        if (masks[i]._needUpdate) return masks[i]._needUpdate();
    }
    return false;
}
function MaskRendererMixin(Base) {
    return class extends Base {
        setMask(extent, projViewMatrix, ratio, minHeight) {
            if (!this.viewport) this.viewport = {
                x: 0,
                y: 0,
                width: ()=>{
                    return this.canvas ? this.canvas.width : 1;
                },
                height: ()=>{
                    return this.canvas ? this.canvas.height : 1;
                }
            };
            if (!this['_extentPass']) {
                if (this.regl) {
                    this['_extentPass'] = new $2wazW.ExtentPass(this.regl, this.viewport);
                    renderExtentMap.call(this, extent, projViewMatrix, ratio, minHeight);
                } else this.layer.once('contextcreate', ()=>{
                    this['_extentPass'] = new $2wazW.ExtentPass(this.regl, this.viewport);
                    renderExtentMap.call(this, extent, projViewMatrix, ratio, minHeight);
                }, this);
            } else renderExtentMap.call(this, extent, projViewMatrix, ratio, minHeight);
        }
        needToRedraw() {
            if (super.needToRedraw()) return true;
            if (hasPlayingVideoMask.call(this)) return true;
            return false;
        }
        getMaskUniforms() {
            if (hasPlayingVideoMask.call(this)) updateVideoMask.call(this);
            this.layer.updateMaskExtent();
            return this['_maskUniforms'];
        }
        getMaskDefines() {
            if (!this['_maskDefines']) this['_maskDefines'] = {};
            if (this['_maskUniforms'] && this['_maskUniforms']['mask_colorExtent']) this['_maskDefines']['HAS_MASK_EXTENT'] = 1;
            else delete this['_maskDefines']['HAS_MASK_EXTENT'];
            return this._maskDefines;
        }
        updateMaskDefines(mesh) {
            const defines = mesh.getDefines();
            delete defines['HAS_MASK_EXTENT'];
            const maskDefines = this.getMaskDefines();
            extend(defines, maskDefines);
            mesh.setDefines(defines);
        }
        _clearMask() {
            this._deleteMaskUniforms();
            if (this._extentPass) {
                this._extentPass.dispose();
                delete this._extentPass;
            }
            this.setToRedraw();
        }
        _deleteMaskUniforms() {
            delete this._maskUniforms;
        }
    };
}
class LRUPool {
    constructor(max, onRemove){
        this.max = max;
        this.onRemove = onRemove;
        this.reset();
    }
    reset() {
        if (this.data) {
            const values = this.data.values();
            for (const p of values)this.onRemove(p);
        }
        this.data = new Map();
        return this;
    }
    clear() {
        this.reset();
        delete this.onRemove;
    }
    add(key, data) {
        if (!data) return this;
        if (this.has(key)) {
            this.data.delete(key);
            this.data.set(key, data);
        } else this.data.set(key, data);
        return this;
    }
    keys() {
        const keys = new Array(this.data.size);
        let i = 0;
        const iterator = this.data.keys();
        for (const k of iterator)keys[i++] = k;
        return keys;
    }
    has(key) {
        return this.data.has(key);
    }
    getAndRemove(key) {
        if (!this.has(key)) return null;
        const data = this.data.get(key);
        this.data.delete(key);
        return data;
    }
    get(key) {
        if (!this.has(key)) return null;
        const data = this.data.get(key);
        return data;
    }
    pop() {
        if (this.data.size < this.max) return null;
        const first = this.data.keys().next();
        const data = this.data.get(first.value);
        if (data.current) {
            this.max += Math.ceil(this.max / 2);
            return null;
        }
        return this.getAndRemove(first.value);
    }
    remove(key) {
        if (!this.has(key)) return this;
        const data = this.data.get(key);
        this.data.delete(key);
        this.onRemove(data);
        return this;
    }
    resetCurrent(current) {
        if (!this.data) return;
        this.data.forEach((v)=>{
            v.current = current;
        });
    }
}
const POINT0$1 = new $gP1US.Point(0, 0);
const POINT1 = new $gP1US.Point(0, 0);
const TEMP_EXTENT = new $gP1US.PointExtent(0, 0, 0, 0);
const TEMP_POINT$3 = new $gP1US.Point(0, 0);
const DEBUG_POINT = new $gP1US.Point(20, 20);
const TERRAIN_CLEAR = {
    color: [
        0,
        0,
        0,
        0
    ],
    depth: 1,
    stencil: 0
};
function terrainExaggeration(terrainData, exaggeration = 1) {
    if (isNil$1(exaggeration) || !terrainData || !terrainData.mesh || exaggeration === 1) return;
    const positions = terrainData.mesh.positions;
    if (!positions) return;
    for(let i = 0, len = positions.length; i < len; i += 3)positions[i + 2] *= exaggeration;
}
class TerrainLayerRenderer extends MaskRendererMixin($gP1US.renderer.TileLayerCanvasRenderer) {
    isDrawable() {
        return true;
    }
    getTempTileOnLoading(tileInfo, tile) {
        if (tile.image && !tile.image.reset) return tile;
        const tempTerrain = this._createTerrainFromParent(tileInfo);
        tempTerrain.temp = true;
        if (!tile.image) tile.image = tempTerrain;
        delete tile.image.reset;
        tile.current = true;
        tile.info = tileInfo;
        extend(tile.image, tempTerrain);
        this._createMesh(tile.image, tileInfo);
        return tile;
    }
    _resetTerrainImage(info, image, skinImagesToDel) {
        image.reset = true;
        delete image.data;
        delete image.loadTime;
        delete image.rendered;
        delete image.minAltitude;
        const refKey = info.id + '-temp';
        const skinImages = image.skinImages;
        if (skinImages) for(let i = 0; i < skinImages.length; i++){
            const cachedImages = skinImages[i];
            if (!cachedImages) continue;
            for(let ii = 0; ii < cachedImages.length; ii++){
                const cached = cachedImages[ii];
                if (!cached) continue;
                cached.refs.delete(refKey);
                if (!cached.refs.size) skinImagesToDel.push(cached);
            }
            delete cachedImages.currentSkins;
            delete cachedImages.tileIds;
        }
        delete image.sourceZoom;
        delete image.skinImages;
        delete image.skinStatus;
        delete image.skinTileIds;
        if (image.debugTexture) {
            // need to rewrite debug text
            image.debugTexture.destroy();
            delete image.debugTexture;
        }
    }
    _createTerrainFromParent(tile, parentTile) {
        parentTile = parentTile || this.findParentTile(tile);
        while(parentTile && parentTile.image && (parentTile.image.sourceZoom === -1 || parentTile.image.originalError))parentTile = this.findParentTile(parentTile.info);
        const res = (parentTile && parentTile.info || tile).res;
        const error = this.getMap().pointAtResToDistance(1, 1, res);
        const heights = parentTile && parentTile.image && parentTile.image.data && this._clipParentTerrain(parentTile, tile);
        const sourceZoom = heights && parentTile.image.sourceZoom !== -1 ? parentTile.info.z : -1;
        if (!heights || heights.width <= 1) {
            // find sibling tile's minAltitude
            const minAltitude = this._findTileMinAltitude(tile, parentTile);
            return {
                data: createEmtpyTerrainHeights(minAltitude || 0, 5),
                minAltitude: minAltitude,
                mesh: EMPTY_TERRAIN_GEO,
                sourceZoom: sourceZoom
            };
        }
        const terrainWidth = heights.width;
        const mesh = createMartiniData(error, heights.data, terrainWidth);
        return {
            data: heights,
            mesh: mesh,
            sourceZoom: sourceZoom
        };
    }
    _findTileMinAltitude(tile, parentTile) {
        if (parentTile && parentTile.minAltitude) return parentTile.minAltitude;
        const { idx, idy, z } = tile;
        for(let i = -1; i <= 1; i++)for(let j = -1; j <= 1; j++){
            if (i === 0 && j === 0) continue;
            const id = this.layer.getTileId(idx + i, idy + j, z);
            const info = this.layer.tileInfoCache.get(id);
            if (info && info.minAltitude) return info.minAltitude;
        }
        return 0;
    }
    consumeTile(tileImage, tileInfo) {
        if (tileImage.empty && !tileImage.mesh) {
            const parentTile = this.findParentTile(tileInfo);
            if (!parentTile || parentTile.image && parentTile.image.empty) {
                tileImage.mesh = EMPTY_TERRAIN_GEO;
                const minAltitude = this._findTileMinAltitude(tileInfo);
                tileImage.data = createEmtpyTerrainHeights(minAltitude || 0, 5);
                tileImage.minAltitude = minAltitude;
                tileImage.sourceZoom = -1;
            } else tileImage = this._createTerrainFromParent(tileInfo, parentTile);
        }
        this._createMesh(tileImage, tileInfo);
        super.consumeTile(tileImage, tileInfo);
        this._recenterMapOnTerrain(tileInfo);
    }
    _createMesh(tileImage, tileInfo) {
        if (tileImage && tileImage.mesh) {
            // console.log(tileImage,tileInfo);
            tileImage.terrainMesh = this._painter.createTerrainMesh(tileInfo, tileImage);
            tileInfo.minAltitude = tileImage.data.min;
            tileInfo.maxAltitude = tileImage.data.max;
            delete tileImage.mesh;
            const tileInfoCache = this.layer.tileInfoCache;
            if (tileInfoCache && tileInfo.parent && !tileImage.empty && !tileImage.temp) {
                const parentNode = tileInfoCache.get(tileInfo.parent);
                if (parentNode) {
                    const { minAltitude, maxAltitude } = tileInfo;
                    if (parentNode.minAltitude === undefined || parentNode.minAltitude > minAltitude) parentNode.minAltitude = minAltitude;
                    if (parentNode.maxAltitude === undefined || parentNode.maxAltitude < maxAltitude) parentNode.maxAltitude = maxAltitude;
                }
            }
        }
    }
    _recenterMapOnTerrain(tileInfo) {
        const map = this.getMap();
        if (map.updateCenterAltitude && map.centerAltitude === undefined && tileInfo.z === this.getCurrentTileZoom()) {
            const prjCenter = map['_getPrjCenter']();
            const centerPoint = map['_prjToPointAtRes'](prjCenter, tileInfo.res, TEMP_POINT$3);
            if (tileInfo.extent2d.contains(centerPoint)) map.updateCenterAltitude();
        }
    }
    draw(timestamp, parentContext) {
        this._createPainter();
        this._painter.startFrame(parentContext);
        super.draw(timestamp, parentContext);
        this._endFrame(parentContext);
    }
    drawTile(tileInfo, tileImage) {
        const map = this.getMap();
        if (!tileInfo || !map || !tileImage) return;
        if (!this.drawingCurrentTiles && !this.drawingChildTiles) return;
        let opacity = this.drawingCurrentTiles ? this.getTileOpacity(tileImage) : 1;
        opacity *= this.layer.options.opacity || 1;
        this._painter.addTerrainImage(tileInfo, tileImage, opacity);
    }
    _drawTiles(tiles, parentTiles, childTiles, placeholders, context, missedTiles /* , incompleteTiles */ ) {
        const skinImagesToDel = [];
        //TODO tiles中如果存在empty瓦片，且sourceZoom精度不够的，可以重新切分精度更高的数据
        const tempTiles = this._getTempTilesForMissed(missedTiles, skinImagesToDel);
        pushIn(tiles, tempTiles);
        // this._tempTilesPool.shrink();
        this._newTerrainTileCounter = 0;
        const skinCount = this.layer.getSkinCount();
        const visitedSkinTiles = new Set();
        // 集中对每个SkinLayer调用renderTerrainSkin，减少 program 的切换开销
        // for (let i = 0; i < skinCount; i++) {
        //     this._renderChildTerrainSkin(i, incompleteTiles, visitedSkinTiles, skinImagesToDel);
        // }
        for(let i = 0; i < skinCount; i++)this._renderChildTerrainSkin(i, tiles, visitedSkinTiles, skinImagesToDel);
        for(let i = 0; i < tiles.length; i++)this._renderTerrainMeshSkin(tiles[i].info, tiles[i].image);
        for(let i = 0; i < skinImagesToDel.length; i++){
            if (skinImagesToDel[i]) {
                if (skinImagesToDel[i].texture && !skinImagesToDel[i].refs.size) {
                    this._skinImageCache.delete(skinImagesToDel[i].tile.id);
                    this._deleteSkinImage(skinImagesToDel[i]);
                }
            }
        }
        this._clearCachdeSkinImages();
        return super._drawTiles(...arguments);
    }
    _getTempTilesForMissed(missedTiles, skinImagesToDel) {
        const tempTiles = [];
        let pool = this._tempTilesPool;
        if (!pool) pool = this._tempTilesPool = new LRUPool(this.layer.options['tempTileCacheSize'], (tile)=>{
            const { info, image } = tile;
            this._deleteTerrainImage(info, image);
        });
        pool.resetCurrent(false);
        for(let i = 0; i < missedTiles.length; i++){
            const tileInfo = missedTiles[i];
            let tile;
            if (pool.has(tileInfo.id)) tile = pool.getAndRemove(tileInfo.id);
            else {
                tile = pool.pop();
                if (!tile) tile = {
                    info: tileInfo
                };
                else if (tile.image) {
                    this._resetTerrainImage(tile.info, tile.image, skinImagesToDel);
                    tile.image.temp = true;
                }
            }
            tile.current = true;
            pool.add(tileInfo.id, tile);
            tempTiles.push(tile);
        }
        for(let i = 0; i < missedTiles.length; i++)this.getTempTileOnLoading(missedTiles[i], tempTiles[i]);
        return tempTiles;
    }
    _clearCachdeSkinImages() {
        if (!this._skinImageCache) return;
        // 每十秒对skinImageCache做一次统一的排查回收，将没人引用的图片删除掉
        // 虽然流程中尽量做了删除，但skinImageCache中仍会出现没人引用的冗余image对象
        // 因为排查困难，且未来的逻辑修改可能会带来新的内存泄露，采用该机制至少能彻底防止skinImageCache中的
        const currentTimestamp = this.getCurrentTimestamp();
        if (this._clearSkinImageTimestamp && currentTimestamp - this._clearSkinImageTimestamp < 1000) return;
        const currentImages = new Set();
        for (const tile of this.tileCache.data.values())this._collectSkinImages(tile, currentImages);
        for(const p in this.tilesInView){
            const tile = this.tilesInView[p];
            this._collectSkinImages(tile, currentImages);
        }
        if (this._tempTilesPool) for (const tile of this._tempTilesPool.data.values())this._collectSkinImages(tile, currentImages);
        if (!currentImages.size) return;
        this._skinImageCache.forEach((v, id)=>{
            if (!currentImages.has(id)) {
                console.log('deleted:', id);
                this._deleteSkinImage(this._skinImageCache.get(id));
                this._skinImageCache.delete(id);
            }
        });
        this._clearSkinImageTimestamp = currentTimestamp;
    }
    _collectSkinImages(tile, currentImages) {
        const skinImages = tile.image && tile.image.skinImages;
        if (!skinImages || !skinImages.length) return;
        for(let i = 0; i < skinImages.length; i++){
            const currentSkins = skinImages[i] && skinImages.currentSkins;
            if (currentSkins) for (const tileId of currentSkins)currentImages.add(tileId);
        }
    }
    _renderChildTerrainSkin(skinIndex, terrainTiles, visitedSkinTiles, skinImagesToDel) {
        const skinLayer = this.layer.getSkinLayer(skinIndex);
        const renderer = skinLayer.getRenderer();
        if (!renderer) return;
        const layerSkinImages = [];
        for(let i = 0; i < terrainTiles.length; i++){
            const { info, image } = terrainTiles[i];
            if (this._prepareChildTerrainSkin(skinIndex, info, image, skinImagesToDel)) {
                const skinImages = terrainTiles[i].image.skinImages[skinIndex];
                for(let j = 0; j < skinImages.length; j++){
                    const tileId = skinImages[j].tile.info.id;
                    // 检查是否存在重复的瓦片，重复的瓦片只需要绘制一次
                    if (!visitedSkinTiles.has(tileId)) {
                        layerSkinImages.push(skinImages[j]);
                        visitedSkinTiles.add(tileId);
                    }
                }
            }
        }
        // render terrain skin of skin layer
        renderer.renderTerrainSkin(this.regl, this.layer, layerSkinImages);
    }
    _prepareChildTerrainSkin(skinIndex, terrainTileInfo, tileImage, skinImagesToDel) {
        const map = this.getMap();
        delete tileImage.path;
        if (!terrainTileInfo || !map || !tileImage) return false;
        const mesh = tileImage.terrainMesh;
        if (!mesh) return false;
        const skinLayer = this.layer.getSkinLayer(skinIndex);
        const renderer = skinLayer.getRenderer();
        if (!renderer) return false;
        if (!tileImage.skinImages) // if (map.isInteracting()) {
        //     const limit = this.layer.options['newTerrainTileRenderLimitPerFrameOnInteracting'];
        //     if (limit > 0 && this._newTerrainTileCounter > limit) {
        //         return false;
        //     }
        // }
        tileImage.skinImages = [];
        if (!tileImage.skinStatus) tileImage.skinStatus = [];
        if (!tileImage.skinTileIds) tileImage.skinTileIds = [];
        const isAnimating = renderer.isAnimating && renderer.isAnimating();
        const status = tileImage.skinStatus[skinIndex];
        const isLayerAskToRefresh = renderer.needToRefreshTerrainTileOnZooming && renderer.needToRefreshTerrainTileOnZooming();
        const needRefreshTerrainTile = isAnimating || isLayerAskToRefresh && tileImage.renderedZoom !== map.getZoom();
        if (status && !needRefreshTerrainTile) return false;
        const sr = skinLayer.getSpatialReference();
        const { x, y, z, res, offset } = terrainTileInfo;
        let nw = terrainTileInfo.nw;
        if (!nw) nw = terrainTileInfo.nw = this.getMap().pointAtResToCoord(terrainTileInfo.extent2d.getMin(POINT0$1), terrainTileInfo.res);
        const tileSize = this.layer.getTileSize().width;
        // const zoom = this.getCurrentTileZoom();
        const { res: myRes, zoom } = getSkinTileRes(sr, z, res);
        const myTileSize = skinLayer.getTileSize().width;
        const scale = getSkinTileScale(myRes, myTileSize, res, tileSize);
        let skinTileIds = tileImage.skinTileIds[skinIndex];
        if (!skinTileIds) {
            const terrainTileScaleY = this.layer['_getTileConfig']().tileSystem.scale.y;
            skinTileIds = tileImage.skinTileIds[skinIndex] = getCascadeTileIds(skinLayer, x, y, zoom, nw, offset, terrainTileScaleY, scale, SKIN_LEVEL_LIMIT);
        }
        const level0 = skinTileIds['0'];
        let complete = true;
        const tiles = [];
        for(let i = 0; i < level0.length; i++){
            const cachedTile = renderer.getCachedTile(level0[i], false);
            if (!cachedTile) {
                complete = false;
                const parentTile = renderer.findParentTile(level0[i]);
                if (parentTile) tiles.push(parentTile);
                continue;
            }
            // if (!cachedTile.info.terrainTileInfos) {
            //     // 预先存好terrain的tileIndex，vt图层中查询高程时，无需再单独计算
            //     cachedTile.info.terrainTileInfos = [];
            // }
            // if (cachedTile.info.terrainTileInfos.indexOf(terrainTileInfo) < 0) {
            //     cachedTile.info.terrainTileInfos.push(terrainTileInfo);
            // }
            tiles.push(cachedTile);
        }
        const skinImages = tileImage.skinImages[skinIndex] || [];
        skinImages.currentSkins = skinImages.currentSkins || new Set();
        const prevSkins = new Set();
        let skinImageRetired = false;
        for(let i = 0; i < skinImages.length; i++){
            if (!skinImages[i].tile) {
                skinImageRetired = true;
                continue;
            }
            const id = skinImages[i].tile.info.id;
            prevSkins.add(id);
        }
        if (!tiles.length) {
            skinImages.currentSkins.clear();
            tileImage.skinImages[skinIndex] = [];
            // this._clearPrevSkinImages(terrainTileInfo, tileImage, prevSkins, null, skinImagesToDel);
            return false;
        }
        const ids = tiles.length ? tiles.map((t)=>t.info.id).join() : tiles[0].info.id;
        if (!needRefreshTerrainTile && !skinImageRetired && skinImages.tileIds === ids) return false;
        skinImages.tileIds = ids;
        let updated = false;
        // if (skinImages.length < tiles.length) {
        skinImages.currentSkins.clear();
        skinImages.length = 0;
        const currentSkins = skinImages.currentSkins;
        let refKey = terrainTileInfo.id;
        if (tileImage.temp) refKey += '-temp';
        // 为每个 skin tile 创建一个 skin texture
        // 当 skin tile 范围比 terrain tile 更大时，每个 skin tile 只需绘制一次
        for(let i = 0; i < tiles.length; i++){
            const tileId = tiles[i].info.id;
            currentSkins.add(tileId);
            let cached = this._getCachedSkinImage(tileId);
            if (!cached || !isValidSkinImage(cached)) {
                cached = {
                    tile: extend({}, tiles[i]),
                    layer: skinLayer,
                    refs: new Set(),
                    texture: renderer.createTerrainTexture(this.regl)
                };
                this._saveCachedSkinImage(tileId, cached);
            }
            cached.refs.add(refKey);
            skinImages.push(cached);
            updated = true;
        }
        this._clearPrevSkinImages(terrainTileInfo, tileImage, prevSkins, currentSkins, skinImagesToDel);
        // }
        if (updated) this._newTerrainTileCounter++;
        tileImage.skinImages[skinIndex] = skinImages;
        skinLayer.fire('renderterrainskin', {
            tile: terrainTileInfo,
            skinTiles: tiles
        });
        if (complete) tileImage.skinStatus[skinIndex] = 1;
        return true;
    }
    _clearPrevSkinImages(terrainTileInfo, tileImage, prevSkins, currentSkins, skinImagesToDel) {
        if (!prevSkins.size) return;
        let refKey = terrainTileInfo.id;
        if (tileImage.temp) refKey += '-temp';
        for (const tileId of prevSkins)if (!currentSkins || !currentSkins.has(tileId)) {
            const cached = this._getCachedSkinImage(tileId);
            this._deleteCachedSkinImage(cached, refKey, skinImagesToDel);
        }
    }
    _getCachedSkinImage(id) {
        if (!this._skinImageCache) this._skinImageCache = new Map();
        return this._skinImageCache.get(id);
    }
    _saveCachedSkinImage(id, cached) {
        // console.log(this._skinImageCache.size);
        this._skinImageCache.set(id, cached);
    }
    _renderTerrainMeshSkin(terrainTileInfo, tileImage) {
        // render a terrain tile's skin
        const map = this.getMap();
        if (!terrainTileInfo || !map || !tileImage) return;
        const skinImages = tileImage.skinImages;
        // if (!skinImages) {
        //     return;
        // }
        const needRefreshSkins = this._needRefreshTerrainSkins(tileImage.renderedZoom);
        if (tileImage.rendered && !needRefreshSkins) return;
        if (!tileImage.skin) tileImage.skin = this._createTerrainTexture(terrainTileInfo, tileImage);
        else {
            TERRAIN_CLEAR.framebuffer = tileImage.skin;
            this.regl.clear(TERRAIN_CLEAR);
        }
        this._initSkinShader();
        const enableDebug = this.layer.options.debug;
        const meshes = [];
        const debugMeshes = enableDebug && [];
        const tileSize = this.layer.getTileSize().width;
        if (skinImages) for(let i = 0; i < skinImages.length; i++){
            const layerSkinImages = skinImages[i];
            for(let ii = 0; ii < layerSkinImages.length; ii++){
                const { tile, texture, layer } = layerSkinImages[ii];
                const hasOffset = tile.info.offset[0] || tile.info.offset[1];
                if (hasOffset && terrainTileInfo.skinTileIds) {
                    const skinTileIds = terrainTileInfo.skinTileIds[layer.getId()];
                    for(let j = 0; j < skinTileIds.length; j++)if (tile.info.x === skinTileIds[j].x && tile.info.y === skinTileIds[j].y) {
                        tile.info.offset = skinTileIds[j].offset;
                        break;
                    }
                }
                const skinDim = computeSkinDimension(terrainTileInfo, tile, tileSize);
                const mesh = layerSkinImages[ii].skinMesh || new $2wazW.Mesh(this._skinGeometry);
                mesh.setUniform('skinTexture', texture);
                const skinTileOpacity = layer.getOpacity();
                mesh.setUniform('opacity', isNil$1(skinTileOpacity) ? 1 : skinTileOpacity);
                mesh.setUniform('skinDim', skinDim);
                mesh.setUniform('tileSize', tileSize);
                mesh.setUniform('x', terrainTileInfo.x);
                mesh.setUniform('y', terrainTileInfo.y);
                layerSkinImages[ii].skinMesh = mesh;
                meshes.push(mesh);
            }
        }
        if (enableDebug) {
            const debugMesh = tileImage.skinDebugMesh || new $2wazW.Mesh(this._skinGeometry);
            debugMesh.setUniform('tileSize', tileSize);
            const debugTexture = tileImage.debugTexture || this._createDebugTexture(terrainTileInfo, tileSize, tileImage.temp);
            tileImage.debugTexture = debugTexture;
            tileImage.skinDebugMesh = debugMesh;
            debugMesh.setUniform('opacity', 1);
            debugMesh.setUniform('skinTexture', debugTexture);
            debugMesh.setUniform('skinDim', [
                0,
                0,
                1
            ]);
            debugMesh.setUniform('tileSize', tileSize);
            debugMeshes.push(debugMesh);
        }
        if (meshes.length) {
            this._skinScene.setMeshes(meshes);
            try {
                this.renderer.render(this._skinShader, null, this._skinScene, tileImage.skin);
            } catch (err) {
                console.error(tileImage);
                throw err;
            }
        }
        if (debugMeshes && debugMeshes.length && this.layer.options.debug) {
            this._skinScene.setMeshes(debugMeshes);
            this.renderer.render(this._skinShader, null, this._skinScene, tileImage.skin);
        }
        tileImage.rendered = this._isSkinReady(tileImage);
        tileImage.renderedZoom = map.getZoom();
    }
    _createDebugTexture(tileInfo, tileSize, isTemp) {
        tileSize *= 2;
        const { x, y, z } = tileInfo;
        const debugInfo = `terrain:${x}/${y}/${z}` + (isTemp ? '-temp' : '');
        const canvas = document.createElement('canvas');
        canvas.width = tileSize;
        canvas.height = tileSize;
        const ctx = canvas.getContext('2d');
        ctx.font = '20px monospace';
        const color = this.layer.options['debugOutline'];
        ctx.fillStyle = color;
        ctx.strokeStyle = color;
        ctx.fillText(debugInfo, 20, tileSize - 40);
        ctx.beginPath();
        ctx.lineWidth = 4;
        ctx.moveTo(0, 0);
        ctx.lineTo(tileSize, 0);
        ctx.lineTo(tileSize, tileSize);
        ctx.lineTo(0, tileSize);
        ctx.lineTo(0, 0);
        ctx.stroke();
        return this.regl.texture({
            data: canvas,
            flipY: true,
            mag: 'linear',
            min: 'linear'
        });
    }
    _createTerrainTexture(tileInfo /*, tileImage*/ ) {
        const tileSize = this.layer.getTileSize().width;
        // 乘以2是为了瓦片（缩放时）被放大后保持清晰度
        const width = tileSize * 2;
        const height = tileSize * 2;
        const regl = this.regl;
        const colorsTexture = tileInfo.colorsTexture;
        let color;
        if (colorsTexture && colorsTexture instanceof Uint8Array) color = regl.texture({
            data: colorsTexture,
            min: 'linear',
            mag: 'linear',
            type: 'uint8',
            width: width,
            height: height,
            flipY: true
        });
        else color = regl.texture({
            min: 'linear',
            mag: 'linear',
            type: 'uint8',
            width: width,
            height: height,
            flipY: true
        });
        const fboInfo = {
            width: width,
            height: height,
            colors: [
                color
            ],
            // stencil: true,
            // colorCount,
            colorFormat: 'rgba',
            ignoreStatusCheck: true,
            depthStencil: false,
            depth: false,
            stencil: false
        };
        const texture = regl.framebuffer(fboInfo);
        texture.colorTex = color;
        return texture;
    }
    _endFrame(context) {
        const renderCount = this._painter.endFrame(context);
        if (renderCount && !Object.keys(this.tilesLoading).length) this.layer.fire('terrainreadyandrender');
    }
    _clipParentTerrain(parentTile, tile) {
        const { image, info } = parentTile;
        const terrainData = image.data;
        const terrainWidth = terrainData.width;
        const { extent2d: parentExtent, res: parentRes } = info;
        const { extent2d, res } = tile;
        const width = parentExtent.getWidth();
        const height = parentExtent.getHeight();
        let xmin = (extent2d.xmin * res / parentRes - parentExtent.xmin) / width * (terrainWidth - 1);
        let ymin = (parentExtent.ymax - extent2d.ymax * res / parentRes) / height * (terrainWidth - 1);
        const xmax = (extent2d.xmax * res / parentRes - parentExtent.xmin) / width * (terrainWidth - 1);
        let tileWidth = Math.round(xmax - xmin);
        const log = Math.log2(tileWidth);
        tileWidth = Math.pow(2, Math.round(log)) + 1;
        xmin = Math.floor(xmin);
        ymin = Math.floor(ymin);
        // const tileSize = tileWidth - 1;
        // if (tileSize & (tileSize - 1)) {
        //     debugger
        // }
        // 先行再列
        const heights = new Float32Array(tileWidth * tileWidth);
        let min = Infinity;
        let max = -Infinity;
        for(let i = 0; i < tileWidth; i++)for(let j = 0; j < tileWidth; j++){
            let x = i + xmin;
            let y = j + ymin;
            if (x > terrainWidth - 1) x = terrainWidth - 1;
            else if (x < 0) x = 0;
            if (y > terrainWidth - 1) y = terrainWidth - 1;
            else if (y < 0) y = 0;
            const height = terrainData.data[x + y * terrainWidth];
            // if (height === undefined) {
            //     debugger
            // }
            heights[i + j * tileWidth] = height;
            if (height < min) min = height;
            if (height > max) max = height;
        }
        return {
            width: tileWidth,
            height: tileWidth,
            data: heights,
            min: min,
            max: max
        };
    }
    getTileOpacity(tileImage) {
        if (!this._isSkinReady(tileImage)) {
            this.resetTileLoadTime(tileImage);
            return 0;
        }
        return super.getTileOpacity(tileImage);
    }
    _isSkinReady(tileImage) {
        const skinCount = this.layer.getSkinCount();
        if (!skinCount) return true;
        if (!tileImage.skinStatus) // 还没有初始化
        return false;
        for(let i = 0; i < skinCount; i++){
            if (!tileImage.skinStatus[i]) return false;
        }
        return true;
    }
    _needRefreshTerrainSkins(renderedZoom) {
        // 只在有缩放地图，或者layer有动画时，才重绘skin
        const zoom = this.getMap().getZoom();
        const skinLayers = this.layer.getSkinLayers();
        for(let i = 0; i < skinLayers.length; i++){
            const renderer = skinLayers[i] && skinLayers[i].getRenderer();
            if (!renderer) continue;
            if (renderer.isAnimating && renderer.isAnimating()) return true;
            if (renderer.needToRefreshTerrainTileOnZooming && renderer.needToRefreshTerrainTileOnZooming() && renderedZoom !== zoom) return true;
        }
        return false;
    }
    isValidCachedTile(tile) {
        // parent或者child tile没有初始化时，也允许加到parentsTile里，执行初始化逻辑
        const notInitialized = !tile.image.skinStatus;
        return tile.image && !tile.image.temp && (notInitialized || this._isSkinReady(tile.image));
    }
    isTileComplete(tile) {
        return tile.image && !tile.image.temp && this._isSkinReady(tile.image);
    }
    _getTerrainWidth() {
        const layerOptions = this.layer.options;
        const tileSize = this.layer.getTileSize().width;
        return isNil$1(layerOptions.terrainWidth) ? tileSize / 4 + 1 : layerOptions.terrainWidth;
    }
    _getParentTileRequest(tile, createIfNotExists) {
        const maxAvailableZoom = this.layer.options['maxAvailableZoom'] - this.layer.options['zoomOffset'];
        const diff = tile.z - maxAvailableZoom;
        const scale = Math.pow(2, diff);
        const x = Math.floor(tile.x / scale);
        const y = Math.floor(tile.y / scale);
        const idx = Math.floor(tile.idx / scale);
        const idy = Math.floor(tile.idy / scale);
        const reqKey = getParentRequestKey(x, y);
        if (!this._parentRequests) this._parentRequests = {};
        const isFirst = !this._parentRequests[reqKey];
        if (isFirst && createIfNotExists) {
            this._parentRequests[reqKey] = new Set();
            this._parentRequests[reqKey].url = this.layer.getTileUrl(x, y, maxAvailableZoom + this.layer.options['zoomOffset']);
        }
        return {
            x: x,
            y: y,
            idx: idx,
            idy: idy,
            requests: this._parentRequests[reqKey],
            isFirst: isFirst,
            key: reqKey
        };
    }
    loadTile(tile) {
        const layer = this.layer;
        const terrainWidth = this._getTerrainWidth();
        const sp = layer.getSpatialReference();
        const res = sp.getResolution(tile.z);
        let error = this.getMap().pointAtResToDistance(1, 1, res);
        const zoomOffset = layer.options['zoomOffset'] || 0;
        const maxAvailableZoom = layer.options['maxAvailableZoom'] && layer.options['maxAvailableZoom'] - zoomOffset;
        if (maxAvailableZoom && tile.z > maxAvailableZoom) {
            // 检查 maxAvailableZoom 的tile是否存在，如果没有存在，则请求它，并在返回结果后clip
            const terrainData = this._createTerrainFromParent(tile);
            if (terrainData.sourceZoom === -1) {
                //改为请求maxAvailableZoom上的瓦片
                const { requests, isFirst, x, y, idx, idy } = this._getParentTileRequest(tile, true);
                requests.add(tile);
                if (!isFirst) return terrainData;
                const diff = tile.z - maxAvailableZoom;
                error = error * Math.pow(2, diff);
                const res = tile.res * Math.pow(2, diff);
                const args = [
                    x,
                    y,
                    maxAvailableZoom,
                    idx,
                    idy,
                    res,
                    tile.error * Math.pow(2, diff)
                ];
                tile = layer.createTileNode ? layer.createTileNode(...args) : layer._createTileNode(...args);
            } else {
                this.onTileLoad(terrainData, tile);
                return terrainData;
            }
        }
        const terrainUrl = tile.url;
        const terrainData = {};
        const layerOptions = layer.options;
        const tileSize = layer.getTileSize();
        const options = {
            terrainWidth: terrainWidth,
            type: layerOptions.type,
            accessToken: layerOptions.accessToken,
            cesiumIonTokenURL: layerOptions.cesiumIonTokenURL,
            error: error,
            colors: layerOptions.colors,
            tileSize: tileSize ? [
                tileSize.width,
                tileSize.height
            ] : [
                256,
                256
            ]
        };
        this.workerConn.fetchTerrain(terrainUrl, options, (err, resource)=>{
            if (this._parentRequests) {
                const reqKey = getParentRequestKey(tile.x, tile.y);
                const childTiles = this._parentRequests[reqKey];
                if (childTiles && childTiles.size) {
                    this.tileCache.add(tile.id, {
                        info: tile,
                        image: terrainData
                    });
                    for (const tile of childTiles)this.removeTileLoading(tile);
                }
                delete this._parentRequests[reqKey];
            }
            if (err) {
                if (err.canceled) return;
                console.warn(err);
                this.onTileError(terrainData, tile);
                return;
            }
            $gP1US.Util.extend(terrainData, resource);
            terrainExaggeration(terrainData, this.layer.options.exaggeration);
            // this.consumeTile(terrainData, tile);
            tile.colorsTexture = terrainData.colorsTexture;
            this.onTileLoad(terrainData, tile);
        });
        return terrainData;
    }
    deleteTile(tile) {
        if (!tile || !tile.image) return;
        super.deleteTile(tile);
        const { info, image } = tile;
        if (image.temp) return;
        delete info.skinTileIds;
        this._deleteTerrainImage(tile.info, image);
    }
    _deleteTerrainImage(tileInfo, image) {
        const skin = image.skin;
        if (skin) {
            skin.destroy();
            skin.colorTex.destroy();
            delete skin.colorTex;
        }
        if (image.debugTexture) {
            image.debugTexture.destroy();
            delete image.debugTexture;
            image.skinDebugMesh.dispose();
            delete image.skinDebugMesh;
        }
        const skinImages = image.skinImages;
        if (skinImages && skinImages.length) {
            let refKey = tileInfo.id;
            if (image.temp) refKey += '-temp';
            for(let i = 0; i < skinImages.length; i++){
                const layerSkinImages = skinImages[i];
                if (!layerSkinImages) continue;
                for(let ii = 0; ii < layerSkinImages.length; ii++){
                    if (!layerSkinImages[ii] || !layerSkinImages[ii].tile) continue;
                    const skinTileId = layerSkinImages[ii].tile.info.id;
                    const cached = this._skinImageCache && this._skinImageCache.get(skinTileId);
                    if (cached) this._deleteCachedSkinImage(cached, refKey);
                }
                layerSkinImages.length = 0;
            }
        }
        if (image.terrainMesh) this._painter.deleteMesh(image.terrainMesh);
        if (image.image && image.image.close) // imageBitmap
        image.image.close();
        delete image.skinImages;
        delete image.skin;
        delete image.skinStatus;
        delete image.skinTileIds;
        delete image.terrainMesh;
        delete image.image;
        delete image.data;
        delete image.mesh;
        delete image.rendered;
    // delete image.temp;
    }
    _deleteCachedSkinImage(cached, refKey, skinImagesToDel) {
        if (!cached) return;
        cached.refs.delete(refKey);
        if (!cached.refs.size) {
            if (skinImagesToDel) skinImagesToDel.push(cached);
            else this._deleteSkinImage(cached);
        }
    }
    _deleteSkinImage(cached) {
        if (!cached || !cached.tile) return;
        const skinTileId = cached.tile.info.id;
        const renderer = cached.layer.getRenderer();
        delete cached.canvas;
        delete cached.layer;
        cached.refs.clear();
        if (cached.texture) {
            if (!renderer) {
                if (cached.texture.destroy) cached.texture.destroy();
            } else renderer.deleteTerrainTexture(cached.texture);
            delete cached.texture;
        }
        if (cached.skinMesh) {
            cached.skinMesh.dispose();
            delete cached.skinMesh;
        }
        if (renderer) {
            if (renderer.removeTileCache) renderer.removeTileCache(skinTileId);
            if (renderer.deleteTile) renderer.constructor.prototype.deleteTile.call(renderer, cached.tile);
        }
        delete cached.tile;
        this._skinImageCache.delete(skinTileId);
    }
    _clearSkinImageCache() {
        if (!this._skinImageCache) return;
        const keys = this._skinImageCache.keys();
        for (const id of keys){
            const cached = this._getCachedSkinImage(id);
            this._deleteSkinImage(cached);
        }
        this._skinImageCache.clear();
    }
    abortTileLoading(tileImage, tileInfo) {
        const layer = this.layer;
        const maxAvailableZoom = layer.options.maxAvailableZoom && layer.options.maxAvailableZoom - layer.options.zoomOffset;
        if (tileInfo) {
            if (maxAvailableZoom && tileInfo.z > maxAvailableZoom) {
                const { requests, key } = this._getParentTileRequest(tileInfo);
                if (requests && requests.size) {
                    requests.delete(tileInfo);
                    if (!requests.size) {
                        // 中止 maxAvailableZoom 瓦片的请求
                        delete this._parentRequests[key];
                        if (this.workerConn) this.workerConn.abortTerrain(requests.url);
                    }
                }
            } else {
                if (tileInfo && tileInfo.url) {
                    if (this.workerConn) this.workerConn.abortTerrain(tileInfo.url);
                }
            }
        }
        super.abortTileLoading(tileImage, tileInfo);
    }
    onTileError(data, tile) {
        // TODO
        super.onTileError(data, tile);
    }
    _getTerrainTileAtPrjCoord(prjCoord) {
        const zoom = this.getCurrentTileZoom();
        const sp = this.layer.getSpatialReference();
        const res = sp.getResolution(zoom);
        const tileIndex = this.layer['_getTileConfig']().getTileIndex(prjCoord, res, this.layer.options['repeatWorld']);
        tileIndex.z = zoom;
        return tileIndex;
    }
    _queryTerrain(out, terrainTileId, tileIndex, worldPos, res) {
        const minZoom = this.layer.getMinZoom();
        const terrainData = this._findTerrainData(terrainTileId, tileIndex.x, tileIndex.y, tileIndex.z, minZoom);
        if (terrainData && terrainData.image && terrainData.image.data) {
            const extent2d = terrainData.info.extent2d;
            const terrainRes = terrainData.info.res;
            const scale = terrainRes / res;
            const x = worldPos.x - extent2d.xmin * scale;
            const y = extent2d.ymax * scale - worldPos.y;
            const altitude = this._queryAltitudeInHeights(terrainData.image.data, x / (extent2d.getWidth() * scale), y / (extent2d.getHeight() * scale));
            out[0] = altitude;
            out[1] = altitude === null ? 0 : +(terrainData.info.z === tileIndex.z);
        } else {
            out[0] = null;
            out[1] = 0;
        }
        return out;
    }
    _findTerrainData(terrainTileId, x, y, z, limit) {
        if (!terrainTileId) terrainTileId = this.layer['_getTileId'](x, y, z);
        const terrainData = this.tilesInView[terrainTileId] || this.tileCache.get(terrainTileId);
        if (!terrainData && z - 1 >= limit) return this._findTerrainData(null, Math.floor(x / 2), Math.floor(y / 2), z - 1, limit);
        return terrainData;
    }
    _queryAltitudeInHeights(terrainData, x, y) {
        const { width, height, data } = terrainData;
        // 减一是因为width索引范围是从0到width-1
        const tx = Math.floor((width - 1) * x);
        // 减一是因为height索引范围是从0到height-1
        const ty = Math.floor((height - 1) * y);
        const index = ty * width + tx;
        if (data[index] === undefined) return null;
        return data[index];
    }
    _queryTileAltitude(out, extent, targetRes) {
        if (!out) out = {
            tiles: {},
            dirty: true,
            complete: false
        };
        const layer = this.layer;
        const z = this.getCurrentTileZoom();
        const sp = layer.getSpatialReference();
        const res = sp.getResolution(z);
        const { xmin, ymin, xmax, ymax } = extent;
        const config = layer['_getTileConfig']();
        POINT0$1.set(xmin, ymin)._multi(targetRes);
        const minIndex = config['_getTileNum'](POINT0$1, targetRes, true);
        POINT1.set(xmax, ymax)._multi(targetRes);
        const maxIndex = config['_getTileNum'](POINT1, targetRes, true);
        const txmin = Math.min(minIndex.x, maxIndex.x);
        const txmax = Math.max(minIndex.x, maxIndex.x);
        const tymin = Math.min(minIndex.y, maxIndex.y);
        const tymax = Math.max(minIndex.y, maxIndex.y);
        const scale = targetRes / res;
        POINT0$1.set(xmin, ymin)._multi(scale);
        POINT1.set(xmax, ymax)._multi(scale);
        const extent2d = TEMP_EXTENT.set(POINT0$1.x, POINT0$1.y, POINT1.x, POINT1.y);
        // martini 需要一点多余的数据
        const terrainSize = layer.getTileSize().width + 1;
        // 扩大一个像素
        extent2d._expand(extent2d.getWidth() / terrainSize);
        out.array = out.array || new Float32Array(terrainSize * terrainSize);
        const tiles = out.tiles;
        out.complete = true;
        out.array.fill(0);
        for(let i = txmin; i <= txmax; i++)for(let j = tymin; j <= tymax; j++){
            const tileId = this.layer['_getTileId'](i, j, z);
            if (tiles[tileId]) continue;
            const terrainData = this.tileCache.get(tileId);
            // 如果当前瓦片找不到，则查询父级瓦片
            if (terrainData) {
                this._fillAltitudeData(out.array, terrainData, extent2d, terrainSize);
                out.dirty = true;
                tiles[tileId] = 1;
            } else {
                out.dirty = out.dirty || out.tiles[tileId] !== undefined;
                if (out.tiles[tileId]) delete out.tiles[tileId];
                out.complete = false;
            }
        }
        return out;
    }
    _fillAltitudeData(out, terrainData, extent2d, terrainSize) {
        const terrainExtent = terrainData.info.extent2d;
        const intersection = terrainExtent.intersection(extent2d);
        const { xmin, ymin, xmax, ymax } = intersection;
        const { data: terrain } = terrainData.image;
        const width = terrain.width;
        const unit = extent2d.getWidth() / terrainSize;
        const xstart = Math.floor((xmin - extent2d.xmin) / unit);
        const ystart = Math.floor((ymin - extent2d.ymin) / unit);
        const xend = Math.floor((xmax - extent2d.xmin) / unit);
        const yend = Math.floor((ymax - extent2d.ymin) / unit);
        const xspan = xend - xstart;
        const yspan = yend - ystart;
        const tunit = terrainExtent.getWidth() / width;
        const tstartx = Math.floor((xmin - terrainExtent.xmin) / tunit);
        const tstarty = Math.floor((ymin - terrainExtent.ymin) / tunit);
        const stride = Math.floor(unit / tunit);
        for(let i = 0; i <= xspan; i++)for(let j = 0; j <= yspan; j++){
            const index = i + xstart + (ystart + j) * terrainSize;
            let height = 0;
            for(let k = 0; k < stride; k++)for(let kk = 0; kk < stride; kk++){
                // const terrainIndex = tstartx + Math.floor(i * stride) + k + (tstarty + Math.floor(j * stride)) * width + kk;
                const terrainIndex = (tstartx + Math.floor(i * stride)) * width + k + tstarty + Math.floor(j * stride) + kk;
                height += terrain.data[terrainIndex];
            }
            out[index] = height / Math.max(stride, 1);
        // if (isNaN(out[index])) {
        //     debugger
        // }
        }
        return out;
    }
    clear() {
        this.clearTempResources();
        return super.clear();
    }
    clearTempResources() {
        if (this._tempTilesPool) {
            this._tempTilesPool.reset();
            delete this._tempTilesPool;
        }
        if (this._skinImageCache) this._clearSkinImageCache();
    }
    onAdd() {
        super.onAdd();
        this.prepareWorker();
    }
    onRemove() {
        if (this.workerConn) {
            this.workerConn.removeLayer(this.layer.getId(), (err)=>{
                if (err) throw err;
            });
            this.workerConn.remove();
            delete this.workerConn;
        }
        this.clearTempResources();
        if (this._skinShader) {
            this._skinShader.dispose();
            delete this._skinShader;
        }
        if (this._skinGeometry) {
            this._skinGeometry.dispose();
            delete this._skinGeometry;
        }
        delete this._parentRequests;
        super.onRemove();
        if (this._painter) {
            this._painter.delete();
            delete this._painter;
        }
    }
    prepareWorker() {
        const map = this.layer.getMap();
        if (!this.workerConn) this.workerConn = new TerrainWorkerConnection(map.id);
        const workerConn = this.workerConn;
        if (!workerConn.isActive()) return;
        const options = this.layer.options || {};
        const id = this.layer.getId();
        workerConn.addLayer(id, options, (err)=>{
            if (err) throw err;
            if (!this.layer) return;
            this.ready = true;
            this.setToRedraw();
            this.layer.fire('workerready');
        });
    }
    createContext() {
        const inGroup = this.canvas.gl && this.canvas.gl.wrap;
        if (inGroup) {
            this.gl = this.canvas.gl.wrap();
            this.regl = this.canvas.gl.regl;
        } else this._createREGLContext();
        this.renderer = new $2wazW.Renderer(this.regl);
        this.layer.fire('contextcreate', {
            regl: this.regl
        });
    }
    _createPainter() {
        const painter = this._painter;
        if (this.layer.options.shader === 'lit' || this.layer.options.shader === 'pbr') {
            if (painter && painter.constructor === TerrainPainter || !painter) {
                if (painter) {
                    painter.delete();
                    this.clear();
                    this.setToRedraw();
                }
                this._painter = new TerrainLitPainter(this.layer);
                this.layer.fire('paintercreated');
            }
        } else if (painter && painter.constructor === TerrainLitPainter || !painter) {
            if (painter) {
                painter.delete();
                this.clear();
                this.setToRedraw();
            }
            this._painter = new TerrainPainter(this.layer);
            this.layer.fire('paintercreated');
        }
    }
    _createREGLContext() {
        const layer = this.layer;
        const attributes = layer.options.glOptions || {
            alpha: true,
            depth: true,
            antialias: this.layer.options['antialias']
        };
        attributes.preserveDrawingBuffer = true;
        attributes.stencil = true;
        this.glOptions = attributes;
        this.gl = this.gl || this._createGLContext(this.canvas, attributes);
        // console.log(this.gl.getParameter(this.gl.MAX_VERTEX_UNIFORM_VECTORS));
        this.regl = (0, $9I15V.createREGL)({
            gl: this.gl,
            attributes: attributes,
            extensions: [
                'OES_element_index_uint'
            ],
            optionalExtensions: layer.options['glExtensions']
        });
    }
    _createGLContext(canvas, options) {
        const names = [
            'webgl',
            'experimental-webgl'
        ];
        let context = null;
        /* eslint-disable no-empty */ for(let i = 0; i < names.length; ++i){
            try {
                context = canvas.getContext(names[i], options);
            } catch (e) {}
            if (context) break;
        }
        return context;
    /* eslint-enable no-empty */ }
    resizeCanvas(canvasSize) {
        if (!this.canvas) return;
        super.resizeCanvas(canvasSize);
    }
    clearCanvas() {
        if (!this.canvas) return;
        super.clearCanvas();
    }
    _initSkinShader() {
        if (this._skinShader) return;
        const tileSize = this.layer.getTileSize().width;
        this._skinShader = new $2wazW.MeshShader({
            vert: skinVert,
            frag: skinFrag,
            extraCommandProps: {
                cull: {
                    enable: false
                },
                viewport: {
                    x: 0,
                    y: 0,
                    width: tileSize * 2,
                    height: tileSize * 2
                },
                depth: {
                    enable: false
                },
                stencil: {
                    enable: false
                },
                blend: {
                    enable: true,
                    func: {
                        src: 'one',
                        dst: 'one minus src alpha'
                    },
                    equation: 'add'
                }
            }
        });
        const aPosition = new Int8Array([
            -1,
            -1,
            1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1
        ]);
        this._skinGeometry = this._skinGeometry || new $2wazW.Geometry({
            aPosition: aPosition
        }, 0, 6, {
            positionSize: 2
        });
        this._skinGeometry.generateBuffers(this.regl);
        this._skinScene = this._skinScene || new $2wazW.Scene();
    }
    updateMaterial(mat) {
        if (!this._painter || !mat) return;
        if (!this._painter.updateMaterial) return;
        if (this._matVer === undefined) this._matVer = 1;
        this._painter.updateMaterial(mat, this._matVer++);
    }
    setMaterial(mat) {
        if (!this._painter || !mat) return;
        if (!this._painter.setMaterial) return;
        if (this._matVer === undefined) this._matVer = 1;
        this._painter.setMaterial(mat, this._matVer++);
    }
    getAnalysisMeshes() {
        if (this._painter && this._painter._leafScene) return this._painter._leafScene.getMeshes();
        return [];
    }
}
const SKIN_LEVEL_LIMIT = 1;
$gP1US.renderer.TileLayerCanvasRenderer.include({
    renderTerrainSkin (regl, terrainLayer, skinImages) {
        const tileSize = this.layer.getTileSize().width;
        const debug = terrainLayer.options['debug'];
        for(let i = 0; i < skinImages.length; i++){
            const { tile, texture } = skinImages[i];
            if (!tile.image) continue;
            const canvas = document.createElement('canvas');
            skinImages[i].canvas = canvas;
            canvas.width = tileSize;
            canvas.height = tileSize;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(tile.image, 0, 0);
            if (debug) {
                const { x, y, z } = tile.info;
                drawDebug(ctx, `${x}/${y}/${z}`, 'yellow', 1, 0, 0, tileSize, tileSize, -18);
            }
            texture({
                data: canvas,
                width: tileSize,
                height: tileSize,
                flipY: true,
                min: 'linear mipmap linear',
                mag: 'linear'
            });
        }
    },
    createTerrainTexture (regl) {
        const tileSize = this.layer.getTileSize().width;
        const config = {
            width: tileSize,
            height: tileSize,
            flipY: true,
            min: 'linear mipmap linear',
            mag: 'linear',
            depthStencil: false,
            depth: false,
            stencil: false
        };
        return regl.texture(config);
    },
    deleteTerrainTexture (texture) {
        texture.destroy();
    }
});
// function drawTileImage(ctx, extent, terrainOffset, tile, res, debug) {
//     const scale = tile.info.res / res;
//     const { info, image } = tile;
//     const offset = info.offset;
//     const width = image.width * scale;
//     const height = image.height * scale;
//     const xmin = info.extent2d.xmin * scale;
//     const ymax = info.extent2d.ymax * scale;
//     const left = xmin - extent.xmin;
//     const top = extent.ymax - ymax;
//     const dx = terrainOffset[0] - offset[0];
//     const dy = offset[1] - terrainOffset[1];
//     ctx.drawImage(image, left + dx, top + dy, width, height);
//     if (debug) {
//         const { x, y, z } = tile.info;
//         drawDebug(ctx, `${x}/${y}/${z}`, 'yellow', 1, left + dx, top + dy, width, height, -18);
//     }
// }
function drawDebug(ctx, debugInfo, color, lineWidth, left, top, width, height, textOffsetY = 0) {
    ctx.font = '20px monospace';
    ctx.fillStyle = color;
    DEBUG_POINT.y = height - 30;
    ctx.globalAlpha = 1;
    ctx.fillText(debugInfo, DEBUG_POINT.x + left, DEBUG_POINT.y + top + textOffsetY);
    ctx.globalAlpha = 0.6;
    ctx.strokeStyle = color;
    ctx.lineWidth = lineWidth;
    ctx.beginPath();
    ctx.moveTo(left, top);
    ctx.lineTo(left + width, top);
    ctx.lineTo(left + width, top + height);
    ctx.lineTo(left, top + height);
    ctx.lineTo(left, top);
    ctx.stroke();
    ctx.globalAlpha = 1;
}
function computeSkinDimension(terrainTileInfo, tile, terrainTileSize) {
    const { res, extent2d: terrainExtent, offset: terrainOffset } = terrainTileInfo;
    const { info } = tile;
    const scale = info.res / res;
    const offset = info.offset;
    const xmin = info.extent2d.xmin * scale;
    const ymin = info.extent2d.ymin * scale;
    const dx = terrainOffset[0] - offset[0];
    const dy = offset[1] - terrainOffset[1];
    const left = xmin - terrainExtent.xmin + dx;
    const bottom = terrainExtent.ymin - ymin + dy;
    return [
        left,
        -bottom,
        scale * info.tileSize / terrainTileSize
    ];
}
function isValidSkinImage(image) {
    return image && image.texture;
}
function getParentRequestKey(x, y) {
    return x + '-' + y;
}
const MASK_MODES = {
    'clip-inside': 0.1,
    'clip-outside': 0.2,
    'flat-inside': 0.3,
    'flat-outside': 0.4,
    'color': 0.5,
    'texture': 0.6,
    'elevate': 0.7
};
const QUAT = [], SCALE = [
    1,
    1,
    1
];
const DEFAULT_SYMBOL = {
    polygonFill: [
        255,
        0,
        0
    ],
    polygonOpacity: 0.8
};
const TRIANGLE_POINT_A = new (0, $gP1US.Coordinate)(0, 0), TRIANGLE_POINT_B = new (0, $gP1US.Coordinate)(0, 0), TRIANGLE$1 = [];
const TEMP_COORD = new (0, $gP1US.Coordinate)(0, 0), TEMP_POINT0 = new (0, $gP1US.Point)(0, 0), TEMP_POINT1 = new (0, $gP1US.Point)(0, 0), TEMP_POINT2 = new (0, $gP1US.Point)(0, 0);
class Mask extends (0, $gP1US.Polygon) {
    getMode() {
        return this._mode;
    }
    remove() {
        const layer = this.getLayer();
        if (!layer) return this;
        layer.removeMask(this);
        this._dispose();
        super.remove();
        return this;
    }
    getMesh(regl, ratio, minHeight) {
        if (!this.isVisible()) return null;
        if (!this._mesh) this._mesh = this._createMesh(regl, ratio, minHeight);
        this._updateUniforms(this._mesh, ratio, minHeight);
        return this._mesh;
    }
    setCoordinates(coordinates) {
        super.setCoordinates(coordinates);
        const layer = this.getLayer();
        if (layer) {
            delete layer['_maskProjViewMatrix'];
            delete layer['_maskExtentInWorld'];
        }
        if (!this._mesh) return this;
        const mode = this.getMode();
        const geojson = this.toGeoJSON();
        geojson.geometry.coordinates[0].reverse();
        const data = (0, $2wazW.earcut).flatten(geojson.geometry.coordinates);
        const { positions, uvs, triangles } = mode === 'texture' ? this._createBilinearPOSITON(data) : this._createPOSITION(data);
        const geometry = this._mesh.geometry;
        geometry.updateData('POSITION', positions);
        geometry.updateData('TEXCOORD', uvs);
        geometry.setElements(triangles);
        this._setLocalTransform(this._mesh);
    }
    _createGeometry(regl) {
        const mode = this.getMode();
        const geojson = this.toGeoJSON();
        geojson.geometry.coordinates[0].reverse();
        const data = (0, $2wazW.earcut).flatten(geojson.geometry.coordinates);
        const { positions, uvs, triangles } = mode === 'texture' ? this._createBilinearPOSITON(data) : this._createPOSITION(data);
        const geometry = new $2wazW.Geometry({
            POSITION: positions,
            TEXCOORD: uvs
        }, triangles, 0, {
            positionAttribute: 'POSITION',
            uv0Attribute: 'TEXCOORD'
        });
        geometry.generateBuffers(regl);
        return geometry;
    }
    _createPOSITION(data) {
        const map = this.getMap();
        const dimension = data.dimensions;
        for(let ii = 0; ii < data.vertices.length; ii += dimension){
            TEMP_COORD.x = data.vertices[ii];
            TEMP_COORD.y = data.vertices[ii + 1];
            const point = coordinateToWorld$2(map, TEMP_COORD);
            data.vertices[ii] = point[0];
            data.vertices[ii + 1] = point[1];
        }
        const centerPos = coordinateToWorld$2(map, this.getCenter());
        const pos = [];
        const idx = this.getLayer().getMasks().indexOf(this);
        const heightOffset = idx * 0.01;
        const len = this.getMode() === 'texture' ? 4 : data.vertices.length / dimension;
        for(let i = 0; i < len; i++){
            pos.push(data.vertices[i * dimension] - centerPos[0]);
            pos.push(data.vertices[i * dimension + 1] - centerPos[1]);
            pos.push(heightOffset);
        }
        const uvs = this._createTexcoords(data.vertices, dimension);
        const indices = (0, $2wazW.earcut)(pos, data.holes, 3);
        return {
            positions: pos,
            uvs: uvs,
            triangles: indices
        };
    }
    _createTexcoords(vertices, dimension) {
        const texcoords = [
            0.0,
            0.0,
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ];
        if (this.hasHoles()) {
            const count = vertices.length / dimension * 2;
            for(let i = texcoords.length / 2 - 1; i < count; i += 2)texcoords[i] = texcoords[i + 1] = 0.0;
        }
        return texcoords;
    }
    _createBilinearPOSITON(data) {
        const rows = 20;
        const cols = 20;
        const dimension = data.dimensions;
        const positions = [];
        const uvs = [];
        const indices = [];
        const map = this.getMap();
        for(let ii = 0; ii < data.vertices.length; ii += dimension){
            TEMP_COORD.x = data.vertices[ii];
            TEMP_COORD.y = data.vertices[ii + 1];
            const point = coordinateToWorld$2(map, TEMP_COORD);
            data.vertices[ii] = point[0];
            data.vertices[ii + 1] = point[1];
        }
        const centerPos = coordinateToWorld$2(this.getMap(), this.getCenter());
        const vertices = {};
        vertices['a'] = {
            x: data.vertices[0 * dimension] - centerPos[0],
            y: data.vertices[0 * dimension + 1] - centerPos[1]
        };
        vertices['b'] = {
            x: data.vertices[1 * dimension] - centerPos[0],
            y: data.vertices[1 * dimension + 1] - centerPos[1]
        };
        vertices['c'] = {
            x: data.vertices[2 * dimension] - centerPos[0],
            y: data.vertices[2 * dimension + 1] - centerPos[1]
        };
        vertices['d'] = {
            x: data.vertices[3 * dimension] - centerPos[0],
            y: data.vertices[3 * dimension + 1] - centerPos[1]
        };
        this._positions = [];
        for(let i = 0; i < 4; i++){
            this._positions.push(data.vertices[i * dimension] - centerPos[0]);
            this._positions.push(data.vertices[i * dimension + 1] - centerPos[1]);
            this._positions.push(0);
        }
        // 生成顶点
        for(let i = 0; i <= rows; i++)for(let j = 0; j <= cols; j++){
            const u = j / cols;
            const v = i / rows;
            // 双线性插值计算实际位置
            const x = (1 - u) * (1 - v) * vertices.a.x + u * (1 - v) * vertices.b.x + u * v * vertices.c.x + (1 - u) * v * vertices.d.x;
            const y = (1 - u) * (1 - v) * vertices.a.y + u * (1 - v) * vertices.b.y + u * v * vertices.c.y + (1 - u) * v * vertices.d.y;
            positions.push(x, y, 0);
            uvs.push(u, 1 - v); // 注意v坐标翻转
        }
        for(let i = 0; i < rows; i++)for(let j = 0; j < cols; j++){
            const a = i * (cols + 1) + j;
            const b = a + 1;
            const c = (i + 1) * (cols + 1) + j;
            const d = c + 1;
            indices.push(a, b, d);
            indices.push(a, d, c);
        }
        return {
            positions: positions,
            uvs: uvs,
            triangles: indices
        };
    }
    clearMesh() {
        this._dispose();
        delete this._mesh;
        if (this.maskGeoJSON) this.maskGeoJSON = null;
    }
    _getMaskMode() {
        return MASK_MODES[this._mode];
    }
    _getMaskColor() {
        const symbol = this.getSymbol();
        const { polygonFill, polygonOpacity } = symbol || DEFAULT_SYMBOL;
        const maskColor = normalizeColor([], polygonFill);
        maskColor[0] /= 255;
        maskColor[1] /= 255;
        maskColor[2] /= 255;
        maskColor[3] = isNumber$1(polygonOpacity) ? polygonOpacity : DEFAULT_SYMBOL.polygonOpacity;
        return maskColor;
    }
    _altitudeToPoint(altitude = 0) {
        const map = this.getMap();
        const res = map.getGLRes();
        return map.altitudeToPoint(altitude, res);
    }
    _setLocalTransform(mesh) {
        const map = this.getMap();
        const centerPos = coordinateToWorld$2(map, this.getCenter());
        const mMatrix = (0, $3iqbd).fromRotationTranslationScale(mesh.localTransform, (0, $k1dpP).identity(QUAT), centerPos, SCALE);
        mesh.localTransform = mMatrix;
    }
    _dispose() {
        if (!this._mesh) return;
        if (this._mesh.material) this._mesh.material.dispose();
        if (this._mesh.geometry) this._mesh.geometry.dispose();
        this._mesh.dispose();
        delete this._mesh;
    }
    containsPoint(coordinate) {
        const extent = this.getExtent();
        TEMP_COORD.set(coordinate[0], coordinate[1]);
        if (!extent || !extent.contains(TEMP_COORD)) return false;
        const holes = this.getHoles();
        for(let i = 0; i < holes.length; i++){
            if (this._contains(holes[i], coordinate)) return false;
        }
        const coordinates = this.getShell();
        return this._contains(coordinates, coordinate);
    }
    _contains(coordinates, coordinate) {
        const area = this._calArea(coordinates);
        let totalArea = 0;
        for(let i = 0; i < coordinates.length; i++){
            TRIANGLE_POINT_A.x = coordinates[i].x;
            TRIANGLE_POINT_A.y = coordinates[i].y;
            const index = i + 1 >= coordinates.length ? 0 : i + 1;
            TRIANGLE_POINT_B.x = coordinates[index].x;
            TRIANGLE_POINT_B.y = coordinates[index].y;
            TEMP_COORD.x = coordinate[0];
            TEMP_COORD.y = coordinate[1];
            TRIANGLE$1[0] = TEMP_COORD;
            TRIANGLE$1[1] = TRIANGLE_POINT_A;
            TRIANGLE$1[2] = TRIANGLE_POINT_B;
            const area = this._calArea(TRIANGLE$1);
            totalArea += area;
        }
        if (Math.abs(totalArea - area) > 1e-8) return false;
        return true;
    }
    _calArea(coordinates) {
        const map = this.getMap();
        let area = 0;
        const glRes = map.getGLRes();
        const point0 = map.coordToPointAtRes(coordinates[0], glRes, TEMP_POINT0);
        for(let i = 1; i < coordinates.length - 1; i++){
            const point1 = map.coordToPointAtRes(coordinates[i], glRes, TEMP_POINT1);
            const point2 = map.coordToPointAtRes(coordinates[i + 1], glRes, TEMP_POINT2);
            area += det(point0, point1, point2) / 2;
        }
        return area;
    }
}
//叉乘
function det(p0, p1, p2) {
    return (p1.x - p0.x) * (p2.y - p0.y) - (p1.y - p0.y) * (p2.x - p0.x);
}
const maskLayerEvents = [
    'shapechange',
    'heightrangechange',
    'flatheightchange'
];
const COORD_EXTENT = new (0, $gP1US.Coordinate)(0, 0);
const EXTENT_MIN = [
    0,
    0,
    0
], EXTENT_MAX = [
    0,
    0,
    0
];
const EMPTY_MAT4 = (0, $3iqbd).identity([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0
]);
function clearMasks() {
    if (!this['_maskList']) return this;
    this['_maskList'].forEach((mask)=>{
        mask.remove();
    });
    this['_maskList'] = [];
    this.updateMaskExtent('shapechange');
    return this;
}
function normalizeHeight(minHeight, maxHeight) {
    const min = minHeight === Infinity ? 0 : minHeight;
    const max = maxHeight === -Infinity ? 0 : maxHeight;
    const range = Math.abs(max - min);
    if (range === 0) return {
        ratio: 1,
        minHeight: 0
    };
    const ratio = Math.pow(range, -1);
    return {
        ratio: ratio,
        minHeight: min
    };
}
function hasVisibleMask() {
    for(let i = 0; i < this['_maskList'].length; i++){
        if (this['_maskList'][i].isVisible()) return true;
    }
    return false;
}
function MaskLayerMixin(Base) {
    return class MaskLayerMixin extends Base {
        removeMask(masks) {
            if (!this['_maskList']) return this;
            if (!masks) {
                clearMasks.call(this);
                return this;
            }
            const maskList = Array.isArray(masks) ? masks : [
                masks
            ];
            for(let i = 0; i < maskList.length; i++){
                const mask = maskList[i];
                const index = this['_maskList'].indexOf(mask);
                if (index > -1) this['_maskList'].splice(index, 1);
            }
            this.updateMaskExtent('shapechange');
            this['fire']('removemask', {
                masks: masks
            });
            return this;
        }
        setMask(masks) {
            this['removeMask'](null);
            if (!this['_maskList']) this['_maskList'] = [];
            if (Array.isArray(masks)) masks.forEach((mask)=>{
                this['_maskList'].push(mask);
            });
            else this['_maskList'].push(masks);
            this['_maskList'].forEach((mask)=>{
                mask['_bindLayer'](this);
                if (mask._updateCoordinates) mask._updateCoordinates();
            });
            this.updateMaskExtent('shapechange');
            this['fire']('setmask', {
                masks: masks
            });
            return this;
        }
        onAdd() {
            super['onAdd']();
            this.updateMaskExtent('shapechange');
        }
        getMasks() {
            return this['_maskList'] || [];
        }
        //@internal
        onGeometryEvent(param) {
            if (!param || !param['target']) return;
            const type = param['type'];
            if (type === 'shapechange' && param['target'] instanceof Mask) param['target'].clearMesh();
            if (param['target'] instanceof Mask && maskLayerEvents.indexOf(type) > -1) this.updateMaskExtent(type);
            if (super['onGeometryEvent']) super['onGeometryEvent'](param);
        }
        identifyMask(point, options) {
            const map = this['getMap']();
            if (!map) return [];
            if (!this['_maskList'] || !this['_maskList'].length) return [];
            const opts = extend({}, options);
            opts['excludeMasks'] = true; //此处调用identifyAtPoint时，不需要去identifyMask
            const identifyData = this['identifyAtPoint'](point, opts);
            const coordinate = identifyData.length && identifyData[0].coordinate;
            if (coordinate) {
                const masks = this['_maskList'];
                if (!masks) return [];
                const hits = [];
                for(let i = 0; i < masks.length; i++){
                    const maskMode = masks[i].getMode();
                    if (masks[i].containsPoint(coordinate) && (maskMode === 'color' || maskMode === 'texture')) hits.push(masks[i]);
                }
                return hits;
            }
            return [];
        }
        remove() {
            if (this['_maskList'] && this['_maskList'].length) this['_maskList'].forEach((mask)=>{
                mask.remove();
            });
            super['remove']();
        }
        updateMask(extent) {
            const map = this['getMap']();
            const { projViewMatrix, mapExtent } = this.getProjViewMatrixInOrtho(extent);
            COORD_EXTENT.x = mapExtent.xmin;
            COORD_EXTENT.y = mapExtent.ymin;
            const extentPointMin = coordinateToWorld$1(EXTENT_MIN, COORD_EXTENT, map);
            COORD_EXTENT.x = mapExtent.xmax;
            COORD_EXTENT.y = mapExtent.ymax;
            const extentPointMax = coordinateToWorld$1(EXTENT_MAX, COORD_EXTENT, map);
            const extentInWorld = [
                extentPointMin[0],
                extentPointMin[1],
                extentPointMax[0],
                extentPointMax[1]
            ];
            return {
                projViewMatrix: projViewMatrix,
                extentInWorld: extentInWorld
            };
        }
        getProjViewMatrixInOrtho(extent) {
            const map = this['getMap']();
            const preView = map.getView();
            const zoom = map.getFitZoom(extent);
            const center = extent.getCenter();
            map.setView({
                center: center,
                zoom: zoom,
                pitch: 0,
                bearing: 0
            });
            const mapExtent = map.getExtent();
            const pvMatrix = (0, $3iqbd).copy(EMPTY_MAT4, map.projViewMatrix);
            map.setView(preView);
            return {
                mapExtent: mapExtent,
                projViewMatrix: pvMatrix
            };
        }
        updateMaskExtent(type) {
            if (!this['_maskList']) return;
            const map = this['getMap']();
            if (!map) return;
            const renderer = this['getRenderer']();
            if (renderer && !this['_maskList'].length) {
                renderer['_clearMask']();
                return;
            }
            if (renderer && !hasVisibleMask.call(this)) {
                renderer['_deleteMaskUniforms']();
                renderer.setToRedraw();
                return;
            }
            const maskExtent = this.getMaskExtent();
            if (!maskExtent) return;
            const { extent, ratio, minHeight } = maskExtent;
            if (type || !this._maskProjViewMatrix || !this._maskExtentInWorld) {
                const { projViewMatrix, extentInWorld } = this.updateMask(extent);
                this._maskProjViewMatrix = projViewMatrix;
                this._maskExtentInWorld = extentInWorld;
            }
            if (renderer) renderer.setMask(this._maskExtentInWorld, this._maskProjViewMatrix, ratio, minHeight);
            else this['once']('renderercreate', (e)=>{
                e.renderer.setMask(this._maskExtentInWorld, this._maskProjViewMatrix, ratio, minHeight);
            });
        }
        getMaskExtent() {
            let xmin = Infinity, ymin = Infinity, xmax = -Infinity, ymax = -Infinity, maxheight = -Infinity, minheight = Infinity;
            let hasMaskInExtent = false;
            for(let i = 0; i < this['_maskList'].length; i++){
                const mask = this['_maskList'][i];
                if (!mask.isVisible()) continue;
                const extent = mask.getExtent();
                if (!extent) continue;
                hasMaskInExtent = true;
                if (extent.xmin < xmin) xmin = extent.xmin;
                if (extent.ymin < ymin) ymin = extent.ymin;
                if (extent.xmax > xmax) xmax = extent.xmax;
                if (extent.ymax > ymax) ymax = extent.ymax;
                if (mask._getHeightRange) {
                    const heightRange = mask._getHeightRange();
                    if (heightRange[0] < minheight) minheight = heightRange[0];
                    if (heightRange[1] > maxheight) maxheight = heightRange[1];
                }
            }
            if (!hasMaskInExtent) return null;
            const { ratio, minHeight } = normalizeHeight(minheight, maxheight);
            const extent = new (0, $gP1US.Extent)(xmin, ymin, xmax, ymax);
            return {
                extent: extent,
                ratio: ratio,
                minHeight: minHeight
            };
        }
    };
}
function coordinateToWorld$1(out, coordinate, map, z = 0) {
    if (!map || !(coordinate instanceof (0, $gP1US.Coordinate))) return null;
    const p = map.coordinateToPointAtRes(coordinate, map.getGLRes());
    out[0] = p.x;
    out[1] = p.y;
    out[2] = z;
    return out;
}
const COORD0 = new $gP1US.Coordinate(0, 0);
const TEMP_POINT$2 = new $gP1US.Coordinate(0, 0);
const POINT0 = new $gP1US.Point(0, 0);
const EMPTY_ARRAY = [];
const options$2 = {
    'forceRenderOnMoving': true,
    'forceRenderOnZooming': true,
    'forceRenderOnRotating': true,
    'fadeAnimation': false,
    'fadeDuration': 1000 / 60 * 15,
    'tileLimitPerFrame': 2,
    'newTerrainTileRenderLimitPerFrameOnInteracting': 1,
    'opacity': 1.0,
    'renderer': 'gl',
    'pyramidMode': 1,
    'tileSize': 512,
    'terrainWidth': null,
    'backZoomOffset': 0,
    'depthMask': true,
    'blendSrc': 'one',
    'blendDst': 'one minus src alpha',
    'requireSkuToken': true,
    'cesiumIonTokenURL': 'https://api.cesium.com/v1/assets/1/endpoint?access_token=',
    'tileRetryCount': 0,
    'shader': 'default',
    'terrainTileMode': true,
    'tempTileCacheSize': 64,
    'tileStackStartDepth': 7,
    'tileStackDepth': 6,
    'currentTilesFirst': false,
    'exaggeration': 1,
    'colors': []
};
const EMPTY_TILE_GRIDS = {
    tileGrids: [],
    count: 0
};
const SKU_ID = '01';
const TOKEN_VERSION = '1';
const base62chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
// terrain 的渲染流程：
// 1. TerrainLayer 计算有哪些瓦片, terrainTiles
// 2. 每个skinLayer根据 terrainTiles 计算出自己需求请求哪些瓦片 skinTiles（需要注意多个terrainTile可能共享skinTile）
// 3. 遍历 skinTiles，为每个 skinTiles 创建必要的 skinTexture，并绘制 skinTiles 到 skinTexture 中，因为做过去重，每个skinTile只会绘制一次
// 4. 遍历 terrainTiles， 为每个 terrainTiles 创建 terrainMesh，并在frag shader中合成 skinTiles 的 skinTexture，最终绘制到地图场景中
class TerrainLayer extends MaskLayerMixin($gP1US.TileLayer) {
    constructor(id, options){
        if (options && !options.tileSystem) {
            if (options.type === 'cesium' || options.type === 'cesium-ion') options.tileSystem = [
                1,
                1,
                -180,
                -90
            ];
            else if (options.type === 'tianditu') options.tileSystem = [
                1,
                -1,
                -180,
                90
            ];
        }
        if (!options.tileSize) {
            if (options.type === 'mapbox') options.tileSize = 512;
        }
        super(id, options);
    }
    onAdd() {
        const options = this.options;
        const map = this.getMap();
        const projection = map.getProjection();
        const is4326 = projection.code === "EPSG:4326" || projection.code === "EPSG:4490";
        const is3857 = projection.code === "EPSG:3857";
        if (options.tileSize === 512 && !options.spatialReference) {
            if (options.type === 'mapbox') {
                if (is4326) options.spatialReference = 'preset-4326-512';
                else if (is3857) options.spatialReference = 'preset-3857-512';
            } else if (options.type === 'cesium' || options.type === 'cesium-ion') options.spatialReference = 'preset-4326-512';
            else if (options.type === 'tianditu') options.spatialReference = {
                'projection': 'EPSG:4326',
                'fullExtent': {
                    'top': 90,
                    'left': -180,
                    'bottom': -90,
                    'right': 180
                },
                'resolutions': function() {
                    const resolutions = [];
                    for(let i = 0; i <= 22; i++)resolutions[i] = 90 / (Math.pow(2, i) * 128);
                    return resolutions;
                }()
            };
        }
        if (!options.terrainWidth && options.type === 'tianditu') // tianditu's terrainWidth has to be 65, decided by the terrain format
        options.terrainWidth = 65;
    }
    getTileUrl(x, y, z) {
        let terrainUrl = super.getTileUrl(x, y, z);
        const type = this.options.type;
        // if (type === 'cesium') {
        //     z = z - 1;
        //     const yTiles = 1 << z;
        //     y =  yTiles - y - 1;
        // }
        if (type === 'mapbox' && this.options['requireSkuToken']) {
            if (!this._skuToken) this._skuToken = this._createSkuToken();
            if (terrainUrl.indexOf('?') > -1) terrainUrl += '&sku=' + this._skuToken;
            else terrainUrl += '?sku=' + this._skuToken;
        } /* else if (type === 'cesium') {
            terrainUrl += '?extensions=octvertexnormals-watermask-metadata&v=1.2.0';
        }*/ 
        return terrainUrl;
    }
    getMaxAvailableZoom() {
        // 这里重载了TileLayer里的getMaxAvailableZoom，没有读取 layer.options.maxAvalibleZoom
        // 原因是在TerrainLayerRenderer中会用maxAvaibleZoom的瓦片数据，实时切分出当前请求请求的瓦片
        // 例如如果 maxAvailbleZoom 是14，16级的地形瓦片是从14级瓦片中切分出来的。
        // 这样可以让skin layer的渲染逻辑更简单明确
        const sr = this.getSpatialReference();
        return sr.getMaxZoom();
    }
    _createSkuToken() {
        // https://github.com/mapbox/mapbox-gl-js/blob/6971327e188b9aa045622925a59800aa8ee940ac/src/util/sku_token.js
        let sessionRandomizer = '';
        for(let i = 0; i < 10; i++)sessionRandomizer += base62chars[Math.floor(Math.random() * 62)];
        const token = [
            TOKEN_VERSION,
            SKU_ID,
            sessionRandomizer
        ].join('');
        return token;
    }
    setSkinLayers(skinLayers) {
        this._skinLayers = skinLayers;
        const renderer = this.getRenderer();
        if (renderer) {
            renderer.clear();
            renderer.setToRedraw();
        }
    }
    getSkinTiles(layer) {
        const renderer = this.getRenderer();
        if (!renderer) return EMPTY_TILE_GRIDS;
        const tileGrids = renderer.getTileGridsInCurrentFrame();
        const grid = tileGrids.tileGrids[0];
        if (!grid) return EMPTY_TILE_GRIDS;
        const layerId = layer.getId();
        const tileSysScale = this._getTileConfig().tileSystem.scale;
        const tileSize = layer.getTileSize().width;
        const tiles = grid.tiles;
        if (!tiles.length) return EMPTY_TILE_GRIDS;
        const map = this.getMap();
        const parents = grid.parents || EMPTY_ARRAY;
        const parentCount = parents.length;
        const allTiles = parents.concat(tiles);
        const sr = layer.getSpatialReference();
        const size = tiles[0].extent2d.getWidth();
        const dx = tileSysScale.x;
        const dy = tileSysScale.y;
        const parentSkinTiles = [];
        const skinTiles = [];
        const allSkinTileIds = new Set();
        const scaleY = this['_getTileConfig']().tileSystem.scale.y;
        for(let i = 0; i < allTiles.length; i++){
            const info = allTiles[i];
            const { res } = info;
            let nw = info.nw;
            if (!nw) nw = info.nw = map.pointAtResToCoord(info.extent2d.getMin(POINT0), info.res);
            const { res: skinRes, zoom } = getSkinTileRes(sr, info.z, res);
            const resScale = skinRes / res;
            const scale = getSkinTileScale(skinRes, tileSize, res, size);
            const { extent2d, offset } = info;
            const leftX = scale * info.x;
            const topY = scale * info.y;
            if (!info.skinTileIds) info.skinTileIds = {};
            if (!info.skinTileIds[layerId]) {
                const skinTileIds = new Set();
                const layerTiles = [];
                const tileIds = getTileIdsAtLevel(layer, info.x, info.y, zoom, nw, offset, dy, scale, 0);
                for(let j = 0; j < tileIds.length; j++){
                    const skinTile = tileIds[j];
                    if (skinTileIds.has(skinTile.id)) continue;
                    skinTile.idx = skinTile.x;
                    skinTile.idy = skinTile.y;
                    skinTile.res = skinRes;
                    skinTile.url = layer.getTileUrl(skinTile.x, skinTile.y, skinTile.z + layer.options['zoomOffset']);
                    const xOffset = dx * (skinTile.x - leftX) * tileSize;
                    const yOffset = dy * (skinTile.skinY - topY) * tileSize;
                    const xmin = extent2d.xmin * resScale + xOffset;
                    const ymax = extent2d.ymax * resScale + yOffset;
                    const ymin = extent2d.ymin * resScale + yOffset;
                    if (scaleY > 0) skinTile.extent2d = new $gP1US.PointExtent(xmin, ymin, xmin + tileSize, ymin + tileSize);
                    else skinTile.extent2d = new $gP1US.PointExtent(xmin, ymax - tileSize, xmin + tileSize, ymax);
                    skinTileIds.add(skinTile.id);
                    layerTiles.push(skinTile);
                }
                info.skinTileIds[layerId] = layerTiles;
            }
            const tileSkinTiles = info.skinTileIds[layerId];
            for(let j = 0; j < tileSkinTiles.length; j++)if (!allSkinTileIds.has(tileSkinTiles[j].id)) {
                if (i < parentCount) parentSkinTiles.push(tileSkinTiles[j]);
                else skinTiles.push(tileSkinTiles[j]);
                allSkinTileIds.add(tileSkinTiles[j].id);
            }
        }
        return {
            tileGrids: [
                {
                    extent: grid.extent,
                    tiles: skinTiles,
                    parents: parentSkinTiles,
                    count: skinTiles.length
                }
            ],
            count: skinTiles.length
        };
    }
    getSkinLayer(index) {
        return this.getSkinLayers()[index];
    }
    getSkinLayers() {
        return this._skinLayers || EMPTY_ARRAY;
    }
    getSkinCount() {
        return this._skinLayers && this._skinLayers.length || 0;
    }
    queryTerrainByProjCoord(prjCoord, out) {
        out = out || [];
        const renderer = this.getRenderer();
        if (!renderer) {
            out[0] = null;
            out[1] = 0;
            return out;
        }
        const map = this.getMap();
        const tileInfo = renderer._getTerrainTileAtPrjCoord(prjCoord);
        if (!tileInfo) {
            out[0] = null;
            out[1] = 0;
            return out;
        }
        const worldPos = map['_prjToPointAtRes'](prjCoord, 1, POINT0);
        return renderer._queryTerrain(out, tileInfo.id, tileInfo, worldPos, 1);
    }
    queryTileTerrainByProjCoord(prjCoord, tileId, tileIndex, out) {
        out = out || [];
        const renderer = this.getRenderer();
        if (!renderer) {
            out[0] = null;
            out[1] = 0;
            return out;
        }
        const map = this.getMap();
        const worldPos = map['_prjToPointAtRes'](prjCoord, 1, POINT0);
        return renderer._queryTerrain(out, tileId, tileIndex, worldPos, 1);
    }
    queryTileTerrainByPointAtRes(point, res, tileId, tileIndex, out) {
        out = out || [];
        const renderer = this.getRenderer();
        if (!renderer) {
            out[0] = null;
            out[1] = 0;
            return out;
        }
        return renderer._queryTerrain(out, tileId, tileIndex, point, res);
    }
    queryTerrain(coordinate, out) {
        out = out || [];
        const renderer = this.getRenderer();
        if (!renderer) {
            out[0] = null;
            out[1] = 0;
            return out;
        }
        const projection = this.getMap().getProjection();
        const projCoord = projection.project(coordinate, COORD0);
        return this.queryTerrainByProjCoord(projCoord, out);
    }
    queryTileMesh(tile, cb) {
        const renderer = this.getRenderer();
        if (!renderer) return;
        renderer._queryTileMesh(tile, cb);
    }
    getTerrainTiles(tileInfo) {
        const { x, y, z, res, offset } = tileInfo;
        const tileSize = tileInfo.extent2d.getWidth();
        const tc = this['_getTileConfig']();
        const sr = this.getSpatialReference();
        const { res: terrainRes, zoom } = getSkinTileRes(sr, z, res);
        const terrainTileSize = this.getTileSize().width;
        const scale = getSkinTileScale(terrainRes, terrainTileSize, res, tileSize);
        let nw = tileInfo.nw;
        if (!nw) nw = tileInfo.nw = this.getMap().pointAtResToCoord(tileInfo.extent2d.getMin(POINT0), tileInfo.res);
        const terrainTiles = getCascadeTileIds(this, x, y, zoom, nw, offset, tc.tileSystem.scale.y, scale, 1)[0];
        for(let i = 0; i < terrainTiles.length; i++){
            const { x: tx, y: ty } = terrainTiles[i];
            const nw = tc.getTilePointNW(tx, ty, terrainRes, POINT0);
            terrainTiles[i].res = terrainRes;
            terrainTiles[i].extent2d = new $gP1US.PointExtent(nw.x, nw.y, nw.x + terrainTileSize, nw.y - terrainTileSize);
        }
        return terrainTiles;
    }
    isTerrainTileLoaded(tileId) {
        const renderer = this.getRenderer();
        if (!renderer) return false;
        return renderer.isTileCached(tileId);
    }
    updateMaterial(mat) {
        if (!mat) return;
        if (!this.options['material']) this.options['material'] = {};
        extend(this.options['material'], mat);
        const renderer = this.getRenderer();
        if (!renderer) return;
        renderer.updateMaterial(mat);
    }
    setMaterial(mat) {
        if (!mat) return;
        this.options['material'] = mat;
        const renderer = this.getRenderer();
        if (!renderer) return;
        renderer.setMaterial(mat);
    }
    _createTileNode(x, y, z, idx, idy, res, error, parentId, extent2d, tileId) {
        const map = this.getMap();
        const zoomOffset = this.options['zoomOffset'];
        if (!extent2d) {
            const tileConfig = this._getTileConfig();
            extent2d = tileConfig.getTilePrjExtent(x, y, res).convertTo((c)=>map._prjToPointAtRes(c, res, TEMP_POINT$2));
        }
        const offset = this._getTileOffset(z);
        return {
            parent: parentId,
            layer: this.getId(),
            x: x,
            y: y,
            z: z,
            idx: idx,
            idy: idy,
            res: res,
            extent2d: extent2d,
            id: tileId || this._getTileId(x, y, z),
            url: this.getTileUrl(x, y, z + zoomOffset),
            offset: offset,
            error: error,
            children: []
        };
    }
}
// TerrainLayer.include({
//     getTileId: (x, y, z) => {
//         // always assume terrain layer is pyramid mode
//         // 由字符串操作改为数值操作，提升性能
//         const total = Math.pow(4, z + 1);
//         const row = Math.sqrt(total / 4);
//         return '' + (total + x * row + y);
//     }
// })
TerrainLayer.mergeOptions(options$2);
TerrainLayer.registerJSONType('TerrainLayer');
TerrainLayer.registerRenderer('gl', TerrainLayerRenderer);
const TRIANGLE = [], POS_A = [], POS_B = [], POS_C = [], TEMP_POINT$1 = new (0, $gP1US.Point)(0, 0), NULL_ALTITUDES = [];
const TEMP_VEC_AB = [], TEMP_VEC_AC = [];
const EMPTY_MAT = [];
const pA_VEC = [], pB_VEC = [], pC_VEC = [];
const INTERSECT_POINT = [];
const bboxIntersects = [];
class RayCaster {
    constructor(from, to, isLngLat = true){
        this._from = from;
        this._to = to;
        this._isLngLat = isLngLat;
    }
    setFromPoint(from) {
        this._from = Array.isArray(from) ? new (0, $gP1US.Coordinate)(from) : from;
    }
    setToPoint(to) {
        this._to = Array.isArray(to) ? new (0, $gP1US.Coordinate)(to) : to;
    }
    test(meshes, map, options = {}) {
        const count = options.count || 0;
        const results = [];
        let from = this._from;
        let to = this._to;
        if (this._isLngLat) {
            from = coordinateToWorld(map, this._from.x, this._from.y, this._from.z);
            to = coordinateToWorld(map, this._to.x, this._to.y, this._to.z);
        }
        const ray = new $gP1US.math.Ray(from, to);
        for(let i = 0; i < meshes.length; i++){
            const mesh = meshes[i];
            if (!this._checkBBox(mesh.getBoundingBox(), ray)) continue;
            const localTransform = mesh.localTransform;
            const geometry = mesh.geometry;
            const positions = geometry.data[geometry.desc.positionAttribute].array;
            const altitudes = geometry.data[geometry.desc.altitudeAttribute] && geometry.data[geometry.desc.altitudeAttribute].array || NULL_ALTITUDES;
            const geoIndices = geometry.indices;
            if (!positions || !positions.length || !geoIndices || !geoIndices.length) continue;
            const matrix = (0, $3iqbd).multiply(EMPTY_MAT, localTransform, mesh.positionMatrix);
            const coordinates = this._testMesh(mesh, ray, map, positions, altitudes, geoIndices, geometry.desc.positionSize, matrix, count);
            if (coordinates) {
                // const { coordinate, indices } = intersect;
                const result = {
                    mesh: mesh,
                    coordinates: coordinates
                };
                results.push(result);
                if (count !== 0 && results.length >= count) break;
            }
        }
        return results;
    }
    _testMesh(mesh, ray, map, positions, altitudes, indices, dim, matrix, count) {
        const coordinates = [];
        for(let j = 0; j < indices.length; j += 3){
            if (j > mesh.properties.skirtOffset) break;
            const a = indices[j];
            const b = indices[j + 1];
            const c = indices[j + 2];
            const positionsA = (0, $eIStk).set(pA_VEC, positions[a * dim], positions[a * dim + 1], positions[a * dim + 2]);
            const pA = this._toWorldPosition(POS_A, map, positionsA, altitudes[a] / 100, matrix);
            const positionsB = (0, $eIStk).set(pB_VEC, positions[b * dim], positions[b * dim + 1], positions[b * dim + 2]);
            const pB = this._toWorldPosition(POS_B, map, positionsB, altitudes[b] / 100, matrix);
            const positionsC = (0, $eIStk).set(pC_VEC, positions[c * dim], positions[c * dim + 1], positions[c * dim + 2]);
            const pC = this._toWorldPosition(POS_C, map, positionsC, altitudes[c] / 100, matrix);
            const triangle = (0, $eIStk).set(TRIANGLE, pA, pB, pC);
            const vAB = (0, $eIStk).sub(TEMP_VEC_AB, pA, pB);
            const vAC = (0, $eIStk).sub(TEMP_VEC_AC, pA, pC);
            const intersectPoint = this._testIntersection(INTERSECT_POINT, triangle, ray);
            if (intersectPoint) {
                const altitude = map.pointAtResToAltitude(intersectPoint[2], map.getGLRes());
                TEMP_POINT$1.x = intersectPoint[0];
                TEMP_POINT$1.y = intersectPoint[1];
                const coord = map.pointAtResToCoordinate(TEMP_POINT$1, map.getGLRes());
                coord.z = altitude;
                coordinates.push({
                    coordinate: coord,
                    indices: [
                        a,
                        b,
                        c
                    ],
                    normal: (0, $eIStk).cross([], vAB, vAC)
                });
                if (count !== 0 && coordinates.length >= count) break;
            }
        }
        return coordinates.length ? coordinates : null;
    }
    _toWorldPosition(out, map, pos, altitude, matrix) {
        let alt;
        if ((0, $gP1US.Util).isNumber(altitude)) {
            alt = map.altitudeToPoint(altitude, map.getGLRes());
            (0, $jxhwV).set(out, pos[0], pos[1], 0, 1);
            (0, $jxhwV).transformMat4(out, out, matrix);
            out[2] = alt;
        } else {
            (0, $jxhwV).set(out, pos[0], pos[1], pos[2], 1);
            (0, $jxhwV).transformMat4(out, out, matrix);
        }
        return out;
    }
    _testIntersection(out, triangle, ray) {
        return ray.intersectTriangle(triangle[0], triangle[1], triangle[2], true, out);
    }
    _checkBBox(bbox, ray) {
        if (!bbox) return false;
        return ray.intersectBox(bbox, bboxIntersects);
    }
}
const COORD = new (0, $gP1US.Coordinate)(0, 0);
function coordinateToWorld(map, x, y, z) {
    if (!map) return null;
    COORD.set(x, y);
    const p = map.coordinateToPointAtRes(COORD, map.getGLRes());
    const height = map.altitudeToPoint(z || 0, map.getGLRes());
    return [
        p.x,
        p.y,
        height
    ];
}
const options$1 = {
    renderer: 'gl',
    antialias: true,
    extensions: [],
    single: true,
    onlyWebGL1: false,
    optionalExtensions: [
        'ANGLE_instanced_arrays',
        'OES_element_index_uint',
        'OES_standard_derivatives',
        'OES_vertex_array_object',
        'OES_texture_half_float',
        'OES_texture_half_float_linear',
        'OES_texture_float',
        'OES_texture_float_linear',
        'WEBGL_depth_texture',
        'EXT_shader_texture_lod',
        'EXT_frag_depth',
        'EXT_texture_filter_anisotropic',
        // compressed textures
        'WEBGL_compressed_texture_astc',
        'WEBGL_compressed_texture_etc',
        'WEBGL_compressed_texture_etc1',
        'WEBGL_compressed_texture_pvrtc',
        'WEBGL_compressed_texture_s3tc',
        'WEBGL_compressed_texture_s3tc_srgb'
    ],
    forceRenderOnZooming: true,
    forceRenderOnMoving: true,
    forceRenderOnRotating: true,
    viewMoveThreshold: 100,
    geometryEvents: true,
    multiSamples: 4,
    forceRedrawPerFrame: false
};
//
const emptyMethod = ()=>{
    return;
};
const EMPTY_COORD0 = new $gP1US.Coordinate(0, 0);
const TEMP_VEC3 = [
    0,
    0,
    0
];
const coord0 = [
    0,
    0,
    0
], coord1 = [
    0,
    0,
    0
];
class GroupGLLayer extends $gP1US.Layer {
    /**
     * Reproduce a GroupGLLayer from layer's profile JSON.
     * @param  {Object} layerJSON - layer's profile JSON
     * @return {GroupGLLayer}
     * @static
     * @private
     * @function
     */ static fromJSON(layerJSON) {
        if (!layerJSON || layerJSON['type'] !== 'GroupGLLayer') return null;
        const layers = layerJSON['layers'].map((json)=>$gP1US.Layer.fromJSON(json));
        return new GroupGLLayer(layerJSON['id'], layers, layerJSON['options']);
    }
    /**
     * @param id    - layer's id
     * @param layers      - layers to add
     * @param  [options=null]          - construct options
     */ constructor(id, layers, options){
        super(id, options);
        this.layers = layers && layers.slice() || [];
        this.layers.forEach((layer)=>{
            if (layer.getMap()) throw new Error(`layer(${layer.getId()} is already added on map`);
        });
        this._checkChildren();
        this.sortLayersByZIndex();
        this._layerMap = {};
    }
    sortLayersByZIndex() {
        if (!this.layers || !this.layers.length) return;
        for(let i = 0, l = this.layers.length; i < l; i++)this.layers[i]['__group_gl_order'] = i;
        this.layers.sort(sortLayersByZIndex);
    }
    setSceneConfig(sceneConfig) {
        this.options.sceneConfig = sceneConfig;
        const renderer = this.getRenderer();
        if (renderer) renderer.updateSceneConfig();
        return this;
    }
    getSceneConfig() {
        return JSON.parse(JSON.stringify(this._getSceneConfig()));
    }
    //@internal
    _getSceneConfig() {
        return this.options.sceneConfig || {};
    }
    getGroundConfig() {
        const sceneConfig = this._getSceneConfig();
        return sceneConfig.ground;
    }
    getWeatherConfig() {
        const sceneConfig = this._getSceneConfig();
        return sceneConfig.weather;
    }
    /**
     * Add a new Layer.
     * @param layer - new layer
     * @param index - index to insert
     * @returns {GroupGLLayer} this
     */ addLayer(layer, index) {
        if (layer.getMap()) throw new Error(`layer(${layer.getId()}) is already added on map`);
        if (layer.options['renderer'] !== 'gl') throw new Error(`layer(${layer.getId()})'s renderer is canvas, not supported to be added to GroupGLLayer`);
        if (index === undefined) this.layers.push(layer);
        else this.layers.splice(index, 0, layer);
        this._checkChildren();
        this.sortLayersByZIndex();
        const renderer = this.getRenderer();
        if (!renderer) // not loaded yet
        return this;
        this._prepareLayer(layer);
        this._updateTerrainSkinLayers();
        renderer.setToRedraw();
        return this;
    }
    removeLayer(layer) {
        if ($gP1US.Util.isString(layer)) layer = this.getChildLayer(layer);
        const idx = this.layers.indexOf(layer);
        if (idx < 0) return this;
        const layerRenderer = layer.getRenderer();
        if (layerRenderer && layerRenderer.setTerrainHelper) layerRenderer.setTerrainHelper(null);
        layer['_doRemove']();
        this._unbindChildListeners(layer);
        delete this._layerMap[layer.getId()];
        this.layers.splice(idx, 1);
        const renderer = this.getRenderer();
        if (!renderer) // not loaded yet
        return this;
        this._updateTerrainSkinLayers();
        renderer.setToRedraw();
        return this;
    }
    clearLayers() {
        const layers = this.getLayers();
        for(let i = 0; i < layers.length; i++)if (layers[i]) layers[i].remove();
        return this;
    }
    //@internal
    _updatePolygonOffset() {
        let total = 0;
        for(let i = 0; i < this.layers.length; i++){
            const layer = this.layers[i];
            if (layer.setPolygonOffset && layer.getPolygonOffsetCount) total += layer.getPolygonOffsetCount();
        }
        let offset = 0;
        const len = this.layers.length;
        for(let i = len - 1; i >= 0; i--){
            const layer = this.layers[i];
            if (layer.setPolygonOffset && layer.getPolygonOffsetCount) {
                layer.setPolygonOffset(offset, total);
                offset += layer.getPolygonOffsetCount();
            }
        }
        this._polygonOffset = offset;
    }
    getPolygonOffsetCount() {
        return this._polygonOffset;
    }
    /**
     * Get children TileLayer
     * @returns {TileLayer[]}
     */ getLayers() {
        return this.layers.slice();
    }
    //@internal
    _getLayers() {
        return this.layers;
    }
    /**
     * 导出GroupGLLayer的序列化JSON对象，可以用于反序列化为一个GroupGLLayer对象。
     * @english
     * Export the GroupGLLayer's profile json. <br>
     * Layer's profile is a snapshot of the layer in JSON format. <br>
     * It can be used to reproduce the instance by [fromJSON]{@link Layer#fromJSON} method
     * @return layer's profile JSON
     */ toJSON() {
        const layers = [];
        if (this.layers) for(let i = 0; i < this.layers.length; i++){
            const layer = this.layers[i];
            if (!layer) continue;
            if (layer && layer.toJSON) layers.push(layer.toJSON());
        }
        const profile = {
            'type': this.getJSONType(),
            'id': this.getId(),
            'layers': layers,
            'options': this.config()
        };
        return profile;
    }
    onLoadEnd() {
        this.layers.forEach((layer)=>{
            this._prepareLayer(layer);
        });
        if (this.options['terrain']) this._initTerrainLayer();
        super.onLoadEnd();
    }
    //@internal
    _prepareLayer(layer) {
        const map = this.getMap();
        this._layerMap[layer.getId()] = layer;
        layer['_canvas'] = this.getRenderer().canvas;
        layer['_bindMap'](map);
        layer.once('renderercreate', this._onChildRendererCreate, this);
        // layer.on('setstyle updatesymbol', this._onChildLayerStyleChanged, this);
        layer.remove = ()=>{
            this.removeLayer(layer);
            layer.constructor.prototype.remove.call(layer);
            delete layer.remove;
            return this;
        };
        layer.load();
        this._bindChildListeners(layer);
    }
    onRemove() {
        this._removeTerrainLayer();
        this.layers.forEach((layer)=>{
            this._resetSkinLayer(layer);
            layer['_doRemove']();
            this._unbindChildListeners(layer);
        });
        this._layerMap = {};
        this.clearAnalysis();
        super.onRemove();
    }
    getChildLayer(id) {
        const layer = this._layerMap[id];
        return layer || null;
    }
    getLayer(id) {
        return this.getChildLayer(id);
    }
    //@internal
    _bindChildListeners(layer) {
        layer.on('show hide', this._onLayerShowHide, this);
        layer.on('idchange', this._onLayerIDChange, this);
    }
    //@internal
    _unbindChildListeners(layer) {
        layer.off('show hide', this._onLayerShowHide, this);
        layer.off('idchange', this._onLayerIDChange, this);
    }
    //@internal
    _onLayerShowHide() {
        const renderer = this.getRenderer();
        if (renderer) renderer.setToRedraw();
    }
    //@internal
    _onLayerIDChange(e) {
        const newId = e.new;
        const oldId = e.old;
        const layer = this.getLayer(oldId);
        delete this._layerMap[oldId];
        this._layerMap[newId] = layer;
    }
    //@internal
    _onChildRendererCreate(e) {
        e.renderer.clearCanvas = empty;
    }
    // _onChildLayerStyleChanged() {
    //     const renderer = (this as any).getRenderer();
    //     if (renderer) {
    //         renderer.setTaaOutdated();
    //     }
    // }
    // isVisible() {
    //     if (!super.isVisible()) {
    //         return false;
    //     }
    //     const children = this.layers;
    //     for (let i = 0, l = children.length; i < l; i++) {
    //         if (children[i].isVisible()) {
    //             return true;
    //         }
    //     }
    //     return false;
    // }
    //@internal
    _checkChildren() {
        const ids = {};
        this.layers.forEach((layer)=>{
            const layerId = layer.getId();
            if (ids[layerId]) throw new Error(`Duplicate child layer id (${layerId}) in the GroupGLLayer (${this.getId()})`);
            else ids[layerId] = 1;
        });
    }
    addAnalysis(analysis) {
        this._analysisTaskList = this._analysisTaskList || [];
        this._analysisTaskList.push(analysis);
        const renderer = this.getRenderer();
        if (renderer) renderer.setToRedraw();
    }
    removeAnalysis(analysis) {
        if (this._analysisTaskList) {
            const index = this._analysisTaskList.indexOf(analysis);
            if (index > -1) {
                this._analysisTaskList.splice(index, 1);
                analysis.remove();
            }
        }
        const renderer = this.getRenderer();
        if (renderer) renderer.setToRedraw();
    }
    clearAnalysis() {
        if (this._analysisTaskList) {
            this._analysisTaskList.forEach((analysis)=>{
                analysis.remove();
            });
            this._analysisTaskList = [];
        }
        const renderer = this.getRenderer();
        if (renderer) renderer.setToRedraw();
    }
    /**
     * 查询给定坐标上的数据要素
     *
     * @english
     * Identify the geometries on the given coordinate
     * @param  coordinate   - coordinate to identify
     * @param  options      - options
     * @return
     */ identify(coordinate, options) {
        const map = this.getMap();
        const renderer = this.getRenderer();
        if (!map || !renderer) return [];
        const cp = map.coordToContainerPoint(new $gP1US.Coordinate(coordinate));
        return this.identifyAtPoint(cp, options);
    }
    /**
     * 查询给定容器坐标（containerPoint）上的数据要素
     * @english
     * Identify the data at the given point
     * @param point - container point to identify
     * @param options - the identify options
     **/ identifyAtPoint(point, options = {}) {
        const isMapGeometryEvent = options.includeInternals;
        const childLayers = this.getLayers();
        const layers = options && options.childLayers || childLayers;
        const map = this.getMap();
        if (!map) return [];
        const count = isNil$1(options.count) ? 1 : options.count;
        let result = [];
        const len = layers.length;
        for(let i = len - 1; i >= 0; i--){
            const layer = layers[i];
            if (childLayers.indexOf(layer) < 0 || !layer.identifyAtPoint) continue;
            const geometryEvents = layer.options['geometryEvents'];
            if (isMapGeometryEvent && (geometryEvents === undefined || geometryEvents === false || geometryEvents === 0)) continue;
            if (layer.isGeometryListening && isMapGeometryEvent && options.eventTypes.indexOf('mousemove') >= 0) {
                if (!layer.isGeometryListening(options.eventTypes)) continue;
            }
            const picks = layer.identifyAtPoint(point, options);
            if (!picks || !picks.length) continue;
            const id = layer.getId();
            for(let j = 0; j < picks.length; j++)if (picks[j]) picks[j].layer = id;
            result.push(...picks);
        }
        if (options.orderByCamera) {
            const cameraPosition = map.cameraPosition;
            result.sort((a, b)=>{
                if (!b.point) return -1;
                else if (!a.point) return 1;
                return (0, $eIStk).dist(a.point, cameraPosition) - (0, $eIStk).dist(b.point, cameraPosition);
            });
        }
        if (count) result = result.slice(0, count);
        return result;
    }
    getTerrain() {
        return this.options.terrain;
    }
    setTerrain(info) {
        this.options.terrain = info;
        if (!this.getRenderer()) return this;
        this._initTerrainLayer();
        this.getMap().updateCenterAltitude();
        return this;
    }
    removeTerrain() {
        return this.setTerrain(null);
    }
    updateTerrainMaterial(mat) {
        if (!this._terrainLayer || !mat) return;
        if (!this.options.terrain.material) this.options.terrain.material = mat;
        else extend(this.options.terrain.material, mat);
        this._terrainLayer.updateMaterial(mat);
    }
    //@internal
    _initTerrainLayer() {
        const renderer = this.getRenderer();
        if (renderer) renderer.setToRedraw();
        const info = this.options['terrain'];
        if (this._terrainLayer) {
            const terrainLayer = this._terrainLayer;
            const options = terrainLayer.options;
            if (!info || options.urlTemplate !== info.urlTemplate || options.spatialReference !== info.spatialReference) this._removeTerrainLayer();
            else {
                for(const p in info){
                    if (p === 'material') terrainLayer.setMaterial(info[p]);
                    else if (p !== 'urlTemplate' && p !== 'spatialReference') terrainLayer.config(p, info[p]);
                }
                return this;
            }
        }
        this._resetTerrainSkinLayers();
        if (!info) return this;
        this._terrainLayer = new TerrainLayer('__terrain_in_group', info);
        this._updateTerrainSkinLayers();
        const terrainLayer = this._terrainLayer;
        terrainLayer.on('tileload', this._onTerrainTileLoad, this);
        this._prepareLayer(terrainLayer);
        const masks = info.masks;
        if (masks && masks.length) terrainLayer.setMask(masks);
        else terrainLayer.removeMask();
        this.fire('terrainlayercreated');
        return this;
    }
    queryTerrain(coord, out) {
        if (!this._terrainLayer) {
            if (out) {
                out[0] = null;
                out[1] = 0;
            }
            return [
                null,
                0
            ];
        }
        return this._terrainLayer.queryTerrain(coord, out);
    }
    // 结果需要与queryTerrain统一起来
    queryTerrainAtPoint(containerPoint) {
        if (!this._terrainLayer) return null;
        const terrainLayer = this._terrainLayer;
        const terrainRenderer = terrainLayer.getRenderer();
        const meshes = terrainRenderer.getAnalysisMeshes();
        return this._queryRayCast(containerPoint, meshes);
    }
    query3DTilesAtPoint(containerPoint) {
        const layers = this._getLayers();
        const tilesLayers = layers.filter((layer)=>layer && layer.isGeo3DTilesLayer);
        if (!tilesLayers.length) return null;
        const options = {
            excludeMasks: true
        };
        for(let i = 0; i < tilesLayers.length; i++){
            const renderer = tilesLayers[i].getRenderer();
            if (!renderer) continue;
            const hits = tilesLayers[i].identifyAtPoint(containerPoint, options);
            if (hits.length) return new $gP1US.Coordinate(hits[0].coordinate);
        }
        return null;
    }
    _queryRayCast(containerPoint, meshes) {
        const map = this.getMap();
        const glRes = map.getGLRes();
        map.getContainerPointRay(coord0, coord1, containerPoint);
        const raycaster = new RayCaster(coord0, coord1, false);
        const results = raycaster.test(meshes, map, {
            count: 1
        });
        const coordinates = [];
        results.forEach((result)=>{
            result.coordinates.forEach((c)=>{
                coordinates.push(c.coordinate);
            });
        });
        const from = map.pointAtResToCoordinate(new $gP1US.Point(coord0[0], coord0[1]), glRes, EMPTY_COORD0);
        from.z = coord0[2] / map.altitudeToPoint(1, glRes);
        const fromPoint = (0, $eIStk).set(TEMP_VEC3, from.x, from.y, from.z);
        coordinates.sort((a, b)=>{
            return (0, $eIStk).dist(a.toArray(), fromPoint) - (0, $eIStk).dist(b.toArray(), fromPoint);
        });
        return coordinates[0];
    }
    queryTerrainByProjCoord(projCoord, out) {
        if (!this._terrainLayer) {
            if (out) {
                out[0] = null;
                out[1] = 0;
            }
            return [
                null,
                0
            ];
        }
        return this._terrainLayer.queryTerrainByProjCoord(projCoord, out);
    }
    //@internal
    _updateTerrainSkinLayers() {
        if (!this._terrainLayer) return;
        const layers = this.layers;
        const skinLayers = [];
        for(let i = 0; i < layers.length; i++){
            if (!layers[i]) continue;
            const layer = layers[i];
            const renderer = layer.getRenderer();
            if (renderer.renderTerrainSkin) {
                if (renderer.deleteTile === emptyMethod) {
                    // 已经被初始化过了
                    skinLayers.push(layers[i]);
                    continue;
                }
                layer.getTiles = ()=>{
                    // debugger
                    return this._terrainLayer && this._terrainLayer.getSkinTiles(layer);
                };
                // 重载原有的drawTile方法
                // 如果renderer定义了drawTileOnTerrain，则代替原有的drawTile，否则用空方法代替
                if (renderer.drawTileOnTerrain) renderer.drawTile = (...args)=>{
                    return renderer.drawTileOnTerrain(...args);
                };
                else renderer.drawTile = emptyMethod;
                // skinLayer的deleteTile交由TerrainLayerRenderer.deleteTile中手动执行
                renderer.deleteTile = emptyMethod;
                skinLayers.push(layers[i]);
            }
            if (renderer.setTerrainHelper) renderer.setTerrainHelper(this._terrainLayer);
        }
        this._terrainLayer.setSkinLayers(skinLayers);
    }
    //@internal
    _resetSkinLayer(layer) {
        if (!isTerrainSkin(layer)) return;
        const renderer = layer.getRenderer();
        if (renderer) {
            if (renderer.setTerrainHelper) renderer.setTerrainHelper(null);
            if (renderer.clear) renderer.clear();
            delete renderer.drawTile;
            delete renderer.deleteTile;
        }
        delete layer.getTiles;
    }
    //@internal
    _resetTerrainSkinLayers() {
        const layers = this.layers;
        for(let i = 0; i < layers.length; i++){
            if (!layers[i]) continue;
            this._resetSkinLayer(layers[i]);
        }
    }
    //@internal
    _onTerrainTileLoad() {
        const renderer = this.getRenderer();
        if (renderer) renderer.setToRedraw();
    }
    //@internal
    _removeTerrainLayer() {
        if (this._terrainLayer) {
            const layer = this._terrainLayer;
            layer.off('tileload', this._onTerrainTileLoad, this);
            this._unbindChildListeners(layer);
            this._terrainLayer['_doRemove']();
            delete this._terrainLayer;
            this.fire('terrainlayerremoved');
        }
    }
    getTerrainLayer() {
        return this._terrainLayer;
    }
    //@internal
    _bindMap(...args) {
        if (this.options['single']) {
            const map = args[0];
            const layers = map.getLayers();
            for(let i = 0; i < layers.length; i++){
                if (layers[i] instanceof GroupGLLayer) throw new Error('Only one GroupGLLayer is allowed in a map instance. Set options.single to false if you want to add two or more GroupGLLayers.');
            }
        }
        return super['_bindMap'](...args);
    }
    fire(...args) {
        if (args[0] === 'layerload') {
            const layers = this._getLayers();
            for (const layer of layers){
                const renderer = layer.getRenderer();
                if (renderer && renderer.isRenderComplete()) layer.fire('layerload');
            }
        }
        //@ts-expect-error-error
        super.fire(...args);
    }
}
GroupGLLayer.mergeOptions(options$1);
GroupGLLayer.registerJSONType('GroupGLLayer');
GroupGLLayer.registerRenderer('gl', GroupGLLayerRenderer);
GroupGLLayer.registerRenderer('canvas', null);
function empty() {
    return;
}
function sortLayersByZIndex(a, b) {
    const c = a.getZIndex() - b.getZIndex();
    if (c === 0) return a['__group_gl_order'] - b['__group_gl_order'];
    return c;
}
function isTerrainSkin(layer) {
    if (!layer) return false;
    const renderer = layer.getRenderer();
    if (!renderer) return false;
    return !!renderer.renderTerrainSkin;
}
var SkyboxMode;
(function(SkyboxMode) {
    SkyboxMode[SkyboxMode["AMBIENT"] = 0] = "AMBIENT";
    SkyboxMode[SkyboxMode["REALISTIC"] = 1] = "REALISTIC";
})(SkyboxMode || (SkyboxMode = {}));
const PREFILTER_CUBE_SIZE = 512;
class LightManager {
    constructor(map){
        this._map = map;
        this._loader = new $2wazW.ResourceLoader();
    }
    getDirectionalLight() {
        return this._config && this._config.directional || {};
    }
    getAmbientLight() {
        return this._config && this._config.ambient || {};
    }
    getAmbientResource() {
        return this._iblMaps;
    }
    setConfig(config) {
        const oldConfig = this._config;
        this._urlModifier = config.urlModifier;
        this._config = JSON.parse(JSON.stringify(config));
        let ambientUpdate = false;
        if (!config || !config.ambient || !config.ambient.resource) {
            this._disposeCubeLight();
            ambientUpdate = oldConfig && oldConfig.ambient && oldConfig.ambient.resource;
        } else if (!oldConfig || !oldConfig.ambient || !ambientEqual(oldConfig.ambient, config.ambient)) {
            this._initAmbientResources();
            return;
        } else if (this._iblMaps) {
            if (config.ambient.prefilterCubeSize !== oldConfig.ambient && oldConfig.ambient.prefilterCubeSize) this._onHDRLoaded();
            ambientUpdate = true;
            if (config.ambient.resource.sh) this._iblMaps.sh = config.ambient.resource.sh;
        }
        this._map.fire('updatelights', {
            ambientUpdate: ambientUpdate
        });
    }
    _tryToGetREGLContext(map) {
        const layers = map.getLayers();
        for(let i = 0; i < layers.length; i++){
            const renderer = layers[i] && layers[i].getRenderer();
            if (!renderer) continue;
            if (renderer.regl) return renderer.regl;
        }
        const canvas = document.createElement('canvas');
        const regl = (0, (/*@__PURE__*/$parcel$interopDefault($9I15V)))({
            canvas: canvas,
            attributes: {
                depth: false,
                stencil: false,
                alpha: false
            },
            optionalExtensions: [
                'OES_standard_derivatives',
                'OES_texture_half_float',
                'OES_texture_half_float_linear',
                'OES_texture_float',
                'OES_texture_float_linear'
            ]
        });
        regl._temp = true;
        return regl;
    }
    _initAmbientResources() {
        const resource = this._config.ambient.resource;
        const url = resource && resource.url;
        if (!url) return;
        const images = [];
        let count = 0;
        let currentCount = 0;
        const onload = ()=>{
            currentCount++;
            if (currentCount >= count) this._onSkyboxLoaded(images);
        };
        const onerror = function() {
            throw new Error(`skybox image with url(${this.src}) failed to load, please check the image's url.`);
        };
        const urlModifier = this._urlModifier;
        if (url.top || url.nx) {
            // ambient with 6 images
            const { front, back, right, left, top, bottom } = url;
            const { nx, ny, px, py, nz, pz } = url;
            let envUrls;
            if (front) envUrls = [
                left,
                right,
                back,
                front,
                top,
                bottom
            ];
            else envUrls = [
                nx,
                px,
                nz,
                pz,
                py,
                ny
            ];
            count = envUrls.length;
            for(let i = 0; i < count; i++){
                const img = new Image();
                img.onload = onload;
                img.onerror = onerror;
                img.src = urlModifier && urlModifier(envUrls[i]) || envUrls[i];
                images[i] = img;
            }
        } else {
            const props = {
                url: resource.url,
                arrayBuffer: true,
                hdr: true,
                // type: 'uint8',
                // format: 'rgba',
                flipY: true
            };
            this._loader.setURLModifier(urlModifier);
            this._hdr = new $2wazW.Texture2D(props, this._loader);
            this._hdr.once('complete', ()=>{
                this._onHDRLoaded();
            });
            this._hdr.once('error', ()=>{
                this._onHDRError();
            });
        }
    }
    dispose() {
        this._disposeCubeLight();
    }
    _onHDRLoaded() {
        if (this._hdr) {
            this._iblMaps = this._createIBLMaps(this._hdr);
            // this._hdr.dispose();
            // delete this._hdr;
            this._map.fire('updatelights', {
                'ambientUpdate': true
            });
        }
    }
    _onHDRError() {
        this._map.fire('hdrerror');
    }
    _onSkyboxLoaded(images) {
        this._iblMaps = this._createIBLMaps(images);
        this._map.fire('updatelights', {
            'ambientUpdate': true
        });
    }
    _createIBLMaps(envTexture) {
        const config = this._config.ambient.resource;
        const cubeSize = config.prefilterCubeSize || PREFILTER_CUBE_SIZE;
        const regl = this._tryToGetREGLContext(this._map);
        const maps = $2wazW.pbr.PBRHelper.createIBLMaps(regl, {
            envTexture: Array.isArray(envTexture) ? envTexture : envTexture.getREGLTexture(regl),
            ignoreSH: !!config['sh'],
            envCubeSize: cubeSize,
            prefilterCubeSize: cubeSize,
            environmentExposure: this._config.ambient.exposure,
            format: 'array'
        });
        // hdr.dispose();
        if (config['sh']) {
            maps.sh = config['sh'];
            //兼容老的[[], [], ..]形式的sh
            if (Array.isArray(maps['sh'][0])) {
                const sh = maps['sh'];
                const flatten = [];
                for(let i = 0; i < sh.length; i++)flatten.push(...sh[i]);
                maps['sh'] = flatten;
            }
        } /* else {
            console.log(JSON.stringify(maps.sh));
        }*/ 
        if (regl._temp) {
            delete this._hdr;
            regl.destroy();
        }
        return maps;
    }
    _disposeCubeLight() {
        if (this._hdr) {
            this._hdr.dispose();
            delete this._hdr;
        }
        delete this._iblMaps;
    }
}
function ambientEqual(config0, config1) {
    if (!config0.resource) return false;
    if (config0.resource.url !== config1.resource.url) return false;
    return true;
}
(0, $gP1US.Map).include({
    setLights (config) {
        this.options['lights'] = config;
        this._initLightManager();
        return this;
    },
    getLights () {
        return this.options['lights'];
    },
    _initLightManager () {
        if (!this._lightManager) this._lightManager = new LightManager(this);
        this._lightManager.setConfig(this.getLights());
    },
    getLightManager () {
        if (!this._lightManager) // if (typeof console && !this._warned) {
        //     this._warned = true;
        //     // console.warn('map\'s light config is not set, use map.setLights(config) to set lights.');
        // }
        return null;
        return this._lightManager;
    }
});
(0, $gP1US.Map).addOnLoadHook(function() {
    if (this.options['lights']) this._initLightManager();
});
let postCanvas;
let regl;
let texture;
let emptyLutTexture;
let postProcess;
const CLEAR_COLOR = {
    color: [
        0,
        0,
        0,
        0
    ]
};
const DEFAULT_CONFIG = {
    enable: false
};
(0, $gP1US.Map).include({
    setPostProcessConfig (config) {
        this.options['postProcessConfig'] = config;
        return this;
    },
    getPostProcessConfig () {
        return this.options['postProcessConfig'];
    }
});
const drawLayerCanvas = (0, $gP1US.renderer).MapCanvasRenderer.prototype.drawLayerCanvas;
(0, $gP1US.renderer).MapCanvasRenderer.prototype.drawLayerCanvas = function() {
    const updated = drawLayerCanvas.apply(this, arguments);
    if (updated) doPostProcess(this, this.canvas);
    return updated;
};
const renderFrame = (0, $gP1US.renderer).MapCanvasRenderer.prototype.renderFrame;
(0, $gP1US.renderer).MapCanvasRenderer.prototype.renderFrame = function() {
    const rendered = renderFrame.apply(this, arguments);
    const config = this.map.getPostProcessConfig();
    //filmicGrain animation
    const grainConfig = config && config.filmicGrain;
    if (grainConfig && (grainConfig.enable === undefined || grainConfig.enable === true)) this.setLayerCanvasUpdated();
    return rendered;
};
function doPostProcess(renderer, canvas) {
    const config = renderer.map.getPostProcessConfig();
    if (!config || !config.enable) return;
    if (!postCanvas) createContext(canvas.width, canvas.height);
    if (postCanvas.width !== canvas.width || postCanvas.height !== canvas.height) {
        postCanvas.width = canvas.width;
        postCanvas.height = canvas.height;
    }
    regl.clear(CLEAR_COLOR);
    const grainConfig = config.filmicGrain || DEFAULT_CONFIG;
    if (grainConfig.enable === undefined) grainConfig.enable = true;
    const vignetteConfig = config.vignette || DEFAULT_CONFIG;
    if (vignetteConfig.enable === undefined) vignetteConfig.enable = true;
    const lutConfig = config.colorLUT || DEFAULT_CONFIG;
    if (lutConfig.enable === undefined) lutConfig.enable = true;
    if (!renderer._postProcessContext) renderer._postProcessContext = {};
    const context = renderer._postProcessContext;
    if (lutConfig.enable) {
        const url = lutConfig.lut;
        if (!context['lutTexture'] || context['lutTexture'].url !== url) {
            const image = new Image();
            image.onload = function() {
                const texInfo = {
                    data: image,
                    min: 'linear',
                    mag: 'linear'
                };
                const texture = context['lutTexture'] ? context['lutTexture'].texture(texInfo) : regl.texture(texInfo);
                context['lutTexture'] = {
                    url: url,
                    texture: texture
                };
                renderer.setLayerCanvasUpdated();
            };
            image.src = url;
        }
    }
    const uniforms = {
        'enableGrain': +!!grainConfig.enable,
        'grainFactor': grainConfig.factor === undefined ? 0.15 : grainConfig.factor,
        'timeGrain': performance.now(),
        'enableVignette': +!!vignetteConfig.enable,
        'lensRadius': vignetteConfig.lensRadius || [
            0.8,
            0.25
        ],
        'frameMod': 1,
        'enableLut': +!!lutConfig.enable,
        'lookupTable': context['lutTexture'] ? context['lutTexture'].texture : emptyLutTexture
    };
    if (!postProcess) postProcess = new PostProcess(regl);
    postProcess.postprocess(null, uniforms, texture({
        width: postCanvas.width,
        height: postCanvas.height,
        data: canvas,
        flipY: true,
        mag: 'linear',
        min: 'linear',
        mipmap: false
    }));
    if (grainConfig.enable) renderer.setLayerCanvasUpdated();
    renderer.context.drawImage(postCanvas, 0, 0, postCanvas.width, postCanvas.height);
}
function createContext(width, height) {
    postCanvas = document.createElement('canvas', width, height);
    // const viewport = {
    //     x: 0,
    //     y: 0,
    //     width: () => {
    //         return postCanvas.width;
    //     },
    //     height: () => {
    //         return postCanvas.height;
    //     }
    // };
    regl = (0, (/*@__PURE__*/$parcel$interopDefault($9I15V)))({
        canvas: postCanvas,
        attributes: {
            depth: false,
            stencil: false,
            alpha: true,
            antialias: false,
            premultipliedAlpha: false
        }
    });
    texture = regl.texture({
        mag: 'linear',
        min: 'linear',
        mipmap: false,
        flipY: true,
        width: width,
        height: height
    });
    emptyLutTexture = regl.texture();
}
const COLOR = [];
function clearShowOnly(mesh) {
    if (!mesh.properties.showOnlyTimestamp) return;
    delete mesh.properties.showOnlyTimestamp;
    restoreOldElements(mesh);
}
function saveOldElements(mesh, elements) {
    const geoProps = mesh.geometry.properties;
    if (!geoProps.oldElementsBeforeHighlight) geoProps.oldElementsBeforeHighlight = mesh.geometry.elements;
    if (geoProps.elements) {
        if (!geoProps.oldElementsArrBeforeHighlight) geoProps.oldElementsArrBeforeHighlight = geoProps.elements;
        geoProps.elements = elements;
    }
}
function restoreOldElements(mesh) {
    const oldElementsBeforeHighlight = mesh.geometry.properties.oldElementsBeforeHighlight;
    if (!oldElementsBeforeHighlight || mesh.geometry.elements === oldElementsBeforeHighlight) return;
    mesh.geometry.deleteElements();
    mesh.geometry.setElements(mesh.geometry.properties.oldElementsBeforeHighlight);
    if (mesh.geometry.properties.oldElementsArrBeforeHighlight) {
        mesh.geometry.properties.elements = mesh.geometry.properties.oldElementsArrBeforeHighlight;
        delete mesh.geometry.properties.oldElementsArrBeforeHighlight;
    }
    delete mesh.geometry.properties.hasInvisible;
    delete mesh.geometry.properties.oldElementsBeforeHighlight;
}
function showOnly(regl, mesh, items, timestamp, feaIdIndiceMap) {
    const { showOnlyTimestamp } = mesh.properties;
    if (!items) {
        if (showOnlyTimestamp) clearShowOnly(mesh);
        return;
    }
    if (timestamp === showOnlyTimestamp) return;
    mesh.properties.showOnlyTimestamp = timestamp;
    const ids = items.keys();
    const elements = [];
    for (const id of ids){
        if (!feaIdIndiceMap.has(id)) continue;
        const indices = feaIdIndiceMap.get(id);
        if (indices) pushIn(elements, indices);
    }
    saveOldElements(mesh, elements);
    if (mesh.geometry.elements !== mesh.geometry.properties.oldElementsBeforeHighlight && mesh.geometry.elements.destroy) mesh.geometry.deleteElements();
    const info = {
        data: elements,
        // type: mesh.geometry.getElementsType(elements),
        primitive: mesh.geometry.getPrimitive()
    };
    mesh.geometry.setElements(regl.elements(info));
    mesh.geometry.generateBuffers(regl);
}
function clearHighlight(mesh) {
    if (!mesh.properties.highlightTimestamp) return;
    const defines = mesh.defines;
    delete defines['HAS_HIGHLIGHT_COLOR'];
    delete defines['HAS_HIGHLIGHT_OPACITY'];
    mesh.setDefines(defines);
    delete mesh.properties.highlightTimestamp;
    restoreOldElements(mesh);
    deleteHighlightBloomMesh(mesh);
}
function highlightMesh(regl, mesh, highlighted, timestamp, feaIdIndiceMap) {
    const { highlightTimestamp } = mesh.properties;
    if (!highlighted) {
        if (highlightTimestamp) clearHighlight(mesh);
        return;
    }
    if (timestamp === highlightTimestamp) return;
    const isInstanced = mesh instanceof $2wazW.InstancedMesh;
    const vertexCount = isInstanced ? mesh.instanceCount : mesh.geometry.getVertexCount();
    let { aHighlightColor, aHighlightOpacity } = mesh.geometry.properties;
    if (aHighlightColor) aHighlightColor.fill(0);
    if (aHighlightOpacity) aHighlightOpacity.fill(255);
    let hasColor = false;
    let hasOpacity = false;
    const ids = highlighted.keys();
    let hlElements = null;
    let invisibleIds = null;
    for (const id of ids)if (feaIdIndiceMap.has(id)) {
        // update attribute data
        const highlightedData = highlighted.get(id);
        const { color, bloom, visible, nodeIndex } = highlightedData;
        if (!isNil$1(nodeIndex) && nodeIndex !== mesh.properties.nodeIndex) continue;
        let { opacity } = highlightedData;
        let normalizedColor;
        if (color) {
            if (!hasColor) {
                if (!aHighlightColor) aHighlightColor = new Uint8Array(vertexCount * 4);
                hasColor = true;
            }
            normalizedColor = normalizeColor255(COLOR, color);
        }
        opacity = isNil$1(opacity) ? 1 : opacity;
        if (opacity < 1) {
            if (!hasOpacity) {
                if (!aHighlightOpacity) {
                    aHighlightOpacity = new Uint8Array(vertexCount);
                    aHighlightOpacity.fill(255);
                }
                hasOpacity = true;
            }
        }
        if (visible === false) {
            if (!invisibleIds) invisibleIds = new Set();
            invisibleIds.add(id);
        }
        if (normalizedColor || opacity < 1 || bloom) {
            const indices = feaIdIndiceMap.get(id);
            if (indices) for(let j = 0; j < indices.length; j++){
                const idx = indices[j];
                if (normalizedColor) (0, $jxhwV).set(aHighlightColor.subarray(idx * 4, idx * 4 + 4), ...normalizedColor);
                if (opacity < 1) aHighlightOpacity[idx] = opacity * 255;
                if (bloom) {
                    if (!hlElements) hlElements = [];
                    hlElements.push(idx);
                }
            }
        }
    }
    const geometry = mesh.geometry;
    const defines = mesh.defines;
    if (hasColor) {
        if (isInstanced) {
            mesh.updateInstancedData('aHighlightColor', aHighlightColor);
            mesh.generateInstancedBuffers(regl);
        } else {
            if (!geometry.data.aHighlightColor) {
                geometry.data.aHighlightColor = aHighlightColor;
                geometry.generateBuffers(regl);
            } else geometry.updateData('aHighlightColor', aHighlightColor);
            geometry.properties.aHighlightColor = aHighlightColor;
        }
        defines['HAS_HIGHLIGHT_COLOR'] = 1;
    } else if (defines['HAS_HIGHLIGHT_COLOR']) {
        if (isInstanced) {
            mesh.updateInstancedData('aHighlightColor', aHighlightColor);
            mesh.generateInstancedBuffers(regl);
        } else geometry.updateData('aHighlightColor', aHighlightColor);
        delete defines['HAS_HIGHLIGHT_COLOR'];
    }
    if (hasOpacity) {
        if (isInstanced) {
            mesh.updateInstancedData('aHighlightOpacity', aHighlightOpacity);
            mesh.generateInstancedBuffers(regl);
        } else {
            if (!geometry.data.aHighlightOpacity) {
                geometry.data.aHighlightOpacity = aHighlightOpacity;
                geometry.generateBuffers(regl);
            } else geometry.updateData('aHighlightOpacity', aHighlightOpacity);
            geometry.properties.aHighlightOpacity = aHighlightOpacity;
        }
        defines['HAS_HIGHLIGHT_OPACITY'] = 1;
    } else if (defines['HAS_HIGHLIGHT_OPACITY']) {
        if (isInstanced) {
            mesh.updateInstancedData('aHighlightOpacity', aHighlightOpacity);
            mesh.generateInstancedBuffers(regl);
        } else geometry.updateData('aHighlightOpacity', aHighlightOpacity);
        delete defines['HAS_HIGHLIGHT_OPACITY'];
    }
    if (invisibleIds && invisibleIds.size > 0) {
        let elements = [];
        feaIdIndiceMap.forEach((value, key)=>{
            if (invisibleIds.has(key)) return;
            pushIn(elements, value);
        });
        geometry.properties.hasInvisible = true;
        saveOldElements(mesh, elements);
        const info = {
            data: elements,
            // type: geometry.getElementsType(elements),
            primitive: geometry.getPrimitive()
        };
        if (geometry.elements !== geometry.properties.oldElementsBeforeHighlight && geometry.elements.destroy) geometry.deleteElements();
        elements = regl.elements(info);
        geometry.setElements(elements);
        geometry.generateBuffers(regl);
    } else if (geometry.properties.hasInvisible) restoreOldElements(mesh);
    mesh.setDefines(defines);
    mesh.properties.highlightTimestamp = timestamp;
    let hlBloomMesh = mesh.properties.hlBloomMesh;
    if (hlElements && hlElements.length) {
        if (!hlBloomMesh) {
            const geo = new $2wazW.Geometry(geometry.data, hlElements, 0, geometry.desc);
            geo.generateBuffers(regl);
            const material = mesh.material;
            hlBloomMesh = new $2wazW.Mesh(geo, material, mesh.config);
            const uniforms = mesh.uniforms;
            for(const p in uniforms)Object.defineProperty(hlBloomMesh.uniforms, p, {
                enumerable: true,
                get: function() {
                    return mesh.getUniform(p);
                }
            });
            const defines = extend({}, mesh.defines);
            defines['HAS_BLOOM'] = 1;
            const localTransform = (0, $3iqbd).copy([], mesh.localTransform);
            const positionMatrix = (0, $3iqbd).copy([], mesh.positionMatrix);
            hlBloomMesh.setLocalTransform(localTransform);
            hlBloomMesh.setPositionMatrix(positionMatrix);
            extend(hlBloomMesh.properties, mesh.properties);
            extend(geo.properties, geometry.properties);
            hlBloomMesh.setDefines(defines);
            hlBloomMesh.bloom = 1;
        } else {
            const localTransform = (0, $3iqbd).copy(hlBloomMesh.localTransform, mesh.localTransform);
            const positionMatrix = (0, $3iqbd).copy(hlBloomMesh.positionMatrix, mesh.positionMatrix);
            hlBloomMesh.setLocalTransform(localTransform);
            hlBloomMesh.setPositionMatrix(positionMatrix);
            mesh.properties.hlBloomMesh.geometry.setElements(hlElements);
        }
        mesh.properties.hlBloomMesh = hlBloomMesh;
    } else if (hlBloomMesh) deleteHighlightBloomMesh(mesh);
}
function deleteHighlightBloomMesh(mesh) {
    if (!mesh) return;
    const { hlBloomMesh } = mesh.properties;
    if (hlBloomMesh) {
        const hlGeo = hlBloomMesh.geometry;
        if (hlGeo.elements && hlGeo.elements.destroy) hlGeo.deleteElements();
        hlBloomMesh.dispose();
        delete mesh.properties.hlBloomMesh;
    }
}
var highlight = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    clearHighlight: clearHighlight,
    clearShowOnly: clearShowOnly,
    deleteHighlightBloomMesh: deleteHighlightBloomMesh,
    highlightMesh: highlightMesh,
    showOnly: showOnly
});
//参考:
//  * https://blog.mapbox.com/introducing-heatmaps-in-mapbox-gl-js-71355ada9e6c
//  * https://codepen.io/fuzhenn/pen/vYOgQwX
// import { mat4, vec3 } from '@maptalks/reshader.gl';
const EMPTY_COLOR = [
    0,
    0,
    0,
    0
];
class HeatmapProcess {
    constructor(regl, sceneConfig, layer, colorStops, stencil, polygonOffset){
        this.renderer = new $2wazW.Renderer(regl);
        this.sceneConfig = sceneConfig;
        this._layer = layer;
        this._colorStops = colorStops;
        this._stencil = stencil;
        this._polygonOffset = polygonOffset || {
            factor: 0,
            units: 0
        };
        this._init();
        this._outputSize = [];
    }
    render(scene, uniforms, fbo) {
        this._check();
        const map = this._layer.getMap();
        this.renderer.regl.clear({
            color: EMPTY_COLOR,
            depth: 1,
            stencil: 0xFF,
            framebuffer: this._heatmapFBO
        });
        this.renderer.render(this._heatmapShader, uniforms, scene, this._heatmapFBO);
        const canvas = this._layer.getRenderer().canvas;
        this._outputSize[0] = canvas.width;
        this._outputSize[1] = canvas.height;
        const displayUniforms = extend({
            colorRamp: this._colorRampTex,
            inputTexture: this._heatmapFBO,
            projViewMatrix: map.projViewMatrix,
            textureOutputSize: this._outputSize
        }, uniforms);
        this._transformGround();
        return this.renderer.render(this._displayShader, displayUniforms, this._groundScene, fbo);
    }
    dispose() {
        if (this._heatmapShader) {
            this._heatmapShader.dispose();
            delete this._heatmapShader;
        }
        if (this._displayShader) {
            this._displayShader.dispose();
            delete this._displayShader;
        }
        if (this._ground) {
            this._ground.geometry.dispose();
            this._ground.dispose();
            delete this._ground;
            delete this._groundScene;
        }
        if (this._heatmapFBO) {
            this._heatmapFBO.destroy();
            delete this._heatmapFBO;
        }
    }
    _createColorRamp() {
        const colorStops = this._colorStops;
        let canvas = this._rampCanvas;
        let ctx = this._rampCtx;
        if (!ctx) {
            canvas = this._rampCanvas = document.createElement('canvas');
            canvas.width = 256;
            canvas.height = 1;
            ctx = this._rampCtx = canvas.getContext('2d');
        } else ctx.clearRect(0, 0, 256, 1);
        const gradient = ctx.createLinearGradient(0, 0, 256, 1);
        for(let i = 0; i < colorStops.length; i++)gradient.addColorStop(colorStops[i][0], colorStops[i][1]);
        ctx.fillStyle = gradient;
        ctx.fillRect(0, 0, 256, 1);
        if (this._colorRampTex) this._colorRampTex.destroy();
        const regl = this.renderer.regl;
        this._colorRampTex = regl.texture({
            width: 256,
            height: 1,
            data: canvas,
            min: 'linear',
            mag: 'linear',
            premultiplyAlpha: true
        });
    }
    _check() {
        const canvas = this._layer.getRenderer().canvas;
        const width = Math.ceil(canvas.width / 4);
        const height = Math.ceil(canvas.height / 4);
        const fbo = this._heatmapFBO;
        if (fbo.width !== width || fbo.height !== height) fbo.resize(width, height);
    }
    _init() {
        this._createColorRamp();
        this._createShader();
        this._createHeatmapTex();
        this._createGround();
    }
    _createGround() {
        const planeGeo = new $2wazW.Plane();
        planeGeo.generateBuffers(this.renderer.regl);
        this._ground = new $2wazW.Mesh(planeGeo);
        this._groundScene = new $2wazW.Scene([
            this._ground
        ]);
    }
    _transformGround() {
        const map = this._layer.getMap();
        const localTransform = GroundPainter.getGroundTransform(this._ground.localTransform, map);
        this._ground.setLocalTransform(localTransform);
    }
    _createHeatmapTex() {
        const canvas = this._layer.getRenderer().canvas;
        const regl = this.renderer.regl;
        const colorType = regl.hasExtension('OES_texture_half_float') ? 'half float' : 'float';
        const width = Math.ceil(canvas.width / 4);
        const height = Math.ceil(canvas.height / 4);
        const tex = regl.texture({
            width: width,
            height: height,
            type: colorType,
            min: 'linear',
            mag: 'linear',
            format: 'rgba'
        });
        this._heatmapFBO = regl.framebuffer({
            width: width,
            height: height,
            color: [
                tex
            ]
        });
    }
    _createShader() {
        const layer = this._layer;
        const canvas = layer.getRenderer().canvas;
        const depthRange = this.sceneConfig.depthRange;
        const extraCommandProps = {
            viewport: {
                x: 0,
                y: 0,
                width: ()=>{
                    return canvas ? Math.ceil(canvas.width / 4) : 1;
                },
                height: ()=>{
                    return canvas ? Math.ceil(canvas.height / 4) : 1;
                }
            },
            depth: {
                enable: true,
                func: 'always'
            }
        };
        if (this._stencil) extraCommandProps.stencil = this._stencil;
        this._heatmapShader = new $2wazW.HeatmapShader({
            extraCommandProps: extraCommandProps
        });
        this._displayShader = new $2wazW.HeatmapDisplayShader({
            x: 0,
            y: 0,
            width: ()=>{
                return canvas ? canvas.width : 1;
            },
            height: ()=>{
                return canvas ? canvas.height : 1;
            }
        }, {
            extraCommandProps: {
                stencil: {
                    enable: false
                },
                depth: {
                    enable: true,
                    range: depthRange || [
                        0,
                        1
                    ],
                    func: '<='
                },
                polygonOffset: {
                    enable: true,
                    offset: this._polygonOffset
                },
                scissor: {
                    enable: false
                }
            }
        });
    }
}
class ClipMask extends Mask {
    constructor(coordinates, options){
        super(coordinates, options);
    }
    _createMesh(regl) {
        const geometry = this._createGeometry(regl);
        const mesh = new $2wazW.Mesh(geometry);
        this._setDefines(mesh);
        this._setLocalTransform(mesh);
        return mesh;
    }
    _updateUniforms(mesh, ratio, minHeight) {
        const maskMode = this._getMaskMode();
        mesh.setUniform('maskMode', maskMode);
        const color = this._getMaskColor();
        mesh.setUniform('maskColor', color);
        if (isNumber$1(ratio)) {
            const heightRange = this._getHeightRange();
            heightRange[0] = (heightRange[0] - minHeight) * ratio;
            heightRange[1] = (heightRange[1] - minHeight) * ratio;
            mesh.setUniform('heightRange', heightRange);
        }
    }
    setHeightRange(heightRange) {
        this.options.heightRange = heightRange;
        this['_fireEvent']('heightrangechange');
    }
    getHeightRange() {
        return this.options.heightRange;
    }
    _getHeightRange() {
        const heightRange = [
            0,
            0
        ];
        if (this.options.heightRange) {
            heightRange[0] = this._altitudeToPoint(this.options.heightRange[0]);
            heightRange[1] = this._altitudeToPoint(this.options.heightRange[1]);
        }
        return heightRange;
    }
    _setDefines(mesh) {
        const defines = mesh.getDefines();
        defines['HAS_MASK_COLOR'] = 1;
        mesh.setDefines(defines);
    }
}
class ClipInsideMask extends ClipMask {
    constructor(coordinates, options){
        super(coordinates, options);
        this._mode = 'clip-inside';
    }
}
class ClipOutsideMask extends ClipMask {
    constructor(coordinates, options){
        super(coordinates, options);
        this._mode = 'clip-outside';
    }
}
class FlatMask extends Mask {
    constructor(coordinates, options){
        super(coordinates, options);
    }
    setFlatheight(flatHeight) {
        this.options.flatHeight = flatHeight;
        this['_fireEvent']('flatheightchange');
    }
    _createMesh(regl) {
        const geometry = this._createGeometry(regl);
        const mesh = new $2wazW.Mesh(geometry);
        this._setDefines(mesh);
        this._setLocalTransform(mesh);
        return mesh;
    }
    _updateUniforms(mesh) {
        const maskMode = this._getMaskMode();
        mesh.setUniform('maskMode', maskMode);
        const color = this._getMaskColor();
        mesh.setUniform('maskColor', color);
        const flatHeight = this._altitudeToPoint(this.options.flatHeight || 0);
        mesh.setUniform('flatHeight', flatHeight);
    }
    _setDefines(mesh) {
        const defines = mesh.getDefines();
        defines['HAS_MASK_FLAT'] = 1;
        mesh.setDefines(defines);
    }
    _getHeightRange() {
        const heightRange = [
            0,
            this.options.flatHeight
        ];
        heightRange[1] = this._altitudeToPoint(heightRange[1]);
        return heightRange;
    }
}
let FlatInsideMask$1 = class FlatInsideMask extends FlatMask {
    constructor(coordinates, options){
        super(coordinates, options);
        this._mode = 'flat-inside';
    }
};
class FlatInsideMask extends FlatMask {
    constructor(coordinates, options){
        super(coordinates, options);
        this._mode = 'flat-outside';
    }
}
class ColorMask extends Mask {
    constructor(coordinates, options){
        super(coordinates, options);
        this._mode = 'color';
    }
    setHeightRange(heightRange) {
        this.options.heightRange = heightRange;
        this['_fireEvent']('heightrangechange');
    }
    _createMesh(regl) {
        const geometry = this._createGeometry(regl);
        const mesh = new $2wazW.Mesh(geometry);
        this._setDefines(mesh);
        this._setLocalTransform(mesh);
        return mesh;
    }
    _updateUniforms(mesh, ratio, minHeight) {
        const maskMode = this._getMaskMode();
        mesh.setUniform('maskMode', maskMode);
        const color = this._getMaskColor();
        mesh.setUniform('maskColor', color);
        if (isNumber$1(ratio)) {
            const heightRange = this._getHeightRange();
            heightRange[0] = (heightRange[0] - minHeight) * ratio;
            heightRange[1] = (heightRange[1] - minHeight) * ratio;
            mesh.setUniform('heightRange', heightRange);
        }
    }
    _setDefines(mesh) {
        const defines = mesh.getDefines();
        defines['HAS_MASK_COLOR'] = 1;
        mesh.setDefines(defines);
    }
    _getHeightRange() {
        const heightRange = [
            0,
            0
        ];
        if (this.options.heightRange) {
            heightRange[0] = this._altitudeToPoint(this.options.heightRange[0]);
            heightRange[1] = this._altitudeToPoint(this.options.heightRange[1]);
        }
        return heightRange;
    }
}
class VideoMask extends Mask {
    constructor(coordinates, options){
        super(coordinates, options);
        this._mode = 'texture';
    }
    play() {
        if (this._video) this._video.play();
    }
    pause() {
        if (this._video) this._video.pause();
    }
    setAudio(audio) {
        if (this._video) this.video.muted = audio;
    }
    setUrl(url) {
        this.options.url = url;
        this._createVideo(url);
    }
    getState() {
        return this._videoState;
    }
    _createMesh(regl) {
        const geometry = this._createGeometry(regl);
        const mesh = new $2wazW.Mesh(geometry);
        const videoTexture = this._createVideoTexture(regl);
        mesh.material = new $2wazW.Material({
            maskTexture: videoTexture
        });
        this._setDefines(mesh);
        this._setLocalTransform(mesh);
        return mesh;
    }
    _updateUniforms(mesh) {
        const maskMode = this._getMaskMode();
        mesh.setUniform('maskMode', maskMode);
        if (this._positions && this._positions.length) for(let i = 0; i < 4; i++)mesh.setUniform('mask_position' + i, this._positions.slice(i * 3, i * 3 + 3));
        const color = this._getMaskColor();
        mesh.setUniform('maskColor', color);
    }
    _setDefines(mesh) {
        const defines = mesh.getDefines();
        defines['HAS_TEXTURE'] = 1;
        mesh.setDefines(defines);
    }
    _createVideoTexture(regl) {
        this._createVideo();
        const videoTexture = regl.texture();
        return videoTexture;
    }
    _createVideo() {
        this._videoState = 'stop';
        const url = this.options.url;
        const id = this.options.elementId;
        let video = document.getElementById(id);
        if (url) {
            video = document.createElement('video');
            video.src = url;
        }
        if (!video) throw new Error('there is no element or url setting for video mask');
        video.autoplay = this.options.autoplay || true;
        video.loop = this.options.loop || true;
        video.muted = this.options.muted || true;
        video.play();
        video.addEventListener('playing', ()=>{
            this._videoState = 'playing';
        });
        video.addEventListener('pause', ()=>{
            this._videoState = 'pause';
        });
        this._video = video;
    }
    _update() {
        const mesh = this._mesh;
        if (!mesh) return;
        if (mesh.material) {
            const videoTexture = mesh.material.get('maskTexture');
            if (videoTexture && this._video && this._needUpdate()) videoTexture(this._video);
        }
    }
    _needUpdate() {
        return this._videoState === 'playing';
    }
}
class ImageMask extends Mask {
    /**
     * @param  {Object} options.url   image resource url
     */ constructor(coordinates, options){
        super(coordinates, options);
        this._mode = 'texture';
    }
    setUrl(url) {
        this.options.url = url;
        const mesh = this._mesh;
        if (!mesh) return;
        if (mesh.material) {
            const maskTexture = mesh.material.get('maskTexture');
            if (maskTexture) {
                this._createTexture(maskTexture);
                const layer = this.getLayer();
                if (layer) layer.getRenderer().setToRedraw();
            }
        }
    }
    _createMesh(regl) {
        const geometry = this._createGeometry(regl);
        const mesh = new $2wazW.Mesh(geometry);
        const texture = regl.texture();
        this._createTexture(texture);
        mesh.material = new $2wazW.Material({
            maskTexture: texture
        });
        this._setDefines(mesh);
        this._setLocalTransform(mesh);
        return mesh;
    }
    _updateUniforms(mesh) {
        const maskMode = this._getMaskMode();
        mesh.setUniform('maskMode', maskMode);
        const color = this._getMaskColor();
        mesh.setUniform('maskColor', color);
        if (this._positions && this._positions.length) for(let i = 0; i < 4; i++)mesh.setUniform('mask_position' + i, this._positions.slice(i * 3, i * 3 + 3));
    }
    _setDefines(mesh) {
        const defines = mesh.getDefines();
        defines['HAS_TEXTURE'] = 1;
        mesh.setDefines(defines);
    }
    _createTexture(imageTexture) {
        const image = new Image();
        image.src = this.options.url;
        image.crossOrigin = 'anonymous';
        image.onload = function() {
            imageTexture(image);
        };
        image.onerror = function() {
            console.warn('Image load error');
        };
    }
}
class ElevateMask extends FlatMask {
    constructor(coordinates, options){
        super(coordinates, options);
        this.setElevation(options.elevation);
        this._mode = 'elevate';
    }
    setElevation(elevation) {
        this.options.elevation = elevation;
        this.setFlatheight(this.options.elevation);
    }
}
const LEFT_POINT = new (0, $gP1US.Point)(0, 0), RIGHT_POINT = new (0, $gP1US.Point)(0, 0), CENTER_POINT = new (0, $gP1US.Point)(0, 0), TEMP_POINT = new (0, $gP1US.Point)(0, 0);
class BoxClipMask extends ClipMask {
    constructor(position, options){
        super([], options);
        this._position = position;
    }
    setPosition(position) {
        this._position = position;
        this._updateCoordinates();
    }
    getPosition() {
        return this._position;
    }
    setWidth(width) {
        this.options['width'] = width;
        this._updateCoordinates();
    }
    setLength(length) {
        this.options['length'] = length;
        this._updateCoordinates();
    }
    setHeight(height) {
        this.options['height'] = height;
        this._updateCoordinates();
    }
    setRotation(rotation) {
        this.options['rotation'] = rotation;
        this._updateCoordinates();
    }
    _updateCoordinates() {
        const layer = this.getLayer();
        if (!layer) return;
        const map = layer.getMap();
        if (map) {
            const { length, width, height } = this.options;
            const center = this._position;
            const rotation = this.options['rotation'] || 0;
            const { coordinates, heightRange } = this._generateCoordinates(map, center, length, width, height, rotation);
            this.setCoordinates(coordinates);
            this.setHeightRange(heightRange);
        }
    }
    _generateCoordinates(map, center, length, width, height, rotation) {
        const glRes = map.getGLRes();
        const pointLeft = map.distanceToPointAtRes(width / 2, 0, glRes, LEFT_POINT);
        const pointTop = map.distanceToPointAtRes(0, length / 2, glRes, RIGHT_POINT);
        const pointCenter = map.coordinateToPointAtRes(center, glRes, CENTER_POINT);
        const leftPointX = pointCenter.x - pointLeft.x;
        const rightPointX = pointCenter.x + pointLeft.x;
        const topPointY = pointCenter.y + pointTop.y;
        const buttomPointY = pointCenter.y - pointTop.y;
        const points = this._rotatePoint([
            [
                leftPointX,
                topPointY
            ],
            [
                rightPointX,
                topPointY
            ],
            [
                rightPointX,
                buttomPointY
            ],
            [
                leftPointX,
                buttomPointY
            ]
        ], pointCenter, rotation);
        TEMP_POINT.set(points[0][0], points[0][1]);
        const lt = map.pointAtResToCoordinate(TEMP_POINT, glRes);
        TEMP_POINT.set(points[1][0], points[1][1]);
        const rt = map.pointAtResToCoordinate(TEMP_POINT, glRes);
        TEMP_POINT.set(points[2][0], points[2][1]);
        const rb = map.pointAtResToCoordinate(TEMP_POINT, glRes);
        TEMP_POINT.set(points[3][0], points[3][1]);
        const lb = map.pointAtResToCoordinate(TEMP_POINT, glRes);
        const buttom = center.z - height / 2;
        const top = center.z + height / 2;
        const heightRange = [
            buttom,
            top
        ];
        const coordinates = [
            [
                lt.x,
                lt.y,
                buttom
            ],
            [
                rt.x,
                rt.y,
                buttom
            ],
            [
                rb.x,
                rb.y,
                buttom
            ],
            [
                lb.x,
                lb.y,
                buttom
            ],
            [
                lt.x,
                lt.y,
                buttom
            ]
        ];
        return {
            coordinates: coordinates,
            heightRange: heightRange
        };
    }
    _rotatePoint(points, center, rotation) {
        for(let i = 0; i < points.length; i++)(0, $6BoVD).rotate(points[i], points[i], [
            center.x,
            center.y
        ], rotation * Math.PI / 180);
        return points;
    }
}
class BoxInsideClipper extends BoxClipMask {
    constructor(position, options){
        super(position, options);
        this._mode = 'clip-inside';
    }
}
class BoxOutsideClipper extends BoxClipMask {
    constructor(position, options){
        super(position, options);
        this._mode = 'clip-outside';
    }
}
const options = {
    'mode': 'LineString',
    'language': 'zh-CN',
    'metric': true,
    'imperial': false,
    'once': true,
    'symbol': {
        'lineColor': "#e8542b",
        'lineWidth': 2,
        'polygonFill': '#eee',
        'polygonOpacity': 0.5
    },
    'vertexSymbol': {
        'markerType': 'ellipse',
        'markerFill': '#e8542b',
        'markerLineColor': '#fff',
        'markerLineWidth': 2,
        'markerWidth': 10,
        'markerHeight': 10,
        'markerDy': 0
    },
    'labelSymbol': {
        'boxStyle': {
            'padding': [
                15,
                6
            ],
            'verticalAlignment': 'top',
            'horizontalAlignment': 'left',
            'minWidth': 150,
            'minHeight': 30,
            'symbol': {
                'markerType': 'square',
                'markerFill': 'rgb(60, 60, 60)',
                'markerFillOpacity': 0.8,
                'markerLineColor': '#fff',
                'markerLineWidth': 2,
                'textDx': -110
            }
        },
        'textSymbol': {
            'textFill': '#fff',
            'textSize': 16,
            'textVerticalAlignment': 'top'
        }
    }
};
class Measure3DTool extends $gP1US.DrawTool {
    constructor(options){
        super(options);
        this.on('enable', this._afterEnable, this);
        this.on('disable', this._afterDisable, this);
        this._drawCoordinates = [];
    }
    addTo(map) {
        if (map) {
            super.addTo(map);
            this._map = map;
            this._addHelperLayer();
        }
        return this;
    }
    _addHelperLayer() {
        const id = $gP1US.INTERNAL_LAYER_PREFIX + 'drawtool';
        this._map.getLayer(id).hide();
    }
    _afterEnable() {
        this.on('drawstart', this._msOnDrawStart, this).on('drawvertex', this._msOnDrawVertex, this).on('mousemove', this._msOnMouseMove, this).on('drawend', this._msOnDrawEnd, this);
    }
    _afterDisable() {
        this.off('drawstart', this._msOnDrawStart, this).off('drawvertex', this._msOnDrawVertex, this).off('mousemove', this._msOnMouseMove, this).off('drawend', this._msOnDrawEnd, this);
    }
    _getPickedCoordinate(e) {
        const { coordinate, containerPoint } = e;
        const gllayer = this._map.getLayers((layer)=>{
            return layer.queryTerrainAtPoint;
        })[0];
        if (!gllayer) {
            coordinate.z = coordinate.z || 0;
            return coordinate;
        }
        const identifyData = gllayer.identify(coordinate, {
            includeInternals: false
        })[0];
        const pickedPoint = identifyData && identifyData.coordinate;
        let pickCoord = null;
        if (pickedPoint) pickCoord = new $gP1US.Coordinate(identifyData.coordinate);
        else {
            coordinate.z = coordinate.z || 0;
            pickCoord = coordinate;
        }
        if (gllayer.getTerrainLayer()) {
            const pickedTerrainCoord = gllayer.queryTerrainAtPoint(containerPoint);
            return pickedTerrainCoord && pickedTerrainCoord.z > pickCoord.z ? pickedTerrainCoord : pickCoord;
        }
        return pickCoord;
    }
    _msOnDrawStart(e) {
        const coordinate = this._getPickedCoordinate(e);
        if (!coordinate) return;
        this._first = true;
        this._drawCoordinates.push(coordinate);
        this._addHelperGeometry(coordinate);
    }
    _msOnDrawVertex(e) {
        const coordinate = this._getPickedCoordinate(e);
        if (!coordinate) return;
        this._first = true;
        this._drawCoordinates[this._drawCoordinates.length - 1] = coordinate;
        this._drawVertexMarker();
    }
    _msOnMouseMove(e) {
        const coordinate = this._getPickedCoordinate(e);
        if (!coordinate) return;
        if (this._first) this._drawCoordinates.push(coordinate);
        else this._drawCoordinates[this._drawCoordinates.length - 1] = coordinate;
        this._drawVertexMarker();
        this._first = false;
    }
    _msOnDrawEnd(e) {
        const coordinate = this._getPickedCoordinate(e);
        if (!coordinate) return;
        this._drawCoordinates.push(coordinate);
        this._drawEnd();
    }
    _drawEnd() {
        this._drawVertexMarker();
        this._drawCoordinates = [];
        this._helperGeometry = null;
        this._label = null;
    }
    remove() {
        if (this._helperLayer) this._helperLayer.remove();
        if (this._markerLayer) this._markerLayer.remove();
    }
    clear() {
        if (this._helperLayer) this._helperLayer.clear();
        if (this._markerLayer) this._markerLayer.clear();
    }
}
Measure3DTool.mergeOptions(options);
class Distance3DTool extends Measure3DTool {
    _addHelperLayer() {
        super._addHelperLayer();
        this._helperLayer = new $gP1US.VectorLayer($gP1US.INTERNAL_LAYER_PREFIX + '_distance3dtool', {
            enableAltitude: true
        }).addTo(this._map);
        this._markerLayer = new $gP1US.VectorLayer($gP1US.INTERNAL_LAYER_PREFIX + '_distance3dtool_marker', {
            enableAltitude: true
        }).addTo(this._map);
    }
    _drawVertexMarker() {
        this._helperGeometry.setCoordinates(this._drawCoordinates);
        const markers = this._markerLayer.getGeometries();
        const geometryCount = this._helperLayer.getGeometries().length;
        for(let i = 0; i < markers.length; i++){
            const id = markers[i].getId();
            if (id !== 'label' + geometryCount && id.indexOf(`${geometryCount}_`) > -1) markers[i].remove();
        }
        for(let i = 0; i < this._drawCoordinates.length; i++)new $gP1US.Marker(this._drawCoordinates[i], {
            id: geometryCount + '_' + i,
            symbol: this.options['vertexSymbol']
        }).addTo(this._markerLayer);
        this._drawLabel();
    }
    _drawLabel() {
        const distance = this.getMeasureResult();
        const language = this.options['language'] === 'zh-CN' ? 0 : 1;
        const unitContent = this._getUnitContent(distance);
        const content = (!language ? "\u8DDD\u79BB: " : 'distance: ') + unitContent;
        const labelCoordinate = this._drawCoordinates[this._drawCoordinates.length - 1];
        const geometryCount = this._helperLayer.getGeometries().length;
        const options = $gP1US.Util.extend({
            id: 'label' + geometryCount
        }, this.options.labelSymbol);
        if (!this._label) this._label = new $gP1US.Label(content, labelCoordinate, options).addTo(this._markerLayer);
        else {
            this._label.setContent(content);
            this._label.setCoordinates(labelCoordinate);
        }
    }
    _getUnitContent(length) {
        let units;
        if (this.options['language'] === 'zh-CN') units = [
            " \u7C73",
            " \u516C\u91CC",
            " \u82F1\u5C3A",
            " \u82F1\u91CC"
        ];
        else units = [
            ' m',
            ' km',
            ' feet',
            ' mile'
        ];
        let content = '';
        if (this.options['metric']) {
            this._measure = length < 1000 ? length.toFixed(1) : (length / 1000).toFixed(2);
            this._units = length < 1000 ? units[0] : units[1];
        }
        if (this.options['imperial']) {
            length *= 3.2808399;
            if (content.length > 0) content += '\n';
            this._measure = length < 5280 ? length.toFixed(1) : (length / 5280).toFixed(2);
            this._units = length < 5280 ? units[2] : units[3];
        }
        content += this._measure + this._units;
        return content;
    }
    _addHelperGeometry(coordinate) {
        if (!this._helperGeometry) this._helperGeometry = new $gP1US.LineString([
            coordinate
        ], {
            symbol: this.options.symbol
        }).addTo(this._helperLayer);
        this._drawVertexMarker();
        this._first = true;
    }
    getMeasureResult() {
        return this._helperGeometry.getLength();
    }
}
class Area3DTool extends Measure3DTool {
    _addHelperLayer() {
        super._addHelperLayer();
        this._helperLayer = new $gP1US.VectorLayer($gP1US.INTERNAL_LAYER_PREFIX + '_area3dtool', {
            enableAltitude: true
        }).addTo(this._map);
        this._markerLayer = new $gP1US.VectorLayer($gP1US.INTERNAL_LAYER_PREFIX + '_area3dtool_marker', {
            enableAltitude: true
        }).addTo(this._map);
    }
    _drawVertexMarker() {
        const coordinates = this._getPolygonCoordinates(this._drawCoordinates);
        this._helperGeometry.setCoordinates(coordinates);
        this._polygon.setCoordinates(coordinates);
        const markers = this._markerLayer.getGeometries();
        const geometryCount = this._helperLayer.getGeometries().length;
        for(let i = 0; i < markers.length; i++){
            const id = markers[i].getId();
            if (id !== 'label' + geometryCount && id.indexOf(`${geometryCount}_`) > -1) markers[i].remove();
        }
        for(let i = 0; i < this._drawCoordinates.length; i++)new $gP1US.Marker(this._drawCoordinates[i], {
            id: geometryCount + '_' + i,
            symbol: this.options['vertexSymbol']
        }).addTo(this._markerLayer);
        this._drawLabel();
    }
    _getPolygonCoordinates(coordinates) {
        const polygonCoords = coordinates.map((coord)=>{
            return coord;
        });
        if (coordinates.length > 2) polygonCoords.push(coordinates[0]);
        return polygonCoords;
    }
    _drawLabel() {
        const distance = this.getMeasureResult();
        const language = this.options['language'] === 'zh-CN' ? 0 : 1;
        const unitContent = this._getUnitContent(distance);
        const content = (!language ? "\u9762\u79EF: " : 'area: ') + unitContent;
        const labelCoordinate = this._drawCoordinates[this._drawCoordinates.length - 1];
        const geometryCount = this._helperLayer.getGeometries().length;
        const options = $gP1US.Util.extend({
            id: 'label' + geometryCount
        }, this.options.labelSymbol);
        if (!this._label) this._label = new $gP1US.Label(content, labelCoordinate, options).addTo(this._markerLayer);
        else {
            this._label.setContent(content);
            this._label.setCoordinates(labelCoordinate);
        }
    }
    _getUnitContent(area) {
        let units;
        if (this.options['language'] === 'zh-CN') units = [
            " \u5E73\u65B9\u7C73",
            " \u5E73\u65B9\u516C\u91CC",
            " \u5E73\u65B9\u82F1\u5C3A",
            " \u5E73\u65B9\u82F1\u91CC"
        ];
        else units = [
            ' sq.m',
            ' sq.km',
            ' sq.ft',
            ' sq.mi'
        ];
        let content = '';
        if (this.options['metric']) {
            this._measure = area < 1E6 ? area.toFixed(2) : (area / 1E6).toFixed(2);
            this._units = area < 1E6 ? units[0] : units[1];
        }
        if (this.options['imperial']) {
            area *= 3.2808399;
            if (content.length > 0) content += '\n';
            const sqmi = 27878400;
            this._measure = area < sqmi ? area.toFixed(2) : (area / sqmi).toFixed(2);
            this._units = area < sqmi ? units[2] : units[3];
        }
        content += this._measure + this._units;
        return content;
    }
    _addHelperGeometry(coordinate) {
        if (!this._helperGeometry) {
            this._helperGeometry = new $gP1US.LineString([
                coordinate
            ], {
                symbol: this.options.symbol
            }).addTo(this._helperLayer);
            this._polygon = new $gP1US.Polygon([
                coordinate
            ]);
        }
        this._drawVertexMarker();
        this._first = true;
    }
    getMeasureResult() {
        return this._polygon.getArea();
    }
}
const MEASURE_HEIGHT_NAMES = [
    [
        "\u76F4\u7EBF\u8DDD\u79BB",
        "\u5782\u76F4\u9AD8\u5EA6",
        "\u6C34\u5E73\u8DDD\u79BB"
    ],
    [
        'spatial distance',
        'vertical height',
        'horizontal distance'
    ]
];
class Height3DTool extends Measure3DTool {
    _addHelperLayer() {
        super._addHelperLayer();
        this._markerLayer = new $gP1US.VectorLayer($gP1US.INTERNAL_LAYER_PREFIX + '_height3dtool_marker', {
            enableAltitude: true
        }).addTo(this._map).bringToFront();
        this._helperLayer = new $gP1US.VectorLayer($gP1US.INTERNAL_LAYER_PREFIX + '_height3dtool', {
            enableAltitude: true
        }).addTo(this._map).bringToFront();
    }
    _msOnDrawVertex(e) {
        super._msOnDrawVertex(e);
        if (this._drawCoordinates.length > 1) {
            this._drawEnd();
            this.disable();
        }
    }
    _drawVertexMarker() {
        const markers = this._markerLayer.getGeometries();
        const geometryCount = this._helperLayer.getGeometries().length;
        for(let i = 0; i < markers.length; i++){
            const id = markers[i].getId();
            if (id !== 'label' + geometryCount + '_' + i && id.indexOf(`${geometryCount}_`) === 0) markers[i].remove();
        }
        for(let i = 0; i < this._drawCoordinates.length; i++)new $gP1US.Marker(this._drawCoordinates[i], {
            id: geometryCount + '_' + i,
            symbol: this.options['vertexSymbol']
        }).addTo(this._markerLayer);
        const len = this._drawCoordinates.length;
        if (len > 1) {
            const x = this._drawCoordinates[len - 1].x, y = this._drawCoordinates[len - 1].y, z = this._drawCoordinates[len - 2].z;
            const coord = new $gP1US.Coordinate([
                x,
                y,
                z
            ]);
            new $gP1US.Marker(coord, {
                id: geometryCount + '_' + 2,
                symbol: this.options['vertexSymbol']
            }).addTo(this._markerLayer);
            const coordinates = [].concat(this._drawCoordinates);
            coordinates.push(coord);
            coordinates.push(this._drawCoordinates[0]);
            const altitude = coordinates.map((c)=>{
                return c.z;
            });
            this._helperGeometry.setCoordinates(coordinates);
            this._helperGeometry.setProperties({
                altitude: altitude
            });
            const horizontalDistance = this._map.getProjection().measureLenBetween(coordinates[0], coordinates[2]);
            const height = coordinates[1].z - coordinates[2].z;
            const distance = Math.sqrt(Math.pow(horizontalDistance, 2) + Math.pow(height, 2));
            this._drawLabel(coordinates, [
                distance,
                height,
                horizontalDistance
            ]);
        }
    }
    _drawLabel(coordinates, distances) {
        for(let i = 0; i < coordinates.length - 1; i++){
            const from = coordinates[i], to = coordinates[i + 1];
            const distance = distances[i];
            const language = this.options['language'] === 'zh-CN' ? 0 : 1;
            const unitContent = this._getUnitContent(distance);
            const content = MEASURE_HEIGHT_NAMES[language][i] + ':' + unitContent;
            const geometryCount = this._helperLayer.getGeometries().length;
            const id = 'label' + geometryCount + '_' + i;
            const options = JSON.parse(JSON.stringify(this.options.labelSymbol));
            options.id = id;
            if (i < 2) options.boxStyle.symbol.textDx *= -1;
            const labelCoordinate = i === 1 ? from : new $gP1US.Coordinate((from.x + to.x) / 2, (from.y + to.y) / 2, (from.z + to.z) / 2);
            const label = this._markerLayer.getGeometryById(id);
            const markerId = `${id}_marker`;
            const marker = this._markerLayer.getGeometryById(markerId);
            if (!label) {
                new $gP1US.Label(content, labelCoordinate, options).addTo(this._markerLayer);
                new $gP1US.Marker(labelCoordinate, {
                    id: markerId,
                    symbol: this.options['vertexSymbol']
                }).addTo(this._markerLayer);
            } else {
                label.setContent(content);
                label.setCoordinates(labelCoordinate);
                marker.setCoordinates(labelCoordinate);
            }
        }
    }
    _getUnitContent(length) {
        let units;
        if (this.options['language'] === 'zh-CN') units = [
            " \u7C73",
            " \u516C\u91CC",
            " \u82F1\u5C3A",
            " \u82F1\u91CC"
        ];
        else units = [
            ' m',
            ' km',
            ' feet',
            ' mile'
        ];
        let content = '';
        if (this.options['metric']) {
            this._measure = length < 1000 ? length.toFixed(1) : (length / 1000).toFixed(2);
            this._units = length < 1000 ? units[0] : units[1];
        }
        if (this.options['imperial']) {
            length *= 3.2808399;
            if (content.length > 0) content += '\n';
            this._measure = length < 5280 ? length.toFixed(1) : (length / 5280).toFixed(2);
            this._units = length < 5280 ? units[2] : units[3];
        }
        content += this._measure + this._units;
        return content;
    }
    _addHelperGeometry(coordinate) {
        if (!this._helperGeometry) this._helperGeometry = new $gP1US.LineString([
            coordinate
        ], {
            symbol: this.options.symbol
        }).addTo(this._helperLayer);
        this._drawVertexMarker();
        this._first = true;
    }
    getMeasureResult() {
        return this._helperGeometry.getLength();
    }
}
const e = "${";
const code = `function(e){
/*!
     * @maptalks/gltf-loader v0.102.3
     * LICENSE : UNLICENSED
     * (c) 2016-2025 maptalks.org
     */
var n,t,r="undefined"!=typeof Float32Array?Float32Array:Array;function o(){var e=new r(3);return r!=Float32Array&&(e[0]=0,e[1]=0,e[2]=0),e}function i(e,n,t){var o=new r(3);return o[0]=e,o[1]=n,o[2]=t,o}function a(){var e=new r(4);return r!=Float32Array&&(e[0]=0,e[1]=0,e[2]=0),e[3]=1,e}Math.hypot||(Math.hypot=function(){for(var e=0,n=arguments.length;n--;)e+=arguments[n]*arguments[n];return Math.sqrt(e)}),o(),n=new r(4),r!=Float32Array&&(n[0]=0,n[1]=0,n[2]=0,n[3]=0),o(),i(1,0,0),i(0,1,0),a(),a(),t=new r(9),r!=Float32Array&&(t[1]=0,t[2]=0,t[3]=0,t[5]=0,t[6]=0,t[7]=0),t[0]=1,t[4]=1,t[8]=1;let s=0;!function(e){e[0]=0,e[1]=0,e[2]=0,e[3]=1}([]),"undefined"!=typeof TextDecoder&&new TextDecoder("utf-8");const c={get:function(e,n={},t){n||(n={});const r=new AbortController,o=r.signal,i=function(e){for(let n=1;n<arguments.length;n++){const t=arguments[n];for(const n in t)e[n]=t[n]}return e}({},n);i.signal=o,i.method||(i.method="GET"),i.referrerPolicy=i.referrerPolicy||"origin","undefined"==typeof window||i.referrer||(i.referrer=window.location.href),t&&(e=t(e));const a=fetch(e,i).then((e=>{const t=this._(e,n.responseType);return t.message?t:t.then((t=>"arraybuffer"===n.responseType?{data:t,cacheControl:e.headers.get("Cache-Control"),expires:e.headers.get("Expires"),contentType:e.headers.get("Content-Type")}:t)).catch((e=>{if(!e.code||e.code!==DOMException.ABORT_ERR)throw e}))})).catch((e=>{if(!e.code||e.code!==DOMException.ABORT_ERR)throw e}));return a.xhr=r,a},_:(e,n)=>200!==e.status?{status:e.status,statusText:e.statusText,message:\`incorrect http request with status code(${e}e.status}): ${e}e.statusText}\`}:"arraybuffer"===n?e.arrayBuffer():"json"===n?e.json():e.text(),getArrayBuffer:(e,n={},t)=>(n||(n={}),n.responseType="arraybuffer",c.get(e,n,t)),getJSON:function(e,n={},t){return n&&n.jsonp?c.jsonp(e):((n=n||{}).responseType="json",c.get(e,n,t))},jsonp:function(e){const n="_maptalks_jsonp_"+s++;e.match(/\\?/)?e+="&callback="+n:e+="?callback="+n;let t=document.createElement("script");return t.type="text/javascript",t.src=e,new Promise((e=>{window[n]=function(r){document.getElementsByTagName("head")[0].removeChild(t),t=null,delete window[n],e(r)},document.getElementsByTagName("head")[0].appendChild(t)}))}};if("undefined"!=typeof TextDecoder&&new TextDecoder("utf-8"),"undefined"!=typeof OffscreenCanvas){let e;try{e=new OffscreenCanvas(2,2).getContext("2d")}catch(r){}}"undefined"!=typeof document&&document.createElement("canvas"),
/** @license zlib.js 2012 - imaya [ https://github.com/imaya/zlib.js ] The MIT License */function(){function e(e){throw e}var n=void 0,t=!0,r=this;function o(e,t){var o,i=e.split("."),a=r;!(i[0]in a)&&a.execScript&&a.execScript("var "+i[0]);for(;i.length&&(o=i.shift());)i.length||t===n?a=a[o]?a[o]:a[o]={}:a[o]=t}var i="undefined"!=typeof Uint8Array&&"undefined"!=typeof Uint16Array&&"undefined"!=typeof Uint32Array&&"undefined"!=typeof DataView;function a(n,t){this.index="number"==typeof t?t:0,this.i=0,this.buffer=n instanceof(i?Uint8Array:Array)?n:new(i?Uint8Array:Array)(32768),2*this.buffer.length<=this.index&&e(Error("invalid index")),this.buffer.length<=this.index&&this.f()}a.prototype.f=function(){var e,n=this.buffer,t=n.length,r=new(i?Uint8Array:Array)(t<<1);if(i)r.set(n);else for(e=0;e<t;++e)r[e]=n[e];return this.buffer=r},a.prototype.d=function(e,n,t){var r,o=this.buffer,i=this.index,a=this.i,s=o[i];if(t&&1<n&&(e=8<n?(h[255&e]<<24|h[e>>>8&255]<<16|h[e>>>16&255]<<8|h[e>>>24&255])>>32-n:h[e]>>8-n),8>n+a)s=s<<n|e,a+=n;else for(r=0;r<n;++r)s=s<<1|e>>n-r-1&1,8==++a&&(a=0,o[i++]=h[s],s=0,i===o.length&&(o=this.f()));o[i]=s,this.buffer=o,this.i=a,this.index=i},a.prototype.finish=function(){var e,n=this.buffer,t=this.index;return 0<this.i&&(n[t]<<=8-this.i,n[t]=h[n[t]],t++),i?e=n.subarray(0,t):(n.length=t,e=n),e};var s,c=new(i?Uint8Array:Array)(256);for(s=0;256>s;++s){for(var f=d=s,l=7,d=d>>>1;d;d>>>=1)f<<=1,f|=1&d,--l;c[s]=(f<<l&255)>>>0}var h=c;function v(e){this.buffer=new(i?Uint16Array:Array)(2*e),this.length=0}function u(e){var n,t,r,o,a,s,c,f,l,d,h=e.length,v=0,u=Number.POSITIVE_INFINITY;for(f=0;f<h;++f)e[f]>v&&(v=e[f]),e[f]<u&&(u=e[f]);for(n=1<<v,t=new(i?Uint32Array:Array)(n),r=1,o=0,a=2;r<=v;){for(f=0;f<h;++f)if(e[f]===r){for(s=0,c=o,l=0;l<r;++l)s=s<<1|1&c,c>>=1;for(d=r<<16|f,l=s;l<n;l+=a)t[l]=d;++o}++r,o<<=1,a<<=1}return[t,v,u]}function _(e,n){this.h=g,this.w=0,this.input=i&&e instanceof Array?new Uint8Array(e):e,this.b=0,n&&(n.lazy&&(this.w=n.lazy),"number"==typeof n.compressionType&&(this.h=n.compressionType),n.outputBuffer&&(this.a=i&&n.outputBuffer instanceof Array?new Uint8Array(n.outputBuffer):n.outputBuffer),"number"==typeof n.outputIndex&&(this.b=n.outputIndex)),this.a||(this.a=new(i?Uint8Array:Array)(32768))}v.prototype.getParent=function(e){return 2*((e-2)/4|0)},v.prototype.push=function(e,n){var t,r,o,i=this.buffer;for(t=this.length,i[this.length++]=n,i[this.length++]=e;0<t&&(r=this.getParent(t),i[t]>i[r]);)o=i[t],i[t]=i[r],i[r]=o,o=i[t+1],i[t+1]=i[r+1],i[r+1]=o,t=r;return this.length},v.prototype.pop=function(){var e,n,t,r,o,i=this.buffer;for(n=i[0],e=i[1],this.length-=2,i[0]=i[this.length],i[1]=i[this.length+1],o=0;!((r=2*o+2)>=this.length)&&(r+2<this.length&&i[r+2]>i[r]&&(r+=2),i[r]>i[o]);)t=i[o],i[o]=i[r],i[r]=t,t=i[o+1],i[o+1]=i[r+1],i[r+1]=t,o=r;return{index:e,value:n,length:this.length}};var m,g=2,x={NONE:0,r:1,k:g,N:3},p=[];for(m=0;288>m;m++)switch(t){case 143>=m:p.push([m+48,8]);break;case 255>=m:p.push([m-144+400,9]);break;case 279>=m:p.push([m-256+0,7]);break;case 287>=m:p.push([m-280+192,8]);break;default:e("invalid literal: "+m)}function A(e,n){this.length=e,this.G=n}_.prototype.j=function(){var r,o,s,c,f=this.input;switch(this.h){case 0:for(s=0,c=f.length;s<c;){var l,d,h,v=o=i?f.subarray(s,s+65535):f.slice(s,s+65535),u=(s+=o.length)===c,_=n,m=n,x=this.a,A=this.b;if(i){for(x=new Uint8Array(this.a.buffer);x.length<=A+v.length+5;)x=new Uint8Array(x.length<<1);x.set(this.a)}if(l=u?1:0,x[A++]=0|l,h=65536+~(d=v.length)&65535,x[A++]=255&d,x[A++]=d>>>8&255,x[A++]=255&h,x[A++]=h>>>8&255,i)x.set(v,A),A+=v.length,x=x.subarray(0,A);else{for(_=0,m=v.length;_<m;++_)x[A++]=v[_];x.length=A}this.b=A,this.a=x}break;case 1:var y=new a(i?new Uint8Array(this.a.buffer):this.a,this.b);y.d(1,1,t),y.d(1,2,t);var b,E,O,S=w(this,f);for(b=0,E=S.length;b<E;b++)if(O=S[b],a.prototype.d.apply(y,p[O]),256<O)y.d(S[++b],S[++b],t),y.d(S[++b],5),y.d(S[++b],S[++b],t);else if(256===O)break;this.a=y.finish(),this.b=this.a.length;break;case g:var C,H,M,k,N,P,D,R,U,L,F,z,W,G,V,j=new a(i?new Uint8Array(this.a.buffer):this.a,this.b),X=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15],K=Array(19);for(C=g,j.d(1,1,t),j.d(C,2,t),H=w(this,f),D=T(P=I(this.L,15)),U=T(R=I(this.K,7)),M=286;257<M&&0===P[M-1];M--);for(k=30;1<k&&0===R[k-1];k--);var B,q,Z,Y,J,$,Q=M,ee=k,ne=new(i?Uint32Array:Array)(Q+ee),te=new(i?Uint32Array:Array)(316),re=new(i?Uint8Array:Array)(19);for(B=q=0;B<Q;B++)ne[q++]=P[B];for(B=0;B<ee;B++)ne[q++]=R[B];if(!i)for(B=0,Y=re.length;B<Y;++B)re[B]=0;for(B=J=0,Y=ne.length;B<Y;B+=q){for(q=1;B+q<Y&&ne[B+q]===ne[B];++q);if(Z=q,0===ne[B])if(3>Z)for(;0<Z--;)te[J++]=0,re[0]++;else for(;0<Z;)($=138>Z?Z:138)>Z-3&&$<Z&&($=Z-3),10>=$?(te[J++]=17,te[J++]=$-3,re[17]++):(te[J++]=18,te[J++]=$-11,re[18]++),Z-=$;else if(te[J++]=ne[B],re[ne[B]]++,3>--Z)for(;0<Z--;)te[J++]=ne[B],re[ne[B]]++;else for(;0<Z;)($=6>Z?Z:6)>Z-3&&$<Z&&($=Z-3),te[J++]=16,te[J++]=$-3,re[16]++,Z-=$}for(r=i?te.subarray(0,J):te.slice(0,J),L=I(re,7),G=0;19>G;G++)K[G]=L[X[G]];for(N=19;4<N&&0===K[N-1];N--);for(F=T(L),j.d(M-257,5,t),j.d(k-1,5,t),j.d(N-4,4,t),G=0;G<N;G++)j.d(K[G],3,t);for(G=0,V=r.length;G<V;G++)if(z=r[G],j.d(F[z],L[z],t),16<=z){switch(G++,z){case 16:W=2;break;case 17:W=3;break;case 18:W=7;break;default:e("invalid code: "+z)}j.d(r[G],W,t)}var oe,ie,ae,se,ce,fe,le,de,he=[D,P],ve=[U,R];for(ce=he[0],fe=he[1],le=ve[0],de=ve[1],oe=0,ie=H.length;oe<ie;++oe)if(ae=H[oe],j.d(ce[ae],fe[ae],t),256<ae)j.d(H[++oe],H[++oe],t),se=H[++oe],j.d(le[se],de[se],t),j.d(H[++oe],H[++oe],t);else if(256===ae)break;this.a=j.finish(),this.b=this.a.length;break;default:e("invalid compression type")}return this.a};var y=function(){function n(n){switch(t){case 3===n:return[257,n-3,0];case 4===n:return[258,n-4,0];case 5===n:return[259,n-5,0];case 6===n:return[260,n-6,0];case 7===n:return[261,n-7,0];case 8===n:return[262,n-8,0];case 9===n:return[263,n-9,0];case 10===n:return[264,n-10,0];case 12>=n:return[265,n-11,1];case 14>=n:return[266,n-13,1];case 16>=n:return[267,n-15,1];case 18>=n:return[268,n-17,1];case 22>=n:return[269,n-19,2];case 26>=n:return[270,n-23,2];case 30>=n:return[271,n-27,2];case 34>=n:return[272,n-31,2];case 42>=n:return[273,n-35,3];case 50>=n:return[274,n-43,3];case 58>=n:return[275,n-51,3];case 66>=n:return[276,n-59,3];case 82>=n:return[277,n-67,4];case 98>=n:return[278,n-83,4];case 114>=n:return[279,n-99,4];case 130>=n:return[280,n-115,4];case 162>=n:return[281,n-131,5];case 194>=n:return[282,n-163,5];case 226>=n:return[283,n-195,5];case 257>=n:return[284,n-227,5];case 258===n:return[285,n-258,0];default:e("invalid length: "+n)}}var r,o,i=[];for(r=3;258>=r;r++)o=n(r),i[r]=o[2]<<24|o[1]<<16|o[0];return i}(),b=i?new Uint32Array(y):y;function w(r,o){function a(n,r){var o,i,a,s,c=n.G,f=[],l=0;switch(o=b[n.length],f[l++]=65535&o,f[l++]=o>>16&255,f[l++]=o>>24,t){case 1===c:i=[0,c-1,0];break;case 2===c:i=[1,c-2,0];break;case 3===c:i=[2,c-3,0];break;case 4===c:i=[3,c-4,0];break;case 6>=c:i=[4,c-5,1];break;case 8>=c:i=[5,c-7,1];break;case 12>=c:i=[6,c-9,2];break;case 16>=c:i=[7,c-13,2];break;case 24>=c:i=[8,c-17,3];break;case 32>=c:i=[9,c-25,3];break;case 48>=c:i=[10,c-33,4];break;case 64>=c:i=[11,c-49,4];break;case 96>=c:i=[12,c-65,5];break;case 128>=c:i=[13,c-97,5];break;case 192>=c:i=[14,c-129,6];break;case 256>=c:i=[15,c-193,6];break;case 384>=c:i=[16,c-257,7];break;case 512>=c:i=[17,c-385,7];break;case 768>=c:i=[18,c-513,8];break;case 1024>=c:i=[19,c-769,8];break;case 1536>=c:i=[20,c-1025,9];break;case 2048>=c:i=[21,c-1537,9];break;case 3072>=c:i=[22,c-2049,10];break;case 4096>=c:i=[23,c-3073,10];break;case 6144>=c:i=[24,c-4097,11];break;case 8192>=c:i=[25,c-6145,11];break;case 12288>=c:i=[26,c-8193,12];break;case 16384>=c:i=[27,c-12289,12];break;case 24576>=c:i=[28,c-16385,13];break;case 32768>=c:i=[29,c-24577,13];break;default:e("invalid distance")}for(o=i,f[l++]=o[0],f[l++]=o[1],f[l++]=o[2],a=0,s=f.length;a<s;++a)g[x++]=f[a];A[f[0]]++,y[f[3]]++,p=n.length+r-1,u=null}var s,c,f,l,d,h,v,u,_,m={},g=i?new Uint16Array(2*o.length):[],x=0,p=0,A=new(i?Uint32Array:Array)(286),y=new(i?Uint32Array:Array)(30),w=r.w;if(!i){for(f=0;285>=f;)A[f++]=0;for(f=0;29>=f;)y[f++]=0}for(A[256]=1,s=0,c=o.length;s<c;++s){for(f=d=0,l=3;f<l&&s+f!==c;++f)d=d<<8|o[s+f];if(m[d]===n&&(m[d]=[]),h=m[d],!(0<p--)){for(;0<h.length&&32768<s-h[0];)h.shift();if(s+3>=c){for(u&&a(u,-1),f=0,l=c-s;f<l;++f)_=o[s+f],g[x++]=_,++A[_];break}0<h.length?(v=E(o,s,h),u?u.length<v.length?(_=o[s-1],g[x++]=_,++A[_],a(v,0)):a(u,-1):v.length<w?u=v:a(v,0)):u?a(u,-1):(_=o[s],g[x++]=_,++A[_])}h.push(s)}return g[x++]=256,A[256]++,r.L=A,r.K=y,i?g.subarray(0,x):g}function E(e,n,t){var r,o,i,a,s,c,f=0,l=e.length;a=0,c=t.length;e:for(;a<c;a++){if(r=t[c-a-1],i=3,3<f){for(s=f;3<s;s--)if(e[r+s-1]!==e[n+s-1])continue e;i=f}for(;258>i&&n+i<l&&e[r+i]===e[n+i];)++i;if(i>f&&(o=r,f=i),258===i)break}return new A(f,n-o)}function I(e,n){var t,r,o,a,s,c=e.length,f=new v(572),l=new(i?Uint8Array:Array)(c);if(!i)for(a=0;a<c;a++)l[a]=0;for(a=0;a<c;++a)0<e[a]&&f.push(a,e[a]);if(t=Array(f.length/2),r=new(i?Uint32Array:Array)(f.length/2),1===t.length)return l[f.pop().index]=1,l;for(a=0,s=f.length/2;a<s;++a)t[a]=f.pop(),r[a]=t[a].value;for(o=function(e,n,t){function r(e){var t=u[e][_[e]];t===n?(r(e+1),r(e+1)):--h[t],++_[e]}var o,a,s,c,f,l=new(i?Uint16Array:Array)(t),d=new(i?Uint8Array:Array)(t),h=new(i?Uint8Array:Array)(n),v=Array(t),u=Array(t),_=Array(t),m=(1<<t)-n,g=1<<t-1;for(l[t-1]=n,a=0;a<t;++a)m<g?d[a]=0:(d[a]=1,m-=g),m<<=1,l[t-2-a]=(l[t-1-a]/2|0)+n;for(l[0]=d[0],v[0]=Array(l[0]),u[0]=Array(l[0]),a=1;a<t;++a)l[a]>2*l[a-1]+d[a]&&(l[a]=2*l[a-1]+d[a]),v[a]=Array(l[a]),u[a]=Array(l[a]);for(o=0;o<n;++o)h[o]=t;for(s=0;s<l[t-1];++s)v[t-1][s]=e[s],u[t-1][s]=s;for(o=0;o<t;++o)_[o]=0;for(1===d[t-1]&&(--h[0],++_[t-1]),a=t-2;0<=a;--a){for(c=o=0,f=_[a+1],s=0;s<l[a];s++)(c=v[a+1][f]+v[a+1][f+1])>e[o]?(v[a][s]=c,u[a][s]=n,f+=2):(v[a][s]=e[o],u[a][s]=o,++o);_[a]=0,1===d[a]&&r(a)}return h}(r,r.length,n),a=0,s=t.length;a<s;++a)l[t[a].index]=o[a];return l}function T(e){var n,t,r,o,a=new(i?Uint16Array:Array)(e.length),s=[],c=[],f=0;for(n=0,t=e.length;n<t;n++)s[e[n]]=1+(0|s[e[n]]);for(n=1,t=16;n<=t;n++)c[n]=f,f+=0|s[n],f<<=1;for(n=0,t=e.length;n<t;n++)for(f=c[e[n]],c[e[n]]+=1,r=a[n]=0,o=e[n];r<o;r++)a[n]=a[n]<<1|1&f,f>>>=1;return a}function O(n,t){switch(this.l=[],this.m=32768,this.e=this.g=this.c=this.q=0,this.input=i?new Uint8Array(n):n,this.s=!1,this.n=C,this.B=!1,!t&&(t={})||(t.index&&(this.c=t.index),t.bufferSize&&(this.m=t.bufferSize),t.bufferType&&(this.n=t.bufferType),t.resize&&(this.B=t.resize)),this.n){case S:this.b=32768,this.a=new(i?Uint8Array:Array)(32768+this.m+258);break;case C:this.b=0,this.a=new(i?Uint8Array:Array)(this.m),this.f=this.J,this.t=this.H,this.o=this.I;break;default:e(Error("invalid inflate mode"))}}var S=0,C=1,H={D:S,C:C};O.prototype.p=function(){for(;!this.s;){var r=Z(this,3);switch(1&r&&(this.s=t),r>>>=1){case 0:var o=this.input,a=this.c,s=this.a,c=this.b,f=o.length,l=n,d=s.length,h=n;switch(this.e=this.g=0,a+1>=f&&e(Error("invalid uncompressed block header: LEN")),l=o[a++]|o[a++]<<8,a+1>=f&&e(Error("invalid uncompressed block header: NLEN")),l===~(o[a++]|o[a++]<<8)&&e(Error("invalid uncompressed block header: length verify")),a+l>o.length&&e(Error("input buffer is broken")),this.n){case S:for(;c+l>s.length;){if(l-=h=d-c,i)s.set(o.subarray(a,a+h),c),c+=h,a+=h;else for(;h--;)s[c++]=o[a++];this.b=c,s=this.f(),c=this.b}break;case C:for(;c+l>s.length;)s=this.f({v:2});break;default:e(Error("invalid inflate mode"))}if(i)s.set(o.subarray(a,a+l),c),c+=l,a+=l;else for(;l--;)s[c++]=o[a++];this.c=a,this.b=c,this.a=s;break;case 1:this.o(K,q);break;case 2:var v,_,m,g,x=Z(this,5)+257,p=Z(this,5)+1,A=Z(this,4)+4,y=new(i?Uint8Array:Array)(P.length),b=n,w=n,E=n,I=n,T=n;for(T=0;T<A;++T)y[P[T]]=Z(this,3);if(!i)for(T=A,A=y.length;T<A;++T)y[P[T]]=0;for(v=u(y),b=new(i?Uint8Array:Array)(x+p),T=0,g=x+p;T<g;)switch(w=Y(this,v),w){case 16:for(I=3+Z(this,2);I--;)b[T++]=E;break;case 17:for(I=3+Z(this,3);I--;)b[T++]=0;E=0;break;case 18:for(I=11+Z(this,7);I--;)b[T++]=0;E=0;break;default:E=b[T++]=w}_=u(i?b.subarray(0,x):b.slice(0,x)),m=u(i?b.subarray(x):b.slice(x)),this.o(_,m);break;default:e(Error("unknown BTYPE: "+r))}}return this.t()};var M,k,N=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15],P=i?new Uint16Array(N):N,D=[3,4,5,6,7,8,9,10,11,13,15,17,19,23,27,31,35,43,51,59,67,83,99,115,131,163,195,227,258,258,258],R=i?new Uint16Array(D):D,U=[0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0,0,0],L=i?new Uint8Array(U):U,F=[1,2,3,4,5,7,9,13,17,25,33,49,65,97,129,193,257,385,513,769,1025,1537,2049,3073,4097,6145,8193,12289,16385,24577],z=i?new Uint16Array(F):F,W=[0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13],G=i?new Uint8Array(W):W,V=new(i?Uint8Array:Array)(288);for(M=0,k=V.length;M<k;++M)V[M]=143>=M?8:255>=M?9:279>=M?7:8;var j,X,K=u(V),B=new(i?Uint8Array:Array)(30);for(j=0,X=B.length;j<X;++j)B[j]=5;var q=u(B);function Z(n,t){for(var r,o=n.g,i=n.e,a=n.input,s=n.c,c=a.length;i<t;)s>=c&&e(Error("input buffer is broken")),o|=a[s++]<<i,i+=8;return r=o&(1<<t)-1,n.g=o>>>t,n.e=i-t,n.c=s,r}function Y(n,t){for(var r,o,i=n.g,a=n.e,s=n.input,c=n.c,f=s.length,l=t[0],d=t[1];a<d&&!(c>=f);)i|=s[c++]<<a,a+=8;return(o=(r=l[i&(1<<d)-1])>>>16)>a&&e(Error("invalid code length: "+o)),n.g=i>>o,n.e=a-o,n.c=c,65535&r}function J(e){if("string"==typeof e){var n,t,r=e.split("");for(n=0,t=r.length;n<t;n++)r[n]=(255&r[n].charCodeAt(0))>>>0;e=r}for(var o,i=1,a=0,s=e.length,c=0;0<s;){s-=o=1024<s?1024:s;do{a+=i+=e[c++]}while(--o);i%=65521,a%=65521}return(a<<16|i)>>>0}function $(n,t){var r,o;if(this.input=n,this.c=0,!t&&(t={})||(t.index&&(this.c=t.index),t.verify&&(this.M=t.verify)),r=n[this.c++],o=n[this.c++],(15&r)===Q)this.method=Q;else e(Error("unsupported compression method"));0!=((r<<8)+o)%31&&e(Error("invalid fcheck flag:"+((r<<8)+o)%31)),32&o&&e(Error("fdict flag is not supported")),this.A=new O(n,{index:this.c,bufferSize:t.bufferSize,bufferType:t.bufferType,resize:t.resize})}O.prototype.o=function(e,n){var t=this.a,r=this.b;this.u=e;for(var o,i,a,s,c=t.length-258;256!==(o=Y(this,e));)if(256>o)r>=c&&(this.b=r,t=this.f(),r=this.b),t[r++]=o;else for(s=R[i=o-257],0<L[i]&&(s+=Z(this,L[i])),o=Y(this,n),a=z[o],0<G[o]&&(a+=Z(this,G[o])),r>=c&&(this.b=r,t=this.f(),r=this.b);s--;)t[r]=t[r++-a];for(;8<=this.e;)this.e-=8,this.c--;this.b=r},O.prototype.I=function(e,n){var t=this.a,r=this.b;this.u=e;for(var o,i,a,s,c=t.length;256!==(o=Y(this,e));)if(256>o)r>=c&&(c=(t=this.f()).length),t[r++]=o;else for(s=R[i=o-257],0<L[i]&&(s+=Z(this,L[i])),o=Y(this,n),a=z[o],0<G[o]&&(a+=Z(this,G[o])),r+s>c&&(c=(t=this.f()).length);s--;)t[r]=t[r++-a];for(;8<=this.e;)this.e-=8,this.c--;this.b=r},O.prototype.f=function(){var e,n,t=new(i?Uint8Array:Array)(this.b-32768),r=this.b-32768,o=this.a;if(i)t.set(o.subarray(32768,t.length));else for(e=0,n=t.length;e<n;++e)t[e]=o[e+32768];if(this.l.push(t),this.q+=t.length,i)o.set(o.subarray(r,r+32768));else for(e=0;32768>e;++e)o[e]=o[r+e];return this.b=32768,o},O.prototype.J=function(e){var n,t,r,o=this.input.length/this.c+1|0,a=this.input,s=this.a;return e&&("number"==typeof e.v&&(o=e.v),"number"==typeof e.F&&(o+=e.F)),2>o?t=(r=(a.length-this.c)/this.u[2]/2*258|0)<s.length?s.length+r:s.length<<1:t=s.length*o,i?(n=new Uint8Array(t)).set(s):n=s,this.a=n},O.prototype.t=function(){var e,n,t,r,o,a=0,s=this.a,c=this.l,f=new(i?Uint8Array:Array)(this.q+(this.b-32768));if(0===c.length)return i?this.a.subarray(32768,this.b):this.a.slice(32768,this.b);for(n=0,t=c.length;n<t;++n)for(r=0,o=(e=c[n]).length;r<o;++r)f[a++]=e[r];for(n=32768,t=this.b;n<t;++n)f[a++]=s[n];return this.l=[],this.buffer=f},O.prototype.H=function(){var e,n=this.b;return i?this.B?(e=new Uint8Array(n)).set(this.a.subarray(0,n)):e=this.a.subarray(0,n):(this.a.length>n&&(this.a.length=n),e=this.a),this.buffer=e},$.prototype.p=function(){var n,t=this.input;return n=this.A.p(),this.c=this.A.c,this.M&&((t[this.c++]<<24|t[this.c++]<<16|t[this.c++]<<8|t[this.c++])>>>0!==J(n)&&e(Error("invalid adler-32 checksum"))),n};var Q=8;function ee(e,n){this.input=e,this.a=new(i?Uint8Array:Array)(32768),this.h=ne.k;var t,r={};for(t in!n&&(n={})||"number"!=typeof n.compressionType||(this.h=n.compressionType),n)r[t]=n[t];r.outputBuffer=this.a,this.z=new _(this.input,r)}var ne=x;function te(e,n){var t,r,i,a;if(Object.keys)t=Object.keys(n);else for(r in t=[],i=0,n)t[i++]=r;for(i=0,a=t.length;i<a;++i)o(e+"."+(r=t[i]),n[r])}ee.prototype.j=function(){var n,t,r,o,a,s,c,f=0;if(c=this.a,(n=Q)===Q)t=Math.LOG2E*Math.log(32768)-8;else e(Error("invalid compression method"));if(r=t<<4|n,c[f++]=r,n===Q)switch(this.h){case ne.NONE:a=0;break;case ne.r:a=1;break;case ne.k:a=2;break;default:e(Error("unsupported compression type"))}else e(Error("invalid compression method"));return o=a<<6,c[f++]=o|31-(256*r+o)%31,s=J(this.input),this.z.b=f,f=(c=this.z.j()).length,i&&((c=new Uint8Array(c.buffer)).length<=f+4&&(this.a=new Uint8Array(c.length+4),this.a.set(c),c=this.a),c=c.subarray(0,f+4)),c[f++]=s>>24&255,c[f++]=s>>16&255,c[f++]=s>>8&255,c[f++]=255&s,c},o("Zlib.Inflate",$),o("Zlib.Inflate.prototype.decompress",$.prototype.p),te("Zlib.Inflate.BufferType",{ADAPTIVE:H.C,BLOCK:H.D}),o("Zlib.Deflate",ee),o("Zlib.Deflate.compress",(function(e,n){return new ee(e,n).j()})),o("Zlib.Deflate.prototype.compress",ee.prototype.j),te("Zlib.Deflate.CompressionType",{NONE:ne.NONE,FIXED:ne.r,DYNAMIC:ne.k})}.call(self);var f="undefined"!=typeof Float32Array?Float32Array:Array;function l(e){return e[0]=1,e[1]=0,e[2]=0,e[3]=0,e[4]=0,e[5]=1,e[6]=0,e[7]=0,e[8]=0,e[9]=0,e[10]=1,e[11]=0,e[12]=0,e[13]=0,e[14]=0,e[15]=1,e}Math.hypot||(Math.hypot=function(){for(var e=0,n=arguments.length;n--;)e+=arguments[n]*arguments[n];return Math.sqrt(e)});function d(){var e=new f(3);return f!=Float32Array&&(e[0]=0,e[1]=0,e[2]=0),e}function h(e,n,t){var r=new f(3);return r[0]=e,r[1]=n,r[2]=t,r}function v(e,n){var t=n[0],r=n[1],o=n[2],i=t*t+r*r+o*o;return i>0&&(i=1/Math.sqrt(i)),e[0]=n[0]*i,e[1]=n[1]*i,e[2]=n[2]*i,e}function u(e,n,t){var r=n[0],o=n[1],i=n[2],a=t[0],s=t[1],c=t[2];return e[0]=o*c-i*s,e[1]=i*a-r*c,e[2]=r*s-o*a,e}var _=function(e,n,t){return e[0]=n[0]-t[0],e[1]=n[1]-t[1],e[2]=n[2]-t[2],e};function m(){var e=new f(4);return f!=Float32Array&&(e[0]=0,e[1]=0,e[2]=0),e[3]=1,e}d(),function(){var e,n=(e=new f(4),f!=Float32Array&&(e[0]=0,e[1]=0,e[2]=0,e[3]=0),e)}();var g;function x(e,n,t){return e[0]=n,e[1]=t,e}d(),h(1,0,0),h(0,1,0),m(),m(),g=new f(9),f!=Float32Array&&(g[1]=0,g[2]=0,g[3]=0,g[5]=0,g[6]=0,g[7]=0),g[0]=1,g[4]=1,g[8]=1,function(){var e=function(){var e=new f(2);return f!=Float32Array&&(e[0]=0,e[1]=0),e}()}(),
/*!
     * @maptalks/reshader.gl v0.106.0
     * LICENSE : UNLICENSED
     * (c) 2016-2025 maptalks.com
     */
l([]),l([]),new Array(16),function(){const e=new ArrayBuffer(4),n=new Float32Array(e),t=new Uint32Array(e),r=new Uint32Array(512),o=new Uint32Array(512);for(let e=0;e<256;++e){const n=e-127;n<-27?(r[e]=0,r[256|e]=32768,o[e]=24,o[256|e]=24):n<-14?(r[e]=1024>>-n-14,r[256|e]=1024>>-n-14|32768,o[e]=-n-1,o[256|e]=-n-1):n<=15?(r[e]=n+15<<10,r[256|e]=n+15<<10|32768,o[e]=13,o[256|e]=13):n<128?(r[e]=31744,r[256|e]=64512,o[e]=24,o[256|e]=24):(r[e]=31744,r[256|e]=64512,o[e]=13,o[256|e]=13)}const i=new Uint32Array(2048),a=new Uint32Array(64),s=new Uint32Array(64);for(let e=1;e<1024;++e){let n=e<<13,t=0;for(;!(8388608&n);)n<<=1,t-=8388608;n&=-8388609,t+=947912704,i[e]=n|t}for(let e=1024;e<2048;++e)i[e]=939524096+(e-1024<<13);for(let e=1;e<31;++e)a[e]=e<<23;a[31]=1199570944,a[32]=2147483648;for(let e=33;e<63;++e)a[e]=2147483648+(e-32<<23);a[63]=3347054592;for(let e=1;e<64;++e)32!==e&&(s[e]=1024)}();const p={vsm_shadow_vert:"\\nuniform mat4 shadow_lightProjViewModelMatrix;\\nvarying vec4 shadow_vLightSpacePos;\\nvoid shadow_computeShadowPars(vec4 position) {\\n    shadow_vLightSpacePos = shadow_lightProjViewModelMatrix * position;\\n}",vsm_shadow_frag:"\\nuniform sampler2D shadow_shadowMap;\\nuniform float shadow_opacity;\\nuniform vec3 shadow_color;\\n#if defined(USE_ESM)\\n    uniform float esm_shadow_threshold;\\n#endif\\nvarying vec4 shadow_vLightSpacePos;\\n#ifdef PACK_FLOAT\\n    #include <common_pack_float>\\n#endif\\n#if defined(USE_ESM)\\nfloat esm(vec3 projCoords, vec4 shadowTexel) {\\n    float compare = projCoords.z;\\n    float c = 120.0;\\n    #ifdef PACK_FLOAT\\n        float depth = common_decodeDepth(shadowTexel);\\n        if (depth >= 1.0 - 1E-6 || compare <= depth) {\\n            return 1.0;\\n        }\\n    #else\\n        float depth = shadowTexel.r;\\n    #endif\\n    depth = exp(-c * min(compare - depth, 0.05));\\n    return clamp(depth, esm_shadow_threshold, 1.0);\\n}\\n#endif\\n#if defined(USE_VSM)\\nfloat vsm_shadow_chebyshevUpperBound(vec3 projCoords, vec4 shadowTexel){\\n    vec2 moments = shadowTexel.rg;\\n    float distance = projCoords.z;\\n    if (distance >= 1.0 || distance <= moments.x)\\n        return 1.0 ;\\n    float variance = moments.y - (moments.x * moments.x);\\n    variance = max(variance, 0.00002);\\n    float d = distance - moments.x;\\n    float p_max = variance / (variance + d * d);\\n    return p_max;\\n}\\n#endif\\nfloat shadow_computeShadow_coeff(sampler2D shadowMap, vec3 projCoords) {\\n    vec2 uv = projCoords.xy;\\n    vec4 shadowTexel = texture2D(shadowMap, uv);\\n    #if defined(USE_ESM)\\n        float esm_coeff = esm(projCoords, shadowTexel);\\n        float coeff = esm_coeff * esm_coeff;\\n    #endif\\n    #if defined(USE_VSM)\\n        float vsm_coeff = vsm_shadow_chebyshevUpperBound(projCoords, shadowTexel);\\n        float coeff = vsm_coeff;\\n    #endif\\n    return 1.0 - (1.0 - coeff) * shadow_opacity;\\n}\\nfloat shadow_computeShadow() {\\n    vec3 projCoords = shadow_vLightSpacePos.xyz / shadow_vLightSpacePos.w;\\n    projCoords = projCoords * 0.5 + 0.5;\\n    if(projCoords.z >= 1.0 || projCoords.x < 0.0 || projCoords.x > 1.0 || projCoords.y < 0.0 || projCoords.y > 1.0) return 1.0;\\n    return shadow_computeShadow_coeff(shadow_shadowMap, projCoords);\\n}\\nvec3 shadow_blend(vec3 color, float coeff) {\\n    color = color * coeff + shadow_color * shadow_opacity * (1.0 - coeff);\\n    return color;\\n}",fbo_picking_vert:"\\n#ifdef ENABLE_PICKING\\n#if HAS_PICKING_ID == 1\\nattribute float aPickingId;\\n#elif HAS_PICKING_ID == 2\\nuniform float uPickingId;\\n#endif\\nvarying float vPickingId;\\nvarying float vFbo_picking_viewZ;\\nvarying float vFbo_picking_visible;\\n#endif\\nvarying float vFbo_picking_fragDepth;\\nvoid fbo_picking_setData(float viewPosZ, bool visible) {\\n    #ifdef ENABLE_PICKING\\n    #if HAS_PICKING_ID == 1\\n       vPickingId = aPickingId;\\n    #elif HAS_PICKING_ID == 2\\n        vPickingId = uPickingId;\\n    #endif\\n        vFbo_picking_viewZ = viewPosZ;\\n    #endif\\n    vFbo_picking_visible = visible ? 1.0 : 0.0;\\n    vFbo_picking_fragDepth = viewPosZ + 1.0;\\n}",common_pack_float:"const float COMMON_FLOAT_MAX =  1.70141184e38;\\nconst float COMMON_FLOAT_MIN = 1.17549435e-38;\\nfloat common_packFloat(vec4 val){\\n    vec4 scl = floor(255.0 * val + 0.5);\\n    float sgn = (scl.a < 128.0) ? 1.0 : -1.0;\\n    float exn = mod(scl.a * 2.0, 256.0) + floor(scl.b / 128.0) - 127.0;\\n    float man = 1.0 +\\n        (scl.r / 8388608.0) +\\n        (scl.g / 32768.0) +\\n        mod(scl.b, 128.0) / 128.0;\\n    return sgn * man * pow(2.0, exn);\\n}\\nvec4 common_unpackFloat(highp float v) {\\n    highp float av = abs(v);\\n    if(av < COMMON_FLOAT_MIN) {\\n        return vec4(0.0, 0.0, 0.0, 0.0);\\n    } else if(v > COMMON_FLOAT_MAX) {\\n        return vec4(127.0, 128.0, 0.0, 0.0) / 255.0;\\n    } else if(v < -COMMON_FLOAT_MAX) {\\n        return vec4(255.0, 128.0, 0.0, 0.0) / 255.0;\\n    }\\n    highp vec4 c = vec4(0,0,0,0);\\n    highp float e = floor(log2(av));\\n    highp float m = av * pow(2.0, -e) - 1.0;\\n    c[1] = floor(128.0 * m);\\n    m -= c[1] / 128.0;\\n    c[2] = floor(32768.0 * m);\\n    m -= c[2] / 32768.0;\\n    c[3] = floor(8388608.0 * m);\\n    highp float ebias = e + 127.0;\\n    c[0] = floor(ebias / 2.0);\\n    ebias -= c[0] * 2.0;\\n    c[1] += floor(ebias) * 128.0;\\n    c[0] += 128.0 * step(0.0, -v);\\n    return c / 255.0;\\n}\\nvec4 common_encodeDepth(const in float depth) {\\n    float alpha = 1.0;\\n    vec4 pack = vec4(0.0);\\n    pack.a = alpha;\\n    const vec3 code = vec3(1.0, 255.0, 65025.0);\\n    pack.rgb = vec3(code * depth);\\n    pack.gb = fract(pack.gb);\\n    pack.rg -= pack.gb * (1.0 / 256.0);\\n    pack.b -= mod(pack.b, 4.0 / 255.0);\\n    return pack;\\n}\\nfloat common_decodeDepth(const in vec4 pack) {\\n    return pack.r + pack.g / 255.0;\\n}",invert_matrix:"mat4 invert_matrix(mat4 matrix) {\\n    #if __VERSION__ == 300\\n        return inverse(matrix);\\n    #else\\n        vec4 vector1 = matrix[0], vector2 = matrix[1], vector3 = matrix[2], vector4 = matrix[3];\\n        float a00 = vector1.x, a01 = vector1.y, a02 = vector1.z, a03 = vector1.w;\\n        float a10 = vector2.x, a11 = vector2.y, a12 = vector2.z, a13 = vector2.w;\\n        float a20 = vector3.x, a21 = vector3.y, a22 = vector3.z, a23 = vector3.w;\\n        float a30 = vector4.x, a31 = vector4.y, a32 = vector4.z, a33 = vector4.w;\\n        float b00 = a00 * a11 - a01 * a10;\\n        float b01 = a00 * a12 - a02 * a10;\\n        float b02 = a00 * a13 - a03 * a10;\\n        float b03 = a01 * a12 - a02 * a11;\\n        float b04 = a01 * a13 - a03 * a11;\\n        float b05 = a02 * a13 - a03 * a12;\\n        float b06 = a20 * a31 - a21 * a30;\\n        float b07 = a20 * a32 - a22 * a30;\\n        float b08 = a20 * a33 - a23 * a30;\\n        float b09 = a21 * a32 - a22 * a31;\\n        float b10 = a21 * a33 - a23 * a31;\\n        float b11 = a22 * a33 - a23 * a32;\\n        float det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;\\n        det = 1.0 / det;\\n        mat4 m = mat4(\\n            (a11 * b11 - a12 * b10 + a13 * b09) * det,\\n            (a02 * b10 - a01 * b11 - a03 * b09) * det,\\n            (a31 * b05 - a32 * b04 + a33 * b03) * det,\\n            (a22 * b04 - a21 * b05 - a23 * b03) * det,\\n            (a12 * b08 - a10 * b11 - a13 * b07) * det,\\n            (a00 * b11 - a02 * b08 + a03 * b07) * det,\\n            (a32 * b02 - a30 * b05 - a33 * b01) * det,\\n            (a20 * b05 - a22 * b02 + a23 * b01) * det,\\n            (a10 * b10 - a11 * b08 + a13 * b06) * det,\\n            (a01 * b08 - a00 * b10 - a03 * b06) * det,\\n            (a30 * b04 - a31 * b02 + a33 * b00) * det,\\n            (a21 * b02 - a20 * b04 - a23 * b00) * det,\\n            (a11 * b07 - a10 * b09 - a12 * b06) * det,\\n            (a00 * b09 - a01 * b07 + a02 * b06) * det,\\n            (a31 * b01 - a30 * b03 - a32 * b00) * det,\\n            (a20 * b03 - a21 * b01 + a22 * b00) * det\\n        );\\n        return m;\\n    #endif\\n}\\nmat4 transpose_matrix(mat4 matrix) {\\n    #if __VERSION__ == 300\\n        return transpose(matrix);\\n    #else\\n        vec4 vector1 = matrix[0], vector2 = matrix[1], vector3 = matrix[2], vector4 = matrix[3];\\n        float a01 = vector1.y, a02 = vector1.z, a03 = vector1.w;\\n        float a12 = vector2.z, a13 = vector2.w;\\n        float a23 = vector3.w;\\n        mat4 m = mat4(\\n            vector1.x,\\n            vector2.x,\\n            vector3.x,\\n            vector4.x,\\n            a01,\\n            vector2.y,\\n            vector3.y,\\n            vector4.y,\\n            a02,\\n            a12,\\n            vector3.z,\\n            vector4.z,\\n            a03,\\n            a13,\\n            a23,\\n            vector4.w\\n        );\\n        return m;\\n    #endif\\n}",get_output:"#include <invert_matrix>\\n#include <draco_decode_vert>\\n#ifdef HAS_INSTANCE\\n    #include <instance_vert>\\n    #ifdef HAS_INSTANCE_COLOR\\n        varying vec4 vInstanceColor;\\n    #endif\\n#endif\\n#ifdef HAS_SKIN\\n    uniform int skinAnimation;\\n    #include <skin_vert>\\n#endif\\n#include <mask_vert>\\n#ifdef HAS_MORPH\\n    attribute vec3 POSITION0;\\n    attribute vec3 POSITION1;\\n    attribute vec3 POSITION2;\\n    attribute vec3 POSITION3;\\n    attribute vec3 POSITION4;\\n    attribute vec3 POSITION5;\\n    attribute vec3 POSITION6;\\n    attribute vec3 POSITION7;\\n    #ifdef HAS_MORPHNORMALS\\n        attribute vec3 NORMAL0;\\n        attribute vec3 NORMAL1;\\n        attribute vec3 NORMAL2;\\n        attribute vec3 NORMAL3;\\n    #endif\\n    uniform vec4 morphWeights1;\\n    uniform vec4 morphWeights2;\\n#endif\\n#ifdef HAS_TERRAIN_ALTITUDE\\nattribute float aTerrainAltitude;\\n#endif\\nmat4 getPositionMatrix() {\\n    mat4 worldMatrix;\\n    #ifdef HAS_INSTANCE\\n        #ifdef HAS_INSTANCE_COLOR\\n            vInstanceColor = instance_getInstanceColor();\\n        #endif\\n        mat4 attributeMatrix = instance_getAttributeMatrix();\\n        #ifdef HAS_SKIN\\n            if (skinAnimation == 1) {\\n                worldMatrix = attributeMatrix * positionMatrix * skin_getSkinMatrix();\\n            } else {\\n                worldMatrix = attributeMatrix * positionMatrix;\\n            }\\n        #else\\n            worldMatrix = attributeMatrix * positionMatrix;\\n        #endif\\n    #else\\n        #ifdef HAS_SKIN\\n            if (skinAnimation == 1) {\\n                worldMatrix = skin_getSkinMatrix() * positionMatrix;\\n            } else {\\n                worldMatrix = positionMatrix;\\n            }\\n        #else\\n            worldMatrix = positionMatrix;\\n        #endif\\n    #endif\\n    return worldMatrix;\\n}\\n#ifdef HAS_MIN_ALTITUDE\\nuniform float minAltitude;\\n#endif\\nvec4 getPosition(vec3 aPosition) {\\n    vec3 position = decode_getPosition(aPosition);\\n    #ifdef HAS_MORPH\\n        vec4 POSITION = vec4(position + morphWeights1[0] * POSITION0 + morphWeights1[1] * POSITION1 + morphWeights1[2] * POSITION2 + morphWeights1[3] * POSITION3\\n        + morphWeights2[0] * POSITION4 + morphWeights2[1] * POSITION5 + morphWeights2[2] * POSITION6 + morphWeights2[3] * POSITION7\\n        , 1.0);\\n    #else\\n        vec4 POSITION = vec4(position, 1.0);\\n    #endif\\n    #ifdef HAS_TERRAIN_ALTITUDE\\n        POSITION.z += aTerrainAltitude * 100.0;\\n    #endif\\n    #ifdef HAS_MIN_ALTITUDE\\n        POSITION.z += minAltitude * 100.0;\\n    #endif\\n    return POSITION;\\n}\\nvec3 appendMorphNormal(vec3 NORMAL) {\\n    #ifdef HAS_MORPHNORMALS\\n        vec3 normal = NORMAL + morphWeights1[0] * NORMAL0 + morphWeights1[1] * NORMAL1 + morphWeights1[2] * NORMAL2 + morphWeights1[3] * NORMAL3;\\n    #else\\n        vec3 normal = NORMAL;\\n    #endif\\n    return normal;\\n}",instance_vert:"attribute vec4 instance_vectorA;\\nattribute vec4 instance_vectorB;\\nattribute vec4 instance_vectorC;\\n#ifdef HAS_INSTANCE_TERRAIN_ALTITUDE\\nattribute float aTerrainAltitude;\\nuniform float terrainAltitudeScale;\\n#endif\\nmat4 instance_getAttributeMatrix() {\\n    mat4 mat =  mat4(\\n        instance_vectorA.x, instance_vectorB.x, instance_vectorC.x, 0.0,\\n        instance_vectorA.y, instance_vectorB.y, instance_vectorC.y, 0.0,\\n        instance_vectorA.z, instance_vectorB.z, instance_vectorC.z, 0.0,\\n        instance_vectorA.w, instance_vectorB.w, instance_vectorC.w, 1.0\\n    );\\n    #ifdef HAS_INSTANCE_TERRAIN_ALTITUDE\\n        mat4 terrainMat = mat4(\\n            1., 0., 0., 0.,\\n            0., 1., 0., 0.,\\n            0., 0., 1., 0.,\\n            0., 0., aTerrainAltitude * terrainAltitudeScale, 1.\\n        );\\n        mat = terrainMat * mat;\\n    #endif\\n    return mat;\\n}\\n#ifdef HAS_INSTANCE_HIGHLIGHT\\n    attribute vec4 highlight_color;\\n#endif\\n#ifdef HAS_INSTANCE_COLOR\\n   \\n    attribute vec4 instance_color;\\n    vec4 instance_getInstanceColor() {\\n        vec4 color = instance_color;\\n        #ifdef HAS_INSTANCE_HIGHLIGHT\\n            color = instance_color * highlight_color;\\n        #endif\\n        return color;\\n    }\\n#endif",skin_vert:"attribute vec4 WEIGHTS_0;\\nattribute vec4 JOINTS_0;\\nuniform sampler2D jointTexture;\\nuniform vec2 jointTextureSize;\\nuniform float numJoints;\\n#define ROW0_U ((0.5 + 0.0) / 4.)\\n#define ROW1_U ((0.5 + 1.0) / 4.)\\n#define ROW2_U ((0.5 + 2.0) / 4.)\\n#define ROW3_U ((0.5 + 3.0) / 4.)\\nmat4 skin_getBoneMatrix(float jointNdx) {\\n    float v = (jointNdx + 0.5) / numJoints;\\n    return mat4(\\n        texture2D(jointTexture, vec2(ROW0_U, v)),\\n        texture2D(jointTexture, vec2(ROW1_U, v)),\\n        texture2D(jointTexture, vec2(ROW2_U, v)),\\n        texture2D(jointTexture, vec2(ROW3_U, v)));\\n}\\nmat4 skin_getSkinMatrix() {\\n        mat4 skinMatrix = skin_getBoneMatrix(JOINTS_0[0]) * WEIGHTS_0[0] +\\n                        skin_getBoneMatrix(JOINTS_0[1]) * WEIGHTS_0[1] +\\n                        skin_getBoneMatrix(JOINTS_0[2]) * WEIGHTS_0[2] +\\n                        skin_getBoneMatrix(JOINTS_0[3]) * WEIGHTS_0[3];\\n        return skinMatrix;\\n}",heatmap_render_vert:"#ifdef HAS_HEATMAP\\nvarying vec2 heatmap_vTexCoord;\\nvoid heatmap_compute(mat4 matrix, vec3 position) {\\n    vec4 pos = matrix * vec4(position.xy, 0., 1.);\\n    heatmap_vTexCoord = (1. + pos.xy / pos.w) / 2.;\\n}\\n#endif",heatmap_render_frag:"#ifdef HAS_HEATMAP\\nuniform sampler2D heatmap_inputTexture;\\nuniform sampler2D heatmap_colorRamp;\\nuniform float heatmap_heatmapOpacity;\\nvarying vec2 heatmap_vTexCoord;\\nvec4 heatmap_getColor(vec4 color) {\\n    float t = texture2D(heatmap_inputTexture, heatmap_vTexCoord).r;\\n    vec4 heatmapColor = texture2D(heatmap_colorRamp, vec2(t, 0.5)) * heatmap_heatmapOpacity;\\n    return color * (1.0 - heatmapColor.a) + heatmapColor * heatmapColor.a;\\n}\\n#endif",line_extrusion_vert:"#ifdef IS_LINE_EXTRUSION\\n    #define ALTITUDE_SCALE 32767.0;\\n    #define EXTRUDE_SCALE 63.0;\\n    attribute vec2 aExtrude;\\n    #ifdef HAS_LINE_WIDTH\\n        attribute float aLineWidth;\\n    #else\\n        uniform float lineWidth;\\n    #endif\\n    #ifdef HAS_LINE_HEIGHT\\n        attribute float aLineHeight;\\n    #else\\n        uniform float lineHeight;\\n    #endif\\n    uniform float linePixelScale;\\n    vec3 getLineExtrudePosition(vec3 position) {\\n        #ifdef HAS_LINE_WIDTH\\n            float lineWidth = aLineWidth / 2.0;\\n        #endif\\n        #ifdef HAS_LINE_HEIGHT\\n            float lineHeight = aLineHeight / 10.0;\\n        #endif\\n        float halfwidth = lineWidth / 2.0;\\n        float outset = halfwidth;\\n        vec2 dist = outset * aExtrude / EXTRUDE_SCALE;\\n        position.z *= lineHeight / ALTITUDE_SCALE;\\n        return position + vec3(dist, 0.0) * linePixelScale;\\n    }\\n#endif",gl2_vert:"#if __VERSION__ == 300\\n    #define texture2D texture\\n    #define varying out\\n    #define attribute in\\n#endif",gl2_frag:"#if __VERSION__ == 300\\n    #define varying in\\n    #define gl_FragDepthEXT gl_FragDepth\\n    #define texture2D texture\\n    #define textureCube texture\\n    #define texture2DProj textureProj\\n    #define texture2DLodEXT textureLod\\n    #define texture2DProjLodEXT textureProjLod\\n    #define textureCubeLodEXT textureLod\\n    #define texture2DGradEXT textureGrad\\n    #define texture2DProjGradEXT textureProjGrad\\n    #define textureCubeGradEXT textureGrad\\n    #define texture2D texture\\n    out vec4 glFragColor;\\n#else\\n    vec4 glFragColor;\\n#endif",hsv_frag:"\\nconst mediump vec4 HSV_K0 = vec4(0.0, -1.0 / 3.0, 2.0 / 3.0, -1.0);\\nconst mediump vec4 HSV_K1 = vec4(1.0, 2.0 / 3.0, 1.0 / 3.0, 3.0);\\nconst mediump float HSV_E = 1.0e-10;\\nvec3 hsv_rgb2hsv(vec3 c) {\\n    vec4 K = HSV_K0;\\n    vec4 p = mix(vec4(c.bg, K.wz), vec4(c.gb, K.xy), step(c.b, c.g));\\n    vec4 q = mix(vec4(p.xyw, c.r), vec4(c.r, p.yzx), step(p.x, c.r));\\n    float d = q.x - min(q.w, q.y);\\n    float e = HSV_E;\\n    return vec3(abs(q.z + (q.w - q.y) / (6.0 * d + e)), d / (q.x + e), q.x);\\n}\\nvec3 hsv_hsv2rgb(vec3 c) {\\n    vec4 K = HSV_K1;\\n    vec3 p = abs(fract(c.xxx + K.xyz) * 6.0 - K.www);\\n    return c.z * mix(K.xxx, clamp(p - K.xxx, 0.0, 1.0), c.y);\\n}\\nvec4 hsv_apply(vec4 c, vec3 hsvOffset) {\\n    vec3 hsv = hsv_rgb2hsv(c.rgb);\\n    hsv += hsv * hsvOffset;\\n    hsv = clamp(hsv, 0.0, 1.0);\\n    return vec4(hsv_hsv2rgb(hsv), c.a);\\n}\\nvec3 hsv_apply(vec3 c, vec3 hsvOffset) {\\n    vec3 hsv = hsv_rgb2hsv(c.rgb);\\n    hsv += hsv * hsvOffset;\\n    hsv = clamp(hsv, 0.0, 1.0);\\n    return hsv_hsv2rgb(hsv);\\n}\\nmat4 contrastMatrix(float contrast)\\n{\\n    float t = (1.0 - contrast) / 2.0;\\n    return mat4(\\n        contrast, 0., 0., 0.,\\n        0., contrast, 0., 0.,\\n        0., 0., contrast, 0.,\\n        t, t, t, 1\\n    );\\n}",snow_frag:"#ifdef HAS_SNOW\\n    float lerp(float a, float b, float w) {\\n        return a + w * (b - a);\\n    }\\n    vec3 snow(vec4 sceneColor, vec3 normalColor, float height) {\\n        float snowIntense = normalColor.b;\\n        vec3 fixedC = vec3(1.0, 1.0, 1.0);\\n        if (height < 1.0) {\\n            float r = lerp(0.5, fixedC.x, snowIntense);\\n            float g = lerp(0.5, fixedC.y, snowIntense);\\n            float b = lerp(0.5, fixedC.z, snowIntense);\\n            return vec3(r, g, b);\\n        } else {\\n            float r = lerp(sceneColor.r, fixedC.x, snowIntense);\\n            float g = lerp(sceneColor.g, fixedC.y, snowIntense);\\n            float b = lerp(sceneColor.b, fixedC.z, snowIntense);\\n            return vec3(r, g, b);\\n        }\\n    }\\n#endif",draco_decode_vert:"#if defined(HAS_TANGENT)\\n    attribute vec4 aTangent;\\n#elif defined(HAS_NORMAL)\\n    #ifdef HAS_DRACO_NORMAL\\n        attribute vec2 aNormal;\\n        uniform float gltf_u_dec_normal_rangeConstant;\\n    #else\\n        attribute vec3 aNormal;\\n    #endif\\n#endif\\n#ifdef HAS_DRACO_POSITION\\n    uniform float gltf_u_dec_position_normConstant;\\n    uniform vec3 minValues_pos;\\n    vec3 decodeDracoPosition(vec3 aPosition) {\\n        return minValues_pos + aPosition * gltf_u_dec_position_normConstant;\\n    }\\n#endif\\n#ifdef HAS_DRACO_TEXCOORD\\n    uniform vec2 minValues_tex;\\n    uniform float gltf_u_dec_texcoord_0_normConstant;\\n    vec2 decodeDracoTexcoord(vec2 aTexCoord) {\\n        return minValues_tex + aTexCoord * gltf_u_dec_texcoord_0_normConstant;\\n    }\\n#endif\\n#ifdef HAS_WEB3D_quantized_attributes_TEXCOORD\\n    uniform mat3 decodeMatrix;\\n#endif\\n#ifdef HAS_DRACO_NORMAL\\n    float czm_signNotZero(float value) {\\n        return value >= 0.0 ? 1.0 : -1.0;\\n    }\\n    vec2 czm_signNotZero(vec2 value) {\\n        return vec2(czm_signNotZero(value.x), czm_signNotZero(value.y));\\n    }\\n    vec3 decodeDracoNormal(vec2 encoded, float range)\\n    {\\n        if (encoded.x == 0.0 && encoded.y == 0.0) {\\n            return vec3(0.0, 0.0, 0.0);\\n        }\\n        encoded = encoded / range * 2.0 - 1.0;\\n        vec3 v = vec3(encoded.x, encoded.y, 1.0 - abs(encoded.x) - abs(encoded.y));\\n        if (v.z < 0.0) {\\n            v.xy = (1.0 - abs(v.yx)) * czm_signNotZero(v.xy);\\n        }\\n        return normalize(v);\\n    }\\n    vec3 decode_getNormal(vec2 aNormal) {\\n        return decodeDracoNormal(aNormal, gltf_u_dec_normal_rangeConstant).zxy;\\n    }\\n#endif\\n#ifdef HAS_COMPRESSED_INT16\\n    #ifdef HAS_COMPRESSED_INT16_POSITION\\n      uniform vec2 compressedPositionRange;\\n    #endif\\n    #ifdef HAS_COMPRESSED_INT16_TEXCOORD_0\\n      uniform vec2 compressedTexcoordRange_0;\\n    #endif\\n    #ifdef HAS_COMPRESSED_INT16_TEXCOORD_1\\n      uniform vec2 compressedTexcoordRange_1;\\n    #endif\\n    #ifdef HAS_COMPRESSED_INT16_NORMAL\\n      uniform vec2 compressedNormalRange;\\n    #endif\\n    #ifdef HAS_COMPRESSED_INT16_RATIO\\n      uniform float compressed_ratio;\\n    #endif\\n    float int16ToFloat32(float value, vec2 range) {\\n        float v = (value >= 32768.0) ? -(65536.0 - value) / 32768.0 : value / 32767.0;\\n        return (v + 1.0) * (range.y - range.x) / 2.0 + range.x;\\n    }\\n#endif\\nvec3 decode_getPosition(vec3 aPosition) {\\n    vec3 position = aPosition;\\n    #if defined(HAS_COMPRESSED_INT16) && defined(HAS_COMPRESSED_INT16_POSITION)\\n        float x = int16ToFloat32(aPosition.x, compressedPositionRange);\\n        float y = int16ToFloat32(aPosition.y, compressedPositionRange);\\n        float z = int16ToFloat32(aPosition.z, compressedPositionRange);\\n        #ifdef HAS_COMPRESSED_INT16_RATIO\\n          position = vec3(x / compressed_ratio, y / compressed_ratio, z);\\n        #else\\n          position = vec3(x, y, z);\\n        #endif\\n    #endif\\n    #ifdef HAS_DRACO_POSITION\\n        return decodeDracoPosition(position);\\n    #else\\n        return position;\\n    #endif\\n}\\nvec2 decode_getTexcoord(vec2 aTexCoord) {\\n    vec2 texcoord = aTexCoord;\\n    #if defined(HAS_COMPRESSED_INT16) && (defined(HAS_COMPRESSED_INT16_TEXCOORD_0) || defined(HAS_COMPRESSED_INT16_TEXCOORD_1))\\n        float x = int16ToFloat32(aTexCoord.x, compressedTexcoordRange_0);\\n        float y = int16ToFloat32(aTexCoord.y, compressedTexcoordRange_0);\\n        texcoord = vec2(x, y);\\n    #endif\\n    #ifdef HAS_DRACO_TEXCOORD\\n        return decodeDracoTexcoord(texcoord);\\n    #elif defined(HAS_WEB3D_quantized_attributes_TEXCOORD)\\n        vec3 web3dTexcoord = decodeMatrix * vec3(texcoord, 1.0);\\n        return vec2(web3dTexcoord.x, web3dTexcoord.y);\\n    #else\\n        return texcoord;\\n    #endif\\n}\\nvec3 decode_getNormal(vec3 aNormal) {\\n    #ifdef HAS_COMPRESSED_INT16_NORMAL\\n        aNormal.x = int16ToFloat32(aNormal.x, compressedNormalRange);\\n        aNormal.y = int16ToFloat32(aNormal.y, compressedNormalRange);\\n        aNormal.z = int16ToFloat32(aNormal.z, compressedNormalRange);\\n    #endif\\n    return aNormal;\\n}",highlight_vert:"#if defined(HAS_HIGHLIGHT_COLOR)\\n    attribute vec4 aHighlightColor;\\n    varying vec4 vHighlightColor;\\n#endif\\n#if defined(HAS_HIGHLIGHT_OPACITY)\\n    attribute float aHighlightOpacity;\\n    varying float vHighlightOpacity;\\n#endif\\nvoid highlight_setVarying() {\\n    #if defined(HAS_HIGHLIGHT_COLOR)\\n        vHighlightColor = aHighlightColor / 255.0;\\n    #endif\\n    #if defined(HAS_HIGHLIGHT_OPACITY)\\n        vHighlightOpacity = aHighlightOpacity / 255.0;\\n    #endif\\n}",highlight_frag:"#if defined(HAS_HIGHLIGHT_COLOR)\\n\\tvarying vec4 vHighlightColor;\\n#endif\\n#if defined(HAS_HIGHLIGHT_OPACITY)\\n    varying float vHighlightOpacity;\\n#endif\\nvec4 highlight_blendColor(vec4 color) {\\n\\tvec4 outColor;\\n\\t#if defined(HAS_HIGHLIGHT_COLOR)\\n\\t\\tcolor.rgb = color.rgb * (1.0 - vHighlightColor.a) + vHighlightColor.rgb * vHighlightColor.a;\\n\\t\\t#ifndef HAS_HIGHLIGHT_COLOR_POINT\\n        \\tcolor.a = color.a * (1.0 - vHighlightColor.a) + vHighlightColor.a;\\n        #endif\\n        outColor = color;\\n\\t#else\\n\\t\\toutColor = color;\\n\\t#endif\\n\\t#if defined(HAS_HIGHLIGHT_OPACITY)\\n\\t\\toutColor *= vHighlightOpacity;\\n\\t#endif\\n\\treturn outColor;\\n}",mask_vert:"#ifdef HAS_MASK_EXTENT\\n    uniform vec4 mask_extent;\\n    uniform sampler2D mask_colorExtent;\\n    uniform sampler2D mask_modeExtent;\\n    uniform float mask_maskMode;\\n    uniform float mask_hasFlatOut;\\n    uniform mat4 viewMatrix;\\n    uniform float mask_heightRatio;\\n    uniform float mask_heightOffset;\\n    varying vec4 vWorldPosition;\\n    varying vec2 vUVInExtent;\\n    varying float vHeightRatio;\\n    varying float vHeightOffset;\\n    const float CLIPINSIDE_MODE = 0.2;\\n    const float FLATINSIDE_MODE = 0.3;\\n    const float FLATOUTSIDE_MODE = 0.4;\\n    const float ELEVATE_MODE = 0.7;\\n    float random (vec2 st) {\\n        return fract(sin(dot(st.xy,vec2(12.9898,78.233)))*43758.5453123) * 0.1;\\n    }\\n    bool isInExtent(vec4 color) {\\n        return length(color.rgb) > 0.0;\\n    }\\n    float getFlatHeight(float maskMode, float flatHeight, float height) {\\n      if (maskMode <= ELEVATE_MODE && maskMode > 0.6) {\\n          return flatHeight + height;\\n      } else {\\n        return flatHeight;\\n      }\\n    }\\n    vec4 getNoErrorPosition(vec4 position, vec4 wPosition) {\\n      vec4 realPos = modelViewMatrix * position;      vec4 pos = viewMatrix * wPosition;      vec4 tempPos = viewMatrix * modelMatrix * position;      float deltaX = realPos.x - tempPos.x;\\n      float deltaY = realPos.y - tempPos.y;\\n      float deltaZ = realPos.z - tempPos.z;\\n      pos.x = pos.x + deltaX;\\n      pos.y = pos.y + deltaY;\\n      pos.z = pos.z + deltaZ;\\n      return pos;\\n    }\\n    vec4 getMaskPosition(vec4 position, mat4 modelMatrix) {\\n        vWorldPosition = modelMatrix * position;\\n        float w = mask_extent.z - mask_extent.x;\\n        float h = mask_extent.y - mask_extent.w;\\n        vec2 uvInExtent = vec2((vWorldPosition.x - mask_extent.x) / abs(w), 1.0 - (vWorldPosition.y - mask_extent.w) / h);\\n        vec4 extentColor = texture2D(mask_colorExtent, uvInExtent);\\n        vec3 maskOptionColor = texture2D(mask_modeExtent, uvInExtent).rgb;\\n        float maskMode = maskOptionColor.r;\\n        float flatHeight = maskOptionColor.g / mask_heightRatio + mask_heightOffset;\\n        float height = getFlatHeight(maskMode, flatHeight, vWorldPosition.z);\\n        vec4 wPosition = vec4(vWorldPosition.x, vWorldPosition.y, height, vWorldPosition.w);\\n        vUVInExtent = uvInExtent;\\n        vHeightRatio = mask_heightRatio;\\n        vHeightOffset = mask_heightOffset;\\n        if (maskMode <= FLATOUTSIDE_MODE && maskMode > FLATINSIDE_MODE) {\\n            return modelViewMatrix * position;;\\n        } else if (mask_hasFlatOut == 1.0) {\\n            return getNoErrorPosition(position, wPosition);\\n        }\\n        if (isInExtent(extentColor) == true && maskMode <= FLATINSIDE_MODE && maskMode > CLIPINSIDE_MODE) {\\n            return getNoErrorPosition(position, wPosition);\\n        } if (isInExtent(extentColor) == true && maskMode <= ELEVATE_MODE && maskMode > 0.6) {\\n            return getNoErrorPosition(position, wPosition);\\n        } else {\\n            return modelViewMatrix * position;\\n        }\\n    }\\n#endif",mask_frag:"#ifdef HAS_MASK_EXTENT\\n    uniform sampler2D mask_colorExtent;\\n    uniform sampler2D mask_modeExtent;\\n    uniform float mask_hasClipOut;\\n    varying float vHeightRatio;\\n    varying float vHeightOffset;\\n    varying vec2 vUVInExtent;\\n    varying vec4 vWorldPosition;\\n    const float CLIPINSIDE_MODE = 0.1;\\n    const float CLIPOUTSIDE_MODE = 0.2;\\n    const float FLATINSIDE_MODE = 0.3;\\n    const float FLATOUTSIDE_MODE = 0.4;\\n    const float COLOR_MODE = 0.5;\\n    const float VIDEO_MODE = 0.6;\\n    bool isInExtent(vec4 color) {\\n        return length(color.rgb) > 0.0;\\n    }\\n    vec4 setMask(vec4 glFragColor) {\\n        vec4 extentColor = texture2D(mask_colorExtent, vUVInExtent);\\n        vec4 modeColor = texture2D(mask_modeExtent, vUVInExtent);\\n        float maskMode = modeColor.r;\\n        float minHeight = modeColor.b / vHeightRatio + vHeightOffset;\\n        float maxHeight = modeColor.a / vHeightRatio + vHeightOffset;\\n        if (maskMode > CLIPINSIDE_MODE && maskMode <= CLIPOUTSIDE_MODE) {\\n            if (minHeight == 0.0 && maxHeight == 0.0) {\\n                return glFragColor;\\n            } else if (vWorldPosition.z >= minHeight && vWorldPosition.z <= maxHeight) {\\n                return glFragColor;\\n            } else {\\n              discard;\\n            }\\n        } else if (mask_hasClipOut == 1.0) {\\n            discard;\\n        }\\n        if (isInExtent(extentColor) == true && maskMode <= CLIPINSIDE_MODE && maskMode > 0.0) {\\n            if (minHeight == 0.0 && maxHeight == 0.0) {\\n                discard;\\n            } else if (vWorldPosition.z >= minHeight && vWorldPosition.z <= maxHeight) {\\n                discard;\\n            } else {\\n              return glFragColor;\\n            }\\n        } else if (isInExtent(extentColor) == true && maskMode <= VIDEO_MODE && maskMode > FLATOUTSIDE_MODE) {\\n            if (minHeight == 0.0 && maxHeight == 0.0) {\\n                glFragColor = vec4(mix(extentColor.rgb, glFragColor.rgb, 1.0 - extentColor.a), glFragColor.a);\\n            } else if (vWorldPosition.z >= minHeight && vWorldPosition.z <= maxHeight) {\\n                glFragColor = vec4(mix(extentColor.rgb, glFragColor.rgb, 1.0 - extentColor.a), glFragColor.a);\\n            }\\n        }\\n        return glFragColor;\\n    }\\n#endif",computeTexcoord_frag:"#ifdef HAS_KHR_TEXTURE_TRANSFORM\\n    uniform vec2 khr_offset;\\n    uniform float khr_rotation;\\n    uniform vec2 khr_scale;\\n    vec2 khr_tex_transformTexCoord(vec2 texCoords, vec2 offset, float rotation, vec2 scale) {\\n        rotation = -rotation;\\n        mat3 transform = mat3(\\n        cos(rotation) * scale.x, sin(rotation) * scale.x, 0.0, -sin(rotation) * scale.y, cos(rotation) * scale.y, 0.0, offset.x, offset.y, 1.0);\\n        vec2 transformedTexCoords = (transform * vec3(fract(texCoords), 1.0)).xy;\\n        return transformedTexCoords;\\n    }\\n#endif\\nvarying highp vec2 vTexCoord;\\n#ifdef HAS_I3S_UVREGION\\n    varying vec4 vUvRegion;\\n#endif\\nvec2 computeTexCoord(vec2 texCoord) {\\n    #ifdef HAS_I3S_UVREGION\\n        vec2 atlasScale = vUvRegion.zw - vUvRegion.xy;\\n        vec2 uvAtlas = fract(texCoord) * atlasScale + vUvRegion.xy;\\n        return uvAtlas;\\n    #elif defined(HAS_KHR_TEXTURE_TRANSFORM)\\n        return khr_tex_transformTexCoord(texCoord, khr_offset, khr_rotation, khr_scale);\\n    #else\\n        return texCoord;\\n    #endif\\n}",terrain_normal_frag:"#ifdef HAS_TERRAIN_NORMAL\\n    uniform sampler2D terrainHeightTexture;\\n    uniform vec2 terrainHeightMapResolution;\\n    uniform vec2 terrainResolution;\\n    uniform float terrainHeightScale;\\n    uniform float terrainTileResolution;\\n    uniform vec4 terrainUnpackFactors;\\n    float getHeight(vec2 uv) {\\n        vec4 color = texture2D(terrainHeightTexture, uv) * 255.0;\\n        color.a = -1.0;\\n        return dot(color, terrainUnpackFactors) / 4.0;\\n    }\\n    vec3 convertTerrainHeightToNormalMap(vec2 uv) {\\n        uv.y = 1.0 - uv.y;\\n        vec2 epsilon = 1.0 / terrainHeightMapResolution;\\n        float a = getHeight(uv + vec2(-epsilon.x, -epsilon.y));\\n        float b = getHeight(uv + vec2(0, -epsilon.y));\\n        float c = getHeight(uv + vec2(epsilon.x, -epsilon.y));\\n        float d = getHeight(uv + vec2(-epsilon.x, 0));\\n        float e = getHeight(uv + vec2(epsilon.x, 0));\\n        float f = getHeight(uv + vec2(-epsilon.x, epsilon.y));\\n        float g = getHeight(uv + vec2(0, epsilon.y));\\n        float h = getHeight(uv + vec2(epsilon.x, epsilon.y));\\n        vec2 dxy = vec2(\\n            (c + e + e + h) - (a + d + d + f),\\n            (f + g + g + h) - (a + b + b + c)\\n        );\\n        return normalize(vec3(dxy / epsilon, terrainResolution ));\\n    }\\n#endif",vertex_color_vert:"#ifdef HAS_VERTEX_COLOR\\nattribute float aVertexColorType;\\nuniform vec4 vertexColorsOfType[VERTEX_TYPES_COUNT];\\nvarying vec4 vertexColor_color;\\nvoid vertexColor_update() {\\n    vertexColor_color = vertexColorsOfType[int(aVertexColorType)];\\n}\\n#endif\\n//\u{7528}\u{4E8E}\u{8BC6}\u{522B}\u{9876}\u{70B9}\u{989C}\u{8272}\u{7C7B}\u{578B}: topPolygonFill \u{8FD8}\u{662F} bottomPolygonFill",vertex_color_frag:"#ifdef HAS_VERTEX_COLOR\\nvarying vec4 vertexColor_color;\\nvec4 vertexColor_get() {\\n\\treturn vertexColor_color;\\n}\\n#endif",excavate_vert:"#ifdef HAS_EXCAVATE_ANALYSIS\\n  uniform vec4 excavateExtent;\\n  varying vec2 vCoordinateTexcoord;\\n  varying float vHeight;\\n  float getWorldHeight() {\\n    vec4 wPosition = modelMatrix * getPosition(aPosition);\\n    return wPosition.z;\\n  }\\n  vec2 getCoordinateTexcoord() {\\n    mat4 localPositionMatrix = getPositionMatrix();\\n    vec4 wPosition = modelMatrix * localPositionMatrix * getPosition(aPosition);\\n    float x = (wPosition.x - excavateExtent.x) / (excavateExtent.z - excavateExtent.x);\\n    float y = (wPosition.y - excavateExtent.y) / (excavateExtent.w - excavateExtent.y);\\n    return vec2(x, y);\\n  }\\n#endif",excavate_frag:"#ifdef HAS_EXCAVATE_ANALYSIS\\n  uniform sampler2D heightmap;\\n  uniform float excavateHeight;\\n  varying vec2 vCoordinateTexcoord;\\n  varying float vHeight;\\n  const vec2 range = vec2(-100.0, 1000.0);\\n  float decodeHeight(const in vec4 pack) {\\n      return pack.r + pack.g / 255.0;\\n  }\\n  vec4 excavateColor(vec4 fragColor) {\\n      float samplerHeight = decodeHeight(texture2D(heightmap, vCoordinateTexcoord));\\n      float realHeight = samplerHeight * (range.y - range.x) + range.x;\\n      if(realHeight < range.x || realHeight > range.y) {\\n          realHeight = 0.0;\\n      }\\n      if(vHeight > realHeight) {\\n          discard;\\n      }\\n      return fragColor;\\n  }\\n#endif",srgb_frag:"vec3 linearTosRGB(const in vec3 color) {\\n    return vec3( color.r < 0.0031308 ? color.r * 12.92 : 1.055 * pow(color.r, 1.0/2.4) - 0.055, color.g < 0.0031308 ? color.g * 12.92 : 1.055 * pow(color.g, 1.0/2.4) - 0.055, color.b < 0.0031308 ? color.b * 12.92 : 1.055 * pow(color.b, 1.0/2.4) - 0.055);\\n}\\nvec3 sRGBToLinear(const in vec3 color) {\\n    return vec3( color.r < 0.04045 ? color.r * (1.0 / 12.92) : pow((color.r + 0.055) * (1.0 / 1.055), 2.4), color.g < 0.04045 ? color.g * (1.0 / 12.92) : pow((color.g + 0.055) * (1.0 / 1.055), 2.4), color.b < 0.04045 ? color.b * (1.0 / 12.92) : pow((color.b + 0.055) * (1.0 / 1.055), 2.4));\\n}"};var A={register(e,n){if(p[e])throw new Error(\`Key of ${e}e} is already registered in ShaderLib.\`);p[e]=n},compile:e=>b(e)};const y=/^[ \\t]*#include +<([\\w\\d.]+)>/gm;function b(e){return e.replace(y,w)}function w(e,n){const t=p[n];if(!t)throw new Error("Can not resolve #include <"+n+">");return b(t)}const E=[[.263385,-.0252475],[-.38545,.054485],[-.139795,-.5379925],[-.2793775,.6875475],[.7139025,.4710925],[.90044,-.16422],[.4481775,-.82799],[-.9253375,-.2910625],[.3468025,1.02292],[-1.13742,.33522],[-.7676225,-.9123175],[-.2005775,-1.1774125],[-.926525,.96876],[1.12909,-.7500325],[.9603,1.14625]],I=E.length,T=[0,0];for(let e=0;e<E.length;e++)T[0]+=E[e][0],T[1]+=E[e][1];T[0]/=I,T[1]/=I;!function(e,n,t){var r=n[0],o=n[1],i=n[2],a=n[3],s=r+r,c=o+o,f=i+i,l=r*s,d=r*c,h=r*f,v=o*c,u=o*f,_=i*f,m=a*s,g=a*c,x=a*f;e[0]=1-(v+_),e[1]=d+x,e[2]=h-g,e[3]=0,e[4]=d-x,e[5]=1-(l+_),e[6]=u+m,e[7]=0,e[8]=h+g,e[9]=u-m,e[10]=1-(l+v),e[11]=0,e[12]=t[0],e[13]=t[1],e[14]=t[2],e[15]=1}([],function(e,n,t,r){var o=.5*Math.PI/180;n*=o,t*=o,r*=o;var i=Math.sin(n),a=Math.cos(n),s=Math.sin(t),c=Math.cos(t),f=Math.sin(r),l=Math.cos(r);return e[0]=i*c*l-a*s*f,e[1]=a*s*l+i*c*f,e[2]=a*c*f-i*s*l,e[3]=a*c*l+i*s*f,e}([],90,0,0),[0,0,0]),function(){const e=[0,0,0],n=90*Math.PI/180,t=[0,0,0,0],r=new Array(16)}(),A.compile("#define SHADER_NAME SKYBOX\\n#if __VERSION__ == 100\\n#ifdef GL_EXT_shader_texture_lod\\n#extension GL_EXT_shader_texture_lod : enable\\n#define textureCubeLod(tex, uv, lod) textureCubeLodEXT(tex, uv, lod)\\n#else\\n#define textureCubeLod(tex, uv, lod) textureCube(tex, uv, lod)\\n#endif\\n#else\\n#define textureCubeLod(tex, uv, lod) textureLod(tex, uv, lod)\\n#endif\\nprecision highp float;\\n#define saturate(x)        clamp(x, 0.0, 1.0)\\n#include <gl2_frag>\\n#include <hsv_frag>\\nuniform vec3 hsv;\\nvarying vec3 vWorldPos;\\n#ifdef USE_AMBIENT\\nuniform vec3 diffuseSPH[9];\\n#else\\nuniform samplerCube cubeMap;\\nuniform float bias;\\nuniform float size;\\n#endif\\nuniform float environmentExposure;\\nuniform float backgroundIntensity;\\nvec4 c(const in samplerCube d, const in vec3 e, const in float f, const in float h) {\\n  vec3 i = e;\\n  return textureCubeLod(d, i, h);\\n}\\nvec3 j(const in vec3 k, const in vec3 l[9]) {\\n  float x = k.x;\\n  float y = k.y;\\n  float z = k.z;\\n  vec3 m = (l[0] + l[1] * x + l[2] * y + l[3] * z + l[4] * z * x + l[5] * y * z + l[6] * y * x + l[7] * (3. * z * z - 1.) + l[8] * (x * x - y * y));\\n  return max(m, vec3(.0));\\n}\\nfloat n(const in vec2 o) {\\n  vec3 u = fract(vec3(o.xyx) * .1031);\\n  u += dot(u, u.yzx + 19.19);\\n  return fract((u.x + u.y) * u.z);\\n}\\n#if defined(TONE_MAPPING)\\nconst float v = 1.;\\nvec3 A(vec3 B) {\\n  vec3 a = B * (B + .0245786) - .000090537;\\n  vec3 b = B * (.983729 * B + .4329510) + .238081;\\n  return a / b;\\n}\\nvec3 C(vec3 D) {\\n  const mat3 E = mat3(vec3(.59719, .07600, .02840), vec3(.35458, .90834, .13383), vec3(.04823, .01566, .83777));\\n  const mat3 F = mat3(vec3(1.60475, -.10208, -.00327), vec3(-.53108, 1.10813, -.07276), vec3(-.07367, -.00605, 1.07602));\\n  D *= v / .6;\\n  D = E * D;\\n  D = A(D);\\n  D = F * D;\\n  return saturate(D);\\n}\\nvec3 G(vec3 D) {\\n  return C(D);\\n}\\nvec4 H(in vec4 I) {\\n  return vec4(mix(pow(I.rgb, vec3(.41666)) * 1.055 - vec3(.055), I.rgb * 12.92, vec3(lessThanEqual(I.rgb, vec3(.0031308)))), I.a);\\n}\\nvec4 J(vec4 I) {\\n  return (H(I));\\n}\\n#endif\\nvoid main() {\\n  vec4 K;\\n#ifdef USE_AMBIENT\\nvec3 k = normalize(vWorldPos + mix(-.5 / 255., .5 / 255., n(gl_FragCoord.xy)) * 2.);\\n  K = vec4(j(k, diffuseSPH), 1.);\\n#else\\nK = c(cubeMap, vWorldPos, size, bias);\\n#endif\\nK.rgb *= environmentExposure;\\n  K.rgb *= backgroundIntensity;\\n  glFragColor = K;\\n  if(length(hsv) > .0) {\\n    glFragColor.rgb = hsv_apply(clamp(glFragColor.rgb, .0, 1.), hsv);\\n  }\\n#if defined(TONE_MAPPING)\\nglFragColor.rgb = G(glFragColor.rgb);\\n  glFragColor = J(glFragColor);\\n#endif\\n#if __VERSION__ == 100\\ngl_FragColor = glFragColor;\\n#endif\\n}"),function(){const e=[[-1,-1,-1,1],[1,-1,-1,1],[1,1,-1,1],[-1,1,-1,1],[-1,-1,1,1],[1,-1,1,1],[1,1,1,1],[-1,1,1,1]],n=new Array(16)}(),function(){let e=new Array(4);const n=new Array(3),t=[0,0,0,0],r=[0,1,0],o=new Array(3);let i=new Array(16),a=new Array(16);const s=new Array(16),c=[1,1,1],f=[0,0,0]}();const O=new Uint8Array(4);new Float32Array(O.buffer);class S{constructor(e=257){this.gridSize=e;const n=e-1;if(n&n-1)throw new Error(\`Expected grid size to be 2^n+1, got ${e}e}.\`);this.numTriangles=n*n*2-2,this.numParentTriangles=this.numTriangles-n*n,this.indices=new Uint32Array(this.gridSize*this.gridSize),this.coords=new Uint16Array(4*this.numTriangles);for(let e=0;e<this.numTriangles;e++){let t=e+2,r=0,o=0,i=0,a=0,s=0,c=0;for(1&t?i=a=s=n:r=o=c=n;(t>>=1)>1;){const e=r+i>>1,n=o+a>>1;1&t?(i=r,a=o,r=s,o=c):(r=i,o=a,i=s,a=c),s=e,c=n}const f=4*e;this.coords[f+0]=r,this.coords[f+1]=o,this.coords[f+2]=i,this.coords[f+3]=a}}createTile(e){return new C(e,this)}}class C{constructor(e,n){const t=n.gridSize;if(e.length!==t*t)throw new Error(\`Expected terrain data of length ${e}t*t} (${e}t} x ${e}t}), got ${e}e.length}.\`);this.terrain=e,this.martini=n,this.errors=new Float32Array(e.length),this.update()}update(){const{numTriangles:e,numParentTriangles:n,coords:t,gridSize:r}=this.martini,{terrain:o,errors:i}=this;for(let a=e-1;a>=0;a--){const e=4*a,s=t[e+0],c=t[e+1],f=t[e+2],l=t[e+3],d=s+f>>1,h=c+l>>1,v=d+h-c,u=h+s-d,_=(o[c*r+s]+o[l*r+f])/2,m=h*r+d,g=Math.abs(_-o[m]);if(i[m]=Math.max(i[m],g),a<n){const e=(c+u>>1)*r+(s+v>>1),n=(l+u>>1)*r+(f+v>>1);i[m]=Math.max(i[m],i[e],i[n])}}}getMesh(e=0){const{gridSize:n,indices:t}=this.martini,{errors:r}=this;let o=0,i=0;const a=n-1;function s(a,c,f,l,d,h){const v=a+f>>1,u=c+l>>1;Math.abs(a-d)+Math.abs(c-h)>1&&r[u*n+v]>e?(s(d,h,a,c,v,u),s(f,l,d,h,v,u)):(t[c*n+a]=t[c*n+a]||++o,t[l*n+f]=t[l*n+f]||++o,t[h*n+d]=t[h*n+d]||++o,i++)}t.fill(0),s(0,0,a,a,a,0),s(a,a,0,0,0,a);const c=new Uint16Array(2*o),f=new Uint32Array(3*i);let l=0;function d(o,i,a,s,h,v){const u=o+a>>1,_=i+s>>1;if(Math.abs(o-h)+Math.abs(i-v)>1&&r[_*n+u]>e)d(h,v,o,i,u,_),d(a,s,h,v,u,_);else{const e=t[i*n+o]-1,r=t[s*n+a]-1,d=t[v*n+h]-1;c[2*e]=o,c[2*e+1]=i,c[2*r]=a,c[2*r+1]=s,c[2*d]=h,c[2*d+1]=v,f[l++]=e,f[l++]=r,f[l++]=d}}return d(0,0,a,a,a,0),d(a,a,0,0,0,a),{vertices:c,triangles:f}}getMeshWithSkirts(e=0,n){const{gridSize:t,indices:r}=this.martini,{errors:o}=this;let i=0,a=0;const s=t-1;let c,f,l=0;const d=[],h=[],v=[],u=[];function _(n,m,g,x,p,A){const y=n+g>>1,b=m+x>>1;Math.abs(n-p)+Math.abs(m-A)>1&&o[b*t+y]>e?(_(p,A,n,m,y,b),_(g,x,p,A,y,b)):(c=m*t+n,f=x*t+g,l=A*t+p,0===r[c]&&(0===n?d.push(i):n===s&&h.push(i),0===m?v.push(i):m===s&&u.push(i),r[c]=++i),0===r[f]&&(0===g?d.push(i):g===s&&h.push(i),0===x?v.push(i):x===s&&u.push(i),r[f]=++i),0===r[l]&&(0===p?d.push(i):p===s&&h.push(i),0===A?v.push(i):A===s&&u.push(i),r[l]=++i),a++)}let m;r.fill(0),_(0,0,s,s,s,0),_(s,s,0,0,0,s),m=n?2*(i+3*d.length-2+3*h.length-2+3*v.length-2+3*u.length-2):2*(i+d.length+h.length+v.length+u.length);const g=3*(a+2*(d.length-1)+2*(h.length-1)+2*(v.length-1)+2*(u.length-1)),x=new Uint16Array(m),p=new Uint32Array(g);let A=0;function y(n,i,a,s,c,f){const l=n+a>>1,d=i+s>>1;if(Math.abs(n-c)+Math.abs(i-f)>1&&o[d*t+l]>e)y(c,f,n,i,l,d),y(a,s,c,f,l,d);else{const e=r[i*t+n]-1,o=r[s*t+a]-1,l=r[f*t+c]-1;x[2*e]=n,x[2*e+1]=i,x[2*o]=a,x[2*o+1]=s,x[2*l]=c,x[2*l+1]=f,p[A++]=e,p[A++]=o,p[A++]=l}}y(0,0,s,s,s,0),y(s,s,0,0,0,s),d.sort(((e,n)=>x[2*e+1]-x[2*n+1])),h.sort(((e,n)=>x[2*n+1]-x[2*e+1])),v.sort(((e,n)=>x[2*n]-x[2*e])),u.sort(((e,n)=>x[2*e]-x[2*n]));let b,w,E,I,T=2*i,O=0;function S(e){O=e.length;for(let t=0;t<O-1;t++)b=e[t],w=e[t+1],E=T/2,I=(T+(n?6:2))/2,x[T++]=2*b,x[T++]=2*b+1,n&&(x[T++]=2*b,x[T++]=2*b+1,x[T++]=2*w,x[T++]=2*w+1),n?(p[A++]=E+1,p[A++]=E,p[A++]=E+2,p[A++]=E,p[A++]=I,p[A++]=E+2):(p[A++]=b,p[A++]=E,p[A++]=w,p[A++]=E,p[A++]=I,p[A++]=w);x[T++]=2*e[O-1],x[T++]=2*e[O-1]+1}S(d);const C=T;S(h);const H=T;S(v);const M=T;S(u);return{vertices:x,triangles:p,numVerticesWithoutSkirts:i,numTrianglesWithoutSkirts:a,leftSkirtIndex:C,rightSkirtIndex:H,bottomSkirtIndex:M,topSkirtIndex:T}}}const H={};let M;const k={width:100,height:10};let N,P=!1;try{const e=new OffscreenCanvas(1,1);e.getContext("2d").fillText("hello",0,0),P=!0}catch(e){P=!1}function D(){if(!M){const{width:e,height:n}=k;P?M=new OffscreenCanvas(e,n):(M=document.createElement("canvas"),M.width=e,M.height=n)}return M}class R{constructor(e,n={}){if(!Array.isArray(e))return void console.error("colors is not array");if(e.length<2)return void console.error("colors.length should >1");this.colors=e;let t=1/0,r=-1/0;for(let n=0,o=e.length;n<o;n++){const o=e[n][0];t=Math.min(o,t),r=Math.max(o,r)}this.min=t,this.max=r,this.valueOffset=this.max-this.min,this.options=Object.assign({},k,n),this.T()}getImageData(){return this.imgData}T(){const e=D(),{width:n,height:t}=this.options;e.width=n,e.height=t;const r=e.getContext("2d");r.clearRect(0,0,e.width,e.height);const o=r.createLinearGradient(0,0,e.width,0),{colors:i,valueOffset:a}=this;for(let e=0,n=i.length;e<n;e++){const[n,t]=i[e],r=(n-this.min)/a;o.addColorStop(r,t)}r.fillStyle=o,r.fillRect(0,0,e.width,e.height),this.imgData=r.getImageData(0,0,e.width,e.height)}getColor(e){e=Math.max(this.min,e);const n=((e=Math.min(e,this.max))-this.min)/this.valueOffset;let t=Math.round(n*this.imgData.width);t=Math.min(t,this.imgData.width-1);const r=4*t;return[this.imgData.data[r],this.imgData.data[r+1],this.imgData.data[r+2],this.imgData.data[r+3]]}}let U=null,L=null;const F=[0,0,0],z=[256,256];function W(){try{U||(U=new OffscreenCanvas(1,1))}catch(e){console.error(e)}}const G={},V={},j={width:64,height:64,elementsPerHeight:3,heightOffset:-1e3,exaggeration:1,heightScale:.001,elementMultiplier:256,stride:4,skirtHeight:.002,skirtOffset:.01},X={cesium_request_token:{Accept:"application/json,*/*;q=0.01","Accept-Encoding":"gzip, deflate, br"},tianditu:{"Accept-Encoding":"gzip, deflate, br"},cesium:{"Accept-Encoding":"gzip, deflate, br",Accept:"application/vnd.quantized-mesh,application/octet-stream;q=0.9,*/*;q=0.01"},mapbox:{Accept:"image/webp,*/*"}};X["cesium-ion"]=X.cesium;const K=32767;let B=null,q=null;function Z(e,n){const t=function(e){if(e.length<1e3)return null;const n=new Zlib.Inflate(e);return n?n.decompress():null}(new Uint8Array(e));if(!t)throw new Error((r=new Uint8Array(e),Y.decode(r)));var r;const o=function(e){const n=e,t=j.width,r=j.height,o=new Uint8Array(t*r*j.stride);let i,a,s,c,f;for(let e=0;e<r;e++)for(let l=0;l<t;l++){c=parseInt(149*e/(r-1)),f=parseInt(149*l/(t-1)),a=2*(150*c+f),i=n[a]+256*n[a+1],(i>1e4||i<-2e3)&&(i=0),s=4*(e*t+l);const d=(i+1e3)/j.heightScale,h=j.elementMultiplier;o[s]=d/(h*h),o[s+1]=(d-o[s]*h*h)/h,o[s+2]=d-o[s]*h*h-o[s+1]*h,o[s+3]=255}return o}(t),i=function(e,n){const t=n,r=n,o=t+1,i=r+1,a=j.elementsPerHeight,s=j.heightOffset,c=j.heightScale,f=j.elementMultiplier,l=j.skirtHeight,d=new Float32Array(o*i);let h=0,v=1/0,u=-1/0;for(let n=0;n<o;n++){const o=n>=r?r-1:n;for(let n=0;n<i;n++){let r=0;const i=o*(4*t)+4*(n>=t?t-1:n);for(let n=0;n<a;n++)r=r*f+e[i+n];r=1*(r*c+s),r-=l,d[h]=r,r<v&&(v=r),r>u&&(u=r),h++}}return{data:d,min:v,max:u}}(o,n-1);return i.width=i.height=n,i}const Y=new TextDecoder("utf-8");function J(e){return e>>1^-(1&e)}const $=[];function Q(e){let n=0;const t=3*Float64Array.BYTES_PER_ELEMENT,r=3*Uint16Array.BYTES_PER_ELEMENT;let o=Uint16Array.BYTES_PER_ELEMENT;const i=new DataView(e);n+=t;const a=i.getFloat32(n,!0);n+=Float32Array.BYTES_PER_ELEMENT;const s=i.getFloat32(n,!0);n+=Float32Array.BYTES_PER_ELEMENT,n+=t;const c=i.getFloat64(n,!0);n+=Float64Array.BYTES_PER_ELEMENT,n+=t;const f=i.getUint32(n,!0);n+=Uint32Array.BYTES_PER_ELEMENT;const l=new Uint16Array(e,n,3*f);n+=f*r,f>65536&&(o=Uint32Array.BYTES_PER_ELEMENT);!function(e,n,t){const r=e.length;let o=0,i=0,a=0;for(let s=0;s<r;++s)o+=J(e[s]),i+=J(n[s]),e[s]=o,n[s]=i,t&&(a+=J(t[s]),t[s]=a)}(l.subarray(0,f),l.subarray(f,2*f),l.subarray(2*f,3*f)),n%o!=0&&(n+=o-n%o);const d=i.getUint32(n,!0);n+=Uint32Array.BYTES_PER_ELEMENT;const h=f>65536?new Uint32Array(e,n,3*d):new Uint16Array(e,n,3*d);let v=0;const u=h.length;for(let e=0;e<u;++e){const n=h[e];h[e]=v-n,0===n&&++v}const _={minimumHeight:a,maximumHeight:s,quantizedVertices:l,indices:h}.quantizedVertices,m=_.length/3,g=_.subarray(0,m),x=_.subarray(m,2*m),p=_.subarray(2*m,3*m),A=$;for(let e=0;e<m;++e){const n=g[e],t=x[e],r=n/K,o=t/K,i=(y=a,b=s,(1-(w=p[e]/K))*y+w*b);A[3*e]=r,A[3*e+1]=1-o,A[3*e+2]=i}var y,b,w;return{positions:A,radius:c,min:a,max:s,indices:h}}const ee=[],ne=[],te=[],re=[],oe=[];class ie{constructor(e,n,t,r,o){this.p0=[],this.p1=[],this.p2=[],this.normal=[],this.min=[],this.max=[],this.set(e,n,t,r,o)}set(e,n,t,r,o){this.radius=o;let i=3*n,a=3*n+1,s=3*n+2;this.p0[0]=e[i]*o,this.p0[1]=e[a]*o,this.p0[2]=e[s],i=3*t,a=3*t+1,s=3*t+2,this.p1[0]=e[i]*o,this.p1[1]=e[a]*o,this.p1[2]=e[s],i=3*r,a=3*r+1,s=3*r+2,this.p2[0]=e[i]*o,this.p2[1]=e[a]*o,this.p2[2]=e[s],this.min[0]=Math.min(this.p0[0],this.p1[0],this.p2[0]),this.min[1]=Math.min(this.p0[1],this.p1[1],this.p2[1]),this.max[0]=Math.max(this.p0[0],this.p1[0],this.p2[0]),this.max[1]=Math.max(this.p0[1],this.p1[1],this.p2[1]);const c=_(ee,this.p1,this.p0),f=_(ne,this.p2,this.p1);this.normal=v(this.normal,u(this.normal,c,f))}contains(e,n){if(e<this.min[0]||e>this.max[0]||n<this.min[1]||n>this.max[1])return!1;x(te,this.p0[0],this.p0[1]),x(re,this.p1[0],this.p1[1]),x(oe,this.p2[0],this.p2[1]);const t=fe(te[0],te[1],re[0],re[1],oe[0],oe[1]);return fe(e,n,te[0],te[1],oe[0],oe[1])+fe(e,n,te[0],te[1],re[0],re[1])+fe(e,n,re[0],re[1],oe[0],oe[1])-t<=1e-4}getHeight(e,n){const t=this.normal;return this.p0[2]-((e-this.p0[0])*t[0]+(n-this.p0[1])*t[1])/t[2]}}let ae=null;function se(e,n,t){if(ae&&ae.contains(n,t))return ae.getHeight(n,t);for(let r=0;r<e.length;r++)if(e[r].contains(n,t))return ae=e[r],e[r].getHeight(n,t);return 0}const ce=[];function fe(e,n,t,r,o,i){return.5*Math.abs(e*r+t*i+o*n-e*i-t*n-o*r)}function le(e,n,t,r,o,i){"cesium-ion"===t&&(n.Authorization="Bearer "+B),function(e,n,t){const r={method:"GET",referrer:t,headers:n},o=c.getArrayBuffer(e,r),i=o.xhr;return V[e]=i,o.then((n=>(delete V[e],n)))}(e,n,origin).then((e=>{if(!e||e.message)i(e?{empty:!0,originalError:e}:{error:{canceled:!0}});else{const n=e.data;let a=null;if("tianditu"===t){const e=Z(n,r);he(o,e,r,null,!0,i)}else if("cesium-ion"===t||"cesium"===t){a=Q(n);const e=function(e,n){const{positions:t,min:r,max:o,indices:i,radius:a}=e,s=[];let c=0;for(let e=0;e<i.length;e+=3){let n=ce[c];n?n.set(t,i[e],i[e+1],i[e+2],2*a):n=ce[c]=new ie(t,i[e],i[e+1],i[e+2],2*a),c++,s.push(n)}const f=new Float32Array(n*n);c=0;for(let e=0;e<n;e++)for(let t=0;t<n;t++)f[c++]=se(s,t/n*a*2,e/n*a*2);return{data:f,min:r,max:o,width:n,height:n}}(a,r);he(o,e,r,null,!0,i)}else"mapbox"===t&&(a=function(e){const n=new self.Blob([new Uint8Array(e)]);return self.createImageBitmap(n)}(n),a.then((e=>{const n=function(e){const{width:n,height:t}=e;U||(U=new OffscreenCanvas(1,1),L=U.getContext("2d",{willReadFrequently:!0}));return U.width=n,U.height=t,L.drawImage(e,0,0,n,t),L.getImageData(0,0,n,t)}(e),t=function(e,n){const{data:t,width:r}=e;let o=1/0,i=-1/0;const a=new Float32Array(n*n),s=Math.round(r/n);for(let e=0;e<n;e++)for(let c=0;c<n;c++){const f=e+c*n;let l=0,d=0;const h=e,v=c;for(let e=0;e<s;e++)for(let n=0;n<s;n++){let o=h*s+e,i=v*s+n;i>r-1&&(i=r-1),o>r-1&&(o=r-1);const a=o+i*r,c=t[4*a],f=t[4*a+1],u=t[4*a+2];0===t[4*a+3]?d+=1:l+=.1*(256*c*256+256*f+u)-1e4}l/=s*s-d||1,l>i&&(i=l),l<o&&(o=l),a[f]=l}return{data:a,width:n,height:n,min:o,max:i}}(n,r);he(o,t,r,e,!0,i)})))}})).catch((n=>{delete V[e],i({empty:!0,originalError:n})}))}function de(e,n){const t=Math.floor(10*(e+1e4)),r=t>>16,o=t>>8&255,i=255&t;return n?(n[0]=r,n[1]=o,n[2]=i,n):[r,o,i]}function he(e,n,t,r,o,i){const a=function(e,n,t,r){let o=H[t];o||(o=H[t]=new S(t));const i=o.createTile(n).getMeshWithSkirts(e,!0),{triangles:a,vertices:s,leftSkirtIndex:c,rightSkirtIndex:f,bottomSkirtIndex:l,topSkirtIndex:d}=i;let{numVerticesWithoutSkirts:h,numTrianglesWithoutSkirts:v}=i;h||(h=s.legnth/3,v=a.length/3);const u=s.length/2,_=new Float32Array(3*u),m=new Float32Array(2*u);let g=1/0,x=-1/0;const p=t-1;for(let e=0;e<u;e++){const r=s[2*e],o=s[2*e+1];if(e>=h){const n=r/2*3;let t,o=.001;(e-(e<c/2?h:e<f/2?c/2:e<l/2?f/2:l/2))%3==0?(t=0,o=0):t=_[n+2],_[3*e]=_[n],_[3*e+1]=_[n+1],_[3*e+2]=t,m[2*e]=_[n]/p+o,m[2*e+1]=-_[n+1]/p+o}else _[3*e]=1*r,_[3*e+1]=1*-o,_[3*e+2]=n[o*t+r],m[2*e]=r/p,m[2*e+1]=o/p;const i=_[_.length-1];i<g&&(g=i),i>x&&(x=i)}return{positions:_,texcoords:m,triangles:a,leftSkirtIndex:c,rightSkirtIndex:f,bottomSkirtIndex:l,topSkirtIndex:d,numTrianglesWithoutSkirts:v,numVerticesWithoutSkirts:h,minHeight:g,maxHeight:x,terrainWidth:t}}(e,n.data,t),s=[a.positions.buffer,a.texcoords.buffer,a.triangles.buffer];r||(r=function(e){if(W(),!U)return;const{width:n,height:t,data:r}=e;if(n&&t&&r)try{let e=U.getContext("2d",{willReadFrequently:!0});const o=e.createImageData(n,t);for(let e=0,n=r.length;e<n;e++){const n=r[e],[t,i,a]=de(n,F),s=4*e;o.data[s]=t,o.data[s+1]=i,o.data[s+2]=a,o.data[s+3]=255}return U.width=n,U.height=t,e=U.getContext("2d",{willReadFrequently:!0}),ve(e),e.putImageData(o,0,0),U.transferToImageBitmap()}catch(e){console.log(e)}}(n)),r&&s.push(r);const c={mesh:a};c.image=r,c.data=n,s.push(n.data.buffer),i(c,s)}function ve(e){const n=e.canvas,{width:t,height:r}=n;e.clearRect(0,0,t,r)}function ue(e,n,t){if(!n||!Array.isArray(n)||n.length<2)return;if(!e||!e.image)return null;let{width:r,height:o}=e.image;(t=t||z)[0]===r&&t[1]===o||(r=t[0],o=t[1]),r*=2,o*=2;try{if(W(),!U)return;const t=U;t.width=r,t.height=o;const i=t.getContext("2d",{willReadFrequently:!0});ve(i),i.drawImage(e.image,0,0,r,o);const a=i.getImageData(0,0,r,o);return function(e,n){const t=JSON.stringify(n);G[t]||(G[t]=new R(n));const r=G[t],o=e.data;for(let e=0,n=o.length;e<n;e+=4){const n=o[e],t=o[e+1],i=o[e+2];let a=0;0!==o[e+3]&&(a=.1*(256*n*256+256*t+i)-1e4,a=Math.max(a,0));const[s,c,f]=r.getColor(a);o[e]=s,o[e+1]=c,o[e+2]=f,o[e+3]=255}}(a,n),new Uint8Array(a.data)}catch(e){console.error(e)}}e.initialize=function(){},e.onmessage=function(e,n){const t=e.data;if("addLayer"===t.command||"removeLayer"===t.command)N=e.workerId,self.postMessage({type:"<response>",actorId:t.actorId,workerId:N,params:"ok",callback:e.callback});else if("fetchTerrain"===t.command){const e=(t.params||{}).colors,r=(t.params||{}).tileSize;!function(e,n){const{url:t,origin:r,type:o,accessToken:i,terrainWidth:a,error:s}=e,c=e.headers||X[o];if("tianditu"===o)le(t,c,o,a,s,n);else if("cesium-ion"===o){const f=e.cesiumIonTokenURL+i;B?le(t,c,o,a,s,n):(q||(q=fetch(f,{responseType:"json",method:"GET",referrer:r,headers:{Accept:"application/json,*/*;q=0.01","Accept-Encoding":"gzip, deflate, br"}}).then((e=>e.json())).then((e=>{B=e.accessToken,q=null}))),q.then((()=>{le(t,c,o,a,s,n)})))}else("cesium"===o||"mapbox"===o)&&le(t,c,o,a,s,n)}(t.params,((t,o)=>{const i=ue(t,e,r);i&&(t.colorsTexture=i,(o=o||[]).push(i.buffer)),n(t.error,t,o)}))}else"abortTerrain"===t.command&&(r=t.params.url,V[r]&&(V[r].abort(),delete V[r]));var r}}`;
registerGLTFLoaderBundle(gltfLoaderExport);
$gP1US.registerWorkerAdapter('@maptalks/terrain', code);
typeof console !== 'undefined' && console.log('@maptalks/gl v0.107.0');

});
parcelRegister("9I15V", function(module, exports) {
(function(U, W) {
    module.exports = W();
})(module.exports, function() {
    function U(a, b) {
        this.id = Cb++;
        this.type = a;
        this.data = b;
    }
    function W(a) {
        if (0 === a.length) return [];
        var b = a.charAt(0), c = a.charAt(a.length - 1);
        if (1 < a.length && b === c && ('"' === b || "'" === b)) return [
            '"' + a.substr(1, a.length - 2).replace(/\\/g, "\\\\").replace(/"/g, '\\"') + '"'
        ];
        if (b = /\[(false|true|null|\d+|'[^']*'|"[^"]*")\]/.exec(a)) return W(a.substr(0, b.index)).concat(W(b[1])).concat(W(a.substr(b.index + b[0].length)));
        b = a.split(".");
        if (1 === b.length) return [
            '"' + a.replace(/\\/g, "\\\\").replace(/"/g, '\\"') + '"'
        ];
        a = [];
        for(c = 0; c < b.length; ++c)a = a.concat(W(b[c]));
        return a;
    }
    function ab(a) {
        return "[" + W(a).join("][") + "]";
    }
    function bb(a, b) {
        if ("function" === typeof a) return new U(0, a);
        if ("number" === typeof a || "boolean" === typeof a) return new U(5, a);
        if (Array.isArray(a)) return new U(6, a.map(function(a, e) {
            return bb(a, b + "[" + e + "]");
        }));
        if (a instanceof U) return a;
    }
    function Db() {
        var a = {
            "": 0
        }, b = [
            ""
        ];
        return {
            id: function(c) {
                var e = a[c];
                if (e) return e;
                e = a[c] = b.length;
                b.push(c);
                return e;
            },
            str: function(a) {
                return b[a];
            }
        };
    }
    function Eb(a, b, c) {
        function e() {
            var b = window.innerWidth, e = window.innerHeight;
            a !== document.body && (e = a.getBoundingClientRect(), b = e.right - e.left, e = e.bottom - e.top);
            f.width = c * b;
            f.height = c * e;
            F(f.style, {
                width: b + "px",
                height: e + "px"
            });
        }
        var f = document.createElement("canvas");
        F(f.style, {
            border: 0,
            margin: 0,
            padding: 0,
            top: 0,
            left: 0
        });
        a.appendChild(f);
        a === document.body && (f.style.position = "absolute", F(a.style, {
            margin: 0,
            padding: 0
        }));
        var d;
        a !== document.body && "function" === typeof ResizeObserver ? (d = new ResizeObserver(function() {
            setTimeout(e);
        }), d.observe(a)) : window.addEventListener("resize", e, !1);
        e();
        return {
            canvas: f,
            onDestroy: function() {
                d ? d.disconnect() : window.removeEventListener("resize", e);
                a.removeChild(f);
            }
        };
    }
    function Fb(a, b) {
        function c(c) {
            try {
                return a.getContext(c, b);
            } catch (f) {
                return null;
            }
        }
        return c("webgl") || c("experimental-webgl") || c("webgl-experimental");
    }
    function cb(a) {
        return "string" === typeof a ? a.split() : a;
    }
    function db(a) {
        return "string" === typeof a ? document.querySelector(a) : a;
    }
    function Gb(a) {
        var b = a || {}, c, e, f, d;
        a = {};
        var p = [], r = [], v = "undefined" === typeof window ? 1 : window.devicePixelRatio, m = !1, u = function(a) {}, n = function() {};
        "string" === typeof b ? c = document.querySelector(b) : "object" === typeof b && ("string" === typeof b.nodeName && "function" === typeof b.appendChild && "function" === typeof b.getBoundingClientRect ? c = b : "function" === typeof b.drawArrays || "function" === typeof b.drawElements ? (d = b, f = d.canvas) : ("gl" in b ? d = b.gl : "canvas" in b ? f = db(b.canvas) : "container" in b && (e = db(b.container)), "attributes" in b && (a = b.attributes), "extensions" in b && (p = cb(b.extensions)), "optionalExtensions" in b && (r = cb(b.optionalExtensions)), "onDone" in b && (u = b.onDone), "profile" in b && (m = !!b.profile), "pixelRatio" in b && (v = +b.pixelRatio)));
        c && ("canvas" === c.nodeName.toLowerCase() ? f = c : e = c);
        if (!d) {
            if (!f) {
                c = Eb(e || document.body, u, v);
                if (!c) return null;
                f = c.canvas;
                n = c.onDestroy;
            }
            void 0 === a.premultipliedAlpha && (a.premultipliedAlpha = !0);
            d = Fb(f, a);
        }
        return d ? {
            gl: d,
            canvas: f,
            container: e,
            extensions: p,
            optionalExtensions: r,
            pixelRatio: v,
            profile: m,
            onDone: u,
            onDestroy: n
        } : (n(), u("webgl not supported, try upgrading your browser or graphics drivers http://get.webgl.org"), null);
    }
    function Hb(a, b) {
        function c(b) {
            b = b.toLowerCase();
            var c;
            try {
                c = e[b] = a.getExtension(b);
            } catch (f) {}
            return !!c;
        }
        for(var e = {}, f = 0; f < b.extensions.length; ++f){
            var d = b.extensions[f];
            if (!c(d)) return b.onDestroy(), b.onDone('"' + d + '" extension is not supported by the current WebGL context, try upgrading your system or a different browser'), null;
        }
        b.optionalExtensions.forEach(c);
        return {
            extensions: e,
            restore: function() {
                Object.keys(e).forEach(function(a) {
                    if (e[a] && !c(a)) throw Error("(regl): error restoring extension " + a);
                });
            }
        };
    }
    function J(a, b) {
        for(var c = Array(a), e = 0; e < a; ++e)c[e] = b(e);
        return c;
    }
    function eb(a) {
        var b, c;
        b = (65535 < a) << 4;
        a >>>= b;
        c = (255 < a) << 3;
        a >>>= c;
        b |= c;
        c = (15 < a) << 2;
        a >>>= c;
        b |= c;
        c = (3 < a) << 1;
        return b | c | a >>> c >> 1;
    }
    function fb() {
        function a(a) {
            a: {
                for(var b = 16; 268435456 >= b; b *= 16)if (a <= b) {
                    a = b;
                    break a;
                }
                a = 0;
            }
            b = c[eb(a) >> 2];
            return 0 < b.length ? b.pop() : new ArrayBuffer(a);
        }
        function b(a) {
            c[eb(a.byteLength) >> 2].push(a);
        }
        var c = J(8, function() {
            return [];
        });
        return {
            alloc: a,
            free: b,
            allocType: function(b, c) {
                var d = null;
                switch(b){
                    case 5120:
                        d = new Int8Array(a(c), 0, c);
                        break;
                    case 5121:
                        d = new Uint8Array(a(c), 0, c);
                        break;
                    case 5122:
                        d = new Int16Array(a(2 * c), 0, c);
                        break;
                    case 5123:
                        d = new Uint16Array(a(2 * c), 0, c);
                        break;
                    case 5124:
                        d = new Int32Array(a(4 * c), 0, c);
                        break;
                    case 5125:
                        d = new Uint32Array(a(4 * c), 0, c);
                        break;
                    case 5126:
                        d = new Float32Array(a(4 * c), 0, c);
                        break;
                    default:
                        return null;
                }
                return d.length !== c ? d.subarray(0, c) : d;
            },
            freeType: function(a) {
                b(a.buffer);
            }
        };
    }
    function aa(a) {
        return !!a && "object" === typeof a && Array.isArray(a.shape) && Array.isArray(a.stride) && "number" === typeof a.offset && a.shape.length === a.stride.length && (Array.isArray(a.data) || K(a.data));
    }
    function gb(a, b, c, e, f, d) {
        for(var p = 0; p < b; ++p)for(var r = a[p], v = 0; v < c; ++v)for(var m = r[v], u = 0; u < e; ++u)f[d++] = m[u];
    }
    function hb(a, b, c, e, f) {
        for(var d = 1, p = c + 1; p < b.length; ++p)d *= b[p];
        var r = b[c];
        if (4 === b.length - c) {
            var v = b[c + 1], m = b[c + 2];
            b = b[c + 3];
            for(p = 0; p < r; ++p)gb(a[p], v, m, b, e, f), f += d;
        } else for(p = 0; p < r; ++p)hb(a[p], b, c + 1, e, f), f += d;
    }
    function Fa(a) {
        return Ga[Object.prototype.toString.call(a)] | 0;
    }
    function ib(a, b) {
        for(var c = 0; c < b.length; ++c)a[c] = b[c];
    }
    function jb(a, b, c, e, f, d, p) {
        for(var r = 0, v = 0; v < c; ++v)for(var m = 0; m < e; ++m)a[r++] = b[f * v + d * m + p];
    }
    function Ib(a, b, c, e) {
        function f(b) {
            this.id = v++;
            this.buffer = a.createBuffer();
            this.type = b;
            this.usage = 35044;
            this.byteLength = 0;
            this.dimension = 1;
            this.dtype = 5121;
            this.persistentData = null;
            c.profile && (this.stats = {
                size: 0
            });
        }
        function d(b, c, q) {
            b.byteLength = c.byteLength;
            a.bufferData(b.type, c, q);
        }
        function p(a, b, c, g, k, h) {
            a.usage = c;
            if (Array.isArray(b)) {
                if (a.dtype = g || 5126, 0 < b.length) {
                    if (Array.isArray(b[0])) {
                        k = kb(b);
                        for(var l = g = 1; l < k.length; ++l)g *= k[l];
                        a.dimension = g;
                        b = Sa(b, k, a.dtype);
                        d(a, b, c);
                        h ? a.persistentData = b : D.freeType(b);
                    } else "number" === typeof b[0] ? (a.dimension = k, k = D.allocType(a.dtype, b.length), ib(k, b), d(a, k, c), h ? a.persistentData = k : D.freeType(k)) : K(b[0]) && (a.dimension = b[0].length, a.dtype = g || Fa(b[0]) || 5126, b = Sa(b, [
                        b.length,
                        b[0].length
                    ], a.dtype), d(a, b, c), h ? a.persistentData = b : D.freeType(b));
                }
            } else if (K(b)) a.dtype = g || Fa(b), a.dimension = k, d(a, b, c), h && (a.persistentData = new Uint8Array(new Uint8Array(b.buffer)));
            else if (aa(b)) {
                k = b.shape;
                var e = b.stride, l = b.offset, t = 0, ka = 0, f = 0, m = 0;
                1 === k.length ? (t = k[0], ka = 1, f = e[0], m = 0) : 2 === k.length && (t = k[0], ka = k[1], f = e[0], m = e[1]);
                a.dtype = g || Fa(b.data) || 5126;
                a.dimension = ka;
                k = D.allocType(a.dtype, t * ka);
                jb(k, b.data, t, ka, f, m, l);
                d(a, k, c);
                h ? a.persistentData = k : D.freeType(k);
            } else b instanceof ArrayBuffer && (a.dtype = 5121, a.dimension = k, d(a, b, c), h && (a.persistentData = new Uint8Array(new Uint8Array(b))));
        }
        function r(c) {
            b.bufferCount--;
            e(c);
            a.deleteBuffer(c.buffer);
            c.buffer = null;
            delete m[c.id];
        }
        var v = 0, m = {};
        f.prototype.bind = function() {
            a.bindBuffer(this.type, this.buffer);
        };
        f.prototype.destroy = function() {
            r(this);
        };
        var u = [];
        c.profile && (b.getTotalBufferSize = function() {
            var a = 0;
            Object.keys(m).forEach(function(b) {
                a += m[b].stats.size;
            });
            return a;
        });
        return {
            create: function(n, e, d, g) {
                function k(b) {
                    var n = 35044, t = null, e = 0, d = 0, f = h && h.dimension || 1;
                    Array.isArray(b) || K(b) || aa(b) || b instanceof ArrayBuffer ? t = b : "number" === typeof b ? e = b | 0 : b && ("data" in b && (t = b.data), "usage" in b && (n = lb[b.usage]), "type" in b && (d = Ha[b.type]), "dimension" in b && (f = b.dimension | 0), "length" in b && (e = b.length | 0));
                    h.bind();
                    t ? p(h, t, n, d, f, g) : (e && a.bufferData(h.type, e, n), h.dtype = d || 5121, h.usage = n, h.dimension = f, h.byteLength = e);
                    c.profile && (h.stats.size = h.byteLength * ha[h.dtype]);
                    return k;
                }
                b.bufferCount++;
                var h = new f(e);
                m[h.id] = h;
                d || k(n);
                k._reglType = "buffer";
                k._buffer = h;
                k.subdata = function(b, c) {
                    var t = (c || 0) | 0, n;
                    h.bind();
                    if (K(b) || b instanceof ArrayBuffer) a.bufferSubData(h.type, t, b);
                    else if (Array.isArray(b)) {
                        if (0 < b.length) {
                            if ("number" === typeof b[0]) {
                                var e = D.allocType(h.dtype, b.length);
                                ib(e, b);
                                a.bufferSubData(h.type, t, e);
                                D.freeType(e);
                            } else if (Array.isArray(b[0]) || K(b[0])) n = kb(b), e = Sa(b, n, h.dtype), a.bufferSubData(h.type, t, e), D.freeType(e);
                        }
                    } else if (aa(b)) {
                        n = b.shape;
                        var d = b.stride, g = e = 0, f = 0, E = 0;
                        1 === n.length ? (e = n[0], g = 1, f = d[0], E = 0) : 2 === n.length && (e = n[0], g = n[1], f = d[0], E = d[1]);
                        n = Array.isArray(b.data) ? h.dtype : Fa(b.data);
                        n = D.allocType(n, e * g);
                        jb(n, b.data, e, g, f, E, b.offset);
                        a.bufferSubData(h.type, t, n);
                        D.freeType(n);
                    }
                    return k;
                };
                c.profile && (k.stats = h.stats);
                k.destroy = function() {
                    r(h);
                };
                return k;
            },
            createStream: function(a, b) {
                var c = u.pop();
                c || (c = new f(a));
                c.bind();
                p(c, b, 35040, 0, 1, !1);
                return c;
            },
            destroyStream: function(a) {
                u.push(a);
            },
            clear: function() {
                S(m).forEach(r);
                u.forEach(r);
            },
            getBuffer: function(a) {
                return a && a._buffer instanceof f ? a._buffer : null;
            },
            restore: function() {
                S(m).forEach(function(b) {
                    b.buffer = a.createBuffer();
                    a.bindBuffer(b.type, b.buffer);
                    a.bufferData(b.type, b.persistentData || b.byteLength, b.usage);
                });
            },
            _initBuffer: p
        };
    }
    function Jb(a, b, c, e) {
        function f(a) {
            this.id = v++;
            r[this.id] = this;
            this.buffer = a;
            this.primType = 4;
            this.type = this.vertCount = 0;
        }
        function d(e, d, f, g, k, h, l) {
            e.buffer.bind();
            var m;
            d ? ((m = l) || K(d) && (!aa(d) || K(d.data)) || (m = b.oes_element_index_uint ? 5125 : 5123), c._initBuffer(e.buffer, d, f, m, 3)) : (a.bufferData(34963, h, f), e.buffer.dtype = m || 5121, e.buffer.usage = f, e.buffer.dimension = 3, e.buffer.byteLength = h);
            m = l;
            if (!l) {
                switch(e.buffer.dtype){
                    case 5121:
                    case 5120:
                        m = 5121;
                        break;
                    case 5123:
                    case 5122:
                        m = 5123;
                        break;
                    case 5125:
                    case 5124:
                        m = 5125;
                }
                e.buffer.dtype = m;
            }
            e.type = m;
            d = k;
            0 > d && (d = e.buffer.byteLength, 5123 === m ? d >>= 1 : 5125 === m && (d >>= 2));
            e.vertCount = d;
            d = g;
            0 > g && (d = 4, g = e.buffer.dimension, 1 === g && (d = 0), 2 === g && (d = 1), 3 === g && (d = 4));
            e.primType = d;
        }
        function p(a) {
            e.elementsCount--;
            delete r[a.id];
            a.buffer.destroy();
            a.buffer = null;
        }
        var r = {}, v = 0, m = {
            uint8: 5121,
            uint16: 5123
        };
        b.oes_element_index_uint && (m.uint32 = 5125);
        f.prototype.bind = function() {
            this.buffer.bind();
        };
        var u = [];
        return {
            create: function(a, b) {
                function q(a) {
                    if (a) {
                        if ("number" === typeof a) g(a), k.primType = 4, k.vertCount = a | 0, k.type = 5121;
                        else {
                            var b = null, c = 35044, e = -1, f = -1, n = 0, r = 0;
                            if (Array.isArray(a) || K(a) || aa(a)) b = a;
                            else if ("data" in a && (b = a.data), "usage" in a && (c = lb[a.usage]), "primitive" in a && (e = Ia[a.primitive]), "count" in a && (f = a.count | 0), "type" in a && (r = m[a.type]), "length" in a) n = a.length | 0;
                            else if (n = f, 5123 === r || 5122 === r) n *= 2;
                            else if (5125 === r || 5124 === r) n *= 4;
                            d(k, b, c, e, f, n, r);
                        }
                    } else g(), k.primType = 4, k.vertCount = 0, k.type = 5121;
                    return q;
                }
                var g = c.create(null, 34963, !0), k = new f(g._buffer);
                e.elementsCount++;
                q(a);
                q._reglType = "elements";
                q._elements = k;
                q.subdata = function(a, b) {
                    g.subdata(a, b);
                    return q;
                };
                q.destroy = function() {
                    p(k);
                };
                return q;
            },
            createStream: function(a) {
                var b = u.pop();
                b || (b = new f(c.create(null, 34963, !0, !1)._buffer));
                d(b, a, 35040, -1, -1, 0, 0);
                return b;
            },
            destroyStream: function(a) {
                u.push(a);
            },
            getElements: function(a) {
                return "function" === typeof a && a._elements instanceof f ? a._elements : null;
            },
            clear: function() {
                S(r).forEach(p);
            }
        };
    }
    function mb(a) {
        for(var b = D.allocType(5123, a.length), c = 0; c < a.length; ++c)if (isNaN(a[c])) b[c] = 65535;
        else if (Infinity === a[c]) b[c] = 31744;
        else if (-Infinity === a[c]) b[c] = 64512;
        else {
            nb[0] = a[c];
            var e = Kb[0], f = e >>> 31 << 15, d = (e << 1 >>> 24) - 127, e = e >> 13 & 1023;
            b[c] = -24 > d ? f : -14 > d ? f + (e + 1024 >> -14 - d) : 15 < d ? f + 31744 : f + (d + 15 << 10) + e;
        }
        return b;
    }
    function pa(a) {
        return Array.isArray(a) || K(a);
    }
    function qa(a) {
        return "[object " + a + "]";
    }
    function ob(a) {
        return Array.isArray(a) && (0 === a.length || "number" === typeof a[0]);
    }
    function pb(a) {
        return Array.isArray(a) && 0 !== a.length && pa(a[0]) ? !0 : !1;
    }
    function ia(a) {
        return Object.prototype.toString.call(a);
    }
    function Ta(a) {
        if (!a) return !1;
        var b = ia(a);
        return 0 <= Lb.indexOf(b) ? !0 : ob(a) || pb(a) || aa(a);
    }
    function qb(a, b) {
        36193 === a.type ? (a.data = mb(b), D.freeType(b)) : a.data = b;
    }
    function Ja(a, b, c, e, f, d) {
        a = "undefined" !== typeof H[a] ? H[a] : R[a] * ra[b];
        d && (a *= 6);
        if (f) {
            for(e = 0; 1 <= c;)e += a * c * c, c /= 2;
            return e;
        }
        return a * c * e;
    }
    function Mb(a, b, c, e, f, d, p) {
        function r() {
            this.format = this.internalformat = 6408;
            this.type = 5121;
            this.flipY = this.premultiplyAlpha = this.compressed = !1;
            this.unpackAlignment = 1;
            this.colorSpace = 37444;
            this.channels = this.height = this.width = 0;
        }
        function v(a, b) {
            a.internalformat = b.internalformat;
            a.format = b.format;
            a.type = b.type;
            a.compressed = b.compressed;
            a.premultiplyAlpha = b.premultiplyAlpha;
            a.flipY = b.flipY;
            a.unpackAlignment = b.unpackAlignment;
            a.colorSpace = b.colorSpace;
            a.width = b.width;
            a.height = b.height;
            a.channels = b.channels;
        }
        function m(a, b) {
            if ("object" === typeof b && b) {
                "premultiplyAlpha" in b && (a.premultiplyAlpha = b.premultiplyAlpha);
                "flipY" in b && (a.flipY = b.flipY);
                "alignment" in b && (a.unpackAlignment = b.alignment);
                "colorSpace" in b && (a.colorSpace = Nb[b.colorSpace]);
                "type" in b && (a.type = O[b.type]);
                var c = a.width, e = a.height, d = a.channels, k = !1;
                "shape" in b ? (c = b.shape[0], e = b.shape[1], 3 === b.shape.length && (d = b.shape[2], k = !0)) : ("radius" in b && (c = e = b.radius), "width" in b && (c = b.width), "height" in b && (e = b.height), "channels" in b && (d = b.channels, k = !0));
                a.width = c | 0;
                a.height = e | 0;
                a.channels = d | 0;
                c = !1;
                "format" in b && (c = b.format, e = a.internalformat = G[c], a.format = x[e], c in O && !("type" in b) && (a.type = O[c]), c in fa && (a.compressed = !0), c = !0);
                !k && c ? a.channels = R[a.format] : k && !c && a.channels !== Ma[a.format] && (a.format = a.internalformat = Ma[a.channels]);
            }
        }
        function u(b) {
            a.pixelStorei(37440, b.flipY);
            a.pixelStorei(37441, b.premultiplyAlpha);
            a.pixelStorei(37443, b.colorSpace);
            a.pixelStorei(3317, b.unpackAlignment);
        }
        function n() {
            r.call(this);
            this.yOffset = this.xOffset = 0;
            this.data = null;
            this.needsFree = !1;
            this.element = null;
            this.needsCopy = !1;
        }
        function z(a, b) {
            var c = null;
            Ta(b) ? c = b : b && (m(a, b), "x" in b && (a.xOffset = b.x | 0), "y" in b && (a.yOffset = b.y | 0), Ta(b.data) && (c = b.data));
            if (b.copy) {
                var e = f.viewportWidth, d = f.viewportHeight;
                a.width = a.width || e - a.xOffset;
                a.height = a.height || d - a.yOffset;
                a.needsCopy = !0;
            } else if (!c) a.width = a.width || 1, a.height = a.height || 1, a.channels = a.channels || 4;
            else if (K(c)) a.channels = a.channels || 4, a.data = c, "type" in b || 5121 !== a.type || (a.type = Ga[Object.prototype.toString.call(c)] | 0);
            else if (ob(c)) {
                a.channels = a.channels || 4;
                e = c;
                d = e.length;
                switch(a.type){
                    case 5121:
                    case 5123:
                    case 5125:
                    case 5126:
                        d = D.allocType(a.type, d);
                        d.set(e);
                        a.data = d;
                        break;
                    case 36193:
                        a.data = mb(e);
                }
                a.alignment = 1;
                a.needsFree = !0;
            } else if (aa(c)) {
                e = c.data;
                Array.isArray(e) || 5121 !== a.type || (a.type = Ga[Object.prototype.toString.call(e)] | 0);
                var d = c.shape, k = c.stride, t, E, g, l;
                3 === d.length ? (g = d[2], l = k[2]) : l = g = 1;
                t = d[0];
                E = d[1];
                d = k[0];
                k = k[1];
                a.alignment = 1;
                a.width = t;
                a.height = E;
                a.channels = g;
                a.format = a.internalformat = Ma[g];
                a.needsFree = !0;
                t = l;
                c = c.offset;
                g = a.width;
                l = a.height;
                E = a.channels;
                for(var w = D.allocType(36193 === a.type ? 5126 : a.type, g * l * E), L = 0, ca = 0; ca < l; ++ca)for(var xa = 0; xa < g; ++xa)for(var Ua = 0; Ua < E; ++Ua)w[L++] = e[d * xa + k * ca + t * Ua + c];
                qb(a, w);
            } else if (ia(c) === Va || ia(c) === Wa || ia(c) === sb) ia(c) === Va || ia(c) === Wa ? a.element = c : a.element = c.canvas, a.width = a.element.width, a.height = a.element.height, a.channels = 4;
            else if (ia(c) === tb) a.element = c, a.width = c.width, a.height = c.height, a.channels = 4;
            else if (ia(c) === ub) a.element = c, a.width = c.naturalWidth, a.height = c.naturalHeight, a.channels = 4;
            else if (ia(c) === vb) a.element = c, a.width = c.videoWidth, a.height = c.videoHeight, a.channels = 4;
            else if (pb(c)) {
                e = a.width || c[0].length;
                d = a.height || c.length;
                k = a.channels;
                k = pa(c[0][0]) ? k || c[0][0].length : k || 1;
                t = Oa.shape(c);
                g = 1;
                for(l = 0; l < t.length; ++l)g *= t[l];
                g = D.allocType(36193 === a.type ? 5126 : a.type, g);
                Oa.flatten(c, t, "", g);
                qb(a, g);
                a.alignment = 1;
                a.width = e;
                a.height = d;
                a.channels = k;
                a.format = a.internalformat = Ma[k];
                a.needsFree = !0;
            }
        }
        function q(b, c, d, k, g) {
            var t = b.element, l = b.data, E = b.internalformat, f = b.format, m = b.type, w = b.width, L = b.height;
            u(b);
            t ? a.texSubImage2D(c, g, d, k, f, m, t) : b.compressed ? a.compressedTexSubImage2D(c, g, d, k, E, w, L, l) : b.needsCopy ? (e(), a.copyTexSubImage2D(c, g, d, k, b.xOffset, b.yOffset, w, L)) : a.texSubImage2D(c, g, d, k, w, L, f, m, l);
        }
        function g() {
            return wb.pop() || new n;
        }
        function k(a) {
            a.needsFree && D.freeType(a.data);
            n.call(a);
            wb.push(a);
        }
        function h() {
            r.call(this);
            this.genMipmaps = !1;
            this.mipmapHint = 4352;
            this.mipmask = 0;
            this.images = Array(16);
        }
        function l(a, b, c) {
            var e = a.images[0] = g();
            a.mipmask = 1;
            e.width = a.width = b;
            e.height = a.height = c;
            e.channels = a.channels = 4;
        }
        function A(a, b) {
            var c = null;
            if (Ta(b)) c = a.images[0] = g(), v(c, a), z(c, b), a.mipmask = 1;
            else if (m(a, b), Array.isArray(b.mipmap)) for(var e = b.mipmap, d = 0; d < e.length; ++d)c = a.images[d] = g(), v(c, a), c.width >>= d, c.height >>= d, z(c, e[d]), a.mipmask |= 1 << d;
            else c = a.images[0] = g(), v(c, a), z(c, b), a.mipmask = 1;
            v(a, a.images[0]);
        }
        function t(b, c) {
            for(var d = b.images, k = 0; k < d.length && d[k]; ++k){
                var g = d[k], t = c, l = k, E = g.element, f = g.data, m = g.internalformat, w = g.format, L = g.type, ca = g.width, xa = g.height;
                u(g);
                E ? a.texImage2D(t, l, w, w, L, E) : g.compressed ? a.compressedTexImage2D(t, l, m, Math.max(1, ca), Math.max(1, xa), 0, f) : g.needsCopy ? (e(), a.copyTexImage2D(t, l, w, g.xOffset, g.yOffset, ca, xa, 0)) : a.texImage2D(t, l, w, ca, xa, 0, w, L, f || null);
            }
        }
        function ka() {
            var a = J.pop() || new h;
            r.call(a);
            for(var b = a.mipmask = 0; 16 > b; ++b)a.images[b] = null;
            return a;
        }
        function wa(a) {
            for(var b = a.images, c = 0; c < b.length; ++c)b[c] && k(b[c]), b[c] = null;
            J.push(a);
        }
        function B() {
            this.magFilter = this.minFilter = 9728;
            this.wrapT = this.wrapS = 33071;
            this.anisotropic = 1;
            this.genMipmaps = !1;
            this.mipmapHint = 4352;
        }
        function C(a, b) {
            "min" in b && (a.minFilter = ya[b.min], 0 <= Ob.indexOf(a.minFilter) && !("faces" in b) && (a.genMipmaps = !0));
            "mag" in b && (a.magFilter = Q[b.mag]);
            var c = a.wrapS, d = a.wrapT;
            if ("wrap" in b) {
                var e = b.wrap;
                "string" === typeof e ? c = d = ga[e] : Array.isArray(e) && (c = ga[e[0]], d = ga[e[1]]);
            } else "wrapS" in b && (c = ga[b.wrapS]), "wrapT" in b && (d = ga[b.wrapT]);
            a.wrapS = c;
            a.wrapT = d;
            "anisotropic" in b && (a.anisotropic = b.anisotropic);
            if ("mipmap" in b) {
                c = !1;
                switch(typeof b.mipmap){
                    case "string":
                        a.mipmapHint = Pb[b.mipmap];
                        c = a.genMipmaps = !0;
                        break;
                    case "boolean":
                        c = a.genMipmaps = b.mipmap;
                        break;
                    case "object":
                        a.genMipmaps = !1, c = !0;
                }
                !c || "min" in b || (a.minFilter = 9984);
            }
        }
        function N(c, d) {
            a.texParameteri(d, 10241, c.minFilter);
            a.texParameteri(d, 10240, c.magFilter);
            a.texParameteri(d, 10242, c.wrapS);
            a.texParameteri(d, 10243, c.wrapT);
            b.ext_texture_filter_anisotropic && a.texParameteri(d, 34046, c.anisotropic);
            c.genMipmaps && (a.hint(33170, c.mipmapHint), a.generateMipmap(d));
        }
        function E(b) {
            r.call(this);
            this.mipmask = 0;
            this.internalformat = 6408;
            this.id = Z++;
            this.refCount = 1;
            this.target = b;
            this.texture = a.createTexture();
            this.unit = -1;
            this.bindCount = 0;
            this.texInfo = new B;
            p.profile && (this.stats = {
                size: 0
            });
        }
        function X(b) {
            a.activeTexture(33984);
            a.bindTexture(b.target, b.texture);
        }
        function la() {
            var b = T[0];
            b ? a.bindTexture(b.target, b.texture) : a.bindTexture(3553, null);
        }
        function y(b) {
            var c = b.texture, e = b.unit, k = b.target;
            0 <= e && (a.activeTexture(33984 + e), a.bindTexture(k, null), T[e] = null);
            a.deleteTexture(c);
            b.texture = null;
            b.params = null;
            b.pixels = null;
            b.refCount = 0;
            delete da[b.id];
            d.textureCount--;
        }
        var Pb = {
            "don't care": 4352,
            "dont care": 4352,
            nice: 4354,
            fast: 4353
        }, ga = {
            repeat: 10497,
            clamp: 33071,
            mirror: 33648
        }, Q = {
            nearest: 9728,
            linear: 9729
        }, ya = F({
            mipmap: 9987,
            "nearest mipmap nearest": 9984,
            "linear mipmap nearest": 9985,
            "nearest mipmap linear": 9986,
            "linear mipmap linear": 9987
        }, Q), Nb = {
            none: 0,
            browser: 37444
        }, O = {
            uint8: 5121,
            rgba4: 32819,
            rgb565: 33635,
            "rgb5 a1": 32820
        }, G = {
            alpha: 6406,
            luminance: 6409,
            "luminance alpha": 6410,
            rgb: 6407,
            rgba: 6408,
            rgba4: 32854,
            "rgb5 a1": 32855,
            rgb565: 36194
        }, fa = {};
        b.ext_srgb && (G.srgb = 35904, G.srgba = 35906);
        b.oes_texture_float && (O.float32 = O["float"] = 5126);
        b.oes_texture_half_float && (O.float16 = O["half float"] = 36193);
        b.webgl_depth_texture && (F(G, {
            depth: 6402,
            "depth stencil": 34041
        }), F(O, {
            uint16: 5123,
            uint32: 5125,
            "depth stencil": 34042
        }));
        b.webgl_compressed_texture_s3tc && F(fa, {
            "rgb s3tc dxt1": 33776,
            "rgba s3tc dxt1": 33777,
            "rgba s3tc dxt3": 33778,
            "rgba s3tc dxt5": 33779
        });
        b.webgl_compressed_texture_atc && F(fa, {
            "rgb atc": 35986,
            "rgba atc explicit alpha": 35987,
            "rgba atc interpolated alpha": 34798
        });
        b.webgl_compressed_texture_pvrtc && F(fa, {
            "rgb pvrtc 4bppv1": 35840,
            "rgb pvrtc 2bppv1": 35841,
            "rgba pvrtc 4bppv1": 35842,
            "rgba pvrtc 2bppv1": 35843
        });
        b.webgl_compressed_texture_etc1 && (fa["rgb etc1"] = 36196);
        var I = Array.prototype.slice.call(a.getParameter(34467));
        Object.keys(fa).forEach(function(a) {
            var b = fa[a];
            0 <= I.indexOf(b) && (G[a] = b);
        });
        var H = Object.keys(G);
        c.textureFormats = H;
        var ba = [];
        Object.keys(G).forEach(function(a) {
            ba[G[a]] = a;
        });
        var M = [];
        Object.keys(O).forEach(function(a) {
            M[O[a]] = a;
        });
        var Da = [];
        Object.keys(Q).forEach(function(a) {
            Da[Q[a]] = a;
        });
        var ma = [];
        Object.keys(ya).forEach(function(a) {
            ma[ya[a]] = a;
        });
        var na = [];
        Object.keys(ga).forEach(function(a) {
            na[ga[a]] = a;
        });
        var x = H.reduce(function(a, c) {
            var d = G[c];
            6409 === d || 6406 === d || 6409 === d || 6410 === d || 6402 === d || 34041 === d || b.ext_srgb && (35904 === d || 35906 === d) ? a[d] = d : 32855 === d || 0 <= c.indexOf("rgba") ? a[d] = 6408 : a[d] = 6407;
            return a;
        }, {}), wb = [], J = [], Z = 0, da = {}, ea = c.maxTextureUnits, T = Array(ea).map(function() {
            return null;
        });
        F(E.prototype, {
            bind: function() {
                this.bindCount += 1;
                var b = this.unit;
                if (0 > b) {
                    for(var c = 0; c < ea; ++c){
                        var e = T[c];
                        if (e) {
                            if (0 < e.bindCount) continue;
                            e.unit = -1;
                        }
                        T[c] = this;
                        b = c;
                        break;
                    }
                    p.profile && d.maxTextureUnits < b + 1 && (d.maxTextureUnits = b + 1);
                    this.unit = b;
                    a.activeTexture(33984 + b);
                    a.bindTexture(this.target, this.texture);
                }
                return b;
            },
            unbind: function() {
                --this.bindCount;
            },
            decRef: function() {
                0 >= --this.refCount && y(this);
            }
        });
        p.profile && (d.getTotalTextureSize = function() {
            var a = 0;
            Object.keys(da).forEach(function(b) {
                a += da[b].stats.size;
            });
            return a;
        });
        return {
            create2D: function(b, c) {
                function e(b, c) {
                    var d = f.texInfo;
                    B.call(d);
                    d.version = a instanceof WebGL2RenderingContext ? 2 : 1;
                    var k = ka();
                    "number" === typeof b ? "number" === typeof c ? l(k, b | 0, c | 0) : l(k, b | 0, b | 0) : b ? (C(d, b), A(k, b)) : l(k, 1, 1);
                    d.genMipmaps && (k.mipmask = (Math.max(k.width, k.height) << 1) - 1);
                    f.mipmask = k.mipmask;
                    v(f, k);
                    f.internalformat = k.internalformat;
                    e.width = k.width;
                    e.height = k.height;
                    X(f);
                    t(k, 3553);
                    N(d, 3553);
                    la();
                    wa(k);
                    p.profile && (f.stats.size = Ja(f.internalformat, f.type, k.width, k.height, d.genMipmaps, !1));
                    e.format = ba[f.internalformat];
                    e.type = M[f.type];
                    e.mag = Da[d.magFilter];
                    e.min = ma[d.minFilter];
                    e.wrapS = na[d.wrapS];
                    e.wrapT = na[d.wrapT];
                    return e;
                }
                var f = new E(3553);
                da[f.id] = f;
                d.textureCount++;
                e(b, c);
                e.subimage = function(a, b, c, d) {
                    b |= 0;
                    c |= 0;
                    d |= 0;
                    var t = g();
                    v(t, f);
                    t.width = 0;
                    t.height = 0;
                    z(t, a);
                    t.width = t.width || (f.width >> d) - b;
                    t.height = t.height || (f.height >> d) - c;
                    X(f);
                    q(t, 3553, b, c, d);
                    la();
                    k(t);
                    return e;
                };
                e.resize = function(b, c) {
                    var d = b | 0, k = c | 0 || d;
                    if (d === f.width && k === f.height) return e;
                    e.width = f.width = d;
                    e.height = f.height = k;
                    X(f);
                    for(var g = 0; f.mipmask >> g; ++g){
                        var t = d >> g, w = k >> g;
                        if (!t || !w) break;
                        a.texImage2D(3553, g, f.format, t, w, 0, f.format, f.type, null);
                    }
                    la();
                    p.profile && (f.stats.size = Ja(f.internalformat, f.type, d, k, !1, !1));
                    return e;
                };
                e.texParameteri = function(b, c) {
                    X(f);
                    var d = a.texParameteri(3553, b, c);
                    la();
                    return d;
                };
                e._reglType = "texture2d";
                e._texture = f;
                p.profile && (e.stats = f.stats);
                e.destroy = function() {
                    f.decRef();
                };
                return e;
            },
            createCube: function(b, c, e, f, n, r) {
                function h(a, b, c, d, e, k) {
                    var f, oa = y.texInfo;
                    B.call(oa);
                    for(f = 0; 6 > f; ++f)u[f] = ka();
                    if ("number" === typeof a || !a) for(a = a | 0 || 1, f = 0; 6 > f; ++f)l(u[f], a, a);
                    else if ("object" === typeof a) {
                        if (b) A(u[0], a), A(u[1], b), A(u[2], c), A(u[3], d), A(u[4], e), A(u[5], k);
                        else if (C(oa, a), m(y, a), "faces" in a) for(a = a.faces, f = 0; 6 > f; ++f)v(u[f], y), A(u[f], a[f]);
                        else for(f = 0; 6 > f; ++f)A(u[f], a);
                    }
                    v(y, u[0]);
                    y.mipmask = oa.genMipmaps ? (Math.max(u[0].width, u[0].height) << 1) - 1 : u[0].mipmask;
                    y.internalformat = u[0].internalformat;
                    h.width = u[0].width;
                    h.height = u[0].height;
                    X(y);
                    for(f = 0; 6 > f; ++f)t(u[f], 34069 + f);
                    N(oa, 34067);
                    la();
                    p.profile && (y.stats.size = Ja(y.internalformat, y.type, h.width, h.height, oa.genMipmaps, !0));
                    h.format = ba[y.internalformat];
                    h.type = M[y.type];
                    h.mag = Da[oa.magFilter];
                    h.min = ma[oa.minFilter];
                    h.wrapS = na[oa.wrapS];
                    h.wrapT = na[oa.wrapT];
                    for(f = 0; 6 > f; ++f)wa(u[f]);
                    return h;
                }
                var y = new E(34067);
                da[y.id] = y;
                d.cubeCount++;
                var u = Array(6);
                h(b, c, e, f, n, r);
                h.subimage = function(a, b, c, d, e) {
                    c |= 0;
                    d |= 0;
                    e |= 0;
                    var f = g();
                    v(f, y);
                    f.width = 0;
                    f.height = 0;
                    z(f, b);
                    f.width = f.width || (y.width >> e) - c;
                    f.height = f.height || (y.height >> e) - d;
                    X(y);
                    q(f, 34069 + a, c, d, e);
                    la();
                    k(f);
                    return h;
                };
                h.resize = function(b) {
                    b |= 0;
                    if (b !== y.width) {
                        h.width = y.width = b;
                        h.height = y.height = b;
                        X(y);
                        for(var c = 0; 6 > c; ++c)for(var d = 0; y.mipmask >> d; ++d)a.texImage2D(34069 + c, d, y.format, b >> d, b >> d, 0, y.format, y.type, null);
                        la();
                        p.profile && (y.stats.size = Ja(y.internalformat, y.type, h.width, h.height, !1, !0));
                        return h;
                    }
                };
                h._reglType = "textureCube";
                h._texture = y;
                p.profile && (h.stats = y.stats);
                h.destroy = function() {
                    y.decRef();
                };
                return h;
            },
            clear: function() {
                for(var b = 0; b < ea; ++b)a.activeTexture(33984 + b), a.bindTexture(3553, null), T[b] = null;
                S(da).forEach(y);
                d.cubeCount = 0;
                d.textureCount = 0;
            },
            getTexture: function(a) {
                return null;
            },
            restore: function() {
                for(var b = 0; b < ea; ++b){
                    var c = T[b];
                    c && (c.bindCount = 0, c.unit = -1, T[b] = null);
                }
                S(da).forEach(function(b) {
                    b.texture = a.createTexture();
                    a.bindTexture(b.target, b.texture);
                    for(var c = 0; 32 > c; ++c)if (0 !== (b.mipmask & 1 << c)) {
                        if (3553 === b.target) a.texImage2D(3553, c, b.internalformat, b.width >> c, b.height >> c, 0, b.internalformat, b.type, null);
                        else for(var d = 0; 6 > d; ++d)a.texImage2D(34069 + d, c, b.internalformat, b.width >> c, b.height >> c, 0, b.internalformat, b.type, null);
                    }
                    N(b.texInfo, b.target);
                });
            },
            refresh: function() {
                for(var b = 0; b < ea; ++b){
                    var c = T[b];
                    c && (c.bindCount = 0, c.unit = -1, T[b] = null);
                    a.activeTexture(33984 + b);
                    a.bindTexture(3553, null);
                    a.bindTexture(34067, null);
                }
            }
        };
    }
    function Qb(a, b, c, e, f, d) {
        function p(a, b, c) {
            this.target = a;
            this.texture = b;
            this.renderbuffer = c;
            var d = a = 0;
            b ? (a = b.width, d = b.height) : c && (a = c.width, d = c.height);
            this.width = a;
            this.height = d;
        }
        function r(a) {
            a && (a.texture && a.texture._texture.decRef(), a.renderbuffer && a.renderbuffer._renderbuffer.decRef());
        }
        function v(a, b, c) {
            a && (a.texture ? a.texture._texture.refCount += 1 : a.renderbuffer._renderbuffer.refCount += 1);
        }
        function m(b, c) {
            c && (c.texture ? a.framebufferTexture2D(36160, b, c.target, c.texture._texture.texture, 0) : a.framebufferRenderbuffer(36160, b, 36161, c.renderbuffer._renderbuffer.renderbuffer));
        }
        function u(a) {
            var b = 3553, c = null, d = null, e = a;
            "object" === typeof a && (e = a.data, "target" in a && (b = a.target | 0));
            a = e._reglType;
            "texture2d" === a ? c = e : "textureCube" === a ? c = e : "renderbuffer" === a && (d = e, b = 36161);
            return new p(b, c, d);
        }
        function n(a, b, c, d, k) {
            if (c) return a = e.create2D({
                width: a,
                height: b,
                format: d,
                type: k
            }), a._texture.refCount = 0, new p(3553, a, null);
            a = f.create({
                width: a,
                height: b,
                format: d
            });
            a._renderbuffer.refCount = 0;
            return new p(36161, null, a);
        }
        function z(a) {
            return a && (a.texture || a.renderbuffer);
        }
        function q(a, b, c) {
            a && (a.texture ? a.texture.resize(b, c) : a.renderbuffer && a.renderbuffer.resize(b, c), a.width = b, a.height = c);
        }
        function g() {
            this.id = C++;
            N[this.id] = this;
            this.framebuffer = a.createFramebuffer();
            this.height = this.width = 0;
            this.colorAttachments = [];
            this.depthStencilAttachment = this.stencilAttachment = this.depthAttachment = null;
        }
        function k(a) {
            a.colorAttachments.forEach(r);
            r(a.depthAttachment);
            r(a.stencilAttachment);
            r(a.depthStencilAttachment);
        }
        function h(b) {
            a.deleteFramebuffer(b.framebuffer);
            b.framebuffer = null;
            d.framebufferCount--;
            delete N[b.id];
        }
        function l(b, d) {
            var e;
            a.bindFramebuffer(36160, b.framebuffer);
            var f = b.colorAttachments;
            for(e = 0; e < f.length; ++e)m(36064 + e, f[e]);
            for(e = f.length; e < c.maxColorAttachments; ++e)a.framebufferTexture2D(36160, 36064 + e, 3553, null, 0);
            a.framebufferTexture2D(36160, 33306, 3553, null, 0);
            a.framebufferTexture2D(36160, 36096, 3553, null, 0);
            a.framebufferTexture2D(36160, 36128, 3553, null, 0);
            m(36096, b.depthAttachment);
            m(36128, b.stencilAttachment);
            m(33306, b.depthStencilAttachment);
            d || (a.checkFramebufferStatus(36160), a.isContextLost());
            a.bindFramebuffer(36160, t.next ? t.next.framebuffer : null);
            t.cur = t.next;
            d || a.getError();
        }
        function A(b, c) {
            function e(a, b) {
                var c, d = 0, g = 0, t = !0, h = !0;
                c = null;
                var m = !0, q = "rgba", r = "uint8", p = 1, A = null, E = null, ma = null, N = !1;
                if ("number" === typeof a) d = a | 0, g = b | 0 || d;
                else if (a) {
                    var x = a;
                    "shape" in x ? (g = x.shape, d = g[0], g = g[1]) : ("radius" in x && (d = g = x.radius), "width" in x && (d = x.width), "height" in x && (g = x.height));
                    if ("color" in x || "colors" in x) c = x.color || x.colors, Array.isArray(c);
                    if (!c) {
                        "colorCount" in x && (p = x.colorCount | 0);
                        "colorTexture" in x && (m = !!x.colorTexture, q = "rgba4");
                        if ("colorType" in x && (r = x.colorType, !m)) {
                            if ("half float" === r || "float16" === r) q = "rgba16f";
                            else if ("float" === r || "float32" === r) q = "rgba32f";
                        }
                        "colorFormat" in x && (q = x.colorFormat, 0 <= ka.indexOf(q) ? m = !0 : 0 <= wa.indexOf(q) && (m = !1));
                    }
                    if ("depthTexture" in x || "depthStencilTexture" in x) N = !(!x.depthTexture && !x.depthStencilTexture);
                    "depth" in x && ("boolean" === typeof x.depth ? t = x.depth : (A = x.depth, h = !1));
                    "stencil" in x && ("boolean" === typeof x.stencil ? h = x.stencil : (E = x.stencil, t = !1));
                    "depthStencil" in x && ("boolean" === typeof x.depthStencil ? t = h = x.depthStencil : (ma = x.depthStencil, h = t = !1));
                } else d = g = 1;
                var C = null, X = null, B = null, F = null;
                if (Array.isArray(c)) C = c.map(u);
                else if (c) C = [
                    u(c)
                ];
                else for(C = Array(p), c = 0; c < p; ++c)C[c] = n(d, g, m, q, r);
                d = d || C[0].width;
                g = g || C[0].height;
                A ? X = u(A) : t && !h && (X = n(d, g, N, "depth", "uint32"));
                E ? B = u(E) : h && !t && (B = n(d, g, !1, "stencil", "uint8"));
                ma ? F = u(ma) : !A && !E && h && t && (F = n(d, g, N, "depth stencil", "depth stencil"));
                t = null;
                for(c = 0; c < C.length; ++c)v(C[c], d, g), C[c] && C[c].texture && (h = Xa[C[c].texture._texture.format] * Pa[C[c].texture._texture.type], null === t && (t = h));
                v(X, d, g);
                v(B, d, g);
                v(F, d, g);
                k(f);
                f.width = d;
                f.height = g;
                f.colorAttachments = C;
                f.depthAttachment = X;
                f.stencilAttachment = B;
                f.depthStencilAttachment = F;
                e.color = C.map(z);
                e.depth = z(X);
                e.stencil = z(B);
                e.depthStencil = z(F);
                e.width = f.width;
                e.height = f.height;
                l(f, x && x.ignoreStatusCheck);
                return e;
            }
            var f = new g;
            d.framebufferCount++;
            e(b, c);
            return F(e, {
                resize: function(a, b) {
                    var c = Math.max(a | 0, 1), d = Math.max(b | 0 || c, 1);
                    if (c === f.width && d === f.height) return e;
                    for(var k = f.colorAttachments, g = 0; g < k.length; ++g)q(k[g], c, d);
                    q(f.depthAttachment, c, d);
                    q(f.stencilAttachment, c, d);
                    q(f.depthStencilAttachment, c, d);
                    f.width = e.width = c;
                    f.height = e.height = d;
                    l(f);
                    return e;
                },
                blit: function(b, c, d) {
                    a.bindFramebuffer(36008, b._framebuffer.framebuffer);
                    a.bindFramebuffer(36009, f.framebuffer);
                    c || (c = 16384);
                    a.blitFramebuffer(0, 0, b.width, b.height, 0, 0, f.width, f.height, c, "linear" === d ? 9729 : 9728);
                    a.bindFramebuffer(36008, null);
                    a.bindFramebuffer(36009, null);
                },
                _reglType: "framebuffer",
                _framebuffer: f,
                destroy: function() {
                    h(f);
                    k(f);
                },
                use: function(a) {
                    t.setFBO({
                        framebuffer: e
                    }, a);
                }
            });
        }
        var t = {
            cur: null,
            next: null,
            dirty: !1,
            setFBO: null
        }, ka = [
            "rgba"
        ], wa = [
            "rgba4",
            "rgb565",
            "rgb5 a1"
        ];
        b.ext_srgb && wa.push("srgba");
        b.ext_color_buffer_half_float && wa.push("rgba16f", "rgb16f");
        b.webgl_color_buffer_float && wa.push("rgba32f");
        var B = [
            "uint8"
        ];
        b.oes_texture_half_float && B.push("half float", "float16");
        b.oes_texture_float && B.push("float", "float32");
        var C = 0, N = {};
        return F(t, {
            getFramebuffer: function(a) {
                return "function" === typeof a && "framebuffer" === a._reglType && (a = a._framebuffer, a instanceof g) ? a : null;
            },
            create: A,
            createCube: function(a) {
                function b(a) {
                    var d, f = {
                        color: null
                    }, k = 0, g = null;
                    d = "rgba";
                    var t = "uint8", l = 1;
                    if ("number" === typeof a) k = a | 0;
                    else if (a) {
                        "shape" in a ? k = a.shape[0] : ("radius" in a && (k = a.radius | 0), "width" in a ? k = a.width | 0 : "height" in a && (k = a.height | 0));
                        if ("color" in a || "colors" in a) g = a.color || a.colors, Array.isArray(g);
                        g || ("colorCount" in a && (l = a.colorCount | 0), "colorType" in a && (t = a.colorType), "colorFormat" in a && (d = a.colorFormat));
                        "depth" in a && (f.depth = a.depth);
                        "stencil" in a && (f.stencil = a.stencil);
                        "depthStencil" in a && (f.depthStencil = a.depthStencil);
                    } else k = 1;
                    if (g) {
                        if (Array.isArray(g)) for(a = [], d = 0; d < g.length; ++d)a[d] = g[d];
                        else a = [
                            g
                        ];
                    } else for(a = Array(l), g = {
                        radius: k,
                        format: d,
                        type: t
                    }, d = 0; d < l; ++d)a[d] = e.createCube(g);
                    f.color = Array(a.length);
                    for(d = 0; d < a.length; ++d)l = a[d], k = k || l.width, f.color[d] = {
                        target: 34069,
                        data: a[d]
                    };
                    for(d = 0; 6 > d; ++d){
                        for(l = 0; l < a.length; ++l)f.color[l].target = 34069 + d;
                        0 < d && (f.depth = c[0].depth, f.stencil = c[0].stencil, f.depthStencil = c[0].depthStencil);
                        if (c[d]) c[d](f);
                        else c[d] = A(f);
                    }
                    return F(b, {
                        width: k,
                        height: k,
                        color: a
                    });
                }
                var c = Array(6);
                b(a);
                return F(b, {
                    faces: c,
                    resize: function(a) {
                        var d = a | 0;
                        if (d === b.width) return b;
                        var e = b.color;
                        for(a = 0; a < e.length; ++a)e[a].resize(d);
                        for(a = 0; 6 > a; ++a)c[a].resize(d);
                        b.width = b.height = d;
                        return b;
                    },
                    _reglType: "framebufferCube",
                    destroy: function() {
                        c.forEach(function(a) {
                            a.destroy();
                        });
                    }
                });
            },
            clear: function() {
                S(N).forEach(h);
            },
            restore: function() {
                t.cur = null;
                t.next = null;
                t.dirty = !0;
                S(N).forEach(function(b) {
                    b.framebuffer = a.createFramebuffer();
                    l(b);
                });
            }
        });
    }
    function Ya() {
        this.w = this.z = this.y = this.x = this.state = 0;
        this.buffer = null;
        this.size = 0;
        this.normalized = !1;
        this.type = 5126;
        this.divisor = this.stride = this.offset = 0;
    }
    function Rb(a, b, c, e, f, d, p) {
        function r(a) {
            if (a !== h.currentVAO) {
                var c = b.oes_vertex_array_object;
                a ? c.bindVertexArrayOES(a.vao) : c.bindVertexArrayOES(null);
                h.currentVAO = a;
            }
        }
        function v(c) {
            if (c !== h.currentVAO) {
                if (c) c.bindAttrs();
                else {
                    for(var d = b.angle_instanced_arrays, e = 0; e < q.length; ++e){
                        var f = q[e];
                        f.buffer ? (a.enableVertexAttribArray(e), f.buffer.bind(), a.vertexAttribPointer(e, f.size, f.type, f.normalized, f.stride, f.offfset), d && f.divisor && d.vertexAttribDivisorANGLE(e, f.divisor)) : (a.disableVertexAttribArray(e), a.vertexAttrib4f(e, f.x, f.y, f.z, f.w));
                    }
                    p.elements ? a.bindBuffer(34963, p.elements.buffer.buffer) : a.bindBuffer(34963, null);
                }
                h.currentVAO = c;
            }
        }
        function m() {
            S(k).forEach(function(a) {
                a.destroy();
            });
        }
        function u() {
            this.id = ++g;
            this.attributes = [];
            this.elements = null;
            this.ownsElements = !1;
            this.offset = this.count = 0;
            this.instances = -1;
            this.primitive = 4;
            var a = b.oes_vertex_array_object;
            this.vao = a ? a.createVertexArrayOES() : null;
            k[this.id] = this;
            this.buffers = [];
        }
        function n() {
            b.oes_vertex_array_object && S(k).forEach(function(a) {
                a.refresh();
            });
        }
        var z = c.maxAttributes, q = Array(z);
        for(c = 0; c < z; ++c)q[c] = new Ya;
        var g = 0, k = {}, h = {
            Record: Ya,
            scope: {},
            state: q,
            currentVAO: null,
            targetVAO: null,
            restore: b.oes_vertex_array_object ? n : function() {},
            createVAO: function(a) {
                function b(a) {
                    var e;
                    Array.isArray(a) ? (e = a, c.elements && c.ownsElements && c.elements.destroy(), c.elements = null, c.ownsElements = !1, c.offset = 0, c.count = 0, c.instances = -1, c.primitive = 4) : (a.elements ? (e = a.elements, c.ownsElements ? ("function" === typeof e && "elements" === e._reglType ? c.elements.destroy() : c.elements(e), c.ownsElements = !1) : d.getElements(a.elements) ? (c.elements = a.elements, c.ownsElements = !1) : (c.elements = d.create(a.elements), c.ownsElements = !0)) : (c.elements = null, c.ownsElements = !1), e = a.attributes, c.offset = 0, c.count = -1, c.instances = -1, c.primitive = 4, c.elements && (c.count = c.elements._elements.vertCount, c.primitive = c.elements._elements.primType), "offset" in a && (c.offset = a.offset | 0), "count" in a && (c.count = a.count | 0), "instances" in a && (c.instances = a.instances | 0), "primitive" in a && (c.primitive = Ia[a.primitive]));
                    a = {};
                    var k = c.attributes;
                    k.length = e.length;
                    for(var g = 0; g < e.length; ++g){
                        var l = e[g], h = k[g] = new Ya, m = l.data || l;
                        if (Array.isArray(m) || K(m) || aa(m)) {
                            var n;
                            c.buffers[g] && (n = c.buffers[g], K(m) && n._buffer.byteLength >= m.byteLength ? n.subdata(m) : (n.destroy(), c.buffers[g] = null));
                            c.buffers[g] || (n = c.buffers[g] = f.create(l, 34962, !1, !0));
                            h.buffer = f.getBuffer(n);
                            h.size = h.buffer.dimension | 0;
                            h.normalized = !1;
                            h.type = h.buffer.dtype;
                            h.offset = 0;
                            h.stride = 0;
                            h.divisor = 0;
                            h.state = 1;
                            a[g] = 1;
                        } else f.getBuffer(l) ? (h.buffer = f.getBuffer(l), h.size = h.buffer.dimension | 0, h.normalized = !1, h.type = h.buffer.dtype, h.offset = 0, h.stride = 0, h.divisor = 0, h.state = 1) : f.getBuffer(l.buffer) ? (h.buffer = f.getBuffer(l.buffer), h.size = (+l.size || h.buffer.dimension) | 0, h.normalized = !!l.normalized || !1, h.type = "type" in l ? Ha[l.type] : h.buffer.dtype, h.offset = (l.offset || 0) | 0, h.stride = (l.stride || 0) | 0, h.divisor = (l.divisor || 0) | 0, h.state = 1) : "x" in l && (h.x = +l.x || 0, h.y = +l.y || 0, h.z = +l.z || 0, h.w = +l.w || 0, h.state = 2);
                    }
                    for(n = 0; n < c.buffers.length; ++n)!a[n] && c.buffers[n] && (c.buffers[n].destroy(), c.buffers[n] = null);
                    c.refresh();
                    return b;
                }
                var c = new u;
                e.vaoCount += 1;
                b.destroy = function() {
                    for(var a = 0; a < c.buffers.length; ++a)c.buffers[a] && c.buffers[a].destroy();
                    c.buffers.length = 0;
                    c.ownsElements && (c.elements.destroy(), c.elements = null, c.ownsElements = !1);
                    c.destroy();
                };
                b._vao = c;
                b._reglType = "vao";
                return b(a);
            },
            getVAO: function(a) {
                return "function" === typeof a && a._vao ? a._vao : null;
            },
            destroyBuffer: function(b) {
                for(var c = 0; c < q.length; ++c){
                    var d = q[c];
                    d.buffer === b && (a.disableVertexAttribArray(c), d.buffer = null);
                }
            },
            setVAO: b.oes_vertex_array_object ? r : v,
            clear: b.oes_vertex_array_object ? m : function() {}
        };
        u.prototype.bindAttrs = function() {
            for(var c = b.angle_instanced_arrays, e = this.attributes, f = 0; f < e.length; ++f){
                var g = e[f];
                g.buffer ? (a.enableVertexAttribArray(f), a.bindBuffer(34962, g.buffer.buffer), a.vertexAttribPointer(f, g.size, g.type, g.normalized, g.stride, g.offset), c && g.divisor && c.vertexAttribDivisorANGLE(f, g.divisor)) : (a.disableVertexAttribArray(f), a.vertexAttrib4f(f, g.x, g.y, g.z, g.w));
            }
            for(c = e.length; c < z; ++c)a.disableVertexAttribArray(c);
            (c = d.getElements(this.elements)) ? a.bindBuffer(34963, c.buffer.buffer) : a.bindBuffer(34963, null);
        };
        u.prototype.refresh = function() {
            var a = b.oes_vertex_array_object;
            a && (a.bindVertexArrayOES(this.vao), this.bindAttrs(), h.currentVAO = null, a.bindVertexArrayOES(null));
        };
        u.prototype.destroy = function() {
            if (this.vao) {
                var a = b.oes_vertex_array_object;
                this === h.currentVAO && (h.currentVAO = null, a.bindVertexArrayOES(null));
                a.deleteVertexArrayOES(this.vao);
                this.vao = null;
            }
            this.ownsElements && (this.elements.destroy(), this.elements = null, this.ownsElements = !1);
            k[this.id] && (delete k[this.id], --e.vaoCount);
        };
        return h;
    }
    function Sb(a, b, c, e) {
        function f(a, b, c, d) {
            this.name = a;
            this.id = b;
            this.location = c;
            this.info = d;
        }
        function d(a, b) {
            for(var c = 0; c < a.length; ++c)if (a[c].id === b.id) {
                a[c].location = b.location;
                return;
            }
            a.push(b);
        }
        function p(c, d, e) {
            e = 35632 === c ? m : u;
            var f = e[d];
            if (!f) {
                var n = b.str(d), f = a.createShader(c);
                a.shaderSource(f, n);
                a.compileShader(f);
                e[d] = f;
            }
            return f;
        }
        function r(a, b) {
            this.id = q++;
            this.fragId = a;
            this.vertId = b;
            this.program = null;
            this.uniforms = [];
            this.attributes = [];
            this.refCount = 1;
            e.profile && (this.stats = {
                uniformsCount: 0,
                attributesCount: 0
            });
        }
        function v(c, k, h) {
            var m;
            m = p(35632, c.fragId);
            var n = p(35633, c.vertId);
            k = c.program = a.createProgram();
            a.attachShader(k, m);
            a.attachShader(k, n);
            if (h) for(m = 0; m < h.length; ++m)n = h[m], a.bindAttribLocation(k, n[0], n[1]);
            a.linkProgram(k);
            n = a.getProgramParameter(k, 35718);
            e.profile && (c.stats.uniformsCount = n);
            var q = c.uniforms;
            for(m = 0; m < n; ++m)if (h = a.getActiveUniform(k, m)) {
                if (1 < h.size) for(var r = 0; r < h.size; ++r){
                    var u = h.name.replace("[0]", "[" + r + "]");
                    d(q, new f(u, b.id(u), a.getUniformLocation(k, u), h));
                }
                r = h.name;
                1 < h.size && (r = r.replace("[0]", ""));
                d(q, new f(r, b.id(r), a.getUniformLocation(k, r), h));
            }
            n = a.getProgramParameter(k, 35721);
            e.profile && (c.stats.attributesCount = n);
            c = c.attributes;
            for(m = 0; m < n; ++m)(h = a.getActiveAttrib(k, m)) && d(c, new f(h.name, b.id(h.name), a.getAttribLocation(k, h.name), h));
        }
        var m = {}, u = {}, n = {}, z = [], q = 0;
        e.profile && (c.getMaxUniformsCount = function() {
            var a = 0;
            z.forEach(function(b) {
                b.stats.uniformsCount > a && (a = b.stats.uniformsCount);
            });
            return a;
        }, c.getMaxAttributesCount = function() {
            var a = 0;
            z.forEach(function(b) {
                b.stats.attributesCount > a && (a = b.stats.attributesCount);
            });
            return a;
        });
        return {
            clear: function() {
                var b = a.deleteShader.bind(a);
                S(m).forEach(b);
                m = {};
                S(u).forEach(b);
                u = {};
                z.forEach(function(b) {
                    a.deleteProgram(b.program);
                });
                z.length = 0;
                n = {};
                c.shaderCount = 0;
            },
            program: function(b, d, e, f) {
                var q = n[d];
                q || (q = n[d] = {});
                var t = q[b];
                if (t && (t.refCount++, !f)) return t;
                var p = new r(d, b);
                c.shaderCount++;
                v(p, e, f);
                t || (q[b] = p);
                z.push(p);
                return F(p, {
                    destroy: function() {
                        p.refCount--;
                        if (0 >= p.refCount) {
                            a.deleteProgram(p.program);
                            var b = z.indexOf(p);
                            z.splice(b, 1);
                            c.shaderCount--;
                        }
                        0 >= q[p.vertId].refCount && (a.deleteShader(u[p.vertId]), delete u[p.vertId], delete n[p.fragId][p.vertId]);
                        Object.keys(n[p.fragId]).length || (a.deleteShader(m[p.fragId]), delete m[p.fragId], delete n[p.fragId]);
                    }
                });
            },
            restore: function() {
                m = {};
                u = {};
                for(var a = 0; a < z.length; ++a)v(z[a], null, z[a].attributes.map(function(a) {
                    return [
                        a.location,
                        a.name
                    ];
                }));
            },
            shader: p,
            frag: -1,
            vert: -1
        };
    }
    function Tb(a, b, c, e, f, d, p) {
        function r(d) {
            var f;
            f = null === b.next ? 5121 : b.next.colorAttachments[0].texture._texture.type;
            var n = 0, r = 0, q = e.framebufferWidth, g = e.framebufferHeight, k = null;
            K(d) ? k = d : d && (n = d.x | 0, r = d.y | 0, q = (d.width || e.framebufferWidth - n) | 0, g = (d.height || e.framebufferHeight - r) | 0, k = d.data || null);
            c();
            d = q * g * 4;
            k || (5121 === f ? k = new Uint8Array(d) : 5126 === f && (k = k || new Float32Array(d)));
            a.pixelStorei(3333, 4);
            a.readPixels(n, r, q, g, 6408, f, k);
            return k;
        }
        function v(a) {
            var c;
            b.setFBO({
                framebuffer: a.framebuffer
            }, function() {
                c = r(a);
            });
            return c;
        }
        return function(a) {
            return a && "framebuffer" in a ? v(a) : r(a);
        };
    }
    function za(a) {
        return Array.prototype.slice.call(a);
    }
    function Aa(a) {
        return za(a).join("");
    }
    function Ub() {
        function a() {
            var a = [], b = [];
            return F(function() {
                a.push.apply(a, za(arguments));
            }, {
                def: function() {
                    var d = "v" + c++;
                    b.push(d);
                    0 < arguments.length && (a.push(d, "="), a.push.apply(a, za(arguments)), a.push(";"));
                    return d;
                },
                toString: function() {
                    return Aa([
                        0 < b.length ? "var " + b.join(",") + ";" : "",
                        Aa(a)
                    ]);
                }
            });
        }
        function b() {
            function b(a, e) {
                d(a, e, "=", c.def(a, e), ";");
            }
            var c = a(), d = a(), e = c.toString, f = d.toString;
            return F(function() {
                c.apply(c, za(arguments));
            }, {
                def: c.def,
                entry: c,
                exit: d,
                save: b,
                set: function(a, d, e) {
                    b(a, d);
                    c(a, d, "=", e, ";");
                },
                toString: function() {
                    return e() + f();
                }
            });
        }
        var c = 0, e = [], f = [], d = a(), p = {};
        return {
            global: d,
            link: function(a) {
                for(var b = 0; b < f.length; ++b)if (f[b] === a) return e[b];
                b = "g" + c++;
                e.push(b);
                f.push(a);
                return b;
            },
            block: a,
            proc: function(a, c) {
                function d() {
                    var a = "a" + e.length;
                    e.push(a);
                    return a;
                }
                var e = [];
                c = c || 0;
                for(var f = 0; f < c; ++f)d();
                var f = b(), z = f.toString;
                return p[a] = F(f, {
                    arg: d,
                    toString: function() {
                        return Aa([
                            "function(",
                            e.join(),
                            "){",
                            z(),
                            "}"
                        ]);
                    }
                });
            },
            scope: b,
            cond: function() {
                var a = Aa(arguments), c = b(), d = b(), e = c.toString, f = d.toString;
                return F(c, {
                    then: function() {
                        c.apply(c, za(arguments));
                        return this;
                    },
                    "else": function() {
                        d.apply(d, za(arguments));
                        return this;
                    },
                    toString: function() {
                        var b = f();
                        b && (b = "else{" + b + "}");
                        return Aa([
                            "if(",
                            a,
                            "){",
                            e(),
                            "}",
                            b
                        ]);
                    }
                });
            },
            compile: function() {
                var a = [
                    '"use strict";',
                    d,
                    "return {"
                ];
                Object.keys(p).forEach(function(b) {
                    a.push('"', b, '":', p[b].toString(), ",");
                });
                a.push("}");
                var b = Aa(a).replace(/;/g, ";\n").replace(/}/g, "}\n").replace(/{/g, "{\n");
                return Function.apply(null, e.concat(b)).apply(null, f);
            }
        };
    }
    function Qa(a) {
        return Array.isArray(a) || K(a) || aa(a);
    }
    function xb(a) {
        return a.sort(function(a, c) {
            return "viewport" === a ? -1 : "viewport" === c ? 1 : a < c ? -1 : 1;
        });
    }
    function I(a, b, c, e) {
        this.thisDep = a;
        this.contextDep = b;
        this.propDep = c;
        this.append = e;
    }
    function va(a) {
        return a && !(a.thisDep || a.contextDep || a.propDep);
    }
    function B(a) {
        return new I(!1, !1, !1, a);
    }
    function M(a, b) {
        var c = a.type;
        if (0 === c) return c = a.data.length, new I(!0, 1 <= c, 2 <= c, b);
        if (4 === c) return c = a.data, new I(c.thisDep, c.contextDep, c.propDep, b);
        if (5 === c) return new I(!1, !1, !1, b);
        if (6 === c) {
            for(var e = c = !1, f = !1, d = 0; d < a.data.length; ++d){
                var p = a.data[d];
                1 === p.type ? f = !0 : 2 === p.type ? e = !0 : 3 === p.type ? c = !0 : 0 === p.type ? (c = !0, p = p.data, 1 <= p && (e = !0), 2 <= p && (f = !0)) : 4 === p.type && (c = c || p.data.thisDep, e = e || p.data.contextDep, f = f || p.data.propDep);
            }
            return new I(c, e, f, b);
        }
        return new I(3 === c, 2 === c, 1 === c, b);
    }
    function Vb(a, b, c, e, f, d, p, r, v, m, u, n, z, q, g) {
        function k(a) {
            return a.replace(".", "_");
        }
        function h(a, b, c) {
            var d = k(a);
            La.push(a);
            Ca[d] = sa[d] = !!c;
            ta[d] = b;
        }
        function l(a, b, c) {
            var d = k(a);
            La.push(a);
            Array.isArray(c) ? (sa[d] = c.slice(), Ca[d] = c.slice()) : sa[d] = Ca[d] = c;
            ua[d] = b;
        }
        function A() {
            var a = Ub(), c = a.link, d = a.global;
            a.id = ra++;
            a.batchId = "0";
            var e = c(rb), f = a.shared = {
                props: "a0"
            };
            Object.keys(rb).forEach(function(a) {
                f[a] = d.def(e, ".", a);
            });
            var g = a.next = {}, k = a.current = {};
            Object.keys(ua).forEach(function(a) {
                Array.isArray(sa[a]) && (g[a] = d.def(f.next, ".", a), k[a] = d.def(f.current, ".", a));
            });
            var Wb = a.constants = {};
            Object.keys(Na).forEach(function(a) {
                Wb[a] = d.def(JSON.stringify(Na[a]));
            });
            a.invoke = function(b, d) {
                switch(d.type){
                    case 0:
                        var e = [
                            "this",
                            f.context,
                            f.props,
                            a.batchId
                        ];
                        return b.def(c(d.data), ".call(", e.slice(0, Math.max(d.data.length + 1, 4)), ")");
                    case 1:
                        return b.def(f.props, d.data);
                    case 2:
                        return b.def(f.context, d.data);
                    case 3:
                        return b.def("this", d.data);
                    case 4:
                        return d.data.append(a, b), d.data.ref;
                    case 5:
                        return d.data.toString();
                    case 6:
                        return d.data.map(function(c) {
                            return a.invoke(b, c);
                        });
                }
            };
            a.attribCache = {};
            var Y = {};
            a.scopeAttrib = function(a) {
                a = b.id(a);
                if (a in Y) return Y[a];
                var d = m.scope[a];
                d || (d = m.scope[a] = new da);
                return Y[a] = c(d);
            };
            return a;
        }
        function t(a) {
            var b = a["static"];
            a = a.dynamic;
            var c;
            if ("profile" in b) {
                var d = !!b.profile;
                c = B(function(a, b) {
                    return d;
                });
                c.enable = d;
            } else if ("profile" in a) {
                var e = a.profile;
                c = M(e, function(a, b) {
                    return a.invoke(b, e);
                });
            }
            return c;
        }
        function D(a, b) {
            var c = a["static"], d = a.dynamic;
            if ("framebuffer" in c) {
                var e = c.framebuffer;
                return e ? (e = r.getFramebuffer(e), B(function(a, b) {
                    var c = a.link(e), d = a.shared;
                    b.set(d.framebuffer, ".next", c);
                    d = d.context;
                    b.set(d, ".framebufferWidth", c + ".width");
                    b.set(d, ".framebufferHeight", c + ".height");
                    return c;
                })) : B(function(a, b) {
                    var c = a.shared;
                    b.set(c.framebuffer, ".next", "null");
                    c = c.context;
                    b.set(c, ".framebufferWidth", c + ".drawingBufferWidth");
                    b.set(c, ".framebufferHeight", c + ".drawingBufferHeight");
                    return "null";
                });
            }
            if ("framebuffer" in d) {
                var f = d.framebuffer;
                return M(f, function(a, b) {
                    var c = a.invoke(b, f), d = a.shared, e = d.framebuffer, c = b.def(e, ".getFramebuffer(", c, ")");
                    b.set(e, ".next", c);
                    d = d.context;
                    b.set(d, ".framebufferWidth", c + "?" + c + ".width:" + d + ".drawingBufferWidth");
                    b.set(d, ".framebufferHeight", c + "?" + c + ".height:" + d + ".drawingBufferHeight");
                    return c;
                });
            }
            return null;
        }
        function H(a, b, c) {
            function d(a) {
                if (a in e) {
                    var c = e[a];
                    a = !0;
                    var w = c.x | 0, ja = c.y | 0, g, k;
                    "width" in c ? g = c.width | 0 : a = !1;
                    "height" in c ? k = c.height | 0 : a = !1;
                    return new I(!a && b && b.thisDep, !a && b && b.contextDep, !a && b && b.propDep, function(a, b) {
                        var d = a.shared.context, e = g;
                        "width" in c || (e = b.def(d, ".", "framebufferWidth", "-", w));
                        var f = k;
                        "height" in c || (f = b.def(d, ".", "framebufferHeight", "-", ja));
                        return [
                            w,
                            ja,
                            e,
                            f
                        ];
                    });
                }
                if (a in f) {
                    var h = f[a];
                    a = M(h, function(a, b) {
                        var c = a.invoke(b, h), d = a.shared.context, e = b.def(c, ".x|0"), f = b.def(c, ".y|0"), w = b.def('"width" in ', c, "?", c, ".width|0:", "(", d, ".", "framebufferWidth", "-", e, ")"), c = b.def('"height" in ', c, "?", c, ".height|0:", "(", d, ".", "framebufferHeight", "-", f, ")");
                        return [
                            e,
                            f,
                            w,
                            c
                        ];
                    });
                    b && (a.thisDep = a.thisDep || b.thisDep, a.contextDep = a.contextDep || b.contextDep, a.propDep = a.propDep || b.propDep);
                    return a;
                }
                return b ? new I(b.thisDep, b.contextDep, b.propDep, function(a, b) {
                    var c = a.shared.context;
                    return [
                        0,
                        0,
                        b.def(c, ".", "framebufferWidth"),
                        b.def(c, ".", "framebufferHeight")
                    ];
                }) : null;
            }
            var e = a["static"], f = a.dynamic;
            if (a = d("viewport")) {
                var g = a;
                a = new I(a.thisDep, a.contextDep, a.propDep, function(a, b) {
                    var c = g.append(a, b), d = a.shared.context;
                    b.set(d, ".viewportWidth", c[2]);
                    b.set(d, ".viewportHeight", c[3]);
                    return c;
                });
            }
            return {
                viewport: a,
                scissor_box: d("scissor.box")
            };
        }
        function K(a, b) {
            var c = a["static"];
            if ("string" === typeof c.frag && "string" === typeof c.vert) {
                if (0 < Object.keys(b.dynamic).length) return null;
                var c = b["static"], d = Object.keys(c);
                if (0 < d.length && "number" === typeof c[d[0]]) {
                    for(var e = [], f = 0; f < d.length; ++f)e.push([
                        c[d[f]] | 0,
                        d[f]
                    ]);
                    return e;
                }
            }
            return null;
        }
        function C(a, c, d) {
            function e(a) {
                if (a in f) {
                    var c = b.id(f[a]);
                    a = B(function() {
                        return c;
                    });
                    a.id = c;
                    return a;
                }
                if (a in g) {
                    var d = g[a];
                    return M(d, function(a, b) {
                        var c = a.invoke(b, d);
                        return b.def(a.shared.strings, ".id(", c, ")");
                    });
                }
                return null;
            }
            var f = a["static"], g = a.dynamic, k = e("frag"), h = e("vert"), Y = null;
            va(k) && va(h) ? (Y = u.program(h.id, k.id, null, d), a = B(function(a, b) {
                return a.link(Y);
            })) : a = new I(k && k.thisDep || h && h.thisDep, k && k.contextDep || h && h.contextDep, k && k.propDep || h && h.propDep, function(a, b) {
                var c = a.shared.shader, d;
                d = k ? k.append(a, b) : b.def(c, ".", "frag");
                var e;
                e = h ? h.append(a, b) : b.def(c, ".", "vert");
                return b.def(c + ".program(" + e + "," + d + ")");
            });
            return {
                frag: k,
                vert: h,
                progVar: a,
                program: Y
            };
        }
        function N(a, b) {
            function c(a, b) {
                if (a in e) {
                    var d = e[a] | 0;
                    b ? k.offset = d : k.instances = d;
                    return B(function(a, c) {
                        b && (a.OFFSET = d);
                        return d;
                    });
                }
                if (a in f) {
                    var w = f[a];
                    return M(w, function(a, c) {
                        var d = a.invoke(c, w);
                        b && (a.OFFSET = d);
                        return d;
                    });
                }
                if (b) {
                    if (Y) return B(function(a, b) {
                        return a.OFFSET = 0;
                    });
                    if (g) return new I(h.thisDep, h.contextDep, h.propDep, function(a, b) {
                        return b.def(a.shared.vao + ".currentVAO?" + a.shared.vao + ".currentVAO.offset:0");
                    });
                } else if (g) return new I(h.thisDep, h.contextDep, h.propDep, function(a, b) {
                    return b.def(a.shared.vao + ".currentVAO?" + a.shared.vao + ".currentVAO.instances:-1");
                });
                return null;
            }
            var e = a["static"], f = a.dynamic, k = {}, g = !1, h = function() {
                if ("vao" in e) {
                    var a = e.vao;
                    null !== a && null === m.getVAO(a) && (a = m.createVAO(a));
                    g = !0;
                    k.vao = a;
                    return B(function(b) {
                        var c = m.getVAO(a);
                        return c ? b.link(c) : "null";
                    });
                }
                if ("vao" in f) {
                    g = !0;
                    var b = f.vao;
                    return M(b, function(a, c) {
                        var d = a.invoke(c, b);
                        return c.def(a.shared.vao + ".getVAO(" + d + ")");
                    });
                }
                return null;
            }(), Y = !1, V = function() {
                if ("elements" in e) {
                    var a = e.elements;
                    k.elements = a;
                    if (Qa(a)) {
                        var b = k.elements = d.create(a, !0), a = d.getElements(b);
                        Y = !0;
                    } else a && (a = d.getElements(a), Y = !0);
                    b = B(function(b, c) {
                        if (a) {
                            var d = b.link(a);
                            return b.ELEMENTS = d;
                        }
                        return b.ELEMENTS = null;
                    });
                    b.value = a;
                    return b;
                }
                if ("elements" in f) {
                    Y = !0;
                    var c = f.elements;
                    return M(c, function(a, b) {
                        var d = a.shared, e = d.isBufferArgs, d = d.elements, f = a.invoke(b, c), w = b.def("null"), e = b.def(e, "(", f, ")"), f = a.cond(e).then(w, "=", d, ".createStream(", f, ");")["else"](w, "=", d, ".getElements(", f, ");");
                        b.entry(f);
                        b.exit(a.cond(e).then(d, ".destroyStream(", w, ");"));
                        return a.ELEMENTS = w;
                    });
                }
                return g ? new I(h.thisDep, h.contextDep, h.propDep, function(a, b) {
                    return b.def(a.shared.vao + ".currentVAO?" + a.shared.elements + ".getElements(" + a.shared.vao + ".currentVAO.elements):null");
                }) : null;
            }(), ja = c("offset", !0), n = function() {
                if ("primitive" in e) {
                    var a = e.primitive;
                    k.primitive = a;
                    return B(function(b, c) {
                        return Ia[a];
                    });
                }
                if ("primitive" in f) {
                    var b = f.primitive;
                    return M(b, function(a, c) {
                        var d = a.constants.primTypes, e = a.invoke(c, b);
                        return c.def(d, "[", e, "]");
                    });
                }
                return Y ? va(V) ? V.value ? B(function(a, b) {
                    return b.def(a.ELEMENTS, ".primType");
                }) : B(function() {
                    return 4;
                }) : new I(V.thisDep, V.contextDep, V.propDep, function(a, b) {
                    var c = a.ELEMENTS;
                    return b.def(c, "?", c, ".primType:", 4);
                }) : g ? new I(h.thisDep, h.contextDep, h.propDep, function(a, b) {
                    return b.def(a.shared.vao + ".currentVAO?" + a.shared.vao + ".currentVAO.primitive:4");
                }) : null;
            }(), q = function() {
                if ("count" in e) {
                    var a = e.count | 0;
                    k.count = a;
                    return B(function() {
                        return a;
                    });
                }
                if ("count" in f) {
                    var b = f.count;
                    return M(b, function(a, c) {
                        return a.invoke(c, b);
                    });
                }
                return Y ? va(V) ? V ? ja ? new I(ja.thisDep, ja.contextDep, ja.propDep, function(a, b) {
                    return b.def(a.ELEMENTS, ".vertCount-", a.OFFSET);
                }) : B(function(a, b) {
                    return b.def(a.ELEMENTS, ".vertCount");
                }) : B(function() {
                    return -1;
                }) : new I(V.thisDep || ja.thisDep, V.contextDep || ja.contextDep, V.propDep || ja.propDep, function(a, b) {
                    var c = a.ELEMENTS;
                    return a.OFFSET ? b.def(c, "?", c, ".vertCount-", a.OFFSET, ":-1") : b.def(c, "?", c, ".vertCount:-1");
                }) : g ? new I(h.thisDep, h.contextDep, h.propDep, function(a, b) {
                    return b.def(a.shared.vao, ".currentVAO?", a.shared.vao, ".currentVAO.count:-1");
                }) : null;
            }(), l = c("instances", !1);
            return {
                elements: V,
                primitive: n,
                count: q,
                instances: l,
                offset: ja,
                vao: h,
                vaoActive: g,
                elementsActive: Y,
                "static": k
            };
        }
        function E(a, b) {
            var c = a["static"], d = a.dynamic, e = {};
            La.forEach(function(a) {
                function b(w, k) {
                    if (a in c) {
                        var g = w(c[a]);
                        e[f] = B(function() {
                            return g;
                        });
                    } else if (a in d) {
                        var L = d[a];
                        e[f] = M(L, function(a, b) {
                            return k(a, b, a.invoke(b, L));
                        });
                    }
                }
                var f = k(a);
                switch(a){
                    case "cull.enable":
                    case "blend.enable":
                    case "dither":
                    case "stencil.enable":
                    case "depth.enable":
                    case "scissor.enable":
                    case "polygonOffset.enable":
                    case "sample.alpha":
                    case "sample.enable":
                    case "depth.mask":
                        return b(function(a) {
                            return a;
                        }, function(a, b, c) {
                            return c;
                        });
                    case "depth.func":
                        return b(function(a) {
                            return Za[a];
                        }, function(a, b, c) {
                            return b.def(a.constants.compareFuncs, "[", c, "]");
                        });
                    case "depth.range":
                        return b(function(a) {
                            return a;
                        }, function(a, b, c) {
                            a = b.def("+", c, "[0]");
                            b = b.def("+", c, "[1]");
                            return [
                                a,
                                b
                            ];
                        });
                    case "blend.func":
                        return b(function(a) {
                            return [
                                Ea["srcRGB" in a ? a.srcRGB : a.src],
                                Ea["dstRGB" in a ? a.dstRGB : a.dst],
                                Ea["srcAlpha" in a ? a.srcAlpha : a.src],
                                Ea["dstAlpha" in a ? a.dstAlpha : a.dst]
                            ];
                        }, function(a, b, c) {
                            function d(a, e) {
                                return b.def('"', a, e, '" in ', c, "?", c, ".", a, e, ":", c, ".", a);
                            }
                            a = a.constants.blendFuncs;
                            var e = d("src", "RGB"), f = d("dst", "RGB"), e = b.def(a, "[", e, "]"), w = b.def(a, "[", d("src", "Alpha"), "]"), f = b.def(a, "[", f, "]");
                            a = b.def(a, "[", d("dst", "Alpha"), "]");
                            return [
                                e,
                                f,
                                w,
                                a
                            ];
                        });
                    case "blend.equation":
                        return b(function(a) {
                            if ("string" === typeof a) return [
                                ea[a],
                                ea[a]
                            ];
                            if ("object" === typeof a) return [
                                ea[a.rgb],
                                ea[a.alpha]
                            ];
                        }, function(a, b, c) {
                            var d = a.constants.blendEquations, e = b.def(), f = b.def();
                            a = a.cond("typeof ", c, '==="string"');
                            a.then(e, "=", f, "=", d, "[", c, "];");
                            a["else"](e, "=", d, "[", c, ".rgb];", f, "=", d, "[", c, ".alpha];");
                            b(a);
                            return [
                                e,
                                f
                            ];
                        });
                    case "blend.color":
                        return b(function(a) {
                            return J(4, function(b) {
                                return +a[b];
                            });
                        }, function(a, b, c) {
                            return J(4, function(a) {
                                return b.def("+", c, "[", a, "]");
                            });
                        });
                    case "stencil.mask":
                        return b(function(a) {
                            return a | 0;
                        }, function(a, b, c) {
                            return b.def(c, "|0");
                        });
                    case "stencil.func":
                        return b(function(a) {
                            return [
                                Za[a.cmp || "keep"],
                                a.ref || 0,
                                "mask" in a ? a.mask : -1
                            ];
                        }, function(a, b, c) {
                            a = b.def('"cmp" in ', c, "?", a.constants.compareFuncs, "[", c, ".cmp]", ":", 7680);
                            var d = b.def(c, ".ref|0");
                            b = b.def('"mask" in ', c, "?", c, ".mask|0:-1");
                            return [
                                a,
                                d,
                                b
                            ];
                        });
                    case "stencil.opFront":
                    case "stencil.opBack":
                        return b(function(b) {
                            return [
                                "stencil.opBack" === a ? 1029 : 1028,
                                Ra[b.fail || "keep"],
                                Ra[b.zfail || "keep"],
                                Ra[b.zpass || "keep"]
                            ];
                        }, function(b, c, d) {
                            function e(a) {
                                return c.def('"', a, '" in ', d, "?", f, "[", d, ".", a, "]:", 7680);
                            }
                            var f = b.constants.stencilOps;
                            return [
                                "stencil.opBack" === a ? 1029 : 1028,
                                e("fail"),
                                e("zfail"),
                                e("zpass")
                            ];
                        });
                    case "polygonOffset.offset":
                        return b(function(a) {
                            return [
                                a.factor | 0,
                                a.units | 0
                            ];
                        }, function(a, b, c) {
                            a = b.def(c, ".factor|0");
                            b = b.def(c, ".units|0");
                            return [
                                a,
                                b
                            ];
                        });
                    case "cull.face":
                        return b(function(a) {
                            var b = 0;
                            "front" === a ? b = 1028 : "back" === a && (b = 1029);
                            return b;
                        }, function(a, b, c) {
                            return b.def(c, '==="front"?', 1028, ":", 1029);
                        });
                    case "lineWidth":
                        return b(function(a) {
                            return a;
                        }, function(a, b, c) {
                            return c;
                        });
                    case "frontFace":
                        return b(function(a) {
                            return yb[a];
                        }, function(a, b, c) {
                            return b.def(c + '==="cw"?2304:2305');
                        });
                    case "colorMask":
                        return b(function(a) {
                            return a.map(function(a) {
                                return !!a;
                            });
                        }, function(a, b, c) {
                            return J(4, function(a) {
                                return "!!" + c + "[" + a + "]";
                            });
                        });
                    case "sample.coverage":
                        return b(function(a) {
                            return [
                                "value" in a ? a.value : 1,
                                !!a.invert
                            ];
                        }, function(a, b, c) {
                            a = b.def('"value" in ', c, "?+", c, ".value:1");
                            b = b.def("!!", c, ".invert");
                            return [
                                a,
                                b
                            ];
                        });
                }
            });
            return e;
        }
        function X(a, b) {
            var c = a["static"], d = a.dynamic, e = {};
            Object.keys(c).forEach(function(a) {
                var b = c[a], d;
                if ("number" === typeof b || "boolean" === typeof b) d = B(function() {
                    return b;
                });
                else if ("function" === typeof b) {
                    var f = b._reglType;
                    if ("texture2d" === f || "textureCube" === f) d = B(function(a) {
                        return a.link(b);
                    });
                    else if ("framebuffer" === f || "framebufferCube" === f) d = B(function(a) {
                        return a.link(b.color[0]);
                    });
                } else pa(b) && (d = B(function(a) {
                    return a.global.def("[", J(b.length, function(a) {
                        return b[a];
                    }), "]");
                }));
                d.value = b;
                e[a] = d;
            });
            Object.keys(d).forEach(function(a) {
                var b = d[a];
                e[a] = M(b, function(a, c) {
                    return a.invoke(c, b);
                });
            });
            return e;
        }
        function la(a, c) {
            var d = a["static"], e = a.dynamic, k = {};
            Object.keys(d).forEach(function(a) {
                var c = d[a], e = b.id(a), w = new da;
                if (Qa(c)) w.state = 1, w.buffer = f.getBuffer(f.create(c, 34962, !1, !0)), w.type = 0;
                else {
                    var g = f.getBuffer(c);
                    if (g) w.state = 1, w.buffer = g, w.type = 0;
                    else if ("constant" in c) {
                        var L = c.constant;
                        w.buffer = "null";
                        w.state = 2;
                        "number" === typeof L ? w.x = L : Ba.forEach(function(a, b) {
                            b < L.length && (w[a] = L[b]);
                        });
                    } else {
                        var g = Qa(c.buffer) ? f.getBuffer(f.create(c.buffer, 34962, !1, !0)) : f.getBuffer(c.buffer), h = c.offset | 0, n = c.stride | 0, q = c.size | 0, l = !!c.normalized, m = 0;
                        "type" in c && (m = Ha[c.type]);
                        c = c.divisor | 0;
                        w.buffer = g;
                        w.state = 1;
                        w.size = q;
                        w.normalized = l;
                        w.type = m || g.dtype;
                        w.offset = h;
                        w.stride = n;
                        w.divisor = c;
                    }
                }
                k[a] = B(function(a, b) {
                    var c = a.attribCache;
                    if (e in c) return c[e];
                    var d = {
                        isStream: !1
                    };
                    Object.keys(w).forEach(function(a) {
                        d[a] = w[a];
                    });
                    w.buffer && (d.buffer = a.link(w.buffer), d.type = d.type || d.buffer + ".dtype");
                    return c[e] = d;
                });
            });
            Object.keys(e).forEach(function(a) {
                var b = e[a];
                k[a] = M(b, function(a, c) {
                    function d(a) {
                        c(g[a], "=", e, ".", a, "|0;");
                    }
                    var e = a.invoke(c, b), f = a.shared, w = a.constants, k = f.isBufferArgs, f = f.buffer, g = {
                        isStream: c.def(!1)
                    }, L = new da;
                    L.state = 1;
                    Object.keys(L).forEach(function(a) {
                        g[a] = c.def("" + L[a]);
                    });
                    var h = g.buffer, ca = g.type;
                    c("if(", k, "(", e, ")){", g.isStream, "=true;", h, "=", f, ".createStream(", 34962, ",", e, ");", ca, "=", h, ".dtype;", "}else{", h, "=", f, ".getBuffer(", e, ");", "if(", h, "){", ca, "=", h, ".dtype;", '}else if("constant" in ', e, "){", g.state, "=", 2, ";", "if(typeof " + e + '.constant === "number"){', g[Ba[0]], "=", e, ".constant;", Ba.slice(1).map(function(a) {
                        return g[a];
                    }).join("="), "=0;", "}else{", Ba.map(function(a, b) {
                        return g[a] + "=" + e + ".constant.length>" + b + "?" + e + ".constant[" + b + "]:0;";
                    }).join(""), "}}else{", "if(", k, "(", e, ".buffer)){", h, "=", f, ".createStream(", 34962, ",", e, ".buffer);", "}else{", h, "=", f, ".getBuffer(", e, ".buffer);", "}", ca, '="type" in ', e, "?", w.glTypes, "[", e, ".type]:", h, ".dtype;", g.normalized, "=!!", e, ".normalized;");
                    d("size");
                    d("offset");
                    d("stride");
                    d("divisor");
                    c("}}");
                    c.exit("if(", g.isStream, "){", f, ".destroyStream(", h, ");", "}");
                    return g;
                });
            });
            return k;
        }
        function y(a) {
            var b = a["static"], c = a.dynamic, d = {};
            Object.keys(b).forEach(function(a) {
                var c = b[a];
                d[a] = B(function(a, b) {
                    return "number" === typeof c || "boolean" === typeof c ? "" + c : a.link(c);
                });
            });
            Object.keys(c).forEach(function(a) {
                var b = c[a];
                d[a] = M(b, function(a, c) {
                    return a.invoke(c, b);
                });
            });
            return d;
        }
        function S(a, b, d, e, f) {
            function g(a) {
                var b = q[a];
                b && (l[a] = b);
            }
            var h = K(a, b), n = D(a, f), q = H(a, n, f), V = N(a, f), l = E(a, f), p = C(a, f, h);
            g("viewport");
            g(k("scissor.box"));
            var r = 0 < Object.keys(l).length, n = {
                framebuffer: n,
                draw: V,
                shader: p,
                state: l,
                dirty: r,
                scopeVAO: null,
                drawVAO: null,
                useVAO: !1,
                attributes: {}
            };
            n.profile = t(a, f);
            n.uniforms = X(d, f);
            n.drawVAO = n.scopeVAO = V.vao;
            if (!n.drawVAO && p.program && !h && c.angle_instanced_arrays && V["static"].elements) {
                var u = !0;
                a = p.program.attributes.map(function(a) {
                    a = b["static"][a];
                    u = u && !!a;
                    return a;
                });
                if (u && 0 < a.length) {
                    var x = m.getVAO(m.createVAO({
                        attributes: a,
                        elements: V["static"].elements
                    }));
                    n.drawVAO = new I(null, null, null, function(a, b) {
                        return a.link(x);
                    });
                    n.useVAO = !0;
                }
            }
            h ? n.useVAO = !0 : n.attributes = la(b, f);
            n.context = y(e, f);
            return n;
        }
        function ga(a, b, c) {
            var d = a.shared.context, e = a.scope();
            Object.keys(c).forEach(function(f) {
                b.save(d, "." + f);
                var g = c[f].append(a, b);
                Array.isArray(g) ? e(d, ".", f, "=[", g.join(), "];") : e(d, ".", f, "=", g, ";");
            });
            b(e);
        }
        function Q(a, b, c, d) {
            var e = a.shared, f = e.gl, g = e.framebuffer, k;
            Ka && (k = b.def(e.extensions, ".webgl_draw_buffers"));
            var h = a.constants, e = h.drawBuffer, h = h.backBuffer;
            a = c ? c.append(a, b) : b.def(g, ".next");
            d || b("if(", a, "!==", g, ".cur){");
            b("if(", a, "){", f, ".bindFramebuffer(", 36160, ",", a, ".framebuffer);");
            Ka && b(k, ".drawBuffersWEBGL(", e, "[", a, ".colorAttachments.length]);");
            b("}else{", f, ".bindFramebuffer(", 36160, ",null);");
            Ka && b(k, ".drawBuffersWEBGL(", h, ");");
            b("}", g, ".cur=", a, ";");
            d || b("}");
        }
        function ya(a, b, c) {
            var d = a.shared, e = d.gl, f = a.current, g = a.next, h = d.current, n = d.next, q = a.cond(h, ".dirty");
            La.forEach(function(b) {
                b = k(b);
                if (!(b in c.state)) {
                    var d, L;
                    if (b in g) {
                        d = g[b];
                        L = f[b];
                        var l = J(sa[b].length, function(a) {
                            return q.def(d, "[", a, "]");
                        });
                        q(a.cond(l.map(function(a, b) {
                            return a + "!==" + L + "[" + b + "]";
                        }).join("||")).then(e, ".", ua[b], "(", l, ");", l.map(function(a, b) {
                            return L + "[" + b + "]=" + a;
                        }).join(";"), ";"));
                    } else d = q.def(n, ".", b), l = a.cond(d, "!==", h, ".", b), q(l), b in ta ? l(a.cond(d).then(e, ".enable(", ta[b], ");")["else"](e, ".disable(", ta[b], ");"), h, ".", b, "=", d, ";") : l(e, ".", ua[b], "(", d, ");", h, ".", b, "=", d, ";");
                }
            });
            0 === Object.keys(c.state).length && q(h, ".dirty=false;");
            b(q);
        }
        function P(a, b, c, d) {
            var e = a.shared, f = a.current, g = e.current, k = e.gl;
            xb(Object.keys(c)).forEach(function(e) {
                var h = c[e];
                if (!d || d(h)) {
                    var n = h.append(a, b);
                    if (ta[e]) {
                        var l = ta[e];
                        va(h) ? n ? b(k, ".enable(", l, ");") : b(k, ".disable(", l, ");") : b(a.cond(n).then(k, ".enable(", l, ");")["else"](k, ".disable(", l, ");"));
                        b(g, ".", e, "=", n, ";");
                    } else if (pa(n)) {
                        var q = f[e];
                        b(k, ".", ua[e], "(", n, ");", n.map(function(a, b) {
                            return q + "[" + b + "]=" + a;
                        }).join(";"), ";");
                    } else b(k, ".", ua[e], "(", n, ");", g, ".", e, "=", n, ";");
                }
            });
        }
        function O(a, b) {
            T && (a.instancing = b.def(a.shared.extensions, ".angle_instanced_arrays"));
        }
        function G(a, b, c, d, e) {
            function f() {
                return "undefined" === typeof performance ? "Date.now()" : "performance.now()";
            }
            function g(a) {
                r = b.def();
                a(r, "=", f(), ";");
                "string" === typeof e ? a(l, ".count+=", e, ";") : a(l, ".count++;");
                q && (d ? (t = b.def(), a(t, "=", p, ".getNumPendingQueries();")) : a(p, ".beginQuery(", l, ");"));
            }
            function k(a) {
                a(l, ".cpuTime+=", f(), "-", r, ";");
                q && (d ? a(p, ".pushScopeStats(", t, ",", p, ".getNumPendingQueries(),", l, ");") : a(p, ".endQuery();"));
            }
            function h(a) {
                var c = b.def(m, ".profile");
                b(m, ".profile=", a, ";");
                b.exit(m, ".profile=", c, ";");
            }
            var n = a.shared, l = a.stats, m = n.current, p = n.timer;
            c = c.profile;
            var r, t;
            if (c) {
                if (va(c)) {
                    c.enable ? (g(b), k(b.exit), h("true")) : h("false");
                    return;
                }
                c = c.append(a, b);
                h(c);
            } else c = b.def(m, ".profile");
            n = a.block();
            g(n);
            b("if(", c, "){", n, "}");
            a = a.block();
            k(a);
            b.exit("if(", c, "){", a, "}");
        }
        function fa(a, b, c, d, e) {
            function f(a) {
                switch(a){
                    case 35664:
                    case 35667:
                    case 35671:
                        return 2;
                    case 35665:
                    case 35668:
                    case 35672:
                        return 3;
                    case 35666:
                    case 35669:
                    case 35673:
                        return 4;
                    default:
                        return 1;
                }
            }
            function g(c, d, e) {
                function f() {
                    b(n, ".enableVertexAttribArray(", l, ");");
                    var c = e.type, g;
                    g = e.size ? b.def(e.size, "||", d) : d;
                    b(n, ".bindBuffer(", 34962, ",", m, ".buffer);", n, ".vertexAttribPointer(", [
                        l,
                        g,
                        c,
                        e.normalized,
                        e.stride,
                        e.offset
                    ], ");", q, ".type=", c, ";", q, ".size=", g, ";", ca.map(function(a) {
                        return q + "." + a + "=" + e[a] + ";";
                    }).join(""));
                    T && (c = e.divisor, b("if(", q, ".divisor!==", c, "){", a.instancing, ".vertexAttribDivisorANGLE(", [
                        l,
                        c
                    ], ");", q, ".divisor=", c, ";}"));
                }
                function h() {
                    b("if(", q, ".buffer){", n, ".disableVertexAttribArray(", l, ");", q, ".buffer=null;", "}if(", Ba.map(function(a, b) {
                        return q + "." + a + "!==" + p[b];
                    }).join("||"), "){", n, ".vertexAttrib4f(", l, ",", p, ");", Ba.map(function(a, b) {
                        return q + "." + a + "=" + p[b] + ";";
                    }).join(""), "}");
                }
                var n = k.gl, l = b.def(c, ".location"), q = b.def(k.attributes, "[", l, "]");
                c = e.state;
                var m = e.buffer, p = [
                    e.x,
                    e.y,
                    e.z,
                    e.w
                ], ca = [
                    "buffer",
                    "normalized",
                    "offset",
                    "stride"
                ];
                1 === c ? f() : 2 === c ? h() : (b("if(", c, "===", 1, "){"), f(), b("}else{"), h(), b("}"));
            }
            var k = a.shared;
            d.forEach(function(d) {
                var k = d.name, h = c.attributes[k], n;
                if (h) {
                    if (!e(h)) return;
                    n = h.append(a, b);
                } else {
                    if (!e(zb)) return;
                    var l = a.scopeAttrib(k);
                    n = {};
                    Object.keys(new da).forEach(function(a) {
                        n[a] = b.def(l, ".", a);
                    });
                }
                g(a.link(d), f(d.info.type), n);
            });
        }
        function R(a, c, d, e, f, g) {
            for(var k = a.shared, h = k.gl, n = {}, l, q = 0; q < e.length; ++q){
                var p = e[q], m = p.name, r = p.info.type, t = p.info.size, u = d.uniforms[m];
                if (1 < t) {
                    if (!u) continue;
                    var x = m.replace("[0]", "");
                    if (n[x]) continue;
                    n[x] = 1;
                }
                var p = a.link(p) + ".location", v;
                if (u) {
                    if (!f(u)) continue;
                    if (va(u)) {
                        m = u.value;
                        if (35678 === r || 35680 === r) r = a.link(m._texture || m.color[0]._texture), c(h, ".uniform1i(", p, ",", r + ".bind());"), c.exit(r, ".unbind();");
                        else if (35674 === r || 35675 === r || 35676 === r) t = a.global.def("new Float32Array([" + Array.prototype.slice.call(m) + "])"), m = 2, 35675 === r ? m = 3 : 35676 === r && (m = 4), c(h, ".uniformMatrix", m, "fv(", p, ",false,", t, ");");
                        else {
                            switch(r){
                                case 5126:
                                    l = "1f";
                                    break;
                                case 35664:
                                    l = "2f";
                                    break;
                                case 35665:
                                    l = "3f";
                                    break;
                                case 35666:
                                    l = "4f";
                                    break;
                                case 35670:
                                    l = "1i";
                                    break;
                                case 5124:
                                    l = "1i";
                                    break;
                                case 35671:
                                    l = "2i";
                                    break;
                                case 35667:
                                    l = "2i";
                                    break;
                                case 35672:
                                    l = "3i";
                                    break;
                                case 35668:
                                    l = "3i";
                                    break;
                                case 35673:
                                    l = "4i";
                                    break;
                                case 35669:
                                    l = "4i";
                            }
                            1 < t ? (l += "v", m = a.global.def("[" + Array.prototype.slice.call(m) + "]")) : m = pa(m) ? Array.prototype.slice.call(m) : m;
                            c(h, ".uniform", l, "(", p, ",", m, ");");
                        }
                        continue;
                    } else v = u.append(a, c);
                } else {
                    if (!f(zb)) continue;
                    v = c.def(k.uniforms, "[", b.id(m), "]");
                }
                35678 === r ? c("if(", v, "&&", v, '._reglType==="framebuffer"){', v, "=", v, ".color[0];", "}") : 35680 === r && c("if(", v, "&&", v, '._reglType==="framebufferCube"){', v, "=", v, ".color[0];", "}");
                m = 1;
                switch(r){
                    case 35678:
                    case 35680:
                        r = c.def(v, "._texture");
                        c(h, ".uniform1i(", p, ",", r, ".bind());");
                        c.exit(r, ".unbind();");
                        continue;
                    case 5124:
                    case 35670:
                        l = "1i";
                        break;
                    case 35667:
                    case 35671:
                        l = "2i";
                        m = 2;
                        break;
                    case 35668:
                    case 35672:
                        l = "3i";
                        m = 3;
                        break;
                    case 35669:
                    case 35673:
                        l = "4i";
                        m = 4;
                        break;
                    case 5126:
                        l = "1f";
                        break;
                    case 35664:
                        l = "2f";
                        m = 2;
                        break;
                    case 35665:
                        l = "3f";
                        m = 3;
                        break;
                    case 35666:
                        l = "4f";
                        m = 4;
                        break;
                    case 35674:
                        l = "Matrix2fv";
                        break;
                    case 35675:
                        l = "Matrix3fv";
                        break;
                    case 35676:
                        l = "Matrix4fv";
                }
                -1 === l.indexOf("Matrix") && 1 < t && (l += "v", m = 1);
                if ("M" === l.charAt(0)) {
                    c(h, ".uniform", l, "(", p, ",");
                    var p = Math.pow(r - 35674 + 2, 2), z = a.global.def("new Float32Array(", p, ")");
                    Array.isArray(v) ? c("false,(", J(p, function(a) {
                        return z + "[" + a + "]=" + v[a];
                    }), ",", z, ")") : c("false,(Array.isArray(", v, ")||", v, " instanceof Float32Array)?", v, ":(", J(p, function(a) {
                        return z + "[" + a + "]=" + v + "[" + a + "]";
                    }), ",", z, ")");
                    c(");");
                } else {
                    if (1 < m) {
                        for(var r = [], A = [], t = 0; t < m; ++t)Array.isArray(v) ? A.push(v[t]) : A.push(c.def(v + "[" + t + "]")), g && r.push(c.def());
                        g && c("if(!", a.batchId, "||", r.map(function(a, b) {
                            return a + "!==" + A[b];
                        }).join("||"), "){", r.map(function(a, b) {
                            return a + "=" + A[b] + ";";
                        }).join(""));
                        c(h, ".uniform", l, "(", p, ",", A.join(","), ");");
                    } else g && (r = c.def(), c("if(!", a.batchId, "||", r, "!==", v, "){", r, "=", v, ";")), c(h, ".uniform", l, "(", p, ",", v, ");");
                    g && c("}");
                }
            }
        }
        function U(a, b, c, d) {
            function e(f) {
                var g = n[f];
                return g ? g.contextDep && d.contextDynamic || g.propDep ? g.append(a, c) : g.append(a, b) : b.def(l, ".", f);
            }
            function f() {
                function a() {
                    c(u, ".drawElementsInstancedANGLE(", [
                        q,
                        r,
                        v,
                        p + "<<((" + v + "-5121)>>1)",
                        t
                    ], ");");
                }
                function b() {
                    c(u, ".drawArraysInstancedANGLE(", [
                        q,
                        p,
                        r,
                        t
                    ], ");");
                }
                m && "null" !== m ? x ? a() : (c("if(", m, "){"), a(), c("}else{"), b(), c("}")) : b();
            }
            function g() {
                function a() {
                    c(h + ".drawElements(" + [
                        q,
                        r,
                        v,
                        p + "<<((" + v + "-5121)>>1)"
                    ] + ");");
                }
                function b() {
                    c(h + ".drawArrays(" + [
                        q,
                        p,
                        r
                    ] + ");");
                }
                m && "null" !== m ? x ? a() : (c("if(", m, "){"), a(), c("}else{"), b(), c("}")) : b();
            }
            var k = a.shared, h = k.gl, l = k.draw, n = d.draw, m = function() {
                var e = n.elements, f = b;
                if (e) {
                    if (e.contextDep && d.contextDynamic || e.propDep) f = c;
                    e = e.append(a, f);
                    n.elementsActive && f("if(" + e + ")" + h + ".bindBuffer(34963," + e + ".buffer.buffer);");
                } else e = f.def(), f(e, "=", l, ".", "elements", ";", "if(", e, "){", h, ".bindBuffer(", 34963, ",", e, ".buffer.buffer);}", "else if(", k.vao, ".currentVAO){", e, "=", a.shared.elements + ".getElements(" + k.vao, ".currentVAO.elements);", qa ? "" : "if(" + e + ")" + h + ".bindBuffer(34963," + e + ".buffer.buffer);", "}");
                return e;
            }(), q = e("primitive"), p = e("offset"), r = function() {
                var e = n.count, f = b;
                if (e) {
                    if (e.contextDep && d.contextDynamic || e.propDep) f = c;
                    e = e.append(a, f);
                } else e = f.def(l, ".", "count");
                return e;
            }();
            if ("number" === typeof r) {
                if (0 === r) return;
            } else c("if(", r, "){"), c.exit("}");
            var t, u;
            T && (t = e("instances"), u = a.instancing);
            var v = m + ".type", x = n.elements && va(n.elements) && !n.vaoActive;
            T && ("number" !== typeof t || 0 <= t) ? "string" === typeof t ? (c("if(", t, ">0){"), f(), c("}else if(", t, "<0){"), g(), c("}")) : f() : g();
        }
        function ba(a, b, c, d, e) {
            b = A();
            e = b.proc("body", e);
            T && (b.instancing = e.def(b.shared.extensions, ".angle_instanced_arrays"));
            a(b, e, c, d);
            return b.compile().body;
        }
        function W(a, b, c, d) {
            O(a, b);
            c.useVAO ? c.drawVAO ? b(a.shared.vao, ".setVAO(", c.drawVAO.append(a, b), ");") : b(a.shared.vao, ".setVAO(", a.shared.vao, ".targetVAO);") : (b(a.shared.vao, ".setVAO(null);"), fa(a, b, c, d.attributes, function() {
                return !0;
            }));
            R(a, b, c, d.uniforms, function() {
                return !0;
            }, !1);
            U(a, b, b, c);
        }
        function Da(a, b) {
            var c = a.proc("draw", 1);
            O(a, c);
            ga(a, c, b.context);
            Q(a, c, b.framebuffer);
            ya(a, c, b);
            P(a, c, b.state);
            G(a, c, b, !1, !0);
            var d = b.shader.progVar.append(a, c);
            c(a.shared.gl, ".useProgram(", d, ".program);");
            if (b.shader.program) W(a, c, b, b.shader.program);
            else {
                c(a.shared.vao, ".setVAO(null);");
                var e = a.global.def("{}"), f = c.def(d, ".id"), g = c.def(e, "[", f, "]");
                c(a.cond(g).then(g, ".call(this,a0);")["else"](g, "=", e, "[", f, "]=", a.link(function(c) {
                    return ba(W, a, b, c, 1);
                }), "(", d, ");", g, ".call(this,a0);"));
            }
            0 < Object.keys(b.state).length && c(a.shared.current, ".dirty=true;");
            a.shared.vao && c(a.shared.vao, ".setVAO(null);");
        }
        function ma(a, b, c, d) {
            function e() {
                return !0;
            }
            a.batchId = "a1";
            O(a, b);
            fa(a, b, c, d.attributes, e);
            R(a, b, c, d.uniforms, e, !1);
            U(a, b, b, c);
        }
        function na(a, b, c, d) {
            function e(a) {
                return a.contextDep && g || a.propDep;
            }
            function f(a) {
                return !e(a);
            }
            O(a, b);
            var g = c.contextDep, k = b.def(), h = b.def();
            a.shared.props = h;
            a.batchId = k;
            var n = a.scope(), l = a.scope();
            b(n.entry, "for(", k, "=0;", k, "<", "a1", ";++", k, "){", h, "=", "a0", "[", k, "];", l, "}", n.exit);
            c.needsContext && ga(a, l, c.context);
            c.needsFramebuffer && Q(a, l, c.framebuffer);
            P(a, l, c.state, e);
            c.profile && e(c.profile) && G(a, l, c, !1, !0);
            d ? (c.useVAO ? c.drawVAO ? e(c.drawVAO) ? l(a.shared.vao, ".setVAO(", c.drawVAO.append(a, l), ");") : n(a.shared.vao, ".setVAO(", c.drawVAO.append(a, n), ");") : n(a.shared.vao, ".setVAO(", a.shared.vao, ".targetVAO);") : (n(a.shared.vao, ".setVAO(null);"), fa(a, n, c, d.attributes, f), fa(a, l, c, d.attributes, e)), R(a, n, c, d.uniforms, f, !1), R(a, l, c, d.uniforms, e, !0), U(a, n, l, c)) : (b = a.global.def("{}"), d = c.shader.progVar.append(a, l), h = l.def(d, ".id"), n = l.def(b, "[", h, "]"), l(a.shared.gl, ".useProgram(", d, ".program);", "if(!", n, "){", n, "=", b, "[", h, "]=", a.link(function(b) {
                return ba(ma, a, c, b, 2);
            }), "(", d, ");}", n, ".call(this,a0[", k, "],", k, ");"));
        }
        function x(a, b) {
            function c(a) {
                return a.contextDep && e || a.propDep;
            }
            var d = a.proc("batch", 2);
            a.batchId = "0";
            O(a, d);
            var e = !1, f = !0;
            Object.keys(b.context).forEach(function(a) {
                e = e || b.context[a].propDep;
            });
            e || (ga(a, d, b.context), f = !1);
            var g = b.framebuffer, k = !1;
            g ? (g.propDep ? e = k = !0 : g.contextDep && e && (k = !0), k || Q(a, d, g)) : Q(a, d, null);
            b.state.viewport && b.state.viewport.propDep && (e = !0);
            ya(a, d, b);
            P(a, d, b.state, function(a) {
                return !c(a);
            });
            b.profile && c(b.profile) || G(a, d, b, !1, "a1");
            b.contextDep = e;
            b.needsContext = f;
            b.needsFramebuffer = k;
            f = b.shader.progVar;
            if (f.contextDep && e || f.propDep) na(a, d, b, null);
            else if (f = f.append(a, d), d(a.shared.gl, ".useProgram(", f, ".program);"), b.shader.program) na(a, d, b, b.shader.program);
            else {
                d(a.shared.vao, ".setVAO(null);");
                var g = a.global.def("{}"), k = d.def(f, ".id"), h = d.def(g, "[", k, "]");
                d(a.cond(h).then(h, ".call(this,a0,a1);")["else"](h, "=", g, "[", k, "]=", a.link(function(c) {
                    return ba(na, a, b, c, 2);
                }), "(", f, ");", h, ".call(this,a0,a1);"));
            }
            0 < Object.keys(b.state).length && d(a.shared.current, ".dirty=true;");
            a.shared.vao && d(a.shared.vao, ".setVAO(null);");
        }
        function aa(a, c) {
            function d(b) {
                var g = c.shader[b];
                g && e.set(f.shader, "." + b, g.append(a, e));
            }
            var e = a.proc("scope", 3);
            a.batchId = "a2";
            var f = a.shared, g = f.current;
            ga(a, e, c.context);
            c.framebuffer && c.framebuffer.append(a, e);
            xb(Object.keys(c.state)).forEach(function(b) {
                var d = c.state[b].append(a, e);
                pa(d) ? d.forEach(function(c, d) {
                    e.set(a.next[b], "[" + d + "]", c);
                }) : e.set(f.next, "." + b, d);
            });
            G(a, e, c, !0, !0);
            [
                "elements",
                "offset",
                "count",
                "instances",
                "primitive"
            ].forEach(function(b) {
                var d = c.draw[b];
                d && e.set(f.draw, "." + b, "" + d.append(a, e));
            });
            Object.keys(c.uniforms).forEach(function(d) {
                var g = c.uniforms[d].append(a, e);
                Array.isArray(g) && (g = "[" + g.join() + "]");
                e.set(f.uniforms, "[" + b.id(d) + "]", g);
            });
            Object.keys(c.attributes).forEach(function(b) {
                var d = c.attributes[b].append(a, e), f = a.scopeAttrib(b);
                Object.keys(new da).forEach(function(a) {
                    e.set(f, "." + a, d[a]);
                });
            });
            c.scopeVAO && e.set(f.vao, ".targetVAO", c.scopeVAO.append(a, e));
            d("vert");
            d("frag");
            0 < Object.keys(c.state).length && (e(g, ".dirty=true;"), e.exit(g, ".dirty=true;"));
            e("a1(", a.shared.context, ",a0,", a.batchId, ");");
        }
        function ia(a) {
            if ("object" === typeof a && !pa(a)) {
                for(var b = Object.keys(a), c = 0; c < b.length; ++c)if (Z.isDynamic(a[b[c]])) return !0;
                return !1;
            }
        }
        function ha(a, b, c) {
            function d(a, b) {
                g.forEach(function(c) {
                    var d = e[c];
                    Z.isDynamic(d) && (d = a.invoke(b, d), b(l, ".", c, "=", d, ";"));
                });
            }
            var e = b["static"][c];
            if (e && ia(e)) {
                var f = a.global, g = Object.keys(e), k = !1, h = !1, n = !1, l = a.global.def("{}");
                g.forEach(function(b) {
                    var c = e[b];
                    if (Z.isDynamic(c)) "function" === typeof c && (c = e[b] = Z.unbox(c)), b = M(c, null), k = k || b.thisDep, n = n || b.propDep, h = h || b.contextDep;
                    else {
                        f(l, ".", b, "=");
                        switch(typeof c){
                            case "number":
                                f(c);
                                break;
                            case "string":
                                f('"', c, '"');
                                break;
                            case "object":
                                Array.isArray(c) && f("[", c.join(), "]");
                                break;
                            default:
                                f(a.link(c));
                        }
                        f(";");
                    }
                });
                b.dynamic[c] = new Z.DynamicVariable(4, {
                    thisDep: k,
                    contextDep: h,
                    propDep: n,
                    ref: l,
                    append: d
                });
                delete b["static"][c];
            }
        }
        var da = m.Record, ea = {
            add: 32774,
            subtract: 32778,
            "reverse subtract": 32779
        };
        c.ext_blend_minmax && (ea.min = 32775, ea.max = 32776);
        var T = c.angle_instanced_arrays, Ka = c.webgl_draw_buffers, qa = c.oes_vertex_array_object, sa = {
            dirty: !0,
            profile: g.profile
        }, Ca = {}, La = [], ta = {}, ua = {};
        h("dither", 3024);
        h("blend.enable", 3042);
        l("blend.color", "blendColor", [
            0,
            0,
            0,
            0
        ]);
        l("blend.equation", "blendEquationSeparate", [
            32774,
            32774
        ]);
        l("blend.func", "blendFuncSeparate", [
            1,
            0,
            1,
            0
        ]);
        h("depth.enable", 2929, !0);
        l("depth.func", "depthFunc", 513);
        l("depth.range", "depthRange", [
            0,
            1
        ]);
        l("depth.mask", "depthMask", !0);
        l("colorMask", "colorMask", [
            !0,
            !0,
            !0,
            !0
        ]);
        h("cull.enable", 2884);
        l("cull.face", "cullFace", 1029);
        l("frontFace", "frontFace", 2305);
        l("lineWidth", "lineWidth", 1);
        h("polygonOffset.enable", 32823);
        l("polygonOffset.offset", "polygonOffset", [
            0,
            0
        ]);
        h("sample.alpha", 32926);
        h("sample.enable", 32928);
        l("sample.coverage", "sampleCoverage", [
            1,
            !1
        ]);
        h("stencil.enable", 2960);
        l("stencil.mask", "stencilMask", -1);
        l("stencil.func", "stencilFunc", [
            519,
            0,
            -1
        ]);
        l("stencil.opFront", "stencilOpSeparate", [
            1028,
            7680,
            7680,
            7680
        ]);
        l("stencil.opBack", "stencilOpSeparate", [
            1029,
            7680,
            7680,
            7680
        ]);
        h("scissor.enable", 3089);
        l("scissor.box", "scissor", [
            0,
            0,
            a.drawingBufferWidth,
            a.drawingBufferHeight
        ]);
        l("viewport", "viewport", [
            0,
            0,
            a.drawingBufferWidth,
            a.drawingBufferHeight
        ]);
        var rb = {
            gl: a,
            context: z,
            strings: b,
            next: Ca,
            current: sa,
            draw: n,
            elements: d,
            buffer: f,
            shader: u,
            attributes: m.state,
            vao: m,
            uniforms: v,
            framebuffer: r,
            extensions: c,
            timer: q,
            isBufferArgs: Qa
        }, Na = {
            primTypes: Ia,
            compareFuncs: Za,
            blendFuncs: Ea,
            blendEquations: ea,
            stencilOps: Ra,
            glTypes: Ha,
            orientationType: yb
        };
        Ka && (Na.backBuffer = [
            1029
        ], Na.drawBuffer = J(e.maxDrawbuffers, function(a) {
            return 0 === a ? [
                0
            ] : J(a, function(a) {
                return 36064 + a;
            });
        }));
        var ra = 0;
        return {
            next: Ca,
            current: sa,
            procs: function() {
                var a = A(), b = a.proc("poll"), d = a.proc("refresh"), f = a.block();
                b(f);
                d(f);
                var g = a.shared, k = g.gl, h = g.next, n = g.current;
                f(n, ".dirty=false;");
                Q(a, b);
                Q(a, d, null, !0);
                var l;
                T && (l = a.link(T));
                c.oes_vertex_array_object && d(a.link(c.oes_vertex_array_object), ".bindVertexArrayOES(null);");
                for(var m = 0; m < e.maxAttributes; ++m){
                    var q = d.def(g.attributes, "[", m, "]"), p = a.cond(q, ".buffer");
                    p.then(k, ".enableVertexAttribArray(", m, ");", k, ".bindBuffer(", 34962, ",", q, ".buffer.buffer);", k, ".vertexAttribPointer(", m, ",", q, ".size,", q, ".type,", q, ".normalized,", q, ".stride,", q, ".offset);")["else"](k, ".disableVertexAttribArray(", m, ");", k, ".vertexAttrib4f(", m, ",", q, ".x,", q, ".y,", q, ".z,", q, ".w);", q, ".buffer=null;");
                    d(p);
                    T && d(l, ".vertexAttribDivisorANGLE(", m, ",", q, ".divisor);");
                }
                d(a.shared.vao, ".currentVAO=null;", a.shared.vao, ".setVAO(", a.shared.vao, ".targetVAO);");
                Object.keys(ta).forEach(function(c) {
                    var e = ta[c], g = f.def(h, ".", c), l = a.block();
                    l("if(", g, "){", k, ".enable(", e, ")}else{", k, ".disable(", e, ")}", n, ".", c, "=", g, ";");
                    d(l);
                    b("if(", g, "!==", n, ".", c, "){", l, "}");
                });
                Object.keys(ua).forEach(function(c) {
                    var e = ua[c], g = sa[c], l, m, q = a.block();
                    q(k, ".", e, "(");
                    pa(g) ? (e = g.length, l = a.global.def(h, ".", c), m = a.global.def(n, ".", c), q(J(e, function(a) {
                        return l + "[" + a + "]";
                    }), ");", J(e, function(a) {
                        return m + "[" + a + "]=" + l + "[" + a + "];";
                    }).join("")), b("if(", J(e, function(a) {
                        return l + "[" + a + "]!==" + m + "[" + a + "]";
                    }).join("||"), "){", q, "}")) : (l = f.def(h, ".", c), m = f.def(n, ".", c), q(l, ");", n, ".", c, "=", l, ";"), b("if(", l, "!==", m, "){", q, "}"));
                    d(q);
                });
                return a.compile();
            }(),
            compile: function(a, b, c, d, e) {
                var f = A();
                f.stats = f.link(e);
                Object.keys(b["static"]).forEach(function(a) {
                    ha(f, b, a);
                });
                Xb.forEach(function(b) {
                    ha(f, a, b);
                });
                var g = S(a, b, c, d, f);
                Da(f, g);
                aa(f, g);
                x(f, g);
                return F(f.compile(), {
                    destroy: function() {
                        g.shader.program.destroy();
                    }
                });
            }
        };
    }
    function Ab(a, b) {
        for(var c = 0; c < a.length; ++c)if (a[c] === b) return c;
        return -1;
    }
    var F = function(a, b) {
        for(var c = Object.keys(b), e = 0; e < c.length; ++e)a[c[e]] = b[c[e]];
        return a;
    }, Cb = 0, Z = {
        DynamicVariable: U,
        define: function(a, b) {
            return new U(a, ab(b + ""));
        },
        isDynamic: function(a) {
            return "function" === typeof a && !a._reglType || a instanceof U;
        },
        unbox: bb,
        accessor: ab
    }, $a = {
        next: "function" === typeof requestAnimationFrame ? function(a) {
            return requestAnimationFrame(a);
        } : function(a) {
            return setTimeout(a, 16);
        },
        cancel: "function" === typeof cancelAnimationFrame ? function(a) {
            return cancelAnimationFrame(a);
        } : clearTimeout
    }, Bb = "undefined" !== typeof performance && performance.now ? function() {
        return performance.now();
    } : function() {
        return +new Date;
    }, D = fb();
    D.zero = fb();
    var Yb = function(a, b) {
        var c = 1;
        b.ext_texture_filter_anisotropic && (c = a.getParameter(34047));
        var e = 1, f = 1;
        b.webgl_draw_buffers && (e = a.getParameter(34852), f = a.getParameter(36063));
        var d = !!b.oes_texture_float;
        if (d) {
            d = a.createTexture();
            a.bindTexture(3553, d);
            a.texImage2D(3553, 0, 6408, 1, 1, 0, 6408, 5126, null);
            var p = a.createFramebuffer();
            a.bindFramebuffer(36160, p);
            a.framebufferTexture2D(36160, 36064, 3553, d, 0);
            a.bindTexture(3553, null);
            if (36053 !== a.checkFramebufferStatus(36160)) d = !1;
            else {
                a.viewport(0, 0, 1, 1);
                a.clearColor(1, 0, 0, 1);
                a.clear(16384);
                var r = D.allocType(5126, 4);
                a.readPixels(0, 0, 1, 1, 6408, 5126, r);
                a.getError() ? d = !1 : (a.deleteFramebuffer(p), a.deleteTexture(d), d = 1 === r[0]);
                D.freeType(r);
            }
        }
        r = !0;
        "undefined" !== typeof navigator && (/MSIE/.test(navigator.userAgent) || /Trident\//.test(navigator.appVersion) || /Edge/.test(navigator.userAgent)) || (r = a.createTexture(), p = D.allocType(5121, 36), a.activeTexture(33984), a.bindTexture(34067, r), a.texImage2D(34069, 0, 6408, 3, 3, 0, 6408, 5121, p), D.freeType(p), a.bindTexture(34067, null), a.deleteTexture(r), r = !a.getError());
        return {
            colorBits: [
                a.getParameter(3410),
                a.getParameter(3411),
                a.getParameter(3412),
                a.getParameter(3413)
            ],
            depthBits: a.getParameter(3414),
            stencilBits: a.getParameter(3415),
            subpixelBits: a.getParameter(3408),
            extensions: Object.keys(b).filter(function(a) {
                return !!b[a];
            }),
            maxAnisotropic: c,
            maxDrawbuffers: e,
            maxColorAttachments: f,
            pointSizeDims: a.getParameter(33901),
            lineWidthDims: a.getParameter(33902),
            maxViewportDims: a.getParameter(3386),
            maxCombinedTextureUnits: a.getParameter(35661),
            maxCubeMapSize: a.getParameter(34076),
            maxRenderbufferSize: a.getParameter(34024),
            maxTextureUnits: a.getParameter(34930),
            maxTextureSize: a.getParameter(3379),
            maxAttributes: a.getParameter(34921),
            maxVertexUniforms: a.getParameter(36347),
            maxVertexTextureUnits: a.getParameter(35660),
            maxVaryingVectors: a.getParameter(36348),
            maxFragmentUniforms: a.getParameter(36349),
            glsl: a.getParameter(35724),
            renderer: a.getParameter(7937),
            vendor: a.getParameter(7936),
            version: a.getParameter(7938),
            readFloat: d,
            npotTextureCube: r
        };
    }, K = function(a) {
        return a instanceof Uint8Array || a instanceof Uint16Array || a instanceof Uint32Array || a instanceof Int8Array || a instanceof Int16Array || a instanceof Int32Array || a instanceof Float32Array || a instanceof Float64Array || a instanceof Uint8ClampedArray;
    }, S = function(a) {
        return Object.keys(a).map(function(b) {
            return a[b];
        });
    }, Oa = {
        shape: function(a) {
            for(var b = []; a.length; a = a[0])b.push(a.length);
            return b;
        },
        flatten: function(a, b, c, e) {
            var f = 1;
            if (b.length) for(var d = 0; d < b.length; ++d)f *= b[d];
            else f = 0;
            c = e || D.allocType(c, f);
            switch(b.length){
                case 0:
                    break;
                case 1:
                    e = b[0];
                    for(b = 0; b < e; ++b)c[b] = a[b];
                    break;
                case 2:
                    e = b[0];
                    b = b[1];
                    for(d = f = 0; d < e; ++d)for(var p = a[d], r = 0; r < b; ++r)c[f++] = p[r];
                    break;
                case 3:
                    gb(a, b[0], b[1], b[2], c, 0);
                    break;
                default:
                    hb(a, b, 0, c, 0);
            }
            return c;
        }
    }, Ga = {
        "[object Int8Array]": 5120,
        "[object Int16Array]": 5122,
        "[object Int32Array]": 5124,
        "[object Uint8Array]": 5121,
        "[object Uint8ClampedArray]": 5121,
        "[object Uint16Array]": 5123,
        "[object Uint32Array]": 5125,
        "[object Float32Array]": 5126,
        "[object Float64Array]": 5121,
        "[object ArrayBuffer]": 5121
    }, Ha = {
        int8: 5120,
        int16: 5122,
        int32: 5124,
        uint8: 5121,
        uint16: 5123,
        uint32: 5125,
        "float": 5126,
        float32: 5126
    }, lb = {
        dynamic: 35048,
        stream: 35040,
        "static": 35044
    }, Sa = Oa.flatten, kb = Oa.shape, ha = [];
    ha[5120] = 1;
    ha[5122] = 2;
    ha[5124] = 4;
    ha[5121] = 1;
    ha[5123] = 2;
    ha[5125] = 4;
    ha[5126] = 4;
    var Ia = {
        points: 0,
        point: 0,
        lines: 1,
        line: 1,
        triangles: 4,
        triangle: 4,
        "line loop": 2,
        "line strip": 3,
        "triangle strip": 5,
        "triangle fan": 6
    }, nb = new Float32Array(1), Kb = new Uint32Array(nb.buffer), Ob = [
        9984,
        9986,
        9985,
        9987
    ], Ma = [
        0,
        6409,
        6410,
        6407,
        6408
    ], R = {};
    R[6409] = R[6406] = R[6402] = 1;
    R[34041] = R[6410] = 2;
    R[6407] = R[35904] = 3;
    R[6408] = R[35906] = 4;
    var Va = qa("HTMLCanvasElement"), Wa = qa("OffscreenCanvas"), sb = qa("CanvasRenderingContext2D"), tb = qa("ImageBitmap"), ub = qa("HTMLImageElement"), vb = qa("HTMLVideoElement"), Lb = Object.keys(Ga).concat([
        Va,
        Wa,
        sb,
        tb,
        ub,
        vb
    ]), ra = [];
    ra[5121] = 1;
    ra[5126] = 4;
    ra[36193] = 2;
    ra[5123] = 2;
    ra[5125] = 4;
    var H = [];
    H[32854] = 2;
    H[32855] = 2;
    H[36194] = 2;
    H[34041] = 4;
    H[33776] = .5;
    H[33777] = .5;
    H[33778] = 1;
    H[33779] = 1;
    H[35986] = .5;
    H[35987] = 1;
    H[34798] = 1;
    H[35840] = .5;
    H[35841] = .25;
    H[35842] = .5;
    H[35843] = .25;
    H[36196] = .5;
    var P = [];
    P[32854] = 2;
    P[32855] = 2;
    P[36194] = 2;
    P[33189] = 2;
    P[36168] = 1;
    P[34041] = 4;
    P[35056] = 4;
    P[35907] = 4;
    P[34836] = 16;
    P[34842] = 8;
    P[34843] = 6;
    var Zb = function(a, b, c, e, f) {
        function d(a) {
            this.id = m++;
            this.refCount = 1;
            this.renderbuffer = a;
            this.format = 32854;
            this.height = this.width = 0;
            f.profile && (this.stats = {
                size: 0
            });
        }
        function p(b) {
            var c = b.renderbuffer;
            a.bindRenderbuffer(36161, null);
            a.deleteRenderbuffer(c);
            b.renderbuffer = null;
            b.refCount = 0;
            delete u[b.id];
            e.renderbufferCount--;
        }
        var r = {
            rgba4: 32854,
            rgba8: 32856,
            rgb565: 36194,
            "rgb5 a1": 32855,
            depth: 33189,
            stencil: 36168,
            "depth stencil": 34041,
            "depth24 stencil8": 35056
        };
        b.ext_srgb && (r.srgba = 35907);
        b.ext_color_buffer_half_float && (r.rgba16f = 34842, r.rgb16f = 34843);
        b.webgl_color_buffer_float && (r.rgba32f = 34836);
        var v = [];
        Object.keys(r).forEach(function(a) {
            v[r[a]] = a;
        });
        var m = 0, u = {};
        d.prototype.decRef = function() {
            0 >= --this.refCount && p(this);
        };
        f.profile && (e.getTotalRenderbufferSize = function() {
            var a = 0;
            Object.keys(u).forEach(function(b) {
                a += u[b].stats.size;
            });
            return a;
        });
        return {
            create: function(b, c) {
                function m(b, c) {
                    var d = 0, e = 0, n = 32854, p = 0;
                    "object" === typeof b && b ? ("shape" in b ? (e = b.shape, d = e[0] | 0, e = e[1] | 0) : ("radius" in b && (d = e = b.radius | 0), "width" in b && (d = b.width | 0), "height" in b && (e = b.height | 0)), "format" in b && (n = r[b.format]), "samples" in b && (p = b.samples)) : "number" === typeof b ? (d = b | 0, e = "number" === typeof c ? c | 0 : d) : b || (d = e = 1);
                    if (d !== g.width || e !== g.height || n !== g.format) return m.width = g.width = d, m.height = g.height = e, m.samples = p, g.format = n, g.samples = p, a.bindRenderbuffer(36161, g.renderbuffer), p && a.renderbufferStorageMultisample ? a.renderbufferStorageMultisample(36161, p, n, d, e) : a.renderbufferStorage(36161, n, d, e), f.profile && (g.stats.size = P[g.format] * g.width * g.height), m.format = v[g.format], m;
                }
                var g = new d(a.createRenderbuffer());
                u[g.id] = g;
                e.renderbufferCount++;
                m(b, c);
                m.resize = function(b, c) {
                    var d = b | 0, e = c | 0 || d;
                    if (d === g.width && e === g.height) return m;
                    m.width = g.width = d;
                    m.height = g.height = e;
                    var n = m.samples;
                    a.bindRenderbuffer(36161, g.renderbuffer);
                    n && a.renderbufferStorageMultisample ? a.renderbufferStorageMultisample(36161, n, g.format, d, e) : a.renderbufferStorage(36161, g.format, d, e);
                    f.profile && (g.stats.size = P[g.format] * g.width * g.height);
                    return m;
                };
                m._reglType = "renderbuffer";
                m._renderbuffer = g;
                f.profile && (m.stats = g.stats);
                m.destroy = function() {
                    g.decRef();
                };
                return m;
            },
            clear: function() {
                S(u).forEach(p);
            },
            restore: function() {
                S(u).forEach(function(b) {
                    b.renderbuffer = a.createRenderbuffer();
                    a.bindRenderbuffer(36161, b.renderbuffer);
                    b.samples && a.renderbufferStorageMultisample ? a.renderbufferStorageMultisample(36161, b.samples, b.format, b.width, b.height) : a.renderbufferStorage(36161, b.format, b.width, b.height);
                });
                a.bindRenderbuffer(36161, null);
            }
        };
    }, Xa = [];
    Xa[6408] = 4;
    Xa[6407] = 3;
    var Pa = [];
    Pa[5121] = 1;
    Pa[5126] = 4;
    Pa[36193] = 2;
    var Ba = [
        "x",
        "y",
        "z",
        "w"
    ], Xb = "blend.func blend.equation stencil.func stencil.opFront stencil.opBack sample.coverage viewport scissor.box polygonOffset.offset".split(" "), Ea = {
        0: 0,
        1: 1,
        zero: 0,
        one: 1,
        "src color": 768,
        "one minus src color": 769,
        "src alpha": 770,
        "one minus src alpha": 771,
        "dst color": 774,
        "one minus dst color": 775,
        "dst alpha": 772,
        "one minus dst alpha": 773,
        "constant color": 32769,
        "one minus constant color": 32770,
        "constant alpha": 32771,
        "one minus constant alpha": 32772,
        "src alpha saturate": 776
    }, Za = {
        never: 512,
        less: 513,
        "<": 513,
        equal: 514,
        "=": 514,
        "==": 514,
        "===": 514,
        lequal: 515,
        "<=": 515,
        greater: 516,
        ">": 516,
        notequal: 517,
        "!=": 517,
        "!==": 517,
        gequal: 518,
        ">=": 518,
        always: 519
    }, Ra = {
        0: 0,
        zero: 0,
        keep: 7680,
        replace: 7681,
        increment: 7682,
        decrement: 7683,
        "increment wrap": 34055,
        "decrement wrap": 34056,
        invert: 5386
    }, yb = {
        cw: 2304,
        ccw: 2305
    }, zb = new I(!1, !1, !1, function() {}), $b = function(a, b) {
        function c() {
            this.endQueryIndex = this.startQueryIndex = -1;
            this.sum = 0;
            this.stats = null;
        }
        function e(a, b, d) {
            var e = p.pop() || new c;
            e.startQueryIndex = a;
            e.endQueryIndex = b;
            e.sum = 0;
            e.stats = d;
            r.push(e);
        }
        if (!b.ext_disjoint_timer_query) return null;
        var f = [], d = [], p = [], r = [], v = [], m = [];
        return {
            beginQuery: function(a) {
                var c = f.pop() || b.ext_disjoint_timer_query.createQueryEXT();
                b.ext_disjoint_timer_query.beginQueryEXT(35007, c);
                d.push(c);
                e(d.length - 1, d.length, a);
            },
            endQuery: function() {
                b.ext_disjoint_timer_query.endQueryEXT(35007);
            },
            pushScopeStats: e,
            update: function() {
                var a, c;
                a = d.length;
                if (0 !== a) {
                    m.length = Math.max(m.length, a + 1);
                    v.length = Math.max(v.length, a + 1);
                    v[0] = 0;
                    var e = m[0] = 0;
                    for(c = a = 0; c < d.length; ++c){
                        var q = d[c];
                        b.ext_disjoint_timer_query.getQueryObjectEXT(q, 34919) ? (e += b.ext_disjoint_timer_query.getQueryObjectEXT(q, 34918), f.push(q)) : d[a++] = q;
                        v[c + 1] = e;
                        m[c + 1] = a;
                    }
                    d.length = a;
                    for(c = a = 0; c < r.length; ++c){
                        var e = r[c], g = e.startQueryIndex, q = e.endQueryIndex;
                        e.sum += v[q] - v[g];
                        g = m[g];
                        q = m[q];
                        q === g ? (e.stats.gpuTime += e.sum / 1E6, p.push(e)) : (e.startQueryIndex = g, e.endQueryIndex = q, r[a++] = e);
                    }
                    r.length = a;
                }
            },
            getNumPendingQueries: function() {
                return d.length;
            },
            clear: function() {
                f.push.apply(f, d);
                for(var a = 0; a < f.length; a++)b.ext_disjoint_timer_query.deleteQueryEXT(f[a]);
                d.length = 0;
                f.length = 0;
            },
            restore: function() {
                d.length = 0;
                f.length = 0;
            }
        };
    };
    return function(a) {
        function b() {
            if (0 === G.length) t && t.update(), ba = null;
            else {
                ba = $a.next(b);
                u();
                for(var a = G.length - 1; 0 <= a; --a){
                    var c = G[a];
                    c && c(C, null, 0);
                }
                q.flush();
                t && t.update();
            }
        }
        function c() {
            !ba && 0 < G.length && (ba = $a.next(b));
        }
        function e() {
            ba && ($a.cancel(b), ba = null);
        }
        function f(a) {
            a.preventDefault();
            e();
            S.forEach(function(a) {
                a();
            });
        }
        function d(a) {
            q.getError();
            k.restore();
            y.restore();
            E.restore();
            K.restore();
            P.restore();
            Q.restore();
            M.restore();
            t && t.restore();
            J.procs.refresh();
            c();
            U.forEach(function(a) {
                a();
            });
        }
        function p(a) {
            function b(a, c) {
                var d = {}, e = {};
                Object.keys(a).forEach(function(b) {
                    var f = a[b];
                    if (Z.isDynamic(f)) e[b] = Z.unbox(f, b);
                    else {
                        if (c && Array.isArray(f)) {
                            for(var g = 0; g < f.length; ++g)if (Z.isDynamic(f[g])) {
                                e[b] = Z.unbox(f, b);
                                return;
                            }
                        }
                        d[b] = f;
                    }
                });
                return {
                    dynamic: e,
                    "static": d
                };
            }
            function c(a) {
                for(; n.length < a;)n.push(null);
                return n;
            }
            var d = b(a.context || {}, !0), e = b(a.uniforms || {}, !0), f = b(a.attributes || {}, !1);
            a = b(function(a) {
                function b(a) {
                    if (a in c) {
                        var d = c[a];
                        delete c[a];
                        Object.keys(d).forEach(function(b) {
                            c[a + "." + b] = d[b];
                        });
                    }
                }
                var c = F({}, a);
                delete c.uniforms;
                delete c.attributes;
                delete c.context;
                delete c.vao;
                "stencil" in c && c.stencil.op && (c.stencil.opBack = c.stencil.opFront = c.stencil.op, delete c.stencil.op);
                b("blend");
                b("depth");
                b("cull");
                b("stencil");
                b("polygonOffset");
                b("scissor");
                b("sample");
                "vao" in a && (c.vao = a.vao);
                return c;
            }(a), !1);
            var g = {
                gpuTime: 0,
                cpuTime: 0,
                count: 0
            }, h = J.compile(a, f, e, d, g), k = h.draw, l = h.batch, m = h.scope, n = [];
            return F(function(a, b) {
                var d;
                if ("function" === typeof a) return m.call(this, null, a, 0);
                if ("function" === typeof b) {
                    if ("number" === typeof a) for(d = 0; d < a; ++d)m.call(this, null, b, d);
                    else if (Array.isArray(a)) for(d = 0; d < a.length; ++d)m.call(this, a[d], b, d);
                    else return m.call(this, a, b, 0);
                } else if ("number" === typeof a) {
                    if (0 < a) return l.call(this, c(a | 0), a | 0);
                } else if (Array.isArray(a)) {
                    if (a.length) return l.call(this, a, a.length);
                } else return k.call(this, a);
            }, {
                stats: g,
                destroy: function() {
                    h.destroy();
                }
            });
        }
        function r(a, b) {
            var c = 0;
            J.procs.poll();
            var d = b.color;
            d && (q.clearColor(+d[0] || 0, +d[1] || 0, +d[2] || 0, +d[3] || 0), c |= 16384);
            "depth" in b && (q.clearDepth(+b.depth), c |= 256);
            "stencil" in b && (q.clearStencil(b.stencil | 0), c |= 1024);
            q.clear(c);
        }
        function v(a) {
            G.push(a);
            c();
            return {
                cancel: function() {
                    function b() {
                        var a = Ab(G, b);
                        G[a] = G[G.length - 1];
                        --G.length;
                        0 >= G.length && e();
                    }
                    var c = Ab(G, a);
                    G[c] = b;
                }
            };
        }
        function m() {
            var a = R.viewport, b = R.scissor_box;
            a[0] = a[1] = b[0] = b[1] = 0;
            C.viewportWidth = C.framebufferWidth = C.drawingBufferWidth = a[2] = b[2] = q.drawingBufferWidth;
            C.viewportHeight = C.framebufferHeight = C.drawingBufferHeight = a[3] = b[3] = q.drawingBufferHeight;
        }
        function u() {
            C.tick += 1;
            C.time = z();
            m();
            J.procs.poll();
        }
        function n() {
            K.refresh();
            m();
            J.procs.refresh();
            t && t.update();
        }
        function z() {
            return (Bb() - B) / 1E3;
        }
        a = Gb(a);
        if (!a) return null;
        var q = a.gl, g = q.getContextAttributes();
        q.isContextLost();
        var k = Hb(q, a);
        if (!k) return null;
        var h = Db(), l = {
            vaoCount: 0,
            bufferCount: 0,
            elementsCount: 0,
            framebufferCount: 0,
            shaderCount: 0,
            textureCount: 0,
            cubeCount: 0,
            renderbufferCount: 0,
            maxTextureUnits: 0
        }, A = k.extensions, t = $b(q, A), B = Bb(), D = q.drawingBufferWidth, H = q.drawingBufferHeight, C = {
            tick: 0,
            time: 0,
            viewportWidth: D,
            viewportHeight: H,
            framebufferWidth: D,
            framebufferHeight: H,
            drawingBufferWidth: D,
            drawingBufferHeight: H,
            pixelRatio: a.pixelRatio
        }, D = {
            elements: null,
            primitive: 4,
            count: -1,
            offset: 0,
            instances: -1
        }, N = Yb(q, A), E = Ib(q, l, a, function(a) {
            return M.destroyBuffer(a);
        }), I = Jb(q, A, E, l), M = Rb(q, A, N, l, E, I, D), y = Sb(q, h, l, a), K = Mb(q, A, N, function() {
            J.procs.poll();
        }, C, l, a), P = Zb(q, A, N, l, a), Q = Qb(q, A, N, K, P, l), J = Vb(q, h, A, N, E, I, K, Q, {}, M, y, D, C, t, a), h = Tb(q, Q, J.procs.poll, C, g, A, N), R = J.next, O = q.canvas, G = [], S = [], U = [], W = [
            a.onDestroy
        ], ba = null;
        O && (O.addEventListener("webglcontextlost", f, !1), O.addEventListener("webglcontextrestored", d, !1));
        var aa = Q.setFBO = p({
            framebuffer: Z.define.call(null, 1, "framebuffer")
        });
        n();
        g = F(p, {
            clear: function(a) {
                if ("framebuffer" in a) {
                    if (a.framebuffer && "framebufferCube" === a.framebuffer_reglType) for(var b = 0; 6 > b; ++b)aa(F({
                        framebuffer: a.framebuffer.faces[b]
                    }, a), r);
                    else aa(a, r);
                } else r(null, a);
            },
            prop: Z.define.bind(null, 1),
            context: Z.define.bind(null, 2),
            "this": Z.define.bind(null, 3),
            draw: p({}),
            buffer: function(a) {
                return E.create(a, 34962, !1, !1);
            },
            elements: function(a) {
                return I.create(a, !1);
            },
            texture: K.create2D,
            cube: K.createCube,
            renderbuffer: P.create,
            framebuffer: Q.create,
            framebufferCube: Q.createCube,
            vao: M.createVAO,
            attributes: g,
            frame: v,
            on: function(a, b) {
                var c;
                switch(a){
                    case "frame":
                        return v(b);
                    case "lost":
                        c = S;
                        break;
                    case "restore":
                        c = U;
                        break;
                    case "destroy":
                        c = W;
                }
                c.push(b);
                return {
                    cancel: function() {
                        for(var a = 0; a < c.length; ++a)if (c[a] === b) {
                            c[a] = c[c.length - 1];
                            c.pop();
                            break;
                        }
                    }
                };
            },
            limits: N,
            hasExtension: function(a) {
                return 0 <= N.extensions.indexOf(a.toLowerCase());
            },
            read: h,
            destroy: function() {
                G.length = 0;
                e();
                O && (O.removeEventListener("webglcontextlost", f), O.removeEventListener("webglcontextrestored", d));
                y.clear();
                Q.clear();
                P.clear();
                M.clear();
                K.clear();
                I.clear();
                E.clear();
                t && t.clear();
                W.forEach(function(a) {
                    a();
                });
            },
            _gl: q,
            _refresh: n,
            poll: function() {
                u();
                t && t.update();
            },
            now: z,
            stats: l,
            blit: Q.blit
        });
        a.onDone(null, g);
        return g;
    };
});

});

parcelRegister("2wazW", function(module, exports) {

$parcel$export(module.exports, "Util", () => $1d56c6a18dbfd30f$export$f8f26dd395d7e1bd);
$parcel$export(module.exports, "Constants", () => $1d56c6a18dbfd30f$export$a002182e51710d39);
$parcel$export(module.exports, "AbstractTexture", () => $1d56c6a18dbfd30f$export$e05be2fb829060c2);
$parcel$export(module.exports, "BoundingBox", () => $1d56c6a18dbfd30f$export$63080c4de6cfc362);
$parcel$export(module.exports, "Geometry", () => $1d56c6a18dbfd30f$export$2db6c17465f94a2);
$parcel$export(module.exports, "REGLHelper", () => $1d56c6a18dbfd30f$export$a7945c105868e82f);
$parcel$export(module.exports, "EdgeGeometry", () => $1d56c6a18dbfd30f$export$269349b0cbfdd78c);
$parcel$export(module.exports, "Material", () => $1d56c6a18dbfd30f$export$a2d8b23205c25948);
$parcel$export(module.exports, "WireFrameMaterial", () => $1d56c6a18dbfd30f$export$9305addea90162cc);
$parcel$export(module.exports, "PhongMaterial", () => $1d56c6a18dbfd30f$export$7d1ec2d75ed228db);
$parcel$export(module.exports, "StandardLiteMaterial", () => $1d56c6a18dbfd30f$export$507a82ff128c1f16);
$parcel$export(module.exports, "PhongSpecularGlossinessMaterial", () => $1d56c6a18dbfd30f$export$9675f394e75cd3f3);
$parcel$export(module.exports, "Mesh", () => $1d56c6a18dbfd30f$export$e176487c05830cc5);
$parcel$export(module.exports, "InstancedMesh", () => $1d56c6a18dbfd30f$export$f3c979c331175ad7);
$parcel$export(module.exports, "Renderer", () => $1d56c6a18dbfd30f$export$88530751e3977073);
$parcel$export(module.exports, "ResourceLoader", () => $1d56c6a18dbfd30f$export$84bade0bc2a1e1);
$parcel$export(module.exports, "Scene", () => $1d56c6a18dbfd30f$export$38af1803e3442a7f);
$parcel$export(module.exports, "Texture2D", () => $1d56c6a18dbfd30f$export$d7f9130fd509486);
$parcel$export(module.exports, "Plane", () => $1d56c6a18dbfd30f$export$7ff5ac152ef991b0);
$parcel$export(module.exports, "ShaderLib", () => $1d56c6a18dbfd30f$export$bee4a7d47f8f5014);
$parcel$export(module.exports, "Shader", () => $1d56c6a18dbfd30f$export$462bb059fed9d9e5);
$parcel$export(module.exports, "MeshShader", () => $1d56c6a18dbfd30f$export$9d2cc9f1c4004434);
$parcel$export(module.exports, "WireframeShader", () => $1d56c6a18dbfd30f$export$b54426a9fafcfc5e);
$parcel$export(module.exports, "PhongShader", () => $1d56c6a18dbfd30f$export$4e9078b58a7c4ba7);
$parcel$export(module.exports, "PointLineShader", () => $1d56c6a18dbfd30f$export$78eff65aa3e6c692);
$parcel$export(module.exports, "QuadShader", () => $1d56c6a18dbfd30f$export$e82c04eda9e9b75c);
$parcel$export(module.exports, "FxaaShader", () => $1d56c6a18dbfd30f$export$1cdaf2440f7f6138);
$parcel$export(module.exports, "BoxBlurShader", () => $1d56c6a18dbfd30f$export$1477fe5fe7b08486);
$parcel$export(module.exports, "PostProcessShader", () => $1d56c6a18dbfd30f$export$7c6e111cc47fa344);
$parcel$export(module.exports, "Jitter", () => $1d56c6a18dbfd30f$export$b4c0ba5bc03d35);
$parcel$export(module.exports, "BloomPass", () => $1d56c6a18dbfd30f$export$54ba5aace06c25b9);
$parcel$export(module.exports, "SsrPass", () => $1d56c6a18dbfd30f$export$f7c71c3adb539dd3);
$parcel$export(module.exports, "HeatmapShader", () => $1d56c6a18dbfd30f$export$32e43688bef63fb9);
$parcel$export(module.exports, "SkyboxShader", () => $1d56c6a18dbfd30f$export$881c590fefe5ccac);
$parcel$export(module.exports, "HeatmapDisplayShader", () => $1d56c6a18dbfd30f$export$8d4ce79d3f8ec4dd);
$parcel$export(module.exports, "WaterShader", () => $1d56c6a18dbfd30f$export$8d6952a07fa5a2a3);
$parcel$export(module.exports, "CopyShader", () => $1d56c6a18dbfd30f$export$57f84a24a9a6130d);
$parcel$export(module.exports, "EdgeShader", () => $1d56c6a18dbfd30f$export$ef84166aa9d1fabd);
$parcel$export(module.exports, "StandardLiteShader", () => $1d56c6a18dbfd30f$export$5688b391eda0d8f9);
$parcel$export(module.exports, "FogPass", () => $1d56c6a18dbfd30f$export$59f3f5e97543da75);
$parcel$export(module.exports, "FogShader", () => $1d56c6a18dbfd30f$export$ed6ba9a2be2fa41a);
$parcel$export(module.exports, "RainRipplesPass", () => $1d56c6a18dbfd30f$export$22591eb5ea34a33);
$parcel$export(module.exports, "ExtentPass", () => $1d56c6a18dbfd30f$export$dce1ad109d1f5f99);
$parcel$export(module.exports, "GLTFHelper", () => $1d56c6a18dbfd30f$export$79ec47965c44651a);
$parcel$export(module.exports, "GLTFManager", () => $1d56c6a18dbfd30f$export$531420000793a6a1);
$parcel$export(module.exports, "ShadowMapShader", () => $1d56c6a18dbfd30f$export$2322f55bf1a46077);
$parcel$export(module.exports, "ShadowPass", () => $1d56c6a18dbfd30f$export$48e48531746e3d8);
$parcel$export(module.exports, "ShadowDisplayShader", () => $1d56c6a18dbfd30f$export$5de8fd44581a7c0b);
$parcel$export(module.exports, "FBORayPicking", () => $1d56c6a18dbfd30f$export$6f30a48810f49c78);
$parcel$export(module.exports, "KHRTechniquesWebglManager", () => $1d56c6a18dbfd30f$export$fd346f1db18c5e1);
$parcel$export(module.exports, "HDR", () => $1d56c6a18dbfd30f$export$974bc3a953a52182);
$parcel$export(module.exports, "pbr", () => $1d56c6a18dbfd30f$export$c66bc961f5364fa5);
$parcel$export(module.exports, "earcut", () => $1d56c6a18dbfd30f$export$71a1409458eaaf0d);
$parcel$export(module.exports, "glMatrix", () => (parcelRequire("amnUE")));
$parcel$export(module.exports, "mat2", () => (parcelRequire("iLdEy")));
$parcel$export(module.exports, "mat2d", () => (parcelRequire("caQGJ")));
$parcel$export(module.exports, "mat3", () => (parcelRequire("bDSmI")));
$parcel$export(module.exports, "mat4", () => (parcelRequire("3iqbd")));
$parcel$export(module.exports, "quat", () => (parcelRequire("k1dpP")));
$parcel$export(module.exports, "quat2", () => (parcelRequire("1vSaR")));
$parcel$export(module.exports, "vec2", () => (parcelRequire("6BoVD")));
$parcel$export(module.exports, "vec3", () => (parcelRequire("eIStk")));
$parcel$export(module.exports, "vec4", () => (parcelRequire("jxhwV")));
/*!
 * @maptalks/reshader.gl v0.106.0
 * LICENSE : UNLICENSED
 * (c) 2016-2025 maptalks.com
 */ 
var $amnUE = parcelRequire("amnUE");
var $iLdEy = parcelRequire("iLdEy");
var $caQGJ = parcelRequire("caQGJ");
var $bDSmI = parcelRequire("bDSmI");
var $3iqbd = parcelRequire("3iqbd");
var $k1dpP = parcelRequire("k1dpP");
var $1vSaR = parcelRequire("1vSaR");
var $6BoVD = parcelRequire("6BoVD");
var $eIStk = parcelRequire("eIStk");
var $jxhwV = parcelRequire("jxhwV");

var $1YyR8 = parcelRequire("1YyR8");
const $1d56c6a18dbfd30f$var$l = function() {
    if ("undefined" != typeof globalThis) return globalThis;
    if ("undefined" != typeof self) return self;
    if ("undefined" != typeof window) return window;
    if ("undefined" != typeof $parcel$global) return $parcel$global;
    throw new Error("unable to locate global object");
};
function $1d56c6a18dbfd30f$var$f() {
    return $1d56c6a18dbfd30f$var$l().maptalks_gltf_loader;
}
function $1d56c6a18dbfd30f$var$d(e) {
    return !$1d56c6a18dbfd30f$var$u(e) && ("string" == typeof e || null !== e.constructor && e.constructor === String);
}
function $1d56c6a18dbfd30f$var$u(e) {
    return null == e;
}
function $1d56c6a18dbfd30f$var$h(e) {
    return !$1d56c6a18dbfd30f$var$u(e);
}
function $1d56c6a18dbfd30f$var$m(e) {
    return !$1d56c6a18dbfd30f$var$u(e) && ("function" == typeof e || null !== e.constructor && e.constructor === Function);
}
function $1d56c6a18dbfd30f$var$v(e, ...t) {
    return Object.assign(e, ...t), e;
}
function $1d56c6a18dbfd30f$var$_(e, ...t) {
    for(let n = 0; n < t.length; n++){
        const r = t[n];
        for(const t in r)null != r[t] && (e[t] = r[t]);
    }
    return e;
}
function $1d56c6a18dbfd30f$var$g(e) {
    return "number" == typeof e && !isNaN(e);
}
function $1d56c6a18dbfd30f$var$x(e, t, n) {
    return e * (1 - n) + t * n;
}
function $1d56c6a18dbfd30f$var$p(e) {
    return Array.isArray(e) || e instanceof Uint8Array || e instanceof Int8Array || e instanceof Uint16Array || e instanceof Int16Array || e instanceof Uint32Array || e instanceof Int32Array || e instanceof Uint8ClampedArray || e instanceof Float32Array || e instanceof Float64Array;
}
function $1d56c6a18dbfd30f$var$b(e) {
    return (e = Math.abs(e)) < 128 ? Int8Array : e < 32768 ? Int16Array : Float32Array;
}
function $1d56c6a18dbfd30f$var$y(e, t, n) {
    return Math.min(n, Math.max(t, e));
}
function $1d56c6a18dbfd30f$var$A(e) {
    return e && e.hasExtension("oes_vertex_array_object");
}
function $1d56c6a18dbfd30f$var$S(e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
}
function $1d56c6a18dbfd30f$var$T(e) {
    if (e.data) {
        if (e.data.BYTES_PER_ELEMENT) return e.data.length * e.data.BYTES_PER_ELEMENT;
        if (e.data.length) return 4 * e.data.length;
    } else {
        if (e.BYTES_PER_ELEMENT) return e.length * e.BYTES_PER_ELEMENT;
        if (e.length) return 4 * e.length;
        if (e.buffer && e.buffer.destroy) return e.buffer._buffer.byteLength;
    }
    return 0;
}
function $1d56c6a18dbfd30f$var$M(e) {
    return e.width * e.height * $1d56c6a18dbfd30f$var$C(e.format) * $1d56c6a18dbfd30f$var$O(e.type) * ("textureCube" === e._reglType ? 6 : 1);
}
function $1d56c6a18dbfd30f$var$O(e) {
    return "uint8" === e ? 1 : "uint16" === e || "float16" === e || "half float" === e ? 2 : "uint32" === e || "float" === e || "float32" === e ? 4 : 0;
}
function $1d56c6a18dbfd30f$var$C(e) {
    return "depth" === e || "alpha" === e || "luminance" === e ? 1 : "luminance alpha" === e || "depth stencil" === e ? 2 : "srgba" === e || "rgb5 a1" === e || "rgba" === e.substring(0, 4) ? 4 : "srgb" === e || "rgb" === e.substring(0, 3) ? 3 : 1;
}
function $1d56c6a18dbfd30f$var$E(e) {
    if (!e.componentType) return !1;
    const t = $1d56c6a18dbfd30f$var$f().GLTFLoader.getTypedArrayCtor(e.componentType);
    return e.byteStride > 0 && e.byteStride !== e.itemSize * t.BYTES_PER_ELEMENT;
}
function $1d56c6a18dbfd30f$var$P(e) {
    return e && (e.stride > 0 || $1d56c6a18dbfd30f$var$E(e));
}
function $1d56c6a18dbfd30f$var$w(e) {
    let t = 0;
    const n = e && e.length || 0;
    if (!n) return t;
    let r;
    for(let i = 0; i < n; i++)r = e.charCodeAt(i), t = (t << 5) - t + r, t |= 0;
    return t;
}
function $1d56c6a18dbfd30f$var$I(e) {
    return !(e & e - 1) && 0 !== e;
}
function $1d56c6a18dbfd30f$var$R(e) {
    return Math.pow(2, Math.floor(Math.log(e) / Math.LN2));
}
function $1d56c6a18dbfd30f$var$H(e, t, n) {
    if ($1d56c6a18dbfd30f$var$p(e)) return $1d56c6a18dbfd30f$var$I(t) && $1d56c6a18dbfd30f$var$I(n) ? e : function(e, t, n) {
        let r = t, i = n;
        $1d56c6a18dbfd30f$var$I(t) || (r = $1d56c6a18dbfd30f$var$R(t)), $1d56c6a18dbfd30f$var$I(n) || (i = $1d56c6a18dbfd30f$var$R(n));
        const o = new ImageData(new Uint8ClampedArray(e), t, n), a = document.createElement("canvas");
        a.width = t, a.height = n, a.getContext("2d").putImageData(o, 0, 0);
        const s = document.createElement("canvas");
        s.width = r, s.height = i, s.getContext("2d").drawImage(a, 0, 0, t, n, 0, 0, i, i), console.warn(`Texture's size is not power of two, resize from (${t}, ${n}) to (${r}, ${i})`);
        let c = document.getElementById("_debug_resize_canvas");
        return c || (c = document.createElement("canvas"), c.id = "_debug_resize_canvas", document.body.appendChild(c)), c.width = r, c.height = i, c.getContext("2d").drawImage(s, 0, 0), s;
    }(e, t, n);
    if ($1d56c6a18dbfd30f$var$I(e.width) && $1d56c6a18dbfd30f$var$I(e.height)) return e;
    n = e.height, $1d56c6a18dbfd30f$var$I(t = e.width) || (t = $1d56c6a18dbfd30f$var$R(t)), $1d56c6a18dbfd30f$var$I(n) || (n = $1d56c6a18dbfd30f$var$R(n));
    const r = document.createElement("canvas");
    r.width = t, r.height = n, r.getContext("2d").drawImage(e, 0, 0, t, n);
    const i = e.src, o = i.lastIndexOf("/") + 1, a = i.substring(o);
    return console.warn(`Texture(${a})'s size is not power of two, resize from (${e.width}, ${e.height}) to (${t}, ${n})`), r;
}
function $1d56c6a18dbfd30f$var$D(e) {
    return e._gl instanceof WebGL2RenderingContext;
}
var $1d56c6a18dbfd30f$export$f8f26dd395d7e1bd = Object.freeze({
    __proto__: null,
    clamp: $1d56c6a18dbfd30f$var$y,
    defined: $1d56c6a18dbfd30f$var$h,
    extend: $1d56c6a18dbfd30f$var$v,
    extendWithoutNil: $1d56c6a18dbfd30f$var$_,
    getBufferSize: $1d56c6a18dbfd30f$var$T,
    getPosArrayType: $1d56c6a18dbfd30f$var$b,
    getSupportedFormats: function(e) {
        return {
            etc: !!e.getExtension("WEBGL_compressed_texture_etc"),
            etc1: !!e.getExtension("WEBGL_compressed_texture_etc1"),
            s3tc: !!e.getExtension("WEBGL_compressed_texture_s3tc"),
            pvrtc: !!e.getExtension("WEBGL_compressed_texture_pvrtc"),
            astc: !!e.getExtension("WEBGL_compressed_texture_astc"),
            bc7: !!e.getExtension("EXT_texture_compression_bptc")
        };
    },
    getTexMemorySize: $1d56c6a18dbfd30f$var$M,
    getTextureByteWidth: $1d56c6a18dbfd30f$var$O,
    getTextureChannels: $1d56c6a18dbfd30f$var$C,
    hasOwn: $1d56c6a18dbfd30f$var$S,
    hashCode: $1d56c6a18dbfd30f$var$w,
    interpolate: $1d56c6a18dbfd30f$var$x,
    isArray: $1d56c6a18dbfd30f$var$p,
    isFunction: $1d56c6a18dbfd30f$var$m,
    isInStride: $1d56c6a18dbfd30f$var$E,
    isInterleaved: $1d56c6a18dbfd30f$var$P,
    isNil: $1d56c6a18dbfd30f$var$u,
    isNumber: $1d56c6a18dbfd30f$var$g,
    isPowerOfTwo: $1d56c6a18dbfd30f$var$I,
    isString: $1d56c6a18dbfd30f$var$d,
    isSupportVAO: $1d56c6a18dbfd30f$var$A,
    isTextureDestroyed: function(e) {
        return !e._texture || !e._texture.texture;
    },
    lerp: function(e, t, n, r) {
        for(let i = 0; i < e.length; i++)e[i] = t[i] + r * (n[i] - t[i]);
        return e;
    },
    log2: function(e) {
        return Math.log2(e);
    },
    normalize: function(e, t) {
        let n = 0;
        for(let e = 0, r = t.length; e < r; e++)n += t[e];
        for(let r = 0, i = t.length; r < i; r++)e[r] = t[r] / n;
        return e;
    },
    resizeToPowerOfTwo: $1d56c6a18dbfd30f$var$H,
    set: function(e, t) {
        for(let n = 0; n < e.length; n++)e[n] = t[n];
        return e;
    },
    supportNPOT: $1d56c6a18dbfd30f$var$D
});
function $1d56c6a18dbfd30f$var$N(e) {
    return class extends e {
        on(e, t) {
            return this._events || (this._events = {
                type: [
                    t
                ]
            }), this._events[e] = this._events[e] || [], this._events[e].push(t), this;
        }
        once(e, t) {
            return this.on(e, this._wrapOnce(e, t));
        }
        off(e, t) {
            return this._events && this._events[e] ? (this._events[e].splice(this._events[e].indexOf(t), 1), this) : this;
        }
        fire(e, t = {}) {
            if (!this._events || !this._events[e]) return this;
            t.target || (t.target = this);
            const n = this._events[e].slice(0);
            for (const e of n)e(t);
            return this;
        }
        _wrapOnce(e, t) {
            const n = this;
            let r = !1;
            return function i(o) {
                r || (r = !0, t(o), n.off(e, i));
            };
        }
    };
}
const $1d56c6a18dbfd30f$var$L = "__reshader_disposed";
var $1d56c6a18dbfd30f$export$a002182e51710d39 = Object.freeze({
    __proto__: null,
    KEY_DISPOSED: $1d56c6a18dbfd30f$var$L,
    WEBGL_EXTENSIONS: [
        "ANGLE_instanced_arrays",
        "OES_element_index_uint",
        "OES_standard_derivatives"
    ],
    WEBGL_OPTIONAL_EXTENSIONS: [
        "OES_vertex_array_object",
        "OES_texture_half_float",
        "OES_texture_half_float_linear",
        "OES_texture_float",
        "OES_texture_float_linear",
        "WEBGL_depth_texture",
        "EXT_shader_texture_lod",
        "EXT_texture_filter_anisotropic"
    ]
});
const $1d56c6a18dbfd30f$var$B = "_reshader_refCount";
let $1d56c6a18dbfd30f$var$z = class {
};
class $1d56c6a18dbfd30f$export$e05be2fb829060c2 extends $1d56c6a18dbfd30f$var$N($1d56c6a18dbfd30f$var$z) {
    constructor(e, t){
        if (super(), $1d56c6a18dbfd30f$var$m(e)) {
            this._texture = e, e = this.config = {};
            for(const t in this._texture)$1d56c6a18dbfd30f$var$S(this._texture, t) && ($1d56c6a18dbfd30f$var$m(this._texture[t]) || (e[t] = this._texture[t]));
        } else if (this.config = e || {}, this.resLoader = t, (e.url || e.promise) && !e.data) {
            this._loading = !0;
            const n = this;
            let r;
            if (e.promise) r = e.promise;
            else {
                let n;
                n = e.arrayBuffer ? t.getArrayBuffer : t.get, r = n.call(t, e.url);
            }
            e.data = t.getDefaultTexture(e.url), this.promise = r, r.then((e)=>(delete this.promise, n._loading = !1, n.config ? (n.onLoad(e), Array.isArray(e) || (e = [
                    e
                ]), n.fire("complete", {
                    target: this,
                    resources: e
                }), e) : e)).catch((e)=>{
                console.error("error when loading texture image.", e), n.fire("error", {
                    target: this,
                    error: e
                });
            });
        }
    }
    onLoad(e) {}
    isReady() {
        return !this._loading;
    }
    set(e, t) {
        return this.config[e] = t, this.dirty = !0, this;
    }
    get(e) {
        return this.config[e];
    }
    createREGLTexture(e) {
        return null;
    }
    getREGLTexture(e) {
        return this._texture || (this._texture = this.createREGLTexture(e), this.config.persistent || (this.config.data && (this.config.data instanceof ImageBitmap || (this.config.data = [])), this.config.image && (this.config.image.array = []), this.config.mipmap && delete this.config.mipmap)), this.dirty && this._updateREGL(), this._texture;
    }
    getMemorySize() {
        if (!this.config) return 0;
        const { width: e, height: t, type: n, format: r } = this.config;
        return e * t * $1d56c6a18dbfd30f$var$O(n || "uint8") * $1d56c6a18dbfd30f$var$C(r || "rgba");
    }
    _updateREGL() {
        this._texture && !this._texture[$1d56c6a18dbfd30f$var$L] && this._texture(this.config), this.dirty = !1;
    }
    dispose() {
        this.config && this.config.url && (URL.revokeObjectURL(this.config.url), this.resLoader.disposeRes(this.config.url)), this.config && this.config.data instanceof ImageBitmap && (this.config.data.close(), this.config.data = []), this._texture && !this._texture[$1d56c6a18dbfd30f$var$L] && (this._texture[$1d56c6a18dbfd30f$var$B] && this._texture[$1d56c6a18dbfd30f$var$B]--, this._texture[$1d56c6a18dbfd30f$var$B] || (this._texture.destroy(), this._texture[$1d56c6a18dbfd30f$var$L] = !0, delete this._texture)), delete this.resLoader, delete this._regl;
        const e = this.config && this.config.url;
        delete this.config, e && this.fire("disposed", {
            target: this,
            url: e
        });
    }
    _needPowerOf2(e) {
        if ($1d56c6a18dbfd30f$var$D(e)) return !1;
        const t = this.config;
        return t.wrap && "clamp" !== t.wrap || t.wrapS && "clamp" !== t.wrapS || t.wrapT && "clamp" !== t.wrapT || t.min && "nearest" !== t.min && "linear" !== t.min;
    }
}
const $1d56c6a18dbfd30f$var$V = (0, $3iqbd).identity([]), $1d56c6a18dbfd30f$var$U = (0, $3iqbd).identity([]);
class $1d56c6a18dbfd30f$export$63080c4de6cfc362 {
    constructor(e, t){
        this.min = e || [
            1 / 0,
            1 / 0,
            1 / 0
        ], this.max = t || [
            -1 / 0,
            -1 / 0,
            -1 / 0
        ], this.updateVertex();
    }
    static copy(e, n) {
        (0, $eIStk).copy(e.min, n.min), (0, $eIStk).copy(e.max, n.max);
        for(let r = 0; r < n.vertex.length; r++)(0, $eIStk).copy(e.vertex[r], n.vertex[r]);
        return e;
    }
    combine(e) {
        if (!e) return this;
        let t, n;
        return Array.isArray(e) ? (t = e[0], n = e[1]) : (t = e.min, n = e.max), t[0] < this.min[0] && (this.min[0] = t[0], this._dirty = !0), t[1] < this.min[1] && (this.min[1] = t[1], this._dirty = !0), t[2] < this.min[2] && (this.min[2] = t[2], this._dirty = !0), n[0] > this.max[0] && (this.max[0] = n[0], this._dirty = !0), n[1] > this.max[1] && (this.max[1] = n[1], this._dirty = !0), n[2] > this.max[2] && (this.max[2] = n[2], this._dirty = !0), this;
    }
    dirty() {
        return this._dirty = !0, this;
    }
    getCenter() {
        return this.center || (this.center = [
            0,
            0,
            0
        ], this._dirty = !0), this._dirty && ((0, $eIStk).add(this.center, this.min, this.max), (0, $eIStk).scale(this.center, this.center, .5)), this._dirty = !1, this.center;
    }
    containPoint(e) {
        const t = this.min, n = this.max;
        return t[0] <= e[0] && t[1] <= e[1] && t[2] <= e[2] && n[0] >= e[0] && n[1] >= e[1] && n[2] >= e[2];
    }
    isFinite() {
        const e = this.min, t = this.max;
        return isFinite(e[0]) && isFinite(e[1]) && isFinite(e[2]) && isFinite(t[0]) && isFinite(t[1]) && isFinite(t[2]);
    }
    updateVertex() {
        if (!this.vertex) {
            this.vertex = [];
            for(let e = 0; e < 8; e++)this.vertex.push([
                0,
                0,
                0
            ]);
        }
        return this.vertex[0][0] = this.min[0], this.vertex[0][1] = this.min[1], this.vertex[0][2] = this.min[2], this.vertex[1][0] = this.min[0], this.vertex[1][1] = this.min[1], this.vertex[1][2] = this.max[2], this.vertex[2][0] = this.min[0], this.vertex[2][1] = this.max[1], this.vertex[2][2] = this.max[2], this.vertex[3][0] = this.min[0], this.vertex[3][1] = this.max[1], this.vertex[3][2] = this.min[2], this.vertex[4][0] = this.max[0], this.vertex[4][1] = this.min[1], this.vertex[4][2] = this.min[2], this.vertex[5][0] = this.max[0], this.vertex[5][1] = this.min[1], this.vertex[5][2] = this.max[2], this.vertex[6][0] = this.max[0], this.vertex[6][1] = this.max[1], this.vertex[6][2] = this.max[2], this.vertex[7][0] = this.max[0], this.vertex[7][1] = this.max[1], this.vertex[7][2] = this.min[2], this.vertex;
    }
    copy(e) {
        return e ? $1d56c6a18dbfd30f$export$63080c4de6cfc362.copy(e, this) : new $1d56c6a18dbfd30f$export$63080c4de6cfc362(this.min.slice(), this.max.slice());
    }
    equals(e) {
        if (!(0, $eIStk).equals(this.min, e.min) || !(0, $eIStk).equals(this.max, e.max)) return !1;
        const n = e.vertex;
        for(let e = 0; e < this.vertex.length; e++)if (!(0, $eIStk).equals(n[e], this.vertex[e])) return !1;
        return !0;
    }
    transform(n, r) {
        if (n = n || $1d56c6a18dbfd30f$var$U, (r = r || $1d56c6a18dbfd30f$var$U)[1] || r[2] || r[4] || r[6] || r[8] || r[9]) {
            const i = this.vertex, o = (0, $3iqbd).multiply($1d56c6a18dbfd30f$var$V, r, n);
            for(let e = 0; e < i.length; e++)(0, $eIStk).transformMat4(this.vertex[e], this.vertex[e], o);
            const a = this.vertex.map((e)=>e[0]), s = this.vertex.map((e)=>e[1]), c = this.vertex.map((e)=>e[2]), l = Math.min(...a), f = Math.max(...a), d = Math.min(...s), u = Math.max(...s), h = Math.min(...c), m = Math.max(...c);
            (0, $eIStk).set(this.min, l, d, h), (0, $eIStk).set(this.max, f, u, m);
        } else {
            const i = (0, $3iqbd).multiply($1d56c6a18dbfd30f$var$V, r, n);
            (0, $eIStk).transformMat4(this.min, this.min, i), (0, $eIStk).transformMat4(this.max, this.max, i);
        }
        return this;
    }
}
const $1d56c6a18dbfd30f$var$X = [], $1d56c6a18dbfd30f$var$W = {
    5120: "int8",
    5122: "int16",
    5124: "int32",
    5121: "uint8",
    5123: "uint16",
    5125: "uint32",
    5126: "float"
}, $1d56c6a18dbfd30f$var$q = {
    5120: 1,
    5122: 2,
    5124: 4,
    5121: 1,
    5123: 2,
    5125: 4,
    5126: 4
}, $1d56c6a18dbfd30f$var$K = {
    positionSize: 3,
    primitive: "triangles",
    positionAttribute: "aPosition",
    normalAttribute: "aNormal",
    uv0Attribute: "aTexCoord",
    uv1Attribute: "aTexCoord1",
    color0Attribute: "aColor0",
    tangentAttribute: "aTangent",
    pickingIdAttribute: "aPickingId",
    textureCoordMatrixAttribute: "aTextureCoordMatrix"
};
let $1d56c6a18dbfd30f$var$J = 1;
const $1d56c6a18dbfd30f$var$Y = "_reshader_refCount";
class $1d56c6a18dbfd30f$export$2db6c17465f94a2 {
    constructor(e, t, n, r){
        this._version = 0, this.data = e, this.elements = t, this.desc = $1d56c6a18dbfd30f$var$v({}, $1d56c6a18dbfd30f$var$K, r);
        const i = this._getPosAttritute();
        this.data[this.desc.positionAttribute] = i, n || (this.elements ? n = $1d56c6a18dbfd30f$var$Q(this.elements) : i && i.length ? n = i.length / this.desc.positionSize : i && i.interleavedArray ? n = i.interleavedArray.length / this.desc.positionSize : i && i.array && (n = i.array.length / this.desc.positionSize)), this.count = n, this.elements || (this.elements = n), this.properties = {}, this._buffers = {}, this._vao = {}, this.getVertexCount(), this._prepareData(!0), this.updateBoundingBox();
    }
    set version(e) {
        throw new Error("Geometry.version is read only.");
    }
    get version() {
        return this._version;
    }
    _getPosAttritute() {
        return this.data[this.desc.positionAttribute];
    }
    _prepareData(e) {
        if (!this.data) return;
        const t = this._buffers || {};
        for(const n in this.data){
            const r = this.data[n];
            if (r) {
                if (r.buffer && r.buffer.destroy) {
                    const t = r.buffer;
                    t[$1d56c6a18dbfd30f$var$Y] || (t[$1d56c6a18dbfd30f$var$Y] = 0), e && t[$1d56c6a18dbfd30f$var$Y]++;
                } else if (r && r.array) {
                    if ($1d56c6a18dbfd30f$var$E(r)) {
                        let e = r.array.buffer.__id;
                        e || (e = r.array.buffer.__id = $1d56c6a18dbfd30f$var$J++), this.data[n] = {
                            buffer: e,
                            offset: r.byteOffset,
                            stride: r.byteStride,
                            type: $1d56c6a18dbfd30f$var$W[r.componentType],
                            size: r.itemSize,
                            count: r.count,
                            componentType: r.componentType
                        }, t[e] || (t[e] = {
                            data: r.array.buffer
                        });
                    } else this.data[n] = r.array;
                }
            }
        }
        this._buffers = t;
        const n = this.elements;
        n && n.array && (this.elements = n.array);
    }
    getAttrData(e) {
        const t = e.key, n = !this._reglData || !this._reglData[t];
        if (this._reglData || (this._reglData = {}), n) {
            const e = this._reglData[t] = {}, n = this.data, { positionAttribute: r, normalAttribute: i, uv0Attribute: o, uv1Attribute: a, tangentAttribute: s, color0Attribute: c, pickingIdAttribute: l, textureCoordMatrixAttribute: f } = this.desc;
            $1d56c6a18dbfd30f$var$v(e, this.data), e.aPosition = n[r], n[i] && (e.aNormal = n[i]), n[o] && (e.aTexCoord = n[o]), n[a] && (e.aTexCoord1 = n[a]), n[s] && (e.aTangent = n[s]), n[c] && (e.aColor0 = n[c]), n[l] && (e.aPickingId = n[l]), n[f] && (e.aTextureCoordMatrix = n[f]);
        }
        return this._reglData[t];
    }
    getREGLData(e, t, n) {
        this.getAttrData(t);
        const r = !this._reglData || !this._reglData[t.key];
        if ($1d56c6a18dbfd30f$var$A(e) && !n) {
            const n = t && t.key || "default";
            if (!this._vao[n] || r || this._vao[n].dirty) {
                const r = this._reglData[t.key], i = this._vertexCount, o = [];
                for(let e = 0; e < t.length; e++){
                    const n = t[e].name, a = r[n] && r[n].buffer;
                    if (a && a.destroy) o.push(void 0 !== r[n].stride ? r[n] : a);
                    else {
                        const e = r[n];
                        if (!e) {
                            o.push(this.desc.fillEmptyDataInMissingAttribute ? new Uint8Array(4 * i) : $1d56c6a18dbfd30f$var$X);
                            continue;
                        }
                        const t = (e.data && $1d56c6a18dbfd30f$var$p(e.data) ? e.data.length : e.length) / i;
                        e.data ? (e.dimension = t, o.push(e)) : o.push({
                            data: e,
                            dimension: t
                        });
                    }
                }
                const a = {
                    attributes: o,
                    primitive: this.getPrimitive()
                };
                if (this.elements && !$1d56c6a18dbfd30f$var$g(this.elements)) {
                    if (this.elements.destroy) a.elements = this.elements;
                    else {
                        a.elements = {
                            primitive: this.getPrimitive(),
                            data: this.elements
                        };
                        const e = this.getElementsType(this.elements);
                        e && (a.elements.type = e);
                    }
                }
                this._vao[n] ? this._vao[n].vao(a) : this._vao[n] = {
                    vao: e.vao(a)
                };
            }
            return delete this._vao[n].dirty, this._vao[n];
        }
        return this._reglData[t.key];
    }
    _isAttrChanged(e) {
        if (e === this._activeAttributes) return !1;
        if (e.length !== this._activeAttributes.length) return !0;
        for(let t = 0; t < e.length; t++)if (e[t] !== this._activeAttributes[t]) return !0;
        return !1;
    }
    generateBuffers(e) {
        const t = this._buffers;
        for(const n in t)t[n].buffer || (t[n].buffer = e.buffer(t[n].data)), delete t[n].data;
        const n = this.desc.positionAttribute, r = this.desc.altitudeAttribute, i = this.data, o = this._vertexCount, a = {};
        for(const s in i)if (i[s]) {
            if (void 0 === i[s].buffer || i[s].buffer instanceof ArrayBuffer) {
                const t = i[s].data ? i[s] : {
                    data: i[s]
                };
                t.dimension = (i[s].data ? i[s].data : i[s]).length / o;
                const c = e.buffer(t);
                c[$1d56c6a18dbfd30f$var$Y] = 1, a[s] = {
                    buffer: c
                }, s !== n && s !== r || (a[s].array = i[s]);
            } else i[s].buffer.destroy ? a[s] = i[s] : t[i[s].buffer] && (a[s] = $1d56c6a18dbfd30f$var$v({}, i[s]), a[s].buffer = t[i[s].buffer].buffer);
            (this.desc.static || s !== n) && delete i[s].array;
        }
        if (this.data = a, delete this._reglData, this.elements && !$1d56c6a18dbfd30f$var$g(this.elements)) {
            const t = {
                primitive: this.getPrimitive(),
                data: this.elements
            }, n = this.getElementsType(this.elements);
            if (n && (t.type = n), !this.desc.static && !this.elements.destroy) {
                const e = this.elements;
                this.indices = new Uint16Array(e.length);
                for(let t = 0; t < e.length; t++)this.indices[t] = e[t];
            }
            this.elements = this.elements.destroy ? this.elements : e.elements(t);
            const r = this.elements;
            r[$1d56c6a18dbfd30f$var$Y] || (r[$1d56c6a18dbfd30f$var$Y] = 0), r[$1d56c6a18dbfd30f$var$Y]++;
        }
    }
    getVertexCount() {
        const { positionAttribute: e, positionSize: t, color0Attribute: n } = this.desc;
        let r = this.data[e];
        r.data && (r = r.data), r.array && (r = r.array), $1d56c6a18dbfd30f$var$p(r) ? this._vertexCount = Math.ceil(r.length / t) : r && void 0 !== r.count && (this._vertexCount = r.count);
        const i = n;
        if (this.data[i]) {
            const e = this.data[i].data || this.data[i].array || this.data[i];
            Array.isArray(e) ? this._color0Size = e.length / this._vertexCount : e && e.count ? this._color0Size = e.count / this._vertexCount : this.data[i].buffer && this.data[i].buffer.destroy && (this._color0Size = this.data[i].buffer._buffer.dimension);
        }
        return this._vertexCount;
    }
    getColor0Size() {
        return this._color0Size || 0;
    }
    addBuffer(e, t) {
        return this._buffers[e] = {
            data: t
        }, delete this._reglData, this._deleteVAO(), this;
    }
    updateBuffer(e, t) {
        if (!this._buffers[e]) throw new Error(`invalid buffer ${e} in geometry`);
        return this._buffers[e].buffer ? this._buffers[e].buffer.subdata(t) : this._buffers[e].data = t, delete this._reglData, this._deleteVAO(), this;
    }
    deleteData(e) {
        const t = this.data[e];
        return t ? (this._incrVersion(), t.buffer && t.buffer.destroy && t.buffer.destroy(), delete this.data[e], delete this._reglData, this._markVAODirty(!1), this) : this;
    }
    updateData(e, t) {
        const n = this.data[e];
        if (!n) return this;
        let r;
        return this._incrVersion(), this.data[e] = t, n.buffer && n.buffer.destroy && (r = n), e === this.desc.positionAttribute && this.updateBoundingBox(), this.getVertexCount(), r && (r.buffer(t), this.data[e] = r), this._prepareData(!1), this.desc.positionAttribute === e && (this._posDirty = !0), delete this._reglData, this;
    }
    updateSubData(e, t, n) {
        const r = this.data[e];
        if (!r) return this;
        let i;
        if (this._incrVersion(), r.buffer && r.buffer.destroy && (i = r), e === this.desc.positionAttribute && this._updateSubBoundingBox(t), i) {
            const e = $1d56c6a18dbfd30f$var$q[i.buffer._buffer.dtype];
            if (t.BYTES_PER_ELEMENT !== e) {
                const n = function(e, t) {
                    if (e instanceof Uint8Array || e instanceof Uint16Array || e instanceof Uint32Array || e instanceof Uint8ClampedArray) return 1 === t ? Uint8Array : 2 === t ? Uint16Array : Uint32Array;
                    if (e instanceof Int8Array || e instanceof Int16Array || e instanceof Int32Array) return 1 === t ? Int8Array : 2 === t ? Int16Array : Int32Array;
                    if (e instanceof Float32Array || e instanceof Float64Array) return 4 === t ? Float32Array : Float64Array;
                    return null;
                }(t, e);
                t = new n(t);
            }
            i.buffer.subdata(t, n * e);
        } else {
            const r = this.data[e].data ? this.data[e].data : this.data[e];
            for(let e = 0; e < t.length; e++)r[n + e] = t[e];
        }
        return this._prepareData(!1), this.desc.positionAttribute === e && (this._posDirty = !0), delete this._reglData, this;
    }
    getPrimitive() {
        return this.desc.primitive;
    }
    getElements() {
        return this.elements;
    }
    setElements(e, t) {
        if (!e) throw new Error("elements data is invalid");
        this._incrVersion();
        const n = this.elements;
        return this.count = void 0 === t ? $1d56c6a18dbfd30f$var$Q(e) : t, this.elements = e && e.destroy ? e : n.destroy ? n(e) : e, this._markVAODirty(!0), this;
    }
    deleteElements() {
        return this.elements && 0 !== this.elements.length ? (this._incrVersion(), this.elements && this.elements.destroy && !this.elements[$1d56c6a18dbfd30f$var$L] && (this.elements.destroy(), this.elements[$1d56c6a18dbfd30f$var$L] = 1), this.elements = [], this._markVAODirty(!0), this) : this;
    }
    _markVAODirty(e) {
        if (this._vao) {
            for(const t in this._vao)e ? this._vao[t].vao.destroy() : this._vao[t].dirty = !0;
            e && (this._vao = {});
        }
    }
    setDrawCount(e) {
        return this._incrVersion(), this.count1 = e, this;
    }
    getDrawCount() {
        return this.count1 >= 0 ? this.count1 : this.count;
    }
    setDrawOffset(e) {
        return this._incrVersion(), this.offset = e, this;
    }
    getDrawOffset() {
        return this.offset || 0;
    }
    dispose() {
        if (this._deleteVAO(), this._forEachBuffer((e)=>{
            if (!e[$1d56c6a18dbfd30f$var$L]) {
                let t = e[$1d56c6a18dbfd30f$var$Y];
                t && t--, t <= 0 ? (e[$1d56c6a18dbfd30f$var$L] = !0, e.destroy()) : e[$1d56c6a18dbfd30f$var$Y] = t;
            }
        }), this.properties) {
            const e = this.properties.oldElementsBeforeHighlight;
            e && !e[$1d56c6a18dbfd30f$var$L] && e.destroy && (e.destroy(), e[$1d56c6a18dbfd30f$var$L] = !0), delete this.properties.oldElementsBeforeHighlight, delete this.properties.hasInvisible;
        }
        this.data = {}, this._buffers = {}, delete this._reglData, this.count = 0, this.elements = [], delete this._tempPosArray, this._disposed = !0;
    }
    isDisposed() {
        return !!this._disposed;
    }
    updateBoundingBox() {
        let e = this.boundingBox;
        e || (e = this.boundingBox = new $1d56c6a18dbfd30f$export$63080c4de6cfc362);
        let n, r, i = this.data[this.desc.positionAttribute];
        if ($1d56c6a18dbfd30f$var$p(i) || (i.data ? i = i.data : $1d56c6a18dbfd30f$var$P(i) ? i = this._getAttributeData(this.desc.positionAttribute) : i.array && (n = i.min, r = i.max, i = i.array)), i && i.length) {
            const o = e.min, a = e.max;
            if (n && r) (0, $eIStk).set(o, ...n), (0, $eIStk).set(a, ...r);
            else {
                (0, $eIStk).set(o, i[0], i[1], i[2]), (0, $eIStk).set(a, i[0], i[1], i[2]);
                for(let e = 3; e < i.length;){
                    const t = i[e++], n = i[e++], r = i[e++];
                    t < o[0] && (o[0] = t), n < o[1] && (o[1] = n), r < o[2] && (o[2] = r), t > a[0] && (a[0] = t), n > a[1] && (a[1] = n), r > a[2] && (a[2] = r);
                }
            }
            e.updateVertex(), e.dirty();
        }
    }
    _updateSubBoundingBox(e) {
        const t = this.boundingBox, n = t.min, r = t.max, i = this.desc.positionSize;
        for(let t = 0; t < e.length;){
            const o = e[t++], a = e[t++];
            let s = 0;
            3 === i && (s = e[t++]), o < n[0] && (n[0] = o), a < n[1] && (n[1] = a), s < n[2] && (n[2] = s), o > r[0] && (r[0] = o), a > r[1] && (r[1] = a), s > r[2] && (r[2] = s);
        }
        t.updateVertex(), t.dirty();
    }
    _getAttributeData(e) {
        const t = $1d56c6a18dbfd30f$var$f(), n = this.data[e] && this.data[e].array ? this.data[e].array : this.data[e], r = n.buffer;
        if ($1d56c6a18dbfd30f$var$P(n)) {
            const i = this._buffers[r] ? this._buffers[r].data : n.array, { count: o, size: a, stride: s, offset: c, componentType: l } = n, f = t.GLTFLoader.getTypedArrayCtor(l);
            if ((0 === s || s === a * f.BYTES_PER_ELEMENT) && c % f.BYTES_PER_ELEMENT == 0) return new f(i, c, o * a);
            if (e === this.desc.positionAttribute) return !this._tempPosArray || this._tempPosArray && this._tempPosArray.length < a * o ? (this._tempPosArray = new f(a * o), t.GLTFLoader.readInterleavedArray(this._tempPosArray, i, o, a, s, c, l)) : this._posDirty ? (this._posDirty = !1, t.GLTFLoader.readInterleavedArray(this._tempPosArray, i, o, a, s, c, l)) : this._tempPosArray;
            {
                const e = new f(a * o);
                return t.GLTFLoader.readInterleavedArray(e, i, o, a, s, c, l);
            }
        }
        return n;
    }
    createTangent(e = "aTangent") {
        this._incrVersion();
        const { normalAttribute: r, positionAttribute: i, uv0Attribute: o } = this.desc, c = this._getAttributeData(r), l = this._getAttributeData(i), f = (0, $1YyR8.buildTangents)(l, c, this.data[o], this.elements), d = this.data[e] = new Float32Array(f.length), u = [
            0,
            0,
            0,
            0
        ], h = [
            0,
            0,
            0
        ], m = [
            0,
            0,
            0,
            0
        ];
        for(let e = 0; e < f.length; e += 4){
            const r = e / 4 * 3;
            (0, $eIStk).set(h, c[r], c[r + 1], c[r + 2]), (0, $jxhwV).set(u, f[e], f[e + 1], f[e + 2], f[e + 3]), (0, $1YyR8.packTangentFrame)(m, h, u), (0, $jxhwV).copy(d.subarray(e, e + 4), m);
        }
        delete this._reglData;
    }
    createNormal(e = "aNormal") {
        this._incrVersion();
        const t = this._getAttributeData(this.desc.positionAttribute);
        this.data[e] = (0, $1YyR8.buildNormals)(t.array || t, this.elements), delete this._reglData;
    }
    createBarycentric(e = "aBarycentric") {
        if ("triangles" !== this.desc.primitive) throw new Error("Primitive must be triangles to create bary centric data");
        this._incrVersion();
        const t = new Uint8Array(3 * this._vertexCount);
        for(let e = 0, n = this.elements.length; e < n;)for(let n = 0; n < 3; n++)t[3 * this.elements[e++] + n] = 1;
        this.data[e] = t, delete this._reglData;
    }
    buildUniqueVertex() {
        this._incrVersion();
        const e = this.data, t = this.elements;
        if (!$1d56c6a18dbfd30f$var$p(t)) throw new Error("elements must be array to build unique vertex.");
        const n = Object.keys(e), r = {};
        let i = e[this.desc.positionAttribute];
        if (i = i.length ? i : i.array, !$1d56c6a18dbfd30f$var$p(i)) throw new Error(this.desc.positionAttribute + " must be array to build unique vertex.");
        const o = this._vertexCount, a = t.length;
        for(let t = 0; t < n.length; t++){
            const i = n[t], s = $1d56c6a18dbfd30f$var$p(e[i]) ? e[i] : e[i].array, c = s.length / o;
            if (!$1d56c6a18dbfd30f$var$p(s)) throw new Error(i + " must be array to build unique vertex.");
            r[i] = s, e[i] = new s.constructor(a * c);
        }
        let s = 0;
        for(let i = 0; i < a; i++){
            const a = t[i];
            for(let t = 0; t < n.length; t++){
                const i = n[t], c = e[i], l = r[i].length / o;
                for(let e = 0; e < l; e++)c[s * l + e] = r[i][a * l + e];
            }
            t[i] = s++;
        }
        i = this.data[this.desc.positionAttribute], this._vertexCount = Math.ceil(i.length / this.desc.positionSize), delete this._reglData;
    }
    getMemorySize() {
        let e = 0;
        for(const t in this.data)$1d56c6a18dbfd30f$var$S(this.data, t) && (e += $1d56c6a18dbfd30f$var$T(this.data[t]));
        if (this.elements) {
            const t = this.elements;
            t.destroy ? e += t._elements.buffer.byteLength : t.BYTES_PER_ELEMENT ? e += t.length * t.BYTES_PER_ELEMENT : t.length && (e += 4 * t.length);
        }
        return e;
    }
    _deleteVAO() {
        for(const e in this._vao)this._vao[e].vao.destroy();
        this._vao = {};
    }
    _forEachBuffer(e) {
        this.elements && this.elements.destroy && e(this.elements);
        for(const t in this.data)$1d56c6a18dbfd30f$var$S(this.data, t) && this.data[t] && this.data[t].buffer && this.data[t].buffer.destroy && e(this.data[t].buffer);
        for(const t in this._buffers)$1d56c6a18dbfd30f$var$S(this._buffers, t) && this._buffers[t] && this._buffers[t].buffer && this._buffers[t].buffer.destroy && e(this._buffers[t].buffer);
    }
    getElementsType(e) {
        return e instanceof Uint8Array ? "uint8" : e instanceof Uint16Array ? "uint16" : e instanceof Uint32Array ? "uint32" : void 0;
    }
    _incrVersion() {
        this._version++;
    }
}
function $1d56c6a18dbfd30f$var$Q(e) {
    if ($1d56c6a18dbfd30f$var$g(e)) return e;
    if (void 0 !== e.count) return e.count;
    if (e.destroy) return e._elements.vertCount;
    if (void 0 !== e.length) return e.length;
    if (e.data) return e.data.length;
    throw new Error("invalid elements length");
}
const $1d56c6a18dbfd30f$var$$ = [
    "points",
    "lines",
    "line strip",
    "line loop",
    "triangles",
    "triangle strip",
    "triangle fan"
];
function $1d56c6a18dbfd30f$var$ee(e) {
    return $1d56c6a18dbfd30f$var$$[e];
}
const $1d56c6a18dbfd30f$var$te = {
    5121: "uint8",
    5123: "uint16",
    5125: "uint32",
    5126: "float",
    36193: "half float"
};
function $1d56c6a18dbfd30f$var$ne(e) {
    return $1d56c6a18dbfd30f$var$te[e];
}
const $1d56c6a18dbfd30f$var$re = {
    6406: "alpha",
    6407: "rgb",
    6408: "rgba",
    6409: "luminance",
    6410: "luminance alpha",
    33776: "rgb s3tc dxt1",
    33777: "rgba s3tc dxt1",
    33778: "rgba s3tc dxt3",
    33779: "rgba s3tc dxt5",
    35840: "rgb pvrtc 4bppv1",
    35841: "rgb pvrtc 2bppv1",
    35842: "rgba pvrtc 4bppv1",
    35843: "rgba pvrtc 2bppv1",
    35986: "rgb atc",
    35987: "rgba atc explicit alpha",
    34798: "rgba atc interpolated alpha",
    36196: "rgb etc1"
};
function $1d56c6a18dbfd30f$var$ie(e) {
    return $1d56c6a18dbfd30f$var$re[e];
}
const $1d56c6a18dbfd30f$var$oe = {
    9729: "linear",
    9728: "nearest"
};
function $1d56c6a18dbfd30f$var$ae(e) {
    return $1d56c6a18dbfd30f$var$oe[e];
}
const $1d56c6a18dbfd30f$var$se = {
    9729: "linear",
    9728: "nearest",
    9984: "nearest mipmap nearest",
    9985: "linear mipmap nearest",
    9986: "nearest mipmap linear",
    9987: "linear mipmap linear"
};
function $1d56c6a18dbfd30f$var$ce(e) {
    return $1d56c6a18dbfd30f$var$se[e];
}
const $1d56c6a18dbfd30f$var$le = {
    10497: "repeat",
    33071: "clamp",
    33648: "mirror"
};
function $1d56c6a18dbfd30f$var$fe(e) {
    return $1d56c6a18dbfd30f$var$le[e];
}
const $1d56c6a18dbfd30f$var$de = "__reshader_webgl_buffer", $1d56c6a18dbfd30f$var$ue = "__reshader_webgl_tex";
function $1d56c6a18dbfd30f$var$he(e, t, n) {
    let r;
    if ($1d56c6a18dbfd30f$var$p(t) ? t.buffer && void 0 !== t.byteOffset && (r = t) : t.array && t.array.buffer && void 0 !== t.array.byteOffset && (r = t.array), !r) return null;
    const i = r.buffer, o = r.byteOffset;
    i[$1d56c6a18dbfd30f$var$de] || (i[$1d56c6a18dbfd30f$var$de] = {});
    let a = i[$1d56c6a18dbfd30f$var$de][o];
    if (!a) {
        const t = {};
        n && $1d56c6a18dbfd30f$var$v(t, n), t.data = r, a = e.buffer(t), i[$1d56c6a18dbfd30f$var$de][o] = a;
    }
    return a;
}
function $1d56c6a18dbfd30f$var$me(e, t) {
    const n = t.data;
    if (!n || !n.buffer) return e.texture(t);
    const r = n.buffer, i = n.byteOffset;
    r[$1d56c6a18dbfd30f$var$ue] || (r[$1d56c6a18dbfd30f$var$ue] = {});
    let o = r[$1d56c6a18dbfd30f$var$ue][i];
    return o || (o = e.texture(t), r[$1d56c6a18dbfd30f$var$ue][i] = o), o;
}
var $1d56c6a18dbfd30f$export$a7945c105868e82f = Object.freeze({
    __proto__: null,
    getMaterialFormat: $1d56c6a18dbfd30f$var$ie,
    getMaterialType: $1d56c6a18dbfd30f$var$ne,
    getPrimitive: $1d56c6a18dbfd30f$var$ee,
    getTextureMagFilter: $1d56c6a18dbfd30f$var$ae,
    getTextureMinFilter: $1d56c6a18dbfd30f$var$ce,
    getTextureWrap: $1d56c6a18dbfd30f$var$fe,
    getUniqueREGLBuffer: $1d56c6a18dbfd30f$var$he,
    getUniqueTexture: $1d56c6a18dbfd30f$var$me
});
const $1d56c6a18dbfd30f$var$_e = [
    0,
    0,
    0
], $1d56c6a18dbfd30f$var$ge = [
    0,
    0,
    0
], $1d56c6a18dbfd30f$var$xe = [
    0,
    0,
    0
], $1d56c6a18dbfd30f$var$pe = [], $1d56c6a18dbfd30f$var$be = [], $1d56c6a18dbfd30f$var$ye = [], $1d56c6a18dbfd30f$var$Ae = [
    "a",
    "b",
    "c"
];
class $1d56c6a18dbfd30f$export$269349b0cbfdd78c extends $1d56c6a18dbfd30f$export$2db6c17465f94a2 {
    constructor(e, t, n, r){
        super(e, t, n, {
            primitive: $1d56c6a18dbfd30f$var$ee(1),
            positionAttribute: r.positionAttribute
        });
    }
    _getPosAttritute() {
        const e = this.data[this.desc.positionAttribute];
        if (!e.length) return [];
        const t = Math.pow(10, 4), n = Math.cos(Math.PI / 180 * .8), r = this.elements, i = e.length ? e : e.array, o = r.length ? r ? r.length : i.length / 3 : r, a = [
            0,
            0,
            0
        ], s = new Array(3), c = {}, l = [], f = new $1d56c6a18dbfd30f$var$Te;
        for(let e = 0; e < o; e += 3){
            r.length ? (a[0] = r[e], a[1] = r[e + 1], a[2] = r[e + 2]) : (a[0] = e, a[1] = e + 1, a[2] = e + 2), f.a = $1d56c6a18dbfd30f$var$Me($1d56c6a18dbfd30f$var$pe, i, a[0]), f.b = $1d56c6a18dbfd30f$var$Me($1d56c6a18dbfd30f$var$be, i, a[1]), f.c = $1d56c6a18dbfd30f$var$Me($1d56c6a18dbfd30f$var$ye, i, a[2]);
            const o = f.getNormal(), d = f.a, u = f.b, h = f.c;
            if (s[0] = `${Math.round(d[0] * t)},${Math.round(d[1] * t)},${Math.round(d[2] * t)}`, s[1] = `${Math.round(u[0] * t)},${Math.round(u[1] * t)},${Math.round(u[2] * t)}`, s[2] = `${Math.round(h[0] * t)},${Math.round(h[1] * t)},${Math.round(h[2] * t)}`, s[0] !== s[1] && s[1] !== s[2] && s[2] !== s[0]) for(let e = 0; e < 3; e++)this._calEdgeData(e, a, f, c, s, n, o, l);
        }
        for(const e in c)if (c[e]) {
            const { index0: t, index1: n } = c[e];
            l.push(i[3 * t], i[3 * t + 1], i[3 * t + 2]), l.push(i[3 * n], i[3 * n + 1], i[3 * n + 2]);
        }
        return this.elements = this._createElements(l), l;
    }
    _calEdgeData(e, n, r, i, o, a, s, c) {
        const l = (e + 1) % 3, f = o[e], d = o[l], u = r[$1d56c6a18dbfd30f$var$Ae[e]], h = r[$1d56c6a18dbfd30f$var$Ae[l]], m = `${f}_${d}`, v = `${d}_${f}`;
        if (v in i && i[v]) (0, $eIStk).dot(s, i[v].normal) <= a && (c.push(u[0], u[1], u[2]), c.push(h[0], h[1], h[2])), i[v] = null;
        else m in i || (i[m] = {
            index0: n[e],
            index1: n[l],
            normal: (0, $eIStk).copy([
                0,
                0,
                0
            ], s)
        });
    }
    _createElements(e) {
        const t = [], n = e.length / 3;
        for(let e = 0; e < n; e++)t.push(e);
        return t;
    }
}
class $1d56c6a18dbfd30f$var$Te {
    constructor(e = [
        0,
        0,
        0
    ], t = [
        0,
        0,
        0
    ], n = [
        0,
        0,
        0
    ]){
        this.a = e, this.b = t, this.c = n;
    }
    getNormal() {
        const e = (0, $eIStk).sub($1d56c6a18dbfd30f$var$_e, this.a, this.b), n = (0, $eIStk).sub($1d56c6a18dbfd30f$var$ge, this.a, this.c);
        (0, $eIStk).cross($1d56c6a18dbfd30f$var$xe, e, n);
        const r = (0, $eIStk).length($1d56c6a18dbfd30f$var$xe);
        return (0, $eIStk).set($1d56c6a18dbfd30f$var$xe, $1d56c6a18dbfd30f$var$xe[0] / r, $1d56c6a18dbfd30f$var$xe[1] / r, $1d56c6a18dbfd30f$var$xe[2] / r);
    }
}
function $1d56c6a18dbfd30f$var$Me(e, n, r) {
    return (0, $eIStk).set(e, n[3 * r], n[3 * r + 1], n[3 * r + 2]);
}
class $1d56c6a18dbfd30f$var$Oe {
}
class $1d56c6a18dbfd30f$export$a2d8b23205c25948 extends $1d56c6a18dbfd30f$var$N($1d56c6a18dbfd30f$var$Oe) {
    constructor(e = {}, t){
        super(), this._version = 0, this._propVerion = 0, this.uniforms = $1d56c6a18dbfd30f$var$_({}, t || {}, e);
        for(const t in e){
            const n = Object.getOwnPropertyDescriptor(e, t).get;
            n && Object.defineProperty(this.uniforms, t, {
                get: n
            });
        }
        this.unlit = !1, this._reglUniforms = {}, this.refCount = 0, this._bindedOnTextureComplete = (...e)=>this._onTextureComplete.call(this, ...e), this._genUniformKeys(), this._checkTextures();
    }
    set version(e) {
        throw new Error("Material.version is read only.");
    }
    get version() {
        return this._version;
    }
    get propVersion() {
        return this._propVerion;
    }
    set doubleSided(e) {
        this.uniforms.doubleSided = e;
    }
    get doubleSided() {
        return !!this.uniforms.doubleSided;
    }
    isReady() {
        return this._loadingCount <= 0;
    }
    set(e, t) {
        const n = $1d56c6a18dbfd30f$var$u(this.uniforms[e]) && !$1d56c6a18dbfd30f$var$u(t) || !$1d56c6a18dbfd30f$var$u(this.uniforms[e]) && $1d56c6a18dbfd30f$var$u(t);
        if (this.uniforms[e] && this.isTexture(e) && this.uniforms[e].dispose(), $1d56c6a18dbfd30f$var$u(t)) $1d56c6a18dbfd30f$var$u(this.uniforms[e]) || delete this.uniforms[e];
        else if (this.uniforms[e] = t, this._reglUniforms) {
            const n = Object.getOwnPropertyDescriptor(this._reglUniforms, e);
            n && !n.get && (this._propVerion++, this._reglUniforms[e] = t);
        }
        return this.isTexture(e) && this._checkTextures(), n && (this._genUniformKeys(), this._incrVersion()), this;
    }
    setFunctionUniform(e, t) {
        return this._genUniformKeys(), this._incrVersion(), Object.defineProperty(this.uniforms, e, {
            enumerable: !0,
            get: t
        }), this;
    }
    hasFunctionUniform(e) {
        return !!this.uniforms && Object.prototype.hasOwnProperty.call(this.uniforms, e);
    }
    get(e) {
        return this.uniforms[e];
    }
    isDirty() {
        return this._uniformVer !== this.version;
    }
    appendDefines(e, t) {
        const n = this.uniforms;
        return n ? (n.jointTexture && (e.HAS_SKIN = 1), n.morphWeights1 && (e.HAS_MORPH = 1), (n.khr_offset || n.khr_rotation || n.khr_scale) && (e.HAS_KHR_TEXTURE_TRANSFORM = 1), e) : e;
    }
    hasSkinAnimation() {
        return !!(this.uniforms && this.uniforms.jointTexture && this.uniforms.skinAnimation);
    }
    getUniforms(e) {
        if (this._reglUniforms && !this.isDirty()) return this._reglUniforms;
        const t = this.uniforms, n = {};
        for(const r in t)if (this.isTexture(r)) Object.defineProperty(n, r, {
            enumerable: !0,
            configurable: !0,
            get: function() {
                return t[r].getREGLTexture(e);
            }
        });
        else Object.getOwnPropertyDescriptor(t, r).get ? Object.defineProperty(n, r, {
            enumerable: !0,
            configurable: !0,
            get: function() {
                return t[r];
            }
        }) : n[r] = t[r];
        return this._reglUniforms = n, this._uniformVer = this.version, n;
    }
    isTexture(e) {
        return this.uniforms[e] instanceof $1d56c6a18dbfd30f$export$e05be2fb829060c2;
    }
    dispose() {
        for(const e in this.uniforms){
            const t = this.uniforms[e];
            t && (t.dispose ? t.dispose() : t.destroy && !t[$1d56c6a18dbfd30f$var$L] && (t.destroy(), t[$1d56c6a18dbfd30f$var$L] = !0));
        }
        delete this.uniforms, delete this._reglUniforms, delete this._bindedOnTextureComplete, this._disposed = !0;
    }
    isDisposed() {
        return !!this._disposed;
    }
    _checkTextures() {
        this._loadingCount = 0;
        for(const e in this.uniforms)if (this.isTexture(e)) {
            const t = this.uniforms[e];
            t.isReady() || (this._loadingCount++, t.on("complete", this._bindedOnTextureComplete));
        }
    }
    _onTextureComplete() {
        this._loadingCount--, this._incrVersion(), this._loadingCount <= 0 && (this._disposed || this.fire("complete"));
    }
    getUniformKeys() {
        return this._uniformKeys;
    }
    _genUniformKeys() {
        const e = [];
        for(const t in this.uniforms)$1d56c6a18dbfd30f$var$S(this.uniforms, t) && !$1d56c6a18dbfd30f$var$u(this.uniforms[t]) && e.push(t);
        this._uniformKeys = e.join();
    }
    _incrVersion() {
        this._version++;
    }
    getMemorySize() {
        const e = this.uniforms;
        let t = 0;
        for(const n in e)this.isTexture(n) ? t += e[n].getMemorySize() : this.uniforms[n] && this.uniforms[n].destroy && (t += $1d56c6a18dbfd30f$var$M(this.uniforms[n]));
        return t;
    }
}
const $1d56c6a18dbfd30f$var$Ee = {
    time: 0,
    seeThrough: !0,
    thickness: .03,
    fill: [
        1,
        .5137254902,
        .98,
        1
    ],
    stroke: [
        .7019607843,
        .9333333333,
        .2274509804,
        1
    ],
    dashEnabled: !1,
    dashAnimate: !1,
    dashRepeats: 1,
    dashLength: .8,
    dashOverlap: !0,
    insideAltColor: !1,
    squeeze: !1,
    squeezeMin: .5,
    squeezeMax: 1,
    dualStroke: !1,
    secondThickness: .05,
    opacity: 1,
    noiseEnable: !1
};
class $1d56c6a18dbfd30f$export$9305addea90162cc extends $1d56c6a18dbfd30f$export$a2d8b23205c25948 {
    constructor(e){
        super(e, $1d56c6a18dbfd30f$var$Ee);
    }
}
const $1d56c6a18dbfd30f$var$we = {
    baseColorFactor: [
        1,
        1,
        1,
        1
    ],
    materialShininess: 32,
    environmentExposure: 1,
    specularStrength: 32,
    opacity: 1,
    extrusionOpacity: 0,
    extrusionOpacityRange: [
        0,
        1.8
    ],
    baseColorTexture: null,
    normalTexture: null,
    emissiveTexture: null,
    occlusionTexture: null,
    uvScale: [
        1,
        1
    ],
    uvOffset: [
        0,
        0
    ],
    alphaTest: 0
};
class $1d56c6a18dbfd30f$export$7d1ec2d75ed228db extends $1d56c6a18dbfd30f$export$a2d8b23205c25948 {
    constructor(e){
        super(e, $1d56c6a18dbfd30f$var$we);
    }
    static convertFrom(e) {
        const t = {};
        for(const n in $1d56c6a18dbfd30f$var$we)t[n] = e.get(n);
        return new $1d56c6a18dbfd30f$export$7d1ec2d75ed228db(t);
    }
    appendDefines(e, t) {
        super.appendDefines(e, t);
        const n = this.uniforms;
        n.extrusionOpacity && (e.HAS_EXTRUSION_OPACITY = 1), t.data[t.desc.colorAttribute] && (e.HAS_COLOR = 1);
        return t.data[t.desc.color0Attribute] && (e.HAS_COLOR0 = 1, e.COLOR0_SIZE = t.getColor0Size()), t.data.aVertexColorType && (e.HAS_VERTEX_COLOR = 1), t.data[t.desc.tangentAttribute] ? e.HAS_TANGENT = 1 : t.data[t.desc.normalAttribute] && (e.HAS_NORMAL = 1), t.data[t.desc.uv0Attribute] ? (n.baseColorTexture && (e.HAS_BASECOLOR_MAP = 1), n.occlusionTexture && t.data[t.desc.uv1Attribute] && (e.HAS_AO_MAP = 1), n.emissiveTexture && (e.HAS_EMISSIVE_MAP = 1), n.normalTexture && (e.HAS_NORMAL_MAP = 1), (e.HAS_BASECOLOR_MAP || e.HAS_AO_MAP || e.HAS_EMISSIVE_MAP || e.HAS_NORMAL_MAP) && (e.HAS_MAP = 1), e) : e;
    }
}
const $1d56c6a18dbfd30f$var$Re = {
    baseColorFactor: [
        1,
        1,
        1,
        1
    ],
    uvScale: [
        1,
        1
    ],
    uvOffset: [
        0,
        0
    ],
    opacity: 1,
    envMapExposure: 128,
    emissiveFactor: [
        .1,
        .1,
        .1
    ],
    specularFactor: [
        0,
        0,
        0
    ],
    envRotationSin: 0,
    envRotationCos: 1,
    reflectivity: .01,
    themingColor: [
        0,
        0,
        0,
        0
    ],
    exposureBias: .6
};
class $1d56c6a18dbfd30f$export$507a82ff128c1f16 extends $1d56c6a18dbfd30f$export$a2d8b23205c25948 {
    constructor(e){
        super(e, $1d56c6a18dbfd30f$var$Re);
    }
    appendDefines(e, t) {
        super.appendDefines(e, t);
        const n = this.uniforms;
        n.extrusionOpacity && (e.HAS_EXTRUSION_OPACITY = 1), t.data[t.desc.colorAttribute] && (e.HAS_COLOR = 1);
        return t.data[t.desc.color0Attribute] && (e.HAS_COLOR0 = 1, e.COLOR0_SIZE = t.getColor0Size()), t.data[t.desc.uv0Attribute] ? (n.baseColorTexture && (e.HAS_BASECOLOR_MAP = 1), n.occlusionTexture && t.data[t.desc.uv1Attribute] && (e.HAS_AO_MAP = 1), n.emissiveTexture && (e.HAS_EMISSIVE_MAP = 1), n.normalTexture && (e.HAS_NORMAL_MAP = 1), (e.HAS_BASECOLOR_MAP || e.HAS_AO_MAP || e.HAS_EMISSIVE_MAP || e.HAS_NORMAL_MAP) && (e.HAS_MAP = 1), e.ALPHATEST = .01, e.GAMMA_INPUT = 1, e.GAMMA_FACTOR = 1, e.TONEMAP_OUTPUT = 1, e.ENVMAP_MODE_REFLECTION = 1, e.ENV_RGBM = 1, e.IRR_RGBM = 1, e) : e;
    }
}
const $1d56c6a18dbfd30f$var$De = {
    diffuseFactor: [
        1,
        1,
        1,
        1
    ],
    specularFactor: [
        1,
        1,
        1
    ],
    glossinessFactor: 1,
    diffuseTexture: null,
    specularGlossinessTexture: null,
    normalTexture: null,
    emissiveTexture: null,
    occlusionTexture: null
};
function $1d56c6a18dbfd30f$var$Fe(e) {
    return class extends e {
        constructor(...e){
            let t = e[0];
            t = $1d56c6a18dbfd30f$var$v({}, $1d56c6a18dbfd30f$var$De, t || {}), super(t, e);
        }
        appendDefines(e, t) {
            if (super.appendDefines(e, t), e.SHADING_MODEL_SPECULAR_GLOSSINESS = 1, !t.data[t.desc.uv0Attribute]) return e;
            const n = this.uniforms;
            return n.diffuseTexture && (e.HAS_DIFFUSE_MAP = 1), n.specularGlossinessTexture && (e.HAS_SPECULARGLOSSINESS_MAP = 1), (e.HAS_SPECULARGLOSSINESS_MAP || e.HAS_DIFFUSE_MAP) && (e.HAS_MAP = 1), e;
        }
    };
}
class $1d56c6a18dbfd30f$export$9675f394e75cd3f3 extends $1d56c6a18dbfd30f$var$Fe($1d56c6a18dbfd30f$export$7d1ec2d75ed228db) {
}
const $1d56c6a18dbfd30f$var$Le = new Array(16);
let $1d56c6a18dbfd30f$var$ke = 0;
class $1d56c6a18dbfd30f$export$e176487c05830cc5 {
    constructor(t, n, r = {}){
        this._version = 0, this._geometry = t, this._material = n, this.transparent = !!r.transparent, this.bloom = !!r.bloom, this.ssr = !!r.ssr, this._castShadow = $1d56c6a18dbfd30f$var$u(r.castShadow) || r.castShadow, this.needUpdateShadow = !1, this.picking = !!r.picking, this.disableVAO = !!r.disableVAO, this.uniforms = {}, this._localTransform = (0, $3iqbd).identity(new Array(16)), this._positionMatrix = (0, $3iqbd).identity(new Array(16)), this.properties = {}, this._dirtyUniforms = !0, this._dirtyGeometry = !0, Object.defineProperty(this, "uuid", {
            value: $1d56c6a18dbfd30f$var$ke++
        }), $1d56c6a18dbfd30f$var$ke > Number.MAX_VALUE - 10 && ($1d56c6a18dbfd30f$var$ke = 0);
    }
    set material(e) {
        this._material !== e && this.setMaterial(e);
    }
    get material() {
        return this._material;
    }
    set version(e) {
        throw new Error("Mesh.version is read only.");
    }
    get version() {
        return this._version;
    }
    get geometry() {
        return this._geometry;
    }
    set geometry(e) {
        this._geometry !== e && (this._incrVersion(), this._dirtyGeometry = !0), this._geometry = e;
    }
    set localTransform(t) {
        this._prevTMat || (this._prevTMat = new Array(16)), Array.isArray(t) && !(0, $3iqbd).exactEquals(this._prevTMat, t) && (this._incrVersion(), this._prevTMat = (0, $3iqbd).copy(this._prevTMat, t)), this._localTransform = t;
    }
    get localTransform() {
        return $1d56c6a18dbfd30f$var$m(this._localTransform) ? this._localTransform() : this._localTransform;
    }
    set positionMatrix(t) {
        this._prevPMat || (this._prevPMat = new Array(16)), Array.isArray(t) && !(0, $3iqbd).exactEquals(this._prevPMat, t) && (this._incrVersion(), this._prevPMat = (0, $3iqbd).copy(this._prevPMat, t)), this._positionMatrix = t;
    }
    get positionMatrix() {
        return $1d56c6a18dbfd30f$var$m(this._positionMatrix) ? this._positionMatrix() : this._positionMatrix;
    }
    get config() {
        return this._options || (this._options = {}), this._options.transparent = this.transparent, this._options.castShadow = this.castShadow, this._options.bloom = this.bloom, this._options.ssr = this.ssr, this._options.picking = this.picking, this._options;
    }
    get defines() {
        return this._getDefines();
    }
    set defines(e) {
        this.setDefines(e);
    }
    get castShadow() {
        return this._castShadow && (!this.material || !this.material.unlit);
    }
    set castShadow(e) {
        this._castShadow = e;
    }
    setMaterial(e) {
        return this._material = e, this._dirtyUniforms = !0, delete this._materialVer, this.dirtyDefines = !0, this;
    }
    setParent(e) {
        return this.parent = e, this;
    }
    setLocalTransform(e) {
        return this.localTransform = e, this;
    }
    setPositionMatrix(e) {
        this.positionMatrix = e;
    }
    setUniform(e, t) {
        return this._updateUniformState(e), this.uniforms[e] = t, this;
    }
    setFunctionUniform(e, t) {
        return this._updateUniformState(e), Object.defineProperty(this.uniforms, e, {
            enumerable: !0,
            get: t
        }), this;
    }
    hasFunctionUniform(e) {
        return !!this.uniforms && Object.prototype.hasOwnProperty.call(this.uniforms, e);
    }
    _updateUniformState(e) {
        void 0 === this.uniforms[e] ? this._dirtyUniforms = !0 : (this._dirtyProps = this._dirtyProps || [], this._dirtyProps.push(e));
    }
    getUniform(e) {
        return this.uniforms[e];
    }
    getDefines() {
        const e = {};
        return $1d56c6a18dbfd30f$var$v(e, this._getDefines()), this._material && this._geometry && this._material.appendDefines(e, this._geometry), e;
    }
    _getDefines() {
        this._defines || (this._defines = {});
        const e = this._geometry, t = e.data[e.desc.positionAttribute], n = e.data[e.desc.uv0Attribute], r = e.data[e.desc.normalAttribute];
        return t && t.quantization && (this._defines.HAS_DRACO_POSITION = 1), n && n.quantization && (this._defines.HAS_DRACO_TEXCOORD = 1), r && r.quantization && (this._defines.HAS_DRACO_NORMAL = 1), this._defines;
    }
    setDefines(e) {
        const t = this._bakDefines;
        return this._defines = e, this.dirtyDefines = this.dirtyDefines || !!t != !!e || !function(e, t) {
            if (!e && !t) return !0;
            const n = Object.getOwnPropertyNames(e), r = Object.getOwnPropertyNames(t);
            if (n.length !== r.length) return !1;
            for(let r = 0; r < n.length; r++)if (e[n[r]] !== t[n[r]]) return !1;
            return !0;
        }(t, e), this.dirtyDefines && (this._bakDefines = $1d56c6a18dbfd30f$var$v({}, e)), this;
    }
    hasSkinAnimation() {
        return this._material && this._material.hasSkinAnimation();
    }
    _getDefinesKey() {
        return this.dirtyDefines = !1, this._createDefinesKey(this.getDefines());
    }
    getCommandKey(e) {
        if (!this._commandKey || this.dirtyDefines || this._material && this._materialKeys !== this._material.getUniformKeys()) {
            let e = this._getDefinesKey();
            e += "_" + ($1d56c6a18dbfd30f$var$g(this.getElements()) ? "count" : "elements"), e += "_" + +!!this.disableVAO, this._material && (e += "_" + +!!this._material.doubleSided), this._commandKey = e, this._material && (this._materialKeys = this._material.getUniformKeys());
        }
        return this._commandKey;
    }
    getUniforms(e) {
        if (this._dirtyUniforms || this._dirtyGeometry || this._material && this._materialVer !== this._material.version) {
            this._uniformDescriptors = new Set, this._realUniforms = {}, this._prepareUniformsForDraco();
            const t = this.uniforms;
            for(const e in this.uniforms)if ($1d56c6a18dbfd30f$var$S(this.uniforms, e)) Object.getOwnPropertyDescriptor(t, e).get ? (this._uniformDescriptors.add(e), Object.defineProperty(this._realUniforms, e, {
                enumerable: !0,
                configurable: !0,
                get: function() {
                    return t[e];
                }
            })) : this._realUniforms[e] = t[e];
            if (this._material) {
                const t = this._material.getUniforms(e);
                for(const e in t)if ($1d56c6a18dbfd30f$var$S(t, e) && !$1d56c6a18dbfd30f$var$S(this._realUniforms, e)) Object.getOwnPropertyDescriptor(t, e).get ? (this._uniformDescriptors.add(e), Object.defineProperty(this._realUniforms, e, {
                    enumerable: !0,
                    configurable: !0,
                    get: function() {
                        return t[e];
                    }
                })) : void 0 === this._realUniforms[e] && (this._realUniforms[e] = t[e]);
            }
            this._dirtyUniforms = !1, this._dirtyGeometry = !1, this._materialVer = this._material && this._material.version, this._materialPropVer = this._material && this._material.propVersion, this._dirtyProps = null;
        } else if (this._dirtyProps || this._material && this._material.propVersion !== this._materialPropVer) {
            if (this._dirtyProps) for (const e of this._dirtyProps)this._realUniforms[e] = this.uniforms[e];
            if (this._material && this._material.propVersion !== this._materialPropVer) {
                const t = this._material.getUniforms(e);
                for(const e in t)if ($1d56c6a18dbfd30f$var$S(t, e) && !this._uniformDescriptors.has(e)) Object.getOwnPropertyDescriptor(t, e).get || this._realUniforms[e] === t[e] || (this._realUniforms[e] = t[e]);
                this._materialPropVer = this._material.propVersion;
            }
            this._dirtyProps = null;
        }
        return this._realUniforms.modelMatrix = this.localTransform, this._realUniforms.positionMatrix = this.positionMatrix, this._realUniforms;
    }
    _prepareUniformsForDraco() {
        const e = this._geometry, t = e.data[e.desc.positionAttribute], n = e.data[e.desc.uv0Attribute], r = e.data[e.desc.normalAttribute];
        if (t && t.quantization) {
            const e = t.quantization, n = e.range / (1 << e.quantizationBits);
            this._realUniforms.minValues_pos = e.minValues, this._realUniforms.gltf_u_dec_position_normConstant = n;
        }
        if (n && n.quantization) {
            const e = n.quantization;
            this._realUniforms.minValues_tex = e.minValues;
            this._realUniforms.gltf_u_dec_texcoord_0_normConstant = e.range / (1 << e.quantizationBits);
        }
        if (r && r.quantization) this._realUniforms.gltf_u_dec_normal_rangeConstant = (1 << r.quantization.quantizationBits) - 1;
    }
    getMaterial() {
        return this._material;
    }
    getElements() {
        return this._geometry.getElements();
    }
    _getREGLAttrData(e, t) {
        return this._geometry.getREGLData(e, t, this.disableVAO);
    }
    getREGLProps(e, t) {
        const n = this.getUniforms(e);
        return $1d56c6a18dbfd30f$var$v(n, this._getREGLAttrData(e, t)), $1d56c6a18dbfd30f$var$A(e) && !this.disableVAO || (n.elements = this._geometry.getElements()), n.meshProperties = this.properties, n.geometryProperties = this._geometry.properties, n.meshConfig = this.config, n.count = this._geometry.getDrawCount(), n.offset = this._geometry.getDrawOffset(), n.primitive = this._geometry.getPrimitive(), n;
    }
    dispose() {
        return delete this._geometry, delete this._material, this.uniforms = null, this;
    }
    isValid() {
        return this._geometry && !this._geometry.isDisposed() && (!this._material || !this._material.isDisposed());
    }
    getBoundingBox() {
        return this._geometry ? (this._bbox || this.updateBoundingBox(), (0, $3iqbd).multiply($1d56c6a18dbfd30f$var$Le, this.localTransform, this.positionMatrix), (0, $3iqbd).exactEquals($1d56c6a18dbfd30f$var$Le, this._currentTransform) && this._geometry.boundingBox.equals(this._geoBox) || this.updateBoundingBox(), this._bboxArr) : null;
    }
    updateBoundingBox() {
        const n = this._geometry.boundingBox;
        this._bbox || (this._bbox = new $1d56c6a18dbfd30f$export$63080c4de6cfc362), this._bboxArr || (this._bboxArr = [
            [
                0,
                0,
                0
            ],
            [
                0,
                0,
                0
            ]
        ]), this._geoBox || (this._geoBox = new $1d56c6a18dbfd30f$export$63080c4de6cfc362), $1d56c6a18dbfd30f$export$63080c4de6cfc362.copy(this._bbox, n), this._bbox.updateVertex(), "InstancedMesh" === this.constructor.name ? (this._bbox.transform(this.localTransform, this.positionMatrix), this._currentTransform = (0, $3iqbd).multiply(this._currentTransform || new Array(16), this.positionMatrix, this.localTransform)) : (this._bbox.transform(this.positionMatrix, this.localTransform), this._currentTransform = (0, $3iqbd).multiply(this._currentTransform || new Array(16), this.localTransform, this.positionMatrix)), $1d56c6a18dbfd30f$export$63080c4de6cfc362.copy(this._geoBox, n), (0, $eIStk).copy(this._bboxArr[0], this._bbox.min), (0, $eIStk).copy(this._bboxArr[1], this._bbox.max);
    }
    _createDefinesKey(e) {
        const t = [];
        for(const n in e)t.push(n, e[n]);
        return t.join(",");
    }
    _incrVersion() {
        this._version++;
    }
    getMemorySize() {
        return (this.geometry && this.geometry.getMemorySize() || 0) + (this.material && this.material.getMemorySize() || 0);
    }
    getWorldTransform() {
        const t = this.parent;
        return t ? (0, $3iqbd).multiply(new Array(16), t.getWorldTransform(), this.localTransform) : this.localTransform;
    }
}
class $1d56c6a18dbfd30f$export$f3c979c331175ad7 extends $1d56c6a18dbfd30f$export$e176487c05830cc5 {
    constructor(e, t, n, r, i = {}){
        super(n, r, i), this._instanceCount = t, this.instancedData = e || {}, this._checkInstancedProp(), this._vao = {};
    }
    get instanceCount() {
        return this._instanceCount;
    }
    set instanceCount(e) {
        this._incrVersion(), this._instanceCount = e;
    }
    getMemorySize() {
        return super.getMemorySize() + this._getInstanceMemorySize();
    }
    _getInstanceMemorySize() {
        let e = 0;
        for(const t in this.instancedData)$1d56c6a18dbfd30f$var$S(this.instancedData, t) && (e += $1d56c6a18dbfd30f$var$T(this.instancedData[t]));
        return e;
    }
    _checkInstancedProp() {
        for(const e in this.instancedData)if (this.geometry.data[e]) throw new Error(`Duplicate attribute ${e} defined in geometry and instanced data`);
    }
    _getREGLAttrData(e, t) {
        const n = this.geometry.getAttrData(t);
        if ($1d56c6a18dbfd30f$var$A(e)) {
            const r = t.key;
            if (!this._vao[r] || this._vao[r].dirty) {
                const i = t.map((e)=>e.name), o = [];
                for(let e = 0; e < i.length; e++){
                    const t = n[i[e]];
                    o.push(t && t.buffer || this.instancedData[i[e]]);
                }
                const a = {
                    attributes: o,
                    primitive: this.geometry.getPrimitive()
                };
                this._vao[r] ? this._vao[r].vao(a) : this._vao[r] = {
                    vao: e.vao(a)
                }, delete this._vao[r].dirty;
            }
            return this._vao[r];
        }
        return n;
    }
    getDefines() {
        const e = super.getDefines();
        return e.HAS_INSTANCE = 1, e;
    }
    getCommandKey(e) {
        return "i_" + super.getCommandKey(e);
    }
    updateInstancedData(e, t) {
        const n = this.instancedData[e];
        if (this._incrVersion(), this.instancedData[e] = t, n && n.buffer && n.buffer.destroy && n.buffer.destroy(), this._vao) for(const e in this._vao)this._vao[e].dirty = !0;
        return this;
    }
    generateInstancedBuffers(e) {
        const t = this.instancedData, n = {};
        for(const r in t){
            if (!t[r]) continue;
            const i = t[r];
            void 0 !== i.buffer && i.buffer.destroy ? (n[r] = i, n[r].divisor && (n[r].divisor = 1)) : n[r] = t[r].destroy ? {
                buffer: t[r],
                divisor: 1
            } : {
                buffer: e.buffer({
                    data: t[r],
                    dimension: t[r].length / this._instanceCount
                }),
                divisor: 1
            };
        }
        return this.instancedData = n, this;
    }
    getREGLProps(e, t) {
        const n = super.getREGLProps(e, t);
        return $1d56c6a18dbfd30f$var$A(e) || $1d56c6a18dbfd30f$var$v(n, this.instancedData), n.elements = this.geometry.getElements(), n.instances = this._instanceCount, n;
    }
    disposeInstancedData() {
        const e = this.instancedData;
        if (e) for(const t in e){
            if (!e[t]) continue;
            const n = e[t].destroy ? e[t] : e[t].buffer;
            n.destroy && !n[$1d56c6a18dbfd30f$var$L] && (n[$1d56c6a18dbfd30f$var$L] = 1, n.destroy());
        }
        this.instancedData = {};
        for(const e in this._vao)this._vao[e].vao.destroy();
        this._vao = {};
    }
}
const $1d56c6a18dbfd30f$var$Ge = {};
class $1d56c6a18dbfd30f$export$88530751e3977073 {
    constructor(e){
        this.regl = e;
    }
    render(e, t, n, r) {
        e.setUniforms(t || $1d56c6a18dbfd30f$var$Ge), e.setFramebuffer(r);
        let i = 0;
        if (n) {
            const { opaques: t, transparents: r } = n.getSortedMeshes();
            i += e.draw(this.regl, t), i += e.draw(this.regl, r);
        } else i += e.draw(this.regl);
        return i;
    }
    clear(e) {
        this.regl.clear(e);
    }
}
const $1d56c6a18dbfd30f$var$Ue = {
    getArrayBuffer: (e, t)=>$1d56c6a18dbfd30f$var$Ue.get(e, {
            responseType: "arraybuffer"
        }, t),
    get: function(e, t, n) {
        const r = $1d56c6a18dbfd30f$var$Ue._getClient(n);
        if (r.open("GET", e, !0), t) {
            for(const e in t.headers)r.setRequestHeader(e, t.headers[e]);
            r.withCredentials = "include" === t.credentials, t.responseType && (r.responseType = t.responseType);
        }
        return r.send(null), r;
    },
    _wrapCallback: function(e, t) {
        return function() {
            if (4 === e.readyState) {
                if (200 === e.status) {
                    if ("arraybuffer" === e.responseType) 0 === e.response.byteLength ? t(new Error("http status 200 returned without content.")) : t(null, {
                        data: e.response,
                        cacheControl: e.getResponseHeader("Cache-Control"),
                        expires: e.getResponseHeader("Expires"),
                        contentType: e.getResponseHeader("Content-Type")
                    });
                    else t(null, e.responseText);
                } else t(new Error(e.statusText + "," + e.status));
            }
        };
    },
    _getClient: function(e) {
        let t;
        try {
            t = new XMLHttpRequest;
        } catch (e) {
            try {
                t = new ActiveXObject("Msxml2.XMLHTTP");
            } catch (e) {
                try {
                    t = new ActiveXObject("Microsoft.XMLHTTP");
                } catch (e) {}
            }
        }
        return t.onreadystatechange = $1d56c6a18dbfd30f$var$Ue._wrapCallback(t, e), t;
    }
};
class $1d56c6a18dbfd30f$var$je {
    constructor(e, t){
        this.defaultTexture = e, this.defaultCubeTexture = new Array(6), this.urlModifier = t, this.resources = {};
    }
    setURLModifier(e) {
        this.urlModifier = e;
    }
    get(e) {
        return Array.isArray(e) ? this._loadImages(e) : this._loadImage(e);
    }
    getArrayBuffer(e) {
        if (Array.isArray(e)) {
            const t = e.map((e)=>this.getArrayBuffer(e));
            return Promise.all(t);
        }
        return new Promise((t, n)=>{
            let r = e;
            this.urlModifier && (r = this.urlModifier(e)), $1d56c6a18dbfd30f$var$Ue.getArrayBuffer(r, (r, i)=>{
                r ? n(r) : t({
                    url: e,
                    data: i
                });
            });
        });
    }
    disposeRes(e) {
        return Array.isArray(e) ? e.forEach((e)=>this._disposeOne(e)) : this._disposeOne(e), this;
    }
    isLoading() {
        return this._count && this._count > 0;
    }
    getDefaultTexture(e) {
        return Array.isArray(e) ? this._getBlankTextures(e.length) : this.defaultTexture;
    }
    _disposeOne(e) {
        const t = this.resources;
        t[e] && (t[e].count--, t[e].count <= 0 && delete t[e]);
    }
    _loadImage(e) {
        const t = this.resources;
        if (t[e]) return Promise.resolve({
            url: e,
            data: t[e].image
        });
        return new Promise((n, r)=>{
            const i = new Image;
            i.crossOrigin = "anonymous", i.onload = function() {
                t[e] = {
                    image: i,
                    count: 1
                }, n({
                    url: e,
                    data: i
                });
            }, i.onerror = function(e) {
                r(e);
            }, i.onabort = function() {
                r(`image(${e}) loading aborted.`);
            }, i.src = this.urlModifier ? this.urlModifier(e) : e;
        });
    }
    _loadImages(e) {
        const t = e.map((e)=>this._loadImage(e));
        return Promise.all(t);
    }
    _getBlankTextures(e) {
        const t = new Array(e);
        for(let e = 0; e < 6; e++)t.push(this.defaultTexture);
        return t;
    }
}
class $1d56c6a18dbfd30f$export$84bade0bc2a1e1 extends $1d56c6a18dbfd30f$var$N($1d56c6a18dbfd30f$var$je) {
}
const $1d56c6a18dbfd30f$var$We = [
    0,
    0,
    0
], $1d56c6a18dbfd30f$var$qe = [
    0,
    0,
    0
];
let $1d56c6a18dbfd30f$var$Ke, $1d56c6a18dbfd30f$var$Je = 0;
function $1d56c6a18dbfd30f$var$Ye(e, n) {
    return (0, $eIStk).transformMat4($1d56c6a18dbfd30f$var$We, e.geometry.boundingBox.getCenter(), e.localTransform), (0, $eIStk).transformMat4($1d56c6a18dbfd30f$var$qe, n.geometry.boundingBox.getCenter(), n.localTransform), (0, $eIStk).dist($1d56c6a18dbfd30f$var$qe, $1d56c6a18dbfd30f$var$Ke) - (0, $eIStk).dist($1d56c6a18dbfd30f$var$We, $1d56c6a18dbfd30f$var$Ke);
}
class $1d56c6a18dbfd30f$export$38af1803e3442a7f {
    constructor(e){
        this._id = $1d56c6a18dbfd30f$var$Je++, this.sortedMeshes = {}, this.setMeshes(e), this.dirty();
    }
    setMeshes(e) {
        if (this.clear(), !e || Array.isArray(e) && !e.length || e === this.meshes) return this;
        e = Array.isArray(e) ? e : [
            e
        ], this.meshes = [];
        for(let t = 0; t < e.length; t++){
            const n = e[t];
            n && (n._scenes = n._scenes || {}, n._scenes[this._id] = 1, this.meshes.push(n));
        }
        return this.dirty(), this;
    }
    addMesh(e) {
        if (!e || Array.isArray(e) && !e.length) return this;
        if (Array.isArray(e)) e.forEach((e)=>{
            const t = e._scenes = e._scenes || {};
            t[this._id] || (t[this._id] = 1, this.meshes.push(e), this.dirty());
        });
        else {
            const t = e._scenes = e._scenes || {};
            t[this._id] || (t[this._id] = 1, this.meshes.push(e), this.dirty());
        }
        return this;
    }
    removeMesh(e) {
        if (!e || Array.isArray(e) && !e.length) return this;
        if (Array.isArray(e)) {
            let t = !1;
            for(let n = 0; n < e.length; n++){
                const r = e[n]._scenes;
                r && r[this._id] && (t = !0, this.dirty(), delete r[this._id]);
            }
            t && (this.meshes = this.meshes.filter((t)=>e.indexOf(t) < 0));
        } else {
            const t = e._scenes;
            if (!t || !t[this._id]) return this;
            const n = this.meshes.indexOf(e);
            n >= 0 && this.meshes.splice(n, 1), delete t[this._id], this.dirty();
        }
        return this;
    }
    getMeshes() {
        return this.meshes || [];
    }
    clear() {
        if (this.meshes) for(let e = 0; e < this.meshes.length; e++)delete this.meshes[e]._scenes[this._id];
        return this.meshes = [], this.sortedMeshes.opaques = [], this.sortedMeshes.transparents = [], this;
    }
    dirty() {
        return this._dirty = !0, this;
    }
    sortMeshes(e) {
        const t = this.meshes;
        this.sortFunction && t.sort(this.sortFunction);
        let n = this.sortedMeshes.transparents;
        if (this._dirty) {
            const e = this.sortedMeshes.opaques = [];
            n = this.sortedMeshes.transparents = [];
            for(let r = 0, i = t.length; r < i; r++)t[r].transparent ? n.push(t[r]) : e.push(t[r]);
        }
        e && n.length > 1 && ($1d56c6a18dbfd30f$var$Ke = e, n.sort($1d56c6a18dbfd30f$var$Ye)), this._dirty = !1;
    }
    getSortedMeshes() {
        return this._dirty && this.sortMeshes(), this.sortedMeshes || {};
    }
}
const $1d56c6a18dbfd30f$var$Qe = String.fromCharCode, $1d56c6a18dbfd30f$var$$e = 8, $1d56c6a18dbfd30f$var$et = 32767;
function $1d56c6a18dbfd30f$var$tt(e, t, n, r) {
    if (e[3] > 0) {
        const i = Math.pow(2, e[3] - 128 - 8 + r);
        t[n + 0] = e[0] * i, t[n + 1] = e[1] * i, t[n + 2] = e[2] * i;
    } else t[n + 0] = 0, t[n + 1] = 0, t[n + 2] = 0;
    return t[n + 3] = 1, t;
}
function $1d56c6a18dbfd30f$var$nt(e, t, n, r) {
    let i = 0, o = 0, a = r;
    for(; a > 0;)if (e[o][0] = t[n++], e[o][1] = t[n++], e[o][2] = t[n++], e[o][3] = t[n++], 1 === e[o][0] && 1 === e[o][1] && 1 === e[o][2]) {
        for(let t = e[o][3] << i >>> 0; t > 0; t--)(c = e[o])[0] = (s = e[o - 1])[0], c[1] = s[1], c[2] = s[2], c[3] = s[3], o++, a--;
        i += 8;
    } else o++, a--, i = 0;
    var s, c;
    return n;
}
function $1d56c6a18dbfd30f$var$rt(e, t, n, r) {
    if (r < $1d56c6a18dbfd30f$var$$e | r > $1d56c6a18dbfd30f$var$et) return $1d56c6a18dbfd30f$var$nt(e, t, n, r);
    let i = t[n++];
    if (2 !== i) return $1d56c6a18dbfd30f$var$nt(e, t, n - 1, r);
    if (e[0][1] = t[n++], e[0][2] = t[n++], i = t[n++], (e[0][2] << 8 >>> 0 | i) >>> 0 !== r) return null;
    for(let i = 0; i < 4; i++)for(let o = 0; o < r;){
        let r = t[n++];
        if (r > 128) {
            r = (127 & r) >>> 0;
            const a = t[n++];
            for(; r--;)e[o++][i] = a;
        } else for(; r--;)e[o++][i] = t[n++];
    }
    return n;
}
function $1d56c6a18dbfd30f$var$it(e, t = 0) {
    const n = new Uint8Array(e), r = n.length;
    if ("#?" !== function(e, t, n) {
        let r = "";
        for(let i = t; i < n; i++)r += $1d56c6a18dbfd30f$var$Qe(e[i]);
        return r;
    }(n, 0, 2)) return null;
    for(var i = 2; i < r && ("\n" !== $1d56c6a18dbfd30f$var$Qe(n[i]) || "\n" !== $1d56c6a18dbfd30f$var$Qe(n[i + 1])); i++);
    if (i >= r) return null;
    i += 2;
    let o = "";
    for(; i < r; i++){
        const e = $1d56c6a18dbfd30f$var$Qe(n[i]);
        if ("\n" === e) break;
        o += e;
    }
    const a = o.split(" "), s = parseInt(a[1]), c = parseInt(a[3]);
    if (!c || !s) return null;
    let l = i + 1;
    const f = [];
    for(let e = 0; e < c; e++){
        f[e] = [];
        for(let t = 0; t < 4; t++)f[e][t] = 0;
    }
    const d = new Float32Array(c * s * 4);
    let u = 0;
    for(let e = 0; e < s; e++){
        if (l = $1d56c6a18dbfd30f$var$rt(f, n, l, c), !l) return null;
        for(let e = 0; e < c; e++)$1d56c6a18dbfd30f$var$tt(f[e], d, u, t), u += 4;
    }
    return {
        width: c,
        height: s,
        pixels: d
    };
}
const $1d56c6a18dbfd30f$var$ot = $1d56c6a18dbfd30f$var$at();
function $1d56c6a18dbfd30f$var$at() {
    const e = new ArrayBuffer(4), t = new Float32Array(e), n = new Uint32Array(e), r = new Uint32Array(512), i = new Uint32Array(512);
    for(let e = 0; e < 256; ++e){
        const t = e - 127;
        t < -27 ? (r[e] = 0, r[256 | e] = 32768, i[e] = 24, i[256 | e] = 24) : t < -14 ? (r[e] = 1024 >> -t - 14, r[256 | e] = 1024 >> -t - 14 | 32768, i[e] = -t - 1, i[256 | e] = -t - 1) : t <= 15 ? (r[e] = t + 15 << 10, r[256 | e] = t + 15 << 10 | 32768, i[e] = 13, i[256 | e] = 13) : t < 128 ? (r[e] = 31744, r[256 | e] = 64512, i[e] = 24, i[256 | e] = 24) : (r[e] = 31744, r[256 | e] = 64512, i[e] = 13, i[256 | e] = 13);
    }
    const o = new Uint32Array(2048), a = new Uint32Array(64), s = new Uint32Array(64);
    for(let e = 1; e < 1024; ++e){
        let t = e << 13, n = 0;
        for(; !(8388608 & t);)t <<= 1, n -= 8388608;
        t &= -8388609, n += 947912704, o[e] = t | n;
    }
    for(let e = 1024; e < 2048; ++e)o[e] = 939524096 + (e - 1024 << 13);
    for(let e = 1; e < 31; ++e)a[e] = e << 23;
    a[31] = 1199570944, a[32] = 2147483648;
    for(let e = 33; e < 63; ++e)a[e] = 2147483648 + (e - 32 << 23);
    a[63] = 3347054592;
    for(let e = 1; e < 64; ++e)32 !== e && (s[e] = 1024);
    return {
        floatView: t,
        uint32View: n,
        baseTable: r,
        shiftTable: i,
        mantissaTable: o,
        exponentTable: a,
        offsetTable: s
    };
}
const $1d56c6a18dbfd30f$var$st = {
    toHalfFloat: function(e) {
        Math.abs(e) > 65504 && console.warn("THREE.DataUtils.toHalfFloat(): Value out of range."), e = $1d56c6a18dbfd30f$var$y(e, -65504, 65504), $1d56c6a18dbfd30f$var$ot.floatView[0] = e;
        const t = $1d56c6a18dbfd30f$var$ot.uint32View[0], n = t >> 23 & 511;
        return $1d56c6a18dbfd30f$var$ot.baseTable[n] + ((8388607 & t) >> $1d56c6a18dbfd30f$var$ot.shiftTable[n]);
    },
    fromHalfFloat: function(e) {
        const t = e >> 10;
        return $1d56c6a18dbfd30f$var$ot.uint32View[0] = $1d56c6a18dbfd30f$var$ot.mantissaTable[$1d56c6a18dbfd30f$var$ot.offsetTable[t] + (1023 & e)] + $1d56c6a18dbfd30f$var$ot.exponentTable[t], $1d56c6a18dbfd30f$var$ot.floatView[0];
    }
};
class $1d56c6a18dbfd30f$export$d7f9130fd509486 extends $1d56c6a18dbfd30f$export$e05be2fb829060c2 {
    onLoad({ data: e }) {
        const t = this.config;
        if (t) {
            if (t.hdr) {
                if (!(e = $1d56c6a18dbfd30f$var$it(e.data, 0))) throw new Error("Invalid hdr data" + (t.url ? ":" + t.url : ""));
                {
                    const n = new Uint16Array(e.pixels.length);
                    for(let t = 0; t < e.pixels.length; t++)n[t] = Math.min($1d56c6a18dbfd30f$var$st.toHalfFloat(e.pixels[t]), 65504);
                    t.data = n, t.type = "float16", t.colorSpace = "browser", t.min = "linear", t.mag = "linear";
                }
            } else t.data = e;
            t.width = t.width || e.width, t.height = t.height || e.height, this._regl && this._checkNPOT(this._regl), this._updateREGL();
        }
    }
    createREGLTexture(e) {
        if (this._regl = e, this._checkNPOT(e), $1d56c6a18dbfd30f$var$p(this.config.data) || $1d56c6a18dbfd30f$var$p(this.config.mipmap)) {
            const t = $1d56c6a18dbfd30f$var$me(e, this.config);
            return t[$1d56c6a18dbfd30f$var$B] || (t[$1d56c6a18dbfd30f$var$B] = 0), t[$1d56c6a18dbfd30f$var$B]++, t;
        }
        return e.texture(this.config);
    }
    _checkNPOT(e) {
        const t = this.config;
        t.data && this._needPowerOf2(e) && (t.data instanceof Image ? (t.data = $1d56c6a18dbfd30f$var$H(t.data), t.width = t.data.width, t.height = t.data.height) : t.hdr || !$1d56c6a18dbfd30f$var$p(t.data) || $1d56c6a18dbfd30f$var$I(t.width) && $1d56c6a18dbfd30f$var$I(t.height) || (t.data = $1d56c6a18dbfd30f$var$H(t.data, t.width, t.height), t.width = t.data.width, t.height = t.data.height));
    }
}
class $1d56c6a18dbfd30f$export$7ff5ac152ef991b0 extends $1d56c6a18dbfd30f$export$2db6c17465f94a2 {
    constructor(e){
        super({
            aPosition: new ($1d56c6a18dbfd30f$var$b(e = e || 0))([
                -1,
                -1,
                e,
                1,
                -1,
                e,
                -1,
                1,
                e,
                1,
                1,
                e
            ]),
            aNormal: new Int8Array([
                0,
                0,
                1,
                0,
                0,
                1,
                0,
                0,
                1,
                0,
                0,
                1
            ])
        }, new Uint16Array([
            0,
            1,
            3,
            3,
            2,
            0
        ]));
    }
}
const $1d56c6a18dbfd30f$var$ft = {
    vsm_shadow_vert: "\nuniform mat4 shadow_lightProjViewModelMatrix;\nvarying vec4 shadow_vLightSpacePos;\nvoid shadow_computeShadowPars(vec4 position) {\n    shadow_vLightSpacePos = shadow_lightProjViewModelMatrix * position;\n}",
    vsm_shadow_frag: "\nuniform sampler2D shadow_shadowMap;\nuniform float shadow_opacity;\nuniform vec3 shadow_color;\n#if defined(USE_ESM)\n    uniform float esm_shadow_threshold;\n#endif\nvarying vec4 shadow_vLightSpacePos;\n#ifdef PACK_FLOAT\n    #include <common_pack_float>\n#endif\n#if defined(USE_ESM)\nfloat esm(vec3 projCoords, vec4 shadowTexel) {\n    float compare = projCoords.z;\n    float c = 120.0;\n    #ifdef PACK_FLOAT\n        float depth = common_decodeDepth(shadowTexel);\n        if (depth >= 1.0 - 1E-6 || compare <= depth) {\n            return 1.0;\n        }\n    #else\n        float depth = shadowTexel.r;\n    #endif\n    depth = exp(-c * min(compare - depth, 0.05));\n    return clamp(depth, esm_shadow_threshold, 1.0);\n}\n#endif\n#if defined(USE_VSM)\nfloat vsm_shadow_chebyshevUpperBound(vec3 projCoords, vec4 shadowTexel){\n    vec2 moments = shadowTexel.rg;\n    float distance = projCoords.z;\n    if (distance >= 1.0 || distance <= moments.x)\n        return 1.0 ;\n    float variance = moments.y - (moments.x * moments.x);\n    variance = max(variance, 0.00002);\n    float d = distance - moments.x;\n    float p_max = variance / (variance + d * d);\n    return p_max;\n}\n#endif\nfloat shadow_computeShadow_coeff(sampler2D shadowMap, vec3 projCoords) {\n    vec2 uv = projCoords.xy;\n    vec4 shadowTexel = texture2D(shadowMap, uv);\n    #if defined(USE_ESM)\n        float esm_coeff = esm(projCoords, shadowTexel);\n        float coeff = esm_coeff * esm_coeff;\n    #endif\n    #if defined(USE_VSM)\n        float vsm_coeff = vsm_shadow_chebyshevUpperBound(projCoords, shadowTexel);\n        float coeff = vsm_coeff;\n    #endif\n    return 1.0 - (1.0 - coeff) * shadow_opacity;\n}\nfloat shadow_computeShadow() {\n    vec3 projCoords = shadow_vLightSpacePos.xyz / shadow_vLightSpacePos.w;\n    projCoords = projCoords * 0.5 + 0.5;\n    if(projCoords.z >= 1.0 || projCoords.x < 0.0 || projCoords.x > 1.0 || projCoords.y < 0.0 || projCoords.y > 1.0) return 1.0;\n    return shadow_computeShadow_coeff(shadow_shadowMap, projCoords);\n}\nvec3 shadow_blend(vec3 color, float coeff) {\n    color = color * coeff + shadow_color * shadow_opacity * (1.0 - coeff);\n    return color;\n}",
    fbo_picking_vert: "\n#ifdef ENABLE_PICKING\n#if HAS_PICKING_ID == 1\nattribute float aPickingId;\n#elif HAS_PICKING_ID == 2\nuniform float uPickingId;\n#endif\nvarying float vPickingId;\nvarying float vFbo_picking_viewZ;\nvarying float vFbo_picking_visible;\n#endif\nvarying float vFbo_picking_fragDepth;\nvoid fbo_picking_setData(float viewPosZ, bool visible) {\n    #ifdef ENABLE_PICKING\n    #if HAS_PICKING_ID == 1\n       vPickingId = aPickingId;\n    #elif HAS_PICKING_ID == 2\n        vPickingId = uPickingId;\n    #endif\n        vFbo_picking_viewZ = viewPosZ;\n    #endif\n    vFbo_picking_visible = visible ? 1.0 : 0.0;\n    vFbo_picking_fragDepth = viewPosZ + 1.0;\n}",
    common_pack_float: "const float COMMON_FLOAT_MAX =  1.70141184e38;\nconst float COMMON_FLOAT_MIN = 1.17549435e-38;\nfloat common_packFloat(vec4 val){\n    vec4 scl = floor(255.0 * val + 0.5);\n    float sgn = (scl.a < 128.0) ? 1.0 : -1.0;\n    float exn = mod(scl.a * 2.0, 256.0) + floor(scl.b / 128.0) - 127.0;\n    float man = 1.0 +\n        (scl.r / 8388608.0) +\n        (scl.g / 32768.0) +\n        mod(scl.b, 128.0) / 128.0;\n    return sgn * man * pow(2.0, exn);\n}\nvec4 common_unpackFloat(highp float v) {\n    highp float av = abs(v);\n    if(av < COMMON_FLOAT_MIN) {\n        return vec4(0.0, 0.0, 0.0, 0.0);\n    } else if(v > COMMON_FLOAT_MAX) {\n        return vec4(127.0, 128.0, 0.0, 0.0) / 255.0;\n    } else if(v < -COMMON_FLOAT_MAX) {\n        return vec4(255.0, 128.0, 0.0, 0.0) / 255.0;\n    }\n    highp vec4 c = vec4(0,0,0,0);\n    highp float e = floor(log2(av));\n    highp float m = av * pow(2.0, -e) - 1.0;\n    c[1] = floor(128.0 * m);\n    m -= c[1] / 128.0;\n    c[2] = floor(32768.0 * m);\n    m -= c[2] / 32768.0;\n    c[3] = floor(8388608.0 * m);\n    highp float ebias = e + 127.0;\n    c[0] = floor(ebias / 2.0);\n    ebias -= c[0] * 2.0;\n    c[1] += floor(ebias) * 128.0;\n    c[0] += 128.0 * step(0.0, -v);\n    return c / 255.0;\n}\nvec4 common_encodeDepth(const in float depth) {\n    float alpha = 1.0;\n    vec4 pack = vec4(0.0);\n    pack.a = alpha;\n    const vec3 code = vec3(1.0, 255.0, 65025.0);\n    pack.rgb = vec3(code * depth);\n    pack.gb = fract(pack.gb);\n    pack.rg -= pack.gb * (1.0 / 256.0);\n    pack.b -= mod(pack.b, 4.0 / 255.0);\n    return pack;\n}\nfloat common_decodeDepth(const in vec4 pack) {\n    return pack.r + pack.g / 255.0;\n}",
    invert_matrix: "mat4 invert_matrix(mat4 matrix) {\n    #if __VERSION__ == 300\n        return inverse(matrix);\n    #else\n        vec4 vector1 = matrix[0], vector2 = matrix[1], vector3 = matrix[2], vector4 = matrix[3];\n        float a00 = vector1.x, a01 = vector1.y, a02 = vector1.z, a03 = vector1.w;\n        float a10 = vector2.x, a11 = vector2.y, a12 = vector2.z, a13 = vector2.w;\n        float a20 = vector3.x, a21 = vector3.y, a22 = vector3.z, a23 = vector3.w;\n        float a30 = vector4.x, a31 = vector4.y, a32 = vector4.z, a33 = vector4.w;\n        float b00 = a00 * a11 - a01 * a10;\n        float b01 = a00 * a12 - a02 * a10;\n        float b02 = a00 * a13 - a03 * a10;\n        float b03 = a01 * a12 - a02 * a11;\n        float b04 = a01 * a13 - a03 * a11;\n        float b05 = a02 * a13 - a03 * a12;\n        float b06 = a20 * a31 - a21 * a30;\n        float b07 = a20 * a32 - a22 * a30;\n        float b08 = a20 * a33 - a23 * a30;\n        float b09 = a21 * a32 - a22 * a31;\n        float b10 = a21 * a33 - a23 * a31;\n        float b11 = a22 * a33 - a23 * a32;\n        float det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;\n        det = 1.0 / det;\n        mat4 m = mat4(\n            (a11 * b11 - a12 * b10 + a13 * b09) * det,\n            (a02 * b10 - a01 * b11 - a03 * b09) * det,\n            (a31 * b05 - a32 * b04 + a33 * b03) * det,\n            (a22 * b04 - a21 * b05 - a23 * b03) * det,\n            (a12 * b08 - a10 * b11 - a13 * b07) * det,\n            (a00 * b11 - a02 * b08 + a03 * b07) * det,\n            (a32 * b02 - a30 * b05 - a33 * b01) * det,\n            (a20 * b05 - a22 * b02 + a23 * b01) * det,\n            (a10 * b10 - a11 * b08 + a13 * b06) * det,\n            (a01 * b08 - a00 * b10 - a03 * b06) * det,\n            (a30 * b04 - a31 * b02 + a33 * b00) * det,\n            (a21 * b02 - a20 * b04 - a23 * b00) * det,\n            (a11 * b07 - a10 * b09 - a12 * b06) * det,\n            (a00 * b09 - a01 * b07 + a02 * b06) * det,\n            (a31 * b01 - a30 * b03 - a32 * b00) * det,\n            (a20 * b03 - a21 * b01 + a22 * b00) * det\n        );\n        return m;\n    #endif\n}\nmat4 transpose_matrix(mat4 matrix) {\n    #if __VERSION__ == 300\n        return transpose(matrix);\n    #else\n        vec4 vector1 = matrix[0], vector2 = matrix[1], vector3 = matrix[2], vector4 = matrix[3];\n        float a01 = vector1.y, a02 = vector1.z, a03 = vector1.w;\n        float a12 = vector2.z, a13 = vector2.w;\n        float a23 = vector3.w;\n        mat4 m = mat4(\n            vector1.x,\n            vector2.x,\n            vector3.x,\n            vector4.x,\n            a01,\n            vector2.y,\n            vector3.y,\n            vector4.y,\n            a02,\n            a12,\n            vector3.z,\n            vector4.z,\n            a03,\n            a13,\n            a23,\n            vector4.w\n        );\n        return m;\n    #endif\n}",
    get_output: "#include <invert_matrix>\n#include <draco_decode_vert>\n#ifdef HAS_INSTANCE\n    #include <instance_vert>\n    #ifdef HAS_INSTANCE_COLOR\n        varying vec4 vInstanceColor;\n    #endif\n#endif\n#ifdef HAS_SKIN\n    uniform int skinAnimation;\n    #include <skin_vert>\n#endif\n#include <mask_vert>\n#ifdef HAS_MORPH\n    attribute vec3 POSITION0;\n    attribute vec3 POSITION1;\n    attribute vec3 POSITION2;\n    attribute vec3 POSITION3;\n    attribute vec3 POSITION4;\n    attribute vec3 POSITION5;\n    attribute vec3 POSITION6;\n    attribute vec3 POSITION7;\n    #ifdef HAS_MORPHNORMALS\n        attribute vec3 NORMAL0;\n        attribute vec3 NORMAL1;\n        attribute vec3 NORMAL2;\n        attribute vec3 NORMAL3;\n    #endif\n    uniform vec4 morphWeights1;\n    uniform vec4 morphWeights2;\n#endif\n#ifdef HAS_TERRAIN_ALTITUDE\nattribute float aTerrainAltitude;\n#endif\nmat4 getPositionMatrix() {\n    mat4 worldMatrix;\n    #ifdef HAS_INSTANCE\n        #ifdef HAS_INSTANCE_COLOR\n            vInstanceColor = instance_getInstanceColor();\n        #endif\n        mat4 attributeMatrix = instance_getAttributeMatrix();\n        #ifdef HAS_SKIN\n            if (skinAnimation == 1) {\n                worldMatrix = attributeMatrix * positionMatrix * skin_getSkinMatrix();\n            } else {\n                worldMatrix = attributeMatrix * positionMatrix;\n            }\n        #else\n            worldMatrix = attributeMatrix * positionMatrix;\n        #endif\n    #else\n        #ifdef HAS_SKIN\n            if (skinAnimation == 1) {\n                worldMatrix = skin_getSkinMatrix() * positionMatrix;\n            } else {\n                worldMatrix = positionMatrix;\n            }\n        #else\n            worldMatrix = positionMatrix;\n        #endif\n    #endif\n    return worldMatrix;\n}\n#ifdef HAS_MIN_ALTITUDE\nuniform float minAltitude;\n#endif\nvec4 getPosition(vec3 aPosition) {\n    vec3 position = decode_getPosition(aPosition);\n    #ifdef HAS_MORPH\n        vec4 POSITION = vec4(position + morphWeights1[0] * POSITION0 + morphWeights1[1] * POSITION1 + morphWeights1[2] * POSITION2 + morphWeights1[3] * POSITION3\n        + morphWeights2[0] * POSITION4 + morphWeights2[1] * POSITION5 + morphWeights2[2] * POSITION6 + morphWeights2[3] * POSITION7\n        , 1.0);\n    #else\n        vec4 POSITION = vec4(position, 1.0);\n    #endif\n    #ifdef HAS_TERRAIN_ALTITUDE\n        POSITION.z += aTerrainAltitude * 100.0;\n    #endif\n    #ifdef HAS_MIN_ALTITUDE\n        POSITION.z += minAltitude * 100.0;\n    #endif\n    return POSITION;\n}\nvec3 appendMorphNormal(vec3 NORMAL) {\n    #ifdef HAS_MORPHNORMALS\n        vec3 normal = NORMAL + morphWeights1[0] * NORMAL0 + morphWeights1[1] * NORMAL1 + morphWeights1[2] * NORMAL2 + morphWeights1[3] * NORMAL3;\n    #else\n        vec3 normal = NORMAL;\n    #endif\n    return normal;\n}",
    instance_vert: "attribute vec4 instance_vectorA;\nattribute vec4 instance_vectorB;\nattribute vec4 instance_vectorC;\n#ifdef HAS_INSTANCE_TERRAIN_ALTITUDE\nattribute float aTerrainAltitude;\nuniform float terrainAltitudeScale;\n#endif\nmat4 instance_getAttributeMatrix() {\n    mat4 mat =  mat4(\n        instance_vectorA.x, instance_vectorB.x, instance_vectorC.x, 0.0,\n        instance_vectorA.y, instance_vectorB.y, instance_vectorC.y, 0.0,\n        instance_vectorA.z, instance_vectorB.z, instance_vectorC.z, 0.0,\n        instance_vectorA.w, instance_vectorB.w, instance_vectorC.w, 1.0\n    );\n    #ifdef HAS_INSTANCE_TERRAIN_ALTITUDE\n        mat4 terrainMat = mat4(\n            1., 0., 0., 0.,\n            0., 1., 0., 0.,\n            0., 0., 1., 0.,\n            0., 0., aTerrainAltitude * terrainAltitudeScale, 1.\n        );\n        mat = terrainMat * mat;\n    #endif\n    return mat;\n}\n#ifdef HAS_INSTANCE_HIGHLIGHT\n    attribute vec4 highlight_color;\n#endif\n#ifdef HAS_INSTANCE_COLOR\n   \n    attribute vec4 instance_color;\n    vec4 instance_getInstanceColor() {\n        vec4 color = instance_color;\n        #ifdef HAS_INSTANCE_HIGHLIGHT\n            color = instance_color * highlight_color;\n        #endif\n        return color;\n    }\n#endif",
    skin_vert: "attribute vec4 WEIGHTS_0;\nattribute vec4 JOINTS_0;\nuniform sampler2D jointTexture;\nuniform vec2 jointTextureSize;\nuniform float numJoints;\n#define ROW0_U ((0.5 + 0.0) / 4.)\n#define ROW1_U ((0.5 + 1.0) / 4.)\n#define ROW2_U ((0.5 + 2.0) / 4.)\n#define ROW3_U ((0.5 + 3.0) / 4.)\nmat4 skin_getBoneMatrix(float jointNdx) {\n    float v = (jointNdx + 0.5) / numJoints;\n    return mat4(\n        texture2D(jointTexture, vec2(ROW0_U, v)),\n        texture2D(jointTexture, vec2(ROW1_U, v)),\n        texture2D(jointTexture, vec2(ROW2_U, v)),\n        texture2D(jointTexture, vec2(ROW3_U, v)));\n}\nmat4 skin_getSkinMatrix() {\n        mat4 skinMatrix = skin_getBoneMatrix(JOINTS_0[0]) * WEIGHTS_0[0] +\n                        skin_getBoneMatrix(JOINTS_0[1]) * WEIGHTS_0[1] +\n                        skin_getBoneMatrix(JOINTS_0[2]) * WEIGHTS_0[2] +\n                        skin_getBoneMatrix(JOINTS_0[3]) * WEIGHTS_0[3];\n        return skinMatrix;\n}",
    heatmap_render_vert: "#ifdef HAS_HEATMAP\nvarying vec2 heatmap_vTexCoord;\nvoid heatmap_compute(mat4 matrix, vec3 position) {\n    vec4 pos = matrix * vec4(position.xy, 0., 1.);\n    heatmap_vTexCoord = (1. + pos.xy / pos.w) / 2.;\n}\n#endif",
    heatmap_render_frag: "#ifdef HAS_HEATMAP\nuniform sampler2D heatmap_inputTexture;\nuniform sampler2D heatmap_colorRamp;\nuniform float heatmap_heatmapOpacity;\nvarying vec2 heatmap_vTexCoord;\nvec4 heatmap_getColor(vec4 color) {\n    float t = texture2D(heatmap_inputTexture, heatmap_vTexCoord).r;\n    vec4 heatmapColor = texture2D(heatmap_colorRamp, vec2(t, 0.5)) * heatmap_heatmapOpacity;\n    return color * (1.0 - heatmapColor.a) + heatmapColor * heatmapColor.a;\n}\n#endif",
    line_extrusion_vert: "#ifdef IS_LINE_EXTRUSION\n    #define ALTITUDE_SCALE 32767.0;\n    #define EXTRUDE_SCALE 63.0;\n    attribute vec2 aExtrude;\n    #ifdef HAS_LINE_WIDTH\n        attribute float aLineWidth;\n    #else\n        uniform float lineWidth;\n    #endif\n    #ifdef HAS_LINE_HEIGHT\n        attribute float aLineHeight;\n    #else\n        uniform float lineHeight;\n    #endif\n    uniform float linePixelScale;\n    vec3 getLineExtrudePosition(vec3 position) {\n        #ifdef HAS_LINE_WIDTH\n            float lineWidth = aLineWidth / 2.0;\n        #endif\n        #ifdef HAS_LINE_HEIGHT\n            float lineHeight = aLineHeight / 10.0;\n        #endif\n        float halfwidth = lineWidth / 2.0;\n        float outset = halfwidth;\n        vec2 dist = outset * aExtrude / EXTRUDE_SCALE;\n        position.z *= lineHeight / ALTITUDE_SCALE;\n        return position + vec3(dist, 0.0) * linePixelScale;\n    }\n#endif",
    gl2_vert: "#if __VERSION__ == 300\n    #define texture2D texture\n    #define varying out\n    #define attribute in\n#endif",
    gl2_frag: "#if __VERSION__ == 300\n    #define varying in\n    #define gl_FragDepthEXT gl_FragDepth\n    #define texture2D texture\n    #define textureCube texture\n    #define texture2DProj textureProj\n    #define texture2DLodEXT textureLod\n    #define texture2DProjLodEXT textureProjLod\n    #define textureCubeLodEXT textureLod\n    #define texture2DGradEXT textureGrad\n    #define texture2DProjGradEXT textureProjGrad\n    #define textureCubeGradEXT textureGrad\n    #define texture2D texture\n    out vec4 glFragColor;\n#else\n    vec4 glFragColor;\n#endif",
    hsv_frag: "\nconst mediump vec4 HSV_K0 = vec4(0.0, -1.0 / 3.0, 2.0 / 3.0, -1.0);\nconst mediump vec4 HSV_K1 = vec4(1.0, 2.0 / 3.0, 1.0 / 3.0, 3.0);\nconst mediump float HSV_E = 1.0e-10;\nvec3 hsv_rgb2hsv(vec3 c) {\n    vec4 K = HSV_K0;\n    vec4 p = mix(vec4(c.bg, K.wz), vec4(c.gb, K.xy), step(c.b, c.g));\n    vec4 q = mix(vec4(p.xyw, c.r), vec4(c.r, p.yzx), step(p.x, c.r));\n    float d = q.x - min(q.w, q.y);\n    float e = HSV_E;\n    return vec3(abs(q.z + (q.w - q.y) / (6.0 * d + e)), d / (q.x + e), q.x);\n}\nvec3 hsv_hsv2rgb(vec3 c) {\n    vec4 K = HSV_K1;\n    vec3 p = abs(fract(c.xxx + K.xyz) * 6.0 - K.www);\n    return c.z * mix(K.xxx, clamp(p - K.xxx, 0.0, 1.0), c.y);\n}\nvec4 hsv_apply(vec4 c, vec3 hsvOffset) {\n    vec3 hsv = hsv_rgb2hsv(c.rgb);\n    hsv += hsv * hsvOffset;\n    hsv = clamp(hsv, 0.0, 1.0);\n    return vec4(hsv_hsv2rgb(hsv), c.a);\n}\nvec3 hsv_apply(vec3 c, vec3 hsvOffset) {\n    vec3 hsv = hsv_rgb2hsv(c.rgb);\n    hsv += hsv * hsvOffset;\n    hsv = clamp(hsv, 0.0, 1.0);\n    return hsv_hsv2rgb(hsv);\n}\nmat4 contrastMatrix(float contrast)\n{\n    float t = (1.0 - contrast) / 2.0;\n    return mat4(\n        contrast, 0., 0., 0.,\n        0., contrast, 0., 0.,\n        0., 0., contrast, 0.,\n        t, t, t, 1\n    );\n}",
    snow_frag: "#ifdef HAS_SNOW\n    float lerp(float a, float b, float w) {\n        return a + w * (b - a);\n    }\n    vec3 snow(vec4 sceneColor, vec3 normalColor, float height) {\n        float snowIntense = normalColor.b;\n        vec3 fixedC = vec3(1.0, 1.0, 1.0);\n        if (height < 1.0) {\n            float r = lerp(0.5, fixedC.x, snowIntense);\n            float g = lerp(0.5, fixedC.y, snowIntense);\n            float b = lerp(0.5, fixedC.z, snowIntense);\n            return vec3(r, g, b);\n        } else {\n            float r = lerp(sceneColor.r, fixedC.x, snowIntense);\n            float g = lerp(sceneColor.g, fixedC.y, snowIntense);\n            float b = lerp(sceneColor.b, fixedC.z, snowIntense);\n            return vec3(r, g, b);\n        }\n    }\n#endif",
    draco_decode_vert: "#if defined(HAS_TANGENT)\n    attribute vec4 aTangent;\n#elif defined(HAS_NORMAL)\n    #ifdef HAS_DRACO_NORMAL\n        attribute vec2 aNormal;\n        uniform float gltf_u_dec_normal_rangeConstant;\n    #else\n        attribute vec3 aNormal;\n    #endif\n#endif\n#ifdef HAS_DRACO_POSITION\n    uniform float gltf_u_dec_position_normConstant;\n    uniform vec3 minValues_pos;\n    vec3 decodeDracoPosition(vec3 aPosition) {\n        return minValues_pos + aPosition * gltf_u_dec_position_normConstant;\n    }\n#endif\n#ifdef HAS_DRACO_TEXCOORD\n    uniform vec2 minValues_tex;\n    uniform float gltf_u_dec_texcoord_0_normConstant;\n    vec2 decodeDracoTexcoord(vec2 aTexCoord) {\n        return minValues_tex + aTexCoord * gltf_u_dec_texcoord_0_normConstant;\n    }\n#endif\n#ifdef HAS_WEB3D_quantized_attributes_TEXCOORD\n    uniform mat3 decodeMatrix;\n#endif\n#ifdef HAS_DRACO_NORMAL\n    float czm_signNotZero(float value) {\n        return value >= 0.0 ? 1.0 : -1.0;\n    }\n    vec2 czm_signNotZero(vec2 value) {\n        return vec2(czm_signNotZero(value.x), czm_signNotZero(value.y));\n    }\n    vec3 decodeDracoNormal(vec2 encoded, float range)\n    {\n        if (encoded.x == 0.0 && encoded.y == 0.0) {\n            return vec3(0.0, 0.0, 0.0);\n        }\n        encoded = encoded / range * 2.0 - 1.0;\n        vec3 v = vec3(encoded.x, encoded.y, 1.0 - abs(encoded.x) - abs(encoded.y));\n        if (v.z < 0.0) {\n            v.xy = (1.0 - abs(v.yx)) * czm_signNotZero(v.xy);\n        }\n        return normalize(v);\n    }\n    vec3 decode_getNormal(vec2 aNormal) {\n        return decodeDracoNormal(aNormal, gltf_u_dec_normal_rangeConstant).zxy;\n    }\n#endif\n#ifdef HAS_COMPRESSED_INT16\n    #ifdef HAS_COMPRESSED_INT16_POSITION\n      uniform vec2 compressedPositionRange;\n    #endif\n    #ifdef HAS_COMPRESSED_INT16_TEXCOORD_0\n      uniform vec2 compressedTexcoordRange_0;\n    #endif\n    #ifdef HAS_COMPRESSED_INT16_TEXCOORD_1\n      uniform vec2 compressedTexcoordRange_1;\n    #endif\n    #ifdef HAS_COMPRESSED_INT16_NORMAL\n      uniform vec2 compressedNormalRange;\n    #endif\n    #ifdef HAS_COMPRESSED_INT16_RATIO\n      uniform float compressed_ratio;\n    #endif\n    float int16ToFloat32(float value, vec2 range) {\n        float v = (value >= 32768.0) ? -(65536.0 - value) / 32768.0 : value / 32767.0;\n        return (v + 1.0) * (range.y - range.x) / 2.0 + range.x;\n    }\n#endif\nvec3 decode_getPosition(vec3 aPosition) {\n    vec3 position = aPosition;\n    #if defined(HAS_COMPRESSED_INT16) && defined(HAS_COMPRESSED_INT16_POSITION)\n        float x = int16ToFloat32(aPosition.x, compressedPositionRange);\n        float y = int16ToFloat32(aPosition.y, compressedPositionRange);\n        float z = int16ToFloat32(aPosition.z, compressedPositionRange);\n        #ifdef HAS_COMPRESSED_INT16_RATIO\n          position = vec3(x / compressed_ratio, y / compressed_ratio, z);\n        #else\n          position = vec3(x, y, z);\n        #endif\n    #endif\n    #ifdef HAS_DRACO_POSITION\n        return decodeDracoPosition(position);\n    #else\n        return position;\n    #endif\n}\nvec2 decode_getTexcoord(vec2 aTexCoord) {\n    vec2 texcoord = aTexCoord;\n    #if defined(HAS_COMPRESSED_INT16) && (defined(HAS_COMPRESSED_INT16_TEXCOORD_0) || defined(HAS_COMPRESSED_INT16_TEXCOORD_1))\n        float x = int16ToFloat32(aTexCoord.x, compressedTexcoordRange_0);\n        float y = int16ToFloat32(aTexCoord.y, compressedTexcoordRange_0);\n        texcoord = vec2(x, y);\n    #endif\n    #ifdef HAS_DRACO_TEXCOORD\n        return decodeDracoTexcoord(texcoord);\n    #elif defined(HAS_WEB3D_quantized_attributes_TEXCOORD)\n        vec3 web3dTexcoord = decodeMatrix * vec3(texcoord, 1.0);\n        return vec2(web3dTexcoord.x, web3dTexcoord.y);\n    #else\n        return texcoord;\n    #endif\n}\nvec3 decode_getNormal(vec3 aNormal) {\n    #ifdef HAS_COMPRESSED_INT16_NORMAL\n        aNormal.x = int16ToFloat32(aNormal.x, compressedNormalRange);\n        aNormal.y = int16ToFloat32(aNormal.y, compressedNormalRange);\n        aNormal.z = int16ToFloat32(aNormal.z, compressedNormalRange);\n    #endif\n    return aNormal;\n}",
    highlight_vert: "#if defined(HAS_HIGHLIGHT_COLOR)\n    attribute vec4 aHighlightColor;\n    varying vec4 vHighlightColor;\n#endif\n#if defined(HAS_HIGHLIGHT_OPACITY)\n    attribute float aHighlightOpacity;\n    varying float vHighlightOpacity;\n#endif\nvoid highlight_setVarying() {\n    #if defined(HAS_HIGHLIGHT_COLOR)\n        vHighlightColor = aHighlightColor / 255.0;\n    #endif\n    #if defined(HAS_HIGHLIGHT_OPACITY)\n        vHighlightOpacity = aHighlightOpacity / 255.0;\n    #endif\n}",
    highlight_frag: "#if defined(HAS_HIGHLIGHT_COLOR)\n\tvarying vec4 vHighlightColor;\n#endif\n#if defined(HAS_HIGHLIGHT_OPACITY)\n    varying float vHighlightOpacity;\n#endif\nvec4 highlight_blendColor(vec4 color) {\n\tvec4 outColor;\n\t#if defined(HAS_HIGHLIGHT_COLOR)\n\t\tcolor.rgb = color.rgb * (1.0 - vHighlightColor.a) + vHighlightColor.rgb * vHighlightColor.a;\n\t\t#ifndef HAS_HIGHLIGHT_COLOR_POINT\n        \tcolor.a = color.a * (1.0 - vHighlightColor.a) + vHighlightColor.a;\n        #endif\n        outColor = color;\n\t#else\n\t\toutColor = color;\n\t#endif\n\t#if defined(HAS_HIGHLIGHT_OPACITY)\n\t\toutColor *= vHighlightOpacity;\n\t#endif\n\treturn outColor;\n}",
    mask_vert: "#ifdef HAS_MASK_EXTENT\n    uniform vec4 mask_extent;\n    uniform sampler2D mask_colorExtent;\n    uniform sampler2D mask_modeExtent;\n    uniform float mask_maskMode;\n    uniform float mask_hasFlatOut;\n    uniform mat4 viewMatrix;\n    uniform float mask_heightRatio;\n    uniform float mask_heightOffset;\n    varying vec4 vWorldPosition;\n    varying vec2 vUVInExtent;\n    varying float vHeightRatio;\n    varying float vHeightOffset;\n    const float CLIPINSIDE_MODE = 0.2;\n    const float FLATINSIDE_MODE = 0.3;\n    const float FLATOUTSIDE_MODE = 0.4;\n    const float ELEVATE_MODE = 0.7;\n    float random (vec2 st) {\n        return fract(sin(dot(st.xy,vec2(12.9898,78.233)))*43758.5453123) * 0.1;\n    }\n    bool isInExtent(vec4 color) {\n        return length(color.rgb) > 0.0;\n    }\n    float getFlatHeight(float maskMode, float flatHeight, float height) {\n      if (maskMode <= ELEVATE_MODE && maskMode > 0.6) {\n          return flatHeight + height;\n      } else {\n        return flatHeight;\n      }\n    }\n    vec4 getNoErrorPosition(vec4 position, vec4 wPosition) {\n      vec4 realPos = modelViewMatrix * position;      vec4 pos = viewMatrix * wPosition;      vec4 tempPos = viewMatrix * modelMatrix * position;      float deltaX = realPos.x - tempPos.x;\n      float deltaY = realPos.y - tempPos.y;\n      float deltaZ = realPos.z - tempPos.z;\n      pos.x = pos.x + deltaX;\n      pos.y = pos.y + deltaY;\n      pos.z = pos.z + deltaZ;\n      return pos;\n    }\n    vec4 getMaskPosition(vec4 position, mat4 modelMatrix) {\n        vWorldPosition = modelMatrix * position;\n        float w = mask_extent.z - mask_extent.x;\n        float h = mask_extent.y - mask_extent.w;\n        vec2 uvInExtent = vec2((vWorldPosition.x - mask_extent.x) / abs(w), 1.0 - (vWorldPosition.y - mask_extent.w) / h);\n        vec4 extentColor = texture2D(mask_colorExtent, uvInExtent);\n        vec3 maskOptionColor = texture2D(mask_modeExtent, uvInExtent).rgb;\n        float maskMode = maskOptionColor.r;\n        float flatHeight = maskOptionColor.g / mask_heightRatio + mask_heightOffset;\n        float height = getFlatHeight(maskMode, flatHeight, vWorldPosition.z);\n        vec4 wPosition = vec4(vWorldPosition.x, vWorldPosition.y, height, vWorldPosition.w);\n        vUVInExtent = uvInExtent;\n        vHeightRatio = mask_heightRatio;\n        vHeightOffset = mask_heightOffset;\n        if (maskMode <= FLATOUTSIDE_MODE && maskMode > FLATINSIDE_MODE) {\n            return modelViewMatrix * position;;\n        } else if (mask_hasFlatOut == 1.0) {\n            return getNoErrorPosition(position, wPosition);\n        }\n        if (isInExtent(extentColor) == true && maskMode <= FLATINSIDE_MODE && maskMode > CLIPINSIDE_MODE) {\n            return getNoErrorPosition(position, wPosition);\n        } if (isInExtent(extentColor) == true && maskMode <= ELEVATE_MODE && maskMode > 0.6) {\n            return getNoErrorPosition(position, wPosition);\n        } else {\n            return modelViewMatrix * position;\n        }\n    }\n#endif",
    mask_frag: "#ifdef HAS_MASK_EXTENT\n    uniform sampler2D mask_colorExtent;\n    uniform sampler2D mask_modeExtent;\n    uniform float mask_hasClipOut;\n    varying float vHeightRatio;\n    varying float vHeightOffset;\n    varying vec2 vUVInExtent;\n    varying vec4 vWorldPosition;\n    const float CLIPINSIDE_MODE = 0.1;\n    const float CLIPOUTSIDE_MODE = 0.2;\n    const float FLATINSIDE_MODE = 0.3;\n    const float FLATOUTSIDE_MODE = 0.4;\n    const float COLOR_MODE = 0.5;\n    const float VIDEO_MODE = 0.6;\n    bool isInExtent(vec4 color) {\n        return length(color.rgb) > 0.0;\n    }\n    vec4 setMask(vec4 glFragColor) {\n        vec4 extentColor = texture2D(mask_colorExtent, vUVInExtent);\n        vec4 modeColor = texture2D(mask_modeExtent, vUVInExtent);\n        float maskMode = modeColor.r;\n        float minHeight = modeColor.b / vHeightRatio + vHeightOffset;\n        float maxHeight = modeColor.a / vHeightRatio + vHeightOffset;\n        if (maskMode > CLIPINSIDE_MODE && maskMode <= CLIPOUTSIDE_MODE) {\n            if (minHeight == 0.0 && maxHeight == 0.0) {\n                return glFragColor;\n            } else if (vWorldPosition.z >= minHeight && vWorldPosition.z <= maxHeight) {\n                return glFragColor;\n            } else {\n              discard;\n            }\n        } else if (mask_hasClipOut == 1.0) {\n            discard;\n        }\n        if (isInExtent(extentColor) == true && maskMode <= CLIPINSIDE_MODE && maskMode > 0.0) {\n            if (minHeight == 0.0 && maxHeight == 0.0) {\n                discard;\n            } else if (vWorldPosition.z >= minHeight && vWorldPosition.z <= maxHeight) {\n                discard;\n            } else {\n              return glFragColor;\n            }\n        } else if (isInExtent(extentColor) == true && maskMode <= VIDEO_MODE && maskMode > FLATOUTSIDE_MODE) {\n            if (minHeight == 0.0 && maxHeight == 0.0) {\n                glFragColor = vec4(mix(extentColor.rgb, glFragColor.rgb, 1.0 - extentColor.a), glFragColor.a);\n            } else if (vWorldPosition.z >= minHeight && vWorldPosition.z <= maxHeight) {\n                glFragColor = vec4(mix(extentColor.rgb, glFragColor.rgb, 1.0 - extentColor.a), glFragColor.a);\n            }\n        }\n        return glFragColor;\n    }\n#endif",
    computeTexcoord_frag: "#ifdef HAS_KHR_TEXTURE_TRANSFORM\n    uniform vec2 khr_offset;\n    uniform float khr_rotation;\n    uniform vec2 khr_scale;\n    vec2 khr_tex_transformTexCoord(vec2 texCoords, vec2 offset, float rotation, vec2 scale) {\n        rotation = -rotation;\n        mat3 transform = mat3(\n        cos(rotation) * scale.x, sin(rotation) * scale.x, 0.0, -sin(rotation) * scale.y, cos(rotation) * scale.y, 0.0, offset.x, offset.y, 1.0);\n        vec2 transformedTexCoords = (transform * vec3(fract(texCoords), 1.0)).xy;\n        return transformedTexCoords;\n    }\n#endif\nvarying highp vec2 vTexCoord;\n#ifdef HAS_I3S_UVREGION\n    varying vec4 vUvRegion;\n#endif\nvec2 computeTexCoord(vec2 texCoord) {\n    #ifdef HAS_I3S_UVREGION\n        vec2 atlasScale = vUvRegion.zw - vUvRegion.xy;\n        vec2 uvAtlas = fract(texCoord) * atlasScale + vUvRegion.xy;\n        return uvAtlas;\n    #elif defined(HAS_KHR_TEXTURE_TRANSFORM)\n        return khr_tex_transformTexCoord(texCoord, khr_offset, khr_rotation, khr_scale);\n    #else\n        return texCoord;\n    #endif\n}",
    terrain_normal_frag: "#ifdef HAS_TERRAIN_NORMAL\n    uniform sampler2D terrainHeightTexture;\n    uniform vec2 terrainHeightMapResolution;\n    uniform vec2 terrainResolution;\n    uniform float terrainHeightScale;\n    uniform float terrainTileResolution;\n    uniform vec4 terrainUnpackFactors;\n    float getHeight(vec2 uv) {\n        vec4 color = texture2D(terrainHeightTexture, uv) * 255.0;\n        color.a = -1.0;\n        return dot(color, terrainUnpackFactors) / 4.0;\n    }\n    vec3 convertTerrainHeightToNormalMap(vec2 uv) {\n        uv.y = 1.0 - uv.y;\n        vec2 epsilon = 1.0 / terrainHeightMapResolution;\n        float a = getHeight(uv + vec2(-epsilon.x, -epsilon.y));\n        float b = getHeight(uv + vec2(0, -epsilon.y));\n        float c = getHeight(uv + vec2(epsilon.x, -epsilon.y));\n        float d = getHeight(uv + vec2(-epsilon.x, 0));\n        float e = getHeight(uv + vec2(epsilon.x, 0));\n        float f = getHeight(uv + vec2(-epsilon.x, epsilon.y));\n        float g = getHeight(uv + vec2(0, epsilon.y));\n        float h = getHeight(uv + vec2(epsilon.x, epsilon.y));\n        vec2 dxy = vec2(\n            (c + e + e + h) - (a + d + d + f),\n            (f + g + g + h) - (a + b + b + c)\n        );\n        return normalize(vec3(dxy / epsilon, terrainResolution ));\n    }\n#endif",
    vertex_color_vert: "#ifdef HAS_VERTEX_COLOR\nattribute float aVertexColorType;\nuniform vec4 vertexColorsOfType[VERTEX_TYPES_COUNT];\nvarying vec4 vertexColor_color;\nvoid vertexColor_update() {\n    vertexColor_color = vertexColorsOfType[int(aVertexColorType)];\n}\n#endif\n//\u7528\u4E8E\u8BC6\u522B\u9876\u70B9\u989C\u8272\u7C7B\u578B: topPolygonFill \u8FD8\u662F bottomPolygonFill",
    vertex_color_frag: "#ifdef HAS_VERTEX_COLOR\nvarying vec4 vertexColor_color;\nvec4 vertexColor_get() {\n\treturn vertexColor_color;\n}\n#endif",
    excavate_vert: "#ifdef HAS_EXCAVATE_ANALYSIS\n  uniform vec4 excavateExtent;\n  varying vec2 vCoordinateTexcoord;\n  varying float vHeight;\n  float getWorldHeight() {\n    vec4 wPosition = modelMatrix * getPosition(aPosition);\n    return wPosition.z;\n  }\n  vec2 getCoordinateTexcoord() {\n    mat4 localPositionMatrix = getPositionMatrix();\n    vec4 wPosition = modelMatrix * localPositionMatrix * getPosition(aPosition);\n    float x = (wPosition.x - excavateExtent.x) / (excavateExtent.z - excavateExtent.x);\n    float y = (wPosition.y - excavateExtent.y) / (excavateExtent.w - excavateExtent.y);\n    return vec2(x, y);\n  }\n#endif",
    excavate_frag: "#ifdef HAS_EXCAVATE_ANALYSIS\n  uniform sampler2D heightmap;\n  uniform float excavateHeight;\n  varying vec2 vCoordinateTexcoord;\n  varying float vHeight;\n  const vec2 range = vec2(-100.0, 1000.0);\n  float decodeHeight(const in vec4 pack) {\n      return pack.r + pack.g / 255.0;\n  }\n  vec4 excavateColor(vec4 fragColor) {\n      float samplerHeight = decodeHeight(texture2D(heightmap, vCoordinateTexcoord));\n      float realHeight = samplerHeight * (range.y - range.x) + range.x;\n      if(realHeight < range.x || realHeight > range.y) {\n          realHeight = 0.0;\n      }\n      if(vHeight > realHeight) {\n          discard;\n      }\n      return fragColor;\n  }\n#endif",
    srgb_frag: "vec3 linearTosRGB(const in vec3 color) {\n    return vec3( color.r < 0.0031308 ? color.r * 12.92 : 1.055 * pow(color.r, 1.0/2.4) - 0.055, color.g < 0.0031308 ? color.g * 12.92 : 1.055 * pow(color.g, 1.0/2.4) - 0.055, color.b < 0.0031308 ? color.b * 12.92 : 1.055 * pow(color.b, 1.0/2.4) - 0.055);\n}\nvec3 sRGBToLinear(const in vec3 color) {\n    return vec3( color.r < 0.04045 ? color.r * (1.0 / 12.92) : pow((color.r + 0.055) * (1.0 / 1.055), 2.4), color.g < 0.04045 ? color.g * (1.0 / 12.92) : pow((color.g + 0.055) * (1.0 / 1.055), 2.4), color.b < 0.04045 ? color.b * (1.0 / 12.92) : pow((color.b + 0.055) * (1.0 / 1.055), 2.4));\n}"
};
var $1d56c6a18dbfd30f$export$bee4a7d47f8f5014 = {
    register (e, t) {
        if ($1d56c6a18dbfd30f$var$ft[e]) throw new Error(`Key of ${e} is already registered in ShaderLib.`);
        $1d56c6a18dbfd30f$var$ft[e] = t;
    },
    compile: (e)=>$1d56c6a18dbfd30f$var$ht(e)
};
const $1d56c6a18dbfd30f$var$ut = /^[ \t]*#include +<([\w\d.]+)>/gm;
function $1d56c6a18dbfd30f$var$ht(e) {
    return e.replace($1d56c6a18dbfd30f$var$ut, $1d56c6a18dbfd30f$var$mt);
}
function $1d56c6a18dbfd30f$var$mt(e, t) {
    const n = $1d56c6a18dbfd30f$var$ft[t];
    if (!n) throw new Error("Can not resolve #include <" + t + ">");
    return $1d56c6a18dbfd30f$var$ht(n);
}
const $1d56c6a18dbfd30f$var$vt = "function", $1d56c6a18dbfd30f$var$_t = "array";
let $1d56c6a18dbfd30f$var$gt = 0;
const $1d56c6a18dbfd30f$var$xt = {};
class $1d56c6a18dbfd30f$export$462bb059fed9d9e5 {
    constructor({ vert: e, frag: t, uniforms: n, defines: r, extraCommandProps: i }){
        this.vert = e, this.frag = t;
        const o = $1d56c6a18dbfd30f$var$gt++;
        Object.defineProperty(this, "uid", {
            enumerable: !0,
            configurable: !1,
            get: ()=>o
        }), this.shaderDefines = r && $1d56c6a18dbfd30f$var$v({}, r) || {}, n = this.uniforms = (n || []).slice(), this.contextDesc = {};
        for(let e = 0, t = n.length; e < t; e++){
            const t = n[e];
            if ($1d56c6a18dbfd30f$var$d(t)) {
                if (t.indexOf("[") > 0) {
                    const { name: e, len: n } = $1d56c6a18dbfd30f$var$bt(t);
                    this.contextDesc[e] = {
                        name: e,
                        type: "array",
                        length: n
                    };
                } else this.contextDesc[t] = null;
            } else if (t.name.indexOf("[") > 0) {
                const { name: e, len: n } = $1d56c6a18dbfd30f$var$bt(t.name);
                this.contextDesc[e] = {
                    name: e,
                    type: "array",
                    length: n,
                    fn: t.fn
                };
            } else this.contextDesc[t.name] = t;
        }
        this.extraCommandProps = i && $1d56c6a18dbfd30f$var$v({}, i) || {}, this.commands = {}, this._compileSource();
    }
    set shaderDefines(e) {
        this._shaderDefines = e, this.dkey = Object.keys(this._shaderDefines).join();
    }
    get shaderDefines() {
        return this._shaderDefines || {};
    }
    setDefines(e) {
        this.shaderDefines = e;
    }
    setFramebuffer(e) {
        return this.context.framebuffer = e, this;
    }
    appendDescUniforms(e, t) {
        const n = t, r = this.contextDesc;
        for(const i in r)if (r[i]) {
            if ("array" === r[i].type) {
                const o = i, a = r[i].length;
                let s = t[i];
                if (r[i].fn && (s = r[i].fn(null, t)), !s) continue;
                if (s.length !== a) throw new Error(`${o} uniform's length is not ${a}`);
                n[o] = n[o] || {};
                for(let t = 0; t < a; t++)n[o][`${t}`] = s[t].getREGLTexture ? s[t].getREGLTexture(e) : s[t];
            } else "function" === r[i].type && (Object.getOwnPropertyDescriptor(n, i) || Object.defineProperty(n, i, {
                configurable: !1,
                enumerable: !0,
                get: function() {
                    return r[i].fn(null, t);
                }
            }));
        }
        return n;
    }
    setUniforms(e) {
        if (e.modelMatrix || e.positionMatrix) throw new Error("modelMatrix or positionMatrix is reserved uniform name for Mesh, please change to another name");
        return this.contextKeys = e ? Object.keys(e).join() : null, this.context = e, this;
    }
    getVersion(e, t) {
        if ("#version" === t.substring(0, 8)) return "";
        return 0 === e.limits.version.indexOf("WebGL 2.0") && 300 === this.version ? "#version 300 es\n" : "#version 100\n";
    }
    getActiveVars(e, t, n, r) {
        const i = r;
        if ($1d56c6a18dbfd30f$var$xt[i]) return $1d56c6a18dbfd30f$var$xt[i];
        const o = e._gl, a = o.createProgram(), s = o.createShader(35633);
        o.shaderSource(s, t), o.compileShader(s);
        const c = o.createShader(35632);
        o.shaderSource(c, n), o.compileShader(c), o.attachShader(a, c), o.attachShader(a, s), o.linkProgram(a);
        const l = o.getProgramParameter(a, 35721), f = [];
        for(let e = 0; e < l; ++e){
            const t = o.getActiveAttrib(a, e);
            t && f.push({
                name: t.name,
                type: t.type
            });
        }
        const d = o.getProgramParameter(a, 35718), u = [];
        for(let e = 0; e < d; ++e){
            const t = o.getActiveUniform(a, e);
            let n = t.name;
            t.name.indexOf("[") > 0 && (n = n.replace("[0]", "")), u.push(n);
        }
        return o.deleteProgram(a), o.deleteShader(s), o.deleteShader(c), $1d56c6a18dbfd30f$var$xt[i] = {
            activeUniforms: u,
            activeAttributes: f
        }, $1d56c6a18dbfd30f$var$xt[i];
    }
    createREGLCommand(e, t, n, r, i, o = {}) {
        const a = $1d56c6a18dbfd30f$var$A(e) && !i, s = $1d56c6a18dbfd30f$var$v({}, this.shaderDefines || {}, t || {}), c = this._insertDefines(this.vert, s), l = this.getVersion(e, c) + c, f = this._insertDefines(this.frag, s), d = this.getVersion(e, f) + f, u = $1d56c6a18dbfd30f$var$w(l) + "_" + $1d56c6a18dbfd30f$var$w(d), { activeAttributes: h, activeUniforms: m } = this.getActiveVars(e, l, d, u), _ = {};
        h.forEach((t, n)=>{
            const r = t.name;
            _[r] = a ? n : e.prop(r);
        });
        const x = {};
        m.forEach((t)=>{
            x[t] = e.prop(t);
        });
        const p = this.contextDesc;
        for(const t in p)if (p[t] && p[t].type === $1d56c6a18dbfd30f$var$vt) x[t] = p[t].fn;
        else if (p[t] && p[t].type === $1d56c6a18dbfd30f$var$_t) {
            const n = p[t].name, r = p[t].length;
            for(let t = 0; t < r; t++){
                const r = `${n}[${t}]`;
                x[r] = e.prop(r);
            }
        } else x[t] = e.prop(t);
        const b = {
            vert: l,
            frag: d,
            uniforms: x,
            attributes: _
        };
        a && (b.vao = e.prop("vao")), a && !r || !n || $1d56c6a18dbfd30f$var$g(n) || (b.elements = e.prop("elements")), b.count = e.prop("count"), b.offset = e.prop("offset"), b.primitive = e.prop("primitive"), b.framebuffer = e.prop("framebuffer"), r && (b.instances = e.prop("instances")), $1d56c6a18dbfd30f$var$v(b, this.extraCommandProps, o);
        const y = e(b);
        return h.key = h.map((e)=>e.name).join(), y.activeAttributes = h, y;
    }
    dispose() {
        for(const e in this.commands){
            const t = this.commands[e];
            t && t.destroy && !t[$1d56c6a18dbfd30f$var$L] && (t[$1d56c6a18dbfd30f$var$L] = !0, t.destroy());
        }
        this.commands = {}, delete this.vert, delete this.frag;
    }
    _insertDefines(e, t) {
        const n = [];
        for(const e in t)$1d56c6a18dbfd30f$var$S(t, e) && !$1d56c6a18dbfd30f$var$m(t[e]) && n.push(`#define ${e} ${t[e]}\n`);
        return n.join("") + e;
    }
    _compileSource() {
        this.vert = $1d56c6a18dbfd30f$export$bee4a7d47f8f5014.compile(this.vert), this.frag = $1d56c6a18dbfd30f$export$bee4a7d47f8f5014.compile(this.frag);
    }
}
function $1d56c6a18dbfd30f$var$bt(e) {
    const t = e.indexOf("["), n = e.indexOf("]");
    return {
        name: e.substring(0, t),
        len: +e.substring(t + 1, n)
    };
}
class $1d56c6a18dbfd30f$export$9d2cc9f1c4004434 extends $1d56c6a18dbfd30f$export$462bb059fed9d9e5 {
    draw(e, t) {
        if (!t || !t.length) return 0;
        const n = [];
        let r, i = 0;
        for(let o = 0, a = t.length; o < a; o++){
            if (!t[o].isValid()) {
                o === a - 1 && r && n.length && r(n);
                continue;
            }
            if (!t[o].geometry.getDrawCount() || !this._runFilter(t[o])) {
                o === a - 1 && r && n.length && r(n);
                continue;
            }
            const s = this.getMeshCommand(e, t[o]);
            n.length && r !== s && (r(n), n.length = 0);
            const c = t[o].getREGLProps(e, s.activeAttributes);
            this._ensureContextDefines(c), c.shaderContext = this.context, this.appendDescUniforms(e, c), n.push(c), i++, o < a - 1 ? r = s : o === a - 1 && s(n);
        }
        return i;
    }
    _ensureContextDefines(e) {
        if (this.context && (e.contextKeys || (e.contextKeys = {}), e.contextKeys[this.uid] !== this.contextKeys)) {
            for(const t in this.context)"framebuffer" === t || Object.getOwnPropertyDescriptor(e, t) || Object.defineProperty(e, t, {
                configurable: !1,
                enumerable: !0,
                get: function() {
                    return this.shaderContext[t];
                }
            });
            Object.getOwnPropertyDescriptor(e, "framebuffer") || Object.defineProperty(e, "framebuffer", {
                configurable: !1,
                enumerable: !0,
                get: function() {
                    return this.targetFramebuffer || this.shaderContext && this.shaderContext.framebuffer;
                }
            }), e.contextKeys[this.uid] = this.contextKeys;
        }
    }
    _runFilter(e) {
        const t = this.filter;
        if (!t) return !0;
        if (Array.isArray(t)) {
            for(let n = 0; n < t.length; n++)if (!t[n](e)) return !1;
            return !0;
        }
        return t(e);
    }
    getMeshCommand(e, t) {
        this._cmdKeys || (this._cmdKeys = {});
        const n = this.dkey || "default";
        let r = this._cmdKeys[n];
        r || (r = this._cmdKeys[n] = {});
        const i = t.getCommandKey(e);
        r[i] || (r[i] = n + "_" + t.getCommandKey(e));
        const o = r[i];
        let a = this.commands[o];
        if (!a) {
            const n = t.getDefines(), r = t.getMaterial(), i = {};
            if (r) r.doubleSided && this.extraCommandProps && (i.cull = {
                enable: !1
            });
            a = this.commands[o] = this.createREGLCommand(e, n, t.getElements(), t instanceof $1d56c6a18dbfd30f$export$f3c979c331175ad7, t.disableVAO, i);
        }
        return a;
    }
}
class $1d56c6a18dbfd30f$export$b54426a9fafcfc5e extends $1d56c6a18dbfd30f$export$9d2cc9f1c4004434 {
    constructor(t = {}){
        let n = t.extraCommandProps || {};
        const r = [];
        n = $1d56c6a18dbfd30f$var$v({}, n, {
            blend: {
                enable: !0,
                func: {
                    src: "src alpha",
                    dst: "one minus src alpha"
                },
                equation: "add"
            },
            sample: {
                alpha: !0
            }
        }), super({
            vert: "#include <gl2_vert>\nattribute vec3 aPosition;\nattribute vec3 aBarycentric;\nvarying vec3 vBarycentric;\nuniform mat4 modelMatrix;\nuniform mat4 modelViewMatrix;\nuniform mat4 projMatrix;\nuniform mat4 positionMatrix;\nvarying vec3 vPosition;\n#include <get_output>\nvoid main() {\n  mat4 c = getPositionMatrix();\n  vec4 d = getPosition(aPosition);\n#ifdef HAS_MASK_EXTENT\ngl_Position = projMatrix * getMaskPosition(c * d, modelMatrix);\n#else\ngl_Position = projMatrix * modelViewMatrix * c * d;\n#endif\nvBarycentric = aBarycentric;\n  vPosition = aPosition;\n}",
            frag: "#if __VERSION__ == 100\n#ifdef GL_OES_standard_derivatives\n#extension GL_OES_standard_derivatives : enable\n#endif\n#endif\nprecision mediump float;\n#include <gl2_frag>\nvarying vec3 vBarycentric;\nuniform float time;\nuniform float thickness;\nuniform float secondThickness;\nuniform float dashRepeats;\nuniform float dashLength;\nuniform bool dashOverlap;\nuniform bool dashEnabled;\nuniform bool dashAnimate;\nuniform bool seeThrough;\nuniform bool insideAltColor;\nuniform bool dualStroke;\nuniform bool squeeze;\nuniform float squeezeMin;\nuniform float squeezeMax;\nuniform vec4 stroke;\nuniform vec4 fill;\nuniform float opacity;\nuniform bool noiseEnable;\nvarying vec3 vPosition;\n#ifdef HAS_INSTANCE\nvarying vec4 vInstanceColor;\n#endif\n#include <mask_frag>\n#define F4 0.309016994374947451\n#define halfDist 0.5\nvec4 c(vec4 x) {\n  return x - floor(x * (1. / 289.)) * 289.;\n}\nfloat c(float x) {\n  return x - floor(x * (1. / 289.)) * 289.;\n}\nvec4 d(vec4 x) {\n  return c((x * 34. + 1.) * x);\n}\nfloat d(float x) {\n  return c((x * 34. + 1.) * x);\n}\nvec4 e(vec4 r) {\n  return 1.79284291400159 - .85373472095314 * r;\n}\nfloat e(float r) {\n  return 1.79284291400159 - .85373472095314 * r;\n}\nvec4 f(float h, vec4 i) {\n  const vec4 k = vec4(1., 1., 1., -1.);\n  vec4 p, s;\n  p.xyz = floor(fract(vec3(h) * i.xyz) * 7.) * i.z - 1.;\n  p.w = 1.5 - dot(abs(p.xyz), k.xyz);\n  s = vec4(lessThan(p, vec4(.0)));\n  p.xyz = p.xyz + (s.xyz * 2. - 1.) * s.www;\n  return p;\n}\nfloat l(vec4 m) {\n  const vec4 n = vec4(.138196601125011, .276393202250021, .414589803375032, -.447213595499958);\n  vec4 o = floor(m + dot(m, vec4(F4)));\n  vec4 u = m - o + dot(o, n.xxxx);\n  vec4 A;\n  vec3 B = step(u.yzw, u.xxx);\n  vec3 D = step(u.zww, u.yyz);\n  A.x = B.x + B.y + B.z;\n  A.yzw = 1. - B;\n  A.y += D.x + D.y;\n  A.zw += 1. - D.xy;\n  A.z += D.z;\n  A.w += 1. - D.z;\n  vec4 E = clamp(A, .0, 1.);\n  vec4 F = clamp(A - 1., .0, 1.);\n  vec4 G = clamp(A - 2., .0, 1.);\n  vec4 H = u - G + n.xxxx;\n  vec4 I = u - F + n.yyyy;\n  vec4 J = u - E + n.zzzz;\n  vec4 K = u + n.wwww;\n  o = c(o);\n  float L = d(d(d(d(o.w) + o.z) + o.y) + o.x);\n  vec4 M = d(d(d(d(o.w + vec4(G.w, F.w, E.w, 1.)) + o.z + vec4(G.z, F.z, E.z, 1.)) + o.y + vec4(G.y, F.y, E.y, 1.)) + o.x + vec4(G.x, F.x, E.x, 1.));\n  vec4 i = vec4(1. / 294., 1. / 49., 1. / 7., .0);\n  vec4 N = f(L, i);\n  vec4 O = f(M.x, i);\n  vec4 P = f(M.y, i);\n  vec4 Q = f(M.z, i);\n  vec4 R = f(M.w, i);\n  vec4 S = e(vec4(dot(N, N), dot(O, O), dot(P, P), dot(Q, Q)));\n  N *= S.x;\n  O *= S.y;\n  P *= S.z;\n  Q *= S.w;\n  R *= e(dot(R, R));\n  vec3 T = max(.6 - vec3(dot(u, u), dot(H, H), dot(I, I)), .0);\n  vec2 U = max(.6 - vec2(dot(J, J), dot(K, K)), .0);\n  T = T * T;\n  U = U * U;\n  return 49. * (dot(T * T, vec3(dot(N, u), dot(O, H), dot(P, I))) + dot(U * U, vec2(dot(Q, J), dot(R, K))));\n}\nconst float V = 3.14159265359;\nfloat W(float X, float Y) {\n  float Z = fwidth(Y) * halfDist;\n  return smoothstep(X - Z, X + Z, Y);\n}\nvec4 ba(vec3 bb) {\n  float bc = min(min(bb.x, bb.y), bb.z);\n  float bd = .0;\n  if(noiseEnable)\n    bd += l(vec4(vPosition.xyz * 80.0, time * halfDist)) * .12;\n  bc += bd;\n  float be = max(bb.x, bb.y);\n  if(bb.y < bb.x && bb.y < bb.z) {\n    be = 1. - be;\n  }\n  float bf = thickness;\n  if(squeeze) {\n    bf *= mix(squeezeMin, squeezeMax, (1. - sin(be * V)));\n  }\n  if(dashEnabled) {\n    float bg = 1. / dashRepeats * dashLength / 2.;\n    if(!dashOverlap) {\n      bg += 1. / dashRepeats / 2.;\n    }\n    if(dashAnimate) {\n      bg += time * .22;\n    }\n    float bh = fract((be + bg) * dashRepeats);\n    bf *= 1. - W(dashLength, bh);\n  }\n  float bi = 1. - W(bf, bc);\n#ifdef HAS_INSTANCE\nvec4 bj = vInstanceColor;\n#else\nvec4 bj = stroke;\n#endif\nvec4 bk = vec4(.0);\n  if(seeThrough) {\n    bk = vec4(bj.xyz, bi);\n    if(insideAltColor && !gl_FrontFacing) {\n      bk.rgb = fill.xyz;\n    }\n  } else {\n    vec3 bl = mix(fill.xyz, bj.xyz, bi);\n    bk.a = fill.a;\n    if(dualStroke) {\n      float bm = 1. - W(secondThickness, bc);\n      vec3 bn = mix(fill.xyz, stroke.xyz, abs(bm - bi));\n      bk.rgb = bn;\n    } else {\n      bk.rgb = bl;\n    }\n  }\n  return bk;\n}\nvoid main() {\n  glFragColor = ba(vBarycentric);\n  glFragColor *= halfDist + opacity;\n#ifdef HAS_MASK_EXTENT\nglFragColor = setMask(glFragColor);\n#endif\n#if __VERSION__ == 100\ngl_FragColor = glFragColor;\n#endif\n}",
            uniforms: [
                {
                    name: "modelViewMatrix",
                    type: "function",
                    fn: (t, n)=>(0, $3iqbd).multiply(r, n.viewMatrix, n.modelMatrix)
                }
            ],
            extraCommandProps: n
        }), this.version = 300;
    }
}
class $1d56c6a18dbfd30f$export$4e9078b58a7c4ba7 extends $1d56c6a18dbfd30f$export$9d2cc9f1c4004434 {
    constructor(t = {}){
        const n = [], i = [], o = t.uniforms, a = [
            {
                name: "modelNormalMatrix",
                type: "function",
                fn: function(e, t) {
                    return (0, $bDSmI).fromMat4(n, t.modelMatrix);
                }
            },
            {
                name: "modelViewMatrix",
                type: "function",
                fn: function(t, n) {
                    return (0, $3iqbd).multiply(i, n.viewMatrix, n.modelMatrix);
                }
            }
        ];
        o && a.push(...o), super({
            vert: t.vert || "#include <gl2_vert>\nattribute vec3 aPosition;\n#include <line_extrusion_vert>\n#ifdef HAS_MAP\nuniform vec2 uvScale;\nuniform vec2 uvOffset;\nattribute vec2 aTexCoord;\nvarying vec2 vTexCoord;\n#ifdef HAS_I3S_UVREGION\nattribute vec4 uvRegion;\nvarying vec4 vUvRegion;\n#endif\n#if defined(HAS_AO_MAP)\nattribute vec2 aTexCoord1;\nvarying vec2 vTexCoord1;\n#endif\n#endif\n#if defined(HAS_COLOR)\nattribute vec4 aColor;\nvarying vec4 vColor;\n#elif defined(HAS_COLOR0)\n#if COLOR0_SIZE == 3\nattribute vec3 aColor0;\n#else\nattribute vec4 aColor0;\n#endif\nvarying vec4 vColor;\n#endif\nvarying vec3 vFragPos;\nvarying vec3 vNormal;\nuniform mat4 projMatrix;\nuniform mat3 modelNormalMatrix;\nuniform mat4 modelViewMatrix;\nuniform mat4 modelMatrix;\nuniform mat4 positionMatrix;\nuniform vec2 halton;\nuniform vec2 outSize;\nuniform mat4 projViewMatrix;\n#include <highlight_vert>\n#include <get_output>\n#include <heatmap_render_vert>\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n#include <vsm_shadow_vert>\n#endif\n#ifdef HAS_EXTRUSION_OPACITY\nattribute float aExtrusionOpacity;\nvarying float vExtrusionOpacity;\n#endif\n#if defined(HAS_TANGENT)\nvarying vec4 vTangent;\n#endif\nvoid c(const highp vec4 q, out highp vec3 d) {\n  d = vec3(.0, .0, 1.) + vec3(2., -2., -2.) * q.x * q.zwx + vec3(2., 2., -2.) * q.y * q.wzy;\n}\nvoid c(const highp vec4 q, out highp vec3 d, out highp vec3 t) {\n  c(q, d);\n  t = vec3(1., .0, .0) + vec3(-2., 2., -2.) * q.y * q.yxw + vec3(-2., 2., 2.) * q.z * q.zwx;\n}\n#include <vertex_color_vert>\nvoid main() {\n  \n#ifdef IS_LINE_EXTRUSION\nvec4 e = getPosition(getLineExtrudePosition(aPosition));\n#else\nvec4 e = getPosition(aPosition);\n#endif\nmat4 f = getPositionMatrix();\n  vFragPos = vec3(modelMatrix * f * e);\n#if defined(HAS_NORMAL) || defined(HAS_TANGENT)\nmat3 h = modelNormalMatrix * mat3(f);\n  vec3 i;\n#if defined(HAS_TANGENT)\nvec3 t;\n  c(aTangent, i, t);\n  vTangent = vec4(h * t, aTangent.w);\n#else\ni = decode_getNormal(aNormal);\n#endif\nvec3 j = appendMorphNormal(i);\n  vNormal = normalize(h * j);\n#else\nvNormal = vec3(.0);\n#endif\nmat4 k = projMatrix;\n  k[2].xy += halton.xy / outSize.xy;\n#ifdef HAS_MASK_EXTENT\ngl_Position = k * getMaskPosition(f * e, modelMatrix);\n#else\ngl_Position = k * modelViewMatrix * f * e;\n#endif\n#ifdef HAS_MAP\nvec2 l = decode_getTexcoord(aTexCoord);\n  vTexCoord = l * uvScale + uvOffset;\n#endif\n#ifdef HAS_AO_MAP\nvec2 m = decode_getTexcoord(aTexCoord1);\n  vTexCoord1 = m * uvScale + uvOffset;\n#endif\n#ifdef HAS_EXTRUSION_OPACITY\nvExtrusionOpacity = aExtrusionOpacity;\n#endif\n#if defined(HAS_COLOR)\nvColor = aColor / 255.;\n#elif defined(HAS_COLOR0)\n#if COLOR0_SIZE == 3\nvColor = vec4(aColor0 / 255., 1.);\n#else\nvColor = aColor0 / 255.;\n#endif\n#endif\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\nshadow_computeShadowPars(f * e);\n#endif\n#ifdef HAS_HEATMAP\nheatmap_compute(projMatrix * modelViewMatrix * f, e);\n#endif\n#ifdef HAS_I3S_UVREGION\nvUvRegion = uvRegion / 65535.;\n#endif\nhighlight_setVarying();\n#ifdef HAS_VERTEX_COLOR\nvertexColor_update();\n#endif\n}",
            frag: t.frag || "precision mediump float;\n#include <gl2_frag>\nuniform vec4 baseColorFactor;\nuniform float materialShininess;\nuniform float environmentExposure;\nuniform float specularStrength;\nuniform vec3 light0_viewDirection;\nuniform vec3 ambientColor;\nuniform vec4 light0_diffuse;\nuniform vec3 lightSpecular;\nuniform vec3 cameraPosition;\nuniform float alphaTest;\n#ifdef HAS_TOON\nuniform float toons;\nuniform float specularToons;\n#endif\n#ifdef HAS_TANGENT\nvarying vec4 vTangent;\n#endif\n#ifdef HAS_MAP\n#include <computeTexcoord_frag>\n#endif\nvarying vec3 vNormal;\nvarying vec3 vFragPos;\n#ifdef HAS_INSTANCE_COLOR\nvarying vec4 vInstanceColor;\n#endif\n#ifdef HAS_BASECOLOR_MAP\nuniform sampler2D baseColorTexture;\n#endif\n#ifdef HAS_EXTRUSION_OPACITY\nuniform vec2 extrusionOpacityRange;\nvarying float vExtrusionOpacity;\n#endif\n#if defined(HAS_COLOR) || defined(HAS_COLOR0)\nvarying vec4 vColor;\n#elif defined(IS_LINE_EXTRUSION)\nuniform vec4 lineColor;\n#else\nuniform vec4 polygonFill;\n#endif\n#ifdef HAS_LAYER_OPACITY\nuniform float layerOpacity;\n#endif\n#ifdef IS_LINE_EXTRUSION\nuniform float lineOpacity;\n#else\nuniform float polygonOpacity;\n#endif\n#ifdef HAS_AO_MAP\nuniform sampler2D occlusionTexture;\nvarying vec2 vTexCoord1;\n#endif\n#ifdef HAS_NORMAL_MAP\nuniform sampler2D normalTexture;\n#endif\n#ifdef HAS_EMISSIVE_MAP\nuniform sampler2D emissiveTexture;\n#endif\n#ifdef SHADING_MODEL_SPECULAR_GLOSSINESS\nuniform vec4 diffuseFactor;\nuniform vec3 specularFactor;\n#ifdef HAS_DIFFUSE_MAP\nuniform sampler2D diffuseTexture;\n#endif\n#ifdef HAS_SPECULARGLOSSINESS_MAP\nuniform sampler2D specularGlossinessTexture;\n#endif\n#endif\n#include <heatmap_render_frag>\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n#include <vsm_shadow_frag>\n#endif\n#include <highlight_frag>\n#include <mask_frag>\n#include <vertex_color_frag>\nvec3 c() {\n  \n#if defined(HAS_NORMAL_MAP)\nvec3 d = normalize(vNormal);\n  vec3 e = texture2D(normalTexture, computeTexCoord(vTexCoord)).xyz * 2. - 1.;\n#if defined(HAS_TANGENT)\nvec3 t = normalize(vTangent.xyz);\n  vec3 b = normalize(cross(d, t) * sign(vTangent.w));\n  mat3 f = mat3(t, b, d);\n  return normalize(f * e);\n#else\nreturn normalize(e);\n#endif\n#else\nreturn normalize(vNormal);\n#endif\n}\nvec4 h() {\n  \n#if defined(HAS_BASECOLOR_MAP)\nreturn texture2D(baseColorTexture, computeTexCoord(vTexCoord));\n#elif defined(HAS_DIFFUSE_MAP)\nreturn texture2D(diffuseTexture, computeTexCoord(vTexCoord));\n#elif defined(SHADING_MODEL_SPECULAR_GLOSSINESS)\nreturn diffuseFactor;\n#else\nreturn baseColorFactor;\n#endif\n}\nvec3 i() {\n  \n#if defined(HAS_SPECULARGLOSSINESS_MAP)\nreturn texture2D(specularGlossinessTexture, computeTexCoord(vTexCoord)).rgb;\n#elif defined(SHADING_MODEL_SPECULAR_GLOSSINESS)\nreturn specularFactor;\n#else\nreturn vec3(1.);\n#endif\n}\nvoid main() {\n  vec4 j = h();\n  vec3 k = environmentExposure * ambientColor * j.rgb;\n#ifdef HAS_INSTANCE_COLOR\nk *= vInstanceColor.rgb;\n#endif\nvec3 l = c();\n  vec3 m = normalize(-light0_viewDirection);\n  float o = max(dot(l, m), .0);\n#ifdef HAS_TOON\nfloat u = floor(o * toons);\n  o = u / toons;\n#endif\nvec3 v = light0_diffuse.rgb * o * j.rgb;\n#if defined(HAS_COLOR) || defined(HAS_COLOR0)\nvec3 A = vColor.rgb;\n#elif defined(IS_LINE_EXTRUSION)\nvec3 A = lineColor.rgb;\n#else\nvec3 A = polygonFill.rgb;\n#endif\n#ifdef HAS_INSTANCE_COLOR\nA *= vInstanceColor.rgb;\n#endif\nk *= A.rgb;\n  v *= A.rgb;\n  vec3 B = normalize(cameraPosition - vFragPos);\n  vec3 C = normalize(m + B);\n  float D = pow(max(dot(l, C), .0), materialShininess);\n#ifdef HAS_TOON\nfloat E = floor(D * specularToons);\n  D = E / specularToons;\n#endif\nvec3 F = specularStrength * lightSpecular * D * i();\n#ifdef HAS_OCCLUSION_MAP\nfloat G = texture2D(occlusionTexture, computeTexCoord(vTexCoord1)).r;\n  k *= G;\n#endif\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\nfloat H = shadow_computeShadow();\n  v = shadow_blend(v, H).rgb;\n  F = shadow_blend(F, H).rgb;\n  k = shadow_blend(k, H).rgb;\n#endif\nvec3 I = k + v + F;\n#ifdef HAS_EMISSIVE_MAP\nvec3 J = texture2D(emissiveTexture, computeTexCoord(vTexCoord)).rgb;\n  I += J;\n#endif\n#ifdef IS_LINE_EXTRUSION\nglFragColor = vec4(I, lineOpacity * j.a);\n#else\nglFragColor = vec4(I, polygonOpacity * j.a);\n#endif\n#if defined(HAS_COLOR) || defined(HAS_COLOR0)\nfloat K = vColor.a;\n#elif defined(IS_LINE_EXTRUSION)\nfloat K = lineColor.a;\n#else\nfloat K = polygonFill.a;\n#endif\nglFragColor *= K;\n#ifdef HAS_EXTRUSION_OPACITY\nfloat L = extrusionOpacityRange.x;\n  float M = extrusionOpacityRange.y;\n  float N = L + vExtrusionOpacity * (M - L);\n  N = clamp(N, .0, 1.);\n  glFragColor *= N;\n#endif\nif(glFragColor.a < alphaTest) {\n    discard;\n  }\n#ifdef HAS_VERTEX_COLOR\nglFragColor *= vertexColor_get();\n#endif\n#ifdef HAS_HEATMAP\nglFragColor = heatmap_getColor(glFragColor);\n#endif\nglFragColor = highlight_blendColor(glFragColor);\n#ifdef HAS_LAYER_OPACITY\nglFragColor *= layerOpacity;\n#endif\n#ifdef HAS_MASK_EXTENT\nglFragColor = setMask(glFragColor);\n#endif\n#if __VERSION__ == 100\ngl_FragColor = glFragColor;\n#endif\n}",
            uniforms: a,
            defines: t.defines || {},
            extraCommandProps: t.extraCommandProps || {}
        }), this.version = 300;
    }
    getGeometryDefines(e) {
        const t = {};
        return e.data[e.desc.tangentAttribute] ? t.HAS_TANGENT = 1 : e.data[e.desc.normalAttribute] && (t.HAS_NORMAL = 1), t;
    }
}
class $1d56c6a18dbfd30f$export$78eff65aa3e6c692 extends $1d56c6a18dbfd30f$export$9d2cc9f1c4004434 {
    constructor(t = {}){
        const n = [];
        super({
            vert: "attribute vec3 aPosition;\n#ifdef HAS_COLOR0\nattribute vec4 aColor0;\nvarying vec4 vColor;\n#endif\nuniform mat4 modelMatrix;\nuniform mat4 projMatrix;\nuniform mat4 positionMatrix;\nuniform mat4 projViewModelMatrix;\nuniform float pointSize;\n#if defined(HAS_MAP)\nattribute vec2 aTexCoord;\nvarying vec2 vTexCoord;\n#endif\n#include <get_output>\n#include <heatmap_render_vert>\n#ifdef HAS_FLOODANALYSE\nvarying float vHeight;\n#endif\nvoid main() {\n  vec4 c = getPosition(aPosition);\n  mat4 d = getPositionMatrix();\n  gl_PointSize = pointSize;\n#ifdef HAS_MASK_EXTENT\ngl_Position = projMatrix * getMaskPosition(d * c, modelMatrix);\n#else\ngl_Position = projViewModelMatrix * d * c;\n#endif\n#ifdef HAS_COLOR0\nvColor = aColor0 / 255.;\n#endif\n#ifdef HAS_MAP\nvTexCoord = aTexCoord;\n#endif\n#ifdef HAS_HEATMAP\nheatmap_compute(projMatrix * modelViewMatrix * d, c);\n#endif\n}",
            frag: "precision mediump float;\n#include <gl2_frag>\n#if defined(HAS_COLOR0)\nvarying vec4 vColor;\n#endif\n#include <heatmap_render_frag>\nuniform vec4 baseColorFactor;\n#if defined(HAS_MAP)\n#if defined(HAS_ALBEDO_MAP)\nuniform sampler2D baseColorTexture;\n#endif\n#if defined(HAS_DIFFUSE_MAP)\nuniform sampler2D diffuseTexture;\n#endif\nvarying vec2 vTexCoord;\n#endif\n#include <mask_frag>\nvoid main() {\n  \n#ifdef HAS_COLOR0\nglFragColor = vColor * baseColorFactor;\n#else\nglFragColor = vec4(1.) * baseColorFactor;\n#endif\n#ifdef HAS_MAP\n#ifdef HAS_ALBEDO_MAP\nglFragColor *= texture2D(baseColorTexture, vTexCoord);\n#endif\n#ifdef HAS_DIFFUSE_MAP\nglFragColor *= texture2D(diffuseTexture, vTexCoord);\n#endif\n#endif\n#ifdef HAS_HEATMAP\nglFragColor = heatmap_getColor(glFragColor);\n#endif\n#ifdef HAS_MASK_EXTENT\nglFragColor = setMask(glFragColor);\n#endif\n#if __VERSION__ == 100\ngl_FragColor = glFragColor;\n#endif\n}",
            uniforms: [
                {
                    name: "projViewModelMatrix",
                    type: "function",
                    fn: (t, r)=>(0, $3iqbd).multiply(n, r.projViewMatrix, r.modelMatrix)
                }
            ],
            defines: t.defines || {},
            extraCommandProps: t.extraCommandProps || {}
        });
    }
}
var $1d56c6a18dbfd30f$var$Mt = "#if __VERSION__ == 300\n#define attribute in\n#define varying out\n#endif\nattribute vec2 aPosition;\nattribute vec2 aTexCoord;\nvarying vec2 vTexCoord;\nvoid main() {\n  gl_Position = vec4(aPosition, 0., 1.);\n  vTexCoord = aTexCoord;\n}";
const $1d56c6a18dbfd30f$var$Ot = new Int8Array([
    -1,
    1,
    -1,
    -1,
    1,
    1,
    1,
    1,
    -1,
    -1,
    1,
    -1
]), $1d56c6a18dbfd30f$var$Ct = new Uint8Array([
    0,
    1,
    0,
    0,
    1,
    1,
    1,
    1,
    0,
    0,
    1,
    0
]);
class $1d56c6a18dbfd30f$export$e82c04eda9e9b75c extends $1d56c6a18dbfd30f$export$9d2cc9f1c4004434 {
    constructor(e){
        e.vert = e.vert || $1d56c6a18dbfd30f$var$Mt, e.extraCommandProps = e.extraCommandProps || {}, e.extraCommandProps.depth || (e.extraCommandProps.depth = {
            enable: !1,
            mask: !1
        }), e.extraCommandProps.stencil || (e.extraCommandProps.stencil = {
            enable: !1
        }), super(e);
    }
    draw(e) {
        return this._quadMesh || this._createQuadMesh(e), super.draw(e, this._quadMesh);
    }
    getMeshCommand(e) {
        const t = this.dkey || "";
        return this.commands[t + "_quad"] || (this.commands[t + "_quad"] = this.createREGLCommand(e, null, this._quadMesh[0].getElements())), this.commands[t + "_quad"];
    }
    _createQuadMesh(e) {
        const t = new $1d56c6a18dbfd30f$export$2db6c17465f94a2({
            aPosition: $1d56c6a18dbfd30f$var$Ot,
            aTexCoord: $1d56c6a18dbfd30f$var$Ct
        }, null, $1d56c6a18dbfd30f$var$Ot.length / 2, {
            positionSize: 2,
            primitive: "triangles"
        });
        t.generateBuffers(e), this._quadMesh = [
            new $1d56c6a18dbfd30f$export$e176487c05830cc5(t)
        ];
    }
    dispose() {
        if (this._quadMesh) {
            const e = this._quadMesh[0];
            e.geometry.dispose(), e.dispose();
        }
        return delete this._quadMesh, super.dispose();
    }
}
class $1d56c6a18dbfd30f$export$1cdaf2440f7f6138 extends $1d56c6a18dbfd30f$export$e82c04eda9e9b75c {
    constructor(){
        super({
            vert: $1d56c6a18dbfd30f$var$Mt,
            frag: "#define SHADER_NAME FXAA\nprecision mediump float;\nvarying vec2 vTexCoord;\nuniform float enableFXAA;\nuniform float enableToneMapping;\nuniform float enableSharpen;\nuniform vec2 resolution;\nuniform sampler2D textureSource;\n#ifdef HAS_NOAA_TEX\nuniform sampler2D noAaTextureSource;\n#endif\n#ifdef HAS_POINT_TEX\nuniform sampler2D pointTextureSource;\n#endif\n#ifdef HAS_TAA_TEX\nuniform sampler2D taaTextureSource;\n#ifdef HAS_FXAA_TEX\nuniform sampler2D fxaaTextureSource;\n#endif\n#endif\nuniform float pixelRatio;\nuniform float sharpFactor;\n#ifdef HAS_OUTLINE_TEX\nuniform sampler2D textureOutline;\nuniform float enableOutline;\nuniform float highlightFactor;\nuniform float outlineFactor;\nuniform float outlineWidth;\nuniform vec3 outlineColor;\n#endif\nvec2 c;\nvec4 d(vec2 e) {\n  \n#ifdef HAS_TAA_TEX\nvec4 f = texture2D(textureSource, e);\n  vec4 taa = texture2D(taaTextureSource, e);\n#ifdef HAS_FXAA_TEX\nvec4 h = texture2D(fxaaTextureSource, e);\n#else\nvec4 h = vec4(.0);\n#endif\nvec4 i = taa + f * (1. - taa.a);\n  return h + i * (1. - h.a);\n#else\nreturn texture2D(textureSource, e);\n#endif\n}\nvec3 j(const in vec3 k, const float l) {\n  vec2 m = pixelRatio / resolution.xy;\n  float n = .0;\n  vec4 o = texture2D(textureSource, c + m * vec2(-1., -1.));\n  o.rgb = mix(vec3(.0), o.rgb, sign(o.a));\n  n += mix(.0, 1., sign(o.a));\n  vec4 u = texture2D(textureSource, c + m * vec2(1.));\n  u.rgb = mix(vec3(.0), u.rgb, sign(u.a));\n  n += mix(.0, 1., sign(u.a));\n  vec4 v = texture2D(textureSource, c + m * vec2(1., -1.));\n  v.rgb = mix(vec3(.0), v.rgb, sign(v.a));\n  n += mix(.0, 1., sign(v.a));\n  vec4 A = texture2D(textureSource, c + m * vec2(-1., 1.));\n  A.rgb = mix(vec3(.0), A.rgb, sign(A.a));\n  n += mix(.0, 1., sign(A.a));\n  return k + l * (n * k - o.rgb - v.rgb - A.rgb - u.rgb);\n}\nvec4 B(const in vec4 k) {\n  return vec4(j(k.rgb, sharpFactor), k.a);\n}\nvec3 C(const vec3 x) {\n  const float a = 2.51;\n  const float b = .03;\n  const float D = 2.43;\n  const float E = .59;\n  const float F = .14;\n  return (x * (a * x + b)) / (x * (D * x + E) + F);\n}\nvec3 G(vec3 k) {\n  k = k / (k + vec3(1.));\n  return k = pow(k, vec3(1. / 2.2));\n}\n#ifdef HAS_OUTLINE_TEX\nvec4 H() {\n  float I = 2.;\n  float J = 1.;\n  float K = pixelRatio / resolution[0] * outlineWidth;\n  float L = pixelRatio / resolution[1] * outlineWidth;\n  vec4 M = (texture2D(textureOutline, c + vec2(K, L)));\n  vec4 N = (texture2D(textureOutline, c + vec2(K, .0)));\n  vec4 O = (texture2D(textureOutline, c + vec2(K, -L)));\n  vec4 P = (texture2D(textureOutline, c + vec2(.0, -L)));\n  vec4 Q = (texture2D(textureOutline, c + vec2(-K, -L)));\n  vec4 R = (texture2D(textureOutline, c + vec2(-K, .0)));\n  vec4 S = (texture2D(textureOutline, c + vec2(-K, L)));\n  vec4 T = (texture2D(textureOutline, c + vec2(.0, L)));\n  vec4 U = -I * R + I * N + -J * S + J * M + -J * Q + J * O;\n  vec4 V = -I * P + I * T + -J * Q + J * S + -J * O + J * M;\n  float W = sqrt(dot(V, V) + dot(U, U));\n  bool X = W < 1. / 65025.;\n  vec3 Y = (texture2D(textureOutline, c)).r * outlineColor;\n  if(Y == vec3(.0) || (highlightFactor == .0 && X)) {\n    return vec4(.0);\n  }\n  float Z = X ? highlightFactor : min(1., sqrt(W) * outlineFactor);\n  return Z * vec4(Y, 1.);\n}\nvec4 ba(const in vec4 k) {\n  vec4 H = H();\n  return H + vec4(k) * (1. - H.a);\n}\n#endif\nvoid main() {\n  c = vTexCoord;\n  vec4 k;\n  if(enableFXAA == 1.) {\n    \n  } else {\n    k = d(vTexCoord);\n  }\n  if(enableSharpen == 1.) {\n    k = B(k);\n  }\n#if defined(HAS_NOAA_TEX) || defined(HAS_POINT_TEX)\nvec4 bb = vec4(.0);\n  vec4 bc = vec4(.0);\n#ifdef HAS_POINT_TEX\nbb = texture2D(pointTextureSource, vTexCoord);\n#endif\n#ifdef HAS_NOAA_TEX\nbc = texture2D(noAaTextureSource, vTexCoord);\n#endif\nvec4 bd = bb + bc * (1. - bb.a);\n  k = bd + k * (1. - bd.a);\n#endif\nif(enableToneMapping == 1.) {\n    k.rgb = G(k.rgb);\n  }\n#ifdef HAS_OUTLINE_TEX\nk = ba(k);\n#endif\ngl_FragColor = k;\n}",
            extraCommandProps: {
                viewport: {
                    x: 0,
                    y: 0,
                    width: (e, t)=>t.resolution[0],
                    height: (e, t)=>t.resolution[1]
                }
            }
        });
    }
    getMeshCommand(e, t) {
        const n = this.dkey || "";
        return this.commands[n + "_fxaa"] || (this.commands[n + "_fxaa"] = this.createREGLCommand(e, null, t.getElements())), this.commands[n + "_fxaa"];
    }
}
class $1d56c6a18dbfd30f$export$1477fe5fe7b08486 extends $1d56c6a18dbfd30f$export$e82c04eda9e9b75c {
    constructor({ blurOffset: e }){
        super({
            vert: $1d56c6a18dbfd30f$var$Mt,
            frag: "precision highp float;\nvarying vec2 vTexCoord;\nuniform sampler2D textureSource;\nuniform vec2 resolution;\nuniform float ignoreTransparent;\nvoid main() {\n  vec4 c = vec4(.0);\n  float d = .0;\n  for(int x = -BOXBLUR_OFFSET; x <= BOXBLUR_OFFSET; ++x)\n    for(int y = -BOXBLUR_OFFSET; y <= BOXBLUR_OFFSET; ++y) {\n      vec2 e = vTexCoord.st + vec2(float(x) / resolution.x, float(y) / resolution.y);\n      e = clamp(e, .0, 1.);\n      vec4 f = texture2D(textureSource, e);\n      float h;\n      if(ignoreTransparent == 1.) {\n        h = sign(f.a);\n      } else {\n        h = 1.;\n      }\n      d += h;\n      c += h * f;\n    }\n  gl_FragColor = c / max(d, 1.) * clamp(sign(d - 1.), .0, 1.);\n}",
            defines: {
                BOXBLUR_OFFSET: e || 2
            },
            extraCommandProps: {
                viewport: {
                    x: 0,
                    y: 0,
                    width: (e, t)=>t.resolution[0],
                    height: (e, t)=>t.resolution[1]
                }
            }
        }), this._blurOffset = e || 2;
    }
    getMeshCommand(e, t) {
        const n = "box_blur_" + this._blurOffset;
        return this.commands[n] || (this.commands[n] = this.createREGLCommand(e, null, t.getElements())), this.commands[n];
    }
}
class $1d56c6a18dbfd30f$export$7c6e111cc47fa344 extends $1d56c6a18dbfd30f$export$e82c04eda9e9b75c {
    constructor(){
        super({
            vert: $1d56c6a18dbfd30f$var$Mt,
            frag: "precision mediump float;\nvarying vec2 vTexCoord;\nuniform vec2 resolution;\nuniform sampler2D textureSource;\nuniform float enableVignette;\nuniform float enableGrain;\nuniform float enableLut;\nuniform float timeGrain;\nuniform float grainFactor;\nuniform vec2 lensRadius;\nuniform float frameMod;\nuniform sampler2D lookupTable;\n#include <srgb_frag>\nfloat c(const in vec2 d) {\n  vec3 e = fract(vec3(d.xyx) * .1031);\n  e += dot(e, e.yzx + 19.19);\n  return fract((e.x + e.y) * e.z);\n}\nfloat f() {\n  float h = c(gl_FragCoord.xy + 1000.0 * fract(timeGrain));\n  float i = h * 2. - 1.;\n  h = i * inversesqrt(abs(i));\n  h = max(-1., h);\n  h = h - sign(i) + .5;\n  return (h + .5) * .5;\n}\nvec4 j(const in vec4 k) {\n  float l = f();\n  return vec4(mix(k.rgb, k.rgb * (k.rgb + (1. - k.rgb) * 2. * l), grainFactor), k.a);\n}\nfloat m(const in vec2 d, const in float n) {\n  vec3 o = vec3(.06711056, .00583715, 52.9829189);\n  return fract(o.z * fract(dot(d.xy + n * vec2(47., 17.) * .695, o.xy)));\n}\nfloat u() {\n  vec2 v = lensRadius;\n  v.y = min(v.y, v.x - 1e-4);\n  float A = m(gl_FragCoord.xy, frameMod);\n  A = (v.x - v.y) * (v.x + v.y) * .07 * (A - .5);\n  return smoothstep(v.x, v.y, A + distance(vTexCoord, vec2(.5)));\n}\nvec4 B(const in vec4 k) {\n  float l = u();\n  return vec4(linearTosRGB(sRGBToLinear(k.rgb) * l), clamp(k.a + (1. - l), .0, 1.));\n}\nvec4 C(in vec4 D, in sampler2D E) {\n  mediump float F = D.b * 63.;\n  mediump vec2 G;\n  G.y = floor(floor(F) / 8.);\n  G.x = floor(F) - G.y * 8.;\n  mediump vec2 H;\n  H.y = floor(ceil(F) / 8.);\n  H.x = ceil(F) - H.y * 8.;\n  highp vec2 I;\n  I.x = G.x * .125 + .5 / 512. + (.125 - 1. / 512.) * D.r;\n  I.y = G.y * .125 + .5 / 512. + (.125 - 1. / 512.) * D.g;\n#ifdef LUT_FLIP_Y\nI.y = 1. - I.y;\n#endif\nhighp vec2 J;\n  J.x = H.x * .125 + .5 / 512. + (.125 - 1. / 512.) * D.r;\n  J.y = H.y * .125 + .5 / 512. + (.125 - 1. / 512.) * D.g;\n#ifdef LUT_FLIP_Y\nJ.y = 1. - J.y;\n#endif\nlowp vec4 K = texture2D(E, I);\n  lowp vec4 L = texture2D(E, J);\n  lowp vec4 M = mix(K, L, fract(F));\n  return M;\n}\nvoid main() {\n  vec4 k = texture2D(textureSource, vTexCoord);\n  if(enableLut == 1.) {\n    k = C(k, lookupTable);\n  }\n  if(enableVignette == 1.) {\n    k = B(k);\n  }\n  if(enableGrain == 1.) {\n    k = j(k);\n  }\n  gl_FragColor = k;\n}",
            extraCommandProps: {
                viewport: {
                    x: 0,
                    y: 0,
                    width: (e, t)=>t.resolution[0],
                    height: (e, t)=>t.resolution[1]
                }
            }
        });
    }
    getMeshCommand(e, t) {
        return this.commands.postprocess || (this.commands.postprocess = this.createREGLCommand(e, null, t.getElements())), this.commands.postprocess;
    }
}
const $1d56c6a18dbfd30f$var$Rt = [
    [
        .263385,
        -0.0252475
    ],
    [
        -0.38545,
        .054485
    ],
    [
        -0.139795,
        -0.5379925
    ],
    [
        -0.2793775,
        .6875475
    ],
    [
        .7139025,
        .4710925
    ],
    [
        .90044,
        -0.16422
    ],
    [
        .4481775,
        -0.82799
    ],
    [
        -0.9253375,
        -0.2910625
    ],
    [
        .3468025,
        1.02292
    ],
    [
        -1.13742,
        .33522
    ],
    [
        -0.7676225,
        -0.9123175
    ],
    [
        -0.2005775,
        -1.1774125
    ],
    [
        -0.926525,
        .96876
    ],
    [
        1.12909,
        -0.7500325
    ],
    [
        .9603,
        1.14625
    ]
], $1d56c6a18dbfd30f$var$Ht = $1d56c6a18dbfd30f$var$Rt.length, $1d56c6a18dbfd30f$var$Dt = [
    0,
    0
];
for(let e = 0; e < $1d56c6a18dbfd30f$var$Rt.length; e++)$1d56c6a18dbfd30f$var$Dt[0] += $1d56c6a18dbfd30f$var$Rt[e][0], $1d56c6a18dbfd30f$var$Dt[1] += $1d56c6a18dbfd30f$var$Rt[e][1];
$1d56c6a18dbfd30f$var$Dt[0] /= $1d56c6a18dbfd30f$var$Ht, $1d56c6a18dbfd30f$var$Dt[1] /= $1d56c6a18dbfd30f$var$Ht;
class $1d56c6a18dbfd30f$export$b4c0ba5bc03d35 {
    constructor(e){
        this._frameNum = 0, this._ratio = e || .05, this._avg = [
            $1d56c6a18dbfd30f$var$Dt[0] * this._ratio,
            $1d56c6a18dbfd30f$var$Dt[1] * this._ratio
        ];
    }
    getRatio() {
        return this._ratio;
    }
    setRatio(e) {
        this._ratio !== e && (this._ratio = e, this.reset()), this._avg = [
            $1d56c6a18dbfd30f$var$Dt[0] * this._ratio,
            $1d56c6a18dbfd30f$var$Dt[1] * this._ratio
        ];
    }
    getAverage() {
        return this._avg;
    }
    reset() {
        this._frameNum = 0;
    }
    getJitter(e) {
        const t = this._frameNum % $1d56c6a18dbfd30f$var$Ht, n = this._ratio;
        return (0, $6BoVD).set(e, $1d56c6a18dbfd30f$var$Rt[t][0] * n, $1d56c6a18dbfd30f$var$Rt[t][1] * n), e;
    }
    frame() {
        this._frameNum++, this._frameNum % $1d56c6a18dbfd30f$var$Ht == 0 && (this._frameNum = 0);
    }
    getSampleCount() {
        return $1d56c6a18dbfd30f$var$Ht;
    }
}
class $1d56c6a18dbfd30f$var$Nt {
    constructor(e, t, n = 5){
        this._regl = e, this._renderer = new $1d56c6a18dbfd30f$export$88530751e3977073(e), this._inputRGBM = t, this._level = n;
    }
    render(e, t) {
        this._initShaders(), this._createTextures(e), this._blur(e, t || 0);
        const n = {
            blurTex0: this._blur01Tex,
            blurTex1: this._blur11Tex,
            blurTex2: this._blur21Tex,
            blurTex3: this._blur31Tex,
            blurTex4: this._blur41Tex
        };
        return this._level > 5 && (n.blurTex5 = this._blur51Tex, n.blurTex6 = this._blur61Tex), n;
    }
    _blur(e, t) {
        let n = this._blurUniforms;
        n || (n = this._blurUniforms = {
            rgbmRange: 7,
            blurDir: [
                0,
                0
            ],
            outSize: [
                0,
                0
            ],
            pixelRatio: [
                1,
                1
            ],
            outputSize: [
                0,
                0
            ]
        }), (0, $6BoVD).set(n.outSize, e.width, e.height), this._blurOnce(this._blur0Shader, e, this._blur00FBO, this._blur01FBO, .5, t), this._blurOnce(this._blur1Shader, this._blur01FBO.color[0], this._blur10FBO, this._blur11FBO, .5), this._blurOnce(this._blur2Shader, this._blur11FBO.color[0], this._blur20FBO, this._blur21FBO, .5), this._blurOnce(this._blur3Shader, this._blur21FBO.color[0], this._blur30FBO, this._blur31FBO, .5), this._blurOnce(this._blur4Shader, this._blur31FBO.color[0], this._blur40FBO, this._blur41FBO, .5), this._level > 5 && (this._blurOnce(this._blur5Shader, this._blur41FBO.color[0], this._blur50FBO, this._blur51FBO, .5), this._blurOnce(this._blur6Shader, this._blur51FBO.color[0], this._blur60FBO, this._blur51FBO, .5));
    }
    _blurOnce(e, t, n, r, o, a) {
        const s = Math.ceil(o * t.width), c = Math.ceil(o * t.height);
        n.width === s && n.height === c || n.resize(s, c), r.width === s && r.height === c || r.resize(s, c);
        const l = this._blurUniforms;
        l.luminThreshold = a, l.TextureBlurInput = t, l.inputRGBM = +this._inputRGBM, (0, $6BoVD).set(l.blurDir, 0, 1), (0, $6BoVD).set(l.outputSize, n.width, n.height), this._renderer.render(e, l, null, n), l.luminThreshold = 0, l.inputRGBM = 1, (0, $6BoVD).set(l.blurDir, 1, 0), l.TextureBlurInput = n.color[0], this._renderer.render(e, l, null, r);
    }
    dispose() {
        this._blur0Shader && (this._blur0Shader.dispose(), delete this._blur0Shader, this._blur1Shader.dispose(), this._blur2Shader.dispose(), this._blur3Shader.dispose(), this._blur4Shader.dispose(), this._blur5Shader && (this._blur5Shader.dispose(), this._blur6Shader.dispose(), delete this._blur5Shader)), this._blur00Tex && (delete this._blur00Tex, this._blur00FBO.destroy(), this._blur01FBO.destroy(), this._blur10FBO.destroy(), this._blur11FBO.destroy(), this._blur20FBO.destroy(), this._blur21FBO.destroy(), this._blur30FBO.destroy(), this._blur31FBO.destroy(), this._blur40FBO.destroy(), this._blur41FBO.destroy(), this._blur50FBO && (this._blur50FBO.destroy(), this._blur51FBO.destroy(), this._blur60FBO.destroy(), this._blur61FBO.destroy()));
    }
    _createTextures(e) {
        if (this._blur00Tex) return;
        let t = e.width, n = e.height;
        this._blur00Tex = this._createColorTex(e, t, n), this._blur00FBO = this._createBlurFBO(this._blur00Tex), this._blur01Tex = this._createColorTex(e), this._blur01FBO = this._createBlurFBO(this._blur01Tex), t = Math.ceil(t / 2), n = Math.ceil(n / 2), this._blur10Tex = this._createColorTex(e, t, n), this._blur10FBO = this._createBlurFBO(this._blur10Tex), this._blur11Tex = this._createColorTex(e, t, n), this._blur11FBO = this._createBlurFBO(this._blur11Tex), t = Math.ceil(t / 2), n = Math.ceil(n / 2), this._blur20Tex = this._createColorTex(e, t, n), this._blur20FBO = this._createBlurFBO(this._blur20Tex), this._blur21Tex = this._createColorTex(e, t, n), this._blur21FBO = this._createBlurFBO(this._blur21Tex), t = Math.ceil(t / 2), n = Math.ceil(n / 2), this._blur30Tex = this._createColorTex(e, t, n), this._blur30FBO = this._createBlurFBO(this._blur30Tex), this._blur31Tex = this._createColorTex(e, t, n), this._blur31FBO = this._createBlurFBO(this._blur31Tex), t = Math.ceil(t / 2), n = Math.ceil(n / 2), this._blur40Tex = this._createColorTex(e, t, n), this._blur40FBO = this._createBlurFBO(this._blur40Tex), this._blur41Tex = this._createColorTex(e, t, n), this._blur41FBO = this._createBlurFBO(this._blur41Tex), this._level > 5 && (t = Math.ceil(t / 2), n = Math.ceil(n / 2), this._blur50Tex = this._createColorTex(e, t, n), this._blur50FBO = this._createBlurFBO(this._blur50Tex), this._blur51Tex = this._createColorTex(e, t, n), this._blur51FBO = this._createBlurFBO(this._blur51Tex), t = Math.ceil(t / 2), n = Math.ceil(n / 2), this._blur60Tex = this._createColorTex(e, t, n), this._blur60FBO = this._createBlurFBO(this._blur60Tex), this._blur61Tex = this._createColorTex(e, t, n), this._blur61FBO = this._createBlurFBO(this._blur61Tex));
    }
    _createColorTex(e, t, n) {
        return this._regl.texture({
            min: "linear",
            mag: "linear",
            type: "uint8",
            width: t || e.width,
            height: n || e.height
        });
    }
    _createBlurFBO(e) {
        return this._regl.framebuffer({
            width: e.width,
            height: e.height,
            colors: [
                e
            ],
            depth: !1,
            stencil: !1
        });
    }
    _initShaders() {
        if (!this._blur0Shader) {
            const e = {
                vert: $1d56c6a18dbfd30f$var$Mt,
                extraCommandProps: {
                    viewport: {
                        x: 0,
                        y: 0,
                        width: (e, t)=>t.outputSize[0],
                        height: (e, t)=>t.outputSize[1]
                    }
                },
                frag: "#version 100\nprecision highp float;\nuniform float rgbmRange;\nuniform sampler2D TextureBlurInput;\nuniform sampler2D TextureInput;\nuniform vec2 blurDir;\nuniform vec2 pixelRatio;\nuniform vec2 outputSize;\nuniform float inputRGBM;\nuniform float luminThreshold;\n#define SHADER_NAME GAUSSIAN_BLUR0\nconst vec3 c = vec3(.2126, .7152, .0722);\nfloat d(const in vec3 e) {\n  return dot(e, c);\n}\nvec4 f(vec4 e) {\n  float h = max(sign(d(e.rgb) - luminThreshold), .0);\n  return e * h;\n}\nvec2 i;\nvec4 j(const in vec3 e, const in float k) {\n  vec4 l;\n  vec3 m = e / k;\n  l.a = clamp(max(max(m.r, m.g), max(m.b, 1e-6)), .0, 1.);\n  l.a = ceil(l.a * 255.) / 255.;\n  l.rgb = m / l.a;\n  return l;\n}\nvec3 n(const in vec4 e, const in float k) {\n  if(inputRGBM == .0)\n    return e.rgb;\n  return k * e.rgb * e.a;\n}\nvec4 o() {\n  vec3 u = .375 * (f(vec4(n(texture2D(TextureBlurInput, i.xy), rgbmRange), 1.))).rgb;\n  vec2 v;\n  vec2 A = pixelRatio.xy * blurDir.xy / outputSize.xy;\n  v = A * 1.2;\n  u += .3125 * (f(vec4(n(texture2D(TextureBlurInput, i.xy + v.xy), rgbmRange), 1.))).rgb;\n  u += .3125 * (f(vec4(n(texture2D(TextureBlurInput, i.xy - v.xy), rgbmRange), 1.))).rgb;\n  return vec4(u, 1.);\n}\nvoid main(void) {\n  i = gl_FragCoord.xy / outputSize.xy;\n  vec4 e = o();\n  e = j(e.rgb, rgbmRange);\n  gl_FragColor = e;\n}"
            };
            this._blur0Shader = new $1d56c6a18dbfd30f$export$e82c04eda9e9b75c(e), e.frag = "#version 100\nprecision highp float;\nuniform float rgbmRange;\nuniform sampler2D TextureBlurInput;\nuniform sampler2D TextureInput;\nuniform vec2 blurDir;\nuniform vec2 pixelRatio;\nuniform vec2 outputSize;\n#define SHADER_NAME GAUSSIAN_BLUR1\nvec2 c;\nvec4 d(const in vec3 e, const in float f) {\n  if(f <= .0)\n    return vec4(e, 1.);\n  vec4 h;\n  vec3 i = e / f;\n  h.a = clamp(max(max(i.r, i.g), max(i.b, 1e-6)), .0, 1.);\n  h.a = ceil(h.a * 255.) / 255.;\n  h.rgb = i / h.a;\n  return h;\n}\nvec3 j(const in vec4 e, const in float f) {\n  if(f <= .0)\n    return e.rgb;\n  return f * e.rgb * e.a;\n}\nvec4 k() {\n  vec3 l = .3125 * (vec4(j(texture2D(TextureBlurInput, c.xy), rgbmRange), 1.)).rgb;\n  vec2 m;\n  vec2 n = pixelRatio.xy * blurDir.xy / outputSize.xy;\n  m = n * 1.2857142857142858;\n  l += .328125 * (vec4(j(texture2D(TextureBlurInput, c.xy + m.xy), rgbmRange), 1.)).rgb;\n  l += .328125 * (vec4(j(texture2D(TextureBlurInput, c.xy - m.xy), rgbmRange), 1.)).rgb;\n  return vec4(l, 1.);\n}\nvoid main(void) {\n  c = gl_FragCoord.xy / outputSize.xy;\n  vec4 e = k();\n  e = d(e.rgb, rgbmRange);\n  gl_FragColor = e;\n}", this._blur1Shader = new $1d56c6a18dbfd30f$export$e82c04eda9e9b75c(e), e.frag = "#version 100\nprecision highp float;\nuniform float rgbmRange;\nuniform sampler2D TextureBlurInput;\nuniform sampler2D TextureInput;\nuniform vec2 blurDir;\nuniform vec2 pixelRatio;\nuniform vec2 outputSize;\n#define SHADER_NAME GAUSSIAN_BLUR2\nvec2 c;\nvec4 d(const in vec3 e, const in float f) {\n  if(f <= .0)\n    return vec4(e, 1.);\n  vec4 h;\n  vec3 i = e / f;\n  h.a = clamp(max(max(i.r, i.g), max(i.b, 1e-6)), .0, 1.);\n  h.a = ceil(h.a * 255.) / 255.;\n  h.rgb = i / h.a;\n  return h;\n}\nvec3 j(const in vec4 e, const in float f) {\n  if(f <= .0)\n    return e.rgb;\n  return f * e.rgb * e.a;\n}\nvec4 k() {\n  vec3 l = .2734375 * (vec4(j(texture2D(TextureBlurInput, c.xy), rgbmRange), 1.)).rgb;\n  vec2 m;\n  vec2 n = pixelRatio.xy * blurDir.xy / outputSize.xy;\n  m = n * 1.3333333333333333;\n  l += .328125 * (vec4(j(texture2D(TextureBlurInput, c.xy + m.xy), rgbmRange), 1.)).rgb;\n  l += .328125 * (vec4(j(texture2D(TextureBlurInput, c.xy - m.xy), rgbmRange), 1.)).rgb;\n  m = n * 3.111111111111111;\n  l += .03515625 * (vec4(j(texture2D(TextureBlurInput, c.xy + m.xy), rgbmRange), 1.)).rgb;\n  l += .03515625 * (vec4(j(texture2D(TextureBlurInput, c.xy - m.xy), rgbmRange), 1.)).rgb;\n  return vec4(l, 1.);\n}\nvoid main(void) {\n  c = gl_FragCoord.xy / outputSize.xy;\n  vec4 e = k();\n  e = d(e.rgb, rgbmRange);\n  gl_FragColor = e;\n}", this._blur2Shader = new $1d56c6a18dbfd30f$export$e82c04eda9e9b75c(e), e.frag = "#version 100\nprecision highp float;\nuniform float rgbmRange;\nuniform sampler2D TextureBlurInput;\nuniform sampler2D TextureInput;\nuniform vec2 blurDir;\nuniform vec2 pixelRatio;\nuniform vec2 outputSize;\n#define SHADER_NAME GAUSSIAN_BLUR3\nvec2 c;\nvec4 d(const in vec3 e, const in float f) {\n  if(f <= .0)\n    return vec4(e, 1.);\n  vec4 h;\n  vec3 i = e / f;\n  h.a = clamp(max(max(i.r, i.g), max(i.b, 1e-6)), .0, 1.);\n  h.a = ceil(h.a * 255.) / 255.;\n  h.rgb = i / h.a;\n  return h;\n}\nvec3 j(const in vec4 e, const in float f) {\n  if(f <= .0)\n    return e.rgb;\n  return f * e.rgb * e.a;\n}\nvec4 k() {\n  vec3 l = .24609375 * (vec4(j(texture2D(TextureBlurInput, c.xy), rgbmRange), 1.)).rgb;\n  vec2 m;\n  vec2 n = pixelRatio.xy * blurDir.xy / outputSize.xy;\n  m = n * 1.3636363636363635;\n  l += .322265625 * (vec4(j(texture2D(TextureBlurInput, c.xy + m.xy), rgbmRange), 1.)).rgb;\n  l += .322265625 * (vec4(j(texture2D(TextureBlurInput, c.xy - m.xy), rgbmRange), 1.)).rgb;\n  m = n * 3.1818181818181817;\n  l += .0537109375 * (vec4(j(texture2D(TextureBlurInput, c.xy + m.xy), rgbmRange), 1.)).rgb;\n  l += .0537109375 * (vec4(j(texture2D(TextureBlurInput, c.xy - m.xy), rgbmRange), 1.)).rgb;\n  return vec4(l, 1.);\n}\nvoid main(void) {\n  c = gl_FragCoord.xy / outputSize.xy;\n  vec4 e = k();\n  e = d(e.rgb, rgbmRange);\n  gl_FragColor = e;\n}", this._blur3Shader = new $1d56c6a18dbfd30f$export$e82c04eda9e9b75c(e), e.frag = "#version 100\nprecision highp float;\nuniform float rgbmRange;\nuniform sampler2D TextureBlurInput;\nuniform sampler2D TextureInput;\nuniform vec2 blurDir;\nuniform vec2 pixelRatio;\nuniform vec2 outputSize;\n#define SHADER_NAME GAUSSIAN_BLUR4\nvec2 c;\nvec4 d(const in vec3 e, const in float f) {\n  if(f <= .0)\n    return vec4(e, 1.);\n  vec4 h;\n  vec3 i = e / f;\n  h.a = clamp(max(max(i.r, i.g), max(i.b, 1e-6)), .0, 1.);\n  h.a = ceil(h.a * 255.) / 255.;\n  h.rgb = i / h.a;\n  return h;\n}\nvec3 j(const in vec4 e, const in float f) {\n  if(f <= .0)\n    return e.rgb;\n  return f * e.rgb * e.a;\n}\nvec4 k() {\n  vec3 l = .2255859375 * (vec4(j(texture2D(TextureBlurInput, c.xy), rgbmRange), 1.)).rgb;\n  vec2 m;\n  vec2 n = pixelRatio.xy * blurDir.xy / outputSize.xy;\n  m = n * 1.3846153846153846;\n  l += .314208984375 * (vec4(j(texture2D(TextureBlurInput, c.xy + m.xy), rgbmRange), 1.)).rgb;\n  l += .314208984375 * (vec4(j(texture2D(TextureBlurInput, c.xy - m.xy), rgbmRange), 1.)).rgb;\n  m = n * 3.230769230769231;\n  l += .06982421875 * (vec4(j(texture2D(TextureBlurInput, c.xy + m.xy), rgbmRange), 1.)).rgb;\n  l += .06982421875 * (vec4(j(texture2D(TextureBlurInput, c.xy - m.xy), rgbmRange), 1.)).rgb;\n  m = n * 5.076923076923077;\n  l += .003173828125 * (vec4(j(texture2D(TextureBlurInput, c.xy + m.xy), rgbmRange), 1.)).rgb;\n  l += .003173828125 * (vec4(j(texture2D(TextureBlurInput, c.xy - m.xy), rgbmRange), 1.)).rgb;\n  return vec4(l, 1.);\n}\nvoid main(void) {\n  c = gl_FragCoord.xy / outputSize.xy;\n  vec4 e = k();\n  e = d(e.rgb, rgbmRange);\n  gl_FragColor = e;\n}", this._blur4Shader = new $1d56c6a18dbfd30f$export$e82c04eda9e9b75c(e), this._level > 5 && (e.frag = "precision highp float;\nuniform float rgbmRange;\nuniform sampler2D TextureBlurInput;\nuniform sampler2D TextureInput;\nuniform vec2 blurDir;\nuniform vec2 outSize;\nuniform vec2 pixelRatio;\nuniform vec2 outputSize;\n#define SHADER_NAME GAUSSIAN_BLUR5\nvec2 c;\nvec4 d(const in vec3 e, const in float f) {\n  if(f <= .0)\n    return vec4(e, 1.);\n  vec4 h;\n  vec3 i = e / f;\n  h.a = clamp(max(max(i.r, i.g), max(i.b, 1e-6)), .0, 1.);\n  h.a = ceil(h.a * 255.) / 255.;\n  h.rgb = i / h.a;\n  return h;\n}\nvec3 j(const in vec4 e, const in float f) {\n  if(f <= .0)\n    return e.rgb;\n  return f * e.rgb * e.a;\n}\nvec4 k() {\n  vec3 l = .20947265625 * (vec4(j(texture2D(TextureBlurInput, c.xy), rgbmRange), 1.)).rgb;\n  vec2 m;\n  vec2 n = pixelRatio.xy * blurDir.xy / outputSize.xy;\n  n *= outSize.y * .00075;\n  m = n * 1.4;\n  l += .30548095703125 * (vec4(j(texture2D(TextureBlurInput, c.xy + m.xy), rgbmRange), 1.)).rgb;\n  l += .30548095703125 * (vec4(j(texture2D(TextureBlurInput, c.xy - m.xy), rgbmRange), 1.)).rgb;\n  m = n * 3.2666666666666666;\n  l += .08331298828125 * (vec4(j(texture2D(TextureBlurInput, c.xy + m.xy), rgbmRange), 1.)).rgb;\n  l += .08331298828125 * (vec4(j(texture2D(TextureBlurInput, c.xy - m.xy), rgbmRange), 1.)).rgb;\n  m = n * 5.133333333333334;\n  l += .00640869140625 * (vec4(j(texture2D(TextureBlurInput, c.xy + m.xy), rgbmRange), 1.)).rgb;\n  l += .00640869140625 * (vec4(j(texture2D(TextureBlurInput, c.xy - m.xy), rgbmRange), 1.)).rgb;\n  return vec4(l, 1.);\n}\nvoid main(void) {\n  c = gl_FragCoord.xy / outputSize.xy;\n  vec4 e = k();\n  e = d(e.rgb, rgbmRange);\n  gl_FragColor = e;\n}", this._blur5Shader = new $1d56c6a18dbfd30f$export$e82c04eda9e9b75c(e), e.frag = "#version 100\nprecision highp float;\nuniform float rgbmRange;\nuniform sampler2D TextureBlurInput;\nuniform sampler2D TextureInput;\nuniform vec2 blurDir;\nuniform vec2 outSize;\nuniform vec2 pixelRatio;\nuniform vec2 outputSize;\n#define SHADER_NAME GAUSSIAN_BLUR6\nvec2 c;\nvec4 d(const in vec3 e, const in float f) {\n  if(f <= .0)\n    return vec4(e, 1.);\n  vec4 h;\n  vec3 i = e / f;\n  h.a = clamp(max(max(i.r, i.g), max(i.b, 1e-6)), .0, 1.);\n  h.a = ceil(h.a * 255.) / 255.;\n  h.rgb = i / h.a;\n  return h;\n}\nvec3 j(const in vec4 e, const in float f) {\n  if(f <= .0)\n    return e.rgb;\n  return f * e.rgb * e.a;\n}\nvec4 k() {\n  vec3 l = .196380615234375 * (vec4(j(texture2D(TextureBlurInput, c.xy), rgbmRange), 1.)).rgb;\n  vec2 m;\n  vec2 n = pixelRatio.xy * blurDir.xy / outputSize.xy;\n  n *= outSize.y * .00075;\n  m = n * 1.411764705882353;\n  l += .2967529296875 * (vec4(j(texture2D(TextureBlurInput, c.xy + m.xy), rgbmRange), 1.)).rgb;\n  l += .2967529296875 * (vec4(j(texture2D(TextureBlurInput, c.xy - m.xy), rgbmRange), 1.)).rgb;\n  m = n * 3.2941176470588234;\n  l += .09442138671875 * (vec4(j(texture2D(TextureBlurInput, c.xy + m.xy), rgbmRange), 1.)).rgb;\n  l += .09442138671875 * (vec4(j(texture2D(TextureBlurInput, c.xy - m.xy), rgbmRange), 1.)).rgb;\n  m = n * 5.176470588235294;\n  l += .0103759765625 * (vec4(j(texture2D(TextureBlurInput, c.xy + m.xy), rgbmRange), 1.)).rgb;\n  l += .0103759765625 * (vec4(j(texture2D(TextureBlurInput, c.xy - m.xy), rgbmRange), 1.)).rgb;\n  return vec4(l, 1.);\n}\nvoid main(void) {\n  c = gl_FragCoord.xy / outputSize.xy;\n  vec4 e = k();\n  e = d(e.rgb, rgbmRange);\n  gl_FragColor = e;\n}", this._blur6Shader = new $1d56c6a18dbfd30f$export$e82c04eda9e9b75c(e));
        }
    }
}
class $1d56c6a18dbfd30f$export$54ba5aace06c25b9 {
    constructor(e){
        this._regl = e, this._renderer = new $1d56c6a18dbfd30f$export$88530751e3977073(e);
    }
    render(e, t, n, r, i, o, a, s, c) {
        this._initShaders(), this._createTextures(e);
        const l = this._blurPass.render(t, n);
        return this._combine(e, l, t, r, i, o, a, s, c);
    }
    _combine(e, t, n, r, o, a, s, c, l) {
        l || this._combineTex.width === e.width && this._combineTex.height === e.height || this._combineFBO.resize(e.width, e.height);
        let f = this._combineUniforms;
        const { blurTex0: d, blurTex1: u, blurTex2: h, blurTex3: m, blurTex4: v } = t;
        f || (f = this._combineUniforms = {
            bloomFactor: 0,
            bloomRadius: 0,
            rgbmRange: 7,
            TextureBloomBlur1: d,
            TextureBloomBlur2: u,
            TextureBloomBlur3: h,
            TextureBloomBlur4: m,
            TextureBloomBlur5: v,
            TextureInput: null,
            TextureSource: null,
            outputSize: [
                0,
                0
            ]
        }), f.noAaTextureSource = a, f.pointTextureSource = s, f.enableAA = c, f.bloomFactor = r, f.bloomRadius = o, f.TextureInput = n, f.TextureSource = e, (0, $6BoVD).set(f.outputSize, e.width, e.height);
        const _ = {};
        return a ? _.HAS_NOAA_TEX = 1 : delete _.HAS_NOAA_TEX, s ? _.HAS_POINT_TEX = 1 : delete _.HAS_POINT_TEX, this._combineShader.setDefines(_), this._renderer.render(this._combineShader, f, null, l ? null : this._combineFBO), l ? null : this._combineTex;
    }
    dispose() {
        this._combineFBO && (this._combineFBO.destroy(), delete this._combineFBO), this._blurPass && (this._blurPass.dispose(), delete this._blurPass), delete this._uniforms;
    }
    _createTextures(e) {
        if (this._combineTex) return;
        this._combineTex = this._createColorTex(e, e.width, e.height, "uint8"), this._combineFBO = this._createBlurFBO(this._combineTex);
    }
    _createColorTex(e, t, n, r) {
        return this._renderer.regl.texture({
            min: "linear",
            mag: "linear",
            type: r,
            width: t || e.width,
            height: n || e.height
        });
    }
    _createBlurFBO(e) {
        return this._renderer.regl.framebuffer({
            width: e.width,
            height: e.height,
            colors: [
                e
            ],
            depth: !1,
            stencil: !1
        });
    }
    _initShaders() {
        if (!this._combineShader) {
            const e = {
                x: 0,
                y: 0,
                width: (e, t)=>t.outputSize[0],
                height: (e, t)=>t.outputSize[1]
            };
            this._blurPass = new $1d56c6a18dbfd30f$var$Nt(this._regl, !1), this._combineShader = new $1d56c6a18dbfd30f$export$e82c04eda9e9b75c({
                vert: $1d56c6a18dbfd30f$var$Mt,
                frag: "precision highp float;\nuniform float bloomFactor;\nuniform float bloomRadius;\nuniform float rgbmRange;\nuniform sampler2D TextureBloomBlur1;\nuniform sampler2D TextureBloomBlur2;\nuniform sampler2D TextureBloomBlur3;\nuniform sampler2D TextureBloomBlur4;\nuniform sampler2D TextureBloomBlur5;\nuniform sampler2D TextureInput;\nuniform sampler2D TextureSource;\n#ifdef HAS_NOAA_TEX\nuniform sampler2D noAaTextureSource;\n#endif\n#ifdef HAS_POINT_TEX\nuniform sampler2D pointTextureSource;\n#endif\nuniform float enableAA;\nuniform vec2 outputSize;\n#define SHADER_NAME bloomCombine\nvec2 c;\n#include <srgb_frag>\nvec3 d(const in vec4 e, const in float f) {\n  if(f <= .0)\n    return e.rgb;\n  return f * e.rgb * e.a;\n}\nfloat h(const float i, const float j) {\n  return mix(i, j * 2. - i, bloomRadius);\n}\nvec4 k() {\n  vec3 l = vec3(.0);\n  const float m = .6;\n  const float n = 1.1;\n  const float o = .9;\n  const float u = .6;\n  const float v = .3;\n  const float A = .1;\n  l += (vec4(d(texture2D(TextureBloomBlur1, c), rgbmRange), 1.)).rgb * h(n, m);\n  l += (vec4(d(texture2D(TextureBloomBlur2, c), rgbmRange), 1.)).rgb * h(o, m);\n  l += (vec4(d(texture2D(TextureBloomBlur3, c), rgbmRange), 1.)).rgb * h(u, m);\n  l += (vec4(d(texture2D(TextureBloomBlur4, c), rgbmRange), 1.)).rgb * h(v, m);\n  l += (vec4(d(texture2D(TextureBloomBlur5, c), rgbmRange), 1.)).rgb * h(A, m);\n  vec4 B;\n  if(enableAA == 1.) {\n    \n  } else {\n    B = texture2D(TextureInput, c);\n  }\n  B.rgb = mix(vec3(.0), B.rgb, sign(B.a));\n  vec4 C = texture2D(TextureSource, c);\n#ifdef HAS_NOAA_TEX\nvec4 D = texture2D(noAaTextureSource, c);\n  C = D + C * (1. - D.a);\n#endif\nvec4 E = vec4(.0);\n#ifdef HAS_POINT_TEX\nE = texture2D(pointTextureSource, c);\n#endif\nfloat F = sqrt((l.r + l.g + l.b) / 3.);\n  vec4 G = vec4(linearTosRGB(l * bloomFactor), F);\n  return E + (B + C * (1. - B.a)) * (1. - E.a) + G;\n}\nvoid main(void) {\n  c = gl_FragCoord.xy / outputSize.xy;\n  vec4 e = k();\n  gl_FragColor = e;\n}",
                extraCommandProps: {
                    viewport: e
                }
            });
        }
    }
}
class $1d56c6a18dbfd30f$var$kt extends $1d56c6a18dbfd30f$export$e82c04eda9e9b75c {
    constructor(){
        const e = [];
        super({
            vert: $1d56c6a18dbfd30f$var$Mt,
            frag: "precision highp float;\n#include <gl2_frag>\n#define SHADER_NAME COPY_DEPTH\nuniform sampler2D TextureDepth;\nuniform vec2 textureSize;\n#include <common_pack_float>\nvoid main(void) {\n  vec2 c = gl_FragCoord.xy / textureSize.xy;\n  float d = texture2D(TextureDepth, c).r;\n  glFragColor = common_encodeDepth(d);\n#if __VERSION__ == 100\ngl_FragColor = glFragColor;\n#endif\n}",
            uniforms: [
                {
                    name: "textureSize",
                    type: "function",
                    fn: (t, n)=>(e[0] = n.TextureDepth.width, e[1] = n.TextureDepth.height, e)
                }
            ],
            extraCommandProps: {
                viewport: {
                    x: 0,
                    y: 0,
                    width: (e, t)=>t.TextureDepth.width,
                    height: (e, t)=>t.TextureDepth.height
                }
            }
        }), this.version = 300;
    }
    getMeshCommand(e, t) {
        return this.commands.copy_depth || (this.commands.copy_depth = this.createREGLCommand(e, null, t.getElements())), this.commands.copy_depth;
    }
}
class $1d56c6a18dbfd30f$export$f7c71c3adb539dd3 {
    static getUniformDeclares() {
        const t = [
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ]
        ], r = new Array(16);
        return [
            {
                name: "invProjMatrix",
                type: "function",
                fn: (t, n)=>(0, $3iqbd).invert(r, n.projMatrix)
            },
            {
                name: "outputFovInfo",
                type: "array",
                length: 2,
                fn: function(e, r) {
                    const i = Math.tan(.5 * r.fov), o = r.outSize[0] / r.outSize[1] * i;
                    return (0, $jxhwV).set(t[0], o, i, o, -i), (0, $jxhwV).set(t[1], -o, i, -o, -i), t;
                }
            },
            {
                name: "reprojViewProjMatrix",
                type: "function",
                fn: (t, n)=>(0, $3iqbd).multiply([], n.prevProjViewMatrix, n.cameraWorldMatrix)
            }
        ];
    }
    static getDefines() {
        return {
            HAS_SSR: 1
        };
    }
    constructor(e){
        this._regl = e, this._renderer = new $1d56c6a18dbfd30f$export$88530751e3977073(e), this._inputRGBM = 0;
    }
    setup(e) {
        this._initShaders(), this._createTextures(e);
    }
    getSSRUniforms(e, t, n) {
        if (!this._depthCopy) return null;
        const r = this._depthCopy;
        return {
            TextureDepth: r,
            TextureReflected: this.getMipmapTexture(),
            ssrFactor: t || 1,
            ssrQuality: n || 2,
            outSize: [
                r.width,
                r.height
            ],
            fov: e.getFov() * Math.PI / 180,
            prevProjViewMatrix: this._projViewMatrix || e.projViewMatrix,
            cameraWorldMatrix: e.cameraWorldMatrix
        };
    }
    genMipMap(t, n, r) {
        return this.setup(t), this._mipmap(t), this.copyDepthTex(n), this._projViewMatrix || (this._projViewMatrix = []), (0, $3iqbd).copy(this._projViewMatrix, r), delete this._depthCopied, this._outputTex;
    }
    getPrevProjViewMatrix() {
        return this._projViewMatrix;
    }
    copyDepthTex(e) {
        if (this._depthCopied) return null;
        if (this.setup(e), this._depthCopy) e.width === this._depthCopy.width && e.height === this._depthCopy.height || this._depthCopyFBO.resize(e.width, e.height);
        else {
            this._depthCopy = this._regl.texture({
                min: "nearest",
                mag: "nearest",
                mipmap: !1,
                type: "uint8",
                width: e.width,
                height: e.height
            });
            this._depthCopyFBO = this._regl.framebuffer({
                width: e.width,
                height: e.height,
                colors: [
                    this._depthCopy
                ],
                colorFormat: "rgba"
            });
        }
        return this._renderer.render(this._copyDepthShader, {
            TextureDepth: e
        }, null, this._depthCopyFBO), this._depthCopied = !0, this._depthCopy;
    }
    _mipmap(e) {
        const t = this._targetFBO, n = Math.ceil(.5 * e.width), r = Math.ceil(.5 * e.height);
        t.width === n && t.height === r || t.resize(n, r);
        let o = this._blurUniforms;
        o || (o = this._blurUniforms = {
            rgbmRange: 7,
            outputSize: [
                0,
                0
            ]
        }), o.TextureInput = e, o.inputRGBM = +this._inputRGBM, (0, $6BoVD).set(o.outputSize, t.width, t.height), this._renderer.render(this._ssrQuadShader, o, null, t);
    }
    getMipmapTexture() {
        return this._outputTex || (this._outputTex = this._renderer.regl.texture({
            type: "uint8",
            width: 2,
            height: 2
        })), this._outputTex;
    }
    dispose() {
        this._copyDepthShader && (this._ssrQuadShader.dispose(), this._copyDepthShader.dispose(), this._targetFBO.destroy(), delete this._copyDepthShader), this._depthCopy && (this._depthCopyFBO.destroy(), delete this._depthCopy, delete this._depthCopyFBO);
    }
    _initShaders() {
        if (!this._copyDepthShader) {
            this._copyDepthShader = new $1d56c6a18dbfd30f$var$kt;
            this._ssrQuadShader = new $1d56c6a18dbfd30f$export$e82c04eda9e9b75c({
                vert: $1d56c6a18dbfd30f$var$Mt,
                frag: "#version 100\nprecision mediump float;\nuniform sampler2D TextureInput;\nuniform vec2 outputSize;\n#define SHADER_NAME QUAD\nvec2 c;\nvoid main(void) {\n  c = gl_FragCoord.xy / outputSize.xy;\n  vec4 d = texture2D(TextureInput, c.xy);\n  gl_FragColor = d;\n}",
                extraCommandProps: {
                    viewport: {
                        x: 0,
                        y: 0,
                        width: (e, t)=>t.outputSize[0],
                        height: (e, t)=>t.outputSize[1]
                    }
                }
            });
        }
    }
    _createTextures(e) {
        if (!this._targetFBO) {
            const t = this._regl;
            this._outputTex && this._outputTex.destroy(), this._outputTex = t.texture({
                min: "linear",
                mag: "linear",
                type: "uint8",
                width: e.width,
                height: e.height
            }), this._targetFBO = t.framebuffer({
                width: e.width,
                height: e.height,
                colors: [
                    this._outputTex
                ],
                depth: !1,
                stencil: !1
            });
        }
    }
}
class $1d56c6a18dbfd30f$export$32e43688bef63fb9 extends $1d56c6a18dbfd30f$export$9d2cc9f1c4004434 {
    constructor(t){
        const n = [];
        super({
            vert: "#define SHADER_NAME HEATMAP\nuniform mat4 projViewModelMatrix;\nuniform float extrudeScale;\nuniform float heatmapIntensity;\nattribute vec3 aPosition;\nvarying vec2 vExtrude;\n#ifdef HAS_HEAT_WEIGHT\nattribute highp float aWeight;\nvarying highp float weight;\n#else\nuniform highp float heatmapWeight;\n#endif\nuniform mediump float heatmapRadius;\nconst highp float c = 1. / 255. / 16.;\n#define GAUSS_COEF 0.3989422804014327\nvoid main(void) {\n  \n#ifdef HAS_HEAT_WEIGHT\nhighp float d = aWeight / 255.;\n  weight = d;\n#else\nhighp float d = heatmapWeight;\n#endif\nmediump float e = heatmapRadius;\n  vec2 f = vec2(mod(aPosition.xy, 2.) * 2. - 1.);\n  float h = sqrt(-2. * log(c / d / heatmapIntensity / GAUSS_COEF)) / 3.;\n  vExtrude = h * f;\n  vec2 i = vExtrude * e * extrudeScale;\n  vec4 j = vec4(floor(aPosition.xy * .5) + i, aPosition.z, 1);\n  gl_Position = projViewModelMatrix * j;\n}",
            frag: "#define SHADER_NAME HEATMAP\nprecision mediump float;\nuniform highp float heatmapIntensity;\nvarying vec2 vExtrude;\n#ifdef HAS_HEAT_WEIGHT\nvarying highp float weight;\n#else\nuniform highp float heatmapWeight;\n#endif\n#define GAUSS_COEF 0.3989422804014327\nvoid main() {\n  \n#ifdef HAS_HEAT_WEIGHT\nhighp float c = weight;\n#else\nhighp float c = heatmapWeight;\n#endif\nfloat d = -.5 * 3. * 3. * dot(vExtrude, vExtrude);\n  float e = c * heatmapIntensity * GAUSS_COEF * exp(d);\n  gl_FragColor = vec4(e, 1., 1., 1.);\n}",
            uniforms: [
                {
                    name: "extrudeScale",
                    type: "function",
                    fn: function(e, t) {
                        return t.resolution / t.dataResolution * t.tileRatio;
                    }
                },
                {
                    name: "projViewModelMatrix",
                    type: "function",
                    fn: function(t, r) {
                        return (0, $3iqbd).multiply(n, r.projViewMatrix, r.modelMatrix);
                    }
                }
            ],
            extraCommandProps: $1d56c6a18dbfd30f$var$v({}, t && t.extraCommandProps || {}, {
                blend: {
                    enable: !0,
                    func: {
                        src: "one",
                        dst: "one"
                    },
                    equation: "add"
                }
            })
        });
    }
}
var $1d56c6a18dbfd30f$var$Gt = [
    -1,
    1,
    -1,
    -1,
    -1,
    -1,
    1,
    -1,
    -1,
    1,
    -1,
    -1,
    1,
    1,
    -1,
    -1,
    1,
    -1,
    -1,
    -1,
    1,
    -1,
    -1,
    -1,
    -1,
    1,
    -1,
    -1,
    1,
    -1,
    -1,
    1,
    1,
    -1,
    -1,
    1,
    1,
    -1,
    -1,
    1,
    -1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    -1,
    1,
    -1,
    -1,
    -1,
    -1,
    1,
    -1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    -1,
    1,
    -1,
    -1,
    1,
    -1,
    1,
    -1,
    1,
    1,
    -1,
    1,
    1,
    1,
    1,
    1,
    1,
    -1,
    1,
    1,
    -1,
    1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1,
    1,
    -1,
    -1,
    1,
    -1,
    -1,
    -1,
    -1,
    1,
    1,
    -1,
    1
], $1d56c6a18dbfd30f$var$Vt = "#define SHADER_NAME SKYBOX\n#if __VERSION__ == 100\n#ifdef GL_EXT_shader_texture_lod\n#extension GL_EXT_shader_texture_lod : enable\n#define textureCubeLod(tex, uv, lod) textureCubeLodEXT(tex, uv, lod)\n#else\n#define textureCubeLod(tex, uv, lod) textureCube(tex, uv, lod)\n#endif\n#else\n#define textureCubeLod(tex, uv, lod) textureLod(tex, uv, lod)\n#endif\nprecision highp float;\n#define saturate(x)        clamp(x, 0.0, 1.0)\n#include <gl2_frag>\n#include <hsv_frag>\nuniform vec3 hsv;\nvarying vec3 vWorldPos;\n#ifdef USE_AMBIENT\nuniform vec3 diffuseSPH[9];\n#else\nuniform samplerCube cubeMap;\nuniform float bias;\nuniform float size;\n#endif\nuniform float environmentExposure;\nuniform float backgroundIntensity;\nvec4 c(const in samplerCube d, const in vec3 e, const in float f, const in float h) {\n  vec3 i = e;\n  return textureCubeLod(d, i, h);\n}\nvec3 j(const in vec3 k, const in vec3 l[9]) {\n  float x = k.x;\n  float y = k.y;\n  float z = k.z;\n  vec3 m = (l[0] + l[1] * x + l[2] * y + l[3] * z + l[4] * z * x + l[5] * y * z + l[6] * y * x + l[7] * (3. * z * z - 1.) + l[8] * (x * x - y * y));\n  return max(m, vec3(.0));\n}\nfloat n(const in vec2 o) {\n  vec3 u = fract(vec3(o.xyx) * .1031);\n  u += dot(u, u.yzx + 19.19);\n  return fract((u.x + u.y) * u.z);\n}\n#if defined(TONE_MAPPING)\nconst float v = 1.;\nvec3 A(vec3 B) {\n  vec3 a = B * (B + .0245786) - .000090537;\n  vec3 b = B * (.983729 * B + .4329510) + .238081;\n  return a / b;\n}\nvec3 C(vec3 D) {\n  const mat3 E = mat3(vec3(.59719, .07600, .02840), vec3(.35458, .90834, .13383), vec3(.04823, .01566, .83777));\n  const mat3 F = mat3(vec3(1.60475, -.10208, -.00327), vec3(-.53108, 1.10813, -.07276), vec3(-.07367, -.00605, 1.07602));\n  D *= v / .6;\n  D = E * D;\n  D = A(D);\n  D = F * D;\n  return saturate(D);\n}\nvec3 G(vec3 D) {\n  return C(D);\n}\nvec4 H(in vec4 I) {\n  return vec4(mix(pow(I.rgb, vec3(.41666)) * 1.055 - vec3(.055), I.rgb * 12.92, vec3(lessThanEqual(I.rgb, vec3(.0031308)))), I.a);\n}\nvec4 J(vec4 I) {\n  return (H(I));\n}\n#endif\nvoid main() {\n  vec4 K;\n#ifdef USE_AMBIENT\nvec3 k = normalize(vWorldPos + mix(-.5 / 255., .5 / 255., n(gl_FragCoord.xy)) * 2.);\n  K = vec4(j(k, diffuseSPH), 1.);\n#else\nK = c(cubeMap, vWorldPos, size, bias);\n#endif\nK.rgb *= environmentExposure;\n  K.rgb *= backgroundIntensity;\n  glFragColor = K;\n  if(length(hsv) > .0) {\n    glFragColor.rgb = hsv_apply(clamp(glFragColor.rgb, .0, 1.), hsv);\n  }\n#if defined(TONE_MAPPING)\nglFragColor.rgb = G(glFragColor.rgb);\n  glFragColor = J(glFragColor);\n#endif\n#if __VERSION__ == 100\ngl_FragColor = glFragColor;\n#endif\n}";
class $1d56c6a18dbfd30f$export$881c590fefe5ccac extends $1d56c6a18dbfd30f$export$9d2cc9f1c4004434 {
    constructor(){
        super({
            vert: "#include <gl2_vert>\nattribute vec3 aPosition;\nuniform mat4 projMatrix;\nuniform mat4 viewMatrix;\nuniform mat3 transformMatrix;\nvarying vec3 vWorldPos;\nvoid main() {\n  vWorldPos = aPosition;\n  mat4 c = mat4(mat3(viewMatrix) * transformMatrix);\n  vec4 d = projMatrix * c * vec4(vWorldPos, 1.);\n  gl_Position = d.xyww;\n}",
            frag: $1d56c6a18dbfd30f$var$Vt,
            extraCommandProps: {
                depth: {
                    enable: !0,
                    range: [
                        1,
                        1
                    ],
                    func: "lequal"
                },
                viewport: {
                    x: 0,
                    y: 0,
                    width: (e, t)=>t.resolution[0],
                    height: (e, t)=>t.resolution[1]
                }
            }
        }), this.version = 300;
    }
    setMode(e, t) {
        const n = {};
        return e && (n.TONE_MAPPING = 1), 0 === t && (n.USE_AMBIENT = 1), this._skyboxMesh ? this._skyboxMesh[0].setDefines(n) : this._meshDefines = n, this;
    }
    draw(e) {
        return this._skyboxMesh || this._createSkyboxMesh(e), super.draw(e, this._skyboxMesh);
    }
    _createSkyboxMesh(e) {
        const t = new $1d56c6a18dbfd30f$export$2db6c17465f94a2({
            aPosition: new Int8Array($1d56c6a18dbfd30f$var$Gt)
        }, null, $1d56c6a18dbfd30f$var$Gt.length / 3);
        t.generateBuffers(e), this._skyboxMesh = [
            new $1d56c6a18dbfd30f$export$e176487c05830cc5(t)
        ], this._meshDefines && (this._skyboxMesh[0].setDefines(this._meshDefines), delete this._meshDefines);
    }
    dispose() {
        if (this._skyboxMesh) {
            const e = this._skyboxMesh[0];
            e.geometry.dispose(), e.dispose();
        }
        return delete this._skyboxMesh, super.dispose();
    }
}
class $1d56c6a18dbfd30f$export$8d4ce79d3f8ec4dd extends $1d56c6a18dbfd30f$export$9d2cc9f1c4004434 {
    constructor(t, n){
        const r = {
            blend: {
                enable: !0,
                func: {
                    src: "one",
                    dst: "one minus src alpha"
                },
                equation: "add"
            },
            viewport: t
        };
        n && n.extraCommandProps && $1d56c6a18dbfd30f$var$v(r, n.extraCommandProps);
        const i = [];
        super({
            vert: "#define SHADER_NAME HEATMAP_DISPLAY\nuniform mat4 projViewModelMatrix;\nattribute vec3 aPosition;\nvoid main() {\n  gl_Position = projViewModelMatrix * vec4(aPosition, 1.);\n}",
            frag: "#define SHADER_NAME HEATMAP_DISPLAY\nprecision mediump float;\nuniform sampler2D inputTexture;\nuniform sampler2D colorRamp;\nuniform vec2 textureOutputSize;\nuniform float heatmapOpacity;\nvoid main() {\n  vec2 c = gl_FragCoord.xy / textureOutputSize.xy;\n  float t = texture2D(inputTexture, c).r;\n  vec4 d = texture2D(colorRamp, vec2(t, .5));\n  gl_FragColor = d * heatmapOpacity;\n}",
            uniforms: [
                {
                    name: "projViewModelMatrix",
                    type: "function",
                    fn: function(t, n) {
                        return (0, $3iqbd).multiply(i, n.projViewMatrix, n.modelMatrix);
                    }
                }
            ],
            extraCommandProps: r
        });
    }
}
class $1d56c6a18dbfd30f$export$8d6952a07fa5a2a3 extends $1d56c6a18dbfd30f$export$9d2cc9f1c4004434 {
    constructor(e = {}){
        super({
            vert: "precision highp float;\nprecision highp sampler2D;\nconst float c = 3.141592653589793;\nuniform mat4 projMatrix;\nuniform mat4 viewMatrix;\nuniform mat4 modelMatrix;\nattribute vec3 aPosition;\nattribute vec2 aTexCoord;\nattribute vec3 aNormal;\nvarying vec2 vuv;\nvarying vec3 vpos;\nvarying vec3 vnormal;\nvarying mat3 vtbnMatrix;\nvec4 d(mat4 e, mat4 f, vec3 h) {\n  return e * modelMatrix * f * vec4(h, 1.);\n}\nvec3 i(in vec3 h, in vec3 j) {\n  return normalize(h + j);\n}\nmat3 k(in vec3 l) {\n  vec3 t = normalize(cross(vec3(.0, .0, 1.), l));\n  vec3 b = normalize(cross(l, t));\n  return mat3(t, b, l);\n}\nvoid m() {\n  \n}\nvoid main(void) {\n  vuv = aTexCoord;\n  vpos = (modelMatrix * vec4(aPosition, 1.)).xyz;\n  vnormal = aNormal;\n  vtbnMatrix = k(vnormal);\n  gl_Position = d(projMatrix, viewMatrix, vpos);\n  m();\n}",
            frag: "precision highp float;\nprecision highp sampler2D;\nuniform sampler2D texWaveNormal;\nuniform sampler2D texWavePerturbation;\nuniform vec3 octaveTextureRepeat;\nuniform vec4 waveParams;\nuniform vec2 waveDirection;\nuniform vec4 waterColor;\nuniform vec3 lightingDirection;\nuniform vec3 lightingIntensity;\nuniform vec3 camPos;\nuniform float timeElapsed;\nvarying vec2 vuv;\nvarying vec3 vpos;\nvarying vec3 vnormal;\nvarying mat3 vtbnMatrix;\nconst vec2 c = vec2(6. / 25., 5. / 24.);\nvec2 d(sampler2D e, vec2 f) {\n  return 2. * texture2D(e, f).rg - 1.;\n}\nfloat h(vec2 f) {\n  return texture2D(texWavePerturbation, f).b;\n}\nvec3 i(sampler2D e, vec2 f) {\n  return 2. * texture2D(e, f).rgb - 1.;\n}\nfloat j(vec2 f, float k) {\n  return fract(k);\n}\nfloat l(vec2 f, float k) {\n  float m = j(f, k);\n  return 1. - abs(1. - 2. * m);\n}\nvec3 n(sampler2D o, vec2 f, float k, float u) {\n  float v = waveParams[2];\n  float A = waveParams[3];\n  vec2 B = d(o, f) * v;\n  float m = j(f, k + u);\n  float C = l(f, k + u);\n  vec2 D = f;\n  D -= B * (m + A);\n  D += u;\n  D += (k - m) * c;\n  return vec3(D, C);\n}\nconst float E = .3737;\nconst float F = 7.77;\nvec3 G(sampler2D H, sampler2D I, vec2 f, vec2 J, float k) {\n  float K = waveParams[0];\n  vec2 L = k * -J;\n  float M = h(f * E) * F;\n  vec3 N = n(I, f + L, k + M, .0);\n  vec3 O = n(I, f + L, k + M, .5);\n  vec3 P = i(H, N.xy) * N.z;\n  vec3 Q = i(H, O.xy) * O.z;\n  vec3 R = normalize(P + Q);\n  R.xy *= K;\n  R.z = sqrt(1. - dot(R.xy, R.xy));\n  return R;\n}\nvec3 S(vec2 f, float k) {\n  float T = waveParams[1];\n  return G(texWaveNormal, texWavePerturbation, f * T, waveDirection, k);\n}\nconst float U = 3.141592653589793;\nconst float V = 1. / U;\nconst float W = .3183098861837907;\nconst float X = 1.570796326794897;\nstruct PBRShadingWater {\n  float NdotL;\n  float NdotV;\n  float NdotH;\n  float VdotH;\n  float LdotH;\n  float VdotN;\n};\nfloat Y = 2.2;\nvec3 Z(float ba, vec3 bb, float bc) {\n  return bb + (bc - bb) * pow(1. - ba, 5.);\n}\nfloat bd(float be, float bf) {\n  float bg = bf * bf;\n  float bh = be * be;\n  float bi = pow((bh * (bg - 1.) + 1.), Y) * U;\n  return bg / bi;\n}\nfloat bj(float bk) {\n  return .25 / (bk * bk);\n}\nvec3 bl(in PBRShadingWater bm, float bf, vec3 bn, float bo) {\n  vec3 bp = Z(bm.VdotH, bn, bo);\n  float bq = bd(bm.NdotH, bf);\n  float br = bj(bm.LdotH);\n  return (bq * br) * bp;\n}\nvec3 bs(const vec3 x) {\n  return (x * (2.51 * x + .03)) / (x * (2.43 * x + .59) + .14);\n}\nconst float bt = 2.2;\nconst float bu = .4545454545;\nvec4 bv(vec4 bw) {\n  return vec4(pow(bw.rgb, vec3(bu)), bw.w);\n}\nvec3 bx(vec3 bw) {\n  return pow(bw, vec3(bt));\n}\nconst vec3 by = vec3(.02, 1., 5.);\nconst vec2 bz = vec2(.02, .1);\nconst float bf = .06;\nconst vec3 bA = vec3(0, .6, .9);\nconst vec3 bB = vec3(.72, .92, 1.);\nPBRShadingWater bC;\nvec3 bD(in float bE, in vec3 bF, in vec3 bG) {\n  float bH = pow((1. - bE), by[2]);\n  return mix(bG, bF, bH);\n}\nvec3 bI(in vec3 bJ, in vec3 bK, in vec3 bL, vec3 bw, in vec3 bM, in vec3 bN, in float bO) {\n  vec3 bP = bx(bw);\n  vec3 bQ = normalize(bL + bK);\n  bC.NdotL = clamp(dot(bJ, bL), .0, 1.);\n  bC.NdotV = clamp(dot(bJ, bK), .001, 1.);\n  bC.VdotN = clamp(dot(bK, bJ), .001, 1.);\n  bC.NdotH = clamp(dot(bJ, bQ), .0, 1.);\n  bC.VdotH = clamp(dot(bK, bQ), .0, 1.);\n  bC.LdotH = clamp(dot(bL, bQ), .0, 1.);\n  float bR = max(dot(bN, bK), .0);\n  vec3 bS = bx(bB);\n  vec3 bT = bx(bA);\n  vec3 bB = bD(bR, bS, bT);\n  float bU = max(dot(bN, bL), .0);\n  bB *= .1 + bU * .9;\n  float bV = clamp(bO, .8, 1.);\n  vec3 bW = Z(bC.VdotN, vec3(by[0]), by[1]) * bB * bV;\n  vec3 bX = bP * mix(bB, bU * bM * V, 2. / 3.) * bV;\n  vec3 bY = vec3(.0);\n  if(bR > .0 && bU > .0) {\n    vec3 bZ = bl(bC, bf, vec3(bz[0]), bz[1]);\n    vec3 ca = bM * V * bO;\n    bY = bC.NdotL * ca * bZ;\n  }\n  return bs(bW + bX + bY);\n}\nvoid main() {\n  vec3 bN = vnormal;\n  vec3 cb = S(vuv, timeElapsed);\n  vec3 bJ = normalize(vtbnMatrix * cb);\n  vec3 bK = -normalize(vpos - camPos);\n  vec3 bL = normalize(-lightingDirection);\n  float bO = 1.;\n  vec4 cc = vec4(bI(bJ, bK, bL, waterColor.rgb, lightingIntensity, bN, bO), waterColor.w);\n  gl_FragColor = bv(cc);\n}",
            defines: e.defines || {},
            extraCommandProps: e.extraCommandProps || {}
        });
    }
}
class $1d56c6a18dbfd30f$export$57f84a24a9a6130d extends $1d56c6a18dbfd30f$export$e82c04eda9e9b75c {
    constructor(){
        super({
            vert: $1d56c6a18dbfd30f$var$Mt,
            frag: "precision highp float;\nuniform sampler2D texture;\nuniform vec2 size;\nuniform float enableSharpen;\nuniform float sharpFactor;\nuniform float pixelRatio;\nvec2 c;\nvec3 d(const in vec3 e, const float f) {\n  vec2 h = pixelRatio / size.xy;\n  float i = .0;\n  vec4 j = texture2D(texture, c + h * vec2(-1., -1.));\n  j.rgb = mix(vec3(.0), j.rgb, sign(j.a));\n  i += mix(.0, 1., sign(j.a));\n  vec4 k = texture2D(texture, c + h * vec2(1.));\n  k.rgb = mix(vec3(.0), k.rgb, sign(k.a));\n  i += mix(.0, 1., sign(k.a));\n  vec4 l = texture2D(texture, c + h * vec2(1., -1.));\n  l.rgb = mix(vec3(.0), l.rgb, sign(l.a));\n  i += mix(.0, 1., sign(l.a));\n  vec4 m = texture2D(texture, c + h * vec2(-1., 1.));\n  m.rgb = mix(vec3(.0), m.rgb, sign(m.a));\n  i += mix(.0, 1., sign(m.a));\n  return e + f * (i * e - j.rgb - l.rgb - m.rgb - k.rgb);\n}\nvoid main() {\n  c = gl_FragCoord.xy / size;\n  vec4 e = texture2D(texture, c);\n  if(enableSharpen == 1.) {\n    e.rgb = d(e.rgb, sharpFactor);\n  }\n  gl_FragColor = e;\n}",
            extraCommandProps: {
                viewport: {
                    x: 0,
                    y: 0,
                    width: (e, t)=>t.size[0],
                    height: (e, t)=>t.size[1]
                }
            }
        });
    }
    getMeshCommand(e, t) {
        return this.commands.copy || (this.commands.copy = this.createREGLCommand(e, null, t.getElements())), this.commands.copy;
    }
}
class $1d56c6a18dbfd30f$export$ef84166aa9d1fabd extends $1d56c6a18dbfd30f$export$9d2cc9f1c4004434 {
    constructor(t = {}){
        const n = [], r = t.uniforms, i = [
            {
                name: "modelViewMatrix",
                type: "function",
                fn: function(t, r) {
                    return (0, $3iqbd).multiply(n, r.viewMatrix, r.modelMatrix);
                }
            }
        ];
        r && i.push(...r), super({
            vert: "attribute vec3 aPosition;\nuniform mat4 projMatrix;\nuniform mat4 modelMatrix;\nuniform mat4 positionMatrix;\nuniform mat4 modelViewMatrix;\n#include <get_output>\nvoid main() {\n  vec4 c = getPosition(aPosition);\n  mat4 d = getPositionMatrix();\n  gl_Position = projMatrix * modelViewMatrix * d * c;\n}",
            frag: "precision mediump float;\nuniform vec4 lineColor;\nuniform float lineOpacity;\nvoid main() {\n  gl_FragColor = lineColor;\n  gl_FragColor.a *= lineOpacity;\n}",
            uniforms: i,
            defines: t.defines || {},
            extraCommandProps: t.extraCommandProps || {}
        });
    }
}
const $1d56c6a18dbfd30f$var$Kt = [], $1d56c6a18dbfd30f$var$Jt = [];
class $1d56c6a18dbfd30f$export$5688b391eda0d8f9 extends $1d56c6a18dbfd30f$export$9d2cc9f1c4004434 {
    constructor(t = {}){
        const n = [], i = t.uniforms, o = [
            {
                name: "viewMatrixInverse",
                type: "function",
                fn: (t, n)=>(0, $3iqbd).invert($1d56c6a18dbfd30f$var$Kt, n.viewMatrix)
            },
            {
                name: "modelViewMatrix",
                type: "function",
                fn: function(t, r) {
                    return (0, $3iqbd).multiply(n, r.viewMatrix, r.modelMatrix);
                }
            },
            {
                name: "environmentTransform",
                type: "function",
                fn: (e, t)=>(0, $bDSmI).fromRotation($1d56c6a18dbfd30f$var$Jt, Math.PI * (t.environmentOrientation || 0) / 180)
            }
        ];
        i && o.push(...i), super({
            vert: "precision mediump float;\n#include <gl2_vert>\nattribute vec3 aPosition;\n#include <line_extrusion_vert>\n#ifdef HAS_MAP\nuniform vec2 uvScale;\nuniform vec2 uvOffset;\nattribute vec2 aTexCoord;\nvarying vec2 vTexCoord;\n#ifdef HAS_I3S_UVREGION\nattribute vec4 uvRegion;\nvarying vec4 vUvRegion;\n#endif\n#endif\n#if defined(HAS_COLOR)\nattribute vec4 aColor;\n#elif defined(HAS_COLOR0)\n#if COLOR0_SIZE == 3\nattribute vec3 aColor0;\n#else\nattribute vec4 aColor0;\n#endif\nvarying vec4 vColor;\n#endif\nuniform mat4 projMatrix;\nuniform mat3 modelNormalMatrix;\nuniform mat4 modelViewMatrix;\nuniform mat4 modelMatrix;\nuniform mat4 positionMatrix;\nuniform vec2 halton;\nuniform vec2 outSize;\nuniform mat4 projViewMatrix;\n#include <get_output>\n#include <heatmap_render_vert>\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n#include <vsm_shadow_vert>\n#endif\nvarying vec3 vViewPosition;\nvoid main() {\n  \n#ifdef IS_LINE_EXTRUSION\nvec4 c = getPosition(getLineExtrudePosition(aPosition));\n#else\nvec4 c = getPosition(aPosition);\n#endif\nmat4 d = getPositionMatrix();\n  mat4 e = projMatrix;\n  e[2].xy += halton.xy / outSize.xy;\n#ifdef HAS_MASK_EXTENT\ngl_Position = e * getMaskPosition(d * c, modelMatrix);\n#else\ngl_Position = e * modelViewMatrix * d * c;\n#endif\nvec4 f = modelViewMatrix * d * c;\n  vViewPosition = -f.xyz;\n#ifdef HAS_MAP\nvec2 h = decode_getTexcoord(aTexCoord);\n  vTexCoord = h * uvScale + uvOffset;\n#endif\n#if defined(HAS_COLOR)\nvColor = aColor / 255.;\n#elif defined(HAS_COLOR0)\n#if COLOR0_SIZE == 3\nvColor = vec4(aColor0 / 255., 1.);\n#else\nvColor = aColor0 / 255.;\n#endif\n#endif\n}",
            frag: "#if __VERSION__ == 100\n#if defined(GL_EXT_shader_texture_lod)\n#extension GL_EXT_shader_texture_lod : enable\n#define textureCubeLod(tex, uv, lod) textureCubeLodEXT(tex, uv, lod)\n#else\n#define textureCubeLod(tex, uv, lod) textureCube(tex, uv, lod)\n#endif\n#if defined(GL_OES_standard_derivatives)\n#extension GL_OES_standard_derivatives : enable\n#endif\n#else\n#define textureCubeLod(tex, uv, lod) textureLod(tex, uv, lod)\n#endif\n#define saturate(x)        clamp(x, 0.0, 1.0)\nprecision mediump float;\n#include <gl2_frag>\n#include <hsv_frag>\nuniform vec3 hsv;\n#define GET_BASEMAP(UV) (texture2D(baseColorTexture, (UV)))\nuniform mat4 viewMatrix;\nuniform mat4 projMatrix;\nuniform vec3 cameraPosition;\n#if defined(HAS_IBL_LIGHTING)\nuniform mat4 viewMatrixInverse;\n#endif\nuniform vec4 baseColorFactor;\nuniform vec3 emissiveFactor;\nuniform vec3 specularFactor;\nuniform float opacity;\nuniform float envRotationSin;\nuniform float envRotationCos;\nuniform float rgbmRange;\n#if defined(HAS_MAP)\n#include <computeTexcoord_frag>\n#endif\n#ifdef HAS_BASECOLOR_MAP\nuniform sampler2D baseColorTexture;\n#endif\n#ifdef HAS_NORMAL_MAP\nuniform sampler2D normalTexture;\nvec3 c(vec3 d, vec3 e) {\n  vec3 f = dFdx(d.xyz);\n  vec3 h = dFdy(d.xyz);\n  vec3 i = normalize(f - h);\n  vec3 j = normalize(-f + h);\n  vec3 k = normalize(e);\n  vec3 l = texture2D(normalTexture, computeTexCoord(vTexCoord)).rgb * 2. - 1.;\n  mat3 m = mat3(i, j, k);\n  return normalize(m * l);\n}\n#endif\n#ifdef HAS_EMISSIVE_MAP\nuniform sampler2D emissiveTexture;\n#endif\n#ifdef SHADING_MODEL_SPECULAR_GLOSSINESS\nuniform vec4 diffuseFactor;\n#ifdef HAS_DIFFUSE_MAP\nuniform sampler2D diffuseTexture;\n#endif\n#ifdef HAS_SPECULARGLOSSINESS_MAP\nuniform sampler2D specularGlossinessTexture;\n#endif\n#endif\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n#include <vsm_shadow_frag>\n#endif\n#if defined(HAS_COLOR) || defined(HAS_COLOR0)\nvarying vec4 vColor;\n#endif\n#ifdef GAMMA_INPUT\nvec3 n(vec3 o) {\n  return o * o;\n}\nfloat n(float o) {\n  return o * o;\n}\n#else\nvec3 n(vec3 o) {\n  return o;\n}\nfloat n(float o) {\n  return o;\n}\n#endif\nvec3 u() {\n  \n#ifdef SHADING_MODEL_SPECULAR_GLOSSINESS\n#ifdef HAS_SPECULARGLOSSINESS_MAP\nreturn texture2D(specularGlossinessTexture, computeTexCoord(vTexCoord)).rgb;\n#else\nreturn specularFactor;\n#endif\n#else\nreturn specularFactor;\n#endif\n}\nvec3 v() {\n  \n#ifdef HAS_EMISSIVE_MAP\nreturn texture2D(emissiveTexture, computeTexCoord(vTexCoord)).rgb;\n#else\nreturn emissiveFactor;\n#endif\n}\n#if defined(TONEMAP_OUTPUT)\n#if TONEMAP_OUTPUT > 0\nuniform float exposureBias;\nfloat A(vec3 rgb) {\n  return dot(rgb, vec3(.299, .587, .114));\n}\nfloat B(vec3 rgb) {\n  return dot(rgb, vec3(.212671, .715160, .072169));\n}\nvec3 C(vec3 xyz) {\n  vec3 D = vec3(3.240479, -1.53715, -.498535);\n  vec3 E = vec3(-.969256, 1.875992, .041556);\n  vec3 F = vec3(.055648, -.204043, 1.057311);\n  vec3 rgb;\n  rgb.b = dot(xyz, F);\n  rgb.g = dot(xyz, E);\n  rgb.r = dot(xyz, D);\n  return rgb;\n}\nvec3 H(vec3 rgb) {\n  vec3 I = vec3(.412453, .35758, .180423);\n  vec3 J = vec3(.212671, .71516, .0721688);\n  vec3 K = vec3(.0193338, .119194, .950227);\n  vec3 xyz;\n  xyz.x = dot(rgb, I);\n  xyz.y = dot(rgb, J);\n  xyz.z = dot(rgb, K);\n  return xyz;\n}\nvec3 L(vec3 xyz) {\n  float M = xyz.x + xyz.y + xyz.z;\n  M = 1. / M;\n  vec3 O;\n  O.z = xyz.y;\n  O.x = xyz.x * M;\n  O.y = xyz.y * M;\n  return O;\n}\nvec3 P(vec3 O) {\n  float x = O.x;\n  float y = O.y;\n  float J = O.z;\n  vec3 xyz;\n  xyz.y = J;\n  xyz.x = x * (J / y);\n  xyz.z = (1. - x - y) * (J / y);\n  return xyz;\n}\nfloat Q(float x) {\n  float U = pow(x, 1.60525727);\n  float V = ((1.05542877 * 4.68037409) * U) / (4.68037409 * U + 1.);\n  return clamp(V, .0, 1.);\n}\nconst float W = 1. / .18;\nfloat ba(float x) {\n  x *= W;\n  const float bb = .2;\n  const float F = .34;\n  const float bc = .002;\n  const float bd = 1.68;\n  const float be = .0005;\n  const float bf = .252;\n  const float bg = 1. / .833837;\n  return ((x * (bb * x + bc * F) + bd * be) / (x * (bb * x + F) + bd * bf) - be / bf) * bg;\n}\nvec3 bh(vec3 x) {\n  x *= W;\n  const float bb = .27;\n  const float F = .29;\n  const float bc = .052;\n  const float bd = .2;\n  const float bf = .18;\n  const float bg = 1. / .897105;\n  return ((x * (bb * x + bc * F)) / (x * (bb * x + F) + bd * bf)) * bg;\n}\nvec3 bi(vec3 x) {\n  vec3 bj = x.rgb;\n  bj = min(bj, vec3(3.));\n  float bk = B(bj);\n  if(bk > .0) {\n    float bl = Q(bk);\n    bj = bj * (bl / bk);\n    bj = clamp(bj, vec3(.0), vec3(1.));\n  }\n  float bm = 1. / 2.2;\n  bj = pow(bj, vec3(bm));\n  return bj;\n}\n#endif\n#endif\n#if defined(IRR_RGBM) || defined(ENV_RGBM) || defined(ENV_GAMMA) || defined(IRR_GAMMA)\nuniform float envMapExposure;\n#endif\nuniform vec4 themingColor;\nuniform mat3 environmentTransform;\nvec3 bn(vec3 bo, vec3 bp) {\n  \n#if defined(HAS_SHADOWMAP)\nfloat bq = dot(shadowLightDir, bp);\n  float br = (bq + 1.) / 2.;\n  br = min(1., br * 1.5);\n  float bs = 1.;\n  vec3 bt = bo * min(bs, br);\n  return bt;\n#else\nreturn bo;\n#endif\n}\n#ifdef HAS_IBL_LIGHTING\nuniform float reflectivity;\nuniform vec3 hdrHSV;\nuniform samplerCube prefilterMap;\nuniform vec3 diffuseSPH[9];\nuniform vec2 prefilterMiplevel;\nuniform vec2 prefilterSize;\n#else\nuniform vec3 ambientColor;\n#endif\n#if defined(HAS_IBL_LIGHTING)\nvec3 bu(const in vec3 bv) {\n  vec3 bw = environmentTransform * bv;\n  float x = bw.x;\n  float y = bw.y;\n  float z = bw.z;\n  vec3 bt = (diffuseSPH[0] + diffuseSPH[1] * x + diffuseSPH[2] * y + diffuseSPH[3] * z + diffuseSPH[4] * z * x + diffuseSPH[5] * y * z + diffuseSPH[6] * y * x + diffuseSPH[7] * (3. * z * z - 1.) + diffuseSPH[8] * (x * x - y * y));\n  if(length(hdrHSV) > .0) {\n    bt = hsv_apply(bt, hdrHSV);\n  }\n  return max(bt, vec3(.0));\n}\nvec3 bx(const in vec4 by, const in float bz) {\n  if(bz <= .0)\n    return by.rgb;\n  return bz * by.rgb * by.a;\n}\nfloat bA(const in float bB) {\n  return bB;\n}\nvec3 bC(const in float bD, const in vec3 D) {\n  vec3 bE = D;\n  float bF = prefilterMiplevel.x;\n  float bG = min(bF, bA(bD) * prefilterMiplevel.y);\n  vec3 bH = bx(textureCubeLod(prefilterMap, bE, bG), rgbmRange);\n  if(length(hdrHSV) > .0) {\n    return hsv_apply(bH, hdrHSV);\n  } else {\n    return bH;\n  }\n}\nvec3 bI(const in vec3 k, const in vec3 D, const in float bJ) {\n  float bK = 1. - bJ;\n  float bL = bK * (sqrt(bK) + bJ);\n  return mix(k, D, bL);\n}\nvec3 bM(const in vec3 bv, const in vec3 bN, const in float bO, const in vec3 bP) {\n  vec3 D = reflect(-bN, bv);\n  D = bI(bv, D, bO);\n  vec3 bQ = bC(bO, environmentTransform * D);\n  float bR = clamp(1. + dot(D, bP), .0, 1.);\n  bQ *= bR * bR;\n  return bQ;\n}\n#else\nvec3 bM(const in vec3 bv, const in vec3 bN, const in float bO, const in vec3 bP) {\n  return ambientColor;\n}\n#endif\nvarying highp vec3 vViewPosition;\nvec3 bS(vec3 bT, float bU) {\n  float bV = max(1. - bU, .0);\n  return bT + (1. - bT) * pow(bV, 5.);\n}\nfloat bW(float bT, float bU) {\n  float bV = max(1. - bU, .0);\n  return bT + (1. - bT) * pow(bV, 5.);\n}\n#include <srgb_frag>\nvoid main() {\n  glFragColor = vec4(vec3(1.), opacity);\n#ifdef HAS_BASECOLOR_MAP\nvec4 bX = GET_BASEMAP(computeTexCoord(vTexCoord));\n#ifdef GAMMA_INPUT\nbX.xyz *= bX.xyz;\n#endif\nglFragColor = glFragColor * bX;\n#endif\n#ifdef ALPHATEST\nif(glFragColor.a < ALPHATEST)\n    discard;\n  \n#endif\nfloat bY = 1.;\n  vec3 bZ = dFdx(vViewPosition);\n  vec3 ca = dFdy(vViewPosition);\n  vec3 bv = normalize(cross(bZ, ca));\n  vec3 cb;\n  if(projMatrix[3][3] == .0) {\n    cb = normalize(vViewPosition);\n  } else {\n    cb = vec3(.0, .0, 1.);\n  }\n  bv = faceforward(bv, -cb, bv);\n  vec3 cc = bv;\n#ifdef HAS_NORMAL_MAP\nbv = c(-vViewPosition, bv);\n#endif\nvec3 cd = vec3(.0);\n  vec3 ce = vec3(.0);\n#ifdef HAS_IBL_LIGHTING\nvec3 bp = mat3(viewMatrixInverse) * bv;\n  vec3 cf = glFragColor.rgb * bu(bp) * .5;\n  cf = bn(cf, bp);\n  cd += n(baseColorFactor.rgb) * cf;\n#endif\nvec3 cg = v();\n#ifdef METAL\nglFragColor.xyz = glFragColor.xyz * (n(cg) + cd + n(baseColorFactor.rgb) + ce);\n#else\nglFragColor.xyz = glFragColor.xyz * (n(cg) + cd + n(baseColorFactor.rgb)) + ce;\n#endif\nvec3 ch;\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\nfloat ci = shadow_computeShadow();\n  ch = shadow_blend(ch, ci).rgb;\n#endif\n#ifdef HAS_COLOR\nglFragColor = glFragColor * vColor;\n#endif\nglFragColor.rgb += ch;\n  glFragColor.rgb = linearTosRGB(glFragColor.rgb);\n#if defined(HAS_IBL_LIGHTING)\nvec3 cj;\n#if defined(HAS_NORMAL_MAP)\n#ifdef ENVMAP_MODE_REFLECTION\ncj = reflect(-cb, bv);\n#else\ncj = refract(-cb, bv, 1.);\n#endif\n#else\ncj = reflect(-cb, bv);\n#endif\ncj = mat3(viewMatrixInverse) * cj;\n  float ck = 1.;\n  vec3 cl;\n#ifdef HAS_IBL_LIGHTING\ncl = vec3(.0);\n#elif\ncl = ambientColor;\n#endif\ncl *= ck;\n  float bV = dot(cb, bv);\n  if(bV < -1e-2 || reflectivity == .0)\n    bV = 1.;\n  else\n    bV = max(1e-6, bV);\n  vec3 cm;\n  vec3 cn = u();\n#ifdef METAL\ncm = n(cn);\n#else\ncm = bS(n(cn), bV) * (1. - envRotationSin);\n  glFragColor.a = mix(glFragColor.a, bW(glFragColor.a, bV), reflectivity) * envRotationCos;\n  float co = pow(1. - bV * .5, 5.);\n  float cp = (28. / 23.) * (1. - co) * (1. - co);\n  glFragColor.rgb *= cp * (1. - n(cn));\n#endif\nglFragColor.rgb += cl.rgb * bY * cm.rgb;\n#endif\n#if defined(TONEMAP_OUTPUT)\n#if TONEMAP_OUTPUT == 1\nglFragColor.rgb = bi(exposureBias * glFragColor.rgb);\n#elif TONEMAP_OUTPUT == 2\nglFragColor.rgb = bh(exposureBias * glFragColor.rgb);\n#endif\n#endif\nglFragColor.rgb = mix(glFragColor.rgb, themingColor.rgb, themingColor.a);\n#if __VERSION__ == 100\ngl_FragColor = glFragColor;\n#endif\n}",
            uniforms: o,
            defines: t.defines || {},
            extraCommandProps: t.extraCommandProps || {}
        }), this.version = 300;
    }
}
const $1d56c6a18dbfd30f$var$Zt = [];
class $1d56c6a18dbfd30f$export$59f3f5e97543da75 {
    constructor(e, t, n){
        this._regl = e, this._layer = n, this._viewport = t, this._init();
    }
    _init() {
        this._shader = new $1d56c6a18dbfd30f$export$9d2cc9f1c4004434({
            vert: "attribute vec3 aPosition;\nuniform mat4 projMatrix;\nuniform mat4 modelMatrix;\nuniform mat4 modelViewMatrix;\nuniform mat4 positionMatrix;\nvarying vec4 vWorldPosition;\n#include <get_output>\nvoid main() {\n  vec4 c = getPosition(aPosition);\n  mat4 d = getPositionMatrix();\n  vec4 e = modelMatrix * d * c;\n  gl_Position = projMatrix * modelViewMatrix * d * c;\n  vWorldPosition = e;\n}",
            frag: "precision mediump float;\nvarying vec4 vWorldPosition;\nuniform vec2 fogDist;\nuniform vec3 cameraPosition;\nuniform float rainDepth;\nvoid main() {\n  vec3 c = vec3(vWorldPosition[0] - cameraPosition[0], vWorldPosition[1] - cameraPosition[1], vWorldPosition[2] - cameraPosition[2]);\n  float d = length(c);\n  float e = clamp(1. - (d - fogDist.x) / (fogDist.y - fogDist.x), .0, 1.);\n  if(vWorldPosition[2] < rainDepth) {\n    gl_FragColor = vec4(e, .0, .0, 1.);\n  } else {\n    gl_FragColor = vec4(e, 1., .0, 1.);\n  }\n}",
            uniforms: [
                {
                    name: "modelViewMatrix",
                    type: "function",
                    fn: function(t, n) {
                        return (0, $3iqbd).multiply($1d56c6a18dbfd30f$var$Zt, n.viewMatrix, n.modelMatrix);
                    }
                }
            ],
            extraCommandProps: {
                viewport: this._viewport
            }
        });
        const t = this._layer.getRenderer().createFBOInfo();
        this._fbo = this._regl.framebuffer(t), this._scene = new $1d56c6a18dbfd30f$export$38af1803e3442a7f, this.renderer = new $1d56c6a18dbfd30f$export$88530751e3977073(this._regl);
    }
    render(e, t) {
        this._resize(), this.renderer.clear({
            color: [
                0,
                0,
                0,
                1
            ],
            depth: 1,
            framebuffer: this._fbo
        }), this._scene.setMeshes(e);
        return this.renderer.render(this._shader, {
            projMatrix: t.projMatrix,
            viewMatrix: t.viewMatrix,
            cameraPosition: t.cameraPosition,
            fogDist: t.fogDist,
            rainDepth: t.rainDepth
        }, this._scene, this._fbo), this._fbo;
    }
    dispose() {
        this._fbo && this._fbo.destroy(), this._shader && this._shader.dispose();
    }
    _resize() {
        const e = $1d56c6a18dbfd30f$var$m(this._viewport.width.data) ? this._viewport.width.data() : this._viewport.width, t = $1d56c6a18dbfd30f$var$m(this._viewport.height.data) ? this._viewport.height.data() : this._viewport.height;
        !this._fbo || this._fbo.width === e && this._fbo.height === t || this._fbo.resize(e, t);
    }
}
class $1d56c6a18dbfd30f$export$ed6ba9a2be2fa41a extends $1d56c6a18dbfd30f$export$e82c04eda9e9b75c {
    constructor(){
        super({
            vert: $1d56c6a18dbfd30f$var$Mt,
            frag: "#if __VERSION__ == 100\n#ifdef GL_OES_standard_derivatives\n#extension GL_OES_standard_derivatives : enable\n#endif\n#endif\nprecision mediump float;\n#include <gl2_frag>\nvarying vec2 vTexCoord;\n#ifdef HAS_RAIN\nuniform sampler2D ripplesMap;\n#endif\n#ifdef HAS_SNOW\nuniform sampler2D normalMap;\n#endif\n#ifdef HAS_FOG\nuniform vec3 fogColor;\n#endif\nuniform sampler2D sceneMap;\nuniform sampler2D mixFactorMap;\nuniform float time;\nuniform vec2 resolution;\nuniform float snowIntensity;\nfloat c(float a, float b, float w) {\n  return a + w * (b - a);\n}\n#define HASHSCALE1 .1031\n#define HASHSCALE3 vec3(.1031, .1030, .0973)\n#define HASHSCALE4 vec3(.1031, .1030, .0973, .1099)\nfloat d = .5;\nfloat e = .2;\nfloat f = .5;\nfloat h = 20.;\nfloat i(float p) {\n  vec3 j = fract(vec3(p) * HASHSCALE1);\n  j += dot(j, j.yzx + 19.19);\n  return fract((j.x + j.y) * j.z);\n}\nvec2 k(vec2 p) {\n  vec3 j = fract(vec3(p.xyx) * HASHSCALE3);\n  j += dot(j, j.yzx + 19.19);\n  return fract((j.xx + j.yz) * j.zy);\n}\nvec2 l(vec2 m) {\n  float x = fract(sin(dot(m.xy, vec2(122.9898, 783.233))) * 43758.5453);\n  float y = fract(sin(dot(m.xy, vec2(457.6537, 537.2793))) * 37573.5913);\n  return vec2(x, y);\n}\nvec3 n(vec2 o, float u) {\n  vec3 v = vec3(.0);\n  o = o * (2. + u);\n  float A = e * snowIntensity;\n  float B = o.y * (((i(u) * 2. - 1.) * .5 + 1.) * A);\n  float C = (f * time);\n  o += vec2(B, C);\n  vec2 D = k(floor(o) + 31.1759 * u);\n  o = fract(o);\n  o -= (D * 2. - 1.) * .35;\n  o -= .5;\n  float r = length(o);\n  float E = .05 * (1. + .3 * sin(time * d));\n  float F = smoothstep(E, -E, r);\n  vec3 G = vec3(F) * D.x;\n  return G;\n}\nvec3 H() {\n  vec3 v = vec3(0);\n  vec2 o = gl_FragCoord.xy / resolution.xy;\n  o *= vec2(resolution.x / resolution.y, 1.);\n  float I = h * snowIntensity;\n  for(float J = 0.; J < I; J++) {\n    v += n(o, J);\n  }\n  return v;\n}\nvec3 K(vec4 L, vec4 M, float N) {\n  float O = M.b;\n  vec3 P = vec3(1.);\n  if(N < 1.) {\n    float r = c(.5, P.x, O);\n    float g = c(.5, P.y, O);\n    float b = c(.5, P.z, O);\n    return vec3(r, g, b);\n  } else {\n    float r = c(L.r, P.x, O);\n    float g = c(L.g, P.y, O);\n    float b = c(L.b, P.z, O);\n    return vec3(r, g, b);\n  }\n}\nvoid main() {\n  vec4 L = texture2D(sceneMap, vTexCoord);\n  glFragColor = L;\n  vec4 Q = texture2D(mixFactorMap, vTexCoord);\n#ifdef HAS_RAIN\nvec4 R = texture2D(ripplesMap, vTexCoord);\n  if(Q.g < 1.) {\n    L = mix(L, R, .4);\n  }\n  glFragColor = L;\n#endif\n#ifdef HAS_SNOW\nvec3 S = H();\n  glFragColor = vec4(L.rgb + S, L.a);\n#endif\n#ifdef HAS_FOG\nfloat T = Q.r;\n  vec3 U = mix(fogColor, glFragColor.rgb, T);\n  glFragColor = vec4(U, L.a);\n#endif\n#if __VERSION__ == 100\ngl_FragColor = glFragColor;\n#endif\n}",
            extraCommandProps: {
                viewport: {
                    x: 0,
                    y: 0,
                    width: (e, t)=>t.resolution[0],
                    height: (e, t)=>t.resolution[1]
                }
            }
        });
    }
}
const $1d56c6a18dbfd30f$var$en = [], $1d56c6a18dbfd30f$var$tn = [
    .03,
    .03,
    .03
], $1d56c6a18dbfd30f$var$nn = [], $1d56c6a18dbfd30f$var$rn = [], $1d56c6a18dbfd30f$var$on = [], $1d56c6a18dbfd30f$var$an = (0, $3iqbd).fromRotationTranslation([], (0, $k1dpP).fromEuler([], 90, 0, 0), [
    0,
    0,
    0
]);
class $1d56c6a18dbfd30f$export$22591eb5ea34a33 {
    constructor(e, t){
        this._regl = e, this._viewport = t, this._init();
    }
    _init() {
        this._shader = new $1d56c6a18dbfd30f$export$9d2cc9f1c4004434({
            vert: "#include <gl2_vert>\nattribute vec3 aPosition;\nattribute vec3 aNormal;\nattribute vec2 aTexCoord;\nuniform mat4 projMatrix;\nuniform mat4 modelMatrix;\nuniform mat4 modelViewMatrix;\nuniform mat4 positionMatrix;\nvarying vec2 vTexCoord;\n#include <get_output>\nvoid main() {\n  vec4 c = getPosition(aPosition);\n  mat4 d = getPositionMatrix();\n  gl_Position = projMatrix * modelViewMatrix * d * c;\n  vTexCoord = aTexCoord;\n}",
            frag: "#if __VERSION__ == 100\n#ifdef GL_OES_standard_derivatives\n#extension GL_OES_standard_derivatives : enable\n#endif\n#endif\nprecision mediump float;\n#include <gl2_frag>\nvarying vec2 vTexCoord;\nuniform float rippleRadius;\nuniform float density;\nuniform float time;\nvec3 c(vec2 p) {\n  vec3 q = vec3(dot(p, vec2(127.1, 311.7)), dot(p, vec2(269.5, 183.3)), dot(p, vec2(419.2, 371.9)));\n  return fract(sin(q) * 43758.5453);\n}\nfloat d(in vec2 x) {\n  vec2 e = x * density / 4000.0;\n  vec2 p = floor(e);\n  vec2 f = fract(e);\n  float h = .0;\n  for(int i = -4; i <= 4; i++)\n    for(int k = -4; k <= 4; k++) {\n      vec2 g = vec2(float(k), float(i));\n      vec3 l = c(p + g);\n      vec2 r = g - f + l.xy;\n      float m = sqrt(dot(r, r));\n      float n = max(mix(smoothstep(.99, .999, max(cos(m - time * 2. + (l.x + l.y) * 5.), 0.)), 0., m), 0.);\n      h += n;\n    }\n  return h;\n}\nvoid main() {\n  vec2 u = vTexCoord;\n  float A = 24. / (rippleRadius * .01);\n  float f = d(A * u) * smoothstep(.0, .4, sin(u.x * 3.151592) * sin(u.y * 3.141592));\n  vec3 B = vec3(-dFdx(f), -dFdy(f), -dFdy(f));\n  glFragColor = vec4(B, 1.);\n#if __VERSION__ == 100\ngl_FragColor = glFragColor;\n#endif\n}",
            uniforms: [
                {
                    name: "modelViewMatrix",
                    type: "function",
                    fn: function(t, n) {
                        return (0, $3iqbd).multiply($1d56c6a18dbfd30f$var$en, n.viewMatrix, n.modelMatrix);
                    }
                }
            ],
            extraCommandProps: {
                viewport: this._viewport
            }
        }), this._shader.version = 300, this._fbo = this._regl.framebuffer({
            color: this._regl.texture({
                width: this._viewport.width(),
                height: this._viewport.height(),
                wrap: "clamp",
                mag: "linear",
                min: "linear"
            }),
            depth: !0
        }), this._scene = new $1d56c6a18dbfd30f$export$38af1803e3442a7f, this.renderer = new $1d56c6a18dbfd30f$export$88530751e3977073(this._regl);
    }
    _transformRipples(n) {
        const r = n.coordinateToPointAtRes(n.getCenter(), n.getGLRes()), i = n.getGLScale() / n.getGLScale(this._fixZoom), a = (0, $eIStk).set($1d56c6a18dbfd30f$var$rn, i, i, i), s = (0, $eIStk).multiply(a, $1d56c6a18dbfd30f$var$tn, a), c = (0, $3iqbd).identity($1d56c6a18dbfd30f$var$on);
        (0, $3iqbd).fromRotationTranslationScale(c, (0, $k1dpP).fromEuler($1d56c6a18dbfd30f$var$nn, 0, 0, 0), [
            r.x,
            r.y,
            0
        ], s), (0, $3iqbd).multiply(c, c, $1d56c6a18dbfd30f$var$an), this._mesh.setLocalTransform(c);
    }
    _createRipplesMask(e) {
        this._fixZoom = e.getZoom();
        const t = 800 * Math.pow(2, 16.685648411389433 - this._fixZoom), n = {};
        n.POSITION = [
            -t,
            0,
            -t,
            t,
            0,
            -t,
            -t,
            0,
            t,
            t,
            0,
            t
        ], n.NORMAL = [
            0,
            1,
            0,
            0,
            1,
            0,
            0,
            1,
            0,
            0,
            1,
            0
        ], n.TEXCOORD_0 = [
            0,
            0,
            1,
            0,
            0,
            1,
            1,
            1
        ];
        const r = new $1d56c6a18dbfd30f$export$2db6c17465f94a2(n, [
            3,
            1,
            0,
            0,
            2,
            3
        ], 0, {
            positionAttribute: "POSITION",
            normalAttribute: "NORMAL",
            uv0Attribute: "TEXCOORD_0"
        });
        r.generateBuffers(this._regl);
        const i = new $1d56c6a18dbfd30f$export$a2d8b23205c25948;
        return new $1d56c6a18dbfd30f$export$e176487c05830cc5(r, i);
    }
    render(e, t) {
        this._resize(), this.renderer.clear({
            color: [
                0,
                0,
                0,
                1
            ],
            depth: 1,
            framebuffer: this._fbo
        }), this._mesh = this._mesh || this._createRipplesMask(e), this._scene.setMeshes(this._mesh), this._transformRipples(e);
        return this.renderer.render(this._shader, {
            projMatrix: t.projMatrix,
            viewMatrix: t.viewMatrix,
            time: t.time,
            rippleRadius: t.rippleRadius,
            density: t.density
        }, this._scene, this._fbo), this._fbo;
    }
    dispose() {
        this._fbo && this._fbo.destroy(), this._shader && this._shader.dispose();
    }
    _resize() {
        const e = $1d56c6a18dbfd30f$var$m(this._viewport.width.data) ? this._viewport.width.data() : this._viewport.width, t = $1d56c6a18dbfd30f$var$m(this._viewport.height.data) ? this._viewport.height.data() : this._viewport.height;
        !this._fbo || this._fbo.width === e && this._fbo.height === t || this._fbo.resize(e, t);
    }
}
var $1d56c6a18dbfd30f$var$cn = "attribute vec3 aPosition;\nuniform mat4 positionMatrix;\nuniform mat4 projViewModelMatrix;\n#ifdef HAS_TEXTURE\nattribute vec2 aTexCoord;\nvarying vec2 uv;\nvarying vec4 vPos;\n#endif\n#include <get_output>\nvoid main() {\n  mat4 c = getPositionMatrix();\n  vec4 d = c * getPosition(aPosition);\n  gl_Position = projViewModelMatrix * d;\n#ifdef HAS_TEXTURE\nuv = aTexCoord;\n  vPos = getPosition(aPosition);\n#endif\n}";
const $1d56c6a18dbfd30f$var$ln = [
    0,
    0,
    0,
    1
];
class $1d56c6a18dbfd30f$export$dce1ad109d1f5f99 {
    constructor(e, t){
        this.regl = e, this._viewport = t, this.renderer = new $1d56c6a18dbfd30f$export$88530751e3977073(e), this._init();
    }
    _init() {
        this._maskColorFbo = this.renderer.regl.framebuffer({
            color: this.renderer.regl.texture({
                width: 1,
                height: 1,
                wrap: "clamp",
                mag: "linear",
                min: "linear"
            }),
            depth: !0
        }), this._maskModeFbo = this.renderer.regl.framebuffer({
            color: this.renderer.regl.texture({
                width: 1,
                height: 1,
                wrap: "clamp",
                mag: "nearest",
                min: "nearest"
            }),
            depth: !0
        });
        const t = [
            {
                name: "projViewModelMatrix",
                type: "function",
                fn: (t, n)=>(0, $3iqbd).multiply([], n.projViewMatrix, n.modelMatrix)
            }
        ];
        this._maskColorShader = new $1d56c6a18dbfd30f$export$9d2cc9f1c4004434({
            vert: $1d56c6a18dbfd30f$var$cn,
            frag: "#ifdef GL_ES\nprecision highp float;\n#endif\nuniform vec4 maskColor;\n#ifdef HAS_TEXTURE\nuniform sampler2D maskTexture;\nvarying vec2 uv;\nuniform vec3 mask_position0;\nuniform vec3 mask_position1;\nuniform vec3 mask_position2;\nuniform vec3 mask_position3;\nvarying vec4 vPos;\nvec2 c(vec2 d, vec2 a, vec2 b, vec2 e, vec2 f) {\n  vec2 h = vec2(.5);\n  for(int i = 0; i < 10; i++) {\n    float j = h.x;\n    float k = h.y;\n    vec2 l = (1. - j) * (1. - k) * a + j * (1. - k) * b + j * k * e + (1. - j) * k * f;\n    vec2 m = d - l;\n    if(length(m) < .001)\n      break;\n    vec2 n = -(1. - k) * a + (1. - k) * b + k * e - k * f;\n    vec2 o = -(1. - j) * a - j * b + j * e + (1. - j) * f;\n    float A = n.x * o.y - n.y * o.x;\n    if(abs(A) > .0001) {\n      vec2 B = vec2((m.x * o.y - m.y * o.x) / A, (m.y * n.x - m.x * n.y) / A);\n      h += B;\n    }\n    h = clamp(h, .0, 1.);\n  }\n  return h;\n}\n#endif\nvoid main() {\n  \n#ifdef HAS_TEXTURE\nvec2 d = vPos.xy;\n  vec2 C = c(d, mask_position0.xy, mask_position1.xy, mask_position2.xy, mask_position3.xy);\n  gl_FragColor = texture2D(maskTexture, C);\n#else\nif(maskColor.a == .0) {\n    discard;\n  }\n  gl_FragColor = maskColor;\n#endif\n}",
            uniforms: t,
            extraCommandProps: {
                viewport: this._viewport
            }
        }), this._maskModeShader = new $1d56c6a18dbfd30f$export$9d2cc9f1c4004434({
            vert: $1d56c6a18dbfd30f$var$cn,
            frag: "#ifdef GL_ES\nprecision highp float;\n#endif\nuniform float maskMode;\n#ifdef HAS_MASK_FLAT\nuniform float flatHeight;\n#endif\n#ifdef HAS_MASK_COLOR\nuniform vec2 heightRange;\n#endif\nvoid main() {\n  \n#if defined(HAS_MASK_FLAT)\ngl_FragColor = vec4(maskMode, flatHeight, .0, 1.);\n#elif defined(HAS_MASK_COLOR)\ngl_FragColor = vec4(maskMode, .0, heightRange.x, heightRange.y);\n#else\ngl_FragColor = vec4(maskMode, .0, .0, .0);\n#endif\n}",
            uniforms: t,
            extraCommandProps: {
                viewport: this._viewport
            }
        }), this._scene = new $1d56c6a18dbfd30f$export$38af1803e3442a7f;
    }
    render(e, t) {
        this._resize(), this.renderer.clear({
            color: $1d56c6a18dbfd30f$var$ln,
            depth: 1,
            framebuffer: this._maskColorFbo
        }), this.renderer.clear({
            color: $1d56c6a18dbfd30f$var$ln,
            depth: 1,
            framebuffer: this._maskModeFbo
        }), this._scene.setMeshes(e);
        const n = {
            projViewMatrix: t
        };
        return this.renderer.render(this._maskColorShader, n, this._scene, this._maskColorFbo), this.renderer.render(this._maskModeShader, n, this._scene, this._maskModeFbo), {
            colorExtent: this._maskColorFbo,
            modeExtent: this._maskModeFbo
        };
    }
    _resize() {
        const e = $1d56c6a18dbfd30f$var$m(this._viewport.width) ? this._viewport.width() : this._viewport.width.data(), t = $1d56c6a18dbfd30f$var$m(this._viewport.height) ? this._viewport.height() : this._viewport.height.data();
        !this._maskColorFbo || this._maskColorFbo.width === e && this._maskColorFbo.height === t || (this._maskColorFbo.resize(e, t), this._maskModeFbo.resize(e, t));
    }
    dispose() {
        this._maskColorFbo && (this._maskColorFbo.destroy(), delete this._maskColorFbo), this._maskModeFbo && (this._maskModeFbo.destroy(), delete this._maskModeFbo), this._maskColorShader && (this._maskColorShader.dispose(), delete this._maskColorShader), this._maskModeShader && (this._maskModeShader.dispose(), delete this._maskModeShader);
    }
}
const $1d56c6a18dbfd30f$var$dn = [], $1d56c6a18dbfd30f$var$un = {
    width: 4,
    type: "float"
};
class $1d56c6a18dbfd30f$var$hn {
    constructor(e, t, n){
        this._regl = e, this.joints = t, this.inverseBindMatrices = [], this.jointMatrices = [], this.jointData = new Float32Array(16 * t.length);
        for(let e = 0; e < t.length; ++e)this.inverseBindMatrices.push(new Float32Array(n.buffer, n.byteOffset + 16 * Float32Array.BYTES_PER_ELEMENT * e, 16)), this.jointMatrices.push(new Float32Array(this.jointData.buffer, 16 * Float32Array.BYTES_PER_ELEMENT * e, 16));
        this.jointTextureSize = [
            4,
            6
        ];
    }
    update(t, n, r) {
        (0, $3iqbd).invert($1d56c6a18dbfd30f$var$dn, t);
        for(let t = 0; t < this.joints.length; ++t){
            const r = this.jointMatrices[t];
            (0, $3iqbd).multiply(r, $1d56c6a18dbfd30f$var$dn, n[this.joints[t].nodeIndex]), (0, $3iqbd).multiply(r, r, this.inverseBindMatrices[t]);
        }
        $1d56c6a18dbfd30f$var$un.height = this.joints.length, $1d56c6a18dbfd30f$var$un.data = this.jointData;
        const i = $1d56c6a18dbfd30f$var$un;
        return r ? r(i) : r = this._regl.texture(i), r;
    }
}
const $1d56c6a18dbfd30f$var$mn = [
    0,
    0,
    0
], $1d56c6a18dbfd30f$var$vn = [
    0,
    0,
    0,
    1
], $1d56c6a18dbfd30f$var$_n = [
    1,
    1,
    1
], $1d56c6a18dbfd30f$var$gn = [];
class $1d56c6a18dbfd30f$var$xn {
    constructor(e = [
        0,
        0,
        0
    ], t = [
        0,
        0,
        0,
        1
    ], n = [
        1,
        1,
        1
    ]){
        this.translation = e, this.rotation = t, this.scale = n;
    }
    getMatrix() {
        return (0, $3iqbd).fromRotationTranslationScale($1d56c6a18dbfd30f$var$gn, this.rotation, this.translation, this.scale);
    }
    decompose(t) {
        (0, $3iqbd).getTranslation(this.translation, t), (0, $3iqbd).getRotation(this.rotation, t), (0, $3iqbd).getScaling(this.scale, t);
    }
    update(e) {
        e && (e.translation && !(0, $eIStk).equals(e.translation, $1d56c6a18dbfd30f$var$mn) && (0, $eIStk).copy(this.translation, e.translation), e.rotation && !(0, $k1dpP).equals(e.rotation, $1d56c6a18dbfd30f$var$vn) && (0, $k1dpP).copy(this.rotation, e.rotation), e.scale && !(0, $eIStk).equals(e.scale, $1d56c6a18dbfd30f$var$_n) && (0, $eIStk).copy(this.scale, e.scale));
    }
}
class $1d56c6a18dbfd30f$var$pn {
    constructor(e){
        this._init(e);
    }
    _init(e) {
        this.bbox = e.bbox, this.geometry = e.geometry, this.nodeMatrix = e.nodeMatrix, this.materialInfo = e.materialInfo, this.extraInfo = e.extraInfo, this.animationMatrix = e.animationMatrix, this.morphWeights = e.morphWeights, this.skin = e.skin, this.nodeIndex = e.nodeIndex;
    }
    copyEdgeGeometry() {
        this.copyGeometry || (this.copyGeometry = this._copyEdgeGeometry(this.geometry));
    }
    createCopyBarycentric() {
        this.copyGeometry && !this.copyGeometry.data.aBarycentric && (this.copyGeometry.buildUniqueVertex(), this.copyGeometry.createBarycentric("aBarycentric"));
    }
    _copyEdgeGeometry(e) {
        const t = e.data, n = e.indices || e.elements, r = {};
        for(const n in t)if (n === e.desc.positionAttribute) {
            if ($1d56c6a18dbfd30f$var$p(t[n])) r[n] = t[n].slice();
            else if (t[n].buffer && t[n].buffer.destroy) r[n] = {
                buffer: t[n].buffer
            }, $1d56c6a18dbfd30f$var$p(t[n].array) && (r[n].array = t[n].array.slice());
            else {
                const t = e._getAttributeData(n);
                r[n] = n !== e.desc.positionAttribute ? t : t.slice();
            }
        }
        const i = void 0 !== n.length ? n.slice() : n, o = JSON.parse(JSON.stringify(e.desc)), a = new $1d56c6a18dbfd30f$export$269349b0cbfdd78c(r, i, 0, o);
        return a.properties = e.properties, a;
    }
}
let $1d56c6a18dbfd30f$var$bn = 0;
const $1d56c6a18dbfd30f$var$yn = [], $1d56c6a18dbfd30f$var$An = [];
class $1d56c6a18dbfd30f$var$Sn {
    constructor(e, t){
        this.gltf = e, this.regl = t, this.geometries = [], t && (this._emptyTexture = t.texture({
            width: 2,
            height: 2
        }));
    }
    getMeshesInfo() {
        if (!this.gltf) return null;
        if (this.geometries.length) return this.geometries;
        this._createTextures(this.gltf.textures), this._createSkins(this.gltf.skins);
        return this.gltf.scenes[0].nodes.forEach((e)=>{
            this._parserNode(e, this.geometries);
        }), this._checkBaseColorFactor(), this.geometries;
    }
    getGLTFBBox() {
        if (!this.gltf) return null;
        const e = this.geometries;
        if (!e || !e.length) return null;
        const t = [
            1 / 0,
            1 / 0,
            1 / 0
        ], n = [
            -1 / 0,
            -1 / 0,
            -1 / 0
        ];
        for(let r = 0; r < e.length; r++){
            const i = e[r].bbox, o = i.min, a = i.max;
            o[0] < t[0] && (t[0] = o[0]), o[1] < t[1] && (t[1] = o[1]), o[2] < t[2] && (t[2] = o[2]), a[0] > n[0] && (n[0] = a[0]), a[1] > n[1] && (n[1] = a[1]), a[2] > n[2] && (n[2] = a[2]);
        }
        return {
            min: t,
            max: n
        };
    }
    _createSkins(e) {
        if (e) {
            this._skinMap = {};
            for(let t = 0; t < e.length; t++){
                const n = e[t];
                n.joints = n.joints.map((e)=>this.gltf.nodes[e]), this._skinMap[t] = new $1d56c6a18dbfd30f$var$hn(this.regl, n.joints, n.inverseBindMatrices.array), delete n.inverseBindMatrices;
            }
        }
    }
    _createTextures(e) {
        if (e) {
            this._textureMap = {};
            for(let t = 0; t < e.length; t++){
                const n = e[t];
                this._textureMap[t] || (this._textureMap[t] = this._toTexture(n), delete n.image);
            }
        }
    }
    _checkBaseColorFactor() {
        if (!this._checkBaseColorFactorAlpha()) for(let e = 0; e < this.geometries.length; e++){
            const t = this.geometries[e].materialInfo.baseColorFactor;
            t && 0 === t[3] && (t[3] = 1);
        }
    }
    _checkBaseColorFactorAlpha() {
        for(let e = 0; e < this.geometries.length; e++){
            const t = this.geometries[e].materialInfo.baseColorFactor;
            if (t && t[3] > 0) return !0;
        }
        return !1;
    }
    dispose() {
        this._emptyTexture && this._emptyTexture.destroy();
        const e = this.getMeshesInfo();
        if (e) {
            e.forEach((e)=>{
                e.geometry.dispose();
                for(const t in e.materialInfo){
                    const n = e.materialInfo[t];
                    n && n.destroy && !n[$1d56c6a18dbfd30f$var$L] && n.destroy();
                }
            });
            for(const e in this._textureMap){
                const t = this._textureMap[e];
                t && t.destroy && !t[$1d56c6a18dbfd30f$var$L] && t.destroy();
            }
            delete this.gltf;
        }
    }
    updateAnimation(e, t, n, r, i, o, a, s) {
        const c = this.gltf;
        if (!c) return;
        const l = $1d56c6a18dbfd30f$var$f();
        if ($1d56c6a18dbfd30f$var$bn = c.animations ? l.GLTFLoader.getAnimationTimeSpan(c, r) : null, !$1d56c6a18dbfd30f$var$bn) return;
        e -= i;
        let d = 0;
        d = t || !t && this._isFirstLoop(e, n, r, i) ? e * n * .001 % ($1d56c6a18dbfd30f$var$bn.max - $1d56c6a18dbfd30f$var$bn.min) + $1d56c6a18dbfd30f$var$bn.min : e * n * .001 + $1d56c6a18dbfd30f$var$bn.min, c.scenes[0].nodes.forEach((e)=>{
            this._updateNodeMatrix(r, d, e, null, o, s);
        });
        for(const e in this.gltf.nodes){
            const t = this.gltf.nodes[e], n = o[t.nodeIndex];
            if (t.skin && n) {
                const e = t.skin.update(n, o, a[t.nodeIndex] && a[t.nodeIndex].jointTexture);
                a[t.nodeIndex] || (a[t.nodeIndex] = {
                    jointTextureSize: t.skin.jointTextureSize,
                    numJoints: t.skin.joints.length
                }), a[t.nodeIndex].jointTexture = e;
            }
        }
    }
    _isFirstLoop(e, t, n, r) {
        const i = this.gltf;
        if (!r || !i) return !0;
        const o = $1d56c6a18dbfd30f$var$f();
        return $1d56c6a18dbfd30f$var$bn = i.animations ? o.GLTFLoader.getAnimationTimeSpan(i, n) : null, e * t * .001 / ($1d56c6a18dbfd30f$var$bn.max - $1d56c6a18dbfd30f$var$bn.min) < 1;
    }
    hasSkinAnimation() {
        return !!this._isAnimation;
    }
    _updateNodeMatrix(t, n, r, i, o, a) {
        r.trs && (a ? a.indexOf(Number(r.nodeIndex)) > -1 && this._updateNodeTRS(r, n, t) : this._updateNodeTRS(r, n, t)), o[r.nodeIndex] = i ? (0, $3iqbd).multiply(o[r.nodeIndex] || [], i, r.matrix || r.trs.getMatrix()) : (0, $3iqbd).copy(o[r.nodeIndex] || [], r.matrix || r.trs.getMatrix()), r.children && r.children.forEach((e)=>{
            this._updateNodeMatrix(t, n, e, o[r.nodeIndex], o, a);
        });
    }
    _updateNodeTRS(e, t, n) {
        const r = $1d56c6a18dbfd30f$var$f().GLTFLoader.getAnimationClip(this.gltf, Number(e.nodeIndex), t, n);
        r.weights && this._updateMorph(e, r.weights), e.trs.update(r);
    }
    _updateMorph(e, t) {
        const n = t.length;
        if (!e.influencesList) {
            e.influencesList = [];
            for(let t = 0; t < n; t++)e.influencesList[t] = [
                t,
                0
            ];
        }
        const r = e.influencesList;
        for(let e = 0; e < r.length; e++){
            const n = r[e];
            n[0] = e, n[1] = t[e];
        }
        r.sort($1d56c6a18dbfd30f$var$Mn);
        const i = [];
        for(let e = 0; e < 8; e++)i[e] = [
            e,
            0
        ];
        for(let e = 0; e < 8; e++)e < n && r[e][1] ? (i[e][0] = r[e][0], i[e][1] = r[e][1]) : (i[e][0] = Number.MAX_SAFE_INTEGER, i[e][1] = 0);
        i.sort($1d56c6a18dbfd30f$var$Tn);
        e.geometries.forEach((e)=>{
            const t = e.properties.morphTargets;
            for(let n = 0; n < 8; n++){
                const r = i[n], o = r[0], a = r[1];
                o !== Number.MAX_SAFE_INTEGER && a ? (e.updateData("POSITION" + n, t["POSITION_" + o].array), e.properties.morphWeights[n] = a) : e.properties.morphWeights[n] = 0;
            }
        });
    }
    _parserNode(t, n, r) {
        if (t.isParsed) return;
        t.nodeMatrix = t.nodeMatrix || (0, $3iqbd).identity([]), t.localMatrix = t.localMatrix || (0, $3iqbd).identity([]), t.matrix ? (t.trs = new $1d56c6a18dbfd30f$var$xn, t.trs.decompose(t.matrix)) : t.trs = new $1d56c6a18dbfd30f$var$xn(t.translation, t.rotation, t.scale), t.localMatrix = t.trs.getMatrix(), r ? (0, $3iqbd).multiply(t.nodeMatrix, r, t.matrix || t.localMatrix) : (0, $3iqbd).copy(t.nodeMatrix, t.matrix || t.localMatrix);
        const i = t.nodeMatrix;
        if (t.children) for(let e = 0; e < t.children.length; e++)this._parserNode(t.children[e], n, i);
        if ($1d56c6a18dbfd30f$var$h(t.skin)) {
            this._isAnimation = !0;
            const e = t.skin;
            t.trs = new $1d56c6a18dbfd30f$var$xn, t.skin = this._skinMap[e];
        }
        if ($1d56c6a18dbfd30f$var$h(t.mesh)) t.mesh = this.gltf.meshes[t.mesh], t.mesh.node = t, t.geometries = t.geometries || [], t.mesh.primitives.forEach((r)=>{
            const o = this._createMaterialInfo(r.material), a = function(e, t, n) {
                const r = e.attributes, i = r.COLOR_0;
                if (i && i.array instanceof Float32Array) {
                    const e = new Uint8Array(i.array.length);
                    for(let t = 0; t < e.length; t++)e[t] = Math.round(255 * i.array[t]);
                    i.array = e;
                } else if (i && (i.array instanceof Uint16Array || i.array instanceof Int16Array || i.array instanceof Uint32Array || i.array instanceof Int32Array)) {
                    const e = new Uint8Array(i.array);
                    i.array = e;
                }
                n && r.TEXCOORD_0 && !r.TEXCOORD_0 && (r.TEXCOORD_1 = r.TEXCOORD_0);
                const o = {};
                for(const e in r)o[e] = $1d56c6a18dbfd30f$var$v({}, r[e]), t && (o[e].buffer = $1d56c6a18dbfd30f$var$he(t, r[e], {
                    dimension: r[e].itemSize
                }));
                if (e.morphTargets) {
                    const e = $1d56c6a18dbfd30f$var$P(o.POSITION) ? o.POSITION.itemSize * o.POSITION.count : o.POSITION.array.length;
                    for(let t = 0; t < 8; t++)o[`POSITION${t}`] || (o[`POSITION${t}`] = new Float32Array(e).fill(0));
                    for(let e = 0; e < 4; e++)o[`NORMAL${e}`] || (o[`NORMAL${e}`] = new Float32Array(o.NORMAL.array ? o.NORMAL.array.length : o.NORMAL.length).fill(0));
                }
                let a = e.indices;
                a && void 0 === a.bufferView && a.array && (a = a.array);
                const s = new $1d56c6a18dbfd30f$export$2db6c17465f94a2(o, a, 0, {
                    primitive: $1d56c6a18dbfd30f$var$g(e.mode) ? $1d56c6a18dbfd30f$var$ee(e.mode) : e.mode,
                    positionAttribute: "POSITION",
                    normalAttribute: "NORMAL",
                    uv0Attribute: "TEXCOORD_0",
                    uv1Attribute: "TEXCOORD_1",
                    color0Attribute: "COLOR_0"
                });
                e.morphTargets && (s.properties.morphWeights = []);
                e.mode > 3 && !s.data.NORMAL && s.createNormal("NORMAL");
                return s;
            }(r, this.regl, o.occlusionTexture);
            a.properties.morphTargets = r.morphTargets, t.geometries.push(a);
            let s = a.boundingBox.copy();
            s = s.transform((0, $3iqbd).identity($1d56c6a18dbfd30f$var$yn), i);
            const c = {
                geometry: a,
                bbox: s,
                nodeMatrix: i,
                materialInfo: o,
                extraInfo: this._createExtralInfo(r.material),
                animationMatrix: t.trs.getMatrix(),
                morphWeights: t.weights,
                nodeIndex: t.nodeIndex
            };
            t.skin && (c.skin = {
                jointTextureSize: [
                    4,
                    6
                ],
                numJoints: t.skin.joints.length,
                jointTexture: t.skin.jointTexture
            });
            const l = new $1d56c6a18dbfd30f$var$pn(c);
            n.push(l);
        });
        t.isParsed = !0;
    }
    _createMaterialInfo(e) {
        const t = {};
        if (this.gltf.materials && this.gltf.materials[e]) {
            const n = this.gltf.materials[e], r = n.pbrMetallicRoughness;
            if (r) {
                const e = r.metallicRoughnessTexture, n = r.baseColorTexture;
                n && (t.baseColorTexture = this._getTexture(n), n.KHR_texture_transform && (t.khr_offset = n.KHR_texture_transform.offset || [
                    0,
                    0
                ], t.khr_rotation = n.KHR_texture_transform.rotation || 0, t.khr_scale = n.KHR_texture_transform.scale || [
                    1,
                    1
                ])), r.baseColorFactor && (t.baseColorFactor = r.baseColorFactor), e ? t.metallicRoughnessTexture = this._getTexture(e) : (t.metallicFactor = $1d56c6a18dbfd30f$var$h(r.metallicFactor) ? r.metallicFactor : 1, t.roughnessFactor = $1d56c6a18dbfd30f$var$h(r.roughnessFactor) ? r.roughnessFactor : 1);
            }
            const i = n.extensions;
            if (i && i.KHR_materials_pbrSpecularGlossiness) {
                const e = i.KHR_materials_pbrSpecularGlossiness;
                t.name = "pbrSpecularGlossiness";
                for(const n in e)t[n] = $1d56c6a18dbfd30f$var$h(e[n].index) ? this._getTexture(e[n]) : e[n];
            }
            n.normalTexture && (t.normalTexture = this._getTexture(n.normalTexture)), n.occlusionTexture && (t.occlusionTexture = this._getTexture(n.occlusionTexture)), n.emissiveTexture && (t.emissiveTexture = this._getTexture(n.emissiveTexture)), n.emissiveFactor && (t.emissiveFactor = n.emissiveFactor), t.alphaCutoff = n.alphaCutoff || .5, t.doubleSided = n.doubleSided, t.alphaMode = n.alphaMode || "OPAQUE";
        }
        return t;
    }
    _createExtralInfo(e) {
        const t = {};
        if (this.gltf.materials && this.gltf.materials[e]) {
            const n = this.gltf.materials[e];
            t.doubleSided = n.doubleSided, t.alphaMode = n.alphaMode || "OPAQUE";
        }
        return t;
    }
    _getTexture(e) {
        const t = e.extensions, n = e.index;
        if (!$1d56c6a18dbfd30f$var$h(n)) return null;
        t && t.KHR_texture_transform && (e.KHR_texture_transform = t.KHR_texture_transform);
        const r = this._textureMap[n];
        return r.texInfo = e, r;
    }
    _toTexture(e) {
        if (!e) return this._emptyTexture;
        const t = e.sampler || {};
        return new $1d56c6a18dbfd30f$export$d7f9130fd509486({
            width: e.image.width,
            height: e.image.height,
            data: e.image.array,
            mag: $1d56c6a18dbfd30f$var$ae(t.magFilter) || "linear",
            min: $1d56c6a18dbfd30f$var$ce(t.minFilter) || "linear mipmap linear",
            wrapS: $1d56c6a18dbfd30f$var$fe(t.wrapS) || "repeat",
            wrapT: $1d56c6a18dbfd30f$var$fe(t.wrapT) || "repeat"
        });
    }
    arrangeAlongLine(e, t, n, r, i, o) {
        const a = [], s = this._getRotationZ(e, t), c = (e.z || 0) - (t.z || 0), l = this._getRotationXY(n, c);
        let f = this._calBoxWidth(r, o);
        f /= i;
        const d = Math.sqrt(n * n + c * c), u = Math.floor(d / f);
        if (u >= 1) {
            for(let n = 1; n <= u; n++){
                const r = f * (n - .5) / d, i = {
                    coordinates: $1d56c6a18dbfd30f$var$On(e, t, r),
                    t: r,
                    scale: [
                        1,
                        1,
                        1
                    ],
                    rotation: [
                        0,
                        0,
                        s
                    ],
                    rotationZ: s,
                    rotationXY: l
                };
                a.push(i);
            }
            if (o.scaleVertex) {
                const n = (f * u + (d - f * u) / 2) / d, r = (d - f * u) / f, i = {
                    coordinates: $1d56c6a18dbfd30f$var$On(e, t, n),
                    t: n,
                    scale: [
                        r,
                        1,
                        1
                    ],
                    rotation: [
                        0,
                        0,
                        s
                    ],
                    rotationZ: s,
                    rotationXY: l
                };
                a.push(i);
            }
        } else if (o.scaleVertex) {
            const n = d / f, r = {
                coordinates: $1d56c6a18dbfd30f$var$On(e, t, .5),
                t: .5,
                scale: [
                    n,
                    1,
                    1
                ],
                rotation: [
                    0,
                    0,
                    s
                ],
                rotationZ: s,
                rotationXY: l
            };
            a.push(r);
        }
        return a;
    }
    calModelHeightScale(e, n) {
        const r = this.getGLTFBBox(), i = n / Math.abs(r.max[1] - r.min[1]);
        return (0, $eIStk).set(e, i, i, i);
    }
    _calBoxWidth(e, n) {
        const r = this.getGLTFBBox(), i = n.direction || 0, o = (0, $eIStk).sub($1d56c6a18dbfd30f$var$An, r.max, r.min);
        (0, $eIStk).multiply(o, o, e);
        return o[i] + n.gapLength;
    }
    _getRotationZ(e, t) {
        return Math.atan2(e.y - t.y, e.x - t.x) / Math.PI * 180;
    }
    _getRotationXY(e, t) {
        return 180 * Math.atan(t / e) / Math.PI;
    }
}
function $1d56c6a18dbfd30f$var$Tn(e, t) {
    return e[0] - t[0];
}
function $1d56c6a18dbfd30f$var$Mn(e, t) {
    return Math.abs(t[1]) - Math.abs(e[1]);
}
function $1d56c6a18dbfd30f$var$On(e, t, n) {
    const r = $1d56c6a18dbfd30f$var$Cn(e.x, t.x, n), i = $1d56c6a18dbfd30f$var$Cn(e.y, t.y, n), o = $1d56c6a18dbfd30f$var$Cn(e.z || 0, t.z || 0, n);
    return new e.constructor(r, i, o);
}
function $1d56c6a18dbfd30f$var$Cn(e, t, n) {
    return e + n * (t - e);
}
function $1d56c6a18dbfd30f$var$En(e, t) {
    const { Ajax: n } = $1d56c6a18dbfd30f$var$f(), { fetchOptions: r, gltfLoaderOptions: i, urlModifier: o } = t, a = i || {};
    a.urlModifier = o;
    const s = e.lastIndexOf("/"), c = e.slice(0, s), l = e.slice(e.lastIndexOf(".")).toLowerCase();
    return ".gltf" === l ? n.getJSON(e, r, o).then((e)=>$1d56c6a18dbfd30f$var$wn(c, e, a)) : ".glb" === l ? n.getArrayBuffer(e, r, o).then((e)=>$1d56c6a18dbfd30f$var$wn(c, {
            buffer: e.data,
            byteOffset: 0
        }, a)) : null;
}
function $1d56c6a18dbfd30f$var$Pn(e, t) {
    return new $1d56c6a18dbfd30f$var$Sn(e, t);
}
function $1d56c6a18dbfd30f$var$wn(e, t, n) {
    const { GLTFLoader: r } = $1d56c6a18dbfd30f$var$f();
    return new r(e, t, n).load();
}
var $1d56c6a18dbfd30f$export$79ec47965c44651a = Object.freeze({
    __proto__: null,
    exportGLTFPack: $1d56c6a18dbfd30f$var$Pn,
    load: $1d56c6a18dbfd30f$var$En,
    loadGLTF: $1d56c6a18dbfd30f$var$wn
});
const $1d56c6a18dbfd30f$var$Rn = [
    -1,
    0,
    -1,
    1,
    0,
    -1,
    -1,
    0,
    1,
    1,
    0,
    1
], $1d56c6a18dbfd30f$var$Hn = [
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    1,
    0
], $1d56c6a18dbfd30f$var$Dn = [
    3,
    1,
    0,
    0,
    2,
    3
], $1d56c6a18dbfd30f$var$Fn = [
    0,
    0,
    1,
    0,
    0,
    1,
    1,
    1
], $1d56c6a18dbfd30f$var$Nn = {
    vertices: [
        -0.8111000061035156,
        2.0102999210357666,
        -0.8111000061035156,
        0,
        .010300000198185444,
        -0,
        -0.8111000061035156,
        2.0102999210357666,
        .8111000061035156,
        -0.8111000061035156,
        2.0102999210357666,
        .8111000061035156,
        0,
        .010300000198185444,
        -0,
        .8111000061035156,
        2.0102999210357666,
        .8111000061035156,
        .8111000061035156,
        2.0102999210357666,
        .8111000061035156,
        0,
        .010300000198185444,
        -0,
        .8111000061035156,
        2.0102999210357666,
        -0.8111000061035156,
        .8111000061035156,
        2.0102999210357666,
        -0.8111000061035156,
        0,
        .010300000198185444,
        -0,
        -0.8111000061035156,
        2.0102999210357666,
        -0.8111000061035156,
        .8111000061035156,
        2.0102999210357666,
        -0.8111000061035156,
        -0.8111000061035156,
        2.0102999210357666,
        -0.8111000061035156,
        0,
        2.9419000148773193,
        -0,
        .8111000061035156,
        2.0102999210357666,
        .8111000061035156,
        .8111000061035156,
        2.0102999210357666,
        -0.8111000061035156,
        0,
        2.9419000148773193,
        -0,
        -0.8111000061035156,
        2.0102999210357666,
        -0.8111000061035156,
        -0.8111000061035156,
        2.0102999210357666,
        .8111000061035156,
        0,
        2.9419000148773193,
        -0,
        -0.8111000061035156,
        2.0102999210357666,
        .8111000061035156,
        .8111000061035156,
        2.0102999210357666,
        .8111000061035156,
        0,
        2.9419000148773193,
        -0
    ],
    normals: [
        -0.9267006516456604,
        -0.3758002817630768,
        -0,
        -0.9267006516456604,
        -0.3758002817630768,
        -0,
        -0.9267006516456604,
        -0.3758002817630768,
        -0,
        0,
        -0.3758002817630768,
        .9267006516456604,
        0,
        -0.3758002817630768,
        .9267006516456604,
        0,
        -0.3758002817630768,
        .9267006516456604,
        .9267006516456604,
        -0.3758002817630768,
        -0,
        .9267006516456604,
        -0.3758002817630768,
        -0,
        .9267006516456604,
        -0.3758002817630768,
        -0,
        0,
        -0.3758002817630768,
        -0.9267006516456604,
        0,
        -0.3758002817630768,
        -0.9267006516456604,
        0,
        -0.3758002817630768,
        -0.9267006516456604,
        0,
        .656676173210144,
        -0.7541726231575012,
        0,
        .656676173210144,
        -0.7541726231575012,
        0,
        .656676173210144,
        -0.7541726231575012,
        .7541726231575012,
        .656676173210144,
        -0,
        .7541726231575012,
        .656676173210144,
        -0,
        .7541726231575012,
        .656676173210144,
        -0,
        -0.7541726231575012,
        .656676173210144,
        -0,
        -0.7541726231575012,
        .656676173210144,
        -0,
        -0.7541726231575012,
        .656676173210144,
        -0,
        0,
        .656676173210144,
        .7541726231575012,
        0,
        .656676173210144,
        .7541726231575012,
        0,
        .656676173210144,
        .7541726231575012
    ],
    indices: [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23
    ]
}, $1d56c6a18dbfd30f$var$Ln = [
    "cube",
    "plane",
    "pyramid"
], $1d56c6a18dbfd30f$var$kn = {
    cube: {
        meshes: [
            {
                primitives: [
                    {
                        attributes: {
                            POSITION: {
                                array: new Int8Array([
                                    1,
                                    1,
                                    1,
                                    -1,
                                    1,
                                    1,
                                    -1,
                                    -1,
                                    1,
                                    1,
                                    -1,
                                    1,
                                    1,
                                    1,
                                    1,
                                    1,
                                    -1,
                                    1,
                                    1,
                                    -1,
                                    -1,
                                    1,
                                    1,
                                    -1,
                                    1,
                                    1,
                                    1,
                                    1,
                                    1,
                                    -1,
                                    -1,
                                    1,
                                    -1,
                                    -1,
                                    1,
                                    1,
                                    -1,
                                    1,
                                    1,
                                    -1,
                                    1,
                                    -1,
                                    -1,
                                    -1,
                                    -1,
                                    -1,
                                    -1,
                                    1,
                                    -1,
                                    -1,
                                    -1,
                                    1,
                                    -1,
                                    -1,
                                    1,
                                    -1,
                                    1,
                                    -1,
                                    -1,
                                    1,
                                    1,
                                    -1,
                                    -1,
                                    -1,
                                    -1,
                                    -1,
                                    -1,
                                    1,
                                    -1,
                                    1,
                                    1,
                                    -1
                                ])
                            },
                            NORMAL: {
                                array: new Int8Array([
                                    0,
                                    0,
                                    1,
                                    0,
                                    0,
                                    1,
                                    0,
                                    0,
                                    1,
                                    0,
                                    0,
                                    1,
                                    1,
                                    0,
                                    0,
                                    1,
                                    0,
                                    0,
                                    1,
                                    0,
                                    0,
                                    1,
                                    0,
                                    0,
                                    0,
                                    1,
                                    0,
                                    0,
                                    1,
                                    0,
                                    0,
                                    1,
                                    0,
                                    0,
                                    1,
                                    0,
                                    -1,
                                    0,
                                    0,
                                    -1,
                                    0,
                                    0,
                                    -1,
                                    0,
                                    0,
                                    -1,
                                    0,
                                    0,
                                    0,
                                    -1,
                                    0,
                                    0,
                                    -1,
                                    0,
                                    0,
                                    -1,
                                    0,
                                    0,
                                    -1,
                                    0,
                                    0,
                                    0,
                                    -1,
                                    0,
                                    0,
                                    -1,
                                    0,
                                    0,
                                    -1,
                                    0,
                                    0,
                                    -1
                                ])
                            },
                            TEXCOORD_0: {
                                array: new Int8Array([
                                    0,
                                    0,
                                    1,
                                    0,
                                    0,
                                    1,
                                    1,
                                    1,
                                    0,
                                    0,
                                    1,
                                    0,
                                    0,
                                    1,
                                    1,
                                    1,
                                    0,
                                    0,
                                    1,
                                    0,
                                    0,
                                    1,
                                    1,
                                    1,
                                    0,
                                    0,
                                    1,
                                    0,
                                    0,
                                    1,
                                    1,
                                    1,
                                    0,
                                    0,
                                    1,
                                    0,
                                    0,
                                    1,
                                    1,
                                    1,
                                    0,
                                    0,
                                    1,
                                    0,
                                    0,
                                    1,
                                    1,
                                    1
                                ])
                            }
                        },
                        indices: new Uint16Array([
                            0,
                            1,
                            2,
                            0,
                            2,
                            3,
                            4,
                            5,
                            6,
                            4,
                            6,
                            7,
                            8,
                            9,
                            10,
                            8,
                            10,
                            11,
                            12,
                            13,
                            14,
                            12,
                            14,
                            15,
                            16,
                            17,
                            18,
                            16,
                            18,
                            19,
                            20,
                            21,
                            22,
                            20,
                            22,
                            23
                        ]),
                        mode: 4
                    }
                ]
            }
        ],
        scenes: [
            {
                nodes: [
                    {
                        mesh: 0,
                        scale: [
                            60,
                            60,
                            60
                        ]
                    }
                ]
            }
        ]
    },
    "plane-cube": {
        meshes: [
            {
                primitives: [
                    {
                        attributes: {
                            POSITION: {
                                array: new Int8Array($1d56c6a18dbfd30f$var$Rn)
                            },
                            TEXCOORD_0: {
                                array: new Int8Array($1d56c6a18dbfd30f$var$Fn)
                            }
                        },
                        indices: new Uint16Array($1d56c6a18dbfd30f$var$Dn),
                        mode: 4
                    }
                ]
            }
        ],
        scenes: [
            {
                nodes: [
                    {
                        mesh: 0,
                        scale: [
                            60,
                            60,
                            60
                        ],
                        translation: [
                            0,
                            -60,
                            0
                        ]
                    },
                    {
                        mesh: 0,
                        scale: [
                            60,
                            60,
                            60
                        ],
                        translation: [
                            0,
                            60,
                            0
                        ]
                    },
                    {
                        mesh: 0,
                        scale: [
                            60,
                            60,
                            60
                        ],
                        translation: [
                            60,
                            0,
                            0
                        ],
                        rotation: [
                            0,
                            0,
                            .7071067811865475,
                            .7071067811865476
                        ]
                    },
                    {
                        mesh: 0,
                        scale: [
                            60,
                            60,
                            60
                        ],
                        translation: [
                            -60,
                            0,
                            0
                        ],
                        rotation: [
                            0,
                            0,
                            .7071067811865475,
                            .7071067811865476
                        ]
                    },
                    {
                        mesh: 0,
                        scale: [
                            60,
                            60,
                            60
                        ],
                        translation: [
                            0,
                            0,
                            60
                        ],
                        rotation: [
                            .7071067811865475,
                            0,
                            0,
                            .7071067811865476
                        ]
                    },
                    {
                        mesh: 0,
                        scale: [
                            60,
                            60,
                            60
                        ],
                        translation: [
                            0,
                            0,
                            -60
                        ],
                        rotation: [
                            .7071067811865475,
                            0,
                            0,
                            .7071067811865476
                        ]
                    }
                ]
            }
        ]
    },
    plane: {
        meshes: [
            {
                primitives: [
                    {
                        attributes: {
                            POSITION: {
                                array: new Int8Array($1d56c6a18dbfd30f$var$Rn)
                            },
                            NORMAL: {
                                array: new Int8Array($1d56c6a18dbfd30f$var$Hn)
                            },
                            TEXCOORD_0: {
                                array: new Int8Array($1d56c6a18dbfd30f$var$Fn)
                            }
                        },
                        indices: new Uint16Array($1d56c6a18dbfd30f$var$Dn),
                        mode: 4
                    }
                ]
            }
        ],
        scenes: [
            {
                nodes: [
                    {
                        mesh: 0,
                        scale: [
                            60,
                            60,
                            60
                        ]
                    }
                ]
            }
        ]
    },
    pyramid: {
        meshes: [
            {
                primitives: [
                    {
                        attributes: {
                            POSITION: {
                                array: new Float32Array($1d56c6a18dbfd30f$var$Nn.vertices)
                            },
                            NORMAL: {
                                array: new Float32Array($1d56c6a18dbfd30f$var$Nn.normals)
                            },
                            TEXCOORD_0: {
                                array: new Float32Array($1d56c6a18dbfd30f$var$Nn.uv)
                            }
                        },
                        indices: new Uint16Array($1d56c6a18dbfd30f$var$Nn.indices),
                        mode: 4
                    }
                ]
            }
        ],
        scenes: [
            {
                nodes: [
                    {
                        mesh: 0,
                        scale: [
                            60,
                            60,
                            60
                        ]
                    }
                ]
            }
        ]
    }
};
class $1d56c6a18dbfd30f$export$531420000793a6a1 {
    constructor(e, t){
        this.regl = e, this.resourceMap = {}, this.options = t || {};
    }
    getGLTF(e) {
        return this.resourceMap[e];
    }
    loginGLTF(e, t) {
        if (this.resourceMap[e]) this.resourceMap[e].refCount += 1;
        else {
            if ($1d56c6a18dbfd30f$var$kn[e]) {
                const t = function(e) {
                    let t = null;
                    return $1d56c6a18dbfd30f$var$kn[e] && (t = {
                        meshes: $1d56c6a18dbfd30f$var$kn[e].meshes
                    }, t.scenes = JSON.parse(JSON.stringify($1d56c6a18dbfd30f$var$kn[e].scenes))), t;
                }(e);
                this.resourceMap[e] = this._exportGLTFResource(t, e, !1);
            } else this.resourceMap[e] = t ? t(e).then((t)=>(this.resourceMap[e] = this._exportGLTFResource(t, e), this.resourceMap[e])) : this._loadGLTFModel(e);
            this.resourceMap[e].refCount = 1;
        }
    }
    logoutGLTF(e) {
        if (this.resourceMap[e] && (this.resourceMap[e].refCount -= 1, this.resourceMap[e].refCount < 1)) {
            const t = this.resourceMap[e].resources;
            if (t) for(let e = 0; e < t.length; e++)t[e].geometry.dispose(), t[e].copyGeometry && t[e].copyGeometry.dispose(), t[e].material && t[e].material.dispose();
            this.resourceMap[e].gltfPack && this.resourceMap[e].gltfPack.dispose(), delete this.resourceMap[e];
        }
    }
    isSimpleModel(e) {
        return $1d56c6a18dbfd30f$var$kn[e];
    }
    addSimpleModel(e, t) {
        !function(e, t) {
            "string" == typeof e && $1d56c6a18dbfd30f$var$Ln.indexOf(e) < 0 && ($1d56c6a18dbfd30f$var$kn[e] = t);
        }(e, t);
    }
    removeSimpleModel(e) {
        delete $1d56c6a18dbfd30f$var$kn[e];
    }
    _exportGLTFResource(e, t, n = !0) {
        if (!e) return null;
        const r = $1d56c6a18dbfd30f$var$Pn(e, n ? this.regl : null), i = r.getMeshesInfo();
        return {
            bbox: r.getGLTFBBox(),
            gltfPack: r,
            resources: i,
            json: e.json,
            refCount: this.resourceMap[t] ? this.resourceMap[t].refCount : 0
        };
    }
    fetchGLTF(e) {
        return $1d56c6a18dbfd30f$var$En(e, this.options).then((e)=>e);
    }
    _loadGLTFModel(e) {
        return this.fetchGLTF(e).then((t)=>(this.resourceMap[e] = this._exportGLTFResource(t, e), this.resourceMap[e]));
    }
}
const $1d56c6a18dbfd30f$var$zn = function() {
    const t = [
        0,
        0,
        0
    ], n = 90 * Math.PI / 180, r = [
        0,
        0,
        0,
        0
    ], i = new Array(16);
    return function(o, a, s, c, l, f) {
        const d = [
            (0, $3iqbd).lookAt([], t, [
                1,
                0,
                0
            ], f && f[0] || [
                0,
                -1,
                0
            ]),
            (0, $3iqbd).lookAt([], t, [
                -1,
                0,
                0
            ], f && f[1] || [
                0,
                -1,
                0
            ]),
            (0, $3iqbd).lookAt([], t, [
                0,
                1,
                0
            ], f && f[2] || [
                0,
                0,
                1
            ]),
            (0, $3iqbd).lookAt([], t, [
                0,
                -1,
                0
            ], f && f[3] || [
                0,
                0,
                -1
            ]),
            (0, $3iqbd).lookAt([], t, [
                0,
                0,
                1
            ], f && f[4] || [
                0,
                -1,
                0
            ]),
            (0, $3iqbd).lookAt([], t, [
                0,
                0,
                -1
            ], f && f[5] || [
                0,
                -1,
                0
            ])
        ], u = {
            context: {
                viewMatrix: function(e, t, n) {
                    return d[n];
                },
                projMatrix: (0, $3iqbd).perspective(i, n, 1, .5, 1.1)
            }
        };
        a && (u.framebuffer = a.faces ? function(e, t, n) {
            return a.faces[n];
        } : a);
        return o(u)(6, (e, t, n)=>{
            const i = {
                color: r,
                depth: 1
            };
            a && (i.framebuffer = a.faces ? a.faces[n] : a), o.clear(i), s(c), l && l();
        }), a;
    };
}();
var $1d56c6a18dbfd30f$var$Gn = {
    vertices: [
        1,
        1,
        1,
        -1,
        1,
        1,
        -1,
        -1,
        1,
        1,
        -1,
        1,
        1,
        1,
        1,
        1,
        -1,
        1,
        1,
        -1,
        -1,
        1,
        1,
        -1,
        1,
        1,
        1,
        1,
        1,
        -1,
        -1,
        1,
        -1,
        -1,
        1,
        1,
        -1,
        1,
        1,
        -1,
        1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        1,
        -1,
        -1,
        -1,
        1,
        -1,
        -1,
        1,
        -1,
        1,
        -1,
        -1,
        1,
        1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        1,
        -1,
        1,
        1,
        -1
    ],
    textures: [
        1,
        1,
        0,
        1,
        0,
        0,
        1,
        0,
        1,
        1,
        0,
        1,
        0,
        0,
        1,
        0,
        1,
        1,
        0,
        1,
        0,
        0,
        1,
        0,
        1,
        1,
        0,
        1,
        0,
        0,
        1,
        0,
        1,
        1,
        0,
        1,
        0,
        0,
        1,
        0,
        1,
        1,
        0,
        1,
        0,
        0,
        1,
        0
    ],
    indices: [
        0,
        1,
        2,
        0,
        2,
        3,
        4,
        5,
        6,
        4,
        6,
        7,
        8,
        9,
        10,
        8,
        10,
        11,
        12,
        13,
        14,
        12,
        14,
        15,
        16,
        17,
        18,
        16,
        18,
        19,
        20,
        21,
        22,
        20,
        22,
        23
    ]
}, $1d56c6a18dbfd30f$var$Vn = "#define SHADER_NAME CUBE_MAP\nattribute vec3 aPosition;\nvarying vec3 vWorldPos;\nuniform mat4 projMatrix;\nuniform mat4 viewMatrix;\nvoid main() {\n  vWorldPos = aPosition;\n  gl_Position = projMatrix * viewMatrix * vec4(vWorldPos, 1.);\n}", $1d56c6a18dbfd30f$var$Un = "#define SHADER_NAME CUBEMAP\nprecision highp float;\nuniform samplerCube cubeMap;\nuniform float exposure;\nvarying vec3 vWorldPos;\n#ifdef ENCODE_RGBM\nvec4 c(const in vec3 d, const in float e) {\n  if(e <= .0)\n    return vec4(d, 1.);\n  vec4 f;\n  vec3 h = d / e;\n  f.a = clamp(max(max(h.r, h.g), max(h.b, 1e-6)), .0, 1.);\n  f.a = ceil(f.a * 255.) / 255.;\n  f.rgb = h / f.a;\n  return f;\n}\n#endif\nvoid main() {\n  vec4 i = textureCube(cubeMap, vWorldPos);\n  i.rgb *= exposure;\n#ifdef ENCODE_RGBM\ni = c(i.rgb, 7.);\n#endif\n#if __VERSION__ == 100\ngl_FragColor = i;\n#endif\n}", $1d56c6a18dbfd30f$var$jn = "precision highp float;\n#define PI 3.1415926\nvarying vec3 vWorldPos;\nuniform sampler2D equirectangularMap;\nconst vec2 c = vec2(.1591, .3183);\nvec2 d(vec3 e) {\n  vec2 f = vec2(atan(e.y, e.x), asin(e.z));\n  f *= c;\n  f += .5;\n  return f;\n}\nvoid main() {\n  vec2 f = d(normalize(vWorldPos));\n  vec4 h = texture2D(equirectangularMap, f);\n  gl_FragColor = vec4(h.rgb, 1.);\n}", $1d56c6a18dbfd30f$var$Xn = "#define SHADER_NAME PBR_prefilter\nprecision highp float;\nvarying vec3 vWorldPos;\nuniform samplerCube environmentMap;\nuniform sampler2D distributionMap;\nuniform float roughness;\nuniform float resolution;\nconst float c = 3.14159265359;\nfloat d(vec3 e, vec3 f, float h) {\n  float a = h * h;\n  float i = a * a;\n  float j = max(dot(e, f), .0);\n  float k = j * j;\n  float l = i;\n  float m = (k * (i - 1.) + 1.);\n  m = c * m * m;\n  return l / m;\n}\nvec3 n(float o, vec3 e, float h) {\n  vec4 u = texture2D(distributionMap, vec2(h, o));\n  vec3 f = u.xyz;\n  float v = sign(u.w - .5);\n  float A = sign(u.w - 200.0 / 255. * clamp(v, .0, 1.) - .15);\n  f.x *= v;\n  f.y *= A;\n  vec3 B = abs(e.z) < .999 ? vec3(.0, .0, 1.) : vec3(1., .0, .0);\n  vec3 C = normalize(cross(B, e));\n  vec3 D = cross(e, C);\n  vec3 E = C * f.x + D * f.y + e * f.z;\n  return normalize(E);\n}\nvoid main() {\n  vec3 e = normalize(vWorldPos);\n  vec3 F = e;\n  vec3 G = F;\n  const int I = 1024;\n  vec3 J = vec3(.0);\n  float K = .0;\n  for(int L = 0; L < I; ++L) {\n    vec3 f = n(float(L) / float(I), e, roughness);\n    vec3 M = normalize(2. * dot(G, f) * f - G);\n    float O = max(dot(e, M), .0);\n    if(O > .0) {\n      J += textureCube(environmentMap, M).rgb * O;\n      K += O;\n    }\n  }\n  J = J / K;\n  gl_FragColor = vec4(J, 1.);\n}", $1d56c6a18dbfd30f$var$Wn = "precision highp float;\nvarying vec2 vTexCoords;\nuniform sampler2D distributionMap;\nconst float c = 3.14159265359;\nvec4 d(float a, float b) {\n  a *= 65535.;\n  b *= 65535.;\n  vec4 rgba;\n  rgba[0] = mod(a, 255.);\n  rgba[1] = (a - rgba[0]) / 65280.0;\n  rgba[2] = mod(b, 255.);\n  rgba[3] = (b - rgba[2]) / 65280.0;\n  return rgba;\n}\nvec3 e(float f, vec3 h, float i) {\n  vec4 j = texture2D(distributionMap, vec2(i, f));\n  vec3 k = j.xyz;\n  float l = sign(j.w - .5);\n  float m = sign(j.w - clamp(l, .0, 1.) * 200.0 / 255. - .15);\n  k.x *= l;\n  k.y *= m;\n  vec3 n = abs(h.z) < .999 ? vec3(.0, .0, 1.) : vec3(1., .0, .0);\n  vec3 o = normalize(cross(n, h));\n  vec3 u = cross(h, o);\n  vec3 v = o * k.x + u * k.y + h * k.z;\n  return normalize(v);\n}\nfloat A(float B, float i) {\n  float a = i;\n  float C = (a * a) / 2.;\n  float D = B;\n  float E = B * (1. - C) + C;\n  return D / E;\n}\nfloat F(float B, float G, float i) {\n  float I = A(B, i);\n  float J = A(G, i);\n  return J * I;\n}\nvec2 K(float B, float i) {\n  vec3 L;\n  L.x = sqrt(1. - B * B);\n  L.y = .0;\n  L.z = B;\n  float M = .0;\n  float O = .0;\n  vec3 h = vec3(.0, .0, 1.);\n  const int P = 1024;\n  for(int Q = 0; Q < P; ++Q) {\n    vec3 k = e(float(Q) / float(P), h, i);\n    vec3 R = normalize(2. * dot(L, k) * k - L);\n    float G = max(R.z, .0);\n    float S = max(k.z, .0);\n    float T = max(dot(L, k), .0);\n    float B = max(dot(h, L), .0);\n    if(G > .0) {\n      float U = F(B, G, i);\n      float W = (U * T) / (S * B);\n      float X = pow(1. - T, 5.);\n      M += (1. - X) * W;\n      O += X * W;\n    }\n  }\n  M /= float(P);\n  O /= float(P);\n  return vec2(M, O);\n}\nvoid main() {\n  vec2 Y = K(vTexCoords.x, vTexCoords.y);\n  gl_FragColor = d(Y.x, Y.y);\n}", $1d56c6a18dbfd30f$var$qn = "attribute vec3 aPosition;\nattribute vec2 aTexCoord;\nvarying vec2 vTexCoords;\nvoid main() {\n  vTexCoords = aTexCoord;\n  gl_Position = vec4(aPosition, 1.);\n}";
/*!
 * from claygl
 * https://github.com/pissang/claygl/
 * License: BSD-2-Clause
 */ function $1d56c6a18dbfd30f$var$Kn(e, t) {
    const n = e[0], r = e[1], i = e[2];
    return 0 === t ? 1 : 1 === t ? n : 2 === t ? r : 3 === t ? i : 4 === t ? n * i : 5 === t ? r * i : 6 === t ? n * r : 7 === t ? 3 * i * i - 1 : n * n - r * r;
}
const $1d56c6a18dbfd30f$var$Jn = {
    px: [
        2,
        1,
        0,
        -1,
        -1,
        1
    ],
    nx: [
        2,
        1,
        0,
        1,
        -1,
        -1
    ],
    py: [
        0,
        2,
        1,
        1,
        -1,
        -1
    ],
    ny: [
        0,
        2,
        1,
        1,
        1,
        1
    ],
    pz: [
        0,
        1,
        2,
        -1,
        -1,
        -1
    ],
    nz: [
        0,
        1,
        2,
        1,
        -1,
        1
    ]
}, $1d56c6a18dbfd30f$var$Yn = [
    "px",
    "nx",
    "py",
    "ny",
    "pz",
    "nz"
];
const $1d56c6a18dbfd30f$var$Zn = $1d56c6a18dbfd30f$export$bee4a7d47f8f5014.compile($1d56c6a18dbfd30f$var$Vt);
function $1d56c6a18dbfd30f$var$Qn(e, t, n, r, i = 1, o = !1) {
    const a = e({
        frag: (o ? "#define ENCODE_RGBM\n" : "") + $1d56c6a18dbfd30f$var$Un,
        vert: $1d56c6a18dbfd30f$var$Vn,
        attributes: {
            aPosition: $1d56c6a18dbfd30f$var$Gn.vertices
        },
        uniforms: {
            projMatrix: e.context("projMatrix"),
            viewMatrix: e.context("viewMatrix"),
            cubeMap: t,
            exposure: i
        },
        elements: $1d56c6a18dbfd30f$var$Gn.indices
    }), s = [], c = e.texture({
        radius: n,
        min: "linear",
        mag: "linear",
        type: r ? "float" : "uint8",
        format: "rgba"
    }), l = e.framebuffer({
        radius: n,
        color: c
    });
    return $1d56c6a18dbfd30f$var$zn(e, l, a, {
        size: n
    }, function() {
        const t = e.read();
        if (r) {
            const e = new Uint16Array(t.length);
            for(let n = 0; n < t.length; n++)e[n] = Math.min($1d56c6a18dbfd30f$var$st.toHalfFloat(t[n]), 65504);
            s.push(e);
        } else s.push(t);
    }), a.destroy(), l.destroy(), s;
}
const $1d56c6a18dbfd30f$var$$n = new Int8Array([
    -1,
    1,
    0,
    -1,
    -1,
    0,
    1,
    1,
    0,
    1,
    -1,
    0
]), $1d56c6a18dbfd30f$var$er = new Int8Array([
    0,
    1,
    0,
    0,
    1,
    1,
    1,
    0
]);
function $1d56c6a18dbfd30f$var$tr(e, t, n, r) {
    t = t || 256;
    const i = $1d56c6a18dbfd30f$var$nr(n = n || 1024, r = r || 256), o = e.texture({
        data: i,
        width: r,
        height: n,
        min: "nearest",
        mag: "nearest"
    }), a = e.buffer($1d56c6a18dbfd30f$var$$n), s = e.buffer($1d56c6a18dbfd30f$var$er), c = e.framebuffer({
        radius: t,
        colorType: "uint8",
        colorFormat: "rgba",
        min: "linear",
        mag: "linear"
    }), l = e({
        frag: $1d56c6a18dbfd30f$var$Wn,
        vert: $1d56c6a18dbfd30f$var$qn,
        attributes: {
            aPosition: {
                buffer: a
            },
            aTexCoord: {
                buffer: s
            }
        },
        uniforms: {
            distributionMap: o
        },
        framebuffer: c,
        viewport: {
            x: 0,
            y: 0,
            width: t,
            height: t
        },
        count: $1d56c6a18dbfd30f$var$$n.length / 3,
        primitive: "triangle strip"
    });
    return l(), l.destroy(), a.destroy(), s.destroy(), o.destroy(), c;
}
function $1d56c6a18dbfd30f$var$nr(e, t) {
    const n = new Float32Array(e * t * 4);
    for(let r = 0; r < e; r++){
        const { x: i, y: o } = $1d56c6a18dbfd30f$var$rr(r, e);
        for(let e = 0; e < t; e++){
            const a = e / t, s = a * a, c = 2 * Math.PI * i, l = Math.sqrt((1 - o) / (1 + (s * s - 1) * o)), f = Math.sqrt(1 - l * l), d = 4 * (r * t + e), u = f * Math.cos(c), h = f * Math.sin(c);
            n[d] = Math.abs(255 * u), n[d + 1] = Math.abs(255 * h), n[d + 2] = 255 * l, n[d + 3] = (u > 0 ? 200 : 0) + (h > 0 ? 55 : 0);
        }
    }
    return n;
}
function $1d56c6a18dbfd30f$var$rr(e, t) {
    let n = (e << 16 | e >>> 16) >>> 0;
    return n = ((1431655765 & n) << 1 | (2863311530 & n) >>> 1) >>> 0, n = ((858993459 & n) << 2 | (3435973836 & n) >>> 2) >>> 0, n = ((252645135 & n) << 4 | (4042322160 & n) >>> 4) >>> 0, n = (((16711935 & n) << 8 | (4278255360 & n) >>> 8) >>> 0) / 4294967296, {
        x: e / t,
        y: n
    };
}
function $1d56c6a18dbfd30f$var$ir(e) {
    return e._gl instanceof WebGL2RenderingContext || e.hasExtension("OES_texture_half_float");
}
var $1d56c6a18dbfd30f$var$or = Object.freeze({
    __proto__: null,
    createIBLMaps: function(e, n = {}) {
        const r = n.envTexture, i = n.envCubeSize || 512, o = n.sampleSize || 1024, a = n.roughnessLevels || 256, s = n.prefilterCubeSize || 256;
        let c, l = !1;
        if (Array.isArray(r)) {
            const t = e.cube({
                flipY: !0,
                faces: r
            });
            c = function(e, t, n) {
                const r = e({
                    frag: $1d56c6a18dbfd30f$var$Zn,
                    vert: $1d56c6a18dbfd30f$var$Vn,
                    attributes: {
                        aPosition: $1d56c6a18dbfd30f$var$Gn.vertices
                    },
                    uniforms: {
                        hsv: [
                            0,
                            0,
                            0
                        ],
                        projMatrix: e.context("projMatrix"),
                        viewMatrix: e.context("viewMatrix"),
                        cubeMap: t,
                        bias: 0,
                        size: t.width,
                        environmentExposure: 1,
                        backgroundIntensity: 1
                    },
                    elements: $1d56c6a18dbfd30f$var$Gn.indices
                }), i = e.cube({
                    width: n,
                    height: n,
                    min: "linear",
                    mag: "linear",
                    format: "rgba"
                }), o = e.framebufferCube({
                    radius: n,
                    color: i
                });
                return $1d56c6a18dbfd30f$var$zn(e, o, r, {
                    size: n
                }, null, [
                    [
                        0,
                        0,
                        -1
                    ],
                    [
                        0,
                        0,
                        -1
                    ],
                    [
                        0,
                        0,
                        1
                    ],
                    [
                        0,
                        0,
                        1
                    ],
                    [
                        0,
                        -1,
                        0
                    ],
                    [
                        0,
                        -1,
                        0
                    ]
                ]), r.destroy(), o;
            }(e, t, i), t.destroy();
        } else c = function(e, t, n) {
            if (!$1d56c6a18dbfd30f$var$ir(e)) throw new Error("HDR is not supported for lack of support for float 16 texture");
            n = n || 512;
            const r = e({
                frag: $1d56c6a18dbfd30f$var$jn,
                vert: $1d56c6a18dbfd30f$var$Vn,
                attributes: {
                    aPosition: $1d56c6a18dbfd30f$var$Gn.vertices
                },
                uniforms: {
                    projMatrix: e.context("projMatrix"),
                    viewMatrix: e.context("viewMatrix"),
                    equirectangularMap: t
                },
                elements: $1d56c6a18dbfd30f$var$Gn.indices
            }), i = e.cube({
                width: n,
                height: n,
                min: "linear mipmap linear",
                mag: "linear",
                type: "float16",
                format: "rgba"
            }), o = e.framebufferCube({
                radius: n,
                color: i
            });
            return $1d56c6a18dbfd30f$var$zn(e, o, r), r.destroy(), o;
        }(e, r, i), l = !0;
        const { prefilterMap: f, prefilterMipmap: d } = function(e, t, n, r, i, o) {
            const a = function(e, t, n, r, i, o) {
                r = r || 1024, i = i || 256;
                const a = $1d56c6a18dbfd30f$var$nr(r, i), s = e.texture({
                    data: a,
                    width: i,
                    height: r,
                    min: "nearest",
                    mag: "nearest"
                }), c = e({
                    frag: $1d56c6a18dbfd30f$var$Xn,
                    vert: $1d56c6a18dbfd30f$var$Vn,
                    attributes: {
                        aPosition: $1d56c6a18dbfd30f$var$Gn.vertices
                    },
                    uniforms: {
                        projMatrix: e.context("projMatrix"),
                        viewMatrix: e.context("viewMatrix"),
                        environmentMap: t,
                        distributionMap: s,
                        roughness: e.prop("roughness"),
                        resolution: n
                    },
                    elements: $1d56c6a18dbfd30f$var$Gn.indices,
                    viewport: {
                        x: 0,
                        y: 0,
                        width: e.prop("size"),
                        height: e.prop("size")
                    }
                });
                let l = n;
                const f = e.texture({
                    radius: n,
                    min: "linear",
                    mag: "linear",
                    type: o ? "float" : "uint8"
                }), d = e.framebuffer({
                    radius: n,
                    color: f
                }), u = Math.log(l) / Math.log(2), h = [];
                for(let t = 0; t <= u; t++){
                    let n = 0;
                    $1d56c6a18dbfd30f$var$zn(e, d, c, {
                        roughness: t / (u - 1),
                        size: l
                    }, function() {
                        const t = e.read({
                            framebuffer: d
                        });
                        let r = t;
                        if (o) {
                            r = new Uint16Array(t.length);
                            for(let e = 0; e < t.length; e++)r[e] = Math.min($1d56c6a18dbfd30f$var$st.toHalfFloat(t[e]), 65504);
                        }
                        h[n] || (h[n] = {
                            mipmap: []
                        }), h[n].mipmap.push(r), n++;
                    }), l /= 2, d.resize(l);
                }
                return s.destroy(), d.destroy(), c.destroy(), h;
            }(e, t, n, r, i, o), s = e.cube({
                radius: n,
                min: "linear",
                mag: "linear",
                type: o ? "float16" : "uint8",
                faces: a,
                format: "rgba"
            });
            return {
                prefilterMap: s,
                prefilterMipmap: a
            };
        }(e, c, s, o, a, l);
        let u;
        if (!n.ignoreSH) {
            const r = s;
            u = function(e, n, r) {
                const i = new Array(9), o = [], a = [], s = [];
                for(let c = 0; c < 9; c++){
                    const l = [
                        0,
                        0,
                        0
                    ];
                    for(let i = 0; i < $1d56c6a18dbfd30f$var$Yn.length; i++){
                        const f = e[i], d = [
                            0,
                            0,
                            0
                        ];
                        let u = 0, h = 0;
                        const m = $1d56c6a18dbfd30f$var$Jn[$1d56c6a18dbfd30f$var$Yn[i]];
                        for(let e = 0; e < r; e++)for(let i = 0; i < n; i++){
                            o[0] = i / (n - 1) * 2 - 1, o[1] = e / (r - 1) * 2 - 1, o[2] = -1, (0, $eIStk).normalize(o, o), s[0] = o[m[0]] * m[3], s[1] = o[m[1]] * m[4], s[2] = o[m[2]] * m[5], a[0] = f[h++] / 255, a[1] = f[h++] / 255, a[2] = f[h++] / 255;
                            const l = f[h++] / 255 * 7;
                            a[0] *= l, a[1] *= l, a[2] *= l, (0, $eIStk).scaleAndAdd(d, d, a, $1d56c6a18dbfd30f$var$Kn(s, c) * -o[2]), u += -o[2];
                        }
                        (0, $eIStk).scaleAndAdd(l, l, d, 1 / u);
                    }
                    i[c] = (0, $eIStk).scale(l, l, 1 / 6);
                }
                return i;
            }($1d56c6a18dbfd30f$var$Qn(e, f, r, !1, n.environmentExposure, !0), r, r);
            const i = [];
            for(let e = 0; e < u.length; e++)i.push(...u[e]);
            u = i;
        }
        const h = {
            envMap: c,
            isHDR: l,
            prefilterMap: f
        };
        return u && (h.sh = u), "array" === n.format && (h.envMap = {
            width: c.width,
            height: c.height,
            faces: $1d56c6a18dbfd30f$var$Qn(e, c, i, l)
        }, h.prefilterMap = {
            width: f.width,
            height: f.height,
            faces: d
        }, c.destroy(), f.destroy()), h;
    },
    generateDFGLUT: $1d56c6a18dbfd30f$var$tr,
    supportFloat16: $1d56c6a18dbfd30f$var$ir
});
const $1d56c6a18dbfd30f$var$ar = {
    uvScale: [
        1,
        1
    ],
    uvOffset: [
        0,
        0
    ],
    uvRotation: 0,
    textureOrigin: null,
    textureWidth: null,
    baseColorFactor: [
        1,
        1,
        1,
        1
    ],
    emissiveFactor: [
        0,
        0,
        0
    ],
    baseColorIntensity: 1,
    emitColorFactor: 1,
    occlusionFactor: 1,
    roughnessFactor: .4,
    metallicFactor: 0,
    normalMapFactor: 1,
    specularF0: .5,
    emitMultiplicative: 1,
    normalMapFlipY: 0,
    outputSRGB: 1,
    baseColorTexture: null,
    normalTexture: null,
    occlusionTexture: null,
    metallicRoughnessTexture: null,
    emissiveTexture: null,
    uvOrigin: [
        0,
        0
    ],
    noiseTexture: null,
    specularAAVariance: 20,
    specularAAThreshold: 20,
    hsv: [
        0,
        0,
        0
    ],
    contrast: 1,
    bumpTexture: null,
    bumpScale: .05,
    bumpMinLayers: 5,
    bumpMaxLayers: 20,
    alphaTest: 0
};
class $1d56c6a18dbfd30f$var$sr extends $1d56c6a18dbfd30f$export$a2d8b23205c25948 {
    constructor(e){
        const t = $1d56c6a18dbfd30f$var$v({}, $1d56c6a18dbfd30f$var$ar);
        (e.metallicRoughnessTexture || e.metallicRoughnessTexture) && (t.roughnessFactor = 1, t.metallicFactor = 1), super(e, t);
    }
    appendDefines(e, t) {
        super.appendDefines(e, t);
        const n = this.uniforms;
        n.GAMMA_CORRECT_INPUT && (e.GAMMA_CORRECT_INPUT = 1), t.data[t.desc.colorAttribute] && (e.HAS_COLOR = 1);
        if (t.data[t.desc.color0Attribute] && (e.HAS_COLOR0 = 1, e.COLOR0_SIZE = t.getColor0Size()), t.data[t.desc.tangentAttribute] ? e.HAS_TANGENT = 1 : t.data[t.desc.normalAttribute] && (e.HAS_NORMAL = 1), t.data.aVertexColorType && (e.HAS_VERTEX_COLOR = 1), !t.data[t.desc.uv0Attribute]) return e;
        n.baseColorTexture && (e.HAS_ALBEDO_MAP = 1), n.metallicRoughnessTexture && (e.HAS_METALLICROUGHNESS_MAP = 1), n.occlusionTexture && t.data[t.desc.uv1Attribute] && (e.HAS_AO_MAP = 1), n.emissiveTexture && (e.HAS_EMISSIVE_MAP = 1), n.normalTexture && (e.HAS_NORMAL_MAP = 1), n.bumpTexture && (e.HAS_BUMP_MAP = 1), n.skinTexture && (e.HAS_SKIN_MAP = 1), (e.HAS_ALBEDO_MAP || e.HAS_METALLICROUGHNESS_MAP || e.HAS_AO_MAP || e.HAS_EMISSIVE_MAP || e.HAS_NORMAL_MAP || e.HAS_BUMP_MAP || e.HAS_SKIN_MAP) && (e.HAS_MAP = 1), n.noiseTexture && (e.HAS_RANDOM_TEX = 1), t.data[t.desc.tangentAttribute] ? e.HAS_TANGENT = 1 : t.data[t.desc.normalAttribute] && (e.HAS_NORMAL = 1);
        const r = n.alphaMode && n.alphaMode.toUpperCase();
        return "MASK" === r ? e.ALPHA_MODE = 1 : "OPAQUE" === r && (e.ALPHA_MODE = 2), e;
    }
}
class $1d56c6a18dbfd30f$var$cr extends $1d56c6a18dbfd30f$var$Fe($1d56c6a18dbfd30f$var$sr) {
}
function $1d56c6a18dbfd30f$var$lr(e, t, n) {
    if (n.ambientUpdate) {
        const { iblTexes: r } = e, i = n.target;
        r ? ($1d56c6a18dbfd30f$var$ur(r), e.iblTexes = $1d56c6a18dbfd30f$var$dr(t, i)) : e.iblTexes = $1d56c6a18dbfd30f$var$dr(t, i), i.getRenderer().setToRedraw();
    }
}
const $1d56c6a18dbfd30f$var$fr = [
    0,
    0
];
function $1d56c6a18dbfd30f$var$dr(e, t) {
    const n = t.getLightManager(), r = n && n.getAmbientResource();
    if (!r) return null;
    const i = r.isHDR;
    return {
        prefilterMap: e.cube({
            width: r.prefilterMap.width,
            height: r.prefilterMap.height,
            faces: r.prefilterMap.faces,
            min: "linear",
            mag: "linear",
            format: "rgba",
            type: i ? "float16" : "uint8"
        }),
        envMap: e.cube({
            width: r.envMap.width,
            height: r.envMap.height,
            faces: r.envMap.faces,
            min: "linear",
            mag: "linear",
            format: "rgba",
            type: i ? "float16" : "uint8"
        }),
        sh: r.sh
    };
}
function $1d56c6a18dbfd30f$var$ur(e) {
    for(const t in e)e[t] && e[t].destroy && e[t].destroy(), delete e[t];
}
var $1d56c6a18dbfd30f$var$hr = Object.freeze({
    __proto__: null,
    createIBLTextures: $1d56c6a18dbfd30f$var$dr,
    disposeIBLTextures: $1d56c6a18dbfd30f$var$ur,
    getIBLResOnCanvas: function(e) {
        const { dfgLUT: t, iblTexes: n } = e;
        return {
            dfgLUT: t,
            iblTexes: n
        };
    },
    getPBRUniforms: function(e, t, n, r, i) {
        const o = e.viewMatrix, a = e.projMatrix, s = e.cameraPosition, c = e.getRenderer().canvas, l = function(e, t) {
            const n = e.getLightManager(), r = n && n.getAmbientResource(), i = n && n.getAmbientLight() || {}, o = n && n.getDirectionalLight() || {};
            let a;
            if (r) {
                const e = t.prefilterMap.width, n = Math.log(e) / Math.log(2);
                a = {
                    prefilterMap: t.prefilterMap,
                    diffuseSPH: t.sh,
                    prefilterMiplevel: [
                        n,
                        n
                    ],
                    prefilterSize: [
                        e,
                        e
                    ],
                    hdrHSV: i.hsv || [
                        0,
                        0,
                        0
                    ]
                };
            } else a = {
                ambientColor: i.color || [
                    .2,
                    .2,
                    .2
                ]
            };
            return a.environmentExposure = $1d56c6a18dbfd30f$var$g(i.exposure) ? i.exposure : 1, a.environmentOrientation = i.orientation || 0, a.light0_diffuse = [
                ...o.color || [
                    1,
                    1,
                    1
                ],
                1
            ], a.light0_viewDirection = o.direction || [
                1,
                1,
                -1
            ], a;
        }(e, t), f = $1d56c6a18dbfd30f$var$v({
            viewMatrix: o,
            projMatrix: a,
            projViewMatrix: e.projViewMatrix,
            cameraPosition: s,
            outSize: [
                c.width,
                c.height
            ],
            cameraNearFar: [
                e.cameraNear,
                e.cameraFar
            ]
        }, l);
        return f.brdfLUT = n, r && r.renderUniforms && $1d56c6a18dbfd30f$var$v(f, r.renderUniforms), f.halton = i || $1d56c6a18dbfd30f$var$fr, f;
    },
    isSupported: function(e) {
        return e.hasExtension("EXT_shader_texture_lod");
    },
    loginIBLResOnCanvas: function(e, t, n) {
        if (!e.dfgLUT && (e.dfgLUT = $1d56c6a18dbfd30f$var$tr(t), e.dfgLUT.mtkRefCount = 0, n)) {
            const r = (...n)=>$1d56c6a18dbfd30f$var$lr.call(this, e, t, ...n);
            n.on("updatelights", r), e._iblResListener = r;
        }
        e.dfgLUT.mtkRefCount++;
        const r = n.getLightManager();
        return r && r.getAmbientResource() ? (e.iblTexes || (e.iblTexes = $1d56c6a18dbfd30f$var$dr(t, n)), {
            dfgLUT: e.dfgLUT,
            iblTexes: e.iblTexes
        }) : {
            dfgLUT: e.dfgLUT,
            iblTexes: null
        };
    },
    logoutIBLResOnCanvas: function(e, t) {
        let n = !1;
        if (e.dfgLUT && (e.dfgLUT.mtkRefCount--, e.dfgLUT.mtkRefCount <= 0)) {
            if (n = !0, t) t.off("updatelights", e._iblResListener);
            e.dfgLUT.destroy(), delete e.dfgLUT;
        }
        e.iblTexes && n && ($1d56c6a18dbfd30f$var$ur(e.iblTexes), delete e.iblTexes);
    }
});
class $1d56c6a18dbfd30f$export$2322f55bf1a46077 extends $1d56c6a18dbfd30f$export$9d2cc9f1c4004434 {
    constructor(t){
        super({
            vert: "attribute vec3 aPosition;\nuniform mat4 lightProjViewModelMatrix;\nuniform mat4 positionMatrix;\nuniform mat4 modelViewMatrix;\nuniform mat4 modelMatrix;\n#include <line_extrusion_vert>\n#include <get_output>\nvarying vec4 vPosition;\nvoid main() {\n  mat4 c = getPositionMatrix();\n#ifdef IS_LINE_EXTRUSION\nvec3 d = getLineExtrudePosition(aPosition);\n  vec4 e = getPosition(d);\n#else\nvec4 e = getPosition(aPosition);\n#endif\ngl_Position = lightProjViewModelMatrix * c * e;\n  vPosition = gl_Position;\n}",
            frag: "#define SHADER_NAME vsm_mapping\n#ifdef USE_VSM\n#extension GL_OES_standard_derivatives : enable\n#endif\nprecision highp float;\nvarying vec4 vPosition;\n#ifdef PACK_FLOAT\n#include <common_pack_float>\n#endif\nvoid main() {\n  \n#if defined(USE_VSM)\nfloat c = vPosition.z / vPosition.w;\n  c = c * .5 + .5;\n  float d = c;\n  float e = c * c;\n  float f = dFdx(c);\n  float h = dFdy(c);\n  e += .25 * (f * f + h * h);\n  gl_FragColor = vec4(d, e, c, .0);\n#endif\n#if defined(USE_ESM)\n#ifdef PACK_FLOAT\ngl_FragColor = common_encodeDepth(gl_FragCoord.z);\n#else\ngl_FragColor = vec4(gl_FragCoord.z, .0, .0, 1.);\n#endif\n#endif\n}",
            uniforms: [
                {
                    name: "lightProjViewModelMatrix",
                    type: "function",
                    fn: function(t, n) {
                        return (0, $3iqbd).multiply([], n.lightProjViewMatrix, n.modelMatrix);
                    }
                }
            ],
            extraCommandProps: {},
            defines: t
        });
    }
    filter(e) {
        return e.castShadow;
    }
}
class $1d56c6a18dbfd30f$var$vr extends $1d56c6a18dbfd30f$export$e82c04eda9e9b75c {
    constructor({ blurOffset: e }){
        super({
            vert: $1d56c6a18dbfd30f$var$Mt,
            frag: "precision highp float;\nvarying vec2 vTexCoord;\nuniform sampler2D textureSource;\nuniform vec2 resolution;\n#include <common_pack_float>\nvoid main() {\n  float c = .0;\n  float d = .0;\n  for(int x = -BOXBLUR_OFFSET; x <= BOXBLUR_OFFSET; ++x)\n    for(int y = -BOXBLUR_OFFSET; y <= BOXBLUR_OFFSET; ++y) {\n      vec2 e = vTexCoord.st + vec2(float(x) / resolution.x, float(y) / resolution.y);\n      e = clamp(e, .0, 1.);\n      float f = common_decodeDepth(texture2D(textureSource, e));\n      float s = max(.0, sign(1. - f));\n      d += sign(f) * s;\n      c += f;\n    }\n  float h = c / max(1., d);\n  gl_FragColor = common_encodeDepth(h);\n}",
            defines: {
                BOXBLUR_OFFSET: e || 2
            }
        }), this._blurOffset = e || 2;
    }
    getMeshCommand(e, t) {
        const n = "box_shadow_blur_" + this._blurOffset;
        return this.commands[n] || (this.commands[n] = this.createREGLCommand(e, null, t.getElements())), this.commands[n];
    }
}
let $1d56c6a18dbfd30f$var$_r = null, $1d56c6a18dbfd30f$var$gr = null;
class $1d56c6a18dbfd30f$export$48e48531746e3d8 {
    constructor(e, { width: t, height: n, blurOffset: r, defines: i }){
        this.renderer = e, this.width = t || 512, this.height = n || 512, this.blurOffset = $1d56c6a18dbfd30f$var$u(r) ? 2 : r, this._init(i);
    }
    render(e, { cameraProjViewMatrix: t, lightDir: n, farPlane: r, cameraLookAt: i }) {
        return {
            lightProjViewMatrix: this._renderShadow(e, t, n, r, i),
            shadowMap: this.blurTex || this.depthTex,
            depthFBO: this.depthFBO,
            blurFBO: this.blurFBO
        };
    }
    resize(e, t) {
        return this.depthTex && (this.depthTex.resize(e, t), this.depthFBO.resize(e, t)), this.width = e, this.blurFBO && (this.blurTex.resize(e, t), this.blurFBO.resize(e, t)), this.height = t, this;
    }
    _renderShadow(e, t, n, r, i) {
        const o = this.renderer, a = $1d56c6a18dbfd30f$var$_r(t);
        if (r) for(let e = 4; e < 8; e++)a[e] = r[e - 4];
        const s = $1d56c6a18dbfd30f$var$gr(i, a, n);
        return o.clear({
            color: [
                1,
                0,
                0,
                1
            ],
            depth: 1,
            framebuffer: this.depthFBO
        }), o.render(this.shadowMapShader, {
            lightProjViewMatrix: s
        }, e, this.depthFBO), this.blurFBO && (this.boxBlurShader || (this.boxBlurShader = new $1d56c6a18dbfd30f$var$vr({
            blurOffset: this.blurOffset
        })), o.clear({
            color: [
                1,
                0,
                0,
                1
            ],
            depth: 1,
            framebuffer: this.blurFBO
        }), o.render(this.boxBlurShader, {
            resolution: [
                this.depthTex.width,
                this.depthTex.height
            ],
            textureSource: this.depthTex
        }, null, this.blurFBO)), s;
    }
    _init(e) {
        const t = this.renderer.regl, n = "uint8", r = this.width, i = this.height;
        this.depthTex = t.texture({
            width: r,
            height: i,
            format: "rgb",
            type: n,
            min: "nearest",
            mag: "nearest"
        }), this.shadowMapShader = new $1d56c6a18dbfd30f$export$2322f55bf1a46077(e), this.shadowMapShader.filter = (e)=>e.castShadow, this.depthFBO = t.framebuffer({
            color: this.depthTex
        }), this.blurOffset <= 0 || (this.blurTex = t.texture({
            width: r,
            height: i,
            format: "rgb",
            type: n,
            min: "linear",
            mag: "linear"
        }), this.blurFBO = t.framebuffer({
            color: this.blurTex
        }));
    }
    dispose() {
        this.depthTex && (this.depthTex.destroy(), this.depthFBO.destroy(), delete this.depthTex, delete this.depthFBO), this.blurTex && (this.blurTex.destroy(), this.blurFBO.destroy(), delete this.blurTex, delete this.blurFBO), this.shadowMapShader && (this.shadowMapShader.dispose(), delete this.shadowMapShader), this.boxBlurShader && (this.boxBlurShader.dispose(), delete this.boxBlurShader);
    }
}
$1d56c6a18dbfd30f$var$_r = function() {
    const t = [
        [
            -1,
            -1,
            -1,
            1
        ],
        [
            1,
            -1,
            -1,
            1
        ],
        [
            1,
            1,
            -1,
            1
        ],
        [
            -1,
            1,
            -1,
            1
        ],
        [
            -1,
            -1,
            1,
            1
        ],
        [
            1,
            -1,
            1,
            1
        ],
        [
            1,
            1,
            1,
            1
        ],
        [
            -1,
            1,
            1,
            1
        ]
    ], r = new Array(16);
    return function(i) {
        (0, $3iqbd).invert(r, i);
        const o = [];
        for(let e = 0; e < t.length; e++){
            const i = (0, $jxhwV).transformMat4([], t[e], r);
            (0, $jxhwV).scale(i, i, 1 / i[3]), o.push(i);
        }
        return o;
    };
}(), $1d56c6a18dbfd30f$var$gr = function() {
    let r = new Array(4);
    const i = new Array(3), o = [
        0,
        0,
        0,
        0
    ], a = [
        0,
        1,
        0
    ], s = new Array(3);
    let c = new Array(16), l = new Array(16);
    const f = new Array(16), d = [
        1,
        1,
        1
    ], u = [
        0,
        0,
        0
    ];
    return function(h, m, v) {
        (0, $jxhwV).set(o, ...h, 1), (0, $eIStk).scale(i, v, -1), c = (0, $3iqbd).lookAt(c, (0, $eIStk).add(s, o, (0, $eIStk).normalize(s, i)), o, a), (0, $jxhwV).transformMat4(r, m[0], c);
        let _ = r[2], g = r[2], x = r[0], p = r[0], b = r[1], y = r[1];
        for(let e = 1; e < 8; e++)r = (0, $jxhwV).transformMat4(r, m[e], c), r[2] > g && (g = r[2]), r[2] < _ && (_ = r[2]), r[0] > p && (p = r[0]), r[0] < x && (x = r[0]), r[1] > y && (y = r[1]), r[1] < b && (b = r[1]);
        l = (0, $3iqbd).ortho(l, -1, 1, -1, 1, -g, -_);
        const A = d[0] = 2 / (p - x), S = d[1] = -2 / (y - b);
        u[0] = -0.5 * (x + p) * A, u[1] = -0.5 * (b + y) * S, (0, $3iqbd).identity(f), (0, $3iqbd).translate(f, f, u), (0, $3iqbd).scale(f, f, d);
        const T = (0, $3iqbd).multiply(l, f, l);
        return (0, $3iqbd).multiply(new Array(16), T, c);
    };
}();
class $1d56c6a18dbfd30f$export$5de8fd44581a7c0b extends $1d56c6a18dbfd30f$export$9d2cc9f1c4004434 {
    constructor(t){
        super({
            vert: "#define SHADER_NAME SHADOW_DISPLAY\nattribute vec3 aPosition;\nuniform mat4 projMatrix;\nuniform mat4 modelViewMatrix;\nuniform vec2 halton;\nuniform vec2 globalTexSize;\nvarying vec4 vPosition;\n#include <vsm_shadow_vert>\nvoid main() {\n  vec4 c = vec4(aPosition, 1.);\n  vec4 d = modelViewMatrix * c;\n  mat4 e = projMatrix;\n  e[2].xy += halton.xy / globalTexSize.xy;\n  gl_Position = e * d;\n  vPosition = gl_Position;\n  shadow_computeShadowPars(c);\n}",
            frag: "#define SHADER_NAME SHADOW_DISPLAY\nprecision mediump float;\nuniform vec3 color;\n#include <vsm_shadow_frag>\nvoid main() {\n  float c = shadow_computeShadow();\n  float d = 1. - c;\n  gl_FragColor = vec4(color * d, d);\n}",
            uniforms: [
                {
                    name: "modelViewMatrix",
                    type: "function",
                    fn: function(t, n) {
                        const r = [];
                        return (0, $3iqbd).multiply(r, n.viewMatrix, n.modelMatrix), r;
                    }
                }
            ],
            defines: t || {
                USE_ESM: 1
            },
            extraCommandProps: {
                depth: {
                    enable: !0,
                    mask: !1
                },
                viewport: {
                    x: 0,
                    y: 0,
                    width: (e, t)=>t.globalTexSize[0],
                    height: (e, t)=>t.globalTexSize[1]
                }
            }
        });
    }
    getMeshCommand(e, t) {
        return this.commands.shadow_display || (this.commands.shadow_display = this.createREGLCommand(e, null, t.getElements())), this.commands.shadow_display;
    }
}
function $1d56c6a18dbfd30f$var$br(e) {
    return 256 * e[2] * 256 + 256 * e[1] + e[0];
}
const $1d56c6a18dbfd30f$var$yr = new Uint8Array(4), $1d56c6a18dbfd30f$var$Ar = new Float32Array($1d56c6a18dbfd30f$var$yr.buffer);
let $1d56c6a18dbfd30f$var$Sr, $1d56c6a18dbfd30f$var$Tr;
const $1d56c6a18dbfd30f$var$Mr = [
    1,
    1
], $1d56c6a18dbfd30f$var$Or = "\n    vec3 unpack(highp float f) {\n        highp vec3 color;\n        color.b = floor(f / 65536.0);\n        color.g = floor((f - color.b * 65536.0) / 256.0);\n        color.r = f - floor(color.b * 65536.0) - floor(color.g * 256.0);\n        // now we have a vec3 with the 3 components in range [0..255]. Let's normalize it!\n        return color / 255.0;\n    }\n", $1d56c6a18dbfd30f$var$Cr = `\n    precision highp float;\n\n    varying float vPickingId;\n    varying float vFbo_picking_visible;\n\n    uniform float fbo_picking_meshId;\n\n    ${$1d56c6a18dbfd30f$var$Or}\n\n    void main() {\n        if (vFbo_picking_visible == 0.0) {\n            discard;\n            return;\n        }\n        gl_FragColor = vec4(unpack(vPickingId), fbo_picking_meshId / 255.0);\n    }\n`, $1d56c6a18dbfd30f$var$Er = `\n    precision highp float;\n\n    uniform int fbo_picking_meshId;\n    varying float vFbo_picking_visible;\n\n    ${$1d56c6a18dbfd30f$var$Or}\n\n    void main() {\n        if (vFbo_picking_visible == 0.0) {\n            discard;\n            return;\n        }\n        gl_FragColor = vec4(unpack(float(fbo_picking_meshId)), 1.0);\n        // gl_FragColor = vec4(unpack(float(35)), 1.0);\n    }\n`, $1d56c6a18dbfd30f$var$Pr = `\n    precision highp float;\n\n    varying float vPickingId;\n    varying float vFbo_picking_visible;\n\n    ${$1d56c6a18dbfd30f$var$Or}\n\n    void main() {\n        if (vFbo_picking_visible == 0.0) {\n            discard;\n            return;\n        }\n        gl_FragColor = vec4(unpack(vPickingId), 1.0);\n    }\n`;
class $1d56c6a18dbfd30f$export$6f30a48810f49c78 {
    constructor(e, { vert: t, uniforms: n, defines: r, extraCommandProps: i, enableStencil: o }, a, s){
        this._renderer = e, this._fbo = a, this._map = s, this._clearFbo(a), this._vert = t, this._uniforms = n, this._defines = r, this._extraCommandProps = $1d56c6a18dbfd30f$var$v({}, i), delete this._extraCommandProps.blend, o ? this._extraCommandProps.stencil = {
            enable: o,
            mask: 255,
            func: {
                cmp: "<",
                ref: 1,
                mask: 255
            },
            op: {
                fail: "keep",
                zfail: "keep",
                zpass: "replace"
            }
        } : delete this._extraCommandProps.stencil, this._currentMeshes = [], this._init();
    }
    _init() {
        const e = [];
        this._uniforms && e.push(...this._uniforms);
        const t = {
            ENABLE_PICKING: 1,
            HAS_PICKING_ID: 1
        };
        if (this._defines) for(const e in this._defines)t[e] = this._defines[e];
        const n = this._vert, r = this._extraCommandProps;
        this._shader0 = new $1d56c6a18dbfd30f$export$9d2cc9f1c4004434({
            vert: n,
            frag: $1d56c6a18dbfd30f$var$Cr,
            uniforms: e,
            defines: t,
            extraCommandProps: r
        }), this._shader2 = new $1d56c6a18dbfd30f$export$9d2cc9f1c4004434({
            vert: n,
            frag: $1d56c6a18dbfd30f$var$Pr,
            uniforms: e,
            defines: t,
            extraCommandProps: r
        });
        const i = {
            ENABLE_PICKING: 1,
            HAS_PICKING_ID: 1
        };
        if (this._defines) for(const e in this._defines)i[e] = this._defines[e];
        this._shader1 = new $1d56c6a18dbfd30f$export$9d2cc9f1c4004434({
            vert: n,
            frag: $1d56c6a18dbfd30f$var$Er,
            uniforms: e,
            defines: i,
            extraCommandProps: r
        }), this._depthShader = new $1d56c6a18dbfd30f$export$9d2cc9f1c4004434({
            vert: n,
            frag: "\n    #ifdef GL_ES\n        precision highp float;\n    #endif\n    #if __VERSION__ == 100 && defined(GL_EXT_frag_depth)\n        #extension GL_EXT_frag_depth : enable\n    #endif\n    #include <gl2_frag>\n    #include <common_pack_float>\n    varying float vFbo_picking_viewZ;\n    uniform float logDepthBufFC;\n    varying float vFbo_picking_fragDepth;\n\n    const float PackUpscale = 256. / 255.;\n    const float UnpackDownscale = 255. / 256.;\n    const vec3 PackFactors = vec3( 256. * 256. * 256., 256. * 256., 256. );\n    const vec4 UnpackFactors = UnpackDownscale / vec4( PackFactors, 1. );\n    const float ShiftRight8 = 1. / 256.;\n    vec4 packDepthToRGBA(const in float v ) {\n        vec4 r = vec4(fract(v * PackFactors), v);\n        r.yzw -= r.xyz * ShiftRight8;\n        return r * PackUpscale;\n    }\n\n    void main() {\n        float fragDepth = vFbo_picking_fragDepth > 1.0 ? vFbo_picking_fragDepth : vFbo_picking_viewZ + 1.0;\n        #if __VERSION__ == 300 || __VERSION__ == 100 && defined(GL_EXT_frag_depth)\n            gl_FragDepthEXT = log2(fragDepth) * logDepthBufFC * 0.5;\n        #endif\n        vec4 depthColor = packDepthToRGBA(fragDepth - 1.0);\n        glFragColor = common_unpackFloat(dot(depthColor, UnpackFactors));\n        #if __VERSION__ == 100\n            gl_FragColor = glFragColor;\n        #endif\n    }\n",
            uniforms: e,
            defines: i,
            extraCommandProps: r
        }), this._scene = new $1d56c6a18dbfd30f$export$38af1803e3442a7f, this._scene1 = new $1d56c6a18dbfd30f$export$38af1803e3442a7f;
    }
    filter() {
        return !0;
    }
    render(e, t, n = !1) {
        if (!e || !e.length) return this;
        const r = this._fbo;
        n && this.clear(), e = e.filter((e)=>e && e.isValid && e.isValid()), this._scene.setMeshes(e);
        const i = this._getShader(e, n);
        i.filter = this.filter, this._currentShader && i !== this._currentShader && this.clear(), this._currentShader = i, e.forEach((e, t)=>{
            e.setUniform("fbo_picking_meshId", t + this._currentMeshes.length);
        });
        for(let t = 0; t < e.length; t++)this._currentMeshes.push(e[t]);
        return this._renderer.render(i, t, this._scene, r), this;
    }
    pickAll(e, t, n, r, i) {
        n = $1d56c6a18dbfd30f$var$Rr(n);
        const { meshIds: o, pickingIds: a, coords: s, points: c } = this._pick(e, t, n, r, i), l = [];
        if (a && o) {
            const e = {};
            for(let t = 0; t < o.length; t++){
                const n = `${a[t]}_${o[t]}`;
                null == o[t] || null == a[t] || e[n] || (e[n] = !0, l.push({
                    meshId: o[t],
                    pickingId: a[t],
                    point: c[t] || null,
                    coordinate: s[t] || null
                }));
            }
        }
        return l;
    }
    pick(e, t, n, r, i = {}) {
        n = $1d56c6a18dbfd30f$var$Rr(n);
        const { meshIds: o, pickingIds: a, width: s, coords: c, points: l } = this._pick(e, t, n, r, i);
        if (a && o) {
            const e = [];
            for(let t = 0; t <= n[0]; t++)e.push(t), t > 0 && e.push(-t);
            for(let t = 0; t < e.length; t++)for(let r = 0; r < e.length; r++){
                const i = (e[r] + n[1]) * s + (e[t] + n[0]);
                if (null != o[i]) return {
                    meshId: o[i],
                    pickingId: a[i],
                    point: l[i] || null,
                    coordinate: c[i] || null
                };
            }
        }
        return {
            pickingId: null,
            meshId: null,
            point: null
        };
    }
    _pick(e, t, n, r, i = {}) {
        const o = this._currentShader, a = this._currentMeshes;
        if (!o || !a || !a.length) return {
            pickingId: null,
            meshId: null,
            point: null
        };
        e = Math.round(e), t = Math.round(t);
        const s = this._fbo;
        if (e <= 2 || e >= s.width - 2 || t <= 2 || t >= s.height - 2) return {
            pickingId: null,
            meshId: null,
            point: null
        };
        const { px: c, py: l, width: f, height: d } = this._getParams(e, t, n, s), u = new Uint8Array(4 * f * d), h = this._renderer.regl.read({
            data: u,
            x: c,
            y: l,
            framebuffer: s,
            width: f,
            height: d
        }), m = [];
        let v = [];
        for(let e = 0; e < h.length; e += 4){
            const { pickingId: t, meshId: n } = this._packData(h.subarray(e, e + 4), o);
            m.push(n), v.push(t);
        }
        const _ = {}, g = m.filter((e)=>null != e && !_[e] && (_[e] = 1, !0)).map((e)=>a[e]);
        let x;
        for(let e = 0; e < g.length; e++)if (g[e] && g[e].geometry) {
            x = g[e];
            break;
        }
        if (!x) return {
            pickingId: null,
            meshId: null,
            point: null
        };
        const p = x.geometry.desc.pickingIdAttribute;
        m.length && o === this._shader1 && (void 0 !== x.getUniform("uPickingId") || x.geometry.data[p]) && (v = this._getPickingId(c, l, f, d, u, g, r));
        const b = [], y = [];
        if (m.length && i.returnPoint) {
            const { viewMatrix: n, projMatrix: o } = i, a = this._pickDepth(c, l, f, d, u, g, r);
            for(let r = 0; r < a.length; r++)if (a[r] && null != m[r]) {
                const i = this._getWorldPos(e, t, a[r], n, o), s = this._convertPickPoint(i);
                b.push(i), y.push(s);
            } else b.push(null), y.push(null);
        }
        return {
            meshIds: m,
            pickingIds: v,
            coords: y,
            points: b,
            width: f,
            height: d
        };
    }
    _convertPickPoint(e) {
        const t = this._map;
        if (!t) return null;
        const n = t.getGLRes();
        if (!$1d56c6a18dbfd30f$var$Sr) {
            const e = t.getCenter();
            $1d56c6a18dbfd30f$var$Tr = new e.constructor(0, 0, 0);
            const n = t.coordToPoint(e);
            $1d56c6a18dbfd30f$var$Sr = new n.constructor(0, 0);
        }
        $1d56c6a18dbfd30f$var$Sr.set(e[0], e[1]);
        const r = t.pointAtResToCoord($1d56c6a18dbfd30f$var$Sr, n, $1d56c6a18dbfd30f$var$Tr), i = t.pointAtResToAltitude(e[2], n);
        return [
            r.x,
            r.y,
            i
        ];
    }
    clear() {
        return this._fbo && this._clearFbo(this._fbo), this._currentMeshes = [], delete this._currentShader, this;
    }
    getMeshAt(e) {
        return this._currentMeshes ? this._currentMeshes[e] : null;
    }
    getRenderedMeshes() {
        return this._currentMeshes;
    }
    dispose() {
        this.clear(), this._shader0 && this._shader0.dispose(), this._shader1 && this._shader1.dispose(), this._shader2 && this._shader2.dispose(), this._scene && this._scene.clear(), this._scene1 && this._scene1.clear();
    }
    _getWorldPos(t, n, r, i, o) {
        const a = this._fbo, s = [], c = a.width / 2 || 1, l = a.height / 2 || 1, f = [
            (t - c) / c,
            (l - n) / l,
            0,
            1
        ], d = [
            (t - c) / c,
            (l - n) / l,
            1,
            1
        ], u = (0, $3iqbd).invert(s, o), h = [], m = [];
        $1d56c6a18dbfd30f$var$Ir(h, f, u), $1d56c6a18dbfd30f$var$Ir(m, d, u);
        const v = -h[2], _ = (r - v) / (-m[2] - v), g = (0, $3iqbd).multiply(s, o, i), p = (0, $3iqbd).invert(s, g), b = $1d56c6a18dbfd30f$var$Ir(f, f, p), y = $1d56c6a18dbfd30f$var$Ir(d, d, p);
        return [
            $1d56c6a18dbfd30f$var$x(b[0], y[0], _),
            $1d56c6a18dbfd30f$var$x(b[1], y[1], _),
            $1d56c6a18dbfd30f$var$x(b[2], y[2], _)
        ];
    }
    _getPickingId(e, t, n, r, i, o, a) {
        const s = this._renderer.regl, c = this._getFBO1();
        this._clearFbo(c), this._scene1.setMeshes(o), this._renderer.render(this._shader2, a, this._scene1, c);
        const l = s.read({
            data: i,
            x: e,
            y: t,
            framebuffer: c,
            width: n,
            height: r
        }), f = [];
        for(let e = 0; e < l.length; e += 4)f.push($1d56c6a18dbfd30f$var$br(l.subarray(e, e + 4)));
        return f;
    }
    _pickDepth(e, t, n, r, i, o, a) {
        const s = this._renderer.regl, c = this._getFBO1();
        this._scene1.setMeshes(o), this._clearFbo(c), a.logDepthBufFC = 2 / (Math.log(this._map.cameraFar + 1) / Math.LN2), this._renderer.render(this._depthShader, a, this._scene1, c);
        const l = s.read({
            data: i,
            x: e,
            y: t,
            framebuffer: c,
            width: n,
            height: r
        }), f = [];
        for(let e = 0; e < l.length; e += 4)f.push((d = l.subarray(e, e + 4), $1d56c6a18dbfd30f$var$yr[0] = d[3], $1d56c6a18dbfd30f$var$yr[1] = d[2], $1d56c6a18dbfd30f$var$yr[2] = d[1], $1d56c6a18dbfd30f$var$yr[3] = d[0], $1d56c6a18dbfd30f$var$Ar[0]));
        var d;
        return f;
    }
    _packData(e, t) {
        if (255 === e[0] && 255 === e[1] && 255 === e[2] && 255 === e[3]) return {
            meshId: null,
            pickingId: null
        };
        let n = null, r = null;
        return t === this._shader1 ? r = $1d56c6a18dbfd30f$var$br(e) : t === this._shader0 ? (r = e[3], n = $1d56c6a18dbfd30f$var$br(e)) : (r = null, n = $1d56c6a18dbfd30f$var$br(e)), {
            meshId: r,
            pickingId: n
        };
    }
    _clearFbo(e) {
        this._renderer.regl.clear({
            color: [
                1,
                1,
                1,
                1
            ],
            depth: 1,
            stencil: 255,
            framebuffer: e
        });
    }
    _getShader(e, t) {
        return t && e.length < 256 ? this._shader0 : this._shader1;
    }
    _getFBO1() {
        const e = this._renderer.regl, t = this._fbo;
        return this._fbo1 ? this._fbo1.width === t.width && this._fbo1.height === t.height || this._fbo1.resize(t.width, t.height) : this._fbo1 = e.framebuffer(t.width, t.height), this._fbo1;
    }
    _getParams(e, t, n, r) {
        const i = n[0], o = n[1];
        t = r.height - t;
        let a = 2 * i + 1, s = 2 * o + 1;
        const c = (e -= i) + a, l = (t -= o) + s;
        return c > r.width && (a -= c - r.width), l > r.height && (s -= l - r.height), {
            px: e = e < 0 ? 0 : e,
            py: t = t < 0 ? 0 : t,
            width: a,
            height: s
        };
    }
    getPickingVert() {
        return this._vert;
    }
    getUniformDeclares() {
        return this._uniforms;
    }
}
function $1d56c6a18dbfd30f$var$Ir(e, t, n) {
    const r = t[0], i = t[1], o = t[2], a = 1 / (n[3] * r + n[7] * i + n[11] * o + n[15]);
    return e[0] = (n[0] * r + n[4] * i + n[8] * o + n[12]) * a, e[1] = (n[1] * r + n[5] * i + n[9] * o + n[13]) * a, e[2] = (n[2] * r + n[6] * i + n[10] * o + n[14]) * a, e;
}
function $1d56c6a18dbfd30f$var$Rr(e) {
    return $1d56c6a18dbfd30f$var$g(e) && ($1d56c6a18dbfd30f$var$Mr[0] = $1d56c6a18dbfd30f$var$Mr[1] = e, e = $1d56c6a18dbfd30f$var$Mr), e;
}
const $1d56c6a18dbfd30f$var$Hr = (e)=>e && e.geometry && void 0 === e.geometry.properties.shaderHash, $1d56c6a18dbfd30f$var$Dr = [], $1d56c6a18dbfd30f$var$Fr = [], $1d56c6a18dbfd30f$var$Nr = [
    {
        name: "modelViewMatrix",
        type: "function",
        fn: (t, n)=>(0, $3iqbd).multiply($1d56c6a18dbfd30f$var$Dr, n.viewMatrix, n.modelMatrix)
    },
    {
        name: "modelViewProjMatrix",
        type: "function",
        fn: (t, n)=>{
            const r = (0, $3iqbd).multiply($1d56c6a18dbfd30f$var$Dr, n.viewMatrix, n.modelMatrix);
            return (0, $3iqbd).multiply($1d56c6a18dbfd30f$var$Dr, n.projMatrix, r);
        }
    },
    {
        name: "modelMatrixInverse",
        type: "function",
        fn: (t, n)=>(0, $3iqbd).invert($1d56c6a18dbfd30f$var$Dr, n.modelMatrix)
    },
    {
        name: "projMatrixInverse",
        type: "function",
        fn: (t, n)=>(0, $3iqbd).invert($1d56c6a18dbfd30f$var$Dr, n.projMatrix)
    },
    {
        name: "modelViewMatrixInverse",
        type: "function",
        fn: (t, n)=>((0, $3iqbd).multiply($1d56c6a18dbfd30f$var$Dr, n.viewMatrix, n.modelMatrix), (0, $3iqbd).invert($1d56c6a18dbfd30f$var$Dr, $1d56c6a18dbfd30f$var$Dr))
    },
    {
        name: "modelViewProjMatrixInverse",
        type: "function",
        fn: (t, n)=>{
            const r = (0, $3iqbd).multiply($1d56c6a18dbfd30f$var$Dr, n.viewMatrix, n.modelMatrix);
            return (0, $3iqbd).multiply($1d56c6a18dbfd30f$var$Dr, n.projMatrix, r), (0, $3iqbd).invert($1d56c6a18dbfd30f$var$Dr, $1d56c6a18dbfd30f$var$Dr);
        }
    },
    {
        name: "modelInverseTransposeMatrix",
        type: "function",
        fn: (e, t)=>{
            const n = (0, $bDSmI).fromMat4($1d56c6a18dbfd30f$var$Fr, t.modelMatrix), i = (0, $bDSmI).transpose(n, n);
            return (0, $bDSmI).invert(i, i);
        }
    },
    {
        name: "modelViewInverseTransposeMatrix",
        type: "function",
        fn: (t, n)=>{
            const i = (0, $3iqbd).multiply($1d56c6a18dbfd30f$var$Dr, n.viewMatrix, n.modelMatrix), o = (0, $bDSmI).fromMat4($1d56c6a18dbfd30f$var$Fr, i), a = (0, $bDSmI).transpose(o, o);
            return (0, $bDSmI).invert(a, a);
        }
    }
], $1d56c6a18dbfd30f$var$Lr = {
    LOCAL: "positionMatrix",
    MODEL: "modelMatrix",
    VIEW: "viewMatrix",
    PROJECTION: "projMatrix",
    MODELVIEW: "modelViewMatrix",
    MODELVIEWPROJECTION: "modelViewProjMatrix",
    MODELINVERSE: "modelMatrixInverse",
    VIEWINVERSE: "viewMatrixInverse",
    PROJECTIONINVERSE: "projMatrixInverse",
    MODELVIEWINVERSE: "modelViewMatrixInverse",
    MODELVIEWPROJECTIONINVERSE: "modelViewProjMatrixInverse",
    MODELINVERSETRANSPOSE: "modelInverseTransposeMatrix",
    MODELVIEWINVERSETRANSPOSE: "modelViewInverseTransposeMatrix",
    VIEWPORT: "viewport",
    JOINTMATRIX: "jointMatrix",
    ALPHACUTOFF: "alphaCutoff"
};
class $1d56c6a18dbfd30f$export$fd346f1db18c5e1 {
    constructor(e, t, n){
        this._regl = e, this._khrShaders = {}, this._commandProps = t, this._resLoader = n;
    }
    getExcludeFilter() {
        return $1d56c6a18dbfd30f$var$Hr;
    }
    forEachShader(e) {
        for(const t in this._khrShaders){
            const n = this._khrShaders[t];
            e(n.shader, n.filter, n.uniformSemantics);
        }
    }
    createMesh(e, t, n, r) {
        const i = t.extensions.KHR_techniques_webgl, o = t.materials[e.material].extensions.KHR_techniques_webgl, { technique: a, values: s } = o, c = i.techniques[a], l = i.programs[c.program], f = i.shaders[l.vertexShader], d = i.shaders[l.fragmentShader];
        d.content = function(e) {
            if (e && e.indexOf("precision") < 0) return "precision mediump float;\n" + e;
            return e;
        }(d.content);
        const u = $1d56c6a18dbfd30f$var$w(f.content) + "-" + $1d56c6a18dbfd30f$var$w(d.content);
        this._khrShaders[u] || (this._khrShaders[u] = this._createTechniqueShader(u, i, a, this._commandProps, r));
        const { attributeSemantics: h } = this._khrShaders[u], m = this._createGeometry(e, h, n, u), _ = $1d56c6a18dbfd30f$var$v({}, s);
        for(const e in s)if (c.uniforms[e] && 35678 === c.uniforms[e].type) _[e] = this._getTexture(t.textures[s[e].index]);
        return {
            geometry: m,
            material: new $1d56c6a18dbfd30f$export$a2d8b23205c25948(_)
        };
    }
    _createGeometry(e, t, n, r) {
        const i = e.attributes, o = "COLOR_0";
        if (i[o]) {
            const e = i[o].array || i[o];
            if (e instanceof Float32Array) {
                const t = new Uint8Array(e.length);
                for(let n = 0; n < t.length; n++)t[n] = Math.round(255 * e[n]);
                i[o].array ? (i[o].array = t, i[o].componentType = 5121) : i[o] = t;
            }
        }
        const a = {};
        for(const e in i){
            const n = $1d56c6a18dbfd30f$var$he(this._regl, i[e], {
                dimension: i[e].itemSize
            }), r = t[e] || e;
            a[r] = {
                buffer: n
            }, i[e].quantization && (a[r].quantization = i[e].quantization), r === t.POSITION && (a[r].array = i[e].array);
        }
        const s = new $1d56c6a18dbfd30f$export$2db6c17465f94a2(a, e.indices.array ? e.indices.array : e.indices, 0, {
            positionAttribute: t.POSITION,
            normalAttribute: t.NORMAL,
            uv0Attribute: t.TEXCOORD_0,
            uv1Attribute: t.TEXCOORD_1,
            color0Attribute: t.COLOR_0,
            tangentAttribute: t.TANGENT,
            textureCoordMatrixAttribute: t.TextureCoordMatrix,
            primitive: void 0 === e.mode ? "triangles" : $1d56c6a18dbfd30f$var$ee(e.mode)
        });
        s.generateBuffers(this._regl, {
            excludeElementsInVAO: n
        }), s.properties.shaderHash = r;
        const c = s.data[s.desc.positionAttribute];
        return c && c.array && delete c.array, s;
    }
    _getTexture(e) {
        const t = {
            type: e.type ? $1d56c6a18dbfd30f$var$ne(e.type) : "uint8",
            format: e.format ? $1d56c6a18dbfd30f$var$ie(e.format) : "rgba",
            flipY: !!e.flipY
        }, n = e.image;
        n.array ? t.data = n.array : n.mipmap && (t.mipmap = n.mipmap), t.width = n.width, t.height = n.height;
        const r = e.sampler || e.texture.sampler;
        return r && (r.magFilter && (t.mag = $1d56c6a18dbfd30f$var$ae(r.magFilter)), r.minFilter && (t.min = $1d56c6a18dbfd30f$var$ce(r.minFilter)), r.wrapS && (t.wrapS = $1d56c6a18dbfd30f$var$fe(r.wrapS)), r.wrapT && (t.wrapT = $1d56c6a18dbfd30f$var$fe(r.wrapT))), new $1d56c6a18dbfd30f$export$d7f9130fd509486(t, this._resLoader);
    }
    _createTechniqueShader(e, t, n, r, i) {
        const { techniques: o, programs: a, shaders: s } = t, c = o[n], l = a[c.program], f = s[l.vertexShader].content, d = s[l.fragmentShader].content, u = {};
        for(const e in c.uniforms){
            const t = c.uniforms[e];
            t.semantic && (u[t.semantic] = e);
        }
        const h = $1d56c6a18dbfd30f$var$Nr.slice();
        for(const e in u)h.push({
            name: u[e],
            type: "function",
            fn: (t, n)=>n[$1d56c6a18dbfd30f$var$Lr[e]]
        });
        const m = new $1d56c6a18dbfd30f$export$9d2cc9f1c4004434({
            vert: f,
            frag: d,
            uniforms: h,
            extraCommandProps: r
        });
        i && (m.version = 300);
        const v = {};
        for(const e in c.attributes)v[c.attributes[e].semantic] = e;
        return {
            shader: m,
            filter: (t)=>t && t.geometry && t.geometry.properties.shaderHash === e,
            uniformSemantics: u,
            attributeSemantics: v
        };
    }
    dispose() {
        for(const e in this._khrShaders){
            const { shader: t } = this._khrShaders[e];
            t.dispose();
        }
        this._khrShaders = {};
    }
}
function $1d56c6a18dbfd30f$var$Br(e, t, n, r, i) {
    let o;
    if (i === function(e, t, n, r) {
        let i = 0;
        for(let o = t, a = n - r; o < n; o += r)i += (e[a] - e[o]) * (e[o + 1] + e[a + 1]), a = o;
        return i;
    }(e, t, n, r) > 0) for(let i = t; i < n; i += r)o = $1d56c6a18dbfd30f$var$si(i / r | 0, e[i], e[i + 1], o);
    else for(let i = n - r; i >= t; i -= r)o = $1d56c6a18dbfd30f$var$si(i / r | 0, e[i], e[i + 1], o);
    return o && $1d56c6a18dbfd30f$var$ti(o, o.next) && ($1d56c6a18dbfd30f$var$ci(o), o = o.next), o;
}
function $1d56c6a18dbfd30f$var$zr(e, t) {
    if (!e) return e;
    t || (t = e);
    let n, r = e;
    do if (n = !1, r.steiner || !$1d56c6a18dbfd30f$var$ti(r, r.next) && 0 !== $1d56c6a18dbfd30f$var$ei(r.prev, r, r.next)) r = r.next;
    else {
        if ($1d56c6a18dbfd30f$var$ci(r), r = t = r.prev, r === r.next) break;
        n = !0;
    }
    while (n || r !== t);
    return t;
}
function $1d56c6a18dbfd30f$var$Gr(e, t, n, r, i, o, a) {
    if (!e) return;
    !a && o && function(e, t, n, r) {
        let i = e;
        do 0 === i.z && (i.z = $1d56c6a18dbfd30f$var$Jr(i.x, i.y, t, n, r)), i.prevZ = i.prev, i.nextZ = i.next, i = i.next;
        while (i !== e);
        i.prevZ.nextZ = null, i.prevZ = null, function(e) {
            let t, n = 1;
            do {
                let r, i = e;
                e = null;
                let o = null;
                for(t = 0; i;){
                    t++;
                    let a = i, s = 0;
                    for(let e = 0; e < n && (s++, a = a.nextZ, a); e++);
                    let c = n;
                    for(; s > 0 || c > 0 && a;)0 !== s && (0 === c || !a || i.z <= a.z) ? (r = i, i = i.nextZ, s--) : (r = a, a = a.nextZ, c--), o ? o.nextZ = r : e = r, r.prevZ = o, o = r;
                    i = a;
                }
                o.nextZ = null, n *= 2;
            }while (t > 1);
        }(i);
    }(e, r, i, o);
    let s = e;
    for(; e.prev !== e.next;){
        const c = e.prev, l = e.next;
        if (o ? $1d56c6a18dbfd30f$var$Ur(e, r, i, o) : $1d56c6a18dbfd30f$var$Vr(e)) t.push(c.i, e.i, l.i), $1d56c6a18dbfd30f$var$ci(e), e = l.next, s = l.next;
        else if ((e = l) === s) {
            a ? 1 === a ? $1d56c6a18dbfd30f$var$Gr(e = $1d56c6a18dbfd30f$var$jr($1d56c6a18dbfd30f$var$zr(e), t), t, n, r, i, o, 2) : 2 === a && $1d56c6a18dbfd30f$var$Xr(e, t, n, r, i, o) : $1d56c6a18dbfd30f$var$Gr($1d56c6a18dbfd30f$var$zr(e), t, n, r, i, o, 1);
            break;
        }
    }
}
function $1d56c6a18dbfd30f$var$Vr(e) {
    const t = e.prev, n = e, r = e.next;
    if ($1d56c6a18dbfd30f$var$ei(t, n, r) >= 0) return !1;
    const i = t.x, o = n.x, a = r.x, s = t.y, c = n.y, l = r.y, f = Math.min(i, o, a), d = Math.min(s, c, l), u = Math.max(i, o, a), h = Math.max(s, c, l);
    let m = r.next;
    for(; m !== t;){
        if (m.x >= f && m.x <= u && m.y >= d && m.y <= h && $1d56c6a18dbfd30f$var$Qr(i, s, o, c, a, l, m.x, m.y) && $1d56c6a18dbfd30f$var$ei(m.prev, m, m.next) >= 0) return !1;
        m = m.next;
    }
    return !0;
}
function $1d56c6a18dbfd30f$var$Ur(e, t, n, r) {
    const i = e.prev, o = e, a = e.next;
    if ($1d56c6a18dbfd30f$var$ei(i, o, a) >= 0) return !1;
    const s = i.x, c = o.x, l = a.x, f = i.y, d = o.y, u = a.y, h = Math.min(s, c, l), m = Math.min(f, d, u), v = Math.max(s, c, l), _ = Math.max(f, d, u), g = $1d56c6a18dbfd30f$var$Jr(h, m, t, n, r), x = $1d56c6a18dbfd30f$var$Jr(v, _, t, n, r);
    let p = e.prevZ, b = e.nextZ;
    for(; p && p.z >= g && b && b.z <= x;){
        if (p.x >= h && p.x <= v && p.y >= m && p.y <= _ && p !== i && p !== a && $1d56c6a18dbfd30f$var$Qr(s, f, c, d, l, u, p.x, p.y) && $1d56c6a18dbfd30f$var$ei(p.prev, p, p.next) >= 0) return !1;
        if (p = p.prevZ, b.x >= h && b.x <= v && b.y >= m && b.y <= _ && b !== i && b !== a && $1d56c6a18dbfd30f$var$Qr(s, f, c, d, l, u, b.x, b.y) && $1d56c6a18dbfd30f$var$ei(b.prev, b, b.next) >= 0) return !1;
        b = b.nextZ;
    }
    for(; p && p.z >= g;){
        if (p.x >= h && p.x <= v && p.y >= m && p.y <= _ && p !== i && p !== a && $1d56c6a18dbfd30f$var$Qr(s, f, c, d, l, u, p.x, p.y) && $1d56c6a18dbfd30f$var$ei(p.prev, p, p.next) >= 0) return !1;
        p = p.prevZ;
    }
    for(; b && b.z <= x;){
        if (b.x >= h && b.x <= v && b.y >= m && b.y <= _ && b !== i && b !== a && $1d56c6a18dbfd30f$var$Qr(s, f, c, d, l, u, b.x, b.y) && $1d56c6a18dbfd30f$var$ei(b.prev, b, b.next) >= 0) return !1;
        b = b.nextZ;
    }
    return !0;
}
function $1d56c6a18dbfd30f$var$jr(e, t) {
    let n = e;
    do {
        const r = n.prev, i = n.next.next;
        !$1d56c6a18dbfd30f$var$ti(r, i) && $1d56c6a18dbfd30f$var$ni(r, n, n.next, i) && $1d56c6a18dbfd30f$var$oi(r, i) && $1d56c6a18dbfd30f$var$oi(i, r) && (t.push(r.i, n.i, i.i), $1d56c6a18dbfd30f$var$ci(n), $1d56c6a18dbfd30f$var$ci(n.next), n = e = i), n = n.next;
    }while (n !== e);
    return $1d56c6a18dbfd30f$var$zr(n);
}
function $1d56c6a18dbfd30f$var$Xr(e, t, n, r, i, o) {
    let a = e;
    do {
        let e = a.next.next;
        for(; e !== a.prev;){
            if (a.i !== e.i && $1d56c6a18dbfd30f$var$$r(a, e)) {
                let s = $1d56c6a18dbfd30f$var$ai(a, e);
                return a = $1d56c6a18dbfd30f$var$zr(a, a.next), s = $1d56c6a18dbfd30f$var$zr(s, s.next), $1d56c6a18dbfd30f$var$Gr(a, t, n, r, i, o, 0), void $1d56c6a18dbfd30f$var$Gr(s, t, n, r, i, o, 0);
            }
            e = e.next;
        }
        a = a.next;
    }while (a !== e);
}
function $1d56c6a18dbfd30f$var$Wr(e, t) {
    let n = e.x - t.x;
    if (0 === n && (n = e.y - t.y, 0 === n)) n = (e.next.y - e.y) / (e.next.x - e.x) - (t.next.y - t.y) / (t.next.x - t.x);
    return n;
}
function $1d56c6a18dbfd30f$var$qr(e, t) {
    const n = function(e, t) {
        let n = t;
        const r = e.x, i = e.y;
        let o, a = -1 / 0;
        if ($1d56c6a18dbfd30f$var$ti(e, n)) return n;
        do {
            if ($1d56c6a18dbfd30f$var$ti(e, n.next)) return n.next;
            if (i <= n.y && i >= n.next.y && n.next.y !== n.y) {
                const e = n.x + (i - n.y) * (n.next.x - n.x) / (n.next.y - n.y);
                if (e <= r && e > a && (a = e, o = n.x < n.next.x ? n : n.next, e === r)) return o;
            }
            n = n.next;
        }while (n !== t);
        if (!o) return null;
        const s = o, c = o.x, l = o.y;
        let f = 1 / 0;
        n = o;
        do {
            if (r >= n.x && n.x >= c && r !== n.x && $1d56c6a18dbfd30f$var$Zr(i < l ? r : a, i, c, l, i < l ? a : r, i, n.x, n.y)) {
                const t = Math.abs(i - n.y) / (r - n.x);
                $1d56c6a18dbfd30f$var$oi(n, e) && (t < f || t === f && (n.x > o.x || n.x === o.x && $1d56c6a18dbfd30f$var$Kr(o, n))) && (o = n, f = t);
            }
            n = n.next;
        }while (n !== s);
        return o;
    }(e, t);
    if (!n) return t;
    const r = $1d56c6a18dbfd30f$var$ai(n, e);
    return $1d56c6a18dbfd30f$var$zr(r, r.next), $1d56c6a18dbfd30f$var$zr(n, n.next);
}
function $1d56c6a18dbfd30f$var$Kr(e, t) {
    return $1d56c6a18dbfd30f$var$ei(e.prev, e, t.prev) < 0 && $1d56c6a18dbfd30f$var$ei(t.next, e, e.next) < 0;
}
function $1d56c6a18dbfd30f$var$Jr(e, t, n, r, i) {
    return (e = 1431655765 & ((e = 858993459 & ((e = 252645135 & ((e = 16711935 & ((e = (e - n) * i | 0) | e << 8)) | e << 4)) | e << 2)) | e << 1)) | (t = 1431655765 & ((t = 858993459 & ((t = 252645135 & ((t = 16711935 & ((t = (t - r) * i | 0) | t << 8)) | t << 4)) | t << 2)) | t << 1)) << 1;
}
function $1d56c6a18dbfd30f$var$Yr(e) {
    let t = e, n = e;
    do (t.x < n.x || t.x === n.x && t.y < n.y) && (n = t), t = t.next;
    while (t !== e);
    return n;
}
function $1d56c6a18dbfd30f$var$Zr(e, t, n, r, i, o, a, s) {
    return (i - a) * (t - s) >= (e - a) * (o - s) && (e - a) * (r - s) >= (n - a) * (t - s) && (n - a) * (o - s) >= (i - a) * (r - s);
}
function $1d56c6a18dbfd30f$var$Qr(e, t, n, r, i, o, a, s) {
    return !(e === a && t === s) && $1d56c6a18dbfd30f$var$Zr(e, t, n, r, i, o, a, s);
}
function $1d56c6a18dbfd30f$var$$r(e, t) {
    return e.next.i !== t.i && e.prev.i !== t.i && !function(e, t) {
        let n = e;
        do {
            if (n.i !== e.i && n.next.i !== e.i && n.i !== t.i && n.next.i !== t.i && $1d56c6a18dbfd30f$var$ni(n, n.next, e, t)) return !0;
            n = n.next;
        }while (n !== e);
        return !1;
    }(e, t) && ($1d56c6a18dbfd30f$var$oi(e, t) && $1d56c6a18dbfd30f$var$oi(t, e) && function(e, t) {
        let n = e, r = !1;
        const i = (e.x + t.x) / 2, o = (e.y + t.y) / 2;
        do n.y > o != n.next.y > o && n.next.y !== n.y && i < (n.next.x - n.x) * (o - n.y) / (n.next.y - n.y) + n.x && (r = !r), n = n.next;
        while (n !== e);
        return r;
    }(e, t) && ($1d56c6a18dbfd30f$var$ei(e.prev, e, t.prev) || $1d56c6a18dbfd30f$var$ei(e, t.prev, t)) || $1d56c6a18dbfd30f$var$ti(e, t) && $1d56c6a18dbfd30f$var$ei(e.prev, e, e.next) > 0 && $1d56c6a18dbfd30f$var$ei(t.prev, t, t.next) > 0);
}
function $1d56c6a18dbfd30f$var$ei(e, t, n) {
    return (t.y - e.y) * (n.x - t.x) - (t.x - e.x) * (n.y - t.y);
}
function $1d56c6a18dbfd30f$var$ti(e, t) {
    return e.x === t.x && e.y === t.y;
}
function $1d56c6a18dbfd30f$var$ni(e, t, n, r) {
    const i = $1d56c6a18dbfd30f$var$ii($1d56c6a18dbfd30f$var$ei(e, t, n)), o = $1d56c6a18dbfd30f$var$ii($1d56c6a18dbfd30f$var$ei(e, t, r)), a = $1d56c6a18dbfd30f$var$ii($1d56c6a18dbfd30f$var$ei(n, r, e)), s = $1d56c6a18dbfd30f$var$ii($1d56c6a18dbfd30f$var$ei(n, r, t));
    return i !== o && a !== s || !(0 !== i || !$1d56c6a18dbfd30f$var$ri(e, n, t)) || !(0 !== o || !$1d56c6a18dbfd30f$var$ri(e, r, t)) || !(0 !== a || !$1d56c6a18dbfd30f$var$ri(n, e, r)) || !(0 !== s || !$1d56c6a18dbfd30f$var$ri(n, t, r));
}
function $1d56c6a18dbfd30f$var$ri(e, t, n) {
    return t.x <= Math.max(e.x, n.x) && t.x >= Math.min(e.x, n.x) && t.y <= Math.max(e.y, n.y) && t.y >= Math.min(e.y, n.y);
}
function $1d56c6a18dbfd30f$var$ii(e) {
    return e > 0 ? 1 : e < 0 ? -1 : 0;
}
function $1d56c6a18dbfd30f$var$oi(e, t) {
    return $1d56c6a18dbfd30f$var$ei(e.prev, e, e.next) < 0 ? $1d56c6a18dbfd30f$var$ei(e, t, e.next) >= 0 && $1d56c6a18dbfd30f$var$ei(e, e.prev, t) >= 0 : $1d56c6a18dbfd30f$var$ei(e, t, e.prev) < 0 || $1d56c6a18dbfd30f$var$ei(e, e.next, t) < 0;
}
function $1d56c6a18dbfd30f$var$ai(e, t) {
    const n = $1d56c6a18dbfd30f$var$li(e.i, e.x, e.y), r = $1d56c6a18dbfd30f$var$li(t.i, t.x, t.y), i = e.next, o = t.prev;
    return e.next = t, t.prev = e, n.next = i, i.prev = n, r.next = n, n.prev = r, o.next = r, r.prev = o, r;
}
function $1d56c6a18dbfd30f$var$si(e, t, n, r) {
    const i = $1d56c6a18dbfd30f$var$li(e, t, n);
    return r ? (i.next = r.next, i.prev = r, r.next.prev = i, r.next = i) : (i.prev = i, i.next = i), i;
}
function $1d56c6a18dbfd30f$var$ci(e) {
    e.next.prev = e.prev, e.prev.next = e.next, e.prevZ && (e.prevZ.nextZ = e.nextZ), e.nextZ && (e.nextZ.prevZ = e.prevZ);
}
function $1d56c6a18dbfd30f$var$li(e, t, n) {
    return {
        i: e,
        x: t,
        y: n,
        prev: null,
        next: null,
        z: 0,
        prevZ: null,
        nextZ: null,
        steiner: !1
    };
}
const $1d56c6a18dbfd30f$export$974bc3a953a52182 = {
    parseHDR: $1d56c6a18dbfd30f$var$it
}, $1d56c6a18dbfd30f$export$c66bc961f5364fa5 = {
    PBRHelper: $1d56c6a18dbfd30f$var$or,
    StandardMaterial: $1d56c6a18dbfd30f$var$sr,
    StandardSpecularGlossinessMaterial: $1d56c6a18dbfd30f$var$cr,
    StandardShader: class extends $1d56c6a18dbfd30f$export$9d2cc9f1c4004434 {
        constructor(t = {}){
            let n = t.extraCommandProps || {};
            const i = t.uniforms;
            n = $1d56c6a18dbfd30f$var$v({}, n);
            const o = t.defines || {}, a = [], s = [], c = [], l = [], f = [], d = [
                {
                    name: "modelNormalMatrix",
                    type: "function",
                    fn: (e, t)=>(0, $bDSmI).fromMat4(a, t.modelMatrix)
                },
                {
                    name: "modelViewNormalMatrix",
                    type: "function",
                    fn: (t, n)=>{
                        const i = (0, $3iqbd).multiply(s, n.viewMatrix, n.modelMatrix), o = (0, $3iqbd).invert(i, i), a = (0, $3iqbd).transpose(o, o);
                        return (0, $bDSmI).fromMat4(c, a);
                    }
                },
                {
                    name: "modelViewMatrix",
                    type: "function",
                    fn: (t, n)=>(0, $3iqbd).multiply(l, n.viewMatrix, n.modelMatrix)
                },
                {
                    name: "environmentTransform",
                    type: "function",
                    fn: (e, t)=>(0, $bDSmI).fromRotation(f, Math.PI * (t.environmentOrientation || 0) / 180)
                }
            ];
            i && d.push(...i);
            super({
                vert: t.vert || "#include <gl2_vert>\n#define SHADER_NAME PBR\nprecision highp float;\nattribute vec3 aPosition;\n#if defined(HAS_MAP)\nattribute vec2 aTexCoord;\nuniform vec2 uvOrigin;\nuniform vec2 uvScale;\nuniform vec2 uvOffset;\nuniform float uvRotation;\n#ifdef HAS_I3S_UVREGION\nattribute vec4 uvRegion;\nvarying vec4 vUvRegion;\n#endif\n#if defined(HAS_AO_MAP)\nattribute vec2 aTexCoord1;\nvarying vec2 vTexCoord1;\n#endif\n#endif\nvec3 c;\nvec3 d;\nvec4 e;\nuniform mat4 modelMatrix;\nuniform mat4 modelViewMatrix;\nuniform mat4 positionMatrix;\nuniform mat4 projMatrix;\nuniform mediump vec3 cameraPosition;\nuniform mat3 modelNormalMatrix;\n#ifdef HAS_SSR\nuniform mat3 modelViewNormalMatrix;\nvarying vec3 vViewNormal;\n#ifdef HAS_TANGENT\nvarying vec4 vViewTangent;\n#endif\n#endif\nvarying vec3 vModelNormal;\nvarying vec4 vViewVertex;\n#if defined(HAS_TANGENT)\nvarying vec4 vModelTangent;\nvarying vec3 vModelBiTangent;\n#endif\nvarying vec3 vModelVertex;\n#if defined(HAS_MAP)\nvarying vec2 vTexCoord;\n#endif\n#if defined(HAS_COLOR)\nattribute vec4 aColor;\nvarying vec4 vColor;\n#endif\n#ifdef HAS_OPACITY\nattribute float aOpacity;\n#endif\nvarying float vOpacity;\n#include <highlight_vert>\n#if defined(HAS_COLOR0)\n#if COLOR0_SIZE == 3\nattribute vec3 aColor0;\nvarying vec3 vColor0;\n#else\nattribute vec4 aColor0;\nvarying vec4 vColor0;\n#endif\n#endif\n#include <line_extrusion_vert>\n#include <get_output>\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n#include <vsm_shadow_vert>\n#endif\n#include <heatmap_render_vert>\n#include <vertex_color_vert>\n#if defined(HAS_BUMP_MAP) && defined(HAS_TANGENT)\nvarying vec3 vTangentViewPos;\nvarying vec3 vTangentFragPos;\n#if __VERSION__ == 100\nmat3 f(in mat3 h) {\n  vec3 i = h[0];\n  vec3 j = h[1];\n  vec3 k = h[2];\n  return mat3(vec3(i.x, j.x, k.x), vec3(i.y, j.y, k.y), vec3(i.z, j.z, k.z));\n}\n#else\nmat3 f(in mat3 h) {\n  return transpose(h);\n}\n#endif\n#endif\nvoid l(const highp vec4 q, out highp vec3 m) {\n  m = vec3(.0, .0, 1.) + vec3(2., -2., -2.) * q.x * q.zwx + vec3(2., 2., -2.) * q.y * q.wzy;\n}\nvoid l(const highp vec4 q, out highp vec3 m, out highp vec3 t) {\n  l(q, m);\n  t = vec3(1., .0, .0) + vec3(-2., 2., -2.) * q.y * q.yxw + vec3(-2., 2., 2.) * q.z * q.zwx;\n}\nconst float o = .5;\nvec2 u(vec2 v, float A) {\n  return vec2(cos(A) * (v.x - o) + sin(A) * (v.y - o) + o, cos(A) * (v.y - o) - sin(A) * (v.x - o) + o);\n}\n#if defined(HAS_MAP)\nvec2 B(vec2 v) {\n  vec2 C = decode_getTexcoord(v);\n#ifdef HAS_RANDOM_TEX\nvec2 D = uvOrigin;\n  vec2 E = C * uvScale + uvOffset;\n  return mod(D, 1.) + E;\n#else\nvec2 D = uvOrigin;\n  vec2 E = C * uvScale;\n  if(uvRotation != .0) {\n    D = u(D, uvRotation);\n    E = u(E, uvRotation);\n  }\n  return mod(D, 1.) + E + uvOffset;\n#endif\n}\n#endif\n#ifdef PICKING_MODE\n#include <fbo_picking_vert>\n#endif\n#include <excavate_vert>\nvoid main() {\n  mat4 F = getPositionMatrix();\n#ifdef IS_LINE_EXTRUSION\nvec3 G = getLineExtrudePosition(aPosition);\n  vec4 H = getPosition(G);\n#else\nvec4 H = getPosition(aPosition);\n#endif\nvModelVertex = (modelMatrix * H).xyz;\n  vec4 I = F * H;\n  vec4 J = modelViewMatrix * I;\n  vViewVertex = J;\n#ifdef HAS_MASK_EXTENT\ngl_Position = projMatrix * getMaskPosition(I, modelMatrix);\n#else\ngl_Position = projMatrix * J;\n#endif\n#ifdef PICKING_MODE\nfloat K = 1.;\n#if defined(HAS_COLOR)\nK *= aColor.a;\n#endif\n#if defined(HAS_COLOR0) && COLOR0_SIZE == 4\nK *= aColor0.a;\n#endif\nfbo_picking_setData(gl_Position.w, K != .0);\n#else\n#if defined(HAS_MAP)\nvTexCoord = B(aTexCoord);\n#ifdef HAS_AO_MAP\nvTexCoord1 = B(aTexCoord1);\n#endif\n#ifdef HAS_I3S_UVREGION\nvUvRegion = uvRegion / 65535.;\n#endif\n#endif\n#if defined(HAS_TANGENT) || defined(HAS_NORMAL)\nmat3 L = mat3(F);\n  mat3 M = modelNormalMatrix * L;\n#if defined(HAS_TANGENT)\nvec3 t;\n  l(aTangent, d, t);\n  vModelTangent = vec4(M * t, aTangent.w);\n#else\nd = decode_getNormal(aNormal);\n#endif\nvec3 N = d;\n  vModelNormal = M * N;\n#else\nd = vec3(.0);\n  vModelNormal = vec3(.0);\n#endif\n#if defined(HAS_TANGENT)\nvModelBiTangent = cross(vModelNormal, vModelTangent.xyz) * sign(aTangent.w);\n#endif\n#ifdef HAS_SSR\nmat3 O = modelViewNormalMatrix * L;\n  vViewNormal = O * d;\n#if defined(HAS_TANGENT)\nvec4 P = vec4(t, aTangent.w);\n  vViewTangent = vec4(O * P.xyz, P.w);\n#endif\n#endif\n#if defined(HAS_COLOR)\nvColor = aColor / 255.;\n#endif\n#ifdef HAS_OPACITY\nvOpacity = aOpacity / 255.;\n#else\nvOpacity = 1.;\n#endif\nhighlight_setVarying();\n#if defined(HAS_COLOR0)\nvColor0 = aColor0 / 255.;\n#endif\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\nshadow_computeShadowPars(I);\n#endif\n#ifdef HAS_HEATMAP\nheatmap_compute(projMatrix * modelViewMatrix * F, H);\n#endif\n#if defined(HAS_BUMP_MAP) && defined(HAS_TANGENT)\nmat3 Q = f(mat3(vModelTangent.xyz, vModelBiTangent, vModelNormal));\n  vTangentViewPos = Q * cameraPosition;\n  vTangentFragPos = Q * vModelVertex;\n#endif\n#ifdef HAS_VERTEX_COLOR\nvertexColor_update();\n#endif\n#ifdef HAS_EXCAVATE_ANALYSIS\nvCoordinateTexcoord = getCoordinateTexcoord();\n  vHeight = getWorldHeight();\n#endif\n#endif\n}",
                frag: t.frag || "#define PI 3.141593\n#define RECIPROCAL_PI 1.0\n#if __VERSION__ == 100\n#if defined(GL_EXT_shader_texture_lod)\n#extension GL_EXT_shader_texture_lod : enable\n#define textureCubeLod(tex, uv, lod) textureCubeLodEXT(tex, uv, lod)\n#else\n#define textureCubeLod(tex, uv, lod) textureCube(tex, uv, lod)\n#endif\n#if defined(GL_OES_standard_derivatives)\n#extension GL_OES_standard_derivatives : enable\n#endif\n#else\n#define textureCubeLod(tex, uv, lod) textureLod(tex, uv, lod)\n#endif\n#define saturate(x)        clamp(x, 0.0, 1.0)\nprecision mediump float;\n#include <gl2_frag>\n#include <hsv_frag>\n#include <srgb_frag>\nuniform vec3 hsv;\nuniform float contrast;\nstruct MaterialUniforms {\n  vec2 roughnessMetalness;\n  vec3 albedo;\n  float alpha;\n  vec3 normal;\n  vec3 emit;\n  float ao;\n  vec3 specularColor;\n  float glossiness;\n  vec4 skinColor;\n} c;\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n#include <vsm_shadow_frag>\n#endif\nuniform vec3 cameraPosition;\nuniform float alphaTest;\n#if defined(SHADING_MODEL_SPECULAR_GLOSSINESS)\nuniform vec4 diffuseFactor;\nuniform vec3 specularFactor;\nuniform float glossinessFactor;\n#if defined(HAS_DIFFUSE_MAP)\nuniform sampler2D diffuseTexture;\n#endif\n#if defined(HAS_SPECULARGLOSSINESS_MAP)\nuniform sampler2D specularGlossinessTexture;\n#endif\n#endif\nuniform vec3 emissiveFactor;\nuniform vec4 baseColorFactor;\nuniform float baseColorIntensity;\nuniform float emitColorFactor;\nuniform float occlusionFactor;\nuniform float environmentExposure;\nuniform float roughnessFactor;\nuniform float metallicFactor;\nuniform float normalMapFactor;\nuniform float specularF0;\nuniform int emitMultiplicative;\nuniform int normalMapFlipY;\nuniform int outputSRGB;\nuniform mat3 environmentTransform;\n#if defined(HAS_ALBEDO_MAP)\nuniform sampler2D baseColorTexture;\n#endif\n#if defined(HAS_METALLICROUGHNESS_MAP)\nuniform sampler2D metallicRoughnessTexture;\n#endif\n#if defined(HAS_EMISSIVE_MAP)\nuniform sampler2D emissiveTexture;\n#endif\n#if defined(HAS_AO_MAP)\nuniform sampler2D occlusionTexture;\nvarying vec2 vTexCoord1;\n#endif\n#if defined(HAS_NORMAL_MAP) && defined(HAS_TANGENT)\nuniform sampler2D normalTexture;\n#endif\n#if defined(HAS_SKIN_MAP)\nuniform sampler2D skinTexture;\n#endif\n#if defined(ALPHA_MODE) && ALPHA_MODE == 1\nuniform float alphaCutoff;\n#endif\n#ifdef HAS_RANDOM_TEX\nuniform highp vec2 uvOrigin;\nuniform sampler2D noiseTexture;\n#endif\nuniform sampler2D brdfLUT;\n#if defined(HAS_IBL_LIGHTING)\nuniform vec3 hdrHSV;\nuniform samplerCube prefilterMap;\nuniform vec3 diffuseSPH[9];\nuniform vec2 prefilterMiplevel;\nuniform vec2 prefilterSize;\n#else\nuniform vec3 ambientColor;\n#endif\nuniform vec2 cameraNearFar;\nuniform vec3 light0_viewDirection;\nuniform vec4 light0_diffuse;\n#ifdef HAS_SSR\nvarying vec3 vViewNormal;\n#if defined(HAS_TANGENT)\nvarying vec4 vViewTangent;\n#endif\n#endif\nvarying vec3 vModelVertex;\nvarying vec4 vViewVertex;\n#if defined(HAS_MAP)\n#include <computeTexcoord_frag>\n#endif\nvarying vec3 vModelNormal;\n#if defined(HAS_TANGENT)\nvarying vec4 vModelTangent;\nvarying vec3 vModelBiTangent;\n#endif\n#if defined(HAS_COLOR0)\n#if COLOR0_SIZE == 3\nvarying vec3 vColor0;\n#else\nvarying vec4 vColor0;\n#endif\n#endif\n#if defined(HAS_COLOR)\nvarying vec4 vColor;\n#elif defined(IS_LINE_EXTRUSION)\nuniform vec4 lineColor;\n#else\nuniform vec4 polygonFill;\n#endif\n#ifdef HAS_LAYER_OPACITY\nuniform float layerOpacity;\n#endif\nvarying float vOpacity;\n#ifdef HAS_INSTANCE_COLOR\nvarying vec4 vInstanceColor;\n#endif\n#ifdef IS_LINE_EXTRUSION\nuniform float lineOpacity;\n#else\nuniform float polygonOpacity;\n#endif\n#ifdef HAS_PATTERN\nuniform sampler2D linePatternFile;\nuniform vec2 atlasSize;\nuniform float flipY;\nuniform float currentTime;\nuniform float animSpeedScale;\n#ifdef HAS_PATTERN_ANIM\nvarying float vLinePatternAnimSpeed;\n#else\nuniform float linePatternAnimSpeed;\n#endif\n#ifdef HAS_PATTERN_GAP\nvarying float vLinePatternGap;\n#else\nuniform float linePatternGap;\n#endif\nuniform vec4 linePatternGapColor;\nuniform vec2 uvScale;\nvarying float vPatternHeight;\nvarying float vLinesofar;\nvarying vec4 vTexInfo;\nvarying float vNormalY;\nvec2 d(vec2 e) {\n  vec2 f = mod(e, 1.);\n  vec2 h = vTexInfo.xy;\n  vec2 i = vTexInfo.zw;\n  return (h + f * i) / atlasSize;\n}\n#endif\n#include <heatmap_render_frag>\n#include <snow_frag>\n#include <mask_frag>\n#include <terrain_normal_frag>\n#include <vertex_color_frag>\n#include <excavate_frag>\n#ifdef HAS_RANDOM_TEX\nconst float j = .5;\nvec2 k(vec2 f, float l) {\n  return vec2(cos(l) * (f.x - j) + sin(l) * (f.y - j) + j, cos(l) * (f.y - j) - sin(l) * (f.x - j) + j);\n}\nfloat m(vec3 n) {\n  return n.x + n.y + n.z;\n}\n#endif\nvec4 o(sampler2D u, in vec2 f) {\n  \n#ifdef HAS_RANDOM_TEX\nhighp vec2 A = uvOrigin;\n  highp vec2 B = f + A - mod(A, 1.);\n  float C = texture2D(noiseTexture, .005 * B).x;\n  vec2 D = dFdx(B);\n  vec2 E = dFdx(B);\n  float F = C * 8.;\n  float G = fract(F);\n#if 1\nfloat H = floor(F);\n  float I = H + 1.;\n#else\nfloat H = floor(F + .5);\n  float I = floor(F);\n  G = min(G, 1. - G) * 2.;\n#endif\nvec2 J = sin(vec2(3., 7.) * H);\n  vec2 K = sin(vec2(3., 7.) * I);\n  float L = .5;\n  vec4 M = texture2DGradEXT(u, f + L * J, D, E);\n  vec4 N = texture2DGradEXT(u, f + L * K, D, E);\n  return mix(M, N, smoothstep(.2, .8, G - .1 * m(M.xyz - N.xyz)));\n#else\nreturn texture2D(u, f);\n#endif\n}\n#if defined(HAS_BUMP_MAP) && defined(HAS_TANGENT)\nuniform sampler2D bumpTexture;\nuniform float bumpScale;\nuniform float bumpMaxLayers;\nuniform float bumpMinLayers;\nvec2 O(vec2 f, vec3 P) {\n  float Q = mix(bumpMaxLayers, bumpMinLayers, abs(dot(vec3(.0, .0, 1.), P)));\n  float R = 1. / Q;\n  float S = .0;\n  vec2 T = P.xy * bumpScale / (P.z * Q);\n  vec2 U = f;\n  float V = o(bumpTexture, U).r;\n  for(int W = 0; W < 30; W++) {\n    S += R;\n    U -= T;\n    V = o(bumpTexture, U).r;\n    if(V < S) {\n      break;\n    }\n  }\n  vec2 X = U + T;\n  float Y = V - S;\n  float Z = o(bumpTexture, X).r - S + R;\n  return mix(U, X, Y / (Y - Z));\n}\nvarying vec3 vTangentViewPos;\nvarying vec3 vTangentFragPos;\n#endif\n#define SHADER_NAME PBR\nvec3 ba() {\n  return c.albedo;\n}\nfloat bb() {\n  return c.alpha;\n}\nfloat bc() {\n  return c.roughnessMetalness.y;\n}\nfloat bd() {\n  \n#if defined(SHADING_MODEL_SPECULAR_GLOSSINESS)\nreturn 1. - c.glossiness;\n#else\nreturn c.roughnessMetalness.x;\n#endif\n}\nvec3 be() {\n  return c.emit;\n}\nvec4 bf() {\n  return c.skinColor;\n}\nvec3 bg() {\n  return c.normal;\n}\nfloat bh() {\n  return c.ao;\n}\nfloat bi(const in vec4 bj) {\n  return bj.r + bj.g / 255.;\n}\nvec3 bk(const in float bl, in vec3 bm, const in vec3 t, const in vec3 b, in vec3 bn) {\n  bm.xy = bl * bm.xy;\n  mat3 bo = mat3(t, b, bn);\n  return normalize(bo * bm);\n}\nfloat bp(const float bq, const vec3 bm, const vec3 br) {\n  float bs = clamp(dot(bm, br), 0., 1.);\n  float a = bq * bq;\n  float bt = a * a;\n  float bu = (bs * bt - bs) * bs + 1.;\n  return bt / (PI * bu * bu);\n}\nvec3 bv(const vec3 bw, const float bx, const in vec3 by, const in vec3 br) {\n  float bz = clamp(dot(by, br), 0., 1.);\n  bz = pow(1. - bz, 5.);\n  return bx * bz + (1. - bz) * bw;\n}\nfloat bA(const in vec3 bm, const in vec3 bB, const in float bq, const float bC) {\n  float bD = clamp(dot(bm, bB), 0., 1.);\n  float a = bq * bq;\n  float bE = bD * (bC * (1. - a) + a);\n  float bF = bC * (bD * (1. - a) + a);\n  return .5 / (bF + bE);\n}\nvec3 bG(const float bq, const vec3 bm, const vec3 bB, const vec3 by, const vec3 bH, const float bC, const float bx) {\n  vec3 br = normalize(bB + by);\n  float bI = bp(bq, bm, br);\n  float bJ = bA(bm, bB, bq, bC);\n  vec3 bK = bv(bH, bx, by, br);\n  return (bI * bJ * PI) * bK;\n}\nvec3 bL(const in vec3 bM) {\n  return RECIPROCAL_PI * bM;\n}\nvoid bN(const in vec3 bm, const in vec3 bB, const in float bC, const in float bq, const in vec3 bO, const in vec3 bH, const in vec3 bP, const in vec3 by, const in float bx, out vec3 bQ, out vec3 bR) {\n  if(bC <= .0) {\n    bR = bQ = vec3(.0);\n    return;\n  }\n  vec3 a = bC * bP;\n  vec3 bS = bG(bq, bm, bB, by, bH, bC, bx);\n  bR = a * bS;\n  bQ = a * bL(bO);\n}\n#if defined(HAS_IBL_LIGHTING)\nvec3 bT(const in vec3 bm) {\n  vec3 bn = environmentTransform * bm;\n  float x = bn.x;\n  float y = bn.y;\n  float z = bn.z;\n  vec3 bU = (diffuseSPH[0] + diffuseSPH[1] * x + diffuseSPH[2] * y + diffuseSPH[3] * z + diffuseSPH[4] * z * x + diffuseSPH[5] * y * z + diffuseSPH[6] * y * x + diffuseSPH[7] * (3. * z * z - 1.) + diffuseSPH[8] * (x * x - y * y));\n  if(length(hdrHSV) > .0) {\n    bU = hsv_apply(bU, hdrHSV);\n  }\n  return max(bU, vec3(.0));\n}\nvec3 bV(const in float bq, const in vec3 bW) {\n  vec3 bX = bW;\n  float bY = prefilterMiplevel.x;\n  float bZ = min(bY, bq * prefilterMiplevel.y);\n  vec3 ca = textureCubeLod(prefilterMap, bX, bZ).rgb;\n  if(length(hdrHSV) > .0) {\n    return hsv_apply(ca, hdrHSV);\n  } else {\n    return ca;\n  }\n}\nvec3 cb(const in vec3 cc, const in vec3 bB, const in float bq, const in vec3 cd, const in vec3 bO) {\n  float ce = 1. - bq;\n  vec3 bW = mix(cc, reflect(-bB, cc), ce * (sqrt(ce) + bq));\n  float bl = clamp(1. + dot(bW, cd), .0, 1.);\n  vec3 cf = bV(bq, environmentTransform * bW) * bl * bl;\n  return cf;\n}\n#else\nvec3 cb(const in vec3 bm, const in vec3 cg, const in float bq, const in vec3 cd, const in vec3 bO) {\n  return ambientColor * bL(bO);\n}\n#endif\nvec3 ch(const in vec3 ci, const in float bq, const in float bD, const in float bx) {\n  vec4 rgba = texture2D(brdfLUT, vec2(bD, bq)) * vec4(255., 65280.0, 255., 65280.0);\n  float b = (rgba[3] + rgba[2]);\n  float a = (rgba[1] + rgba[0]);\n  return (ci * a + b * bx) / 65535.;\n}\nvec3 cj(const in vec3 bm, const in vec3 cg, const in float bD, const in float bq, const in vec3 bH, const in vec3 cd, const in float bx, const in vec3 bO) {\n  return cb(bm, cg, bq, cd, bO) * ch(bH, bq, bD, bx);\n}\nfloat ck(const in float cl, const in float bD) {\n  float bu = bD + cl;\n  return clamp(bu * bu - 1. + cl, .0, 1.);\n}\nvoid cm() {\n  \n#ifdef HAS_MAP\nvec2 f = computeTexCoord(vTexCoord);\n#endif\n#ifdef HAS_UV_FLIP\nf.y = 1. - f.y;\n#endif\n#if defined(HAS_BUMP_MAP) && defined(HAS_TANGENT)\nf = O(f, normalize(vTangentViewPos - vTangentFragPos));\n#endif\nc.albedo = baseColorIntensity * baseColorFactor.rgb;\n  c.alpha = baseColorFactor.a * vOpacity;\n#if defined(HAS_PATTERN)\nfloat cn = vLinesofar;\n  vec2 i = vTexInfo.zw;\n#ifdef HAS_PATTERN_GAP\nfloat co = vLinePatternGap;\n#else\nfloat co = linePatternGap;\n#endif\n#ifdef HAS_PATTERN_ANIM\nfloat cp = vLinePatternAnimSpeed;\n#else\nfloat cp = linePatternAnimSpeed;\n#endif\nfloat cq = ceil(i.x * vPatternHeight / i.y);\n  float cr = cq * (1. + co);\n  cp /= animSpeedScale;\n  cn += mod(currentTime * -cp * .2, cr);\n  float cs = mod(cn / cr, 1.);\n  float ct = mod(flipY * vNormalY, 1.);\n  vec2 f = d(vec2(cs * (1. + co) * uvScale[0], ct * uvScale[1]));\n  vec4 cu = texture2D(linePatternFile, f);\n  float cv = clamp(sign(1. / (1. + co) - cs) + .000001, .0, 1.);\n  cu = mix(linePatternGapColor, cu, cv);\n#ifdef IS_SQUARE_TUBE\nfloat n = clamp(sign(abs(vNormalY) - .999999), .0, 1.);\n  cu = mix(cu, vec4(1.), n);\n#endif\nc.albedo *= cu.rgb;\n  c.alpha *= cu.a;\n#endif\n#if defined(HAS_ALBEDO_MAP)\nvec4 cw = o(baseColorTexture, f);\n  c.albedo *= sRGBToLinear(cw.rgb);\n  c.alpha *= cw.a;\n#endif\n#if defined(HAS_SKIN_MAP)\nvec4 cx = o(skinTexture, f);\n  c.skinColor = cx;\n#endif\n#if defined(HAS_COLOR0)\nc.albedo *= vColor0.rgb;\n#if COLOR0_SIZE == 4\nc.alpha *= vColor0.a;\n#endif\n#endif\n#if defined(HAS_COLOR)\nc.albedo *= vColor.rgb;\n  c.alpha *= vColor.a;\n#elif defined(IS_LINE_EXTRUSION)\nc.albedo *= lineColor.rgb;\n  c.alpha *= lineColor.a;\n#else\nc.albedo *= polygonFill.rgb;\n  c.alpha *= polygonFill.a;\n#endif\n#if defined(HAS_INSTANCE_COLOR)\nc.albedo *= vInstanceColor.rgb;\n  c.alpha *= vInstanceColor.a;\n#endif\n#if defined(HAS_METALLICROUGHNESS_MAP)\nc.roughnessMetalness = o(metallicRoughnessTexture, f).gb * vec2(roughnessFactor, metallicFactor);\n#else\nc.roughnessMetalness = vec2(roughnessFactor, metallicFactor);\n#endif\nc.emit = emissiveFactor;\n#if defined(HAS_EMISSIVE_MAP)\nif(emitMultiplicative == 1) {\n    c.emit *= sRGBToLinear(o(emissiveTexture, f).rgb);\n  } else {\n    c.emit += sRGBToLinear(o(emissiveTexture, f).rgb);\n  }\n#endif\nc.emit *= emitColorFactor;\n#if defined(HAS_AO_MAP)\nvec2 cy = computeTexCoord(vTexCoord1);\n  c.ao = o(occlusionTexture, cy).r;\n#else\nc.ao = 1.;\n#endif\nc.ao *= occlusionFactor;\n#if defined(HAS_NORMAL_MAP) && defined(HAS_TANGENT)\nvec3 cz = o(normalTexture, f).xyz * 2. - 1.;\n  cz.y = normalMapFlipY == 1 ? -cz.y : cz.y;\n  c.normal = cz;\n#else\nc.normal = normalize(vModelNormal);\n#endif\n#if defined(HAS_TERRAIN_NORMAL) && defined(HAS_TANGENT)\nvec3 cz = convertTerrainHeightToNormalMap(f);\n  cz.y = normalMapFlipY == 1 ? -cz.y : cz.y;\n  c.normal = cz;\n#endif\n#if defined(SHADING_MODEL_SPECULAR_GLOSSINESS)\nc.albedo *= diffuseFactor.rgb;\n  c.alpha *= diffuseFactor.a;\n#if defined(HAS_DIFFUSE_MAP)\nvec4 cA = o(diffuseTexture, f);\n  c.albedo *= sRGBToLinear(cA.rgb);\n  c.alpha *= cA.a;\n#endif\nc.specularColor = specularFactor;\n  c.glossiness = glossinessFactor;\n#if defined(HAS_SPECULARGLOSSINESS_MAP)\nvec4 cB = o(specularGlossinessTexture, f);\n  c.specularColor *= sRGBToLinear(cB.rgb);\n  c.glossiness *= cB.a;\n#endif\n#endif\n}\nvec3 cC(const vec3 x) {\n  const float a = 2.51;\n  const float b = .03;\n  const float cD = 2.43;\n  const float bu = .59;\n  const float cE = .14;\n  return (x * (a * x + b)) / (x * (cD * x + bu) + cE);\n}\nvec3 cF(vec3 cG) {\n  cG = cC(cG);\n  return cG = pow(cG, vec3(1. / 2.2));\n}\nuniform float specularAAVariance;\nuniform float specularAAThreshold;\nfloat cH(float bq, const vec3 cI) {\n  \n#if defined(GL_OES_standard_derivatives) || __VERSION__ == 300\nvec3 cJ = dFdx(cI);\n  vec3 cK = dFdy(cI);\n  float cL = specularAAVariance * (dot(cJ, cJ) + dot(cK, cK));\n  float cM = min(2. * cL, specularAAThreshold);\n  float cN = saturate(bq * bq + cM);\n  return sqrt(cN);\n#else\nreturn bq;\n#endif\n}\n#ifdef HAS_SSR\nuniform sampler2D TextureDepth;\nuniform highp vec2 outSize;\nuniform float ssrFactor;\nuniform float ssrQuality;\nuniform sampler2D TextureReflected;\nuniform highp mat4 projMatrix;\nuniform mat4 invProjMatrix;\nuniform vec4 outputFovInfo[2];\nuniform mat4 reprojViewProjMatrix;\nvec3 cO(const in mat4 cP, const in vec3 cQ) {\n  vec4 cR = cP * vec4(cQ, 1.);\n  return vec3(.5 + .5 * cR.xy / cR.w, cR.w);\n}\nvec3 cS(const in float cT, const in vec2 f) {\n  return texture2D(TextureReflected, f).rgb;\n}\nfloat cU(float cV) {\n  highp mat4 cP = projMatrix;\n  highp float z = cV * 2. - 1.;\n  return -cP[3].z / (z + cP[2].z);\n}\nfloat cW(const vec2 f) {\n  float cV = bi(texture2D(TextureDepth, f));\n  return cV;\n}\nfloat cX(const in vec2 cY, const in float cZ) {\n  vec3 da = vec3(.06711056, .00583715, 52.9829189);\n  return fract(da.z * fract(dot(cY.xy + cZ * vec2(47., 17.) * .695, da.xy))) * .5;\n}\nvec3 db(const in float cZ, const in vec3 dc, const in vec3 dd, const in vec3 de, const in vec3 cg, const in float df) {\n  vec2 dg;\n  dg.x = cX(gl_FragCoord.yx, cZ);\n  dg.y = fract(dg.x * 52.9829189);\n  dg.y = mix(dg.y, 1., .7);\n  float dh = 2. * 3.14159 * dg.x;\n  float di = pow(max(dg.y, .000001), df / (2. - df));\n  float dj = sqrt(1. - di * di);\n  vec3 dk = vec3(dj * cos(dh), dj * sin(dh), di);\n  dk = dk.x * dc + dk.y * dd + dk.z * de;\n  return normalize((2. * dot(cg, dk)) * dk - cg);\n}\nfloat dl(const in float cZ) {\n  return (cX(gl_FragCoord.xy, cZ) - .5);\n}\nvec3 dm(const in vec3 dn, const in float dp, const in vec3 dq) {\n  vec3 dr = cO(projMatrix, vViewVertex.xyz + dq * dp);\n  dr.z = 1. / dr.z;\n  dr -= dn;\n  float ds = min(1., .99 * (1. - dn.x) / max(1e-5, dr.x));\n  float dt = min(1., .99 * (1. - dn.y) / max(1e-5, dr.y));\n  float dw = min(1., .99 * dn.x / max(1e-5, -dr.x));\n  float dx = min(1., .99 * dn.y / max(1e-5, -dr.y));\n  return dr * min(ds, dt) * min(dw, dx);\n}\nfloat dy(const in vec3 dn, const in vec3 dr, inout float dz, inout float dA) {\n  float dB = (dA + dz) * .5;\n  vec3 dC = dn + dr * dB;\n  float z = cW(dC.xy);\n  float cV = cU(z);\n  float dD = -1. / dC.z;\n  dz = cV > dD ? dz : dB;\n  dA = cV > dD ? dB : dA;\n  return dB;\n}\nvec4 dE(const in vec3 dn, const in float dp, in float dF, const in vec3 dq, const in float bq, const in float cZ) {\n  int dG = 20;\n  float dH = 1. / float(dG);\n  dF *= dH;\n  vec3 dr = dm(dn, dp, dq);\n  float dI = dH;\n  vec3 dJ = vec3(.0, dI, 1.);\n  vec3 dC;\n  float z, cV, dD, dK, dL, dM;\n  bool dN;\n  float dO = 1.;\n  float dB;\n  for(int W = 0; W < dG; W++) {\n    dC = dn + dr * dJ.y;\n    z = cW(dC.xy);\n    cV = cU(z);\n    dD = -1. / dC.z;\n    float dP = clamp(sign(.999 - z), .0, 1.);\n    dK = dP * (dD - cV);\n    dK *= clamp(sign(abs(dK) - dp * dH * dH), .0, 1.);\n    dN = abs(dK + dF) < dF;\n    dL = clamp(dJ.x / (dJ.x - dK), .0, 1.);\n    dM = dN ? dJ.y + dL * dH - dH : 1.;\n    dJ.z = min(dJ.z, dM);\n    dJ.x = dK;\n    if(dN) {\n      float dz = dJ.y - dH;\n      float dA = dJ.y;\n      dB = dy(dn, dr, dz, dA);\n      dB = dy(dn, dr, dz, dA);\n      dB = dy(dn, dr, dz, dA);\n      dO = dB;\n      break;\n    }\n    dJ.y += dH;\n  }\n  return vec4(dn + dr * dO, 1. - dO);\n}\nvec4 dQ(in vec4 dR, const in float dS, const in vec3 dT, const in vec3 dU, const in float bq) {\n  vec4 dV = mix(outputFovInfo[0], outputFovInfo[1], dR.x);\n  dR.xyz = vec3(mix(dV.xy, dV.zw, dR.y), 1.) * -1. / dR.z;\n  dR.xyz = (reprojViewProjMatrix * vec4(dR.xyz, 1.)).xyw;\n  dR.xy /= dR.z;\n  float dW = clamp(6. - 6. * max(abs(dR.x), abs(dR.y)), .0, 1.);\n  dR.xy = .5 + .5 * dR.xy;\n  vec3 dX = dU * cS(bq * (1. - dR.w), dR.xy);\n  return vec4(mix(dT, dX, dS * dW), 1.);\n}\nvec3 ssr(const in vec3 dT, const in vec3 dU, const in float bq, const in vec3 bm, const in vec3 cg) {\n  float dY = .0;\n  vec4 bU = vec4(.0);\n  float df = bq * bq;\n  df = df * df;\n  vec3 dZ = abs(bm.z) < .999 ? vec3(.0, .0, 1.) : vec3(1., .0, .0);\n  vec3 dc = normalize(cross(dZ, bm));\n  vec3 dd = cross(bm, dc);\n  float dS = ssrFactor * clamp(-4. * dot(cg, bm) + 3.8, .0, 1.);\n  dS *= clamp(4.7 - bq * 5., .0, 1.);\n  vec3 dn = cO(projMatrix, vViewVertex.xyz);\n  dn.z = 1. / dn.z;\n  vec3 dq = db(dY, dc, dd, bm, cg, df);\n  float dp = mix(cameraNearFar.y + vViewVertex.z, -vViewVertex.z - cameraNearFar.x, dq.z * .5 + .5);\n  float dF = .5 * dp;\n  vec4 dR;\n  if(dot(dq, bm) > .001 && dS > .0) {\n    dR = dE(dn, dp, dF, dq, bq, dY);\n    if(dR.w > .0)\n      bU += dQ(dR, dS, dT, dU, bq);\n    \n  }\n  return bU.w > .0 ? bU.rgb / bU.w : dT;\n}\n#endif\n#include <highlight_frag>\nvec4 ea(in vec4 eb) {\n  return vec4(mix(pow(eb.rgb, vec3(.41666)) * 1.055 - vec3(.055), eb.rgb * 12.92, vec3(lessThanEqual(eb.rgb, vec3(.0031308)))), eb.a);\n}\nvec4 ec(vec4 eb) {\n  return (ea(eb));\n}\nvoid main() {\n  cm();\n  vec3 cg = normalize(cameraPosition - vModelVertex.xyz);\n#if defined(HAS_DOUBLE_SIDE)\nvec3 cd = gl_FrontFacing ? normalize(vModelNormal) : -normalize(vModelNormal);\n#else\nvec3 cd = normalize(vModelNormal);\n#endif\n#if defined(HAS_TANGENT)\nvec4 ed;\n  ed = vModelTangent;\n#if defined(HAS_DOUBLE_SIDE)\ned.xyz = gl_FrontFacing ? normalize(ed.xyz) : -normalize(ed.xyz);\n#else\ned.xyz = normalize(ed.xyz);\n#endif\nvec3 ee = normalize(vModelBiTangent);\n#endif\nfloat bw = .08 * specularF0;\n  float ef = bc();\n  vec3 bO = ba();\n#if defined(SHADING_MODEL_SPECULAR_GLOSSINESS)\nvec3 eg = c.specularColor;\n#else\nvec3 eg = mix(vec3(bw), bO, ef);\n#endif\nbO *= 1. - ef;\n  float eh = clamp(50.0 * eg.g, .0, 1.);\n  float ei = bd();\n  if(specularAAVariance > .0) {\n    ei = cH(ei, cd);\n  }\n  vec3 ej = be();\n  vec3 ek = bg();\n  vec3 el = vec3(ek);\n#if defined(HAS_TANGENT) && (defined(HAS_NORMAL_MAP) || defined(HAS_TERRAIN_NORMAL))\nel = bk(normalMapFactor, el, ed.xyz, ee, cd);\n#endif\nvec3 cA = vec3(.0);\n  vec3 bH = vec3(.0);\n#if defined(HAS_IBL_LIGHTING)\ncA = bO * bT(el) * .5;\n#else\ncA = bO * ambientColor;\n#endif\nfloat bD = dot(el, cg);\n  bH = cj(el, cg, bD, ei, eg, cd, eh, bO);\n  float em;\n  float en = 1.;\n  float eo = bh();\n  cA *= environmentExposure * eo;\n#ifdef HAS_IBL_LIGHTING\nen = ck(eo, bD);\n#endif\n#ifdef HAS_SSR\nvec3 ep = normalize(gl_FrontFacing ? vViewNormal : -vViewNormal);\n  vec3 eq = ep;\n#if defined(HAS_TANGENT) && (defined(HAS_NORMAL_MAP) || defined(HAS_TERRAIN_NORMAL))\nvec4 er;\n  er = vViewTangent;\n  er = gl_FrontFacing ? er : -er;\n  er.xyz = normalize(er.xyz);\n  vec3 es = normalize(cross(ep, er.xyz)) * er.w;\n  eq = bk(normalMapFactor, ek, er.xyz, es, ep);\n#endif\nbH = ssr(bH, eg * en, ei, eq, -normalize(vViewVertex.xyz));\n#endif\nbH *= environmentExposure * en;\n  vec3 et, eu;\n  vec3 ev = vModelNormal;\n  vec3 ew = -light0_viewDirection;\n  float ex = saturate(dot(ew, el));\n  bN(el, cg, ex, max(.045, ei), bO, eg, light0_diffuse.rgb, ew, eh, eu, et);\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\nfloat ey = shadow_computeShadow();\n  eu = shadow_blend(eu, ey).rgb;\n  et = shadow_blend(et, ey).rgb;\n#endif\ncA += eu;\n  bH += et;\n  cA += ej;\n  vec3 ez = bH + cA;\n  if(outputSRGB == 1)\n    ez = linearTosRGB(ez);\n  \n#ifdef HAS_SKIN_MAP\nvec4 eA = bf();\n  ez.rgb = ez.rgb * (1. - eA.a) + eA.rgb * eA.a;\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\nez.rgb = shadow_blend(ez.rgb, ey).rgb;\n#endif\n#endif\nfloat eB = bb();\n  if(eB < alphaTest) {\n    discard;\n  }\n#if defined(ALPHA_MODE)\n#if ALPHA_MODE == 1\nif(eB < alphaCutoff) {\n    discard;\n  } else {\n    eB = 1.;\n  }\n#else\neB = 1.;\n#endif\n#endif\n#if defined(IS_LINE_EXTRUSION)\neB *= lineOpacity;\n#else\neB *= polygonOpacity;\n#endif\nglFragColor = vec4(ez * eB, eB);\n#ifdef HAS_VERTEX_COLOR\nglFragColor *= vertexColor_get();\n#endif\n#ifdef HAS_EXCAVATE_ANALYSIS\nglFragColor = excavateColor(glFragColor);\n#endif\n#ifdef HAS_HEATMAP\nglFragColor = heatmap_getColor(glFragColor);\n#endif\n#ifdef HAS_SNOW\nglFragColor.rgb = snow(glFragColor, bg(), 1.);\n#endif\nif(contrast != 1.) {\n    glFragColor = contrastMatrix(contrast) * glFragColor;\n  }\n  if(length(hsv) > .0) {\n    glFragColor = hsv_apply(glFragColor, hsv);\n  }\n#ifdef OUTPUT_NORMAL\nglFragColor = vec4(cd, 1.);\n#endif\nglFragColor = highlight_blendColor(glFragColor);\n#ifdef HAS_LAYER_OPACITY\nglFragColor *= layerOpacity;\n#endif\n#ifdef HAS_MASK_EXTENT\nglFragColor = setMask(glFragColor);\n#endif\n#if __VERSION__ == 100\ngl_FragColor = glFragColor;\n#endif\n}",
                uniforms: d,
                extraCommandProps: n,
                defines: o
            }), this.version = 300;
        }
        getGeometryDefines(e) {
            const t = {};
            return e.data[e.desc.tangentAttribute] ? t.HAS_TANGENT = 1 : e.data[e.desc.normalAttribute] && (t.HAS_NORMAL = 1), e.data[e.desc.colorAttribute] && (t.HAS_COLOR = 1), e.data[e.desc.color0Attribute] && (t.HAS_COLOR0 = 1, t.COLOR0_SIZE = e.getColor0Size()), t;
        }
    },
    StandardDepthShader: class extends $1d56c6a18dbfd30f$export$9d2cc9f1c4004434 {
        constructor(t = {}){
            const n = [];
            super({
                vert: "#define SHADER_NAME depth_vert\nprecision highp float;\nattribute vec3 aPosition;\n#include <line_extrusion_vert>\nuniform mat4 modelViewMatrix;\nuniform mat4 positionMatrix;\nuniform mat4 projMatrix;\nuniform vec2 outSize;\nuniform vec2 halton;\n#include <get_output>\nvoid main() {\n  mat4 c = getPositionMatrix();\n#ifdef IS_LINE_EXTRUSION\nvec4 d = getPosition(getLineExtrudePosition(aPosition));\n#else\nvec4 d = getPosition(aPosition);\n#endif\nvec4 e = modelViewMatrix * c * d;\n  mat4 f = projMatrix;\n  f[2].xy += halton.xy / outSize.xy;\n  gl_Position = f * e;\n}",
                frag: "#define SHADER_NAME depth_frag\nprecision highp float;\nvoid main() {\n  gl_FragColor = vec4(1., .0, .0, 1.);\n}",
                uniforms: [
                    {
                        name: "modelViewMatrix",
                        type: "function",
                        fn: (t, r)=>(0, $3iqbd).multiply(n, r.viewMatrix, r.modelMatrix)
                    }
                ],
                extraCommandProps: t.extraCommandProps,
                defines: t.defines
            });
        }
    },
    PBRUtils: $1d56c6a18dbfd30f$var$hr
}, $1d56c6a18dbfd30f$export$71a1409458eaaf0d = function(e, t, n = 2) {
    const r = t && t.length, i = r ? t[0] * n : e.length;
    let o = $1d56c6a18dbfd30f$var$Br(e, 0, i, n, !0);
    const a = [];
    if (!o || o.next === o.prev) return a;
    let s, c, l;
    if (r && (o = function(e, t, n, r) {
        const i = [];
        for(let n = 0, o = t.length; n < o; n++){
            const a = $1d56c6a18dbfd30f$var$Br(e, t[n] * r, n < o - 1 ? t[n + 1] * r : e.length, r, !1);
            a === a.next && (a.steiner = !0), i.push($1d56c6a18dbfd30f$var$Yr(a));
        }
        i.sort($1d56c6a18dbfd30f$var$Wr);
        for(let e = 0; e < i.length; e++)n = $1d56c6a18dbfd30f$var$qr(i[e], n);
        return n;
    }(e, t, o, n)), e.length > 80 * n) {
        s = 1 / 0, c = 1 / 0;
        let t = -1 / 0, r = -1 / 0;
        for(let o = n; o < i; o += n){
            const n = e[o], i = e[o + 1];
            n < s && (s = n), i < c && (c = i), n > t && (t = n), i > r && (r = i);
        }
        l = Math.max(t - s, r - c), l = 0 !== l ? 32767 / l : 0;
    }
    return $1d56c6a18dbfd30f$var$Gr(o, a, n, s, c, l, 0), a;
};
$1d56c6a18dbfd30f$export$71a1409458eaaf0d.flatten = function(e) {
    const t = [], n = [], r = e[0][0].length;
    let i = 0, o = 0;
    for (const a of e){
        for (const e of a)for(let n = 0; n < r; n++)t.push(e[n]);
        o && (i += o, n.push(i)), o = a.length;
    }
    return {
        vertices: t,
        holes: n,
        dimensions: r
    };
};

});
parcelRegister("amnUE", function(module, exports) {

$parcel$export(module.exports, "EPSILON", () => $78ae820aa9ececfa$export$fd293b15f47e270);
$parcel$export(module.exports, "ARRAY_TYPE", () => $78ae820aa9ececfa$export$b67359430d3b1b2);
$parcel$export(module.exports, "RANDOM", () => $78ae820aa9ececfa$export$5ada478c8a628231);
$parcel$export(module.exports, "setMatrixArrayType", () => $78ae820aa9ececfa$export$cb2c0eb57f5e532c);
$parcel$export(module.exports, "toRadian", () => $78ae820aa9ececfa$export$408b8ee5959eefd5);
$parcel$export(module.exports, "equals", () => $78ae820aa9ececfa$export$e9bab7fafb253603);
/**
 * Common utilities
 * @module glMatrix
 */ // Configuration Constants
var $78ae820aa9ececfa$export$fd293b15f47e270 = 0.000001;
var $78ae820aa9ececfa$export$b67359430d3b1b2 = typeof Float32Array !== 'undefined' ? Float32Array : Array;
var $78ae820aa9ececfa$export$5ada478c8a628231 = Math.random;
function $78ae820aa9ececfa$export$cb2c0eb57f5e532c(type) {
    $78ae820aa9ececfa$export$b67359430d3b1b2 = type;
}
var $78ae820aa9ececfa$var$degree = Math.PI / 180;
function $78ae820aa9ececfa$export$408b8ee5959eefd5(a) {
    return a * $78ae820aa9ececfa$var$degree;
}
function $78ae820aa9ececfa$export$e9bab7fafb253603(a, b) {
    return Math.abs(a - b) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a), Math.abs(b));
}
if (!Math.hypot) Math.hypot = function() {
    var y = 0, i = arguments.length;
    while(i--)y += arguments[i] * arguments[i];
    return Math.sqrt(y);
};

});

parcelRegister("iLdEy", function(module, exports) {

$parcel$export(module.exports, "create", () => $da8734fa136af005$export$185802fd694ee1f5);
$parcel$export(module.exports, "clone", () => $da8734fa136af005$export$9cd59f9826255e47);
$parcel$export(module.exports, "copy", () => $da8734fa136af005$export$784d13d8ee351f07);
$parcel$export(module.exports, "identity", () => $da8734fa136af005$export$f0954fd7d5368655);
$parcel$export(module.exports, "fromValues", () => $da8734fa136af005$export$a82be99ed2a44a7d);
$parcel$export(module.exports, "set", () => $da8734fa136af005$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "transpose", () => $da8734fa136af005$export$9cb09a71b7d66923);
$parcel$export(module.exports, "invert", () => $da8734fa136af005$export$6897c284b6f9f4dc);
$parcel$export(module.exports, "adjoint", () => $da8734fa136af005$export$33f3c024b4ae00a1);
$parcel$export(module.exports, "determinant", () => $da8734fa136af005$export$a04698f914c55ed9);
$parcel$export(module.exports, "multiply", () => $da8734fa136af005$export$2060d2db72cce88f);
$parcel$export(module.exports, "rotate", () => $da8734fa136af005$export$bb628a54ab399bc9);
$parcel$export(module.exports, "scale", () => $da8734fa136af005$export$dcdf75081b88279d);
$parcel$export(module.exports, "fromRotation", () => $da8734fa136af005$export$926fc125ff3c666c);
$parcel$export(module.exports, "fromScaling", () => $da8734fa136af005$export$832ca188ffb1955d);
$parcel$export(module.exports, "str", () => $da8734fa136af005$export$42d51816ce590c93);
$parcel$export(module.exports, "frob", () => $da8734fa136af005$export$326827e8268e9cdb);
$parcel$export(module.exports, "LDU", () => $da8734fa136af005$export$c7126d0da24b9100);
$parcel$export(module.exports, "add", () => $da8734fa136af005$export$e16d8520af44a096);
$parcel$export(module.exports, "subtract", () => $da8734fa136af005$export$4e2d2ead65e5f7e3);
$parcel$export(module.exports, "exactEquals", () => $da8734fa136af005$export$f2599a5cf1109d8);
$parcel$export(module.exports, "equals", () => $da8734fa136af005$export$e9bab7fafb253603);
$parcel$export(module.exports, "multiplyScalar", () => $da8734fa136af005$export$c697bed75648cdb7);
$parcel$export(module.exports, "multiplyScalarAndAdd", () => $da8734fa136af005$export$553579f63bdd7137);
$parcel$export(module.exports, "mul", () => $da8734fa136af005$export$6e3a27864ab166fe);
$parcel$export(module.exports, "sub", () => $da8734fa136af005$export$f93b5905241a7cca);

var $amnUE = parcelRequire("amnUE");
function $da8734fa136af005$export$185802fd694ee1f5() {
    var out = new $amnUE.ARRAY_TYPE(4);
    if ($amnUE.ARRAY_TYPE != Float32Array) {
        out[1] = 0;
        out[2] = 0;
    }
    out[0] = 1;
    out[3] = 1;
    return out;
}
function $da8734fa136af005$export$9cd59f9826255e47(a) {
    var out = new $amnUE.ARRAY_TYPE(4);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    return out;
}
function $da8734fa136af005$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    return out;
}
function $da8734fa136af005$export$f0954fd7d5368655(out) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 1;
    return out;
}
function $da8734fa136af005$export$a82be99ed2a44a7d(m00, m01, m10, m11) {
    var out = new $amnUE.ARRAY_TYPE(4);
    out[0] = m00;
    out[1] = m01;
    out[2] = m10;
    out[3] = m11;
    return out;
}
function $da8734fa136af005$export$adaa4cf7ef1b65be(out, m00, m01, m10, m11) {
    out[0] = m00;
    out[1] = m01;
    out[2] = m10;
    out[3] = m11;
    return out;
}
function $da8734fa136af005$export$9cb09a71b7d66923(out, a) {
    // If we are transposing ourselves we can skip a few steps but have to cache
    // some values
    if (out === a) {
        var a1 = a[1];
        out[1] = a[2];
        out[2] = a1;
    } else {
        out[0] = a[0];
        out[1] = a[2];
        out[2] = a[1];
        out[3] = a[3];
    }
    return out;
}
function $da8734fa136af005$export$6897c284b6f9f4dc(out, a) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3]; // Calculate the determinant
    var det = a0 * a3 - a2 * a1;
    if (!det) return null;
    det = 1.0 / det;
    out[0] = a3 * det;
    out[1] = -a1 * det;
    out[2] = -a2 * det;
    out[3] = a0 * det;
    return out;
}
function $da8734fa136af005$export$33f3c024b4ae00a1(out, a) {
    // Caching this value is nessecary if out == a
    var a0 = a[0];
    out[0] = a[3];
    out[1] = -a[1];
    out[2] = -a[2];
    out[3] = a0;
    return out;
}
function $da8734fa136af005$export$a04698f914c55ed9(a) {
    return a[0] * a[3] - a[2] * a[1];
}
function $da8734fa136af005$export$2060d2db72cce88f(out, a, b) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3];
    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
    out[0] = a0 * b0 + a2 * b1;
    out[1] = a1 * b0 + a3 * b1;
    out[2] = a0 * b2 + a2 * b3;
    out[3] = a1 * b2 + a3 * b3;
    return out;
}
function $da8734fa136af005$export$bb628a54ab399bc9(out, a, rad) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3];
    var s = Math.sin(rad);
    var c = Math.cos(rad);
    out[0] = a0 * c + a2 * s;
    out[1] = a1 * c + a3 * s;
    out[2] = a0 * -s + a2 * c;
    out[3] = a1 * -s + a3 * c;
    return out;
}
function $da8734fa136af005$export$dcdf75081b88279d(out, a, v) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3];
    var v0 = v[0], v1 = v[1];
    out[0] = a0 * v0;
    out[1] = a1 * v0;
    out[2] = a2 * v1;
    out[3] = a3 * v1;
    return out;
}
function $da8734fa136af005$export$926fc125ff3c666c(out, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad);
    out[0] = c;
    out[1] = s;
    out[2] = -s;
    out[3] = c;
    return out;
}
function $da8734fa136af005$export$832ca188ffb1955d(out, v) {
    out[0] = v[0];
    out[1] = 0;
    out[2] = 0;
    out[3] = v[1];
    return out;
}
function $da8734fa136af005$export$42d51816ce590c93(a) {
    return "mat2(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ")";
}
function $da8734fa136af005$export$326827e8268e9cdb(a) {
    return Math.hypot(a[0], a[1], a[2], a[3]);
}
function $da8734fa136af005$export$c7126d0da24b9100(L, D, U, a) {
    L[2] = a[2] / a[0];
    U[0] = a[0];
    U[1] = a[1];
    U[3] = a[3] - L[2] * U[1];
    return [
        L,
        D,
        U
    ];
}
function $da8734fa136af005$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    out[3] = a[3] + b[3];
    return out;
}
function $da8734fa136af005$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    out[3] = a[3] - b[3];
    return out;
}
function $da8734fa136af005$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3];
}
function $da8734fa136af005$export$e9bab7fafb253603(a, b) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3];
    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
    return Math.abs(a0 - b0) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a2), Math.abs(b2)) && Math.abs(a3 - b3) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a3), Math.abs(b3));
}
function $da8734fa136af005$export$c697bed75648cdb7(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    out[3] = a[3] * b;
    return out;
}
function $da8734fa136af005$export$553579f63bdd7137(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    out[2] = a[2] + b[2] * scale;
    out[3] = a[3] + b[3] * scale;
    return out;
}
var $da8734fa136af005$export$6e3a27864ab166fe = $da8734fa136af005$export$2060d2db72cce88f;
var $da8734fa136af005$export$f93b5905241a7cca = $da8734fa136af005$export$4e2d2ead65e5f7e3;

});

parcelRegister("caQGJ", function(module, exports) {

$parcel$export(module.exports, "create", () => $8dcf4a037b5f4ce8$export$185802fd694ee1f5);
$parcel$export(module.exports, "clone", () => $8dcf4a037b5f4ce8$export$9cd59f9826255e47);
$parcel$export(module.exports, "copy", () => $8dcf4a037b5f4ce8$export$784d13d8ee351f07);
$parcel$export(module.exports, "identity", () => $8dcf4a037b5f4ce8$export$f0954fd7d5368655);
$parcel$export(module.exports, "fromValues", () => $8dcf4a037b5f4ce8$export$a82be99ed2a44a7d);
$parcel$export(module.exports, "set", () => $8dcf4a037b5f4ce8$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "invert", () => $8dcf4a037b5f4ce8$export$6897c284b6f9f4dc);
$parcel$export(module.exports, "determinant", () => $8dcf4a037b5f4ce8$export$a04698f914c55ed9);
$parcel$export(module.exports, "multiply", () => $8dcf4a037b5f4ce8$export$2060d2db72cce88f);
$parcel$export(module.exports, "rotate", () => $8dcf4a037b5f4ce8$export$bb628a54ab399bc9);
$parcel$export(module.exports, "scale", () => $8dcf4a037b5f4ce8$export$dcdf75081b88279d);
$parcel$export(module.exports, "translate", () => $8dcf4a037b5f4ce8$export$d73ee8ef04f5226a);
$parcel$export(module.exports, "fromRotation", () => $8dcf4a037b5f4ce8$export$926fc125ff3c666c);
$parcel$export(module.exports, "fromScaling", () => $8dcf4a037b5f4ce8$export$832ca188ffb1955d);
$parcel$export(module.exports, "fromTranslation", () => $8dcf4a037b5f4ce8$export$bc9e79e74e9fddf6);
$parcel$export(module.exports, "str", () => $8dcf4a037b5f4ce8$export$42d51816ce590c93);
$parcel$export(module.exports, "frob", () => $8dcf4a037b5f4ce8$export$326827e8268e9cdb);
$parcel$export(module.exports, "add", () => $8dcf4a037b5f4ce8$export$e16d8520af44a096);
$parcel$export(module.exports, "subtract", () => $8dcf4a037b5f4ce8$export$4e2d2ead65e5f7e3);
$parcel$export(module.exports, "multiplyScalar", () => $8dcf4a037b5f4ce8$export$c697bed75648cdb7);
$parcel$export(module.exports, "multiplyScalarAndAdd", () => $8dcf4a037b5f4ce8$export$553579f63bdd7137);
$parcel$export(module.exports, "exactEquals", () => $8dcf4a037b5f4ce8$export$f2599a5cf1109d8);
$parcel$export(module.exports, "equals", () => $8dcf4a037b5f4ce8$export$e9bab7fafb253603);
$parcel$export(module.exports, "mul", () => $8dcf4a037b5f4ce8$export$6e3a27864ab166fe);
$parcel$export(module.exports, "sub", () => $8dcf4a037b5f4ce8$export$f93b5905241a7cca);

var $amnUE = parcelRequire("amnUE");
function $8dcf4a037b5f4ce8$export$185802fd694ee1f5() {
    var out = new $amnUE.ARRAY_TYPE(6);
    if ($amnUE.ARRAY_TYPE != Float32Array) {
        out[1] = 0;
        out[2] = 0;
        out[4] = 0;
        out[5] = 0;
    }
    out[0] = 1;
    out[3] = 1;
    return out;
}
function $8dcf4a037b5f4ce8$export$9cd59f9826255e47(a) {
    var out = new $amnUE.ARRAY_TYPE(6);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    return out;
}
function $8dcf4a037b5f4ce8$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    return out;
}
function $8dcf4a037b5f4ce8$export$f0954fd7d5368655(out) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 1;
    out[4] = 0;
    out[5] = 0;
    return out;
}
function $8dcf4a037b5f4ce8$export$a82be99ed2a44a7d(a, b, c, d, tx, ty) {
    var out = new $amnUE.ARRAY_TYPE(6);
    out[0] = a;
    out[1] = b;
    out[2] = c;
    out[3] = d;
    out[4] = tx;
    out[5] = ty;
    return out;
}
function $8dcf4a037b5f4ce8$export$adaa4cf7ef1b65be(out, a, b, c, d, tx, ty) {
    out[0] = a;
    out[1] = b;
    out[2] = c;
    out[3] = d;
    out[4] = tx;
    out[5] = ty;
    return out;
}
function $8dcf4a037b5f4ce8$export$6897c284b6f9f4dc(out, a) {
    var aa = a[0], ab = a[1], ac = a[2], ad = a[3];
    var atx = a[4], aty = a[5];
    var det = aa * ad - ab * ac;
    if (!det) return null;
    det = 1.0 / det;
    out[0] = ad * det;
    out[1] = -ab * det;
    out[2] = -ac * det;
    out[3] = aa * det;
    out[4] = (ac * aty - ad * atx) * det;
    out[5] = (ab * atx - aa * aty) * det;
    return out;
}
function $8dcf4a037b5f4ce8$export$a04698f914c55ed9(a) {
    return a[0] * a[3] - a[1] * a[2];
}
function $8dcf4a037b5f4ce8$export$2060d2db72cce88f(out, a, b) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3], a4 = a[4], a5 = a[5];
    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5];
    out[0] = a0 * b0 + a2 * b1;
    out[1] = a1 * b0 + a3 * b1;
    out[2] = a0 * b2 + a2 * b3;
    out[3] = a1 * b2 + a3 * b3;
    out[4] = a0 * b4 + a2 * b5 + a4;
    out[5] = a1 * b4 + a3 * b5 + a5;
    return out;
}
function $8dcf4a037b5f4ce8$export$bb628a54ab399bc9(out, a, rad) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3], a4 = a[4], a5 = a[5];
    var s = Math.sin(rad);
    var c = Math.cos(rad);
    out[0] = a0 * c + a2 * s;
    out[1] = a1 * c + a3 * s;
    out[2] = a0 * -s + a2 * c;
    out[3] = a1 * -s + a3 * c;
    out[4] = a4;
    out[5] = a5;
    return out;
}
function $8dcf4a037b5f4ce8$export$dcdf75081b88279d(out, a, v) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3], a4 = a[4], a5 = a[5];
    var v0 = v[0], v1 = v[1];
    out[0] = a0 * v0;
    out[1] = a1 * v0;
    out[2] = a2 * v1;
    out[3] = a3 * v1;
    out[4] = a4;
    out[5] = a5;
    return out;
}
function $8dcf4a037b5f4ce8$export$d73ee8ef04f5226a(out, a, v) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3], a4 = a[4], a5 = a[5];
    var v0 = v[0], v1 = v[1];
    out[0] = a0;
    out[1] = a1;
    out[2] = a2;
    out[3] = a3;
    out[4] = a0 * v0 + a2 * v1 + a4;
    out[5] = a1 * v0 + a3 * v1 + a5;
    return out;
}
function $8dcf4a037b5f4ce8$export$926fc125ff3c666c(out, rad) {
    var s = Math.sin(rad), c = Math.cos(rad);
    out[0] = c;
    out[1] = s;
    out[2] = -s;
    out[3] = c;
    out[4] = 0;
    out[5] = 0;
    return out;
}
function $8dcf4a037b5f4ce8$export$832ca188ffb1955d(out, v) {
    out[0] = v[0];
    out[1] = 0;
    out[2] = 0;
    out[3] = v[1];
    out[4] = 0;
    out[5] = 0;
    return out;
}
function $8dcf4a037b5f4ce8$export$bc9e79e74e9fddf6(out, v) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 1;
    out[4] = v[0];
    out[5] = v[1];
    return out;
}
function $8dcf4a037b5f4ce8$export$42d51816ce590c93(a) {
    return "mat2d(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ", " + a[4] + ", " + a[5] + ")";
}
function $8dcf4a037b5f4ce8$export$326827e8268e9cdb(a) {
    return Math.hypot(a[0], a[1], a[2], a[3], a[4], a[5], 1);
}
function $8dcf4a037b5f4ce8$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    out[3] = a[3] + b[3];
    out[4] = a[4] + b[4];
    out[5] = a[5] + b[5];
    return out;
}
function $8dcf4a037b5f4ce8$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    out[3] = a[3] - b[3];
    out[4] = a[4] - b[4];
    out[5] = a[5] - b[5];
    return out;
}
function $8dcf4a037b5f4ce8$export$c697bed75648cdb7(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    out[3] = a[3] * b;
    out[4] = a[4] * b;
    out[5] = a[5] * b;
    return out;
}
function $8dcf4a037b5f4ce8$export$553579f63bdd7137(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    out[2] = a[2] + b[2] * scale;
    out[3] = a[3] + b[3] * scale;
    out[4] = a[4] + b[4] * scale;
    out[5] = a[5] + b[5] * scale;
    return out;
}
function $8dcf4a037b5f4ce8$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3] && a[4] === b[4] && a[5] === b[5];
}
function $8dcf4a037b5f4ce8$export$e9bab7fafb253603(a, b) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3], a4 = a[4], a5 = a[5];
    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5];
    return Math.abs(a0 - b0) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a2), Math.abs(b2)) && Math.abs(a3 - b3) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a3), Math.abs(b3)) && Math.abs(a4 - b4) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a4), Math.abs(b4)) && Math.abs(a5 - b5) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a5), Math.abs(b5));
}
var $8dcf4a037b5f4ce8$export$6e3a27864ab166fe = $8dcf4a037b5f4ce8$export$2060d2db72cce88f;
var $8dcf4a037b5f4ce8$export$f93b5905241a7cca = $8dcf4a037b5f4ce8$export$4e2d2ead65e5f7e3;

});

parcelRegister("bDSmI", function(module, exports) {

$parcel$export(module.exports, "create", () => $879d8210211d0bfa$export$185802fd694ee1f5);
$parcel$export(module.exports, "fromMat4", () => $879d8210211d0bfa$export$b4ad467060d346fe);
$parcel$export(module.exports, "clone", () => $879d8210211d0bfa$export$9cd59f9826255e47);
$parcel$export(module.exports, "copy", () => $879d8210211d0bfa$export$784d13d8ee351f07);
$parcel$export(module.exports, "fromValues", () => $879d8210211d0bfa$export$a82be99ed2a44a7d);
$parcel$export(module.exports, "set", () => $879d8210211d0bfa$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "identity", () => $879d8210211d0bfa$export$f0954fd7d5368655);
$parcel$export(module.exports, "transpose", () => $879d8210211d0bfa$export$9cb09a71b7d66923);
$parcel$export(module.exports, "invert", () => $879d8210211d0bfa$export$6897c284b6f9f4dc);
$parcel$export(module.exports, "adjoint", () => $879d8210211d0bfa$export$33f3c024b4ae00a1);
$parcel$export(module.exports, "determinant", () => $879d8210211d0bfa$export$a04698f914c55ed9);
$parcel$export(module.exports, "multiply", () => $879d8210211d0bfa$export$2060d2db72cce88f);
$parcel$export(module.exports, "translate", () => $879d8210211d0bfa$export$d73ee8ef04f5226a);
$parcel$export(module.exports, "rotate", () => $879d8210211d0bfa$export$bb628a54ab399bc9);
$parcel$export(module.exports, "scale", () => $879d8210211d0bfa$export$dcdf75081b88279d);
$parcel$export(module.exports, "fromTranslation", () => $879d8210211d0bfa$export$bc9e79e74e9fddf6);
$parcel$export(module.exports, "fromRotation", () => $879d8210211d0bfa$export$926fc125ff3c666c);
$parcel$export(module.exports, "fromScaling", () => $879d8210211d0bfa$export$832ca188ffb1955d);
$parcel$export(module.exports, "fromMat2d", () => $879d8210211d0bfa$export$68f5977575fae9bf);
$parcel$export(module.exports, "fromQuat", () => $879d8210211d0bfa$export$2ff2bbe382249af7);
$parcel$export(module.exports, "normalFromMat4", () => $879d8210211d0bfa$export$966b25ab6dc1b1f9);
$parcel$export(module.exports, "projection", () => $879d8210211d0bfa$export$b74061472fe7c07);
$parcel$export(module.exports, "str", () => $879d8210211d0bfa$export$42d51816ce590c93);
$parcel$export(module.exports, "frob", () => $879d8210211d0bfa$export$326827e8268e9cdb);
$parcel$export(module.exports, "add", () => $879d8210211d0bfa$export$e16d8520af44a096);
$parcel$export(module.exports, "subtract", () => $879d8210211d0bfa$export$4e2d2ead65e5f7e3);
$parcel$export(module.exports, "multiplyScalar", () => $879d8210211d0bfa$export$c697bed75648cdb7);
$parcel$export(module.exports, "multiplyScalarAndAdd", () => $879d8210211d0bfa$export$553579f63bdd7137);
$parcel$export(module.exports, "exactEquals", () => $879d8210211d0bfa$export$f2599a5cf1109d8);
$parcel$export(module.exports, "equals", () => $879d8210211d0bfa$export$e9bab7fafb253603);
$parcel$export(module.exports, "mul", () => $879d8210211d0bfa$export$6e3a27864ab166fe);
$parcel$export(module.exports, "sub", () => $879d8210211d0bfa$export$f93b5905241a7cca);

var $amnUE = parcelRequire("amnUE");
function $879d8210211d0bfa$export$185802fd694ee1f5() {
    var out = new $amnUE.ARRAY_TYPE(9);
    if ($amnUE.ARRAY_TYPE != Float32Array) {
        out[1] = 0;
        out[2] = 0;
        out[3] = 0;
        out[5] = 0;
        out[6] = 0;
        out[7] = 0;
    }
    out[0] = 1;
    out[4] = 1;
    out[8] = 1;
    return out;
}
function $879d8210211d0bfa$export$b4ad467060d346fe(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[4];
    out[4] = a[5];
    out[5] = a[6];
    out[6] = a[8];
    out[7] = a[9];
    out[8] = a[10];
    return out;
}
function $879d8210211d0bfa$export$9cd59f9826255e47(a) {
    var out = new $amnUE.ARRAY_TYPE(9);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    return out;
}
function $879d8210211d0bfa$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    return out;
}
function $879d8210211d0bfa$export$a82be99ed2a44a7d(m00, m01, m02, m10, m11, m12, m20, m21, m22) {
    var out = new $amnUE.ARRAY_TYPE(9);
    out[0] = m00;
    out[1] = m01;
    out[2] = m02;
    out[3] = m10;
    out[4] = m11;
    out[5] = m12;
    out[6] = m20;
    out[7] = m21;
    out[8] = m22;
    return out;
}
function $879d8210211d0bfa$export$adaa4cf7ef1b65be(out, m00, m01, m02, m10, m11, m12, m20, m21, m22) {
    out[0] = m00;
    out[1] = m01;
    out[2] = m02;
    out[3] = m10;
    out[4] = m11;
    out[5] = m12;
    out[6] = m20;
    out[7] = m21;
    out[8] = m22;
    return out;
}
function $879d8210211d0bfa$export$f0954fd7d5368655(out) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 1;
    out[5] = 0;
    out[6] = 0;
    out[7] = 0;
    out[8] = 1;
    return out;
}
function $879d8210211d0bfa$export$9cb09a71b7d66923(out, a) {
    // If we are transposing ourselves we can skip a few steps but have to cache some values
    if (out === a) {
        var a01 = a[1], a02 = a[2], a12 = a[5];
        out[1] = a[3];
        out[2] = a[6];
        out[3] = a01;
        out[5] = a[7];
        out[6] = a02;
        out[7] = a12;
    } else {
        out[0] = a[0];
        out[1] = a[3];
        out[2] = a[6];
        out[3] = a[1];
        out[4] = a[4];
        out[5] = a[7];
        out[6] = a[2];
        out[7] = a[5];
        out[8] = a[8];
    }
    return out;
}
function $879d8210211d0bfa$export$6897c284b6f9f4dc(out, a) {
    var a00 = a[0], a01 = a[1], a02 = a[2];
    var a10 = a[3], a11 = a[4], a12 = a[5];
    var a20 = a[6], a21 = a[7], a22 = a[8];
    var b01 = a22 * a11 - a12 * a21;
    var b11 = -a22 * a10 + a12 * a20;
    var b21 = a21 * a10 - a11 * a20; // Calculate the determinant
    var det = a00 * b01 + a01 * b11 + a02 * b21;
    if (!det) return null;
    det = 1.0 / det;
    out[0] = b01 * det;
    out[1] = (-a22 * a01 + a02 * a21) * det;
    out[2] = (a12 * a01 - a02 * a11) * det;
    out[3] = b11 * det;
    out[4] = (a22 * a00 - a02 * a20) * det;
    out[5] = (-a12 * a00 + a02 * a10) * det;
    out[6] = b21 * det;
    out[7] = (-a21 * a00 + a01 * a20) * det;
    out[8] = (a11 * a00 - a01 * a10) * det;
    return out;
}
function $879d8210211d0bfa$export$33f3c024b4ae00a1(out, a) {
    var a00 = a[0], a01 = a[1], a02 = a[2];
    var a10 = a[3], a11 = a[4], a12 = a[5];
    var a20 = a[6], a21 = a[7], a22 = a[8];
    out[0] = a11 * a22 - a12 * a21;
    out[1] = a02 * a21 - a01 * a22;
    out[2] = a01 * a12 - a02 * a11;
    out[3] = a12 * a20 - a10 * a22;
    out[4] = a00 * a22 - a02 * a20;
    out[5] = a02 * a10 - a00 * a12;
    out[6] = a10 * a21 - a11 * a20;
    out[7] = a01 * a20 - a00 * a21;
    out[8] = a00 * a11 - a01 * a10;
    return out;
}
function $879d8210211d0bfa$export$a04698f914c55ed9(a) {
    var a00 = a[0], a01 = a[1], a02 = a[2];
    var a10 = a[3], a11 = a[4], a12 = a[5];
    var a20 = a[6], a21 = a[7], a22 = a[8];
    return a00 * (a22 * a11 - a12 * a21) + a01 * (-a22 * a10 + a12 * a20) + a02 * (a21 * a10 - a11 * a20);
}
function $879d8210211d0bfa$export$2060d2db72cce88f(out, a, b) {
    var a00 = a[0], a01 = a[1], a02 = a[2];
    var a10 = a[3], a11 = a[4], a12 = a[5];
    var a20 = a[6], a21 = a[7], a22 = a[8];
    var b00 = b[0], b01 = b[1], b02 = b[2];
    var b10 = b[3], b11 = b[4], b12 = b[5];
    var b20 = b[6], b21 = b[7], b22 = b[8];
    out[0] = b00 * a00 + b01 * a10 + b02 * a20;
    out[1] = b00 * a01 + b01 * a11 + b02 * a21;
    out[2] = b00 * a02 + b01 * a12 + b02 * a22;
    out[3] = b10 * a00 + b11 * a10 + b12 * a20;
    out[4] = b10 * a01 + b11 * a11 + b12 * a21;
    out[5] = b10 * a02 + b11 * a12 + b12 * a22;
    out[6] = b20 * a00 + b21 * a10 + b22 * a20;
    out[7] = b20 * a01 + b21 * a11 + b22 * a21;
    out[8] = b20 * a02 + b21 * a12 + b22 * a22;
    return out;
}
function $879d8210211d0bfa$export$d73ee8ef04f5226a(out, a, v) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a10 = a[3], a11 = a[4], a12 = a[5], a20 = a[6], a21 = a[7], a22 = a[8], x = v[0], y = v[1];
    out[0] = a00;
    out[1] = a01;
    out[2] = a02;
    out[3] = a10;
    out[4] = a11;
    out[5] = a12;
    out[6] = x * a00 + y * a10 + a20;
    out[7] = x * a01 + y * a11 + a21;
    out[8] = x * a02 + y * a12 + a22;
    return out;
}
function $879d8210211d0bfa$export$bb628a54ab399bc9(out, a, rad) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a10 = a[3], a11 = a[4], a12 = a[5], a20 = a[6], a21 = a[7], a22 = a[8], s = Math.sin(rad), c = Math.cos(rad);
    out[0] = c * a00 + s * a10;
    out[1] = c * a01 + s * a11;
    out[2] = c * a02 + s * a12;
    out[3] = c * a10 - s * a00;
    out[4] = c * a11 - s * a01;
    out[5] = c * a12 - s * a02;
    out[6] = a20;
    out[7] = a21;
    out[8] = a22;
    return out;
}
function $879d8210211d0bfa$export$dcdf75081b88279d(out, a, v) {
    var x = v[0], y = v[1];
    out[0] = x * a[0];
    out[1] = x * a[1];
    out[2] = x * a[2];
    out[3] = y * a[3];
    out[4] = y * a[4];
    out[5] = y * a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    return out;
}
function $879d8210211d0bfa$export$bc9e79e74e9fddf6(out, v) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 1;
    out[5] = 0;
    out[6] = v[0];
    out[7] = v[1];
    out[8] = 1;
    return out;
}
function $879d8210211d0bfa$export$926fc125ff3c666c(out, rad) {
    var s = Math.sin(rad), c = Math.cos(rad);
    out[0] = c;
    out[1] = s;
    out[2] = 0;
    out[3] = -s;
    out[4] = c;
    out[5] = 0;
    out[6] = 0;
    out[7] = 0;
    out[8] = 1;
    return out;
}
function $879d8210211d0bfa$export$832ca188ffb1955d(out, v) {
    out[0] = v[0];
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = v[1];
    out[5] = 0;
    out[6] = 0;
    out[7] = 0;
    out[8] = 1;
    return out;
}
function $879d8210211d0bfa$export$68f5977575fae9bf(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = 0;
    out[3] = a[2];
    out[4] = a[3];
    out[5] = 0;
    out[6] = a[4];
    out[7] = a[5];
    out[8] = 1;
    return out;
}
function $879d8210211d0bfa$export$2ff2bbe382249af7(out, q) {
    var x = q[0], y = q[1], z = q[2], w = q[3];
    var x2 = x + x;
    var y2 = y + y;
    var z2 = z + z;
    var xx = x * x2;
    var yx = y * x2;
    var yy = y * y2;
    var zx = z * x2;
    var zy = z * y2;
    var zz = z * z2;
    var wx = w * x2;
    var wy = w * y2;
    var wz = w * z2;
    out[0] = 1 - yy - zz;
    out[3] = yx - wz;
    out[6] = zx + wy;
    out[1] = yx + wz;
    out[4] = 1 - xx - zz;
    out[7] = zy - wx;
    out[2] = zx - wy;
    out[5] = zy + wx;
    out[8] = 1 - xx - yy;
    return out;
}
function $879d8210211d0bfa$export$966b25ab6dc1b1f9(out, a) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    var a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    var a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    var a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    var b00 = a00 * a11 - a01 * a10;
    var b01 = a00 * a12 - a02 * a10;
    var b02 = a00 * a13 - a03 * a10;
    var b03 = a01 * a12 - a02 * a11;
    var b04 = a01 * a13 - a03 * a11;
    var b05 = a02 * a13 - a03 * a12;
    var b06 = a20 * a31 - a21 * a30;
    var b07 = a20 * a32 - a22 * a30;
    var b08 = a20 * a33 - a23 * a30;
    var b09 = a21 * a32 - a22 * a31;
    var b10 = a21 * a33 - a23 * a31;
    var b11 = a22 * a33 - a23 * a32; // Calculate the determinant
    var det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
    if (!det) return null;
    det = 1.0 / det;
    out[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
    out[1] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
    out[2] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
    out[3] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
    out[4] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
    out[5] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
    out[6] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
    out[7] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
    out[8] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
    return out;
}
function $879d8210211d0bfa$export$b74061472fe7c07(out, width, height) {
    out[0] = 2 / width;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = -2 / height;
    out[5] = 0;
    out[6] = -1;
    out[7] = 1;
    out[8] = 1;
    return out;
}
function $879d8210211d0bfa$export$42d51816ce590c93(a) {
    return "mat3(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ", " + a[4] + ", " + a[5] + ", " + a[6] + ", " + a[7] + ", " + a[8] + ")";
}
function $879d8210211d0bfa$export$326827e8268e9cdb(a) {
    return Math.hypot(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
}
function $879d8210211d0bfa$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    out[3] = a[3] + b[3];
    out[4] = a[4] + b[4];
    out[5] = a[5] + b[5];
    out[6] = a[6] + b[6];
    out[7] = a[7] + b[7];
    out[8] = a[8] + b[8];
    return out;
}
function $879d8210211d0bfa$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    out[3] = a[3] - b[3];
    out[4] = a[4] - b[4];
    out[5] = a[5] - b[5];
    out[6] = a[6] - b[6];
    out[7] = a[7] - b[7];
    out[8] = a[8] - b[8];
    return out;
}
function $879d8210211d0bfa$export$c697bed75648cdb7(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    out[3] = a[3] * b;
    out[4] = a[4] * b;
    out[5] = a[5] * b;
    out[6] = a[6] * b;
    out[7] = a[7] * b;
    out[8] = a[8] * b;
    return out;
}
function $879d8210211d0bfa$export$553579f63bdd7137(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    out[2] = a[2] + b[2] * scale;
    out[3] = a[3] + b[3] * scale;
    out[4] = a[4] + b[4] * scale;
    out[5] = a[5] + b[5] * scale;
    out[6] = a[6] + b[6] * scale;
    out[7] = a[7] + b[7] * scale;
    out[8] = a[8] + b[8] * scale;
    return out;
}
function $879d8210211d0bfa$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3] && a[4] === b[4] && a[5] === b[5] && a[6] === b[6] && a[7] === b[7] && a[8] === b[8];
}
function $879d8210211d0bfa$export$e9bab7fafb253603(a, b) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3], a4 = a[4], a5 = a[5], a6 = a[6], a7 = a[7], a8 = a[8];
    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7], b8 = b[8];
    return Math.abs(a0 - b0) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a2), Math.abs(b2)) && Math.abs(a3 - b3) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a3), Math.abs(b3)) && Math.abs(a4 - b4) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a4), Math.abs(b4)) && Math.abs(a5 - b5) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a5), Math.abs(b5)) && Math.abs(a6 - b6) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a6), Math.abs(b6)) && Math.abs(a7 - b7) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a7), Math.abs(b7)) && Math.abs(a8 - b8) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a8), Math.abs(b8));
}
var $879d8210211d0bfa$export$6e3a27864ab166fe = $879d8210211d0bfa$export$2060d2db72cce88f;
var $879d8210211d0bfa$export$f93b5905241a7cca = $879d8210211d0bfa$export$4e2d2ead65e5f7e3;

});

parcelRegister("3iqbd", function(module, exports) {

$parcel$export(module.exports, "create", () => $26675c4f95835ef1$export$185802fd694ee1f5);
$parcel$export(module.exports, "clone", () => $26675c4f95835ef1$export$9cd59f9826255e47);
$parcel$export(module.exports, "copy", () => $26675c4f95835ef1$export$784d13d8ee351f07);
$parcel$export(module.exports, "fromValues", () => $26675c4f95835ef1$export$a82be99ed2a44a7d);
$parcel$export(module.exports, "set", () => $26675c4f95835ef1$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "identity", () => $26675c4f95835ef1$export$f0954fd7d5368655);
$parcel$export(module.exports, "transpose", () => $26675c4f95835ef1$export$9cb09a71b7d66923);
$parcel$export(module.exports, "invert", () => $26675c4f95835ef1$export$6897c284b6f9f4dc);
$parcel$export(module.exports, "adjoint", () => $26675c4f95835ef1$export$33f3c024b4ae00a1);
$parcel$export(module.exports, "determinant", () => $26675c4f95835ef1$export$a04698f914c55ed9);
$parcel$export(module.exports, "multiply", () => $26675c4f95835ef1$export$2060d2db72cce88f);
$parcel$export(module.exports, "translate", () => $26675c4f95835ef1$export$d73ee8ef04f5226a);
$parcel$export(module.exports, "scale", () => $26675c4f95835ef1$export$dcdf75081b88279d);
$parcel$export(module.exports, "rotate", () => $26675c4f95835ef1$export$bb628a54ab399bc9);
$parcel$export(module.exports, "rotateX", () => $26675c4f95835ef1$export$a59c8716592e09af);
$parcel$export(module.exports, "rotateY", () => $26675c4f95835ef1$export$cf71e4d4ca4d1cfd);
$parcel$export(module.exports, "rotateZ", () => $26675c4f95835ef1$export$ea6eae3365de5b9c);
$parcel$export(module.exports, "fromTranslation", () => $26675c4f95835ef1$export$bc9e79e74e9fddf6);
$parcel$export(module.exports, "fromScaling", () => $26675c4f95835ef1$export$832ca188ffb1955d);
$parcel$export(module.exports, "fromRotation", () => $26675c4f95835ef1$export$926fc125ff3c666c);
$parcel$export(module.exports, "fromXRotation", () => $26675c4f95835ef1$export$dd47cc2f828c32ef);
$parcel$export(module.exports, "fromYRotation", () => $26675c4f95835ef1$export$7dc997d67d2b7f33);
$parcel$export(module.exports, "fromZRotation", () => $26675c4f95835ef1$export$ad5ddaedc8f405df);
$parcel$export(module.exports, "fromRotationTranslation", () => $26675c4f95835ef1$export$9545ac307f2a256b);
$parcel$export(module.exports, "fromQuat2", () => $26675c4f95835ef1$export$ff497f2be31cc6a);
$parcel$export(module.exports, "getTranslation", () => $26675c4f95835ef1$export$202e99f82f7f0395);
$parcel$export(module.exports, "getScaling", () => $26675c4f95835ef1$export$71dc54d92bd04b57);
$parcel$export(module.exports, "getRotation", () => $26675c4f95835ef1$export$df3937d3b537df0a);
$parcel$export(module.exports, "fromRotationTranslationScale", () => $26675c4f95835ef1$export$ddf9c55c9f2be172);
$parcel$export(module.exports, "fromRotationTranslationScaleOrigin", () => $26675c4f95835ef1$export$1def1f860edc4b1f);
$parcel$export(module.exports, "fromQuat", () => $26675c4f95835ef1$export$2ff2bbe382249af7);
$parcel$export(module.exports, "frustum", () => $26675c4f95835ef1$export$89b5708c387cac6c);
$parcel$export(module.exports, "perspectiveNO", () => $26675c4f95835ef1$export$4cf19729ec9a96b8);
$parcel$export(module.exports, "perspective", () => $26675c4f95835ef1$export$541149539f3a4684);
$parcel$export(module.exports, "perspectiveZO", () => $26675c4f95835ef1$export$294bba99a6af0c0c);
$parcel$export(module.exports, "perspectiveFromFieldOfView", () => $26675c4f95835ef1$export$58ae211c788e338f);
$parcel$export(module.exports, "orthoNO", () => $26675c4f95835ef1$export$c5f65ef3eb668f27);
$parcel$export(module.exports, "ortho", () => $26675c4f95835ef1$export$4f2167e613cfc87b);
$parcel$export(module.exports, "orthoZO", () => $26675c4f95835ef1$export$b1d31ea7b4d854e);
$parcel$export(module.exports, "lookAt", () => $26675c4f95835ef1$export$d924e14fd6d9aa66);
$parcel$export(module.exports, "targetTo", () => $26675c4f95835ef1$export$aa67782f4dc9e52c);
$parcel$export(module.exports, "str", () => $26675c4f95835ef1$export$42d51816ce590c93);
$parcel$export(module.exports, "frob", () => $26675c4f95835ef1$export$326827e8268e9cdb);
$parcel$export(module.exports, "add", () => $26675c4f95835ef1$export$e16d8520af44a096);
$parcel$export(module.exports, "subtract", () => $26675c4f95835ef1$export$4e2d2ead65e5f7e3);
$parcel$export(module.exports, "multiplyScalar", () => $26675c4f95835ef1$export$c697bed75648cdb7);
$parcel$export(module.exports, "multiplyScalarAndAdd", () => $26675c4f95835ef1$export$553579f63bdd7137);
$parcel$export(module.exports, "exactEquals", () => $26675c4f95835ef1$export$f2599a5cf1109d8);
$parcel$export(module.exports, "equals", () => $26675c4f95835ef1$export$e9bab7fafb253603);
$parcel$export(module.exports, "mul", () => $26675c4f95835ef1$export$6e3a27864ab166fe);
$parcel$export(module.exports, "sub", () => $26675c4f95835ef1$export$f93b5905241a7cca);

var $amnUE = parcelRequire("amnUE");
function $26675c4f95835ef1$export$185802fd694ee1f5() {
    var out = new $amnUE.ARRAY_TYPE(16);
    if ($amnUE.ARRAY_TYPE != Float32Array) {
        out[1] = 0;
        out[2] = 0;
        out[3] = 0;
        out[4] = 0;
        out[6] = 0;
        out[7] = 0;
        out[8] = 0;
        out[9] = 0;
        out[11] = 0;
        out[12] = 0;
        out[13] = 0;
        out[14] = 0;
    }
    out[0] = 1;
    out[5] = 1;
    out[10] = 1;
    out[15] = 1;
    return out;
}
function $26675c4f95835ef1$export$9cd59f9826255e47(a) {
    var out = new $amnUE.ARRAY_TYPE(16);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    out[9] = a[9];
    out[10] = a[10];
    out[11] = a[11];
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
    return out;
}
function $26675c4f95835ef1$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    out[9] = a[9];
    out[10] = a[10];
    out[11] = a[11];
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
    return out;
}
function $26675c4f95835ef1$export$a82be99ed2a44a7d(m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33) {
    var out = new $amnUE.ARRAY_TYPE(16);
    out[0] = m00;
    out[1] = m01;
    out[2] = m02;
    out[3] = m03;
    out[4] = m10;
    out[5] = m11;
    out[6] = m12;
    out[7] = m13;
    out[8] = m20;
    out[9] = m21;
    out[10] = m22;
    out[11] = m23;
    out[12] = m30;
    out[13] = m31;
    out[14] = m32;
    out[15] = m33;
    return out;
}
function $26675c4f95835ef1$export$adaa4cf7ef1b65be(out, m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33) {
    out[0] = m00;
    out[1] = m01;
    out[2] = m02;
    out[3] = m03;
    out[4] = m10;
    out[5] = m11;
    out[6] = m12;
    out[7] = m13;
    out[8] = m20;
    out[9] = m21;
    out[10] = m22;
    out[11] = m23;
    out[12] = m30;
    out[13] = m31;
    out[14] = m32;
    out[15] = m33;
    return out;
}
function $26675c4f95835ef1$export$f0954fd7d5368655(out) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = 1;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 1;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $26675c4f95835ef1$export$9cb09a71b7d66923(out, a) {
    // If we are transposing ourselves we can skip a few steps but have to cache some values
    if (out === a) {
        var a01 = a[1], a02 = a[2], a03 = a[3];
        var a12 = a[6], a13 = a[7];
        var a23 = a[11];
        out[1] = a[4];
        out[2] = a[8];
        out[3] = a[12];
        out[4] = a01;
        out[6] = a[9];
        out[7] = a[13];
        out[8] = a02;
        out[9] = a12;
        out[11] = a[14];
        out[12] = a03;
        out[13] = a13;
        out[14] = a23;
    } else {
        out[0] = a[0];
        out[1] = a[4];
        out[2] = a[8];
        out[3] = a[12];
        out[4] = a[1];
        out[5] = a[5];
        out[6] = a[9];
        out[7] = a[13];
        out[8] = a[2];
        out[9] = a[6];
        out[10] = a[10];
        out[11] = a[14];
        out[12] = a[3];
        out[13] = a[7];
        out[14] = a[11];
        out[15] = a[15];
    }
    return out;
}
function $26675c4f95835ef1$export$6897c284b6f9f4dc(out, a) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    var a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    var a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    var a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    var b00 = a00 * a11 - a01 * a10;
    var b01 = a00 * a12 - a02 * a10;
    var b02 = a00 * a13 - a03 * a10;
    var b03 = a01 * a12 - a02 * a11;
    var b04 = a01 * a13 - a03 * a11;
    var b05 = a02 * a13 - a03 * a12;
    var b06 = a20 * a31 - a21 * a30;
    var b07 = a20 * a32 - a22 * a30;
    var b08 = a20 * a33 - a23 * a30;
    var b09 = a21 * a32 - a22 * a31;
    var b10 = a21 * a33 - a23 * a31;
    var b11 = a22 * a33 - a23 * a32; // Calculate the determinant
    var det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
    if (!det) return null;
    det = 1.0 / det;
    out[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
    out[1] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
    out[2] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
    out[3] = (a22 * b04 - a21 * b05 - a23 * b03) * det;
    out[4] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
    out[5] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
    out[6] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
    out[7] = (a20 * b05 - a22 * b02 + a23 * b01) * det;
    out[8] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
    out[9] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
    out[10] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
    out[11] = (a21 * b02 - a20 * b04 - a23 * b00) * det;
    out[12] = (a11 * b07 - a10 * b09 - a12 * b06) * det;
    out[13] = (a00 * b09 - a01 * b07 + a02 * b06) * det;
    out[14] = (a31 * b01 - a30 * b03 - a32 * b00) * det;
    out[15] = (a20 * b03 - a21 * b01 + a22 * b00) * det;
    return out;
}
function $26675c4f95835ef1$export$33f3c024b4ae00a1(out, a) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    var a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    var a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    var a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    out[0] = a11 * (a22 * a33 - a23 * a32) - a21 * (a12 * a33 - a13 * a32) + a31 * (a12 * a23 - a13 * a22);
    out[1] = -(a01 * (a22 * a33 - a23 * a32) - a21 * (a02 * a33 - a03 * a32) + a31 * (a02 * a23 - a03 * a22));
    out[2] = a01 * (a12 * a33 - a13 * a32) - a11 * (a02 * a33 - a03 * a32) + a31 * (a02 * a13 - a03 * a12);
    out[3] = -(a01 * (a12 * a23 - a13 * a22) - a11 * (a02 * a23 - a03 * a22) + a21 * (a02 * a13 - a03 * a12));
    out[4] = -(a10 * (a22 * a33 - a23 * a32) - a20 * (a12 * a33 - a13 * a32) + a30 * (a12 * a23 - a13 * a22));
    out[5] = a00 * (a22 * a33 - a23 * a32) - a20 * (a02 * a33 - a03 * a32) + a30 * (a02 * a23 - a03 * a22);
    out[6] = -(a00 * (a12 * a33 - a13 * a32) - a10 * (a02 * a33 - a03 * a32) + a30 * (a02 * a13 - a03 * a12));
    out[7] = a00 * (a12 * a23 - a13 * a22) - a10 * (a02 * a23 - a03 * a22) + a20 * (a02 * a13 - a03 * a12);
    out[8] = a10 * (a21 * a33 - a23 * a31) - a20 * (a11 * a33 - a13 * a31) + a30 * (a11 * a23 - a13 * a21);
    out[9] = -(a00 * (a21 * a33 - a23 * a31) - a20 * (a01 * a33 - a03 * a31) + a30 * (a01 * a23 - a03 * a21));
    out[10] = a00 * (a11 * a33 - a13 * a31) - a10 * (a01 * a33 - a03 * a31) + a30 * (a01 * a13 - a03 * a11);
    out[11] = -(a00 * (a11 * a23 - a13 * a21) - a10 * (a01 * a23 - a03 * a21) + a20 * (a01 * a13 - a03 * a11));
    out[12] = -(a10 * (a21 * a32 - a22 * a31) - a20 * (a11 * a32 - a12 * a31) + a30 * (a11 * a22 - a12 * a21));
    out[13] = a00 * (a21 * a32 - a22 * a31) - a20 * (a01 * a32 - a02 * a31) + a30 * (a01 * a22 - a02 * a21);
    out[14] = -(a00 * (a11 * a32 - a12 * a31) - a10 * (a01 * a32 - a02 * a31) + a30 * (a01 * a12 - a02 * a11));
    out[15] = a00 * (a11 * a22 - a12 * a21) - a10 * (a01 * a22 - a02 * a21) + a20 * (a01 * a12 - a02 * a11);
    return out;
}
function $26675c4f95835ef1$export$a04698f914c55ed9(a) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    var a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    var a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    var a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    var b00 = a00 * a11 - a01 * a10;
    var b01 = a00 * a12 - a02 * a10;
    var b02 = a00 * a13 - a03 * a10;
    var b03 = a01 * a12 - a02 * a11;
    var b04 = a01 * a13 - a03 * a11;
    var b05 = a02 * a13 - a03 * a12;
    var b06 = a20 * a31 - a21 * a30;
    var b07 = a20 * a32 - a22 * a30;
    var b08 = a20 * a33 - a23 * a30;
    var b09 = a21 * a32 - a22 * a31;
    var b10 = a21 * a33 - a23 * a31;
    var b11 = a22 * a33 - a23 * a32; // Calculate the determinant
    return b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
}
function $26675c4f95835ef1$export$2060d2db72cce88f(out, a, b) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    var a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    var a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    var a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15]; // Cache only the current line of the second matrix
    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
    out[0] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[1] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[2] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[3] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    b0 = b[4];
    b1 = b[5];
    b2 = b[6];
    b3 = b[7];
    out[4] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[5] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[6] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[7] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    b0 = b[8];
    b1 = b[9];
    b2 = b[10];
    b3 = b[11];
    out[8] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[9] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[10] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[11] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    b0 = b[12];
    b1 = b[13];
    b2 = b[14];
    b3 = b[15];
    out[12] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[13] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[14] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[15] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    return out;
}
function $26675c4f95835ef1$export$d73ee8ef04f5226a(out, a, v) {
    var x = v[0], y = v[1], z = v[2];
    var a00, a01, a02, a03;
    var a10, a11, a12, a13;
    var a20, a21, a22, a23;
    if (a === out) {
        out[12] = a[0] * x + a[4] * y + a[8] * z + a[12];
        out[13] = a[1] * x + a[5] * y + a[9] * z + a[13];
        out[14] = a[2] * x + a[6] * y + a[10] * z + a[14];
        out[15] = a[3] * x + a[7] * y + a[11] * z + a[15];
    } else {
        a00 = a[0];
        a01 = a[1];
        a02 = a[2];
        a03 = a[3];
        a10 = a[4];
        a11 = a[5];
        a12 = a[6];
        a13 = a[7];
        a20 = a[8];
        a21 = a[9];
        a22 = a[10];
        a23 = a[11];
        out[0] = a00;
        out[1] = a01;
        out[2] = a02;
        out[3] = a03;
        out[4] = a10;
        out[5] = a11;
        out[6] = a12;
        out[7] = a13;
        out[8] = a20;
        out[9] = a21;
        out[10] = a22;
        out[11] = a23;
        out[12] = a00 * x + a10 * y + a20 * z + a[12];
        out[13] = a01 * x + a11 * y + a21 * z + a[13];
        out[14] = a02 * x + a12 * y + a22 * z + a[14];
        out[15] = a03 * x + a13 * y + a23 * z + a[15];
    }
    return out;
}
function $26675c4f95835ef1$export$dcdf75081b88279d(out, a, v) {
    var x = v[0], y = v[1], z = v[2];
    out[0] = a[0] * x;
    out[1] = a[1] * x;
    out[2] = a[2] * x;
    out[3] = a[3] * x;
    out[4] = a[4] * y;
    out[5] = a[5] * y;
    out[6] = a[6] * y;
    out[7] = a[7] * y;
    out[8] = a[8] * z;
    out[9] = a[9] * z;
    out[10] = a[10] * z;
    out[11] = a[11] * z;
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
    return out;
}
function $26675c4f95835ef1$export$bb628a54ab399bc9(out, a, rad, axis) {
    var x = axis[0], y = axis[1], z = axis[2];
    var len = Math.hypot(x, y, z);
    var s, c, t;
    var a00, a01, a02, a03;
    var a10, a11, a12, a13;
    var a20, a21, a22, a23;
    var b00, b01, b02;
    var b10, b11, b12;
    var b20, b21, b22;
    if (len < $amnUE.EPSILON) return null;
    len = 1 / len;
    x *= len;
    y *= len;
    z *= len;
    s = Math.sin(rad);
    c = Math.cos(rad);
    t = 1 - c;
    a00 = a[0];
    a01 = a[1];
    a02 = a[2];
    a03 = a[3];
    a10 = a[4];
    a11 = a[5];
    a12 = a[6];
    a13 = a[7];
    a20 = a[8];
    a21 = a[9];
    a22 = a[10];
    a23 = a[11]; // Construct the elements of the rotation matrix
    b00 = x * x * t + c;
    b01 = y * x * t + z * s;
    b02 = z * x * t - y * s;
    b10 = x * y * t - z * s;
    b11 = y * y * t + c;
    b12 = z * y * t + x * s;
    b20 = x * z * t + y * s;
    b21 = y * z * t - x * s;
    b22 = z * z * t + c; // Perform rotation-specific matrix multiplication
    out[0] = a00 * b00 + a10 * b01 + a20 * b02;
    out[1] = a01 * b00 + a11 * b01 + a21 * b02;
    out[2] = a02 * b00 + a12 * b01 + a22 * b02;
    out[3] = a03 * b00 + a13 * b01 + a23 * b02;
    out[4] = a00 * b10 + a10 * b11 + a20 * b12;
    out[5] = a01 * b10 + a11 * b11 + a21 * b12;
    out[6] = a02 * b10 + a12 * b11 + a22 * b12;
    out[7] = a03 * b10 + a13 * b11 + a23 * b12;
    out[8] = a00 * b20 + a10 * b21 + a20 * b22;
    out[9] = a01 * b20 + a11 * b21 + a21 * b22;
    out[10] = a02 * b20 + a12 * b21 + a22 * b22;
    out[11] = a03 * b20 + a13 * b21 + a23 * b22;
    if (a !== out) {
        // If the source and destination differ, copy the unchanged last row
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    }
    return out;
}
function $26675c4f95835ef1$export$a59c8716592e09af(out, a, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad);
    var a10 = a[4];
    var a11 = a[5];
    var a12 = a[6];
    var a13 = a[7];
    var a20 = a[8];
    var a21 = a[9];
    var a22 = a[10];
    var a23 = a[11];
    if (a !== out) {
        // If the source and destination differ, copy the unchanged rows
        out[0] = a[0];
        out[1] = a[1];
        out[2] = a[2];
        out[3] = a[3];
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    } // Perform axis-specific matrix multiplication
    out[4] = a10 * c + a20 * s;
    out[5] = a11 * c + a21 * s;
    out[6] = a12 * c + a22 * s;
    out[7] = a13 * c + a23 * s;
    out[8] = a20 * c - a10 * s;
    out[9] = a21 * c - a11 * s;
    out[10] = a22 * c - a12 * s;
    out[11] = a23 * c - a13 * s;
    return out;
}
function $26675c4f95835ef1$export$cf71e4d4ca4d1cfd(out, a, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad);
    var a00 = a[0];
    var a01 = a[1];
    var a02 = a[2];
    var a03 = a[3];
    var a20 = a[8];
    var a21 = a[9];
    var a22 = a[10];
    var a23 = a[11];
    if (a !== out) {
        // If the source and destination differ, copy the unchanged rows
        out[4] = a[4];
        out[5] = a[5];
        out[6] = a[6];
        out[7] = a[7];
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    } // Perform axis-specific matrix multiplication
    out[0] = a00 * c - a20 * s;
    out[1] = a01 * c - a21 * s;
    out[2] = a02 * c - a22 * s;
    out[3] = a03 * c - a23 * s;
    out[8] = a00 * s + a20 * c;
    out[9] = a01 * s + a21 * c;
    out[10] = a02 * s + a22 * c;
    out[11] = a03 * s + a23 * c;
    return out;
}
function $26675c4f95835ef1$export$ea6eae3365de5b9c(out, a, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad);
    var a00 = a[0];
    var a01 = a[1];
    var a02 = a[2];
    var a03 = a[3];
    var a10 = a[4];
    var a11 = a[5];
    var a12 = a[6];
    var a13 = a[7];
    if (a !== out) {
        // If the source and destination differ, copy the unchanged last row
        out[8] = a[8];
        out[9] = a[9];
        out[10] = a[10];
        out[11] = a[11];
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    } // Perform axis-specific matrix multiplication
    out[0] = a00 * c + a10 * s;
    out[1] = a01 * c + a11 * s;
    out[2] = a02 * c + a12 * s;
    out[3] = a03 * c + a13 * s;
    out[4] = a10 * c - a00 * s;
    out[5] = a11 * c - a01 * s;
    out[6] = a12 * c - a02 * s;
    out[7] = a13 * c - a03 * s;
    return out;
}
function $26675c4f95835ef1$export$bc9e79e74e9fddf6(out, v) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = 1;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 1;
    out[11] = 0;
    out[12] = v[0];
    out[13] = v[1];
    out[14] = v[2];
    out[15] = 1;
    return out;
}
function $26675c4f95835ef1$export$832ca188ffb1955d(out, v) {
    out[0] = v[0];
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = v[1];
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = v[2];
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $26675c4f95835ef1$export$926fc125ff3c666c(out, rad, axis) {
    var x = axis[0], y = axis[1], z = axis[2];
    var len = Math.hypot(x, y, z);
    var s, c, t;
    if (len < $amnUE.EPSILON) return null;
    len = 1 / len;
    x *= len;
    y *= len;
    z *= len;
    s = Math.sin(rad);
    c = Math.cos(rad);
    t = 1 - c; // Perform rotation-specific matrix multiplication
    out[0] = x * x * t + c;
    out[1] = y * x * t + z * s;
    out[2] = z * x * t - y * s;
    out[3] = 0;
    out[4] = x * y * t - z * s;
    out[5] = y * y * t + c;
    out[6] = z * y * t + x * s;
    out[7] = 0;
    out[8] = x * z * t + y * s;
    out[9] = y * z * t - x * s;
    out[10] = z * z * t + c;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $26675c4f95835ef1$export$dd47cc2f828c32ef(out, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad); // Perform axis-specific matrix multiplication
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = c;
    out[6] = s;
    out[7] = 0;
    out[8] = 0;
    out[9] = -s;
    out[10] = c;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $26675c4f95835ef1$export$7dc997d67d2b7f33(out, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad); // Perform axis-specific matrix multiplication
    out[0] = c;
    out[1] = 0;
    out[2] = -s;
    out[3] = 0;
    out[4] = 0;
    out[5] = 1;
    out[6] = 0;
    out[7] = 0;
    out[8] = s;
    out[9] = 0;
    out[10] = c;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $26675c4f95835ef1$export$ad5ddaedc8f405df(out, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad); // Perform axis-specific matrix multiplication
    out[0] = c;
    out[1] = s;
    out[2] = 0;
    out[3] = 0;
    out[4] = -s;
    out[5] = c;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 1;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $26675c4f95835ef1$export$9545ac307f2a256b(out, q, v) {
    // Quaternion math
    var x = q[0], y = q[1], z = q[2], w = q[3];
    var x2 = x + x;
    var y2 = y + y;
    var z2 = z + z;
    var xx = x * x2;
    var xy = x * y2;
    var xz = x * z2;
    var yy = y * y2;
    var yz = y * z2;
    var zz = z * z2;
    var wx = w * x2;
    var wy = w * y2;
    var wz = w * z2;
    out[0] = 1 - (yy + zz);
    out[1] = xy + wz;
    out[2] = xz - wy;
    out[3] = 0;
    out[4] = xy - wz;
    out[5] = 1 - (xx + zz);
    out[6] = yz + wx;
    out[7] = 0;
    out[8] = xz + wy;
    out[9] = yz - wx;
    out[10] = 1 - (xx + yy);
    out[11] = 0;
    out[12] = v[0];
    out[13] = v[1];
    out[14] = v[2];
    out[15] = 1;
    return out;
}
function $26675c4f95835ef1$export$ff497f2be31cc6a(out, a) {
    var translation = new $amnUE.ARRAY_TYPE(3);
    var bx = -a[0], by = -a[1], bz = -a[2], bw = a[3], ax = a[4], ay = a[5], az = a[6], aw = a[7];
    var magnitude = bx * bx + by * by + bz * bz + bw * bw; //Only scale if it makes sense
    if (magnitude > 0) {
        translation[0] = (ax * bw + aw * bx + ay * bz - az * by) * 2 / magnitude;
        translation[1] = (ay * bw + aw * by + az * bx - ax * bz) * 2 / magnitude;
        translation[2] = (az * bw + aw * bz + ax * by - ay * bx) * 2 / magnitude;
    } else {
        translation[0] = (ax * bw + aw * bx + ay * bz - az * by) * 2;
        translation[1] = (ay * bw + aw * by + az * bx - ax * bz) * 2;
        translation[2] = (az * bw + aw * bz + ax * by - ay * bx) * 2;
    }
    $26675c4f95835ef1$export$9545ac307f2a256b(out, a, translation);
    return out;
}
function $26675c4f95835ef1$export$202e99f82f7f0395(out, mat) {
    out[0] = mat[12];
    out[1] = mat[13];
    out[2] = mat[14];
    return out;
}
function $26675c4f95835ef1$export$71dc54d92bd04b57(out, mat) {
    var m11 = mat[0];
    var m12 = mat[1];
    var m13 = mat[2];
    var m21 = mat[4];
    var m22 = mat[5];
    var m23 = mat[6];
    var m31 = mat[8];
    var m32 = mat[9];
    var m33 = mat[10];
    out[0] = Math.hypot(m11, m12, m13);
    out[1] = Math.hypot(m21, m22, m23);
    out[2] = Math.hypot(m31, m32, m33);
    return out;
}
function $26675c4f95835ef1$export$df3937d3b537df0a(out, mat) {
    var scaling = new $amnUE.ARRAY_TYPE(3);
    $26675c4f95835ef1$export$71dc54d92bd04b57(scaling, mat);
    var is1 = 1 / scaling[0];
    var is2 = 1 / scaling[1];
    var is3 = 1 / scaling[2];
    var sm11 = mat[0] * is1;
    var sm12 = mat[1] * is2;
    var sm13 = mat[2] * is3;
    var sm21 = mat[4] * is1;
    var sm22 = mat[5] * is2;
    var sm23 = mat[6] * is3;
    var sm31 = mat[8] * is1;
    var sm32 = mat[9] * is2;
    var sm33 = mat[10] * is3;
    var trace = sm11 + sm22 + sm33;
    var S = 0;
    if (trace > 0) {
        S = Math.sqrt(trace + 1.0) * 2;
        out[3] = 0.25 * S;
        out[0] = (sm23 - sm32) / S;
        out[1] = (sm31 - sm13) / S;
        out[2] = (sm12 - sm21) / S;
    } else if (sm11 > sm22 && sm11 > sm33) {
        S = Math.sqrt(1.0 + sm11 - sm22 - sm33) * 2;
        out[3] = (sm23 - sm32) / S;
        out[0] = 0.25 * S;
        out[1] = (sm12 + sm21) / S;
        out[2] = (sm31 + sm13) / S;
    } else if (sm22 > sm33) {
        S = Math.sqrt(1.0 + sm22 - sm11 - sm33) * 2;
        out[3] = (sm31 - sm13) / S;
        out[0] = (sm12 + sm21) / S;
        out[1] = 0.25 * S;
        out[2] = (sm23 + sm32) / S;
    } else {
        S = Math.sqrt(1.0 + sm33 - sm11 - sm22) * 2;
        out[3] = (sm12 - sm21) / S;
        out[0] = (sm31 + sm13) / S;
        out[1] = (sm23 + sm32) / S;
        out[2] = 0.25 * S;
    }
    return out;
}
function $26675c4f95835ef1$export$ddf9c55c9f2be172(out, q, v, s) {
    // Quaternion math
    var x = q[0], y = q[1], z = q[2], w = q[3];
    var x2 = x + x;
    var y2 = y + y;
    var z2 = z + z;
    var xx = x * x2;
    var xy = x * y2;
    var xz = x * z2;
    var yy = y * y2;
    var yz = y * z2;
    var zz = z * z2;
    var wx = w * x2;
    var wy = w * y2;
    var wz = w * z2;
    var sx = s[0];
    var sy = s[1];
    var sz = s[2];
    out[0] = (1 - (yy + zz)) * sx;
    out[1] = (xy + wz) * sx;
    out[2] = (xz - wy) * sx;
    out[3] = 0;
    out[4] = (xy - wz) * sy;
    out[5] = (1 - (xx + zz)) * sy;
    out[6] = (yz + wx) * sy;
    out[7] = 0;
    out[8] = (xz + wy) * sz;
    out[9] = (yz - wx) * sz;
    out[10] = (1 - (xx + yy)) * sz;
    out[11] = 0;
    out[12] = v[0];
    out[13] = v[1];
    out[14] = v[2];
    out[15] = 1;
    return out;
}
function $26675c4f95835ef1$export$1def1f860edc4b1f(out, q, v, s, o) {
    // Quaternion math
    var x = q[0], y = q[1], z = q[2], w = q[3];
    var x2 = x + x;
    var y2 = y + y;
    var z2 = z + z;
    var xx = x * x2;
    var xy = x * y2;
    var xz = x * z2;
    var yy = y * y2;
    var yz = y * z2;
    var zz = z * z2;
    var wx = w * x2;
    var wy = w * y2;
    var wz = w * z2;
    var sx = s[0];
    var sy = s[1];
    var sz = s[2];
    var ox = o[0];
    var oy = o[1];
    var oz = o[2];
    var out0 = (1 - (yy + zz)) * sx;
    var out1 = (xy + wz) * sx;
    var out2 = (xz - wy) * sx;
    var out4 = (xy - wz) * sy;
    var out5 = (1 - (xx + zz)) * sy;
    var out6 = (yz + wx) * sy;
    var out8 = (xz + wy) * sz;
    var out9 = (yz - wx) * sz;
    var out10 = (1 - (xx + yy)) * sz;
    out[0] = out0;
    out[1] = out1;
    out[2] = out2;
    out[3] = 0;
    out[4] = out4;
    out[5] = out5;
    out[6] = out6;
    out[7] = 0;
    out[8] = out8;
    out[9] = out9;
    out[10] = out10;
    out[11] = 0;
    out[12] = v[0] + ox - (out0 * ox + out4 * oy + out8 * oz);
    out[13] = v[1] + oy - (out1 * ox + out5 * oy + out9 * oz);
    out[14] = v[2] + oz - (out2 * ox + out6 * oy + out10 * oz);
    out[15] = 1;
    return out;
}
function $26675c4f95835ef1$export$2ff2bbe382249af7(out, q) {
    var x = q[0], y = q[1], z = q[2], w = q[3];
    var x2 = x + x;
    var y2 = y + y;
    var z2 = z + z;
    var xx = x * x2;
    var yx = y * x2;
    var yy = y * y2;
    var zx = z * x2;
    var zy = z * y2;
    var zz = z * z2;
    var wx = w * x2;
    var wy = w * y2;
    var wz = w * z2;
    out[0] = 1 - yy - zz;
    out[1] = yx + wz;
    out[2] = zx - wy;
    out[3] = 0;
    out[4] = yx - wz;
    out[5] = 1 - xx - zz;
    out[6] = zy + wx;
    out[7] = 0;
    out[8] = zx + wy;
    out[9] = zy - wx;
    out[10] = 1 - xx - yy;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $26675c4f95835ef1$export$89b5708c387cac6c(out, left, right, bottom, top, near, far) {
    var rl = 1 / (right - left);
    var tb = 1 / (top - bottom);
    var nf = 1 / (near - far);
    out[0] = near * 2 * rl;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = near * 2 * tb;
    out[6] = 0;
    out[7] = 0;
    out[8] = (right + left) * rl;
    out[9] = (top + bottom) * tb;
    out[10] = (far + near) * nf;
    out[11] = -1;
    out[12] = 0;
    out[13] = 0;
    out[14] = far * near * 2 * nf;
    out[15] = 0;
    return out;
}
function $26675c4f95835ef1$export$4cf19729ec9a96b8(out, fovy, aspect, near, far) {
    var f = 1.0 / Math.tan(fovy / 2), nf;
    out[0] = f / aspect;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = f;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[11] = -1;
    out[12] = 0;
    out[13] = 0;
    out[15] = 0;
    if (far != null && far !== Infinity) {
        nf = 1 / (near - far);
        out[10] = (far + near) * nf;
        out[14] = 2 * far * near * nf;
    } else {
        out[10] = -1;
        out[14] = -2 * near;
    }
    return out;
}
var $26675c4f95835ef1$export$541149539f3a4684 = $26675c4f95835ef1$export$4cf19729ec9a96b8;
function $26675c4f95835ef1$export$294bba99a6af0c0c(out, fovy, aspect, near, far) {
    var f = 1.0 / Math.tan(fovy / 2), nf;
    out[0] = f / aspect;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = f;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[11] = -1;
    out[12] = 0;
    out[13] = 0;
    out[15] = 0;
    if (far != null && far !== Infinity) {
        nf = 1 / (near - far);
        out[10] = far * nf;
        out[14] = far * near * nf;
    } else {
        out[10] = -1;
        out[14] = -near;
    }
    return out;
}
function $26675c4f95835ef1$export$58ae211c788e338f(out, fov, near, far) {
    var upTan = Math.tan(fov.upDegrees * Math.PI / 180.0);
    var downTan = Math.tan(fov.downDegrees * Math.PI / 180.0);
    var leftTan = Math.tan(fov.leftDegrees * Math.PI / 180.0);
    var rightTan = Math.tan(fov.rightDegrees * Math.PI / 180.0);
    var xScale = 2.0 / (leftTan + rightTan);
    var yScale = 2.0 / (upTan + downTan);
    out[0] = xScale;
    out[1] = 0.0;
    out[2] = 0.0;
    out[3] = 0.0;
    out[4] = 0.0;
    out[5] = yScale;
    out[6] = 0.0;
    out[7] = 0.0;
    out[8] = -((leftTan - rightTan) * xScale * 0.5);
    out[9] = (upTan - downTan) * yScale * 0.5;
    out[10] = far / (near - far);
    out[11] = -1;
    out[12] = 0.0;
    out[13] = 0.0;
    out[14] = far * near / (near - far);
    out[15] = 0.0;
    return out;
}
function $26675c4f95835ef1$export$c5f65ef3eb668f27(out, left, right, bottom, top, near, far) {
    var lr = 1 / (left - right);
    var bt = 1 / (bottom - top);
    var nf = 1 / (near - far);
    out[0] = -2 * lr;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = -2 * bt;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 2 * nf;
    out[11] = 0;
    out[12] = (left + right) * lr;
    out[13] = (top + bottom) * bt;
    out[14] = (far + near) * nf;
    out[15] = 1;
    return out;
}
var $26675c4f95835ef1$export$4f2167e613cfc87b = $26675c4f95835ef1$export$c5f65ef3eb668f27;
function $26675c4f95835ef1$export$b1d31ea7b4d854e(out, left, right, bottom, top, near, far) {
    var lr = 1 / (left - right);
    var bt = 1 / (bottom - top);
    var nf = 1 / (near - far);
    out[0] = -2 * lr;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = -2 * bt;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = nf;
    out[11] = 0;
    out[12] = (left + right) * lr;
    out[13] = (top + bottom) * bt;
    out[14] = near * nf;
    out[15] = 1;
    return out;
}
function $26675c4f95835ef1$export$d924e14fd6d9aa66(out, eye, center, up) {
    var x0, x1, x2, y0, y1, y2, z0, z1, z2, len;
    var eyex = eye[0];
    var eyey = eye[1];
    var eyez = eye[2];
    var upx = up[0];
    var upy = up[1];
    var upz = up[2];
    var centerx = center[0];
    var centery = center[1];
    var centerz = center[2];
    if (Math.abs(eyex - centerx) < $amnUE.EPSILON && Math.abs(eyey - centery) < $amnUE.EPSILON && Math.abs(eyez - centerz) < $amnUE.EPSILON) return $26675c4f95835ef1$export$f0954fd7d5368655(out);
    z0 = eyex - centerx;
    z1 = eyey - centery;
    z2 = eyez - centerz;
    len = 1 / Math.hypot(z0, z1, z2);
    z0 *= len;
    z1 *= len;
    z2 *= len;
    x0 = upy * z2 - upz * z1;
    x1 = upz * z0 - upx * z2;
    x2 = upx * z1 - upy * z0;
    len = Math.hypot(x0, x1, x2);
    if (!len) {
        x0 = 0;
        x1 = 0;
        x2 = 0;
    } else {
        len = 1 / len;
        x0 *= len;
        x1 *= len;
        x2 *= len;
    }
    y0 = z1 * x2 - z2 * x1;
    y1 = z2 * x0 - z0 * x2;
    y2 = z0 * x1 - z1 * x0;
    len = Math.hypot(y0, y1, y2);
    if (!len) {
        y0 = 0;
        y1 = 0;
        y2 = 0;
    } else {
        len = 1 / len;
        y0 *= len;
        y1 *= len;
        y2 *= len;
    }
    out[0] = x0;
    out[1] = y0;
    out[2] = z0;
    out[3] = 0;
    out[4] = x1;
    out[5] = y1;
    out[6] = z1;
    out[7] = 0;
    out[8] = x2;
    out[9] = y2;
    out[10] = z2;
    out[11] = 0;
    out[12] = -(x0 * eyex + x1 * eyey + x2 * eyez);
    out[13] = -(y0 * eyex + y1 * eyey + y2 * eyez);
    out[14] = -(z0 * eyex + z1 * eyey + z2 * eyez);
    out[15] = 1;
    return out;
}
function $26675c4f95835ef1$export$aa67782f4dc9e52c(out, eye, target, up) {
    var eyex = eye[0], eyey = eye[1], eyez = eye[2], upx = up[0], upy = up[1], upz = up[2];
    var z0 = eyex - target[0], z1 = eyey - target[1], z2 = eyez - target[2];
    var len = z0 * z0 + z1 * z1 + z2 * z2;
    if (len > 0) {
        len = 1 / Math.sqrt(len);
        z0 *= len;
        z1 *= len;
        z2 *= len;
    }
    var x0 = upy * z2 - upz * z1, x1 = upz * z0 - upx * z2, x2 = upx * z1 - upy * z0;
    len = x0 * x0 + x1 * x1 + x2 * x2;
    if (len > 0) {
        len = 1 / Math.sqrt(len);
        x0 *= len;
        x1 *= len;
        x2 *= len;
    }
    out[0] = x0;
    out[1] = x1;
    out[2] = x2;
    out[3] = 0;
    out[4] = z1 * x2 - z2 * x1;
    out[5] = z2 * x0 - z0 * x2;
    out[6] = z0 * x1 - z1 * x0;
    out[7] = 0;
    out[8] = z0;
    out[9] = z1;
    out[10] = z2;
    out[11] = 0;
    out[12] = eyex;
    out[13] = eyey;
    out[14] = eyez;
    out[15] = 1;
    return out;
}
function $26675c4f95835ef1$export$42d51816ce590c93(a) {
    return "mat4(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ", " + a[4] + ", " + a[5] + ", " + a[6] + ", " + a[7] + ", " + a[8] + ", " + a[9] + ", " + a[10] + ", " + a[11] + ", " + a[12] + ", " + a[13] + ", " + a[14] + ", " + a[15] + ")";
}
function $26675c4f95835ef1$export$326827e8268e9cdb(a) {
    return Math.hypot(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15]);
}
function $26675c4f95835ef1$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    out[3] = a[3] + b[3];
    out[4] = a[4] + b[4];
    out[5] = a[5] + b[5];
    out[6] = a[6] + b[6];
    out[7] = a[7] + b[7];
    out[8] = a[8] + b[8];
    out[9] = a[9] + b[9];
    out[10] = a[10] + b[10];
    out[11] = a[11] + b[11];
    out[12] = a[12] + b[12];
    out[13] = a[13] + b[13];
    out[14] = a[14] + b[14];
    out[15] = a[15] + b[15];
    return out;
}
function $26675c4f95835ef1$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    out[3] = a[3] - b[3];
    out[4] = a[4] - b[4];
    out[5] = a[5] - b[5];
    out[6] = a[6] - b[6];
    out[7] = a[7] - b[7];
    out[8] = a[8] - b[8];
    out[9] = a[9] - b[9];
    out[10] = a[10] - b[10];
    out[11] = a[11] - b[11];
    out[12] = a[12] - b[12];
    out[13] = a[13] - b[13];
    out[14] = a[14] - b[14];
    out[15] = a[15] - b[15];
    return out;
}
function $26675c4f95835ef1$export$c697bed75648cdb7(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    out[3] = a[3] * b;
    out[4] = a[4] * b;
    out[5] = a[5] * b;
    out[6] = a[6] * b;
    out[7] = a[7] * b;
    out[8] = a[8] * b;
    out[9] = a[9] * b;
    out[10] = a[10] * b;
    out[11] = a[11] * b;
    out[12] = a[12] * b;
    out[13] = a[13] * b;
    out[14] = a[14] * b;
    out[15] = a[15] * b;
    return out;
}
function $26675c4f95835ef1$export$553579f63bdd7137(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    out[2] = a[2] + b[2] * scale;
    out[3] = a[3] + b[3] * scale;
    out[4] = a[4] + b[4] * scale;
    out[5] = a[5] + b[5] * scale;
    out[6] = a[6] + b[6] * scale;
    out[7] = a[7] + b[7] * scale;
    out[8] = a[8] + b[8] * scale;
    out[9] = a[9] + b[9] * scale;
    out[10] = a[10] + b[10] * scale;
    out[11] = a[11] + b[11] * scale;
    out[12] = a[12] + b[12] * scale;
    out[13] = a[13] + b[13] * scale;
    out[14] = a[14] + b[14] * scale;
    out[15] = a[15] + b[15] * scale;
    return out;
}
function $26675c4f95835ef1$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3] && a[4] === b[4] && a[5] === b[5] && a[6] === b[6] && a[7] === b[7] && a[8] === b[8] && a[9] === b[9] && a[10] === b[10] && a[11] === b[11] && a[12] === b[12] && a[13] === b[13] && a[14] === b[14] && a[15] === b[15];
}
function $26675c4f95835ef1$export$e9bab7fafb253603(a, b) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3];
    var a4 = a[4], a5 = a[5], a6 = a[6], a7 = a[7];
    var a8 = a[8], a9 = a[9], a10 = a[10], a11 = a[11];
    var a12 = a[12], a13 = a[13], a14 = a[14], a15 = a[15];
    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
    var b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7];
    var b8 = b[8], b9 = b[9], b10 = b[10], b11 = b[11];
    var b12 = b[12], b13 = b[13], b14 = b[14], b15 = b[15];
    return Math.abs(a0 - b0) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a2), Math.abs(b2)) && Math.abs(a3 - b3) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a3), Math.abs(b3)) && Math.abs(a4 - b4) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a4), Math.abs(b4)) && Math.abs(a5 - b5) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a5), Math.abs(b5)) && Math.abs(a6 - b6) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a6), Math.abs(b6)) && Math.abs(a7 - b7) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a7), Math.abs(b7)) && Math.abs(a8 - b8) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a8), Math.abs(b8)) && Math.abs(a9 - b9) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a9), Math.abs(b9)) && Math.abs(a10 - b10) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a10), Math.abs(b10)) && Math.abs(a11 - b11) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a11), Math.abs(b11)) && Math.abs(a12 - b12) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a12), Math.abs(b12)) && Math.abs(a13 - b13) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a13), Math.abs(b13)) && Math.abs(a14 - b14) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a14), Math.abs(b14)) && Math.abs(a15 - b15) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a15), Math.abs(b15));
}
var $26675c4f95835ef1$export$6e3a27864ab166fe = $26675c4f95835ef1$export$2060d2db72cce88f;
var $26675c4f95835ef1$export$f93b5905241a7cca = $26675c4f95835ef1$export$4e2d2ead65e5f7e3;

});

parcelRegister("k1dpP", function(module, exports) {

$parcel$export(module.exports, "create", () => $e92e4eb8d35aaf31$export$185802fd694ee1f5);
$parcel$export(module.exports, "identity", () => $e92e4eb8d35aaf31$export$f0954fd7d5368655);
$parcel$export(module.exports, "setAxisAngle", () => $e92e4eb8d35aaf31$export$4286ddefc8f49512);
$parcel$export(module.exports, "getAxisAngle", () => $e92e4eb8d35aaf31$export$3f70be5e7d7dc51);
$parcel$export(module.exports, "getAngle", () => $e92e4eb8d35aaf31$export$b363da9ded343252);
$parcel$export(module.exports, "dot", () => $e92e4eb8d35aaf31$export$94132a0e348806d4);
$parcel$export(module.exports, "multiply", () => $e92e4eb8d35aaf31$export$2060d2db72cce88f);
$parcel$export(module.exports, "rotateX", () => $e92e4eb8d35aaf31$export$a59c8716592e09af);
$parcel$export(module.exports, "rotateY", () => $e92e4eb8d35aaf31$export$cf71e4d4ca4d1cfd);
$parcel$export(module.exports, "rotateZ", () => $e92e4eb8d35aaf31$export$ea6eae3365de5b9c);
$parcel$export(module.exports, "calculateW", () => $e92e4eb8d35aaf31$export$fb72b72e8d764d4e);
$parcel$export(module.exports, "exp", () => $e92e4eb8d35aaf31$export$b310ec824aaee37f);
$parcel$export(module.exports, "ln", () => $e92e4eb8d35aaf31$export$876cb1b29620556f);
$parcel$export(module.exports, "pow", () => $e92e4eb8d35aaf31$export$9c297f60e22e3389);
$parcel$export(module.exports, "scale", () => $e92e4eb8d35aaf31$export$dcdf75081b88279d);
$parcel$export(module.exports, "slerp", () => $e92e4eb8d35aaf31$export$1544d9bc2995de08);
$parcel$export(module.exports, "random", () => $e92e4eb8d35aaf31$export$4385e60b38654f68);
$parcel$export(module.exports, "invert", () => $e92e4eb8d35aaf31$export$6897c284b6f9f4dc);
$parcel$export(module.exports, "conjugate", () => $e92e4eb8d35aaf31$export$7679f47e72c62560);
$parcel$export(module.exports, "fromMat3", () => $e92e4eb8d35aaf31$export$272a1eb8e5a4b55b);
$parcel$export(module.exports, "fromEuler", () => $e92e4eb8d35aaf31$export$7a404a587ea85af);
$parcel$export(module.exports, "str", () => $e92e4eb8d35aaf31$export$42d51816ce590c93);
$parcel$export(module.exports, "clone", () => $e92e4eb8d35aaf31$export$9cd59f9826255e47);
$parcel$export(module.exports, "fromValues", () => $e92e4eb8d35aaf31$export$a82be99ed2a44a7d);
$parcel$export(module.exports, "copy", () => $e92e4eb8d35aaf31$export$784d13d8ee351f07);
$parcel$export(module.exports, "set", () => $e92e4eb8d35aaf31$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "add", () => $e92e4eb8d35aaf31$export$e16d8520af44a096);
$parcel$export(module.exports, "mul", () => $e92e4eb8d35aaf31$export$6e3a27864ab166fe);
$parcel$export(module.exports, "lerp", () => $e92e4eb8d35aaf31$export$3a89f8d6f6bf6c9f);
$parcel$export(module.exports, "length", () => $e92e4eb8d35aaf31$export$f24224f1c91d8156);
$parcel$export(module.exports, "len", () => $e92e4eb8d35aaf31$export$fc1400facf92c78);
$parcel$export(module.exports, "squaredLength", () => $e92e4eb8d35aaf31$export$ab44e1323ffc8376);
$parcel$export(module.exports, "sqrLen", () => $e92e4eb8d35aaf31$export$99d8dd3f32a3435);
$parcel$export(module.exports, "normalize", () => $e92e4eb8d35aaf31$export$a3295358bff77e);
$parcel$export(module.exports, "exactEquals", () => $e92e4eb8d35aaf31$export$f2599a5cf1109d8);
$parcel$export(module.exports, "equals", () => $e92e4eb8d35aaf31$export$e9bab7fafb253603);
$parcel$export(module.exports, "rotationTo", () => $e92e4eb8d35aaf31$export$72d66f5842c00904);
$parcel$export(module.exports, "sqlerp", () => $e92e4eb8d35aaf31$export$699b0866ca50f6cb);
$parcel$export(module.exports, "setAxes", () => $e92e4eb8d35aaf31$export$937ca0a544b2d712);

var $amnUE = parcelRequire("amnUE");

var $bDSmI = parcelRequire("bDSmI");

var $eIStk = parcelRequire("eIStk");

var $jxhwV = parcelRequire("jxhwV");
function $e92e4eb8d35aaf31$export$185802fd694ee1f5() {
    var out = new $amnUE.ARRAY_TYPE(4);
    if ($amnUE.ARRAY_TYPE != Float32Array) {
        out[0] = 0;
        out[1] = 0;
        out[2] = 0;
    }
    out[3] = 1;
    return out;
}
function $e92e4eb8d35aaf31$export$f0954fd7d5368655(out) {
    out[0] = 0;
    out[1] = 0;
    out[2] = 0;
    out[3] = 1;
    return out;
}
function $e92e4eb8d35aaf31$export$4286ddefc8f49512(out, axis, rad) {
    rad = rad * 0.5;
    var s = Math.sin(rad);
    out[0] = s * axis[0];
    out[1] = s * axis[1];
    out[2] = s * axis[2];
    out[3] = Math.cos(rad);
    return out;
}
function $e92e4eb8d35aaf31$export$3f70be5e7d7dc51(out_axis, q) {
    var rad = Math.acos(q[3]) * 2.0;
    var s = Math.sin(rad / 2.0);
    if (s > $amnUE.EPSILON) {
        out_axis[0] = q[0] / s;
        out_axis[1] = q[1] / s;
        out_axis[2] = q[2] / s;
    } else {
        // If s is zero, return any axis (no rotation - axis does not matter)
        out_axis[0] = 1;
        out_axis[1] = 0;
        out_axis[2] = 0;
    }
    return rad;
}
function $e92e4eb8d35aaf31$export$b363da9ded343252(a, b) {
    var dotproduct = $e92e4eb8d35aaf31$export$94132a0e348806d4(a, b);
    return Math.acos(2 * dotproduct * dotproduct - 1);
}
function $e92e4eb8d35aaf31$export$2060d2db72cce88f(out, a, b) {
    var ax = a[0], ay = a[1], az = a[2], aw = a[3];
    var bx = b[0], by = b[1], bz = b[2], bw = b[3];
    out[0] = ax * bw + aw * bx + ay * bz - az * by;
    out[1] = ay * bw + aw * by + az * bx - ax * bz;
    out[2] = az * bw + aw * bz + ax * by - ay * bx;
    out[3] = aw * bw - ax * bx - ay * by - az * bz;
    return out;
}
function $e92e4eb8d35aaf31$export$a59c8716592e09af(out, a, rad) {
    rad *= 0.5;
    var ax = a[0], ay = a[1], az = a[2], aw = a[3];
    var bx = Math.sin(rad), bw = Math.cos(rad);
    out[0] = ax * bw + aw * bx;
    out[1] = ay * bw + az * bx;
    out[2] = az * bw - ay * bx;
    out[3] = aw * bw - ax * bx;
    return out;
}
function $e92e4eb8d35aaf31$export$cf71e4d4ca4d1cfd(out, a, rad) {
    rad *= 0.5;
    var ax = a[0], ay = a[1], az = a[2], aw = a[3];
    var by = Math.sin(rad), bw = Math.cos(rad);
    out[0] = ax * bw - az * by;
    out[1] = ay * bw + aw * by;
    out[2] = az * bw + ax * by;
    out[3] = aw * bw - ay * by;
    return out;
}
function $e92e4eb8d35aaf31$export$ea6eae3365de5b9c(out, a, rad) {
    rad *= 0.5;
    var ax = a[0], ay = a[1], az = a[2], aw = a[3];
    var bz = Math.sin(rad), bw = Math.cos(rad);
    out[0] = ax * bw + ay * bz;
    out[1] = ay * bw - ax * bz;
    out[2] = az * bw + aw * bz;
    out[3] = aw * bw - az * bz;
    return out;
}
function $e92e4eb8d35aaf31$export$fb72b72e8d764d4e(out, a) {
    var x = a[0], y = a[1], z = a[2];
    out[0] = x;
    out[1] = y;
    out[2] = z;
    out[3] = Math.sqrt(Math.abs(1.0 - x * x - y * y - z * z));
    return out;
}
function $e92e4eb8d35aaf31$export$b310ec824aaee37f(out, a) {
    var x = a[0], y = a[1], z = a[2], w = a[3];
    var r = Math.sqrt(x * x + y * y + z * z);
    var et = Math.exp(w);
    var s = r > 0 ? et * Math.sin(r) / r : 0;
    out[0] = x * s;
    out[1] = y * s;
    out[2] = z * s;
    out[3] = et * Math.cos(r);
    return out;
}
function $e92e4eb8d35aaf31$export$876cb1b29620556f(out, a) {
    var x = a[0], y = a[1], z = a[2], w = a[3];
    var r = Math.sqrt(x * x + y * y + z * z);
    var t = r > 0 ? Math.atan2(r, w) / r : 0;
    out[0] = x * t;
    out[1] = y * t;
    out[2] = z * t;
    out[3] = 0.5 * Math.log(x * x + y * y + z * z + w * w);
    return out;
}
function $e92e4eb8d35aaf31$export$9c297f60e22e3389(out, a, b) {
    $e92e4eb8d35aaf31$export$876cb1b29620556f(out, a);
    $e92e4eb8d35aaf31$export$dcdf75081b88279d(out, out, b);
    $e92e4eb8d35aaf31$export$b310ec824aaee37f(out, out);
    return out;
}
function $e92e4eb8d35aaf31$export$1544d9bc2995de08(out, a, b, t) {
    // benchmarks:
    //    http://jsperf.com/quaternion-slerp-implementations
    var ax = a[0], ay = a[1], az = a[2], aw = a[3];
    var bx = b[0], by = b[1], bz = b[2], bw = b[3];
    var omega, cosom, sinom, scale0, scale1; // calc cosine
    cosom = ax * bx + ay * by + az * bz + aw * bw; // adjust signs (if necessary)
    if (cosom < 0.0) {
        cosom = -cosom;
        bx = -bx;
        by = -by;
        bz = -bz;
        bw = -bw;
    } // calculate coefficients
    if (1.0 - cosom > $amnUE.EPSILON) {
        // standard case (slerp)
        omega = Math.acos(cosom);
        sinom = Math.sin(omega);
        scale0 = Math.sin((1.0 - t) * omega) / sinom;
        scale1 = Math.sin(t * omega) / sinom;
    } else {
        // "from" and "to" quaternions are very close
        //  ... so we can do a linear interpolation
        scale0 = 1.0 - t;
        scale1 = t;
    } // calculate final values
    out[0] = scale0 * ax + scale1 * bx;
    out[1] = scale0 * ay + scale1 * by;
    out[2] = scale0 * az + scale1 * bz;
    out[3] = scale0 * aw + scale1 * bw;
    return out;
}
function $e92e4eb8d35aaf31$export$4385e60b38654f68(out) {
    // Implementation of http://planning.cs.uiuc.edu/node198.html
    // TODO: Calling random 3 times is probably not the fastest solution
    var u1 = $amnUE.RANDOM();
    var u2 = $amnUE.RANDOM();
    var u3 = $amnUE.RANDOM();
    var sqrt1MinusU1 = Math.sqrt(1 - u1);
    var sqrtU1 = Math.sqrt(u1);
    out[0] = sqrt1MinusU1 * Math.sin(2.0 * Math.PI * u2);
    out[1] = sqrt1MinusU1 * Math.cos(2.0 * Math.PI * u2);
    out[2] = sqrtU1 * Math.sin(2.0 * Math.PI * u3);
    out[3] = sqrtU1 * Math.cos(2.0 * Math.PI * u3);
    return out;
}
function $e92e4eb8d35aaf31$export$6897c284b6f9f4dc(out, a) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3];
    var dot = a0 * a0 + a1 * a1 + a2 * a2 + a3 * a3;
    var invDot = dot ? 1.0 / dot : 0; // TODO: Would be faster to return [0,0,0,0] immediately if dot == 0
    out[0] = -a0 * invDot;
    out[1] = -a1 * invDot;
    out[2] = -a2 * invDot;
    out[3] = a3 * invDot;
    return out;
}
function $e92e4eb8d35aaf31$export$7679f47e72c62560(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    out[2] = -a[2];
    out[3] = a[3];
    return out;
}
function $e92e4eb8d35aaf31$export$272a1eb8e5a4b55b(out, m) {
    // Algorithm in Ken Shoemake's article in 1987 SIGGRAPH course notes
    // article "Quaternion Calculus and Fast Animation".
    var fTrace = m[0] + m[4] + m[8];
    var fRoot;
    if (fTrace > 0.0) {
        // |w| > 1/2, may as well choose w > 1/2
        fRoot = Math.sqrt(fTrace + 1.0); // 2w
        out[3] = 0.5 * fRoot;
        fRoot = 0.5 / fRoot; // 1/(4w)
        out[0] = (m[5] - m[7]) * fRoot;
        out[1] = (m[6] - m[2]) * fRoot;
        out[2] = (m[1] - m[3]) * fRoot;
    } else {
        // |w| <= 1/2
        var i = 0;
        if (m[4] > m[0]) i = 1;
        if (m[8] > m[i * 3 + i]) i = 2;
        var j = (i + 1) % 3;
        var k = (i + 2) % 3;
        fRoot = Math.sqrt(m[i * 3 + i] - m[j * 3 + j] - m[k * 3 + k] + 1.0);
        out[i] = 0.5 * fRoot;
        fRoot = 0.5 / fRoot;
        out[3] = (m[j * 3 + k] - m[k * 3 + j]) * fRoot;
        out[j] = (m[j * 3 + i] + m[i * 3 + j]) * fRoot;
        out[k] = (m[k * 3 + i] + m[i * 3 + k]) * fRoot;
    }
    return out;
}
function $e92e4eb8d35aaf31$export$7a404a587ea85af(out, x, y, z) {
    var halfToRad = 0.5 * Math.PI / 180.0;
    x *= halfToRad;
    y *= halfToRad;
    z *= halfToRad;
    var sx = Math.sin(x);
    var cx = Math.cos(x);
    var sy = Math.sin(y);
    var cy = Math.cos(y);
    var sz = Math.sin(z);
    var cz = Math.cos(z);
    out[0] = sx * cy * cz - cx * sy * sz;
    out[1] = cx * sy * cz + sx * cy * sz;
    out[2] = cx * cy * sz - sx * sy * cz;
    out[3] = cx * cy * cz + sx * sy * sz;
    return out;
}
function $e92e4eb8d35aaf31$export$42d51816ce590c93(a) {
    return "quat(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ")";
}
var $e92e4eb8d35aaf31$export$9cd59f9826255e47 = $jxhwV.clone;
var $e92e4eb8d35aaf31$export$a82be99ed2a44a7d = $jxhwV.fromValues;
var $e92e4eb8d35aaf31$export$784d13d8ee351f07 = $jxhwV.copy;
var $e92e4eb8d35aaf31$export$adaa4cf7ef1b65be = $jxhwV.set;
var $e92e4eb8d35aaf31$export$e16d8520af44a096 = $jxhwV.add;
var $e92e4eb8d35aaf31$export$6e3a27864ab166fe = $e92e4eb8d35aaf31$export$2060d2db72cce88f;
var $e92e4eb8d35aaf31$export$dcdf75081b88279d = $jxhwV.scale;
var $e92e4eb8d35aaf31$export$94132a0e348806d4 = $jxhwV.dot;
var $e92e4eb8d35aaf31$export$3a89f8d6f6bf6c9f = $jxhwV.lerp;
var $e92e4eb8d35aaf31$export$f24224f1c91d8156 = $jxhwV.length;
var $e92e4eb8d35aaf31$export$fc1400facf92c78 = $e92e4eb8d35aaf31$export$f24224f1c91d8156;
var $e92e4eb8d35aaf31$export$ab44e1323ffc8376 = $jxhwV.squaredLength;
var $e92e4eb8d35aaf31$export$99d8dd3f32a3435 = $e92e4eb8d35aaf31$export$ab44e1323ffc8376;
var $e92e4eb8d35aaf31$export$a3295358bff77e = $jxhwV.normalize;
var $e92e4eb8d35aaf31$export$f2599a5cf1109d8 = $jxhwV.exactEquals;
var $e92e4eb8d35aaf31$export$e9bab7fafb253603 = $jxhwV.equals;
var $e92e4eb8d35aaf31$export$72d66f5842c00904 = function() {
    var tmpvec3 = $eIStk.create();
    var xUnitVec3 = $eIStk.fromValues(1, 0, 0);
    var yUnitVec3 = $eIStk.fromValues(0, 1, 0);
    return function(out, a, b) {
        var dot = $eIStk.dot(a, b);
        if (dot < -0.999999) {
            $eIStk.cross(tmpvec3, xUnitVec3, a);
            if ($eIStk.len(tmpvec3) < 0.000001) $eIStk.cross(tmpvec3, yUnitVec3, a);
            $eIStk.normalize(tmpvec3, tmpvec3);
            $e92e4eb8d35aaf31$export$4286ddefc8f49512(out, tmpvec3, Math.PI);
            return out;
        } else if (dot > 0.999999) {
            out[0] = 0;
            out[1] = 0;
            out[2] = 0;
            out[3] = 1;
            return out;
        } else {
            $eIStk.cross(tmpvec3, a, b);
            out[0] = tmpvec3[0];
            out[1] = tmpvec3[1];
            out[2] = tmpvec3[2];
            out[3] = 1 + dot;
            return $e92e4eb8d35aaf31$export$a3295358bff77e(out, out);
        }
    };
}();
var $e92e4eb8d35aaf31$export$699b0866ca50f6cb = function() {
    var temp1 = $e92e4eb8d35aaf31$export$185802fd694ee1f5();
    var temp2 = $e92e4eb8d35aaf31$export$185802fd694ee1f5();
    return function(out, a, b, c, d, t) {
        $e92e4eb8d35aaf31$export$1544d9bc2995de08(temp1, a, d, t);
        $e92e4eb8d35aaf31$export$1544d9bc2995de08(temp2, b, c, t);
        $e92e4eb8d35aaf31$export$1544d9bc2995de08(out, temp1, temp2, 2 * t * (1 - t));
        return out;
    };
}();
var $e92e4eb8d35aaf31$export$937ca0a544b2d712 = function() {
    var matr = $bDSmI.create();
    return function(out, view, right, up) {
        matr[0] = right[0];
        matr[3] = right[1];
        matr[6] = right[2];
        matr[1] = up[0];
        matr[4] = up[1];
        matr[7] = up[2];
        matr[2] = -view[0];
        matr[5] = -view[1];
        matr[8] = -view[2];
        return $e92e4eb8d35aaf31$export$a3295358bff77e(out, $e92e4eb8d35aaf31$export$272a1eb8e5a4b55b(out, matr));
    };
}();

});
parcelRegister("eIStk", function(module, exports) {

$parcel$export(module.exports, "create", () => $ab7f6dc0910e1ef7$export$185802fd694ee1f5);
$parcel$export(module.exports, "clone", () => $ab7f6dc0910e1ef7$export$9cd59f9826255e47);
$parcel$export(module.exports, "length", () => $ab7f6dc0910e1ef7$export$f24224f1c91d8156);
$parcel$export(module.exports, "fromValues", () => $ab7f6dc0910e1ef7$export$a82be99ed2a44a7d);
$parcel$export(module.exports, "copy", () => $ab7f6dc0910e1ef7$export$784d13d8ee351f07);
$parcel$export(module.exports, "set", () => $ab7f6dc0910e1ef7$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "add", () => $ab7f6dc0910e1ef7$export$e16d8520af44a096);
$parcel$export(module.exports, "subtract", () => $ab7f6dc0910e1ef7$export$4e2d2ead65e5f7e3);
$parcel$export(module.exports, "multiply", () => $ab7f6dc0910e1ef7$export$2060d2db72cce88f);
$parcel$export(module.exports, "divide", () => $ab7f6dc0910e1ef7$export$cd007d971a5a2143);
$parcel$export(module.exports, "ceil", () => $ab7f6dc0910e1ef7$export$803ce6b71a0a94b2);
$parcel$export(module.exports, "floor", () => $ab7f6dc0910e1ef7$export$a3fe094919f356fd);
$parcel$export(module.exports, "min", () => $ab7f6dc0910e1ef7$export$96ec731ed4dcb222);
$parcel$export(module.exports, "max", () => $ab7f6dc0910e1ef7$export$8960430cfd85939f);
$parcel$export(module.exports, "round", () => $ab7f6dc0910e1ef7$export$2077e0241d6afd3c);
$parcel$export(module.exports, "scale", () => $ab7f6dc0910e1ef7$export$dcdf75081b88279d);
$parcel$export(module.exports, "scaleAndAdd", () => $ab7f6dc0910e1ef7$export$19cedf1da84ba854);
$parcel$export(module.exports, "distance", () => $ab7f6dc0910e1ef7$export$9f17032d917177de);
$parcel$export(module.exports, "squaredDistance", () => $ab7f6dc0910e1ef7$export$88e6ebb4fe54f538);
$parcel$export(module.exports, "squaredLength", () => $ab7f6dc0910e1ef7$export$ab44e1323ffc8376);
$parcel$export(module.exports, "negate", () => $ab7f6dc0910e1ef7$export$aef51622e549b8b0);
$parcel$export(module.exports, "inverse", () => $ab7f6dc0910e1ef7$export$70ae2c07e401031b);
$parcel$export(module.exports, "normalize", () => $ab7f6dc0910e1ef7$export$a3295358bff77e);
$parcel$export(module.exports, "dot", () => $ab7f6dc0910e1ef7$export$94132a0e348806d4);
$parcel$export(module.exports, "cross", () => $ab7f6dc0910e1ef7$export$bb646b20bb93d339);
$parcel$export(module.exports, "lerp", () => $ab7f6dc0910e1ef7$export$3a89f8d6f6bf6c9f);
$parcel$export(module.exports, "hermite", () => $ab7f6dc0910e1ef7$export$ae8865616f30561c);
$parcel$export(module.exports, "bezier", () => $ab7f6dc0910e1ef7$export$b9c5f84610baddaf);
$parcel$export(module.exports, "random", () => $ab7f6dc0910e1ef7$export$4385e60b38654f68);
$parcel$export(module.exports, "transformMat4", () => $ab7f6dc0910e1ef7$export$5ffbd13800309d59);
$parcel$export(module.exports, "transformMat3", () => $ab7f6dc0910e1ef7$export$f0bfa0a0024626ee);
$parcel$export(module.exports, "transformQuat", () => $ab7f6dc0910e1ef7$export$c32adef9e939ce85);
$parcel$export(module.exports, "rotateX", () => $ab7f6dc0910e1ef7$export$a59c8716592e09af);
$parcel$export(module.exports, "rotateY", () => $ab7f6dc0910e1ef7$export$cf71e4d4ca4d1cfd);
$parcel$export(module.exports, "rotateZ", () => $ab7f6dc0910e1ef7$export$ea6eae3365de5b9c);
$parcel$export(module.exports, "angle", () => $ab7f6dc0910e1ef7$export$944b09d2ad10b378);
$parcel$export(module.exports, "zero", () => $ab7f6dc0910e1ef7$export$7f9972325ebfd559);
$parcel$export(module.exports, "str", () => $ab7f6dc0910e1ef7$export$42d51816ce590c93);
$parcel$export(module.exports, "exactEquals", () => $ab7f6dc0910e1ef7$export$f2599a5cf1109d8);
$parcel$export(module.exports, "equals", () => $ab7f6dc0910e1ef7$export$e9bab7fafb253603);
$parcel$export(module.exports, "sub", () => $ab7f6dc0910e1ef7$export$f93b5905241a7cca);
$parcel$export(module.exports, "mul", () => $ab7f6dc0910e1ef7$export$6e3a27864ab166fe);
$parcel$export(module.exports, "div", () => $ab7f6dc0910e1ef7$export$159d9494db57879b);
$parcel$export(module.exports, "dist", () => $ab7f6dc0910e1ef7$export$6c4a311cc157c764);
$parcel$export(module.exports, "sqrDist", () => $ab7f6dc0910e1ef7$export$2422cd6c492a8b3a);
$parcel$export(module.exports, "len", () => $ab7f6dc0910e1ef7$export$fc1400facf92c78);
$parcel$export(module.exports, "sqrLen", () => $ab7f6dc0910e1ef7$export$99d8dd3f32a3435);
$parcel$export(module.exports, "forEach", () => $ab7f6dc0910e1ef7$export$4b80e395e36b5a56);

var $amnUE = parcelRequire("amnUE");
function $ab7f6dc0910e1ef7$export$185802fd694ee1f5() {
    var out = new $amnUE.ARRAY_TYPE(3);
    if ($amnUE.ARRAY_TYPE != Float32Array) {
        out[0] = 0;
        out[1] = 0;
        out[2] = 0;
    }
    return out;
}
function $ab7f6dc0910e1ef7$export$9cd59f9826255e47(a) {
    var out = new $amnUE.ARRAY_TYPE(3);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    return out;
}
function $ab7f6dc0910e1ef7$export$f24224f1c91d8156(a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    return Math.hypot(x, y, z);
}
function $ab7f6dc0910e1ef7$export$a82be99ed2a44a7d(x, y, z) {
    var out = new $amnUE.ARRAY_TYPE(3);
    out[0] = x;
    out[1] = y;
    out[2] = z;
    return out;
}
function $ab7f6dc0910e1ef7$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    return out;
}
function $ab7f6dc0910e1ef7$export$adaa4cf7ef1b65be(out, x, y, z) {
    out[0] = x;
    out[1] = y;
    out[2] = z;
    return out;
}
function $ab7f6dc0910e1ef7$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    return out;
}
function $ab7f6dc0910e1ef7$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    return out;
}
function $ab7f6dc0910e1ef7$export$2060d2db72cce88f(out, a, b) {
    out[0] = a[0] * b[0];
    out[1] = a[1] * b[1];
    out[2] = a[2] * b[2];
    return out;
}
function $ab7f6dc0910e1ef7$export$cd007d971a5a2143(out, a, b) {
    out[0] = a[0] / b[0];
    out[1] = a[1] / b[1];
    out[2] = a[2] / b[2];
    return out;
}
function $ab7f6dc0910e1ef7$export$803ce6b71a0a94b2(out, a) {
    out[0] = Math.ceil(a[0]);
    out[1] = Math.ceil(a[1]);
    out[2] = Math.ceil(a[2]);
    return out;
}
function $ab7f6dc0910e1ef7$export$a3fe094919f356fd(out, a) {
    out[0] = Math.floor(a[0]);
    out[1] = Math.floor(a[1]);
    out[2] = Math.floor(a[2]);
    return out;
}
function $ab7f6dc0910e1ef7$export$96ec731ed4dcb222(out, a, b) {
    out[0] = Math.min(a[0], b[0]);
    out[1] = Math.min(a[1], b[1]);
    out[2] = Math.min(a[2], b[2]);
    return out;
}
function $ab7f6dc0910e1ef7$export$8960430cfd85939f(out, a, b) {
    out[0] = Math.max(a[0], b[0]);
    out[1] = Math.max(a[1], b[1]);
    out[2] = Math.max(a[2], b[2]);
    return out;
}
function $ab7f6dc0910e1ef7$export$2077e0241d6afd3c(out, a) {
    out[0] = Math.round(a[0]);
    out[1] = Math.round(a[1]);
    out[2] = Math.round(a[2]);
    return out;
}
function $ab7f6dc0910e1ef7$export$dcdf75081b88279d(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    return out;
}
function $ab7f6dc0910e1ef7$export$19cedf1da84ba854(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    out[2] = a[2] + b[2] * scale;
    return out;
}
function $ab7f6dc0910e1ef7$export$9f17032d917177de(a, b) {
    var x = b[0] - a[0];
    var y = b[1] - a[1];
    var z = b[2] - a[2];
    return Math.hypot(x, y, z);
}
function $ab7f6dc0910e1ef7$export$88e6ebb4fe54f538(a, b) {
    var x = b[0] - a[0];
    var y = b[1] - a[1];
    var z = b[2] - a[2];
    return x * x + y * y + z * z;
}
function $ab7f6dc0910e1ef7$export$ab44e1323ffc8376(a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    return x * x + y * y + z * z;
}
function $ab7f6dc0910e1ef7$export$aef51622e549b8b0(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    out[2] = -a[2];
    return out;
}
function $ab7f6dc0910e1ef7$export$70ae2c07e401031b(out, a) {
    out[0] = 1.0 / a[0];
    out[1] = 1.0 / a[1];
    out[2] = 1.0 / a[2];
    return out;
}
function $ab7f6dc0910e1ef7$export$a3295358bff77e(out, a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    var len = x * x + y * y + z * z;
    if (len > 0) //TODO: evaluate use of glm_invsqrt here?
    len = 1 / Math.sqrt(len);
    out[0] = a[0] * len;
    out[1] = a[1] * len;
    out[2] = a[2] * len;
    return out;
}
function $ab7f6dc0910e1ef7$export$94132a0e348806d4(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}
function $ab7f6dc0910e1ef7$export$bb646b20bb93d339(out, a, b) {
    var ax = a[0], ay = a[1], az = a[2];
    var bx = b[0], by = b[1], bz = b[2];
    out[0] = ay * bz - az * by;
    out[1] = az * bx - ax * bz;
    out[2] = ax * by - ay * bx;
    return out;
}
function $ab7f6dc0910e1ef7$export$3a89f8d6f6bf6c9f(out, a, b, t) {
    var ax = a[0];
    var ay = a[1];
    var az = a[2];
    out[0] = ax + t * (b[0] - ax);
    out[1] = ay + t * (b[1] - ay);
    out[2] = az + t * (b[2] - az);
    return out;
}
function $ab7f6dc0910e1ef7$export$ae8865616f30561c(out, a, b, c, d, t) {
    var factorTimes2 = t * t;
    var factor1 = factorTimes2 * (2 * t - 3) + 1;
    var factor2 = factorTimes2 * (t - 2) + t;
    var factor3 = factorTimes2 * (t - 1);
    var factor4 = factorTimes2 * (3 - 2 * t);
    out[0] = a[0] * factor1 + b[0] * factor2 + c[0] * factor3 + d[0] * factor4;
    out[1] = a[1] * factor1 + b[1] * factor2 + c[1] * factor3 + d[1] * factor4;
    out[2] = a[2] * factor1 + b[2] * factor2 + c[2] * factor3 + d[2] * factor4;
    return out;
}
function $ab7f6dc0910e1ef7$export$b9c5f84610baddaf(out, a, b, c, d, t) {
    var inverseFactor = 1 - t;
    var inverseFactorTimesTwo = inverseFactor * inverseFactor;
    var factorTimes2 = t * t;
    var factor1 = inverseFactorTimesTwo * inverseFactor;
    var factor2 = 3 * t * inverseFactorTimesTwo;
    var factor3 = 3 * factorTimes2 * inverseFactor;
    var factor4 = factorTimes2 * t;
    out[0] = a[0] * factor1 + b[0] * factor2 + c[0] * factor3 + d[0] * factor4;
    out[1] = a[1] * factor1 + b[1] * factor2 + c[1] * factor3 + d[1] * factor4;
    out[2] = a[2] * factor1 + b[2] * factor2 + c[2] * factor3 + d[2] * factor4;
    return out;
}
function $ab7f6dc0910e1ef7$export$4385e60b38654f68(out, scale) {
    scale = scale || 1.0;
    var r = $amnUE.RANDOM() * 2.0 * Math.PI;
    var z = $amnUE.RANDOM() * 2.0 - 1.0;
    var zScale = Math.sqrt(1.0 - z * z) * scale;
    out[0] = Math.cos(r) * zScale;
    out[1] = Math.sin(r) * zScale;
    out[2] = z * scale;
    return out;
}
function $ab7f6dc0910e1ef7$export$5ffbd13800309d59(out, a, m) {
    var x = a[0], y = a[1], z = a[2];
    var w = m[3] * x + m[7] * y + m[11] * z + m[15];
    w = w || 1.0;
    out[0] = (m[0] * x + m[4] * y + m[8] * z + m[12]) / w;
    out[1] = (m[1] * x + m[5] * y + m[9] * z + m[13]) / w;
    out[2] = (m[2] * x + m[6] * y + m[10] * z + m[14]) / w;
    return out;
}
function $ab7f6dc0910e1ef7$export$f0bfa0a0024626ee(out, a, m) {
    var x = a[0], y = a[1], z = a[2];
    out[0] = x * m[0] + y * m[3] + z * m[6];
    out[1] = x * m[1] + y * m[4] + z * m[7];
    out[2] = x * m[2] + y * m[5] + z * m[8];
    return out;
}
function $ab7f6dc0910e1ef7$export$c32adef9e939ce85(out, a, q) {
    // benchmarks: https://jsperf.com/quaternion-transform-vec3-implementations-fixed
    var qx = q[0], qy = q[1], qz = q[2], qw = q[3];
    var x = a[0], y = a[1], z = a[2]; // var qvec = [qx, qy, qz];
    // var uv = vec3.cross([], qvec, a);
    var uvx = qy * z - qz * y, uvy = qz * x - qx * z, uvz = qx * y - qy * x; // var uuv = vec3.cross([], qvec, uv);
    var uuvx = qy * uvz - qz * uvy, uuvy = qz * uvx - qx * uvz, uuvz = qx * uvy - qy * uvx; // vec3.scale(uv, uv, 2 * w);
    var w2 = qw * 2;
    uvx *= w2;
    uvy *= w2;
    uvz *= w2; // vec3.scale(uuv, uuv, 2);
    uuvx *= 2;
    uuvy *= 2;
    uuvz *= 2; // return vec3.add(out, a, vec3.add(out, uv, uuv));
    out[0] = x + uvx + uuvx;
    out[1] = y + uvy + uuvy;
    out[2] = z + uvz + uuvz;
    return out;
}
function $ab7f6dc0910e1ef7$export$a59c8716592e09af(out, a, b, rad) {
    var p = [], r = []; //Translate point to the origin
    p[0] = a[0] - b[0];
    p[1] = a[1] - b[1];
    p[2] = a[2] - b[2]; //perform rotation
    r[0] = p[0];
    r[1] = p[1] * Math.cos(rad) - p[2] * Math.sin(rad);
    r[2] = p[1] * Math.sin(rad) + p[2] * Math.cos(rad); //translate to correct position
    out[0] = r[0] + b[0];
    out[1] = r[1] + b[1];
    out[2] = r[2] + b[2];
    return out;
}
function $ab7f6dc0910e1ef7$export$cf71e4d4ca4d1cfd(out, a, b, rad) {
    var p = [], r = []; //Translate point to the origin
    p[0] = a[0] - b[0];
    p[1] = a[1] - b[1];
    p[2] = a[2] - b[2]; //perform rotation
    r[0] = p[2] * Math.sin(rad) + p[0] * Math.cos(rad);
    r[1] = p[1];
    r[2] = p[2] * Math.cos(rad) - p[0] * Math.sin(rad); //translate to correct position
    out[0] = r[0] + b[0];
    out[1] = r[1] + b[1];
    out[2] = r[2] + b[2];
    return out;
}
function $ab7f6dc0910e1ef7$export$ea6eae3365de5b9c(out, a, b, rad) {
    var p = [], r = []; //Translate point to the origin
    p[0] = a[0] - b[0];
    p[1] = a[1] - b[1];
    p[2] = a[2] - b[2]; //perform rotation
    r[0] = p[0] * Math.cos(rad) - p[1] * Math.sin(rad);
    r[1] = p[0] * Math.sin(rad) + p[1] * Math.cos(rad);
    r[2] = p[2]; //translate to correct position
    out[0] = r[0] + b[0];
    out[1] = r[1] + b[1];
    out[2] = r[2] + b[2];
    return out;
}
function $ab7f6dc0910e1ef7$export$944b09d2ad10b378(a, b) {
    var ax = a[0], ay = a[1], az = a[2], bx = b[0], by = b[1], bz = b[2], mag1 = Math.sqrt(ax * ax + ay * ay + az * az), mag2 = Math.sqrt(bx * bx + by * by + bz * bz), mag = mag1 * mag2, cosine = mag && $ab7f6dc0910e1ef7$export$94132a0e348806d4(a, b) / mag;
    return Math.acos(Math.min(Math.max(cosine, -1), 1));
}
function $ab7f6dc0910e1ef7$export$7f9972325ebfd559(out) {
    out[0] = 0.0;
    out[1] = 0.0;
    out[2] = 0.0;
    return out;
}
function $ab7f6dc0910e1ef7$export$42d51816ce590c93(a) {
    return "vec3(" + a[0] + ", " + a[1] + ", " + a[2] + ")";
}
function $ab7f6dc0910e1ef7$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2];
}
function $ab7f6dc0910e1ef7$export$e9bab7fafb253603(a, b) {
    var a0 = a[0], a1 = a[1], a2 = a[2];
    var b0 = b[0], b1 = b[1], b2 = b[2];
    return Math.abs(a0 - b0) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a2), Math.abs(b2));
}
var $ab7f6dc0910e1ef7$export$f93b5905241a7cca = $ab7f6dc0910e1ef7$export$4e2d2ead65e5f7e3;
var $ab7f6dc0910e1ef7$export$6e3a27864ab166fe = $ab7f6dc0910e1ef7$export$2060d2db72cce88f;
var $ab7f6dc0910e1ef7$export$159d9494db57879b = $ab7f6dc0910e1ef7$export$cd007d971a5a2143;
var $ab7f6dc0910e1ef7$export$6c4a311cc157c764 = $ab7f6dc0910e1ef7$export$9f17032d917177de;
var $ab7f6dc0910e1ef7$export$2422cd6c492a8b3a = $ab7f6dc0910e1ef7$export$88e6ebb4fe54f538;
var $ab7f6dc0910e1ef7$export$fc1400facf92c78 = $ab7f6dc0910e1ef7$export$f24224f1c91d8156;
var $ab7f6dc0910e1ef7$export$99d8dd3f32a3435 = $ab7f6dc0910e1ef7$export$ab44e1323ffc8376;
var $ab7f6dc0910e1ef7$export$4b80e395e36b5a56 = function() {
    var vec = $ab7f6dc0910e1ef7$export$185802fd694ee1f5();
    return function(a, stride, offset, count, fn, arg) {
        var i, l;
        if (!stride) stride = 3;
        if (!offset) offset = 0;
        if (count) l = Math.min(count * stride + offset, a.length);
        else l = a.length;
        for(i = offset; i < l; i += stride){
            vec[0] = a[i];
            vec[1] = a[i + 1];
            vec[2] = a[i + 2];
            fn(vec, vec, arg);
            a[i] = vec[0];
            a[i + 1] = vec[1];
            a[i + 2] = vec[2];
        }
        return a;
    };
}();

});

parcelRegister("jxhwV", function(module, exports) {

$parcel$export(module.exports, "create", () => $e38eb280d3b76273$export$185802fd694ee1f5);
$parcel$export(module.exports, "clone", () => $e38eb280d3b76273$export$9cd59f9826255e47);
$parcel$export(module.exports, "fromValues", () => $e38eb280d3b76273$export$a82be99ed2a44a7d);
$parcel$export(module.exports, "copy", () => $e38eb280d3b76273$export$784d13d8ee351f07);
$parcel$export(module.exports, "set", () => $e38eb280d3b76273$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "add", () => $e38eb280d3b76273$export$e16d8520af44a096);
$parcel$export(module.exports, "subtract", () => $e38eb280d3b76273$export$4e2d2ead65e5f7e3);
$parcel$export(module.exports, "multiply", () => $e38eb280d3b76273$export$2060d2db72cce88f);
$parcel$export(module.exports, "divide", () => $e38eb280d3b76273$export$cd007d971a5a2143);
$parcel$export(module.exports, "ceil", () => $e38eb280d3b76273$export$803ce6b71a0a94b2);
$parcel$export(module.exports, "floor", () => $e38eb280d3b76273$export$a3fe094919f356fd);
$parcel$export(module.exports, "min", () => $e38eb280d3b76273$export$96ec731ed4dcb222);
$parcel$export(module.exports, "max", () => $e38eb280d3b76273$export$8960430cfd85939f);
$parcel$export(module.exports, "round", () => $e38eb280d3b76273$export$2077e0241d6afd3c);
$parcel$export(module.exports, "scale", () => $e38eb280d3b76273$export$dcdf75081b88279d);
$parcel$export(module.exports, "scaleAndAdd", () => $e38eb280d3b76273$export$19cedf1da84ba854);
$parcel$export(module.exports, "distance", () => $e38eb280d3b76273$export$9f17032d917177de);
$parcel$export(module.exports, "squaredDistance", () => $e38eb280d3b76273$export$88e6ebb4fe54f538);
$parcel$export(module.exports, "length", () => $e38eb280d3b76273$export$f24224f1c91d8156);
$parcel$export(module.exports, "squaredLength", () => $e38eb280d3b76273$export$ab44e1323ffc8376);
$parcel$export(module.exports, "negate", () => $e38eb280d3b76273$export$aef51622e549b8b0);
$parcel$export(module.exports, "inverse", () => $e38eb280d3b76273$export$70ae2c07e401031b);
$parcel$export(module.exports, "normalize", () => $e38eb280d3b76273$export$a3295358bff77e);
$parcel$export(module.exports, "dot", () => $e38eb280d3b76273$export$94132a0e348806d4);
$parcel$export(module.exports, "cross", () => $e38eb280d3b76273$export$bb646b20bb93d339);
$parcel$export(module.exports, "lerp", () => $e38eb280d3b76273$export$3a89f8d6f6bf6c9f);
$parcel$export(module.exports, "random", () => $e38eb280d3b76273$export$4385e60b38654f68);
$parcel$export(module.exports, "transformMat4", () => $e38eb280d3b76273$export$5ffbd13800309d59);
$parcel$export(module.exports, "transformQuat", () => $e38eb280d3b76273$export$c32adef9e939ce85);
$parcel$export(module.exports, "zero", () => $e38eb280d3b76273$export$7f9972325ebfd559);
$parcel$export(module.exports, "str", () => $e38eb280d3b76273$export$42d51816ce590c93);
$parcel$export(module.exports, "exactEquals", () => $e38eb280d3b76273$export$f2599a5cf1109d8);
$parcel$export(module.exports, "equals", () => $e38eb280d3b76273$export$e9bab7fafb253603);
$parcel$export(module.exports, "sub", () => $e38eb280d3b76273$export$f93b5905241a7cca);
$parcel$export(module.exports, "mul", () => $e38eb280d3b76273$export$6e3a27864ab166fe);
$parcel$export(module.exports, "div", () => $e38eb280d3b76273$export$159d9494db57879b);
$parcel$export(module.exports, "dist", () => $e38eb280d3b76273$export$6c4a311cc157c764);
$parcel$export(module.exports, "sqrDist", () => $e38eb280d3b76273$export$2422cd6c492a8b3a);
$parcel$export(module.exports, "len", () => $e38eb280d3b76273$export$fc1400facf92c78);
$parcel$export(module.exports, "sqrLen", () => $e38eb280d3b76273$export$99d8dd3f32a3435);
$parcel$export(module.exports, "forEach", () => $e38eb280d3b76273$export$4b80e395e36b5a56);

var $amnUE = parcelRequire("amnUE");
function $e38eb280d3b76273$export$185802fd694ee1f5() {
    var out = new $amnUE.ARRAY_TYPE(4);
    if ($amnUE.ARRAY_TYPE != Float32Array) {
        out[0] = 0;
        out[1] = 0;
        out[2] = 0;
        out[3] = 0;
    }
    return out;
}
function $e38eb280d3b76273$export$9cd59f9826255e47(a) {
    var out = new $amnUE.ARRAY_TYPE(4);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    return out;
}
function $e38eb280d3b76273$export$a82be99ed2a44a7d(x, y, z, w) {
    var out = new $amnUE.ARRAY_TYPE(4);
    out[0] = x;
    out[1] = y;
    out[2] = z;
    out[3] = w;
    return out;
}
function $e38eb280d3b76273$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    return out;
}
function $e38eb280d3b76273$export$adaa4cf7ef1b65be(out, x, y, z, w) {
    out[0] = x;
    out[1] = y;
    out[2] = z;
    out[3] = w;
    return out;
}
function $e38eb280d3b76273$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    out[3] = a[3] + b[3];
    return out;
}
function $e38eb280d3b76273$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    out[3] = a[3] - b[3];
    return out;
}
function $e38eb280d3b76273$export$2060d2db72cce88f(out, a, b) {
    out[0] = a[0] * b[0];
    out[1] = a[1] * b[1];
    out[2] = a[2] * b[2];
    out[3] = a[3] * b[3];
    return out;
}
function $e38eb280d3b76273$export$cd007d971a5a2143(out, a, b) {
    out[0] = a[0] / b[0];
    out[1] = a[1] / b[1];
    out[2] = a[2] / b[2];
    out[3] = a[3] / b[3];
    return out;
}
function $e38eb280d3b76273$export$803ce6b71a0a94b2(out, a) {
    out[0] = Math.ceil(a[0]);
    out[1] = Math.ceil(a[1]);
    out[2] = Math.ceil(a[2]);
    out[3] = Math.ceil(a[3]);
    return out;
}
function $e38eb280d3b76273$export$a3fe094919f356fd(out, a) {
    out[0] = Math.floor(a[0]);
    out[1] = Math.floor(a[1]);
    out[2] = Math.floor(a[2]);
    out[3] = Math.floor(a[3]);
    return out;
}
function $e38eb280d3b76273$export$96ec731ed4dcb222(out, a, b) {
    out[0] = Math.min(a[0], b[0]);
    out[1] = Math.min(a[1], b[1]);
    out[2] = Math.min(a[2], b[2]);
    out[3] = Math.min(a[3], b[3]);
    return out;
}
function $e38eb280d3b76273$export$8960430cfd85939f(out, a, b) {
    out[0] = Math.max(a[0], b[0]);
    out[1] = Math.max(a[1], b[1]);
    out[2] = Math.max(a[2], b[2]);
    out[3] = Math.max(a[3], b[3]);
    return out;
}
function $e38eb280d3b76273$export$2077e0241d6afd3c(out, a) {
    out[0] = Math.round(a[0]);
    out[1] = Math.round(a[1]);
    out[2] = Math.round(a[2]);
    out[3] = Math.round(a[3]);
    return out;
}
function $e38eb280d3b76273$export$dcdf75081b88279d(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    out[3] = a[3] * b;
    return out;
}
function $e38eb280d3b76273$export$19cedf1da84ba854(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    out[2] = a[2] + b[2] * scale;
    out[3] = a[3] + b[3] * scale;
    return out;
}
function $e38eb280d3b76273$export$9f17032d917177de(a, b) {
    var x = b[0] - a[0];
    var y = b[1] - a[1];
    var z = b[2] - a[2];
    var w = b[3] - a[3];
    return Math.hypot(x, y, z, w);
}
function $e38eb280d3b76273$export$88e6ebb4fe54f538(a, b) {
    var x = b[0] - a[0];
    var y = b[1] - a[1];
    var z = b[2] - a[2];
    var w = b[3] - a[3];
    return x * x + y * y + z * z + w * w;
}
function $e38eb280d3b76273$export$f24224f1c91d8156(a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    var w = a[3];
    return Math.hypot(x, y, z, w);
}
function $e38eb280d3b76273$export$ab44e1323ffc8376(a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    var w = a[3];
    return x * x + y * y + z * z + w * w;
}
function $e38eb280d3b76273$export$aef51622e549b8b0(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    out[2] = -a[2];
    out[3] = -a[3];
    return out;
}
function $e38eb280d3b76273$export$70ae2c07e401031b(out, a) {
    out[0] = 1.0 / a[0];
    out[1] = 1.0 / a[1];
    out[2] = 1.0 / a[2];
    out[3] = 1.0 / a[3];
    return out;
}
function $e38eb280d3b76273$export$a3295358bff77e(out, a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    var w = a[3];
    var len = x * x + y * y + z * z + w * w;
    if (len > 0) len = 1 / Math.sqrt(len);
    out[0] = x * len;
    out[1] = y * len;
    out[2] = z * len;
    out[3] = w * len;
    return out;
}
function $e38eb280d3b76273$export$94132a0e348806d4(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2] + a[3] * b[3];
}
function $e38eb280d3b76273$export$bb646b20bb93d339(out, u, v, w) {
    var A = v[0] * w[1] - v[1] * w[0], B = v[0] * w[2] - v[2] * w[0], C = v[0] * w[3] - v[3] * w[0], D = v[1] * w[2] - v[2] * w[1], E = v[1] * w[3] - v[3] * w[1], F = v[2] * w[3] - v[3] * w[2];
    var G = u[0];
    var H = u[1];
    var I = u[2];
    var J = u[3];
    out[0] = H * F - I * E + J * D;
    out[1] = -(G * F) + I * C - J * B;
    out[2] = G * E - H * C + J * A;
    out[3] = -(G * D) + H * B - I * A;
    return out;
}
function $e38eb280d3b76273$export$3a89f8d6f6bf6c9f(out, a, b, t) {
    var ax = a[0];
    var ay = a[1];
    var az = a[2];
    var aw = a[3];
    out[0] = ax + t * (b[0] - ax);
    out[1] = ay + t * (b[1] - ay);
    out[2] = az + t * (b[2] - az);
    out[3] = aw + t * (b[3] - aw);
    return out;
}
function $e38eb280d3b76273$export$4385e60b38654f68(out, scale) {
    scale = scale || 1.0; // Marsaglia, George. Choosing a Point from the Surface of a
    // Sphere. Ann. Math. Statist. 43 (1972), no. 2, 645--646.
    // http://projecteuclid.org/euclid.aoms/1177692644;
    var v1, v2, v3, v4;
    var s1, s2;
    do {
        v1 = $amnUE.RANDOM() * 2 - 1;
        v2 = $amnUE.RANDOM() * 2 - 1;
        s1 = v1 * v1 + v2 * v2;
    }while (s1 >= 1);
    do {
        v3 = $amnUE.RANDOM() * 2 - 1;
        v4 = $amnUE.RANDOM() * 2 - 1;
        s2 = v3 * v3 + v4 * v4;
    }while (s2 >= 1);
    var d = Math.sqrt((1 - s1) / s2);
    out[0] = scale * v1;
    out[1] = scale * v2;
    out[2] = scale * v3 * d;
    out[3] = scale * v4 * d;
    return out;
}
function $e38eb280d3b76273$export$5ffbd13800309d59(out, a, m) {
    var x = a[0], y = a[1], z = a[2], w = a[3];
    out[0] = m[0] * x + m[4] * y + m[8] * z + m[12] * w;
    out[1] = m[1] * x + m[5] * y + m[9] * z + m[13] * w;
    out[2] = m[2] * x + m[6] * y + m[10] * z + m[14] * w;
    out[3] = m[3] * x + m[7] * y + m[11] * z + m[15] * w;
    return out;
}
function $e38eb280d3b76273$export$c32adef9e939ce85(out, a, q) {
    var x = a[0], y = a[1], z = a[2];
    var qx = q[0], qy = q[1], qz = q[2], qw = q[3]; // calculate quat * vec
    var ix = qw * x + qy * z - qz * y;
    var iy = qw * y + qz * x - qx * z;
    var iz = qw * z + qx * y - qy * x;
    var iw = -qx * x - qy * y - qz * z; // calculate result * inverse quat
    out[0] = ix * qw + iw * -qx + iy * -qz - iz * -qy;
    out[1] = iy * qw + iw * -qy + iz * -qx - ix * -qz;
    out[2] = iz * qw + iw * -qz + ix * -qy - iy * -qx;
    out[3] = a[3];
    return out;
}
function $e38eb280d3b76273$export$7f9972325ebfd559(out) {
    out[0] = 0.0;
    out[1] = 0.0;
    out[2] = 0.0;
    out[3] = 0.0;
    return out;
}
function $e38eb280d3b76273$export$42d51816ce590c93(a) {
    return "vec4(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ")";
}
function $e38eb280d3b76273$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3];
}
function $e38eb280d3b76273$export$e9bab7fafb253603(a, b) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3];
    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
    return Math.abs(a0 - b0) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a2), Math.abs(b2)) && Math.abs(a3 - b3) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a3), Math.abs(b3));
}
var $e38eb280d3b76273$export$f93b5905241a7cca = $e38eb280d3b76273$export$4e2d2ead65e5f7e3;
var $e38eb280d3b76273$export$6e3a27864ab166fe = $e38eb280d3b76273$export$2060d2db72cce88f;
var $e38eb280d3b76273$export$159d9494db57879b = $e38eb280d3b76273$export$cd007d971a5a2143;
var $e38eb280d3b76273$export$6c4a311cc157c764 = $e38eb280d3b76273$export$9f17032d917177de;
var $e38eb280d3b76273$export$2422cd6c492a8b3a = $e38eb280d3b76273$export$88e6ebb4fe54f538;
var $e38eb280d3b76273$export$fc1400facf92c78 = $e38eb280d3b76273$export$f24224f1c91d8156;
var $e38eb280d3b76273$export$99d8dd3f32a3435 = $e38eb280d3b76273$export$ab44e1323ffc8376;
var $e38eb280d3b76273$export$4b80e395e36b5a56 = function() {
    var vec = $e38eb280d3b76273$export$185802fd694ee1f5();
    return function(a, stride, offset, count, fn, arg) {
        var i, l;
        if (!stride) stride = 4;
        if (!offset) offset = 0;
        if (count) l = Math.min(count * stride + offset, a.length);
        else l = a.length;
        for(i = offset; i < l; i += stride){
            vec[0] = a[i];
            vec[1] = a[i + 1];
            vec[2] = a[i + 2];
            vec[3] = a[i + 3];
            fn(vec, vec, arg);
            a[i] = vec[0];
            a[i + 1] = vec[1];
            a[i + 2] = vec[2];
            a[i + 3] = vec[3];
        }
        return a;
    };
}();

});


parcelRegister("1vSaR", function(module, exports) {

$parcel$export(module.exports, "create", () => $11a2b594d0ba6d4b$export$185802fd694ee1f5);
$parcel$export(module.exports, "clone", () => $11a2b594d0ba6d4b$export$9cd59f9826255e47);
$parcel$export(module.exports, "fromValues", () => $11a2b594d0ba6d4b$export$a82be99ed2a44a7d);
$parcel$export(module.exports, "fromRotationTranslationValues", () => $11a2b594d0ba6d4b$export$31d4759777f5e259);
$parcel$export(module.exports, "fromRotationTranslation", () => $11a2b594d0ba6d4b$export$9545ac307f2a256b);
$parcel$export(module.exports, "fromTranslation", () => $11a2b594d0ba6d4b$export$bc9e79e74e9fddf6);
$parcel$export(module.exports, "fromRotation", () => $11a2b594d0ba6d4b$export$926fc125ff3c666c);
$parcel$export(module.exports, "fromMat4", () => $11a2b594d0ba6d4b$export$b4ad467060d346fe);
$parcel$export(module.exports, "copy", () => $11a2b594d0ba6d4b$export$784d13d8ee351f07);
$parcel$export(module.exports, "identity", () => $11a2b594d0ba6d4b$export$f0954fd7d5368655);
$parcel$export(module.exports, "set", () => $11a2b594d0ba6d4b$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "getReal", () => $11a2b594d0ba6d4b$export$850568f5e3cdb212);
$parcel$export(module.exports, "getDual", () => $11a2b594d0ba6d4b$export$6b62e6fd886a6462);
$parcel$export(module.exports, "setReal", () => $11a2b594d0ba6d4b$export$611329ee5753c868);
$parcel$export(module.exports, "setDual", () => $11a2b594d0ba6d4b$export$c5d0e0cf08580c3f);
$parcel$export(module.exports, "getTranslation", () => $11a2b594d0ba6d4b$export$202e99f82f7f0395);
$parcel$export(module.exports, "translate", () => $11a2b594d0ba6d4b$export$d73ee8ef04f5226a);
$parcel$export(module.exports, "rotateX", () => $11a2b594d0ba6d4b$export$a59c8716592e09af);
$parcel$export(module.exports, "rotateY", () => $11a2b594d0ba6d4b$export$cf71e4d4ca4d1cfd);
$parcel$export(module.exports, "rotateZ", () => $11a2b594d0ba6d4b$export$ea6eae3365de5b9c);
$parcel$export(module.exports, "rotateByQuatAppend", () => $11a2b594d0ba6d4b$export$7da74d4771545cc5);
$parcel$export(module.exports, "rotateByQuatPrepend", () => $11a2b594d0ba6d4b$export$82e307635ffa6e66);
$parcel$export(module.exports, "rotateAroundAxis", () => $11a2b594d0ba6d4b$export$1b0030ab84d46e01);
$parcel$export(module.exports, "add", () => $11a2b594d0ba6d4b$export$e16d8520af44a096);
$parcel$export(module.exports, "multiply", () => $11a2b594d0ba6d4b$export$2060d2db72cce88f);
$parcel$export(module.exports, "mul", () => $11a2b594d0ba6d4b$export$6e3a27864ab166fe);
$parcel$export(module.exports, "scale", () => $11a2b594d0ba6d4b$export$dcdf75081b88279d);
$parcel$export(module.exports, "dot", () => $11a2b594d0ba6d4b$export$94132a0e348806d4);
$parcel$export(module.exports, "lerp", () => $11a2b594d0ba6d4b$export$3a89f8d6f6bf6c9f);
$parcel$export(module.exports, "invert", () => $11a2b594d0ba6d4b$export$6897c284b6f9f4dc);
$parcel$export(module.exports, "squaredLength", () => $11a2b594d0ba6d4b$export$ab44e1323ffc8376);
$parcel$export(module.exports, "conjugate", () => $11a2b594d0ba6d4b$export$7679f47e72c62560);
$parcel$export(module.exports, "length", () => $11a2b594d0ba6d4b$export$f24224f1c91d8156);
$parcel$export(module.exports, "len", () => $11a2b594d0ba6d4b$export$fc1400facf92c78);
$parcel$export(module.exports, "sqrLen", () => $11a2b594d0ba6d4b$export$99d8dd3f32a3435);
$parcel$export(module.exports, "normalize", () => $11a2b594d0ba6d4b$export$a3295358bff77e);
$parcel$export(module.exports, "str", () => $11a2b594d0ba6d4b$export$42d51816ce590c93);
$parcel$export(module.exports, "exactEquals", () => $11a2b594d0ba6d4b$export$f2599a5cf1109d8);
$parcel$export(module.exports, "equals", () => $11a2b594d0ba6d4b$export$e9bab7fafb253603);

var $amnUE = parcelRequire("amnUE");

var $k1dpP = parcelRequire("k1dpP");

var $3iqbd = parcelRequire("3iqbd");
function $11a2b594d0ba6d4b$export$185802fd694ee1f5() {
    var dq = new $amnUE.ARRAY_TYPE(8);
    if ($amnUE.ARRAY_TYPE != Float32Array) {
        dq[0] = 0;
        dq[1] = 0;
        dq[2] = 0;
        dq[4] = 0;
        dq[5] = 0;
        dq[6] = 0;
        dq[7] = 0;
    }
    dq[3] = 1;
    return dq;
}
function $11a2b594d0ba6d4b$export$9cd59f9826255e47(a) {
    var dq = new $amnUE.ARRAY_TYPE(8);
    dq[0] = a[0];
    dq[1] = a[1];
    dq[2] = a[2];
    dq[3] = a[3];
    dq[4] = a[4];
    dq[5] = a[5];
    dq[6] = a[6];
    dq[7] = a[7];
    return dq;
}
function $11a2b594d0ba6d4b$export$a82be99ed2a44a7d(x1, y1, z1, w1, x2, y2, z2, w2) {
    var dq = new $amnUE.ARRAY_TYPE(8);
    dq[0] = x1;
    dq[1] = y1;
    dq[2] = z1;
    dq[3] = w1;
    dq[4] = x2;
    dq[5] = y2;
    dq[6] = z2;
    dq[7] = w2;
    return dq;
}
function $11a2b594d0ba6d4b$export$31d4759777f5e259(x1, y1, z1, w1, x2, y2, z2) {
    var dq = new $amnUE.ARRAY_TYPE(8);
    dq[0] = x1;
    dq[1] = y1;
    dq[2] = z1;
    dq[3] = w1;
    var ax = x2 * 0.5, ay = y2 * 0.5, az = z2 * 0.5;
    dq[4] = ax * w1 + ay * z1 - az * y1;
    dq[5] = ay * w1 + az * x1 - ax * z1;
    dq[6] = az * w1 + ax * y1 - ay * x1;
    dq[7] = -ax * x1 - ay * y1 - az * z1;
    return dq;
}
function $11a2b594d0ba6d4b$export$9545ac307f2a256b(out, q, t) {
    var ax = t[0] * 0.5, ay = t[1] * 0.5, az = t[2] * 0.5, bx = q[0], by = q[1], bz = q[2], bw = q[3];
    out[0] = bx;
    out[1] = by;
    out[2] = bz;
    out[3] = bw;
    out[4] = ax * bw + ay * bz - az * by;
    out[5] = ay * bw + az * bx - ax * bz;
    out[6] = az * bw + ax * by - ay * bx;
    out[7] = -ax * bx - ay * by - az * bz;
    return out;
}
function $11a2b594d0ba6d4b$export$bc9e79e74e9fddf6(out, t) {
    out[0] = 0;
    out[1] = 0;
    out[2] = 0;
    out[3] = 1;
    out[4] = t[0] * 0.5;
    out[5] = t[1] * 0.5;
    out[6] = t[2] * 0.5;
    out[7] = 0;
    return out;
}
function $11a2b594d0ba6d4b$export$926fc125ff3c666c(out, q) {
    out[0] = q[0];
    out[1] = q[1];
    out[2] = q[2];
    out[3] = q[3];
    out[4] = 0;
    out[5] = 0;
    out[6] = 0;
    out[7] = 0;
    return out;
}
function $11a2b594d0ba6d4b$export$b4ad467060d346fe(out, a) {
    //TODO Optimize this
    var outer = $k1dpP.create();
    $3iqbd.getRotation(outer, a);
    var t = new $amnUE.ARRAY_TYPE(3);
    $3iqbd.getTranslation(t, a);
    $11a2b594d0ba6d4b$export$9545ac307f2a256b(out, outer, t);
    return out;
}
function $11a2b594d0ba6d4b$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    return out;
}
function $11a2b594d0ba6d4b$export$f0954fd7d5368655(out) {
    out[0] = 0;
    out[1] = 0;
    out[2] = 0;
    out[3] = 1;
    out[4] = 0;
    out[5] = 0;
    out[6] = 0;
    out[7] = 0;
    return out;
}
function $11a2b594d0ba6d4b$export$adaa4cf7ef1b65be(out, x1, y1, z1, w1, x2, y2, z2, w2) {
    out[0] = x1;
    out[1] = y1;
    out[2] = z1;
    out[3] = w1;
    out[4] = x2;
    out[5] = y2;
    out[6] = z2;
    out[7] = w2;
    return out;
}
var $11a2b594d0ba6d4b$export$850568f5e3cdb212 = $k1dpP.copy;
function $11a2b594d0ba6d4b$export$6b62e6fd886a6462(out, a) {
    out[0] = a[4];
    out[1] = a[5];
    out[2] = a[6];
    out[3] = a[7];
    return out;
}
var $11a2b594d0ba6d4b$export$611329ee5753c868 = $k1dpP.copy;
function $11a2b594d0ba6d4b$export$c5d0e0cf08580c3f(out, q) {
    out[4] = q[0];
    out[5] = q[1];
    out[6] = q[2];
    out[7] = q[3];
    return out;
}
function $11a2b594d0ba6d4b$export$202e99f82f7f0395(out, a) {
    var ax = a[4], ay = a[5], az = a[6], aw = a[7], bx = -a[0], by = -a[1], bz = -a[2], bw = a[3];
    out[0] = (ax * bw + aw * bx + ay * bz - az * by) * 2;
    out[1] = (ay * bw + aw * by + az * bx - ax * bz) * 2;
    out[2] = (az * bw + aw * bz + ax * by - ay * bx) * 2;
    return out;
}
function $11a2b594d0ba6d4b$export$d73ee8ef04f5226a(out, a, v) {
    var ax1 = a[0], ay1 = a[1], az1 = a[2], aw1 = a[3], bx1 = v[0] * 0.5, by1 = v[1] * 0.5, bz1 = v[2] * 0.5, ax2 = a[4], ay2 = a[5], az2 = a[6], aw2 = a[7];
    out[0] = ax1;
    out[1] = ay1;
    out[2] = az1;
    out[3] = aw1;
    out[4] = aw1 * bx1 + ay1 * bz1 - az1 * by1 + ax2;
    out[5] = aw1 * by1 + az1 * bx1 - ax1 * bz1 + ay2;
    out[6] = aw1 * bz1 + ax1 * by1 - ay1 * bx1 + az2;
    out[7] = -ax1 * bx1 - ay1 * by1 - az1 * bz1 + aw2;
    return out;
}
function $11a2b594d0ba6d4b$export$a59c8716592e09af(out, a, rad) {
    var bx = -a[0], by = -a[1], bz = -a[2], bw = a[3], ax = a[4], ay = a[5], az = a[6], aw = a[7], ax1 = ax * bw + aw * bx + ay * bz - az * by, ay1 = ay * bw + aw * by + az * bx - ax * bz, az1 = az * bw + aw * bz + ax * by - ay * bx, aw1 = aw * bw - ax * bx - ay * by - az * bz;
    $k1dpP.rotateX(out, a, rad);
    bx = out[0];
    by = out[1];
    bz = out[2];
    bw = out[3];
    out[4] = ax1 * bw + aw1 * bx + ay1 * bz - az1 * by;
    out[5] = ay1 * bw + aw1 * by + az1 * bx - ax1 * bz;
    out[6] = az1 * bw + aw1 * bz + ax1 * by - ay1 * bx;
    out[7] = aw1 * bw - ax1 * bx - ay1 * by - az1 * bz;
    return out;
}
function $11a2b594d0ba6d4b$export$cf71e4d4ca4d1cfd(out, a, rad) {
    var bx = -a[0], by = -a[1], bz = -a[2], bw = a[3], ax = a[4], ay = a[5], az = a[6], aw = a[7], ax1 = ax * bw + aw * bx + ay * bz - az * by, ay1 = ay * bw + aw * by + az * bx - ax * bz, az1 = az * bw + aw * bz + ax * by - ay * bx, aw1 = aw * bw - ax * bx - ay * by - az * bz;
    $k1dpP.rotateY(out, a, rad);
    bx = out[0];
    by = out[1];
    bz = out[2];
    bw = out[3];
    out[4] = ax1 * bw + aw1 * bx + ay1 * bz - az1 * by;
    out[5] = ay1 * bw + aw1 * by + az1 * bx - ax1 * bz;
    out[6] = az1 * bw + aw1 * bz + ax1 * by - ay1 * bx;
    out[7] = aw1 * bw - ax1 * bx - ay1 * by - az1 * bz;
    return out;
}
function $11a2b594d0ba6d4b$export$ea6eae3365de5b9c(out, a, rad) {
    var bx = -a[0], by = -a[1], bz = -a[2], bw = a[3], ax = a[4], ay = a[5], az = a[6], aw = a[7], ax1 = ax * bw + aw * bx + ay * bz - az * by, ay1 = ay * bw + aw * by + az * bx - ax * bz, az1 = az * bw + aw * bz + ax * by - ay * bx, aw1 = aw * bw - ax * bx - ay * by - az * bz;
    $k1dpP.rotateZ(out, a, rad);
    bx = out[0];
    by = out[1];
    bz = out[2];
    bw = out[3];
    out[4] = ax1 * bw + aw1 * bx + ay1 * bz - az1 * by;
    out[5] = ay1 * bw + aw1 * by + az1 * bx - ax1 * bz;
    out[6] = az1 * bw + aw1 * bz + ax1 * by - ay1 * bx;
    out[7] = aw1 * bw - ax1 * bx - ay1 * by - az1 * bz;
    return out;
}
function $11a2b594d0ba6d4b$export$7da74d4771545cc5(out, a, q) {
    var qx = q[0], qy = q[1], qz = q[2], qw = q[3], ax = a[0], ay = a[1], az = a[2], aw = a[3];
    out[0] = ax * qw + aw * qx + ay * qz - az * qy;
    out[1] = ay * qw + aw * qy + az * qx - ax * qz;
    out[2] = az * qw + aw * qz + ax * qy - ay * qx;
    out[3] = aw * qw - ax * qx - ay * qy - az * qz;
    ax = a[4];
    ay = a[5];
    az = a[6];
    aw = a[7];
    out[4] = ax * qw + aw * qx + ay * qz - az * qy;
    out[5] = ay * qw + aw * qy + az * qx - ax * qz;
    out[6] = az * qw + aw * qz + ax * qy - ay * qx;
    out[7] = aw * qw - ax * qx - ay * qy - az * qz;
    return out;
}
function $11a2b594d0ba6d4b$export$82e307635ffa6e66(out, q, a) {
    var qx = q[0], qy = q[1], qz = q[2], qw = q[3], bx = a[0], by = a[1], bz = a[2], bw = a[3];
    out[0] = qx * bw + qw * bx + qy * bz - qz * by;
    out[1] = qy * bw + qw * by + qz * bx - qx * bz;
    out[2] = qz * bw + qw * bz + qx * by - qy * bx;
    out[3] = qw * bw - qx * bx - qy * by - qz * bz;
    bx = a[4];
    by = a[5];
    bz = a[6];
    bw = a[7];
    out[4] = qx * bw + qw * bx + qy * bz - qz * by;
    out[5] = qy * bw + qw * by + qz * bx - qx * bz;
    out[6] = qz * bw + qw * bz + qx * by - qy * bx;
    out[7] = qw * bw - qx * bx - qy * by - qz * bz;
    return out;
}
function $11a2b594d0ba6d4b$export$1b0030ab84d46e01(out, a, axis, rad) {
    //Special case for rad = 0
    if (Math.abs(rad) < $amnUE.EPSILON) return $11a2b594d0ba6d4b$export$784d13d8ee351f07(out, a);
    var axisLength = Math.hypot(axis[0], axis[1], axis[2]);
    rad = rad * 0.5;
    var s = Math.sin(rad);
    var bx = s * axis[0] / axisLength;
    var by = s * axis[1] / axisLength;
    var bz = s * axis[2] / axisLength;
    var bw = Math.cos(rad);
    var ax1 = a[0], ay1 = a[1], az1 = a[2], aw1 = a[3];
    out[0] = ax1 * bw + aw1 * bx + ay1 * bz - az1 * by;
    out[1] = ay1 * bw + aw1 * by + az1 * bx - ax1 * bz;
    out[2] = az1 * bw + aw1 * bz + ax1 * by - ay1 * bx;
    out[3] = aw1 * bw - ax1 * bx - ay1 * by - az1 * bz;
    var ax = a[4], ay = a[5], az = a[6], aw = a[7];
    out[4] = ax * bw + aw * bx + ay * bz - az * by;
    out[5] = ay * bw + aw * by + az * bx - ax * bz;
    out[6] = az * bw + aw * bz + ax * by - ay * bx;
    out[7] = aw * bw - ax * bx - ay * by - az * bz;
    return out;
}
function $11a2b594d0ba6d4b$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    out[3] = a[3] + b[3];
    out[4] = a[4] + b[4];
    out[5] = a[5] + b[5];
    out[6] = a[6] + b[6];
    out[7] = a[7] + b[7];
    return out;
}
function $11a2b594d0ba6d4b$export$2060d2db72cce88f(out, a, b) {
    var ax0 = a[0], ay0 = a[1], az0 = a[2], aw0 = a[3], bx1 = b[4], by1 = b[5], bz1 = b[6], bw1 = b[7], ax1 = a[4], ay1 = a[5], az1 = a[6], aw1 = a[7], bx0 = b[0], by0 = b[1], bz0 = b[2], bw0 = b[3];
    out[0] = ax0 * bw0 + aw0 * bx0 + ay0 * bz0 - az0 * by0;
    out[1] = ay0 * bw0 + aw0 * by0 + az0 * bx0 - ax0 * bz0;
    out[2] = az0 * bw0 + aw0 * bz0 + ax0 * by0 - ay0 * bx0;
    out[3] = aw0 * bw0 - ax0 * bx0 - ay0 * by0 - az0 * bz0;
    out[4] = ax0 * bw1 + aw0 * bx1 + ay0 * bz1 - az0 * by1 + ax1 * bw0 + aw1 * bx0 + ay1 * bz0 - az1 * by0;
    out[5] = ay0 * bw1 + aw0 * by1 + az0 * bx1 - ax0 * bz1 + ay1 * bw0 + aw1 * by0 + az1 * bx0 - ax1 * bz0;
    out[6] = az0 * bw1 + aw0 * bz1 + ax0 * by1 - ay0 * bx1 + az1 * bw0 + aw1 * bz0 + ax1 * by0 - ay1 * bx0;
    out[7] = aw0 * bw1 - ax0 * bx1 - ay0 * by1 - az0 * bz1 + aw1 * bw0 - ax1 * bx0 - ay1 * by0 - az1 * bz0;
    return out;
}
var $11a2b594d0ba6d4b$export$6e3a27864ab166fe = $11a2b594d0ba6d4b$export$2060d2db72cce88f;
function $11a2b594d0ba6d4b$export$dcdf75081b88279d(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    out[3] = a[3] * b;
    out[4] = a[4] * b;
    out[5] = a[5] * b;
    out[6] = a[6] * b;
    out[7] = a[7] * b;
    return out;
}
var $11a2b594d0ba6d4b$export$94132a0e348806d4 = $k1dpP.dot;
function $11a2b594d0ba6d4b$export$3a89f8d6f6bf6c9f(out, a, b, t) {
    var mt = 1 - t;
    if ($11a2b594d0ba6d4b$export$94132a0e348806d4(a, b) < 0) t = -t;
    out[0] = a[0] * mt + b[0] * t;
    out[1] = a[1] * mt + b[1] * t;
    out[2] = a[2] * mt + b[2] * t;
    out[3] = a[3] * mt + b[3] * t;
    out[4] = a[4] * mt + b[4] * t;
    out[5] = a[5] * mt + b[5] * t;
    out[6] = a[6] * mt + b[6] * t;
    out[7] = a[7] * mt + b[7] * t;
    return out;
}
function $11a2b594d0ba6d4b$export$6897c284b6f9f4dc(out, a) {
    var sqlen = $11a2b594d0ba6d4b$export$ab44e1323ffc8376(a);
    out[0] = -a[0] / sqlen;
    out[1] = -a[1] / sqlen;
    out[2] = -a[2] / sqlen;
    out[3] = a[3] / sqlen;
    out[4] = -a[4] / sqlen;
    out[5] = -a[5] / sqlen;
    out[6] = -a[6] / sqlen;
    out[7] = a[7] / sqlen;
    return out;
}
function $11a2b594d0ba6d4b$export$7679f47e72c62560(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    out[2] = -a[2];
    out[3] = a[3];
    out[4] = -a[4];
    out[5] = -a[5];
    out[6] = -a[6];
    out[7] = a[7];
    return out;
}
var $11a2b594d0ba6d4b$export$f24224f1c91d8156 = $k1dpP.length;
var $11a2b594d0ba6d4b$export$fc1400facf92c78 = $11a2b594d0ba6d4b$export$f24224f1c91d8156;
var $11a2b594d0ba6d4b$export$ab44e1323ffc8376 = $k1dpP.squaredLength;
var $11a2b594d0ba6d4b$export$99d8dd3f32a3435 = $11a2b594d0ba6d4b$export$ab44e1323ffc8376;
function $11a2b594d0ba6d4b$export$a3295358bff77e(out, a) {
    var magnitude = $11a2b594d0ba6d4b$export$ab44e1323ffc8376(a);
    if (magnitude > 0) {
        magnitude = Math.sqrt(magnitude);
        var a0 = a[0] / magnitude;
        var a1 = a[1] / magnitude;
        var a2 = a[2] / magnitude;
        var a3 = a[3] / magnitude;
        var b0 = a[4];
        var b1 = a[5];
        var b2 = a[6];
        var b3 = a[7];
        var a_dot_b = a0 * b0 + a1 * b1 + a2 * b2 + a3 * b3;
        out[0] = a0;
        out[1] = a1;
        out[2] = a2;
        out[3] = a3;
        out[4] = (b0 - a0 * a_dot_b) / magnitude;
        out[5] = (b1 - a1 * a_dot_b) / magnitude;
        out[6] = (b2 - a2 * a_dot_b) / magnitude;
        out[7] = (b3 - a3 * a_dot_b) / magnitude;
    }
    return out;
}
function $11a2b594d0ba6d4b$export$42d51816ce590c93(a) {
    return "quat2(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ", " + a[4] + ", " + a[5] + ", " + a[6] + ", " + a[7] + ")";
}
function $11a2b594d0ba6d4b$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3] && a[4] === b[4] && a[5] === b[5] && a[6] === b[6] && a[7] === b[7];
}
function $11a2b594d0ba6d4b$export$e9bab7fafb253603(a, b) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3], a4 = a[4], a5 = a[5], a6 = a[6], a7 = a[7];
    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7];
    return Math.abs(a0 - b0) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a2), Math.abs(b2)) && Math.abs(a3 - b3) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a3), Math.abs(b3)) && Math.abs(a4 - b4) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a4), Math.abs(b4)) && Math.abs(a5 - b5) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a5), Math.abs(b5)) && Math.abs(a6 - b6) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a6), Math.abs(b6)) && Math.abs(a7 - b7) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a7), Math.abs(b7));
}

});

parcelRegister("6BoVD", function(module, exports) {

$parcel$export(module.exports, "create", () => $4ce98914b6676340$export$185802fd694ee1f5);
$parcel$export(module.exports, "clone", () => $4ce98914b6676340$export$9cd59f9826255e47);
$parcel$export(module.exports, "fromValues", () => $4ce98914b6676340$export$a82be99ed2a44a7d);
$parcel$export(module.exports, "copy", () => $4ce98914b6676340$export$784d13d8ee351f07);
$parcel$export(module.exports, "set", () => $4ce98914b6676340$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "add", () => $4ce98914b6676340$export$e16d8520af44a096);
$parcel$export(module.exports, "subtract", () => $4ce98914b6676340$export$4e2d2ead65e5f7e3);
$parcel$export(module.exports, "multiply", () => $4ce98914b6676340$export$2060d2db72cce88f);
$parcel$export(module.exports, "divide", () => $4ce98914b6676340$export$cd007d971a5a2143);
$parcel$export(module.exports, "ceil", () => $4ce98914b6676340$export$803ce6b71a0a94b2);
$parcel$export(module.exports, "floor", () => $4ce98914b6676340$export$a3fe094919f356fd);
$parcel$export(module.exports, "min", () => $4ce98914b6676340$export$96ec731ed4dcb222);
$parcel$export(module.exports, "max", () => $4ce98914b6676340$export$8960430cfd85939f);
$parcel$export(module.exports, "round", () => $4ce98914b6676340$export$2077e0241d6afd3c);
$parcel$export(module.exports, "scale", () => $4ce98914b6676340$export$dcdf75081b88279d);
$parcel$export(module.exports, "scaleAndAdd", () => $4ce98914b6676340$export$19cedf1da84ba854);
$parcel$export(module.exports, "distance", () => $4ce98914b6676340$export$9f17032d917177de);
$parcel$export(module.exports, "squaredDistance", () => $4ce98914b6676340$export$88e6ebb4fe54f538);
$parcel$export(module.exports, "length", () => $4ce98914b6676340$export$f24224f1c91d8156);
$parcel$export(module.exports, "squaredLength", () => $4ce98914b6676340$export$ab44e1323ffc8376);
$parcel$export(module.exports, "negate", () => $4ce98914b6676340$export$aef51622e549b8b0);
$parcel$export(module.exports, "inverse", () => $4ce98914b6676340$export$70ae2c07e401031b);
$parcel$export(module.exports, "normalize", () => $4ce98914b6676340$export$a3295358bff77e);
$parcel$export(module.exports, "dot", () => $4ce98914b6676340$export$94132a0e348806d4);
$parcel$export(module.exports, "cross", () => $4ce98914b6676340$export$bb646b20bb93d339);
$parcel$export(module.exports, "lerp", () => $4ce98914b6676340$export$3a89f8d6f6bf6c9f);
$parcel$export(module.exports, "random", () => $4ce98914b6676340$export$4385e60b38654f68);
$parcel$export(module.exports, "transformMat2", () => $4ce98914b6676340$export$b732428d73874bfc);
$parcel$export(module.exports, "transformMat2d", () => $4ce98914b6676340$export$3e55bc4b3707dfd3);
$parcel$export(module.exports, "transformMat3", () => $4ce98914b6676340$export$f0bfa0a0024626ee);
$parcel$export(module.exports, "transformMat4", () => $4ce98914b6676340$export$5ffbd13800309d59);
$parcel$export(module.exports, "rotate", () => $4ce98914b6676340$export$bb628a54ab399bc9);
$parcel$export(module.exports, "angle", () => $4ce98914b6676340$export$944b09d2ad10b378);
$parcel$export(module.exports, "zero", () => $4ce98914b6676340$export$7f9972325ebfd559);
$parcel$export(module.exports, "str", () => $4ce98914b6676340$export$42d51816ce590c93);
$parcel$export(module.exports, "exactEquals", () => $4ce98914b6676340$export$f2599a5cf1109d8);
$parcel$export(module.exports, "equals", () => $4ce98914b6676340$export$e9bab7fafb253603);
$parcel$export(module.exports, "len", () => $4ce98914b6676340$export$fc1400facf92c78);
$parcel$export(module.exports, "sub", () => $4ce98914b6676340$export$f93b5905241a7cca);
$parcel$export(module.exports, "mul", () => $4ce98914b6676340$export$6e3a27864ab166fe);
$parcel$export(module.exports, "div", () => $4ce98914b6676340$export$159d9494db57879b);
$parcel$export(module.exports, "dist", () => $4ce98914b6676340$export$6c4a311cc157c764);
$parcel$export(module.exports, "sqrDist", () => $4ce98914b6676340$export$2422cd6c492a8b3a);
$parcel$export(module.exports, "sqrLen", () => $4ce98914b6676340$export$99d8dd3f32a3435);
$parcel$export(module.exports, "forEach", () => $4ce98914b6676340$export$4b80e395e36b5a56);

var $amnUE = parcelRequire("amnUE");
function $4ce98914b6676340$export$185802fd694ee1f5() {
    var out = new $amnUE.ARRAY_TYPE(2);
    if ($amnUE.ARRAY_TYPE != Float32Array) {
        out[0] = 0;
        out[1] = 0;
    }
    return out;
}
function $4ce98914b6676340$export$9cd59f9826255e47(a) {
    var out = new $amnUE.ARRAY_TYPE(2);
    out[0] = a[0];
    out[1] = a[1];
    return out;
}
function $4ce98914b6676340$export$a82be99ed2a44a7d(x, y) {
    var out = new $amnUE.ARRAY_TYPE(2);
    out[0] = x;
    out[1] = y;
    return out;
}
function $4ce98914b6676340$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    return out;
}
function $4ce98914b6676340$export$adaa4cf7ef1b65be(out, x, y) {
    out[0] = x;
    out[1] = y;
    return out;
}
function $4ce98914b6676340$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    return out;
}
function $4ce98914b6676340$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    return out;
}
function $4ce98914b6676340$export$2060d2db72cce88f(out, a, b) {
    out[0] = a[0] * b[0];
    out[1] = a[1] * b[1];
    return out;
}
function $4ce98914b6676340$export$cd007d971a5a2143(out, a, b) {
    out[0] = a[0] / b[0];
    out[1] = a[1] / b[1];
    return out;
}
function $4ce98914b6676340$export$803ce6b71a0a94b2(out, a) {
    out[0] = Math.ceil(a[0]);
    out[1] = Math.ceil(a[1]);
    return out;
}
function $4ce98914b6676340$export$a3fe094919f356fd(out, a) {
    out[0] = Math.floor(a[0]);
    out[1] = Math.floor(a[1]);
    return out;
}
function $4ce98914b6676340$export$96ec731ed4dcb222(out, a, b) {
    out[0] = Math.min(a[0], b[0]);
    out[1] = Math.min(a[1], b[1]);
    return out;
}
function $4ce98914b6676340$export$8960430cfd85939f(out, a, b) {
    out[0] = Math.max(a[0], b[0]);
    out[1] = Math.max(a[1], b[1]);
    return out;
}
function $4ce98914b6676340$export$2077e0241d6afd3c(out, a) {
    out[0] = Math.round(a[0]);
    out[1] = Math.round(a[1]);
    return out;
}
function $4ce98914b6676340$export$dcdf75081b88279d(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    return out;
}
function $4ce98914b6676340$export$19cedf1da84ba854(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    return out;
}
function $4ce98914b6676340$export$9f17032d917177de(a, b) {
    var x = b[0] - a[0], y = b[1] - a[1];
    return Math.hypot(x, y);
}
function $4ce98914b6676340$export$88e6ebb4fe54f538(a, b) {
    var x = b[0] - a[0], y = b[1] - a[1];
    return x * x + y * y;
}
function $4ce98914b6676340$export$f24224f1c91d8156(a) {
    var x = a[0], y = a[1];
    return Math.hypot(x, y);
}
function $4ce98914b6676340$export$ab44e1323ffc8376(a) {
    var x = a[0], y = a[1];
    return x * x + y * y;
}
function $4ce98914b6676340$export$aef51622e549b8b0(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    return out;
}
function $4ce98914b6676340$export$70ae2c07e401031b(out, a) {
    out[0] = 1.0 / a[0];
    out[1] = 1.0 / a[1];
    return out;
}
function $4ce98914b6676340$export$a3295358bff77e(out, a) {
    var x = a[0], y = a[1];
    var len = x * x + y * y;
    if (len > 0) //TODO: evaluate use of glm_invsqrt here?
    len = 1 / Math.sqrt(len);
    out[0] = a[0] * len;
    out[1] = a[1] * len;
    return out;
}
function $4ce98914b6676340$export$94132a0e348806d4(a, b) {
    return a[0] * b[0] + a[1] * b[1];
}
function $4ce98914b6676340$export$bb646b20bb93d339(out, a, b) {
    var z = a[0] * b[1] - a[1] * b[0];
    out[0] = out[1] = 0;
    out[2] = z;
    return out;
}
function $4ce98914b6676340$export$3a89f8d6f6bf6c9f(out, a, b, t) {
    var ax = a[0], ay = a[1];
    out[0] = ax + t * (b[0] - ax);
    out[1] = ay + t * (b[1] - ay);
    return out;
}
function $4ce98914b6676340$export$4385e60b38654f68(out, scale) {
    scale = scale || 1.0;
    var r = $amnUE.RANDOM() * 2.0 * Math.PI;
    out[0] = Math.cos(r) * scale;
    out[1] = Math.sin(r) * scale;
    return out;
}
function $4ce98914b6676340$export$b732428d73874bfc(out, a, m) {
    var x = a[0], y = a[1];
    out[0] = m[0] * x + m[2] * y;
    out[1] = m[1] * x + m[3] * y;
    return out;
}
function $4ce98914b6676340$export$3e55bc4b3707dfd3(out, a, m) {
    var x = a[0], y = a[1];
    out[0] = m[0] * x + m[2] * y + m[4];
    out[1] = m[1] * x + m[3] * y + m[5];
    return out;
}
function $4ce98914b6676340$export$f0bfa0a0024626ee(out, a, m) {
    var x = a[0], y = a[1];
    out[0] = m[0] * x + m[3] * y + m[6];
    out[1] = m[1] * x + m[4] * y + m[7];
    return out;
}
function $4ce98914b6676340$export$5ffbd13800309d59(out, a, m) {
    var x = a[0];
    var y = a[1];
    out[0] = m[0] * x + m[4] * y + m[12];
    out[1] = m[1] * x + m[5] * y + m[13];
    return out;
}
function $4ce98914b6676340$export$bb628a54ab399bc9(out, a, b, rad) {
    //Translate point to the origin
    var p0 = a[0] - b[0], p1 = a[1] - b[1], sinC = Math.sin(rad), cosC = Math.cos(rad); //perform rotation and translate to correct position
    out[0] = p0 * cosC - p1 * sinC + b[0];
    out[1] = p0 * sinC + p1 * cosC + b[1];
    return out;
}
function $4ce98914b6676340$export$944b09d2ad10b378(a, b) {
    var x1 = a[0], y1 = a[1], x2 = b[0], y2 = b[1], // mag is the product of the magnitudes of a and b
    mag = Math.sqrt(x1 * x1 + y1 * y1) * Math.sqrt(x2 * x2 + y2 * y2), // mag &&.. short circuits if mag == 0
    cosine = mag && (x1 * x2 + y1 * y2) / mag; // Math.min(Math.max(cosine, -1), 1) clamps the cosine between -1 and 1
    return Math.acos(Math.min(Math.max(cosine, -1), 1));
}
function $4ce98914b6676340$export$7f9972325ebfd559(out) {
    out[0] = 0.0;
    out[1] = 0.0;
    return out;
}
function $4ce98914b6676340$export$42d51816ce590c93(a) {
    return "vec2(" + a[0] + ", " + a[1] + ")";
}
function $4ce98914b6676340$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1];
}
function $4ce98914b6676340$export$e9bab7fafb253603(a, b) {
    var a0 = a[0], a1 = a[1];
    var b0 = b[0], b1 = b[1];
    return Math.abs(a0 - b0) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1));
}
var $4ce98914b6676340$export$fc1400facf92c78 = $4ce98914b6676340$export$f24224f1c91d8156;
var $4ce98914b6676340$export$f93b5905241a7cca = $4ce98914b6676340$export$4e2d2ead65e5f7e3;
var $4ce98914b6676340$export$6e3a27864ab166fe = $4ce98914b6676340$export$2060d2db72cce88f;
var $4ce98914b6676340$export$159d9494db57879b = $4ce98914b6676340$export$cd007d971a5a2143;
var $4ce98914b6676340$export$6c4a311cc157c764 = $4ce98914b6676340$export$9f17032d917177de;
var $4ce98914b6676340$export$2422cd6c492a8b3a = $4ce98914b6676340$export$88e6ebb4fe54f538;
var $4ce98914b6676340$export$99d8dd3f32a3435 = $4ce98914b6676340$export$ab44e1323ffc8376;
var $4ce98914b6676340$export$4b80e395e36b5a56 = function() {
    var vec = $4ce98914b6676340$export$185802fd694ee1f5();
    return function(a, stride, offset, count, fn, arg) {
        var i, l;
        if (!stride) stride = 2;
        if (!offset) offset = 0;
        if (count) l = Math.min(count * stride + offset, a.length);
        else l = a.length;
        for(i = offset; i < l; i += stride){
            vec[0] = a[i];
            vec[1] = a[i + 1];
            fn(vec, vec, arg);
            a[i] = vec[0];
            a[i + 1] = vec[1];
        }
        return a;
    };
}();

});

parcelRegister("1YyR8", function(module, exports) {

$parcel$export(module.exports, "packTangentFrame", () => $17066eba19098a7a$export$7887572cbb5df67e);
$parcel$export(module.exports, "buildNormals", () => $17066eba19098a7a$export$65708918a3cbfcde);
$parcel$export(module.exports, "buildTangents", () => $17066eba19098a7a$export$ebbebc985463d100);

var $7rajR = parcelRequire("7rajR");
var $aw6iW = parcelRequire("aw6iW");
/*!
 * Contains code from google filament
 * https://github.com/google/filament/
 * License Apache-2.0
 */ const $17066eba19098a7a$var$CHAR_BIT = 8;
const $17066eba19098a7a$var$MAT0 = [];
const $17066eba19098a7a$var$TMP0 = [];
const $17066eba19098a7a$var$TMP1 = [];
const $17066eba19098a7a$var$TMP2 = [];
function $17066eba19098a7a$export$7887572cbb5df67e(q, /* vec3 */ n, /* vec4 */ t) {
    const c = (0, $aw6iW).cross($17066eba19098a7a$var$TMP0, n, t);
    const mat = $17066eba19098a7a$var$toMat3($17066eba19098a7a$var$MAT0, t[0], t[1], t[2], ...c, ...n);
    q = (0, $7rajR).fromMat3(q, mat);
    q = (0, $7rajR).normalize(q, q);
    q = $17066eba19098a7a$var$positive(q);
    const storageSize = 2; //sizeof(int16_t)
    // Ensure w is never 0.0
    // Bias is 2^(nb_bits - 1) - 1
    const bias = 1 / ((1 << storageSize * $17066eba19098a7a$var$CHAR_BIT - 1) - 1);
    if (q[3] < bias) {
        q[3] = bias;
        const factor = Math.sqrt(1.0 - bias * bias);
        q[0] *= factor;
        q[1] *= factor;
        q[2] *= factor;
    }
    const b = t[3] > 0 ? (0, $aw6iW).cross($17066eba19098a7a$var$TMP1, t, n) : (0, $aw6iW).cross($17066eba19098a7a$var$TMP1, n, t);
    // If there's a reflection ((n x t) . b <= 0), make sure w is negative
    const cc = (0, $aw6iW).cross($17066eba19098a7a$var$TMP2, t, n);
    if ((0, $aw6iW).dot(cc, b) < 0) (0, $7rajR).scale(q, q, -1);
    return q;
}
function $17066eba19098a7a$var$toMat3(out, c00, c01, c02, c10, c11, c12, c20, c21, c22) {
    out[0] = c00;
    out[1] = c01;
    out[2] = c02;
    out[3] = c10;
    out[4] = c11;
    out[5] = c12;
    out[6] = c20;
    out[7] = c21;
    out[8] = c22;
    return out;
}
const $17066eba19098a7a$var$F0 = [
    0.0,
    0.0,
    1.0
];
const $17066eba19098a7a$var$F1 = [
    2.0,
    -2,
    -2
];
const $17066eba19098a7a$var$F2 = [
    2.0,
    2.0,
    -2
];
/**
 * Extracts the normal vector of the tangent frame encoded in the specified quaternion.
 */ function $17066eba19098a7a$var$toNormal(out, q) {
    const n0 = $17066eba19098a7a$var$F0;
    const n1 = (0, $aw6iW).scale($17066eba19098a7a$var$TMP0, $17066eba19098a7a$var$F1, q[0]);
    (0, $aw6iW).multiply(n1, n1, (0, $aw6iW).set($17066eba19098a7a$var$TMP1, q[2], q[3], q[0]));
    const n2 = (0, $aw6iW).scale($17066eba19098a7a$var$TMP2, $17066eba19098a7a$var$F2, q[1]);
    (0, $aw6iW).multiply(n2, n2, (0, $aw6iW).set($17066eba19098a7a$var$TMP1, q[3], q[2], q[1]));
    (0, $aw6iW).add(out, n0, n1);
    (0, $aw6iW).add(out, out, n2);
}
const $17066eba19098a7a$var$Q0 = [
    1,
    0,
    0
];
const $17066eba19098a7a$var$Q1 = [
    -2,
    2,
    -2
];
const $17066eba19098a7a$var$Q2 = [
    -2,
    2,
    2
];
function $17066eba19098a7a$export$a1df1da2c55b4eeb(q, n, t) {
    $17066eba19098a7a$var$toNormal(n, q);
    const t0 = $17066eba19098a7a$var$Q0;
    const t1 = (0, $aw6iW).scale($17066eba19098a7a$var$TMP0, $17066eba19098a7a$var$Q1, q[1]);
    (0, $aw6iW).multiply(t1, t1, (0, $aw6iW).set($17066eba19098a7a$var$TMP1, q[1], q[0], q[3]));
    const t2 = (0, $aw6iW).scale($17066eba19098a7a$var$TMP2, $17066eba19098a7a$var$Q2, q[2]);
    (0, $aw6iW).multiply(t2, t2, (0, $aw6iW).set($17066eba19098a7a$var$TMP1, q[2], q[3], q[0]));
    (0, $aw6iW).add(t, t0, t1);
    (0, $aw6iW).add(t, t, t2);
}
function $17066eba19098a7a$var$positive(q) {
    if (q[3] < 0) return (0, $7rajR).scale(q, q, -1);
    else return q;
}
const $17066eba19098a7a$var$COUNTS = [];
function $17066eba19098a7a$export$65708918a3cbfcde(positions, indices, out) {
    const normals = out || [];
    if (normals.setLength) // array from arraypool
    normals.setLength(positions.length);
    const counts = $17066eba19098a7a$var$COUNTS;
    if (counts.length < positions.length / 3) counts.length = positions.length / 3;
    counts.fill(0, 0, positions.length / 3);
    const len = indices.length === undefined ? indices : indices.length; //indices may be number
    for(let i = 0; i < len / 3; i++)if (indices.length === undefined) $17066eba19098a7a$var$computeNormal(positions, i * 3, i * 3 + 1, i * 3 + 2, normals, counts);
    else $17066eba19098a7a$var$computeNormal(positions, indices[i * 3], indices[i * 3 + 1], indices[i * 3 + 2], normals, counts);
    //Calculate the sum of the normal vectors of the shared faces of each vertex, then average it.
    for(let i = 0; i < normals.length; i += 3){
        const count = counts[i / 3];
        if (count === 0) {
            normals[i] = 0;
            normals[i + 1] = 0;
            normals[i + 2] = 0;
            continue;
        }
        normals[i] /= count;
        normals[i + 1] /= count;
        normals[i + 2] /= count;
    }
    return normals;
}
const $17066eba19098a7a$var$V0 = [];
const $17066eba19098a7a$var$V1 = [];
const $17066eba19098a7a$var$V2 = [];
const $17066eba19098a7a$var$vA = [];
const $17066eba19098a7a$var$vB = [];
const $17066eba19098a7a$var$vC = [];
const $17066eba19098a7a$var$normal = [];
function $17066eba19098a7a$var$computeNormal(vertices, v1, v2, v3, normals, counts) {
    (0, $aw6iW).set($17066eba19098a7a$var$vA, vertices[v1 * 3], vertices[v1 * 3 + 1], vertices[v1 * 3 + 2]);
    (0, $aw6iW).set($17066eba19098a7a$var$vB, vertices[v2 * 3], vertices[v2 * 3 + 1], vertices[v2 * 3 + 2]);
    (0, $aw6iW).set($17066eba19098a7a$var$vC, vertices[v3 * 3], vertices[v3 * 3 + 1], vertices[v3 * 3 + 2]);
    const cb = (0, $aw6iW).sub($17066eba19098a7a$var$V0, $17066eba19098a7a$var$vC, $17066eba19098a7a$var$vB);
    const ab = (0, $aw6iW).sub($17066eba19098a7a$var$V1, $17066eba19098a7a$var$vA, $17066eba19098a7a$var$vB);
    const cross = (0, $aw6iW).cross($17066eba19098a7a$var$V2, cb, ab);
    (0, $aw6iW).normalize($17066eba19098a7a$var$normal, cross);
    normals[v1 * 3] = normals[v1 * 3] || 0;
    normals[v2 * 3] = normals[v2 * 3] || 0;
    normals[v3 * 3] = normals[v3 * 3] || 0;
    normals[v1 * 3 + 1] = normals[v1 * 3 + 1] || 0;
    normals[v2 * 3 + 1] = normals[v2 * 3 + 1] || 0;
    normals[v3 * 3 + 1] = normals[v3 * 3 + 1] || 0;
    normals[v1 * 3 + 2] = normals[v1 * 3 + 2] || 0;
    normals[v2 * 3 + 2] = normals[v2 * 3 + 2] || 0;
    normals[v3 * 3 + 2] = normals[v3 * 3 + 2] || 0;
    normals[v1 * 3] += $17066eba19098a7a$var$normal[0];
    normals[v2 * 3] += $17066eba19098a7a$var$normal[0];
    normals[v3 * 3] += $17066eba19098a7a$var$normal[0];
    normals[v1 * 3 + 1] += $17066eba19098a7a$var$normal[1];
    normals[v2 * 3 + 1] += $17066eba19098a7a$var$normal[1];
    normals[v3 * 3 + 1] += $17066eba19098a7a$var$normal[1];
    normals[v1 * 3 + 2] += $17066eba19098a7a$var$normal[2];
    normals[v2 * 3 + 2] += $17066eba19098a7a$var$normal[2];
    normals[v3 * 3 + 2] += $17066eba19098a7a$var$normal[2];
    counts[v1] += 1;
    counts[v2] += 1;
    counts[v3] += 1;
}
function $17066eba19098a7a$export$ebbebc985463d100(positions, normals, uvs, indices, out) {
    const nVertices = positions.length / 3;
    const tangents = out || new Array(4 * nVertices);
    const tan1 = [], tan2 = [];
    for(let i = 0; i < nVertices; i++){
        tan1[i] = [
            0,
            0,
            0
        ];
        tan2[i] = [
            0,
            0,
            0
        ];
    }
    const vA = [
        0,
        0,
        0
    ], vB = [
        0,
        0,
        0
    ], vC = [
        0,
        0,
        0
    ], uvA = [
        0,
        0
    ], uvB = [
        0,
        0
    ], uvC = [
        0,
        0
    ], sdir = [
        0,
        0,
        0
    ], tdir = [
        0,
        0,
        0
    ];
    function handleTriangle(a, b, c) {
        $17066eba19098a7a$var$fromArray3(vA, positions, a * 3);
        $17066eba19098a7a$var$fromArray3(vB, positions, b * 3);
        $17066eba19098a7a$var$fromArray3(vC, positions, c * 3);
        $17066eba19098a7a$var$fromArray2(uvA, uvs, a * 2);
        $17066eba19098a7a$var$fromArray2(uvB, uvs, b * 2);
        $17066eba19098a7a$var$fromArray2(uvC, uvs, c * 2);
        const x1 = vB[0] - vA[0];
        const x2 = vC[0] - vA[0];
        const y1 = vB[1] - vA[1];
        const y2 = vC[1] - vA[1];
        const z1 = vB[2] - vA[2];
        const z2 = vC[2] - vA[2];
        const s1 = uvB[0] - uvA[0];
        const s2 = uvC[0] - uvA[0];
        const t1 = uvB[1] - uvA[1];
        const t2 = uvC[1] - uvA[1];
        const r = 1.0 / (s1 * t2 - s2 * t1);
        (0, $aw6iW).set(sdir, (t2 * x1 - t1 * x2) * r, (t2 * y1 - t1 * y2) * r, (t2 * z1 - t1 * z2) * r);
        (0, $aw6iW).set(tdir, (s1 * x2 - s2 * x1) * r, (s1 * y2 - s2 * y1) * r, (s1 * z2 - s2 * z1) * r);
        (0, $aw6iW).add(tan1[a], tan1[a], sdir);
        (0, $aw6iW).add(tan1[b], tan1[b], sdir);
        (0, $aw6iW).add(tan1[c], tan1[c], sdir);
        (0, $aw6iW).add(tan2[a], tan2[a], tdir);
        (0, $aw6iW).add(tan2[b], tan2[b], tdir);
        (0, $aw6iW).add(tan2[c], tan2[c], tdir);
    }
    for(let j = 0, jl = indices.length; j < jl; j += 3)handleTriangle(indices[j + 0], indices[j + 1], indices[j + 2]);
    const tmp = [], tmp2 = [];
    const n = [], n2 = [];
    let w, t, test;
    function handleVertex(v) {
        $17066eba19098a7a$var$fromArray3(n, normals, v * 3);
        (0, $aw6iW).copy(n2, n);
        // n2.copy(n);
        t = tan1[v];
        // Gram-Schmidt orthogonalize
        (0, $aw6iW).copy(tmp, t);
        (0, $aw6iW).sub(tmp, tmp, (0, $aw6iW).scale(n, n, (0, $aw6iW).dot(n, t)));
        (0, $aw6iW).normalize(tmp, tmp);
        // tmp.sub(n.multiplyScalar(n.dot(t))).normalize();
        // Calculate handedness
        (0, $aw6iW).cross(tmp2, n2, t);
        test = (0, $aw6iW).dot(tmp2, tan2[v]);
        // tmp2.crossVectors(n2, t);
        // test = tmp2.dot(tan2[ v ]);
        w = test < 0.0 ? -1 : 1.0;
        tangents[v * 4] = tmp[0];
        tangents[v * 4 + 1] = tmp[1];
        tangents[v * 4 + 2] = tmp[2];
        tangents[v * 4 + 3] = w;
    }
    for(let j = 0, jl = indices.length; j < jl; j += 3){
        handleVertex(indices[j + 0]);
        handleVertex(indices[j + 1]);
        handleVertex(indices[j + 2]);
    }
    return tangents;
}
function $17066eba19098a7a$var$fromArray3(out, array, offset) {
    out[0] = array[offset];
    out[1] = array[offset + 1];
    out[2] = array[offset + 2];
    return out;
}
function $17066eba19098a7a$var$fromArray2(out, array, offset) {
    out[0] = array[offset];
    out[1] = array[offset + 1];
    return out;
}

});
parcelRegister("7rajR", function(module, exports) {

$parcel$export(module.exports, "create", () => $56a30f39111b3ef6$export$185802fd694ee1f5);
$parcel$export(module.exports, "identity", () => $56a30f39111b3ef6$export$f0954fd7d5368655);
$parcel$export(module.exports, "setAxisAngle", () => $56a30f39111b3ef6$export$4286ddefc8f49512);
$parcel$export(module.exports, "getAxisAngle", () => $56a30f39111b3ef6$export$3f70be5e7d7dc51);
$parcel$export(module.exports, "multiply", () => $56a30f39111b3ef6$export$2060d2db72cce88f);
$parcel$export(module.exports, "rotateX", () => $56a30f39111b3ef6$export$a59c8716592e09af);
$parcel$export(module.exports, "rotateY", () => $56a30f39111b3ef6$export$cf71e4d4ca4d1cfd);
$parcel$export(module.exports, "rotateZ", () => $56a30f39111b3ef6$export$ea6eae3365de5b9c);
$parcel$export(module.exports, "calculateW", () => $56a30f39111b3ef6$export$fb72b72e8d764d4e);
$parcel$export(module.exports, "slerp", () => $56a30f39111b3ef6$export$1544d9bc2995de08);
$parcel$export(module.exports, "random", () => $56a30f39111b3ef6$export$4385e60b38654f68);
$parcel$export(module.exports, "invert", () => $56a30f39111b3ef6$export$6897c284b6f9f4dc);
$parcel$export(module.exports, "conjugate", () => $56a30f39111b3ef6$export$7679f47e72c62560);
$parcel$export(module.exports, "fromMat3", () => $56a30f39111b3ef6$export$272a1eb8e5a4b55b);
$parcel$export(module.exports, "fromEuler", () => $56a30f39111b3ef6$export$7a404a587ea85af);
$parcel$export(module.exports, "str", () => $56a30f39111b3ef6$export$42d51816ce590c93);
$parcel$export(module.exports, "clone", () => $56a30f39111b3ef6$export$9cd59f9826255e47);
$parcel$export(module.exports, "fromValues", () => $56a30f39111b3ef6$export$a82be99ed2a44a7d);
$parcel$export(module.exports, "copy", () => $56a30f39111b3ef6$export$784d13d8ee351f07);
$parcel$export(module.exports, "set", () => $56a30f39111b3ef6$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "add", () => $56a30f39111b3ef6$export$e16d8520af44a096);
$parcel$export(module.exports, "mul", () => $56a30f39111b3ef6$export$6e3a27864ab166fe);
$parcel$export(module.exports, "scale", () => $56a30f39111b3ef6$export$dcdf75081b88279d);
$parcel$export(module.exports, "dot", () => $56a30f39111b3ef6$export$94132a0e348806d4);
$parcel$export(module.exports, "lerp", () => $56a30f39111b3ef6$export$3a89f8d6f6bf6c9f);
$parcel$export(module.exports, "length", () => $56a30f39111b3ef6$export$f24224f1c91d8156);
$parcel$export(module.exports, "len", () => $56a30f39111b3ef6$export$fc1400facf92c78);
$parcel$export(module.exports, "squaredLength", () => $56a30f39111b3ef6$export$ab44e1323ffc8376);
$parcel$export(module.exports, "sqrLen", () => $56a30f39111b3ef6$export$99d8dd3f32a3435);
$parcel$export(module.exports, "normalize", () => $56a30f39111b3ef6$export$a3295358bff77e);
$parcel$export(module.exports, "exactEquals", () => $56a30f39111b3ef6$export$f2599a5cf1109d8);
$parcel$export(module.exports, "equals", () => $56a30f39111b3ef6$export$e9bab7fafb253603);
$parcel$export(module.exports, "rotationTo", () => $56a30f39111b3ef6$export$72d66f5842c00904);
$parcel$export(module.exports, "sqlerp", () => $56a30f39111b3ef6$export$699b0866ca50f6cb);
$parcel$export(module.exports, "setAxes", () => $56a30f39111b3ef6$export$937ca0a544b2d712);

var $y7g8h = parcelRequire("y7g8h");

var $a73e9 = parcelRequire("a73e9");

var $aw6iW = parcelRequire("aw6iW");

var $1astZ = parcelRequire("1astZ");
function $56a30f39111b3ef6$export$185802fd694ee1f5() {
    var out = new $y7g8h.ARRAY_TYPE(4);
    if ($y7g8h.ARRAY_TYPE != Float32Array) {
        out[0] = 0;
        out[1] = 0;
        out[2] = 0;
    }
    out[3] = 1;
    return out;
}
function $56a30f39111b3ef6$export$f0954fd7d5368655(out) {
    out[0] = 0;
    out[1] = 0;
    out[2] = 0;
    out[3] = 1;
    return out;
}
function $56a30f39111b3ef6$export$4286ddefc8f49512(out, axis, rad) {
    rad = rad * 0.5;
    var s = Math.sin(rad);
    out[0] = s * axis[0];
    out[1] = s * axis[1];
    out[2] = s * axis[2];
    out[3] = Math.cos(rad);
    return out;
}
function $56a30f39111b3ef6$export$3f70be5e7d7dc51(out_axis, q) {
    var rad = Math.acos(q[3]) * 2.0;
    var s = Math.sin(rad / 2.0);
    if (s > $y7g8h.EPSILON) {
        out_axis[0] = q[0] / s;
        out_axis[1] = q[1] / s;
        out_axis[2] = q[2] / s;
    } else {
        // If s is zero, return any axis (no rotation - axis does not matter)
        out_axis[0] = 1;
        out_axis[1] = 0;
        out_axis[2] = 0;
    }
    return rad;
}
function $56a30f39111b3ef6$export$2060d2db72cce88f(out, a, b) {
    var ax = a[0], ay = a[1], az = a[2], aw = a[3];
    var bx = b[0], by = b[1], bz = b[2], bw = b[3];
    out[0] = ax * bw + aw * bx + ay * bz - az * by;
    out[1] = ay * bw + aw * by + az * bx - ax * bz;
    out[2] = az * bw + aw * bz + ax * by - ay * bx;
    out[3] = aw * bw - ax * bx - ay * by - az * bz;
    return out;
}
function $56a30f39111b3ef6$export$a59c8716592e09af(out, a, rad) {
    rad *= 0.5;
    var ax = a[0], ay = a[1], az = a[2], aw = a[3];
    var bx = Math.sin(rad), bw = Math.cos(rad);
    out[0] = ax * bw + aw * bx;
    out[1] = ay * bw + az * bx;
    out[2] = az * bw - ay * bx;
    out[3] = aw * bw - ax * bx;
    return out;
}
function $56a30f39111b3ef6$export$cf71e4d4ca4d1cfd(out, a, rad) {
    rad *= 0.5;
    var ax = a[0], ay = a[1], az = a[2], aw = a[3];
    var by = Math.sin(rad), bw = Math.cos(rad);
    out[0] = ax * bw - az * by;
    out[1] = ay * bw + aw * by;
    out[2] = az * bw + ax * by;
    out[3] = aw * bw - ay * by;
    return out;
}
function $56a30f39111b3ef6$export$ea6eae3365de5b9c(out, a, rad) {
    rad *= 0.5;
    var ax = a[0], ay = a[1], az = a[2], aw = a[3];
    var bz = Math.sin(rad), bw = Math.cos(rad);
    out[0] = ax * bw + ay * bz;
    out[1] = ay * bw - ax * bz;
    out[2] = az * bw + aw * bz;
    out[3] = aw * bw - az * bz;
    return out;
}
function $56a30f39111b3ef6$export$fb72b72e8d764d4e(out, a) {
    var x = a[0], y = a[1], z = a[2];
    out[0] = x;
    out[1] = y;
    out[2] = z;
    out[3] = Math.sqrt(Math.abs(1.0 - x * x - y * y - z * z));
    return out;
}
function $56a30f39111b3ef6$export$1544d9bc2995de08(out, a, b, t) {
    // benchmarks:
    //    http://jsperf.com/quaternion-slerp-implementations
    var ax = a[0], ay = a[1], az = a[2], aw = a[3];
    var bx = b[0], by = b[1], bz = b[2], bw = b[3];
    var omega = void 0, cosom = void 0, sinom = void 0, scale0 = void 0, scale1 = void 0;
    // calc cosine
    cosom = ax * bx + ay * by + az * bz + aw * bw;
    // adjust signs (if necessary)
    if (cosom < 0.0) {
        cosom = -cosom;
        bx = -bx;
        by = -by;
        bz = -bz;
        bw = -bw;
    }
    // calculate coefficients
    if (1.0 - cosom > $y7g8h.EPSILON) {
        // standard case (slerp)
        omega = Math.acos(cosom);
        sinom = Math.sin(omega);
        scale0 = Math.sin((1.0 - t) * omega) / sinom;
        scale1 = Math.sin(t * omega) / sinom;
    } else {
        // "from" and "to" quaternions are very close
        //  ... so we can do a linear interpolation
        scale0 = 1.0 - t;
        scale1 = t;
    }
    // calculate final values
    out[0] = scale0 * ax + scale1 * bx;
    out[1] = scale0 * ay + scale1 * by;
    out[2] = scale0 * az + scale1 * bz;
    out[3] = scale0 * aw + scale1 * bw;
    return out;
}
function $56a30f39111b3ef6$export$4385e60b38654f68(out) {
    // Implementation of http://planning.cs.uiuc.edu/node198.html
    // TODO: Calling random 3 times is probably not the fastest solution
    var u1 = $y7g8h.RANDOM();
    var u2 = $y7g8h.RANDOM();
    var u3 = $y7g8h.RANDOM();
    var sqrt1MinusU1 = Math.sqrt(1 - u1);
    var sqrtU1 = Math.sqrt(u1);
    out[0] = sqrt1MinusU1 * Math.sin(2.0 * Math.PI * u2);
    out[1] = sqrt1MinusU1 * Math.cos(2.0 * Math.PI * u2);
    out[2] = sqrtU1 * Math.sin(2.0 * Math.PI * u3);
    out[3] = sqrtU1 * Math.cos(2.0 * Math.PI * u3);
    return out;
}
function $56a30f39111b3ef6$export$6897c284b6f9f4dc(out, a) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3];
    var dot = a0 * a0 + a1 * a1 + a2 * a2 + a3 * a3;
    var invDot = dot ? 1.0 / dot : 0;
    // TODO: Would be faster to return [0,0,0,0] immediately if dot == 0
    out[0] = -a0 * invDot;
    out[1] = -a1 * invDot;
    out[2] = -a2 * invDot;
    out[3] = a3 * invDot;
    return out;
}
function $56a30f39111b3ef6$export$7679f47e72c62560(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    out[2] = -a[2];
    out[3] = a[3];
    return out;
}
function $56a30f39111b3ef6$export$272a1eb8e5a4b55b(out, m) {
    // Algorithm in Ken Shoemake's article in 1987 SIGGRAPH course notes
    // article "Quaternion Calculus and Fast Animation".
    var fTrace = m[0] + m[4] + m[8];
    var fRoot = void 0;
    if (fTrace > 0.0) {
        // |w| > 1/2, may as well choose w > 1/2
        fRoot = Math.sqrt(fTrace + 1.0); // 2w
        out[3] = 0.5 * fRoot;
        fRoot = 0.5 / fRoot; // 1/(4w)
        out[0] = (m[5] - m[7]) * fRoot;
        out[1] = (m[6] - m[2]) * fRoot;
        out[2] = (m[1] - m[3]) * fRoot;
    } else {
        // |w| <= 1/2
        var i = 0;
        if (m[4] > m[0]) i = 1;
        if (m[8] > m[i * 3 + i]) i = 2;
        var j = (i + 1) % 3;
        var k = (i + 2) % 3;
        fRoot = Math.sqrt(m[i * 3 + i] - m[j * 3 + j] - m[k * 3 + k] + 1.0);
        out[i] = 0.5 * fRoot;
        fRoot = 0.5 / fRoot;
        out[3] = (m[j * 3 + k] - m[k * 3 + j]) * fRoot;
        out[j] = (m[j * 3 + i] + m[i * 3 + j]) * fRoot;
        out[k] = (m[k * 3 + i] + m[i * 3 + k]) * fRoot;
    }
    return out;
}
function $56a30f39111b3ef6$export$7a404a587ea85af(out, x, y, z) {
    var halfToRad = 0.5 * Math.PI / 180.0;
    x *= halfToRad;
    y *= halfToRad;
    z *= halfToRad;
    var sx = Math.sin(x);
    var cx = Math.cos(x);
    var sy = Math.sin(y);
    var cy = Math.cos(y);
    var sz = Math.sin(z);
    var cz = Math.cos(z);
    out[0] = sx * cy * cz - cx * sy * sz;
    out[1] = cx * sy * cz + sx * cy * sz;
    out[2] = cx * cy * sz - sx * sy * cz;
    out[3] = cx * cy * cz + sx * sy * sz;
    return out;
}
function $56a30f39111b3ef6$export$42d51816ce590c93(a) {
    return 'quat(' + a[0] + ', ' + a[1] + ', ' + a[2] + ', ' + a[3] + ')';
}
var $56a30f39111b3ef6$export$9cd59f9826255e47 = $1astZ.clone;
var $56a30f39111b3ef6$export$a82be99ed2a44a7d = $1astZ.fromValues;
var $56a30f39111b3ef6$export$784d13d8ee351f07 = $1astZ.copy;
var $56a30f39111b3ef6$export$adaa4cf7ef1b65be = $1astZ.set;
var $56a30f39111b3ef6$export$e16d8520af44a096 = $1astZ.add;
var $56a30f39111b3ef6$export$6e3a27864ab166fe = $56a30f39111b3ef6$export$2060d2db72cce88f;
var $56a30f39111b3ef6$export$dcdf75081b88279d = $1astZ.scale;
var $56a30f39111b3ef6$export$94132a0e348806d4 = $1astZ.dot;
var $56a30f39111b3ef6$export$3a89f8d6f6bf6c9f = $1astZ.lerp;
var $56a30f39111b3ef6$export$f24224f1c91d8156 = $1astZ.length;
var $56a30f39111b3ef6$export$fc1400facf92c78 = $56a30f39111b3ef6$export$f24224f1c91d8156;
var $56a30f39111b3ef6$export$ab44e1323ffc8376 = $1astZ.squaredLength;
var $56a30f39111b3ef6$export$99d8dd3f32a3435 = $56a30f39111b3ef6$export$ab44e1323ffc8376;
var $56a30f39111b3ef6$export$a3295358bff77e = $1astZ.normalize;
var $56a30f39111b3ef6$export$f2599a5cf1109d8 = $1astZ.exactEquals;
var $56a30f39111b3ef6$export$e9bab7fafb253603 = $1astZ.equals;
var $56a30f39111b3ef6$export$72d66f5842c00904 = function() {
    var tmpvec3 = $aw6iW.create();
    var xUnitVec3 = $aw6iW.fromValues(1, 0, 0);
    var yUnitVec3 = $aw6iW.fromValues(0, 1, 0);
    return function(out, a, b) {
        var dot = $aw6iW.dot(a, b);
        if (dot < -0.999999) {
            $aw6iW.cross(tmpvec3, xUnitVec3, a);
            if ($aw6iW.len(tmpvec3) < 0.000001) $aw6iW.cross(tmpvec3, yUnitVec3, a);
            $aw6iW.normalize(tmpvec3, tmpvec3);
            $56a30f39111b3ef6$export$4286ddefc8f49512(out, tmpvec3, Math.PI);
            return out;
        } else if (dot > 0.999999) {
            out[0] = 0;
            out[1] = 0;
            out[2] = 0;
            out[3] = 1;
            return out;
        } else {
            $aw6iW.cross(tmpvec3, a, b);
            out[0] = tmpvec3[0];
            out[1] = tmpvec3[1];
            out[2] = tmpvec3[2];
            out[3] = 1 + dot;
            return $56a30f39111b3ef6$export$a3295358bff77e(out, out);
        }
    };
}();
var $56a30f39111b3ef6$export$699b0866ca50f6cb = function() {
    var temp1 = $56a30f39111b3ef6$export$185802fd694ee1f5();
    var temp2 = $56a30f39111b3ef6$export$185802fd694ee1f5();
    return function(out, a, b, c, d, t) {
        $56a30f39111b3ef6$export$1544d9bc2995de08(temp1, a, d, t);
        $56a30f39111b3ef6$export$1544d9bc2995de08(temp2, b, c, t);
        $56a30f39111b3ef6$export$1544d9bc2995de08(out, temp1, temp2, 2 * t * (1 - t));
        return out;
    };
}();
var $56a30f39111b3ef6$export$937ca0a544b2d712 = function() {
    var matr = $a73e9.create();
    return function(out, view, right, up) {
        matr[0] = right[0];
        matr[3] = right[1];
        matr[6] = right[2];
        matr[1] = up[0];
        matr[4] = up[1];
        matr[7] = up[2];
        matr[2] = -view[0];
        matr[5] = -view[1];
        matr[8] = -view[2];
        return $56a30f39111b3ef6$export$a3295358bff77e(out, $56a30f39111b3ef6$export$272a1eb8e5a4b55b(out, matr));
    };
}();

});
parcelRegister("y7g8h", function(module, exports) {

$parcel$export(module.exports, "EPSILON", () => $0668ce9e03a06e79$export$fd293b15f47e270);
$parcel$export(module.exports, "ARRAY_TYPE", () => $0668ce9e03a06e79$export$b67359430d3b1b2);
$parcel$export(module.exports, "RANDOM", () => $0668ce9e03a06e79$export$5ada478c8a628231);
/**
 * Common utilities
 * @module glMatrix
 */ // Configuration Constants
var $0668ce9e03a06e79$export$fd293b15f47e270 = 0.000001;
var $0668ce9e03a06e79$export$b67359430d3b1b2 = typeof Float32Array !== 'undefined' ? Float32Array : Array;
var $0668ce9e03a06e79$export$5ada478c8a628231 = Math.random;
function $0668ce9e03a06e79$export$cb2c0eb57f5e532c(type) {
    $0668ce9e03a06e79$export$b67359430d3b1b2 = type;
}
var $0668ce9e03a06e79$var$degree = Math.PI / 180;
function $0668ce9e03a06e79$export$408b8ee5959eefd5(a) {
    return a * $0668ce9e03a06e79$var$degree;
}
function $0668ce9e03a06e79$export$e9bab7fafb253603(a, b) {
    return Math.abs(a - b) <= $0668ce9e03a06e79$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a), Math.abs(b));
}

});

parcelRegister("a73e9", function(module, exports) {

$parcel$export(module.exports, "create", () => $75cd0fb5dedbaf21$export$185802fd694ee1f5);

var $y7g8h = parcelRequire("y7g8h");
function $75cd0fb5dedbaf21$export$185802fd694ee1f5() {
    var out = new $y7g8h.ARRAY_TYPE(9);
    if ($y7g8h.ARRAY_TYPE != Float32Array) {
        out[1] = 0;
        out[2] = 0;
        out[3] = 0;
        out[5] = 0;
        out[6] = 0;
        out[7] = 0;
    }
    out[0] = 1;
    out[4] = 1;
    out[8] = 1;
    return out;
}
function $75cd0fb5dedbaf21$export$b4ad467060d346fe(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[4];
    out[4] = a[5];
    out[5] = a[6];
    out[6] = a[8];
    out[7] = a[9];
    out[8] = a[10];
    return out;
}
function $75cd0fb5dedbaf21$export$9cd59f9826255e47(a) {
    var out = new $y7g8h.ARRAY_TYPE(9);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    return out;
}
function $75cd0fb5dedbaf21$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    return out;
}
function $75cd0fb5dedbaf21$export$a82be99ed2a44a7d(m00, m01, m02, m10, m11, m12, m20, m21, m22) {
    var out = new $y7g8h.ARRAY_TYPE(9);
    out[0] = m00;
    out[1] = m01;
    out[2] = m02;
    out[3] = m10;
    out[4] = m11;
    out[5] = m12;
    out[6] = m20;
    out[7] = m21;
    out[8] = m22;
    return out;
}
function $75cd0fb5dedbaf21$export$adaa4cf7ef1b65be(out, m00, m01, m02, m10, m11, m12, m20, m21, m22) {
    out[0] = m00;
    out[1] = m01;
    out[2] = m02;
    out[3] = m10;
    out[4] = m11;
    out[5] = m12;
    out[6] = m20;
    out[7] = m21;
    out[8] = m22;
    return out;
}
function $75cd0fb5dedbaf21$export$f0954fd7d5368655(out) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 1;
    out[5] = 0;
    out[6] = 0;
    out[7] = 0;
    out[8] = 1;
    return out;
}
function $75cd0fb5dedbaf21$export$9cb09a71b7d66923(out, a) {
    // If we are transposing ourselves we can skip a few steps but have to cache some values
    if (out === a) {
        var a01 = a[1], a02 = a[2], a12 = a[5];
        out[1] = a[3];
        out[2] = a[6];
        out[3] = a01;
        out[5] = a[7];
        out[6] = a02;
        out[7] = a12;
    } else {
        out[0] = a[0];
        out[1] = a[3];
        out[2] = a[6];
        out[3] = a[1];
        out[4] = a[4];
        out[5] = a[7];
        out[6] = a[2];
        out[7] = a[5];
        out[8] = a[8];
    }
    return out;
}
function $75cd0fb5dedbaf21$export$6897c284b6f9f4dc(out, a) {
    var a00 = a[0], a01 = a[1], a02 = a[2];
    var a10 = a[3], a11 = a[4], a12 = a[5];
    var a20 = a[6], a21 = a[7], a22 = a[8];
    var b01 = a22 * a11 - a12 * a21;
    var b11 = -a22 * a10 + a12 * a20;
    var b21 = a21 * a10 - a11 * a20;
    // Calculate the determinant
    var det = a00 * b01 + a01 * b11 + a02 * b21;
    if (!det) return null;
    det = 1.0 / det;
    out[0] = b01 * det;
    out[1] = (-a22 * a01 + a02 * a21) * det;
    out[2] = (a12 * a01 - a02 * a11) * det;
    out[3] = b11 * det;
    out[4] = (a22 * a00 - a02 * a20) * det;
    out[5] = (-a12 * a00 + a02 * a10) * det;
    out[6] = b21 * det;
    out[7] = (-a21 * a00 + a01 * a20) * det;
    out[8] = (a11 * a00 - a01 * a10) * det;
    return out;
}
function $75cd0fb5dedbaf21$export$33f3c024b4ae00a1(out, a) {
    var a00 = a[0], a01 = a[1], a02 = a[2];
    var a10 = a[3], a11 = a[4], a12 = a[5];
    var a20 = a[6], a21 = a[7], a22 = a[8];
    out[0] = a11 * a22 - a12 * a21;
    out[1] = a02 * a21 - a01 * a22;
    out[2] = a01 * a12 - a02 * a11;
    out[3] = a12 * a20 - a10 * a22;
    out[4] = a00 * a22 - a02 * a20;
    out[5] = a02 * a10 - a00 * a12;
    out[6] = a10 * a21 - a11 * a20;
    out[7] = a01 * a20 - a00 * a21;
    out[8] = a00 * a11 - a01 * a10;
    return out;
}
function $75cd0fb5dedbaf21$export$a04698f914c55ed9(a) {
    var a00 = a[0], a01 = a[1], a02 = a[2];
    var a10 = a[3], a11 = a[4], a12 = a[5];
    var a20 = a[6], a21 = a[7], a22 = a[8];
    return a00 * (a22 * a11 - a12 * a21) + a01 * (-a22 * a10 + a12 * a20) + a02 * (a21 * a10 - a11 * a20);
}
function $75cd0fb5dedbaf21$export$2060d2db72cce88f(out, a, b) {
    var a00 = a[0], a01 = a[1], a02 = a[2];
    var a10 = a[3], a11 = a[4], a12 = a[5];
    var a20 = a[6], a21 = a[7], a22 = a[8];
    var b00 = b[0], b01 = b[1], b02 = b[2];
    var b10 = b[3], b11 = b[4], b12 = b[5];
    var b20 = b[6], b21 = b[7], b22 = b[8];
    out[0] = b00 * a00 + b01 * a10 + b02 * a20;
    out[1] = b00 * a01 + b01 * a11 + b02 * a21;
    out[2] = b00 * a02 + b01 * a12 + b02 * a22;
    out[3] = b10 * a00 + b11 * a10 + b12 * a20;
    out[4] = b10 * a01 + b11 * a11 + b12 * a21;
    out[5] = b10 * a02 + b11 * a12 + b12 * a22;
    out[6] = b20 * a00 + b21 * a10 + b22 * a20;
    out[7] = b20 * a01 + b21 * a11 + b22 * a21;
    out[8] = b20 * a02 + b21 * a12 + b22 * a22;
    return out;
}
function $75cd0fb5dedbaf21$export$d73ee8ef04f5226a(out, a, v) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a10 = a[3], a11 = a[4], a12 = a[5], a20 = a[6], a21 = a[7], a22 = a[8], x = v[0], y = v[1];
    out[0] = a00;
    out[1] = a01;
    out[2] = a02;
    out[3] = a10;
    out[4] = a11;
    out[5] = a12;
    out[6] = x * a00 + y * a10 + a20;
    out[7] = x * a01 + y * a11 + a21;
    out[8] = x * a02 + y * a12 + a22;
    return out;
}
function $75cd0fb5dedbaf21$export$bb628a54ab399bc9(out, a, rad) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a10 = a[3], a11 = a[4], a12 = a[5], a20 = a[6], a21 = a[7], a22 = a[8], s = Math.sin(rad), c = Math.cos(rad);
    out[0] = c * a00 + s * a10;
    out[1] = c * a01 + s * a11;
    out[2] = c * a02 + s * a12;
    out[3] = c * a10 - s * a00;
    out[4] = c * a11 - s * a01;
    out[5] = c * a12 - s * a02;
    out[6] = a20;
    out[7] = a21;
    out[8] = a22;
    return out;
}
function $75cd0fb5dedbaf21$export$dcdf75081b88279d(out, a, v) {
    var x = v[0], y = v[1];
    out[0] = x * a[0];
    out[1] = x * a[1];
    out[2] = x * a[2];
    out[3] = y * a[3];
    out[4] = y * a[4];
    out[5] = y * a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    return out;
}
function $75cd0fb5dedbaf21$export$bc9e79e74e9fddf6(out, v) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 1;
    out[5] = 0;
    out[6] = v[0];
    out[7] = v[1];
    out[8] = 1;
    return out;
}
function $75cd0fb5dedbaf21$export$926fc125ff3c666c(out, rad) {
    var s = Math.sin(rad), c = Math.cos(rad);
    out[0] = c;
    out[1] = s;
    out[2] = 0;
    out[3] = -s;
    out[4] = c;
    out[5] = 0;
    out[6] = 0;
    out[7] = 0;
    out[8] = 1;
    return out;
}
function $75cd0fb5dedbaf21$export$832ca188ffb1955d(out, v) {
    out[0] = v[0];
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = v[1];
    out[5] = 0;
    out[6] = 0;
    out[7] = 0;
    out[8] = 1;
    return out;
}
function $75cd0fb5dedbaf21$export$68f5977575fae9bf(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = 0;
    out[3] = a[2];
    out[4] = a[3];
    out[5] = 0;
    out[6] = a[4];
    out[7] = a[5];
    out[8] = 1;
    return out;
}
function $75cd0fb5dedbaf21$export$2ff2bbe382249af7(out, q) {
    var x = q[0], y = q[1], z = q[2], w = q[3];
    var x2 = x + x;
    var y2 = y + y;
    var z2 = z + z;
    var xx = x * x2;
    var yx = y * x2;
    var yy = y * y2;
    var zx = z * x2;
    var zy = z * y2;
    var zz = z * z2;
    var wx = w * x2;
    var wy = w * y2;
    var wz = w * z2;
    out[0] = 1 - yy - zz;
    out[3] = yx - wz;
    out[6] = zx + wy;
    out[1] = yx + wz;
    out[4] = 1 - xx - zz;
    out[7] = zy - wx;
    out[2] = zx - wy;
    out[5] = zy + wx;
    out[8] = 1 - xx - yy;
    return out;
}
function $75cd0fb5dedbaf21$export$966b25ab6dc1b1f9(out, a) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    var a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    var a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    var a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    var b00 = a00 * a11 - a01 * a10;
    var b01 = a00 * a12 - a02 * a10;
    var b02 = a00 * a13 - a03 * a10;
    var b03 = a01 * a12 - a02 * a11;
    var b04 = a01 * a13 - a03 * a11;
    var b05 = a02 * a13 - a03 * a12;
    var b06 = a20 * a31 - a21 * a30;
    var b07 = a20 * a32 - a22 * a30;
    var b08 = a20 * a33 - a23 * a30;
    var b09 = a21 * a32 - a22 * a31;
    var b10 = a21 * a33 - a23 * a31;
    var b11 = a22 * a33 - a23 * a32;
    // Calculate the determinant
    var det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
    if (!det) return null;
    det = 1.0 / det;
    out[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
    out[1] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
    out[2] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
    out[3] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
    out[4] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
    out[5] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
    out[6] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
    out[7] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
    out[8] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
    return out;
}
function $75cd0fb5dedbaf21$export$b74061472fe7c07(out, width, height) {
    out[0] = 2 / width;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = -2 / height;
    out[5] = 0;
    out[6] = -1;
    out[7] = 1;
    out[8] = 1;
    return out;
}
function $75cd0fb5dedbaf21$export$42d51816ce590c93(a) {
    return 'mat3(' + a[0] + ', ' + a[1] + ', ' + a[2] + ', ' + a[3] + ', ' + a[4] + ', ' + a[5] + ', ' + a[6] + ', ' + a[7] + ', ' + a[8] + ')';
}
function $75cd0fb5dedbaf21$export$326827e8268e9cdb(a) {
    return Math.sqrt(Math.pow(a[0], 2) + Math.pow(a[1], 2) + Math.pow(a[2], 2) + Math.pow(a[3], 2) + Math.pow(a[4], 2) + Math.pow(a[5], 2) + Math.pow(a[6], 2) + Math.pow(a[7], 2) + Math.pow(a[8], 2));
}
function $75cd0fb5dedbaf21$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    out[3] = a[3] + b[3];
    out[4] = a[4] + b[4];
    out[5] = a[5] + b[5];
    out[6] = a[6] + b[6];
    out[7] = a[7] + b[7];
    out[8] = a[8] + b[8];
    return out;
}
function $75cd0fb5dedbaf21$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    out[3] = a[3] - b[3];
    out[4] = a[4] - b[4];
    out[5] = a[5] - b[5];
    out[6] = a[6] - b[6];
    out[7] = a[7] - b[7];
    out[8] = a[8] - b[8];
    return out;
}
function $75cd0fb5dedbaf21$export$c697bed75648cdb7(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    out[3] = a[3] * b;
    out[4] = a[4] * b;
    out[5] = a[5] * b;
    out[6] = a[6] * b;
    out[7] = a[7] * b;
    out[8] = a[8] * b;
    return out;
}
function $75cd0fb5dedbaf21$export$553579f63bdd7137(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    out[2] = a[2] + b[2] * scale;
    out[3] = a[3] + b[3] * scale;
    out[4] = a[4] + b[4] * scale;
    out[5] = a[5] + b[5] * scale;
    out[6] = a[6] + b[6] * scale;
    out[7] = a[7] + b[7] * scale;
    out[8] = a[8] + b[8] * scale;
    return out;
}
function $75cd0fb5dedbaf21$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3] && a[4] === b[4] && a[5] === b[5] && a[6] === b[6] && a[7] === b[7] && a[8] === b[8];
}
function $75cd0fb5dedbaf21$export$e9bab7fafb253603(a, b) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3], a4 = a[4], a5 = a[5], a6 = a[6], a7 = a[7], a8 = a[8];
    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7], b8 = b[8];
    return Math.abs(a0 - b0) <= $y7g8h.EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= $y7g8h.EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= $y7g8h.EPSILON * Math.max(1.0, Math.abs(a2), Math.abs(b2)) && Math.abs(a3 - b3) <= $y7g8h.EPSILON * Math.max(1.0, Math.abs(a3), Math.abs(b3)) && Math.abs(a4 - b4) <= $y7g8h.EPSILON * Math.max(1.0, Math.abs(a4), Math.abs(b4)) && Math.abs(a5 - b5) <= $y7g8h.EPSILON * Math.max(1.0, Math.abs(a5), Math.abs(b5)) && Math.abs(a6 - b6) <= $y7g8h.EPSILON * Math.max(1.0, Math.abs(a6), Math.abs(b6)) && Math.abs(a7 - b7) <= $y7g8h.EPSILON * Math.max(1.0, Math.abs(a7), Math.abs(b7)) && Math.abs(a8 - b8) <= $y7g8h.EPSILON * Math.max(1.0, Math.abs(a8), Math.abs(b8));
}
var $75cd0fb5dedbaf21$export$6e3a27864ab166fe = $75cd0fb5dedbaf21$export$2060d2db72cce88f;
var $75cd0fb5dedbaf21$export$f93b5905241a7cca = $75cd0fb5dedbaf21$export$4e2d2ead65e5f7e3;

});

parcelRegister("aw6iW", function(module, exports) {

$parcel$export(module.exports, "create", () => $7a81c87b76cbb37e$export$185802fd694ee1f5);
$parcel$export(module.exports, "clone", () => $7a81c87b76cbb37e$export$9cd59f9826255e47);
$parcel$export(module.exports, "length", () => $7a81c87b76cbb37e$export$f24224f1c91d8156);
$parcel$export(module.exports, "fromValues", () => $7a81c87b76cbb37e$export$a82be99ed2a44a7d);
$parcel$export(module.exports, "copy", () => $7a81c87b76cbb37e$export$784d13d8ee351f07);
$parcel$export(module.exports, "set", () => $7a81c87b76cbb37e$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "add", () => $7a81c87b76cbb37e$export$e16d8520af44a096);
$parcel$export(module.exports, "subtract", () => $7a81c87b76cbb37e$export$4e2d2ead65e5f7e3);
$parcel$export(module.exports, "multiply", () => $7a81c87b76cbb37e$export$2060d2db72cce88f);
$parcel$export(module.exports, "divide", () => $7a81c87b76cbb37e$export$cd007d971a5a2143);
$parcel$export(module.exports, "ceil", () => $7a81c87b76cbb37e$export$803ce6b71a0a94b2);
$parcel$export(module.exports, "floor", () => $7a81c87b76cbb37e$export$a3fe094919f356fd);
$parcel$export(module.exports, "min", () => $7a81c87b76cbb37e$export$96ec731ed4dcb222);
$parcel$export(module.exports, "max", () => $7a81c87b76cbb37e$export$8960430cfd85939f);
$parcel$export(module.exports, "round", () => $7a81c87b76cbb37e$export$2077e0241d6afd3c);
$parcel$export(module.exports, "scale", () => $7a81c87b76cbb37e$export$dcdf75081b88279d);
$parcel$export(module.exports, "scaleAndAdd", () => $7a81c87b76cbb37e$export$19cedf1da84ba854);
$parcel$export(module.exports, "distance", () => $7a81c87b76cbb37e$export$9f17032d917177de);
$parcel$export(module.exports, "squaredDistance", () => $7a81c87b76cbb37e$export$88e6ebb4fe54f538);
$parcel$export(module.exports, "squaredLength", () => $7a81c87b76cbb37e$export$ab44e1323ffc8376);
$parcel$export(module.exports, "negate", () => $7a81c87b76cbb37e$export$aef51622e549b8b0);
$parcel$export(module.exports, "inverse", () => $7a81c87b76cbb37e$export$70ae2c07e401031b);
$parcel$export(module.exports, "normalize", () => $7a81c87b76cbb37e$export$a3295358bff77e);
$parcel$export(module.exports, "dot", () => $7a81c87b76cbb37e$export$94132a0e348806d4);
$parcel$export(module.exports, "cross", () => $7a81c87b76cbb37e$export$bb646b20bb93d339);
$parcel$export(module.exports, "lerp", () => $7a81c87b76cbb37e$export$3a89f8d6f6bf6c9f);
$parcel$export(module.exports, "hermite", () => $7a81c87b76cbb37e$export$ae8865616f30561c);
$parcel$export(module.exports, "bezier", () => $7a81c87b76cbb37e$export$b9c5f84610baddaf);
$parcel$export(module.exports, "random", () => $7a81c87b76cbb37e$export$4385e60b38654f68);
$parcel$export(module.exports, "transformMat4", () => $7a81c87b76cbb37e$export$5ffbd13800309d59);
$parcel$export(module.exports, "transformMat3", () => $7a81c87b76cbb37e$export$f0bfa0a0024626ee);
$parcel$export(module.exports, "transformQuat", () => $7a81c87b76cbb37e$export$c32adef9e939ce85);
$parcel$export(module.exports, "rotateX", () => $7a81c87b76cbb37e$export$a59c8716592e09af);
$parcel$export(module.exports, "rotateY", () => $7a81c87b76cbb37e$export$cf71e4d4ca4d1cfd);
$parcel$export(module.exports, "rotateZ", () => $7a81c87b76cbb37e$export$ea6eae3365de5b9c);
$parcel$export(module.exports, "angle", () => $7a81c87b76cbb37e$export$944b09d2ad10b378);
$parcel$export(module.exports, "str", () => $7a81c87b76cbb37e$export$42d51816ce590c93);
$parcel$export(module.exports, "exactEquals", () => $7a81c87b76cbb37e$export$f2599a5cf1109d8);
$parcel$export(module.exports, "equals", () => $7a81c87b76cbb37e$export$e9bab7fafb253603);
$parcel$export(module.exports, "sub", () => $7a81c87b76cbb37e$export$f93b5905241a7cca);
$parcel$export(module.exports, "mul", () => $7a81c87b76cbb37e$export$6e3a27864ab166fe);
$parcel$export(module.exports, "div", () => $7a81c87b76cbb37e$export$159d9494db57879b);
$parcel$export(module.exports, "dist", () => $7a81c87b76cbb37e$export$6c4a311cc157c764);
$parcel$export(module.exports, "sqrDist", () => $7a81c87b76cbb37e$export$2422cd6c492a8b3a);
$parcel$export(module.exports, "len", () => $7a81c87b76cbb37e$export$fc1400facf92c78);
$parcel$export(module.exports, "sqrLen", () => $7a81c87b76cbb37e$export$99d8dd3f32a3435);
$parcel$export(module.exports, "forEach", () => $7a81c87b76cbb37e$export$4b80e395e36b5a56);

var $y7g8h = parcelRequire("y7g8h");
function $7a81c87b76cbb37e$export$185802fd694ee1f5() {
    var out = new $y7g8h.ARRAY_TYPE(3);
    if ($y7g8h.ARRAY_TYPE != Float32Array) {
        out[0] = 0;
        out[1] = 0;
        out[2] = 0;
    }
    return out;
}
function $7a81c87b76cbb37e$export$9cd59f9826255e47(a) {
    var out = new $y7g8h.ARRAY_TYPE(3);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    return out;
}
function $7a81c87b76cbb37e$export$f24224f1c91d8156(a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    return Math.sqrt(x * x + y * y + z * z);
}
function $7a81c87b76cbb37e$export$a82be99ed2a44a7d(x, y, z) {
    var out = new $y7g8h.ARRAY_TYPE(3);
    out[0] = x;
    out[1] = y;
    out[2] = z;
    return out;
}
function $7a81c87b76cbb37e$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    return out;
}
function $7a81c87b76cbb37e$export$adaa4cf7ef1b65be(out, x, y, z) {
    out[0] = x;
    out[1] = y;
    out[2] = z;
    return out;
}
function $7a81c87b76cbb37e$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    return out;
}
function $7a81c87b76cbb37e$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    return out;
}
function $7a81c87b76cbb37e$export$2060d2db72cce88f(out, a, b) {
    out[0] = a[0] * b[0];
    out[1] = a[1] * b[1];
    out[2] = a[2] * b[2];
    return out;
}
function $7a81c87b76cbb37e$export$cd007d971a5a2143(out, a, b) {
    out[0] = a[0] / b[0];
    out[1] = a[1] / b[1];
    out[2] = a[2] / b[2];
    return out;
}
function $7a81c87b76cbb37e$export$803ce6b71a0a94b2(out, a) {
    out[0] = Math.ceil(a[0]);
    out[1] = Math.ceil(a[1]);
    out[2] = Math.ceil(a[2]);
    return out;
}
function $7a81c87b76cbb37e$export$a3fe094919f356fd(out, a) {
    out[0] = Math.floor(a[0]);
    out[1] = Math.floor(a[1]);
    out[2] = Math.floor(a[2]);
    return out;
}
function $7a81c87b76cbb37e$export$96ec731ed4dcb222(out, a, b) {
    out[0] = Math.min(a[0], b[0]);
    out[1] = Math.min(a[1], b[1]);
    out[2] = Math.min(a[2], b[2]);
    return out;
}
function $7a81c87b76cbb37e$export$8960430cfd85939f(out, a, b) {
    out[0] = Math.max(a[0], b[0]);
    out[1] = Math.max(a[1], b[1]);
    out[2] = Math.max(a[2], b[2]);
    return out;
}
function $7a81c87b76cbb37e$export$2077e0241d6afd3c(out, a) {
    out[0] = Math.round(a[0]);
    out[1] = Math.round(a[1]);
    out[2] = Math.round(a[2]);
    return out;
}
function $7a81c87b76cbb37e$export$dcdf75081b88279d(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    return out;
}
function $7a81c87b76cbb37e$export$19cedf1da84ba854(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    out[2] = a[2] + b[2] * scale;
    return out;
}
function $7a81c87b76cbb37e$export$9f17032d917177de(a, b) {
    var x = b[0] - a[0];
    var y = b[1] - a[1];
    var z = b[2] - a[2];
    return Math.sqrt(x * x + y * y + z * z);
}
function $7a81c87b76cbb37e$export$88e6ebb4fe54f538(a, b) {
    var x = b[0] - a[0];
    var y = b[1] - a[1];
    var z = b[2] - a[2];
    return x * x + y * y + z * z;
}
function $7a81c87b76cbb37e$export$ab44e1323ffc8376(a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    return x * x + y * y + z * z;
}
function $7a81c87b76cbb37e$export$aef51622e549b8b0(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    out[2] = -a[2];
    return out;
}
function $7a81c87b76cbb37e$export$70ae2c07e401031b(out, a) {
    out[0] = 1.0 / a[0];
    out[1] = 1.0 / a[1];
    out[2] = 1.0 / a[2];
    return out;
}
function $7a81c87b76cbb37e$export$a3295358bff77e(out, a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    var len = x * x + y * y + z * z;
    if (len > 0) {
        //TODO: evaluate use of glm_invsqrt here?
        len = 1 / Math.sqrt(len);
        out[0] = a[0] * len;
        out[1] = a[1] * len;
        out[2] = a[2] * len;
    }
    return out;
}
function $7a81c87b76cbb37e$export$94132a0e348806d4(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}
function $7a81c87b76cbb37e$export$bb646b20bb93d339(out, a, b) {
    var ax = a[0], ay = a[1], az = a[2];
    var bx = b[0], by = b[1], bz = b[2];
    out[0] = ay * bz - az * by;
    out[1] = az * bx - ax * bz;
    out[2] = ax * by - ay * bx;
    return out;
}
function $7a81c87b76cbb37e$export$3a89f8d6f6bf6c9f(out, a, b, t) {
    var ax = a[0];
    var ay = a[1];
    var az = a[2];
    out[0] = ax + t * (b[0] - ax);
    out[1] = ay + t * (b[1] - ay);
    out[2] = az + t * (b[2] - az);
    return out;
}
function $7a81c87b76cbb37e$export$ae8865616f30561c(out, a, b, c, d, t) {
    var factorTimes2 = t * t;
    var factor1 = factorTimes2 * (2 * t - 3) + 1;
    var factor2 = factorTimes2 * (t - 2) + t;
    var factor3 = factorTimes2 * (t - 1);
    var factor4 = factorTimes2 * (3 - 2 * t);
    out[0] = a[0] * factor1 + b[0] * factor2 + c[0] * factor3 + d[0] * factor4;
    out[1] = a[1] * factor1 + b[1] * factor2 + c[1] * factor3 + d[1] * factor4;
    out[2] = a[2] * factor1 + b[2] * factor2 + c[2] * factor3 + d[2] * factor4;
    return out;
}
function $7a81c87b76cbb37e$export$b9c5f84610baddaf(out, a, b, c, d, t) {
    var inverseFactor = 1 - t;
    var inverseFactorTimesTwo = inverseFactor * inverseFactor;
    var factorTimes2 = t * t;
    var factor1 = inverseFactorTimesTwo * inverseFactor;
    var factor2 = 3 * t * inverseFactorTimesTwo;
    var factor3 = 3 * factorTimes2 * inverseFactor;
    var factor4 = factorTimes2 * t;
    out[0] = a[0] * factor1 + b[0] * factor2 + c[0] * factor3 + d[0] * factor4;
    out[1] = a[1] * factor1 + b[1] * factor2 + c[1] * factor3 + d[1] * factor4;
    out[2] = a[2] * factor1 + b[2] * factor2 + c[2] * factor3 + d[2] * factor4;
    return out;
}
function $7a81c87b76cbb37e$export$4385e60b38654f68(out, scale) {
    scale = scale || 1.0;
    var r = $y7g8h.RANDOM() * 2.0 * Math.PI;
    var z = $y7g8h.RANDOM() * 2.0 - 1.0;
    var zScale = Math.sqrt(1.0 - z * z) * scale;
    out[0] = Math.cos(r) * zScale;
    out[1] = Math.sin(r) * zScale;
    out[2] = z * scale;
    return out;
}
function $7a81c87b76cbb37e$export$5ffbd13800309d59(out, a, m) {
    var x = a[0], y = a[1], z = a[2];
    var w = m[3] * x + m[7] * y + m[11] * z + m[15];
    w = w || 1.0;
    out[0] = (m[0] * x + m[4] * y + m[8] * z + m[12]) / w;
    out[1] = (m[1] * x + m[5] * y + m[9] * z + m[13]) / w;
    out[2] = (m[2] * x + m[6] * y + m[10] * z + m[14]) / w;
    return out;
}
function $7a81c87b76cbb37e$export$f0bfa0a0024626ee(out, a, m) {
    var x = a[0], y = a[1], z = a[2];
    out[0] = x * m[0] + y * m[3] + z * m[6];
    out[1] = x * m[1] + y * m[4] + z * m[7];
    out[2] = x * m[2] + y * m[5] + z * m[8];
    return out;
}
function $7a81c87b76cbb37e$export$c32adef9e939ce85(out, a, q) {
    // benchmarks: https://jsperf.com/quaternion-transform-vec3-implementations-fixed
    var qx = q[0], qy = q[1], qz = q[2], qw = q[3];
    var x = a[0], y = a[1], z = a[2];
    // var qvec = [qx, qy, qz];
    // var uv = vec3.cross([], qvec, a);
    var uvx = qy * z - qz * y, uvy = qz * x - qx * z, uvz = qx * y - qy * x;
    // var uuv = vec3.cross([], qvec, uv);
    var uuvx = qy * uvz - qz * uvy, uuvy = qz * uvx - qx * uvz, uuvz = qx * uvy - qy * uvx;
    // vec3.scale(uv, uv, 2 * w);
    var w2 = qw * 2;
    uvx *= w2;
    uvy *= w2;
    uvz *= w2;
    // vec3.scale(uuv, uuv, 2);
    uuvx *= 2;
    uuvy *= 2;
    uuvz *= 2;
    // return vec3.add(out, a, vec3.add(out, uv, uuv));
    out[0] = x + uvx + uuvx;
    out[1] = y + uvy + uuvy;
    out[2] = z + uvz + uuvz;
    return out;
}
function $7a81c87b76cbb37e$export$a59c8716592e09af(out, a, b, c) {
    var p = [], r = [];
    //Translate point to the origin
    p[0] = a[0] - b[0];
    p[1] = a[1] - b[1];
    p[2] = a[2] - b[2];
    //perform rotation
    r[0] = p[0];
    r[1] = p[1] * Math.cos(c) - p[2] * Math.sin(c);
    r[2] = p[1] * Math.sin(c) + p[2] * Math.cos(c);
    //translate to correct position
    out[0] = r[0] + b[0];
    out[1] = r[1] + b[1];
    out[2] = r[2] + b[2];
    return out;
}
function $7a81c87b76cbb37e$export$cf71e4d4ca4d1cfd(out, a, b, c) {
    var p = [], r = [];
    //Translate point to the origin
    p[0] = a[0] - b[0];
    p[1] = a[1] - b[1];
    p[2] = a[2] - b[2];
    //perform rotation
    r[0] = p[2] * Math.sin(c) + p[0] * Math.cos(c);
    r[1] = p[1];
    r[2] = p[2] * Math.cos(c) - p[0] * Math.sin(c);
    //translate to correct position
    out[0] = r[0] + b[0];
    out[1] = r[1] + b[1];
    out[2] = r[2] + b[2];
    return out;
}
function $7a81c87b76cbb37e$export$ea6eae3365de5b9c(out, a, b, c) {
    var p = [], r = [];
    //Translate point to the origin
    p[0] = a[0] - b[0];
    p[1] = a[1] - b[1];
    p[2] = a[2] - b[2];
    //perform rotation
    r[0] = p[0] * Math.cos(c) - p[1] * Math.sin(c);
    r[1] = p[0] * Math.sin(c) + p[1] * Math.cos(c);
    r[2] = p[2];
    //translate to correct position
    out[0] = r[0] + b[0];
    out[1] = r[1] + b[1];
    out[2] = r[2] + b[2];
    return out;
}
function $7a81c87b76cbb37e$export$944b09d2ad10b378(a, b) {
    var tempA = $7a81c87b76cbb37e$export$a82be99ed2a44a7d(a[0], a[1], a[2]);
    var tempB = $7a81c87b76cbb37e$export$a82be99ed2a44a7d(b[0], b[1], b[2]);
    $7a81c87b76cbb37e$export$a3295358bff77e(tempA, tempA);
    $7a81c87b76cbb37e$export$a3295358bff77e(tempB, tempB);
    var cosine = $7a81c87b76cbb37e$export$94132a0e348806d4(tempA, tempB);
    if (cosine > 1.0) return 0;
    else if (cosine < -1) return Math.PI;
    else return Math.acos(cosine);
}
function $7a81c87b76cbb37e$export$42d51816ce590c93(a) {
    return 'vec3(' + a[0] + ', ' + a[1] + ', ' + a[2] + ')';
}
function $7a81c87b76cbb37e$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2];
}
function $7a81c87b76cbb37e$export$e9bab7fafb253603(a, b) {
    var a0 = a[0], a1 = a[1], a2 = a[2];
    var b0 = b[0], b1 = b[1], b2 = b[2];
    return Math.abs(a0 - b0) <= $y7g8h.EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= $y7g8h.EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= $y7g8h.EPSILON * Math.max(1.0, Math.abs(a2), Math.abs(b2));
}
var $7a81c87b76cbb37e$export$f93b5905241a7cca = $7a81c87b76cbb37e$export$4e2d2ead65e5f7e3;
var $7a81c87b76cbb37e$export$6e3a27864ab166fe = $7a81c87b76cbb37e$export$2060d2db72cce88f;
var $7a81c87b76cbb37e$export$159d9494db57879b = $7a81c87b76cbb37e$export$cd007d971a5a2143;
var $7a81c87b76cbb37e$export$6c4a311cc157c764 = $7a81c87b76cbb37e$export$9f17032d917177de;
var $7a81c87b76cbb37e$export$2422cd6c492a8b3a = $7a81c87b76cbb37e$export$88e6ebb4fe54f538;
var $7a81c87b76cbb37e$export$fc1400facf92c78 = $7a81c87b76cbb37e$export$f24224f1c91d8156;
var $7a81c87b76cbb37e$export$99d8dd3f32a3435 = $7a81c87b76cbb37e$export$ab44e1323ffc8376;
var $7a81c87b76cbb37e$export$4b80e395e36b5a56 = function() {
    var vec = $7a81c87b76cbb37e$export$185802fd694ee1f5();
    return function(a, stride, offset, count, fn, arg) {
        var i = void 0, l = void 0;
        if (!stride) stride = 3;
        if (!offset) offset = 0;
        if (count) l = Math.min(count * stride + offset, a.length);
        else l = a.length;
        for(i = offset; i < l; i += stride){
            vec[0] = a[i];
            vec[1] = a[i + 1];
            vec[2] = a[i + 2];
            fn(vec, vec, arg);
            a[i] = vec[0];
            a[i + 1] = vec[1];
            a[i + 2] = vec[2];
        }
        return a;
    };
}();

});

parcelRegister("1astZ", function(module, exports) {

$parcel$export(module.exports, "clone", () => $0d9cd1b289324032$export$9cd59f9826255e47);
$parcel$export(module.exports, "fromValues", () => $0d9cd1b289324032$export$a82be99ed2a44a7d);
$parcel$export(module.exports, "copy", () => $0d9cd1b289324032$export$784d13d8ee351f07);
$parcel$export(module.exports, "set", () => $0d9cd1b289324032$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "add", () => $0d9cd1b289324032$export$e16d8520af44a096);
$parcel$export(module.exports, "scale", () => $0d9cd1b289324032$export$dcdf75081b88279d);
$parcel$export(module.exports, "length", () => $0d9cd1b289324032$export$f24224f1c91d8156);
$parcel$export(module.exports, "squaredLength", () => $0d9cd1b289324032$export$ab44e1323ffc8376);
$parcel$export(module.exports, "normalize", () => $0d9cd1b289324032$export$a3295358bff77e);
$parcel$export(module.exports, "dot", () => $0d9cd1b289324032$export$94132a0e348806d4);
$parcel$export(module.exports, "lerp", () => $0d9cd1b289324032$export$3a89f8d6f6bf6c9f);
$parcel$export(module.exports, "exactEquals", () => $0d9cd1b289324032$export$f2599a5cf1109d8);
$parcel$export(module.exports, "equals", () => $0d9cd1b289324032$export$e9bab7fafb253603);

var $y7g8h = parcelRequire("y7g8h");
function $0d9cd1b289324032$export$185802fd694ee1f5() {
    var out = new $y7g8h.ARRAY_TYPE(4);
    if ($y7g8h.ARRAY_TYPE != Float32Array) {
        out[0] = 0;
        out[1] = 0;
        out[2] = 0;
        out[3] = 0;
    }
    return out;
}
function $0d9cd1b289324032$export$9cd59f9826255e47(a) {
    var out = new $y7g8h.ARRAY_TYPE(4);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    return out;
}
function $0d9cd1b289324032$export$a82be99ed2a44a7d(x, y, z, w) {
    var out = new $y7g8h.ARRAY_TYPE(4);
    out[0] = x;
    out[1] = y;
    out[2] = z;
    out[3] = w;
    return out;
}
function $0d9cd1b289324032$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    return out;
}
function $0d9cd1b289324032$export$adaa4cf7ef1b65be(out, x, y, z, w) {
    out[0] = x;
    out[1] = y;
    out[2] = z;
    out[3] = w;
    return out;
}
function $0d9cd1b289324032$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    out[3] = a[3] + b[3];
    return out;
}
function $0d9cd1b289324032$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    out[3] = a[3] - b[3];
    return out;
}
function $0d9cd1b289324032$export$2060d2db72cce88f(out, a, b) {
    out[0] = a[0] * b[0];
    out[1] = a[1] * b[1];
    out[2] = a[2] * b[2];
    out[3] = a[3] * b[3];
    return out;
}
function $0d9cd1b289324032$export$cd007d971a5a2143(out, a, b) {
    out[0] = a[0] / b[0];
    out[1] = a[1] / b[1];
    out[2] = a[2] / b[2];
    out[3] = a[3] / b[3];
    return out;
}
function $0d9cd1b289324032$export$803ce6b71a0a94b2(out, a) {
    out[0] = Math.ceil(a[0]);
    out[1] = Math.ceil(a[1]);
    out[2] = Math.ceil(a[2]);
    out[3] = Math.ceil(a[3]);
    return out;
}
function $0d9cd1b289324032$export$a3fe094919f356fd(out, a) {
    out[0] = Math.floor(a[0]);
    out[1] = Math.floor(a[1]);
    out[2] = Math.floor(a[2]);
    out[3] = Math.floor(a[3]);
    return out;
}
function $0d9cd1b289324032$export$96ec731ed4dcb222(out, a, b) {
    out[0] = Math.min(a[0], b[0]);
    out[1] = Math.min(a[1], b[1]);
    out[2] = Math.min(a[2], b[2]);
    out[3] = Math.min(a[3], b[3]);
    return out;
}
function $0d9cd1b289324032$export$8960430cfd85939f(out, a, b) {
    out[0] = Math.max(a[0], b[0]);
    out[1] = Math.max(a[1], b[1]);
    out[2] = Math.max(a[2], b[2]);
    out[3] = Math.max(a[3], b[3]);
    return out;
}
function $0d9cd1b289324032$export$2077e0241d6afd3c(out, a) {
    out[0] = Math.round(a[0]);
    out[1] = Math.round(a[1]);
    out[2] = Math.round(a[2]);
    out[3] = Math.round(a[3]);
    return out;
}
function $0d9cd1b289324032$export$dcdf75081b88279d(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    out[3] = a[3] * b;
    return out;
}
function $0d9cd1b289324032$export$19cedf1da84ba854(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    out[2] = a[2] + b[2] * scale;
    out[3] = a[3] + b[3] * scale;
    return out;
}
function $0d9cd1b289324032$export$9f17032d917177de(a, b) {
    var x = b[0] - a[0];
    var y = b[1] - a[1];
    var z = b[2] - a[2];
    var w = b[3] - a[3];
    return Math.sqrt(x * x + y * y + z * z + w * w);
}
function $0d9cd1b289324032$export$88e6ebb4fe54f538(a, b) {
    var x = b[0] - a[0];
    var y = b[1] - a[1];
    var z = b[2] - a[2];
    var w = b[3] - a[3];
    return x * x + y * y + z * z + w * w;
}
function $0d9cd1b289324032$export$f24224f1c91d8156(a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    var w = a[3];
    return Math.sqrt(x * x + y * y + z * z + w * w);
}
function $0d9cd1b289324032$export$ab44e1323ffc8376(a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    var w = a[3];
    return x * x + y * y + z * z + w * w;
}
function $0d9cd1b289324032$export$aef51622e549b8b0(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    out[2] = -a[2];
    out[3] = -a[3];
    return out;
}
function $0d9cd1b289324032$export$70ae2c07e401031b(out, a) {
    out[0] = 1.0 / a[0];
    out[1] = 1.0 / a[1];
    out[2] = 1.0 / a[2];
    out[3] = 1.0 / a[3];
    return out;
}
function $0d9cd1b289324032$export$a3295358bff77e(out, a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    var w = a[3];
    var len = x * x + y * y + z * z + w * w;
    if (len > 0) {
        len = 1 / Math.sqrt(len);
        out[0] = x * len;
        out[1] = y * len;
        out[2] = z * len;
        out[3] = w * len;
    }
    return out;
}
function $0d9cd1b289324032$export$94132a0e348806d4(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2] + a[3] * b[3];
}
function $0d9cd1b289324032$export$3a89f8d6f6bf6c9f(out, a, b, t) {
    var ax = a[0];
    var ay = a[1];
    var az = a[2];
    var aw = a[3];
    out[0] = ax + t * (b[0] - ax);
    out[1] = ay + t * (b[1] - ay);
    out[2] = az + t * (b[2] - az);
    out[3] = aw + t * (b[3] - aw);
    return out;
}
function $0d9cd1b289324032$export$4385e60b38654f68(out, scale) {
    scale = scale || 1.0;
    // Marsaglia, George. Choosing a Point from the Surface of a
    // Sphere. Ann. Math. Statist. 43 (1972), no. 2, 645--646.
    // http://projecteuclid.org/euclid.aoms/1177692644;
    var v1, v2, v3, v4;
    var s1, s2;
    do {
        v1 = $y7g8h.RANDOM() * 2 - 1;
        v2 = $y7g8h.RANDOM() * 2 - 1;
        s1 = v1 * v1 + v2 * v2;
    }while (s1 >= 1);
    do {
        v3 = $y7g8h.RANDOM() * 2 - 1;
        v4 = $y7g8h.RANDOM() * 2 - 1;
        s2 = v3 * v3 + v4 * v4;
    }while (s2 >= 1);
    var d = Math.sqrt((1 - s1) / s2);
    out[0] = scale * v1;
    out[1] = scale * v2;
    out[2] = scale * v3 * d;
    out[3] = scale * v4 * d;
    return out;
}
function $0d9cd1b289324032$export$5ffbd13800309d59(out, a, m) {
    var x = a[0], y = a[1], z = a[2], w = a[3];
    out[0] = m[0] * x + m[4] * y + m[8] * z + m[12] * w;
    out[1] = m[1] * x + m[5] * y + m[9] * z + m[13] * w;
    out[2] = m[2] * x + m[6] * y + m[10] * z + m[14] * w;
    out[3] = m[3] * x + m[7] * y + m[11] * z + m[15] * w;
    return out;
}
function $0d9cd1b289324032$export$c32adef9e939ce85(out, a, q) {
    var x = a[0], y = a[1], z = a[2];
    var qx = q[0], qy = q[1], qz = q[2], qw = q[3];
    // calculate quat * vec
    var ix = qw * x + qy * z - qz * y;
    var iy = qw * y + qz * x - qx * z;
    var iz = qw * z + qx * y - qy * x;
    var iw = -qx * x - qy * y - qz * z;
    // calculate result * inverse quat
    out[0] = ix * qw + iw * -qx + iy * -qz - iz * -qy;
    out[1] = iy * qw + iw * -qy + iz * -qx - ix * -qz;
    out[2] = iz * qw + iw * -qz + ix * -qy - iy * -qx;
    out[3] = a[3];
    return out;
}
function $0d9cd1b289324032$export$42d51816ce590c93(a) {
    return 'vec4(' + a[0] + ', ' + a[1] + ', ' + a[2] + ', ' + a[3] + ')';
}
function $0d9cd1b289324032$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3];
}
function $0d9cd1b289324032$export$e9bab7fafb253603(a, b) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3];
    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
    return Math.abs(a0 - b0) <= $y7g8h.EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= $y7g8h.EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= $y7g8h.EPSILON * Math.max(1.0, Math.abs(a2), Math.abs(b2)) && Math.abs(a3 - b3) <= $y7g8h.EPSILON * Math.max(1.0, Math.abs(a3), Math.abs(b3));
}
var $0d9cd1b289324032$export$f93b5905241a7cca = $0d9cd1b289324032$export$4e2d2ead65e5f7e3;
var $0d9cd1b289324032$export$6e3a27864ab166fe = $0d9cd1b289324032$export$2060d2db72cce88f;
var $0d9cd1b289324032$export$159d9494db57879b = $0d9cd1b289324032$export$cd007d971a5a2143;
var $0d9cd1b289324032$export$6c4a311cc157c764 = $0d9cd1b289324032$export$9f17032d917177de;
var $0d9cd1b289324032$export$2422cd6c492a8b3a = $0d9cd1b289324032$export$88e6ebb4fe54f538;
var $0d9cd1b289324032$export$fc1400facf92c78 = $0d9cd1b289324032$export$f24224f1c91d8156;
var $0d9cd1b289324032$export$99d8dd3f32a3435 = $0d9cd1b289324032$export$ab44e1323ffc8376;
var $0d9cd1b289324032$export$4b80e395e36b5a56 = function() {
    var vec = $0d9cd1b289324032$export$185802fd694ee1f5();
    return function(a, stride, offset, count, fn, arg) {
        var i = void 0, l = void 0;
        if (!stride) stride = 4;
        if (!offset) offset = 0;
        if (count) l = Math.min(count * stride + offset, a.length);
        else l = a.length;
        for(i = offset; i < l; i += stride){
            vec[0] = a[i];
            vec[1] = a[i + 1];
            vec[2] = a[i + 2];
            vec[3] = a[i + 3];
            fn(vec, vec, arg);
            a[i] = vec[0];
            a[i + 1] = vec[1];
            a[i + 2] = vec[2];
            a[i + 3] = vec[3];
        }
        return a;
    };
}();

});




parcelRegister("KTgK2", function(module, exports) {

$parcel$export(module.exports, "GLContext", () => $08cf2b450ce76d44$export$d29d39a0fc926565);
/*!
 * @maptalks/fusiongl v0.9.2
 * LICENSE : UNLICENSED
 * (c) 2016-2025 maptalks.com
 */ 
var $hHTrr = parcelRequire("hHTrr");
function $08cf2b450ce76d44$var$i(t) {
    for(let i = 1; i < arguments.length; i++){
        const e = arguments[i];
        for(const i in e)t[i] = e[i];
    }
    return t;
}
function $08cf2b450ce76d44$var$e(t, ...e1) {
    for(let r = 0; r < e1.length; r++)$08cf2b450ce76d44$var$i(t, e1[r]);
}
class $08cf2b450ce76d44$var$DrawBuffersExt {
    constructor(t){
        this.context = t, this.COLOR_ATTACHMENT0_WEBGL = 36064, this.COLOR_ATTACHMENT1_WEBGL = 36065, this.COLOR_ATTACHMENT2_WEBGL = 36066, this.COLOR_ATTACHMENT3_WEBGL = 36067, this.COLOR_ATTACHMENT4_WEBGL = 36068, this.COLOR_ATTACHMENT5_WEBGL = 36069, this.COLOR_ATTACHMENT6_WEBGL = 36070, this.COLOR_ATTACHMENT7_WEBGL = 36071, this.COLOR_ATTACHMENT8_WEBGL = 36072, this.COLOR_ATTACHMENT9_WEBGL = 36073, this.COLOR_ATTACHMENT10_WEBGL = 577040, this.COLOR_ATTACHMENT11_WEBGL = 577041, this.COLOR_ATTACHMENT12_WEBGL = 577042, this.COLOR_ATTACHMENT13_WEBGL = 577043, this.COLOR_ATTACHMENT14_WEBGL = 577044, this.COLOR_ATTACHMENT15_WEBGL = 577045, this.DRAW_BUFFER0_WEBGL = 34853, this.DRAW_BUFFER1_WEBGL = 34854, this.DRAW_BUFFER2_WEBGL = 34855, this.DRAW_BUFFER3_WEBGL = 34856, this.DRAW_BUFFER4_WEBGL = 34857, this.DRAW_BUFFER5_WEBGL = 34858, this.DRAW_BUFFER6_WEBGL = 34859, this.DRAW_BUFFER7_WEBGL = 34860, this.DRAW_BUFFER8_WEBGL = 34861, this.DRAW_BUFFER9_WEBGL = 34862, this.DRAW_BUFFER10_WEBGL = 34863, this.DRAW_BUFFER11_WEBGL = 34864, this.DRAW_BUFFER12_WEBGL = 34865, this.DRAW_BUFFER13_WEBGL = 34866, this.DRAW_BUFFER14_WEBGL = 34867, this.DRAW_BUFFER15_WEBGL = 34868, this.MAX_COLOR_ATTACHMENTS_WEBGL = 36063, this.MAX_DRAW_BUFFERS_WEBGL = 2178;
    }
    drawBuffersWEBGL() {
        return this.context.drawBuffers.apply(this.context, arguments);
    }
}
class $08cf2b450ce76d44$var$VertexArrayObjectExt {
    constructor(t){
        this.context = t, this.VERTEX_ARRAY_BINDING_OES = 34229;
    }
    createVertexArrayOES() {
        return this.context.createVertexArray();
    }
    deleteVertexArrayOES() {
        return this.context.deleteVertexArray.apply(this.context, arguments);
    }
    isVertexArrayOES() {
        return this.context.isVertexArray.apply(this.context, arguments);
    }
    bindVertexArrayOES() {
        return this.context.bindVertexArray.apply(this.context, arguments);
    }
}
class $08cf2b450ce76d44$var$AngleInstancedArrayExt {
    constructor(t){
        this.context = t, this.VERTEX_ATTRIB_ARRAY_DIVISOR_ANGLE = 35070;
    }
    drawArraysInstancedANGLE() {
        return this.context.drawArraysInstanced.apply(this.context, arguments);
    }
    drawElementsInstancedANGLE() {
        return this.context.drawElementsInstanced.apply(this.context, arguments);
    }
    vertexAttribDivisorANGLE() {
        return this.context.vertexAttribDivisor.apply(this.context, arguments);
    }
}
const $08cf2b450ce76d44$var$r = 36193, $08cf2b450ce76d44$var$s = {
    webgl_depth_texture: {
        UNSIGNED_INT_24_8_WEBGL: 34042
    },
    oes_element_index_uint: {},
    oes_texture_float: {},
    oes_texture_half_float: {
        HALF_FLOAT_OES: 36193
    },
    ext_color_buffer_float: {},
    oes_standard_derivatives: {},
    ext_frag_depth: {},
    ext_blend_minmax: {
        MIN_EXT: 32775,
        MAX_EXT: 32776
    },
    ext_shader_texture_lod: {}
}, $08cf2b450ce76d44$var$h = {
    has (t, i) {
        const e = t.t, r = t.i;
        return !(!e && !r.getExtension(i)) && (i = i.toLowerCase(), e && $08cf2b450ce76d44$var$s[i] || "webgl_draw_buffers" === i || "oes_vertex_array_object" === i || "angle_instanced_arrays" === i);
    },
    mock: (t, i)=>(i = i.toLowerCase(), $08cf2b450ce76d44$var$s[i] ? t.t ? ("oes_texture_float" !== i && "oes_texture_half_float" !== i || t.i.getExtension("EXT_color_buffer_float"), $08cf2b450ce76d44$var$s[i]) : t.i.getExtension(i) : "webgl_draw_buffers" === i ? new $08cf2b450ce76d44$var$DrawBuffersExt(t) : "oes_vertex_array_object" === i ? new $08cf2b450ce76d44$var$VertexArrayObjectExt(t) : "angle_instanced_arrays" === i ? new $08cf2b450ce76d44$var$AngleInstancedArrayExt(t) : null),
    getInternalFormat: (t, i, e)=>6402 === i ? 33190 : 34041 === i ? 35056 : e === $08cf2b450ce76d44$var$r && i === t.RGBA ? 34842 : e === $08cf2b450ce76d44$var$r && i === t.RGB ? 34843 : e === t.FLOAT && i === t.RGBA ? 34836 : e === t.FLOAT && i === t.RGB ? 34837 : i,
    getTextureType: (t, i)=>i === $08cf2b450ce76d44$var$r ? t.HALF_FLOAT : i
};
let $08cf2b450ce76d44$var$n = 1;
class $08cf2b450ce76d44$export$d29d39a0fc926565 {
    constructor(t){
        this.uid = $08cf2b450ce76d44$var$n++, this.states = function(t) {
            return {
                scissor: [
                    0,
                    0,
                    t.canvas.width,
                    t.canvas.height
                ],
                viewport: [
                    0,
                    0,
                    t.canvas.width,
                    t.canvas.height
                ],
                blendColor: [
                    0,
                    0,
                    0,
                    0
                ],
                blendEquationSeparate: [
                    t.FUNC_ADD,
                    t.FUNC_ADD
                ],
                blendFuncSeparate: [
                    t.ONE,
                    t.ZERO,
                    t.ONE,
                    t.ZERO
                ],
                clearColor: [
                    0,
                    0,
                    0,
                    0
                ],
                clearDepth: [
                    1
                ],
                clearStencil: [
                    0
                ],
                colorMask: [
                    !0,
                    !0,
                    !0,
                    !0
                ],
                cullFace: [
                    t.BACK
                ],
                depthFunc: [
                    t.LESS
                ],
                depthMask: [
                    !0
                ],
                depthRange: [
                    0,
                    1
                ],
                capabilities: {
                    3042: !1,
                    2884: !1,
                    2929: !1,
                    3024: !1,
                    32823: !1,
                    32926: !1,
                    32928: !1,
                    3089: !1,
                    2960: !1
                },
                frontFace: [
                    t.CCW
                ],
                hint: {
                    33170: [
                        t.DONT_CARE
                    ],
                    35723: [
                        t.DONT_CARE
                    ]
                },
                lineWidth: [
                    1
                ],
                pixelStorei: {
                    3333: [
                        4
                    ],
                    3317: [
                        4
                    ],
                    37440: [
                        !1
                    ],
                    37441: [
                        !1
                    ],
                    37443: [
                        t.BROWSER_DEFAULT_WEBGL
                    ]
                },
                polygonOffset: [
                    0,
                    0
                ],
                sampleCoverage: [
                    1,
                    !1
                ],
                stencilFuncSeparate: {
                    1028: [
                        t.ALWAYS,
                        0,
                        4294967295
                    ],
                    1029: [
                        t.ALWAYS,
                        0,
                        4294967295
                    ]
                },
                stencilMaskSeparate: {
                    1028: [
                        4294967295
                    ],
                    1029: [
                        4294967295
                    ]
                },
                stencilOpSeparate: {
                    1028: [
                        t.KEEP,
                        t.KEEP,
                        t.KEEP
                    ],
                    1029: [
                        t.KEEP,
                        t.KEEP,
                        t.KEEP
                    ]
                },
                program: null,
                framebuffer: {
                    36160: null,
                    36008: null,
                    36009: null
                },
                renderbuffer: {
                    36161: null
                },
                textures: {
                    active: -1,
                    units: function() {
                        const i = [], e = t.getParameter(t.MAX_COMBINED_TEXTURE_IMAGE_UNITS);
                        for(let t = 0; t < e; t++)i.push({
                            3553: null,
                            34067: null
                        });
                        return i[-1] = {
                            3553: null,
                            34067: null
                        }, i;
                    }()
                },
                attributes: {},
                arrayBuffer: null,
                elementArrayBuffer: null
            };
        }(t), this.i = t, this.i._fusiongl_drawCalls = 0, this.t = void 0 !== window.WebGL2RenderingContext && this.i instanceof window.WebGL2RenderingContext;
        const i = Object.getPrototypeOf(this);
        this.t ? Object.setPrototypeOf(i, window.WebGL2RenderingContext.prototype) : Object.setPrototypeOf(i, WebGLRenderingContext.prototype), this.h = t.getParameter(t.MAX_VERTEX_ATTRIBS);
    }
    get canvas() {
        return this.i.canvas;
    }
    get drawingBufferWidth() {
        return this.i.drawingBufferWidth;
    }
    get drawingBufferHeight() {
        return this.i.drawingBufferHeight;
    }
    get drawingBufferColorSpace() {
        return this.i.drawingBufferColorSpace;
    }
    set drawingBufferColorSpace(t) {
        this.i.drawingBufferColorSpace = t;
    }
    get gl() {
        return this.i;
    }
    get buffersOES() {
        return this.u || (this.u = this.i.getExtension("WEBGL_draw_buffers")), this.u;
    }
    get vaoOES() {
        return this.o || (this.o = this.i.getExtension("OES_vertex_array_object")), this.o;
    }
    get angleOES() {
        return this.l || (this.l = this.i.getExtension("ANGLE_instanced_arrays")), this.l;
    }
    get standOES() {
        return this.m || (this.m = this.i.getExtension("OES_standard_derivatives")), this.m;
    }
    attachShader(t, i) {
        return this.i.attachShader(t, i);
    }
    shaderSource(t, i) {
        return this.i.shaderSource(t, i);
    }
    compileShader(t) {
        return this.i.compileShader(t);
    }
    createShader(t) {
        return this.i.createShader(t);
    }
    createProgram() {
        return this.i.createProgram();
    }
    deleteProgram(t) {
        return this.states.program === t && (this.states.program = null), this.i.deleteProgram(t);
    }
    deleteShader(t) {
        return this.i.deleteShader(t);
    }
    detachShader(t, i) {
        return this.i.detachShader(t, i);
    }
    getAttachedShaders(t) {
        return this.i.getAttachedShaders(t);
    }
    linkProgram(t) {
        return this.i.linkProgram(t);
    }
    makeXRCompatible() {
        return this.i.makeXRCompatible();
    }
    getShaderParameter(t, i) {
        return this.i.getShaderParameter(t, i);
    }
    getShaderPrecisionFormat(t, i) {
        return this.i.getShaderPrecisionFormat(t, i);
    }
    getShaderInfoLog(t) {
        return this.i.getShaderInfoLog(t);
    }
    getShaderSource(t) {
        return this.i.getShaderSource(t);
    }
    getProgramInfoLog(t) {
        return this.i.getProgramInfoLog(t);
    }
    getProgramParameter(t, i) {
        return this.i.getProgramParameter(t, i);
    }
    getError() {
        return this.i.getError();
    }
    getContextAttributes() {
        return this.i.getContextAttributes();
    }
    getExtension(t) {
        return $08cf2b450ce76d44$var$h.has(this, t) ? $08cf2b450ce76d44$var$h.mock(this, t) : this.i.getExtension(t);
    }
    getSupportedExtensions() {
        return this.i.getSupportedExtensions();
    }
    getParameter(t) {
        return this.i.getParameter(t);
    }
    isEnabled(t) {
        return this.i.isEnabled(t);
    }
    isProgram(t) {
        return this.i.isProgram(t);
    }
    isShader(t) {
        return this.i.isShader(t);
    }
    validateProgram(t) {
        return this.i.validateProgram(t);
    }
    clear(t) {
        return this.v(), this.i.clear(t);
    }
    drawArrays(t, i, e) {
        return this.v(), this._(), this.i.drawArrays(t, i, e);
    }
    drawElements(t, i, e, r) {
        return this.v(), this._(), this.i.drawElements(t, i, e, r);
    }
    drawBuffers(t) {
        return this.v(), this._(), this.t ? this.i.drawBuffers(t) : this.buffersOES.drawBuffersWEBGL(t);
    }
    _() {
        this.i._fusiongl_drawCalls++;
    }
    resetDrawCalls() {
        this.i._fusiongl_drawCalls = 0;
    }
    getDrawCalls() {
        return this.i._fusiongl_drawCalls;
    }
    S() {
        const t = this.i, i = t.getParameter(t.CURRENT_PROGRAM), e = t.getProgramParameter(i, t.ACTIVE_ATTRIBUTES), r = [];
        for(let i = 0; i < e; i++)r.push(t.getVertexAttrib(i, t.VERTEX_ATTRIB_ARRAY_BUFFER_BINDING));
        this.A = {
            buffers: r,
            elements: t.getParameter(t.ELEMENT_ARRAY_BUFFER_BINDING),
            framebuffer: t.getParameter(t.FRAMEBUFFER_BINDING)
        }, window.DEBUGGING && (console.log(this.uid, this.A), console.log(this.uid, this.states.attributes), console.log(this.states.attributes[0].buffer === this.A.buffers[0]), console.log(this.states.attributes[1].buffer === this.A.buffers[1]), console.log(this.states.attributes[2].buffer === this.A.buffers[2]));
    }
    finish() {
        return this.i.finish();
    }
    flush() {
        return this.v(), this.i.flush();
    }
    commit() {
        return this.v(), this.i.commit();
    }
    isContextLost() {
        return this.i.isContextLost();
    }
    getFragDataLocation(t, i) {
        return this.i.getFragDataLocation(t, i);
    }
    createSampler() {
        return this.i.createSampler();
    }
    deleteSampler() {
        return this.i.deleteSampler();
    }
    bindSampler() {
        return this.i.bindSampler();
    }
    isSampler() {
        return this.i.isSampler();
    }
    getSamplerParameter() {
        return this.i.getSamplerParameter();
    }
    isQuery(t) {
        return this.i.beginQuery(t);
    }
    beginQuery(t, i) {
        return this.i.beginQuery(t, i);
    }
    deleteQuery(t) {
        return this.i.query(t);
    }
    isTransformFeedback(t) {
        return this.i.isTransformFeedback(t);
    }
    beginTransformFeedback(t) {
        return this.i.beginTransformFeedback(t);
    }
    deleteTransformFeedback(t) {
        return this.i.deleteTransformFeedback(t);
    }
    pauseTransformFeedback() {
        return this.i.pauseTransformFeedback();
    }
    resumeTransformFeedback() {
        return this.i.resumeTransformFeedback();
    }
    transformFeedbackVaryings(t, i, e) {
        return this.i.transformFeedbackVaryings(t, i, e);
    }
    bindBufferBase(t, i, e) {
        return this.i.bbindBufferBase(t, i, e);
    }
    bindBufferRange(t, i, e, r, s) {
        return this.i.bindBufferRange(t, i, e, r, s);
    }
    bindTransformFeedback(t, i) {
        return this.i.bindTransformFeedback(t, i);
    }
    fenceSync(t, i) {
        return this.i.fenceSync(t, i);
    }
    isSync(t) {
        return this.i.isSync(t);
    }
    deleteSync(t) {
        return this.i.deleteSync(t);
    }
    clientWaitSync(t, i, e) {
        return this.i.clientWaitSync(t, i, e);
    }
    waitSync(t, i, e) {
        return this.i.waitSync(t, i, e);
    }
    getSyncParameter(t, i) {
        return this.i.getSyncParameter(t, i);
    }
    getIndexedParameter(t, i) {
        return this.i.getIndexedParameter(t, i);
    }
}
$08cf2b450ce76d44$var$e($08cf2b450ce76d44$export$d29d39a0fc926565.prototype, {
    bufferData (...t) {
        return this.v(), this.i.bufferData(...t);
    },
    bufferSubData (...t) {
        return this.v(), this.i.bufferSubData(...t);
    },
    createBuffer () {
        return this.i.createBuffer();
    },
    deleteBuffer (t) {
        const i = this.states;
        i.arrayBuffer === t ? i.arrayBuffer = null : i.elementArrayBuffer === t && (i.elementArrayBuffer = null);
        const e = i.attributes;
        for(const i in e)e[i].buffer === t && (e[i].buffer = null);
        return this.i.deleteBuffer(t);
    },
    getBufferParameter (t, i) {
        return this.v(), this.i.getBufferParameter(t, i);
    },
    isBuffer (t) {
        return this.i.isBuffer(t);
    },
    copyBufferSubData (t, i, e, r, s) {
        return this.i.isBuffer(t, i, e, r, s);
    },
    readBuffer (t) {
        return this.i.readBuffer(t);
    }
}), $08cf2b450ce76d44$var$e($08cf2b450ce76d44$export$d29d39a0fc926565.prototype, {
    checkFramebufferStatus (t) {
        return this.i.checkFramebufferStatus(t);
    },
    createFramebuffer () {
        return this.i.createFramebuffer();
    },
    deleteFramebuffer (t) {
        const i = this.states.framebuffer;
        for(const e in i)i[e] === t && (i[e] = null);
        return this.i.deleteFramebuffer(t);
    },
    framebufferRenderbuffer (t, i, e, r) {
        return this.v(), this.i.framebufferRenderbuffer(t, i, e, r);
    },
    framebufferTexture2D (t, i, e, r, s) {
        return this.v(), this.i.framebufferTexture2D(t, i, e, r, s);
    },
    getFramebufferAttachmentParameter (t, i, e) {
        return this.v(), this.i.getFramebufferAttachmentParameter(t, i, e);
    },
    isFramebuffer (t) {
        return this.i.isFramebuffer(t);
    },
    readPixels (t, i, e, r, s, h, n) {
        return this.v(), this.i.readPixels(t, i, e, r, s, h, n);
    },
    blitFramebuffer (t, i, e, r, s, h, n, u, o, a) {
        return this.v(), this.i.blitFramebuffer(t, i, e, r, s, h, n, u, o, a);
    }
}), $08cf2b450ce76d44$var$e($08cf2b450ce76d44$export$d29d39a0fc926565.prototype, {
    createRenderbuffer () {
        return this.i.createRenderbuffer();
    },
    deleteRenderbuffer (t) {
        const i = this.states.renderbuffer;
        for(const e in i)i[e] === t && (i[e] = null);
        return this.i.deleteRenderbuffer(t);
    },
    getRenderbufferParameter (t, i) {
        return this.v(), this.i.getRenderbufferParameter(t, i);
    },
    isRenderbuffer (t) {
        return this.i.isRenderbuffer(t);
    },
    renderbufferStorage (t, i, e, r) {
        return this.v(), this.i.renderbufferStorage(t, i, e, r);
    },
    renderbufferStorageMultisample (t, i, e, r, s) {
        return this.v(), this.i.renderbufferStorageMultisample(t, i, e, r, s);
    }
});
const $08cf2b450ce76d44$var$u = "_fusion_context";
$08cf2b450ce76d44$var$e($08cf2b450ce76d44$export$d29d39a0fc926565.prototype, {
    scissor (t, i, e, r) {
        this.v();
        const s = this.states.scissor;
        s[0] === t && s[1] === i && s[2] === e && s[3] === r || (s[0] = t, s[1] = i, s[2] = e, s[3] = r, this.i.scissor(t, i, e, r));
    },
    viewport (t, i, e, r) {
        this.v();
        const s = this.states.viewport;
        s[0] === t && s[1] === i && s[2] === e && s[3] === r || (s[0] = t, s[1] = i, s[2] = e, s[3] = r, this.i.viewport(t, i, e, r));
    },
    blendColor (t, i, e, r) {
        this.v();
        const s = this.states.blendColor;
        s[0] === t && s[1] === i && s[2] === e && s[3] === r || (s[0] = t, s[1] = i, s[2] = e, s[3] = r, this.i.blendColor(t, i, e, r));
    },
    blendEquation (t) {
        this.v();
        const i = this.states.blendEquationSeparate;
        i[0] === t && i[1] === t || (i[0] = t, i[1] = t, this.i.blendEquation(t));
    },
    blendEquationSeparate (t, i) {
        this.v();
        const e = this.states.blendEquationSeparate;
        e[0] === t && e[1] === i || (e[0] = t, e[1] = i, this.i.blendEquationSeparate(t, i));
    },
    blendFunc (t, i) {
        this.v();
        const e = this.states.blendFuncSeparate;
        e[0] === t && e[2] === t && e[1] === i && e[3] === i || (e[0] = t, e[1] = i, e[2] = t, e[3] = i, this.i.blendFunc(t, i));
    },
    blendFuncSeparate (t, i, e, r) {
        this.v();
        const s = this.states.blendFuncSeparate;
        s[0] === t && s[1] === i && s[2] === e && s[3] === r || (s[0] = t, s[1] = i, s[2] = e, s[3] = r, this.i.blendFuncSeparate(t, i, e, r));
    },
    clearColor (t, i, e, r) {
        this.v();
        const s = this.states.clearColor;
        s[0] === t && s[1] === i && s[2] === e && s[3] === r || (s[0] = t, s[1] = i, s[2] = e, s[3] = r, this.i.clearColor(t, i, e, r));
    },
    clearDepth (t) {
        this.v();
        const i = this.states.clearDepth;
        i[0] !== t && (i[0] = t, this.i.clearDepth(t));
    },
    clearStencil (t) {
        this.v();
        const i = this.states.clearStencil;
        i[0] !== t && (i[0] = t, this.i.clearStencil(t));
    },
    colorMask (t, i, e, r) {
        this.v();
        const s = this.states.colorMask;
        s[0] === t && s[1] === i && s[2] === e && s[3] === r || (s[0] = t, s[1] = i, s[2] = e, s[3] = r, this.i.colorMask(t, i, e, r));
    },
    cullFace (t) {
        this.v();
        const i = this.states.cullFace;
        i[0] !== t && (i[0] = t, this.i.cullFace(t));
    },
    depthFunc (t) {
        this.v();
        const i = this.states.depthFunc;
        i[0] !== t && (i[0] = t, this.i.depthFunc(t));
    },
    depthMask (t) {
        this.v();
        const i = this.states.depthMask;
        i[0] !== t && (i[0] = t, this.i.depthMask(t));
    },
    depthRange (t, i) {
        this.v();
        const e = this.states.depthRange;
        e[0] === t && e[1] === i || (e[0] = t, e[1] = i, this.i.depthRange(t, i));
    },
    disable (t) {
        this.v();
        const i = this.states.capabilities;
        i[t] && (i[t] = !1, this.i.disable(t));
    },
    enable (t) {
        this.v();
        const i = this.states.capabilities;
        i[t] || (i[t] = !0, this.i.enable(t));
    },
    frontFace (t) {
        this.v();
        const i = this.states.frontFace;
        i[0] !== t && (i[0] = t, this.i.frontFace(t));
    },
    hint (t, i) {
        this.v();
        const e = this.states.hint;
        e[t][0] !== i && (e[t][0] = i, this.i.hint(t, i));
    },
    lineWidth (t) {
        this.v();
        const i = this.states.lineWidth;
        i[0] !== t && (i[0] = t, this.i.lineWidth(t));
    },
    pixelStorei (t, i) {
        this.v();
        const e = this.states.pixelStorei;
        e[t] !== i && (e[t] && (e[t][0] = i), this.i.pixelStorei(t, i));
    },
    polygonOffset (t, i) {
        this.v();
        const e = this.states.polygonOffset;
        e[0] === t && e[1] === i || (e[0] = t, e[1] = i, this.i.polygonOffset(t, i));
    },
    sampleCoverage (t, i) {
        this.v();
        const e = this.states.sampleCoverage;
        e[0] === t && e[1] === i || (e[0] = t, e[1] = i, this.i.sampleCoverage(t, i));
    },
    stencilFunc (t, i, e) {
        this.v();
        const r = this.states.stencilFuncSeparate, s = this.i;
        r[s.FRONT][0] === t && r[s.FRONT][1] === i && r[s.FRONT][2] === e && r[s.BACK][0] === t && r[s.BACK][1] === i && r[s.BACK][2] === e || (r[s.FRONT][0] = r[s.BACK][0] = t, r[s.FRONT][1] = r[s.BACK][1] = i, r[s.FRONT][2] = r[s.BACK][2] = e, this.i.stencilFunc(t, i, e));
    },
    stencilFuncSeparate (t, i, e, r) {
        this.v();
        if (t === this.i.FRONT_AND_BACK) return void this.stencilFunc(i, e, r);
        const s = this.states.stencilFuncSeparate;
        s[t][0] === i && s[t][1] === e && s[t][2] === r || (s[t][0] = i, s[t][1] = e, s[t][2] = r, this.i.stencilFuncSeparate(t, i, e, r));
    },
    stencilMask (t) {
        this.v();
        const i = this.i, e = this.states.stencilMaskSeparate;
        e[i.FRONT][0] === t && e[i.BACK][0] === t || (e[i.FRONT][0] = t, e[i.BACK][0] = t, this.i.stencilMask(t));
    },
    stencilMaskSeparate (t, i) {
        if (this.v(), t === this.i.FRONT_AND_BACK) return void this.stencilMask(i);
        const e = this.states.stencilMaskSeparate;
        e[t][0] !== i && (e[t][0] = i, this.i.stencilMaskSeparate(t, i));
    },
    stencilOp (t, i, e) {
        this.v();
        const r = this.states.stencilOpSeparate, s = this.i;
        r[s.FRONT][0] === t && r[s.FRONT][1] === i && r[s.FRONT][2] === e && r[s.BACK][0] === t && r[s.BACK][1] === i && r[s.BACK][2] === e || (r[s.FRONT][0] = r[s.BACK][0] = t, r[s.FRONT][1] = r[s.BACK][1] = i, r[s.FRONT][2] = r[s.BACK][2] = e, this.i.stencilOp(t, i, e));
    },
    stencilOpSeparate (t, i, e, r) {
        if (this.v(), t === this.i.FRONT_AND_BACK) return void this.stencilOp(i, e, r);
        const s = this.states.stencilOpSeparate;
        s[t][0] === i && s[t][1] === e && s[t][2] === r || (s[t][0] = i, s[t][1] = e, s[t][2] = r, this.i.stencilOpSeparate(t, i, e, r));
    },
    bindFramebuffer (t, i) {
        this.v();
        const e = this.states.framebuffer;
        e[t] !== i && (e[t] = i, this.i.bindFramebuffer(t, i));
    },
    bindRenderbuffer (t, i) {
        this.v();
        const e = this.states.renderbuffer;
        e[t] !== i && (e[t] = i, this.i.bindRenderbuffer(t, i));
    },
    bindTexture (t, i) {
        this.v();
        const e = this.states.textures, r = -1 !== e.active ? e.active - 33984 : -1;
        e.units[r][t] = i, this.i.bindTexture(t, i);
    },
    activeTexture (t) {
        this.v();
        const i = this.i, e = this.states.textures, r = e.active;
        e.active = t, this.activeUnit !== t && (i.activeTexture(t), this.activeUnit = t), -1 === r && (e.units[t - 33984][i.TEXTURE_2D] = e.units[-1][i.TEXTURE_2D], e.units[t - 33984][i.TEXTURE_CUBE_MAP] = e.units[-1][i.TEXTURE_CUBE_MAP], e.units[-1][i.TEXTURE_2D] = null, e.units[-1][i.TEXTURE_CUBE_MAP] = null);
    },
    useProgram (t) {
        this.v();
        const i = this.states;
        i.program !== t && (this.states.activeAttribType = 0, i.program = t, void 0 === t.fid && (t.fid = 0), this.p(), this.i.useProgram(t));
    },
    p () {
        const t = this.states.program;
        if (!t) return;
        const i = t.cachedUniforms = t.cachedUniforms || {};
        for(const t in i)Array.isArray(i[t]) ? i[t].fill(null) : i[t] = null;
    },
    bindBuffer (t, i) {
        this.v();
        const e = this.i, r = this.states;
        t === e.ELEMENT_ARRAY_BUFFER ? r.elementArrayBuffer = i : r.arrayBuffer = i, e.bindBuffer(t, i);
    },
    bindVertexArray (t) {
        this.v(), this.states.activeAttribType = 1;
        const i = this.i, e = this.states;
        e.vao !== t && (e.vao = t, this.t ? i.bindVertexArray(t) : this.vaoOES.bindVertexArrayOES(t));
    },
    vertexAttribPointer (t, i, e, r, s, h) {
        this.v(), this.states.attributes[t] || (this.states.attributes[t] = {
            enable: !0
        });
        const n = this.states.attributes[t];
        return n.buffer = this.states.arrayBuffer, n.args ? (n.args[0] = t, n.args[1] = i, n.args[2] = e, n.args[3] = r, n.args[4] = s, n.args[5] = h) : n.args = [
            t,
            i,
            e,
            r,
            s,
            h
        ], this.i.vertexAttribPointer(t, i, e, r, s, h);
    },
    vertexAttribDivisor (t, i) {
        this.v();
        return this.states.attributes[t].divisor = i, this.t ? this.i.vertexAttribDivisor(t, i) : this.angleOES.vertexAttribDivisorANGLE(t, i);
    }
}, {
    v () {
        const t = this.i;
        if (t[$08cf2b450ce76d44$var$u] !== this) {
            if (t[$08cf2b450ce76d44$var$u]) {
                const i = t[$08cf2b450ce76d44$var$u];
                this.N(i.states), t[$08cf2b450ce76d44$var$u] = this;
            } else t[$08cf2b450ce76d44$var$u] = this;
        }
    },
    N (i) {
        if (!i) return;
        delete this.activeUnit;
        const e = this.states, r = this.i;
        let s = 0;
        for(const h in e)if ("capabilities" !== h && "textures" !== h && "attributes" !== h && "arrayBuffer" !== h && "elementArrayBuffer" !== h && "vao" !== h) {
            if ("program" === h) e.program !== i.program && (r.useProgram(e.program), e.program && (s = r.getProgramParameter(e.program, r.ACTIVE_ATTRIBUTES)));
            else if ("framebuffer" === h) for(const t in e[h])e[h][t] !== i[h][t] && r.bindFramebuffer(+t, e[h][t]);
            else if ("renderbuffer" === h) for(const t in e[h])e[h][t] !== i[h][t] && r.bindRenderbuffer(+t, e[h][t]);
            else if (!(0, (/*@__PURE__*/$parcel$interopDefault($hHTrr)))(e[h], i[h])) {
                if (Array.isArray(i[h])) r[h](...e[h]);
                else if (i[h]) for(const s in e[h])(0, (/*@__PURE__*/$parcel$interopDefault($hHTrr)))(e[h][s], i[h][s]) || r[h](+s, ...e[h][s]);
            }
        }
        this.p();
        for(const t in e.capabilities)e.capabilities[t] !== i.capabilities[t] && r[e.capabilities[t] ? "enable" : "disable"](+t);
        const h = e.textures, n = i.textures, u = h.units, o = n.units, a = h.active - r.TEXTURE0;
        for(let t = 0; t < u.length; t++)t === a || u[t][r.TEXTURE_2D] === o[t][r.TEXTURE_2D] && u[t][r.TEXTURE_CUBE_MAP] === o[t][r.TEXTURE_CUBE_MAP] || (r.activeTexture(r.TEXTURE0 + t), r.bindTexture(r.TEXTURE_2D, u[t][r.TEXTURE_2D]), r.bindTexture(r.TEXTURE_CUBE_MAP, u[t][r.TEXTURE_CUBE_MAP]));
        if (h.active > -1) {
            const t = u[a];
            t[r.TEXTURE_2D] === o[a][r.TEXTURE_2D] && t[r.TEXTURE_CUBE_MAP] === o[a][r.TEXTURE_CUBE_MAP] || (r.activeTexture(h.active), r.bindTexture(r.TEXTURE_2D, t[r.TEXTURE_2D]), r.bindTexture(r.TEXTURE_CUBE_MAP, t[r.TEXTURE_CUBE_MAP]));
        }
        this.t ? r.bindVertexArray(null) : this.o && this.o.bindVertexArrayOES(null);
        const f = this.h;
        if (this.t || this.angleOES) for(let t = 0; t < f; t++)this.t ? r.vertexAttribDivisor(t, 0) : this.angleOES.vertexAttribDivisorANGLE(t, 0);
        r.bindBuffer(r.ARRAY_BUFFER, e.arrayBuffer), r.bindBuffer(r.ELEMENT_ARRAY_BUFFER, e.elementArrayBuffer), 1 === e.activeAttribType ? this.F(e, r) : this.L(e, r, s);
    },
    F (t, i) {
        const e = t.vao;
        e && (this.t ? i.bindVertexArray(e || null) : this.o && this.o.bindVertexArrayOES(e || null));
    },
    L (t, i, e) {
        const r = this.h, s = t.attributes;
        let h = 0;
        for(let t = 0; t < r; t++){
            const r = s[t];
            if (h < e && r) {
                if (r.buffer) {
                    if (i.bindBuffer(i.ARRAY_BUFFER, r.buffer), i.vertexAttribPointer(...r.args), r.divisor && (this.t ? i.vertexAttribDivisor(t, r.divisor) : this.angleOES.vertexAttribDivisorANGLE(t, r.divisor)), r.enable) {
                        i.enableVertexAttribArray(t), h++;
                        continue;
                    }
                    i.disableVertexAttribArray(t);
                }
                i.disableVertexAttribArray(t);
            } else i.disableVertexAttribArray(t);
        }
    }
}), $08cf2b450ce76d44$var$e($08cf2b450ce76d44$export$d29d39a0fc926565.prototype, {
    compressedTexImage2D (t, i, e, r, s, h, n) {
        return this.v(), this.i.compressedTexImage2D(t, i, e, r, s, h, n);
    },
    copyTexImage2D (t, i, e, r, s, h, n, u) {
        return this.v(), this.i.copyTexImage2D(t, i, e, r, s, h, n, u);
    },
    copyTexSubImage2D (t, i, e, r, s, h, n, u) {
        return this.v(), this.i.copyTexSubImage2D(t, i, e, r, s, h, n, u);
    },
    createTexture () {
        return this.i.createTexture();
    },
    deleteTexture (t) {
        const i = this.states.textures.units;
        for(let e = 0; e < i.length; e++)for(const r in i[e])i[e][r] === t && (i[e][r] = null);
        return this.i.deleteTexture(t);
    },
    generateMipmap (t) {
        return this.v(), this.i.generateMipmap(t);
    },
    getTexParameter (t, i) {
        return this.v(), this.i.getTexParameter(t, i);
    },
    isTexture (t) {
        return this.i.isTexture(t);
    },
    texImage2D (...t) {
        if (this.v(), this.t) {
            const i = t[t.length - 2], e = $08cf2b450ce76d44$var$h.getInternalFormat(this.i, t[2], i);
            e !== t[2] && (t[2] = e);
            const r = $08cf2b450ce76d44$var$h.getTextureType(this.i, i);
            r !== i && (t[t.length - 2] = r);
        }
        return this.i.texImage2D(...t);
    },
    texSubImage2D (...t) {
        if (this.v(), this.t) {
            const i = t[t.length - 2], e = $08cf2b450ce76d44$var$h.getTextureType(this.i, i);
            e !== i && (t[t.length - 2] = e);
        }
        return this.i.texSubImage2D(...t);
    },
    texParameterf (t, i, e) {
        return this.v(), this.i.texParameterf(t, i, e);
    },
    texParameteri (t, i, e) {
        return this.v(), this.i.texParameteri(t, i, e);
    },
    texStorage2D (t, i, e, r, s) {
        return this.v(), this.i.texStorage2D(t, i, e, r, s);
    },
    texImage3D (t, i, e, r, s, h, n, u, o, a) {
        return this.v(), this.i.texImage3D(t, i, e, r, s, h, n, u, o, a);
    },
    texStorage3D (t, i, e, r, s, h) {
        return this.v(), this.i.texStorage3D(t, i, e, r, s, h);
    },
    texSubImage3D (t, i, e, r, s, h, n, u, o, a, f) {
        return this.v(), this.i.texSubImage3D(t, i, e, r, s, h, n, u, o, a, f);
    },
    copyTexSubImage3D (t, i, e, r, s, h, n, u, o) {
        return this.v(), this.i.copyTexSubImage3D(t, i, e, r, s, h, n, u, o);
    },
    compressedTexSubImage3D (t, i, e, r, s, h, n, u, o, a, f) {
        return this.v(), this.i.compressedTexSubImage3D(t, i, e, r, s, h, n, u, o, a, f);
    }
});
const $08cf2b450ce76d44$var$o = [];
function $08cf2b450ce76d44$var$a(t, i) {
    const e = i.length;
    for(let r = 0; r < e; r++)t[r] = i[r];
    return t;
}
$08cf2b450ce76d44$var$e($08cf2b450ce76d44$export$d29d39a0fc926565.prototype, {
    bindAttribLocation (t, i, e) {
        return this.i.bindAttribLocation(t, i, e);
    },
    enableVertexAttribArray (t) {
        return this.v(), this.states.attributes[t] || (this.states.attributes[t] = {}), this.states.attributes[t].enable = !0, this.i.enableVertexAttribArray(t);
    },
    disableVertexAttribArray (t) {
        return this.v(), this.states.attributes[t] || (this.states.attributes[t] = {}), this.states.attributes[t].enable = !1, this.i.disableVertexAttribArray(t);
    },
    getActiveAttrib (t, i) {
        return this.i.getActiveAttrib(t, i);
    },
    getActiveUniform (t, i) {
        return this.i.getActiveUniform(t, i);
    },
    getAttribLocation (t, i) {
        return this.i.getAttribLocation(t, i);
    },
    getUniformLocation (t, i) {
        return this.i.getUniformLocation(t, i);
    },
    getVertexAttrib (t, i) {
        return this.v(), this.i.getVertexAttrib(t, i);
    },
    getVertexAttribOffset (t, i) {
        return this.v(), this.i.getVertexAttribOffset(t, i);
    },
    uniformBlockBinding (t, i, e) {
        return this.v(), this.i.uniformBlockBinding(t, i, e);
    },
    B (t, ...i) {
        const e = this.states.program;
        if (!e) return !1;
        let r = t.fid;
        void 0 === r && (r = t.fid = e.fid++);
        const s = e.cachedUniforms[r];
        return !!function(t, i) {
            if (!t) return !1;
            const e = i.length;
            for(let r = 0; r < e; r++)if (t[r] && void 0 !== t[r].length) {
                const e = t[r].length;
                for(let s = 0; s < e; s++)if (t[r][s] !== i[r][s]) return !1;
            } else if (t[r] !== i[r]) return !1;
            return !0;
        }(s, i) || (e.cachedUniforms[r] = function(t, i) {
            t = t || new Array(i.length);
            const e = i.length;
            for(let r = 0; r < e; r++)t[r] = void 0 !== i[r].length ? $08cf2b450ce76d44$var$a(t[r] || [], i[r]) : i[r];
            return t;
        }(s, i), !1);
    },
    uniformMatrix2fv (t, i, e) {
        this.B(t, i, e) || (this.v(), this.i.uniformMatrix2fv(t, i, e));
    },
    uniformMatrix3fv (t, i, e) {
        this.B(t, i, e) || (this.v(), this.i.uniformMatrix3fv(t, i, e));
    },
    uniformMatrix4fv (t, i, e) {
        t ? (e = this.C(e), this.B(t, i, e) || this.i.uniformMatrix4fv(t, i, e)) : console.warn("UniformLocation invalid, null value encountered in browser:", navigator.userAgent);
    },
    C: (t)=>t ? ($08cf2b450ce76d44$var$o[0] = isNaN(t[0]) ? -1000000000000000000000000000000 : t[0], $08cf2b450ce76d44$var$o[1] = isNaN(t[1]) ? -1000000000000000000000000000000 : t[1], $08cf2b450ce76d44$var$o[2] = isNaN(t[2]) ? -1000000000000000000000000000000 : t[2], $08cf2b450ce76d44$var$o[3] = isNaN(t[3]) ? -1000000000000000000000000000000 : t[3], $08cf2b450ce76d44$var$o[4] = isNaN(t[4]) ? -1000000000000000000000000000000 : t[4], $08cf2b450ce76d44$var$o[5] = isNaN(t[5]) ? -1000000000000000000000000000000 : t[5], $08cf2b450ce76d44$var$o[6] = isNaN(t[6]) ? -1000000000000000000000000000000 : t[6], $08cf2b450ce76d44$var$o[7] = isNaN(t[7]) ? -1000000000000000000000000000000 : t[7], $08cf2b450ce76d44$var$o[8] = isNaN(t[8]) ? -1000000000000000000000000000000 : t[8], $08cf2b450ce76d44$var$o[9] = isNaN(t[9]) ? -1000000000000000000000000000000 : t[9], $08cf2b450ce76d44$var$o[10] = isNaN(t[10]) ? -1000000000000000000000000000000 : t[10], $08cf2b450ce76d44$var$o[11] = isNaN(t[11]) ? -1000000000000000000000000000000 : t[11], $08cf2b450ce76d44$var$o[12] = isNaN(t[12]) ? -1000000000000000000000000000000 : t[12], $08cf2b450ce76d44$var$o[13] = isNaN(t[13]) ? -1000000000000000000000000000000 : t[13], $08cf2b450ce76d44$var$o[14] = isNaN(t[14]) ? -1000000000000000000000000000000 : t[14], $08cf2b450ce76d44$var$o[15] = isNaN(t[15]) ? -1000000000000000000000000000000 : t[15], $08cf2b450ce76d44$var$o) : t,
    uniform1f (t, i) {
        return this.v(), this.i.uniform1f(t, i);
    },
    uniform1i (t, i) {
        return this.v(), this.i.uniform1i(t, i);
    },
    uniform2f (t, i, e) {
        return this.v(), this.i.uniform2f(t, i, e);
    },
    uniform2i (t, i, e) {
        return this.v(), this.i.uniform2i(t, i, e);
    },
    uniform3f (t, i, e, r) {
        return this.v(), this.i.uniform3f(t, i, e, r);
    },
    uniform3i (t, i, e, r) {
        return this.v(), this.i.uniform3i(t, i, e, r);
    },
    uniform4f (t, i, e, r, s) {
        return this.v(), this.i.uniform4f(t, i, e, r, s);
    },
    uniform4i (t, i, e, r, s) {
        return this.v(), this.i.uniform4i(t, i, e, r, s);
    },
    uniform1ui (t, i) {
        return this.v(), this.i.uniform1ui(t, i);
    },
    uniform2ui (t, i, e) {
        return this.v(), this.i.uniform2ui(t, i, e);
    },
    uniform3ui (t, i, e, r) {
        return this.v(), this.i.uniform3ui(t, i, e, r);
    },
    uniform4ui (t, i, e, r, s) {
        return this.v(), this.i.uniform4ui(t, i, e, r, s);
    },
    uniform1fv (t, i, e, r) {
        this.v(), void 0 !== r ? this.i.uniform1fv(t, i, e, r) : void 0 !== e ? this.i.uniform1fv(t, i, e) : this.i.uniform1fv(t, i);
    },
    uniform2fv (t, i, e, r) {
        this.v(), void 0 !== r ? this.i.uniform2fv(t, i, e, r) : void 0 !== e ? this.i.uniform2fv(t, i, e) : this.i.uniform2fv(t, i);
    },
    uniform3fv (t, i, e, r) {
        this.v(), void 0 !== r ? this.i.uniform3fv(t, i, e, r) : void 0 !== e ? this.i.uniform3fv(t, i, e) : this.i.uniform3fv(t, i);
    },
    uniform4fv (t, i, e, r) {
        this.v(), void 0 !== r ? this.i.uniform4fv(t, i, e, r) : void 0 !== e ? this.i.uniform4fv(t, i, e) : this.i.uniform4fv(t, i);
    },
    uniform1iv (t, i, e, r) {
        this.v(), void 0 !== r ? this.i.uniform1iv(t, i, e, r) : void 0 !== e ? this.i.uniform1iv(t, i, e) : this.i.uniform1iv(t, i);
    },
    uniform2iv (t, i, e, r) {
        this.v(), void 0 !== r ? this.i.uniform2iv(t, i, e, r) : void 0 !== e ? this.i.uniform2iv(t, i, e) : this.i.uniform2iv(t, i);
    },
    uniform3iv (t, i, e, r) {
        this.v(), void 0 !== r ? this.i.uniform3iv(t, i, e, r) : void 0 !== e ? this.i.uniform3iv(t, i, e) : this.i.uniform3iv(t, i);
    },
    uniform4iv (t, i, e, r) {
        this.v(), void 0 !== r ? this.i.uniform4iv(t, i, e, r) : void 0 !== e ? this.i.uniform4iv(t, i, e) : this.i.uniform4iv(t, i);
    },
    uniform1uiv (t, i, e, r) {
        this.v(), void 0 !== r ? this.i.uniform1uiv(t, i, e, r) : void 0 !== e ? this.i.uniform1uiv(t, i, e) : this.i.uniform1uiv(t, i);
    },
    uniform2uiv (t, i, e, r) {
        this.v(), void 0 !== r ? this.i.uniform2uiv(t, i, e, r) : void 0 !== e ? this.i.uniform2uiv(t, i, e) : this.i.uniform2uiv(t, i);
    },
    uniform3uiv (t, i, e, r) {
        this.v(), void 0 !== r ? this.i.uniform3uiv(t, i, e, r) : void 0 !== e ? this.i.uniform3uiv(t, i, e) : this.i.uniform3uiv(t, i);
    },
    uniform4uiv (t, i, e, r) {
        this.v(), void 0 !== r ? this.i.uniform4uiv(t, i, e, r) : void 0 !== e ? this.i.uniform4uiv(t, i, e) : this.i.uniform4uiv(t, i);
    },
    vertexAttrib1f (t, i) {
        return this.v(), this.i.vertexAttrib1f(t, i);
    },
    vertexAttrib2f (t, i, e) {
        return this.v(), this.i.vertexAttrib2f(t, i, e);
    },
    vertexAttrib3f (t, i, e, r) {
        return this.v(), this.i.vertexAttrib3f(t, i, e, r);
    },
    vertexAttrib4f (t, i, e, r, s) {
        return this.v(), this.i.vertexAttrib4f(t, i, e, r, s);
    },
    vertexAttrib1fv (t, i) {
        return this.v(), this.i.vertexAttrib1fv(t, i);
    },
    vertexAttrib2fv (t, i) {
        return this.v(), this.i.vertexAttrib2fv(t, i);
    },
    vertexAttrib3fv (t, i) {
        return this.v(), this.i.vertexAttrib3fv(t, i);
    },
    vertexAttrib4fv (t, i) {
        return this.v(), this.i.vertexAttrib4fv(t, i);
    },
    vertexAttribI4i (t, i, e, r, s) {
        return this.v(), this.i.vertexAttribI4i(t, i, e, r, s);
    },
    vertexAttribI4ui (t, i, e, r, s) {
        return this.v(), this.i.vertexAttribI4ui(t, i, e, r, s);
    },
    vertexAttribI4iv (t, i) {
        return this.v(), this.i.vertexAttribI4iv(t, i);
    },
    vertexAttribI4uiv (t, i) {
        return this.v(), this.i.vertexAttribI4uiv(t, i);
    }
}), $08cf2b450ce76d44$var$e($08cf2b450ce76d44$export$d29d39a0fc926565.prototype, {
    createVertexArray () {
        return this.t ? this.i.createVertexArray() : this.vaoOES.createVertexArrayOES();
    },
    deleteVertexArray (t) {
        const i = this.states;
        return i.vao === t && (i.vao = null), this.t ? this.i.deleteVertexArray(t) : this.vaoOES.deleteVertexArrayOES(t);
    },
    isVertexArray (t) {
        return this.t ? this.i.isVertexArray(t) : this.vaoOES.isVertexArrayOES(t);
    }
}), $08cf2b450ce76d44$var$e($08cf2b450ce76d44$export$d29d39a0fc926565.prototype, {
    drawArraysInstanced (t, i, e, r) {
        return this.v(), this._(), this.t ? this.i.drawArraysInstanced(t, i, e, r) : this.angleOES.drawArraysInstancedANGLE(t, i, e, r);
    },
    drawElementsInstanced (t, i, e, r, s) {
        return this.v(), this._(), this.t ? this.i.drawElementsInstanced(t, i, e, r, s) : this.angleOES.drawElementsInstancedANGLE(t, i, e, r, s);
    }
});

});
parcelRegister("hHTrr", function(module, exports) {
'use strict';
var $ce41755b60e9e9a1$var$isArray = Array.isArray;
var $ce41755b60e9e9a1$var$keyList = Object.keys;
var $ce41755b60e9e9a1$var$hasProp = Object.prototype.hasOwnProperty;
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        var arrA = $ce41755b60e9e9a1$var$isArray(a), arrB = $ce41755b60e9e9a1$var$isArray(b), i, length, key;
        if (arrA && arrB) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (arrA != arrB) return false;
        var dateA = a instanceof Date, dateB = b instanceof Date;
        if (dateA != dateB) return false;
        if (dateA && dateB) return a.getTime() == b.getTime();
        var regexpA = a instanceof RegExp, regexpB = b instanceof RegExp;
        if (regexpA != regexpB) return false;
        if (regexpA && regexpB) return a.toString() == b.toString();
        var keys = $ce41755b60e9e9a1$var$keyList(a);
        length = keys.length;
        if (length !== $ce41755b60e9e9a1$var$keyList(b).length) return false;
        for(i = length; i-- !== 0;)if (!$ce41755b60e9e9a1$var$hasProp.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
};

});



var $4cd7bf4c93975fb1$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"izUj7\",\"diapason.04cb2868.js\",\"i2mrA\",\"diapason_cover.117f195f.jpg\",\"dfJlt\",\"BOOM_DIAPASON_Pick-up a manico.39ea2f1b.jpg\",\"dzaw5\",\"BOOM_DIAPASON_Ponte.94a2e26b.jpg\",\"1CIoy\",\"BOOM_DIAPASON_Tastiera.0570cef4.jpg\",\"RpMki\",\"ROAR_TRETRECINQUE_principlale.c6469240.jpg\",\"iR9kf\",\"ROAR_TRETRECINQUE_Segnatasti.666f9072.jpg\",\"bVqGn\",\"ROAR_TRETRECINQUE_Pick up.6d7b9472.jpg\",\"ilvCG\",\"ROAR_TRETRECINQUE_Ponte.32492f02.jpg\",\"74WNe\",\"ROAR_VENERE_principale.b5b22d6c.jpg\",\"gQzQa\",\"ROAR VENERE_Ponte.4b59f31c.jpg\",\"ghlwP\",\"ROAR_VENERE_Pickup.4589e534.jpg\",\"cRsNx\",\"ROAR_VENERE_Segnatasti.e8a7ed58.jpg\",\"cnfZn\",\"SLURP_MONO_principale.0334f7c2.jpg\",\"1Xbq4\",\"SLURP_MONO_pickup.6bface3f.jpg\",\"j0gIj\",\"SLURP_MONO_Manico.3310c735.jpg\",\"gMqUy\",\"SLURP_MONO_Marchio.b1633f1a.jpg\",\"jiSSI\",\"SLURP_PINDERBASS_principale.99b5c778.jpg\",\"9BB2M\",\"SLURP_PINDERBASS_Ponte.c9883e99.jpg\",\"4hyVp\",\"SLURP_PINDERBASS_legni.8363dff6.jpg\",\"27EPG\",\"SLURP_PINDERBASS_Equalizzazione.b7063c7b.jpg\",\"CmUIG\",\"WOW_KLEIN_principale.3eec29cf.jpg\",\"dxcot\",\"WOW_KLEIN_Pickup.4f17e2a6.jpg\",\"bB8wF\",\"WOW_KLEIN_Ponte.fa600748.jpg\",\"5HAs2\",\"WOW_KLEIN_Meccaniche e marchio.caf023bb.jpg\",\"laSA1\",\"ROAR_SPRING_principale.5ddd21df.jpg\",\"d0s22\",\"Meccaniche.c175c0ba.jpg\",\"4sM8H\",\"Tailpiece.1a5da196.jpg\",\"j2XL8\",\"Legni.6668b4b6.jpg\",\"5du26\",\"SLURP_FELIPE_Principale.beb388c2.jpg\",\"dqChr\",\"Manico.854d2e80.jpg\",\"9Yuj0\",\"Nome.9c673b76.jpg\",\"bHM2G\",\"Pickup ponte.6b975c63.jpg\",\"0Hdg5\",\"BOOM_MONOBLOCCO_principale.415211b7.jpg\",\"b0aKf\",\"BOOM_MONOBLOCCO_Ponte.f094e07a.jpg\",\"ihzqR\",\"BOOM_MONOBLOCCO_Giunzione manico.87efef98.jpg\",\"7FAiq\",\"BOOM_MONOBLOCCO_Legni.00fd1a7d.jpg\"]"));


var $2Tywo = parcelRequire("2Tywo");
/*!
 * CSSPlugin 3.12.5
 * https://gsap.com
 *
 * Copyright 2008-2024, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ 
var $2Tywo = parcelRequire("2Tywo");
var $0cdfc2eaac330c87$var$_win, $0cdfc2eaac330c87$var$_doc, $0cdfc2eaac330c87$var$_docElement, $0cdfc2eaac330c87$var$_pluginInitted, $0cdfc2eaac330c87$var$_tempDiv, $0cdfc2eaac330c87$var$_tempDivStyler, $0cdfc2eaac330c87$var$_recentSetterPlugin, $0cdfc2eaac330c87$var$_reverting, $0cdfc2eaac330c87$var$_windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, $0cdfc2eaac330c87$var$_transformProps = {}, $0cdfc2eaac330c87$var$_RAD2DEG = 180 / Math.PI, $0cdfc2eaac330c87$var$_DEG2RAD = Math.PI / 180, $0cdfc2eaac330c87$var$_atan2 = Math.atan2, $0cdfc2eaac330c87$var$_bigNum = 1e8, $0cdfc2eaac330c87$var$_capsExp = /([A-Z])/g, $0cdfc2eaac330c87$var$_horizontalExp = /(left|right|width|margin|padding|x)/i, $0cdfc2eaac330c87$var$_complexExp = /[\s,\(]\S/, $0cdfc2eaac330c87$var$_propertyAliases = {
    autoAlpha: "opacity,visibility",
    scale: "scaleX,scaleY",
    alpha: "opacity"
}, $0cdfc2eaac330c87$var$_renderCSSProp = function _renderCSSProp(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
}, $0cdfc2eaac330c87$var$_renderPropWithEnd = function _renderPropWithEnd(ratio, data) {
    return data.set(data.t, data.p, ratio === 1 ? data.e : Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
}, $0cdfc2eaac330c87$var$_renderCSSPropWithBeginning = function _renderCSSPropWithBeginning(ratio, data) {
    return data.set(data.t, data.p, ratio ? Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u : data.b, data);
}, //if units change, we need a way to render the original unit/value when the tween goes all the way back to the beginning (ratio:0)
$0cdfc2eaac330c87$var$_renderRoundedCSSProp = function _renderRoundedCSSProp(ratio, data) {
    var value = data.s + data.c * ratio;
    data.set(data.t, data.p, ~~(value + (value < 0 ? -0.5 : .5)) + data.u, data);
}, $0cdfc2eaac330c87$var$_renderNonTweeningValue = function _renderNonTweeningValue(ratio, data) {
    return data.set(data.t, data.p, ratio ? data.e : data.b, data);
}, $0cdfc2eaac330c87$var$_renderNonTweeningValueOnlyAtEnd = function _renderNonTweeningValueOnlyAtEnd(ratio, data) {
    return data.set(data.t, data.p, ratio !== 1 ? data.b : data.e, data);
}, $0cdfc2eaac330c87$var$_setterCSSStyle = function _setterCSSStyle(target, property, value) {
    return target.style[property] = value;
}, $0cdfc2eaac330c87$var$_setterCSSProp = function _setterCSSProp(target, property, value) {
    return target.style.setProperty(property, value);
}, $0cdfc2eaac330c87$var$_setterTransform = function _setterTransform(target, property, value) {
    return target._gsap[property] = value;
}, $0cdfc2eaac330c87$var$_setterScale = function _setterScale(target, property, value) {
    return target._gsap.scaleX = target._gsap.scaleY = value;
}, $0cdfc2eaac330c87$var$_setterScaleWithRender = function _setterScaleWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache.scaleX = cache.scaleY = value;
    cache.renderTransform(ratio, cache);
}, $0cdfc2eaac330c87$var$_setterTransformWithRender = function _setterTransformWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache[property] = value;
    cache.renderTransform(ratio, cache);
}, $0cdfc2eaac330c87$var$_transformProp = "transform", $0cdfc2eaac330c87$var$_transformOriginProp = $0cdfc2eaac330c87$var$_transformProp + "Origin", $0cdfc2eaac330c87$var$_saveStyle = function _saveStyle(property, isNotCSS) {
    var _this = this;
    var target = this.target, style = target.style, cache = target._gsap;
    if (property in $0cdfc2eaac330c87$var$_transformProps && style) {
        this.tfm = this.tfm || {};
        if (property !== "transform") {
            property = $0cdfc2eaac330c87$var$_propertyAliases[property] || property;
            ~property.indexOf(",") ? property.split(",").forEach(function(a) {
                return _this.tfm[a] = $0cdfc2eaac330c87$var$_get(target, a);
            }) : this.tfm[property] = cache.x ? cache[property] : $0cdfc2eaac330c87$var$_get(target, property); // note: scale would map to "scaleX,scaleY", thus we loop and apply them both.
            property === $0cdfc2eaac330c87$var$_transformOriginProp && (this.tfm.zOrigin = cache.zOrigin);
        } else return $0cdfc2eaac330c87$var$_propertyAliases.transform.split(",").forEach(function(p) {
            return _saveStyle.call(_this, p, isNotCSS);
        });
        if (this.props.indexOf($0cdfc2eaac330c87$var$_transformProp) >= 0) return;
        if (cache.svg) {
            this.svgo = target.getAttribute("data-svg-origin");
            this.props.push($0cdfc2eaac330c87$var$_transformOriginProp, isNotCSS, "");
        }
        property = $0cdfc2eaac330c87$var$_transformProp;
    }
    (style || isNotCSS) && this.props.push(property, isNotCSS, style[property]);
}, $0cdfc2eaac330c87$var$_removeIndependentTransforms = function _removeIndependentTransforms(style) {
    if (style.translate) {
        style.removeProperty("translate");
        style.removeProperty("scale");
        style.removeProperty("rotate");
    }
}, $0cdfc2eaac330c87$var$_revertStyle = function _revertStyle() {
    var props = this.props, target = this.target, style = target.style, cache = target._gsap, i, p;
    for(i = 0; i < props.length; i += 3)// stored like this: property, isNotCSS, value
    props[i + 1] ? target[props[i]] = props[i + 2] : props[i + 2] ? style[props[i]] = props[i + 2] : style.removeProperty(props[i].substr(0, 2) === "--" ? props[i] : props[i].replace($0cdfc2eaac330c87$var$_capsExp, "-$1").toLowerCase());
    if (this.tfm) {
        for(p in this.tfm)cache[p] = this.tfm[p];
        if (cache.svg) {
            cache.renderTransform();
            target.setAttribute("data-svg-origin", this.svgo || "");
        }
        i = $0cdfc2eaac330c87$var$_reverting();
        if ((!i || !i.isStart) && !style[$0cdfc2eaac330c87$var$_transformProp]) {
            $0cdfc2eaac330c87$var$_removeIndependentTransforms(style);
            if (cache.zOrigin && style[$0cdfc2eaac330c87$var$_transformOriginProp]) {
                style[$0cdfc2eaac330c87$var$_transformOriginProp] += " " + cache.zOrigin + "px"; // since we're uncaching, we must put the zOrigin back into the transformOrigin so that we can pull it out accurately when we parse again. Otherwise, we'd lose the z portion of the origin since we extract it to protect from Safari bugs.
                cache.zOrigin = 0;
                cache.renderTransform();
            }
            cache.uncache = 1; // if it's a startAt that's being reverted in the _initTween() of the core, we don't need to uncache transforms. This is purely a performance optimization.
        }
    }
}, $0cdfc2eaac330c87$var$_getStyleSaver = function _getStyleSaver(target, properties) {
    var saver = {
        target: target,
        props: [],
        revert: $0cdfc2eaac330c87$var$_revertStyle,
        save: $0cdfc2eaac330c87$var$_saveStyle
    };
    target._gsap || (0, $2Tywo.gsap).core.getCache(target); // just make sure there's a _gsap cache defined because we read from it in _saveStyle() and it's more efficient to just check it here once.
    properties && properties.split(",").forEach(function(p) {
        return saver.save(p);
    });
    return saver;
}, $0cdfc2eaac330c87$var$_supports3D, $0cdfc2eaac330c87$export$a232bb0480ae674a = function _createElement(type, ns) {
    var e = $0cdfc2eaac330c87$var$_doc.createElementNS ? $0cdfc2eaac330c87$var$_doc.createElementNS((ns || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), type) : $0cdfc2eaac330c87$var$_doc.createElement(type); //some servers swap in https for http in the namespace which can break things, making "style" inaccessible.
    return e && e.style ? e : $0cdfc2eaac330c87$var$_doc.createElement(type); //some environments won't allow access to the element's style when created with a namespace in which case we default to the standard createElement() to work around the issue. Also note that when GSAP is embedded directly inside an SVG file, createElement() won't allow access to the style object in Firefox (see https://gsap.com/forums/topic/20215-problem-using-tweenmax-in-standalone-self-containing-svg-file-err-cannot-set-property-csstext-of-undefined/).
}, $0cdfc2eaac330c87$var$_getComputedProperty = function _getComputedProperty(target, property, skipPrefixFallback) {
    var cs = getComputedStyle(target);
    return cs[property] || cs.getPropertyValue(property.replace($0cdfc2eaac330c87$var$_capsExp, "-$1").toLowerCase()) || cs.getPropertyValue(property) || !skipPrefixFallback && _getComputedProperty(target, $0cdfc2eaac330c87$export$8cbef5dd49a09c8b(property) || property, 1) || ""; //css variables may not need caps swapped out for dashes and lowercase.
}, $0cdfc2eaac330c87$var$_prefixes = "O,Moz,ms,Ms,Webkit".split(","), $0cdfc2eaac330c87$export$8cbef5dd49a09c8b = function _checkPropPrefix(property, element, preferPrefix) {
    var e = element || $0cdfc2eaac330c87$var$_tempDiv, s = e.style, i = 5;
    if (property in s && !preferPrefix) return property;
    property = property.charAt(0).toUpperCase() + property.substr(1);
    while(i-- && !($0cdfc2eaac330c87$var$_prefixes[i] + property in s));
    return i < 0 ? null : (i === 3 ? "ms" : i >= 0 ? $0cdfc2eaac330c87$var$_prefixes[i] : "") + property;
}, $0cdfc2eaac330c87$var$_initCore = function _initCore() {
    if ($0cdfc2eaac330c87$var$_windowExists() && window.document) {
        $0cdfc2eaac330c87$var$_win = window;
        $0cdfc2eaac330c87$var$_doc = $0cdfc2eaac330c87$var$_win.document;
        $0cdfc2eaac330c87$var$_docElement = $0cdfc2eaac330c87$var$_doc.documentElement;
        $0cdfc2eaac330c87$var$_tempDiv = $0cdfc2eaac330c87$export$a232bb0480ae674a("div") || {
            style: {}
        };
        $0cdfc2eaac330c87$var$_tempDivStyler = $0cdfc2eaac330c87$export$a232bb0480ae674a("div");
        $0cdfc2eaac330c87$var$_transformProp = $0cdfc2eaac330c87$export$8cbef5dd49a09c8b($0cdfc2eaac330c87$var$_transformProp);
        $0cdfc2eaac330c87$var$_transformOriginProp = $0cdfc2eaac330c87$var$_transformProp + "Origin";
        $0cdfc2eaac330c87$var$_tempDiv.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0"; //make sure to override certain properties that may contaminate measurements, in case the user has overreaching style sheets.
        $0cdfc2eaac330c87$var$_supports3D = !!$0cdfc2eaac330c87$export$8cbef5dd49a09c8b("perspective");
        $0cdfc2eaac330c87$var$_reverting = (0, $2Tywo.gsap).core.reverting;
        $0cdfc2eaac330c87$var$_pluginInitted = 1;
    }
}, $0cdfc2eaac330c87$var$_getBBoxHack = function _getBBoxHack(swapIfPossible) {
    //works around issues in some browsers (like Firefox) that don't correctly report getBBox() on SVG elements inside a <defs> element and/or <mask>. We try creating an SVG, adding it to the documentElement and toss the element in there so that it's definitely part of the rendering tree, then grab the bbox and if it works, we actually swap out the original getBBox() method for our own that does these extra steps whenever getBBox is needed. This helps ensure that performance is optimal (only do all these extra steps when absolutely necessary...most elements don't need it).
    var svg = $0cdfc2eaac330c87$export$a232bb0480ae674a("svg", this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns") || "http://www.w3.org/2000/svg"), oldParent = this.parentNode, oldSibling = this.nextSibling, oldCSS = this.style.cssText, bbox;
    $0cdfc2eaac330c87$var$_docElement.appendChild(svg);
    svg.appendChild(this);
    this.style.display = "block";
    if (swapIfPossible) try {
        bbox = this.getBBox();
        this._gsapBBox = this.getBBox; //store the original
        this.getBBox = _getBBoxHack;
    } catch (e) {}
    else if (this._gsapBBox) bbox = this._gsapBBox();
    if (oldParent) {
        if (oldSibling) oldParent.insertBefore(this, oldSibling);
        else oldParent.appendChild(this);
    }
    $0cdfc2eaac330c87$var$_docElement.removeChild(svg);
    this.style.cssText = oldCSS;
    return bbox;
}, $0cdfc2eaac330c87$var$_getAttributeFallbacks = function _getAttributeFallbacks(target, attributesArray) {
    var i = attributesArray.length;
    while(i--){
        if (target.hasAttribute(attributesArray[i])) return target.getAttribute(attributesArray[i]);
    }
}, $0cdfc2eaac330c87$export$41bc7c2d1e04f11b = function _getBBox(target) {
    var bounds;
    try {
        bounds = target.getBBox(); //Firefox throws errors if you try calling getBBox() on an SVG element that's not rendered (like in a <symbol> or <defs>). https://bugzilla.mozilla.org/show_bug.cgi?id=612118
    } catch (error) {
        bounds = $0cdfc2eaac330c87$var$_getBBoxHack.call(target, true);
    }
    bounds && (bounds.width || bounds.height) || target.getBBox === $0cdfc2eaac330c87$var$_getBBoxHack || (bounds = $0cdfc2eaac330c87$var$_getBBoxHack.call(target, true)); //some browsers (like Firefox) misreport the bounds if the element has zero width and height (it just assumes it's at x:0, y:0), thus we need to manually grab the position in that case.
    return bounds && !bounds.width && !bounds.x && !bounds.y ? {
        x: +$0cdfc2eaac330c87$var$_getAttributeFallbacks(target, [
            "x",
            "cx",
            "x1"
        ]) || 0,
        y: +$0cdfc2eaac330c87$var$_getAttributeFallbacks(target, [
            "y",
            "cy",
            "y1"
        ]) || 0,
        width: 0,
        height: 0
    } : bounds;
}, $0cdfc2eaac330c87$var$_isSVG = function _isSVG(e) {
    return !!(e.getCTM && (!e.parentNode || e.ownerSVGElement) && $0cdfc2eaac330c87$export$41bc7c2d1e04f11b(e));
}, //reports if the element is an SVG on which getBBox() actually works
$0cdfc2eaac330c87$var$_removeProperty = function _removeProperty(target, property) {
    if (property) {
        var style = target.style, first2Chars;
        if (property in $0cdfc2eaac330c87$var$_transformProps && property !== $0cdfc2eaac330c87$var$_transformOriginProp) property = $0cdfc2eaac330c87$var$_transformProp;
        if (style.removeProperty) {
            first2Chars = property.substr(0, 2);
            if (first2Chars === "ms" || property.substr(0, 6) === "webkit") //Microsoft and some Webkit browsers don't conform to the standard of capitalizing the first prefix character, so we adjust so that when we prefix the caps with a dash, it's correct (otherwise it'd be "ms-transform" instead of "-ms-transform" for IE9, for example)
            property = "-" + property;
            style.removeProperty(first2Chars === "--" ? property : property.replace($0cdfc2eaac330c87$var$_capsExp, "-$1").toLowerCase());
        } else //note: old versions of IE use "removeAttribute()" instead of "removeProperty()"
        style.removeAttribute(property);
    }
}, $0cdfc2eaac330c87$var$_addNonTweeningPT = function _addNonTweeningPT(plugin, target, property, beginning, end, onlySetAtEnd) {
    var pt = new (0, $2Tywo.PropTween)(plugin._pt, target, property, 0, 1, onlySetAtEnd ? $0cdfc2eaac330c87$var$_renderNonTweeningValueOnlyAtEnd : $0cdfc2eaac330c87$var$_renderNonTweeningValue);
    plugin._pt = pt;
    pt.b = beginning;
    pt.e = end;
    plugin._props.push(property);
    return pt;
}, $0cdfc2eaac330c87$var$_nonConvertibleUnits = {
    deg: 1,
    rad: 1,
    turn: 1
}, $0cdfc2eaac330c87$var$_nonStandardLayouts = {
    grid: 1,
    flex: 1
}, //takes a single value like 20px and converts it to the unit specified, like "%", returning only the numeric amount.
$0cdfc2eaac330c87$var$_convertToUnit = function _convertToUnit(target, property, value, unit) {
    var curValue = parseFloat(value) || 0, curUnit = (value + "").trim().substr((curValue + "").length) || "px", // some browsers leave extra whitespace at the beginning of CSS variables, hence the need to trim()
    style = $0cdfc2eaac330c87$var$_tempDiv.style, horizontal = $0cdfc2eaac330c87$var$_horizontalExp.test(property), isRootSVG = target.tagName.toLowerCase() === "svg", measureProperty = (isRootSVG ? "client" : "offset") + (horizontal ? "Width" : "Height"), amount = 100, toPixels = unit === "px", toPercent = unit === "%", px, parent, cache, isSVG;
    if (unit === curUnit || !curValue || $0cdfc2eaac330c87$var$_nonConvertibleUnits[unit] || $0cdfc2eaac330c87$var$_nonConvertibleUnits[curUnit]) return curValue;
    curUnit !== "px" && !toPixels && (curValue = _convertToUnit(target, property, value, "px"));
    isSVG = target.getCTM && $0cdfc2eaac330c87$var$_isSVG(target);
    if ((toPercent || curUnit === "%") && ($0cdfc2eaac330c87$var$_transformProps[property] || ~property.indexOf("adius"))) {
        px = isSVG ? target.getBBox()[horizontal ? "width" : "height"] : target[measureProperty];
        return (0, $2Tywo._round)(toPercent ? curValue / px * amount : curValue / 100 * px);
    }
    style[horizontal ? "width" : "height"] = amount + (toPixels ? curUnit : unit);
    parent = ~property.indexOf("adius") || unit === "em" && target.appendChild && !isRootSVG ? target : target.parentNode;
    if (isSVG) parent = (target.ownerSVGElement || {}).parentNode;
    if (!parent || parent === $0cdfc2eaac330c87$var$_doc || !parent.appendChild) parent = $0cdfc2eaac330c87$var$_doc.body;
    cache = parent._gsap;
    if (cache && toPercent && cache.width && horizontal && cache.time === (0, $2Tywo._ticker).time && !cache.uncache) return (0, $2Tywo._round)(curValue / cache.width * amount);
    else {
        if (toPercent && (property === "height" || property === "width")) {
            // if we're dealing with width/height that's inside a container with padding and/or it's a flexbox/grid container, we must apply it to the target itself rather than the _tempDiv in order to ensure complete accuracy, factoring in the parent's padding.
            var v = target.style[property];
            target.style[property] = amount + unit;
            px = target[measureProperty];
            v ? target.style[property] = v : $0cdfc2eaac330c87$var$_removeProperty(target, property);
        } else {
            (toPercent || curUnit === "%") && !$0cdfc2eaac330c87$var$_nonStandardLayouts[$0cdfc2eaac330c87$var$_getComputedProperty(parent, "display")] && (style.position = $0cdfc2eaac330c87$var$_getComputedProperty(target, "position"));
            parent === target && (style.position = "static"); // like for borderRadius, if it's a % we must have it relative to the target itself but that may not have position: relative or position: absolute in which case it'd go up the chain until it finds its offsetParent (bad). position: static protects against that.
            parent.appendChild($0cdfc2eaac330c87$var$_tempDiv);
            px = $0cdfc2eaac330c87$var$_tempDiv[measureProperty];
            parent.removeChild($0cdfc2eaac330c87$var$_tempDiv);
            style.position = "absolute";
        }
        if (horizontal && toPercent) {
            cache = (0, $2Tywo._getCache)(parent);
            cache.time = (0, $2Tywo._ticker).time;
            cache.width = parent[measureProperty];
        }
    }
    return (0, $2Tywo._round)(toPixels ? px * curValue / amount : px && curValue ? amount / px * curValue : 0);
}, $0cdfc2eaac330c87$var$_get = function _get(target, property, unit, uncache) {
    var value;
    $0cdfc2eaac330c87$var$_pluginInitted || $0cdfc2eaac330c87$var$_initCore();
    if (property in $0cdfc2eaac330c87$var$_propertyAliases && property !== "transform") {
        property = $0cdfc2eaac330c87$var$_propertyAliases[property];
        if (~property.indexOf(",")) property = property.split(",")[0];
    }
    if ($0cdfc2eaac330c87$var$_transformProps[property] && property !== "transform") {
        value = $0cdfc2eaac330c87$var$_parseTransform(target, uncache);
        value = property !== "transformOrigin" ? value[property] : value.svg ? value.origin : $0cdfc2eaac330c87$var$_firstTwoOnly($0cdfc2eaac330c87$var$_getComputedProperty(target, $0cdfc2eaac330c87$var$_transformOriginProp)) + " " + value.zOrigin + "px";
    } else {
        value = target.style[property];
        if (!value || value === "auto" || uncache || ~(value + "").indexOf("calc(")) value = $0cdfc2eaac330c87$var$_specialProps[property] && $0cdfc2eaac330c87$var$_specialProps[property](target, property, unit) || $0cdfc2eaac330c87$var$_getComputedProperty(target, property) || (0, $2Tywo._getProperty)(target, property) || (property === "opacity" ? 1 : 0); // note: some browsers, like Firefox, don't report borderRadius correctly! Instead, it only reports every corner like  borderTopLeftRadius
    }
    return unit && !~(value + "").trim().indexOf(" ") ? $0cdfc2eaac330c87$var$_convertToUnit(target, property, value, unit) + unit : value;
}, $0cdfc2eaac330c87$var$_tweenComplexCSSString = function _tweenComplexCSSString(target, prop, start, end) {
    // note: we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    if (!start || start === "none") {
        // some browsers like Safari actually PREFER the prefixed property and mis-report the unprefixed value like clipPath (BUG). In other words, even though clipPath exists in the style ("clipPath" in target.style) and it's set in the CSS properly (along with -webkit-clip-path), Safari reports clipPath as "none" whereas WebkitClipPath reports accurately like "ellipse(100% 0% at 50% 0%)", so in this case we must SWITCH to using the prefixed property instead. See https://gsap.com/forums/topic/18310-clippath-doesnt-work-on-ios/
        var p = $0cdfc2eaac330c87$export$8cbef5dd49a09c8b(prop, target, 1), s = p && $0cdfc2eaac330c87$var$_getComputedProperty(target, p, 1);
        if (s && s !== start) {
            prop = p;
            start = s;
        } else if (prop === "borderColor") start = $0cdfc2eaac330c87$var$_getComputedProperty(target, "borderTopColor"); // Firefox bug: always reports "borderColor" as "", so we must fall back to borderTopColor. See https://gsap.com/forums/topic/24583-how-to-return-colors-that-i-had-after-reverse/
    }
    var pt = new (0, $2Tywo.PropTween)(this._pt, target.style, prop, 0, 1, (0, $2Tywo._renderComplexString)), index = 0, matchIndex = 0, a, result, startValues, startNum, color, startValue, endValue, endNum, chunk, endUnit, startUnit, endValues;
    pt.b = start;
    pt.e = end;
    start += ""; // ensure values are strings
    end += "";
    if (end === "auto") {
        startValue = target.style[prop];
        target.style[prop] = end;
        end = $0cdfc2eaac330c87$var$_getComputedProperty(target, prop) || end;
        startValue ? target.style[prop] = startValue : $0cdfc2eaac330c87$var$_removeProperty(target, prop);
    }
    a = [
        start,
        end
    ];
    (0, $2Tywo._colorStringFilter)(a); // pass an array with the starting and ending values and let the filter do whatever it needs to the values. If colors are found, it returns true and then we must match where the color shows up order-wise because for things like boxShadow, sometimes the browser provides the computed values with the color FIRST, but the user provides it with the color LAST, so flip them if necessary. Same for drop-shadow().
    start = a[0];
    end = a[1];
    startValues = start.match((0, $2Tywo._numWithUnitExp)) || [];
    endValues = end.match((0, $2Tywo._numWithUnitExp)) || [];
    if (endValues.length) {
        while(result = (0, $2Tywo._numWithUnitExp).exec(end)){
            endValue = result[0];
            chunk = end.substring(index, result.index);
            if (color) color = (color + 1) % 5;
            else if (chunk.substr(-5) === "rgba(" || chunk.substr(-5) === "hsla(") color = 1;
            if (endValue !== (startValue = startValues[matchIndex++] || "")) {
                startNum = parseFloat(startValue) || 0;
                startUnit = startValue.substr((startNum + "").length);
                endValue.charAt(1) === "=" && (endValue = (0, $2Tywo._parseRelative)(startNum, endValue) + startUnit);
                endNum = parseFloat(endValue);
                endUnit = endValue.substr((endNum + "").length);
                index = (0, $2Tywo._numWithUnitExp).lastIndex - endUnit.length;
                if (!endUnit) {
                    //if something like "perspective:300" is passed in and we must add a unit to the end
                    endUnit = endUnit || (0, $2Tywo._config).units[prop] || startUnit;
                    if (index === end.length) {
                        end += endUnit;
                        pt.e += endUnit;
                    }
                }
                if (startUnit !== endUnit) startNum = $0cdfc2eaac330c87$var$_convertToUnit(target, prop, startValue, endUnit) || 0;
                 // these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
                pt._pt = {
                    _next: pt._pt,
                    p: chunk || matchIndex === 1 ? chunk : ",",
                    //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                    s: startNum,
                    c: endNum - startNum,
                    m: color && color < 4 || prop === "zIndex" ? Math.round : 0
                };
            }
        }
        pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    } else pt.r = prop === "display" && end === "none" ? $0cdfc2eaac330c87$var$_renderNonTweeningValueOnlyAtEnd : $0cdfc2eaac330c87$var$_renderNonTweeningValue;
    (0, $2Tywo._relExp).test(end) && (pt.e = 0); //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within another plugin too, thus "this" would refer to the plugin.
    return pt;
}, $0cdfc2eaac330c87$var$_keywordToPercent = {
    top: "0%",
    bottom: "100%",
    left: "0%",
    right: "100%",
    center: "50%"
}, $0cdfc2eaac330c87$var$_convertKeywordsToPercentages = function _convertKeywordsToPercentages(value) {
    var split = value.split(" "), x = split[0], y = split[1] || "50%";
    if (x === "top" || x === "bottom" || y === "left" || y === "right") {
        //the user provided them in the wrong order, so flip them
        value = x;
        x = y;
        y = value;
    }
    split[0] = $0cdfc2eaac330c87$var$_keywordToPercent[x] || x;
    split[1] = $0cdfc2eaac330c87$var$_keywordToPercent[y] || y;
    return split.join(" ");
}, $0cdfc2eaac330c87$var$_renderClearProps = function _renderClearProps(ratio, data) {
    if (data.tween && data.tween._time === data.tween._dur) {
        var target = data.t, style = target.style, props = data.u, cache = target._gsap, prop, clearTransforms, i;
        if (props === "all" || props === true) {
            style.cssText = "";
            clearTransforms = 1;
        } else {
            props = props.split(",");
            i = props.length;
            while(--i > -1){
                prop = props[i];
                if ($0cdfc2eaac330c87$var$_transformProps[prop]) {
                    clearTransforms = 1;
                    prop = prop === "transformOrigin" ? $0cdfc2eaac330c87$var$_transformOriginProp : $0cdfc2eaac330c87$var$_transformProp;
                }
                $0cdfc2eaac330c87$var$_removeProperty(target, prop);
            }
        }
        if (clearTransforms) {
            $0cdfc2eaac330c87$var$_removeProperty(target, $0cdfc2eaac330c87$var$_transformProp);
            if (cache) {
                cache.svg && target.removeAttribute("transform");
                $0cdfc2eaac330c87$var$_parseTransform(target, 1); // force all the cached values back to "normal"/identity, otherwise if there's another tween that's already set to render transforms on this element, it could display the wrong values.
                cache.uncache = 1;
                $0cdfc2eaac330c87$var$_removeIndependentTransforms(style);
            }
        }
    }
}, // note: specialProps should return 1 if (and only if) they have a non-zero priority. It indicates we need to sort the linked list.
$0cdfc2eaac330c87$var$_specialProps = {
    clearProps: function clearProps(plugin, target, property, endValue, tween) {
        if (tween.data !== "isFromStart") {
            var pt = plugin._pt = new (0, $2Tywo.PropTween)(plugin._pt, target, property, 0, 0, $0cdfc2eaac330c87$var$_renderClearProps);
            pt.u = endValue;
            pt.pr = -10;
            pt.tween = tween;
            plugin._props.push(property);
            return 1;
        }
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TRANSFORMS
 * --------------------------------------------------------------------------------------
 */ $0cdfc2eaac330c87$var$_identity2DMatrix = [
    1,
    0,
    0,
    1,
    0,
    0
], $0cdfc2eaac330c87$var$_rotationalProperties = {}, $0cdfc2eaac330c87$var$_isNullTransform = function _isNullTransform(value) {
    return value === "matrix(1, 0, 0, 1, 0, 0)" || value === "none" || !value;
}, $0cdfc2eaac330c87$var$_getComputedTransformMatrixAsArray = function _getComputedTransformMatrixAsArray(target) {
    var matrixString = $0cdfc2eaac330c87$var$_getComputedProperty(target, $0cdfc2eaac330c87$var$_transformProp);
    return $0cdfc2eaac330c87$var$_isNullTransform(matrixString) ? $0cdfc2eaac330c87$var$_identity2DMatrix : matrixString.substr(7).match((0, $2Tywo._numExp)).map((0, $2Tywo._round));
}, $0cdfc2eaac330c87$var$_getMatrix = function _getMatrix(target, force2D) {
    var cache = target._gsap || (0, $2Tywo._getCache)(target), style = target.style, matrix = $0cdfc2eaac330c87$var$_getComputedTransformMatrixAsArray(target), parent, nextSibling, temp, addedToDOM;
    if (cache.svg && target.getAttribute("transform")) {
        temp = target.transform.baseVal.consolidate().matrix; //ensures that even complex values like "translate(50,60) rotate(135,0,0)" are parsed because it mashes it into a matrix.
        matrix = [
            temp.a,
            temp.b,
            temp.c,
            temp.d,
            temp.e,
            temp.f
        ];
        return matrix.join(",") === "1,0,0,1,0,0" ? $0cdfc2eaac330c87$var$_identity2DMatrix : matrix;
    } else if (matrix === $0cdfc2eaac330c87$var$_identity2DMatrix && !target.offsetParent && target !== $0cdfc2eaac330c87$var$_docElement && !cache.svg) {
        //note: if offsetParent is null, that means the element isn't in the normal document flow, like if it has display:none or one of its ancestors has display:none). Firefox returns null for getComputedStyle() if the element is in an iframe that has display:none. https://bugzilla.mozilla.org/show_bug.cgi?id=548397
        //browsers don't report transforms accurately unless the element is in the DOM and has a display value that's not "none". Firefox and Microsoft browsers have a partial bug where they'll report transforms even if display:none BUT not any percentage-based values like translate(-50%, 8px) will be reported as if it's translate(0, 8px).
        temp = style.display;
        style.display = "block";
        parent = target.parentNode;
        if (!parent || !target.offsetParent) {
            // note: in 3.3.0 we switched target.offsetParent to _doc.body.contains(target) to avoid [sometimes unnecessary] MutationObserver calls but that wasn't adequate because there are edge cases where nested position: fixed elements need to get reparented to accurately sense transforms. See https://github.com/greensock/GSAP/issues/388 and https://github.com/greensock/GSAP/issues/375
            addedToDOM = 1; //flag
            nextSibling = target.nextElementSibling;
            $0cdfc2eaac330c87$var$_docElement.appendChild(target); //we must add it to the DOM in order to get values properly
        }
        matrix = $0cdfc2eaac330c87$var$_getComputedTransformMatrixAsArray(target);
        temp ? style.display = temp : $0cdfc2eaac330c87$var$_removeProperty(target, "display");
        if (addedToDOM) nextSibling ? parent.insertBefore(target, nextSibling) : parent ? parent.appendChild(target) : $0cdfc2eaac330c87$var$_docElement.removeChild(target);
    }
    return force2D && matrix.length > 6 ? [
        matrix[0],
        matrix[1],
        matrix[4],
        matrix[5],
        matrix[12],
        matrix[13]
    ] : matrix;
}, $0cdfc2eaac330c87$var$_applySVGOrigin = function _applySVGOrigin(target, origin, originIsAbsolute, smooth, matrixArray, pluginToAddPropTweensTo) {
    var cache = target._gsap, matrix = matrixArray || $0cdfc2eaac330c87$var$_getMatrix(target, true), xOriginOld = cache.xOrigin || 0, yOriginOld = cache.yOrigin || 0, xOffsetOld = cache.xOffset || 0, yOffsetOld = cache.yOffset || 0, a = matrix[0], b = matrix[1], c = matrix[2], d = matrix[3], tx = matrix[4], ty = matrix[5], originSplit = origin.split(" "), xOrigin = parseFloat(originSplit[0]) || 0, yOrigin = parseFloat(originSplit[1]) || 0, bounds, determinant, x, y;
    if (!originIsAbsolute) {
        bounds = $0cdfc2eaac330c87$export$41bc7c2d1e04f11b(target);
        xOrigin = bounds.x + (~originSplit[0].indexOf("%") ? xOrigin / 100 * bounds.width : xOrigin);
        yOrigin = bounds.y + (~(originSplit[1] || originSplit[0]).indexOf("%") ? yOrigin / 100 * bounds.height : yOrigin); // if (!("xOrigin" in cache) && (xOrigin || yOrigin)) { // added in 3.12.3, reverted in 3.12.4; requires more exploration
    // 	xOrigin -= bounds.x;
    // 	yOrigin -= bounds.y;
    // }
    } else if (matrix !== $0cdfc2eaac330c87$var$_identity2DMatrix && (determinant = a * d - b * c)) {
        //if it's zero (like if scaleX and scaleY are zero), skip it to avoid errors with dividing by zero.
        x = xOrigin * (d / determinant) + yOrigin * (-c / determinant) + (c * ty - d * tx) / determinant;
        y = xOrigin * (-b / determinant) + yOrigin * (a / determinant) - (a * ty - b * tx) / determinant;
        xOrigin = x;
        yOrigin = y; // theory: we only had to do this for smoothing and it assumes that the previous one was not originIsAbsolute.
    }
    if (smooth || smooth !== false && cache.smooth) {
        tx = xOrigin - xOriginOld;
        ty = yOrigin - yOriginOld;
        cache.xOffset = xOffsetOld + (tx * a + ty * c) - tx;
        cache.yOffset = yOffsetOld + (tx * b + ty * d) - ty;
    } else cache.xOffset = cache.yOffset = 0;
    cache.xOrigin = xOrigin;
    cache.yOrigin = yOrigin;
    cache.smooth = !!smooth;
    cache.origin = origin;
    cache.originIsAbsolute = !!originIsAbsolute;
    target.style[$0cdfc2eaac330c87$var$_transformOriginProp] = "0px 0px"; //otherwise, if someone sets  an origin via CSS, it will likely interfere with the SVG transform attribute ones (because remember, we're baking the origin into the matrix() value).
    if (pluginToAddPropTweensTo) {
        $0cdfc2eaac330c87$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOrigin", xOriginOld, xOrigin);
        $0cdfc2eaac330c87$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOrigin", yOriginOld, yOrigin);
        $0cdfc2eaac330c87$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOffset", xOffsetOld, cache.xOffset);
        $0cdfc2eaac330c87$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOffset", yOffsetOld, cache.yOffset);
    }
    target.setAttribute("data-svg-origin", xOrigin + " " + yOrigin);
}, $0cdfc2eaac330c87$var$_parseTransform = function _parseTransform(target, uncache) {
    var cache = target._gsap || new (0, $2Tywo.GSCache)(target);
    if ("x" in cache && !uncache && !cache.uncache) return cache;
    var style = target.style, invertedScaleX = cache.scaleX < 0, px = "px", deg = "deg", cs = getComputedStyle(target), origin = $0cdfc2eaac330c87$var$_getComputedProperty(target, $0cdfc2eaac330c87$var$_transformOriginProp) || "0", x, y, z, scaleX, scaleY, rotation, rotationX, rotationY, skewX, skewY, perspective, xOrigin, yOrigin, matrix, angle, cos, sin, a, b, c, d, a12, a22, t1, t2, t3, a13, a23, a33, a42, a43, a32;
    x = y = z = rotation = rotationX = rotationY = skewX = skewY = perspective = 0;
    scaleX = scaleY = 1;
    cache.svg = !!(target.getCTM && $0cdfc2eaac330c87$var$_isSVG(target));
    if (cs.translate) {
        // accommodate independent transforms by combining them into normal ones.
        if (cs.translate !== "none" || cs.scale !== "none" || cs.rotate !== "none") style[$0cdfc2eaac330c87$var$_transformProp] = (cs.translate !== "none" ? "translate3d(" + (cs.translate + " 0 0").split(" ").slice(0, 3).join(", ") + ") " : "") + (cs.rotate !== "none" ? "rotate(" + cs.rotate + ") " : "") + (cs.scale !== "none" ? "scale(" + cs.scale.split(" ").join(",") + ") " : "") + (cs[$0cdfc2eaac330c87$var$_transformProp] !== "none" ? cs[$0cdfc2eaac330c87$var$_transformProp] : "");
        style.scale = style.rotate = style.translate = "none";
    }
    matrix = $0cdfc2eaac330c87$var$_getMatrix(target, cache.svg);
    if (cache.svg) {
        if (cache.uncache) {
            // if cache.uncache is true (and maybe if origin is 0,0), we need to set element.style.transformOrigin = (cache.xOrigin - bbox.x) + "px " + (cache.yOrigin - bbox.y) + "px". Previously we let the data-svg-origin stay instead, but when introducing revert(), it complicated things.
            t2 = target.getBBox();
            origin = cache.xOrigin - t2.x + "px " + (cache.yOrigin - t2.y) + "px";
            t1 = "";
        } else t1 = !uncache && target.getAttribute("data-svg-origin"); //  Remember, to work around browser inconsistencies we always force SVG elements' transformOrigin to 0,0 and offset the translation accordingly.
        $0cdfc2eaac330c87$var$_applySVGOrigin(target, t1 || origin, !!t1 || cache.originIsAbsolute, cache.smooth !== false, matrix);
    }
    xOrigin = cache.xOrigin || 0;
    yOrigin = cache.yOrigin || 0;
    if (matrix !== $0cdfc2eaac330c87$var$_identity2DMatrix) {
        a = matrix[0]; //a11
        b = matrix[1]; //a21
        c = matrix[2]; //a31
        d = matrix[3]; //a41
        x = a12 = matrix[4];
        y = a22 = matrix[5]; //2D matrix
        if (matrix.length === 6) {
            scaleX = Math.sqrt(a * a + b * b);
            scaleY = Math.sqrt(d * d + c * c);
            rotation = a || b ? $0cdfc2eaac330c87$var$_atan2(b, a) * $0cdfc2eaac330c87$var$_RAD2DEG : 0; //note: if scaleX is 0, we cannot accurately measure rotation. Same for skewX with a scaleY of 0. Therefore, we default to the previously recorded value (or zero if that doesn't exist).
            skewX = c || d ? $0cdfc2eaac330c87$var$_atan2(c, d) * $0cdfc2eaac330c87$var$_RAD2DEG + rotation : 0;
            skewX && (scaleY *= Math.abs(Math.cos(skewX * $0cdfc2eaac330c87$var$_DEG2RAD)));
            if (cache.svg) {
                x -= xOrigin - (xOrigin * a + yOrigin * c);
                y -= yOrigin - (xOrigin * b + yOrigin * d);
            } //3D matrix
        } else {
            a32 = matrix[6];
            a42 = matrix[7];
            a13 = matrix[8];
            a23 = matrix[9];
            a33 = matrix[10];
            a43 = matrix[11];
            x = matrix[12];
            y = matrix[13];
            z = matrix[14];
            angle = $0cdfc2eaac330c87$var$_atan2(a32, a33);
            rotationX = angle * $0cdfc2eaac330c87$var$_RAD2DEG; //rotationX
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a12 * cos + a13 * sin;
                t2 = a22 * cos + a23 * sin;
                t3 = a32 * cos + a33 * sin;
                a13 = a12 * -sin + a13 * cos;
                a23 = a22 * -sin + a23 * cos;
                a33 = a32 * -sin + a33 * cos;
                a43 = a42 * -sin + a43 * cos;
                a12 = t1;
                a22 = t2;
                a32 = t3;
            } //rotationY
            angle = $0cdfc2eaac330c87$var$_atan2(-c, a33);
            rotationY = angle * $0cdfc2eaac330c87$var$_RAD2DEG;
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a * cos - a13 * sin;
                t2 = b * cos - a23 * sin;
                t3 = c * cos - a33 * sin;
                a43 = d * sin + a43 * cos;
                a = t1;
                b = t2;
                c = t3;
            } //rotationZ
            angle = $0cdfc2eaac330c87$var$_atan2(b, a);
            rotation = angle * $0cdfc2eaac330c87$var$_RAD2DEG;
            if (angle) {
                cos = Math.cos(angle);
                sin = Math.sin(angle);
                t1 = a * cos + b * sin;
                t2 = a12 * cos + a22 * sin;
                b = b * cos - a * sin;
                a22 = a22 * cos - a12 * sin;
                a = t1;
                a12 = t2;
            }
            if (rotationX && Math.abs(rotationX) + Math.abs(rotation) > 359.9) {
                //when rotationY is set, it will often be parsed as 180 degrees different than it should be, and rotationX and rotation both being 180 (it looks the same), so we adjust for that here.
                rotationX = rotation = 0;
                rotationY = 180 - rotationY;
            }
            scaleX = (0, $2Tywo._round)(Math.sqrt(a * a + b * b + c * c));
            scaleY = (0, $2Tywo._round)(Math.sqrt(a22 * a22 + a32 * a32));
            angle = $0cdfc2eaac330c87$var$_atan2(a12, a22);
            skewX = Math.abs(angle) > 0.0002 ? angle * $0cdfc2eaac330c87$var$_RAD2DEG : 0;
            perspective = a43 ? 1 / (a43 < 0 ? -a43 : a43) : 0;
        }
        if (cache.svg) {
            //sense if there are CSS transforms applied on an SVG element in which case we must overwrite them when rendering. The transform attribute is more reliable cross-browser, but we can't just remove the CSS ones because they may be applied in a CSS rule somewhere (not just inline).
            t1 = target.getAttribute("transform");
            cache.forceCSS = target.setAttribute("transform", "") || !$0cdfc2eaac330c87$var$_isNullTransform($0cdfc2eaac330c87$var$_getComputedProperty(target, $0cdfc2eaac330c87$var$_transformProp));
            t1 && target.setAttribute("transform", t1);
        }
    }
    if (Math.abs(skewX) > 90 && Math.abs(skewX) < 270) {
        if (invertedScaleX) {
            scaleX *= -1;
            skewX += rotation <= 0 ? 180 : -180;
            rotation += rotation <= 0 ? 180 : -180;
        } else {
            scaleY *= -1;
            skewX += skewX <= 0 ? 180 : -180;
        }
    }
    uncache = uncache || cache.uncache;
    cache.x = x - ((cache.xPercent = x && (!uncache && cache.xPercent || (Math.round(target.offsetWidth / 2) === Math.round(-x) ? -50 : 0))) ? target.offsetWidth * cache.xPercent / 100 : 0) + px;
    cache.y = y - ((cache.yPercent = y && (!uncache && cache.yPercent || (Math.round(target.offsetHeight / 2) === Math.round(-y) ? -50 : 0))) ? target.offsetHeight * cache.yPercent / 100 : 0) + px;
    cache.z = z + px;
    cache.scaleX = (0, $2Tywo._round)(scaleX);
    cache.scaleY = (0, $2Tywo._round)(scaleY);
    cache.rotation = (0, $2Tywo._round)(rotation) + deg;
    cache.rotationX = (0, $2Tywo._round)(rotationX) + deg;
    cache.rotationY = (0, $2Tywo._round)(rotationY) + deg;
    cache.skewX = skewX + deg;
    cache.skewY = skewY + deg;
    cache.transformPerspective = perspective + px;
    if (cache.zOrigin = parseFloat(origin.split(" ")[2]) || !uncache && cache.zOrigin || 0) style[$0cdfc2eaac330c87$var$_transformOriginProp] = $0cdfc2eaac330c87$var$_firstTwoOnly(origin);
    cache.xOffset = cache.yOffset = 0;
    cache.force3D = (0, $2Tywo._config).force3D;
    cache.renderTransform = cache.svg ? $0cdfc2eaac330c87$var$_renderSVGTransforms : $0cdfc2eaac330c87$var$_supports3D ? $0cdfc2eaac330c87$var$_renderCSSTransforms : $0cdfc2eaac330c87$var$_renderNon3DTransforms;
    cache.uncache = 0;
    return cache;
}, $0cdfc2eaac330c87$var$_firstTwoOnly = function _firstTwoOnly(value) {
    return (value = value.split(" "))[0] + " " + value[1];
}, //for handling transformOrigin values, stripping out the 3rd dimension
$0cdfc2eaac330c87$var$_addPxTranslate = function _addPxTranslate(target, start, value) {
    var unit = (0, $2Tywo.getUnit)(start);
    return (0, $2Tywo._round)(parseFloat(start) + parseFloat($0cdfc2eaac330c87$var$_convertToUnit(target, "x", value + "px", unit))) + unit;
}, $0cdfc2eaac330c87$var$_renderNon3DTransforms = function _renderNon3DTransforms(ratio, cache) {
    cache.z = "0px";
    cache.rotationY = cache.rotationX = "0deg";
    cache.force3D = 0;
    $0cdfc2eaac330c87$var$_renderCSSTransforms(ratio, cache);
}, $0cdfc2eaac330c87$var$_zeroDeg = "0deg", $0cdfc2eaac330c87$var$_zeroPx = "0px", $0cdfc2eaac330c87$var$_endParenthesis = ") ", $0cdfc2eaac330c87$var$_renderCSSTransforms = function _renderCSSTransforms(ratio, cache) {
    var _ref = cache || this, xPercent = _ref.xPercent, yPercent = _ref.yPercent, x = _ref.x, y = _ref.y, z = _ref.z, rotation = _ref.rotation, rotationY = _ref.rotationY, rotationX = _ref.rotationX, skewX = _ref.skewX, skewY = _ref.skewY, scaleX = _ref.scaleX, scaleY = _ref.scaleY, transformPerspective = _ref.transformPerspective, force3D = _ref.force3D, target = _ref.target, zOrigin = _ref.zOrigin, transforms = "", use3D = force3D === "auto" && ratio && ratio !== 1 || force3D === true; // Safari has a bug that causes it not to render 3D transform-origin values properly, so we force the z origin to 0, record it in the cache, and then do the math here to offset the translate values accordingly (basically do the 3D transform-origin part manually)
    if (zOrigin && (rotationX !== $0cdfc2eaac330c87$var$_zeroDeg || rotationY !== $0cdfc2eaac330c87$var$_zeroDeg)) {
        var angle = parseFloat(rotationY) * $0cdfc2eaac330c87$var$_DEG2RAD, a13 = Math.sin(angle), a33 = Math.cos(angle), cos;
        angle = parseFloat(rotationX) * $0cdfc2eaac330c87$var$_DEG2RAD;
        cos = Math.cos(angle);
        x = $0cdfc2eaac330c87$var$_addPxTranslate(target, x, a13 * cos * -zOrigin);
        y = $0cdfc2eaac330c87$var$_addPxTranslate(target, y, -Math.sin(angle) * -zOrigin);
        z = $0cdfc2eaac330c87$var$_addPxTranslate(target, z, a33 * cos * -zOrigin + zOrigin);
    }
    if (transformPerspective !== $0cdfc2eaac330c87$var$_zeroPx) transforms += "perspective(" + transformPerspective + $0cdfc2eaac330c87$var$_endParenthesis;
    if (xPercent || yPercent) transforms += "translate(" + xPercent + "%, " + yPercent + "%) ";
    if (use3D || x !== $0cdfc2eaac330c87$var$_zeroPx || y !== $0cdfc2eaac330c87$var$_zeroPx || z !== $0cdfc2eaac330c87$var$_zeroPx) transforms += z !== $0cdfc2eaac330c87$var$_zeroPx || use3D ? "translate3d(" + x + ", " + y + ", " + z + ") " : "translate(" + x + ", " + y + $0cdfc2eaac330c87$var$_endParenthesis;
    if (rotation !== $0cdfc2eaac330c87$var$_zeroDeg) transforms += "rotate(" + rotation + $0cdfc2eaac330c87$var$_endParenthesis;
    if (rotationY !== $0cdfc2eaac330c87$var$_zeroDeg) transforms += "rotateY(" + rotationY + $0cdfc2eaac330c87$var$_endParenthesis;
    if (rotationX !== $0cdfc2eaac330c87$var$_zeroDeg) transforms += "rotateX(" + rotationX + $0cdfc2eaac330c87$var$_endParenthesis;
    if (skewX !== $0cdfc2eaac330c87$var$_zeroDeg || skewY !== $0cdfc2eaac330c87$var$_zeroDeg) transforms += "skew(" + skewX + ", " + skewY + $0cdfc2eaac330c87$var$_endParenthesis;
    if (scaleX !== 1 || scaleY !== 1) transforms += "scale(" + scaleX + ", " + scaleY + $0cdfc2eaac330c87$var$_endParenthesis;
    target.style[$0cdfc2eaac330c87$var$_transformProp] = transforms || "translate(0, 0)";
}, $0cdfc2eaac330c87$var$_renderSVGTransforms = function _renderSVGTransforms(ratio, cache) {
    var _ref2 = cache || this, xPercent = _ref2.xPercent, yPercent = _ref2.yPercent, x = _ref2.x, y = _ref2.y, rotation = _ref2.rotation, skewX = _ref2.skewX, skewY = _ref2.skewY, scaleX = _ref2.scaleX, scaleY = _ref2.scaleY, target = _ref2.target, xOrigin = _ref2.xOrigin, yOrigin = _ref2.yOrigin, xOffset = _ref2.xOffset, yOffset = _ref2.yOffset, forceCSS = _ref2.forceCSS, tx = parseFloat(x), ty = parseFloat(y), a11, a21, a12, a22, temp;
    rotation = parseFloat(rotation);
    skewX = parseFloat(skewX);
    skewY = parseFloat(skewY);
    if (skewY) {
        //for performance reasons, we combine all skewing into the skewX and rotation values. Remember, a skewY of 10 degrees looks the same as a rotation of 10 degrees plus a skewX of 10 degrees.
        skewY = parseFloat(skewY);
        skewX += skewY;
        rotation += skewY;
    }
    if (rotation || skewX) {
        rotation *= $0cdfc2eaac330c87$var$_DEG2RAD;
        skewX *= $0cdfc2eaac330c87$var$_DEG2RAD;
        a11 = Math.cos(rotation) * scaleX;
        a21 = Math.sin(rotation) * scaleX;
        a12 = Math.sin(rotation - skewX) * -scaleY;
        a22 = Math.cos(rotation - skewX) * scaleY;
        if (skewX) {
            skewY *= $0cdfc2eaac330c87$var$_DEG2RAD;
            temp = Math.tan(skewX - skewY);
            temp = Math.sqrt(1 + temp * temp);
            a12 *= temp;
            a22 *= temp;
            if (skewY) {
                temp = Math.tan(skewY);
                temp = Math.sqrt(1 + temp * temp);
                a11 *= temp;
                a21 *= temp;
            }
        }
        a11 = (0, $2Tywo._round)(a11);
        a21 = (0, $2Tywo._round)(a21);
        a12 = (0, $2Tywo._round)(a12);
        a22 = (0, $2Tywo._round)(a22);
    } else {
        a11 = scaleX;
        a22 = scaleY;
        a21 = a12 = 0;
    }
    if (tx && !~(x + "").indexOf("px") || ty && !~(y + "").indexOf("px")) {
        tx = $0cdfc2eaac330c87$var$_convertToUnit(target, "x", x, "px");
        ty = $0cdfc2eaac330c87$var$_convertToUnit(target, "y", y, "px");
    }
    if (xOrigin || yOrigin || xOffset || yOffset) {
        tx = (0, $2Tywo._round)(tx + xOrigin - (xOrigin * a11 + yOrigin * a12) + xOffset);
        ty = (0, $2Tywo._round)(ty + yOrigin - (xOrigin * a21 + yOrigin * a22) + yOffset);
    }
    if (xPercent || yPercent) {
        //The SVG spec doesn't support percentage-based translation in the "transform" attribute, so we merge it into the translation to simulate it.
        temp = target.getBBox();
        tx = (0, $2Tywo._round)(tx + xPercent / 100 * temp.width);
        ty = (0, $2Tywo._round)(ty + yPercent / 100 * temp.height);
    }
    temp = "matrix(" + a11 + "," + a21 + "," + a12 + "," + a22 + "," + tx + "," + ty + ")";
    target.setAttribute("transform", temp);
    forceCSS && (target.style[$0cdfc2eaac330c87$var$_transformProp] = temp); //some browsers prioritize CSS transforms over the transform attribute. When we sense that the user has CSS transforms applied, we must overwrite them this way (otherwise some browser simply won't render the transform attribute changes!)
}, $0cdfc2eaac330c87$var$_addRotationalPropTween = function _addRotationalPropTween(plugin, target, property, startNum, endValue) {
    var cap = 360, isString = (0, $2Tywo._isString)(endValue), endNum = parseFloat(endValue) * (isString && ~endValue.indexOf("rad") ? $0cdfc2eaac330c87$var$_RAD2DEG : 1), change = endNum - startNum, finalValue = startNum + change + "deg", direction, pt;
    if (isString) {
        direction = endValue.split("_")[1];
        if (direction === "short") {
            change %= cap;
            if (change !== change % (cap / 2)) change += change < 0 ? cap : -cap;
        }
        if (direction === "cw" && change < 0) change = (change + cap * $0cdfc2eaac330c87$var$_bigNum) % cap - ~~(change / cap) * cap;
        else if (direction === "ccw" && change > 0) change = (change - cap * $0cdfc2eaac330c87$var$_bigNum) % cap - ~~(change / cap) * cap;
    }
    plugin._pt = pt = new (0, $2Tywo.PropTween)(plugin._pt, target, property, startNum, change, $0cdfc2eaac330c87$var$_renderPropWithEnd);
    pt.e = finalValue;
    pt.u = "deg";
    plugin._props.push(property);
    return pt;
}, $0cdfc2eaac330c87$var$_assign = function _assign(target, source) {
    // Internet Explorer doesn't have Object.assign(), so we recreate it here.
    for(var p in source)target[p] = source[p];
    return target;
}, $0cdfc2eaac330c87$var$_addRawTransformPTs = function _addRawTransformPTs(plugin, transforms, target) {
    //for handling cases where someone passes in a whole transform string, like transform: "scale(2, 3) rotate(20deg) translateY(30em)"
    var startCache = $0cdfc2eaac330c87$var$_assign({}, target._gsap), exclude = "perspective,force3D,transformOrigin,svgOrigin", style = target.style, endCache, p, startValue, endValue, startNum, endNum, startUnit, endUnit;
    if (startCache.svg) {
        startValue = target.getAttribute("transform");
        target.setAttribute("transform", "");
        style[$0cdfc2eaac330c87$var$_transformProp] = transforms;
        endCache = $0cdfc2eaac330c87$var$_parseTransform(target, 1);
        $0cdfc2eaac330c87$var$_removeProperty(target, $0cdfc2eaac330c87$var$_transformProp);
        target.setAttribute("transform", startValue);
    } else {
        startValue = getComputedStyle(target)[$0cdfc2eaac330c87$var$_transformProp];
        style[$0cdfc2eaac330c87$var$_transformProp] = transforms;
        endCache = $0cdfc2eaac330c87$var$_parseTransform(target, 1);
        style[$0cdfc2eaac330c87$var$_transformProp] = startValue;
    }
    for(p in $0cdfc2eaac330c87$var$_transformProps){
        startValue = startCache[p];
        endValue = endCache[p];
        if (startValue !== endValue && exclude.indexOf(p) < 0) {
            //tweening to no perspective gives very unintuitive results - just keep the same perspective in that case.
            startUnit = (0, $2Tywo.getUnit)(startValue);
            endUnit = (0, $2Tywo.getUnit)(endValue);
            startNum = startUnit !== endUnit ? $0cdfc2eaac330c87$var$_convertToUnit(target, p, startValue, endUnit) : parseFloat(startValue);
            endNum = parseFloat(endValue);
            plugin._pt = new (0, $2Tywo.PropTween)(plugin._pt, endCache, p, startNum, endNum - startNum, $0cdfc2eaac330c87$var$_renderCSSProp);
            plugin._pt.u = endUnit || 0;
            plugin._props.push(p);
        }
    }
    $0cdfc2eaac330c87$var$_assign(endCache, startCache);
}; // handle splitting apart padding, margin, borderWidth, and borderRadius into their 4 components. Firefox, for example, won't report borderRadius correctly - it will only do borderTopLeftRadius and the other corners. We also want to handle paddingTop, marginLeft, borderRightWidth, etc.
(0, $2Tywo._forEachName)("padding,margin,Width,Radius", function(name, index) {
    var t = "Top", r = "Right", b = "Bottom", l = "Left", props = (index < 3 ? [
        t,
        r,
        b,
        l
    ] : [
        t + l,
        t + r,
        b + r,
        b + l
    ]).map(function(side) {
        return index < 2 ? name + side : "border" + side + name;
    });
    $0cdfc2eaac330c87$var$_specialProps[index > 1 ? "border" + name : name] = function(plugin, target, property, endValue, tween) {
        var a, vars;
        if (arguments.length < 4) {
            // getter, passed target, property, and unit (from _get())
            a = props.map(function(prop) {
                return $0cdfc2eaac330c87$var$_get(plugin, prop, property);
            });
            vars = a.join(" ");
            return vars.split(a[0]).length === 5 ? a[0] : vars;
        }
        a = (endValue + "").split(" ");
        vars = {};
        props.forEach(function(prop, i) {
            return vars[prop] = a[i] = a[i] || a[(i - 1) / 2 | 0];
        });
        plugin.init(target, vars, tween);
    };
});
var $0cdfc2eaac330c87$export$855822f522f18eef = {
    name: "css",
    register: $0cdfc2eaac330c87$var$_initCore,
    targetTest: function targetTest(target) {
        return target.style && target.nodeType;
    },
    init: function init(target, vars, tween, index, targets) {
        var props = this._props, style = target.style, startAt = tween.vars.startAt, startValue, endValue, endNum, startNum, type, specialProp, p, startUnit, endUnit, relative, isTransformRelated, transformPropTween, cache, smooth, hasPriority, inlineProps;
        $0cdfc2eaac330c87$var$_pluginInitted || $0cdfc2eaac330c87$var$_initCore(); // we may call init() multiple times on the same plugin instance, like when adding special properties, so make sure we don't overwrite the revert data or inlineProps
        this.styles = this.styles || $0cdfc2eaac330c87$var$_getStyleSaver(target);
        inlineProps = this.styles.props;
        this.tween = tween;
        for(p in vars){
            if (p === "autoRound") continue;
            endValue = vars[p];
            if ((0, $2Tywo._plugins)[p] && (0, $2Tywo._checkPlugin)(p, vars, tween, index, target, targets)) continue;
            type = typeof endValue;
            specialProp = $0cdfc2eaac330c87$var$_specialProps[p];
            if (type === "function") {
                endValue = endValue.call(tween, index, target, targets);
                type = typeof endValue;
            }
            if (type === "string" && ~endValue.indexOf("random(")) endValue = (0, $2Tywo._replaceRandom)(endValue);
            if (specialProp) specialProp(this, target, p, endValue, tween) && (hasPriority = 1);
            else if (p.substr(0, 2) === "--") {
                //CSS variable
                startValue = (getComputedStyle(target).getPropertyValue(p) + "").trim();
                endValue += "";
                (0, $2Tywo._colorExp).lastIndex = 0;
                if (!(0, $2Tywo._colorExp).test(startValue)) {
                    // colors don't have units
                    startUnit = (0, $2Tywo.getUnit)(startValue);
                    endUnit = (0, $2Tywo.getUnit)(endValue);
                }
                endUnit ? startUnit !== endUnit && (startValue = $0cdfc2eaac330c87$var$_convertToUnit(target, p, startValue, endUnit) + endUnit) : startUnit && (endValue += startUnit);
                this.add(style, "setProperty", startValue, endValue, index, targets, 0, 0, p);
                props.push(p);
                inlineProps.push(p, 0, style[p]);
            } else if (type !== "undefined") {
                if (startAt && p in startAt) {
                    // in case someone hard-codes a complex value as the start, like top: "calc(2vh / 2)". Without this, it'd use the computed value (always in px)
                    startValue = typeof startAt[p] === "function" ? startAt[p].call(tween, index, target, targets) : startAt[p];
                    (0, $2Tywo._isString)(startValue) && ~startValue.indexOf("random(") && (startValue = (0, $2Tywo._replaceRandom)(startValue));
                    (0, $2Tywo.getUnit)(startValue + "") || startValue === "auto" || (startValue += (0, $2Tywo._config).units[p] || (0, $2Tywo.getUnit)($0cdfc2eaac330c87$var$_get(target, p)) || ""); // for cases when someone passes in a unitless value like {x: 100}; if we try setting translate(100, 0px) it won't work.
                    (startValue + "").charAt(1) === "=" && (startValue = $0cdfc2eaac330c87$var$_get(target, p)); // can't work with relative values
                } else startValue = $0cdfc2eaac330c87$var$_get(target, p);
                startNum = parseFloat(startValue);
                relative = type === "string" && endValue.charAt(1) === "=" && endValue.substr(0, 2);
                relative && (endValue = endValue.substr(2));
                endNum = parseFloat(endValue);
                if (p in $0cdfc2eaac330c87$var$_propertyAliases) {
                    if (p === "autoAlpha") {
                        //special case where we control the visibility along with opacity. We still allow the opacity value to pass through and get tweened.
                        if (startNum === 1 && $0cdfc2eaac330c87$var$_get(target, "visibility") === "hidden" && endNum) //if visibility is initially set to "hidden", we should interpret that as intent to make opacity 0 (a convenience)
                        startNum = 0;
                        inlineProps.push("visibility", 0, style.visibility);
                        $0cdfc2eaac330c87$var$_addNonTweeningPT(this, style, "visibility", startNum ? "inherit" : "hidden", endNum ? "inherit" : "hidden", !endNum);
                    }
                    if (p !== "scale" && p !== "transform") {
                        p = $0cdfc2eaac330c87$var$_propertyAliases[p];
                        ~p.indexOf(",") && (p = p.split(",")[0]);
                    }
                }
                isTransformRelated = p in $0cdfc2eaac330c87$var$_transformProps; //--- TRANSFORM-RELATED ---
                if (isTransformRelated) {
                    this.styles.save(p);
                    if (!transformPropTween) {
                        cache = target._gsap;
                        cache.renderTransform && !vars.parseTransform || $0cdfc2eaac330c87$var$_parseTransform(target, vars.parseTransform); // if, for example, gsap.set(... {transform:"translateX(50vw)"}), the _get() call doesn't parse the transform, thus cache.renderTransform won't be set yet so force the parsing of the transform here.
                        smooth = vars.smoothOrigin !== false && cache.smooth;
                        transformPropTween = this._pt = new (0, $2Tywo.PropTween)(this._pt, style, $0cdfc2eaac330c87$var$_transformProp, 0, 1, cache.renderTransform, cache, 0, -1); //the first time through, create the rendering PropTween so that it runs LAST (in the linked list, we keep adding to the beginning)
                        transformPropTween.dep = 1; //flag it as dependent so that if things get killed/overwritten and this is the only PropTween left, we can safely kill the whole tween.
                    }
                    if (p === "scale") {
                        this._pt = new (0, $2Tywo.PropTween)(this._pt, cache, "scaleY", cache.scaleY, (relative ? (0, $2Tywo._parseRelative)(cache.scaleY, relative + endNum) : endNum) - cache.scaleY || 0, $0cdfc2eaac330c87$var$_renderCSSProp);
                        this._pt.u = 0;
                        props.push("scaleY", p);
                        p += "X";
                    } else if (p === "transformOrigin") {
                        inlineProps.push($0cdfc2eaac330c87$var$_transformOriginProp, 0, style[$0cdfc2eaac330c87$var$_transformOriginProp]);
                        endValue = $0cdfc2eaac330c87$var$_convertKeywordsToPercentages(endValue); //in case something like "left top" or "bottom right" is passed in. Convert to percentages.
                        if (cache.svg) $0cdfc2eaac330c87$var$_applySVGOrigin(target, endValue, 0, smooth, 0, this);
                        else {
                            endUnit = parseFloat(endValue.split(" ")[2]) || 0; //handle the zOrigin separately!
                            endUnit !== cache.zOrigin && $0cdfc2eaac330c87$var$_addNonTweeningPT(this, cache, "zOrigin", cache.zOrigin, endUnit);
                            $0cdfc2eaac330c87$var$_addNonTweeningPT(this, style, p, $0cdfc2eaac330c87$var$_firstTwoOnly(startValue), $0cdfc2eaac330c87$var$_firstTwoOnly(endValue));
                        }
                        continue;
                    } else if (p === "svgOrigin") {
                        $0cdfc2eaac330c87$var$_applySVGOrigin(target, endValue, 1, smooth, 0, this);
                        continue;
                    } else if (p in $0cdfc2eaac330c87$var$_rotationalProperties) {
                        $0cdfc2eaac330c87$var$_addRotationalPropTween(this, cache, p, startNum, relative ? (0, $2Tywo._parseRelative)(startNum, relative + endValue) : endValue);
                        continue;
                    } else if (p === "smoothOrigin") {
                        $0cdfc2eaac330c87$var$_addNonTweeningPT(this, cache, "smooth", cache.smooth, endValue);
                        continue;
                    } else if (p === "force3D") {
                        cache[p] = endValue;
                        continue;
                    } else if (p === "transform") {
                        $0cdfc2eaac330c87$var$_addRawTransformPTs(this, endValue, target);
                        continue;
                    }
                } else if (!(p in style)) p = $0cdfc2eaac330c87$export$8cbef5dd49a09c8b(p) || p;
                if (isTransformRelated || (endNum || endNum === 0) && (startNum || startNum === 0) && !$0cdfc2eaac330c87$var$_complexExp.test(endValue) && p in style) {
                    startUnit = (startValue + "").substr((startNum + "").length);
                    endNum || (endNum = 0); // protect against NaN
                    endUnit = (0, $2Tywo.getUnit)(endValue) || (p in (0, $2Tywo._config).units ? (0, $2Tywo._config).units[p] : startUnit);
                    startUnit !== endUnit && (startNum = $0cdfc2eaac330c87$var$_convertToUnit(target, p, startValue, endUnit));
                    this._pt = new (0, $2Tywo.PropTween)(this._pt, isTransformRelated ? cache : style, p, startNum, (relative ? (0, $2Tywo._parseRelative)(startNum, relative + endNum) : endNum) - startNum, !isTransformRelated && (endUnit === "px" || p === "zIndex") && vars.autoRound !== false ? $0cdfc2eaac330c87$var$_renderRoundedCSSProp : $0cdfc2eaac330c87$var$_renderCSSProp);
                    this._pt.u = endUnit || 0;
                    if (startUnit !== endUnit && endUnit !== "%") {
                        //when the tween goes all the way back to the beginning, we need to revert it to the OLD/ORIGINAL value (with those units). We record that as a "b" (beginning) property and point to a render method that handles that. (performance optimization)
                        this._pt.b = startValue;
                        this._pt.r = $0cdfc2eaac330c87$var$_renderCSSPropWithBeginning;
                    }
                } else if (!(p in style)) {
                    if (p in target) //maybe it's not a style - it could be a property added directly to an element in which case we'll try to animate that.
                    this.add(target, p, startValue || target[p], relative ? relative + endValue : endValue, index, targets);
                    else if (p !== "parseTransform") {
                        (0, $2Tywo._missingPlugin)(p, endValue);
                        continue;
                    }
                } else $0cdfc2eaac330c87$var$_tweenComplexCSSString.call(this, target, p, startValue, relative ? relative + endValue : endValue);
                isTransformRelated || (p in style ? inlineProps.push(p, 0, style[p]) : inlineProps.push(p, 1, startValue || target[p]));
                props.push(p);
            }
        }
        hasPriority && (0, $2Tywo._sortPropTweensByPriority)(this);
    },
    render: function render(ratio, data) {
        if (data.tween._time || !$0cdfc2eaac330c87$var$_reverting()) {
            var pt = data._pt;
            while(pt){
                pt.r(ratio, pt.d);
                pt = pt._next;
            }
        } else data.styles.revert();
    },
    get: $0cdfc2eaac330c87$var$_get,
    aliases: $0cdfc2eaac330c87$var$_propertyAliases,
    getSetter: function getSetter(target, property, plugin) {
        //returns a setter function that accepts target, property, value and applies it accordingly. Remember, properties like "x" aren't as simple as target.style.property = value because they've got to be applied to a proxy object and then merged into a transform string in a renderer.
        var p = $0cdfc2eaac330c87$var$_propertyAliases[property];
        p && p.indexOf(",") < 0 && (property = p);
        return property in $0cdfc2eaac330c87$var$_transformProps && property !== $0cdfc2eaac330c87$var$_transformOriginProp && (target._gsap.x || $0cdfc2eaac330c87$var$_get(target, "x")) ? plugin && $0cdfc2eaac330c87$var$_recentSetterPlugin === plugin ? property === "scale" ? $0cdfc2eaac330c87$var$_setterScale : $0cdfc2eaac330c87$var$_setterTransform : ($0cdfc2eaac330c87$var$_recentSetterPlugin = plugin || {}, property === "scale" ? $0cdfc2eaac330c87$var$_setterScaleWithRender : $0cdfc2eaac330c87$var$_setterTransformWithRender) : target.style && !(0, $2Tywo._isUndefined)(target.style[property]) ? $0cdfc2eaac330c87$var$_setterCSSStyle : ~property.indexOf("-") ? $0cdfc2eaac330c87$var$_setterCSSProp : (0, $2Tywo._getSetter)(target, property);
    },
    core: {
        _removeProperty: $0cdfc2eaac330c87$var$_removeProperty,
        _getMatrix: $0cdfc2eaac330c87$var$_getMatrix
    }
};
(0, $2Tywo.gsap).utils.checkPrefix = $0cdfc2eaac330c87$export$8cbef5dd49a09c8b;
(0, $2Tywo.gsap).core.getStyleSaver = $0cdfc2eaac330c87$var$_getStyleSaver;
(function(positionAndScale, rotation, others, aliases) {
    var all = (0, $2Tywo._forEachName)(positionAndScale + "," + rotation + "," + others, function(name) {
        $0cdfc2eaac330c87$var$_transformProps[name] = 1;
    });
    (0, $2Tywo._forEachName)(rotation, function(name) {
        (0, $2Tywo._config).units[name] = "deg";
        $0cdfc2eaac330c87$var$_rotationalProperties[name] = 1;
    });
    $0cdfc2eaac330c87$var$_propertyAliases[all[13]] = positionAndScale + "," + rotation;
    (0, $2Tywo._forEachName)(aliases, function(name) {
        var split = name.split(":");
        $0cdfc2eaac330c87$var$_propertyAliases[split[1]] = all[split[0]];
    });
})("x,y,z,scale,scaleX,scaleY,xPercent,yPercent", "rotation,rotationX,rotationY,skewX,skewY", "transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY");
(0, $2Tywo._forEachName)("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function(name) {
    (0, $2Tywo._config).units[name] = "px";
});
(0, $2Tywo.gsap).registerPlugin($0cdfc2eaac330c87$export$855822f522f18eef);


var $357b3f2d5f2ec9d5$export$99ee26438460406a = (0, $2Tywo.gsap).registerPlugin((0, $0cdfc2eaac330c87$export$855822f522f18eef)) || (0, $2Tywo.gsap), // to protect from tree shaking
$357b3f2d5f2ec9d5$export$7b23975ad686bf91 = $357b3f2d5f2ec9d5$export$99ee26438460406a.core.Tween;


var $f233fb7ce3af900a$exports = {};
!function(t, n) {
    $f233fb7ce3af900a$exports = n();
}($f233fb7ce3af900a$exports, function() {
    function t(t, n) {
        for(var r = 0; r < n.length; r++){
            var i = n[r];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, "symbol" == typeof (e = function(t, n) {
                if ("object" != typeof t || null === t) return t;
                var r = t[Symbol.toPrimitive];
                if (void 0 !== r) {
                    var i = r.call(t, "string");
                    if ("object" != typeof i) return i;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(t);
            }(i.key)) ? e : String(e), i);
        }
        var e;
    }
    function n(n, r, i) {
        return r && t(n.prototype, r), i && t(n, i), Object.defineProperty(n, "prototype", {
            writable: !1
        }), n;
    }
    function r() {
        return r = Object.assign ? Object.assign.bind() : function(t) {
            for(var n = 1; n < arguments.length; n++){
                var r = arguments[n];
                for(var i in r)Object.prototype.hasOwnProperty.call(r, i) && (t[i] = r[i]);
            }
            return t;
        }, r.apply(this, arguments);
    }
    function i(t, n) {
        t.prototype = Object.create(n.prototype), t.prototype.constructor = t, o(t, n);
    }
    function e(t) {
        return e = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
            return t.__proto__ || Object.getPrototypeOf(t);
        }, e(t);
    }
    function o(t, n) {
        return o = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, n) {
            return t.__proto__ = n, t;
        }, o(t, n);
    }
    function u() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
        } catch (t) {
            return !1;
        }
    }
    function s(t, n, r) {
        return s = u() ? Reflect.construct.bind() : function(t, n, r) {
            var i = [
                null
            ];
            i.push.apply(i, n);
            var e = new (Function.bind.apply(t, i));
            return r && o(e, r.prototype), e;
        }, s.apply(null, arguments);
    }
    function f(t) {
        var n = "function" == typeof Map ? new Map : void 0;
        return f = function(t) {
            if (null === t || -1 === Function.toString.call(t).indexOf("[native code]")) return t;
            if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
            if (void 0 !== n) {
                if (n.has(t)) return n.get(t);
                n.set(t, r);
            }
            function r() {
                return s(t, arguments, e(this).constructor);
            }
            return r.prototype = Object.create(t.prototype, {
                constructor: {
                    value: r,
                    enumerable: !1,
                    writable: !0,
                    configurable: !0
                }
            }), o(r, t);
        }, f(t);
    }
    function c(t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
    }
    var a, h = function() {
        this.before = void 0, this.beforeLeave = void 0, this.leave = void 0, this.afterLeave = void 0, this.beforeEnter = void 0, this.enter = void 0, this.afterEnter = void 0, this.after = void 0;
    };
    !function(t) {
        t[t.off = 0] = "off", t[t.error = 1] = "error", t[t.warning = 2] = "warning", t[t.info = 3] = "info", t[t.debug = 4] = "debug";
    }(a || (a = {}));
    var v = a.off, d = /*#__PURE__*/ function() {
        function t(t) {
            this.t = void 0, this.t = t;
        }
        t.getLevel = function() {
            return v;
        }, t.setLevel = function(t) {
            return v = a[t];
        };
        var n = t.prototype;
        return n.error = function() {
            this.i(console.error, a.error, [].slice.call(arguments));
        }, n.warn = function() {
            this.i(console.warn, a.warning, [].slice.call(arguments));
        }, n.info = function() {
            this.i(console.info, a.info, [].slice.call(arguments));
        }, n.debug = function() {
            this.i(console.log, a.debug, [].slice.call(arguments));
        }, n.i = function(n, r, i) {
            r <= t.getLevel() && n.apply(console, [
                "[" + this.t + "] "
            ].concat(i));
        }, t;
    }();
    function l(t) {
        return t.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
    }
    function p(t) {
        return t && t.sensitive ? "" : "i";
    }
    var m = {
        container: "container",
        history: "history",
        namespace: "namespace",
        prefix: "data-barba",
        prevent: "prevent",
        wrapper: "wrapper"
    }, w = /*#__PURE__*/ function() {
        function t() {
            this.o = m, this.u = void 0, this.h = {
                after: null,
                before: null,
                parent: null
            };
        }
        var n = t.prototype;
        return n.toString = function(t) {
            return t.outerHTML;
        }, n.toDocument = function(t) {
            return this.u || (this.u = new DOMParser), this.u.parseFromString(t, "text/html");
        }, n.toElement = function(t) {
            var n = document.createElement("div");
            return n.innerHTML = t, n;
        }, n.getHtml = function(t) {
            return void 0 === t && (t = document), this.toString(t.documentElement);
        }, n.getWrapper = function(t) {
            return void 0 === t && (t = document), t.querySelector("[" + this.o.prefix + '="' + this.o.wrapper + '"]');
        }, n.getContainer = function(t) {
            return void 0 === t && (t = document), t.querySelector("[" + this.o.prefix + '="' + this.o.container + '"]');
        }, n.removeContainer = function(t) {
            document.body.contains(t) && (this.v(t), t.parentNode.removeChild(t));
        }, n.addContainer = function(t, n) {
            var r = this.getContainer() || this.h.before;
            r ? this.l(t, r) : this.h.after ? this.h.after.parentNode.insertBefore(t, this.h.after) : this.h.parent ? this.h.parent.appendChild(t) : n.appendChild(t);
        }, n.getSibling = function() {
            return this.h;
        }, n.getNamespace = function(t) {
            void 0 === t && (t = document);
            var n = t.querySelector("[" + this.o.prefix + "-" + this.o.namespace + "]");
            return n ? n.getAttribute(this.o.prefix + "-" + this.o.namespace) : null;
        }, n.getHref = function(t) {
            if (t.tagName && "a" === t.tagName.toLowerCase()) {
                if ("string" == typeof t.href) return t.href;
                var n = t.getAttribute("href") || t.getAttribute("xlink:href");
                if (n) return this.resolveUrl(n.baseVal || n);
            }
            return null;
        }, n.resolveUrl = function() {
            var t = [].slice.call(arguments).length;
            if (0 === t) throw new Error("resolveUrl requires at least one argument; got none.");
            var n = document.createElement("base");
            if (n.href = arguments[0], 1 === t) return n.href;
            var r = document.getElementsByTagName("head")[0];
            r.insertBefore(n, r.firstChild);
            for(var i, e = document.createElement("a"), o = 1; o < t; o++)e.href = arguments[o], n.href = i = e.href;
            return r.removeChild(n), i;
        }, n.l = function(t, n) {
            n.parentNode.insertBefore(t, n.nextSibling);
        }, n.v = function(t) {
            return this.h = {
                after: t.nextElementSibling,
                before: t.previousElementSibling,
                parent: t.parentElement
            }, this.h;
        }, t;
    }(), b = new w, y = /*#__PURE__*/ function() {
        function t() {
            this.p = void 0, this.m = [], this.P = -1;
        }
        var i = t.prototype;
        return i.init = function(t, n) {
            this.p = "barba";
            var r = {
                data: {},
                ns: n,
                scroll: {
                    x: window.scrollX,
                    y: window.scrollY
                },
                url: t
            };
            this.P = 0, this.m.push(r);
            var i = {
                from: this.p,
                index: this.P,
                states: [].concat(this.m)
            };
            window.history && window.history.replaceState(i, "", t);
        }, i.change = function(t, n, r) {
            if (r && r.state) {
                var i = r.state, e = i.index;
                n = this.g(this.P - e), this.replace(i.states), this.P = e;
            } else this.add(t, n);
            return n;
        }, i.add = function(t, n, r, i) {
            var e = null != r ? r : this.R(n), o = {
                data: null != i ? i : {},
                ns: "tmp",
                scroll: {
                    x: window.scrollX,
                    y: window.scrollY
                },
                url: t
            };
            switch(e){
                case "push":
                    this.P = this.size, this.m.push(o);
                    break;
                case "replace":
                    this.set(this.P, o);
            }
            var u = {
                from: this.p,
                index: this.P,
                states: [].concat(this.m)
            };
            switch(e){
                case "push":
                    window.history && window.history.pushState(u, "", t);
                    break;
                case "replace":
                    window.history && window.history.replaceState(u, "", t);
            }
        }, i.store = function(t, n) {
            var i = n || this.P, e = this.get(i);
            e.data = r({}, e.data, t), this.set(i, e);
            var o = {
                from: this.p,
                index: this.P,
                states: [].concat(this.m)
            };
            window.history.replaceState(o, "");
        }, i.update = function(t, n) {
            var i = n || this.P, e = r({}, this.get(i), t);
            this.set(i, e);
        }, i.remove = function(t) {
            t ? this.m.splice(t, 1) : this.m.pop(), this.P--;
        }, i.clear = function() {
            this.m = [], this.P = -1;
        }, i.replace = function(t) {
            this.m = t;
        }, i.get = function(t) {
            return this.m[t];
        }, i.set = function(t, n) {
            return this.m[t] = n;
        }, i.R = function(t) {
            var n = "push", r = t, i = m.prefix + "-" + m.history;
            return r.hasAttribute && r.hasAttribute(i) && (n = r.getAttribute(i)), n;
        }, i.g = function(t) {
            return Math.abs(t) > 1 ? t > 0 ? "forward" : "back" : 0 === t ? "popstate" : t > 0 ? "back" : "forward";
        }, n(t, [
            {
                key: "current",
                get: function() {
                    return this.m[this.P];
                }
            },
            {
                key: "previous",
                get: function() {
                    return this.P < 1 ? null : this.m[this.P - 1];
                }
            },
            {
                key: "size",
                get: function() {
                    return this.m.length;
                }
            }
        ]), t;
    }(), P = new y, g = function(t, n) {
        try {
            var r = function() {
                if (!n.next.html) return Promise.resolve(t).then(function(t) {
                    var r = n.next;
                    if (t) {
                        var i = b.toElement(t.html);
                        r.namespace = b.getNamespace(i), r.container = b.getContainer(i), r.url = t.url, r.html = t.html, P.update({
                            ns: r.namespace
                        });
                        var e = b.toDocument(t.html);
                        document.title = e.title;
                    }
                });
            }();
            return Promise.resolve(r && r.then ? r.then(function() {}) : void 0);
        } catch (t) {
            return Promise.reject(t);
        }
    }, E = function t(n, r, i) {
        return n instanceof RegExp ? function(t, n) {
            if (!n) return t;
            for(var r = /\((?:\?<(.*?)>)?(?!\?)/g, i = 0, e = r.exec(t.source); e;)n.push({
                name: e[1] || i++,
                prefix: "",
                suffix: "",
                modifier: "",
                pattern: ""
            }), e = r.exec(t.source);
            return t;
        }(n, r) : Array.isArray(n) ? function(n, r, i) {
            var e = n.map(function(n) {
                return t(n, r, i).source;
            });
            return new RegExp("(?:".concat(e.join("|"), ")"), p(i));
        }(n, r, i) : function(t, n, r) {
            return function(t, n, r) {
                void 0 === r && (r = {});
                for(var i = r.strict, e = void 0 !== i && i, o = r.start, u = void 0 === o || o, s = r.end, f = void 0 === s || s, c = r.encode, a = void 0 === c ? function(t) {
                    return t;
                } : c, h = r.delimiter, v = void 0 === h ? "/#?" : h, d = r.endsWith, m = "[".concat(l(void 0 === d ? "" : d), "]|$"), w = "[".concat(l(v), "]"), b = u ? "^" : "", y = 0, P = t; y < P.length; y++){
                    var g = P[y];
                    if ("string" == typeof g) b += l(a(g));
                    else {
                        var E = l(a(g.prefix)), x = l(a(g.suffix));
                        if (g.pattern) {
                            if (n && n.push(g), E || x) {
                                if ("+" === g.modifier || "*" === g.modifier) {
                                    var R = "*" === g.modifier ? "?" : "";
                                    b += "(?:".concat(E, "((?:").concat(g.pattern, ")(?:").concat(x).concat(E, "(?:").concat(g.pattern, "))*)").concat(x, ")").concat(R);
                                } else b += "(?:".concat(E, "(").concat(g.pattern, ")").concat(x, ")").concat(g.modifier);
                            } else b += "+" === g.modifier || "*" === g.modifier ? "((?:".concat(g.pattern, ")").concat(g.modifier, ")") : "(".concat(g.pattern, ")").concat(g.modifier);
                        } else b += "(?:".concat(E).concat(x, ")").concat(g.modifier);
                    }
                }
                if (f) e || (b += "".concat(w, "?")), b += r.endsWith ? "(?=".concat(m, ")") : "$";
                else {
                    var k = t[t.length - 1], O = "string" == typeof k ? w.indexOf(k[k.length - 1]) > -1 : void 0 === k;
                    e || (b += "(?:".concat(w, "(?=").concat(m, "))?")), O || (b += "(?=".concat(w, "|").concat(m, ")"));
                }
                return new RegExp(b, p(r));
            }(function(t, n) {
                void 0 === n && (n = {});
                for(var r = function(t) {
                    for(var n = [], r = 0; r < t.length;){
                        var i = t[r];
                        if ("*" !== i && "+" !== i && "?" !== i) {
                            if ("\\" !== i) {
                                if ("{" !== i) {
                                    if ("}" !== i) {
                                        if (":" !== i) {
                                            if ("(" !== i) n.push({
                                                type: "CHAR",
                                                index: r,
                                                value: t[r++]
                                            });
                                            else {
                                                var e = 1, o = "";
                                                if ("?" === t[s = r + 1]) throw new TypeError('Pattern cannot start with "?" at '.concat(s));
                                                for(; s < t.length;)if ("\\" !== t[s]) {
                                                    if (")" === t[s]) {
                                                        if (0 == --e) {
                                                            s++;
                                                            break;
                                                        }
                                                    } else if ("(" === t[s] && (e++, "?" !== t[s + 1])) throw new TypeError("Capturing groups are not allowed at ".concat(s));
                                                    o += t[s++];
                                                } else o += t[s++] + t[s++];
                                                if (e) throw new TypeError("Unbalanced pattern at ".concat(r));
                                                if (!o) throw new TypeError("Missing pattern at ".concat(r));
                                                n.push({
                                                    type: "PATTERN",
                                                    index: r,
                                                    value: o
                                                }), r = s;
                                            }
                                        } else {
                                            for(var u = "", s = r + 1; s < t.length;){
                                                var f = t.charCodeAt(s);
                                                if (!(f >= 48 && f <= 57 || f >= 65 && f <= 90 || f >= 97 && f <= 122 || 95 === f)) break;
                                                u += t[s++];
                                            }
                                            if (!u) throw new TypeError("Missing parameter name at ".concat(r));
                                            n.push({
                                                type: "NAME",
                                                index: r,
                                                value: u
                                            }), r = s;
                                        }
                                    } else n.push({
                                        type: "CLOSE",
                                        index: r,
                                        value: t[r++]
                                    });
                                } else n.push({
                                    type: "OPEN",
                                    index: r,
                                    value: t[r++]
                                });
                            } else n.push({
                                type: "ESCAPED_CHAR",
                                index: r++,
                                value: t[r++]
                            });
                        } else n.push({
                            type: "MODIFIER",
                            index: r,
                            value: t[r++]
                        });
                    }
                    return n.push({
                        type: "END",
                        index: r,
                        value: ""
                    }), n;
                }(t), i = n.prefixes, e = void 0 === i ? "./" : i, o = "[^".concat(l(n.delimiter || "/#?"), "]+?"), u = [], s = 0, f = 0, c = "", a = function(t) {
                    if (f < r.length && r[f].type === t) return r[f++].value;
                }, h = function(t) {
                    var n = a(t);
                    if (void 0 !== n) return n;
                    var i = r[f], e = i.index;
                    throw new TypeError("Unexpected ".concat(i.type, " at ").concat(e, ", expected ").concat(t));
                }, v = function() {
                    for(var t, n = ""; t = a("CHAR") || a("ESCAPED_CHAR");)n += t;
                    return n;
                }; f < r.length;){
                    var d = a("CHAR"), p = a("NAME"), m = a("PATTERN");
                    if (p || m) -1 === e.indexOf(b = d || "") && (c += b, b = ""), c && (u.push(c), c = ""), u.push({
                        name: p || s++,
                        prefix: b,
                        suffix: "",
                        pattern: m || o,
                        modifier: a("MODIFIER") || ""
                    });
                    else {
                        var w = d || a("ESCAPED_CHAR");
                        if (w) c += w;
                        else if (c && (u.push(c), c = ""), a("OPEN")) {
                            var b = v(), y = a("NAME") || "", P = a("PATTERN") || "", g = v();
                            h("CLOSE"), u.push({
                                name: y || (P ? s++ : ""),
                                pattern: y && !P ? o : P,
                                prefix: b,
                                suffix: g,
                                modifier: a("MODIFIER") || ""
                            });
                        } else h("END");
                    }
                }
                return u;
            }(t, r), n, r);
        }(n, r, i);
    }, x = {
        __proto__: null,
        update: g,
        nextTick: function() {
            return new Promise(function(t) {
                window.requestAnimationFrame(t);
            });
        },
        pathToRegexp: E
    }, R = function() {
        return window.location.origin;
    }, k = function(t) {
        return void 0 === t && (t = window.location.href), O(t).port;
    }, O = function(t) {
        var n, r = t.match(/:\d+/);
        if (null === r) /^http/.test(t) && (n = 80), /^https/.test(t) && (n = 443);
        else {
            var i = r[0].substring(1);
            n = parseInt(i, 10);
        }
        var e, o = t.replace(R(), ""), u = {}, s = o.indexOf("#");
        s >= 0 && (e = o.slice(s + 1), o = o.slice(0, s));
        var f = o.indexOf("?");
        return f >= 0 && (u = T(o.slice(f + 1)), o = o.slice(0, f)), {
            hash: e,
            path: o,
            port: n,
            query: u
        };
    }, T = function(t) {
        return t.split("&").reduce(function(t, n) {
            var r = n.split("=");
            return t[r[0]] = r[1], t;
        }, {});
    }, A = function(t) {
        return void 0 === t && (t = window.location.href), t.replace(/(\/#.*|\/|#.*)$/, "");
    }, j = {
        __proto__: null,
        getHref: function() {
            return window.location.href;
        },
        getAbsoluteHref: function(t, n) {
            return void 0 === n && (n = document.baseURI), new URL(t, n).href;
        },
        getOrigin: R,
        getPort: k,
        getPath: function(t) {
            return void 0 === t && (t = window.location.href), O(t).path;
        },
        getQuery: function(t, n) {
            return void 0 === n && (n = !1), n ? JSON.stringify(O(t).query) : O(t).query;
        },
        getHash: function(t) {
            return O(t).hash;
        },
        parse: O,
        parseQuery: T,
        clean: A
    };
    function M(t, n, i, e, o) {
        return void 0 === n && (n = 2e3), new Promise(function(u, s) {
            var f = new XMLHttpRequest;
            f.onreadystatechange = function() {
                if (f.readyState === XMLHttpRequest.DONE) {
                    if (200 === f.status) {
                        var n = "" !== f.responseURL && f.responseURL !== t ? f.responseURL : t;
                        u({
                            html: f.responseText,
                            url: r({
                                href: n
                            }, O(n))
                        }), e.update(t, {
                            status: "fulfilled",
                            target: n
                        });
                    } else if (f.status) {
                        var o = {
                            status: f.status,
                            statusText: f.statusText
                        };
                        i(t, o), s(o), e.update(t, {
                            status: "rejected"
                        });
                    }
                }
            }, f.ontimeout = function() {
                var r = new Error("Timeout error [" + n + "]");
                i(t, r), s(r), e.update(t, {
                    status: "rejected"
                });
            }, f.onerror = function() {
                var n = new Error("Fetch error");
                i(t, n), s(n), e.update(t, {
                    status: "rejected"
                });
            }, f.open("GET", t), f.timeout = n, f.setRequestHeader("Accept", "text/html,application/xhtml+xml,application/xml"), f.setRequestHeader("x-barba", "yes"), o.all().forEach(function(t, n) {
                f.setRequestHeader(n, t);
            }), f.send();
        });
    }
    function N(t) {
        return !!t && ("object" == typeof t || "function" == typeof t) && "function" == typeof t.then;
    }
    function S(t, n) {
        return void 0 === n && (n = {}), function() {
            var r = arguments, i = !1, e = new Promise(function(e, o) {
                n.async = function() {
                    return i = !0, function(t, n) {
                        t ? o(t) : e(n);
                    };
                };
                var u = t.apply(n, [].slice.call(r));
                i || (N(u) ? u.then(e, o) : e(u));
            });
            return e;
        };
    }
    var C = /*#__PURE__*/ function(t) {
        function n() {
            var n;
            return (n = t.call(this) || this).logger = new d("@barba/core"), n.all = [
                "ready",
                "page",
                "reset",
                "currentAdded",
                "currentRemoved",
                "nextAdded",
                "nextRemoved",
                "beforeOnce",
                "once",
                "afterOnce",
                "before",
                "beforeLeave",
                "leave",
                "afterLeave",
                "beforeEnter",
                "enter",
                "afterEnter",
                "after"
            ], n.registered = new Map, n.init(), n;
        }
        i(n, t);
        var r = n.prototype;
        return r.init = function() {
            var t = this;
            this.registered.clear(), this.all.forEach(function(n) {
                t[n] || (t[n] = function(r, i) {
                    t.registered.has(n) || t.registered.set(n, new Set), t.registered.get(n).add({
                        ctx: i || {},
                        fn: r
                    });
                });
            });
        }, r.do = function(t) {
            var n = arguments, r = this;
            if (this.registered.has(t)) {
                var i = Promise.resolve();
                return this.registered.get(t).forEach(function(t) {
                    i = i.then(function() {
                        return S(t.fn, t.ctx).apply(void 0, [].slice.call(n, 1));
                    });
                }), i.catch(function(n) {
                    r.logger.debug("Hook error [" + t + "]"), r.logger.error(n);
                });
            }
            return Promise.resolve();
        }, r.clear = function() {
            var t = this;
            this.all.forEach(function(n) {
                delete t[n];
            }), this.init();
        }, r.help = function() {
            this.logger.info("Available hooks: " + this.all.join(","));
            var t = [];
            this.registered.forEach(function(n, r) {
                return t.push(r);
            }), this.logger.info("Registered hooks: " + t.join(","));
        }, n;
    }(h), L = new C, H = /*#__PURE__*/ function() {
        function t(t) {
            if (this.k = void 0, this.O = [], "boolean" == typeof t) this.k = t;
            else {
                var n = Array.isArray(t) ? t : [
                    t
                ];
                this.O = n.map(function(t) {
                    return E(t);
                });
            }
        }
        return t.prototype.checkHref = function(t) {
            if ("boolean" == typeof this.k) return this.k;
            var n = O(t).path;
            return this.O.some(function(t) {
                return null !== t.exec(n);
            });
        }, t;
    }(), _ = /*#__PURE__*/ function(t) {
        function n(n) {
            var r;
            return (r = t.call(this, n) || this).T = new Map, r;
        }
        i(n, t);
        var e = n.prototype;
        return e.set = function(t, n, r, i, e) {
            return this.T.set(t, {
                action: r,
                request: n,
                status: i,
                target: null != e ? e : t
            }), {
                action: r,
                request: n,
                status: i,
                target: e
            };
        }, e.get = function(t) {
            return this.T.get(t);
        }, e.getRequest = function(t) {
            return this.T.get(t).request;
        }, e.getAction = function(t) {
            return this.T.get(t).action;
        }, e.getStatus = function(t) {
            return this.T.get(t).status;
        }, e.getTarget = function(t) {
            return this.T.get(t).target;
        }, e.has = function(t) {
            return !this.checkHref(t) && this.T.has(t);
        }, e.delete = function(t) {
            return this.T.delete(t);
        }, e.update = function(t, n) {
            var i = r({}, this.T.get(t), n);
            return this.T.set(t, i), i;
        }, n;
    }(H), D = /*#__PURE__*/ function() {
        function t() {
            this.A = new Map;
        }
        var n = t.prototype;
        return n.set = function(t, n) {
            return this.A.set(t, n), {
                name: n
            };
        }, n.get = function(t) {
            return this.A.get(t);
        }, n.all = function() {
            return this.A;
        }, n.has = function(t) {
            return this.A.has(t);
        }, n.delete = function(t) {
            return this.A.delete(t);
        }, n.clear = function() {
            return this.A.clear();
        }, t;
    }(), B = function() {
        return !window.history.pushState;
    }, q = function(t) {
        return !t.el || !t.href;
    }, F = function(t) {
        var n = t.event;
        return n.which > 1 || n.metaKey || n.ctrlKey || n.shiftKey || n.altKey;
    }, I = function(t) {
        var n = t.el;
        return n.hasAttribute("target") && "_blank" === n.target;
    }, U = function(t) {
        var n = t.el;
        return void 0 !== n.protocol && window.location.protocol !== n.protocol || void 0 !== n.hostname && window.location.hostname !== n.hostname;
    }, $ = function(t) {
        var n = t.el;
        return void 0 !== n.port && k() !== k(n.href);
    }, Q = function(t) {
        var n = t.el;
        return n.getAttribute && "string" == typeof n.getAttribute("download");
    }, X = function(t) {
        return t.el.hasAttribute(m.prefix + "-" + m.prevent);
    }, z = function(t) {
        return Boolean(t.el.closest("[" + m.prefix + "-" + m.prevent + '="all"]'));
    }, G = function(t) {
        var n = t.href;
        return A(n) === A() && k(n) === k();
    }, J = /*#__PURE__*/ function(t) {
        function n(n) {
            var r;
            return (r = t.call(this, n) || this).suite = [], r.tests = new Map, r.init(), r;
        }
        i(n, t);
        var r = n.prototype;
        return r.init = function() {
            this.add("pushState", B), this.add("exists", q), this.add("newTab", F), this.add("blank", I), this.add("corsDomain", U), this.add("corsPort", $), this.add("download", Q), this.add("preventSelf", X), this.add("preventAll", z), this.add("sameUrl", G, !1);
        }, r.add = function(t, n, r) {
            void 0 === r && (r = !0), this.tests.set(t, n), r && this.suite.push(t);
        }, r.run = function(t, n, r, i) {
            return this.tests.get(t)({
                el: n,
                event: r,
                href: i
            });
        }, r.checkLink = function(t, n, r) {
            var i = this;
            return this.suite.some(function(e) {
                return i.run(e, t, n, r);
            });
        }, n;
    }(H), W = /*#__PURE__*/ function(t) {
        function n(r, i) {
            var e;
            return void 0 === i && (i = "Barba error"), (e = t.call.apply(t, [
                this
            ].concat([].slice.call(arguments, 2))) || this).error = void 0, e.label = void 0, e.error = r, e.label = i, Error.captureStackTrace && Error.captureStackTrace(c(e), n), e.name = "BarbaError", e;
        }
        return i(n, t), n;
    }(/*#__PURE__*/ f(Error)), K = /*#__PURE__*/ function() {
        function t(t) {
            void 0 === t && (t = []), this.logger = new d("@barba/core"), this.all = [], this.page = [], this.once = [], this.j = [
                {
                    name: "namespace",
                    type: "strings"
                },
                {
                    name: "custom",
                    type: "function"
                }
            ], t && (this.all = this.all.concat(t)), this.update();
        }
        var n = t.prototype;
        return n.add = function(t, n) {
            "rule" === t ? this.j.splice(n.position || 0, 0, n.value) : this.all.push(n), this.update();
        }, n.resolve = function(t, n) {
            var r = this;
            void 0 === n && (n = {});
            var i = n.once ? this.once : this.page;
            i = i.filter(n.self ? function(t) {
                return t.name && "self" === t.name;
            } : function(t) {
                return !t.name || "self" !== t.name;
            });
            var e = new Map, o = i.find(function(i) {
                var o = !0, u = {};
                return n.self && "self" === i.name ? (e.set(i, u), !0) : (r.j.reverse().forEach(function(n) {
                    o && (o = r.M(i, n, t, u), i.from && i.to && (o = r.M(i, n, t, u, "from") && r.M(i, n, t, u, "to")), i.from && !i.to && (o = r.M(i, n, t, u, "from")), !i.from && i.to && (o = r.M(i, n, t, u, "to")));
                }), e.set(i, u), o);
            }), u = e.get(o), s = [];
            if (s.push(n.once ? "once" : "page"), n.self && s.push("self"), u) {
                var f, c = [
                    o
                ];
                Object.keys(u).length > 0 && c.push(u), (f = this.logger).info.apply(f, [
                    "Transition found [" + s.join(",") + "]"
                ].concat(c));
            } else this.logger.info("No transition found [" + s.join(",") + "]");
            return o;
        }, n.update = function() {
            var t = this;
            this.all = this.all.map(function(n) {
                return t.N(n);
            }).sort(function(t, n) {
                return t.priority - n.priority;
            }).reverse().map(function(t) {
                return delete t.priority, t;
            }), this.page = this.all.filter(function(t) {
                return void 0 !== t.leave || void 0 !== t.enter;
            }), this.once = this.all.filter(function(t) {
                return void 0 !== t.once;
            });
        }, n.M = function(t, n, r, i, e) {
            var o = !0, u = !1, s = t, f = n.name, c = f, a = f, h = f, v = e ? s[e] : s, d = "to" === e ? r.next : r.current;
            if (e ? v && v[f] : v[f]) {
                switch(n.type){
                    case "strings":
                    default:
                        var l = Array.isArray(v[c]) ? v[c] : [
                            v[c]
                        ];
                        d[c] && -1 !== l.indexOf(d[c]) && (u = !0), -1 === l.indexOf(d[c]) && (o = !1);
                        break;
                    case "object":
                        var p = Array.isArray(v[a]) ? v[a] : [
                            v[a]
                        ];
                        d[a] ? (d[a].name && -1 !== p.indexOf(d[a].name) && (u = !0), -1 === p.indexOf(d[a].name) && (o = !1)) : o = !1;
                        break;
                    case "function":
                        v[h](r) ? u = !0 : o = !1;
                }
                u && (e ? (i[e] = i[e] || {}, i[e][f] = s[e][f]) : i[f] = s[f]);
            }
            return o;
        }, n.S = function(t, n, r) {
            var i = 0;
            return (t[n] || t.from && t.from[n] || t.to && t.to[n]) && (i += Math.pow(10, r), t.from && t.from[n] && (i += 1), t.to && t.to[n] && (i += 2)), i;
        }, n.N = function(t) {
            var n = this;
            t.priority = 0;
            var r = 0;
            return this.j.forEach(function(i, e) {
                r += n.S(t, i.name, e + 1);
            }), t.priority = r, t;
        }, t;
    }();
    function V(t, n) {
        try {
            var r = t();
        } catch (t) {
            return n(t);
        }
        return r && r.then ? r.then(void 0, n) : r;
    }
    var Y = /*#__PURE__*/ function() {
        function t(t) {
            void 0 === t && (t = []), this.logger = new d("@barba/core"), this.store = void 0, this.C = !1, this.store = new K(t);
        }
        var r = t.prototype;
        return r.get = function(t, n) {
            return this.store.resolve(t, n);
        }, r.doOnce = function(t) {
            var n = t.data, r = t.transition;
            try {
                var i = function() {
                    e.C = !1;
                }, e = this, o = r || {};
                e.C = !0;
                var u = V(function() {
                    return Promise.resolve(e.L("beforeOnce", n, o)).then(function() {
                        return Promise.resolve(e.once(n, o)).then(function() {
                            return Promise.resolve(e.L("afterOnce", n, o)).then(function() {});
                        });
                    });
                }, function(t) {
                    e.C = !1, e.logger.debug("Transition error [before/after/once]"), e.logger.error(t);
                });
                return Promise.resolve(u && u.then ? u.then(i) : i());
            } catch (t) {
                return Promise.reject(t);
            }
        }, r.doPage = function(t) {
            var n = t.data, r = t.transition, i = t.page, e = t.wrapper;
            try {
                var o = function(t) {
                    u.C = !1;
                }, u = this, s = r || {}, f = !0 === s.sync || !1;
                u.C = !0;
                var c = V(function() {
                    function t() {
                        return Promise.resolve(u.L("before", n, s)).then(function() {
                            function t(t) {
                                return Promise.resolve(u.remove(n)).then(function() {
                                    return Promise.resolve(u.L("after", n, s)).then(function() {});
                                });
                            }
                            var r = function() {
                                if (f) return V(function() {
                                    return Promise.resolve(u.add(n, e)).then(function() {
                                        return Promise.resolve(u.L("beforeLeave", n, s)).then(function() {
                                            return Promise.resolve(u.L("beforeEnter", n, s)).then(function() {
                                                return Promise.resolve(Promise.all([
                                                    u.leave(n, s),
                                                    u.enter(n, s)
                                                ])).then(function() {
                                                    return Promise.resolve(u.L("afterLeave", n, s)).then(function() {
                                                        return Promise.resolve(u.L("afterEnter", n, s)).then(function() {});
                                                    });
                                                });
                                            });
                                        });
                                    });
                                }, function(t) {
                                    if (u.H(t)) throw new W(t, "Transition error [sync]");
                                });
                                var t = function(t) {
                                    return V(function() {
                                        var t = function() {
                                            if (!1 !== r) return Promise.resolve(u.add(n, e)).then(function() {
                                                return Promise.resolve(u.L("beforeEnter", n, s)).then(function() {
                                                    return Promise.resolve(u.enter(n, s, r)).then(function() {
                                                        return Promise.resolve(u.L("afterEnter", n, s)).then(function() {});
                                                    });
                                                });
                                            });
                                        }();
                                        if (t && t.then) return t.then(function() {});
                                    }, function(t) {
                                        if (u.H(t)) throw new W(t, "Transition error [before/after/enter]");
                                    });
                                }, r = !1, o = V(function() {
                                    return Promise.resolve(u.L("beforeLeave", n, s)).then(function() {
                                        return Promise.resolve(Promise.all([
                                            u.leave(n, s),
                                            g(i, n)
                                        ]).then(function(t) {
                                            return t[0];
                                        })).then(function(t) {
                                            return r = t, Promise.resolve(u.L("afterLeave", n, s)).then(function() {});
                                        });
                                    });
                                }, function(t) {
                                    if (u.H(t)) throw new W(t, "Transition error [before/after/leave]");
                                });
                                return o && o.then ? o.then(t) : t();
                            }();
                            return r && r.then ? r.then(t) : t();
                        });
                    }
                    var r = function() {
                        if (f) return Promise.resolve(g(i, n)).then(function() {});
                    }();
                    return r && r.then ? r.then(t) : t();
                }, function(t) {
                    if (u.C = !1, t.name && "BarbaError" === t.name) throw u.logger.debug(t.label), u.logger.error(t.error), t;
                    throw u.logger.debug("Transition error [page]"), u.logger.error(t), t;
                });
                return Promise.resolve(c && c.then ? c.then(o) : o());
            } catch (t) {
                return Promise.reject(t);
            }
        }, r.once = function(t, n) {
            try {
                return Promise.resolve(L.do("once", t, n)).then(function() {
                    return n.once ? S(n.once, n)(t) : Promise.resolve();
                });
            } catch (t) {
                return Promise.reject(t);
            }
        }, r.leave = function(t, n) {
            try {
                return Promise.resolve(L.do("leave", t, n)).then(function() {
                    return n.leave ? S(n.leave, n)(t) : Promise.resolve();
                });
            } catch (t) {
                return Promise.reject(t);
            }
        }, r.enter = function(t, n, r) {
            try {
                return Promise.resolve(L.do("enter", t, n)).then(function() {
                    return n.enter ? S(n.enter, n)(t, r) : Promise.resolve();
                });
            } catch (t) {
                return Promise.reject(t);
            }
        }, r.add = function(t, n) {
            try {
                return b.addContainer(t.next.container, n), L.do("nextAdded", t), Promise.resolve();
            } catch (t) {
                return Promise.reject(t);
            }
        }, r.remove = function(t) {
            try {
                return b.removeContainer(t.current.container), L.do("currentRemoved", t), Promise.resolve();
            } catch (t) {
                return Promise.reject(t);
            }
        }, r.H = function(t) {
            return t.message ? !/Timeout error|Fetch error/.test(t.message) : !t.status;
        }, r.L = function(t, n, r) {
            try {
                return Promise.resolve(L.do(t, n, r)).then(function() {
                    return r[t] ? S(r[t], r)(n) : Promise.resolve();
                });
            } catch (t) {
                return Promise.reject(t);
            }
        }, n(t, [
            {
                key: "isRunning",
                get: function() {
                    return this.C;
                },
                set: function(t) {
                    this.C = t;
                }
            },
            {
                key: "hasOnce",
                get: function() {
                    return this.store.once.length > 0;
                }
            },
            {
                key: "hasSelf",
                get: function() {
                    return this.store.all.some(function(t) {
                        return "self" === t.name;
                    });
                }
            },
            {
                key: "shouldWait",
                get: function() {
                    return this.store.all.some(function(t) {
                        return t.to && !t.to.route || t.sync;
                    });
                }
            }
        ]), t;
    }(), Z = /*#__PURE__*/ function() {
        function t(t) {
            var n = this;
            this.names = [
                "beforeLeave",
                "afterLeave",
                "beforeEnter",
                "afterEnter"
            ], this.byNamespace = new Map, 0 !== t.length && (t.forEach(function(t) {
                n.byNamespace.set(t.namespace, t);
            }), this.names.forEach(function(t) {
                L[t](n._(t));
            }));
        }
        return t.prototype._ = function(t) {
            var n = this;
            return function(r) {
                var i = t.match(/enter/i) ? r.next : r.current, e = n.byNamespace.get(i.namespace);
                return e && e[t] ? S(e[t], e)(r) : Promise.resolve();
            };
        }, t;
    }();
    Element.prototype.matches || (Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector), Element.prototype.closest || (Element.prototype.closest = function(t) {
        var n = this;
        do {
            if (n.matches(t)) return n;
            n = n.parentElement || n.parentNode;
        }while (null !== n && 1 === n.nodeType);
        return null;
    });
    var tt = {
        container: null,
        html: "",
        namespace: "",
        url: {
            hash: "",
            href: "",
            path: "",
            port: null,
            query: {}
        }
    }, nt = /*#__PURE__*/ function() {
        function t() {
            this.version = "2.10.3", this.schemaPage = tt, this.Logger = d, this.logger = new d("@barba/core"), this.plugins = [], this.timeout = void 0, this.cacheIgnore = void 0, this.cacheFirstPage = void 0, this.prefetchIgnore = void 0, this.preventRunning = void 0, this.hooks = L, this.cache = void 0, this.headers = void 0, this.prevent = void 0, this.transitions = void 0, this.views = void 0, this.dom = b, this.helpers = x, this.history = P, this.request = M, this.url = j, this.D = void 0, this.B = void 0, this.q = void 0, this.F = void 0;
        }
        var i = t.prototype;
        return i.use = function(t, n) {
            var r = this.plugins;
            r.indexOf(t) > -1 ? this.logger.warn("Plugin [" + t.name + "] already installed.") : "function" == typeof t.install ? (t.install(this, n), r.push(t)) : this.logger.warn("Plugin [" + t.name + '] has no "install" method.');
        }, i.init = function(t) {
            var n = void 0 === t ? {} : t, i = n.transitions, e = void 0 === i ? [] : i, o = n.views, u = void 0 === o ? [] : o, s = n.schema, f = void 0 === s ? m : s, c = n.requestError, a = n.timeout, h = void 0 === a ? 2e3 : a, v = n.cacheIgnore, l = void 0 !== v && v, p = n.cacheFirstPage, w = void 0 !== p && p, b = n.prefetchIgnore, y = void 0 !== b && b, P = n.preventRunning, g = void 0 !== P && P, E = n.prevent, x = void 0 === E ? null : E, R = n.debug, k = n.logLevel;
            if (d.setLevel(!0 === (void 0 !== R && R) ? "debug" : void 0 === k ? "off" : k), this.logger.info(this.version), Object.keys(f).forEach(function(t) {
                m[t] && (m[t] = f[t]);
            }), this.B = c, this.timeout = h, this.cacheIgnore = l, this.cacheFirstPage = w, this.prefetchIgnore = y, this.preventRunning = g, this.q = this.dom.getWrapper(), !this.q) throw new Error("[@barba/core] No Barba wrapper found");
            this.I();
            var O = this.data.current;
            if (!O.container) throw new Error("[@barba/core] No Barba container found");
            if (this.cache = new _(l), this.headers = new D, this.prevent = new J(y), this.transitions = new Y(e), this.views = new Z(u), null !== x) {
                if ("function" != typeof x) throw new Error("[@barba/core] Prevent should be a function");
                this.prevent.add("preventCustom", x);
            }
            this.history.init(O.url.href, O.namespace), w && this.cache.set(O.url.href, Promise.resolve({
                html: O.html,
                url: O.url
            }), "init", "fulfilled"), this.U = this.U.bind(this), this.$ = this.$.bind(this), this.X = this.X.bind(this), this.G(), this.plugins.forEach(function(t) {
                return t.init();
            });
            var T = this.data;
            T.trigger = "barba", T.next = T.current, T.current = r({}, this.schemaPage), this.hooks.do("ready", T), this.once(T), this.I();
        }, i.destroy = function() {
            this.I(), this.J(), this.history.clear(), this.hooks.clear(), this.plugins = [];
        }, i.force = function(t) {
            window.location.assign(t);
        }, i.go = function(t, n, r) {
            var i;
            if (void 0 === n && (n = "barba"), this.F = null, this.transitions.isRunning) this.force(t);
            else if (!(i = "popstate" === n ? this.history.current && this.url.getPath(this.history.current.url) === this.url.getPath(t) && this.url.getQuery(this.history.current.url, !0) === this.url.getQuery(t, !0) : this.prevent.run("sameUrl", null, null, t)) || this.transitions.hasSelf) return n = this.history.change(this.cache.has(t) ? this.cache.get(t).target : t, n, r), r && (r.stopPropagation(), r.preventDefault()), this.page(t, n, null != r ? r : void 0, i);
        }, i.once = function(t) {
            try {
                var n = this;
                return Promise.resolve(n.hooks.do("beforeEnter", t)).then(function() {
                    function r() {
                        return Promise.resolve(n.hooks.do("afterEnter", t)).then(function() {});
                    }
                    var i = function() {
                        if (n.transitions.hasOnce) {
                            var r = n.transitions.get(t, {
                                once: !0
                            });
                            return Promise.resolve(n.transitions.doOnce({
                                transition: r,
                                data: t
                            })).then(function() {});
                        }
                    }();
                    return i && i.then ? i.then(r) : r();
                });
            } catch (t) {
                return Promise.reject(t);
            }
        }, i.page = function(t, n, i, e) {
            try {
                var o, u = function() {
                    var t = s.data;
                    return Promise.resolve(s.hooks.do("page", t)).then(function() {
                        var n = function(n, r) {
                            try {
                                var i = (u = s.transitions.get(t, {
                                    once: !1,
                                    self: e
                                }), Promise.resolve(s.transitions.doPage({
                                    data: t,
                                    page: o,
                                    transition: u,
                                    wrapper: s.q
                                })).then(function() {
                                    s.I();
                                }));
                            } catch (t) {
                                return r();
                            }
                            var u;
                            return i && i.then ? i.then(void 0, r) : i;
                        }(0, function() {
                            0 === d.getLevel() && s.force(t.next.url.href);
                        });
                        if (n && n.then) return n.then(function() {});
                    });
                }, s = this;
                if (s.data.next.url = r({
                    href: t
                }, s.url.parse(t)), s.data.trigger = n, s.data.event = i, s.cache.has(t)) o = s.cache.update(t, {
                    action: "click"
                }).request;
                else {
                    var f = s.request(t, s.timeout, s.onRequestError.bind(s, n), s.cache, s.headers);
                    f.then(function(r) {
                        r.url.href !== t && s.history.add(r.url.href, n, "replace");
                    }), o = s.cache.set(t, f, "click", "pending").request;
                }
                var c = function() {
                    if (s.transitions.shouldWait) return Promise.resolve(g(o, s.data)).then(function() {});
                }();
                return Promise.resolve(c && c.then ? c.then(u) : u());
            } catch (t) {
                return Promise.reject(t);
            }
        }, i.onRequestError = function(t) {
            this.transitions.isRunning = !1;
            var n = [].slice.call(arguments, 1), r = n[0], i = n[1], e = this.cache.getAction(r);
            return this.cache.delete(r), this.B && !1 === this.B(t, e, r, i) || "click" === e && this.force(r), !1;
        }, i.prefetch = function(t) {
            var n = this;
            t = this.url.getAbsoluteHref(t), this.cache.has(t) || this.cache.set(t, this.request(t, this.timeout, this.onRequestError.bind(this, "barba"), this.cache, this.headers).catch(function(t) {
                n.logger.error(t);
            }), "prefetch", "pending");
        }, i.G = function() {
            !0 !== this.prefetchIgnore && (document.addEventListener("mouseover", this.U), document.addEventListener("touchstart", this.U)), document.addEventListener("click", this.$), window.addEventListener("popstate", this.X);
        }, i.J = function() {
            !0 !== this.prefetchIgnore && (document.removeEventListener("mouseover", this.U), document.removeEventListener("touchstart", this.U)), document.removeEventListener("click", this.$), window.removeEventListener("popstate", this.X);
        }, i.U = function(t) {
            var n = this, r = this.W(t);
            if (r) {
                var i = this.url.getAbsoluteHref(this.dom.getHref(r));
                this.prevent.checkHref(i) || this.cache.has(i) || this.cache.set(i, this.request(i, this.timeout, this.onRequestError.bind(this, r), this.cache, this.headers).catch(function(t) {
                    n.logger.error(t);
                }), "enter", "pending");
            }
        }, i.$ = function(t) {
            var n = this.W(t);
            if (n) {
                if (this.transitions.isRunning && this.preventRunning) return t.preventDefault(), void t.stopPropagation();
                this.F = t, this.go(this.dom.getHref(n), n, t);
            }
        }, i.X = function(t) {
            this.go(this.url.getHref(), "popstate", t);
        }, i.W = function(t) {
            for(var n = t.target; n && !this.dom.getHref(n);)n = n.parentNode;
            if (n && !this.prevent.checkLink(n, t, this.dom.getHref(n))) return n;
        }, i.I = function() {
            var t = this.url.getHref(), n = {
                container: this.dom.getContainer(),
                html: this.dom.getHtml(),
                namespace: this.dom.getNamespace(),
                url: r({
                    href: t
                }, this.url.parse(t))
            };
            this.D = {
                current: n,
                event: void 0,
                next: r({}, this.schemaPage),
                trigger: void 0
            }, this.hooks.do("reset", this.data);
        }, n(t, [
            {
                key: "data",
                get: function() {
                    return this.D;
                }
            },
            {
                key: "wrapper",
                get: function() {
                    return this.q;
                }
            }
        ]), t;
    }();
    return new nt;
});


var $525e6c7d12a445be$exports = {};

var $gP1US = parcelRequire("gP1US");

var $9e7Ip = parcelRequire("9e7Ip");
/*!
 * @maptalks/vt v0.106.2
 * LICENSE : undefined
 * (c) 2016-2025 maptalks.org
 */ 
var $gP1US = parcelRequire("gP1US");
parcelRequire("9e7Ip");
var $9I15V = parcelRequire("9I15V");
var $9e7Ip = parcelRequire("9e7Ip");
var $iLdEy = parcelRequire("iLdEy");
var $bDSmI = parcelRequire("bDSmI");
var $3iqbd = parcelRequire("3iqbd");
var $k1dpP = parcelRequire("k1dpP");
var $2wazW = parcelRequire("2wazW");
var $6BoVD = parcelRequire("6BoVD");
var $eIStk = parcelRequire("eIStk");
var $jxhwV = parcelRequire("jxhwV");
var $08acccbbd431ef55$exports = {};
'use strict';
var $86e889c881e89501$exports = {};
/* MIT license */ var $e81b4034aa9db203$exports = {};
'use strict';
$e81b4034aa9db203$exports = {
    "aliceblue": [
        240,
        248,
        255
    ],
    "antiquewhite": [
        250,
        235,
        215
    ],
    "aqua": [
        0,
        255,
        255
    ],
    "aquamarine": [
        127,
        255,
        212
    ],
    "azure": [
        240,
        255,
        255
    ],
    "beige": [
        245,
        245,
        220
    ],
    "bisque": [
        255,
        228,
        196
    ],
    "black": [
        0,
        0,
        0
    ],
    "blanchedalmond": [
        255,
        235,
        205
    ],
    "blue": [
        0,
        0,
        255
    ],
    "blueviolet": [
        138,
        43,
        226
    ],
    "brown": [
        165,
        42,
        42
    ],
    "burlywood": [
        222,
        184,
        135
    ],
    "cadetblue": [
        95,
        158,
        160
    ],
    "chartreuse": [
        127,
        255,
        0
    ],
    "chocolate": [
        210,
        105,
        30
    ],
    "coral": [
        255,
        127,
        80
    ],
    "cornflowerblue": [
        100,
        149,
        237
    ],
    "cornsilk": [
        255,
        248,
        220
    ],
    "crimson": [
        220,
        20,
        60
    ],
    "cyan": [
        0,
        255,
        255
    ],
    "darkblue": [
        0,
        0,
        139
    ],
    "darkcyan": [
        0,
        139,
        139
    ],
    "darkgoldenrod": [
        184,
        134,
        11
    ],
    "darkgray": [
        169,
        169,
        169
    ],
    "darkgreen": [
        0,
        100,
        0
    ],
    "darkgrey": [
        169,
        169,
        169
    ],
    "darkkhaki": [
        189,
        183,
        107
    ],
    "darkmagenta": [
        139,
        0,
        139
    ],
    "darkolivegreen": [
        85,
        107,
        47
    ],
    "darkorange": [
        255,
        140,
        0
    ],
    "darkorchid": [
        153,
        50,
        204
    ],
    "darkred": [
        139,
        0,
        0
    ],
    "darksalmon": [
        233,
        150,
        122
    ],
    "darkseagreen": [
        143,
        188,
        143
    ],
    "darkslateblue": [
        72,
        61,
        139
    ],
    "darkslategray": [
        47,
        79,
        79
    ],
    "darkslategrey": [
        47,
        79,
        79
    ],
    "darkturquoise": [
        0,
        206,
        209
    ],
    "darkviolet": [
        148,
        0,
        211
    ],
    "deeppink": [
        255,
        20,
        147
    ],
    "deepskyblue": [
        0,
        191,
        255
    ],
    "dimgray": [
        105,
        105,
        105
    ],
    "dimgrey": [
        105,
        105,
        105
    ],
    "dodgerblue": [
        30,
        144,
        255
    ],
    "firebrick": [
        178,
        34,
        34
    ],
    "floralwhite": [
        255,
        250,
        240
    ],
    "forestgreen": [
        34,
        139,
        34
    ],
    "fuchsia": [
        255,
        0,
        255
    ],
    "gainsboro": [
        220,
        220,
        220
    ],
    "ghostwhite": [
        248,
        248,
        255
    ],
    "gold": [
        255,
        215,
        0
    ],
    "goldenrod": [
        218,
        165,
        32
    ],
    "gray": [
        128,
        128,
        128
    ],
    "green": [
        0,
        128,
        0
    ],
    "greenyellow": [
        173,
        255,
        47
    ],
    "grey": [
        128,
        128,
        128
    ],
    "honeydew": [
        240,
        255,
        240
    ],
    "hotpink": [
        255,
        105,
        180
    ],
    "indianred": [
        205,
        92,
        92
    ],
    "indigo": [
        75,
        0,
        130
    ],
    "ivory": [
        255,
        255,
        240
    ],
    "khaki": [
        240,
        230,
        140
    ],
    "lavender": [
        230,
        230,
        250
    ],
    "lavenderblush": [
        255,
        240,
        245
    ],
    "lawngreen": [
        124,
        252,
        0
    ],
    "lemonchiffon": [
        255,
        250,
        205
    ],
    "lightblue": [
        173,
        216,
        230
    ],
    "lightcoral": [
        240,
        128,
        128
    ],
    "lightcyan": [
        224,
        255,
        255
    ],
    "lightgoldenrodyellow": [
        250,
        250,
        210
    ],
    "lightgray": [
        211,
        211,
        211
    ],
    "lightgreen": [
        144,
        238,
        144
    ],
    "lightgrey": [
        211,
        211,
        211
    ],
    "lightpink": [
        255,
        182,
        193
    ],
    "lightsalmon": [
        255,
        160,
        122
    ],
    "lightseagreen": [
        32,
        178,
        170
    ],
    "lightskyblue": [
        135,
        206,
        250
    ],
    "lightslategray": [
        119,
        136,
        153
    ],
    "lightslategrey": [
        119,
        136,
        153
    ],
    "lightsteelblue": [
        176,
        196,
        222
    ],
    "lightyellow": [
        255,
        255,
        224
    ],
    "lime": [
        0,
        255,
        0
    ],
    "limegreen": [
        50,
        205,
        50
    ],
    "linen": [
        250,
        240,
        230
    ],
    "magenta": [
        255,
        0,
        255
    ],
    "maroon": [
        128,
        0,
        0
    ],
    "mediumaquamarine": [
        102,
        205,
        170
    ],
    "mediumblue": [
        0,
        0,
        205
    ],
    "mediumorchid": [
        186,
        85,
        211
    ],
    "mediumpurple": [
        147,
        112,
        219
    ],
    "mediumseagreen": [
        60,
        179,
        113
    ],
    "mediumslateblue": [
        123,
        104,
        238
    ],
    "mediumspringgreen": [
        0,
        250,
        154
    ],
    "mediumturquoise": [
        72,
        209,
        204
    ],
    "mediumvioletred": [
        199,
        21,
        133
    ],
    "midnightblue": [
        25,
        25,
        112
    ],
    "mintcream": [
        245,
        255,
        250
    ],
    "mistyrose": [
        255,
        228,
        225
    ],
    "moccasin": [
        255,
        228,
        181
    ],
    "navajowhite": [
        255,
        222,
        173
    ],
    "navy": [
        0,
        0,
        128
    ],
    "oldlace": [
        253,
        245,
        230
    ],
    "olive": [
        128,
        128,
        0
    ],
    "olivedrab": [
        107,
        142,
        35
    ],
    "orange": [
        255,
        165,
        0
    ],
    "orangered": [
        255,
        69,
        0
    ],
    "orchid": [
        218,
        112,
        214
    ],
    "palegoldenrod": [
        238,
        232,
        170
    ],
    "palegreen": [
        152,
        251,
        152
    ],
    "paleturquoise": [
        175,
        238,
        238
    ],
    "palevioletred": [
        219,
        112,
        147
    ],
    "papayawhip": [
        255,
        239,
        213
    ],
    "peachpuff": [
        255,
        218,
        185
    ],
    "peru": [
        205,
        133,
        63
    ],
    "pink": [
        255,
        192,
        203
    ],
    "plum": [
        221,
        160,
        221
    ],
    "powderblue": [
        176,
        224,
        230
    ],
    "purple": [
        128,
        0,
        128
    ],
    "rebeccapurple": [
        102,
        51,
        153
    ],
    "red": [
        255,
        0,
        0
    ],
    "rosybrown": [
        188,
        143,
        143
    ],
    "royalblue": [
        65,
        105,
        225
    ],
    "saddlebrown": [
        139,
        69,
        19
    ],
    "salmon": [
        250,
        128,
        114
    ],
    "sandybrown": [
        244,
        164,
        96
    ],
    "seagreen": [
        46,
        139,
        87
    ],
    "seashell": [
        255,
        245,
        238
    ],
    "sienna": [
        160,
        82,
        45
    ],
    "silver": [
        192,
        192,
        192
    ],
    "skyblue": [
        135,
        206,
        235
    ],
    "slateblue": [
        106,
        90,
        205
    ],
    "slategray": [
        112,
        128,
        144
    ],
    "slategrey": [
        112,
        128,
        144
    ],
    "snow": [
        255,
        250,
        250
    ],
    "springgreen": [
        0,
        255,
        127
    ],
    "steelblue": [
        70,
        130,
        180
    ],
    "tan": [
        210,
        180,
        140
    ],
    "teal": [
        0,
        128,
        128
    ],
    "thistle": [
        216,
        191,
        216
    ],
    "tomato": [
        255,
        99,
        71
    ],
    "turquoise": [
        64,
        224,
        208
    ],
    "violet": [
        238,
        130,
        238
    ],
    "wheat": [
        245,
        222,
        179
    ],
    "white": [
        255,
        255,
        255
    ],
    "whitesmoke": [
        245,
        245,
        245
    ],
    "yellow": [
        255,
        255,
        0
    ],
    "yellowgreen": [
        154,
        205,
        50
    ]
};


var $617e73434a6cfefb$exports = {};
'use strict';
var $56bdac45c1c7ed69$exports = {};
$56bdac45c1c7ed69$exports = function isArrayish(obj) {
    if (!obj || typeof obj === 'string') return false;
    return obj instanceof Array || Array.isArray(obj) || obj.length >= 0 && (obj.splice instanceof Function || Object.getOwnPropertyDescriptor(obj, obj.length - 1) && obj.constructor.name !== 'String');
};


var $617e73434a6cfefb$var$concat = Array.prototype.concat;
var $617e73434a6cfefb$var$slice = Array.prototype.slice;
var $617e73434a6cfefb$var$swizzle = $617e73434a6cfefb$exports = function swizzle(args) {
    var results = [];
    for(var i = 0, len = args.length; i < len; i++){
        var arg = args[i];
        if ($56bdac45c1c7ed69$exports(arg)) // http://jsperf.com/javascript-array-concat-vs-push/98
        results = $617e73434a6cfefb$var$concat.call(results, $617e73434a6cfefb$var$slice.call(arg));
        else results.push(arg);
    }
    return results;
};
$617e73434a6cfefb$var$swizzle.wrap = function(fn) {
    return function() {
        return fn($617e73434a6cfefb$var$swizzle(arguments));
    };
};


var $86e889c881e89501$var$hasOwnProperty = Object.hasOwnProperty;
var $86e889c881e89501$var$reverseNames = Object.create(null);
// create a list of reverse color names
for(var $86e889c881e89501$var$name in $e81b4034aa9db203$exports)if ($86e889c881e89501$var$hasOwnProperty.call($e81b4034aa9db203$exports, $86e889c881e89501$var$name)) $86e889c881e89501$var$reverseNames[$e81b4034aa9db203$exports[$86e889c881e89501$var$name]] = $86e889c881e89501$var$name;
var $86e889c881e89501$var$cs = $86e889c881e89501$exports = {
    to: {},
    get: {}
};
$86e889c881e89501$var$cs.get = function(string) {
    var prefix = string.substring(0, 3).toLowerCase();
    var val;
    var model;
    switch(prefix){
        case 'hsl':
            val = $86e889c881e89501$var$cs.get.hsl(string);
            model = 'hsl';
            break;
        case 'hwb':
            val = $86e889c881e89501$var$cs.get.hwb(string);
            model = 'hwb';
            break;
        default:
            val = $86e889c881e89501$var$cs.get.rgb(string);
            model = 'rgb';
            break;
    }
    if (!val) return null;
    return {
        model: model,
        value: val
    };
};
$86e889c881e89501$var$cs.get.rgb = function(string) {
    if (!string) return null;
    var abbr = /^#([a-f0-9]{3,4})$/i;
    var hex = /^#([a-f0-9]{6})([a-f0-9]{2})?$/i;
    var rgba = /^rgba?\(\s*([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/;
    var per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/;
    var keyword = /^(\w+)$/;
    var rgb = [
        0,
        0,
        0,
        1
    ];
    var match;
    var i;
    var hexAlpha;
    if (match = string.match(hex)) {
        hexAlpha = match[2];
        match = match[1];
        for(i = 0; i < 3; i++){
            // https://jsperf.com/slice-vs-substr-vs-substring-methods-long-string/19
            var i2 = i * 2;
            rgb[i] = parseInt(match.slice(i2, i2 + 2), 16);
        }
        if (hexAlpha) rgb[3] = parseInt(hexAlpha, 16) / 255;
    } else if (match = string.match(abbr)) {
        match = match[1];
        hexAlpha = match[3];
        for(i = 0; i < 3; i++)rgb[i] = parseInt(match[i] + match[i], 16);
        if (hexAlpha) rgb[3] = parseInt(hexAlpha + hexAlpha, 16) / 255;
    } else if (match = string.match(rgba)) {
        for(i = 0; i < 3; i++)rgb[i] = parseInt(match[i + 1], 0);
        if (match[4]) {
            if (match[5]) rgb[3] = parseFloat(match[4]) * 0.01;
            else rgb[3] = parseFloat(match[4]);
        }
    } else if (match = string.match(per)) {
        for(i = 0; i < 3; i++)rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
        if (match[4]) {
            if (match[5]) rgb[3] = parseFloat(match[4]) * 0.01;
            else rgb[3] = parseFloat(match[4]);
        }
    } else if (match = string.match(keyword)) {
        if (match[1] === 'transparent') return [
            0,
            0,
            0,
            0
        ];
        if (!$86e889c881e89501$var$hasOwnProperty.call($e81b4034aa9db203$exports, match[1])) return null;
        rgb = $e81b4034aa9db203$exports[match[1]];
        rgb[3] = 1;
        return rgb;
    } else return null;
    for(i = 0; i < 3; i++)rgb[i] = $86e889c881e89501$var$clamp(rgb[i], 0, 255);
    rgb[3] = $86e889c881e89501$var$clamp(rgb[3], 0, 1);
    return rgb;
};
$86e889c881e89501$var$cs.get.hsl = function(string) {
    if (!string) return null;
    var hsl = /^hsla?\(\s*([+-]?(?:\d{0,3}\.)?\d+)(?:deg)?\s*,?\s*([+-]?[\d\.]+)%\s*,?\s*([+-]?[\d\.]+)%\s*(?:[,|\/]\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/;
    var match = string.match(hsl);
    if (match) {
        var alpha = parseFloat(match[4]);
        var h = (parseFloat(match[1]) % 360 + 360) % 360;
        var s = $86e889c881e89501$var$clamp(parseFloat(match[2]), 0, 100);
        var l = $86e889c881e89501$var$clamp(parseFloat(match[3]), 0, 100);
        var a = $86e889c881e89501$var$clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
        return [
            h,
            s,
            l,
            a
        ];
    }
    return null;
};
$86e889c881e89501$var$cs.get.hwb = function(string) {
    if (!string) return null;
    var hwb = /^hwb\(\s*([+-]?\d{0,3}(?:\.\d+)?)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/;
    var match = string.match(hwb);
    if (match) {
        var alpha = parseFloat(match[4]);
        var h = (parseFloat(match[1]) % 360 + 360) % 360;
        var w = $86e889c881e89501$var$clamp(parseFloat(match[2]), 0, 100);
        var b = $86e889c881e89501$var$clamp(parseFloat(match[3]), 0, 100);
        var a = $86e889c881e89501$var$clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
        return [
            h,
            w,
            b,
            a
        ];
    }
    return null;
};
$86e889c881e89501$var$cs.to.hex = function() {
    var rgba = $617e73434a6cfefb$exports(arguments);
    return '#' + $86e889c881e89501$var$hexDouble(rgba[0]) + $86e889c881e89501$var$hexDouble(rgba[1]) + $86e889c881e89501$var$hexDouble(rgba[2]) + (rgba[3] < 1 ? $86e889c881e89501$var$hexDouble(Math.round(rgba[3] * 255)) : '');
};
$86e889c881e89501$var$cs.to.rgb = function() {
    var rgba = $617e73434a6cfefb$exports(arguments);
    return rgba.length < 4 || rgba[3] === 1 ? 'rgb(' + Math.round(rgba[0]) + ', ' + Math.round(rgba[1]) + ', ' + Math.round(rgba[2]) + ')' : 'rgba(' + Math.round(rgba[0]) + ', ' + Math.round(rgba[1]) + ', ' + Math.round(rgba[2]) + ', ' + rgba[3] + ')';
};
$86e889c881e89501$var$cs.to.rgb.percent = function() {
    var rgba = $617e73434a6cfefb$exports(arguments);
    var r = Math.round(rgba[0] / 255 * 100);
    var g = Math.round(rgba[1] / 255 * 100);
    var b = Math.round(rgba[2] / 255 * 100);
    return rgba.length < 4 || rgba[3] === 1 ? 'rgb(' + r + '%, ' + g + '%, ' + b + '%)' : 'rgba(' + r + '%, ' + g + '%, ' + b + '%, ' + rgba[3] + ')';
};
$86e889c881e89501$var$cs.to.hsl = function() {
    var hsla = $617e73434a6cfefb$exports(arguments);
    return hsla.length < 4 || hsla[3] === 1 ? 'hsl(' + hsla[0] + ', ' + hsla[1] + '%, ' + hsla[2] + '%)' : 'hsla(' + hsla[0] + ', ' + hsla[1] + '%, ' + hsla[2] + '%, ' + hsla[3] + ')';
};
// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
// (hwb have alpha optional & 1 is default value)
$86e889c881e89501$var$cs.to.hwb = function() {
    var hwba = $617e73434a6cfefb$exports(arguments);
    var a = '';
    if (hwba.length >= 4 && hwba[3] !== 1) a = ', ' + hwba[3];
    return 'hwb(' + hwba[0] + ', ' + hwba[1] + '%, ' + hwba[2] + '%' + a + ')';
};
$86e889c881e89501$var$cs.to.keyword = function(rgb) {
    return $86e889c881e89501$var$reverseNames[rgb.slice(0, 3)];
};
// helpers
function $86e889c881e89501$var$clamp(num, min, max) {
    return Math.min(Math.max(min, num), max);
}
function $86e889c881e89501$var$hexDouble(num) {
    var str = Math.round(num).toString(16).toUpperCase();
    return str.length < 2 ? '0' + str : str;
}


var $3e574d92e62e98fa$exports = {};
var $7f6f8e04ce3f0a38$exports = {};
/* MIT license */ var $97828da41acdfa1a$exports = {};
'use strict';
$97828da41acdfa1a$exports = {
    "aliceblue": [
        240,
        248,
        255
    ],
    "antiquewhite": [
        250,
        235,
        215
    ],
    "aqua": [
        0,
        255,
        255
    ],
    "aquamarine": [
        127,
        255,
        212
    ],
    "azure": [
        240,
        255,
        255
    ],
    "beige": [
        245,
        245,
        220
    ],
    "bisque": [
        255,
        228,
        196
    ],
    "black": [
        0,
        0,
        0
    ],
    "blanchedalmond": [
        255,
        235,
        205
    ],
    "blue": [
        0,
        0,
        255
    ],
    "blueviolet": [
        138,
        43,
        226
    ],
    "brown": [
        165,
        42,
        42
    ],
    "burlywood": [
        222,
        184,
        135
    ],
    "cadetblue": [
        95,
        158,
        160
    ],
    "chartreuse": [
        127,
        255,
        0
    ],
    "chocolate": [
        210,
        105,
        30
    ],
    "coral": [
        255,
        127,
        80
    ],
    "cornflowerblue": [
        100,
        149,
        237
    ],
    "cornsilk": [
        255,
        248,
        220
    ],
    "crimson": [
        220,
        20,
        60
    ],
    "cyan": [
        0,
        255,
        255
    ],
    "darkblue": [
        0,
        0,
        139
    ],
    "darkcyan": [
        0,
        139,
        139
    ],
    "darkgoldenrod": [
        184,
        134,
        11
    ],
    "darkgray": [
        169,
        169,
        169
    ],
    "darkgreen": [
        0,
        100,
        0
    ],
    "darkgrey": [
        169,
        169,
        169
    ],
    "darkkhaki": [
        189,
        183,
        107
    ],
    "darkmagenta": [
        139,
        0,
        139
    ],
    "darkolivegreen": [
        85,
        107,
        47
    ],
    "darkorange": [
        255,
        140,
        0
    ],
    "darkorchid": [
        153,
        50,
        204
    ],
    "darkred": [
        139,
        0,
        0
    ],
    "darksalmon": [
        233,
        150,
        122
    ],
    "darkseagreen": [
        143,
        188,
        143
    ],
    "darkslateblue": [
        72,
        61,
        139
    ],
    "darkslategray": [
        47,
        79,
        79
    ],
    "darkslategrey": [
        47,
        79,
        79
    ],
    "darkturquoise": [
        0,
        206,
        209
    ],
    "darkviolet": [
        148,
        0,
        211
    ],
    "deeppink": [
        255,
        20,
        147
    ],
    "deepskyblue": [
        0,
        191,
        255
    ],
    "dimgray": [
        105,
        105,
        105
    ],
    "dimgrey": [
        105,
        105,
        105
    ],
    "dodgerblue": [
        30,
        144,
        255
    ],
    "firebrick": [
        178,
        34,
        34
    ],
    "floralwhite": [
        255,
        250,
        240
    ],
    "forestgreen": [
        34,
        139,
        34
    ],
    "fuchsia": [
        255,
        0,
        255
    ],
    "gainsboro": [
        220,
        220,
        220
    ],
    "ghostwhite": [
        248,
        248,
        255
    ],
    "gold": [
        255,
        215,
        0
    ],
    "goldenrod": [
        218,
        165,
        32
    ],
    "gray": [
        128,
        128,
        128
    ],
    "green": [
        0,
        128,
        0
    ],
    "greenyellow": [
        173,
        255,
        47
    ],
    "grey": [
        128,
        128,
        128
    ],
    "honeydew": [
        240,
        255,
        240
    ],
    "hotpink": [
        255,
        105,
        180
    ],
    "indianred": [
        205,
        92,
        92
    ],
    "indigo": [
        75,
        0,
        130
    ],
    "ivory": [
        255,
        255,
        240
    ],
    "khaki": [
        240,
        230,
        140
    ],
    "lavender": [
        230,
        230,
        250
    ],
    "lavenderblush": [
        255,
        240,
        245
    ],
    "lawngreen": [
        124,
        252,
        0
    ],
    "lemonchiffon": [
        255,
        250,
        205
    ],
    "lightblue": [
        173,
        216,
        230
    ],
    "lightcoral": [
        240,
        128,
        128
    ],
    "lightcyan": [
        224,
        255,
        255
    ],
    "lightgoldenrodyellow": [
        250,
        250,
        210
    ],
    "lightgray": [
        211,
        211,
        211
    ],
    "lightgreen": [
        144,
        238,
        144
    ],
    "lightgrey": [
        211,
        211,
        211
    ],
    "lightpink": [
        255,
        182,
        193
    ],
    "lightsalmon": [
        255,
        160,
        122
    ],
    "lightseagreen": [
        32,
        178,
        170
    ],
    "lightskyblue": [
        135,
        206,
        250
    ],
    "lightslategray": [
        119,
        136,
        153
    ],
    "lightslategrey": [
        119,
        136,
        153
    ],
    "lightsteelblue": [
        176,
        196,
        222
    ],
    "lightyellow": [
        255,
        255,
        224
    ],
    "lime": [
        0,
        255,
        0
    ],
    "limegreen": [
        50,
        205,
        50
    ],
    "linen": [
        250,
        240,
        230
    ],
    "magenta": [
        255,
        0,
        255
    ],
    "maroon": [
        128,
        0,
        0
    ],
    "mediumaquamarine": [
        102,
        205,
        170
    ],
    "mediumblue": [
        0,
        0,
        205
    ],
    "mediumorchid": [
        186,
        85,
        211
    ],
    "mediumpurple": [
        147,
        112,
        219
    ],
    "mediumseagreen": [
        60,
        179,
        113
    ],
    "mediumslateblue": [
        123,
        104,
        238
    ],
    "mediumspringgreen": [
        0,
        250,
        154
    ],
    "mediumturquoise": [
        72,
        209,
        204
    ],
    "mediumvioletred": [
        199,
        21,
        133
    ],
    "midnightblue": [
        25,
        25,
        112
    ],
    "mintcream": [
        245,
        255,
        250
    ],
    "mistyrose": [
        255,
        228,
        225
    ],
    "moccasin": [
        255,
        228,
        181
    ],
    "navajowhite": [
        255,
        222,
        173
    ],
    "navy": [
        0,
        0,
        128
    ],
    "oldlace": [
        253,
        245,
        230
    ],
    "olive": [
        128,
        128,
        0
    ],
    "olivedrab": [
        107,
        142,
        35
    ],
    "orange": [
        255,
        165,
        0
    ],
    "orangered": [
        255,
        69,
        0
    ],
    "orchid": [
        218,
        112,
        214
    ],
    "palegoldenrod": [
        238,
        232,
        170
    ],
    "palegreen": [
        152,
        251,
        152
    ],
    "paleturquoise": [
        175,
        238,
        238
    ],
    "palevioletred": [
        219,
        112,
        147
    ],
    "papayawhip": [
        255,
        239,
        213
    ],
    "peachpuff": [
        255,
        218,
        185
    ],
    "peru": [
        205,
        133,
        63
    ],
    "pink": [
        255,
        192,
        203
    ],
    "plum": [
        221,
        160,
        221
    ],
    "powderblue": [
        176,
        224,
        230
    ],
    "purple": [
        128,
        0,
        128
    ],
    "rebeccapurple": [
        102,
        51,
        153
    ],
    "red": [
        255,
        0,
        0
    ],
    "rosybrown": [
        188,
        143,
        143
    ],
    "royalblue": [
        65,
        105,
        225
    ],
    "saddlebrown": [
        139,
        69,
        19
    ],
    "salmon": [
        250,
        128,
        114
    ],
    "sandybrown": [
        244,
        164,
        96
    ],
    "seagreen": [
        46,
        139,
        87
    ],
    "seashell": [
        255,
        245,
        238
    ],
    "sienna": [
        160,
        82,
        45
    ],
    "silver": [
        192,
        192,
        192
    ],
    "skyblue": [
        135,
        206,
        235
    ],
    "slateblue": [
        106,
        90,
        205
    ],
    "slategray": [
        112,
        128,
        144
    ],
    "slategrey": [
        112,
        128,
        144
    ],
    "snow": [
        255,
        250,
        250
    ],
    "springgreen": [
        0,
        255,
        127
    ],
    "steelblue": [
        70,
        130,
        180
    ],
    "tan": [
        210,
        180,
        140
    ],
    "teal": [
        0,
        128,
        128
    ],
    "thistle": [
        216,
        191,
        216
    ],
    "tomato": [
        255,
        99,
        71
    ],
    "turquoise": [
        64,
        224,
        208
    ],
    "violet": [
        238,
        130,
        238
    ],
    "wheat": [
        245,
        222,
        179
    ],
    "white": [
        255,
        255,
        255
    ],
    "whitesmoke": [
        245,
        245,
        245
    ],
    "yellow": [
        255,
        255,
        0
    ],
    "yellowgreen": [
        154,
        205,
        50
    ]
};


// NOTE: conversions should only return primitive values (i.e. arrays, or
//       values that give correct `typeof` results).
//       do not use box values types (i.e. Number(), String(), etc.)
var $7f6f8e04ce3f0a38$var$reverseKeywords = {};
for(var $7f6f8e04ce3f0a38$var$key in $97828da41acdfa1a$exports)if ($97828da41acdfa1a$exports.hasOwnProperty($7f6f8e04ce3f0a38$var$key)) $7f6f8e04ce3f0a38$var$reverseKeywords[$97828da41acdfa1a$exports[$7f6f8e04ce3f0a38$var$key]] = $7f6f8e04ce3f0a38$var$key;
var $7f6f8e04ce3f0a38$var$convert = $7f6f8e04ce3f0a38$exports = {
    rgb: {
        channels: 3,
        labels: 'rgb'
    },
    hsl: {
        channels: 3,
        labels: 'hsl'
    },
    hsv: {
        channels: 3,
        labels: 'hsv'
    },
    hwb: {
        channels: 3,
        labels: 'hwb'
    },
    cmyk: {
        channels: 4,
        labels: 'cmyk'
    },
    xyz: {
        channels: 3,
        labels: 'xyz'
    },
    lab: {
        channels: 3,
        labels: 'lab'
    },
    lch: {
        channels: 3,
        labels: 'lch'
    },
    hex: {
        channels: 1,
        labels: [
            'hex'
        ]
    },
    keyword: {
        channels: 1,
        labels: [
            'keyword'
        ]
    },
    ansi16: {
        channels: 1,
        labels: [
            'ansi16'
        ]
    },
    ansi256: {
        channels: 1,
        labels: [
            'ansi256'
        ]
    },
    hcg: {
        channels: 3,
        labels: [
            'h',
            'c',
            'g'
        ]
    },
    apple: {
        channels: 3,
        labels: [
            'r16',
            'g16',
            'b16'
        ]
    },
    gray: {
        channels: 1,
        labels: [
            'gray'
        ]
    }
};
// hide .channels and .labels properties
for(var $7f6f8e04ce3f0a38$var$model in $7f6f8e04ce3f0a38$var$convert)if ($7f6f8e04ce3f0a38$var$convert.hasOwnProperty($7f6f8e04ce3f0a38$var$model)) {
    if (!('channels' in $7f6f8e04ce3f0a38$var$convert[$7f6f8e04ce3f0a38$var$model])) throw new Error('missing channels property: ' + $7f6f8e04ce3f0a38$var$model);
    if (!('labels' in $7f6f8e04ce3f0a38$var$convert[$7f6f8e04ce3f0a38$var$model])) throw new Error('missing channel labels property: ' + $7f6f8e04ce3f0a38$var$model);
    if ($7f6f8e04ce3f0a38$var$convert[$7f6f8e04ce3f0a38$var$model].labels.length !== $7f6f8e04ce3f0a38$var$convert[$7f6f8e04ce3f0a38$var$model].channels) throw new Error('channel and label counts mismatch: ' + $7f6f8e04ce3f0a38$var$model);
    var $7f6f8e04ce3f0a38$var$channels = $7f6f8e04ce3f0a38$var$convert[$7f6f8e04ce3f0a38$var$model].channels;
    var $7f6f8e04ce3f0a38$var$labels = $7f6f8e04ce3f0a38$var$convert[$7f6f8e04ce3f0a38$var$model].labels;
    delete $7f6f8e04ce3f0a38$var$convert[$7f6f8e04ce3f0a38$var$model].channels;
    delete $7f6f8e04ce3f0a38$var$convert[$7f6f8e04ce3f0a38$var$model].labels;
    Object.defineProperty($7f6f8e04ce3f0a38$var$convert[$7f6f8e04ce3f0a38$var$model], 'channels', {
        value: $7f6f8e04ce3f0a38$var$channels
    });
    Object.defineProperty($7f6f8e04ce3f0a38$var$convert[$7f6f8e04ce3f0a38$var$model], 'labels', {
        value: $7f6f8e04ce3f0a38$var$labels
    });
}
$7f6f8e04ce3f0a38$var$convert.rgb.hsl = function(rgb) {
    var r = rgb[0] / 255;
    var g = rgb[1] / 255;
    var b = rgb[2] / 255;
    var min = Math.min(r, g, b);
    var max = Math.max(r, g, b);
    var delta = max - min;
    var h;
    var s;
    var l;
    if (max === min) h = 0;
    else if (r === max) h = (g - b) / delta;
    else if (g === max) h = 2 + (b - r) / delta;
    else if (b === max) h = 4 + (r - g) / delta;
    h = Math.min(h * 60, 360);
    if (h < 0) h += 360;
    l = (min + max) / 2;
    if (max === min) s = 0;
    else if (l <= 0.5) s = delta / (max + min);
    else s = delta / (2 - max - min);
    return [
        h,
        s * 100,
        l * 100
    ];
};
$7f6f8e04ce3f0a38$var$convert.rgb.hsv = function(rgb) {
    var rdif;
    var gdif;
    var bdif;
    var h;
    var s;
    var r = rgb[0] / 255;
    var g = rgb[1] / 255;
    var b = rgb[2] / 255;
    var v = Math.max(r, g, b);
    var diff = v - Math.min(r, g, b);
    var diffc = function(c) {
        return (v - c) / 6 / diff + 0.5;
    };
    if (diff === 0) h = s = 0;
    else {
        s = diff / v;
        rdif = diffc(r);
        gdif = diffc(g);
        bdif = diffc(b);
        if (r === v) h = bdif - gdif;
        else if (g === v) h = 1 / 3 + rdif - bdif;
        else if (b === v) h = 2 / 3 + gdif - rdif;
        if (h < 0) h += 1;
        else if (h > 1) h -= 1;
    }
    return [
        h * 360,
        s * 100,
        v * 100
    ];
};
$7f6f8e04ce3f0a38$var$convert.rgb.hwb = function(rgb) {
    var r = rgb[0];
    var g = rgb[1];
    var b = rgb[2];
    var h = $7f6f8e04ce3f0a38$var$convert.rgb.hsl(rgb)[0];
    var w = 1 / 255 * Math.min(r, Math.min(g, b));
    b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));
    return [
        h,
        w * 100,
        b * 100
    ];
};
$7f6f8e04ce3f0a38$var$convert.rgb.cmyk = function(rgb) {
    var r = rgb[0] / 255;
    var g = rgb[1] / 255;
    var b = rgb[2] / 255;
    var c;
    var m;
    var y;
    var k;
    k = Math.min(1 - r, 1 - g, 1 - b);
    c = (1 - r - k) / (1 - k) || 0;
    m = (1 - g - k) / (1 - k) || 0;
    y = (1 - b - k) / (1 - k) || 0;
    return [
        c * 100,
        m * 100,
        y * 100,
        k * 100
    ];
};
/**
 * See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
 * */ function $7f6f8e04ce3f0a38$var$comparativeDistance(x, y) {
    return Math.pow(x[0] - y[0], 2) + Math.pow(x[1] - y[1], 2) + Math.pow(x[2] - y[2], 2);
}
$7f6f8e04ce3f0a38$var$convert.rgb.keyword = function(rgb) {
    var reversed = $7f6f8e04ce3f0a38$var$reverseKeywords[rgb];
    if (reversed) return reversed;
    var currentClosestDistance = Infinity;
    var currentClosestKeyword;
    for(var keyword in $97828da41acdfa1a$exports)if ($97828da41acdfa1a$exports.hasOwnProperty(keyword)) {
        var value = $97828da41acdfa1a$exports[keyword];
        // Compute comparative distance
        var distance = $7f6f8e04ce3f0a38$var$comparativeDistance(rgb, value);
        // Check if its less, if so set as closest
        if (distance < currentClosestDistance) {
            currentClosestDistance = distance;
            currentClosestKeyword = keyword;
        }
    }
    return currentClosestKeyword;
};
$7f6f8e04ce3f0a38$var$convert.keyword.rgb = function(keyword) {
    return $97828da41acdfa1a$exports[keyword];
};
$7f6f8e04ce3f0a38$var$convert.rgb.xyz = function(rgb) {
    var r = rgb[0] / 255;
    var g = rgb[1] / 255;
    var b = rgb[2] / 255;
    // assume sRGB
    r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
    g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
    b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
    var x = r * 0.4124 + g * 0.3576 + b * 0.1805;
    var y = r * 0.2126 + g * 0.7152 + b * 0.0722;
    var z = r * 0.0193 + g * 0.1192 + b * 0.9505;
    return [
        x * 100,
        y * 100,
        z * 100
    ];
};
$7f6f8e04ce3f0a38$var$convert.rgb.lab = function(rgb) {
    var xyz = $7f6f8e04ce3f0a38$var$convert.rgb.xyz(rgb);
    var x = xyz[0];
    var y = xyz[1];
    var z = xyz[2];
    var l;
    var a;
    var b;
    x /= 95.047;
    y /= 100;
    z /= 108.883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    l = 116 * y - 16;
    a = 500 * (x - y);
    b = 200 * (y - z);
    return [
        l,
        a,
        b
    ];
};
$7f6f8e04ce3f0a38$var$convert.hsl.rgb = function(hsl) {
    var h = hsl[0] / 360;
    var s = hsl[1] / 100;
    var l = hsl[2] / 100;
    var t1;
    var t2;
    var t3;
    var rgb;
    var val;
    if (s === 0) {
        val = l * 255;
        return [
            val,
            val,
            val
        ];
    }
    if (l < 0.5) t2 = l * (1 + s);
    else t2 = l + s - l * s;
    t1 = 2 * l - t2;
    rgb = [
        0,
        0,
        0
    ];
    for(var i = 0; i < 3; i++){
        t3 = h + 1 / 3 * -(i - 1);
        if (t3 < 0) t3++;
        if (t3 > 1) t3--;
        if (6 * t3 < 1) val = t1 + (t2 - t1) * 6 * t3;
        else if (2 * t3 < 1) val = t2;
        else if (3 * t3 < 2) val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
        else val = t1;
        rgb[i] = val * 255;
    }
    return rgb;
};
$7f6f8e04ce3f0a38$var$convert.hsl.hsv = function(hsl) {
    var h = hsl[0];
    var s = hsl[1] / 100;
    var l = hsl[2] / 100;
    var smin = s;
    var lmin = Math.max(l, 0.01);
    var sv;
    var v;
    l *= 2;
    s *= l <= 1 ? l : 2 - l;
    smin *= lmin <= 1 ? lmin : 2 - lmin;
    v = (l + s) / 2;
    sv = l === 0 ? 2 * smin / (lmin + smin) : 2 * s / (l + s);
    return [
        h,
        sv * 100,
        v * 100
    ];
};
$7f6f8e04ce3f0a38$var$convert.hsv.rgb = function(hsv) {
    var h = hsv[0] / 60;
    var s = hsv[1] / 100;
    var v = hsv[2] / 100;
    var hi = Math.floor(h) % 6;
    var f = h - Math.floor(h);
    var p = 255 * v * (1 - s);
    var q = 255 * v * (1 - s * f);
    var t = 255 * v * (1 - s * (1 - f));
    v *= 255;
    switch(hi){
        case 0:
            return [
                v,
                t,
                p
            ];
        case 1:
            return [
                q,
                v,
                p
            ];
        case 2:
            return [
                p,
                v,
                t
            ];
        case 3:
            return [
                p,
                q,
                v
            ];
        case 4:
            return [
                t,
                p,
                v
            ];
        case 5:
            return [
                v,
                p,
                q
            ];
    }
};
$7f6f8e04ce3f0a38$var$convert.hsv.hsl = function(hsv) {
    var h = hsv[0];
    var s = hsv[1] / 100;
    var v = hsv[2] / 100;
    var vmin = Math.max(v, 0.01);
    var lmin;
    var sl;
    var l;
    l = (2 - s) * v;
    lmin = (2 - s) * vmin;
    sl = s * vmin;
    sl /= lmin <= 1 ? lmin : 2 - lmin;
    sl = sl || 0;
    l /= 2;
    return [
        h,
        sl * 100,
        l * 100
    ];
};
// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
$7f6f8e04ce3f0a38$var$convert.hwb.rgb = function(hwb) {
    var h = hwb[0] / 360;
    var wh = hwb[1] / 100;
    var bl = hwb[2] / 100;
    var ratio = wh + bl;
    var i;
    var v;
    var f;
    var n;
    // wh + bl cant be > 1
    if (ratio > 1) {
        wh /= ratio;
        bl /= ratio;
    }
    i = Math.floor(6 * h);
    v = 1 - bl;
    f = 6 * h - i;
    if ((i & 0x01) !== 0) f = 1 - f;
    n = wh + f * (v - wh); // linear interpolation
    var r;
    var g;
    var b;
    switch(i){
        default:
        case 6:
        case 0:
            r = v;
            g = n;
            b = wh;
            break;
        case 1:
            r = n;
            g = v;
            b = wh;
            break;
        case 2:
            r = wh;
            g = v;
            b = n;
            break;
        case 3:
            r = wh;
            g = n;
            b = v;
            break;
        case 4:
            r = n;
            g = wh;
            b = v;
            break;
        case 5:
            r = v;
            g = wh;
            b = n;
            break;
    }
    return [
        r * 255,
        g * 255,
        b * 255
    ];
};
$7f6f8e04ce3f0a38$var$convert.cmyk.rgb = function(cmyk) {
    var c = cmyk[0] / 100;
    var m = cmyk[1] / 100;
    var y = cmyk[2] / 100;
    var k = cmyk[3] / 100;
    var r;
    var g;
    var b;
    r = 1 - Math.min(1, c * (1 - k) + k);
    g = 1 - Math.min(1, m * (1 - k) + k);
    b = 1 - Math.min(1, y * (1 - k) + k);
    return [
        r * 255,
        g * 255,
        b * 255
    ];
};
$7f6f8e04ce3f0a38$var$convert.xyz.rgb = function(xyz) {
    var x = xyz[0] / 100;
    var y = xyz[1] / 100;
    var z = xyz[2] / 100;
    var r;
    var g;
    var b;
    r = x * 3.2406 + y * -1.5372 + z * -0.4986;
    g = x * -0.9689 + y * 1.8758 + z * 0.0415;
    b = x * 0.0557 + y * -0.204 + z * 1.0570;
    // assume sRGB
    r = r > 0.0031308 ? 1.055 * Math.pow(r, 1.0 / 2.4) - 0.055 : r * 12.92;
    g = g > 0.0031308 ? 1.055 * Math.pow(g, 1.0 / 2.4) - 0.055 : g * 12.92;
    b = b > 0.0031308 ? 1.055 * Math.pow(b, 1.0 / 2.4) - 0.055 : b * 12.92;
    r = Math.min(Math.max(0, r), 1);
    g = Math.min(Math.max(0, g), 1);
    b = Math.min(Math.max(0, b), 1);
    return [
        r * 255,
        g * 255,
        b * 255
    ];
};
$7f6f8e04ce3f0a38$var$convert.xyz.lab = function(xyz) {
    var x = xyz[0];
    var y = xyz[1];
    var z = xyz[2];
    var l;
    var a;
    var b;
    x /= 95.047;
    y /= 100;
    z /= 108.883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    l = 116 * y - 16;
    a = 500 * (x - y);
    b = 200 * (y - z);
    return [
        l,
        a,
        b
    ];
};
$7f6f8e04ce3f0a38$var$convert.lab.xyz = function(lab) {
    var l = lab[0];
    var a = lab[1];
    var b = lab[2];
    var x;
    var y;
    var z;
    y = (l + 16) / 116;
    x = a / 500 + y;
    z = y - b / 200;
    var y2 = Math.pow(y, 3);
    var x2 = Math.pow(x, 3);
    var z2 = Math.pow(z, 3);
    y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
    x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
    z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;
    x *= 95.047;
    y *= 100;
    z *= 108.883;
    return [
        x,
        y,
        z
    ];
};
$7f6f8e04ce3f0a38$var$convert.lab.lch = function(lab) {
    var l = lab[0];
    var a = lab[1];
    var b = lab[2];
    var hr;
    var h;
    var c;
    hr = Math.atan2(b, a);
    h = hr * 360 / 2 / Math.PI;
    if (h < 0) h += 360;
    c = Math.sqrt(a * a + b * b);
    return [
        l,
        c,
        h
    ];
};
$7f6f8e04ce3f0a38$var$convert.lch.lab = function(lch) {
    var l = lch[0];
    var c = lch[1];
    var h = lch[2];
    var a;
    var b;
    var hr;
    hr = h / 360 * 2 * Math.PI;
    a = c * Math.cos(hr);
    b = c * Math.sin(hr);
    return [
        l,
        a,
        b
    ];
};
$7f6f8e04ce3f0a38$var$convert.rgb.ansi16 = function(args) {
    var r = args[0];
    var g = args[1];
    var b = args[2];
    var value = 1 in arguments ? arguments[1] : $7f6f8e04ce3f0a38$var$convert.rgb.hsv(args)[2]; // hsv -> ansi16 optimization
    value = Math.round(value / 50);
    if (value === 0) return 30;
    var ansi = 30 + (Math.round(b / 255) << 2 | Math.round(g / 255) << 1 | Math.round(r / 255));
    if (value === 2) ansi += 60;
    return ansi;
};
$7f6f8e04ce3f0a38$var$convert.hsv.ansi16 = function(args) {
    // optimization here; we already know the value and don't need to get
    // it converted for us.
    return $7f6f8e04ce3f0a38$var$convert.rgb.ansi16($7f6f8e04ce3f0a38$var$convert.hsv.rgb(args), args[2]);
};
$7f6f8e04ce3f0a38$var$convert.rgb.ansi256 = function(args) {
    var r = args[0];
    var g = args[1];
    var b = args[2];
    // we use the extended greyscale palette here, with the exception of
    // black and white. normal palette only has 4 greyscale shades.
    if (r === g && g === b) {
        if (r < 8) return 16;
        if (r > 248) return 231;
        return Math.round((r - 8) / 247 * 24) + 232;
    }
    var ansi = 16 + 36 * Math.round(r / 255 * 5) + 6 * Math.round(g / 255 * 5) + Math.round(b / 255 * 5);
    return ansi;
};
$7f6f8e04ce3f0a38$var$convert.ansi16.rgb = function(args) {
    var color = args % 10;
    // handle greyscale
    if (color === 0 || color === 7) {
        if (args > 50) color += 3.5;
        color = color / 10.5 * 255;
        return [
            color,
            color,
            color
        ];
    }
    var mult = (~~(args > 50) + 1) * 0.5;
    var r = (color & 1) * mult * 255;
    var g = (color >> 1 & 1) * mult * 255;
    var b = (color >> 2 & 1) * mult * 255;
    return [
        r,
        g,
        b
    ];
};
$7f6f8e04ce3f0a38$var$convert.ansi256.rgb = function(args) {
    // handle greyscale
    if (args >= 232) {
        var c = (args - 232) * 10 + 8;
        return [
            c,
            c,
            c
        ];
    }
    args -= 16;
    var rem;
    var r = Math.floor(args / 36) / 5 * 255;
    var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
    var b = rem % 6 / 5 * 255;
    return [
        r,
        g,
        b
    ];
};
$7f6f8e04ce3f0a38$var$convert.rgb.hex = function(args) {
    var integer = ((Math.round(args[0]) & 0xFF) << 16) + ((Math.round(args[1]) & 0xFF) << 8) + (Math.round(args[2]) & 0xFF);
    var string = integer.toString(16).toUpperCase();
    return '000000'.substring(string.length) + string;
};
$7f6f8e04ce3f0a38$var$convert.hex.rgb = function(args) {
    var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
    if (!match) return [
        0,
        0,
        0
    ];
    var colorString = match[0];
    if (match[0].length === 3) colorString = colorString.split('').map(function(char) {
        return char + char;
    }).join('');
    var integer = parseInt(colorString, 16);
    var r = integer >> 16 & 0xFF;
    var g = integer >> 8 & 0xFF;
    var b = integer & 0xFF;
    return [
        r,
        g,
        b
    ];
};
$7f6f8e04ce3f0a38$var$convert.rgb.hcg = function(rgb) {
    var r = rgb[0] / 255;
    var g = rgb[1] / 255;
    var b = rgb[2] / 255;
    var max = Math.max(Math.max(r, g), b);
    var min = Math.min(Math.min(r, g), b);
    var chroma = max - min;
    var grayscale;
    var hue;
    if (chroma < 1) grayscale = min / (1 - chroma);
    else grayscale = 0;
    if (chroma <= 0) hue = 0;
    else if (max === r) hue = (g - b) / chroma % 6;
    else if (max === g) hue = 2 + (b - r) / chroma;
    else hue = 4 + (r - g) / chroma + 4;
    hue /= 6;
    hue %= 1;
    return [
        hue * 360,
        chroma * 100,
        grayscale * 100
    ];
};
$7f6f8e04ce3f0a38$var$convert.hsl.hcg = function(hsl) {
    var s = hsl[1] / 100;
    var l = hsl[2] / 100;
    var c = 1;
    var f = 0;
    if (l < 0.5) c = 2.0 * s * l;
    else c = 2.0 * s * (1.0 - l);
    if (c < 1.0) f = (l - 0.5 * c) / (1.0 - c);
    return [
        hsl[0],
        c * 100,
        f * 100
    ];
};
$7f6f8e04ce3f0a38$var$convert.hsv.hcg = function(hsv) {
    var s = hsv[1] / 100;
    var v = hsv[2] / 100;
    var c = s * v;
    var f = 0;
    if (c < 1.0) f = (v - c) / (1 - c);
    return [
        hsv[0],
        c * 100,
        f * 100
    ];
};
$7f6f8e04ce3f0a38$var$convert.hcg.rgb = function(hcg) {
    var h = hcg[0] / 360;
    var c = hcg[1] / 100;
    var g = hcg[2] / 100;
    if (c === 0.0) return [
        g * 255,
        g * 255,
        g * 255
    ];
    var pure = [
        0,
        0,
        0
    ];
    var hi = h % 1 * 6;
    var v = hi % 1;
    var w = 1 - v;
    var mg = 0;
    switch(Math.floor(hi)){
        case 0:
            pure[0] = 1;
            pure[1] = v;
            pure[2] = 0;
            break;
        case 1:
            pure[0] = w;
            pure[1] = 1;
            pure[2] = 0;
            break;
        case 2:
            pure[0] = 0;
            pure[1] = 1;
            pure[2] = v;
            break;
        case 3:
            pure[0] = 0;
            pure[1] = w;
            pure[2] = 1;
            break;
        case 4:
            pure[0] = v;
            pure[1] = 0;
            pure[2] = 1;
            break;
        default:
            pure[0] = 1;
            pure[1] = 0;
            pure[2] = w;
    }
    mg = (1.0 - c) * g;
    return [
        (c * pure[0] + mg) * 255,
        (c * pure[1] + mg) * 255,
        (c * pure[2] + mg) * 255
    ];
};
$7f6f8e04ce3f0a38$var$convert.hcg.hsv = function(hcg) {
    var c = hcg[1] / 100;
    var g = hcg[2] / 100;
    var v = c + g * (1.0 - c);
    var f = 0;
    if (v > 0.0) f = c / v;
    return [
        hcg[0],
        f * 100,
        v * 100
    ];
};
$7f6f8e04ce3f0a38$var$convert.hcg.hsl = function(hcg) {
    var c = hcg[1] / 100;
    var g = hcg[2] / 100;
    var l = g * (1.0 - c) + 0.5 * c;
    var s = 0;
    if (l > 0.0 && l < 0.5) s = c / (2 * l);
    else if (l >= 0.5 && l < 1.0) s = c / (2 * (1 - l));
    return [
        hcg[0],
        s * 100,
        l * 100
    ];
};
$7f6f8e04ce3f0a38$var$convert.hcg.hwb = function(hcg) {
    var c = hcg[1] / 100;
    var g = hcg[2] / 100;
    var v = c + g * (1.0 - c);
    return [
        hcg[0],
        (v - c) * 100,
        (1 - v) * 100
    ];
};
$7f6f8e04ce3f0a38$var$convert.hwb.hcg = function(hwb) {
    var w = hwb[1] / 100;
    var b = hwb[2] / 100;
    var v = 1 - b;
    var c = v - w;
    var g = 0;
    if (c < 1) g = (v - c) / (1 - c);
    return [
        hwb[0],
        c * 100,
        g * 100
    ];
};
$7f6f8e04ce3f0a38$var$convert.apple.rgb = function(apple) {
    return [
        apple[0] / 65535 * 255,
        apple[1] / 65535 * 255,
        apple[2] / 65535 * 255
    ];
};
$7f6f8e04ce3f0a38$var$convert.rgb.apple = function(rgb) {
    return [
        rgb[0] / 255 * 65535,
        rgb[1] / 255 * 65535,
        rgb[2] / 255 * 65535
    ];
};
$7f6f8e04ce3f0a38$var$convert.gray.rgb = function(args) {
    return [
        args[0] / 100 * 255,
        args[0] / 100 * 255,
        args[0] / 100 * 255
    ];
};
$7f6f8e04ce3f0a38$var$convert.gray.hsl = $7f6f8e04ce3f0a38$var$convert.gray.hsv = function(args) {
    return [
        0,
        0,
        args[0]
    ];
};
$7f6f8e04ce3f0a38$var$convert.gray.hwb = function(gray) {
    return [
        0,
        100,
        gray[0]
    ];
};
$7f6f8e04ce3f0a38$var$convert.gray.cmyk = function(gray) {
    return [
        0,
        0,
        0,
        gray[0]
    ];
};
$7f6f8e04ce3f0a38$var$convert.gray.lab = function(gray) {
    return [
        gray[0],
        0,
        0
    ];
};
$7f6f8e04ce3f0a38$var$convert.gray.hex = function(gray) {
    var val = Math.round(gray[0] / 100 * 255) & 0xFF;
    var integer = (val << 16) + (val << 8) + val;
    var string = integer.toString(16).toUpperCase();
    return '000000'.substring(string.length) + string;
};
$7f6f8e04ce3f0a38$var$convert.rgb.gray = function(rgb) {
    var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
    return [
        val / 255 * 100
    ];
};


var $1807b44030601d9a$exports = {};

/*
	this function routes a model to all other models.

	all functions that are routed have a property `.conversion` attached
	to the returned synthetic function. This property is an array
	of strings, each with the steps in between the 'from' and 'to'
	color models (inclusive).

	conversions that are not possible simply are not included.
*/ function $1807b44030601d9a$var$buildGraph() {
    var graph = {};
    // https://jsperf.com/object-keys-vs-for-in-with-closure/3
    var models = Object.keys($7f6f8e04ce3f0a38$exports);
    for(var len = models.length, i = 0; i < len; i++)graph[models[i]] = {
        // http://jsperf.com/1-vs-infinity
        // micro-opt, but this is simple.
        distance: -1,
        parent: null
    };
    return graph;
}
// https://en.wikipedia.org/wiki/Breadth-first_search
function $1807b44030601d9a$var$deriveBFS(fromModel) {
    var graph = $1807b44030601d9a$var$buildGraph();
    var queue = [
        fromModel
    ]; // unshift -> queue -> pop
    graph[fromModel].distance = 0;
    while(queue.length){
        var current = queue.pop();
        var adjacents = Object.keys($7f6f8e04ce3f0a38$exports[current]);
        for(var len = adjacents.length, i = 0; i < len; i++){
            var adjacent = adjacents[i];
            var node = graph[adjacent];
            if (node.distance === -1) {
                node.distance = graph[current].distance + 1;
                node.parent = current;
                queue.unshift(adjacent);
            }
        }
    }
    return graph;
}
function $1807b44030601d9a$var$link(from, to) {
    return function(args) {
        return to(from(args));
    };
}
function $1807b44030601d9a$var$wrapConversion(toModel, graph) {
    var path = [
        graph[toModel].parent,
        toModel
    ];
    var fn = $7f6f8e04ce3f0a38$exports[graph[toModel].parent][toModel];
    var cur = graph[toModel].parent;
    while(graph[cur].parent){
        path.unshift(graph[cur].parent);
        fn = $1807b44030601d9a$var$link($7f6f8e04ce3f0a38$exports[graph[cur].parent][cur], fn);
        cur = graph[cur].parent;
    }
    fn.conversion = path;
    return fn;
}
$1807b44030601d9a$exports = function(fromModel) {
    var graph = $1807b44030601d9a$var$deriveBFS(fromModel);
    var conversion = {};
    var models = Object.keys(graph);
    for(var len = models.length, i = 0; i < len; i++){
        var toModel = models[i];
        var node = graph[toModel];
        if (node.parent === null) continue;
        conversion[toModel] = $1807b44030601d9a$var$wrapConversion(toModel, graph);
    }
    return conversion;
};


var $3e574d92e62e98fa$var$convert = {};
var $3e574d92e62e98fa$var$models = Object.keys($7f6f8e04ce3f0a38$exports);
function $3e574d92e62e98fa$var$wrapRaw(fn) {
    var wrappedFn = function(args) {
        if (args === undefined || args === null) return args;
        if (arguments.length > 1) args = Array.prototype.slice.call(arguments);
        return fn(args);
    };
    // preserve .conversion property if there is one
    if ('conversion' in fn) wrappedFn.conversion = fn.conversion;
    return wrappedFn;
}
function $3e574d92e62e98fa$var$wrapRounded(fn) {
    var wrappedFn = function(args) {
        if (args === undefined || args === null) return args;
        if (arguments.length > 1) args = Array.prototype.slice.call(arguments);
        var result = fn(args);
        // we're assuming the result is an array here.
        // see notice in conversions.js; don't use box types
        // in conversion functions.
        if (typeof result === 'object') for(var len = result.length, i = 0; i < len; i++)result[i] = Math.round(result[i]);
        return result;
    };
    // preserve .conversion property if there is one
    if ('conversion' in fn) wrappedFn.conversion = fn.conversion;
    return wrappedFn;
}
$3e574d92e62e98fa$var$models.forEach(function(fromModel) {
    $3e574d92e62e98fa$var$convert[fromModel] = {};
    Object.defineProperty($3e574d92e62e98fa$var$convert[fromModel], 'channels', {
        value: $7f6f8e04ce3f0a38$exports[fromModel].channels
    });
    Object.defineProperty($3e574d92e62e98fa$var$convert[fromModel], 'labels', {
        value: $7f6f8e04ce3f0a38$exports[fromModel].labels
    });
    var routes = $1807b44030601d9a$exports(fromModel);
    var routeModels = Object.keys(routes);
    routeModels.forEach(function(toModel) {
        var fn = routes[toModel];
        $3e574d92e62e98fa$var$convert[fromModel][toModel] = $3e574d92e62e98fa$var$wrapRounded(fn);
        $3e574d92e62e98fa$var$convert[fromModel][toModel].raw = $3e574d92e62e98fa$var$wrapRaw(fn);
    });
});
$3e574d92e62e98fa$exports = $3e574d92e62e98fa$var$convert;


var $08acccbbd431ef55$var$_slice = [].slice;
var $08acccbbd431ef55$var$skippedModels = [
    // to be honest, I don't really feel like keyword belongs in color convert, but eh.
    'keyword',
    // gray conflicts with some method names, and has its own method defined.
    'gray',
    // shouldn't really be in color-convert either...
    'hex'
];
var $08acccbbd431ef55$var$hashedModelKeys = {};
Object.keys($3e574d92e62e98fa$exports).forEach(function(model) {
    $08acccbbd431ef55$var$hashedModelKeys[$08acccbbd431ef55$var$_slice.call($3e574d92e62e98fa$exports[model].labels).sort().join('')] = model;
});
var $08acccbbd431ef55$var$limiters = {};
function $08acccbbd431ef55$var$Color(obj, model) {
    if (!(this instanceof $08acccbbd431ef55$var$Color)) return new $08acccbbd431ef55$var$Color(obj, model);
    if (model && model in $08acccbbd431ef55$var$skippedModels) model = null;
    if (model && !(model in $3e574d92e62e98fa$exports)) throw new Error('Unknown model: ' + model);
    var i;
    var channels;
    if (obj == null) {
        this.model = 'rgb';
        this.color = [
            0,
            0,
            0
        ];
        this.valpha = 1;
    } else if (obj instanceof $08acccbbd431ef55$var$Color) {
        this.model = obj.model;
        this.color = obj.color.slice();
        this.valpha = obj.valpha;
    } else if (typeof obj === 'string') {
        var result = $86e889c881e89501$exports.get(obj);
        if (result === null) throw new Error('Unable to parse color from string: ' + obj);
        this.model = result.model;
        channels = $3e574d92e62e98fa$exports[this.model].channels;
        this.color = result.value.slice(0, channels);
        this.valpha = typeof result.value[channels] === 'number' ? result.value[channels] : 1;
    } else if (obj.length) {
        this.model = model || 'rgb';
        channels = $3e574d92e62e98fa$exports[this.model].channels;
        var newArr = $08acccbbd431ef55$var$_slice.call(obj, 0, channels);
        this.color = $08acccbbd431ef55$var$zeroArray(newArr, channels);
        this.valpha = typeof obj[channels] === 'number' ? obj[channels] : 1;
    } else if (typeof obj === 'number') {
        // this is always RGB - can be converted later on.
        obj &= 0xFFFFFF;
        this.model = 'rgb';
        this.color = [
            obj >> 16 & 0xFF,
            obj >> 8 & 0xFF,
            obj & 0xFF
        ];
        this.valpha = 1;
    } else {
        this.valpha = 1;
        var keys = Object.keys(obj);
        if ('alpha' in obj) {
            keys.splice(keys.indexOf('alpha'), 1);
            this.valpha = typeof obj.alpha === 'number' ? obj.alpha : 0;
        }
        var hashedKeys = keys.sort().join('');
        if (!(hashedKeys in $08acccbbd431ef55$var$hashedModelKeys)) throw new Error('Unable to parse color from object: ' + JSON.stringify(obj));
        this.model = $08acccbbd431ef55$var$hashedModelKeys[hashedKeys];
        var labels = $3e574d92e62e98fa$exports[this.model].labels;
        var color = [];
        for(i = 0; i < labels.length; i++)color.push(obj[labels[i]]);
        this.color = $08acccbbd431ef55$var$zeroArray(color);
    }
    // perform limitations (clamping, etc.)
    if ($08acccbbd431ef55$var$limiters[this.model]) {
        channels = $3e574d92e62e98fa$exports[this.model].channels;
        for(i = 0; i < channels; i++){
            var limit = $08acccbbd431ef55$var$limiters[this.model][i];
            if (limit) this.color[i] = limit(this.color[i]);
        }
    }
    this.valpha = Math.max(0, Math.min(1, this.valpha));
    if (Object.freeze) Object.freeze(this);
}
$08acccbbd431ef55$var$Color.prototype = {
    toString: function() {
        return this.string();
    },
    toJSON: function() {
        return this[this.model]();
    },
    string: function(places) {
        var self = this.model in $86e889c881e89501$exports.to ? this : this.rgb();
        self = self.round(typeof places === 'number' ? places : 1);
        var args = self.valpha === 1 ? self.color : self.color.concat(this.valpha);
        return $86e889c881e89501$exports.to[self.model](args);
    },
    percentString: function(places) {
        var self = this.rgb().round(typeof places === 'number' ? places : 1);
        var args = self.valpha === 1 ? self.color : self.color.concat(this.valpha);
        return $86e889c881e89501$exports.to.rgb.percent(args);
    },
    array: function() {
        return this.valpha === 1 ? this.color.slice() : this.color.concat(this.valpha);
    },
    object: function() {
        var result = {};
        var channels = $3e574d92e62e98fa$exports[this.model].channels;
        var labels = $3e574d92e62e98fa$exports[this.model].labels;
        for(var i = 0; i < channels; i++)result[labels[i]] = this.color[i];
        if (this.valpha !== 1) result.alpha = this.valpha;
        return result;
    },
    unitArray: function() {
        var rgb = this.rgb().color;
        rgb[0] /= 255;
        rgb[1] /= 255;
        rgb[2] /= 255;
        if (this.valpha !== 1) rgb.push(this.valpha);
        return rgb;
    },
    unitObject: function() {
        var rgb = this.rgb().object();
        rgb.r /= 255;
        rgb.g /= 255;
        rgb.b /= 255;
        if (this.valpha !== 1) rgb.alpha = this.valpha;
        return rgb;
    },
    round: function(places) {
        places = Math.max(places || 0, 0);
        return new $08acccbbd431ef55$var$Color(this.color.map($08acccbbd431ef55$var$roundToPlace(places)).concat(this.valpha), this.model);
    },
    alpha: function(val) {
        if (arguments.length) return new $08acccbbd431ef55$var$Color(this.color.concat(Math.max(0, Math.min(1, val))), this.model);
        return this.valpha;
    },
    // rgb
    red: $08acccbbd431ef55$var$getset('rgb', 0, $08acccbbd431ef55$var$maxfn(255)),
    green: $08acccbbd431ef55$var$getset('rgb', 1, $08acccbbd431ef55$var$maxfn(255)),
    blue: $08acccbbd431ef55$var$getset('rgb', 2, $08acccbbd431ef55$var$maxfn(255)),
    hue: $08acccbbd431ef55$var$getset([
        'hsl',
        'hsv',
        'hsl',
        'hwb',
        'hcg'
    ], 0, function(val) {
        return (val % 360 + 360) % 360;
    }),
    saturationl: $08acccbbd431ef55$var$getset('hsl', 1, $08acccbbd431ef55$var$maxfn(100)),
    lightness: $08acccbbd431ef55$var$getset('hsl', 2, $08acccbbd431ef55$var$maxfn(100)),
    saturationv: $08acccbbd431ef55$var$getset('hsv', 1, $08acccbbd431ef55$var$maxfn(100)),
    value: $08acccbbd431ef55$var$getset('hsv', 2, $08acccbbd431ef55$var$maxfn(100)),
    chroma: $08acccbbd431ef55$var$getset('hcg', 1, $08acccbbd431ef55$var$maxfn(100)),
    gray: $08acccbbd431ef55$var$getset('hcg', 2, $08acccbbd431ef55$var$maxfn(100)),
    white: $08acccbbd431ef55$var$getset('hwb', 1, $08acccbbd431ef55$var$maxfn(100)),
    wblack: $08acccbbd431ef55$var$getset('hwb', 2, $08acccbbd431ef55$var$maxfn(100)),
    cyan: $08acccbbd431ef55$var$getset('cmyk', 0, $08acccbbd431ef55$var$maxfn(100)),
    magenta: $08acccbbd431ef55$var$getset('cmyk', 1, $08acccbbd431ef55$var$maxfn(100)),
    yellow: $08acccbbd431ef55$var$getset('cmyk', 2, $08acccbbd431ef55$var$maxfn(100)),
    black: $08acccbbd431ef55$var$getset('cmyk', 3, $08acccbbd431ef55$var$maxfn(100)),
    x: $08acccbbd431ef55$var$getset('xyz', 0, $08acccbbd431ef55$var$maxfn(100)),
    y: $08acccbbd431ef55$var$getset('xyz', 1, $08acccbbd431ef55$var$maxfn(100)),
    z: $08acccbbd431ef55$var$getset('xyz', 2, $08acccbbd431ef55$var$maxfn(100)),
    l: $08acccbbd431ef55$var$getset('lab', 0, $08acccbbd431ef55$var$maxfn(100)),
    a: $08acccbbd431ef55$var$getset('lab', 1),
    b: $08acccbbd431ef55$var$getset('lab', 2),
    keyword: function(val) {
        if (arguments.length) return new $08acccbbd431ef55$var$Color(val);
        return $3e574d92e62e98fa$exports[this.model].keyword(this.color);
    },
    hex: function(val) {
        if (arguments.length) return new $08acccbbd431ef55$var$Color(val);
        return $86e889c881e89501$exports.to.hex(this.rgb().round().color);
    },
    rgbNumber: function() {
        var rgb = this.rgb().color;
        return (rgb[0] & 0xFF) << 16 | (rgb[1] & 0xFF) << 8 | rgb[2] & 0xFF;
    },
    luminosity: function() {
        // http://www.w3.org/TR/WCAG20/#relativeluminancedef
        var rgb = this.rgb().color;
        var lum = [];
        for(var i = 0; i < rgb.length; i++){
            var chan = rgb[i] / 255;
            lum[i] = chan <= 0.03928 ? chan / 12.92 : Math.pow((chan + 0.055) / 1.055, 2.4);
        }
        return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
    },
    contrast: function(color2) {
        // http://www.w3.org/TR/WCAG20/#contrast-ratiodef
        var lum1 = this.luminosity();
        var lum2 = color2.luminosity();
        if (lum1 > lum2) return (lum1 + 0.05) / (lum2 + 0.05);
        return (lum2 + 0.05) / (lum1 + 0.05);
    },
    level: function(color2) {
        var contrastRatio = this.contrast(color2);
        if (contrastRatio >= 7.1) return 'AAA';
        return contrastRatio >= 4.5 ? 'AA' : '';
    },
    isDark: function() {
        // YIQ equation from http://24ways.org/2010/calculating-color-contrast
        var rgb = this.rgb().color;
        var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
        return yiq < 128;
    },
    isLight: function() {
        return !this.isDark();
    },
    negate: function() {
        var rgb = this.rgb();
        for(var i = 0; i < 3; i++)rgb.color[i] = 255 - rgb.color[i];
        return rgb;
    },
    lighten: function(ratio) {
        var hsl = this.hsl();
        hsl.color[2] += hsl.color[2] * ratio;
        return hsl;
    },
    darken: function(ratio) {
        var hsl = this.hsl();
        hsl.color[2] -= hsl.color[2] * ratio;
        return hsl;
    },
    saturate: function(ratio) {
        var hsl = this.hsl();
        hsl.color[1] += hsl.color[1] * ratio;
        return hsl;
    },
    desaturate: function(ratio) {
        var hsl = this.hsl();
        hsl.color[1] -= hsl.color[1] * ratio;
        return hsl;
    },
    whiten: function(ratio) {
        var hwb = this.hwb();
        hwb.color[1] += hwb.color[1] * ratio;
        return hwb;
    },
    blacken: function(ratio) {
        var hwb = this.hwb();
        hwb.color[2] += hwb.color[2] * ratio;
        return hwb;
    },
    grayscale: function() {
        // http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
        var rgb = this.rgb().color;
        var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
        return $08acccbbd431ef55$var$Color.rgb(val, val, val);
    },
    fade: function(ratio) {
        return this.alpha(this.valpha - this.valpha * ratio);
    },
    opaquer: function(ratio) {
        return this.alpha(this.valpha + this.valpha * ratio);
    },
    rotate: function(degrees) {
        var hsl = this.hsl();
        var hue = hsl.color[0];
        hue = (hue + degrees) % 360;
        hue = hue < 0 ? 360 + hue : hue;
        hsl.color[0] = hue;
        return hsl;
    },
    mix: function(mixinColor, weight) {
        // ported from sass implementation in C
        // https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
        if (!mixinColor || !mixinColor.rgb) throw new Error('Argument to "mix" was not a Color instance, but rather an instance of ' + typeof mixinColor);
        var color1 = mixinColor.rgb();
        var color2 = this.rgb();
        var p = weight === undefined ? 0.5 : weight;
        var w = 2 * p - 1;
        var a = color1.alpha() - color2.alpha();
        var w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
        var w2 = 1 - w1;
        return $08acccbbd431ef55$var$Color.rgb(w1 * color1.red() + w2 * color2.red(), w1 * color1.green() + w2 * color2.green(), w1 * color1.blue() + w2 * color2.blue(), color1.alpha() * p + color2.alpha() * (1 - p));
    }
};
// model conversion methods and static constructors
Object.keys($3e574d92e62e98fa$exports).forEach(function(model) {
    if ($08acccbbd431ef55$var$skippedModels.indexOf(model) !== -1) return;
    var channels = $3e574d92e62e98fa$exports[model].channels;
    // conversion methods
    $08acccbbd431ef55$var$Color.prototype[model] = function() {
        if (this.model === model) return new $08acccbbd431ef55$var$Color(this);
        if (arguments.length) return new $08acccbbd431ef55$var$Color(arguments, model);
        var newAlpha = typeof arguments[channels] === 'number' ? channels : this.valpha;
        return new $08acccbbd431ef55$var$Color($08acccbbd431ef55$var$assertArray($3e574d92e62e98fa$exports[this.model][model].raw(this.color)).concat(newAlpha), model);
    };
    // 'static' construction methods
    $08acccbbd431ef55$var$Color[model] = function(color) {
        if (typeof color === 'number') color = $08acccbbd431ef55$var$zeroArray($08acccbbd431ef55$var$_slice.call(arguments), channels);
        return new $08acccbbd431ef55$var$Color(color, model);
    };
});
function $08acccbbd431ef55$var$roundTo(num, places) {
    return Number(num.toFixed(places));
}
function $08acccbbd431ef55$var$roundToPlace(places) {
    return function(num) {
        return $08acccbbd431ef55$var$roundTo(num, places);
    };
}
function $08acccbbd431ef55$var$getset(model, channel, modifier) {
    model = Array.isArray(model) ? model : [
        model
    ];
    model.forEach(function(m) {
        ($08acccbbd431ef55$var$limiters[m] || ($08acccbbd431ef55$var$limiters[m] = []))[channel] = modifier;
    });
    model = model[0];
    return function(val) {
        var result;
        if (arguments.length) {
            if (modifier) val = modifier(val);
            result = this[model]();
            result.color[channel] = val;
            return result;
        }
        result = this[model]().color[channel];
        if (modifier) result = modifier(result);
        return result;
    };
}
function $08acccbbd431ef55$var$maxfn(max) {
    return function(v) {
        return Math.max(0, Math.min(max, v));
    };
}
function $08acccbbd431ef55$var$assertArray(val) {
    return Array.isArray(val) ? val : [
        val
    ];
}
function $08acccbbd431ef55$var$zeroArray(arr, length) {
    for(var i = 0; i < length; i++)if (typeof arr[i] !== 'number') arr[i] = 0;
    return arr;
}
$08acccbbd431ef55$exports = $08acccbbd431ef55$var$Color;


var $c4542b84c1927bd5$exports = {};
'use strict';
var $c4542b84c1927bd5$var$isArray = Array.isArray;
var $c4542b84c1927bd5$var$keyList = Object.keys;
var $c4542b84c1927bd5$var$hasProp = Object.prototype.hasOwnProperty;
$c4542b84c1927bd5$exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        var arrA = $c4542b84c1927bd5$var$isArray(a), arrB = $c4542b84c1927bd5$var$isArray(b), i, length, key;
        if (arrA && arrB) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (arrA != arrB) return false;
        var dateA = a instanceof Date, dateB = b instanceof Date;
        if (dateA != dateB) return false;
        if (dateA && dateB) return a.getTime() == b.getTime();
        var regexpA = a instanceof RegExp, regexpB = b instanceof RegExp;
        if (regexpA != regexpB) return false;
        if (regexpA && regexpB) return a.toString() == b.toString();
        var keys = $c4542b84c1927bd5$var$keyList(a);
        length = keys.length;
        if (length !== $c4542b84c1927bd5$var$keyList(b).length) return false;
        for(i = length; i-- !== 0;)if (!$c4542b84c1927bd5$var$hasProp.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
};


let $f8f71edb2b5cacdf$var$canvas;
const $f8f71edb2b5cacdf$var$OPTIONS = {
    width: 100,
    height: 10
};
// const ISNODE = typeof global === 'object';
let $f8f71edb2b5cacdf$var$offscreenCanvas = false;
try {
    const canvas = new OffscreenCanvas(1, 1);
    const ctx = canvas.getContext('2d');
    ctx.fillText('hello', 0, 0);
    $f8f71edb2b5cacdf$var$offscreenCanvas = true;
} catch (err) {
    $f8f71edb2b5cacdf$var$offscreenCanvas = false;
}
function $f8f71edb2b5cacdf$var$getCanvas() {
    if (!$f8f71edb2b5cacdf$var$canvas) {
        const { width: width, height: height } = $f8f71edb2b5cacdf$var$OPTIONS;
        if ($f8f71edb2b5cacdf$var$offscreenCanvas) $f8f71edb2b5cacdf$var$canvas = new OffscreenCanvas(width, height);
        else {
            $f8f71edb2b5cacdf$var$canvas = document.createElement('canvas');
            $f8f71edb2b5cacdf$var$canvas.width = width;
            $f8f71edb2b5cacdf$var$canvas.height = height;
        }
    }
    return $f8f71edb2b5cacdf$var$canvas;
}
function $f8f71edb2b5cacdf$export$9573117a657eb43f(canvasInstance) {
    if (canvasInstance) $f8f71edb2b5cacdf$var$canvas = canvasInstance;
}
class $f8f71edb2b5cacdf$export$6d355730f3cecc27 {
    constructor(colors, options = {}){
        if (!Array.isArray(colors)) {
            console.error('colors is not array');
            return;
        }
        if (colors.length < 2) {
            console.error('colors.length should >1');
            return;
        }
        this.colors = colors;
        let min = Infinity, max = -Infinity;
        for(let i = 0, len = colors.length; i < len; i++){
            const value = colors[i][0];
            min = Math.min(value, min);
            max = Math.max(value, max);
        }
        this.min = min;
        this.max = max;
        this.valueOffset = this.max - this.min;
        this.options = Object.assign({}, $f8f71edb2b5cacdf$var$OPTIONS, options);
        this._initImgData();
    }
    getImageData() {
        return this.imgData;
    }
    _initImgData() {
        const canvas = $f8f71edb2b5cacdf$var$getCanvas();
        const { width: width, height: height } = this.options;
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        const gradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
        const { colors: colors, valueOffset: valueOffset } = this;
        for(let i = 0, len = colors.length; i < len; i++){
            const [stop, color] = colors[i];
            const s = (stop - this.min) / valueOffset;
            gradient.addColorStop(s, color);
        }
        ctx.fillStyle = gradient;
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        this.imgData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    }
    getColor(stop) {
        stop = Math.max(this.min, stop);
        stop = Math.min(stop, this.max);
        const s = (stop - this.min) / this.valueOffset;
        let x = Math.round(s * this.imgData.width);
        x = Math.min(x, this.imgData.width - 1);
        const idx = x * 4;
        const r = this.imgData.data[idx];
        const g = this.imgData.data[idx + 1];
        const b = this.imgData.data[idx + 2];
        const a = this.imgData.data[idx + 3];
        return [
            r,
            g,
            b,
            a
        ];
    }
}


var $14507960c5dac0fb$var$isMapSupported = typeof Map === 'function';
var $14507960c5dac0fb$var$colorInCache;
if ($14507960c5dac0fb$var$isMapSupported) $14507960c5dac0fb$var$colorInCache = new Map();
function $14507960c5dac0fb$var$isNull(value) {
    return value === null || value === undefined;
}
function $14507960c5dac0fb$var$isNotNull(value) {
    return !$14507960c5dac0fb$var$isNull(value);
}
function $14507960c5dac0fb$var$isEmptyString(value) {
    return value === '';
}
/*eslint-disable no-var, prefer-const*/ function $14507960c5dac0fb$var$createFunction(parameters, defaultType) {
    var fun;
    var isFeatureConstant, isZoomConstant;
    if (!$14507960c5dac0fb$export$ec423ecbfcdb9a06(parameters)) {
        fun = function() {
            return parameters;
        };
        isFeatureConstant = true;
        isZoomConstant = true;
    } else {
        var zoomAndFeatureDependent = parameters.stops && typeof parameters.stops[0][0] === 'object';
        var featureDependent = zoomAndFeatureDependent || $14507960c5dac0fb$var$isNotNull(parameters.property);
        var zoomDependent = zoomAndFeatureDependent || !featureDependent;
        var type = parameters.type || defaultType || 'exponential';
        var innerFun;
        if (type === 'exponential') innerFun = $14507960c5dac0fb$var$evaluateExponentialFunction;
        else if (type === 'interval') innerFun = $14507960c5dac0fb$var$evaluateIntervalFunction;
        else if (type === 'categorical') innerFun = $14507960c5dac0fb$var$evaluateCategoricalFunction;
        else if (type === 'identity') innerFun = $14507960c5dac0fb$var$evaluateIdentityFunction;
        else if (type === 'color-interpolate') innerFun = $14507960c5dac0fb$var$evaluateColorInterpolateFunction;
        else if (type === 'calculate-expression') innerFun = $14507960c5dac0fb$var$evaluateCalculateExpressionFunction;
        else throw new Error('Unknown function type "' + type + '"');
        if (zoomAndFeatureDependent) {
            var featureFunctions = {};
            var featureFunctionStops = [];
            for(let s = 0; s < parameters.stops.length; s++){
                var stop = parameters.stops[s];
                if (featureFunctions[stop[0].zoom] === undefined) featureFunctions[stop[0].zoom] = {
                    zoom: stop[0].zoom,
                    type: parameters.type,
                    property: parameters.property,
                    default: parameters.default,
                    stops: []
                };
                featureFunctions[stop[0].zoom].stops.push([
                    stop[0].value,
                    stop[1]
                ]);
            }
            for(let z in featureFunctions)featureFunctionStops.push([
                featureFunctions[z].zoom,
                $14507960c5dac0fb$var$createFunction(featureFunctions[z])
            ]);
            fun = function(zoom, feature) {
                const value = $14507960c5dac0fb$var$evaluateExponentialFunction({
                    stops: featureFunctionStops,
                    base: parameters.base
                }, zoom)(zoom, feature);
                return typeof value === 'function' ? value(zoom, feature) : value;
            };
            isFeatureConstant = false;
            isZoomConstant = false;
        } else if (zoomDependent) {
            fun = function(zoom) {
                const value = innerFun(parameters, zoom);
                return typeof value === 'function' ? value(zoom) : value;
            };
            isFeatureConstant = true;
            isZoomConstant = false;
        } else {
            fun = function(zoom, feature) {
                const value = innerFun(parameters, feature ? feature[parameters.property] : null);
                return typeof value === 'function' ? value(zoom, feature) : value;
            };
            isFeatureConstant = false;
            isZoomConstant = true;
        }
    }
    fun.isZoomConstant = isZoomConstant;
    fun.isFeatureConstant = isFeatureConstant;
    return fun;
}
function $14507960c5dac0fb$var$coalesce(a, b, c) {
    if ($14507960c5dac0fb$var$isNotNull(a)) return a;
    if ($14507960c5dac0fb$var$isNotNull(b)) return b;
    if ($14507960c5dac0fb$var$isNotNull(c)) return c;
    return null;
}
function $14507960c5dac0fb$var$evaluateCategoricalFunction(parameters, input) {
    for(let i = 0; i < parameters.stops.length; i++){
        if (input === parameters.stops[i][0]) return parameters.stops[i][1];
    }
    return parameters.default;
}
function $14507960c5dac0fb$var$evaluateIntervalFunction(parameters, input) {
    for(var i = 0; i < parameters.stops.length; i++){
        if (input < parameters.stops[i][0]) break;
    }
    return parameters.stops[Math.max(i - 1, 0)][1];
}
function $14507960c5dac0fb$var$evaluateExponentialFunction(parameters, input) {
    var base = $14507960c5dac0fb$var$isNotNull(parameters.base) && !$14507960c5dac0fb$var$isEmptyString(parameters.base) ? parameters.base : 1;
    var i = 0;
    while(true){
        if (i >= parameters.stops.length) break;
        else if (input <= parameters.stops[i][0]) break;
        else i++;
    }
    if (i === 0) return parameters.stops[i][1];
    else if (i === parameters.stops.length) return parameters.stops[i - 1][1];
    else return $14507960c5dac0fb$var$interpolate(input, base, parameters.stops[i - 1][0], parameters.stops[i][0], parameters.stops[i - 1][1], parameters.stops[i][1]);
}
const $14507960c5dac0fb$var$COLORIN_OPTIONS = {
    width: 100,
    height: 1
};
function $14507960c5dac0fb$var$evaluateColorInterpolateFunction(parameters, input) {
    const stops = parameters.stops;
    if (stops && stops.length > 1) {
        let colorIn;
        if ($14507960c5dac0fb$var$colorInCache) {
            const key = JSON.stringify(stops);
            if (!$14507960c5dac0fb$var$colorInCache.has(key)) {
                const colorIn = new (0, $f8f71edb2b5cacdf$export$6d355730f3cecc27)(stops, $14507960c5dac0fb$var$COLORIN_OPTIONS);
                $14507960c5dac0fb$var$colorInCache.set(key, colorIn);
            }
            colorIn = $14507960c5dac0fb$var$colorInCache.get(key);
        } else colorIn = new (0, $f8f71edb2b5cacdf$export$6d355730f3cecc27)(stops, $14507960c5dac0fb$var$COLORIN_OPTIONS);
        const [r, g, b, a] = colorIn.getColor(input);
        return [
            r / 255,
            g / 255,
            b / 255,
            a / 255
        ];
    } else if (stops && stops.length === 1) return stops[0][1];
    return null;
}
function $14507960c5dac0fb$var$evaluateIdentityFunction(parameters, input) {
    return $14507960c5dac0fb$var$coalesce(input, parameters.default);
}
// 2添加修改计算函数
// 处理空字符串和未定义属性的函数
function $14507960c5dac0fb$var$evaluateCalculateExpressionFunction(parameters, input) {
    const targetVariable = String(parameters.property);
    const expression = parameters.expression;
    const newValue = input;
    // 定义函数来替换表达式中的变量
    function traverseAndAssign(expression, targetVariable, newValue) {
        const newValueAsNumber = Number(newValue);
        const targetVariableAsString = String(targetVariable);
        if (Array.isArray(expression)) return expression.map((subExpr)=>traverseAndAssign(subExpr, targetVariableAsString, newValueAsNumber));
        else if (expression === targetVariableAsString) return newValueAsNumber;
        else return expression;
    }
    // 定义函数来计算表达式的结果
    function evaluateExpression(expression) {
        if (Array.isArray(expression)) {
            const operator = expression[0];
            if (![
                '+',
                '-',
                '*',
                '/'
            ].includes(operator)) throw new Error(`Unknown operator: ${operator}`);
            const operands = expression.slice(1).map((op)=>evaluateExpression(op));
            switch(operator){
                case '+':
                    return operands.reduce((acc, curr)=>acc + curr, 0);
                case '-':
                    return operands.reduce((acc, curr)=>acc - curr);
                case '*':
                    return operands.reduce((acc, curr)=>acc * curr, 1);
                case '/':
                    // 如果发现有零作为除数，返回默认值
                    if (operands.some((op)=>op === 0)) return parameters.default;
                    return operands.reduce((acc, curr)=>acc / curr);
                default:
                    throw new Error(`Unsupported operator: ${operator}`);
            }
        } else if (typeof expression === 'number') return expression;
        else throw new Error('Invalid expression format');
    }
    // 使用 coalesce 函数处理结果中的默认值
    function coalesce(value) {
        return $14507960c5dac0fb$var$isNull(value) || $14507960c5dac0fb$var$isEmptyString(value) || isNaN(value) ? parameters.default : value;
    }
    // 如果 input 存在且大于0，则处理表达式
    if ($14507960c5dac0fb$var$isNotNull(input) && !$14507960c5dac0fb$var$isEmptyString(input) && !isNaN(input) && !(input < 0)) {
        const updatedExpression = traverseAndAssign(expression, targetVariable, newValue);
        return coalesce(evaluateExpression(updatedExpression));
    } else return coalesce(parameters.default);
}
function $14507960c5dac0fb$var$interpolate(input, base, inputLower, inputUpper, outputLower, outputUpper) {
    if (typeof outputLower === 'function') return function() {
        var evaluatedLower = outputLower.apply(undefined, arguments);
        var evaluatedUpper = outputUpper.apply(undefined, arguments);
        return $14507960c5dac0fb$var$interpolate(input, base, inputLower, inputUpper, evaluatedLower, evaluatedUpper);
    };
    else if (outputLower.length) return $14507960c5dac0fb$var$interpolateArray(input, base, inputLower, inputUpper, outputLower, outputUpper);
    else return $14507960c5dac0fb$var$interpolateNumber(input, base, inputLower, inputUpper, outputLower, outputUpper);
}
function $14507960c5dac0fb$var$interpolateNumber(input, base, inputLower, inputUpper, outputLower, outputUpper) {
    var difference = inputUpper - inputLower;
    var progress = input - inputLower;
    var ratio;
    if (base === 1) ratio = progress / difference;
    else ratio = (Math.pow(base, progress) - 1) / (Math.pow(base, difference) - 1);
    return outputLower * (1 - ratio) + outputUpper * ratio;
}
function $14507960c5dac0fb$var$interpolateArray(input, base, inputLower, inputUpper, outputLower, outputUpper) {
    var output = [];
    for(let i = 0; i < outputLower.length; i++)output[i] = $14507960c5dac0fb$var$interpolateNumber(input, base, inputLower, inputUpper, outputLower[i], outputUpper[i]);
    return output;
}
function $14507960c5dac0fb$export$ec423ecbfcdb9a06(obj) {
    return obj && typeof obj === 'object' && (obj.stops || obj.property && obj.type === 'identity' || obj.expression && obj.type === 'calculate-expression');
}
function $14507960c5dac0fb$export$3ab4b318ddeff41d(obj) {
    for(const p in obj){
        if ($14507960c5dac0fb$export$ec423ecbfcdb9a06(obj[p])) return true;
    }
    return false;
}
function $14507960c5dac0fb$export$b5e0f6446c9b8e3c(parameters) {
    return $14507960c5dac0fb$var$createFunction1(parameters, 'exponential');
}
function $14507960c5dac0fb$export$79e978600dd1e509(parameters) {
    return $14507960c5dac0fb$var$createFunction1(parameters, 'interval');
}
function $14507960c5dac0fb$export$7359e25750286ba6(obj, argFn) {
    if (!obj) return null;
    var hit = false;
    if (Array.isArray(obj)) {
        var multResult = [], loaded;
        for(let i = 0; i < obj.length; i++){
            loaded = $14507960c5dac0fb$export$7359e25750286ba6(obj[i], argFn);
            if (!loaded) multResult.push(obj[i]);
            else {
                multResult.push(loaded);
                hit = true;
            }
        }
        return hit ? multResult : obj;
    }
    var result = {
        '__fn_types_loaded': true
    }, props = [], p;
    for(p in obj)if (obj.hasOwnProperty(p)) props.push(p);
    const buildFn = function(p) {
        Object.defineProperty(result, p, {
            get: function() {
                if (!this['__fn_' + p]) this['__fn_' + p] = $14507960c5dac0fb$export$b5e0f6446c9b8e3c(this['_' + p]);
                return this['__fn_' + p].apply(this, argFn());
            },
            set: function(v) {
                this['_' + p] = v;
            },
            configurable: true,
            enumerable: true
        });
    };
    for(let i = 0, len = props.length; i < len; i++){
        p = props[i];
        if ($14507960c5dac0fb$export$ec423ecbfcdb9a06(obj[p])) {
            hit = true;
            result['_' + p] = obj[p];
            buildFn(p);
        } else result[p] = obj[p];
    }
    return hit ? result : obj;
}
function $14507960c5dac0fb$export$ea0045a2989f36d(t) {
    if (!t || !t.stops) return [];
    const res = [];
    for(let i = 0, l = t.stops.length; i < l; i++)res.push(t.stops[i][1]);
    return res;
}
/*eslint-enable no-var, prefer-const*/ function $14507960c5dac0fb$var$createFunction1(parameters, defaultType) {
    if (!$14507960c5dac0fb$export$ec423ecbfcdb9a06(parameters)) return function() {
        return parameters;
    };
    parameters = JSON.parse(JSON.stringify(parameters));
    let isZoomConstant = true;
    let isFeatureConstant = true;
    const stops = parameters.stops;
    if (stops) {
        for(let i = 0; i < stops.length; i++)if ($14507960c5dac0fb$export$ec423ecbfcdb9a06(stops[i][1])) {
            const fn = $14507960c5dac0fb$var$createFunction1(stops[i][1], defaultType);
            isZoomConstant = isZoomConstant && fn.isZoomConstant;
            isFeatureConstant = isFeatureConstant && fn.isFeatureConstant;
            stops[i] = [
                stops[i][0],
                fn
            ];
        }
    }
    const fn = $14507960c5dac0fb$var$createFunction(parameters, defaultType);
    fn.isZoomConstant = isZoomConstant && fn.isZoomConstant;
    fn.isFeatureConstant = isFeatureConstant && fn.isFeatureConstant;
    return fn;
}


/*!
* Contains code from jquery.easing
* BSD License
* https://github.com/gdsmith/jquery.easing/
*/ var $1b5c2c202f8c280d$var$pow = Math.pow, $1b5c2c202f8c280d$var$sqrt = Math.sqrt, $1b5c2c202f8c280d$var$sin = Math.sin, $1b5c2c202f8c280d$var$cos = Math.cos, $1b5c2c202f8c280d$var$PI = Math.PI, $1b5c2c202f8c280d$var$c1 = 1.70158, $1b5c2c202f8c280d$var$c2 = $1b5c2c202f8c280d$var$c1 * 1.525, $1b5c2c202f8c280d$var$c3 = $1b5c2c202f8c280d$var$c1 + 1, $1b5c2c202f8c280d$var$c4 = 2 * $1b5c2c202f8c280d$var$PI / 3, $1b5c2c202f8c280d$var$c5 = 2 * $1b5c2c202f8c280d$var$PI / 4.5;
// x is the fraction of animation progress, in the range 0..1
function $1b5c2c202f8c280d$var$bounceOut(x) {
    var n1 = 7.5625, d1 = 2.75;
    if (x < 1 / d1) return n1 * x * x;
    else if (x < 2 / d1) return n1 * (x -= 1.5 / d1) * x + .75;
    else if (x < 2.5 / d1) return n1 * (x -= 2.25 / d1) * x + .9375;
    else return n1 * (x -= 2.625 / d1) * x + .984375;
}
function $1b5c2c202f8c280d$export$2e2bcd8739ae039(easing, x) {
    easing = easing.toLowerCase();
    switch(easing){
        case 'swing':
            return $1b5c2c202f8c280d$export$84fc4030631e573c(x);
        case 'easeinquad':
            return $1b5c2c202f8c280d$export$2d59ca22077f6eab(x);
        case 'easeoutquad':
            return $1b5c2c202f8c280d$export$be35423d31ba201e(x);
        case 'easeinoutquad':
            return $1b5c2c202f8c280d$export$42add3d9cb3645a2(x);
        case 'easeincubic':
            return $1b5c2c202f8c280d$export$5da70c9577229d30(x);
        case 'easeoutcubic':
            return $1b5c2c202f8c280d$export$1157fb72e7fbceb5(x);
        case 'easeinoutcubic':
            return $1b5c2c202f8c280d$export$24656b269d8df7d6(x);
        case 'easeinquart':
            return $1b5c2c202f8c280d$export$c3d8280971f5e7ab(x);
        case 'easeoutquart':
            return $1b5c2c202f8c280d$export$fb9e4320a4025f10(x);
        case 'easeinoutquart':
            return $1b5c2c202f8c280d$export$bd93209e120f4915(x);
        case 'easeinquint':
            return $1b5c2c202f8c280d$export$d5a2637b851d40fa(x);
        case 'easeoutquint':
            return $1b5c2c202f8c280d$export$54ef52175ef1a966(x);
        case 'easeinoutquint':
            return $1b5c2c202f8c280d$export$40df750f1044ce5e(x);
        case 'easeinsine':
            return $1b5c2c202f8c280d$export$887f6c7954385bcf(x);
        case 'easeoutsine':
            return $1b5c2c202f8c280d$export$894fdbb88fdb9ced(x);
        case 'easeinoutsine':
            return $1b5c2c202f8c280d$export$dbce5739ea4fa8d3(x);
        case 'easeinexpo':
            return $1b5c2c202f8c280d$export$fe4a60940f66e545(x);
        case 'easeoutexpo':
            return $1b5c2c202f8c280d$export$b410709e4ad080bf(x);
        case 'easeinoutexpo':
            return $1b5c2c202f8c280d$export$ea354f4caf3d04bf(x);
        case 'easeincirc':
            return $1b5c2c202f8c280d$export$f6288029261ec108(x);
        case 'easeoutcirc':
            return $1b5c2c202f8c280d$export$f25eb0110f83e43b(x);
        case 'easeinoutcirc':
            return $1b5c2c202f8c280d$export$5f50baf27f660509(x);
        case 'easeinelastic':
            return $1b5c2c202f8c280d$export$1cfc337f5fbf02de(x);
        case 'easeoutelastic':
            return $1b5c2c202f8c280d$export$1d83bcb8568cb53c(x);
        case 'easeinoutelastic':
            return $1b5c2c202f8c280d$export$7d409c700005d9a9(x);
        case 'easeinback':
            return $1b5c2c202f8c280d$export$9d60100a8a802bac(x);
        case 'easeoutback':
            return $1b5c2c202f8c280d$export$3daa4a78f444687d(x);
        case 'easeinoutback':
            return $1b5c2c202f8c280d$export$7895717e81685a1a(x);
        case 'easeinbounce':
            return $1b5c2c202f8c280d$export$923f03c7f8e976ca(x);
        case 'easeoutbounce':
            return $1b5c2c202f8c280d$export$1f36003cbba0aa13(x);
        case 'easeinoutbounce':
            return $1b5c2c202f8c280d$export$150cd0e83065a867(x);
    }
    throw new Error('Unsupported easing function:' + easing);
}
function $1b5c2c202f8c280d$export$84fc4030631e573c(x) {
    return $1b5c2c202f8c280d$export$2d59ca22077f6eab(x);
}
function $1b5c2c202f8c280d$export$2d59ca22077f6eab(x) {
    return x * x;
}
function $1b5c2c202f8c280d$export$be35423d31ba201e(x) {
    return 1 - (1 - x) * (1 - x);
}
function $1b5c2c202f8c280d$export$42add3d9cb3645a2(x) {
    return x < 0.5 ? 2 * x * x : 1 - $1b5c2c202f8c280d$var$pow(-2 * x + 2, 2) / 2;
}
function $1b5c2c202f8c280d$export$5da70c9577229d30(x) {
    return x * x * x;
}
function $1b5c2c202f8c280d$export$1157fb72e7fbceb5(x) {
    return 1 - $1b5c2c202f8c280d$var$pow(1 - x, 3);
}
function $1b5c2c202f8c280d$export$24656b269d8df7d6(x) {
    return x < 0.5 ? 4 * x * x * x : 1 - $1b5c2c202f8c280d$var$pow(-2 * x + 2, 3) / 2;
}
function $1b5c2c202f8c280d$export$c3d8280971f5e7ab(x) {
    return x * x * x * x;
}
function $1b5c2c202f8c280d$export$fb9e4320a4025f10(x) {
    return 1 - $1b5c2c202f8c280d$var$pow(1 - x, 4);
}
function $1b5c2c202f8c280d$export$bd93209e120f4915(x) {
    return x < 0.5 ? 8 * x * x * x * x : 1 - $1b5c2c202f8c280d$var$pow(-2 * x + 2, 4) / 2;
}
function $1b5c2c202f8c280d$export$d5a2637b851d40fa(x) {
    return x * x * x * x * x;
}
function $1b5c2c202f8c280d$export$54ef52175ef1a966(x) {
    return 1 - $1b5c2c202f8c280d$var$pow(1 - x, 5);
}
function $1b5c2c202f8c280d$export$40df750f1044ce5e(x) {
    return x < 0.5 ? 16 * x * x * x * x * x : 1 - $1b5c2c202f8c280d$var$pow(-2 * x + 2, 5) / 2;
}
function $1b5c2c202f8c280d$export$887f6c7954385bcf(x) {
    return 1 - $1b5c2c202f8c280d$var$cos(x * $1b5c2c202f8c280d$var$PI / 2);
}
function $1b5c2c202f8c280d$export$894fdbb88fdb9ced(x) {
    return $1b5c2c202f8c280d$var$sin(x * $1b5c2c202f8c280d$var$PI / 2);
}
function $1b5c2c202f8c280d$export$dbce5739ea4fa8d3(x) {
    return -($1b5c2c202f8c280d$var$cos($1b5c2c202f8c280d$var$PI * x) - 1) / 2;
}
function $1b5c2c202f8c280d$export$fe4a60940f66e545(x) {
    return x === 0 ? 0 : $1b5c2c202f8c280d$var$pow(2, 10 * x - 10);
}
function $1b5c2c202f8c280d$export$b410709e4ad080bf(x) {
    return x === 1 ? 1 : 1 - $1b5c2c202f8c280d$var$pow(2, -10 * x);
}
function $1b5c2c202f8c280d$export$ea354f4caf3d04bf(x) {
    return x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? $1b5c2c202f8c280d$var$pow(2, 20 * x - 10) / 2 : (2 - $1b5c2c202f8c280d$var$pow(2, -20 * x + 10)) / 2;
}
function $1b5c2c202f8c280d$export$f6288029261ec108(x) {
    return 1 - $1b5c2c202f8c280d$var$sqrt(1 - $1b5c2c202f8c280d$var$pow(x, 2));
}
function $1b5c2c202f8c280d$export$f25eb0110f83e43b(x) {
    return $1b5c2c202f8c280d$var$sqrt(1 - $1b5c2c202f8c280d$var$pow(x - 1, 2));
}
function $1b5c2c202f8c280d$export$5f50baf27f660509(x) {
    return x < 0.5 ? (1 - $1b5c2c202f8c280d$var$sqrt(1 - $1b5c2c202f8c280d$var$pow(2 * x, 2))) / 2 : ($1b5c2c202f8c280d$var$sqrt(1 - $1b5c2c202f8c280d$var$pow(-2 * x + 2, 2)) + 1) / 2;
}
function $1b5c2c202f8c280d$export$1cfc337f5fbf02de(x) {
    return x === 0 ? 0 : x === 1 ? 1 : -$1b5c2c202f8c280d$var$pow(2, 10 * x - 10) * $1b5c2c202f8c280d$var$sin((x * 10 - 10.75) * $1b5c2c202f8c280d$var$c4);
}
function $1b5c2c202f8c280d$export$1d83bcb8568cb53c(x) {
    return x === 0 ? 0 : x === 1 ? 1 : $1b5c2c202f8c280d$var$pow(2, -10 * x) * $1b5c2c202f8c280d$var$sin((x * 10 - 0.75) * $1b5c2c202f8c280d$var$c4) + 1;
}
function $1b5c2c202f8c280d$export$7d409c700005d9a9(x) {
    return x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? -($1b5c2c202f8c280d$var$pow(2, 20 * x - 10) * $1b5c2c202f8c280d$var$sin((20 * x - 11.125) * $1b5c2c202f8c280d$var$c5)) / 2 : $1b5c2c202f8c280d$var$pow(2, -20 * x + 10) * $1b5c2c202f8c280d$var$sin((20 * x - 11.125) * $1b5c2c202f8c280d$var$c5) / 2 + 1;
}
function $1b5c2c202f8c280d$export$9d60100a8a802bac(x) {
    return $1b5c2c202f8c280d$var$c3 * x * x * x - $1b5c2c202f8c280d$var$c1 * x * x;
}
function $1b5c2c202f8c280d$export$3daa4a78f444687d(x) {
    return 1 + $1b5c2c202f8c280d$var$c3 * $1b5c2c202f8c280d$var$pow(x - 1, 3) + $1b5c2c202f8c280d$var$c1 * $1b5c2c202f8c280d$var$pow(x - 1, 2);
}
function $1b5c2c202f8c280d$export$7895717e81685a1a(x) {
    return x < 0.5 ? $1b5c2c202f8c280d$var$pow(2 * x, 2) * (($1b5c2c202f8c280d$var$c2 + 1) * 2 * x - $1b5c2c202f8c280d$var$c2) / 2 : ($1b5c2c202f8c280d$var$pow(2 * x - 2, 2) * (($1b5c2c202f8c280d$var$c2 + 1) * (x * 2 - 2) + $1b5c2c202f8c280d$var$c2) + 2) / 2;
}
function $1b5c2c202f8c280d$export$923f03c7f8e976ca(x) {
    return 1 - $1b5c2c202f8c280d$var$bounceOut(1 - x);
}
function $1b5c2c202f8c280d$export$1f36003cbba0aa13(x) {
    return $1b5c2c202f8c280d$var$bounceOut(x);
}
function $1b5c2c202f8c280d$export$150cd0e83065a867(x) {
    return x < 0.5 ? (1 - $1b5c2c202f8c280d$var$bounceOut(1 - 2 * x)) / 2 : (1 + $1b5c2c202f8c280d$var$bounceOut(2 * x - 1)) / 2;
}


/*!
    Feature Filter by

    (c) mapbox 2016 and maptalks 2018
    www.mapbox.com | www.maptalks.org
    License: MIT, header required.
*/ const $b541c4b531a4f326$var$types = [
    'Unknown',
    'Point',
    'LineString',
    'Polygon',
    'MultiPoint',
    'MultiLineString',
    'MultiPolygon',
    'GeometryCollection'
];
function $b541c4b531a4f326$var$isObject(obj) {
    return typeof obj === 'object' && !!obj;
}
function $b541c4b531a4f326$export$5d81789ff4aeccdf(filter) {
    return new Function('f', `var p = (f && f.properties || {}); return ${$b541c4b531a4f326$var$compile(filter)}`);
}
function $b541c4b531a4f326$export$baa7400d578a9bfd(filter) {
    if (filter === true || filter === false) return true;
    if (!Array.isArray(filter) || filter.length === 0) return false;
    switch(filter[0]){
        case 'has':
        case '!has':
            return filter.length === 2 && (typeof filter[1] === 'string' || filter[1].property && filter[1].op);
        case 'in':
        case '!in':
            return filter.length >= 2 && (typeof filter[1] === 'string' || filter[1].property && filter[1].op);
        case '==':
        case '!=':
        case '>':
        case '>=':
        case '<':
        case '<=':
            return filter.length === 3 && (typeof filter[1] === 'string' || filter[1].property && filter[1].op);
        case 'none':
        case 'any':
        case 'all':
            for (const f of filter.slice(1)){
                if (!$b541c4b531a4f326$export$baa7400d578a9bfd(f) && typeof f !== 'boolean') return false;
            }
            return true;
        case 'contains':
            return true;
        default:
            return false;
    }
}
function $b541c4b531a4f326$var$compile(filter) {
    if (!filter) return 'true';
    const op = filter[0];
    if (filter.length <= 1) return op === 'any' ? 'false' : 'true';
    const str = op === '==' ? $b541c4b531a4f326$var$compileComparisonOp(filter[1], filter[2], '===', false) : op === '!=' ? $b541c4b531a4f326$var$compileComparisonOp(filter[1], filter[2], '!==', false) : op === '<' || op === '>' || op === '<=' || op === '>=' ? $b541c4b531a4f326$var$compileComparisonOp(filter[1], filter[2], op, true) : op === 'any' ? $b541c4b531a4f326$var$compileLogicalOp(filter.slice(1), '||') : op === 'all' ? $b541c4b531a4f326$var$compileLogicalOp(filter.slice(1), '&&') : op === 'none' ? $b541c4b531a4f326$var$compileNegation($b541c4b531a4f326$var$compileLogicalOp(filter.slice(1), '||')) : op === 'in' ? $b541c4b531a4f326$var$compileInOp(filter[1], filter.slice(2)) : op === '!in' ? $b541c4b531a4f326$var$compileNegation($b541c4b531a4f326$var$compileInOp(filter[1], filter.slice(2))) : op === 'has' ? $b541c4b531a4f326$var$compileHasOp(filter[1]) : op === '!has' ? $b541c4b531a4f326$var$compileNegation($b541c4b531a4f326$var$compileHasOp(filter[1])) : // op === 'test' ? compileRegex(filter[1], filter[2]) :
    op === 'contains' ? $b541c4b531a4f326$var$compileContains(filter[1], filter[2], filter[3]) : 'true';
    return `(${str})`;
}
function $b541c4b531a4f326$var$compileFunction(propertyObj, value, op, checkType) {
    const property = propertyObj.property, funName = propertyObj.op;
    let left = $b541c4b531a4f326$var$compilePropertyReference(property);
    if (funName === 'length') left = `((${left}+='').length)`;
    else {
        // TODO
        //  other functions
        console.error(`not support ${funName} op`);
        return 'false';
    }
    return $b541c4b531a4f326$var$getComparisonCode(left, property, value, op, checkType);
}
function $b541c4b531a4f326$var$compileContains(property, str, index) {
    const prop = $b541c4b531a4f326$var$compilePropertyReference(property);
    if (index !== undefined) return `(${prop} + '').indexOf("${str}") === ${index}`;
    else return `(${prop} + '').indexOf("${str}") >= 0`;
}
// function compileRegex(property, regex) {
//     const prop = compilePropertyReference(property);
//     return `new RegExp("${regex}").test(${prop})`;
// }
function $b541c4b531a4f326$var$compilePropertyReference(property) {
    // const ref =
    //     property === '$type' ? 'f.type' :
    //         property === '$id' ? 'f.id' : `p[${JSON.stringify(property)}]`;
    // return ref;
    return property[0] === '$' ? 'f.' + property.substring(1) : 'p[' + JSON.stringify(property) + ']';
}
function $b541c4b531a4f326$var$compileComparisonOp(property, value, op, checkType) {
    if ($b541c4b531a4f326$var$isObject(property) && property.op) return $b541c4b531a4f326$var$compileFunction(property, value, op, checkType);
    const left = $b541c4b531a4f326$var$compilePropertyReference(property);
    return $b541c4b531a4f326$var$getComparisonCode(left, property, value, op, checkType);
}
function $b541c4b531a4f326$var$getComparisonCode(left, property, value, op, checkType) {
    const right = property === '$type' ? $b541c4b531a4f326$var$types.indexOf(value) : JSON.stringify(value);
    return (checkType ? `typeof ${left}=== typeof ${right}&&` : '') + left + op + right;
}
function $b541c4b531a4f326$var$compileLogicalOp(expressions, op) {
    return expressions.map($b541c4b531a4f326$var$compile).join(op);
}
function $b541c4b531a4f326$var$compileInOp(property, values) {
    if (property === '$type') values = values.map((value)=>{
        return $b541c4b531a4f326$var$types.indexOf(value);
    });
    const left = JSON.stringify(values.sort($b541c4b531a4f326$var$compare));
    const right = $b541c4b531a4f326$var$compilePropertyReference(property);
    if (values.length <= 200) return `${left}.indexOf(${right}) !== -1`;
    return `function(v, a, i, j) {
        while (i <= j) { var m = (i + j) >> 1;
            if (a[m] === v) return true; if (a[m] > v) j = m - 1; else i = m + 1;
        }
    return false; }(${right}, ${left},0,${values.length - 1})`;
}
function $b541c4b531a4f326$var$compileHasOp(property) {
    return property === '$id' ? '"id" in f' : `${JSON.stringify(property)} in p`;
}
function $b541c4b531a4f326$var$compileNegation(expression) {
    return `!(${expression})`;
}
// Comparison function to sort numbers and strings
function $b541c4b531a4f326$var$compare(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
}
function $b541c4b531a4f326$export$16beb34be993a35(geometry) {
    const json = geometry._toJSON(), g = json['feature'];
    g['type'] = $b541c4b531a4f326$var$types.indexOf(g['geometry']['type']);
    g['subType'] = json['subType'];
    return g;
}
function $b541c4b531a4f326$export$fe74925a79db722(styles) {
    if (!Array.isArray(styles)) return $b541c4b531a4f326$export$fe74925a79db722([
        styles
    ]);
    const compiled = [];
    for(let i = 0; i < styles.length; i++){
        let filter;
        if (styles[i]['filter'] === true) filter = function() {
            return true;
        };
        else filter = $b541c4b531a4f326$export$5d81789ff4aeccdf(styles[i]['filter']);
        compiled.push($b541c4b531a4f326$var$extend({}, styles[i], {
            filter: filter
        }));
    }
    return compiled;
}
function $b541c4b531a4f326$var$extend(dest) {
    for(let i = 1; i < arguments.length; i++){
        const src = arguments[i];
        for(const k in src)dest[k] = src[k];
    }
    return dest;
}


const $6d8c21c29b6ffa36$var$registedClazz = {};
function $6d8c21c29b6ffa36$var$VectorTilePlugin() {}
const $6d8c21c29b6ffa36$var$parentProto = $6d8c21c29b6ffa36$var$VectorTilePlugin.prototype;
$6d8c21c29b6ffa36$var$parentProto.getType = function() {
    return Object.getPrototypeOf(this).constructor.type;
};
$6d8c21c29b6ffa36$var$parentProto.isVisible = function() {
    throw new Error('to be implemented.');
};
$6d8c21c29b6ffa36$var$parentProto.prepareRender = function() {
    throw new Error('to be implemented.');
};
$6d8c21c29b6ffa36$var$parentProto.updateCollision = function() {
    throw new Error('to be implemented.');
};
$6d8c21c29b6ffa36$var$parentProto.supportRenderMode = function() {
    throw new Error('to be implemented.');
};
$6d8c21c29b6ffa36$var$parentProto.startFrame = function() {
    throw new Error('to be implemented.');
};
$6d8c21c29b6ffa36$var$parentProto.endFrame = function() {
    throw new Error('to be implemented.');
};
$6d8c21c29b6ffa36$var$parentProto.paintTile = function() {
    throw new Error('to be implemented.');
};
$6d8c21c29b6ffa36$var$parentProto.getShadowMeshes = function() {
    throw new Error('to be implemented.');
};
$6d8c21c29b6ffa36$var$parentProto.updateSceneConfig = function() {
    throw new Error('to be implemented.');
};
$6d8c21c29b6ffa36$var$parentProto.updateDataConfig = function() {
    throw new Error('to be implemented.');
};
$6d8c21c29b6ffa36$var$parentProto.updateSymbol = function() {
    throw new Error('to be implemented.');
};
$6d8c21c29b6ffa36$var$parentProto.pick = function() {
    throw new Error('to be implemented.');
};
$6d8c21c29b6ffa36$var$parentProto.resize = function() {
    throw new Error('to be implemented.');
};
$6d8c21c29b6ffa36$var$parentProto.deleteTile = function() {
    throw new Error('to be implemented.');
};
$6d8c21c29b6ffa36$var$parentProto.remove = function() {
    throw new Error('to be implemented.');
};
$6d8c21c29b6ffa36$var$parentProto.needToRedraw = function() {
    throw new Error('to be implemented.');
};
$6d8c21c29b6ffa36$var$parentProto.needToRetireFrames = function() {
    throw new Error('to be implemented.');
};
$6d8c21c29b6ffa36$var$parentProto.outline = function() {
    throw new Error('to be implemented.');
};
$6d8c21c29b6ffa36$var$parentProto.outlineAll = function() {
    throw new Error('to be implemented.');
};
$6d8c21c29b6ffa36$var$parentProto.needPolygonOffset = function() {
    throw new Error('to be implemented.');
};
$6d8c21c29b6ffa36$var$parentProto.constructor = $6d8c21c29b6ffa36$var$VectorTilePlugin;
const $6d8c21c29b6ffa36$var$hasOwn = Object.prototype.hasOwnProperty;
$6d8c21c29b6ffa36$var$VectorTilePlugin.extend = function(type, props) {
    /**
     * @type Class
     */ const clazz = function() {
        if (this.init) this.init();
    };
    const proto = Object.create($6d8c21c29b6ffa36$var$parentProto);
    proto.constructor = clazz;
    clazz.prototype = proto;
    clazz.type = type;
    for(const p in props)if ($6d8c21c29b6ffa36$var$hasOwn.call(props, p)) clazz.prototype[p] = props[p];
    clazz.registerAt = $6d8c21c29b6ffa36$var$registerAt.bind(clazz);
    $6d8c21c29b6ffa36$var$registedClazz[type] = clazz;
    return clazz;
};
function $6d8c21c29b6ffa36$var$registerAt(VectorTileLayer) {
    VectorTileLayer.registerPlugin(this);
}
var $6d8c21c29b6ffa36$export$2e2bcd8739ae039 = $6d8c21c29b6ffa36$var$VectorTilePlugin;



var $6BoVD = parcelRequire("6BoVD");
var $eIStk = parcelRequire("eIStk");
var $jxhwV = parcelRequire("jxhwV");
function $1b0c9f6ca9bef72e$export$2e2bcd8739ae039(data, holeIndices, dim = 2) {
    const hasHoles = holeIndices && holeIndices.length;
    const outerLen = hasHoles ? holeIndices[0] * dim : data.length;
    let outerNode = $1b0c9f6ca9bef72e$var$linkedList(data, 0, outerLen, dim, true);
    const triangles = [];
    if (!outerNode || outerNode.next === outerNode.prev) return triangles;
    let minX, minY, invSize;
    if (hasHoles) outerNode = $1b0c9f6ca9bef72e$var$eliminateHoles(data, holeIndices, outerNode, dim);
    // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
    if (data.length > 80 * dim) {
        minX = Infinity;
        minY = Infinity;
        let maxX = -Infinity;
        let maxY = -Infinity;
        for(let i = dim; i < outerLen; i += dim){
            const x = data[i];
            const y = data[i + 1];
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
        }
        // minX, minY and invSize are later used to transform coords into integers for z-order calculation
        invSize = Math.max(maxX - minX, maxY - minY);
        invSize = invSize !== 0 ? 32767 / invSize : 0;
    }
    $1b0c9f6ca9bef72e$var$earcutLinked(outerNode, triangles, dim, minX, minY, invSize, 0);
    return triangles;
}
// create a circular doubly linked list from polygon points in the specified winding order
function $1b0c9f6ca9bef72e$var$linkedList(data, start, end, dim, clockwise) {
    let last;
    if (clockwise === $1b0c9f6ca9bef72e$var$signedArea(data, start, end, dim) > 0) for(let i = start; i < end; i += dim)last = $1b0c9f6ca9bef72e$var$insertNode(i / dim | 0, data[i], data[i + 1], last);
    else for(let i = end - dim; i >= start; i -= dim)last = $1b0c9f6ca9bef72e$var$insertNode(i / dim | 0, data[i], data[i + 1], last);
    if (last && $1b0c9f6ca9bef72e$var$equals(last, last.next)) {
        $1b0c9f6ca9bef72e$var$removeNode(last);
        last = last.next;
    }
    return last;
}
// eliminate colinear or duplicate points
function $1b0c9f6ca9bef72e$var$filterPoints(start, end) {
    if (!start) return start;
    if (!end) end = start;
    let p = start, again;
    do {
        again = false;
        if (!p.steiner && ($1b0c9f6ca9bef72e$var$equals(p, p.next) || $1b0c9f6ca9bef72e$var$area(p.prev, p, p.next) === 0)) {
            $1b0c9f6ca9bef72e$var$removeNode(p);
            p = end = p.prev;
            if (p === p.next) break;
            again = true;
        } else p = p.next;
    }while (again || p !== end);
    return end;
}
// main ear slicing loop which triangulates a polygon (given as a linked list)
function $1b0c9f6ca9bef72e$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
    if (!ear) return;
    // interlink polygon nodes in z-order
    if (!pass && invSize) $1b0c9f6ca9bef72e$var$indexCurve(ear, minX, minY, invSize);
    let stop = ear;
    // iterate through ears, slicing them one by one
    while(ear.prev !== ear.next){
        const prev = ear.prev;
        const next = ear.next;
        if (invSize ? $1b0c9f6ca9bef72e$var$isEarHashed(ear, minX, minY, invSize) : $1b0c9f6ca9bef72e$var$isEar(ear)) {
            triangles.push(prev.i, ear.i, next.i); // cut off the triangle
            $1b0c9f6ca9bef72e$var$removeNode(ear);
            // skipping the next vertex leads to less sliver triangles
            ear = next.next;
            stop = next.next;
            continue;
        }
        ear = next;
        // if we looped through the whole remaining polygon and can't find any more ears
        if (ear === stop) {
            // try filtering points and slicing again
            if (!pass) $1b0c9f6ca9bef72e$var$earcutLinked($1b0c9f6ca9bef72e$var$filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
            else if (pass === 1) {
                ear = $1b0c9f6ca9bef72e$var$cureLocalIntersections($1b0c9f6ca9bef72e$var$filterPoints(ear), triangles);
                $1b0c9f6ca9bef72e$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
            // as a last resort, try splitting the remaining polygon into two
            } else if (pass === 2) $1b0c9f6ca9bef72e$var$splitEarcut(ear, triangles, dim, minX, minY, invSize);
            break;
        }
    }
}
// check whether a polygon node forms a valid ear with adjacent nodes
function $1b0c9f6ca9bef72e$var$isEar(ear) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($1b0c9f6ca9bef72e$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    // now make sure we don't have other points inside the potential ear
    const ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox
    const x0 = Math.min(ax, bx, cx), y0 = Math.min(ay, by, cy), x1 = Math.max(ax, bx, cx), y1 = Math.max(ay, by, cy);
    let p = c.next;
    while(p !== a){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && $1b0c9f6ca9bef72e$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, p.x, p.y) && $1b0c9f6ca9bef72e$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.next;
    }
    return true;
}
function $1b0c9f6ca9bef72e$var$isEarHashed(ear, minX, minY, invSize) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($1b0c9f6ca9bef72e$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    const ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox
    const x0 = Math.min(ax, bx, cx), y0 = Math.min(ay, by, cy), x1 = Math.max(ax, bx, cx), y1 = Math.max(ay, by, cy);
    // z-order range for the current triangle bbox;
    const minZ = $1b0c9f6ca9bef72e$var$zOrder(x0, y0, minX, minY, invSize), maxZ = $1b0c9f6ca9bef72e$var$zOrder(x1, y1, minX, minY, invSize);
    let p = ear.prevZ, n = ear.nextZ;
    // look for points inside the triangle in both directions
    while(p && p.z >= minZ && n && n.z <= maxZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $1b0c9f6ca9bef72e$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, p.x, p.y) && $1b0c9f6ca9bef72e$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $1b0c9f6ca9bef72e$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, n.x, n.y) && $1b0c9f6ca9bef72e$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    // look for remaining points in decreasing z-order
    while(p && p.z >= minZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $1b0c9f6ca9bef72e$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, p.x, p.y) && $1b0c9f6ca9bef72e$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
    }
    // look for remaining points in increasing z-order
    while(n && n.z <= maxZ){
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $1b0c9f6ca9bef72e$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, n.x, n.y) && $1b0c9f6ca9bef72e$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    return true;
}
// go through all polygon nodes and cure small local self-intersections
function $1b0c9f6ca9bef72e$var$cureLocalIntersections(start, triangles) {
    let p = start;
    do {
        const a = p.prev, b = p.next.next;
        if (!$1b0c9f6ca9bef72e$var$equals(a, b) && $1b0c9f6ca9bef72e$var$intersects(a, p, p.next, b) && $1b0c9f6ca9bef72e$var$locallyInside(a, b) && $1b0c9f6ca9bef72e$var$locallyInside(b, a)) {
            triangles.push(a.i, p.i, b.i);
            // remove two nodes involved
            $1b0c9f6ca9bef72e$var$removeNode(p);
            $1b0c9f6ca9bef72e$var$removeNode(p.next);
            p = start = b;
        }
        p = p.next;
    }while (p !== start);
    return $1b0c9f6ca9bef72e$var$filterPoints(p);
}
// try splitting polygon into two and triangulate them independently
function $1b0c9f6ca9bef72e$var$splitEarcut(start, triangles, dim, minX, minY, invSize) {
    // look for a valid diagonal that divides the polygon into two
    let a = start;
    do {
        let b = a.next.next;
        while(b !== a.prev){
            if (a.i !== b.i && $1b0c9f6ca9bef72e$var$isValidDiagonal(a, b)) {
                // split the polygon in two by the diagonal
                let c = $1b0c9f6ca9bef72e$var$splitPolygon(a, b);
                // filter colinear points around the cuts
                a = $1b0c9f6ca9bef72e$var$filterPoints(a, a.next);
                c = $1b0c9f6ca9bef72e$var$filterPoints(c, c.next);
                // run earcut on each half
                $1b0c9f6ca9bef72e$var$earcutLinked(a, triangles, dim, minX, minY, invSize, 0);
                $1b0c9f6ca9bef72e$var$earcutLinked(c, triangles, dim, minX, minY, invSize, 0);
                return;
            }
            b = b.next;
        }
        a = a.next;
    }while (a !== start);
}
// link every hole into the outer loop, producing a single-ring polygon without holes
function $1b0c9f6ca9bef72e$var$eliminateHoles(data, holeIndices, outerNode, dim) {
    const queue = [];
    for(let i = 0, len = holeIndices.length; i < len; i++){
        const start = holeIndices[i] * dim;
        const end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        const list = $1b0c9f6ca9bef72e$var$linkedList(data, start, end, dim, false);
        if (list === list.next) list.steiner = true;
        queue.push($1b0c9f6ca9bef72e$var$getLeftmost(list));
    }
    queue.sort($1b0c9f6ca9bef72e$var$compareXYSlope);
    // process holes from left to right
    for(let i = 0; i < queue.length; i++)outerNode = $1b0c9f6ca9bef72e$var$eliminateHole(queue[i], outerNode);
    return outerNode;
}
function $1b0c9f6ca9bef72e$var$compareXYSlope(a, b) {
    let result = a.x - b.x;
    // when the left-most point of 2 holes meet at a vertex, sort the holes counterclockwise so that when we find
    // the bridge to the outer shell is always the point that they meet at.
    if (result === 0) {
        result = a.y - b.y;
        if (result === 0) {
            const aSlope = (a.next.y - a.y) / (a.next.x - a.x);
            const bSlope = (b.next.y - b.y) / (b.next.x - b.x);
            result = aSlope - bSlope;
        }
    }
    return result;
}
// find a bridge between vertices that connects hole with an outer ring and and link it
function $1b0c9f6ca9bef72e$var$eliminateHole(hole, outerNode) {
    const bridge = $1b0c9f6ca9bef72e$var$findHoleBridge(hole, outerNode);
    if (!bridge) return outerNode;
    const bridgeReverse = $1b0c9f6ca9bef72e$var$splitPolygon(bridge, hole);
    // filter collinear points around the cuts
    $1b0c9f6ca9bef72e$var$filterPoints(bridgeReverse, bridgeReverse.next);
    return $1b0c9f6ca9bef72e$var$filterPoints(bridge, bridge.next);
}
// David Eberly's algorithm for finding a bridge between hole and outer polygon
function $1b0c9f6ca9bef72e$var$findHoleBridge(hole, outerNode) {
    let p = outerNode;
    const hx = hole.x;
    const hy = hole.y;
    let qx = -Infinity;
    let m;
    // find a segment intersected by a ray from the hole's leftmost point to the left;
    // segment's endpoint with lesser x will be potential connection point
    // unless they intersect at a vertex, then choose the vertex
    if ($1b0c9f6ca9bef72e$var$equals(hole, p)) return p;
    do {
        if ($1b0c9f6ca9bef72e$var$equals(hole, p.next)) return p.next;
        else if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
            const x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
            if (x <= hx && x > qx) {
                qx = x;
                m = p.x < p.next.x ? p : p.next;
                if (x === hx) return m; // hole touches outer segment; pick leftmost endpoint
            }
        }
        p = p.next;
    }while (p !== outerNode);
    if (!m) return null;
    // look for points inside the triangle of hole point, segment intersection and endpoint;
    // if there are no points found, we have a valid connection;
    // otherwise choose the point of the minimum angle with the ray as connection point
    const stop = m;
    const mx = m.x;
    const my = m.y;
    let tanMin = Infinity;
    p = m;
    do {
        if (hx >= p.x && p.x >= mx && hx !== p.x && $1b0c9f6ca9bef72e$var$pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
            const tan = Math.abs(hy - p.y) / (hx - p.x); // tangential
            if ($1b0c9f6ca9bef72e$var$locallyInside(p, hole) && (tan < tanMin || tan === tanMin && (p.x > m.x || p.x === m.x && $1b0c9f6ca9bef72e$var$sectorContainsSector(m, p)))) {
                m = p;
                tanMin = tan;
            }
        }
        p = p.next;
    }while (p !== stop);
    return m;
}
// whether sector in vertex m contains sector in vertex p in the same coordinates
function $1b0c9f6ca9bef72e$var$sectorContainsSector(m, p) {
    return $1b0c9f6ca9bef72e$var$area(m.prev, m, p.prev) < 0 && $1b0c9f6ca9bef72e$var$area(p.next, m, m.next) < 0;
}
// interlink polygon nodes in z-order
function $1b0c9f6ca9bef72e$var$indexCurve(start, minX, minY, invSize) {
    let p = start;
    do {
        if (p.z === 0) p.z = $1b0c9f6ca9bef72e$var$zOrder(p.x, p.y, minX, minY, invSize);
        p.prevZ = p.prev;
        p.nextZ = p.next;
        p = p.next;
    }while (p !== start);
    p.prevZ.nextZ = null;
    p.prevZ = null;
    $1b0c9f6ca9bef72e$var$sortLinked(p);
}
// Simon Tatham's linked list merge sort algorithm
// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
function $1b0c9f6ca9bef72e$var$sortLinked(list) {
    let numMerges;
    let inSize = 1;
    do {
        let p = list;
        let e;
        list = null;
        let tail = null;
        numMerges = 0;
        while(p){
            numMerges++;
            let q = p;
            let pSize = 0;
            for(let i = 0; i < inSize; i++){
                pSize++;
                q = q.nextZ;
                if (!q) break;
            }
            let qSize = inSize;
            while(pSize > 0 || qSize > 0 && q){
                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                    e = p;
                    p = p.nextZ;
                    pSize--;
                } else {
                    e = q;
                    q = q.nextZ;
                    qSize--;
                }
                if (tail) tail.nextZ = e;
                else list = e;
                e.prevZ = tail;
                tail = e;
            }
            p = q;
        }
        tail.nextZ = null;
        inSize *= 2;
    }while (numMerges > 1);
    return list;
}
// z-order of a point given coords and inverse of the longer side of data bbox
function $1b0c9f6ca9bef72e$var$zOrder(x, y, minX, minY, invSize) {
    // coords are transformed into non-negative 15-bit integer range
    x = (x - minX) * invSize | 0;
    y = (y - minY) * invSize | 0;
    x = (x | x << 8) & 0x00FF00FF;
    x = (x | x << 4) & 0x0F0F0F0F;
    x = (x | x << 2) & 0x33333333;
    x = (x | x << 1) & 0x55555555;
    y = (y | y << 8) & 0x00FF00FF;
    y = (y | y << 4) & 0x0F0F0F0F;
    y = (y | y << 2) & 0x33333333;
    y = (y | y << 1) & 0x55555555;
    return x | y << 1;
}
// find the leftmost node of a polygon ring
function $1b0c9f6ca9bef72e$var$getLeftmost(start) {
    let p = start, leftmost = start;
    do {
        if (p.x < leftmost.x || p.x === leftmost.x && p.y < leftmost.y) leftmost = p;
        p = p.next;
    }while (p !== start);
    return leftmost;
}
// check if a point lies within a convex triangle
function $1b0c9f6ca9bef72e$var$pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
    return (cx - px) * (ay - py) >= (ax - px) * (cy - py) && (ax - px) * (by - py) >= (bx - px) * (ay - py) && (bx - px) * (cy - py) >= (cx - px) * (by - py);
}
// check if a point lies within a convex triangle but false if its equal to the first point of the triangle
function $1b0c9f6ca9bef72e$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, px, py) {
    return !(ax === px && ay === py) && $1b0c9f6ca9bef72e$var$pointInTriangle(ax, ay, bx, by, cx, cy, px, py);
}
// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
function $1b0c9f6ca9bef72e$var$isValidDiagonal(a, b) {
    return a.next.i !== b.i && a.prev.i !== b.i && !$1b0c9f6ca9bef72e$var$intersectsPolygon(a, b) && // dones't intersect other edges
    ($1b0c9f6ca9bef72e$var$locallyInside(a, b) && $1b0c9f6ca9bef72e$var$locallyInside(b, a) && $1b0c9f6ca9bef72e$var$middleInside(a, b) && // locally visible
    ($1b0c9f6ca9bef72e$var$area(a.prev, a, b.prev) || $1b0c9f6ca9bef72e$var$area(a, b.prev, b)) || // does not create opposite-facing sectors
    $1b0c9f6ca9bef72e$var$equals(a, b) && $1b0c9f6ca9bef72e$var$area(a.prev, a, a.next) > 0 && $1b0c9f6ca9bef72e$var$area(b.prev, b, b.next) > 0); // special zero-length case
}
// signed area of a triangle
function $1b0c9f6ca9bef72e$var$area(p, q, r) {
    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
}
// check if two points are equal
function $1b0c9f6ca9bef72e$var$equals(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
}
// check if two segments intersect
function $1b0c9f6ca9bef72e$var$intersects(p1, q1, p2, q2) {
    const o1 = $1b0c9f6ca9bef72e$var$sign($1b0c9f6ca9bef72e$var$area(p1, q1, p2));
    const o2 = $1b0c9f6ca9bef72e$var$sign($1b0c9f6ca9bef72e$var$area(p1, q1, q2));
    const o3 = $1b0c9f6ca9bef72e$var$sign($1b0c9f6ca9bef72e$var$area(p2, q2, p1));
    const o4 = $1b0c9f6ca9bef72e$var$sign($1b0c9f6ca9bef72e$var$area(p2, q2, q1));
    if (o1 !== o2 && o3 !== o4) return true; // general case
    if (o1 === 0 && $1b0c9f6ca9bef72e$var$onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
    if (o2 === 0 && $1b0c9f6ca9bef72e$var$onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
    if (o3 === 0 && $1b0c9f6ca9bef72e$var$onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
    if (o4 === 0 && $1b0c9f6ca9bef72e$var$onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2
    return false;
}
// for collinear points p, q, r, check if point q lies on segment pr
function $1b0c9f6ca9bef72e$var$onSegment(p, q, r) {
    return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
}
function $1b0c9f6ca9bef72e$var$sign(num) {
    return num > 0 ? 1 : num < 0 ? -1 : 0;
}
// check if a polygon diagonal intersects any polygon segments
function $1b0c9f6ca9bef72e$var$intersectsPolygon(a, b) {
    let p = a;
    do {
        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i && $1b0c9f6ca9bef72e$var$intersects(p, p.next, a, b)) return true;
        p = p.next;
    }while (p !== a);
    return false;
}
// check if a polygon diagonal is locally inside the polygon
function $1b0c9f6ca9bef72e$var$locallyInside(a, b) {
    return $1b0c9f6ca9bef72e$var$area(a.prev, a, a.next) < 0 ? $1b0c9f6ca9bef72e$var$area(a, b, a.next) >= 0 && $1b0c9f6ca9bef72e$var$area(a, a.prev, b) >= 0 : $1b0c9f6ca9bef72e$var$area(a, b, a.prev) < 0 || $1b0c9f6ca9bef72e$var$area(a, a.next, b) < 0;
}
// check if the middle point of a polygon diagonal is inside the polygon
function $1b0c9f6ca9bef72e$var$middleInside(a, b) {
    let p = a;
    let inside = false;
    const px = (a.x + b.x) / 2;
    const py = (a.y + b.y) / 2;
    do {
        if (p.y > py !== p.next.y > py && p.next.y !== p.y && px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x) inside = !inside;
        p = p.next;
    }while (p !== a);
    return inside;
}
// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
// if one belongs to the outer ring and another to a hole, it merges it into a single ring
function $1b0c9f6ca9bef72e$var$splitPolygon(a, b) {
    const a2 = $1b0c9f6ca9bef72e$var$createNode(a.i, a.x, a.y), b2 = $1b0c9f6ca9bef72e$var$createNode(b.i, b.x, b.y), an = a.next, bp = b.prev;
    a.next = b;
    b.prev = a;
    a2.next = an;
    an.prev = a2;
    b2.next = a2;
    a2.prev = b2;
    bp.next = b2;
    b2.prev = bp;
    return b2;
}
// create a node and optionally link it with previous one (in a circular doubly linked list)
function $1b0c9f6ca9bef72e$var$insertNode(i, x, y, last) {
    const p = $1b0c9f6ca9bef72e$var$createNode(i, x, y);
    if (!last) {
        p.prev = p;
        p.next = p;
    } else {
        p.next = last.next;
        p.prev = last;
        last.next.prev = p;
        last.next = p;
    }
    return p;
}
function $1b0c9f6ca9bef72e$var$removeNode(p) {
    p.next.prev = p.prev;
    p.prev.next = p.next;
    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
}
function $1b0c9f6ca9bef72e$var$createNode(i, x, y) {
    return {
        i: i,
        x: x,
        y: y,
        prev: null,
        next: null,
        z: 0,
        prevZ: null,
        nextZ: null,
        steiner: false // indicates whether this is a steiner point
    };
}
function $1b0c9f6ca9bef72e$export$e8fd98ab2e1cd1ee(data, holeIndices, dim, triangles) {
    const hasHoles = holeIndices && holeIndices.length;
    const outerLen = hasHoles ? holeIndices[0] * dim : data.length;
    let polygonArea = Math.abs($1b0c9f6ca9bef72e$var$signedArea(data, 0, outerLen, dim));
    if (hasHoles) for(let i = 0, len = holeIndices.length; i < len; i++){
        const start = holeIndices[i] * dim;
        const end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        polygonArea -= Math.abs($1b0c9f6ca9bef72e$var$signedArea(data, start, end, dim));
    }
    let trianglesArea = 0;
    for(let i = 0; i < triangles.length; i += 3){
        const a = triangles[i] * dim;
        const b = triangles[i + 1] * dim;
        const c = triangles[i + 2] * dim;
        trianglesArea += Math.abs((data[a] - data[c]) * (data[b + 1] - data[a + 1]) - (data[a] - data[b]) * (data[c + 1] - data[a + 1]));
    }
    return polygonArea === 0 && trianglesArea === 0 ? 0 : Math.abs((trianglesArea - polygonArea) / polygonArea);
}
function $1b0c9f6ca9bef72e$var$signedArea(data, start, end, dim) {
    let sum = 0;
    for(let i = start, j = end - dim; i < end; i += dim){
        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
        j = i;
    }
    return sum;
}
function $1b0c9f6ca9bef72e$export$bffa455ba8c619a6(data) {
    const vertices = [];
    const holes = [];
    const dimensions = data[0][0].length;
    let holeIndex = 0;
    let prevLen = 0;
    for (const ring of data){
        for (const p of ring)for(let d = 0; d < dimensions; d++)vertices.push(p[d]);
        if (prevLen) {
            holeIndex += prevLen;
            holes.push(holeIndex);
        }
        prevLen = ring.length;
    }
    return {
        vertices: vertices,
        holes: holes,
        dimensions: dimensions
    };
}



var $1YyR8 = parcelRequire("1YyR8");
var $176ca75ee9f69668$exports = {};
!function(t, i) {
    $176ca75ee9f69668$exports = i();
}($176ca75ee9f69668$exports, function() {
    "use strict";
    function t(t, r, e, a, h) {
        !function t(n, r, e, a, h) {
            for(; a > e;){
                if (a - e > 600) {
                    var o = a - e + 1, s = r - e + 1, l = Math.log(o), f = .5 * Math.exp(2 * l / 3), u = .5 * Math.sqrt(l * f * (o - f) / o) * (s - o / 2 < 0 ? -1 : 1), m = Math.max(e, Math.floor(r - s * f / o + u)), c = Math.min(a, Math.floor(r + (o - s) * f / o + u));
                    t(n, r, m, c, h);
                }
                var p = n[r], d = e, x = a;
                for(i(n, e, r), h(n[a], p) > 0 && i(n, e, a); d < x;){
                    for(i(n, d, x), d++, x--; h(n[d], p) < 0;)d++;
                    for(; h(n[x], p) > 0;)x--;
                }
                0 === h(n[e], p) ? i(n, e, x) : i(n, ++x, a), x <= r && (e = x + 1), r <= x && (a = x - 1);
            }
        }(t, r, e || 0, a || t.length - 1, h || n);
    }
    function i(t, i, n) {
        var r = t[i];
        t[i] = t[n], t[n] = r;
    }
    function n(t, i) {
        return t < i ? -1 : t > i ? 1 : 0;
    }
    var r = function(t) {
        void 0 === t && (t = 9), this._maxEntries = Math.max(4, t), this._minEntries = Math.max(2, Math.ceil(.4 * this._maxEntries)), this.clear();
    };
    function e(t, i, n) {
        if (!n) return i.indexOf(t);
        for(var r = 0; r < i.length; r++)if (n(t, i[r])) return r;
        return -1;
    }
    function a(t, i) {
        h(t, 0, t.children.length, i, t);
    }
    function h(t, i, n, r, e) {
        e || (e = p(null)), e.minX = 1 / 0, e.minY = 1 / 0, e.maxX = -1 / 0, e.maxY = -1 / 0;
        for(var a = i; a < n; a++){
            var h = t.children[a];
            o(e, t.leaf ? r(h) : h);
        }
        return e;
    }
    function o(t, i) {
        return t.minX = Math.min(t.minX, i.minX), t.minY = Math.min(t.minY, i.minY), t.maxX = Math.max(t.maxX, i.maxX), t.maxY = Math.max(t.maxY, i.maxY), t;
    }
    function s(t, i) {
        return t.minX - i.minX;
    }
    function l(t, i) {
        return t.minY - i.minY;
    }
    function f(t) {
        return (t.maxX - t.minX) * (t.maxY - t.minY);
    }
    function u(t) {
        return t.maxX - t.minX + (t.maxY - t.minY);
    }
    function m(t, i) {
        return t.minX <= i.minX && t.minY <= i.minY && i.maxX <= t.maxX && i.maxY <= t.maxY;
    }
    function c(t, i) {
        return i.minX <= t.maxX && i.minY <= t.maxY && i.maxX >= t.minX && i.maxY >= t.minY;
    }
    function p(t) {
        return {
            children: t,
            height: 1,
            leaf: !0,
            minX: 1 / 0,
            minY: 1 / 0,
            maxX: -1 / 0,
            maxY: -1 / 0
        };
    }
    function d(i, n, r, e, a) {
        for(var h = [
            n,
            r
        ]; h.length;)if (!((r = h.pop()) - (n = h.pop()) <= e)) {
            var o = n + Math.ceil((r - n) / e / 2) * e;
            t(i, o, n, r, a), h.push(n, o, o, r);
        }
    }
    return r.prototype.all = function() {
        return this._all(this.data, []);
    }, r.prototype.search = function(t) {
        var i = this.data, n = [];
        if (!c(t, i)) return n;
        for(var r = this.toBBox, e = []; i;){
            for(var a = 0; a < i.children.length; a++){
                var h = i.children[a], o = i.leaf ? r(h) : h;
                c(t, o) && (i.leaf ? n.push(h) : m(t, o) ? this._all(h, n) : e.push(h));
            }
            i = e.pop();
        }
        return n;
    }, r.prototype.collides = function(t) {
        var i = this.data;
        if (!c(t, i)) return !1;
        for(var n = []; i;){
            for(var r = 0; r < i.children.length; r++){
                var e = i.children[r], a = i.leaf ? this.toBBox(e) : e;
                if (c(t, a)) {
                    if (i.leaf || m(t, a)) return !0;
                    n.push(e);
                }
            }
            i = n.pop();
        }
        return !1;
    }, r.prototype.load = function(t) {
        if (!t || !t.length) return this;
        if (t.length < this._minEntries) {
            for(var i = 0; i < t.length; i++)this.insert(t[i]);
            return this;
        }
        var n = this._build(t.slice(), 0, t.length - 1, 0);
        if (this.data.children.length) {
            if (this.data.height === n.height) this._splitRoot(this.data, n);
            else {
                if (this.data.height < n.height) {
                    var r = this.data;
                    this.data = n, n = r;
                }
                this._insert(n, this.data.height - n.height - 1, !0);
            }
        } else this.data = n;
        return this;
    }, r.prototype.insert = function(t) {
        return t && this._insert(t, this.data.height - 1), this;
    }, r.prototype.clear = function() {
        return this.data = p([]), this;
    }, r.prototype.remove = function(t, i) {
        if (!t) return this;
        for(var n, r, a, h = this.data, o = this.toBBox(t), s = [], l = []; h || s.length;){
            if (h || (h = s.pop(), r = s[s.length - 1], n = l.pop(), a = !0), h.leaf) {
                var f = e(t, h.children, i);
                if (-1 !== f) return h.children.splice(f, 1), s.push(h), this._condense(s), this;
            }
            a || h.leaf || !m(h, o) ? r ? (n++, h = r.children[n], a = !1) : h = null : (s.push(h), l.push(n), n = 0, r = h, h = h.children[0]);
        }
        return this;
    }, r.prototype.toBBox = function(t) {
        return t;
    }, r.prototype.compareMinX = function(t, i) {
        return t.minX - i.minX;
    }, r.prototype.compareMinY = function(t, i) {
        return t.minY - i.minY;
    }, r.prototype.toJSON = function() {
        return this.data;
    }, r.prototype.fromJSON = function(t) {
        return this.data = t, this;
    }, r.prototype._all = function(t, i) {
        for(var n = []; t;)t.leaf ? i.push.apply(i, t.children) : n.push.apply(n, t.children), t = n.pop();
        return i;
    }, r.prototype._build = function(t, i, n, r) {
        var e, h = n - i + 1, o = this._maxEntries;
        if (h <= o) return a(e = p(t.slice(i, n + 1)), this.toBBox), e;
        r || (r = Math.ceil(Math.log(h) / Math.log(o)), o = Math.ceil(h / Math.pow(o, r - 1))), (e = p([])).leaf = !1, e.height = r;
        var s = Math.ceil(h / o), l = s * Math.ceil(Math.sqrt(o));
        d(t, i, n, l, this.compareMinX);
        for(var f = i; f <= n; f += l){
            var u = Math.min(f + l - 1, n);
            d(t, f, u, s, this.compareMinY);
            for(var m = f; m <= u; m += s){
                var c = Math.min(m + s - 1, u);
                e.children.push(this._build(t, m, c, r - 1));
            }
        }
        return a(e, this.toBBox), e;
    }, r.prototype._chooseSubtree = function(t, i, n, r) {
        for(; r.push(i), !i.leaf && r.length - 1 !== n;){
            for(var e = 1 / 0, a = 1 / 0, h = void 0, o = 0; o < i.children.length; o++){
                var s = i.children[o], l = f(s), u = (m = t, c = s, (Math.max(c.maxX, m.maxX) - Math.min(c.minX, m.minX)) * (Math.max(c.maxY, m.maxY) - Math.min(c.minY, m.minY)) - l);
                u < a ? (a = u, e = l < e ? l : e, h = s) : u === a && l < e && (e = l, h = s);
            }
            i = h || i.children[0];
        }
        var m, c;
        return i;
    }, r.prototype._insert = function(t, i, n) {
        var r = n ? t : this.toBBox(t), e = [], a = this._chooseSubtree(r, this.data, i, e);
        for(a.children.push(t), o(a, r); i >= 0 && e[i].children.length > this._maxEntries;)this._split(e, i), i--;
        this._adjustParentBBoxes(r, e, i);
    }, r.prototype._split = function(t, i) {
        var n = t[i], r = n.children.length, e = this._minEntries;
        this._chooseSplitAxis(n, e, r);
        var h = this._chooseSplitIndex(n, e, r), o = p(n.children.splice(h, n.children.length - h));
        o.height = n.height, o.leaf = n.leaf, a(n, this.toBBox), a(o, this.toBBox), i ? t[i - 1].children.push(o) : this._splitRoot(n, o);
    }, r.prototype._splitRoot = function(t, i) {
        this.data = p([
            t,
            i
        ]), this.data.height = t.height + 1, this.data.leaf = !1, a(this.data, this.toBBox);
    }, r.prototype._chooseSplitIndex = function(t, i, n) {
        for(var r, e, a, o, s, l, u, m = 1 / 0, c = 1 / 0, p = i; p <= n - i; p++){
            var d = h(t, 0, p, this.toBBox), x = h(t, p, n, this.toBBox), v = (e = d, a = x, o = void 0, s = void 0, l = void 0, u = void 0, o = Math.max(e.minX, a.minX), s = Math.max(e.minY, a.minY), l = Math.min(e.maxX, a.maxX), u = Math.min(e.maxY, a.maxY), Math.max(0, l - o) * Math.max(0, u - s)), M = f(d) + f(x);
            v < m ? (m = v, r = p, c = M < c ? M : c) : v === m && M < c && (c = M, r = p);
        }
        return r || n - i;
    }, r.prototype._chooseSplitAxis = function(t, i, n) {
        var r = t.leaf ? this.compareMinX : s, e = t.leaf ? this.compareMinY : l;
        this._allDistMargin(t, i, n, r) < this._allDistMargin(t, i, n, e) && t.children.sort(r);
    }, r.prototype._allDistMargin = function(t, i, n, r) {
        t.children.sort(r);
        for(var e = this.toBBox, a = h(t, 0, i, e), s = h(t, n - i, n, e), l = u(a) + u(s), f = i; f < n - i; f++){
            var m = t.children[f];
            o(a, t.leaf ? e(m) : m), l += u(a);
        }
        for(var c = n - i - 1; c >= i; c--){
            var p = t.children[c];
            o(s, t.leaf ? e(p) : p), l += u(s);
        }
        return l;
    }, r.prototype._adjustParentBBoxes = function(t, i, n) {
        for(var r = n; r >= 0; r--)o(i[r], t);
    }, r.prototype._condense = function(t) {
        for(var i = t.length - 1, n = void 0; i >= 0; i--)0 === t[i].children.length ? i > 0 ? (n = t[i - 1].children).splice(n.indexOf(t[i]), 1) : this.clear() : a(t[i], this.toBBox);
    }, r;
});


const $435bc7696844e930$var$E = "${", $435bc7696844e930$var$D = `function(t){let e;const n={width:100,height:10};let r=!1;try{const t=new OffscreenCanvas(1,1);t.getContext("2d").fillText("hello",0,0),r=!0}catch(t){r=!1}function i(){if(!e){const{width:t,height:i}=n;r?e=new OffscreenCanvas(t,i):(e=document.createElement("canvas"),e.width=t,e.height=i)}return e}class o{constructor(t,e={}){if(!Array.isArray(t))return void console.error("colors is not array");if(t.length<2)return void console.error("colors.length should >1");this.colors=t;let r=1/0,i=-1/0;for(let e=0,n=t.length;e<n;e++){const n=t[e][0];r=Math.min(n,r),i=Math.max(n,i)}this.min=r,this.max=i,this.valueOffset=this.max-this.min,this.options=Object.assign({},n,e),this._initImgData()}getImageData(){return this.imgData}_initImgData(){const t=i(),{width:e,height:n}=this.options;t.width=e,t.height=n;const r=t.getContext("2d");r.clearRect(0,0,t.width,t.height);const o=r.createLinearGradient(0,0,t.width,0),{colors:s,valueOffset:a}=this;for(let t=0,e=s.length;t<e;t++){const[e,n]=s[t],r=(e-this.min)/a;o.addColorStop(r,n)}r.fillStyle=o,r.fillRect(0,0,t.width,t.height),this.imgData=r.getImageData(0,0,t.width,t.height)}getColor(t){t=Math.max(this.min,t);const e=((t=Math.min(t,this.max))-this.min)/this.valueOffset;let n=Math.round(e*this.imgData.width);n=Math.min(n,this.imgData.width-1);const r=4*n;return[this.imgData.data[r],this.imgData.data[r+1],this.imgData.data[r+2],this.imgData.data[r+3]]}}var s;function a(t){return null==t}function l(t){return!a(t)}function u(t){return""===t}function h(t,e){var n,r,i;if(w(t)){var o,s=t.stops&&"object"==typeof t.stops[0][0],a=s||l(t.property),u=s||!a,d=t.type||e||"exponential";if("exponential"===d)o=p;else if("interval"===d)o=f;else if("categorical"===d)o=c;else if("identity"===d)o=y;else if("color-interpolate"===d)o=g;else{if("calculate-expression"!==d)throw new Error('Unknown function type "'+d+'"');o=x}if(s){var m={},v=[];for(let e=0;e<t.stops.length;e++){var M=t.stops[e];void 0===m[M[0].zoom]&&(m[M[0].zoom]={zoom:M[0].zoom,type:t.type,property:t.property,default:t.default,stops:[]}),m[M[0].zoom].stops.push([M[0].value,M[1]])}for(let t in m)v.push([m[t].zoom,h(m[t])]);n=function(e,n){const r=p({stops:v,base:t.base},e)(e,n);return"function"==typeof r?r(e,n):r},r=!1,i=!1}else u?(n=function(e){const n=o(t,e);return"function"==typeof n?n(e):n},r=!0,i=!1):(n=function(e,n){const r=o(t,n?n[t.property]:null);return"function"==typeof r?r(e,n):r},r=!1,i=!0)}else n=function(){return t},r=!0,i=!0;return n.isZoomConstant=i,n.isFeatureConstant=r,n}function c(t,e){for(let n=0;n<t.stops.length;n++)if(e===t.stops[n][0])return t.stops[n][1];return t.default}function f(t,e){for(var n=0;n<t.stops.length&&!(e<t.stops[n][0]);n++);return t.stops[Math.max(n-1,0)][1]}function p(t,e){for(var n=l(t.base)&&!u(t.base)?t.base:1,r=0;!(r>=t.stops.length||e<=t.stops[r][0]);)r++;return 0===r?t.stops[r][1]:r===t.stops.length?t.stops[r-1][1]:m(e,n,t.stops[r-1][0],t.stops[r][0],t.stops[r-1][1],t.stops[r][1])}"function"==typeof Map&&(s=new Map);const d={width:100,height:1};function g(t,e){const n=t.stops;if(n&&n.length>1){let t;if(s){const e=JSON.stringify(n);if(!s.has(e)){const t=new o(n,d);s.set(e,t)}t=s.get(e)}else t=new o(n,d);const[r,i,a,l]=t.getColor(e);return[r/255,i/255,a/255,l/255]}return n&&1===n.length?n[0][1]:null}function y(t,e){return n=e,r=t.default,l(n)?n:l(r)?r:l(i)?i:null;var n,r,i}function x(t,e){const n=String(t.property),r=t.expression,i=e;function o(e){return a(e)||u(e)||isNaN(e)?t.default:e}if(!l(e)||u(e)||isNaN(e)||e<0)return o(t.default);{const e=function t(e,n,r){const i=Number(r),o=String(n);return Array.isArray(e)?e.map((e=>t(e,o,i))):e===o?i:e}(r,n,i);return o(function e(n){if(!Array.isArray(n)){if("number"==typeof n)return n;throw new Error("Invalid expression format")}{const r=n[0];if(!["+","-","*","/"].includes(r))throw new Error(\`Unknown operator: ${$435bc7696844e930$var$E}r}\`);const i=n.slice(1).map((t=>e(t)));switch(r){case"+":return i.reduce(((t,e)=>t+e),0);case"-":return i.reduce(((t,e)=>t-e));case"*":return i.reduce(((t,e)=>t*e),1);case"/":return i.some((t=>0===t))?t.default:i.reduce(((t,e)=>t/e));default:throw new Error(\`Unsupported operator: ${$435bc7696844e930$var$E}r}\`)}}}(e))}}function m(t,e,n,r,i,o){return"function"==typeof i?function(){var s=i.apply(void 0,arguments),a=o.apply(void 0,arguments);return m(t,e,n,r,s,a)}:i.length?function(t,e,n,r,i,o){var s=[];for(let a=0;a<i.length;a++)s[a]=v(t,e,n,r,i[a],o[a]);return s}(t,e,n,r,i,o):v(t,e,n,r,i,o)}function v(t,e,n,r,i,o){var s,a=r-n,l=t-n;return i*(1-(s=1===e?l/a:(Math.pow(e,l)-1)/(Math.pow(e,a)-1)))+o*s}function w(t){return t&&"object"==typeof t&&(t.stops||t.property&&"identity"===t.type||t.expression&&"calculate-expression"===t.type)}function M(t){return b(t,"interval")}function b(t,e){if(!w(t))return function(){return t};let n=!0,r=!0;const i=(t=JSON.parse(JSON.stringify(t))).stops;if(i)for(let t=0;t<i.length;t++)if(w(i[t][1])){const o=b(i[t][1],e);n=n&&o.isZoomConstant,r=r&&o.isFeatureConstant,i[t]=[i[t][0],o]}const o=h(t,e);return o.isZoomConstant=n&&o.isZoomConstant,o.isFeatureConstant=r&&o.isFeatureConstant,o}let P=0;const _="function"==typeof Object.assign;function I(t,...e){if(_)return Object.assign(t,...e),t;for(let n=0;n<e.length;n++){const r=e[n];for(const e in r)t[e]=r[e]}return t}function A(t){return!k(t)&&("string"==typeof t||null!==t.constructor&&t.constructor===String)}function S(t){return"number"==typeof t&&!isNaN(t)}function F(t){return!k(t)&&("function"==typeof t||null!==t.constructor&&t.constructor===Function)}function T(t){return!Array.isArray(t)&&"object"==typeof t&&!!t}function k(t){return null==t}function B(t){return w(t)&&t.property}const L="function"==typeof fetch&&"function"==typeof AbortController,C={jsonp:function(t,e){const n="_maptalks_jsonp_"+P++;t.match(/\\?/)?t+="&callback="+n:t+="?callback="+n;let r=document.createElement("script");return r.type="text/javascript",r.src=t,window[n]=function(t){e(null,t),document.getElementsByTagName("head")[0].removeChild(r),r=null,delete window[n]},document.getElementsByTagName("head")[0].appendChild(r),this},get:function(t,e,n){if(F(e)){const t=n;n=e,e=t}(e=e||{}).method&&(e.method=e.method.toUpperCase());const r="POST"===e.method;if(L){const r=new AbortController,i=e;i.signal=r.signal,i.referrerPolicy=i.referrerPolicy||"origin",i.method=i.method||"GET";const o=new Request(t,i);return e.returnJSON&&o.headers.set("Accept","application/json"),fetch(o).then((r=>{const i=this._parseResponse(r,e.returnJSON,e.responseType);i.message?(i.url=t,n(i)):i.then((t=>{"arraybuffer"===e.responseType?n(null,{data:t,cacheControl:r.headers.get("Cache-Control"),expires:r.headers.get("Expires"),contentType:r.headers.get("Content-Type")}):n(null,t)})).catch((e=>{e.code&&e.code===DOMException.ABORT_ERR||(console.error("Fetch error:",t,e),n(e))}))})).catch((e=>{e.code&&e.code===DOMException.ABORT_ERR||(console.error("Fetch error:",t,e),n(e))})),r}{const i=C._getClient(n);if(i.open(e.method||"GET",t,!0),e){for(const t in e.headers)i.setRequestHeader(t,e.headers[t]);i.withCredentials="include"===e.credentials,e.responseType&&(i.responseType=e.responseType)}return i.send(r?e.body:null),i}},_parseResponse:(t,e,n)=>200!==t.status?{status:t.status,statusText:t.statusText,message:\`incorrect http request with status code(${$435bc7696844e930$var$E}t.status}): ${$435bc7696844e930$var$E}t.statusText}\`}:"arraybuffer"===n?t.arrayBuffer():e?t.json():t.text(),_wrapCallback:function(t,e){return function(){if(4===t.readyState)if(200===t.status)if("arraybuffer"===t.responseType){0===t.response.byteLength?e({status:200,statusText:t.statusText,message:"http status 200 returned without content."}):e(null,{data:t.response,cacheControl:t.getResponseHeader("Cache-Control"),expires:t.getResponseHeader("Expires"),contentType:t.getResponseHeader("Content-Type")})}else e(null,t.responseText);else e({status:t.status,statusText:t.statusText,message:\`incorrect http request with status code(${$435bc7696844e930$var$E}t.status}): ${$435bc7696844e930$var$E}t.statusText}\`})}},_getClient:function(t){let e;try{e=new XMLHttpRequest}catch(t){try{e=new ActiveXObject("Msxml2.XMLHTTP")}catch(t){try{e=new ActiveXObject("Microsoft.XMLHTTP")}catch(t){}}}return e.onreadystatechange=C._wrapCallback(e,t),e},getArrayBuffer(t,e,n){if(F(e)){const t=n;n=e,e=t}return e||(e={}),e.responseType="arraybuffer",C.get(t,e,n)}};function Y(t,e,n,r,i=3){let o=r;const s=n-e>>1;let a,l=n-e;const u=t[e],h=t[e+1],c=t[n],f=t[n+1];for(let r=e+i;r<n;r+=i){const e=V(t[r],t[r+1],u,h,c,f);if(e>o)a=r,o=e;else if(e===o){const t=Math.abs(r-s);t<l&&(a=r,l=t)}}o>r&&(a-e>i&&Y(t,e,a,r,i),t[a+2]=o,n-a>i&&Y(t,a,n,r,i))}function V(t,e,n,r,i,o){let s=i-n,a=o-r;if(0!==s||0!==a){const l=((t-n)*s+(e-r)*a)/(s*s+a*a);l>1?(n=i,r=o):l>0&&(n+=s*l,r+=a*l)}return s=t-n,a=e-r,s*s+a*a}function O(t,e,n,r,i,o){const s={id:null==t?null:t,type:e,geometry:n,tags:r,minX:1/0,minY:1/0,maxX:-1/0,maxY:-1/0};i&&(s.layer=i);return function(t,e){const n=t.geometry,r=t.type;if("Point"===r||"MultiPoint"===r||"LineString"===r)X(t,n,e);else if("Polygon"===r)X(t,n[0],e);else if("MultiLineString"===r)for(const r of n)X(t,r,e);else if("MultiPolygon"===r)for(const r of n)X(t,r[0],e)}(s,o?4:3),s}function X(t,e,n){for(let r=0;r<e.length;r+=n)t.minX=Math.min(t.minX,e[r]),t.minY=Math.min(t.minY,e[r+1]),t.maxX=Math.max(t.maxX,e[r]),t.maxY=Math.max(t.maxY,e[r+1])}function N(t,e,n,r){if(r.layer=e,"FeatureCollection"===n.type)for(let e=0;e<n.features.length;e++)E(t,n.features[e],r,e);else"Feature"===n.type?E(t,n,r):E(t,{geometry:n},r)}function E(t,e,n,r){if(!e.geometry)return;const i=e.geometry.coordinates,o=e.geometry.type,s=Math.pow(n.tolerance/((1<<n.maxZoom)*n.extent),2);let a=[],l=e.id;if(n.promoteId?l=e.properties[n.promoteId]:n.generateId&&(l=r||0),"Point"===o)z(i,a,n);else if("MultiPoint"===o)for(const t of i)z(t,a,n);else if("LineString"===o)$(i,a,s,!1,n);else if("MultiLineString"===o){if(n.lineMetrics){for(const r of i)a=[],$(r,a,s,!1,n),t.push(O(l,"LineString",a,e.properties,n.layer,n.hasAltitude));return}q(i,a,s,!1,n)}else if("Polygon"===o)q(i,a,s,!0,n);else{if("MultiPolygon"!==o){if("GeometryCollection"===o){for(const i of e.geometry.geometries)E(t,{id:l,geometry:i,properties:e.properties},n,r);return}throw new Error("Input data is not a valid GeoJSON object.")}for(const t of i){const e=[];q(t,e,s,!0,n),a.push(e)}}t.push(O(l,o,a,e.properties,n.layer,n.hasAltitude))}function z(t,e,n){e.push(D(t[0]),j(t[1],n.projection),0),n.hasAltitude&&(t.length>2?e.push(t[2]):e.push(0))}function $(t,e,n,r,i){let o,s,a=0;for(let n=0;n<t.length;n++){const l=D(t[n][0]),u=j(t[n][1],i.projection);e.push(l,u,0),i.hasAltitude&&(t[n].length>2?e.push(t[n][2]):e.push(0)),n>0&&(a+=r?(o*u-l*s)/2:Math.sqrt(Math.pow(l-o,2)+Math.pow(u-s,2))),o=l,s=u}const l=i.hasAltitude?4:3,u=e.length-l;e[2]=1,Y(e,0,u,n,l),e[u+2]=1,e.size=Math.abs(a),e.start=0,e.end=e.size}function q(t,e,n,r,i){for(let o=0;o<t.length;o++){const s=[];$(t[o],s,n,r,i),e.push(s)}}function D(t){return t/360+.5}function j(t,e){if("EPSG:4326"===e)return(90-t)/360;const n=Math.sin(t*Math.PI/180),r=.5-.25*Math.log((1+n)/(1-n))/Math.PI;return r<0?0:r>1?1:r}function Z(t,e,n,r,i,o,s,a){if(r/=e,o>=(n/=e)&&s<r)return t;if(s<n||o>=r)return null;const l=[];for(const e of t){const t=e.geometry;let o=e.type;const s=0===i?e.minX:e.minY,u=0===i?e.maxX:e.maxY;if(s>=n&&u<r){l.push(e);continue}if(u<n||s>=r)continue;let h=[];if("Point"===o||"MultiPoint"===o)G(t,h,n,r,i,a.hasAltitude);else if("LineString"===o)U(t,h,n,r,i,!1,a.lineMetrics,a.hasAltitude);else if("MultiLineString"===o)J(t,h,n,r,i,!1,a.hasAltitude);else if("Polygon"===o)J(t,h,n,r,i,!0,a.hasAltitude);else if("MultiPolygon"===o)for(const e of t){const t=[];J(e,t,n,r,i,!0,a.hasAltitude),t.length&&h.push(t)}if(h.length){if(a.lineMetrics&&"LineString"===o){for(const t of h)l.push(O(e.id,o,t,e.tags,e.layer,a.hasAltitude));continue}"LineString"!==o&&"MultiLineString"!==o||(1===h.length?(o="LineString",h=h[0]):o="MultiLineString"),"Point"!==o&&"MultiPoint"!==o||(o=3===h.length?"Point":"MultiPoint"),l.push(O(e.id,o,h,e.tags,e.layer,a.hasAltitude))}}return l.length?l:null}function G(t,e,n,r,i,o){const s=o?4:3;for(let a=0;a<t.length;a+=s){const s=t[a+i];s>=n&&s<=r&&(H(e,t[a],t[a+1],t[a+2]),o&&e.push(t[a+3]))}}function U(t,e,n,r,i,o,s,a){let l=R(t);const u=0===i?W:K;let h,c,f=t.start;const p=a?4:3,d=o?t.length:t.length-p;for(let g=0;g<d;g+=p){const y=t[g],x=t[g+1],m=t[g+2];let v,w,M,b;o&&g===d-p?(v=t[0],w=t[1]):(v=t[g+p],w=t[g+p+1]),a&&(M=t[g+3],b=o&&g===d-p?t[3]:t[g+p+3]);const P=0===i?y:x,_=0===i?v:w;let I=!1;s&&(h=Math.sqrt(Math.pow(y-v,2)+Math.pow(x-w,2))),P<n?_>n&&(c=u(l,y,x,v,w,n),a&&l.push(Q(M,b,c)),s&&(l.start=f+h*c)):P>r?_<r&&(c=u(l,y,x,v,w,r),a&&l.push(Q(M,b,c)),s&&(l.start=f+h*c)):(H(l,y,x,m),a&&l.push(M)),_<n&&P>=n&&(c=u(l,y,x,v,w,n),a&&l.push(Q(M,b,c)),I=!0),_>r&&P<=r&&(c=u(l,y,x,v,w,r),a&&l.push(Q(M,b,c)),I=!0),!o&&I&&(s&&(l.end=f+h*c),e.push(l),l=R(t)),s&&(f+=h)}let g=t.length-p;if(!o){const e=t[g],o=t[g+1],s=t[g+2],u=0===i?e:o;if(u>=n&&u<=r&&H(l,e,o,s),u>=n&&u<=r&&a){const e=t[g+3];l.push(e)}}g=l.length-p,o&&g>=p&&(l[g]!==l[0]||l[g+1]!==l[1])&&(H(l,l[0],l[1],l[2]),a&&l.push(l[3])),l.length&&e.push(l)}function R(t){const e=[];return e.size=t.size,e.start=t.start,e.end=t.end,e}function J(t,e,n,r,i,o,s){for(const a of t)U(a,e,n,r,i,o,!1,s)}function H(t,e,n,r){t.push(e,n,r)}function W(t,e,n,r,i,o){const s=(o-e)/(r-e);return H(t,o,n+(i-n)*s,1),s}function K(t,e,n,r,i,o){const s=(o-n)/(i-n);return H(t,e+(r-e)*s,o,1),s}function Q(t,e,n){return t+(e-t)*n}function tt(t,e,n){const r=[];for(let i=0;i<t.length;i++){const o=t[i],s=o.type;let a;if("Point"===s||"MultiPoint"===s||"LineString"===s)a=et(o.geometry,e,n);else if("MultiLineString"===s||"Polygon"===s){a=[];for(const t of o.geometry)a.push(et(t,e,n))}else if("MultiPolygon"===s){a=[];for(const t of o.geometry){const r=[];for(const i of t)r.push(et(i,e,n));a.push(r)}}r.push(O(o.id,s,a,o.tags,o.layer,n))}return r}function et(t,e,n){const r=[];r.size=t.size,void 0!==t.start&&(r.start=t.start,r.end=t.end);const i=n?4:3;for(let o=0;o<t.length;o+=i)r.push(t[o]+e,t[o+1],t[o+2]),n&&r.push(t[o+3]);return r}function nt(t,e,n){if(t.transformed)return t;const r=1<<t.z,i=t.x,o=t.y,s=n?3:2;for(const a of t.features){const t=a.geometry,l=a.type;if(a.geometry=[],1===l)for(let l=0;l<t.length;l+=s)a.geometry.push(rt(t[l],t[l+1],e,r,i,o)),n&&a.geometry[a.geometry.length-1].push(t[l+2]);else for(let l=0;l<t.length;l++){const u=[];for(let a=0;a<t[l].length;a+=s)u.push(rt(t[l][a],t[l][a+1],e,r,i,o)),n&&u[u.length-1].push(t[l][a+2]);a.geometry.push(u)}}return t.transformed=!0,t}function rt(t,e,n,r,i,o){return[Math.round(n*(t*r-i)),Math.round(n*(e*r-o))]}function it(t,e,n,r,i){const o=e===i.maxZoom?0:i.tolerance/((1<<e)*i.extent),s={features:[],numPoints:0,numSimplified:0,numFeatures:t.length,source:null,x:n,y:r,z:e,transformed:!1,minX:2,minY:1,maxX:-1,maxY:0};for(const e of t)ot(s,e,o,i);return s}function ot(t,e,n,r){const i=e.geometry,o=e.type,s=[],a=r.hasAltitude?4:3;if(t.minX=Math.min(t.minX,e.minX),t.minY=Math.min(t.minY,e.minY),t.maxX=Math.max(t.maxX,e.maxX),t.maxY=Math.max(t.maxY,e.maxY),"Point"===o||"MultiPoint"===o)for(let e=0;e<i.length;e+=a)s.push(i[e],i[e+1]),r.hasAltitude&&s.push(i[e+3]),t.numPoints++,t.numSimplified++;else if("LineString"===o)at(s,i,t,n,!1,!1,r);else if("MultiLineString"===o||"Polygon"===o)for(let e=0;e<i.length;e++)at(s,i[e],t,n,"Polygon"===o,0===e,r);else if("MultiPolygon"===o)for(let e=0;e<i.length;e++){const o=i[e];for(let e=0;e<o.length;e++)at(s,o[e],t,n,!0,0===e,r)}if(s.length){let n=e.tags||null;if("LineString"===o&&r.lineMetrics){n={};for(const t in e.tags)n[t]=e.tags[t];n.mapbox_clip_start=i.start/i.size,n.mapbox_clip_end=i.end/i.size}const a={geometry:s,type:"Polygon"===o||"MultiPolygon"===o?3:"LineString"===o||"MultiLineString"===o?2:1,tags:n};e.layer&&(a.layer=e.layer),null!==e.id&&(a.id=e.id),t.features.push(a)}}function st(t,e,n){return 0===t[e+2]&&t[e+3]>0&&n}function at(t,e,n,r,i,o,s){const a=r*r,{hasAltitude:l,disableFilter:u}=s,h=l?4:3;if(!u&&r>0&&e.size<(i?a:r))return void(n.numPoints+=e.length/h);const c=[];for(let t=0;t<e.length;t+=h)(0===r||e[t+2]>a||st(e,t,l))&&(n.numSimplified++,c.push(e[t],e[t+1]),l&&c.push(e[t+3])),n.numPoints++;i&&function(t,e,n){const r=n?3:2;let i=0;for(let e=0,n=t.length,o=n-r;e<n;o=e,e+=r)i+=(t[e]-t[o])*(t[e+1]+t[o+1]);if(i>0===e){const e=r,i=r-1,o=r-2;for(let s=0,a=t.length;s<a/2;s+=r){const r=t[s],l=t[s+1];let u;n&&(u=t[s+2]),t[s]=t[a-e-s],t[s+1]=t[a-i-s],n&&(t[s+2]=t[a-o-s]),t[a-e-s]=r,t[a-i-s]=l,n&&(t[a-o-s]=u)}}}(c,o,l),t.push(c)}C.getJSON=function(t,e,n){if(F(e)){const t=n;n=e,e=t}const r=function(t,e){const r="string"==typeof e?JSON.parse(e):e||null;n(t,r)};return e&&e.jsonp?C.jsonp(t,r):((e=e||{}).returnJSON=!0,C.get(t,e,r))};const lt={maxZoom:14,indexMaxZoom:5,indexMaxPoints:1e5,tolerance:3,extent:4096,buffer:64,lineMetrics:!1,promoteId:null,generateId:!1,hasAltitude:!1,disableFilter:!1,debug:0};class ut{constructor(t,e){const n=(e=this.options=function(t,e){for(const n in e)t[n]=e[n];return t}(Object.create(lt),e)).debug;if(n&&console.time("preprocess data"),e.maxZoom<0||e.maxZoom>24)throw new Error("maxZoom should be in the 0-24 range");if(e.promoteId&&e.generateId)throw new Error("promoteId and generateId cannot be used together.");let r=function(t,e){const n=[];if(Array.isArray(t)){for(let r=0;r<t.length;r++)N(n,t[r].layer,t[r].data,e);return n}if("FeatureCollection"===t.type)for(let r=0;r<t.features.length;r++)E(n,t.features[r],e,r);else"Feature"===t.type?E(n,t,e):E(n,{geometry:t},e);return n}(t,e);this.tiles={},this.tileCoords=[],n&&(console.timeEnd("preprocess data"),console.log("index: maxZoom: %d, maxPoints: %d",e.indexMaxZoom,e.indexMaxPoints),console.time("generate tiles"),this.stats={},this.total=0),r=function(t,e){const n=e.buffer/e.extent;let r=t;const i=Z(t,1,-1-n,n,0,-1,2,e),o=Z(t,1,1-n,2+n,0,-1,2,e);return(i||o)&&(r=Z(t,1,-n,1+n,0,-1,2,e)||[],i&&(r=tt(i,1,e.hasAltitude).concat(r)),o&&(r=r.concat(tt(o,-1,e.hasAltitude)))),r}(r,e),r.length&&this.splitTile(r,0,0,0),n&&(r.length&&console.log("features: %d, points: %d",this.tiles[0].numFeatures,this.tiles[0].numPoints),console.timeEnd("generate tiles"),console.log("tiles generated:",this.total,JSON.stringify(this.stats)))}splitTile(t,e,n,r,i,o,s){const a=[t,e,n,r],l=this.options,u=l.debug;for(;a.length;){r=a.pop(),n=a.pop(),e=a.pop(),t=a.pop();const h=1<<e,c=ht(e,n,r);let f=this.tiles[c];if(!f&&(u>1&&console.time("creation"),f=this.tiles[c]=it(t,e,n,r,l),this.tileCoords.push({z:e,x:n,y:r}),u)){u>1&&(console.log("tile z%d-%d-%d (features: %d, points: %d, simplified: %d)",e,n,r,f.numFeatures,f.numPoints,f.numSimplified),console.timeEnd("creation"));const t=\`z${$435bc7696844e930$var$E}e}\`;this.stats[t]=(this.stats[t]||0)+1,this.total++}if(f.source=t,null==i){if(e===l.indexMaxZoom||f.numPoints<=l.indexMaxPoints)continue}else{if(e===l.maxZoom||e===i)continue;if(null!=i){const t=i-e;if(n!==o>>t||r!==s>>t)continue}}if(f.source=null,0===t.length)continue;u>1&&console.time("clipping");const p=.5*l.buffer/l.extent,d=.5-p,g=.5+p,y=1+p;let x=null,m=null,v=null,w=null,M=Z(t,h,n-p,n+g,0,f.minX,f.maxX,l),b=Z(t,h,n+d,n+y,0,f.minX,f.maxX,l);t=null,M&&(x=Z(M,h,r-p,r+g,1,f.minY,f.maxY,l),m=Z(M,h,r+d,r+y,1,f.minY,f.maxY,l),M=null),b&&(v=Z(b,h,r-p,r+g,1,f.minY,f.maxY,l),w=Z(b,h,r+d,r+y,1,f.minY,f.maxY,l),b=null),u>1&&console.timeEnd("clipping"),a.push(x||[],e+1,2*n,2*r),a.push(m||[],e+1,2*n,2*r+1),a.push(v||[],e+1,2*n+1,2*r),a.push(w||[],e+1,2*n+1,2*r+1)}}getTile(t,e,n){t=+t,e=+e,n=+n;const r=this.options,{extent:i,debug:o}=r,{hasAltitude:s,wrapX:a}=r;if(t<0||t>24)return null;if(a){const n=1<<t;e=e+n&n-1}const l=ht(t,e,n);if(this.tiles[l])return nt(this.tiles[l],i,s);o>1&&console.log("drilling down to z%d-%d-%d",t,e,n);let u,h=t,c=e,f=n;for(;!u&&h>0;)h--,c>>=1,f>>=1,u=this.tiles[ht(h,c,f)];return u&&u.source?(o>1&&(console.log("found parent tile z%d-%d-%d",h,c,f),console.time("drilling down")),this.splitTile(u.source,h,c,f,t,e,n),o>1&&console.timeEnd("drilling down"),this.tiles[l]?nt(this.tiles[l],i,s):null):null}}function ht(t,e,n){return 32*((1<<t)*n+e)+t}function ct(t,e,n,r,i,o,s){const a=n&&Array.isArray(n[0]);for(let l=0,u=n.length;l<u;l++){t[e]=(a?n[l][0]:n[l].x)*r,t[e+1]=(a?n[l][1]:n[l].y)*r,s!==Float32Array&&(t[e]=Math.round(t[e]),t[e+1]=Math.round(t[e+1]));let h=i||0;Array.isArray(i)&&(h=i[l]),h=h?Math.round(r*h):0,t[e+2]=h,e+=3,o&&0!==l&&l!==u-1&&(t[e]=t[e-3],t[e+1]=t[e-2],t[e+2]=t[e-1],e+=3)}return t.trySetLength&&t.trySetLength(e),e}function ft(t,e,n,r){const i=t[3*e],o=t[3*e+1],s=t[3*n],a=t[3*n+1];return i===s&&(i<0||i>r)||o===a&&(o<0||o>r)}var pt="undefined"!=typeof Float32Array?Float32Array:Array;function dt(t,e,n,r){return t[0]=e,t[1]=n,t[2]=r,t}function gt(t,e){return t[0]=e[0],t[1]=e[1],t[2]=e[2],t[3]=e[3],t}function yt(t,e,n,r,i){return t[0]=e,t[1]=n,t[2]=r,t[3]=i,t}function xt(t,e,n){return t[0]=e[0]/n[0],t[1]=e[1]/n[1],t[2]=e[2]/n[2],t[3]=e[3]/n[3],t}function mt(t,e,n){return t[0]=e,t[1]=n,t}function vt(t,e){var n=e[0]-t[0],r=e[1]-t[1];return Math.hypot(n,r)}Math.hypot||(Math.hypot=function(){for(var t=0,e=arguments.length;e--;)t+=arguments[e]*arguments[e];return Math.sqrt(t)}),function(){var t,e=(t=new pt(3),pt!=Float32Array&&(t[0]=0,t[1]=0,t[2]=0),t)}(),function(){var t,e=(t=new pt(4),pt!=Float32Array&&(t[0]=0,t[1]=0,t[2]=0,t[3]=0),t)}(),function(){var t,e=(t=new pt(2),pt!=Float32Array&&(t[0]=0,t[1]=0),t)}();const wt=Math.PI/180,Mt=6378137*Math.PI/180,bt=85.0511287798;function Pt(t,e,n){if("EPSG:3857"===n)return function(t,e){const n=bt,r=e[0],i=Math.max(Math.min(n,e[1]),-n);let o;o=0===i?0:Math.log(Math.tan((90+i)*wt/2))/wt;return t[0]=r*Mt,t[1]=o*Mt,t}(t,e);if("EPSG:4326"===n||"EPSG:4490"===n||"identity"===n)return _t(t,e);if("baidu"===n)return _t(t,e);throw new Error("unsupported projection:"+n)}function _t(t,e){return t[0]=e[0],t[1]=e[1],t}function It(t,e,n,r,i,o,s,a,l,u,h,c,f,p,d){0===t?function(t,e,n,r,i,o,s,a,l,u){const h=1/(100*o[0]),c=1/(100*o[1]),f=u&&u[0]||0,p=u&&u[1]||0,d=[0,0];for(let i=t;i<e;i+=3){const t=i/3*2,e=r[i]-f,o=r[i+1]-p;n[t]=d[0]+e/s*h/a,n[t+1]=d[1]-o/s*c/l}}(e,n,r,i,0,s,a,l,u,d):1===t&&function(t,e,n,r,i,o,s,a,l,u,h){if(!t)return;let c,f,p,d;0===t[4]?(c=t[0],f=t[1],p=t[2],d=t[3]):(c=t[1],f=t[2],p=t[3],d=t[0]);const g=vt(c,f),y=vt(f,p),x=[],m=[],v=[];for(let t=e;t<n;t+=3){const e=t/3*2;mt(x,(o.x/l+i[t]/s)*a,o.y/l*a+(h?i[t+1]:-i[t+1])/s*a),"EPSG:4326"!==u&&"EPSG:4490"!==u||Pt(x,x,"EPSG:3857"),At(m,x,c,f),At(v,x,d,c),r[e]=vt(c,m)/g,r[e+1]=vt(c,v)/y}}(h,e,n,r,i,o,a,c,f,p,!!d)}function At(t,e,n,r){const i=n[0]-r[0],o=n[1]-r[1];let s=(e[0]-n[0])*(n[0]-r[0])+(e[1]-n[1])*(n[1]-r[1]);return s/=i*i+o*o,t[0]=n[0]+s*i,t[1]=n[1]+s*o,t}function St(t,e,n,r,i){const o=3*e[n-1],s=3*e[n-1]+1,a=t[o],l=t[s];return u=r,h=i,c=a,f=l,Math.sqrt((c-u)*(c-u)+(f-h)*(f-h));var u,h,c,f}function Ft(t,e,n=2){const r=e&&e.length,i=r?e[0]*n:t.length;let o=Tt(t,0,i,n,!0);const s=[];if(!o||o.next===o.prev)return s;let a,l,u;if(r&&(o=function(t,e,n,r){const i=[];for(let n=0,o=e.length;n<o;n++){const s=Tt(t,e[n]*r,n<o-1?e[n+1]*r:t.length,r,!1);s===s.next&&(s.steiner=!0),i.push(zt(s))}i.sort(Ot);for(let t=0;t<i.length;t++)n=Xt(i[t],n);return n}(t,e,o,n)),t.length>80*n){a=1/0,l=1/0;let e=-1/0,r=-1/0;for(let o=n;o<i;o+=n){const n=t[o],i=t[o+1];n<a&&(a=n),i<l&&(l=i),n>e&&(e=n),i>r&&(r=i)}u=Math.max(e-a,r-l),u=0!==u?32767/u:0}return Bt(o,s,n,a,l,u,0),s}function Tt(t,e,n,r,i){let o;if(i===function(t,e,n,r){let i=0;for(let o=e,s=n-r;o<n;o+=r)i+=(t[s]-t[o])*(t[o+1]+t[s+1]),s=o;return i}(t,e,n,r)>0)for(let i=e;i<n;i+=r)o=Wt(i/r|0,t[i],t[i+1],o);else for(let i=n-r;i>=e;i-=r)o=Wt(i/r|0,t[i],t[i+1],o);return o&&Zt(o,o.next)&&(Kt(o),o=o.next),o}function kt(t,e){if(!t)return t;e||(e=t);let n,r=t;do{if(n=!1,r.steiner||!Zt(r,r.next)&&0!==jt(r.prev,r,r.next))r=r.next;else{if(Kt(r),r=e=r.prev,r===r.next)break;n=!0}}while(n||r!==e);return e}function Bt(t,e,n,r,i,o,s){if(!t)return;!s&&o&&function(t,e,n,r){let i=t;do{0===i.z&&(i.z=Et(i.x,i.y,e,n,r)),i.prevZ=i.prev,i.nextZ=i.next,i=i.next}while(i!==t);i.prevZ.nextZ=null,i.prevZ=null,function(t){let e,n=1;do{let r,i=t;t=null;let o=null;for(e=0;i;){e++;let s=i,a=0;for(let t=0;t<n&&(a++,s=s.nextZ,s);t++);let l=n;for(;a>0||l>0&&s;)0!==a&&(0===l||!s||i.z<=s.z)?(r=i,i=i.nextZ,a--):(r=s,s=s.nextZ,l--),o?o.nextZ=r:t=r,r.prevZ=o,o=r;i=s}o.nextZ=null,n*=2}while(e>1)}(i)}(t,r,i,o);let a=t;for(;t.prev!==t.next;){const l=t.prev,u=t.next;if(o?Ct(t,r,i,o):Lt(t))e.push(l.i,t.i,u.i),Kt(t),t=u.next,a=u.next;else if((t=u)===a){s?1===s?Bt(t=Yt(kt(t),e),e,n,r,i,o,2):2===s&&Vt(t,e,n,r,i,o):Bt(kt(t),e,n,r,i,o,1);break}}}function Lt(t){const e=t.prev,n=t,r=t.next;if(jt(e,n,r)>=0)return!1;const i=e.x,o=n.x,s=r.x,a=e.y,l=n.y,u=r.y,h=Math.min(i,o,s),c=Math.min(a,l,u),f=Math.max(i,o,s),p=Math.max(a,l,u);let d=r.next;for(;d!==e;){if(d.x>=h&&d.x<=f&&d.y>=c&&d.y<=p&&qt(i,a,o,l,s,u,d.x,d.y)&&jt(d.prev,d,d.next)>=0)return!1;d=d.next}return!0}function Ct(t,e,n,r){const i=t.prev,o=t,s=t.next;if(jt(i,o,s)>=0)return!1;const a=i.x,l=o.x,u=s.x,h=i.y,c=o.y,f=s.y,p=Math.min(a,l,u),d=Math.min(h,c,f),g=Math.max(a,l,u),y=Math.max(h,c,f),x=Et(p,d,e,n,r),m=Et(g,y,e,n,r);let v=t.prevZ,w=t.nextZ;for(;v&&v.z>=x&&w&&w.z<=m;){if(v.x>=p&&v.x<=g&&v.y>=d&&v.y<=y&&v!==i&&v!==s&&qt(a,h,l,c,u,f,v.x,v.y)&&jt(v.prev,v,v.next)>=0)return!1;if(v=v.prevZ,w.x>=p&&w.x<=g&&w.y>=d&&w.y<=y&&w!==i&&w!==s&&qt(a,h,l,c,u,f,w.x,w.y)&&jt(w.prev,w,w.next)>=0)return!1;w=w.nextZ}for(;v&&v.z>=x;){if(v.x>=p&&v.x<=g&&v.y>=d&&v.y<=y&&v!==i&&v!==s&&qt(a,h,l,c,u,f,v.x,v.y)&&jt(v.prev,v,v.next)>=0)return!1;v=v.prevZ}for(;w&&w.z<=m;){if(w.x>=p&&w.x<=g&&w.y>=d&&w.y<=y&&w!==i&&w!==s&&qt(a,h,l,c,u,f,w.x,w.y)&&jt(w.prev,w,w.next)>=0)return!1;w=w.nextZ}return!0}function Yt(t,e){let n=t;do{const r=n.prev,i=n.next.next;!Zt(r,i)&&Gt(r,n,n.next,i)&&Jt(r,i)&&Jt(i,r)&&(e.push(r.i,n.i,i.i),Kt(n),Kt(n.next),n=t=i),n=n.next}while(n!==t);return kt(n)}function Vt(t,e,n,r,i,o){let s=t;do{let t=s.next.next;for(;t!==s.prev;){if(s.i!==t.i&&Dt(s,t)){let a=Ht(s,t);return s=kt(s,s.next),a=kt(a,a.next),Bt(s,e,n,r,i,o,0),void Bt(a,e,n,r,i,o,0)}t=t.next}s=s.next}while(s!==t)}function Ot(t,e){let n=t.x-e.x;if(0===n&&(n=t.y-e.y,0===n)){n=(t.next.y-t.y)/(t.next.x-t.x)-(e.next.y-e.y)/(e.next.x-e.x)}return n}function Xt(t,e){const n=function(t,e){let n=e;const r=t.x,i=t.y;let o,s=-1/0;if(Zt(t,n))return n;do{if(Zt(t,n.next))return n.next;if(i<=n.y&&i>=n.next.y&&n.next.y!==n.y){const t=n.x+(i-n.y)*(n.next.x-n.x)/(n.next.y-n.y);if(t<=r&&t>s&&(s=t,o=n.x<n.next.x?n:n.next,t===r))return o}n=n.next}while(n!==e);if(!o)return null;const a=o,l=o.x,u=o.y;let h=1/0;n=o;do{if(r>=n.x&&n.x>=l&&r!==n.x&&$t(i<u?r:s,i,l,u,i<u?s:r,i,n.x,n.y)){const e=Math.abs(i-n.y)/(r-n.x);Jt(n,t)&&(e<h||e===h&&(n.x>o.x||n.x===o.x&&Nt(o,n)))&&(o=n,h=e)}n=n.next}while(n!==a);return o}(t,e);if(!n)return e;const r=Ht(n,t);return kt(r,r.next),kt(n,n.next)}function Nt(t,e){return jt(t.prev,t,e.prev)<0&&jt(e.next,t,t.next)<0}function Et(t,e,n,r,i){return(t=1431655765&((t=858993459&((t=252645135&((t=16711935&((t=(t-n)*i|0)|t<<8))|t<<4))|t<<2))|t<<1))|(e=1431655765&((e=858993459&((e=252645135&((e=16711935&((e=(e-r)*i|0)|e<<8))|e<<4))|e<<2))|e<<1))<<1}function zt(t){let e=t,n=t;do{(e.x<n.x||e.x===n.x&&e.y<n.y)&&(n=e),e=e.next}while(e!==t);return n}function $t(t,e,n,r,i,o,s,a){return(i-s)*(e-a)>=(t-s)*(o-a)&&(t-s)*(r-a)>=(n-s)*(e-a)&&(n-s)*(o-a)>=(i-s)*(r-a)}function qt(t,e,n,r,i,o,s,a){return!(t===s&&e===a)&&$t(t,e,n,r,i,o,s,a)}function Dt(t,e){return t.next.i!==e.i&&t.prev.i!==e.i&&!function(t,e){let n=t;do{if(n.i!==t.i&&n.next.i!==t.i&&n.i!==e.i&&n.next.i!==e.i&&Gt(n,n.next,t,e))return!0;n=n.next}while(n!==t);return!1}(t,e)&&(Jt(t,e)&&Jt(e,t)&&function(t,e){let n=t,r=!1;const i=(t.x+e.x)/2,o=(t.y+e.y)/2;do{n.y>o!=n.next.y>o&&n.next.y!==n.y&&i<(n.next.x-n.x)*(o-n.y)/(n.next.y-n.y)+n.x&&(r=!r),n=n.next}while(n!==t);return r}(t,e)&&(jt(t.prev,t,e.prev)||jt(t,e.prev,e))||Zt(t,e)&&jt(t.prev,t,t.next)>0&&jt(e.prev,e,e.next)>0)}function jt(t,e,n){return(e.y-t.y)*(n.x-e.x)-(e.x-t.x)*(n.y-e.y)}function Zt(t,e){return t.x===e.x&&t.y===e.y}function Gt(t,e,n,r){const i=Rt(jt(t,e,n)),o=Rt(jt(t,e,r)),s=Rt(jt(n,r,t)),a=Rt(jt(n,r,e));return i!==o&&s!==a||(!(0!==i||!Ut(t,n,e))||(!(0!==o||!Ut(t,r,e))||(!(0!==s||!Ut(n,t,r))||!(0!==a||!Ut(n,e,r)))))}function Ut(t,e,n){return e.x<=Math.max(t.x,n.x)&&e.x>=Math.min(t.x,n.x)&&e.y<=Math.max(t.y,n.y)&&e.y>=Math.min(t.y,n.y)}function Rt(t){return t>0?1:t<0?-1:0}function Jt(t,e){return jt(t.prev,t,t.next)<0?jt(t,e,t.next)>=0&&jt(t,t.prev,e)>=0:jt(t,e,t.prev)<0||jt(t,t.next,e)<0}function Ht(t,e){const n=Qt(t.i,t.x,t.y),r=Qt(e.i,e.x,e.y),i=t.next,o=e.prev;return t.next=e,e.prev=t,n.next=i,i.prev=n,r.next=n,n.prev=r,o.next=r,r.prev=o,r}function Wt(t,e,n,r){const i=Qt(t,e,n);return r?(i.next=r.next,i.prev=r,r.next.prev=i,r.next=i):(i.prev=i,i.next=i),i}function Kt(t){t.next.prev=t.prev,t.prev.next=t.next,t.prevZ&&(t.prevZ.nextZ=t.nextZ),t.nextZ&&(t.nextZ.prevZ=t.prevZ)}function Qt(t,e,n){return{i:t,x:e,y:n,prev:null,next:null,z:0,prevZ:null,nextZ:null,steiner:!1}}const te="__fea_idx";new Float32Array([-1e12])[0];const ee="maptalks_ombb";function ne(){return function(){if("undefined"!=typeof undefinedThis)return globalThis;if("undefined"!=typeof self)return self;if("undefined"!=typeof window)return window;if("undefined"!=typeof undefined)return global;throw new Error("unable to locate global object")}().maptalks_vt_packers}const{PackUtil:re,ArrayPool:ie}=ne();function oe(t,e,n,r,i,o,s,a,l,u,h,c,f,p,d,g,y){const x=e.getLength(),m=i/3;for(let n=2,r=x;n<r;n+=3)t[i+n-2]=e[n-2],t[i+n-1]=e[n-1],t[i+n-0]=e[n]-s;i+=x;for(let n=2,r=x;n<r;n+=3)t[i+n-2]=e[n-2],t[i+n-1]=e[n-1],t[i+n-0]=e[n]-a;i+=x,t.trySetLength(i+x),t.copyWithin(i,i-2*x,i-x),i+=x,t.trySetLength(i+x),t.copyWithin(i,i-2*x,i-x),i+=x,(n=n||[]).push(x/3);const v=n.getLength();for(let e=0;e<v;e++){se(m+(n[e-1]||0),m+n[e],t,x/3,l,r,u,h,c,f,o,p,d,g,y)}return i}function se(t,e,n,r,i,o,s,a,l,u,h,c,f,p,d){const g=o.getLength();let y,x;for(let s=t,a=e;s<a-1;s++)if(y=s,x=s+1,i===1/0||!ft(n,y,x,i))if((s-t)%2==1&&(y+=2*r,x+=2*r),d){let t=o.currentIndex;o[t++]=y+r,o[t++]=x,o[t++]=y,o[t++]=x+r,o[t++]=x,o[t++]=y+r,o.currentIndex=t}else{let t=o.currentIndex;o[t++]=y+r,o[t++]=y,o[t++]=x,o[t++]=x,o[t++]=x+r,o[t++]=y+r,o.currentIndex=t}s&&function(t,e,n,r,i,o,s,a,l,u,h,c){let f,p=0,d=0,g=0,y=0;const x=c?[1,3,4]:[2,3,4];for(let c=o.getLength()-1;c>=s;c--){const s=o[c],m=3*s+1,v=3*s+2,w=i[3*s],M=i[m],b=i[v];p||d||(p=Math.max(i[v],i[3*o[c-3]+2]),d=Math.min(i[v],i[3*o[c-3]+2]),f=p-d);let P=g;const _=c%6;0===t?(5===_&&(y=St(i,o,c,w,M)),P=_===x[0]||_===x[1]||_===x[2]?g:g+y):1===t&&(_===x[0]||_===x[1]||_===x[2]?P=0:5===_?(y=St(i,o,c,w,M),P=y):P=y);const I=P/u*(1/(100*h))/a;let A;A=1===e?b===p?1:0:"bottom"===n?b===p?f/100/l:0:b===p?0:-f/100/l,r[2*s]=I,r[2*s+1]=A,0===_&&(g+=y)}}(a,l,u,h,n,o,g,c[0],c[1],f,p,d)}function ae(t){const e=[t[0]];let n=t[0];for(let r=1;r<t.length;r++)Array.isArray(t[r])?t[r][0]===n[0]&&t[r][1]===n[1]&&t[r][2]===n[2]||e.push(t[r]):t[r].x===n.x&&t[r].y===n.y&&t[r].z===n.z||e.push(t[r]),n=t[r];return e}var le="undefined"!=typeof Float32Array?Float32Array:Array;function ue(){var t=new le(3);return le!=Float32Array&&(t[0]=0,t[1]=0,t[2]=0),t}function he(t,e,n){var r=new le(3);return r[0]=t,r[1]=e,r[2]=n,r}function ce(t,e){return t[0]=e[0],t[1]=e[1],t[2]=e[2],t}function fe(t,e,n,r){return t[0]=e,t[1]=n,t[2]=r,t}function pe(t,e,n){return t[0]=e[0]+n[0],t[1]=e[1]+n[1],t[2]=e[2]+n[2],t}function de(t,e){var n=e[0],r=e[1],i=e[2],o=n*n+r*r+i*i;return o>0&&(o=1/Math.sqrt(o),t[0]=e[0]*o,t[1]=e[1]*o,t[2]=e[2]*o),t}function ge(t,e){return t[0]*e[0]+t[1]*e[1]+t[2]*e[2]}function ye(t,e,n){var r=e[0],i=e[1],o=e[2],s=n[0],a=n[1],l=n[2];return t[0]=i*l-o*a,t[1]=o*s-r*l,t[2]=r*a-i*s,t}var xe=function(t,e,n){return t[0]=e[0]-n[0],t[1]=e[1]-n[1],t[2]=e[2]-n[2],t};function me(){var t=new le(4);return le!=Float32Array&&(t[0]=0,t[1]=0,t[2]=0),t[3]=1,t}function ve(t,e){var n=e[0]+e[4]+e[8],r=void 0;if(n>0)r=Math.sqrt(n+1),t[3]=.5*r,r=.5/r,t[0]=(e[5]-e[7])*r,t[1]=(e[6]-e[2])*r,t[2]=(e[1]-e[3])*r;else{var i=0;e[4]>e[0]&&(i=1),e[8]>e[3*i+i]&&(i=2);var o=(i+1)%3,s=(i+2)%3;r=Math.sqrt(e[3*i+i]-e[3*o+o]-e[3*s+s]+1),t[i]=.5*r,r=.5/r,t[3]=(e[3*o+s]-e[3*s+o])*r,t[o]=(e[3*o+i]+e[3*i+o])*r,t[s]=(e[3*s+i]+e[3*i+s])*r}return t}!function(){var t=ue()}(),function(){var t,e=(t=new le(4),le!=Float32Array&&(t[0]=0,t[1]=0,t[2]=0,t[3]=0),t)}();var we,Me=function(t,e,n){return t[0]=e[0]*n,t[1]=e[1]*n,t[2]=e[2]*n,t[3]=e[3]*n,t},be=function(t,e){var n=e[0],r=e[1],i=e[2],o=e[3],s=n*n+r*r+i*i+o*o;return s>0&&(s=1/Math.sqrt(s),t[0]=n*s,t[1]=r*s,t[2]=i*s,t[3]=o*s),t};ue(),he(1,0,0),he(0,1,0),me(),me(),we=new le(9),le!=Float32Array&&(we[1]=0,we[2]=0,we[3]=0,we[5]=0,we[6]=0,we[7]=0),we[0]=1,we[4]=1,we[8]=1;\n/*!\n     * Contains code from google filament\n     * https://github.com/google/filament/\n     * License Apache-2.0\n     */\nconst Pe=8,_e=[],Ie=[],Ae=[],Se=[];function Fe(t,e,n){const r=ye(Ie,e,n),i=function(t,e,n,r,i,o,s,a,l,u){return t[0]=e,t[1]=n,t[2]=r,t[3]=i,t[4]=o,t[5]=s,t[6]=a,t[7]=l,t[8]=u,t}(_e,n[0],n[1],n[2],...r,...e);t=ve(t,i),t=function(t){return t[3]<0?Me(t,t,-1):t}(t=be(t,t));const o=1/((1<<2*Pe-1)-1);if(t[3]<o){t[3]=o;const e=Math.sqrt(1-o*o);t[0]*=e,t[1]*=e,t[2]*=e}const s=n[3]>0?ye(Ae,n,e):ye(Ae,e,n);return ge(ye(Se,n,e),s)<0&&Me(t,t,-1),t}const Te=[];const ke=[],Be=[],Le=[],Ce=[],Ye=[],Ve=[],Oe=[];function Xe(t,e,n,r,i,o){fe(Ce,t[3*e],t[3*e+1],t[3*e+2]),fe(Ye,t[3*n],t[3*n+1],t[3*n+2]),fe(Ve,t[3*r],t[3*r+1],t[3*r+2]);const s=xe(ke,Ve,Ye),a=xe(Be,Ce,Ye),l=ye(Le,s,a);de(Oe,l),i[3*e]=i[3*e]||0,i[3*n]=i[3*n]||0,i[3*r]=i[3*r]||0,i[3*e+1]=i[3*e+1]||0,i[3*n+1]=i[3*n+1]||0,i[3*r+1]=i[3*r+1]||0,i[3*e+2]=i[3*e+2]||0,i[3*n+2]=i[3*n+2]||0,i[3*r+2]=i[3*r+2]||0,i[3*e]+=Oe[0],i[3*n]+=Oe[0],i[3*r]+=Oe[0],i[3*e+1]+=Oe[1],i[3*n+1]+=Oe[1],i[3*r+1]+=Oe[1],i[3*e+2]+=Oe[2],i[3*n+2]+=Oe[2],i[3*r+2]+=Oe[2],o[e]+=1,o[n]+=1,o[r]+=1}\n/*!\n     * Contains code from THREE.JS\n     * https://github.com/mrdoob/three.js/\n     * License MIT\n     * \n     * Generate tangents per vertex.\n     */function Ne(t,e,n){return t[0]=e[n],t[1]=e[n+1],t[2]=e[n+2],t}function Ee(t,e,n){return t[0]=e[n],t[1]=e[n+1],t}const{StyleUtil:ze,PackUtil:$e,ArrayPool:qe}=ne(),De=qe.getInstance();function je(t,e,n,r,i,o,s,a,l,u,h,c,f,p,d,g){void 0===e.top&&(e.top=!0),void 0===e.side&&(e.side=!0),De.reset();const{altitudeScale:y,altitudeProperty:x,defaultAltitude:m,heightProperty:v,minHeightProperty:P,defaultHeight:_,tangent:I,uv:A,topUVMode:F,sideUVMode:T,sideVerticalUVMode:k,top:L,side:C,textureYOrigin:Y,topThickness:V}=e,O=function(t,e,{altitudeScale:n,altitudeProperty:r,defaultAltitude:i,heightProperty:o,minHeightProperty:s,defaultHeight:a},{center:l,side:u,top:h,topThickness:c,uvOrigin:f,uv:p,uvSize:d,topUVMode:g,sideUVMode:y,sideVerticalUVMode:x,textureYOrigin:m,tileRatio:v,centimeterToPoint:w,verticalCentimeterToPoint:M,positionType:b,res:P,glScale:_,projectionCode:I},A,F){let T=e/t[0].extent;e===1/0&&(T=1);const k=e===1/0,B=F.get(),L=F.get(),C=F.get(),Y=F.getProxy(),V=F.get(),O=F.get(),X=F.get(),N=!!p,E=!!h,z=!!u,$=N?F.get():null;function q(t,n,r,i,o,s){let a=n;if(E){const u=Ft(Y,r,3);if(0===u.length)return n;let h=Y.getLength(),p=V.currentIndex;for(let t=0;t<h;t++)V[p++]=Y[t];if(V.currentIndex=p,n+=Y.getLength(),s)for(let e=2,n=u.length;e<n;e+=3)u[e]+=t/3,u[e-1]+=t/3,u[e-2]+=t/3;else{let e;for(let n=2,r=u.length;n<r;n+=3)e=u[n-1],u[n-1]=u[n]+t/3,u[n]=e+t/3,u[n-2]+=t/3}h=u.length,p=O.currentIndex;for(let t=0;t<h;t++)O[p++]=u[t];O.currentIndex=p,N&&It(g||0,t,n,$,V,f,w,v,d[0],d[1],o,P,_,I,l),c>0&&!z&&(n=oe(V,Y,r,O,n,$,0,c,e,N,y||0,x||0,m,d,v,M,i<0?!s:s)),X.setLength(n/3),X.fill(1,a/3,n/3)}if(z){E&&(c=0),a=n,n=oe(V,Y,r,O,n,$,c,i,e,N,y||0,x||0,m,d,v,M,i<0?!s:s),X.setLength(n/3);const t=Y.getLength()/3;X.fill(1,a/3,a/3+t),X.fill(0,a/3+t,a/3+2*t),X.fill(1,a/3+2*t,a/3+3*t),X.fill(0,a/3+3*t,n/3)}return n}let D=-1/0,j=1/0,Z=0;const G=[-1,-1,e+1,e+1];let U=0,R=t.length;S(A)&&(U=A,R=A+1);let J=0,H=!1;const W=F.getProxy();let K=!1;for(;U<R;U++){const l=t[U],u=l.id;S(u)&&(Math.abs(u)>J&&(J=Math.abs(u)),u<0&&(H=!0));const h=l.geometry,c=l.properties[ee];let f=Array.isArray(c&&c[0]&&c[0][0])?c[0]:c;const{altitude:p,height:d}=re.getFeaAltitudeAndHeight(l,n,r,i,o,a,s);d<0?(K=!0,j=Math.min(p,j),D=Math.max(p-d,D)):(D=Math.max(p,D),j=Math.min(p-d,j));const g=V.getLength();let y=0,x=Z;W.setLength(0),Y.setLength(0);const m=re.calculateSignedArea(h[0])<0;for(let t=0,n=h.length;t<n;t++){let r=h[t];m&&(r=r.reverse()),r=ae(r);const i=re.calculateSignedArea(r)<0;if(!i&&t>0&&(y++,f=c&&c[y],Z=q(x,Z,W,d*T,f,k),Y.setLength(0),W.setLength(0),x=Z),e!==1/0&&(r=re.clipPolygon(r,G)),!r.length){t===n-1&&(Z=q(x,Z,W,d*T,f,k));continue}const o=r.length;if(Array.isArray(r[0])?r[0][0]===r[o-1][0]&&r[0][1]===r[o-1][1]||r.push([r[0][0],r[0][1]]):r[0].x===r[o-1].x&&r[0].y===r[o-1].y||r.push(r[0]),i){let t=W.currentIndex;W[t++]=Y.getLength()/3,W.currentIndex=t}ct(Y,Y.getLength(),r,T,p,!1,b),t===n-1&&(Z=q(x,Z,W,d*T,f,k))}const v=V.getLength()-g,w=(te+"").trim();for(let t=0;t<v/3;t++){let t=L.currentIndex;L[t++]=void 0===l[w]?U:l[w],L.currentIndex=t,t=B.currentIndex,B[t++]=U,B.currentIndex=t,S(u)&&(t=C.currentIndex,C[t++]=u,C.currentIndex=t)}}const Q=re.getUnsignedArrayType(L.getLength()?L[L.getLength()-1]:0),tt={hasNegativeHeight:K,maxAltitude:D===-1/0?0:D,minAltitude:j===1/0?0:j,vertices:V,verticeTypes:X,indices:O,pickingIds:ie.createTypedArray(L,Q),featureIndexes:B};if(C.getLength()){const t=H?re.getPosArrayType(J):re.getUnsignedArrayType(J);tt.featureIds=ie.createTypedArray(C,t)}else tt.featureIds=[];return $&&($.setLength(V.getLength()/3*2),tt.uvs=$),tt}(t,n,{altitudeScale:y,altitudeProperty:x,defaultAltitude:m||0,heightProperty:v,minHeightProperty:P,defaultHeight:_||0},{center:g,top:L,side:C,topThickness:10*V||0,uv:A||I,uvSize:[i,i],uvOrigin:r,topUVMode:F,sideUVMode:T,sideVerticalUVMode:k,textureYOrigin:Y,tileRatio:a,centimeterToPoint:l,verticalCentimeterToPoint:u,positionType:d,res:o,glScale:s,projectionCode:f},p,De),X=[],N=O.vertices.getLength()/3,E=$e.getIndexArrayType(N),z=qe.createTypedArray(O.indices,E);delete O.indices,X.push(z.buffer,O.pickingIds.buffer);const $=Math.max(Math.abs(O.maxAltitude),Math.abs(O.minAltitude)),q=$e.getPosArrayType(Math.max(512,$));O.vertices=qe.createTypedArray(O.vertices,q);const D=I?De.getProxy():new Float32Array(3*N);D.setLength&&D.setLength(3*N);const j=function(t,e,n){const r=n||[];r.setLength&&r.setLength(t.length);const i=Te;i.length<t.length/3&&(i.length=t.length/3),i.fill(0,0,t.length/3);const o=void 0===e.length?e:e.length;for(let n=0;n<o/3;n++)void 0===e.length?Xe(t,3*n,3*n+1,3*n+2,r,i):Xe(t,e[3*n],e[3*n+1],e[3*n+2],r,i);for(let t=0;t<r.length;t+=3){const e=i[t/3];0!==e?(r[t]/=e,r[t+1]/=e,r[t+2]/=e):(r[t]=0,r[t+1]=0,r[t+2]=0)}return r}(O.vertices,z,D);let Z=!0;const G=j.getLength?j.getLength():j.length;for(let t=0;t<G;t++){j[t]=-j[t];const e=j[t]%1;1-Math.abs(e)>1e-6?Z=!1:0!==e&&(j[t]=Math.round(j[t]))}if(O.normals=j,I){let t=De.get();t.setLength(4*N),t=function(t,e,n,r,i){const o=t.length/3,s=i||new Array(4*o),a=[],l=[];for(let t=0;t<o;t++)a[t]=[0,0,0],l[t]=[0,0,0];const u=[0,0,0],h=[0,0,0],c=[0,0,0],f=[0,0],p=[0,0],d=[0,0],g=[0,0,0],y=[0,0,0];function x(e,r,i){Ne(u,t,3*e),Ne(h,t,3*r),Ne(c,t,3*i),Ee(f,n,2*e),Ee(p,n,2*r),Ee(d,n,2*i);const o=h[0]-u[0],s=c[0]-u[0],x=h[1]-u[1],m=c[1]-u[1],v=h[2]-u[2],w=c[2]-u[2],M=p[0]-f[0],b=d[0]-f[0],P=p[1]-f[1],_=d[1]-f[1],I=1/(M*_-b*P);fe(g,(_*o-P*s)*I,(_*x-P*m)*I,(_*v-P*w)*I),fe(y,(M*s-b*o)*I,(M*m-b*x)*I,(M*w-b*v)*I),pe(a[e],a[e],g),pe(a[r],a[r],g),pe(a[i],a[i],g),pe(l[e],l[e],y),pe(l[r],l[r],y),pe(l[i],l[i],y)}for(let t=0,e=r.length;t<e;t+=3)x(r[t+0],r[t+1],r[t+2]);const m=[],v=[],w=[],M=[];let b,P,_;function I(t){Ne(w,e,3*t),ce(M,w),P=a[t],ce(m,P),xe(m,m,function(t,e,n){return t[0]=e[0]*n,t[1]=e[1]*n,t[2]=e[2]*n,t}(w,w,ge(w,P))),de(m,m),ye(v,M,P),_=ge(v,l[t]),b=_<0?-1:1,s[4*t]=m[0],s[4*t+1]=m[1],s[4*t+2]=m[2],s[4*t+3]=b}for(let t=0,e=r.length;t<e;t+=3)I(r[t+0]),I(r[t+1]),I(r[t+2]);return s}(O.vertices,O.normals,O.uvs,z,t),t=function(t,e){const n=e.getLength(),r=new Float32Array(n),i=[],o=[],s=[];for(let a=0;a<n;a+=4){const n=a/4*3;dt(o,t[n]||0,t[n+1]||0,t[n+2]||0),yt(i,e[a]||0,e[a+1]||0,e[a+2]||0,e[a+3]||0),Fe(s,o,i),gt(r.subarray(a,a+4),s)}return r}(O.normals,t),O.tangents=t,X.push(t.buffer),delete O.normals}if(O.normals&&(Z&&(O.normals=qe.createTypedArray(O.normals,Int8Array)),X.push(O.normals.buffer)),O.uvs){const t=O.uvs;O.uvs=qe.createTypedArray(t,Float32Array),X.push(O.uvs.buffer)}const U=function(t,e,n,r){const i={},o={},s=r.getLength();if(B(e.polygonFill)){let a=M(e.polygonFill);const l=new Uint8Array(4*s);l.fill(255);for(let e=0;e<s;e++){const o=t[r[e]],s=o.properties||{};s.$layer=o.layer,s.$type=o.type;let u=a(n,s);w(u)&&(i.aColor=1,a=M(u),u=a(n,s)),delete s.$layer,delete s.$type,ze.normalizeColor(Ze,u),l[4*e]=Ze[0],l[4*e+1]=Ze[1],l[4*e+2]=Ze[2],l[4*e+3]=Ze[3]}o.aColor=l}if(B(e.polygonOpacity)){let a=b(e.polygonOpacity,"exponential");const l=new Uint8Array(s);l.fill(255);for(let e=0;e<s;e++){const o=t[r[e]],s=o.properties||{};s.$layer=o.layer,s.$type=o.type;let u=a(n,s);w(u)&&(i.aOpacity=1,a=M(u),u=a(n,s)),delete s.$layer,delete s.$type,l[e]=255*u}o.aOpacity=l}return o.dynamicAttributes=i,o}(t,h,c,O.featureIndexes),R=function(t,e,n,r,i){const o=[[],[]],s=B(r.topPolygonFill),a=B(r.bottomPolygonFill),l=[255,255,255,255],u=e.getLength();if(s||a){let h=s&&M(r.topPolygonFill),c=a&&M(r.bottomPolygonFill),f=null,p=null,d=null,g=null;for(let r=0;r<u;r++){if(1===t[r]&&!s||0===t[r]&&!a)continue;const u=1===t[r];if(u&&e[r]===f){t[r]=d;continue}if(!u&&e[r]===p){t[r]=g;continue}const y=n[e[r]],x=y.properties||{};x.$layer=y.layer,x.$type=y.type;let m=u?h:c,v=m(i,x);w(v)&&(m=M(v),v=m(i,x)),delete x.$layer,delete x.$type,ze.normalizeColor(Ze,v),xt(Ze,Ze,l);let b=Ge(o,Ze);b<0&&(b=o.length,o.push(gt([],Ze))),t[r]=b,u?(f=e[r],d=b):(p=e[r],g=b)}}return o.slice(2)}(O.verticeTypes,O.featureIndexes,t,h,c),J={data:{data:{aVertexColorType:R.length<=252?qe.createTypedArray(O.verticeTypes,Uint8Array):qe.createTypedArray(O.verticeTypes,Uint16Array),aPosition:O.vertices,aNormal:O.normals,aTexCoord0:O.uvs,aTangent:O.tangents,aPickingId:O.pickingIds},indices:z,properties:{maxAltitude:O.maxAltitude/100,minAltitude:O.minAltitude/100,hasNegativeHeight:O.hasNegativeHeight},dynamicAttributes:U.dynamicAttributes,vertexColors:R},buffers:X};return O.featureIds.length?(J.data.featureIds=O.featureIds,X.push(J.data.featureIds.buffer)):J.data.featureIds=[],U.aColor&&(J.data.data.aColor=U.aColor,J.buffers.push(U.aColor.buffer)),U.aOpacity&&(J.data.data.aOpacity=U.aOpacity,J.buffers.push(U.aOpacity.buffer)),J.buffers.push(J.data.data.aPosition.buffer),J.data.pickingIdIndiceMap=$e.generatePickingIndiceIndex(J.data.data.aPickingId,J.data.indices),J}const Ze=[];function Ge(t,e){for(let i=0;i<t.length;i++)if(n=e,r=t[i],n[0]===r[0]&&n[1]===r[1]&&n[2]===r[2]&&n[3]===r[3])return i;var n,r;return-1}const{PackUtil:Ue,StyleUtil:Re,FilterUtil:Je}=ne();function He(t,e,n,r,{altitudeScale:i,altitudeProperty:o,defaultAltitude:s,heightProperty:a,minHeightProperty:l,defaultHeight:u,bottom:h}){const c=h,f=e/t[0].extent,p=2*function(t,e){let n=0;for(let e=0,r=t.length;e<r;e++){const r=t[e];if(S(r.geometry[0][0]))n+=3*r.geometry.length;else for(let t=0,e=r.geometry.length;t<e;t++){let e=3*r.geometry[t].length;3===r.type&&(e-=3),n+=e}}return n}(t)+3*t.length*2,d=[],g=new Int16Array(p),y=new Uint8Array(g.length/3*4);w(n)&&(n=Je.compileFilter(n));const x=[];function m(t,n,r){const i=n-t,o=g.subarray(t,n),s=g.subarray(n,n+i);s.set(o);for(let t=2,e=s.length;t<e;t+=3)s[t]=o[t]-r;const a=t/3,l=i/3;let u,h;for(let t=a,n=l+a;t<n;t++)t<n-1?(u=t,h=t+1):(u=t,h=a),ft(g,u,h,e)||(x.push(u,h),c&&x.push(u+l,h+l),We(g,u,e)||x.push(u,u+l));return n+i}let v=0,M=-1/0,b=1/0;const P=(te+"").trim(),_=[];for(let e=0,h=t.length;e<h;e++){const h=t[e],c=h.geometry;if(n){let t;t="function"==typeof n?n(h&&h.properties):n,Re.normalizeColor(_,t)}else dt(_,255,255,255);const p=v/3*4,{altitude:w,height:I}=Ue.getFeaAltitudeAndHeight(h,i,o,s,a,u,l);I<0?(b=Math.min(w,b),M=Math.max(w-I,M)):(b=Math.min(w-I,b),M=Math.max(w,M));let A=v;for(let t=0,e=c.length;t<e;t++){let e=c[t];const n=e.length;e[0][0]===e[n-1][0]&&e[0][1]===e[n-1][1]&&(e=e.slice(0,n-1)),v=ct(g,A,e,f,w),v=m(A,v,I*f),A=v}const S=A/3*4;for(let t=p;t<S;t+=4)y[t]=_[0],y[t+1]=_[1],y[t+2]=_[2],y[t+3]=255*(r||1);const F=x.length-d.length;for(let t=0;t<F;t++)d.push(h[P])}const I=x.reduce(((t,e)=>Math.max(t,e)),0),A=new(Ue.getIndexArrayType(I))(x),F=Ue.getUnsignedArrayType(t.length),T=Math.max(Math.abs(M,Math.abs(b)));return{aPosition:new(Ue.getPosArrayType(Math.max(512,T)))(g),indices:A,aPickingId:new F(d),aColor:y,maxAltitude:M===-1/0?0:M/100,minAltitude:b===1/0?0:b/100}}function We(t,e,n){const r=t[3*e],i=t[3*e+1];return r<0||r>n||i<0||i>n}function Ke(t,e,n,r){const i=He(t,e,n.lineColor,n.lineOpacity,r),{minAltitude:o,maxAltitude:s}=i;delete i.minAltitude,delete i.maxAltitude;const a=[i.aPosition.buffer,i.indices.buffer,i.aPickingId.buffer],l=i.indices;return delete i.indices,{data:{data:i,properties:{minAltitude:o,maxAltitude:s},indices:l},buffers:a}}\n/*!\n        Feature Filter by\n\n        (c) mapbox 2016 and maptalks 2018\n        www.mapbox.com | www.maptalks.org\n        License: MIT, header required.\n    */const Qe=["Unknown","Point","LineString","Polygon","MultiPoint","MultiLineString","MultiPolygon","GeometryCollection"];function tn(t){if(!t)return"true";const e=t[0];if(t.length<=1)return"any"===e?"false":"true";return\`(${$435bc7696844e930$var$E}"=="===e?nn(t[1],t[2],"===",!1):"!="===e?nn(t[1],t[2],"!==",!1):"<"===e||">"===e||"<="===e||">="===e?nn(t[1],t[2],e,!0):"any"===e?on(t.slice(1),"||"):"all"===e?on(t.slice(1),"&&"):"none"===e?ln(on(t.slice(1),"||")):"in"===e?sn(t[1],t.slice(2)):"!in"===e?ln(sn(t[1],t.slice(2))):"has"===e?an(t[1]):"!has"===e?ln(an(t[1])):"contains"===e?function(t,e,n){const r=en(t);return void 0!==n?\`(${$435bc7696844e930$var$E}r} + '').indexOf("${$435bc7696844e930$var$E}e}") === ${$435bc7696844e930$var$E}n}\`:\`(${$435bc7696844e930$var$E}r} + '').indexOf("${$435bc7696844e930$var$E}e}") >= 0\`}(t[1],t[2],t[3]):"true"})\`}function en(t){return"$"===t[0]?"f."+t.substring(1):"p["+JSON.stringify(t)+"]"}function nn(t,e,n,r){if("object"==typeof(i=t)&&i&&t.op)return function(t,e,n,r){const i=t.property,o=t.op;let s=en(i);return"length"!==o?(console.error(\`not support ${$435bc7696844e930$var$E}o} op\`),"false"):(s=\`((${$435bc7696844e930$var$E}s}+='').length)\`,rn(s,i,e,n,r))}(t,e,n,r);var i;return rn(en(t),t,e,n,r)}function rn(t,e,n,r,i){const o="$type"===e?Qe.indexOf(n):JSON.stringify(n);return(i?\`typeof ${$435bc7696844e930$var$E}t}=== typeof ${$435bc7696844e930$var$E}o}&&\`:"")+t+r+o}function on(t,e){return t.map(tn).join(e)}function sn(t,e){"$type"===t&&(e=e.map((t=>Qe.indexOf(t))));const n=JSON.stringify(e.sort(un)),r=en(t);return e.length<=200?\`${$435bc7696844e930$var$E}n}.indexOf(${$435bc7696844e930$var$E}r}) !== -1\`:\`function(v, a, i, j) {\\n        while (i <= j) { var m = (i + j) >> 1;\\n            if (a[m] === v) return true; if (a[m] > v) j = m - 1; else i = m + 1;\\n        }\\n    return false; }(${$435bc7696844e930$var$E}r}, ${$435bc7696844e930$var$E}n},0,${$435bc7696844e930$var$E}e.length-1})\`}function an(t){return"$id"===t?'"id" in f':\`${$435bc7696844e930$var$E}JSON.stringify(t)} in p\`}function ln(t){return\`!(${$435bc7696844e930$var$E}t})\`}function un(t,e){return t<e?-1:t>e?1:0}let hn=!1;try{const t=new OffscreenCanvas(1,1);t.getContext("2d").fillText("hello",0,0),hn=!0}catch(t){hn=!1}var cn=hn;const{VectorPack:fn,PolygonPack:pn,NativeLinePack:dn,LinePack:gn,PointPack:yn,NativePointPack:xn,LineExtrusionPack:mn,CirclePack:vn,RoundTubePack:wn,SquareTubePack:Mn,FilterUtil:bn,PackUtil:Pn,StyleUtil:_n,TextUtil:In,DEFAULT_TEX_WIDTH:An,GlyphRequestor:Sn}=ne(),Fn="__original_properties",Tn="__fn-type_properties";class kn{constructor(t,e,n,r,i){this.id=t,this.options=e,this.upload=n,this._compileStyle(e.style),this.requests={},this._cache=r,this._styleCounter=1,this.loadings=i}updateStyle(t,e){this.options.style=t,this._styleCounter=t.styleCounter,this._compileStyle(t),e()}updateOptions(t,e){this.options=I(this.options,t),e()}loadTile(t,e){const n=this.loadings,r=t.tileInfo.url,i=this.options.debugTile;if(i){const{x:n,y:r,z:o}=t.tileInfo;let s=!1;for(let t=0;t<i.length;t++)if(n===i[t].x&&r===i[t].y&&o===i[t].z){s=!0;break}if(!s)return void e()}if(n[r])return void n[r].push({context:t,callback:e,ref:this});n[r]=[{context:t,callback:e,ref:this}];const o=this.options.featureIdProperty;this.requests[r]=this.getTileFeatures(t,((e,i,s,a)=>{const l=n[r];if(delete n[r],this.checkIfCanceled(r))return delete this.requests[r],void this._callWaitings(l,null,{canceled:!0});if(delete this.requests[r],(this.options.debug||o)&&i)for(let e=0;e<i.length;e++)if(this.options.debug&&(i[e]._debug_info={index:e,id:i[e].id,tileId:t.tileInfo.id}),o){const t=T(o)?o[i[e].layer]:o,n=i[e].properties;i[e].id=n&&n[t]||null}if(e)this._callWaitings(l,e);else if(i&&i.length){if(l)for(let t=0;t<l.length;t++)this._onTileLoad.call(l[t].ref,l[t].context,l[t].callback,r,s,i,a)}else this._callWaitings(l)}))}_onTileLoad(t,e,n,r,i,o){this._createTileData(r,i,t).then((n=>{n.canceled?e(null,{canceled:!0}):(n.data.styleCounter=t.styleCounter,o&&I(n.data,o),e(null,n.data,n.buffers))})).catch((t=>{e(t)}))}abortTile(t,e){delete this.requests[t],this._cancelLoadings(t),e()}_cancelLoadings(t){const e=this.loadings[t];if(e)for(let t=0;t<e.length;t++)e[t].callback(null,{canceled:!0});delete this.loadings[t]}_callWaitings(t,e,n){if(t)for(let r=0;r<t.length;r++)t[r].callback(e,n)}checkIfCanceled(t){return!this.requests[t]}onRemove(){this.loadings={},delete this._cache,this.requests={}}fetchIconGlyphs(t,e,n){if(this.options.workerGlyph&&cn){const r=[];if(t&&Object.keys(t).length){const e=new Promise((e=>{this.upload("fetchIconGlyphs",{icons:t},null,((t,n)=>{e({err:t,iconData:n})}))}));r.push(e)}if(e&&Object.keys(e).length){const t=new Promise((t=>{this._glyphRequestor||(this._glyphRequestor=new Sn),this._glyphRequestor.getGlyphs(e,((e,n)=>{t({err:e,glyphData:n})}))}));r.push(t)}Promise.all(r).then((t=>{const e={icons:null,glyphs:null};for(let r=0;r<t.length;r++){if(t[r].err)return void n(t[r].err);t[r].iconData?e.icons=t[r].iconData.icons:t[r].glyphData&&(e.glyphs=t[r].glyphData.glyphs)}return e})).then((t=>{n(null,t)}))}else this.upload("fetchIconGlyphs",{icons:t,glyphs:e},null,n)}_createTileData(t,e,n){if(!e.length)return Promise.resolve({data:null,buffers:[]});const{glScale:r,tileInfo:i}=n,o=!this.options.style.style.length&&!this.options.style.featureStyle.length;let s=this.pluginConfig.slice(0);o&&(s=this._updateLayerPluginConfig(t)),this.featurePlugins&&function(t){for(let e=1;e<arguments.length;e++){const n=arguments[e];if(n)for(let e=0,r=n.length;e<r;e++)t.push(n[e])}t.length}(s,this.featurePlugins);const a={};for(let t=0;t<s.length;t++)Xn(e,n.tileInfo.z,s[t],a);const l=[],u=[];for(let t=0;t<e.length;t++){const n=e[t],r=a[t];if(r){u.fill(null);let t=0;for(const e in r){let i=0;const o=r[e].values();for(const t of o){let r=u[i];r||(r=$n(n),u[i]=r),r.properties[e]=t,i++}i>t&&(t=i)}for(let e=0;e<t;e++)l.push(u[e])}else l.push(n)}const h=(e=l)[0].extent,c=i.z,f={x:i.extent2d.xmin*r,y:i.extent2d.ymax*r},p=[],d=[],g=[],y=this.options,x=[],m={},v=[Promise.resolve(n.styleCounter)];let w=0,M=-1;const b=[];let P=!1;for(let t=0;t<s.length;t++){M++;const r=s[t];r.type!==w&&(M=0,w=r.type);const a=0===r.type?p:d;if(r.symbol&&!1===r.symbol.visible){a[M]=null;continue}jn(r.symbol,b,t),P=P||b[t]&&b[t].size>0;const{tileFeatures:l,tileFeaIndexes:u}=this._filterFeatures(c,r.type,r.filter,e,m,t);if(!l.length){a[M]=null;continue}const y=u[u.length-1],_=Pn.getIndexArrayType(y);a[M]={styledFeatures:new _(u)},g.push({idx:t,typeIdx:M}),x.push(a[M].styledFeatures.buffer);const A=I({},n,{extent:h,zoom:c,tilePoint:f});if(this.options.debugTile){const t=this.options.debugTile;for(let e=0;e<t.length;e++){const{x:n,y:r,z:o}=t[e];if(i.x===n&&i.y===r&&i.z===o){A.debugIndex=t[e].index;break}}}let S=this._createTileGeometry(l,r,A);o&&(S=S.then((t=>{if(!t)return null;if(t.data)t.data.layer=l[0].layer;else if(Array.isArray(t))for(let e=0;e<t.length;e++)t[e]&&t[e].data&&(t[e].data.layer=l[0].layer);return t}))),v.push(S)}return Promise.all(v).then((([n,...r])=>{if(n!==this._styleCounter)return{canceled:!0};function i(t,e){if(void 0!==t.data.ref)return;const n=s[g[e].idx],r=n.renderPlugin.dataConfig;if(t.data.type=r.type,t.data.filter=n.filter.def,r.altitudeOffset&&(t.data.properties.minAltitude+=r.altitudeOffset,t.data.properties.maxAltitude+=r.altitudeOffset),t.buffers&&t.buffers.length)for(let e=0;e<t.buffers.length;e++)x.push(t.buffers[e])}for(let t=0;t<r.length;t++){if(!r[t])continue;const e=r[t],n=0===s[g[t].idx].type?p:d;if(Array.isArray(e)){const r=[];for(let n=0;n<e.length;n++)e[n]&&(i(e[n],t),(void 0===e[n].data.ref||e[e[n].data.ref])&&r.push(e[n].data));r.length&&(n[g[t].typeIdx].data=r)}else i(e,t),n[g[t].typeIdx].data=e.data}const o={},a=t;if(y.features||y.schema||P){let t,n=!1;for(let r=0,i=e.length;r<i;r++)if(t=e[r],a[t.layer].properties||(a[t.layer].properties=Cn(t.properties)),t&&(y.features||P&&m[r]))if("id"===y.features)o[r]=t.id;else{y.pickingGeometry||delete t.geometry,delete t.extent,delete t.properties.$layer,delete t.properties.$type,delete t.__index;const e=t.originalFeature;if(e){const e=t.properties,n=I({},t.originalFeature);delete e[Fn],n.customProps=I({},e),t=n}const i=I({},t);if(P&&m[r]&&(!y.features||"transient"===y.features)){const i=m[r];for(let r=0;r<i.length;r++){const i=b[r];i&&i.forEach((r=>{const i=e?e.properties:t.properties;i[Tn]||(i[Tn]=new Set),i[Tn].add(r),n=!0}))}}o[r]=i}if(n)for(const t in o){const e=o[t],n=e.properties[Tn];if(n){delete e.properties[Tn],"transient"===y.features&&(e.fnTypeProps=I({},e.properties));for(const t in e.properties)n.has(t)||("transient"===y.features?delete e.fnTypeProps[t]:delete e.properties[t])}}}return{data:{styleCounter:n,schema:a,data:p,featureData:d,extent:h,features:o},buffers:x}})).catch((t=>{console.error(t)}))}_createTileGeometry(t,e,n){let r=t;const i=e.renderPlugin.dataConfig,o=e.symbol,s=this.options.tileSize,{extent:a,glScale:l,zScale:u,zoom:h,tilePoint:c,centimeterToPoint:f,verticalCentimeterToPoint:p}=n,d=a/s,g=i.type,y=n.debugIndex;let x=I({},i,{EXTENT:a,zoom:h,debugIndex:y,features:this.options.features});if("3d-extrusion"===g){Yn(o)&&(i.uv=1);const t=this.options.projectionCode,e=o.material&&o.material.textureWidth||An;return Promise.all([Promise.resolve(je(r,i,a,c,e,n.tileInfo.res,l,a/this.options.tileSize,f,p,o,h,t,y))])}if("3d-wireframe"===g)return Promise.all([Promise.resolve(Ke(r,a,o,i))]);if("point"===g){x=I(x,{requestor:this.fetchIconGlyphs.bind(this),altitudeToTileScale:u*a/this.options.tileSize/l,pluginType:e.renderPlugin.type});let t=o;return Array.isArray(o)||(t=[o]),t=t.map(((t,e)=>(t&&(t.index={index:e},t.isIconText=function(t){return t.markerType||t.markerFile}(t)),t))).filter((t=>!!t)),Promise.all(t.map((t=>{const e=fn.genFnTypes(t);let n=r;return yn.needMerge(t,e,h)&&(n=yn.mergeLineFeatures(r,t,e,h)),new yn(n,t,x).load(d)})))}if("native-point"===g){const t=u*a/this.options.tileSize/l;return x.altitudeToTileScale=t,Vn(r,o,x,xn,d)}if("line"===g)return x=I(x,{requestor:this.fetchIconGlyphs.bind(this),tileRatio:d}),Vn(r,o,x,gn,1,!0);if("native-line"===g)return Vn(r,o,x,dn,1,!0);if("fill"===g)return x=I(x,{requestor:this.fetchIconGlyphs.bind(this)}),Vn(r,o,x,pn);if("line-extrusion"===g){delete o.lineGradientProperty,o.lineJoin="miter",o.lineCap="butt";const t=Yn(o);if(t&&(i.uv=1),x=I(x,{tileSize:s,zScale:u,glScale:l}),o.mergeOnProperty){const t=fn.genFnTypes(o);r=gn.mergeLineFeatures(r,o,t,x.zoom)}if(t){const t=[];if(!1!==i.top){const e=I({},x);e.side=!1,t.push(new mn(r,o,e))}return!1!==i.side&&(x.side=!0,x.top=!1,t.push(new mn(r,o,x))),Promise.all(t.map((t=>t.load())))}return Promise.all([new mn(r,o,x).load()])}if("circle"===g)return Vn(r,o,x,vn);if("round-tube"===g||"square-tube"===g){const t="round-tube"===g?wn:Mn;return x=I(x,{requestor:this.fetchIconGlyphs.bind(this),radialSegments:"round-tube"===g?i.radialSegments||8:4,centimeterToPoint:f,verticalCentimeterToPoint:p,tileRatio:d,isTube:!0}),Vn(r,o,x,t)}return Promise.resolve([])}_filterFeatures(t,e,n,r,i,o){const s=(te+"").trim(),a=[],l=[],u=r.length;for(let h=0;h<u;h++)if((1===e||void 0===r[h].id||!this.styledFeatures[r[h].id])&&((!n.def||"default"===n.def)&&!i[h]||!0===n.def||n.def&&(void 0!==n.def.condition||Array.isArray(n.def))&&n(r[h],t))){const t=r[h];if(void 0===t[s]&&(t[s]=h),i[h]||(i[h]=[]),i[h].push(o),l.push(t),a.push(h),1===e)break}return{tileFeatures:l,tileFeaIndexes:a}}_compileStyle(t){const{style:e,featureStyle:n}=t,r={};n.forEach((t=>{Array.isArray(t.id)?(t.id.forEach((t=>{r[t]=1})),t.filter=["in","$id",...t.id]):(r[t.id]=1,t.filter=["==","$id",t.id])}));const i=bn.compileStyle(e);for(let t=0;t<e.length;t++)i[t].filter&&(i[t].filter.def=e[t].filter?e[t].filter.value||e[t].filter:void 0),i[t].type=0;const o=[],s=bn.compileStyle(n);for(let t=0;t<n.length;t++)s[t].type=1,s[t].filter.def=n[t].filter?n[t].filter.value||n[t].filter:void 0,s[t].renderPlugin&&o.push(s[t]);this.pluginConfig=i,this.featurePlugins=o,this.styledFeatures=r}_updateLayerPluginConfig(t){let e=this._layerPlugins;this._layerPlugins||(e=this._layerPlugins={});const n=["","Point","LineString","Polygon","MultiPoint","MultiLineString","MultiPolygon"],r=[];for(const o in t){const s=o;if(!e[o]){const r=[];for(let e=0;e<t[o].types.length;e++){const a=t[o].types[e],l=["all",["==","$layer",s],["==","$type",n[a]]],u={filter:(i=l,new Function("f",\`var p = (f && f.properties || {}); return ${$435bc7696844e930$var$E}tn(i)}\`)),renderPlugin:Bn(a),symbol:Ln(a)};u.filter.def=l,u.type=0,r.push(u)}e[s]=r}r.push(...e[s])}var i;return r}}function Bn(t){switch(t){case 1:return{type:"native-point",dataConfig:{type:"native-point",only2D:!0}};case 2:return{type:"native-line",dataConfig:{type:"native-line",only2D:!0}};case 3:return{type:"fill",dataConfig:{type:"fill",only2D:!0}}}return null}function Ln(t){switch(t){case 1:return{markerFill:"#f00",markerSize:10};case 2:return{lineColor:"#fff"};case 3:return{polygonFill:"#00f",polygonOpacity:.4}}return null}function Cn(t){if(Array.isArray(t)||!T(t))return{};const e={};for(const n in t){const r=t[n];A(r)?e[n]="string":S(r)?e[n]="number":!0===r||!1===r?e[n]="boolean":Array.isArray(r)?e[n]="array":e[n]="object"}return e}function Yn(t){if(!t)return 0;let e=0;for(const n in t){if(("normalTexture"===n||"bumpTexture"===n)&&t[n])return 2;if(n.indexOf("Texture")>0&&t[n])e=1;else if(T(t[n])){const r=Yn(t[n]);if(2===r)return r;1===r&&(e=1)}}return e}function Vn(t,e,n,r,i,o){const s={},a=Array.isArray(e)?e:[e];let l=-1;for(let t=0;t<a.length;t++)s[t]=On(a[t]),!s[t]&&a[t]&&-1===l&&(l=t);const u=[];for(let e=0;e<a.length;e++){if(!a[e])continue;a[e].index={index:e};let h=t;if(o&&a[e].mergeOnProperty){const r=fn.genFnTypes(a[e]);h=gn.mergeLineFeatures(t,a[0],r,n.zoom)}s[e]||e===l?u.push(new r(h,a[e],n).load(i)):u.push({data:{ref:l,symbolIndex:{index:e}}})}return Promise.all(u)}function On(t){if(!t)return 0;for(const e in t)if(B(t[e]))return 1;return 0}function Xn(t,e,n,r){const i=n.customProperties;if(!i)return t;if(i)for(let t=0;t<i.length;t++)i[t].fn=bn.compileFilter(i[t].filter);for(let n=0;n<i.length;n++)for(let o=0,s=t.length;o<s;o++)if(i[n].fn(t[o],e))for(const t in i[n].properties){const e=i[n].properties[t];k(e)||(r[o]||(r[o]={}),r[o][t]||(r[o][t]=new Set),r[o][t].add(e))}}const Nn={get:(t,e)=>e in t?t[e]:t.originalFeature[e],has:(t,e)=>e in t||e in t.originalFeature},En={get:function(t,e){return e in t?t[e]:t[Fn][e]},has:(t,e)=>e in t||e in t[Fn]},zn={};function $n(t){const e={};e.originalFeature=t;const n=new Proxy(e,Nn);return n.properties=new Proxy({},En),n.properties[Fn]=t.properties||zn,n}function qn(t,e,n){t[e]||(t[e]=new Set),t[e].add(n)}const Dn=[];function jn(t,e,n){if(!t)return Dn;for(const r in t){if(!t[r]||!_n.checkIfZoomFnTypeSymbol(r))continue;if(B(t[r]))qn(e,n,t[r].property);else{if("lineGradientProperty"===r){qn(e,n,t[r]);continue}if("textName"===r)if(A(t[r])){const i=In.resolveVarNames(t[r]);if(i)for(let t=0;t<i.length;t++)qn(e,n,i[t])}else if(bn.isExpression(t[r])){const i=[];In.resolveExpVarNames(i,t[r]);for(let t=0;t<i.length;t++)qn(e,n,i[t])}}const i=t[r].stops;if(i&&i.length)for(let t=0;t<i.length;t++)B(i[t][1])&&qn(e,t,i[t][1].property)}return e[n]}function Zn(t,e){Gn(t.geometry,e)}function Gn(t,e){if(t)switch(t.type){case"Point":Un(t.coordinates,e);break;case"MultiPoint":case"LineString":Rn(t.coordinates,e);break;case"MultiLineString":!function(t,e){for(let n=0,r=t.length;n<r;n++)Rn(t[n],e)}(t.coordinates,e);break;case"Polygon":Jn(t.coordinates,e);break;case"MultiPolygon":!function(t,e){for(let n=0,r=t.length;n<r;n++)Jn(t[n],e)}(t.coordinates,e);break;case"GeometryCollection":const n=t.geometries.length;for(let r=0;r<n;r++)Gn(t.geometries[r],e)}}function Un(t,e){e[0]=Math.min(e[0],t[0]),e[1]=Math.min(e[1],t[1]),e[2]=Math.max(e[2],t[0]),e[3]=Math.max(e[3],t[1])}function Rn(t,e){for(let n=0,r=t.length;n<r;n++)Un(t[n],e)}function Jn(t,e){t.length&&Rn(t[0],e)}function Hn(t,e,n,r,i){Wn(t,e,n||0,r||t.length-1,i||Qn)}function Wn(t,e,n,r,i){for(;r>n;){if(r-n>600){var o=r-n+1,s=e-n+1,a=Math.log(o),l=.5*Math.exp(2*a/3),u=.5*Math.sqrt(a*l*(o-l)/o)*(s-o/2<0?-1:1);Wn(t,e,Math.max(n,Math.floor(e-s*l/o+u)),Math.min(r,Math.floor(e+(o-s)*l/o+u)),i)}var h=t[e],c=n,f=r;for(Kn(t,n,e),i(t[r],h)>0&&Kn(t,n,r);c<f;){for(Kn(t,c,f),c++,f--;i(t[c],h)<0;)c++;for(;i(t[f],h)>0;)f--}0===i(t[n],h)?Kn(t,n,f):Kn(t,++f,r),f<=e&&(n=f+1),e<=f&&(r=f-1)}}function Kn(t,e,n){var r=t[e];t[e]=t[n],t[n]=r}function Qn(t,e){return t<e?-1:t>e?1:0}class tr{constructor(t=9){this._maxEntries=Math.max(4,t),this._minEntries=Math.max(2,Math.ceil(.4*this._maxEntries)),this.clear()}all(){return this._all(this.data,[])}search(t){let e=this.data;const n=[];if(!cr(t,e))return n;const r=this.toBBox,i=[];for(;e;){for(let o=0;o<e.children.length;o++){const s=e.children[o],a=e.leaf?r(s):s;cr(t,a)&&(e.leaf?n.push(s):hr(t,a)?this._all(s,n):i.push(s))}e=i.pop()}return n}collides(t){let e=this.data;if(!cr(t,e))return!1;const n=[];for(;e;){for(let r=0;r<e.children.length;r++){const i=e.children[r],o=e.leaf?this.toBBox(i):i;if(cr(t,o)){if(e.leaf||hr(t,o))return!0;n.push(i)}}e=n.pop()}return!1}load(t){if(!t||!t.length)return this;if(t.length<this._minEntries){for(let e=0;e<t.length;e++)this.insert(t[e]);return this}let e=this._build(t.slice(),0,t.length-1,0);if(this.data.children.length)if(this.data.height===e.height)this._splitRoot(this.data,e);else{if(this.data.height<e.height){const t=this.data;this.data=e,e=t}this._insert(e,this.data.height-e.height-1,!0)}else this.data=e;return this}insert(t){return t&&this._insert(t,this.data.height-1),this}clear(){return this.data=fr([]),this}remove(t,e){if(!t)return this;let n=this.data;const r=this.toBBox(t),i=[],o=[];let s,a,l;for(;n||i.length;){if(n||(n=i.pop(),a=i[i.length-1],s=o.pop(),l=!0),n.leaf){const r=er(t,n.children,e);if(-1!==r)return n.children.splice(r,1),i.push(n),this._condense(i),this}l||n.leaf||!hr(n,r)?a?(s++,n=a.children[s],l=!1):n=null:(i.push(n),o.push(s),s=0,a=n,n=n.children[0])}return this}toBBox(t){return t}compareMinX(t,e){return t.minX-e.minX}compareMinY(t,e){return t.minY-e.minY}toJSON(){return this.data}fromJSON(t){return this.data=t,this}_all(t,e){const n=[];for(;t;)t.leaf?e.push(...t.children):n.push(...t.children),t=n.pop();return e}_build(t,e,n,r){const i=n-e+1;let o,s=this._maxEntries;if(i<=s)return o=fr(t.slice(e,n+1)),nr(o,this.toBBox),o;r||(r=Math.ceil(Math.log(i)/Math.log(s)),s=Math.ceil(i/Math.pow(s,r-1))),o=fr([]),o.leaf=!1,o.height=r;const a=Math.ceil(i/s),l=a*Math.ceil(Math.sqrt(s));pr(t,e,n,l,this.compareMinX);for(let i=e;i<=n;i+=l){const e=Math.min(i+l-1,n);pr(t,i,e,a,this.compareMinY);for(let n=i;n<=e;n+=a){const i=Math.min(n+a-1,e);o.children.push(this._build(t,n,i,r-1))}}return nr(o,this.toBBox),o}_chooseSubtree(t,e,n,r){for(;r.push(e),!e.leaf&&r.length-1!==n;){let n,r=1/0,s=1/0;for(let a=0;a<e.children.length;a++){const l=e.children[a],u=ar(l),h=(i=t,o=l,(Math.max(o.maxX,i.maxX)-Math.min(o.minX,i.minX))*(Math.max(o.maxY,i.maxY)-Math.min(o.minY,i.minY))-u);h<s?(s=h,r=u<r?u:r,n=l):h===s&&u<r&&(r=u,n=l)}e=n||e.children[0]}var i,o;return e}_insert(t,e,n){const r=n?t:this.toBBox(t),i=[],o=this._chooseSubtree(r,this.data,e,i);for(o.children.push(t),ir(o,r);e>=0&&i[e].children.length>this._maxEntries;)this._split(i,e),e--;this._adjustParentBBoxes(r,i,e)}_split(t,e){const n=t[e],r=n.children.length,i=this._minEntries;this._chooseSplitAxis(n,i,r);const o=this._chooseSplitIndex(n,i,r),s=fr(n.children.splice(o,n.children.length-o));s.height=n.height,s.leaf=n.leaf,nr(n,this.toBBox),nr(s,this.toBBox),e?t[e-1].children.push(s):this._splitRoot(n,s)}_splitRoot(t,e){this.data=fr([t,e]),this.data.height=t.height+1,this.data.leaf=!1,nr(this.data,this.toBBox)}_chooseSplitIndex(t,e,n){let r,i=1/0,o=1/0;for(let s=e;s<=n-e;s++){const e=rr(t,0,s,this.toBBox),a=rr(t,s,n,this.toBBox),l=ur(e,a),u=ar(e)+ar(a);l<i?(i=l,r=s,o=u<o?u:o):l===i&&u<o&&(o=u,r=s)}return r||n-e}_chooseSplitAxis(t,e,n){const r=t.leaf?this.compareMinX:or,i=t.leaf?this.compareMinY:sr;this._allDistMargin(t,e,n,r)<this._allDistMargin(t,e,n,i)&&t.children.sort(r)}_allDistMargin(t,e,n,r){t.children.sort(r);const i=this.toBBox,o=rr(t,0,e,i),s=rr(t,n-e,n,i);let a=lr(o)+lr(s);for(let r=e;r<n-e;r++){const e=t.children[r];ir(o,t.leaf?i(e):e),a+=lr(o)}for(let r=n-e-1;r>=e;r--){const e=t.children[r];ir(s,t.leaf?i(e):e),a+=lr(s)}return a}_adjustParentBBoxes(t,e,n){for(let r=n;r>=0;r--)ir(e[r],t)}_condense(t){for(let e,n=t.length-1;n>=0;n--)0===t[n].children.length?n>0?(e=t[n-1].children,e.splice(e.indexOf(t[n]),1)):this.clear():nr(t[n],this.toBBox)}}function er(t,e,n){if(!n)return e.indexOf(t);for(let r=0;r<e.length;r++)if(n(t,e[r]))return r;return-1}function nr(t,e){rr(t,0,t.children.length,e,t)}function rr(t,e,n,r,i){i||(i=fr(null)),i.minX=1/0,i.minY=1/0,i.maxX=-1/0,i.maxY=-1/0;for(let o=e;o<n;o++){const e=t.children[o];ir(i,t.leaf?r(e):e)}return i}function ir(t,e){return t.minX=Math.min(t.minX,e.minX),t.minY=Math.min(t.minY,e.minY),t.maxX=Math.max(t.maxX,e.maxX),t.maxY=Math.max(t.maxY,e.maxY),t}function or(t,e){return t.minX-e.minX}function sr(t,e){return t.minY-e.minY}function ar(t){return(t.maxX-t.minX)*(t.maxY-t.minY)}function lr(t){return t.maxX-t.minX+(t.maxY-t.minY)}function ur(t,e){const n=Math.max(t.minX,e.minX),r=Math.max(t.minY,e.minY),i=Math.min(t.maxX,e.maxX),o=Math.min(t.maxY,e.maxY);return Math.max(0,i-n)*Math.max(0,o-r)}function hr(t,e){return t.minX<=e.minX&&t.minY<=e.minY&&e.maxX<=t.maxX&&e.maxY<=t.maxY}function cr(t,e){return e.minX<=t.maxX&&e.minY<=t.maxY&&e.maxX>=t.minX&&e.maxY>=t.minY}function fr(t){return{children:t,height:1,leaf:!0,minX:1/0,minY:1/0,maxX:-1/0,maxY:-1/0}}function pr(t,e,n,r,i){const o=[e,n];for(;o.length;){if((n=o.pop())-(e=o.pop())<=r)continue;const s=e+Math.ceil((n-e)/r/2)*r;Hn(t,s,e,n,i),o.push(e,s,s,n)}}class dr{constructor(t=[],e=gr){if(this.data=t,this.length=this.data.length,this.compare=e,this.length>0)for(let t=(this.length>>1)-1;t>=0;t--)this._down(t)}push(t){this.data.push(t),this.length++,this._up(this.length-1)}pop(){if(0===this.length)return;const t=this.data[0],e=this.data.pop();return this.length--,this.length>0&&(this.data[0]=e,this._down(0)),t}peek(){return this.data[0]}_up(t){const{data:e,compare:n}=this,r=e[t];for(;t>0;){const i=t-1>>1,o=e[i];if(n(r,o)>=0)break;e[t]=o,t=i}e[t]=r}_down(t){const{data:e,compare:n}=this,r=this.length>>1,i=e[t];for(;t<r;){let r=1+(t<<1),o=e[r];const s=r+1;if(s<this.length&&n(e[s],o)<0&&(r=s,o=e[s]),n(o,i)>=0)break;e[t]=o,t=r}e[t]=i}}function gr(t,e){return t<e?-1:t>e?1:0}function yr(t){return t&&t.__esModule&&Object.prototype.hasOwnProperty.call(t,"default")?t.default:t}var xr={exports:{}},mr=function(t,e,n,r){var i=t[0],o=t[1],s=!1;void 0===n&&(n=0),void 0===r&&(r=e.length);for(var a=(r-n)/2,l=0,u=a-1;l<a;u=l++){var h=e[n+2*l+0],c=e[n+2*l+1],f=e[n+2*u+0],p=e[n+2*u+1];c>o!=p>o&&i<(f-h)*(o-c)/(p-c)+h&&(s=!s)}return s},vr=function(t,e,n,r){var i=t[0],o=t[1],s=!1;void 0===n&&(n=0),void 0===r&&(r=e.length);for(var a=r-n,l=0,u=a-1;l<a;u=l++){var h=e[l+n][0],c=e[l+n][1],f=e[u+n][0],p=e[u+n][1];c>o!=p>o&&i<(f-h)*(o-c)/(p-c)+h&&(s=!s)}return s};xr.exports=function(t,e,n,r){return e.length>0&&Array.isArray(e[0])?vr(t,e,n,r):mr(t,e,n,r)};var wr=xr.exports.nested=vr;xr.exports.flat=mr;const Mr=11102230246251565e-32,br=134217729,Pr=(3+8*Mr)*Mr;function _r(t,e,n,r,i){let o,s,a,l,u=e[0],h=r[0],c=0,f=0;h>u==h>-u?(o=u,u=e[++c]):(o=h,h=r[++f]);let p=0;if(c<t&&f<n)for(h>u==h>-u?(s=u+o,a=o-(s-u),u=e[++c]):(s=h+o,a=o-(s-h),h=r[++f]),o=s,0!==a&&(i[p++]=a);c<t&&f<n;)h>u==h>-u?(s=o+u,l=s-o,a=o-(s-l)+(u-l),u=e[++c]):(s=o+h,l=s-o,a=o-(s-l)+(h-l),h=r[++f]),o=s,0!==a&&(i[p++]=a);for(;c<t;)s=o+u,l=s-o,a=o-(s-l)+(u-l),u=e[++c],o=s,0!==a&&(i[p++]=a);for(;f<n;)s=o+h,l=s-o,a=o-(s-l)+(h-l),h=r[++f],o=s,0!==a&&(i[p++]=a);return 0===o&&0!==p||(i[p++]=o),p}function Ir(t){return new Float64Array(t)}const Ar=33306690738754716e-32,Sr=22204460492503146e-32,Fr=11093356479670487e-47,Tr=Ir(4),kr=Ir(8),Br=Ir(12),Lr=Ir(16),Cr=Ir(4);function Yr(t,e,n,r,i,o){const s=(e-o)*(n-i),a=(t-i)*(r-o),l=s-a;if(0===s||0===a||s>0!=a>0)return l;const u=Math.abs(s+a);return Math.abs(l)>=Ar*u?l:-function(t,e,n,r,i,o,s){let a,l,u,h,c,f,p,d,g,y,x,m,v,w,M,b,P,_;const I=t-i,A=n-i,S=e-o,F=r-o;w=I*F,f=br*I,p=f-(f-I),d=I-p,f=br*F,g=f-(f-F),y=F-g,M=d*y-(w-p*g-d*g-p*y),b=S*A,f=br*S,p=f-(f-S),d=S-p,f=br*A,g=f-(f-A),y=A-g,P=d*y-(b-p*g-d*g-p*y),x=M-P,c=M-x,Tr[0]=M-(x+c)+(c-P),m=w+x,c=m-w,v=w-(m-c)+(x-c),x=v-b,c=v-x,Tr[1]=v-(x+c)+(c-b),_=m+x,c=_-m,Tr[2]=m-(_-c)+(x-c),Tr[3]=_;let T=function(t,e){let n=e[0];for(let r=1;r<t;r++)n+=e[r];return n}(4,Tr),k=Sr*s;if(T>=k||-T>=k)return T;if(c=t-I,a=t-(I+c)+(c-i),c=n-A,u=n-(A+c)+(c-i),c=e-S,l=e-(S+c)+(c-o),c=r-F,h=r-(F+c)+(c-o),0===a&&0===l&&0===u&&0===h)return T;if(k=Fr*s+Pr*Math.abs(T),T+=I*h+F*a-(S*u+A*l),T>=k||-T>=k)return T;w=a*F,f=br*a,p=f-(f-a),d=a-p,f=br*F,g=f-(f-F),y=F-g,M=d*y-(w-p*g-d*g-p*y),b=l*A,f=br*l,p=f-(f-l),d=l-p,f=br*A,g=f-(f-A),y=A-g,P=d*y-(b-p*g-d*g-p*y),x=M-P,c=M-x,Cr[0]=M-(x+c)+(c-P),m=w+x,c=m-w,v=w-(m-c)+(x-c),x=v-b,c=v-x,Cr[1]=v-(x+c)+(c-b),_=m+x,c=_-m,Cr[2]=m-(_-c)+(x-c),Cr[3]=_;const B=_r(4,Tr,4,Cr,kr);w=I*h,f=br*I,p=f-(f-I),d=I-p,f=br*h,g=f-(f-h),y=h-g,M=d*y-(w-p*g-d*g-p*y),b=S*u,f=br*S,p=f-(f-S),d=S-p,f=br*u,g=f-(f-u),y=u-g,P=d*y-(b-p*g-d*g-p*y),x=M-P,c=M-x,Cr[0]=M-(x+c)+(c-P),m=w+x,c=m-w,v=w-(m-c)+(x-c),x=v-b,c=v-x,Cr[1]=v-(x+c)+(c-b),_=m+x,c=_-m,Cr[2]=m-(_-c)+(x-c),Cr[3]=_;const L=_r(B,kr,4,Cr,Br);w=a*h,f=br*a,p=f-(f-a),d=a-p,f=br*h,g=f-(f-h),y=h-g,M=d*y-(w-p*g-d*g-p*y),b=l*u,f=br*l,p=f-(f-l),d=l-p,f=br*u,g=f-(f-u),y=u-g,P=d*y-(b-p*g-d*g-p*y),x=M-P,c=M-x,Cr[0]=M-(x+c)+(c-P),m=w+x,c=m-w,v=w-(m-c)+(x-c),x=v-b,c=v-x,Cr[1]=v-(x+c)+(c-b),_=m+x,c=_-m,Cr[2]=m-(_-c)+(x-c),Cr[3]=_;const C=_r(L,Br,4,Cr,Lr);return Lr[C-1]}(t,e,n,r,i,o,u)}function Vr(t,e,n){e=Math.max(0,void 0===e?2:e),n=n||0;var r=function(t){for(var e=t[0],n=t[0],r=t[0],i=t[0],o=0;o<t.length;o++){var s=t[o];s[0]<e[0]&&(e=s),s[0]>r[0]&&(r=s),s[1]<n[1]&&(n=s),s[1]>i[1]&&(i=s)}var a=[e,n,r,i],l=a.slice();for(o=0;o<t.length;o++)wr(t[o],a)||l.push(t[o]);return function(t){t.sort(Ur);for(var e=[],n=0;n<t.length;n++){for(;e.length>=2&&$r(e[e.length-2],e[e.length-1],t[n])<=0;)e.pop();e.push(t[n])}for(var r=[],i=t.length-1;i>=0;i--){for(;r.length>=2&&$r(r[r.length-2],r[r.length-1],t[i])<=0;)r.pop();r.push(t[i])}return r.pop(),e.pop(),e.concat(r)}(l)}(t),i=new tr(16);i.toBBox=function(t){return{minX:t[0],minY:t[1],maxX:t[0],maxY:t[1]}},i.compareMinX=function(t,e){return t[0]-e[0]},i.compareMinY=function(t,e){return t[1]-e[1]},i.load(t);for(var o,s=[],a=0;a<r.length;a++){var l=r[a];i.remove(l),o=Dr(l,o),s.push(o)}var u=new tr(16);for(a=0;a<s.length;a++)u.insert(qr(s[a]));for(var h=e*e,c=n*n;s.length;){var f=s.shift(),p=f.p,d=f.next.p,g=jr(p,d);if(!(g<c)){var y=g/h;(l=Or(i,f.prev.p,p,d,f.next.next.p,y,u))&&Math.min(jr(l,p),jr(l,d))<=y&&(s.push(f),s.push(Dr(l,f)),i.remove(l),u.remove(f),u.insert(qr(f)),u.insert(qr(f.next)))}}f=o;var x=[];do{x.push(f.p),f=f.next}while(f!==o);return x.push(f.p),x}function Or(t,e,n,r,i,o,s){for(var a=new dr([],Xr),l=t.data;l;){for(var u=0;u<l.children.length;u++){var h=l.children[u],c=l.leaf?Zr(h,n,r):Nr(n,r,h);c>o||a.push({node:h,dist:c})}for(;a.length&&!a.peek().node.children;){var f=a.pop(),p=f.node,d=Zr(p,e,n),g=Zr(p,r,i);if(f.dist<d&&f.dist<g&&zr(n,p,s)&&zr(r,p,s))return p}(l=a.pop())&&(l=l.node)}return null}function Xr(t,e){return t.dist-e.dist}function Nr(t,e,n){if(Er(t,n)||Er(e,n))return 0;var r=Gr(t[0],t[1],e[0],e[1],n.minX,n.minY,n.maxX,n.minY);if(0===r)return 0;var i=Gr(t[0],t[1],e[0],e[1],n.minX,n.minY,n.minX,n.maxY);if(0===i)return 0;var o=Gr(t[0],t[1],e[0],e[1],n.maxX,n.minY,n.maxX,n.maxY);if(0===o)return 0;var s=Gr(t[0],t[1],e[0],e[1],n.minX,n.maxY,n.maxX,n.maxY);return 0===s?0:Math.min(r,i,o,s)}function Er(t,e){return t[0]>=e.minX&&t[0]<=e.maxX&&t[1]>=e.minY&&t[1]<=e.maxY}function zr(t,e,n){for(var r,i,o,s,a=Math.min(t[0],e[0]),l=Math.min(t[1],e[1]),u=Math.max(t[0],e[0]),h=Math.max(t[1],e[1]),c=n.search({minX:a,minY:l,maxX:u,maxY:h}),f=0;f<c.length;f++)if(r=c[f].p,i=c[f].next.p,o=t,r!==(s=e)&&i!==o&&$r(r,i,o)>0!=$r(r,i,s)>0&&$r(o,s,r)>0!=$r(o,s,i)>0)return!1;return!0}function $r(t,e,n){return Yr(t[0],t[1],e[0],e[1],n[0],n[1])}function qr(t){var e=t.p,n=t.next.p;return t.minX=Math.min(e[0],n[0]),t.minY=Math.min(e[1],n[1]),t.maxX=Math.max(e[0],n[0]),t.maxY=Math.max(e[1],n[1]),t}function Dr(t,e){var n={p:t,prev:null,next:null,minX:0,minY:0,maxX:0,maxY:0};return e?(n.next=e.next,n.prev=e,e.next.prev=n,e.next=n):(n.prev=n,n.next=n),n}function jr(t,e){var n=t[0]-e[0],r=t[1]-e[1];return n*n+r*r}function Zr(t,e,n){var r=e[0],i=e[1],o=n[0]-r,s=n[1]-i;if(0!==o||0!==s){var a=((t[0]-r)*o+(t[1]-i)*s)/(o*o+s*s);a>1?(r=n[0],i=n[1]):a>0&&(r+=o*a,i+=s*a)}return(o=t[0]-r)*o+(s=t[1]-i)*s}function Gr(t,e,n,r,i,o,s,a){var l,u,h,c,f=n-t,p=r-e,d=s-i,g=a-o,y=t-i,x=e-o,m=f*f+p*p,v=f*d+p*g,w=d*d+g*g,M=f*y+p*x,b=d*y+g*x,P=m*w-v*v,_=P,I=P;0===P?(u=0,_=1,c=b,I=w):(c=m*b-v*M,(u=v*b-w*M)<0?(u=0,c=b,I=w):u>_&&(u=_,c=b+v,I=w)),c<0?(c=0,-M<0?u=0:-M>m?u=_:(u=-M,_=m)):c>I&&(c=I,-M+v<0?u=0:-M+v>m?u=_:(u=-M+v,_=m));var A=(1-(h=0===c?0:c/I))*i+h*s-((1-(l=0===u?0:u/_))*t+l*n),S=(1-h)*o+h*a-((1-l)*e+l*r);return A*A+S*S}function Ur(t,e){return t[0]===e[0]?t[1]-e[1]:t[0]-e[0]}const{PackUtil:Rr}=ne();class Jr{constructor(t,e){this.x=t,this.y=e}clone(){return new Jr(this.x,this.y)}normalize(){const t=this.length();this.x/=t,this.y/=t}negate(){this.x=-this.x,this.y=-this.y}length(){return Math.sqrt(this.x*this.x+this.y*this.y)}diff(t){return new Jr(this.x-t.x,this.y-t.y)}distance(t){const e=this.x-t.x,n=this.y-t.y;return Math.sqrt(e*e+n*n)}dot(t){return this.x*t.x+this.y*t.y}equals(t){return this.x===t.x&&this.y===t.y}orthogonal(){return new Jr(this.y,-this.x)}}function Hr(t,e,n,r){const i=e.x*r.y-e.y*r.x,o=n.x-t.x,s=n.y-t.y,a=(o*r.y-s*r.x)/i;return new Jr(t.x+a*e.x,t.y+a*e.y)}const Wr=[],Kr=[];function Qr(t){if(S(t[0]&&t[0].x)){const e=[];let n=0;for(let r=0;r<t.length;r++)Kr[n]?(Kr[n][0]=t[r].x,Kr[n][1]=t[r].y):Kr[n]=[t[r].x,t[r].y],e.push(Kr[n]),n++;t=e}try{const e=Vr(t,1/0);let n=[1/0,1/0],r=[-1/0,-1/0];for(let t=0;t<e.length;t++)e[t][0]<n[0]&&(n[0]=e[t][0]),e[t][0]>r[0]&&(r[0]=e[t][0]),e[t][1]<n[1]&&(n[1]=e[t][1]),e[t][1]>r[1]&&(r[1]=e[t][1]);const i=[];let o=[],s=0;for(let t=0;t<e.length;t++)t===e.length-1&&e[t][0]===e[0][0]&&e[t][1]===e[0][1]||(Pt(i,e[t],"EPSG:3857"),Wr[s]?(Wr[s].x=i[0],Wr[s].y=i[1]):Wr[s]=new Jr(i[0],i[1]),o.push(Wr[s]),s++);Rr.calculateSignedArea(o)<0&&(o=o.reverse());const a=function(t){let e,n=Number.MAX_VALUE;const r=function(t,r,i,o,s,a,l,u){var h=Hr(t,r,s,a),c=Hr(i,o,s,a),f=Hr(l,u,t,r),p=Hr(l,u,i,o),d=h.distance(c)*h.distance(f);0!==d&&d<n&&(e=[h,f,p,c],n=d)};var i=[];for(let e=0;e<t.length;e++)i.push(t[(e+1)%t.length].diff(t[e])),i[e].normalize();var o,s,a,l,u=new Jr(Number.POSITIVE_INFINITY,Number.POSITIVE_INFINITY),h=new Jr(Number.NEGATIVE_INFINITY,Number.NEGATIVE_INFINITY);for(let e=0;e<t.length;e++){var c=t[e];c.x<u.x&&(u.x=c.x,o=e),c.x>h.x&&(h.x=c.x,s=e),c.y<u.y&&(u.y=c.y,l=e),c.y>h.y&&(h.y=c.y,a=e)}var f=new Jr(0,-1),p=new Jr(0,1),d=new Jr(-1,0),g=new Jr(1,0);for(let e=0;e<t.length;e++){var y=[Math.acos(f.dot(i[o])),Math.acos(p.dot(i[s])),Math.acos(d.dot(i[a])),Math.acos(g.dot(i[l]))];switch(y.indexOf(Math.min.apply(Math,y))){case 0:(p=(f=i[o].clone()).clone()).negate(),(g=(d=f.orthogonal()).clone()).negate(),o=(o+1)%t.length;break;case 1:(f=(p=i[s].clone()).clone()).negate(),(g=(d=f.orthogonal()).clone()).negate(),s=(s+1)%t.length;break;case 2:(g=(d=i[a].clone()).clone()).negate(),(p=(f=g.orthogonal()).clone()).negate(),a=(a+1)%t.length;break;case 3:(d=(g=i[l].clone()).clone()).negate(),(p=(f=g.orthogonal()).clone()).negate(),l=(l+1)%t.length}r(t[o],f,t[s],p,t[a],d,t[l],g)}return e}(o);if(!a||4!==a.length)return null;const l=a[0].distance(a[1]),u=a[1].distance(a[2]),h=a.map((t=>[t.x,t.y]));return h.push(+(u>l)),h}catch(t){return null}}const ti=[];function ei(t,e){const n=Array.isArray(t&&t[0]&&t[0][0]);for(let r=0;r<t.length;r++)n?t[r]=ei(t[r]):(Pt(ti,t[r],e),t[r][0]=ti[0],t[r][1]=ti[1]);return t}const{PackUtil:ni}=ne();class ri extends kn{constructor(t,e,n,r,i,o){super(t,e,n,r,i),(e=e||{}).extent||(e.extent=8192),this.setData(e.data,o)}setData(t,e){if(delete this.index,function(t){if(!t)return!0;if(Array.isArray(t)&&!t.length)return!0;if(t.features&&!t.features.length)return!0;return!1}(t))return this.empty=!0,void e();const n={maxZoom:24,tolerance:this.options.simplifyTolerance,extent:this.options.extent,buffer:S(this.options.tileBuffer)?this.options.tileBuffer:64,hasAltitude:!!this.options.hasAltitude,debug:0,lineMetrics:!0,indexMaxZoom:5,indexMaxPoints:1e5,disableFilter:!0};if(this.options.projection&&(n.projection=this.options.projection,"EPSG:4490"===n.projection&&(n.projection="EPSG:4326")),A(t)&&"{"!=t.substring(0,1)||t.url){const r=t.url?t.url:t;C.getJSON(r,t.url?t:{},((t,i)=>{if(t&&(console.error("Failed to fetch geojson:"+r),e(t)),!i)return void e(null,{extent:null,idMap:{}});let o=i;if(this.options.convertFn){o=new Function("data",this.options.convertFn+"\\nreturn convert(data)")(o)}const s=Array.isArray(o)?o:o.features;this._genOMBB(s);const{sample1000:a,idMap:l}=this._generateId(s);this._generate(a,l,o,n,e)}))}else{"string"==typeof t&&(t=JSON.parse(t));const r=Array.isArray(t)?t:t.features,i=r&&r.length;this._genOMBB(r);let o=r;if(r&&i>1e3){o=[];for(let t=0;t<i;t++)ii(r[t],o,t,i)}this._generate(o,null,t,n,e)}}_genOMBB(t){if(this.options.generateOMBB&&t)for(let e=0;e<t.length;e++){const n=t[e];if(n&&n.geometry&&n.geometry.coordinates)if("Polygon"===n.geometry.type){const t=n.geometry.coordinates[0];if(!t)continue;const e=Qr(t,t.length);n.properties=n.properties||{},n.properties[ee]=e}else if("MultiPolygon"===n.geometry.type){const t=n.geometry.coordinates;for(let e=0;e<t.length;e++){if(!t[e])continue;const r=t[e][0];if(!r)continue;const i=Qr(r,r.length);n.properties=n.properties||{},n.properties[ee]=n.properties[ee]||[],n.properties[ee][e]=i}}}}_generate(t,e,n,r,i){try{const o=t&&t.length?function(t){let e=[Number.POSITIVE_INFINITY,Number.POSITIVE_INFINITY,Number.NEGATIVE_INFINITY,Number.NEGATIVE_INFINITY];switch(t.type){case"FeatureCollection":const n=t.features.length;for(let r=0;r<n;r++)Zn(t.features[r],e);break;case"Feature":Zn(t,e);break;default:Gn(t,e)}return e}({type:"FeatureCollection",features:t}):null;this.index=function(t,e){return new ut(t,e)}(n,this.options.geojsonvt||r),i(null,{extent:o,idMap:e})}catch(t){console.warn(t),i({error:t.message})}}_generateId(t){const e=[],n={};let r=0;const i=this.options.featureIdProperty;if(t){const o=t.length;t.forEach(((t,s)=>{!function(t,o,s){if(t&&("Feature"!==t.type||t.geometry)){if(S(t.id)||(t.id=r++),i){let e=i;T(i)&&(e=i[t.layer||"0"]),t.id=t.properties[e]}n[t.id]=I({},t),t.geometry?(n[t.id].geometry=I({},t.geometry),n[t.id].geometry.coordinates=null):t.coordinates&&(n[t.id].coordinates=null),ii(t,e,o,s)}}(t,s,o)}))}return{sample1000:e,idMap:n}}getTileFeatures(t,e){const n=t.tileInfo,r=[];if(!this.index)return this.empty?(setTimeout((function(){e(null,r,[])}),1),1):(setTimeout((function(){e({loading:!0})}),1),1);const i=this.index.getTile(n.z,n.x,n.y);if(!i||0===i.features.length)return setTimeout((function(){e(null,r,[])}),1),1;const o=[];for(let t=0,e=i.features.length;t<e;t++){const e=i.features[t];let n=e.layer;void 0===n&&(n="0"),o[n]={types:{}};o[n].types[e.type]=1,e.tags=e.tags||{},e.geometry.converted||(ni.convertGeometry(e),e.geometry.converted=1),r.push({type:e.type,layer:n,id:e.id,geometry:e.geometry,properties:e.tags,extent:this.options.extent})}for(const t in o)o[t].types=Object.keys(o[t].types).map((t=>+t));return setTimeout((function(){e(null,r,o)}),1),1}onRemove(){super.onRemove(),delete this.index}}function ii(t,e,n,r){const i=Math.floor(r/998);(0===n||n===r-1||(0===i||n%i==0)&&e.length<999)&&e.push(t)}var oi={\n/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */\nread:function(t,e,n,r,i){var o,s,a=8*i-r-1,l=(1<<a)-1,u=l>>1,h=-7,c=n?i-1:0,f=n?-1:1,p=t[e+c];for(c+=f,o=p&(1<<-h)-1,p>>=-h,h+=a;h>0;o=256*o+t[e+c],c+=f,h-=8);for(s=o&(1<<-h)-1,o>>=-h,h+=r;h>0;s=256*s+t[e+c],c+=f,h-=8);if(0===o)o=1-u;else{if(o===l)return s?NaN:1/0*(p?-1:1);s+=Math.pow(2,r),o-=u}return(p?-1:1)*s*Math.pow(2,o-r)},write:function(t,e,n,r,i,o){var s,a,l,u=8*o-i-1,h=(1<<u)-1,c=h>>1,f=23===i?Math.pow(2,-24)-Math.pow(2,-77):0,p=r?0:o-1,d=r?1:-1,g=e<0||0===e&&1/e<0?1:0;for(e=Math.abs(e),isNaN(e)||e===1/0?(a=isNaN(e)?1:0,s=h):(s=Math.floor(Math.log(e)/Math.LN2),e*(l=Math.pow(2,-s))<1&&(s--,l*=2),(e+=s+c>=1?f/l:f*Math.pow(2,1-c))*l>=2&&(s++,l/=2),s+c>=h?(a=0,s=h):s+c>=1?(a=(e*l-1)*Math.pow(2,i),s+=c):(a=e*Math.pow(2,c-1)*Math.pow(2,i),s=0));i>=8;t[n+p]=255&a,p+=d,a/=256,i-=8);for(s=s<<i|a,u+=i;u>0;t[n+p]=255&s,p+=d,s/=256,u-=8);t[n+p-d]|=128*g}},si=li,ai=oi;function li(t){this.buf=ArrayBuffer.isView&&ArrayBuffer.isView(t)?t:new Uint8Array(t||0),this.pos=0,this.type=0,this.length=this.buf.length}li.Varint=0,li.Fixed64=1,li.Bytes=2,li.Fixed32=5;var ui=4294967296,hi=1/ui,ci="undefined"==typeof TextDecoder?null:new TextDecoder("utf8");function fi(t){return t.type===li.Bytes?t.readVarint()+t.pos:t.pos+1}function pi(t,e,n){return n?4294967296*e+(t>>>0):4294967296*(e>>>0)+(t>>>0)}function di(t,e,n){var r=e<=16383?1:e<=2097151?2:e<=268435455?3:Math.floor(Math.log(e)/(7*Math.LN2));n.realloc(r);for(var i=n.pos-1;i>=t;i--)n.buf[i+r]=n.buf[i]}function gi(t,e){for(var n=0;n<t.length;n++)e.writeVarint(t[n])}function yi(t,e){for(var n=0;n<t.length;n++)e.writeSVarint(t[n])}function xi(t,e){for(var n=0;n<t.length;n++)e.writeFloat(t[n])}function mi(t,e){for(var n=0;n<t.length;n++)e.writeDouble(t[n])}function vi(t,e){for(var n=0;n<t.length;n++)e.writeBoolean(t[n])}function wi(t,e){for(var n=0;n<t.length;n++)e.writeFixed32(t[n])}function Mi(t,e){for(var n=0;n<t.length;n++)e.writeSFixed32(t[n])}function bi(t,e){for(var n=0;n<t.length;n++)e.writeFixed64(t[n])}function Pi(t,e){for(var n=0;n<t.length;n++)e.writeSFixed64(t[n])}function _i(t,e){return(t[e]|t[e+1]<<8|t[e+2]<<16)+16777216*t[e+3]}function Ii(t,e,n){t[n]=e,t[n+1]=e>>>8,t[n+2]=e>>>16,t[n+3]=e>>>24}function Ai(t,e){return(t[e]|t[e+1]<<8|t[e+2]<<16)+(t[e+3]<<24)}li.prototype={destroy:function(){this.buf=null},readFields:function(t,e,n){for(n=n||this.length;this.pos<n;){var r=this.readVarint(),i=r>>3,o=this.pos;this.type=7&r,t(i,e,this),this.pos===o&&this.skip(r)}return e},readMessage:function(t,e){return this.readFields(t,e,this.readVarint()+this.pos)},readFixed32:function(){var t=_i(this.buf,this.pos);return this.pos+=4,t},readSFixed32:function(){var t=Ai(this.buf,this.pos);return this.pos+=4,t},readFixed64:function(){var t=_i(this.buf,this.pos)+_i(this.buf,this.pos+4)*ui;return this.pos+=8,t},readSFixed64:function(){var t=_i(this.buf,this.pos)+Ai(this.buf,this.pos+4)*ui;return this.pos+=8,t},readFloat:function(){var t=ai.read(this.buf,this.pos,!0,23,4);return this.pos+=4,t},readDouble:function(){var t=ai.read(this.buf,this.pos,!0,52,8);return this.pos+=8,t},readVarint:function(t){var e,n,r=this.buf;return e=127&(n=r[this.pos++]),n<128?e:(e|=(127&(n=r[this.pos++]))<<7,n<128?e:(e|=(127&(n=r[this.pos++]))<<14,n<128?e:(e|=(127&(n=r[this.pos++]))<<21,n<128?e:function(t,e,n){var r,i,o=n.buf;if(i=o[n.pos++],r=(112&i)>>4,i<128)return pi(t,r,e);if(i=o[n.pos++],r|=(127&i)<<3,i<128)return pi(t,r,e);if(i=o[n.pos++],r|=(127&i)<<10,i<128)return pi(t,r,e);if(i=o[n.pos++],r|=(127&i)<<17,i<128)return pi(t,r,e);if(i=o[n.pos++],r|=(127&i)<<24,i<128)return pi(t,r,e);if(i=o[n.pos++],r|=(1&i)<<31,i<128)return pi(t,r,e);throw new Error("Expected varint not more than 10 bytes")}(e|=(15&(n=r[this.pos]))<<28,t,this))))},readVarint64:function(){return this.readVarint(!0)},readSVarint:function(){var t=this.readVarint();return t%2==1?(t+1)/-2:t/2},readBoolean:function(){return Boolean(this.readVarint())},readString:function(){var t=this.readVarint()+this.pos,e=this.pos;return this.pos=t,t-e>=12&&ci?function(t,e,n){return ci.decode(t.subarray(e,n))}(this.buf,e,t):function(t,e,n){var r="",i=e;for(;i<n;){var o,s,a,l=t[i],u=null,h=l>239?4:l>223?3:l>191?2:1;if(i+h>n)break;1===h?l<128&&(u=l):2===h?128==(192&(o=t[i+1]))&&(u=(31&l)<<6|63&o)<=127&&(u=null):3===h?(o=t[i+1],s=t[i+2],128==(192&o)&&128==(192&s)&&((u=(15&l)<<12|(63&o)<<6|63&s)<=2047||u>=55296&&u<=57343)&&(u=null)):4===h&&(o=t[i+1],s=t[i+2],a=t[i+3],128==(192&o)&&128==(192&s)&&128==(192&a)&&((u=(15&l)<<18|(63&o)<<12|(63&s)<<6|63&a)<=65535||u>=1114112)&&(u=null)),null===u?(u=65533,h=1):u>65535&&(u-=65536,r+=String.fromCharCode(u>>>10&1023|55296),u=56320|1023&u),r+=String.fromCharCode(u),i+=h}return r}(this.buf,e,t)},readBytes:function(){var t=this.readVarint()+this.pos,e=this.buf.subarray(this.pos,t);return this.pos=t,e},readPackedVarint:function(t,e){if(this.type!==li.Bytes)return t.push(this.readVarint(e));var n=fi(this);for(t=t||[];this.pos<n;)t.push(this.readVarint(e));return t},readPackedSVarint:function(t){if(this.type!==li.Bytes)return t.push(this.readSVarint());var e=fi(this);for(t=t||[];this.pos<e;)t.push(this.readSVarint());return t},readPackedBoolean:function(t){if(this.type!==li.Bytes)return t.push(this.readBoolean());var e=fi(this);for(t=t||[];this.pos<e;)t.push(this.readBoolean());return t},readPackedFloat:function(t){if(this.type!==li.Bytes)return t.push(this.readFloat());var e=fi(this);for(t=t||[];this.pos<e;)t.push(this.readFloat());return t},readPackedDouble:function(t){if(this.type!==li.Bytes)return t.push(this.readDouble());var e=fi(this);for(t=t||[];this.pos<e;)t.push(this.readDouble());return t},readPackedFixed32:function(t){if(this.type!==li.Bytes)return t.push(this.readFixed32());var e=fi(this);for(t=t||[];this.pos<e;)t.push(this.readFixed32());return t},readPackedSFixed32:function(t){if(this.type!==li.Bytes)return t.push(this.readSFixed32());var e=fi(this);for(t=t||[];this.pos<e;)t.push(this.readSFixed32());return t},readPackedFixed64:function(t){if(this.type!==li.Bytes)return t.push(this.readFixed64());var e=fi(this);for(t=t||[];this.pos<e;)t.push(this.readFixed64());return t},readPackedSFixed64:function(t){if(this.type!==li.Bytes)return t.push(this.readSFixed64());var e=fi(this);for(t=t||[];this.pos<e;)t.push(this.readSFixed64());return t},skip:function(t){var e=7&t;if(e===li.Varint)for(;this.buf[this.pos++]>127;);else if(e===li.Bytes)this.pos=this.readVarint()+this.pos;else if(e===li.Fixed32)this.pos+=4;else{if(e!==li.Fixed64)throw new Error("Unimplemented type: "+e);this.pos+=8}},writeTag:function(t,e){this.writeVarint(t<<3|e)},realloc:function(t){for(var e=this.length||16;e<this.pos+t;)e*=2;if(e!==this.length){var n=new Uint8Array(e);n.set(this.buf),this.buf=n,this.length=e}},finish:function(){return this.length=this.pos,this.pos=0,this.buf.subarray(0,this.length)},writeFixed32:function(t){this.realloc(4),Ii(this.buf,t,this.pos),this.pos+=4},writeSFixed32:function(t){this.realloc(4),Ii(this.buf,t,this.pos),this.pos+=4},writeFixed64:function(t){this.realloc(8),Ii(this.buf,-1&t,this.pos),Ii(this.buf,Math.floor(t*hi),this.pos+4),this.pos+=8},writeSFixed64:function(t){this.realloc(8),Ii(this.buf,-1&t,this.pos),Ii(this.buf,Math.floor(t*hi),this.pos+4),this.pos+=8},writeVarint:function(t){(t=+t||0)>268435455||t<0?function(t,e){var n,r;t>=0?(n=t%4294967296|0,r=t/4294967296|0):(r=~(-t/4294967296),4294967295^(n=~(-t%4294967296))?n=n+1|0:(n=0,r=r+1|0));if(t>=0x10000000000000000||t<-0x10000000000000000)throw new Error("Given varint doesn't fit into 10 bytes");e.realloc(10),function(t,e,n){n.buf[n.pos++]=127&t|128,t>>>=7,n.buf[n.pos++]=127&t|128,t>>>=7,n.buf[n.pos++]=127&t|128,t>>>=7,n.buf[n.pos++]=127&t|128,t>>>=7,n.buf[n.pos]=127&t}(n,0,e),function(t,e){var n=(7&t)<<4;if(e.buf[e.pos++]|=n|((t>>>=3)?128:0),!t)return;if(e.buf[e.pos++]=127&t|((t>>>=7)?128:0),!t)return;if(e.buf[e.pos++]=127&t|((t>>>=7)?128:0),!t)return;if(e.buf[e.pos++]=127&t|((t>>>=7)?128:0),!t)return;if(e.buf[e.pos++]=127&t|((t>>>=7)?128:0),!t)return;e.buf[e.pos++]=127&t}(r,e)}(t,this):(this.realloc(4),this.buf[this.pos++]=127&t|(t>127?128:0),t<=127||(this.buf[this.pos++]=127&(t>>>=7)|(t>127?128:0),t<=127||(this.buf[this.pos++]=127&(t>>>=7)|(t>127?128:0),t<=127||(this.buf[this.pos++]=t>>>7&127))))},writeSVarint:function(t){this.writeVarint(t<0?2*-t-1:2*t)},writeBoolean:function(t){this.writeVarint(Boolean(t))},writeString:function(t){t=String(t),this.realloc(4*t.length),this.pos++;var e=this.pos;this.pos=function(t,e,n){for(var r,i,o=0;o<e.length;o++){if((r=e.charCodeAt(o))>55295&&r<57344){if(!i){r>56319||o+1===e.length?(t[n++]=239,t[n++]=191,t[n++]=189):i=r;continue}if(r<56320){t[n++]=239,t[n++]=191,t[n++]=189,i=r;continue}r=i-55296<<10|r-56320|65536,i=null}else i&&(t[n++]=239,t[n++]=191,t[n++]=189,i=null);r<128?t[n++]=r:(r<2048?t[n++]=r>>6|192:(r<65536?t[n++]=r>>12|224:(t[n++]=r>>18|240,t[n++]=r>>12&63|128),t[n++]=r>>6&63|128),t[n++]=63&r|128)}return n}(this.buf,t,this.pos);var n=this.pos-e;n>=128&&di(e,n,this),this.pos=e-1,this.writeVarint(n),this.pos+=n},writeFloat:function(t){this.realloc(4),ai.write(this.buf,t,this.pos,!0,23,4),this.pos+=4},writeDouble:function(t){this.realloc(8),ai.write(this.buf,t,this.pos,!0,52,8),this.pos+=8},writeBytes:function(t){var e=t.length;this.writeVarint(e),this.realloc(e);for(var n=0;n<e;n++)this.buf[this.pos++]=t[n]},writeRawMessage:function(t,e){this.pos++;var n=this.pos;t(e,this);var r=this.pos-n;r>=128&&di(n,r,this),this.pos=n-1,this.writeVarint(r),this.pos+=r},writeMessage:function(t,e,n){this.writeTag(t,li.Bytes),this.writeRawMessage(e,n)},writePackedVarint:function(t,e){e.length&&this.writeMessage(t,gi,e)},writePackedSVarint:function(t,e){e.length&&this.writeMessage(t,yi,e)},writePackedBoolean:function(t,e){e.length&&this.writeMessage(t,vi,e)},writePackedFloat:function(t,e){e.length&&this.writeMessage(t,xi,e)},writePackedDouble:function(t,e){e.length&&this.writeMessage(t,mi,e)},writePackedFixed32:function(t,e){e.length&&this.writeMessage(t,wi,e)},writePackedSFixed32:function(t,e){e.length&&this.writeMessage(t,Mi,e)},writePackedFixed64:function(t,e){e.length&&this.writeMessage(t,bi,e)},writePackedSFixed64:function(t,e){e.length&&this.writeMessage(t,Pi,e)},writeBytesField:function(t,e){this.writeTag(t,li.Bytes),this.writeBytes(e)},writeFixed32Field:function(t,e){this.writeTag(t,li.Fixed32),this.writeFixed32(e)},writeSFixed32Field:function(t,e){this.writeTag(t,li.Fixed32),this.writeSFixed32(e)},writeFixed64Field:function(t,e){this.writeTag(t,li.Fixed64),this.writeFixed64(e)},writeSFixed64Field:function(t,e){this.writeTag(t,li.Fixed64),this.writeSFixed64(e)},writeVarintField:function(t,e){this.writeTag(t,li.Varint),this.writeVarint(e)},writeSVarintField:function(t,e){this.writeTag(t,li.Varint),this.writeSVarint(e)},writeStringField:function(t,e){this.writeTag(t,li.Bytes),this.writeString(e)},writeFloatField:function(t,e){this.writeTag(t,li.Fixed32),this.writeFloat(e)},writeDoubleField:function(t,e){this.writeTag(t,li.Fixed64),this.writeDouble(e)},writeBooleanField:function(t,e){this.writeVarintField(t,Boolean(e))}};var Si=yr(si),Fi=Ti;function Ti(t,e){this.x=t,this.y=e}Ti.prototype={clone:function(){return new Ti(this.x,this.y)},add:function(t){return this.clone()._add(t)},sub:function(t){return this.clone()._sub(t)},multByPoint:function(t){return this.clone()._multByPoint(t)},divByPoint:function(t){return this.clone()._divByPoint(t)},mult:function(t){return this.clone()._mult(t)},div:function(t){return this.clone()._div(t)},rotate:function(t){return this.clone()._rotate(t)},rotateAround:function(t,e){return this.clone()._rotateAround(t,e)},matMult:function(t){return this.clone()._matMult(t)},unit:function(){return this.clone()._unit()},perp:function(){return this.clone()._perp()},round:function(){return this.clone()._round()},mag:function(){return Math.sqrt(this.x*this.x+this.y*this.y)},equals:function(t){return this.x===t.x&&this.y===t.y},dist:function(t){return Math.sqrt(this.distSqr(t))},distSqr:function(t){var e=t.x-this.x,n=t.y-this.y;return e*e+n*n},angle:function(){return Math.atan2(this.y,this.x)},angleTo:function(t){return Math.atan2(this.y-t.y,this.x-t.x)},angleWith:function(t){return this.angleWithSep(t.x,t.y)},angleWithSep:function(t,e){return Math.atan2(this.x*e-this.y*t,this.x*t+this.y*e)},_matMult:function(t){var e=t[0]*this.x+t[1]*this.y,n=t[2]*this.x+t[3]*this.y;return this.x=e,this.y=n,this},_add:function(t){return this.x+=t.x,this.y+=t.y,this},_sub:function(t){return this.x-=t.x,this.y-=t.y,this},_mult:function(t){return this.x*=t,this.y*=t,this},_div:function(t){return this.x/=t,this.y/=t,this},_multByPoint:function(t){return this.x*=t.x,this.y*=t.y,this},_divByPoint:function(t){return this.x/=t.x,this.y/=t.y,this},_unit:function(){return this._div(this.mag()),this},_perp:function(){var t=this.y;return this.y=this.x,this.x=-t,this},_rotate:function(t){var e=Math.cos(t),n=Math.sin(t),r=e*this.x-n*this.y,i=n*this.x+e*this.y;return this.x=r,this.y=i,this},_rotateAround:function(t,e){var n=Math.cos(t),r=Math.sin(t),i=e.x+n*(this.x-e.x)-r*(this.y-e.y),o=e.y+r*(this.x-e.x)+n*(this.y-e.y);return this.x=i,this.y=o,this},_round:function(){return this.x=Math.round(this.x),this.y=Math.round(this.y),this}},Ti.convert=function(t){return t instanceof Ti?t:Array.isArray(t)?new Ti(t[0],t[1]):t};var ki=Fi,Bi=Li;function Li(t,e,n,r,i){this.properties={},this.extent=n,this.type=0,this._pbf=t,this._geometry=-1,this._keys=r,this._values=i,t.readFields(Ci,this,e)}function Ci(t,e,n){1==t?e.id=n.readVarint():2==t?function(t,e){var n=t.readVarint()+t.pos;for(;t.pos<n;){var r=e._keys[t.readVarint()],i=e._values[t.readVarint()];e.properties[r]=i}}(n,e):3==t?e.type=n.readVarint():4==t&&(e._geometry=n.pos)}function Yi(t){for(var e,n,r=0,i=0,o=t.length,s=o-1;i<o;s=i++)e=t[i],r+=((n=t[s]).x-e.x)*(e.y+n.y);return r}Li.types=["Unknown","Point","LineString","Polygon"],Li.prototype.loadGeometry=function(){var t=this._pbf;t.pos=this._geometry;for(var e,n=t.readVarint()+t.pos,r=1,i=0,o=0,s=0,a=[];t.pos<n;){if(i<=0){var l=t.readVarint();r=7&l,i=l>>3}if(i--,1===r||2===r)o+=t.readSVarint(),s+=t.readSVarint(),1===r&&(e&&a.push(e),e=[]),e.push(new ki(o,s));else{if(7!==r)throw new Error("unknown command "+r);e&&e.push(e[0].clone())}}return e&&a.push(e),a},Li.prototype.bbox=function(){var t=this._pbf;t.pos=this._geometry;for(var e=t.readVarint()+t.pos,n=1,r=0,i=0,o=0,s=1/0,a=-1/0,l=1/0,u=-1/0;t.pos<e;){if(r<=0){var h=t.readVarint();n=7&h,r=h>>3}if(r--,1===n||2===n)(i+=t.readSVarint())<s&&(s=i),i>a&&(a=i),(o+=t.readSVarint())<l&&(l=o),o>u&&(u=o);else if(7!==n)throw new Error("unknown command "+n)}return[s,l,a,u]},Li.prototype.toGeoJSON=function(t,e,n){var r,i,o=this.extent*Math.pow(2,n),s=this.extent*t,a=this.extent*e,l=this.loadGeometry(),u=Li.types[this.type];function h(t){for(var e=0;e<t.length;e++){var n=t[e],r=180-360*(n.y+a)/o;t[e]=[360*(n.x+s)/o-180,360/Math.PI*Math.atan(Math.exp(r*Math.PI/180))-90]}}switch(this.type){case 1:var c=[];for(r=0;r<l.length;r++)c[r]=l[r][0];h(l=c);break;case 2:for(r=0;r<l.length;r++)h(l[r]);break;case 3:for(l=function(t){var e=t.length;if(e<=1)return[t];for(var n,r,i=[],o=0;o<e;o++){var s=Yi(t[o]);0!==s&&(void 0===r&&(r=s<0),r===s<0?(n&&i.push(n),n=[t[o]]):n.push(t[o]))}n&&i.push(n);return i}(l),r=0;r<l.length;r++)for(i=0;i<l[r].length;i++)h(l[r][i])}1===l.length?l=l[0]:u="Multi"+u;var f={type:"Feature",geometry:{type:u,coordinates:l},properties:this.properties};return"id"in this&&(f.id=this.id),f};var Vi=Bi,Oi=Xi;function Xi(t,e){this.version=1,this.name=null,this.extent=4096,this.length=0,this._pbf=t,this._keys=[],this._values=[],this._features=[],t.readFields(Ni,this,e),this.length=this._features.length}function Ni(t,e,n){15===t?e.version=n.readVarint():1===t?e.name=n.readString():5===t?e.extent=n.readVarint():2===t?e._features.push(n.pos):3===t?e._keys.push(n.readString()):4===t&&e._values.push(function(t){var e=null,n=t.readVarint()+t.pos;for(;t.pos<n;){var r=t.readVarint()>>3;e=1===r?t.readString():2===r?t.readFloat():3===r?t.readDouble():4===r?t.readVarint64():5===r?t.readVarint():6===r?t.readSVarint():7===r?t.readBoolean():null}return e}(n))}Xi.prototype.feature=function(t){if(t<0||t>=this._features.length)throw new Error("feature index out of bounds");this._pbf.pos=this._features[t];var e=this._pbf.readVarint()+this._pbf.pos;return new Vi(this._pbf,e,this.extent,this._keys,this._values)};var Ei=Oi,zi=function(t,e){this.layers=t.readFields($i,{},e)};function $i(t,e,n){if(3===t){var r=new Ei(n,n.readVarint()+n.pos);r.length&&(e[r.name]=r)}}var qi=zi;const Di=2;class ji extends kn{constructor(t,e,n,r,i,o){super(t,e,n,r,i),e=e||{},o()}getTileFeatures(t,e){const n=t.tileInfo.url,r=t.fetchOptions||{},{altitudePropertyName:i,disableAltitudeWarning:o}=t,s=this._cache.get(n);if(s&&s.cacheIndex===t.workerCacheIndex){const{err:t,data:r}=s;return setTimeout((()=>{this._readTile(n,i,o,t,r,e)}),1)}const{tileArrayBuffer:a}=t;return a?setTimeout((()=>{this._readTile(n,i,o,null,a,e)}),1):(r.referrer=t.referrer,C.getArrayBuffer(n,r,((r,s)=>{this._cache&&(r?r.loading||this._cache.add(n,{err:r,data:s&&s.data,cacheIndex:t.workerCacheIndex}):s&&s.data&&this._cache.add(n,{err:null,data:s.data,cacheIndex:t.workerCacheIndex}),this._readTile(n,i,o,r,s&&s.data,e))})))}_readTile(t,e,n,r,i,o){if(r)return void o(r);let s;try{s=new qi(new Si(i))}catch(r){return void o(r.message,[],[])}const a=[];if(!s.layers)return void o(null,a,[]);const l={};let u;for(const t in s.layers)if(h=s.layers,c=t,Object.prototype.hasOwnProperty.call(h,c)){l[t]={types:{}};const i=l[t].types;for(let o=0,l=s.layers[t].length;o<l;o++)try{u=s.layers[t].feature(o),i[u.type]=1;const r={type:u.type,layer:t,geometry:u.loadGeometry(),properties:u.properties,extent:u.extent};void 0!==u.id&&(r.id=u.id);let l=r.properties[ee];l&&(A(l)&&(l=JSON.parse(l)),r.properties[ee]=ei(l,"EPSG:3857"));const h=e&&r.properties[e];if(h){const t=Zi(h),e=[];Gi(r.geometry,t,e),e.length&&!n&&(console.warn("feature.geometry is not consistent with altitude values:"),console.warn(JSON.stringify(r,null,2)))}a.push(r)}catch(r){console.warn("error when load vt geometry:",r)}}var h,c;for(const t in l)l[t].types=Object.keys(l[t].types).map((t=>+t));o(null,a,l,{byteLength:i.byteLength})}abortTile(t,e){const n=this.requests[t];delete this.requests[t],n&&n.abort&&n.abort(),this._cancelLoadings(t),e()}onRemove(){super.onRemove();for(const t in this.requests){const e=this.requests[t];e&&e.abort&&e.abort()}this.requests={}}}function Zi(t){const e=atob(t),n=new Uint8Array(e.length);for(let t=0;t<e.length;t++)n[t]=e.charCodeAt(t);return new Float32Array(n.buffer)}function Gi(t,e,n,r){r||(r={index:0});for(let i=0;i<t.length;i++)if(Array.isArray(t[i]))Gi(t[i],e,n,r);else{const o=r.index;k(e[o])?n.push(Di):t[i].z=100*e[o],r.index++}}const{LRUCache:Ui}=ne();let Ri=0;const Ji=new Ui(128);class Hi{constructor(t){this._layers={},this._callbacks={},this.workerId=t}addLayer({actorId:t,mapId:e,layerId:n,params:r},i){if(this._getLayerById(e,n))return;const o=this._genKey(e,n),s=r.type,a=r.options,l=this.send.bind(this,t);this._layers[o]="GeoJSONVectorTileLayer"===s?new ri(n,a,l,Ji,{},i):new ji(n,a,l,Ji,{},i)}removeLayer({mapId:t,layerId:e},n){const r=this._getLayerById(t,e),i=this._genKey(t,e);delete this._layers[i],r&&r.onRemove(n)}loadTile({mapId:t,layerId:e,params:n},r){const i=this._getLayerById(t,e);i&&i.loadTile(n,r)}abortTile({mapId:t,layerId:e,params:n},r){const i=this._getLayerById(t,e);i&&i.abortTile&&i.abortTile(n.url,r)}removeTile({mapId:t,layerId:e,params:n},r){const i=this._getLayerById(t,e);i&&i.removeTile(n,r)}updateStyle({mapId:t,layerId:e,params:n},r){const i=this._getLayerById(t,e);i&&i.updateStyle(n,r)}updateOptions({mapId:t,layerId:e,params:n},r){const i=this._getLayerById(t,e);i&&i.updateOptions(n,r)}setData({mapId:t,layerId:e,params:n},r){const i=this._getLayerById(t,e);i&&i.setData(n.data,r)}receive(t){const e=t.callback,n=this._callbacks[e];delete this._callbacks[e],n&&t.error?n(new Error(t.error)):n&&n(null,t.data)}send(t,e,n,r,i){const o=i?\`${$435bc7696844e930$var$E}t}-${$435bc7696844e930$var$E}Ri++}\`:null;i&&(this._callbacks[o]=i),postMessage({type:"<request>",workerId:this.workerId,actorId:t,command:e,params:n,callback:String(o)},r||[])}_genKey(t,e){return\`${$435bc7696844e930$var$E}t}-${$435bc7696844e930$var$E}e}\`}_getLayerById(t,e){const n=this._genKey(t,e);return this._layers[n]}_resetCache(){Ji.reset()}}t.initialize=function(){},t.onmessage=function(t,e){const n=t.data;if(this.dispatcher||(this.dispatcher=new Hi(t.workerId)),"<response>"===t.type)this.dispatcher.workerId===t.workerId&&this.dispatcher.receive(t);else{const r=n.command;this.dispatcher[r]({actorId:t.actorId,mapId:n.mapId,layerId:n.layerId,params:n.params},((t,n,i)=>{t&&404!==t.status&&204!==t.status&&!t.loading&&console.error(r,t),e(t,n,i)}))}}}`;
function $435bc7696844e930$var$L(e) {
    const t = function() {
        return "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : void 0;
    };
    if (t().maptalks_vt_packers) return;
    function n(e) {
        return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
    }
    var i = r;
    function r(e, t) {
        this.x = e, this.y = t;
    }
    r.prototype = {
        clone: function() {
            return new r(this.x, this.y);
        },
        add: function(e) {
            return this.clone()._add(e);
        },
        sub: function(e) {
            return this.clone()._sub(e);
        },
        multByPoint: function(e) {
            return this.clone()._multByPoint(e);
        },
        divByPoint: function(e) {
            return this.clone()._divByPoint(e);
        },
        mult: function(e) {
            return this.clone()._mult(e);
        },
        div: function(e) {
            return this.clone()._div(e);
        },
        rotate: function(e) {
            return this.clone()._rotate(e);
        },
        rotateAround: function(e, t) {
            return this.clone()._rotateAround(e, t);
        },
        matMult: function(e) {
            return this.clone()._matMult(e);
        },
        unit: function() {
            return this.clone()._unit();
        },
        perp: function() {
            return this.clone()._perp();
        },
        round: function() {
            return this.clone()._round();
        },
        mag: function() {
            return Math.sqrt(this.x * this.x + this.y * this.y);
        },
        equals: function(e) {
            return this.x === e.x && this.y === e.y;
        },
        dist: function(e) {
            return Math.sqrt(this.distSqr(e));
        },
        distSqr: function(e) {
            var t = e.x - this.x, n = e.y - this.y;
            return t * t + n * n;
        },
        angle: function() {
            return Math.atan2(this.y, this.x);
        },
        angleTo: function(e) {
            return Math.atan2(this.y - e.y, this.x - e.x);
        },
        angleWith: function(e) {
            return this.angleWithSep(e.x, e.y);
        },
        angleWithSep: function(e, t) {
            return Math.atan2(this.x * t - this.y * e, this.x * e + this.y * t);
        },
        _matMult: function(e) {
            var t = e[0] * this.x + e[1] * this.y, n = e[2] * this.x + e[3] * this.y;
            return this.x = t, this.y = n, this;
        },
        _add: function(e) {
            return this.x += e.x, this.y += e.y, this;
        },
        _sub: function(e) {
            return this.x -= e.x, this.y -= e.y, this;
        },
        _mult: function(e) {
            return this.x *= e, this.y *= e, this;
        },
        _div: function(e) {
            return this.x /= e, this.y /= e, this;
        },
        _multByPoint: function(e) {
            return this.x *= e.x, this.y *= e.y, this;
        },
        _divByPoint: function(e) {
            return this.x /= e.x, this.y /= e.y, this;
        },
        _unit: function() {
            return this._div(this.mag()), this;
        },
        _perp: function() {
            var e = this.y;
            return this.y = this.x, this.x = -e, this;
        },
        _rotate: function(e) {
            var t = Math.cos(e), n = Math.sin(e), i = t * this.x - n * this.y, r = n * this.x + t * this.y;
            return this.x = i, this.y = r, this;
        },
        _rotateAround: function(e, t) {
            var n = Math.cos(e), i = Math.sin(e), r = t.x + n * (this.x - t.x) - i * (this.y - t.y), s = t.y + i * (this.x - t.x) + n * (this.y - t.y);
            return this.x = r, this.y = s, this;
        },
        _round: function() {
            return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
        }
    }, r.convert = function(e) {
        return e instanceof r ? e : Array.isArray(e) ? new r(e[0], e[1]) : e;
    };
    var s = n(i);
    const o = {
        Point: 1,
        LineString: 2,
        Polygon: 3,
        MultiPoint: 4,
        MultiLineString: 5,
        MultiPolygon: 6
    };
    function a(e, t = {}) {
        var n = [];
        if ("FeatureCollection" === e.type) for(var i = 0; i < e.features.length; i++)l(n, e.features[i], t, i);
        else "Feature" === e.type ? l(n, e, t) : l(n, {
            geometry: e
        }, t);
        return n;
    }
    function l(e, t, n, i) {
        if (t.geometry && t.geometry.geometry) {
            var r = t.geometry.coordinates, s = t.geometry.type, o = [], a = t.id;
            if (n.promoteId ? a = t.properties[n.promoteId] : n.generateId && (a = i || 0), "Point" === s) h(r, o);
            else if ("MultiPoint" === s) for(var d = 0; d < r.length; d++)h(r[d], o);
            else if ("LineString" === s) u([
                r
            ], o);
            else if ("MultiLineString" === s) {
                if (n.lineMetrics) {
                    for(d = 0; d < r.length; d++)o = [], c(r[d], o), e.push(f(a, "LineString", o, t.properties));
                    return;
                }
                u(r, o);
            } else if ("Polygon" === s) u(r, o);
            else {
                if ("MultiPolygon" !== s) {
                    if ("GeometryCollection" === s) {
                        for(d = 0; d < t.geometry.geometries.length; d++)l(e, {
                            id: a,
                            geometry: t.geometry.geometries[d],
                            properties: t.properties
                        }, n, i);
                        return;
                    }
                    return void console.warn(`Input data type(${s}) is not a valid GeoJSON geometry type.`);
                }
                for(d = 0; d < r.length; d++){
                    var p = [];
                    u(r[d], p), o.push(p);
                }
            }
            e.push(f(a, s, o, t.properties));
        }
    }
    function h(e, t) {
        const n = new s(e[0], e[1]);
        n.z = 100 * (e[2] || 0), t.push([
            n
        ]);
    }
    function c(e, t) {
        for(let n = 0; n < e.length; n++){
            const i = e[n][0], r = e[n][1], o = new s(i, r);
            o.z = 100 * (e[n][2] || 0), t.push(o);
        }
    }
    function u(e, t, n, i) {
        for(var r = 0; r < e.length; r++){
            var s = [];
            c(e[r], s), t.push(s);
        }
    }
    function f(e, t, n, i) {
        return {
            id: void 0 === e ? null : e,
            type: o[t],
            geometry: n,
            properties: i
        };
    }
    function d(e, t, n) {
        n = n || {}, this.w = e || 64, this.h = t || 64, this.autoResize = !!n.autoResize, this.shelves = [], this.freebins = [], this.stats = {}, this.bins = {}, this.maxId = 0;
    }
    function p(e, t, n) {
        this.x = 0, this.y = e, this.w = this.free = t, this.h = n;
    }
    function g(e, t, n, i, r, s, o) {
        this.id = e, this.x = t, this.y = n, this.w = i, this.h = r, this.maxw = s || i, this.maxh = o || r, this.refcount = 0 /*!
	 * Codes from mapbox-gl-js
	 * github.com/mapbox/mapbox-gl-js
	 * MIT License
	 */ ;
    }
    function m(e, { width: t, height: n }, i, r) {
        if (r) {
            if (r.length !== t * n * i) throw new RangeError("mismatched image size");
        } else r = new Uint8Array(t * n * i);
        return e.width = t, e.height = n, e.data = r, e;
    }
    function y(e, { width: t, height: n }, i) {
        if (t === e.width && n === e.height) return;
        const r = m({}, {
            width: t,
            height: n
        }, i);
        x(e, r, {
            x: 0,
            y: 0
        }, {
            x: 0,
            y: 0
        }, {
            width: Math.min(e.width, t),
            height: Math.min(e.height, n)
        }, i), e.width = t, e.height = n, e.data = r.data;
    }
    function x(e, t, n, i, r, s) {
        if (0 === r.width || 0 === r.height) return t;
        if (r.width > e.width || r.height > e.height || n.x > e.width - r.width || n.y > e.height - r.height) throw new RangeError("out of range source coordinates for image copy");
        if (r.width > t.width || r.height > t.height || i.x > t.width - r.width || i.y > t.height - r.height) throw new RangeError("out of range destination coordinates for image copy");
        const o = e.data, a = t.data;
        if (o === a) return t;
        for(let l = 0; l < r.height; l++){
            const h = ((n.y + l) * e.width + n.x) * s, c = ((i.y + l) * t.width + i.x) * s;
            for(let e = 0; e < r.width * s; e++)a[c + e] = o[h + e];
        }
        return t;
    }
    d.prototype.pack = function(e, t) {
        e = [].concat(e), t = t || {};
        for(var n, i, r, s, o = [], a = 0; a < e.length; a++)if (n = e[a].w || e[a].width, i = e[a].h || e[a].height, r = e[a].id, n && i) {
            if (!(s = this.packOne(n, i, r))) continue;
            t.inPlace && (e[a].x = s.x, e[a].y = s.y, e[a].id = s.id), o.push(s);
        }
        return this.shrink(), o;
    }, d.prototype.packOne = function(e, t, n) {
        var i, r, s, o, a, l, h, c, u = {
            freebin: -1,
            shelf: -1,
            waste: 1 / 0
        }, f = 0;
        if ("string" == typeof n || "number" == typeof n) {
            if (i = this.getBin(n)) return this.ref(i), i;
            "number" == typeof n && (this.maxId = Math.max(n, this.maxId));
        } else n = ++this.maxId;
        for(o = 0; o < this.freebins.length; o++){
            if (t === (i = this.freebins[o]).maxh && e === i.maxw) return this.allocFreebin(o, e, t, n);
            t > i.maxh || e > i.maxw || t <= i.maxh && e <= i.maxw && (s = i.maxw * i.maxh - e * t) < u.waste && (u.waste = s, u.freebin = o);
        }
        for(o = 0; o < this.shelves.length; o++)if (f += (r = this.shelves[o]).h, !(e > r.free)) {
            if (t === r.h) return this.allocShelf(o, e, t, n);
            t > r.h || t < r.h && (s = (r.h - t) * e) < u.waste && (u.freebin = -1, u.waste = s, u.shelf = o);
        }
        return -1 !== u.freebin ? this.allocFreebin(u.freebin, e, t, n) : -1 !== u.shelf ? this.allocShelf(u.shelf, e, t, n) : t <= this.h - f && e <= this.w ? (r = new p(f, this.w, t), this.allocShelf(this.shelves.push(r) - 1, e, t, n)) : this.autoResize ? (a = l = this.h, ((h = c = this.w) <= a || e > h) && (c = 2 * Math.max(e, h)), (a < h || t > a) && (l = 2 * Math.max(t, a)), this.resize(c, l), this.packOne(e, t, n)) : null;
    }, d.prototype.allocFreebin = function(e, t, n, i) {
        var r = this.freebins.splice(e, 1)[0];
        return r.id = i, r.w = t, r.h = n, r.refcount = 0, this.bins[i] = r, this.ref(r), r;
    }, d.prototype.allocShelf = function(e, t, n, i) {
        var r = this.shelves[e].alloc(t, n, i);
        return this.bins[i] = r, this.ref(r), r;
    }, d.prototype.shrink = function() {
        if (this.shelves.length > 0) {
            for(var e = 0, t = 0, n = 0; n < this.shelves.length; n++){
                var i = this.shelves[n];
                t += i.h, e = Math.max(i.w - i.free, e);
            }
            this.resize(e, t);
        }
    }, d.prototype.getBin = function(e) {
        return this.bins[e];
    }, d.prototype.ref = function(e) {
        if (1 == ++e.refcount) {
            var t = e.h;
            this.stats[t] = 1 + (0 | this.stats[t]);
        }
        return e.refcount;
    }, d.prototype.unref = function(e) {
        return 0 === e.refcount ? 0 : (0 == --e.refcount && (this.stats[e.h]--, delete this.bins[e.id], this.freebins.push(e)), e.refcount);
    }, d.prototype.clear = function() {
        this.shelves = [], this.freebins = [], this.stats = {}, this.bins = {}, this.maxId = 0;
    }, d.prototype.resize = function(e, t) {
        this.w = e, this.h = t;
        for(var n = 0; n < this.shelves.length; n++)this.shelves[n].resize(e);
        return !0;
    }, p.prototype.alloc = function(e, t, n) {
        if (e > this.free || t > this.h) return null;
        var i = this.x;
        return this.x += e, this.free -= e, new g(n, i, this.y, e, t, e, this.h);
    }, p.prototype.resize = function(e) {
        return this.free += e - this.w, this.w = e, !0;
    };
    class _ {
        constructor(e, t){
            m(this, e, 1, t);
        }
        resize(e) {
            y(this, e, 1);
        }
        clone() {
            return new _({
                width: this.width,
                height: this.height
            }, new Uint8Array(this.data));
        }
        static copy(e, t, n, i, r) {
            x(e, t, n, i, r, 1);
        }
    }
    class v {
        constructor(e, t){
            m(this, e, 4, t);
        }
        resize(e) {
            y(this, e, 4);
        }
        clone() {
            return new v({
                width: this.width,
                height: this.height
            }, new Uint8Array(this.data));
        }
        static copy(e, t, n, i, r) {
            x(e, t, n, i, r, 4);
        }
    }
    function b(e) {
        let t = 0;
        for(let n, i, r = 0, s = e.length, o = s - 1; r < s; o = r++)if (n = e[r], i = e[o], void 0 !== n.x) t += (i.x - n.x) * (n.y + i.y);
        else {
            if (n[2] || i[2]) return 1;
            t += (i[0] - n[0]) * (n[1] + i[1]);
        }
        return t;
    }
    function A(e, t, n, i, r) {
        const s = e[t * i], o = e[t * i + 1], a = e[n * i], l = e[n * i + 1];
        return s === a && (s < 0 || s > r) && o !== l || o === l && (o < 0 || o > r) && s !== a;
    }
    function T(e, t, n) {
        let i = n;
        return t && e && (i = +e[t]), isNaN(i) && (i = n || 0), 100 * i;
    }
    function S(e, t, n, i, r, s, o) {
        t || 0 === t || (t = 1);
        const a = T(e.properties, n, i), l = a * t;
        let h = (s ? 100 * s : 0) || a;
        return r ? h = T(e.properties, r, s) : o && (h = a - T(e.properties, o, s)), h *= t, {
            altitude: l,
            height: h
        };
    }
    function w(e, t) {
        return t < 1 / 0 && (e.x < 0 || e.x > t || e.y < 0 || e.y > t);
    }
    function M(e) {
        return null == e;
    }
    function P(e, t, n) {
        if (e === n || e === t) return e;
        const i = n - t;
        return ((e - t) % i + i) % i + t;
    }
    function I(e, t) {
        if (!t) return null;
        const n = new Map;
        for(let i = 0; i < t.length; i++){
            const r = t[i], s = e[r];
            let o = n.get(s);
            o || (o = [], n.set(s, o)), o.push(r);
        }
        return n;
    }
    function C(e) {
        return !(e & e - 1) && 0 !== e;
    }
    /*!
	 * Codes from mapbox-gl-js
	 * github.com/mapbox/mapbox-gl-js
	 * MIT License
	 */ class k {
        constructor(e, t, { pixelRatio: n }){
            this.paddedRect = e, this.pixelRatio = n || 1, this.padding = t;
        }
        get tl() {
            return [
                this.paddedRect.x + this.padding,
                this.paddedRect.y + this.padding
            ];
        }
        get br() {
            return [
                this.paddedRect.x + this.paddedRect.w - this.padding,
                this.paddedRect.y + this.paddedRect.h - this.padding
            ];
        }
        get displaySize() {
            return [
                (this.paddedRect.w - 2 * this.padding) / this.pixelRatio,
                (this.paddedRect.h - 2 * this.padding) / this.pixelRatio
            ];
        }
    }
    class F {
        constructor(e){
            this.glyphMap = e, this.build();
        }
        build() {
            const e = this.glyphMap, t = Object.keys(e).length, n = {}, i = new d(0, 0, {
                autoResize: !0
            }), r = [], s = t > 1 ? 1 : 0;
            for(const t in e){
                const i = e[t], o = {
                    x: 0,
                    y: 0,
                    w: i.data.width + 2 * s,
                    h: i.data.height + 2 * s
                };
                r.push(o), n[t] = new k(o, s, i);
            }
            if (i.pack(r, {
                inPlace: !0
            }), !C(i.w) || !C(i.h)) {
                const e = O(i.w), t = O(i.h);
                i.resize(e, t);
            }
            const o = new v({
                width: i.w,
                height: i.h
            });
            for(const t in e){
                const i = e[t], r = n[t].paddedRect;
                v.copy(i.data, o, {
                    x: 0,
                    y: 0
                }, {
                    x: r.x + s,
                    y: r.y + s
                }, i.data);
            }
            this.image = o, this.positions = n;
        }
    }
    function O(e) {
        return Math.pow(2, Math.ceil(Math.log(e) / Math.LN2));
    }
    /*!
	 * Codes from mapbox-gl-js
	 * github.com/mapbox/mapbox-gl-js
	 * MIT License
	 * TODO 升级为potpack
	 */ class R {
        constructor(e){
            this.glyphMap = e, this.build();
        }
        build() {
            const e = this.glyphMap, t = {}, n = new d(0, 0, {
                autoResize: !0
            }), i = [];
            for(const n in e){
                const r = e[n], s = t[n] = {};
                for(const e in r){
                    const t = r[+e];
                    if (!t || 0 === t.bitmap.width || 0 === t.bitmap.height) continue;
                    const n = {
                        x: 0,
                        y: 0,
                        w: t.bitmap.width + 2,
                        h: t.bitmap.height + 2
                    };
                    i.push(n), s[e] = {
                        rect: n,
                        metrics: t.metrics
                    };
                }
            }
            n.pack(i, {
                inPlace: !0
            });
            const r = new _({
                width: n.w,
                height: n.h
            });
            for(const n in e){
                const i = e[n];
                for(const e in i){
                    const s = i[+e];
                    if (!s || 0 === s.bitmap.width || 0 === s.bitmap.height) continue;
                    const o = t[n][e].rect;
                    _.copy(s.bitmap, r, {
                        x: 0,
                        y: 0
                    }, {
                        x: o.x + 1,
                        y: o.y + 1
                    }, s.bitmap);
                }
            }
            this.image = r, this.positions = t;
        }
    }
    function E(e) {
        return e < 65536 ? Uint16Array : Uint32Array;
    }
    function D(e) {
        return (e = Math.abs(e)) < 128 ? Int8Array : e < 32768 ? Int16Array : Float32Array;
    }
    function L(e) {
        return e < 256 ? Uint8Array : e < 65536 ? Uint16Array : Float32Array;
    }
    function H(e, t) {
        const n = e.getLength ? e.getLength() : e.length;
        if (e instanceof t) return e.slice(0, n);
        const i = new t(n);
        e = e._origin || e;
        for(let t = 0; t < n; t++)i[t] = e[t] || 0;
        return i;
    }
    function N(e) {
        const t = e.type, n = [];
        if (1 === t || 4 === t) for(let t = 0; t < e.geometry.length; t++)h(e.geometry[t], n);
        else if (2 === t) u(e.geometry, n);
        else if (3 === t) u(e.geometry, n);
        else if (5 === t) u(e.geometry, n);
        else if (6 === t) for(let t = 0; t < e.geometry.length; t++){
            const i = [];
            u(e.geometry[t], i), n.push(i);
        }
        return e.geometry = n, e;
    }
    let z;
    const V = {
        width: 100,
        height: 10
    };
    let U = !1;
    try {
        new OffscreenCanvas(1, 1).getContext("2d").fillText("hello", 0, 0), U = !0;
    } catch (e) {
        U = !1;
    }
    class B {
        constructor(e, t = {}){
            if (!Array.isArray(e)) return void console.error("colors is not array");
            if (e.length < 2) return void console.error("colors.length should >1");
            this.colors = e;
            let n = 1 / 0, i = -1 / 0;
            for(let t = 0, r = e.length; t < r; t++){
                const r = e[t][0];
                n = Math.min(r, n), i = Math.max(r, i);
            }
            this.min = n, this.max = i, this.valueOffset = this.max - this.min, this.options = Object.assign({}, V, t), this._initImgData();
        }
        getImageData() {
            return this.imgData;
        }
        _initImgData() {
            const e = function() {
                if (!z) {
                    const { width: e, height: t } = V;
                    U ? z = new OffscreenCanvas(e, t) : (z = document.createElement("canvas"), z.width = e, z.height = t);
                }
                return z;
            }(), { width: t, height: n } = this.options;
            e.width = t, e.height = n;
            const i = e.getContext("2d");
            i.clearRect(0, 0, e.width, e.height);
            const r = i.createLinearGradient(0, 0, e.width, 0), { colors: s, valueOffset: o } = this;
            for(let e = 0, t = s.length; e < t; e++){
                const [t, n] = s[e], i = (t - this.min) / o;
                r.addColorStop(i, n);
            }
            i.fillStyle = r, i.fillRect(0, 0, e.width, e.height), this.imgData = i.getImageData(0, 0, e.width, e.height);
        }
        getColor(e) {
            e = Math.max(this.min, e);
            const t = ((e = Math.min(e, this.max)) - this.min) / this.valueOffset;
            let n = Math.round(t * this.imgData.width);
            n = Math.min(n, this.imgData.width - 1);
            const i = 4 * n;
            return [
                this.imgData.data[i],
                this.imgData.data[i + 1],
                this.imgData.data[i + 2],
                this.imgData.data[i + 3]
            ];
        }
    }
    var G;
    function j(e) {
        return null == e;
    }
    function W(e) {
        return !j(e);
    }
    function X(e) {
        return "" === e;
    }
    function Y(e, t) {
        var n, i, r;
        if (ie(e)) {
            var s, o = e.stops && "object" == typeof e.stops[0][0], a = o || W(e.property), l = o || !a, h = e.type || t || "exponential";
            if ("exponential" === h) s = $;
            else if ("interval" === h) s = q;
            else if ("categorical" === h) s = Z;
            else if ("identity" === h) s = Q;
            else if ("color-interpolate" === h) s = K;
            else {
                if ("calculate-expression" !== h) throw new Error('Unknown function type "' + h + '"');
                s = ee;
            }
            if (o) {
                var c = {}, u = [];
                for(let t = 0; t < e.stops.length; t++){
                    var f = e.stops[t];
                    void 0 === c[f[0].zoom] && (c[f[0].zoom] = {
                        zoom: f[0].zoom,
                        type: e.type,
                        property: e.property,
                        default: e.default,
                        stops: []
                    }), c[f[0].zoom].stops.push([
                        f[0].value,
                        f[1]
                    ]);
                }
                for(let e in c)u.push([
                    c[e].zoom,
                    Y(c[e])
                ]);
                n = function(t, n) {
                    const i = $({
                        stops: u,
                        base: e.base
                    }, t)(t, n);
                    return "function" == typeof i ? i(t, n) : i;
                }, i = !1, r = !1;
            } else l ? (n = function(t) {
                const n = s(e, t);
                return "function" == typeof n ? n(t) : n;
            }, i = !0, r = !1) : (n = function(t, n) {
                const i = s(e, n ? n[e.property] : null);
                return "function" == typeof i ? i(t, n) : i;
            }, i = !1, r = !0);
        } else n = function() {
            return e;
        }, i = !0, r = !0;
        return n.isZoomConstant = r, n.isFeatureConstant = i, n;
    }
    function Z(e, t) {
        for(let n = 0; n < e.stops.length; n++)if (t === e.stops[n][0]) return e.stops[n][1];
        return e.default;
    }
    function q(e, t) {
        for(var n = 0; n < e.stops.length && !(t < e.stops[n][0]); n++);
        return e.stops[Math.max(n - 1, 0)][1];
    }
    function $(e, t) {
        for(var n = W(e.base) && !X(e.base) ? e.base : 1, i = 0; !(i >= e.stops.length || t <= e.stops[i][0]);)i++;
        return 0 === i ? e.stops[i][1] : i === e.stops.length ? e.stops[i - 1][1] : te(t, n, e.stops[i - 1][0], e.stops[i][0], e.stops[i - 1][1], e.stops[i][1]);
    }
    "function" == typeof Map && (G = new Map);
    const J = {
        width: 100,
        height: 1
    };
    function K(e, t) {
        const n = e.stops;
        if (n && n.length > 1) {
            let e;
            if (G) {
                const t = JSON.stringify(n);
                if (!G.has(t)) {
                    const e = new B(n, J);
                    G.set(t, e);
                }
                e = G.get(t);
            } else e = new B(n, J);
            const [i, r, s, o] = e.getColor(t);
            return [
                i / 255,
                r / 255,
                s / 255,
                o / 255
            ];
        }
        return n && 1 === n.length ? n[0][1] : null;
    }
    function Q(e, t) {
        var n, i, r;
        return n = t, i = e.default, W(n) ? n : W(i) ? i : W(r) ? r : null;
    }
    function ee(e, t) {
        const n = String(e.property), i = e.expression, r = t;
        function s(t) {
            return j(t) || X(t) || isNaN(t) ? e.default : t;
        }
        if (!W(t) || X(t) || isNaN(t) || t < 0) return s(e.default);
        {
            const t = function e(t, n, i) {
                const r = Number(i), s = String(n);
                return Array.isArray(t) ? t.map((t)=>e(t, s, r)) : t === s ? r : t;
            }(i, n, r);
            return s(function t(n) {
                if (!Array.isArray(n)) {
                    if ("number" == typeof n) return n;
                    throw new Error("Invalid expression format");
                }
                {
                    const i = n[0];
                    if (![
                        "+",
                        "-",
                        "*",
                        "/"
                    ].includes(i)) throw new Error(`Unknown operator: ${i}`);
                    const r = n.slice(1).map((e)=>t(e));
                    switch(i){
                        case "+":
                            return r.reduce((e, t)=>e + t, 0);
                        case "-":
                            return r.reduce((e, t)=>e - t);
                        case "*":
                            return r.reduce((e, t)=>e * t, 1);
                        case "/":
                            return r.some((e)=>0 === e) ? e.default : r.reduce((e, t)=>e / t);
                        default:
                            throw new Error(`Unsupported operator: ${i}`);
                    }
                }
            }(t));
        }
    }
    function te(e, t, n, i, r, s) {
        return "function" == typeof r ? function() {
            var o = r.apply(void 0, arguments), a = s.apply(void 0, arguments);
            return te(e, t, n, i, o, a);
        } : r.length ? function(e, t, n, i, r, s) {
            var o = [];
            for(let a = 0; a < r.length; a++)o[a] = ne(e, t, n, i, r[a], s[a]);
            return o;
        }(e, t, n, i, r, s) : ne(e, t, n, i, r, s);
    }
    function ne(e, t, n, i, r, s) {
        var o, a = i - n, l = e - n;
        return r * (1 - (o = 1 === t ? l / a : (Math.pow(t, l) - 1) / (Math.pow(t, a) - 1))) + s * o;
    }
    function ie(e) {
        return e && "object" == typeof e && (e.stops || e.property && "identity" === e.type || e.expression && "calculate-expression" === e.type);
    }
    function re(e) {
        return ae(e, "exponential");
    }
    function se(e) {
        return ae(e, "interval");
    }
    function oe(e, t) {
        if (!e) return null;
        var n = !1;
        if (Array.isArray(e)) {
            var i, r = [];
            for(let s = 0; s < e.length; s++)(i = oe(e[s], t)) ? (r.push(i), n = !0) : r.push(e[s]);
            return n ? r : e;
        }
        var s, o = {
            __fn_types_loaded: !0
        }, a = [];
        for(s in e)e.hasOwnProperty(s) && a.push(s);
        const l = function(e) {
            Object.defineProperty(o, e, {
                get: function() {
                    return this["__fn_" + e] || (this["__fn_" + e] = re(this["_" + e])), this["__fn_" + e].apply(this, t());
                },
                set: function(t) {
                    this["_" + e] = t;
                },
                configurable: !0,
                enumerable: !0
            });
        };
        for(let t = 0, i = a.length; t < i; t++)ie(e[s = a[t]]) ? (n = !0, o["_" + s] = e[s], l(s)) : o[s] = e[s];
        return n ? o : e;
    }
    function ae(e, t) {
        if (!ie(e)) return function() {
            return e;
        };
        let n = !0, i = !0;
        const r = (e = JSON.parse(JSON.stringify(e))).stops;
        if (r) {
            for(let e = 0; e < r.length; e++)if (ie(r[e][1])) {
                const s = ae(r[e][1], t);
                n = n && s.isZoomConstant, i = i && s.isFeatureConstant, r[e] = [
                    r[e][0],
                    s
                ];
            }
        }
        const s = Y(e, t);
        return s.isZoomConstant = n && s.isZoomConstant, s.isFeatureConstant = i && s.isFeatureConstant, s;
    }
    var le = {
        exports: {}
    }, he = {
        exports: {}
    }, ce = function(e) {
        return !(!e || "string" == typeof e) && (e instanceof Array || Array.isArray(e) || e.length >= 0 && (e.splice instanceof Function || Object.getOwnPropertyDescriptor(e, e.length - 1) && "String" !== e.constructor.name));
    }, ue = Array.prototype.concat, fe = Array.prototype.slice, de = he.exports = function(e) {
        for(var t = [], n = 0, i = e.length; n < i; n++){
            var r = e[n];
            ce(r) ? t = ue.call(t, fe.call(r)) : t.push(r);
        }
        return t;
    };
    de.wrap = function(e) {
        return function() {
            return e(de(arguments));
        };
    };
    var pe = he.exports, ge = {
        aliceblue: [
            240,
            248,
            255
        ],
        antiquewhite: [
            250,
            235,
            215
        ],
        aqua: [
            0,
            255,
            255
        ],
        aquamarine: [
            127,
            255,
            212
        ],
        azure: [
            240,
            255,
            255
        ],
        beige: [
            245,
            245,
            220
        ],
        bisque: [
            255,
            228,
            196
        ],
        black: [
            0,
            0,
            0
        ],
        blanchedalmond: [
            255,
            235,
            205
        ],
        blue: [
            0,
            0,
            255
        ],
        blueviolet: [
            138,
            43,
            226
        ],
        brown: [
            165,
            42,
            42
        ],
        burlywood: [
            222,
            184,
            135
        ],
        cadetblue: [
            95,
            158,
            160
        ],
        chartreuse: [
            127,
            255,
            0
        ],
        chocolate: [
            210,
            105,
            30
        ],
        coral: [
            255,
            127,
            80
        ],
        cornflowerblue: [
            100,
            149,
            237
        ],
        cornsilk: [
            255,
            248,
            220
        ],
        crimson: [
            220,
            20,
            60
        ],
        cyan: [
            0,
            255,
            255
        ],
        darkblue: [
            0,
            0,
            139
        ],
        darkcyan: [
            0,
            139,
            139
        ],
        darkgoldenrod: [
            184,
            134,
            11
        ],
        darkgray: [
            169,
            169,
            169
        ],
        darkgreen: [
            0,
            100,
            0
        ],
        darkgrey: [
            169,
            169,
            169
        ],
        darkkhaki: [
            189,
            183,
            107
        ],
        darkmagenta: [
            139,
            0,
            139
        ],
        darkolivegreen: [
            85,
            107,
            47
        ],
        darkorange: [
            255,
            140,
            0
        ],
        darkorchid: [
            153,
            50,
            204
        ],
        darkred: [
            139,
            0,
            0
        ],
        darksalmon: [
            233,
            150,
            122
        ],
        darkseagreen: [
            143,
            188,
            143
        ],
        darkslateblue: [
            72,
            61,
            139
        ],
        darkslategray: [
            47,
            79,
            79
        ],
        darkslategrey: [
            47,
            79,
            79
        ],
        darkturquoise: [
            0,
            206,
            209
        ],
        darkviolet: [
            148,
            0,
            211
        ],
        deeppink: [
            255,
            20,
            147
        ],
        deepskyblue: [
            0,
            191,
            255
        ],
        dimgray: [
            105,
            105,
            105
        ],
        dimgrey: [
            105,
            105,
            105
        ],
        dodgerblue: [
            30,
            144,
            255
        ],
        firebrick: [
            178,
            34,
            34
        ],
        floralwhite: [
            255,
            250,
            240
        ],
        forestgreen: [
            34,
            139,
            34
        ],
        fuchsia: [
            255,
            0,
            255
        ],
        gainsboro: [
            220,
            220,
            220
        ],
        ghostwhite: [
            248,
            248,
            255
        ],
        gold: [
            255,
            215,
            0
        ],
        goldenrod: [
            218,
            165,
            32
        ],
        gray: [
            128,
            128,
            128
        ],
        green: [
            0,
            128,
            0
        ],
        greenyellow: [
            173,
            255,
            47
        ],
        grey: [
            128,
            128,
            128
        ],
        honeydew: [
            240,
            255,
            240
        ],
        hotpink: [
            255,
            105,
            180
        ],
        indianred: [
            205,
            92,
            92
        ],
        indigo: [
            75,
            0,
            130
        ],
        ivory: [
            255,
            255,
            240
        ],
        khaki: [
            240,
            230,
            140
        ],
        lavender: [
            230,
            230,
            250
        ],
        lavenderblush: [
            255,
            240,
            245
        ],
        lawngreen: [
            124,
            252,
            0
        ],
        lemonchiffon: [
            255,
            250,
            205
        ],
        lightblue: [
            173,
            216,
            230
        ],
        lightcoral: [
            240,
            128,
            128
        ],
        lightcyan: [
            224,
            255,
            255
        ],
        lightgoldenrodyellow: [
            250,
            250,
            210
        ],
        lightgray: [
            211,
            211,
            211
        ],
        lightgreen: [
            144,
            238,
            144
        ],
        lightgrey: [
            211,
            211,
            211
        ],
        lightpink: [
            255,
            182,
            193
        ],
        lightsalmon: [
            255,
            160,
            122
        ],
        lightseagreen: [
            32,
            178,
            170
        ],
        lightskyblue: [
            135,
            206,
            250
        ],
        lightslategray: [
            119,
            136,
            153
        ],
        lightslategrey: [
            119,
            136,
            153
        ],
        lightsteelblue: [
            176,
            196,
            222
        ],
        lightyellow: [
            255,
            255,
            224
        ],
        lime: [
            0,
            255,
            0
        ],
        limegreen: [
            50,
            205,
            50
        ],
        linen: [
            250,
            240,
            230
        ],
        magenta: [
            255,
            0,
            255
        ],
        maroon: [
            128,
            0,
            0
        ],
        mediumaquamarine: [
            102,
            205,
            170
        ],
        mediumblue: [
            0,
            0,
            205
        ],
        mediumorchid: [
            186,
            85,
            211
        ],
        mediumpurple: [
            147,
            112,
            219
        ],
        mediumseagreen: [
            60,
            179,
            113
        ],
        mediumslateblue: [
            123,
            104,
            238
        ],
        mediumspringgreen: [
            0,
            250,
            154
        ],
        mediumturquoise: [
            72,
            209,
            204
        ],
        mediumvioletred: [
            199,
            21,
            133
        ],
        midnightblue: [
            25,
            25,
            112
        ],
        mintcream: [
            245,
            255,
            250
        ],
        mistyrose: [
            255,
            228,
            225
        ],
        moccasin: [
            255,
            228,
            181
        ],
        navajowhite: [
            255,
            222,
            173
        ],
        navy: [
            0,
            0,
            128
        ],
        oldlace: [
            253,
            245,
            230
        ],
        olive: [
            128,
            128,
            0
        ],
        olivedrab: [
            107,
            142,
            35
        ],
        orange: [
            255,
            165,
            0
        ],
        orangered: [
            255,
            69,
            0
        ],
        orchid: [
            218,
            112,
            214
        ],
        palegoldenrod: [
            238,
            232,
            170
        ],
        palegreen: [
            152,
            251,
            152
        ],
        paleturquoise: [
            175,
            238,
            238
        ],
        palevioletred: [
            219,
            112,
            147
        ],
        papayawhip: [
            255,
            239,
            213
        ],
        peachpuff: [
            255,
            218,
            185
        ],
        peru: [
            205,
            133,
            63
        ],
        pink: [
            255,
            192,
            203
        ],
        plum: [
            221,
            160,
            221
        ],
        powderblue: [
            176,
            224,
            230
        ],
        purple: [
            128,
            0,
            128
        ],
        rebeccapurple: [
            102,
            51,
            153
        ],
        red: [
            255,
            0,
            0
        ],
        rosybrown: [
            188,
            143,
            143
        ],
        royalblue: [
            65,
            105,
            225
        ],
        saddlebrown: [
            139,
            69,
            19
        ],
        salmon: [
            250,
            128,
            114
        ],
        sandybrown: [
            244,
            164,
            96
        ],
        seagreen: [
            46,
            139,
            87
        ],
        seashell: [
            255,
            245,
            238
        ],
        sienna: [
            160,
            82,
            45
        ],
        silver: [
            192,
            192,
            192
        ],
        skyblue: [
            135,
            206,
            235
        ],
        slateblue: [
            106,
            90,
            205
        ],
        slategray: [
            112,
            128,
            144
        ],
        slategrey: [
            112,
            128,
            144
        ],
        snow: [
            255,
            250,
            250
        ],
        springgreen: [
            0,
            255,
            127
        ],
        steelblue: [
            70,
            130,
            180
        ],
        tan: [
            210,
            180,
            140
        ],
        teal: [
            0,
            128,
            128
        ],
        thistle: [
            216,
            191,
            216
        ],
        tomato: [
            255,
            99,
            71
        ],
        turquoise: [
            64,
            224,
            208
        ],
        violet: [
            238,
            130,
            238
        ],
        wheat: [
            245,
            222,
            179
        ],
        white: [
            255,
            255,
            255
        ],
        whitesmoke: [
            245,
            245,
            245
        ],
        yellow: [
            255,
            255,
            0
        ],
        yellowgreen: [
            154,
            205,
            50
        ]
    }, me = pe, ye = Object.hasOwnProperty, xe = Object.create(null);
    for(var _e in ge)ye.call(ge, _e) && (xe[ge[_e]] = _e);
    var ve = le.exports = {
        to: {},
        get: {}
    };
    function be(e, t, n) {
        return Math.min(Math.max(t, e), n);
    }
    function Ae(e) {
        var t = Math.round(e).toString(16).toUpperCase();
        return t.length < 2 ? "0" + t : t;
    }
    ve.get = function(e) {
        var t, n;
        switch(e.substring(0, 3).toLowerCase()){
            case "hsl":
                t = ve.get.hsl(e), n = "hsl";
                break;
            case "hwb":
                t = ve.get.hwb(e), n = "hwb";
                break;
            default:
                t = ve.get.rgb(e), n = "rgb";
        }
        return t ? {
            model: n,
            value: t
        } : null;
    }, ve.get.rgb = function(e) {
        if (!e) return null;
        var t, n, i, r = [
            0,
            0,
            0,
            1
        ];
        if (t = e.match(/^#([a-f0-9]{6})([a-f0-9]{2})?$/i)) {
            for(i = t[2], t = t[1], n = 0; n < 3; n++){
                var s = 2 * n;
                r[n] = parseInt(t.slice(s, s + 2), 16);
            }
            i && (r[3] = parseInt(i, 16) / 255);
        } else if (t = e.match(/^#([a-f0-9]{3,4})$/i)) {
            for(i = (t = t[1])[3], n = 0; n < 3; n++)r[n] = parseInt(t[n] + t[n], 16);
            i && (r[3] = parseInt(i + i, 16) / 255);
        } else if (t = e.match(/^rgba?\(\s*([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/)) {
            for(n = 0; n < 3; n++)r[n] = parseInt(t[n + 1], 0);
            t[4] && (t[5] ? r[3] = .01 * parseFloat(t[4]) : r[3] = parseFloat(t[4]));
        } else {
            if (!(t = e.match(/^rgba?\(\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/))) return (t = e.match(/^(\w+)$/)) ? "transparent" === t[1] ? [
                0,
                0,
                0,
                0
            ] : ye.call(ge, t[1]) ? ((r = ge[t[1]])[3] = 1, r) : null : null;
            for(n = 0; n < 3; n++)r[n] = Math.round(2.55 * parseFloat(t[n + 1]));
            t[4] && (t[5] ? r[3] = .01 * parseFloat(t[4]) : r[3] = parseFloat(t[4]));
        }
        for(n = 0; n < 3; n++)r[n] = be(r[n], 0, 255);
        return r[3] = be(r[3], 0, 1), r;
    }, ve.get.hsl = function(e) {
        if (!e) return null;
        var t = e.match(/^hsla?\(\s*([+-]?(?:\d{0,3}\.)?\d+)(?:deg)?\s*,?\s*([+-]?[\d\.]+)%\s*,?\s*([+-]?[\d\.]+)%\s*(?:[,|\/]\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/);
        if (t) {
            var n = parseFloat(t[4]);
            return [
                (parseFloat(t[1]) % 360 + 360) % 360,
                be(parseFloat(t[2]), 0, 100),
                be(parseFloat(t[3]), 0, 100),
                be(isNaN(n) ? 1 : n, 0, 1)
            ];
        }
        return null;
    }, ve.get.hwb = function(e) {
        if (!e) return null;
        var t = e.match(/^hwb\(\s*([+-]?\d{0,3}(?:\.\d+)?)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/);
        if (t) {
            var n = parseFloat(t[4]);
            return [
                (parseFloat(t[1]) % 360 + 360) % 360,
                be(parseFloat(t[2]), 0, 100),
                be(parseFloat(t[3]), 0, 100),
                be(isNaN(n) ? 1 : n, 0, 1)
            ];
        }
        return null;
    }, ve.to.hex = function() {
        var e = me(arguments);
        return "#" + Ae(e[0]) + Ae(e[1]) + Ae(e[2]) + (e[3] < 1 ? Ae(Math.round(255 * e[3])) : "");
    }, ve.to.rgb = function() {
        var e = me(arguments);
        return e.length < 4 || 1 === e[3] ? "rgb(" + Math.round(e[0]) + ", " + Math.round(e[1]) + ", " + Math.round(e[2]) + ")" : "rgba(" + Math.round(e[0]) + ", " + Math.round(e[1]) + ", " + Math.round(e[2]) + ", " + e[3] + ")";
    }, ve.to.rgb.percent = function() {
        var e = me(arguments), t = Math.round(e[0] / 255 * 100), n = Math.round(e[1] / 255 * 100), i = Math.round(e[2] / 255 * 100);
        return e.length < 4 || 1 === e[3] ? "rgb(" + t + "%, " + n + "%, " + i + "%)" : "rgba(" + t + "%, " + n + "%, " + i + "%, " + e[3] + ")";
    }, ve.to.hsl = function() {
        var e = me(arguments);
        return e.length < 4 || 1 === e[3] ? "hsl(" + e[0] + ", " + e[1] + "%, " + e[2] + "%)" : "hsla(" + e[0] + ", " + e[1] + "%, " + e[2] + "%, " + e[3] + ")";
    }, ve.to.hwb = function() {
        var e = me(arguments), t = "";
        return e.length >= 4 && 1 !== e[3] && (t = ", " + e[3]), "hwb(" + e[0] + ", " + e[1] + "%, " + e[2] + "%" + t + ")";
    }, ve.to.keyword = function(e) {
        return xe[e.slice(0, 3)];
    };
    var Te = le.exports, Se = {
        exports: {}
    }, we = {
        aliceblue: [
            240,
            248,
            255
        ],
        antiquewhite: [
            250,
            235,
            215
        ],
        aqua: [
            0,
            255,
            255
        ],
        aquamarine: [
            127,
            255,
            212
        ],
        azure: [
            240,
            255,
            255
        ],
        beige: [
            245,
            245,
            220
        ],
        bisque: [
            255,
            228,
            196
        ],
        black: [
            0,
            0,
            0
        ],
        blanchedalmond: [
            255,
            235,
            205
        ],
        blue: [
            0,
            0,
            255
        ],
        blueviolet: [
            138,
            43,
            226
        ],
        brown: [
            165,
            42,
            42
        ],
        burlywood: [
            222,
            184,
            135
        ],
        cadetblue: [
            95,
            158,
            160
        ],
        chartreuse: [
            127,
            255,
            0
        ],
        chocolate: [
            210,
            105,
            30
        ],
        coral: [
            255,
            127,
            80
        ],
        cornflowerblue: [
            100,
            149,
            237
        ],
        cornsilk: [
            255,
            248,
            220
        ],
        crimson: [
            220,
            20,
            60
        ],
        cyan: [
            0,
            255,
            255
        ],
        darkblue: [
            0,
            0,
            139
        ],
        darkcyan: [
            0,
            139,
            139
        ],
        darkgoldenrod: [
            184,
            134,
            11
        ],
        darkgray: [
            169,
            169,
            169
        ],
        darkgreen: [
            0,
            100,
            0
        ],
        darkgrey: [
            169,
            169,
            169
        ],
        darkkhaki: [
            189,
            183,
            107
        ],
        darkmagenta: [
            139,
            0,
            139
        ],
        darkolivegreen: [
            85,
            107,
            47
        ],
        darkorange: [
            255,
            140,
            0
        ],
        darkorchid: [
            153,
            50,
            204
        ],
        darkred: [
            139,
            0,
            0
        ],
        darksalmon: [
            233,
            150,
            122
        ],
        darkseagreen: [
            143,
            188,
            143
        ],
        darkslateblue: [
            72,
            61,
            139
        ],
        darkslategray: [
            47,
            79,
            79
        ],
        darkslategrey: [
            47,
            79,
            79
        ],
        darkturquoise: [
            0,
            206,
            209
        ],
        darkviolet: [
            148,
            0,
            211
        ],
        deeppink: [
            255,
            20,
            147
        ],
        deepskyblue: [
            0,
            191,
            255
        ],
        dimgray: [
            105,
            105,
            105
        ],
        dimgrey: [
            105,
            105,
            105
        ],
        dodgerblue: [
            30,
            144,
            255
        ],
        firebrick: [
            178,
            34,
            34
        ],
        floralwhite: [
            255,
            250,
            240
        ],
        forestgreen: [
            34,
            139,
            34
        ],
        fuchsia: [
            255,
            0,
            255
        ],
        gainsboro: [
            220,
            220,
            220
        ],
        ghostwhite: [
            248,
            248,
            255
        ],
        gold: [
            255,
            215,
            0
        ],
        goldenrod: [
            218,
            165,
            32
        ],
        gray: [
            128,
            128,
            128
        ],
        green: [
            0,
            128,
            0
        ],
        greenyellow: [
            173,
            255,
            47
        ],
        grey: [
            128,
            128,
            128
        ],
        honeydew: [
            240,
            255,
            240
        ],
        hotpink: [
            255,
            105,
            180
        ],
        indianred: [
            205,
            92,
            92
        ],
        indigo: [
            75,
            0,
            130
        ],
        ivory: [
            255,
            255,
            240
        ],
        khaki: [
            240,
            230,
            140
        ],
        lavender: [
            230,
            230,
            250
        ],
        lavenderblush: [
            255,
            240,
            245
        ],
        lawngreen: [
            124,
            252,
            0
        ],
        lemonchiffon: [
            255,
            250,
            205
        ],
        lightblue: [
            173,
            216,
            230
        ],
        lightcoral: [
            240,
            128,
            128
        ],
        lightcyan: [
            224,
            255,
            255
        ],
        lightgoldenrodyellow: [
            250,
            250,
            210
        ],
        lightgray: [
            211,
            211,
            211
        ],
        lightgreen: [
            144,
            238,
            144
        ],
        lightgrey: [
            211,
            211,
            211
        ],
        lightpink: [
            255,
            182,
            193
        ],
        lightsalmon: [
            255,
            160,
            122
        ],
        lightseagreen: [
            32,
            178,
            170
        ],
        lightskyblue: [
            135,
            206,
            250
        ],
        lightslategray: [
            119,
            136,
            153
        ],
        lightslategrey: [
            119,
            136,
            153
        ],
        lightsteelblue: [
            176,
            196,
            222
        ],
        lightyellow: [
            255,
            255,
            224
        ],
        lime: [
            0,
            255,
            0
        ],
        limegreen: [
            50,
            205,
            50
        ],
        linen: [
            250,
            240,
            230
        ],
        magenta: [
            255,
            0,
            255
        ],
        maroon: [
            128,
            0,
            0
        ],
        mediumaquamarine: [
            102,
            205,
            170
        ],
        mediumblue: [
            0,
            0,
            205
        ],
        mediumorchid: [
            186,
            85,
            211
        ],
        mediumpurple: [
            147,
            112,
            219
        ],
        mediumseagreen: [
            60,
            179,
            113
        ],
        mediumslateblue: [
            123,
            104,
            238
        ],
        mediumspringgreen: [
            0,
            250,
            154
        ],
        mediumturquoise: [
            72,
            209,
            204
        ],
        mediumvioletred: [
            199,
            21,
            133
        ],
        midnightblue: [
            25,
            25,
            112
        ],
        mintcream: [
            245,
            255,
            250
        ],
        mistyrose: [
            255,
            228,
            225
        ],
        moccasin: [
            255,
            228,
            181
        ],
        navajowhite: [
            255,
            222,
            173
        ],
        navy: [
            0,
            0,
            128
        ],
        oldlace: [
            253,
            245,
            230
        ],
        olive: [
            128,
            128,
            0
        ],
        olivedrab: [
            107,
            142,
            35
        ],
        orange: [
            255,
            165,
            0
        ],
        orangered: [
            255,
            69,
            0
        ],
        orchid: [
            218,
            112,
            214
        ],
        palegoldenrod: [
            238,
            232,
            170
        ],
        palegreen: [
            152,
            251,
            152
        ],
        paleturquoise: [
            175,
            238,
            238
        ],
        palevioletred: [
            219,
            112,
            147
        ],
        papayawhip: [
            255,
            239,
            213
        ],
        peachpuff: [
            255,
            218,
            185
        ],
        peru: [
            205,
            133,
            63
        ],
        pink: [
            255,
            192,
            203
        ],
        plum: [
            221,
            160,
            221
        ],
        powderblue: [
            176,
            224,
            230
        ],
        purple: [
            128,
            0,
            128
        ],
        rebeccapurple: [
            102,
            51,
            153
        ],
        red: [
            255,
            0,
            0
        ],
        rosybrown: [
            188,
            143,
            143
        ],
        royalblue: [
            65,
            105,
            225
        ],
        saddlebrown: [
            139,
            69,
            19
        ],
        salmon: [
            250,
            128,
            114
        ],
        sandybrown: [
            244,
            164,
            96
        ],
        seagreen: [
            46,
            139,
            87
        ],
        seashell: [
            255,
            245,
            238
        ],
        sienna: [
            160,
            82,
            45
        ],
        silver: [
            192,
            192,
            192
        ],
        skyblue: [
            135,
            206,
            235
        ],
        slateblue: [
            106,
            90,
            205
        ],
        slategray: [
            112,
            128,
            144
        ],
        slategrey: [
            112,
            128,
            144
        ],
        snow: [
            255,
            250,
            250
        ],
        springgreen: [
            0,
            255,
            127
        ],
        steelblue: [
            70,
            130,
            180
        ],
        tan: [
            210,
            180,
            140
        ],
        teal: [
            0,
            128,
            128
        ],
        thistle: [
            216,
            191,
            216
        ],
        tomato: [
            255,
            99,
            71
        ],
        turquoise: [
            64,
            224,
            208
        ],
        violet: [
            238,
            130,
            238
        ],
        wheat: [
            245,
            222,
            179
        ],
        white: [
            255,
            255,
            255
        ],
        whitesmoke: [
            245,
            245,
            245
        ],
        yellow: [
            255,
            255,
            0
        ],
        yellowgreen: [
            154,
            205,
            50
        ]
    }, Me = {};
    for(var Pe in we)we.hasOwnProperty(Pe) && (Me[we[Pe]] = Pe);
    var Ie = Se.exports = {
        rgb: {
            channels: 3,
            labels: "rgb"
        },
        hsl: {
            channels: 3,
            labels: "hsl"
        },
        hsv: {
            channels: 3,
            labels: "hsv"
        },
        hwb: {
            channels: 3,
            labels: "hwb"
        },
        cmyk: {
            channels: 4,
            labels: "cmyk"
        },
        xyz: {
            channels: 3,
            labels: "xyz"
        },
        lab: {
            channels: 3,
            labels: "lab"
        },
        lch: {
            channels: 3,
            labels: "lch"
        },
        hex: {
            channels: 1,
            labels: [
                "hex"
            ]
        },
        keyword: {
            channels: 1,
            labels: [
                "keyword"
            ]
        },
        ansi16: {
            channels: 1,
            labels: [
                "ansi16"
            ]
        },
        ansi256: {
            channels: 1,
            labels: [
                "ansi256"
            ]
        },
        hcg: {
            channels: 3,
            labels: [
                "h",
                "c",
                "g"
            ]
        },
        apple: {
            channels: 3,
            labels: [
                "r16",
                "g16",
                "b16"
            ]
        },
        gray: {
            channels: 1,
            labels: [
                "gray"
            ]
        }
    };
    for(var Ce in Ie)if (Ie.hasOwnProperty(Ce)) {
        if (!("channels" in Ie[Ce])) throw new Error("missing channels property: " + Ce);
        if (!("labels" in Ie[Ce])) throw new Error("missing channel labels property: " + Ce);
        if (Ie[Ce].labels.length !== Ie[Ce].channels) throw new Error("channel and label counts mismatch: " + Ce);
        var ke = Ie[Ce].channels, Fe = Ie[Ce].labels;
        delete Ie[Ce].channels, delete Ie[Ce].labels, Object.defineProperty(Ie[Ce], "channels", {
            value: ke
        }), Object.defineProperty(Ie[Ce], "labels", {
            value: Fe
        });
    }
    Ie.rgb.hsl = function(e) {
        var t, n, i = e[0] / 255, r = e[1] / 255, s = e[2] / 255, o = Math.min(i, r, s), a = Math.max(i, r, s), l = a - o;
        return a === o ? t = 0 : i === a ? t = (r - s) / l : r === a ? t = 2 + (s - i) / l : s === a && (t = 4 + (i - r) / l), (t = Math.min(60 * t, 360)) < 0 && (t += 360), n = (o + a) / 2, [
            t,
            100 * (a === o ? 0 : n <= .5 ? l / (a + o) : l / (2 - a - o)),
            100 * n
        ];
    }, Ie.rgb.hsv = function(e) {
        var t, n, i, r, s, o = e[0] / 255, a = e[1] / 255, l = e[2] / 255, h = Math.max(o, a, l), c = h - Math.min(o, a, l), u = function(e) {
            return (h - e) / 6 / c + .5;
        };
        return 0 === c ? r = s = 0 : (s = c / h, t = u(o), n = u(a), i = u(l), o === h ? r = i - n : a === h ? r = 1 / 3 + t - i : l === h && (r = 2 / 3 + n - t), r < 0 ? r += 1 : r > 1 && (r -= 1)), [
            360 * r,
            100 * s,
            100 * h
        ];
    }, Ie.rgb.hwb = function(e) {
        var t = e[0], n = e[1], i = e[2];
        return [
            Ie.rgb.hsl(e)[0],
            1 / 255 * Math.min(t, Math.min(n, i)) * 100,
            100 * (i = 1 - 1 / 255 * Math.max(t, Math.max(n, i)))
        ];
    }, Ie.rgb.cmyk = function(e) {
        var t, n = e[0] / 255, i = e[1] / 255, r = e[2] / 255;
        return [
            100 * ((1 - n - (t = Math.min(1 - n, 1 - i, 1 - r))) / (1 - t) || 0),
            100 * ((1 - i - t) / (1 - t) || 0),
            100 * ((1 - r - t) / (1 - t) || 0),
            100 * t
        ];
    }, Ie.rgb.keyword = function(e) {
        var t = Me[e];
        if (t) return t;
        var n, i, r, s = 1 / 0;
        for(var o in we)if (we.hasOwnProperty(o)) {
            var a = (i = e, r = we[o], Math.pow(i[0] - r[0], 2) + Math.pow(i[1] - r[1], 2) + Math.pow(i[2] - r[2], 2));
            a < s && (s = a, n = o);
        }
        return n;
    }, Ie.keyword.rgb = function(e) {
        return we[e];
    }, Ie.rgb.xyz = function(e) {
        var t = e[0] / 255, n = e[1] / 255, i = e[2] / 255;
        return [
            100 * (.4124 * (t = t > .04045 ? Math.pow((t + .055) / 1.055, 2.4) : t / 12.92) + .3576 * (n = n > .04045 ? Math.pow((n + .055) / 1.055, 2.4) : n / 12.92) + .1805 * (i = i > .04045 ? Math.pow((i + .055) / 1.055, 2.4) : i / 12.92)),
            100 * (.2126 * t + .7152 * n + .0722 * i),
            100 * (.0193 * t + .1192 * n + .9505 * i)
        ];
    }, Ie.rgb.lab = function(e) {
        var t = Ie.rgb.xyz(e), n = t[0], i = t[1], r = t[2];
        return i /= 100, r /= 108.883, n = (n /= 95.047) > .008856 ? Math.pow(n, 1 / 3) : 7.787 * n + 16 / 116, [
            116 * (i = i > .008856 ? Math.pow(i, 1 / 3) : 7.787 * i + 16 / 116) - 16,
            500 * (n - i),
            200 * (i - (r = r > .008856 ? Math.pow(r, 1 / 3) : 7.787 * r + 16 / 116))
        ];
    }, Ie.hsl.rgb = function(e) {
        var t, n, i, r, s, o = e[0] / 360, a = e[1] / 100, l = e[2] / 100;
        if (0 === a) return [
            s = 255 * l,
            s,
            s
        ];
        t = 2 * l - (n = l < .5 ? l * (1 + a) : l + a - l * a), r = [
            0,
            0,
            0
        ];
        for(var h = 0; h < 3; h++)(i = o + 1 / 3 * -(h - 1)) < 0 && i++, i > 1 && i--, s = 6 * i < 1 ? t + 6 * (n - t) * i : 2 * i < 1 ? n : 3 * i < 2 ? t + (n - t) * (2 / 3 - i) * 6 : t, r[h] = 255 * s;
        return r;
    }, Ie.hsl.hsv = function(e) {
        var t = e[0], n = e[1] / 100, i = e[2] / 100, r = n, s = Math.max(i, .01);
        return n *= (i *= 2) <= 1 ? i : 2 - i, r *= s <= 1 ? s : 2 - s, [
            t,
            100 * (0 === i ? 2 * r / (s + r) : 2 * n / (i + n)),
            (i + n) / 2 * 100
        ];
    }, Ie.hsv.rgb = function(e) {
        var t = e[0] / 60, n = e[1] / 100, i = e[2] / 100, r = Math.floor(t) % 6, s = t - Math.floor(t), o = 255 * i * (1 - n), a = 255 * i * (1 - n * s), l = 255 * i * (1 - n * (1 - s));
        switch(i *= 255, r){
            case 0:
                return [
                    i,
                    l,
                    o
                ];
            case 1:
                return [
                    a,
                    i,
                    o
                ];
            case 2:
                return [
                    o,
                    i,
                    l
                ];
            case 3:
                return [
                    o,
                    a,
                    i
                ];
            case 4:
                return [
                    l,
                    o,
                    i
                ];
            case 5:
                return [
                    i,
                    o,
                    a
                ];
        }
    }, Ie.hsv.hsl = function(e) {
        var t, n, i, r = e[0], s = e[1] / 100, o = e[2] / 100, a = Math.max(o, .01);
        return i = (2 - s) * o, n = s * a, [
            r,
            100 * (n = (n /= (t = (2 - s) * a) <= 1 ? t : 2 - t) || 0),
            100 * (i /= 2)
        ];
    }, Ie.hwb.rgb = function(e) {
        var t, n, i, r, s, o, a, l = e[0] / 360, h = e[1] / 100, c = e[2] / 100, u = h + c;
        switch(u > 1 && (h /= u, c /= u), i = 6 * l - (t = Math.floor(6 * l)), 1 & t && (i = 1 - i), r = h + i * ((n = 1 - c) - h), t){
            default:
            case 6:
            case 0:
                s = n, o = r, a = h;
                break;
            case 1:
                s = r, o = n, a = h;
                break;
            case 2:
                s = h, o = n, a = r;
                break;
            case 3:
                s = h, o = r, a = n;
                break;
            case 4:
                s = r, o = h, a = n;
                break;
            case 5:
                s = n, o = h, a = r;
        }
        return [
            255 * s,
            255 * o,
            255 * a
        ];
    }, Ie.cmyk.rgb = function(e) {
        var t = e[0] / 100, n = e[1] / 100, i = e[2] / 100, r = e[3] / 100;
        return [
            255 * (1 - Math.min(1, t * (1 - r) + r)),
            255 * (1 - Math.min(1, n * (1 - r) + r)),
            255 * (1 - Math.min(1, i * (1 - r) + r))
        ];
    }, Ie.xyz.rgb = function(e) {
        var t, n, i, r = e[0] / 100, s = e[1] / 100, o = e[2] / 100;
        return n = -0.9689 * r + 1.8758 * s + .0415 * o, i = .0557 * r + -0.204 * s + 1.057 * o, t = (t = 3.2406 * r + -1.5372 * s + -0.4986 * o) > .0031308 ? 1.055 * Math.pow(t, 1 / 2.4) - .055 : 12.92 * t, n = n > .0031308 ? 1.055 * Math.pow(n, 1 / 2.4) - .055 : 12.92 * n, i = i > .0031308 ? 1.055 * Math.pow(i, 1 / 2.4) - .055 : 12.92 * i, [
            255 * (t = Math.min(Math.max(0, t), 1)),
            255 * (n = Math.min(Math.max(0, n), 1)),
            255 * (i = Math.min(Math.max(0, i), 1))
        ];
    }, Ie.xyz.lab = function(e) {
        var t = e[0], n = e[1], i = e[2];
        return n /= 100, i /= 108.883, t = (t /= 95.047) > .008856 ? Math.pow(t, 1 / 3) : 7.787 * t + 16 / 116, [
            116 * (n = n > .008856 ? Math.pow(n, 1 / 3) : 7.787 * n + 16 / 116) - 16,
            500 * (t - n),
            200 * (n - (i = i > .008856 ? Math.pow(i, 1 / 3) : 7.787 * i + 16 / 116))
        ];
    }, Ie.lab.xyz = function(e) {
        var t, n, i, r = e[0];
        t = e[1] / 500 + (n = (r + 16) / 116), i = n - e[2] / 200;
        var s = Math.pow(n, 3), o = Math.pow(t, 3), a = Math.pow(i, 3);
        return n = s > .008856 ? s : (n - 16 / 116) / 7.787, t = o > .008856 ? o : (t - 16 / 116) / 7.787, i = a > .008856 ? a : (i - 16 / 116) / 7.787, [
            t *= 95.047,
            n *= 100,
            i *= 108.883
        ];
    }, Ie.lab.lch = function(e) {
        var t, n = e[0], i = e[1], r = e[2];
        return (t = 360 * Math.atan2(r, i) / 2 / Math.PI) < 0 && (t += 360), [
            n,
            Math.sqrt(i * i + r * r),
            t
        ];
    }, Ie.lch.lab = function(e) {
        var t, n = e[0], i = e[1];
        return t = e[2] / 360 * 2 * Math.PI, [
            n,
            i * Math.cos(t),
            i * Math.sin(t)
        ];
    }, Ie.rgb.ansi16 = function(e) {
        var t = e[0], n = e[1], i = e[2], r = 1 in arguments ? arguments[1] : Ie.rgb.hsv(e)[2];
        if (0 === (r = Math.round(r / 50))) return 30;
        var s = 30 + (Math.round(i / 255) << 2 | Math.round(n / 255) << 1 | Math.round(t / 255));
        return 2 === r && (s += 60), s;
    }, Ie.hsv.ansi16 = function(e) {
        return Ie.rgb.ansi16(Ie.hsv.rgb(e), e[2]);
    }, Ie.rgb.ansi256 = function(e) {
        var t = e[0], n = e[1], i = e[2];
        return t === n && n === i ? t < 8 ? 16 : t > 248 ? 231 : Math.round((t - 8) / 247 * 24) + 232 : 16 + 36 * Math.round(t / 255 * 5) + 6 * Math.round(n / 255 * 5) + Math.round(i / 255 * 5);
    }, Ie.ansi16.rgb = function(e) {
        var t = e % 10;
        if (0 === t || 7 === t) return e > 50 && (t += 3.5), [
            t = t / 10.5 * 255,
            t,
            t
        ];
        var n = .5 * (1 + ~~(e > 50));
        return [
            (1 & t) * n * 255,
            (t >> 1 & 1) * n * 255,
            (t >> 2 & 1) * n * 255
        ];
    }, Ie.ansi256.rgb = function(e) {
        if (e >= 232) {
            var t = 10 * (e - 232) + 8;
            return [
                t,
                t,
                t
            ];
        }
        var n;
        return e -= 16, [
            Math.floor(e / 36) / 5 * 255,
            Math.floor((n = e % 36) / 6) / 5 * 255,
            n % 6 / 5 * 255
        ];
    }, Ie.rgb.hex = function(e) {
        var t = (((255 & Math.round(e[0])) << 16) + ((255 & Math.round(e[1])) << 8) + (255 & Math.round(e[2]))).toString(16).toUpperCase();
        return "000000".substring(t.length) + t;
    }, Ie.hex.rgb = function(e) {
        var t = e.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
        if (!t) return [
            0,
            0,
            0
        ];
        var n = t[0];
        3 === t[0].length && (n = n.split("").map(function(e) {
            return e + e;
        }).join(""));
        var i = parseInt(n, 16);
        return [
            i >> 16 & 255,
            i >> 8 & 255,
            255 & i
        ];
    }, Ie.rgb.hcg = function(e) {
        var t, n = e[0] / 255, i = e[1] / 255, r = e[2] / 255, s = Math.max(Math.max(n, i), r), o = Math.min(Math.min(n, i), r), a = s - o;
        return t = a <= 0 ? 0 : s === n ? (i - r) / a % 6 : s === i ? 2 + (r - n) / a : 4 + (n - i) / a + 4, t /= 6, [
            360 * (t %= 1),
            100 * a,
            100 * (a < 1 ? o / (1 - a) : 0)
        ];
    }, Ie.hsl.hcg = function(e) {
        var t, n = e[1] / 100, i = e[2] / 100, r = 0;
        return (t = i < .5 ? 2 * n * i : 2 * n * (1 - i)) < 1 && (r = (i - .5 * t) / (1 - t)), [
            e[0],
            100 * t,
            100 * r
        ];
    }, Ie.hsv.hcg = function(e) {
        var t = e[1] / 100, n = e[2] / 100, i = t * n, r = 0;
        return i < 1 && (r = (n - i) / (1 - i)), [
            e[0],
            100 * i,
            100 * r
        ];
    }, Ie.hcg.rgb = function(e) {
        var t = e[0] / 360, n = e[1] / 100, i = e[2] / 100;
        if (0 === n) return [
            255 * i,
            255 * i,
            255 * i
        ];
        var r, s = [
            0,
            0,
            0
        ], o = t % 1 * 6, a = o % 1, l = 1 - a;
        switch(Math.floor(o)){
            case 0:
                s[0] = 1, s[1] = a, s[2] = 0;
                break;
            case 1:
                s[0] = l, s[1] = 1, s[2] = 0;
                break;
            case 2:
                s[0] = 0, s[1] = 1, s[2] = a;
                break;
            case 3:
                s[0] = 0, s[1] = l, s[2] = 1;
                break;
            case 4:
                s[0] = a, s[1] = 0, s[2] = 1;
                break;
            default:
                s[0] = 1, s[1] = 0, s[2] = l;
        }
        return r = (1 - n) * i, [
            255 * (n * s[0] + r),
            255 * (n * s[1] + r),
            255 * (n * s[2] + r)
        ];
    }, Ie.hcg.hsv = function(e) {
        var t = e[1] / 100, n = t + e[2] / 100 * (1 - t), i = 0;
        return n > 0 && (i = t / n), [
            e[0],
            100 * i,
            100 * n
        ];
    }, Ie.hcg.hsl = function(e) {
        var t = e[1] / 100, n = e[2] / 100 * (1 - t) + .5 * t, i = 0;
        return n > 0 && n < .5 ? i = t / (2 * n) : n >= .5 && n < 1 && (i = t / (2 * (1 - n))), [
            e[0],
            100 * i,
            100 * n
        ];
    }, Ie.hcg.hwb = function(e) {
        var t = e[1] / 100, n = t + e[2] / 100 * (1 - t);
        return [
            e[0],
            100 * (n - t),
            100 * (1 - n)
        ];
    }, Ie.hwb.hcg = function(e) {
        var t = e[1] / 100, n = 1 - e[2] / 100, i = n - t, r = 0;
        return i < 1 && (r = (n - i) / (1 - i)), [
            e[0],
            100 * i,
            100 * r
        ];
    }, Ie.apple.rgb = function(e) {
        return [
            e[0] / 65535 * 255,
            e[1] / 65535 * 255,
            e[2] / 65535 * 255
        ];
    }, Ie.rgb.apple = function(e) {
        return [
            e[0] / 255 * 65535,
            e[1] / 255 * 65535,
            e[2] / 255 * 65535
        ];
    }, Ie.gray.rgb = function(e) {
        return [
            e[0] / 100 * 255,
            e[0] / 100 * 255,
            e[0] / 100 * 255
        ];
    }, Ie.gray.hsl = Ie.gray.hsv = function(e) {
        return [
            0,
            0,
            e[0]
        ];
    }, Ie.gray.hwb = function(e) {
        return [
            0,
            100,
            e[0]
        ];
    }, Ie.gray.cmyk = function(e) {
        return [
            0,
            0,
            0,
            e[0]
        ];
    }, Ie.gray.lab = function(e) {
        return [
            e[0],
            0,
            0
        ];
    }, Ie.gray.hex = function(e) {
        var t = 255 & Math.round(e[0] / 100 * 255), n = ((t << 16) + (t << 8) + t).toString(16).toUpperCase();
        return "000000".substring(n.length) + n;
    }, Ie.rgb.gray = function(e) {
        return [
            (e[0] + e[1] + e[2]) / 3 / 255 * 100
        ];
    };
    var Oe = Se.exports, Re = Oe;
    function Ee(e, t) {
        return function(n) {
            return t(e(n));
        };
    }
    function De(e, t) {
        for(var n = [
            t[e].parent,
            e
        ], i = Re[t[e].parent][e], r = t[e].parent; t[r].parent;)n.unshift(t[r].parent), i = Ee(Re[t[r].parent][r], i), r = t[r].parent;
        return i.conversion = n, i;
    }
    var Le = Oe, He = function(e) {
        for(var t = function(e) {
            var t = function() {
                for(var e = {}, t = Object.keys(Re), n = t.length, i = 0; i < n; i++)e[t[i]] = {
                    distance: -1,
                    parent: null
                };
                return e;
            }(), n = [
                e
            ];
            for(t[e].distance = 0; n.length;)for(var i = n.pop(), r = Object.keys(Re[i]), s = r.length, o = 0; o < s; o++){
                var a = r[o], l = t[a];
                -1 === l.distance && (l.distance = t[i].distance + 1, l.parent = i, n.unshift(a));
            }
            return t;
        }(e), n = {}, i = Object.keys(t), r = i.length, s = 0; s < r; s++){
            var o = i[s];
            null !== t[o].parent && (n[o] = De(o, t));
        }
        return n;
    }, Ne = {};
    Object.keys(Le).forEach(function(e) {
        Ne[e] = {}, Object.defineProperty(Ne[e], "channels", {
            value: Le[e].channels
        }), Object.defineProperty(Ne[e], "labels", {
            value: Le[e].labels
        });
        var t = He(e);
        Object.keys(t).forEach(function(n) {
            var i = t[n];
            Ne[e][n] = function(e) {
                var t = function(t) {
                    if (null == t) return t;
                    arguments.length > 1 && (t = Array.prototype.slice.call(arguments));
                    var n = e(t);
                    if ("object" == typeof n) for(var i = n.length, r = 0; r < i; r++)n[r] = Math.round(n[r]);
                    return n;
                };
                return "conversion" in e && (t.conversion = e.conversion), t;
            }(i), Ne[e][n].raw = function(e) {
                var t = function(t) {
                    return null == t ? t : (arguments.length > 1 && (t = Array.prototype.slice.call(arguments)), e(t));
                };
                return "conversion" in e && (t.conversion = e.conversion), t;
            }(i);
        });
    });
    var ze = Te, Ve = Ne, Ue = [].slice, Be = [
        "keyword",
        "gray",
        "hex"
    ], Ge = {};
    Object.keys(Ve).forEach(function(e) {
        Ge[Ue.call(Ve[e].labels).sort().join("")] = e;
    });
    var je = {};
    function We(e, t) {
        if (!(this instanceof We)) return new We(e, t);
        if (t && t in Be && (t = null), t && !(t in Ve)) throw new Error("Unknown model: " + t);
        var n, i;
        if (null == e) this.model = "rgb", this.color = [
            0,
            0,
            0
        ], this.valpha = 1;
        else if (e instanceof We) this.model = e.model, this.color = e.color.slice(), this.valpha = e.valpha;
        else if ("string" == typeof e) {
            var r = ze.get(e);
            if (null === r) throw new Error("Unable to parse color from string: " + e);
            this.model = r.model, i = Ve[this.model].channels, this.color = r.value.slice(0, i), this.valpha = "number" == typeof r.value[i] ? r.value[i] : 1;
        } else if (e.length) {
            this.model = t || "rgb", i = Ve[this.model].channels;
            var s = Ue.call(e, 0, i);
            this.color = Ze(s, i), this.valpha = "number" == typeof e[i] ? e[i] : 1;
        } else if ("number" == typeof e) e &= 16777215, this.model = "rgb", this.color = [
            e >> 16 & 255,
            e >> 8 & 255,
            255 & e
        ], this.valpha = 1;
        else {
            this.valpha = 1;
            var o = Object.keys(e);
            "alpha" in e && (o.splice(o.indexOf("alpha"), 1), this.valpha = "number" == typeof e.alpha ? e.alpha : 0);
            var a = o.sort().join("");
            if (!(a in Ge)) throw new Error("Unable to parse color from object: " + JSON.stringify(e));
            this.model = Ge[a];
            var l = Ve[this.model].labels, h = [];
            for(n = 0; n < l.length; n++)h.push(e[l[n]]);
            this.color = Ze(h);
        }
        if (je[this.model]) for(i = Ve[this.model].channels, n = 0; n < i; n++){
            var c = je[this.model][n];
            c && (this.color[n] = c(this.color[n]));
        }
        this.valpha = Math.max(0, Math.min(1, this.valpha)), Object.freeze && Object.freeze(this);
    }
    function Xe(e, t, n) {
        return (e = Array.isArray(e) ? e : [
            e
        ]).forEach(function(e) {
            (je[e] || (je[e] = []))[t] = n;
        }), e = e[0], function(i) {
            var r;
            return arguments.length ? (n && (i = n(i)), (r = this[e]()).color[t] = i, r) : (r = this[e]().color[t], n && (r = n(r)), r);
        };
    }
    function Ye(e) {
        return function(t) {
            return Math.max(0, Math.min(e, t));
        };
    }
    function Ze(e, t) {
        for(var n = 0; n < t; n++)"number" != typeof e[n] && (e[n] = 0);
        return e;
    }
    We.prototype = {
        toString: function() {
            return this.string();
        },
        toJSON: function() {
            return this[this.model]();
        },
        string: function(e) {
            var t = this.model in ze.to ? this : this.rgb(), n = 1 === (t = t.round("number" == typeof e ? e : 1)).valpha ? t.color : t.color.concat(this.valpha);
            return ze.to[t.model](n);
        },
        percentString: function(e) {
            var t = this.rgb().round("number" == typeof e ? e : 1), n = 1 === t.valpha ? t.color : t.color.concat(this.valpha);
            return ze.to.rgb.percent(n);
        },
        array: function() {
            return 1 === this.valpha ? this.color.slice() : this.color.concat(this.valpha);
        },
        object: function() {
            for(var e = {}, t = Ve[this.model].channels, n = Ve[this.model].labels, i = 0; i < t; i++)e[n[i]] = this.color[i];
            return 1 !== this.valpha && (e.alpha = this.valpha), e;
        },
        unitArray: function() {
            var e = this.rgb().color;
            return e[0] /= 255, e[1] /= 255, e[2] /= 255, 1 !== this.valpha && e.push(this.valpha), e;
        },
        unitObject: function() {
            var e = this.rgb().object();
            return e.r /= 255, e.g /= 255, e.b /= 255, 1 !== this.valpha && (e.alpha = this.valpha), e;
        },
        round: function(e) {
            return e = Math.max(e || 0, 0), new We(this.color.map(function(e) {
                return function(t) {
                    return function(e, t) {
                        return Number(e.toFixed(t));
                    }(t, e);
                };
            }(e)).concat(this.valpha), this.model);
        },
        alpha: function(e) {
            return arguments.length ? new We(this.color.concat(Math.max(0, Math.min(1, e))), this.model) : this.valpha;
        },
        red: Xe("rgb", 0, Ye(255)),
        green: Xe("rgb", 1, Ye(255)),
        blue: Xe("rgb", 2, Ye(255)),
        hue: Xe([
            "hsl",
            "hsv",
            "hsl",
            "hwb",
            "hcg"
        ], 0, function(e) {
            return (e % 360 + 360) % 360;
        }),
        saturationl: Xe("hsl", 1, Ye(100)),
        lightness: Xe("hsl", 2, Ye(100)),
        saturationv: Xe("hsv", 1, Ye(100)),
        value: Xe("hsv", 2, Ye(100)),
        chroma: Xe("hcg", 1, Ye(100)),
        gray: Xe("hcg", 2, Ye(100)),
        white: Xe("hwb", 1, Ye(100)),
        wblack: Xe("hwb", 2, Ye(100)),
        cyan: Xe("cmyk", 0, Ye(100)),
        magenta: Xe("cmyk", 1, Ye(100)),
        yellow: Xe("cmyk", 2, Ye(100)),
        black: Xe("cmyk", 3, Ye(100)),
        x: Xe("xyz", 0, Ye(100)),
        y: Xe("xyz", 1, Ye(100)),
        z: Xe("xyz", 2, Ye(100)),
        l: Xe("lab", 0, Ye(100)),
        a: Xe("lab", 1),
        b: Xe("lab", 2),
        keyword: function(e) {
            return arguments.length ? new We(e) : Ve[this.model].keyword(this.color);
        },
        hex: function(e) {
            return arguments.length ? new We(e) : ze.to.hex(this.rgb().round().color);
        },
        rgbNumber: function() {
            var e = this.rgb().color;
            return (255 & e[0]) << 16 | (255 & e[1]) << 8 | 255 & e[2];
        },
        luminosity: function() {
            for(var e = this.rgb().color, t = [], n = 0; n < e.length; n++){
                var i = e[n] / 255;
                t[n] = i <= .03928 ? i / 12.92 : Math.pow((i + .055) / 1.055, 2.4);
            }
            return .2126 * t[0] + .7152 * t[1] + .0722 * t[2];
        },
        contrast: function(e) {
            var t = this.luminosity(), n = e.luminosity();
            return t > n ? (t + .05) / (n + .05) : (n + .05) / (t + .05);
        },
        level: function(e) {
            var t = this.contrast(e);
            return t >= 7.1 ? "AAA" : t >= 4.5 ? "AA" : "";
        },
        isDark: function() {
            var e = this.rgb().color;
            return (299 * e[0] + 587 * e[1] + 114 * e[2]) / 1e3 < 128;
        },
        isLight: function() {
            return !this.isDark();
        },
        negate: function() {
            for(var e = this.rgb(), t = 0; t < 3; t++)e.color[t] = 255 - e.color[t];
            return e;
        },
        lighten: function(e) {
            var t = this.hsl();
            return t.color[2] += t.color[2] * e, t;
        },
        darken: function(e) {
            var t = this.hsl();
            return t.color[2] -= t.color[2] * e, t;
        },
        saturate: function(e) {
            var t = this.hsl();
            return t.color[1] += t.color[1] * e, t;
        },
        desaturate: function(e) {
            var t = this.hsl();
            return t.color[1] -= t.color[1] * e, t;
        },
        whiten: function(e) {
            var t = this.hwb();
            return t.color[1] += t.color[1] * e, t;
        },
        blacken: function(e) {
            var t = this.hwb();
            return t.color[2] += t.color[2] * e, t;
        },
        grayscale: function() {
            var e = this.rgb().color, t = .3 * e[0] + .59 * e[1] + .11 * e[2];
            return We.rgb(t, t, t);
        },
        fade: function(e) {
            return this.alpha(this.valpha - this.valpha * e);
        },
        opaquer: function(e) {
            return this.alpha(this.valpha + this.valpha * e);
        },
        rotate: function(e) {
            var t = this.hsl(), n = t.color[0];
            return n = (n = (n + e) % 360) < 0 ? 360 + n : n, t.color[0] = n, t;
        },
        mix: function(e, t) {
            if (!e || !e.rgb) throw new Error('Argument to "mix" was not a Color instance, but rather an instance of ' + typeof e);
            var n = e.rgb(), i = this.rgb(), r = void 0 === t ? .5 : t, s = 2 * r - 1, o = n.alpha() - i.alpha(), a = ((s * o == -1 ? s : (s + o) / (1 + s * o)) + 1) / 2, l = 1 - a;
            return We.rgb(a * n.red() + l * i.red(), a * n.green() + l * i.green(), a * n.blue() + l * i.blue(), n.alpha() * r + i.alpha() * (1 - r));
        }
    }, Object.keys(Ve).forEach(function(e) {
        if (-1 === Be.indexOf(e)) {
            var t = Ve[e].channels;
            We.prototype[e] = function() {
                if (this.model === e) return new We(this);
                if (arguments.length) return new We(arguments, e);
                var n, i = "number" == typeof arguments[t] ? t : this.valpha;
                return new We((n = Ve[this.model][e].raw(this.color), Array.isArray(n) ? n : [
                    n
                ]).concat(i), e);
            }, We[e] = function(n) {
                return "number" == typeof n && (n = Ze(Ue.call(arguments), t)), new We(n, e);
            };
        }
    });
    var qe = n(We);
    function $e(e) {
        for(let t = 1; t < arguments.length; t++){
            const n = arguments[t];
            for(const t in n)e[t] = n[t];
        }
        return e;
    }
    function Je(e) {
        return null == e;
    }
    function Ke(e) {
        return "number" == typeof e && !isNaN(e);
    }
    function Qe(e) {
        return "object" == typeof e && !!e;
    }
    function et(e) {
        return !Je(e) && ("string" == typeof e || null !== e.constructor && e.constructor === String);
    }
    function tt(e) {
        return !Je(e) && ("function" == typeof e || null !== e.constructor && e.constructor === Function);
    }
    const nt = Object.prototype.hasOwnProperty;
    function it(e, t) {
        return nt.call(e, t);
    }
    const rt = Math.PI / 180;
    function st(e) {
        return e && ie(e) && e.property;
    }
    function ot(e) {
        const { verticalCentimeterToPoint: t, tileRatio: n } = e;
        return t * n;
    }
    function at(e) {
        return "centimeter" === e || "cm" === e ? 1 : "millimeter" === e || "mm" === e ? .1 : 100;
    }
    const lt = {};
    function ht(e, t) {
        if (!Array.isArray(t)) {
            if (t && void 0 !== t.r && void 0 !== t.g && void 0 !== t.b) return e[0] = 255 * t.r, e[1] = 255 * t.g, e[2] = 255 * t.b, void 0 !== t.a ? e[3] = 255 * t.a : e[3] = 255, e;
            const n = t;
            t = lt[n] = lt[n] || qe(t).unitArray();
        }
        for(let n = 0; n < t.length; n++)e[n] = 255 * t[n];
        return 3 === t.length && (e[3] = 255), e;
    }
    const ct = {
        textFill: 1,
        textSize: 1,
        textOpacity: 1,
        textDx: 1,
        textDy: 1,
        markerWidth: 1,
        markerHeight: 1,
        markerOpacity: 1,
        markerDx: 1,
        markerDy: 1,
        lineWidth: 1,
        lineColor: 1,
        lineOpacity: 1,
        polygonFill: 1,
        polygonOpacity: 1,
        polygonPatternFileWidth: 1,
        polygonPatternFileOrigin: 1,
        rotationX: 1,
        rotationY: 1,
        rotationZ: 1,
        scaleX: 1,
        scaleY: 1,
        scaleZ: 1,
        translationX: 1,
        translationY: 1,
        translationZ: 1
    }, ut = {
        textName: 1,
        markerTextFitPadding: 1,
        markerTextFit: 1,
        lineGradientProperty: 1
    };
    var ft = Object.freeze({
        __proto__: null,
        checkIfIdentityZoomDependent: function(e, t, n) {
            if (Array.isArray(n) || (n = Object.values(n)), !n || !n.length) return !1;
            if (!ct[e]) return !1;
            for(let e = 0; e < n.length; e++){
                const i = n[e] && (n[e].feature || n[e]);
                if (!i) continue;
                const r = i.properties && i.properties[t];
                if (r && ie(r) && !re(r).isZoomConstant) return !0;
            }
            return !1;
        },
        checkIfZoomFnTypeSymbol: function(e) {
            return !!ct[e] || !!ut[e];
        },
        evaluate: function(e, t, n) {
            return tt(e) ? e(void 0 !== n ? n : null, t) : e;
        },
        extend: $e,
        getAltitudeToLocal: ot,
        getTubeSizeScale: at,
        hasOwn: it,
        isFnTypeSymbol: st,
        isFunction: tt,
        isInteger: function(e) {
            return (0 | e) === e;
        },
        isNil: Je,
        isNumber: Ke,
        isObject: Qe,
        isString: et,
        join: function(e, t) {
            return e.join ? e.join(t || ",") : Array.prototype.join.call(e, t || ",");
        },
        normalizeColor: ht,
        now: function() {
            return Date.now();
        },
        toDegree: function(e) {
            return e / rt;
        },
        toRadian: function(e) {
            return e * rt;
        }
    });
    class dt {
        constructor(e, t, n, i){
            this.feature = e, this.symbol = t, this.fnTypes = n, this.options = i;
        }
        getPolygonResource() {
            let e = this.symbol.polygonPatternFile;
            const { polygonPatternFileFn: t } = this.fnTypes, n = t;
            return this._getResource(e, n);
        }
        getLineResource() {
            let e = this.symbol.linePatternFile;
            const { linePatternFileFn: t } = this.fnTypes, n = t;
            return this._getResource(e, n);
        }
        _getResource(e, t) {
            if (t) {
                const n = this.feature.properties;
                e = t(this.options.zoom, n);
            }
            return e;
        }
    }
    function pt(e, t, n, i) {
        const r = Math.abs(i) >> 15, s = r >> 1, o = r % 2;
        let a = i % Math.pow(2, 15);
        const l = t + (s << 14) * Math.sign(t), h = n + (o << 14) * Math.sign(n);
        return e[0] = l, e[1] = h, a = Math.round(a), e[2] = 0 === a ? i < 0 ? -1 : 0 : a, e;
    }
    const gt = Math.pow(2, 14), mt = Math.pow(2, 15), yt = [
        "Unknown",
        "Point",
        "LineString",
        "Polygon",
        "MultiPoint",
        "MultiLineString",
        "MultiPolygon",
        "GeometryCollection"
    ];
    /*!
	    Feature Filter by

	    (c) mapbox 2016 and maptalks 2018
	    www.mapbox.com | www.maptalks.org
	    License: MIT, header required.
	*/ function xt(e) {
        if (!0 === e || !1 === e) return !0;
        if (!Array.isArray(e) || 0 === e.length) return !1;
        switch(e[0]){
            case "has":
            case "!has":
                return 2 === e.length && ("string" == typeof e[1] || e[1].property && e[1].op);
            case "in":
            case "!in":
                return e.length >= 2 && ("string" == typeof e[1] || e[1].property && e[1].op);
            case "==":
            case "!=":
            case ">":
            case ">=":
            case "<":
            case "<=":
                return 3 === e.length && ("string" == typeof e[1] || e[1].property && e[1].op);
            case "none":
            case "any":
            case "all":
                for (const t of e.slice(1))if (!xt(t) && "boolean" != typeof t) return !1;
                return !0;
            case "contains":
                return !0;
            default:
                return !1;
        }
    }
    function _t(e) {
        if (!e) return "true";
        const t = e[0];
        if (e.length <= 1) return "any" === t ? "false" : "true";
        const n = "==" === t ? bt(e[1], e[2], "===", !1) : "!=" === t ? bt(e[1], e[2], "!==", !1) : "<" === t || ">" === t || "<=" === t || ">=" === t ? bt(e[1], e[2], t, !0) : "any" === t ? Tt(e.slice(1), "||") : "all" === t ? Tt(e.slice(1), "&&") : "none" === t ? Mt(Tt(e.slice(1), "||")) : "in" === t ? St(e[1], e.slice(2)) : "!in" === t ? Mt(St(e[1], e.slice(2))) : "has" === t ? wt(e[1]) : "!has" === t ? Mt(wt(e[1])) : "contains" === t ? function(e, t, n) {
            const i = vt(e);
            return void 0 !== n ? `(${i} + '').indexOf("${t}") === ${n}` : `(${i} + '').indexOf("${t}") >= 0`;
        }(e[1], e[2], e[3]) : "true";
        return `(${n})`;
    }
    function vt(e) {
        return "$" === e[0] ? "f." + e.substring(1) : "p[" + JSON.stringify(e) + "]";
    }
    function bt(e, t, n, i) {
        var r;
        return "object" == typeof (r = e) && r && e.op ? function(e, t, n, i) {
            const r = e.property, s = e.op;
            let o = vt(r);
            return "length" !== s ? (console.error(`not support ${s} op`), "false") : (o = `((${o}+='').length)`, At(o, r, t, n, i));
        }(e, t, n, i) : At(vt(e), e, t, n, i);
    }
    function At(e, t, n, i, r) {
        const s = "$type" === t ? yt.indexOf(n) : JSON.stringify(n);
        return (r ? `typeof ${e}=== typeof ${s}&&` : "") + e + i + s;
    }
    function Tt(e, t) {
        return e.map(_t).join(t);
    }
    function St(e, t) {
        "$type" === e && (t = t.map((e)=>yt.indexOf(e)));
        const n = JSON.stringify(t.sort(Pt)), i = vt(e);
        return t.length <= 200 ? `${n}.indexOf(${i}) !== -1` : `function(v, a, i, j) {\n        while (i <= j) { var m = (i + j) >> 1;\n            if (a[m] === v) return true; if (a[m] > v) j = m - 1; else i = m + 1;\n        }\n    return false; }(${i}, ${n},0,${t.length - 1})`;
    }
    function wt(e) {
        return "$id" === e ? '"id" in f' : `${JSON.stringify(e)} in p`;
    }
    function Mt(e) {
        return `!(${e})`;
    }
    function Pt(e, t) {
        return e < t ? -1 : e > t ? 1 : 0;
    }
    /*!
	 * a compact version of mapbox-gl-style-spec
	 * based on mapbox-gl-style-spec@13.28.0
	 * https://github.com/mapbox/mapbox-gl-js/tree/main/src/style-spec
	 * LICENSE : ISC
	 */ var It = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : {}, Ct = {
        exports: {}
    };
    function kt(e, ...t) {
        for (const n of t)for(const t in n)e[t] = n[t];
        return e;
    }
    /*! https://mths.be/punycode v1.3.2 by @mathias */ !function(e, t) {
        !function(n) {
            var i = t && !t.nodeType && t, r = e && !e.nodeType && e, s = "object" == typeof It && It;
            s.global !== s && s.window !== s && s.self !== s || (n = s);
            var o, a, l = 2147483647, h = 36, c = 26, u = 38, f = 700, d = /^xn--/, p = /[^\x20-\x7E]/, g = /[\x2E\u3002\uFF0E\uFF61]/g, m = {
                overflow: "Overflow: input needs wider integers to process",
                "not-basic": "Illegal input >= 0x80 (not a basic code point)",
                "invalid-input": "Invalid input"
            }, y = h - 1, x = Math.floor, _ = String.fromCharCode;
            function v(e) {
                throw RangeError(m[e]);
            }
            function b(e, t) {
                for(var n = e.length, i = []; n--;)i[n] = t(e[n]);
                return i;
            }
            function A(e, t) {
                var n = e.split("@"), i = "";
                return n.length > 1 && (i = n[0] + "@", e = n[1]), i + b((e = e.replace(g, ".")).split("."), t).join(".");
            }
            function T(e) {
                for(var t, n, i = [], r = 0, s = e.length; r < s;)(t = e.charCodeAt(r++)) >= 55296 && t <= 56319 && r < s ? 56320 == (64512 & (n = e.charCodeAt(r++))) ? i.push(((1023 & t) << 10) + (1023 & n) + 65536) : (i.push(t), r--) : i.push(t);
                return i;
            }
            function S(e) {
                return b(e, function(e) {
                    var t = "";
                    return e > 65535 && (t += _((e -= 65536) >>> 10 & 1023 | 55296), e = 56320 | 1023 & e), t + _(e);
                }).join("");
            }
            function w(e, t) {
                return e + 22 + 75 * (e < 26) - ((0 != t) << 5);
            }
            function M(e, t, n) {
                var i = 0;
                for(e = n ? x(e / f) : e >> 1, e += x(e / t); e > y * c >> 1; i += h)e = x(e / y);
                return x(i + (y + 1) * e / (e + u));
            }
            function P(e) {
                var t, n, i, r, s, o, a, u, f, d, p, g = [], m = e.length, y = 0, _ = 128, b = 72;
                for((n = e.lastIndexOf("-")) < 0 && (n = 0), i = 0; i < n; ++i)e.charCodeAt(i) >= 128 && v("not-basic"), g.push(e.charCodeAt(i));
                for(r = n > 0 ? n + 1 : 0; r < m;){
                    for(s = y, o = 1, a = h; r >= m && v("invalid-input"), ((u = (p = e.charCodeAt(r++)) - 48 < 10 ? p - 22 : p - 65 < 26 ? p - 65 : p - 97 < 26 ? p - 97 : h) >= h || u > x((l - y) / o)) && v("overflow"), y += u * o, !(u < (f = a <= b ? 1 : a >= b + c ? c : a - b)); a += h)o > x(l / (d = h - f)) && v("overflow"), o *= d;
                    b = M(y - s, t = g.length + 1, 0 == s), x(y / t) > l - _ && v("overflow"), _ += x(y / t), y %= t, g.splice(y++, 0, _);
                }
                return S(g);
            }
            function I(e) {
                var t, n, i, r, s, o, a, u, f, d, p, g, m, y, b, A = [];
                for(g = (e = T(e)).length, t = 128, n = 0, s = 72, o = 0; o < g; ++o)(p = e[o]) < 128 && A.push(_(p));
                for(i = r = A.length, r && A.push("-"); i < g;){
                    for(a = l, o = 0; o < g; ++o)(p = e[o]) >= t && p < a && (a = p);
                    for(a - t > x((l - n) / (m = i + 1)) && v("overflow"), n += (a - t) * m, t = a, o = 0; o < g; ++o)if ((p = e[o]) < t && ++n > l && v("overflow"), p == t) {
                        for(u = n, f = h; !(u < (d = f <= s ? 1 : f >= s + c ? c : f - s)); f += h)b = u - d, y = h - d, A.push(_(w(d + b % y, 0))), u = x(b / y);
                        A.push(_(w(u, 0))), s = M(n, m, i == r), n = 0, ++i;
                    }
                    ++n, ++t;
                }
                return A.join("");
            }
            if (o = {
                version: "1.3.2",
                ucs2: {
                    decode: T,
                    encode: S
                },
                decode: P,
                encode: I,
                toASCII: function(e) {
                    return A(e, function(e) {
                        return p.test(e) ? "xn--" + I(e) : e;
                    });
                },
                toUnicode: function(e) {
                    return A(e, function(e) {
                        return d.test(e) ? P(e.slice(4).toLowerCase()) : e;
                    });
                }
            }, i && r) {
                if (e.exports == i) r.exports = o;
                else for(a in o)o.hasOwnProperty(a) && (i[a] = o[a]);
            } else n.punycode = o;
        }(It);
    }(Ct, Ct.exports);
    class Ft extends Error {
        constructor(e, t){
            super(t), this.message = t, this.key = e;
        }
    }
    var Ot = Ft;
    class Rt {
        constructor(e, t = []){
            this.parent = e, this.bindings = {};
            for (const [e, n] of t)this.bindings[e] = n;
        }
        concat(e) {
            return new Rt(this, e);
        }
        get(e) {
            if (this.bindings[e]) return this.bindings[e];
            if (this.parent) return this.parent.get(e);
            throw new Error(`${e} not found in scope.`);
        }
        has(e) {
            return !!this.bindings[e] || !!this.parent && this.parent.has(e);
        }
    }
    var Et = Rt;
    const Dt = {
        kind: "null"
    }, Lt = {
        kind: "number"
    }, Ht = {
        kind: "string"
    }, Nt = {
        kind: "boolean"
    }, zt = {
        kind: "color"
    }, Vt = {
        kind: "object"
    }, Ut = {
        kind: "value"
    }, Bt = {
        kind: "collator"
    }, Gt = {
        kind: "formatted"
    }, jt = {
        kind: "resolvedImage"
    };
    function Wt(e, t) {
        return {
            kind: "array",
            itemType: e,
            N: t
        };
    }
    function Xt(e) {
        if ("array" === e.kind) {
            const t = Xt(e.itemType);
            return "number" == typeof e.N ? `array<${t}, ${e.N}>` : "value" === e.itemType.kind ? "array" : `array<${t}>`;
        }
        return e.kind;
    }
    const Yt = [
        Dt,
        Lt,
        Ht,
        Nt,
        zt,
        Gt,
        Vt,
        Wt(Ut),
        jt
    ];
    function Zt(e, t) {
        if ("error" === t.kind) return null;
        if ("array" === e.kind) {
            if ("array" === t.kind && (0 === t.N && "value" === t.itemType.kind || !Zt(e.itemType, t.itemType)) && ("number" != typeof e.N || e.N === t.N)) return null;
        } else {
            if (e.kind === t.kind) return null;
            if ("value" === e.kind) {
                for (const e of Yt)if (!Zt(e, t)) return null;
            }
        }
        return `Expected ${Xt(e)} but found ${Xt(t)} instead.`;
    }
    function qt(e, t) {
        return t.some((t)=>t.kind === e.kind);
    }
    function $t(e, t) {
        return t.some((t)=>"null" === t ? null === e : "array" === t ? Array.isArray(e) : "object" === t ? e && !Array.isArray(e) && "object" == typeof e : t === typeof e);
    }
    var Jt, Kt = {
        transparent: [
            0,
            0,
            0,
            0
        ],
        aliceblue: [
            240,
            248,
            255,
            1
        ],
        antiquewhite: [
            250,
            235,
            215,
            1
        ],
        aqua: [
            0,
            255,
            255,
            1
        ],
        aquamarine: [
            127,
            255,
            212,
            1
        ],
        azure: [
            240,
            255,
            255,
            1
        ],
        beige: [
            245,
            245,
            220,
            1
        ],
        bisque: [
            255,
            228,
            196,
            1
        ],
        black: [
            0,
            0,
            0,
            1
        ],
        blanchedalmond: [
            255,
            235,
            205,
            1
        ],
        blue: [
            0,
            0,
            255,
            1
        ],
        blueviolet: [
            138,
            43,
            226,
            1
        ],
        brown: [
            165,
            42,
            42,
            1
        ],
        burlywood: [
            222,
            184,
            135,
            1
        ],
        cadetblue: [
            95,
            158,
            160,
            1
        ],
        chartreuse: [
            127,
            255,
            0,
            1
        ],
        chocolate: [
            210,
            105,
            30,
            1
        ],
        coral: [
            255,
            127,
            80,
            1
        ],
        cornflowerblue: [
            100,
            149,
            237,
            1
        ],
        cornsilk: [
            255,
            248,
            220,
            1
        ],
        crimson: [
            220,
            20,
            60,
            1
        ],
        cyan: [
            0,
            255,
            255,
            1
        ],
        darkblue: [
            0,
            0,
            139,
            1
        ],
        darkcyan: [
            0,
            139,
            139,
            1
        ],
        darkgoldenrod: [
            184,
            134,
            11,
            1
        ],
        darkgray: [
            169,
            169,
            169,
            1
        ],
        darkgreen: [
            0,
            100,
            0,
            1
        ],
        darkgrey: [
            169,
            169,
            169,
            1
        ],
        darkkhaki: [
            189,
            183,
            107,
            1
        ],
        darkmagenta: [
            139,
            0,
            139,
            1
        ],
        darkolivegreen: [
            85,
            107,
            47,
            1
        ],
        darkorange: [
            255,
            140,
            0,
            1
        ],
        darkorchid: [
            153,
            50,
            204,
            1
        ],
        darkred: [
            139,
            0,
            0,
            1
        ],
        darksalmon: [
            233,
            150,
            122,
            1
        ],
        darkseagreen: [
            143,
            188,
            143,
            1
        ],
        darkslateblue: [
            72,
            61,
            139,
            1
        ],
        darkslategray: [
            47,
            79,
            79,
            1
        ],
        darkslategrey: [
            47,
            79,
            79,
            1
        ],
        darkturquoise: [
            0,
            206,
            209,
            1
        ],
        darkviolet: [
            148,
            0,
            211,
            1
        ],
        deeppink: [
            255,
            20,
            147,
            1
        ],
        deepskyblue: [
            0,
            191,
            255,
            1
        ],
        dimgray: [
            105,
            105,
            105,
            1
        ],
        dimgrey: [
            105,
            105,
            105,
            1
        ],
        dodgerblue: [
            30,
            144,
            255,
            1
        ],
        firebrick: [
            178,
            34,
            34,
            1
        ],
        floralwhite: [
            255,
            250,
            240,
            1
        ],
        forestgreen: [
            34,
            139,
            34,
            1
        ],
        fuchsia: [
            255,
            0,
            255,
            1
        ],
        gainsboro: [
            220,
            220,
            220,
            1
        ],
        ghostwhite: [
            248,
            248,
            255,
            1
        ],
        gold: [
            255,
            215,
            0,
            1
        ],
        goldenrod: [
            218,
            165,
            32,
            1
        ],
        gray: [
            128,
            128,
            128,
            1
        ],
        green: [
            0,
            128,
            0,
            1
        ],
        greenyellow: [
            173,
            255,
            47,
            1
        ],
        grey: [
            128,
            128,
            128,
            1
        ],
        honeydew: [
            240,
            255,
            240,
            1
        ],
        hotpink: [
            255,
            105,
            180,
            1
        ],
        indianred: [
            205,
            92,
            92,
            1
        ],
        indigo: [
            75,
            0,
            130,
            1
        ],
        ivory: [
            255,
            255,
            240,
            1
        ],
        khaki: [
            240,
            230,
            140,
            1
        ],
        lavender: [
            230,
            230,
            250,
            1
        ],
        lavenderblush: [
            255,
            240,
            245,
            1
        ],
        lawngreen: [
            124,
            252,
            0,
            1
        ],
        lemonchiffon: [
            255,
            250,
            205,
            1
        ],
        lightblue: [
            173,
            216,
            230,
            1
        ],
        lightcoral: [
            240,
            128,
            128,
            1
        ],
        lightcyan: [
            224,
            255,
            255,
            1
        ],
        lightgoldenrodyellow: [
            250,
            250,
            210,
            1
        ],
        lightgray: [
            211,
            211,
            211,
            1
        ],
        lightgreen: [
            144,
            238,
            144,
            1
        ],
        lightgrey: [
            211,
            211,
            211,
            1
        ],
        lightpink: [
            255,
            182,
            193,
            1
        ],
        lightsalmon: [
            255,
            160,
            122,
            1
        ],
        lightseagreen: [
            32,
            178,
            170,
            1
        ],
        lightskyblue: [
            135,
            206,
            250,
            1
        ],
        lightslategray: [
            119,
            136,
            153,
            1
        ],
        lightslategrey: [
            119,
            136,
            153,
            1
        ],
        lightsteelblue: [
            176,
            196,
            222,
            1
        ],
        lightyellow: [
            255,
            255,
            224,
            1
        ],
        lime: [
            0,
            255,
            0,
            1
        ],
        limegreen: [
            50,
            205,
            50,
            1
        ],
        linen: [
            250,
            240,
            230,
            1
        ],
        magenta: [
            255,
            0,
            255,
            1
        ],
        maroon: [
            128,
            0,
            0,
            1
        ],
        mediumaquamarine: [
            102,
            205,
            170,
            1
        ],
        mediumblue: [
            0,
            0,
            205,
            1
        ],
        mediumorchid: [
            186,
            85,
            211,
            1
        ],
        mediumpurple: [
            147,
            112,
            219,
            1
        ],
        mediumseagreen: [
            60,
            179,
            113,
            1
        ],
        mediumslateblue: [
            123,
            104,
            238,
            1
        ],
        mediumspringgreen: [
            0,
            250,
            154,
            1
        ],
        mediumturquoise: [
            72,
            209,
            204,
            1
        ],
        mediumvioletred: [
            199,
            21,
            133,
            1
        ],
        midnightblue: [
            25,
            25,
            112,
            1
        ],
        mintcream: [
            245,
            255,
            250,
            1
        ],
        mistyrose: [
            255,
            228,
            225,
            1
        ],
        moccasin: [
            255,
            228,
            181,
            1
        ],
        navajowhite: [
            255,
            222,
            173,
            1
        ],
        navy: [
            0,
            0,
            128,
            1
        ],
        oldlace: [
            253,
            245,
            230,
            1
        ],
        olive: [
            128,
            128,
            0,
            1
        ],
        olivedrab: [
            107,
            142,
            35,
            1
        ],
        orange: [
            255,
            165,
            0,
            1
        ],
        orangered: [
            255,
            69,
            0,
            1
        ],
        orchid: [
            218,
            112,
            214,
            1
        ],
        palegoldenrod: [
            238,
            232,
            170,
            1
        ],
        palegreen: [
            152,
            251,
            152,
            1
        ],
        paleturquoise: [
            175,
            238,
            238,
            1
        ],
        palevioletred: [
            219,
            112,
            147,
            1
        ],
        papayawhip: [
            255,
            239,
            213,
            1
        ],
        peachpuff: [
            255,
            218,
            185,
            1
        ],
        peru: [
            205,
            133,
            63,
            1
        ],
        pink: [
            255,
            192,
            203,
            1
        ],
        plum: [
            221,
            160,
            221,
            1
        ],
        powderblue: [
            176,
            224,
            230,
            1
        ],
        purple: [
            128,
            0,
            128,
            1
        ],
        rebeccapurple: [
            102,
            51,
            153,
            1
        ],
        red: [
            255,
            0,
            0,
            1
        ],
        rosybrown: [
            188,
            143,
            143,
            1
        ],
        royalblue: [
            65,
            105,
            225,
            1
        ],
        saddlebrown: [
            139,
            69,
            19,
            1
        ],
        salmon: [
            250,
            128,
            114,
            1
        ],
        sandybrown: [
            244,
            164,
            96,
            1
        ],
        seagreen: [
            46,
            139,
            87,
            1
        ],
        seashell: [
            255,
            245,
            238,
            1
        ],
        sienna: [
            160,
            82,
            45,
            1
        ],
        silver: [
            192,
            192,
            192,
            1
        ],
        skyblue: [
            135,
            206,
            235,
            1
        ],
        slateblue: [
            106,
            90,
            205,
            1
        ],
        slategray: [
            112,
            128,
            144,
            1
        ],
        slategrey: [
            112,
            128,
            144,
            1
        ],
        snow: [
            255,
            250,
            250,
            1
        ],
        springgreen: [
            0,
            255,
            127,
            1
        ],
        steelblue: [
            70,
            130,
            180,
            1
        ],
        tan: [
            210,
            180,
            140,
            1
        ],
        teal: [
            0,
            128,
            128,
            1
        ],
        thistle: [
            216,
            191,
            216,
            1
        ],
        tomato: [
            255,
            99,
            71,
            1
        ],
        turquoise: [
            64,
            224,
            208,
            1
        ],
        violet: [
            238,
            130,
            238,
            1
        ],
        wheat: [
            245,
            222,
            179,
            1
        ],
        white: [
            255,
            255,
            255,
            1
        ],
        whitesmoke: [
            245,
            245,
            245,
            1
        ],
        yellow: [
            255,
            255,
            0,
            1
        ],
        yellowgreen: [
            154,
            205,
            50,
            1
        ]
    };
    function Qt(e) {
        return (e = Math.round(e)) < 0 ? 0 : e > 255 ? 255 : e;
    }
    function en(e) {
        return e < 0 ? 0 : e > 1 ? 1 : e;
    }
    function tn(e) {
        return "%" === e[e.length - 1] ? Qt(parseFloat(e) / 100 * 255) : Qt(parseInt(e));
    }
    function nn(e) {
        return "%" === e[e.length - 1] ? en(parseFloat(e) / 100) : en(parseFloat(e));
    }
    function rn(e, t, n) {
        return n < 0 ? n += 1 : n > 1 && (n -= 1), 6 * n < 1 ? e + (t - e) * n * 6 : 2 * n < 1 ? t : 3 * n < 2 ? e + (t - e) * (2 / 3 - n) * 6 : e;
    }
    try {
        Jt = ({}).parseCSSColor = function(e) {
            var t, n = e.replace(/ /g, "").toLowerCase();
            if (n in Kt) return Kt[n].slice();
            if ("#" === n[0]) return 4 === n.length ? (t = parseInt(n.substr(1), 16)) >= 0 && t <= 4095 ? [
                (3840 & t) >> 4 | (3840 & t) >> 8,
                240 & t | (240 & t) >> 4,
                15 & t | (15 & t) << 4,
                1
            ] : null : 7 === n.length && (t = parseInt(n.substr(1), 16)) >= 0 && t <= 16777215 ? [
                (16711680 & t) >> 16,
                (65280 & t) >> 8,
                255 & t,
                1
            ] : null;
            var i = n.indexOf("("), r = n.indexOf(")");
            if (-1 !== i && r + 1 === n.length) {
                var s = n.substr(0, i), o = n.substr(i + 1, r - (i + 1)).split(","), a = 1;
                switch(s){
                    case "rgba":
                        if (4 !== o.length) return null;
                        a = nn(o.pop());
                    case "rgb":
                        return 3 !== o.length ? null : [
                            tn(o[0]),
                            tn(o[1]),
                            tn(o[2]),
                            a
                        ];
                    case "hsla":
                        if (4 !== o.length) return null;
                        a = nn(o.pop());
                    case "hsl":
                        if (3 !== o.length) return null;
                        var l = (parseFloat(o[0]) % 360 + 360) % 360 / 360, h = nn(o[1]), c = nn(o[2]), u = c <= .5 ? c * (h + 1) : c + h - c * h, f = 2 * c - u;
                        return [
                            Qt(255 * rn(f, u, l + 1 / 3)),
                            Qt(255 * rn(f, u, l)),
                            Qt(255 * rn(f, u, l - 1 / 3)),
                            a
                        ];
                    default:
                        return null;
                }
            }
            return null;
        };
    } catch (e) {}
    class sn {
        constructor(e, t, n, i = 1){
            this.r = e, this.g = t, this.b = n, this.a = i;
        }
        static parse(e) {
            if (!e) return;
            if (e instanceof sn) return e;
            if ("string" != typeof e) return;
            const t = Jt(e);
            return t ? new sn(t[0] / 255 * t[3], t[1] / 255 * t[3], t[2] / 255 * t[3], t[3]) : void 0;
        }
        toString() {
            const [e, t, n, i] = this.toArray();
            return `rgba(${Math.round(e)},${Math.round(t)},${Math.round(n)},${i})`;
        }
        toArray() {
            const { r: e, g: t, b: n, a: i } = this;
            return 0 === i ? [
                0,
                0,
                0,
                0
            ] : [
                255 * e / i,
                255 * t / i,
                255 * n / i,
                i
            ];
        }
        toArray01() {
            const { r: e, g: t, b: n, a: i } = this;
            return 0 === i ? [
                0,
                0,
                0,
                0
            ] : [
                e / i,
                t / i,
                n / i,
                i
            ];
        }
        toArray01PremultipliedAlpha() {
            const { r: e, g: t, b: n, a: i } = this;
            return [
                e,
                t,
                n,
                i
            ];
        }
    }
    sn.black = new sn(0, 0, 0, 1), sn.white = new sn(1, 1, 1, 1), sn.transparent = new sn(0, 0, 0, 0), sn.red = new sn(1, 0, 0, 1), sn.blue = new sn(0, 0, 1, 1);
    var on = sn;
    class an {
        constructor(e, t, n){
            this.sensitivity = e ? t ? "variant" : "case" : t ? "accent" : "base", this.locale = n, this.collator = new Intl.Collator(this.locale ? this.locale : [], {
                sensitivity: this.sensitivity,
                usage: "search"
            });
        }
        compare(e, t) {
            return this.collator.compare(e, t);
        }
        resolvedLocale() {
            return new Intl.Collator(this.locale ? this.locale : []).resolvedOptions().locale;
        }
    }
    class ln {
        constructor(e, t, n, i, r){
            this.text = e.normalize ? e.normalize() : e, this.image = t, this.scale = n, this.fontStack = i, this.textColor = r;
        }
    }
    class hn {
        constructor(e){
            this.sections = e;
        }
        static fromString(e) {
            return new hn([
                new ln(e, null, null, null, null)
            ]);
        }
        isEmpty() {
            return 0 === this.sections.length || !this.sections.some((e)=>0 !== e.text.length || e.image && 0 !== e.image.name.length);
        }
        static factory(e) {
            return e instanceof hn ? e : hn.fromString(e);
        }
        toString() {
            return 0 === this.sections.length ? "" : this.sections.map((e)=>e.text).join("");
        }
        serialize() {
            const e = [
                "format"
            ];
            for (const t of this.sections){
                if (t.image) {
                    e.push([
                        "image",
                        t.image.name
                    ]);
                    continue;
                }
                e.push(t.text);
                const n = {};
                t.fontStack && (n["text-font"] = [
                    "literal",
                    t.fontStack.split(",")
                ]), t.scale && (n["font-scale"] = t.scale), t.textColor && (n["text-color"] = [
                    "rgba"
                ].concat(t.textColor.toArray())), e.push(n);
            }
            return e;
        }
    }
    class cn {
        constructor(e){
            this.name = e.name, this.available = e.available;
        }
        toString() {
            return this.name;
        }
        static fromString(e) {
            return e ? new cn({
                name: e,
                available: !1
            }) : null;
        }
        serialize() {
            return [
                "image",
                this.name
            ];
        }
    }
    function un(e, t, n, i) {
        return "number" == typeof e && e >= 0 && e <= 255 && "number" == typeof t && t >= 0 && t <= 255 && "number" == typeof n && n >= 0 && n <= 255 ? void 0 === i || "number" == typeof i && i >= 0 && i <= 1 ? null : `Invalid rgba value [${[
            e,
            t,
            n,
            i
        ].join(", ")}]: 'a' must be between 0 and 1.` : `Invalid rgba value [${("number" == typeof i ? [
            e,
            t,
            n,
            i
        ] : [
            e,
            t,
            n
        ]).join(", ")}]: 'r', 'g', and 'b' must be between 0 and 255.`;
    }
    function fn(e) {
        if (null === e) return !0;
        if ("string" == typeof e) return !0;
        if ("boolean" == typeof e) return !0;
        if ("number" == typeof e) return !0;
        if (e instanceof on) return !0;
        if (e instanceof an) return !0;
        if (e instanceof hn) return !0;
        if (e instanceof cn) return !0;
        if (Array.isArray(e)) {
            for (const t of e)if (!fn(t)) return !1;
            return !0;
        }
        if ("object" == typeof e) {
            for(const t in e)if (!fn(e[t])) return !1;
            return !0;
        }
        return !1;
    }
    function dn(e) {
        if (null === e) return Dt;
        if ("string" == typeof e) return Ht;
        if ("boolean" == typeof e) return Nt;
        if ("number" == typeof e) return Lt;
        if (e instanceof on) return zt;
        if (e instanceof an) return Bt;
        if (e instanceof hn) return Gt;
        if (e instanceof cn) return jt;
        if (Array.isArray(e)) {
            const t = e.length;
            let n;
            for (const t of e){
                const e = dn(t);
                if (n) {
                    if (n === e) continue;
                    n = Ut;
                    break;
                }
                n = e;
            }
            return Wt(n || Ut, t);
        }
        return Vt;
    }
    function pn(e) {
        const t = typeof e;
        return null === e ? "" : "string" === t || "number" === t || "boolean" === t ? String(e) : e instanceof on || e instanceof hn || e instanceof cn ? e.toString() : JSON.stringify(e);
    }
    class gn {
        constructor(e, t){
            this.type = e, this.value = t;
        }
        static parse(e, t) {
            if (2 !== e.length) return t.error(`'literal' expression requires exactly one argument, but found ${e.length - 1} instead.`);
            if (!fn(e[1])) return t.error("invalid value");
            const n = e[1];
            let i = dn(n);
            const r = t.expectedType;
            return "array" !== i.kind || 0 !== i.N || !r || "array" !== r.kind || "number" == typeof r.N && 0 !== r.N || (i = r), new gn(i, n);
        }
        evaluate() {
            return this.value;
        }
        eachChild() {}
        outputDefined() {
            return !0;
        }
        serialize() {
            return "array" === this.type.kind || "object" === this.type.kind ? [
                "literal",
                this.value
            ] : this.value instanceof on ? [
                "rgba"
            ].concat(this.value.toArray()) : this.value instanceof hn ? this.value.serialize() : this.value;
        }
    }
    var mn = gn, yn = class {
        constructor(e){
            this.name = "ExpressionEvaluationError", this.message = e;
        }
        toJSON() {
            return this.message;
        }
    };
    const xn = {
        string: Ht,
        number: Lt,
        boolean: Nt,
        object: Vt
    };
    class _n {
        constructor(e, t){
            this.type = e, this.args = t;
        }
        static parse(e, t) {
            if (e.length < 2) return t.error("Expected at least one argument.");
            let n, i = 1;
            const r = e[0];
            if ("array" === r) {
                let r, s;
                if (e.length > 2) {
                    const n = e[1];
                    if ("string" != typeof n || !(n in xn) || "object" === n) return t.error('The item type argument of "array" must be one of string, number, boolean', 1);
                    r = xn[n], i++;
                } else r = Ut;
                if (e.length > 3) {
                    if (null !== e[2] && ("number" != typeof e[2] || e[2] < 0 || e[2] !== Math.floor(e[2]))) return t.error('The length argument to "array" must be a positive integer literal', 2);
                    s = e[2], i++;
                }
                n = Wt(r, s);
            } else n = xn[r];
            const s = [];
            for(; i < e.length; i++){
                const n = t.parse(e[i], i, Ut);
                if (!n) return null;
                s.push(n);
            }
            return new _n(n, s);
        }
        evaluate(e) {
            for(let t = 0; t < this.args.length; t++){
                const n = this.args[t].evaluate(e);
                if (!Zt(this.type, dn(n))) return n;
                if (t === this.args.length - 1) throw new yn(`Expected value to be of type ${Xt(this.type)}, but found ${Xt(dn(n))} instead.`);
            }
            return null;
        }
        eachChild(e) {
            this.args.forEach(e);
        }
        outputDefined() {
            return this.args.every((e)=>e.outputDefined());
        }
        serialize() {
            const e = this.type, t = [
                e.kind
            ];
            if ("array" === e.kind) {
                const n = e.itemType;
                if ("string" === n.kind || "number" === n.kind || "boolean" === n.kind) {
                    t.push(n.kind);
                    const i = e.N;
                    ("number" == typeof i || this.args.length > 1) && t.push(i);
                }
            }
            return t.concat(this.args.map((e)=>e.serialize()));
        }
    }
    var vn = _n;
    class bn {
        constructor(e){
            this.type = Gt, this.sections = e;
        }
        static parse(e, t) {
            if (e.length < 2) return t.error("Expected at least one argument.");
            const n = e[1];
            if (!Array.isArray(n) && "object" == typeof n) return t.error("First argument must be an image or text section.");
            const i = [];
            let r = !1;
            for(let n = 1; n <= e.length - 1; ++n){
                const s = e[n];
                if (r && "object" == typeof s && !Array.isArray(s)) {
                    r = !1;
                    let e = null;
                    if (s["font-scale"] && (e = t.parse(s["font-scale"], 1, Lt), !e)) return null;
                    let n = null;
                    if (s["text-font"] && (n = t.parse(s["text-font"], 1, Wt(Ht)), !n)) return null;
                    let o = null;
                    if (s["text-color"] && (o = t.parse(s["text-color"], 1, zt), !o)) return null;
                    const a = i[i.length - 1];
                    a.scale = e, a.font = n, a.textColor = o;
                } else {
                    const s = t.parse(e[n], 1, Ut);
                    if (!s) return null;
                    const o = s.type.kind;
                    if ("string" !== o && "value" !== o && "null" !== o && "resolvedImage" !== o) return t.error("Formatted text type must be 'string', 'value', 'image' or 'null'.");
                    r = !0, i.push({
                        content: s,
                        scale: null,
                        font: null,
                        textColor: null
                    });
                }
            }
            return new bn(i);
        }
        evaluate(e) {
            return new hn(this.sections.map((t)=>{
                const n = t.content.evaluate(e);
                return dn(n) === jt ? new ln("", n, null, null, null) : new ln(pn(n), null, t.scale ? t.scale.evaluate(e) : null, t.font ? t.font.evaluate(e).join(",") : null, t.textColor ? t.textColor.evaluate(e) : null);
            }));
        }
        eachChild(e) {
            for (const t of this.sections)e(t.content), t.scale && e(t.scale), t.font && e(t.font), t.textColor && e(t.textColor);
        }
        outputDefined() {
            return !1;
        }
        serialize() {
            const e = [
                "format"
            ];
            for (const t of this.sections){
                e.push(t.content.serialize());
                const n = {};
                t.scale && (n["font-scale"] = t.scale.serialize()), t.font && (n["text-font"] = t.font.serialize()), t.textColor && (n["text-color"] = t.textColor.serialize()), e.push(n);
            }
            return e;
        }
    }
    class An {
        constructor(e){
            this.type = jt, this.input = e;
        }
        static parse(e, t) {
            if (2 !== e.length) return t.error("Expected two arguments.");
            const n = t.parse(e[1], 1, Ht);
            return n ? new An(n) : t.error("No image name provided.");
        }
        evaluate(e) {
            const t = this.input.evaluate(e), n = cn.fromString(t);
            return n && e.availableImages && (n.available = e.availableImages.indexOf(t) > -1), n;
        }
        eachChild(e) {
            e(this.input);
        }
        outputDefined() {
            return !1;
        }
        serialize() {
            return [
                "image",
                this.input.serialize()
            ];
        }
    }
    const Tn = {
        "to-boolean": Nt,
        "to-color": zt,
        "to-number": Lt,
        "to-string": Ht
    };
    class Sn {
        constructor(e, t){
            this.type = e, this.args = t;
        }
        static parse(e, t) {
            if (e.length < 2) return t.error("Expected at least one argument.");
            const n = e[0];
            if (("to-boolean" === n || "to-string" === n) && 2 !== e.length) return t.error("Expected one argument.");
            const i = Tn[n], r = [];
            for(let n = 1; n < e.length; n++){
                const i = t.parse(e[n], n, Ut);
                if (!i) return null;
                r.push(i);
            }
            return new Sn(i, r);
        }
        evaluate(e) {
            if ("boolean" === this.type.kind) return Boolean(this.args[0].evaluate(e));
            if ("color" === this.type.kind) {
                let t, n;
                for (const i of this.args){
                    if (t = i.evaluate(e), n = null, t instanceof on) return t;
                    if ("string" == typeof t) {
                        const n = e.parseColor(t);
                        if (n) return n;
                    } else if (Array.isArray(t) && (n = t.length < 3 || t.length > 4 ? `Invalid rbga value ${JSON.stringify(t)}: expected an array containing either three or four numeric values.` : un(t[0], t[1], t[2], t[3]), !n)) return new on(t[0] / 255, t[1] / 255, t[2] / 255, t[3]);
                }
                throw new yn(n || `Could not parse color from value '${"string" == typeof t ? t : String(JSON.stringify(t))}'`);
            }
            if ("number" === this.type.kind) {
                let t = null;
                for (const n of this.args){
                    if (t = n.evaluate(e), null === t) return 0;
                    const i = Number(t);
                    if (!isNaN(i)) return i;
                }
                throw new yn(`Could not convert ${JSON.stringify(t)} to number.`);
            }
            return "formatted" === this.type.kind ? hn.fromString(pn(this.args[0].evaluate(e))) : "resolvedImage" === this.type.kind ? cn.fromString(pn(this.args[0].evaluate(e))) : pn(this.args[0].evaluate(e));
        }
        eachChild(e) {
            this.args.forEach(e);
        }
        outputDefined() {
            return this.args.every((e)=>e.outputDefined());
        }
        serialize() {
            if ("formatted" === this.type.kind) return new bn([
                {
                    content: this.args[0],
                    scale: null,
                    font: null,
                    textColor: null
                }
            ]).serialize();
            if ("resolvedImage" === this.type.kind) return new An(this.args[0]).serialize();
            const e = [
                `to-${this.type.kind}`
            ];
            return this.eachChild((t)=>{
                e.push(t.serialize());
            }), e;
        }
    }
    var wn = Sn;
    const Mn = [
        "Unknown",
        "Point",
        "LineString",
        "Polygon"
    ];
    var Pn = class {
        constructor(){
            this.globals = null, this.feature = null, this.featureState = null, this.formattedSection = null, this._parseColorCache = {}, this.availableImages = null, this.canonical = null, this.featureTileCoord = null, this.featureDistanceData = null;
        }
        id() {
            return this.feature && void 0 !== this.feature.id ? this.feature.id : null;
        }
        geometryType() {
            return this.feature ? "number" == typeof this.feature.type ? Mn[this.feature.type] : this.feature.type : null;
        }
        geometry() {
            return this.feature && "geometry" in this.feature ? this.feature.geometry : null;
        }
        canonicalID() {
            return this.canonical;
        }
        properties() {
            return this.feature && this.feature.properties || {};
        }
        distanceFromCenter() {
            if (this.featureTileCoord && this.featureDistanceData) {
                const e = this.featureDistanceData.center, t = this.featureDistanceData.scale, { x: n, y: i } = this.featureTileCoord, r = n * t - e[0], s = i * t - e[1];
                return this.featureDistanceData.bearing[0] * r + this.featureDistanceData.bearing[1] * s;
            }
            return 0;
        }
        parseColor(e) {
            let t = this._parseColorCache[e];
            return t || (t = this._parseColorCache[e] = on.parse(e)), t;
        }
    };
    class In {
        constructor(e, t, n, i){
            this.name = e, this.type = t, this._evaluate = n, this.args = i;
        }
        evaluate(e) {
            return this._evaluate(e, this.args);
        }
        eachChild(e) {
            this.args.forEach(e);
        }
        outputDefined() {
            return !1;
        }
        serialize() {
            return [
                this.name
            ].concat(this.args.map((e)=>e.serialize()));
        }
        static parse(e, t) {
            const n = e[0], i = In.definitions[n];
            if (!i) return t.error(`Unknown expression "${n}". If you wanted a literal array, use ["literal", [...]].`, 0);
            const r = Array.isArray(i) ? i[0] : i.type, s = Array.isArray(i) ? [
                [
                    i[1],
                    i[2]
                ]
            ] : i.overloads, o = s.filter(([t])=>!Array.isArray(t) || t.length === e.length - 1);
            let a = null;
            for (const [i, s] of o){
                a = new ni(t.registry, t.path, null, t.scope);
                const o = [];
                let l = !1;
                for(let t = 1; t < e.length; t++){
                    const n = e[t], r = Array.isArray(i) ? i[t - 1] : i.type, s = a.parse(n, 1 + o.length, r);
                    if (!s) {
                        l = !0;
                        break;
                    }
                    o.push(s);
                }
                if (!l) {
                    if (Array.isArray(i) && i.length !== o.length) a.error(`Expected ${i.length} arguments, but found ${o.length} instead.`);
                    else {
                        for(let e = 0; e < o.length; e++){
                            const t = Array.isArray(i) ? i[e] : i.type, n = o[e];
                            a.concat(e + 1).checkSubtype(t, n.type);
                        }
                        if (0 === a.errors.length) return new In(n, r, s, o);
                    }
                }
            }
            if (1 === o.length) t.errors.push(...a.errors);
            else {
                const n = (o.length ? o : s).map(([e])=>{
                    var t;
                    return t = e, Array.isArray(t) ? `(${t.map(Xt).join(", ")})` : `(${Xt(t.type)}...)`;
                }).join(" | "), i = [];
                for(let n = 1; n < e.length; n++){
                    const r = t.parse(e[n], 1 + i.length);
                    if (!r) return null;
                    i.push(Xt(r.type));
                }
                t.error(`Expected arguments of type ${n}, but found (${i.join(", ")}) instead.`);
            }
            return null;
        }
        static register(e, t) {
            In.definitions = t;
            for(const n in t)e[n] = In;
        }
    }
    var Cn = In;
    class kn {
        constructor(e, t, n){
            this.type = Bt, this.locale = n, this.caseSensitive = e, this.diacriticSensitive = t;
        }
        static parse(e, t) {
            if (2 !== e.length) return t.error("Expected one argument.");
            const n = e[1];
            if ("object" != typeof n || Array.isArray(n)) return t.error("Collator options argument must be an object.");
            const i = t.parse(void 0 !== n["case-sensitive"] && n["case-sensitive"], 1, Nt);
            if (!i) return null;
            const r = t.parse(void 0 !== n["diacritic-sensitive"] && n["diacritic-sensitive"], 1, Nt);
            if (!r) return null;
            let s = null;
            return n.locale && (s = t.parse(n.locale, 1, Ht), !s) ? null : new kn(i, r, s);
        }
        evaluate(e) {
            return new an(this.caseSensitive.evaluate(e), this.diacriticSensitive.evaluate(e), this.locale ? this.locale.evaluate(e) : null);
        }
        eachChild(e) {
            e(this.caseSensitive), e(this.diacriticSensitive), this.locale && e(this.locale);
        }
        outputDefined() {
            return !1;
        }
        serialize() {
            const e = {};
            return e["case-sensitive"] = this.caseSensitive.serialize(), e["diacritic-sensitive"] = this.diacriticSensitive.serialize(), this.locale && (e.locale = this.locale.serialize()), [
                "collator",
                e
            ];
        }
    }
    const Fn = 8192;
    function On(e, t) {
        e[0] = Math.min(e[0], t[0]), e[1] = Math.min(e[1], t[1]), e[2] = Math.max(e[2], t[0]), e[3] = Math.max(e[3], t[1]);
    }
    function Rn(e, t) {
        return !(e[0] <= t[0] || e[2] >= t[2] || e[1] <= t[1] || e[3] >= t[3]);
    }
    function En(e, t) {
        const n = (180 + e[0]) / 360, i = (r = e[1], (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + r * Math.PI / 360))) / 360);
        var r;
        const s = Math.pow(2, t.z);
        return [
            Math.round(n * s * Fn),
            Math.round(i * s * Fn)
        ];
    }
    function Dn(e, t, n) {
        const i = e[0] - t[0], r = e[1] - t[1], s = e[0] - n[0], o = e[1] - n[1];
        return i * o - s * r == 0 && i * s <= 0 && r * o <= 0;
    }
    function Ln(e, t) {
        let n = !1;
        for(let o = 0, a = t.length; o < a; o++){
            const a = t[o];
            for(let t = 0, o = a.length; t < o - 1; t++){
                if (Dn(e, a[t], a[t + 1])) return !1;
                i = e, r = a[t], s = a[t + 1], r[1] > i[1] != s[1] > i[1] && i[0] < (s[0] - r[0]) * (i[1] - r[1]) / (s[1] - r[1]) + r[0] && (n = !n);
            }
        }
        var i, r, s;
        return n;
    }
    function Hn(e, t) {
        for(let n = 0; n < t.length; n++)if (Ln(e, t[n])) return !0;
        return !1;
    }
    function Nn(e, t, n, i) {
        const r = e[0] - n[0], s = e[1] - n[1], o = t[0] - n[0], a = t[1] - n[1], l = i[0] - n[0], h = i[1] - n[1], c = r * h - l * s, u = o * h - l * a;
        return c > 0 && u < 0 || c < 0 && u > 0;
    }
    function zn(e, t, n, i) {
        const r = [
            t[0] - e[0],
            t[1] - e[1]
        ];
        var s, o;
        return 0 != (s = [
            i[0] - n[0],
            i[1] - n[1]
        ])[0] * (o = r)[1] - s[1] * o[0] && !(!Nn(e, t, n, i) || !Nn(n, i, e, t));
    }
    function Vn(e, t, n) {
        for (const i of n)for(let n = 0; n < i.length - 1; ++n)if (zn(e, t, i[n], i[n + 1])) return !0;
        return !1;
    }
    function Un(e, t) {
        for(let n = 0; n < e.length; ++n)if (!Ln(e[n], t)) return !1;
        for(let n = 0; n < e.length - 1; ++n)if (Vn(e[n], e[n + 1], t)) return !1;
        return !0;
    }
    function Bn(e, t) {
        for(let n = 0; n < t.length; n++)if (Un(e, t[n])) return !0;
        return !1;
    }
    function Gn(e, t, n) {
        const i = [];
        for(let r = 0; r < e.length; r++){
            const s = [];
            for(let i = 0; i < e[r].length; i++){
                const o = En(e[r][i], n);
                On(t, o), s.push(o);
            }
            i.push(s);
        }
        return i;
    }
    function jn(e, t, n) {
        const i = [];
        for(let r = 0; r < e.length; r++){
            const s = Gn(e[r], t, n);
            i.push(s);
        }
        return i;
    }
    function Wn(e, t, n, i) {
        if (e[0] < n[0] || e[0] > n[2]) {
            const t = .5 * i;
            let r = e[0] - n[0] > t ? -i : n[0] - e[0] > t ? i : 0;
            0 === r && (r = e[0] - n[2] > t ? -i : n[2] - e[0] > t ? i : 0), e[0] += r;
        }
        On(t, e);
    }
    function Xn(e, t, n, i) {
        const r = Math.pow(2, i.z) * Fn, s = [
            i.x * Fn,
            i.y * Fn
        ], o = [];
        if (!e) return o;
        for (const i of e)for (const e of i){
            const i = [
                e.x + s[0],
                e.y + s[1]
            ];
            Wn(i, t, n, r), o.push(i);
        }
        return o;
    }
    function Yn(e, t, n, i) {
        const r = Math.pow(2, i.z) * Fn, s = [
            i.x * Fn,
            i.y * Fn
        ], o = [];
        if (!e) return o;
        for (const n of e){
            const e = [];
            for (const i of n){
                const n = [
                    i.x + s[0],
                    i.y + s[1]
                ];
                On(t, n), e.push(n);
            }
            o.push(e);
        }
        if (t[2] - t[0] <= r / 2) {
            (a = t)[0] = a[1] = 1 / 0, a[2] = a[3] = -1 / 0;
            for (const e of o)for (const i of e)Wn(i, t, n, r);
        }
        var a;
        return o;
    }
    class Zn {
        constructor(e, t){
            this.type = Nt, this.geojson = e, this.geometries = t;
        }
        static parse(e, t) {
            if (2 !== e.length) return t.error(`'within' expression requires exactly one argument, but found ${e.length - 1} instead.`);
            if (fn(e[1])) {
                const t = e[1];
                if ("FeatureCollection" === t.type) for(let e = 0; e < t.features.length; ++e){
                    const n = t.features[e].geometry.type;
                    if ("Polygon" === n || "MultiPolygon" === n) return new Zn(t, t.features[e].geometry);
                }
                else if ("Feature" === t.type) {
                    const e = t.geometry.type;
                    if ("Polygon" === e || "MultiPolygon" === e) return new Zn(t, t.geometry);
                } else if ("Polygon" === t.type || "MultiPolygon" === t.type) return new Zn(t, t);
            }
            return t.error("'within' expression requires valid geojson object that contains polygon geometry type.");
        }
        evaluate(e) {
            if (null != e.geometry() && null != e.canonicalID()) {
                if ("Point" === e.geometryType()) return function(e, t) {
                    const n = [
                        1 / 0,
                        1 / 0,
                        -1 / 0,
                        -1 / 0
                    ], i = [
                        1 / 0,
                        1 / 0,
                        -1 / 0,
                        -1 / 0
                    ], r = e.canonicalID();
                    if (!r) return !1;
                    if ("Polygon" === t.type) {
                        const s = Gn(t.coordinates, i, r), o = Xn(e.geometry(), n, i, r);
                        if (!Rn(n, i)) return !1;
                        for (const e of o)if (!Ln(e, s)) return !1;
                    }
                    if ("MultiPolygon" === t.type) {
                        const s = jn(t.coordinates, i, r), o = Xn(e.geometry(), n, i, r);
                        if (!Rn(n, i)) return !1;
                        for (const e of o)if (!Hn(e, s)) return !1;
                    }
                    return !0;
                }(e, this.geometries);
                if ("LineString" === e.geometryType()) return function(e, t) {
                    const n = [
                        1 / 0,
                        1 / 0,
                        -1 / 0,
                        -1 / 0
                    ], i = [
                        1 / 0,
                        1 / 0,
                        -1 / 0,
                        -1 / 0
                    ], r = e.canonicalID();
                    if (!r) return !1;
                    if ("Polygon" === t.type) {
                        const s = Gn(t.coordinates, i, r), o = Yn(e.geometry(), n, i, r);
                        if (!Rn(n, i)) return !1;
                        for (const e of o)if (!Un(e, s)) return !1;
                    }
                    if ("MultiPolygon" === t.type) {
                        const s = jn(t.coordinates, i, r), o = Yn(e.geometry(), n, i, r);
                        if (!Rn(n, i)) return !1;
                        for (const e of o)if (!Bn(e, s)) return !1;
                    }
                    return !0;
                }(e, this.geometries);
            }
            return !1;
        }
        eachChild() {}
        outputDefined() {
            return !0;
        }
        serialize() {
            return [
                "within",
                this.geojson
            ];
        }
    }
    var qn = Zn;
    function $n(e) {
        if (e instanceof Cn) {
            if ("get" === e.name && 1 === e.args.length) return !1;
            if ("feature-state" === e.name) return !1;
            if ("has" === e.name && 1 === e.args.length) return !1;
            if ("properties" === e.name || "geometry-type" === e.name || "id" === e.name) return !1;
            if (/^filter-/.test(e.name)) return !1;
        }
        if (e instanceof qn) return !1;
        let t = !0;
        return e.eachChild((e)=>{
            t && !$n(e) && (t = !1);
        }), t;
    }
    function Jn(e) {
        if (e instanceof Cn && "feature-state" === e.name) return !1;
        let t = !0;
        return e.eachChild((e)=>{
            t && !Jn(e) && (t = !1);
        }), t;
    }
    function Kn(e, t) {
        if (e instanceof Cn && t.indexOf(e.name) >= 0) return !1;
        let n = !0;
        return e.eachChild((e)=>{
            n && !Kn(e, t) && (n = !1);
        }), n;
    }
    class Qn {
        constructor(e, t){
            this.type = t.type, this.name = e, this.boundExpression = t;
        }
        static parse(e, t) {
            if (2 !== e.length || "string" != typeof e[1]) return t.error("'var' expression requires exactly one string literal argument.");
            const n = e[1];
            return t.scope.has(n) ? new Qn(n, t.scope.get(n)) : t.error(`Unknown variable "${n}". Make sure "${n}" has been bound in an enclosing "let" expression before using it.`, 1);
        }
        evaluate(e) {
            return this.boundExpression.evaluate(e);
        }
        eachChild() {}
        outputDefined() {
            return !1;
        }
        serialize() {
            return [
                "var",
                this.name
            ];
        }
    }
    var ei = Qn;
    class ti {
        constructor(e, t = [], n, i = new Et, r = []){
            this.registry = e, this.path = t, this.key = t.map((e)=>`[${e}]`).join(""), this.scope = i, this.errors = r, this.expectedType = n;
        }
        parse(e, t, n, i, r = {}) {
            return t ? this.concat(t, n, i)._parse(e, r) : this._parse(e, r);
        }
        _parse(e, t) {
            function n(e, t, n) {
                return "assert" === n ? new vn(t, [
                    e
                ]) : "coerce" === n ? new wn(t, [
                    e
                ]) : e;
            }
            if (null !== e && "string" != typeof e && "boolean" != typeof e && "number" != typeof e || (e = [
                "literal",
                e
            ]), Array.isArray(e)) {
                if (0 === e.length) return this.error('Expected an array with at least one element. If you wanted a literal array, use ["literal", []].');
                const i = e[0];
                if ("string" != typeof i) return this.error(`Expression name must be a string, but found ${typeof i} instead. If you wanted a literal array, use ["literal", [...]].`, 0), null;
                const r = this.registry[i];
                if (r) {
                    let i = r.parse(e, this);
                    if (!i) return null;
                    if (this.expectedType) {
                        const e = this.expectedType, r = i.type;
                        if ("string" !== e.kind && "number" !== e.kind && "boolean" !== e.kind && "object" !== e.kind && "array" !== e.kind || "value" !== r.kind) {
                            if ("color" !== e.kind && "formatted" !== e.kind && "resolvedImage" !== e.kind || "value" !== r.kind && "string" !== r.kind) {
                                if (this.checkSubtype(e, r)) return null;
                            } else i = n(i, e, t.typeAnnotation || "coerce");
                        } else i = n(i, e, t.typeAnnotation || "assert");
                    }
                    if (!(i instanceof mn) && "resolvedImage" !== i.type.kind && ii(i)) {
                        const t = new Pn;
                        try {
                            i = new mn(i.type, i.evaluate(t));
                        } catch (e) {
                            return this.error(e.message), null;
                        }
                    }
                    return i;
                }
                return this.error(`Unknown expression "${i}". If you wanted a literal array, use ["literal", [...]].`, 0);
            }
            return void 0 === e ? this.error("'undefined' value invalid. Use null instead.") : "object" == typeof e ? this.error('Bare objects invalid. Use ["literal", {...}] instead.') : this.error(`Expected an array, but found ${typeof e} instead.`);
        }
        concat(e, t, n) {
            const i = "number" == typeof e ? this.path.concat(e) : this.path, r = n ? this.scope.concat(n) : this.scope;
            return new ti(this.registry, i, t || null, r, this.errors);
        }
        error(e, ...t) {
            const n = `${this.key}${t.map((e)=>`[${e}]`).join("")}`;
            this.errors.push(new Ot(n, e));
        }
        checkSubtype(e, t) {
            const n = Zt(e, t);
            return n && this.error(n), n;
        }
    }
    var ni = ti;
    function ii(e) {
        if (e instanceof ei) return ii(e.boundExpression);
        if (e instanceof Cn && "error" === e.name) return !1;
        if (e instanceof kn) return !1;
        if (e instanceof qn) return !1;
        const t = e instanceof wn || e instanceof vn;
        let n = !0;
        return e.eachChild((e)=>{
            n = t ? n && ii(e) : n && e instanceof mn;
        }), !!n && $n(e) && Kn(e, [
            "zoom",
            "heatmap-density",
            "line-progress",
            "sky-radial-progress",
            "accumulated",
            "is-supported-script",
            "pitch",
            "distance-from-center"
        ]);
    }
    function ri(e, t) {
        const n = e.length - 1;
        let i, r, s = 0, o = n, a = 0;
        for(; s <= o;)if (a = Math.floor((s + o) / 2), i = e[a], r = e[a + 1], i <= t) {
            if (a === n || t < r) return a;
            s = a + 1;
        } else {
            if (!(i > t)) throw new yn("Input is not a number.");
            o = a - 1;
        }
        return 0;
    }
    class si {
        constructor(e, t, n){
            this.type = e, this.input = t, this.labels = [], this.outputs = [];
            for (const [e, t] of n)this.labels.push(e), this.outputs.push(t);
        }
        static parse(e, t) {
            if (e.length - 1 < 4) return t.error(`Expected at least 4 arguments, but found only ${e.length - 1}.`);
            if ((e.length - 1) % 2 != 0) return t.error("Expected an even number of arguments.");
            const n = t.parse(e[1], 1, Lt);
            if (!n) return null;
            const i = [];
            let r = null;
            t.expectedType && "value" !== t.expectedType.kind && (r = t.expectedType);
            for(let n = 1; n < e.length; n += 2){
                const s = 1 === n ? -1 / 0 : e[n], o = e[n + 1], a = n, l = n + 1;
                if ("number" != typeof s) return t.error('Input/output pairs for "step" expressions must be defined using literal numeric values (not computed expressions) for the input values.', a);
                if (i.length && i[i.length - 1][0] >= s) return t.error('Input/output pairs for "step" expressions must be arranged with input values in strictly ascending order.', a);
                const h = t.parse(o, l, r);
                if (!h) return null;
                r = r || h.type, i.push([
                    s,
                    h
                ]);
            }
            return new si(r, n, i);
        }
        evaluate(e) {
            const t = this.labels, n = this.outputs;
            if (1 === t.length) return n[0].evaluate(e);
            const i = this.input.evaluate(e);
            if (i <= t[0]) return n[0].evaluate(e);
            const r = t.length;
            return i >= t[r - 1] ? n[r - 1].evaluate(e) : n[ri(t, i)].evaluate(e);
        }
        eachChild(e) {
            e(this.input);
            for (const t of this.outputs)e(t);
        }
        outputDefined() {
            return this.outputs.every((e)=>e.outputDefined());
        }
        serialize() {
            const e = [
                "step",
                this.input.serialize()
            ];
            for(let t = 0; t < this.labels.length; t++)t > 0 && e.push(this.labels[t]), e.push(this.outputs[t].serialize());
            return e;
        }
    }
    var oi = si, ai = li;
    function li(e, t, n, i) {
        this.cx = 3 * e, this.bx = 3 * (n - e) - this.cx, this.ax = 1 - this.cx - this.bx, this.cy = 3 * t, this.by = 3 * (i - t) - this.cy, this.ay = 1 - this.cy - this.by, this.p1x = e, this.p1y = t, this.p2x = n, this.p2y = i;
    }
    function hi(e, t, n) {
        return e * (1 - n) + t * n;
    }
    li.prototype = {
        sampleCurveX: function(e) {
            return ((this.ax * e + this.bx) * e + this.cx) * e;
        },
        sampleCurveY: function(e) {
            return ((this.ay * e + this.by) * e + this.cy) * e;
        },
        sampleCurveDerivativeX: function(e) {
            return (3 * this.ax * e + 2 * this.bx) * e + this.cx;
        },
        solveCurveX: function(e, t) {
            if (void 0 === t && (t = 1e-6), e < 0) return 0;
            if (e > 1) return 1;
            for(var n = e, i = 0; i < 8; i++){
                var r = this.sampleCurveX(n) - e;
                if (Math.abs(r) < t) return n;
                var s = this.sampleCurveDerivativeX(n);
                if (Math.abs(s) < 1e-6) break;
                n -= r / s;
            }
            var o = 0, a = 1;
            for(n = e, i = 0; i < 20 && (r = this.sampleCurveX(n), !(Math.abs(r - e) < t)); i++)e > r ? o = n : a = n, n = .5 * (a - o) + o;
            return n;
        },
        solve: function(e, t) {
            return this.sampleCurveY(this.solveCurveX(e, t));
        }
    };
    var ci = Object.freeze({
        __proto__: null,
        number: hi,
        color: function(e, t, n) {
            return new on(hi(e.r, t.r, n), hi(e.g, t.g, n), hi(e.b, t.b, n), hi(e.a, t.a, n));
        },
        array: function(e, t, n) {
            return e.map((e, i)=>hi(e, t[i], n));
        }
    });
    const ui = .95047, fi = 1.08883, di = 4 / 29, pi = 6 / 29, gi = 3 * pi * pi, mi = pi * pi * pi, yi = Math.PI / 180, xi = 180 / Math.PI;
    function _i(e) {
        return e > mi ? Math.pow(e, 1 / 3) : e / gi + di;
    }
    function vi(e) {
        return e > pi ? e * e * e : gi * (e - di);
    }
    function bi(e) {
        return 255 * (e <= .0031308 ? 12.92 * e : 1.055 * Math.pow(e, 1 / 2.4) - .055);
    }
    function Ai(e) {
        return (e /= 255) <= .04045 ? e / 12.92 : Math.pow((e + .055) / 1.055, 2.4);
    }
    function Ti(e) {
        const t = Ai(e.r), n = Ai(e.g), i = Ai(e.b), r = _i((.4124564 * t + .3575761 * n + .1804375 * i) / ui), s = _i((.2126729 * t + .7151522 * n + .072175 * i) / 1);
        return {
            l: 116 * s - 16,
            a: 500 * (r - s),
            b: 200 * (s - _i((.0193339 * t + .119192 * n + .9503041 * i) / fi)),
            alpha: e.a
        };
    }
    function Si(e) {
        let t = (e.l + 16) / 116, n = isNaN(e.a) ? t : t + e.a / 500, i = isNaN(e.b) ? t : t - e.b / 200;
        return t = 1 * vi(t), n = ui * vi(n), i = fi * vi(i), new on(bi(3.2404542 * n - 1.5371385 * t - .4985314 * i), bi(-0.969266 * n + 1.8760108 * t + .041556 * i), bi(.0556434 * n - .2040259 * t + 1.0572252 * i), e.alpha);
    }
    function wi(e, t, n) {
        const i = t - e;
        return e + n * (i > 180 || i < -180 ? i - 360 * Math.round(i / 360) : i);
    }
    const Mi = {
        forward: Ti,
        reverse: Si,
        interpolate: function(e, t, n) {
            return {
                l: hi(e.l, t.l, n),
                a: hi(e.a, t.a, n),
                b: hi(e.b, t.b, n),
                alpha: hi(e.alpha, t.alpha, n)
            };
        }
    }, Pi = {
        forward: function(e) {
            const { l: t, a: n, b: i } = Ti(e), r = Math.atan2(i, n) * xi;
            return {
                h: r < 0 ? r + 360 : r,
                c: Math.sqrt(n * n + i * i),
                l: t,
                alpha: e.a
            };
        },
        reverse: function(e) {
            const t = e.h * yi, n = e.c;
            return Si({
                l: e.l,
                a: Math.cos(t) * n,
                b: Math.sin(t) * n,
                alpha: e.alpha
            });
        },
        interpolate: function(e, t, n) {
            return {
                h: wi(e.h, t.h, n),
                c: hi(e.c, t.c, n),
                l: hi(e.l, t.l, n),
                alpha: hi(e.alpha, t.alpha, n)
            };
        }
    };
    var Ii = Object.freeze({
        __proto__: null,
        lab: Mi,
        hcl: Pi
    });
    class Ci {
        constructor(e, t, n, i, r){
            this.type = e, this.operator = t, this.interpolation = n, this.input = i, this.labels = [], this.outputs = [];
            for (const [e, t] of r)this.labels.push(e), this.outputs.push(t);
        }
        static interpolationFactor(e, t, n, i) {
            let r = 0;
            if ("exponential" === e.name) r = ki(t, e.base, n, i);
            else if ("linear" === e.name) r = ki(t, 1, n, i);
            else if ("cubic-bezier" === e.name) {
                const s = e.controlPoints;
                r = new ai(s[0], s[1], s[2], s[3]).solve(ki(t, 1, n, i));
            }
            return r;
        }
        static parse(e, t) {
            let [n, i, r, ...s] = e;
            if (!Array.isArray(i) || 0 === i.length) return t.error("Expected an interpolation type expression.", 1);
            if ("linear" === i[0]) i = {
                name: "linear"
            };
            else if ("exponential" === i[0]) {
                const e = i[1];
                if ("number" != typeof e) return t.error("Exponential interpolation requires a numeric base.", 1, 1);
                i = {
                    name: "exponential",
                    base: e
                };
            } else {
                if ("cubic-bezier" !== i[0]) return t.error(`Unknown interpolation type ${String(i[0])}`, 1, 0);
                {
                    const e = i.slice(1);
                    if (4 !== e.length || e.some((e)=>"number" != typeof e || e < 0 || e > 1)) return t.error("Cubic bezier interpolation requires four numeric arguments with values between 0 and 1.", 1);
                    i = {
                        name: "cubic-bezier",
                        controlPoints: e
                    };
                }
            }
            if (e.length - 1 < 4) return t.error(`Expected at least 4 arguments, but found only ${e.length - 1}.`);
            if ((e.length - 1) % 2 != 0) return t.error("Expected an even number of arguments.");
            if (r = t.parse(r, 2, Lt), !r) return null;
            const o = [];
            let a = null;
            "interpolate-hcl" === n || "interpolate-lab" === n ? a = zt : t.expectedType && "value" !== t.expectedType.kind && (a = t.expectedType);
            for(let e = 0; e < s.length; e += 2){
                const n = s[e], i = s[e + 1], r = e + 3, l = e + 4;
                if ("number" != typeof n) return t.error('Input/output pairs for "interpolate" expressions must be defined using literal numeric values (not computed expressions) for the input values.', r);
                if (o.length && o[o.length - 1][0] >= n) return t.error('Input/output pairs for "interpolate" expressions must be arranged with input values in strictly ascending order.', r);
                const h = t.parse(i, l, a);
                if (!h) return null;
                a = a || h.type, o.push([
                    n,
                    h
                ]);
            }
            return "number" === a.kind || "color" === a.kind || "array" === a.kind && "number" === a.itemType.kind && "number" == typeof a.N ? new Ci(a, n, i, r, o) : t.error(`Type ${Xt(a)} is not interpolatable.`);
        }
        evaluate(e) {
            const t = this.labels, n = this.outputs;
            if (1 === t.length) return n[0].evaluate(e);
            const i = this.input.evaluate(e);
            if (i <= t[0]) return n[0].evaluate(e);
            const r = t.length;
            if (i >= t[r - 1]) return n[r - 1].evaluate(e);
            const s = ri(t, i), o = t[s], a = t[s + 1], l = Ci.interpolationFactor(this.interpolation, i, o, a), h = n[s].evaluate(e), c = n[s + 1].evaluate(e);
            return "interpolate" === this.operator ? ci[this.type.kind.toLowerCase()](h, c, l) : "interpolate-hcl" === this.operator ? Pi.reverse(Pi.interpolate(Pi.forward(h), Pi.forward(c), l)) : Mi.reverse(Mi.interpolate(Mi.forward(h), Mi.forward(c), l));
        }
        eachChild(e) {
            e(this.input);
            for (const t of this.outputs)e(t);
        }
        outputDefined() {
            return this.outputs.every((e)=>e.outputDefined());
        }
        serialize() {
            let e;
            e = "linear" === this.interpolation.name ? [
                "linear"
            ] : "exponential" === this.interpolation.name ? 1 === this.interpolation.base ? [
                "linear"
            ] : [
                "exponential",
                this.interpolation.base
            ] : [
                "cubic-bezier"
            ].concat(this.interpolation.controlPoints);
            const t = [
                this.operator,
                e,
                this.input.serialize()
            ];
            for(let e = 0; e < this.labels.length; e++)t.push(this.labels[e], this.outputs[e].serialize());
            return t;
        }
    }
    function ki(e, t, n, i) {
        const r = i - n, s = e - n;
        return 0 === r ? 0 : 1 === t ? s / r : (Math.pow(t, s) - 1) / (Math.pow(t, r) - 1);
    }
    var Fi = Ci;
    class Oi {
        constructor(e, t){
            this.type = e, this.args = t;
        }
        static parse(e, t) {
            if (e.length < 2) return t.error("Expectected at least one argument.");
            let n = null;
            const i = t.expectedType;
            i && "value" !== i.kind && (n = i);
            const r = [];
            for (const i of e.slice(1)){
                const e = t.parse(i, 1 + r.length, n, void 0, {
                    typeAnnotation: "omit"
                });
                if (!e) return null;
                n = n || e.type, r.push(e);
            }
            const s = i && r.some((e)=>Zt(i, e.type));
            return new Oi(s ? Ut : n, r);
        }
        evaluate(e) {
            let t, n = null, i = 0;
            for (const r of this.args){
                if (i++, n = r.evaluate(e), n && n instanceof cn && !n.available && (t || (t = n), n = null, i === this.args.length)) return t;
                if (null !== n) break;
            }
            return n;
        }
        eachChild(e) {
            this.args.forEach(e);
        }
        outputDefined() {
            return this.args.every((e)=>e.outputDefined());
        }
        serialize() {
            const e = [
                "coalesce"
            ];
            return this.eachChild((t)=>{
                e.push(t.serialize());
            }), e;
        }
    }
    var Ri = Oi;
    class Ei {
        constructor(e, t){
            this.type = t.type, this.bindings = [].concat(e), this.result = t;
        }
        evaluate(e) {
            return this.result.evaluate(e);
        }
        eachChild(e) {
            for (const t of this.bindings)e(t[1]);
            e(this.result);
        }
        static parse(e, t) {
            if (e.length < 4) return t.error(`Expected at least 3 arguments, but found ${e.length - 1} instead.`);
            const n = [];
            for(let i = 1; i < e.length - 1; i += 2){
                const r = e[i];
                if ("string" != typeof r) return t.error(`Expected string, but found ${typeof r} instead.`, i);
                if (/[^a-zA-Z0-9_]/.test(r)) return t.error("Variable names must contain only alphanumeric characters or '_'.", i);
                const s = t.parse(e[i + 1], i + 1);
                if (!s) return null;
                n.push([
                    r,
                    s
                ]);
            }
            const i = t.parse(e[e.length - 1], e.length - 1, t.expectedType, n);
            return i ? new Ei(n, i) : null;
        }
        outputDefined() {
            return this.result.outputDefined();
        }
        serialize() {
            const e = [
                "let"
            ];
            for (const [t, n] of this.bindings)e.push(t, n.serialize());
            return e.push(this.result.serialize()), e;
        }
    }
    var Di = Ei;
    class Li {
        constructor(e, t, n){
            this.type = e, this.index = t, this.input = n;
        }
        static parse(e, t) {
            if (3 !== e.length) return t.error(`Expected 2 arguments, but found ${e.length - 1} instead.`);
            const n = t.parse(e[1], 1, Lt), i = t.parse(e[2], 2, Wt(t.expectedType || Ut));
            if (!n || !i) return null;
            const r = i.type;
            return new Li(r.itemType, n, i);
        }
        evaluate(e) {
            const t = this.index.evaluate(e), n = this.input.evaluate(e);
            if (t < 0) throw new yn(`Array index out of bounds: ${t} < 0.`);
            if (t >= n.length) throw new yn(`Array index out of bounds: ${t} > ${n.length - 1}.`);
            if (t !== Math.floor(t)) throw new yn(`Array index must be an integer, but found ${t} instead.`);
            return n[t];
        }
        eachChild(e) {
            e(this.index), e(this.input);
        }
        outputDefined() {
            return !1;
        }
        serialize() {
            return [
                "at",
                this.index.serialize(),
                this.input.serialize()
            ];
        }
    }
    var Hi = Li;
    class Ni {
        constructor(e, t){
            this.type = Nt, this.needle = e, this.haystack = t;
        }
        static parse(e, t) {
            if (3 !== e.length) return t.error(`Expected 2 arguments, but found ${e.length - 1} instead.`);
            const n = t.parse(e[1], 1, Ut), i = t.parse(e[2], 2, Ut);
            return n && i ? qt(n.type, [
                Nt,
                Ht,
                Lt,
                Dt,
                Ut
            ]) ? new Ni(n, i) : t.error(`Expected first argument to be of type boolean, string, number or null, but found ${Xt(n.type)} instead`) : null;
        }
        evaluate(e) {
            const t = this.needle.evaluate(e), n = this.haystack.evaluate(e);
            if (null == n) return !1;
            if (!$t(t, [
                "boolean",
                "string",
                "number",
                "null"
            ])) throw new yn(`Expected first argument to be of type boolean, string, number or null, but found ${Xt(dn(t))} instead.`);
            if (!$t(n, [
                "string",
                "array"
            ])) throw new yn(`Expected second argument to be of type array or string, but found ${Xt(dn(n))} instead.`);
            return n.indexOf(t) >= 0;
        }
        eachChild(e) {
            e(this.needle), e(this.haystack);
        }
        outputDefined() {
            return !0;
        }
        serialize() {
            return [
                "in",
                this.needle.serialize(),
                this.haystack.serialize()
            ];
        }
    }
    var zi = Ni;
    class Vi {
        constructor(e, t, n){
            this.type = Lt, this.needle = e, this.haystack = t, this.fromIndex = n;
        }
        static parse(e, t) {
            if (e.length <= 2 || e.length >= 5) return t.error(`Expected 3 or 4 arguments, but found ${e.length - 1} instead.`);
            const n = t.parse(e[1], 1, Ut), i = t.parse(e[2], 2, Ut);
            if (!n || !i) return null;
            if (!qt(n.type, [
                Nt,
                Ht,
                Lt,
                Dt,
                Ut
            ])) return t.error(`Expected first argument to be of type boolean, string, number or null, but found ${Xt(n.type)} instead`);
            if (4 === e.length) {
                const r = t.parse(e[3], 3, Lt);
                return r ? new Vi(n, i, r) : null;
            }
            return new Vi(n, i);
        }
        evaluate(e) {
            const t = this.needle.evaluate(e), n = this.haystack.evaluate(e);
            if (!$t(t, [
                "boolean",
                "string",
                "number",
                "null"
            ])) throw new yn(`Expected first argument to be of type boolean, string, number or null, but found ${Xt(dn(t))} instead.`);
            if (!$t(n, [
                "string",
                "array"
            ])) throw new yn(`Expected second argument to be of type array or string, but found ${Xt(dn(n))} instead.`);
            if (this.fromIndex) {
                const i = this.fromIndex.evaluate(e);
                return n.indexOf(t, i);
            }
            return n.indexOf(t);
        }
        eachChild(e) {
            e(this.needle), e(this.haystack), this.fromIndex && e(this.fromIndex);
        }
        outputDefined() {
            return !1;
        }
        serialize() {
            if (null != this.fromIndex && void 0 !== this.fromIndex) {
                const e = this.fromIndex.serialize();
                return [
                    "index-of",
                    this.needle.serialize(),
                    this.haystack.serialize(),
                    e
                ];
            }
            return [
                "index-of",
                this.needle.serialize(),
                this.haystack.serialize()
            ];
        }
    }
    var Ui = Vi;
    class Bi {
        constructor(e, t, n, i, r, s){
            this.inputType = e, this.type = t, this.input = n, this.cases = i, this.outputs = r, this.otherwise = s;
        }
        static parse(e, t) {
            if (e.length < 5) return t.error(`Expected at least 4 arguments, but found only ${e.length - 1}.`);
            if (e.length % 2 != 1) return t.error("Expected an even number of arguments.");
            let n, i;
            t.expectedType && "value" !== t.expectedType.kind && (i = t.expectedType);
            const r = {}, s = [];
            for(let o = 2; o < e.length - 1; o += 2){
                let a = e[o];
                const l = e[o + 1];
                Array.isArray(a) || (a = [
                    a
                ]);
                const h = t.concat(o);
                if (0 === a.length) return h.error("Expected at least one branch label.");
                for (const e of a){
                    if ("number" != typeof e && "string" != typeof e) return h.error("Branch labels must be numbers or strings.");
                    if ("number" == typeof e && Math.abs(e) > Number.MAX_SAFE_INTEGER) return h.error(`Branch labels must be integers no larger than ${Number.MAX_SAFE_INTEGER}.`);
                    if ("number" == typeof e && Math.floor(e) !== e) return h.error("Numeric branch labels must be integer values.");
                    if (n) {
                        if (h.checkSubtype(n, dn(e))) return null;
                    } else n = dn(e);
                    if (void 0 !== r[String(e)]) return h.error("Branch labels must be unique.");
                    r[String(e)] = s.length;
                }
                const c = t.parse(l, o, i);
                if (!c) return null;
                i = i || c.type, s.push(c);
            }
            const o = t.parse(e[1], 1, Ut);
            if (!o) return null;
            const a = t.parse(e[e.length - 1], e.length - 1, i);
            return a ? "value" !== o.type.kind && t.concat(1).checkSubtype(n, o.type) ? null : new Bi(n, i, o, r, s, a) : null;
        }
        evaluate(e) {
            const t = this.input.evaluate(e);
            return (dn(t) === this.inputType && this.outputs[this.cases[t]] || this.otherwise).evaluate(e);
        }
        eachChild(e) {
            e(this.input), this.outputs.forEach(e), e(this.otherwise);
        }
        outputDefined() {
            return this.outputs.every((e)=>e.outputDefined()) && this.otherwise.outputDefined();
        }
        serialize() {
            const e = [
                "match",
                this.input.serialize()
            ], t = Object.keys(this.cases).sort(), n = [], i = {};
            for (const e of t){
                const t = i[this.cases[e]];
                void 0 === t ? (i[this.cases[e]] = n.length, n.push([
                    this.cases[e],
                    [
                        e
                    ]
                ])) : n[t][1].push(e);
            }
            const r = (e)=>"number" === this.inputType.kind ? Number(e) : e;
            for (const [t, i] of n)1 === i.length ? e.push(r(i[0])) : e.push(i.map(r)), e.push(this.outputs[t].serialize());
            return e.push(this.otherwise.serialize()), e;
        }
    }
    var Gi = Bi;
    class ji {
        constructor(e, t, n){
            this.type = e, this.branches = t, this.otherwise = n;
        }
        static parse(e, t) {
            if (e.length < 4) return t.error(`Expected at least 3 arguments, but found only ${e.length - 1}.`);
            if (e.length % 2 != 0) return t.error("Expected an odd number of arguments.");
            let n;
            t.expectedType && "value" !== t.expectedType.kind && (n = t.expectedType);
            const i = [];
            for(let r = 1; r < e.length - 1; r += 2){
                const s = t.parse(e[r], r, Nt);
                if (!s) return null;
                const o = t.parse(e[r + 1], r + 1, n);
                if (!o) return null;
                i.push([
                    s,
                    o
                ]), n = n || o.type;
            }
            const r = t.parse(e[e.length - 1], e.length - 1, n);
            return r ? new ji(n, i, r) : null;
        }
        evaluate(e) {
            for (const [t, n] of this.branches)if (t.evaluate(e)) return n.evaluate(e);
            return this.otherwise.evaluate(e);
        }
        eachChild(e) {
            for (const [t, n] of this.branches)e(t), e(n);
            e(this.otherwise);
        }
        outputDefined() {
            return this.branches.every(([e, t])=>t.outputDefined()) && this.otherwise.outputDefined();
        }
        serialize() {
            const e = [
                "case"
            ];
            return this.eachChild((t)=>{
                e.push(t.serialize());
            }), e;
        }
    }
    var Wi = ji;
    class Xi {
        constructor(e, t, n, i){
            this.type = e, this.input = t, this.beginIndex = n, this.endIndex = i;
        }
        static parse(e, t) {
            if (e.length <= 2 || e.length >= 5) return t.error(`Expected 3 or 4 arguments, but found ${e.length - 1} instead.`);
            const n = t.parse(e[1], 1, Ut), i = t.parse(e[2], 2, Lt);
            if (!n || !i) return null;
            if (!qt(n.type, [
                Wt(Ut),
                Ht,
                Ut
            ])) return t.error(`Expected first argument to be of type array or string, but found ${Xt(n.type)} instead`);
            if (4 === e.length) {
                const r = t.parse(e[3], 3, Lt);
                return r ? new Xi(n.type, n, i, r) : null;
            }
            return new Xi(n.type, n, i);
        }
        evaluate(e) {
            const t = this.input.evaluate(e), n = this.beginIndex.evaluate(e);
            if (!$t(t, [
                "string",
                "array"
            ])) throw new yn(`Expected first argument to be of type array or string, but found ${Xt(dn(t))} instead.`);
            if (this.endIndex) {
                const i = this.endIndex.evaluate(e);
                return t.slice(n, i);
            }
            return t.slice(n);
        }
        eachChild(e) {
            e(this.input), e(this.beginIndex), this.endIndex && e(this.endIndex);
        }
        outputDefined() {
            return !1;
        }
        serialize() {
            if (null != this.endIndex && void 0 !== this.endIndex) {
                const e = this.endIndex.serialize();
                return [
                    "slice",
                    this.input.serialize(),
                    this.beginIndex.serialize(),
                    e
                ];
            }
            return [
                "slice",
                this.input.serialize(),
                this.beginIndex.serialize()
            ];
        }
    }
    var Yi = Xi;
    function Zi(e, t) {
        return "==" === e || "!=" === e ? "boolean" === t.kind || "string" === t.kind || "number" === t.kind || "null" === t.kind || "value" === t.kind : "string" === t.kind || "number" === t.kind || "value" === t.kind;
    }
    function qi(e, t, n, i) {
        return 0 === i.compare(t, n);
    }
    function $i(e, t, n) {
        const i = "==" !== e && "!=" !== e;
        return class r {
            constructor(e, t, n){
                this.type = Nt, this.lhs = e, this.rhs = t, this.collator = n, this.hasUntypedArgument = "value" === e.type.kind || "value" === t.type.kind;
            }
            static parse(e, t) {
                if (3 !== e.length && 4 !== e.length) return t.error("Expected two or three arguments.");
                const n = e[0];
                let s = t.parse(e[1], 1, Ut);
                if (!s) return null;
                if (!Zi(n, s.type)) return t.concat(1).error(`"${n}" comparisons are not supported for type '${Xt(s.type)}'.`);
                let o = t.parse(e[2], 2, Ut);
                if (!o) return null;
                if (!Zi(n, o.type)) return t.concat(2).error(`"${n}" comparisons are not supported for type '${Xt(o.type)}'.`);
                if (s.type.kind !== o.type.kind && "value" !== s.type.kind && "value" !== o.type.kind) return t.error(`Cannot compare types '${Xt(s.type)}' and '${Xt(o.type)}'.`);
                i && ("value" === s.type.kind && "value" !== o.type.kind ? s = new vn(o.type, [
                    s
                ]) : "value" !== s.type.kind && "value" === o.type.kind && (o = new vn(s.type, [
                    o
                ])));
                let a = null;
                if (4 === e.length) {
                    if ("string" !== s.type.kind && "string" !== o.type.kind && "value" !== s.type.kind && "value" !== o.type.kind) return t.error("Cannot use collator to compare non-string types.");
                    if (a = t.parse(e[3], 3, Bt), !a) return null;
                }
                return new r(s, o, a);
            }
            evaluate(r) {
                const s = this.lhs.evaluate(r), o = this.rhs.evaluate(r);
                if (i && this.hasUntypedArgument) {
                    const t = dn(s), n = dn(o);
                    if (t.kind !== n.kind || "string" !== t.kind && "number" !== t.kind) throw new yn(`Expected arguments for "${e}" to be (string, string) or (number, number), but found (${t.kind}, ${n.kind}) instead.`);
                }
                if (this.collator && !i && this.hasUntypedArgument) {
                    const e = dn(s), n = dn(o);
                    if ("string" !== e.kind || "string" !== n.kind) return t(r, s, o);
                }
                return this.collator ? n(r, s, o, this.collator.evaluate(r)) : t(r, s, o);
            }
            eachChild(e) {
                e(this.lhs), e(this.rhs), this.collator && e(this.collator);
            }
            outputDefined() {
                return !0;
            }
            serialize() {
                const t = [
                    e
                ];
                return this.eachChild((e)=>{
                    t.push(e.serialize());
                }), t;
            }
        };
    }
    const Ji = $i("==", function(e, t, n) {
        return t === n;
    }, qi), Ki = $i("!=", function(e, t, n) {
        return t !== n;
    }, function(e, t, n, i) {
        return !qi(0, t, n, i);
    }), Qi = $i("<", function(e, t, n) {
        return t < n;
    }, function(e, t, n, i) {
        return i.compare(t, n) < 0;
    }), er = $i(">", function(e, t, n) {
        return t > n;
    }, function(e, t, n, i) {
        return i.compare(t, n) > 0;
    }), tr = $i("<=", function(e, t, n) {
        return t <= n;
    }, function(e, t, n, i) {
        return i.compare(t, n) <= 0;
    }), nr = $i(">=", function(e, t, n) {
        return t >= n;
    }, function(e, t, n, i) {
        return i.compare(t, n) >= 0;
    });
    class ir {
        constructor(e, t, n, i, r, s){
            this.type = Ht, this.number = e, this.locale = t, this.currency = n, this.unit = i, this.minFractionDigits = r, this.maxFractionDigits = s;
        }
        static parse(e, t) {
            if (3 !== e.length) return t.error("Expected two arguments.");
            const n = t.parse(e[1], 1, Lt);
            if (!n) return null;
            const i = e[2];
            if ("object" != typeof i || Array.isArray(i)) return t.error("NumberFormat options argument must be an object.");
            let r = null;
            if (i.locale && (r = t.parse(i.locale, 1, Ht), !r)) return null;
            let s = null;
            if (i.currency && (s = t.parse(i.currency, 1, Ht), !s)) return null;
            let o = null;
            if (i.unit && (o = t.parse(i.unit, 1, Ht), !o)) return null;
            let a = null;
            if (i["min-fraction-digits"] && (a = t.parse(i["min-fraction-digits"], 1, Lt), !a)) return null;
            let l = null;
            return i["max-fraction-digits"] && (l = t.parse(i["max-fraction-digits"], 1, Lt), !l) ? null : new ir(n, r, s, o, a, l);
        }
        evaluate(e) {
            return new Intl.NumberFormat(this.locale ? this.locale.evaluate(e) : [], {
                style: (this.currency ? "currency" : this.unit && "unit") || "decimal",
                currency: this.currency ? this.currency.evaluate(e) : void 0,
                unit: this.unit ? this.unit.evaluate(e) : void 0,
                minimumFractionDigits: this.minFractionDigits ? this.minFractionDigits.evaluate(e) : void 0,
                maximumFractionDigits: this.maxFractionDigits ? this.maxFractionDigits.evaluate(e) : void 0
            }).format(this.number.evaluate(e));
        }
        eachChild(e) {
            e(this.number), this.locale && e(this.locale), this.currency && e(this.currency), this.unit && e(this.unit), this.minFractionDigits && e(this.minFractionDigits), this.maxFractionDigits && e(this.maxFractionDigits);
        }
        outputDefined() {
            return !1;
        }
        serialize() {
            const e = {};
            return this.locale && (e.locale = this.locale.serialize()), this.currency && (e.currency = this.currency.serialize()), this.unit && (e.unit = this.unit.serialize()), this.minFractionDigits && (e["min-fraction-digits"] = this.minFractionDigits.serialize()), this.maxFractionDigits && (e["max-fraction-digits"] = this.maxFractionDigits.serialize()), [
                "number-format",
                this.number.serialize(),
                e
            ];
        }
    }
    class rr {
        constructor(e){
            this.type = Lt, this.input = e;
        }
        static parse(e, t) {
            if (2 !== e.length) return t.error(`Expected 1 argument, but found ${e.length - 1} instead.`);
            const n = t.parse(e[1], 1);
            return n ? "array" !== n.type.kind && "string" !== n.type.kind && "value" !== n.type.kind ? t.error(`Expected argument of type string or array, but found ${Xt(n.type)} instead.`) : new rr(n) : null;
        }
        evaluate(e) {
            const t = this.input.evaluate(e);
            if ("string" == typeof t) return t.length;
            if (Array.isArray(t)) return t.length;
            throw new yn(`Expected value to be of type string or array, but found ${Xt(dn(t))} instead.`);
        }
        eachChild(e) {
            e(this.input);
        }
        outputDefined() {
            return !1;
        }
        serialize() {
            const e = [
                "length"
            ];
            return this.eachChild((t)=>{
                e.push(t.serialize());
            }), e;
        }
    }
    const sr = {
        "==": Ji,
        "!=": Ki,
        ">": er,
        "<": Qi,
        ">=": nr,
        "<=": tr,
        array: vn,
        at: Hi,
        boolean: vn,
        case: Wi,
        coalesce: Ri,
        collator: kn,
        format: bn,
        image: An,
        in: zi,
        "index-of": Ui,
        interpolate: Fi,
        "interpolate-hcl": Fi,
        "interpolate-lab": Fi,
        length: rr,
        let: Di,
        literal: mn,
        match: Gi,
        number: vn,
        "number-format": ir,
        object: vn,
        slice: Yi,
        step: oi,
        string: vn,
        "to-boolean": wn,
        "to-color": wn,
        "to-number": wn,
        "to-string": wn,
        var: ei,
        within: qn
    };
    function or(e, [t, n, i, r]) {
        t = t.evaluate(e), n = n.evaluate(e), i = i.evaluate(e);
        const s = r ? r.evaluate(e) : 1, o = un(t, n, i, s);
        if (o) throw new yn(o);
        return new on(t / 255 * s, n / 255 * s, i / 255 * s, s);
    }
    function ar(e, t) {
        return e in t;
    }
    function lr(e, t) {
        const n = t[e];
        return void 0 === n ? null : n;
    }
    function hr(e) {
        return {
            type: e
        };
    }
    Cn.register(sr, {
        error: [
            {
                kind: "error"
            },
            [
                Ht
            ],
            (e, [t])=>{
                throw new yn(t.evaluate(e));
            }
        ],
        typeof: [
            Ht,
            [
                Ut
            ],
            (e, [t])=>Xt(dn(t.evaluate(e)))
        ],
        "to-rgba": [
            Wt(Lt, 4),
            [
                zt
            ],
            (e, [t])=>t.evaluate(e).toArray()
        ],
        rgb: [
            zt,
            [
                Lt,
                Lt,
                Lt
            ],
            or
        ],
        rgba: [
            zt,
            [
                Lt,
                Lt,
                Lt,
                Lt
            ],
            or
        ],
        has: {
            type: Nt,
            overloads: [
                [
                    [
                        Ht
                    ],
                    (e, [t])=>ar(t.evaluate(e), e.properties())
                ],
                [
                    [
                        Ht,
                        Vt
                    ],
                    (e, [t, n])=>ar(t.evaluate(e), n.evaluate(e))
                ]
            ]
        },
        get: {
            type: Ut,
            overloads: [
                [
                    [
                        Ht
                    ],
                    (e, [t])=>lr(t.evaluate(e), e.properties())
                ],
                [
                    [
                        Ht,
                        Vt
                    ],
                    (e, [t, n])=>lr(t.evaluate(e), n.evaluate(e))
                ]
            ]
        },
        "feature-state": [
            Ut,
            [
                Ht
            ],
            (e, [t])=>lr(t.evaluate(e), e.featureState || {})
        ],
        properties: [
            Vt,
            [],
            (e)=>e.properties()
        ],
        "geometry-type": [
            Ht,
            [],
            (e)=>e.geometryType()
        ],
        id: [
            Ut,
            [],
            (e)=>e.id()
        ],
        zoom: [
            Lt,
            [],
            (e)=>e.globals.zoom
        ],
        pitch: [
            Lt,
            [],
            (e)=>e.globals.pitch || 0
        ],
        "distance-from-center": [
            Lt,
            [],
            (e)=>e.distanceFromCenter()
        ],
        "heatmap-density": [
            Lt,
            [],
            (e)=>e.globals.heatmapDensity || 0
        ],
        "line-progress": [
            Lt,
            [],
            (e)=>e.globals.lineProgress || 0
        ],
        "sky-radial-progress": [
            Lt,
            [],
            (e)=>e.globals.skyRadialProgress || 0
        ],
        accumulated: [
            Ut,
            [],
            (e)=>void 0 === e.globals.accumulated ? null : e.globals.accumulated
        ],
        "+": [
            Lt,
            hr(Lt),
            (e, t)=>{
                let n = 0;
                for (const i of t)n += i.evaluate(e);
                return n;
            }
        ],
        "*": [
            Lt,
            hr(Lt),
            (e, t)=>{
                let n = 1;
                for (const i of t)n *= i.evaluate(e);
                return n;
            }
        ],
        "-": {
            type: Lt,
            overloads: [
                [
                    [
                        Lt,
                        Lt
                    ],
                    (e, [t, n])=>t.evaluate(e) - n.evaluate(e)
                ],
                [
                    [
                        Lt
                    ],
                    (e, [t])=>-t.evaluate(e)
                ]
            ]
        },
        "/": [
            Lt,
            [
                Lt,
                Lt
            ],
            (e, [t, n])=>t.evaluate(e) / n.evaluate(e)
        ],
        "%": [
            Lt,
            [
                Lt,
                Lt
            ],
            (e, [t, n])=>t.evaluate(e) % n.evaluate(e)
        ],
        ln2: [
            Lt,
            [],
            ()=>Math.LN2
        ],
        pi: [
            Lt,
            [],
            ()=>Math.PI
        ],
        e: [
            Lt,
            [],
            ()=>Math.E
        ],
        "^": [
            Lt,
            [
                Lt,
                Lt
            ],
            (e, [t, n])=>Math.pow(t.evaluate(e), n.evaluate(e))
        ],
        sqrt: [
            Lt,
            [
                Lt
            ],
            (e, [t])=>Math.sqrt(t.evaluate(e))
        ],
        log10: [
            Lt,
            [
                Lt
            ],
            (e, [t])=>Math.log(t.evaluate(e)) / Math.LN10
        ],
        ln: [
            Lt,
            [
                Lt
            ],
            (e, [t])=>Math.log(t.evaluate(e))
        ],
        log2: [
            Lt,
            [
                Lt
            ],
            (e, [t])=>Math.log(t.evaluate(e)) / Math.LN2
        ],
        sin: [
            Lt,
            [
                Lt
            ],
            (e, [t])=>Math.sin(t.evaluate(e))
        ],
        cos: [
            Lt,
            [
                Lt
            ],
            (e, [t])=>Math.cos(t.evaluate(e))
        ],
        tan: [
            Lt,
            [
                Lt
            ],
            (e, [t])=>Math.tan(t.evaluate(e))
        ],
        asin: [
            Lt,
            [
                Lt
            ],
            (e, [t])=>Math.asin(t.evaluate(e))
        ],
        acos: [
            Lt,
            [
                Lt
            ],
            (e, [t])=>Math.acos(t.evaluate(e))
        ],
        atan: [
            Lt,
            [
                Lt
            ],
            (e, [t])=>Math.atan(t.evaluate(e))
        ],
        min: [
            Lt,
            hr(Lt),
            (e, t)=>Math.min(...t.map((t)=>t.evaluate(e)))
        ],
        max: [
            Lt,
            hr(Lt),
            (e, t)=>Math.max(...t.map((t)=>t.evaluate(e)))
        ],
        abs: [
            Lt,
            [
                Lt
            ],
            (e, [t])=>Math.abs(t.evaluate(e))
        ],
        round: [
            Lt,
            [
                Lt
            ],
            (e, [t])=>{
                const n = t.evaluate(e);
                return n < 0 ? -Math.round(-n) : Math.round(n);
            }
        ],
        floor: [
            Lt,
            [
                Lt
            ],
            (e, [t])=>Math.floor(t.evaluate(e))
        ],
        ceil: [
            Lt,
            [
                Lt
            ],
            (e, [t])=>Math.ceil(t.evaluate(e))
        ],
        "filter-==": [
            Nt,
            [
                Ht,
                Ut
            ],
            (e, [t, n])=>e.properties()[t.value] === n.value
        ],
        "filter-id-==": [
            Nt,
            [
                Ut
            ],
            (e, [t])=>e.id() === t.value
        ],
        "filter-type-==": [
            Nt,
            [
                Ht
            ],
            (e, [t])=>e.geometryType() === t.value
        ],
        "filter-<": [
            Nt,
            [
                Ht,
                Ut
            ],
            (e, [t, n])=>{
                const i = e.properties()[t.value], r = n.value;
                return typeof i == typeof r && i < r;
            }
        ],
        "filter-id-<": [
            Nt,
            [
                Ut
            ],
            (e, [t])=>{
                const n = e.id(), i = t.value;
                return typeof n == typeof i && n < i;
            }
        ],
        "filter->": [
            Nt,
            [
                Ht,
                Ut
            ],
            (e, [t, n])=>{
                const i = e.properties()[t.value], r = n.value;
                return typeof i == typeof r && i > r;
            }
        ],
        "filter-id->": [
            Nt,
            [
                Ut
            ],
            (e, [t])=>{
                const n = e.id(), i = t.value;
                return typeof n == typeof i && n > i;
            }
        ],
        "filter-<=": [
            Nt,
            [
                Ht,
                Ut
            ],
            (e, [t, n])=>{
                const i = e.properties()[t.value], r = n.value;
                return typeof i == typeof r && i <= r;
            }
        ],
        "filter-id-<=": [
            Nt,
            [
                Ut
            ],
            (e, [t])=>{
                const n = e.id(), i = t.value;
                return typeof n == typeof i && n <= i;
            }
        ],
        "filter->=": [
            Nt,
            [
                Ht,
                Ut
            ],
            (e, [t, n])=>{
                const i = e.properties()[t.value], r = n.value;
                return typeof i == typeof r && i >= r;
            }
        ],
        "filter-id->=": [
            Nt,
            [
                Ut
            ],
            (e, [t])=>{
                const n = e.id(), i = t.value;
                return typeof n == typeof i && n >= i;
            }
        ],
        "filter-has": [
            Nt,
            [
                Ut
            ],
            (e, [t])=>t.value in e.properties()
        ],
        "filter-has-id": [
            Nt,
            [],
            (e)=>null !== e.id() && void 0 !== e.id()
        ],
        "filter-type-in": [
            Nt,
            [
                Wt(Ht)
            ],
            (e, [t])=>t.value.indexOf(e.geometryType()) >= 0
        ],
        "filter-id-in": [
            Nt,
            [
                Wt(Ut)
            ],
            (e, [t])=>t.value.indexOf(e.id()) >= 0
        ],
        "filter-in-small": [
            Nt,
            [
                Ht,
                Wt(Ut)
            ],
            (e, [t, n])=>n.value.indexOf(e.properties()[t.value]) >= 0
        ],
        "filter-in-large": [
            Nt,
            [
                Ht,
                Wt(Ut)
            ],
            (e, [t, n])=>(function(e, t, n, i) {
                    for(; n <= i;){
                        const r = n + i >> 1;
                        if (t[r] === e) return !0;
                        t[r] > e ? i = r - 1 : n = r + 1;
                    }
                    return !1;
                })(e.properties()[t.value], n.value, 0, n.value.length - 1)
        ],
        all: {
            type: Nt,
            overloads: [
                [
                    [
                        Nt,
                        Nt
                    ],
                    (e, [t, n])=>t.evaluate(e) && n.evaluate(e)
                ],
                [
                    hr(Nt),
                    (e, t)=>{
                        for (const n of t)if (!n.evaluate(e)) return !1;
                        return !0;
                    }
                ]
            ]
        },
        any: {
            type: Nt,
            overloads: [
                [
                    [
                        Nt,
                        Nt
                    ],
                    (e, [t, n])=>t.evaluate(e) || n.evaluate(e)
                ],
                [
                    hr(Nt),
                    (e, t)=>{
                        for (const n of t)if (n.evaluate(e)) return !0;
                        return !1;
                    }
                ]
            ]
        },
        "!": [
            Nt,
            [
                Nt
            ],
            (e, [t])=>!t.evaluate(e)
        ],
        "is-supported-script": [
            Nt,
            [
                Ht
            ],
            (e, [t])=>{
                const n = e.globals && e.globals.isSupportedScript;
                return !n || n(t.evaluate(e));
            }
        ],
        upcase: [
            Ht,
            [
                Ht
            ],
            (e, [t])=>t.evaluate(e).toUpperCase()
        ],
        downcase: [
            Ht,
            [
                Ht
            ],
            (e, [t])=>t.evaluate(e).toLowerCase()
        ],
        concat: [
            Ht,
            hr(Ut),
            (e, t)=>t.map((t)=>pn(t.evaluate(e))).join("")
        ],
        "resolved-locale": [
            Ht,
            [
                Bt
            ],
            (e, [t])=>t.evaluate(e).resolvedLocale()
        ]
    });
    var cr = sr;
    function ur(e) {
        return {
            result: "success",
            value: e
        };
    }
    function fr(e) {
        return {
            result: "error",
            value: e
        };
    }
    function dr(e) {
        return !!e.expression && e.expression.interpolated;
    }
    function pr(e) {
        return e instanceof Number ? "number" : e instanceof String ? "string" : e instanceof Boolean ? "boolean" : Array.isArray(e) ? "array" : null === e ? "null" : typeof e;
    }
    function gr(e) {
        return "object" == typeof e && null !== e && !Array.isArray(e);
    }
    function mr(e) {
        return e;
    }
    function yr(e, t) {
        const n = "color" === t.type, i = e.stops && "object" == typeof e.stops[0][0], r = i || void 0 !== e.property, s = i || !r, o = e.type || (dr(t) ? "exponential" : "interval");
        if (n && ((e = kt({}, e)).stops && (e.stops = e.stops.map((e)=>[
                e[0],
                on.parse(e[1])
            ])), e.default ? e.default = on.parse(e.default) : e.default = on.parse(t.default)), e.colorSpace && "rgb" !== e.colorSpace && !Ii[e.colorSpace]) throw new Error(`Unknown color space: ${e.colorSpace}`);
        let a, l, h;
        if ("exponential" === o) a = br;
        else if ("interval" === o) a = vr;
        else if ("categorical" === o) {
            a = _r, l = Object.create(null);
            for (const t of e.stops)l[t[0]] = t[1];
            h = typeof e.stops[0][0];
        } else {
            if ("identity" !== o) throw new Error(`Unknown function type "${o}"`);
            a = Ar;
        }
        if (i) {
            const n = {}, i = [];
            for(let t = 0; t < e.stops.length; t++){
                const r = e.stops[t], s = r[0].zoom;
                void 0 === n[s] && (n[s] = {
                    zoom: s,
                    type: e.type,
                    property: e.property,
                    default: e.default,
                    stops: []
                }, i.push(s)), n[s].stops.push([
                    r[0].value,
                    r[1]
                ]);
            }
            const r = [];
            for (const e of i)r.push([
                n[e].zoom,
                yr(n[e], t)
            ]);
            const s = {
                name: "linear"
            };
            return {
                kind: "composite",
                interpolationType: s,
                interpolationFactor: Fi.interpolationFactor.bind(void 0, s),
                zoomStops: r.map((e)=>e[0]),
                evaluate: ({ zoom: n }, i)=>br({
                        stops: r,
                        base: e.base
                    }, t, n).evaluate(n, i)
            };
        }
        if (s) {
            const n = "exponential" === o ? {
                name: "exponential",
                base: void 0 !== e.base ? e.base : 1
            } : null;
            return {
                kind: "camera",
                interpolationType: n,
                interpolationFactor: Fi.interpolationFactor.bind(void 0, n),
                zoomStops: e.stops.map((e)=>e[0]),
                evaluate: ({ zoom: n })=>a(e, t, n, l, h)
            };
        }
        return {
            kind: "source",
            evaluate (n, i) {
                const r = i && i.properties ? i.properties[e.property] : void 0;
                return void 0 === r ? xr(e.default, t.default) : a(e, t, r, l, h);
            }
        };
    }
    function xr(e, t, n) {
        return void 0 !== e ? e : void 0 !== t ? t : void 0 !== n ? n : void 0;
    }
    function _r(e, t, n, i, r) {
        return xr(typeof n === r ? i[n] : void 0, e.default, t.default);
    }
    function vr(e, t, n) {
        if ("number" !== pr(n)) return xr(e.default, t.default);
        const i = e.stops.length;
        if (1 === i) return e.stops[0][1];
        if (n <= e.stops[0][0]) return e.stops[0][1];
        if (n >= e.stops[i - 1][0]) return e.stops[i - 1][1];
        const r = ri(e.stops.map((e)=>e[0]), n);
        return e.stops[r][1];
    }
    function br(e, t, n) {
        const i = void 0 !== e.base ? e.base : 1;
        if ("number" !== pr(n)) return xr(e.default, t.default);
        const r = e.stops.length;
        if (1 === r) return e.stops[0][1];
        if (n <= e.stops[0][0]) return e.stops[0][1];
        if (n >= e.stops[r - 1][0]) return e.stops[r - 1][1];
        const s = ri(e.stops.map((e)=>e[0]), n), o = function(e, t, n, i) {
            const r = i - n, s = e - n;
            return 0 === r ? 0 : 1 === t ? s / r : (Math.pow(t, s) - 1) / (Math.pow(t, r) - 1);
        }(n, i, e.stops[s][0], e.stops[s + 1][0]), a = e.stops[s][1], l = e.stops[s + 1][1];
        let h = ci[t.type] || mr;
        if (e.colorSpace && "rgb" !== e.colorSpace) {
            const t = Ii[e.colorSpace];
            h = (e, n)=>t.reverse(t.interpolate(t.forward(e), t.forward(n), o));
        }
        return "function" == typeof a.evaluate ? {
            evaluate (...e) {
                const t = a.evaluate.apply(void 0, e), n = l.evaluate.apply(void 0, e);
                if (void 0 !== t && void 0 !== n) return h(t, n, o);
            }
        } : h(a, l, o);
    }
    function Ar(e, t, n) {
        return "color" === t.type ? n = on.parse(n) : "formatted" === t.type ? n = hn.fromString(n.toString()) : "resolvedImage" === t.type ? n = cn.fromString(n.toString()) : pr(n) === t.type || "enum" === t.type && t.values[n] || (n = void 0), xr(n, e.default, t.default);
    }
    class Tr {
        constructor(e, t){
            this.expression = e, this._warningHistory = {}, this._evaluator = new Pn, this._defaultValue = t ? function(e) {
                return "color" === e.type && (gr(e.default) || Array.isArray(e.default)) ? new on(0, 0, 0, 0) : "color" === e.type ? on.parse(e.default) || null : void 0 === e.default ? null : e.default;
            }(t) : null, this._enumValues = t && "enum" === t.type ? t.values : null;
        }
        evaluateWithoutErrorHandling(e, t, n, i, r, s, o, a) {
            return this._evaluator.globals = e, this._evaluator.feature = t, this._evaluator.featureState = n, this._evaluator.canonical = i || null, this._evaluator.availableImages = r || null, this._evaluator.formattedSection = s, this._evaluator.featureTileCoord = o || null, this._evaluator.featureDistanceData = a || null, this.expression.evaluate(this._evaluator);
        }
        evaluate(e, t, n, i, r, s, o, a) {
            this._evaluator.globals = e, this._evaluator.feature = t || null, this._evaluator.featureState = n || null, this._evaluator.canonical = i || null, this._evaluator.availableImages = r || null, this._evaluator.formattedSection = s || null, this._evaluator.featureTileCoord = o || null, this._evaluator.featureDistanceData = a || null;
            try {
                const e = this.expression.evaluate(this._evaluator);
                if (null == e || "number" == typeof e && e != e) return this._defaultValue;
                if (this._enumValues && !(e in this._enumValues)) throw new yn(`Expected value to be one of ${Object.keys(this._enumValues).map((e)=>JSON.stringify(e)).join(", ")}, but found ${JSON.stringify(e)} instead.`);
                return e;
            } catch (e) {
                return this._warningHistory[e.message] || (this._warningHistory[e.message] = !0, "undefined" != typeof console && console.warn(e.message)), this._defaultValue;
            }
        }
    }
    function Sr(e) {
        return Array.isArray(e) && e.length > 0 && "string" == typeof e[0] && e[0] in cr;
    }
    function wr(e, t) {
        const n = new ni(cr, [], t ? function(e) {
            const t = {
                color: zt,
                string: Ht,
                number: Lt,
                enum: Ht,
                boolean: Nt,
                formatted: Gt,
                resolvedImage: jt
            };
            return "array" === e.type ? Wt(t[e.value] || Ut, e.length) : t[e.type];
        }(t) : void 0), i = n.parse(e, void 0, void 0, void 0, t && "string" === t.type ? {
            typeAnnotation: "coerce"
        } : void 0);
        return i ? ur(new Tr(i, t)) : fr(n.errors);
    }
    class Mr {
        constructor(e, t){
            this.kind = e, this._styleExpression = t, this.isStateDependent = "constant" !== e && !Jn(t.expression);
        }
        evaluateWithoutErrorHandling(e, t, n, i, r, s) {
            return this._styleExpression.evaluateWithoutErrorHandling(e, t, n, i, r, s);
        }
        evaluate(e, t, n, i, r, s) {
            return this._styleExpression.evaluate(e, t, n, i, r, s);
        }
    }
    class Pr {
        constructor(e, t, n, i){
            this.kind = e, this.zoomStops = n, this._styleExpression = t, this.isStateDependent = "camera" !== e && !Jn(t.expression), this.interpolationType = i;
        }
        evaluateWithoutErrorHandling(e, t, n, i, r, s) {
            return this._styleExpression.evaluateWithoutErrorHandling(e, t, n, i, r, s);
        }
        evaluate(e, t, n, i, r, s) {
            return this._styleExpression.evaluate(e, t, n, i, r, s);
        }
        interpolationFactor(e, t, n) {
            return this.interpolationType ? Fi.interpolationFactor(this.interpolationType, e, t, n) : 0;
        }
    }
    function Ir(e, t) {
        if ("error" === (e = wr(e, t)).result) return e;
        const n = e.value.expression, i = $n(n);
        if (!i && !function(e) {
            return "data-driven" === e["property-type"];
        }(t)) return fr([
            new Ot("", "data expressions not supported")
        ]);
        const r = Kn(n, [
            "zoom",
            "pitch",
            "distance-from-center"
        ]);
        if (!r && !function(e) {
            return !!e.expression && e.expression.parameters.indexOf("zoom") > -1;
        }(t)) return fr([
            new Ot("", "zoom expressions not supported")
        ]);
        const s = kr(n);
        if (!s && !r) return fr([
            new Ot("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.')
        ]);
        if (s instanceof Ot) return fr([
            s
        ]);
        if (s instanceof Fi && !dr(t)) return fr([
            new Ot("", '"interpolate" expressions cannot be used with this property')
        ]);
        if (!s) return ur(new Mr(i ? "constant" : "source", e.value));
        const o = s instanceof Fi ? s.interpolation : void 0;
        return ur(new Pr(i ? "camera" : "composite", e.value, s.labels, o));
    }
    class Cr {
        constructor(e, t){
            this._parameters = e, this._specification = t, kt(this, yr(this._parameters, this._specification));
        }
        static deserialize(e) {
            return new Cr(e._parameters, e._specification);
        }
        static serialize(e) {
            return {
                _parameters: e._parameters,
                _specification: e._specification
            };
        }
    }
    function kr(e) {
        let t = null;
        if (e instanceof Di) t = kr(e.result);
        else if (e instanceof Ri) {
            for (const n of e.args)if (t = kr(n), t) break;
        } else (e instanceof oi || e instanceof Fi) && e.input instanceof Cn && "zoom" === e.input.name && (t = e);
        return t instanceof Ot || e.eachChild((e)=>{
            const n = kr(e);
            n instanceof Ot ? t = n : !t && n ? t = new Ot("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.') : t && n && t !== n && (t = new Ot("", 'Only one zoom-based "step" or "interpolate" subexpression may be used in an expression.'));
        }), t;
    }
    function Fr(e) {
        if (Array.isArray(e)) return e.map(Fr);
        if (e instanceof Object && !(e instanceof Number || e instanceof String || e instanceof Boolean)) {
            const t = {};
            for(const n in e)t[n] = Fr(e[n]);
            return t;
        }
        return function(e) {
            return e instanceof Number || e instanceof String || e instanceof Boolean ? e.valueOf() : e;
        }(e);
    }
    function Or(e, t = "fill") {
        if (null == e) return {
            filter: ()=>!0,
            needGeometry: !1,
            needFeature: !1
        };
        const n = e;
        let i = !0;
        try {
            i = function(e) {
                if (!Dr(e)) return e;
                let t = Fr(e);
                return Er(t), t = Rr(t), t;
            }(n);
        } catch (e) {
            console.warn(`Failed to extract static filter. Filter will continue working, but at higher memory usage and slower framerate.\nThis is most likely a bug, please report this via https://github.com/mapbox/mapbox-gl-js/issues/new?assignees=&labels=&template=Bug_report.md\nand paste the contents of this message in the report.\nThank you!\nFilter Expression:\n${JSON.stringify(n, null, 2)}\n        `);
        }
        const r = wr(i, null);
        let s = null;
        if ("error" === r.result) throw new Error(r.value.map((e)=>`${e.key}: ${e.message}`).join(", "));
        s = (e, t, n)=>r.value.evaluate(e, t, {}, n);
        let o = null, a = null;
        if (i !== n) {
            const e = wr(n, null);
            if ("error" === e.result) throw new Error(e.value.map((e)=>`${e.key}: ${e.message}`).join(", "));
            o = (t, n, i, r, s)=>e.value.evaluate(t, n, {}, i, void 0, void 0, r, s), a = !$n(e.value.expression);
        }
        return {
            filter: s,
            dynamicFilter: o || void 0,
            needGeometry: Hr(i),
            needFeature: !!a
        };
    }
    function Rr(e) {
        if (!Array.isArray(e)) return e;
        const t = function(e) {
            if (Lr.has(e[0])) {
                for(let t = 1; t < e.length; t++)if (Dr(e[t])) return !0;
            }
            return e;
        }(e);
        return !0 === t ? t : t.map((e)=>Rr(e));
    }
    function Er(e) {
        let t = !1;
        const n = [];
        if ("case" === e[0]) {
            for(let i = 1; i < e.length - 1; i += 2)t = t || Dr(e[i]), n.push(e[i + 1]);
            n.push(e[e.length - 1]);
        } else if ("match" === e[0]) {
            t = t || Dr(e[1]);
            for(let t = 2; t < e.length - 1; t += 2)n.push(e[t + 1]);
            n.push(e[e.length - 1]);
        } else if ("step" === e[0]) {
            t = t || Dr(e[1]);
            for(let t = 1; t < e.length - 1; t += 2)n.push(e[t + 1]);
        }
        t && (e.length = 0, e.push("any", ...n));
        for(let t = 1; t < e.length; t++)Er(e[t]);
    }
    function Dr(e) {
        if (!Array.isArray(e)) return !1;
        if (function(e) {
            return "pitch" === e || "distance-from-center" === e;
        }(e[0])) return !0;
        for(let t = 1; t < e.length; t++)if (Dr(e[t])) return !0;
        return !1;
    }
    const Lr = new Set([
        "in",
        "==",
        "!=",
        ">",
        ">=",
        "<",
        "<=",
        "to-boolean"
    ]);
    function Hr(e) {
        if (!Array.isArray(e)) return !1;
        if ("within" === e[0]) return !0;
        for(let t = 1; t < e.length; t++)if (Hr(e[t])) return !0;
        return !1;
    }
    const Nr = {
        StyleExpression: Tr,
        isExpression: Sr,
        isExpressionFilter: function e(t) {
            if (!0 === t || !1 === t) return !0;
            if (!Array.isArray(t) || 0 === t.length) return !1;
            switch(t[0]){
                case "has":
                    return t.length >= 2 && "$id" !== t[1] && "$type" !== t[1];
                case "in":
                    return t.length >= 3 && ("string" != typeof t[1] || Array.isArray(t[2]));
                case "!in":
                case "!has":
                case "none":
                    return !1;
                case "==":
                case "!=":
                case ">":
                case ">=":
                case "<":
                case "<=":
                    return 3 !== t.length || Array.isArray(t[1]) || Array.isArray(t[2]);
                case "any":
                case "all":
                    for (const n of t.slice(1))if (!e(n) && "boolean" != typeof n) return !1;
                    return !0;
                default:
                    return !0;
            }
        },
        createExpression: wr,
        createPropertyExpression: Ir,
        normalizePropertyExpression: function(e, t) {
            if (gr(e)) return new Cr(e, t);
            if (Sr(e)) {
                const n = Ir(e, t);
                if ("error" === n.result) throw new Error(n.value.map((e)=>`${e.key}: ${e.message}`).join(", "));
                return n.value;
            }
            {
                let n = e;
                return "string" == typeof e && "color" === t.type && (n = on.parse(e)), {
                    kind: "constant",
                    evaluate: ()=>n
                };
            }
        },
        ZoomConstantExpression: Mr,
        ZoomDependentExpression: Pr,
        StylePropertyFunction: Cr
    }, { isExpression: zr, createExpression: Vr } = Nr, Ur = {};
    function Br(e) {
        if (!Array.isArray(e)) return Br([
            e
        ]);
        const t = [];
        for(let n = 0; n < e.length; n++){
            let i;
            i = !0 === e[n].filter ? function() {
                return !0;
            } : Gr(e[n].filter), t.push($e({}, e[n], {
                filter: i
            }));
        }
        return t;
    }
    function Gr(e) {
        if (!0 === e) return function() {
            return !0;
        };
        if (e && e.condition) {
            if ("any" === e.type) {
                const t = e.condition, n = [];
                for(let e = 0; e < t.length; e++)n.push(Gr(t[e]));
                return (e, t)=>{
                    for(let i = 0; i < n.length; i++)if (n[i](e, t)) return !0;
                    return !1;
                };
            }
            const t = Gr(e.condition);
            if (Je(e.layer)) return t;
            const n = (t)=>t.layer === e.layer;
            return (e, i)=>n(e) && t(e, i);
        }
        if (xt(e)) return new Function("f", `var p = (f && f.properties || {}); return ${_t(e)}`);
        {
            let t = Or(e);
            t = t && t.filter;
            const n = (e, n)=>(Ur.zoom = n, t && t(Ur, e));
            return n;
        }
    }
    const jr = {
        type: "number",
        "property-type": "data-driven",
        expression: {
            parameters: [
                "zoom",
                "feature"
            ]
        }
    };
    function Wr(e, t) {
        jr.type = t || "number";
        const n = Vr(e, jr);
        if ("success" !== n.result) throw new Error(`Invalid maplibre spec expression: ${JSON.stringify(e)} (${n.value})`);
        return n.value;
    }
    function Xr(e) {
        return zr(e);
    }
    const Yr = {
        lineWidth: 1,
        lineStrokeWidth: 1,
        lineDx: 1,
        lineDy: 1,
        lineOpacity: 1,
        linePatternAnimSpeed: 1,
        markerWidth: 1,
        markerHeight: 1,
        markerDx: 1,
        markerDy: 1,
        markerSpacing: 1,
        markerOpacity: 1,
        markerRotation: 1,
        textWrapWidth: 1,
        textSpacing: 1,
        textSize: 1,
        textHaloRadius: 1,
        textHaloOpacity: 1,
        textDx: 1,
        textDy: 1,
        textOpacity: 1,
        textRotation: 1,
        polygonOpacity: 1
    };
    function Zr(e) {
        return Yr[e];
    }
    const qr = {
        markerPlacement: 1,
        markerFile: 1,
        mergeOnProperty: 1,
        markerTextFit: 1,
        markerType: 1,
        markerHorizontalAlignment: 1,
        markerVerticalAlignment: 1,
        markerRotationAlignment: 1,
        markerPitchAlignment: 1,
        markerFillPatternFile: 1,
        markerLinePatternFile: 1,
        textName: 1,
        textPlacement: 1,
        textFaceName: 1,
        textStyle: 1,
        textHorizontalAlignment: 1,
        textVerticalAlignment: 1,
        textRotationAlignment: 1,
        textPitchAlignment: 1,
        lineJoin: 1,
        lineCap: 1,
        linePatternFile: 1,
        polygonPatternFile: 1
    }, $r = {
        lineDasharray: 1,
        markerLineDasharray: 1,
        uvScale: 1,
        uvOffset: 1
    };
    function Jr(e) {
        return qr[e] ? "string" : Zr(e) ? "number" : $r[e] ? "array" : "color";
    }
    var Kr = Object.freeze({
        __proto__: null,
        compileFilter: Gr,
        compileStyle: function(e = []) {
            return Br(e = e.map((e)=>{
                const t = $e({}, e);
                return t.filter && t.filter.value && (t.filter = t.filter.value), t;
            }));
        },
        createExpression: Wr,
        getExpressionType: Jr,
        isExpression: Xr,
        isInterpolated: Zr
    });
    const Qr = "undefined" != typeof WorkerGlobalScope && self instanceof WorkerGlobalScope, es = function(e) {
        return class extends e {
            pushIn(...e) {
                const t = e.length;
                for(let n = 0; n < t; n++)this[this.currentIndex++] = e[n];
            }
            fill(e, t, n) {
                super.fill(e, t, n), n > this.currentIndex && (this.currentIndex = n);
            }
            set(e, t) {
                e >= this.currentIndex && (this.currentIndex = e + 1), this[e] = t;
            }
            getLength() {
                return this.currentIndex;
            }
            setLength(e) {
                this.currentIndex = e, super.length < e && (super.length = e);
            }
            trySetLength(e) {
                e > this.currentIndex && this.setLength(e);
            }
            reset() {
                this.currentIndex = 0;
            }
            slice(e, t) {
                const n = super.slice(e, t);
                return n.currentIndex = t - e, n;
            }
        };
    }, ts = es(Array), ns = {
        get: function(e, t) {
            return "length" === t ? e.getLength() : e[t];
        }
    };
    class is extends Array {
        setLength(e) {
            this.length = e, this.currentIndex = e;
        }
        trySetLength(e) {
            this.length = e, this.currentIndex = e;
        }
        getLength() {
            return this.length;
        }
    }
    let rs;
    class ss {
        static createTypedArray(e, t) {
            return H(e, t);
        }
        static getInstance() {
            return rs;
        }
        static ensureCapacity(e, t) {
            if (!e.BYTES_PER_ELEMENT) return e;
            if (e.length >= t) return e;
            const n = new e.constructor(t + Math.ceil(.5 * t)), i = e.getLength();
            for(let t = 0; t < i; t++)n[t] = e[t];
            return n.currentIndex = e.currentIndex, n;
        }
        static getArray(e) {
            let t;
            if (e) {
                const n = es(e), i = 1048576 / n.BYTES_PER_ELEMENT;
                t = new n(i);
            } else t = new ts;
            return t.push = (...e)=>{
                t.pushIn(...e);
            }, t;
        }
        static getProxyArray() {
            const e = new ts, t = new Proxy(e, ns);
            return t.push = (...t)=>{
                e.pushIn(...t);
            }, t._origin = e, t;
        }
        constructor(){
            this._arrays = [], this._index = 0, this._proxiedArrays = [], this._proxiedIndex = 0, this._typedArrays = {};
        }
        getProxy() {
            if (!Qr) {
                const e = new is;
                return e.currentIndex = 0, e;
            }
            const e = this._proxiedArrays[this._proxiedIndex] = this._proxiedArrays[this._proxiedIndex] || ss.getProxyArray();
            return e.reset(), this._proxiedIndex++, e;
        }
        get(e) {
            if (!Qr) {
                const e = new is;
                return e.currentIndex = 0, e;
            }
            if (e) {
                const t = e.name;
                let n = this._typedArrays[t];
                n || (n = this._typedArrays[t] = {
                    arrays: [],
                    index: 0
                });
                const i = n.index, r = n.arrays[i] = n.arrays[i] || ss.getArray(e);
                return r.reset(), n.index++, r;
            }
            const t = this._arrays[this._index] = this._arrays[this._index] || ss.getArray();
            return t.reset(), this._index++, t;
        }
        reset() {
            this._index = 0, this._proxiedIndex = 0;
            for(const e in this._typedArrays)this._typedArrays[e].index = 0;
        }
    }
    rs = new ss;
    const os = "__fea_idx", as = [], ls = {}, hs = {}, cs = {}, us = [], fs = ss.getInstance();
    let ds = !1;
    const ps = Math.pow(2, 17);
    class gs {
        static isAtlasLoaded(e, t = {}) {
            const { iconAtlas: n } = t;
            return !!(!e || n && n.positions[e]);
        }
        static genFnTypes(e) {
            const t = {};
            for(const n in e)if (Xr(e[n])) {
                const i = (n + "_Fn_0").trim(), r = (n + "Fn").trim(), s = Jr(n);
                t[i] = Wr(e[n], s), t[r] = (e, n)=>{
                    let r;
                    ls.zoom = e, hs.properties = n;
                    try {
                        r = t[i].evaluateWithoutErrorHandling(ls, hs, cs, null, us);
                    } catch (e) {
                        return null;
                    }
                    return r;
                };
            } else if (st(e[n])) {
                const i = (n + "_Fn_0").trim(), r = (n + "Fn").trim();
                Zr(n) ? (t[i] = re(e[n]), t[r] = (e, n)=>{
                    const r = t[i](e, n);
                    return st(r) ? re(r)(e, n) : r;
                }) : (t[i] = se(e[n]), t[r] = (e, n)=>{
                    const r = t[i](e, n);
                    return st(r) ? se(r)(e, n) : r;
                });
            }
            return t;
        }
        constructor(e, t, n){
            this.options = n;
            const i = [];
            this.symbolDef = t, this.symbol = oe(t, ()=>(i[0] = n.zoom, i)), this.styledVectors = [], this.properties = {}, this._fnTypes = n.fnTypes || gs.genFnTypes(this.symbolDef), st(this.symbolDef.visible) && (this._visibleFn = re(this.symbolDef.visible)), n.atlas && (this.iconAtlas = n.atlas.iconAtlas, this.glyphAtlas = n.atlas.glyphAtlas), this.features = this._check(e);
        }
        needAltitudeAttribute() {
            const e = Math.max(Math.abs(this.maxPosZ), Math.abs(this.minPosZ));
            return this.options.forceAltitudeAttribute || e >= ps || this.options.positionType === Float32Array;
        }
        getPositionFormat() {
            return this.needAltitudeAttribute() ? [
                {
                    type: Int16Array,
                    width: 2,
                    name: "aPosition"
                },
                {
                    type: Float32Array,
                    width: 1,
                    name: "aAltitude"
                }
            ] : [
                {
                    type: Float32Array,
                    width: 3,
                    name: "aPosition"
                }
            ];
        }
        fillPosition(e, t, n, i) {
            if (t < this._minX && (this._minX = t), t > this._maxX && (this._maxX = t), n < this._minY && (this._minY = n), n > this._maxY && (this._maxY = n), this.needAltitudeAttribute()) {
                let r = e.aPosition.currentIndex;
                e.aPosition[r++] = t, e.aPosition[r++] = n, e.aPosition.currentIndex = r, r = e.aAltitude.currentIndex, e.aAltitude[r++] = i, e.aAltitude.currentIndex = r;
            } else {
                pt(as, t, n, i);
                let r = e.aPosition.currentIndex;
                e.aPosition[r++] = as[0], e.aPosition[r++] = as[1], e.aPosition[r++] = as[2], e.aPosition.currentIndex = r;
            }
        }
        _check(e) {
            if (!e.length) return e;
            const t = (os + "").trim();
            let n, i = 0, r = e[i];
            for(; !r.geometry;)i++, r = e[i];
            if (Array.isArray(r.geometry) && r.properties) {
                let t = r.geometry[0];
                for(; Array.isArray(t);)t = t[0];
                Je(t.x) || (n = e);
            }
            if (!n) {
                if (n = [], Array.isArray(r.geometry)) for(let t = 0; t < e.length; t++){
                    const i = $e({}, e[t]);
                    n.push(N(i));
                }
                else for(let i = 0; i < e.length; i++){
                    const r = e[i], s = a(r);
                    for(let e = 0; e < s.length; e++){
                        const i = s[e];
                        i[t] = r[t], n.push(i);
                    }
                }
            }
            if (this.maxPosZ = 0, this.minPosZ = 0, !this.options.forceAltitudeAttribute) {
                const e = "line" === this.symbolDef.textPlacement;
                let t = -1 / 0, i = 1 / 0, r = !1;
                const { textPitchAlignmentFn: s } = this._fnTypes;
                !s && e && "map" === this.symbolDef.textPitchAlignment && (r = !0);
                const o = [];
                for(let a = 0; a < n.length; a++){
                    const [l, h] = ys(o, n[a] && n[a].geometry);
                    if (h > t && (t = h), l < i && (i = l), e && !r && s && n[a].properties) {
                        const e = s(null, n[a].properties);
                        "map" === e && (r = e);
                    }
                }
                this.hasMapPitchAlign = r, this.maxPosZ = t === -1 / 0 ? 0 : t, this.minPosZ = i === 1 / 0 ? 0 : i;
            }
            const s = this.options.order;
            if (s) {
                const e = [];
                for(let t = 0; t < s.length; t++)s[t] && e.push(Gr(s[t]));
                n = n.sort((t, n)=>{
                    const i = e.length;
                    let r = -1, s = -1;
                    for(let o = 0; o < i && (e[o](t) && (r = o), e[o](n) && (s = o), !(r >= 0 && r < i && s >= 0 && s < i)); o++);
                    return r - s;
                });
            }
            return n;
        }
        load(e = 1) {
            const t = (os + "").trim(), n = "_debug_info".trim(), i = this._fnTypes, r = this.styledVectors;
            this.count = 0;
            const s = this.features;
            if (!s || !s.length) return Promise.resolve(null);
            const o = {}, a = {}, l = {
                zoom: this.options.zoom,
                isVector3D: !!this.options.center
            }, h = [], c = oe(this.symbolDef, ()=>(h[0] = l.zoom, h));
            let u = 0, f = s.length;
            const d = this.options.debugIndex;
            try {
                for(; u < f; u++){
                    const e = s[u];
                    if (!e || !e.geometry) continue;
                    if (Ke(d) && e[n].index !== d) continue;
                    e.properties || (e.properties = {}), e.properties.$layer = e.layer, e.properties.$type = e.type;
                    const h = this.createStyledVector(e, c, i, l, o, a);
                    h && h.feature.geometry && (h.featureIdx = void 0 === e[t] ? u : e[t], this.count++, r.push(h));
                }
            } catch (e) {
                return Promise.reject(e);
            }
            return this.options.atlas ? Promise.resolve(this.pack(e)) : this.loadAtlas(o, a).then(()=>this.pack(e));
        }
        loadAtlas(e, t) {
            return new Promise((n, i)=>{
                this.fetchAtlas(e, t, (e, t)=>{
                    if (e) i(e);
                    else {
                        if (t) {
                            const { icons: e, glyphs: n } = t;
                            if (e && Object.keys(e).length) {
                                for(const t in e){
                                    const n = e[t], { width: i, height: r, data: s } = n.data;
                                    n.data = new v({
                                        width: i,
                                        height: r
                                    }, s);
                                }
                                this.iconAtlas = new F(e);
                            }
                            if (n && Object.keys(n).length) {
                                for(const e in n){
                                    const t = n[e];
                                    for(const e in t){
                                        const n = t[e], { width: i, height: r, data: s } = n.bitmap;
                                        n.bitmap = new _({
                                            width: i,
                                            height: r
                                        }, s);
                                    }
                                }
                                this.glyphAtlas = new R(n);
                            }
                        }
                        n({
                            glyphAtlas: this.glyphAtlas,
                            iconAtlas: this.iconAtlas
                        });
                    }
                });
            });
        }
        fetchAtlas(e, t, n) {
            Object.keys(e).length > 0 || Object.keys(t).length > 0 ? this.options.requestor(e, t, n) : n();
        }
        pack(e) {
            if (!this.count) return null;
            if (null == e) throw new Error("layout scale is undefined");
            const t = this.createDataPack(this.styledVectors, e);
            if (!t) return null;
            this.properties.minAltitude = this.minPosZ / 100, this.properties.maxAltitude = this.maxPosZ / 100, t.properties = this.properties, this.empty && (t.empty = !0);
            const n = t.buffers;
            delete t.buffers;
            const i = {
                data: t,
                buffers: n
            };
            if (this.iconAtlas) {
                const e = i.data.iconAtlas = ms(this.iconAtlas);
                if (e.glyphMap) for(const t in e.glyphMap){
                    const i = e.glyphMap[t];
                    n.push(i.data.data.buffer);
                }
                n.push(i.data.iconAtlas.image.data.buffer);
            }
            return this.glyphAtlas && (i.data.glyphAtlas = ms(this.glyphAtlas), n.push(i.data.glyphAtlas.image.data.buffer)), i;
        }
        createStyledVector(e, t, n, i) {
            return new dt(e, t, n, i);
        }
        createDataPack(e, t) {
            if (!e || !e.length) return null;
            this.maxIndex = 0, this.maxPos = 0, this._minX = this._minY = 1 / 0, this._maxX = this._maxY = -1 / 0, this.maxAltitude = 0, this.dynamicAttrs = {};
            const n = this.data = {};
            this._arrayPool = fs, fs.reset();
            let i = this.elements = fs.get();
            const r = this._dataFormat = this.getFormat(Array.isArray(e[0]) ? e[0][0].symbol : e[0].symbol), s = this.needAltitudeAttribute() ? 2 : 3;
            for(let e = 0; e < r.length; e++)n[r[e].name] = fs.get(r[e].type);
            let o = fs.get(), a = 0;
            const l = fs.get();
            let h = 0, c = !1, u = !0;
            const f = new Set;
            for(let i = 0, r = e.length; i < r; i++){
                if (!e[i].feature.geometry) continue;
                const r = Array.isArray(e[i]) ? e[i][0].feature.id : e[i].feature.id;
                u && (void 0 !== hs.id ? f && (f.has(hs.id) ? u = !1 : f.add(hs.id)) : u = !1), Ke(r) && (Math.abs(r) > h && (h = Math.abs(r)), r < 0 && (c = !0));
                const d = this.data.aPosition.getLength();
                if (Array.isArray(e[i])) for(let n = 0; n < e[i].length; n++)this._placeVector(e[i][n], t);
                else this._placeVector(e[i], t);
                const p = (n.aPosition.getLength() - d) / s;
                for(let t = 0; t < p; t++)o.push(e[i].featureIdx), Ke(r) && l.push(r);
                a = Math.max(a, e[i].featureIdx);
            }
            if (this.countOutOfAngle > 0 && !ds && (ds = !0, console.warn("text anchor along line is ignored as anchor's line angle is bigger than textMaxAngle.")), this.hasElements() && !i.getLength()) return null;
            const d = this.options.center ? Float32Array : L(a);
            o = ss.createTypedArray(o, d), this.options.positionType ? r[0].type = this.options.positionType : r[0].type = D(this.maxPos);
            const p = this.options.center;
            if (p && (p[0] || p[1])) {
                const e = n.aPosition, t = e.getLength();
                for(let n = 0; n < t; n += s)e[n] -= p[0], e[n + 1] -= p[1];
            }
            const g = function(e, t) {
                const n = {};
                for(let i = 0; i < e.length; i++){
                    const r = e[i], s = r.type, o = r.name;
                    n[o] = s === Array ? t[o] : H(t[o], s);
                }
                return n;
            }(r, n);
            g.aPickingId = o;
            const m = [];
            for(const e in g)m.push(g[e].buffer);
            const y = E(this.maxIndex);
            i = ss.createTypedArray(i, y), m.push(i.buffer);
            const x = {
                data: g,
                isIdUnique: u,
                is2D: 0 === this.maxPosZ && 0 === this.minPosZ,
                indices: this.hasElements() ? i : null,
                positionSize: s,
                positionBounding: [
                    this._minX,
                    this._minY,
                    this._maxX,
                    this._maxY
                ],
                buffers: m,
                symbolIndex: this.symbolDef.index || {
                    index: 0
                },
                dynamicAttributes: this.dynamicAttrs
            };
            if (this._packMarkerPlacement && (x.markerPlacement = this._packMarkerPlacement), this._packTextPlacement && (x.textPlacement = this._packTextPlacement), l.getLength()) {
                const e = c ? D(h) : L(h);
                x.featureIds = ss.createTypedArray(l, e), m.push(x.featureIds.buffer);
            } else x.featureIds = [];
            return x.pickingIdIndiceMap = I(o, x.indices), x;
        }
        _placeVector(e, t) {
            const n = e.feature.properties;
            this._visibleFn && !this._visibleFn(this.options.zoom, n) || this.placeVector(e, t, this.formatWidth);
        }
        addElements(e, t, n) {
            this.maxIndex = Math.max(this.maxIndex, e, t, n);
            let i = this.elements.currentIndex;
            this.elements[i++] = e, this.elements[i++] = t, this.elements[i++] = n, this.elements.currentIndex = i;
        }
        hasElements() {
            return !0;
        }
        getAltitude(e) {
            const { altitudeProperty: t, defaultAltitude: n, altitudeScale: i } = this.options;
            let r = T(e, t, n);
            return i && (r *= i), this.maxAltitude = Math.max(this.maxAltitude, Math.abs(r)), r;
        }
        getIconAtlasMaxValue() {
            const e = this.iconAtlas.positions;
            let t = 0;
            for(const n in e)if (it(e, n)) {
                const { tl: i, displaySize: r } = e[n], s = Math.max(i[0], i[1], r[0] - 1, r[1] - 1);
                s > t && (t = s);
            }
            return t;
        }
        ensureDataCapacity(e, t) {
            const n = this._dataFormat;
            for(let i = 0; i < n.length; i++){
                const r = this.data[n[i].name];
                if (!r) continue;
                const s = n[i].width * e, o = r.getLength();
                this.data[n[i].name] = ss.ensureCapacity(r, o + s * t);
            }
        }
    }
    function ms(e) {
        let t = e.positions, n = e.image && e.image.format || "alpha";
        if (e instanceof F) {
            t = {};
            for(const n in e.positions){
                const i = e.positions[n];
                t[n] = {
                    paddedRect: i.paddedRect,
                    pixelRatio: i.pixelRatio,
                    tl: i.tl,
                    br: i.br,
                    displaySize: i.displaySize
                };
            }
            n = "rgba";
        }
        const i = e.image;
        return {
            image: {
                width: i.width,
                height: i.height,
                data: i.data,
                format: n
            },
            glyphMap: e.glyphMap,
            positions: t
        };
    }
    function ys(e, t) {
        if (!t) return 0;
        let n = -1 / 0, i = 1 / 0;
        const r = [];
        if (Array.isArray(t)) for(let e = 0; e < t.length; e++)if (Array.isArray(t[e])) {
            const [s, o] = ys(r, t[e]);
            o > n && (n = o), s < i && (i = s);
        } else {
            const r = Math.abs(t[e].z || 0);
            r > n && (n = r), r < i && (i = r);
        }
        else {
            const e = Math.abs(t.z || 0);
            e > n && (n = e), e < i && (i = e);
        }
        return e[0] = i, e[1] = n, e;
    }
    const xs = "___fn_in_stops";
    function _s(e, t, n, i) {
        const r = "__fn_textSize".trim();
        let s = e.textSize;
        if (Je(t.textSize)) return [
            16,
            16
        ];
        e[r] && (s = e[r]);
        const o = [];
        if (tt(s) ? o[0] = s(i, n) : o[0] = s, ie(o[0])) {
            const t = o[0].__fn_key = o[0].__fn_key || JSON.stringify(o[0]);
            e[xs] || (e[xs] = {}), e[xs][t] || (e[xs][t] = re(o[0]));
            const r = e[xs][t];
            o[0] = r(i, n);
        }
        return o[1] = o[0], o;
    }
    function vs(e) {
        const t = e.stops;
        let n = -1 / 0;
        for(let e = 0; e < t.length; e++){
            let i = t[e][1];
            Qe(t[e][1]) && (i = vs(t[e][1])), i > n && (n = i);
        }
        return n;
    }
    const bs = [
        "{",
        "}"
    ], As = "";
    function Ts(e) {
        return e || "Open Sans Regular";
    }
    const Ss = /\{[\w-]+(?:\|[\w-]+)*\}/g;
    function ws(e, t) {
        if (!et(e)) return e;
        function n(e) {
            if (!t) return As;
            const n = t[e];
            return Je(n) ? As : Array.isArray(n) ? n.join() : n;
        }
        const [i, r] = bs, s = Ms(e);
        for(let t = 0, o = s.length; t < o; t++){
            const o = s[t], a = `${i}${o}${r}`;
            if (o.indexOf("|") > 0) {
                const t = o.split("|");
                let i = !1;
                for(let r = 0; r < t.length; r++){
                    const s = n(t[r]);
                    if (s !== As) {
                        e = Ps(e, a, s), i = !0;
                        break;
                    }
                }
                i || (e = Ps(e, a, As));
            } else e = Ps(e, a, n(o));
        }
        return e;
    }
    function Ms(e) {
        e += As;
        const [t, n] = bs, i = [];
        let r = !1, s = As;
        for(let o = 0, a = e.length; o < a; o++){
            const a = e[o];
            r || a !== t || (r = !0), a === t && r && (s = As), r && a !== t && a !== n && (s += a), a === n && s && (r = !1, i.push(s), s = As);
        }
        return i;
    }
    function Ps(e, t, n) {
        if (!e) return e;
        if (e.replaceAll) return e.replaceAll(t, n);
        for(; e.indexOf(t) > -1;)e = e.replace(t, n);
        return e;
    }
    var Is = Object.freeze({
        __proto__: null,
        EMPTY_STRING: As,
        getSDFFont: Ts,
        replaceAll: Ps,
        resolveExpVarNames: function e(t, n) {
            if (2 !== n.length || "get" !== n[0]) for(let i = 0; i < n.length; i++)2 === n[i].length && "get" === n[i][0] ? t.push(n[i][1]) : Array.isArray(n[i]) && e(t, n[i]);
            else t.push(n[1]);
        },
        resolveText: ws,
        resolveText_bak: function(e, t) {
            return et(e) ? e.replace(Ss, function(e) {
                if (!t) return "";
                if ((e = e.substring(1, e.length - 1)).indexOf("|") > 0) {
                    const n = e.split("|");
                    for(let e = 0; e < n.length; e++){
                        const i = t[n[e]];
                        if (!Je(i)) return i;
                    }
                    return "";
                }
                const n = t[e];
                return Je(n) ? "" : Array.isArray(n) ? n.join() : n;
            }) : e;
        },
        resolveVarNames: function(e) {
            return e.match(Ss);
        },
        templateKeys: Ms
    });
    const Cs = {
        "Latin-1 Supplement": (e)=>e >= 128 && e <= 255,
        Arabic: (e)=>e >= 1536 && e <= 1791,
        "Arabic Supplement": (e)=>e >= 1872 && e <= 1919,
        "Arabic Extended-A": (e)=>e >= 2208 && e <= 2303,
        "Hangul Jamo": (e)=>e >= 4352 && e <= 4607,
        "Unified Canadian Aboriginal Syllabics": (e)=>e >= 5120 && e <= 5759,
        Khmer: (e)=>e >= 6016 && e <= 6143,
        "Unified Canadian Aboriginal Syllabics Extended": (e)=>e >= 6320 && e <= 6399,
        "General Punctuation": (e)=>e >= 8192 && e <= 8303,
        "Letterlike Symbols": (e)=>e >= 8448 && e <= 8527,
        "Number Forms": (e)=>e >= 8528 && e <= 8591,
        "Miscellaneous Technical": (e)=>e >= 8960 && e <= 9215,
        "Control Pictures": (e)=>e >= 9216 && e <= 9279,
        "Optical Character Recognition": (e)=>e >= 9280 && e <= 9311,
        "Enclosed Alphanumerics": (e)=>e >= 9312 && e <= 9471,
        "Geometric Shapes": (e)=>e >= 9632 && e <= 9727,
        "Miscellaneous Symbols": (e)=>e >= 9728 && e <= 9983,
        "Miscellaneous Symbols and Arrows": (e)=>e >= 11008 && e <= 11263,
        "CJK Radicals Supplement": (e)=>e >= 11904 && e <= 12031,
        "Kangxi Radicals": (e)=>e >= 12032 && e <= 12255,
        "Ideographic Description Characters": (e)=>e >= 12272 && e <= 12287,
        "CJK Symbols and Punctuation": (e)=>e >= 12288 && e <= 12351,
        Hiragana: (e)=>e >= 12352 && e <= 12447,
        Katakana: (e)=>e >= 12448 && e <= 12543,
        Bopomofo: (e)=>e >= 12544 && e <= 12591,
        "Hangul Compatibility Jamo": (e)=>e >= 12592 && e <= 12687,
        Kanbun: (e)=>e >= 12688 && e <= 12703,
        "Bopomofo Extended": (e)=>e >= 12704 && e <= 12735,
        "CJK Strokes": (e)=>e >= 12736 && e <= 12783,
        "Katakana Phonetic Extensions": (e)=>e >= 12784 && e <= 12799,
        "Enclosed CJK Letters and Months": (e)=>e >= 12800 && e <= 13055,
        "CJK Compatibility": (e)=>e >= 13056 && e <= 13311,
        "CJK Unified Ideographs Extension A": (e)=>e >= 13312 && e <= 19903,
        "Yijing Hexagram Symbols": (e)=>e >= 19904 && e <= 19967,
        "CJK Unified Ideographs": (e)=>e >= 19968 && e <= 40959,
        "Yi Syllables": (e)=>e >= 40960 && e <= 42127,
        "Yi Radicals": (e)=>e >= 42128 && e <= 42191,
        "Hangul Jamo Extended-A": (e)=>e >= 43360 && e <= 43391,
        "Hangul Syllables": (e)=>e >= 44032 && e <= 55215,
        "Hangul Jamo Extended-B": (e)=>e >= 55216 && e <= 55295,
        "Private Use Area": (e)=>e >= 57344 && e <= 63743,
        "CJK Compatibility Ideographs": (e)=>e >= 63744 && e <= 64255,
        "Arabic Presentation Forms-A": (e)=>e >= 64336 && e <= 65023,
        "Vertical Forms": (e)=>e >= 65040 && e <= 65055,
        "CJK Compatibility Forms": (e)=>e >= 65072 && e <= 65103,
        "Small Form Variants": (e)=>e >= 65104 && e <= 65135,
        "Arabic Presentation Forms-B": (e)=>e >= 65136 && e <= 65279,
        "Halfwidth and Fullwidth Forms": (e)=>e >= 65280 && e <= 65519
    };
    function ks(e) {
        return !(Cs.Arabic(e) || Cs["Arabic Supplement"](e) || Cs["Arabic Extended-A"](e) || Cs["Arabic Presentation Forms-A"](e) || Cs["Arabic Presentation Forms-B"](e));
    }
    function Fs(e) {
        return !!(!(e < 11904) && (Cs["Bopomofo Extended"](e) || Cs.Bopomofo(e) || Cs["CJK Compatibility Forms"](e) || Cs["CJK Compatibility Ideographs"](e) || Cs["CJK Compatibility"](e) || Cs["CJK Radicals Supplement"](e) || Cs["CJK Strokes"](e) || Cs["CJK Symbols and Punctuation"](e) || Cs["CJK Unified Ideographs Extension A"](e) || Cs["CJK Unified Ideographs"](e) || Cs["Enclosed CJK Letters and Months"](e) || Cs["Halfwidth and Fullwidth Forms"](e) || Cs.Hiragana(e) || Cs["Ideographic Description Characters"](e) || Cs["Kangxi Radicals"](e) || Cs["Katakana Phonetic Extensions"](e) || Cs.Katakana(e) || Cs["Vertical Forms"](e) || Cs["Yi Radicals"](e) || Cs["Yi Syllables"](e)));
    }
    function Os(e) {
        return !!(746 === e || 747 === e || !(e < 4352) && (Cs["Bopomofo Extended"](e) || Cs.Bopomofo(e) || Cs["CJK Compatibility Forms"](e) && !(e >= 65097 && e <= 65103) || Cs["CJK Compatibility Ideographs"](e) || Cs["CJK Compatibility"](e) || Cs["CJK Radicals Supplement"](e) || Cs["CJK Strokes"](e) || !(!Cs["CJK Symbols and Punctuation"](e) || e >= 12296 && e <= 12305 || e >= 12308 && e <= 12319 || 12336 === e) || Cs["CJK Unified Ideographs Extension A"](e) || Cs["CJK Unified Ideographs"](e) || Cs["Enclosed CJK Letters and Months"](e) || Cs["Hangul Compatibility Jamo"](e) || Cs["Hangul Jamo Extended-A"](e) || Cs["Hangul Jamo Extended-B"](e) || Cs["Hangul Jamo"](e) || Cs["Hangul Syllables"](e) || Cs.Hiragana(e) || Cs["Ideographic Description Characters"](e) || Cs.Kanbun(e) || Cs["Kangxi Radicals"](e) || Cs["Katakana Phonetic Extensions"](e) || Cs.Katakana(e) && 12540 !== e || !(!Cs["Halfwidth and Fullwidth Forms"](e) || 65288 === e || 65289 === e || 65293 === e || e >= 65306 && e <= 65310 || 65339 === e || 65341 === e || 65343 === e || e >= 65371 && e <= 65503 || 65507 === e || e >= 65512 && e <= 65519) || !(!Cs["Small Form Variants"](e) || e >= 65112 && e <= 65118 || e >= 65123 && e <= 65126) || Cs["Unified Canadian Aboriginal Syllabics"](e) || Cs["Unified Canadian Aboriginal Syllabics Extended"](e) || Cs["Vertical Forms"](e) || Cs["Yijing Hexagram Symbols"](e) || Cs["Yi Syllables"](e) || Cs["Yi Radicals"](e)));
    }
    function Rs(e) {
        return !(Os(e) || function(e) {
            return !!(Cs["Latin-1 Supplement"](e) && (167 === e || 169 === e || 174 === e || 177 === e || 188 === e || 189 === e || 190 === e || 215 === e || 247 === e) || Cs["General Punctuation"](e) && (8214 === e || 8224 === e || 8225 === e || 8240 === e || 8241 === e || 8251 === e || 8252 === e || 8258 === e || 8263 === e || 8264 === e || 8265 === e || 8273 === e) || Cs["Letterlike Symbols"](e) || Cs["Number Forms"](e) || Cs["Miscellaneous Technical"](e) && (e >= 8960 && e <= 8967 || e >= 8972 && e <= 8991 || e >= 8996 && e <= 9e3 || 9003 === e || e >= 9085 && e <= 9114 || e >= 9150 && e <= 9165 || 9167 === e || e >= 9169 && e <= 9179 || e >= 9186 && e <= 9215) || Cs["Control Pictures"](e) && 9251 !== e || Cs["Optical Character Recognition"](e) || Cs["Enclosed Alphanumerics"](e) || Cs["Geometric Shapes"](e) || Cs["Miscellaneous Symbols"](e) && !(e >= 9754 && e <= 9759) || Cs["Miscellaneous Symbols and Arrows"](e) && (e >= 11026 && e <= 11055 || e >= 11088 && e <= 11097 || e >= 11192 && e <= 11243) || Cs["CJK Symbols and Punctuation"](e) || Cs.Katakana(e) || Cs["Private Use Area"](e) || Cs["CJK Compatibility Forms"](e) || Cs["Small Form Variants"](e) || Cs["Halfwidth and Fullwidth Forms"](e) || 8734 === e || 8756 === e || 8757 === e || e >= 9984 && e <= 10087 || e >= 10102 && e <= 10131 || 65532 === e || 65533 === e);
        }(e));
    }
    function Es(e) {
        return e >= 1424 && e <= 2303 || Cs["Arabic Presentation Forms-A"](e) || Cs["Arabic Presentation Forms-B"](e);
    }
    const Ds = [
        [
            9,
            9
        ],
        [
            32,
            32
        ],
        [
            5760,
            5760
        ],
        [
            8192,
            8198
        ],
        [
            8200,
            8202
        ],
        [
            8287,
            12288
        ],
        [
            6158,
            6158
        ],
        [
            8203,
            8205
        ]
    ];
    function Ls(e) {
        for (const t of Ds)if (e >= t[0] && e <= t[1]) return !0;
        return !1;
    }
    const Hs = {
        "!": "\uFE15",
        "#": "\uFF03",
        $: "\uFF04",
        "%": "\uFF05",
        "&": "\uFF06",
        "(": "\uFE35",
        ")": "\uFE36",
        "*": "\uFF0A",
        "+": "\uFF0B",
        ",": "\uFE10",
        "-": "\uFE32",
        ".": "\u30FB",
        "/": "\uFF0F",
        ":": "\uFE13",
        ";": "\uFE14",
        "<": "\uFE3F",
        "=": "\uFF1D",
        ">": "\uFE40",
        "?": "\uFE16",
        "@": "\uFF20",
        "[": "\uFE47",
        "\\": "\uFF3C",
        "]": "\uFE48",
        "^": "\uFF3E",
        _: "\uFE33",
        "`": "\uFF40",
        "{": "\uFE37",
        "|": "\u2015",
        "}": "\uFE38",
        "~": "\uFF5E",
        "\xa2": "\uFFE0",
        "\xa3": "\uFFE1",
        "\xa5": "\uFFE5",
        "\xa6": "\uFFE4",
        "\xac": "\uFFE2",
        "\xaf": "\uFFE3",
        "\u2013": "\uFE32",
        "\u2014": "\uFE31",
        "\u2018": "\uFE43",
        "\u2019": "\uFE44",
        "\u201C": "\uFE41",
        "\u201D": "\uFE42",
        "\u2026": "\uFE19",
        "\u2027": "\u30FB",
        "\u20A9": "\uFFE6",
        "\u3001": "\uFE11",
        "\u3002": "\uFE12",
        "\u3008": "\uFE3F",
        "\u3009": "\uFE40",
        "\u300A": "\uFE3D",
        "\u300B": "\uFE3E",
        "\u300C": "\uFE41",
        "\u300D": "\uFE42",
        "\u300E": "\uFE43",
        "\u300F": "\uFE44",
        "\u3010": "\uFE3B",
        "\u3011": "\uFE3C",
        "\u3014": "\uFE39",
        "\u3015": "\uFE3A",
        "\u3016": "\uFE17",
        "\u3017": "\uFE18",
        "\uFF01": "\uFE15",
        "\uFF08": "\uFE35",
        "\uFF09": "\uFE36",
        "\uFF0C": "\uFE10",
        "\uFF0D": "\uFE32",
        "\uFF0E": "\u30FB",
        "\uFF1A": "\uFE13",
        "\uFF1B": "\uFE14",
        "\uFF1C": "\uFE3F",
        "\uFF1E": "\uFE40",
        "\uFF1F": "\uFE16",
        "\uFF3B": "\uFE47",
        "\uFF3D": "\uFE48",
        "\uFF3F": "\uFE33",
        "\uFF5B": "\uFE37",
        "\uFF5C": "\u2015",
        "\uFF5D": "\uFE38",
        "\uFF5F": "\uFE35",
        "\uFF60": "\uFE36",
        "\uFF61": "\uFE12",
        "\uFF62": "\uFE41",
        "\uFF63": "\uFE42"
    }, Ns = 1, zs = 2;
    function Vs(e, t, n, i, r, s, o, a, l, h) {
        let c = e.trim();
        h === zs && (c = function(e) {
            let t = "";
            const n = Array.from(e);
            for(let e = 0; e < n.length; e++){
                const i = n[e + 1].codePointAt(0) || null, r = n[e - 1].codePointAt(0) || null;
                i && Rs(i) && !Hs[n[e + 1]] || r && Rs(r) && !Hs[n[e - 1]] || !Hs[n[e]] ? t += n[e] : t += Hs[n[e]];
            }
            return t;
        }(c));
        const u = [], f = {
            positionedGlyphs: u,
            text: c,
            top: a[1],
            bottom: a[1],
            left: a[0],
            right: a[0],
            writingMode: h
        };
        let d;
        return d = function(e, t) {
            const n = [];
            let i = 0;
            for(let r = 0; r < t.length; r++){
                const s = t[r];
                n.push(e.substring(i, s)), i = s;
            }
            return i < e.length && n.push(e.substring(i, e.length)), n;
        }(c, function(e, t, n, i) {
            if (!n) return [];
            if (!e) return [];
            const r = [], s = function(e, t, n, i) {
                let r = 0;
                for(let n = 0; n < e.length; n++){
                    const s = i[e.codePointAt(n)];
                    s && (r += s.metrics.advance + t);
                }
                return r / Math.max(1, Math.ceil(r / n));
            }(e, t, n, i);
            let o = 0;
            for(let n = 0; n < e.length; n++){
                const a = e.codePointAt(n), l = i[a];
                l && (l && !Us[a] && (o += l.metrics.advance + t), n < e.length - 1 && (Bs[a] || Fs(a)) && r.push(Ws(n + 1, o, s, r, js(a, e.codePointAt(n + 1)), !1)));
            }
            return Xs(Ws(e.length, o, s, r, 0, !0));
        }(c, o, n, t)), function(e, t, n, i, r, s, o, a, l, h) {
            let c = 0, u = 0, f = 0;
            const d = e.positionedGlyphs;
            for(let e = 0; e < n.length; e++){
                let r = n[e];
                if (r = r.trim(), !r.length) {
                    u -= i;
                    continue;
                }
                const s = d.length;
                for(let e = 0; e < r.length; e++){
                    const n = r.codePointAt(e), i = t[n];
                    i && (Os(n) && o !== Ns ? (32 !== n && d.push({
                        glyph: n,
                        x: c,
                        y: 0,
                        vertical: !0
                    }), c += l + a) : (32 !== n && d.push({
                        glyph: n,
                        x: c,
                        y: u,
                        vertical: !1
                    }), c += i.metrics.advance + a));
                }
                if (d.length !== s) {
                    const e = c - a;
                    f = Math.max(e, f), Zs(d, t, s, d.length - 1, .5);
                }
                c = 0, u -= i;
            }
            const { horizontalAlign: p, verticalAlign: g } = Ys(r, void 0);
            !function(e, t, n, i, r, s, o) {
                const a = (.5 - n) * r, l = -(-i * o + .5) * s;
                if (a || l) for(let t = 0; t < e.length; t++)e[t].x += a, e[t].y += l;
            }(d, 0, p, g, f, i, n.length);
            const m = n.length * i;
            e.top += -g * m, e.bottom = e.top + m, e.left += -p * f, e.right = e.left + f;
        }(f, t, d, i, r, 0, h, o, l), !!u.length && f;
    }
    const Us = {
        9: !0,
        10: !0,
        11: !0,
        12: !0,
        13: !0,
        32: !0
    }, Bs = {
        10: !0,
        32: !0,
        38: !0,
        40: !0,
        41: !0,
        43: !0,
        45: !0,
        47: !0,
        173: !0,
        183: !0,
        8203: !0,
        8208: !0,
        8211: !0,
        8231: !0
    };
    function Gs(e, t, n, i) {
        const r = Math.pow(e - t, 2);
        return i ? e < t ? r / 2 : 2 * r : r + Math.abs(n) * n;
    }
    function js(e, t) {
        let n = 0;
        return 10 === e && (n -= 1e4), 40 !== e && 65288 !== e || (n += 50), 41 !== t && 65289 !== t || (n += 50), n;
    }
    function Ws(e, t, n, i, r, s) {
        let o = null, a = Gs(t, n, r, s);
        for(let e = 0; e < i.length; e++){
            const l = i[e], h = Gs(t - l.x, n, r, s) + l.badness;
            h <= a && (o = l, a = h);
        }
        return {
            index: e,
            x: t,
            priorBreak: o,
            badness: a
        };
    }
    function Xs(e) {
        return e ? Xs(e.priorBreak).concat(e.index) : [];
    }
    function Ys(e, t) {
        let n = .5, i = .5;
        switch(e){
            case "right":
            case "top-right":
            case "bottom-right":
                n = t ? 1 : 0;
                break;
            case "left":
            case "top-left":
            case "bottom-left":
                n = t ? 0 : 1;
        }
        switch(e){
            case "bottom":
            case "bottom-right":
            case "bottom-left":
                i = t ? 1 : 0;
                break;
            case "top":
            case "top-right":
            case "top-left":
                i = t ? 0 : 1;
        }
        return {
            horizontalAlign: n,
            verticalAlign: i
        };
    }
    function Zs(e, t, n, i, r) {
        const s = t[e[i].glyph];
        if (s) {
            const t = s.metrics.advance, o = (e[i].x + t) * r;
            if (!o) return;
            for(let t = n; t <= i; t++)e[t].x -= o;
        }
    }
    function qs(e) {
        if (!function(e) {
            for (const t of e)if (Es(t.charCodeAt(0))) return !0;
            return !1;
        }(e)) return e;
        const t = [], n = [], i = [];
        let r = 0, s = 0, o = 1, a = 1;
        for (const l of e){
            const e = l.codePointAt(0);
            Ls(e) ? (i.push(l), r++) : (o = Es(e) ? -1 : 1, a !== o ? (s = r, n.length && (a > 0 && n.reverse(), t.push(...n)), i.length && (t.splice(s, 0, ...i), i.length = 0), a = o, n.length = 0) : i.length && (n.push(...i), i.length = 0), n.push(l), r++);
        }
        return i.length && n.push(...i), n.length && (a > 0 && n.reverse(), t.push(...n)), t.reverse().join("");
    }
    const $s = /\{ *([\w_]+) *\}/g;
    class Js {
        constructor(e, t, n, i, r){
            this.feature = e, this.symbolDef = t, this.symbol = n, this.options = r, this._thisReplacer = this._replacer.bind(this), this._fnTypes = i;
        }
        _replacer(e, t) {
            return this.feature.properties[t] || "";
        }
        getShape(e, t) {
            if (this._shape) return this._shape;
            const { textHorizontalAlignmentFn: n, textVerticalAlignmentFn: i, markerHorizontalAlignmentFn: r, markerVerticalAlignmentFn: s, textWrapWidthFn: o } = this._fnTypes, a = {}, l = this.symbol, h = this.getIconAndGlyph(), c = this.feature.properties;
            if (h && h.glyph) {
                const { font: e, text: r } = h.glyph;
                if ("" === r) return null;
                const s = 24, u = this.textSize[0] / s, f = 24, d = l.textKeepUpright, p = "map" === l.textRotationAlignment && "line" === l.textPlacement && !l.isIconText, g = t.glyphMap[e], m = Ks(n ? n(null, c) : l.textHorizontalAlignment, i ? i(null, c) : l.textVerticalAlignment), y = 1.2 * f, x = function(e) {
                    for(let t = 0; t < e.length; t++)if (!ks(e.charAt(t).charCodeAt(0))) return !1;
                    return !0;
                }(r), _ = x && l.textLetterSpacing / u || 0, v = [
                    l.textDx / u || 0,
                    l.textDy / u || 0
                ], b = ((o ? o(null, c) : l.textWrapWidth) || 10 * f) / u, A = {};
                A.horizontal = Vs(r, g, b, y, m, 0, _, v, f, Ns, this.options.isVector3D), x && p && d && (A.vertical = Vs(r, g, b, y, m, 0, _, v, f, zs)), a.textShape = A;
            }
            if (h && h.icon) {
                if (!e || !e.positions[h.icon.url]) return null;
                const t = Ks(r ? r(null, c) : l.markerHorizontalAlignment, s ? s(null, c) : l.markerVerticalAlignment), n = function(e, t, n) {
                    let { horizontalAlign: i, verticalAlign: r } = Ys(t, n);
                    n ? i = 1 - i : r = 1 - r;
                    const s = -2048 * i, o = -2048 * r;
                    return {
                        image: e,
                        top: o,
                        bottom: o + 2048,
                        left: s,
                        right: s + 2048
                    };
                }(e.positions[h.icon.url], t, this.options.isVector3D);
                this.iconSize || (this.iconSize = n.image.displaySize), a.iconShape = n;
            }
            return this._shape = a, a;
        }
        getIconAndGlyph() {
            if (this.iconGlyph) return this.iconGlyph;
            const { markerFileFn: e, markerTypeFn: t, markerPathFn: n, markerWidthFn: i, markerHeightFn: r, markerFillFn: s, markerFillPatternFileFn: o, markerFillOpacityFn: a, markerTextFitFn: l, markerTextFitPaddingFn: h, markerLineColorFn: c, markerLineWidthFn: u, markerLineOpacityFn: f, markerLineDasharrayFn: d, markerLinePatternFileFn: p, markerPathWidthFn: g, markerPathHeightFn: m, textNameFn: y, textFaceNameFn: x } = this._fnTypes, { zoom: _ } = this.options, v = {}, b = this.symbol, A = this.symbolDef, T = this.feature.properties, S = e ? e(null, T) : b.markerFile, w = t ? t(null, T) : b.markerType, M = S || w || b.markerPath, P = !Je(this.symbolDef.textName);
            let I, C;
            if (M) {
                I = function(e, t, n, i, r, s) {
                    if (Je(t.markerWidth) && Je(t.markerHeight)) return null;
                    const o = "__fn_markerWidth".trim(), a = "__fn_markerHeight".trim();
                    let l = t.markerWidth || 0, h = t.markerHeight || 0;
                    return Qe(l) && ("identity" !== l.type ? l = vs(l) : (l = e.markerWidth, e[o] && (l = e[o](i, n)), Qe(l) && (l = "identity" === l.type ? r(i, n) : vs(l)))), Qe(h) && ("identity" !== h.type ? h = vs(h) : (h = e.markerHeight, e[a] && (h = e[a](i, n)), Qe(h) && (h = "identity" === h.type ? s(i, n) : vs(h)))), [
                        l,
                        h
                    ];
                }(b, this.symbolDef, T, _, i, r) || [
                    0,
                    0
                ];
                let e = b.markerTextFit;
                if (l && (e = l(_, T)), e && A.textName && "none" !== e) {
                    const t = A.textSize;
                    let n = A.textName;
                    ie(n) && (n = re(n)(_, T));
                    const i = ws(n, T);
                    if (i) {
                        const n = "__fn_textSize".trim(), r = "__fn_textSize_0".trim();
                        ie(t) && !A[n] && (A[r] = re(t), A[n] = (e, t)=>{
                            const n = A[r](e, t);
                            return ie(n) ? re(n)(e, t) : n;
                        });
                        const s = _s(A, A, T, _);
                        if ("width" !== e && "both" !== e || (I[0] = s[0] * i.length), "height" !== e && "both" !== e || (I[1] = s[1]), s[0] && s[1]) {
                            let e = b.markerTextFitPadding || [
                                0,
                                0,
                                0,
                                0
                            ];
                            h && (e = h(_, T)), I[0] += e[1] + e[3], I[1] += e[0] + e[2];
                        }
                    } else I[0] = I[1] = -1;
                }
            }
            if (P && (C = _s(b, this.symbolDef, T, _)), !C && !I) return v;
            if (I && (I[0] = Math.ceil(I[0]), I[1] = Math.ceil(I[1])), C && (C[0] = Math.ceil(C[0]), C[1] = Math.ceil(C[1])), this.iconSize = I, this.textSize = C, M && I[0] >= 0 && I[1] >= 0) {
                let e;
                if (w) {
                    const t = {};
                    if (t.markerType = w, "path" === w && (t.markerPath = n ? n(null, T) : b.markerPath, t.markerPathWidth = g ? g(null, T) : b.markerPathWidth, t.markerPathHeight = m ? m(null, T) : b.markerPathHeight), i) {
                        const e = i(null, T);
                        Je(e) || (t.markerWidth = e);
                    } else b.markerWidth >= 0 && (t.markerWidth = b.markerWidth);
                    if (r) {
                        const e = r(null, T);
                        Je(e) || (t.markerHeight = e);
                    } else b.markerHeight >= 0 && (t.markerHeight = b.markerHeight);
                    if (s) {
                        const e = s(null, T);
                        Je(e) || (t.markerFill = e);
                    } else b.markerFill && (t.markerFill = b.markerFill);
                    if (o) {
                        const e = o(null, T);
                        Je(e) || (t.markerFillPatternFile = e);
                    } else b.markerFillPatternFile && (t.markerFillPatternFile = b.markerFillPatternFile);
                    if (a) {
                        const e = a(null, T);
                        Je(e) || (t.markerFillOpacity = e);
                    } else b.markerFillOpacity >= 0 && (t.markerFillOpacity = b.markerFillOpacity);
                    if (c) {
                        const e = c(null, T);
                        Je(e) || (t.markerLineColor = e);
                    } else b.markerLineColor && (t.markerLineColor = b.markerLineColor);
                    if (u) {
                        const e = u(null, T);
                        Je(e) || (t.markerLineWidth = e);
                    } else b.markerLineWidth >= 0 && (t.markerLineWidth = b.markerLineWidth);
                    if (f) {
                        const e = f(null, T);
                        Je(e) || (t.markerLineOpacity = e);
                    } else b.markerLineOpacity >= 0 && (t.markerLineOpacity = b.markerLineOpacity);
                    if (d) {
                        const e = d(null, T);
                        Je(e) || (t.markerLineDasharray = e);
                    } else b.markerLineDasharray && (t.markerLineDasharray = b.markerLineDasharray);
                    if (p) {
                        const e = p(null, T);
                        Je(e) || (t.markerLinePatternFile = e);
                    } else b.markerLinePatternFile && (t.markerLinePatternFile = b.markerLinePatternFile);
                    e = "vector://" + JSON.stringify(t);
                } else e = S ? S.replace($s, this._thisReplacer) : b.markerPath ? function(e, t, n) {
                    if (!e.markerPath) return null;
                    let i = 1;
                    const r = function(e) {
                        const t = {
                            stroke: {
                                stroke: e.markerLineColor,
                                "stroke-width": e.markerLineWidth,
                                "stroke-opacity": e.markerLineOpacity,
                                "stroke-dasharray": null,
                                "stroke-linecap": "butt",
                                "stroke-linejoin": "round"
                            },
                            fill: {
                                fill: e.markerFill,
                                "fill-opacity": e.markerFillOpacity
                            }
                        };
                        return 0 === t.stroke["stroke-width"] && (t.stroke["stroke-opacity"] = 0), t;
                    }(e);
                    Ke(e.markerOpacity) && (i = e.markerOpacity), Ke(e.opacity) && (i *= e.opacity);
                    const s = {};
                    if (r) {
                        for(const e in r.stroke)it(r.stroke, e) && (Je(r.stroke[e]) || (s[e] = r.stroke[e]));
                        for(const e in r.fill)it(r.fill, e) && (Je(r.fill[e]) || (s[e] = r.fill[e]));
                    }
                    const o = Array.isArray(e.markerPath) ? e.markerPath : [
                        e.markerPath
                    ];
                    let a;
                    const l = [];
                    for(let e = 0; e < o.length; e++)a = et(o[e]) ? {
                        path: o[e]
                    } : o[e], a = $e({}, a, s), a.d = a.path, delete a.path, l.push(a);
                    const h = [
                        '<svg version="1.1"',
                        'xmlns="http://www.w3.org/2000/svg"'
                    ];
                    i < 1 && h.push('opacity="' + i + '"'), e.markerPathWidth && e.markerPathHeight && h.push('viewBox="0 0 ' + e.markerPathWidth + " " + e.markerPathHeight + '"'), h.push('preserveAspectRatio="none"'), t && h.push('width="' + t + '"'), n && h.push('height="' + n + '"'), h.push("><defs></defs>");
                    for(let e = 0; e < l.length; e++){
                        let t = "<path ";
                        for(const n in l[e])it(l[e], n) && (t += " " + n + '="' + l[e][n] + '"');
                        t += "></path>", h.push(t);
                    }
                    return h.push("</svg>"), "data:image/svg+xml;base64," + btoa(h.join(" "));
                }(b, I[0], I[1]) : null;
                v.icon = {
                    url: e,
                    iconSize: I,
                    textSize: C
                };
            }
            if (P) {
                const e = y ? y(this.options.zoom, T) : b.textName;
                if (e || 0 === e) {
                    const t = Ts(x ? x(null, T) : b.textFaceName);
                    let n = ws(e, T);
                    n && n.length && (n = qs(n), v.glyph = {
                        font: t,
                        text: n
                    });
                }
            }
            return this.iconGlyph = v, v;
        }
    }
    function Ks(e, t) {
        t && "middle" !== t || (t = "center"), e && "middle" !== e || (e = "center");
        let n = "center" !== t ? t : "";
        return n += "center" !== e ? (n.length ? "-" : "") + e : "", n;
    }
    /*!
	 * From mapbox-gl-js
	 * MIT License
	 * https://github.com/mapbox/mapbox-gl-js
	 */ function Qs(e, t, n, i, r) {
        const o = [];
        let a;
        for(let l = 0; l < e.length; l++){
            const h = e[l];
            let c, u = !1;
            for(let e = 0; e < h.length - 1; e++){
                let l = h[e], f = h[e + 1];
                l.x < t && f.x < t || (l.x < t ? (a = l, l = new s(t, l.y + (f.y - l.y) * ((t - l.x) / (f.x - l.x)))._round(), l.z = a.z + (f.z - a.z) * ((t - a.x) / (f.x - a.x)), u = !0) : f.x < t && (a = f, f = new s(t, l.y + (f.y - l.y) * ((t - l.x) / (f.x - l.x)))._round(), f.z = l.z + (a.z - l.z) * ((t - l.x) / (a.x - l.x)), u = !0), l.y < n && f.y < n || (l.y < n ? (a = l, l = new s(l.x + (f.x - l.x) * ((n - l.y) / (f.y - l.y)), n)._round(), l.z = a.z + (f.z - a.z) * ((n - a.y) / (f.y - a.y)), u = !0) : f.y < n && (a = f, f = new s(l.x + (f.x - l.x) * ((n - l.y) / (f.y - l.y)), n)._round(), f.z = l.z + (a.z - l.z) * ((n - l.y) / (a.y - l.y)), u = !0), l.x >= i && f.x >= i || (l.x >= i ? (a = l, l = new s(i, l.y + (f.y - l.y) * ((i - l.x) / (f.x - l.x)))._round(), l.z = a.z + (f.z - a.z) * ((i - a.x) / (f.x - a.x)), u = !0) : f.x >= i && (a = f, f = new s(i, l.y + (f.y - l.y) * ((i - l.x) / (f.x - l.x)))._round(), f.z = l.z + (a.z - l.z) * ((i - l.x) / (a.x - l.x)), u = !0), l.y >= r && f.y >= r || (l.y >= r ? (a = l, l = new s(l.x + (f.x - l.x) * ((r - l.y) / (f.y - l.y)), r)._round(), l.z = a.z + (f.z - a.z) * ((r - a.y) / (f.y - a.y)), u = !0) : f.y >= r && (a = f, f = new s(l.x + (f.x - l.x) * ((r - l.y) / (f.y - l.y)), r)._round(), f.z = l.z + (a.z - l.z) * ((r - l.y) / (a.y - l.y)), u = !0), c && l.equals(c[c.length - 1]) || (c = [
                    l
                ], o.push(c)), u && (c.clipped = !0), c.push(f)))));
            }
        }
        return o;
    }
    class eo extends s {
        constructor(e, t, n, i){
            super(e, t), this.angle = n, void 0 !== i && (this.segment = i);
        }
        clone() {
            return new eo(this.x, this.y, this.angle, this.segment);
        }
    }
    /*!
	 * From mapbox-gl-js
	 * MIT License
	 * https://github.com/mapbox/mapbox-gl-js
	 */ function to(e, t, n, i, r) {
        if (void 0 === t.segment) return !0;
        let s = t, o = t.segment + 1, a = 0;
        for(; a > -n / 2;){
            if (o--, o < 0) return !1;
            a -= e[o].dist(s), s = e[o];
        }
        a += e[o].dist(e[o + 1]), o++;
        const l = [];
        let h = 0;
        for(; a < n / 2;){
            const t = e[o - 1], n = e[o], s = e[o + 1];
            if (!s) return !1;
            let c = t.angleTo(n) - n.angleTo(s);
            for(c = Math.abs((c + 3 * Math.PI) % (2 * Math.PI) - Math.PI), l.push({
                distance: a,
                angleDelta: c
            }), h += c; a - l[0].distance > i;)h -= l.shift().angleDelta;
            if (h > r) return !1;
            o++, a += n.dist(s);
        }
        return !0;
    }
    function no(e, t, n, i, r, s, o, a, l, h, c) {
        const u = function(e, t, n) {
            return e ? .6 * t * n : 0;
        }(i, s, o), f = function(e, t) {
            return Math.max(e ? e.right - e.left : 0, 0);
        }(i), d = 0 === e[0].x || e[0].x === l || 0 === e[0].y || e[0].y === l;
        return t - f * o < t / 4 && (t = f * o + t / 4), io(e, d ? t / 2 * a % t : (f / 2 + 2 * s) * o * a % t, t, u, n, f * o, d, !1, l, h, c);
    }
    function io(e, t, n, i, r, s, o, a, l, h, c) {
        let u = 0;
        const f = s / 2, d = function(e) {
            let t = 0;
            for(let n = 0; n < e.length - 1; n++)t += e[n].dist(e[n + 1]);
            return t;
        }(e);
        let p = 0, g = t - n, m = [];
        for(let t = 0; t < e.length - 1; t++){
            const o = e[t], a = e[t + 1], y = o.dist(a), x = a.angleTo(o);
            for(; g + n < p + y;){
                g += n;
                const _ = (g - p) / y, v = ro(o.x, a.x, _), b = ro(o.y, a.y, _), A = ro(o.z || 0, a.z || 0, _);
                if (v >= 0 && v < l && b >= 0 && b < l && g - f >= 0 && g + f <= d) {
                    const n = new eo(v, b, x, t);
                    n.z = A, h && (n.axis = [
                        o.y - b,
                        v - o.x
                    ], n.angleR = A === (o.z || 0) ? 0 : Math.atan(.9 * (A - (o.z || 0)) * c / o.dist(n))), n.line = e, n._round(), !i || to(e, n, s, i, r) ? m.push(n) : i && u++;
                }
            }
            p += y;
        }
        return a || m.length || o || (m = io(e, p / 2, n, i, r, s, o, !0, l, h, c)), m.countOutOfAngle = u, m;
    }
    function ro(e, t, n) {
        return e * (1 - n) + t * n;
    }
    var so = {
        exports: {}
    };
    so.exports = function() {
        function e(n, i, r, s, o) {
            for(; s > r;){
                if (s - r > 600) {
                    var a = s - r + 1, l = i - r + 1, h = Math.log(a), c = .5 * Math.exp(2 * h / 3), u = .5 * Math.sqrt(h * c * (a - c) / a) * (l - a / 2 < 0 ? -1 : 1);
                    e(n, i, Math.max(r, Math.floor(i - l * c / a + u)), Math.min(s, Math.floor(i + (a - l) * c / a + u)), o);
                }
                var f = n[i], d = r, p = s;
                for(t(n, r, i), o(n[s], f) > 0 && t(n, r, s); d < p;){
                    for(t(n, d, p), d++, p--; o(n[d], f) < 0;)d++;
                    for(; o(n[p], f) > 0;)p--;
                }
                0 === o(n[r], f) ? t(n, r, p) : t(n, ++p, s), p <= i && (r = p + 1), i <= p && (s = p - 1);
            }
        }
        function t(e, t, n) {
            var i = e[t];
            e[t] = e[n], e[n] = i;
        }
        function n(e, t) {
            return e < t ? -1 : e > t ? 1 : 0;
        }
        return function(t, i, r, s, o) {
            e(t, i, r || 0, s || t.length - 1, o || n);
        };
    }();
    var oo = n(so.exports);
    function ao(e, t) {
        const n = e.length;
        if (n <= 1) return [
            e
        ];
        const i = [];
        let r, s;
        for(let t = 0; t < n; t++){
            const n = b(e[t]);
            0 !== n && (e[t].area = Math.abs(n), void 0 === s && (s = n < 0), s === n < 0 ? (r && i.push(r), r = [
                e[t]
            ]) : r.push(e[t]));
        }
        if (r && i.push(r), t > 1) for(let e = 0; e < i.length; e++)i[e].length <= t || (oo(i[e], t, 1, i[e].length - 1, lo), i[e] = i[e].slice(0, t));
        return i;
    }
    function lo(e, t) {
        return t.area - e.area;
    }
    class ho {
        constructor(e = [], t = co){
            if (this.data = e, this.length = this.data.length, this.compare = t, this.length > 0) for(let e = (this.length >> 1) - 1; e >= 0; e--)this._down(e);
        }
        push(e) {
            this.data.push(e), this.length++, this._up(this.length - 1);
        }
        pop() {
            if (0 === this.length) return;
            const e = this.data[0], t = this.data.pop();
            return this.length--, this.length > 0 && (this.data[0] = t, this._down(0)), e;
        }
        peek() {
            return this.data[0];
        }
        _up(e) {
            const { data: t, compare: n } = this, i = t[e];
            for(; e > 0;){
                const r = e - 1 >> 1, s = t[r];
                if (n(i, s) >= 0) break;
                t[e] = s, e = r;
            }
            t[e] = i;
        }
        _down(e) {
            const { data: t, compare: n } = this, i = this.length >> 1, r = t[e];
            for(; e < i;){
                let i = 1 + (e << 1), s = t[i];
                const o = i + 1;
                if (o < this.length && n(t[o], s) < 0 && (i = o, s = t[o]), n(s, r) >= 0) break;
                t[e] = s, e = i;
            }
            t[e] = r;
        }
    }
    function co(e, t) {
        return e < t ? -1 : e > t ? 1 : 0;
    }
    function uo(e, t, n) {
        const i = t.distSqr(n);
        if (0 === i) return e.distSqr(t);
        const r = ((e.x - t.x) * (n.x - t.x) + (e.y - t.y) * (n.y - t.y)) / i;
        return r < 0 ? e.distSqr(t) : r > 1 ? e.distSqr(n) : e.distSqr(n.sub(t)._mult(r)._add(t));
    }
    function fo(e, t = 1, n = !1) {
        let i = 1 / 0, r = 1 / 0, o = -1 / 0, a = -1 / 0;
        const l = e[0];
        for(let e = 0; e < l.length; e++){
            const t = l[e];
            (!e || t.x < i) && (i = t.x), (!e || t.y < r) && (r = t.y), (!e || t.x > o) && (o = t.x), (!e || t.y > a) && (a = t.y);
        }
        const h = o - i, c = a - r, u = Math.min(h, c);
        let f = u / 2;
        const d = new ho([], po);
        if (0 === u) return new s(i, r);
        for(let t = i; t < o; t += u)for(let n = r; n < a; n += u)d.push(new go(t + f, n + f, f, e));
        let p = function(e) {
            let t = 0, n = 0, i = 0;
            const r = e[0];
            for(let e = 0, s = r.length, o = s - 1; e < s; o = e++){
                const s = r[e], a = r[o], l = s.x * a.y - a.x * s.y;
                n += (s.x + a.x) * l, i += (s.y + a.y) * l, t += 3 * l;
            }
            return new go(n / t, i / t, 0, e);
        }(e), g = d.length;
        for(; d.length;){
            const i = d.pop();
            (i.d > p.d || !p.d) && (p = i, n && console.log("found best %d after %d probes", Math.round(1e4 * i.d) / 1e4, g)), i.max - p.d <= t || (f = i.h / 2, d.push(new go(i.p.x - f, i.p.y - f, f, e)), d.push(new go(i.p.x + f, i.p.y - f, f, e)), d.push(new go(i.p.x - f, i.p.y + f, f, e)), d.push(new go(i.p.x + f, i.p.y + f, f, e)), g += 4);
        }
        return n && (console.log(`num probes: ${g}`), console.log(`best distance: ${p.d}`)), p.p;
    }
    function po(e, t) {
        return t.max - e.max;
    }
    function go(e, t, n, i) {
        this.p = new s(e, t), this.h = n, this.d = function(e, t) {
            let n = !1, i = 1 / 0;
            for(let r = 0; r < t.length; r++){
                const s = t[r];
                for(let t = 0, r = s.length, o = r - 1; t < r; o = t++){
                    const r = s[t], a = s[o];
                    r.y > e.y != a.y > e.y && e.x < (a.x - r.x) * (e.y - r.y) / (a.y - r.y) + r.x && (n = !n), i = Math.min(i, uo(e, r, a));
                }
            }
            return (n ? 1 : -1) * Math.sqrt(i);
        }(this.p, i), this.max = this.d + this.h * Math.SQRT2;
    }
    function mo(e, t, n, i, r, s, o, a, l, h) {
        const { feature: c, iconSize: u, textSize: f, symbol: d } = e, p = u || f ? 24 : 0, g = r * (f ? f[0] / p : 1);
        if ("line" === o) {
            const e = [];
            e.countOutOfAngle = 0;
            let r = c.geometry;
            s && (r = Qs(c.geometry, 0, 0, s, s));
            for(let o = 0; o < r.length; o++){
                const c = no(r[o], a, n, d.isIconText ? null : i && i.vertical || i && i.horizontal || i, 0, p, d.isIconText ? 1 : g, 1, s || 1 / 0, l, h);
                if (d.textPlacement && !d.isIconText) for(let e = 0; e < c.length; e++)c[e].startIndex = t.length / 3;
                if (e.push.apply(e, c), d.textPlacement && !d.isIconText) for(let e = 0; e < r[o].length; e++)t.push(r[o][e].x, r[o][e].y, r[o][e].z || 0);
                e.countOutOfAngle += c.countOutOfAngle || 0;
            }
            return e;
        }
        return yo(c, o, s);
    }
    function yo(e, t, n, i, r) {
        const s = [];
        if (3 === e.type) {
            const o = ao(e.geometry, 0);
            for(let e = 0; e < o.length; e++){
                const a = o[e];
                if ("vertex" === t) for(let e = 0; e < a.length; e++){
                    const t = a[e];
                    for(let o = 0; o < t.length; o++)w(t[o], n) || (s.push(t[o]), i && (0 === o ? xo(t[o], t[o], t[e + 1], r) : xo(t[o], t[o - 1], t[o], r)));
                }
                else if ("vertex-first" === t) {
                    const e = a[0];
                    e && e[0] && !w(e[0], n) && (s.push(e[0]), i && xo(e[0], e[0], e[1], r));
                } else if ("vertex-last" === t || "vertex-firstlast" === t) {
                    const e = a[0];
                    if ("vertex-firstlast" === t && e && e[0] && !w(e[0], n) && (s.push(e[0]), i && xo(e[0], e[0], e[1], r)), e && e[e.length - 1] && !w(e[e.length - 1], n)) {
                        const t = e.length - 1;
                        s.push(e[t]), i && xo(e[t], e[t - 1], e[t], r);
                    }
                } else {
                    const e = fo(a, 16);
                    w(e, n) || s.push(e);
                }
            }
        } else if (2 === e.type) for(let o = 0; o < e.geometry.length; o++){
            const a = e.geometry[o];
            if ("vertex" === t) for(let e = 0; e < a.length; e++)w(a[e], n) || (s.push(a[e]), i && (0 === e ? xo(a[e], a[e], a[e + 1], r) : xo(a[e], a[e - 1], a[e], r)));
            else if ("vertex-last" === t || "vertex-firstlast" === t) {
                if ("vertex-firstlast" !== t || w(a[0], n) || (s.push(a[0]), i && xo(a[0], a[0], a[1], r)), a && a[a.length - 1] && !w(a[a.length - 1], n)) {
                    const e = a.length - 1;
                    s.push(a[e]), i && xo(a[e], a[e - 1], a[e], r);
                }
            } else w(a[0], n) || (s.push(a[0]), i && xo(a[0], a[0], a[1], r));
        }
        else if (1 === e.type) for(let t = 0; t < e.geometry.length; t++){
            const r = e.geometry[t];
            for(let e = 0; e < r.length; e++){
                const t = r[e];
                w(t, n) || (i && (t.xRotation = 0, t.yRotation = 0, t.zRotation = 0), s.push(t));
            }
        }
        return s;
    }
    function xo(e, t, n, i) {
        if (e.xRotation || e.yRotation || e.zRotation) return e;
        const r = n.x - t.x, s = t.y - n.y, o = (n.z - t.z) * i, a = Math.atan2(s, r);
        e.zRotation = a;
        const l = Math.atan2(o, Math.sqrt(r * r + s * s));
        return e.xyRotation = l, e;
    }
    function _o(e, t) {
        const n = {}, i = {}, r = [];
        let s = 0;
        function o(t) {
            r.push(e[t]), s++;
        }
        function a(e, t, n) {
            const s = i[e];
            return delete i[e], i[t] = s, r[s].geometry[0].pop(), r[s].geometry[0] = r[s].geometry[0].concat(n[0]), s;
        }
        function l(e, t, i) {
            const s = n[t];
            return delete n[t], n[e] = s, r[s].geometry[0].shift(), r[s].geometry[0] = i[0].concat(r[s].geometry[0]), s;
        }
        function h(e, t, n) {
            const i = n ? t[0][t[0].length - 1] : t[0][0];
            return `${e}:${i.x}:${i.y}`;
        }
        for(let c = 0; c < e.length; c++){
            const u = e[c], f = u.geometry;
            if (!f) continue;
            const d = u.properties[t] ? u.properties[t].toString() : null;
            if (!d) {
                o(c);
                continue;
            }
            const p = h(d, f), g = h(d, f, !0);
            if (p in i && g in n && i[p] !== n[g]) {
                const e = l(p, g, f), t = a(p, g, r[e].geometry);
                delete n[p], delete i[g], i[h(d, r[t].geometry, !0)] = t, r[e].geometry = null;
            } else p in i ? a(p, g, f) : g in n ? l(p, g, f) : (o(c), n[p] = s - 1, i[g] = s - 1);
        }
        return r.filter((e)=>e.geometry);
    }
    const vo = "__index";
    function bo(e, t, n, i) {
        const r = (vo + "").trim(), s = function(e, t, n, i) {
            const r = (vo + "").trim(), { mergeOnPropertyFn: s } = n;
            if (!t.mergeOnProperty) return [];
            if (!M(o = t.mergeOnProperty) && ("string" == typeof o || null !== o.constructor && o.constructor === String)) return [
                {
                    features: e,
                    property: t.mergeOnProperty
                }
            ];
            var o;
            const a = [], l = {}, h = [];
            for(let n = 0; n < e.length; n++){
                e[n][r] = n;
                const o = e[n].properties = e[n].properties || {};
                o.$layer = e[n].layer, o.$type = e[n].type;
                const c = s ? s(i, o) : t.mergeOnProperty;
                M(c) ? h.push(e[n]) : (void 0 === l[c] && (l[c] = a.length, a.push({
                    features: [],
                    property: c
                })), a[l[c]].features.push(e[n]));
            }
            return h.length && a.push({
                features: h
            }), a;
        }(e, t, n, i);
        if (s.length) {
            const e = [];
            for(let t = 0; t < s.length; t++)s[t].property ? e.push(_o(s[t].features, s[t].property)) : e.push(s[t].features);
            if (1 === e.length) return e[0];
            {
                let t = [];
                for(let n = 0; n < e.length; n++)t = t.concat(e[n]);
                return t.sort((e, t)=>e[r] - t[r]), t;
            }
        }
        return [];
    }
    class Ao extends gs {
        static needMerge(e, t, n) {
            if (!e) return !1;
            let i = "line" === e.textPlacement || "line" === e.markerPlacement;
            return i || (t.textPlacementFn && (i = "line" === t.textPlacementFn(n)), t.markerPlacementFn && (i = "line" === t.markerPlacementFn(n))), e.mergeOnProperty && i;
        }
        static mergeLineFeatures(e, t, n, i) {
            let r = t.textPlacement, s = t.markerPlacement;
            return n.textPlacementFn && (r = n.textPlacementFn(i)), n.markerPlacementFn && (s = n.markerPlacementFn(i)), "line" !== r && "line" !== s ? e : bo(e, t, n, i);
        }
        static splitPointSymbol(e, t = 0) {
            const n = [];
            if (Array.isArray(e)) {
                const t = e;
                for(let e = 0; e < t.length; e++)t[e] && n.push(...Ao.splitPointSymbol(t[e], e));
                return n;
            }
            let i = null, r = null;
            for(const t in e)0 === t.indexOf("marker") ? (i = i || {}, i[t] = e[t]) : 0 === t.indexOf("text") && (r = r || {}, r[t] = e[t]);
            return i && (i.isIconText = !0, e.mergeOnProperty && (i.mergeOnProperty = e.mergeOnProperty), n.push(i)), r && (i && (r.textPlacement = i.markerPlacement, r.textSpacing = i.markerSpacing, r.isIconText = !0), e.mergeOnProperty && (r.mergeOnProperty = e.mergeOnProperty), n.push(r)), void 0 !== e.visible && (i && (i.visible = e.visible), r && (r.visible = e.visible)), i && (i.markerTextFit && r && (i.text = {}, i.text.textName = r.textName, i.text.textSize = r.textSize), i.index = {
                index: t,
                type: 0
            }), r && (r.index = {
                index: t,
                type: 1
            }), n;
        }
        static isAtlasLoaded(e, t) {
            const { icon: n, glyph: i } = e, { iconAtlas: r, glyphAtlas: s } = t;
            if (n && (!r || !r.positions[n.url])) return !1;
            if (i) {
                if (!s || !s.positions[i.font]) return !1;
                const e = s.positions[i.font], { text: t } = i;
                for (const n of t)if (!e[n.codePointAt(0)]) return !1;
            }
            return !0;
        }
        constructor(e, t, n){
            super(e, t, n), this._textPlacement = t.textPlacement, this._fnTypes.textPlacementFn && (this._textPlacement = this._fnTypes.textPlacementFn(this.options.zoom));
        }
        createStyledVector(e, t, n, i, r, s) {
            const o = new Js(e, this.symbolDef, t, n, i), a = o.getIconAndGlyph();
            if (a.icon && !this.options.atlas) {
                const { url: e, iconSize: t } = a.icon;
                r[e] || (r[e] = a.icon.iconSize), r[e][0] < t[0] && (r[e][0] = t[0]), r[e][1] < t[1] && (r[e][1] = t[1]);
            }
            if (a.glyph && !this.options.atlas) {
                const { font: e, text: t } = a.glyph, n = s[e] = s[e] || {};
                for (const e of t)n[e.codePointAt(0)] = 1;
                "line" === this._textPlacement && (s.options = {
                    isCharsCompact: !1
                });
            }
            return this.options.allowEmptyPack || a.icon || a.glyph ? o : null;
        }
        getFormat(e) {
            const t = "text" === this.options.pluginType, n = "line" === this._textPlacement && !e.isIconText, i = this.getPackSDFFormat(e);
            i.push(...this._getTextFnTypeFormats()), n || i.push(...this._getMarkerFnTypeFormats());
            const { markerOpacityFn: r, textOpacityFn: s, markerPitchAlignmentFn: o, textPitchAlignmentFn: a, markerRotationAlignmentFn: l, textRotationAlignmentFn: h, markerRotationFn: c, textRotationFn: u, markerAllowOverlapFn: f, textAllowOverlapFn: d, markerIgnorePlacementFn: p, textIgnorePlacementFn: g } = this._fnTypes;
            return r ? i.push({
                type: Uint8Array,
                width: 2,
                name: "aColorOpacity"
            }) : s && i.push({
                type: Uint8Array,
                width: 1,
                name: "aColorOpacity"
            }), (o || a) && i.push({
                type: Uint8Array,
                width: t ? 1 : 2,
                name: "aPitchAlign"
            }), (l || h) && i.push({
                type: Uint8Array,
                width: t ? 1 : 2,
                name: "aRotationAlign"
            }), (c || u) && i.push({
                type: Uint16Array,
                width: t ? 1 : 2,
                name: "aRotation"
            }), (f || d || p || g) && i.push({
                type: Uint8Array,
                width: 1,
                name: "aOverlap"
            }), i;
        }
        _is3DPitchText() {
            return this.hasMapPitchAlign;
        }
        _getTextFnTypeFormats() {
            const { textFillFn: e, textSizeFn: t, textHaloFillFn: n, textHaloRadiusFn: i, textHaloOpacityFn: r, textDxFn: s, textDyFn: o } = this._fnTypes, a = [];
            return e && a.push({
                type: Uint8Array,
                width: 4,
                name: "aTextFill"
            }), t && a.push({
                type: Uint8Array,
                width: 1,
                name: "aTextSize"
            }), n && a.push({
                type: Uint8Array,
                width: 4,
                name: "aTextHaloFill"
            }), (i || r) && a.push({
                type: Uint8Array,
                width: 2,
                name: "aTextHalo"
            }), s && a.push({
                type: Int8Array,
                width: 1,
                name: "aTextDx"
            }), o && a.push({
                type: Int8Array,
                width: 1,
                name: "aTextDy"
            }), a;
        }
        _getMarkerFnTypeFormats() {
            const { markerWidthFn: e, markerHeightFn: t, markerDxFn: n, markerDyFn: i, textDxFn: r, textDyFn: s } = this._fnTypes, o = [];
            return e && o.push({
                type: this.options.markerWidthType || Uint8Array,
                width: 1,
                name: "aMarkerWidth"
            }), t && o.push({
                type: this.options.markerHeightType || Uint8Array,
                width: 1,
                name: "aMarkerHeight"
            }), (n || r) && o.push({
                type: Int8Array,
                width: 1,
                name: "aMarkerDx"
            }), (i || s) && o.push({
                type: Int8Array,
                width: 1,
                name: "aMarkerDy"
            }), o;
        }
        _prepareFnTypes() {
            this.iconAtlas || (this._fnTypes.markerWidthFn = this._fnTypes.markerHeightFn = this._fnTypes.markerDxFn = this._fnTypes.markerDyFn = this._fnTypes.markerPitchAlignmentFn = this._fnTypes.markerRotationAlignmentFn = this._fnTypes.markerRotationFn = this._fnTypes.markerAllowOverlapFn = this._fnTypes.markerIgnorePlacementFn = this._fnTypes.markerOpacityFn = null), this.glyphAtlas || (this._fnTypes.textFillFn = this._fnTypes.textSizeFn = this._fnTypes.textHaloFillFn = this._fnTypes.textHaloRadiusFn = this._fnTypes.textHaloOpacityFn = this._fnTypes.textDxFn = this._fnTypes.textDyFn = this._fnTypes.textPitchAlignmentFn = this._fnTypes.textRotationAlignmentFn = this._fnTypes.textRotationFn = this._fnTypes.textAllowOverlapFn = this._fnTypes.textIgnorePlacementFn = this._fnTypes.textOpacityFn = null);
        }
        createDataPack() {
            if (!this.iconAtlas && !this.glyphAtlas) {
                if (!this.options.allowEmptyPack) return null;
                this.empty = !0;
            }
            this._prepareFnTypes(), this.countOutOfAngle = 0, this.lineVertex = [];
            const e = super.createDataPack.apply(this, arguments);
            return e ? (e.lineVertex = new Int16Array(this.lineVertex), e.buffers.push(e.lineVertex.buffer), e) : null;
        }
        placeVector(e, t) {
            const n = e.getShape(this.iconAtlas, this.glyphAtlas);
            if (!n) return;
            const { iconShape: i, textShape: r } = n, o = !i || !i.image, a = !r || !r.horizontal && !r.vertical;
            if (!this.options.allowEmptyPack && o && a) return;
            const l = this._getAnchors(e, r || i, t);
            if (this.countOutOfAngle += l.countOutOfAngle || 0, 0 === l.length) return;
            const h = this.data, c = this.needAltitudeAttribute() ? 2 : 3;
            let u = this.data.aPosition.getLength() / c;
            const f = e.symbol, d = e.feature.properties, p = "line" === this._textPlacement && !f.isIconText, g = !a, m = !o, y = g && p && function(e) {
                let t = 0;
                for(let n = 0; n < e.length; n++)if (Os(e.charAt(n).charCodeAt(0))) t = 0;
                else if (t++, t >= 1) return !1;
                return !0;
            }(e.getIconAndGlyph().glyph.text) ? 1 : 0, { textFillFn: x, textSizeFn: _, textHaloFillFn: v, textHaloRadiusFn: b, textHaloOpacityFn: A, textDxFn: T, textDyFn: I, textPitchAlignmentFn: C, textRotationAlignmentFn: k, textRotationFn: F, textAllowOverlapFn: O, textIgnorePlacementFn: R, textOpacityFn: E, markerWidthFn: D, markerHeightFn: L, markerDxFn: H, markerDyFn: N, markerPitchAlignmentFn: z, markerRotationAlignmentFn: V, markerRotationFn: U, markerAllowOverlapFn: B, markerIgnorePlacementFn: G, markerOpacityFn: j } = this._fnTypes;
            let W, X, Y, Z, q, $ = [
                0,
                0,
                0,
                0
            ], J = 14, K = [
                0,
                0,
                0,
                0
            ], Q = 0, ee = 0, te = 0, ne = 0, re = 0, se = 0, oe = 0, ae = 0, le = 0, he = 0, ce = 0, ue = 0, fe = 0, de = 0;
            if (g) {
                const t = e.getIconAndGlyph().glyph.font;
                Y = function(e, t, n) {
                    const i = e.positionedGlyphs, r = [];
                    for(let o = 0; o < i.length; o++){
                        const a = i[o], l = n[a.glyph];
                        if (!l) continue;
                        const h = l.rect;
                        if (!h) continue;
                        const c = 4, u = l.metrics.advance / 2, f = l.metrics.height / 2, d = t ? [
                            a.x + u,
                            0
                        ] : [
                            0,
                            0
                        ], p = t ? [
                            0,
                            a.y - f
                        ] : [
                            a.x + u,
                            a.y - f
                        ], g = l.metrics.left - c - u + p[0], m = l.metrics.top - c + p[1], y = g + h.w, x = m + h.h, _ = new s(g, m), v = new s(y, m), b = new s(g, x), A = new s(y, x);
                        if (t && a.vertical) {
                            const e = new s(-u, u), t = -Math.PI / 2, n = new s(5, 0);
                            _._rotateAround(t, e)._add(n), v._rotateAround(t, e)._add(n), b._rotateAround(t, e)._add(n), A._rotateAround(t, e)._add(n);
                        }
                        r.push({
                            tl: _,
                            tr: v,
                            bl: b,
                            br: A,
                            tex: h,
                            writingMode: e.writingMode,
                            glyphOffset: d
                        });
                    }
                    return r;
                }(r.horizontal, p, this.glyphAtlas.positions[t]), x && ($ = x(null, d), ie($) ? this.dynamicAttrs.aTextFill = 1 : $ = ht([], $)), _ && (J = _(this.options.zoom, d), M(J) && (J = 14)), v && (K = v(null, d), ie(K) ? this.dynamicAttrs.aTextHaloFill = 1 : K = ht([], K)), b && (Q = b(null, d)), A && (ee = 255 * A(null, d)), T && (te = T(null, d) || 0), I && (ne = I(null, d) || 0), C && (he = +("map" === C(null, d))), k && (ue = +("map" === k(null, d))), F && (de = P(F(null, d), 0, 360) * Math.PI / 180);
            }
            m && (Z = i ? function(e) {
                const t = e.image, n = e.top - 1 / t.pixelRatio, i = e.left - 1 / t.pixelRatio, r = e.bottom + 1 / t.pixelRatio, o = e.right + 1 / t.pixelRatio;
                let a, l, h, c;
                return a = new s(i, n), l = new s(o, n), h = new s(o, r), c = new s(i, r), [
                    {
                        tl: a,
                        tr: l,
                        bl: c,
                        br: h,
                        tex: {
                            x: t.tl[0],
                            y: t.tl[1],
                            w: t.displaySize[0],
                            h: t.displaySize[1]
                        },
                        writingMode: void 0,
                        glyphOffset: [
                            0,
                            0
                        ]
                    }
                ];
            }(i) : function() {
                const e = new s(0, 0), t = new s(0, 0), n = new s(0, 0);
                return [
                    {
                        tl: e,
                        tr: t,
                        bl: new s(0, 0),
                        br: n,
                        tex: {
                            x: 0,
                            y: 0,
                            w: 0,
                            h: 0
                        },
                        writingMode: void 0,
                        glyphOffset: [
                            0,
                            0
                        ]
                    }
                ];
            }(), D && (re = D(null, d)), M(re) && (re = Z[0].tex.w), L && (se = L(null, d)), M(se) && (se = Z[0].tex.h), H && (oe = H(null, d)), N && (ae = N(null, d)), z && (le = +("map" === z(null, d))), V && (ce = +("map" === V(null, d))), U && (fe = P(U(null, d), 0, 360) * Math.PI / 180)), ie(J) && (this.dynamicAttrs.aTextSize = 1), (ie(Q) || ie(ee)) && (this.dynamicAttrs.aTextHalo = 1), ie(re) && (this.dynamicAttrs.aMarkerWidth = 1), ie(se) && (this.dynamicAttrs.aMarkerHeight = 1), (ie(oe) || ie(te)) && (this.dynamicAttrs.aDxDy = 1), (ie(ae) || ie(te)) && (this.dynamicAttrs.aDxDy = 1), (ie(le) || ie(he)) && (this.dynamicAttrs.aPitchAlign = 1), (ie(ce) || ie(ue)) && (this.dynamicAttrs.aRotationAlign = 1), (ie(fe) || ie(de)) && (this.dynamicAttrs.aRotation = 1), (B || O) && (B && (W = B(null, d) || 0), !W && O && (W = O(null, d) || 0)), (G || R) && (G && (X = G(null, d) || 0), !X && R && (X = R(null, d) || 0)), j && (q = 255 * (j(this.options.zoom, d) || 0));
            let pe = 0;
            E && (pe = 255 * (E(this.options.zoom, d) || 0));
            const ge = Y && Y.length || 0;
            this.ensureDataCapacity(4 * (ge + (Z && Z.length || 0)), l.length);
            const me = this.options.EXTENT, { altitudeScale: ye, altitudeProperty: xe, defaultAltitude: _e } = this.options, { altitude: ve } = S(e.feature, ye, xe, _e), be = this.needAltitudeAttribute(), Ae = (e, t, n, i, r, s, o)=>{
                if (!t) return;
                const a = e ? ge : 1;
                for(let l = 0; l < t.length; l++){
                    const c = t[l], { tl: f, tr: d, bl: g, br: m, tex: x } = c;
                    let _;
                    this._fillPos(h, n, i, r, 10 * f.x, 10 * f.y, x.x, x.y + x.h, e, o), this._fillTextData(h, p, a, c.glyphOffset, s, y, s.axis, s.angleR), this._fillFnTypeData(h, $, J, K, Q, ee, te, ne, re, se, oe, ae, q, pe, le, he, ce, ue, fe, de, W, X), this._fillPos(h, n, i, r, 10 * d.x, 10 * d.y, x.x + x.w, x.y + x.h, e, o), this._fillTextData(h, p, a, c.glyphOffset, s, y, s.axis, s.angleR), this._fillFnTypeData(h, $, J, K, Q, ee, te, ne, re, se, oe, ae, q, pe, le, he, ce, ue, fe, de, W, X), this._fillPos(h, n, i, r, 10 * g.x, 10 * g.y, x.x, x.y, e, o), this._fillTextData(h, p, a, c.glyphOffset, s, y, s.axis, s.angleR), this._fillFnTypeData(h, $, J, K, Q, ee, te, ne, re, se, oe, ae, q, pe, le, he, ce, ue, fe, de, W, X), this._fillPos(h, n, i, r, 10 * m.x, 10 * m.y, x.x + x.w, x.y, e, o), this._fillTextData(h, p, a, c.glyphOffset, s, y, s.axis, s.angleR), this._fillFnTypeData(h, $, J, K, Q, ee, te, ne, re, se, oe, ae, q, pe, le, he, ce, ue, fe, de, W, X), this.addElements(u, u + 1, u + 2), this.addElements(u + 1, u + 2, u + 3), u += 4, _ = be ? Math.max(Math.abs(n), Math.abs(i)) : Math.max(Math.abs(n), Math.abs(i), Math.abs(r)), _ > this.maxPos && (this.maxPos = _);
                }
            }, Te = "text" === this.options.pluginType;
            for(let e = 0; e < l.length; e++){
                const t = l[e], n = t.z || ve || 0;
                if (me !== 1 / 0 && w(t, me)) continue;
                const i = t.x, r = t.y;
                m && Ae(!1, Z, i, r, n, t), g && (Te || Ae(!0, Y, i, r, n, t, !0), Ae(!0, Y, i, r, n, t, !1));
            }
        }
        _fillPos(e, t, n, i, r, s, o, a, l, h) {
            this.fillPosition(e, t, n, i);
            let c = e.aShape.currentIndex;
            e.aShape[c++] = r, e.aShape[c++] = s, e.aShape.currentIndex = c, e.aTexCoord ? (c = e.aTexCoord.currentIndex, e.aTexCoord[c++] = o, e.aTexCoord[c++] = a, e.aTexCoord.currentIndex = c) : (c = e.aShape.currentIndex, "text" !== this.options.pluginType ? (e.aShape[c++] = +!!l + (o << 1), e.aShape[c++] = +!!h + (a << 1)) : (e.aShape[c++] = o, e.aShape[c++] = a), e.aShape.currentIndex = c);
        }
        _fillTextData(e, t, n, i, r, s, o, a) {
            let l = e.aCount.currentIndex;
            if (e.aCount[l++] = n, e.aCount.currentIndex = l, t) {
                l = e.aGlyphOffset.currentIndex, e.aGlyphOffset[l++] = i[0], e.aGlyphOffset[l++] = i[1], e.aGlyphOffset.currentIndex = l, this._is3DPitchText() && (l = e.aPitchRotation.currentIndex, e.aPitchRotation[l++] = o[0], e.aPitchRotation[l++] = o[1], e.aPitchRotation[l++] = a, e.aPitchRotation.currentIndex = l);
                const t = r.startIndex;
                l = e.aSegment.currentIndex, e.aSegment[l++] = r.segment + t, e.aSegment[l++] = t, e.aSegment[l++] = r.line.length, e.aSegment.currentIndex = l, l = e.aVertical.currentIndex, e.aVertical[l++] = s, e.aVertical.currentIndex = l;
            }
        }
        _fillFnTypeData(e, t, n, i, r, s, o, a, l, h, c, u, f, d, p, g, m, y, x, _, v, b) {
            const { textFillFn: A, textSizeFn: T, textHaloFillFn: S, textHaloRadiusFn: w, textDxFn: P, textDyFn: I, textPitchAlignmentFn: C, textRotationAlignmentFn: k, textRotationFn: F, textAllowOverlapFn: O, textIgnorePlacementFn: R, textOpacityFn: E, textHaloOpacityFn: D, markerWidthFn: L, markerHeightFn: H, markerDxFn: N, markerDyFn: z, markerPitchAlignmentFn: V, markerRotationAlignmentFn: U, markerRotationFn: B, markerAllowOverlapFn: G, markerIgnorePlacementFn: j, markerOpacityFn: W } = this._fnTypes;
            if (A) {
                let n = e.aTextFill.currentIndex;
                e.aTextFill[n++] = t[0], e.aTextFill[n++] = t[1], e.aTextFill[n++] = t[2], e.aTextFill[n++] = t[3], e.aTextFill.currentIndex = n;
            }
            if (T) {
                let t = e.aTextSize.currentIndex;
                e.aTextSize[t++] = n, e.aTextSize.currentIndex = t;
            }
            if (S) {
                let t = e.aTextHaloFill.currentIndex;
                e.aTextHaloFill[t++] = i[0], e.aTextHaloFill[t++] = i[1], e.aTextHaloFill[t++] = i[2], e.aTextHaloFill[t++] = i[3], e.aTextHaloFill.currentIndex = t;
            }
            if (w || D) {
                let t = e.aTextHalo.currentIndex;
                e.aTextHalo[t++] = r || 0, e.aTextHalo.currentIndex = t, t = e.aTextHalo.currentIndex, e.aTextHalo[t++] = 255 * (M(s) ? 1 : s), e.aTextHalo.currentIndex = t;
            }
            if (P) {
                let t = e.aTextDx.currentIndex;
                e.aTextDx[t++] = o, e.aTextDx.currentIndex = t;
            }
            if (I) {
                let t = e.aTextDy.currentIndex;
                e.aTextDy[t++] = a, e.aTextDy.currentIndex = t;
            }
            if (L) {
                let t = e.aMarkerWidth.currentIndex;
                e.aMarkerWidth[t++] = l, e.aMarkerWidth.currentIndex = t;
            }
            if (H) {
                let t = e.aMarkerHeight.currentIndex;
                e.aMarkerHeight[t++] = h, e.aMarkerHeight.currentIndex = t;
            }
            if (N) {
                let t = e.aMarkerDx.currentIndex;
                e.aMarkerDx[t++] = c, e.aMarkerDx.currentIndex = t;
            }
            if (z) {
                let t = e.aMarkerDy.currentIndex;
                e.aMarkerDy[t++] = u, e.aMarkerDy.currentIndex = t;
            }
            const X = "text" === this.options.pluginType;
            if (!X && (W || E)) {
                W || (f = 255);
                let t = e.aColorOpacity.currentIndex;
                e.aColorOpacity[t++] = f, e.aColorOpacity.currentIndex = t, f = E ? d : 255, t = e.aColorOpacity.currentIndex, e.aColorOpacity[t++] = f, e.aColorOpacity.currentIndex = t;
            }
            if (X && E) {
                let t = e.aColorOpacity.currentIndex;
                e.aColorOpacity[t++] = d, e.aColorOpacity.currentIndex = t;
            }
            if (C || V) {
                if (X) {
                    let t = e.aPitchAlign.currentIndex;
                    e.aPitchAlign[t++] = g, e.aPitchAlign.currentIndex = t;
                } else {
                    let t = e.aPitchAlign.currentIndex;
                    e.aPitchAlign[t++] = p, e.aPitchAlign.currentIndex = t, t = e.aPitchAlign.currentIndex, e.aPitchAlign[t++] = g, e.aPitchAlign.currentIndex = t;
                }
            }
            if (U || k) {
                if (X) {
                    let t = e.aRotationAlign.currentIndex;
                    e.aRotationAlign[t++] = y, e.aRotationAlign.currentIndex = t;
                } else {
                    let t = e.aRotationAlign.currentIndex;
                    e.aRotationAlign[t++] = m, e.aRotationAlign.currentIndex = t, t = e.aRotationAlign.currentIndex, e.aRotationAlign[t++] = y, e.aRotationAlign.currentIndex = t;
                }
            }
            if (B || F) {
                if (X) {
                    let t = e.aRotation.currentIndex;
                    e.aRotation[t++] = 9362 * _, e.aRotation.currentIndex = t;
                } else {
                    let t = e.aRotation.currentIndex;
                    e.aRotation[t++] = 9362 * x, e.aRotation.currentIndex = t, t = e.aRotation.currentIndex, e.aRotation[t++] = 9362 * _, e.aRotation.currentIndex = t;
                }
            }
            const Y = G || O, Z = j || R;
            if (Y || Z) {
                const t = (Y ? 8 : 0) + 4 * v, n = (Z ? 2 : 0) + b;
                let i = e.aOverlap.currentIndex;
                e.aOverlap[i++] = t + n, e.aOverlap.currentIndex = i;
            }
            r > 0 && (this.properties.hasHalo = 1);
        }
        _getAnchors(e, t, n) {
            const { feature: i, symbol: r } = e, s = this._getPlacement(e, r), o = i.properties, { markerSpacingFn: a, textSpacingFn: l, textMaxAngleFn: h } = this._fnTypes, c = ((a ? a(null, o) : r.markerSpacing) || (l ? l(null, o) : r.textSpacing) || 250) * n;
            let u = h ? h(this.options.zoom, o) : r.textMaxAngle;
            M(u) && (u = 80), u *= Math.PI / 180;
            const f = this.options.EXTENT, d = this.options.altitudeToTileScale, p = this._is3DPitchText();
            return mo(e, this.lineVertex, u, t, n, f, s, c, p, d);
        }
        _getPlacement(e, t) {
            let n;
            return n = this._fnTypes.markerPlacementFn ? this._fnTypes.markerPlacementFn(this.options.zoom, e.feature.properties) : t.markerPlacement || this._textPlacement, this._packMarkerPlacement || !t.markerPlacement && !t.isIconText || (this._packMarkerPlacement = n), !this._textPlacement || t.isIconText || this._packTextPlacement || (this._packTextPlacement = n), n;
        }
        getPackSDFFormat(e) {
            if ("line" !== this._textPlacement || e.isIconText) return [
                ...this.getPositionFormat(),
                {
                    type: Int16Array,
                    width: 4,
                    name: "aShape"
                },
                {
                    type: Uint8Array,
                    width: 1,
                    name: "aCount"
                }
            ];
            {
                const e = [
                    ...this.getPositionFormat(),
                    {
                        type: Int16Array,
                        width: 2,
                        name: "aShape"
                    },
                    {
                        type: Uint16Array,
                        width: 2,
                        name: "aTexCoord"
                    },
                    {
                        type: Uint8Array,
                        width: 1,
                        name: "aCount"
                    },
                    {
                        type: Int16Array,
                        width: 2,
                        name: "aGlyphOffset"
                    },
                    {
                        type: Uint16Array,
                        width: 3,
                        name: "aSegment"
                    },
                    {
                        type: Uint8Array,
                        width: 1,
                        name: "aVertical"
                    }
                ];
                return this._is3DPitchText() && e.push({
                    type: Float32Array,
                    width: 3,
                    name: "aPitchRotation"
                }), e;
            }
        }
    }
    class To {
        constructor(e){
            this.x = e.x, this.y = e.y, this.z = e.z || 0;
        }
        clone() {
            return new To(this);
        }
        _unit() {
            return this._div(this.mag()), this;
        }
        _div(e) {
            return this.x /= e, this.y /= e, this.z /= e, this;
        }
        _perp() {
            var e = this.y;
            return this.y = this.x, this.x = -e, this;
        }
        mag() {
            return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
        }
        add(e) {
            return this.clone()._add(e);
        }
        sub(e) {
            return this.clone()._sub(e);
        }
        _add(e) {
            return this.x += e.x, this.y += e.y, this.z += e.z, this;
        }
        _sub(e) {
            return this.x -= e.x, this.y -= e.y, this.z -= e.z, this;
        }
        equals(e) {
            return this.x === e.x && this.y === e.y && this.z === e.z;
        }
        mult(e) {
            return this.clone()._mult(e);
        }
        _mult(e) {
            return this.x *= e, this.y *= e, this.z *= e, this;
        }
        dist(e) {
            return Math.sqrt(this.distSqr(e));
        }
        distSqr(e) {
            var t = e.x - this.x, n = e.y - this.y, i = e.z - this.z;
            return t * t + n * n + i * i;
        }
        _round() {
            return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this;
        }
        angleTo(e) {
            return Math.atan2(this.y - e.y, this.x - e.x);
        }
    }
    var So, wo = "undefined" != typeof Float32Array ? Float32Array : Array;
    function Mo(e, t, n, i) {
        return e[0] = t, e[1] = n, e[2] = i, e;
    }
    function Po(e, t) {
        var n = t[0], i = t[1], r = t[2], s = n * n + i * i + r * r;
        return s > 0 && (s = 1 / Math.sqrt(s)), e[0] = t[0] * s, e[1] = t[1] * s, e[2] = t[2] * s, e;
    }
    function Io(e, t, n) {
        var i = t[0], r = t[1], s = t[2], o = n[0], a = n[1], l = n[2];
        return e[0] = r * l - s * a, e[1] = s * o - i * l, e[2] = i * a - r * o, e;
    }
    function Co(e, t, n, i, r) {
        return e[0] = t, e[1] = n, e[2] = i, e[3] = r, e;
    }
    function ko(e, t, n) {
        return e[0] = t[0] * n, e[1] = t[1] * n, e[2] = t[2] * n, e[3] = t[3] * n, e;
    }
    function Fo(e, t, n) {
        return e[0] = t, e[1] = n, e;
    }
    Math.hypot || (Math.hypot = function() {
        for(var e = 0, t = arguments.length; t--;)e += arguments[t] * arguments[t];
        return Math.sqrt(e);
    }), So = new wo(3), wo != Float32Array && (So[0] = 0, So[1] = 0, So[2] = 0), function() {
        var e = new wo(4);
        wo != Float32Array && (e[0] = 0, e[1] = 0, e[2] = 0, e[3] = 0);
    }();
    !function() {
        var e = new wo(2);
        wo != Float32Array && (e[0] = 0, e[1] = 0);
    }();
    const Oo = 63, Ro = Math.cos(Math.PI / 180 * 37.5), Eo = Math.pow(2, 16) / 1, Do = new s, Lo = new s, Ho = new s;
    class No extends gs {
        static mergeLineFeatures(e, t, n, i) {
            return bo(e, t, n, i);
        }
        constructor(e, t, n){
            super(e, t, n);
            let i = !1;
            const { lineDasharrayFn: r, lineDashColorFn: s } = this._fnTypes;
            this.hasGradient = this.symbol.lineGradientProperty, r && (i = function(e, t, n) {
                for(let i = 0; i < e.length; i++)if (n(t, e[i].properties)) return !0;
                return !1;
            }(e, this.options.zoom, r), i && (this.dasharrayFn = r)), this.hasDasharray = Uo(this.symbol.lineDasharray) || i, this.hasDasharray && s && (this.dashColorFn = s);
        }
        createStyledVector(e, t, n, i, r) {
            const s = new dt(e, t, n, i), o = s.getLineResource();
            return !this.options.atlas && o && (r[o] = [
                0,
                0
            ]), s;
        }
        getFormat() {
            const { lineWidthFn: e, lineStrokeWidthFn: t, lineStrokeColorFn: n, lineColorFn: i, lineOpacityFn: r, lineDxFn: s, lineDyFn: o, linePatternAnimSpeedFn: a, linePatternGapFn: l } = this._fnTypes, h = [
                ...this.getPositionFormat()
            ];
            if (this.iconAtlas || this.hasDasharray ? h.push({
                type: Int8Array,
                width: 3,
                name: "aExtrude"
            }) : h.push({
                type: Int8Array,
                width: 2,
                name: "aExtrude"
            }), h.push({
                type: this.options.positionType || Uint16Array,
                width: 1,
                name: "aLinesofar"
            }), e && h.push({
                type: Uint8Array,
                width: 1,
                name: "aLineWidth"
            }), t && h.push({
                type: Uint8Array,
                width: 1,
                name: "aLineStrokeWidth"
            }), i && h.push({
                type: Uint8Array,
                width: 4,
                name: "aColor"
            }), n && h.push({
                type: Uint8Array,
                width: 4,
                name: "aStrokeColor"
            }), r && h.push({
                type: Uint8Array,
                width: 1,
                name: "aOpacity"
            }), this.dasharrayFn && h.push({
                type: Uint8Array,
                width: 4,
                name: "aDasharray"
            }), this.dashColorFn && h.push({
                type: Uint8Array,
                width: 4,
                name: "aDashColor"
            }), this.iconAtlas) {
                const e = this.getIconAtlasMaxValue();
                h.push({
                    type: e > 255 ? Uint16Array : Uint8Array,
                    width: 4,
                    name: "aTexInfo"
                });
            }
            return (s || o) && h.push({
                type: Int8Array,
                width: 2,
                name: "aLineDxDy"
            }), (a || l) && h.push({
                type: Int8Array,
                width: 2,
                name: "aLinePattern"
            }), h;
        }
        placeVector(e) {
            const { lineJoinFn: t, lineCapFn: n, lineWidthFn: i, lineHeightFn: r, lineStrokeWidthFn: s, lineStrokeColorFn: o, lineColorFn: a, lineOpacityFn: l, lineDxFn: h, lineDyFn: c, linePatternAnimSpeedFn: u, linePatternGapFn: f } = this._fnTypes, d = this.symbol, p = e.feature, g = p.properties;
            this.elements;
            let m = d.lineJoin || "miter", y = d.lineCap || "butt";
            if (t && (m = t(this.options.zoom, g) || "miter"), n && (y = n(this.options.zoom, g) || "butt"), i) {
                let e = i(this.options.zoom, g);
                ie(e) && (this.dynamicAttrs.aLineWidth = 1, e = 4), Je(e) && (e = 4), this.feaLineWidth = +e;
            } else this.feaLineWidth = +d.lineWidth;
            if (r) {
                let e = r(this.options.zoom, g);
                ie(e) && (this.dynamicAttrs.aLineHeight = 1), Je(e) && (e = this.feaLineWidth), this.feaLineHeight = +e;
            } else this.feaLineHeight = +d.lineHeight || this.feaLineWidth;
            if (s) {
                let e = s(this.options.zoom, g);
                ie(e) && (this.dynamicAttrs.aLineStrokeWidth = 1, e = 0), Je(e) && (e = 0), this.feaLineStrokeWidth = e;
            } else this.feaLineStrokeWidth = d.lineStrokeWidth || 0;
            if (a && (this.feaColor = a(this.options.zoom, g) || [
                255,
                255,
                255,
                255
            ], ie(this.feaColor) ? (this.dynamicAttrs.aColor = 1, this.feaColor = [
                0,
                0,
                0,
                0
            ]) : this.feaColor = ht([], this.feaColor)), o && (this.feaStrokeColor = o(this.options.zoom, g) || [
                0,
                0,
                0,
                255
            ], ie(this.feaStrokeColor) ? (this.dynamicAttrs.aStrokeColor = 1, this.feaStrokeColor = [
                0,
                0,
                0,
                0
            ]) : this.feaStrokeColor = ht([], this.feaStrokeColor)), l) {
                let e = l(this.options.zoom, g);
                ie(e) && (this.dynamicAttrs.aOpacity = 1, e = 1), Je(e) && (e = 1), this.feaOpacity = 255 * e;
            }
            if (this.dasharrayFn) {
                let e = this.dasharrayFn(this.options.zoom, g) || [
                    0,
                    0,
                    0,
                    0
                ];
                if (ie(e) && (this.dynamicAttrs.aDasharray = 1, e = [
                    0,
                    0,
                    0,
                    0
                ]), e.length < 4) {
                    const t = e;
                    1 === e.length ? e = [
                        t[0],
                        t[0],
                        t[0],
                        t[0]
                    ] : 2 === e.length ? e = [
                        t[0],
                        t[1],
                        t[0],
                        t[1]
                    ] : 3 === e.length && (e = [
                        t[0],
                        t[1],
                        t[2],
                        t[2]
                    ]);
                }
                this.feaDash = e;
            }
            if (this.dashColorFn) {
                let e = (this.dashColorFn ? this.dashColorFn(this.options.zoom, g) : this.symbol.lineDashColor) || [
                    0,
                    0,
                    0,
                    0
                ];
                ie(e) && (this.dynamicAttrs.aDashColor = 1, e = [
                    0,
                    0,
                    0,
                    0
                ]), e = ht([], e), this.feaDashColor = e;
            }
            if (this.iconAtlas) {
                const t = e.getLineResource(), n = this.iconAtlas.glyphMap[t];
                if (this.feaTexInfo = this.feaTexInfo || [
                    0,
                    0,
                    0,
                    0
                ], n) {
                    const { tl: e, displaySize: n } = this.iconAtlas.positions[t];
                    this.feaTexInfo[0] = e[0] + 1, this.feaTexInfo[1] = e[1] + 1, this.feaTexInfo[2] = n[0] - 3, this.feaTexInfo[3] = n[1] - 3;
                } else this.feaTexInfo[0] = this.feaTexInfo[1] = this.feaTexInfo[2] = this.feaTexInfo[3] = 0;
            }
            if (h) {
                let e = h(this.options.zoom, g);
                ie(e) && (this.dynamicAttrs.aLineDxDy = 1, e = 0), Je(e) && (e = 0), this.feaLineDx = e;
            }
            if (c) {
                let e = c(this.options.zoom, g);
                ie(e) && (this.dynamicAttrs.aLineDxDy = 1, e = 0), Je(e) && (e = 0), this.feaLineDy = e;
            }
            if (u) {
                let e = u(this.options.zoom, g);
                ie(e) && (this.dynamicAttrs.aLinePatternAnimSpeed = 1, e = 0), Je(e) && (e = 0), 0 !== e && (this.properties.hasPatternAnim = 1), this.feaPatternAnimSpeed = e;
            }
            if (f) {
                let e = f(this.options.zoom, g);
                ie(e) && (this.dynamicAttrs.aLinePatternGap = 1, e = 0), Je(e) && (e = 0), this.feaLinePatternGap = e;
            }
            const x = this.options.EXTENT;
            let _ = p.geometry;
            if (x !== 1 / 0) {
                _ = [];
                const e = [];
                for(let t = 0; t < p.geometry.length; t++){
                    e[0] = p.geometry[t];
                    const n = Qs(e, -1, -1, x + 1, x + 1);
                    if (3 === p.type && n.length > 1) {
                        const e = n[0], t = n[n.length - 1];
                        Wo(e[0], t[t.length - 1]) && (n[0] = t.concat(e.slice(1)), n.length = n.length - 1);
                    }
                    _.push(...n);
                }
            }
            const v = this.needAltitudeAttribute() ? 2 : 3;
            for(let e = 0; e < _.length; e++){
                this.offset = this.data.aPosition.getLength() / v;
                const t = _[e];
                this._addLine(t, p, m, y, 2, 1.05);
            }
        }
        _hasPattern() {
            return this.iconAtlas && this.feaTexInfo[2] && this.feaTexInfo[3];
        }
        _addLine(e, t, n, i, r, s) {
            const o = this._hasPattern() || Uo(this.feaDash) || Uo(this.symbol.lineDasharray), a = this.options.isTube;
            a && (e = e.map((e)=>new To(e))), this.overscaling = 1;
            const l = this.options.EXTENT;
            if (this.distance = 0, this.scaledDistance = 0, this.totalDistance = 0, this.prevVertex = null, this.symbol.lineGradientProperty && t.properties && Ke(t.properties.mapbox_clip_start) && Ke(t.properties.mapbox_clip_end)) {
                this.clipStart = +t.properties.mapbox_clip_start, this.clipEnd = +t.properties.mapbox_clip_end;
                for(let t = 0; t < e.length - 1; t++)this.totalDistance += e[t].dist(e[t + 1]);
                this.updateScaledDistance();
            }
            const h = 3 === t.type && !e.clipped;
            let c = e.length;
            for(; c >= 2 && Wo(e[c - 1], e[c - 2]);)c--;
            let u = 0;
            for(; u < c - 1 && Wo(e[u], e[u + 1]);)u++;
            if (c < (h ? 3 : 2)) return;
            "bevel" === n && (r = 1.05);
            const f = this.overscaling <= 16 ? 15 * l / (512 * this.overscaling) : 0, d = {
                vertexLength: 0,
                primitiveLength: 0,
                currentNormal: null
            };
            let p, g, m, y, x;
            this.e1 = this.e2 = -1, h && (p = e[c - 2], x = e[u].sub(p)._unit()._perp()), this.ensureDataCapacity(n, c, 360, 2);
            for(let t = u; t < c; t++){
                if (m = t === c - 1 ? h ? e[u + 1] : void 0 : e[t + 1], m && Wo(e[t], m)) continue;
                x && (y = x), p && (g = p), p = e[t], m && p.x === m.x && p.y === m.y && (p.x += 1e-4), x = m ? m.sub(p)._unit()._perp() : y, d.dir = g ? p.sub(g)._unit() : m.sub(p)._unit(), y = y || x, d.currentNormal = y;
                let l = y.add(x);
                0 === l.x && 0 === l.y || l._unit();
                const _ = y.x * x.x + y.y * x.y, v = l.x * x.x + l.y * x.y, b = 0 !== v ? 1 / v : 1 / 0, A = 2 * Math.sqrt(2 - 2 * v), T = v < Ro && g && m, S = y.x * x.y - y.y * x.x > 0;
                if (!a && T && t > u) {
                    const e = p.dist(g);
                    if (e > 2 * f) {
                        const t = p.sub(p.sub(g)._mult(f / e)._round());
                        t.z = p.z, this.updateDistance(g, t), this.addCurrentVertex(t, y, 0, 0, d), g = t;
                    }
                }
                const w = g && m;
                d.middleVertex = w;
                let M = w ? n : h ? "butt" : i;
                if (w && "round" === M && (b < s ? M = "miter" : b <= 2 && (M = "fakeround")), "miter" === M && b > r && !a && (M = "bevel"), "bevel" === M && (b > 2 && (M = "flipbevel"), b < r && (M = "miter")), g && this.updateDistance(g, p), "miter" === M) a ? (this.addCurrentVertex(p, y, 0, 0, d), d.dir = m.sub(p)._unit(), this.addCurrentVertex(p, x, 0, 0, d)) : (l._mult(b), this.addCurrentVertex(p, l, 0, 0, d), o && (d.currentNormal = x, d.dir = m.sub(p)._unit(), this.addCurrentVertex(p, l, 0, 0, d)));
                else if ("flipbevel" === M) {
                    if (b > 100) l = x.mult(-1);
                    else {
                        const e = b * y.add(x).mag() / y.sub(x).mag();
                        l._perp()._mult(e * (S ? -1 : 1));
                    }
                    this.addCurrentVertex(p, l, 0, 0, d), this.addCurrentVertex(p, l.mult(-1), 0, 0, d);
                } else if ("bevel" === M || "fakeround" === M) {
                    const e = -Math.sqrt(b * b - 1), t = S ? e : 0, n = S ? 0 : e;
                    if (g && this.addCurrentVertex(p, y, t, n, d), "fakeround" === M) {
                        const e = Math.round(180 * A / Math.PI / 20);
                        for(let t = 1; t < e; t++){
                            let n = t / e;
                            if (.5 !== n) {
                                const e = n - .5;
                                n += n * e * (n - 1) * ((1.0904 + _ * (_ * (3.55645 - 1.43519 * _) - 3.2452)) * e * e + (.848013 + _ * (.215638 * _ - 1.06021)));
                            }
                            const i = x.sub(y)._mult(n)._add(y)._unit()._mult(S ? -1 : 1);
                            this.addHalfVertex(p, i.x, i.y, !1, S, 0, d);
                        }
                    }
                    m && (d.currentNormal = x, d.dir = m.sub(p)._unit(), this.addCurrentVertex(p, x, -t, -n, d));
                } else if ("butt" === M) this.addCurrentVertex(p, l, 0, 0, d);
                else if ("square" === M) {
                    const e = g ? 1 : -1;
                    this.addCurrentVertex(p, l, e, e, d);
                } else "round" === M && (g && (this.addCurrentVertex(p, y, 0, 0, d), this.addCurrentVertex(p, y, 1, 1, d, !0)), m && (this.addCurrentVertex(p, x, -1, -1, d, !0), this.addCurrentVertex(p, x, 0, 0, d)));
                if (!a && T && t < c - 1) {
                    const e = p.dist(m);
                    if (e > 2 * f) {
                        const t = p.add(m.sub(p)._mult(f / e)._round());
                        t.z = p.z, this.updateDistance(p, t), this.addCurrentVertex(t, x, 0, 0, d), p = t;
                    }
                }
            }
        }
        ensureDataCapacity(e, t, n, i) {
            const r = "round" === e ? Math.round(n / 20) - 1 : 0;
            super.ensureDataCapacity((6 + r) * i, t);
        }
        addCurrentVertex(e, t, n, i, r, s = !1) {
            const o = t.x + t.y * n, a = t.y - t.x * n, l = -t.x + t.y * i, h = -t.y - t.x * i;
            let c = 0, u = 0;
            if (r.middleVertex) {
                Do.x = o, Do.y = a;
                const e = r.currentNormal;
                if (c = jo(e, Do, r.dir), 0 === n && 0 === i) u = -c;
                else {
                    const t = Lo;
                    t.x = e.x, t.y = e.y, t._mult(-1), Ho.x = l, Ho.y = h, u = jo(t, Ho, r.dir);
                }
            }
            this.addHalfVertex(e, o, a, s, !1, n, r, c), this.addHalfVertex(e, l, h, s, !0, -i, r, u), this.prevVertex && Wo(e, this.prevVertex) || (this.prevVertex = e), this.distance > Eo / 2 && 0 === this.totalDistance && (this.distance = 0, this.updateScaledDistance(), this.addCurrentVertex(e, t, n, i, r, s));
        }
        addHalfVertex({ x: e, y: t, z: n }, i, r, s, o, a, l, h) {
            const c = 1 * this.scaledDistance;
            this.fillData(this.data, e, t, n || 0, i, r, s, o, c, h);
            const u = l.vertexLength++;
            this.e1 >= 0 && this.e2 >= 0 && (this.addElements(this.e1, this.e2, u), l.primitiveLength++), o ? this.e2 = u : this.e1 = u;
        }
        fillData(e, t, n, i, r, s, o, a, l, h) {
            const { lineWidthFn: c, lineStrokeWidthFn: u, lineStrokeColorFn: f, lineColorFn: d, lineOpacityFn: p, lineDxFn: g, lineDyFn: m, linePatternAnimSpeedFn: y, linePatternGapFn: x } = this._fnTypes;
            this.fillPosition(e, t, n, i);
            let _ = Oo * r;
            _ = (Math.sign(_) || 1) * ((Math.floor(Math.abs(_)) >> 1 << 1) + +o);
            let v = Oo * s;
            v = (Math.sign(v) || 1) * ((Math.floor(Math.abs(v)) >> 1 << 1) + +a);
            let b = e.aExtrude.currentIndex;
            e.aExtrude[b++] = _, e.aExtrude[b++] = v, (this.iconAtlas || this.hasDasharray) && (e.aExtrude[b++] = Oo * h), e.aExtrude.currentIndex = b, b = e.aLinesofar.currentIndex, e.aLinesofar[b++] = l, e.aLinesofar.currentIndex = b, c && (b = e.aLineWidth.currentIndex, e.aLineWidth[b++] = Math.round(2 * this.feaLineWidth), e.aLineWidth.currentIndex = b), u && (b = e.aLineStrokeWidth.currentIndex, e.aLineStrokeWidth[b++] = Math.round(2 * this.feaLineStrokeWidth), e.aLineStrokeWidth.currentIndex = b), d && (b = e.aColor.currentIndex, e.aColor[b++] = this.feaColor[0], e.aColor[b++] = this.feaColor[1], e.aColor[b++] = this.feaColor[2], e.aColor[b++] = this.feaColor[3], e.aColor.currentIndex = b), f && (b = e.aStrokeColor.currentIndex, e.aStrokeColor[b++] = this.feaStrokeColor[0], e.aStrokeColor[b++] = this.feaStrokeColor[1], e.aStrokeColor[b++] = this.feaStrokeColor[2], e.aStrokeColor[b++] = this.feaStrokeColor[3], e.aStrokeColor.currentIndex = b), p && (b = e.aOpacity.currentIndex, e.aOpacity[b++] = this.feaOpacity, e.aOpacity.currentIndex = b), this.dasharrayFn && (b = e.aDasharray.currentIndex, e.aDasharray[b++] = this.feaDash[0], e.aDasharray[b++] = this.feaDash[1], e.aDasharray[b++] = this.feaDash[2], e.aDasharray[b++] = this.feaDash[3], e.aDasharray.currentIndex = b), this.dashColorFn && (b = e.aDashColor.currentIndex, e.aDashColor[b++] = this.feaDashColor[0], e.aDashColor[b++] = this.feaDashColor[1], e.aDashColor[b++] = this.feaDashColor[2], e.aDashColor[b++] = this.feaDashColor[3], e.aDashColor.currentIndex = b), this.iconAtlas && (b = e.aTexInfo.currentIndex, e.aTexInfo[b++] = this.feaTexInfo[0], e.aTexInfo[b++] = this.feaTexInfo[1], e.aTexInfo[b++] = this.feaTexInfo[2], e.aTexInfo[b++] = this.feaTexInfo[3], e.aTexInfo.currentIndex = b), (g || m) && (b = e.aLineDxDy.currentIndex, e.aLineDxDy[b++] = this.feaLineDx || 0, e.aLineDxDy[b++] = this.feaLineDy || 0, e.aLineDxDy.currentIndex = b), (y || x) && (b = e.aLinePattern.currentIndex, e.aLinePattern[b++] = 127 * (this.feaPatternAnimSpeed || 0), e.aLinePattern[b++] = 10 * (this.feaLinePatternGap || 0), e.aLinePattern.currentIndex = b), this.maxPos = Math.max(this.maxPos, Math.abs(t) + 1, Math.abs(n) + 1);
        }
        addElements(e, t, n) {
            super.addElements(this.offset + e, this.offset + t, this.offset + n);
        }
        _filterPolygonEdges(e) {
            const t = this.options.EXTENT, n = this.elements;
            for(let i = 0; i < n.length; i += 3)if (t === 1 / 0 || !Vo(this.data.aPosition, n[i], n[i + 1], 3, t) && !Vo(this.data.aPosition, n[i + 1], n[i + 2], 3, t)) {
                let t = e.currentIndex;
                e[t++] = n[i], e[t++] = n[i + 1], e[t++] = n[i + 2], e.currentIndex = t;
            }
        }
        _filterLine(e) {
            if (e.length <= 1) return e;
            const t = [], n = this.options.EXTENT;
            let i, r = !0;
            for(i = 0; i < e.length - 1; i++){
                const s = zo(e[i], e[i + 1], n);
                s && r || (t.push(e[i]), r = s);
            }
            return r || t.push(e[i]), t;
        }
        updateDistance(e, t) {
            if (this.options.isTube) {
                const n = e.dist(t), i = ot(this.options) * (t.z - e.z);
                this.distance += Math.sqrt(n * n + i * i);
            } else this.distance += e.dist(t);
            this.updateScaledDistance();
        }
        updateScaledDistance() {
            this.scaledDistance = this.totalDistance > 0 ? (this.clipStart + (this.clipEnd - this.clipStart) * this.distance / this.totalDistance) * (Eo - 1) : this.distance;
        }
    }
    function zo(e, t, n) {
        return n !== 1 / 0 && (e.x < 0 && t.x < 0 || e.x > n && t.x > n || e.y < 0 && t.y < 0 || e.y > n && t.y > n);
    }
    function Vo(e, t, n, i, r) {
        if (r === 1 / 0) return !1;
        const s = Math.floor(.5 * e[t * i]), o = Math.floor(.5 * e[t * i + 1]), a = Math.floor(.5 * e[n * i]), l = Math.floor(.5 * e[n * i + 1]);
        return s === a && (s < 0 || s > r) && o !== l || o === l && (o < 0 || o > r) && s !== a;
    }
    function Uo(e) {
        if (!Array.isArray(e)) return !1;
        for(let t = 0; t < e.length; t++)if (e[t]) return !0;
        return !1;
    }
    const Bo = [], Go = [];
    function jo(e, t, n) {
        const i = e.mag(), r = t.mag();
        Fo(Bo, n.x, n.y), Fo(Go, t.x, t.y);
        const s = (a = Go, (o = Bo)[0] * a[0] + o[1] * a[1]);
        var o, a;
        return -Math.sign(s) * Math.sqrt(r * r - i * i);
    }
    function Wo(e, t) {
        return e.equals(t) && e.z === t.z;
    }
    var Xo = "undefined" != typeof Float32Array ? Float32Array : Array;
    function Yo(e, t, n, i) {
        return e[0] = t, e[1] = n, e[2] = i, e;
    }
    var Zo = function(e, t, n) {
        return e[0] = t[0] - n[0], e[1] = t[1] - n[1], e[2] = t[2] - n[2], e;
    };
    !function() {
        var e = new Xo(3);
        Xo != Float32Array && (e[0] = 0, e[1] = 0, e[2] = 0);
    }();
    const qo = [], $o = [], Jo = [], Ko = [], Qo = [], ea = [], ta = [], na = [];
    function ia(e, t, n, i, r, s) {
        Yo(Qo, e[3 * t], e[3 * t + 1], e[3 * t + 2]), Yo(ea, e[3 * n], e[3 * n + 1], e[3 * n + 2]), Yo(ta, e[3 * i], e[3 * i + 1], e[3 * i + 2]);
        const o = Zo($o, ta, ea), a = Zo(Jo, Qo, ea), l = function(e, t, n) {
            var i = t[0], r = t[1], s = t[2], o = n[0], a = n[1], l = n[2];
            return e[0] = r * l - s * a, e[1] = s * o - i * l, e[2] = i * a - r * o, e;
        }(Ko, o, a);
        !function(e, t) {
            var n = t[0], i = t[1], r = t[2], s = n * n + i * i + r * r;
            s > 0 && (s = 1 / Math.sqrt(s), e[0] = t[0] * s, e[1] = t[1] * s, e[2] = t[2] * s);
        }(na, l), r[3 * t] = r[3 * t] || 0, r[3 * n] = r[3 * n] || 0, r[3 * i] = r[3 * i] || 0, r[3 * t + 1] = r[3 * t + 1] || 0, r[3 * n + 1] = r[3 * n + 1] || 0, r[3 * i + 1] = r[3 * i + 1] || 0, r[3 * t + 2] = r[3 * t + 2] || 0, r[3 * n + 2] = r[3 * n + 2] || 0, r[3 * i + 2] = r[3 * i + 2] || 0, r[3 * t] += na[0], r[3 * n] += na[0], r[3 * i] += na[0], r[3 * t + 1] += na[1], r[3 * n + 1] += na[1], r[3 * i + 1] += na[1], r[3 * t + 2] += na[2], r[3 * n + 2] += na[2], r[3 * i + 2] += na[2], s[t] += 1, s[n] += 1, s[i] += 1;
    }
    const ra = Math.pow(2, 16) / 1, sa = 45 * Math.PI / 100;
    function oa(e, t, n = 2) {
        const i = t && t.length, r = i ? t[0] * n : e.length;
        let s = aa(e, 0, r, n, !0);
        const o = [];
        if (!s || s.next === s.prev) return o;
        let a, l, h;
        if (i && (s = function(e, t, n, i) {
            const r = [];
            for(let n = 0, s = t.length; n < s; n++){
                const o = aa(e, t[n] * i, n < s - 1 ? t[n + 1] * i : e.length, i, !1);
                o === o.next && (o.steiner = !0), r.push(xa(o));
            }
            r.sort(pa);
            for(let e = 0; e < r.length; e++)n = ga(r[e], n);
            return n;
        }(e, t, s, n)), e.length > 80 * n) {
            a = 1 / 0, l = 1 / 0;
            let t = -1 / 0, i = -1 / 0;
            for(let s = n; s < r; s += n){
                const n = e[s], r = e[s + 1];
                n < a && (a = n), r < l && (l = r), n > t && (t = n), r > i && (i = r);
            }
            h = Math.max(t - a, i - l), h = 0 !== h ? 32767 / h : 0;
        }
        return ha(s, o, n, a, l, h, 0), o;
    }
    function aa(e, t, n, i, r) {
        let s;
        if (r === function(e, t, n, i) {
            let r = 0;
            for(let s = t, o = n - i; s < n; s += i)r += (e[o] - e[s]) * (e[s + 1] + e[o + 1]), o = s;
            return r;
        }(e, t, n, i) > 0) for(let r = t; r < n; r += i)s = Ca(r / i | 0, e[r], e[r + 1], s);
        else for(let r = n - i; r >= t; r -= i)s = Ca(r / i | 0, e[r], e[r + 1], s);
        return s && Ta(s, s.next) && (ka(s), s = s.next), s;
    }
    function la(e, t) {
        if (!e) return e;
        t || (t = e);
        let n, i = e;
        do if (n = !1, i.steiner || !Ta(i, i.next) && 0 !== Aa(i.prev, i, i.next)) i = i.next;
        else {
            if (ka(i), i = t = i.prev, i === i.next) break;
            n = !0;
        }
        while (n || i !== t);
        return t;
    }
    function ha(e, t, n, i, r, s, o) {
        if (!e) return;
        !o && s && function(e, t, n, i) {
            let r = e;
            do 0 === r.z && (r.z = ya(r.x, r.y, t, n, i)), r.prevZ = r.prev, r.nextZ = r.next, r = r.next;
            while (r !== e);
            r.prevZ.nextZ = null, r.prevZ = null, function(e) {
                let t, n = 1;
                do {
                    let i, r = e;
                    e = null;
                    let s = null;
                    for(t = 0; r;){
                        t++;
                        let o = r, a = 0;
                        for(let e = 0; e < n && (a++, o = o.nextZ, o); e++);
                        let l = n;
                        for(; a > 0 || l > 0 && o;)0 !== a && (0 === l || !o || r.z <= o.z) ? (i = r, r = r.nextZ, a--) : (i = o, o = o.nextZ, l--), s ? s.nextZ = i : e = i, i.prevZ = s, s = i;
                        r = o;
                    }
                    s.nextZ = null, n *= 2;
                }while (t > 1);
            }(r);
        }(e, i, r, s);
        let a = e;
        for(; e.prev !== e.next;){
            const l = e.prev, h = e.next;
            if (s ? ua(e, i, r, s) : ca(e)) t.push(l.i, e.i, h.i), ka(e), e = h.next, a = h.next;
            else if ((e = h) === a) {
                o ? 1 === o ? ha(e = fa(la(e), t), t, n, i, r, s, 2) : 2 === o && da(e, t, n, i, r, s) : ha(la(e), t, n, i, r, s, 1);
                break;
            }
        }
    }
    function ca(e) {
        const t = e.prev, n = e, i = e.next;
        if (Aa(t, n, i) >= 0) return !1;
        const r = t.x, s = n.x, o = i.x, a = t.y, l = n.y, h = i.y, c = Math.min(r, s, o), u = Math.min(a, l, h), f = Math.max(r, s, o), d = Math.max(a, l, h);
        let p = i.next;
        for(; p !== t;){
            if (p.x >= c && p.x <= f && p.y >= u && p.y <= d && va(r, a, s, l, o, h, p.x, p.y) && Aa(p.prev, p, p.next) >= 0) return !1;
            p = p.next;
        }
        return !0;
    }
    function ua(e, t, n, i) {
        const r = e.prev, s = e, o = e.next;
        if (Aa(r, s, o) >= 0) return !1;
        const a = r.x, l = s.x, h = o.x, c = r.y, u = s.y, f = o.y, d = Math.min(a, l, h), p = Math.min(c, u, f), g = Math.max(a, l, h), m = Math.max(c, u, f), y = ya(d, p, t, n, i), x = ya(g, m, t, n, i);
        let _ = e.prevZ, v = e.nextZ;
        for(; _ && _.z >= y && v && v.z <= x;){
            if (_.x >= d && _.x <= g && _.y >= p && _.y <= m && _ !== r && _ !== o && va(a, c, l, u, h, f, _.x, _.y) && Aa(_.prev, _, _.next) >= 0) return !1;
            if (_ = _.prevZ, v.x >= d && v.x <= g && v.y >= p && v.y <= m && v !== r && v !== o && va(a, c, l, u, h, f, v.x, v.y) && Aa(v.prev, v, v.next) >= 0) return !1;
            v = v.nextZ;
        }
        for(; _ && _.z >= y;){
            if (_.x >= d && _.x <= g && _.y >= p && _.y <= m && _ !== r && _ !== o && va(a, c, l, u, h, f, _.x, _.y) && Aa(_.prev, _, _.next) >= 0) return !1;
            _ = _.prevZ;
        }
        for(; v && v.z <= x;){
            if (v.x >= d && v.x <= g && v.y >= p && v.y <= m && v !== r && v !== o && va(a, c, l, u, h, f, v.x, v.y) && Aa(v.prev, v, v.next) >= 0) return !1;
            v = v.nextZ;
        }
        return !0;
    }
    function fa(e, t) {
        let n = e;
        do {
            const i = n.prev, r = n.next.next;
            !Ta(i, r) && Sa(i, n, n.next, r) && Pa(i, r) && Pa(r, i) && (t.push(i.i, n.i, r.i), ka(n), ka(n.next), n = e = r), n = n.next;
        }while (n !== e);
        return la(n);
    }
    function da(e, t, n, i, r, s) {
        let o = e;
        do {
            let e = o.next.next;
            for(; e !== o.prev;){
                if (o.i !== e.i && ba(o, e)) {
                    let a = Ia(o, e);
                    return o = la(o, o.next), a = la(a, a.next), ha(o, t, n, i, r, s, 0), void ha(a, t, n, i, r, s, 0);
                }
                e = e.next;
            }
            o = o.next;
        }while (o !== e);
    }
    function pa(e, t) {
        let n = e.x - t.x;
        return 0 === n && (n = e.y - t.y, 0 === n) && (n = (e.next.y - e.y) / (e.next.x - e.x) - (t.next.y - t.y) / (t.next.x - t.x)), n;
    }
    function ga(e, t) {
        const n = function(e, t) {
            let n = t;
            const i = e.x, r = e.y;
            let s, o = -1 / 0;
            if (Ta(e, n)) return n;
            do {
                if (Ta(e, n.next)) return n.next;
                if (r <= n.y && r >= n.next.y && n.next.y !== n.y) {
                    const e = n.x + (r - n.y) * (n.next.x - n.x) / (n.next.y - n.y);
                    if (e <= i && e > o && (o = e, s = n.x < n.next.x ? n : n.next, e === i)) return s;
                }
                n = n.next;
            }while (n !== t);
            if (!s) return null;
            const a = s, l = s.x, h = s.y;
            let c = 1 / 0;
            n = s;
            do {
                if (i >= n.x && n.x >= l && i !== n.x && _a(r < h ? i : o, r, l, h, r < h ? o : i, r, n.x, n.y)) {
                    const t = Math.abs(r - n.y) / (i - n.x);
                    Pa(n, e) && (t < c || t === c && (n.x > s.x || n.x === s.x && ma(s, n))) && (s = n, c = t);
                }
                n = n.next;
            }while (n !== a);
            return s;
        }(e, t);
        if (!n) return t;
        const i = Ia(n, e);
        return la(i, i.next), la(n, n.next);
    }
    function ma(e, t) {
        return Aa(e.prev, e, t.prev) < 0 && Aa(t.next, e, e.next) < 0;
    }
    function ya(e, t, n, i, r) {
        return (e = 1431655765 & ((e = 858993459 & ((e = 252645135 & ((e = 16711935 & ((e = (e - n) * r | 0) | e << 8)) | e << 4)) | e << 2)) | e << 1)) | (t = 1431655765 & ((t = 858993459 & ((t = 252645135 & ((t = 16711935 & ((t = (t - i) * r | 0) | t << 8)) | t << 4)) | t << 2)) | t << 1)) << 1;
    }
    function xa(e) {
        let t = e, n = e;
        do (t.x < n.x || t.x === n.x && t.y < n.y) && (n = t), t = t.next;
        while (t !== e);
        return n;
    }
    function _a(e, t, n, i, r, s, o, a) {
        return (r - o) * (t - a) >= (e - o) * (s - a) && (e - o) * (i - a) >= (n - o) * (t - a) && (n - o) * (s - a) >= (r - o) * (i - a);
    }
    function va(e, t, n, i, r, s, o, a) {
        return !(e === o && t === a) && _a(e, t, n, i, r, s, o, a);
    }
    function ba(e, t) {
        return e.next.i !== t.i && e.prev.i !== t.i && !function(e, t) {
            let n = e;
            do {
                if (n.i !== e.i && n.next.i !== e.i && n.i !== t.i && n.next.i !== t.i && Sa(n, n.next, e, t)) return !0;
                n = n.next;
            }while (n !== e);
            return !1;
        }(e, t) && (Pa(e, t) && Pa(t, e) && function(e, t) {
            let n = e, i = !1;
            const r = (e.x + t.x) / 2, s = (e.y + t.y) / 2;
            do n.y > s != n.next.y > s && n.next.y !== n.y && r < (n.next.x - n.x) * (s - n.y) / (n.next.y - n.y) + n.x && (i = !i), n = n.next;
            while (n !== e);
            return i;
        }(e, t) && (Aa(e.prev, e, t.prev) || Aa(e, t.prev, t)) || Ta(e, t) && Aa(e.prev, e, e.next) > 0 && Aa(t.prev, t, t.next) > 0);
    }
    function Aa(e, t, n) {
        return (t.y - e.y) * (n.x - t.x) - (t.x - e.x) * (n.y - t.y);
    }
    function Ta(e, t) {
        return e.x === t.x && e.y === t.y;
    }
    function Sa(e, t, n, i) {
        const r = Ma(Aa(e, t, n)), s = Ma(Aa(e, t, i)), o = Ma(Aa(n, i, e)), a = Ma(Aa(n, i, t));
        return r !== s && o !== a || !(0 !== r || !wa(e, n, t)) || !(0 !== s || !wa(e, i, t)) || !(0 !== o || !wa(n, e, i)) || !(0 !== a || !wa(n, t, i));
    }
    function wa(e, t, n) {
        return t.x <= Math.max(e.x, n.x) && t.x >= Math.min(e.x, n.x) && t.y <= Math.max(e.y, n.y) && t.y >= Math.min(e.y, n.y);
    }
    function Ma(e) {
        return e > 0 ? 1 : e < 0 ? -1 : 0;
    }
    function Pa(e, t) {
        return Aa(e.prev, e, e.next) < 0 ? Aa(e, t, e.next) >= 0 && Aa(e, e.prev, t) >= 0 : Aa(e, t, e.prev) < 0 || Aa(e, e.next, t) < 0;
    }
    function Ia(e, t) {
        const n = Fa(e.i, e.x, e.y), i = Fa(t.i, t.x, t.y), r = e.next, s = t.prev;
        return e.next = t, t.prev = e, n.next = r, r.prev = n, i.next = n, n.prev = i, s.next = i, i.prev = s, i;
    }
    function Ca(e, t, n, i) {
        const r = Fa(e, t, n);
        return i ? (r.next = i.next, r.prev = i, i.next.prev = r, i.next = r) : (r.prev = r, r.next = r), r;
    }
    function ka(e) {
        e.next.prev = e.prev, e.prev.next = e.next, e.prevZ && (e.prevZ.nextZ = e.nextZ), e.nextZ && (e.nextZ.prevZ = e.prevZ);
    }
    function Fa(e, t, n) {
        return {
            i: e,
            x: t,
            y: n,
            prev: null,
            next: null,
            z: 0,
            prevZ: null,
            nextZ: null,
            steiner: !1
        };
    }
    const Oa = [], Ra = [];
    function Ea(e, t) {
        var n, i, r, o, a, l, h;
        for(i = 1; i <= 8; i *= 2){
            for(n = [], o = !(La(r = e[e.length - 1], t) & i), a = 0; a < e.length; a++){
                if ((h = !(La(l = e[a], t) & i)) !== o) {
                    const e = Da(r, l, i, t);
                    void 0 !== l.x ? n.push(new s(e[0], e[1])) : n.push(e);
                }
                h && n.push(l), r = l, o = h;
            }
            if (!(e = n).length) break;
        }
        return n;
    }
    function Da(e, t, n, i) {
        return Oa[0] = void 0 === e.x ? e[0] : e.x, Oa[1] = void 0 === e.y ? e[1] : e.y, e = Oa, Ra[0] = void 0 === t.x ? t[0] : t.x, Ra[1] = void 0 === t.y ? t[1] : t.y, t = Ra, 8 & n ? [
            e[0] + (t[0] - e[0]) * (i[3] - e[1]) / (t[1] - e[1]),
            i[3]
        ] : 4 & n ? [
            e[0] + (t[0] - e[0]) * (i[1] - e[1]) / (t[1] - e[1]),
            i[1]
        ] : 2 & n ? [
            i[2],
            e[1] + (t[1] - e[1]) * (i[2] - e[0]) / (t[0] - e[0])
        ] : 1 & n ? [
            i[0],
            e[1] + (t[1] - e[1]) * (i[0] - e[0]) / (t[0] - e[0])
        ] : null;
    }
    function La(e, t) {
        Oa[0] = void 0 === e.x ? e[0] : e.x, Oa[1] = void 0 === e.y ? e[1] : e.y;
        var n = 0;
        return (e = Oa)[0] < t[0] ? n |= 1 : e[0] > t[2] && (n |= 2), e[1] < t[1] ? n |= 4 : e[1] > t[3] && (n |= 8), n;
    }
    const Ha = [
        0,
        0,
        0,
        0
    ], Na = -9999999, za = [
        {
            type: Int16Array,
            width: 3,
            name: "aPosition"
        }
    ];
    class Va extends No {
        constructor(e, t, n){
            (t = $e({}, t)).lineJoin = "miter", t.lineCap = "butt", super(e, t, n), this.options.radialSegments % 2 == 1 && this.options.radialSegments--;
        }
        getFormat() {
            const { lineWidthFn: e, lineColorFn: t, lineOpacityFn: n, linePatternAnimSpeedFn: i, linePatternGapFn: r } = this._fnTypes, s = [
                ...this.getPositionFormat(),
                {
                    type: Int8Array,
                    width: 4,
                    name: "aTubeNormal"
                },
                {
                    type: this.options.positionType || Uint16Array,
                    width: 1,
                    name: "aLinesofar"
                }
            ];
            if (this.iconAtlas) {
                s.push({
                    type: Int8Array,
                    width: 1,
                    name: "aNormalDistance"
                });
                const e = this.getIconAtlasMaxValue();
                s.push({
                    type: e > 255 ? Uint16Array : Uint8Array,
                    width: 4,
                    name: "aTexInfo"
                });
            }
            return e && s.push({
                type: Uint16Array,
                width: 1,
                name: "aLineWidth"
            }), t && s.push({
                type: Uint8Array,
                width: 4,
                name: "aColor"
            }), n && s.push({
                type: Uint8Array,
                width: 1,
                name: "aOpacity"
            }), i && s.push({
                type: Int8Array,
                width: 1,
                name: "aLinePatternAnimSpeed"
            }), r && s.push({
                type: Int8Array,
                width: 1,
                name: "aLinePatternGap"
            }), s;
        }
        ensureDataCapacity(e, t, n, i) {
            const r = this.options.radialSegments / 2;
            return super.ensureDataCapacity(e, t, n, i * r);
        }
        addHalfVertex(e, t, n, i, r, s, o, a) {
            const { x: l, y: h, z: c } = e, u = 1 * this.scaledDistance, f = this.options.radialSegments / 2, { x: d, y: p, z: g } = o.dir, m = function(e, t, n, i, r, s, o, a) {
                Mo(Ua, n, i, r), Mo(Ba, s, o, 0), Io(Ga, Ua, Ba), Po(Ba, Ba), Po(Ga, Ga), ja[t] || (ja[t] = []);
                const l = ja[t];
                for(var h = 0; h < t; h++){
                    const e = Math.PI * h / t, n = 0, i = 1 - Math.abs(e - n) / (Math.PI / 2);
                    l[h] = l[h] || [], Wa(Ba, Ga, l[h], 1, e, i * (a ? -1 : 1));
                }
                return l;
            }(0, f, d, p, g, t, n, r);
            this.prevVertex && this.fillTubeElements(r), this.fillData(this.data, l, h, c || 0, m, r, u, a);
        }
        fillTubeElements(e) {
            const t = this.options.radialSegments / 2, n = this.needAltitudeAttribute() ? 2 : 3, i = this.data.aPosition.getLength() / n;
            for(let n = 0; n < t; n++){
                const r = n + i, s = n + i - 2 * t;
                let o, a;
                n === t - 1 && e ? (o = n + i - 2 * t + 1, a = n + i - 2 * t - 2 * t + 1) : (o = n + i + 1, a = n + i + 1 - 2 * t), super.addElements(r - this.offset, o - this.offset, s - this.offset), super.addElements(s - this.offset, o - this.offset, a - this.offset);
            }
        }
        fillData(e, t, n, i, r, s, o, a) {
            const { lineWidthFn: l, lineColorFn: h, lineOpacityFn: c, linePatternAnimSpeedFn: u, linePatternGapFn: f } = this._fnTypes, d = r.length;
            for(let s = 0; s < d; s++){
                this.fillPosition(e, t, n, i), ko(r[s], r[s], Oo);
                let d = e.aTubeNormal.currentIndex;
                for(let t = 0; t < r[s].length; t++)e.aTubeNormal[d++] = r[s][t];
                if (e.aTubeNormal.currentIndex = d, d = e.aLinesofar.currentIndex, e.aLinesofar[d++] = o, e.aLinesofar.currentIndex = d, this.iconAtlas && (d = e.aNormalDistance.currentIndex, e.aNormalDistance[d++] = Oo * a, e.aNormalDistance.currentIndex = d, d = e.aTexInfo.currentIndex, e.aTexInfo[d++] = this.feaTexInfo[0], e.aTexInfo[d++] = this.feaTexInfo[1], e.aTexInfo[d++] = this.feaTexInfo[2], e.aTexInfo[d++] = this.feaTexInfo[3], e.aTexInfo.currentIndex = d), l) {
                    const t = at(this.options.metric);
                    let n = this.feaLineWidth * t;
                    isNaN(n) && (n = 0), d = e.aLineWidth.currentIndex, e.aLineWidth[d++] = Math.round(n), e.aLineWidth.currentIndex = d;
                }
                h && (d = e.aColor.currentIndex, e.aColor[d++] = this.feaColor[0], e.aColor[d++] = this.feaColor[1], e.aColor[d++] = this.feaColor[2], e.aColor[d++] = this.feaColor[3], e.aColor.currentIndex = d), c && (d = e.aOpacity.currentIndex, e.aOpacity[d++] = this.feaOpacity, e.aOpacity.currentIndex = d), u && (d = e.aLinePatternAnimSpeed.currentIndex, e.aLinePatternAnimSpeed[d++] = 127 * (this.feaPatternAnimSpeed || 0), e.aLinePatternAnimSpeed.currentIndex = d), f && (d = e.aLinePatternGap.currentIndex, e.aLinePatternGap[d++] = 10 * (this.feaLinePatternGap || 0), e.aLinePatternGap.currentIndex = d);
            }
            this.maxPos = Math.max(this.maxPos, Math.abs(t) + 1, Math.abs(n) + 1);
        }
        createDataPack(e, t) {
            const n = super.createDataPack(e, t);
            return n && (n.is2D = !1), n;
        }
    }
    const Ua = [], Ba = [], Ga = [], ja = {};
    function Wa(e, t, n, i, r, s) {
        return Co(n, i * (Math.cos(r) * e[0] + Math.sin(r) * t[0]), i * (Math.cos(r) * e[1] + Math.sin(r) * t[1]), i * (Math.cos(r) * e[2] + Math.sin(r) * t[2]), s), n;
    }
    const Xa = [], Ya = [], Za = [], qa = [], $a = [];
    function Ja(e, t, n, i, r, s, o, a) {
        Mo(Ya, n, i, r), Mo(Za, s, o, 0), Io(qa, Ya, Za), Po(Za, Za), Po(qa, qa), Fo(Xa, e, t);
        const l = function(e) {
            var t = e[0], n = e[1];
            return Math.hypot(t, n);
        }(Xa) / e, h = Math.atan(t / e);
        let c = Math.PI / 2 + (Math.PI / 2 - h);
        return $a[0] || ($a[0] = []), Wa(Za, qa, $a[0], l, c, a ? 1 : -1), c += 2 * h, $a[1] || ($a[1] = []), Wa(Za, qa, $a[1], l, c, a ? 1 : -1), $a;
    }
    class Ka {
        constructor(e){
            this.max = e, this.reset();
        }
        reset() {
            return this.data = {}, this.order = [], this;
        }
        clear() {
            this.reset();
        }
        add(e, t) {
            return this.has(e) ? (this.order.splice(this.order.indexOf(e), 1), this.data[e] = t, this.order.push(e)) : (this.data[e] = t, this.order.push(e), this.order.length > this.max && this.getAndRemove(this.order[0])), this;
        }
        has(e) {
            return e in this.data;
        }
        keys() {
            return this.order;
        }
        getAndRemove(e) {
            if (!this.has(e)) return null;
            const t = this.data[e];
            return delete this.data[e], this.order.splice(this.order.indexOf(e), 1), t;
        }
        get(e) {
            return this.has(e) ? this.data[e] : null;
        }
        remove(e) {
            return this.has(e) ? (delete this.data[e], this.order.splice(this.order.indexOf(e), 1), this) : this;
        }
        setMaxSize(e) {
            for(this.max = e; this.order.length > this.max;)this.getAndRemove(this.order[0]);
            return this;
        }
    }
    /*!
	 * based on @mapbox/tiny-sdf
	 * https://github.com/mapbox/tiny-sdf
	 * @License BSD 2-Clause
	 */ var Qa = 1e20;
    function el(e, t, n, i, r, s, o) {
        this.fontSize = e || 24, this.buffer = void 0 === t ? 3 : t, this.cutoff = i || .25, this.fontFamily = r || "sans-serif", this.fontWeight = s || "normal", this.fontStyle = o || "normal", this.radius = n || 8;
        var a = this.size = this.fontSize + 2 * this.buffer;
        this.canvas = "undefined" == typeof document ? new OffscreenCanvas(a, a) : document.createElement("canvas"), this.canvas.width = this.canvas.height = a, this.ctx = this.canvas.getContext("2d", {
            willReadFrequently: !0
        }), this.ctx.font = this.fontStyle + " " + this.fontWeight + " " + this.fontSize + "px " + this.fontFamily, this.ctx.textBaseline = "middle", this.ctx.fillStyle = "black", this.gridOuter = new Float64Array(a * a), this.gridInner = new Float64Array(a * a), this.f = new Float64Array(a), this.z = new Float64Array(a + 1), this.v = new Uint16Array(a), this.middle = Math.round(a / 2 * (navigator.userAgent.indexOf("Gecko/") >= 0 ? 1.2 : 1));
    }
    function tl(e, t, n, i, r, s) {
        for(var o = 0; o < t; o++)nl(e, o, t, n, i, r, s);
        for(var a = 0; a < n; a++)nl(e, a * t, 1, t, i, r, s);
    }
    function nl(e, t, n, i, r, s, o) {
        var a, l, h, c;
        for(s[0] = 0, o[0] = -Qa, o[1] = Qa, a = 0; a < i; a++)r[a] = e[t + a * n];
        for(a = 1, l = 0, h = 0; a < i; a++){
            do c = s[l], h = (r[a] - r[c] + a * a - c * c) / (a - c) / 2;
            while (h <= o[l] && --l > -1);
            s[++l] = a, o[l] = h, o[l + 1] = Qa;
        }
        for(a = 0, l = 0; a < i; a++){
            for(; o[l + 1] < a;)l++;
            c = s[l], e[t + a * n] = r[c] + (a - c) * (a - c);
        }
    }
    el.prototype.draw = function(e, t, n) {
        this.ctx.clearRect(0, 0, this.size, this.size), this.ctx.textBaseline = "top", this.ctx.fillText(e, this.buffer, this.buffer);
        for(var i = this.ctx.getImageData(0, 0, t, n), r = new Uint8ClampedArray(t * n), s = 0; s < t * n; s++){
            var o = i.data[4 * s + 3] / 255;
            this.gridOuter[s] = 1 === o ? 0 : 0 === o ? Qa : Math.pow(Math.max(0, .5 - o), 2), this.gridInner[s] = 1 === o ? Qa : 0 === o ? 0 : Math.pow(Math.max(0, o - .5), 2);
        }
        for(tl(this.gridOuter, t, n, this.f, this.v, this.z), tl(this.gridInner, t, n, this.f, this.v, this.z), s = 0; s < t * n; s++){
            var a = Math.sqrt(this.gridOuter[s]) - Math.sqrt(this.gridInner[s]);
            r[s] = Math.round(255 - 255 * (a / this.radius + this.cutoff));
        }
        return r;
    };
    let il = 0;
    function rl(e) {
        const t = {
            width: e.bitmap.width,
            height: e.bitmap.height,
            data: new Uint8ClampedArray(e.bitmap.data)
        };
        return {
            charCode: e.charCode,
            bitmap: t,
            metrics: $e({}, e.metrics)
        };
    }
    var sl = Object.freeze({
        __proto__: null,
        calculateSignedArea: b,
        clipPolygon: Ea,
        convertGeometry: N,
        convertRTLText: qs,
        generatePickingIndiceIndex: I,
        getFeaAltitudeAndHeight: S,
        getIndexArrayType: E,
        getPosArrayType: D,
        getUnsignedArrayType: L,
        packPosition: pt,
        unpackPosition: function(e, t, n, i) {
            const r = (Math.sign(t) || 1) * (Math.abs(t) % gt), s = (Math.sign(n) || 1) * (Math.abs(n) % gt), o = Math.floor(Math.abs(t) / gt), a = Math.floor(Math.abs(n) / gt);
            return e[0] = r, e[1] = s, e[2] = Math.sign(i + 1e-5) * (2 * o + a) * mt + i, e;
        }
    });
    const ol = {}, al = {}, ll = [];
    var hl = Object.freeze({
        __proto__: null,
        loadSymbolFnTypes: function e(t, n) {
            if (!t) return null;
            var i = !1;
            if (Array.isArray(t)) {
                var r, s = [];
                for(let o = 0; o < t.length; o++)(r = e(t[o], n)) ? (s.push(r), i = !0) : s.push(t[o]);
                return i ? s : t;
            }
            var o = {
                __fn_types_loaded: !0
            };
            const a = [];
            for(const e in t)it(t, e) && a.push(e);
            const l = function(e) {
                Object.defineProperty(o, e, {
                    get: function() {
                        return this["__fn_" + e] || (this["__fn_" + e] = re(this["_" + e])), this["__fn_" + e].apply(this, n());
                    },
                    set: function(t) {
                        this["_" + e] = t;
                    },
                    configurable: !0,
                    enumerable: !0
                });
            }, h = {}, c = function(e, t) {
                Object.defineProperty(o, e, {
                    get: function() {
                        this["__fn_" + e] || (this["__fn_" + e] = Wr(this["_" + e], t));
                        const i = n()[0];
                        h.zoom = i;
                        try {
                            return this["__fn_" + e].evaluateWithoutErrorHandling(h, ol, al, null, ll);
                        } catch (e) {
                            return null;
                        }
                    },
                    set: function(t) {
                        this["_" + e] = t;
                    },
                    configurable: !0,
                    enumerable: !0
                });
            };
            for(let e = 0, n = a.length; e < n; e++){
                const n = a[e];
                if (ie(t[n])) i = !0, o["_" + n] = t[n], l(n);
                else if (Xr(t[n])) {
                    i = !0;
                    const e = Jr(n);
                    o["_" + n] = t[n], c(n, e);
                } else o[n] = t[n];
            }
            return i ? o : t;
        }
    });
    const cl = {
        polygonPatternFile: 1,
        markerFile: 1,
        markerPlacement: 1,
        markerSpacing: 1,
        textName: 1,
        textFaceName: 1,
        textPlacement: 1,
        textSpacing: 1,
        lineJoin: 1,
        lineCap: 1,
        linePatternFile: 1
    }, ul = {
        visible: 1,
        textHorizontalAlignment: 1,
        textVerticalAlignment: 1,
        textWrapWidth: 1,
        markerHorizontalAlignment: 1,
        markerVerticalAlignment: 1
    }, fl = {
        lineDasharray: 1,
        topPolygonFill: 1,
        bottomPolygonFill: 1
    };
    Object.assign(ul, cl), Object.assign(fl, cl), e.ArrayPool = ss, e.CirclePack = class extends gs {
        getFormat() {
            return za;
        }
        placeVector(e, t) {
            const n = this._getAnchors(e, t);
            if (0 === n.length) return;
            const i = this.data, r = this.getAltitude(e.feature.properties);
            let s = i.aPosition.getLength() / za[0].width;
            for(let e = 0; e < n.length; e++){
                const t = n[e];
                i.aPosition.push(2 * t.x + 0, 2 * t.y + 0, r), i.aPosition.push(2 * t.x + 1, 2 * t.y + 0, r), i.aPosition.push(2 * t.x + 1, 2 * t.y + 1, r), i.aPosition.push(2 * t.x + 0, 2 * t.y + 1, r), this.addElements(s, s + 1, s + 2), this.addElements(s, s + 2, s + 3), s += 4;
                const o = Math.max(Math.abs(2 * t.x + 1), Math.abs(2 * t.y + 1));
                o > this.maxPos && (this.maxPos = o);
            }
        }
        _getAnchors(e, t) {
            const { feature: n, symbol: i } = e, r = this._getPlacement(e, i), s = n.properties, { markerSpacingFn: o } = this._fnTypes, a = ((o ? o(null, s) : i.markerSpacing) || 250) * t;
            return mo(e, null, null, t, this.options.EXTENT, r, a);
        }
        _getPlacement(e, t) {
            return this._fnTypes.markerPlacementFn ? this._fnTypes.markerPlacementFn(this.options.zoom, e.feature.properties) : t.markerPlacement;
        }
    }, e.DEFAULT_TEX_WIDTH = 23.25, e.FilterUtil = Kr, e.FuncTypeUtil = hl, e.GlyphRequestor = class {
        constructor(e, t = 15, n, i){
            this.entries = {}, this._cachedFont = {}, this._cache = new Ka(2048, function() {}), this._framer = e, this._limit = t, this._isCompactChars = n, this._sdfURL = i;
        }
        _isValidSDFURL(e) {
            return e && e.indexOf("{stack}") >= 0 && e.indexOf("{range}") > 0;
        }
        getGlyphs(e, t) {
            if (!e || !Object.keys(e).length) return void t(null, {
                glyphs: null
            });
            if (this._isValidSDFURL(this._sdfURL)) return void this._requestRemoteSDF(e, t);
            const n = this.entries, i = e.options;
            let r = !0;
            i && (r = !1 !== i.isCharsCompact), r = r || this._isCompactChars;
            const s = (i, s, a)=>{
                let l = 0, h = 0;
                for(const t in e)if ("options" !== t) {
                    n[t] = n[t] || {}, s[t] = s[t] || {};
                    for(const c in e[t]){
                        if (h++, h <= i) continue;
                        const e = r && !Os(+c), u = t + ":" + c + ":" + e;
                        let f;
                        if (this._cache.has(u) ? f = this._cache.get(u) : (f = this._tinySDF(n[t], t, c, e), this._cache.add(u, f), l++), f = rl(f), s[t][c] = f, a.push(f.bitmap.data.buffer), this._framer && l > this._limit) return void this._framer(o(h, s, a));
                    }
                }
                t(null, {
                    glyphs: s,
                    buffers: a
                });
            };
            function o(e, t, n) {
                return ()=>{
                    s(e, t, n);
                };
            }
            s(0, {}, []);
        }
        _requestRemoteSDF(e, t) {
            const n = [];
            for(const t in e)for (const i of e[t])n.push(this._requestGlyph(t, i));
            Promise.all(n).then((e)=>{
                t(null, e);
            });
        }
        _requestGlyph() {
            return Promise.resolve(null);
        }
        _tinySDF(e, t, n, i) {
            const r = t;
            let s = e.tinySDF;
            const o = i ? -1 : 2;
            if (!s) {
                let t = "400";
                /bolder/i.test(r) ? t = "1000" : /bold/i.test(r) ? t = "900" : /medium/i.test(r) ? t = "500" : /light/i.test(r) && (t = "200"), s = e.tinySDF = new el(24, 2, 8, .25, r, t);
            }
            const a = String.fromCodePoint(n), l = s.ctx.measureText(a), h = Math.round(l.width), c = s.draw(a, h + 4, 28);
            if (il < 4) {
                const e = "undefined" != typeof document && document.getElementById("sdf-debug-" + il++);
                e && (e.width = h + 4, e.height = s.canvas.height, e.getContext("2d").drawImage(s.canvas, 0, 0));
            }
            return {
                charCode: n,
                bitmap: {
                    width: h + 4,
                    height: 28,
                    data: c
                },
                metrics: {
                    width: h,
                    height: 24,
                    left: 1,
                    top: -2,
                    advance: h + 2 + o
                }
            };
        }
    }, e.INVALID_TEX_COORD = Na, e.LRUCache = Ka, e.LineExtrusionPack = class extends No {
        constructor(e, t, n){
            super(e, t, n), this._hasALineHeight = n.altitudeProperty;
        }
        getFormat() {
            const { lineColorFn: e, lineWidthFn: t } = this._fnTypes, n = [
                {
                    type: Math.max(Math.abs(this.maxPosZ), Math.abs(this.minPosZ)) >= Math.pow(2, 15) ? Float32Array : Int16Array,
                    width: 3,
                    name: "aPosition"
                },
                {
                    type: Uint16Array,
                    width: 1,
                    name: "aLinesofar"
                },
                {
                    type: Uint8Array,
                    width: 1,
                    name: "aUp"
                },
                {
                    type: Int16Array,
                    width: 3,
                    name: "aExtrudedPosition"
                },
                {
                    type: Int8Array,
                    width: 2,
                    name: "aExtrude"
                }
            ];
            return e && n.push({
                type: Uint8Array,
                width: 4,
                name: "aColor"
            }), t && n.push({
                type: Uint8Array,
                width: 1,
                name: "aLineWidth"
            }), this._hasALineHeight && n.push({
                type: Float32Array,
                width: 1,
                name: "aLineHeight"
            }), n;
        }
        placeVector(e) {
            const t = e.feature;
            if (this._hasALineHeight) {
                const { altitudeScale: e, altitudeProperty: n, defaultAltitude: i, heightProperty: r, defaultHeight: s, minHeightProperty: o } = this.options, { altitude: a, height: l } = S(t, e, n, i, r, s, o);
                this.feaAltitude = a, this.feaMinHeight = (a - l) / a * 32767, a > this.maxAltitude && (this.maxAltitude = a);
            }
            return super.placeVector(e);
        }
        needAltitudeAttribute() {
            return !1;
        }
        _addLine(e, t, n, i, r, s) {
            const o = this.data.aPosition.getLength() / 3;
            super._addLine(e, t, n, i, r, s);
            const a = this.data.aPosition.getLength() / 3, l = this.data.aPosition.getLength() / 3 - this.offset, h = 3 === t.type, c = !1 !== this.options.side;
            if (!h && l > 0 && c) {
                const e = !1 !== this.options.top ? 1 : 0, t = e + 4;
                let n = this.data.aPosition.getLength() / 3;
                for(const e in this.data){
                    const t = this.data[e], i = t.getLength() / n;
                    let r = t.currentIndex;
                    for(let e = 0; e < i; e++)t[r++] = t[o * i + 3 * i + e];
                    t.currentIndex = r;
                }
                n = this.data.aPosition.getLength() / 3;
                for(const e in this.data){
                    const i = this.data[e], r = i.getLength() / n;
                    let s = i.currentIndex;
                    for(let e = 0; e < r; e++)i[s++] = i[o * r + r * t + e];
                    i.currentIndex = s;
                }
                n = this.data.aPosition.getLength() / 3;
                for(const e in this.data){
                    const i = this.data[e], r = i.getLength() / n;
                    let s = i.currentIndex;
                    for(let e = 0; e < r; e++)i[s++] = i[o * r + r * (t + 3) + e];
                    i.currentIndex = s;
                }
                super.addElements(e + 1, l + 1, l), super.addElements(l, l + 1, l + 2);
                const i = this.data.aPosition.getLength() / 3 - this.offset;
                n = this.data.aPosition.getLength() / 3;
                for(const e in this.data){
                    const t = this.data[e], i = t.getLength() / n;
                    let r = t.currentIndex;
                    for(let e = 0; e < i; e++)t[r++] = t[a * i - i + e];
                    t.currentIndex = r;
                }
                n = this.data.aPosition.getLength() / 3;
                for(const e in this.data){
                    const i = this.data[e], r = i.getLength() / n;
                    let s = i.currentIndex;
                    for(let e = 0; e < r; e++)i[s++] = i[a * r - t * r - r + e];
                    i.currentIndex = s;
                }
                n = this.data.aPosition.getLength() / 3;
                for(const e in this.data){
                    const i = this.data[e], r = i.getLength() / n;
                    let s = i.currentIndex;
                    for(let e = 0; e < r; e++)i[s++] = i[a * r - t * r - 3 * r + e];
                    i.currentIndex = s;
                }
                super.addElements(i, l - 3, i + 1), super.addElements(l - 3, i + 2, i + 1);
            }
        }
        fillData(e, t, n, i, r, s, o, a, l) {
            const h = !1 !== this.options.top, c = !1 !== this.options.side, u = this.options.EXTENT / this.options.tileSize, f = this.feaLineWidth || this.symbol.lineWidth / 2 * u, d = Oo * r, p = Oo * s, g = f * r + t, m = f * s + n;
            this._fillTop(e, t, n, r, s, o, a, l, g, m, d, p), c && (h && this._fillTop(e, t, n, r, s, o, a, l, g, m, d, p), this._fillTop(e, t, n, r, s, o, a, l, g, m, d, p), this._fillBottom(e, t, n, r, s, o, a, l, g, m, d, p), this._fillBottom(e, t, n, r, s, o, a, l, g, m, d, p)), this.maxPos = Math.max(this.maxPos, Math.abs(t), Math.abs(n));
        }
        _fillTop(e, t, n, i, r, s, o, a, l, h, c, u) {
            const { lineColorFn: f, lineWidthFn: d } = this._fnTypes;
            let p = e.aPosition.currentIndex;
            e.aPosition[p++] = t, e.aPosition[p++] = n, e.aPosition[p++] = 32767, e.aPosition.currentIndex = p, p = e.aLinesofar.currentIndex, e.aLinesofar[p++] = a, e.aLinesofar.currentIndex = p, p = e.aUp.currentIndex, e.aUp[p++] = +o, e.aUp.currentIndex = p, p = e.aExtrudedPosition.currentIndex, e.aExtrudedPosition[p++] = l, e.aExtrudedPosition[p++] = h, e.aExtrudedPosition[p++] = 1, e.aExtrudedPosition.currentIndex = p, p = e.aExtrude.currentIndex, e.aExtrude[p++] = c, e.aExtrude[p++] = u, e.aExtrude.push(c, u), f && (p = e.aColor.currentIndex, e.aColor[p++] = this.feaColor[0], e.aColor[p++] = this.feaColor[1], e.aColor[p++] = this.feaColor[2], e.aColor[p++] = this.feaColor[3], e.aColor.currentIndex = p), d && (p = e.aLineWidth.currentIndex, e.aLineWidth[p++] = Math.round(2 * this.feaLineWidth), e.aLineWidth.currentIndex = p), this._hasALineHeight && (p = e.aLineHeight.currentIndex, e.aLineHeight[p++] = this.feaAltitude, e.aLineHeight.currentIndex = p);
        }
        _fillBottom(e, t, n, i, r, s, o, a, l, h, c, u) {
            const { lineColorFn: f, lineWidthFn: d } = this._fnTypes;
            let p = e.aPosition.currentIndex;
            e.aPosition[p++] = t, e.aPosition[p++] = n, e.aPosition[p++] = this.feaMinHeight || 0, e.aPosition.currentIndex = p, p = e.aLinesofar.currentIndex, e.aLinesofar[p++] = a, e.aLinesofar.currentIndex = p, p = e.aUp.currentIndex, e.aUp[p++] = +o, e.aUp.currentIndex = p, p = e.aExtrudedPosition.currentIndex, e.aExtrudedPosition[p++] = l, e.aExtrudedPosition[p++] = h, e.aExtrudedPosition[p++] = 1, e.aExtrudedPosition.currentIndex = p, p = e.aExtrude.currentIndex, e.aExtrude[p++] = c, e.aExtrude[p++] = u, e.aExtrude.push(c, u), f && (p = e.aColor.currentIndex, e.aColor[p++] = this.feaColor[0], e.aColor[p++] = this.feaColor[1], e.aColor[p++] = this.feaColor[2], e.aColor[p++] = this.feaColor[3], e.aColor.currentIndex = p), d && (p = e.aLineWidth.currentIndex, e.aLineWidth[p++] = Math.round(2 * this.feaLineWidth), e.aLineWidth.currentIndex = p), this._hasALineHeight && (p = e.aLineHeight.currentIndex, e.aLineHeight[p++] = this.feaAltitude, e.aLineHeight.currentIndex = p);
        }
        addElements(e, t, n) {
            const i = !1 !== this.options.top, r = !1 !== this.options.side, s = (i ? 1 : 0) + (r ? 4 : 0), o = this.offset;
            if (e *= s, t *= s, n *= s, this.data.aUp[o + n + 4]) {
                if (i && super.addElements(t, e, n), r) {
                    const e = i ? 1 : 0;
                    super.addElements(t + e, n + e, n + e + 2), super.addElements(t + e + 1, n + e + 1 + 2, t + e + 1 + 2);
                }
            } else if (i && super.addElements(e, n, t), r) {
                const t = i ? 1 : 0;
                super.addElements(e + t, e + t + 2, n + t), super.addElements(e + t + 1 + 2, n + t + 1 + 2, n + t + 1);
            }
        }
        createDataPack(e, t) {
            this.maxAltitude = 0;
            const n = super.createDataPack(e, t);
            if (!n) return n;
            const { data: i, indices: r } = n;
            this.getFormat().reduce((e, t)=>(e[t.name] = {
                    size: t.width
                }, e), {}).aPickingId = {
                size: 1
            };
            const { aExtrudedPosition: s, aPosition: o, aLinesofar: a, aUp: l, aExtrude: h, aColor: c, aLineHeight: u, aLineWidth: f } = i, d = {}, p = function(e, t, n) {
                const i = [];
                i.setLength && i.setLength(e.length);
                const r = qo;
                r.length < e.length / 3 && (r.length = e.length / 3), r.fill(0, 0, e.length / 3);
                const s = void 0 === t.length ? t : t.length;
                for(let n = 0; n < s / 3; n++)void 0 === t.length ? ia(e, 3 * n, 3 * n + 1, 3 * n + 2, i, r) : ia(e, t[3 * n], t[3 * n + 1], t[3 * n + 2], i, r);
                for(let e = 0; e < i.length; e += 3){
                    const t = r[e / 3];
                    0 !== t ? (i[e] /= t, i[e + 1] /= t, i[e + 2] /= t) : (i[e] = 0, i[e + 1] = 0, i[e + 2] = 0);
                }
                return i;
            }(s, r);
            let g, m = !0;
            for(let e = 0; e < p.length; e++)p[e] = -p[e], p[e] % 1 != 0 && (m = !1);
            if (!1 !== this.options.top && this.symbol.material && function(e) {
                for(const t in e)if (t.indexOf("Texture") >= 0 && e[t]) return !0;
                return !1;
            }(this.symbol.material) && (g = function(e, t, n) {
                const i = [];
                for(let r = 0; r < e.length; r += 3){
                    const e = t[r / 3];
                    n[r / 3] ? i.push(e / 256, 1) : i.push(e / 256, 0);
                }
                return i;
            }(s, a, l)), d.aPosition = o, g && (d.aTexCoord0 = new Float32Array(g)), d.aNormal = m ? new Int8Array(p) : new Float32Array(p), d.aPickingId = i.aPickingId, d.aExtrude = h, c && (d.aColor = c), f && (d.aLineWidth = f), u) {
                const e = D(this.maxAltitude);
                d.aLineHeight = new e(u);
            }
            const y = [];
            for(const e in d)y.push(d[e].buffer);
            return n.data = d, n.buffers = y, n;
        }
    }, e.LinePack = No, e.NativeLinePack = class extends gs {
        getFormat() {
            return [
                ...this.getPositionFormat()
            ];
        }
        placeVector(e) {
            const t = e.feature, n = 3 === t.type, i = t.geometry, r = this.elements;
            n && (this.elements = this._arrayPool.get());
            const s = this.needAltitudeAttribute() ? 2 : 3;
            for(let e = 0; e < i.length; e++)this.offset = this.data.aPosition.getLength() / s, this._addLine(i[e], t), n && (this._filterPolygonEdges(r), this.elements = this._arrayPool.get());
            n && (this.elements = r);
        }
        _addLine(e, t) {
            const n = 3 === t.type;
            let i = e.length;
            for(; i >= 2 && e[i - 1].equals(e[i - 2]);)i--;
            let r, s, o, a = 0;
            for(; a < i - 1 && e[a].equals(e[a + 1]);)a++;
            if (!(i < (n ? 3 : 2))) {
                this.distance = 0, this.vertexLength = 0, this.primitiveLength = 0, this.e1 = this.e2 = this.e3 = -1, n && (r = e[i - 2]);
                for(let t = a; t < i; t++)o = n && t === i - 1 ? e[a + 1] : e[t + 1], o && e[t].equals(o) || (r && (s = r), r = e[t], s && (this.distance += r.dist(s)), this.addCurrentVertex(r, this.distance));
            }
        }
        addCurrentVertex(e, t) {
            const n = this.vertexLength++;
            this.addLineVertex(this.data, e, t), n >= 1 && this.addElements(n - 1, n), t > ra && (this.distance = 0, this.addCurrentVertex(e, this.distance));
        }
        addLineVertex(e, t) {
            const n = this.needAltitudeAttribute();
            this.fillPosition(e, t.x, t.y, t.z || 0), this.maxPos = n ? Math.max(this.maxPos, Math.abs(t.x), Math.abs(t.y)) : Math.max(this.maxPos, Math.abs(t.x), Math.abs(t.y), Math.abs(t.z || 0));
        }
        addElements(e, t) {
            this.maxIndex = Math.max(this.maxIndex, this.offset + e, this.offset + t);
            let n = this.elements.currentIndex;
            this.elements[n++] = this.offset + e, this.elements[n++] = this.offset + t, this.elements.currentIndex = n;
        }
        _filterPolygonEdges(e) {
            const t = this.options.EXTENT, n = this.elements, i = n.getLength();
            for(let r = 0; r < i; r += 2)if (!A(this.data.aPosition, n[r], n[r + 1], 3, t)) {
                let t = e.currentIndex;
                e[t++] = n[r], e[t++] = n[r + 1], e.currentIndex = t;
            }
        }
    }, e.NativePointPack = class extends gs {
        getFormat() {
            const { markerFillFn: e } = this._fnTypes;
            let t;
            return t = "line" === this.symbol.markerRotationAlignment ? [
                ...this.getPositionFormat(),
                {
                    type: Float32Array,
                    width: 1,
                    name: "aXYRotation"
                },
                {
                    type: Float32Array,
                    width: 1,
                    name: "aZRotation"
                }
            ] : [
                ...this.getPositionFormat()
            ], e && t.push({
                type: Uint8Array,
                width: 4,
                name: "aColor"
            }), t;
        }
        placeVector(e) {
            const t = e.feature.properties, { markerFillFn: n } = this._fnTypes;
            let i;
            n && (i = n(this.options.zoom, t) || [
                255,
                255,
                255,
                255
            ], ie(i) ? (this.dynamicAttrs.aColor = 1, i = [
                0,
                0,
                0,
                0
            ]) : i = ht([], i));
            const r = this.data, s = this.symbol.markerSpacing || 250, o = this.symbol.markerPlacement || "point", a = "line" === this.symbol.markerRotationAlignment, l = this._getAnchors(e, s, o, a), h = this.needAltitudeAttribute();
            for(let e = 0; e < l.length; e++){
                const t = l[e];
                if (this.fillPosition(this.data, t.x, t.y, t.z), a) {
                    let e = r.aXYRotation.currentIndex;
                    r.aXYRotation[e++] = t.xyRotation || 0, r.aXYRotation.currentIndex = e, e = r.aZRotation.currentIndex, r.aZRotation[e++] = t.zRotation || 0, r.aZRotation.currentIndex = e;
                }
                if (i) {
                    let e = r.aColor.currentIndex;
                    r.aColor[e++] = i[0], r.aColor[e++] = i[1], r.aColor[e++] = i[2], r.aColor[e++] = i[3], r.aColor.currentIndex = e;
                }
                let n;
                n = h ? Math.max(Math.abs(t.x), Math.abs(t.y)) : Math.max(Math.abs(t.x), Math.abs(t.y), Math.abs(t.z || 0)), n > this.maxPos && (this.maxPos = n);
            }
        }
        _getAnchors(e, t, n, i) {
            const r = e.feature, s = this.options.EXTENT;
            if ("line" === n) {
                const e = [];
                let n = r.geometry;
                s && (n = Qs(r.geometry, 0, 0, s, s));
                for(let i = 0; i < n.length; i++){
                    const r = no(n[i], t, sa, null, 0, 24, 1, 1, s || 1 / 0);
                    e.push.apply(e, r);
                }
                return e;
            }
            return yo(r, n, s, i, this.options.altitudeToTileScale);
        }
        hasElements() {
            return !1;
        }
    }, e.PackUtil = sl, e.PointPack = Ao, e.PolygonPack = class extends gs {
        constructor(...e){
            super(...e), this.lineElements = [];
        }
        createStyledVector(e, t, n, i, r) {
            const s = new dt(e, t, n, i), o = s.getPolygonResource();
            return !this.options.atlas && o && (r[o] = [
                0,
                0
            ]), s;
        }
        getFormat() {
            const e = [
                ...this.getPositionFormat()
            ], { polygonFillFn: t, polygonOpacityFn: n, uvScaleFn: i, uvOffsetFn: r, polygonPatternUVFn: s } = this._fnTypes;
            if (this.iconAtlas) {
                const t = this.getIconAtlasMaxValue();
                e.push({
                    type: t > 255 ? Uint16Array : Uint8Array,
                    width: 4,
                    name: "aTexInfo"
                });
            }
            return t && e.push({
                type: Uint8Array,
                width: 4,
                name: "aColor"
            }), n && e.push({
                type: Uint8Array,
                width: 1,
                name: "aOpacity"
            }), i && e.push({
                type: Uint16Array,
                width: 2,
                name: "aUVScale"
            }), r && e.push({
                type: Uint8Array,
                width: 2,
                name: "aUVOffset"
            }), s && e.push({
                type: Float32Array,
                width: 2,
                name: "aTexCoord"
            }), e;
        }
        placeVector(e, t) {
            const n = e.feature, i = n.geometry;
            this._addPolygon(i, n, t);
        }
        _addPolygon(e, t) {
            let n, i, r, s;
            const { polygonFillFn: o, polygonOpacityFn: a, uvScaleFn: l, uvOffsetFn: h, uvOffsetInMeterFn: c, polygonPatternUVFn: u } = this._fnTypes, f = t.properties;
            o && (n = o(this.options.zoom, f) || Co([], 255, 255, 255, 255), ie(n) ? (this.dynamicAttrs.aColor = 1, n = Ha) : n = ht([], n)), a && (i = a(this.options.zoom, f), ie(i) ? (this.dynamicAttrs.aOpacity = 1, i = 255) : (Je(i) && (i = 1), i *= 255)), l && (r = l(this.options.zoom, f), ie(r) ? (r = [
                255,
                255
            ], this.dynamicAttrs.aUVScale = 1) : (Je(r) && (r = [
                1,
                1
            ]), r = [
                255 * r[0],
                255 * r[1]
            ])), h && (c && c(null, f) ? s = [
                0,
                0
            ] : (s = h(this.options.zoom, f), ie(s) ? (s = [
                0,
                0
            ], this.dynamicAttrs.aUVOffset = 1) : (Je(s) && (s = [
                0,
                0
            ]), s = [
                255 * s[0],
                255 * s[1]
            ])));
            const d = !!this.iconAtlas, p = ao(e, 500), g = [
                0,
                0
            ], m = [
                0,
                0
            ];
            if (d) {
                const { polygonPatternFileFn: e } = this._fnTypes, t = e ? e(null, f) : this.symbol.polygonPatternFile;
                if (this.iconAtlas.glyphMap[t]) {
                    const e = this.iconAtlas.positions[t], n = !C(e.displaySize[0]) || !C(e.displaySize[1]);
                    g[0] = e.tl[0] + (n ? 1 : 0), g[1] = e.tl[1] + (n ? 1 : 0), m[0] = e.displaySize[0] - 1 - (n ? 2 : 0), m[1] = e.displaySize[1] - 1 - (n ? 2 : 0);
                }
            }
            let y, x = 0;
            u && (y = u(this.options.zoom, f));
            const _ = this.needAltitudeAttribute() ? 2 : 3, v = [
                -1,
                -1,
                t.extent + 1,
                t.extent + 1
            ], b = this._flattened = this._flattened || this._arrayPool.getProxy(), A = this._holeIndices = this._holeIndices || this._arrayPool.getProxy();
            for(let e = 0; e < p.length; e++){
                const t = p[e], o = this.data.aPosition.getLength() / _;
                b.setLength(0), A.setLength(0);
                for(let e = 0; e < t.length; e++){
                    let o = t[e];
                    if (this.options.EXTENT !== 1 / 0 && 0 === this.maxPosZ && 0 === this.minPosZ && (o = Ea(o, v)), 0 === o.length) continue;
                    0 !== e && A.push(b.length / 3), this.ensureDataCapacity(o.length);
                    const a = this.data;
                    for(let e = 0; e < o.length; e++){
                        const t = o[e].x, l = o[e].y, h = o[e].z || 0;
                        if (this.fillPosition(this.data, t, l, h), d) {
                            let e = a.aTexInfo.currentIndex;
                            a.aTexInfo[e++] = g[0], a.aTexInfo[e++] = g[1], a.aTexInfo[e++] = m[0], a.aTexInfo[e++] = m[1], a.aTexInfo.currentIndex = e;
                        }
                        if (void 0 !== n) {
                            let e = a.aColor.currentIndex;
                            a.aColor[e++] = n[0], a.aColor[e++] = n[1], a.aColor[e++] = n[2], a.aColor[e++] = n[3], a.aColor.currentIndex = e;
                        }
                        if (void 0 !== i) {
                            let e = a.aOpacity.currentIndex;
                            a.aOpacity[e++] = i, a.aOpacity.currentIndex = e;
                        }
                        if (void 0 !== r) {
                            let e = a.aUVScale.currentIndex;
                            a.aUVScale[e++] = r[0], a.aUVScale[e++] = r[1], a.aUVScale.currentIndex = e;
                        }
                        if (void 0 !== s) {
                            let e = a.aUVOffset.currentIndex;
                            a.aUVOffset[e++] = s[0], a.aUVOffset[e++] = s[1], a.aUVOffset.currentIndex = e;
                        }
                        if (u) {
                            let e = a.aTexCoord.currentIndex;
                            if (y) {
                                const t = Je(y[2 * x]) ? y[0] : y[2 * x], n = Je(y[2 * x] + 1) ? y[1] : y[2 * x + 1];
                                a.aTexCoord[e++] = t, a.aTexCoord[e++] = n;
                            } else a.aTexCoord[e++] = Na, a.aTexCoord[e++] = Na;
                            a.aTexCoord.currentIndex = e, x++;
                        }
                        const c = Math.abs(t), f = Math.abs(l);
                        c > this.maxPos && (this.maxPos = c), f > this.maxPos && (this.maxPos = f), b.push(t, l, h);
                    }
                }
                let a = oa(b, A, 3);
                if (b.length && !a.length) {
                    const e = [];
                    for(let t = 0; t < b.length; t += 3)e[t] = b[t], e[t + 1] = b[t + 2], e[t + 2] = b[t + 1];
                    if (a = oa(e, A, 3), !a.length) {
                        for(let t = 0; t < b.length; t += 3)e[t] = b[t + 1], e[t + 1] = b[t + 2], e[t + 2] = b[t];
                        a = oa(e, A, 3);
                    }
                }
                for(let e = 0; e < a.length; e += 3)this.addElements(o + a[e], o + a[e + 1], o + a[e + 2]);
            }
        }
        ensureDataCapacity(e) {
            super.ensureDataCapacity(1, e);
        }
    }, e.RoundTubePack = Va, e.SYMBOLS_NEED_REBUILD_IN_VECTOR = fl, e.SYMBOLS_NEED_REBUILD_IN_VT = ul, e.SquareTubePack = class extends Va {
        addHalfVertex(e, t, n, i, r, s, o, a) {
            const { x: l, y: h, z: c } = e, u = 1 * this.scaledDistance, { x: f, y: d, z: p } = o.dir, g = Ja(this.feaLineWidth, this.feaLineHeight, f, d, p, t, n, r);
            this.prevVertex && this.fillTubeElements(r), this.fillData(this.data, l, h, c || 0, g, r, u, a);
        }
        ensureDataCapacity(e, t, n, i) {
            return super.ensureDataCapacity(e, t, n, 2 * i);
        }
    }, e.StyleUtil = ft, e.StyledPoint = Js, e.StyledVector = dt, e.TEXT_MAX_ANGLE = 80, e.TextUtil = Is, e.VectorPack = gs, t().maptalks_vt_packers = e;
}
$435bc7696844e930$var$L({});
function $435bc7696844e930$var$H() {
    return function() {
        if ("undefined" != typeof globalThis) return globalThis;
        if ("undefined" != typeof self) return self;
        if ("undefined" != typeof window) return window;
        if ("undefined" != typeof $parcel$global) return $parcel$global;
        throw new Error("unable to locate global object");
    }().maptalks_vt_packers;
}
let $435bc7696844e930$var$N = 0;
function $435bc7696844e930$var$z() {
    return $435bc7696844e930$var$N++;
}
const $435bc7696844e930$var$V = "function" == typeof Object.assign;
function $435bc7696844e930$var$U(e, ...t) {
    if ($435bc7696844e930$var$V) return Object.assign(e, ...t), e;
    for(let n = 0; n < t.length; n++){
        const i = t[n];
        for(const t in i)e[t] = i[t];
    }
    return e;
}
function $435bc7696844e930$var$B(e) {
    return !$435bc7696844e930$var$X(e) && ("string" == typeof e || null !== e.constructor && e.constructor === String);
}
function $435bc7696844e930$var$G(e) {
    return "number" == typeof e && !isNaN(e);
}
function $435bc7696844e930$var$j(e) {
    return !$435bc7696844e930$var$X(e) && ("function" == typeof e || null !== e.constructor && e.constructor === Function);
}
function $435bc7696844e930$var$W(e) {
    return !Array.isArray(e) && "object" == typeof e && !!e;
}
function $435bc7696844e930$var$X(e) {
    return null == e;
}
function $435bc7696844e930$var$Y(e) {
    for(let t = 1; t < arguments.length; t++){
        const n = arguments[t];
        if (n) for(let t = 0, i = n.length; t < i; t++)e.push(n[t]);
    }
    return e.length;
}
function $435bc7696844e930$var$Z(e) {
    return (0, $14507960c5dac0fb$export$ec423ecbfcdb9a06)(e) && e.property;
}
function $435bc7696844e930$var$q(e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
}
function $435bc7696844e930$var$$(e, t) {
    let n = t.altitudeToPoint(100, e);
    const i = t.options.heightFactor;
    return i && 1 !== i && (n /= i), n / 100 / 100;
}
function $435bc7696844e930$var$J(e, t, n) {
    for(let i = 0; i < e.length; i++){
        const r = e[i], s = $435bc7696844e930$var$U({}, r), { renderPlugin: o } = r, a = $435bc7696844e930$var$U({}, o);
        a.sceneConfig && !Object.keys(a.sceneConfig).length && delete a.sceneConfig;
        let l = -1;
        for(let e = n.length - 1; e >= 0; e--)if ((0, (/*@__PURE__*/$parcel$interopDefault($c4542b84c1927bd5$exports)))(a, n[e])) {
            l = e;
            break;
        }
        l < 0 && (l = n.length, n.push(a)), s.renderPlugin = l, t.push(s);
    }
}
const $435bc7696844e930$var$K = "function" == typeof fetch && "function" == typeof AbortController, $435bc7696844e930$var$Q = {
    jsonp: function(e, t) {
        const n = "_maptalks_jsonp_" + $435bc7696844e930$var$z();
        e.match(/\?/) ? e += "&callback=" + n : e += "?callback=" + n;
        let i = document.createElement("script");
        return i.type = "text/javascript", i.src = e, window[n] = function(e) {
            t(null, e), document.getElementsByTagName("head")[0].removeChild(i), i = null, delete window[n];
        }, document.getElementsByTagName("head")[0].appendChild(i), this;
    },
    get: function(e, t, n) {
        if ($435bc7696844e930$var$j(t)) {
            const e = n;
            n = t, t = e;
        }
        (t = t || {}).method && (t.method = t.method.toUpperCase());
        const i = "POST" === t.method;
        if ($435bc7696844e930$var$K) {
            const i = new AbortController, r = t;
            r.signal = i.signal, r.referrerPolicy = r.referrerPolicy || "origin", r.method = r.method || "GET";
            const s = new Request(e, r);
            return t.returnJSON && s.headers.set("Accept", "application/json"), fetch(s).then((i)=>{
                const r = this._parseResponse(i, t.returnJSON, t.responseType);
                r.message ? (r.url = e, n(r)) : r.then((e)=>{
                    "arraybuffer" === t.responseType ? n(null, {
                        data: e,
                        cacheControl: i.headers.get("Cache-Control"),
                        expires: i.headers.get("Expires"),
                        contentType: i.headers.get("Content-Type")
                    }) : n(null, e);
                }).catch((t)=>{
                    t.code && t.code === DOMException.ABORT_ERR || (console.error("Fetch error:", e, t), n(t));
                });
            }).catch((t)=>{
                t.code && t.code === DOMException.ABORT_ERR || (console.error("Fetch error:", e, t), n(t));
            }), i;
        }
        {
            const r = $435bc7696844e930$var$Q._getClient(n);
            if (r.open(t.method || "GET", e, !0), t) {
                for(const e in t.headers)r.setRequestHeader(e, t.headers[e]);
                r.withCredentials = "include" === t.credentials, t.responseType && (r.responseType = t.responseType);
            }
            return r.send(i ? t.body : null), r;
        }
    },
    _parseResponse: (e, t, n)=>200 !== e.status ? {
            status: e.status,
            statusText: e.statusText,
            message: `incorrect http request with status code(${e.status}): ${e.statusText}`
        } : "arraybuffer" === n ? e.arrayBuffer() : t ? e.json() : e.text(),
    _wrapCallback: function(e, t) {
        return function() {
            if (4 === e.readyState) {
                if (200 === e.status) {
                    if ("arraybuffer" === e.responseType) 0 === e.response.byteLength ? t({
                        status: 200,
                        statusText: e.statusText,
                        message: "http status 200 returned without content."
                    }) : t(null, {
                        data: e.response,
                        cacheControl: e.getResponseHeader("Cache-Control"),
                        expires: e.getResponseHeader("Expires"),
                        contentType: e.getResponseHeader("Content-Type")
                    });
                    else t(null, e.responseText);
                } else t({
                    status: e.status,
                    statusText: e.statusText,
                    message: `incorrect http request with status code(${e.status}): ${e.statusText}`
                });
            }
        };
    },
    _getClient: function(e) {
        let t;
        try {
            t = new XMLHttpRequest;
        } catch (e) {
            try {
                t = new ActiveXObject("Msxml2.XMLHTTP");
            } catch (e) {
                try {
                    t = new ActiveXObject("Microsoft.XMLHTTP");
                } catch (e) {}
            }
        }
        return t.onreadystatechange = $435bc7696844e930$var$Q._wrapCallback(t, e), t;
    },
    getArrayBuffer (e, t, n) {
        if ($435bc7696844e930$var$j(t)) {
            const e = n;
            n = t, t = e;
        }
        return t || (t = {}), t.responseType = "arraybuffer", $435bc7696844e930$var$Q.get(e, t, n);
    },
    getJSON: function(e, t, n) {
        if ($435bc7696844e930$var$j(t)) {
            const e = n;
            n = t, t = e;
        }
        const i = function(e, t) {
            const i = "string" == typeof t ? JSON.parse(t) : t || null;
            n(e, i);
        };
        return t && t.jsonp ? $435bc7696844e930$var$Q.jsonp(e, i) : ((t = t || {}).returnJSON = !0, $435bc7696844e930$var$Q.get(e, t, i));
    }
};
class $435bc7696844e930$var$ee {
    constructor(e){
        this.max = e, this.reset();
    }
    reset() {
        return this.data = {}, this.order = [], this;
    }
    clear() {
        this.reset();
    }
    add(e, t) {
        return this.has(e) ? (this.order.splice(this.order.indexOf(e), 1), this.data[e] = t, this.order.push(e)) : (this.data[e] = t, this.order.push(e), this.order.length > this.max && this.getAndRemove(this.order[0])), this;
    }
    has(e) {
        return e in this.data;
    }
    keys() {
        return this.order;
    }
    getAndRemove(e) {
        if (!this.has(e)) return null;
        const t = this.data[e];
        return delete this.data[e], this.order.splice(this.order.indexOf(e), 1), t;
    }
    get(e) {
        if (!this.has(e)) return null;
        return this.data[e];
    }
    remove(e) {
        return this.has(e) ? (delete this.data[e], this.order.splice(this.order.indexOf(e), 1), this) : this;
    }
    setMaxSize(e) {
        for(this.max = e; this.order.length > this.max;)this.getAndRemove(this.order[0]);
        return this;
    }
}
class $435bc7696844e930$var$te {
    constructor(e){
        this.options = e || {}, this._requesting = {}, this._cache = new $435bc7696844e930$var$ee(256, function() {});
        const t = document.createElement("canvas");
        this.ctx = t.getContext("2d", {
            willReadFrequently: !0
        });
    }
    getIcons(e, i) {
        if (!e || !Object.keys(e).length) return void i(null, {
            icons: null
        });
        const r = Object.keys(e), s = {}, o = [];
        let a = 0, l = 0;
        const h = this;
        function c(e, t) {
            s[e] = h._getCache(e, t), s[e] && "error" !== s[e] ? o.push(s[e].data.data.buffer) : delete s[e], l++, l === a && i(null, {
                icons: s,
                buffers: o
            });
        }
        function u(e) {
            const t = h._requesting[e.url];
            for(let n = 0; n < t.length; n++)t[n].call(e, e.url, e.size);
            delete h._requesting[e.url];
        }
        function f() {
            const e = h.ctx;
            let t, n;
            try {
                t = this.width, n = this.height, this.size[0] = t, this.size[1] = n, h._ensureMaxSize(null, this.size), t = this.size[0], n = this.size[1];
                const i = e.canvas;
                i.width = t, i.height = n, e.imageSmoothingEnabled = !1, e.drawImage(this, 0, 0, t, n);
                const r = e.getImageData(0, 0, i.width, i.height).data;
                h._addCache(this.url, r, i.width, i.height);
            } catch (e) {
                console.warn(e);
            }
            u(this);
        }
        function d(e) {
            console.warn(`failed loading icon(${this.index}) at "${this.url}"`), console.warn(e), h.options.iconErrorUrl ? this.src = h.options.iconErrorUrl : (h._addCache(this.url), u(this));
        }
        const p = this.options.urlModifier;
        let g, m = !1;
        for(let i = 0; i < r.length; i++){
            const l = r[i], h = e[l];
            this._ensureMaxSize(l, h);
            const u = this._getCache(l, h);
            if (u && "error" !== u) {
                s[l] = this._getCache(l, h);
                continue;
            }
            if ("error" === u) continue;
            let y, x = l;
            if (0 === l.indexOf("vector://") && (y = JSON.parse(l.substring(9)), "path" === y.markerType && (x = (0, $gP1US.Util).getMarkerPathBase64(y, y.markerWidth, y.markerHeight))), 0 === l.indexOf("vector://") && "path" !== y.markerType) {
                g = g || new (0, $gP1US.Marker)([
                    0,
                    0
                ]);
                const { markerFill: e, markerLineColor: t } = y;
                e && Array.isArray(e) && (y.markerFill = $435bc7696844e930$var$ne(e)), t && Array.isArray(t) && (y.markerLineColor = $435bc7696844e930$var$ne(t)), delete y.markerHorizontalAlignment, delete y.markerVerticalAlignment, delete y.markerDx, delete y.markerDy, delete y.markerPlacement, delete y.markerFile, y.markerWidth = h[0], y.markerHeight = h[1], g.setSymbol(y);
                const i = g["_getSprite".trim()]();
                if (i) {
                    const e = i.canvas, t = e.width, n = e.height, r = e.getContext("2d").getImageData(0, 0, t, n).data;
                    s[l] = {
                        data: {
                            data: new Uint8ClampedArray(r),
                            width: t,
                            height: n
                        },
                        url: l
                    }, o.push(s[l].data.data.buffer), this._addCache(l, r, t, n);
                }
            } else {
                if (this._requesting[l]) {
                    m = !0, a++, this._requesting[l].push(c);
                    continue;
                }
                this._requesting[l] = [], this._requesting[l].push(c);
                const e = new Image;
                e.index = i, e.size = h, e.onload = f, e.onerror = d, e.onabort = d, e.url = l, e.crossOrigin = "Anonymous", m = !0, a++, e.src = p && p(x) || x;
            }
        }
        m || i(null, {
            icons: s,
            buffers: o
        });
    }
    _hasCache(e, t, n) {
        const i = this._cache.get(e);
        return i && "error" !== i && i.data.width >= t && i.data.height >= n;
    }
    _addCache(e, t, n, i) {
        this._hasCache(e, n, i) || (t ? this._cache.add(e, {
            data: {
                data: t,
                width: n,
                height: i
            },
            url: e
        }) : this._cache.add(e, "error"));
    }
    _getCache(e, t) {
        if (!this._hasCache(e, t[0], t[1])) return null;
        const n = this._cache.get(e);
        return n ? "error" === n ? n : {
            data: {
                data: new Uint8ClampedArray(n.data.data),
                width: n.data.width,
                height: n.data.height
            },
            url: n.url
        } : null;
    }
    _ensureMaxSize(e, t) {
        if (!t[0] || !t[1]) return;
        const n = this.options.maxSize || 2048;
        let [i, r] = t;
        const s = i / r;
        if (e) {
            const t = this._cache.get(e);
            if (t && "error" !== t) {
                const { width: e, height: n } = t.data;
                e > i && (i = e), n > r && (r = n);
            }
        }
        i > n && (r = n / s, i = n), r > n && (i = n * s, r = n), t[0] = Math.floor(i), t[1] = Math.floor(r);
    }
}
function $435bc7696844e930$var$ne(e) {
    return 3 === e.length && e.push(1), e.reduce((e, t, n)=>e += n < 3 ? 255 * t + "," : t + ")", "rgba(");
}
const { GlyphRequestor: $435bc7696844e930$var$ie } = $435bc7696844e930$var$H(), $435bc7696844e930$var$re = [
    "GeoJSONVectorTileLayer"
];
class $435bc7696844e930$var$se extends $gP1US.worker.Actor {
    constructor(e, t){
        super(e);
        const n = t.getMap().id;
        this._layer = t, this._mapId = n, this._workerLayerId = "vt_" + $435bc7696844e930$var$z();
        const i = t.getJSONType();
        this._isDedicated = $435bc7696844e930$var$re.indexOf(i) >= 0, this._dedicatedVTWorkers = {}, this._iconRequestor = new $435bc7696844e930$var$te({
            iconErrorUrl: t.options.iconErrorUrl,
            maxSize: t.options.maxIconSize,
            urlModifier: (e)=>{
                const n = t.getURLModifier();
                return n && n(e) || e;
            }
        });
        const r = !t.getRenderer().isEnableWorkAround("win-intel-gpu-crash");
        this._glyphRequestor = new $435bc7696844e930$var$ie((e)=>{
            t.getMap().getRenderer().callInNextFrame(e);
        }, t.options.glyphSdfLimitPerFrame, r);
    }
    initialize(e) {
        e(null);
    }
    addLayer(e) {
        const t = this._layer, n = t.getWorkerOptions() || {}, i = this._workerLayerId, r = t.getJSONType(), s = {
            mapId: this._mapId,
            layerId: i,
            command: "addLayer",
            params: {
                type: r,
                options: n
            }
        };
        this._isDedicated ? (void 0 === this._dedicatedVTWorkers[i] && (this._dedicatedVTWorkers[i] = this.getDedicatedWorker()), this.send(s, null, e, this._dedicatedVTWorkers[i])) : this.broadcast(s, null, e);
    }
    abortTile(e, t) {
        const n = this._workerLayerId, i = {
            mapId: this._mapId,
            layerId: n,
            command: "abortTile",
            params: {
                url: e
            }
        };
        this._isDedicated ? (void 0 === this._dedicatedVTWorkers[n] && (this._dedicatedVTWorkers[n] = this.getDedicatedWorker()), this.send(i, null, t, this._dedicatedVTWorkers[n])) : this.broadcast(i, null, t);
    }
    removeLayer(e) {
        const t = this._workerLayerId, n = {
            mapId: this._mapId,
            layerId: t,
            command: "removeLayer"
        };
        this._isDedicated ? (void 0 !== this._dedicatedVTWorkers[t] && this.send(n, null, e, this._dedicatedVTWorkers[t]), delete this._dedicatedVTWorkers[t]) : this.broadcast(n, null, e);
    }
    updateStyle(e, t) {
        const n = this._workerLayerId, i = {
            mapId: this._mapId,
            layerId: n,
            command: "updateStyle",
            params: e
        };
        this._isDedicated ? void 0 !== this._dedicatedVTWorkers[n] && this.send(i, null, t, this._dedicatedVTWorkers[n]) : this.broadcast(i, null, t);
    }
    updateOptions(e, t) {
        const n = this._workerLayerId, i = {
            mapId: this._mapId,
            layerId: n,
            command: "updateOptions",
            params: e
        };
        this._isDedicated ? void 0 !== this._dedicatedVTWorkers[n] && this.send(i, null, t, this._dedicatedVTWorkers[n]) : this.broadcast(i, null, t);
    }
    loadTile(e, t) {
        const n = $435bc7696844e930$var$U({}, e);
        n.tileInfo = function(e) {
            const t = {};
            for(const n in e)void 0 !== e[n] && null !== e[n] && (e[n].toJSON ? t[n] = e[n].toJSON() : t[n] = e[n]);
            return t;
        }(e.tileInfo);
        const i = this._workerLayerId, r = {
            mapId: this._mapId,
            layerId: i,
            command: "loadTile",
            params: n
        }, { x: s, y: o } = e.tileInfo, a = (s + o) % this.workers.length, l = [], h = n.tileArrayBuffer;
        h && h instanceof ArrayBuffer && l.push(h), this.send(r, l, t, void 0 === this._dedicatedVTWorkers[i] ? this.workers[a].id : this._dedicatedVTWorkers[i]);
    }
    remove() {
        super.remove(), this._dedicatedVTWorkers = {};
    }
    fetchIconGlyphs({ icons: e, glyphs: t }, n) {
        this._glyphRequestor.getGlyphs(t, (t, i)=>{
            if (t) throw t;
            const r = i.buffers || [];
            this._iconRequestor.getIcons(e, (e, t)=>{
                if (e) throw e;
                t.buffers && t.buffers.length && r.push(...t.buffers), n(null, {
                    icons: t.icons,
                    glyphs: i.glyphs
                }, r);
            });
        });
    }
    setData(e, t) {
        const n = this._workerLayerId, i = {
            mapId: this._mapId,
            layerId: n,
            command: "setData",
            params: {
                data: e
            }
        };
        this.send(i, null, t, this._dedicatedVTWorkers[n]);
    }
    _getTileKey(e) {
        return e.id;
    }
}
const $435bc7696844e930$var$oe = {}, $435bc7696844e930$var$ae = {
    collision: !0,
    fading: !1,
    fadingDuration: 224,
    fadeInDelay: 600,
    fadeOutDelay: 100,
    uniquePlacement: !1,
    depthFunc: "always"
};
class $435bc7696844e930$var$le {
    constructor(e, t, n){
        this._regl = e, this._map = t, this._color = n || [
            0,
            1,
            0
        ];
    }
    draw(e, t, n, i, r) {
        if (this._command || this._init(), !this._data) {
            this._data = this._regl.buffer($435bc7696844e930$var$he(i));
            const e = i / n;
            this._textData = this._regl.buffer($435bc7696844e930$var$ce(i, e));
        }
        if (i !== this._extent) {
            const e = i / n;
            this._data($435bc7696844e930$var$he(i)), this._textData($435bc7696844e930$var$ce(i, e));
        }
        this._extent = i;
        let s = this._debugInfoCanvas;
        if (!s) {
            const e = this._map.getDevicePixelRatio() > 1 ? 2 : 1;
            s = this._debugInfoCanvas = document.createElement("canvas"), s.width = 512 * e, s.height = 64 * e;
            const t = s.getContext("2d");
            t.font = "36px monospace", t.scale(e, e), this._texture = this._regl.texture({
                width: s.width,
                height: s.height,
                data: s
            });
        }
        const o = s.getContext("2d");
        o.clearRect(0, 0, s.width, s.height), o.fillStyle = `rgba(${this._color.map((e)=>255 * e).join()})`, o.fillText(e, 20, 36), this._texture({
            width: s.width,
            height: s.height,
            data: s
        }), this._command({
            transform: t,
            data: this._data,
            texData: this._texCoordData,
            debugLine: 1,
            primitive: "lines",
            framebuffer: r || null,
            image: this._texture,
            count: 8
        }), this._command({
            transform: t,
            data: this._textData,
            texData: this._texCoordData,
            debugLine: 0,
            primitive: "triangle strip",
            framebuffer: r || null,
            image: this._texture,
            count: 4
        });
    }
    delete() {
        this._texture && (this._texture.destroy(), delete this._texture), this._texCoordData && (this._texCoordData.destroy(), delete this._texCoordData), this._data && (this._data.destroy(), this._textData.destroy(), delete this._data, delete this._textData), this._command && (this._command.destroy(), delete this._command);
    }
    _init() {
        this._texCoordData = this._regl.buffer(new Uint8Array([
            0,
            0,
            0,
            1,
            1,
            0,
            1,
            1,
            0,
            0,
            0,
            1,
            1,
            0,
            1,
            1
        ])), this._command = this._regl({
            vert: "\n                attribute vec2 aPosition;\n                attribute vec2 aTexCoord;\n                uniform mat4 transform;\n\n                varying vec2 vTexCoord;\n                void main()\n                {\n                    gl_Position = transform * vec4(aPosition, 0.0, 1.0);\n                    vTexCoord = aTexCoord;\n                }\n            ",
            frag: "\n                precision mediump float;\n                uniform sampler2D uImage;\n                uniform vec3 uColor;\n                uniform float uOpacity;\n                uniform float uDebugLine;\n\n                varying vec2 vTexCoord;\n\n                void main()\n                {\n                    if (uDebugLine == 1.) {\n                        gl_FragColor = vec4(uColor, 1.0) * uOpacity;\n                    } else {\n                        gl_FragColor = texture2D(uImage, vTexCoord) * uOpacity;\n                    }\n                    gl_FragColor *= gl_FragColor.a;\n                }\n            ",
            attributes: {
                aPosition: this._regl.prop("data"),
                aTexCoord: this._regl.prop("texData")
            },
            uniforms: {
                transform: this._regl.prop("transform"),
                uColor: this._color,
                uOpacity: 1,
                uDebugLine: this._regl.prop("debugLine"),
                uImage: this._regl.prop("image")
            },
            count: this._regl.prop("count"),
            primitive: this._regl.prop("primitive"),
            depth: {
                enable: !1,
                mask: !1
            },
            blend: {
                enable: !0,
                func: {
                    src: "one",
                    dst: "one minus src alpha"
                },
                equation: "add"
            },
            stencil: {
                enable: !1
            },
            viewport: {
                x: 0,
                y: 0,
                width: ()=>this._map.getRenderer().canvas.width,
                height: ()=>this._map.getRenderer().canvas.height
            },
            framebuffer: this._regl.prop("framebuffer")
        });
    }
}
function $435bc7696844e930$var$he(e) {
    return new Uint16Array([
        0,
        0,
        0,
        e,
        0,
        e,
        e,
        e,
        e,
        e,
        e,
        0,
        e,
        0,
        0,
        0
    ]);
}
function $435bc7696844e930$var$ce(e, t) {
    return new Uint16Array([
        0,
        e - 64 * t,
        0,
        e,
        512 * t,
        e - 64 * t,
        512 * t,
        e
    ]);
}
const $435bc7696844e930$var$ue = new Uint8Array([
    0,
    0,
    0,
    1,
    1,
    0,
    1,
    0,
    0,
    1,
    1,
    1
]), $435bc7696844e930$var$fe = [];
class $435bc7696844e930$var$de {
    constructor(e, t, n){
        this._regl = e;
        (this._geometry = new (0, $2wazW).Geometry({
            aPosition: $435bc7696844e930$var$ue
        }, null, $435bc7696844e930$var$ue.length / 2, {
            positionSize: 2
        })).generateBuffers(e), this._scene = new (0, $2wazW).Scene, this._meshes = [], this._counter = 0, this._canvas = t, this._map = n, this._init(e);
    }
    start() {
        this._counter = 0, this._scene.clear();
    }
    add(e, t, n) {
        const i = this._getMesh(n);
        i.setUniform("ref", e), (0, $eIStk).set($435bc7696844e930$var$fe, t, t, 1);
        const r = i.localTransform;
        (0, $3iqbd).fromScaling(r, $435bc7696844e930$var$fe), (0, $3iqbd).mul(r, n, r), i.setLocalTransform(r), this._scene.addMesh(i);
    }
    render(e) {
        this._renderer.render(this._shader, {
            projViewMatrix: this._map.projViewMatrix
        }, this._scene, e);
    }
    _getMesh() {
        const e = this._counter++;
        return this._meshes[e] || (this._meshes[e] = new (0, $2wazW).Mesh(this._geometry)), this._meshes[e];
    }
    _init(e) {
        const t = this._canvas, n = {
            viewport: {
                x: 0,
                y: 0,
                width: ()=>t.width,
                height: ()=>t.height
            },
            stencil: {
                enable: !0,
                mask: 255,
                func: {
                    cmp: "always",
                    ref: (e, t)=>t.ref,
                    mask: 255
                },
                op: {
                    fail: "replace",
                    zfail: "replace",
                    zpass: "replace"
                }
            },
            depth: {
                enable: !0,
                func: "always",
                mask: !1
            },
            colorMask: [
                !1,
                !1,
                !1,
                !1
            ]
        };
        this._shader = new (0, $2wazW).MeshShader({
            vert: "\n#define SHADER_NAME TILE_STENCIL_VERT\nattribute vec2 aPosition;\nuniform mat4 projViewModelMatrix;\n\nvoid main()\n{\n    gl_Position = projViewModelMatrix * vec4(aPosition, 0.0, 1.0);\n}\n",
            frag: "\n#define SHADER_NAME TILE_STENCIL_FRAG\nvoid main()\n{\n    gl_FragColor = vec4(1.0, 0.0, 0.0, 0.1);\n}\n",
            uniforms: [
                {
                    name: "projViewModelMatrix",
                    type: "function",
                    fn: function(e, t) {
                        const n = [];
                        return (0, $3iqbd).multiply(n, t.projViewMatrix, t.modelMatrix), n;
                    }
                }
            ],
            extraCommandProps: n
        }), this._renderer = new (0, $2wazW).Renderer(e);
    }
    remove() {
        this._geometry.dispose();
        for(let e = 0; e < this._meshes.length; e++)this._meshes[e].dispose();
        this._meshes.length = 0, this._shader.dispose();
    }
}
const $435bc7696844e930$var$pe = "__fea_idx", $435bc7696844e930$var$ge = -999999, $435bc7696844e930$var$me = new Float32Array([
    -1000000000000
])[0], $435bc7696844e930$var$ye = "maptalks_ombb", $435bc7696844e930$var$xe = ($435bc7696844e930$var$pe + "").trim();
function $435bc7696844e930$var$_e(t, n, i, r, s, o) {
    const a = {};
    if (function(e) {
        if (!e) return !1;
        for(const t in e)if (void 0 !== e[t] && null !== e[t]) return !0;
        return !1;
    }(t)) for(let l = 0, h = (n || t).length; l < h; l++){
        let h = n ? t[n[l]] : t[l];
        "id" === s.options.features && s.getFeature && (h = s.getFeature(h), h.layer = i), s instanceof $gP1US.TileLayer && (h = $435bc7696844e930$var$Se(h, o));
        a[n ? n[l] : h[$435bc7696844e930$var$xe]] = {
            feature: h,
            symbol: r
        };
    }
    return a;
}
const $435bc7696844e930$var$ve = "__original_properties", $435bc7696844e930$var$be = "__external_properties", $435bc7696844e930$var$Ae = {
    get: function(e, t) {
        return t in e ? e[t] : e[$435bc7696844e930$var$ve][t] || e[$435bc7696844e930$var$be] && e[$435bc7696844e930$var$be][t];
    },
    has: function(e, t) {
        return t in e || t in e[$435bc7696844e930$var$ve] || e[$435bc7696844e930$var$be] && t in e[$435bc7696844e930$var$be];
    }
}, $435bc7696844e930$var$Te = {};
function $435bc7696844e930$var$Se(e, t) {
    const n = e.properties;
    if (n && n[$435bc7696844e930$var$ve]) return e;
    t && (e = $435bc7696844e930$var$U({}, e)), e.customProps = e.customProps || {};
    const i = e.customProps;
    return i.$layer = e.layer, i.$type = e.type, i[$435bc7696844e930$var$ve] = n || $435bc7696844e930$var$Te, e.properties = new Proxy(i, $435bc7696844e930$var$Ae), e;
}
function $435bc7696844e930$var$we(e) {
    for(let t = 1; t < arguments.length; t++){
        const n = arguments[t];
        for(const t in n)e[t] = n[t];
    }
    return e;
}
function $435bc7696844e930$var$Me(e, t, n) {
    return Math.min(n, Math.max(t, e));
}
function $435bc7696844e930$var$Pe(e, t, n) {
    if (e === n || e === t) return e;
    const i = n - t;
    return ((e - t) % i + i) % i + t;
}
function $435bc7696844e930$var$Ie(e) {
    return null == e;
}
function $435bc7696844e930$var$Ce(e) {
    return JSON.parse(JSON.stringify(e));
}
function $435bc7696844e930$var$ke(e, t, n, i, r, s) {
    t in e || Object.defineProperty(e, t, {
        enumerable: !0,
        get: function() {
            const e = $435bc7696844e930$var$Ie(n[i]) || (0, $14507960c5dac0fb$export$ec423ecbfcdb9a06)(n[i]) ? r : n[i];
            return s ? s(e) : e;
        }
    });
}
const $435bc7696844e930$var$Fe = [];
function $435bc7696844e930$var$Oe(e) {
    for(let t = 0; t < e.length; t++)$435bc7696844e930$var$Fe[t] = e[t], $435bc7696844e930$var$Fe[t] *= 255;
    return 3 === e.length && ($435bc7696844e930$var$Fe[3] = 255), $435bc7696844e930$var$Fe;
}
function $435bc7696844e930$var$Re(e, t = 4) {
    return $435bc7696844e930$var$Ee.bind(this, e, t);
}
function $435bc7696844e930$var$Ee(e, t, n) {
    if (Array.isArray(n)) return 3 === n.length && 4 === t && n.push(1), n;
    if (e && e[n]) return e[n];
    if (void 0 !== n.r && void 0 !== n.g && void 0 !== n.b && void 0 !== n.a) return [
        n.r,
        n.g,
        n.b,
        n.a
    ];
    const i = (0, (/*@__PURE__*/$parcel$interopDefault($08acccbbd431ef55$exports)))(n).unitArray();
    return 3 === i.length && 4 === t && i.push(1), e && (e[n] = i), i;
}
function $435bc7696844e930$var$De(e, t, n, i) {
    if (e.fill) e.fill(t, n, i);
    else for(let r = n; r < i; r++)e[r] = t;
}
function $435bc7696844e930$var$Le(e) {
    return "number" == typeof e && !isNaN(e);
}
function $435bc7696844e930$var$He(e) {
    return e && (e.markerFile || e.markerType) && void 0 !== e.textName;
}
function $435bc7696844e930$var$Ne(e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
}
function $435bc7696844e930$var$ze(e, t) {
    if (t) {
        let t = e[e.length - 1];
        const n = [
            t
        ];
        for(let i = e.length - 2; i >= 0; i--)e[i] !== t && (n.push(e[i]), t = e[i]);
        return n;
    }
    {
        let t = e[e[0]];
        const n = [
            t
        ];
        for(let i = 1; i < e.length; i++)e[i] !== t && (n.push(e[i]), t = e[i]);
        return n;
    }
}
const $435bc7696844e930$var$Ve = new $gP1US.Coordinate(0, 0);
function $435bc7696844e930$var$Ue(e, t, n, i, r) {
    const s = e.distanceToPointAtRes(t, t, i, n, $435bc7696844e930$var$Ve);
    return r ? s.y : s.x;
}
const { FilterUtil: $435bc7696844e930$var$Be } = $435bc7696844e930$var$H(), $435bc7696844e930$var$Ge = [], $435bc7696844e930$var$je = [
    0,
    0,
    0,
    0
], $435bc7696844e930$var$We = new $gP1US.Point(0, 0), $435bc7696844e930$var$Xe = [], $435bc7696844e930$var$Ye = {
    color: $435bc7696844e930$var$je,
    depth: 1,
    stencil: 0
}, $435bc7696844e930$var$Ze = (e)=>e.isTerrainSkin(), $435bc7696844e930$var$qe = (e)=>e.isTerrainVector();
class $435bc7696844e930$export$55c5e09254f6444 extends $gP1US.renderer.TileLayerCanvasRenderer {
    supportRenderMode() {
        return !0;
    }
    constructor(e){
        super(e), this._workerCacheIndex = 0, this.ready = !1, this._styleCounter = 1, this._requestingMVT = {}, this._plugins = {}, this._featurePlugins = {};
    }
    getTileLevelValue(e, t) {
        if (this.isBackTile(e.id)) {
            const n = e.z, i = 5;
            return n - t >= 0 ? t + i - n : i + (t - n);
        }
        return 0;
    }
    getWorkerConnection() {
        return this._workerConn;
    }
    getStyleCounter() {
        return this._styleCounter;
    }
    setStyle() {
        if (this._groundPainter && this._groundPainter.update(), this._workerConn) {
            this._styleCounter++, this._preservePrevTiles();
            const e = this.layer._getComputedStyle();
            e.styleCounter = this._styleCounter, this._workersyncing = !0, this._workerConn.updateStyle(e, (e)=>{
                if (this._workersyncing = !1, e) throw new Error(e);
                this._needRetire = !0, this._initPlugins(), this.setToRedraw(), this.layer.fire("refreshstyle");
            });
        } else this._initPlugins();
    }
    _preservePrevTiles() {
        if (this._prevTilesInView) for(const e in this._prevTilesInView){
            const t = this._prevTilesInView[e];
            t && this.deleteTile(t);
        }
        this._prevTilesInView = this.tilesInView;
        const e = this.tileCache;
        for(const t in this._prevTilesInView){
            const n = this._prevTilesInView[t];
            n && n.info && e.getAndRemove(n.info.id);
        }
        e.reset(), this.tilesInView = {}, this.tilesLoading = {}, this._requestingMVT = {}, this._parentTiles = [], this._childTiles = [], this._tileZoom = void 0;
    }
    updateOptions(e) {
        this._workerConn && this._workerConn.updateOptions(this.layer.getWorkerOptions(), (t)=>{
            if (t) throw new Error(t);
            e && (e.features || e.pickingGeometry || e.altitudeProperty) && (this.clear(), this._clearPlugin(), this._initPlugins()), this.setToRedraw();
        });
    }
    updateSceneConfig(e, t, n) {
        const i = 0 === e ? this._getStylePlugins() : this._getFeaturePlugins();
        if (!i || !i[t]) return;
        this._needRetire = !0;
        const r = this.layer._getComputedStyle(), s = this.layer._getTargetStyle(e, r);
        i[t].config = s[t].renderPlugin, i[t].updateSceneConfig({
            sceneConfig: n
        }), this.setToRedraw();
    }
    updateDataConfig(e, t, n, i) {
        const r = 0 === e ? this._getStylePlugins() : this._getFeaturePlugins();
        r && r[t] && (this._needRetire = !0, r[t].updateDataConfig(n, i) ? this.setStyle() : this.setToRedraw());
    }
    updateSymbol(e, t, n) {
        const i = 0 === e ? this._getStylePlugins() : this._getFeaturePlugins();
        if (!i || !i[t]) return !1;
        const r = this.layer._getComputedStyle(), s = this.layer._getTargetStyle(e, r), o = i[t];
        o.style = s[t];
        const a = o.updateSymbol(n, s[t].symbol);
        return !a && $435bc7696844e930$var$et(n) && this.setStyle(), this.setToRedraw(), a;
    }
    needToRedraw() {
        const e = super.needToRedraw();
        if (!e) {
            const e = this._getFramePlugins();
            for(let t = 0; t < e.length; t++)if (e[t] && e[t].needToRedraw()) return !0;
        }
        return e;
    }
    needRetireFrames() {
        if (this._needRetire) return !0;
        const e = this._getFramePlugins();
        for(let t = 0; t < e.length; t++)if (e[t] && e[t].needToRetireFrames()) return !0;
        return !1;
    }
    isAnimating() {
        const e = this.getMap().getRenderer(), t = e.getFrameTimestamp && e.getFrameTimestamp() || e._frameTimestamp;
        if (this._highlightUpdated && (this._highlightFrametime = t, delete this._highlightUpdated), this._highlightFrametime === t) return !0;
        const n = this._getFramePlugins();
        for(let e = 0; e < n.length; e++)if (n[e] && n[e].isAnimating()) return !0;
        return !1;
    }
    needToRefreshTerrainTileOnZooming() {
        const e = this._getFramePlugins();
        for(let t = 0; t < e.length; t++)if (e[t] && e[t].needToRefreshTerrainTileOnZooming()) return !0;
        return !1;
    }
    _isInGroupGLLayer() {
        return !!(this.canvas && this.canvas.gl && this.canvas.gl.wrap);
    }
    createContext() {
        const e = this.canvas.gl && this.canvas.gl.wrap;
        if (e) this.gl = this.canvas.gl.wrap(), this.regl = this.canvas.gl.regl;
        else {
            const { gl: e, regl: t, attributes: n } = this._createREGLContext(this.canvas);
            this.gl = e, this.regl = t, this.glOptions = n;
        }
        if (e && (this.canvas.pickingFBO = this.canvas.pickingFBO || this.regl.framebuffer(this.canvas.width, this.canvas.height)), this.pickingFBO = this.canvas.pickingFBO || this.regl.framebuffer(this.canvas.width, this.canvas.height), this._debugPainter = new $435bc7696844e930$var$le(this.regl, this.getMap()), this._prepareWorker(), this._groundPainter = new (0, $9e7Ip.GroundPainter)(this.regl, this.layer), !this.consumeTile) {
            const e = this.getMap().VERSION;
            throw new Error(`Incompatible version of maptalks: ${e}, upgrade maptalks >= v1.0.0-rc.14`);
        }
    }
    _createREGLContext(e) {
        const t = this.layer, n = t.options.glOptions || {
            alpha: !0,
            depth: !0,
            antialias: this.layer.options.antialias
        };
        n.preserveDrawingBuffer = !0, n.stencil = !0;
        const i = this._createGLContext(e, n);
        return {
            gl: i,
            attributes: n,
            regl: (0, (/*@__PURE__*/$parcel$interopDefault($9I15V)))({
                gl: i,
                attributes: n,
                extensions: [
                    "ANGLE_instanced_arrays",
                    "OES_element_index_uint",
                    "OES_standard_derivatives"
                ],
                optionalExtensions: t.options.glExtensions || [
                    "OES_vertex_array_object",
                    "OES_texture_half_float",
                    "OES_texture_half_float_linear",
                    "OES_texture_float",
                    "OES_texture_float_linear",
                    "WEBGL_draw_buffers",
                    "EXT_shader_texture_lod",
                    "EXT_frag_depth"
                ]
            })
        };
    }
    _prepareWorker() {
        this._workerConn || (this._workerConn = new $435bc7696844e930$var$se("@maptalks/vt", this.layer));
        this._workerConn.addLayer((e, t)=>{
            this.layer && (this.ready = !0, this.layer.onWorkerReady(e, t), this.layer.fire("workerready"), this.setToRedraw());
        });
    }
    _incrWorkerCacheIndex() {
        this._workerCacheIndex++;
    }
    clearCanvas() {
        super.clearCanvas(), this.regl && this.regl.clear({
            color: $435bc7696844e930$var$je,
            depth: 1,
            stencil: 0
        });
    }
    isDrawable() {
        return !0;
    }
    checkResources() {
        return $435bc7696844e930$var$Ge;
    }
    _drawTiles(e, t, n, i, r) {
        if (super._drawTiles(e, t, n, i, r), this._prevTilesInView) {
            if (Object.keys(this._prevTilesInView).length) for(const e in this._prevTilesInView){
                const t = this._prevTilesInView[e];
                t && t.info && t.info.id && !this.tileCache.has(t.info.id) && this._drawTile(t.info, t.image, r);
            }
            else this._deletePrevPlugins(), delete this._prevTilesInView;
        }
    }
    _deletePrevPlugins() {
        const e = this._styleCounter, t = [], n = [];
        for(const n in this._plugins)if (+n !== e) {
            t.push(n);
            this._getStylePlugins(n).forEach((e)=>{
                e.remove();
            });
        }
        for(const t in this._featurePlugins)if (+t !== e) {
            n.push(t);
            this._getFeaturePlugins(t).forEach((e)=>{
                e.remove();
            });
        }
        for(let e = 0; e < t.length; e++)delete this._plugins[t[e]];
        for(let e = 0; e < n.length; e++)delete this._featurePlugins[n[e]];
    }
    draw(e, t) {
        this._currentTimestamp !== e && (this._needRetire = !1, this._setPluginIndex());
        const n = this.layer;
        if (this.prepareCanvas(), !this.ready || !n.ready) return;
        let i = this._plugins[this._styleCounter];
        i || (this._initPlugins(), this._setPluginIndex(), i = this._getStylePlugins());
        const r = this._getFeaturePlugins();
        n.isDefaultRender() || i.length || r.length ? (n.options.collision && n.clearCollisionIndex(), this._frameTime = e, this._zScale = this._getCentiMeterScale(this.getMap().getGLRes()), this._parentContext = t || {}, this._startFrame(e), super.draw(e), this._currentTimestamp !== e && this._prepareRender(e), this._endFrame(e), this._currentTimestamp = e) : this.completeRender();
    }
    _setPluginIndex() {
        this._getFramePlugins().forEach((e, t)=>{
            e && (e.renderIndex = t);
        });
    }
    _prepareRender() {
        const e = this._getFramePlugins();
        this._pluginOffsets = this._pluginOffsets || [];
        let t = 0;
        for(let n = e.length - 1; n >= 0; n--){
            const i = e[n];
            i.isVisible() && i.hasMesh() && (this._pluginOffsets[n] = t, i.needPolygonOffset() && t++);
        }
        this._groundPainter.isEnable() && t++, this._polygonOffsetIndex = t;
    }
    getFrameTimestamp() {
        return this._frameTime;
    }
    drawOnInteracting(e, t, n) {
        this.draw(t, n);
    }
    drawOutline(e) {
        (this._outline || this._outlineAll) && (this._outlineAll ? this.paintOutlineAll(e) : this._outline.forEach((t)=>{
            this[t[0]](e, ...t[1]);
        }));
    }
    getAnalysisMeshes() {
        return this.getShadowMeshes();
    }
    getShadowMeshes() {
        const e = [];
        return this._getAllPlugins().forEach((t)=>{
            if (!t) return;
            if (!this._isVisible(t)) return;
            const n = t.getShadowMeshes();
            if (Array.isArray(n)) for(let t = 0; t < n.length; t++)e.push(n[t]);
        }), e;
    }
    isForeground(e) {
        return !(!this._vtCurrentTiles || !this._vtCurrentTiles[e.properties.tile.id]);
    }
    _getTileZoomDiff(t) {
        const n = this.layer;
        let i = n._getTileZoom(this.getMap().getZoom());
        const r = n.getMinZoom(), s = n.getMaxZoom();
        i = $gP1US.Util.clamp(i, r, s);
        return i - t.properties.tile.z;
    }
    isTileNearCamera(e) {
        return this._getTileZoomDiff(e) <= 1;
    }
    isBackTile(e) {
        return !(!this._vtBgTiles || !this._vtBgTiles[e]);
    }
    loadTileQueue(e) {
        this._workersyncing || super.loadTileQueue(e);
    }
    loadTile(t) {
        const { url: n } = t, i = this._requestingMVT[n];
        if (i) i.keys[t.id] || (i.tiles.push(t), i.keys[t.id] = 1);
        else {
            const i = this.getMap(), r = $435bc7696844e930$var$We.set(t.extent2d.xmin, t.extent2d.ymax), s = i.pointAtResToCoord(new $gP1US.Point(r), t.res), o = [
                $435bc7696844e930$var$Ue(i, 1, s, t.res) / 100,
                $435bc7696844e930$var$Ue(i, 1, s, t.res, 1) / 100
            ], a = this.getCentimeterToPoint(t.z), l = this.getTileGLScale(t.z);
            this._requestingMVT[n] = {
                keys: {},
                tiles: [
                    t
                ]
            }, this._requestingMVT[n].keys[t.id] = 1;
            const h = this.layer.options.fetchOptions, c = window && window.location.href, u = this.layer.options.altitudePropertyName, f = this.layer.options.disableAltitudeWarning, d = {
                tileInfo: {
                    res: t.res,
                    x: t.x,
                    y: t.y,
                    z: t.z,
                    url: $435bc7696844e930$var$it(t),
                    id: t.id,
                    extent2d: t.extent2d
                },
                glScale: l,
                disableAltitudeWarning: f,
                altitudePropertyName: u,
                zScale: this._zScale,
                centimeterToPoint: o,
                verticalCentimeterToPoint: a,
                fetchOptions: h,
                styleCounter: this._styleCounter,
                referrer: c,
                workerCacheIndex: this._workerCacheIndex,
                command: "loadTile"
            };
            this.loadTileArrayBuffer && $435bc7696844e930$var$j(this.loadTileArrayBuffer) ? this.loadTileArrayBuffer(d.tileInfo.url, t, (e, t)=>{
                e ? this._onReceiveMVTData(n, e) : t && t instanceof ArrayBuffer ? (d.tileArrayBuffer = t, this._workerConn.loadTile(d, this._onReceiveMVTData.bind(this, n))) : console.error("loadTileArrayBuffer return data is not ArrayBuffer:", t);
            }, d) : this._workerConn.loadTile(d, this._onReceiveMVTData.bind(this, n));
        }
        return {};
    }
    getTileGLScale(e) {
        const t = this.getMap();
        return this.layer.getSpatialReference().getResolution(e) / t.getGLRes();
    }
    getCentimeterToPoint(e) {
        const t = this.getMap();
        return $435bc7696844e930$var$$(this.layer.getSpatialReference().getResolution(e), t);
    }
    getRenderedFeatures() {
        const e = [], t = this.tileCache.keys();
        for(let n = 0; n < t.length; n++){
            const i = this.tileCache.get(t[n]);
            if (!i || !i.info || !i.image) continue;
            const { info: r, image: s } = i, o = $435bc7696844e930$var$nt(s);
            e.push({
                tile: {
                    id: r.id,
                    x: r.x,
                    y: r.y,
                    z: r.z,
                    url: r.url
                },
                current: !!this.tilesInView[r.id],
                features: o
            });
        }
        return e;
    }
    _onReceiveMVTData(e, t, n) {
        if (this.setToRedraw(), !this._requestingMVT[e]) return;
        if (n && n.canceled) return;
        const i = this.layer, r = i.isDefaultRender(), { tiles: s } = this._requestingMVT[e];
        if (delete this._requestingMVT[e], t) {
            if (t.status && (404 === t.status || 204 === t.status)) for(let e = 0; e < s.length; e++){
                const t = s[e];
                this.onTileError($435bc7696844e930$var$oe, t);
            }
            return;
        }
        if (!n) {
            for(let e = 0; e < s.length; e++){
                const t = s[e];
                this.consumeTile({
                    _empty: !0
                }, t);
            }
            return;
        }
        if (n.styleCounter !== this._styleCounter) return;
        let o = !1;
        const a = n.features, l = [];
        for(let e = 0; e < n.data.length; e++){
            const t = n.data[e];
            if (!t || !t.data || !t.styledFeatures.length) continue;
            const { isUpdated: i, layer: r } = this._parseTileData(0, e, t, a, l);
            l.push(r), i && (o = i);
        }
        for(let e = 0; e < n.featureData.length; e++){
            const t = n.featureData[e];
            t && t.data && t.styledFeatures.length && this._parseTileData(1, e, t, a);
        }
        o && i._compileStyle();
        const h = s[0].z, c = this.layer.getDataSchema(h);
        if (this._updateSchema(c, n.schema), delete n.features, r && n.data.length !== l.length) {
            const e = n.data;
            n.data = [];
            for(let t = 0; t < e.length; t++)e[t] && e[t].features && n.data.push(e[t]);
        }
        n.layers = l;
        for(let e = 0; e < s.length; e++){
            const t = s[e];
            if (0 === e && i.options.debugTileData) {
                const { x: e, y: n, z: r } = t;
                console.log("tile", {
                    layerId: i.getId(),
                    x: e,
                    y: n,
                    z: r,
                    layers: $435bc7696844e930$var$Qe(Object.values(a))
                });
            }
            const r = 0 === e ? n : $435bc7696844e930$var$Je(n);
            for(let e = 0; e < r.data.length; e++){
                if (!r.data[e]) continue;
                const n = r.data[e].features;
                for(const e in n)n[e].tile = t;
            }
            t.extent = r.extent, this._receivedTileExtent || (this._receivedTileExtent = t.extent), r.features = Object.values(a), r.styleCounter = n.styleCounter, this.onTileLoad(r, t);
        }
        this.layer.fire("datareceived", {
            url: e
        });
    }
    _parseTileData(e, t, n, i) {
        const { style: r, isUpdated: s } = this._updatePluginIfNecessary(e, t, n.data), o = this.layer, a = o.isDefaultRender(), l = r.symbol, h = $435bc7696844e930$var$_e(i, n.styledFeatures, t, l, o, !(!o.getData || !o.getData()));
        delete n.styledFeatures, n.features = h;
        let c = n.data;
        return Array.isArray(c) && (c = c[0]), {
            isUpdated: s,
            layer: a ? {
                layer: c.layer,
                type: c.type
            } : null
        };
    }
    _updateSchema(e, t) {
        for(const n in t){
            e[n] || (e[n] = {
                types: t[n].types,
                properties: {}
            });
            const i = t[n].properties, r = e[n].properties;
            for(const e in i)(!r[e] || r[e] && "object" !== i[e] && "object" === r[e]) && (r[e] = i[e]);
        }
    }
    _updatePluginIfNecessary(e, t, n) {
        Array.isArray(n) && (n = n[0]);
        const i = this.layer;
        let r, s = !1;
        if (i.isDefaultRender() && 0 === e) {
            let e = this._layerPlugins;
            e || (e = this._layerPlugins = {});
            const t = n.layer, i = n.type;
            e[t] || (e[t] = []);
            const o = ("plugin_" + i).trim();
            e[t][o] ? r = e[t][o] : (r = this._getDefaultRenderPlugin(i), r.filter = n.filter, e[t].push(r), e[t][o] = r, s = !0);
        } else {
            const o = i._getComputedStyle(), a = i._getTargetStyle(e, o), l = this._getStylePlugins();
            if (r = a[t], !r.renderPlugin) {
                s = !0;
                const { plugin: e, symbol: i, renderPlugin: o } = this._getDefaultRenderPlugin(n.type);
                l[t] = e, r.symbol = i, r.renderPlugin = o;
            }
        }
        return {
            style: r,
            isUpdated: s
        };
    }
    _getFramePlugins(e) {
        const t = e && e.style;
        let n = this._getStylePlugins(t) || [];
        this.layer.isDefaultRender() && this._layerPlugins && (n = [], e ? e.layers && e.layers.forEach((e)=>{
            if (!e) return;
            const t = ("plugin_" + e.type).trim();
            n.push(this._layerPlugins[e.layer][t].plugin);
        }) : Object.keys(this._layerPlugins).forEach((e)=>{
            for(let t = 0; t < this._layerPlugins[e].length; t++)n.push(this._layerPlugins[e][t].plugin);
        }));
        const i = this._getFeaturePlugins(t);
        return i && i.length && (n = n.slice(), $435bc7696844e930$var$Y(n, i)), n;
    }
    _getAllPlugins() {
        if (this.layer.isDefaultRender() && this._layerPlugins) {
            const e = [];
            return Object.keys(this._layerPlugins).forEach((t)=>{
                for(let n = 0; n < this._layerPlugins[t].length; n++)e.push(this._layerPlugins[t][n].plugin);
            }), e;
        }
        const e = [];
        for(const t in this._plugins)e.push(...this._plugins[t]);
        for(const t in this._featurePlugins)e.push(...this._featurePlugins[t]);
        return e;
    }
    _getStylePlugins(e) {
        return $435bc7696844e930$var$X(e) && (e = this._styleCounter), this._plugins[e] || $435bc7696844e930$var$Ge;
    }
    _getFeaturePlugins(e) {
        return $435bc7696844e930$var$X(e) && (e = this._styleCounter), this._featurePlugins[e] || $435bc7696844e930$var$Ge;
    }
    _startFrame(e, t) {
        const n = this._isRenderingTerrain(), i = this.layer.isDefaultRender() && this._layerPlugins, r = this._parentContext;
        this._getAllPlugins().forEach((s, o)=>{
            if (!s || t && !t(s)) return;
            if (!this._isVisible(o)) return;
            const a = this.regl, l = this.gl, h = i ? s.defaultSymbol : s.style && s.style.symbol, c = {
                regl: a,
                layer: this.layer,
                symbol: h,
                gl: l,
                isRenderingTerrain: n,
                sceneConfig: s.config ? s.config.sceneConfig : null,
                dataConfig: s.config ? s.config.dataConfig : null,
                pluginIndex: o,
                timestamp: e
            };
            r && $435bc7696844e930$var$U(c, r), s.startFrame(c);
        });
    }
    _endFrame(e) {
        const t = this._parentContext, n = t.renderMode, i = t && t.renderTarget && t.renderTarget.fbo, r = this.getMap().cameraPosition, s = this._getAllPlugins(), o = this._isRenderingTerrain(), a = !t.timestamp || t.isFinalRender;
        this.layer.options.collision && !t.isPostProcess ? s.forEach((t)=>{
            if (!this._isVisible(t) || !t.hasMesh()) return;
            if (n && "default" !== n && !t.supportRenderMode(n)) return;
            if (o && !$435bc7696844e930$var$qe(t)) return;
            const i = this._getPluginContext(t, 0, r, e);
            t.prepareRender(i), t.updateCollision(i);
        }) : s.forEach((t)=>{
            if (!this._isVisible(t) || !t.hasMesh()) return;
            if (n && "default" !== n && !t.supportRenderMode(n)) return;
            if (o && !$435bc7696844e930$var$qe(t)) return;
            const i = this._getPluginContext(t, 0, r, e);
            t.prepareRender(i);
        });
        const l = this._currentTimestamp !== t.timestamp;
        let h = !1;
        if (l && !o) {
            const t = this.layer.getPolygonOffset() + this.layer.getPolygonOffsetCount(), n = this._getPluginContext(null, t, r, e);
            n.offsetFactor = t, n.offsetUnits = t, this._groundPainter.paint(n);
        }
        s.forEach((t, s)=>{
            if (!this._isVisitable(t)) return;
            if (n && "default" !== n && !t.supportRenderMode(n)) return;
            if (o && !$435bc7696844e930$var$qe(t)) return;
            this.regl.clear({
                stencil: 255,
                framebuffer: i
            });
            const a = this._pluginOffsets[s] || 0, l = this._getPluginContext(t, a, r, e);
            t.painter && t.painter.isEnableTileStencil(l) && this._drawTileStencil(i, t.painter);
            const c = t.endFrame(l);
            c && c.redraw && this.setToRedraw(), h = !0;
        }), h && this.layer.fire("canvasisdirty"), a && this._drawDebug();
    }
    getPolygonOffsetCount() {
        return this._polygonOffsetIndex || 0;
    }
    _drawDebug() {
        if (this.layer.options.debug) {
            const e = this._parentContext, t = [], n = this.getMap().projViewMatrix;
            for(const i in this.tilesInView){
                const r = this.tilesInView[i].info, s = this.tilesInView[i].image;
                if (s._empty) continue;
                const o = r.transform, l = s.extent, h = e && e.renderTarget;
                if (o && l) {
                    const e = this.getDebugInfo(r.id), i = (0, $3iqbd).multiply(t, n, o), s = this.layer.getTileSize().width;
                    this._debugPainter.draw(e, i, s, l, h && h.fbo);
                }
            }
        }
    }
    _isVisitable(e) {
        if (!e) return !0;
        const t = this._parentContext, n = this._isVisible(e), i = t && t.states && t.states.includesChanged, r = this._hasMesh(e.painter.scene.getMeshes());
        return !n || !i && !r ? 0 : r ? 2 : 1;
    }
    _getPluginContext(e, t, n, i) {
        const r = this._isRenderingTerrain(), s = r && e && $435bc7696844e930$var$Ze(e), o = this.regl, a = this.gl, l = {
            regl: o,
            layer: this.layer,
            gl: a,
            isRenderingTerrain: r,
            isRenderingTerrainSkin: s,
            sceneConfig: e && e.config.sceneConfig,
            pluginIndex: e && e.renderIndex,
            polygonOffsetIndex: t,
            cameraPosition: n,
            timestamp: i
        }, h = this._parentContext;
        return h && $435bc7696844e930$var$U(l, h), l;
    }
    _hasMesh(e) {
        if (!e) return !1;
        const t = this._parentContext && this._parentContext.sceneFilter;
        return t ? e.filter((e)=>t(e) || e.properties.hlBloomMesh && t(e.properties.hlBloomMesh)).length > 0 : e.length > 0;
    }
    _drawTileStencil(e, t) {
        const n = t.isUniqueStencilRefPerTile(), i = this.getCurrentTileZoom();
        let r = this._stencilRenderer;
        r || (r = this._stencilRenderer = new $435bc7696844e930$var$de(this.regl, this.canvas, this.getMap())), r.start();
        const { tiles: s } = this._stencilTiles;
        let { parentTiles: o, childTiles: a } = this._stencilTiles, l = 1;
        a = a.sort($435bc7696844e930$var$Ke);
        for(let e = 0; e < a.length; e++){
            const t = n ? l : this.getTileLevelValue(a[e].info, i);
            this._addTileStencil(a[e].info, t), l++;
        }
        o = o.sort($435bc7696844e930$var$Ke);
        for(let e = 0; e < o.length; e++){
            const t = n ? l : this.getTileLevelValue(o[e].info, i);
            this._addTileStencil(o[e].info, t), l++;
        }
        const h = s.sort($435bc7696844e930$var$Ke);
        for(let e = h.length - 1; e >= 0; e--){
            const t = n ? l : this.getTileLevelValue(h[e].info, i);
            this._addTileStencil(h[e].info, t), l++;
        }
        r.render(e);
    }
    _addTileStencil(e, t) {
        const n = $435bc7696844e930$var$We.set(e.extent2d.xmin, e.extent2d.ymax), i = e.extent || this._receivedTileExtent || 8192, r = e.transform = e.transform || this.calculateTileMatrix(n, e.z, i);
        e.stencilRef = t, this._stencilRenderer.add(t, i, r);
    }
    onDrawTileStart(e) {
        super.onDrawTileStart(e);
        const { tiles: t, childTiles: n, parentTiles: i } = e;
        this._vtCurrentTiles = {}, this._vtBgTiles = {};
        for(let e = 0; e < t.length; e++)this._vtCurrentTiles[t[e].info.id] = 1;
        for(let e = 0; e < n.length; e++)this._vtBgTiles[n[e].info.id] = 1;
        for(let e = 0; e < i.length; e++)this._vtBgTiles[i[e].info.id] = 1;
        this._stencilTiles = e;
    }
    isEnableTileStencil() {
        if (this.layer.options.altitude) return !1;
        const e = this._getFramePlugins();
        for(let t = 0; t < e.length; t++)if (e[t] && e[t].painter && !e[t].painter.isOnly2D()) return !1;
        return !0;
    }
    setTerrainHelper(e) {
        this._terrainLayer = e;
    }
    getTerrainHelper() {
        return this._terrainLayer;
    }
    drawTileOnTerrain(...e) {
        $435bc7696844e930$export$55c5e09254f6444.prototype.drawTile.call(this, ...e);
    }
    createTerrainTexture(e) {
        const t = this.layer.getTileSize().width, n = 2 * t, i = 2 * t, r = e.texture({
            min: "linear",
            mag: "linear",
            type: "uint8",
            width: n,
            height: i
        });
        this._terrainDepthStencil || (this._terrainDepthStencil = e.renderbuffer({
            width: n,
            height: i,
            format: "depth24 stencil8"
        }));
        const s = {
            width: n,
            height: i,
            colors: [
                r
            ],
            colorFormat: "rgba",
            ignoreStatusCheck: !0
        };
        s.depthStencil = this._terrainDepthStencil;
        const o = e.framebuffer(s);
        return o.colorTex = r, o;
    }
    deleteTerrainTexture(e) {
        e.destroy(), e.colorTex && (e.colorTex.destroy(), delete e.colorTex);
    }
    renderTerrainSkin(e, t, n) {
        const i = this._currentTimestamp, r = this._parentContext, s = this.layer.getTileSize().width;
        this._startFrame(i);
        for(let t = 0; t < n.length; t++){
            const i = n[t].texture;
            this._parentContext = {
                renderTarget: {
                    fbo: i
                }
            }, $435bc7696844e930$var$Ye.framebuffer = i, e.clear($435bc7696844e930$var$Ye), this._parentContext.viewport = $435bc7696844e930$var$tt(s), this._drawTerrainTile(n[t].tile, i);
        }
        this._endTerrainFrame(n), this._parentContext = r;
    }
    _drawTerrainTile(e) {
        const { info: t, image: n } = e;
        this.drawTile(t, n, $435bc7696844e930$var$Ze);
    }
    _endTerrainFrame(e) {
        const t = this._getAllPlugins(), n = this.getMap().cameraPosition, i = this._currentTimestamp || 0;
        this.layer.options.collision ? t.forEach((e)=>{
            if (!this._isVisible(e) || !e.hasMesh()) return;
            if (!$435bc7696844e930$var$Ze(e) || !this.layer.options.awareOfTerrain) return;
            const t = this._getPluginContext(e, 0, n, i);
            t.isRenderingTerrainSkin = !0, e.prepareRender(t), e.updateCollision(t);
        }) : t.forEach((e)=>{
            if (!this._isVisible(e) || !e.hasMesh()) return;
            if (!$435bc7696844e930$var$Ze(e) || !this.layer.options.awareOfTerrain) return;
            const t = this._getPluginContext(e, 0, n, i);
            t.isRenderingTerrainSkin = !0, e.prepareRender(t);
        }), t.forEach((t, n)=>{
            if (!this._isVisitable(t) || !$435bc7696844e930$var$Ze(t)) return;
            for(let t = 0; t < e.length; t++){
                const n = e[t].texture;
                this.regl.clear({
                    stencil: 255,
                    framebuffer: n
                });
            }
            const i = this._pluginOffsets[n] || 0, r = this._getPluginContext(t, i, [
                0,
                0,
                0
            ], this._currentTimestamp);
            r.isRenderingTerrainSkin = !0, t.endFrame(r);
        });
    }
    drawTile(e, t, n) {
        if (!t.cache) return;
        const i = this._isRenderingTerrain(), r = t.cache, s = $435bc7696844e930$var$We.set(e.extent2d.xmin, e.extent2d.ymax), o = e.extent || this._receivedTileExtent || 8192, a = e.transform = e.transform || this.calculateTileMatrix(s, e.z, o), l = e.tileTranslationMatrix = e.tileTranslationMatrix || this.calculateTileTranslationMatrix(s, e.z), h = e.terrainTransform = e.terrainTransform || this.calculateTerrainTileMatrix(s, e.z, o), c = this._parentContext, u = [];
        $435bc7696844e930$var$Y(u, t.data), $435bc7696844e930$var$Y(u, t.featureData);
        this._getFramePlugins(t).forEach((s, o)=>{
            if (!s || n && !n(s)) return;
            if (!u[o]) return;
            if (!r[o]) return;
            const f = i && $435bc7696844e930$var$Ze(s), d = this.regl, p = this.gl, g = {
                regl: d,
                layer: this.layer,
                gl: p,
                sceneConfig: s.config.sceneConfig,
                pluginIndex: o,
                tileCache: r[o],
                tileData: u[o],
                tileTransform: f ? h : a,
                tileVectorTransform: a,
                tileTranslationMatrix: l,
                tileExtent: t.extent,
                timestamp: this._frameTime,
                tileInfo: e,
                tileZoom: this._tileZoom,
                bloom: this._parentContext && this._parentContext.bloom,
                isRenderingTerrain: i,
                isRenderingTerrainSkin: f
            };
            f && c && c.renderTarget && (g.renderTarget = c.renderTarget);
            const m = s.paintTile(g);
            !this._needRetire && (m.retire || m.redraw) && s.supportRenderMode("taa") && (this._needRetire = !0), m.redraw && this.setToRedraw();
        }), t && t.style === this._styleCounter && this._retirePrevTile(e), this.setCanvasUpdated();
    }
    _createOneTile(e, t) {
        if (!t.loadTime || t._empty) return;
        let n = t.cache;
        n || (n = t.cache = {});
        const i = this._isRenderingTerrain(), r = $435bc7696844e930$var$We.set(e.extent2d.xmin, e.extent2d.ymax), s = e.transform = e.transform || this.calculateTileMatrix(r, e.z, t.extent), o = e.tileTranslationMatrix = e.tileTranslationMatrix || this.calculateTileTranslationMatrix(r, e.z), a = e.terrainTransform = e.terrainTransform || this.calculateTerrainTileMatrix(r, e.z, e.extent), l = [];
        $435bc7696844e930$var$Y(l, t.data), $435bc7696844e930$var$Y(l, t.featureData);
        this._getFramePlugins(t).forEach((r, h)=>{
            if (!r) return;
            if (!l[h]) return;
            const c = i && $435bc7696844e930$var$Ze(r), u = this.regl, f = this.gl;
            n[h] || (n[h] = {});
            const d = {
                regl: u,
                layer: this.layer,
                gl: f,
                sceneConfig: r.config.sceneConfig,
                pluginIndex: h,
                tileCache: n[h],
                tileData: l[h],
                tileTransform: c ? a : s,
                tileVectorTransform: s,
                isRenderingTerrain: i,
                isRenderingTerrainSkin: c,
                tileTranslationMatrix: o,
                tileExtent: t.extent,
                timestamp: this._frameTime,
                tileInfo: e,
                tileZoom: this._tileZoom
            }, p = r.createTile(d);
            n[h].geometry && (t.data[h] = 1), !this._needRetire && p.retire && r.supportRenderMode("taa") && (this._needRetire = !0);
        });
    }
    checkTileInQueue(e) {
        return e.styleCounter === this._styleCounter;
    }
    pick(e, t, n) {
        const i = [];
        if (!this.layer.isVisible()) return i;
        return this._getFramePlugins().forEach((r)=>{
            if (!r) return;
            if (!this._isVisible(r)) return;
            const s = r.pick(e, t, n.tolerance);
            s && (s.type = r.getType(), i.push(s));
        }), i;
    }
    deleteTile(e) {
        if (e) {
            if (e.image && !e.image._empty) {
                const t = e.image && e.image.style, n = this._getStylePlugins(t);
                n && n.forEach((t, n)=>{
                    t && t.deleteTile({
                        pluginIndex: n,
                        regl: this.regl,
                        layer: this.layer,
                        gl: this.gl,
                        tileCache: e.image.cache ? e.image.cache[n] : {},
                        tileInfo: e.info,
                        tileData: e.image
                    });
                }), e.image.cache = {};
            }
            e.info && (delete e.info.completeTerrainQuery, delete e.info.terrainQueryStatus), super.deleteTile(e);
        }
    }
    abortTileLoading(e, t) {
        const n = t ? $435bc7696844e930$var$it(t) : "";
        t && t.url && (this._workerConn && this._workerConn.abortTile(n), delete this._requestingMVT[t.url]), this.loadTileArrayBuffer && $435bc7696844e930$var$j(this.loadTileArrayBuffer) ? this.loadTileArrayBuffer(n, t, ()=>{}, {
            command: "abortTile"
        }) : super.abortTileLoading(e, t);
    }
    resizeCanvas(e) {
        super.resizeCanvas(e);
        const t = this.canvas;
        t && (!this.pickingFBO || this.pickingFBO.width === t.width && this.pickingFBO.height === t.height || (this.pickingFBO.resize(t.width, t.height), this._getFramePlugins().forEach((e)=>{
            e && e.resize(t.width, t.height);
        })));
    }
    onRemove() {
        this._stencilRenderer && this._stencilRenderer.remove(), this._workerConn && (this._workerConn.removeLayer((e)=>{
            if (e) throw e;
        }), this._workerConn.remove(), delete this._workerConn), this.pickingFBO && (this.canvas.pickingFBO || this.pickingFBO.destroy(), delete this.pickingFBO), this._debugPainter && (this._debugPainter.delete(), delete this._debugPainter), this._terrainDepthStencil && (this._terrainDepthStencil.destroy(), delete this._terrainDepthStencil), this._groundPainter && (this._groundPainter.dispose(), delete this._groundPainter), super.onRemove && super.onRemove(), this._clearPlugin();
    }
    _clearPlugin() {
        this._getAllPlugins().forEach((e)=>{
            e.remove();
        }), this.plugins = {};
    }
    hitDetect(e) {
        if (!this.gl || !this.layer.options.hitDetect) return !1;
        const t = this.gl, n = new Uint8Array(4), i = this.canvas.height;
        return t.readPixels(e.x, i - e.y, 1, 1, t.RGBA, t.UNSIGNED_BYTE, n), n[3] > 0;
    }
    _initPlugins() {
        const { style: e, featureStyle: t } = this.layer._getComputedStyle(), n = e.map((e, t)=>{
            const n = e.renderPlugin;
            if (!n) return null;
            if (!n.type) throw new Error("invalid plugin type for style at " + t);
            const i = this._createRenderPlugin(n);
            return i.styleCounter = this._styleCounter, i.style = e, i;
        }), i = [];
        t.forEach((e, t)=>{
            const n = e.renderPlugin;
            if (!n) return null;
            if (!n.type) throw new Error("invalid plugin type for features at " + t);
            const r = this._createRenderPlugin(n);
            return r.style = e, r.styleCounter = this._styleCounter, i.push(r), r;
        });
        const r = this._styleCounter;
        if (this._plugins[r] = n, this._featurePlugins[r] = i, this.layer.fire("pluginsinited"), this._highlighted && this._highlighted.size || this.layer._highlighted) {
            this.layer._highlighted && this.layer._resumeHighlights();
            this.getMap().getRenderer().callInNextFrame(()=>{
                this._getFramePlugins().forEach((e)=>{
                    e.highlight(this._highlighted);
                });
            });
        }
        return n;
    }
    _createRenderPlugin(e) {
        const t = this.layer.constructor.getPlugins()[e.type];
        if (!t) throw new Error(`Plugin for (${e.type}) is not loaded.`);
        const n = new t;
        return n.config = e, n.config.sceneConfig || (n.config.sceneConfig = {}), n;
    }
    _createGLContext(e, t) {
        const n = [
            "webgl",
            "experimental-webgl"
        ];
        let i = null;
        for(let r = 0; r < n.length; ++r){
            try {
                i = e.getContext(n[r], t);
            } catch (e) {}
            if (i) break;
        }
        return i;
    }
    _getCentiMeterScale(e) {
        return $435bc7696844e930$var$$(e, this.getMap());
    }
    debugFBO(e, t) {
        const n = document.getElementById(e), i = t.width, r = t.height;
        n.width = i, n.height = r;
        const s = n.getContext("2d"), o = this.regl.read({
            framebuffer: t
        }), a = r / 2 | 0, l = 4 * i;
        for(let e = 0; e < o.length; e++)o[e] *= 255;
        const h = new Uint8Array(4 * i);
        for(let e = 0; e < a; ++e){
            const t = e * l, n = (r - e - 1) * l;
            h.set(o.subarray(t, t + l)), o.copyWithin(t, n, n + l), o.set(h, n);
        }
        const c = new ImageData(i, r);
        c.data.set(o), s.putImageData(c, 0, 0);
    }
    _getDefaultRenderPlugin(e) {
        let t;
        switch(e){
            case "native-line":
                t = {
                    type: "native-line",
                    dataConfig: {
                        type: "native-line",
                        only2D: !0
                    }
                };
                break;
            case "native-point":
                t = {
                    type: "native-point",
                    dataConfig: {
                        type: "native-point",
                        only2D: !0
                    }
                };
                break;
            case "fill":
                t = {
                    type: "fill",
                    dataConfig: {
                        type: "fill",
                        only2D: !0
                    },
                    sceneConfig: {
                        antialias: !0
                    }
                };
                break;
            default:
                t = null;
        }
        const n = function(e) {
            switch(e){
                case "native-point":
                    return {
                        markerFill: "#f00",
                        markerSize: 6,
                        markerOpacity: .5
                    };
                case "native-line":
                    return {
                        lineColor: "#bbb",
                        lineOpacity: .5
                    };
                case "fill":
                    return {
                        polygonFill: "#76a6f0",
                        polygonOpacity: .8
                    };
            }
            return null;
        }(e), i = this._createRenderPlugin(t);
        return i.defaultSymbol = n, {
            plugin: i,
            symbol: n,
            renderPlugin: t
        };
    }
    _isVisible() {
        return !0;
    }
    isEnableWorkAround(e) {
        return "win-intel-gpu-crash" === e && this.layer.options.workarounds["win-intel-gpu-crash"] && function(e) {
            const t = e.getExtension("WEBGL_debug_renderer_info");
            if (t && "undefined" != typeof navigator) {
                const n = e.getParameter(t.UNMASKED_RENDERER_WEBGL), i = "Win32" === navigator.platform || "Win64" === navigator.platform;
                if (n && n.toLowerCase().indexOf("intel") >= 0 && i) return !0;
            }
            return !1;
        }(this.gl);
    }
    getZScale() {
        return this._zScale;
    }
    outline(e, t) {
        t && (Array.isArray(t) || (t = [
            t
        ]), this._outline || (this._outline = []), this._outline.push([
            "paintOutline",
            [
                e,
                t
            ]
        ]), this.setToRedraw());
    }
    outlineFeatures(e) {
        e && (Array.isArray(e) || (e = [
            e
        ]), this._outline || (this._outline = []), this._outline.push([
            "paintOutline",
            [
                null,
                e
            ]
        ]), this.setToRedraw());
    }
    outlineBatch(e) {
        this._outline || (this._outline = []), this._outline.push([
            "paintBatchOutline",
            [
                e
            ]
        ]), this.setToRedraw();
    }
    outlineAll() {
        this._outlineAll = !0, this.setToRedraw();
    }
    paintOutlineAll(e) {
        const t = this._getFramePlugins();
        for(let n = 0; n < t.length; n++)t[n].outlineAll(e);
    }
    paintOutline(e, t, n) {
        if (!$435bc7696844e930$var$X(t)) {
            const i = t, r = this._getFramePlugins();
            if (!r[i] || r[i].painter && !r[i].painter.isVisible()) return;
            return void r[i].outline(e, n);
        }
        const i = this._getFramePlugins();
        for(let t = 0; t < n.length; t++){
            const r = n[t];
            for(let t = 0; t < i.length; t++)i[t].style && i[t].style.id === r && i[t].outline(e, [
                r
            ]);
        }
    }
    paintBatchOutline(e, t) {
        const n = this._getFramePlugins();
        !n[t] || n[t].painter && !n[t].painter.isVisible() || n[t].outlineAll(e);
    }
    cancelOutline() {
        delete this._outline, delete this._outlineAll, this.setToRedraw();
    }
    setZIndex() {
        return this.setToRedraw(), this._needRetire = !0, super.setZIndex.apply(this, arguments);
    }
    consumeTile(e, t) {
        if (e && !e._empty) {
            const [n, i] = this._findTileAltitude(e);
            t.minAltitude = n, t.maxAltitude = i;
        }
        if (this._retirePrevTile(t), super.consumeTile(e, t), "transient" === this.layer.options.features && e.data) {
            for(let t = 0; t < e.data.length; t++){
                if (!e.data[t]) continue;
                const n = e.data[t].features;
                if (n) for(const e in n){
                    const t = n[e] && n[e].feature;
                    t && (t.fnTypeProps ? t.customProps[$435bc7696844e930$var$ve] = t.fnTypeProps : n[e] = null);
                }
            }
            this.layer.fire("_transientfeature", {
                tileImage: e
            });
        }
        e && e.features && (e.features = []), this._createOneTile(t, e);
    }
    _findTileAltitude(e) {
        const t = e.data;
        let n = -1 / 0, i = 1 / 0;
        for(let e = 0; e < t.length; e++){
            if (!t[e]) continue;
            const r = t[e].data;
            if (r) for(let e = 0; e < r.length; e++){
                const t = r[e];
                if (!t || !t.properties) continue;
                const { maxAltitude: s, minAltitude: o } = t.properties;
                s > n && (n = s), o < i && (i = o);
            }
        }
        return $435bc7696844e930$var$Xe[0] = i === 1 / 0 ? 0 : i, $435bc7696844e930$var$Xe[1] = n === -1 / 0 ? 0 : n, $435bc7696844e930$var$Xe;
    }
    onTileError(e, t) {
        this._retirePrevTile(t), super.onTileError(e, t);
    }
    _retirePrevTile(e) {
        const { id: t } = e;
        if (this._prevTilesInView && this._prevTilesInView[t]) {
            const e = this._prevTilesInView[t];
            this.deleteTile(e), delete this._prevTilesInView[t];
        }
    }
    highlight(e) {
        if (this._highlighted || (this._highlighted = new Map), Array.isArray(e)) for(let t = 0; t < e.length; t++)$435bc7696844e930$var$X(e[t].name) && !$435bc7696844e930$var$X(e[t].id) && (e[t] = $435bc7696844e930$var$U({}, e[t]), e[t].name = e[t].id), this._highlighted.set(e[t].name, e[t]);
        else $435bc7696844e930$var$X(e.name) && !$435bc7696844e930$var$X(e.id) && ((e = $435bc7696844e930$var$U({}, e)).name = e.id), this._highlighted.set(e.name, e);
        this._getFramePlugins().forEach((e)=>{
            e.highlight(this._highlighted);
        }), this._highlightUpdated = !0;
    }
    cancelHighlight(e) {
        if (!this._highlighted) return;
        if (Array.isArray(e)) for(let t = 0; t < e.length; t++)this._highlighted.delete(e[t]);
        else this._highlighted.delete(e);
        this._getFramePlugins().forEach((e)=>{
            e.highlight(this._highlighted);
        }), this._highlightUpdated = !0;
    }
    cancelAllHighlight() {
        if (!this._highlighted) return;
        delete this._highlighted;
        this._getFramePlugins().forEach((e)=>{
            e.cancelAllHighlight();
        }), this._highlightUpdated = !0;
    }
    _getLayerOpacity() {
        const e = this.layer.options.opacity;
        return this._isInGroupGLLayer() ? $435bc7696844e930$var$X(e) ? 1 : e : 1;
    }
    _isRenderingTerrain() {
        return !!this._terrainLayer && this.layer.options.awareOfTerrain;
    }
}
function $435bc7696844e930$var$Je(e) {
    let t;
    Array.isArray(e.data) ? (t = [], $435bc7696844e930$var$Y(t, e.data)) : (t = {}, $435bc7696844e930$var$U(t, e.data));
    const n = $435bc7696844e930$var$U({}, e);
    return n.data = t, n;
}
function $435bc7696844e930$var$Ke(e, t) {
    return t.info.z - e.info.z;
}
function $435bc7696844e930$var$Qe(e) {
    const t = {};
    for(let n = 0; n < e.length; n++){
        const i = e[n].layer || "default";
        t[i] || (t[i] = []), t[i].push(e[n]);
    }
    return t;
}
function $435bc7696844e930$var$et(e) {
    if (Array.isArray(e)) {
        const t = e;
        for(let e = 0; e < t.length; e++)if ($435bc7696844e930$var$et(t[e])) return !0;
    }
    for(const t in e)if ((0, $14507960c5dac0fb$export$ec423ecbfcdb9a06)(e[t]) || $435bc7696844e930$var$Be.isExpression(e[t])) return !0;
    return !1;
}
function $435bc7696844e930$var$tt(e) {
    return {
        x: 0,
        y: 0,
        width: 2 * e,
        height: 2 * e
    };
}
function $435bc7696844e930$var$nt(e) {
    if (!e.cache) return [];
    for(const t in e.cache){
        const n = e.cache[t];
        if (n.geometry) for(let e = 0; e < n.geometry.length; e++){
            const t = n.geometry[e] && n.geometry[e].geometry;
            if (t && t.properties && t.properties.features) {
                const e = t.properties.features.empty;
                delete t.properties.features.empty;
                const n = Object.values(t.properties.features);
                return void 0 !== e && (t.properties.features.empty = e), n;
            }
        }
    }
    return [];
}
function $435bc7696844e930$var$it(t) {
    return $gP1US.Util.getAbsoluteURL(t.url);
}
$435bc7696844e930$export$55c5e09254f6444.include({
    calculateTileMatrix: function() {
        const e = new Array(3), t = new Array(3), n = new Array(3);
        return function(i, r, s) {
            const l = this.getTileGLScale(r), h = i, c = this.layer.getTileSize().width, u = (0, $3iqbd).identity([]);
            return (0, $3iqbd).scale(u, u, (0, $eIStk).set(e, l, l, this._zScale)), (0, $3iqbd).translate(u, u, (0, $eIStk).set(t, h.x, h.y, 0)), (0, $3iqbd).scale(u, u, (0, $eIStk).set(n, c / s, -c / s, 1)), u;
        };
    }(),
    calculateTerrainTileMatrix: function() {
        const e = new Array(3);
        return function(t, n, i) {
            const r = (0, $3iqbd).identity([]), s = i / 2;
            return (0, $3iqbd).scale(r, r, (0, $eIStk).set(e, 1 / s, -1 / s, 0)), (0, $3iqbd).translate(r, r, (0, $eIStk).set(e, -s, -s, 0)), r;
        };
    }(),
    calculateTileTranslationMatrix: function() {
        const e = new Array(3);
        return function(t, n) {
            const i = this.getTileGLScale(n), r = t, s = (0, $3iqbd).identity([]);
            return (0, $3iqbd).translate(s, s, (0, $eIStk).set(e, r.x * i, r.y * i, 0)), s;
        };
    }()
});
const { PackUtil: $435bc7696844e930$var$rt } = $435bc7696844e930$var$H(), $435bc7696844e930$var$st = new $gP1US.Point(0, 0), $435bc7696844e930$var$ot = new $gP1US.Coordinate(0, 0), $435bc7696844e930$var$at = [
    null,
    0
], $435bc7696844e930$var$lt = [];
class $435bc7696844e930$export$ab7f86d6b8cd9f25 extends $gP1US.TileLayer {
    static loadFrom(e, t) {
        return fetch(e, t || {}).then((e)=>e.json()).then((e)=>$435bc7696844e930$export$ab7f86d6b8cd9f25.fromJSON(e));
    }
    constructor(e, t){
        super(e, t), this._schema = {}, this.VERSION = $435bc7696844e930$export$ab7f86d6b8cd9f25.VERSION;
        const n = t && t.style;
        this.setStyle(n);
    }
    setURLModifier(e) {
        this._urlModifier = e;
        const t = this.getRenderer();
        return t && t.updateOptions(), this;
    }
    getURLModifier() {
        return this._urlModifier;
    }
    onAdd() {
        const e = this.getMap();
        this._prepareOptions();
        const t = this.getSpatialReference().toJSON().projection, n = e.getSpatialReference().toJSON().projection;
        if ((t && t.toLowerCase()) !== (n && n.toLowerCase())) throw new Error(`VectorTileLayer's projection(${t}) must be the same with map(${n}).`);
    }
    setFeatureState(e, t) {
        if ($435bc7696844e930$var$X(e.id)) throw new Error("missing id in first parameter of setFeatureState.");
        this._featureStates || (this._featureStates = {});
        const n = e.layer || "0";
        let i = this._featureStates[n];
        return this._featureStates[n] || (i = this._featureStates[n] = new Map), i.set(e.id, t), this._markFeatureState(), this;
    }
    removeFeatureState(e, t) {
        if ($435bc7696844e930$var$X(e.id)) throw new Error("missing id in first parameter of removeFeatureState.");
        if (!this._featureStates) return this;
        const n = e.layer || "0", i = this._featureStates[n];
        if (!i) return this;
        if (t) {
            const n = i.get(e.id);
            if ($435bc7696844e930$var$W(t)) for(const e in t)delete n[e];
            else delete n[t];
            i.set(e.id, n);
        } else i.delete(e.id);
        return this._markFeatureState(), this;
    }
    getFeatureState(e) {
        if ($435bc7696844e930$var$X(e.id)) throw new Error("missing id in first parameter of getFeatureState.");
        if (!this._featureStates) return null;
        const t = e.layer || "0";
        return this._featureStates[t].get(e.id);
    }
    _markFeatureState() {
        const e = this.getRenderer();
        if (!e) return;
        const t = e.getFrameTimestamp();
        this._featureStamp = t;
    }
    _getFeatureStateStamp() {
        return this._featureStamp;
    }
    _isFeatureStateDirty(e) {
        return this._featureStamp && this._featureStamp !== e;
    }
    _prepareOptions() {
        const e = this.options, t = this.getMap().getProjection(), n = "EPSG:4326" === t.code || "EPSG:4490" === t.code, i = "EPSG:3857" === t.code;
        if (!e.spatialReference) 512 === this.getTileSize().width && (i ? e.spatialReference = "preset-vt-3857" : n && (e.spatialReference = "preset-vt-4326"));
        e.tileSystem || (e.tms ? i ? e.tileSystem = [
            1,
            1,
            -6378137 * Math.PI,
            -6378137 * Math.PI
        ] : n && (e.tileSystem = [
            1,
            1,
            -180,
            -90
        ]) : n && (e.tileSystem = [
            1,
            -1,
            -180,
            90
        ]));
    }
    forceReload() {
        const e = this.getRenderer();
        return e && e._incrWorkerCacheIndex(), super.forceReload();
    }
    onWorkerReady() {}
    onConfig(e) {
        const t = this.getRenderer();
        t && t.updateOptions(e);
    }
    getWorkerOptions() {
        return {
            debug: this.options.debug,
            debugTile: this.options.debugTile,
            altitudeProperty: this.options.altitudeProperty,
            tileSize: this.getTileSize().width,
            style: this.isDefaultRender() ? {
                style: [],
                featureStyle: []
            } : this._getComputedStyle(),
            features: this.options.debugTileData || this.options.features,
            schema: this.options.schema,
            pickingGeometry: this.options.pickingGeometry,
            projectionCode: this.getSpatialReference().getProjection().code,
            workerGlyph: this.options.workerGlyph && !this.getURLModifier(),
            featureIdProperty: this.options.featureIdProperty
        };
    }
    setStyle(e) {
        if (e && ($435bc7696844e930$var$B(e) || e.url)) {
            const t = e, n = t.lastIndexOf("/"), i = n < 0 ? "." : t.substring(0, n);
            return this.ready = !1, $435bc7696844e930$var$Q.getJSON(e.url ? e.url : e, e.url ? e : {}, (e, n)=>{
                if (e) throw this.setStyle([]), e;
                let r;
                n.style ? (r = n, r.$root || (r.$root = i)) : r = {
                    $root: i,
                    style: n
                }, this.options.style = t, this._setStyle(r);
            }), this;
        }
        return this.options.style = e, this._setStyle(e), this;
    }
    _tilePointToPoint(e, t, n, i) {
        const r = i / this.getTileSize().width;
        return e.set(n.x + t.x / r, n.y - t.y / r);
    }
    queryTilePointTerrain(e, t, n, i, r) {
        const s = this.getRenderer(), o = s && s.getTerrainHelper();
        if (!s || !o) return $435bc7696844e930$var$at[0] = null, $435bc7696844e930$var$at[1] = 0, $435bc7696844e930$var$at;
        const a = this._tilePointToPoint($435bc7696844e930$var$st, e, n, i);
        return t && o.queryTileTerrainByPointAtRes ? o.queryTileTerrainByPointAtRes(a, r, t.id, t, $435bc7696844e930$var$lt) : ($435bc7696844e930$var$at[0] = null, $435bc7696844e930$var$at[1] = 0, $435bc7696844e930$var$at);
    }
    queryTerrainTiles(e) {
        const t = this.getRenderer(), n = t && t.getTerrainHelper();
        return t && n ? n.getTerrainTiles(e) : null;
    }
    _setStyle(e) {
        if (e && e.$root) {
            let t = e.$root;
            t && "/" === t[t.length - 1] && (t = t.substring(0, t.length - 1)), this._replacer = function(e) {
                return "{$root}" === e ? t : null;
            };
        }
        this.ready = !0, e = e || [], Array.isArray(e) ? e = {
            style: e
        } : e.renderPlugin && (e = {
            style: [
                e
            ]
        }), e = function(e) {
            if (!e.plugins) return e;
            const { plugins: t, styles: n } = e;
            let { style: i, featureStyle: r } = n;
            i = i || [], r = r || [];
            const s = new Array(i.length);
            for(let e = 0; e < i.length; e++)s[e] = $435bc7696844e930$var$U({}, i[e]), s[e].renderPlugin = t[i[e].renderPlugin];
            const o = new Array(r.length);
            for(let e = 0; e < r.length; e++)o[e] = $435bc7696844e930$var$U({}, r[e]), o[e].renderPlugin = t[r[e].renderPlugin];
            const a = {
                style: s,
                featureStyle: o
            };
            return e.$root && (a.$root = e.$root), a;
        }(e = JSON.parse(JSON.stringify(e))), this._originFeatureStyle = e.featureStyle || [], this._featureStyle = function(e) {
            if (!e || !Array.isArray(e)) return [];
            const t = [];
            for(let n = 0; n < e.length; n++){
                const i = e[n].style;
                if (i && Array.isArray(i) && i.length) for(let r = 0; r < i.length; r++){
                    const s = $435bc7696844e930$var$U({}, e[n], i[r]);
                    i[r]._renderIdx = t.length, delete s.style, t.push(s);
                }
                else t.push($435bc7696844e930$var$U({}, e[n]));
            }
            return t;
        }(e.featureStyle), this._vtStyle = e.style || [];
        const t = e.background || {};
        this._background = {
            enable: t.enable || !1,
            color: $435bc7696844e930$var$ut(t.color) || [
                0,
                0,
                0,
                0
            ],
            opacity: $435bc7696844e930$var$ft(t.opacity, 1),
            patternFile: t.patternFile,
            depthRange: t.depthRange
        }, this.validateStyle(), this._replacer && this._parseStylePath(), this._compileStyle();
        const n = this.getRenderer();
        n && n.setStyle(), this.fire("setstyle", {
            style: this.getStyle(),
            computedStyle: this.getComputedStyle()
        });
    }
    getPolygonOffsetCount() {
        const e = this.getRenderer();
        return e ? e.getPolygonOffsetCount() : 0;
    }
    getPolygonOffset() {
        return this._polygonOffset || 0;
    }
    setPolygonOffset(e, t) {
        return this._polygonOffset = e, this._totalPolygonOffset = t, this;
    }
    getTotalPolygonOffset() {
        return this._totalPolygonOffset;
    }
    _convertFeatures(e) {
        if (!e || !e.length) return;
        const t = this._getTileConfig();
        let n;
        for(let i = 0, r = e.length; i < r; i++){
            const { feature: r, tile: s } = e[i], o = r.geometry;
            if (!r || !s || !o) continue;
            if (o.type) continue;
            const { x: a, y: l, res: h, extent: c } = s;
            undefined === a && undefined === l && undefined === h || (n = t.getTilePointNW(a, l, h));
            const u = r.type, f = this._convertGeometry(u, o, n, c, h);
            r.geometry = f;
        }
    }
    getRenderedFeatures() {
        const e = this.getRenderer();
        if (!e) return [];
        const t = e.getRenderedFeatures() || [];
        for(let e = 0, n = t.length; e < n; e++){
            const n = t[e];
            if (!n) continue;
            const i = n.features || [];
            this._convertFeatures(i);
        }
        return t;
    }
    getRenderedFeaturesAsync(t = {}) {
        return new Promise((n, i)=>{
            const r = this.getRenderer();
            if (r) {
                if ($gP1US.MicroTask) {
                    const i = r.getRenderedFeatures() || [], s = [];
                    i.forEach((e)=>{
                        const t = e.features || [];
                        t.length && $435bc7696844e930$var$Y(s, t);
                    });
                    const o = (t = Object.assign({}, {
                        countPerTime: 1e4
                    }, t)).countPerTime, a = Math.ceil(s.length / o);
                    let l = 1;
                    const h = ()=>{
                        const e = (l - 1) * o, t = l * o, n = s.slice(e, t);
                        this._convertFeatures(n), l++;
                    };
                    $gP1US.MicroTask.runTaskAsync({
                        count: a,
                        run: h
                    }).then(()=>{
                        n(i);
                    });
                } else n(this.getRenderedFeatures());
            } else n([]);
        });
    }
    outlineAll() {
        const e = this.getRenderer();
        return e ? (e.outlineAll(), this) : this;
    }
    outline(e, t) {
        const n = this.getRenderer();
        return n ? (n.outline(e, t), this) : this;
    }
    outlineBatch(e) {
        const t = this.getRenderer();
        return t ? (t.outlineBatch(e), this) : this;
    }
    outlineFeatures(e) {
        const t = this.getRenderer();
        return t ? (t.outlineFeatures(e), this) : this;
    }
    cancelOutline() {
        const e = this.getRenderer();
        return e ? (e.cancelOutline(), this) : this;
    }
    highlight(e) {
        this._validateHighlight(e);
        const t = this.getRenderer();
        return t ? (t.highlight(e), this) : (this._highlighted || (this._highlighted = []), this._highlighted.push(e), this);
    }
    _validateHighlight(e) {
        if (Array.isArray(e)) for(let t = 0; t < e.length; t++)this._validateHighlight(e[t]);
        else {
            if (e.filter) {
                if (!this.options.features) throw new Error("options.features must be turned on to support filter in highlight");
                if (!e.name) throw new Error("A name is required for highlight with filter");
            }
            if ($435bc7696844e930$var$X(e.filter) && $435bc7696844e930$var$X(e.id)) throw new Error("id or filter must be provided for highlight");
        }
    }
    _resumeHighlights() {
        if (this._highlighted) {
            for(let e = 0; e < this._highlighted.length; e++)this.highlight(this._highlighted[e]);
            delete this._highlighted;
        }
    }
    cancelHighlight(e) {
        const t = this.getRenderer();
        return t ? (t.cancelHighlight(e), this) : this;
    }
    cancelAllHighlight() {
        const e = this.getRenderer();
        return e ? (e.cancelAllHighlight(), this) : this;
    }
    _parseStylePath() {
        $gP1US.Util.convertStylePath(this._vtStyle, this._replacer), $gP1US.Util.convertStylePath(this._featureStyle, this._replacer);
    }
    updateSceneConfig(e, t) {
        return $435bc7696844e930$var$B(e) && (e = this._getStyleIndex(e)), this._updateSceneConfig(0, e, t);
    }
    updateFeatureSceneConfig(e, t, n) {
        return this._updateSceneConfig(1, e, n, t);
    }
    _updateSceneConfig(e, t, n, i) {
        const r = this._getTargetStyle(e);
        if (!r) return this;
        let s, o = t;
        if (r[t].renderPlugin.sceneConfig || (r[t].renderPlugin.sceneConfig = {}), $435bc7696844e930$var$U(r[t].renderPlugin.sceneConfig, n), void 0 !== i) {
            $435bc7696844e930$var$dt(this._originFeatureStyle, t, i), o = this._originFeatureStyle[t].style[i]._renderIdx;
            const e = r[o].renderPlugin;
            e.sceneConfig || (e.sceneConfig = {}), s = e.sceneConfig;
        } else $435bc7696844e930$var$pt(r, t), s = r[t].renderPlugin.sceneConfig;
        if ($435bc7696844e930$var$U(s, n), Array.isArray(this.options.style)) {
            const e = this.options.style[t].renderPlugin;
            e.sceneConfig || (e.sceneConfig = {}), $435bc7696844e930$var$U(e.sceneConfig, n);
        } else {
            const r = this._getTargetStyle(e, this.options.style);
            let s;
            void 0 !== i ? ($435bc7696844e930$var$dt(r, t, i), s = r[t].style[i].renderPlugin) : ($435bc7696844e930$var$pt(r, t), s = r[t].renderPlugin), s.sceneConfig || (s.sceneConfig = {}), $435bc7696844e930$var$U(s.sceneConfig, n);
        }
        const a = this.getRenderer();
        return a && a.updateSceneConfig(e, o, n), 0 === e ? this.fire("updatesceneconfig", {
            index: t,
            sceneConfig: n
        }) : 1 === e && this.fire("updatefeaturesceneconfig", {
            index: t,
            styleIdx: i,
            sceneConfig: n
        }), this;
    }
    updateDataConfig(e, t) {
        return $435bc7696844e930$var$B(e) && (e = this._getStyleIndex(e)), this._updateDataConfig(0, e, t);
    }
    updateFeatureDataConfig(e, t, n) {
        return this._updateDataConfig(1, e, n, t);
    }
    _updateDataConfig(e, t, n, i) {
        const r = this._getTargetStyle(e);
        if (!r) return this;
        let s, o = t;
        void 0 !== i ? ($435bc7696844e930$var$dt(this._originFeatureStyle, t, i), o = this._originFeatureStyle[t].style[i]._renderIdx, s = r[o].renderPlugin.dataConfig) : ($435bc7696844e930$var$pt(r, t), s = r[t].renderPlugin.dataConfig);
        const a = $435bc7696844e930$var$U({}, s);
        if ($435bc7696844e930$var$U(s, n), Array.isArray(this.options.style)) $435bc7696844e930$var$U(this.options.style[t].renderPlugin.dataConfig, n);
        else {
            const r = this._getTargetStyle(e, this.options.style);
            let s;
            void 0 !== i ? ($435bc7696844e930$var$dt(r, t, i), s = r[t].style[i].renderPlugin) : ($435bc7696844e930$var$pt(r, t), s = r[t].renderPlugin), s.dataConfig || (s.dataConfig = {}), $435bc7696844e930$var$U(s.dataConfig, n);
        }
        const l = this.getRenderer();
        return l && l.updateDataConfig(e, o, n, a), 0 === e ? this.fire("updatedataconfig", {
            index: t,
            dataConfig: n
        }) : 1 === e && this.fire("updatefeaturedataconfig", {
            index: t,
            styleIdx: i,
            dataConfig: n
        }), this;
    }
    updateSymbol(e, t) {
        return $435bc7696844e930$var$B(e) && (e = this._getStyleIndex(e)), this._updateSymbol(0, e, t);
    }
    updateFeatureSymbol(e, t, n) {
        return this._updateSymbol(1, e, n, t);
    }
    _updateSymbol(t, n, i, r) {
        const s = this._getTargetStyle(t);
        if (!s) return this;
        let o = n;
        void 0 !== r && ($435bc7696844e930$var$dt(this._originFeatureStyle, n, r), o = this._originFeatureStyle[n].style[r]._renderIdx);
        const a = s[o];
        if (!a) throw new Error(`No style defined at ${n}`);
        const l = this, h = this._replacer;
        function c(i, s, o) {
            if (!i) return !1;
            h && (i = JSON.parse(JSON.stringify(i)), $gP1US.Util.parseSymbolPath(i, h));
            const a = Object.keys(i);
            let c = !1;
            for(let e = 0; e < a.length; e++){
                const t = a[e];
                if ($435bc7696844e930$var$ct(s[t]) || $435bc7696844e930$var$ct(i[t])) {
                    c = !0;
                    break;
                }
            }
            for(const t in i)$435bc7696844e930$var$q(i, t) && (!$gP1US.Util.isObject(i[t]) || Array.isArray(i[t]) || (0, $14507960c5dac0fb$export$ec423ecbfcdb9a06)(i[t]) ? s[t] = i[t] : (s[t] || (s[t] = {}), $435bc7696844e930$var$U(s[t], i[t])));
            let u = l.options.style;
            if ($435bc7696844e930$var$B(u)) return c;
            Array.isArray(u) || (u = l._getTargetStyle(t, l.options.style));
            const f = JSON.parse(JSON.stringify(s));
            return void 0 !== r ? ($435bc7696844e930$var$dt(u, n, r), void 0 === o ? u[n].style[r].symbol = f : u[n].style[r].symbol[o] = f) : ($435bc7696844e930$var$pt(u, n), void 0 === o ? u[n].symbol = f : u[n].symbol[o] = f), c;
        }
        const u = this.getRenderer();
        if (!u) return c(), this._compileStyle(), this;
        let f = !1;
        const d = a.symbol;
        if (Array.isArray(i)) for(let e = 0; e < i.length; e++){
            const t = c(i[e], d[e], e);
            t && (f = t);
        }
        else c(i, d);
        return this._compileStyle(), f ? u.setStyle() : (f = u.updateSymbol(t, o, i), f && u.setStyle()), 0 === t ? this.fire("updatesymbol", {
            index: n,
            symbol: i
        }) : 1 === t && this.fire("updatefeaturesymbol", {
            index: n,
            featureStyleIndex: r,
            symbol: i
        }), this;
    }
    _getTargetStyle(e, t) {
        if (t) return 0 === e ? t.style : t.featureStyle;
        return 0 === e ? this._vtStyle : this._featureStyle;
    }
    isDefaultRender() {
        return !!this._isDefaultRender && this.options.defaultRendering;
    }
    validateStyle() {
        this._isDefaultRender = !1;
        let e = this._vtStyle;
        this.options.style || (this._isDefaultRender = !0, e = this._vtStyle = []), Array.isArray(e) || (e = this._vtStyle = [
            e
        ]);
        for(let t = 0; t < e.length; t++){
            let n = e[t].filter;
            if (n && n.value && (n = n.value), n || console.warn(`render plugin at ${t} doesn't define filter, its filter will be set to 'default' by default.`), void 0 !== n && "default" !== n && !0 !== n && !Array.isArray(n) && void 0 === n.condition) throw new Error(`Invalid filter at ${t} : ${JSON.stringify(n)}`);
        }
    }
    getStyle() {
        return this.options.style ? JSON.parse(JSON.stringify(this.options.style)) : null;
    }
    _getStyleIndex(e) {
        const t = this._vtStyle;
        if (!t) return -1;
        for(let n = 0; n < t.length; n++)if (t[n].name === e) return n;
        throw new Error(`No style defined with name: ${e}`);
    }
    getGroundConfig() {
        this._backgroundConfig || (this._backgroundConfig = {
            enable: !0,
            renderPlugin: {
                type: "fill",
                sceneConfig: {}
            },
            symbol: {
                polygonFill: [
                    0,
                    0,
                    0,
                    0
                ],
                polygonOpacity: 1
            }
        });
        const e = this._getComputedStyle().background || {};
        return this._backgroundConfig.enable = e.enable, this._backgroundConfig.symbol.polygonFill = e.color, this._backgroundConfig.symbol.polygonOpacity = e.opacity, this._backgroundConfig.symbol.polygonPatternFile = e.patternFile, this._backgroundConfig.renderPlugin.sceneConfig.depthRange = e.depthRange, this._backgroundConfig;
    }
    getComputedStyle() {
        return JSON.parse(JSON.stringify(this._getComputedStyle()));
    }
    _getComputedStyle() {
        return {
            background: this._background,
            style: this._vtStyle || [],
            featureStyle: this._featureStyle || []
        };
    }
    identify(t, n = {}) {
        const i = this.getMap(), r = this.getRenderer();
        if (!i || !r) return [];
        const s = i.coordToContainerPoint(new $gP1US.Coordinate(t));
        return this.identifyAtPoint(s, n);
    }
    identifyAtPoint(e, t = {}) {
        const n = this.getMap(), i = this.getRenderer();
        if (!n || !i) return [];
        const r = n.getDevicePixelRatio();
        let s = i.pick(e.x * r, e.y * r, t);
        return this.options.features && "id" !== this.options.features && (s = this._convertPickedFeature(s)), t && t.filter ? s.filter((e)=>t.filter(e)) : s;
    }
    _convertPickedFeature(e) {
        if (!this.getRenderer()) return e;
        const t = this._getTileConfig(), n = this.getSpatialReference();
        for(let i = 0; i < e.length; i++){
            let r = e[i];
            if (!r || !r.data) continue;
            const { tile: s } = r.data, { x: o, y: a, z: l, extent: h } = s, c = n.getResolution(l), u = t.getTilePointNW(o, a, c), f = r.data.feature && r.data.feature.geometry;
            if (f) {
                r.data = $435bc7696844e930$var$U({}, r.data), r.data.feature = $435bc7696844e930$var$U({}, r.data.feature);
                const e = r.data.feature.type;
                r.data.feature.type = "Feature", r.data.feature.geometry = this._convertGeometry(e, f, u, h, c);
            }
        }
        return e;
    }
    _convertGeometry(e, t, n, i, r) {
        if (t.type && t.coordinates) return t;
        let s, o;
        if (1 === e) t.length <= 1 ? (s = "Point", o = this._convertGeometryCoords(t, n, i, r) || []) : (s = "MultiPoint", o = this._convertGeometryCoords(t, n, i, r));
        else if (2 === e) t.length <= 1 ? (s = "LineString", o = this._convertGeometryCoords(t, n, i, r) || []) : (s = "MultiLineString", o = this._convertGeometryCoords(t, n, i, r));
        else if (3 === e) {
            o = [];
            let e = [], a = 0;
            for(let s = 0; s < t.length; s++)$435bc7696844e930$var$rt.calculateSignedArea(t[s]) > 0 && (a++, e && e.length && o.push(e), e = []), e.push(this._convertGeometryCoords(t[s], n, i, r));
            e.length && o.push(e), a <= 1 ? (s = "Polygon", o = o[0]) : s = "MultiPolygon";
        }
        return {
            type: s,
            coordinates: o
        };
    }
    _convertGeometryCoords(e, t, n, i) {
        const r = n / this.getTileSize().width, s = this.getMap(), o = (e)=>{
            const n = [];
            $435bc7696844e930$var$W(e) && (e = [
                e
            ]);
            for(let o = 0, a = e.length; o < a; o++){
                const a = e[o];
                $435bc7696844e930$var$st.x = t.x + a.x / r, $435bc7696844e930$var$st.y = t.y - a.y / r, s.pointAtResToCoord($435bc7696844e930$var$st, i, $435bc7696844e930$var$ot), n.push($435bc7696844e930$var$ot.toArray());
            }
            return 1 === e.length ? n[0] : n;
        };
        if ($435bc7696844e930$var$W(e)) return o(e);
        const a = e.length;
        if (1 === a) return o(e[0]);
        {
            let t = [];
            for(let n = 0; n < a; n++)t.push(o(e[n]));
            return t;
        }
    }
    getDataSchema(e) {
        return this._schema || (this._schema = {}), $435bc7696844e930$var$X(e) || this._schema[e] || (this._schema[e] = {}), $435bc7696844e930$var$X(e) ? this._schema : this._schema[e];
    }
    onRemove() {
        super.onRemove();
    }
    static fromJSON(e) {
        return e && "VectorTileLayer" === e.type ? new $435bc7696844e930$export$ab7f86d6b8cd9f25(e.id, e.options) : null;
    }
    _compileStyle() {}
    static registerPlugin(e) {
        $435bc7696844e930$export$ab7f86d6b8cd9f25.plugins || ($435bc7696844e930$export$ab7f86d6b8cd9f25.plugins = {}), $435bc7696844e930$export$ab7f86d6b8cd9f25.plugins[e.type] = e;
    }
    static getPlugins() {
        return $435bc7696844e930$export$ab7f86d6b8cd9f25.plugins || {};
    }
    static compressStyleJSON(e) {
        return Array.isArray(e) && e.length ? function(e) {
            Array.isArray(e) && (e = {
                style: e,
                featureStyle: []
            });
            const t = [], n = [], i = [];
            $435bc7696844e930$var$J(e.style, t, i), $435bc7696844e930$var$J(e.featureStyle, n, i);
            const r = {
                plugins: i,
                styles: {
                    style: t,
                    featureStyle: n
                }
            };
            return e.$root && (r.$root = e.$root), r;
        }(e) : e;
    }
}
function $435bc7696844e930$var$ct(e) {
    return !(!e || !e.properties);
}
function $435bc7696844e930$var$ut(e) {
    return e ? (Array.isArray(e) || (e = (0, (/*@__PURE__*/$parcel$interopDefault($08acccbbd431ef55$exports)))(e).unitArray()), 3 === e.length && e.push(1), e) : null;
}
function $435bc7696844e930$var$ft(e, t) {
    return null == e ? t : e;
}
function $435bc7696844e930$var$dt(e, t, n) {
    if (!e[t] || !e[t].style || !e[t].style[n]) throw new Error(`No plugin defined at feature style of ${t} - ${n}`);
}
function $435bc7696844e930$var$pt(e, t) {
    if (!e[t]) throw new Error(`No plugin defined at style of ${t}`);
}
$435bc7696844e930$export$ab7f86d6b8cd9f25.prototype._getTileZoom = function(t) {
    return t = Math.floor(t), $gP1US.TileLayer.prototype._getTileZoom.call(this, t);
}, $435bc7696844e930$export$ab7f86d6b8cd9f25.registerJSONType("VectorTileLayer"), $435bc7696844e930$export$ab7f86d6b8cd9f25.mergeOptions({
    urlTemplate: null,
    renderer: "gl",
    altitudeProperty: "altitude",
    forceRenderOnZooming: !0,
    forceRenderOnMoving: !0,
    forceRenderOnRotating: !0,
    tileSize: [
        512,
        512
    ],
    features: !1,
    schema: !1,
    cascadeTiles: !0,
    collision: !0,
    collisionBuffserSize: 0,
    picking: !0,
    pickingPoint: !0,
    pickingGeometry: !1,
    glyphSdfLimitPerFrame: 15,
    tileLimitPerFrame: 1,
    loadingLimitOnInteracting: 5,
    loadingLimit: 0,
    antialias: !1,
    iconErrorUrl: null,
    collisionFrameLimit: 1.5,
    defaultRendering: !0,
    textGamma: 1,
    maxIconSize: 254,
    workarounds: {
        "win-intel-gpu-crash": !1
    },
    pyramidMode: 1,
    styleScale: 1,
    enableAltitude: !0,
    fadeAnimation: !1,
    debugTileData: !1,
    fetchOptions: null,
    awareOfTerrain: !0,
    altitudeQueryTimeLimitPerFrame: 3,
    workerGlyph: !0,
    featureIdProperty: null,
    currentTilesFirst: !0,
    tileStackStartDepth: 3,
    tileStackDepth: 2,
    altitudePropertyName: null,
    disableAltitudeWarning: !1
}), $435bc7696844e930$export$ab7f86d6b8cd9f25.registerRenderer("gl", $435bc7696844e930$export$55c5e09254f6444), $435bc7696844e930$export$ab7f86d6b8cd9f25.registerRenderer("canvas", null);
const $435bc7696844e930$var$gt = new $gP1US.Size(1, 1);
class $435bc7696844e930$export$d39412b8ec89578a extends $gP1US.OverlayLayer {
    static registerPainter(e, t) {
        $435bc7696844e930$export$d39412b8ec89578a.painters || ($435bc7696844e930$export$d39412b8ec89578a.painters = {}), $435bc7696844e930$export$d39412b8ec89578a.painters[e] = t;
    }
    static get3DPainterClass(e) {
        return $435bc7696844e930$export$d39412b8ec89578a.painters[e];
    }
    setURLModifier(e) {
        return this._urlModifier = e, this;
    }
    getURLModifier() {
        return this._urlModifier;
    }
    getEvents() {
        let e;
        return e = super.getEvents ? super.getEvents() : {}, e.spatialreferencechange = this._onSpatialReferenceChange, e;
    }
    onConfig(e) {
        if (super.onConfig(e), void 0 !== e.enableBloom) {
            const t = this.getRenderer();
            t && t.updateBloom(e.enableBloom);
        }
    }
    updateSymbol(e, t) {
        if (!this.options.style) throw new Error("can't call update symbol when style is not set");
        const n = Array.isArray(this.options.style) ? this.options.style : this.options.style.style;
        if (!n[e]) throw new Error(`invalid style at ${e}`);
        return $435bc7696844e930$var$U(n[e].symbol, t), this.setStyle(this.options.style), this;
    }
    getPolygonOffsetCount() {
        return this.isEmpty() || this.options.altitude ? 0 : 1;
    }
    getPolygonOffset() {
        return this.options.altitude ? 0 : this._polygonOffset || 0;
    }
    setPolygonOffset(e, t) {
        return this._polygonOffset = e, this._totalPolygonOffset = t, this;
    }
    getTotalPolygonOffset() {
        return this._totalPolygonOffset;
    }
    identify(t, n = {}) {
        const i = this.getMap(), r = this.getRenderer();
        if (!i || !r) return [];
        const s = i.coordToContainerPoint(new $gP1US.Coordinate(t));
        return this.identifyAtPoint(s, n);
    }
    identifyAtPoint(e, t = {}) {
        const n = this.getMap(), i = this.getRenderer();
        if (!n || !i) return [];
        const r = this.getMap().getDevicePixelRatio(), s = i.pick(e.x * r, e.y * r, t);
        return t && t.filter ? s.filter((e)=>t.filter(e)) : s;
    }
    getComputedStyle() {
        return {
            style: this.getStyle() || []
        };
    }
    outlineAll() {
        const e = this.getRenderer();
        return e ? (e.outlineAll(), this) : this;
    }
    outline(e) {
        if (!Array.isArray(e) || !e.length) return this;
        const t = this.getRenderer();
        return t ? (t.outline(e), this) : this;
    }
    cancelOutline() {
        const e = this.getRenderer();
        return e ? (e.cancelOutline(), this) : this;
    }
    toJSON() {
        const e = {
            type: this.getJSONType(),
            id: this.getId(),
            options: this.config(),
            geometries: []
        }, t = this.getGeometries();
        for(let n = 0, i = t.length; n < i; n++){
            const i = t[n].toJSON();
            e.geometries.push(i);
        }
        return e;
    }
    getTileSize() {
        return $435bc7696844e930$var$gt;
    }
    _onSpatialReferenceChange() {
        const e = this.getRenderer();
        e && e._onSpatialReferenceChange();
    }
}
$435bc7696844e930$export$d39412b8ec89578a.mergeOptions({
    picking: !0,
    pickingPoint: !0,
    renderer: "gl",
    collision: !1,
    collisionBufferSize: 0,
    textGamma: 1,
    geometryEvents: !0,
    styleScale: 1,
    forceRenderOnZooming: !0,
    forceRenderOnMoving: !0,
    forceRenderOnRotating: !0,
    meshRenderOrder: 0,
    enableBloom: !1,
    enableAltitude: !0,
    workarounds: {
        "win-intel-gpu-crash": !0
    }
});
const $435bc7696844e930$var$yt = {
    redraw: !1,
    retire: !1
}, $435bc7696844e930$var$xt = [];
let $435bc7696844e930$var$_t = 1;
function $435bc7696844e930$var$vt(e, t) {
    const n = (0, $6d8c21c29b6ffa36$export$2e2bcd8739ae039).extend(e, {
        init: function() {
            this._meshCache = {};
        },
        isVisible () {
            return this.painter && this.painter.isVisible();
        },
        supportRenderMode: function(e) {
            return this.painter.supportRenderMode(e);
        },
        hasMesh () {
            return this.painter && this.painter.hasMesh();
        },
        startFrame: function(e) {
            const n = e.layer, i = e.regl, r = e.sceneConfig, s = e.dataConfig, o = e.symbol;
            let a = this.painter;
            if (!a) {
                const l = e.pluginIndex;
                a = this.painter = new t(i, n, o, r, l, s);
            }
            this._meshCache || (this._meshCache = {});
            const l = r.excludes;
            this._excludes ? l !== this._excludes && (this._excludesFunc = l ? (0, $b541c4b531a4f326$export$5d81789ff4aeccdf)(l) : null, this._excludes = l) : l && (this._excludes = l), a.startFrame(e), this._frameCache = {};
        },
        updateCollision: function(e) {
            const t = this.painter;
            return t && t.isVisible() ? t.updateCollision(e) : null;
        },
        prepareRender: function(e) {
            const t = this.painter;
            return t && t.isVisible() ? t.prepareRender(e) : null;
        },
        endFrame: function(e) {
            const t = this.painter;
            return t && t.isVisible() ? t.render(e) : null;
        },
        getShadowMeshes () {
            const e = this.painter;
            return e && e.getShadowMeshes && e.getShadowMeshes() || $435bc7696844e930$var$xt;
        },
        createTile: function(e) {
            const { tileCache: t, tileData: n } = e;
            let i = !1;
            const r = this.painter;
            if (!r) return {
                retire: i
            };
            const s = this._getMeshKey(e);
            let o = t.geometry;
            if (!o) {
                const s = n.features, a = n.data;
                if (!a || !a.length) return {
                    retire: i
                };
                const l = a;
                if (this.painter.colorSymbol && !function(e) {
                    if (!e) return !0;
                    for(const t in e)return !1;
                    return !0;
                }(s)) for(let e = 0; e < a.length; e++){
                    const t = this._generateColorArray(s, a[e].data.aPickingId, a[e].indices, a[e].data.aPosition, a[e].positionSize);
                    a[e].data.aColor = t;
                }
                o = t.geometry = r.createGeometries(l, s);
                for(let t = 0; t < o.length; t++)o[t] && o[t].geometry && (i = !0, o[t].geometry.properties.features = s, this._fillCommonProps(o[t].geometry, e));
            }
            let a = this._getMesh(s);
            if (!a) {
                const { meshes: t, retire: n } = this._createMeshes(o, e);
                i || (i = n), a = t;
            }
            return {
                retire: i
            };
        },
        _createMeshes (e, t) {
            const { tileInfo: n, tileExtent: i, tileTransform: r, tileTranslationMatrix: s, tileVectorTransform: o, tileZoom: a, sceneConfig: l } = t;
            let h = !1;
            const c = this.painter, u = [
                n.extent2d.xmin,
                n.extent2d.ymax
            ], f = c.createMeshes(e, r, {
                tileExtent: i,
                tilePoint: u,
                tileZoom: a,
                tileTranslationMatrix: s,
                tileVectorTransform: o
            }, t);
            if (f.length) {
                for(let e = 0; e < f.length; e++)f[e] && (h = !0, this._fillMeshProps(f[e], r, t.timestamp, $435bc7696844e930$var$_t++, c.isEnableTileStencil()));
                l.animation && (f._animationTime = t.timestamp);
                const e = this._getMeshKey(t);
                this._meshCache[e] = f;
            }
            return {
                meshes: f,
                retire: h
            };
        },
        paintTile: function(e) {
            const { tileCache: t, tileInfo: n, tileZoom: i, sceneConfig: r } = e, s = this.painter;
            if (!s) return $435bc7696844e930$var$yt;
            let o = t.geometry;
            if (!o) return $435bc7696844e930$var$yt;
            let a = !1;
            const l = this._getMeshKey(e);
            let h = this._getMesh(l);
            if (!h) {
                const { meshes: t, retire: n } = this._createMeshes(o, e);
                a || (a = n), h = t;
            }
            if (!h.length) return $435bc7696844e930$var$yt;
            const c = s.getTileLevelValue(n, i);
            h.forEach((e)=>{
                e.properties.tile = n, e.properties.level = c;
            });
            let u = !1;
            if (!this._frameCache[l]) {
                let t = null, n = r.animation;
                if (n) {
                    const i = e.sceneConfig.animationDuration || 800, r = (e.timestamp - h._animationTime) / i, s = h[0].properties.createTime;
                    h._animationTime - s < i && r < 1 && (!0 !== n && 1 !== n || (n = "linear"), t = "linear" === n ? r : (0, $1b5c2c202f8c280d$export$2e2bcd8739ae039)(n, r), u = !0);
                }
                s.addMesh(h, t, e), this._frameCache[l] = 1;
            }
            return {
                redraw: u,
                retire: a
            };
        },
        _fillMeshProps: function(e, t, n, i, r) {
            if (e.properties.tileTransform = t, e.properties.createTime = n, e.properties.meshKey = i, e.needUpdateShadow = !0, r) {
                const t = e.defines || {};
                t.ENABLE_TILE_STENCIL = 1, e.setDefines(t);
            }
            "stencilRef" in e.uniforms || Object.defineProperty(e.uniforms, "stencilRef", {
                enumerable: !0,
                get: function() {
                    return e.properties.tile && void 0 !== e.properties.tile.stencilRef ? e.properties.tile.stencilRef : e.properties.level;
                }
            });
        },
        _fillCommonProps: function(e, t) {
            const { layer: n, tileInfo: i } = t, r = n.getMap(), s = (n.getSpatialReference ? n.getSpatialReference() : r.getSpatialReference()).getResolution(i.z), o = t.tileExtent / n.getTileSize().width;
            e.properties.tileResolution = s, e.properties.tileRatio = o, e.properties.z = i.z, e.properties.tileExtent = t.tileExtent;
        },
        updateSceneConfig: function(e) {
            const t = this.painter;
            t && t.updateSceneConfig(e.sceneConfig);
        },
        updateDataConfig: function(e, t) {
            const n = this.painter;
            return !n || n.updateDataConfig(e, t);
        },
        updateSymbol: function(e, t) {
            const n = this.painter;
            if (!n) return !1;
            if (n.shouldDeleteMeshOnUpdateSymbol(e)) {
                if (this._meshCache) for(const e in this._meshCache)n.deleteMesh(this._meshCache[e], !0);
                delete this._meshCache, delete this._frameCache;
            }
            return n.updateSymbol(e, t);
        },
        pick: function(e, t, n) {
            return this.painter && this.painter.pick ? this.painter.pick(e, t, n) : null;
        },
        deleteTile: function(e) {
            if (!this._meshCache) return;
            const t = this._getMeshKey(e), n = this._meshCache[t];
            n && this.painter && this.painter.deleteMesh(n), delete this._meshCache[t], this._frameCache && delete this._frameCache[t];
        },
        remove: function() {
            const e = this.painter;
            if (e && this._meshCache) {
                for(const t in this._meshCache)e.deleteMesh(this._meshCache[t]);
                e.delete(), delete this.painter;
            }
            delete this._meshCache, delete this._frameCache;
        },
        resize: function(e, t) {
            const n = this.painter;
            n && n.resize(e, t);
        },
        needToRedraw: function() {
            return !!this.painter && this.painter.needToRedraw();
        },
        needToRetireFrames: function() {
            return !!this.painter && this.painter.needToRetireFrames();
        },
        isAnimating () {
            return !!this.painter && this.painter.isAnimating();
        },
        needToRefreshTerrainTileOnZooming: function() {
            return !!this.painter && this.painter.needToRefreshTerrainTileOnZooming();
        },
        isTerrainSkin: function() {
            return !!this.painter && this.painter.isTerrainSkin();
        },
        isTerrainVector: function() {
            return !!this.painter && this.painter.isTerrainVector();
        },
        _generateColorArray: function(e, t, n, i, r = 3) {
            if (!i || !e || !t.length) return null;
            const s = new Uint8Array(i.length / r * 4);
            let o, a;
            const l = this.painter.colorSymbol, h = {};
            let c;
            for(let n = 0, i = t.length; n < i; n++){
                const i = t[n];
                if (o = e[i].symbol, a = h[i], !a) {
                    if (l) {
                        let t;
                        t = "function" == typeof l ? l(e[i].feature && e[i].feature.properties) : l, t = (0, (/*@__PURE__*/$parcel$interopDefault($08acccbbd431ef55$exports)))(t), a = h[i] = t.array();
                    } else a = h[i] = [
                        255,
                        255,
                        255
                    ];
                }
                c = 4 * n, s[c] = a[0], s[c + 1] = a[1], s[c + 2] = a[2], s[c + 3] = 255 * (o[this.painter.opacitySymbol] || 1);
            }
            return s;
        },
        _getMeshKey: function(e) {
            const t = e.tileInfo;
            return t.meshKey || (t.meshKey = $435bc7696844e930$var$_t++), t.meshKey;
        },
        _getMesh: function(e) {
            return this._meshCache[e];
        },
        _filterElements (e, t) {
            if (Array.isArray(e)) e.forEach((e, n)=>{
                const { features: i } = e.properties;
                this._filterGeoElements(e, t[n], i);
            });
            else {
                const { features: n } = e.properties;
                this._filterGeoElements(e, Array.isArray(t) ? t[0] : t, n);
            }
        },
        _filterGeoElements (e, t, n) {
            const i = t.featureIndexes || t.data.featureIndexes;
            if (i) {
                if (this._excludesFunc) {
                    const r = t.indices;
                    let s = null, o = !1;
                    const a = [];
                    for(let e = 0; e < r.length; e++){
                        const t = n[i[r[e]]];
                        null !== s && s === r[e] || (o = this._excludesFunc(t.feature), s = r[e]), o || a.push(r[e]);
                    }
                    e.setElements(new t.indices.constructor(a));
                } else e.setElements(t.indices);
            }
        },
        outline (e, t) {
            const n = this.painter;
            n && n.outline(e, t);
        },
        outlineAll (e) {
            const t = this.painter;
            t && t.outlineAll(e);
        },
        needPolygonOffset () {
            const e = this.painter;
            return e && e.needPolygonOffset();
        },
        highlight (e) {
            const t = this.painter, n = this.style.name, i = this.renderIndex;
            if (e) {
                const t = [];
                if (e.forEach((e, r)=>{
                    void 0 !== e.plugin && null !== e.plugin && (Array.isArray(e.plugin) ? e.plugin.length && e.plugin.indexOf(n) < 0 && e.plugin.indexOf(i) < 0 && t.push(r) : e.plugin !== n && e.plugin !== i && t.push(r));
                }), t.length) {
                    const n = new Map(e);
                    for(let e = 0; e < t.length; e++)n.delete(t[e]);
                    e = n;
                }
            }
            return t && t.highlight(e);
        },
        cancelAllHighlight () {
            const e = this.painter;
            return e && e.cancelAllHighlight();
        }
    });
    return n;
}
function $435bc7696844e930$var$bt(e) {
    return !e || (void 0 !== e.empty || (e.empty = function(e) {
        for(const t in e)return !1;
        return !0;
    }(e)), e.empty);
}
const { StyleUtil: $435bc7696844e930$var$At } = $435bc7696844e930$var$H(), $435bc7696844e930$var$Tt = "_fn_type_", $435bc7696844e930$var$St = "__current_fn_types";
function $435bc7696844e930$var$wt(e, t, n, i) {
    if (!$435bc7696844e930$var$bt(e.properties.features)) for(let r = 0; r < n.length; r++){
        const { symbolName: s } = n[r];
        (e[$435bc7696844e930$var$St] = e[$435bc7696844e930$var$St] || {})[s] = t[s], $435bc7696844e930$var$Mt(e, t, n[r], i);
    }
}
function $435bc7696844e930$var$Mt(e, t, n, i) {
    const r = function(e) {
        const t = e.properties;
        let n = t.aPickingId;
        n || (n = t.aPickingId = new e.data.aPickingId.constructor(e.data.aPickingId));
        return n;
    }(e), { attrName: s, symbolName: o, related: a } = n;
    let l = e.data[s];
    return l ? $435bc7696844e930$var$Lt(t[o]) || function(e, t) {
        if (!Array.isArray(e)) return !1;
        for(let n = 0; n < e.length; n++)if ($435bc7696844e930$var$Lt(t[e[n]])) return !0;
        return !1;
    }(a, t) ? ($435bc7696844e930$var$Lt(t[o]) && $435bc7696844e930$var$Pt(e, t, n), l) : (void 0 === n.index && (e.deleteData(s), $435bc7696844e930$var$It(e, s)), null) : $435bc7696844e930$var$Lt(t[o]) && function(e, t) {
        if (e.startsWith("marker") && !t.properties.iconAtlas) return !1;
        if (e.startsWith("text") && !t.properties.glyphAtlas) return !1;
        return !0;
    }(o, e) ? (l = e.data[s] = new n.type(n.width * r.length), function(e, t, n, i, r) {
        const { attrName: s } = i, o = ($435bc7696844e930$var$Tt + s + "Index").trim();
        $435bc7696844e930$var$Pt(t, n, i);
        const a = t.properties[o];
        $435bc7696844e930$var$Rt(t, a, i, r);
    }(l, e, t, n, i), l) : null;
}
function $435bc7696844e930$var$Pt(e, t, n) {
    const { attrName: i, symbolName: r } = n, s = e.properties, o = ($435bc7696844e930$var$Tt + i + "Index").trim(), a = ($435bc7696844e930$var$Tt + i).trim();
    if (s[o] && s[a]) return;
    const l = function(e) {
        if (!e) return $435bc7696844e930$var$Ot;
        const t = [];
        for(let n = 0; n < e.length; n++)(0, $14507960c5dac0fb$export$ec423ecbfcdb9a06)(e[n][1]) && !(0, $14507960c5dac0fb$export$b5e0f6446c9b8e3c)(e[n][1]).isZoomConstant && t.push(e[n][0]);
        return t;
    }(t[r].stops), h = "identity" === t[r].type && $435bc7696844e930$var$At.checkIfIdentityZoomDependent(r, t[r].property, s.features);
    if (!h && !l.length) return void (void 0 === n.index && $435bc7696844e930$var$It(e, i));
    const { features: c, aPickingId: u } = s, f = function(e, t, n, i, r) {
        const s = [];
        let o = 0, a = t[0];
        for(let l = 1, h = t.length; l < h; l++)!e[a] || t[l] === a && l !== h - 1 || ((r || $435bc7696844e930$var$Ft(e[a].feature, n, i)) && s.push(o, l === h - 1 ? h : l), a = t[l], o = l);
        return s;
    }(c, u, t[r].property, l, h);
    if (!f.length) return void (void 0 === n.index && $435bc7696844e930$var$It(e, i));
    if (s[o] = f, s[a]) return;
    const d = e.data[i];
    s[a] = d.BYTES_PER_ELEMENT ? new d.constructor(d) : new n.type(d.length);
}
function $435bc7696844e930$var$It(e, t) {
    const n = e.properties, i = ($435bc7696844e930$var$Tt + t + "Index").trim(), r = ($435bc7696844e930$var$Tt + t).trim();
    delete n[i], delete n[r];
}
function $435bc7696844e930$var$Ct(e, t, n, i, r, s) {
    if (!r) return;
    const o = r.geometry;
    if (!o) return;
    if (!$435bc7696844e930$var$bt(o.properties.features)) {
        for(let a = 0; a < i.length; a++){
            const l = i[a], h = l.attrName;
            if (!($435bc7696844e930$var$kt(o, n, l) || t._isFeatureStateDirty && t._isFeatureStateDirty(r.geometry._featureTimestamp))) {
                const { aPickingId: e } = o.properties;
                if (!e || o._fnDataZoom === s) continue;
                const n = ($435bc7696844e930$var$Tt + h + "Index").trim(), i = o.properties[n];
                if (!i) continue;
                $435bc7696844e930$var$Rt(o, i, l, t);
                continue;
            }
            const c = $435bc7696844e930$var$Mt(o, n, l, t), u = l.define;
            if (c) {
                const n = ($435bc7696844e930$var$Tt + h + "Index").trim();
                if ($435bc7696844e930$var$Rt(o, o.properties[n], l, t), t._getFeatureStateStamp && (o._featureTimestamp = t._getFeatureStateStamp()), u) {
                    const e = r.defines;
                    e[u] = 1, r.setDefines(e);
                }
                o.generateBuffers(e);
            } else if (u) {
                const e = r.defines;
                e[u] && (delete e[u], r.setDefines(e));
            }
        }
        o._fnDataZoom = s;
    }
}
function $435bc7696844e930$var$kt(e, t, n) {
    const i = t[n.symbolName], r = e[$435bc7696844e930$var$St];
    return !(0, (/*@__PURE__*/$parcel$interopDefault($c4542b84c1927bd5$exports)))(i, r[n.symbolName]) && (r[n.symbolName] = i, !0);
}
function $435bc7696844e930$var$Ft(e, t, n) {
    for(let i = 0; i < n.length; i++)if ("$" === t[0] && e[t.substring(1)] === n[i] || e.properties[t] === n[i]) return !0;
    return !1;
}
const $435bc7696844e930$var$Ot = [];
function $435bc7696844e930$var$Rt(e, t, n, i) {
    const { attrName: r, evaluate: s, index: o, width: a } = n, { aPickingId: l, features: h } = e.properties;
    let c;
    if (t) {
        const n = ($435bc7696844e930$var$Tt + r).trim();
        c = e.properties[n];
        const u = a, f = t.length;
        for(let n = 0; n < f; n += 2){
            const r = t[n], a = t[n + 1];
            let f = h[l[r]];
            f && f.feature && $435bc7696844e930$var$Dt(c, f, s, r, a, u, o, e, i);
        }
    } else {
        if (c = e.data[r], function(e) {
            return Array.isArray(e) || e.constructor === Float32Array || e.constructor === Float64Array || e.constructor === Uint8Array || e.constructor === Int8Array || e.constructor === Uint16Array || e.constructor === Int16Array || e.constructor === Uint32Array || e.constructor === Int32Array || e.constructor === Uint8ClampedArray;
        }(c)) c.dirty = !0;
        else {
            const t = ($435bc7696844e930$var$Tt + r).trim();
            c = e.properties[t], c || (c = e.properties[t] = new n.type(n.width * l.length), c.dirty = !0);
        }
        const t = c.length / l.length, a = l.length;
        let u = 0;
        for(let n = 0; n < a; n++){
            if (l[n] === l[u] && n < a - 1) continue;
            let r = h[l[u]];
            r && r.feature && ($435bc7696844e930$var$Dt(c, r, s, u, n === a - 1 ? a : n, t, o, e, i), u = n);
        }
    }
    c.dirty && (e.updateData(r, c), c.dirty = !1);
}
const $435bc7696844e930$var$Et = {};
function $435bc7696844e930$var$Dt(e, t, n, i, r, s, o, a, l) {
    const h = (t = t.feature).properties || {};
    if (void 0 === h.$layer && (t.properties || (t.properties = h), h.$layer = t.layer, h.$type = t.type), l.getFeatureState && ($435bc7696844e930$var$Et.layer = t.layer, $435bc7696844e930$var$Et.id = t.id, t[$435bc7696844e930$var$be] && (t[$435bc7696844e930$var$be] = null), !$435bc7696844e930$var$Ie(t.id))) {
        const e = l.getFeatureState($435bc7696844e930$var$Et);
        t.properties[$435bc7696844e930$var$be] = e;
    }
    const c = n(h, a, e, i * s);
    if (Array.isArray(c)) {
        let t = !1;
        for(let n = 0; n < s; n++)if (e[i * s + n] !== c[n]) {
            t = !0;
            break;
        }
        if (t) {
            for(let t = i * s; t < r * s; t += s)e.set(c, t);
            e.dirty = !0;
        }
    } else if (s > 1) for(let t = i * s; t < r * s; t += s)e[t + o] !== c && (e[t + o] = c, e.dirty = !0);
    else e[i] !== c && ($435bc7696844e930$var$De(e, c, i, r), e.dirty = !0);
}
function $435bc7696844e930$var$Lt(e) {
    return $435bc7696844e930$var$At.isFnTypeSymbol(e);
}
function $435bc7696844e930$var$Ht(e) {
    return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var $435bc7696844e930$var$Nt = $435bc7696844e930$var$zt;
function $435bc7696844e930$var$zt(e, t) {
    this.x = e, this.y = t;
}
$435bc7696844e930$var$zt.prototype = {
    clone: function() {
        return new $435bc7696844e930$var$zt(this.x, this.y);
    },
    add: function(e) {
        return this.clone()._add(e);
    },
    sub: function(e) {
        return this.clone()._sub(e);
    },
    multByPoint: function(e) {
        return this.clone()._multByPoint(e);
    },
    divByPoint: function(e) {
        return this.clone()._divByPoint(e);
    },
    mult: function(e) {
        return this.clone()._mult(e);
    },
    div: function(e) {
        return this.clone()._div(e);
    },
    rotate: function(e) {
        return this.clone()._rotate(e);
    },
    rotateAround: function(e, t) {
        return this.clone()._rotateAround(e, t);
    },
    matMult: function(e) {
        return this.clone()._matMult(e);
    },
    unit: function() {
        return this.clone()._unit();
    },
    perp: function() {
        return this.clone()._perp();
    },
    round: function() {
        return this.clone()._round();
    },
    mag: function() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    },
    equals: function(e) {
        return this.x === e.x && this.y === e.y;
    },
    dist: function(e) {
        return Math.sqrt(this.distSqr(e));
    },
    distSqr: function(e) {
        var t = e.x - this.x, n = e.y - this.y;
        return t * t + n * n;
    },
    angle: function() {
        return Math.atan2(this.y, this.x);
    },
    angleTo: function(e) {
        return Math.atan2(this.y - e.y, this.x - e.x);
    },
    angleWith: function(e) {
        return this.angleWithSep(e.x, e.y);
    },
    angleWithSep: function(e, t) {
        return Math.atan2(this.x * t - this.y * e, this.x * e + this.y * t);
    },
    _matMult: function(e) {
        var t = e[0] * this.x + e[1] * this.y, n = e[2] * this.x + e[3] * this.y;
        return this.x = t, this.y = n, this;
    },
    _add: function(e) {
        return this.x += e.x, this.y += e.y, this;
    },
    _sub: function(e) {
        return this.x -= e.x, this.y -= e.y, this;
    },
    _mult: function(e) {
        return this.x *= e, this.y *= e, this;
    },
    _div: function(e) {
        return this.x /= e, this.y /= e, this;
    },
    _multByPoint: function(e) {
        return this.x *= e.x, this.y *= e.y, this;
    },
    _divByPoint: function(e) {
        return this.x /= e.x, this.y /= e.y, this;
    },
    _unit: function() {
        return this._div(this.mag()), this;
    },
    _perp: function() {
        var e = this.y;
        return this.y = this.x, this.x = -e, this;
    },
    _rotate: function(e) {
        var t = Math.cos(e), n = Math.sin(e), i = t * this.x - n * this.y, r = n * this.x + t * this.y;
        return this.x = i, this.y = r, this;
    },
    _rotateAround: function(e, t) {
        var n = Math.cos(e), i = Math.sin(e), r = t.x + n * (this.x - t.x) - i * (this.y - t.y), s = t.y + i * (this.x - t.x) + n * (this.y - t.y);
        return this.x = r, this.y = s, this;
    },
    _round: function() {
        return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
    }
}, $435bc7696844e930$var$zt.convert = function(e) {
    return e instanceof $435bc7696844e930$var$zt ? e : Array.isArray(e) ? new $435bc7696844e930$var$zt(e[0], e[1]) : e;
};
var $435bc7696844e930$var$Vt = $435bc7696844e930$var$Ht($435bc7696844e930$var$Nt);
const $435bc7696844e930$var$Ut = [];
function $435bc7696844e930$var$Bt(e, t, n, i, r) {
    return (0, $jxhwV).set($435bc7696844e930$var$Ut, t[0], t[1], t[2], 1), (0, $jxhwV).transformMat4($435bc7696844e930$var$Ut, $435bc7696844e930$var$Ut, n), e[2] = $435bc7696844e930$var$Ut[3], (0, $jxhwV).scale($435bc7696844e930$var$Ut, $435bc7696844e930$var$Ut, 1 / $435bc7696844e930$var$Ut[3]), e[0] = ($435bc7696844e930$var$Ut[0] + 1) * i / 2, e[1] = (1 - $435bc7696844e930$var$Ut[1]) * r / 2, e;
}
const $435bc7696844e930$var$Gt = [], $435bc7696844e930$var$jt = [], $435bc7696844e930$var$Wt = [];
const $435bc7696844e930$var$Xt = [
    -99999,
    -99999
], $435bc7696844e930$var$Yt = new $gP1US.Point(0, 0), $435bc7696844e930$var$Zt = [];
function $435bc7696844e930$var$qt(e, t, n, i, r, s, a, l) {
    const { res: h, extent: c, extent2d: u } = n.properties.tile, { xmin: f, ymax: d } = u, p = f + i.x * r, g = d - i.y * r;
    let m = null;
    if (l) {
        for(let e = 0; e < l.length; e++)if ($435bc7696844e930$var$$t(l[e], p, g, h)) {
            m = l[e];
            break;
        }
    }
    if (!m) return $435bc7696844e930$var$Xt;
    const y = $435bc7696844e930$var$Yt.set(f, d), x = s.queryTilePointTerrain(i, m, y, c, h), _ = null === x[0] ? $435bc7696844e930$var$me : x[0];
    if (_) {
        let n = (0, $eIStk).set($435bc7696844e930$var$Zt, i.x, i.y, 0);
        return n[2] += 100 * _, n = $435bc7696844e930$var$Bt(e, n, a, t.width, t.height), n;
    }
    return e[0] = i.x, e[1] = i.y, e;
}
function $435bc7696844e930$var$$t(e, t, n, i) {
    const r = $435bc7696844e930$var$Yt.set(t, n)._multi(i / e.res);
    return e.extent2d.contains(r);
}
const { SYMBOLS_NEED_REBUILD_IN_VT: $435bc7696844e930$var$Jt, StyleUtil: $435bc7696844e930$var$Kt, FuncTypeUtil: $435bc7696844e930$var$Qt } = $435bc7696844e930$var$H(), { loginIBLResOnCanvas: $435bc7696844e930$var$en, logoutIBLResOnCanvas: $435bc7696844e930$var$tn, getIBLResOnCanvas: $435bc7696844e930$var$nn } = (0, $2wazW).pbr.PBRUtils, $435bc7696844e930$var$rn = "__gl_textures", $435bc7696844e930$var$sn = [], $435bc7696844e930$var$on = new $gP1US.Point(0, 0), $435bc7696844e930$var$an = new $gP1US.Point(0, 0), $435bc7696844e930$var$ln = new Float32Array(1), $435bc7696844e930$var$hn = [], $435bc7696844e930$var$cn = (e)=>0 === e.properties.level, $435bc7696844e930$var$un = (e)=>e.properties.level > 0;
class $435bc7696844e930$var$fn {
    static getBloomSymbol() {
        return [
            "bloom"
        ];
    }
    constructor(e, t, n, i, r, o){
        this._is2D = !0, this.regl = e, this.layer = t, this.canvas = e._gl.canvas, this.sceneConfig = i || {}, this.dataConfig = o || {}, this.pluginIndex = r, this.scene = new (0, $2wazW).Scene, this.pickingFBO = t.getRenderer().pickingFBO, this.level0Filter = $435bc7696844e930$var$cn, this.levelNFilter = $435bc7696844e930$var$un, this.loginTextureCache(), this.symbolDef = Array.isArray(n) ? n.map((e)=>$435bc7696844e930$var$Ce(e)) : [
            $435bc7696844e930$var$Ce(n)
        ], this._compileSymbols(), this.pickingViewport = {
            x: 0,
            y: 0,
            width: ()=>this.canvas ? this.canvas.width : 1,
            height: ()=>this.canvas ? this.canvas.height : 1
        }, this.sortByCommandKey = $435bc7696844e930$var$dn.bind(this), this.colorCache = {}, this._invisibleWhenCreated = this.symbolDef.map((e)=>!(!e || !1 !== e.visible));
    }
    hasMesh() {
        const e = this.scene && this.scene.getMeshes();
        return this.isVisible() && e && !!e.length;
    }
    getMap() {
        return this.layer ? this.layer.getMap() : null;
    }
    getTileLevelValue(e, t) {
        const n = this.layer.getRenderer();
        return n.getTileLevelValue && n.getTileLevelValue(e, t) || 0;
    }
    getAnalysisMeshes() {
        return this.getShadowMeshes ? this.getShadowMeshes() : $435bc7696844e930$var$hn;
    }
    isVisible() {
        const { minZoom: e, maxZoom: t } = this.sceneConfig, n = this.getMap().getZoom();
        if (!$435bc7696844e930$var$Ie(e) && n < e) return !1;
        if (!$435bc7696844e930$var$Ie(t) && n > t) return !1;
        const i = this._visibleFn;
        if (i.length) {
            for(let e = 0; e < i.length; e++)if (i[e] && !i[e].isFeatureConstant) return !0;
        }
        const r = this.getSymbols();
        for(let e = 0; e < r.length; e++){
            const t = r[e].visible;
            if (!1 !== t && 0 !== t) return !0;
        }
        return !1;
    }
    isMeshVisible(e) {
        const t = e && e.properties && e.properties.symbolIndex;
        if (!t) return !1;
        const n = this._visibleFn, i = t.index;
        let r;
        if (n[i]) {
            if (!n[i].isFeatureConstant) return !0;
            r = n[i](this.getMap().getZoom());
        } else r = this.getSymbol(t).visible;
        return !1 !== r && 0 !== r;
    }
    isAnimating() {
        return !1;
    }
    needToRedraw() {
        return this.isAnimating() || this._redraw;
    }
    needToRetireFrames() {
        return this._needRetire;
    }
    needToRefreshTerrainTileOnZooming() {
        return !0;
    }
    isTerrainSkin() {
        return this.layer.options.awareOfTerrain;
    }
    isTerrainVector() {
        return !1;
    }
    isShadowIncludeChanged(e) {
        const t = e && e.isRenderingTerrain && this.isTerrainSkin();
        return e && e.states && e.states.includesChanged.shadow || t && this._includeKeys;
    }
    fillIncludes(e, t, n) {
        if (delete this._includeKeys, n && n.isRenderingTerrain && this.isTerrainSkin()) return;
        const i = n && n.includes;
        if (i) {
            let r = "";
            for(const s in i)i[s] && (r += s, n[s].uniformDeclares && t.push(...n[s].uniformDeclares), n[s].defines && $435bc7696844e930$var$we(e, n[s].defines));
            this._includeKeys = r;
        }
    }
    setIncludeUniformValues(e, t) {
        if (t && t.isRenderingTerrain && this.isTerrainSkin()) return;
        const n = t && t.includes;
        if (n) for(const i in n)n[i] && t[i].renderUniforms && $435bc7696844e930$var$we(e, t[i].renderUniforms);
    }
    createGeometries(e, t) {
        if (!e.length) return $435bc7696844e930$var$hn;
        const n = [];
        for(let i = 0; i < e.length; i++)if (e[i]) {
            if (void 0 !== e[i].ref) n[e[i].ref] ? n.push({
                geometry: n[e[i].ref].geometry,
                symbolIndex: e[i].symbolIndex,
                ref: e[i].ref
            }) : n.push(null);
            else {
                e[i] && !e[i].is2D && (this._is2D = !1);
                const r = this.createGeometry(e[i], t, i);
                if (r && r.geometry) {
                    const s = r.geometry.properties, { pickingIdMap: o, idPickingMap: a, hasFeaIds: l } = this._getIdMap(e[i]);
                    l && (s.feaIdPickingMap = o, s.feaPickingIdMap = a), s.symbolIndex = r.symbolIndex, s.features = t, s.is2D = e[i].is2D, s.layer = this.layer, s.positionBounding = e[i].positionBounding, this.postCreateGeometry(r, n);
                }
                n.push(r);
            }
        }
        return n;
    }
    isOnly2D() {
        return this._is2D;
    }
    postCreateGeometry() {}
    _getIdMap(e) {
        if (!e) return {};
        if (Array.isArray(e) && !(e = e[0])) return {};
        const t = e.featureIds, n = {}, i = {}, r = t && t.length;
        if (r) for(let r = 0; r < t.length; r++){
            const s = e.data.aPickingId[r];
            void 0 === n[s] && (n[s] = t[r], i[t[r]] || (i[t[r]] = []), i[t[r]].push(e.data.aPickingId[r]));
        }
        return {
            hasFeaIds: r,
            idPickingMap: n,
            pickingIdMap: i
        };
    }
    createGeometry() {
        throw new Error("not implemented");
    }
    createMeshes(e, t, n, i) {
        const r = this.layer.options.awareOfTerrain, s = [];
        for(let o = 0; o < e.length; o++){
            if (!e[o]) continue;
            if (r && i && i.isRenderingTerrain && this.isTerrainVector()) {
                const t = e[o], n = t && t.geometry;
                this._updateTerrainAltitude(n, n.data, n.properties, n.positionSize || n.desc.positionSize, i);
            }
            let a = this.createMesh(e[o], t, n, i || {});
            Array.isArray(a) ? (a = a.filter((e)=>!!e), s.push(...a)) : a && s.push(a);
        }
        return s;
    }
    createMesh() {
        throw new Error("not implemented");
    }
    getAltitudeOffsetMatrix() {
        const e = 100 * (this.dataConfig.altitudeOffset || 0), t = (0, $3iqbd).identity([]);
        return (0, $eIStk).set($435bc7696844e930$var$sn, 0, 0, e), (0, $3iqbd).translate(t, t, $435bc7696844e930$var$sn), t;
    }
    isBloom(e) {
        return !!this.getSymbol(e.properties.symbolIndex).bloom;
    }
    forbiddenTerrainUpscale() {
        return !0;
    }
    addMesh(e, t, n) {
        if (n.isRenderingTerrain && this.isTerrainSkin() && this.forbiddenTerrainUpscale()) {
            const e = this.getMap().getResolution();
            if (n.tileInfo.res / e > 3) return;
        }
        const i = n.isRenderingTerrain && this.isTerrainVector(), r = this.getRenderFBO(n);
        e = e.filter((e)=>this.isMeshVisible(e)), i && (e = e.filter((e)=>e.geometry && e.geometry.data.aTerrainAltitude));
        const s = void 0 === this.sceneConfig.castShadow || !!this.sceneConfig.castShadow, o = !(!n || !n.bloom);
        e.forEach((e)=>{
            const t = this.isBloom(e) && o;
            e.bloom = t, e.castShadow = s;
            let a = !1;
            const l = e.defines || {};
            if (!!l.HAS_BLOOM !== t && (a = !0, t ? l.HAS_BLOOM = 1 : delete l.HAS_BLOOM), i) {
                if (e.geometry.data.aTerrainAltitude) {
                    const t = e.geometry;
                    this._updateTerrainAltitude(t, t.data, t.properties, t.desc.positionSize, n);
                }
                e.geometry.data.aTerrainAltitude && !l.HAS_TERRAIN_ALTITUDE && (l.HAS_TERRAIN_ALTITUDE = 1, a = !0);
            } else l.HAS_TERRAIN_ALTITUDE && (delete l.HAS_TERRAIN_ALTITUDE, a = !0);
            a && e.setDefines(l), r ? e.setUniform("targetFramebuffer", r) : e.uniforms.targetFramebuffer && (e.uniforms.targetFramebuffer = null), this._highlightMesh(e);
        }), this.scene.addMesh(e);
    }
    updateCollision() {}
    render(e) {
        return this.pluginIndex = e.pluginIndex, this.polygonOffsetIndex = e.polygonOffsetIndex, this.paint(e), {
            redraw: this._redraw,
            drawCount: this._drawCount
        };
    }
    prepareRender(e) {
        if (this._currentTimestamp === e.timestamp) return;
        if (!this.createFnTypeConfig) return;
        const t = this.scene.getMeshes();
        if (!t || !t.length) return;
        const n = e && e.sceneFilter, i = this.getMap().getZoom();
        for(let r = 0; r < t.length; r++){
            if (!t[r] || !t[r].geometry) continue;
            if (n && !n(t[r])) continue;
            const { symbolIndex: s } = t[r].properties, o = this.getSymbolDef(s);
            if (!o) continue;
            this._currentTimestamp = e.timestamp;
            const a = this.getFnTypeConfig(s);
            $435bc7696844e930$var$Ct(this.regl, this.layer, o, a, t[r], i);
        }
    }
    paint(e) {
        const t = this.layer.getMap();
        if (!t) return {
            redraw: !1
        };
        this._renderContext = e;
        const n = this.getUniformValues(t, e);
        return this.callShader(n, e), {
            redraw: this._redraw
        };
    }
    setToRedraw(e) {
        e && (this._needRetire = e), this._redraw = !0;
    }
    callShader(e, t) {
        this.callCurrentTileShader(e, t), this.callBackgroundTileShader(e, t);
    }
    callCurrentTileShader(e, t) {
        this.shader && (this.shader.filter = t && t.sceneFilter ? [
            this.level0Filter,
            t.sceneFilter
        ] : this.level0Filter), this.callRenderer(this.shader, e, t);
    }
    callBackgroundTileShader(e, t) {
        this.shader && (this.shader.filter = t && t.sceneFilter ? [
            this.levelNFilter,
            t.sceneFilter
        ] : this.levelNFilter), this.scene.getMeshes().sort($435bc7696844e930$var$pn), this.callRenderer(this.shader, e, t);
    }
    callRenderer(e, t, n) {
        const i = this.scene.getMeshes(), r = [];
        i.forEach((e)=>{
            e.properties.hlBloomMesh && n && n.bloom && r.push(e.properties.hlBloomMesh), r.push(e);
        }), this._setLayerUniforms(t), this.scene.setMeshes(r), this._drawCount += this.renderer.render(e, t, this.scene, this.getRenderFBO(n)), this.scene.setMeshes(i);
    }
    _setLayerUniforms(e) {
        const t = this.layer.options.altitude || 0, n = this.layer.getRenderer();
        e.layerOpacity = n._getLayerOpacity(), e.minAltitude = t;
    }
    getRenderFBO(e) {
        return e && e.renderTarget && e.renderTarget.fbo;
    }
    needPolygonOffset() {
        return !1;
    }
    needRebuildOnGometryPropertiesChanged() {
        return !0;
    }
    onFeatureChange() {}
    getPolygonOffset() {
        const e = this.layer;
        return {
            factor: ()=>e.getPolygonOffset() + (this.polygonOffsetIndex || 0),
            units: ()=>e.getPolygonOffset() + (this.polygonOffsetIndex || 0)
        };
    }
    getBlendFunc() {
        return {
            src: ()=>this.sceneConfig.blendSrc || "one",
            dst: ()=>this.sceneConfig.blendDst || "one minus src alpha"
        };
    }
    pick(e, t, n = 3) {
        if (!this.layer.options.picking || !1 === this.sceneConfig.picking) return null;
        if (!this.pickingFBO || !this.picking) return null;
        const i = this.getMap(), r = this.getUniformValues(i);
        this._setLayerUniforms(r);
        for(let s = 0; s < this.picking.length; s++){
            const o = this.picking[s];
            o.render(this.scene.getMeshes(), r, !0);
            let a = {};
            o.getRenderedMeshes().length && (a = o.pick(e, t, n, r, {
                viewMatrix: i.viewMatrix,
                projMatrix: i.projMatrix,
                returnPoint: this.layer.options.pickingPoint && !1 !== this.sceneConfig.pickingPoint,
                logDepthBufFC: 2 / (Math.log(i.cameraFar + 1) / Math.LN2)
            }));
            const { meshId: l, pickingId: h, point: c } = a, u = (0 === l || l) && o.getMeshAt(l);
            if (!u || !u.geometry) continue;
            let f = u.geometry.properties;
            f.features || (f = u.properties), c && c.length && (c[0] = Math.round(1e5 * c[0]) / 1e5, c[1] = Math.round(1e5 * c[1]) / 1e5, c[2] = Math.round(1e5 * c[2]) / 1e5);
            const d = {
                data: this._convertProxyFeature(f && f.features && f.features[h]),
                point: c,
                coordinate: a.coordinate,
                plugin: this.pluginIndex
            };
            return $435bc7696844e930$var$Ie(u.properties.nodeIndex) || (d.data.nodeIndex = u.properties.nodeIndex), d;
        }
        return null;
    }
    _convertProxyFeature(e) {
        const t = e && e.feature;
        if (!t || !t.customProps) return e;
        const n = $435bc7696844e930$var$we({}, e);
        return n.feature = $435bc7696844e930$var$we({}, e.feature), delete n.feature.customProps, n.feature.properties = $435bc7696844e930$var$we({}, t.properties, t.properties[$435bc7696844e930$var$ve], t.properties[$435bc7696844e930$var$be]), delete n.feature.properties[$435bc7696844e930$var$be], delete n.feature.properties[$435bc7696844e930$var$ve], delete n.feature.properties.$layer, delete n.feature.properties.$type, n;
    }
    updateSceneConfig() {}
    updateDataConfig(e) {
        return $435bc7696844e930$var$we(this.dataConfig, e), !0;
    }
    deleteMesh(e, t) {
        if (e) {
            if (this.scene.removeMesh(e), Array.isArray(e)) for(let n = 0; n < e.length; n++){
                if (!e[n].isValid()) continue;
                const i = e[n].geometry;
                !t && i && i.dispose(), e[n].material && e[n].material.dispose(), e[n].dispose(), (0, $9e7Ip.HighlightUtil).deleteHighlightBloomMesh(e[n]);
            }
            else {
                if (!e.isValid()) return;
                !t && e.geometry && e.geometry.dispose(), e.material && e.material.dispose(), e.dispose(), (0, $9e7Ip.HighlightUtil).deleteHighlightBloomMesh(e);
            }
        }
    }
    startFrame(e) {
        this._inited || (this.init(e), this._inited = !0), this._currentTimestamp !== e.timestamp && (this._redraw = !1, this._needRetire = !1, this._drawCount = 0), this.scene.clear();
    }
    resize() {}
    delete() {
        if (this.scene.clear(), this.shader && this.shader.dispose(), this.picking) {
            for(let e = 0; e < this.picking.length; e++)this.picking[e].dispose();
            delete this.picking;
        }
        if (this._outlineShaders) {
            for(let e = 0; e < this._outlineShaders.length; e++)this._outlineShaders[e].dispose();
            delete this._outlineShaders;
        }
        delete this._terrainAltitudeCache, this.logoutTextureCache();
    }
    updateSymbol(e, t) {
        Array.isArray(e) || (e = [
            e
        ], t = [
            t
        ]);
        let n = !1;
        for(let i = 0; i < e.length; i++)if (e[i]) {
            const r = this._updateChildSymbol(i, e[i], t[i]);
            r && (n = r);
        }
        return delete this._fnTypeConfigs, this.setToRedraw(!1), n;
    }
    _isNeedRefreshStyle(e, t) {
        for(const n in t)if ($435bc7696844e930$var$Ne(t, n)) {
            if ($435bc7696844e930$var$Kt.isFnTypeSymbol(t[n]) && !this.layer.options.features && (!e[n] || e[n].property !== t[n].property)) return !0;
            if ($435bc7696844e930$var$Jt[n] && !(0, (/*@__PURE__*/$parcel$interopDefault($c4542b84c1927bd5$exports)))(t[n], e[n])) return !0;
        }
        return !1;
    }
    _updateChildSymbol(e, t, n) {
        if (!this._symbol) return !1;
        const i = this._isNeedRefreshStyle(this.symbolDef[e] || {}, n);
        if (this._invisibleWhenCreated[e] && !1 !== n.visible) return this._invisibleWhenCreated[e] = !1, !0;
        this.symbolDef[e] = $435bc7696844e930$var$Ce(n);
        const r = this._symbol[e];
        for(const e in r)delete r[e];
        const s = this.getMap(), o = [], a = $435bc7696844e930$var$Qt.loadSymbolFnTypes(this.symbolDef[e], ()=>(o[0] = s.getZoom(), o));
        for(const e in a){
            const t = Object.getOwnPropertyDescriptor(a, e);
            t.get ? Object.defineProperty(r, e, {
                get: t.get,
                set: t.set,
                configurable: !0,
                enumerable: !0
            }) : r[e] = a[e];
        }
        return (0, $14507960c5dac0fb$export$ec423ecbfcdb9a06)(n.visible) && (this._visibleFn[e] = (0, $14507960c5dac0fb$export$b5e0f6446c9b8e3c)(n.visible)), i;
    }
    getSymbolDef(e) {
        return this.symbolDef[e.index];
    }
    getSymbols() {
        return this._symbol;
    }
    getSymbol(e) {
        const t = e.index;
        return this._symbol[t];
    }
    _compileSymbols() {
        const e = this.getMap(), t = [], n = ()=>(t[0] = e.getZoom(), t);
        this._symbol = [], this._visibleFn = [];
        for(let e = 0; e < this.symbolDef.length; e++)this._symbol[e] = $435bc7696844e930$var$Qt.loadSymbolFnTypes($435bc7696844e930$var$we({}, this.symbolDef[e]), n), this.symbolDef[e] && (0, $14507960c5dac0fb$export$ec423ecbfcdb9a06)(this.symbolDef[e].visible) && (this._visibleFn[e] = (0, $14507960c5dac0fb$export$b5e0f6446c9b8e3c)(this.symbolDef[e].visible));
    }
    getFnTypeConfig(e) {
        this._fnTypeConfigs || (this._fnTypeConfigs = []);
        const t = e.index;
        if (!this._fnTypeConfigs[t]) {
            const n = this.getSymbolDef(e), i = this.getMap();
            this._fnTypeConfigs[t] = this.createFnTypeConfig(i, n);
        }
        return this._fnTypeConfigs[t];
    }
    _deleteFnTypeConfigs() {
        delete this._fnTypeConfigs;
    }
    loginTextureCache() {
        const e = ($435bc7696844e930$var$rn + "").trim(), t = this.getMap();
        t[e] || (t[e] = {
            count: 0
        }), t[e].count++;
    }
    logoutTextureCache() {
        const e = ($435bc7696844e930$var$rn + "").trim(), t = this.getMap(), n = this._myTextures;
        if (n) for(const i in n)$435bc7696844e930$var$Ne(n, i) && t[e][i] && (t[e][i].count--, t[e][i].count <= 0 && delete t[e][i]);
        t[e].count--, t[e].count <= 0 && (t[e] = {});
    }
    getCachedTexture(e) {
        const t = ($435bc7696844e930$var$rn + "").trim(), n = this.getMap()[t][e];
        return n ? n.data : null;
    }
    addCachedTexture(e, t) {
        const n = ($435bc7696844e930$var$rn + "").trim(), i = this.getMap();
        let r = i[n][e];
        r ? r.data = t : r = i[n][e] = {
            data: t,
            count: 0
        }, this._myTextures || (this._myTextures = {}), r.data.then || this._myTextures[e] || (r.count++, this._myTextures[e] = 1);
    }
    disposeCachedTexture(e) {
        let t;
        if (t = "string" == typeof e ? e : e.url, !this._myTextures || !this._myTextures[t]) return;
        const n = ($435bc7696844e930$var$rn + "").trim();
        delete this._myTextures[t];
        const i = this.getMap();
        i[n][t] && (i[n][t].count--, i[n][t].count <= 0 && delete i[n][t]);
    }
    shouldDeleteMeshOnUpdateSymbol() {
        return !1;
    }
    isEnableTileStencil() {
        return !0;
    }
    isUniqueStencilRefPerTile() {
        return this.isOnly2D();
    }
    supportRenderMode(e) {
        return "taa" === e || "fxaa" === e;
    }
    outline(e, t) {
        const n = {};
        for(let i = 0; i < t.length; i++)$435bc7696844e930$var$Ie(t[i]) || n[t[i]] || (this._outlineOne(e, t[i]), n[t[i]] = 1);
    }
    _outlineOne(e, t) {
        if (!this.picking) return;
        if (this._outlineScene || (this._outlineScene = new (0, $2wazW).Scene), !this._outlineShaders && (this._initOutlineShaders(), !this._outlineShaders)) return void console.warn(`Plugin at ${this.pluginIndex} doesn't support outline.`);
        const n = this.getUniformValues(this.getMap(), this._renderContext);
        this._setLayerUniforms(n);
        const i = this._findMeshesHasFeaId(t);
        if (i.length) for(let r = 0; r < i.length; r++){
            const s = i[r].geometry.properties.feaIdPickingMap;
            if (s) {
                const o = s[t];
                if (o) {
                    const t = {};
                    this._outlineScene.setMeshes(i[r]);
                    for(let i = 0; i < o.length; i++){
                        const r = o[i];
                        if (!t[r]) {
                            t[r] = 1, n.highlightPickingId = r;
                            for(let t = 0; t < this._outlineShaders.length; t++)this.renderer.render(this._outlineShaders[t], n, this._outlineScene, e);
                        }
                    }
                }
            }
        }
    }
    _findMeshesHasFeaId(e) {
        const t = [], n = this.scene.getMeshes();
        for(let i = 0; i < n.length; i++){
            const r = n[i], s = r.geometry.properties.feaIdPickingMap;
            s && void 0 !== s[e] && t.push(r);
        }
        return t;
    }
    outlineAll(e) {
        if (!this.picking) return;
        if (!this._outlineShaders && (this._initOutlineShaders(), !this._outlineShaders)) return void console.warn(`Plugin at ${this.pluginIndex} doesn't support outline.`);
        const t = this.getUniformValues(this.getMap(), this._renderContext);
        this._setLayerUniforms(t), t.highlightPickingId = -1;
        for(let n = 0; n < this._outlineShaders.length; n++)this.renderer.render(this._outlineShaders[n], t, this.scene, e);
    }
    _initOutlineShaders() {
        if (!this.picking) return;
        const e = this.layer.getRenderer().canvas;
        this._outlineShaders = [];
        for(let t = 0; t < this.picking.length; t++){
            const n = this.picking[t].getPickingVert(), i = {
                ENABLE_PICKING: 1,
                HAS_PICKING_ID: 1
            }, r = this.picking[t].getUniformDeclares().slice(0);
            void 0 !== r.uPickingId && (i.HAS_PICKING_ID = 2), this._outlineShaders[t] = new (0, $2wazW).MeshShader({
                vert: n,
                frag: "precision highp float;\nuniform float highlightPickingId;\nvarying float vPickingId;\nvoid main() {\n  if(highlightPickingId < .0 || floor(highlightPickingId + .5) == floor(vPickingId + .5)) {\n    gl_FragColor = vec4(1.);\n  } else {\n    discard;\n  }\n}",
                uniforms: r,
                defines: i,
                extraCommandProps: {
                    viewport: {
                        x: 0,
                        y: 0,
                        width: ()=>e.width,
                        height: ()=>e.height
                    },
                    depth: {
                        enable: !0,
                        mask: !1,
                        func: "always"
                    },
                    blend: {
                        enable: !0,
                        func: {
                            src: "src alpha",
                            dst: "one minus src alpha"
                        },
                        equation: "add"
                    }
                }
            }), this._outlineShaders[t].filter = this.picking[t].filter;
        }
    }
    hasIBL() {
        const e = this.getMap().getLightManager();
        return !!(e && e.getAmbientResource());
    }
    updateIBLDefines(e) {
        const t = e.shaderDefines;
        let n = !1;
        this.hasIBL() ? t[[
            "HAS_IBL_LIGHTING"
        ]] || (t.HAS_IBL_LIGHTING = 1, n = !0) : t[[
            "HAS_IBL_LIGHTING"
        ]] && (delete t.HAS_IBL_LIGHTING, n = !0), n && (e.shaderDefines = t);
    }
    getIBLRes() {
        const e = this.layer.getRenderer().canvas;
        return $435bc7696844e930$var$nn(e);
    }
    createIBLTextures() {
        const e = this.layer.getRenderer().canvas;
        $435bc7696844e930$var$en(e, this.regl, this.getMap()), this.setToRedraw(!0), this.layer.fire("iblupdated");
    }
    disposeIBLTextures() {
        const e = this.layer.getRenderer().canvas;
        $435bc7696844e930$var$tn(e, this.getMap());
    }
    evaluateInFnTypeConfig(e, t, n, i, r) {
        let s = this._fnCaches;
        s || (s = this._fnCaches = {});
        const o = function(e) {
            let t = 0;
            const n = e && e.length || 0;
            if (!n) return t;
            let i;
            for(let r = 0; r < n; r++)i = e.codePointAt(r), t = (t << 5) - t + i, t |= 0;
            return t;
        }(JSON.stringify(e));
        let a = s[o];
        return a || (a = s[o] = r ? (0, $14507960c5dac0fb$export$79e978600dd1e509)(e) : (0, $14507960c5dac0fb$export$b5e0f6446c9b8e3c)(e)), a(n.getZoom(), i);
    }
    highlight(e) {
        this._highlighted = e, this._highlightTimestamp = this.layer.getRenderer().getFrameTimestamp(), this.setToRedraw(!0);
    }
    cancelAllHighlight() {
        this._highlighted = null, this._highlightTimestamp = this.layer.getRenderer().getFrameTimestamp(), this.setToRedraw(!0);
    }
    _prepareFeatureIds(e, t) {
        const { featureIds: n, pickingIdIndiceMap: i } = t;
        e.properties.aFeaIds = n, e.properties.pickingIdIndiceMap = i;
    }
    _highlightMesh(e) {
        if (e && e.properties.isHalo) return;
        const t = e instanceof (0, $2wazW).InstancedMesh ? e.properties : e.geometry.properties, { pickingIdIndiceMap: n } = t, i = this._highlighted ? function(e, t, n) {
            const i = e instanceof (0, $2wazW).InstancedMesh ? e.properties : e.geometry.properties, { aPickingId: r, feaIdPickingMap: o, features: a } = i, l = new Map, h = n.keys();
            for (const e of h){
                const i = n.get(e);
                if (i) {
                    if ($435bc7696844e930$var$Ie(i.id)) {
                        if (i.filter && r) {
                            let e = null;
                            for(let n = 0; n < r.length; n++){
                                r[n] !== e && (e = r[n]);
                                const s = a[e];
                                i.filter(s && s.feature, t) && l.set(e, i);
                            }
                        }
                    } else {
                        const e = o[i.id];
                        if (!e || !e.length) continue;
                        for(let t = 0; t < e.length; t++)l.set(e[t], i);
                    }
                }
            }
            return l;
        }(e, this.layer, this._highlighted) : null;
        (0, $9e7Ip.HighlightUtil).highlightMesh(this.regl, e, i, this._highlightTimestamp, n);
    }
    _updateTerrainAltitude(e, t, n, i, r) {
        let s = n.aAnchor;
        if (!s) {
            const { aPosition: e } = t;
            s = n.aAnchor = e.slice(0);
        }
        let o = n.aTerrainAltitude;
        o || (o = n.aTerrainAltitude = new Float32Array(s.length / i), o.fill($435bc7696844e930$var$me)), this._fillTerrainAltitude(o, s, r.tileInfo, 0, o.length - 1), t.aTerrainAltitude ? o.dirty && this._updateATerrainAltitude(e, o) : t.aTerrainAltitude = o, o.dirty = !1;
    }
    _updateATerrainAltitude(e, t) {
        e && e.updateData && e.updateData("aTerrainAltitude", t);
    }
    _fillTerrainAltitude(t, n, i, r, s) {
        const { res: o, extent: a, extent2d: l, id: h } = i, c = this.pluginIndex, u = h + "-" + c;
        if (i.completeTerrainQuery || (i.completeTerrainQuery = []), i.completeTerrainQuery[c]) return;
        if (!i.completeTerrainQuery[c] && this._terrainAltitudeCache && this._terrainAltitudeCache.has(u)) {
            const e = this._terrainAltitudeCache.getAndRemove(u);
            return this._terrainAltitudeCache.add(u, e), t.set(e.altitudeData), i.terrainTileInfos = e.terrainTileInfos, t.dirty = !0, void (i.completeTerrainQuery[c] = !0);
        }
        const f = this.layer, d = f.getMap(), p = f.getRenderer(), g = p && p.getTerrainHelper();
        let m = i.terrainTileInfos;
        m || (m = i.terrainTileInfos = this.layer.queryTerrainTiles(i)), i.terrainQueryStatus || (i.terrainQueryStatus = []);
        let y = !1, x = [];
        for(let e = 0; e < i.terrainTileInfos.length; e++)if (x[e] = +g.isTerrainTileLoaded(i.terrainTileInfos[e].id), x[e] && i.terrainQueryStatus[c] && !i.terrainQueryStatus[c][e]) {
            y = !0;
            break;
        }
        if (!y && i.terrainQueryStatus[c]) return;
        const _ = f.constructor;
        if (d.isInteracting()) {
            const e = p.getFrameTimestamp();
            _.altitudeQueryFrameTimestamp !== e && (_.altitudeQueryFrameTimestamp = e, _.altitudeQueryFrameTime = 0);
            const t = f.options.altitudeQueryTimeLimitPerFrame;
            if (_.altitudeQueryFrameTime > t) return;
        }
        const v = performance.now();
        i.terrainQueryStatus[c] = x;
        const { xmin: b, ymax: A } = l, T = $435bc7696844e930$var$on.set(b, A), S = this.layer.getTileSize().width / i.extent, w = n.length / t.length;
        let M = t.queryResult;
        M || (M = t.queryResult = new Map);
        let P = !0;
        for(let e = r; e <= s; e++){
            let i = n[e * w];
            i < 0 ? i = 0 : i > a && (i = a);
            let r = n[e * w + 1];
            r < 0 ? r = 0 : r > a && (r = a);
            const s = i + r * a;
            let l, h, c = M.get(s);
            if (c || 0 === c) t[e] !== c && (t[e] = c, t.dirty = !0);
            else {
                for(let e = 0; e < m.length; e++)if ($435bc7696844e930$var$$t(m[e], b + S * i, A - S * r, o)) {
                    l = m[e];
                    break;
                }
                l && (g.getRenderer().isTileCached(l.id) || t[e] === $435bc7696844e930$var$me) && ($435bc7696844e930$var$an.set(i, r), h = this.layer.queryTilePointTerrain($435bc7696844e930$var$an, l, T, a, o)), c = t[e], h && (c = null === h[0] ? $435bc7696844e930$var$me : h[0], $435bc7696844e930$var$ln[0] = c, c = $435bc7696844e930$var$ln[0]), t[e] !== c && (t[e] = c, t.dirty = !0), h && h[1] ? M.set(s, c) : P = !1;
            }
        }
        _.altitudeQueryFrameTime = (_.altitudeQueryFrameTime || 0) + (performance.now() - v), i.completeTerrainQuery[c] = P, P && (this._terrainAltitudeCache || (this._terrainAltitudeCache = new $gP1US.LRUCache(4 * this.layer.options.maxCacheSize)), this._terrainAltitudeCache.add(u, {
            altitudeData: t,
            terrainTileInfos: m
        }));
    }
}
function $435bc7696844e930$var$dn(e, t) {
    const n = e && e.getCommandKey(this.regl) || "", i = t && t.getCommandKey(this.regl) || "";
    return n.localeCompare(i);
}
function $435bc7696844e930$var$pn(e, t) {
    return e.properties.level - t.properties.level;
}
class $435bc7696844e930$var$gn extends $435bc7696844e930$var$fn {
    createGeometry(e, t) {
        if (!e.data) return {
            geometry: null,
            symbolIndex: e.symbolIndex
        };
        e.iconAtlas && e.iconAtlas.image && (e.iconAtlas.image.dataType = e.type, e.iconAtlas.image.type = "icon"), e.glyphAtlas && e.glyphAtlas.image && (e.glyphAtlas.image.type = "glyph");
        const n = $435bc7696844e930$var$we({}, e.data), i = {
            primitive: this.getPrimitive(),
            positionSize: e.positionSize
        };
        n.aAltitude && (i.altitudeAttribute = "aAltitude");
        const r = new (0, $2wazW).Geometry(n, e.indices, 0, i);
        return r.properties = {
            features: t
        }, e.iconAtlas && (r.properties.iconAtlas = e.iconAtlas.image, r.properties.iconPositions = e.iconAtlas.positions), e.glyphAtlas && (r.properties.glyphAtlas = e.glyphAtlas.image), $435bc7696844e930$var$bt(t) || (r.properties.aFeaIds = e.featureIds, this._prepareFeatureIds(r, e)), e.markerPlacement && (r.properties.markerPlacement = e.markerPlacement), e.textPlacement && (r.properties.textPlacement = e.textPlacement), $435bc7696844e930$var$we(r.properties, e.properties), {
            geometry: r,
            symbolIndex: e.symbolIndex
        };
    }
    getRayCastData(e, t) {
        const { features: n, aFeaIds: i } = e.geometry.properties;
        if (!n || !i) return null;
        return n[i[t]];
    }
    getPrimitive() {
        return "triangles";
    }
    getRenderFBO(e) {
        return e && e.renderTarget && e.renderTarget.fbo;
    }
    supportRenderMode(e) {
        return "noAa" === e;
    }
    drawDebugAtlas(e) {
        if (document.getElementById("MAPTALKS_ICON_DEBUG")) {
            const t = document.getElementById("MAPTALKS_ICON_DEBUG");
            let n;
            if (t.width = e.width, t.height = e.height, t.style.width = e.width + "px", t.style.height = e.height + "px", "alpha" === e.format) {
                n = new Uint8ClampedArray(4 * e.data.length);
                for(let t = 0; t < e.data.length; t++)n[4 * t + 3] = e.data[t];
            } else n = new Uint8ClampedArray(e.data);
            const i = t.getContext("2d");
            i.imageSmoothingEnabled = !1, i.putImageData(new ImageData(n, e.width, e.height), 0, 0);
        }
    }
}
var $435bc7696844e930$var$mn = "#include <gl2_vert>\n#ifdef HAS_ALTITUDE\nattribute vec2 aPosition;\nattribute float aAltitude;\n#else\nattribute vec3 aPosition;\n#endif\nuniform mat4 projViewModelMatrix;\nuniform mat4 positionMatrix;\n#include <fbo_picking_vert>\n#include <vt_position_vert>\nvoid main() {\n  vec3 c = unpackVTPosition();\n  gl_Position = projViewModelMatrix * positionMatrix * vec4(c, 1.);\n  fbo_picking_setData(gl_Position.w, true);\n}";
function $435bc7696844e930$var$yn(e, t, n, i) {
    if (i) {
        const e = (0, $2wazW).Util.resizeToPowerOfTwo(t.data, t.width, t.height);
        t.data = e;
    }
    const r = t, o = {
        width: r.width,
        height: r.height,
        data: r.data,
        format: r.format,
        mag: "linear",
        min: i ? "linear mipmap linear" : "linear",
        flipY: n,
        premultiplyAlpha: !0
    };
    if ("icon" === t.type) {
        const e = "point" !== t.dataType ? "repeat" : "clamp";
        o.wrapS = e, o.wrapT = e;
    }
    return e.texture(o);
}
const $435bc7696844e930$var$xn = [
    0,
    0
], $435bc7696844e930$var$_n = [];
function $435bc7696844e930$var$vn(e) {
    if (!e.properties.iconPositions) return $435bc7696844e930$var$xn;
    let t, n = 0;
    for(const i in e.properties.iconPositions)if (t = i, n++, n > 1) return $435bc7696844e930$var$xn;
    if (!t) return $435bc7696844e930$var$xn;
    const i = e.properties.iconPositions[t], r = i.displaySize[0], s = i.displaySize[1];
    return $435bc7696844e930$var$_n[0] = r, $435bc7696844e930$var$_n[1] = s, $435bc7696844e930$var$_n;
}
const { INVALID_TEX_COORD: $435bc7696844e930$var$bn } = $435bc7696844e930$var$H(), $435bc7696844e930$var$An = (0, $3iqbd).identity([]), $435bc7696844e930$var$Tn = {
    polygonFill: [
        1,
        1,
        1,
        1
    ],
    polygonOpacity: 1,
    uvScale: [
        1,
        1
    ],
    uvOffset: [
        0,
        0
    ],
    patternWidth: [
        0,
        0
    ],
    patternOffset: [
        0,
        0
    ]
}, $435bc7696844e930$var$Sn = [], $435bc7696844e930$var$wn = new $gP1US.Coordinate(0, 0), $435bc7696844e930$var$Mn = new $gP1US.Coordinate(0, 0), $435bc7696844e930$var$Pn = new $gP1US.Coordinate(0, 0), $435bc7696844e930$var$In = [];
class $435bc7696844e930$export$2a19652d1018576 extends $435bc7696844e930$var$gn {
    static getBloomSymbol() {
        return [
            "polygonBloom"
        ];
    }
    prepareSymbol(e) {
        const t = e.polygonFill;
        Array.isArray(t) && (3 === t.length && t.push(1), e.polygonFill = t.map((e)=>255 * e));
    }
    supportRenderMode(e) {
        return this.sceneConfig.antialias || void 0 === this.sceneConfig.antialias ? "fxaa" === e || "fxaaBeforeTaa" === e : super.supportRenderMode(e);
    }
    isBloom(e) {
        return !!this.getSymbol(e.properties.symbolIndex)[$435bc7696844e930$export$2a19652d1018576.getBloomSymbol()[0]];
    }
    forbiddenTerrainUpscale() {
        return !0;
    }
    needPolygonOffset() {
        return !0;
    }
    getAnalysisMeshes() {
        if (!this.isVisible()) return $435bc7696844e930$var$Sn;
        return this.scene.getMeshes().filter((e)=>0 === e.properties.level);
    }
    createMesh(t, n, i) {
        const r = this.getMap(), { tilePoint: o } = i, { geometry: a, symbolIndex: l, ref: h } = t, c = this.layer instanceof $gP1US.TileLayer, u = this.layer.getTileSize().width, d = a.properties.tileExtent / u, p = a.properties.tileResolution, g = r.pointAtResToCoord($435bc7696844e930$var$wn.set(o[0], o[1]), p), m = {
            tileExtent: a.properties.tileExtent,
            tileRatio: d
        }, y = this.getSymbol(l), x = this.getSymbolDef(l);
        if ((0, $14507960c5dac0fb$export$ec423ecbfcdb9a06)(x.polygonPatternFileOrigin) && this._preparePatternOrigin(x, t, c ? [
            0,
            0
        ] : o, p), ((0, $14507960c5dac0fb$export$ec423ecbfcdb9a06)(x.polygonPatternFileWidth) || (0, $14507960c5dac0fb$export$ec423ecbfcdb9a06)(x.polygonPatternFileWidth)) && this._preparePatternWidth(x, t, c ? d : 1, g, p), x.uvOffsetInMeter && (0, $14507960c5dac0fb$export$ec423ecbfcdb9a06)(x.uvOffset) && this._preparePatternOffset(x, t, g, p), $435bc7696844e930$var$ke(m, "polygonFill", y, "polygonFill", $435bc7696844e930$var$Tn.polygonFill, $435bc7696844e930$var$Re(this.colorCache)), $435bc7696844e930$var$ke(m, "polygonOpacity", y, "polygonOpacity", $435bc7696844e930$var$Tn.polygonOpacity), $435bc7696844e930$var$ke(m, "uvScale", y, "uvScale", $435bc7696844e930$var$Tn.uvScale), void 0 === h) {
            const e = this.getFnTypeConfig(l);
            $435bc7696844e930$var$wt(a, x, e, this.layer), a.generateBuffers(this.regl);
        }
        const v = a.properties.iconAtlas, b = 2048;
        if (v && a.data.aTexInfo) {
            const e = [];
            Object.defineProperty(m, "uvOrigin", {
                enumerable: !0,
                get: ()=>{
                    const t = m.tileScale;
                    if (a.data.aPatternOrigin) return e[0] = o[0] * t % b, e[1] = o[1] * t % b, e;
                    const n = y.polygonPatternFileOrigin;
                    return n ? ($435bc7696844e930$var$wn.set(n[0], n[1]), r.coordToPointAtRes($435bc7696844e930$var$wn, p, $435bc7696844e930$var$Mn), (0, $6BoVD).set(e, o[0] - $435bc7696844e930$var$Mn.x, o[1] - $435bc7696844e930$var$Mn.y)) : (e[0] = o[0] * t % b, e[1] = o[1] * t % b, e);
                }
            });
            const t = [];
            Object.defineProperty(m, "patternWidth", {
                enumerable: !0,
                get: ()=>{
                    if (a.data.aPatternWidth) return $435bc7696844e930$var$Tn.patternWidth;
                    const e = x.polygonPatternFileWidth, n = x.polygonPatternFileHeight;
                    if (!e && !n) return $435bc7696844e930$var$Tn.patternWidth;
                    const [i, r] = this._computePatternWidth($435bc7696844e930$var$In, e, n, c ? d : 1, g, p);
                    return (0, $6BoVD).set(t, i, r);
                }
            }), Object.defineProperty(m, "uvOffset", {
                enumerable: !0,
                get: ()=>a.data.aPatternOffset || x.uvOffsetInMeter ? $435bc7696844e930$var$Tn.uvOffset : y.uvOffset || $435bc7696844e930$var$Tn.uvOffset
            });
            const n = [];
            Object.defineProperty(m, "patternOffset", {
                enumerable: !0,
                get: ()=>{
                    if (a.data.aPatternOffset) return $435bc7696844e930$var$Tn.uvOffset;
                    if (!x.uvOffsetInMeter) return $435bc7696844e930$var$Tn.uvOffset;
                    const e = x.uvOffset;
                    if (!e) return $435bc7696844e930$var$Tn.uvOffset;
                    const t = $435bc7696844e930$var$Ue(r, e[0], g, p), i = $435bc7696844e930$var$Ue(r, e[1], g, p);
                    return (0, $6BoVD).set(n, t, i);
                }
            }), Object.defineProperty(m, "tileScale", {
                enumerable: !0,
                get: function() {
                    const e = x.polygonPatternFileWidth, t = x.polygonPatternFileHeight;
                    return e || t ? 1 : a.properties.tileResolution / r.getResolution();
                }
            }), m.polygonPatternFile = $435bc7696844e930$var$yn(this.regl, v, !1, !1), m.atlasSize = [
                v.width,
                v.height
            ], this.drawDebugAtlas(v);
        }
        const A = new (0, $2wazW).Material(m, $435bc7696844e930$var$Tn), T = new (0, $2wazW).Mesh(a, A, {
            castShadow: !1,
            picking: !0
        }), S = {};
        return v && a.data.aTexInfo && (S.HAS_PATTERN = 1), v && a.data.aTexCoord && (S.HAS_TEX_COORD = 1, S.INVALID_TEX_COORD = $435bc7696844e930$var$bn + ".0"), a.data.aAltitude && (S.HAS_ALTITUDE = 1), a.data.aColor && (S.HAS_COLOR = 1), a.data.aOpacity && (S.HAS_OPACITY = 1), a.data.aUVScale && (S.HAS_UV_SCALE = 1), a.data.aUVOffset && (S.HAS_UV_OFFSET = 1), a.data.aPatternOrigin && (S.HAS_PATTERN_ORIGIN = 1), a.data.aPatternWidth && (S.HAS_PATTERN_WIDTH = 1), a.data.aPatternOffset && (S.HAS_PATTERN_OFFSET = 1), c && (S.IS_VT = 1), T.setDefines(S), T.positionMatrix = this.getAltitudeOffsetMatrix(), T.setLocalTransform(n), T.properties.symbolIndex = l, T;
    }
    _preparePatternWidth(e, t, n, i, r) {
        if (!(t = t && t.geometry)) return;
        const s = t.properties.features;
        if ($435bc7696844e930$var$bt(s)) return;
        const o = e.polygonPatternFileWidth, a = e.polygonPatternFileHeight, l = (0, $14507960c5dac0fb$export$b5e0f6446c9b8e3c)(e.polygonPatternFileOrigin);
        let h, c;
        (0, $14507960c5dac0fb$export$ec423ecbfcdb9a06)(o) && (h = (0, $14507960c5dac0fb$export$b5e0f6446c9b8e3c)(o)), (0, $14507960c5dac0fb$export$ec423ecbfcdb9a06)(a) && (c = (0, $14507960c5dac0fb$export$b5e0f6446c9b8e3c)(a));
        const { aPickingId: u, aPatternOrigin: f } = t.data, d = u.length, p = new Float32Array(2 * d);
        let g, m, y;
        for(let e = 0, t = u.length; e < t; e++){
            let t, d;
            if (u[e] === g) {
                p[2 * e] = m, p[2 * e + 1] = y;
                continue;
            }
            const x = s[u[e]];
            if (t = h ? h(null, x.feature.properties) : o, d = c ? c(null, x.feature.properties) : a, g = u[e], t || d) {
                let s = i;
                if (f) {
                    const e = l(null, x.feature.properties);
                    e && (s = $435bc7696844e930$var$Pn.set(e[0], e[1]));
                }
                const [o, a] = this._computePatternWidth($435bc7696844e930$var$In, t, d, n, s, r);
                m = p[2 * e] = o, y = p[2 * e + 1] = a;
            } else m = p[2 * e] = 0, y = p[2 * e + 1] = 0;
        }
        t.data.aPatternWidth = p;
    }
    _preparePatternOffset(e, t, n, i) {
        if (!(t = t && t.geometry)) return;
        const r = t.properties.features;
        if ($435bc7696844e930$var$bt(r)) return;
        const s = this.getMap();
        let o = (0, $14507960c5dac0fb$export$ec423ecbfcdb9a06)(e.uvOffsetInMeter) && (0, $14507960c5dac0fb$export$79e978600dd1e509)(e.uvOffsetInMeter);
        const a = (0, $14507960c5dac0fb$export$b5e0f6446c9b8e3c)(e.uvOffset), l = (0, $14507960c5dac0fb$export$b5e0f6446c9b8e3c)(e.polygonPatternFileOrigin), { aPickingId: h, aPatternOrigin: c } = t.data, u = h.length, f = new Float32Array(2 * u);
        let d, p, g;
        for(let e = 0, t = h.length; e < t; e++){
            if (h[e] === d) {
                f[2 * e] = p, f[2 * e + 1] = g;
                continue;
            }
            const t = r[h[e]], u = a(null, t.feature.properties);
            let m = !0;
            if (o && (m = o(null, t.feature.properties)), d = h[e], u && m) {
                let r = n;
                if (c) {
                    const e = l(null, t.feature.properties);
                    e && (r = $435bc7696844e930$var$Pn.set(e[0], e[1]));
                }
                const o = $435bc7696844e930$var$Ue(s, u[0], r, i), a = $435bc7696844e930$var$Ue(s, u[0], r, i);
                p = f[2 * e] = o, g = f[2 * e + 1] = a;
            } else p = f[2 * e] = 0, g = f[2 * e + 1] = 0;
        }
        t.data.aPatternOffset = f;
    }
    _preparePatternOrigin(e, t, n, i) {
        if (!(t = t && t.geometry)) return;
        const r = t.properties.features;
        if ($435bc7696844e930$var$bt(r)) return;
        const s = this.getMap(), o = (0, $14507960c5dac0fb$export$b5e0f6446c9b8e3c)(e.polygonPatternFileOrigin), a = t.data.aPickingId, l = a.length, h = new Float32Array(2 * l);
        let c, u, f;
        for(let e = 0, t = a.length; e < t; e++){
            if (a[e] === c) {
                h[2 * e] = u, h[2 * e + 1] = f;
                continue;
            }
            c = a[e];
            const t = o(null, r[c].feature.properties);
            t ? ($435bc7696844e930$var$wn.set(t[0], t[1]), s.coordToPointAtRes($435bc7696844e930$var$wn, i, $435bc7696844e930$var$Mn), u = h[2 * e] = $435bc7696844e930$var$Mn.x, f = h[2 * e + 1] = $435bc7696844e930$var$Mn.y) : (u = h[2 * e] = n[0], f = h[2 * e + 1] = n[1]);
        }
        t.data.aPatternOrigin = h;
    }
    createFnTypeConfig(e, t) {
        const n = (0, $14507960c5dac0fb$export$79e978600dd1e509)(t.polygonFill), i = (0, $14507960c5dac0fb$export$b5e0f6446c9b8e3c)(t.polygonOpacity), r = (0, $14507960c5dac0fb$export$b5e0f6446c9b8e3c)(t.uvScale), s = (0, $14507960c5dac0fb$export$b5e0f6446c9b8e3c)(t.uvOffset), o = new Uint8Array(1), a = new Uint16Array(2), l = new Uint8Array(2);
        return [
            {
                attrName: "aColor",
                symbolName: "polygonFill",
                type: Uint8Array,
                width: 4,
                define: "HAS_COLOR",
                evaluate: (t, i)=>{
                    let r = n(e.getZoom(), t);
                    return (0, $14507960c5dac0fb$export$ec423ecbfcdb9a06)(r) && (r = this.evaluateInFnTypeConfig(r, i, e, t, !0)), Array.isArray(r) || (r = this.colorCache[r] = this.colorCache[r] || (0, (/*@__PURE__*/$parcel$interopDefault($08acccbbd431ef55$exports)))(r).unitArray()), r = $435bc7696844e930$var$Oe(r), r;
                }
            },
            {
                attrName: "aOpacity",
                symbolName: "polygonOpacity",
                type: Uint8Array,
                width: 1,
                define: "HAS_OPACITY",
                evaluate: (t, n)=>{
                    let r = i(e.getZoom(), t);
                    return (0, $14507960c5dac0fb$export$ec423ecbfcdb9a06)(r) && (r = this.evaluateInFnTypeConfig(r, n, e, t)), o[0] = 255 * r, o[0];
                }
            },
            {
                attrName: "aUVScale",
                symbolName: "uvScale",
                type: Uint16Array,
                width: 2,
                define: "HAS_UV_SCALE",
                evaluate: (t)=>{
                    const n = r(e.getZoom(), t);
                    return a[0] = 255 * n[0], a[1] = 255 * n[1], a;
                }
            },
            {
                attrName: "aUVOffset",
                symbolName: "uvOffset",
                type: Uint8Array,
                width: 2,
                define: "HAS_UV_OFFSET",
                evaluate: (t)=>{
                    const n = s(e.getZoom(), t);
                    return l[0] = 255 * n[0], l[1] = 255 * n[1], l;
                }
            }
        ];
    }
    paint(e) {
        this.isShadowIncludeChanged(e) && (this.shader.dispose(), this._createShader(e)), super.paint(e);
    }
    isEnableTileStencil(t) {
        const n = "VectorTileLayer" === this.layer.getJSONType(), i = this.layer instanceof $gP1US.TileLayer;
        return !!!(t && t.isRenderingTerrain && this.isTerrainSkin()) && (n || i && this.isOnly2D());
    }
    init(t) {
        const n = this.regl, i = this.canvas, r = {
            x: (e, t)=>t.viewport ? t.viewport.x : 0,
            y: (e, t)=>t.viewport ? t.viewport.y : 0,
            width: (e, t)=>t.viewport ? t.viewport.width : i ? i.width : 1,
            height: (e, t)=>t.viewport ? t.viewport.height : i ? i.height : 1
        };
        this.renderer = new (0, $2wazW).Renderer(n);
        const o = {
            viewport: r,
            stencil: {
                enable: ()=>this.isEnableTileStencil(t),
                func: {
                    cmp: ()=>this.isOnly2D() ? "=" : "<=",
                    ref: (e, t)=>t.stencilRef
                },
                op: {
                    fail: "keep",
                    zfail: "keep",
                    zpass: ()=>{
                        const e = "VectorTileLayer" === this.layer.getJSONType(), t = this.isOnly2D();
                        return e && t ? "zero" : "replace";
                    }
                }
            },
            depth: {
                enable: !0,
                range: this.sceneConfig.depthRange || [
                    0,
                    1
                ],
                mask: (e, t)=>{
                    if (!$435bc7696844e930$var$Ie(this.sceneConfig.depthMask)) return !!this.sceneConfig.depthMask;
                    if (t.hasSSRGround) return !0;
                    if (t.meshConfig.transparent) return !1;
                    const n = t.polygonOpacity;
                    return !($435bc7696844e930$var$Le(n) && n < 1);
                },
                func: this.sceneConfig.depthFunc || "<="
            },
            blend: {
                enable: !0,
                func: this.getBlendFunc(),
                equation: "add"
            },
            polygonOffset: {
                enable: !0,
                offset: this.getPolygonOffset()
            }
        };
        if (this._createShader(t, o), this.pickingFBO) {
            const t = [], n = this.layer instanceof $gP1US.TileLayer;
            this.picking = [
                new (0, $2wazW).FBORayPicking(this.renderer, {
                    vert: $435bc7696844e930$var$mn,
                    uniforms: [
                        {
                            name: "projViewModelMatrix",
                            type: "function",
                            fn: function(e, n) {
                                return (0, $3iqbd).multiply(t, n.projViewMatrix, n.modelMatrix), t;
                            }
                        }
                    ],
                    extraCommandProps: o,
                    enableStencil: ()=>n && this.isOnly2D()
                }, this.pickingFBO, this.getMap())
            ];
        }
    }
    _createShader(e, t) {
        const n = [], i = [
            {
                name: "projViewModelMatrix",
                type: "function",
                fn: function(e, t) {
                    return (0, $3iqbd).multiply(n, t.projViewMatrix, t.modelMatrix), n;
                }
            }
        ], r = {};
        this.fillIncludes(r, i, e), this.shader = new (0, $2wazW).MeshShader({
            vert: "#define SHADER_NAME FILL\n#ifdef HAS_ALTITUDE\nattribute vec2 aPosition;\nattribute float aAltitude;\n#else\nattribute vec3 aPosition;\n#endif\n#ifdef HAS_COLOR\nattribute vec4 aColor;\nvarying vec4 vColor;\n#endif\n#ifdef HAS_OPACITY\nattribute float aOpacity;\nvarying float vOpacity;\n#endif\nuniform mat4 projViewModelMatrix;\nuniform mat4 positionMatrix;\n#ifndef IS_VT\nuniform mat4 modelMatrix;\n#endif\n#ifdef HAS_PATTERN\n#ifdef HAS_TEX_COORD\nattribute vec2 aTexCoord;\n#endif\nattribute vec4 aTexInfo;\nuniform vec2 patternWidth;\nuniform vec2 patternOffset;\nuniform vec2 uvOrigin;\nuniform vec2 uvScale;\n#ifdef IS_VT\nuniform float tileRatio;\nuniform float tileScale;\n#else\nuniform float glScale;\n#endif\n#ifdef HAS_UV_SCALE\nattribute vec2 aUVScale;\nvarying vec2 vUVScale;\n#endif\n#ifdef HAS_UV_OFFSET\nattribute vec2 aUVOffset;\nvarying vec2 vUVOffset;\n#endif\n#ifdef HAS_PATTERN_WIDTH\nattribute vec2 aPatternWidth;\n#endif\n#ifdef HAS_PATTERN_ORIGIN\nattribute vec2 aPatternOrigin;\n#endif\n#ifdef HAS_PATTERN_OFFSET\nattribute vec2 aPatternOffset;\n#endif\nvarying vec2 vTexCoord;\nvarying vec4 vTexInfo;\nvec2 c(vec2 d, vec2 e) {\n  \n#ifdef IS_VT\nfloat f = d.x / e.x;\n  float h = d.y / e.y;\n  return vec2(f, h);\n#else\nfloat i = glScale;\n#ifdef HAS_PATTERN_WIDTH\nfloat j = sign(length(aPatternWidth));\n  i = mix(glScale, 1., j);\n#endif\nvec2 k = uvOrigin;\n#ifdef HAS_PATTERN_ORIGIN\nk = aPatternOrigin;\n#endif\n#ifdef HAS_PATTERN_OFFSET\nvec2 l = aPatternOffset;\n#else\nvec2 l = patternOffset;\n#endif\nk += l;\n  float f = (d.x - k.x) * i / e.x;\n  float h = (d.y - k.y) * i / e.y;\n  return vec2(f, -h);\n#endif\n}\nvec2 m(vec4 n, vec2 o) {\n  \n#ifdef IS_VT\n#ifdef HAS_PATTERN_OFFSET\nvec2 l = aPatternOffset;\n#else\nvec2 l = patternOffset;\n#endif\nvec2 k = uvOrigin + l;\n#ifdef HAS_PATTERN_ORIGIN\nk = k - aPatternOrigin * tileScale;\n#endif\nfloat j = sign(length(patternWidth));\n  vec2 A = mix(o, patternWidth, j);\n#ifdef HAS_PATTERN_WIDTH\nA = aPatternWidth;\n#endif\nvec2 B = k * vec2(1., -1.) / A;\n  return mod(B, 1.) + c(n.xy * tileScale / tileRatio, A);\n#else\nvec2 A = o;\n#ifdef HAS_PATTERN_WIDTH\nfloat j = sign(length(aPatternWidth));\n  A = mix(o, aPatternWidth, j);\n#endif\nvec4 C = modelMatrix * n;\n  return c(C.xy, A);\n#endif\n}\n#endif\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n#include <vsm_shadow_vert>\n#endif\n#include <vt_position_vert>\n#include <highlight_vert>\nvoid main() {\n  vec3 D = unpackVTPosition();\n  vec4 n = vec4(D, 1.);\n  gl_Position = projViewModelMatrix * positionMatrix * n;\n#ifdef HAS_PATTERN\nvec2 o = aTexInfo.zw + 1.;\n  vTexInfo = vec4(aTexInfo.xy, o);\n#ifdef HAS_TEX_COORD\nif(aTexCoord.x == INVALID_TEX_COORD) {\n    vTexCoord = m(n, o);\n  } else {\n    vTexCoord = aTexCoord;\n  }\n#else\nvTexCoord = m(n, o);\n#endif\n#ifdef HAS_UV_SCALE\nvUVScale = aUVScale / 255.;\n#endif\n#ifdef HAS_UV_OFFSET\nvUVOffset = aUVOffset / 255.;\n#endif\n#endif\n#ifdef HAS_COLOR\nvColor = aColor / 255.;\n#endif\nhighlight_setVarying();\n#ifdef HAS_OPACITY\nvOpacity = aOpacity / 255.;\n#endif\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\nshadow_computeShadowPars(n);\n#endif\n}",
            frag: "#define SHADER_NAME FILL\nprecision mediump float;\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n#include <vsm_shadow_frag>\n#endif\n#ifdef HAS_PATTERN\n#ifdef HAS_UV_SCALE\nvarying vec2 vUVScale;\n#else\nuniform highp vec2 uvScale;\n#endif\n#ifdef HAS_UV_OFFSET\nvarying vec2 vUVOffset;\n#else\nuniform vec2 uvOffset;\n#endif\n#endif\n#ifdef HAS_PATTERN\nuniform sampler2D polygonPatternFile;\nuniform vec2 atlasSize;\nvarying vec2 vTexCoord;\nvarying vec4 vTexInfo;\nvec2 c() {\n  \n#ifdef HAS_UV_SCALE\nvec2 d = vUVScale;\n#else\nvec2 d = uvScale;\n#endif\n#ifdef HAS_UV_OFFSET\nvec2 e = vUVOffset;\n#else\nvec2 e = uvOffset;\n#endif\nvec2 f = mod(vTexCoord * d + e, 1.);\n  vec2 h = vTexInfo.xy;\n  vec2 i = vTexInfo.zw;\n  return (h + f * i) / atlasSize;\n}\n#endif\n#ifdef HAS_COLOR\nvarying vec4 vColor;\n#else\nuniform vec4 polygonFill;\n#endif\n#include <highlight_frag>\n#ifdef HAS_OPACITY\nvarying float vOpacity;\n#else\nuniform lowp float polygonOpacity;\n#endif\nuniform float layerOpacity;\nuniform float tileExtent;\nvoid main() {\n  \n#ifdef HAS_COLOR\nvec4 j = vColor;\n#else\nvec4 j = polygonFill;\n#endif\n#ifdef HAS_PATTERN\nif(vTexInfo.z * vTexInfo.w > 1.) {\n    vec2 f = c();\n    j = texture2D(polygonPatternFile, f);\n  }\n#endif\n#ifdef HAS_OPACITY\ngl_FragColor = j * vOpacity;\n#else\ngl_FragColor = j * polygonOpacity;\n#endif\ngl_FragColor *= layerOpacity;\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\nfloat k = shadow_computeShadow();\n  gl_FragColor.rgb = shadow_blend(gl_FragColor.rgb, k);\n#endif\ngl_FragColor = highlight_blendColor(gl_FragColor);\n}",
            uniforms: i,
            defines: r,
            extraCommandProps: t
        });
    }
    getUniformValues(e, t) {
        const n = t && t.isRenderingTerrainSkin, i = {
            projViewMatrix: n ? $435bc7696844e930$var$An : e.projViewMatrix,
            glScale: t && t.isRenderingTerrainSkin ? 1 : 1 / e.getGLScale(),
            viewport: n && t && t.viewport,
            hasSSRGround: t && t.hasSSRGround
        };
        return this.setIncludeUniformValues(i, t), i;
    }
    _computePatternWidth(e, t, n, i, r, s) {
        let o, a;
        const l = this.getMap();
        if (t) o = $435bc7696844e930$var$Ue(l, t, r, s);
        if (n) a = $435bc7696844e930$var$Ue(l, n, r, s, 1);
        return o = o || a, a = a || o, e[0] = o, e[1] = a, e;
    }
}
var $435bc7696844e930$var$kn = "#define SHADER_NAME LINE\n#define AA_CLIP_LIMIT 2.0\n#define AA_LINE_WIDTH 16.0\n#define DEVICE_PIXEL_RATIO 1.0\n#define ANTIALIASING 1.0 / DEVICE_PIXEL_RATIO / 2.0\n#define EXTRUDE_SCALE 63.0\n#define EXTRUDE_MOD 64.0\n#define MAX_LINE_DISTANCE 65535.0\n#ifdef PICKING_MODE\n#include <gl2_vert>\n#endif\n#ifdef HAS_ALTITUDE\nattribute vec2 aPosition;\nattribute float aAltitude;\n#else\nattribute vec3 aPosition;\n#endif\n#if defined(HAS_PATTERN) || defined(HAS_DASHARRAY)\nattribute vec3 aExtrude;\n#else\nattribute vec2 aExtrude;\n#endif\n#if defined(HAS_PATTERN) || defined(HAS_DASHARRAY) || defined(HAS_GRADIENT) || defined(HAS_TRAIL)\nattribute float aLinesofar;\nvarying highp float vLinesofar;\n#endif\nuniform float cameraToCenterDistance;\n#if defined(HAS_STROKE_WIDTH)\nattribute float aLineStrokeWidth;\n#else\nuniform float lineStrokeWidth;\n#endif\nuniform mat4 positionMatrix;\nuniform mat4 projViewModelMatrix;\nuniform mat4 modelMatrix;\nuniform float tileResolution;\nuniform float resolution;\nuniform float tileRatio;\nuniform float isRenderingTerrain;\n#if defined(HAS_LINE_DX) || defined(HAS_LINE_DY)\nattribute vec2 aLineDxDy;\n#endif\n#ifndef HAS_LINE_DX\nuniform float lineDx;\n#endif\n#ifndef HAS_LINE_DY\nuniform float lineDy;\n#endif\nuniform vec2 canvasSize;\nuniform float layerScale;\nvarying vec2 vNormal;\nvarying vec2 vWidth;\nvarying float vGammaScale;\n#ifndef ENABLE_TILE_STENCIL\nvarying vec2 vPosition;\n#endif\n#ifdef USE_LINE_OFFSET\nattribute vec2 aExtrudeOffset;\n#endif\n#ifdef HAS_LINE_WIDTH\nattribute float aLineWidth;\n#else\nuniform float lineWidth;\n#endif\n#ifndef PICKING_MODE\n#ifndef HAS_GRADIENT\n#ifdef HAS_COLOR\nattribute vec4 aColor;\nvarying vec4 vColor;\n#endif\n#ifdef HAS_PATTERN\n#if defined(HAS_PATTERN_ANIM) || defined(HAS_PATTERN_GAP)\nattribute vec2 aLinePattern;\n#endif\n#ifdef HAS_PATTERN_ANIM\nvarying float vLinePatternAnimSpeed;\n#endif\n#ifdef HAS_PATTERN_GAP\nvarying float vLinePatternGap;\n#endif\nattribute vec4 aTexInfo;\nvarying vec4 vTexInfo;\n#endif\n#ifdef HAS_DASHARRAY\n#ifdef HAS_DASHARRAY_ATTR\nattribute vec4 aDasharray;\nvarying vec4 vDasharray;\n#endif\n#ifdef HAS_DASHARRAY_COLOR\nattribute vec4 aDashColor;\nvarying vec4 vDashColor;\n#endif\n#endif\n#endif\n#ifdef HAS_STROKE_COLOR\nattribute vec4 aStrokeColor;\nvarying vec4 vStrokeColor;\n#endif\n#ifdef HAS_OPACITY\nattribute float aOpacity;\nvarying float vOpacity;\n#endif\n#ifdef HAS_GRADIENT\nattribute float aGradIndex;\nvarying float vGradIndex;\n#endif\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n#include <vsm_shadow_vert>\n#endif\n#include <highlight_vert>\n#else\n#include <fbo_picking_vert>\n#endif\nvarying vec3 vVertex;\n#include <vt_position_vert>\nvoid main() {\n  vec3 c = unpackVTPosition();\n  float d = mod(abs(aExtrude.x), 2.);\n  float e = mod(abs(aExtrude.y), 2.);\n  vNormal = vec2(d, e * 2. - 1.);\n  vec4 f = vec4(c, 1.);\n  vec4 h = projViewModelMatrix * positionMatrix * f;\n  if(isRenderingTerrain == 1.) {\n    vVertex = (positionMatrix * f).xyz;\n  } else {\n    vVertex = (modelMatrix * positionMatrix * f).xyz;\n  }\n#ifdef HAS_STROKE_WIDTH\nfloat i = aLineStrokeWidth / 2. * layerScale;\n#else\nfloat i = lineStrokeWidth;\n#endif\n#ifdef HAS_LINE_WIDTH\nfloat j = aLineWidth / 2. * layerScale;\n#else\nfloat j = lineWidth * layerScale;\n#endif\nfloat k = j / 2. + i;\n  float l = sign(i) * j / 2.;\n  float m = l + sign(l) * ANTIALIASING;\n  float n = k + sign(k) * ANTIALIASING;\n#ifdef USE_LINE_OFFSET\nvec2 o = lineOffset * (vNormal.y * (aExtrude.xy - aExtrudeOffset) + aExtrudeOffset);\n  vec2 u = (n * aExtrude.xy + o) / EXTRUDE_SCALE;\n#else\nvec2 v = aExtrude.xy / EXTRUDE_SCALE;\n  vec2 u = n * v;\n#endif\nfloat A = tileResolution / resolution;\n  vec4 B = vec4(c + vec3(u, .0) * tileRatio / A, 1.);\n  gl_Position = projViewModelMatrix * positionMatrix * B;\n#ifdef HAS_LINE_DX\nfloat C = aLineDxDy[0];\n#else\nfloat C = lineDx;\n#endif\n#ifdef HAS_LINE_DY\nfloat D = aLineDxDy[1];\n#else\nfloat D = lineDy;\n#endif\nfloat E = gl_Position.w;\n  gl_Position.xy += vec2(C, D) * 2. / canvasSize * E;\n#ifndef PICKING_MODE\nvWidth = vec2(n, m);\n  if(isRenderingTerrain == 1.) {\n    vGammaScale = 1.;\n  } else {\n    vGammaScale = E / cameraToCenterDistance;\n  }\n#ifndef ENABLE_TILE_STENCIL\nvPosition = c.xy;\n#ifdef USE_LINE_OFFSET\nvPosition += tileRatio * o / EXTRUDE_SCALE;\n#endif\n#endif\n#if defined(HAS_PATTERN) || defined(HAS_DASHARRAY) || defined(HAS_GRADIENT)\n#ifdef HAS_GRADIENT\nvLinesofar = aLinesofar / MAX_LINE_DISTANCE;\n  vGradIndex = aGradIndex;\n#else\nfloat F = aLinesofar - k * aExtrude.z / EXTRUDE_SCALE / A * tileRatio;\n  vLinesofar = F / tileRatio * A;\n#endif\n#endif\n#ifndef HAS_GRADIENT\n#ifdef HAS_COLOR\nvColor = aColor;\n#endif\n#ifdef HAS_DASHARRAY\n#ifdef HAS_DASHARRAY_ATTR\nvDasharray = aDasharray;\n#endif\n#ifdef HAS_DASHARRAY_COLOR\nvDashColor = aDashColor / 255.;\n#endif\n#endif\n#ifdef HAS_PATTERN\nvTexInfo = vec4(aTexInfo.xy, aTexInfo.zw + 1.);\n#ifdef HAS_PATTERN_ANIM\nvLinePatternAnimSpeed = aLinePattern[0] / 127.;\n#endif\n#ifdef HAS_PATTERN_GAP\nvLinePatternGap = aLinePattern[1] / 10.0;\n#endif\n#endif\n#endif\n#ifdef HAS_STROKE_COLOR\nvStrokeColor = aStrokeColor;\n#endif\n#ifdef HAS_OPACITY\nvOpacity = aOpacity / 255.;\n#endif\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\nshadow_computeShadowPars(B);\n#endif\nhighlight_setVarying();\n#else\nfbo_picking_setData(E, true);\n#endif\n}";
const $435bc7696844e930$var$Fn = (0, $3iqbd).identity([]), $435bc7696844e930$var$On = [];
class $435bc7696844e930$export$5f708b59aa06f95b extends $435bc7696844e930$var$gn {
    static getBloomSymbol() {
        return [
            "lineBloom"
        ];
    }
    isUniqueStencilRefPerTile() {
        return !1;
    }
    prepareSymbol(e) {
        const t = e.lineColor;
        Array.isArray(t) && (3 === t.length && t.push(1), e.lineColor = t.map((e)=>255 * e));
        const n = e.lineStrokeColor;
        Array.isArray(n) && (3 === n.length && n.push(1), e.lineStrokeColor = n.map((e)=>255 * e));
        const i = e.lineDashColor;
        Array.isArray(i) && (3 === i.length && i.push(1), e.lineDashColor = i.map((e)=>255 * e));
    }
    isAnimating() {
        if (this._hasPatternAnim) return !0;
        const e = this.getSymbols(), t = this.sceneConfig.trailAnimation;
        if (t && t.enable) return !0;
        for(let t = 0; t < e.length; t++)if (e[t].linePatternFile && e[t].linePatternAnimSpeed) return !0;
        return !1;
    }
    needToRedraw() {
        return !!super.needToRedraw() || !!this.isAnimating();
    }
    isBloom(e) {
        return !!this.getSymbol(e.properties.symbolIndex)[$435bc7696844e930$export$5f708b59aa06f95b.getBloomSymbol()[0]];
    }
    needPolygonOffset() {
        return !0;
    }
    createMesh(t, n) {
        if (!t.geometry) return null;
        const { geometry: i, symbolIndex: r, ref: o } = t, a = this.getSymbolDef(r);
        if (void 0 === o) $435bc7696844e930$var$wt(i, a, this.getFnTypeConfig(r), this.layer);
        const l = this.getSymbol(r), h = {
            tileResolution: i.properties.tileResolution,
            tileRatio: i.properties.tileRatio,
            tileExtent: i.properties.tileExtent,
            fogFactor: this.layer.options.fogFactor || 0
        };
        this.setLineUniforms(l, h), $435bc7696844e930$var$ke(h, "lineColor", l, "lineColor", "#fff", $435bc7696844e930$var$Re(this.colorCache)), $435bc7696844e930$var$ke(h, "linePatterGapColor", l, "linePatterGapColor", [
            0,
            0,
            0,
            0
        ], $435bc7696844e930$var$Re(this.colorCache)), $435bc7696844e930$var$ke(h, "lineStrokeColor", l, "lineStrokeColor", [
            0,
            0,
            0,
            0
        ], $435bc7696844e930$var$Re(this.colorCache)), $435bc7696844e930$var$ke(h, "lineDasharray", l, "lineDasharray", [
            0,
            0,
            0,
            0
        ], (e)=>{
            let t;
            if (e && e.length) {
                const n = e;
                1 === e.length ? t = [
                    n[0],
                    n[0],
                    n[0],
                    n[0]
                ] : 2 === e.length ? t = [
                    n[0],
                    n[1],
                    n[0],
                    n[1]
                ] : 3 === e.length ? t = [
                    n[0],
                    n[1],
                    n[2],
                    n[2]
                ] : 4 === e.length ? t = e : e.length > 4 && (t = e.slice(0, 4));
            }
            return t || [
                0,
                0,
                0,
                0
            ];
        }), $435bc7696844e930$var$ke(h, "lineDashColor", l, "lineDashColor", [
            0,
            0,
            0,
            0
        ], $435bc7696844e930$var$Re(this.colorCache));
        const c = i.properties.iconAtlas, u = this.layer instanceof $gP1US.TileLayer;
        c && (h.linePatternFile = $435bc7696844e930$var$yn(this.regl, c, !1, !1), h.atlasSize = c ? [
            c.width,
            c.height
        ] : [
            0,
            0
        ], h.flipY = u ? -1 : 1, this.drawDebugAtlas(c)), void 0 === o && i.generateBuffers(this.regl);
        const f = new (0, $2wazW).Material(h), d = new (0, $2wazW).Mesh(i, f, {
            castShadow: !1,
            picking: !0
        });
        d.setLocalTransform(n), d.positionMatrix = this.getAltitudeOffsetMatrix();
        const p = {};
        return c && (p.HAS_PATTERN = 1), d.properties.symbolIndex = r, this._prepareDashDefines(d, p), i.data.aColor && (p.HAS_COLOR = 1), i.data.aStrokeColor && (p.HAS_STROKE_COLOR = 1), this.setMeshDefines(p, i, a), i.data.aAltitude && (p.HAS_ALTITUDE = 1), d.setDefines(p), d;
    }
    addMesh(...e) {
        delete this._hasPatternAnim;
        const t = e[0];
        Array.isArray(t) ? t.forEach((e)=>{
            this._prepareMesh(e);
        }) : this._prepareMesh(t), super.addMesh(...e);
    }
    _prepareMesh(e) {
        if (!e.geometry.aLineWidth && e.material.get("lineWidth") <= 0 || !e.geometry.aOpacity && e.material.get("lineOpacity") <= 0) return;
        const t = e.defines;
        this._prepareDashDefines(e, t), e.setDefines(t), e.geometry.properties.hasPatternAnim && (this._hasPatternAnim = 1);
    }
    _prepareDashDefines(e, t) {
        const n = e.geometry, i = this.getSymbol(e.properties.symbolIndex);
        n.data.aDasharray || Array.isArray(i.lineDasharray) && i.lineDasharray.reduce((e, t)=>e + t, 0) > 0 ? (t.HAS_DASHARRAY = 1, n.data.aDasharray && (t.HAS_DASHARRAY_ATTR = 1), n.data.aDashColor && (t.HAS_DASHARRAY_COLOR = 1)) : t.HAS_DASHARRAY && delete t.HAS_DASHARRAY;
    }
    setLineUniforms(e, t) {
        $435bc7696844e930$var$ke(t, "lineWidth", e, "lineWidth", 2), $435bc7696844e930$var$ke(t, "lineOpacity", e, "lineOpacity", 1), $435bc7696844e930$var$ke(t, "lineStrokeWidth", e, "lineStrokeWidth", 0), $435bc7696844e930$var$ke(t, "lineBlur", e, "lineBlur", .7), $435bc7696844e930$var$ke(t, "lineOffset", e, "lineOffset", 0), $435bc7696844e930$var$ke(t, "lineDx", e, "lineDx", 0), $435bc7696844e930$var$ke(t, "lineDy", e, "lineDy", 0), $435bc7696844e930$var$ke(t, "linePatternAnimSpeed", e, "linePatternAnimSpeed", 0), $435bc7696844e930$var$ke(t, "linePatternGap", e, "linePatternGap", 0);
    }
    setMeshDefines(e, t, n) {
        t.data.aOpacity && (e.HAS_OPACITY = 1), t.data.aLineWidth && (e.HAS_LINE_WIDTH = 1), t.data.aLineStrokeWidth && (e.HAS_STROKE_WIDTH = 1), $435bc7696844e930$var$Lt(n.lineDx) && (e.HAS_LINE_DX = 1), $435bc7696844e930$var$Lt(n.lineDy) && (e.HAS_LINE_DY = 1), $435bc7696844e930$var$Lt(n.linePatternAnimSpeed) && (e.HAS_PATTERN_ANIM = 1), $435bc7696844e930$var$Lt(n.linePatternGap) && (e.HAS_PATTERN_GAP = 1);
    }
    paint(e) {
        this.isShadowIncludeChanged(e) && (this.shader.dispose(), this.createShader(e)), super.paint(e);
    }
    createFnTypeConfig(e, t) {
        const n = (0, $14507960c5dac0fb$export$79e978600dd1e509)(t.lineColor), i = (0, $14507960c5dac0fb$export$79e978600dd1e509)(t.aLinePatternAnimSpeed), r = (0, $14507960c5dac0fb$export$79e978600dd1e509)(t.aLinePatternGap), s = this.createShapeFnTypeConfigs(e, t), o = new Int8Array(2);
        return [
            {
                attrName: "aColor",
                symbolName: "lineColor",
                type: Uint8Array,
                width: 4,
                define: "HAS_COLOR",
                evaluate: (t, i)=>{
                    let r = n(e.getZoom(), t);
                    return (0, $14507960c5dac0fb$export$ec423ecbfcdb9a06)(r) && (r = this.evaluateInFnTypeConfig(r, i, e, t, !0)), Array.isArray(r) || (r = this.colorCache[r] = this.colorCache[r] || (0, (/*@__PURE__*/$parcel$interopDefault($08acccbbd431ef55$exports)))(r).unitArray()), r = $435bc7696844e930$var$Oe(r), r;
                }
            },
            {
                attrName: "aLinePattern",
                symbolName: "linePatternAnimSpeed",
                type: Int8Array,
                width: 2,
                related: [
                    "linePatternGap"
                ],
                define: "HAS_LINE_PATTERN",
                evaluate: (t, n, r, s)=>{
                    let a = i(e.getZoom(), t);
                    return $435bc7696844e930$var$Ie(a) && (a = 0), 0 !== a && (n.properties.hasPatternAnim = 1), o[0] = a / 127, o[1] = r[s + 1], o;
                }
            },
            {
                attrName: "aLinePattern",
                symbolName: "linePatternGap",
                type: Int8Array,
                width: 2,
                related: [
                    "linePatternAnimSpeed"
                ],
                define: "HAS_LINE_PATTERN",
                evaluate: (t, n, i, s)=>{
                    let a = r(e.getZoom(), t);
                    return $435bc7696844e930$var$Ie(a) && (a = 0), o[1] = 10 * a, o[0] = i[s], o;
                }
            }
        ].concat(s);
    }
    createShapeFnTypeConfigs(e, t) {
        const n = (0, $14507960c5dac0fb$export$b5e0f6446c9b8e3c)(t.lineWidth), i = (0, $14507960c5dac0fb$export$b5e0f6446c9b8e3c)(t.lineOpacity), r = (0, $14507960c5dac0fb$export$b5e0f6446c9b8e3c)(t.lineStrokeWidth), s = (0, $14507960c5dac0fb$export$b5e0f6446c9b8e3c)(t.lineDx), o = (0, $14507960c5dac0fb$export$b5e0f6446c9b8e3c)(t.lineDy), a = new Uint16Array(1), l = new Int8Array(1);
        return [
            {
                attrName: "aLineWidth",
                symbolName: "lineWidth",
                type: Uint8Array,
                width: 1,
                define: "HAS_LINE_WIDTH",
                evaluate: (t, i)=>{
                    let r = n(e.getZoom(), t);
                    return (0, $14507960c5dac0fb$export$ec423ecbfcdb9a06)(r) && (r = this.evaluateInFnTypeConfig(r, i, e, t)), a[0] = Math.round(2 * r), a[0];
                }
            },
            {
                attrName: "aLineStrokeWidth",
                symbolName: "lineStrokeWidth",
                type: Uint8Array,
                width: 1,
                define: "HAS_STROKE_WIDTH",
                evaluate: (t)=>{
                    const n = r(e.getZoom(), t);
                    return a[0] = Math.round(2 * n), a[0];
                }
            },
            {
                attrName: "aLineDxDy",
                symbolName: "lineDx",
                type: Int8Array,
                width: 2,
                define: "HAS_LINE_DX",
                evaluate: (t)=>{
                    const n = s(e.getZoom(), t);
                    return l[0] = n, l[0];
                }
            },
            {
                attrName: "aLineDxDy",
                symbolName: "lineDy",
                type: Int8Array,
                width: 2,
                define: "HAS_LINE_DY",
                evaluate: (t)=>{
                    const n = o(e.getZoom(), t);
                    return l[0] = n, l[0];
                }
            },
            {
                attrName: "aOpacity",
                symbolName: "lineOpacity",
                type: Uint8Array,
                width: 1,
                define: "HAS_OPACITY",
                evaluate: (t, n)=>{
                    let r = i(e.getZoom(), t);
                    return (0, $14507960c5dac0fb$export$ec423ecbfcdb9a06)(r) && (r = this.evaluateInFnTypeConfig(r, n, e, t)), a[0] = 255 * r, a[0];
                }
            }
        ];
    }
    updateSceneConfig(e) {
        e.trailAnimation && this.createShader(this._context);
    }
    init(e) {
        const t = this.regl;
        this.renderer = new (0, $2wazW).Renderer(t), this.createShader(e), this.pickingFBO && (this.picking = [
            new (0, $2wazW).FBORayPicking(this.renderer, {
                vert: "#define PICKING_MODE 1\n" + $435bc7696844e930$var$kn,
                uniforms: [
                    {
                        name: "projViewModelMatrix",
                        type: "function",
                        fn: function(e, t) {
                            const n = [];
                            return (0, $3iqbd).multiply(n, t.projViewMatrix, t.modelMatrix), n;
                        }
                    }
                ],
                extraCommandProps: this.getExtraCommandProps()
            }, this.pickingFBO, this.getMap())
        ]);
    }
    createShader(e) {
        this._context = e;
        const t = [], n = {};
        this.fillIncludes(n, t, e), this.sceneConfig.trailAnimation && this.sceneConfig.trailAnimation.enable && (n.HAS_TRAIL = 1);
        const i = [];
        t.push({
            name: "projViewModelMatrix",
            type: "function",
            fn: function(e, t) {
                return (0, $3iqbd).multiply(i, t.projViewMatrix, t.modelMatrix), i;
            }
        }), this.shader = new (0, $2wazW).MeshShader({
            vert: $435bc7696844e930$var$kn,
            frag: "#define SHADER_NAME LINE\n#define DEVICE_PIXEL_RATIO 1.0\nprecision highp float;\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n#include <vsm_shadow_frag>\n#endif\nuniform lowp float blendSrcIsOne;\nuniform lowp float lineBlur;\nuniform float isRenderingTerrain;\n#ifdef HAS_COLOR\nvarying vec4 vColor;\n#else\nuniform lowp vec4 lineColor;\n#endif\n#include <highlight_frag>\n#ifdef HAS_STROKE_COLOR\nvarying vec4 vStrokeColor;\n#else\nuniform lowp vec4 lineStrokeColor;\n#endif\n#ifdef HAS_OPACITY\nvarying float vOpacity;\n#else\nuniform lowp float lineOpacity;\n#endif\nuniform float layerOpacity;\n#ifdef HAS_PATTERN\nuniform sampler2D linePatternFile;\nuniform vec2 atlasSize;\nuniform float flipY;\n#ifdef HAS_PATTERN_ANIM\nvarying float vLinePatternAnimSpeed;\n#else\nuniform float linePatternAnimSpeed;\n#endif\n#ifdef HAS_PATTERN_GAP\nvarying float vLinePatternGap;\n#else\nuniform float linePatternGap;\n#endif\nuniform vec4 linePatterGapColor;\nvarying vec4 vTexInfo;\nvec2 c(vec2 d) {\n  vec2 e = mod(d, 1.);\n  vec2 f = vTexInfo.xy;\n  vec2 h = vTexInfo.zw;\n  return (f + e * h) / atlasSize;\n}\n#endif\nvarying vec2 vNormal;\nvarying vec2 vWidth;\nvarying float vGammaScale;\n#ifndef ENABLE_TILE_STENCIL\nvarying vec2 vPosition;\n#endif\nuniform float tileExtent;\n#ifdef HAS_DASHARRAY\n#ifdef HAS_DASHARRAY_ATTR\nvarying vec4 vDasharray;\n#else\nuniform vec4 lineDasharray;\n#endif\n#ifdef HAS_DASHARRAY_COLOR\nvarying vec4 vDashColor;\n#else\nuniform vec4 lineDashColor;\n#endif\n#endif\n#if defined(HAS_PATTERN) || defined(HAS_DASHARRAY) || defined(HAS_GRADIENT) || defined(HAS_TRAIL)\nvarying highp float vLinesofar;\n#endif\n#ifdef HAS_TRAIL\nuniform float trailSpeed;\nuniform float trailLength;\nuniform float trailCircle;\n#endif\n#if defined(HAS_TRAIL) || defined(HAS_PATTERN)\nuniform float currentTime;\n#endif\nfloat i(float j, float k) {\n  float l = k / 2.;\n  float m = abs(j - l);\n  float n = (.1 + 1. / DEVICE_PIXEL_RATIO) * vGammaScale;\n  return clamp(min(m + n, l - m) / n, .0, 1.);\n}\nvarying vec3 vVertex;\nuniform vec3 cameraPosition;\nuniform float cameraToCenterDistance;\nuniform float fogFactor;\nvoid main() {\n  \n#ifndef ENABLE_TILE_STENCIL\nfloat o = sign(tileExtent - min(tileExtent, abs(vPosition.x))) * sign(1. + sign(vPosition.x)) * sign(tileExtent - min(tileExtent, abs(vPosition.y))) * sign(1. + sign(vPosition.y));\n  if(o == .0) {\n    discard;\n  }\n#endif\n#if defined(HAS_PATTERN) || defined(HAS_DASHARRAY) || defined(HAS_GRADIENT) || defined(HAS_TRAIL)\nfloat u = vLinesofar;\n#endif\nfloat v = length(vNormal) * vWidth.s;\n#ifdef HAS_PATTERN\nvec2 h = vTexInfo.zw;\n  float A = sign(h.x * h.y);\n  float B = mix(lineBlur, .0, A);\n#else\nfloat B = lineBlur;\n#endif\nfloat n = (B + 1. / DEVICE_PIXEL_RATIO) * vGammaScale;\n  float C = clamp(min(v - (vWidth.t - n), vWidth.s - v) / n, .0, 1.);\n#ifdef HAS_COLOR\nvec4 D = vColor / 255.;\n#else\nvec4 D = lineColor;\n#endif\n#ifdef HAS_PATTERN\nif(A == 1.) {\n    \n#ifdef HAS_PATTERN_GAP\nfloat E = vLinePatternGap;\n#else\nfloat E = linePatternGap;\n#endif\n#ifdef HAS_PATTERN_ANIM\nfloat F = vLinePatternAnimSpeed;\n#else\nfloat F = linePatternAnimSpeed;\n#endif\nfloat G = h.x * vWidth.s * 2. / h.y;\n    float H = G * (1. + E);\n    u += mod(currentTime * -F * .2, H);\n    float I = mod(u / H, 1.);\n    float J = mod((flipY * vNormal.y + 1.) / 2., 1.);\n    vec4 K = texture2D(linePatternFile, c(vec2(I * (1. + E), J)));\n    float L = clamp(sign(1. / (1. + E) - I) + .000001, .0, 1.);\n    K = mix(linePatterGapColor, K, L);\n    D *= K;\n  }\n#endif\n#ifdef HAS_DASHARRAY\n#ifdef HAS_DASHARRAY_ATTR\nvec4 M = vDasharray;\n#else\nvec4 M = lineDasharray;\n#endif\n#ifdef HAS_DASHARRAY_COLOR\nvec4 N = vDashColor;\n#else\nvec4 N = lineDashColor;\n#endif\nfloat k = M[0] + M[1] + M[2] + M[3];\n  float j = mod(u, k);\n  float O = max(sign(M[0] - j), .0);\n  float P = j - M[0] - M[1];\n  float Q = max(sign(P), .0) * max(sign(M[2] - P), .0);\n  float R = O + Q;\n  float S = i(j, M[0]);\n  float T = i(P, M[2]);\n  float U = S * O + T * Q;\n  D = D * (1. - U) + N * U;\n#endif\n#ifdef HAS_STROKE_COLOR\nvec4 V = vStrokeColor / 255.;\n#else\nvec4 V = lineStrokeColor;\n#endif\nV = mix(D, V, sign(vWidth.t));\n  D = V * C + max(sign(vWidth.t - v), .0) * D * (1. - C);\n#ifdef HAS_TRAIL\nfloat W = mod(u - currentTime * trailSpeed * .1, trailCircle);\n  float X = W < trailLength ? mix(.0, 1., W / trailLength) : .0;\n  D *= X;\n#endif\n#ifdef HAS_OPACITY\nfloat Y = vOpacity;\n#else\nfloat Y = lineOpacity;\n#endif\ngl_FragColor = D * Y * layerOpacity;\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\nfloat Z = shadow_computeShadow();\n  gl_FragColor.rgb = shadow_blend(gl_FragColor.rgb, Z);\n#endif\nfloat ba;\n  if(isRenderingTerrain == 1.) {\n    ba = 1.;\n  } else {\n    ba = clamp(cameraToCenterDistance * 1.5 / distance(vVertex, cameraPosition), .0, 1.);\n  }\n  gl_FragColor *= ba;\n  gl_FragColor = highlight_blendColor(gl_FragColor);\n  if(fogFactor > .0) {\n    vec3 bb = vec3(vVertex[0] - cameraPosition[0], vVertex[1] - cameraPosition[1], vVertex[2] - cameraPosition[2]);\n    float bc = length(bb);\n    float bd = clamp(1. - (bc * 1.2) / fogFactor, .0, 1.);\n    gl_FragColor *= bd;\n  }\n}",
            uniforms: t,
            defines: n,
            extraCommandProps: this.getExtraCommandProps(e)
        });
    }
    isEnableTileStencil(e) {
        return !!!(e && e.isRenderingTerrain && this.isTerrainSkin());
    }
    getExtraCommandProps(e) {
        const t = this.canvas;
        return {
            viewport: {
                x: (e, t)=>t.viewport ? t.viewport.x : 0,
                y: (e, t)=>t.viewport ? t.viewport.y : 0,
                width: (e, n)=>n.viewport ? n.viewport.width : t ? t.width : 1,
                height: (e, n)=>n.viewport ? n.viewport.height : t ? t.height : 1
            },
            stencil: {
                enable: ()=>this.isEnableTileStencil(e),
                mask: 255,
                func: {
                    cmp: ()=>"<=",
                    ref: (e, t)=>t.stencilRef
                },
                op: {
                    fail: "keep",
                    zfail: "keep",
                    zpass: "replace"
                }
            },
            depth: {
                enable: !0,
                range: this.sceneConfig.depthRange || [
                    0,
                    1
                ],
                mask: this.sceneConfig.depthMask || !1,
                func: this.sceneConfig.depthFunc || "<="
            },
            blend: {
                enable: !0,
                func: this.getBlendFunc(),
                equation: "add"
            },
            polygonOffset: {
                enable: !0,
                offset: this.getPolygonOffset()
            }
        };
    }
    getUniformValues(e, t) {
        const n = t && t.isRenderingTerrainSkin, i = this.layer.getTileSize().width, r = n ? $435bc7696844e930$var$Fn : e.projViewMatrix, s = e.viewMatrix, o = e.cameraToCenterDistance, a = e.getResolution(), l = (0, $6BoVD).set($435bc7696844e930$var$On, e.width, e.height);
        n && (0, $6BoVD).set(l, i, i);
        const h = this.getBlendFunc().src(), c = this.sceneConfig.trailAnimation || {}, u = {
            layerScale: this.layer.options.styleScale || 1,
            projViewMatrix: r,
            viewMatrix: s,
            cameraToCenterDistance: o,
            resolution: a,
            canvasSize: l,
            trailSpeed: c.speed || 1,
            trailLength: c.trailLength || 500,
            trailCircle: c.trailCircle || 1e3,
            currentTime: this.layer.getRenderer().getFrameTimestamp() || 0,
            blendSrcIsOne: +!(1 !== h && "one" !== h),
            cameraPosition: e.cameraPosition,
            viewport: n && t && t.viewport,
            isRenderingTerrain: +!!n
        };
        return this.setIncludeUniformValues(u, t), u;
    }
}
const $435bc7696844e930$var$En = {
    markerFile: {
        type: "identity",
        default: null,
        property: "_symbol_markerFile"
    },
    markerWidth: {
        type: "identity",
        default: null,
        property: "_symbol_markerWidth"
    },
    markerHeight: {
        type: "identity",
        default: null,
        property: "_symbol_markerHeight"
    },
    markerPathWidth: {
        type: "identity",
        default: 20,
        property: "_symbol_markerPathWidth"
    },
    markerPathHeight: {
        type: "identity",
        default: 20,
        property: "_symbol_markerPathHeight"
    },
    markerDx: {
        type: "identity",
        default: null,
        property: "_symbol_markerDx"
    },
    markerDy: {
        type: "identity",
        default: null,
        property: "_symbol_markerDy"
    },
    markerType: {
        type: "identity",
        default: null,
        property: "_symbol_markerType"
    },
    markerPath: {
        type: "identity",
        default: null,
        property: "_symbol_markerPath"
    },
    markerFill: {
        type: "identity",
        default: null,
        property: "_symbol_markerFill"
    },
    markerFillPatternFile: {
        type: "identity",
        default: null,
        property: "_symbol_markerFillPatternFile"
    },
    markerFillOpacity: {
        type: "identity",
        default: null,
        property: "_symbol_markerFillOpacity"
    },
    markerLineColor: {
        type: "identity",
        default: null,
        property: "_symbol_markerLineColor"
    },
    markerLineWidth: {
        type: "identity",
        default: null,
        property: "_symbol_markerLineWidth"
    },
    markerLineOpacity: {
        type: "identity",
        default: null,
        property: "_symbol_markerLineOpacity"
    },
    markerLineDasharray: {
        type: "identity",
        default: null,
        property: "_symbol_markerLineDasharray"
    },
    markerLinePatternFile: {
        type: "identity",
        default: null,
        property: "_symbol_markerLinePatternFile"
    },
    markerVerticalAlignment: {
        type: "identity",
        default: "top",
        property: "_symbol_markerVerticalAlignment"
    },
    markerHorizontalAlignment: {
        type: "identity",
        default: "middle",
        property: "_symbol_markerHorizontalAlignment"
    },
    markerOpacity: {
        type: "identity",
        default: 1,
        property: "_symbol_markerOpacity"
    },
    markerPitchAlignment: {
        type: "identity",
        default: "viewport",
        property: "_symbol_markerPitchAlignment"
    },
    markerRotationAlignment: {
        type: "identity",
        default: "viewport",
        property: "_symbol_markerRotationAlignment"
    },
    markerRotation: {
        type: "identity",
        default: 0,
        property: "_symbol_markerRotation"
    },
    markerAllowOverlap: {
        type: "identity",
        default: 0,
        property: "_symbol_markerAllowOverlap"
    },
    markerIgnorePlacement: {
        type: "identity",
        default: 0,
        property: "_symbol_markerIgnorePlacement"
    },
    markerTextFit: {
        type: "identity",
        default: null,
        property: "_symbol_markerTextFit"
    },
    markerSpacing: {
        type: "identity",
        default: 250,
        property: "_symbol_markerSpacing"
    },
    markerTextFitPadding: {
        type: "identity",
        default: null,
        property: "_symbol_markerTextFitPadding"
    },
    markerPlacement: {
        type: "identity",
        default: "point",
        property: "_symbol_markerPlacement"
    }
}, $435bc7696844e930$var$Dn = {
    textName: {
        type: "identity",
        default: null,
        property: "_symbol_textName"
    },
    textFaceName: {
        type: "identity",
        default: null,
        property: "_symbol_textFaceName"
    },
    textWrapWidth: {
        type: "identity",
        default: null,
        property: "_symbol_textWrapWidth"
    },
    textHorizontalAlignment: {
        type: "identity",
        default: null,
        property: "_symbol_textHorizontalAlignment"
    },
    textVerticalAlignment: {
        type: "identity",
        default: null,
        property: "_symbol_textVerticalAlignment"
    },
    textFill: {
        type: "identity",
        default: null,
        property: "_symbol_textFill"
    },
    textSize: {
        type: "identity",
        default: null,
        property: "_symbol_textSize"
    },
    textHaloRadius: {
        type: "identity",
        default: null,
        property: "_symbol_textHaloRadius"
    },
    textHaloFill: {
        type: "identity",
        default: null,
        property: "_symbol_textHaloFill"
    },
    textHaloOpacity: {
        type: "identity",
        default: 255,
        property: "_symbol_textHaloOpacity"
    },
    textDx: {
        type: "identity",
        default: 0,
        property: "_symbol_textDx"
    },
    textDy: {
        type: "identity",
        default: 0,
        property: "_symbol_textDy"
    },
    textOpacity: {
        type: "identity",
        default: 1,
        property: "_symbol_textOpacity"
    },
    textPitchAlignment: {
        type: "identity",
        default: "viewport",
        property: "_symbol_textPitchAlignment"
    },
    textRotationAlignment: {
        type: "identity",
        default: "viewport",
        property: "_symbol_textRotationAlignment"
    },
    textRotation: {
        type: "identity",
        default: 0,
        property: "_symbol_textRotation"
    },
    textAllowOverlap: {
        type: "identity",
        default: 0,
        property: "_symbol_textAllowOverlap"
    },
    textIgnorePlacement: {
        type: "identity",
        default: 0,
        property: "_symbol_textIgnorePlacement"
    },
    textSpacing: {
        type: "identity",
        default: 250,
        property: "_symbol_textSpacing"
    },
    textPlacement: {
        type: "identity",
        default: "point",
        property: "_symbol_textPlacement"
    }
}, $435bc7696844e930$var$Ln = {
    lineWidth: {
        type: "identity",
        default: 2,
        property: "_symbol_lineWidth"
    },
    lineStrokeWidth: {
        type: "identity",
        default: 0,
        property: "_symbol_lineStrokeWidth"
    },
    lineColor: {
        type: "identity",
        default: [
            1,
            1,
            1,
            1
        ],
        property: "_symbol_lineColor"
    },
    lineStrokeColor: {
        type: "identity",
        default: [
            0,
            0,
            0,
            0
        ],
        property: "_symbol_lineStrokeColor"
    },
    lineDx: {
        type: "identity",
        default: 0,
        property: "_symbol_lineDx"
    },
    lineDy: {
        type: "identity",
        default: 0,
        property: "_symbol_lineDy"
    },
    linePatternFile: {
        type: "identity",
        default: null,
        property: "_symbol_linePatternFile"
    },
    linePatternAnimSpeed: {
        type: "identity",
        default: 0,
        property: "_symbol_linePatternAnimSpeed"
    },
    linePatternGap: {
        type: "identity",
        default: 0,
        property: "_symbol_linePatternGap"
    },
    lineOpacity: {
        type: "identity",
        default: 1,
        property: "_symbol_lineOpacity"
    },
    lineJoin: {
        type: "identity",
        default: null,
        property: "_symbol_lineJoin"
    },
    lineCap: {
        type: "identity",
        default: null,
        property: "_symbol_lineCap"
    },
    lineDasharray: {
        type: "identity",
        default: null,
        property: "_symbol_lineDasharray"
    },
    lineDashColor: {
        type: "identity",
        default: null,
        property: "_symbol_lineDashColor"
    }
}, $435bc7696844e930$var$Hn = "_line_gradient_property", { PackUtil: $435bc7696844e930$var$Nn } = $435bc7696844e930$var$H(), $435bc7696844e930$var$zn = new $gP1US.Point(0, 0), $435bc7696844e930$var$Vn = "_vector3dlayer_id", $435bc7696844e930$var$Un = ($435bc7696844e930$var$Hn + "").trim();
function $435bc7696844e930$var$Bn(t, n, i) {
    const r = ($435bc7696844e930$var$pe + "").trim(), s = t.getMap(), o = s.getGLRes();
    let a = t.getCoordinates();
    const l = [], h = [];
    let c = 1;
    if (t instanceof $gP1US.Marker || t instanceof $gP1US.MultiPoint) {
        t instanceof $gP1US.Marker && (a = [
            a
        ]);
        for(let e = 0; e < a.length; e++)s.coordToPointAtRes(a[e], o, $435bc7696844e930$var$zn), l.push([
            $435bc7696844e930$var$zn.x,
            $435bc7696844e930$var$zn.y,
            a[e].z || 0
        ]), h.push([
            a[e].x,
            a[e].y
        ]);
    } else if (t instanceof $gP1US.LineString || t instanceof $gP1US.MultiLineString) {
        c = 2, t instanceof $gP1US.LineString && (a = [
            a
        ]);
        for(let e = 0; e < a.length; e++){
            l[e] = [], h[e] = [];
            for(let t = 0; t < a[e].length; t++)s.coordToPointAtRes(a[e][t], o, $435bc7696844e930$var$zn), l[e].push([
                $435bc7696844e930$var$zn.x,
                $435bc7696844e930$var$zn.y,
                a[e][t].z || 0
            ]), h[e].push([
                a[e][t].x,
                a[e][t].y
            ]);
        }
    } else if (t instanceof $gP1US.Polygon || t instanceof $gP1US.MultiPolygon) {
        c = 3, t instanceof $gP1US.Circle || t instanceof $gP1US.Rectangle || t instanceof $gP1US.Ellipse || t instanceof $gP1US.Sector ? a = [
            [
                t.getShell()
            ]
        ] : t instanceof $gP1US.Polygon && (a = [
            a
        ]);
        let n = 0;
        for(let e = 0; e < a.length; e++){
            let t = !1;
            for(let i = 0; i < a[e].length; i++){
                if (l[n] = [], h[n] = [], t) for(let t = a[e][i].length - 1; t >= 0; t--)s.coordToPointAtRes(a[e][i][t], o, $435bc7696844e930$var$zn), l[n].push([
                    $435bc7696844e930$var$zn.x,
                    $435bc7696844e930$var$zn.y,
                    a[e][i][t].z || 0
                ]), h[n].push([
                    a[e][i][t].x,
                    a[e][i][t].y
                ]);
                else for(let t = 0; t < a[e][i].length; t++)s.coordToPointAtRes(a[e][i][t], o, $435bc7696844e930$var$zn), l[n].push([
                    $435bc7696844e930$var$zn.x,
                    $435bc7696844e930$var$zn.y,
                    a[e][i][t].z || 0
                ]), h[n].push([
                    a[e][i][t].x,
                    a[e][i][t].y
                ]);
                0 === i && (t = $435bc7696844e930$var$Nn.calculateSignedArea(l[n]) < 0, t && (l[n] = l[n].reverse(), h[n] = h[n].reverse())), n++;
            }
        }
    }
    const u = t.getProperties() ? Object.assign({}, t.getProperties()) : {}, f = t._getInternalSymbol() || function(t) {
        if (t instanceof $gP1US.Marker || t instanceof $gP1US.MultiPoint) return {
            markerType: "ellipse",
            markerWidth: 8,
            markerHeight: 0,
            markerFill: "#000"
        };
        if (t instanceof $gP1US.LineString || t instanceof $gP1US.MultiLineString) return {
            lineColor: "#000",
            lineWidth: 1
        };
        if (t instanceof $gP1US.Polygon || t instanceof $gP1US.MultiPolygon) return {
            polygonFill: "#fff",
            lineColor: "#000",
            lineWidth: 1
        };
    }(t), d = i ? Array.isArray(i) ? i[0].id : i.id : n.id++;
    if (Array.isArray(f) && f.length) {
        const e = [], s = f.length;
        for(let o = 0; o < s; o++){
            const a = o === s - 1 ? u : $435bc7696844e930$var$U({}, u), p = $435bc7696844e930$var$Gn(f[o], a);
            for(const e in f[o])if ($435bc7696844e930$var$q(f[o], e)) a[("_symbol_" + e).trim()] = f[o][e];
            p && (f[o].lineGradientProperty = p);
            const g = i && i[o] ? i[o][r] : n.pickingId++, m = {
                type: c,
                id: d,
                properties: a,
                visible: t.isVisible(),
                geometry: l,
                coordinates: h,
                extent: 1 / 0
            };
            m[r] = g, e.push(m);
        }
        return e;
    }
    if (f) {
        const e = $435bc7696844e930$var$Gn(f, u);
        for(const e in f)if ($435bc7696844e930$var$q(f, e)) u[("_symbol_" + e).trim()] = f[e];
        e && (f.lineGradientProperty = e);
    }
    const p = i ? i.id : n.pickingId++, g = {
        type: c,
        id: d,
        properties: u,
        visible: t.isVisible(),
        geometry: l,
        coordinates: h,
        extent: 1 / 0
    };
    return g[r] = p, g;
}
function $435bc7696844e930$var$Gn(e, t) {
    const n = e.lineGradientProperty;
    return n && (t[$435bc7696844e930$var$Un] = t[n], t.mapbox_clip_start = 0, t.mapbox_clip_end = 1, delete t[n]), n;
}
class $435bc7696844e930$var$jn extends $435bc7696844e930$export$5f708b59aa06f95b {
    postCreateGeometry(e) {
        this.generateGradProperties(e);
    }
    startFrame(...e) {
        super.startFrame(...e), this._updateMeshGradient();
    }
    _updateMeshGradient() {
        if (this._changedMeshes) {
            for(let e = 0; e < this._changedMeshes.length; e++){
                if (!this._changedMeshes[e] || !this._changedMeshes[e].isValid()) continue;
                const { geometry: t, material: n } = this._changedMeshes[e], { symbolIndex: i } = t.properties;
                this.generateGradProperties({
                    geometry: t,
                    symbolIndex: i
                });
                const r = this._genGradientTexture(t.properties.gradients), s = n.get("lineGradientTexture");
                s && s.destroy(), t.generateBuffers(this.regl), n.set("lineGradientTexture", r), n.set("lineGradientTextureHeight", r.height);
            }
            delete this._changedMeshes;
        }
    }
    onFeatureChange(e, t) {
        this._changedMeshes || (this._changedMeshes = []);
        for(let n = 0; n < t.length; n++){
            if (!t[n] || !t[n].isValid()) continue;
            const i = t[n].geometry, { features: r } = i.properties;
            if (!r) continue;
            const s = e && e[$435bc7696844e930$var$Vn];
            r[s] && (r[s].feature.properties[$435bc7696844e930$var$Hn] = e.properties[$435bc7696844e930$var$Hn], this._changedMeshes.push(t[n]), this.setToRedraw());
        }
    }
    needRebuildOnGometryPropertiesChanged() {
        return !1;
    }
    generateGradProperties(e) {
        const { symbolIndex: t, geometry: n } = e, { features: i } = n.properties, r = this.getSymbol(t).lineGradientProperty, s = n.properties.aPickingId || n.data.aPickingId, o = new Uint8Array(s.length), a = [], l = new Map;
        function h(e) {
            let t = e && e[r];
            Array.isArray(t) || (t = [
                0,
                "black",
                1,
                "black"
            ]);
            let n, i = t.join();
            return l.has(i) ? n = l.get(i) : (n = a.length, l.set(i, n), a.push(t)), n;
        }
        let c = s[0], u = i[c].feature.properties, f = h(u);
        for(let e = 1; e < s.length; e++)s[e] !== c && (c = s[e], u = i[c].feature.properties, f = h(u)), o[e] = f;
        if (n.data.aGradIndex) {
            const e = n.data.aGradIndex;
            e && e.buffer && e.buffer.destroy && e.buffer.destroy();
        }
        n.data.aGradIndex = o, n.properties.gradients = a;
    }
    createMesh(e, t) {
        const { geometry: n, symbolIndex: i, ref: r } = e, o = this.getSymbolDef(i);
        if (void 0 === r) $435bc7696844e930$var$wt(n, o, this.getFnTypeConfig(i), this.layer);
        const a = {
            tileResolution: n.properties.tileResolution,
            tileRatio: n.properties.tileRatio,
            tileExtent: n.properties.tileExtent
        }, l = this.getSymbol(i);
        this.setLineUniforms(l, a);
        const h = this._genGradientTexture(n.properties.gradients);
        a.lineGradientTexture = h, a.lineGradientTextureHeight = h.height, void 0 === r && n.generateBuffers(this.regl);
        const c = new (0, $2wazW).Material(a), u = new (0, $2wazW).Mesh(n, c, {
            castShadow: !1,
            picking: !0
        });
        u.setLocalTransform(t);
        const f = {
            HAS_GRADIENT: 1
        };
        return n.data.aAltitude && (f.HAS_ALTITUDE = 1), this.setMeshDefines(f, n, o), u.setDefines(f), u.properties.symbolIndex = i, u;
    }
    _genGradientTexture(e) {
        const t = 2 * e.length;
        return this.regl.texture({
            width: 256,
            height: t,
            data: $435bc7696844e930$var$Wn(e),
            format: "rgba",
            mag: "linear",
            min: "linear",
            flipY: !1
        });
    }
    createFnTypeConfig(e, t) {
        return this.createShapeFnTypeConfigs(e, t);
    }
    createShader(e) {
        this._context = e;
        const t = [], n = {};
        this.fillIncludes(n, t, e), this.sceneConfig.trailAnimation && this.sceneConfig.trailAnimation.enable && (n.HAS_TRAIL = 1);
        const i = [];
        t.push({
            name: "projViewModelMatrix",
            type: "function",
            fn: function(e, t) {
                return (0, $3iqbd).multiply(i, t.projViewMatrix, t.modelMatrix), i;
            }
        }), this.shader = new (0, $2wazW).MeshShader({
            vert: $435bc7696844e930$var$kn,
            frag: "#define SHADER_NAME LINE_GRADIENT\n#define DEVICE_PIXEL_RATIO 1.0\n#define MAX_LINE_COUNT 128.0\nprecision mediump float;\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n#include <vsm_shadow_frag>\n#endif\n#ifdef HAS_OPACITY\nvarying float vOpacity;\n#else\nuniform lowp float lineOpacity;\n#endif\nuniform float layerOpacity;\nuniform lowp float lineBlur;\nuniform float lineGradientTextureHeight;\nuniform float tileExtent;\nuniform sampler2D lineGradientTexture;\nvarying vec2 vNormal;\nvarying vec2 vWidth;\nvarying float vGammaScale;\nvarying highp float vLinesofar;\nvarying float vGradIndex;\n#ifndef ENABLE_TILE_STENCIL\nvarying vec2 vPosition;\n#endif\n#ifdef HAS_TRAIL\nuniform float trailSpeed;\nuniform float trailLength;\nuniform float trailCircle;\nuniform float currentTime;\n#endif\n#include <highlight_frag>\nvoid main() {\n  \n#ifndef ENABLE_TILE_STENCIL\nfloat c = sign(tileExtent - min(tileExtent, abs(vPosition.x))) * sign(1. + sign(vPosition.x)) * sign(tileExtent - min(tileExtent, abs(vPosition.y))) * sign(1. + sign(vPosition.y));\n  if(c == .0) {\n    discard;\n  }\n#endif\nfloat d = length(vNormal) * vWidth.s;\n  float e = (lineBlur + 1. / DEVICE_PIXEL_RATIO) * vGammaScale;\n  float f = clamp(min(d - (vWidth.t - e), vWidth.s - d) / e, .0, 1.);\n  float h = vLinesofar;\n  vec4 i = texture2D(lineGradientTexture, vec2(h, (vGradIndex * 2. + .5) / lineGradientTextureHeight)) * f;\n  i *= max(sign(MAX_LINE_COUNT - vGradIndex), .0);\n#ifdef HAS_TRAIL\nfloat j = mod(h - currentTime * trailSpeed * .1, trailCircle);\n  float k = j < trailLength ? mix(.0, 1., j / trailLength) : .0;\n  i *= k;\n#endif\n#ifdef HAS_OPACITY\nfloat l = vOpacity;\n#else\nfloat l = lineOpacity;\n#endif\ngl_FragColor = i * l * layerOpacity;\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\nfloat m = shadow_computeShadow();\n  gl_FragColor.rgb = shadow_blend(gl_FragColor.rgb, m);\n#endif\ngl_FragColor = highlight_blendColor(gl_FragColor);\n}",
            uniforms: t,
            defines: n,
            extraCommandProps: this.getExtraCommandProps()
        });
    }
}
function $435bc7696844e930$var$Wn(e) {
    e.length > 2048 && console.warn(`Gradients count is (${e.length}), it may be slow to render.`);
    const t = document.createElement("canvas"), n = t.getContext("2d");
    t.width = 256, t.height = 2 * e.length;
    for(let t = 0; t < e.length; t++){
        const i = e[t], r = n.createLinearGradient(0, 0, 256, 0);
        for(let e = 0; e < i.length; e += 2)r.addColorStop(+i[e], i[e + 1]);
        n.fillStyle = r;
        const s = t % 256;
        n.fillRect(0, 2 * s, 256, 2 * s + 2);
    }
    return n.canvas;
}
class $435bc7696844e930$var$Xn {
    constructor(e){
        this._meshes = e || [], this.properties = {};
    }
    set meshes(e) {
        this._meshes = e;
    }
    get meshes() {
        return this._meshes;
    }
}
const $435bc7696844e930$var$Yn = 224, $435bc7696844e930$var$Zn = 600, $435bc7696844e930$var$qn = 100, $435bc7696844e930$var$$n = new Uint8Array(1), $435bc7696844e930$var$Jn = [], $435bc7696844e930$var$Kn = {
    collides: 0,
    boxes: []
}, $435bc7696844e930$var$Qn = [], $435bc7696844e930$var$ei = [];
class $435bc7696844e930$var$ti extends $435bc7696844e930$var$gn {
    createGeometry(...t) {
        const n = super.createGeometry(...t);
        if (!n || !n.geometry) return n;
        const { geometry: i } = n, r = t[0];
        i.properties.collideIds = r.featureIds && r.featureIds.length && r.isIdUnique ? r.featureIds : r.data.aPickingId;
        const s = this.layer instanceof $gP1US.TileLayer;
        return i.properties.uniqueCollideIds = $435bc7696844e930$var$ze(i.properties.collideIds, !s), n;
    }
    supportRenderMode(e) {
        const t = this.sceneConfig.renderToPointRenderTarget;
        return t || void 0 === t ? "point" === e : "fxaa" === e || "fxaaAfterTaa" === e;
    }
    addMesh(e, t, n) {
        if (e && !this.isEnableCollision()) {
            let t = e;
            Array.isArray(t) || ($435bc7696844e930$var$Qn[0] = e, t = $435bc7696844e930$var$Qn);
            for(let e = 0; e < t.length; e++){
                const n = t[e].defines;
                delete n.ENABLE_COLLISION, t[e].setDefines(n);
                const { elements: i, visElemts: r } = t[e].geometry.properties;
                r && void 0 !== r.count && r.count !== i.length && (t[e].geometry.setElements(i), r.count = i.length);
            }
        }
        return super.addMesh(e, t, n);
    }
    startMeshCollision(e) {
        const { meshKey: t } = e.properties, { renderer: n } = this._cachedInstances, i = n.isForeground(e instanceof $435bc7696844e930$var$Xn ? e.meshes[0] : e);
        if (e.properties.isForeground = i, e instanceof $435bc7696844e930$var$Xn && e.meshes.length) for(let t = 0; t < e.meshes.length; t++)e.meshes[t].properties.isForeground = i;
        this._startTime = performance.now(), this._canProceed = this._canProceedCollision(), this._meshCollisionStale = this._isCachedCollisionStale(t);
    }
    endMeshCollision(t) {
        const n = this._collisionContext.tags[t];
        if (this._canProceed && n && this._meshCollisionStale) {
            const t = this.getMap();
            this._anchorCoord0 || (this._anchorCoord0 = new $gP1US.Coordinate(0, 0), this._anchorCoord1 = new $gP1US.Coordinate(0, 0)), n.anchor0 = t.containerPointToCoord(this._containerAnchor0, this._anchorCoord0), n.anchor1 = t.containerPointToCoord(this._containerAnchor1, this._anchorCoord1), n.anchor0.z = t.getZoom(), n.anchor0.width = t.width, n.anchor0.height = t.height, n.anchor0.pitch = t.getPitch();
        }
        this.getMap().collisionFrameTime += performance.now() - this._startTime;
    }
    _isCachedCollisionStale(e) {
        const t = this.getMap(), n = t.getZoom(), i = t.getPitch(), [r, s] = this._getMeshAnchor(e);
        return !r || !s || r.z !== n || r.width !== t.width || r.height !== t.height || r.pitch !== i || r.distanceTo(this._containerAnchor0) > 3 || s.distanceTo(this._containerAnchor1) > 3;
    }
    _startCollision() {
        const t = this.getMap();
        this._coordCache = {}, this._containerAnchor0 = new $gP1US.Point(t.width / 3, t.height / 2), this._containerAnchor1 = new $gP1US.Point(2 * t.width / 3, t.height / 2), delete this._canProceed, this._collisionContext || (this._collisionContext = {
            tags: {}
        }), this._cachedInstances = {
            layer: this.layer,
            renderer: this.layer.getRenderer(),
            frameTimestamp: this.layer.getRenderer().getFrameTimestamp(),
            map: this.getMap(),
            zoom: t.getZoom(),
            collisionTags: this._collisionContext.tags,
            isEnableUniquePlacement: this.isEnableUniquePlacement()
        };
    }
    _endCollision() {}
    _getCachedCollision(e, t) {
        const n = this._collisionContext;
        return n.tags[e] && n.tags[e][t];
    }
    _setCollisionCache(e, t, n) {
        const i = this._collisionContext;
        i.tags[e] = i.tags[e] || [], i.tags[e][t] = n;
    }
    _canProceedCollision() {
        const e = this.getMap();
        if (!e.isInteracting()) return !0;
        const t = this.layer.options.collisionFrameLimit;
        return e.collisionFrameTime <= t;
    }
    _getMeshAnchor(e) {
        const t = "__meshAnchorKey".trim(), n = this._collisionContext.tags[e];
        if (n && n.anchor0) {
            const { anchor0: e, anchor1: i } = n, r = e[t] = e[t] || e.x + "," + e.y, s = i[t] = i[t] || i.x + "," + i.y;
            let o = this._coordCache[r], a = this._coordCache[s];
            if (!o || !a) {
                const t = this.getMap();
                o = this._coordCache[r] = t.coordToContainerPoint(e), a = this._coordCache[s] = t.coordToContainerPoint(i);
            }
            return o.z = e.z, $435bc7696844e930$var$Jn[0] = o, $435bc7696844e930$var$Jn[1] = a, o.width = e.width, o.height = e.height, $435bc7696844e930$var$Jn;
        }
        return $435bc7696844e930$var$Jn[0] = $435bc7696844e930$var$Jn[1] = null, $435bc7696844e930$var$Jn;
    }
    updateBoxCollisionFading(e, t, n, i, r) {
        const { layer: s, renderer: o, zoom: a, collisionTags: l, isEnableUniquePlacement: h } = this._cachedInstances, { meshKey: c, isForeground: u } = t.properties;
        if (h && this._isReplacedPlacement(c, r)) return !1;
        const f = n.length;
        let d = l[c] && l[c][r];
        const p = d, g = this._zooming && d;
        if (!(g && 0 !== d.collides) && e) {
            const e = g && 0 === d.collides;
            if (this._canProceed || e) {
                if ((this._meshCollisionStale || d && d.z !== a) && (d = null), d) {
                    if (d.boxes && d.boxes.length) {
                        const { boxes: e, isAllowOverlap: t } = d;
                        let n = 0;
                        if (!t) {
                            let t = 0;
                            for(let i = 0; i < e.length; i++)if (!n) {
                                const r = this.isCollides(e[i]);
                                if (-1 === r) t++;
                                else if (1 === r) {
                                    n = 1;
                                    break;
                                }
                            }
                            t === e.length && (n = -1);
                        }
                        d.collides = n;
                    }
                } else {
                    d = p || {
                        collides: 0,
                        boxes: []
                    }, d.boxes.length = 0, d.z = a;
                    let e = 0;
                    for(let t = 0; t < f; t++){
                        const { mesh: s, allElements: o, boxCount: a, start: l, end: h } = n[t], c = this._isBoxVisible(s, o, a, l, h, i, r);
                        c.isAllowOverlap && (d.isAllowOverlap = 1), 0 === e && (e = c.collides), c.boxes && d.boxes.push(...c.boxes);
                    }
                    d.collides = e, this._setCollisionCache(c, r, d);
                }
            }
        }
        let m = e && d && 0 === d.collides, y = 1, x = !1;
        if (this.sceneConfig.fading) {
            const e = this._getBoxTimestamps(t);
            if (this._zoomingOut) e[r] = m ? 1 : -1;
            else if (u && delete t._fadeOutStartTime, y = this._getBoxFading(u, m, e, r), u ? (y > 0 && (m = !0), x = this.isBoxFading(t, r), x && this.setToRedraw()) : m || (this._markFadingCollided(e, r), y = 0), m) {
                const n = t._fadeOutStartTime;
                if (n && 1 === y && e[r] > 0) {
                    let { fadeOutDelay: e, fadingDuration: t } = this.sceneConfig;
                    $435bc7696844e930$var$Ie(t) && (t = $435bc7696844e930$var$Yn), $435bc7696844e930$var$Ie(e) && (e = $435bc7696844e930$var$qn);
                    const i = $435bc7696844e930$var$Me(1 - (o.getFrameTimestamp() - n - e) / t, 0, 1);
                    y *= i, i > 0 && this.setToRedraw();
                }
            }
        }
        if (d && s.options.debugCollision && this.addCollisionDebugBox(d.boxes, d.collides ? 0 : 1), m || x) {
            const { mesh: e, start: t } = n[0], i = this.getSymbol(e.properties.symbolIndex);
            !this._isIgnorePlacement(i, e, t) && d && d.boxes && this._fillCollisionIndex(d.boxes, e);
        }
        if (m) {
            const e = $435bc7696844e930$var$$n[0] = 255 * y;
            for(let t = 0; t < f; t++){
                const { mesh: i, allElements: r, start: s, boxStart: o, end: a, boxIndex: l } = n[t], h = void 0 === o ? s : o;
                this.setCollisionOpacity(i, r, e, h, a, l);
            }
        }
        return m && y > 0;
    }
    isMeshIterable() {
        return !0;
    }
    setCollisionOpacity(e, t, n, i, r) {
        const s = t[i], o = t[r - 1];
        this._updateOpacityData(e, n, s, o);
    }
    _updateOpacityData(e, t, n, i) {
        const { aOpacity: r } = e.geometry.properties;
        if (!r) return;
        const s = n;
        if (r[s] !== t) {
            const e = i;
            for(let n = s; n <= e; n++)r[n] = t;
            r.dirty = !0;
        }
    }
    isBoxFading(e, t) {
        const { frameTimestamp: n } = this._cachedInstances;
        let i = this.sceneConfig.fadingDuration;
        $435bc7696844e930$var$Ie(i) && (i = $435bc7696844e930$var$Yn);
        return n - Math.abs(this._getBoxTimestamps(e)[t]) < i;
    }
    _isBoxVisible(e, t, n, i, r, s, o) {
        const a = this.getSymbol(e.properties.symbolIndex), l = this._isIgnorePlacement(a, e, t[i]), h = this._isAllowOverlap(a, e, t[i]);
        if (!this.isEnableCollision() || l && h) return $435bc7696844e930$var$Kn;
        const c = this.isBoxCollides(e, t, n, i, r, s, o);
        return h && (c.collides = 0, c.isAllowOverlap = 1), c;
    }
    _isIgnorePlacement(e, t, n) {
        if (!this.isEnableCollision()) return !0;
        const i = t.geometry.properties.aOverlap;
        if (!i) return 1 == +e[this.propIgnorePlacement];
        const r = i[n], s = r % 8;
        return r < 2 ? 1 == +e[this.propIgnorePlacement] : s % 2;
    }
    _isAllowOverlap(e, t, n) {
        if (!this.isEnableCollision()) return !0;
        const i = t.geometry.properties.aOverlap;
        if (!i) return 1 == +e[this.propAllowOverlap];
        const r = i[n], s = r >> 2;
        return r < 2 ? 1 == +e[this.propAllowOverlap] : s % 2;
    }
    _fillCollisionIndex(e) {
        if (Array.isArray(e[0])) for(let t = 0; t < e.length; t++)this.insertCollisionBox(e[t]);
        else this.insertCollisionBox(e);
    }
    _getBoxFading(e, t, n, i) {
        let { fadingDuration: r, fadeInDelay: s, fadeOutDelay: o } = this.sceneConfig;
        $435bc7696844e930$var$Ie(r) && (r = $435bc7696844e930$var$Yn), $435bc7696844e930$var$Ie(s) && (s = $435bc7696844e930$var$Zn), $435bc7696844e930$var$Ie(o) && (o = $435bc7696844e930$var$qn);
        const { frameTimestamp: a } = this._cachedInstances;
        let l = n[i], h = t ? 1 : 0;
        if (!l) return t && e && (n[i] = a + s), 0;
        if (a < Math.abs(l) && (!t && l > 0 || t && l < 0)) {
            const e = a - r;
            n[i] = l = t ? e : -e;
        }
        return a - Math.abs(l) < r ? h = l > 0 ? (a - l) / r : 1 - (a + l) / r : t ? (l < 0 && (n[i] = l = a + s), h = (a - l) / r) : (l > 0 && (n[i] = l = -(a + o)), h = 1 - (a + l) / r), (h < 0 || h > 1) && (h = $435bc7696844e930$var$Me(h, 0, 1)), h;
    }
    _getBoxTimestamps(e) {
        this._boxTimestamps || (this._boxTimestamps = {});
        const { meshKey: t } = e.properties;
        if (!this._boxTimestamps[t]) {
            const { frameTimestamp: e } = this._cachedInstances;
            this._boxTimestamps[t] = {
                timestamp: e
            };
        }
        return this._boxTimestamps[t];
    }
    _refreshTimeStamps(e) {
        if (!this._prevTimestamp) return void (this._prevTimestamp = e);
        const t = this.scene.getMeshes();
        if (t && t.length) {
            for(let n = 0; n < t.length; n++){
                const i = this._getBoxTimestamps(t[n]);
                i.timestamp < this._prevTimestamp ? delete t[n]._fading_timestamps : i.timestamp = e;
            }
            this._prevTimestamp = e;
        }
    }
    _markFadingCollided(e, t) {
        if (!e) return;
        const { frameTimestamp: n } = this._cachedInstances;
        let { fadingDuration: i } = this.sceneConfig;
        $435bc7696844e930$var$Ie(i) && (i = $435bc7696844e930$var$Yn), e[t] = -(n - i - 1);
    }
    deleteMesh(e, t) {
        if (e) {
            if (Array.isArray(e)) for(let t = 0; t < e.length; t++){
                const n = e[t].properties.meshKey;
                this._collisionContext && delete this._collisionContext.tags[n], this._boxTimestamps && delete this._boxTimestamps[n];
            }
            else {
                const t = e.properties.meshKey;
                this._collisionContext && delete this._collisionContext.tags[t], this._boxTimestamps && delete this._boxTimestamps[t];
            }
            super.deleteMesh(e, t);
        }
    }
    delete(e) {
        this._collisionMesh && (this._collisionMesh.geometry.dispose(), this._collisionShader.dispose(), this._collisionMesh.dispose(), delete this._collisionMesh, delete this._collisionShader, delete this._collisionRenderer), delete this._collisionContext, super.delete(e);
    }
    isCollides(e) {
        const t = this.layer, n = t.getMap(), i = n.getDevicePixelRatio();
        if ((0, $jxhwV).scale($435bc7696844e930$var$ei, e, 1 / i), n.isOffscreen($435bc7696844e930$var$ei)) return -1;
        const r = t.getCollisionIndex(), s = this.sceneConfig.collisionBufferSize || t.options.collisionBufferSize || 0;
        return s && (e = $435bc7696844e930$var$si($435bc7696844e930$var$ei, e, s)), +r.collides(e);
    }
    insertCollisionBox(e) {
        const t = this.layer, n = t.getCollisionIndex(), i = this.sceneConfig.collisionBufferSize || t.options.collisionBufferSize || 0;
        let r = e;
        i && (r = e._buffered = e._buffered || [], e = $435bc7696844e930$var$si(r, e, i)), n.insertBox(r);
    }
    addCollisionDebugBox(e, t) {
        if (e && e.length) {
            if (Array.isArray(e[0])) for(let n = 0; n < e.length; n++){
                const i = e[n];
                this._addCollisionBox(i, t);
            }
            else this._addCollisionBox(e, t);
        }
    }
    _addCollisionBox(e, t) {
        if (!e) return;
        const n = this._collisionBoxes = this._collisionBoxes || {
            aPosition: [],
            aVisible: [],
            indices: []
        }, i = this.sceneConfig.collisionBufferSize || this.layer.options.collisionBufferSize || 0;
        i && (e = $435bc7696844e930$var$si($435bc7696844e930$var$ei, e, i));
        const r = this.getMap(), s = r.getDevicePixelRatio();
        if ((0, $jxhwV).scale($435bc7696844e930$var$ei, e, 1 / s), r.isOffscreen($435bc7696844e930$var$ei)) return;
        const o = n.aPosition.length / 2;
        n.aPosition.push(e[0], e[1], e[2], e[1], e[2], e[3], e[0], e[3]), n.aVisible.push(t, t, t, t), n.indices.push(o, o + 1, o + 1, o + 2, o + 2, o + 3, o + 3, o);
    }
    updateCollision(e) {
        super.updateCollision(e), this._startCollision(), this._prepareZoomEndMeshes(), this._zoomEndMeshes && this._zoomEndMeshes.length && (this._updateZoomMeshesLevel(), this._zoomEndMeshes && (this.setToRedraw(), this.scene.addMesh(this._zoomEndMeshes)));
        (this.getMap().isZooming() || this._zoomEndMeshes && this._zoomEndMeshes.length) && (this._updateUniquePlacements(), this._mergeUniquePlacements(this.scene.getMeshes()));
    }
    paint(e) {
        const t = super.paint(e);
        return this._renderCollisionBox(e), !1 === this._canProceed && this.setToRedraw(), t;
    }
    shouldIgnoreBackground() {
        return !this.getMap().isZooming() && !this._zoomEndMeshes;
    }
    _prepareZoomEndMeshes() {
        const e = this.getMap(), t = e.isZooming();
        if (!t && this._zooming) {
            const e = this.layer.getRenderer();
            this._zoomEndMeshes = this.scene.getMeshes().filter((t)=>!e.isForeground(t) && !t.properties.isLinePlacement);
        } else t && !this._zooming && (this._preRes = e.getResolution());
        if (t) this._clearTimeout && (clearTimeout(this._clearTimeout), delete this._zoomingOut, delete this._clearTimeout), this._zoomingOut = this._preRes && e.getResolution() > this._preRes;
        else if (this._zooming && !this._clearTimeout) {
            let { fadeOutDelay: e, fadingDuration: t } = this.sceneConfig;
            $435bc7696844e930$var$Ie(e) && (e = $435bc7696844e930$var$qn), $435bc7696844e930$var$Ie(t) && (t = $435bc7696844e930$var$Yn), this._clearTimeout = setTimeout(()=>{
                delete this._zoomingOut, delete this._clearTimeout;
            }, e + t + 1);
        }
        this._zooming = t;
    }
    _renderCollisionBox(e) {
        if (!this._collisionBoxes || !this.layer.options.debugCollision) return;
        this._collisionRenderer || this._initCollisionShader();
        const { aPosition: t, aVisible: n, indices: i } = this._collisionBoxes;
        if (!this._collisionMesh) {
            const e = new (0, $2wazW).Geometry({
                aPosition: [],
                aVisible: []
            }, [], 0, {
                positionSize: 2,
                primitive: "lines"
            });
            this._collisionMesh = new (0, $2wazW).Mesh(e), this._collisionScene = new (0, $2wazW).Scene, this._collisionScene.addMesh(this._collisionMesh);
        }
        const r = this._collisionMesh.geometry;
        r.updateData("aPosition", new Float32Array(t)), r.updateData("aVisible", new Uint8Array(n)), r.setElements(i), this._collisionRenderer.render(this._collisionShader, {
            size: [
                this.canvas.width,
                this.canvas.height
            ]
        }, this._collisionScene, this.getRenderFBO(e)), delete this._collisionBoxes;
    }
    _initCollisionShader() {
        const e = this.regl;
        this._collisionRenderer = new (0, $2wazW).Renderer(e);
        const t = this.canvas, n = {
            x: 0,
            y: 0,
            width: ()=>t ? t.width : 1,
            height: ()=>t ? t.height : 1
        };
        this._collisionShader = new (0, $2wazW).MeshShader({
            vert: "attribute vec2 aPosition;\nattribute float aVisible;\nuniform vec2 size;\nvarying vec4 vColor;\nvoid main() {\n  vec2 c = (aPosition / size - .5) * 2. * vec2(1., -1.);\n  gl_Position = vec4(c, .0, 1.);\n  vColor = mix(vec4(1., .0, .0, 1.5) * .5, vec4(.0, 1., .0, 1.) * .4, aVisible);\n}",
            frag: "precision mediump float;\nvarying vec4 vColor;\nvoid main() {\n  gl_FragColor = vec4(vColor.rgb, .5);\n}",
            uniforms: [
                "size"
            ],
            extraCommandProps: {
                viewport: n,
                depth: {
                    enable: !1
                },
                blend: {
                    enable: !0,
                    func: {
                        src: "src alpha",
                        dst: "one minus src alpha"
                    },
                    equation: "add"
                }
            }
        });
    }
    _updateZoomMeshesLevel() {
        let { fadeOutDelay: e, fadingDuration: t } = this.sceneConfig;
        $435bc7696844e930$var$Ie(e) && (e = $435bc7696844e930$var$qn), $435bc7696844e930$var$Ie(t) && (t = $435bc7696844e930$var$Yn);
        const n = this.layer.getRenderer(), i = n.getCurrentTileZoom(), r = n.getFrameTimestamp(), s = [];
        for(let o = 0; o < this._zoomEndMeshes.length; o++){
            const a = this._zoomEndMeshes[o], l = a.properties.tile;
            !a._fadeOutStartTime && n.isBackTile(l.id) && (a._fadeOutStartTime = r);
            const h = l.z - i > 0 ? 2 * (l.z - i) - 1 : 2 * (i - l.z);
            a.properties.level = h, n.isForeground(a) || a._fadeOutStartTime && r - a._fadeOutStartTime > e + t ? delete a._fadeOutStartTime : s.push(a);
        }
        delete this._zoomEndMeshes, s.length && (this._zoomEndMeshes = s);
    }
    isEnableCollision() {
        return this.layer.options.collision && !!this.sceneConfig.collision;
    }
    isEnableUniquePlacement() {
        return this.isEnableCollision() && this.sceneConfig.uniquePlacement;
    }
    isMeshUniquePlaced(e) {
        return this.isMeshIterable(e);
    }
    _updateUniquePlacements() {
        if (!this.isEnableUniquePlacement()) return;
        const e = this.scene.getMeshes(), t = (e, t, n, i)=>{
            const { start: r, end: s } = t[0], o = e.geometry.properties, a = o.elements;
            let l = o.uniquePlacements;
            if (l || (l = o.uniquePlacements = []), void 0 === l[i]) {
                const t = this.getUniqueEntryKey(e, a[r], i);
                l[i] = t ? {
                    key: t,
                    index: i,
                    start: a[r],
                    end: a[s - 1]
                } : null;
            }
        };
        for(let n = 0; n < e.length; n++){
            const i = e[n];
            this.isMeshUniquePlaced(i) && this.forEachBox(i, t);
        }
    }
    _mergeUniquePlacements(e) {
        if (!this.isEnableUniquePlacement()) return;
        const t = this.getMap().getZoom();
        let n = !this._mergedMeshes || this._mergedMehesZoom !== t;
        if (!n) {
            for(let t = 0; t < e.length; t++)if (!this._mergedMeshes[e[t].properties.meshKey]) {
                n = !0;
                break;
            }
        }
        if (!n) return;
        this._mergedMehesZoom = t, this._replacedPlacements = {}, this._mergedMeshes = {}, e = e.sort($435bc7696844e930$var$ri);
        const i = this.getMap().getGLScale(), r = {};
        for(let t = 0; t < e.length; t++){
            const n = e[t];
            if (!n.geometry) continue;
            const { meshKey: s } = n.properties;
            this._mergedMeshes[s] = 1;
            const { uniquePlacements: o } = n.geometry.properties;
            if (o) for(let e = 0; e < o.length; e++){
                if (!o[e]) continue;
                const { key: t, index: s } = o[e], a = this._getBoxTimestamps(n), l = $435bc7696844e930$var$ii(t, i), h = r[l];
                if (h) {
                    const e = h.length, t = h[e - 3].properties.meshKey, i = h[e - 2], r = h[e - 1];
                    this._replacedPlacements[t] = this._replacedPlacements[t] || {}, this._replacedPlacements[t][r] = 1, this._updatePlacementStamps(a, s, i, r), h.push(n, a, s);
                } else r[l] = [
                    n,
                    a,
                    s
                ];
            }
        }
        for(const e in r){
            const t = r[e];
            if (t.length <= 6) continue;
            const n = t.length, i = t[n - 2][t[n - 1]];
            if (t[1][t[2]] !== i) for(let e = 0; e < n - 6; e += 3)t[e + 1][t[e + 2]] = i;
        }
    }
    _updatePlacementStamps(e, t, n, i) {
        if (void 0 !== n[i]) {
            if (void 0 === e[t]) e[t] = n[i];
            else {
                let r = e[t];
                Math.abs(n[i]) > Math.abs(r) ? e[t] = n[i] : n[i] = e[t];
            }
        } else void 0 !== e[t] && (n[i] = e[t]);
    }
    _isReplacedPlacement(e, t) {
        return this._replacedPlacements && this._replacedPlacements[e] && this._replacedPlacements[e][t];
    }
    _getCollideBoxes(e, t) {
        const { symbolIndex: n } = e.properties, i = n.type || 0;
        let r = e.properties._collidesBoxes;
        r || (r = e.properties._collidesBoxes = []);
        let s = r[n.index];
        s || (s = e.properties._collidesBoxes = []), s[i] || (s[i] = []), s = s[i];
        const o = t / 6;
        if (!s[o]) {
            const e = [];
            s[o] = {
                boxes: e,
                collision: {
                    boxes: e
                }
            };
        }
        return s[o];
    }
    _getMeshBoxes(e) {
        let t = this._MeshBoxes;
        if (t || (t = this._MeshBoxes = []), !t[e]) {
            t[e] = [];
            for(let n = 0; n < e; n++)t[e][n] = {};
        }
        return t[e];
    }
    _isHalo0(e) {
        if (!e || !e.geometry) return !0;
        const t = $435bc7696844e930$var$Lt(this.getSymbolDef(e.geometry.properties.symbolIndex).textHaloRadius);
        if (!e.geometry.properties.glyphAtlas || !e.material.get("isHalo") || t && e.geometry.properties.hasHalo) return !1;
        if (t && !e.geometry.properties.hasHalo) return !0;
        return !this.getSymbol(e.geometry.properties.symbolIndex).textHaloRadius;
    }
}
const $435bc7696844e930$var$ni = 10;
function $435bc7696844e930$var$ii(e, t) {
    return Math.round(e[0] / t / $435bc7696844e930$var$ni) * Math.round(e[1] / t / $435bc7696844e930$var$ni) * (e[2] ? Math.round(e[2] / $435bc7696844e930$var$ni) : 1) + "-" + e[3];
}
function $435bc7696844e930$var$ri(e, t) {
    const n = t.properties.level - e.properties.level;
    return 0 === n ? e.properties.meshKey - t.properties.meshKey : n;
}
function $435bc7696844e930$var$si(e, t, n) {
    return e[0] = t[0] - n, e[1] = t[1] - n, e[2] = t[2] + n, e[3] = t[3] + n, e;
}
var $435bc7696844e930$var$oi = "#include <gl2_vert>\n#define SHADER_NAME MARKER\n#define RAD 0.0174532925\n#ifdef HAS_ALTITUDE\nattribute vec2 aPosition;\nattribute float aAltitude;\n#else\nattribute vec3 aPosition;\n#endif\nattribute vec4 aShape;\n#ifdef ENABLE_COLLISION\nattribute float aOpacity;\n#endif\n#ifdef HAS_OPACITY\nattribute vec2 aColorOpacity;\n#endif\n#ifdef HAS_TEXT_SIZE\nattribute float aTextSize;\n#else\nuniform float textSize;\n#endif\n#if defined(HAS_TEXT_DX) || defined(HAS_TEXT_DY) || defined(HAS_MARKER_DX) || defined(HAS_MARKER_DY)\nattribute vec4 aDxDy;\n#endif\n#ifndef HAS_MARKER_DX\nuniform float markerDx;\n#endif\n#ifndef HAS_MARKER_DY\nuniform float markerDy;\n#endif\n#ifndef HAS_TEXT_DX\nuniform float textDx;\n#endif\n#ifndef HAS_TEXT_DY\nuniform float textDy;\n#endif\n#ifdef HAS_MARKER_WIDTH\nattribute float aMarkerWidth;\n#else\nuniform float markerWidth;\n#endif\n#ifdef HAS_MARKER_HEIGHT\nattribute float aMarkerHeight;\n#else\nuniform float markerHeight;\n#endif\n#if defined(HAS_MARKER_PITCH_ALIGN) || defined(HAS_TEXT_PITCH_ALIGN)\nattribute vec2 aPitchAlign;\n#endif\n#ifndef HAS_MARKER_PITCH_ALIGN\nuniform float markerPitchWithMap;\n#endif\n#ifndef HAS_TEXT_PITCH_ALIGN\nuniform float textPitchWithMap;\n#endif\n#if defined(HAS_MARKER_ROTATION_ALIGN) || defined(HAS_TEXT_ROTATION_ALIGN)\nattribute vec2 aRotationAlign;\n#endif\n#ifndef HAS_MARKER_ROTATION_ALIGN\nuniform float markerRotateWithMap;\n#endif\n#ifndef HAS_TEXT_ROTATION_ALIGN\nuniform float textRotateWithMap;\n#endif\nuniform float flipY;\n#if defined(HAS_MARKER_ROTATION) || defined(HAS_TEXT_ROTATION)\nattribute vec2 aRotation;\n#endif\n#ifndef HAS_MARKER_ROTATION\nuniform float markerRotation;\n#endif\n#ifndef HAS_TEXT_ROTATION\nuniform float textRotation;\n#endif\n#ifdef HAS_PAD_OFFSET\nattribute vec2 aPadOffset;\n#endif\nuniform float cameraToCenterDistance;\nuniform mat4 positionMatrix;\nuniform mat4 projViewModelMatrix;\nuniform float textPerspectiveRatio;\nuniform float markerPerspectiveRatio;\nuniform float glyphSize;\nuniform vec2 iconSize;\nuniform vec2 canvasSize;\nuniform vec2 iconTexSize;\nuniform vec2 glyphTexSize;\nuniform float mapPitch;\nuniform float mapRotation;\nuniform float zoomScale;\nuniform float tileRatio;\nuniform float layerScale;\nuniform float isRenderingTerrain;\n#include <vt_position_vert>\nvarying float vIsText;\n#ifndef PICKING_MODE\nvarying vec2 vTexCoord;\nvarying float vOpacity;\nvarying float vGammaScale;\nvarying float vTextSize;\nvarying float vHalo;\n#ifdef HAS_TEXT_FILL\nattribute vec4 aTextFill;\nvarying vec4 vTextFill;\n#endif\n#ifdef HAS_TEXT_HALO_FILL\nattribute vec4 aTextHaloFill;\nvarying vec4 vTextHaloFill;\n#endif\n#if defined(HAS_TEXT_HALO_RADIUS) || defined(HAS_TEXT_HALO_OPACITY)\nattribute vec2 aTextHalo;\nvarying vec2 vTextHalo;\n#endif\n#include <highlight_vert>\n#else\n#include <fbo_picking_vert>\n#endif\nvoid main() {\n  vec3 c = unpackVTPosition();\n#ifdef HAS_TEXT_SIZE\nfloat d = aTextSize * layerScale;\n#else\nfloat d = textSize * layerScale;\n#endif\n#ifdef HAS_TEXT_DX\nfloat e = aDxDy.z;\n#else\nfloat e = textDx;\n#endif\n#ifdef HAS_TEXT_DY\nfloat f = aDxDy.w;\n#else\nfloat f = textDy;\n#endif\n#ifdef HAS_MARKER_WIDTH\nfloat h = aMarkerWidth;\n#else\nfloat h = markerWidth;\n#endif\n#ifdef HAS_MARKER_HEIGHT\nfloat i = aMarkerHeight;\n#else\nfloat i = markerHeight;\n#endif\n#ifdef HAS_MARKER_DX\nfloat j = aDxDy.x;\n#else\nfloat j = markerDx;\n#endif\n#ifdef HAS_MARKER_DY\nfloat k = aDxDy.y;\n#else\nfloat k = markerDy;\n#endif\nfloat l = mod(aShape.z, 2.);\n  float m;\n  if(l > .5) {\n    \n#ifdef HAS_TEXT_PITCH_ALIGN\nm = aPitchAlign.y;\n#else\nm = textPitchWithMap;\n#endif\n  } else {\n    \n#ifdef HAS_MARKER_PITCH_ALIGN\nm = aPitchAlign.x;\n#else\nm = markerPitchWithMap;\n#endif\n  }\n  float n;\n  if(l > .5) {\n    \n#ifdef HAS_TEXT_ROTATION_ALIGN\nn = aRotationAlign.y;\n#else\nn = textRotateWithMap;\n#endif\n  } else {\n    \n#ifdef HAS_MARKER_ROTATION_ALIGN\nn = aRotationAlign.x;\n#else\nn = markerRotateWithMap;\n#endif\n  }\n  gl_Position = projViewModelMatrix * positionMatrix * vec4(c, 1.);\n  float o = gl_Position.w;\n  float u;\n  if(isRenderingTerrain == 1. && m == 1.) {\n    u = 1.;\n  } else {\n    float v = (1. - cameraToCenterDistance / o) * markerPerspectiveRatio;\n    u = clamp(.5 + .5 * (1. - v), .0, 4.);\n  }\n  float A;\n  if(l > .5) {\n    \n#ifdef HAS_TEXT_ROTATION\nA = -aRotation.y / 9362. - mapRotation * n;\n#else\nA = -textRotation - mapRotation * n;\n#endif\n  } else {\n    \n#ifdef HAS_MARKER_ROTATION\nA = -aRotation.x / 9362. - mapRotation * n;\n#else\nA = -markerRotation - mapRotation * n;\n#endif\n  }\n  if(m == 1.) {\n    \n#ifdef REVERSE_MAP_ROTATION_ON_PITCH\nA += mapRotation;\n#else\nif(l > .5) {\n      A -= mapRotation;\n    } else {\n      A += mapRotation;\n    }\n#endif\n  }\n  float B = sin(A);\n  float C = cos(A);\n  mat2 D = mat2(C, -1. * B, B, C);\n  vec2 E = (aShape.xy / 10.0);\n  if(m == 1. && flipY == .0) {\n    E *= vec2(1., -1.);\n  }\n  vIsText = l;\n  if(l > .5) {\n    E = E / glyphSize * d;\n  } else {\n    \n#ifdef HAS_PAD_OFFSET\nfloat F = aPadOffset.x - 1.;\n    float G = aPadOffset.y;\n#else\nfloat F = .0;\n    float G = .0;\n#endif\nE = (E / iconSize * vec2(h, i) + vec2(F, G)) * layerScale;\n  }\n  E = D * E;\n  float H;\n  if(isRenderingTerrain == 1.) {\n    H = 1.;\n  } else {\n    H = o / cameraToCenterDistance;\n  }\n  if(m == .0) {\n    vec2 I = E * 2. / canvasSize;\n    gl_Position.xy += I * u * o;\n  } else if(l > .5) {\n    float J;\n    if(isRenderingTerrain == 1.) {\n      J = tileRatio / zoomScale;\n    } else {\n      J = tileRatio / zoomScale * H * u;\n    }\n    vec2 I = E;\n    gl_Position = projViewModelMatrix * positionMatrix * vec4(c + vec3(I, .0) * J, 1.);\n  } else {\n    vec2 I = E;\n    gl_Position = projViewModelMatrix * positionMatrix * vec4(c + vec3(I, .0) * tileRatio / zoomScale * H * u, 1.);\n  }\n  if(l > .5) {\n    gl_Position.xy += vec2(e, -f) * 2. / canvasSize * o;\n  } else {\n    gl_Position.xy += vec2(j, -k) * 2. / canvasSize * o;\n  }\n#ifndef PICKING_MODE\nif(m == .0) {\n    vGammaScale = mix(1., H, textPerspectiveRatio);\n  } else {\n    vGammaScale = H + mapPitch / 4.;\n  }\n  vGammaScale = clamp(vGammaScale, .0, 1.);\n  vec2 K = floor(aShape.zw / 2.);\n  if(l > .5) {\n    vTexCoord = K / glyphTexSize;\n  } else {\n    vTexCoord = K / iconTexSize;\n  }\n  vHalo = mod(aShape.w, 2.);\n  vTextSize = d;\n#ifdef ENABLE_COLLISION\nvOpacity = aOpacity / 255.;\n#else\nvOpacity = 1.;\n#endif\n#ifdef HAS_OPACITY\nif(l > .5) {\n    vOpacity *= aColorOpacity.y / 255.;\n  } else {\n    vOpacity *= aColorOpacity.x / 255.;\n  }\n#endif\n#ifdef HAS_TEXT_FILL\nvTextFill = aTextFill / 255.;\n#endif\n#ifdef HAS_TEXT_HALO_FILL\nvTextHaloFill = aTextHaloFill / 255.;\n#endif\n#if defined(HAS_TEXT_HALO_RADIUS) || defined(HAS_TEXT_HALO_OPACITY)\nvTextHalo = aTextHalo;\n#endif\nhighlight_setVarying();\n#else\n#ifdef ENABLE_COLLISION\nbool L = aOpacity == 255.;\n#else\nbool L = true;\n#endif\nfbo_picking_setData(gl_Position.w, L);\n#endif\n}";
const $435bc7696844e930$var$ai = [], $435bc7696844e930$var$li = [], $435bc7696844e930$var$hi = [], $435bc7696844e930$var$ci = [], $435bc7696844e930$var$ui = [], $435bc7696844e930$var$fi = [];
function $435bc7696844e930$var$di(e, t, n, i, r, s, a, l, h, u, d, p, g, m) {
    const { tileRatio: y, tileResolution: x } = h, _ = y / (x / u.getResolution()) * (d / u.cameraToCenterDistance) * p;
    (0, $6BoVD).scale(n, n, _), (0, $6BoVD).scale(i, i, _), (0, $6BoVD).scale(r, r, _), (0, $6BoVD).scale(s, s, _), (0, $eIStk).set($435bc7696844e930$var$ai, n[0], n[1], g ? n[2] / m : 0), (0, $eIStk).set($435bc7696844e930$var$li, i[0], i[1], g ? i[2] / m : 0), (0, $eIStk).set($435bc7696844e930$var$hi, r[0], r[1], g ? r[2] / m : 0), (0, $eIStk).set($435bc7696844e930$var$ci, s[0], s[1], g ? s[2] / m : 0), (0, $eIStk).add($435bc7696844e930$var$ai, $435bc7696844e930$var$ai, t), (0, $eIStk).add($435bc7696844e930$var$li, $435bc7696844e930$var$li, t), (0, $eIStk).add($435bc7696844e930$var$hi, $435bc7696844e930$var$hi, t), (0, $eIStk).add($435bc7696844e930$var$ci, $435bc7696844e930$var$ci, t), $435bc7696844e930$var$Bt(n, $435bc7696844e930$var$ai, a, u.width, u.height), $435bc7696844e930$var$Bt(i, $435bc7696844e930$var$li, a, u.width, u.height), $435bc7696844e930$var$Bt(r, $435bc7696844e930$var$hi, a, u.width, u.height), $435bc7696844e930$var$Bt(s, $435bc7696844e930$var$ci, a, u.width, u.height), (0, $6BoVD).set($435bc7696844e930$var$ui, Math.min(n[0], i[0], r[0], s[0]), Math.min(n[1], i[1], r[1], s[1])), (0, $6BoVD).set($435bc7696844e930$var$fi, Math.max(n[0], i[0], r[0], s[0]), Math.max(n[1], i[1], r[1], s[1])), (0, $jxhwV).set(e, $435bc7696844e930$var$ui[0] + l[0], $435bc7696844e930$var$ui[1] + l[1], $435bc7696844e930$var$fi[0] + l[0], $435bc7696844e930$var$fi[1] + l[1]);
}
function $435bc7696844e930$var$pi(e, t, n, i, r, s, o, a) {
    1 !== a && ((0, $6BoVD).scale(n, n, a), (0, $6BoVD).scale(i, i, a), (0, $6BoVD).scale(r, r, a), (0, $6BoVD).scale(s, s, a)), (0, $6BoVD).set($435bc7696844e930$var$ui, Math.min(n[0], i[0], r[0], s[0]), Math.min(n[1], i[1], r[1], s[1])), (0, $6BoVD).set($435bc7696844e930$var$fi, Math.max(n[0], i[0], r[0], s[0]), Math.max(n[1], i[1], r[1], s[1])), (0, $jxhwV).set(e, t[0] + $435bc7696844e930$var$ui[0] + o[0], t[1] + $435bc7696844e930$var$ui[1] - o[1], t[0] + $435bc7696844e930$var$fi[0] + o[0], t[1] + $435bc7696844e930$var$fi[1] - o[1]);
}
function $435bc7696844e930$var$gi(e, t, n, i, r) {
    t -= n * i, 1 === r && (t += n);
    const s = Math.sin(t), o = Math.cos(t);
    return (0, $iLdEy).set(e, o, -s, s, o);
}
const $435bc7696844e930$var$mi = 15, $435bc7696844e930$var$yi = 15, $435bc7696844e930$var$xi = 2048, $435bc7696844e930$var$_i = 24, $435bc7696844e930$var$vi = .01, $435bc7696844e930$var$bi = [], $435bc7696844e930$var$Ai = [], $435bc7696844e930$var$Ti = [], $435bc7696844e930$var$Si = [], $435bc7696844e930$var$wi = [], $435bc7696844e930$var$Mi = [], $435bc7696844e930$var$Pi = [], $435bc7696844e930$var$Ii = [], $435bc7696844e930$var$Ci = [
    1,
    -1
], $435bc7696844e930$var$ki = [
    1,
    1
];
function $435bc7696844e930$var$Fi(e, t, n, i, r) {
    const s = t.material.uniforms, a = r.cameraToCenterDistance, l = t.geometry.properties, h = this.getSymbol(l.symbolIndex), c = t.geometry.desc.positionSize, u = l.aAnchor, d = (0, $eIStk).set($435bc7696844e930$var$bi, u[n * c], u[n * c + 1], 2 === c ? 0 : u[n * c + 2]), { aTerrainAltitude: p } = l;
    if (p) {
        const e = 100 * p[2 * n];
        e && (d[2] += e);
    }
    let g = $435bc7696844e930$var$Bt($435bc7696844e930$var$Ai, d, i, r.width, r.height);
    const m = g[2];
    let y = 1;
    if (s.markerPerspectiveRatio) y = $435bc7696844e930$var$Me(.5 + .5 * (1 - (1 - a / m) * s.markerPerspectiveRatio), 0, 4);
    const { aShape: x, aMarkerDx: _, aMarkerDy: v, aMarkerWidth: b, aMarkerHeight: A, aPitchAlign: T, aRotationAlign: S, aRotation: w } = l, M = _ ? _[n] : h.markerDx, P = v ? v[n] : h.markerDy, I = T ? T[2 * n] : s.markerPitchWithMap, C = S ? S[2 * n] : s.markerRotateWithMap, k = (0, $6BoVD).set($435bc7696844e930$var$Ii, M || 0, -(P || 0));
    let F = (0, $6BoVD).set($435bc7696844e930$var$Si, x[2 * n] / 10, x[2 * n + 1] / 10), O = (0, $6BoVD).set($435bc7696844e930$var$wi, x[2 * n + 2] / 10, x[2 * n + 3] / 10), R = (0, $6BoVD).set($435bc7696844e930$var$Mi, x[2 * n + 4] / 10, x[2 * n + 5] / 10), E = (0, $6BoVD).set($435bc7696844e930$var$Pi, x[2 * n + 6] / 10, x[2 * n + 7] / 10);
    0 === s.flipY && 1 === I && ((0, $6BoVD).multiply(F, F, $435bc7696844e930$var$Ci), (0, $6BoVD).multiply(O, O, $435bc7696844e930$var$Ci), (0, $6BoVD).multiply(R, R, $435bc7696844e930$var$Ci), (0, $6BoVD).multiply(E, E, $435bc7696844e930$var$Ci));
    const [D, L] = $435bc7696844e930$var$vn(t.geometry);
    let H = b ? b[n] : h.markerWidth;
    $435bc7696844e930$var$Ie(H) && (H = D || $435bc7696844e930$var$mi);
    let N = A ? A[n] : h.markerHeight;
    $435bc7696844e930$var$Ie(N) && (N = L || $435bc7696844e930$var$yi);
    const z = (0, $6BoVD).set($435bc7696844e930$var$ki, H / $435bc7696844e930$var$xi, N / $435bc7696844e930$var$xi);
    let V;
    (0, $6BoVD).mul(F, F, z), (0, $6BoVD).mul(O, O, z), (0, $6BoVD).mul(R, R, z), (0, $6BoVD).mul(E, E, z), V = w ? w[2 * n] / 9362 : -(h.markerRotation || 0) * Math.PI / 180;
    const U = -V, B = r.getBearing() * Math.PI / 180;
    if (B * C || U) {
        const e = $435bc7696844e930$var$gi($435bc7696844e930$var$Ti, U, B, C, I);
        F = (0, $6BoVD).transformMat2(F, F, e), O = (0, $6BoVD).transformMat2(O, O, e), R = (0, $6BoVD).transformMat2(R, R, e), E = (0, $6BoVD).transformMat2(E, E, e);
    }
    1 === I ? $435bc7696844e930$var$di(e, d, F, O, R, E, i, k, s, r, m, y) : ((0, $6BoVD).multiply(F, F, $435bc7696844e930$var$Ci), (0, $6BoVD).multiply(O, O, $435bc7696844e930$var$Ci), (0, $6BoVD).multiply(R, R, $435bc7696844e930$var$Ci), (0, $6BoVD).multiply(E, E, $435bc7696844e930$var$Ci), $435bc7696844e930$var$pi(e, g, F, O, R, E, k, y));
    const G = this.getMap().getDevicePixelRatio();
    return 1 !== G && (e[0] *= G, e[1] *= G, e[2] *= G, e[3] *= G), e;
}
const { PackUtil: $435bc7696844e930$var$Oi } = $435bc7696844e930$var$H(), $435bc7696844e930$var$Ri = 1, $435bc7696844e930$var$Ei = [], $435bc7696844e930$var$Di = [], $435bc7696844e930$var$Li = [], $435bc7696844e930$var$Hi = [], $435bc7696844e930$var$Ni = [], $435bc7696844e930$var$zi = [], $435bc7696844e930$var$Vi = [
    1,
    -1
];
function $435bc7696844e930$var$Ui(e, t, n, i, r, s, a, l, h) {
    const c = i.material.uniforms, u = h.cameraToCenterDistance, d = i.geometry.properties, p = this.getSymbol(d.symbolIndex), g = "line" === p.textPlacement && !$435bc7696844e930$var$He(p), m = $435bc7696844e930$var$_i, y = n[2];
    let x = 1;
    if (c.textPerspectiveRatio) x = $435bc7696844e930$var$Me(.5 + .5 * (1 - (1 - u / y) * c.textPerspectiveRatio), 0, 4);
    const { aTextDx: _, aTextDy: v, aPitchAlign: b, aRotationAlign: A, aRotation: T, aType: S, aDxDy: w } = i.geometry.properties;
    let M, P, I;
    w ? (M = w[4 * a + 2], P = w[4 * a + 3]) : (M = _ ? _[a] : p.textDx, P = v ? v[a] : p.textDy), b && (I = S ? b[2 * a + 1] : b[a]);
    const C = b ? I : c.textPitchWithMap;
    let k;
    A && (k = S ? A[2 * a + 1] : A[a]);
    const F = A ? k : c.textRotateWithMap, O = (0, $6BoVD).set($435bc7696844e930$var$zi, M || 0, -(P || 0));
    if (g) {
        const { aOffset: i, aShape: r } = d, s = i.length !== r.length;
        let u, p, g, m;
        if (s ? (u = (0, $eIStk).set($435bc7696844e930$var$Di, i[3 * a] / 10, i[3 * a + 1] / 10, i[3 * a + 2] / 10), p = (0, $eIStk).set($435bc7696844e930$var$Li, i[3 * a + 3] / 10, i[3 * a + 4] / 10, i[3 * a + 5] / 10), g = (0, $eIStk).set($435bc7696844e930$var$Hi, i[3 * a + 6] / 10, i[3 * a + 7] / 10, i[3 * a + 8] / 10), m = (0, $eIStk).set($435bc7696844e930$var$Ni, i[3 * a + 9] / 10, i[3 * a + 10] / 10, i[3 * a + 11] / 10)) : (u = (0, $6BoVD).set($435bc7696844e930$var$Di, i[2 * a] / 10, i[2 * a + 1] / 10), p = (0, $6BoVD).set($435bc7696844e930$var$Li, i[2 * a + 2] / 10, i[2 * a + 3] / 10), g = (0, $6BoVD).set($435bc7696844e930$var$Hi, i[2 * a + 4] / 10, i[2 * a + 5] / 10), m = (0, $6BoVD).set($435bc7696844e930$var$Ni, i[2 * a + 6] / 10, i[2 * a + 7] / 10)), 1 === C) {
            const n = $435bc7696844e930$var$$(h.getResolution(), h);
            $435bc7696844e930$var$di(e, t, u, p, g, m, l, O, c, h, y, x, s, n);
        } else (0, $6BoVD).multiply(u, u, $435bc7696844e930$var$Vi), (0, $6BoVD).multiply(p, p, $435bc7696844e930$var$Vi), (0, $6BoVD).multiply(g, g, $435bc7696844e930$var$Vi), (0, $6BoVD).multiply(m, m, $435bc7696844e930$var$Vi), $435bc7696844e930$var$pi(e, n, u, p, g, m, O, x);
    } else {
        const { aShape: i } = d;
        let s, o = (0, $6BoVD).set($435bc7696844e930$var$Di, i[2 * a] / 10, -i[2 * a + 1] / 10), u = (0, $6BoVD).set($435bc7696844e930$var$Li, i[2 * a + 2] / 10, -i[2 * a + 3] / 10), _ = (0, $6BoVD).set($435bc7696844e930$var$Hi, i[2 * a + 4] / 10, -i[2 * a + 5] / 10), v = (0, $6BoVD).set($435bc7696844e930$var$Ni, i[2 * a + 6] / 10, -i[2 * a + 7] / 10);
        0 === c.flipY && 1 === C && ((0, $6BoVD).multiply(o, o, $435bc7696844e930$var$Vi), (0, $6BoVD).multiply(u, u, $435bc7696844e930$var$Vi), (0, $6BoVD).multiply(_, _, $435bc7696844e930$var$Vi), (0, $6BoVD).multiply(v, v, $435bc7696844e930$var$Vi)), s = T ? S && T.length > S.length ? T[2 * a + 1] / 9362 : T[a] / 9362 : (p.textRotation || 0) * Math.PI / 180;
        const b = g ? 0 : h.getBearing() * Math.PI / 180;
        if (s || b) {
            const e = $435bc7696844e930$var$gi($435bc7696844e930$var$Ei, s, b, F, C);
            o = (0, $6BoVD).transformMat2(o, o, e), u = (0, $6BoVD).transformMat2(u, u, e), _ = (0, $6BoVD).transformMat2(_, _, e), v = (0, $6BoVD).transformMat2(v, v, e);
        }
        const A = r / m;
        (0, $6BoVD).scale(o, o, A), (0, $6BoVD).scale(u, u, A), (0, $6BoVD).scale(_, _, A), (0, $6BoVD).scale(v, v, A), 1 === C ? $435bc7696844e930$var$di(e, t, o, u, _, v, l, O, c, h, y, x) : $435bc7696844e930$var$pi(e, n, o, u, _, v, O, x);
    }
    s = s || 0, e[0] -= s + $435bc7696844e930$var$Ri, e[1] -= s + $435bc7696844e930$var$Ri, e[2] += s + $435bc7696844e930$var$Ri, e[3] += s + $435bc7696844e930$var$Ri;
    const R = this.getMap().getDevicePixelRatio();
    return 1 !== R && (e[0] *= R, e[1] *= R, e[2] *= R, e[3] *= R), e;
}
function $435bc7696844e930$var$Bi(e, t, n) {
    const i = t.geometry.desc.positionSize, { aAnchor: r, aAltitude: s, aTerrainAltitude: a } = t.geometry.properties, l = n * i;
    if (s ? (0, $eIStk).set(e, r[l], r[l + 1], s[n]) : 3 === i ? $435bc7696844e930$var$Oi.unpackPosition(e, r[l], r[l + 1], r[l + 2]) : (0, $eIStk).set(e, r[l], r[l + 1], 0), a) {
        const t = 100 * a[2 * n];
        t && (e[2] += t);
    }
    return e;
}
(0, $2wazW).ShaderLib.register("text_render_frag", "#define HAS_HIGHLIGHT_COLOR_POINT 1\n#define SDF_PX 8.0\n#define DEVICE_PIXEL_RATIO 1.0\n#define EDGE_GAMMA 0.105 / DEVICE_PIXEL_RATIO\nuniform sampler2D glyphTex;\nuniform float textOpacity;\nuniform highp float gammaScale;\nuniform float isHalo;\nuniform highp float textHaloBlur;\n#if defined(HAS_TEXT_HALO_OPACITY) || defined(HAS_TEXT_HALO_RADIUS)\n    varying vec2 vTextHalo;\n#endif\n#ifndef HAS_TEXT_HALO_OPACITY\n    uniform float textHaloOpacity;\n#endif\n#ifndef HAS_TEXT_HALO_RADIUS\n    uniform highp float textHaloRadius;\n#endif\nvarying float vTextSize;\nvarying float vGammaScale;\n#ifdef HAS_TEXT_FILL\n    varying vec4 vTextFill;\n#else\n    uniform vec4 textFill;\n#endif\n#ifdef HAS_TEXT_HALO_FILL\n    varying vec4 vTextHaloFill;\n#else\n    uniform vec4 textHaloFill;\n#endif\nvec4 renderText(vec2 texCoord) {\n    #ifdef HAS_TEXT_FILL\n        vec4 myTextFill = vTextFill;\n    #else\n        vec4 myTextFill = textFill;\n    #endif\n    float fontScale = vTextSize / 24.0;\n    vec4 color = myTextFill;\n    highp float gamma = EDGE_GAMMA / (fontScale * gammaScale);\n    lowp float buff = 185.0 / 256.0;    bool isHaloText;\n    #ifdef HAS_HALO_ATTR\n        isHaloText = vHalo > 0.5;\n    #else\n        isHaloText = isHalo == 1.0;\n    #endif\n    if (isHaloText) {\n        #ifdef HAS_TEXT_HALO_FILL\n            vec4 haloFill = vTextHaloFill;\n        #else\n            vec4 haloFill = textHaloFill;\n        #endif\n        #ifdef HAS_TEXT_HALO_RADIUS\n            float haloRadius = vTextHalo.x;\n        #else\n            float haloRadius = textHaloRadius;\n        #endif\n        if (haloRadius == 0.0) {\n            discard;\n        }\n        color = haloFill;\n        gamma = (textHaloBlur * 1.19 / SDF_PX + EDGE_GAMMA) / (fontScale * gammaScale);\n        buff = (6.0 - haloRadius / fontScale) / SDF_PX;\n        #ifdef HAS_TEXT_HALO_OPACITY\n            float haloOpacity = vTextHalo.y / 255.0;\n        #else\n            float haloOpacity = textHaloOpacity;\n        #endif\n        color *= haloOpacity * 1.25;\n    }\n    float dist = texture2D(glyphTex, texCoord).a;\n    highp float gammaScaled = gamma * vGammaScale * 0.7;\n    float alpha = clamp(smoothstep(buff - gammaScaled, buff + gammaScaled, dist), 0.0, 1.0);\n    return color * (alpha * textOpacity);\n}");
const $435bc7696844e930$var$Gi = {
    textFill: [
        0,
        0,
        0,
        1
    ],
    textOpacity: 1,
    textPitchAlignment: 0,
    textRotationAlignment: 0,
    textHaloRadius: 0,
    textHaloFill: [
        1,
        1,
        1,
        1
    ],
    textHaloBlur: 0,
    textHaloOpacity: 1,
    textPerspectiveRatio: 0,
    textSize: 14,
    textDx: 0,
    textDy: 0,
    textRotation: 0
};
function $435bc7696844e930$var$ji(e, t, n, i, r, o, a, l, h) {
    const c = [];
    if (t.isDisposed() || 0 === t.data.aPosition.length) return c;
    const u = t.properties.glyphAtlas;
    if (!u) return c;
    if (0 === i.textSize || 0 === i.textOpacity) return c;
    $435bc7696844e930$var$Xi.call(this, t, i, o, a, l, h);
    const f = $435bc7696844e930$var$Yi.call(this, {}, e, t, r);
    let d = !1;
    r.textOpacity < 1 && (d = !0), t.properties.memorySize = t.getMemorySize(), t.generateBuffers(e, {
        excludeElementsInVAO: !0
    });
    const p = new (0, $2wazW).Material(f, $435bc7696844e930$var$Gi), g = new (0, $2wazW).Mesh(t, p, {
        disableVAO: !0,
        transparent: d,
        castShadow: !1,
        picking: !0
    });
    if (g.setLocalTransform(n), g.setUniform("alphaTest", $435bc7696844e930$var$vi), f.isHalo && (g.properties.isHalo = !0), a && g.setDefines({
        ENABLE_COLLISION: 1
    }), c.push(g), f.isHalo) {
        const e = $435bc7696844e930$var$Wi.call(this, t, r, f.glyphTex, u, a, n);
        e.properties.haloMesh = g, c.push(e);
    }
    return c.forEach((e)=>{
        const n = e.defines || {};
        $435bc7696844e930$var$Zi.call(this, n, e), e.setDefines(n), e.properties.symbolIndex = t.properties.symbolIndex;
    }), c;
}
function $435bc7696844e930$var$Wi(e, t, n, i, r, o) {
    let a = !1;
    t.textOpacity < 1 && (a = !0);
    const l = {
        flipY: 0,
        tileResolution: e.properties.tileResolution,
        tileRatio: e.properties.tileRatio,
        glyphTex: n,
        glyphTexSize: [
            i.width,
            i.height
        ],
        isHalo: 0
    };
    $435bc7696844e930$var$$i(e, l, t);
    const h = new (0, $2wazW).Material(l, $435bc7696844e930$var$Gi), c = new (0, $2wazW).Mesh(e, h, {
        disableVAO: !0,
        transparent: a,
        castShadow: !1,
        picking: !0
    });
    return c.setUniform("alphaTest", $435bc7696844e930$var$vi), Object.defineProperty(c.properties, "textSize", {
        enumerable: !0,
        get: function() {
            return l.textSize;
        }
    }), r && c.setDefines({
        ENABLE_COLLISION: 1
    }), c.setLocalTransform(o), c;
}
function $435bc7696844e930$var$Xi(e, t, n, i, r, s) {
    $435bc7696844e930$var$wt(e, t, n, this.layer);
    const o = e.properties;
    if (!o.textInitialized) {
        $435bc7696844e930$var$qi.call(this, e, i || s, r), o.textInitialized = !0;
        const { aTextSize: t, aTextDx: n, aTextDy: a, aPitchAlign: l, aRotationAlign: h, aRotation: c, aOverlap: u, aAltitude: f } = e.data;
        if (t) {
            const e = ($435bc7696844e930$var$Tt + "aTextSize").trim();
            o.aTextSize = o[e] || new t.constructor(t);
        }
        if (n) {
            const e = ($435bc7696844e930$var$Tt + "aTextDx").trim();
            o.aTextDx = o[e] || new n.constructor(n);
        }
        if (a) {
            const e = ($435bc7696844e930$var$Tt + "aTextDy").trim();
            o.aTextDy = o[e] || new a.constructor(a);
        }
        if (l) {
            const e = ($435bc7696844e930$var$Tt + "aPitchAlign").trim();
            o.aPitchAlign = o[e] || new l.constructor(l);
        }
        if (h) {
            const e = ($435bc7696844e930$var$Tt + "aRotationAlign").trim();
            o.aRotationAlign = o[e] || new h.constructor(h);
        }
        if (c) {
            const e = ($435bc7696844e930$var$Tt + "aRotation").trim();
            o.aRotation = o[e] || new c.constructor(c);
        }
        if (u) {
            const e = ($435bc7696844e930$var$Tt + "aOverlap").trim();
            o.aOverlap = o[e] || new u.constructor(u);
        }
        if (f) {
            const e = ($435bc7696844e930$var$Tt + "aAltitude").trim();
            o.aAltitude = o[e] || new f.constructor(f);
        }
    }
}
function $435bc7696844e930$var$Yi(e, t, n, i) {
    const r = n.properties.glyphAtlas, s = r && $435bc7696844e930$var$yn(t, r, !1);
    return $435bc7696844e930$var$we(e = e || {}, {
        flipY: 0,
        tileResolution: n.properties.tileResolution,
        tileRatio: n.properties.tileRatio,
        glyphTex: s || this._emptyTexture,
        glyphTexSize: [
            r && r.width || 0,
            r && r.height || 0
        ]
    }), $435bc7696844e930$var$$i(n, e, i), e;
}
function $435bc7696844e930$var$Zi(e, t) {
    const n = t.geometry;
    n.data.aTextFill && (e.HAS_TEXT_FILL = 1), n.data.aTextSize && (e.HAS_TEXT_SIZE = 1), n.data.aColorOpacity && (e.HAS_OPACITY = 1), n.data.aTextHaloFill && t.material.uniforms.isHalo && (e.HAS_TEXT_HALO_FILL = 1);
    const i = this.getSymbolDef(n.properties.symbolIndex);
    $435bc7696844e930$var$Lt(i.textHaloRadius) && t.material.uniforms.isHalo && (e.HAS_TEXT_HALO_RADIUS = 1), $435bc7696844e930$var$Lt(i.textHaloOpacity) && t.material.uniforms.isHalo && (e.HAS_TEXT_HALO_OPACITY = 1), $435bc7696844e930$var$Lt(i.textDx) && (e.HAS_TEXT_DX = 1), $435bc7696844e930$var$Lt(i.textDy) && (e.HAS_TEXT_DY = 1), n.data.aPitchAlign && (e.HAS_PITCH_ALIGN = 1), $435bc7696844e930$var$Lt(i.textRotationAlignment) && (e.HAS_TEXT_ROTATION_ALIGN = 1), n.data.aRotation && (e.HAS_TEXT_ROTATION = 1), n.data.aAltitude && (e.HAS_ALTITUDE = 1), n.properties.aOffset && n.properties.aShape && n.properties.aOffset.length !== n.properties.aShape.length && (e.HAS_OFFSET_Z = 1);
}
function $435bc7696844e930$var$qi(e, t, n) {
    const i = e.properties, r = this.getSymbol(i.symbolIndex), s = "line" === i.textPlacement && !$435bc7696844e930$var$He(r), { aPosition: o, aShape: a } = e.data, l = o.length / e.desc.positionSize;
    if (i.vertexCount = l, i.aPickingId = e.data.aPickingId, i.aCount || (i.aCount = e.data.aCount, delete e.data.aCount), t || s) {
        let e = a;
        if (a.length === 4 * l) {
            e = new a.constructor(2 * l);
            for(let t = 0; t < l; t++)e[2 * t] = a[4 * t], e[2 * t + 1] = a[4 * t + 1];
        }
        i.aAnchor = o, i.aShape = e;
    }
    if (i.visElemts || (i.elements = e.elements, i.visElemts = new e.elements.constructor(e.elements.length)), s) {
        const { aVertical: t, aSegment: n, aGlyphOffset: r, aPitchRotation: s } = e.data, o = !!s;
        i.aGlyphOffset = r, i.aPitchRotation = s, i.aSegment = n, i.aVertical = t, delete e.data.aSegment, delete e.data.aVertical, delete e.data.aGlyphOffset, delete e.data.aPitchRotation;
        const a = l * (o ? 3 : 2);
        e.data.aOffset = {
            usage: "dynamic",
            data: new Int16Array(a)
        }, i.aOffset = new Int16Array(a);
    }
    if (t) {
        e.data.aOpacity = {
            usage: "dynamic",
            data: new Uint8Array(l)
        }, i.aOpacity = new Uint8Array(l), n && (i.aOpacity.fill(255, 0), e.data.aOpacity.data.fill(255, 0));
        const { aTextHalo: t } = e.data;
        if (t && !i.aTextHalo) {
            const e = ($435bc7696844e930$var$Tt + "aTextHalo").trim();
            i.aTextHalo = i[e] || new t.constructor(t);
        }
    }
}
function $435bc7696844e930$var$$i(e, t, n) {
    void 0 === t.isHalo && (t.isHalo = 1), $435bc7696844e930$var$ke(t, "textOpacity", n, "textOpacity", $435bc7696844e930$var$Gi.textOpacity), $435bc7696844e930$var$ke(t, "textFill", n, "textFill", $435bc7696844e930$var$Gi.textFill, $435bc7696844e930$var$Re()), $435bc7696844e930$var$ke(t, "textHaloFill", n, "textHaloFill", $435bc7696844e930$var$Gi.textHaloFill, $435bc7696844e930$var$Re()), $435bc7696844e930$var$ke(t, "textHaloBlur", n, "textHaloBlur", $435bc7696844e930$var$Gi.textHaloBlur), $435bc7696844e930$var$ke(t, "textHaloRadius", n, "textHaloRadius", $435bc7696844e930$var$Gi.textHaloRadius), $435bc7696844e930$var$ke(t, "textHaloOpacity", n, "textHaloOpacity", $435bc7696844e930$var$Gi.textHaloOpacity), $435bc7696844e930$var$ke(t, "textPerspectiveRatio", n, "textPerspectiveRatio", $435bc7696844e930$var$Gi.textPerspectiveRatio, (t)=>"line" === e.properties.textPlacement ? 1 : t), $435bc7696844e930$var$ke(t, "textRotateWithMap", n, "textRotationAlignment", $435bc7696844e930$var$Gi.textRotationAlignment, (e)=>+("map" === e)), $435bc7696844e930$var$ke(t, "textPitchWithMap", n, "textPitchAlignment", $435bc7696844e930$var$Gi.textPitchAlignment, (e)=>+("map" === e)), $435bc7696844e930$var$ke(t, "textSize", n, "textSize", $435bc7696844e930$var$Gi.textSize), $435bc7696844e930$var$ke(t, "textDx", n, "textDx", $435bc7696844e930$var$Gi.textDx), $435bc7696844e930$var$ke(t, "textDy", n, "textDy", $435bc7696844e930$var$Gi.textDy), $435bc7696844e930$var$ke(t, "textRotation", n, "textRotation", $435bc7696844e930$var$Gi.textRotation, (e)=>e * Math.PI / 180);
}
function $435bc7696844e930$var$Ji(e) {
    const t = [];
    return {
        uniforms: [
            {
                name: "projViewModelMatrix",
                type: "function",
                fn: function(e, n) {
                    return (0, $3iqbd).multiply(t, n.projViewMatrix, n.modelMatrix);
                }
            },
            {
                name: "zoomScale",
                type: "function",
                fn: function(e, t) {
                    return t.tileResolution / t.resolution;
                }
            }
        ],
        extraCommandProps: {
            viewport: {
                x: 0,
                y: 0,
                width: ()=>e ? e.width : 1,
                height: ()=>e ? e.height : 1
            },
            stencil: {
                enable: !0,
                mask: 255,
                func: {
                    cmp: "<=",
                    ref: (e, t)=>t.stencilRef,
                    mask: 255
                },
                op: {
                    fail: "keep",
                    zfail: "keep",
                    zpass: "replace"
                }
            },
            blend: {
                enable: !0,
                func: this.getBlendFunc(),
                equation: "add"
            },
            depth: {
                enable: !0,
                range: ()=>this.sceneConfig.depthRange || [
                        0,
                        1
                    ],
                func: ()=>this.sceneConfig.depthFunc || "always",
                mask: !1
            },
            polygonOffset: {
                enable: !0,
                offset: this.getPolygonOffset()
            }
        }
    };
}
function $435bc7696844e930$var$Ki(e, t) {
    const n = (0, $14507960c5dac0fb$export$b5e0f6446c9b8e3c)(t.textFill), i = (0, $14507960c5dac0fb$export$b5e0f6446c9b8e3c)(t.textSize), r = (0, $14507960c5dac0fb$export$b5e0f6446c9b8e3c)(t.textHaloFill), s = (0, $14507960c5dac0fb$export$b5e0f6446c9b8e3c)(t.textHaloRadius), o = (0, $14507960c5dac0fb$export$b5e0f6446c9b8e3c)(t.textHaloOpacity), a = (0, $14507960c5dac0fb$export$b5e0f6446c9b8e3c)(t.textDx), l = (0, $14507960c5dac0fb$export$b5e0f6446c9b8e3c)(t.textDy), h = (0, $14507960c5dac0fb$export$b5e0f6446c9b8e3c)(t.textOpacity), c = (0, $14507960c5dac0fb$export$79e978600dd1e509)(t.textPitchAlignment), u = (0, $14507960c5dac0fb$export$79e978600dd1e509)(t.textRotationAlignment), f = (0, $14507960c5dac0fb$export$b5e0f6446c9b8e3c)(t.textRotation), d = (0, $14507960c5dac0fb$export$79e978600dd1e509)(t.textAllowOverlapFn), p = (0, $14507960c5dac0fb$export$79e978600dd1e509)(t.textIgnorePlacement), g = {}, m = new Int16Array(1), x = new Uint16Array(1);
    return [
        {
            attrName: "aTextFill",
            symbolName: "textFill",
            define: "HAS_TEXT_FILL",
            type: Uint8Array,
            width: 4,
            evaluate: (t, i)=>{
                let r = n(e.getZoom(), t);
                return (0, $14507960c5dac0fb$export$ec423ecbfcdb9a06)(r) && (r = this.evaluateInFnTypeConfig(r, i, e, t, !0)), Array.isArray(r) || (r = g[r] = g[r] || (0, (/*@__PURE__*/$parcel$interopDefault($08acccbbd431ef55$exports)))(r).unitArray()), r = $435bc7696844e930$var$Oe(r), r;
            }
        },
        {
            attrName: "aTextSize",
            symbolName: "textSize",
            define: "HAS_TEXT_SIZE",
            type: Uint8Array,
            width: 1,
            evaluate: (t, n)=>{
                let r = i(e.getZoom(), t) || $435bc7696844e930$var$Gi.textSize;
                return (0, $14507960c5dac0fb$export$ec423ecbfcdb9a06)(r) && (r = this.evaluateInFnTypeConfig(r, n, e, t)), m[0] = r, m[0];
            }
        },
        {
            attrName: "aTextHaloFill",
            symbolName: "textHaloFill",
            define: "HAS_TEXT_HALO_FILL",
            type: Uint8Array,
            width: 4,
            evaluate: (t)=>{
                let n = r(e.getZoom(), t);
                return Array.isArray(n) || (n = g[n] = g[n] || (0, (/*@__PURE__*/$parcel$interopDefault($08acccbbd431ef55$exports)))(n).unitArray()), n = $435bc7696844e930$var$Oe(n), n;
            }
        },
        {
            attrName: "aTextHalo",
            symbolName: "textHaloRadius",
            define: "HAS_TEXT_HALO_RADIUS",
            type: Uint8Array,
            index: 0,
            width: 2,
            evaluate: (t)=>{
                const n = s(e.getZoom(), t);
                return m[0] = n, m[0];
            }
        },
        {
            attrName: "aTextHalo",
            symbolName: "textHaloOpacity",
            define: "HAS_TEXT_HALO_OPACITY",
            type: Uint8Array,
            index: 1,
            width: 2,
            evaluate: (t)=>{
                const n = o(e.getZoom(), t);
                return m[0] = 255 * n, m[0];
            }
        },
        {
            attrName: "aTextDx",
            symbolName: "textDx",
            define: "HAS_TEXT_DX",
            type: Uint8Array,
            width: 1,
            evaluate: (t, n)=>{
                let i = a(e.getZoom(), t);
                return (0, $14507960c5dac0fb$export$ec423ecbfcdb9a06)(i) && (i = this.evaluateInFnTypeConfig(i, n, e, t)), m[0] = i, m[0];
            }
        },
        {
            attrName: "aTextDy",
            symbolName: "textDy",
            define: "HAS_TEXT_DY",
            type: Uint8Array,
            width: 1,
            evaluate: (t, n)=>{
                let i = l(e.getZoom(), t);
                return (0, $14507960c5dac0fb$export$ec423ecbfcdb9a06)(i) && (i = this.evaluateInFnTypeConfig(i, n, e, t)), m[0] = i, m[0];
            }
        },
        {
            attrName: "aColorOpacity",
            symbolName: "textOpacity",
            define: "HAS_OPACITY",
            type: Uint8Array,
            width: 1,
            evaluate: (t, n)=>{
                let i = h(e.getZoom(), t);
                return (0, $14507960c5dac0fb$export$ec423ecbfcdb9a06)(i) && (i = this.evaluateInFnTypeConfig(i, n, e, t)), m[0] = 255 * i, m[0];
            }
        },
        {
            attrName: "aPitchAlign",
            symbolName: "textPitchAlignment",
            type: Uint8Array,
            width: 1,
            define: "HAS_PITCH_ALIGN",
            evaluate: (t)=>+("map" === c(e.getZoom(), t))
        },
        {
            attrName: "aRotationAlign",
            symbolName: "textRotationAlignment",
            type: Uint8Array,
            width: 1,
            define: "HAS_ROTATION_ALIGN",
            evaluate: (t)=>+("map" === u(e.getZoom(), t))
        },
        {
            attrName: "aRotation",
            symbolName: "textRotation",
            type: Uint16Array,
            width: 1,
            define: "HAS_TEXT_ROTATION",
            evaluate: (t)=>{
                const n = $435bc7696844e930$var$Pe(f(e.getZoom(), t), 0, 360) * Math.PI / 180;
                return x[0] = 9362 * n, x[0];
            }
        },
        {
            attrName: "aOverlap",
            symbolName: "textAllowOverlap",
            type: Uint8Array,
            width: 1,
            evaluate: (n)=>{
                let i = d(e.getZoom(), n) || 0, r = (p ? p(e.getZoom(), n) : t.textIgnorePlacement) || 0;
                return i = 1 << 3 + 4 * i, r = (p ? 2 : 0) + r, i + r;
            }
        },
        {
            attrName: "aOverlap",
            symbolName: "textIgnorePlacement",
            type: Uint8Array,
            width: 1,
            evaluate: (n)=>{
                let i = (d ? d(e.getZoom(), n) : t.textAllowOverlap) || 0, r = p(e.getZoom(), n) || 0;
                return i = (d ? 8 : 0) + 4 * i, r = 1 << 1 + r, i + r;
            }
        }
    ];
}
const $435bc7696844e930$var$Qi = [], $435bc7696844e930$var$er = [], $435bc7696844e930$var$tr = [], $435bc7696844e930$var$nr = [];
function $435bc7696844e930$var$ir(e, t, n, i, r, s, o) {
    e = 1 === e ? 1 : 0;
    const a = this.getMap(), l = t.geometry.properties, h = this.getSymbol(l.symbolIndex), c = "line" === l.textPlacement && !$435bc7696844e930$var$He(h), { aTextSize: u, aTextHalo: f, aShape: d } = l;
    let p = u ? u[n[r]] : h.textSize;
    null == p && (p = $435bc7696844e930$var$Gi.textSize);
    const g = f ? f[2 * n[r]] : t.properties.textHaloRadius, m = $435bc7696844e930$var$Bi($435bc7696844e930$var$tr, t, n[r]), { aProjectedAnchor: y } = t.geometry.properties;
    let x = $435bc7696844e930$var$nr;
    const _ = 3 * n[r];
    y && y[_] !== $435bc7696844e930$var$ge ? ($435bc7696844e930$var$nr[0] = y[_], $435bc7696844e930$var$nr[1] = y[_ + 1], $435bc7696844e930$var$nr[2] = y[_ + 2]) : x = $435bc7696844e930$var$Bt($435bc7696844e930$var$nr, m, o, a.width, a.height);
    const v = i, { boxes: b, collision: A } = this._getCollideBoxes(t, r);
    let T = 0;
    if (c || 1 === t.material.uniforms.textRotateWithMap || h.textRotation) {
        let i = 0;
        for(let s = r; s < r + 6 * v; s += 6){
            const r = b[T] = b[T] || [];
            T++;
            const l = $435bc7696844e930$var$Ui.call(this, r, m, x, t, p, g, n[s], o, a);
            if (!e) {
                const t = this.isCollides(l);
                1 === t ? e = 1 : -1 === t && i++;
            }
        }
        i === v && (e = -1);
    } else {
        let i = n[r], l = d[2 * i + 1];
        for(let h = r; h < s; h += 6){
            const r = d[2 * n[h] + 1];
            if (l !== r || h === s - 6) {
                const c = n[h === s - 6 ? h : h - 6], u = $435bc7696844e930$var$Ui.call(this, $435bc7696844e930$var$Qi, m, x, t, p, g, i, o, a), f = $435bc7696844e930$var$Ui.call(this, $435bc7696844e930$var$er, m, x, t, p, g, c, o, a), d = b[T] = b[T] || [];
                T++, d[0] = Math.min(u[0], f[0]), d[1] = Math.min(u[1], f[1]), d[2] = Math.max(u[2], f[2]), d[3] = Math.max(u[3], f[3]), i = n[h], l = r, !e && this.isCollides(d) && (e = 1);
            }
        }
    }
    return A.collides = e, A;
}
function $435bc7696844e930$var$rr(e, t) {
    const n = function(e, t) {
        const { aPickingId: n, features: i } = e.geometry.properties, r = n[t], s = i && i[r] && i[r].feature;
        return s && s.label;
    }(e, t);
    return n ? function(e, t, n) {
        if (!n) return null;
        const i = e.localTransform, r = $435bc7696844e930$var$Bi($435bc7696844e930$var$sr, e, t);
        (0, $jxhwV).set($435bc7696844e930$var$or, r[0], r[1], r[2], 1);
        const s = (0, $jxhwV).transformMat4($435bc7696844e930$var$or, $435bc7696844e930$var$or, i);
        let o = 0;
        for (const e of n)o += e.codePointAt(0);
        return [
            Math.floor(s[0]),
            Math.floor(s[1]),
            Math.floor(s[2]),
            o
        ];
    }(e, t, n) : null;
}
const $435bc7696844e930$var$sr = [], $435bc7696844e930$var$or = [];
const $435bc7696844e930$var$ar = 6, $435bc7696844e930$var$lr = 4, $435bc7696844e930$var$hr = new Uint16Array(1), $435bc7696844e930$var$cr = new Int8Array(1);
function $435bc7696844e930$var$ur(e, t, n, i, r, o, a, l, h) {
    if (t.isDisposed() || 0 === t.data.aPosition.length) return null;
    const c = !!t.properties.iconAtlas, u = !!t.properties.glyphAtlas;
    if (!c && !u && !t.properties.isEmpty) return null;
    //!geometry.properties.aShape 以避免重复创建collision数据
    if (!t.properties.aShape) {
        const { aPosition: e, aShape: n } = t.data, i = t.data.aPosition.length / t.desc.positionSize, r = new Uint8Array(i);
        l && r.fill(255, 0), t.data.aOpacity = {
            usage: "dynamic",
            data: r
        }, t.properties.aOpacity = new Uint8Array(i), l && t.properties.aOpacity.fill(255, 0), t.properties.aAnchor = e;
        const s = n.length / 4, o = new n.constructor(2 * s);
        for(let e = 0; e < s; e++)o[2 * e] = n[4 * e], o[2 * e + 1] = n[4 * e + 1];
        t.properties.aShape = o;
    }
    t.properties.visElemts || (t.properties.elements = t.elements, t.properties.visElemts = new t.elements.constructor(t.elements.length)), u && $435bc7696844e930$var$Xi.call(this, t, i, o.text, a, l, h), t.properties.memorySize = t.getMemorySize(), t.generateBuffers(e, {
        excludeElementsInVAO: !0
    });
    const f = {
        flipY: 0,
        tileResolution: t.properties.tileResolution,
        tileRatio: t.properties.tileRatio
    };
    $435bc7696844e930$var$dr.call(this, f, e, t, r), $435bc7696844e930$var$Yi.call(this, f, e, t, r), f.isHalo = 0;
    const d = [], p = {
        disableVAO: !0,
        transparent: !0,
        castShadow: !1,
        picking: !0
    };
    let g;
    if (u) {
        const e = $435bc7696844e930$var$we({}, f);
        e.isHalo = 1;
        const i = new (0, $2wazW).Material(e);
        g = new (0, $2wazW).Mesh(t, i, p), g.properties.isHalo = 1, g.setUniform("alphaTest", $435bc7696844e930$var$vi), g.setLocalTransform(n);
    }
    const m = new (0, $2wazW).Material(f), y = new (0, $2wazW).Mesh(t, m, p), x = {
        HAS_HALO_ATTR: 1
    };
    if (a && (x.ENABLE_COLLISION = 1), $435bc7696844e930$var$pr.call(this, t, x), g) {
        const e = $435bc7696844e930$var$we({}, x);
        $435bc7696844e930$var$Zi.call(this, x, g), g.setDefines(e);
    }
    return u && $435bc7696844e930$var$Zi.call(this, x, y), y.setDefines(x), y.setUniform("alphaTest", $435bc7696844e930$var$vi), y.setLocalTransform(n), y.properties.symbolIndex = t.properties.symbolIndex, d.push(y), d;
}
function $435bc7696844e930$var$fr(e) {
    const { aMarkerDx: t, aMarkerDy: n, aTextDx: i, aTextDy: r } = e.data, s = i || r || t || n;
    if (s) {
        const o = new s.constructor(4 * s.length);
        for(let e = 0; e < o.length; e += 4){
            const s = e / 4;
            t && (o[e] = t[s]), n && (o[e + 1] = n[s]), i && (o[e + 2] = i[s]), r && (o[e + 3] = r[s]);
        }
        e.data.aDxDy = o, e.properties.aDxDy = o.slice(), t && (e.properties.aMarkerDx = t), n && (e.properties.aMarkerDy = n), i && (e.properties.aTextDx = i), r && (e.properties.aTextDy = r);
    }
}
function $435bc7696844e930$var$dr(e, t, n, i) {
    const [r, s] = $435bc7696844e930$var$vn(n);
    $435bc7696844e930$var$ke(e, "markerOpacity", i, "markerOpacity", 1), $435bc7696844e930$var$ke(e, "markerPerspectiveRatio", i, "markerPerspectiveRatio", i.markerTextFit ? 0 : 1), $435bc7696844e930$var$ke(e, "markerWidth", i, "markerWidth", r || $435bc7696844e930$var$mi), $435bc7696844e930$var$ke(e, "markerHeight", i, "markerHeight", s || $435bc7696844e930$var$yi), $435bc7696844e930$var$ke(e, "markerDx", i, "markerDx", 0), $435bc7696844e930$var$ke(e, "markerDy", i, "markerDy", 0), $435bc7696844e930$var$ke(e, "markerRotation", i, "markerRotation", 0, (e)=>e * Math.PI / 180), $435bc7696844e930$var$ke(e, "markerPitchWithMap", i, "markerPitchAlignment", 0, (e)=>"map" === e ? 1 : 0), $435bc7696844e930$var$ke(e, "markerRotateWithMap", i, "markerRotationAlignment", 0, (e)=>"map" === e ? 1 : 0);
    const o = n.properties.iconAtlas;
    e.iconTex = o ? $435bc7696844e930$var$yn(t, o, !1) : this._emptyTexture, e.iconTexSize = o ? [
        o.width,
        o.height
    ] : [
        0,
        0
    ];
}
function $435bc7696844e930$var$pr(e, t) {
    e.data.aMarkerWidth && (t.HAS_MARKER_WIDTH = 1), e.data.aMarkerHeight && (t.HAS_MARKER_HEIGHT = 1), e.data.aColorOpacity && (t.HAS_OPACITY = 1);
    const n = this.getSymbolDef(e.properties.symbolIndex);
    $435bc7696844e930$var$Lt(n.markerDx) && (t.HAS_MARKER_DX = 1), $435bc7696844e930$var$Lt(n.markerDy) && (t.HAS_MARKER_DY = 1), $435bc7696844e930$var$Lt(n.textDx) && (t.HAS_TEXT_DX = 1), $435bc7696844e930$var$Lt(n.textDy) && (t.HAS_TEXT_DY = 1), $435bc7696844e930$var$Lt(n.markerPitchAlignment) && (t.HAS_MARKER_PITCH_ALIGN = 1), $435bc7696844e930$var$Lt(n.textPitchAlignment) && (t.HAS_TEXT_PITCH_ALIGN = 1), $435bc7696844e930$var$Lt(n.markerRotationAlignment) && (t.HAS_MARKER_ROTATION_ALIGN = 1), $435bc7696844e930$var$Lt(n.textRotationAlignment) && (t.HAS_TEXT_ROTATION_ALIGN = 1), $435bc7696844e930$var$Lt(n.markerRotation) && (t.HAS_MARKER_ROTATION = 1), $435bc7696844e930$var$Lt(n.textRotation) && (t.HAS_TEXT_ROTATION = 1), e.data.aPadOffset && (t.HAS_PAD_OFFSET = 1), e.data.aAltitude && (t.HAS_ALTITUDE = 1);
}
function $435bc7696844e930$var$gr(e, t, n, i) {
    $435bc7696844e930$var$wt(e, t, n, i), function(e) {
        const { aMarkerWidth: t, aMarkerHeight: n, aMarkerDx: i, aMarkerDy: r, aPitchAlign: s, aRotationAlign: o, aRotation: a, aOverlap: l } = e.data;
        if (t) {
            const n = ($435bc7696844e930$var$Tt + "aMarkerWidth").trim();
            e.properties.aMarkerWidth = e.properties[n] || new t.constructor(t);
        }
        if (n) {
            const t = ($435bc7696844e930$var$Tt + "aMarkerHeight").trim();
            e.properties.aMarkerHeight = e.properties[t] || new n.constructor(n);
        }
        if (i) {
            const t = ($435bc7696844e930$var$Tt + "aMarkerDx").trim();
            e.properties.aMarkerDx = e.properties[t] || new i.constructor(i);
        }
        if (r) {
            const t = ($435bc7696844e930$var$Tt + "aMarkerDy").trim();
            e.properties.aMarkerDy = e.properties[t] || new r.constructor(r);
        }
        if (s) {
            const t = ($435bc7696844e930$var$Tt + "aPitchAlign").trim();
            e.properties.aPitchAlign = e.properties[t] || new s.constructor(s);
        }
        if (o) {
            const t = ($435bc7696844e930$var$Tt + "aRotationAlign").trim();
            e.properties.aRotationAlign = e.properties[t] || new o.constructor(o);
        }
        if (a) {
            const t = ($435bc7696844e930$var$Tt + "aRotation").trim();
            e.properties.aRotation = e.properties[t] || new a.constructor(a);
        }
        if (l) {
            const t = ($435bc7696844e930$var$Tt + "aOverlap").trim();
            e.properties.aOverlap = e.properties[t] || new l.constructor(l);
        }
    }(e);
}
function $435bc7696844e930$var$mr(e, t) {
    const n = (0, $14507960c5dac0fb$export$b5e0f6446c9b8e3c)(t.markerWidth), i = (0, $14507960c5dac0fb$export$b5e0f6446c9b8e3c)(t.markerHeight), r = (0, $14507960c5dac0fb$export$b5e0f6446c9b8e3c)(t.markerDx), s = (0, $14507960c5dac0fb$export$b5e0f6446c9b8e3c)(t.markerDy), o = (0, $14507960c5dac0fb$export$b5e0f6446c9b8e3c)(t.markerOpacity), a = (0, $14507960c5dac0fb$export$b5e0f6446c9b8e3c)(t.markerTextFit), l = (0, $14507960c5dac0fb$export$79e978600dd1e509)(t.markerPitchAlignment), h = (0, $14507960c5dac0fb$export$79e978600dd1e509)(t.textPitchAlignment), c = (0, $14507960c5dac0fb$export$79e978600dd1e509)(t.markerRotationAlignment), u = (0, $14507960c5dac0fb$export$79e978600dd1e509)(t.textRotationAlignment), f = (0, $14507960c5dac0fb$export$b5e0f6446c9b8e3c)(t.markerRotation), d = (0, $14507960c5dac0fb$export$b5e0f6446c9b8e3c)(t.textRotation), p = (0, $14507960c5dac0fb$export$79e978600dd1e509)(t.markerAllowOverlapFn), g = (0, $14507960c5dac0fb$export$79e978600dd1e509)(t.markerIgnorePlacement), m = (0, $14507960c5dac0fb$export$b5e0f6446c9b8e3c)(t.textOpacity), y = (0, $14507960c5dac0fb$export$b5e0f6446c9b8e3c)(t.textDx), x = (0, $14507960c5dac0fb$export$b5e0f6446c9b8e3c)(t.textDy), A = new Int16Array(1), T = new Uint16Array(1);
    return [
        {
            attrName: "aMarkerWidth",
            symbolName: "markerWidth",
            type: Uint16Array,
            width: 1,
            define: "HAS_MARKER_WIDTH",
            evaluate: (i, r, s, o)=>{
                const l = s[o], h = t.markerTextFit, c = a ? a(e.getZoom(), i) : h;
                if ("both" === c || "width" === c) return l;
                let u = n(e.getZoom(), i);
                return (0, $14507960c5dac0fb$export$ec423ecbfcdb9a06)(u) && (u = this.evaluateInFnTypeConfig(u, r, e, i)), A[0] = u, A[0];
            }
        },
        {
            attrName: "aMarkerHeight",
            symbolName: "markerHeight",
            type: Uint16Array,
            width: 1,
            define: "HAS_MARKER_HEIGHT",
            evaluate: (n, r, s, o)=>{
                const l = s[o], h = t.markerTextFit, c = a ? a(e.getZoom(), n) : h;
                if ("both" === c || "height" === c) return l;
                let u = i(e.getZoom(), n);
                return (0, $14507960c5dac0fb$export$ec423ecbfcdb9a06)(u) && (u = this.evaluateInFnTypeConfig(u, r, e, n)), A[0] = u, A[0];
            }
        },
        {
            attrName: "aDxDy",
            symbolName: "markerDx",
            type: Int8Array,
            width: 4,
            index: 0,
            define: "HAS_MARKER_DX",
            evaluate: (t, n, i, s)=>{
                let o = r(e.getZoom(), t);
                (0, $14507960c5dac0fb$export$ec423ecbfcdb9a06)(o) && (o = this.evaluateInFnTypeConfig(o, n, e, t));
                const { aMarkerDx: a } = n.properties;
                return a && (a[s / 4] = o), A[0] = o, A[0];
            }
        },
        {
            attrName: "aDxDy",
            symbolName: "markerDy",
            type: Int8Array,
            width: 4,
            index: 1,
            define: "HAS_MARKER_DY",
            evaluate: (t, n, i, r)=>{
                let o = s(e.getZoom(), t);
                (0, $14507960c5dac0fb$export$ec423ecbfcdb9a06)(o) && (o = this.evaluateInFnTypeConfig(o, n, e, t));
                const { aMarkerDy: a } = n.properties;
                return a && (a[Math.floor(r / 4)] = o), A[0] = o, A[0];
            }
        },
        {
            attrName: "aDxDy",
            symbolName: "textDx",
            type: Int8Array,
            width: 4,
            index: 2,
            define: "HAS_TEXT_DX",
            evaluate: (t, n, i, r)=>{
                let s = y(e.getZoom(), t);
                (0, $14507960c5dac0fb$export$ec423ecbfcdb9a06)(s) && (s = this.evaluateInFnTypeConfig(s, n, e, t));
                const { aTextDx: o } = n.properties;
                return o && (o[Math.floor(r / 4)] = s), A[0] = s, A[0];
            }
        },
        {
            attrName: "aDxDy",
            symbolName: "textDy",
            type: Int8Array,
            width: 4,
            index: 3,
            define: "HAS_TEXT_DY",
            evaluate: (t, n, i, r)=>{
                let s = x(e.getZoom(), t);
                (0, $14507960c5dac0fb$export$ec423ecbfcdb9a06)(s) && (s = this.evaluateInFnTypeConfig(s, n, e, t));
                const { aTextDy: o } = n.properties;
                return o && (o[Math.floor(r / 4)] = s), A[0] = s, A[0];
            }
        },
        {
            attrName: "aColorOpacity",
            symbolName: "markerOpacity",
            type: Uint8Array,
            width: 2,
            index: 0,
            define: "HAS_OPACITY",
            evaluate: (t, n)=>{
                let i = 1;
                return o && (i = o(e.getZoom(), t), (0, $14507960c5dac0fb$export$ec423ecbfcdb9a06)(i) && (i = this.evaluateInFnTypeConfig(i, n, e, t))), A[0] = 255 * i, A[0];
            }
        },
        {
            attrName: "aColorOpacity",
            symbolName: "textOpacity",
            type: Uint8Array,
            width: 2,
            index: 1,
            define: "HAS_OPACITY",
            evaluate: (t, n)=>{
                let i = 1;
                return m && (i = m(e.getZoom(), t), (0, $14507960c5dac0fb$export$ec423ecbfcdb9a06)(i) && (i = this.evaluateInFnTypeConfig(i, n, e, t))), A[0] = 255 * i, A[0];
            }
        },
        {
            attrName: "aPitchAlign",
            symbolName: "markerPitchAlignment",
            type: Uint8Array,
            width: 2,
            index: 0,
            define: "HAS_PITCH_ALIGN",
            evaluate: (t)=>+("map" === l(e.getZoom(), t))
        },
        {
            attrName: "aPitchAlign",
            symbolName: "textPitchAlignment",
            type: Uint8Array,
            width: 2,
            index: 1,
            define: "HAS_PITCH_ALIGN",
            evaluate: (t)=>+("map" === h(e.getZoom(), t))
        },
        {
            attrName: "aRotationAlign",
            symbolName: "markerRotationAlignment",
            type: Uint8Array,
            width: 2,
            index: 0,
            define: "HAS_MARKER_ROTATION_ALIGN",
            evaluate: (t)=>+("map" === c(e.getZoom(), t))
        },
        {
            attrName: "aRotationAlign",
            symbolName: "textRotationAlignment",
            type: Uint8Array,
            width: 2,
            index: 1,
            define: "HAS_TEXT_ROTATION_ALIGN",
            evaluate: (t)=>+("map" === u(e.getZoom(), t))
        },
        {
            attrName: "aRotation",
            symbolName: "markerRotation",
            type: Uint16Array,
            width: 2,
            index: 0,
            define: "HAS_MARKER_ROTATION",
            evaluate: (t)=>{
                const n = $435bc7696844e930$var$Pe(f(e.getZoom(), t), 0, 360) * Math.PI / 180;
                return T[0] = 9362 * n, T[0];
            }
        },
        {
            attrName: "aRotation",
            symbolName: "textRotation",
            type: Uint16Array,
            width: 2,
            index: 1,
            define: "HAS_TEXT_ROTATION",
            evaluate: (t)=>{
                const n = $435bc7696844e930$var$Pe(d(e.getZoom(), t), 0, 360) * Math.PI / 180;
                return T[0] = 9362 * n, T[0];
            }
        },
        {
            attrName: "aOverlap",
            symbolName: "markerAllowOverlap",
            type: Uint8Array,
            width: 1,
            evaluate: (n)=>{
                let i = p(e.getZoom(), n) || 0, r = (g ? g(e.getZoom(), n) : t.markerIgnorePlacement) || 0;
                return i = 1 << 3 + 4 * i, r = (g ? 2 : 0) + r, i + r;
            }
        },
        {
            attrName: "aOverlap",
            symbolName: "markerIgnorePlacement",
            type: Uint8Array,
            width: 1,
            evaluate: (n)=>{
                let i = (p ? p(e.getZoom(), n) : t.markerAllowOverlap) || 0, r = g(e.getZoom(), n) || 0;
                return i = (p ? 8 : 0) + 4 * i, r = 2 + r, i + r;
            }
        }
    ];
}
function $435bc7696844e930$var$yr(e, t, n) {
    if (!t || !n || "none" === n) return;
    const { iconAtlas: i, glyphAtlas: r } = t.properties;
    if (!i || !r) return;
    !function(e) {
        if (e.properties.iconElements) return;
        const t = [], n = [], i = e.elements, r = e.properties.aType;
        for(let e = 0; e < i.length; e++){
            const s = i[e];
            0 === r[s] ? t.push(s) : n.push(s);
        }
        e.properties.iconElements = new i.constructor(t), e.properties.textElements = new i.constructor(n);
    }(t);
    const s = function(e, t) {
        let n = e.properties.textFitFn;
        (0, $14507960c5dac0fb$export$ec423ecbfcdb9a06)(t) && (n = e.properties.textFitFn = (0, $14507960c5dac0fb$export$79e978600dd1e509)(t));
        const i = "none" !== t, r = [], s = e.properties.iconElements, o = e.data.aPickingId, a = e.properties.textElements, l = e.data.aPickingId, h = e.properties.aCount, c = e.properties.features;
        let u, f = a[0];
        u = {
            pickingId: l[f],
            start: 0,
            end: h[f] * $435bc7696844e930$var$ar
        };
        let d = !1, p = !1, g = 0;
        const m = new Set;
        for(let e = 0; e < s.length; e += $435bc7696844e930$var$ar){
            const f = o[s[e]];
            if (!d && u) for(; u.pickingId < f && u.end < a.length;){
                const e = u.end, t = a[e];
                u.start = e, u.end = e + h[t] * $435bc7696844e930$var$ar, u.pickingId = l[t];
            }
            if (!d && u && u.pickingId < f && (d = !0, !i)) {
                if (!p) return [];
                for(let t = e; t < s.length; t += $435bc7696844e930$var$ar)r[g++] = [
                    -1,
                    -1
                ];
                return r;
            }
            const y = c[f] && c[f].feature, x = y && y.properties || {}, _ = n ? n(null, x) : t;
            if (u && f === u.pickingId) {
                r[g++] = [
                    u.start,
                    u.end
                ];
                const e = u.end, t = a[e];
                u.start = e, u.end = e + h[t] * $435bc7696844e930$var$ar, u.pickingId = l[t], p = !0;
            } else if (_ && "none" !== _) for(let t = e; t < e + $435bc7696844e930$var$ar; t++)m.add(t);
            else r[g++] = [
                -1,
                -1
            ];
        }
        if (m.size) {
            if (m.size === s.length) e.setElements([]);
            else {
                const t = [];
                for(let e = 0; e < s.length; e++)m.has(e) || t.push(s[e]);
                e.setElements(new s.constructor(t));
            }
        }
        if (!p) return [];
        return r;
    }(t, n);
    if (!t.getElements().length) return;
    if (!s.length) return;
    t.properties.labelIndex = s;
    if (s.length && n && "none" !== n) {
        const n = function(e) {
            const t = [], n = e.properties.labelIndex, { aShape: i } = e.data;
            let r = !1;
            for(let s = 0; s < n.length; s++){
                const [o, a] = n[s];
                if (-1 === o) t.push(0, 0, 0, 0);
                else {
                    r = !0;
                    let n = 1 / 0, s = 1 / 0, l = -1 / 0, h = -1 / 0;
                    const c = e.properties.textElements;
                    for(let e = o; e < a; e++){
                        const t = c[e], r = i[4 * t], o = i[4 * t + 1];
                        r < n && (n = r), r > l && (l = r), o < s && (s = o), o > h && (h = o);
                    }
                    t.push(n, s, l, h);
                }
            }
            if (!r) return [];
            return t;
        }(t);
        n.length && (t.properties.labelShape = n, $435bc7696844e930$var$xr.call(this, e, t));
    }
}
function $435bc7696844e930$var$xr(e, t) {
    const n = this.getSymbolDef(t.properties.symbolIndex), i = n.markerTextFit, r = t.properties;
    let s = "both" === i || "width" === i, o = "both" === i || "height" === i;
    if ((0, $14507960c5dac0fb$export$ec423ecbfcdb9a06)(n.markerTextFit)) {
        let e = t.properties.textFitFn;
        e || (e = t.properties.textFitFn = (0, $14507960c5dac0fb$export$b5e0f6446c9b8e3c)(n.markerTextFit));
        const { features: i } = t.properties, a = t.properties.iconElements, { aPickingId: l } = t.data, h = [], c = [];
        let u = !0;
        for(let t = 0; t < a.length; t += $435bc7696844e930$var$ar){
            const n = i[l[a[t]]], r = (n && n.feature || {}).properties || {};
            let s = e(null, r);
            if ((0, $14507960c5dac0fb$export$ec423ecbfcdb9a06)(s)) s = (r.textFitFn = r.textFitFn || (0, $14507960c5dac0fb$export$b5e0f6446c9b8e3c)(s))(null, r);
            "both" === s ? (h.push(t / $435bc7696844e930$var$ar), c.push(t / $435bc7696844e930$var$ar)) : "width" === s ? (u = !1, h.push(t / $435bc7696844e930$var$ar)) : "height" === s && (u = !1, c.push(t / $435bc7696844e930$var$ar));
        }
        u ? (r.fitIcons = h, s = !0, o = !0) : (h.length && (r.fitWidthIcons = h, s = !0), c.length && (r.fitHeightIcons = c, o = !0));
    }
    r.aPickingId || (r.aPickingId = new t.data.aPickingId.constructor(t.data.aPickingId));
    const { aMarkerWidth: a, aMarkerHeight: l, aPickingId: h } = r, c = h.length;
    if (s) {
        if (a) {
            const e = t.data.aMarkerWidth;
            t.data.aMarkerWidth = new Uint16Array(e), r.aMarkerWidth = new Uint16Array(e);
            const n = ($435bc7696844e930$var$Tt + "aMarkerWidth").trim();
            r[n] && (r[n] = r.aMarkerWidth);
        } else {
            const e = this.getSymbol(t.properties.symbolIndex).markerWidth || 0;
            r.aMarkerWidth = new Uint16Array(c), r.aMarkerWidth.fill(e), e && (r.aMarkerWidth.dirty = !0), t.data.aMarkerWidth = new Uint16Array(c);
        }
    }
    if (o) {
        if (l) {
            const e = t.data.aMarkerHeight;
            t.data.aMarkerHeight = new Uint16Array(e), r.aMarkerHeight = new Uint16Array(e);
            const n = ($435bc7696844e930$var$Tt + "aMarkerHeight").trim();
            r[n] && (r[n] = r.aMarkerHeight);
        } else {
            const e = this.getSymbol(t.properties.symbolIndex).markerHeight || 0;
            r.aMarkerHeight = new Uint16Array(c), r.aMarkerHeight.fill(e), e && (r.aMarkerHeight.dirty = !0), t.data.aMarkerHeight = new Uint16Array(c);
        }
    }
    const u = this.getSymbolDef(t.properties.symbolIndex), f = (0, $14507960c5dac0fb$export$b5e0f6446c9b8e3c)(u.textSize);
    $435bc7696844e930$var$vr.call(this, e, t), (!(0, $14507960c5dac0fb$export$ec423ecbfcdb9a06)(u.textSize) || f.isZoomConstant && f.isFeatureConstant) && (r.isFitConstant = !0);
}
const $435bc7696844e930$var$_r = [
    0,
    0,
    0,
    0
];
function $435bc7696844e930$var$vr(e, t) {
    const n = t.properties;
    if (!n.glyphAtlas || !n.textElements || !n.textElements.length) return;
    const i = t.properties;
    if (i.isFitConstant || !i.labelShape || !i.labelShape.length) return;
    const r = this.getSymbolDef(t.properties.symbolIndex), s = r.textSize;
    let o;
    (0, $14507960c5dac0fb$export$ec423ecbfcdb9a06)(s) && (o = n._textSizeFn ? n._textSizeFn : n._textSizeFn = (0, $14507960c5dac0fb$export$b5e0f6446c9b8e3c)(s));
    const a = r.markerTextFitPadding || $435bc7696844e930$var$_r;
    let l;
    (0, $14507960c5dac0fb$export$ec423ecbfcdb9a06)(a) && (l = i._paddingFn ? i._paddingFn : i._paddingFn = (0, $14507960c5dac0fb$export$79e978600dd1e509)(a));
    const h = e.getZoom(), { fitIcons: c, fitWidthIcons: u, fitHeightIcons: f } = i, { aMarkerWidth: d, aMarkerHeight: p, labelShape: g } = i, m = t.properties.iconElements, { features: y, aPickingId: x } = i, A = (e, t, n, r)=>{
        const c = g[4 * t], u = g[4 * t + 1], f = g[4 * t + 2], m = g[4 * t + 3];
        if (!(c || u || f || m)) return;
        const A = x[e], T = y[A] && y[A].feature, S = T && T.properties || {};
        let w = o ? o(h, S) : s;
        if ((0, $14507960c5dac0fb$export$ec423ecbfcdb9a06)(w)) w = (S.textSizeFn = S.textSizeFn || (0, $14507960c5dac0fb$export$b5e0f6446c9b8e3c)(w))(h, S);
        w /= $435bc7696844e930$var$_i;
        let M, P = l && l(h, S) || a;
        if ((0, $14507960c5dac0fb$export$ec423ecbfcdb9a06)(P)) P = (S.fitPaddingFn = S.fitPaddingFn || (0, $14507960c5dac0fb$export$79e978600dd1e509)(P))(h, S);
        if (P = P || $435bc7696844e930$var$_r, P[0] === P[2] && P[1] === P[3] || (M = i.aPadOffset, M || (M = i.aPadOffset = new Int8Array(2 * d.length))), d && n) {
            const t = Math.abs((f - c) / 10 * w) + (P[1] + P[3] || 0);
            if ($435bc7696844e930$var$hr[0] = t, d[e] !== $435bc7696844e930$var$hr[0] && ($435bc7696844e930$var$De(d, $435bc7696844e930$var$hr[0], e, e + $435bc7696844e930$var$lr), d.dirty = !0), M) {
                const t = (P[1] + P[3]) / 2 - P[3];
                if ($435bc7696844e930$var$cr[0] = t, M[2 * e] !== $435bc7696844e930$var$cr[0]) {
                    for(let n = e; n < e + $435bc7696844e930$var$lr; n++)M[2 * n] = t;
                    M.dirty = !0;
                }
            }
        }
        if (p && r) {
            const t = Math.abs((m - u) / 10 * w) + (P[0] + P[2] || 0);
            if ($435bc7696844e930$var$hr[0] = t, p[e] !== $435bc7696844e930$var$hr[0] && ($435bc7696844e930$var$De(p, $435bc7696844e930$var$hr[0], e, e + $435bc7696844e930$var$lr), p.dirty = !0), M) {
                const t = P[0] - (P[0] + P[2]) / 2;
                if ($435bc7696844e930$var$cr[0] = t, M[2 * e + 1] !== $435bc7696844e930$var$cr[0]) {
                    for(let n = e; n < e + $435bc7696844e930$var$lr; n++)M[2 * n + 1] = t;
                    M.dirty = !0;
                }
            }
        }
    };
    if (c || u || f) {
        if (c) for(let e = 0; e < c.length; e++){
            const t = c[e];
            A(m[t * $435bc7696844e930$var$ar], t, !0, !0);
        }
        else if (u || f) {
            if (u) for(let e = 0; e < u.length; e++){
                const t = u[e];
                A(m[t * $435bc7696844e930$var$ar], t, !0, !1);
            }
            if (f) for(let e = 0; e < f.length; e++){
                const t = f[e];
                A(m[t * $435bc7696844e930$var$ar], t, !1, !0);
            }
        }
    } else for(let e = 0; e < m.length; e += $435bc7696844e930$var$ar){
        const t = e / $435bc7696844e930$var$ar;
        A(m[e], t, !0, !0);
    }
    const { aPadOffset: T } = i;
    T && (t.data.aPadOffset = T);
}
const { FilterUtil: $435bc7696844e930$var$br } = $435bc7696844e930$var$H(), $435bc7696844e930$var$Ar = [], $435bc7696844e930$var$Tr = {
    collides: -1
}, $435bc7696844e930$var$Sr = [
    $435bc7696844e930$var$xi,
    $435bc7696844e930$var$xi
], $435bc7696844e930$var$wr = (0, $3iqbd).identity([]), $435bc7696844e930$var$Mr = [];
class $435bc7696844e930$export$eb2cc705f4de3b75 extends $435bc7696844e930$var$ti {
    static getBloomSymbol() {
        return [
            "markerBloom",
            "textBloom"
        ];
    }
    constructor(e, t, n, i, r, s){
        super(e, t, n, i, r, s), this.propAllowOverlap = "markerAllowOverlap", this.propIgnorePlacement = "markerIgnorePlacement", this._fnTypeConfigs = {}, this.isLabelCollides = $435bc7696844e930$var$ir.bind(this), this._meshesToCheck = [], this._emptyTexture = e.texture(2);
    }
    needToRefreshTerrainTileOnZooming() {
        for(let e = 0; e < this.symbolDef.length; e++){
            const t = this.symbolDef[e].markerPitchAlignment;
            if ("map" === t || (0, $14507960c5dac0fb$export$ec423ecbfcdb9a06)(t) || $435bc7696844e930$var$br.isExpression(t)) return !0;
        }
        return !1;
    }
    isTerrainVector() {
        return this.layer.options.awareOfTerrain && !this.needToRefreshTerrainTileOnZooming();
    }
    isTerrainSkin() {
        return super.isTerrainSkin() && this.needToRefreshTerrainTileOnZooming();
    }
    setShaderDefines(e) {
        this._shaderDefines = e;
    }
    createFnTypeConfig(e, t) {
        const n = $435bc7696844e930$var$mr.call(this, e, t), i = $435bc7696844e930$var$Ki.call(this, e, t);
        for(let e = i.length - 1; e >= 0; e--){
            const t = i[e].attrName;
            "aTextDx" !== t && "aTextDy" !== t && "aPitchAlign" !== t && "aRotation" !== t && "aRotationAlign" !== t && "aColorOpacity" !== t && "aOverlap" !== t || i.splice(e, 1);
        }
        const r = n.concat(i);
        return r.text = i, r.icon = n, r;
    }
    startFrame(...e) {
        return this._meshesToCheck.length = 0, super.startFrame(...e);
    }
    createGeometry(e, t) {
        return e && e.empty && (e.data = {
            aPosition: new Uint8Array(e.data.aPosition),
            aPickingId: e.data.aPickingId
        }), super.createGeometry(e, t);
    }
    postCreateGeometry(e) {
        const { geometry: t, symbolIndex: n } = e, i = this.getSymbolDef(n), r = this.getFnTypeConfig(n), { iconAtlas: s, glyphAtlas: o } = t.properties;
        if (s || o) {
            if (this._prepareRequiredProps(t), s && (this.drawDebugAtlas(s), $435bc7696844e930$var$gr(t, i, r.icon, this.layer)), o) {
                const e = i.markerTextFit;
                if (e) {
                    const n = this.getMap();
                    $435bc7696844e930$var$yr.call(this, n, t, e);
                }
            }
        } else t.properties.isEmpty = !0;
    }
    _prepareRequiredProps(e) {
        const { aCount: t, aShape: n } = e.data;
        e.properties.aCount = t, delete e.data.aCount;
        const i = n.length / 4, r = new Uint8Array(i), s = new Uint8Array(i);
        for(let e = 0; e < i; e++)r[e] = n[4 * e + 2] % 2, s[e] = n[4 * e + 3] % 2;
        e.properties.aType = r, e.properties.aHalo = s, $435bc7696844e930$var$fr.call(this, e);
    }
    prepareCollideIndex(e) {
        const { collideIds: t, elements: n, aCount: i, aType: r } = e.properties;
        if (!t) return;
        const s = {};
        if (!n) return void (e.properties.collideBoxIndex = s);
        let o = 0, a = n[0], l = 0, h = t[a], c = r[0], u = 1;
        i && (u = i[n[l]]);
        for(let e = 0; e <= n.length; e += $435bc7696844e930$var$ar)if (a = n[e], t[a] !== h || c !== r[a] || e === n.length) {
            s[h] || (s[h] = []);
            const f = e;
            let d = l;
            1 === c && (d = l + (f - l) / 2), s[h].push([
                d,
                f,
                (f - d) / (u * $435bc7696844e930$var$ar),
                o++,
                l
            ]), h = t[a], c = r[a], l = e, i && (u = i[n[l]]);
        }
        e.properties.collideBoxIndex = s;
    }
    createMesh(e, t) {
        const n = this.isEnableCollision(), i = this.layer, { geometry: r, symbolIndex: s } = e;
        r.properties.symbolIndex = s;
        const o = this.getSymbolDef(s), a = this.getSymbol(s), l = this.getFnTypeConfig(s), h = [], c = this.isEnableUniquePlacement(), u = $435bc7696844e930$var$ur.call(this, this.regl, r, t, o, a, l, i.options.collision, !n, c);
        if (u.length) {
            const e = this.getAltitudeOffsetMatrix();
            u[0].positionMatrix = e, u[1] && (u[1].positionMatrix = e), h.push(...u);
        }
        return "line" === r.properties.markerPlacement && (this._rebuildCollideIds(r), h.forEach((e)=>e.properties.isLinePlacement = !0)), this.prepareCollideIndex(r), h;
    }
    _rebuildCollideIds(t) {
        const n = this.layer instanceof $gP1US.TileLayer, { collideIds: i, glyphAtlas: r, iconAtlas: s } = t.properties, o = new Uint16Array(i.length), a = !!r;
        if (!!s) {
            const { collideIds: e, aType: i } = t.properties;
            if (r) {
                let t = 0, n = i[0], r = 0;
                for(let s = 1; s < e.length; s++)0 === i[s] && 1 === n && (o.fill(t++, r, s), r = s), n = i[s];
                r < e.length && o.fill(t++, r, e.length);
            } else {
                let t = 0;
                for(let n = 0; n < e.length; n += $435bc7696844e930$var$lr)o.fill(t++, n, n + $435bc7696844e930$var$lr);
            }
            t.properties.collideIds = o, t.properties.uniqueCollideIds = $435bc7696844e930$var$ze(o, !n);
        } else if (a) {
            const { collideIds: e, aCount: i } = t.properties;
            if (!i) return;
            let r = 0, s = i[0];
            for(let t = 0; t < e.length;){
                const n = t + s * $435bc7696844e930$var$lr;
                e.fill(r++, t, n), t += s * $435bc7696844e930$var$lr, n < e.length && (s = i[n]);
            }
            t.properties.uniqueCollideIds = $435bc7696844e930$var$ze(e, !n);
        }
    }
    addMesh(e) {
        if (this.isEnableCollision() && e.length > 0) {
            const t = new $435bc7696844e930$var$Xn(e);
            t.properties.uniqueCollideIds = e[0].geometry.properties.uniqueCollideIds, t.properties.meshKey = e[0].properties.meshKey, t.properties.level = e[0].properties.level, this._meshesToCheck.push(t);
        }
        for(let t = 0; t < e.length; t++){
            if (!this.isMeshIterable(e[t])) continue;
            const n = e[t].geometry, { symbolIndex: i } = n.properties;
            $435bc7696844e930$var$He(this.getSymbolDef(i)) && $435bc7696844e930$var$vr.call(this, this.getMap(), n);
        }
        const t = this.getMap().getZoom();
        for(let n = 0; n < e.length; n++){
            if (!this.isMeshIterable(e[n])) continue;
            const i = e[n].geometry, { symbolIndex: r } = i.properties, s = this.getSymbolDef(r), o = this.getFnTypeConfig(r);
            $435bc7696844e930$var$Ct(this.regl, this.layer, s, o, e[n], t);
            const { aMarkerWidth: a, aMarkerHeight: l, aPadOffset: h } = i.properties;
            a && a.dirty && (i.updateData("aMarkerWidth", a), a.dirty = !1), l && l.dirty && (i.updateData("aMarkerHeight", l), l.dirty = !1), h && h.dirty && (i.updateData("aPadOffset", h), h.dirty = !1);
        }
        super.addMesh(...arguments);
    }
    updateCollision(e) {
        if (!this.isEnableCollision()) return;
        super.updateCollision(e);
        const t = this.scene.getMeshes();
        t && t.length ? (this._updateIconCollision(e.timestamp), this._meshesToCheck = [], this._endCollision()) : this._endCollision();
    }
    isMeshIterable(e) {
        return e && e.geometry && !e.geometry.properties.isEmpty && e.material && this.isMeshVisible(e) && !(this.shouldIgnoreBackground() && !this.layer.getRenderer().isForeground(e));
    }
    _updateIconCollision() {
        if (!this.isEnableCollision()) return;
        let e = this._meshesToCheck;
        e && e.length && this._updateIconAndText(e);
    }
    _updateBox(e, t, n, i) {
        return this.updateBoxCollisionFading(!0, e, t, n, i);
    }
    isEnableUniquePlacement() {
        return this.isEnableCollision() && !0 === this.sceneConfig.uniquePlacement;
    }
    _updateIconAndText(e) {
        const t = this.layer.getRenderer();
        e = e.sort($435bc7696844e930$var$Ir);
        for(let n = 0; n < e.length; n++){
            const i = e[n];
            if (!i || !i.meshes.length) continue;
            let r = !1;
            if (1 === i.meshes.length) r = this.isMeshIterable(i.meshes[0]);
            else for(let e = 0; e < i.meshes.length; e++)if (this.isMeshIterable(i.meshes[e])) {
                r = !0;
                break;
            }
            if (!r) continue;
            const s = t.isForeground(i.meshes[0]);
            if (this.shouldIgnoreBackground() && !s) continue;
            const o = i.properties.meshKey;
            this.startMeshCollision(i), this._startCheckMesh(i), this.forEachBox(i, this._updateBox), this._endCheckMesh(i), this.endMeshCollision(o);
            for(let e = 0; e < i.meshes.length; e++)this._updateOpacity(i.meshes[e]);
        }
    }
    _updateOpacity(e) {
        const t = e && e.geometry && e.geometry.properties.aOpacity;
        t && t.dirty && (e.geometry.updateData("aOpacity", t), t.dirty = !1);
    }
    forEachBox(e, t) {
        const n = e.properties.uniqueCollideIds;
        if (!n) return;
        const i = {
            boxIndex: 0
        }, r = n.length;
        for(let s = 0; s < r; s++)this._iterateMeshBox(e, n[s], t, i);
    }
    _iterateMeshBox(e, t, n, i) {
        const r = this.getMap(), { collideBoxIndex: s } = e.meshes[0].geometry.properties, o = s && s[t];
        if (!o || !o.length) return !1;
        const l = (0, $3iqbd).multiply($435bc7696844e930$var$Ar, r.projViewMatrix, e.meshes[0].localTransform);
        let h, c = !1;
        const u = e.meshes;
        let f = 0;
        for(let e = 0; e < u.length; e++){
            if (!this.isMeshIterable(u[e])) continue;
            const { collideBoxIndex: n } = u[e].geometry.properties, i = n[t];
            i && (f += i.length);
        }
        if (!f) return !1;
        h = this._getMeshBoxes(f);
        let d = 0;
        for(let e = 0; e < u.length; e++){
            const n = u[e];
            if (!this.isMeshIterable(n)) continue;
            c = !0;
            const i = n.geometry.properties, { elements: r, aCount: s, collideBoxIndex: o } = i, a = o[t];
            if (a) for(let e = 0; e < a.length; e++){
                const [t, o, l] = a[e];
                let c = 1;
                s && (c = s[r[t]]);
                const u = t + 0 * c * $435bc7696844e930$var$ar;
                h[d].mesh = n, h[d].start = u, h[d].end = o, h[d].boxStart = a[e][4], h[d].boxCount = i.glyphAtlas ? c : l, h[d].allElements = r, d++;
            }
        }
        if (!c) return !1;
        return n.call(this, e, h, l, i.boxIndex++) && this._markerVisible(e, t), !0;
    }
    _startCheckMesh(e) {
        const t = e.meshes;
        for(let e = 0; e < t.length; e++){
            const n = t[e], i = n && n.geometry;
            i && (i.properties.visElemts.count = 0);
        }
    }
    _markerVisible(e, t) {
        const n = e.meshes;
        for(let e = 0; e < n.length; e++){
            const i = n[e], r = i && i.geometry;
            if (!r || r.properties.isEmpty) continue;
            const { collideBoxIndex: s, elements: o, visElemts: a } = r.properties, l = s[t];
            if (l && l.length) for(let e = 0; e < l.length; e++){
                const t = l[e][4], n = l[e][1];
                let i = a.count;
                for(let e = t; e < n; e++)a[i++] = o[e];
                a.count = i;
            }
        }
    }
    _endCheckMesh(e) {
        const t = e.meshes;
        for(let e = 0; e < t.length; e++){
            const n = t[e], i = n && n.geometry;
            if (!i) continue;
            const { visElemts: r } = i.properties;
            i.setElements(r, r.count);
        }
    }
    isBoxCollides(e, t, n, i, r, s) {
        if (this._isTextGeo(e, t, i)) return $435bc7696844e930$var$ir.call(this, 0, e, t, n, i, r, s);
        if (e.geometry.properties.isEmpty) return $435bc7696844e930$var$Tr;
        const { aTerrainAltitude: o } = e.geometry.properties;
        if (o) {
            if (o[2 * t[i]] === $435bc7696844e930$var$me) return $435bc7696844e930$var$Tr;
        }
        const a = this.getMap(), { boxes: l, collision: h } = this._getCollideBoxes(e, i);
        let c = 0, u = 0, f = 0;
        for(let n = i; n < r; n += $435bc7696844e930$var$ar){
            const i = l[f] = l[f] || [];
            f++;
            const r = $435bc7696844e930$var$Fi.call(this, i, e, t[n], s, a);
            if (!c) {
                const e = this.isCollides(r);
                1 === e ? c = 1 : -1 === e && u++;
            }
        }
        return u === n && (c = -1), h.collides = c, h;
    }
    deleteMesh(e, t) {
        e && (e instanceof $435bc7696844e930$var$Xn && (e = e.meshes), t && (Array.isArray(e) ? e.forEach((e)=>{
            e && e.material && delete e.material.uniforms.iconTex;
        }) : e.material && delete e.material.uniforms.iconTex), super.deleteMesh(e, t));
    }
    isBloom(e) {
        const t = e && e.material && !$435bc7696844e930$var$Ie(e.material.get("markerOpacity")), n = this.getSymbol(e.properties.symbolIndex);
        return !!(t ? n.markerBloom : n.textBloom);
    }
    isUniqueStencilRefPerTile() {
        return !1;
    }
    init() {
        const e = this.regl, t = this.canvas;
        this.renderer = new (0, $2wazW).Renderer(e);
        const n = {
            viewport: {
                x: (e, t)=>t.viewport ? t.viewport.x : 0,
                y: (e, t)=>t.viewport ? t.viewport.y : 0,
                width: (e, n)=>n.viewport ? n.viewport.width : t ? t.width : 1,
                height: (e, n)=>n.viewport ? n.viewport.height : t ? t.height : 1
            },
            stencil: {
                enable: !0,
                func: {
                    cmp: "<=",
                    ref: (e, t)=>t.stencilRef
                },
                op: {
                    fail: "keep",
                    zfail: "keep",
                    zpass: "replace"
                }
            },
            blend: {
                enable: !0,
                func: this.getBlendFunc(),
                equation: "add"
            },
            depth: {
                enable: !0,
                range: ()=>this.sceneConfig.depthRange || [
                        0,
                        1
                    ],
                func: ()=>this.sceneConfig.depthFunc || "always",
                mask: !!$435bc7696844e930$var$Ie(this.sceneConfig.depthMask) || this.sceneConfig.depthMask
            },
            polygonOffset: {
                enable: !0,
                offset: this.getPolygonOffset()
            }
        }, i = this._shaderDefines || {};
        if (this.shader = new (0, $2wazW).MeshShader({
            vert: $435bc7696844e930$var$oi,
            frag: "#define SHADER_NAME MARKER\n#define HAS_HIGHLIGHT_COLOR_POINT 1\nprecision mediump float;\n#include <gl2_frag>\nuniform float alphaTest;\nuniform sampler2D iconTex;\nuniform lowp float markerOpacity;\nuniform lowp float blendSrcIsOne;\nuniform float layerOpacity;\n#include <highlight_frag>\nvarying vec2 vTexCoord;\nvarying float vOpacity;\nvarying float vIsText;\nvarying float vHalo;\n#include <text_render_frag>\nvoid main() {\n  vec4 c;\n  if(vIsText > .5) {\n    c = renderText(vTexCoord);\n  } else {\n    c = texture2D(iconTex, vTexCoord) * markerOpacity;\n  }\n  c = c * vOpacity * layerOpacity;\n  if(c.a < .05) {\n    discard;\n  }\n  glFragColor = c;\n  if(glFragColor.a < alphaTest) {\n    discard;\n  }\n  glFragColor = highlight_blendColor(glFragColor);\n#if __VERSION__ == 100\ngl_FragColor = glFragColor;\n#endif\n}",
            uniforms: [
                {
                    name: "projViewModelMatrix",
                    type: "function",
                    fn: function(e, t) {
                        return (0, $3iqbd).multiply([], t.projViewMatrix, t.modelMatrix);
                    }
                },
                {
                    name: "zoomScale",
                    type: "function",
                    fn: function(e, t) {
                        return t.tileResolution / t.resolution;
                    }
                }
            ],
            extraCommandProps: n,
            defines: i
        }), this.shader.version = 300, this.pickingFBO) {
            const e = new (0, $2wazW).FBORayPicking(this.renderer, {
                vert: "#define PICKING_MODE 1\n" + $435bc7696844e930$var$oi,
                uniforms: [
                    {
                        name: "projViewModelMatrix",
                        type: "function",
                        fn: function(e, t) {
                            return (0, $3iqbd).multiply([], t.projViewMatrix, t.modelMatrix);
                        }
                    },
                    {
                        name: "zoomScale",
                        type: "function",
                        fn: function(e, t) {
                            return t.tileResolution / t.resolution;
                        }
                    }
                ],
                extraCommandProps: n
            }, this.pickingFBO, this.getMap());
            this.picking = [
                e
            ];
        }
    }
    getUniformValues(t, n) {
        const i = n && n.isRenderingTerrainSkin, r = this.layer.getTileSize().width, s = i ? $435bc7696844e930$var$wr : t.projViewMatrix, o = t.cameraToCenterDistance, a = (0, $6BoVD).set($435bc7696844e930$var$Mr, t.width, t.height);
        i && (0, $6BoVD).set(a, r, r);
        const l = this.getBlendFunc(), h = $gP1US.Util.isFunction(l.src) ? l.src() : l.src;
        return {
            layerScale: this.layer.options.styleScale || 1,
            mapPitch: t.getPitch() * Math.PI / 180,
            mapRotation: t.getBearing() * Math.PI / 180,
            projViewMatrix: s,
            cameraToCenterDistance: o,
            canvasSize: a,
            iconSize: $435bc7696844e930$var$Sr,
            resolution: t.getResolution(),
            glyphSize: $435bc7696844e930$var$_i,
            gammaScale: 1,
            blendSrcIsOne: +!("one" !== h && 1 !== h),
            viewport: i && n && n.viewport,
            isRenderingTerrain: +!!i
        };
    }
    getUniqueEntryKey(e, t) {
        if (!this._isTextGeo(e.geometry)) return null;
        const { elements: n } = e.geometry.properties;
        return $435bc7696844e930$var$rr(e, n[t]);
    }
    _isTextGeo(e, t, n) {
        const { aType: i } = e.geometry.properties;
        return 1 === i[t[n]];
    }
    delete() {
        return this._emptyTexture && ((0, $2wazW).Util.isTextureDestroyed(this._emptyTexture) || this._emptyTexture.destroy(), this._emptyTexture = null), super.delete();
    }
}
function $435bc7696844e930$var$Ir(e, t) {
    return e.properties.level - t.properties.level || e.properties.meshKey - t.properties.meshKey;
}
const $435bc7696844e930$var$Cr = [], $435bc7696844e930$var$kr = [], $435bc7696844e930$var$Fr = [];
function $435bc7696844e930$var$Or(e, t, n, i, r, s, a, l, h, c, u, d, p) {
    const { aGlyphOffset: g, aSegment: m, aTextDx: y, aTextDy: x, symbolIndex: _ } = t.geometry.properties, v = this.getSymbol(_), b = y ? y[r] : v.textDx, A = x ? x[r] : v.textDy, T = (0, $6BoVD).set($435bc7696844e930$var$Fr, b || 0, A || 0), S = (0, $6BoVD).set($435bc7696844e930$var$Cr, g[2 * r], g[2 * r + 1]), w = (0, $eIStk).set($435bc7696844e930$var$kr, m[3 * r], m[3 * r + 1], m[3 * r + 2]), M = function(e, t, n, i, r, s, o, a, l, h, c, u, f, d, p, g, m, y) {
        p || (p = i);
        const x = t.geometry.properties.line, _ = s[0] * u, v = f ? _ - o : _ + o;
        let b = v > 0 ? 1 : -1, A = 0;
        f && (b *= -1, A = Math.PI), b < 0 && (A += Math.PI);
        const T = h + c, S = Math.abs(v);
        let w = b > 0 ? l : l + 1, M = $435bc7696844e930$var$Vt.convert(i), P = $435bc7696844e930$var$Vt.convert(i), I = $435bc7696844e930$var$Vt.convert(r), C = $435bc7696844e930$var$Vt.convert(r), k = 0, F = 0;
        for(; k + F <= S;){
            if (w += b, w < h || w >= T) return null;
            P.x = M.x, P.y = M.y, C.x = I.x, C.y = I.y, M.x = n[3 * w], M.y = n[3 * w + 1], I.x = x[3 * w], I.y = x[3 * w + 1], k += F, F = P.dist(M) / d;
        }
        const O = (S - k) / F, R = g && g.getRenderer(), E = R && R.getTerrainHelper(), D = t.properties.tile.terrainTileInfos;
        if (!y && E) {
            const { extent: n } = t.properties.tile, i = g.getTileSize().width / n, r = g.getMap();
            let s = I.sub(C).mult(O)._add(C);
            M = $435bc7696844e930$var$qt($435bc7696844e930$var$Gt, r, t, I, i, g, m, D), P = $435bc7696844e930$var$qt($435bc7696844e930$var$jt, r, t, C, i, g, m, D), s = $435bc7696844e930$var$qt($435bc7696844e930$var$Wt, r, t, s, i, g, m, D);
            const o = A + Math.atan2(M[1] - P[1], M[0] - P[0]);
            return e[0] = (s[0] - p[0]) / d, e[1] = (s[1] - p[1]) / d, e[2] = o, e;
        }
        const L = M.sub(P), H = L.mult(O)._add(P);
        H._add(L._unit()._perp()._mult(a * b));
        const N = A + Math.atan2(M.y - P.y, M.x - P.x);
        return e[0] = (H.x - i[0]) / d, e[1] = (H.y - i[1]) / d, e[2] = N, e;
    }(e, t, i, s, a, S, T[0], T[1], w[0], w[1], w[2], n / 24, h, l, c, u, d, p);
    return M;
}
const $435bc7696844e930$var$Rr = [], $435bc7696844e930$var$Er = [];
function $435bc7696844e930$var$Dr(e, t, n, i, r, s, a, l, h, c, u, d, p) {
    const { aVertical: g } = n.geometry.properties, m = g[s];
    let y, x, _ = $435bc7696844e930$var$Or.call(this, $435bc7696844e930$var$Rr, n, i, r, s, l, h, c, !1);
    if (!_) return null;
    if ((0, $eIStk).copy(e, _), _ = $435bc7696844e930$var$Or.call(this, $435bc7696844e930$var$Er, n, i, r, a, l, h, c, !1), p = Math.PI * p / 180, !_ || Math.abs(_[2]) > p) return null;
    if ((0, $eIStk).copy(t, _), d && ((0, $6BoVD).transformMat2($435bc7696844e930$var$Rr, $435bc7696844e930$var$Rr, d), (0, $6BoVD).transformMat2($435bc7696844e930$var$Er, $435bc7696844e930$var$Er, d)), m) {
        const e = Math.abs($435bc7696844e930$var$Er[1] - $435bc7696844e930$var$Rr[1]), t = Math.abs($435bc7696844e930$var$Er[0] - $435bc7696844e930$var$Rr[0]) * u;
        x = $435bc7696844e930$var$Rr[0] > $435bc7696844e930$var$Er[0] ? 1 : 0, e > t ? (y = 1, x = $435bc7696844e930$var$Rr[1] < $435bc7696844e930$var$Er[1] ? 0 : 1) : y = 0;
    } else y = 0, x = $435bc7696844e930$var$Rr[0] > $435bc7696844e930$var$Er[0] ? 1 : 0;
    return 2 * x + y;
}
var $435bc7696844e930$var$Lr = "#define SHADER_NAME TEXT_VERT\n#define RAD 0.0174532925\n#ifdef HAS_ALTITUDE\nattribute vec2 aPosition;\nattribute float aAltitude;\n#else\nattribute vec3 aPosition;\n#endif\nattribute vec4 aShape;\n#ifdef ENABLE_COLLISION\nattribute float aOpacity;\n#endif\n#ifdef HAS_OPACITY\nattribute float aColorOpacity;\n#endif\n#ifdef HAS_TEXT_SIZE\nattribute float aTextSize;\n#else\nuniform float textSize;\n#endif\n#ifdef HAS_TEXT_DX\nattribute float aTextDx;\n#else\nuniform float textDx;\n#endif\n#ifdef HAS_TEXT_DY\nattribute float aTextDy;\n#else\nuniform float textDy;\n#endif\n#if defined(HAS_PITCH_ALIGN)\nattribute float aPitchAlign;\n#else\nuniform float textPitchWithMap;\n#endif\n#if defined(HAS_TEXT_ROTATION_ALIGN)\nattribute float aRotationAlign;\n#else\nuniform float textRotateWithMap;\n#endif\nuniform float flipY;\n#if defined(HAS_TEXT_ROTATION)\nattribute float aRotation;\n#else\nuniform float textRotation;\n#endif\nuniform float cameraToCenterDistance;\nuniform mat4 positionMatrix;\nuniform mat4 projViewModelMatrix;\nuniform float textPerspectiveRatio;\nuniform vec2 glyphTexSize;\nuniform vec2 canvasSize;\nuniform float glyphSize;\nuniform float mapPitch;\nuniform float mapRotation;\nuniform float zoomScale;\nuniform float tileRatio;\nuniform float layerScale;\nuniform float isRenderingTerrain;\n#ifndef PICKING_MODE\nvarying vec2 vTexCoord;\nvarying float vGammaScale;\nvarying float vTextSize;\nvarying float vOpacity;\n#ifdef HAS_TEXT_FILL\nattribute vec4 aTextFill;\nvarying vec4 vTextFill;\n#endif\n#ifdef HAS_TEXT_HALO_FILL\nattribute vec4 aTextHaloFill;\nvarying vec4 vTextHaloFill;\n#endif\n#if defined(HAS_TEXT_HALO_RADIUS) || defined(HAS_TEXT_HALO_OPACITY)\nattribute vec2 aTextHalo;\nvarying vec2 vTextHalo;\n#endif\n#include <highlight_vert>\n#else\n#include <fbo_picking_vert>\n#endif\n#include <vt_position_vert>\nvoid main() {\n  vec3 c = unpackVTPosition();\n#ifdef HAS_TEXT_SIZE\nfloat d = aTextSize * layerScale;\n#else\nfloat d = textSize * layerScale;\n#endif\n#ifdef HAS_TEXT_DX\nfloat e = aTextDx;\n#else\nfloat e = textDx;\n#endif\n#ifdef HAS_TEXT_DY\nfloat f = aTextDy;\n#else\nfloat f = textDy;\n#endif\n#if defined(HAS_PITCH_ALIGN)\nfloat h = aPitchAlign;\n#else\nfloat h = textPitchWithMap;\n#endif\n#if defined(HAS_ROTATION_ALIGN)\nfloat i = aRotationAlign;\n#else\nfloat i = textRotateWithMap;\n#endif\ngl_Position = projViewModelMatrix * positionMatrix * vec4(c, 1.);\n  float j = gl_Position.w;\n  float k;\n  if(isRenderingTerrain == 1. && h == 1.) {\n    k = 1.;\n  } else {\n    float l = (1. - cameraToCenterDistance / j) * textPerspectiveRatio;\n    k = clamp(.5 + .5 * (1. - l), .0, 4.);\n  }\n#ifdef HAS_TEXT_ROTATION\nfloat m = -aRotation / 9362. - mapRotation * i;\n#else\nfloat m = -textRotation - mapRotation * i;\n#endif\nif(h == 1.) {\n    \n#ifdef REVERSE_MAP_ROTATION_ON_PITCH\nm += mapRotation;\n#else\nm -= mapRotation;\n#endif\n  }\n  float n = sin(m);\n  float o = cos(m);\n  mat2 u = mat2(o, -1. * n, n, o);\n  vec2 v = aShape.xy / 10.0;\n  if(h == 1. && flipY == .0) {\n    v = v * vec2(1., -1.);\n  }\n  vec2 A = aShape.zw;\n  v = u * (v / glyphSize * d);\n  float B;\n  if(isRenderingTerrain == 1.) {\n    B = 1.;\n  } else {\n    B = j / cameraToCenterDistance;\n  }\n  if(h == .0) {\n    vec2 C = v * 2. / canvasSize;\n    gl_Position.xy += C * k * j;\n  } else {\n    float D;\n    if(isRenderingTerrain == 1.) {\n      D = tileRatio / zoomScale;\n    } else {\n      D = tileRatio / zoomScale * B * k;\n    }\n    vec2 C = v;\n    gl_Position = projViewModelMatrix * positionMatrix * vec4(c + vec3(C, .0) * D, 1.);\n  }\n  gl_Position.xy += vec2(e, -f) * 2. / canvasSize * j;\n#ifndef PICKING_MODE\nif(h == .0) {\n    vGammaScale = mix(1., B, textPerspectiveRatio);\n  } else {\n    vGammaScale = B + mapPitch / 4.;\n  }\n  vTexCoord = A / glyphTexSize;\n  vGammaScale = clamp(vGammaScale, .0, 1.);\n  vTextSize = d;\n#ifdef ENABLE_COLLISION\nvOpacity = aOpacity / 255.;\n#else\nvOpacity = 1.;\n#endif\n#ifdef HAS_OPACITY\nvOpacity *= aColorOpacity / 255.;\n#endif\n#ifdef HAS_TEXT_FILL\nvTextFill = aTextFill / 255.;\n#endif\n#ifdef HAS_TEXT_HALO_FILL\nvTextHaloFill = aTextHaloFill / 255.;\n#endif\n#if defined(HAS_TEXT_HALO_RADIUS) || defined(HAS_TEXT_HALO_OPACITY)\nvTextHalo = aTextHalo;\n#endif\nhighlight_setVarying();\n#else\n#ifdef ENABLE_COLLISION\nbool E = aOpacity == 255.;\n#else\nbool E = true;\n#endif\nfbo_picking_setData(gl_Position.w, E);\n#endif\n}", $435bc7696844e930$var$Hr = "#define SHADER_NAME TEXT_LINE\n#ifdef HAS_ALTITUDE\nattribute vec2 aPosition;\nattribute float aAltitude;\n#else\nattribute vec3 aPosition;\n#endif\nattribute vec2 aTexCoord;\n#ifdef HAS_OFFSET_Z\nattribute vec3 aOffset;\nuniform float altitudeScale;\n#else\nattribute vec2 aOffset;\n#endif\n#ifdef ENABLE_COLLISION\nattribute float aOpacity;\n#endif\n#ifdef HAS_OPACITY\nattribute float aColorOpacity;\n#endif\n#ifdef HAS_TEXT_SIZE\nattribute float aTextSize;\n#else\nuniform float textSize;\n#endif\n#ifdef HAS_TEXT_DX\nattribute float aTextDx;\n#else\nuniform float textDx;\n#endif\n#ifdef HAS_TEXT_DY\nattribute float aTextDy;\n#else\nuniform float textDy;\n#endif\n#if defined(HAS_PITCH_ALIGN)\nattribute float aPitchAlign;\n#else\nuniform float textPitchWithMap;\n#endif\nuniform float zoomScale;\nuniform float cameraToCenterDistance;\nuniform mat4 projViewModelMatrix;\nuniform float textPerspectiveRatio;\nuniform float mapPitch;\nuniform vec2 glyphTexSize;\nuniform vec2 canvasSize;\nuniform float tileRatio;\nuniform float layerScale;\nuniform float isRenderingTerrain;\nuniform float textPitchFilter;\n#ifndef PICKING_MODE\nvarying vec2 vTexCoord;\nvarying float vGammaScale;\nvarying float vTextSize;\nvarying float vOpacity;\n#ifdef HAS_TEXT_FILL\nattribute vec4 aTextFill;\nvarying vec4 vTextFill;\n#endif\n#ifdef HAS_TEXT_HALO_FILL\nattribute vec4 aTextHaloFill;\nvarying vec4 vTextHaloFill;\n#endif\n#if defined(HAS_TEXT_HALO_RADIUS) || defined(HAS_TEXT_HALO_OPACITY)\nattribute vec2 aTextHalo;\nvarying vec2 vTextHalo;\n#endif\n#include <highlight_vert>\n#else\n#include <fbo_picking_vert>\n#endif\n#include <vt_position_vert>\nvoid main() {\n  vec3 c = unpackVTPosition();\n#ifdef HAS_TEXT_DX\nfloat d = aTextDx;\n#else\nfloat d = textDx;\n#endif\n#ifdef HAS_TEXT_DY\nfloat e = aTextDy;\n#else\nfloat e = textDy;\n#endif\n#ifdef HAS_TEXT_SIZE\nfloat f = aTextSize * layerScale;\n#else\nfloat f = textSize * layerScale;\n#endif\n#ifdef HAS_PITCH_ALIGN\nfloat h = aPitchAlign;\n#else\nfloat h = textPitchWithMap;\n#endif\ngl_Position = projViewModelMatrix * vec4(c, 1.);\n  float i = gl_Position.w;\n  float j = i / cameraToCenterDistance;\n  float k;\n  if(isRenderingTerrain == 1.) {\n    k = 1.;\n  } else {\n    float l = (1. - cameraToCenterDistance / i) * textPerspectiveRatio;\n    k = clamp(.5 + .5 * (1. - l), .0, 4.);\n  }\n#ifdef HAS_OFFSET_Z\nvec3 m = aOffset / 10.0;\n  m[2] /= altitudeScale;\n#else\nvec3 m = vec3(aOffset / 10.0, .0);\n#endif\nvec2 n = aTexCoord;\n  if(h == 1.) {\n    float o;\n    if(isRenderingTerrain == 1.) {\n      o = tileRatio;\n    } else {\n      o = tileRatio / zoomScale * j * k;\n    }\n    m.xy *= o;\n    gl_Position = projViewModelMatrix * vec4(c + m, 1.);\n  } else {\n    gl_Position.xy += m.xy * 2. / canvasSize * k * i;\n  }\n  gl_Position.xy += vec2(d, -e) * 2. / canvasSize * i;\n  if(textPitchFilter > .0) {\n    if(textPitchFilter == 1. && h == .0 || textPitchFilter == 2. && h == 1.) {\n      gl_Position = vec4(-9999., -9999., .0, 1.);\n    }\n  }\n#ifndef PICKING_MODE\nif(h == 1.) {\n    vGammaScale = j + mapPitch / 4.;\n  } else {\n    vGammaScale = mix(1., j, textPerspectiveRatio);\n  }\n  vGammaScale = clamp(vGammaScale, .0, 1.);\n  vTexCoord = n / glyphTexSize;\n  vTextSize = f;\n#ifdef ENABLE_COLLISION\nvOpacity = aOpacity / 255.;\n#else\nvOpacity = 1.;\n#endif\n#ifdef HAS_OPACITY\nvOpacity *= aColorOpacity / 255.;\n#endif\n#ifdef HAS_TEXT_FILL\nvTextFill = aTextFill / 255.;\n#endif\n#ifdef HAS_TEXT_HALO_FILL\nvTextHaloFill = aTextHaloFill / 255.;\n#endif\n#if defined(HAS_TEXT_HALO_RADIUS) || defined(HAS_TEXT_HALO_OPACITY)\nvTextHalo = aTextHalo;\n#endif\nhighlight_setVarying();\n#else\n#ifdef ENABLE_COLLISION\nbool u = aOpacity == 255.;\n#else\nbool u = true;\n#endif\nfbo_picking_setData(gl_Position.w, u);\n#endif\n}", $435bc7696844e930$var$Nr = "#define SHADER_NAME TEXT_FRAG\nprecision mediump float;\nuniform float layerOpacity;\nvarying vec2 vTexCoord;\nvarying float vOpacity;\nuniform float alphaTest;\n#include <text_render_frag>\n#include <highlight_frag>\nvoid main() {\n  gl_FragColor = renderText(vTexCoord) * vOpacity * layerOpacity;\n  if(gl_FragColor.a < alphaTest) {\n    discard;\n  }\n  gl_FragColor = highlight_blendColor(gl_FragColor);\n}";
const { TextUtil: $435bc7696844e930$var$zr, PackUtil: $435bc7696844e930$var$Vr, FilterUtil: $435bc7696844e930$var$Ur, TEXT_MAX_ANGLE: $435bc7696844e930$var$Br } = $435bc7696844e930$var$H(), $435bc7696844e930$var$Gr = function(e) {
    const t = this.layer.getRenderer();
    return !this._isHalo0(e) && t.isTileNearCamera(e) && "line" !== e.geometry.properties.textPlacement;
}, $435bc7696844e930$var$jr = function(e) {
    const t = this.layer.getRenderer();
    return !this._isHalo0(e) && !t.isForeground(e) && "line" !== e.geometry.properties.textPlacement;
}, $435bc7696844e930$var$Wr = function(e) {
    const t = this.layer.getRenderer();
    return !this._isHalo0(e) && t.isTileNearCamera(e) && "line" === e.geometry.properties.textPlacement;
}, $435bc7696844e930$var$Xr = function(e) {
    const t = this.layer.getRenderer(), n = e.properties.tile.z, i = t.getCurrentTileZoom();
    return !this._isHalo0(e) && !t.isForeground(e) && "line" === e.geometry.properties.textPlacement && n < i;
}, $435bc7696844e930$var$Yr = [
    0,
    0,
    3
], $435bc7696844e930$var$Zr = [], $435bc7696844e930$var$qr = [], $435bc7696844e930$var$$r = [], $435bc7696844e930$var$Jr = [], $435bc7696844e930$var$Kr = [], $435bc7696844e930$var$Qr = [], $435bc7696844e930$var$es = [], $435bc7696844e930$var$ts = [], $435bc7696844e930$var$ns = [
    1,
    -1
], $435bc7696844e930$var$is = new Int16Array(3), $435bc7696844e930$var$rs = [], $435bc7696844e930$var$ss = [], $435bc7696844e930$var$os = [], $435bc7696844e930$var$as = [], $435bc7696844e930$var$ls = [], $435bc7696844e930$var$hs = [], $435bc7696844e930$var$cs = [], $435bc7696844e930$var$us = {}, $435bc7696844e930$var$fs = {}, $435bc7696844e930$var$ds = {}, $435bc7696844e930$var$ps = [], $435bc7696844e930$var$gs = [], $435bc7696844e930$var$ms = (0, $3iqbd).identity([]), $435bc7696844e930$var$ys = [];
class $435bc7696844e930$export$ebaea115ca21d80b extends $435bc7696844e930$var$ti {
    static getBloomSymbol() {
        return [
            "textBloom"
        ];
    }
    constructor(e, t, n, i, r, s){
        super(e, t, n, i, r, s), this.propAllowOverlap = "textAllowOverlap", this.propIgnorePlacement = "textIgnorePlacement", this.colorCache = {}, this._filter0 = $435bc7696844e930$var$Gr.bind(this), this._filter1 = $435bc7696844e930$var$jr.bind(this), this._lineFilter0 = $435bc7696844e930$var$Wr.bind(this), this._lineFilter1 = $435bc7696844e930$var$Xr.bind(this), this.isLabelCollides = $435bc7696844e930$var$ir.bind(this), this._genTextNames();
    }
    prepareRender(...e) {
        super.prepareRender(...e);
        const t = this.scene.getMeshes();
        if (t && t.length) for(let e = 0; e < t.length; e++){
            if (t[e].properties.isHalo) continue;
            const { haloMesh: n } = t[e].properties;
            n.dirtyDefines && t[e].setDefines(n.defines);
        }
    }
    updateSymbol(...e) {
        this._tagTerrainVector = void 0, this._tagTerrainSkin = void 0;
        const t = super.updateSymbol(...e);
        return this._genTextNames(), t;
    }
    isTerrainVector() {
        if (!super.isTerrainSkin()) return !1;
        if (void 0 !== this._tagTerrainVector) return this._tagTerrainVector;
        for(let e = 0; e < this.symbolDef.length; e++){
            if ("map" !== this.symbolDef[e].textPitchAlignment) return this._tagTerrainVector = !0, !0;
        }
        return this._tagTerrainVector = !1, !1;
    }
    isTerrainSkin() {
        if (!super.isTerrainSkin()) return !1;
        if (void 0 !== this._tagTerrainSkin) return this._tagTerrainSkin;
        for(let e = 0; e < this.symbolDef.length; e++){
            const t = this.symbolDef[e].textPitchAlignment;
            if ("map" === t || (0, $14507960c5dac0fb$export$ec423ecbfcdb9a06)(t) || $435bc7696844e930$var$Ur.isExpression(t)) return this._tagTerrainSkin = !0, !0;
        }
        return this._tagTerrainSkin = !1, !1;
    }
    _genTextNames() {
        this._textNameFn = [];
        for(let e = 0; e < this.symbolDef.length; e++){
            const t = this.symbolDef[e];
            if ($435bc7696844e930$var$Ur.isExpression(t.textName)) {
                const n = $435bc7696844e930$var$Ur.createExpression(t.textName, "string");
                this._textNameFn[e] = (e, t)=>{
                    let i;
                    $435bc7696844e930$var$us.zoom = e, $435bc7696844e930$var$fs.properties = t;
                    try {
                        i = n.evaluateWithoutErrorHandling($435bc7696844e930$var$us, $435bc7696844e930$var$fs, $435bc7696844e930$var$ds, null, $435bc7696844e930$var$ps);
                    } catch (e) {
                        i = null;
                    }
                    return i;
                };
            } else (0, $14507960c5dac0fb$export$ec423ecbfcdb9a06)(t.textName) && (this._textNameFn[e] = (0, $14507960c5dac0fb$export$b5e0f6446c9b8e3c)(t.textName));
        }
    }
    shouldDeleteMeshOnUpdateSymbol(e) {
        if (!Array.isArray(e)) return (0 === e.textHaloRadius || 0 === this.symbolDef[0].textHaloRadius) && e.textHaloRadius !== this.symbolDef[0].textHaloRadius;
        for(let t = 0; t < e.length; t++)if (e[t] && (0 === e[t].textHaloRadius || 0 === this.symbolDef[t].textHaloRadius) && e[t].textHaloRadius !== this.symbolDef[t].textHaloRadius) return !0;
        return !1;
    }
    createFnTypeConfig(e, t) {
        return $435bc7696844e930$var$Ki(e, t);
    }
    isBloom(e) {
        return !!this.getSymbol(e.properties.symbolIndex)[$435bc7696844e930$export$ebaea115ca21d80b.getBloomSymbol()[0]];
    }
    createGeometry(e, t, n) {
        const i = e;
        if (!i.glyphAtlas) return null;
        const r = super.createGeometry(i, t);
        if (!r || !r.geometry) return null;
        const { geometry: s } = r;
        return s.properties.glyphAtlas && this.drawDebugAtlas(s.properties.glyphAtlas), s && i.lineVertex && (s.properties.line = i.lineVertex, s.properties.line.id = n), r;
    }
    createMesh(e, t, { tileVectorTransform: n }) {
        const i = this.isEnableCollision(), r = this.isEnableUniquePlacement(), { geometry: s, symbolIndex: o } = e;
        s.properties.symbolIndex = o;
        const a = this.getSymbol(o), l = this.getSymbolDef(o), h = this.getFnTypeConfig(o), c = $435bc7696844e930$var$ji.call(this, this.regl, s, t, l, a, h, this.layer.options.collision, !i, r);
        if (c.length) "line" === s.properties.textPlacement ? this._hasLineText = !0 : this._hasNormalText = !0;
        return c.forEach((e)=>{
            e.positionMatrix = this.getAltitudeOffsetMatrix(), e.properties.tileVectorTransform = n;
        }), c;
    }
    updateCollision(e) {
        super.updateCollision(e);
        const t = this.scene.getMeshes();
        t && t.length ? (this._projectedLinesCache = {}, this._updateLabels(e.timestamp), this._endCollision()) : this._endCollision();
    }
    callCurrentTileShader(e, t) {
        this.shader.filter = t.sceneFilter ? [
            this._filter0,
            t.sceneFilter
        ] : this._filter0, this.callRenderer(this.shader, e, t), this._shaderAlongLine.filter = t.sceneFilter ? [
            this._lineFilter0,
            t.sceneFilter
        ] : this._lineFilter0, this.callRenderer(this._shaderAlongLine, e, t);
    }
    callBackgroundTileShader(e, t) {
        this.shader.filter = t.sceneFilter ? [
            this._filter1,
            t.sceneFilter
        ] : this._filter1, this.callRenderer(this.shader, e, t), this._shaderAlongLine.filter = t.sceneFilter ? [
            this._lineFilter1,
            t.sceneFilter
        ] : this._lineFilter1, this.callRenderer(this._shaderAlongLine, e, t);
    }
    callRenderer(e, t, n) {
        n && n.isRenderingTerrain && (0, $14507960c5dac0fb$export$ec423ecbfcdb9a06)(this.symbolDef.textPitchAlignment) && (n.isRenderingTerrainSkin ? t.textPitchFilter = 1 : t.textPitchFilter = 2), super.callRenderer(e, t, n);
    }
    _updateLabels() {
        let e = this.scene.getMeshes();
        if (!e || !e.length) return;
        const t = -this.getMap().getBearing() * Math.PI / 180, n = (0, $iLdEy).fromRotation($435bc7696844e930$var$$r, t), i = (e, t, n, i)=>{
            const { start: r, end: s, mesh: o, allElements: a } = t[0];
            if (this.updateBoxCollisionFading(!0, o, t, n, i)) {
                let t = e.count;
                for(let n = r; n < s; n++)e[t++] = a[n];
                e.count = t;
            }
        }, r = this.isEnableCollision(), s = this.layer.getRenderer();
        e = e.sort($435bc7696844e930$var$vs);
        for(let t = 0; t < e.length; t++){
            const o = e[t];
            if (!this.isMeshIterable(o)) continue;
            if (!s.isTileNearCamera(o)) {
                const { visElemts: e } = o.geometry.properties;
                e && (e.count = 0), o.geometry.setElements(e, 0);
                continue;
            }
            const a = o.geometry, l = this.getSymbol(o.properties.symbolIndex);
            o.properties.textHaloRadius = $435bc7696844e930$var$Ie(l.textHaloRadius) ? $435bc7696844e930$var$Gi.textHaloRadius : l.textHaloRadius;
            const h = o.properties.meshKey;
            if ("line" === a.properties.textPlacement) {
                if (!a.properties.line) continue;
                r && this.startMeshCollision(o), this._updateLineLabel(o, n);
                const { aOffset: e, aOpacity: t } = a.properties;
                e.dirty && (a.updateData("aOffset", e), e.dirty = !1), t && t.dirty && (a.updateData("aOpacity", t), t.dirty = !1), r && this.endMeshCollision(h);
            } else if (r) {
                this.startMeshCollision(o);
                const { elements: e, aOpacity: t, visElemts: n } = a.properties;
                n.count = 0, this.forEachBox(o, (e, t, r, s, o)=>{
                    i(n, t, r, s);
                }), t && t.dirty && a.updateData("aOpacity", t);
                const r = n.count === e.length && a.count === e.length, s = !n.count && !a.count;
                r || s || a.setElements(n, n.count), this.endMeshCollision(h);
            }
        }
    }
    isMeshIterable(e) {
        return e.isValid() && e.material && !e.material.get("isHalo") && !(this.shouldIgnoreBackground() && !this.layer.getRenderer().isForeground(e));
    }
    isMeshUniquePlaced(e) {
        if (!this.isMeshIterable(e)) return !1;
        return "line" !== this.getSymbol(e.properties.symbolIndex).textPlacement;
    }
    getUniqueEntryKey(e, t) {
        return $435bc7696844e930$var$rr(e, t);
    }
    _updateLineLabel(e, t) {
        const n = this.getMap(), i = e.geometry, r = i.properties;
        let s = r.line;
        if (!s) return;
        const o = n.getPitch(), l = n.getBearing(), { lineTextPitch: h, lineTextBearing: c } = e.properties, u = 1 === e.material.uniforms.textPitchWithMap, f = r.elements;
        if (!u) {
            const t = (0, $3iqbd).multiply($435bc7696844e930$var$Zr, n.projViewMatrix, e.localTransform), i = s.id + "-" + t.join();
            let o;
            this._projectedLinesCache[i] ? s = this._projectedLinesCache[i] : (o = r.projectedLine = r.projectedLine || new Array(s.length), s = this._projectLine(o, s, t, n.width, n.height), this._projectedLinesCache[i] = o);
        }
        const d = this.isEnableCollision(), p = i.properties.visElemts = i.properties.visElemts || new f.constructor(f.length), g = i.properties.visCache = i.properties.visCache || [];
        d && (p.count = 0);
        const m = void 0 === h || !n.isInteracting() || Math.abs(o - h) > 2 || Math.abs(l - c) > 2;
        m && (this._meshCollisionStale = !0), this.forEachBox(e, (e, n, i, r)=>{
            const { start: o, end: a } = n[0];
            let l = g[r];
            if ((void 0 === l || m) && (l = this._updateLabelAttributes(e, f, o, a, s, i, u ? t : null, r)), g[r] = l, d && (l = this.updateBoxCollisionFading(l, e, n, i, r), l)) {
                let e = p.count;
                for(let t = o; t < a; t++)p[e++] = f[t];
                p.count = e;
            }
        }), m && (e.properties.lineTextPitch = o, e.properties.lineTextBearing = l);
        const y = e.geometry.properties.aAltitude;
        y && y.dirty && (i.updateData("aAltitude", y), y.dirty = !1), !d || p.count === f.length && i.count === p.count || i.setElements(p, p.count);
    }
    _projectLine(e, t, n, i, r) {
        const s = function(e, t, n, i, r) {
            for(let s = 0; s < t.length; s += 3)(0, $jxhwV).set($435bc7696844e930$var$Ut, t[s], t[s + 1], t[s + 2], 1), $435bc7696844e930$var$Bt($435bc7696844e930$var$Ut, $435bc7696844e930$var$Ut, n, i, r), e[s] = $435bc7696844e930$var$Ut[0], e[s + 1] = $435bc7696844e930$var$Ut[1], e[s + 2] = t[s + 2];
            return e;
        }(e, t, n, i, r);
        return s;
    }
    forEachBox(e, t) {
        const n = this.getMap(), i = (0, $3iqbd).multiply($435bc7696844e930$var$Zr, n.projViewMatrix, e.properties.tileVectorTransform), { collideIds: r, aCount: s, features: o, elements: l } = e.geometry.properties;
        if (!r) return;
        const h = this.isEnableUniquePlacement(), c = this._getMeshBoxes(1);
        c[0].allElements = l, c[0].mesh = e;
        let u = 0, f = l[0], d = 0, p = r[f];
        for(let n = 0; n <= l.length; n += 6)if (f = l[n], r[f] !== p || n === l.length) {
            const a = o[p] && o[p].feature;
            if (h && this.isMeshUniquePlaced(e) && a && !a.label) {
                const t = a.properties || {}, { symbolIndex: n } = e.properties, i = n && this._textNameFn[n.index] ? this._textNameFn[n.index](e.properties.z, t) : this.getSymbol(e.properties.symbolIndex).textName, r = $435bc7696844e930$var$zr.resolveText(i, t);
                a.label = r;
            }
            const g = n, m = s[l[d]];
            for(let n = d; n < g; n += 6 * m)c[0].start = n, c[0].end = n + 6 * m, c[0].boxCount = m, t.call(this, e, c, i, u++);
            p = r[f], d = n;
        }
    }
    _updateLabelAttributes(e, t, n, i, r, s, l) {
        const h = this.layer.getRenderer(), u = e.material.uniforms, d = 1 === u.textPitchWithMap, g = !d && h.getTerrainHelper && h.getTerrainHelper(), m = this.isEnableCollision(), y = this.getMap(), x = e.geometry, _ = x.desc.positionSize, { aShape: v, aOffset: b, aAnchor: A, aAltitude: T, aPitchRotation: S } = x.properties;
        let { aProjectedAnchor: w } = x.properties;
        w || (w = x.properties.aProjectedAnchor = new Array(A.length / _ * 3));
        const M = x.properties.aTextSize, P = !l, I = t[n], C = I * _;
        let k;
        k = x.data.aAltitude ? (0, $eIStk).set($435bc7696844e930$var$Jr, A[C], A[C + 1], T[I]) : $435bc7696844e930$var$Vr.unpackPosition($435bc7696844e930$var$Jr, A[C], A[C + 1], A[C + 2]);
        const F = $435bc7696844e930$var$Bt($435bc7696844e930$var$Kr, k, s, y.width, y.height), O = x.properties.aTerrainAltitude;
        let R;
        if (O) {
            const e = O[I];
            if (e === $435bc7696844e930$var$me) return w[3 * I] = $435bc7696844e930$var$ge, w[3 * I + 1] = $435bc7696844e930$var$ge, w[3 * I + 2] = $435bc7696844e930$var$ge, !1;
            e ? (R = (0, $eIStk).set($435bc7696844e930$var$gs, ...k), R[2] = 100 * e, R = $435bc7696844e930$var$Bt(R, R, s, y.width, y.height)) : R = F;
        } else R = F;
        const E = y.getDevicePixelRatio();
        if ((0, $jxhwV).scale($435bc7696844e930$var$ys, R, 1 / E), y.isOffscreen($435bc7696844e930$var$ys)) return m || $435bc7696844e930$var$_s(b, t, n, i), w[3 * I] = $435bc7696844e930$var$ge, w[3 * I + 1] = $435bc7696844e930$var$ge, w[3 * I + 2] = $435bc7696844e930$var$ge, !1;
        P && (k = F), w[3 * I] = R[0], w[3 * I + 1] = R[1], w[3 * I + 2] = R[2];
        const D = P ? 1 : x.properties.tileExtent / this.layer.getTileSize().width;
        let L = !0;
        const H = t[n], N = t[i - 1], z = M ? M[H] : e.properties.textSize, V = this._updateNormal(e, z, r, H, N, k, $435bc7696844e930$var$Jr, D, l);
        if (null === V) return $435bc7696844e930$var$_s(b, t, n, i), !1;
        const U = N - H <= 3, B = Math.floor(V / 2), G = V % 2;
        for(let l = n; l < i; l += 6){
            const h = t[l];
            let c;
            if (c = B || l !== n || U || g ? B || l !== i - 6 || U || g ? $435bc7696844e930$var$Or.call(this, $435bc7696844e930$var$qr, e, z, r, h, k, $435bc7696844e930$var$Jr, D, B, R, this.layer, s, d) : $435bc7696844e930$var$cs : $435bc7696844e930$var$hs, !c) {
                L = !1, m || $435bc7696844e930$var$_s(b, t, n, i);
                break;
            }
            let y = c[2];
            G && (y -= Math.PI / 2);
            const x = $435bc7696844e930$var$gi($435bc7696844e930$var$Qr, y, 0, u.textRotateWithMap, u.textPitchWithMap), _ = b.length > v.length;
            let A;
            if (_) {
                (0, $eIStk).set($435bc7696844e930$var$as, S[3 * h], S[3 * h + 1], 0);
                const e = (0, $eIStk).normalize($435bc7696844e930$var$as, $435bc7696844e930$var$as), t = -S[3 * h + 2];
                if (t) {
                    const n = (0, $k1dpP).setAxisAngle($435bc7696844e930$var$rs, e, t);
                    (0, $3iqbd).fromTranslation($435bc7696844e930$var$ss, $435bc7696844e930$var$Yr), (0, $3iqbd).fromQuat($435bc7696844e930$var$os, n), A = (0, $3iqbd).multiply($435bc7696844e930$var$os, $435bc7696844e930$var$os, $435bc7696844e930$var$ss);
                }
            }
            for(let e = 0; e < 4; e++){
                const t = 2 * (h + e);
                (0, $6BoVD).set($435bc7696844e930$var$es, v[t] / 10, v[t + 1] / 10), (0, $6BoVD).scale($435bc7696844e930$var$es, $435bc7696844e930$var$es, z / 24), (0, $6BoVD).transformMat2($435bc7696844e930$var$es, $435bc7696844e930$var$es, x), d ? ((0, $6BoVD).multiply($435bc7696844e930$var$es, $435bc7696844e930$var$es, $435bc7696844e930$var$ns), (0, $6BoVD).add($435bc7696844e930$var$ts, $435bc7696844e930$var$es, c), _ && ($435bc7696844e930$var$ts[2] = 0, A && (0, $eIStk).transformMat4($435bc7696844e930$var$ts, $435bc7696844e930$var$ts, A))) : ((0, $6BoVD).multiply($435bc7696844e930$var$ts, c, $435bc7696844e930$var$ns), (0, $6BoVD).add($435bc7696844e930$var$ts, $435bc7696844e930$var$es, $435bc7696844e930$var$ts)), $435bc7696844e930$var$is[0] = 10 * $435bc7696844e930$var$ts[0], $435bc7696844e930$var$is[1] = 10 * $435bc7696844e930$var$ts[1], _ && ($435bc7696844e930$var$is[2] = 10 * $435bc7696844e930$var$ts[2]);
                const n = (_ ? 3 : 2) * (h + e);
                (b[n] !== $435bc7696844e930$var$is[0] || b[n + 1] !== $435bc7696844e930$var$is[1] || _ && b[n + 2] !== $435bc7696844e930$var$is[2]) && (b.dirty = !0, b[n] = $435bc7696844e930$var$is[0], b[n + 1] = $435bc7696844e930$var$is[1], _ && (b[n + 2] = $435bc7696844e930$var$is[2]));
            }
        }
        return L;
    }
    _updateNormal(e, t, n, i, r, s, o, a, l) {
        const h = r - i <= 3, c = this.getMap(), u = this.getSymbol(e.geometry.properties.symbolIndex);
        return h ? 0 : $435bc7696844e930$var$Dr.call(this, $435bc7696844e930$var$hs, $435bc7696844e930$var$cs, e, t, n, i, r, s, o, a, c.width / c.height, l, u.textMaxAngle || $435bc7696844e930$var$Br);
    }
    isBoxCollides(e, t, n, i, r, s) {
        return this.isLabelCollides(0, e, t, n, i, r, s);
    }
    deleteMesh(e, t) {
        e && (t && (Array.isArray(e) ? e.forEach((e)=>{
            e && e.material && delete e.material.uniforms.texture;
        }) : e.material && delete e.material.uniforms.texture), super.deleteMesh(e, t));
    }
    delete() {
        super.delete(), this._shaderAlongLine.dispose(), delete this._projectedLinesCache, this._linePicking && this._linePicking.dispose();
    }
    isUniqueStencilRefPerTile() {
        return !1;
    }
    isEnableTileStencil() {
        return !this.layer.getRenderer().isEnableWorkAround("win-intel-gpu-crash");
    }
    init() {
        const e = this.regl;
        this.renderer = new (0, $2wazW).Renderer(e);
        const { uniforms: t, extraCommandProps: n } = $435bc7696844e930$var$Ji.call(this, this.canvas, this.sceneConfig), i = this.canvas, r = {
            x: (e, t)=>t.viewport ? t.viewport.x : 0,
            y: (e, t)=>t.viewport ? t.viewport.y : 0,
            width: (e, t)=>t.viewport ? t.viewport.width : i ? i.width : 1,
            height: (e, t)=>t.viewport ? t.viewport.height : i ? i.height : 1
        };
        n.viewport = r, this.shader = new (0, $2wazW).MeshShader({
            vert: $435bc7696844e930$var$Lr,
            frag: $435bc7696844e930$var$Nr,
            uniforms: t,
            extraCommandProps: n
        });
        let o = n;
        if (this.layer.getRenderer().isEnableWorkAround("win-intel-gpu-crash") && (o = $435bc7696844e930$var$we({}, n), o.stencil = $435bc7696844e930$var$we({}, n.stencil), o.stencil.enable = !0, o.stencil.func.cmp = "<", o.stencil.func.ref = (e, t)=>2 * t.level + (t.isHalo || 0) + 1), this._shaderAlongLine = new (0, $2wazW).MeshShader({
            vert: $435bc7696844e930$var$Hr,
            frag: $435bc7696844e930$var$Nr,
            uniforms: t,
            extraCommandProps: o
        }), this.pickingFBO) {
            const e = new (0, $2wazW).FBORayPicking(this.renderer, {
                vert: "#define PICKING_MODE 1\n" + $435bc7696844e930$var$Lr,
                uniforms: t,
                extraCommandProps: {
                    viewport: this.pickingViewport
                }
            }, this.pickingFBO, this.getMap());
            e.filter = (e)=>{
                const t = e.properties.symbolIndex;
                return "line" !== this.getSymbol(t).textPlacement;
            };
            const n = new (0, $2wazW).FBORayPicking(this.renderer, {
                vert: "#define PICKING_MODE 1\n" + $435bc7696844e930$var$Hr,
                uniforms: t,
                extraCommandProps: {
                    viewport: this.pickingViewport
                }
            }, this.pickingFBO, this.getMap());
            n.filter = (e)=>"line" === e.geometry.properties.textPlacement, this.picking = [
                e,
                n
            ];
        }
    }
    getUniformValues(e, t) {
        const n = t && t.isRenderingTerrainSkin, i = this.layer.getTileSize().width, r = n ? $435bc7696844e930$var$ms : e.projViewMatrix, s = e.cameraToCenterDistance, o = (0, $6BoVD).set($435bc7696844e930$var$ls, e.width, e.height);
        n && (0, $6BoVD).set(o, i, i);
        const a = $435bc7696844e930$var$$(e.getResolution(), e);
        return {
            layerScale: this.layer.options.styleScale || 1,
            mapPitch: e.getPitch() * Math.PI / 180,
            mapRotation: e.getBearing() * Math.PI / 180,
            projViewMatrix: r,
            viewMatrix: e.viewMatrix,
            cameraToCenterDistance: s,
            canvasSize: o,
            glyphSize: $435bc7696844e930$var$_i,
            gammaScale: 1 * (this.layer.options.textGamma || 1),
            resolution: e.getResolution(),
            altitudeScale: a,
            viewport: n && t && t.viewport,
            textPitchFilter: 0,
            isRenderingTerrain: +!!n
        };
    }
}
function $435bc7696844e930$var$_s(e, t, n, i) {
    for(let r = n; r < i; r += 6){
        const n = t[r];
        for(let t = 0; t < 4; t++){
            const i = 3 * (n + t);
            (e[i] || e[i + 1] || e[i + 2]) && (e.dirty = !0, e[i] = 0, e[i + 1] = 0, e[i + 2] = 0);
        }
    }
}
function $435bc7696844e930$var$vs(e, t) {
    const n = e.properties.level - t.properties.level;
    return 0 === n ? e.properties.meshKey - t.properties.meshKey : n;
}
var $435bc7696844e930$var$bs = "#define SHADER_NAME NATIVE_POINT\n#include <gl2_vert>\n#ifdef HAS_ALTITUDE\nattribute vec2 aPosition;\nattribute float aAltitude;\n#else\nattribute vec3 aPosition;\n#endif\n#ifdef HAS_COLOR\nattribute vec4 aColor;\nvarying vec4 vColor;\n#endif\nuniform mat4 positionMatrix;\nuniform mat4 projViewModelMatrix;\nuniform float markerSize;\n#ifdef PICKING_MODE\n#include <fbo_picking_vert>\n#endif\n#include <vt_position_vert>\nvoid main() {\n  vec3 c = unpackVTPosition();\n  gl_Position = projViewModelMatrix * positionMatrix * vec4(c, 1.);\n  gl_PointSize = markerSize;\n#ifdef HAS_COLOR\nvColor = aColor / 255.;\n#endif\n#ifdef PICKING_MODE\nfbo_picking_setData(gl_Position.w, true);\n#endif\n}";
const $435bc7696844e930$var$As = {
    markerFill: [
        0,
        0,
        0
    ],
    markerOpacity: 1,
    markerSize: 10
};
class $435bc7696844e930$export$d48fdc78612718e6 extends $435bc7696844e930$var$gn {
    getPrimitive() {
        return "points";
    }
    isTerrainSkin() {
        return !1;
    }
    isTerrainVector() {
        return this.layer.options.awareOfTerrain;
    }
    isUniqueStencilRefPerTile() {
        return !1;
    }
    createMesh(e, t) {
        const { geometry: n, symbolIndex: i, ref: r } = e, o = this.getSymbol(i);
        if (void 0 === r) $435bc7696844e930$var$wt(n, this.getSymbolDef(i), this.getFnTypeConfig(i), this.layer), n.generateBuffers(this.regl);
        const a = {};
        $435bc7696844e930$var$ke(a, "markerOpacity", o, "markerOpacity", 1), $435bc7696844e930$var$ke(a, "markerSize", o, "markerSize", 10), $435bc7696844e930$var$ke(a, "markerFill", o, "markerFill", "#000", $435bc7696844e930$var$Re(this.colorCache, 3));
        const l = new (0, $2wazW).Material(a, $435bc7696844e930$var$As);
        l.createDefines = ()=>"square" !== o.markerType ? {
                USE_CIRCLE: 1
            } : null, l.appendDefines = (e)=>("square" !== o.markerType && (e.USE_CIRCLE = 1), e);
        const h = new (0, $2wazW).Mesh(n, l, {
            castShadow: !1,
            picking: !0
        }), c = {};
        return h.geometry.data.aAltitude && (c.HAS_ALTITUDE = 1), n.data.aColor && (c.HAS_COLOR = 1), h.setDefines(c), h.positionMatrix = this.getAltitudeOffsetMatrix(), h.setLocalTransform(t), h.properties.symbolIndex = i, h;
    }
    createFnTypeConfig(e, t) {
        const n = (0, $14507960c5dac0fb$export$79e978600dd1e509)(t.markerFill);
        return [
            {
                attrName: "aColor",
                symbolName: "markerFill",
                type: Uint8Array,
                width: 4,
                define: "HAS_COLOR",
                evaluate: (t, i)=>{
                    let r = n(e.getZoom(), t);
                    return (0, $14507960c5dac0fb$export$ec423ecbfcdb9a06)(r) && (r = this.evaluateInFnTypeConfig(r, i, e, t, !0)), Array.isArray(r) || (r = this.colorCache[r] = this.colorCache[r] || (0, (/*@__PURE__*/$parcel$interopDefault($08acccbbd431ef55$exports)))(r).unitArray()), r = $435bc7696844e930$var$Oe(r), r;
                }
            }
        ];
    }
    init() {
        const e = this.regl;
        this.renderer = new (0, $2wazW).Renderer(e);
        const t = [], n = {
            vert: $435bc7696844e930$var$bs,
            frag: "#define SHADER_NAME NATIVE_POINT\nprecision mediump float;\n#include <gl2_frag>\n#ifdef USE_CIRCLE\n#if __VERSION__ == 100\n#ifdef GL_OES_standard_derivatives\n#define STANDARD_DERIVATIVES_ENABLED 1\n#extension GL_OES_standard_derivatives : enable\n#endif\n#else\n#define STANDARD_DERIVATIVES_ENABLED 1\n#endif\n#endif\n#ifdef HAS_COLOR\nvarying vec4 vColor;\n#else\nuniform vec3 markerFill;\n#endif\nuniform float markerOpacity;\nuniform float layerOpacity;\nvoid main() {\n  float c = 1.;\n#ifdef USE_CIRCLE\nfloat r = .0, d = .0;\n  vec2 e = 2. * gl_PointCoord - 1.;\n  r = dot(e, e);\n  if(r > 1.) {\n    discard;\n  }\n#ifdef STANDARD_DERIVATIVES_ENABLED\nd = fwidth(r);\n  c = 1. - smoothstep(1. - d, 1. + d, r);\n#endif\n#endif\n#ifdef HAS_COLOR\nvec4 f = vColor;\n#else\nvec4 f = vec4(markerFill, 1.);\n#endif\nglFragColor = f * markerOpacity * c * layerOpacity;\n#if __VERSION__ == 100\ngl_FragColor = glFragColor;\n#endif\n}",
            uniforms: [
                {
                    name: "projViewModelMatrix",
                    type: "function",
                    fn: function(e, n) {
                        return (0, $3iqbd).multiply(t, n.projViewMatrix, n.modelMatrix), t;
                    }
                }
            ],
            defines: null,
            extraCommandProps: {
                viewport: {
                    x: 0,
                    y: 0,
                    width: ()=>this.canvas ? this.canvas.width : 1,
                    height: ()=>this.canvas ? this.canvas.height : 1
                },
                depth: {
                    enable: !0,
                    mask: !1,
                    range: this.sceneConfig.depthRange || [
                        0,
                        1
                    ],
                    func: this.sceneConfig.depthFunc || "always"
                },
                blend: {
                    enable: !0,
                    func: this.getBlendFunc(),
                    equation: "add"
                }
            }
        };
        if (this.shader = new (0, $2wazW).MeshShader(n), this.shader.version = 300, this.pickingFBO) {
            const e = [];
            this.picking = [
                new (0, $2wazW).FBORayPicking(this.renderer, {
                    vert: "#define PICKING_MODE 1\n" + $435bc7696844e930$var$bs,
                    uniforms: [
                        {
                            name: "projViewModelMatrix",
                            type: "function",
                            fn: function(t, n) {
                                return (0, $3iqbd).multiply(e, n.projViewMatrix, n.modelMatrix), e;
                            }
                        }
                    ],
                    extraCommandProps: {
                        viewport: this.pickingViewport
                    }
                }, this.pickingFBO, this.getMap())
            ];
        }
    }
    getUniformValues(e) {
        return {
            projViewMatrix: e.projViewMatrix
        };
    }
}
var $435bc7696844e930$var$Ss = "#define SHADER_NAME NATIVE_LINE\n#ifdef HAS_ALTITUDE\nattribute vec2 aPosition;\nattribute float aAltitude;\n#else\nattribute vec3 aPosition;\n#endif\nuniform mat4 projViewModelMatrix;\nuniform mat4 positionMatrix;\n#ifndef PICKING_MODE\n#if defined(HAS_COLOR)\nattribute vec4 aColor;\nvarying vec4 vColor;\n#endif\n#else\n#include <fbo_picking_vert>\n#endif\n#include <vt_position_vert>\nvoid main() {\n  vec3 c = unpackVTPosition();\n  gl_Position = projViewModelMatrix * positionMatrix * vec4(c, 1.);\n#ifndef PICKING_MODE\n#if defined(HAS_COLOR)\nvColor = aColor / 255.;\n#endif\n#else\nfbo_picking_setData(gl_Position.w, true);\n#endif\n}";
const $435bc7696844e930$var$ws = (0, $3iqbd).identity([]);
class $435bc7696844e930$export$303928d80b576bb3 extends $435bc7696844e930$var$gn {
    constructor(e, t, n, i, r, s){
        if (super(e, t, n, i, r, s), this.primitive = "lines", (0, $14507960c5dac0fb$export$ec423ecbfcdb9a06)(this.symbolDef.lineColor)) {
            const e = t.getMap(), n = (0, $14507960c5dac0fb$export$79e978600dd1e509)(this.symbolDef.lineColor);
            this.colorSymbol = (t)=>n(e.getZoom(), t);
        }
    }
    needPolygonOffset() {
        return !0;
    }
    createMesh(e, t) {
        const { geometry: n, symbolIndex: i, ref: r } = e, o = this.getSymbol(i), a = this.getMeshUniforms(n, o);
        void 0 === r && n.generateBuffers(this.regl);
        const l = new (0, $2wazW).Material(a), h = new (0, $2wazW).Mesh(n, l, {
            castShadow: !1,
            picking: !0
        });
        h.setLocalTransform(t), h.properties.symbolIndex = i;
        const c = {};
        return h.geometry.data.aAltitude && (c.HAS_ALTITUDE = 1), h.setDefines(c), h;
    }
    getMeshUniforms(e, t) {
        const n = {};
        return $435bc7696844e930$var$ke(n, "lineColor", t, "lineColor", "#000", $435bc7696844e930$var$Re(this.colorCache)), $435bc7696844e930$var$ke(n, "lineOpacity", t, "lineOpacity", 1), n;
    }
    isEnableTileStencil(e) {
        return !!!(e && e.isRenderingTerrain && this.isTerrainSkin());
    }
    init(e) {
        const t = this.regl;
        this.renderer = new (0, $2wazW).Renderer(t);
        const n = this.canvas, i = {
            x: (e, t)=>t.viewport ? t.viewport.x : 0,
            y: (e, t)=>t.viewport ? t.viewport.y : 0,
            width: (e, t)=>t.viewport ? t.viewport.width : n ? n.width : 1,
            height: (e, t)=>t.viewport ? t.viewport.height : n ? n.height : 1
        }, r = [
            {
                name: "projViewModelMatrix",
                type: "function",
                fn: function(e, t) {
                    const n = [];
                    return (0, $3iqbd).multiply(n, t.projViewMatrix, t.modelMatrix), n;
                }
            }
        ], o = this.sceneConfig.depthRange, l = {
            vert: $435bc7696844e930$var$Ss,
            frag: "#define SHADER_NAME NATIVE_LINE\nprecision mediump float;\nuniform float lineOpacity;\nuniform vec4 lineColor;\nuniform float layerOpacity;\n#if defined(HAS_COLOR)\nvarying vec4 vColor;\n#endif\nvoid main() {\n  gl_FragColor = lineColor * lineOpacity;\n#if defined(HAS_COLOR)\ngl_FragColor *= vColor;\n#endif\ngl_FragColor *= layerOpacity;\n}",
            uniforms: r,
            defines: null,
            extraCommandProps: {
                viewport: i,
                stencil: {
                    enable: ()=>this.isEnableTileStencil(e),
                    mask: 255,
                    func: {
                        cmp: ()=>this.isOnly2D() ? "=" : "<=",
                        ref: (e, t)=>t.stencilRef,
                        mask: 255
                    },
                    op: {
                        fail: "keep",
                        zfail: "keep",
                        zpass: "replace"
                    }
                },
                depth: {
                    enable: !0,
                    range: o || [
                        0,
                        1
                    ],
                    func: this.sceneConfig.depthFunc || "<="
                },
                blend: {
                    enable: !0,
                    func: this.getBlendFunc(),
                    equation: "add"
                },
                polygonOffset: {
                    enable: !0,
                    offset: this.getPolygonOffset()
                }
            }
        };
        this.shader = new (0, $2wazW).MeshShader(l), this.pickingFBO && (this.picking = [
            new (0, $2wazW).FBORayPicking(this.renderer, {
                vert: "#define PICKING_MODE 1\n" + $435bc7696844e930$var$Ss,
                uniforms: r,
                extraCommandProps: {
                    viewport: this.pickingViewport
                }
            }, this.pickingFBO, this.getMap())
        ]);
    }
    getUniformValues(e, t) {
        const n = t && t.isRenderingTerrainSkin;
        return {
            projViewMatrix: n ? $435bc7696844e930$var$ws : e.projViewMatrix,
            viewport: n && t && t.viewport
        };
    }
    getPrimitive() {
        return "lines";
    }
}
const { DEFAULT_TEX_WIDTH: $435bc7696844e930$var$Ps } = $435bc7696844e930$var$H(), $435bc7696844e930$var$Is = [
    1,
    1,
    1
], $435bc7696844e930$var$Cs = [
    1,
    1,
    1,
    1
], $435bc7696844e930$var$ks = [
    0,
    0
], $435bc7696844e930$var$Fs = [
    1,
    1
], $435bc7696844e930$var$Os = [], $435bc7696844e930$var$Rs = new $gP1US.Coordinate(0, 0), $435bc7696844e930$var$Es = new $gP1US.Coordinate(0, 0), $435bc7696844e930$var$Ds = [], $435bc7696844e930$var$Ls = [];
class $435bc7696844e930$var$Hs extends $435bc7696844e930$var$fn {
    isEnableTileStencil() {
        return !1;
    }
    supportRenderMode(e) {
        return this.isAnimating() ? "fxaa" === e || "fxaaAfterTaa" === e : "taa" === e || "fxaa" === e;
    }
    isTerrainSkin() {
        return !1;
    }
    isTerrainVector() {
        return this.layer.options.awareOfTerrain;
    }
    isAnimating() {
        return !1;
    }
    createMesh(t, n, { tilePoint: i }) {
        if (!this.material) return this.setToRedraw(), null;
        const { geometry: r, symbolIndex: o } = t, l = this.layer instanceof $gP1US.TileLayer, h = new (0, $2wazW).Mesh(r, this.material);
        if (this.sceneConfig.animation) {
            $435bc7696844e930$var$Is[2] = .01;
            const e = [];
            (0, $3iqbd).fromScaling(e, $435bc7696844e930$var$Is), (0, $3iqbd).multiply(e, n, e), n = e;
        }
        const c = this.getSymbolDef(o), u = this.getFnTypeConfig(o);
        $435bc7696844e930$var$wt(r, c, u, this.layer);
        const f = this.getShader(), d = f.getGeometryDefines ? f.getGeometryDefines(r) : {}, p = this.getSymbol(o), g = $435bc7696844e930$var$Re(this.colorCache);
        if (r.data.aExtrude) {
            d.IS_LINE_EXTRUSION = 1;
            const { tileResolution: e, tileRatio: t } = r.properties, n = this.getMap();
            Object.defineProperty(h.uniforms, "linePixelScale", {
                enumerable: !0,
                get: function() {
                    return t * n.getResolution() / e;
                }
            }), $435bc7696844e930$var$ke(h.uniforms, "lineWidth", p, "lineWidth", 4), $435bc7696844e930$var$ke(h.uniforms, "lineOpacity", p, "lineOpacity", 1), $435bc7696844e930$var$ke(h.uniforms, "lineColor", p, "lineColor", "#fff", g), Object.defineProperty(h.uniforms, "lineHeight", {
                enumerable: !0,
                get: ()=>{
                    const e = this.dataConfig.defaultAltitude * (this.dataConfig.altitudeScale || 1);
                    return $435bc7696844e930$var$Le(e) ? e : 0;
                }
            });
        } else {
            $435bc7696844e930$var$ke(h.uniforms, "polygonFill", p, "polygonFill", $435bc7696844e930$var$Cs, g), $435bc7696844e930$var$ke(h.uniforms, "polygonOpacity", p, "polygonOpacity", 1);
            const e = [];
            Object.defineProperty(h.uniforms, "vertexColorsOfType", {
                enumerable: !0,
                get: ()=>{
                    const t = g(p.bottomPolygonFill || $435bc7696844e930$var$Cs), n = g(p.topPolygonFill || $435bc7696844e930$var$Cs);
                    e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3], e[4] = n[0], e[5] = n[1], e[6] = n[2], e[7] = n[3];
                    const i = h.geometry.properties.vertexColors;
                    if (i) {
                        let t = 8;
                        e.length = 8 + i.length;
                        for(let n = 0; n < i.length; n++)e[t++] = i[n][0], e[t++] = i[n][1], e[t++] = i[n][2], e[t++] = i[n][3];
                    }
                    return e;
                }
            });
        }
        if (r.data.aColor && (d.HAS_COLOR = 1), r.data.aOpacity && (d.HAS_OPACITY = 1), r.data.aLineWidth && (d.HAS_LINE_WIDTH = 1), r.data.aLineHeight && (d.HAS_LINE_HEIGHT = 1), r.data.aTerrainAltitude && (d.HAS_TERRAIN_ALTITUDE = 1), r.data.aVertexColorType) {
            const e = h.geometry.properties.vertexColors;
            let t = 2;
            e && (t += e.length), d.VERTEX_TYPES_COUNT = t;
        }
        if (r.data.aOpacity) {
            const e = r.data.aOpacity;
            for(let t = 0; t < e.length; t++)if (e[t] < 255) {
                r.properties.hasAlpha = !0;
                break;
            }
        }
        d.HAS_MIN_ALTITUDE = 1, d.HAS_LAYER_OPACITY = 1, r.generateBuffers(this.regl), h.setDefines(d), h.setPositionMatrix(this.getAltitudeOffsetMatrix()), h.setLocalTransform(n), (r.properties.maxAltitude <= 0 || h.properties.level >= 3) && (h.castShadow = !1), h.setUniform("maxAltitude", h.geometry.properties.maxAltitude), Object.defineProperty(h.uniforms, "minAltitude", {
            enumerable: !0,
            get: ()=>this.layer.options.altitude || 0
        });
        const { tileResolution: m } = r.properties, y = this.getMap(), x = this.layer.getRenderer(), _ = y.pointAtResToCoord(new $gP1US.Point(i), m), v = function(e, t, n, i, r) {
            return e.pointAtResToDistance(t, 0, i, n);
        }(y, 1, _, m), b = [];
        Object.defineProperty(h.uniforms, "uvOrigin", {
            enumerable: !0,
            get: ()=>this._computeUVOffset(b, o, i, m, v, l)
        }), h.setUniform("uvOffset", [
            0,
            0
        ]), Object.defineProperty(h.uniforms, "hasAlpha", {
            enumerable: !0,
            get: ()=>{
                const e = this.getSymbol(o);
                return r.properties.hasAlpha || e.polygonOpacity < 1 || e.lineOpacity < 1 || h.material && (h.material.uniforms.baseColorTexture || h.material.uniforms.emissiveTexture);
            }
        });
        const A = this.layer.getMap().getMaxNativeZoom();
        return Object.defineProperty(h.uniforms, "stencilRef", {
            enumerable: !0,
            get: ()=>x.isForeground(h) ? 0 : A - h.properties.tile.z
        }), h.properties.symbolIndex = o, h;
    }
    _computeUVOffset(e, t, n, i, r, s) {
        if (1 === this.dataConfig.topUVMode) return e[0] = 0, e[1] = 0, e;
        const o = this.getMap(), a = this.getSymbol(t).material;
        let l = n;
        !this.dataConfig.side && a && a.textureOrigin && ($435bc7696844e930$var$Rs.set(a.textureOrigin[0], a.textureOrigin[1]), o.coordToPointAtRes($435bc7696844e930$var$Rs, i, $435bc7696844e930$var$Es), l = (0, $6BoVD).set($435bc7696844e930$var$Ds, n[0] - $435bc7696844e930$var$Es.x, n[1] - $435bc7696844e930$var$Es.y));
        const h = !!a && a.uvOffsetInMeter;
        let c = a && a.uvOffset || $435bc7696844e930$var$ks;
        const u = this.getUVOffsetAnim();
        u && (c = this.getUVOffset(u));
        const d = a && a.uvScale || $435bc7696844e930$var$Fs;
        let p = this.dataConfig.side ? 0 : l[0], g = this.dataConfig.side ? 0 : l[1];
        const m = a && a.textureWidth || $435bc7696844e930$var$Ps, y = m * d[1] / d[0];
        h && (p += c[0] / r, g += c[1] / r);
        const x = h ? 0 : c[0], _ = h ? 0 : c[1], v = (0, $6BoVD).set(e, p * r * d[0] / m + x, g * r * d[1] / y + _);
        return s || (v[1] *= -1), v;
    }
    callShader(e, t) {
        const n = this.sceneConfig.cullFace;
        this.sceneConfig.cullFace = "front", this.callBackgroundTileShader(e, t), void 0 === n ? delete this.sceneConfig.cullFace : this.sceneConfig.cullFace = n, super.callShader(e, t);
    }
    getShadowMeshes() {
        if (!this.isVisible()) return $435bc7696844e930$var$Os;
        this.shadowCount = this.scene.getMeshes().length;
        const e = this.scene.getMeshes().filter((e)=>0 === e.properties.level);
        for(let t = 0; t < e.length; t++){
            const n = e[t];
            n.material !== this.material && n.setMaterial(this.material);
        }
        return e;
    }
    getUVOffsetAnim() {
        const e = this.getSymbols()[0];
        return e.material && e.material.uvOffsetAnim;
    }
    getUVOffset(e) {
        const t = this.getSymbols()[0], n = t.material && t.material.uvOffset || $435bc7696844e930$var$ks, i = !!t.material && t.material.uvOffsetInMeter, r = performance.now() / 1e3, s = (0, $6BoVD).set($435bc7696844e930$var$Ls, n[0], n[1]);
        return s[0] = r * e[0], s[1] = r * e[0], i || (s[0] %= 1, s[1] %= 1), s;
    }
    needPolygonOffset() {
        return this._needPolygonOffset;
    }
    startFrame(...e) {
        return delete this._needPolygonOffset, super.startFrame(...e);
    }
    addMesh(e, t) {
        e.forEach((e)=>{
            this._prepareMesh(e, t);
        }), super.addMesh(...arguments);
    }
    _prepareMesh(e, t) {
        if (null !== t) {
            const n = e.localTransform;
            0 === t && (t = .01), $435bc7696844e930$var$Is[2] = t, (0, $3iqbd).fromScaling(n, $435bc7696844e930$var$Is), (0, $3iqbd).multiply(n, e.properties.tileTransform, n), e.setLocalTransform(n);
        } else e.setLocalTransform(e.properties.tileTransform);
        e.material !== this.material && e.setMaterial(this.material), e.geometry.properties.maxAltitude <= 0 && (this._needPolygonOffset = !0), this.getSymbol(e.properties.symbolIndex).ssr ? e.ssr = 1 : e.ssr = 0;
    }
    deleteMaterial() {
        this.material && (this.material.dispose(), delete this.material);
    }
    deleteMesh(e, t) {
        if (e) {
            if (this.scene.removeMesh(e), Array.isArray(e)) for(let n = 0; n < e.length; n++)t || (e[n].geometry.dispose(), delete e[n].geometry.properties.layer), e[n].dispose();
            else t || (e.geometry.dispose(), delete e.geometry.properties.layer), e.dispose();
        }
    }
    updateDataConfig(e, t) {
        return !("line-extrusion" === this.dataConfig.type && !e.altitudeProperty && !t.altitudeProperty);
    }
    createFnTypeConfig(e, t) {
        const n = (0, $14507960c5dac0fb$export$79e978600dd1e509)(t.polygonFill || t.lineColor), i = (0, $14507960c5dac0fb$export$b5e0f6446c9b8e3c)(t.polygonOpacity || t.lineOpacity), r = (0, $14507960c5dac0fb$export$b5e0f6446c9b8e3c)(t.lineWidth), s = new Uint8Array(1), o = new Uint16Array(1), a = t.polygonFill ? "polygonFill" : t.lineColor ? "lineColor" : "polygonFill", l = t.polygonOpacity ? "polygonOpacity" : t.lineOpacity ? "lineOpacity" : "polygonOpacity";
        return [
            {
                attrName: "aColor",
                type: Uint8Array,
                width: 4,
                symbolName: a,
                define: "HAS_COLOR",
                evaluate: (t, i)=>{
                    let r = n(e.getZoom(), t);
                    return (0, $14507960c5dac0fb$export$ec423ecbfcdb9a06)(r) && (r = this.evaluateInFnTypeConfig(r, i, e, t, !0)), Array.isArray(r) || (r = this.colorCache[r] = this.colorCache[r] || (0, (/*@__PURE__*/$parcel$interopDefault($08acccbbd431ef55$exports)))(r).unitArray()), r = $435bc7696844e930$var$Oe(r), r;
                }
            },
            {
                attrName: "aOpacity",
                type: Uint8Array,
                width: 1,
                symbolName: l,
                evaluate: (t, n)=>{
                    let r = i(e.getZoom(), t);
                    return (0, $14507960c5dac0fb$export$ec423ecbfcdb9a06)(r) && (r = this.evaluateInFnTypeConfig(r, n, e, t, !1)), s[0] = 255 * r, s[0] < 255 && (n.properties.hasAlpha = !0), s[0];
                }
            },
            {
                attrName: "aLineWidth",
                type: Uint8Array,
                width: 1,
                symbolName: "lineWidth",
                define: "HAS_LINE_WIDTH",
                evaluate: (t)=>{
                    const n = r(e.getZoom(), t);
                    return o[0] = Math.round(2 * n), o[0];
                }
            }
        ];
    }
    updateSymbol(e, t) {
        let n = !1;
        e && e.material && (n = function(e, t) {
            for(const n in t)if ($435bc7696844e930$var$zs[n] && t[n] !== e[n] && (!e[n] || !t[n])) return !0;
            return !1;
        }(this.symbolDef[0].material || {}, e.material));
        const i = super.updateSymbol(e, t);
        return e && e.material && this._updateMaterial(e.material), n || i;
    }
    _isNeedRefreshStyle(e, t) {
        return $435bc7696844e930$var$Ns(e) !== $435bc7696844e930$var$Ns(t);
    }
}
function $435bc7696844e930$var$Ns(e) {
    if (!e || !e.material) return !1;
    for(const t in e.material)if (t.indexOf("Texture") > 0 && e.material[t]) return !0;
    return !1;
}
const $435bc7696844e930$var$zs = {
    normalTexture: 1,
    bumpTexture: 1
};
class $435bc7696844e930$export$567a8d5f44cddc05 extends $435bc7696844e930$var$Hs {
    createGeometry(e) {
        const t = e.data, n = this.getSymbols()[0];
        if (n.material && n.material.extrusionOpacity) {
            const e = new Uint8Array(t.aPosition.length / 3);
            for(let n = 0; n < t.aPosition.length; n += 3)t.aPosition[n + 2] > 0 ? e[n / 3] = 0 : e[n / 3] = 1;
            t.aExtrusionOpacity = e;
        }
        const i = new (0, $2wazW).Geometry(t, e.indices);
        return $435bc7696844e930$var$we(i.properties, e.properties), this._prepareFeatureIds(i, e), {
            geometry: i,
            symbolIndex: {
                index: 0
            }
        };
    }
    updateSceneConfig(e) {
        let t;
        if (this.sceneConfig.cullFace !== e.cullFace && (t = !0), $435bc7696844e930$var$we(this.sceneConfig, e), t) {
            const e = this.getShaderConfig();
            this.shader.dispose(), this.shader = new (0, $2wazW).PhongShader(e);
        }
        this.setToRedraw();
    }
    getShader() {
        return this.shader;
    }
    delete(e) {
        this.getMap().off("updatelights", this._updateLights, this), super.delete(e), this.material.dispose();
    }
    init() {
        this.getMap().on("updatelights", this._updateLights, this);
        const e = this.regl;
        this.renderer = new (0, $2wazW).Renderer(e);
        const t = this.getShaderConfig();
        this.shader = new (0, $2wazW).PhongShader(t), this._updateMaterial();
        const n = {
            vert: this.getPickingVert(),
            uniforms: [
                "projViewMatrix",
                "modelMatrix",
                "positionMatrix",
                {
                    name: "projViewModelMatrix",
                    type: "function",
                    fn: function(e, t) {
                        return (0, $3iqbd).multiply([], t.projViewMatrix, t.modelMatrix);
                    }
                }
            ],
            extraCommandProps: {
                viewport: this.pickingViewport
            }
        };
        this.picking = [
            new (0, $2wazW).FBORayPicking(this.renderer, n, this.layer.getRenderer().pickingFBO, this.getMap())
        ];
    }
    _updateLights() {
        this.setToRedraw();
    }
    getShaderConfig() {
        const e = this.canvas, t = {
            x: 0,
            y: 0,
            width: ()=>e ? e.width : 1,
            height: ()=>e ? e.height : 1
        };
        return {
            extraCommandProps: {
                cull: {
                    enable: ()=>void 0 === this.sceneConfig.cullFace || !!this.sceneConfig.cullFace,
                    face: ()=>{
                        let e = this.sceneConfig.cullFace;
                        return !0 === e && (e = "back"), e || "back";
                    }
                },
                stencil: {
                    enable: !0,
                    func: {
                        cmp: "<=",
                        ref: (e, t)=>t.level
                    },
                    op: {
                        fail: "keep",
                        zfail: "keep",
                        zpass: "replace"
                    }
                },
                depth: {
                    enable: !0,
                    range: this.sceneConfig.depthRange || [
                        0,
                        1
                    ],
                    func: this.sceneConfig.depthFunc || "<="
                },
                blend: {
                    enable: !0,
                    func: this.getBlendFunc(),
                    equation: "add"
                },
                viewport: t,
                polygonOffset: {
                    enable: !0,
                    offset: this.getPolygonOffset()
                }
            }
        };
    }
    _updateMaterial() {
        this.material && this.material.dispose();
        const t = this.layer instanceof $gP1US.TileLayer, n = this.getSymbols()[0].material, i = {};
        for(const e in n)$435bc7696844e930$var$Ne(n, e) && (i[e] = n[e], "uvRotation" === e && (i[e] = i[e] * Math.PI / 180, t || (i[e] *= -1)));
        this.material = new (0, $2wazW).PhongMaterial(i);
    }
    getUniformValues(e, t) {
        const n = e.viewMatrix, i = e.projMatrix, r = e.cameraPosition, s = this._getLightUniformValues(), o = $435bc7696844e930$var$we({
            viewMatrix: n,
            projMatrix: i,
            cameraPosition: r,
            projViewMatrix: e.projViewMatrix
        }, s);
        t && t.jitter ? o.halton = t.jitter : o.halton = [
            0,
            0
        ];
        const a = this.layer.getRenderer().canvas;
        return o.outSize = [
            a.width,
            a.height
        ], o;
    }
    getPickingVert() {
        return "\n            attribute vec3 aPosition;\n            uniform mat4 projViewModelMatrix;\n            uniform mat4 modelMatrix;\n            uniform mat4 positionMatrix;\n            //\u5F15\u5165fbo picking\u7684vert\u76F8\u5173\u51FD\u6570\n            #include <fbo_picking_vert>\n            #include <get_output>\n            void main()\n            {\n                mat4 localPositionMatrix = getPositionMatrix();\n                vec4 localPosition = getPosition(aPosition);\n\n                gl_Position = projViewModelMatrix * localPositionMatrix * localPosition;\n                //\u4F20\u5165gl_Position\u7684depth\u503C\n                fbo_picking_setData(gl_Position.w, true);\n            }\n        ";
    }
    _getLightUniformValues() {
        const e = this.getMap().getLightManager(), t = e && e.getAmbientLight() || {}, n = e && e.getDirectionalLight() || {};
        return {
            ambientColor: t.color || [
                .2,
                .2,
                .2
            ],
            light0_diffuse: [
                ...n.color || [
                    .1,
                    .1,
                    .1
                ],
                1
            ],
            lightSpecular: n.specular || [
                .8,
                .8,
                .8
            ],
            light0_viewDirection: n.direction || [
                1,
                1,
                -1
            ]
        };
    }
}
const $435bc7696844e930$var$Us = [
    1,
    1,
    1
];
class $435bc7696844e930$export$f8a5f3ca2ebee3b0 extends $435bc7696844e930$var$fn {
    createGeometry(e) {
        const { data: t, indices: n } = e, i = new (0, $2wazW).Geometry(t, n, 0, {
            primitive: "lines"
        });
        return i.generateBuffers(this.regl), {
            geometry: i,
            symbolIndex: {
                index: 0
            }
        };
    }
    createMesh(e, t) {
        const { geometry: n } = e, i = new (0, $2wazW).Mesh(n);
        if (i.castShadow = !1, this.sceneConfig.animation) {
            $435bc7696844e930$var$Us[2] = .01;
            const e = [];
            (0, $3iqbd).fromScaling(e, $435bc7696844e930$var$Us), (0, $3iqbd).multiply(e, t, e), t = e;
        }
        return i.setLocalTransform(t), i.properties.symbolIndex = {
            index: 0
        }, i;
    }
    addMesh(e, t) {
        if (!e.length) return this;
        let n;
        null !== t ? (0 === t && (t = .01), n = e[0].localTransform, $435bc7696844e930$var$Us[2] = t, (0, $3iqbd).fromScaling(n, $435bc7696844e930$var$Us), (0, $3iqbd).multiply(n, e[0].properties.tileTransform, n)) : n = e[0].properties.tileTransform;
        for(let t = 0; t < e.length; t++)e[t].setLocalTransform(n);
        return this.scene.addMesh(e), this;
    }
    init() {
        const e = this.regl;
        this.scene = new (0, $2wazW).Scene, this.renderer = new (0, $2wazW).Renderer(e);
        const t = {
            x: 0,
            y: 0,
            width: ()=>this.canvas ? this.canvas.width : 1,
            height: ()=>this.canvas ? this.canvas.height : 1
        }, n = {
            vert: "\n    attribute vec3 aPosition;\n    attribute vec4 aColor;\n\n    uniform mat4 projViewModelMatrix;\n    uniform vec2 outSize;\n\n    varying vec4 vColor;\n\n    void main()\n    {\n        gl_Position = projViewModelMatrix * vec4(aPosition, 1.0);\n        vColor = aColor / 255.0;\n    }\n",
            frag: "\n    #ifdef GL_ES\n        precision lowp float;\n    #endif\n\n    uniform float opacity;\n\n    varying vec4 vColor;\n\n    void main()\n    {\n        gl_FragColor = vColor * opacity;\n    }\n",
            uniforms: [
                {
                    name: "projViewModelMatrix",
                    type: "function",
                    fn: function(e, t) {
                        const n = [];
                        return (0, $3iqbd).multiply(n, t.projViewMatrix, t.modelMatrix), n;
                    }
                }
            ],
            extraCommandProps: {
                stencil: {
                    enable: !0,
                    func: {
                        cmp: "<=",
                        ref: (e, t)=>t.level
                    },
                    op: {
                        fail: "keep",
                        zfail: "keep",
                        zpass: "replace"
                    }
                },
                blend: {
                    enable: !0,
                    func: this.getBlendFunc(),
                    equation: "add"
                },
                viewport: t
            }
        };
        this.shader = new (0, $2wazW).MeshShader(n);
    }
    getUniformValues(e) {
        const t = this.sceneConfig.opacity || .3, n = this.layer.getRenderer().canvas;
        return {
            projViewMatrix: e.projViewMatrix,
            outSize: [
                n.width,
                n.height
            ],
            opacity: t
        };
    }
}
const { getPBRUniforms: $435bc7696844e930$var$Gs } = (0, $2wazW).pbr.PBRUtils;
class $435bc7696844e930$var$js extends $435bc7696844e930$var$Hs {
    constructor(...e){
        super(...e), this._loader = new (0, $2wazW).ResourceLoader(null, this.layer.getURLModifier()), this.scene.sortFunction = this.sortByCommandKey;
    }
    supportRenderMode(e) {
        return this.getSymbols()[0].ssr ? "fxaa" === e || "fxaaAfterTaa" === e : super.supportRenderMode(e);
    }
    isAnimating() {
        const e = this._getUVOffsetAnim();
        if (e && (e[0] || e[1])) return !0;
    }
    needToRedraw() {
        const e = this._getUVOffsetAnim();
        return !(!e || !e[0] && !e[1]) || super.needToRedraw();
    }
    _getUVOffsetAnim() {
        const e = this.getSymbols()[0];
        return e.material && e.material.uvOffsetAnim;
    }
    createGeometry(e) {
        if (!e.data || !e.data.aPosition || !e.data.aPosition.length) return null;
        const t = {
            uv0Attribute: "aTexCoord0"
        };
        e.data.aAltitude && (t.altitudeAttribute = "aAltitude");
        const n = new (0, $2wazW).Geometry(e.data, e.indices, 0, t);
        return $435bc7696844e930$var$we(n.properties, e.properties), e.vertexColors && (n.properties.vertexColors = e.vertexColors), this.material.uniforms.normalTexture && !n.data[n.desc.tangentAttribute] && n.data[n.desc.uv0Attribute] && (n.data[n.desc.normalAttribute] || n.createNormal(), n.createTangent()), this._prepareFeatureIds(n, e), {
            geometry: n,
            symbolIndex: {
                index: 0
            }
        };
    }
    paint(e) {
        const t = !!e.shadow;
        e.states && e.states.includesChanged && (this.shader.dispose(), delete this.shader, this._updateDepthShader.dispose(), delete this._updateDepthShader, this._createShader(e));
        let n = !!e.ssr && this.getSymbols()[0].ssr;
        const i = this.shader, r = i.shaderDefines;
        if (n) {
            const t = $435bc7696844e930$var$we({}, r, e.ssr.defines);
            i.shaderDefines = t;
        }
        if (e.onlyUpdateDepthInTaa && (this.shader = this._updateDepthShader, !n && this._previousSSR && (this.shader = i, this.setToRedraw(!0))), this.updateIBLDefines(i), super.paint(e), void 0 !== this.shadowCount && t) {
            const e = this.scene.getMeshes().length;
            this.shadowCount !== e && this.setToRedraw();
        }
        this.shader = i, n && (i.shaderDefines = r), delete this.shadowCount, this._previousSSR = n;
    }
    updateSceneConfig(e) {
        $435bc7696844e930$var$we(this.sceneConfig, e), this.setToRedraw();
    }
    delete() {
        super.delete(), this.disposeIBLTextures(), this.material.dispose(), this._updateDepthShader && (this._updateDepthShader.dispose(), delete this._updateDepthShader);
    }
    init(e) {
        this.getMap().on("updatelights", this._onUpdatelights, this), this.createIBLTextures(), this._context = this._context || e;
        const t = this.regl;
        this.renderer = new (0, $2wazW).Renderer(t), this._bindedOnTextureLoad = this._onTextureLoad.bind(this), this._bindDisposeCachedTexture = this.disposeCachedTexture.bind(this), this._bindOnMaterialComplete = this._onMaterialComplete.bind(this), this._updateMaterial(), this._createShader(e);
        const n = {
            vert: "\n                #include <gl2_vert>\n                attribute vec3 aPosition;\n                uniform mat4 projViewModelMatrix;\n                uniform mat4 positionMatrix;\n                //\u5F15\u5165fbo picking\u7684vert\u76F8\u5173\u51FD\u6570\n                #include <line_extrusion_vert>\n                #include <get_output>\n                #include <fbo_picking_vert>\n                void main() {\n                    mat4 localPositionMatrix = getPositionMatrix();\n                    #ifdef IS_LINE_EXTRUSION\n                        vec3 linePosition = getLineExtrudePosition(aPosition);\n                        vec4 localVertex = getPosition(linePosition);\n                    #else\n                        vec4 localVertex = getPosition(aPosition);\n                    #endif\n\n                    gl_Position = projViewModelMatrix * localPositionMatrix * localVertex;\n                    fbo_picking_setData(gl_Position.w, true);\n                }\n            ",
            uniforms: [
                {
                    name: "projViewModelMatrix",
                    type: "function",
                    fn: (e, t)=>(0, $3iqbd).multiply([], t.projViewMatrix, t.modelMatrix)
                }
            ],
            extraCommandProps: {
                viewport: this.pickingViewport,
                depth: {
                    enable: !0,
                    range: this.sceneConfig.depthRange || [
                        0,
                        1
                    ],
                    func: this.sceneConfig.depthFunc || "<=",
                    mask: !!$435bc7696844e930$var$Ie(this.sceneConfig.depthMask) || this.sceneConfig.depthMask
                }
            }
        };
        this.picking = [
            new (0, $2wazW).FBORayPicking(this.renderer, n, this.layer.getRenderer().pickingFBO, this.getMap())
        ];
    }
    _createShader(e) {
        const t = {
            x: 0,
            y: 0,
            width: ()=>this.canvas ? this.canvas.width : 1,
            height: ()=>this.canvas ? this.canvas.height : 1
        }, n = {}, i = [];
        i.push(...(0, $2wazW).SsrPass.getUniformDeclares()), this.fillIncludes(n, i, e);
        const r = {
            cull: {
                enable: (e, t)=>!(t.geometryProperties.hasNegativeHeight || void 0 !== this.sceneConfig.cullFace && !this.sceneConfig.cullFace),
                face: ()=>this.sceneConfig.cullFace || "back"
            },
            stencil: {
                enable: !1
            },
            viewport: t,
            depth: {
                enable: !0,
                range: this.sceneConfig.depthRange || [
                    0,
                    1
                ],
                func: this.sceneConfig.depthFunc || "<="
            },
            blend: {
                enable: (e, t)=>void 0 === t.hasAlpha || !!t.hasAlpha,
                func: this.getBlendFunc(),
                equation: "add"
            },
            polygonOffset: {
                enable: !0,
                offset: this.getPolygonOffset()
            }
        }, o = {
            uniforms: i,
            defines: this._getDefines(n),
            extraCommandProps: r
        };
        this.shader = new (0, $2wazW).pbr.StandardShader(o), o.frag = "\n            precision mediump float;\n            #include <gl2_frag>\n            void main() {\n                glFragColor = vec4(0.0);\n                #if __VERSION__ == 100\n                    gl_FragColor = glFragColor;\n                #endif\n            }\n        ", this._updateDepthShader = new (0, $2wazW).pbr.StandardShader(o);
    }
    _onTextureLoad({ resources: e }) {
        for(let t = 0; t < e.length; t++)this.addCachedTexture(e[t].url, e[t].data);
        this.setToRedraw(!0);
    }
    _onMaterialComplete() {
        this.setToRedraw(!0);
    }
    _updateMaterial(t) {
        if (t) {
            const e = this.getSymbols()[0].material;
            e && $435bc7696844e930$var$we(e, t);
        }
        const n = this.layer instanceof $gP1US.TileLayer, i = this.dataConfig, r = t || this.getSymbols()[0].material, o = {};
        let a = !1;
        for(const e in r)if ($435bc7696844e930$var$Ne(r, e)) {
            if (e.indexOf("Texture") > 0) {
                let t = r[e];
                if (!t) {
                    o[e] = void 0;
                    continue;
                }
                const n = "string" == typeof t ? t : t.url, l = this.getCachedTexture(n);
                l ? l.then ? n === t ? t = {
                    promise: l,
                    wrap: "repeat"
                } : t.promise = l : n === t ? t = {
                    data: l,
                    wrap: "repeat"
                } : t.data = l : n === t && (t = {
                    url: n,
                    wrap: "repeat"
                }), t.flipY = !i.upsideUpTexture, t.min = "linear mipmap linear", t.mag = "linear", o[e] = new (0, $2wazW).Texture2D(t, this._loader), o[e].once("complete", this._bindedOnTextureLoad), o[e].once("disposed", this._bindDisposeCachedTexture), o[e].promise && this.addCachedTexture(n, o[e].promise), a = !0;
            } else o[e] = r[e], "uvRotation" === e && (o[e] = Math.PI * o[e] / 180, n || (o[e] *= -1));
        }
        if (void 0 === o.alphaTest && this.getMaterialClazz && (o.alphaTest = .05), this.material) {
            for(let e in o)this.material.set(e, o[e]);
            this.setToRedraw(!0);
        } else this.material = new (0, $2wazW).pbr.StandardMaterial(o), this.material.once("complete", this._bindOnMaterialComplete);
        a || this._onMaterialComplete();
    }
    getShader() {
        return this.shader;
    }
    getUniformValues(e, t) {
        const { iblTexes: n, dfgLUT: i } = this.getIBLRes(), r = $435bc7696844e930$var$Gs(e, n, i, t && t.ssr, t && t.jitter);
        return this.setIncludeUniformValues(r, t), r;
    }
    _getDefines(e) {
        return this.hasIBL() ? e.HAS_IBL_LIGHTING = 1 : delete e.HAS_IBL_LIGHTING, e;
    }
    _onUpdatelights() {
        if (!this.shader) return;
        const e = this.shader.shaderDefines;
        this._getDefines(e), this.shader.shaderDefines = e;
    }
}
var $435bc7696844e930$var$Ws = "#include <gl2_vert>\n#define EXTRUDE_SCALE 63.0\n#define EXTRUDE_MOD 64.0\n#define MAX_LINE_DISTANCE 65535.0\nuniform mat4 projViewModelMatrix;\nuniform mat4 positionMatrix;\nuniform vec2 centiMeterToLocal;\n#ifdef HAS_ALTITUDE\nattribute vec2 aPosition;\nattribute float aAltitude;\n#else\nattribute vec3 aPosition;\n#endif\nattribute vec4 aTubeNormal;\n#ifdef HAS_LINE_WIDTH\nattribute float aLineWidth;\n#else\nuniform float lineWidth;\n#endif\n#include <vt_position_vert>\n#ifdef PICKING_MODE\n#include <fbo_picking_vert>\n#else\nuniform mat4 modelViewMatrix;\nuniform mat3 modelNormalMatrix;\nuniform mat4 modelMatrix;\n#if defined(HAS_PATTERN)\nuniform float resolution;\nuniform float tileResolution;\nuniform float tileRatio;\nattribute float aLinesofar;\nvarying highp float vLinesofar;\nattribute vec4 aTexInfo;\nvarying vec4 vTexInfo;\nvarying float vNormalY;\nvarying float vPatternHeight;\nattribute float aNormalDistance;\n#if defined(HAS_PATTERN_ANIM)\nattribute float aLinePatternAnimSpeed;\nvarying float vLinePatternAnimSpeed;\n#endif\n#if defined(HAS_PATTERN_GAP)\nattribute float aLinePatternGap;\nvarying float vLinePatternGap;\n#endif\n#endif\n#ifdef HAS_COLOR\nattribute vec4 aColor;\nvarying vec4 vColor;\n#endif\n#ifdef HAS_OPACITY\nattribute float aOpacity;\n#endif\nvarying float vOpacity;\nvarying vec3 vModelNormal;\nvarying vec4 vViewVertex;\nvarying vec3 vModelVertex;\n#endif\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n#include <vsm_shadow_vert>\n#endif\n#include <highlight_vert>\nvoid main() {\n  \n#ifdef HAS_LINE_WIDTH\nfloat c = aLineWidth;\n#else\nfloat c = lineWidth;\n#endif\nfloat d = c / 2.;\n  vec3 e = aTubeNormal.xyz / EXTRUDE_SCALE;\n  vec3 f = unpackVTPosition();\n  vec4 h = vec4(f, 1.);\n  h.xy += e.xy * d * centiMeterToLocal;\n  h.z += e.z * d;\n  gl_Position = projViewModelMatrix * h;\n#ifdef PICKING_MODE\nfbo_picking_setData(gl_Position.w, true);\n#else\nvViewVertex = modelViewMatrix * h;\n  vec3 i = normalize(e);\n  vModelNormal = modelNormalMatrix * i;\n  vModelVertex = (modelMatrix * h).xyz;\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\nshadow_computeShadowPars(h);\n#endif\n#ifdef HAS_COLOR\nvColor = aColor / 255.;\n#endif\n#ifdef HAS_OPACITY\nvOpacity = aOpacity / 255.;\n#else\nvOpacity = 1.;\n#endif\n#ifdef HAS_PATTERN\nfloat j = tileResolution / resolution;\n  float k = aLinesofar - d * centiMeterToLocal.y * aNormalDistance / EXTRUDE_SCALE;\n  vLinesofar = k / tileRatio * j;\n  vTexInfo = vec4(aTexInfo.xy, aTexInfo.zw + 1.);\n  vPatternHeight = c * centiMeterToLocal.x / tileRatio * j;\n  vNormalY = aTubeNormal.w / EXTRUDE_SCALE;\n#if defined(HAS_PATTERN_ANIM)\nvLinePatternAnimSpeed = aLinePatternAnimSpeed / 127.;\n#endif\n#if defined(HAS_PATTERN_GAP)\nvLinePatternGap = aLinePatternGap / 10.0;\n#endif\n#endif\nhighlight_setVarying();\n#endif\n}";
const { StyleUtil: $435bc7696844e930$var$Xs } = $435bc7696844e930$var$H(), { getPBRUniforms: $435bc7696844e930$var$Ys } = (0, $2wazW).pbr.PBRUtils;
class $435bc7696844e930$var$Zs extends $435bc7696844e930$var$gn {
    needToRedraw() {
        return super.needToRedraw() || this.isAnimating();
    }
    isTerrainSkin() {
        return !1;
    }
    isTerrainVector() {
        return !0;
    }
    isUniqueStencilRefPerTile() {
        return !1;
    }
    supportRenderMode(e) {
        return this.isAnimating() ? "fxaa" === e || "fxaaAfterTaa" === e : "taa" === e || "fxaa" === e;
    }
    isAnimating() {
        if (this._hasPatternAnim) return !0;
        const e = this.getSymbols();
        for(let t = 0; t < e.length; t++)if (e[t].linePatternFile && e[t].linePatternAnimSpeed) return !0;
        return !1;
    }
    isBloom(e) {
        return !!this.getSymbol(e.properties.symbolIndex).lineBloom;
    }
    createMesh(t, n) {
        if (!t.geometry) return null;
        const i = this.getMap(), { geometry: r, symbolIndex: o, ref: a } = t, l = this.getSymbolDef(o);
        if (void 0 === a) $435bc7696844e930$var$wt(r, l, this.getFnTypeConfig(o), this.layer);
        const h = this.getSymbol(o), { tileResolution: c, tileRatio: u } = r.properties, f = {
            tileResolution: c,
            tileRatio: u
        };
        $435bc7696844e930$var$ke(f, "lineColor", h, "lineColor", "#fff", $435bc7696844e930$var$Re(this.colorCache)), $435bc7696844e930$var$ke(f, "linePatternGapColor", h, "linePatternGapColor", [
            1,
            1,
            1,
            1
        ], $435bc7696844e930$var$Re(this.colorCache)), $435bc7696844e930$var$ke(f, "lineWidth", h, "lineWidth", 2, (e)=>$435bc7696844e930$var$Xs.getTubeSizeScale(this.dataConfig.metric) * e), $435bc7696844e930$var$ke(f, "lineOpacity", h, "lineOpacity", 1), $435bc7696844e930$var$ke(f, "linePatternAnimSpeed", h, "linePatternAnimSpeed", 0), $435bc7696844e930$var$ke(f, "linePatternGap", h, "linePatternGap", 0), $435bc7696844e930$var$ke(f, "metallicFactor", h, "metallicFactor", 0), $435bc7696844e930$var$ke(f, "roughnessFactor", h, "roughnessFactor", .4), $435bc7696844e930$var$ke(f, "emissiveFactor", h, "emissiveFactor", [
            0,
            0,
            0
        ]), $435bc7696844e930$var$ke(f, "uvScale", h, "uvScale", [
            1,
            1
        ]);
        const d = r.properties.iconAtlas, p = this.layer instanceof $gP1US.TileLayer;
        d && (f.linePatternFile = $435bc7696844e930$var$yn(this.regl, d, !1), f.atlasSize = d ? [
            d.width,
            d.height
        ] : [
            0,
            0
        ], f.flipY = p ? -1 : 1, this.drawDebugAtlas(d)), void 0 === a && r.generateBuffers(this.regl), f.alphaTest = -1;
        const g = new (0, $2wazW).pbr.StandardMaterial(f), m = new (0, $2wazW).Mesh(r, g, {
            castShadow: !1,
            picking: !0
        }), y = i.distanceToPointAtRes(100, 100, r.properties.tileResolution)._multi(u / 1e4).toArray();
        m.setUniform("centiMeterToLocal", y);
        const x = i.getResolution(i.getMaxNativeZoom());
        m.setUniform("animSpeedScale", c / x), m.setLocalTransform(n);
        const _ = {
            IS_LINE_EXTRUSION: 1,
            HAS_LAYER_OPACITY: 1
        };
        return "square-tube" === this.dataConfig.type && (_.IS_SQUARE_TUBE = 1), d && (_.HAS_PATTERN = 1), m.properties.symbolIndex = o, r.data.aColor && (_.HAS_COLOR = 1), this.setMeshDefines(_, r, l), r.data.aAltitude && (_.HAS_ALTITUDE = 1), m.setDefines(_), m;
    }
    setMeshDefines(e, t, n) {
        t.data.aOpacity && (e.HAS_OPACITY = 1), t.data.aLineWidth && (e.HAS_LINE_WIDTH = 1), $435bc7696844e930$var$Lt(n.linePatternAnimSpeed) && (e.HAS_PATTERN_ANIM = 1), $435bc7696844e930$var$Lt(n.linePatternGap) && (e.HAS_PATTERN_GAP = 1);
    }
    paint(e) {
        e.states && e.states.includesChanged.shadow && (this.shader.dispose(), this.createShader(e)), super.paint(e);
    }
    init(e) {
        this.getMap().on("updatelights", this._onUpdatelights, this), this.createIBLTextures();
        const t = this.regl;
        if (this.renderer = new (0, $2wazW).Renderer(t), this.createShader(e), this.pickingFBO) {
            const e = [];
            this.picking = [
                new (0, $2wazW).FBORayPicking(this.renderer, {
                    vert: "#define PICKING_MODE 1\n" + $435bc7696844e930$var$Ws,
                    uniforms: [
                        {
                            name: "projViewModelMatrix",
                            type: "function",
                            fn: function(e, t) {
                                const n = [];
                                return (0, $3iqbd).multiply(n, t.projViewMatrix, t.modelMatrix), n;
                            }
                        },
                        {
                            name: "modelNormalMatrix",
                            type: "function",
                            fn: (t, n)=>(0, $bDSmI).fromMat4(e, n.modelMatrix)
                        }
                    ],
                    extraCommandProps: this.getExtraCommandProps()
                }, this.pickingFBO, this.getMap())
            ];
        }
    }
    createShader(e) {
        this._context = e;
        const t = [], n = {};
        this.fillIncludes(n, t, e), t.push({
            name: "projViewModelMatrix",
            type: "function",
            fn: function(e, t) {
                const n = [];
                return (0, $3iqbd).multiply(n, t.projViewMatrix, t.modelMatrix), n;
            }
        }), this.shader = new (0, $2wazW).pbr.StandardShader({
            vert: $435bc7696844e930$var$Ws,
            uniforms: t,
            defines: this._getDefines(n),
            extraCommandProps: this.getExtraCommandProps()
        });
    }
    getExtraCommandProps() {
        const e = this.canvas, t = {
            x: 0,
            y: 0,
            width: ()=>e ? e.width : 1,
            height: ()=>e ? e.height : 1
        }, n = this.sceneConfig.depthRange;
        return {
            viewport: t,
            stencil: {
                enable: !0,
                func: {
                    cmp: ()=>"<=",
                    ref: (e, t)=>t.level
                },
                op: {
                    fail: "keep",
                    zfail: "keep",
                    zpass: "replace"
                }
            },
            cull: {
                enable: ()=>!!this.sceneConfig.cullFace,
                face: this.sceneConfig.cullFace || "back"
            },
            depth: {
                enable: !0,
                range: n || [
                    0,
                    1
                ],
                mask: this.sceneConfig.depthMask || !0,
                func: this.sceneConfig.depthFunc || "<="
            },
            blend: {
                enable: !0,
                func: this.getBlendFunc(),
                equation: "add"
            },
            polygonOffset: {
                enable: !0,
                offset: this.getPolygonOffset()
            }
        };
    }
    getUniformValues(e, t) {
        const { iblTexes: n, dfgLUT: i } = this.getIBLRes(), r = $435bc7696844e930$var$Ys(e, n, i, null, t && t.jitter), s = e.projViewMatrix, o = e.viewMatrix;
        return r.projViewMatrix = s, r.viewMatrix = o, r.resolution = e.getResolution(), r.currentTime = this.layer.getRenderer().getFrameTimestamp() || 0, this.setIncludeUniformValues(r, t), r;
    }
    createFnTypeConfig(e, t) {
        const n = (0, $14507960c5dac0fb$export$79e978600dd1e509)(t.lineColor), i = (0, $14507960c5dac0fb$export$79e978600dd1e509)(t.aLinePatternAnimSpeed), r = (0, $14507960c5dac0fb$export$79e978600dd1e509)(t.aLinePatternGap), s = this.createShapeFnTypeConfigs(e, t), o = new Int8Array(2);
        return [
            {
                attrName: "aColor",
                symbolName: "lineColor",
                type: Uint8Array,
                width: 4,
                define: "HAS_COLOR",
                evaluate: (t, i)=>{
                    let r = n(e.getZoom(), t);
                    return (0, $14507960c5dac0fb$export$ec423ecbfcdb9a06)(r) && (r = this.evaluateInFnTypeConfig(r, i, e, t, !0)), Array.isArray(r) || (r = this.colorCache[r] = this.colorCache[r] || (0, (/*@__PURE__*/$parcel$interopDefault($08acccbbd431ef55$exports)))(r).unitArray()), r = $435bc7696844e930$var$Oe(r), r;
                }
            },
            {
                attrName: "aLinePattern",
                symbolName: "linePatternAnimSpeed",
                type: Int8Array,
                width: 2,
                related: [
                    "linePatternGap"
                ],
                define: "HAS_LINE_PATTERN",
                evaluate: (t, n, r, s)=>{
                    let a = i(e.getZoom(), t);
                    return $435bc7696844e930$var$Ie(a) && (a = 0), 0 !== a && (n.properties.hasPatternAnim = 1), o[0] = a / 127, o[1] = r[s + 1], o;
                }
            },
            {
                attrName: "aLinePattern",
                symbolName: "linePatternGap",
                type: Int8Array,
                width: 2,
                related: [
                    "linePatternAnimSpeed"
                ],
                define: "HAS_LINE_PATTERN",
                evaluate: (t, n, i, s)=>{
                    let a = r(e.getZoom(), t);
                    return $435bc7696844e930$var$Ie(a) && (a = 0), o[1] = 10 * a, o[0] = i[s], o;
                }
            }
        ].concat(s);
    }
    createShapeFnTypeConfigs(e, t) {
        const n = (0, $14507960c5dac0fb$export$b5e0f6446c9b8e3c)(t.lineWidth), i = (0, $14507960c5dac0fb$export$b5e0f6446c9b8e3c)(t.lineOpacity), r = new Uint16Array(1);
        return [
            {
                attrName: "aLineWidth",
                symbolName: "lineWidth",
                type: Uint8Array,
                width: 1,
                define: "HAS_LINE_WIDTH",
                evaluate: (t, i)=>{
                    let s = n(e.getZoom(), t);
                    return (0, $14507960c5dac0fb$export$ec423ecbfcdb9a06)(s) && (s = this.evaluateInFnTypeConfig(s, i, e, t)), r[0] = Math.round(2 * s), r[0];
                }
            },
            {
                attrName: "aOpacity",
                symbolName: "lineOpacity",
                type: Uint8Array,
                width: 1,
                define: "HAS_OPACITY",
                evaluate: (t, n)=>{
                    let s = i(e.getZoom(), t);
                    return (0, $14507960c5dac0fb$export$ec423ecbfcdb9a06)(s) && (s = this.evaluateInFnTypeConfig(s, n, e, t)), r[0] = 255 * s, r[0];
                }
            }
        ];
    }
    _getDefines(e) {
        return this.hasIBL() ? e.HAS_IBL_LIGHTING = 1 : delete e.HAS_IBL_LIGHTING, e;
    }
    _onUpdatelights() {
        if (!this.shader) return;
        const e = this.shader.shaderDefines;
        this._getDefines(e), this.shader.shaderDefines = e;
    }
    delete() {
        super.delete(), this.disposeIBLTextures(), this.shader && (this.shader.dispose(), delete this.shader);
    }
}
const { PackUtil: $435bc7696844e930$var$qs } = $435bc7696844e930$var$H(), $435bc7696844e930$var$$s = [], $435bc7696844e930$var$Js = [], $435bc7696844e930$var$Ks = [], $435bc7696844e930$var$Qs = [], $435bc7696844e930$var$eo = [], $435bc7696844e930$var$to = [], $435bc7696844e930$var$no = [
    0,
    0,
    0
], $435bc7696844e930$var$io = [
    0,
    0,
    0
], $435bc7696844e930$var$ro = [
    1,
    1,
    1
], $435bc7696844e930$var$so = [], $435bc7696844e930$var$oo = [
    1,
    1,
    1,
    1
], $435bc7696844e930$var$ao = [], $435bc7696844e930$var$lo = [
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    -1,
    0,
    0,
    0,
    0,
    0,
    1
], $435bc7696844e930$var$ho = (e)=>class extends e {
        constructor(e, t, n, i, r, o){
            super(e, t, n, i, r, o), this._ready = !1, this.scene.sortFunction = this.sortByCommandKey;
            const a = i.fetchOptions || {};
            a.referrer = window && window.location.href, this._gltfManager = e.gltfManager = e.gltfManager || new (0, $2wazW).GLTFManager(e, {
                fetchOptions: a,
                urlModifier: (e)=>{
                    const n = t.getURLModifier();
                    return n && n(e) || e;
                }
            }), this._initTRSFuncType(), this._initGLTF();
        }
        isUniqueStencilRefPerTile() {
            return !1;
        }
        isAnimating() {
            const e = this.getSymbols();
            for(let t = 0; t < e.length; t++){
                if (e[t] && this._gltfPack[t] && this._isSkinAnimating(t)) return !0;
            }
            return !1;
        }
        createGeometry(e, t) {
            const { data: n, positionSize: i } = e;
            return {
                geometry: {
                    properties: $435bc7696844e930$var$we({}, e.properties),
                    data: n,
                    positionSize: i,
                    features: t
                },
                symbolIndex: e.symbolIndex
            };
        }
        getFnTypeConfig() {
            return $435bc7696844e930$var$so;
        }
        createMesh(e, t, { tileTranslationMatrix: n, tileExtent: i, tilePoint: r }, { timestamp: l }) {
            if (!this._ready) return null;
            const h = this.getMap(), { geometry: c } = e, { positionSize: u, features: f } = c;
            if (!c.data.aPosition || 0 === c.data.aPosition.length) return null;
            "native-line" === this.dataConfig.type && this._arrangeAlongLine(0, c, r);
            const { aPosition: d, aPickingId: p, aXYRotation: g, aZRotation: m, aAltitude: y } = c.data;
            let x = d.length / u;
            const _ = {
                instance_vectorA: new Float32Array(4 * x),
                instance_vectorB: new Float32Array(4 * x),
                instance_vectorC: new Float32Array(4 * x),
                aPickingId: []
            }, v = this._updateInstanceData(_, n, i, c.properties.z, d, y, g, m, u, p, f);
            c.data.aTerrainAltitude && (_.aTerrainAltitude = c.data.aTerrainAltitude);
            const b = {}, A = _.aPickingId, T = function(e) {
                const t = new Map;
                for(let n = 0; n < e.length; n++){
                    const i = e[n];
                    let r = t.get(i);
                    r || (r = [], t.set(i, r)), r.push(n);
                }
                return t;
            }(A);
            for(const e in _)b[e] = {
                buffer: this.regl.buffer({
                    dimension: _[e].length / x,
                    data: _[e]
                }),
                divisor: 1
            };
            const S = this._hasFuncType(), w = this._getMeterScale(), M = (0, $3iqbd).identity([]);
            (0, $3iqbd).scale(M, M, [
                w,
                w,
                w
            ]);
            const P = [], I = this.getSymbols();
            for(let e = 0; e < I.length; e++){
                const t = I[e], i = this._gltfMeshInfos[e];
                if (!i) continue;
                const r = this._gltfPack[e][0], { fixSizeOnZoom: u } = t;
                let f = (0, $3iqbd).identity([]);
                S || (f = this._getSymbolTRSMatrix(f));
                let d = 0;
                i.forEach((e)=>{
                    const { geometry: n, nodeMatrix: i } = e;
                    (0, $3iqbd).multiply($435bc7696844e930$var$ao, $435bc7696844e930$var$lo, i), (0, $3iqbd).multiply($435bc7696844e930$var$ao, f, $435bc7696844e930$var$ao);
                    const r = (0, $3iqbd).multiply($435bc7696844e930$var$ao, M, $435bc7696844e930$var$ao), s = n.boundingBox.copy();
                    s.transform(r);
                    const o = this._calAnchorTranslation(s, t);
                    Math.abs(o) > Math.abs(d) && (d = o);
                });
                const p = [
                    0,
                    0,
                    d
                ], g = i.map((i, g)=>{
                    const { geometry: m, materialInfo: y, morphWeights: S, extraInfo: w, nodeIndex: P } = i;
                    t.alphaTest && (y.alphaTest = t.alphaTest);
                    const I = new (this.getMaterialClazz(y))(y), C = {}, k = new (0, $2wazW).InstancedMesh(b, x, m, I, {
                        transparent: !1,
                        picking: !0
                    });
                    if (r.hasSkinAnimation()) {
                        const t = this._updateAnimation(k, e, 0)[P];
                        k.setUniform("jointTexture", t.jointTexture), k.setUniform("jointTextureSize", t.jointTextureSize), k.setUniform("numJoints", t.numJoints), k.setUniform("skinAnimation", +this._isSkinAnimating(e)), k.properties.startTime = l, C.HAS_SKIN = 1;
                    }
                    S && (k.setUniform("morphWeights", S), C.HAS_MORPH = 1), k.setUniform("hasAlpha", w.alphaMode && "BLEND" === w.alphaMode.toUpperCase()), $435bc7696844e930$var$ke(k.uniforms, "polygonFill", t, "markerFill", $435bc7696844e930$var$oo, $435bc7696844e930$var$Re(this.colorCache)), $435bc7696844e930$var$ke(k.uniforms, "polygonOpacity", t, "markerOpacity", 1);
                    const F = [];
                    k.setPositionMatrix(()=>{
                        const t = this._getMeshNodeMatrix(e, g, P);
                        (0, $3iqbd).multiply(F, $435bc7696844e930$var$lo, t), (0, $3iqbd).multiply(F, f, F), (0, $3iqbd).multiply(F, M, F);
                        const n = (0, $3iqbd).identity($435bc7696844e930$var$ao);
                        if (0 !== d && ((0, $3iqbd).fromTranslation(n, p), (0, $3iqbd).multiply(F, n, F)), $435bc7696844e930$var$Le(u)) {
                            const e = h.getGLScale() / h.getGLScale(u);
                            return (0, $eIStk).set($435bc7696844e930$var$$s, e, e, e), (0, $3iqbd).fromScaling(n, $435bc7696844e930$var$$s), (0, $3iqbd).multiply(n, n, F);
                        }
                        return F;
                    });
                    const O = this.layer.getRenderer().getZScale(), R = [], E = [];
                    return k.setLocalTransform(()=>{
                        const e = this.layer.options.altitude || 0;
                        return (0, $eIStk).copy(E, v), E[2] += 100 * e * O, (0, $3iqbd).translate(R, n, E), R;
                    }), m.generateBuffers(this.regl, {
                        excludeElementsInVAO: !0
                    }), _.instance_color && (C.HAS_INSTANCE_COLOR = 1), _.aTerrainAltitude && (C.HAS_INSTANCE_TERRAIN_ALTITUDE = 1, k.setUniform("terrainAltitudeScale", 100 * this.layer.getRenderer().getZScale())), C.HAS_LAYER_OPACITY = 1, $435bc7696844e930$var$we(k.properties, c.properties), k.properties.aPickingId = A, k.properties.nodeIndex = P, k.properties.pickingIdIndiceMap = T, k.setDefines(C), k.properties.symbolIndex = {
                        index: e
                    }, k;
                });
                P.push(...g);
            }
            return P.insContext = {
                instanceData: _,
                tileTranslationMatrix: n,
                tileExtent: i,
                aPosition: d,
                positionSize: u
            }, P;
        }
        _arrangeAlongLine(e, t) {
            const { tileExtent: n, z: r } = t.properties, { data: s, positionSize: a } = t;
            let l = this._calGLTFScale(e);
            const h = this._getMeterScale();
            l = (0, $eIStk).scale([], l, h);
            const c = {
                gapLength: this.dataConfig.gapLength || 0,
                direction: this.dataConfig.direction || 0,
                scaleVertex: !0
            }, u = this._gltfPack[0][0], { aPosition: f, aAltitude: d, aPickingId: p } = s, g = new (0, $gP1US.Coordinate)(0, 0, 0), m = new (0, $gP1US.Coordinate)(0, 0, 0), y = [], x = d ? [] : y, _ = [], v = [], b = [], A = [], T = [], S = this.layer.getTileSize().width / n * this.layer.getRenderer().getTileGLScale(r), w = this.layer.getRenderer().getZScale();
            let M = p[0];
            for(let e = 0; e < f.length - a; e += a){
                const t = p[e / a + 1];
                if (t !== M) {
                    M = t;
                    continue;
                }
                d ? (0, $eIStk).set(A, f[e], f[e + 1], d[e / a]) : $435bc7696844e930$var$qs.unpackPosition(A, f[e], f[e + 1], f[e + 2]);
                const [n, i, r] = A;
                let s = e + a;
                d ? (0, $eIStk).set(T, f[s], f[s + 1], d[s / a]) : $435bc7696844e930$var$qs.unpackPosition(T, f[s], f[s + 1], f[s + 2]);
                const [h, P, I] = T, C = p[e / a], k = g.set(n * S, i * S, r * w), F = m.set(h * S, P * S, I * w), O = k.distanceTo(F), R = u.arrangeAlongLine(k, F, O, l, 1, c);
                for(let e = 0; e < R.length; e++){
                    const t = R[e];
                    g.set(n, i, r), m.set(h, P, I);
                    const s = $435bc7696844e930$var$co(g, m, t.t);
                    y.push(s.x, s.y), x.push(s.z), _.push(C), v.push(-t.rotationZ * Math.PI / 180), b.push(t.rotationXY * Math.PI / 180);
                }
            }
            t.data = {
                aPosition: new f.constructor(y),
                aPickingId: new p.constructor(_),
                aZRotation: v,
                aXYRotation: b
            }, d && (t.data.aAltitude = new d.constructor(x));
        }
        _calGLTFScale(e) {
            const t = this.getSymbols()[e], n = [
                1,
                1,
                1
            ], i = t.modelHeight;
            if (i) this._gltfPack[e][0].calModelHeightScale(n, i);
            return (0, $eIStk).set($435bc7696844e930$var$eo, t.scaleX || 1, t.scaleY || 1, t.scaleZ || 1), (0, $eIStk).multiply(n, n, $435bc7696844e930$var$eo);
        }
        _getMeshNodeMatrix(e, t, n) {
            const i = e, r = this._gltfMeshInfos[i][t];
            return this._isSkinAnimating(e) && this._nodeMatrixMap && this._nodeMatrixMap[n] || r.nodeMatrix;
        }
        _updateAnimation(e, t, n) {
            if (!this._gltfPack) return;
            const i = this._gltfPack[t][0];
            this._skinMap || (this._skinMap = {}), this._nodeMatrixMap = {}, this._skinMap[e.uuid] || (this._skinMap[e.uuid] = {});
            const r = this.getSymbols()[t], s = this._gltfJSON[t], { loop: o, speed: a, animationName: l } = r, h = l || s.animations[0].name;
            return i.updateAnimation(n, o || !1, a || 1, h, e.properties.startTime || 0, this._nodeMatrixMap, this._skinMap[e.uuid]), this._skinMap[e.uuid];
        }
        _calAnchorTranslation(e, t) {
            const n = t.anchorZ || "center";
            let i = 0;
            const r = e.max[2] - e.min[2];
            return "bottom" === n ? i = r / 2 : "top" === n && (i = -r / 2), i;
        }
        addMesh(e, t, n) {
            if (!e) return null;
            if (e[0].properties.level > 2) return null;
            const i = n.timestamp;
            for(let t = 0; t < e.length; t++){
                if (!e[t] || !e[t].geometry) continue;
                e[t].instancedData.aTerrainAltitude && this._updateTerrainAltitude(e[t], e[t].instancedData, e[t].properties, 3, n);
                const r = e[t].properties.symbolIndex.index, s = this._isSkinAnimating(r);
                s && this._updateAnimation(e[t], r, i), e[t].setUniform("skinAnimation", +s), this._highlightMesh(e[t]);
            }
            return this.scene.addMesh(e), this;
        }
        _updateATerrainAltitude(e, t) {
            e && e.updateInstancedData && e.updateInstancedData("aTerrainAltitude", t);
        }
        prepareRender(e) {
            const t = this.getSymbols();
            let n = !1;
            for(let e = 0; e < t.length; e++){
                if (!t[e] || !this._gltfPack[e]) continue;
                if (this._isSkinAnimating(e) && this._gltfPack[e] && !n) {
                    n = !0;
                    break;
                }
            }
            n && this.setToRedraw(!0), super.prepareRender(e);
        }
        getShadowMeshes() {
            if (!this.isVisible()) return $435bc7696844e930$var$so;
            this.shadowCount = this.scene.getMeshes().length;
            return this.scene.getMeshes().filter((e)=>0 === e.properties.level);
        }
        _isSkinAnimating(e) {
            const t = this.getSymbols()[e];
            return !!(t && t.animation && this._gltfPack[e] && this._gltfPack[e][0] && this._gltfPack[e][0].hasSkinAnimation());
        }
        _updateInstanceData(e, t, n, i, r, s, l, h, c, u, f) {
            function d(t, n, i, r) {
                e[t][4 * n] = i[r], e[t][4 * n + 1] = i[r + 4], e[t][4 * n + 2] = i[r + 8], e[t][4 * n + 3] = i[r + 12];
            }
            const p = r.length / c, g = this.layer.getTileSize().width / n * this.layer.getRenderer().getTileGLScale(i), m = this.layer.getRenderer().getZScale(), y = 100 * (this.dataConfig.altitudeOffset || 0);
            let x = 1 / 0, _ = 1 / 0, v = 1 / 0, b = -1 / 0, A = -1 / 0, T = -1 / 0;
            const S = [], w = [];
            for(let e = 0; e < p; e++){
                s ? (0, $eIStk).set(w, r[e * c], r[e * c + 1], s[e]) : $435bc7696844e930$var$qs.unpackPosition(w, r[e * c], r[e * c + 1], r[e * c + 2]);
                const t = (0, $eIStk).set(S, w[0] * g, -w[1] * g, (w[2] + y) * m);
                t[0] < x && (x = t[0]), t[0] > b && (b = t[0]), t[1] < _ && (_ = t[1]), t[1] > A && (A = t[1]), t[2] < v && (v = t[2]), t[2] > T && (T = t[2]);
            }
            const M = (x + b) / 2, P = (_ + A) / 2, I = (v + T) / 2, C = [], k = this._hasFuncType(), F = [
                0,
                0,
                1
            ], O = [
                0,
                0,
                0
            ];
            for(let t = 0; t < p; t++){
                s ? (0, $eIStk).set(w, r[t * c], r[t * c + 1], s[t]) : $435bc7696844e930$var$qs.unpackPosition(w, r[t * c], r[t * c + 1], r[t * c + 2]);
                const n = w[0], i = w[1], p = (0, $eIStk).set(S, n * g - M, -i * g - P, (w[2] + y) * m - I), x = l && l[t] || 0, _ = h && h[t] || 0;
                if (x || _) {
                    (0, $3iqbd).fromRotation(C, _, F);
                    const e = (0, $eIStk).set($435bc7696844e930$var$$s, Math.cos(_), Math.sin(_), 0), t = (0, $eIStk).rotateZ(e, e, O, 90 * Math.PI / 180);
                    (0, $3iqbd).rotate(C, C, x, t);
                    const n = (0, $3iqbd).fromTranslation($435bc7696844e930$var$ao, p);
                    (0, $3iqbd).multiply(C, n, C);
                } else (0, $3iqbd).fromTranslation(C, p);
                if (k) {
                    const e = this._getSymbolTRSMatrix($435bc7696844e930$var$ao, f, u, t);
                    (0, $3iqbd).multiply(C, C, e);
                }
                d("instance_vectorA", t, C, 0), d("instance_vectorB", t, C, 1), d("instance_vectorC", t, C, 2), e.aPickingId[t] = u[t];
            }
            return (0, $eIStk).set(S, M, P, I), S;
        }
        _getMeterScale() {
            if (!this._meterScale) {
                const e = this.getMap();
                this._meterScale = 100 * $435bc7696844e930$var$$(e.getGLRes(), e);
            }
            return this._meterScale;
        }
        _getSymbolTRSMatrix(e, t, n, i) {
            const r = this.getMap(), s = this.symbolDef[0], a = this._getMeterScale();
            let l = s.translationX || 0, h = s.translationY || 0, c = s.translationZ || 0, u = s.rotationX || 0, f = s.rotationY || 0, d = s.rotationZ || 0, p = s.scaleX || 1, g = s.scaleY || 1, m = s.scaleZ || 1;
            const y = n && n[i], x = t && t[y], _ = r.getZoom(), v = x && x.feature && x.feature.properties, b = this._getModelHeightScale(_, v);
            this._txFn && (l = this._txFn(_, v)), this._tyFn && (h = this._tyFn(_, v)), this._tzFn && (c = this._tzFn(_, v));
            const A = (0, $eIStk).set($435bc7696844e930$var$Js, l * a, h * a, c * a);
            this._rxFn && (u = this._rxFn(_, v)), this._ryFn && (f = this._ryFn(_, v)), this._rzFn && (d = this._rzFn(_, v));
            const T = (0, $eIStk).set($435bc7696844e930$var$Ks, u, f, d);
            this._sxFn && (p = this._sxFn(_, v)), this._syFn && (g = this._syFn(_, v)), this._szFn && (m = this._szFn(_, v));
            const S = (0, $eIStk).set($435bc7696844e930$var$Qs, p * b, g * b, m * b);
            return this._getGLTFMatrix(e, A, T, S);
        }
        _getModelHeightScale(e, t) {
            const n = this.symbolDef[0];
            let i = this._modelHeightFn ? this._modelHeightFn(e, t) : n.modelHeight;
            if ($435bc7696844e930$var$X(i)) return 1;
            const r = this._gltfBBox[0];
            return i / Math.abs(r.max[1] - r.min[1]);
        }
        getShaderConfig() {
            const e = super.getShaderConfig();
            return e.positionAttribute = "POSITION", e.normalAttribute = "NORMAL", e;
        }
        init(e) {
            super.init(e), this._initGLTF();
        }
        _initTRSFuncType() {
            const e = this.symbolDef[0];
            (0, $14507960c5dac0fb$export$ec423ecbfcdb9a06)(e.modelHeight) && (this._modelHeightFn = (0, $14507960c5dac0fb$export$b5e0f6446c9b8e3c)(e.modelHeight)), (0, $14507960c5dac0fb$export$ec423ecbfcdb9a06)(e.translationX) && (this._txFn = (0, $14507960c5dac0fb$export$b5e0f6446c9b8e3c)(e.translationX)), (0, $14507960c5dac0fb$export$ec423ecbfcdb9a06)(e.translationY) && (this._tyFn = (0, $14507960c5dac0fb$export$b5e0f6446c9b8e3c)(e.translationY)), (0, $14507960c5dac0fb$export$ec423ecbfcdb9a06)(e.translationZ) && (this._tzFn = (0, $14507960c5dac0fb$export$b5e0f6446c9b8e3c)(e.translationZ)), (0, $14507960c5dac0fb$export$ec423ecbfcdb9a06)(e.rotationX) && (this._rxFn = (0, $14507960c5dac0fb$export$b5e0f6446c9b8e3c)(e.rotationX)), (0, $14507960c5dac0fb$export$ec423ecbfcdb9a06)(e.rotationY) && (this._ryFn = (0, $14507960c5dac0fb$export$b5e0f6446c9b8e3c)(e.rotationY)), (0, $14507960c5dac0fb$export$ec423ecbfcdb9a06)(e.rotationZ) && (this._rzFn = (0, $14507960c5dac0fb$export$b5e0f6446c9b8e3c)(e.rotationZ)), (0, $14507960c5dac0fb$export$ec423ecbfcdb9a06)(e.scaleX) && (this._sxFn = (0, $14507960c5dac0fb$export$b5e0f6446c9b8e3c)(e.scaleX)), (0, $14507960c5dac0fb$export$ec423ecbfcdb9a06)(e.scaleY) && (this._syFn = (0, $14507960c5dac0fb$export$b5e0f6446c9b8e3c)(e.scaleY)), (0, $14507960c5dac0fb$export$ec423ecbfcdb9a06)(e.scaleZ) && (this._szFn = (0, $14507960c5dac0fb$export$b5e0f6446c9b8e3c)(e.scaleZ));
        }
        _hasFuncType() {
            return !!(this._modelHeightFn && !this._modelHeightFn.isFeatureConstant || this._txFn && !this._txFn.isFeatureConstant || this._tyFn && !this._tyFn.isFeatureConstant || this._tzFn && !this._tzFn.isFeatureConstant || this._rxFn && !this._rxFn.isFeatureConstant || this._ryFn && !this._ryFn.isFeatureConstant || this._rzFn && !this._rzFn.isFeatureConstant || this._sxFn && !this._sxFn.isFeatureConstant || this._syFn && !this._syFn.isFeatureConstant || this._szFn && !this._szFn.isFeatureConstant);
        }
        _initGLTF() {
            if (this._gltfPack) return;
            this._gltfPack = [], this._gltfJSON = [], this._gltfBBox = [], this._gltfMeshInfos = [];
            const e = this.getSymbols();
            this._loaded = 0;
            for(let t = 0; t < e.length; t++){
                const n = e[t].url || "pyramid";
                this._gltfManager.loginGLTF(n);
                const i = this._gltfManager.getGLTF(n);
                if (i.then) i.then((n)=>{
                    if (!n.gltfPack) return this._loaded++, void (this._loaded >= e.length && (this._ready = !0, this.setToRedraw(!0)));
                    const { gltfPack: i, json: r, bbox: s } = n;
                    this._gltfPack[t] = [
                        i
                    ], this._gltfMeshInfos[t] = i.getMeshesInfo(), this._gltfJSON[t] = r, this._gltfBBox[t] = s, this._loaded++, this._loaded >= e.length && (this._ready = !0), this.setToRedraw(!0);
                });
                else {
                    const { gltfPack: e, json: n, bbox: r } = i;
                    e && (this._gltfPack[t] = [
                        e
                    ], this._gltfMeshInfos[t] = e.getMeshesInfo(), this._gltfJSON[t] = n, this._gltfBBox[t] = r, this._loaded++);
                }
            }
            this._loaded >= e.length && (this._ready = !0);
        }
        getPickingVert() {
            return "\n    attribute vec3 aPosition;\n    uniform mat4 projViewModelMatrix;\n    uniform mat4 modelMatrix;\n    uniform mat4 positionMatrix;\n    //\u5F15\u5165fbo picking\u7684vert\u76F8\u5173\u51FD\u6570\n    #include <fbo_picking_vert>\n    #include <get_output>\n    void main()\n    {\n        mat4 localPositionMatrix = getPositionMatrix();\n        vec4 localPosition = getPosition(aPosition);\n\n        gl_Position = projViewModelMatrix * localPositionMatrix * localPosition;\n        //\u4F20\u5165gl_Position\u7684depth\u503C\n        fbo_picking_setData(gl_Position.w, true);\n    }";
        }
        deleteMesh(e) {
            if (e) {
                this.scene.removeMesh(e);
                for(let t = 0; t < e.length; t++){
                    const n = this._skinMap && this._skinMap[e[t].uuid];
                    if (n) {
                        for(const e in n)n[e].jointTexture && n[e].jointTexture.destroy();
                        delete this._skinMap[e[t].uuid];
                    }
                    e[t].disposeInstancedData(), e[t].dispose();
                }
            }
        }
        delete() {
            super.delete();
            const e = this.getSymbols();
            for(let t = 0; t < e.length; t++){
                const n = e[t].url || "pyramid";
                this._gltfManager.logoutGLTF(n);
            }
            if (this._skinMap) {
                for(const e in this._skinMap){
                    const t = this._skinMap[e];
                    for(const e in t)t[e].jointTexture && t[e].jointTexture.destroy();
                }
                delete this._skinMap;
            }
            delete this._nodeMatrixMap;
        }
        _getGLTFMatrix(e, t, n, i) {
            const r = (0, $eIStk).set($435bc7696844e930$var$$s, ...t || $435bc7696844e930$var$no), s = n || $435bc7696844e930$var$io, l = i || $435bc7696844e930$var$ro, h = (0, $k1dpP).fromEuler($435bc7696844e930$var$to, s[0], s[1], s[2]);
            return (0, $3iqbd).fromRotationTranslationScale(e, h, r, l);
        }
    };
function $435bc7696844e930$var$co(e, t, n) {
    const i = $435bc7696844e930$var$uo(e.x, t.x, n), r = $435bc7696844e930$var$uo(e.y, t.y, n), s = $435bc7696844e930$var$uo(e.z || 0, t.z || 0, n);
    return new e.constructor(i, r, s);
}
function $435bc7696844e930$var$uo(e, t, n) {
    return e + n * (t - e);
}
class $435bc7696844e930$var$fo extends $435bc7696844e930$var$ho($435bc7696844e930$export$567a8d5f44cddc05) {
    getMaterialClazz(e) {
        return e.diffuseFactor ? (0, $2wazW).PhongSpecularGlossinessMaterial : (0, $2wazW).PhongMaterial;
    }
}
class $435bc7696844e930$var$po extends $435bc7696844e930$var$ho($435bc7696844e930$var$js) {
    getMaterialClazz(e) {
        return e.specularGlossinessTexture || e.diffuseTexture ? (0, $2wazW).pbr.StandardSpecularGlossinessMaterial : (0, $2wazW).pbr.StandardMaterial;
    }
}
const { getPBRUniforms: $435bc7696844e930$var$go } = (0, $2wazW).pbr.PBRUtils, $435bc7696844e930$var$mo = {
    color: [
        2.0303,
        2.028,
        2.028
    ],
    direction: [
        0,
        -0.2717,
        -1
    ]
}, $435bc7696844e930$var$yo = .3737, $435bc7696844e930$var$xo = {
    index: 0
}, $435bc7696844e930$var$_o = [
    0,
    0,
    0
], $435bc7696844e930$var$vo = [
    2,
    2
];
class $435bc7696844e930$var$bo extends $435bc7696844e930$var$gn {
    supportRenderMode(e) {
        return "fxaa" === e || "fxaaBeforeTaa" === e;
    }
    needPolygonOffset() {
        return !0;
    }
    isTerrainSkin() {
        return !1;
    }
    isTerrainVector() {
        return !0;
    }
    needToRedraw() {
        if (super.needToRedraw()) return !0;
        return this.getSymbol($435bc7696844e930$var$xo).animation;
    }
    createMesh(e, t) {
        const { geometry: n } = e;
        n.generateBuffers(this.regl);
        const i = new (0, $2wazW).Mesh(n, null, {
            castShadow: !1,
            picking: !0
        });
        return i.properties.symbolIndex = $435bc7696844e930$var$xo, i.setLocalTransform(t), i;
    }
    callShader(e, t) {
        super.callShader(e, t), this.transformWater();
        const n = this._getWaterUniform(this.getMap(), t);
        this._drawCount += this.renderer.render(this._waterShader, n, this._waterScene, this.getRenderFBO(t));
    }
    addMesh(e, t) {
        this._prepareMesh(e, t), super.addMesh(...arguments);
    }
    _prepareMesh(e) {
        const t = this.getSymbol($435bc7696844e930$var$xo).ssr;
        for(let n = 0; n < e.length; n++)e[n].ssr = t ? 1 : 0;
    }
    paint(e) {
        e.states && e.states.includesChanged && (this.shader.dispose(), this._waterShader.dispose(), this._createShader(e));
        const t = !!e.ssr && this.getSymbol($435bc7696844e930$var$xo).ssr, n = this._waterShader, i = n.shaderDefines;
        if (t) {
            const t = $435bc7696844e930$var$we({}, i, e.ssr.defines);
            n.shaderDefines = t;
        }
        this.updateIBLDefines(n), this._water.ssr = t ? 1 : 0, super.paint(e), t && (n.shaderDefines = i);
    }
    isEnableTileStencil() {
        return !1;
    }
    init(e) {
        this.createIBLTextures();
        const t = this.regl;
        this.renderer = new (0, $2wazW).Renderer(t), this.createGround(), this._createShader(e), this.pickingFBO && (this.picking = [
            new (0, $2wazW).FBORayPicking(this.renderer, {
                vert: $435bc7696844e930$var$mn,
                uniforms: [
                    {
                        name: "projViewModelMatrix",
                        type: "function",
                        fn: function(e, t) {
                            const n = [];
                            return (0, $3iqbd).multiply(n, t.projViewMatrix, t.modelMatrix), n;
                        }
                    }
                ],
                extraCommandProps: {
                    viewport: this.pickingViewport
                }
            }, this.pickingFBO, this.getMap())
        ]), this._loadTextures();
    }
    _loadTextures() {
        const e = this.regl;
        this._emptyTex || (this._emptyTex = e.texture(2));
        const t = this.layer.getURLModifier(), n = this.getSymbol({
            index: 0
        }), i = n.texWaveNormal, r = this.getCachedTexture(i), s = this;
        if (r) this._normalTex || (r.isLoading ? setTimeout(()=>{
            this.shader && this._loadTextures();
        }, 20) : this._normalTex = this._createTex(e, r));
        else {
            const n = new Image;
            n.isLoading = !0, n.onload = function() {
                delete this.isLoading, s._normalTex = s._createTex(e, this), s.setToRedraw();
            }, n.onerror = ()=>{
                console.error("invalid water wave normal texture:" + i);
            }, this.addCachedTexture(i, n), n.src = t && t(i) || i;
        }
        const o = n.texWavePerturbation, a = this.getCachedTexture(o);
        if (a) this._pertTex || (a.isLoading ? setTimeout(()=>{
            this._loadTextures(), this.shader;
        }, 20) : this._pertTex = this._createTex(e, a));
        else {
            const n = new Image;
            n.isLoading = !0, n.onload = function() {
                delete this.isLoading, s._pertTex = s._createTex(e, this), s.setToRedraw();
            }, n.onerror = ()=>{
                console.error("invalid water wave perturbation texture:" + o);
            }, this.addCachedTexture(o, n), n.src = t && t(o) || o;
        }
    }
    _createTex(e, t) {
        return this._emptyTex ? e.texture({
            width: t.width,
            height: t.height,
            mag: "linear",
            min: "linear mipmap linear",
            wrapS: "repeat",
            wrapT: "repeat",
            flipY: !0,
            data: t
        }) : null;
    }
    _createShader(e) {
        const t = this.canvas, n = [], i = [
            {
                name: "projViewModelMatrix",
                type: "function",
                fn: function(e, t) {
                    const n = [];
                    return (0, $3iqbd).multiply(n, t.projViewMatrix, t.modelMatrix), n;
                }
            },
            {
                name: "modelViewNormalMatrix",
                type: "function",
                fn: (e, t)=>{
                    const n = (0, $3iqbd).multiply([], t.viewMatrix, t.modelMatrix), i = (0, $3iqbd).invert(n, n), r = (0, $3iqbd).transpose(i, i);
                    return (0, $bDSmI).fromMat4([], r);
                }
            },
            {
                name: "modelViewMatrix",
                type: "function",
                fn: (e, t)=>(0, $3iqbd).multiply([], t.viewMatrix, t.modelMatrix)
            },
            {
                name: "environmentTransform",
                type: "function",
                fn: (e, t)=>{
                    const i = t.environmentOrientation || 0;
                    return (0, $bDSmI).fromRotation(n, Math.PI * i / 180);
                }
            }
        ], r = {
            TIME_NOISE_TEXTURE_REPEAT: $435bc7696844e930$var$yo
        };
        this.fillIncludes(r, i, e);
        const o = {
            x: 0,
            y: 0,
            width: ()=>t ? t.width : 1,
            height: ()=>t ? t.height : 1
        }, l = this.sceneConfig.depthRange;
        this.shader = new (0, $2wazW).MeshShader({
            vert: "\n                attribute vec3 aPosition;\n\n                uniform mat4 projViewModelMatrix;\n                uniform float minAltitude;\n\n                void main() {\n                    vec3 position = aPosition;\n                    position.z += minAltitude * 100.0;\n                    gl_Position = projViewModelMatrix * vec4(position, 1.);\n                }\n            ",
            frag: "\n    #define SHADER_NAME WATER_STENCIL\n    precision mediump float;\n    void main() {\n        gl_FragColor = vec4(1.0, 0.0, 0.0, 1.0);\n    }\n",
            uniforms: [
                {
                    name: "projViewModelMatrix",
                    type: "function",
                    fn: function(e, t) {
                        const n = [];
                        return (0, $3iqbd).multiply(n, t.projViewMatrix, t.modelMatrix), n;
                    }
                }
            ],
            extraCommandProps: {
                viewport: o,
                colorMask: [
                    !1,
                    !1,
                    !1,
                    !1
                ],
                stencil: {
                    enable: !0,
                    mask: 255,
                    func: {
                        cmp: "<=",
                        ref: 254,
                        mask: 255
                    },
                    op: {
                        fail: "keep",
                        zfail: "keep",
                        zpass: "replace"
                    }
                },
                depth: {
                    enable: !0,
                    range: l || [
                        0,
                        1
                    ],
                    func: this.sceneConfig.depthFunc || "<="
                },
                polygonOffset: {
                    enable: !0,
                    offset: this.getPolygonOffset()
                }
            }
        });
        const h = {
            viewport: o,
            stencil: {
                enable: !0,
                mask: 255,
                func: {
                    cmp: "==",
                    ref: 254,
                    mask: 255
                },
                op: {
                    fail: "keep",
                    zfail: "keep",
                    zpass: "replace"
                }
            },
            depth: {
                enable: !1
            }
        };
        i.push(...(0, $2wazW).SsrPass.getUniformDeclares()), this._waterShader = new (0, $2wazW).MeshShader({
            vert: "#define SHADER_NAME WATER\nuniform mat4 modelMatrix;\nuniform mat4 projViewModelMatrix;\nattribute vec3 aPosition;\nattribute vec2 aTexCoord;\nuniform vec2 uvOffset;\nuniform vec2 noiseUvOffset;\nuniform vec2 uvScale;\nvarying vec2 vUv;\nvarying vec2 vNoiseUv;\nvarying vec3 vPos;\nvarying mat3 vTbnMatrix;\n#ifdef HAS_SSR\nuniform mat4 modelViewMatrix;\nvarying vec4 vViewVertex;\n#endif\n#include <highlight_vert>\nmat3 c(in vec3 d) {\n  vec3 t = normalize(cross(d, vec3(.0, 1., .0)));\n  vec3 e = normalize(cross(d, t));\n  return mat3(t, e, d);\n}\n#if defined(HAS_SHADOWING)\n#include <vsm_shadow_vert>\n#endif\nconst vec3 f = vec3(0., 0., 1.);\nvoid main(void) {\n  vec4 h = vec4(aPosition, 1.);\n  vec4 i = modelMatrix * h;\n  vPos = i.xyz;\n  vTbnMatrix = c(f);\n  gl_Position = projViewModelMatrix * h;\n  vUv = aTexCoord * uvScale + uvOffset;\n  vNoiseUv = aTexCoord * uvScale * TIME_NOISE_TEXTURE_REPEAT + noiseUvOffset;\n#ifdef HAS_SSR\nvec4 j = modelViewMatrix * h;\n  vViewVertex = j;\n#endif\n#if defined(HAS_SHADOWING)\nshadow_computeShadowPars(h);\n#endif\nhighlight_setVarying();\n}",
            frag: "#define SHADER_NAME WATER\nprecision highp float;\nprecision highp sampler2D;\n#include <hsv_frag>\nuniform vec3 hsv;\nuniform float contrast;\nuniform float layerOpacity;\n#if defined(HAS_SHADOWING)\n#include <vsm_shadow_frag>\n#endif\n#include <highlight_frag>\n#if defined(HAS_IBL_LIGHTING)\nuniform vec3 hdrHSV;\nuniform samplerCube prefilterMap;\nuniform sampler2D brdfLUT;\nuniform mat3 environmentTransform;\nuniform vec3 diffuseSPH[9];\nvec3 c(const in vec3 d) {\n  vec3 e = environmentTransform * d;\n  float x = e.x;\n  float y = e.y;\n  float z = e.z;\n  vec3 f = (diffuseSPH[0] + diffuseSPH[1] * x + diffuseSPH[2] * y + diffuseSPH[3] * z + diffuseSPH[4] * z * x + diffuseSPH[5] * y * z + diffuseSPH[6] * y * x + diffuseSPH[7] * (3. * z * z - 1.) + diffuseSPH[8] * (x * x - y * y));\n  if(length(hdrHSV) > .0) {\n    f = hsv_apply(f, hdrHSV);\n  }\n  return max(f, vec3(.0));\n}\nvec3 h(const in vec3 i, const in float j, const in float k, const in float l) {\n  vec4 rgba = texture2D(brdfLUT, vec2(k, j));\n  float b = (rgba[3] * 65280.0 + rgba[2] * 255.);\n  float a = (rgba[1] * 65280.0 + rgba[0] * 255.);\n  const float m = 1. / 65535.;\n  return (i * a + b * l) * m;\n}\n#else\nuniform vec3 ambientColor;\n#endif\nstruct PBRShadingWater {\n  float NdotL;\n  float NdotV;\n  float NdotH;\n  float VdotH;\n  float LdotH;\n  float VdotN;\n};\nvec3 o(const in vec4 u, const in float v) {\n  if(v <= .0)\n    return u.rgb;\n  return v * u.rgb * u.a;\n}\n#ifdef HAS_SSR\nvarying vec4 vViewVertex;\nuniform mat3 modelViewNormalMatrix;\nuniform sampler2D TextureDepth;\nuniform highp vec2 outSize;\nuniform float ssrFactor;\nuniform float ssrQuality;\nuniform sampler2D TextureReflected;\nuniform highp mat4 projMatrix;\nuniform mat4 invProjMatrix;\nuniform vec4 outputFovInfo[2];\nuniform mat4 reprojViewProjMatrix;\nuniform vec2 cameraNearFar;\nfloat A(const in vec4 B) {\n  return B.r + B.g / 255.;\n}\nfloat C(const in vec2 D, const in float E) {\n  vec3 F = vec3(.06711056, .00583715, 52.9829189);\n  return fract(F.z * fract(dot(D.xy + E * vec2(47., 17.) * .695, F.xy))) * .5;\n}\nvec3 G(const in float H, const in float I, const in vec2 J) {\n  float K = min(I - .01, H);\n  float L = floor(K);\n  float M = min(I, L + 1.);\n  float N = pow(2., M);\n  vec2 O = 2. * N / J;\n  if(K - L > .5)\n    N *= 2.;\n  return vec3(O, N);\n}\nvec2 P(const in vec2 Q, const in vec3 R) {\n  vec2 S = max(R.xy, min(1. - R.xy, Q));\n  return vec2(2. * S.x, R.z - 1. - S.y) / R.z;\n}\nvec3 T(const in mat4 U, const in vec3 V) {\n  vec4 W = U * vec4(V, 1.);\n  return vec3(.5 + .5 * W.xy / W.w, W.w);\n}\nvec3 X(const in float Y, const in vec2 S) {\n  return texture2D(TextureReflected, S).rgb;\n}\nfloat Z(float ba) {\n  highp mat4 U = projMatrix;\n  highp float z = ba * 2. - 1.;\n  return -U[3].z / (z + U[2].z);\n}\nfloat bb(const vec2 S) {\n  float ba = A(texture2D(TextureDepth, S));\n  return ba;\n}\nvec3 bc(const in float E, const in vec3 bd, const in vec3 be, const in vec3 bf, const in vec3 bg, const in float bh) {\n  vec2 bi;\n  bi.x = C(gl_FragCoord.yx, E);\n  bi.y = fract(bi.x * 52.9829189);\n  bi.y = mix(bi.y, 1., .7);\n  float bj = 2. * 3.14159 * bi.x;\n  float bk = pow(max(bi.y, .000001), bh / (2. - bh));\n  float bl = sqrt(1. - bk * bk);\n  vec3 bm = vec3(bl * cos(bj), bl * sin(bj), bk);\n  bm = bm.x * bd + bm.y * be + bm.z * bf;\n  return normalize((2. * dot(bg, bm)) * bm - bg);\n}\nfloat bn(const in float E) {\n  return (C(gl_FragCoord.xy, E) - .5);\n}\nvec3 bo(const in vec3 bp, const in float bq, const in vec3 br) {\n  vec3 bs = T(projMatrix, vViewVertex.xyz + br * bq);\n  bs.z = 1. / bs.z;\n  bs -= bp;\n  float bt = min(1., .99 * (1. - bp.x) / max(1e-5, bs.x));\n  float bu = min(1., .99 * (1. - bp.y) / max(1e-5, bs.y));\n  float bv = min(1., .99 * bp.x / max(1e-5, -bs.x));\n  float bw = min(1., .99 * bp.y / max(1e-5, -bs.y));\n  return bs * min(bt, bu) * min(bv, bw);\n}\nfloat bx(const in vec3 bp, const in vec3 bs, inout float by, inout float bz) {\n  float bA = (bz + by) * .5;\n  vec3 bB = bp + bs * bA;\n  float z = bb(bB.xy);\n  float ba = Z(z);\n  float bC = -1. / bB.z;\n  by = ba > bC ? by : bA;\n  bz = ba > bC ? bA : bz;\n  return bA;\n}\nvec4 bD(const in vec3 bp, const in float bq, in float bE, const in vec3 br, const in float j, const in float E) {\n  const int bF = 20;\n  float bG = 1. / float(bF);\n  bE *= bG;\n  vec3 bs = bo(bp, bq, br);\n  float bH = bG;\n  vec3 bI = vec3(.0, bH, 1.);\n  vec3 bB;\n  float z, ba, bC, bJ, bK, bL;\n  bool bM;\n  float bN = 1.;\n  float bA;\n  for(int bO = 0; bO < bF; bO++) {\n    bB = bp + bs * bI.y;\n    z = bb(bB.xy);\n    ba = Z(z);\n    bC = -1. / bB.z;\n    bJ = bC - ba;\n    bJ *= clamp(sign(abs(bJ) - bq * bG * bG), .0, 1.);\n    bM = abs(bJ + bE) < bE;\n    bK = clamp(bI.x / (bI.x - bJ), .0, 1.);\n    bL = bM ? bI.y + bK * bG - bG : 1.;\n    bI.z = min(bI.z, bL);\n    bI.x = bJ;\n    if(bM) {\n      float by = bI.y - bG;\n      float bz = bI.y;\n      bA = bx(bp, bs, by, bz);\n      bA = bx(bp, bs, by, bz);\n      bA = bx(bp, bs, by, bz);\n      bN = bA;\n      break;\n    }\n    bI.y += bG;\n  }\n  return vec4(bp + bs * bN, 1. - bN);\n}\nvec3 bP(in vec4 bQ, const in float bR, const in vec3 bS, const in vec3 bT, const in float j) {\n  vec4 bU = mix(outputFovInfo[0], outputFovInfo[1], bQ.x);\n  bQ.xyz = vec3(mix(bU.xy, bU.zw, bQ.y), 1.) * -1. / bQ.z;\n  bQ.xyz = (reprojViewProjMatrix * vec4(bQ.xyz, 1.)).xyw;\n  bQ.xy /= bQ.z;\n  float bV = clamp(6. - 6. * max(abs(bQ.x), abs(bQ.y)), .0, 1.);\n  bQ.xy = .5 + .5 * bQ.xy;\n  return vec3(bQ.xy, 1.);\n}\nvec3 ssr(const in vec3 bS, const in vec3 bT, const in float j, const in vec3 d, const in vec3 bg) {\n  float bW = .0;\n  vec4 f = vec4(.0);\n  float bh = j * j;\n  bh = bh * bh;\n  vec3 bX = abs(d.z) < .999 ? vec3(.0, .0, 1.) : vec3(1., .0, .0);\n  vec3 bd = normalize(cross(bX, d));\n  vec3 be = cross(d, bd);\n  float bR = ssrFactor * clamp(-4. * dot(bg, d) + 3.8, .0, 1.);\n  bR *= clamp(4.7 - j * 5., .0, 1.);\n  vec3 bp = T(projMatrix, vViewVertex.xyz);\n  bp.z = 1. / bp.z;\n  vec3 br = bc(bW, bd, be, d, bg, bh);\n  float bq = mix(cameraNearFar.y + vViewVertex.z, -vViewVertex.z - cameraNearFar.x, br.z * .5 + .5);\n  float bE = .5 * bq;\n  vec4 bQ;\n  if(dot(br, d) > .001 && bR > .0) {\n    bQ = bD(bp, bq, bE, br, j, bW);\n    if(bQ.w > .0)\n      return bP(bQ, bR, bS, bT, j);\n    \n  }\n  return vec3(.0);\n}\n#endif\nconst vec3 bY = vec3(0., 0., 1.);\nuniform mat4 viewMatrix;\nuniform sampler2D normalTexture;\nuniform sampler2D heightTexture;\nuniform vec4 waveParams;\nuniform vec2 waterDir;\nuniform vec4 waterBaseColor;\nuniform vec3 lightDirection;\nuniform vec3 lightColor;\nuniform vec3 camPos;\nuniform float timeElapsed;\nvarying vec2 vUv;\nvarying vec2 vNoiseUv;\nvarying vec3 vPos;\nvarying mat3 vTbnMatrix;\nfloat bZ(vec3 e, float ca) {\n  float cb = max(.015, ca);\n  return max((e.x + e.y) * .3303545 / cb + .3303545, .0);\n}\nconst vec2 cc = vec2(6. / 25., 5. / 24.);\nvec2 cd(sampler2D ce, vec2 S) {\n  return 2. * texture2D(ce, S).rg - 1.;\n}\nfloat cf(vec2 S) {\n  return texture2D(heightTexture, S).b;\n}\nvec3 cg(sampler2D ce, vec2 S) {\n  return 2. * texture2D(ce, S).rgb - 1.;\n}\nfloat ch(vec2 S, float ci) {\n  return fract(ci);\n}\nfloat cj(vec2 S, float ci) {\n  float ck = ch(S, ci);\n  return 1. - abs(1. - 2. * ck);\n}\nvec3 cl(sampler2D cm, vec2 S, float ci, float cn) {\n  float co = waveParams[2];\n  float cp = waveParams[3];\n  vec2 cq = cd(cm, S) * co;\n  float ck = ch(S, ci + cn);\n  float cr = cj(S, ci + cn);\n  vec2 f = S;\n  f -= cq * (ck + cp);\n  f += cn;\n  f += (ci - ck) * cc;\n  return vec3(f, cr);\n}\nconst float cs = 7.77;\nvec3 ct(sampler2D cu, sampler2D cv, vec2 cw, vec2 cx, float ci) {\n  float ca = waveParams[0];\n  vec2 cy = ci * -cx;\n  float cz = cf(vNoiseUv) * cs;\n  vec3 cA = cl(cv, cw + cy, ci + cz, .0);\n  vec3 cB = cl(cv, cw + cy, ci + cz, .5);\n  vec3 cC = cg(cu, cA.xy) * cA.z;\n  vec3 cD = cg(cu, cB.xy) * cB.z;\n  vec3 cE = normalize(cC + cD);\n  cE.xy *= ca;\n  cE.z = sqrt(1. - dot(cE.xy, cE.xy));\n  return cE;\n}\nvec4 cF(vec2 cw, float cG) {\n  float cH = waveParams[1];\n  vec3 d = ct(normalTexture, heightTexture, cw * cH, waterDir, cG);\n  float cI = bZ(d, waveParams[0]);\n  return vec4(d, cI);\n}\nconst float cJ = 3.141592653589793;\nconst float cK = 1. / cJ;\nconst float cL = .3183098861837907;\nconst float cM = 1.570796326794897;\nconst float cN = .4;\nfloat cO = 2.2;\nvec3 cP(float cQ, vec3 cR, float l) {\n  return cR + (l - cR) * pow(1. - cQ, 5.);\n}\nfloat cS(float cT, float j) {\n  float cU = j * j;\n  float cV = cT * cT;\n  float cW = pow((cV * (cU - 1.) + 1.), cO) * cJ;\n  return cU / cW;\n}\nfloat cX(float cY) {\n  return .25 / (cY * cY);\n}\nvec3 cZ(const vec3 x) {\n  return (x * (2.51 * x + .03)) / (x * (2.43 * x + .59) + .14);\n}\nconst float da = 2.2;\nconst float db = .4545454545;\nvec4 dc(vec4 u) {\n  return vec4(pow(u.rgb, vec3(db)), u.w);\n}\nvec3 dd(vec3 u) {\n  return pow(u, vec3(da));\n}\nconst vec3 de = vec3(.02, 1., 5.);\nconst vec2 df = vec2(.02, .1);\nconst float j = .06;\nconst float dg = 1.7;\nconst vec3 dh = vec3(0, .6, .9);\nconst vec3 di = vec3(.72, .92, 1.);\nconst float dj = .65;\nconst float dk = 300000.0;\nconst float dl = 500000.0;\nconst float dm = .775;\nconst float dn = .8;\nPBRShadingWater dp;\nvec3 dq(in PBRShadingWater dr, float j, vec3 ds, float dt) {\n  vec3 du = cP(dr.VdotH, ds, dt);\n  float dv = cS(dr.NdotH, j);\n  float dw = cX(dr.LdotH);\n  float dx = mix(j + .045, j + .385, 1. - dr.VdotH);\n  float dy = 1.2;\n  float dz = cS(dr.NdotH, dx) * dy;\n  return ((dv + dz) * dw) * du;\n}\nvec3 dA(float dg, float dB, vec3 dh, float dC) {\n  return dg * (.075 * dh * pow(dB, 4.) + 50. * pow(dB, 23.)) * dC;\n}\nvec3 dD(in float bk, in vec3 dE, in vec3 dF) {\n  float dG = pow((1. - bk), de[2]);\n  return mix(dF, dE, dG);\n}\nvec3 dH(in vec3 e, in vec3 dI, in float dJ, in float j) {\n  \n#ifdef HAS_IBL_LIGHTING\nvec3 dK = reflect(-dI, e);\n  vec3 dL = textureCube(prefilterMap, environmentTransform * dK).rgb;\n  float dM = clamp(1. + dot(dK, e), .0, 1.);\n  dL *= dM * dM;\n  vec3 i = dL;\n  vec3 dN = c(e);\n  float l = clamp(50.0 * waterBaseColor.g, .0, 1.);\n  vec3 dO = h(waterBaseColor.rgb, j, dot(e, dI), l);\n  return i * dO + dN;\n#else\nvec3 dP = dd(di);\n  vec3 dQ = dd(dh);\n  vec3 di = dD(dJ, dP, dQ);\n  return di;\n#endif\n}\nvec3 dR(in vec3 e, in vec3 dI, in vec3 dS, vec3 u, in vec3 dT, in vec3 dU, in float dV, float dW, vec3 dX) {\n  float dY = 0.;\n  vec3 dZ = dd(u);\n  vec3 bm = normalize(dS + dI);\n  dp.NdotL = clamp(dot(e, dS), .0, 1.);\n  dp.NdotV = clamp(dot(e, dI), .001, 1.);\n  dp.VdotN = clamp(dot(dI, e), .001, 1.);\n  dp.NdotH = clamp(dot(e, bm), .0, 1.);\n  dp.VdotH = clamp(dot(dI, bm), .0, 1.);\n  dp.LdotH = clamp(dot(dS, bm), .0, 1.);\n  float dJ = max(dot(dU, dI), .0);\n  vec3 di = dH(e, dI, dJ, j);\n  float ea = max(dot(dU, dS), .0);\n  float eb = .1 + ea * .9;\n  di *= eb;\n  float ec = clamp(dV, .8, 1.);\n  vec3 ed = cP(dp.VdotN, vec3(de[0]), de[1]);\n  vec3 ee = ed * di * ec;\n  vec3 ef = dZ * mix(di, ea * dT * cK, 2. / 3.) * ec;\n  vec3 i = vec3(.0);\n  if(dJ > .0 && ea > .0) {\n    vec3 eg = dq(dp, j, vec3(df[0]), df[1]);\n    vec3 eh = dT * cK * dV;\n    i = dp.NdotL * eh * eg;\n  }\n  vec3 cI = vec3(.0);\n  if(dJ > .0) {\n    cI = dA(dg, dW, dh, eb);\n  }\n  vec3 ei = vec3(.0);\n#ifdef HAS_SSR\nfloat ej = smoothstep(dl, dk, -dX.z);\n  mat4 ek = viewMatrix;\n  vec4 el = vec4(dX.xyz, 1.);\n  vec3 em = normalize(el.xyz);\n  vec4 en = ek * vec4(e, .0);\n  vec3 eo = normalize(en.xyz);\n  vec4 ep = ek * vec4(dU, .0);\n  float eq = pow(max(dot(-em, ep.xyz), .0), cN);\n  vec3 er = mix(ep.xyz, eo, eq);\n  vec3 es = ssr(vec3(.0), vec3(1.), j, normalize(er), -normalize(vViewVertex.xyz));\n  if(es.z > .0) {\n    vec2 et = smoothstep(.3, .6, abs(vec2(.5) - es.xy));\n    dY = dm * clamp(1. - 1.3 * et.y, .0, 1.) * ej;\n    vec3 eu = X(.0, es.xy);\n    ei = dd(eu) * dY * ed.y * dj;\n  }\n#endif\nfloat ev = mix(dn, dn * .5, dY);\n  return cZ((1. - dY) * ee + ei + ef * ev + i + cI);\n}\nvoid main() {\n  vec3 dU = bY;\n  vec4 ew = cF(vUv, timeElapsed);\n  vec3 e = normalize(vTbnMatrix * ew.xyz);\n  vec3 dI = -normalize(vPos - camPos);\n  vec3 dS = normalize(-lightDirection);\n#if defined(HAS_SHADOWING)\nfloat dV = shadow_computeShadow();\n#else\nfloat dV = 1.;\n#endif\nvec4 ex = viewMatrix * vec4(vPos, 1.);\n  vec4 ey = vec4(dR(e, dI, dS, waterBaseColor.rgb, lightColor, dU, dV, ew.w, ex.xyz), waterBaseColor.a);\n  gl_FragColor = dc(ey);\n  if(contrast != 1.) {\n    gl_FragColor = contrastMatrix(contrast) * gl_FragColor;\n  }\n  if(length(hsv) > .0) {\n    gl_FragColor = hsv_apply(gl_FragColor, hsv);\n  }\n  gl_FragColor = highlight_blendColor(gl_FragColor) * layerOpacity;\n}",
            defines: r,
            uniforms: i,
            extraCommandProps: h
        });
    }
    getUniformValues(e) {
        return {
            projViewMatrix: e.projViewMatrix,
            minAltitude: this.layer.options.altitude || 0
        };
    }
    _getWaterUniform(e, t) {
        const { iblTexes: n, dfgLUT: i } = this.getIBLRes(), r = $435bc7696844e930$var$go(e, n, i, t && t.ssr, t && t.jitter), s = e.getLightManager();
        let o = s && s.getDirectionalLight() || {};
        const a = s && s.getAmbientLight() || {}, l = this.getSymbol($435bc7696844e930$var$xo), h = this._waterDir = this._waterDir || [], u = this._waveParams = this._waveParams || [];
        (0, $jxhwV).set(u, .09, l.uvScale || 3, .03, -0.5);
        $435bc7696844e930$var$we(r, {
            ambientColor: a.color || [
                .2,
                .2,
                .2
            ],
            viewMatrix: e.viewMatrix,
            lightDirection: o.direction || $435bc7696844e930$var$mo.direction,
            lightColor: o.color || $435bc7696844e930$var$mo.color,
            camPos: e.cameraPosition,
            timeElapsed: l.animation ? (this.layer.getRenderer().getFrameTimestamp() || 0) / (1 / (l.waterSpeed || 1) * 1e4) : 0,
            normalTexture: this._normalTex || this._emptyTex,
            heightTexture: this._pertTex || this._emptyTex,
            waveParams: u,
            waterDir: $435bc7696844e930$var$Ao(h, l.waterDirection || 0),
            waterBaseColor: l.waterBaseColor || [
                .1451,
                .2588,
                .4863,
                1
            ],
            contrast: l.contrast || 1,
            hsv: l.hsv || $435bc7696844e930$var$_o
        });
        const f = this.layer.getRenderer();
        return r.layerOpacity = f._getLayerOpacity(), this.setIncludeUniformValues(r, t), t && t.ssr && t.ssr.renderUniforms && $435bc7696844e930$var$we(r, t.ssr.renderUniforms), r;
    }
    delete() {
        super.delete(), this._emptyTex && (this._emptyTex.destroy(), delete this._emptyTex), this._normalTex && this._normalTex.destroy(), this._pertTex && this._pertTex.destroy(), this.shader && (this.shader.dispose(), delete this.shader), this._waterShader && this._waterShader.dispose(), this._water && (this._water.geometry.dispose(), this._water.material && this._water.material.dispose(), this._water.dispose(), delete this._water), this.disposeIBLTextures();
    }
    createGround() {
        const e = new (0, $2wazW).Plane;
        e.data.aTexCoord = new Uint8Array([
            0,
            1,
            1,
            1,
            0,
            0,
            1,
            0
        ]), e.generateBuffers(this.renderer.regl), this._water = new (0, $2wazW).Mesh(e, null, {
            castShadow: !1
        }), this._waterScene = new (0, $2wazW).Scene([
            this._water
        ]);
    }
    transformWater() {
        const e = this.getMap(), t = (0, $9e7Ip.GroundPainter).getGroundTransform(this._water.localTransform, e);
        this._water.setLocalTransform(t);
        const n = e._get2DExtentAtRes(e.getGLRes()), i = n.getWidth(), r = n.getHeight(), s = e.cameraLookAt, o = s[0] - i, a = s[1] + r, h = o / $435bc7696844e930$var$vo[0], c = a / $435bc7696844e930$var$vo[1], u = h % 1, f = c % 1, d = h * $435bc7696844e930$var$yo % 1, p = c * $435bc7696844e930$var$yo % 1, g = i / $435bc7696844e930$var$vo[0] * 2, m = r / $435bc7696844e930$var$vo[1] * 2;
        this._water.setUniform("uvOffset", [
            u,
            f
        ]), this._water.setUniform("noiseUvOffset", [
            d,
            p
        ]), this._water.setUniform("uvScale", [
            g,
            -m
        ]);
    }
}
function $435bc7696844e930$var$Ao(e, t) {
    var n;
    return n = t, t = Math.PI * n / 180, e[0] = Math.sin(t), e[1] = Math.cos(t), e;
}
const $435bc7696844e930$export$4634a494d7b31036 = $435bc7696844e930$var$vt("fill", $435bc7696844e930$export$2a19652d1018576);
$435bc7696844e930$export$4634a494d7b31036.registerAt($435bc7696844e930$export$ab7f86d6b8cd9f25);
const $435bc7696844e930$export$5ac5131b276abfac = $435bc7696844e930$var$vt("line", $435bc7696844e930$export$5f708b59aa06f95b);
$435bc7696844e930$export$5ac5131b276abfac.registerAt($435bc7696844e930$export$ab7f86d6b8cd9f25);
const $435bc7696844e930$export$ed2e3e029d5ed95c = $435bc7696844e930$var$vt("line-gradient", $435bc7696844e930$var$jn);
$435bc7696844e930$export$ed2e3e029d5ed95c.registerAt($435bc7696844e930$export$ab7f86d6b8cd9f25);
const $435bc7696844e930$export$c2fff9ffd62c4a21 = $435bc7696844e930$var$vt("icon", $435bc7696844e930$export$eb2cc705f4de3b75);
$435bc7696844e930$export$c2fff9ffd62c4a21.registerAt($435bc7696844e930$export$ab7f86d6b8cd9f25);
const $435bc7696844e930$export$3c83395b8a6a396f = $435bc7696844e930$var$vt("text", $435bc7696844e930$export$ebaea115ca21d80b);
$435bc7696844e930$export$3c83395b8a6a396f.registerAt($435bc7696844e930$export$ab7f86d6b8cd9f25);
const $435bc7696844e930$export$723b4c624f74c435 = $435bc7696844e930$var$vt("native-line", $435bc7696844e930$export$303928d80b576bb3);
$435bc7696844e930$export$723b4c624f74c435.registerAt($435bc7696844e930$export$ab7f86d6b8cd9f25);
$435bc7696844e930$var$vt("native-point", $435bc7696844e930$export$d48fdc78612718e6).registerAt($435bc7696844e930$export$ab7f86d6b8cd9f25);
const $435bc7696844e930$export$71a340750ea11f12 = $435bc7696844e930$var$vt("phong", $435bc7696844e930$export$567a8d5f44cddc05);
$435bc7696844e930$export$71a340750ea11f12.registerAt($435bc7696844e930$export$ab7f86d6b8cd9f25);
const $435bc7696844e930$export$a9136d96a3728bdb = $435bc7696844e930$var$vt("wireframe", $435bc7696844e930$export$f8a5f3ca2ebee3b0);
$435bc7696844e930$export$a9136d96a3728bdb.registerAt($435bc7696844e930$export$ab7f86d6b8cd9f25);
const $435bc7696844e930$export$c171edfb411a81c5 = $435bc7696844e930$var$vt("lit", $435bc7696844e930$var$js);
$435bc7696844e930$export$c171edfb411a81c5.registerAt($435bc7696844e930$export$ab7f86d6b8cd9f25);
const $435bc7696844e930$export$2027056f30c0fe12 = $435bc7696844e930$var$vt("tube", $435bc7696844e930$var$Zs);
$435bc7696844e930$export$2027056f30c0fe12.registerAt($435bc7696844e930$export$ab7f86d6b8cd9f25);
const $435bc7696844e930$export$3e18c3492588d360 = $435bc7696844e930$var$vt("gltf-phong", $435bc7696844e930$var$fo);
$435bc7696844e930$export$3e18c3492588d360.registerAt($435bc7696844e930$export$ab7f86d6b8cd9f25);
const $435bc7696844e930$export$1bedce282617abaf = $435bc7696844e930$var$vt("gltf-lit", $435bc7696844e930$var$po);
$435bc7696844e930$export$1bedce282617abaf.registerAt($435bc7696844e930$export$ab7f86d6b8cd9f25);
const $435bc7696844e930$export$a004723e142d4b8a = $435bc7696844e930$var$vt("heatmap", class extends $435bc7696844e930$var$gn {
    createFnTypeConfig(e, t) {
        const n = (0, $14507960c5dac0fb$export$b5e0f6446c9b8e3c)(t.heatmapWeight), i = new Int16Array(1);
        return [
            {
                attrName: "aWeight",
                symbolName: "heatmapWeight",
                type: Int16Array,
                width: 1,
                define: "HAS_HEAT_WEIGHT",
                evaluate: (t)=>{
                    const r = n(e.getZoom(), t);
                    return i[0] = 255 * r, i[0];
                }
            }
        ];
    }
    createMesh(e, t) {
        const { geometry: n, symbolIndex: i, ref: r } = e;
        if (void 0 === r) $435bc7696844e930$var$wt(n, this.getSymbolDef(i), this.getFnTypeConfig(i), this.layer);
        const o = this.getSymbol(i), a = {
            tileRatio: n.properties.tileRatio,
            dataResolution: n.properties.tileResolution
        };
        $435bc7696844e930$var$ke(a, "heatmapIntensity", o, "heatmapIntensity", 1), $435bc7696844e930$var$ke(a, "heatmapRadius", o, "heatmapRadius", 6), $435bc7696844e930$var$ke(a, "heatmapWeight", o, "heatmapWeight", 1), $435bc7696844e930$var$ke(a, "heatmapOpacity", o, "heatmapOpacity", 1), n.generateBuffers(this.regl);
        const l = new (0, $2wazW).Material(a), h = new (0, $2wazW).Mesh(n, l, {
            transparent: !0,
            castShadow: !1,
            picking: !0
        }), c = {};
        return n.data.aWeight && (c.HAS_HEAT_WEIGHT = 1), h.setDefines(c), h.setLocalTransform(t), h.properties.symbolIndex = i, h;
    }
    callRenderer(e, t, n) {
        const i = this.getRenderFBO(n);
        this._drawCount += this._process.render(this.scene, t, i);
    }
    getUniformValues(e) {
        const t = this.getSymbol({
            index: 0
        }), { projViewMatrix: n } = e;
        return {
            glScale: 1 / e.getGLScale(),
            resolution: e.getResolution(),
            projViewMatrix: n,
            heatmapOpacity: t.heatmapOpacity
        };
    }
    getHeatmapMeshes() {
        return this.scene.getMeshes();
    }
    delete() {
        super.delete(...arguments), this._process.dispose(), delete this._process;
    }
    init() {
        const e = this.regl;
        this.renderer = new (0, $2wazW).Renderer(e);
        const t = this.getPolygonOffset(), n = this.getSymbols()[0];
        this._process = new (0, $9e7Ip.HeatmapProcess)(this.regl, this.sceneConfig, this.layer, n.heatmapColor, null, t);
    }
});
$435bc7696844e930$export$a004723e142d4b8a.registerAt($435bc7696844e930$export$ab7f86d6b8cd9f25);
const $435bc7696844e930$export$d5d58802d5cead99 = $435bc7696844e930$var$vt("water", $435bc7696844e930$var$bo);
$435bc7696844e930$export$d5d58802d5cead99.registerAt($435bc7696844e930$export$ab7f86d6b8cd9f25), $435bc7696844e930$export$d39412b8ec89578a.registerPainter("lit", $435bc7696844e930$var$js), $435bc7696844e930$export$d39412b8ec89578a.registerPainter("icon", $435bc7696844e930$export$eb2cc705f4de3b75), $435bc7696844e930$export$d39412b8ec89578a.registerPainter("fill", $435bc7696844e930$export$2a19652d1018576), $435bc7696844e930$export$d39412b8ec89578a.registerPainter("line", $435bc7696844e930$export$5f708b59aa06f95b), $435bc7696844e930$export$d39412b8ec89578a.registerPainter("line-gradient", $435bc7696844e930$var$jn), $435bc7696844e930$export$d39412b8ec89578a.registerPainter("water", $435bc7696844e930$var$bo), $435bc7696844e930$export$d39412b8ec89578a.registerPainter("tube", $435bc7696844e930$var$Zs);
class $435bc7696844e930$export$a19625daaee656fb extends $435bc7696844e930$export$ab7f86d6b8cd9f25 {
    getTileUrl(e, t, n) {
        const i = this.getMap().getResolution(n);
        return super.getTileUrl(e, t, function(e) {
            return 19 - Math.log(e / $435bc7696844e930$var$No) / Math.LN2;
        }(i));
    }
    static fromJSON(e) {
        return e && "MapboxVectorTileLayer" === e.type ? new $435bc7696844e930$export$a19625daaee656fb(e.id, e.options) : null;
    }
}
$435bc7696844e930$export$a19625daaee656fb.registerJSONType("MapboxVectorTileLayer");
const $435bc7696844e930$var$No = 12756274 * Math.PI / (256 * Math.pow(2, 20));
class $435bc7696844e930$export$efd796d14586ecb0 extends $435bc7696844e930$export$ab7f86d6b8cd9f25 {
    constructor(e, t){
        (t = t || {}).spatialReference = null, super(e, t), this.setData(t.data);
    }
    onAdd() {
        this._prepareOptions();
    }
    _prepareOptions() {
        const e = this.getMap(), t = e.getMaxNativeZoom(), n = e.getProjection(), i = "EPSG:4326" === n.code || "EPSG:4490" === n.code;
        var r;
        i && (this.options.tileSystem = [
            1,
            -1,
            -180,
            90
        ]), this.options.spatialReference = i ? function(e, t) {
            return {
                projection: t,
                fullExtent: {
                    top: 90,
                    left: -180,
                    bottom: -90,
                    right: 180
                },
                resolutions: function() {
                    const t = [];
                    for(let n = 0; n <= e + 1; n++)t[n] = 90 / (128 * Math.pow(2, n));
                    return t;
                }()
            };
        }(t, n.code) : (r = t, {
            projection: "EPSG:3857",
            resolutions: function() {
                const e = [], t = 6378137 * Math.PI;
                for(let n = 0; n <= r + 1; n++)e[n] = t / (256 * Math.pow(2, n));
                return e;
            }(),
            fullExtent: {
                top: 6378137 * Math.PI,
                left: -6378137 * Math.PI,
                bottom: -6378137 * Math.PI,
                right: 6378137 * Math.PI
            }
        });
    }
    getWorkerOptions() {
        const e = super.getWorkerOptions();
        let t = this.options.data;
        return $435bc7696844e930$var$B(t) || t && t.url ? (t.url && (t = JSON.parse(JSON.stringify(t))), t = $435bc7696844e930$var$Uo(t, this.getURLModifier())) : t = this.features, e.data = t, e.tileBuffer = this.options.tileBuffer, e.extent = this.options.extent, e.hasAltitude = this.options.enableAltitude, e.simplifyTolerance = this.options.simplifyTolerance, e.projection = this.getSpatialReference().getProjection().code, e.generateOMBB = this.options.generateOMBB, e.convertFn = this.options.convertFn ? this.options.convertFn + "" : null, e;
    }
    setData(e) {
        if (this.options.data = e, e && ($435bc7696844e930$var$B(e) || e.url)) return !!this.getRenderer() && this._updateWorker(), this;
        return this._setData(e), this._updateWorker(), this;
    }
    _setData(e) {
        if (this.options.convertFn) e = new Function("data", this.options.convertFn + "\nreturn convert(data)")(e);
        return this.features = e, this._generateIdMap(), this;
    }
    _updateWorker() {
        const e = this.getRenderer();
        if (e) {
            const t = e.getWorkerConnection();
            if (t) {
                let n = this.options.data;
                $435bc7696844e930$var$B(n) || n && n.url ? (n.url && (n = JSON.parse(JSON.stringify(n))), n = $435bc7696844e930$var$Uo(n, this.getURLModifier())) : n = this.features, t.setData(n, (t, n)=>{
                    e.clear(), this.onWorkerReady(null, n), e.setToRedraw(), setTimeout(()=>{
                        e.setToRedraw();
                    }, 500);
                });
            }
        }
    }
    getExtent() {
        return this._dataExtent;
    }
    onWorkerReady(e, t) {
        e ? this.fire("dataerror", {
            error: e
        }) : (t && (t.extent && this._setExtent(t.extent), t.idMap && (this._idMaps = t.idMap)), this.fire("dataload", {
            extent: t && t.extent
        }));
    }
    _setExtent(t) {
        this._dataExtent = new $gP1US.Extent(...t);
    }
    _fetchData(e, t) {
        $435bc7696844e930$var$B(e) ? $435bc7696844e930$var$Q.getJSON(e, t) : $435bc7696844e930$var$Q.getJSON(e.url, e, t);
    }
    getData() {
        return this.features || null;
    }
    getTileUrl(e, t, n) {
        return this.getId() + "," + e + "," + t + "," + n;
    }
    getFeature(e) {
        return this._idMaps[e];
    }
    static fromJSON(e) {
        return e && "GeoJSONVectorTileLayer" === e.type ? new $435bc7696844e930$export$efd796d14586ecb0(e.id, e.options) : null;
    }
    getGeometryById(e) {
        return this._idMaps ? this._idMaps[e] : null;
    }
    _generateIdMap() {
        if (!this.features) return;
        if (this.features = JSON.parse(JSON.stringify(this.features)), !this.features) return;
        let e = 0;
        this._idMaps = {};
        const t = this.options.featureIdProperty, n = this.features;
        Array.isArray(n) ? n.forEach((n)=>{
            if (n) {
                if ($435bc7696844e930$var$G(n.id) || (n.id = e++), t) {
                    let e = t;
                    $435bc7696844e930$var$W(t) && (e = t[n.layer || "0"]), n.id = n.properties[e];
                }
                this._idMaps[n.id] = n;
            }
        }) : n.features && n.features.forEach((n)=>{
            if (n) {
                if ($435bc7696844e930$var$G(n.id) || (n.id = e++), t) {
                    let e = t;
                    $435bc7696844e930$var$W(t) && (e = t[n.layer || "0"]), n.id = n.properties[e];
                }
                this._idMaps[n.id] = n;
            }
        });
    }
}
function $435bc7696844e930$var$Vo(e) {
    let t = document.createElement("a");
    return t.href = e, e = t.href, t = null, e;
}
function $435bc7696844e930$var$Uo(e, t) {
    return e.url ? e.url = t ? t(e.url) : $435bc7696844e930$var$Vo(e.url) : e = t ? t(e) : $435bc7696844e930$var$Vo(e), e;
}
$435bc7696844e930$export$efd796d14586ecb0.registerJSONType("GeoJSONVectorTileLayer"), $435bc7696844e930$export$efd796d14586ecb0.mergeOptions({
    features: "id",
    tileBuffer: 64,
    extent: 8192,
    pyramidMode: 1,
    simplifyTolerance: 3,
    tileStackDepth: 0,
    generateOMBB: !0
});
const { SYMBOLS_NEED_REBUILD_IN_VECTOR: $435bc7696844e930$var$Bo, GlyphRequestor: $435bc7696844e930$var$Go, PointPack: $435bc7696844e930$var$jo, LinePack: $435bc7696844e930$var$Wo, StyledPoint: $435bc7696844e930$var$Xo, VectorPack: $435bc7696844e930$var$Yo, StyledVector: $435bc7696844e930$var$Zo } = $435bc7696844e930$var$H();
let $435bc7696844e930$var$qo = !1, $435bc7696844e930$var$$o = 1;
const $435bc7696844e930$var$Jo = "_symbol_".trim(), $435bc7696844e930$var$Ko = ($435bc7696844e930$var$pe + "").trim();
let $435bc7696844e930$var$Qo = new Float32Array(1);
const $435bc7696844e930$var$ea = [];
class $435bc7696844e930$var$ta extends $gP1US.renderer.CanvasRenderer {
    constructor(...e){
        super(...e), this.features = {}, this._geometries = {}, this._counter = 0, this._allFeatures = {}, this._featureMapping = {}, this._markerFeatures = {}, this._textFeatures = {}, this._lineFeatures = {}, this._dirtyAll = !0, this._kidGen = {
            id: 0,
            pickingId: 0
        }, this._dirtyTargetsInCurrentFrame = {};
    }
    setURLModifier(e) {
        this._urlModifier = e;
    }
    getURLModifier() {
        return this._urlModifier;
    }
    needToRedraw() {
        const e = super.needToRedraw();
        return e || this.painter && this.painter.needToRedraw() || this._markerPainter && this._markerPainter.needToRedraw() || this._linePainter && this._linePainter.needToRedraw();
    }
    getAnalysisMeshes() {
        return this.painter && this.painter.getAnalysisMeshes() || $435bc7696844e930$var$ea;
    }
    getRayCastData() {
        return null;
    }
    draw(e, t) {
        this._frameTime = e;
        const n = this.layer;
        this.prepareCanvas(), this._zScale = this._getCentiMeterScale(this.getMap().getGLRes()), this._parentContext = t || {};
        const i = this._parentContext.renderMode, r = this._preparePaintContext();
        if (this._startFrame(r, i), this._dirtyAll) this.buildMesh(), this._buildMarkerMesh(), this._buildLineMesh(), this._dirtyTargetsInCurrentFrame = {}, this._dirtyGeo = !1, this._dirtyAll = !1, this._dirtyLine = !1;
        else if (this._dirtyGeo) {
            const e = this.atlas, t = this._markerAtlas, n = this._lineAtlas;
            delete this.atlas, delete this._markerAtlas, delete this._lineAtlas, this.buildMesh(e), this._buildMarkerMesh(t), this._buildLineMesh(n), this._dirtyGeo = !1, this._dirtyLine = !1;
        } else if (this._dirtyLine) {
            const e = this._lineAtlas;
            delete this._lineAtlas, this._buildLineMesh(e), this._dirtyLine = !1;
        }
        if (!this.meshes && !this._markerMeshes && !this._lineMeshes) return void this.completeRender();
        this._showHideUpdated && (this._updateMeshVisible(), this._showHideUpdated = !1), this._updateDirtyTargets();
        const s = !i || "default" === i;
        let o = 0;
        0 === this.layer.options.meshRenderOrder && this._renderMeshes(r, o, i);
        let a = 0;
        if (this._lineMeshes && (s || this._linePainter.supportRenderMode(i))) {
            this._linePainter.startFrame(r), this._linePainter.addMesh(this._lineMeshes, null, {
                bloom: this._parentContext.bloom
            }), this._linePainter.prepareRender(r);
            const e = r.polygonOffsetIndex || 0;
            o = this.meshes && this.meshes.length ? o - 1 : o, r.polygonOffsetIndex = (r.polygonOffsetIndex || 0) + o, a = this._linePainter.render(r).drawCount, r.polygonOffsetIndex = e;
        }
        if (1 === this.layer.options.meshRenderOrder && this._renderMeshes(r, a ? o - 1 : o, i), this._markerMeshes && (s || this._markerPainter.supportRenderMode(i))) {
            const t = !this._parentContext.timestamp || this._parentContext.isFinalRender, i = !this._collisionTimestamp || this._collisionTimestamp !== e;
            n.options.collision && i && n.clearCollisionIndex();
            const s = this.layer.options.sceneConfig;
            this._markerPainter.sceneConfig.collision = !s || !!$435bc7696844e930$var$X(s.collision) || s.collision, this._markerPainter.startFrame(r), this._markerPainter.addMesh(this._markerMeshes, null, {
                bloom: this._parentContext.bloom
            }), this._markerPainter.prepareRender(r), n.options.collision && i && (this._markerPainter.updateCollision(r), t && (this._collisionTimestamp = e)), this._markerPainter.render(r);
        }
        (s || t && t.isFinalRender) && (this.completeRender(), this.layer.fire("canvasisdirty"));
    }
    _startFrame(e, t) {
        const n = !t || "default" === t;
        this.painter && (n || this.painter.supportRenderMode(t)) && this.painter.startFrame(e);
    }
    _renderMeshes(e, t, n) {
        const i = !n || "default" === n;
        if (this.painter && this.meshes && (i || this.painter.supportRenderMode(n))) {
            this.painter.addMesh(this.meshes, null, {
                bloom: e && e.bloom
            }), this.painter.prepareRender(e), e.polygonOffsetIndex = (e.polygonOffsetIndex || 0) + t;
            return this.painter.render(e);
        }
        return {
            redraw: !1,
            drawCount: 0
        };
    }
    supportRenderMode() {
        return !0;
    }
    isForeground() {
        return !0;
    }
    _preparePaintContext() {
        const e = {
            regl: this.regl,
            layer: this.layer,
            symbol: this._layerSymbol,
            gl: this.gl,
            sceneConfig: this.layer.options.sceneConfig,
            pluginIndex: 0,
            cameraPosition: this.getMap().cameraPosition,
            timestamp: this.getFrameTimestamp()
        };
        return this._parentContext && $435bc7696844e930$var$U(e, this._parentContext), e;
    }
    drawOnInteracting(e, t, n) {
        this.draw(t, n);
    }
    getFrameTimestamp() {
        return this._frameTime;
    }
    _getFeaturesToRender(e, t) {
        (e = e || t) === t && (t = null);
        const n = [], i = [
            0,
            0,
            0,
            0
        ];
        this.layer._sortGeometries();
        const r = this.layer.getGeometries();
        for(let s = 0; s < r.length; s++){
            const o = r[s][$435bc7696844e930$var$Vn];
            if (!this.features[o]) continue;
            const a = this.features[o];
            if (Array.isArray(a)) for(let r = 0; r < a.length; r++){
                const s = a[r], o = s[$435bc7696844e930$var$Ko];
                (!e || e[o] || t && (!t || t[o])) && (s.visible || (this._showHideUpdated = !0), this._addCoordsToCenter(s.geometry, i, s.coordinates), n.push(s));
            }
            else {
                a.visible || (this._showHideUpdated = !0);
                const r = a[$435bc7696844e930$var$Ko];
                if (e && !e[r] && (!t || t && !t[r])) continue;
                this._addCoordsToCenter(a.geometry, i, a.coordinates), n.push(a);
            }
        }
        if (n.length || (this.meshes && this.painter && (this.painter.deleteMesh(this.meshes), delete this.meshes), this._markerMeshes && (this._markerPainter.deleteMesh(this._markerMeshes), delete this._markerMeshes), this._lineMeshes && (this._linePainter.deleteMesh(this._lineMeshes), delete this._lineMeshes)), i[3] && (i[0] /= i[3], i[1] /= i[3]), isNaN(i[0]) || isNaN(i[1])) throw new Error(`invalid geometry coordinates for ${this.layer.getJSONType()}`);
        return {
            features: n,
            center: i
        };
    }
    buildMesh() {}
    createVectorPacks(e, t, n, i, r, s) {
        if (!e || !i || !i.length) return Promise.resolve(null);
        return new t(i, n, {
            zoom: this.getMap().getZoom(),
            EXTENT: 1 / 0,
            requestor: this.requestor,
            atlas: r,
            center: s,
            positionType: Float32Array
        }).load();
    }
    createMesh(e, t, n, i, r, s) {
        return this.createVectorPacks(e, t, n, i, r, s).then((o)=>this._createMesh(o, e, t, n, i, r, s));
    }
    _createMesh(e, t, n, i, r, s, l) {
        if (!e) return null;
        const h = t.createGeometries([
            e.data
        ], $435bc7696844e930$var$_e(r, null, 0, i, this.layer));
        for(let e = 0; e < h.length; e++)h[e] && this._fillCommonProps(h[e].geometry);
        const c = (0, $3iqbd).identity([]);
        (0, $3iqbd).translate(c, c, (0, $eIStk).set([], l[0], l[1], 0)), (0, $3iqbd).scale(c, c, (0, $eIStk).set([], 1, 1, this._zScale));
        const u = t.createMeshes(h, c, {
            tilePoint: [
                l[0],
                l[1]
            ]
        });
        for(let e = 0; e < u.length; e++){
            const t = u[e];
            t.properties.level = 0, t.properties.tileTransform = c;
            const n = t.defines;
            n.ENABLE_TILE_STENCIL = 1, t.setDefines(n), t.properties.meshKey = this.layer.getId();
        }
        return {
            meshes: u,
            atlas: {
                iconAtlas: e.data.iconAtlas
            }
        };
    }
    _addCoordsToCenter(e, t, n) {
        for(let i = 0; i < e.length; i++)if (Array.isArray(e[i][0])) for(let r = 0; r < e[i].length; r++)if (Array.isArray(e[i][r][0])) for(let s = 0; s < e[i][r].length; s++)isNaN(+e[i][r][s][0]) || isNaN(+e[i][r][s][1]) || this._addCoord(t, e[i][r][s][0], e[i][r][s][1], e[i][r][s][2], 1, n[i][r][s]);
        else isNaN(+e[i][r][0]) || isNaN(+e[i][r][1]) || this._addCoord(t, e[i][r][0], e[i][r][1], e[i][r][2], 1, n[i][r]);
        else isNaN(+e[i][0]) || isNaN(+e[i][1]) || this._addCoord(t, e[i][0], e[i][1], e[i][2], 1, n[i]);
    }
    _addCoord(e, t, n, i, r, s) {
        const o = this.getMap().getProjection().isSphere();
        let a = !1;
        (s[0] > 180 || s[0] < -180) && (a = !0, o && !$435bc7696844e930$var$qo && ($435bc7696844e930$var$qo = !0, console.warn(`Layer(${this.layer.getId()}) has invalid longitude value: ${s[0]}`))), (s[1] > 90 || s[1] < -90) && (a = !0, o && !$435bc7696844e930$var$qo && ($435bc7696844e930$var$qo = !0, console.warn(`Layer(${this.layer.getId()}) has invalid latitude value: ${s[1]}`))), a || (e[0] += t, e[1] += n, e[2] += i || 0, e[3] += r);
    }
    _fillCommonProps(e) {
        const t = this.getMap().getGLRes(), n = e.properties;
        n.tileResolution = t, n.tileRatio = 1, n.z = 1, n.tileExtent = 1, n.elements = e.elements, n.aPickingId = e.data.aPickingId;
    }
    _isEnableWorkAround(e) {
        return "win-intel-gpu-crash" === e && this.layer.options.workarounds["win-intel-gpu-crash"] && $435bc7696844e930$var$ia(this.gl);
    }
    prepareRequestors() {
        if (this._iconRequestor) return;
        const e = this.layer;
        this._iconRequestor = new $435bc7696844e930$var$te({
            iconErrorUrl: e.options.iconErrorUrl,
            urlModifier: (t)=>{
                const n = e.getURLModifier();
                return n && n(t) || t;
            }
        });
        const t = !this._isEnableWorkAround("win-intel-gpu-crash");
        this._glyphRequestor = new $435bc7696844e930$var$Go((t)=>{
            e.getMap().getRenderer().callInNextFrame(t);
        }, e.options.glyphSdfLimitPerFrame, t), this.requestor = this._fetchPattern.bind(this), this._markerRequestor = this._fetchIconGlyphs.bind(this);
    }
    _fetchPattern(e, t, n) {
        const i = [];
        this._iconRequestor.getIcons(e, (e, t)=>{
            if (e) throw e;
            t.buffers && i.push(...t.buffers), n(null, {
                icons: t.icons
            }, i);
        });
    }
    _fetchIconGlyphs(e, t, n) {
        this._glyphRequestor.getGlyphs(t, (t, i)=>{
            if (t) throw t;
            const r = i.buffers || [];
            this._iconRequestor.getIcons(e, (e, t)=>{
                if (e) throw e;
                t.buffers && t.buffers.length && r.push(...t.buffers), n(null, {
                    icons: t.icons,
                    glyphs: i.glyphs
                }, r);
            });
        });
    }
    _buildMarkerMesh(e) {
        const t = Object.keys(this._markerFeatures), n = Object.keys(this._textFeatures);
        if (!t.length && !n.length) return void (this._markerMeshes && (this._markerPainter.deleteMesh(this._markerMeshes), delete this._markerMeshes));
        const { features: i, center: r } = this._getFeaturesToRender(this._markerFeatures, this._textFeatures), s = [], l = [];
        for(let e = 0; e < i.length; e++){
            const t = i[e][$435bc7696844e930$var$Ko];
            this._markerFeatures[t] && s.push(i[e]), this._textFeatures[t] && l.push(i[e]);
        }
        if (!s.length && !l.length) return void (this._markerMeshes && (this._markerPainter.deleteMesh(this._markerMeshes), delete this._markerMeshes));
        const h = this._showHideUpdated;
        this._markerCenter = r;
        const c = this._createPointPacks(s, l, e, r);
        this._markerAtlas = {};
        const u = [], f = [];
        this._isCreatingMarkerMesh = !0, Promise.all(c).then((e)=>{
            if (this._markerMeshes && (this._markerPainter.deleteMesh(this._markerMeshes), delete this._markerMeshes), !e || !e.length) return void this.setToRedraw();
            const t = this._markerPainter.createGeometries(e.map((e)=>(e && e.data && (e.data.isIdUnique = !0), e && e.data)), this._allFeatures);
            for(let n = 0; n < t.length; n++)this._fillCommonProps(t[n].geometry, e[n] && e[n].data);
            const n = e[0] && e[0].data.iconAtlas, i = e[0] && e[0].data.glyphAtlas || e[1] && e[1].data.glyphAtlas;
            n && (this._markerAtlas.iconAtlas = n), i && (this._markerAtlas.glyphAtlas = i);
            const s = (0, $3iqbd).identity([]);
            (0, $3iqbd).translate(s, s, (0, $eIStk).set(f, r[0], r[1], 0)), (0, $3iqbd).scale(s, s, (0, $eIStk).set(u, 1, 1, this._zScale));
            const l = this._markerPainter.createMeshes(t, s);
            for(let e = 0; e < l.length; e++)l[e].geometry.properties.originElements = l[e].geometry.properties.elements.slice(), l[e].properties.level = 0, l[e].material.set("flipY", 1), l[e].properties.meshKey = $435bc7696844e930$var$$o++;
            this._markerMeshes = l, h && (this._showHideUpdated = !0), this._isCreatingMarkerMesh = !1, this.setToRedraw(), this.layer.fire("buildmarkermesh");
        });
    }
    _updateMeshVisible() {
        if (this._markerMeshes && (this._updateVisElements(this._markerMeshes[0], this._markerFeatures), this._updateVisElements(this._markerMeshes[1], this._textFeatures), this._markerMeshes[0] && this._markerPainter.prepareCollideIndex(this._markerMeshes[0].geometry), this._markerMeshes[1] && this._markerPainter.prepareCollideIndex(this._markerMeshes[1].geometry)), this._lineMeshes) for(let e = 0; e < this._lineMeshes.length; e++)this._updateVisElements(this._lineMeshes[e], this._lineFeatures);
        if (this.meshes) for(let e = 0; e < this.meshes.length; e++)this._updateVisElements(this.meshes[e], this._allFeatures);
    }
    _updateVisElements(e, t) {
        if (!e) return;
        const { aPickingId: n, originElements: i } = e.geometry.properties, r = [];
        for(let e = 0; e < i.length; e++){
            const s = n[i[e]];
            t[s] && t[s].feature.visible && r.push(i[e]);
        }
        const s = e.geometry.properties.elements = new i.constructor(r);
        e.geometry.setElements(s);
    }
    _createPointPacks(e, t, n, i) {
        const r = {
            zoom: this.getMap().getZoom(),
            EXTENT: 1 / 0,
            requestor: this._markerRequestor,
            atlas: n,
            center: i,
            positionType: Float32Array,
            defaultAltitude: 0,
            forceAltitudeAttribute: !0,
            markerWidthType: Uint16Array,
            markerHeightType: Uint16Array,
            allowEmptyPack: 1
        };
        return [
            this._markerSymbol
        ].map((n, i)=>new $435bc7696844e930$var$jo(0 === i ? e : t, n, r).load());
    }
    updateMesh() {}
    _updateMarkerMesh(e) {
        const t = e._getInternalSymbol(), n = {
            zoom: this.getMap().getZoom(),
            isVector3D: !0
        }, i = this._convertGeo(e);
        if (!this._markerMeshes) return !1;
        let r = this.features[i];
        Array.isArray(r) || (r = [
            r
        ]);
        const s = [], o = [], a = [], l = this.getMap().getZoom();
        let h, c;
        h = Array.isArray(t) ? t.map((e)=>e ? (0, $14507960c5dac0fb$export$7359e25750286ba6)(e, ()=>(s[0] = l, s)) : e) : (0, $14507960c5dac0fb$export$7359e25750286ba6)(t, ()=>(s[0] = l, s)), c = Array.isArray(t) ? t.map((e)=>e ? $435bc7696844e930$var$Yo.genFnTypes(e) : e) : $435bc7696844e930$var$Yo.genFnTypes(t);
        for(let e = 0; e < r.length; e++){
            if (!r[e]) continue;
            const i = Array.isArray(t) ? t[e] : t, s = Array.isArray(h) ? h[e] : h, o = Array.isArray(c) ? c[e] : c, a = new $435bc7696844e930$var$Xo(r, i, s, o, n).getIconAndGlyph();
            if (!this._markerAtlas || !$435bc7696844e930$var$jo.isAtlasLoaded(a, this._markerAtlas)) return this._markRebuild(), this.setToRedraw(), !1;
        }
        for(let e = 0; e < r.length; e++){
            const t = r[e][$435bc7696844e930$var$Ko];
            this._markerFeatures[t] && o.push(r[e]), this._textFeatures[t] && a.push(r[e]);
        }
        const u = r[0].id, f = this._createPointPacks(o, a, this._markerAtlas, this._markerCenter), d = this._markerMeshes;
        return Promise.all(f).then((e)=>{
            for(let t = 0; t < e.length; t++){
                if (!e[t]) continue;
                e[t].data && (e[t].data.isIdUnique = !0);
                const n = d[t], i = n.geometry.properties.aFeaIds.indexOf(u);
                if (i < 0) continue;
                const r = e[t].data.featureIds.length, s = e[t].data.dynamicAttributes;
                for(const o in e[t].data.data){
                    if ("aPickingId" === o) continue;
                    if (s[o]) continue;
                    const a = e[t].data.data[o];
                    a && n.geometry.updateSubData(o, a, i * a.length / r);
                }
            }
            this.setToRedraw();
        }), !0;
    }
    _updateLineMesh(e) {
        return this._updateMesh(e, this._lineMeshes, this._lineAtlas, this._lineCenter, this._linePainter, $435bc7696844e930$var$Wo, $435bc7696844e930$var$Ln, this._groupLineFeas);
    }
    _updateMesh(e, t, n, i, r, s, o, a) {
        if (!t) return !1;
        if (!n) return this._markRebuild(), this.setToRedraw(), !1;
        const l = e._getInternalSymbol(), h = {
            zoom: this.getMap().getZoom()
        }, c = e[$435bc7696844e930$var$Vn];
        let u = this.features[c];
        Array.isArray(u) || (u = [
            u
        ]);
        const f = [];
        for(let e = 0; e < u.length; e++){
            const t = u[e];
            if (!t) continue;
            const i = Array.isArray(l) ? l[e] : l, r = $435bc7696844e930$var$Yo.genFnTypes(i), o = new $435bc7696844e930$var$Zo(u, i, r, h), a = s === $435bc7696844e930$var$Wo ? o.getLineResource() : o.getPolygonResource();
            if (!$435bc7696844e930$var$Yo.isAtlasLoaded(a, n[e])) return this._markRebuild(), this.setToRedraw(), !1;
            f.push(t);
        }
        const d = u[0].id, p = a.call(this, f);
        for(let e = 0; e < p.length; e++)if (p[e].length) {
            const n = t.filter((t)=>t.feaGroupIndex === e);
            if (!n.length) return this._markRebuild(), this.setToRedraw(), !1;
            if (n[0].geometry.properties.aFeaIds.indexOf(d) < 0) return this._markRebuild(), this.setToRedraw(), !1;
        }
        const g = $435bc7696844e930$var$U({}, o), m = p.map((e)=>this.createVectorPacks(r, s, g, e, n[0], i));
        return Promise.all(m).then((e)=>{
            for(let n = 0; n < e.length; n++){
                let i;
                if (Array.isArray(t)) {
                    for(let e = 0; e < t.length; e++)if (t[e].feaGroupIndex === n) {
                        i = t[e];
                        break;
                    }
                } else i = t;
                i && this._updateMeshData(i, d, e[n]);
            }
        }), !0;
    }
    _updateMeshData(e, t, n) {
        const i = e.geometry.properties.aFeaIds, r = i.indexOf(t);
        if (!(r < 0)) {
            if (n) {
                const t = n.data.dynamicAttributes, i = n.data.featureIds.length, s = n.data.data;
                for(const n in s)if (!t[n] && $435bc7696844e930$var$q(s, n) && s[n]) {
                    const t = s[n];
                    e.geometry.updateSubData(n, t, r * t.length / i);
                }
            } else {
                let n = r + 1;
                for(; i[n] === t;)n++;
                const s = n - r, o = e.geometry.desc.positionSize;
                $435bc7696844e930$var$Qo.length !== 3 * s && ($435bc7696844e930$var$Qo = new Float32Array(s * o), $435bc7696844e930$var$Qo.fill(-1 / 0, 0)), e.geometry.updateSubData(e.geometry.desc.positionAttribute, $435bc7696844e930$var$Qo, r * o);
            }
            this.layer.fire("updatemesh"), this.setToRedraw();
        }
    }
    _buildLineMesh(e) {
        if (!Object.keys(this._lineFeatures).length) return void (this._lineMeshes && (this._linePainter.deleteMesh(this._lineMeshes), delete this._lineMeshes));
        const { features: t, center: n } = this._getFeaturesToRender(this._lineFeatures);
        if (!t.length) return;
        const i = this._showHideUpdated;
        this._lineCenter = n;
        const r = this._groupLineFeas(t), s = $435bc7696844e930$var$U({}, $435bc7696844e930$var$Ln), o = r.map((t, i)=>this.createMesh(this._linePainter, $435bc7696844e930$var$Wo, s, t, e && e[i], n));
        this._isCreatingLineMesh = !0, Promise.all(o).then((e)=>{
            this._lineMeshes && this._linePainter.deleteMesh(this._lineMeshes);
            const t = [], n = [];
            for(let i = 0; i < e.length; i++){
                const r = e[i] && e[i].meshes;
                if (r) {
                    for(let e = 0; e < r.length; e++){
                        const n = r[e];
                        n.feaGroupIndex = i, t.push(n), n.geometry.properties.originElements = n.geometry.properties.elements.slice();
                    }
                    n[i] = e[i].atlas;
                }
            }
            this._lineMeshes = t, this._lineAtlas = n, i && (this._showHideUpdated = i), this._isCreatingLineMesh = !1, this.setToRedraw(), this.layer.fire("buildlinemesh");
        });
    }
    _groupLineFeas(e) {
        const t = ($435bc7696844e930$var$Jo + "lineDasharray").trim(), n = ($435bc7696844e930$var$Jo + "linePatternFile").trim(), i = [], r = [], s = [];
        for(let o = 0; o < e.length; o++){
            const a = e[o], l = a.properties && a.properties[t];
            l && $435bc7696844e930$var$ha(l) ? s.push(a) : a.properties && a.properties[n] ? r.push(a) : i.push(a);
        }
        return [
            i,
            r,
            s
        ];
    }
    _markRebuildGeometry() {
        this._dirtyGeo = !0, this.setToRedraw();
    }
    _markRebuild() {
        this._dirtyAll = !0, this.setToRedraw();
    }
    _convertGeometries(e) {
        const t = this.layer.getId();
        for(let n = 0; n < e.length; n++){
            const i = e[n];
            let r = !1;
            for(let e = 0; e < this.GeometryTypes.length; e++)if (i instanceof this.GeometryTypes[e]) {
                r = !0;
                break;
            }
            if (!r) throw new Error(`${i.getJSONType()} can't be added to ${this.layer.getJSONType()}(id:${t}).`);
            this._convertGeo(i);
        }
    }
    _convertGeo(e) {
        void 0 === e[$435bc7696844e930$var$Vn] && (e[$435bc7696844e930$var$Vn] = this._counter++);
        const t = e[$435bc7696844e930$var$Vn];
        this.features[t] && this._removeFeatures(t), this.features[t] = $435bc7696844e930$var$Bn(e, this._kidGen, this.features[t]);
        const n = this.features[t];
        return this._refreshFeatures(n, t), this._geometries[t] = e, t;
    }
    _refreshFeatures(e, t) {
        if (!e) return;
        const n = Array.isArray(e) ? e[0].id : e.id;
        if (this._featureMapping[n] = e, Array.isArray(e)) for(let n = 0; n < e.length; n++){
            const i = e[n][$435bc7696844e930$var$Ko];
            if (e[n][$435bc7696844e930$var$Vn] = t, this._allFeatures[i] = {
                feature: e[n]
            }, this._allFeatures[i][$435bc7696844e930$var$Vn] = t, !this.needCheckPointLineSymbols()) continue;
            const r = {
                feature: e[n]
            };
            ($435bc7696844e930$var$ra(e[n]) || $435bc7696844e930$var$sa(e[n])) && (this._markerFeatures[i] = r), $435bc7696844e930$var$sa(e[n]) && (this._textFeatures[i] = r), $435bc7696844e930$var$la(e[n]) && (this._lineFeatures[i] = r);
        }
        else {
            e[$435bc7696844e930$var$Vn] = t;
            const n = {
                feature: e
            }, i = e[$435bc7696844e930$var$Ko];
            if (this._allFeatures[i] = n, !this.needCheckPointLineSymbols()) return;
            ($435bc7696844e930$var$ra(e) || $435bc7696844e930$var$sa(e)) && (this._markerFeatures[i] = n), $435bc7696844e930$var$sa(e) && (this._textFeatures[i] = n), $435bc7696844e930$var$la(e) && (this._lineFeatures[i] = n);
        }
    }
    needCheckPointLineSymbols() {
        return !0;
    }
    _removeFeatures(e) {
        const t = this.features[e];
        if (t) {
            if (Array.isArray(t)) for(let e = 0; e < t.length; e++){
                const n = t[e][$435bc7696844e930$var$Ko], i = t[e].id;
                delete this._featureMapping[i], delete this._allFeatures[n], delete this._markerFeatures[n], delete this._textFeatures[n], delete this._lineFeatures[n];
            }
            else {
                const e = t[$435bc7696844e930$var$Ko], n = t.id;
                delete this._featureMapping[n], delete this._allFeatures[e], delete this._markerFeatures[e], delete this._textFeatures[e], delete this._lineFeatures[e];
            }
        }
    }
    pick(e, t, n) {
        const i = [];
        if (!this.layer.isVisible()) return i;
        return [
            this.painter,
            this._markerPainter,
            this._linePainter
        ].forEach((r)=>{
            if (!r) return;
            const s = r.pick(e, t, n.tolerance);
            if (s && s.data && s.data.feature) {
                const e = s.data.feature, t = this._geometries[e[$435bc7696844e930$var$Vn]];
                n && n.includeInternals ? i.push(t) : (s.geometry = t, delete s.plugin, delete s.data, delete s.point, i.push(s));
            }
        }), i;
    }
    _getFeaKeyId(e) {
        const t = e[$435bc7696844e930$var$Vn], n = this.features[t];
        return Array.isArray(n) ? n[0][$435bc7696844e930$var$Ko] : n[$435bc7696844e930$var$Ko];
    }
    _updateDirtyTargets() {
        let e = !1;
        for(const t in this._dirtyTargetsInCurrentFrame){
            const n = this._dirtyTargetsInCurrentFrame[t], i = this._getFeaKeyId(n);
            if (!this._isCreatingMarkerMesh && (this._markerFeatures[i] || this._textFeatures[i])) {
                const t = this._updateMarkerMesh(n);
                e = e || t;
            }
            if (!this._isCreatingLineMesh && this._lineFeatures[i]) {
                const t = this._updateLineMesh(n);
                e = e || t;
            }
            if (!this._isCreatingMesh) {
                const t = this.updateMesh(n);
                e = e || t;
            }
        }
        this._dirtyTargetsInCurrentFrame = {}, e && ($435bc7696844e930$var$na(this), this.layer.fire("partialupdate"));
    }
    _convertAndRebuild(e) {
        this._convertGeo(e), this._markRebuild(), $435bc7696844e930$var$na(this);
    }
    onGeometryAdd(e) {
        this.setToRedraw(), this.canvas && e && e.length && (this._convertGeometries(e), this._markRebuild(), $435bc7696844e930$var$na(this));
    }
    onGeometryRemove(e) {
        if (e && e.length) {
            for(let t = 0; t < e.length; t++){
                const n = e[t][$435bc7696844e930$var$Vn];
                void 0 !== n && (delete this._geometries[n], this._removeFeatures(n), delete this.features[n]);
            }
            this._markRebuild(), $435bc7696844e930$var$na(this);
        }
    }
    onGeometrySymbolChange(e) {
        const t = e.target._getParent() || e.target, n = t[$435bc7696844e930$var$Vn];
        if (void 0 === n) return;
        let i = e.properties;
        if (Array.isArray(i)) {
            const e = {};
            for(let t = 0; t < i.length; t++)i[t] && $435bc7696844e930$var$U(e, i[t]);
            i = e;
        } else if (i && void 0 !== i[0]) {
            const e = {};
            for(const t in i)i[t] && $435bc7696844e930$var$U(e, i[t]);
            i = e;
        }
        for(const e in i)if ($435bc7696844e930$var$q(i, e) && $435bc7696844e930$var$Bo[e]) return void this._convertAndRebuild(t);
        const r = t._getInternalSymbol(), s = this.features[n];
        if (this._convertGeo(t), s) {
            if (function(e, t) {
                return Array.isArray(e) ? !!Array.isArray(t) && e.length === t.length : !Array.isArray(t);
            }(r, s)) {
                if (Array.isArray(r)) for(let e = 0; e < r.length; e++){
                    if (!$435bc7696844e930$var$ca(r[e], s[e])) return void this._convertAndRebuild(t);
                }
                else if (!$435bc7696844e930$var$ca(r, s)) return void this._convertAndRebuild(t);
                this.onGeometryPositionChange(e);
            } else this._convertAndRebuild(t);
        } else this._convertAndRebuild(t);
    }
    onGeometryShapeChange(e) {
        const t = e.target._getParent() || e.target;
        void 0 !== t[$435bc7696844e930$var$Vn] && (this._convertGeometries([
            t
        ]), this._markRebuildGeometry(), $435bc7696844e930$var$na(this));
    }
    onGeometryPositionChange(e) {
        const t = e.target._getParent() || e.target, n = t[$435bc7696844e930$var$Vn];
        void 0 !== n && (this._convertGeometries([
            t
        ]), this._dirtyTargetsInCurrentFrame[n] = t, $435bc7696844e930$var$na(this));
    }
    onGeometryZIndexChange(e) {
        void 0 !== (e.target._getParent() || e.target)[$435bc7696844e930$var$Vn] && this._markRebuild();
    }
    onGeometryShow(e) {
        void 0 !== (e.target._getParent() || e.target)[$435bc7696844e930$var$Vn] && this._onShowHide(e);
    }
    onGeometryHide(e) {
        void 0 !== (e.target._getParent() || e.target)[$435bc7696844e930$var$Vn] && this._onShowHide(e);
    }
    _onShowHide(e) {
        const t = e.target._getParent() || e.target, n = t[$435bc7696844e930$var$Vn], i = this.features[n];
        if (i) {
            const e = t.isVisible();
            if (Array.isArray(i)) {
                if (e === i[0].visible) return;
                for(let t = 0; t < i.length; t++)i[t].visible = e;
            } else {
                if (e === i.visible) return;
                i.visible = e;
            }
            this._markShowHide(), $435bc7696844e930$var$na(this);
        }
    }
    _markShowHide() {
        this._showHideUpdated = !0;
    }
    onGeometryPropertiesChange(e) {
        const t = e.target._getParent() || e.target, n = t[$435bc7696844e930$var$Vn];
        void 0 !== n && this.painter && (this.features[n] = $435bc7696844e930$var$Bn(t, this._kidGen), this._refreshFeatures(this.features[n], n), this._markerMeshes && this._markerMeshes.length && this._markerPainter.needRebuildOnGometryPropertiesChanged() || this._lineMeshes && this._lineMeshes.length && this._linePainter.needRebuildOnGometryPropertiesChanged() || this.meshes && this.meshes.length && this.painter.needRebuildOnGometryPropertiesChanged() ? this._markRebuild() : this.painter.onFeatureChange(this.features[n], this.meshes), $435bc7696844e930$var$na(this));
    }
    createContext() {
        const e = this.canvas.gl && this.canvas.gl.wrap;
        e ? (this.gl = this.canvas.gl.wrap(), this.regl = this.canvas.gl.regl) : this._createREGLContext(), e && (this.canvas.pickingFBO = this.canvas.pickingFBO || this.regl.framebuffer(this.canvas.width, this.canvas.height)), this.prepareRequestors(), this.pickingFBO = this.canvas.pickingFBO || this.regl.framebuffer(this.canvas.width, this.canvas.height), this.painter = this.createPainter();
        const t = $435bc7696844e930$export$d39412b8ec89578a.get3DPainterClass("icon");
        let n = t.getBloomSymbol();
        const i = $435bc7696844e930$var$U({}, $435bc7696844e930$var$En, $435bc7696844e930$var$Dn);
        i.markerPerspectiveRatio = this.layer.options.markerPerspectiveRatio || 0, this._defineSymbolBloom(i, n), this._markerSymbol = i;
        const r = $435bc7696844e930$var$U({}, $435bc7696844e930$var$ae, this.layer.options.sceneConfig || {});
        this._markerPainter = new t(this.regl, this.layer, i, r, 0), this._markerPainter.setShaderDefines({
            REVERSE_MAP_ROTATION_ON_PITCH: 1
        });
        const s = $435bc7696844e930$export$d39412b8ec89578a.get3DPainterClass("line"), o = $435bc7696844e930$var$U({}, $435bc7696844e930$var$Ln);
        n = s.getBloomSymbol(), this._defineSymbolBloom(o, n), this._lineSymbol = o;
        const a = $435bc7696844e930$var$U({}, this.layer.options.sceneConfig || {});
        void 0 === a.depthMask && (a.depthMask = !0), this._linePainter = new s(this.regl, this.layer, o, a, 0), this.layer.getGeometries() && this.onGeometryAdd(this.layer.getGeometries());
    }
    _isInGroupGLLayer() {
        return !!(this.canvas && this.canvas.gl && this.canvas.gl.wrap);
    }
    _defineSymbolBloom(e, t) {
        for(let n = 0; n < t.length; n++)e[t[n]] = this.layer.options.enableBloom;
    }
    updateBloom(e) {
        this._markerPainter && this._updatePainterBloom(this._markerPainter, this._markerSymbol, e), this._linePainter && this._updatePainterBloom(this._linePainter, this._lineSymbol, e), this.painter && this._updatePainterBloom(this.painter, this.painterSymbol, e);
    }
    _updatePainterBloom(e, t, n) {
        const i = e.constructor.getBloomSymbol().reduce((e, i)=>(e[i] = n, t[i] = n, e), {});
        e.updateSymbol(i, t);
    }
    createPainter() {}
    _createREGLContext() {
        const e = this.layer.options.glOptions || {
            alpha: !0,
            depth: !0,
            stencil: !0,
            antialias: !1
        };
        e.preserveDrawingBuffer = !0, e.stencil = !0, this.glOptions = e, this.gl = this.gl || this._createGLContext(this.canvas, e), this.regl = (0, (/*@__PURE__*/$parcel$interopDefault($9I15V)))({
            gl: this.gl,
            attributes: e,
            extensions: (0, $2wazW).Constants.WEBGL_EXTENSIONS,
            optionalExtensions: (0, $2wazW).Constants.WEBGL_OPTIONAL_EXTENSIONS
        });
    }
    _createGLContext(e, t) {
        const n = [
            "webgl",
            "experimental-webgl"
        ];
        let i = null;
        for(let r = 0; r < n.length; ++r){
            try {
                i = e.getContext(n[r], t);
            } catch (e) {}
            if (i) break;
        }
        return i;
    }
    clearCanvas() {
        super.clearCanvas(), this.regl && this.regl.clear({
            color: [
                0,
                0,
                0,
                0
            ],
            depth: 1,
            stencil: 255
        });
    }
    resizeCanvas(e) {
        super.resizeCanvas(e);
        const t = this.canvas;
        t && (!this.pickingFBO || this.pickingFBO.width === t.width && this.pickingFBO.height === t.height || this.pickingFBO.resize(t.width, t.height), this.painter && this.painter.resize(t.width, t.height));
    }
    onRemove() {
        super.onRemove(), this.painter && (this.painter.delete(), delete this.painter), this._markerPainter && (this._markerPainter.delete(), delete this._markerPainter), this._linePainter && (this._linePainter.delete(), delete this._linePainter);
    }
    drawOutline(e) {
        if (this._outlineAll && (this.painter && this.painter.outlineAll(e), this._markerPainter.outlineAll(e), this._linePainter.outlineAll(e)), this._outlineFeatures) for(let t = 0; t < this._outlineFeatures.length; t++)this.painter && this.painter.outline(e, this._outlineFeatures[t]), this._markerPainter.outline(e, this._outlineFeatures[t]), this._linePainter.outline(e, this._outlineFeatures[t]);
    }
    outlineAll() {
        this._outlineAll = !0, this.setToRedraw();
    }
    outline(e) {
        this._outlineFeatures || (this._outlineFeatures = []);
        const t = [];
        for(let n = 0; n < e.length; n++){
            const i = this.layer.getGeometryById(e[n]);
            if (i) {
                const e = this.features[i[$435bc7696844e930$var$Vn]];
                if (Array.isArray(e)) for(let n = 0; n < e.length; n++)t.push(e[n].id);
                else t.push(e.id);
            }
        }
        this._outlineFeatures.push(t), this.setToRedraw();
    }
    cancelOutline() {
        delete this._outlineAll, delete this._outlineFeatures, this.setToRedraw();
    }
    isEnableWorkAround(e) {
        return "win-intel-gpu-crash" === e && this.layer.options.workarounds["win-intel-gpu-crash"] && $435bc7696844e930$var$ia(this.gl);
    }
    _getCentiMeterScale(e) {
        return $435bc7696844e930$var$$(e, this.getMap());
    }
    _onSpatialReferenceChange() {
        const e = this.layer.getGeometries();
        e && this._convertGeometries(e), this._markRebuild();
    }
    _getLayerOpacity() {
        const e = this.layer.options.opacity;
        return this._isInGroupGLLayer() ? $435bc7696844e930$var$X(e) ? 1 : e : 1;
    }
}
function $435bc7696844e930$var$na(e) {
    e.setToRedraw();
}
function $435bc7696844e930$var$ia(e) {
    const t = e.getExtension("WEBGL_debug_renderer_info");
    if (t && "undefined" != typeof navigator) {
        const n = e.getParameter(t.UNMASKED_RENDERER_WEBGL), i = "Win32" === navigator.platform || "Win64" === navigator.platform;
        if (n && n.toLowerCase().indexOf("intel") >= 0 && i) return !0;
    }
    return !1;
}
function $435bc7696844e930$var$ra({ properties: e }) {
    const t = ($435bc7696844e930$var$Jo + "markerFile").trim(), n = ($435bc7696844e930$var$Jo + "markerType").trim();
    return e[t] || e[n];
}
function $435bc7696844e930$var$sa({ properties: e }) {
    return e[($435bc7696844e930$var$Jo + "textName").trim()];
}
const $435bc7696844e930$var$oa = ($435bc7696844e930$var$Jo + "lineWidth").trim(), $435bc7696844e930$var$aa = ($435bc7696844e930$var$Hn + "").trim();
function $435bc7696844e930$var$la(e) {
    return 2 === e.type && !e.properties[$435bc7696844e930$var$aa] || 3 === e.type && void 0 !== e.properties[$435bc7696844e930$var$oa];
}
function $435bc7696844e930$var$ha(e) {
    if (!Array.isArray(e)) return 0;
    let t = 0;
    for(let n = 0; n < e.length; n++)t += e[n];
    return t;
}
function $435bc7696844e930$var$ca(e, t) {
    if (Object.keys(e).sort().join() !== Object.keys(t.properties || {}).filter((e)=>0 === e.indexOf($435bc7696844e930$var$Jo)).map((e)=>e.substring($435bc7696844e930$var$Jo.length)).sort().join()) return !1;
    for(const n in e)if ($435bc7696844e930$var$q(e, n)) {
        const i = ($435bc7696844e930$var$Jo + n).trim();
        if ((0, $14507960c5dac0fb$export$ec423ecbfcdb9a06)(e[n]) !== (0, $14507960c5dac0fb$export$ec423ecbfcdb9a06)(t.properties[i])) return !1;
    }
    return !0;
}
function $435bc7696844e930$var$ua(t, n, i) {
    if (!t || t.type !== n) return null;
    const r = new i(t.id, t.options), s = t.geometries, o = [];
    for(let t = 0; t < s.length; t++){
        const n = $gP1US.Geometry.fromJSON(s[t]);
        n && o.push(n);
    }
    return r.addGeometry(o), r;
}
class $435bc7696844e930$export$3104c9d70f6f4edf extends $435bc7696844e930$export$d39412b8ec89578a {
    static fromJSON(e) {
        return $435bc7696844e930$var$ua(e, "PointLayer", $435bc7696844e930$export$3104c9d70f6f4edf);
    }
    constructor(...e){
        super(...e), this.options.sceneConfig || (this.options.sceneConfig = $435bc7696844e930$var$U({}, $435bc7696844e930$var$ae));
    }
    getPolygonOffsetCount() {
        return 0;
    }
    getPolygonOffset() {
        return 0;
    }
}
$435bc7696844e930$export$3104c9d70f6f4edf.mergeOptions({
    glyphSdfLimitPerFrame: 15,
    iconErrorUrl: null,
    workarounds: {
        "win-intel-gpu-crash": !0
    },
    collision: !1,
    collisionFrameLimit: 1
}), $435bc7696844e930$export$3104c9d70f6f4edf.registerJSONType("PointLayer"), $435bc7696844e930$export$3104c9d70f6f4edf.registerRenderer("canvas", null);
$435bc7696844e930$export$3104c9d70f6f4edf.registerRenderer("gl", class extends $435bc7696844e930$var$ta {
    constructor(...t){
        super(...t), this.GeometryTypes = [
            $gP1US.Marker,
            $gP1US.MultiPoint
        ];
    }
    onGeometryAdd(e) {
        e && (Array.isArray(e) ? e.forEach((e)=>{
            e.options.maxMarkerWidth = e.options.maxMarkerHeight = 255;
        }) : e.options.maxMarkerWidth = e.options.maxMarkerHeight = 255, super.onGeometryAdd(e));
    }
});
const { LinePack: $435bc7696844e930$var$da } = $435bc7696844e930$var$H();
class $435bc7696844e930$export$65b0c9a2ead3779a extends $435bc7696844e930$export$d39412b8ec89578a {
    static fromJSON(e) {
        return $435bc7696844e930$var$ua(e, "LineStringLayer", $435bc7696844e930$export$65b0c9a2ead3779a);
    }
}
$435bc7696844e930$export$65b0c9a2ead3779a.mergeOptions({
    meshRenderOrder: 1
}), $435bc7696844e930$export$65b0c9a2ead3779a.registerJSONType("LineStringLayer");
const $435bc7696844e930$var$ga = ($435bc7696844e930$var$Hn + "").trim();
$435bc7696844e930$export$65b0c9a2ead3779a.registerRenderer("gl", class extends $435bc7696844e930$var$ta {
    constructor(...t){
        super(...t), this.GeometryTypes = [
            $gP1US.LineString,
            $gP1US.MultiLineString
        ];
    }
    createPainter() {
        const e = $435bc7696844e930$export$d39412b8ec89578a.get3DPainterClass("line-gradient");
        this.painterSymbol = $435bc7696844e930$var$U({}, {
            lineGradientProperty: $435bc7696844e930$var$ga
        }, $435bc7696844e930$var$Ln), this._defineSymbolBloom(this.painterSymbol, e.getBloomSymbol());
        const t = $435bc7696844e930$var$U({}, this.layer.options.sceneConfig || {});
        void 0 === t.depthMask && (t.depthMask = !0);
        return new e(this.regl, this.layer, this.painterSymbol, t, 0);
    }
    buildMesh() {
        let { features: e, center: t } = this._getFeaturesToRender();
        if (e = e.filter((e)=>!!e.properties[$435bc7696844e930$var$ga]), !e.length) return;
        const n = this._showHideUpdated;
        this._meshCenter = t;
        const i = $435bc7696844e930$var$U({}, this.painterSymbol), r = this.createMesh(this.painter, $435bc7696844e930$var$da, i, e, null, t);
        this._isCreatingMesh = !0, r.then((e)=>{
            this.meshes && this.painter.deleteMesh(this.meshes);
            const t = [], i = e && e.meshes;
            if (i) {
                t.push(...i);
                for(let e = 0; e < i.length; e++)i[e].feaGroupIndex = 0, i[e].geometry.properties.originElements = i[e].geometry.properties.elements.slice();
            }
            this.meshes = t, n && (this._showHideUpdated = n), this._isCreatingMesh = !1, this.setToRedraw();
        });
    }
}), $435bc7696844e930$export$65b0c9a2ead3779a.registerRenderer("canvas", null);
const { PolygonPack: $435bc7696844e930$var$ma } = $435bc7696844e930$var$H();
class $435bc7696844e930$export$fc86642dffc12c0a extends $435bc7696844e930$export$d39412b8ec89578a {
    static fromJSON(e) {
        return $435bc7696844e930$var$ua(e, "PolygonLayer", $435bc7696844e930$export$fc86642dffc12c0a);
    }
}
$435bc7696844e930$export$fc86642dffc12c0a.registerJSONType("PolygonLayer");
const $435bc7696844e930$var$xa = {
    polygonFill: {
        type: "identity",
        default: [
            1,
            1,
            1,
            1
        ],
        property: "_symbol_polygonFill"
    },
    polygonPatternFile: {
        type: "identity",
        default: void 0,
        property: "_symbol_polygonPatternFile"
    },
    polygonOpacity: {
        type: "identity",
        default: 1,
        property: "_symbol_polygonOpacity"
    },
    uvScale: {
        type: "identity",
        default: [
            1,
            1
        ],
        property: "_symbol_uvScale"
    },
    uvOffset: {
        type: "identity",
        default: [
            0,
            0
        ],
        property: "_symbol_uvOffset"
    },
    uvOffsetInMeter: {
        type: "identity",
        default: !1,
        property: "_symbol_uvOffsetInMeter"
    },
    polygonPatternFileWidth: {
        type: "identity",
        default: void 0,
        property: "_symbol_polygonPatternFileWidth"
    },
    polygonPatternFileHeight: {
        type: "identity",
        default: void 0,
        property: "_symbol_polygonPatternFileHeight"
    },
    polygonPatternFileOrigin: {
        type: "identity",
        default: void 0,
        property: "_symbol_polygonPatternFileOrigin"
    },
    polygonPatternUV: {
        type: "identity",
        default: void 0,
        property: "_symbol_polygonPatternUV"
    }
};
class $435bc7696844e930$var$_a extends $435bc7696844e930$var$ta {
    constructor(){
        super(...arguments), this.GeometryTypes = [
            $gP1US.Polygon,
            $gP1US.MultiPolygon
        ];
    }
    getPolygonOffsetCount() {
        return this.options.altitude > 0 ? 0 : 2;
    }
    buildMesh(e) {
        const { features: t, center: n } = this._getFeaturesToRender();
        if (!t.length) return;
        const i = this._showHideUpdated;
        this._meshCenter = n;
        const r = this._groupPolygonFeatures(t), s = $435bc7696844e930$var$U({}, $435bc7696844e930$var$xa), o = r.map((t, i)=>this.createMesh(this.painter, $435bc7696844e930$var$ma, s, t, e && e[i], n));
        this._isCreatingMesh = !0, Promise.all(o).then((e)=>{
            this.meshes && this.painter.deleteMesh(this.meshes), e = function(e) {
                const t = [];
                for(let n = 0; n < e.length; n++)Array.isArray(e[n]) ? t.push(...e[n]) : t.push(e[n]);
                return t;
            }(e);
            const t = [], n = [];
            for(let i = 0; i < e.length; i++){
                const r = e[i] && e[i].meshes;
                if (r) {
                    t.push(...r);
                    for(let e = 0; e < r.length; e++)r[e].feaGroupIndex = i, r[e].geometry.properties.originElements = r[e].geometry.properties.elements.slice(), 1 === i && (r[e].transparent = !0);
                    n[i] = e[i].atlas;
                }
            }
            this.meshes = t, this.atlas = n, i && (this._showHideUpdated = i), this._isCreatingMesh = !1, this.setToRedraw(), this.layer.fire("buildmesh");
        });
    }
    getRayCastData(e, t) {
        const n = this.painter.getRayCastData(e, t);
        if (!n || !n.feature) return null;
        const i = n.feature[$435bc7696844e930$var$Vn];
        return this._geometries[i];
    }
    _groupPolygonFeatures(e) {
        const t = [], n = [];
        for(let i = 0; i < e.length; i++){
            const r = e[i];
            r.properties && r.properties._symbol_polygonOpacity < 1 ? n.push(r) : t.push(r);
        }
        return [
            t,
            n
        ];
    }
    createPainter() {
        const e = $435bc7696844e930$export$d39412b8ec89578a.get3DPainterClass("fill"), t = this.painterSymbol = $435bc7696844e930$var$U({}, $435bc7696844e930$var$xa);
        this._defineSymbolBloom(t, e.getBloomSymbol());
        return new e(this.regl, this.layer, t, this.layer.options.sceneConfig, 0);
    }
    updateMesh(e) {
        return this._updateMesh(e, this.meshes, this.atlas, this._meshCenter, this.painter, $435bc7696844e930$var$ma, $435bc7696844e930$var$xa, this._groupPolygonFeatures);
    }
}
function $435bc7696844e930$var$va(e, t, n, i, r, s, o) {
    const a = n && Array.isArray(n[0]);
    for(let s = 0, l = n.length; s < l; s++){
        e[t] = (a ? n[s][0] : n[s].x) * i, e[t + 1] = (a ? n[s][1] : n[s].y) * i, o !== Float32Array && (e[t] = Math.round(e[t]), e[t + 1] = Math.round(e[t + 1]));
        let l = r || 0;
        Array.isArray(r) && (l = r[s]), l = l ? Math.round(i * l) : 0, e[t + 2] = l, t += 3;
    }
    return e.trySetLength && e.trySetLength(t), t;
}
function $435bc7696844e930$var$ba(e, t, n, i) {
    const r = e[3 * t], s = e[3 * t + 1], o = e[3 * n], a = e[3 * n + 1];
    return r === o && (r < 0 || r > i) || s === a && (s < 0 || s > i);
}
$435bc7696844e930$export$fc86642dffc12c0a.registerRenderer("gl", $435bc7696844e930$var$_a), $435bc7696844e930$export$fc86642dffc12c0a.registerRenderer("canvas", null);
const $435bc7696844e930$var$Aa = Math.PI / 180, $435bc7696844e930$var$Ta = 6378137 * Math.PI / 180, $435bc7696844e930$var$Sa = 85.0511287798;
function $435bc7696844e930$var$wa(e, t, n) {
    return function(e, t) {
        const n = $435bc7696844e930$var$Sa, i = t[0], r = Math.max(Math.min(n, t[1]), -n);
        let s;
        s = 0 === r ? 0 : Math.log(Math.tan((90 + r) * $435bc7696844e930$var$Aa / 2)) / $435bc7696844e930$var$Aa;
        return e[0] = i * $435bc7696844e930$var$Ta, e[1] = s * $435bc7696844e930$var$Ta, e;
    }(e, t);
}
function $435bc7696844e930$var$Ma(e, t, n, i, r, s, o, a, l, h, c, u, f, d, p) {
    0 === e ? function(e, t, n, i, r, s, o, a, l, h) {
        const c = 1 / (100 * s[0]), u = 1 / (100 * s[1]), f = h && h[0] || 0, d = h && h[1] || 0, p = [
            0,
            0
        ];
        for(let r = e; r < t; r += 3){
            const e = r / 3 * 2, t = i[r] - f, s = i[r + 1] - d;
            n[e] = p[0] + t / o * c / a, n[e + 1] = p[1] - s / o * u / l;
        }
    }(t, n, i, r, 0, o, a, l, h, p) : 1 === e && function(e, t, n, i, r, s, o, a, l, h, c) {
        if (!e) return;
        let u, f, d, p;
        0 === e[4] ? (u = e[0], f = e[1], d = e[2], p = e[3]) : (u = e[1], f = e[2], d = e[3], p = e[0]);
        const g = (0, $6BoVD).distance(u, f), m = (0, $6BoVD).distance(f, d), y = [], x = [], _ = [];
        for(let e = t; e < n; e += 3){
            const t = e / 3 * 2, n = (s.x / l + r[e] / o) * a, d = s.y / l * a + (c ? r[e + 1] : -r[e + 1]) / o * a;
            (0, $6BoVD).set(y, n, d), "EPSG:4326" !== h && "EPSG:4490" !== h || $435bc7696844e930$var$wa(y, y), $435bc7696844e930$var$Pa(x, y, u, f), $435bc7696844e930$var$Pa(_, y, p, u), i[t] = (0, $6BoVD).distance(u, x) / g, i[t + 1] = (0, $6BoVD).distance(u, _) / m;
        }
    }(c, t, n, i, r, s, a, u, f, d, !!p);
}
function $435bc7696844e930$var$Pa(e, t, n, i) {
    const r = n[0] - i[0], s = n[1] - i[1];
    let o = (t[0] - n[0]) * (n[0] - i[0]) + (t[1] - n[1]) * (n[1] - i[1]);
    return o /= r * r + s * s, e[0] = n[0] + o * r, e[1] = n[1] + o * s, e;
}
function $435bc7696844e930$var$Ia(e, t, n, i, r) {
    const s = 3 * t[n - 1], o = 3 * t[n - 1] + 1, a = e[s], l = e[o];
    var h, c, u, f;
    return h = i, c = r, u = a, f = l, Math.sqrt((u - h) * (u - h) + (f - c) * (f - c));
}
const { PackUtil: $435bc7696844e930$var$Ca, ArrayPool: $435bc7696844e930$var$ka } = $435bc7696844e930$var$H();
function $435bc7696844e930$var$Fa(e, t, n, i, r, s, o, a, l, h, c, u, f, d, p, g, m) {
    const y = t.getLength(), x = r / 3;
    for(let n = 2, i = y; n < i; n += 3)e[r + n - 2] = t[n - 2], e[r + n - 1] = t[n - 1], e[r + n - 0] = t[n] - o;
    r += y;
    for(let n = 2, i = y; n < i; n += 3)e[r + n - 2] = t[n - 2], e[r + n - 1] = t[n - 1], e[r + n - 0] = t[n] - a;
    r += y, e.trySetLength(r + y), e.copyWithin(r, r - 2 * y, r - y), r += y, e.trySetLength(r + y), e.copyWithin(r, r - 2 * y, r - y), r += y, (n = n || []).push(y / 3);
    const _ = n.getLength();
    for(let t = 0; t < _; t++)$435bc7696844e930$var$Oa(x + (n[t - 1] || 0), x + n[t], e, y / 3, l, i, h, c, u, f, s, d, p, g, m);
    return r;
}
function $435bc7696844e930$var$Oa(e, t, n, i, r, s, o, a, l, h, c, u, f, d, p) {
    const g = s.getLength();
    let m, y;
    for(let o = e, a = t; o < a - 1; o++)if (m = o, y = o + 1, r === 1 / 0 || !$435bc7696844e930$var$ba(n, m, y, r)) {
        if ((o - e) % 2 == 1 && (m += 2 * i, y += 2 * i), p) {
            let e = s.currentIndex;
            s[e++] = m + i, s[e++] = y, s[e++] = m, s[e++] = y + i, s[e++] = y, s[e++] = m + i, s.currentIndex = e;
        } else {
            let e = s.currentIndex;
            s[e++] = m + i, s[e++] = m, s[e++] = y, s[e++] = y, s[e++] = y + i, s[e++] = m + i, s.currentIndex = e;
        }
    }
    o && function(e, t, n, i, r, s, o, a, l, h, c, u) {
        let f, d = 0, p = 0, g = 0, m = 0;
        const y = u ? [
            1,
            3,
            4
        ] : [
            2,
            3,
            4
        ];
        for(let u = s.getLength() - 1; u >= o; u--){
            const o = s[u], x = 3 * o + 1, _ = 3 * o + 2, v = r[3 * o], b = r[x], A = r[_];
            d || p || (d = Math.max(r[_], r[3 * s[u - 3] + 2]), p = Math.min(r[_], r[3 * s[u - 3] + 2]), f = d - p);
            let T = g;
            const S = u % 6;
            0 === e ? (5 === S && (m = $435bc7696844e930$var$Ia(r, s, u, v, b)), T = S === y[0] || S === y[1] || S === y[2] ? g : g + m) : 1 === e && (S === y[0] || S === y[1] || S === y[2] ? T = 0 : 5 === S ? (m = $435bc7696844e930$var$Ia(r, s, u, v, b), T = m) : T = m);
            const w = T / h * (1 / (100 * c)) / a;
            let M;
            M = 1 === t ? A === d ? 1 : 0 : "bottom" === n ? A === d ? f / 100 / l : 0 : A === d ? 0 : -f / 100 / l, i[2 * o] = w, i[2 * o + 1] = M, 0 === S && (g += m);
        }
    }(a, l, h, c, n, s, g, u[0], u[1], f, d, p);
}
function $435bc7696844e930$var$Ra(e) {
    const t = [
        e[0]
    ];
    let n = e[0];
    for(let i = 1; i < e.length; i++)Array.isArray(e[i]) ? e[i][0] === n[0] && e[i][1] === n[1] && e[i][2] === n[2] || t.push(e[i]) : e[i].x === n.x && e[i].y === n.y && e[i].z === n.z || t.push(e[i]), n = e[i];
    return t;
}
const { StyleUtil: $435bc7696844e930$var$Ea, PackUtil: $435bc7696844e930$var$Da, ArrayPool: $435bc7696844e930$var$La } = $435bc7696844e930$var$H(), $435bc7696844e930$var$Ha = $435bc7696844e930$var$La.getInstance();
function $435bc7696844e930$var$Na(e, t, n, i, r, s, o, a, l, h, c, u, f, d, p, g) {
    void 0 === t.top && (t.top = !0), void 0 === t.side && (t.side = !0), $435bc7696844e930$var$Ha.reset();
    const { altitudeScale: m, altitudeProperty: y, defaultAltitude: x, heightProperty: A, minHeightProperty: T, defaultHeight: S, tangent: w, uv: M, topUVMode: R, sideUVMode: E, sideVerticalUVMode: D, top: L, side: H, textureYOrigin: N, topThickness: z } = t, V = !!g, U = function(e, t, { altitudeScale: n, altitudeProperty: i, defaultAltitude: r, heightProperty: s, minHeightProperty: o, defaultHeight: a }, { center: l, side: h, top: c, topThickness: u, uvOrigin: f, uv: d, uvSize: p, topUVMode: g, sideUVMode: m, sideVerticalUVMode: y, textureYOrigin: x, tileRatio: _, centimeterToPoint: v, verticalCentimeterToPoint: b, positionType: A, res: T, glScale: S, projectionCode: w }, M, P) {
        let I = t / e[0].extent;
        t === 1 / 0 && (I = 1);
        const k = t === 1 / 0, F = P.get(), O = P.get(), R = P.get(), E = P.getProxy(), D = P.get(), L = P.get(), H = P.get(), N = !!d, z = !!c, V = !!h, U = N ? P.get() : null;
        function B(e, n, i, r, s, o) {
            let a = n;
            if (z) {
                const h = (0, $1b0c9f6ca9bef72e$export$2e2bcd8739ae039)(E, i, 3);
                if (0 === h.length) return n;
                let c = E.getLength(), d = D.currentIndex;
                for(let e = 0; e < c; e++)D[d++] = E[e];
                if (D.currentIndex = d, n += E.getLength(), o) for(let t = 2, n = h.length; t < n; t += 3)h[t] += e / 3, h[t - 1] += e / 3, h[t - 2] += e / 3;
                else {
                    let t;
                    for(let n = 2, i = h.length; n < i; n += 3)t = h[n - 1], h[n - 1] = h[n] + e / 3, h[n] = t + e / 3, h[n - 2] += e / 3;
                }
                c = h.length, d = L.currentIndex;
                for(let e = 0; e < c; e++)L[d++] = h[e];
                L.currentIndex = d, N && $435bc7696844e930$var$Ma(g || 0, e, n, U, D, f, v, _, p[0], p[1], s, T, S, w, l), u > 0 && !V && (n = $435bc7696844e930$var$Fa(D, E, i, L, n, U, 0, u, t, N, m || 0, y || 0, x, p, _, b, r < 0 ? !o : o)), H.setLength(n / 3), H.fill(1, a / 3, n / 3);
            }
            if (V) {
                z && (u = 0), a = n, n = $435bc7696844e930$var$Fa(D, E, i, L, n, U, u, r, t, N, m || 0, y || 0, x, p, _, b, r < 0 ? !o : o), H.setLength(n / 3);
                const e = E.getLength() / 3;
                H.fill(1, a / 3, a / 3 + e), H.fill(0, a / 3 + e, a / 3 + 2 * e), H.fill(1, a / 3 + 2 * e, a / 3 + 3 * e), H.fill(0, a / 3 + 3 * e, n / 3);
            }
            return n;
        }
        let j = -1 / 0, W = 1 / 0, X = 0;
        const Y = [
            -1,
            -1,
            t + 1,
            t + 1
        ];
        let Z = 0, q = e.length;
        $435bc7696844e930$var$G(M) && (Z = M, q = M + 1);
        let $ = 0, J = !1;
        const K = P.getProxy();
        let Q = !1;
        for(; Z < q; Z++){
            const l = e[Z], h = l.id;
            $435bc7696844e930$var$G(h) && (Math.abs(h) > $ && ($ = Math.abs(h)), h < 0 && (J = !0));
            const c = l.geometry, u = l.properties[$435bc7696844e930$var$ye];
            let f = Array.isArray(u && u[0] && u[0][0]) ? u[0] : u;
            const { altitude: d, height: p } = $435bc7696844e930$var$Ca.getFeaAltitudeAndHeight(l, n, i, r, s, a, o);
            p < 0 ? (Q = !0, W = Math.min(d, W), j = Math.max(d - p, j)) : (j = Math.max(d, j), W = Math.min(d - p, W));
            const g = D.getLength();
            let m = 0, y = X;
            K.setLength(0), E.setLength(0);
            const x = $435bc7696844e930$var$Ca.calculateSignedArea(c[0]) < 0;
            for(let e = 0, n = c.length; e < n; e++){
                let i = c[e];
                x && (i = i.reverse()), i = $435bc7696844e930$var$Ra(i);
                const r = $435bc7696844e930$var$Ca.calculateSignedArea(i) < 0;
                if (!r && e > 0 && (m++, f = u && u[m], X = B(y, X, K, p * I, f, k), E.setLength(0), K.setLength(0), y = X), t !== 1 / 0 && (i = $435bc7696844e930$var$Ca.clipPolygon(i, Y)), !i.length) {
                    e === n - 1 && (X = B(y, X, K, p * I, f, k));
                    continue;
                }
                const s = i.length;
                if (Array.isArray(i[0]) ? i[0][0] === i[s - 1][0] && i[0][1] === i[s - 1][1] || i.push([
                    i[0][0],
                    i[0][1]
                ]) : i[0].x === i[s - 1].x && i[0].y === i[s - 1].y || i.push(i[0]), r) {
                    let e = K.currentIndex;
                    K[e++] = E.getLength() / 3, K.currentIndex = e;
                }
                $435bc7696844e930$var$va(E, E.getLength(), i, I, d, 0, A), e === n - 1 && (X = B(y, X, K, p * I, f, k));
            }
            const _ = D.getLength() - g, v = ($435bc7696844e930$var$pe + "").trim();
            for(let e = 0; e < _ / 3; e++){
                let e = O.currentIndex;
                O[e++] = void 0 === l[v] ? Z : l[v], O.currentIndex = e, e = F.currentIndex, F[e++] = Z, F.currentIndex = e, $435bc7696844e930$var$G(h) && (e = R.currentIndex, R[e++] = h, R.currentIndex = e);
            }
        }
        const ee = $435bc7696844e930$var$Ca.getUnsignedArrayType(O.getLength() ? O[O.getLength() - 1] : 0), te = {
            hasNegativeHeight: Q,
            maxAltitude: j === -1 / 0 ? 0 : j,
            minAltitude: W === 1 / 0 ? 0 : W,
            vertices: D,
            verticeTypes: H,
            indices: L,
            pickingIds: $435bc7696844e930$var$ka.createTypedArray(O, ee),
            featureIndexes: F
        };
        if (R.getLength()) {
            const e = J ? $435bc7696844e930$var$Ca.getPosArrayType($) : $435bc7696844e930$var$Ca.getUnsignedArrayType($);
            te.featureIds = $435bc7696844e930$var$ka.createTypedArray(R, e);
        } else te.featureIds = [];
        return U && (U.setLength(D.getLength() / 3 * 2), te.uvs = U), te;
    }(e, n, {
        altitudeScale: m,
        altitudeProperty: y,
        defaultAltitude: x || 0,
        heightProperty: A,
        minHeightProperty: T,
        defaultHeight: S || 0
    }, {
        center: g,
        top: L,
        side: H,
        topThickness: 10 * z || 0,
        uv: M || w,
        uvSize: [
            r,
            r
        ],
        uvOrigin: i,
        topUVMode: R,
        sideUVMode: E,
        sideVerticalUVMode: D,
        textureYOrigin: N,
        tileRatio: a,
        centimeterToPoint: l,
        verticalCentimeterToPoint: h,
        positionType: p,
        res: s,
        glScale: o,
        projectionCode: f
    }, d, $435bc7696844e930$var$Ha), B = [], j = U.vertices.getLength() / 3, W = $435bc7696844e930$var$Da.getIndexArrayType(j), X = $435bc7696844e930$var$La.createTypedArray(U.indices, W);
    delete U.indices, B.push(X.buffer, U.pickingIds.buffer);
    const Y = Math.max(Math.abs(U.maxAltitude), Math.abs(U.minAltitude)), q = p || $435bc7696844e930$var$Da.getPosArrayType(Math.max(512, Y));
    U.vertices = $435bc7696844e930$var$La.createTypedArray(U.vertices, q);
    const $ = w ? $435bc7696844e930$var$Ha.getProxy() : new Float32Array(3 * j);
    $.setLength && $.setLength(3 * j);
    const J = (0, $1YyR8.buildNormals)(U.vertices, X, $);
    let K = !0;
    const Q = J.getLength ? J.getLength() : J.length;
    for(let e = 0; e < Q; e++){
        V || (J[e] = -J[e]);
        const t = J[e] % 1;
        1 - Math.abs(t) > 1e-6 ? K = !1 : 0 !== t && (J[e] = Math.round(J[e]));
    }
    if (U.normals = J, w) {
        let e = $435bc7696844e930$var$Ha.get();
        e.setLength(4 * j), e = (0, $1YyR8.buildTangents)(U.vertices, U.normals, U.uvs, X, e), e = function(e, t) {
            const n = t.getLength(), i = new Float32Array(n), r = [], s = [], o = [];
            for(let a = 0; a < n; a += 4){
                const n = a / 4 * 3;
                (0, $eIStk).set(s, e[n] || 0, e[n + 1] || 0, e[n + 2] || 0), (0, $jxhwV).set(r, t[a] || 0, t[a + 1] || 0, t[a + 2] || 0, t[a + 3] || 0), (0, $1YyR8.packTangentFrame)(o, s, r), (0, $jxhwV).copy(i.subarray(a, a + 4), o);
            }
            return i;
        }(U.normals, e), U.tangents = e, B.push(e.buffer), delete U.normals;
    }
    if (U.normals && (K && (U.normals = $435bc7696844e930$var$La.createTypedArray(U.normals, Int8Array)), B.push(U.normals.buffer)), U.uvs) {
        const e = U.uvs;
        U.uvs = $435bc7696844e930$var$La.createTypedArray(e, Float32Array), B.push(U.uvs.buffer);
    }
    if (g) {
        const e = U.vertices, t = e.length;
        for(let n = 0; n < t; n += 3)e[n] -= g[0], e[n + 1] -= g[1];
    }
    const ee = function(e, t, n, i) {
        const r = {}, s = {}, o = i.getLength();
        if ($435bc7696844e930$var$Z(t.polygonFill)) {
            let a = (0, $14507960c5dac0fb$export$79e978600dd1e509)(t.polygonFill);
            const l = new Uint8Array(4 * o);
            l.fill(255);
            for(let t = 0; t < o; t++){
                const s = e[i[t]], o = s.properties || {};
                o.$layer = s.layer, o.$type = s.type;
                let h = a(n, o);
                (0, $14507960c5dac0fb$export$ec423ecbfcdb9a06)(h) && (r.aColor = 1, a = (0, $14507960c5dac0fb$export$79e978600dd1e509)(h), h = a(n, o)), delete o.$layer, delete o.$type, $435bc7696844e930$var$Ea.normalizeColor($435bc7696844e930$var$za, h), l[4 * t] = $435bc7696844e930$var$za[0], l[4 * t + 1] = $435bc7696844e930$var$za[1], l[4 * t + 2] = $435bc7696844e930$var$za[2], l[4 * t + 3] = $435bc7696844e930$var$za[3];
            }
            s.aColor = l;
        }
        if ($435bc7696844e930$var$Z(t.polygonOpacity)) {
            let a = (0, $14507960c5dac0fb$export$b5e0f6446c9b8e3c)(t.polygonOpacity);
            const l = new Uint8Array(o);
            l.fill(255);
            for(let t = 0; t < o; t++){
                const s = e[i[t]], o = s.properties || {};
                o.$layer = s.layer, o.$type = s.type;
                let h = a(n, o);
                (0, $14507960c5dac0fb$export$ec423ecbfcdb9a06)(h) && (r.aOpacity = 1, a = (0, $14507960c5dac0fb$export$79e978600dd1e509)(h), h = a(n, o)), delete o.$layer, delete o.$type, l[t] = 255 * h;
            }
            s.aOpacity = l;
        }
        return s.dynamicAttributes = r, s;
    }(e, c, u, U.featureIndexes), te = function(e, t, n, i, r) {
        const s = [
            [],
            []
        ], o = $435bc7696844e930$var$Z(i.topPolygonFill), a = $435bc7696844e930$var$Z(i.bottomPolygonFill), l = [
            255,
            255,
            255,
            255
        ], h = t.getLength();
        if (o || a) {
            let c = o && (0, $14507960c5dac0fb$export$79e978600dd1e509)(i.topPolygonFill), u = a && (0, $14507960c5dac0fb$export$79e978600dd1e509)(i.bottomPolygonFill), f = null, d = null, p = null, g = null;
            for(let i = 0; i < h; i++){
                if (1 === e[i] && !o || 0 === e[i] && !a) continue;
                const h = 1 === e[i];
                if (h && t[i] === f) {
                    e[i] = p;
                    continue;
                }
                if (!h && t[i] === d) {
                    e[i] = g;
                    continue;
                }
                const m = n[t[i]], y = m.properties || {};
                y.$layer = m.layer, y.$type = m.type;
                let x = h ? c : u, v = x(r, y);
                (0, $14507960c5dac0fb$export$ec423ecbfcdb9a06)(v) && (x = (0, $14507960c5dac0fb$export$79e978600dd1e509)(v), v = x(r, y)), delete y.$layer, delete y.$type, $435bc7696844e930$var$Ea.normalizeColor($435bc7696844e930$var$za, v), (0, $jxhwV).divide($435bc7696844e930$var$za, $435bc7696844e930$var$za, l);
                let A = $435bc7696844e930$var$Va(s, $435bc7696844e930$var$za);
                A < 0 && (A = s.length, s.push((0, $jxhwV).copy([], $435bc7696844e930$var$za))), e[i] = A, h ? (f = t[i], p = A) : (d = t[i], g = A);
            }
        }
        return s.slice(2);
    }(U.verticeTypes, U.featureIndexes, e, c, u), ne = {
        data: {
            data: {
                aVertexColorType: te.length <= 252 ? $435bc7696844e930$var$La.createTypedArray(U.verticeTypes, Uint8Array) : $435bc7696844e930$var$La.createTypedArray(U.verticeTypes, Uint16Array),
                aPosition: U.vertices,
                aNormal: U.normals,
                aTexCoord0: U.uvs,
                aTangent: U.tangents,
                aPickingId: U.pickingIds
            },
            indices: X,
            properties: {
                maxAltitude: U.maxAltitude / 100,
                minAltitude: U.minAltitude / 100,
                hasNegativeHeight: U.hasNegativeHeight
            },
            dynamicAttributes: ee.dynamicAttributes,
            vertexColors: te
        },
        buffers: B
    };
    return U.featureIds.length ? (ne.data.featureIds = U.featureIds, B.push(ne.data.featureIds.buffer)) : ne.data.featureIds = [], ee.aColor && (ne.data.data.aColor = ee.aColor, ne.buffers.push(ee.aColor.buffer)), ee.aOpacity && (ne.data.data.aOpacity = ee.aOpacity, ne.buffers.push(ee.aOpacity.buffer)), ne.buffers.push(ne.data.data.aPosition.buffer), ne.data.pickingIdIndiceMap = $435bc7696844e930$var$Da.generatePickingIndiceIndex(ne.data.data.aPickingId, ne.data.indices), ne;
}
const $435bc7696844e930$var$za = [];
function $435bc7696844e930$var$Va(e, t) {
    for(let n = 0; n < e.length; n++)if ((0, $jxhwV).exactEquals(t, e[n])) return n;
    return -1;
}
$435bc7696844e930$var$H();
class $435bc7696844e930$var$Ua {
    constructor(e = [], t = $435bc7696844e930$var$Ba){
        if (this.data = e, this.length = this.data.length, this.compare = t, this.length > 0) for(let e = (this.length >> 1) - 1; e >= 0; e--)this._down(e);
    }
    push(e) {
        this.data.push(e), this.length++, this._up(this.length - 1);
    }
    pop() {
        if (0 === this.length) return;
        const e = this.data[0], t = this.data.pop();
        return this.length--, this.length > 0 && (this.data[0] = t, this._down(0)), e;
    }
    peek() {
        return this.data[0];
    }
    _up(e) {
        const { data: t, compare: n } = this, i = t[e];
        for(; e > 0;){
            const r = e - 1 >> 1, s = t[r];
            if (n(i, s) >= 0) break;
            t[e] = s, e = r;
        }
        t[e] = i;
    }
    _down(e) {
        const { data: t, compare: n } = this, i = this.length >> 1, r = t[e];
        for(; e < i;){
            let i = 1 + (e << 1), s = t[i];
            const o = i + 1;
            if (o < this.length && n(t[o], s) < 0 && (i = o, s = t[o]), n(s, r) >= 0) break;
            t[e] = s, e = i;
        }
        t[e] = r;
    }
}
function $435bc7696844e930$var$Ba(e, t) {
    return e < t ? -1 : e > t ? 1 : 0;
}
var $435bc7696844e930$var$Ga = {
    exports: {}
}, $435bc7696844e930$var$ja = function(e, t, n, i) {
    var r = e[0], s = e[1], o = !1;
    void 0 === n && (n = 0), void 0 === i && (i = t.length);
    for(var a = (i - n) / 2, l = 0, h = a - 1; l < a; h = l++){
        var c = t[n + 2 * l + 0], u = t[n + 2 * l + 1], f = t[n + 2 * h + 0], d = t[n + 2 * h + 1];
        u > s != d > s && r < (f - c) * (s - u) / (d - u) + c && (o = !o);
    }
    return o;
}, $435bc7696844e930$var$Wa = function(e, t, n, i) {
    var r = e[0], s = e[1], o = !1;
    void 0 === n && (n = 0), void 0 === i && (i = t.length);
    for(var a = i - n, l = 0, h = a - 1; l < a; h = l++){
        var c = t[l + n][0], u = t[l + n][1], f = t[h + n][0], d = t[h + n][1];
        u > s != d > s && r < (f - c) * (s - u) / (d - u) + c && (o = !o);
    }
    return o;
};
$435bc7696844e930$var$Ga.exports = function(e, t, n, i) {
    return t.length > 0 && Array.isArray(t[0]) ? $435bc7696844e930$var$Wa(e, t, n, i) : $435bc7696844e930$var$ja(e, t, n, i);
};
var $435bc7696844e930$var$Xa = $435bc7696844e930$var$Ga.exports.nested = $435bc7696844e930$var$Wa;
$435bc7696844e930$var$Ga.exports.flat = $435bc7696844e930$var$ja;
const $435bc7696844e930$var$Ya = 11102230246251565e-32, $435bc7696844e930$var$Za = 134217729, $435bc7696844e930$var$qa = (3 + 8 * $435bc7696844e930$var$Ya) * $435bc7696844e930$var$Ya;
function $435bc7696844e930$var$$a(e, t, n, i, r) {
    let s, o, a, l, h = t[0], c = i[0], u = 0, f = 0;
    c > h == c > -h ? (s = h, h = t[++u]) : (s = c, c = i[++f]);
    let d = 0;
    if (u < e && f < n) for(c > h == c > -h ? (o = h + s, a = s - (o - h), h = t[++u]) : (o = c + s, a = s - (o - c), c = i[++f]), s = o, 0 !== a && (r[d++] = a); u < e && f < n;)c > h == c > -h ? (o = s + h, l = o - s, a = s - (o - l) + (h - l), h = t[++u]) : (o = s + c, l = o - s, a = s - (o - l) + (c - l), c = i[++f]), s = o, 0 !== a && (r[d++] = a);
    for(; u < e;)o = s + h, l = o - s, a = s - (o - l) + (h - l), h = t[++u], s = o, 0 !== a && (r[d++] = a);
    for(; f < n;)o = s + c, l = o - s, a = s - (o - l) + (c - l), c = i[++f], s = o, 0 !== a && (r[d++] = a);
    return 0 === s && 0 !== d || (r[d++] = s), d;
}
function $435bc7696844e930$var$Ja(e) {
    return new Float64Array(e);
}
const $435bc7696844e930$var$Ka = 33306690738754716e-32, $435bc7696844e930$var$Qa = 22204460492503146e-32, $435bc7696844e930$var$el = 11093356479670487e-47, $435bc7696844e930$var$tl = $435bc7696844e930$var$Ja(4), $435bc7696844e930$var$nl = $435bc7696844e930$var$Ja(8), $435bc7696844e930$var$il = $435bc7696844e930$var$Ja(12), $435bc7696844e930$var$rl = $435bc7696844e930$var$Ja(16), $435bc7696844e930$var$sl = $435bc7696844e930$var$Ja(4);
function $435bc7696844e930$var$ol(e, t, n, i, r, s) {
    const o = (t - s) * (n - r), a = (e - r) * (i - s), l = o - a;
    if (0 === o || 0 === a || o > 0 != a > 0) return l;
    const h = Math.abs(o + a);
    return Math.abs(l) >= $435bc7696844e930$var$Ka * h ? l : -function(e, t, n, i, r, s, o) {
        let a, l, h, c, u, f, d, p, g, m, y, x, _, v, b, A, T, S;
        const w = e - r, M = n - r, P = t - s, I = i - s;
        v = w * I, f = $435bc7696844e930$var$Za * w, d = f - (f - w), p = w - d, f = $435bc7696844e930$var$Za * I, g = f - (f - I), m = I - g, b = p * m - (v - d * g - p * g - d * m), A = P * M, f = $435bc7696844e930$var$Za * P, d = f - (f - P), p = P - d, f = $435bc7696844e930$var$Za * M, g = f - (f - M), m = M - g, T = p * m - (A - d * g - p * g - d * m), y = b - T, u = b - y, $435bc7696844e930$var$tl[0] = b - (y + u) + (u - T), x = v + y, u = x - v, _ = v - (x - u) + (y - u), y = _ - A, u = _ - y, $435bc7696844e930$var$tl[1] = _ - (y + u) + (u - A), S = x + y, u = S - x, $435bc7696844e930$var$tl[2] = x - (S - u) + (y - u), $435bc7696844e930$var$tl[3] = S;
        let C = function(e, t) {
            let n = t[0];
            for(let i = 1; i < e; i++)n += t[i];
            return n;
        }(4, $435bc7696844e930$var$tl), k = $435bc7696844e930$var$Qa * o;
        if (C >= k || -C >= k) return C;
        if (u = e - w, a = e - (w + u) + (u - r), u = n - M, h = n - (M + u) + (u - r), u = t - P, l = t - (P + u) + (u - s), u = i - I, c = i - (I + u) + (u - s), 0 === a && 0 === l && 0 === h && 0 === c) return C;
        if (k = $435bc7696844e930$var$el * o + $435bc7696844e930$var$qa * Math.abs(C), C += w * c + I * a - (P * h + M * l), C >= k || -C >= k) return C;
        v = a * I, f = $435bc7696844e930$var$Za * a, d = f - (f - a), p = a - d, f = $435bc7696844e930$var$Za * I, g = f - (f - I), m = I - g, b = p * m - (v - d * g - p * g - d * m), A = l * M, f = $435bc7696844e930$var$Za * l, d = f - (f - l), p = l - d, f = $435bc7696844e930$var$Za * M, g = f - (f - M), m = M - g, T = p * m - (A - d * g - p * g - d * m), y = b - T, u = b - y, $435bc7696844e930$var$sl[0] = b - (y + u) + (u - T), x = v + y, u = x - v, _ = v - (x - u) + (y - u), y = _ - A, u = _ - y, $435bc7696844e930$var$sl[1] = _ - (y + u) + (u - A), S = x + y, u = S - x, $435bc7696844e930$var$sl[2] = x - (S - u) + (y - u), $435bc7696844e930$var$sl[3] = S;
        const F = $435bc7696844e930$var$$a(4, $435bc7696844e930$var$tl, 4, $435bc7696844e930$var$sl, $435bc7696844e930$var$nl);
        v = w * c, f = $435bc7696844e930$var$Za * w, d = f - (f - w), p = w - d, f = $435bc7696844e930$var$Za * c, g = f - (f - c), m = c - g, b = p * m - (v - d * g - p * g - d * m), A = P * h, f = $435bc7696844e930$var$Za * P, d = f - (f - P), p = P - d, f = $435bc7696844e930$var$Za * h, g = f - (f - h), m = h - g, T = p * m - (A - d * g - p * g - d * m), y = b - T, u = b - y, $435bc7696844e930$var$sl[0] = b - (y + u) + (u - T), x = v + y, u = x - v, _ = v - (x - u) + (y - u), y = _ - A, u = _ - y, $435bc7696844e930$var$sl[1] = _ - (y + u) + (u - A), S = x + y, u = S - x, $435bc7696844e930$var$sl[2] = x - (S - u) + (y - u), $435bc7696844e930$var$sl[3] = S;
        const O = $435bc7696844e930$var$$a(F, $435bc7696844e930$var$nl, 4, $435bc7696844e930$var$sl, $435bc7696844e930$var$il);
        v = a * c, f = $435bc7696844e930$var$Za * a, d = f - (f - a), p = a - d, f = $435bc7696844e930$var$Za * c, g = f - (f - c), m = c - g, b = p * m - (v - d * g - p * g - d * m), A = l * h, f = $435bc7696844e930$var$Za * l, d = f - (f - l), p = l - d, f = $435bc7696844e930$var$Za * h, g = f - (f - h), m = h - g, T = p * m - (A - d * g - p * g - d * m), y = b - T, u = b - y, $435bc7696844e930$var$sl[0] = b - (y + u) + (u - T), x = v + y, u = x - v, _ = v - (x - u) + (y - u), y = _ - A, u = _ - y, $435bc7696844e930$var$sl[1] = _ - (y + u) + (u - A), S = x + y, u = S - x, $435bc7696844e930$var$sl[2] = x - (S - u) + (y - u), $435bc7696844e930$var$sl[3] = S;
        const R = $435bc7696844e930$var$$a(O, $435bc7696844e930$var$il, 4, $435bc7696844e930$var$sl, $435bc7696844e930$var$rl);
        return $435bc7696844e930$var$rl[R - 1];
    }(e, t, n, i, r, s, h);
}
function $435bc7696844e930$var$al(e, t, n) {
    t = Math.max(0, void 0 === t ? 2 : t), n = n || 0;
    var i = function(e) {
        for(var t = e[0], n = e[0], i = e[0], r = e[0], s = 0; s < e.length; s++){
            var o = e[s];
            o[0] < t[0] && (t = o), o[0] > i[0] && (i = o), o[1] < n[1] && (n = o), o[1] > r[1] && (r = o);
        }
        var a = [
            t,
            n,
            i,
            r
        ], l = a.slice();
        for(s = 0; s < e.length; s++)$435bc7696844e930$var$Xa(e[s], a) || l.push(e[s]);
        return function(e) {
            e.sort($435bc7696844e930$var$_l);
            for(var t = [], n = 0; n < e.length; n++){
                for(; t.length >= 2 && $435bc7696844e930$var$dl(t[t.length - 2], t[t.length - 1], e[n]) <= 0;)t.pop();
                t.push(e[n]);
            }
            for(var i = [], r = e.length - 1; r >= 0; r--){
                for(; i.length >= 2 && $435bc7696844e930$var$dl(i[i.length - 2], i[i.length - 1], e[r]) <= 0;)i.pop();
                i.push(e[r]);
            }
            return i.pop(), t.pop(), t.concat(i);
        }(l);
    }(e), r = new (0, (/*@__PURE__*/$parcel$interopDefault($176ca75ee9f69668$exports)))(16);
    r.toBBox = function(e) {
        return {
            minX: e[0],
            minY: e[1],
            maxX: e[0],
            maxY: e[1]
        };
    }, r.compareMinX = function(e, t) {
        return e[0] - t[0];
    }, r.compareMinY = function(e, t) {
        return e[1] - t[1];
    }, r.load(e);
    for(var s, o = [], a = 0; a < i.length; a++){
        var l = i[a];
        r.remove(l), s = $435bc7696844e930$var$gl(l, s), o.push(s);
    }
    var h = new (0, (/*@__PURE__*/$parcel$interopDefault($176ca75ee9f69668$exports)))(16);
    for(a = 0; a < o.length; a++)h.insert($435bc7696844e930$var$pl(o[a]));
    for(var c = t * t, u = n * n; o.length;){
        var f = o.shift(), d = f.p, p = f.next.p, g = $435bc7696844e930$var$ml(d, p);
        if (!(g < u)) {
            var m = g / c;
            (l = $435bc7696844e930$var$ll(r, f.prev.p, d, p, f.next.next.p, m, h)) && Math.min($435bc7696844e930$var$ml(l, d), $435bc7696844e930$var$ml(l, p)) <= m && (o.push(f), o.push($435bc7696844e930$var$gl(l, f)), r.remove(l), h.remove(f), h.insert($435bc7696844e930$var$pl(f)), h.insert($435bc7696844e930$var$pl(f.next)));
        }
    }
    f = s;
    var y = [];
    do y.push(f.p), f = f.next;
    while (f !== s);
    return y.push(f.p), y;
}
function $435bc7696844e930$var$ll(e, t, n, i, r, s, o) {
    for(var a = new $435bc7696844e930$var$Ua([], $435bc7696844e930$var$hl), l = e.data; l;){
        for(var h = 0; h < l.children.length; h++){
            var c = l.children[h], u = l.leaf ? $435bc7696844e930$var$yl(c, n, i) : $435bc7696844e930$var$cl(n, i, c);
            u > s || a.push({
                node: c,
                dist: u
            });
        }
        for(; a.length && !a.peek().node.children;){
            var f = a.pop(), d = f.node, p = $435bc7696844e930$var$yl(d, t, n), g = $435bc7696844e930$var$yl(d, i, r);
            if (f.dist < p && f.dist < g && $435bc7696844e930$var$fl(n, d, o) && $435bc7696844e930$var$fl(i, d, o)) return d;
        }
        (l = a.pop()) && (l = l.node);
    }
    return null;
}
function $435bc7696844e930$var$hl(e, t) {
    return e.dist - t.dist;
}
function $435bc7696844e930$var$cl(e, t, n) {
    if ($435bc7696844e930$var$ul(e, n) || $435bc7696844e930$var$ul(t, n)) return 0;
    var i = $435bc7696844e930$var$xl(e[0], e[1], t[0], t[1], n.minX, n.minY, n.maxX, n.minY);
    if (0 === i) return 0;
    var r = $435bc7696844e930$var$xl(e[0], e[1], t[0], t[1], n.minX, n.minY, n.minX, n.maxY);
    if (0 === r) return 0;
    var s = $435bc7696844e930$var$xl(e[0], e[1], t[0], t[1], n.maxX, n.minY, n.maxX, n.maxY);
    if (0 === s) return 0;
    var o = $435bc7696844e930$var$xl(e[0], e[1], t[0], t[1], n.minX, n.maxY, n.maxX, n.maxY);
    return 0 === o ? 0 : Math.min(i, r, s, o);
}
function $435bc7696844e930$var$ul(e, t) {
    return e[0] >= t.minX && e[0] <= t.maxX && e[1] >= t.minY && e[1] <= t.maxY;
}
function $435bc7696844e930$var$fl(e, t, n) {
    for(var i, r, s, o, a = Math.min(e[0], t[0]), l = Math.min(e[1], t[1]), h = Math.max(e[0], t[0]), c = Math.max(e[1], t[1]), u = n.search({
        minX: a,
        minY: l,
        maxX: h,
        maxY: c
    }), f = 0; f < u.length; f++)if (i = u[f].p, r = u[f].next.p, s = e, i !== (o = t) && r !== s && $435bc7696844e930$var$dl(i, r, s) > 0 != $435bc7696844e930$var$dl(i, r, o) > 0 && $435bc7696844e930$var$dl(s, o, i) > 0 != $435bc7696844e930$var$dl(s, o, r) > 0) return !1;
    return !0;
}
function $435bc7696844e930$var$dl(e, t, n) {
    return $435bc7696844e930$var$ol(e[0], e[1], t[0], t[1], n[0], n[1]);
}
function $435bc7696844e930$var$pl(e) {
    var t = e.p, n = e.next.p;
    return e.minX = Math.min(t[0], n[0]), e.minY = Math.min(t[1], n[1]), e.maxX = Math.max(t[0], n[0]), e.maxY = Math.max(t[1], n[1]), e;
}
function $435bc7696844e930$var$gl(e, t) {
    var n = {
        p: e,
        prev: null,
        next: null,
        minX: 0,
        minY: 0,
        maxX: 0,
        maxY: 0
    };
    return t ? (n.next = t.next, n.prev = t, t.next.prev = n, t.next = n) : (n.prev = n, n.next = n), n;
}
function $435bc7696844e930$var$ml(e, t) {
    var n = e[0] - t[0], i = e[1] - t[1];
    return n * n + i * i;
}
function $435bc7696844e930$var$yl(e, t, n) {
    var i = t[0], r = t[1], s = n[0] - i, o = n[1] - r;
    if (0 !== s || 0 !== o) {
        var a = ((e[0] - i) * s + (e[1] - r) * o) / (s * s + o * o);
        a > 1 ? (i = n[0], r = n[1]) : a > 0 && (i += s * a, r += o * a);
    }
    return (s = e[0] - i) * s + (o = e[1] - r) * o;
}
function $435bc7696844e930$var$xl(e, t, n, i, r, s, o, a) {
    var l, h, c, u, f = n - e, d = i - t, p = o - r, g = a - s, m = e - r, y = t - s, x = f * f + d * d, _ = f * p + d * g, v = p * p + g * g, b = f * m + d * y, A = p * m + g * y, T = x * v - _ * _, S = T, w = T;
    0 === T ? (h = 0, S = 1, u = A, w = v) : (u = x * A - _ * b, (h = _ * A - v * b) < 0 ? (h = 0, u = A, w = v) : h > S && (h = S, u = A + _, w = v)), u < 0 ? (u = 0, -b < 0 ? h = 0 : -b > x ? h = S : (h = -b, S = x)) : u > w && (u = w, -b + _ < 0 ? h = 0 : -b + _ > x ? h = S : (h = -b + _, S = x));
    var M = (1 - (c = 0 === u ? 0 : u / w)) * r + c * o - ((1 - (l = 0 === h ? 0 : h / S)) * e + l * n), P = (1 - c) * s + c * a - ((1 - l) * t + l * i);
    return M * M + P * P;
}
function $435bc7696844e930$var$_l(e, t) {
    return e[0] === t[0] ? e[1] - t[1] : e[0] - t[0];
}
const { PackUtil: $435bc7696844e930$var$vl } = $435bc7696844e930$var$H();
class $435bc7696844e930$var$bl {
    constructor(e, t){
        this.x = e, this.y = t;
    }
    clone() {
        return new $435bc7696844e930$var$bl(this.x, this.y);
    }
    normalize() {
        const e = this.length();
        this.x /= e, this.y /= e;
    }
    negate() {
        this.x = -this.x, this.y = -this.y;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    }
    diff(e) {
        return new $435bc7696844e930$var$bl(this.x - e.x, this.y - e.y);
    }
    distance(e) {
        const t = this.x - e.x, n = this.y - e.y;
        return Math.sqrt(t * t + n * n);
    }
    dot(e) {
        return this.x * e.x + this.y * e.y;
    }
    equals(e) {
        return this.x === e.x && this.y === e.y;
    }
    orthogonal() {
        return new $435bc7696844e930$var$bl(this.y, -this.x);
    }
}
function $435bc7696844e930$var$Al(e, t, n, i) {
    const r = t.x * i.y - t.y * i.x, s = n.x - e.x, o = n.y - e.y, a = (s * i.y - o * i.x) / r;
    return new $435bc7696844e930$var$bl(e.x + a * t.x, e.y + a * t.y);
}
const $435bc7696844e930$var$Tl = [], $435bc7696844e930$var$Sl = [];
function $435bc7696844e930$var$wl(e) {
    if ($435bc7696844e930$var$G(e[0] && e[0].x)) {
        const t = [];
        let n = 0;
        for(let i = 0; i < e.length; i++)$435bc7696844e930$var$Sl[n] ? ($435bc7696844e930$var$Sl[n][0] = e[i].x, $435bc7696844e930$var$Sl[n][1] = e[i].y) : $435bc7696844e930$var$Sl[n] = [
            e[i].x,
            e[i].y
        ], t.push($435bc7696844e930$var$Sl[n]), n++;
        e = t;
    }
    try {
        const t = $435bc7696844e930$var$al(e, 1 / 0);
        let n = [
            1 / 0,
            1 / 0
        ], i = [
            -1 / 0,
            -1 / 0
        ];
        for(let e = 0; e < t.length; e++)t[e][0] < n[0] && (n[0] = t[e][0]), t[e][0] > i[0] && (i[0] = t[e][0]), t[e][1] < n[1] && (n[1] = t[e][1]), t[e][1] > i[1] && (i[1] = t[e][1]);
        const r = [];
        let s = [], o = 0;
        for(let e = 0; e < t.length; e++)e === t.length - 1 && t[e][0] === t[0][0] && t[e][1] === t[0][1] || ($435bc7696844e930$var$wa(r, t[e]), $435bc7696844e930$var$Tl[o] ? ($435bc7696844e930$var$Tl[o].x = r[0], $435bc7696844e930$var$Tl[o].y = r[1]) : $435bc7696844e930$var$Tl[o] = new $435bc7696844e930$var$bl(r[0], r[1]), s.push($435bc7696844e930$var$Tl[o]), o++);
        $435bc7696844e930$var$vl.calculateSignedArea(s) < 0 && (s = s.reverse());
        const a = function(e) {
            let t, n = Number.MAX_VALUE;
            const i = function(e, i, r, s, o, a, l, h) {
                var c = $435bc7696844e930$var$Al(e, i, o, a), u = $435bc7696844e930$var$Al(r, s, o, a), f = $435bc7696844e930$var$Al(l, h, e, i), d = $435bc7696844e930$var$Al(l, h, r, s), p = c.distance(u) * c.distance(f);
                0 !== p && p < n && (t = [
                    c,
                    f,
                    d,
                    u
                ], n = p);
            };
            var r = [];
            for(let t = 0; t < e.length; t++)r.push(e[(t + 1) % e.length].diff(e[t])), r[t].normalize();
            var s, o, a, l, h = new $435bc7696844e930$var$bl(Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY), c = new $435bc7696844e930$var$bl(Number.NEGATIVE_INFINITY, Number.NEGATIVE_INFINITY);
            for(let t = 0; t < e.length; t++){
                var u = e[t];
                u.x < h.x && (h.x = u.x, s = t), u.x > c.x && (c.x = u.x, o = t), u.y < h.y && (h.y = u.y, l = t), u.y > c.y && (c.y = u.y, a = t);
            }
            var f = new $435bc7696844e930$var$bl(0, -1), d = new $435bc7696844e930$var$bl(0, 1), p = new $435bc7696844e930$var$bl(-1, 0), g = new $435bc7696844e930$var$bl(1, 0);
            for(let t = 0; t < e.length; t++){
                var m = [
                    Math.acos(f.dot(r[s])),
                    Math.acos(d.dot(r[o])),
                    Math.acos(p.dot(r[a])),
                    Math.acos(g.dot(r[l]))
                ];
                switch(m.indexOf(Math.min.apply(Math, m))){
                    case 0:
                        (d = (f = r[s].clone()).clone()).negate(), (g = (p = f.orthogonal()).clone()).negate(), s = (s + 1) % e.length;
                        break;
                    case 1:
                        (f = (d = r[o].clone()).clone()).negate(), (g = (p = f.orthogonal()).clone()).negate(), o = (o + 1) % e.length;
                        break;
                    case 2:
                        (g = (p = r[a].clone()).clone()).negate(), (d = (f = g.orthogonal()).clone()).negate(), a = (a + 1) % e.length;
                        break;
                    case 3:
                        (p = (g = r[l].clone()).clone()).negate(), (d = (f = g.orthogonal()).clone()).negate(), l = (l + 1) % e.length;
                }
                i(e[s], f, e[o], d, e[a], p, e[l], g);
            }
            return t;
        }(s);
        if (!a || 4 !== a.length) return null;
        const l = a[0].distance(a[1]), h = a[1].distance(a[2]), c = a.map((e)=>[
                e.x,
                e.y
            ]);
        return c.push(+(h > l)), c;
    } catch (e) {
        return null;
    }
}
const { DEFAULT_TEX_WIDTH: $435bc7696844e930$var$Ml } = $435bc7696844e930$var$H();
class $435bc7696844e930$export$cd8a11917dcf40ea extends $435bc7696844e930$export$d39412b8ec89578a {
    static fromJSON(e) {
        return $435bc7696844e930$var$ua(e, "ExtrudePolygonLayer", $435bc7696844e930$export$cd8a11917dcf40ea);
    }
    getPolygonOffsetCount() {
        return 0;
    }
    getPolygonOffset() {
        return 0;
    }
    onConfig(e) {
        const t = this.getRenderer();
        return t && t.onConfig(e), super.onConfig(e);
    }
    updateMaterial(e) {
        this.options.material || (this.options.material = {}), e ? $435bc7696844e930$var$U(this.options.material, e) : this.options.material = null;
        const t = this.getRenderer();
        return t && t.updateMaterial(e), this;
    }
    updateSideMaterial(e) {
        let t = !1;
        this.options.sideMaterial || (this.options.sideMaterial = {}, t = !0), e ? $435bc7696844e930$var$U(this.options.sideMaterial, e) : this.options.sideMaterial = null;
        const n = this.getRenderer();
        return n && (t && n._deleteSideMaterial(), n.updateSideMaterial(e)), this;
    }
    updateDataConfig(e) {
        if (!e) return this;
        this.options.dataConfig || (this.options.dataConfig = {});
        const t = JSON.parse(JSON.stringify(this.options.dataConfig));
        $435bc7696844e930$var$U(this.options.dataConfig, e);
        const n = this.getRenderer();
        return n && n.updateDataConfig(e, t), this;
    }
}
$435bc7696844e930$export$cd8a11917dcf40ea.registerJSONType("ExtrudePolygonLayer"), $435bc7696844e930$export$cd8a11917dcf40ea.mergeOptions({
    cullFace: !1,
    castShadow: !0
});
const $435bc7696844e930$var$Il = {
    polygonFill: {
        type: "identity",
        default: [
            1,
            1,
            1,
            1
        ],
        property: "_symbol_polygonFill"
    },
    polygonOpacity: {
        type: "identity",
        default: 1,
        property: "_symbol_polygonOpacity"
    },
    topPolygonFill: {
        type: "identity",
        default: [
            1,
            1,
            1,
            1
        ],
        property: "_symbol_topPolygonFill"
    },
    bottomPolygonFill: {
        type: "identity",
        default: [
            1,
            1,
            1,
            1
        ],
        property: "_symbol_bottomPolygonFill"
    }
}, $435bc7696844e930$var$Cl = {
    defaultAltitude: 20
}, $435bc7696844e930$var$kl = (e)=>1 === e.properties.top;
$435bc7696844e930$export$cd8a11917dcf40ea.registerRenderer("gl", class extends $435bc7696844e930$var$_a {
    constructor(...t){
        super(...t), this.GeometryTypes = [
            $gP1US.Polygon,
            $gP1US.MultiPolygon
        ];
    }
    _groupPolygonFeatures(e) {
        return [
            e
        ];
    }
    onConfig(e) {
        this.painter && ($435bc7696844e930$var$X(e.cullFace) || this.painter.updateSceneConfig({
            cullFace: e.cullFace
        }));
    }
    updateMaterial(e) {
        this.painter && (this.painter._updateMaterial(e), this.layer.options.sideMaterial || this.sidePainter._updateMaterial(e), this.setToRedraw());
    }
    _deleteSideMaterial() {
        this.sidePainter && this.sidePainter.deleteMaterial();
    }
    updateSideMaterial(e) {
        this.sidePainter && (e ? this.sidePainter._updateMaterial(e) : (this.sidePainter.deleteMaterial(), this.sidePainter._updateMaterial(this.layer.options.material)), this.setToRedraw());
    }
    updateDataConfig(e, t) {
        this.painter && (this.painter.updateDataConfig(e, t), this._markRebuild());
    }
    updateBloom(e) {
        super.updateBloom(e), this.sidePainter && this._updatePainterBloom(this.sidePainter, this.sidePainterSymbol, e);
    }
    needCheckPointLineSymbols() {
        return !1;
    }
    draw(e, t) {
        return super.draw(e, t);
    }
    createPainter() {
        const e = $435bc7696844e930$export$d39412b8ec89578a.get3DPainterClass("lit");
        this.painterSymbol = $435bc7696844e930$var$U({}, $435bc7696844e930$var$Il), this.sidePainterSymbol = $435bc7696844e930$var$U({}, $435bc7696844e930$var$Il), this._defineSymbolBloom(this.painterSymbol, e.getBloomSymbol());
        const t = this.layer, n = $435bc7696844e930$var$U({}, $435bc7696844e930$var$Cl, t.options.dataConfig || {});
        t.options.material && (this.painterSymbol.material = t.options.material), t.options.sideMaterial ? this.sidePainterSymbol.material = t.options.sideMaterial : this.sidePainterSymbol.material = t.options.material;
        const i = {
            cullFace: t.options.cullFace
        };
        Object.defineProperty(i, "castShadow", {
            enumerable: !0,
            get: ()=>t.options.castShadow
        }), Object.defineProperty(i, "depthMask", {
            enumerable: !0,
            get: ()=>t.options.depthMask
        });
        const r = $435bc7696844e930$var$U({}, n);
        r.upsideUpTexture = !0;
        const s = new e(this.regl, t, this.painterSymbol, i, 0, r);
        return this.sidePainter = new e(this.regl, t, this.sidePainterSymbol, i, 0, n), s;
    }
    _startFrame(...e) {
        super._startFrame(...e);
        const t = this.painter;
        this.painter = this.sidePainter, super._startFrame(...e), this.painter = t;
    }
    _renderMeshes(...e) {
        const t = e[0], n = t.sceneFilter;
        t.sceneFilter = (e)=>(!n || n(e)) && $435bc7696844e930$var$kl(e);
        const i = super._renderMeshes(...e);
        t.sceneFilter = (e)=>(!n || n(e)) && $435bc7696844e930$var$kl(e);
        const r = this.painter;
        this.painter = this.sidePainter;
        const s = t.sceneFilter = (e)=>(!n || n(e)) && ((e)=>1 === e.properties.side)(e);
        return super._renderMeshes(...e), this.painter = r, t.sceneFilter = n, {
            redraw: i.redraw || s.redraw,
            drawCount: (i.drawCount || 0) + (s.drawCount || 0)
        };
    }
    createMesh(e, t, n, i, r, s) {
        const o = [];
        this._extrudeCenter = s;
        const a = this._createPackData(i, n, !0, !1), l = this._createPackData(i, n, !1, !0);
        if (a) {
            const r = this._createMesh(a, e, t, n, i, null, s);
            r.meshes[0].properties.top = 1, o.push(r);
        }
        if (l) {
            const r = this._createMesh(l, e, t, n, i, null, s);
            r.meshes[0].properties.side = 1, o.push(r);
        }
        return o;
    }
    _createPackData(t, n, i, r) {
        const s = this.getMap();
        n = $435bc7696844e930$var$Il;
        const o = this._extrudeCenter, a = 1 / 0, l = s.getZoom(), h = new $gP1US.Point(0, 0), c = new $gP1US.Coordinate(0, 0), u = $435bc7696844e930$var$U({}, $435bc7696844e930$var$Cl, this.layer.options.dataConfig);
        if (u.uv = !0, u.top && (u.top = i), u.side && (u.side = r), !1 === u.top && !1 === u.side) return null;
        if (!t.length) return null;
        const f = s.getGLRes(), d = s.getProjection().code, p = i ? this.painterSymbol && this.painterSymbol.material : this.sidePainterSymbol && this.sidePainterSymbol.material, g = p && p.textureWidth || $435bc7696844e930$var$Ml, m = [
            $435bc7696844e930$var$Ue(s, 1, c, f) / 100,
            $435bc7696844e930$var$Ue(s, 1, c, f, 1) / 100
        ];
        return $435bc7696844e930$var$Na(t, u, a, h, g, s.getGLRes(), 1, 1, m, this._zScale, n, l, d, undefined, Float32Array, o);
    }
    updateMesh(e) {
        const t = e[$435bc7696844e930$var$Vn];
        let n = this.features[t];
        if (!n || !this.meshes) return;
        const i = this._createPackData([
            n
        ], this.painterSymbol, !0, !1);
        let r = 0;
        i && i.data && this._updateMeshData(this.meshes[r++], n.id, i);
        const s = this._createPackData([
            n
        ], this.painterSymbol, !1, !0);
        s && s.data && this._updateMeshData(this.meshes[r++], n.id, s);
    }
    _convertGeo(t) {
        if (t.getProperties() || t.setProperties({}), !t.getProperties()[$435bc7696844e930$var$ye]) {
            const n = t.getCoordinates();
            if (t instanceof $gP1US.MultiPolygon) {
                const e = [];
                for(let t = 0; t < n.length; t++){
                    const i = n[t] && n[t][0];
                    e[t] = $435bc7696844e930$var$wl(i);
                }
                t.getProperties()[$435bc7696844e930$var$ye] = e;
            } else {
                const e = $435bc7696844e930$var$wl(n[0]);
                t.getProperties()[$435bc7696844e930$var$ye] = e;
            }
        }
        return super._convertGeo(t);
    }
    resizeCanvas(e) {
        super.resizeCanvas(e), this.sidePainter && this.sidePainter.resize(this.canvas.width, this.canvas.height);
    }
    onRemove() {
        super.onRemove(), this.sidePainter && (this.sidePainter.delete(), delete this.sidePainter);
    }
    drawOutline(e) {
        if (super.drawOutline(e), this._outlineAll && this.sidePainter && this.sidePainter.outlineAll(e), this._outlineFeatures) for(let t = 0; t < this._outlineFeatures.length; t++)this.sidePainter && this.sidePainter.outline(e, this._outlineFeatures[t]);
    }
    getShadowMeshes() {
        return this.painter ? this.painter.getShadowMeshes() : [];
    }
}), $435bc7696844e930$export$cd8a11917dcf40ea.registerRenderer("canvas", null);
const { PackUtil: $435bc7696844e930$export$638f486da79eff10, FilterUtil: $435bc7696844e930$export$c64c1e14f0a3e851, SYMBOLS_NEED_REBUILD_IN_VT: $435bc7696844e930$export$13f56d9d62b9341a, SYMBOLS_NEED_REBUILD_IN_VECTOR: $435bc7696844e930$export$c0117c5f52408e3c } = $435bc7696844e930$var$H();
(0, $2wazW).ShaderLib.register("vt_position_vert", "#ifdef HAS_TERRAIN_ALTITUDE\n    attribute float aTerrainAltitude;\n#endif\nuniform float minAltitude;\n#ifdef HAS_ALTITUDE\n    vec3 unpackVTPosition() {\n        float altitude = aAltitude;\n        #ifdef HAS_TERRAIN_ALTITUDE\n            altitude += aTerrainAltitude * 100.0;\n        #endif\n        altitude += minAltitude * 100.0;\n        return vec3(aPosition, altitude);\n    }\n#else\n    float position_modValue = 16384.0;\n    float position_delta = 0.00001;\n    vec3 unpackVTPosition() {\n        float z = aPosition.z;\n        vec2 pos = sign(aPosition.xy + position_delta) * mod(abs(aPosition.xy), position_modValue);\n        vec2 highs = floor(abs(aPosition.xy) / position_modValue);\n        float altitude = sign(z + position_delta) * (highs.x * 2.0 + highs.y) * pow(2.0, 15.0) + z;\n        #ifdef HAS_TERRAIN_ALTITUDE\n            altitude += aTerrainAltitude * 100.0;\n        #endif\n        altitude += minAltitude * 100.0;\n        return vec3(pos, altitude);\n    }\n#endif");
$3iqbd.create();
const $435bc7696844e930$var$Dl = function(e, t) {
    const n = e.toString(), i = n.indexOf("{") + 1, r = n.substring(0, i);
    let s = `${r}\n    (` + t.toString() + ")({});\n";
    return s += "\n" + n.substring(r.length), s;
}($435bc7696844e930$var$D, $435bc7696844e930$var$L);
if ($9e7Ip.transcoders) {
    const t = $gP1US.Map.VERSION;
    if (t.indexOf("1.0.0-beta") >= 0 || t.indexOf("1.0.0-alpha") >= 0) {
        const t = $9e7Ip.transcoders.inject($435bc7696844e930$var$Dl);
        $gP1US.registerWorkerAdapter("@maptalks/vt", t);
    } else $gP1US.registerWorkerAdapter("@maptalks/vt", function() {
        return $9e7Ip.transcoders.inject($435bc7696844e930$var$Dl);
    });
} else $gP1US.registerWorkerAdapter("@maptalks/vt", $435bc7696844e930$var$Dl);
"undefined" != typeof console && console.log("@maptalks/vt v0.106.2");


/*!
 * @maptalks/3dtiles v0.105.3
 * LICENSE : UNLICENSED
 * (c) 2016-2025 maptalks.org
 */ 
var $gP1US = parcelRequire("gP1US");

var $9e7Ip = parcelRequire("9e7Ip");
var $9I15V = parcelRequire("9I15V");
var $bDSmI = parcelRequire("bDSmI");
var $3iqbd = parcelRequire("3iqbd");
var $k1dpP = parcelRequire("k1dpP");
var $2wazW = parcelRequire("2wazW");
var $6BoVD = parcelRequire("6BoVD");
var $eIStk = parcelRequire("eIStk");
var $jxhwV = parcelRequire("jxhwV");
/*!
* Contains code from THREE.js
* MIT License
* https://github.com/mrdoob/three.js
*/ var $9b5be2c4f6c5fa19$var$planes = [];
for(var $9b5be2c4f6c5fa19$var$i = 0; $9b5be2c4f6c5fa19$var$i < 6; $9b5be2c4f6c5fa19$var$i++)$9b5be2c4f6c5fa19$var$planes[$9b5be2c4f6c5fa19$var$i] = [];
function $9b5be2c4f6c5fa19$export$aae45361196531d9(matrix, sphere, mask) {
    $9b5be2c4f6c5fa19$var$setPlanes(matrix);
    var center = sphere[0];
    var negRadius = -sphere[1];
    for(var i = 0; i < 6; i++){
        if (mask && mask.charAt(i) === '0') continue;
        var distance = $9b5be2c4f6c5fa19$var$distanceToPoint($9b5be2c4f6c5fa19$var$planes[i], center);
        if (distance < negRadius) return false;
    }
    return true;
}
var $9b5be2c4f6c5fa19$var$p = [];
function $9b5be2c4f6c5fa19$export$25ea4bdae27a952b(matrix, box, mask) {
    $9b5be2c4f6c5fa19$var$setPlanes(matrix);
    for(var i = 0; i < 6; i++){
        if (mask && mask.charAt(i) === '0') continue;
        var plane = $9b5be2c4f6c5fa19$var$planes[i];
        // corner at max distance
        $9b5be2c4f6c5fa19$var$p[0] = plane[0] > 0 ? box[1][0] : box[0][0];
        $9b5be2c4f6c5fa19$var$p[1] = plane[1] > 0 ? box[1][1] : box[0][1];
        $9b5be2c4f6c5fa19$var$p[2] = plane[2] > 0 ? box[1][2] : box[0][2];
        if ($9b5be2c4f6c5fa19$var$distanceToPoint(plane, $9b5be2c4f6c5fa19$var$p) < 0) return false;
    }
    return true;
}
function $9b5be2c4f6c5fa19$export$b727a1c83049f29(matrix, box, mask) {
    $9b5be2c4f6c5fa19$var$setPlanes(matrix);
    for(var i = 0; i < 6; i++){
        if (mask && mask.charAt(i) === '0') continue;
        var plane = $9b5be2c4f6c5fa19$var$planes[i];
        if (!$9b5be2c4f6c5fa19$var$intersectsPlane(plane, box)) return false;
    }
    return true;
}
var $9b5be2c4f6c5fa19$var$COLUMN0ROW0 = 3, $9b5be2c4f6c5fa19$var$COLUMN0ROW1 = 4, $9b5be2c4f6c5fa19$var$COLUMN0ROW2 = 5, $9b5be2c4f6c5fa19$var$COLUMN1ROW0 = 6, $9b5be2c4f6c5fa19$var$COLUMN1ROW1 = 7, $9b5be2c4f6c5fa19$var$COLUMN1ROW2 = 8, $9b5be2c4f6c5fa19$var$COLUMN2ROW0 = 9, $9b5be2c4f6c5fa19$var$COLUMN2ROW1 = 10, $9b5be2c4f6c5fa19$var$COLUMN2ROW2 = 11;
// const COLUMN0ROW0 = 0, COLUMN0ROW1 = 1, COLUMN0ROW2 = 2, COLUMN1ROW0 = 3, COLUMN1ROW1 = 4, COLUMN1ROW2 = 5, COLUMN2ROW0 = 6, COLUMN2ROW1 = 7, COLUMN2ROW2 = 8;
var $9b5be2c4f6c5fa19$var$BOX_CENTER = [];
var $9b5be2c4f6c5fa19$var$HALF_AXES = [];
function $9b5be2c4f6c5fa19$var$intersectsPlane(plane, box) {
    var center = box;
    var normal = plane;
    var halfAxes = box;
    var normalX = normal[0], normalY = normal[1], normalZ = normal[2];
    // plane is used as if it is its normal; the first three components are assumed to be normalized
    var radEffective = Math.abs(normalX * halfAxes[$9b5be2c4f6c5fa19$var$COLUMN0ROW0] + normalY * halfAxes[$9b5be2c4f6c5fa19$var$COLUMN0ROW1] + normalZ * halfAxes[$9b5be2c4f6c5fa19$var$COLUMN0ROW2]) + Math.abs(normalX * halfAxes[$9b5be2c4f6c5fa19$var$COLUMN1ROW0] + normalY * halfAxes[$9b5be2c4f6c5fa19$var$COLUMN1ROW1] + normalZ * halfAxes[$9b5be2c4f6c5fa19$var$COLUMN1ROW2]) + Math.abs(normalX * halfAxes[$9b5be2c4f6c5fa19$var$COLUMN2ROW0] + normalY * halfAxes[$9b5be2c4f6c5fa19$var$COLUMN2ROW1] + normalZ * halfAxes[$9b5be2c4f6c5fa19$var$COLUMN2ROW2]);
    var distanceToPlane = $9b5be2c4f6c5fa19$var$distanceToPoint(plane, center);
    if (distanceToPlane <= -radEffective) // The entire box is on the negative side of the plane normal
    // return Intersect.OUTSIDE;
    return false;
    else if (distanceToPlane >= radEffective) // The entire box is on the positive side of the plane normal
    // return Intersect.INSIDE;
    return true;
    return true;
// return Intersect.INTERSECTING;
}
function $9b5be2c4f6c5fa19$var$setPlanes(m) {
    var me = m;
    var me0 = me[0], me1 = me[1], me2 = me[2], me3 = me[3];
    var me4 = me[4], me5 = me[5], me6 = me[6], me7 = me[7];
    var me8 = me[8], me9 = me[9], me10 = me[10], me11 = me[11];
    var me12 = me[12], me13 = me[13], me14 = me[14], me15 = me[15];
    //right
    $9b5be2c4f6c5fa19$var$setComponents($9b5be2c4f6c5fa19$var$planes[0], me3 - me0, me7 - me4, me11 - me8, me15 - me12);
    //left
    $9b5be2c4f6c5fa19$var$setComponents($9b5be2c4f6c5fa19$var$planes[1], me3 + me0, me7 + me4, me11 + me8, me15 + me12);
    //bottom
    $9b5be2c4f6c5fa19$var$setComponents($9b5be2c4f6c5fa19$var$planes[2], me3 + me1, me7 + me5, me11 + me9, me15 + me13);
    //top
    $9b5be2c4f6c5fa19$var$setComponents($9b5be2c4f6c5fa19$var$planes[3], me3 - me1, me7 - me5, me11 - me9, me15 - me13);
    //z-far
    $9b5be2c4f6c5fa19$var$setComponents($9b5be2c4f6c5fa19$var$planes[4], me3 - me2, me7 - me6, me11 - me10, me15 - me14);
    //z-near
    $9b5be2c4f6c5fa19$var$setComponents($9b5be2c4f6c5fa19$var$planes[5], me3 + me2, me7 + me6, me11 + me10, me15 + me14);
}
function $9b5be2c4f6c5fa19$var$setComponents(out, x, y, z, w) {
    // THREE.js Plane.js
    var inverseNormalLength = 1 / Math.sqrt(x * x + y * y + z * z);
    out[0] = x * inverseNormalLength;
    out[1] = y * inverseNormalLength;
    out[2] = z * inverseNormalLength;
    out[3] = w * inverseNormalLength;
    return out;
}
function $9b5be2c4f6c5fa19$var$distanceToPoint(plane, p) {
    return plane[0] * p[0] + plane[1] * p[1] + plane[2] * p[2] + plane[3];
}



var $bDSmI = parcelRequire("bDSmI");
var $3iqbd = parcelRequire("3iqbd");
var $k1dpP = parcelRequire("k1dpP");
var $eIStk = parcelRequire("eIStk");
const $5671aa7ae64fb35e$var$_ = "${", $5671aa7ae64fb35e$var$M = `function(t){\n/*!\n     * @maptalks/gl v0.106.3\n     * LICENSE : UNLICENSED\n     * (c) 2016-2025 maptalks.com\n     */\nconst e=function(){if("undefined"!=typeof undefinedThis)return globalThis;if("undefined"!=typeof self)return self;if("undefined"!=typeof window)return window;if("undefined"!=typeof undefined)return global;throw new Error("unable to locate global object")},n=e(),r=n.gl_trans__coders=n.gl_trans__coders||{};function a(){return e().maptalks_gltf_loader}r.inject=function(t){const r=t.toString(),a=r.indexOf("{")+1,o=r.substring(0,a),i=n.gl_trans__coders=n.gl_trans__coders||{};let s=\`${$5671aa7ae64fb35e$var$_}o}\\n    const _____getGlobal = ${$5671aa7ae64fb35e$var$_}e.toString()};\\n    const g___lobals = _____getGlobal()\\n    const tran_____scoders = g___lobals['gl_trans__coders'] = g___lobals['gl_trans__coders'] || {};\`;for(const t in i)"inject"!==t&&"getTranscoder"!==t&&"registerTranscoder"!==t&&(s+='tran_____scoders["'+t+'"] ='+i[t].toString()+"\\n;");return s+="\\n("+e().maptalks_gltf_loader_bundle.toString()+")({});\\n",s+="\\n"+r.substring(o.length),s},r.registerTranscoder=function(t,e){r[t]=e},r.getTranscoder=function(t){return r[t]};var o="undefined"!=typeof Float32Array?Float32Array:Array;function i(t){return t[0]=1,t[1]=0,t[2]=0,t[3]=0,t[4]=0,t[5]=1,t[6]=0,t[7]=0,t[8]=0,t[9]=0,t[10]=1,t[11]=0,t[12]=0,t[13]=0,t[14]=0,t[15]=1,t}function s(t,e,n){var r=e[0],a=e[1],o=e[2],i=e[3],s=e[4],c=e[5],u=e[6],l=e[7],f=e[8],h=e[9],y=e[10],d=e[11],b=e[12],m=e[13],p=e[14],g=e[15],v=n[0],w=n[1],M=n[2],T=n[3];return t[0]=v*r+w*s+M*f+T*b,t[1]=v*a+w*c+M*h+T*m,t[2]=v*o+w*u+M*y+T*p,t[3]=v*i+w*l+M*d+T*g,v=n[4],w=n[5],M=n[6],T=n[7],t[4]=v*r+w*s+M*f+T*b,t[5]=v*a+w*c+M*h+T*m,t[6]=v*o+w*u+M*y+T*p,t[7]=v*i+w*l+M*d+T*g,v=n[8],w=n[9],M=n[10],T=n[11],t[8]=v*r+w*s+M*f+T*b,t[9]=v*a+w*c+M*h+T*m,t[10]=v*o+w*u+M*y+T*p,t[11]=v*i+w*l+M*d+T*g,v=n[12],w=n[13],M=n[14],T=n[15],t[12]=v*r+w*s+M*f+T*b,t[13]=v*a+w*c+M*h+T*m,t[14]=v*o+w*u+M*y+T*p,t[15]=v*i+w*l+M*d+T*g,t}function c(t,e){return t[0]===e[0]&&t[1]===e[1]&&t[2]===e[2]&&t[3]===e[3]&&t[4]===e[4]&&t[5]===e[5]&&t[6]===e[6]&&t[7]===e[7]&&t[8]===e[8]&&t[9]===e[9]&&t[10]===e[10]&&t[11]===e[11]&&t[12]===e[12]&&t[13]===e[13]&&t[14]===e[14]&&t[15]===e[15]}function u(){var t=new o(3);return o!=Float32Array&&(t[0]=0,t[1]=0,t[2]=0),t}function l(t){var e=t[0],n=t[1],r=t[2];return Math.hypot(e,n,r)}function f(t,e,n){var r=new o(3);return r[0]=t,r[1]=e,r[2]=n,r}function h(t,e){return t[0]=e[0],t[1]=e[1],t[2]=e[2],t}function y(t,e,n,r){return t[0]=e,t[1]=n,t[2]=r,t}function d(t,e,n){return t[0]=e[0]+n[0],t[1]=e[1]+n[1],t[2]=e[2]+n[2],t}function b(t,e){var n=e[0],r=e[1],a=e[2],o=n*n+r*r+a*a;return o>0&&(o=1/Math.sqrt(o)),t[0]=e[0]*o,t[1]=e[1]*o,t[2]=e[2]*o,t}function m(t,e){return t[0]*e[0]+t[1]*e[1]+t[2]*e[2]}function p(t,e,n){var r=e[0],a=e[1],o=e[2],i=n[3]*r+n[7]*a+n[11]*o+n[15];return i=i||1,t[0]=(n[0]*r+n[4]*a+n[8]*o+n[12])/i,t[1]=(n[1]*r+n[5]*a+n[9]*o+n[13])/i,t[2]=(n[2]*r+n[6]*a+n[10]*o+n[14])/i,t}Math.hypot||(Math.hypot=function(){for(var t=0,e=arguments.length;e--;)t+=arguments[e]*arguments[e];return Math.sqrt(t)});var g=function(t,e,n){return t[0]=e[0]-n[0],t[1]=e[1]-n[1],t[2]=e[2]-n[2],t},v=function(t,e,n){return t[0]=e[0]*n[0],t[1]=e[1]*n[1],t[2]=e[2]*n[2],t},w=l;function M(){var t=new o(4);return o!=Float32Array&&(t[0]=0,t[1]=0,t[2]=0),t[3]=1,t}u(),function(){var t,e=(t=new o(4),o!=Float32Array&&(t[0]=0,t[1]=0,t[2]=0,t[3]=0),t)}();var T;function A(t){return t&&t.t&&Object.prototype.hasOwnProperty.call(t,"default")?t.default:t}u(),f(1,0,0),f(0,1,0),M(),M(),T=new o(9),o!=Float32Array&&(T[1]=0,T[2]=0,T[3]=0,T[5]=0,T[6]=0,T[7]=0),T[0]=1,T[4]=1,T[8]=1;var k={exports:{}},_={exports:{}},O=function(t){return!(!t||"string"==typeof t)&&(t instanceof Array||Array.isArray(t)||t.length>=0&&(t.splice instanceof Function||Object.getOwnPropertyDescriptor(t,t.length-1)&&"String"!==t.constructor.name))},S=Array.prototype.concat,x=Array.prototype.slice,F=_.exports=function(t){for(var e=[],n=0,r=t.length;n<r;n++){var a=t[n];O(a)?e=S.call(e,x.call(a)):e.push(a)}return e};F.wrap=function(t){return function(){return t(F(arguments))}};var I=_.exports,C={"aliceblue":[240,248,255],"antiquewhite":[250,235,215],"aqua":[0,255,255],"aquamarine":[127,255,212],"azure":[240,255,255],"beige":[245,245,220],"bisque":[255,228,196],"black":[0,0,0],"blanchedalmond":[255,235,205],"blue":[0,0,255],"blueviolet":[138,43,226],"brown":[165,42,42],"burlywood":[222,184,135],"cadetblue":[95,158,160],"chartreuse":[127,255,0],"chocolate":[210,105,30],"coral":[255,127,80],"cornflowerblue":[100,149,237],"cornsilk":[255,248,220],"crimson":[220,20,60],"cyan":[0,255,255],"darkblue":[0,0,139],"darkcyan":[0,139,139],"darkgoldenrod":[184,134,11],"darkgray":[169,169,169],"darkgreen":[0,100,0],"darkgrey":[169,169,169],"darkkhaki":[189,183,107],"darkmagenta":[139,0,139],"darkolivegreen":[85,107,47],"darkorange":[255,140,0],"darkorchid":[153,50,204],"darkred":[139,0,0],"darksalmon":[233,150,122],"darkseagreen":[143,188,143],"darkslateblue":[72,61,139],"darkslategray":[47,79,79],"darkslategrey":[47,79,79],"darkturquoise":[0,206,209],"darkviolet":[148,0,211],"deeppink":[255,20,147],"deepskyblue":[0,191,255],"dimgray":[105,105,105],"dimgrey":[105,105,105],"dodgerblue":[30,144,255],"firebrick":[178,34,34],"floralwhite":[255,250,240],"forestgreen":[34,139,34],"fuchsia":[255,0,255],"gainsboro":[220,220,220],"ghostwhite":[248,248,255],"gold":[255,215,0],"goldenrod":[218,165,32],"gray":[128,128,128],"green":[0,128,0],"greenyellow":[173,255,47],"grey":[128,128,128],"honeydew":[240,255,240],"hotpink":[255,105,180],"indianred":[205,92,92],"indigo":[75,0,130],"ivory":[255,255,240],"khaki":[240,230,140],"lavender":[230,230,250],"lavenderblush":[255,240,245],"lawngreen":[124,252,0],"lemonchiffon":[255,250,205],"lightblue":[173,216,230],"lightcoral":[240,128,128],"lightcyan":[224,255,255],"lightgoldenrodyellow":[250,250,210],"lightgray":[211,211,211],"lightgreen":[144,238,144],"lightgrey":[211,211,211],"lightpink":[255,182,193],"lightsalmon":[255,160,122],"lightseagreen":[32,178,170],"lightskyblue":[135,206,250],"lightslategray":[119,136,153],"lightslategrey":[119,136,153],"lightsteelblue":[176,196,222],"lightyellow":[255,255,224],"lime":[0,255,0],"limegreen":[50,205,50],"linen":[250,240,230],"magenta":[255,0,255],"maroon":[128,0,0],"mediumaquamarine":[102,205,170],"mediumblue":[0,0,205],"mediumorchid":[186,85,211],"mediumpurple":[147,112,219],"mediumseagreen":[60,179,113],"mediumslateblue":[123,104,238],"mediumspringgreen":[0,250,154],"mediumturquoise":[72,209,204],"mediumvioletred":[199,21,133],"midnightblue":[25,25,112],"mintcream":[245,255,250],"mistyrose":[255,228,225],"moccasin":[255,228,181],"navajowhite":[255,222,173],"navy":[0,0,128],"oldlace":[253,245,230],"olive":[128,128,0],"olivedrab":[107,142,35],"orange":[255,165,0],"orangered":[255,69,0],"orchid":[218,112,214],"palegoldenrod":[238,232,170],"palegreen":[152,251,152],"paleturquoise":[175,238,238],"palevioletred":[219,112,147],"papayawhip":[255,239,213],"peachpuff":[255,218,185],"peru":[205,133,63],"pink":[255,192,203],"plum":[221,160,221],"powderblue":[176,224,230],"purple":[128,0,128],"rebeccapurple":[102,51,153],"red":[255,0,0],"rosybrown":[188,143,143],"royalblue":[65,105,225],"saddlebrown":[139,69,19],"salmon":[250,128,114],"sandybrown":[244,164,96],"seagreen":[46,139,87],"seashell":[255,245,238],"sienna":[160,82,45],"silver":[192,192,192],"skyblue":[135,206,235],"slateblue":[106,90,205],"slategray":[112,128,144],"slategrey":[112,128,144],"snow":[255,250,250],"springgreen":[0,255,127],"steelblue":[70,130,180],"tan":[210,180,140],"teal":[0,128,128],"thistle":[216,191,216],"tomato":[255,99,71],"turquoise":[64,224,208],"violet":[238,130,238],"wheat":[245,222,179],"white":[255,255,255],"whitesmoke":[245,245,245],"yellow":[255,255,0],"yellowgreen":[154,205,50]},E=I,U=Object.hasOwnProperty,N=Object.create(null);for(var z in C)U.call(C,z)&&(N[C[z]]=z);var L=k.exports={to:{},get:{}};function j(t,e,n){return Math.min(Math.max(e,t),n)}function D(t){var e=Math.round(t).toString(16).toUpperCase();return e.length<2?"0"+e:e}L.get=function(t){var e,n;switch(t.substring(0,3).toLowerCase()){case"hsl":e=L.get.hsl(t),n="hsl";break;case"hwb":e=L.get.hwb(t),n="hwb";break;default:e=L.get.rgb(t),n="rgb"}return e?{model:n,value:e}:null},L.get.rgb=function(t){if(!t)return null;var e,n,r,a=[0,0,0,1];if(e=t.match(/^#([a-f0-9]{6})([a-f0-9]{2})?$/i)){for(r=e[2],e=e[1],n=0;n<3;n++){var o=2*n;a[n]=parseInt(e.slice(o,o+2),16)}r&&(a[3]=parseInt(r,16)/255)}else if(e=t.match(/^#([a-f0-9]{3,4})$/i)){for(r=(e=e[1])[3],n=0;n<3;n++)a[n]=parseInt(e[n]+e[n],16);r&&(a[3]=parseInt(r+r,16)/255)}else if(e=t.match(/^rgba?\\(\\s*([+-]?\\d+)(?=[\\s,])\\s*(?:,\\s*)?([+-]?\\d+)(?=[\\s,])\\s*(?:,\\s*)?([+-]?\\d+)\\s*(?:[,|\\/]\\s*([+-]?[\\d\\.]+)(%?)\\s*)?\\)$/)){for(n=0;n<3;n++)a[n]=parseInt(e[n+1],0);e[4]&&(e[5]?a[3]=.01*parseFloat(e[4]):a[3]=parseFloat(e[4]))}else{if(!(e=t.match(/^rgba?\\(\\s*([+-]?[\\d\\.]+)\\%\\s*,?\\s*([+-]?[\\d\\.]+)\\%\\s*,?\\s*([+-]?[\\d\\.]+)\\%\\s*(?:[,|\\/]\\s*([+-]?[\\d\\.]+)(%?)\\s*)?\\)$/)))return(e=t.match(/^(\\w+)$/))?"transparent"===e[1]?[0,0,0,0]:U.call(C,e[1])?((a=C[e[1]])[3]=1,a):null:null;for(n=0;n<3;n++)a[n]=Math.round(2.55*parseFloat(e[n+1]));e[4]&&(e[5]?a[3]=.01*parseFloat(e[4]):a[3]=parseFloat(e[4]))}for(n=0;n<3;n++)a[n]=j(a[n],0,255);return a[3]=j(a[3],0,1),a},L.get.hsl=function(t){if(!t)return null;var e=t.match(/^hsla?\\(\\s*([+-]?(?:\\d{0,3}\\.)?\\d+)(?:deg)?\\s*,?\\s*([+-]?[\\d\\.]+)%\\s*,?\\s*([+-]?[\\d\\.]+)%\\s*(?:[,|\\/]\\s*([+-]?(?=\\.\\d|\\d)(?:0|[1-9]\\d*)?(?:\\.\\d*)?(?:[eE][+-]?\\d+)?)\\s*)?\\)$/);if(e){var n=parseFloat(e[4]);return[(parseFloat(e[1])%360+360)%360,j(parseFloat(e[2]),0,100),j(parseFloat(e[3]),0,100),j(isNaN(n)?1:n,0,1)]}return null},L.get.hwb=function(t){if(!t)return null;var e=t.match(/^hwb\\(\\s*([+-]?\\d{0,3}(?:\\.\\d+)?)(?:deg)?\\s*,\\s*([+-]?[\\d\\.]+)%\\s*,\\s*([+-]?[\\d\\.]+)%\\s*(?:,\\s*([+-]?(?=\\.\\d|\\d)(?:0|[1-9]\\d*)?(?:\\.\\d*)?(?:[eE][+-]?\\d+)?)\\s*)?\\)$/);if(e){var n=parseFloat(e[4]);return[(parseFloat(e[1])%360+360)%360,j(parseFloat(e[2]),0,100),j(parseFloat(e[3]),0,100),j(isNaN(n)?1:n,0,1)]}return null},L.to.hex=function(){var t=E(arguments);return"#"+D(t[0])+D(t[1])+D(t[2])+(t[3]<1?D(Math.round(255*t[3])):"")},L.to.rgb=function(){var t=E(arguments);return t.length<4||1===t[3]?"rgb("+Math.round(t[0])+", "+Math.round(t[1])+", "+Math.round(t[2])+")":"rgba("+Math.round(t[0])+", "+Math.round(t[1])+", "+Math.round(t[2])+", "+t[3]+")"},L.to.rgb.percent=function(){var t=E(arguments),e=Math.round(t[0]/255*100),n=Math.round(t[1]/255*100),r=Math.round(t[2]/255*100);return t.length<4||1===t[3]?"rgb("+e+"%, "+n+"%, "+r+"%)":"rgba("+e+"%, "+n+"%, "+r+"%, "+t[3]+")"},L.to.hsl=function(){var t=E(arguments);return t.length<4||1===t[3]?"hsl("+t[0]+", "+t[1]+"%, "+t[2]+"%)":"hsla("+t[0]+", "+t[1]+"%, "+t[2]+"%, "+t[3]+")"},L.to.hwb=function(){var t=E(arguments),e="";return t.length>=4&&1!==t[3]&&(e=", "+t[3]),"hwb("+t[0]+", "+t[1]+"%, "+t[2]+"%"+e+")"},L.to.keyword=function(t){return N[t.slice(0,3)]};var P=k.exports,B={exports:{}},q={"aliceblue":[240,248,255],"antiquewhite":[250,235,215],"aqua":[0,255,255],"aquamarine":[127,255,212],"azure":[240,255,255],"beige":[245,245,220],"bisque":[255,228,196],"black":[0,0,0],"blanchedalmond":[255,235,205],"blue":[0,0,255],"blueviolet":[138,43,226],"brown":[165,42,42],"burlywood":[222,184,135],"cadetblue":[95,158,160],"chartreuse":[127,255,0],"chocolate":[210,105,30],"coral":[255,127,80],"cornflowerblue":[100,149,237],"cornsilk":[255,248,220],"crimson":[220,20,60],"cyan":[0,255,255],"darkblue":[0,0,139],"darkcyan":[0,139,139],"darkgoldenrod":[184,134,11],"darkgray":[169,169,169],"darkgreen":[0,100,0],"darkgrey":[169,169,169],"darkkhaki":[189,183,107],"darkmagenta":[139,0,139],"darkolivegreen":[85,107,47],"darkorange":[255,140,0],"darkorchid":[153,50,204],"darkred":[139,0,0],"darksalmon":[233,150,122],"darkseagreen":[143,188,143],"darkslateblue":[72,61,139],"darkslategray":[47,79,79],"darkslategrey":[47,79,79],"darkturquoise":[0,206,209],"darkviolet":[148,0,211],"deeppink":[255,20,147],"deepskyblue":[0,191,255],"dimgray":[105,105,105],"dimgrey":[105,105,105],"dodgerblue":[30,144,255],"firebrick":[178,34,34],"floralwhite":[255,250,240],"forestgreen":[34,139,34],"fuchsia":[255,0,255],"gainsboro":[220,220,220],"ghostwhite":[248,248,255],"gold":[255,215,0],"goldenrod":[218,165,32],"gray":[128,128,128],"green":[0,128,0],"greenyellow":[173,255,47],"grey":[128,128,128],"honeydew":[240,255,240],"hotpink":[255,105,180],"indianred":[205,92,92],"indigo":[75,0,130],"ivory":[255,255,240],"khaki":[240,230,140],"lavender":[230,230,250],"lavenderblush":[255,240,245],"lawngreen":[124,252,0],"lemonchiffon":[255,250,205],"lightblue":[173,216,230],"lightcoral":[240,128,128],"lightcyan":[224,255,255],"lightgoldenrodyellow":[250,250,210],"lightgray":[211,211,211],"lightgreen":[144,238,144],"lightgrey":[211,211,211],"lightpink":[255,182,193],"lightsalmon":[255,160,122],"lightseagreen":[32,178,170],"lightskyblue":[135,206,250],"lightslategray":[119,136,153],"lightslategrey":[119,136,153],"lightsteelblue":[176,196,222],"lightyellow":[255,255,224],"lime":[0,255,0],"limegreen":[50,205,50],"linen":[250,240,230],"magenta":[255,0,255],"maroon":[128,0,0],"mediumaquamarine":[102,205,170],"mediumblue":[0,0,205],"mediumorchid":[186,85,211],"mediumpurple":[147,112,219],"mediumseagreen":[60,179,113],"mediumslateblue":[123,104,238],"mediumspringgreen":[0,250,154],"mediumturquoise":[72,209,204],"mediumvioletred":[199,21,133],"midnightblue":[25,25,112],"mintcream":[245,255,250],"mistyrose":[255,228,225],"moccasin":[255,228,181],"navajowhite":[255,222,173],"navy":[0,0,128],"oldlace":[253,245,230],"olive":[128,128,0],"olivedrab":[107,142,35],"orange":[255,165,0],"orangered":[255,69,0],"orchid":[218,112,214],"palegoldenrod":[238,232,170],"palegreen":[152,251,152],"paleturquoise":[175,238,238],"palevioletred":[219,112,147],"papayawhip":[255,239,213],"peachpuff":[255,218,185],"peru":[205,133,63],"pink":[255,192,203],"plum":[221,160,221],"powderblue":[176,224,230],"purple":[128,0,128],"rebeccapurple":[102,51,153],"red":[255,0,0],"rosybrown":[188,143,143],"royalblue":[65,105,225],"saddlebrown":[139,69,19],"salmon":[250,128,114],"sandybrown":[244,164,96],"seagreen":[46,139,87],"seashell":[255,245,238],"sienna":[160,82,45],"silver":[192,192,192],"skyblue":[135,206,235],"slateblue":[106,90,205],"slategray":[112,128,144],"slategrey":[112,128,144],"snow":[255,250,250],"springgreen":[0,255,127],"steelblue":[70,130,180],"tan":[210,180,140],"teal":[0,128,128],"thistle":[216,191,216],"tomato":[255,99,71],"turquoise":[64,224,208],"violet":[238,130,238],"wheat":[245,222,179],"white":[255,255,255],"whitesmoke":[245,245,245],"yellow":[255,255,0],"yellowgreen":[154,205,50]},R={};for(var V in q)q.hasOwnProperty(V)&&(R[q[V]]=V);var G=B.exports={rgb:{channels:3,labels:"rgb"},hsl:{channels:3,labels:"hsl"},hsv:{channels:3,labels:"hsv"},hwb:{channels:3,labels:"hwb"},cmyk:{channels:4,labels:"cmyk"},xyz:{channels:3,labels:"xyz"},lab:{channels:3,labels:"lab"},lch:{channels:3,labels:"lch"},hex:{channels:1,labels:["hex"]},keyword:{channels:1,labels:["keyword"]},ansi16:{channels:1,labels:["ansi16"]},ansi256:{channels:1,labels:["ansi256"]},hcg:{channels:3,labels:["h","c","g"]},apple:{channels:3,labels:["r16","g16","b16"]},gray:{channels:1,labels:["gray"]}};for(var $ in G)if(G.hasOwnProperty($)){if(!("channels"in G[$]))throw new Error("missing channels property: "+$);if(!("labels"in G[$]))throw new Error("missing channel labels property: "+$);if(G[$].labels.length!==G[$].channels)throw new Error("channel and label counts mismatch: "+$);var X=G[$].channels,H=G[$].labels;delete G[$].channels,delete G[$].labels,Object.defineProperty(G[$],"channels",{value:X}),Object.defineProperty(G[$],"labels",{value:H})}G.rgb.hsl=function(t){var e,n,r=t[0]/255,a=t[1]/255,o=t[2]/255,i=Math.min(r,a,o),s=Math.max(r,a,o),c=s-i;return s===i?e=0:r===s?e=(a-o)/c:a===s?e=2+(o-r)/c:o===s&&(e=4+(r-a)/c),(e=Math.min(60*e,360))<0&&(e+=360),n=(i+s)/2,[e,100*(s===i?0:n<=.5?c/(s+i):c/(2-s-i)),100*n]},G.rgb.hsv=function(t){var e,n,r,a,o,i=t[0]/255,s=t[1]/255,c=t[2]/255,u=Math.max(i,s,c),l=u-Math.min(i,s,c),f=function(t){return(u-t)/6/l+.5};return 0===l?a=o=0:(o=l/u,e=f(i),n=f(s),r=f(c),i===u?a=r-n:s===u?a=1/3+e-r:c===u&&(a=2/3+n-e),a<0?a+=1:a>1&&(a-=1)),[360*a,100*o,100*u]},G.rgb.hwb=function(t){var e=t[0],n=t[1],r=t[2];return[G.rgb.hsl(t)[0],100*(1/255*Math.min(e,Math.min(n,r))),100*(r=1-1/255*Math.max(e,Math.max(n,r)))]},G.rgb.cmyk=function(t){var e,n=t[0]/255,r=t[1]/255,a=t[2]/255;return[100*((1-n-(e=Math.min(1-n,1-r,1-a)))/(1-e)||0),100*((1-r-e)/(1-e)||0),100*((1-a-e)/(1-e)||0),100*e]},G.rgb.keyword=function(t){var e=R[t];if(e)return e;var n,r,a,o=1/0;for(var i in q)if(q.hasOwnProperty(i)){var s=q[i],c=(r=t,a=s,Math.pow(r[0]-a[0],2)+Math.pow(r[1]-a[1],2)+Math.pow(r[2]-a[2],2));c<o&&(o=c,n=i)}return n},G.keyword.rgb=function(t){return q[t]},G.rgb.xyz=function(t){var e=t[0]/255,n=t[1]/255,r=t[2]/255;return[100*(.4124*(e=e>.04045?Math.pow((e+.055)/1.055,2.4):e/12.92)+.3576*(n=n>.04045?Math.pow((n+.055)/1.055,2.4):n/12.92)+.1805*(r=r>.04045?Math.pow((r+.055)/1.055,2.4):r/12.92)),100*(.2126*e+.7152*n+.0722*r),100*(.0193*e+.1192*n+.9505*r)]},G.rgb.lab=function(t){var e=G.rgb.xyz(t),n=e[0],r=e[1],a=e[2];return r/=100,a/=108.883,n=(n/=95.047)>.008856?Math.pow(n,1/3):7.787*n+16/116,[116*(r=r>.008856?Math.pow(r,1/3):7.787*r+16/116)-16,500*(n-r),200*(r-(a=a>.008856?Math.pow(a,1/3):7.787*a+16/116))]},G.hsl.rgb=function(t){var e,n,r,a,o,i=t[0]/360,s=t[1]/100,c=t[2]/100;if(0===s)return[o=255*c,o,o];e=2*c-(n=c<.5?c*(1+s):c+s-c*s),a=[0,0,0];for(var u=0;u<3;u++)(r=i+1/3*-(u-1))<0&&r++,r>1&&r--,o=6*r<1?e+6*(n-e)*r:2*r<1?n:3*r<2?e+(n-e)*(2/3-r)*6:e,a[u]=255*o;return a},G.hsl.hsv=function(t){var e=t[0],n=t[1]/100,r=t[2]/100,a=n,o=Math.max(r,.01);return n*=(r*=2)<=1?r:2-r,a*=o<=1?o:2-o,[e,100*(0===r?2*a/(o+a):2*n/(r+n)),100*((r+n)/2)]},G.hsv.rgb=function(t){var e=t[0]/60,n=t[1]/100,r=t[2]/100,a=Math.floor(e)%6,o=e-Math.floor(e),i=255*r*(1-n),s=255*r*(1-n*o),c=255*r*(1-n*(1-o));switch(r*=255,a){case 0:return[r,c,i];case 1:return[s,r,i];case 2:return[i,r,c];case 3:return[i,s,r];case 4:return[c,i,r];case 5:return[r,i,s]}},G.hsv.hsl=function(t){var e,n,r,a=t[0],o=t[1]/100,i=t[2]/100,s=Math.max(i,.01);return r=(2-o)*i,n=o*s,[a,100*(n=(n/=(e=(2-o)*s)<=1?e:2-e)||0),100*(r/=2)]},G.hwb.rgb=function(t){var e,n,r,a,o,i,s,c=t[0]/360,u=t[1]/100,l=t[2]/100,f=u+l;switch(f>1&&(u/=f,l/=f),r=6*c-(e=Math.floor(6*c)),1&e&&(r=1-r),a=u+r*((n=1-l)-u),e){default:case 6:case 0:o=n,i=a,s=u;break;case 1:o=a,i=n,s=u;break;case 2:o=u,i=n,s=a;break;case 3:o=u,i=a,s=n;break;case 4:o=a,i=u,s=n;break;case 5:o=n,i=u,s=a}return[255*o,255*i,255*s]},G.cmyk.rgb=function(t){var e=t[0]/100,n=t[1]/100,r=t[2]/100,a=t[3]/100;return[255*(1-Math.min(1,e*(1-a)+a)),255*(1-Math.min(1,n*(1-a)+a)),255*(1-Math.min(1,r*(1-a)+a))]},G.xyz.rgb=function(t){var e,n,r,a=t[0]/100,o=t[1]/100,i=t[2]/100;return n=-.9689*a+1.8758*o+.0415*i,r=.0557*a+-.204*o+1.057*i,e=(e=3.2406*a+-1.5372*o+-.4986*i)>.0031308?1.055*Math.pow(e,1/2.4)-.055:12.92*e,n=n>.0031308?1.055*Math.pow(n,1/2.4)-.055:12.92*n,r=r>.0031308?1.055*Math.pow(r,1/2.4)-.055:12.92*r,[255*(e=Math.min(Math.max(0,e),1)),255*(n=Math.min(Math.max(0,n),1)),255*(r=Math.min(Math.max(0,r),1))]},G.xyz.lab=function(t){var e=t[0],n=t[1],r=t[2];return n/=100,r/=108.883,e=(e/=95.047)>.008856?Math.pow(e,1/3):7.787*e+16/116,[116*(n=n>.008856?Math.pow(n,1/3):7.787*n+16/116)-16,500*(e-n),200*(n-(r=r>.008856?Math.pow(r,1/3):7.787*r+16/116))]},G.lab.xyz=function(t){var e,n,r,a=t[0];e=t[1]/500+(n=(a+16)/116),r=n-t[2]/200;var o=Math.pow(n,3),i=Math.pow(e,3),s=Math.pow(r,3);return n=o>.008856?o:(n-16/116)/7.787,e=i>.008856?i:(e-16/116)/7.787,r=s>.008856?s:(r-16/116)/7.787,[e*=95.047,n*=100,r*=108.883]},G.lab.lch=function(t){var e,n=t[0],r=t[1],a=t[2];return(e=360*Math.atan2(a,r)/2/Math.PI)<0&&(e+=360),[n,Math.sqrt(r*r+a*a),e]},G.lch.lab=function(t){var e,n=t[0],r=t[1];return e=t[2]/360*2*Math.PI,[n,r*Math.cos(e),r*Math.sin(e)]},G.rgb.ansi16=function(t){var e=t[0],n=t[1],r=t[2],a=1 in arguments?arguments[1]:G.rgb.hsv(t)[2];if(0===(a=Math.round(a/50)))return 30;var o=30+(Math.round(r/255)<<2|Math.round(n/255)<<1|Math.round(e/255));return 2===a&&(o+=60),o},G.hsv.ansi16=function(t){return G.rgb.ansi16(G.hsv.rgb(t),t[2])},G.rgb.ansi256=function(t){var e=t[0],n=t[1],r=t[2];return e===n&&n===r?e<8?16:e>248?231:Math.round((e-8)/247*24)+232:16+36*Math.round(e/255*5)+6*Math.round(n/255*5)+Math.round(r/255*5)},G.ansi16.rgb=function(t){var e=t%10;if(0===e||7===e)return t>50&&(e+=3.5),[e=e/10.5*255,e,e];var n=.5*(1+~~(t>50));return[(1&e)*n*255,(e>>1&1)*n*255,(e>>2&1)*n*255]},G.ansi256.rgb=function(t){if(t>=232){var e=10*(t-232)+8;return[e,e,e]}var n;return t-=16,[Math.floor(t/36)/5*255,Math.floor((n=t%36)/6)/5*255,n%6/5*255]},G.rgb.hex=function(t){var e=(((255&Math.round(t[0]))<<16)+((255&Math.round(t[1]))<<8)+(255&Math.round(t[2]))).toString(16).toUpperCase();return"000000".substring(e.length)+e},G.hex.rgb=function(t){var e=t.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);if(!e)return[0,0,0];var n=e[0];3===e[0].length&&(n=n.split("").map((function(t){return t+t})).join(""));var r=parseInt(n,16);return[r>>16&255,r>>8&255,255&r]},G.rgb.hcg=function(t){var e,n=t[0]/255,r=t[1]/255,a=t[2]/255,o=Math.max(Math.max(n,r),a),i=Math.min(Math.min(n,r),a),s=o-i;return e=s<=0?0:o===n?(r-a)/s%6:o===r?2+(a-n)/s:4+(n-r)/s+4,e/=6,[360*(e%=1),100*s,100*(s<1?i/(1-s):0)]},G.hsl.hcg=function(t){var e=t[1]/100,n=t[2]/100,r=1,a=0;return(r=n<.5?2*e*n:2*e*(1-n))<1&&(a=(n-.5*r)/(1-r)),[t[0],100*r,100*a]},G.hsv.hcg=function(t){var e=t[1]/100,n=t[2]/100,r=e*n,a=0;return r<1&&(a=(n-r)/(1-r)),[t[0],100*r,100*a]},G.hcg.rgb=function(t){var e=t[0]/360,n=t[1]/100,r=t[2]/100;if(0===n)return[255*r,255*r,255*r];var a,o=[0,0,0],i=e%1*6,s=i%1,c=1-s;switch(Math.floor(i)){case 0:o[0]=1,o[1]=s,o[2]=0;break;case 1:o[0]=c,o[1]=1,o[2]=0;break;case 2:o[0]=0,o[1]=1,o[2]=s;break;case 3:o[0]=0,o[1]=c,o[2]=1;break;case 4:o[0]=s,o[1]=0,o[2]=1;break;default:o[0]=1,o[1]=0,o[2]=c}return a=(1-n)*r,[255*(n*o[0]+a),255*(n*o[1]+a),255*(n*o[2]+a)]},G.hcg.hsv=function(t){var e=t[1]/100,n=e+t[2]/100*(1-e),r=0;return n>0&&(r=e/n),[t[0],100*r,100*n]},G.hcg.hsl=function(t){var e=t[1]/100,n=t[2]/100*(1-e)+.5*e,r=0;return n>0&&n<.5?r=e/(2*n):n>=.5&&n<1&&(r=e/(2*(1-n))),[t[0],100*r,100*n]},G.hcg.hwb=function(t){var e=t[1]/100,n=e+t[2]/100*(1-e);return[t[0],100*(n-e),100*(1-n)]},G.hwb.hcg=function(t){var e=t[1]/100,n=1-t[2]/100,r=n-e,a=0;return r<1&&(a=(n-r)/(1-r)),[t[0],100*r,100*a]},G.apple.rgb=function(t){return[t[0]/65535*255,t[1]/65535*255,t[2]/65535*255]},G.rgb.apple=function(t){return[t[0]/255*65535,t[1]/255*65535,t[2]/255*65535]},G.gray.rgb=function(t){return[t[0]/100*255,t[0]/100*255,t[0]/100*255]},G.gray.hsl=G.gray.hsv=function(t){return[0,0,t[0]]},G.gray.hwb=function(t){return[0,100,t[0]]},G.gray.cmyk=function(t){return[0,0,0,t[0]]},G.gray.lab=function(t){return[t[0],0,0]},G.gray.hex=function(t){var e=255&Math.round(t[0]/100*255),n=((e<<16)+(e<<8)+e).toString(16).toUpperCase();return"000000".substring(n.length)+n},G.rgb.gray=function(t){return[(t[0]+t[1]+t[2])/3/255*100]};var J=B.exports,Y=J;function K(t){var e=function(){for(var t={},e=Object.keys(Y),n=e.length,r=0;r<n;r++)t[e[r]]={distance:-1,parent:null};return t}(),n=[t];for(e[t].distance=0;n.length;)for(var r=n.pop(),a=Object.keys(Y[r]),o=a.length,i=0;i<o;i++){var s=a[i],c=e[s];-1===c.distance&&(c.distance=e[r].distance+1,c.parent=r,n.unshift(s))}return e}function Q(t,e){return function(n){return e(t(n))}}function Z(t,e){for(var n=[e[t].parent,t],r=Y[e[t].parent][t],a=e[t].parent;e[a].parent;)n.unshift(e[a].parent),r=Q(Y[e[a].parent][a],r),a=e[a].parent;return r.conversion=n,r}var W=J,tt=function(t){for(var e=K(t),n={},r=Object.keys(e),a=r.length,o=0;o<a;o++){var i=r[o];null!==e[i].parent&&(n[i]=Z(i,e))}return n},et={};Object.keys(W).forEach((function(t){et[t]={},Object.defineProperty(et[t],"channels",{value:W[t].channels}),Object.defineProperty(et[t],"labels",{value:W[t].labels});var e=tt(t);Object.keys(e).forEach((function(n){var r=e[n];et[t][n]=function(t){var e=function(e){if(null==e)return e;arguments.length>1&&(e=Array.prototype.slice.call(arguments));var n=t(e);if("object"==typeof n)for(var r=n.length,a=0;a<r;a++)n[a]=Math.round(n[a]);return n};return"conversion"in t&&(e.conversion=t.conversion),e}(r),et[t][n].raw=function(t){var e=function(e){return null==e?e:(arguments.length>1&&(e=Array.prototype.slice.call(arguments)),t(e))};return"conversion"in t&&(e.conversion=t.conversion),e}(r)}))}));var nt=P,rt=et,at=[].slice,ot=["keyword","gray","hex"],it={};Object.keys(rt).forEach((function(t){it[at.call(rt[t].labels).sort().join("")]=t}));var st={};function ct(t,e){if(!(this instanceof ct))return new ct(t,e);if(e&&e in ot&&(e=null),e&&!(e in rt))throw new Error("Unknown model: "+e);var n,r;if(null==t)this.model="rgb",this.color=[0,0,0],this.valpha=1;else if(t instanceof ct)this.model=t.model,this.color=t.color.slice(),this.valpha=t.valpha;else if("string"==typeof t){var a=nt.get(t);if(null===a)throw new Error("Unable to parse color from string: "+t);this.model=a.model,r=rt[this.model].channels,this.color=a.value.slice(0,r),this.valpha="number"==typeof a.value[r]?a.value[r]:1}else if(t.length){this.model=e||"rgb",r=rt[this.model].channels;var o=at.call(t,0,r);this.color=ft(o,r),this.valpha="number"==typeof t[r]?t[r]:1}else if("number"==typeof t)t&=16777215,this.model="rgb",this.color=[t>>16&255,t>>8&255,255&t],this.valpha=1;else{this.valpha=1;var i=Object.keys(t);"alpha"in t&&(i.splice(i.indexOf("alpha"),1),this.valpha="number"==typeof t.alpha?t.alpha:0);var s=i.sort().join("");if(!(s in it))throw new Error("Unable to parse color from object: "+JSON.stringify(t));this.model=it[s];var c=rt[this.model].labels,u=[];for(n=0;n<c.length;n++)u.push(t[c[n]]);this.color=ft(u)}if(st[this.model])for(r=rt[this.model].channels,n=0;n<r;n++){var l=st[this.model][n];l&&(this.color[n]=l(this.color[n]))}this.valpha=Math.max(0,Math.min(1,this.valpha)),Object.freeze&&Object.freeze(this)}function ut(t,e,n){return(t=Array.isArray(t)?t:[t]).forEach((function(t){(st[t]||(st[t]=[]))[e]=n})),t=t[0],function(r){var a;return arguments.length?(n&&(r=n(r)),(a=this[t]()).color[e]=r,a):(a=this[t]().color[e],n&&(a=n(a)),a)}}function lt(t){return function(e){return Math.max(0,Math.min(t,e))}}function ft(t,e){for(var n=0;n<e;n++)"number"!=typeof t[n]&&(t[n]=0);return t}function ht(t){return null==t}function yt(t){return"object"==typeof t&&!!t}function dt(t){return t/Math.PI*180}ct.prototype={toString:function(){return this.string()},toJSON:function(){return this[this.model]()},string:function(t){var e=this.model in nt.to?this:this.rgb(),n=1===(e=e.round("number"==typeof t?t:1)).valpha?e.color:e.color.concat(this.valpha);return nt.to[e.model](n)},percentString:function(t){var e=this.rgb().round("number"==typeof t?t:1),n=1===e.valpha?e.color:e.color.concat(this.valpha);return nt.to.rgb.percent(n)},array:function(){return 1===this.valpha?this.color.slice():this.color.concat(this.valpha)},object:function(){for(var t={},e=rt[this.model].channels,n=rt[this.model].labels,r=0;r<e;r++)t[n[r]]=this.color[r];return 1!==this.valpha&&(t.alpha=this.valpha),t},unitArray:function(){var t=this.rgb().color;return t[0]/=255,t[1]/=255,t[2]/=255,1!==this.valpha&&t.push(this.valpha),t},unitObject:function(){var t=this.rgb().object();return t.r/=255,t.g/=255,t.b/=255,1!==this.valpha&&(t.alpha=this.valpha),t},round:function(t){return t=Math.max(t||0,0),new ct(this.color.map(function(t){return function(e){return function(t,e){return Number(t.toFixed(e))}(e,t)}}(t)).concat(this.valpha),this.model)},alpha:function(t){return arguments.length?new ct(this.color.concat(Math.max(0,Math.min(1,t))),this.model):this.valpha},red:ut("rgb",0,lt(255)),green:ut("rgb",1,lt(255)),blue:ut("rgb",2,lt(255)),hue:ut(["hsl","hsv","hsl","hwb","hcg"],0,(function(t){return(t%360+360)%360})),saturationl:ut("hsl",1,lt(100)),lightness:ut("hsl",2,lt(100)),saturationv:ut("hsv",1,lt(100)),value:ut("hsv",2,lt(100)),chroma:ut("hcg",1,lt(100)),gray:ut("hcg",2,lt(100)),white:ut("hwb",1,lt(100)),wblack:ut("hwb",2,lt(100)),cyan:ut("cmyk",0,lt(100)),magenta:ut("cmyk",1,lt(100)),yellow:ut("cmyk",2,lt(100)),black:ut("cmyk",3,lt(100)),x:ut("xyz",0,lt(100)),y:ut("xyz",1,lt(100)),z:ut("xyz",2,lt(100)),l:ut("lab",0,lt(100)),a:ut("lab",1),b:ut("lab",2),keyword:function(t){return arguments.length?new ct(t):rt[this.model].keyword(this.color)},hex:function(t){return arguments.length?new ct(t):nt.to.hex(this.rgb().round().color)},rgbNumber:function(){var t=this.rgb().color;return(255&t[0])<<16|(255&t[1])<<8|255&t[2]},luminosity:function(){for(var t=this.rgb().color,e=[],n=0;n<t.length;n++){var r=t[n]/255;e[n]=r<=.03928?r/12.92:Math.pow((r+.055)/1.055,2.4)}return.2126*e[0]+.7152*e[1]+.0722*e[2]},contrast:function(t){var e=this.luminosity(),n=t.luminosity();return e>n?(e+.05)/(n+.05):(n+.05)/(e+.05)},level:function(t){var e=this.contrast(t);return e>=7.1?"AAA":e>=4.5?"AA":""},isDark:function(){var t=this.rgb().color;return(299*t[0]+587*t[1]+114*t[2])/1e3<128},isLight:function(){return!this.isDark()},negate:function(){for(var t=this.rgb(),e=0;e<3;e++)t.color[e]=255-t.color[e];return t},lighten:function(t){var e=this.hsl();return e.color[2]+=e.color[2]*t,e},darken:function(t){var e=this.hsl();return e.color[2]-=e.color[2]*t,e},saturate:function(t){var e=this.hsl();return e.color[1]+=e.color[1]*t,e},desaturate:function(t){var e=this.hsl();return e.color[1]-=e.color[1]*t,e},whiten:function(t){var e=this.hwb();return e.color[1]+=e.color[1]*t,e},blacken:function(t){var e=this.hwb();return e.color[2]+=e.color[2]*t,e},grayscale:function(){var t=this.rgb().color,e=.3*t[0]+.59*t[1]+.11*t[2];return ct.rgb(e,e,e)},fade:function(t){return this.alpha(this.valpha-this.valpha*t)},opaquer:function(t){return this.alpha(this.valpha+this.valpha*t)},rotate:function(t){var e=this.hsl(),n=e.color[0];return n=(n=(n+t)%360)<0?360+n:n,e.color[0]=n,e},mix:function(t,e){if(!t||!t.rgb)throw new Error('Argument to "mix" was not a Color instance, but rather an instance of '+typeof t);var n=t.rgb(),r=this.rgb(),a=void 0===e?.5:e,o=2*a-1,i=n.alpha()-r.alpha(),s=((o*i==-1?o:(o+i)/(1+o*i))+1)/2,c=1-s;return ct.rgb(s*n.red()+c*r.red(),s*n.green()+c*r.green(),s*n.blue()+c*r.blue(),n.alpha()*a+r.alpha()*(1-a))}},Object.keys(rt).forEach((function(t){if(-1===ot.indexOf(t)){var e=rt[t].channels;ct.prototype[t]=function(){if(this.model===t)return new ct(this);if(arguments.length)return new ct(arguments,t);var n,r="number"==typeof arguments[e]?e:this.valpha;return new ct((n=rt[this.model][t].raw(this.color),Array.isArray(n)?n:[n]).concat(r),t)},ct[t]=function(n){return"number"==typeof n&&(n=ft(at.call(arguments),e)),new ct(n,t)}}}));const bt=[1,1,1,1,2,2,3,0];function mt(t){const e=t.length;let n="";for(let r=0;r<e;){let a=t[r++];if(128&a){let n=bt[a>>3&7];if(!(64&a)||!n||r+n>e)return null;for(a&=63>>n;n>0;n-=1){const e=t[r++];if(128!=(192&e))return null;a=a<<6|63&e}}n+=String.fromCharCode(a)}return n}new Array(3),new Array(3);const pt=[1/6378137,1/6378137,1/6356752.314245179],gt=[1/40680631590769,1/40680631590769,1/40408299984661.445],vt=new Array(3),wt=new Array(3),Mt=new Array(3);function Tt(t,e){const n=gt,r=function(t,e,n,r,a){const o=e[0],i=e[1],s=e[2],c=n[0],u=n[1],l=n[2],f=o*o*c*c,h=i*i*u*u,y=s*s*l*l,d=f+h+y,b=Math.sqrt(1/d),m=function(t,e,n){return t[0]=e[0]*n,t[1]=e[1]*n,t[2]=e[2]*n,t}(At,e,b);if(d<a)return isFinite(b)?m:void 0;const p=r[0],g=r[1],v=r[2],w=kt;w[0]=m[0]*p*2,w[1]=m[1]*g*2,w[2]=m[2]*v*2;let M,T,A,k,_,O,S,x,F,I,C,E=(1-b)*Ot(e)/(.5*Ot(w)),U=0;do{E-=U,A=1/(1+E*p),k=1/(1+E*g),_=1/(1+E*v),O=A*A,S=k*k,x=_*_,F=O*A,I=S*k,C=x*_,M=f*O+h*S+y*x-1,T=f*F*p+h*I*g+y*C*v;U=M/(-2*T)}while(Math.abs(M)>_t);return t[0]=o*A,t[1]=i*k,t[2]=s*_,t}(vt,e,pt,n,.1);let a=v(wt,r,n);a=function(t,e){const n=e[0],r=e[1],a=e[2];let o=n*n+r*r+a*a;o>0&&(o=Math.sqrt(o),t[0]=e[0]/o,t[1]=e[1]/o,t[2]=e[2]/o);return t}(a,a);const o=g(Mt,e,r),i=Math.atan2(a[1],a[0]),s=Math.asin(a[2]),c=(u=m(o,e),(Math.sign?Math.sign(u):0==(u=+u)||isNaN(u)?Number(u):u>0?1:-1)*Ot(o));var u;return t[0]=dt(i),t[1]=dt(s),t[2]=c,t}const At=new Array(3),kt=new Array(3),_t=1e-12;function Ot(t){return l(t)}function St(t,e){let n="";for(let r=0;r<4;r++){const a=t.getUint8(e+r);n+=String.fromCharCode(a)}return n}const xt="undefined"!=typeof TextDecoder?new TextDecoder("utf-8"):null;function Ft(t,e,n){const r=new Uint8Array(t,e,n);return xt?JSON.parse(xt.decode(r)):JSON.parse(mt(r))}function It(t,e,n){const r=new Uint8Array(t,e,n);return xt?JSON.parse(xt.decode(r)):JSON.parse(mt(r))}function Ct(t,e,n){return{offset:e,byteLength:n}}function Et(t,e,n,r){const{byteOffset:a,componentType:o,type:i}=t,{ctor:s,type:c}=function(t){return zt[t]}(o||"UNSIGNED_SHORT"),u=function(t){if(!t)return 1;return Nt[t]}(i);return{byteStride:0,byteOffset:a+n,itemSize:u,count:r*u,componentType:c,array:new s(e,n+a,r*u)}}function Ut(t,e,n,r){const a=Et(t,e,n,r);return a.array.buffer.byteLength!==e.byteLength&&(a.array=a.array.slice()),a}const Nt={"SCALAR":1,"VEC2":2,"VEC3":3,"VEC4":4};const zt={"BYTE":{ctor:Int8Array,type:5120,name:"Int8Array"},"UNSIGNED_BYTE":{ctor:Uint8Array,type:5121,name:"Uint8Array"},"SHORT":{ctor:Int16Array,type:5122,name:"Int16Array"},"UNSIGNED_SHORT":{ctor:Uint16Array,type:5123,name:"Uint16Array"},"INT":{ctor:Int32Array,type:5124,name:"Int32Array"},"UNSIGNED_INT":{ctor:Uint32Array,type:5125,name:"Uint32Array"},"FLOAT":{ctor:Float32Array,type:5126,name:"Float32Array"},"DOUBLE":{ctor:Float64Array,type:5126,name:"Float64Array"}};function Lt(t){for(const e in zt)if(t===zt[e].ctor)return zt[e].type;throw new Error("unrecognized ctor:"+t)}function jt(t,e,n,r){const a=t,o=e.length/3;for(let t=0;t<o;t++)a[3*t]=e[3*t]/65535*r[0]+n[0],a[3*t+1]=e[3*t+1]/65535*r[1]+n[1],a[3*t+2]=e[3*t+2]/65535*r[2]+n[2];return a}function Dt(t,e,n){const r=t.getUint32(12,!0),a=t.getUint32(16,!0),o=t.getUint32(20,!0),i=t.getUint32(24,!0),s=t.buffer;let c,u={},l={},f=null;r>0&&(u=Ft(s,e,r),e+=r),a>0&&(c=function(t,e,n){return{offset:e,byteLength:n}}(0,e,a),e+=a),o>0&&(l=It(s,e,o),e+=o);const h=Ct(0,e,i);return f=s.slice(h.offset,h.offset+h.byteLength),n.push(f),{featureTable:u,featureTableBin:c,batchTable:l,batchTableBin:f}}const Pt={5120:Int8Array,5122:Int16Array,5124:Int32Array,5121:Uint8Array,5123:Uint16Array,5125:Uint32Array,5126:Float32Array};function Bt(t){for(const e in Pt)if(t===Pt[e])return+e;throw new Error("unrecognized ctor:"+t)}let qt=null;function Rt(){return qt||(qt={"image/crn":r.crn&&r.crn(),"image/ktx2":r.ktx2&&r.ktx2(),"image/cttf":r.ktx2&&r.ktx2(),"draco":r.draco&&r.draco()}),qt}const{Ajax:Vt,GLTFLoader:Gt}=a();class $t{constructor(t,e,n){this.o=t,this.i=e||Gt,this.u=n,this.h=Rt()}static createEmptyB3DM(){return{featureTable:null,batchTable:null,gltf:{}}}load(t,e,n=0,r=0,a){return e?(r||(r=e.byteLength),this.m(t,e,n,r,a)):Vt.getArrayBuffer(t,{}).then((e=>{const a=e.data;return r||(r=a.byteLength),this.m(t,a,n,r)}))}m(t,e,n,r,a){const o=a&&a.maxTextureSize,i=this.p(e,n,r,t);if(i.error)return Promise.resolve(i);const s=t.substring(0,t.lastIndexOf("/"));let c;try{c=new this.i(s,i.glb,{transferable:!0,requestImage:this.o,decoders:this.h,supportedFormats:this.u,maxTextureSize:o})}catch(t){return Promise.resolve({error:t})}return c.load({skipAttributeTransform:!1}).then((e=>{e.url=\`${$5671aa7ae64fb35e$var$_}t}-${$5671aa7ae64fb35e$var$_}n}-${$5671aa7ae64fb35e$var$_}r}\`;const a=c.transferables;for(let t=0;t<i.transferables.length;t++)a.indexOf(i.transferables[t])<0&&a.push(i.transferables[t]);return{magic:"b3dm",count:i.count,transferables:a,featureTable:i.featureTable,batchTable:i.batchTable,batchTableBin:i.batchTableBin,gltf:e}}))}p(t,e,n,r){const a=new DataView(t,e,n),o=a.getUint32(4,!0);if(1!==o){const t="Unsupported b3dm version: "+o+", url:"+r;return console.warn(t),{error:t}}if(a.getUint32(8,!0)!==a.byteLength){const t="Length in b3dm header is inconsistent with b3dm's byte length, url: "+r;return console.warn(t),{error:t}}let i,s=a.getUint32(12,!0),c=a.getUint32(16,!0),u=a.getUint32(20,!0),l=a.getUint32(24,!0),f=28+e;u>=570425344?(f-=8,i=s,u=c,l=0,s=0,c=0):l>=570425344&&(f-=4,i=u,u=s,l=c,s=0,c=0);const h=[t];let y,d,b;if(s>0?(y=Ft(t,f,s),f+=s,i=y.BATCH_LENGTH):y={"BATCH_LENGTH":i},c>0&&(f+=c),u>0&&(d=It(t,f,u),f+=u,l>0)){const e=Ct(0,f,l);b=t.slice(e.offset,e.offset+e.byteLength),f+=l,h.push(b)}const m=y.BATCH_LENGTH,p={};if(y&&y.BATCH_ID){p.BATCH_ID=Ut(y.BATCH_ID,t,undefined.offset,m);const e=p.BATCH_ID.array&&p.BATCH_ID.array.buffer;e&&h.indexOf(e)<0&&h.push(e)}return{count:i,transferables:h,featureTable:y,batchTable:d,batchTableBin:b,b3dm:p,glb:{buffer:t,byteOffset:f,byteLength:a.byteLength+a.byteOffset-f}}}v(){return null}}const{Ajax:Xt,GLTFLoader:Ht}=a();class Jt{constructor(t,e,n,r){this.o=t,this.i=e||Ht,this.u=n,this.h=Rt(),this.M=r}load(t,e,n=0,r=0,a){return e?(r||(r=e.byteLength),this.m(t,e,n,r,a)):Xt.getArrayBuffer(t,{}).then((e=>{const a=e.data;return r||(r=a.byteLength),this.m(t,a,n,r)}))}m(t,e,n,r,a){return this.T(t,e,n,r,a).then((({gltf:a,transferables:o})=>{const i=this.A(e,n,r,t);if(i.error)return Promise.resolve(i);for(let t=0;t<o.length;t++)-1===i.transferables.indexOf(o[t])&&i.transferables.push(o[t]);return delete a.transferables,Promise.resolve({magic:"i3dm",count:i.count,transferables:i.transferables,featureTable:i.featureTable,batchTable:i.batchTable,batchTableBin:i.batchTableBin,i3dm:i.i3dm,gltf:a})}))}T(t,e,n,r,a){const o=a&&a.maxTextureSize,i={transferable:!0,requestImage:this.o,decoders:this.h,supportedFormats:this.u,maxTextureSize:o},s=new DataView(e,n,r),c=32+s.getUint32(12,!0)+s.getUint32(16,!0)+s.getUint32(20,!0)+s.getUint32(24,!0);if(0===s.getUint32(28,!0)){let r=mt(new Uint8Array(e,c+n,s.byteLength-c));-1==r.indexOf("://")&&(r=t.substring(0,t.lastIndexOf("/"))+"/"+r);return r.indexOf(".glb")>0?Xt.getArrayBuffer(r,{}).then((t=>this.k(r,{buffer:t.data,byteOffset:0},i))):Xt.getJSON(r,{}).then((t=>this.k(r,t,i)))}{const r={buffer:e,byteOffset:c+n,byteLength:s.byteLength-c};return this.k(t,r,i)}}k(t,e,n){const r=t.substring(0,t.lastIndexOf("/")),a=new this.i(r,e,n);return a.load({skipAttributeTransform:!0}).then((n=>{let r=0,o=0;return e.buffer&&(r=e.byteOffset||0,o=e.byteLength||0),n.url=\`${$5671aa7ae64fb35e$var$_}t}-${$5671aa7ae64fb35e$var$_}r}-${$5671aa7ae64fb35e$var$_}o}\`,{transferables:a.transferables,gltf:n}}))}A(t,e,n,r){const a=new DataView(t,e,n),o=a.getUint32(4,!0);if(1!==o){const t="Unsupported pnts version: "+o+", url:"+r;return console.warn(t),{error:t}}if(a.getUint32(8,!0)!==a.byteLength){const t="Length in pnts header is inconsistent with pnts's byte length, url: "+r;return console.warn(t),{error:t}}const i=[t],{featureTable:s,featureTableBin:c,batchTable:u,batchTableBin:l}=Dt(a,32+e,i),f={},h=s.INSTANCES_LENGTH;if(s.POSITION){const{byteOffset:e}=s.POSITION;f.POSITION={byteStride:0,byteOffset:0,itemSize:3,count:h,componentType:5126,array:new Float32Array(t,e+c.offset,3*h).slice()},i.push(f.POSITION.array.buffer)}else if(s.POSITION_QUANTIZED){const e=s.QUANTIZED_VOLUME_OFFSET,n=s.QUANTIZED_VOLUME_SCALE,{byteOffset:r}=s.POSITION_QUANTIZED;f.POSITION={byteStride:12,byteOffset:0,itemSize:3,count:h,componentType:5126,array:this._(new Uint16Array(t,r+c.offset,3*h),e,n)},i.push(f.POSITION.array.buffer)}if(s.BATCH_ID){f.BATCH_ID=Ut(s.BATCH_ID,t,c.offset,h);const e=f.BATCH_ID.array&&f.BATCH_ID.array.buffer;e&&i.indexOf(e)<0&&i.push(e)}if(s.NORMAL_UP){let{byteOffset:e}=s.NORMAL_UP;f.NORMAL_UP={byteStride:0,byteOffset:0,itemSize:3,count:h,componentType:5126,array:new Float32Array(t,e+c.offset,3*h).slice()},i.push(f.NORMAL_UP.array.buffer),e=s.NORMAL_RIGHT.byteOffset,f.NORMAL_RIGHT={byteStride:0,byteOffset:0,itemSize:3,count:h,componentType:5126,array:new Float32Array(t,e+c.offset,3*h).slice()},i.push(f.NORMAL_RIGHT.array.buffer)}else if(s.NORMAL_UP_OCT32P){let{byteOffset:e}=s.NORMAL_UP_OCT32P;f.NORMAL_UP={byteStride:0,byteOffset:0,itemSize:3,count:h,componentType:5126,array:this.O(new Uint16Array(t,e+c.offset,2*h))},i.push(f.NORMAL_UP.array.buffer),e=s.NORMAL_RIGHT_OCT32P.byteOffset,f.NORMAL_RIGHT={byteStride:0,byteOffset:0,itemSize:3,count:h,componentType:5126,array:this.O(new Uint16Array(t,e+c.offset,2*h))},i.push(f.NORMAL_RIGHT.array.buffer)}if(s.SCALE){const{byteOffset:e}=s.SCALE;f.SCALE={byteStride:0,byteOffset:0,itemSize:1,count:h,componentType:5126,array:new Float32Array(t,e+c.offset,h).slice()},i.push(f.SCALE.array.buffer)}else if(s.SCALE_NON_UNIFORM){const{byteOffset:e}=s.SCALE_NON_UNIFORM;f.SCALE_NON_UNIFORM={byteStride:0,byteOffset:0,itemSize:3,count:h,componentType:5126,array:new Float32Array(t,e+c.offset,3*h).slice()},i.push(f.SCALE_NON_UNIFORM.array.buffer)}return{count:h,batchTable:u,batchTableBin:l,featureTable:s,i3dm:f,transferables:i}}O(t){const e=t.length/2,n=new Float32Array(3*e),r=[];for(let a=0;a<e;a++)Yt(r,t[2*a],t[2*a+1],65535),n[3*a]=r[0],n[3*a+1]=r[1],n[3*a+2]=r[2];return n}_(t,e,n){return jt(new Float32Array(t.length),t,e,n)}v(){return null}}function Yt(t,e,n,r){if(t[0]=Kt(e,r),t[1]=Kt(n,r),t[2]=1-(Math.abs(t[0])+Math.abs(t[1])),t[2]<0){const e=t[0];t[0]=(1-Math.abs(t[1]))*Qt(e),t[1]=(1-Math.abs(e))*Qt(t[1])}return b(t,t)}function Kt(t,e){return function(t,e,n){return t<e?e:t>n?n:t}(t,0,e=function(t,e){if(null!=t)return t;return e}(e,255))/e*2-1}function Qt(t){return t<0?-1:1}const{Ajax:Zt}=a();class Wt{constructor(){}load(t,e,n=0,r=0){return e?(r||(r=e.byteLength),this.m(t,e,n,r)):Zt.getArrayBuffer(t,{}).then((e=>{const a=e.data;return r||(r=a.byteLength),this.m(t,a,n,r)}))}m(t,e,n,r){return this.S(e,n,r,t).then((t=>t.error?t:{magic:"pnts",count:t.count,transferables:t.transferables,featureTable:t.featureTable,batchTable:t.batchTable,batchTableBin:t.batchTableBin,pnts:t.pnts}))}S(t,e,n,r){const a=new DataView(t,e,n),o=a.getUint32(4,!0);if(1!==o){const t="Unsupported pnts version: "+o+", url:"+r;return console.warn(t),{error:t}}if(a.getUint32(8,!0)!==a.byteLength){const t="Length in pnts header is inconsistent with pnts's byte length, url: "+r;return console.warn(t),{error:t}}const i=[t],{featureTable:s,featureTableBin:c,batchTable:u,batchTableBin:l}=Dt(a,e+28,i),f=s.QUANTIZED_VOLUME_OFFSET,h=s.QUANTIZED_VOLUME_SCALE,y=s.POINTS_LENGTH;let d,b={};if(s.extensions&&s.extensions["3DTILES_draco_point_compression"]){b=s.extensions["3DTILES_draco_point_compression"],d=new DataView(t,b.byteOffset+c.offset,b.byteLength);const e={attributes:b.properties,useUniqueIDs:!1};return this.F||(this.F=Rt().draco),this.F(d,e).then((e=>{const n=e.attributes;!s.POSITION&&!s.POSITION_QUANTIZED||n.POSITION||n.POSITION_QUANTIZED||(n.POSITION=s.POSITION,n.POSITION_QUANTIZED=s.POSITION_QUANTIZED),!(s.RGB||s.RGBA||s.RGB565)||n.RGB||n.RGBA||n.RGB565||(n.RGB=s.RGB,n.RGBA=s.RGBA,n.RGB565=s.RGB565),!s.NORMAL&&!s.NORMAL_OCT16P||n.NORMAL||n.NORMAL_OCT16P||(n.NORMAL=s.NORMAL,n.NORMAL_OCT16P=s.NORMAL_OCT16P);const r=this.I(t,e.attributes,c.offset,y,i,f,h);if(e.attributes.BATCH_ID){const t=e.attributes.BATCH_ID.array;r.BATCH_ID={byteStride:0,byteOffset:0,itemSize:1,count:t.length,componentType:Lt(t.constructor),array:t},i.push(t.buffer)}else if(s.BATCH_ID||Object.keys(u).length){s.BATCH_ID?r.BATCH_ID=Ut(s.BATCH_ID,t,c.offset,y):r.BATCH_ID=te(y);const e=r.BATCH_ID.array&&r.BATCH_ID.array.buffer;e&&i.indexOf(e)<0&&i.push(e)}return{count:y,batchTable:u,batchTableBin:l,featureTable:s,pnts:r,transferables:i}}))}const m=this.I(t,s,c.offset,y,i,f,h);if(s.BATCH_ID||Object.keys(u).length){s.BATCH_ID?m.BATCH_ID=Ut(s.BATCH_ID,t,c.offset,y):m.BATCH_ID=te(y);const e=m.BATCH_ID.array&&m.BATCH_ID.array.buffer;e&&i.indexOf(e)<0&&i.push(e)}return Promise.resolve({count:y,batchTable:u,batchTableBin:l,featureTable:s,pnts:m,transferables:i})}I(t,e,n,r,a,o,i){const s={};if(e.POSITION){let{byteOffset:o,array:i}=e.POSITION;o=o||0;const c=i?0:n;if(!i){const e=t.slice(o+c,o+c+3*r*4);i=new Float32Array(e)}s.POSITION={byteStride:0,byteOffset:0,itemSize:3,count:r,componentType:5126,array:i},a.push(i.buffer)}else if(e.POSITION_QUANTIZED){let{byteOffset:c}=e.POSITION_QUANTIZED;const{array:u}=e.POSITION_QUANTIZED;c=c||0;const l=u?0:n;s.POSITION={byteStride:0,byteOffset:0,itemSize:3,count:r,componentType:5126,array:this._(u||new Uint16Array(t,c+l,3*r),o,i)},a.push(s.POSITION.array.buffer)}if(e.RGBA){let{byteOffset:o,array:i}=e.RGBA;o=o||0;const c=i?0:n;if(!i){const e=t.slice(o+c,o+c+4*r);i=new Uint8Array(e)}s.RGBA={byteStride:0,byteOffset:0,itemSize:4,count:r,componentType:5121,array:i},a.push(i.buffer)}else if(e.RGB){let{byteOffset:o,array:i}=e.RGB;o=o||0;const c=i?0:n;if(!i){const e=t.slice(o+c,o+c+3*r);i=new Uint8Array(e)}s.RGB={byteStride:0,byteOffset:0,itemSize:3,count:r,componentType:5121,array:i},a.push(i.buffer)}else if(e.RGB565){let{byteOffset:o,array:i}=e.RGB565;o=o||0;const c=i?0:n;if(!i){const e=t.slice(o+c,o+c+2*r);i=new Uint16Array(e)}s.RGB565={byteStride:0,byteOffset:0,itemSize:1,count:r,componentType:5123,array:i},a.push(i.buffer)}if(e.NORMAL){let{byteOffset:o,array:i}=e.NORMAL;o=o||0;const c=i?0:n;if(!i){const e=t.slice(o+c,o+c+3*r*4);i=new Float32Array(e)}s.NORMAL={byteStride:0,byteOffset:0,itemSize:3,count:r,componentType:5126,array:i},a.push(i.buffer)}else if(e.NORMAL_OCT16P){let{byteOffset:o,array:i}=e.NORMAL_OCT16P;o=o||0;const c=i?0:n;if(!i){const e=t.slice(o+c,o+c+2*r);i=new Uint8Array(e)}s.NORMAL_OCT16P={byteStride:0,byteOffset:0,itemSize:2,count:r,componentType:5121,array:i},a.push(i.buffer)}return s}_(t,e,n){return jt(new Float32Array(t.length),t,e,n)}v(){return null}}function te(t){const e=(n=t)<256?Uint8Array:n<65536?Uint16Array:Uint32Array;var n;const r=new e(t);for(let e=0;e<t;e++)r[e]=e;return{byteStride:0,byteOffset:0,itemSize:1,count:t,componentType:Lt(e),array:r}}const{Ajax:ee,GLTFLoader:ne}=a();class re{constructor(t,e,n,r){this.u=n,this.o=t,this.i=e||ne,this.M=r}load(t,e,n=0,r=0,a){return e?this.m(t,e,n,r,a):ee.getArrayBuffer(t,{}).then((e=>{const a=e.data;return this.m(t,a,n,r)}))}m(t,e,n,r,a){r||(r=e.byteLength);const o=this.C(e,t,n,r),i=[];for(let n=0;n<o.length;n++){let r;if("b3dm"===o[n].magic)r=new $t(this.o,this.i,this.u);else if("i3dm"===o[n].magic)r=new Jt(this.o,this.i,this.u,this.M);else if("pnts"===o[n].magic)r=new Wt;else{if("cmpt"!==o[n].magic){console.warn("Unsupported magic in CMPT tile:",o[n].magic);continue}r=new re(this.o,this.i,this.u,this.M)}i.push(r.load(t,e,o[n].offset,o[n].byteLength,a).then((t=>t)))}return Promise.all(i).then((t=>({magic:"cmpt",tiles:t})))}C(t,e,n,r){const a=new DataView(t,n,r),o=a.getUint32(4,!0);if(1!==o){const t="Unsupported cmpt version: "+o+", url:"+e;return console.warn(t),{error:t}}if(16===a.byteLength)return[];const i=[],s=a.getUint32(12,!0);let c=16;for(let e=0;e<s;e++){const e=St(a,c),r=a.getUint32(c+8,!0);i.push({magic:e,buffer:t,offset:c+n,byteLength:r}),c+=r}return i}}const{GLTFLoader:ae}=a();function oe(t,e){if(t.scenes&&t.scenes.length)for(let n=0,r=t.scenes.length;n<r;n++){const r=t.scenes[n].nodes;for(let n=0,a=r.length;n<a;n++){const a=[];he(r[n],a,t,e)}}}const ie=[],se=[],ce=[],ue=[0,0,0],le=function(t){return t[0]=0,t[1]=0,t[2]=0,t[3]=1,t}([]),fe=[1,1,1];function he(t,e,n,r){const a=e.slice(0);if(t.matrix)a.push(t.matrix);else if(t.rotation||t.translation||t.scale){const e=function(t,e){return t[0]=1,t[1]=0,t[2]=0,t[3]=0,t[4]=0,t[5]=1,t[6]=0,t[7]=0,t[8]=0,t[9]=0,t[10]=1,t[11]=0,t[12]=e[0],t[13]=e[1],t[14]=e[2],t[15]=1,t}(ie,t.translation||ue),n=function(t,e){var n=e[0],r=e[1],a=e[2],o=e[3],i=n+n,s=r+r,c=a+a,u=n*i,l=r*i,f=r*s,h=a*i,y=a*s,d=a*c,b=o*i,m=o*s,p=o*c;return t[0]=1-f-d,t[1]=l+p,t[2]=h-m,t[3]=0,t[4]=l-p,t[5]=1-u-d,t[6]=y+b,t[7]=0,t[8]=h+m,t[9]=y-b,t[10]=1-u-f,t[11]=0,t[12]=0,t[13]=0,t[14]=0,t[15]=1,t}(se,t.rotation||le),r=function(t,e){return t[0]=e[0],t[1]=0,t[2]=0,t[3]=0,t[4]=0,t[5]=e[1],t[6]=0,t[7]=0,t[8]=0,t[9]=0,t[10]=e[2],t[11]=0,t[12]=0,t[13]=0,t[14]=0,t[15]=1,t}(ce,t.scale||fe);s(r,n,r);const o=s([],e,r);a.push(o)}if(t.children&&t.children.length)for(let e=0,o=t.children.length;e<o;e++)he(t.children[e],a,n,r);if(void 0!==t.mesh){const e=t.mesh,o=n.meshes[e];if(o){const t=a.slice(0),i=o.primitives;for(let a=0,o=i.length;a<o;a++){const o=i[a];o&&(o.matrices=t,r(o,e,a,n))}}}}function ye(t,e){let{byteOffset:n,byteStride:r,count:a}=t;const{componentType:o,itemSize:i}=t,s=t.array.buffer,c=o?ae.getTypedArrayCtor(o):t.array.constructor;if(n=void 0===n?t.array.byteOffset:n,r=r||0,a=a||t.array.length/i,(!r||r===i*c.BYTES_PER_ELEMENT)&&n%c.BYTES_PER_ELEMENT==0){const t=new c(s,n,a*i);for(let r=0;r<a*i;r+=i){e(new c(t.buffer,n+r*c.BYTES_PER_ELEMENT,i),r/i)}return}const u=new Uint8Array(i*c.BYTES_PER_ELEMENT);r||(r=i*c.BYTES_PER_ELEMENT);for(let t=0;t<a;t++){const a=new Uint8Array(s,r*t+n,i*c.BYTES_PER_ELEMENT);u.set(a);e(new c(u.buffer),t),a.set(u)}}var de=ge("DXT1"),be=ge("DXT3"),me=ge("DXT5"),pe=ge("DX10");function ge(t){return t.charCodeAt(0)+(t.charCodeAt(1)<<8)+(t.charCodeAt(2)<<16)+(t.charCodeAt(3)<<24)}var ve=A((function(t){var e,n,r=new Int32Array(t,0,31);if(542327876!==r[0])throw new Error("Invalid magic number in DDS header");if(4&!r[20])throw new Error("Unsupported format, must contain a FourCC code");var a=r[21];switch(a){case de:e=8,n="dxt1";break;case be:e=16,n="dxt3";break;case me:e=16,n="dxt5";break;case 116:n="rgba32f";break;case pe:var o=new Uint32Array(t.slice(128,148));n=o[0];var i=o[1];if(o[2],o[3],o[4],3!==i||2!==n)throw new Error("Unsupported DX10 texture format "+n);n="rgba32f";break;default:throw new Error("Unsupported FourCC code: "+(s=a,String.fromCharCode(255&s,s>>8&255,s>>16&255,s>>24&255)))}var s;var c=r[2],u=1;131072&c&&(u=Math.max(1,r[7]));var l=!1;512&r[28]&&(l=!0);var f,h=r[4],y=r[3],d=r[1]+4,b=h,m=y,p=[];a===pe&&(d+=20);if(l)for(var g=0;g<6;g++){if("rgba32f"!==n)throw new Error("Only RGBA32f cubemaps are supported");h=b,y=m;for(var v=Math.log(h)/Math.log(2)+1,w=0;w<v;w++)f=h*y*16,p.push({offset:d,length:f,shape:[h,y]}),w<u&&(d+=f),h=Math.floor(h/2),y=Math.floor(y/2)}else for(w=0;w<u;w++)f=Math.max(4,h)/4*Math.max(4,y)/4*e,p.push({offset:d,length:f,shape:[h,y]}),d+=f,h=Math.floor(h/2),y=Math.floor(y/2);return{shape:[b,m],images:p,format:n,flags:c,cubemap:l}})),we=Math.abs,Me=Math.sin,Te=Math.cos,Ae=Math.tan,ke=Math.atan,_e=Math.atan2,Oe=Math.sqrt,Se=Math.log,xe=Math.hypot,Fe=Math.sinh,Ie=Math.cosh,Ce=1/0;function Ee(t){var e,n,r,a,o,i,s=[],c=[],u=[],l=[];function f(t,e){for(var n,r=2*Te(2*e),a=t.length-1,o=t[a],i=0;--a>=0;)n=r*o-i+t[a],i=o,o=n;return e+n*Me(2*e)}function h(t,e,n){for(var r,a,o=Me(e),i=Te(e),s=Fe(n),c=Ie(n),u=2*i*c,l=-2*o*s,f=t.length-1,h=t[f],y=0,d=0,b=0;--f>=0;)r=d,a=y,h=u*(d=h)-r-l*(y=b)+t[f],b=l*d-a+u*y;return[(u=o*c)*h-(l=i*s)*b,u*b+l*h]}t.es,o=a=(r=t.es/(1+Oe(1-t.es)))/(2-r),s[0]=a*(2+a*(-2/3+a*(a*(116/45+a*(26/45+a*(-2854/675)))-2))),c[0]=a*(a*(2/3+a*(4/3+a*(-82/45+a*(32/45+a*(4642/4725)))))-2),o*=a,s[1]=o*(7/3+a*(a*(-227/45+a*(2704/315+a*(2323/945)))-1.6)),c[1]=o*(5/3+a*(-16/15+a*(-13/9+a*(904/315+a*(-1522/945))))),o*=a,s[2]=o*(56/15+a*(-136/35+a*(-1262/105+a*(73814/2835)))),c[2]=o*(-26/15+a*(34/21+a*(1.6+a*(-12686/2835)))),o*=a,s[3]=o*(4279/630+a*(-332/35+a*(-399572/14175))),c[3]=o*(1237/630+a*(a*(-24832/14175)-2.4)),o*=a,s[4]=o*(4174/315+a*(-144838/6237)),c[4]=o*(-734/315+a*(109598/31185)),o*=a,s[5]=o*(601676/22275),c[5]=o*(444337/155925),o=a*a,e=t.k0/(1+a)*(1+o*(1/4+o*(1/64+o/256))),u[0]=a*(a*(2/3+a*(-37/96+a*(1/360+a*(81/512+a*(-96199/604800)))))-.5),l[0]=a*(.5+a*(-2/3+a*(5/16+a*(41/180+a*(-127/288+a*(7891/37800)))))),u[1]=o*(-1/48+a*(-1/15+a*(437/1440+a*(-46/105+a*(1118711/3870720))))),l[1]=o*(13/48+a*(a*(557/1440+a*(281/630+a*(-1983433/1935360)))-.6)),o*=a,u[2]=o*(-17/480+a*(37/840+a*(209/4480+a*(-5569/90720)))),l[2]=o*(61/240+a*(-103/140+a*(15061/26880+a*(167603/181440)))),o*=a,u[3]=o*(-4397/161280+a*(11/504+a*(830251/7257600))),l[3]=o*(49561/161280+a*(-179/168+a*(6601661/7257600))),o*=a,u[4]=o*(-4583/161280+a*(108847/3991680)),l[4]=o*(34729/80640+a*(-3418889/1995840)),o*=a,u[5]=o*(-20648693/638668800),l[5]=.6650675310896665*o,i=f(c,t.phi0),n=-e*(i+function(t,e){var n,r=2*Te(e),a=t.length-1,o=t[a],i=0;for(;--a>=0;)n=r*o-i+t[a],i=o,o=n;return Me(e)*n}(l,2*i)),t.fwd=function(t,r){var a,o,i,s,u,y=t.phi,d=t.lam;y=f(c,y),a=Me(y),o=Te(y),s=Me(d),i=Te(d),y=_e(a,i*o),d=_e(s*o,xe(a,o*i)),d=function(t){var e=we(t);return e=function(t){var e=1+t,n=e-1;return 0===n?t:t*Se(e)/n}(e*(1+e/(xe(1,e)+1))),t<0?-e:e}(Ae(d)),u=h(l,2*y,2*d),y+=u[0],d+=u[1],we(d)<=2.623395162778?(r.y=e*y+n,r.x=e*d):r.x=r.y=Ce},t.inv=function(t,r){var a,o,i,c,l,y=t.y,d=t.x;y=(y-n)/e,we(d/=e)<=2.623395162778?(y+=(l=h(u,2*y,2*d))[0],d+=l[1],d=ke(Fe(d)),a=Me(y),o=Te(y),c=Me(d),i=Te(d),d=_e(c,i*o),y=_e(a*i,xe(c,i*o)),r.phi=f(s,y),r.lam=d):r.phi=r.lam=Ce}}const Ue=Math.PI/180,Ne=6378137*Math.PI/180,ze=85.0511287798,Le={};function je(t,e,n,r){if("EPSG:3857"===n)return function(t,e){const n=ze,r=e[0],a=Math.max(Math.min(n,e[1]),-n);let o;o=0===a?0:Math.log(Math.tan((90+a)*Ue/2))/Ue;return t[0]=r*Ne,t[1]=o*Ne,t}(t,e);if(!n||"EPSG:9807"!==n.code&&"Traverse_Mercator"!==n.code){if("EPSG:4326"===n||"EPSG:4490"===n||"identity"===n)return De(t,e);if("baidu"===n)return De(t,e);throw new Error("unsupported projection:"+n)}{if(!(!r||4326===r.wkid))return function(t,e){return t[0]=e[0],t[1]=e[1],t}(t,e);const a=JSON.stringify(n);let o=Le[a];return o||(o=Le[a]=function(t){const e={a:Be,es:qe,x0:ht(t.falseEasting)?5e5:t.falseEasting,y0:ht(t.falseNorthing)?0:t.falseNorthing,k0:t.scaleFactor||.9996,lam0:(t.centralMeridian||0)*Pe,phi0:(t.latitudeOfOrigin||0)*Pe,originLam0:t.startLongtitude||0,originPhi0:t.startLatitude||0};Ee(e);const n={lam:0,phi:0},r={};let a=0,o=0;(e.originLam0||e.originPhi0)&&(n.lam=e.originLam0*Pe-e.lam0,n.phi=e.originPhi0*Pe,e.fwd(n,r),a=e.a*r.x+e.x0,o=e.a*r.y+e.y0);return{project:function(t,i){n.lam=t[0]*Pe-e.lam0,n.phi=t[1]*Pe,e.fwd(n,r);const s=e.a*r.x+e.x0-a,c=e.a*r.y+e.y0-o;return i[0]=s,i[1]=c,i}}}(n)),o.project(e,t)}}function De(t,e){return t[0]=e[0],t[1]=e[1],t}const Pe=.017453292519943295,Be=6378137,qe=.0066943799901413165;const{Ajax:Re}=a(),Ve=i([]),Ge=Rt().draco,$e=Rt().ktx2,Xe={"pbrMetallicRoughness":{"baseColorFactor":[.5,.5,.5,1],"metallicFactor":0,"roughnessFactor":.5}},He={"position":{name:"POSITION",accessor:{"componentType":5126,"type":"VEC3"}},"normal":{name:"NORMAL",accessor:{"componentType":5126,"type":"VEC3"}},"uv0":{name:"TEXCOORD_0",accessor:{"componentType":5126,"type":"VEC2"}},"color":{name:"COLOR_0",accessor:{"componentType":5121,"type":"VEC4"}},"uv-region":{name:"uvRegion",accessor:{"componentType":5123,"type":"VEC4"}},"feature-index":{name:"_BATCHID",accessor:{"componentType":5125,"type":"SCALAR"}},"faceRange":{name:"faceRange",accessor:{"componentType":5125,"type":"VEC2"}}};function Je(t,e,n,r,a,o){const s=[],c=[],u=[];for(let e=0;e<t.meshes.length;e++){const{geometry:n,material:r}=t.meshes[e],a=Re.getArrayBuffer(n.url,o);a.xhr.url=n.url,u.push(a.xhr);const i=a.then((t=>({buffer:t})));s.push(i);const l=[];if(nn(r,l),l.length){const t=l.map((t=>{const e=Re.getArrayBuffer(t.url,o);return e.xhr.url=t.url,u.push(e.xhr),e.then((e=>e&&e.status?null:{buffer:e,mimeType:t.mimeType,format:t.format}))}));s.push(...t)}c[e]=l.length}const l=Promise.all(s).then((o=>{for(let t=0;t<o.length;t++)if(!o[t]||!o[t].buffer)return Promise.resolve(null);const s=[];let u=0;for(let t=0;t<c.length;t++){const e=c[t];s.push({geoBuffer:{data:o[u].buffer.data},textureBuffers:o.slice(u+1,e+u+1).map((t=>({data:t.buffer.data,mimeType:t.mimeType,format:t.format})))}),u+=1+e}const l=function(t,e,n,r,a,o){const s={asset:{generator:"i3s",version:"2.0"},extensions:{},scene:0,scenes:[{nodes:[]}],nodes:{},meshes:{},materials:[],skins:[],animations:null,textures:[],transferables:[]},c=[];for(let u=0;u<t.meshes.length;u++){let{material:l}=t.meshes[u];const{geometry:f}=t.meshes[u];let h;const y=e[u].geoBuffer.data;if(!y)continue;h=un(y)?Ke(s,u,f,y,t.transform,t.center,a,o):Ze(s,u,f,y,t.transform,t.center,a,o),c.push(h),s.nodes[u]={mesh:u,nodeIndex:u,matrix:i([])},s.scenes[0].nodes[u]=s.nodes[u],l||(l=Xe);const d=tn(u,s,l,e[u].textureBuffers,n,r);c.push(d)}return Promise.all(c).then((()=>({gltf:s,featureTable:{BATCH_LENGTH:0},transferables:s.transferables})))}(t,s,e,a,n,r);return l}));return l.xhr=u,l}const Ye={"magFilter":9728,"minFilter":9728,"wrapR":33071,"wrapS":33071,"wrapT":33071};function Ke(t,e,n,r,a,o,i,s){const c=n.info.compressedAttributes.attributes.reduce(((t,e,n)=>{const r=He[e];if(!r)return t;return t[r.name||e]=n,t}),{});return Ge(r,{attributes:c,metadatas:{"POSITION":[{name:"i3s-scale_x",type:"double"},{name:"i3s-scale_y",type:"double"}]},useUniqueIDs:!1,skipAttributeTransform:!1}).then((n=>We(n,t,e,a,o,i,s)))}const Qe={position:function(t,e,n){const r=3*t.vertexCount,a=new Float32Array(e,n,r);return t.position={array:a,componentType:5126,itemSize:3,count:r/3,meta:{"i3s-scale_x":1,"i3s-scale_y":1},type:"VEC3"},n+=4*r},normal:function(t,e,n){const r=3*t.vertexCount,a=new Float32Array(e,n,r);return t.normal={array:a,componentType:5126,itemSize:3,count:r/3,type:"VEC3"},n+=4*r},uv0:function(t,e,n){const r=2*t.vertexCount,a=new Float32Array(e,n,r);return t.uv0={array:a,componentType:5126,itemSize:2,count:r/2,type:"VEC2"},n+=4*r},color:function(t,e,n){const r=4*t.vertexCount,a=new Uint8Array(e,n,r);return t.color={array:a,componentType:5121,itemSize:4,count:r/4,type:"VEC4"},n+=r},featureId:function(t,e,n){return n+=8*t.featureCount},id:function(t,e,n){return n+=8*t.featureCount},faceRange:function(t,e,n){const r=2*t.featureCount,a=new Uint32Array(e,n,r);return t.faceRange={array:a,componentType:5125,itemSize:2,count:r/2,type:"VEC2"},n+=4*r},uvRegion:function(t,e,n){const r=4*t.vertexCount,a=new Uint16Array(e,n,r);return t["uv-region"]={array:a,componentType:5123,itemSize:4,count:r/4,type:"VEC4"},n+=2*r},region:function(t,e,n){const r=4*t.vertexCount,a=new Uint16Array(e,n,r);return t["uv-region"]={array:a,componentType:5123,itemSize:4,count:r/4,type:"VEC4"},n+=2*r}};function Ze(t,e,n,r,a,o,i,s){const c={vertexCount:0},u=new DataView(r);try{let t=0;c.vertexCount=u.getUint32(t,1),t+=4,c.featureCount=u.getUint32(t,1),t+=4;const e=n.info.ordering?null:n.info;if(e){const n=[];for(const t in e)"offset"!==t&&""!==t&&n.push(t);for(let e=0;e<n.length;e++)Qe[n[e]]?t=Qe[n[e]](c,r,t):console.error("Unknown decoder for",n[e])}else{const e=n.info;let a=e.ordering,o=e.featureAttributeOrder;const i=null;i&&i.geometryData&&i.geometryData[0]&&i.geometryData[0].params;for(let e=0;e<a.length;e++){const n=Qe[a[e]];n||console.log(a[e]),t=n(c,r,t)}for(let e=0;e<o.length;e++){const n=Qe[o[e]];n||console.log(o[e]),t=n(c,r,t)}}}catch(t){}c.scale_x=1,c.scale_y=1;const l={};for(const t in c){const e=He[t]&&He[t].name;e&&(l[e]=c[t])}if(c.faceRange){const t=c.faceRange.array,e=t.length/2,n=(f=e)<=255?Uint8Array:f<=65535?Uint16Array:Uint32Array,r=new n(l.POSITION.array.length/3);for(let e=0;e<t.length-1;e+=2){const n=e/2,a=t[e],o=t[e+1];for(let t=a;t<=o;t++)r[3*t]=n,r[3*t+1]=n,r[3*t+2]=n}l._BATCHID={componentType:Bt(n),array:r,itemSize:1,count:r.length,type:"SCALAR"}}var f;return We({attributes:l},t,e,a,o,i,s)}function We(t,e,n,r,a,o,i){const s={attributes:t.attributes,material:n,indices:t.indices,mode:4};!function(t){const e=t.array,n=t.meta&&t.meta["i3s-scale_x"],r=t.meta&&t.meta["i3s-scale_y"];if(n&&r&&(1!==n||1!==r))for(let t=0;t<e.length;t+=3)e[t]*=n.value,e[t+1]*=r.value}(t.attributes.POSITION);const u=function(t,e,n,r,a){let o,i=[0,0,0,1];const s=[0,0],u=je([],n,r,a);u[2]=n[2];const l=e&&c(Ve,e);return ye(t,(t=>(i[0]=t[0],i[1]=t[1],i[2]=t[2],l||(i=p(i,i,e)),n&&d(i,i,n),je(s,i,r,a),o=i[2],t[0]=s[0]-u[0],t[1]=s[1]-u[1],t[2]=o-u[2],t))),u}(t.attributes.POSITION,r,a,o,i);e.meshes[n]={primitives:[s],index:n},e.extensions.MAPTALKS_RTC={projCenter:u},e.extensions.CESIUM_RTC={rtcCoord:a};for(const n in t.attributes)cn(e.transferables,t.attributes[n].array.buffer);return t.indices&&cn(e.transferables,t.indices.array.buffer),s}function tn(t,e,n,r,a,o){const i=r.map((t=>function(t,e,n,r,a){if("dds"===e){const e=ve(t),r=e.images.map((e=>new Uint8Array(t,e.offset,e.length))),a="dxt1"===e.format?33777:33779;return Promise.resolve({image:{mipmap:r,width:e.shape[0],height:e.shape[1],mimeType:n},sampler:Ye,format:a})}if("png"===e||"jpg"===e)return function(t,e){rn||(rn=new OffscreenCanvas(2,2),an=rn.getContext("2d",{willReadFrequently:!0}));const n=new Blob([new Uint8Array(t)]);return createImageBitmap(n).then((t=>{let{width:n,height:r}=t;on(n)||(n=sn(n)),on(r)||(r=sn(r));const a=e;a&&(n=Math.min(a,n),r=Math.min(a,r)),rn.width=n,rn.height=r,an.drawImage(t,0,0,n,r),t.close();const o=an.getImageData(0,0,n,r);return{width:n,height:r,array:new Uint8Array(o.data)}})).catch((()=>({width:2,height:2,array:new Uint8Array(4)})))}(t,a).then((t=>{t.mimeType=n;return{image:t,sampler:Ye,format:6408}}));if("ktx2"===e)return $e(t,r).then((t=>(t.mimeType=n,{image:t,sampler:Ye,format:t.format})));return null}(t.data,t.format,t.mimeType,a,o).then((t=>{if(t.image)if(t.image.array)cn(e.transferables,t.image.array.buffer);else if(t.image.mipmap)for(let n=0;n<t.image.mipmap.length;n++)cn(e.transferables,t.image.mipmap[n].buffer);return t}))));return Promise.all(i).then((r=>{en(t,e,n,r)}))}function en(t,e,n,r){const a=JSON.parse(JSON.stringify(n)),o=e.textures;r.ptr||(r.ptr=0);for(const t in n)n[t]&&n[t].url?(o.push(r[r.ptr++]),a[t]={index:o.length-1},void 0!==n[t].factor&&(a[t].scale=n[t].factor)):yt(n[t])&&(a[t]=en(-1,e,n[t],r));return t>=0&&(e.materials[t]=a),a}function nn(t,e){for(const n in t)t[n]&&t[n].url?e.push({url:t[n].url,mimeType:t[n].mimeType,format:t[n].format}):yt(t[n])&&nn(t[n],e)}let rn,an;function on(t){return!(t&t-1)&&0!==t}function sn(t){return Math.pow(2,Math.floor(Math.log(t)/Math.LN2))}function cn(t,e){e&&(t.indexOf(e)>=0||t.push(e))}function un(t){const e=new Uint8Array(t,0,5);return e[0]==="D".charCodeAt()&&e[1]==="R".charCodeAt()&&e[2]==="A".charCodeAt()&&e[3]==="C".charCodeAt()&&e[4]==="O".charCodeAt()}var ln="undefined"!=typeof Float32Array?Float32Array:Array;function fn(t,e,n,r){return t[0]=e,t[1]=n,t[2]=r,t}var hn=function(t,e,n){return t[0]=e[0]-n[0],t[1]=e[1]-n[1],t[2]=e[2]-n[2],t};!function(){var t=function(){var t=new ln(3);return ln!=Float32Array&&(t[0]=0,t[1]=0,t[2]=0),t}()}();const yn=[];const dn=[],bn=[],mn=[],pn=[],gn=[],vn=[],wn=[];function Mn(t,e,n,r,a,o){fn(pn,t[3*e],t[3*e+1],t[3*e+2]),fn(gn,t[3*n],t[3*n+1],t[3*n+2]),fn(vn,t[3*r],t[3*r+1],t[3*r+2]);const i=hn(dn,vn,gn),s=hn(bn,pn,gn),c=function(t,e,n){var r=e[0],a=e[1],o=e[2],i=n[0],s=n[1],c=n[2];return t[0]=a*c-o*s,t[1]=o*i-r*c,t[2]=r*s-a*i,t}(mn,i,s);!function(t,e){var n=e[0],r=e[1],a=e[2],o=n*n+r*r+a*a;o>0&&(o=1/Math.sqrt(o),t[0]=e[0]*o,t[1]=e[1]*o,t[2]=e[2]*o)}(wn,c),a[3*e]=a[3*e]||0,a[3*n]=a[3*n]||0,a[3*r]=a[3*r]||0,a[3*e+1]=a[3*e+1]||0,a[3*n+1]=a[3*n+1]||0,a[3*r+1]=a[3*r+1]||0,a[3*e+2]=a[3*e+2]||0,a[3*n+2]=a[3*n+2]||0,a[3*r+2]=a[3*r+2]||0,a[3*e]+=wn[0],a[3*n]+=wn[0],a[3*r]+=wn[0],a[3*e+1]+=wn[1],a[3*n+1]+=wn[1],a[3*r+1]+=wn[1],a[3*e+2]+=wn[2],a[3*n+2]+=wn[2],a[3*r+2]+=wn[2],o[e]+=1,o[n]+=1,o[r]+=1}const{Ajax:Tn,GLTFLoader:An}=a(),kn=[1,0,0,0,0,0,1,0,0,-1,0,0,0,0,0,1],_n=[0,0,1,0,0,1,0,0,-1,0,0,0,0,0,0,1],On=2*Math.PI*6378137/360,Sn="undefined"!=typeof TextDecoder?new TextDecoder("utf-8"):null;let xn,Fn,In=!1;if("undefined"!=typeof OffscreenCanvas){try{Fn=new OffscreenCanvas(2,2).getContext("2d",{willReadFrequently:!0})}catch(t){}Fn&&"undefined"!=typeof createImageBitmap&&(In=!0)}const Cn=i([]),En=[0,0,0],Un=[],Nn=[],zn=[],Ln=[],jn={"POSITION":1,"TEXCOORD_0":1,"TEXCOORD_1":1,"NORMAL":1,"TANGENT":1},Dn={"TEXCOORD_0":1e-4,"TEXCOORD_1":1e-4};let Pn;class Bn{constructor(t,e,n,r){this.id=t,this.options=e,this.U=(...t)=>this.requestImage.call(this,...t),this.N=n,this.L={},r(null,{},[])}j(t){this.D||(this.u=t,this.P=new Wt,this.D=new $t(this.U,An,t),this.B=new Jt(this.U,An,t))}requestImage(t,e){In?fetch(t).then((t=>t.arrayBuffer())).then((t=>{const e=new self.Blob([new Uint8Array(t)]);return createImageBitmap(e)})).then((t=>{xn.width=t.width,xn.height=t.height,Fn.drawImage(t,0,0);const n=Fn.getImageData(0,0,xn.width,xn.height);t.close(),e(null,{width:t.width,height:t.height,data:new Uint8Array(n.data)})})):this.N("requestImage",{url:t},null,e)}loadTile(t,e){this.j(t.supportedFormats);const{service:n,url:r,arraybuffer:a}=t,o=n.fetchOptions||{};if(o.referrer=t.referrer,o.referrerPolicy=o.referrerPolicy||"origin",function(t){return t.indexOf("i3s:")>=0}(r)){const a=t.i3sInfo,i=n.maxTextureSize||0,s=Je(a,t.supportedFormats,this.options.projection,t.projection,i,o);return s.then((t=>{if(delete this.L[r],!t)return void e({status:404,url:r,i3sInfo:a});if(!Object.keys(t.gltf.meshes).length)return void e({status:404,url:r,i3sInfo:a});t.gltf.url=r;const{transferables:o}=t;t.magic="b3dm",n.createNormalIfMissed&&this.q(t.gltf),Yn(n)&&this.R(t.gltf),e(null,t,o)})),void(this.L[r]=s.xhr)}if(a){delete this.L[r];const n=St(new DataView(a),0);if("{"===n[0]||" "===n[0]||"<"===n[0]){const n=function(t,e,n){if(Sn){const r=new Uint8Array(t,e,n);return Sn.decode(r)}return mt(new Uint8Array(t,e,n))}(a,0,a.byteLength),o=JSON.parse(n);o.accessors?this.V(o,r,t,"gltf",e):this.G(t.rootIdx,o,a,r,e)}else this.V(a,r,t,n,e)}else{let a=n.urlParams;a&&(a=(r.indexOf("?")>0?"&":"?")+a);const i=r.replace(/\\+/g,"%2B");let s=Tn.getArrayBuffer(i+(a||""),o);const c=s.xhr;s=s.then((n=>{delete this.L[r],n&&n.status?e(n):(t.arraybuffer=n&&n.data,this.loadTile(t,e))})).catch((t=>{delete this.L[r],e(t)})),this.L[r]=c}}V(t,e,n,r,a){r=r&&r.toLowerCase();const{service:o}=n;if("b3dm"===r){this.D.load(e,t,0,0,{maxTextureSize:o.maxTextureSize||0}).then((t=>{if(t.error)return void a(t);const{content:e,transferables:r}=this.$(t,n);o.createNormalIfMissed&&this.q(e.gltf),Yn(o)&&this.R(e.gltf),a(null,e,r)})).catch((t=>{a(t)}))}else if("pnts"===r){const r=n.transform||Cn;this.P.load(e,t).then((t=>{const{content:e,transferables:o}=this.X(t,r,n.rootIdx);this.H(e),a(null,e,o)}))}else if("i3dm"===r){const r=n.transform||Cn;this.B.load(e,t,0,0,{maxTextureSize:o.maxTextureSize||0}).then((t=>{const{content:e,transferables:i}=this.J(t,r,n.rootIdx);o.createNormalIfMissed&&this.q(e.gltf),Yn(o)&&this.R(e.gltf),a(null,e,i)}))}else if("cmpt"===r){new re(this.U,An,this.u,o.maxTextureSize||0).load(e,t,0,0,{maxTextureSize:o.maxTextureSize||0}).then((t=>{const{content:e,transferables:r}=this.Y(t,n);this.K(e,o),Yn(o)&&this.Z(e),a(null,e,r)})).catch((t=>{a(t)}))}else if("gltf"===r){this.h||(this.h=Rt());const r=e.substring(0,e.lastIndexOf("/")),i=t instanceof ArrayBuffer&&{buffer:t,byteOffset:0,byteLength:t.byteLength}||t;let s;try{s=new An(r,i,{transferable:!0,requestImage:this.U,decoders:this.h,supportedFormats:this.u,maxTextureSize:o.maxTextureSize||0})}catch(t){a(t)}s.load({skipAttributeTransform:!1}).then((t=>{t.url=e,this.W(t,null,n),o.createNormalIfMissed&&this.q(t),Yn(o)&&this.R(t),a(null,{magic:"gltf",gltf:t},s.transferables)}))}else a(new Error("unsupported tile format: "+r))}K(t,e){t.content?t.content.forEach((t=>{this.K(t,e)})):e.createNormalIfMissed&&this.q(t.gltf)}Z(t){t.content?t.content.forEach((t=>{this.Z(t)})):this.R(t.gltf)}tt(t,e){if(this.et(t,e)&&!t.attributes.NORMAL){const e=t.attributes.POSITION.array,n=e.length,r=this.nt()?Pn.subarray(0,n):e,a=function(t,e,n){const r=n||[];r.setLength&&r.setLength(t.length);const a=yn;a.length<t.length/3&&(a.length=t.length/3),a.fill(0,0,t.length/3);const o=void 0===e.length?e:e.length;for(let n=0;n<o/3;n++)void 0===e.length?Mn(t,3*n,3*n+1,3*n+2,r,a):Mn(t,e[3*n],e[3*n+1],e[3*n+2],r,a);for(let t=0;t<r.length;t+=3){const e=a[t/3];0!==e?(r[t]/=e,r[t+1]/=e,r[t+2]/=e):(r[t]=0,r[t+1]=0,r[t+2]=0)}return r}(r,t.indices.array,new Float32Array(r.length));t.attributes.NORMAL={array:a,byteLength:a.byteLength,byteOffset:0,byteStride:0,componentType:5126,count:a.length/3,itemSize:3,name:"NORMAL",type:"VEC3"}}}R(t){if(!t||!t.meshes||t.extensionsUsed&&t.extensionsUsed.indexOf("KHR_techniques_webgl")>-1)return;if(t.asset&&t.asset.sharePosition)return;const e=t.meshes;for(const t in e){e[t].primitives.forEach((t=>{t.compressed_int16_params={};const e=t.attributes;for(const n in e)if(jn[n]&&e[n].array&&e[n].array instanceof Float32Array){let r=1;this.nt()&&"POSITION"===n&&(r=On,t.compressed_int16_params.compressed_ratio=r);const a=Xn(e[n].array,r,e[n].min,e[n].max,n);if(!a)continue;const{array:o,range:i}=a;e[n].componentType=5124,e[n].array=o,t.compressed_int16_params[n]=i}}))}}q(t){if(!t||!t.meshes||t.extensionsUsed&&t.extensionsUsed.indexOf("KHR_techniques_webgl")>-1)return;if(t.asset&&t.asset.sharePosition)return;const e=t.meshes;for(const n in e){e[n].primitives.forEach((e=>{this.tt(e,t)}))}}H(t){if(!t||!t.pnts)return;const e=t.pnts;t.compressed_int16_params={};for(const n in e)if(jn[n]&&e[n].array&&e[n].array instanceof Float32Array){let r=1;this.nt()&&"POSITION"===n&&(r=On,t.compressed_int16_params.compressed_ratio=r);const{array:a,range:o}=Xn(e[n].array,r,e[n].min,e[n].max,n);e[n].array=a,t.compressed_int16_params[n]=o}}rt(t){const e=[];for(let n=0;n<t.length;n++){const r=t[n];if(!r.childTile)continue;const a={boundingVolume:{sphere:[r.boundingSphere.center.x,r.boundingSphere.center.y,r.boundingSphere.center.z,r.boundingSphere.radius]},content:{uri:r.childTile},geometricError:r.boundingSphere.radius/r.rangeList*16,refine:"REPLACE"};e.push(a)}return e}G(t,e,n,r,a){return e.capabilities,void a(null,e)}Y(t,e){const{tiles:n}=t,r={magic:"cmpt",content:[]},a=[];for(let t=0;t<n.length;t++){const{magic:o}=n[t];if("b3dm"===o){const{content:o,transferables:i}=this.$(n[t],e);Gn(a,i),r.content.push(o)}else if("i3dm"===o){const{transform:o,rootIdx:i}=e,{content:s,transferables:c}=this.J(n[t],o,i);Gn(a,c),r.content.push(s)}else if("pnts"===o){const{transform:o,rootIdx:i}=e,{content:s,transferables:c}=this.X(n[t],o,i);Gn(a,c),r.content.push(s)}else if("cmpt"===o){const{content:o,transferables:i}=this.Y(n[t],e);Gn(a,i),r.content.push(o)}}return{content:r,transferables:a}}$(t,e){const{gltf:n,transferables:r,featureTable:a}=t;return this.W(n,a,e),delete t.transferables,{content:t,transferables:r}}W(t,e,n){const r=function(t){if(!t||!t.meshes)return!1;if(t.extensions&&t.extensions.KHR_techniques_webgl)return!0;const e="visited";let n=1;const r=[];for(const a in t.meshes){const o=t.meshes[a],{primitives:i}=o;if(i)for(let t=0;t<i.length;t++){const a=i[t].attributes&&i[t].attributes.POSITION;if(!a||!a.array)continue;a.array.buffer[e]||(a.array.buffer[e]=n++);const o=n-1+"-"+(a.byteOffset||0);if(r.indexOf(o)>=0)return!0;r.push(o)}}return!1}(t);this.ot(t);n.service.createNormalIfMissed||this.it(t),t.asset||(t.asset={}),r?(t.asset.sharePosition=!0,this.st(t,e,n.upAxis,n.transform)):this.ct(t,e,n.upAxis,n.transform)}J(t,e,n){const{featureTable:r}=t,a=t.i3dm,o=r&&r.RTC_CENTER||[0,0,0],i=this.options.projection,s=e&&c(Cn,e),u={xmin:1/0,xmax:-1/0,ymin:1/0,ymax:-1/0,hmin:1/0,hmax:-1/0};Rn(a.POSITION.array,3,o,Cn,u);const l=Vn(u);e&&!s&&p(l,l,e);const f=this.ut(l),d=[];je(d,f,i),d[2]=f[2];const b=h([],l),m=[0,0,0],g=[0,0,0],v=[0,0],M=[1/0,1/0,1/0],T=[-1/0,-1/0,-1/0];ye(a.POSITION,(t=>{m[0]=t[0]+o[0],m[1]=t[1]+o[1],m[2]=t[2]+o[2],e&&!s&&p(m,m,e),0===w(m)?y(g,0,0,-6378137):Tt(g,m),je(v,g,i),t[0]=v[0]-d[0],t[1]=v[1]-d[1],t[2]=g[2]-d[2],t[0]<M[0]&&(M[0]=t[0]),t[1]<M[1]&&(M[1]=t[1]),t[2]<M[2]&&(M[2]=t[2]),t[0]>T[0]&&(T[0]=t[0]),t[1]>T[1]&&(T[1]=t[1]),t[2]>T[2]&&(T[2]=t[2])})),a.POSITION.min=M,a.POSITION.max=T,e&&p(l,l,e),t.rtcCenter=b,t.rtcCoord=f,t.projCenter=d,t.rootIdx=n;const A=t.transferables;return delete t.transferables,{content:t,transferables:A}}X(t,e,n){const{featureTable:r}=t,a=t.pnts,o=r&&r.RTC_CENTER||[0,0,0],i=this.options.projection,s=e&&c(Cn,e),u={xmin:1/0,xmax:-1/0,ymin:1/0,ymax:-1/0,hmin:1/0,hmax:-1/0};Rn(a.POSITION.array,3,o,e,u);const l=Vn(u),f=this.lt(l),d=h([],l),b=[1/0,1/0,1/0],m=[-1/0,-1/0,-1/0];let g=[0,0,0,1];const v=[0,0,0],M=[0,0];ye(a.POSITION,(t=>(g[0]=t[0]+o[0],g[1]=t[1]+o[1],g[2]=t[2]+o[2],e&&!s&&(g=p(g,g,e)),0===w(g)?y(v,0,0,-6378137):Tt(v,g),je(M,v,i),t[0]=M[0]-f[0],t[1]=M[1]-f[1],t[2]=v[2]-f[2],t[0]<b[0]&&(b[0]=t[0]),t[1]<b[1]&&(b[1]=t[1]),t[2]<b[2]&&(b[2]=t[2]),t[0]>m[0]&&(m[0]=t[0]),t[1]>m[1]&&(m[1]=t[1]),t[2]>m[2]&&(m[2]=t[2]),t))),a.POSITION.min=b,a.POSITION.max=m,e&&p(l,l,e);const T=this.ut(l);t.rtcCenter=d,t.projCenter=f,t.rtcCoord=T,t.rootIdx=n;const A=t.transferables;return delete t.transferables,{content:t,transferables:A}}ot(t){if(!Array.isArray(t.textures))return;const e=t.textures;for(let t=0;t<e.length;t++){const n=e[t]&&e[t].image&&e[t].image.array;if(n&&n.length){const r=n[0],a=n[1],o=n[2],i=n[3];let s=!0;for(let t=4;t<n.length;t+=4)if(n[t]!==r||n[t+1]!==a||n[t+2]!==o||n[t+3]!==i){s=!1;break}s&&(e[t].image.color=[r/255,a/255,o/255,i/255],delete e[t].image.array)}}}it(t){const e=t.meshes;for(const n in e){const r=e[n];if(!r)continue;const a=r.primitives;if(a)for(let e=0;e<a.length;e++){if(!a[e])continue;if(!a[e].attributes||a[e].attributes.NORMAL)continue;const n=a[e].material;if(!ht(n)){const e=t.materials[n];if(!e)continue;e.extensions||(e.extensions={}),e.extensions.KHR_materials_unlit={}}}}}abortTileLoading(t,e){const n=this.L[t.url];if(Array.isArray(n))for(let t=0;t<n.length;t++)n[t].abort();else n&&n.abort&&n.abort();delete this.L[t.url],e(null)}ft(t,e,n,r){const a=e&&e.RTC_CENTER||t.extensions&&t.extensions.CESIUM_RTC&&t.extensions.CESIUM_RTC.center;let o=kn;"X"===(n=n&&n.toUpperCase())?o=_n:"Z"===n&&(o=Cn),t.extensions=t.extensions||{},t.extensions.CESIUM_RTC||(t.extensions.CESIUM_RTC={}),a&&(t.extensions.CESIUM_RTC.center=a),t.extensions.MAPTALKS_RTC={};const c={xmin:1/0,xmax:-1/0,ymin:1/0,ymax:-1/0,hmin:1/0,hmax:-1/0};oe(t,(t=>{if(!(t.attributes&&t.attributes.POSITION))return;const e=i(Un);t.matrices&&$n(e,t.matrices);const n=t.attributes.POSITION.array,u=t.attributes.POSITION.itemSize;s(e,o,e),r&&s(e,r,e),Rn(n,u,a||En,e,c,t.compressUniforms)}));const u=Vn(c);return{rtcCenter:a,modelCenter:u,upAxisTransform:o}}st(t,e,n,r){const{modelCenter:a,upAxisTransform:o,rtcCenter:c}=this.ft(t,e,n),u=this.lt(a);t.extensions.MAPTALKS_RTC.projCenter=u,t.extensions.MAPTALKS_RTC.rtcCoord=t.extensions.CESIUM_RTC.rtcCoord=this.ut(a);const l=h([],a);r&&p(a,a,r),t.extensions.CESIUM_RTC.rtcCoord=this.ut(a),c||(oe(t,(t=>{if(t.attributes&&t.attributes.POSITION){const e=t.attributes.POSITION;if(e.array.buffer.projected&&e.array.buffer.projected[e.byteOffset])return;const n=i(Un);t.matrices&&$n(n,t.matrices),s(n,o,n);const r=function(t,e){var n=e[0],r=e[1],a=e[2],o=e[3],i=e[4],s=e[5],c=e[6],u=e[7],l=e[8],f=e[9],h=e[10],y=e[11],d=e[12],b=e[13],m=e[14],p=e[15],g=n*s-r*i,v=n*c-a*i,w=n*u-o*i,M=r*c-a*s,T=r*u-o*s,A=a*u-o*c,k=l*b-f*d,_=l*m-h*d,O=l*p-y*d,S=f*m-h*b,x=f*p-y*b,F=h*p-y*m,I=g*F-v*x+w*S+M*O-T*_+A*k;return I?(I=1/I,t[0]=(s*F-c*x+u*S)*I,t[1]=(a*x-r*F-o*S)*I,t[2]=(b*A-m*T+p*M)*I,t[3]=(h*T-f*A-y*M)*I,t[4]=(c*O-i*F-u*_)*I,t[5]=(n*F-a*O+o*_)*I,t[6]=(m*w-d*A-p*v)*I,t[7]=(l*A-h*w+y*v)*I,t[8]=(i*x-s*O+u*k)*I,t[9]=(r*O-n*x-o*k)*I,t[10]=(d*T-b*w+p*g)*I,t[11]=(f*w-l*T-y*g)*I,t[12]=(s*_-i*S-c*k)*I,t[13]=(n*S-r*_+a*k)*I,t[14]=(b*v-d*M-m*g)*I,t[15]=(l*M-f*v+h*g)*I,t):null}(Nn,n),a=[1/0,1/0,1/0],c=[-1/0,-1/0,-1/0];ye(e,(t=>{p(t,t,n),t[0]=t[0]-l[0],t[1]=t[1]-l[1],t[2]=t[2]-l[2],p(t,t,r),t[0]<a[0]&&(a[0]=t[0]),t[1]<a[1]&&(a[1]=t[1]),t[2]<a[2]&&(a[2]=t[2]),t[0]>c[0]&&(c[0]=t[0]),t[1]>c[1]&&(c[1]=t[1]),t[2]>c[2]&&(c[2]=t[2])})),e.min=a,e.max=c,e.array.buffer.projected||(e.array.buffer.projected={}),e.array.buffer.projected[e.byteOffset]=1}})),t.extensions.CESIUM_RTC.center=l)}ct(t,e,n,r){const{modelCenter:a,rtcCenter:o}=this.ft(t,e,n,r),i=this.lt(a);t.extensions.MAPTALKS_RTC.projCenter=i,t.extensions.MAPTALKS_RTC.rtcCoord=t.extensions.CESIUM_RTC.rtcCoord=this.ut(a),oe(t,(e=>{if(e.attributes&&e.attributes.POSITION){const a=this.et(e,t);if(a){const t=e.attributes.POSITION.array.length;(!Pn||Pn.length<t)&&(Pn=new Float32Array(t))}e.attributes.NORMAL&&this.ht(e.attributes.NORMAL,e.matrices,n),e.attributes.TANGENT&&this.ht(e.attributes.TANGENT,e.matrices,n);const{newPositions:i}=this.yt(e.attributes.POSITION,e.matrices,o,t.extensions.MAPTALKS_RTC,n,r,e.compressUniforms,a),{componentType:s}=e.attributes.POSITION;5126!==s&&(e.attributes.POSITION.array=new Float32Array(i))}}));for(const e in t.nodes){t.nodes[e].matrix=Cn}}lt(t){const e=this.options.projection;"identity"===e?h(zn,t):0===w(t)?y(zn,0,0,-6378137):Tt(zn,t),je(Ln,zn,e);const n=zn[2],r=[];return r[0]=Ln[0],r[1]=Ln[1],r[2]=n,r}ht(t,e,n){let r;r="Y"===n?kn:"X"===n?_n:Cn;const a=function(t,e){return t[0]=e[0],t[1]=e[1],t[2]=e[2],t[3]=e[3],t[4]=e[4],t[5]=e[5],t[6]=e[6],t[7]=e[7],t[8]=e[8],t[9]=e[9],t[10]=e[10],t[11]=e[11],t[12]=e[12],t[13]=e[13],t[14]=e[14],t[15]=e[15],t}([],r);if($n(a,e),c(a,Cn))return;const o=function(t,e){return t[0]=e[0],t[1]=e[1],t[2]=e[2],t[3]=e[4],t[4]=e[5],t[5]=e[6],t[6]=e[8],t[7]=e[9],t[8]=e[10],t}([],a),i=[];ye(t,(t=>(function(t,e,n){var r=e[0],a=e[1],o=e[2];t[0]=r*n[0]+a*n[3]+o*n[6],t[1]=r*n[1]+a*n[4]+o*n[7],t[2]=r*n[2]+a*n[5]+o*n[8]}(i,t,o),b(i,i),h(t,i),i)))}yt(t,e,n,r,a,o,s,u){if(t.array.buffer.projected&&t.array.buffer.projected[t.byteOffset])return null;const l=i([]);$n(l,e);const f=this.options.projection;a=a&&a.toUpperCase();const h=n;let b=null;"Y"===a?b=kn:"X"===a&&(b=_n);let m=[0,0,0,1];const g=[0,0,0],v=[0,0],M=r.projCenter,T=je([],r.rtcCoord,"EPSG:3857"),A=o&&c(Cn,o),k=t.min=t.min||[],_=t.max=t.max||[];y(k,1/0,1/0,1/0),y(_,-1/0,-1/0,-1/0);const O=s||{},{decode_position_min:S,decode_position_normConstant:x}=O;let F=[0,0,0,0],I=1;S&&(F=S),x&&(I=x);const C=[];return ye(t,((e,n)=>{if(m[0]=e[0]*I+F[0],m[1]=e[1]*I+F[1],m[2]=e[2]*I+F[2],m=p(m,m,l),b&&(m=p(m,m,b)),h&&d(m,m,h),o&&!A&&(m=p(m,m,o)),0===w(m)?y(g,0,0,-6378137):Tt(g,m),u){const t=Pn;je(v,g,f),t[3*n]=v[0]-T[0],t[3*n+1]=v[0]-T[1],t[3*n+2]=v[0]-T[2]}if(je(v,g,f),e instanceof Float32Array)e[0]=v[0]-M[0],e[1]=v[1]-M[1],e[2]=g[2]-M[2];else{const n=v[0]-M[0],r=v[1]-M[1],a=g[2]-M[2];5126!==t.componentType&&(C.push(n),C.push(r),C.push(a),C.push(e[3]))}return e[0]<k[0]&&(k[0]=e[0]),e[1]<k[1]&&(k[1]=e[1]),e[2]<k[2]&&(k[2]=e[2]),e[0]>_[0]&&(_[0]=e[0]),e[1]>_[1]&&(_[1]=e[1]),e[2]>_[2]&&(_[2]=e[2]),e})),t.array.buffer.projected||(t.array.buffer.projected={}),t.array.buffer.projected[t.byteOffset]=1,{projCenter:M,newPositions:C}}ut(t){return 0===w(t)?y([],0,0,-6378137):Tt([],t)}onRemove(){}nt(){return"EPSG:4326"===this.options.projection||"EPSG:4490"===this.options.projection}et(t,e){if(!t.attributes.POSITION||function(t,e){const n=e.materials[t.material],r=n&&n.extensions&&n.extensions.KHR_materials_unlit;return r}(t,e))return!1;return!t.attributes.TANGENT}}const qn=[];function Rn(t,e,n,r,a,o){const i=o||{},{decode_position_min:s,decode_position_normConstant:c}=i;let u=[0,0,0,0],l=1;s&&(u=s),c&&(l=c);for(let o=0,i=t.length;o<i;o+=e){const{xmin:i,ymin:s,xmax:c,ymax:f,hmin:h,hmax:b}=a;y(qn,t[o]*l+u[0],t[o+1]*l+u[1],t[o+2]*l+u[2]),p(qn,qn,r);const m=d(qn,n,qn);m[0]<i&&(a.xmin=m[0]),m[0]>c&&(a.xmax=m[0]),m[1]<s&&(a.ymin=m[1]),m[1]>f&&(a.ymax=m[1]),e>2&&(m[2]<h&&(a.hmin=m[2]),m[2]>b&&(a.hmax=m[2]))}}function Vn(t){const{xmax:e,ymax:n,xmin:r,ymin:a,hmin:o,hmax:i}=t,s=[(r+e)/2,(a+n)/2,(o+i)/2];return e===-1/0&&(s[0]=0),n===-1/0&&(s[1]=0),i===-1/0&&(s[2]=0),isNaN(s[2])&&(s[2]=0),s}function Gn(t,e){for(let n=0;n<e.length;n++)t.indexOf(e[n])<0&&t.push(e[n])}function $n(t,e){const n=t;for(let t=e.length-1;t>=0;t--)s(n,e[t],n);return n}function Xn(t,e,n,r,a){if(e&&e>1)for(let n=0;n<t.length;n++)(n+1)%3!=0&&(t[n]*=e);let o,i;if(n&&r&&1===e)o=Math.min(...n),i=Math.max(...r);else{const{min:e,max:n}=function(t){let e=1/0,n=-1/0;for(let r=0;r<t.length;r++)t[r]>n&&(n=t[r]),t[r]<e&&(e=t[r]);return{min:e,max:n}}(t);o=e,i=n}return!function(t,e,n,r){for(let a=0;a<t.length;a++){const o=Hn(Jn(t[a],e,n),e,n);if(Math.abs(o-t[a])>Dn[r])return!1}return!0}(t,o,i,a)&&Dn[a]?null:function(t,e,n){const r=new Int16Array(t.length);for(let a=0;a<t.length;a++)r[a]=Jn(t[a],e,n);return{array:r,range:[e,n]}}(t,o,i)}function Hn(t,e,n){return((t>=32768?-(65536-t)/32768:t/32767)+1)*(n-e)/2+e}function Jn(t,e,n){const r=2*(t-e)/(n-e)-1,a=Math.max(-1,Math.min(1,r));return a<0?32768*a:32767*a}function Yn(t){return void 0===t.compressGeometry||t.compressGeometry}let Kn=0;class Qn{constructor(t){this.workerId=t,this.workers={},this.dt={}}addLayer({actorId:t,mapId:e,layerId:n,params:r},a){if(this.bt(e,n))return;const o=this.gt(e,n),i=r.options;this.workers[o]=new Bn(n,i,((...e)=>this.send.call(this,t,...e)),a)}removeLayer({mapId:t,layerId:e},n){const r=this.bt(t,e),a=this.gt(t,e);delete this.workers[a],r&&r.onRemove(n)}loadTile({mapId:t,layerId:e,params:n},r){const a=this.bt(t,e);a&&a.loadTile(n,r)}abortTileLoading({mapId:t,layerId:e,params:n},r){const a=this.bt(t,e);a&&a.abortTileLoading(n,r)}receive(t){const e=t.callback,n=this.dt[e];delete this.dt[e],n&&t.error?n(new Error(t.error)):n&&n(null,t.data)}send(t,e,n,r,a){const o=a?\`${$5671aa7ae64fb35e$var$_}t}-${$5671aa7ae64fb35e$var$_}Kn++}\`:null;a&&(this.dt[o]=a),postMessage({type:"<request>",workerId:this.workerId,actorId:t,command:e,params:n,callback:String(o)},r||[])}gt(t,e){return\`${$5671aa7ae64fb35e$var$_}t}-${$5671aa7ae64fb35e$var$_}e}\`}bt(t,e){const n=this.gt(t,e);return this.workers[n]}}t.initialize=function(){},t.onmessage=function(t,e){const n=t.data;this.dispatcher||(this.dispatcher=new Qn(t.workerId)),"<response>"===t.type?this.dispatcher.workerId===t.workerId&&this.dispatcher.receive(t):this.dispatcher[n.command]({actorId:n.actorId,mapId:n.mapId,layerId:n.layerId,params:n.params},((t,n,r)=>{t&&404!==t.status&&204!==t.status&&console.error(t),t instanceof Error&&(t={message:t.message}),e(t,n,r)}))}}`;
function $5671aa7ae64fb35e$var$O(t) {
    return t && t.t && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var $5671aa7ae64fb35e$var$A = {
    exports: {}
}, $5671aa7ae64fb35e$var$x = {
    exports: {}
}, $5671aa7ae64fb35e$var$I = function(t) {
    return !(!t || "string" == typeof t) && (t instanceof Array || Array.isArray(t) || t.length >= 0 && (t.splice instanceof Function || Object.getOwnPropertyDescriptor(t, t.length - 1) && "String" !== t.constructor.name));
}, $5671aa7ae64fb35e$var$S = Array.prototype.concat, $5671aa7ae64fb35e$var$C = Array.prototype.slice, $5671aa7ae64fb35e$var$k = $5671aa7ae64fb35e$var$x.exports = function(t) {
    for(var e = [], n = 0, r = t.length; n < r; n++){
        var s = t[n];
        $5671aa7ae64fb35e$var$I(s) ? e = $5671aa7ae64fb35e$var$S.call(e, $5671aa7ae64fb35e$var$C.call(s)) : e.push(s);
    }
    return e;
};
$5671aa7ae64fb35e$var$k.wrap = function(t) {
    return function() {
        return t($5671aa7ae64fb35e$var$k(arguments));
    };
};
var $5671aa7ae64fb35e$var$N = $5671aa7ae64fb35e$var$x.exports, $5671aa7ae64fb35e$var$L = {
    "aliceblue": [
        240,
        248,
        255
    ],
    "antiquewhite": [
        250,
        235,
        215
    ],
    "aqua": [
        0,
        255,
        255
    ],
    "aquamarine": [
        127,
        255,
        212
    ],
    "azure": [
        240,
        255,
        255
    ],
    "beige": [
        245,
        245,
        220
    ],
    "bisque": [
        255,
        228,
        196
    ],
    "black": [
        0,
        0,
        0
    ],
    "blanchedalmond": [
        255,
        235,
        205
    ],
    "blue": [
        0,
        0,
        255
    ],
    "blueviolet": [
        138,
        43,
        226
    ],
    "brown": [
        165,
        42,
        42
    ],
    "burlywood": [
        222,
        184,
        135
    ],
    "cadetblue": [
        95,
        158,
        160
    ],
    "chartreuse": [
        127,
        255,
        0
    ],
    "chocolate": [
        210,
        105,
        30
    ],
    "coral": [
        255,
        127,
        80
    ],
    "cornflowerblue": [
        100,
        149,
        237
    ],
    "cornsilk": [
        255,
        248,
        220
    ],
    "crimson": [
        220,
        20,
        60
    ],
    "cyan": [
        0,
        255,
        255
    ],
    "darkblue": [
        0,
        0,
        139
    ],
    "darkcyan": [
        0,
        139,
        139
    ],
    "darkgoldenrod": [
        184,
        134,
        11
    ],
    "darkgray": [
        169,
        169,
        169
    ],
    "darkgreen": [
        0,
        100,
        0
    ],
    "darkgrey": [
        169,
        169,
        169
    ],
    "darkkhaki": [
        189,
        183,
        107
    ],
    "darkmagenta": [
        139,
        0,
        139
    ],
    "darkolivegreen": [
        85,
        107,
        47
    ],
    "darkorange": [
        255,
        140,
        0
    ],
    "darkorchid": [
        153,
        50,
        204
    ],
    "darkred": [
        139,
        0,
        0
    ],
    "darksalmon": [
        233,
        150,
        122
    ],
    "darkseagreen": [
        143,
        188,
        143
    ],
    "darkslateblue": [
        72,
        61,
        139
    ],
    "darkslategray": [
        47,
        79,
        79
    ],
    "darkslategrey": [
        47,
        79,
        79
    ],
    "darkturquoise": [
        0,
        206,
        209
    ],
    "darkviolet": [
        148,
        0,
        211
    ],
    "deeppink": [
        255,
        20,
        147
    ],
    "deepskyblue": [
        0,
        191,
        255
    ],
    "dimgray": [
        105,
        105,
        105
    ],
    "dimgrey": [
        105,
        105,
        105
    ],
    "dodgerblue": [
        30,
        144,
        255
    ],
    "firebrick": [
        178,
        34,
        34
    ],
    "floralwhite": [
        255,
        250,
        240
    ],
    "forestgreen": [
        34,
        139,
        34
    ],
    "fuchsia": [
        255,
        0,
        255
    ],
    "gainsboro": [
        220,
        220,
        220
    ],
    "ghostwhite": [
        248,
        248,
        255
    ],
    "gold": [
        255,
        215,
        0
    ],
    "goldenrod": [
        218,
        165,
        32
    ],
    "gray": [
        128,
        128,
        128
    ],
    "green": [
        0,
        128,
        0
    ],
    "greenyellow": [
        173,
        255,
        47
    ],
    "grey": [
        128,
        128,
        128
    ],
    "honeydew": [
        240,
        255,
        240
    ],
    "hotpink": [
        255,
        105,
        180
    ],
    "indianred": [
        205,
        92,
        92
    ],
    "indigo": [
        75,
        0,
        130
    ],
    "ivory": [
        255,
        255,
        240
    ],
    "khaki": [
        240,
        230,
        140
    ],
    "lavender": [
        230,
        230,
        250
    ],
    "lavenderblush": [
        255,
        240,
        245
    ],
    "lawngreen": [
        124,
        252,
        0
    ],
    "lemonchiffon": [
        255,
        250,
        205
    ],
    "lightblue": [
        173,
        216,
        230
    ],
    "lightcoral": [
        240,
        128,
        128
    ],
    "lightcyan": [
        224,
        255,
        255
    ],
    "lightgoldenrodyellow": [
        250,
        250,
        210
    ],
    "lightgray": [
        211,
        211,
        211
    ],
    "lightgreen": [
        144,
        238,
        144
    ],
    "lightgrey": [
        211,
        211,
        211
    ],
    "lightpink": [
        255,
        182,
        193
    ],
    "lightsalmon": [
        255,
        160,
        122
    ],
    "lightseagreen": [
        32,
        178,
        170
    ],
    "lightskyblue": [
        135,
        206,
        250
    ],
    "lightslategray": [
        119,
        136,
        153
    ],
    "lightslategrey": [
        119,
        136,
        153
    ],
    "lightsteelblue": [
        176,
        196,
        222
    ],
    "lightyellow": [
        255,
        255,
        224
    ],
    "lime": [
        0,
        255,
        0
    ],
    "limegreen": [
        50,
        205,
        50
    ],
    "linen": [
        250,
        240,
        230
    ],
    "magenta": [
        255,
        0,
        255
    ],
    "maroon": [
        128,
        0,
        0
    ],
    "mediumaquamarine": [
        102,
        205,
        170
    ],
    "mediumblue": [
        0,
        0,
        205
    ],
    "mediumorchid": [
        186,
        85,
        211
    ],
    "mediumpurple": [
        147,
        112,
        219
    ],
    "mediumseagreen": [
        60,
        179,
        113
    ],
    "mediumslateblue": [
        123,
        104,
        238
    ],
    "mediumspringgreen": [
        0,
        250,
        154
    ],
    "mediumturquoise": [
        72,
        209,
        204
    ],
    "mediumvioletred": [
        199,
        21,
        133
    ],
    "midnightblue": [
        25,
        25,
        112
    ],
    "mintcream": [
        245,
        255,
        250
    ],
    "mistyrose": [
        255,
        228,
        225
    ],
    "moccasin": [
        255,
        228,
        181
    ],
    "navajowhite": [
        255,
        222,
        173
    ],
    "navy": [
        0,
        0,
        128
    ],
    "oldlace": [
        253,
        245,
        230
    ],
    "olive": [
        128,
        128,
        0
    ],
    "olivedrab": [
        107,
        142,
        35
    ],
    "orange": [
        255,
        165,
        0
    ],
    "orangered": [
        255,
        69,
        0
    ],
    "orchid": [
        218,
        112,
        214
    ],
    "palegoldenrod": [
        238,
        232,
        170
    ],
    "palegreen": [
        152,
        251,
        152
    ],
    "paleturquoise": [
        175,
        238,
        238
    ],
    "palevioletred": [
        219,
        112,
        147
    ],
    "papayawhip": [
        255,
        239,
        213
    ],
    "peachpuff": [
        255,
        218,
        185
    ],
    "peru": [
        205,
        133,
        63
    ],
    "pink": [
        255,
        192,
        203
    ],
    "plum": [
        221,
        160,
        221
    ],
    "powderblue": [
        176,
        224,
        230
    ],
    "purple": [
        128,
        0,
        128
    ],
    "rebeccapurple": [
        102,
        51,
        153
    ],
    "red": [
        255,
        0,
        0
    ],
    "rosybrown": [
        188,
        143,
        143
    ],
    "royalblue": [
        65,
        105,
        225
    ],
    "saddlebrown": [
        139,
        69,
        19
    ],
    "salmon": [
        250,
        128,
        114
    ],
    "sandybrown": [
        244,
        164,
        96
    ],
    "seagreen": [
        46,
        139,
        87
    ],
    "seashell": [
        255,
        245,
        238
    ],
    "sienna": [
        160,
        82,
        45
    ],
    "silver": [
        192,
        192,
        192
    ],
    "skyblue": [
        135,
        206,
        235
    ],
    "slateblue": [
        106,
        90,
        205
    ],
    "slategray": [
        112,
        128,
        144
    ],
    "slategrey": [
        112,
        128,
        144
    ],
    "snow": [
        255,
        250,
        250
    ],
    "springgreen": [
        0,
        255,
        127
    ],
    "steelblue": [
        70,
        130,
        180
    ],
    "tan": [
        210,
        180,
        140
    ],
    "teal": [
        0,
        128,
        128
    ],
    "thistle": [
        216,
        191,
        216
    ],
    "tomato": [
        255,
        99,
        71
    ],
    "turquoise": [
        64,
        224,
        208
    ],
    "violet": [
        238,
        130,
        238
    ],
    "wheat": [
        245,
        222,
        179
    ],
    "white": [
        255,
        255,
        255
    ],
    "whitesmoke": [
        245,
        245,
        245
    ],
    "yellow": [
        255,
        255,
        0
    ],
    "yellowgreen": [
        154,
        205,
        50
    ]
}, $5671aa7ae64fb35e$var$E = $5671aa7ae64fb35e$var$N, $5671aa7ae64fb35e$var$R = Object.hasOwnProperty, $5671aa7ae64fb35e$var$P = Object.create(null);
for(var $5671aa7ae64fb35e$var$U in $5671aa7ae64fb35e$var$L)$5671aa7ae64fb35e$var$R.call($5671aa7ae64fb35e$var$L, $5671aa7ae64fb35e$var$U) && ($5671aa7ae64fb35e$var$P[$5671aa7ae64fb35e$var$L[$5671aa7ae64fb35e$var$U]] = $5671aa7ae64fb35e$var$U);
var $5671aa7ae64fb35e$var$B = $5671aa7ae64fb35e$var$A.exports = {
    to: {},
    get: {}
};
function $5671aa7ae64fb35e$var$G(t, e, n) {
    return Math.min(Math.max(e, t), n);
}
function $5671aa7ae64fb35e$var$D(t) {
    var e = Math.round(t).toString(16).toUpperCase();
    return e.length < 2 ? "0" + e : e;
}
$5671aa7ae64fb35e$var$B.get = function(t) {
    var e, n;
    switch(t.substring(0, 3).toLowerCase()){
        case "hsl":
            e = $5671aa7ae64fb35e$var$B.get.hsl(t), n = "hsl";
            break;
        case "hwb":
            e = $5671aa7ae64fb35e$var$B.get.hwb(t), n = "hwb";
            break;
        default:
            e = $5671aa7ae64fb35e$var$B.get.rgb(t), n = "rgb";
    }
    return e ? {
        model: n,
        value: e
    } : null;
}, $5671aa7ae64fb35e$var$B.get.rgb = function(t) {
    if (!t) return null;
    var e, n, r, s = [
        0,
        0,
        0,
        1
    ];
    if (e = t.match(/^#([a-f0-9]{6})([a-f0-9]{2})?$/i)) {
        for(r = e[2], e = e[1], n = 0; n < 3; n++){
            var i = 2 * n;
            s[n] = parseInt(e.slice(i, i + 2), 16);
        }
        r && (s[3] = parseInt(r, 16) / 255);
    } else if (e = t.match(/^#([a-f0-9]{3,4})$/i)) {
        for(r = (e = e[1])[3], n = 0; n < 3; n++)s[n] = parseInt(e[n] + e[n], 16);
        r && (s[3] = parseInt(r + r, 16) / 255);
    } else if (e = t.match(/^rgba?\(\s*([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/)) {
        for(n = 0; n < 3; n++)s[n] = parseInt(e[n + 1], 0);
        e[4] && (e[5] ? s[3] = .01 * parseFloat(e[4]) : s[3] = parseFloat(e[4]));
    } else {
        if (!(e = t.match(/^rgba?\(\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/))) return (e = t.match(/^(\w+)$/)) ? "transparent" === e[1] ? [
            0,
            0,
            0,
            0
        ] : $5671aa7ae64fb35e$var$R.call($5671aa7ae64fb35e$var$L, e[1]) ? ((s = $5671aa7ae64fb35e$var$L[e[1]])[3] = 1, s) : null : null;
        for(n = 0; n < 3; n++)s[n] = Math.round(2.55 * parseFloat(e[n + 1]));
        e[4] && (e[5] ? s[3] = .01 * parseFloat(e[4]) : s[3] = parseFloat(e[4]));
    }
    for(n = 0; n < 3; n++)s[n] = $5671aa7ae64fb35e$var$G(s[n], 0, 255);
    return s[3] = $5671aa7ae64fb35e$var$G(s[3], 0, 1), s;
}, $5671aa7ae64fb35e$var$B.get.hsl = function(t) {
    if (!t) return null;
    var e = t.match(/^hsla?\(\s*([+-]?(?:\d{0,3}\.)?\d+)(?:deg)?\s*,?\s*([+-]?[\d\.]+)%\s*,?\s*([+-]?[\d\.]+)%\s*(?:[,|\/]\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/);
    if (e) {
        var n = parseFloat(e[4]);
        return [
            (parseFloat(e[1]) % 360 + 360) % 360,
            $5671aa7ae64fb35e$var$G(parseFloat(e[2]), 0, 100),
            $5671aa7ae64fb35e$var$G(parseFloat(e[3]), 0, 100),
            $5671aa7ae64fb35e$var$G(isNaN(n) ? 1 : n, 0, 1)
        ];
    }
    return null;
}, $5671aa7ae64fb35e$var$B.get.hwb = function(t) {
    if (!t) return null;
    var e = t.match(/^hwb\(\s*([+-]?\d{0,3}(?:\.\d+)?)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/);
    if (e) {
        var n = parseFloat(e[4]);
        return [
            (parseFloat(e[1]) % 360 + 360) % 360,
            $5671aa7ae64fb35e$var$G(parseFloat(e[2]), 0, 100),
            $5671aa7ae64fb35e$var$G(parseFloat(e[3]), 0, 100),
            $5671aa7ae64fb35e$var$G(isNaN(n) ? 1 : n, 0, 1)
        ];
    }
    return null;
}, $5671aa7ae64fb35e$var$B.to.hex = function() {
    var t = $5671aa7ae64fb35e$var$E(arguments);
    return "#" + $5671aa7ae64fb35e$var$D(t[0]) + $5671aa7ae64fb35e$var$D(t[1]) + $5671aa7ae64fb35e$var$D(t[2]) + (t[3] < 1 ? $5671aa7ae64fb35e$var$D(Math.round(255 * t[3])) : "");
}, $5671aa7ae64fb35e$var$B.to.rgb = function() {
    var t = $5671aa7ae64fb35e$var$E(arguments);
    return t.length < 4 || 1 === t[3] ? "rgb(" + Math.round(t[0]) + ", " + Math.round(t[1]) + ", " + Math.round(t[2]) + ")" : "rgba(" + Math.round(t[0]) + ", " + Math.round(t[1]) + ", " + Math.round(t[2]) + ", " + t[3] + ")";
}, $5671aa7ae64fb35e$var$B.to.rgb.percent = function() {
    var t = $5671aa7ae64fb35e$var$E(arguments), e = Math.round(t[0] / 255 * 100), n = Math.round(t[1] / 255 * 100), r = Math.round(t[2] / 255 * 100);
    return t.length < 4 || 1 === t[3] ? "rgb(" + e + "%, " + n + "%, " + r + "%)" : "rgba(" + e + "%, " + n + "%, " + r + "%, " + t[3] + ")";
}, $5671aa7ae64fb35e$var$B.to.hsl = function() {
    var t = $5671aa7ae64fb35e$var$E(arguments);
    return t.length < 4 || 1 === t[3] ? "hsl(" + t[0] + ", " + t[1] + "%, " + t[2] + "%)" : "hsla(" + t[0] + ", " + t[1] + "%, " + t[2] + "%, " + t[3] + ")";
}, $5671aa7ae64fb35e$var$B.to.hwb = function() {
    var t = $5671aa7ae64fb35e$var$E(arguments), e = "";
    return t.length >= 4 && 1 !== t[3] && (e = ", " + t[3]), "hwb(" + t[0] + ", " + t[1] + "%, " + t[2] + "%" + e + ")";
}, $5671aa7ae64fb35e$var$B.to.keyword = function(t) {
    return $5671aa7ae64fb35e$var$P[t.slice(0, 3)];
};
var $5671aa7ae64fb35e$var$F = $5671aa7ae64fb35e$var$A.exports, $5671aa7ae64fb35e$var$j = {
    exports: {}
}, $5671aa7ae64fb35e$var$z = {
    "aliceblue": [
        240,
        248,
        255
    ],
    "antiquewhite": [
        250,
        235,
        215
    ],
    "aqua": [
        0,
        255,
        255
    ],
    "aquamarine": [
        127,
        255,
        212
    ],
    "azure": [
        240,
        255,
        255
    ],
    "beige": [
        245,
        245,
        220
    ],
    "bisque": [
        255,
        228,
        196
    ],
    "black": [
        0,
        0,
        0
    ],
    "blanchedalmond": [
        255,
        235,
        205
    ],
    "blue": [
        0,
        0,
        255
    ],
    "blueviolet": [
        138,
        43,
        226
    ],
    "brown": [
        165,
        42,
        42
    ],
    "burlywood": [
        222,
        184,
        135
    ],
    "cadetblue": [
        95,
        158,
        160
    ],
    "chartreuse": [
        127,
        255,
        0
    ],
    "chocolate": [
        210,
        105,
        30
    ],
    "coral": [
        255,
        127,
        80
    ],
    "cornflowerblue": [
        100,
        149,
        237
    ],
    "cornsilk": [
        255,
        248,
        220
    ],
    "crimson": [
        220,
        20,
        60
    ],
    "cyan": [
        0,
        255,
        255
    ],
    "darkblue": [
        0,
        0,
        139
    ],
    "darkcyan": [
        0,
        139,
        139
    ],
    "darkgoldenrod": [
        184,
        134,
        11
    ],
    "darkgray": [
        169,
        169,
        169
    ],
    "darkgreen": [
        0,
        100,
        0
    ],
    "darkgrey": [
        169,
        169,
        169
    ],
    "darkkhaki": [
        189,
        183,
        107
    ],
    "darkmagenta": [
        139,
        0,
        139
    ],
    "darkolivegreen": [
        85,
        107,
        47
    ],
    "darkorange": [
        255,
        140,
        0
    ],
    "darkorchid": [
        153,
        50,
        204
    ],
    "darkred": [
        139,
        0,
        0
    ],
    "darksalmon": [
        233,
        150,
        122
    ],
    "darkseagreen": [
        143,
        188,
        143
    ],
    "darkslateblue": [
        72,
        61,
        139
    ],
    "darkslategray": [
        47,
        79,
        79
    ],
    "darkslategrey": [
        47,
        79,
        79
    ],
    "darkturquoise": [
        0,
        206,
        209
    ],
    "darkviolet": [
        148,
        0,
        211
    ],
    "deeppink": [
        255,
        20,
        147
    ],
    "deepskyblue": [
        0,
        191,
        255
    ],
    "dimgray": [
        105,
        105,
        105
    ],
    "dimgrey": [
        105,
        105,
        105
    ],
    "dodgerblue": [
        30,
        144,
        255
    ],
    "firebrick": [
        178,
        34,
        34
    ],
    "floralwhite": [
        255,
        250,
        240
    ],
    "forestgreen": [
        34,
        139,
        34
    ],
    "fuchsia": [
        255,
        0,
        255
    ],
    "gainsboro": [
        220,
        220,
        220
    ],
    "ghostwhite": [
        248,
        248,
        255
    ],
    "gold": [
        255,
        215,
        0
    ],
    "goldenrod": [
        218,
        165,
        32
    ],
    "gray": [
        128,
        128,
        128
    ],
    "green": [
        0,
        128,
        0
    ],
    "greenyellow": [
        173,
        255,
        47
    ],
    "grey": [
        128,
        128,
        128
    ],
    "honeydew": [
        240,
        255,
        240
    ],
    "hotpink": [
        255,
        105,
        180
    ],
    "indianred": [
        205,
        92,
        92
    ],
    "indigo": [
        75,
        0,
        130
    ],
    "ivory": [
        255,
        255,
        240
    ],
    "khaki": [
        240,
        230,
        140
    ],
    "lavender": [
        230,
        230,
        250
    ],
    "lavenderblush": [
        255,
        240,
        245
    ],
    "lawngreen": [
        124,
        252,
        0
    ],
    "lemonchiffon": [
        255,
        250,
        205
    ],
    "lightblue": [
        173,
        216,
        230
    ],
    "lightcoral": [
        240,
        128,
        128
    ],
    "lightcyan": [
        224,
        255,
        255
    ],
    "lightgoldenrodyellow": [
        250,
        250,
        210
    ],
    "lightgray": [
        211,
        211,
        211
    ],
    "lightgreen": [
        144,
        238,
        144
    ],
    "lightgrey": [
        211,
        211,
        211
    ],
    "lightpink": [
        255,
        182,
        193
    ],
    "lightsalmon": [
        255,
        160,
        122
    ],
    "lightseagreen": [
        32,
        178,
        170
    ],
    "lightskyblue": [
        135,
        206,
        250
    ],
    "lightslategray": [
        119,
        136,
        153
    ],
    "lightslategrey": [
        119,
        136,
        153
    ],
    "lightsteelblue": [
        176,
        196,
        222
    ],
    "lightyellow": [
        255,
        255,
        224
    ],
    "lime": [
        0,
        255,
        0
    ],
    "limegreen": [
        50,
        205,
        50
    ],
    "linen": [
        250,
        240,
        230
    ],
    "magenta": [
        255,
        0,
        255
    ],
    "maroon": [
        128,
        0,
        0
    ],
    "mediumaquamarine": [
        102,
        205,
        170
    ],
    "mediumblue": [
        0,
        0,
        205
    ],
    "mediumorchid": [
        186,
        85,
        211
    ],
    "mediumpurple": [
        147,
        112,
        219
    ],
    "mediumseagreen": [
        60,
        179,
        113
    ],
    "mediumslateblue": [
        123,
        104,
        238
    ],
    "mediumspringgreen": [
        0,
        250,
        154
    ],
    "mediumturquoise": [
        72,
        209,
        204
    ],
    "mediumvioletred": [
        199,
        21,
        133
    ],
    "midnightblue": [
        25,
        25,
        112
    ],
    "mintcream": [
        245,
        255,
        250
    ],
    "mistyrose": [
        255,
        228,
        225
    ],
    "moccasin": [
        255,
        228,
        181
    ],
    "navajowhite": [
        255,
        222,
        173
    ],
    "navy": [
        0,
        0,
        128
    ],
    "oldlace": [
        253,
        245,
        230
    ],
    "olive": [
        128,
        128,
        0
    ],
    "olivedrab": [
        107,
        142,
        35
    ],
    "orange": [
        255,
        165,
        0
    ],
    "orangered": [
        255,
        69,
        0
    ],
    "orchid": [
        218,
        112,
        214
    ],
    "palegoldenrod": [
        238,
        232,
        170
    ],
    "palegreen": [
        152,
        251,
        152
    ],
    "paleturquoise": [
        175,
        238,
        238
    ],
    "palevioletred": [
        219,
        112,
        147
    ],
    "papayawhip": [
        255,
        239,
        213
    ],
    "peachpuff": [
        255,
        218,
        185
    ],
    "peru": [
        205,
        133,
        63
    ],
    "pink": [
        255,
        192,
        203
    ],
    "plum": [
        221,
        160,
        221
    ],
    "powderblue": [
        176,
        224,
        230
    ],
    "purple": [
        128,
        0,
        128
    ],
    "rebeccapurple": [
        102,
        51,
        153
    ],
    "red": [
        255,
        0,
        0
    ],
    "rosybrown": [
        188,
        143,
        143
    ],
    "royalblue": [
        65,
        105,
        225
    ],
    "saddlebrown": [
        139,
        69,
        19
    ],
    "salmon": [
        250,
        128,
        114
    ],
    "sandybrown": [
        244,
        164,
        96
    ],
    "seagreen": [
        46,
        139,
        87
    ],
    "seashell": [
        255,
        245,
        238
    ],
    "sienna": [
        160,
        82,
        45
    ],
    "silver": [
        192,
        192,
        192
    ],
    "skyblue": [
        135,
        206,
        235
    ],
    "slateblue": [
        106,
        90,
        205
    ],
    "slategray": [
        112,
        128,
        144
    ],
    "slategrey": [
        112,
        128,
        144
    ],
    "snow": [
        255,
        250,
        250
    ],
    "springgreen": [
        0,
        255,
        127
    ],
    "steelblue": [
        70,
        130,
        180
    ],
    "tan": [
        210,
        180,
        140
    ],
    "teal": [
        0,
        128,
        128
    ],
    "thistle": [
        216,
        191,
        216
    ],
    "tomato": [
        255,
        99,
        71
    ],
    "turquoise": [
        64,
        224,
        208
    ],
    "violet": [
        238,
        130,
        238
    ],
    "wheat": [
        245,
        222,
        179
    ],
    "white": [
        255,
        255,
        255
    ],
    "whitesmoke": [
        245,
        245,
        245
    ],
    "yellow": [
        255,
        255,
        0
    ],
    "yellowgreen": [
        154,
        205,
        50
    ]
}, $5671aa7ae64fb35e$var$H = {};
for(var $5671aa7ae64fb35e$var$q in $5671aa7ae64fb35e$var$z)$5671aa7ae64fb35e$var$z.hasOwnProperty($5671aa7ae64fb35e$var$q) && ($5671aa7ae64fb35e$var$H[$5671aa7ae64fb35e$var$z[$5671aa7ae64fb35e$var$q]] = $5671aa7ae64fb35e$var$q);
var $5671aa7ae64fb35e$var$$ = $5671aa7ae64fb35e$var$j.exports = {
    rgb: {
        channels: 3,
        labels: "rgb"
    },
    hsl: {
        channels: 3,
        labels: "hsl"
    },
    hsv: {
        channels: 3,
        labels: "hsv"
    },
    hwb: {
        channels: 3,
        labels: "hwb"
    },
    cmyk: {
        channels: 4,
        labels: "cmyk"
    },
    xyz: {
        channels: 3,
        labels: "xyz"
    },
    lab: {
        channels: 3,
        labels: "lab"
    },
    lch: {
        channels: 3,
        labels: "lch"
    },
    hex: {
        channels: 1,
        labels: [
            "hex"
        ]
    },
    keyword: {
        channels: 1,
        labels: [
            "keyword"
        ]
    },
    ansi16: {
        channels: 1,
        labels: [
            "ansi16"
        ]
    },
    ansi256: {
        channels: 1,
        labels: [
            "ansi256"
        ]
    },
    hcg: {
        channels: 3,
        labels: [
            "h",
            "c",
            "g"
        ]
    },
    apple: {
        channels: 3,
        labels: [
            "r16",
            "g16",
            "b16"
        ]
    },
    gray: {
        channels: 1,
        labels: [
            "gray"
        ]
    }
};
for(var $5671aa7ae64fb35e$var$V in $5671aa7ae64fb35e$var$$)if ($5671aa7ae64fb35e$var$$.hasOwnProperty($5671aa7ae64fb35e$var$V)) {
    if (!("channels" in $5671aa7ae64fb35e$var$$[$5671aa7ae64fb35e$var$V])) throw new Error("missing channels property: " + $5671aa7ae64fb35e$var$V);
    if (!("labels" in $5671aa7ae64fb35e$var$$[$5671aa7ae64fb35e$var$V])) throw new Error("missing channel labels property: " + $5671aa7ae64fb35e$var$V);
    if ($5671aa7ae64fb35e$var$$[$5671aa7ae64fb35e$var$V].labels.length !== $5671aa7ae64fb35e$var$$[$5671aa7ae64fb35e$var$V].channels) throw new Error("channel and label counts mismatch: " + $5671aa7ae64fb35e$var$V);
    var $5671aa7ae64fb35e$var$J = $5671aa7ae64fb35e$var$$[$5671aa7ae64fb35e$var$V].channels, $5671aa7ae64fb35e$var$Y = $5671aa7ae64fb35e$var$$[$5671aa7ae64fb35e$var$V].labels;
    delete $5671aa7ae64fb35e$var$$[$5671aa7ae64fb35e$var$V].channels, delete $5671aa7ae64fb35e$var$$[$5671aa7ae64fb35e$var$V].labels, Object.defineProperty($5671aa7ae64fb35e$var$$[$5671aa7ae64fb35e$var$V], "channels", {
        value: $5671aa7ae64fb35e$var$J
    }), Object.defineProperty($5671aa7ae64fb35e$var$$[$5671aa7ae64fb35e$var$V], "labels", {
        value: $5671aa7ae64fb35e$var$Y
    });
}
$5671aa7ae64fb35e$var$$.rgb.hsl = function(t) {
    var e, n, r = t[0] / 255, s = t[1] / 255, i = t[2] / 255, o = Math.min(r, s, i), a = Math.max(r, s, i), c = a - o;
    return a === o ? e = 0 : r === a ? e = (s - i) / c : s === a ? e = 2 + (i - r) / c : i === a && (e = 4 + (r - s) / c), (e = Math.min(60 * e, 360)) < 0 && (e += 360), n = (o + a) / 2, [
        e,
        100 * (a === o ? 0 : n <= .5 ? c / (a + o) : c / (2 - a - o)),
        100 * n
    ];
}, $5671aa7ae64fb35e$var$$.rgb.hsv = function(t) {
    var e, n, r, s, i, o = t[0] / 255, a = t[1] / 255, c = t[2] / 255, l = Math.max(o, a, c), h = l - Math.min(o, a, c), u = function(t) {
        return (l - t) / 6 / h + .5;
    };
    return 0 === h ? s = i = 0 : (i = h / l, e = u(o), n = u(a), r = u(c), o === l ? s = r - n : a === l ? s = 1 / 3 + e - r : c === l && (s = 2 / 3 + n - e), s < 0 ? s += 1 : s > 1 && (s -= 1)), [
        360 * s,
        100 * i,
        100 * l
    ];
}, $5671aa7ae64fb35e$var$$.rgb.hwb = function(t) {
    var e = t[0], n = t[1], r = t[2];
    return [
        $5671aa7ae64fb35e$var$$.rgb.hsl(t)[0],
        100 * (1 / 255 * Math.min(e, Math.min(n, r))),
        100 * (r = 1 - 1 / 255 * Math.max(e, Math.max(n, r)))
    ];
}, $5671aa7ae64fb35e$var$$.rgb.cmyk = function(t) {
    var e, n = t[0] / 255, r = t[1] / 255, s = t[2] / 255;
    return [
        100 * ((1 - n - (e = Math.min(1 - n, 1 - r, 1 - s))) / (1 - e) || 0),
        100 * ((1 - r - e) / (1 - e) || 0),
        100 * ((1 - s - e) / (1 - e) || 0),
        100 * e
    ];
}, $5671aa7ae64fb35e$var$$.rgb.keyword = function(t) {
    var e = $5671aa7ae64fb35e$var$H[t];
    if (e) return e;
    var n, r, s, i = 1 / 0;
    for(var o in $5671aa7ae64fb35e$var$z)if ($5671aa7ae64fb35e$var$z.hasOwnProperty(o)) {
        var a = $5671aa7ae64fb35e$var$z[o], c = (r = t, s = a, Math.pow(r[0] - s[0], 2) + Math.pow(r[1] - s[1], 2) + Math.pow(r[2] - s[2], 2));
        c < i && (i = c, n = o);
    }
    return n;
}, $5671aa7ae64fb35e$var$$.keyword.rgb = function(t) {
    return $5671aa7ae64fb35e$var$z[t];
}, $5671aa7ae64fb35e$var$$.rgb.xyz = function(t) {
    var e = t[0] / 255, n = t[1] / 255, r = t[2] / 255;
    return [
        100 * (.4124 * (e = e > .04045 ? Math.pow((e + .055) / 1.055, 2.4) : e / 12.92) + .3576 * (n = n > .04045 ? Math.pow((n + .055) / 1.055, 2.4) : n / 12.92) + .1805 * (r = r > .04045 ? Math.pow((r + .055) / 1.055, 2.4) : r / 12.92)),
        100 * (.2126 * e + .7152 * n + .0722 * r),
        100 * (.0193 * e + .1192 * n + .9505 * r)
    ];
}, $5671aa7ae64fb35e$var$$.rgb.lab = function(t) {
    var e = $5671aa7ae64fb35e$var$$.rgb.xyz(t), n = e[0], r = e[1], s = e[2];
    return r /= 100, s /= 108.883, n = (n /= 95.047) > .008856 ? Math.pow(n, 1 / 3) : 7.787 * n + 16 / 116, [
        116 * (r = r > .008856 ? Math.pow(r, 1 / 3) : 7.787 * r + 16 / 116) - 16,
        500 * (n - r),
        200 * (r - (s = s > .008856 ? Math.pow(s, 1 / 3) : 7.787 * s + 16 / 116))
    ];
}, $5671aa7ae64fb35e$var$$.hsl.rgb = function(t) {
    var e, n, r, s, i, o = t[0] / 360, a = t[1] / 100, c = t[2] / 100;
    if (0 === a) return [
        i = 255 * c,
        i,
        i
    ];
    e = 2 * c - (n = c < .5 ? c * (1 + a) : c + a - c * a), s = [
        0,
        0,
        0
    ];
    for(var l = 0; l < 3; l++)(r = o + 1 / 3 * -(l - 1)) < 0 && r++, r > 1 && r--, i = 6 * r < 1 ? e + 6 * (n - e) * r : 2 * r < 1 ? n : 3 * r < 2 ? e + (n - e) * (2 / 3 - r) * 6 : e, s[l] = 255 * i;
    return s;
}, $5671aa7ae64fb35e$var$$.hsl.hsv = function(t) {
    var e = t[0], n = t[1] / 100, r = t[2] / 100, s = n, i = Math.max(r, .01);
    return n *= (r *= 2) <= 1 ? r : 2 - r, s *= i <= 1 ? i : 2 - i, [
        e,
        100 * (0 === r ? 2 * s / (i + s) : 2 * n / (r + n)),
        100 * ((r + n) / 2)
    ];
}, $5671aa7ae64fb35e$var$$.hsv.rgb = function(t) {
    var e = t[0] / 60, n = t[1] / 100, r = t[2] / 100, s = Math.floor(e) % 6, i = e - Math.floor(e), o = 255 * r * (1 - n), a = 255 * r * (1 - n * i), c = 255 * r * (1 - n * (1 - i));
    switch(r *= 255, s){
        case 0:
            return [
                r,
                c,
                o
            ];
        case 1:
            return [
                a,
                r,
                o
            ];
        case 2:
            return [
                o,
                r,
                c
            ];
        case 3:
            return [
                o,
                a,
                r
            ];
        case 4:
            return [
                c,
                o,
                r
            ];
        case 5:
            return [
                r,
                o,
                a
            ];
    }
}, $5671aa7ae64fb35e$var$$.hsv.hsl = function(t) {
    var e, n, r, s = t[0], i = t[1] / 100, o = t[2] / 100, a = Math.max(o, .01);
    return r = (2 - i) * o, n = i * a, [
        s,
        100 * (n = (n /= (e = (2 - i) * a) <= 1 ? e : 2 - e) || 0),
        100 * (r /= 2)
    ];
}, $5671aa7ae64fb35e$var$$.hwb.rgb = function(t) {
    var e, n, r, s, i, o, a, c = t[0] / 360, l = t[1] / 100, h = t[2] / 100, u = l + h;
    switch(u > 1 && (l /= u, h /= u), r = 6 * c - (e = Math.floor(6 * c)), 1 & e && (r = 1 - r), s = l + r * ((n = 1 - h) - l), e){
        default:
        case 6:
        case 0:
            i = n, o = s, a = l;
            break;
        case 1:
            i = s, o = n, a = l;
            break;
        case 2:
            i = l, o = n, a = s;
            break;
        case 3:
            i = l, o = s, a = n;
            break;
        case 4:
            i = s, o = l, a = n;
            break;
        case 5:
            i = n, o = l, a = s;
    }
    return [
        255 * i,
        255 * o,
        255 * a
    ];
}, $5671aa7ae64fb35e$var$$.cmyk.rgb = function(t) {
    var e = t[0] / 100, n = t[1] / 100, r = t[2] / 100, s = t[3] / 100;
    return [
        255 * (1 - Math.min(1, e * (1 - s) + s)),
        255 * (1 - Math.min(1, n * (1 - s) + s)),
        255 * (1 - Math.min(1, r * (1 - s) + s))
    ];
}, $5671aa7ae64fb35e$var$$.xyz.rgb = function(t) {
    var e, n, r, s = t[0] / 100, i = t[1] / 100, o = t[2] / 100;
    return n = -0.9689 * s + 1.8758 * i + .0415 * o, r = .0557 * s + -0.204 * i + 1.057 * o, e = (e = 3.2406 * s + -1.5372 * i + -0.4986 * o) > .0031308 ? 1.055 * Math.pow(e, 1 / 2.4) - .055 : 12.92 * e, n = n > .0031308 ? 1.055 * Math.pow(n, 1 / 2.4) - .055 : 12.92 * n, r = r > .0031308 ? 1.055 * Math.pow(r, 1 / 2.4) - .055 : 12.92 * r, [
        255 * (e = Math.min(Math.max(0, e), 1)),
        255 * (n = Math.min(Math.max(0, n), 1)),
        255 * (r = Math.min(Math.max(0, r), 1))
    ];
}, $5671aa7ae64fb35e$var$$.xyz.lab = function(t) {
    var e = t[0], n = t[1], r = t[2];
    return n /= 100, r /= 108.883, e = (e /= 95.047) > .008856 ? Math.pow(e, 1 / 3) : 7.787 * e + 16 / 116, [
        116 * (n = n > .008856 ? Math.pow(n, 1 / 3) : 7.787 * n + 16 / 116) - 16,
        500 * (e - n),
        200 * (n - (r = r > .008856 ? Math.pow(r, 1 / 3) : 7.787 * r + 16 / 116))
    ];
}, $5671aa7ae64fb35e$var$$.lab.xyz = function(t) {
    var e, n, r, s = t[0];
    e = t[1] / 500 + (n = (s + 16) / 116), r = n - t[2] / 200;
    var i = Math.pow(n, 3), o = Math.pow(e, 3), a = Math.pow(r, 3);
    return n = i > .008856 ? i : (n - 16 / 116) / 7.787, e = o > .008856 ? o : (e - 16 / 116) / 7.787, r = a > .008856 ? a : (r - 16 / 116) / 7.787, [
        e *= 95.047,
        n *= 100,
        r *= 108.883
    ];
}, $5671aa7ae64fb35e$var$$.lab.lch = function(t) {
    var e, n = t[0], r = t[1], s = t[2];
    return (e = 360 * Math.atan2(s, r) / 2 / Math.PI) < 0 && (e += 360), [
        n,
        Math.sqrt(r * r + s * s),
        e
    ];
}, $5671aa7ae64fb35e$var$$.lch.lab = function(t) {
    var e, n = t[0], r = t[1];
    return e = t[2] / 360 * 2 * Math.PI, [
        n,
        r * Math.cos(e),
        r * Math.sin(e)
    ];
}, $5671aa7ae64fb35e$var$$.rgb.ansi16 = function(t) {
    var e = t[0], n = t[1], r = t[2], s = 1 in arguments ? arguments[1] : $5671aa7ae64fb35e$var$$.rgb.hsv(t)[2];
    if (0 === (s = Math.round(s / 50))) return 30;
    var i = 30 + (Math.round(r / 255) << 2 | Math.round(n / 255) << 1 | Math.round(e / 255));
    return 2 === s && (i += 60), i;
}, $5671aa7ae64fb35e$var$$.hsv.ansi16 = function(t) {
    return $5671aa7ae64fb35e$var$$.rgb.ansi16($5671aa7ae64fb35e$var$$.hsv.rgb(t), t[2]);
}, $5671aa7ae64fb35e$var$$.rgb.ansi256 = function(t) {
    var e = t[0], n = t[1], r = t[2];
    return e === n && n === r ? e < 8 ? 16 : e > 248 ? 231 : Math.round((e - 8) / 247 * 24) + 232 : 16 + 36 * Math.round(e / 255 * 5) + 6 * Math.round(n / 255 * 5) + Math.round(r / 255 * 5);
}, $5671aa7ae64fb35e$var$$.ansi16.rgb = function(t) {
    var e = t % 10;
    if (0 === e || 7 === e) return t > 50 && (e += 3.5), [
        e = e / 10.5 * 255,
        e,
        e
    ];
    var n = .5 * (1 + ~~(t > 50));
    return [
        (1 & e) * n * 255,
        (e >> 1 & 1) * n * 255,
        (e >> 2 & 1) * n * 255
    ];
}, $5671aa7ae64fb35e$var$$.ansi256.rgb = function(t) {
    if (t >= 232) {
        var e = 10 * (t - 232) + 8;
        return [
            e,
            e,
            e
        ];
    }
    var n;
    return t -= 16, [
        Math.floor(t / 36) / 5 * 255,
        Math.floor((n = t % 36) / 6) / 5 * 255,
        n % 6 / 5 * 255
    ];
}, $5671aa7ae64fb35e$var$$.rgb.hex = function(t) {
    var e = (((255 & Math.round(t[0])) << 16) + ((255 & Math.round(t[1])) << 8) + (255 & Math.round(t[2]))).toString(16).toUpperCase();
    return "000000".substring(e.length) + e;
}, $5671aa7ae64fb35e$var$$.hex.rgb = function(t) {
    var e = t.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
    if (!e) return [
        0,
        0,
        0
    ];
    var n = e[0];
    3 === e[0].length && (n = n.split("").map(function(t) {
        return t + t;
    }).join(""));
    var r = parseInt(n, 16);
    return [
        r >> 16 & 255,
        r >> 8 & 255,
        255 & r
    ];
}, $5671aa7ae64fb35e$var$$.rgb.hcg = function(t) {
    var e, n = t[0] / 255, r = t[1] / 255, s = t[2] / 255, i = Math.max(Math.max(n, r), s), o = Math.min(Math.min(n, r), s), a = i - o;
    return e = a <= 0 ? 0 : i === n ? (r - s) / a % 6 : i === r ? 2 + (s - n) / a : 4 + (n - r) / a + 4, e /= 6, [
        360 * (e %= 1),
        100 * a,
        100 * (a < 1 ? o / (1 - a) : 0)
    ];
}, $5671aa7ae64fb35e$var$$.hsl.hcg = function(t) {
    var e = t[1] / 100, n = t[2] / 100, r = 1, s = 0;
    return (r = n < .5 ? 2 * e * n : 2 * e * (1 - n)) < 1 && (s = (n - .5 * r) / (1 - r)), [
        t[0],
        100 * r,
        100 * s
    ];
}, $5671aa7ae64fb35e$var$$.hsv.hcg = function(t) {
    var e = t[1] / 100, n = t[2] / 100, r = e * n, s = 0;
    return r < 1 && (s = (n - r) / (1 - r)), [
        t[0],
        100 * r,
        100 * s
    ];
}, $5671aa7ae64fb35e$var$$.hcg.rgb = function(t) {
    var e = t[0] / 360, n = t[1] / 100, r = t[2] / 100;
    if (0 === n) return [
        255 * r,
        255 * r,
        255 * r
    ];
    var s, i = [
        0,
        0,
        0
    ], o = e % 1 * 6, a = o % 1, c = 1 - a;
    switch(Math.floor(o)){
        case 0:
            i[0] = 1, i[1] = a, i[2] = 0;
            break;
        case 1:
            i[0] = c, i[1] = 1, i[2] = 0;
            break;
        case 2:
            i[0] = 0, i[1] = 1, i[2] = a;
            break;
        case 3:
            i[0] = 0, i[1] = c, i[2] = 1;
            break;
        case 4:
            i[0] = a, i[1] = 0, i[2] = 1;
            break;
        default:
            i[0] = 1, i[1] = 0, i[2] = c;
    }
    return s = (1 - n) * r, [
        255 * (n * i[0] + s),
        255 * (n * i[1] + s),
        255 * (n * i[2] + s)
    ];
}, $5671aa7ae64fb35e$var$$.hcg.hsv = function(t) {
    var e = t[1] / 100, n = e + t[2] / 100 * (1 - e), r = 0;
    return n > 0 && (r = e / n), [
        t[0],
        100 * r,
        100 * n
    ];
}, $5671aa7ae64fb35e$var$$.hcg.hsl = function(t) {
    var e = t[1] / 100, n = t[2] / 100 * (1 - e) + .5 * e, r = 0;
    return n > 0 && n < .5 ? r = e / (2 * n) : n >= .5 && n < 1 && (r = e / (2 * (1 - n))), [
        t[0],
        100 * r,
        100 * n
    ];
}, $5671aa7ae64fb35e$var$$.hcg.hwb = function(t) {
    var e = t[1] / 100, n = e + t[2] / 100 * (1 - e);
    return [
        t[0],
        100 * (n - e),
        100 * (1 - n)
    ];
}, $5671aa7ae64fb35e$var$$.hwb.hcg = function(t) {
    var e = t[1] / 100, n = 1 - t[2] / 100, r = n - e, s = 0;
    return r < 1 && (s = (n - r) / (1 - r)), [
        t[0],
        100 * r,
        100 * s
    ];
}, $5671aa7ae64fb35e$var$$.apple.rgb = function(t) {
    return [
        t[0] / 65535 * 255,
        t[1] / 65535 * 255,
        t[2] / 65535 * 255
    ];
}, $5671aa7ae64fb35e$var$$.rgb.apple = function(t) {
    return [
        t[0] / 255 * 65535,
        t[1] / 255 * 65535,
        t[2] / 255 * 65535
    ];
}, $5671aa7ae64fb35e$var$$.gray.rgb = function(t) {
    return [
        t[0] / 100 * 255,
        t[0] / 100 * 255,
        t[0] / 100 * 255
    ];
}, $5671aa7ae64fb35e$var$$.gray.hsl = $5671aa7ae64fb35e$var$$.gray.hsv = function(t) {
    return [
        0,
        0,
        t[0]
    ];
}, $5671aa7ae64fb35e$var$$.gray.hwb = function(t) {
    return [
        0,
        100,
        t[0]
    ];
}, $5671aa7ae64fb35e$var$$.gray.cmyk = function(t) {
    return [
        0,
        0,
        0,
        t[0]
    ];
}, $5671aa7ae64fb35e$var$$.gray.lab = function(t) {
    return [
        t[0],
        0,
        0
    ];
}, $5671aa7ae64fb35e$var$$.gray.hex = function(t) {
    var e = 255 & Math.round(t[0] / 100 * 255), n = ((e << 16) + (e << 8) + e).toString(16).toUpperCase();
    return "000000".substring(n.length) + n;
}, $5671aa7ae64fb35e$var$$.rgb.gray = function(t) {
    return [
        (t[0] + t[1] + t[2]) / 3 / 255 * 100
    ];
};
var $5671aa7ae64fb35e$var$Z = $5671aa7ae64fb35e$var$j.exports, $5671aa7ae64fb35e$var$K = $5671aa7ae64fb35e$var$Z;
function $5671aa7ae64fb35e$var$X(t) {
    var e = function() {
        for(var t = {}, e = Object.keys($5671aa7ae64fb35e$var$K), n = e.length, r = 0; r < n; r++)t[e[r]] = {
            distance: -1,
            parent: null
        };
        return t;
    }(), n = [
        t
    ];
    for(e[t].distance = 0; n.length;)for(var r = n.pop(), s = Object.keys($5671aa7ae64fb35e$var$K[r]), i = s.length, o = 0; o < i; o++){
        var a = s[o], c = e[a];
        -1 === c.distance && (c.distance = e[r].distance + 1, c.parent = r, n.unshift(a));
    }
    return e;
}
function $5671aa7ae64fb35e$var$W(t, e) {
    return function(n) {
        return e(t(n));
    };
}
function $5671aa7ae64fb35e$var$Q(t, e) {
    for(var n = [
        e[t].parent,
        t
    ], r = $5671aa7ae64fb35e$var$K[e[t].parent][t], s = e[t].parent; e[s].parent;)n.unshift(e[s].parent), r = $5671aa7ae64fb35e$var$W($5671aa7ae64fb35e$var$K[e[s].parent][s], r), s = e[s].parent;
    return r.conversion = n, r;
}
var $5671aa7ae64fb35e$var$tt = $5671aa7ae64fb35e$var$Z, $5671aa7ae64fb35e$var$et = function(t) {
    for(var e = $5671aa7ae64fb35e$var$X(t), n = {}, r = Object.keys(e), s = r.length, i = 0; i < s; i++){
        var o = r[i];
        null !== e[o].parent && (n[o] = $5671aa7ae64fb35e$var$Q(o, e));
    }
    return n;
}, $5671aa7ae64fb35e$var$nt = {};
Object.keys($5671aa7ae64fb35e$var$tt).forEach(function(t) {
    $5671aa7ae64fb35e$var$nt[t] = {}, Object.defineProperty($5671aa7ae64fb35e$var$nt[t], "channels", {
        value: $5671aa7ae64fb35e$var$tt[t].channels
    }), Object.defineProperty($5671aa7ae64fb35e$var$nt[t], "labels", {
        value: $5671aa7ae64fb35e$var$tt[t].labels
    });
    var e = $5671aa7ae64fb35e$var$et(t);
    Object.keys(e).forEach(function(n) {
        var r = e[n];
        $5671aa7ae64fb35e$var$nt[t][n] = function(t) {
            var e = function(e) {
                if (null == e) return e;
                arguments.length > 1 && (e = Array.prototype.slice.call(arguments));
                var n = t(e);
                if ("object" == typeof n) for(var r = n.length, s = 0; s < r; s++)n[s] = Math.round(n[s]);
                return n;
            };
            return "conversion" in t && (e.conversion = t.conversion), e;
        }(r), $5671aa7ae64fb35e$var$nt[t][n].raw = function(t) {
            var e = function(e) {
                return null == e ? e : (arguments.length > 1 && (e = Array.prototype.slice.call(arguments)), t(e));
            };
            return "conversion" in t && (e.conversion = t.conversion), e;
        }(r);
    });
});
var $5671aa7ae64fb35e$var$rt = $5671aa7ae64fb35e$var$F, $5671aa7ae64fb35e$var$st = $5671aa7ae64fb35e$var$nt, $5671aa7ae64fb35e$var$it = [].slice, $5671aa7ae64fb35e$var$ot = [
    "keyword",
    "gray",
    "hex"
], $5671aa7ae64fb35e$var$at = {};
Object.keys($5671aa7ae64fb35e$var$st).forEach(function(t) {
    $5671aa7ae64fb35e$var$at[$5671aa7ae64fb35e$var$it.call($5671aa7ae64fb35e$var$st[t].labels).sort().join("")] = t;
});
var $5671aa7ae64fb35e$var$ct = {};
function $5671aa7ae64fb35e$var$lt(t, e) {
    if (!(this instanceof $5671aa7ae64fb35e$var$lt)) return new $5671aa7ae64fb35e$var$lt(t, e);
    if (e && e in $5671aa7ae64fb35e$var$ot && (e = null), e && !(e in $5671aa7ae64fb35e$var$st)) throw new Error("Unknown model: " + e);
    var n, r;
    if (null == t) this.model = "rgb", this.color = [
        0,
        0,
        0
    ], this.valpha = 1;
    else if (t instanceof $5671aa7ae64fb35e$var$lt) this.model = t.model, this.color = t.color.slice(), this.valpha = t.valpha;
    else if ("string" == typeof t) {
        var s = $5671aa7ae64fb35e$var$rt.get(t);
        if (null === s) throw new Error("Unable to parse color from string: " + t);
        this.model = s.model, r = $5671aa7ae64fb35e$var$st[this.model].channels, this.color = s.value.slice(0, r), this.valpha = "number" == typeof s.value[r] ? s.value[r] : 1;
    } else if (t.length) {
        this.model = e || "rgb", r = $5671aa7ae64fb35e$var$st[this.model].channels;
        var i = $5671aa7ae64fb35e$var$it.call(t, 0, r);
        this.color = $5671aa7ae64fb35e$var$ft(i, r), this.valpha = "number" == typeof t[r] ? t[r] : 1;
    } else if ("number" == typeof t) t &= 16777215, this.model = "rgb", this.color = [
        t >> 16 & 255,
        t >> 8 & 255,
        255 & t
    ], this.valpha = 1;
    else {
        this.valpha = 1;
        var o = Object.keys(t);
        "alpha" in t && (o.splice(o.indexOf("alpha"), 1), this.valpha = "number" == typeof t.alpha ? t.alpha : 0);
        var a = o.sort().join("");
        if (!(a in $5671aa7ae64fb35e$var$at)) throw new Error("Unable to parse color from object: " + JSON.stringify(t));
        this.model = $5671aa7ae64fb35e$var$at[a];
        var c = $5671aa7ae64fb35e$var$st[this.model].labels, l = [];
        for(n = 0; n < c.length; n++)l.push(t[c[n]]);
        this.color = $5671aa7ae64fb35e$var$ft(l);
    }
    if ($5671aa7ae64fb35e$var$ct[this.model]) for(r = $5671aa7ae64fb35e$var$st[this.model].channels, n = 0; n < r; n++){
        var h = $5671aa7ae64fb35e$var$ct[this.model][n];
        h && (this.color[n] = h(this.color[n]));
    }
    this.valpha = Math.max(0, Math.min(1, this.valpha)), Object.freeze && Object.freeze(this);
}
function $5671aa7ae64fb35e$var$ht(t, e, n) {
    return (t = Array.isArray(t) ? t : [
        t
    ]).forEach(function(t) {
        ($5671aa7ae64fb35e$var$ct[t] || ($5671aa7ae64fb35e$var$ct[t] = []))[e] = n;
    }), t = t[0], function(r) {
        var s;
        return arguments.length ? (n && (r = n(r)), (s = this[t]()).color[e] = r, s) : (s = this[t]().color[e], n && (s = n(s)), s);
    };
}
function $5671aa7ae64fb35e$var$ut(t) {
    return function(e) {
        return Math.max(0, Math.min(t, e));
    };
}
function $5671aa7ae64fb35e$var$ft(t, e) {
    for(var n = 0; n < e; n++)"number" != typeof t[n] && (t[n] = 0);
    return t;
}
$5671aa7ae64fb35e$var$lt.prototype = {
    toString: function() {
        return this.string();
    },
    toJSON: function() {
        return this[this.model]();
    },
    string: function(t) {
        var e = this.model in $5671aa7ae64fb35e$var$rt.to ? this : this.rgb(), n = 1 === (e = e.round("number" == typeof t ? t : 1)).valpha ? e.color : e.color.concat(this.valpha);
        return $5671aa7ae64fb35e$var$rt.to[e.model](n);
    },
    percentString: function(t) {
        var e = this.rgb().round("number" == typeof t ? t : 1), n = 1 === e.valpha ? e.color : e.color.concat(this.valpha);
        return $5671aa7ae64fb35e$var$rt.to.rgb.percent(n);
    },
    array: function() {
        return 1 === this.valpha ? this.color.slice() : this.color.concat(this.valpha);
    },
    object: function() {
        for(var t = {}, e = $5671aa7ae64fb35e$var$st[this.model].channels, n = $5671aa7ae64fb35e$var$st[this.model].labels, r = 0; r < e; r++)t[n[r]] = this.color[r];
        return 1 !== this.valpha && (t.alpha = this.valpha), t;
    },
    unitArray: function() {
        var t = this.rgb().color;
        return t[0] /= 255, t[1] /= 255, t[2] /= 255, 1 !== this.valpha && t.push(this.valpha), t;
    },
    unitObject: function() {
        var t = this.rgb().object();
        return t.r /= 255, t.g /= 255, t.b /= 255, 1 !== this.valpha && (t.alpha = this.valpha), t;
    },
    round: function(t) {
        return t = Math.max(t || 0, 0), new $5671aa7ae64fb35e$var$lt(this.color.map(function(t) {
            return function(e) {
                return function(t, e) {
                    return Number(t.toFixed(e));
                }(e, t);
            };
        }(t)).concat(this.valpha), this.model);
    },
    alpha: function(t) {
        return arguments.length ? new $5671aa7ae64fb35e$var$lt(this.color.concat(Math.max(0, Math.min(1, t))), this.model) : this.valpha;
    },
    red: $5671aa7ae64fb35e$var$ht("rgb", 0, $5671aa7ae64fb35e$var$ut(255)),
    green: $5671aa7ae64fb35e$var$ht("rgb", 1, $5671aa7ae64fb35e$var$ut(255)),
    blue: $5671aa7ae64fb35e$var$ht("rgb", 2, $5671aa7ae64fb35e$var$ut(255)),
    hue: $5671aa7ae64fb35e$var$ht([
        "hsl",
        "hsv",
        "hsl",
        "hwb",
        "hcg"
    ], 0, function(t) {
        return (t % 360 + 360) % 360;
    }),
    saturationl: $5671aa7ae64fb35e$var$ht("hsl", 1, $5671aa7ae64fb35e$var$ut(100)),
    lightness: $5671aa7ae64fb35e$var$ht("hsl", 2, $5671aa7ae64fb35e$var$ut(100)),
    saturationv: $5671aa7ae64fb35e$var$ht("hsv", 1, $5671aa7ae64fb35e$var$ut(100)),
    value: $5671aa7ae64fb35e$var$ht("hsv", 2, $5671aa7ae64fb35e$var$ut(100)),
    chroma: $5671aa7ae64fb35e$var$ht("hcg", 1, $5671aa7ae64fb35e$var$ut(100)),
    gray: $5671aa7ae64fb35e$var$ht("hcg", 2, $5671aa7ae64fb35e$var$ut(100)),
    white: $5671aa7ae64fb35e$var$ht("hwb", 1, $5671aa7ae64fb35e$var$ut(100)),
    wblack: $5671aa7ae64fb35e$var$ht("hwb", 2, $5671aa7ae64fb35e$var$ut(100)),
    cyan: $5671aa7ae64fb35e$var$ht("cmyk", 0, $5671aa7ae64fb35e$var$ut(100)),
    magenta: $5671aa7ae64fb35e$var$ht("cmyk", 1, $5671aa7ae64fb35e$var$ut(100)),
    yellow: $5671aa7ae64fb35e$var$ht("cmyk", 2, $5671aa7ae64fb35e$var$ut(100)),
    black: $5671aa7ae64fb35e$var$ht("cmyk", 3, $5671aa7ae64fb35e$var$ut(100)),
    x: $5671aa7ae64fb35e$var$ht("xyz", 0, $5671aa7ae64fb35e$var$ut(100)),
    y: $5671aa7ae64fb35e$var$ht("xyz", 1, $5671aa7ae64fb35e$var$ut(100)),
    z: $5671aa7ae64fb35e$var$ht("xyz", 2, $5671aa7ae64fb35e$var$ut(100)),
    l: $5671aa7ae64fb35e$var$ht("lab", 0, $5671aa7ae64fb35e$var$ut(100)),
    a: $5671aa7ae64fb35e$var$ht("lab", 1),
    b: $5671aa7ae64fb35e$var$ht("lab", 2),
    keyword: function(t) {
        return arguments.length ? new $5671aa7ae64fb35e$var$lt(t) : $5671aa7ae64fb35e$var$st[this.model].keyword(this.color);
    },
    hex: function(t) {
        return arguments.length ? new $5671aa7ae64fb35e$var$lt(t) : $5671aa7ae64fb35e$var$rt.to.hex(this.rgb().round().color);
    },
    rgbNumber: function() {
        var t = this.rgb().color;
        return (255 & t[0]) << 16 | (255 & t[1]) << 8 | 255 & t[2];
    },
    luminosity: function() {
        for(var t = this.rgb().color, e = [], n = 0; n < t.length; n++){
            var r = t[n] / 255;
            e[n] = r <= .03928 ? r / 12.92 : Math.pow((r + .055) / 1.055, 2.4);
        }
        return .2126 * e[0] + .7152 * e[1] + .0722 * e[2];
    },
    contrast: function(t) {
        var e = this.luminosity(), n = t.luminosity();
        return e > n ? (e + .05) / (n + .05) : (n + .05) / (e + .05);
    },
    level: function(t) {
        var e = this.contrast(t);
        return e >= 7.1 ? "AAA" : e >= 4.5 ? "AA" : "";
    },
    isDark: function() {
        var t = this.rgb().color;
        return (299 * t[0] + 587 * t[1] + 114 * t[2]) / 1e3 < 128;
    },
    isLight: function() {
        return !this.isDark();
    },
    negate: function() {
        for(var t = this.rgb(), e = 0; e < 3; e++)t.color[e] = 255 - t.color[e];
        return t;
    },
    lighten: function(t) {
        var e = this.hsl();
        return e.color[2] += e.color[2] * t, e;
    },
    darken: function(t) {
        var e = this.hsl();
        return e.color[2] -= e.color[2] * t, e;
    },
    saturate: function(t) {
        var e = this.hsl();
        return e.color[1] += e.color[1] * t, e;
    },
    desaturate: function(t) {
        var e = this.hsl();
        return e.color[1] -= e.color[1] * t, e;
    },
    whiten: function(t) {
        var e = this.hwb();
        return e.color[1] += e.color[1] * t, e;
    },
    blacken: function(t) {
        var e = this.hwb();
        return e.color[2] += e.color[2] * t, e;
    },
    grayscale: function() {
        var t = this.rgb().color, e = .3 * t[0] + .59 * t[1] + .11 * t[2];
        return $5671aa7ae64fb35e$var$lt.rgb(e, e, e);
    },
    fade: function(t) {
        return this.alpha(this.valpha - this.valpha * t);
    },
    opaquer: function(t) {
        return this.alpha(this.valpha + this.valpha * t);
    },
    rotate: function(t) {
        var e = this.hsl(), n = e.color[0];
        return n = (n = (n + t) % 360) < 0 ? 360 + n : n, e.color[0] = n, e;
    },
    mix: function(t, e) {
        if (!t || !t.rgb) throw new Error('Argument to "mix" was not a Color instance, but rather an instance of ' + typeof t);
        var n = t.rgb(), r = this.rgb(), s = void 0 === e ? .5 : e, i = 2 * s - 1, o = n.alpha() - r.alpha(), a = ((i * o == -1 ? i : (i + o) / (1 + i * o)) + 1) / 2, c = 1 - a;
        return $5671aa7ae64fb35e$var$lt.rgb(a * n.red() + c * r.red(), a * n.green() + c * r.green(), a * n.blue() + c * r.blue(), n.alpha() * s + r.alpha() * (1 - s));
    }
}, Object.keys($5671aa7ae64fb35e$var$st).forEach(function(t) {
    if (-1 === $5671aa7ae64fb35e$var$ot.indexOf(t)) {
        var e = $5671aa7ae64fb35e$var$st[t].channels;
        $5671aa7ae64fb35e$var$lt.prototype[t] = function() {
            if (this.model === t) return new $5671aa7ae64fb35e$var$lt(this);
            if (arguments.length) return new $5671aa7ae64fb35e$var$lt(arguments, t);
            var n, r = "number" == typeof arguments[e] ? e : this.valpha;
            return new $5671aa7ae64fb35e$var$lt((n = $5671aa7ae64fb35e$var$st[this.model][t].raw(this.color), Array.isArray(n) ? n : [
                n
            ]).concat(r), t);
        }, $5671aa7ae64fb35e$var$lt[t] = function(n) {
            return "number" == typeof n && (n = $5671aa7ae64fb35e$var$ft($5671aa7ae64fb35e$var$it.call(arguments), e)), new $5671aa7ae64fb35e$var$lt(n, t);
        };
    }
});
var $5671aa7ae64fb35e$var$dt = $5671aa7ae64fb35e$var$O($5671aa7ae64fb35e$var$lt);
function $5671aa7ae64fb35e$var$mt(t) {
    return null == t;
}
function $5671aa7ae64fb35e$var$pt(t) {
    for(let e = 1; e < arguments.length; e++){
        const n = arguments[e];
        for(const e in n)t[e] = n[e];
    }
    return t;
}
function $5671aa7ae64fb35e$var$bt(t) {
    return null != t && ("function" == typeof t || null !== t.constructor && t.constructor === Function);
}
function $5671aa7ae64fb35e$var$yt(t) {
    return "object" == typeof t && !!t;
}
function $5671aa7ae64fb35e$var$gt(t) {
    return "number" == typeof t && !isNaN(t);
}
function $5671aa7ae64fb35e$var$wt(t) {
    return t * Math.PI / 180;
}
function $5671aa7ae64fb35e$var$vt(t) {
    return t / Math.PI * 180;
}
function $5671aa7ae64fb35e$var$Tt(t) {
    let e = document.createElement("a");
    return e.href = t, t = e.href, e = null, t;
}
function $5671aa7ae64fb35e$var$_t(t) {
    return Math.sign ? Math.sign(t) : 0 === (t = +t) || isNaN(t) ? Number(t) : t > 0 ? 1 : -1;
}
const $5671aa7ae64fb35e$var$Mt = [
    1,
    1,
    1,
    1,
    2,
    2,
    3,
    0
];
function $5671aa7ae64fb35e$var$Ot(t) {
    const e = t.length;
    let n = "";
    for(let r = 0; r < e;){
        let s = t[r++];
        if (128 & s) {
            let n = $5671aa7ae64fb35e$var$Mt[s >> 3 & 7];
            if (!(64 & s) || !n || r + n > e) return null;
            for(s &= 63 >> n; n > 0; n -= 1){
                const e = t[r++];
                if (128 != (192 & e)) return null;
                s = s << 6 | 63 & e;
            }
        }
        n += String.fromCharCode(s);
    }
    return n;
}
function $5671aa7ae64fb35e$var$At(t, e, n) {
    return t[3 * n] = e[0], t[3 * n + 1] = e[1], t[3 * n + 2] = e[2], t;
}
function $5671aa7ae64fb35e$var$xt(t) {
    return t.flat ? t.flat(1 / 0) : t.reduce((t, e)=>t.concat(e), []);
}
function $5671aa7ae64fb35e$var$It(t) {
    return t < 256 ? Uint8Array : t < 65536 ? Uint16Array : Uint32Array;
}
function $5671aa7ae64fb35e$var$St(t) {
    return 0 === t.indexOf("data:");
}
function $5671aa7ae64fb35e$var$Ct(t) {
    const e = t.indexOf("base64,"), n = t.substring(e + 7), r = window.atob(n), s = r.length, i = new Uint8Array(s);
    for(let t = 0; t < s; t++)i[t] = r.charCodeAt(t);
    return i.buffer;
}
function $5671aa7ae64fb35e$var$kt(t) {
    for(let e = 1; e < arguments.length; e++){
        const n = arguments[e];
        if (n) for(let e = 0, r = n.length; e < r; e++)t.push(n[e]);
    }
    return t.length;
}
const $5671aa7ae64fb35e$var$Nt = {};
function $5671aa7ae64fb35e$var$Lt(t, e) {
    if (!Array.isArray(e)) {
        const t = e;
        e = $5671aa7ae64fb35e$var$Nt[t] = $5671aa7ae64fb35e$var$Nt[t] || $5671aa7ae64fb35e$var$dt(e).array().map((t)=>t / 255);
    }
    for(let n = 0; n < e.length; n++)t[n] = e[n];
    return 3 === e.length && (t[3] = 1), t;
}
var $5671aa7ae64fb35e$export$aae4dafe84bb6c63 = Object.freeze({
    __proto__: null,
    base64URLToArrayBuffer: $5671aa7ae64fb35e$var$Ct,
    extend: $5671aa7ae64fb35e$var$pt,
    flatArr: $5671aa7ae64fb35e$var$xt,
    getAbsoluteURL: $5671aa7ae64fb35e$var$Tt,
    getBatchIdArrayType: $5671aa7ae64fb35e$var$It,
    isBase64: $5671aa7ae64fb35e$var$St,
    isFunction: $5671aa7ae64fb35e$var$bt,
    isNil: $5671aa7ae64fb35e$var$mt,
    isNumber: $5671aa7ae64fb35e$var$gt,
    isObject: $5671aa7ae64fb35e$var$yt,
    normalizeColor: $5671aa7ae64fb35e$var$Lt,
    pushIn: $5671aa7ae64fb35e$var$kt,
    setColumn3: $5671aa7ae64fb35e$var$At,
    sign: $5671aa7ae64fb35e$var$_t,
    stringFromUTF8Array: $5671aa7ae64fb35e$var$Ot,
    toDegree: $5671aa7ae64fb35e$var$vt,
    toRadian: $5671aa7ae64fb35e$var$wt
});
function $5671aa7ae64fb35e$var$Rt(t) {
    return -1 === t.indexOf("http://") && -1 === t.indexOf("https://") && -1 === t.indexOf("file://");
}
function $5671aa7ae64fb35e$var$Pt(t) {
    return (t = t || {}).referrerPolicy = t.referrerPolicy || "origin", t.referrer = window && window.location.href, t;
}
const $5671aa7ae64fb35e$var$Ut = function() {
    if ("undefined" != typeof globalThis) return globalThis;
    if ("undefined" != typeof self) return self;
    if ("undefined" != typeof window) return window;
    if ("undefined" != typeof $parcel$global) return $parcel$global;
    throw new Error("unable to locate global object");
}, $5671aa7ae64fb35e$var$Bt = $5671aa7ae64fb35e$var$Ut(), $5671aa7ae64fb35e$var$Gt = $5671aa7ae64fb35e$var$Bt.gl_trans__coders = $5671aa7ae64fb35e$var$Bt.gl_trans__coders || {};
/*!
 * @maptalks/gl v0.106.3
 * LICENSE : UNLICENSED
 * (c) 2016-2025 maptalks.com
 */ function $5671aa7ae64fb35e$var$Dt() {
    return $5671aa7ae64fb35e$var$Ut().maptalks_gltf_loader;
}
$5671aa7ae64fb35e$var$Gt.inject = function(t) {
    const e = t.toString(), n = e.indexOf("{") + 1, r = e.substring(0, n), s = $5671aa7ae64fb35e$var$Bt.gl_trans__coders = $5671aa7ae64fb35e$var$Bt.gl_trans__coders || {};
    let i = `${r}\n    const _____getGlobal = ${$5671aa7ae64fb35e$var$Ut.toString()};\n    const g___lobals = _____getGlobal()\n    const tran_____scoders = g___lobals['gl_trans__coders'] = g___lobals['gl_trans__coders'] || {};`;
    for(const t in s)"inject" !== t && "getTranscoder" !== t && "registerTranscoder" !== t && (i += 'tran_____scoders["' + t + '"] =' + s[t].toString() + "\n;");
    return i += "\n(" + $5671aa7ae64fb35e$var$Ut().maptalks_gltf_loader_bundle.toString() + ")({});\n", i += "\n" + e.substring(r.length), i;
}, $5671aa7ae64fb35e$var$Gt.registerTranscoder = function(t, e) {
    $5671aa7ae64fb35e$var$Gt[t] = e;
}, $5671aa7ae64fb35e$var$Gt.getTranscoder = function(t) {
    return $5671aa7ae64fb35e$var$Gt[t];
};
const $5671aa7ae64fb35e$var$Ft = "undefined" == typeof document ? null : document.createElement("canvas");
class $5671aa7ae64fb35e$var$jt extends $gP1US.worker.Actor {
    constructor(t, e, n){
        super(t), this.mapId = e, this.i = n;
    }
    initialize(t) {
        t(null);
    }
    loadTile(t, e, n) {
        let r = null;
        e && e.arraybuffer && (r = [
            e.arraybuffer
        ]);
        const s = {
            mapId: this.mapId,
            layerId: t,
            command: "loadTile",
            params: e
        };
        this.send(s, r, n);
    }
    abortTileLoading(t, e, n) {
        const r = {
            mapId: this.mapId,
            layerId: t,
            command: "abortTileLoading",
            params: {
                url: e
            }
        };
        this.broadcast(r, null, n);
    }
    addLayer(t, e, n) {
        const r = {
            actorId: this.actorId,
            mapId: this.mapId,
            layerId: t,
            command: "addLayer",
            params: {
                options: e
            }
        };
        this.broadcast(r, null, n);
    }
    removeLayer(t, e) {
        const n = {
            mapId: this.mapId,
            layerId: t,
            command: "removeLayer"
        };
        this.broadcast(n, null, e);
    }
    requestImage({ url: t }, e) {
        const n = new Image;
        n.onload = ()=>{
            if (!this.isActive()) return;
            if (!$5671aa7ae64fb35e$var$Ft) return void e(new Error("There is no canvas to draw image!"));
            const t = this.i ? n : function(t) {
                if ($5671aa7ae64fb35e$var$zt(t.width) && $5671aa7ae64fb35e$var$zt(t.height)) return t;
                let e = t.width, n = t.height;
                $5671aa7ae64fb35e$var$zt(e) || (e = $5671aa7ae64fb35e$var$Ht(e));
                $5671aa7ae64fb35e$var$zt(n) || (n = $5671aa7ae64fb35e$var$Ht(n));
                const r = document.createElement("canvas");
                r.width = e, r.height = n, r.getContext("2d").drawImage(t, 0, 0, e, n);
                const s = t.src, i = s.lastIndexOf("/") + 1, o = s.substring(i);
                return console.warn(`Texture(${o})'s size is not power of two, resize from (${t.width}, ${t.height}) to (${e}, ${n})`), r;
            }(n);
            $5671aa7ae64fb35e$var$Ft.width = t.width, $5671aa7ae64fb35e$var$Ft.height = t.height;
            const r = $5671aa7ae64fb35e$var$Ft.getContext("2d", {
                willReadFrequently: !0
            });
            r.drawImage(t, 0, 0, t.width, t.height);
            const s = r.getImageData(0, 0, t.width, t.height), i = {
                width: t.width,
                height: t.height,
                data: new Uint8Array(s.data)
            };
            e(null, i, [
                i.data.buffer
            ]);
        }, n.onerror = function(t) {
            e(t);
        }, n.src = t;
    }
}
function $5671aa7ae64fb35e$var$zt(t) {
    return !(t & t - 1) && 0 !== t;
}
function $5671aa7ae64fb35e$var$Ht(t) {
    return Math.pow(2, Math.floor(Math.log(t) / Math.LN2));
}
const { GLTFLoader: $5671aa7ae64fb35e$var$qt } = $5671aa7ae64fb35e$var$Dt();
function $5671aa7ae64fb35e$var$$t(t, e) {
    if (t.scenes && t.scenes.length) for(let n = 0, r = t.scenes.length; n < r; n++){
        const r = t.scenes[n].nodes;
        for(let n = 0, s = r.length; n < s; n++){
            const s = [];
            $5671aa7ae64fb35e$var$Wt(r[n], s, t, e);
        }
    }
}
const $5671aa7ae64fb35e$var$Vt = [], $5671aa7ae64fb35e$var$Jt = [], $5671aa7ae64fb35e$var$Yt = [], $5671aa7ae64fb35e$var$Zt = [
    0,
    0,
    0
], $5671aa7ae64fb35e$var$Kt = (0, $k1dpP).identity([]), $5671aa7ae64fb35e$var$Xt = [
    1,
    1,
    1
];
function $5671aa7ae64fb35e$var$Wt(t, e, n, r) {
    const s = e.slice(0);
    if (t.matrix) s.push(t.matrix);
    else if (t.rotation || t.translation || t.scale) {
        const e = (0, $3iqbd).fromTranslation($5671aa7ae64fb35e$var$Vt, t.translation || $5671aa7ae64fb35e$var$Zt), n = (0, $3iqbd).fromQuat($5671aa7ae64fb35e$var$Jt, t.rotation || $5671aa7ae64fb35e$var$Kt), r = (0, $3iqbd).fromScaling($5671aa7ae64fb35e$var$Yt, t.scale || $5671aa7ae64fb35e$var$Xt);
        (0, $3iqbd).multiply(r, n, r);
        const i = (0, $3iqbd).multiply([], e, r);
        s.push(i);
    }
    if (t.children && t.children.length) for(let e = 0, i = t.children.length; e < i; e++)$5671aa7ae64fb35e$var$Wt(t.children[e], s, n, r);
    if (void 0 !== t.mesh) {
        const e = t.mesh, i = n.meshes[e];
        if (i) {
            const t = s.slice(0), o = i.primitives;
            for(let s = 0, i = o.length; s < i; s++){
                const i = o[s];
                i && (i.matrices = t, r(i, e, s, n));
            }
        }
    }
}
function $5671aa7ae64fb35e$var$Qt(t, e, n) {
    let { byteOffset: r, byteStride: s } = e;
    const { componentType: i, itemSize: o } = e, a = e.array.buffer, c = i ? $5671aa7ae64fb35e$var$qt.getTypedArrayCtor(i) : e.array.constructor;
    if (r = void 0 === r ? e.array.byteOffset : r, s = s || 0, !s || s === o * c.BYTES_PER_ELEMENT && r % c.BYTES_PER_ELEMENT == 0) {
        const e = new c(a, r + n * o * c.BYTES_PER_ELEMENT, o);
        return t.set(e), t;
    }
    s || (s = o * c.BYTES_PER_ELEMENT);
    const l = new Uint8Array(a, s * n + r, o * c.BYTES_PER_ELEMENT);
    return new Uint8Array(t.buffer).set(l), t;
}
function $5671aa7ae64fb35e$var$te(t, e, n, r) {
    t[4 * e] = n[r], t[4 * e + 1] = n[r + 4], t[4 * e + 2] = n[r + 8], t[4 * e + 3] = n[r + 12];
}
var $5671aa7ae64fb35e$var$ee = "#include <gl2_vert>\n\nconst float SHIFT_RIGHT_11 = 1.0 / 2048.0;\n\nconst float SHIFT_RIGHT_5 = 1.0 / 32.0;\n\nconst float SHIFT_LEFT_11 = 2048.0;\n\nconst float SHIFT_LEFT_5 = 32.0;\n\nconst float NORMALIZE_6 = 1.0 / 64.0;\n\nconst float NORMALIZE_5 = 1.0 / 32.0;\n\n\n\n#ifdef HAS_POSITION\n\n    attribute vec3 POSITION;\n\n#endif\n\n\n\n#if defined(HAS_RGB)\n\n    attribute vec3 RGB;\n\n#elif defined(HAS_RGBA)\n\n    attribute vec4 RGBA;\n\n#elif defined(HAS_RGB565)\n\n    attribute float RGB565;\n\n#endif\n\n\n\nuniform vec4 pointColor;\n\nuniform float pointSize;\n\n\n\nuniform mat4 projViewModelMatrix;\n\nuniform float pointOpacity;\n\n\n\nvarying vec4 vColor;\n\n\n\n#ifdef HAS_NORMAL\n\n    #ifdef HAS_NORMAL_OCT16P\n\n        attribute vec2 NORMAL_OCT16P;\n\n        float signNotZero(float value) {\n\n            return value >= 0.0 ? 1.0 : -1.0;\n\n        }\n\n        vec2 signNotZero(vec2 value) {\n\n            return vec2(signNotZero(value.x), signNotZero(value.y));\n\n        }\n\n        vec3 octDecode(vec2 encoded, float range) {\n\n            if (encoded.x == 0.0 && encoded.y == 0.0) {\n\n                return vec3(0.0, 0.0, 0.0);\n\n            }\n\n            encoded = encoded / range * 2.0 - 1.0;\n\n            vec3 v = vec3(encoded.x, encoded.y, 1.0 - abs(encoded.x) - abs(encoded.y));\n\n            if (v.z < 0.0) {\n\n                v.xy = (1.0 - abs(v.yx)) * signNotZero(v.xy);\n\n            }\n\n            return normalize(v);\n\n        }\n\n        vec3 octDecode(vec2 encoded) {\n\n            return octDecode(encoded, 255.0);\n\n        }\n\n    #else\n\n        attribute vec3 NORMAL;\n\n    #endif\n\n    uniform vec3 lightDir;\n\n    uniform mat3 modelNormalMatrix;\n\n    uniform mat4 positionMatrix;\n\n    float getLambertDiffuse(vec3 lightDir, vec3 normal) {\n\n        return max(dot(-lightDir, normal), 0.0);\n\n    }\n\n#endif\n\n#ifdef PICKING_MODE\n\n    #include <fbo_picking_vert>\n\n#endif\n\n#include <draco_decode_vert>\n\nvoid main() {\n\n    #ifdef HAS_POSITION\n\n        vec3 localPos = decode_getPosition(POSITION);\n\n    #endif\n\n    gl_Position = projViewModelMatrix * vec4(localPos, 1.0);\n\n    gl_PointSize = pointSize;\n\n\n\n    #ifdef PICKING_MODE\n\n        fbo_picking_setData(gl_Position.w, true);\n\n    #else\n\n        #if defined(HAS_RGB)\n\n            vColor = vec4(RGB / 255.0, 1.0) * pointOpacity;\n\n        #elif defined(HAS_RGBA)\n\n            vColor = RGBA / 255.0 * pointOpacity;\n\n        #elif defined(HAS_RGB565)\n\n            float compressed = RGB565;\n\n            float r = floor(compressed * SHIFT_RIGHT_11);\n\n            compressed -= r * SHIFT_LEFT_11;\n\n            float g = floor(compressed * SHIFT_RIGHT_5);\n\n            compressed -= g * SHIFT_LEFT_5;\n\n            float b = compressed;\n\n            vec3 rgb = vec3(r * NORMALIZE_5, g * NORMALIZE_6, b * NORMALIZE_5);\n\n            vColor = vec4(rgb, 1.0);\n\n        #else\n\n            vColor = pointColor;\n\n        #endif\n\n\n\n        #ifdef HAS_NORMAL\n\n            mat3 positionNormalMatrix = mat3(positionMatrix);\n\n            mat3 normalMatrix = modelNormalMatrix * positionNormalMatrix;\n\n            #ifdef HAS_NORMAL_OCT16P\n\n                vec3 localNormal = octDecode(NORMAL_OCT16P);\n\n            #else\n\n                vec3 localNormal = NORMAL;\n\n            #endif\n\n            vec3 normal = normalize(normalMatrix * localNormal);\n\n            float colorStrength = getLambertDiffuse(lightDir, normal);\n\n            colorStrength = max(colorStrength, 0.5);\n\n            vColor *= colorStrength;\n\n        #endif\n\n    #endif\n\n\n\n\n\n\n\n\n\n}\n\n";
const $5671aa7ae64fb35e$var$ne = new Array(3), $5671aa7ae64fb35e$var$re = new Array(3), $5671aa7ae64fb35e$var$se = [
    40680631590769,
    40680631590769,
    40408299984661.445
];
function $5671aa7ae64fb35e$var$ie(t, e, n, r) {
    const s = $5671aa7ae64fb35e$var$se, i = Math.cos(n);
    $5671aa7ae64fb35e$var$ne[0] = i * Math.cos(e), $5671aa7ae64fb35e$var$ne[1] = i * Math.sin(e), $5671aa7ae64fb35e$var$ne[2] = Math.sin(n), $5671aa7ae64fb35e$var$be($5671aa7ae64fb35e$var$ne, $5671aa7ae64fb35e$var$ne), (0, $eIStk).multiply($5671aa7ae64fb35e$var$re, s, $5671aa7ae64fb35e$var$ne);
    const o = Math.sqrt((0, $eIStk).dot($5671aa7ae64fb35e$var$ne, $5671aa7ae64fb35e$var$re));
    var a, c, l;
    return c = $5671aa7ae64fb35e$var$re, l = o, (a = $5671aa7ae64fb35e$var$re)[0] = c[0] / l, a[1] = c[1] / l, a[2] = c[2] / l, (0, $eIStk).scale($5671aa7ae64fb35e$var$ne, $5671aa7ae64fb35e$var$ne, r), (0, $eIStk).add(t, $5671aa7ae64fb35e$var$re, $5671aa7ae64fb35e$var$ne);
}
const $5671aa7ae64fb35e$var$oe = [
    1 / 6378137,
    1 / 6378137,
    1 / 6356752.314245179
], $5671aa7ae64fb35e$var$ae = [
    1 / 40680631590769,
    1 / 40680631590769,
    1 / 40408299984661.445
], $5671aa7ae64fb35e$var$ce = new Array(3), $5671aa7ae64fb35e$var$le = new Array(3), $5671aa7ae64fb35e$var$he = new Array(3);
function $5671aa7ae64fb35e$var$ue(t, e) {
    const n = $5671aa7ae64fb35e$var$ae, r = function(t, e, n, r, s) {
        const i = e[0], o = e[1], a = e[2], c = n[0], l = n[1], h = n[2], u = i * i * c * c, f = o * o * l * l, d = a * a * h * h, m = u + f + d, p = Math.sqrt(1 / m), b = (0, $eIStk).scale($5671aa7ae64fb35e$var$fe, e, p);
        if (m < s) return isFinite(p) ? b : void 0;
        const y = r[0], g = r[1], w = r[2], T = $5671aa7ae64fb35e$var$de;
        T[0] = b[0] * y * 2, T[1] = b[1] * g * 2, T[2] = b[2] * w * 2;
        let _, M, O, A, x, I, S, C, k, N, L, E = (1 - p) * $5671aa7ae64fb35e$var$pe(e) / (.5 * $5671aa7ae64fb35e$var$pe(T)), R = 0;
        do {
            E -= R, O = 1 / (1 + E * y), A = 1 / (1 + E * g), x = 1 / (1 + E * w), I = O * O, S = A * A, C = x * x, k = I * O, N = S * A, L = C * x, _ = u * I + f * S + d * C - 1, M = u * k * y + f * N * g + d * L * w;
            R = _ / (-2 * M);
        }while (Math.abs(_) > $5671aa7ae64fb35e$var$me);
        return t[0] = i * O, t[1] = o * A, t[2] = a * x, t;
    }($5671aa7ae64fb35e$var$ce, e, $5671aa7ae64fb35e$var$oe, n, .1);
    let s = (0, $eIStk).mul($5671aa7ae64fb35e$var$le, r, n);
    s = $5671aa7ae64fb35e$var$be(s, s);
    const i = (0, $eIStk).sub($5671aa7ae64fb35e$var$he, e, r), o = Math.atan2(s[1], s[0]), a = Math.asin(s[2]), c = $5671aa7ae64fb35e$var$_t((0, $eIStk).dot(i, e)) * $5671aa7ae64fb35e$var$pe(i);
    return t[0] = $5671aa7ae64fb35e$var$vt(o), t[1] = $5671aa7ae64fb35e$var$vt(a), t[2] = c, t;
}
const $5671aa7ae64fb35e$var$fe = new Array(3), $5671aa7ae64fb35e$var$de = new Array(3), $5671aa7ae64fb35e$var$me = 1e-12;
function $5671aa7ae64fb35e$var$pe(t) {
    return (0, $eIStk).length(t);
}
function $5671aa7ae64fb35e$var$be(t, e) {
    const n = e[0], r = e[1], s = e[2];
    let i = n * n + r * r + s * s;
    return i > 0 && (i = Math.sqrt(i), t[0] = e[0] / i, t[1] = e[1] / i, t[2] = e[2] / i), t;
}
function $5671aa7ae64fb35e$var$ye(t, e) {
    return (0, $eIStk).multiply(e, t, $5671aa7ae64fb35e$var$ae), (0, $eIStk).normalize(e, e);
}
function $5671aa7ae64fb35e$var$ge(t, e) {
    const n = t[0], r = t[1], s = Math.cos(r), i = s * Math.cos(n), o = s * Math.sin(n), a = Math.sin(r);
    return e.x = i, e.y = o, e.z = a, (0, $eIStk).normalize(e, e);
}
var $5671aa7ae64fb35e$export$b4254dbf0be38ff8 = Object.freeze({
    __proto__: null,
    cartesian3ToDegree: $5671aa7ae64fb35e$var$ue,
    geodeticSurfaceNormal: $5671aa7ae64fb35e$var$ye,
    geodeticSurfaceNormalCartographic: $5671aa7ae64fb35e$var$ge,
    normalizeCartesian: $5671aa7ae64fb35e$var$be,
    radianToCartesian3: $5671aa7ae64fb35e$var$ie
});
function $5671aa7ae64fb35e$var$ve(t, e, n, r) {
    n = n || 0, r = r || n;
    const s = Math.abs(t - e);
    return s <= r || s <= n * Math.max(Math.abs(t), Math.abs(e));
}
function $5671aa7ae64fb35e$var$Te(t, e) {
    let n = "";
    for(let r = 0; r < 4; r++){
        const s = t.getUint8(e + r);
        n += String.fromCharCode(s);
    }
    return n;
}
const $5671aa7ae64fb35e$var$_e = "undefined" != typeof TextDecoder ? new TextDecoder("utf-8") : null;
function $5671aa7ae64fb35e$var$Me(t, e, n) {
    const r = new Uint8Array(t, e, n);
    return $5671aa7ae64fb35e$var$_e ? JSON.parse($5671aa7ae64fb35e$var$_e.decode(r)) : JSON.parse($5671aa7ae64fb35e$var$Ot(r));
}
function $5671aa7ae64fb35e$var$Oe(t, e, n) {
    const r = new Uint8Array(t, e, n);
    return $5671aa7ae64fb35e$var$_e ? JSON.parse($5671aa7ae64fb35e$var$_e.decode(r)) : JSON.parse($5671aa7ae64fb35e$var$Ot(r));
}
function $5671aa7ae64fb35e$var$Ae(t, e, n) {
    return {
        offset: e,
        byteLength: n
    };
}
function $5671aa7ae64fb35e$var$xe(t, e, n, r) {
    const { byteOffset: s, componentType: i, type: o } = t, { ctor: a, type: c } = $5671aa7ae64fb35e$var$Le(i || "UNSIGNED_SHORT"), l = $5671aa7ae64fb35e$var$ke(o);
    return {
        byteStride: 0,
        byteOffset: s + n,
        itemSize: l,
        count: r * l,
        componentType: c,
        array: new a(e, n + s, r * l)
    };
}
function $5671aa7ae64fb35e$var$Ie(t, e, n, r) {
    const s = $5671aa7ae64fb35e$var$xe(t, e, n, r);
    return s.array.buffer.byteLength !== e.byteLength && (s.array = s.array.slice()), s;
}
function $5671aa7ae64fb35e$var$Se(t, e, n, r) {
    const { byteOffset: s, componentType: i, type: o } = t, { ctor: a } = $5671aa7ae64fb35e$var$Le(i || "UNSIGNED_SHORT"), c = $5671aa7ae64fb35e$var$ke(o), l = new a(e, s, n * c);
    return 1 === c ? l[r] : l.subarray(r * c, r * c + c);
}
const $5671aa7ae64fb35e$var$Ce = {
    "SCALAR": 1,
    "VEC2": 2,
    "VEC3": 3,
    "VEC4": 4
};
function $5671aa7ae64fb35e$var$ke(t) {
    return t ? $5671aa7ae64fb35e$var$Ce[t] : 1;
}
const $5671aa7ae64fb35e$var$Ne = {
    "BYTE": {
        ctor: Int8Array,
        type: 5120,
        name: "Int8Array"
    },
    "UNSIGNED_BYTE": {
        ctor: Uint8Array,
        type: 5121,
        name: "Uint8Array"
    },
    "SHORT": {
        ctor: Int16Array,
        type: 5122,
        name: "Int16Array"
    },
    "UNSIGNED_SHORT": {
        ctor: Uint16Array,
        type: 5123,
        name: "Uint16Array"
    },
    "INT": {
        ctor: Int32Array,
        type: 5124,
        name: "Int32Array"
    },
    "UNSIGNED_INT": {
        ctor: Uint32Array,
        type: 5125,
        name: "Uint32Array"
    },
    "FLOAT": {
        ctor: Float32Array,
        type: 5126,
        name: "Float32Array"
    },
    "DOUBLE": {
        ctor: Float64Array,
        type: 5126,
        name: "Float64Array"
    }
};
function $5671aa7ae64fb35e$var$Le(t) {
    return $5671aa7ae64fb35e$var$Ne[t];
}
function $5671aa7ae64fb35e$var$Ee(t) {
    for(const e in $5671aa7ae64fb35e$var$Ne)if (t === $5671aa7ae64fb35e$var$Ne[e].ctor) return $5671aa7ae64fb35e$var$Ne[e].type;
    throw new Error("unrecognized ctor:" + t);
}
function $5671aa7ae64fb35e$var$Re(t, e, n, r) {
    const s = t, i = e.length / 3;
    for(let t = 0; t < i; t++)s[3 * t] = e[3 * t] / 65535 * r[0] + n[0], s[3 * t + 1] = e[3 * t + 1] / 65535 * r[1] + n[1], s[3 * t + 2] = e[3 * t + 2] / 65535 * r[2] + n[2];
    return s;
}
function $5671aa7ae64fb35e$var$Pe(t, e, n) {
    const r = t.getUint32(12, !0), s = t.getUint32(16, !0), i = t.getUint32(20, !0), o = t.getUint32(24, !0), a = t.buffer;
    let c, l = {}, h = {}, u = null;
    r > 0 && (l = $5671aa7ae64fb35e$var$Me(a, e, r), e += r), s > 0 && (c = function(t, e, n) {
        return {
            offset: e,
            byteLength: n
        };
    }(0, e, s), e += s), i > 0 && (h = $5671aa7ae64fb35e$var$Oe(a, e, i), e += i);
    const f = $5671aa7ae64fb35e$var$Ae(0, e, o);
    return u = a.slice(f.offset, f.offset + f.byteLength), n.push(u), {
        featureTable: l,
        featureTableBin: c,
        batchTable: h,
        batchTableBin: u
    };
}
const $5671aa7ae64fb35e$var$Ue = {
    up: {
        south: "east",
        north: "west",
        west: "south",
        east: "north"
    },
    down: {
        south: "west",
        north: "east",
        west: "north",
        east: "south"
    },
    south: {
        up: "west",
        down: "east",
        west: "down",
        east: "up"
    },
    north: {
        up: "east",
        down: "west",
        west: "up",
        east: "down"
    },
    west: {
        up: "north",
        down: "south",
        north: "down",
        south: "up"
    },
    east: {
        up: "south",
        down: "north",
        north: "up",
        south: "down"
    }
}, $5671aa7ae64fb35e$var$Be = {
    north: [
        -1,
        0,
        0
    ],
    east: [
        0,
        1,
        0
    ],
    up: [
        0,
        0,
        1
    ],
    south: [
        1,
        0,
        0
    ],
    west: [
        0,
        -1,
        0
    ],
    down: [
        0,
        0,
        -1
    ]
}, $5671aa7ae64fb35e$var$Ge = {}, $5671aa7ae64fb35e$var$De = {
    east: [],
    north: [],
    up: [],
    west: [],
    south: [],
    down: []
};
let $5671aa7ae64fb35e$var$Fe = [], $5671aa7ae64fb35e$var$je = [], $5671aa7ae64fb35e$var$ze = [];
const $5671aa7ae64fb35e$var$He = [
    0,
    0,
    0
];
function $5671aa7ae64fb35e$var$qe(t, e, n) {
    return n[0] = t[0], n[1] = t[1], n[2] = t[2], n[3] = t[3], n[4] = t[4], n[5] = t[5], n[6] = t[6], n[7] = t[7], n[8] = t[8], n[9] = t[9], n[10] = t[10], n[11] = t[11], n[12] = e[0], n[13] = e[1], n[14] = e[2], n[15] = t[15], n;
}
const $5671aa7ae64fb35e$var$$e = function(t, e) {
    const n = $5671aa7ae64fb35e$var$Ue[t][e];
    let r;
    const s = t + e;
    return $5671aa7ae64fb35e$var$Ge[s] ? r = $5671aa7ae64fb35e$var$Ge[s] : (r = function(r, s, i) {
        if ((0, $eIStk).equals(r, $5671aa7ae64fb35e$var$He)) (0, $eIStk).copy($5671aa7ae64fb35e$var$Fe, $5671aa7ae64fb35e$var$Be[t]), (0, $eIStk).copy($5671aa7ae64fb35e$var$je, $5671aa7ae64fb35e$var$Be[e]), (0, $eIStk).copy($5671aa7ae64fb35e$var$ze, $5671aa7ae64fb35e$var$Be[n]);
        else if ($5671aa7ae64fb35e$var$ve(r[0], 0, 1e-14) && $5671aa7ae64fb35e$var$ve(r[1], 0, 1e-14)) {
            const s = $5671aa7ae64fb35e$var$_t(r[2]);
            (0, $eIStk).copy($5671aa7ae64fb35e$var$Fe, $5671aa7ae64fb35e$var$Be[t]), (0, $eIStk).copy($5671aa7ae64fb35e$var$je, $5671aa7ae64fb35e$var$Be[e]), (0, $eIStk).scale($5671aa7ae64fb35e$var$je, $5671aa7ae64fb35e$var$je, s), (0, $eIStk).copy($5671aa7ae64fb35e$var$ze, $5671aa7ae64fb35e$var$Be[n]), (0, $eIStk).scale($5671aa7ae64fb35e$var$ze, $5671aa7ae64fb35e$var$ze, s);
        } else {
            $5671aa7ae64fb35e$var$ye(r, $5671aa7ae64fb35e$var$De.up);
            const s = $5671aa7ae64fb35e$var$De.up, i = $5671aa7ae64fb35e$var$De.east;
            i[0] = -r[1], i[1] = r[0], i[2] = 0, (0, $eIStk).normalize($5671aa7ae64fb35e$var$De.east, i), (0, $eIStk).cross($5671aa7ae64fb35e$var$De.north, s, i), (0, $eIStk).scale($5671aa7ae64fb35e$var$De.down, $5671aa7ae64fb35e$var$De.up, -1), (0, $eIStk).scale($5671aa7ae64fb35e$var$De.west, $5671aa7ae64fb35e$var$De.east, -1), (0, $eIStk).scale($5671aa7ae64fb35e$var$De.south, $5671aa7ae64fb35e$var$De.north, -1), $5671aa7ae64fb35e$var$Fe = $5671aa7ae64fb35e$var$De[t], $5671aa7ae64fb35e$var$je = $5671aa7ae64fb35e$var$De[e], $5671aa7ae64fb35e$var$ze = $5671aa7ae64fb35e$var$De[n];
        }
        return i[0] = $5671aa7ae64fb35e$var$Fe[0], i[1] = $5671aa7ae64fb35e$var$Fe[1], i[2] = $5671aa7ae64fb35e$var$Fe[2], i[3] = 0, i[4] = $5671aa7ae64fb35e$var$je[0], i[5] = $5671aa7ae64fb35e$var$je[1], i[6] = $5671aa7ae64fb35e$var$je[2], i[7] = 0, i[8] = $5671aa7ae64fb35e$var$ze[0], i[9] = $5671aa7ae64fb35e$var$ze[1], i[10] = $5671aa7ae64fb35e$var$ze[2], i[11] = 0, i[12] = r[0], i[13] = r[1], i[14] = r[2], i[15] = 1, i;
    }, $5671aa7ae64fb35e$var$Ge[s] = r), r;
}("east", "north"), $5671aa7ae64fb35e$var$Ve = [], $5671aa7ae64fb35e$var$Je = [], $5671aa7ae64fb35e$var$Ye = [], $5671aa7ae64fb35e$var$Ze = [], $5671aa7ae64fb35e$var$Ke = [], $5671aa7ae64fb35e$var$Xe = [], $5671aa7ae64fb35e$var$We = [], $5671aa7ae64fb35e$var$Qe = {
    x: 0,
    y: 0
}, $5671aa7ae64fb35e$var$tn = {
    x: 0,
    y: 0
}, $5671aa7ae64fb35e$var$en = Math.PI / 180;
let $5671aa7ae64fb35e$var$nn;
const $5671aa7ae64fb35e$var$rn = {
    width: 100,
    height: 10
};
let $5671aa7ae64fb35e$var$sn = !1;
try {
    const t = new OffscreenCanvas(1, 1);
    t.getContext("2d").fillText("hello", 0, 0), $5671aa7ae64fb35e$var$sn = !0;
} catch (t) {
    $5671aa7ae64fb35e$var$sn = !1;
}
function $5671aa7ae64fb35e$var$on() {
    if (!$5671aa7ae64fb35e$var$nn) {
        const { width: t, height: e } = $5671aa7ae64fb35e$var$rn;
        $5671aa7ae64fb35e$var$sn ? $5671aa7ae64fb35e$var$nn = new OffscreenCanvas(t, e) : ($5671aa7ae64fb35e$var$nn = document.createElement("canvas"), $5671aa7ae64fb35e$var$nn.width = t, $5671aa7ae64fb35e$var$nn.height = e);
    }
    return $5671aa7ae64fb35e$var$nn;
}
class $5671aa7ae64fb35e$var$an {
    constructor(t, e = {}){
        if (!Array.isArray(t)) return void console.error("colors is not array");
        if (t.length < 2) return void console.error("colors.length should >1");
        this.colors = t;
        let n = 1 / 0, r = -1 / 0;
        for(let e = 0, s = t.length; e < s; e++){
            const s = t[e][0];
            n = Math.min(s, n), r = Math.max(s, r);
        }
        this.min = n, this.max = r, this.valueOffset = this.max - this.min, this.options = Object.assign({}, $5671aa7ae64fb35e$var$rn, e), this.o();
    }
    getImageData() {
        return this.imgData;
    }
    o() {
        const t = $5671aa7ae64fb35e$var$on(), { width: e, height: n } = this.options;
        t.width = e, t.height = n;
        const r = t.getContext("2d");
        r.clearRect(0, 0, t.width, t.height);
        const s = r.createLinearGradient(0, 0, t.width, 0), { colors: i, valueOffset: o } = this;
        for(let t = 0, e = i.length; t < e; t++){
            const [e, n] = i[t], r = (e - this.min) / o;
            s.addColorStop(r, n);
        }
        r.fillStyle = s, r.fillRect(0, 0, t.width, t.height), this.imgData = r.getImageData(0, 0, t.width, t.height);
    }
    getColor(t) {
        t = Math.max(this.min, t);
        const e = ((t = Math.min(t, this.max)) - this.min) / this.valueOffset;
        let n = Math.round(e * this.imgData.width);
        n = Math.min(n, this.imgData.width - 1);
        const r = 4 * n;
        return [
            this.imgData.data[r],
            this.imgData.data[r + 1],
            this.imgData.data[r + 2],
            this.imgData.data[r + 3]
        ];
    }
}
var $5671aa7ae64fb35e$var$cn;
function $5671aa7ae64fb35e$var$ln(t) {
    return null == t;
}
function $5671aa7ae64fb35e$var$hn(t) {
    return !$5671aa7ae64fb35e$var$ln(t);
}
function $5671aa7ae64fb35e$var$un(t) {
    return "" === t;
}
function $5671aa7ae64fb35e$var$fn(t, e) {
    var n, r, s;
    if ($5671aa7ae64fb35e$var$_n(t)) {
        var i, o = t.stops && "object" == typeof t.stops[0][0], a = o || $5671aa7ae64fb35e$var$hn(t.property), c = o || !a, l = t.type || e || "exponential";
        if ("exponential" === l) i = $5671aa7ae64fb35e$var$pn;
        else if ("interval" === l) i = $5671aa7ae64fb35e$var$mn;
        else if ("categorical" === l) i = $5671aa7ae64fb35e$var$dn;
        else if ("identity" === l) i = $5671aa7ae64fb35e$var$gn;
        else if ("color-interpolate" === l) i = $5671aa7ae64fb35e$var$yn;
        else {
            if ("calculate-expression" !== l) throw new Error('Unknown function type "' + l + '"');
            i = $5671aa7ae64fb35e$var$wn;
        }
        if (o) {
            var h = {}, u = [];
            for(let e = 0; e < t.stops.length; e++){
                var f = t.stops[e];
                void 0 === h[f[0].zoom] && (h[f[0].zoom] = {
                    zoom: f[0].zoom,
                    type: t.type,
                    property: t.property,
                    default: t.default,
                    stops: []
                }), h[f[0].zoom].stops.push([
                    f[0].value,
                    f[1]
                ]);
            }
            for(let t in h)u.push([
                h[t].zoom,
                $5671aa7ae64fb35e$var$fn(h[t])
            ]);
            n = function(e, n) {
                const r = $5671aa7ae64fb35e$var$pn({
                    stops: u,
                    base: t.base
                }, e)(e, n);
                return "function" == typeof r ? r(e, n) : r;
            }, r = !1, s = !1;
        } else c ? (n = function(e) {
            const n = i(t, e);
            return "function" == typeof n ? n(e) : n;
        }, r = !0, s = !1) : (n = function(e, n) {
            const r = i(t, n ? n[t.property] : null);
            return "function" == typeof r ? r(e, n) : r;
        }, r = !1, s = !0);
    } else n = function() {
        return t;
    }, r = !0, s = !0;
    return n.isZoomConstant = s, n.isFeatureConstant = r, n;
}
function $5671aa7ae64fb35e$var$dn(t, e) {
    for(let n = 0; n < t.stops.length; n++)if (e === t.stops[n][0]) return t.stops[n][1];
    return t.default;
}
function $5671aa7ae64fb35e$var$mn(t, e) {
    for(var n = 0; n < t.stops.length && !(e < t.stops[n][0]); n++);
    return t.stops[Math.max(n - 1, 0)][1];
}
function $5671aa7ae64fb35e$var$pn(t, e) {
    for(var n = $5671aa7ae64fb35e$var$hn(t.base) && !$5671aa7ae64fb35e$var$un(t.base) ? t.base : 1, r = 0; !(r >= t.stops.length || e <= t.stops[r][0]);)r++;
    return 0 === r ? t.stops[r][1] : r === t.stops.length ? t.stops[r - 1][1] : $5671aa7ae64fb35e$var$vn(e, n, t.stops[r - 1][0], t.stops[r][0], t.stops[r - 1][1], t.stops[r][1]);
}
"function" == typeof Map && ($5671aa7ae64fb35e$var$cn = new Map);
const $5671aa7ae64fb35e$var$bn = {
    width: 100,
    height: 1
};
function $5671aa7ae64fb35e$var$yn(t, e) {
    const n = t.stops;
    if (n && n.length > 1) {
        let t;
        if ($5671aa7ae64fb35e$var$cn) {
            const e = JSON.stringify(n);
            if (!$5671aa7ae64fb35e$var$cn.has(e)) {
                const t = new $5671aa7ae64fb35e$var$an(n, $5671aa7ae64fb35e$var$bn);
                $5671aa7ae64fb35e$var$cn.set(e, t);
            }
            t = $5671aa7ae64fb35e$var$cn.get(e);
        } else t = new $5671aa7ae64fb35e$var$an(n, $5671aa7ae64fb35e$var$bn);
        const [r, s, i, o] = t.getColor(e);
        return [
            r / 255,
            s / 255,
            i / 255,
            o / 255
        ];
    }
    return n && 1 === n.length ? n[0][1] : null;
}
function $5671aa7ae64fb35e$var$gn(t, e) {
    var n, r, s;
    return n = e, r = t.default, $5671aa7ae64fb35e$var$hn(n) ? n : $5671aa7ae64fb35e$var$hn(r) ? r : $5671aa7ae64fb35e$var$hn(s) ? s : null;
}
function $5671aa7ae64fb35e$var$wn(t, e) {
    const n = String(t.property), r = t.expression, s = e;
    function i(e) {
        return $5671aa7ae64fb35e$var$ln(e) || $5671aa7ae64fb35e$var$un(e) || isNaN(e) ? t.default : e;
    }
    if (!$5671aa7ae64fb35e$var$hn(e) || $5671aa7ae64fb35e$var$un(e) || isNaN(e) || e < 0) return i(t.default);
    {
        const e = function t(e, n, r) {
            const s = Number(r), i = String(n);
            return Array.isArray(e) ? e.map((e)=>t(e, i, s)) : e === i ? s : e;
        }(r, n, s);
        return i(function e(n) {
            if (!Array.isArray(n)) {
                if ("number" == typeof n) return n;
                throw new Error("Invalid expression format");
            }
            {
                const r = n[0];
                if (![
                    "+",
                    "-",
                    "*",
                    "/"
                ].includes(r)) throw new Error(`Unknown operator: ${r}`);
                const s = n.slice(1).map((t)=>e(t));
                switch(r){
                    case "+":
                        return s.reduce((t, e)=>t + e, 0);
                    case "-":
                        return s.reduce((t, e)=>t - e);
                    case "*":
                        return s.reduce((t, e)=>t * e, 1);
                    case "/":
                        return s.some((t)=>0 === t) ? t.default : s.reduce((t, e)=>t / e);
                    default:
                        throw new Error(`Unsupported operator: ${r}`);
                }
            }
        }(e));
    }
}
function $5671aa7ae64fb35e$var$vn(t, e, n, r, s, i) {
    return "function" == typeof s ? function() {
        var o = s.apply(void 0, arguments), a = i.apply(void 0, arguments);
        return $5671aa7ae64fb35e$var$vn(t, e, n, r, o, a);
    } : s.length ? function(t, e, n, r, s, i) {
        var o = [];
        for(let a = 0; a < s.length; a++)o[a] = $5671aa7ae64fb35e$var$Tn(t, e, n, r, s[a], i[a]);
        return o;
    }(t, e, n, r, s, i) : $5671aa7ae64fb35e$var$Tn(t, e, n, r, s, i);
}
function $5671aa7ae64fb35e$var$Tn(t, e, n, r, s, i) {
    var o, a = r - n, c = t - n;
    return s * (1 - (o = 1 === e ? c / a : (Math.pow(e, c) - 1) / (Math.pow(e, a) - 1))) + i * o;
}
function $5671aa7ae64fb35e$var$_n(t) {
    return t && "object" == typeof t && (t.stops || t.property && "identity" === t.type || t.expression && "calculate-expression" === t.type);
}
function $5671aa7ae64fb35e$var$Mn(t) {
    return $5671aa7ae64fb35e$var$On(t, "exponential");
}
function $5671aa7ae64fb35e$var$On(t, e) {
    if (!$5671aa7ae64fb35e$var$_n(t)) return function() {
        return t;
    };
    let n = !0, r = !0;
    const s = (t = JSON.parse(JSON.stringify(t))).stops;
    if (s) {
        for(let t = 0; t < s.length; t++)if ($5671aa7ae64fb35e$var$_n(s[t][1])) {
            const i = $5671aa7ae64fb35e$var$On(s[t][1], e);
            n = n && i.isZoomConstant, r = r && i.isFeatureConstant, s[t] = [
                s[t][0],
                i
            ];
        }
    }
    const i = $5671aa7ae64fb35e$var$fn(t, e);
    return i.isZoomConstant = n && i.isZoomConstant, i.isFeatureConstant = r && i.isFeatureConstant, i;
}
const { getTextureMagFilter: $5671aa7ae64fb35e$var$An, getTextureMinFilter: $5671aa7ae64fb35e$var$xn, getTextureWrap: $5671aa7ae64fb35e$var$In, getMaterialType: $5671aa7ae64fb35e$var$Sn, getMaterialFormat: $5671aa7ae64fb35e$var$Cn, getPrimitive: $5671aa7ae64fb35e$var$kn, getUniqueREGLBuffer: $5671aa7ae64fb35e$var$Nn } = (0, $2wazW).REGLHelper, $5671aa7ae64fb35e$var$Ln = [
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    -1,
    0,
    0,
    0,
    0,
    0,
    1
], $5671aa7ae64fb35e$var$En = [
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    -1,
    0,
    0,
    0,
    0,
    0,
    0,
    1
], { loginIBLResOnCanvas: $5671aa7ae64fb35e$var$Rn, logoutIBLResOnCanvas: $5671aa7ae64fb35e$var$Pn, getIBLResOnCanvas: $5671aa7ae64fb35e$var$Un, getPBRUniforms: $5671aa7ae64fb35e$var$Bn } = (0, $2wazW).pbr.PBRUtils, $5671aa7ae64fb35e$var$Gn = {
    factor: 0,
    units: 0
}, $5671aa7ae64fb35e$var$Dn = [
    1,
    1,
    1,
    1
], $5671aa7ae64fb35e$var$Fn = [
    0,
    0,
    0
], $5671aa7ae64fb35e$var$jn = {
    specularStrength: 0,
    materialShininess: 1
}, $5671aa7ae64fb35e$var$zn = [
    1,
    1,
    1
], $5671aa7ae64fb35e$var$Hn = (0, $3iqbd).identity([]), $5671aa7ae64fb35e$var$qn = [
    0,
    0,
    0
], $5671aa7ae64fb35e$var$$n = [
    0,
    0
], $5671aa7ae64fb35e$var$Vn = [], $5671aa7ae64fb35e$var$Jn = (t)=>t.material instanceof (0, $2wazW).PhongMaterial, $5671aa7ae64fb35e$var$Yn = (t)=>t.material instanceof (0, $2wazW).pbr.StandardMaterial, $5671aa7ae64fb35e$var$Zn = [], $5671aa7ae64fb35e$var$Kn = new $gP1US.Coordinate(0, 0), $5671aa7ae64fb35e$var$Xn = new $gP1US.Point(0, 0), $5671aa7ae64fb35e$var$Wn = new $gP1US.Point(0, 0), $5671aa7ae64fb35e$var$Qn = new $gP1US.Point(0, 0), $5671aa7ae64fb35e$var$tr = [], $5671aa7ae64fb35e$var$er = [], $5671aa7ae64fb35e$var$nr = [], $5671aa7ae64fb35e$var$rr = [], $5671aa7ae64fb35e$var$sr = [], $5671aa7ae64fb35e$var$ir = [], $5671aa7ae64fb35e$var$or = [], $5671aa7ae64fb35e$var$ar = [], $5671aa7ae64fb35e$var$cr = [], $5671aa7ae64fb35e$var$lr = [], $5671aa7ae64fb35e$var$hr = [], $5671aa7ae64fb35e$var$ur = [], $5671aa7ae64fb35e$var$fr = [], $5671aa7ae64fb35e$var$dr = [], $5671aa7ae64fb35e$var$mr = {
    "POSITION": "POSITION",
    "NORMAL": "NORMAL",
    "TEXCOORD_0": "TEXCOORD_0",
    "TEXCOORD_1": "TEXCOORD_1",
    "COLOR_0": "COLOR_0",
    "TANGENT": "TANGENT",
    "_BATCHID": "_BATCHID"
}, $5671aa7ae64fb35e$var$pr = [
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    0,
    0,
    4,
    1,
    5,
    2,
    6,
    3,
    7,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    4
], $5671aa7ae64fb35e$var$br = function(t, e) {
    const n = 2 * Math.PI / t, r = [], s = [];
    for(let s = 0; s <= t; s++){
        const t = Math.cos(n * s) * e, i = Math.sin(n * s) * e, o = 0;
        r[3 * s] = t, r[3 * s + 1] = i, r[3 * s + 2] = o;
    }
    for(let s = t; s <= 2 * t; s++){
        const t = Math.cos(n * s) * e, i = Math.sin(n * s) * e, o = 0;
        r[3 * s] = o, r[3 * s + 1] = t, r[3 * s + 2] = i;
    }
    for(let s = 2 * t; s <= 3 * t; s++){
        const t = Math.cos(n * s) * e, i = Math.sin(n * s) * e, o = 0;
        r[3 * s] = t, r[3 * s + 1] = o, r[3 * s + 2] = i;
    }
    const i = r.length / 3 - 1;
    for(let e = 0; e < i; e++)e !== t - 1 && e !== 2 * t - 1 && (s[2 * e] = e, s[2 * e + 1] = e + 1);
    return r.push(0, 0, 0), r.push(e, 0, 0), r.push(0, e, 0), r.push(0, 0, e), s.push(i + 1, i + 2), s.push(i + 1, i + 3), s.push(i + 1, i + 4), {
        vertices: r,
        indices: s
    };
}(100, 1), $5671aa7ae64fb35e$var$yr = [
    0,
    0,
    0,
    1
], $5671aa7ae64fb35e$var$gr = [
    1,
    1,
    1
];
class $5671aa7ae64fb35e$var$wr {
    constructor(t, e){
        this.h = e, this.u = e.getRenderer().canvas, this.pickingFBO = e.getRenderer().pickingFBO, this.m = t, this.p = new (0, $2wazW).Renderer(t), this.v = {}, this.T = {}, this._ = {}, this.M = {}, this.O = {}, this.A = {}, this.I = new (0, $2wazW).Scene, this.S = new (0, $2wazW).Scene, this.C = new (0, $2wazW).Scene, this.k = new (0, $2wazW).Scene, this.N = new (0, $2wazW).ResourceLoader(t.texture(2)), this.L = (...t)=>this.R.call(this, ...t), this.P = new (0, $2wazW).KHRTechniquesWebglManager(this.m, this.U(), this.N);
        const r = this.getMap();
        this.B = r.altitudeToPoint(100, r.getGLRes()) / 100;
    }
    getI3DMMeshes() {
        return this.M;
    }
    getPNTSMeshes() {
        return this._;
    }
    getB3DMMeshes() {
        return this.T;
    }
    getPaintedMeshes() {
        return this.G;
    }
    getMap() {
        return this.h.getMap();
    }
    paint(t, e, n) {
        const o = n && n.renderTarget, a = n && n.sceneFilter, c = this.getMap();
        if (!t.length || !c) return null;
        const l = this.D(), h = c.projViewMatrix, u = [], f = [], d = [], m = [], b = [];
        for(let e = 0, i = t.length; e < i; e++){
            const i = t[e].data.node;
            let o = this.F(i);
            if (!o) continue;
            const a = this.h.j(i.H), c = a.debugNodes, l = a.heightOffset || 0, y = a.coordOffset || $5671aa7ae64fb35e$var$$n;
            this.O[i.id] && (o = this.O[i.id], o = $5671aa7ae64fb35e$var$xt(o));
            let g = a.polygonOffset || $5671aa7ae64fb35e$var$Gn;
            $5671aa7ae64fb35e$var$bt(g) && (g = g()), Array.isArray(o) || (u[0] = o, o = u);
            for(let u = 0, w = o.length; u < w; u++){
                if (!o[u] || !o[u].isValid || !o[u].isValid()) continue;
                const w = o[u].properties.magic;
                if (o[u].properties.heightOffset === l && o[u].properties.coordOffset[0] === y[0] && o[u].properties.coordOffset[1] === y[1] || (this.q(o[u]), o[u].$ = (0, $3iqbd).copy([], o[u].localTransform)), o[u].V = i, "b3dm" === w) {
                    if (o[u].getBoundingBox && !(0, $9b5be2c4f6c5fa19$export$25ea4bdae27a952b)(h, o[u].getBoundingBox())) continue;
                    const { batchIdData: t, batchIdMap: e } = o[u].geometry.properties;
                    if (t && e) {
                        const t = o[u].properties.node.H;
                        this.J && this.J[t] ? (0, $9e7Ip.HighlightUtil).highlightMesh(this.m, o[u], this.J[t], this.Y, e) : this.J && this.J[t] || (0, $9e7Ip.HighlightUtil).highlightMesh(this.m, o[u], null, this.Y, e), (0, $9e7Ip.HighlightUtil).showOnly(this.m, o[u], this.Z && this.Z[t], this.K, e);
                    }
                    if (c && c.length && c.indexOf(o[u].V.id) < 0) continue;
                    n && n.bloom && o[u].properties.hlBloomMesh && (o[u].properties.hlBloomMesh.properties.depthFunc = "always", d.push(o[u].properties.hlBloomMesh)), d.push(o[u]);
                } else "pnts" === w ? m.push(o[u]) : "i3dm" === w && b.push(o[u]);
                o[u].properties.isLeaf = t[e].leave, o[u].properties.branchRootId = t[e].branchRootId;
                const v = 255 - t[e].selectionDepth;
                o[u].properties.selectionDepth = v, o[u].properties.polygonOffset = g;
                const T = void 0 === a.cullFace || !!a.cullFace;
                o[u].properties.cullFace = T;
                const _ = o[u].properties.hlBloomMesh;
                if (_) {
                    const n = _.properties;
                    n.branchRootId = t[e].branchRootId, n.selectionDepth = v, n.polygonOffset = g, n.cullFace = T;
                }
                t[e].leave || f.push(o[u]), this.X(o[u]), this.W(o[u], i);
            }
        }
        let y = 0;
        const g = this.P.getExcludeFilter();
        (0, $9e7Ip.ContextUtil).setIncludeUniformValues(l, n), y += this.tt(this.et, l, [
            a,
            $5671aa7ae64fb35e$var$Jn,
            g
        ], o, f, d, b), y += this.tt(this.nt, l, [
            a,
            $5671aa7ae64fb35e$var$Yn,
            g
        ], o, f, d, b), this.P.forEachShader((t, e, n)=>{
            const r = this.D(n);
            y += this.tt(t, r, [
                a,
                e
            ], o, f, d, b);
        }), this.S.setMeshes(m);
        const w = this.rt();
        return y += this.p.render(this.st, w, this.S, o && o.fbo), this.G = {
            pntsMeshes: m,
            i3dmMeshes: b,
            b3dmMeshes: d
        }, this.k.setMeshes(e), this.p.render(this.it, l, this.k, o && o.fbo), y;
    }
    prepareRender(t) {
        this.ot(t);
    }
    ot(t) {
        t && t.states && t.states.includesChanged && (this.nt.dispose(), delete this.nt, this.et.dispose(), delete this.et), this.ct(t);
    }
    tt(t, e, n, r, s, i, o) {
        t.filter = n.filter((t)=>!!t), e.stencilEnable = !1, e.cullFace = "back";
        const a = r && r.fbo;
        let c = 0;
        const l = [], h = [];
        let u = !1, f = i[0] && i[0].properties.branchRootId;
        for(let n = 0; n < i.length; n++){
            const { branchRootId: r } = i[n].properties;
            r !== f && (u ? (h.length && (c += this.lt(t, e, a, !1, h), h.length = 0), c += this.lt(t, e, a, u, l)) : $5671aa7ae64fb35e$var$kt(h, l), f = r, u = !1, l.length = 0), l.push(i[n]), i[n].properties.selectionDepth < 255 && (u = !0), n === i.length - 1 && (u || ($5671aa7ae64fb35e$var$kt(h, l), l.length = 0), h.length && (c += this.lt(t, e, a, !1, h)), c += this.lt(t, e, a, u, l));
        }
        return this.I.setMeshes(i.filter((t)=>t.properties.isLeaf)), this.C.setMeshes(o), c += this.p.render(t, e, this.C, r && r.fbo), c;
    }
    lt(t, e, n, r, s) {
        return s.length ? (this.I.setMeshes(s), e.stencilEnable = !1, r && (this.ht(n), e.stencilEnable = !1, e.cullFace = "front", this.p.render(t, e, this.I, n), e.cullFace = "back", e.stencilEnable = !0), this.p.render(t, e, this.I, n)) : 0;
    }
    ht(t) {
        this.m.clear({
            stencil: 255,
            framebuffer: t
        });
    }
    getCurrentB3DMMeshes() {
        return this.I.getMeshes();
    }
    getCurrentI3DMMeshes() {
        return this.C.getMeshes();
    }
    ut(t, e) {
        return e.V.ft - t.V.ft;
    }
    deleteTile(t) {
        const e = t.node;
        e.dt && (e.dt.geometry.dispose(), e.dt.dispose(), delete e.dt);
        const n = e.id;
        this.bt(n);
    }
    bt(t) {
        const e = this.T[t] || this._[t] || this.M[t] || this.O[t] || this.v[t];
        this.O[t] ? this.yt(t) : e && (this.gt(e), delete this.T[t], delete this._[t], delete this.M[t], delete this.v[t]);
    }
    yt(t) {
        let e = this.O[t];
        e = $5671aa7ae64fb35e$var$xt(e);
        for(let t = 0; t < e.length; t++){
            const { id: n } = e[t].properties;
            this.bt(n);
        }
        delete this.O[t];
    }
    gt(t) {
        if (Array.isArray(t)) for(let e = 0, n = t.length; e < n; e++)this.gt(t[e]);
        else {
            (0, $9e7Ip.HighlightUtil).showOnly(this.m, t), (0, $9e7Ip.HighlightUtil).highlightMesh(this.m, t);
            const e = t.geometry.properties.url;
            if (e) {
                const n = this.A[e];
                n && n.refMeshes && (n.refMeshes.delete(t.uuid), n.refMeshes.size || (n.geometry.dispose(), n.material.dispose(), delete this.A[e]));
            } else t.geometry.dispose(), t.material && t.material.dispose();
            t.dispose();
        }
    }
    remove() {
        const t = this.h;
        $5671aa7ae64fb35e$var$Pn(t.getRenderer().canvas, t.getMap());
        for(const t in this.O)this.yt(t);
        this.O = {};
        for(const t in this.T)this.bt(t);
        this.T = {};
        for(const t in this._)this.bt(t);
        this._ = {};
        for(const t in this.M)this.bt(t);
        this.M = {};
        for(const t in this.v)this.bt(t);
        this.v = {}, this.et && (this.et.dispose(), delete this.et), this.nt && (this.nt.dispose(), delete this.nt), this.st && (this.st.dispose(), delete this.st), this.it && (this.it.dispose(), delete this.it), this.P.dispose(), this.picking && this.picking.dispose();
    }
    F(t) {
        return this.T[t.id] || this._[t.id] || this.M[t.id] || this.O[t.id];
    }
    has(t) {
        return this.F(t) || this.v[t.id];
    }
    q(t) {
        const e = t.properties.magic;
        "b3dm" === e ? this.wt(t) : "i3dm" === e ? this.vt(t) : "pnts" === e && this.Tt(t);
    }
    createPntsMesh(t, e, s, i) {
        if (this._[e]) {
            const t = this._[e];
            return console.warn(`pnts mesh with id(${e}) was already created.`), i(null, {
                id: e,
                mesh: t
            }), t;
        }
        const { pnts: o, featureTable: a, rootIdx: c, compressed_int16_params: l } = t, h = a.POINTS_LENGTH;
        o.BATCH_ID || (o.BATCH_ID = new Uint8Array(h), o.BATCH_ID.fill(0));
        const u = new (0, $2wazW).Geometry(o, null, h, {
            static: !0,
            primitive: "points",
            positionAttribute: "POSITION",
            pickingIdAttribute: "BATCH_ID"
        });
        u.generateBuffers(this.m);
        const f = {};
        o.POSITION ? f.HAS_POSITION = 1 : o.POSITION_QUANTIZED && (f.HAS_POSITION_QUANTIZED = 1), o.RGB ? f.HAS_RGB = 1 : o.RGBA ? f.HAS_RGBA = 1 : o.RGB565 && (f.HAS_RGB565 = 1), (o.NORMAL || o.NORMAL_OCT16P) && (f.HAS_NORMAL = 1, o.NORMAL_OCT16P && (f.HAS_NORMAL_OCT16P = 1)), this._t(f, l), t.featureTable.CONSTANT_RGBA && (t.featureTable.CONSTANT_RGBA = t.featureTable.CONSTANT_RGBA.map((t)=>t / 255));
        const { rtcCenter: d, rtcCoord: m, projCenter: p } = t, b = this.h.j(c), y = new (0, $2wazW).Mesh(u);
        y.properties.magic = "pnts", y.properties.id = e, y.properties.node = s, y.properties.count = h, y.properties.batchTable = t.batchTable, y.properties.batchTableBin = t.batchTableBin, y.properties.serviceIndex = c, y.properties.rtcCoord = m, y.properties.rtcCenter = d, y.properties.projCenter = p, y.setDefines(f), y.setFunctionUniform("pointColor", function() {
            return t.featureTable.CONSTANT_RGBA ? t.featureTable.CONSTANT_RGBA : b && b.pointColor || [
                1,
                1,
                1,
                1
            ];
        });
        const g = this.getMap();
        let w = null, v = null;
        y.setFunctionUniform("pointSize", function() {
            if (!b) return 2;
            if ($5671aa7ae64fb35e$var$_n(b.pointSize)) {
                const t = JSON.stringify(b.pointSize);
                t !== w && (v = $5671aa7ae64fb35e$var$Mn(b.pointSize), w = t);
                return v(g.getZoom());
            }
            return b.pointSize || 2;
        });
        let T = null, _ = null;
        return y.setFunctionUniform("pointOpacity", function() {
            if (!b) return 1;
            if ($5671aa7ae64fb35e$var$_n(b.pointOpacity)) {
                const t = JSON.stringify(b.pointOpacity);
                t !== T && (_ = $5671aa7ae64fb35e$var$Mn(b.pointOpacity), T = t);
                return _(g.getZoom());
            }
            return b.pointOpacity || 1;
        }), this.Mt(y, l), this.Tt(y), y.$ = (0, $3iqbd).copy([], y.localTransform), this._[e] = y, i(null, {
            id: e,
            mesh: [
                y
            ]
        }), [
            y
        ];
    }
    Tt(t) {
        const e = t.localTransform || [], { rtcCoord: n, node: r, projCenter: s } = t.properties;
        this.Ot(e, n, s, r.H), t.setLocalTransform(e);
    }
    createI3DMMesh(t, e, s, i) {
        if (this.M[e]) {
            const t = this.M[e];
            return console.warn(`i3dm mesh with id(${e}) was already created.`), this.v[e] || i(null, {
                id: e,
                mesh: t
            }), t;
        }
        const c = this.h.j(s.H), l = this.At(s.xt), { i3dm: h, featureTable: u, gltf: f, batchTable: d, batchTableBin: m, count: p } = t, b = u.INSTANCES_LENGTH, { rtcCenter: y, rtcCoord: g, projCenter: w } = t, v = this.It($5671aa7ae64fb35e$var$rr, s, y, g);
        $5671aa7ae64fb35e$var$qe(v, $5671aa7ae64fb35e$var$qn, v);
        const T = (0, $3iqbd).getRotation($5671aa7ae64fb35e$var$sr, v);
        (0, $k1dpP).normalize(T, T);
        const _ = (0, $3iqbd).getScaling($5671aa7ae64fb35e$var$ir, v), M = (0, $3iqbd).fromScaling($5671aa7ae64fb35e$var$or, _), O = this.St($5671aa7ae64fb35e$var$ar, w, s), A = this.Ct($5671aa7ae64fb35e$var$hr), x = this.kt($5671aa7ae64fb35e$var$ur, g), I = (0, $eIStk).div($5671aa7ae64fb35e$var$fr, x, A), S = (0, $3iqbd).fromScaling($5671aa7ae64fb35e$var$dr, I), { POSITION: C, NORMAL_UP: k, NORMAL_RIGHT: N, SCALE: L, SCALE_NON_UNIFORM: E } = h, R = {
            "instance_vectorA": new Float32Array(4 * b),
            "instance_vectorB": new Float32Array(4 * b),
            "instance_vectorC": new Float32Array(4 * b),
            "aPickingId": new Uint16Array(b)
        };
        for(let t = 0; t < b; t++)R.aPickingId[t] = t;
        const P = new Float32Array(3), U = new Float32Array(3), B = [], G = new Float32Array(1), D = new Float32Array(3), F = [], j = [], z = [], H = [];
        !function(t, e) {
            let { byteOffset: n, byteStride: r, count: s } = t;
            const { componentType: i, itemSize: o } = t, a = t.array.buffer, c = i ? $5671aa7ae64fb35e$var$qt.getTypedArrayCtor(i) : t.array.constructor;
            if (n = void 0 === n ? t.array.byteOffset : n, r = r || 0, s = s || t.array.length / o, (!r || r === o * c.BYTES_PER_ELEMENT) && n % c.BYTES_PER_ELEMENT == 0) {
                const t = new c(a, n, s * o);
                for(let r = 0; r < s * o; r += o)e(new c(t.buffer, n + r * c.BYTES_PER_ELEMENT, o), r / o);
                return;
            }
            const l = new Uint8Array(o * c.BYTES_PER_ELEMENT);
            r || (r = o * c.BYTES_PER_ELEMENT);
            for(let t = 0; t < s; t++){
                const s = new Uint8Array(a, r * t + n, o * c.BYTES_PER_ELEMENT);
                l.set(s), e(new c(l.buffer), t), s.set(l);
            }
        }(C, (t, e)=>{
            k ? ($5671aa7ae64fb35e$var$Qt(U, N, e), $5671aa7ae64fb35e$var$Qt(P, k, e), (0, $eIStk).cross(B, U, P), (0, $eIStk).normalize(B, B), $5671aa7ae64fb35e$var$At(F, U, 0), $5671aa7ae64fb35e$var$At(F, P, 1), $5671aa7ae64fb35e$var$At(F, B, 2), (0, $k1dpP).fromMat3(j, F), (0, $k1dpP).normalize(j, j), (0, $k1dpP).multiply(j, T, j)) : (0, $k1dpP).identity(j), L ? ($5671aa7ae64fb35e$var$Qt(G, L, e), (0, $eIStk).set(z, G[0], G[0], G[0])) : E ? ($5671aa7ae64fb35e$var$Qt(D, E, e), (0, $eIStk).set(z, ...D)) : (0, $eIStk).set(z, 1, 1, 1), (0, $3iqbd).fromRotationTranslationScale(H, j, t, z), $5671aa7ae64fb35e$var$te(R.instance_vectorA, e, H, 0), $5671aa7ae64fb35e$var$te(R.instance_vectorB, e, H, 1), $5671aa7ae64fb35e$var$te(R.instance_vectorC, e, H, 2);
        });
        const q = {};
        for(const t in R)q[t] = {
            buffer: this.m.buffer({
                dimension: R[t].length / b,
                data: R[t]
            }),
            divisor: 1
        };
        const $ = c.shader || "pbr";
        let V = 0, J = !0;
        const Y = [], Z = [];
        return $5671aa7ae64fb35e$var$$t(f, (t, i, o, a)=>{
            const c = this.Nt(t, i, o, a, s, !0, $, Z), { geometry: h, material: f } = c;
            f && !f.isReady() && (J = !1, V++);
            const T = new (0, $2wazW).InstancedMesh(q, b, h, f);
            c.refMeshes || (c.refMeshes = new Set, c.refMeshes.add(T.uuid)), T.properties.magic = "i3dm", T.properties.id = e, T.properties.count = p, T.properties.batchTable = d, T.properties.batchTableBin = m, T.properties.serviceIndex = s.H, T.properties.rtcCoord = g, T.properties.rtcCenter = y, T.properties.projCenter = w, T.properties.node = s;
            const _ = this.Lt(t, h, f, s.H, a);
            t.compressed_int16_params && this.Mt(T, t.compressed_int16_params), this.Et(T, t.attributes);
            const A = (0, $3iqbd).identity([]);
            if (t.matrices && t.matrices.length) for(let e = 0; e < t.matrices.length; e++)(0, $3iqbd).multiply(A, A, t.matrices[e]);
            (0, $3iqbd).multiply(A, l, A), (0, $3iqbd).multiply(A, S, A), u.EAST_NORTH_UP || k ? (0, $3iqbd).multiply(A, M, A) : (0, $3iqbd).multiply(A, v, A), T.setPositionMatrix(A), this.vt(T, O), T.setDefines(_), T.properties.polygonOffset = {
                offset: 0,
                factor: 0
            }, Y.push(T), delete t.attributes, T.$ = (0, $3iqbd).copy([], T.localTransform);
        }), $5671aa7ae64fb35e$var$vr(Z), J ? (this.M[e] = Y, i(null, {
            id: e,
            mesh: Y
        })) : (this.v[e] = {
            meshes: Y,
            count: V
        }, Y.Rt = i), Y;
    }
    vt(t, e) {
        const { rtcCoord: n, node: s, projCenter: i } = t.properties;
        e || (e = this.St($5671aa7ae64fb35e$var$ar, i, s));
        const o = this.h.j(s.H), a = t.localTransform || [];
        if (o.coordOffset) {
            const t = this.Pt($5671aa7ae64fb35e$var$rr, s.H, n);
            (0, $3iqbd).multiply(a, t, e);
        } else (0, $3iqbd).copy(a, e);
        t.setLocalTransform(a), t.properties.heightOffset = o.heightOffset || 0, t.properties.coordOffset = o.coordOffset && o.coordOffset.slice(0) || $5671aa7ae64fb35e$var$$n;
    }
    St(t, e, n) {
        (0, $3iqbd).fromScaling(t, this.Ct($5671aa7ae64fb35e$var$hr));
        const s = this.Ut($5671aa7ae64fb35e$var$er, e, n.H);
        return (0, $3iqbd).multiply(t, (0, $3iqbd).fromTranslation($5671aa7ae64fb35e$var$cr, s), t), t;
    }
    createB3DMMesh(e, s, i, o) {
        if (e.gltf && (e.gltf.transferables = null), this.T[s] || this.v[s]) {
            const t = this.T[s];
            return console.warn(`mesh with id(${s}) was already created.`), this.v[s] || o(null, {
                id: s,
                mesh: t
            }), t;
        }
        let a;
        if (i.maxExtent) {
            const e = new $gP1US.Extent(i.maxExtent).convertTo((t)=>this._pointToPrj(t));
            a = [
                e.xmin,
                e.ymin,
                e.xmax,
                e.ymax
            ];
        }
        const c = e.gltf, { projCenter: l } = c.extensions.MAPTALKS_RTC, { rtcCoord: h, center: u } = c.extensions.CESIUM_RTC, f = c.asset.sharePosition, d = this.At(i.xt), m = this.Bt($5671aa7ae64fb35e$var$ar, f, h, u, l, i), p = this.h.j(i.H);
        let b = p.shader || "pbr";
        if (p.unlit) b = "phong";
        else if (c.materials) {
            for(let t = 0; t < c.materials.length; t++)if (c.materials[t] && c.materials[t].extensions && c.materials[t].extensions.KHR_materials_unlit) {
                b = "phong";
                break;
            }
        }
        const y = [], g = [];
        let w = 0, v = !0;
        return $5671aa7ae64fb35e$var$$t(c, (t, o, c, T)=>{
            const _ = this.Nt(t, o, c, T, i, !1, b, y), { geometry: M, material: O } = _;
            O && !O.isReady() && (v = !1, w++);
            const A = new (0, $2wazW).Mesh(M, O);
            _.refMeshes || (_.refMeshes = new Set, _.refMeshes.add(A.uuid)), A.properties.magic = "b3dm", A.properties.id = s, A.properties.node = i, e.batchTable && (A.properties.batchTable = e.batchTable, A.properties.batchTableBin = e.batchTableBin), A.properties.count = e.featureTable && e.featureTable.BATCH_LENGTH || 0, A.properties.serviceIndex = i.H;
            const x = this.Lt(t, M, O, i.H, T);
            A.setDefines(x);
            const I = t.compressUniforms;
            if (I) for(const t in I)A.setUniform(t, I[t]);
            t.compressed_int16_params && this.Mt(A, t.compressed_int16_params), this.Et(A, t.attributes), a && (x.USE_MAX_EXTENT = 1, A.setUniform("maxPrjExtent", a)), A.hasFunctionUniform("polygonOpacity") || A.setFunctionUniform("polygonOpacity", function() {
                return $5671aa7ae64fb35e$var$gt(p.opacity) ? p.opacity : 1;
            }), A.hasFunctionUniform("polygonFill") || A.setFunctionUniform("polygonFill", function() {
                return $5671aa7ae64fb35e$var$Lt([], p.polygonFill || $5671aa7ae64fb35e$var$Dn);
            }), A.material.hasFunctionUniform("hsv") || A.material.setFunctionUniform("hsv", function() {
                return p.hsv || $5671aa7ae64fb35e$var$Fn;
            });
            const S = (0, $3iqbd).identity([]);
            if (f && t.matrices && t.matrices.length) for(let e = 0; e < t.matrices.length; e++)(0, $3iqbd).multiply(S, S, t.matrices[e]);
            f && (0, $3iqbd).multiply(S, d, S), A.properties.node = i, A.properties.projCenter = l, A.properties.nodeMatrix = S, A.properties.isSharedPosition = f, A.properties.rtcCoord = h, A.properties.rtcCenter = u, this.wt(A, m), g.push(A), delete t.attributes, A.$ = (0, $3iqbd).copy([], A.localTransform);
        }), $5671aa7ae64fb35e$var$vr(y), v ? (this.T[s] = g, o(null, {
            id: s,
            mesh: g
        })) : (this.v[s] = {
            meshes: g,
            count: w
        }, g.Rt = o), g;
    }
    Gt(t) {
        const e = this.h.Dt(t.id);
        if (!e || t.dt) return;
        let s, i, o, a;
        if (e.obbox) s = e.boxPosition, i = $5671aa7ae64fb35e$var$pr, o = e.boxCenter, a = $5671aa7ae64fb35e$var$gr;
        else if (e.sphereBox) {
            const t = e.sphereBox[0], n = e.sphereBox[1];
            s = $5671aa7ae64fb35e$var$br.vertices, i = $5671aa7ae64fb35e$var$br.indices, o = t, a = [
                n,
                n,
                n
            ];
        }
        const c = new (0, $2wazW).Geometry({
            POSITION: s
        }, i, 0, {
            primitive: "lines",
            positionAttribute: "POSITION"
        }), l = new (0, $2wazW).Mesh(c, new (0, $2wazW).Material({
            lineColor: [
                .8,
                .8,
                .1,
                1
            ],
            lineOpacity: 1
        })), h = [];
        (0, $3iqbd).fromRotationTranslationScale(h, $5671aa7ae64fb35e$var$yr, o, a), l.localTransform = h, l.$ = (0, $3iqbd).copy([], h), l.properties.node = t, t.dt = l;
    }
    Ft(t) {
        t.dt && (t.dt.geometry.dispose(), t.dt.dispose(), delete t.dt);
    }
    Mt(t, e) {
        e.POSITION && t.setUniform("compressedPositionRange", e.POSITION), e.TEXCOORD_0 && t.setUniform("compressedTexcoordRange_0", e.TEXCOORD_0), e.TEXCOORD_1 && t.setUniform("compressedTexcoordRange_1", e.TEXCOORD_0), e.NORMAL && t.setUniform("compressedNormalRange", e.NORMAL), e.TANGENT && t.setUniform("compressedTangentRange", e.TANGENT), e.compressed_ratio && t.setUniform("compressed_ratio", e.compressed_ratio);
    }
    wt(t, e) {
        const { isSharedPosition: n, rtcCoord: s, rtcCenter: i, projCenter: o, nodeMatrix: a, node: c } = t.properties;
        e || (e = this.Bt(e || $5671aa7ae64fb35e$var$ar, n, s, i, o, c));
        const l = t.localTransform || (0, $3iqbd).identity([]);
        (0, $3iqbd).multiply(l, e, a);
        const h = this.h.j(c.H);
        if (h.coordOffset) {
            const t = this.Pt($5671aa7ae64fb35e$var$rr, c.H, s);
            (0, $3iqbd).multiply(l, t, l);
        }
        t.setLocalTransform(l), t.properties.heightOffset = h.heightOffset || 0, t.properties.coordOffset = h.coordOffset && h.coordOffset.slice(0) || $5671aa7ae64fb35e$var$$n;
    }
    Bt(t, e, n, s, i, o) {
        if (e) {
            const e = this.kt($5671aa7ae64fb35e$var$ur, n), i = (0, $3iqbd).fromScaling($5671aa7ae64fb35e$var$nr, e), a = this.It($5671aa7ae64fb35e$var$rr, o, s, n);
            (0, $3iqbd).multiply(t, a, i);
        } else this.Ot(t, n, i, o.H);
        return t;
    }
    Et(t, e) {
        if (e && e.TEXCOORD_0 && e.TEXCOORD_0.extensions && e.TEXCOORD_0.extensions.WEB3D_quantized_attributes) {
            const n = e.TEXCOORD_0.extensions.WEB3D_quantized_attributes.decodeMatrix;
            t.setUniform("decodeMatrix", n);
        }
    }
    It(t, e, n, s) {
        const i = this.getMap(), o = this.h.j(e.H).heightOffset || 0, c = e.matrix ? (0, $3iqbd).copy(t, e.matrix) : (0, $3iqbd).identity(t);
        if (n) $5671aa7ae64fb35e$var$qe(c, (0, $eIStk).transformMat4($5671aa7ae64fb35e$var$Zn, n, c), c);
        const l = function(t, e, n, r, s, i, o) {
            e = (0, $eIStk).copy($5671aa7ae64fb35e$var$Ve, e);
            const a = $5671aa7ae64fb35e$var$ie($5671aa7ae64fb35e$var$Ve, e[0] * $5671aa7ae64fb35e$var$en, e[1] * $5671aa7ae64fb35e$var$en, e[2]), c = (0, $3iqbd).getTranslation($5671aa7ae64fb35e$var$Je, n), l = r.ellipsoid;
            let h;
            h = 0 === (0, $eIStk).len(c) ? (0, $eIStk).set($5671aa7ae64fb35e$var$Ye, 0, 0, -6378137) : $5671aa7ae64fb35e$var$ue($5671aa7ae64fb35e$var$Ye, c), $5671aa7ae64fb35e$var$Qe.x = h[0], $5671aa7ae64fb35e$var$Qe.y = h[1];
            const u = r.project($5671aa7ae64fb35e$var$Qe, $5671aa7ae64fb35e$var$tn);
            $5671aa7ae64fb35e$var$Ze[0] = u.x / s, $5671aa7ae64fb35e$var$Ze[1] = u.y / s, $5671aa7ae64fb35e$var$Ze[2] = (h[2] + o) * i;
            const f = $5671aa7ae64fb35e$var$$e(a, l, $5671aa7ae64fb35e$var$Ke);
            return $5671aa7ae64fb35e$var$qe(function(t, e, n) {
                const r = t[0], s = t[1], i = t[2], o = t[4], a = t[5], c = t[6], l = t[8], h = t[9], u = t[10], f = e[0], d = e[1], m = e[2], p = e[3], b = e[4], y = e[5], g = e[6], w = e[7], v = e[8], T = r * f + o * d + l * m, _ = s * f + a * d + h * m, M = i * f + c * d + u * m, O = r * p + o * b + l * y, A = s * p + a * b + h * y, x = i * p + c * b + u * y, I = r * g + o * w + l * v, S = s * g + a * w + h * v, C = i * g + c * w + u * v;
                return n[0] = T, n[1] = _, n[2] = M, n[3] = 0, n[4] = O, n[5] = A, n[6] = x, n[7] = 0, n[8] = I, n[9] = S, n[10] = C, n[11] = 0, n[12] = t[12], n[13] = t[13], n[14] = t[14], n[15] = t[15], n;
            }((0, $3iqbd).invert($5671aa7ae64fb35e$var$Xe, f), (0, $bDSmI).fromMat4($5671aa7ae64fb35e$var$We, n), t), $5671aa7ae64fb35e$var$Ze, t), t;
        }(c, s, c, i.getProjection(), i.getGLRes(), this.B, o), h = function(t, e) {
            return (0, $eIStk).set(t, e[12], e[13], e[14]), t;
        }($5671aa7ae64fb35e$var$er, l);
        let u = this.h.options.offset;
        if ($5671aa7ae64fb35e$var$bt(u)) {
            const t = this.h.Dt(e.id).boxCoord;
            u = u.call(this.h, t);
        }
        return (0, $eIStk).set($5671aa7ae64fb35e$var$tr, u[0], u[1], 0), (0, $eIStk).sub(h, h, $5671aa7ae64fb35e$var$tr), $5671aa7ae64fb35e$var$qe(l, h, l), l;
    }
    Pt(t, e, n) {
        const s = this.h.j(e);
        if (!s.coordOffset) return null;
        const i = this.getMap(), o = i.getGLRes();
        $5671aa7ae64fb35e$var$Kn.set(n[0], n[1]);
        const c = i.coordToPointAtRes($5671aa7ae64fb35e$var$Kn, o, $5671aa7ae64fb35e$var$Wn), l = s.coordOffset, h = $5671aa7ae64fb35e$var$Kn.set(n[0] + l[0], n[1] + l[1]), u = i.coordToPointAtRes(h, o, $5671aa7ae64fb35e$var$Qn), f = u.x - c.x, d = u.y - c.y, m = this.B, p = (0, $eIStk).set($5671aa7ae64fb35e$var$tr, f, d, (l[2] || 0) * m);
        return (0, $3iqbd).fromTranslation(t, p);
    }
    createCMPTMesh(t, e, n, r) {
        if (this.O[e]) {
            const t = this.O[e];
            return console.warn(`mesh with id(${e}) was already created.`), r(null, {
                id: e,
                mesh: t
            }), t;
        }
        const { content: s } = t, i = [];
        for(let t = 0; t < s.length; t++){
            const { magic: r } = s[t], o = e + "." + t;
            "b3dm" === r ? this.createB3DMMesh(s[t], o, n, (t, { mesh: e })=>{
                i.push(e);
            }) : "i3dm" === r ? this.createI3DMMesh(s[t], o, n, (t, { mesh: e })=>{
                i.push(e);
            }) : "pnts" === r ? this.createPntsMesh(s[t], o, n, (t, { mesh: e })=>{
                i.push(e);
            }) : "cmpt" === r && this.createCMPTMesh(s[t], o, n, (t, { mesh: e })=>{
                i.push(e);
            });
        }
        return this.O[e] = i, r(null, {
            id: e,
            mesh: i
        }), i;
    }
    Lt(t, e, n, r, s) {
        const i = ("phong" === (this.h.j(r).shader || "pbr") ? this.et : this.nt).getGeometryDefines(e);
        s.asset && "S3M" === s.asset.generator && this.jt(i, e), e.data.uvRegion && (i.HAS_I3S_UVREGION = 1), e.data[e.desc.normalAttribute] && (i.VertexNormal = 1), e.data[e.desc.color0Attribute] && (i.VertexColor = 1), e.data[e.desc.uv0Attribute] && (i.TexCoord = 1), e.data[e.desc.textureCoordMatrixAttribute] && (i.HAS_TextureCoordMatrix = 1), n.get("uTexture") && (i.COMPUTE_TEXCOORD = 1), n.get("uTexture2") && (i.TexCoord2 = 1), "MESHOPT" === this.h.zt && (i.MeshOPT_Compress = 1), this.hasIBL() && (i.HAS_IBL_LIGHTING = 1), t.attributes && t.attributes.TEXCOORD_0 && "WEB3D_quantized_attributes" === t.attributes.TEXCOORD_0.extensions && (i.HAS_WEB3D_quantized_attributes_TEXCOORD = 1), i.HAS_MIN_ALTITUDE = 1, i.HAS_LAYER_OPACITY = 1, this._t(i, t.compressed_int16_params);
        return $5671aa7ae64fb35e$var$pt(i, t.compressDefines), i;
    }
    _t(t, e) {
        e && Object.keys(e).length > 0 && (t.HAS_COMPRESSED_INT16 = 1, e.POSITION && (t.HAS_COMPRESSED_INT16_POSITION = 1), e.TEXCOORD_0 && (t.HAS_COMPRESSED_INT16_TEXCOORD_0 = 1), e.TEXCOORD_1 && (t.HAS_COMPRESSED_INT16_TEXCOORD_1 = 1), e.NORMAL && (t.HAS_COMPRESSED_INT16_NORMAL = 1), e.TANGENT && (t.HAS_COMPRESSED_INT16_TANGENT = 1), e.compressed_ratio && (t.HAS_COMPRESSED_INT16_RATIO = 1));
    }
    X(t) {
        const e = this.h.getRenderer();
        e && e.updateMaskDefines(t);
    }
    jt(t, e) {
        e.data.aNormal && (t.VertexNormal = 1), e.data.instanceId && (t.Instance = 1), e.data.aTexCoord0 && (t.TexCoord = 1), e.data.aColor && (t.VertexColor = 1), e.data.aTexCoord1 && (t.TexCoord2 = 1), e.data.uv2 && (t.InstanceBim = 1);
    }
    Nt(t, e, r, s, i, o, a, c) {
        let l = !1;
        s.asset && "S3M" === s.asset.generator && (l = !0, s.extensions = s.extensions || {});
        const h = s.url + "-" + e + "-" + r;
        if (this.A[h]) return this.A[h];
        let u, f;
        c.push(t);
        const d = s.materials && s.materials[t.material], m = s.extensions && s.extensions.KHR_techniques_webgl, p = this.h.j(i.H);
        if (m && d.extensions && d.extensions.KHR_techniques_webgl) {
            const e = this.Ht(t, s, o, l);
            u = e.material, f = e.geometry, p.fillEmptyDataInMissingAttribute && (f.desc.fillEmptyDataInMissingAttribute = !0);
        } else {
            f = this.qt(t, o, $5671aa7ae64fb35e$var$mr);
            const e = p.material;
            u = this.$t(t.material, s, a, e || $5671aa7ae64fb35e$var$jn, c, p);
        }
        u && (u.setFunctionUniform("alphaTest", function() {
            const t = p.alphaTest;
            return $5671aa7ae64fb35e$var$mt(t) ? .1 : t;
        }), u.setFunctionUniform("environmentExposure", ()=>{
            const t = p.ambientLight;
            let e = p.environmentExposure;
            const n = this.getMap().getLightManager(), r = n && n.getAmbientLight();
            if (t && (!r || r.color) && void 0 === e) {
                const n = r && r.color ? r.color[0] : .2;
                e = t[0] / n;
            }
            return e || 1;
        })), u && !u.isReady() ? u.Vt = i.id : u || (u = new (0, $2wazW).PhongMaterial({
            "baseColorFactor": [
                1,
                1,
                1,
                1
            ]
        }));
        const b = {
            geometry: f,
            material: u
        };
        return f.properties.url = h, this.A[h] = b, b;
    }
    Ht(t, e, n, r) {
        const { geometry: s, material: i } = this.P.createMesh(t, e, n, r);
        return {
            geometry: s,
            material: i
        };
    }
    qt(t, e, r) {
        const s = t.attributes, i = "COLOR_0";
        let o = s._BATCHID && s._BATCHID.array;
        if (o && o.byteOffset && (o = new o.constructor(o)), s[i]) {
            const t = s[i].array || s[i];
            if (t instanceof Float32Array) {
                const e = new Uint8Array(t.length);
                for(let n = 0; n < e.length; n++)e[n] = Math.round(255 * t[n]);
                s[i].array ? (s[i].array = e, s[i].componentType = 5121) : s[i] = e;
            }
        }
        const a = {};
        for(const t in s){
            const e = $5671aa7ae64fb35e$var$Nn(this.m, s[t], {
                dimension: s[t].itemSize
            }), n = r[t] || t;
            a[n] = {
                buffer: e
            }, s[t].quantization && (a[n].quantization = s[t].quantization), n === r.POSITION && (a[n].array = s[t].array, a[n].min = s[t].min, a[n].max = s[t].max);
        }
        const c = t.indices ? t.indices.array ? t.indices.array.slice() : t.indices : null, l = new (0, $2wazW).Geometry(a, c, 0, {
            positionAttribute: r.POSITION,
            normalAttribute: r.NORMAL,
            uv0Attribute: r.TEXCOORD_0,
            uv1Attribute: r.TEXCOORD_1,
            color0Attribute: r.COLOR_0,
            tangentAttribute: r.TANGENT,
            pickingIdAttribute: r._BATCHID,
            primitive: void 0 === t.mode ? "triangles" : $5671aa7ae64fb35e$var$kn(t.mode)
        });
        return o && c && (l.properties.batchIdData = o, l.properties.batchIdMap = function(t, e) {
            if (!e) return null;
            const n = new Map;
            for(let r = 0; r < e.length; r++){
                const s = e[r], i = t[s];
                let o = n.get(i);
                o || (o = [], n.set(i, o)), o.push(s);
            }
            return n;
        }(o, c)), l.generateBuffers(this.m, {
            excludeElementsInVAO: e
        }), l;
    }
    Ot(t, e, n, s) {
        const i = (0, $3iqbd).identity(t), o = this.Ct($5671aa7ae64fb35e$var$zn);
        return this.Ut($5671aa7ae64fb35e$var$er, n, s), (0, $3iqbd).translate(i, i, $5671aa7ae64fb35e$var$er), (0, $3iqbd).scale(i, i, o), i;
    }
    Ut(t, e, n) {
        const r = this.B;
        $5671aa7ae64fb35e$var$Kn.x = e[0], $5671aa7ae64fb35e$var$Kn.y = e[1];
        const s = this._prjToPoint($5671aa7ae64fb35e$var$Kn);
        let i = this.h.options.offset;
        $5671aa7ae64fb35e$var$bt(i) && (i = i.call(this.h, $5671aa7ae64fb35e$var$Kn));
        const o = this.h.j(n).heightOffset || 0;
        return (0, $eIStk).set(t, s.x - i[0], s.y - i[1], r * e[2] + r * o), t;
    }
    W(t, e) {
        const n = this.h.Jt($5671aa7ae64fb35e$var$lr, e);
        t.localTransform = (0, $3iqbd).multiply(t.localTransform, n, t.$);
    }
    kt(t, e) {
        const n = this.getMap();
        $5671aa7ae64fb35e$var$Kn.x = e[0], $5671aa7ae64fb35e$var$Kn.y = e[1];
        const r = n.distanceToPointAtRes(100, 100, n.getGLRes(), $5671aa7ae64fb35e$var$Kn), s = this.B;
        return (0, $eIStk).set(t, r.x / 100, r.y / 100, s), t;
    }
    ct(t) {
        if (this.nt) return;
        const e = {
            x: 0,
            y: 0,
            width: ()=>this.u ? this.u.width : 1,
            height: ()=>this.u ? this.u.height : 1
        }, s = [], o = [];
        this.st = new (0, $2wazW).MeshShader({
            vert: $5671aa7ae64fb35e$var$ee,
            frag: "#define SHADER_NAME PNTS\n\nprecision mediump float;\n\n\n\nvarying vec4 vColor;\n\n\n\nvoid main() {\n\n    vec2 circCoord = 2.0 * gl_PointCoord - 1.0;\n\n    if (dot(circCoord, circCoord) > 1.0) {\n\n        discard;\n\n    } else {\n\n        gl_FragColor = vColor;\n\n    }\n\n}\n\n",
            uniforms: [
                {
                    name: "projViewModelMatrix",
                    type: "function",
                    fn: (t, e)=>(0, $3iqbd).multiply(o, e.projViewMatrix, e.modelMatrix)
                },
                {
                    name: "modelNormalMatrix",
                    type: "function",
                    fn: (t, e)=>(0, $bDSmI).fromMat4(s, e.modelMatrix)
                }
            ],
            extraCommandProps: {
                viewport: e,
                blend: {
                    enable: !0,
                    func: {
                        src: "one",
                        dst: "one minus src alpha"
                    },
                    equation: "add"
                },
                depth: {
                    enable: !0,
                    func: "<"
                }
            }
        });
        const a = {}, l = [];
        (0, $9e7Ip.ContextUtil).fillIncludes(a, l, t);
        const h = this.U();
        this.et = new (0, $2wazW).PhongShader({
            uniforms: l,
            defines: a,
            extraCommandProps: h
        }), this.nt = new (0, $2wazW).pbr.StandardShader({
            uniforms: l,
            defines: a,
            extraCommandProps: h
        }), this.it = new (0, $2wazW).EdgeShader({
            extraCommandProps: {
                viewport: {
                    x: 0,
                    y: 0,
                    width: ()=>this.u ? this.u.width : 1,
                    height: ()=>this.u ? this.u.height : 1
                },
                blend: {
                    enable: !0,
                    func: {
                        srcRGB: "src alpha",
                        srcAlpha: 1,
                        dstRGB: "one minus src alpha",
                        dstAlpha: "one minus src alpha"
                    },
                    equation: "add"
                }
            }
        });
        const u = this.h;
        $5671aa7ae64fb35e$var$Rn(u.getRenderer().canvas, this.m, u.getMap()), this.picking = new (0, $2wazW).FBORayPicking(this.p, {
            vert: this.nt.vert,
            extraCommandProps: h,
            uniforms: this.nt.uniforms,
            defines: {
                "PICKING_MODE": 1,
                "ENABLE_PICKING": 1,
                "HAS_PICKING_ID": 1
            }
        }, this.pickingFBO, this.getMap()), this.Yt = new (0, $2wazW).FBORayPicking(this.p, {
            vert: $5671aa7ae64fb35e$var$ee,
            extraCommandProps: h,
            uniforms: this.st.uniforms,
            defines: {
                "PICKING_MODE": 1,
                "ENABLE_PICKING": 1,
                "HAS_PICKING_ID": 1
            }
        }, this.pickingFBO, this.getMap());
    }
    U() {
        return {
            viewport: {
                x: 0,
                y: 0,
                width: ()=>this.u ? this.u.width : 1,
                height: ()=>this.u ? this.u.height : 1
            },
            cull: {
                enable: (t, e)=>e.meshProperties.cullFace,
                face: (t, e)=>e.cullFace || "back"
            },
            stencil: {
                enable: (t, e)=>e.stencilEnable,
                func: {
                    cmp: "<=",
                    ref: (t, e)=>e.meshProperties.selectionDepth
                },
                opFront: {
                    fail: "keep",
                    zfail: "keep",
                    zpass: "replace"
                },
                opBack: {
                    fail: "keep",
                    zfail: "keep",
                    zpass: "replace"
                }
            },
            depth: {
                enable: !0,
                func: (t, e)=>e.meshProperties.depthFunc || "<="
            },
            blend: {
                enable: !0,
                func: {
                    src: 1,
                    dst: "one minus src alpha"
                },
                equation: "add"
            },
            polygonOffset: {
                enable: !0,
                offset: (t, e)=>e.meshProperties.polygonOffset
            }
        };
    }
    rt(t) {
        const e = this.getMap(), n = e.getLightManager(), r = (n && n.getDirectionalLight() || {}).direction || [
            1,
            1,
            -1
        ], s = t && t.pointOpacity || 1;
        return {
            projViewMatrix: e.projViewMatrix,
            pointOpacity: s,
            lightDir: (0, $eIStk).normalize($5671aa7ae64fb35e$var$Vn, r)
        };
    }
    D() {
        const t = this.getMap(), e = this.h, n = e.getRenderer().canvas, { iblTexes: r, dfgLUT: s } = $5671aa7ae64fb35e$var$Un(n), i = $5671aa7ae64fb35e$var$Bn(t, r, s), o = this.h.getRenderer(), a = o.getMaskUniforms();
        i.minAltitude = e.options.altitude || 0;
        const c = o.canvas.gl && o.canvas.gl.wrap ? e.options.opacity || 0 : 1;
        return i.layerOpacity = c, $5671aa7ae64fb35e$var$pt(i, {
            czm_lightDirectionEC: i.light0_viewDirection,
            lightSpecular: [
                1,
                1,
                1
            ],
            viewMatrix: t.viewMatrix,
            projMatrix: t.projMatrix,
            projViewMatrix: t.projViewMatrix,
            outSize: [
                n.width,
                n.height
            ],
            polygonFill: [
                1,
                1,
                1,
                1
            ],
            polygonOpacity: 1
        }), $5671aa7ae64fb35e$var$pt(i, a), i;
    }
    $t(t, e, r, s, i, o) {
        const a = e.materials && e.materials[t];
        if (!a || !a.baseColorTexture && !a.pbrMetallicRoughness) return null;
        const c = $5671aa7ae64fb35e$var$pt({}, s);
        if (a.baseColorTexture) {
            const t = e.textures[a.baseColorTexture.index];
            let n;
            t && !t.image.color && (n = this.Zt(t, i)), c.baseColorFactor = t && t.image.color || a.baseColorFactor || [
                1,
                1,
                1,
                1
            ], n && (c.baseColorTexture = n);
        } else {
            if (a.normalTexture) {
                const t = this.Zt(e.textures[a.normalTexture.index], i);
                if (t) {
                    const e = a.normalTexture.scale || 1;
                    c.normalTexture = t, c.normalMapFactor = e;
                }
            }
            if (a.occlusionTexture) {
                const t = this.Zt(e.textures[a.occlusionTexture.index], i);
                if (t) {
                    const e = a.occlusionTexture.strength || 1;
                    c.occlusionTexture = t, c.occlusionFactor = e;
                }
            }
            if (a.emissiveTexture) {
                const t = this.Zt(e.textures[a.emissiveTexture.index], i);
                t && (c.emissiveTexture = t);
            }
            a.emissiveFactor && (c.emissiveFactor = a.emissiveFactor);
            const t = a.pbrMetallicRoughness;
            if (t) {
                if (t.baseColorFactor && (c.baseColorFactor = t.baseColorFactor), t.baseColorTexture && void 0 !== t.baseColorTexture.index) {
                    const n = e.textures[t.baseColorTexture.index];
                    if (n && n.image && n.image.color) c.baseColorFactor = c.baseColorFactor ? (0, $jxhwV).multiply(c.baseColorFactor, c.baseColorFactor, n.image.color) : n.image.color;
                    else {
                        const t = this.Zt(n, i);
                        t && (c.baseColorTexture = t, c.baseColorTexture.getREGLTexture(this.m));
                    }
                }
                if ($5671aa7ae64fb35e$var$mt(t.metallicFactor) || (c.metallicFactor = t.metallicFactor), $5671aa7ae64fb35e$var$mt(t.roughnessFactor) || (c.roughnessFactor = t.roughnessFactor), a.metallicRoughnessTexture) {
                    const t = this.Zt(e.textures[a.metallicRoughnessTexture.index], i);
                    t && (c.metallicRoughnessTexture = t);
                }
            }
        }
        if (a.s3mMaterial) return new (0, $2wazW).Material(c);
        if (o.unlit || a.extensions && a.extensions.KHR_materials_unlit) {
            c.ambientColor = [
                1,
                1,
                1
            ], c.light0_diffuse = [
                0,
                0,
                0,
                0
            ], c.lightSpecular = [
                0,
                0,
                0
            ];
            const t = new (0, $2wazW).PhongMaterial(c);
            return t.unlit = void 0 === o.unlit || !!o.unlit, t;
        }
        let h = new (0, $2wazW).pbr.StandardMaterial(c);
        "phong" === r && (h = (0, $2wazW).PhongMaterial.convertFrom(h));
        const u = a.pbrMetallicRoughness, f = u && u.baseColorTexture && u.baseColorTexture.extensions;
        return f && f.KHR_texture_transform && (h.set("khr_offset", f.KHR_texture_transform.offset || [
            0,
            0
        ]), h.set("khr_rotation", f.KHR_texture_transform.rotation || 0), h.set("khr_scale", f.KHR_texture_transform.scale || [
            1,
            1
        ])), h.doubleSided = !(!o.doubleSided && !a.doubleSided), h.once("complete", this.L), h;
    }
    Zt(t, e) {
        if (!t) return null;
        const r = {
            type: t.type ? $5671aa7ae64fb35e$var$Sn(t.type) : "uint8",
            format: t.format ? $5671aa7ae64fb35e$var$Cn(t.format) : "rgba",
            flipY: !!t.flipY
        }, s = t.image;
        if (e.push(s), s.array ? r.data = s.array : s.mipmap && (r.mipmap = s.mipmap), !r.data && !r.mipmap) return null;
        if (r.width = s.width, r.height = s.height, r.mipmap && (r.width < 4 || r.height < 4)) return null;
        const i = t.sampler || t.texture && t.texture.sampler;
        return i && (i.magFilter && (r.mag = $5671aa7ae64fb35e$var$An(i.magFilter)), i.minFilter && (r.min = $5671aa7ae64fb35e$var$xn(i.minFilter)), i.wrapS && (r.wrapS = $5671aa7ae64fb35e$var$In(i.wrapS)), i.wrapT && (r.wrapT = $5671aa7ae64fb35e$var$In(i.wrapT))), new (0, $2wazW).Texture2D(r, this.N);
    }
    R({ target: t }) {
        const e = t.Vt, n = this.v[e];
        if (n.count--, !n.count) {
            const t = n.meshes;
            this.T[e] = t, delete this.v[e];
            const r = t.Rt;
            delete t.Rt, r(null, {
                mesh: n.meshes,
                id: e
            });
        }
    }
    Ct(t) {
        const e = 1 / this.getMap().getGLRes(), n = this.B;
        return t[0] = t[1] = e, t[2] = n, t;
    }
    Kt(t) {
        return this.h.Kt(t);
    }
    _pointToPrj(t) {
        const e = this.getMap();
        return e.getGLZoom ? e._pointToPrj(t, e.getGLZoom()) : e._pointToPrjAtRes(t, e.getGLRes());
    }
    _prjToPoint(t) {
        const e = this.getMap();
        return e.getGLZoom ? e._prjToPoint(t, e.getGLZoom()) : e._prjToPointAtRes(t, e.getGLRes(), $5671aa7ae64fb35e$var$Xn);
    }
    At(t) {
        return "Y" === t ? $5671aa7ae64fb35e$var$Ln : "X" === t ? $5671aa7ae64fb35e$var$En : $5671aa7ae64fb35e$var$Hn;
    }
    pick(t, e, n = 3) {
        const r = this.h;
        if (!r || !r.options.picking) return [];
        if (!this.pickingFBO || !this.picking) return [];
        const s = [], i = this.D(), o = this.Xt(this.picking, i, this.I, t, e, n);
        o && s.push(o);
        const a = this.Xt(this.picking, i, this.C, t, e, n);
        a && s.push(a);
        const c = this.rt(), l = this.Xt(this.Yt, c, this.S, t, e, n);
        return l && s.push(l), s;
    }
    Xt(t, e, n, r, s, i) {
        if (!n.getMeshes().length) return null;
        const o = this.h, a = this.getMap();
        t.render(n.getMeshes().filter((t)=>!t.bloom), e, !0);
        let c = {};
        t.getRenderedMeshes().length && (c = t.pick(r, s, i, e, {
            viewMatrix: a.viewMatrix,
            projMatrix: a.projMatrix,
            returnPoint: o.options.pickingPoint
        }));
        const { meshId: l, pickingId: h, point: u, coordinate: f } = c, d = (0 === l || l) && t.getMeshAt(l);
        if (!d || !d.geometry) return null;
        const m = d.properties;
        u && u.length && (u[0] = Math.round(1e5 * u[0]) / 1e5, u[1] = Math.round(1e5 * u[1]) / 1e5, u[2] = Math.round(1e5 * u[2]) / 1e5);
        const p = {
            batchId: h
        }, b = o.options.services, y = b && b[d.properties.serviceIndex];
        if (y && y.debug && (p.debugInfo = m), m && m.batchTable) {
            const { batchTable: t, batchTableBin: e, count: n } = m, r = h;
            for(const s in t)void 0 !== t[s].byteOffset ? p[s] = $5671aa7ae64fb35e$var$Se(t[s], e, n, r) : p[s] = t[s][r];
        }
        return {
            service: d.properties.serviceIndex,
            data: p,
            point: u,
            coordinate: f
        };
    }
    highlight(t) {
        this.J = t;
        const e = this.h.getRenderer();
        this.Y = e.getFrameTimestamp(), e.setToRedraw(!0);
    }
    cancelAllHighlight() {
        this.J = null;
        const t = this.h.getRenderer();
        this.Y = t.getFrameTimestamp(), t.setToRedraw(!0);
    }
    showOnly(t) {
        this.Z = t;
        const e = this.h.getRenderer();
        this.K = e.getFrameTimestamp(), e.setToRedraw(!0);
    }
    cancelShowOnly() {
        this.Z = null;
        const t = this.h.getRenderer();
        this.K = t.getFrameTimestamp(), t.setToRedraw(!0);
    }
    Wt() {
        if (!this.G) return [];
        const t = {}, e = [];
        for(const n in this.G){
            const r = this.G[n];
            if (r) for(let n = 0; n < r.length; n++){
                const s = r[n], i = s && s.geometry;
                if (!s || !i) continue;
                const o = s.properties.serviceIndex;
                t[o] || (t[o] = new Set);
                const a = i.properties.batchIdData;
                if (a) for(let n = 0; n < a.length; n++)t[o].has(a[n]) || (e.push({
                    id: a[n],
                    service: o
                }), t[o].add(a[n]));
            }
        }
        return e;
    }
    hasIBL() {
        const t = this.getMap().getLightManager();
        return !!(t && t.getAmbientResource());
    }
}
function $5671aa7ae64fb35e$var$vr(t) {
    for(let e = 0; e < t.length; e++)t[e] && (t[e].array && (t[e].array = null), t[e].mipmap && (t[e].mipmap = null), t[e].indices && (t[e].indices = null));
}
function $5671aa7ae64fb35e$var$Tr(t, e) {
    if (e) for(let n = 0; n < e.length; n++)t[e[n].id || e[n].index] = e[n];
}
const $5671aa7ae64fb35e$var$_r = [];
class $5671aa7ae64fb35e$var$Mr {
    constructor(t, e, n, r, s){
        this.h = r, this.Qt = t, this.H = e, this.te = s, this.ee = n.version, t.indexOf("i3s:tileset:") < 0 ? (this.ee <= 1.6 ? this.ne = "root" : this.ne = 0, n.version = this.ee) : (this.ne = t.substring(12), this.ee > 1.6 && (this.ne = parseInt(this.ne))), this.Qt = t, this.re = n;
    }
    load() {
        const t = this.re, e = t.layerScene.baseUrl;
        if (this.ee <= 1.6) return t[this.ne] && t[this.ne].lodSelection ? (this.se = t[this.ne], this.ie()) : new Promise((n)=>{
            let r = e + "/nodes/" + this.ne;
            t.layerScene.eslpk && (r += "/3dNodeIndexDocument.json"), this.te(this.H, r, ()=>{
                this.se = t[this.ne], n(this.ie());
            });
        });
        if (this.ee >= 1.7) {
            if (t[this.ne]) return this.se = t[this.ne], this.ie();
            const n = Math.floor(this.ne / t.nodesPerPage);
            return new Promise((r)=>{
                let s = e + "/nodepages/" + n;
                t.layerScene.eslpk && (s += ".json"), this.te(this.H, s, ()=>{
                    this.se = t[this.ne], r(this.ie());
                });
            });
        }
        return null;
    }
    getTileset() {
        return this.oe;
    }
    getChildrenURL() {
        return this.ae;
    }
    ie() {
        const t = this.re, e = t.layerScene.baseUrl, n = this.se.children, r = [], s = {};
        if (n) for(let i = 0; i < n.length; i++)if (this.ee <= 1.6) {
            const o = n[i].id;
            if (t[o]) continue;
            const a = o;
            s[a] || (s[a] = new Promise((n)=>{
                let r = e + "/nodes/" + a;
                t.layerScene.eslpk && (r += "/3dNodeIndexDocument.json"), this.te(this.H, r, ()=>{
                    n();
                });
            }), r.push(s[a]));
        } else {
            const o = n[i];
            if (t[o]) continue;
            const a = Math.floor(o / t.nodesPerPage);
            s[a] || (s[a] = new Promise((n)=>{
                let r = e + "/nodepages/" + a;
                t.layerScene.eslpk && (r += ".json"), this.te(this.H, r, ()=>{
                    n();
                });
            }), r.push(s[a]));
        }
        return r.length ? Promise.all(r).then(()=>this.ce()) : this.ce();
    }
    ce() {
        return Promise.resolve(this.le());
    }
    he(t) {
        $5671aa7ae64fb35e$var$Tr(this.re, t);
    }
    le() {
        return {
            asset: {
                i3s: !0,
                version: "1.0",
                gltfUpAxis: "Z"
            },
            geometricError: Number.MAX_VALUE,
            root: this.ue(this.se, !0)
        };
    }
    ue(t) {
        const e = this.h.getRenderer(), n = this.re.projection, r = !n || n && 4326 === n.wkid, s = this.ee, i = this.re, o = t, a = o.obb, c = o.mbs, l = {};
        let h;
        if (c) h = (0, $eIStk).set([], c[0], c[1], c[2]), r || (h = e.fe(h, h)), h = $5671aa7ae64fb35e$var$Or([], h[0], h[1], h[2]), l.sphere = [
            ...h,
            c[3]
        ];
        else if (a) {
            h = (0, $eIStk).set([], a.center[0], a.center[1], a.center[2]), r || (h = e.fe(h, h)), h = $5671aa7ae64fb35e$var$Or([], h[0], h[1], h[2]);
            const t = function(t, e, n) {
                const r = (0, $bDSmI).fromQuat([], n);
                return r[0] = r[0] * e[0], r[1] = r[1] * e[0], r[2] = r[2] * e[0], r[3] = r[3] * e[1], r[4] = r[4] * e[1], r[5] = r[5] * e[1], r[6] = r[6] * e[2], r[7] = r[7] * e[2], r[8] = r[8] * e[2], [
                    ...t,
                    ...r
                ];
            }(h, a.halfSize, a.quaternion), n = t[3] + t[6] + t[9], s = t[4] + t[7] + t[10], i = t[5] + t[8] + t[11];
            (0, $eIStk).set($5671aa7ae64fb35e$var$_r, n, s, i);
            const o = (0, $eIStk).len($5671aa7ae64fb35e$var$_r);
            l.sphere = [
                ...h,
                o
            ];
        }
        let u = 1 / 0, f = 0;
        if (o.mbs ? f = o.mbs[3] : o.obb && (f = Math.max(Math.max(o.obb.halfSize[0], o.obb.halfSize[1]), o.obb.halfSize[2])), void 0 !== o.lodThreshold) {
            if ("maxScreenThresholdSQ" === i.lodSelectionMetricType) u = f / (Math.sqrt(o.lodThreshold) / (.25 * Math.PI));
            else console.error("Unsupported lodSelectionMetricType in Layer");
        } else if (void 0 !== o.lodSelection) for(let t = 0; t < o.lodSelection.length; t++)"maxScreenThreshold" === o.lodSelection[t].metricType && (u = f / o.lodSelection[t].maxError);
        (u === 1 / 0 || isNaN(u)) && (u = 1e5);
        const d = 16 * u, m = (0, $3iqbd).identity([]), p = o.children;
        let b;
        if (p) {
            b = [];
            const t = this.re;
            for(let e = 0; e < p.length; e++){
                const n = s <= 1.6 ? p[e].id : p[e];
                if (!t[n]) {
                    b = null;
                    break;
                }
                b.push(this.ue(t[n]));
            }
        }
        const y = {
            refine: "REPLACE",
            boundingVolume: l,
            transform: m,
            geometricError: d
        };
        return s <= 1.6 ? t.lodSelection ? t.geometryData && (y.content = {
            uri: "i3s:mesh:" + (t.id || t.index)
        }) : y.content = {
            uri: "i3s:tileset:" + (t.id || t.index)
        } : p && p.length && !b ? y.content = {
            uri: "i3s:tileset:" + (t.id || t.index)
        } : o.mesh && (y.content = {
            uri: "i3s:mesh:" + (t.id || t.index)
        }), b && b.length && (y.children = b), y;
    }
    getJSON() {
        return this.se;
    }
}
function $5671aa7ae64fb35e$var$Or(t, e, n, r) {
    return $5671aa7ae64fb35e$var$ie(t, $5671aa7ae64fb35e$var$wt(e), $5671aa7ae64fb35e$var$wt(n), r);
}
const $5671aa7ae64fb35e$var$Ar = !!$5671aa7ae64fb35e$var$Gt.ktx2, $5671aa7ae64fb35e$var$xr = (0, $3iqbd).identity([]), $5671aa7ae64fb35e$var$Ir = (()=>{
    try {
        if ("object" == typeof WebAssembly && "function" == typeof WebAssembly.instantiate) {
            const t = new WebAssembly.Module(Uint8Array.of(0, 97, 115, 109, 1, 0, 0, 0));
            if (t instanceof WebAssembly.Module) return new WebAssembly.Instance(t) instanceof WebAssembly.Instance;
        }
    } catch (t) {}
    return !1;
})();
function $5671aa7ae64fb35e$var$Sr(t) {
    return t.indexOf("i3s:mesh") >= 0;
}
const $5671aa7ae64fb35e$var$Cr = 9;
function $5671aa7ae64fb35e$var$kr(t, e, n, r, s) {
    const i = e.layerScene.eslpk, o = function(t, e) {
        const n = e.substring($5671aa7ae64fb35e$var$Cr);
        return t >= 1.7 ? parseInt(n) : n;
    }(e.version, t), a = e[o], c = e.layerScene.baseUrl, l = [];
    let h = !1;
    const u = $5671aa7ae64fb35e$var$xr;
    let f, d;
    if (e.version <= 1.6) {
        if (!a.geometryData) return null;
        const t = a.geometryData.length;
        if (!t) return null;
        let n = c + `/nodes/${a.id}/` + a.geometryData[t - 1].href;
        i && (n += ".bin");
        const r = {
            geometry: {
                url: n,
                info: e.layerScene.store.defaultGeometrySchema
            }
        };
        let s = a.textureData && a.textureData[0] && a.textureData[0].href;
        if (s) {
            const t = e.layerScene.store.textureEncoding[0];
            let n;
            n = "image/jpeg" === t ? "jpg" : "png", i && (s += "." + n);
            const o = {
                pbrMetallicRoughness: {
                    baseColorTexture: {
                        url: c + `/nodes/${a.id}/` + s,
                        factor: 1,
                        format: n,
                        mimeType: t
                    },
                    metallicFactor: 0
                }
            };
            r.material = o;
        }
        l.push(r);
    } else {
        f = a.mesh.geometry, d = a.mesh.material;
        const t = e.layerScene.geometryDefinitions, o = (e.layerScene.store || {}).textureEncoding, u = t[f.definition], { geometryBuffers: m } = u;
        h = r && 2 === m.length;
        const p = $5671aa7ae64fb35e$var$Gt.draco && h ? m[1] : m[0], b = $5671aa7ae64fb35e$var$Gt.draco && h ? 1 : 0;
        let y = c + `/nodes/${f.resource}/geometries/` + b;
        i && (y += ".bin");
        const g = {
            geometry: {
                url: y,
                info: p
            }
        };
        if (s && $5671aa7ae64fb35e$var$Ir && h && !$5671aa7ae64fb35e$var$Gt.draco) throw new Error("Must import @maptalks/transcoder.draco to load i3s draco compressed geometry");
        const w = e.layerScene.materialDefinitions, v = e.layerScene.textureSetDefinitions;
        let T, _ = 0;
        if (d && (_ = w[d.definition]), w) T = function(t, e, n, r, s, i, o) {
            const a = JSON.parse(JSON.stringify(e));
            return $5671aa7ae64fb35e$var$Nr(t, a, n, r, s, i, o), a;
        }(o, _, v, c, d.resource, n, e.layerScene.eslpk);
        else T = {
            pbrMetallicRoughness: {
                metallicFactor: 0
            }
        };
        g.material = T, l.push(g);
    }
    return {
        dracoCompression: h,
        meshes: l,
        nodeIndex: o,
        center: a.obb && a.obb.center || a.mbs && [
            a.mbs[0],
            a.mbs[1],
            a.mbs[2]
        ],
        transform: u
    };
}
function $5671aa7ae64fb35e$var$Nr(t, e, n, r, s, i, o) {
    for(const a in e)if (e[a] && e[a].textureSetDefinitionId >= 0) {
        const c = n[e[a].textureSetDefinitionId], l = "images/" + c.formats[0].format, h = $5671aa7ae64fb35e$var$Er(c.formats, i, t), u = {
            url: r + `/nodes/${s}/textures/${h.name}`,
            factor: void 0 === e[a].factor ? 1 : e[a].factor,
            format: h.format,
            mimeType: l
        };
        if (o) {
            let t = "";
            switch(h.format){
                case "dds":
                    t = "bin.dds";
                    break;
                case "jpg":
                case "png":
                    t = h.format;
            }
            u.url += "." + t;
        }
        e[a] = u;
    } else $5671aa7ae64fb35e$var$yt(e[a]) && $5671aa7ae64fb35e$var$Nr(t, e[a], n, r, s, i, o);
}
const $5671aa7ae64fb35e$var$Lr = {
    "image/jpeg": "jpg",
    "image/jpg": "jpg",
    "image/png": "jpg",
    "image/vnd-ms.dds": "dds",
    "image/ktx": "jpg"
};
function $5671aa7ae64fb35e$var$Er(t, e, n) {
    if (n && n.length) {
        const e = n[n.length - 1], r = $5671aa7ae64fb35e$var$Lr[e];
        if (r) for(let e = 0, n = t.length; e < n; e++){
            if (t[e].format === r) return t[e];
        }
        else console.error("i3s not find texture format type from:", $5671aa7ae64fb35e$var$Lr, "current textureEncoding:", e);
    }
    for(let n = 0; n <= t.length; n++){
        const r = t[n].format;
        if ("dds" === r && e.hasExtension("WEBGL_compressed_texture_s3tc")) return t[n];
        if ("jpg" === r || "png" === r) return t[n];
        if ("ktx2" === r && $5671aa7ae64fb35e$var$Ar) return t[n];
    }
    return null;
}
const { Ajax: $5671aa7ae64fb35e$var$Rr } = $5671aa7ae64fb35e$var$Dt(), $5671aa7ae64fb35e$var$Pr = new $gP1US.Coordinate(0, 0), $5671aa7ae64fb35e$var$Ur = new $gP1US.Coordinate(0, 0), $5671aa7ae64fb35e$var$Br = new Set, $5671aa7ae64fb35e$var$Gr = [], $5671aa7ae64fb35e$var$Dr = new class {
    constructor(t, e){
        this.max = t, this.currentSize = 0, this.data = new Map, this.onRemove = e;
    }
    reset(t) {
        if (this.data) {
            const e = this.data.keys();
            for (const n of e){
                const e = this.data.get(n);
                t && t !== e.renderer || this.de(n, e);
            }
        }
        return t || (this.data = new Map, this.currentSize = 0), this;
    }
    clear(t) {
        this.reset(t);
    }
    add(t, e) {
        if (!e) return this;
        if (e.node && e.node.memorySize && (this.currentSize += e.node.memorySize), this.has(t)) {
            const n = this.data.get(t);
            n && n.node && n.node.memorySize && (this.currentSize -= n.node.memorySize), this.data.delete(t), this.data.set(t, e);
        } else this.data.set(t, e);
        return this;
    }
    shrink() {
        if (this.currentSize > this.max) {
            let t = !1;
            const e = this.data.keys();
            let n = e.next();
            for(; this.currentSize > this.max && void 0 !== n.value;){
                !t && this.data.get(n.value).current && (t = !0, console.warn(`current maxGPUMemory(${this.max / 1024 / 1024}) for Geo3DTilesLayer is not enough, one or more current tiles will be discarded.`));
                const r = this.getAndRemove(n.value);
                r && this.onRemove(r), n = e.next();
            }
        }
    }
    has(t) {
        return this.data.has(t);
    }
    keys() {
        const t = new Array(this.data.size);
        let e = 0;
        const n = this.data.keys();
        for (const r of n)t[e++] = r;
        return t;
    }
    getAndRemove(t) {
        if (!this.has(t)) return null;
        const e = this.data.get(t);
        return e.node && e.node.memorySize && (this.currentSize -= e.node.memorySize), this.data.delete(t), e;
    }
    get(t) {
        if (!this.has(t)) return null;
        const e = this.data.get(t);
        return this.data.delete(t), this.data.set(t, e), e;
    }
    remove(t) {
        if (!this.has(t)) return this;
        const e = this.data.get(t);
        return this.de(t, e), this;
    }
    de(t, e) {
        e.node && e.node.memorySize && (this.currentSize -= e.node.memorySize), this.data.delete(t), this.onRemove(e);
    }
    setMaxSize(t) {
        return this.max = t, this.shrink(), this;
    }
    getMemorySize() {
        let t = 0;
        const e = this.data.values();
        for (const n of e){
            const e = n && n.node;
            e && e.memorySize && (t += e.memorySize);
        }
        return t;
    }
    markAll(t, e) {
        const n = this.data.values();
        for (const r of n)t && r.renderer !== t || (r.current = e);
    }
}(1024 * ($gP1US.Browser.mobile ? 32 : 1024) * 1024, (t)=>{
    const e = t.renderer;
    delete t.renderer, e.deleteTile(t);
});
let $5671aa7ae64fb35e$var$Fr = 0;
class $5671aa7ae64fb35e$var$jr extends (0, $9e7Ip.MaskRendererMixin)($gP1US.renderer.CanvasRenderer) {
    constructor(t){
        super(t);
        const e = 1024 * t.options.maxGPUMemory * 1024;
        e > $5671aa7ae64fb35e$var$Dr.max && $5671aa7ae64fb35e$var$Dr.setMaxSize(e), this.tileCache = $5671aa7ae64fb35e$var$Dr, $5671aa7ae64fb35e$var$Fr++, this.tilesLoading = {}, this.me = {}, this.pe = [], this.te = (...t)=>this.be.call(this, ...t);
    }
    getAnalysisMeshes() {
        if (!this.painter) return $5671aa7ae64fb35e$var$Gr;
        const t = this.painter.getPaintedMeshes();
        if (!t) return $5671aa7ae64fb35e$var$Gr;
        const e = [], { b3dmMeshes: n, pntsMeshes: r, i3dmMeshes: s } = t;
        return n.length && $5671aa7ae64fb35e$var$kt(e, n.filter((t)=>!(!t || !t.geometry))), r.length && $5671aa7ae64fb35e$var$kt(e, r.filter((t)=>!(!t || !t.geometry))), s.length && $5671aa7ae64fb35e$var$kt(e, s.filter((t)=>!(!t || !t.geometry))), e;
    }
    needToRedraw() {
        return !!this.getMap().isInteracting() || !!this.pe.length || super.needToRedraw();
    }
    getFrameTimestamp() {
        return this.ye;
    }
    drawOnInteracting(t, e, n) {
        this.draw(e, n);
    }
    draw(t, e) {
        this.ye = t;
        const n = this.prepareCanvas();
        if (n && !n.intersects(this.canvasExtent2D)) return void this.completeRender();
        const { root: r, tiles: s } = this.layer.getTiles(), i = s.length;
        if (!s || !i) return void this.completeRender();
        this.painter.prepareRender(e), this.ge(), this.we(e);
        const { selectedTiles: o, requests: a } = this.ve(r, s);
        a.length && this.loadTiles(a), this.Te(o, e), this._e(), a.length || this.completeRender();
    }
    ve(t, e) {
        let n = [];
        this.Me();
        let r = 0;
        const s = this.Oe(), i = {};
        let o = !1, a = !1;
        for(let t = 0; t < e.length; t++){
            const s = e[t], c = s.node;
            if (i[c.id]) continue;
            i[c.id] = 1;
            let l = !1;
            const h = this.getCachedTile(c.id);
            if (this.Ae(c.id) ? (r++, l = a = !0, this.tilesLoading[c.id].current = !0) : h ? (this.getTileOpacity(h) < 1 && (l = a = !0), o = !0, s.selected = !0, s.data = h) : this.painter.has(c) || (l = a = !0, n.push(c)), !l) continue;
            if (this.xe(s)) o = !0;
            else this.Ie(s).length && (o = !0);
        }
        const c = o ? this.Se(t) : [];
        if (n.length > 1 && (n.sort($5671aa7ae64fb35e$var$zr), s)) {
            const t = s - r;
            n = t > 0 ? n.slice(0, t) : [];
        }
        return {
            loading: a,
            requests: n,
            selectedTiles: c
        };
    }
    Se(t) {
        const e = [];
        let n, r;
        const s = [
            t
        ], i = [];
        for(; s.length > 0 || i.length > 0;){
            if (i.length > 0) {
                const t = i[i.length - 1];
                if (t.Ce === s.length) {
                    i.pop(), t === n && (t.leave = !0), t.branchRootId = r, e.push(t), 0 === i.length && (r = null);
                    continue;
                }
            }
            const t = s.pop(), o = t.children;
            if (t.selected) {
                if ("add" === t.node.refine) t.leave = !0, t.selectionDepth = i.length, t.branchRootId = r, e.push(t);
                else {
                    if (t.selectionDepth = i.length, n = t, 0 === o.length) {
                        t.leave = !0, t.branchRootId = r, e.push(t);
                        continue;
                    }
                    0 === i.length && (r = t.node.id), i.push(t), t.Ce = s.length;
                }
            }
            for(let t = 0; t < o.length; t++)s.push(o[t]);
        }
        return e;
    }
    xe(t) {
        if (!t.parent) return null;
        let e = t.parent;
        for(; e && e.level >= 0;){
            const t = e.node.id;
            if (this.tileCache.has(t)) return e.selected = !0, e.data = this.tileCache.get(t), e;
            e = e.parent;
        }
        return null;
    }
    Ie(t) {
        const e = [];
        if (!t.node.children || !t.node.children.length) return e;
        const n = t.ke + 1, r = [
            t.node
        ];
        for(; r.length > 0;){
            const s = r.pop().children;
            for(let i = 0, o = s.length; i < o; i++){
                if ((!s[i].content || !s[i].content.url) && s[i].children && s[i].children.length) {
                    r.push(s[i]);
                    continue;
                }
                const o = s[i].id;
                if (this.tileCache.has(o)) {
                    const n = this.layer.Ne(s[i], t);
                    n.selected = !0, n.data = this.tileCache.get(o), t.children.push(n), e.push(n);
                } else s[i].ke <= n && r.push(s[i]);
            }
        }
        return e;
    }
    Te(t, e) {
        this.tileCache.markAll(this, !1);
        const n = [];
        for(let e = 0, r = t.length; e < r; e++){
            const r = t[e].data;
            r.current = !0, r.renderer = this, this.tileCache.add(t[e].node.id, r);
            const s = r.node, i = this.layer.j(s.H);
            s.dt && i.debug && !Array.isArray(i.debug) && n.push(s.dt);
        }
        const r = this.layer.options.services;
        for(let t = 0; t < r.length; t++){
            const e = r[t], s = Array.isArray(e.debug) && e.debug;
            if (s) for (const t of s){
                const e = this.layer.Dt(t), r = e && e.node;
                r && r.dt && n.push(r.dt);
            }
        }
        const s = {
            tiles: t
        };
        this.onDrawTileStart(s);
        const i = this.painter.paint(t, n, e);
        this.layer.fire("drawtiles", {
            count: i
        }), this.onDrawTileEnd(s), i && this.layer.fire("canvasisdirty", {
            renderCount: i
        }), this.tileCache.shrink();
    }
    onDrawTileStart() {}
    onDrawTileEnd() {}
    loadTiles(t) {
        for(let e = 0, n = t.length; e < n; e++){
            const n = t[e];
            this.tilesLoading[n.id] = {
                current: !0,
                node: n
            }, this.loadTile(n);
        }
    }
    loadTile(t) {
        let e = t.content.url;
        if ($5671aa7ae64fb35e$var$St(e)) {
            const n = $5671aa7ae64fb35e$var$Ct(e);
            return this.Le(e, n, t), null;
        }
        if (function(t) {
            return t.indexOf("i3s:tileset") >= 0;
        }(e)) {
            const n = t.H, r = this.Ee[n];
            return new $5671aa7ae64fb35e$var$Mr(e, n, r, this.layer, this.te).load().then((n)=>{
                this.onTilesetLoad(n, t, e);
            });
        }
        return t && $5671aa7ae64fb35e$var$Rt(e) && !$5671aa7ae64fb35e$var$Sr(e) && (e = t.baseUrl + e), this.Le(e, null, t), null;
    }
    Le(t, e, r) {
        let s = this.Re;
        s || (s = (0, $2wazW).Util.getSupportedFormats(this.gl.gl || this.gl), this.Re = s);
        const i = this.layer.j(r.H);
        i.isSuperMapiServer && (t = function(t, e) {
            const n = t.substring(e.length), r = n.split("/"), s = [];
            for(let t = 0; t < r.length; t++)s.push(encodeURIComponent(r[t]));
            return e + s.join("/");
        }(t, r.baseUrl));
        const o = {
            url: this.layer.getTileUrl(t, this.layer.Pe[r.H]),
            arraybuffer: e,
            rootIdx: r.H,
            upAxis: r.xt,
            transform: r.matrix,
            supportedFormats: s
        };
        if ($5671aa7ae64fb35e$var$Sr(t)) {
            const e = this.Ee[r.H];
            if (o.projection = e.projection, o.i3sInfo = $5671aa7ae64fb35e$var$kr(t, e, this.regl, this.layer.options.enableI3SCompressedGeometry, this.layer.options.forceI3SCompressedGeometry), !o.i3sInfo) return void this.onTileError({
                status: 404
            }, r, t);
        }
        o.service = $5671aa7ae64fb35e$var$pt({}, i), i.offset && delete o.service.offset, o.referrer = window && window.location.href, this.workerConn.loadTile(this.layer.getId(), o, (e, n)=>{
            if (e) return void this.onTileError(e, r, t);
            const { magic: s } = n;
            "b3dm" === s || "pnts" === s || "i3dm" === s || "cmpt" === s || "gltf" === s ? this.pe.push({
                data: n,
                tile: r
            }) : this.onTilesetLoad(n, r, t);
        });
    }
    Gt(t) {
        this.painter && this.painter.Gt(t);
    }
    Ft(t) {
        this.painter && this.painter.Ft(t);
    }
    we() {
        const t = this.getMap(), e = this.layer.options.meshLimitPerFrame;
        let n = 0;
        for(; this.pe.length && (n < e || !t.isInteracting());){
            const { data: t, tile: e } = this.pe.shift(), { magic: r } = t;
            "b3dm" === r || "gltf" === r ? this.painter.createB3DMMesh(t, e.id, e, (n, { mesh: r })=>{
                this.Ue(t, e, n, r);
            }) : "pnts" === r ? this.painter.createPntsMesh(t, e.id, e, (n, { mesh: r })=>{
                this.Ue(t, e, n, r);
            }) : "i3dm" === r ? this.painter.createI3DMMesh(t, e.id, e, (n, { mesh: r })=>{
                this.Ue(t, e, n, r);
            }) : "cmpt" === r && this.painter.createCMPTMesh(t, e.id, e, (n, { mesh: r })=>{
                this.Ue(t, e, n, r);
            }), n++;
        }
    }
    Ue(t, e, n, r) {
        if (n) this.onTileError(n, e);
        else {
            const n = this.Be(r);
            e.memorySize = n, this.onTileLoad(t, e);
        }
    }
    Be(t) {
        let e = 0;
        if (Array.isArray(t)) for(let n = 0; n < t.length; n++)t[n] && (e += this.Be(t[n]));
        else t && (e += t.getMemorySize());
        return e;
    }
    onTileLoad(t, e) {
        this.layer && (delete this.tilesLoading[e.id], this.layer.onTileLoad(t, e), this.Ge(e), this.setToRedraw(), this.layer.fire("tileload", {
            node: e
        }));
    }
    onTilesetLoad(t, e, n) {
        this.layer && (this.layer.zt = t.extensions && t.extensions["s3m:VertexCompressionType"], t.capabilities || t.layers && t.layers[0] && t.layers[0].capabilities ? this.De(t, e, n) : (delete this.tilesLoading[e.id], this.layer.onTilesetLoad(t, e, n)));
    }
    onTileError(e, n, r) {
        if (!this.layer) return;
        const s = r || n.content.url, i = e && e.message || e;
        e && (404 === e.status || 204 === e.status) || $5671aa7ae64fb35e$var$Br.has(i) || (console.warn("failed to load 3d tile: " + s), console.warn(e), $5671aa7ae64fb35e$var$Br.add(i)), delete this.tilesLoading[n.id], (!this.layer.options.onlyCacheNoContentTileWhenError || e && !$gP1US.Util.isNoContentHttpCode(e.status)) && this.Fe(n, e), this.layer.fire("tileerror", {
            node: n,
            error: e
        });
    }
    getCachedTile(t) {
        return this.tileCache.get(t);
    }
    getShadowMeshes() {
        if (!this.painter) return [];
        const t = [], e = this.painter.getCurrentB3DMMeshes();
        for(const n in e)e[n] && e[n].isValid && e[n].isValid() && t.push(e[n]);
        const n = this.painter.getCurrentI3DMMeshes();
        for(const e in n)n[e] && n[e].isValid && n[e].isValid() && t.push(n[e]);
        return t;
    }
    Fe(e, n) {
        const r = {
            loadTime: $gP1US.Util.now(),
            current: !0,
            error: n,
            node: e
        };
        r.renderer = this, this.tileCache.add(e.id, r);
    }
    Ge(e) {
        const n = {
            loadTime: $gP1US.Util.now(),
            current: !0,
            node: e
        };
        n.renderer = this, this.tileCache.add(e.id, n);
    }
    abortTileLoading(t) {
        if (!t || !this.workerConn) return;
        const e = t.node.content.url;
        this.workerConn.abortTileLoading(this.layer.getId(), e), delete this.me[e];
    }
    Me() {
        if (this.tilesLoading) for(const t in this.tilesLoading)this.tilesLoading[t].current = !1;
    }
    deleteTile(t) {
        this.painter.deleteTile(t);
    }
    createContext() {
        const t = this.layer, e = t.options.glOptions || {
            alpha: !0,
            depth: !0,
            stencil: !0,
            preserveDrawingBuffer: !0,
            antialias: t.options.antialias
        }, n = this.canvas.gl && this.canvas.gl.wrap;
        n ? (this.gl = this.canvas.gl.wrap(), this.regl = this.canvas.gl.regl) : (this.glOptions = e, this.gl = this.je(this.canvas, e)), this.regl = this.regl || (0, (/*@__PURE__*/$parcel$interopDefault($9I15V)))({
            gl: this.gl,
            attributes: e,
            extensions: [
                "OES_element_index_uint"
            ],
            optionalExtensions: t.options.optionalExtensions || []
        }), this.prepareWorker(), n && (this.canvas.pickingFBO = this.canvas.pickingFBO || this.regl.framebuffer(this.canvas.width, this.canvas.height)), this.pickingFBO = this.canvas.pickingFBO || this.regl.framebuffer(this.canvas.width, this.canvas.height), this.painter = new $5671aa7ae64fb35e$var$wr(this.regl, t), this.layer.ze(), this.layer.fire("contextcreate", {
            regl: this.regl
        });
    }
    prepareWorker() {
        const t = this.getMap();
        this.workerConn || (this.workerConn = new $5671aa7ae64fb35e$var$jt("@maptalks/3dtiles", t.id, (0, $2wazW).Util.supportNPOT(this.regl)));
        const e = this.workerConn;
        if (!e.isActive()) return;
        let r = this.layer.options || {};
        r = $5671aa7ae64fb35e$var$pt({}, r), delete r.offset;
        const s = t.options.spatialReference;
        r.projection = s && s.coordType || s && s.projection || t.getSpatialReference().getProjection().code;
        const i = this.layer.getId();
        e.addLayer(i, r, (t)=>{
            if (t) throw t;
            this.layer && (this.ready = !0, this.layer.fire("workerready"));
        });
    }
    onRemove() {
        this.painter && this.painter.remove(), this.pickingFBO && (this.canvas.pickingFBO || this.pickingFBO.destroy(), delete this.pickingFBO), this.workerConn && (this.workerConn.removeLayer(this.layer.getId(), (t)=>{
            if (t) throw t;
        }), this.workerConn.remove(), delete this.workerConn), $5671aa7ae64fb35e$var$Fr--, $5671aa7ae64fb35e$var$Fr || $5671aa7ae64fb35e$var$Dr.reset(), this.clear(), delete this.tileCache, super.onRemove();
    }
    clear() {
        this._e(!0), this.tileCache.reset(this), this.tilesLoading = {}, super.clear();
    }
    clearCanvas() {
        this.regl && this.regl.clear({
            color: [
                0,
                0,
                0,
                0
            ],
            depth: 1,
            stencil: 0
        }), super.clearCanvas();
    }
    getTileOpacity() {
        return 1;
    }
    getStencilValue() {
        return 0;
    }
    _e(t) {
        this.He || (this.He = Date.now());
        const e = Date.now();
        if (!t && e - this.He < this.layer.options.retireInterval) return;
        this.He = e;
        const n = [];
        for(const e in this.tilesLoading){
            const r = this.tilesLoading[e];
            !t && r.current || (n.push(e), this.abortTileLoading(r));
        }
        for(let t = 0; t < n.length; t++)delete this.tilesLoading[n[t]];
    }
    Oe() {
        return this.getMap().isInteracting() ? this.layer.options.loadingLimitOnInteracting : this.layer.options.loadingLimit;
    }
    je(t, e) {
        const n = [
            "webgl",
            "experimental-webgl"
        ];
        let r = null;
        for(let s = 0; s < n.length; ++s){
            try {
                r = t.getContext(n[s], e);
            } catch (t) {}
            if (r) break;
        }
        return r;
    }
    Ae(t) {
        return !!this.tilesLoading[t];
    }
    getI3DMMeshes() {
        return this.painter.getI3DMMeshes();
    }
    getPNTSMeshes() {
        return this.painter.getPNTSMeshes();
    }
    getB3DMMeshes() {
        return this.painter.getB3DMMeshes();
    }
    readBatchData(t, e, n) {
        return $5671aa7ae64fb35e$var$xe(t, e, 0, n);
    }
    ge() {
        if (!this.qe) return;
        const t = this.layer.options.i3sNodepageLimitPerFrame || Number.MAX_VALUE;
        let e = 0;
        const n = [];
        for(const r in this.qe){
            const s = this.qe[r];
            if ("pending" === s.status) continue;
            s.status = "pending";
            const i = s.rootIdx, o = $5671aa7ae64fb35e$var$Pt(this.layer.j(i).fetchOptions);
            if (n.push($5671aa7ae64fb35e$var$Rr.getJSON(r, o).then((t)=>{
                delete this.qe[r];
                const e = this.Ee[i];
                if (e) {
                    t.nodes ? $5671aa7ae64fb35e$var$Tr(e, t.nodes) : (e[t.id] = t, $5671aa7ae64fb35e$var$Tr(e, t.children));
                    for(let t = 0; t < s.length; t++)s[t]();
                    this.setToRedraw();
                } else this.setToRedraw();
            })), e++, e >= t) break;
        }
        n.length && Promise.all(n);
    }
    be(t, e, n) {
        this.qe || (this.qe = {}), this.qe[e] = this.qe[e] || [], this.qe[e].rootIdx = t, this.qe[e].push(n), this.setToRedraw();
    }
    De(t, e, n) {
        this.Ee || (this.Ee = []);
        const r = e.H;
        this.Ee[r] || (this.Ee[r] = {});
        const s = this.Ee[r], i = this.layer.j(r);
        t.layers && (t = t.layers[0], "/" !== n[n.length - 1] && (n += "/"), n += "layers/0"), s.version = +(i.i3sVersion || t.store.version), !t.spatialReference || t.spatialReference.wkid && 4326 === t.spatialReference.wkid || console.warn("i3s has a spatialReference other than 4326.", t.spatialReference), t.spatialReference && 4490 === t.spatialReference.wkid && (console.warn("i3s spatialReference is 4490,auto set spatialReference to 4326,This may cause some location issues, please ensure that your service is 4326"), t.spatialReference.wkid = 4326), s.projection = t.spatialReference, (function(t, e, n, r, s, i, o) {
            if (!i.layerScene) {
                i.layerScene = e, i.nodesPerPage = e.nodePages && e.nodePages.nodesPerPage || 64, i.lodSelectionMetricType = e.nodePages && e.nodePages.lodSelectionMetricType;
                let t = s;
                if (i.layerScene.eslpk = t.indexOf("3dSceneLayer.json") >= 0, t.endsWith(".json")) {
                    const e = s.lastIndexOf("/");
                    t = e < 0 ? "./" : s.substring(0, e);
                }
                i.layerScene.baseUrl = function(t) {
                    return t.split("?")[0];
                }(t);
            }
            return new $5671aa7ae64fb35e$var$Mr(s, n, i, t, o).load();
        })(this.layer, t, r, 0, n, s, this.te).then((t)=>{
            this.onTilesetLoad(t, e, n);
        });
    }
    pick(t, e, n) {
        if (!this.painter) return [];
        const r = this.pickingFBO, { width: s, height: i } = this.canvas;
        return !this.pickingFBO || r.width === s && r.height === i || r.resize(s, i), this.painter.pick(t, e, n && n.tolerance);
    }
    highlight(t) {
        if (this.J || (this.J = []), Array.isArray(t)) for(let e = 0; e < t.length; e++){
            const n = t[e].service || 0;
            let r = this.J[n];
            r || (r = this.J[n] = new Map), r.set(t[e].id, t[e]);
        }
        else {
            const e = t.service || 0;
            let n = this.J[e];
            n || (n = this.J[e] = new Map), n.set(t.id, t);
        }
        this.painter.highlight(this.J);
    }
    cancelHighlight(t, e) {
        if (!this.J) return;
        const n = this.J[t];
        if (n) {
            if (Array.isArray(e)) for(let t = 0; t < e.length; t++)n.delete(e[t]);
            else n.delete(e);
            n.size || (this.J[t] = null), this.painter.highlight(this.J);
        }
    }
    cancelAllHighlight() {
        delete this.J, this.painter.cancelAllHighlight();
    }
    showOnly(t) {
        if (this.Z || (this.Z = []), Array.isArray(t)) for(let e = 0; e < t.length; e++){
            const n = t[e].service || 0;
            let r = this.Z[n];
            r || (r = this.Z[n] = new Map), r.set(t[e].id, t[e]);
        }
        else {
            const e = t.service || 0;
            let n = this.Z[e];
            n || (n = this.Z[e] = new Map), n.set(t.id, t);
        }
        this.painter.showOnly(this.Z);
    }
    cancelShowOnly() {
        delete this.Z, this.painter.cancelShowOnly();
    }
    Wt() {
        return this.painter ? this.painter.Wt() : [];
    }
    fe(t, e) {
        const n = this.getMap();
        if ("identity" === n.getProjection().code.toLowerCase()) {
            const n = this.$e();
            return $5671aa7ae64fb35e$var$Pr.set(e[0], e[1]), n.unproject($5671aa7ae64fb35e$var$Pr, $5671aa7ae64fb35e$var$Ur), t[0] = $5671aa7ae64fb35e$var$Ur.x, t[1] = $5671aa7ae64fb35e$var$Ur.y, t;
        }
        return $5671aa7ae64fb35e$var$Pr.set(e[0], e[1]), n.getProjection().unproject($5671aa7ae64fb35e$var$Pr, $5671aa7ae64fb35e$var$Ur), t[0] = $5671aa7ae64fb35e$var$Ur.x, t[1] = $5671aa7ae64fb35e$var$Ur.y, t;
    }
    Ve(t, e) {
        const n = this.$e();
        return $5671aa7ae64fb35e$var$Pr.set(e[0], e[1]), n.project($5671aa7ae64fb35e$var$Pr, $5671aa7ae64fb35e$var$Ur), t[0] = $5671aa7ae64fb35e$var$Ur.x, t[1] = $5671aa7ae64fb35e$var$Ur.y, t;
    }
    Je(t, e) {
        const n = this.$e();
        return $5671aa7ae64fb35e$var$Pr.set(e[0], e[1]), n.unproject($5671aa7ae64fb35e$var$Pr, $5671aa7ae64fb35e$var$Ur), t[0] = $5671aa7ae64fb35e$var$Ur.x, t[1] = $5671aa7ae64fb35e$var$Ur.y, t;
    }
    $e() {
        const e = this.getMap().options.spatialReference.coordType;
        if (!e) throw new Error("Missing coordType in map spatialReference.");
        return this.Ye || (this.Ye = $gP1US.SpatialReference.getProjectionInstance(e)), this.Ye;
    }
}
function $5671aa7ae64fb35e$var$zr(t, e) {
    return t.ft - e.ft;
}
function $5671aa7ae64fb35e$var$Hr(t, e, n) {
    return t[0] = e[n], t[1] = e[n + 3], t[2] = e[n + 6], t;
}
function $5671aa7ae64fb35e$var$qr(t, e, n) {
    return Math.sqrt(function(t, e, n) {
        const r = (0, $eIStk).subtract($5671aa7ae64fb35e$var$$r, n, t), s = $5671aa7ae64fb35e$var$Hr($5671aa7ae64fb35e$var$Vr, e, 0), i = $5671aa7ae64fb35e$var$Hr($5671aa7ae64fb35e$var$Jr, e, 1), o = $5671aa7ae64fb35e$var$Hr($5671aa7ae64fb35e$var$Yr, e, 2), a = (0, $eIStk).len(s), c = (0, $eIStk).len(i), l = (0, $eIStk).len(o);
        (0, $eIStk).normalize(s, s), (0, $eIStk).normalize(i, i), (0, $eIStk).normalize(o, o);
        const h = $5671aa7ae64fb35e$var$Zr;
        h[0] = (0, $eIStk).dot(r, s), h[1] = (0, $eIStk).dot(r, i), h[2] = (0, $eIStk).dot(r, o);
        let u, f = 0;
        h[0] < -a ? (u = h[0] + a, f += u * u) : h[0] > a && (u = h[0] - a, f += u * u);
        h[1] < -c ? (u = h[1] + c, f += u * u) : h[1] > c && (u = h[1] - c, f += u * u);
        h[2] < -l ? (u = h[2] + l, f += u * u) : h[2] > l && (u = h[2] - l, f += u * u);
        return f;
    }(t, e, n));
}
const $5671aa7ae64fb35e$var$$r = [], $5671aa7ae64fb35e$var$Vr = [], $5671aa7ae64fb35e$var$Jr = [], $5671aa7ae64fb35e$var$Yr = [], $5671aa7ae64fb35e$var$Zr = [];
const $5671aa7ae64fb35e$var$Kr = 2 * Math.PI;
class $5671aa7ae64fb35e$var$Xr {
    constructor(t, e, n, r){
        this.west = t, this.south = e, this.east = n, this.north = r;
    }
    static contains(t, e) {
        let n = e[0];
        const r = e[1], s = t.west;
        let i = t.east;
        return i < s && (i += $5671aa7ae64fb35e$var$Kr, n < 0 && (n += $5671aa7ae64fb35e$var$Kr)), (n > s || $5671aa7ae64fb35e$var$ve(n, s, 1e-14)) && (n < i || $5671aa7ae64fb35e$var$ve(n, i, 1e-14)) && r >= t.south && r <= t.north;
    }
    static southwest(t, e) {
        return e[0] = t.west, e[1] = t.south, e[2] = 0, e;
    }
    static northeast(t, e) {
        return e[0] = t.east, e[1] = t.north, e[2] = 0, e;
    }
    static southeast(t, e) {
        return e[0] = t.east, e[1] = t.south, e[2] = 0, e;
    }
    static northwest(t, e) {
        return e[0] = t.west, e[1] = t.north, e[2] = 0, e;
    }
}
const $5671aa7ae64fb35e$var$Wr = [
    0,
    0,
    1
];
function $5671aa7ae64fb35e$var$Qr(t, e) {
    return $5671aa7ae64fb35e$var$ie(e, t[0], t[1], t[2]);
}
class $5671aa7ae64fb35e$var$ts {
    constructor(t, e){
        this.normal = (0, $eIStk).copy([], t), this.distance = e;
    }
    static fromPointNormal(t, e, n) {
        const r = -(0, $eIStk).dot(e, t);
        return (0, $eIStk).copy(n.normal, e), n.distance = r, n;
    }
}
const $5671aa7ae64fb35e$var$es = [], $5671aa7ae64fb35e$var$ns = [], $5671aa7ae64fb35e$var$rs = [], $5671aa7ae64fb35e$var$ss = [], $5671aa7ae64fb35e$var$is = [], $5671aa7ae64fb35e$var$os = [], $5671aa7ae64fb35e$var$as = [], $5671aa7ae64fb35e$var$cs = [], $5671aa7ae64fb35e$var$ls = [], $5671aa7ae64fb35e$var$hs = [], $5671aa7ae64fb35e$var$us = new $5671aa7ae64fb35e$var$ts([
    1,
    0,
    0
], 0), $5671aa7ae64fb35e$var$fs = [];
class $5671aa7ae64fb35e$var$ds {
    constructor(t){
        this.southwestCornerCartesian = [], this.northeastCornerCartesian = [], this.westNormal = [], this.eastNormal = [], this.southNormal = [], this.northNormal = [], this.rectangle = new $5671aa7ae64fb35e$var$Xr(...t), this.minimumHeight = t[4], this.maximumHeight = t[5], this.computeBox(this.rectangle);
    }
    distanceToCamera(t, e) {
        let n = 0;
        if (!$5671aa7ae64fb35e$var$Xr.contains(this.rectangle, e)) {
            const e = this.southwestCornerCartesian, r = this.northeastCornerCartesian, s = this.westNormal, i = this.southNormal, o = this.eastNormal, c = this.northNormal, l = (0, $eIStk).subtract($5671aa7ae64fb35e$var$fs, t, e), h = (0, $eIStk).dot(l, s), u = (0, $eIStk).dot(l, i), f = (0, $eIStk).subtract($5671aa7ae64fb35e$var$fs, t, r), d = (0, $eIStk).dot(f, o), m = (0, $eIStk).dot(f, c);
            h > 0 ? n += h * h : d > 0 && (n += d * d), u > 0 ? n += u * u : m > 0 && (n += m * m);
        }
        const r = e[2], s = this.minimumHeight, i = this.maximumHeight;
        if (r > i) {
            const t = r - i;
            n += t * t;
        } else if (r < s) {
            const t = s - r;
            n += t * t;
        }
        return Math.sqrt(n);
    }
    computeBox(t) {
        const e = this;
        $5671aa7ae64fb35e$var$Qr($5671aa7ae64fb35e$var$Xr.southwest(t, $5671aa7ae64fb35e$var$ns), e.southwestCornerCartesian), $5671aa7ae64fb35e$var$Qr($5671aa7ae64fb35e$var$Xr.northeast(t, $5671aa7ae64fb35e$var$ns), e.northeastCornerCartesian), $5671aa7ae64fb35e$var$es[0] = t.west, $5671aa7ae64fb35e$var$es[1] = .5 * (t.south + t.north), $5671aa7ae64fb35e$var$es[2] = 0;
        const n = $5671aa7ae64fb35e$var$Qr($5671aa7ae64fb35e$var$es, $5671aa7ae64fb35e$var$rs), r = (0, $eIStk).cross($5671aa7ae64fb35e$var$is, n, $5671aa7ae64fb35e$var$Wr);
        (0, $eIStk).normalize(e.westNormal, r), $5671aa7ae64fb35e$var$es[0] = t.east;
        const s = $5671aa7ae64fb35e$var$Qr($5671aa7ae64fb35e$var$es, $5671aa7ae64fb35e$var$cs), i = (0, $eIStk).cross($5671aa7ae64fb35e$var$is, $5671aa7ae64fb35e$var$Wr, s);
        (0, $eIStk).normalize(e.eastNormal, i);
        const o = (0, $eIStk).subtract($5671aa7ae64fb35e$var$is, n, s), c = (0, $eIStk).normalize($5671aa7ae64fb35e$var$ss, o), l = t.south;
        let h;
        if (l > 0) {
            $5671aa7ae64fb35e$var$es[0] = .5 * (t.west + t.east), $5671aa7ae64fb35e$var$es[1] = l;
            const n = $5671aa7ae64fb35e$var$Qr($5671aa7ae64fb35e$var$es, $5671aa7ae64fb35e$var$ls);
            (0, $eIStk).copy($5671aa7ae64fb35e$var$hs, c);
            const r = $5671aa7ae64fb35e$var$ts.fromPointNormal(e.southwestCornerCartesian, e.westNormal, $5671aa7ae64fb35e$var$us);
            $5671aa7ae64fb35e$var$ms($5671aa7ae64fb35e$var$ls, $5671aa7ae64fb35e$var$hs, r, e.southwestCornerCartesian), h = $5671aa7ae64fb35e$var$ye(n, $5671aa7ae64fb35e$var$os);
        } else h = $5671aa7ae64fb35e$var$ge($5671aa7ae64fb35e$var$Xr.southeast(t, $5671aa7ae64fb35e$var$ns), $5671aa7ae64fb35e$var$os);
        const u = (0, $eIStk).cross($5671aa7ae64fb35e$var$as, h, o);
        (0, $eIStk).normalize(e.southNormal, u);
        const f = t.north;
        let d;
        if (f < 0) {
            $5671aa7ae64fb35e$var$es[0] = .5 * (t.west + t.east), $5671aa7ae64fb35e$var$es[1] = f;
            const n = $5671aa7ae64fb35e$var$Qr($5671aa7ae64fb35e$var$es, $5671aa7ae64fb35e$var$ls);
            (0, $eIStk).scale($5671aa7ae64fb35e$var$hs, c, -1);
            const r = $5671aa7ae64fb35e$var$ts.fromPointNormal(e.northeastCornerCartesian, e.eastNormal, $5671aa7ae64fb35e$var$us);
            $5671aa7ae64fb35e$var$ms($5671aa7ae64fb35e$var$ls, $5671aa7ae64fb35e$var$hs, r, e.northeastCornerCartesian), d = $5671aa7ae64fb35e$var$ye(n, $5671aa7ae64fb35e$var$os);
        } else d = $5671aa7ae64fb35e$var$ge($5671aa7ae64fb35e$var$Xr.northwest(t, $5671aa7ae64fb35e$var$ns), $5671aa7ae64fb35e$var$os);
        const m = (0, $eIStk).cross($5671aa7ae64fb35e$var$as, o, d);
        (0, $eIStk).normalize(e.northNormal, m);
    }
}
function $5671aa7ae64fb35e$var$ms(t, e, n, r) {
    const s = t, i = e, o = n.normal, c = (0, $eIStk).dot(o, i);
    if (Math.abs(c) < 1e-15) return;
    const l = (-n.distance - (0, $eIStk).dot(o, s)) / c;
    return l < 0 ? void 0 : (r = (0, $eIStk).scale(r, i, l), (0, $eIStk).add(r, s, r));
}
function $5671aa7ae64fb35e$var$ps(t) {
    return [
        t.xmin,
        t.ymin,
        t.xmax,
        t.ymax
    ];
}
const $5671aa7ae64fb35e$var$bs = $gP1US.BBOXUtil, $5671aa7ae64fb35e$var$ys = {
    "services": [],
    "maxGPUMemory": $gP1US.Browser.mobile ? 32 : 1536,
    "retireInterval": 2e3,
    "loadingLimitOnInteracting": 5,
    "loadingLimit": 10,
    "debug": !1,
    "meshLimitPerFrame": 1,
    "i3sNodepageLimitPerFrame": 1,
    "enableI3SCompressedGeometry": !0,
    "forceI3SCompressedGeometry": !0,
    "onlyCacheNoContentTileWhenError": !0,
    "picking": !0,
    "pickingPoint": !0,
    "geometryEvents": !1,
    "alwaysShowTopTiles": !0,
    "antialias": !1,
    "offset": [
        0,
        0
    ],
    "renderer": "gl",
    "forceRenderOnZooming": !0,
    "forceRenderOnRotating": !0,
    "forceRenderOnMoving": !0,
    "optionalExtensions": [
        "ANGLE_instanced_arrays",
        "OES_element_index_uint",
        "OES_standard_derivatives",
        "OES_vertex_array_object",
        "OES_texture_half_float",
        "OES_texture_half_float_linear",
        "OES_texture_float",
        "OES_texture_float_linear",
        "WEBGL_depth_texture",
        "EXT_shader_texture_lod",
        "WEBGL_compressed_texture_astc",
        "WEBGL_compressed_texture_etc",
        "WEBGL_compressed_texture_etc1",
        "WEBGL_compressed_texture_pvrtc",
        "WEBGL_compressed_texture_s3tc",
        "WEBGL_compressed_texture_s3tc_srgb"
    ]
}, $5671aa7ae64fb35e$var$gs = [
    0,
    0,
    0
], $5671aa7ae64fb35e$var$ws = [
    0,
    0,
    0
], $5671aa7ae64fb35e$var$vs = [
    0,
    0,
    0
], $5671aa7ae64fb35e$var$Ts = [
    0,
    0,
    0
], $5671aa7ae64fb35e$var$_s = [
    0,
    0,
    0
], $5671aa7ae64fb35e$var$Ms = [
    0,
    0,
    0
], $5671aa7ae64fb35e$var$Os = [
    0,
    0,
    0
], $5671aa7ae64fb35e$var$As = [
    1,
    1,
    1
], $5671aa7ae64fb35e$var$xs = [
    1,
    1,
    1
], $5671aa7ae64fb35e$var$Is = [
    0,
    0,
    0,
    0
], $5671aa7ae64fb35e$var$Ss = [], $5671aa7ae64fb35e$var$Cs = new $gP1US.Coordinate(0, 0), $5671aa7ae64fb35e$var$ks = new $gP1US.Point(0, 0), $5671aa7ae64fb35e$var$Ns = [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0
], $5671aa7ae64fb35e$var$Ls = [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0
], $5671aa7ae64fb35e$var$Es = [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0
], $5671aa7ae64fb35e$var$Rs = [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0
], $5671aa7ae64fb35e$var$Ps = new $gP1US.Point(0, 0), $5671aa7ae64fb35e$var$Us = (0, $3iqbd).identity([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0
]), $5671aa7ae64fb35e$var$Bs = [
    0,
    0
], $5671aa7ae64fb35e$var$Gs = [
    0,
    0,
    0
], $5671aa7ae64fb35e$var$Ds = [
    1,
    1,
    1
], $5671aa7ae64fb35e$var$Fs = [
    0,
    0,
    0
], $5671aa7ae64fb35e$var$js = [
    0,
    0,
    0
], $5671aa7ae64fb35e$var$zs = [
    0,
    0,
    0,
    0
], $5671aa7ae64fb35e$var$Hs = [
    1,
    1,
    1,
    1,
    -1,
    1,
    -1,
    -1,
    1,
    -1,
    1,
    1,
    1,
    1,
    -1,
    1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1,
    -1
];
class $5671aa7ae64fb35e$export$6e071cc129defa7d extends (0, $9e7Ip.MaskLayerMixin)($gP1US.Layer) {
    static fromJSON(t) {
        return t && "Geo3DTilesLayer" === t.type ? new $5671aa7ae64fb35e$export$6e071cc129defa7d(t.id, t.options) : null;
    }
    static getEnuTransform(t, e = [
        1,
        1,
        1
    ], n = [
        0,
        0,
        0
    ]) {
        const s = $5671aa7ae64fb35e$var$ie([], t[0] * Math.PI / 180, t[1] * Math.PI / 180, t[2] || 0), i = $5671aa7ae64fb35e$var$$e(s, null, []), a = (0, $k1dpP).fromEuler([
            0,
            0,
            0,
            0
        ], ...n), c = (0, $3iqbd).fromRotationTranslationScale([
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ], a, [
            0,
            0,
            0
        ], e);
        return (0, $3iqbd).multiply(c, i, c);
    }
    constructor(t, e){
        super(t, e), this.isGeo3DTilesLayer = !0, this.Ze(), this.Ke = [];
    }
    Ze() {
        const t = this.options.services.map((t)=>t.url);
        this.Xe = this.Xe || {}, this.Pe = this.Pe || [];
        for(let e = 0; e < t.length; e++){
            const n = t[e];
            let r = this.Xe[n];
            void 0 === r && (r = this.Xe[n] = this.Pe.length), this.Pe[r] = $5671aa7ae64fb35e$var$Js(n, r, this.options.services[e]);
        }
        this.fire("rootready", {
            roots: this.Pe.slice(0)
        });
    }
    showService(t) {
        return this.updateService(t, {
            visible: !0
        }), this;
    }
    hideService(t) {
        return this.updateService(t, {
            visible: !1
        }), this;
    }
    setToRedraw() {
        return this.We(), this;
    }
    addService(t) {
        return this.options.services = this.options.services || [], this.options.services.push(t), this.Ze(), this.We(), this;
    }
    updateService(t, e) {
        if (!e) return this;
        const n = this.options.services;
        let r = !1;
        n && n[t] && (r = !($5671aa7ae64fb35e$var$Ks(n[t].coordOffset, e.coordOffset) && $5671aa7ae64fb35e$var$Ks(n[t].heightOffset, e.heightOffset) && $5671aa7ae64fb35e$var$Ks(n[t].scale, e.scale) && $5671aa7ae64fb35e$var$Ks(n[t].rotation, e.rotation)), $5671aa7ae64fb35e$var$pt(n[t], e));
        const s = n[t].url, i = this.Xe[s], o = this.Pe && this.Pe[i];
        return o && ($5671aa7ae64fb35e$var$mt(e.visible) || (o.visible = e.visible), r && o.version++), this.We(), this;
    }
    removeService(t) {
        const e = this.options.services;
        if (e && e[t]) {
            const n = e[t].url, r = this.Xe[n];
            this.Pe[r] && (this.Pe[r] = null), delete this.Xe[n], e.splice(t, 1);
        }
        return this.We(), this;
    }
    getTileUrl(t, e) {
        const n = e && e.service && e.service.subdomains;
        if (n && e.domainKey) {
            const r = n.length;
            if (r) {
                const s = [
                    ...t
                ].reduce((t, e)=>t + e.charCodeAt(0), 0) % r;
                return t.replace(e.domainKey, n[s]);
            }
        }
        return t;
    }
    getExtent(e) {
        if (!e && 0 !== e) {
            const e = new $gP1US.Extent;
            for(let t = 0; t < this.Pe.length; t++){
                const n = this.Pe[t];
                if (n && n.boundingVolume) {
                    const t = this.boundingVolumeToExtent(n);
                    e._combine(t);
                }
            }
            return e;
        }
        const n = this.Pe[e];
        return n && n.boundingVolume ? this.boundingVolumeToExtent(n) : null;
    }
    boundingVolumeToExtent(e) {
        const n = e.boundingVolume.Qe ? $5671aa7ae64fb35e$var$Us : e.matrix, r = this.getMap(), s = "identity" === r.getProjection().code.toLowerCase(), i = this.getRenderer();
        if (e.boundingVolume.region) {
            const n = e.boundingVolume.region;
            return new $gP1US.Extent($5671aa7ae64fb35e$var$vt(n[0]), $5671aa7ae64fb35e$var$vt(n[1]), $5671aa7ae64fb35e$var$vt(n[2]), $5671aa7ae64fb35e$var$vt(n[3]));
        }
        if (e.boundingVolume.sphere) {
            const o = e.boundingVolume.sphere, c = $5671aa7ae64fb35e$var$ue([], (0, $eIStk).transformMat4([
                0,
                0,
                0
            ], o, n));
            s && i.Ve(c, c);
            const l = o[3], h = r.locate(c, -l, l), u = r.locate(c, l, -l);
            return new $gP1US.Extent(h, u);
        }
        if (e.boundingVolume.box) {
            const o = e.boundingVolume.box, l = (0, $eIStk).transformMat4([
                0,
                0,
                0
            ], o, n), h = new $gP1US.Coordinate($5671aa7ae64fb35e$var$ue([], l));
            s && i.Ve(h, h);
            const u = o.slice(3);
            (0, $bDSmI).multiply(u, (0, $bDSmI).fromMat4([
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ], e.matrix), u);
            const f = (0, $eIStk).length(u.slice(0, 3)), d = (0, $eIStk).length(u.slice(3, 6)), m = (0, $eIStk).length(u.slice(6, 9)), p = Math.max(f, d, m), b = r.locate(h, -p, p), y = r.locate(h, p, -p);
            return new $gP1US.Extent(b, y);
        }
        return null;
    }
    getRootTiles() {
        return this.Pe;
    }
    getTiles() {
        const t = this.getRenderer();
        if (!t.ready) return this.We(), {
            tiles: $5671aa7ae64fb35e$var$Ss
        };
        const e = this.getMap(), n = e.cameraPosition, r = e.pointAtResToDistance(n[2], 0, e.getGLRes()), s = this.tn(n);
        this.nn = this.nn || [
            0,
            0,
            0
        ], (0, $eIStk).set(this.nn, $5671aa7ae64fb35e$var$wt(s.x), $5671aa7ae64fb35e$var$wt(s.y), r), this.rn = $5671aa7ae64fb35e$var$ie(this.rn || [], this.nn[0], this.nn[1], this.nn[2]), this.sn = 2 * Math.tan(.5 * $5671aa7ae64fb35e$var$wt(e.getFov()));
        const i = e.projViewMatrix;
        let o;
        if (e.getPitch() <= 80) {
            const t = e.getExtent(), n = t.getWidth() / 2, r = t.getHeight() / 2;
            t.xmin -= n, t.ymin -= r, t.xmax += n, t.ymax += r, o = $5671aa7ae64fb35e$var$ps(t);
        }
        const c = (this.getMasks() || []).filter((t)=>t && t instanceof (0, $9e7Ip.ClipOutsideMask));
        c.forEach((t)=>{
            if (!t.maskGeoJSON && t.toGeoJSON) try {
                t.maskGeoJSON = t.toGeoJSON();
                const e = t.getExtent();
                t.maskGeoJSON.bbox = $5671aa7ae64fb35e$var$ps(e);
            } catch (t) {
                console.error(t);
            }
        });
        const l = {
            children: [],
            level: -1
        };
        let h = l;
        const u = [];
        for(let e = 0; e < this.Pe.length; e++){
            const n = this.Pe[e];
            if (!n || !n.visible) continue;
            const r = n.service, s = [
                n
            ], a = this.an(e);
            for(; s.length > 0;){
                const e = s.pop();
                for(e.id || this.cn(e); h.level >= e.ke;)h = h.parent;
                const n = this.ln(e, a, i, o, c);
                if (e.service = r, !(n === $5671aa7ae64fb35e$var$Xs.VISIBLE || n !== $5671aa7ae64fb35e$var$Xs.OUT_OF_FRUSTUM && this.options.alwaysShowTopTiles && $5671aa7ae64fb35e$var$Zs(e))) {
                    let t = h;
                    for(; t && !t.content;)t = t.parent;
                    n === $5671aa7ae64fb35e$var$Xs.SCREEN_ERROR_TOO_SMALL && t && t.content && this.hn(u, t);
                    continue;
                }
                e.ft < 1 / 0 && this.un(e);
                const l = this.Ne(e, h);
                h.children.push(l);
                const f = e.children, d = f && f.length, m = l.content;
                if (m && (!d || n === $5671aa7ae64fb35e$var$Xs.SCREEN_ERROR_TOO_SMALL) && this.hn(u, l), n !== $5671aa7ae64fb35e$var$Xs.SCREEN_ERROR_TOO_SMALL && d) {
                    m && "add" === e.refine && this.hn(u, l), h = l;
                    const n = f[0].parent;
                    let r = !1;
                    for(let i = 0, o = f.length; i < o; i++){
                        if (n) {
                            const e = t.getCachedTile(f[i].id);
                            if (e && e.error && 404 !== e.error.status) continue;
                            r = !0;
                        } else {
                            r = !0, f[i].parent = e, f[i].xt = e.xt, f[i].baseUrl = e.baseUrl;
                            const t = f[i].content && (f[i].content.url || f[i].content.uri);
                            t && ($5671aa7ae64fb35e$var$St(t) || t.indexOf("i3s:") >= 0 ? f[i].baseUrl = e.baseUrl : $5671aa7ae64fb35e$var$Rt(t) ? f[i].content.url = e.baseUrl + t : f[i].baseUrl = t.substring(0, t.lastIndexOf("/") + 1));
                        }
                        s.push(f[i]);
                    }
                    !r && m && this.hn(u, l);
                }
            }
        }
        return {
            root: l,
            tiles: u
        };
    }
    hn(t, e) {
        const { viewerRequestVolume: n, matrix: r } = e.node;
        n && !function(t, e, n, r) {
            if (n.region) {
                const e = n.region;
                if (t[0] >= e[0] && t[0] <= e[2] && t[1] >= e[1] && t[1] <= e[3]) return !0;
            } else {
                if (n.sphere) return $5671aa7ae64fb35e$var$$s(n, e, r) <= 0;
                if (n.box) return 0 === $5671aa7ae64fb35e$var$Vs(n, e, r);
            }
            return !1;
        }(this.nn, this.rn, n, r) || t.push(e);
    }
    Ne(t, e) {
        return {
            id: t.id,
            node: t,
            children: [],
            level: t.ke,
            parent: e,
            content: t.content && t.content.url
        };
    }
    cn(e) {
        const n = this.getId();
        e.id = n + ":" + $gP1US.Util.GUID(), e.matrix = e.transform || (0, $3iqbd).identity([
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]), e.dn = this.mn(e), e.parent && (function(t) {
            return t.content && t.content.uri && t.content.uri.indexOf("i3s:") >= 0;
        }(e) || (e.matrix = (0, $3iqbd).multiply(e.matrix, e.parent.matrix, e.matrix)), e.H = e.parent.H, void 0 === e.ke && (e.ke = e.parent.ke + 1), e.maxExtent = e.parent.maxExtent), e.refine = e.refine && e.refine.toLowerCase() || "replace", e.content && !e.content.url && e.content.uri && (e.content.url = e.content.uri);
    }
    j(t) {
        return this.Pe[t].service;
    }
    pn(t) {
        const e = t.boundingVolume;
        if (!e || e.Qe && !this.bn(t)) return;
        const n = this.j(t.H), s = n.heightOffset || 0, i = this.options.offset, o = $5671aa7ae64fb35e$var$bt(i) || i[0] || i[1], c = n.coordOffset || $5671aa7ae64fb35e$var$Bs;
        if (!Array.isArray(c)) throw new Error("service.coordOffset must be an array");
        if (!e.Qe && (!t.boundingVolume || !s && (0, $3iqbd).exactEquals(t.matrix, $5671aa7ae64fb35e$var$Us) && !o && c === $5671aa7ae64fb35e$var$Bs)) return;
        e.box && e.region && delete e.region;
        const { region: l, box: h, sphere: u } = e;
        if (e.coordOffset = [
            c[0],
            c[1]
        ], e.heightOffset = s, l) {
            e.originalVolume || (e.originalVolume = l.slice(0));
            const t = e.originalVolume, n = this.yn([
                $5671aa7ae64fb35e$var$vt(t[0]),
                $5671aa7ae64fb35e$var$vt(t[1])
            ]);
            l[0] = $5671aa7ae64fb35e$var$wt(n.x + c[0]), l[1] = $5671aa7ae64fb35e$var$wt(n.y + c[1]);
            const r = this.yn([
                $5671aa7ae64fb35e$var$vt(t[2]),
                $5671aa7ae64fb35e$var$vt(t[3])
            ]);
            l[2] = $5671aa7ae64fb35e$var$wt(r.x + c[0]), l[3] = $5671aa7ae64fb35e$var$wt(r.y + c[1]), l[4] = t[4] + s + (c[2] || 0), l[5] = t[5] + s + (c[2] || 0);
        } else if (h || u) {
            e.originalVolume || (e.originalVolume = (h || u).slice(0));
            const n = h || u, r = e.originalVolume, i = (0, $eIStk).transformMat4($5671aa7ae64fb35e$var$gs, r, t.matrix), o = $5671aa7ae64fb35e$var$ue($5671aa7ae64fb35e$var$ws, i), l = this.yn([
                o[0] + c[0],
                o[1] + c[1]
            ]);
            o[0] = l.x, o[1] = l.y, o[2] += s + (c[2] || 0), $5671aa7ae64fb35e$var$ie(n, $5671aa7ae64fb35e$var$wt(o[0]), $5671aa7ae64fb35e$var$wt(o[1]), o[2]);
        }
        e.Qe = !0;
        try {
            t.extent = this.boundingVolumeToExtent(t);
        } catch (t) {
            console.error(t);
        }
    }
    bn(t) {
        const e = t.boundingVolume, n = this.j(t.H), r = n.heightOffset || 0, s = n.coordOffset || $5671aa7ae64fb35e$var$Bs;
        return e.coordOffset[0] !== s[0] || e.coordOffset[1] !== s[1] || e.heightOffset !== r;
    }
    mn(t) {
        return void 0 === t.geometricError || !t.boundingVolume;
    }
    un(t) {
        let e = t.parent;
        for(; e && e.dn && !(e.ft <= t.ft);)e.ft = t.ft, e = t.parent;
    }
    onTileLoad(t, e) {
        if (t.children && (!e.children || !e.children.length)) {
            e.children = t.children;
            const n = e.content.url;
            e.baseUrl = n.substring(0, n.lastIndexOf("/") + 1), this.We();
        }
    }
    onTilesetLoad(t, e, n) {
        if (!t) return void console.warn("invalid tileset at : " + n);
        const s = (t.asset && t.asset.gltfUpAxis || e && e.xt || "Y").toUpperCase();
        t.root.baseUrl = n.substring(0, n.lastIndexOf("/") + 1);
        const i = n.indexOf("realspace/") > -1;
        0 === e.ke && t.asset && t.asset.s3mType && i && (t.root.baseUrl += "data/path/");
        const o = t.asset.i3s;
        if (t.root.xt = s, e) {
            const n = e.boundingVolume, s = e.gn;
            s && delete e.gn, $5671aa7ae64fb35e$var$pt(e, t.root), e.refine = e.refine && e.refine.toLowerCase() || "replace", n && (e.boundingVolume = n);
            let i = t.root.transform;
            if (s) {
                const t = this.j(e.H);
                t.ecefTransform && (i = (0, $3iqbd).multiply([
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ], t.ecefTransform, i || $5671aa7ae64fb35e$var$Us));
            }
            i && (e.parent ? o || (e.matrix = (0, $3iqbd).multiply([
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ], e.parent.matrix, i)) : e.matrix = (0, $3iqbd).multiply([
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ], e.matrix, i)), delete e.content, t.root.content && (e.content = t.root.content), e.dn = this.mn(e);
            const a = e.content && (e.content.url || e.content.uri);
            a && e.content.uri && (e.content.url = e.content.uri, delete e.content.uri), !o && a && !$5671aa7ae64fb35e$var$St(a) && $5671aa7ae64fb35e$var$Rt(a) && (e.content.url = e.baseUrl + a), t.root && !e.parent && this.wn(e);
        }
        this.We(), this.fire("loadtileset", {
            tileset: t,
            index: e && e.H,
            url: n
        });
    }
    vn(t, e, n) {
        if (!t.extent || !$5671aa7ae64fb35e$var$bs) return !0;
        const r = t.extent;
        if ($5671aa7ae64fb35e$var$zs[0] = r.xmin, $5671aa7ae64fb35e$var$zs[1] = r.ymin, $5671aa7ae64fb35e$var$zs[2] = r.xmax, $5671aa7ae64fb35e$var$zs[3] = r.ymax, e) {
            if (!$5671aa7ae64fb35e$var$bs.bboxIntersect($5671aa7ae64fb35e$var$zs, e)) return !1;
        }
        if (n.length) {
            for(let t = 0, e = n.length; t < e; t++){
                const e = n[t].maskGeoJSON;
                if (!e || !e.bbox || $5671aa7ae64fb35e$var$bs.bboxInMask($5671aa7ae64fb35e$var$zs, e)) return !0;
            }
            return !1;
        }
        return !0;
    }
    ln(t, e, n, r, s) {
        if (!this.vn(t, r, s)) return $5671aa7ae64fb35e$var$Xs.OUT_OF_FRUSTUM;
        if (t.ft = 1 / 0, 0 === t.ke || t.dn) return this.wn(t), $5671aa7ae64fb35e$var$Xs.VISIBLE;
        if (this.pn(t), !this.Tn(t, e, n)) return $5671aa7ae64fb35e$var$Xs.OUT_OF_FRUSTUM;
        if (0 === t.geometricError) return $5671aa7ae64fb35e$var$Xs.VISIBLE;
        let i = this.j(t.H).maximumScreenSpaceError;
        null == i && (i = 16);
        let o = this._n(t);
        return 0 === o && t.parent && (o = .5 * (t.parent.Mn || 0)), o >= i ? $5671aa7ae64fb35e$var$Xs.VISIBLE : $5671aa7ae64fb35e$var$Xs.SCREEN_ERROR_TOO_SMALL;
    }
    Kt(e, n) {
        n || (n = new $gP1US.Point(0, 0));
        const r = this.getMap();
        return r.coordToPointAtRes(e, r.getGLRes(), n);
    }
    Tn(t, e, n) {
        const r = t.id;
        let s = this.Ke[r];
        const { boundingVolume: i } = t, o = i.region, a = i.box, c = i.sphere, l = this.On(t.H), h = this.getRenderer();
        s && s.version === l.version || (o ? s = this.Ke[r] = this.An(t) : a ? s = this.Ke[r] = this.xn(t) : c && (s = this.Ke[r] = this.In(t)), s.version = l.version, t.dt && (h.Ft(t.dt), delete t.dt));
        return this.j(t.H).debug && (this.Ke[r].node = t, h.Gt(t)), s.obbox ? (0, $9b5be2c4f6c5fa19$export$b727a1c83049f29)(n, s.obbox) : !!c && (0, $9b5be2c4f6c5fa19$export$aae45361196531d9)(n, s.sphereBox);
    }
    An(e) {
        const n = this.getMap(), s = n.getGLRes(), i = e.boundingVolume.region;
        let { ws: o, en: c } = function(t) {
            const e = t[0], n = t[1], r = t[2], s = t[3], i = t[4], o = t[5], a = $5671aa7ae64fb35e$var$ie([], e, n, i), c = $5671aa7ae64fb35e$var$ie([], r, s, o), l = $5671aa7ae64fb35e$var$ue(a, a), h = $5671aa7ae64fb35e$var$ue(c, c);
            return {
                ws: l,
                en: h
            };
        }(i);
        o = new $gP1US.Coordinate(o), c = new $gP1US.Coordinate(c);
        const l = n.coordToPointAtRes(o, s);
        l.z = n.altitudeToPoint(o.z, s);
        const h = n.coordToPointAtRes(c, s);
        h.z = n.altitudeToPoint(c.z, s);
        const u = [
            h.x,
            l.y,
            h.z,
            h.x,
            h.y,
            h.z,
            l.x,
            h.y,
            h.z,
            l.x,
            l.y,
            h.z,
            h.x,
            l.y,
            l.z,
            h.x,
            h.y,
            l.z,
            l.x,
            h.y,
            l.z,
            l.x,
            l.y,
            l.z
        ], f = [
            (u[0] + u[18]) / 2,
            (u[1] + u[19]) / 2,
            (u[2] + u[20]) / 2
        ], d = this.On(e.H);
        e !== d || d.Sn || (d.Sn = f);
        const m = this.Jt([], e), p = (0, $3iqbd).exactEquals($5671aa7ae64fb35e$var$Us, m);
        if (!p) {
            (0, $eIStk).transformMat4(f, f, m);
            const t = $5671aa7ae64fb35e$var$gs;
            for(let e = 0; e < u.length; e += 3){
                let n = (0, $eIStk).set(t, u[e], u[e + 1], u[e + 2]);
                p || (n = (0, $eIStk).transformMat4(n, n, m)), u[e] = n[0], u[e + 1] = n[1], u[e + 2] = n[2];
            }
        }
        const b = n.pointAtResToCoord(new $gP1US.Point(f), s);
        b.z = (o.z + c.z) / 2;
        const y = this.Cn(u, f);
        for(let t = 0; t < u.length; t++)u[t] -= f[t % 3];
        return {
            obbox: y,
            boxPosition: u,
            boxCenter: f,
            boxCoord: b
        };
    }
    xn(t) {
        const e = this.getRenderer(), n = this.getMap(), s = "identity" === n.getProjection().code.toLowerCase(), i = n.getGLRes(), { boxCenter: o, boxCoord: c } = this.kn(t), l = t.boundingVolume.box, h = this.Nn(l, t.matrix), u = (d = l, function(t, e, n, r, s, i, o, a, c, l, h, u, f, d, m, p, b) {
            return t[0] = e || 0, t[1] = i || 0, t[2] = l || 0, t[3] = 0, t[4] = n || 0, t[5] = o || 0, t[6] = h || 0, t[7] = 0, t[8] = r || 0, t[9] = a || 0, t[10] = u || 0, t[11] = 0, t[12] = s || 0, t[13] = c || 0, t[14] = f || 0, t[15] = b, t;
        }([], (f = h)[0], f[3], f[6], d[0], f[1], f[4], f[7], d[1], f[2], f[5], f[8], d[2], 0, 0, 0, 1));
        var f, d;
        const m = this.Jt([], t), p = (0, $3iqbd).exactEquals($5671aa7ae64fb35e$var$Us, m);
        p || (0, $eIStk).transformMat4(o, o, m);
        const b = [], y = $5671aa7ae64fb35e$var$gs;
        for(let t = 0; t < $5671aa7ae64fb35e$var$Hs.length; t += 3){
            y[0] = $5671aa7ae64fb35e$var$Hs[t], y[1] = $5671aa7ae64fb35e$var$Hs[t + 1], y[2] = $5671aa7ae64fb35e$var$Hs[t + 2], (0, $eIStk).transformMat4(y, y, u), $5671aa7ae64fb35e$var$ue(y, y), s && e.Ve(y, y);
            const r = $5671aa7ae64fb35e$var$Cs.set(y[0], y[1], y[2]);
            n.coordToPointAtRes(r, i, $5671aa7ae64fb35e$var$ks);
            let o = (0, $eIStk).set(y, $5671aa7ae64fb35e$var$ks.x, $5671aa7ae64fb35e$var$ks.y, n.altitudeToPoint(r.z, i));
            p || (o = (0, $eIStk).transformMat4(o, o, m)), b[t] = o[0], b[t + 1] = o[1], b[t + 2] = o[2];
        }
        const g = this.Cn(b, o);
        for(let t = 0; t < b.length; t++)b[t] -= o[t % 3];
        return {
            obbox: g,
            boxPosition: b,
            boxCenter: o,
            boxCoord: c
        };
    }
    In(e) {
        const n = this.getMap(), r = this.getRenderer(), s = "identity" === n.getProjection().code.toLowerCase(), i = e.boundingVolume.sphere, o = i;
        let a = $5671aa7ae64fb35e$var$gs;
        0 === o[0] && 0 === o[1] && 0 === o[2] ? a = [
            0,
            0,
            -6378137
        ] : $5671aa7ae64fb35e$var$ue(a, o), s && r.Ve(a, a);
        const c = new $gP1US.Coordinate(a), l = this.Kt(c, $5671aa7ae64fb35e$var$ks).toArray();
        l[2] = n.altitudeToPoint(c.z, n.getGLRes());
        const h = this.Ln(c);
        return {
            boxCenter: l,
            boxCoord: c,
            sphereBox: [
                l,
                i[3] * h[2]
            ]
        };
    }
    Cn(t, e) {
        const n = $5671aa7ae64fb35e$var$Ys($5671aa7ae64fb35e$var$_s, t, 0, 1, 4, 5), r = $5671aa7ae64fb35e$var$Ys($5671aa7ae64fb35e$var$Ms, t, 0, 3, 4, 7), s = $5671aa7ae64fb35e$var$Ys($5671aa7ae64fb35e$var$Os, t, 0, 1, 2, 3);
        return [
            ...e,
            ...(0, $eIStk).sub($5671aa7ae64fb35e$var$gs, n, e),
            ...(0, $eIStk).sub($5671aa7ae64fb35e$var$ws, r, e),
            ...(0, $eIStk).sub($5671aa7ae64fb35e$var$vs, s, e)
        ];
    }
    kn(e) {
        const n = this.getMap(), r = this.getRenderer(), s = "identity" === n.getProjection().code.toLowerCase(), i = n.getGLRes(), o = e.boundingVolume.box.slice(0, 3);
        $5671aa7ae64fb35e$var$ue(o, o), s && r.Ve(o, o);
        const a = new $gP1US.Coordinate(o), c = n.coordToPointAtRes(a, i);
        return {
            boxCenter: [
                c.x,
                c.y,
                n.altitudeToPoint(a.z, i)
            ],
            boxCoord: a
        };
    }
    Jt(t, e) {
        const n = this.On(e.H), s = this.j(e.H), i = n.Sn, c = (0, $3iqbd).fromTranslation($5671aa7ae64fb35e$var$Ls, (0, $eIStk).set($5671aa7ae64fb35e$var$gs, -i[0], -i[1], -i[2])), l = (0, $3iqbd).fromTranslation($5671aa7ae64fb35e$var$Es, i), h = s.rotation || $5671aa7ae64fb35e$var$Gs, u = (0, $k1dpP).fromEuler($5671aa7ae64fb35e$var$Is, ...h), f = s.scale;
        let d;
        d = Array.isArray(f) ? (0, $eIStk).set($5671aa7ae64fb35e$var$Fs, f[0], f[1], f[2]) : f && (0, $eIStk).set($5671aa7ae64fb35e$var$Fs, f, f, f) || $5671aa7ae64fb35e$var$Ds;
        const m = (0, $3iqbd).fromRotationTranslationScale($5671aa7ae64fb35e$var$Rs, u, $5671aa7ae64fb35e$var$js, d);
        return t = (0, $3iqbd).multiply(t, m, c), (0, $3iqbd).multiply(t, l, t);
    }
    wn(t) {
        const e = this.j(t.H);
        if (!t.boundingVolume || this.En(t, e)) return;
        const n = t.boundingVolume.box, r = t.boundingVolume.region, s = t.boundingVolume.sphere;
        let i = null;
        n ? i = this.Rn(t).boxCenter : r ? i = this.Pn(t).boxCenter : s && (i = this.In(t).boxCenter);
        const o = e.heightOffset || 0, a = e.coordOffset || [
            0,
            0
        ];
        t.Un = [
            a[0] || 0,
            a[1] || 0
        ], t.Bn = o, t.Sn = i;
    }
    En(t, e) {
        if (!t.Un) return !1;
        const n = e.coordOffset || $5671aa7ae64fb35e$var$Bs;
        return t.Un[0] === n[0] && t.Un[1] === n[1] && t.Bn === (e.heightOffset || 0);
    }
    Pn(t) {
        return this.pn(t), this.An(t);
    }
    Rn(t) {
        return this.pn(t), this.kn(t);
    }
    Nn(t, e) {
        let n = t.slice(3, 12);
        const r = (0, $bDSmI).fromMat4($5671aa7ae64fb35e$var$Ns, e);
        return n = (0, $bDSmI).multiply(n, r, n), n;
    }
    Ln(t) {
        const e = this.getMap(), n = e.distanceToPointAtRes(100, 100, e.getGLRes(), t);
        let r;
        return r = e.altitudeToPoint ? e.altitudeToPoint(100, e.getGLRes()) / 100 : n.y / 100, (0, $eIStk).set($5671aa7ae64fb35e$var$As, n.x / 100 * 1.01, n.y / 100 * 1.01, r), $5671aa7ae64fb35e$var$As;
    }
    yn(e) {
        Array.isArray(e) && (e = new $gP1US.Coordinate(e));
        let n = this.options.offset;
        if ($5671aa7ae64fb35e$var$bt(n) && (n = n.call(this, Array.isArray(e) ? new $gP1US.Coordinate(e) : e)), n[0] || n[1]) {
            const t = this.getMap(), r = t.getGLRes(), s = t.coordToPointAtRes(e, r);
            return $5671aa7ae64fb35e$var$ks.set(n[0], n[1]), s._sub($5671aa7ae64fb35e$var$ks), t.pointAtResToCoord(s, r);
        }
        return e;
    }
    On(t) {
        return this.Pe[t];
    }
    an(e) {
        const n = this.j(e).maxExtent;
        if (!n) return null;
        const r = this.Pe[e];
        return r.maxExtent || (r.maxExtent = new $gP1US.Extent(n).convertTo((t)=>this.Kt(t))), r.maxExtent;
    }
    _n(t) {
        const e = this.sn, n = t.geometricError;
        if (0 === n) return t.Mn = 0, 0;
        const s = this.j(t.H);
        let i = s.scale || 1;
        if (Array.isArray(i) && (i = (0, $eIStk).length(i)), s.ecefTransform) {
            const t = (0, $3iqbd).getScaling($5671aa7ae64fb35e$var$xs, s.ecefTransform);
            i *= (0, $eIStk).len(t);
        }
        const o = this.getMap();
        let c;
        t.boundingVolume.region ? c = function(t, e, n) {
            t.Gn || (t.Gn = new $5671aa7ae64fb35e$var$ds(t.boundingVolume.region));
            return t.Gn.distanceToCamera(e, n);
        }(t, this.rn, this.nn) : t.boundingVolume.sphere ? c = $5671aa7ae64fb35e$var$$s(t.boundingVolume, this.rn) : t.boundingVolume.box && (c = $5671aa7ae64fb35e$var$Vs(t.boundingVolume, this.rn));
        const l = Math.max(Math.abs(c), 1e-7), h = n * i * o.height / (l * e);
        return t.ft = c, t.Mn = h, h;
    }
    We() {
        const t = this.getRenderer();
        t && t.setToRedraw();
    }
    Dt(t) {
        return this.Ke[t];
    }
    identify(e, n = {}) {
        const r = this.getMap(), s = this.getRenderer();
        if (!r || !s) return [];
        Array.isArray(e) && (e = new $gP1US.Coordinate(e));
        const i = r.coordToContainerPoint(e);
        return this.identifyAtPoint(i, n);
    }
    identifyAtPoint(t, e = {}) {
        const n = [];
        if (!e.excludeMasks) {
            const r = this.identifyMask(t, e);
            r && r.length && $5671aa7ae64fb35e$var$kt(n, r);
        }
        const r = this.getMap(), s = this.getRenderer();
        if (!r || !s) return [];
        const i = r.getDevicePixelRatio();
        return $5671aa7ae64fb35e$var$kt(n, s.pick(t.x * i, t.y * i, e)), e && e.filter && !e.excludeMasks ? n.filter((t)=>e.filter(t)) : n;
    }
    getCurrentBatchIDs() {
        const t = this.getMap(), e = this.getRenderer();
        return t && e ? e.Wt() : [];
    }
    highlight(t) {
        const e = this.getRenderer();
        return Array.isArray(t) || (t = [
            t
        ]), e ? (e.highlight(t), this) : (this.J || (this.J = []), this.J.push(t), this);
    }
    ze() {
        if (this.J) {
            for(let t = 0; t < this.J.length; t++)this.highlight(this.J[t]);
            delete this.J;
        }
    }
    cancelHighlight(t, e) {
        const n = this.getRenderer();
        return n ? (n.cancelHighlight(t, e), this) : this;
    }
    cancelAllHighlight() {
        const t = this.getRenderer();
        return t ? (t.cancelAllHighlight(), this) : this;
    }
    showOnly(t) {
        const e = this.getRenderer();
        return e ? (e.showOnly(t), this) : (this.Z || (this.Z = []), this.Z.push(t), this);
    }
    Dn() {
        if (this.Z) {
            for(let t = 0; t < this.Z.length; t++)this.showOnly(this.Z[t]);
            delete this.Z;
        }
    }
    cancelShowOnly(t) {
        const e = this.getRenderer();
        return e ? (e.cancelShowOnly(t), this) : this;
    }
    setServiceOpacity(t, e) {
        const n = this.options.services[t];
        n && (n.opacity = e);
        return this.getRenderer() ? (this.We(), this) : this;
    }
    setServiceDebug(t, e) {
        const n = this.options.services[t];
        n && (n.debug = e);
        return this.getRenderer() ? (this.We(), this) : this;
    }
    tn(t) {
        const e = this.getMap(), n = e.getGLRes();
        $5671aa7ae64fb35e$var$Ps.set(t[0], t[1]);
        const r = e.pointAtResToCoord($5671aa7ae64fb35e$var$Ps, n);
        return "identity" === e.getProjection().code.toLowerCase() ? ($5671aa7ae64fb35e$var$ws[0] = r.x, $5671aa7ae64fb35e$var$ws[1] = r.y, this.getRenderer().Je($5671aa7ae64fb35e$var$gs, $5671aa7ae64fb35e$var$ws), r.set($5671aa7ae64fb35e$var$gs[0], $5671aa7ae64fb35e$var$gs[1]), r) : r;
    }
    toJSON() {
        return {
            "type": this.getJSONType(),
            "id": this.getId(),
            "options": this.config()
        };
    }
}
function $5671aa7ae64fb35e$var$$s(t, e, n) {
    let r = t.sphere;
    n && (r = (0, $eIStk).transformMat4([
        0,
        0,
        0
    ], r, n));
    const s = (0, $eIStk).dist(r, e), i = t.sphere[3];
    return s < i ? 0 : s - i;
}
function $5671aa7ae64fb35e$var$Vs(t, e, n) {
    const r = t.box;
    let s = (0, $eIStk).set($5671aa7ae64fb35e$var$gs, r[0], r[1], r[2]);
    n && (s = (0, $eIStk).transformMat4([
        0,
        0,
        0
    ], s, n));
    return $5671aa7ae64fb35e$var$qr(s, (0, $bDSmI).set($5671aa7ae64fb35e$var$Ns, r[3], r[4], r[5], r[6], r[7], r[8], r[9], r[10], r[11]), e);
}
function $5671aa7ae64fb35e$var$Js(t, e, n) {
    const s = (t = $5671aa7ae64fb35e$var$Tt(t)).indexOf("{s}") >= 0 ? "{s}" : t.indexOf("%7Bs%7D") >= 0 ? "%7Bs%7D" : null;
    return {
        version: 0,
        dn: !0,
        service: n,
        visible: !!$5671aa7ae64fb35e$var$mt(n.visible) || n.visible,
        baseUrl: t.substring(0, t.lastIndexOf("/")) + "/",
        content: {
            url: t
        },
        refine: "replace",
        matrix: (0, $3iqbd).identity([
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        H: e,
        ke: 0,
        gn: !0,
        domainKey: s
    };
}
function $5671aa7ae64fb35e$var$Ys(t, e, n, r, s, i) {
    const o = (0, $eIStk).set($5671aa7ae64fb35e$var$gs, e[3 * n], e[3 * n + 1], e[3 * n + 2]), c = (0, $eIStk).set($5671aa7ae64fb35e$var$ws, e[3 * r], e[3 * r + 1], e[3 * r + 2]), l = (0, $eIStk).set($5671aa7ae64fb35e$var$vs, e[3 * s], e[3 * s + 1], e[3 * s + 2]), h = (0, $eIStk).set($5671aa7ae64fb35e$var$Ts, e[3 * i], e[3 * i + 1], e[3 * i + 2]);
    return t[0] = (o[0] + c[0] + l[0] + h[0]) / 4, t[1] = (o[1] + c[1] + l[1] + h[1]) / 4, t[2] = (o[2] + c[2] + l[2] + h[2]) / 4, t;
}
function $5671aa7ae64fb35e$var$Zs(t) {
    if (!t.content || t.hasParentContent) return !1;
    let e = t.parent;
    if (e && (e.content || e.hasParentContent)) return t.hasParentContent || (t.hasParentContent = !0), !1;
    for(; e;){
        if (e.content || e.hasParentContent) return t.hasParentContent || (t.hasParentContent = !0), !1;
        e = e.parent;
    }
    return !0;
}
function $5671aa7ae64fb35e$var$Ks(t, e) {
    return Array.isArray(t) && Array.isArray(e) ? 2 === t.length ? (0, $6BoVD).exactEquals(t, e) : (0, $eIStk).exactEquals(t, e) : t === e;
}
var $5671aa7ae64fb35e$var$Xs;
$5671aa7ae64fb35e$export$6e071cc129defa7d.mergeOptions($5671aa7ae64fb35e$var$ys), $5671aa7ae64fb35e$export$6e071cc129defa7d.registerRenderer("gl", $5671aa7ae64fb35e$var$jr), $5671aa7ae64fb35e$export$6e071cc129defa7d.registerJSONType("Geo3DTilesLayer"), function(t) {
    t[t.OUT_OF_FRUSTUM = 0] = "OUT_OF_FRUSTUM", t[t.SCREEN_ERROR_TOO_SMALL = 1] = "SCREEN_ERROR_TOO_SMALL", t[t.VISIBLE = 2] = "VISIBLE";
}($5671aa7ae64fb35e$var$Xs || ($5671aa7ae64fb35e$var$Xs = {}));
let $5671aa7ae64fb35e$var$Ws = null;
function $5671aa7ae64fb35e$var$Qs() {
    return $5671aa7ae64fb35e$var$Ws || ($5671aa7ae64fb35e$var$Ws = {
        "image/crn": $5671aa7ae64fb35e$var$Gt.crn && $5671aa7ae64fb35e$var$Gt.crn(),
        "image/ktx2": $5671aa7ae64fb35e$var$Gt.ktx2 && $5671aa7ae64fb35e$var$Gt.ktx2(),
        "image/cttf": $5671aa7ae64fb35e$var$Gt.ktx2 && $5671aa7ae64fb35e$var$Gt.ktx2(),
        "draco": $5671aa7ae64fb35e$var$Gt.draco && $5671aa7ae64fb35e$var$Gt.draco()
    }), $5671aa7ae64fb35e$var$Ws;
}
const { Ajax: $5671aa7ae64fb35e$var$ti, GLTFLoader: $5671aa7ae64fb35e$var$ei } = $5671aa7ae64fb35e$var$Dt();
class $5671aa7ae64fb35e$export$567a81515c8bfb31 {
    constructor(t, e, n){
        this.Fn = t, this.jn = e || $5671aa7ae64fb35e$var$ei, this.Re = n, this.zn = $5671aa7ae64fb35e$var$Qs();
    }
    static createEmptyB3DM() {
        return {
            featureTable: null,
            batchTable: null,
            gltf: {}
        };
    }
    load(t, e, n = 0, r = 0, s) {
        return e ? (r || (r = e.byteLength), this.Hn(t, e, n, r, s)) : $5671aa7ae64fb35e$var$ti.getArrayBuffer(t, {}).then((e)=>{
            const s = e.data;
            return r || (r = s.byteLength), this.Hn(t, s, n, r);
        });
    }
    Hn(t, e, n, r, s) {
        const i = s && s.maxTextureSize, o = this.qn(e, n, r, t);
        if (o.error) return Promise.resolve(o);
        const a = t.substring(0, t.lastIndexOf("/"));
        let c;
        try {
            c = new this.jn(a, o.glb, {
                transferable: !0,
                requestImage: this.Fn,
                decoders: this.zn,
                supportedFormats: this.Re,
                maxTextureSize: i
            });
        } catch (t) {
            return Promise.resolve({
                error: t
            });
        }
        return c.load({
            skipAttributeTransform: !1
        }).then((e)=>{
            e.url = `${t}-${n}-${r}`;
            const s = c.transferables;
            for(let t = 0; t < o.transferables.length; t++)s.indexOf(o.transferables[t]) < 0 && s.push(o.transferables[t]);
            return {
                magic: "b3dm",
                count: o.count,
                transferables: s,
                featureTable: o.featureTable,
                batchTable: o.batchTable,
                batchTableBin: o.batchTableBin,
                gltf: e
            };
        });
    }
    qn(t, e, n, r) {
        const s = new DataView(t, e, n), i = s.getUint32(4, !0);
        if (1 !== i) {
            const t = "Unsupported b3dm version: " + i + ", url:" + r;
            return console.warn(t), {
                error: t
            };
        }
        if (s.getUint32(8, !0) !== s.byteLength) {
            const t = "Length in b3dm header is inconsistent with b3dm's byte length, url: " + r;
            return console.warn(t), {
                error: t
            };
        }
        let o, a = s.getUint32(12, !0), c = s.getUint32(16, !0), l = s.getUint32(20, !0), h = s.getUint32(24, !0), u = 28 + e;
        l >= 570425344 ? (u -= 8, o = a, l = c, h = 0, a = 0, c = 0) : h >= 570425344 && (u -= 4, o = l, l = a, h = c, a = 0, c = 0);
        const f = [
            t
        ];
        let d, m, p;
        if (a > 0 ? (d = $5671aa7ae64fb35e$var$Me(t, u, a), u += a, o = d.BATCH_LENGTH) : d = {
            "BATCH_LENGTH": o
        }, c > 0 && (u += c), l > 0 && (m = $5671aa7ae64fb35e$var$Oe(t, u, l), u += l, h > 0)) {
            const e = $5671aa7ae64fb35e$var$Ae(0, u, h);
            p = t.slice(e.offset, e.offset + e.byteLength), u += h, f.push(p);
        }
        const b = d.BATCH_LENGTH, y = {};
        if (d && d.BATCH_ID) {
            y.BATCH_ID = $5671aa7ae64fb35e$var$Ie(d.BATCH_ID, t, undefined.offset, b);
            const e = y.BATCH_ID.array && y.BATCH_ID.array.buffer;
            e && f.indexOf(e) < 0 && f.push(e);
        }
        return {
            count: o,
            transferables: f,
            featureTable: d,
            batchTable: m,
            batchTableBin: p,
            b3dm: y,
            glb: {
                buffer: t,
                byteOffset: u,
                byteLength: s.byteLength + s.byteOffset - u
            }
        };
    }
    $n() {
        return null;
    }
}
const { Ajax: $5671aa7ae64fb35e$var$ri, GLTFLoader: $5671aa7ae64fb35e$var$si } = $5671aa7ae64fb35e$var$Dt();
class $5671aa7ae64fb35e$var$ii {
    constructor(t, e, n, r){
        this.Fn = t, this.jn = e || $5671aa7ae64fb35e$var$si, this.Re = n, this.zn = $5671aa7ae64fb35e$var$Qs(), this.Vn = r;
    }
    load(t, e, n = 0, r = 0, s) {
        return e ? (r || (r = e.byteLength), this.Hn(t, e, n, r, s)) : $5671aa7ae64fb35e$var$ri.getArrayBuffer(t, {}).then((e)=>{
            const s = e.data;
            return r || (r = s.byteLength), this.Hn(t, s, n, r);
        });
    }
    Hn(t, e, n, r, s) {
        return this.Jn(t, e, n, r, s).then(({ gltf: s, transferables: i })=>{
            const o = this.Yn(e, n, r, t);
            if (o.error) return Promise.resolve(o);
            for(let t = 0; t < i.length; t++)-1 === o.transferables.indexOf(i[t]) && o.transferables.push(i[t]);
            return delete s.transferables, Promise.resolve({
                magic: "i3dm",
                count: o.count,
                transferables: o.transferables,
                featureTable: o.featureTable,
                batchTable: o.batchTable,
                batchTableBin: o.batchTableBin,
                i3dm: o.i3dm,
                gltf: s
            });
        });
    }
    Jn(t, e, n, r, s) {
        const i = s && s.maxTextureSize, o = {
            transferable: !0,
            requestImage: this.Fn,
            decoders: this.zn,
            supportedFormats: this.Re,
            maxTextureSize: i
        }, a = new DataView(e, n, r), c = 32 + a.getUint32(12, !0) + a.getUint32(16, !0) + a.getUint32(20, !0) + a.getUint32(24, !0);
        if (0 === a.getUint32(28, !0)) {
            let r = $5671aa7ae64fb35e$var$Ot(new Uint8Array(e, c + n, a.byteLength - c));
            -1 == r.indexOf("://") && (r = t.substring(0, t.lastIndexOf("/")) + "/" + r);
            return r.indexOf(".glb") > 0 ? $5671aa7ae64fb35e$var$ri.getArrayBuffer(r, {}).then((t)=>this.Zn(r, {
                    buffer: t.data,
                    byteOffset: 0
                }, o)) : $5671aa7ae64fb35e$var$ri.getJSON(r, {}).then((t)=>this.Zn(r, t, o));
        }
        {
            const r = {
                buffer: e,
                byteOffset: c + n,
                byteLength: a.byteLength - c
            };
            return this.Zn(t, r, o);
        }
    }
    Zn(t, e, n) {
        const r = t.substring(0, t.lastIndexOf("/")), s = new this.jn(r, e, n);
        return s.load({
            skipAttributeTransform: !0
        }).then((n)=>{
            let r = 0, i = 0;
            return e.buffer && (r = e.byteOffset || 0, i = e.byteLength || 0), n.url = `${t}-${r}-${i}`, {
                transferables: s.transferables,
                gltf: n
            };
        });
    }
    Yn(t, e, n, r) {
        const s = new DataView(t, e, n), i = s.getUint32(4, !0);
        if (1 !== i) {
            const t = "Unsupported pnts version: " + i + ", url:" + r;
            return console.warn(t), {
                error: t
            };
        }
        if (s.getUint32(8, !0) !== s.byteLength) {
            const t = "Length in pnts header is inconsistent with pnts's byte length, url: " + r;
            return console.warn(t), {
                error: t
            };
        }
        const o = [
            t
        ], { featureTable: a, featureTableBin: c, batchTable: l, batchTableBin: h } = $5671aa7ae64fb35e$var$Pe(s, 32 + e, o), u = {}, f = a.INSTANCES_LENGTH;
        if (a.POSITION) {
            const { byteOffset: e } = a.POSITION;
            u.POSITION = {
                byteStride: 0,
                byteOffset: 0,
                itemSize: 3,
                count: f,
                componentType: 5126,
                array: new Float32Array(t, e + c.offset, 3 * f).slice()
            }, o.push(u.POSITION.array.buffer);
        } else if (a.POSITION_QUANTIZED) {
            const e = a.QUANTIZED_VOLUME_OFFSET, n = a.QUANTIZED_VOLUME_SCALE, { byteOffset: r } = a.POSITION_QUANTIZED;
            u.POSITION = {
                byteStride: 12,
                byteOffset: 0,
                itemSize: 3,
                count: f,
                componentType: 5126,
                array: this.Kn(new Uint16Array(t, r + c.offset, 3 * f), e, n)
            }, o.push(u.POSITION.array.buffer);
        }
        if (a.BATCH_ID) {
            u.BATCH_ID = $5671aa7ae64fb35e$var$Ie(a.BATCH_ID, t, c.offset, f);
            const e = u.BATCH_ID.array && u.BATCH_ID.array.buffer;
            e && o.indexOf(e) < 0 && o.push(e);
        }
        if (a.NORMAL_UP) {
            let { byteOffset: e } = a.NORMAL_UP;
            u.NORMAL_UP = {
                byteStride: 0,
                byteOffset: 0,
                itemSize: 3,
                count: f,
                componentType: 5126,
                array: new Float32Array(t, e + c.offset, 3 * f).slice()
            }, o.push(u.NORMAL_UP.array.buffer), e = a.NORMAL_RIGHT.byteOffset, u.NORMAL_RIGHT = {
                byteStride: 0,
                byteOffset: 0,
                itemSize: 3,
                count: f,
                componentType: 5126,
                array: new Float32Array(t, e + c.offset, 3 * f).slice()
            }, o.push(u.NORMAL_RIGHT.array.buffer);
        } else if (a.NORMAL_UP_OCT32P) {
            let { byteOffset: e } = a.NORMAL_UP_OCT32P;
            u.NORMAL_UP = {
                byteStride: 0,
                byteOffset: 0,
                itemSize: 3,
                count: f,
                componentType: 5126,
                array: this.Xn(new Uint16Array(t, e + c.offset, 2 * f))
            }, o.push(u.NORMAL_UP.array.buffer), e = a.NORMAL_RIGHT_OCT32P.byteOffset, u.NORMAL_RIGHT = {
                byteStride: 0,
                byteOffset: 0,
                itemSize: 3,
                count: f,
                componentType: 5126,
                array: this.Xn(new Uint16Array(t, e + c.offset, 2 * f))
            }, o.push(u.NORMAL_RIGHT.array.buffer);
        }
        if (a.SCALE) {
            const { byteOffset: e } = a.SCALE;
            u.SCALE = {
                byteStride: 0,
                byteOffset: 0,
                itemSize: 1,
                count: f,
                componentType: 5126,
                array: new Float32Array(t, e + c.offset, f).slice()
            }, o.push(u.SCALE.array.buffer);
        } else if (a.SCALE_NON_UNIFORM) {
            const { byteOffset: e } = a.SCALE_NON_UNIFORM;
            u.SCALE_NON_UNIFORM = {
                byteStride: 0,
                byteOffset: 0,
                itemSize: 3,
                count: f,
                componentType: 5126,
                array: new Float32Array(t, e + c.offset, 3 * f).slice()
            }, o.push(u.SCALE_NON_UNIFORM.array.buffer);
        }
        return {
            count: f,
            batchTable: l,
            batchTableBin: h,
            featureTable: a,
            i3dm: u,
            transferables: o
        };
    }
    Xn(t) {
        const e = t.length / 2, n = new Float32Array(3 * e), r = [];
        for(let s = 0; s < e; s++)$5671aa7ae64fb35e$var$oi(r, t[2 * s], t[2 * s + 1], 65535), n[3 * s] = r[0], n[3 * s + 1] = r[1], n[3 * s + 2] = r[2];
        return n;
    }
    Kn(t, e, n) {
        return $5671aa7ae64fb35e$var$Re(new Float32Array(t.length), t, e, n);
    }
    $n() {
        return null;
    }
}
function $5671aa7ae64fb35e$var$oi(t, e, n, r) {
    if (t[0] = $5671aa7ae64fb35e$var$ai(e, r), t[1] = $5671aa7ae64fb35e$var$ai(n, r), t[2] = 1 - (Math.abs(t[0]) + Math.abs(t[1])), t[2] < 0) {
        const e = t[0];
        t[0] = (1 - Math.abs(t[1])) * $5671aa7ae64fb35e$var$ci(e), t[1] = (1 - Math.abs(e)) * $5671aa7ae64fb35e$var$ci(t[1]);
    }
    return (0, $eIStk).normalize(t, t);
}
function $5671aa7ae64fb35e$var$ai(t, e) {
    return function(t, e, n) {
        return t < e ? e : t > n ? n : t;
    }(t, 0, e = function(t, e) {
        if (null != t) return t;
        return e;
    }(e, 255)) / e * 2 - 1;
}
function $5671aa7ae64fb35e$var$ci(t) {
    return t < 0 ? -1 : 1;
}
const { Ajax: $5671aa7ae64fb35e$var$li } = $5671aa7ae64fb35e$var$Dt();
class $5671aa7ae64fb35e$var$hi {
    constructor(){}
    load(t, e, n = 0, r = 0) {
        return e ? (r || (r = e.byteLength), this.Hn(t, e, n, r)) : $5671aa7ae64fb35e$var$li.getArrayBuffer(t, {}).then((e)=>{
            const s = e.data;
            return r || (r = s.byteLength), this.Hn(t, s, n, r);
        });
    }
    Hn(t, e, n, r) {
        return this.Wn(e, n, r, t).then((t)=>t.error ? t : {
                magic: "pnts",
                count: t.count,
                transferables: t.transferables,
                featureTable: t.featureTable,
                batchTable: t.batchTable,
                batchTableBin: t.batchTableBin,
                pnts: t.pnts
            });
    }
    Wn(t, e, n, r) {
        const s = new DataView(t, e, n), i = s.getUint32(4, !0);
        if (1 !== i) {
            const t = "Unsupported pnts version: " + i + ", url:" + r;
            return console.warn(t), {
                error: t
            };
        }
        if (s.getUint32(8, !0) !== s.byteLength) {
            const t = "Length in pnts header is inconsistent with pnts's byte length, url: " + r;
            return console.warn(t), {
                error: t
            };
        }
        const o = [
            t
        ], { featureTable: a, featureTableBin: c, batchTable: l, batchTableBin: h } = $5671aa7ae64fb35e$var$Pe(s, e + 28, o), u = a.QUANTIZED_VOLUME_OFFSET, f = a.QUANTIZED_VOLUME_SCALE, d = a.POINTS_LENGTH;
        let m, p = {};
        if (a.extensions && a.extensions["3DTILES_draco_point_compression"]) {
            p = a.extensions["3DTILES_draco_point_compression"], m = new DataView(t, p.byteOffset + c.offset, p.byteLength);
            const e = {
                attributes: p.properties,
                useUniqueIDs: !1
            };
            return this.Qn || (this.Qn = $5671aa7ae64fb35e$var$Qs().draco), this.Qn(m, e).then((e)=>{
                const n = e.attributes;
                !a.POSITION && !a.POSITION_QUANTIZED || n.POSITION || n.POSITION_QUANTIZED || (n.POSITION = a.POSITION, n.POSITION_QUANTIZED = a.POSITION_QUANTIZED), !(a.RGB || a.RGBA || a.RGB565) || n.RGB || n.RGBA || n.RGB565 || (n.RGB = a.RGB, n.RGBA = a.RGBA, n.RGB565 = a.RGB565), !a.NORMAL && !a.NORMAL_OCT16P || n.NORMAL || n.NORMAL_OCT16P || (n.NORMAL = a.NORMAL, n.NORMAL_OCT16P = a.NORMAL_OCT16P);
                const r = this.tr(t, e.attributes, c.offset, d, o, u, f);
                if (e.attributes.BATCH_ID) {
                    const t = e.attributes.BATCH_ID.array;
                    r.BATCH_ID = {
                        byteStride: 0,
                        byteOffset: 0,
                        itemSize: 1,
                        count: t.length,
                        componentType: $5671aa7ae64fb35e$var$Ee(t.constructor),
                        array: t
                    }, o.push(t.buffer);
                } else if (a.BATCH_ID || Object.keys(l).length) {
                    a.BATCH_ID ? r.BATCH_ID = $5671aa7ae64fb35e$var$Ie(a.BATCH_ID, t, c.offset, d) : r.BATCH_ID = $5671aa7ae64fb35e$var$ui(d);
                    const e = r.BATCH_ID.array && r.BATCH_ID.array.buffer;
                    e && o.indexOf(e) < 0 && o.push(e);
                }
                return {
                    count: d,
                    batchTable: l,
                    batchTableBin: h,
                    featureTable: a,
                    pnts: r,
                    transferables: o
                };
            });
        }
        const b = this.tr(t, a, c.offset, d, o, u, f);
        if (a.BATCH_ID || Object.keys(l).length) {
            a.BATCH_ID ? b.BATCH_ID = $5671aa7ae64fb35e$var$Ie(a.BATCH_ID, t, c.offset, d) : b.BATCH_ID = $5671aa7ae64fb35e$var$ui(d);
            const e = b.BATCH_ID.array && b.BATCH_ID.array.buffer;
            e && o.indexOf(e) < 0 && o.push(e);
        }
        return Promise.resolve({
            count: d,
            batchTable: l,
            batchTableBin: h,
            featureTable: a,
            pnts: b,
            transferables: o
        });
    }
    tr(t, e, n, r, s, i, o) {
        const a = {};
        if (e.POSITION) {
            let { byteOffset: i, array: o } = e.POSITION;
            i = i || 0;
            const c = o ? 0 : n;
            if (!o) {
                const e = t.slice(i + c, i + c + 3 * r * 4);
                o = new Float32Array(e);
            }
            a.POSITION = {
                byteStride: 0,
                byteOffset: 0,
                itemSize: 3,
                count: r,
                componentType: 5126,
                array: o
            }, s.push(o.buffer);
        } else if (e.POSITION_QUANTIZED) {
            let { byteOffset: c } = e.POSITION_QUANTIZED;
            const { array: l } = e.POSITION_QUANTIZED;
            c = c || 0;
            const h = l ? 0 : n;
            a.POSITION = {
                byteStride: 0,
                byteOffset: 0,
                itemSize: 3,
                count: r,
                componentType: 5126,
                array: this.Kn(l || new Uint16Array(t, c + h, 3 * r), i, o)
            }, s.push(a.POSITION.array.buffer);
        }
        if (e.RGBA) {
            let { byteOffset: i, array: o } = e.RGBA;
            i = i || 0;
            const c = o ? 0 : n;
            if (!o) {
                const e = t.slice(i + c, i + c + 4 * r);
                o = new Uint8Array(e);
            }
            a.RGBA = {
                byteStride: 0,
                byteOffset: 0,
                itemSize: 4,
                count: r,
                componentType: 5121,
                array: o
            }, s.push(o.buffer);
        } else if (e.RGB) {
            let { byteOffset: i, array: o } = e.RGB;
            i = i || 0;
            const c = o ? 0 : n;
            if (!o) {
                const e = t.slice(i + c, i + c + 3 * r);
                o = new Uint8Array(e);
            }
            a.RGB = {
                byteStride: 0,
                byteOffset: 0,
                itemSize: 3,
                count: r,
                componentType: 5121,
                array: o
            }, s.push(o.buffer);
        } else if (e.RGB565) {
            let { byteOffset: i, array: o } = e.RGB565;
            i = i || 0;
            const c = o ? 0 : n;
            if (!o) {
                const e = t.slice(i + c, i + c + 2 * r);
                o = new Uint16Array(e);
            }
            a.RGB565 = {
                byteStride: 0,
                byteOffset: 0,
                itemSize: 1,
                count: r,
                componentType: 5123,
                array: o
            }, s.push(o.buffer);
        }
        if (e.NORMAL) {
            let { byteOffset: i, array: o } = e.NORMAL;
            i = i || 0;
            const c = o ? 0 : n;
            if (!o) {
                const e = t.slice(i + c, i + c + 3 * r * 4);
                o = new Float32Array(e);
            }
            a.NORMAL = {
                byteStride: 0,
                byteOffset: 0,
                itemSize: 3,
                count: r,
                componentType: 5126,
                array: o
            }, s.push(o.buffer);
        } else if (e.NORMAL_OCT16P) {
            let { byteOffset: i, array: o } = e.NORMAL_OCT16P;
            i = i || 0;
            const c = o ? 0 : n;
            if (!o) {
                const e = t.slice(i + c, i + c + 2 * r);
                o = new Uint8Array(e);
            }
            a.NORMAL_OCT16P = {
                byteStride: 0,
                byteOffset: 0,
                itemSize: 2,
                count: r,
                componentType: 5121,
                array: o
            }, s.push(o.buffer);
        }
        return a;
    }
    Kn(t, e, n) {
        return $5671aa7ae64fb35e$var$Re(new Float32Array(t.length), t, e, n);
    }
    $n() {
        return null;
    }
}
function $5671aa7ae64fb35e$var$ui(t) {
    const e = $5671aa7ae64fb35e$var$It(t), n = new e(t);
    for(let e = 0; e < t; e++)n[e] = e;
    return {
        byteStride: 0,
        byteOffset: 0,
        itemSize: 1,
        count: t,
        componentType: $5671aa7ae64fb35e$var$Ee(e),
        array: n
    };
}
const { Ajax: $5671aa7ae64fb35e$var$fi, GLTFLoader: $5671aa7ae64fb35e$var$di } = $5671aa7ae64fb35e$var$Dt();
class $5671aa7ae64fb35e$export$711e0dc692c2ab61 {
    constructor(t, e, n, r){
        this.Re = n, this.Fn = t, this.jn = e || $5671aa7ae64fb35e$var$di, this.Vn = r;
    }
    load(t, e, n = 0, r = 0, s) {
        return e ? this.Hn(t, e, n, r, s) : $5671aa7ae64fb35e$var$fi.getArrayBuffer(t, {}).then((e)=>{
            const s = e.data;
            return this.Hn(t, s, n, r);
        });
    }
    Hn(t, e, n, r, s) {
        r || (r = e.byteLength);
        const i = this.er(e, t, n, r), o = [];
        for(let n = 0; n < i.length; n++){
            let r;
            if ("b3dm" === i[n].magic) r = new $5671aa7ae64fb35e$export$567a81515c8bfb31(this.Fn, this.jn, this.Re);
            else if ("i3dm" === i[n].magic) r = new $5671aa7ae64fb35e$var$ii(this.Fn, this.jn, this.Re, this.Vn);
            else if ("pnts" === i[n].magic) r = new $5671aa7ae64fb35e$var$hi;
            else {
                if ("cmpt" !== i[n].magic) {
                    console.warn("Unsupported magic in CMPT tile:", i[n].magic);
                    continue;
                }
                r = new $5671aa7ae64fb35e$export$711e0dc692c2ab61(this.Fn, this.jn, this.Re, this.Vn);
            }
            o.push(r.load(t, e, i[n].offset, i[n].byteLength, s).then((t)=>t));
        }
        return Promise.all(o).then((t)=>({
                magic: "cmpt",
                tiles: t
            }));
    }
    er(t, e, n, r) {
        const s = new DataView(t, n, r), i = s.getUint32(4, !0);
        if (1 !== i) {
            const t = "Unsupported cmpt version: " + i + ", url:" + e;
            return console.warn(t), {
                error: t
            };
        }
        if (16 === s.byteLength) return [];
        const o = [], a = s.getUint32(12, !0);
        let c = 16;
        for(let e = 0; e < a; e++){
            const e = $5671aa7ae64fb35e$var$Te(s, c), r = s.getUint32(c + 8, !0);
            o.push({
                magic: e,
                buffer: t,
                offset: c + n,
                byteLength: r
            }), c += r;
        }
        return o;
    }
}
if ($9e7Ip.transcoders) {
    const n = $gP1US.Map.VERSION;
    if (n.indexOf("1.0.0-beta") >= 0 || n.indexOf("1.0.0-alpha") >= 0) {
        const n = $9e7Ip.transcoders.inject($5671aa7ae64fb35e$var$M);
        $gP1US.registerWorkerAdapter("@maptalks/3dtiles", n);
    } else $gP1US.registerWorkerAdapter("@maptalks/3dtiles", function() {
        return $9e7Ip.transcoders.inject($5671aa7ae64fb35e$var$M);
    });
} else $gP1US.registerWorkerAdapter("@maptalks/3dtiles", $5671aa7ae64fb35e$var$M);
"undefined" != typeof console && console.log("@maptalks/3dtiles v0.105.3");


/*!
 * @maptalks/gltf-layer v0.104.3
 * LICENSE : UNLICENSED
 * (c) 2016-2025 maptalks.org
 */ 
var $gP1US = parcelRequire("gP1US");
parcelRequire("9e7Ip");
var $9I15V = parcelRequire("9I15V");
var $9e7Ip = parcelRequire("9e7Ip");
var $3iqbd = parcelRequire("3iqbd");
var $k1dpP = parcelRequire("k1dpP");
var $2wazW = parcelRequire("2wazW");
var $6BoVD = parcelRequire("6BoVD");
var $eIStk = parcelRequire("eIStk");
var $jxhwV = parcelRequire("jxhwV");



const $f87d9fed9ae75f45$var$M = 'function(e){\n/*!\n     * @maptalks/gl v0.106.3\n     * LICENSE : UNLICENSED\n     * (c) 2016-2025 maptalks.com\n     */\nconst n=function(){if("undefined"!=typeof undefinedThis)return globalThis;if("undefined"!=typeof self)return self;if("undefined"!=typeof window)return window;if("undefined"!=typeof undefined)return global;throw new Error("unable to locate global object")},t=n(),r=t.gl_trans__coders=t.gl_trans__coders||{};r.inject=function(e){const r=e.toString(),o=r.indexOf("{")+1,s=r.substring(0,o),a=t.gl_trans__coders=t.gl_trans__coders||{};let c=`${s}\\n    const _____getGlobal = ${n.toString()};\\n    const g___lobals = _____getGlobal()\\n    const tran_____scoders = g___lobals[\'gl_trans__coders\'] = g___lobals[\'gl_trans__coders\'] || {};`;for(const e in a)"inject"!==e&&"getTranscoder"!==e&&"registerTranscoder"!==e&&(c+=\'tran_____scoders["\'+e+\'"] =\'+a[e].toString()+"\\n;");return c+="\\n("+n().maptalks_gltf_loader_bundle.toString()+")({});\\n",c+="\\n"+r.substring(s.length),c},r.registerTranscoder=function(e,n){r[e]=n},r.getTranscoder=function(e){return r[e]};const o=n().maptalks_gltf_loader,s={"image/crn":r.crn&&r.crn(),"image/ktx2":r.ktx2&&r.ktx2(),"image/cttf":r.ktx2&&r.ktx2(),"draco":r.draco&&r.draco()};let a;const c={};function i(e,n,t){return new o.GLTFLoader(e,n,t).load({skipAttributeTransform:!0})}function f(e,n,t,r){const a=n.lastIndexOf("/"),c=n.slice(0,a);r&&(n=r(n));const f=(...n)=>l.call(this,e,...n);return function(e,n){return o.Ajax.getArrayBuffer(e,n)}(n,t).then((e=>{if(e.message)return e;const a=e.data;return new DataView(a,a.byteOffset,a.byteLength).getUint32(4,!0)>2?function(e,n){return o.Ajax.getJSON(e,n)}(n,t).then((e=>e.message?e:i(c,e,{requestImage:f,decoders:s,transferable:!0,fetchOptions:t,urlModifier:r}))):i(c,{buffer:e.data,byteOffset:0},{requestImage:f,decoders:s,transferable:!0,fetchOptions:t,urlModifier:r})}))}function l(e,n,t,r){e?c[n]?c[n].push(r):(c[n]=[r],self.postMessage({type:"<request>",command:"sendImageData",actorId:e,workerId:a,params:n})):function(e,n){const t=new Image;t.onload=()=>{if(!u)return void n(new Error("There is no canvas to draw image!"));u.width=t.width,u.height=t.height;const e=u.getContext("2d");e.drawImage(t,0,0,t.width,t.height);const r=e.getImageData(0,0,t.width,t.height),o={width:t.width,height:t.height,data:new Uint8Array(r.data)};n(null,o,[o.data.buffer])},t.onerror=function(e){n(e)},t.src=e}(n,r)}const u="undefined"==typeof document?null:document.createElement("canvas");e.loadGLTF=f,e.onmessage=function(e){const n=e.data,t=n.url;if("addLayer"===n.command||"removeLayer"===n.command)a=e.workerId,self.postMessage({type:"<response>",actorId:n.actorId,workerId:a,params:"ok"});else if(t)!function(e){const n=e.data,t=e.callback,r=e.actorId,o=n.url,s=n.fetchOptions||{};s.referrerPolicy=s.referrerPolicy||"origin",s.referrer=n.referrer,f(r,o,s).then((e=>{e.message?self.postMessage({callback:t,error:e}):self.postMessage({callback:t,data:e},e.transferables)})).catch((e=>{self.postMessage({callback:t,error:e})})),c.receive=t}(e);else if(n.imageUrl){const e=c[n.imageUrl];if(delete c[n.imageUrl],e)for(let t=0;t<e.length;t++)e[t](null,n.result)}}}';
function $f87d9fed9ae75f45$var$S(t) {
    return null == t;
}
function $f87d9fed9ae75f45$var$O(t) {
    return !$f87d9fed9ae75f45$var$S(t);
}
function $f87d9fed9ae75f45$var$T(t, s) {
    if (!t || !s) return null;
    let n = s;
    if (Array.isArray(s)) {
        if (!(0, $gP1US.Util).isNumber(s[0])) return null;
        n = new (0, $gP1US.Coordinate)(s);
    }
    const r = t.coordinateToPointAtRes(n, t.getGLRes()), o = t.altitudeToPoint(n.z || 0, t.getGLRes());
    return [
        r.x,
        r.y,
        o
    ];
}
function $f87d9fed9ae75f45$var$A(t, e) {
    return Math.abs(t) * Math.sign(e);
}
function $f87d9fed9ae75f45$var$k(t, i, n) {
    const r = (0, $gP1US.measurer).Measurer.getInstance().measureLenBetween(t, i), o = n.gapLength + n.bboxWidth;
    let h = n.count;
    h && n.snapToEndVertexes && (h -= 1);
    const a = h > 0 ? r / h : o, c = Math.floor(r / a), l = [], u = n.map, f = n.rotateAlongLine + function(t, i, s) {
        const n = s.getGLRes(), r = s.coordinateToPointAtRes(t, n), o = s.coordinateToPointAtRes(i, n);
        return (0, $gP1US.Util).computeDegree(o.x, o.y, r.x, r.y) / Math.PI * 180;
    }(t, i, u);
    if (c >= 1) {
        const e = 0, s = c;
        if (n.snapToEndVertexes) for(let n = e; n <= s; n++){
            const e = {
                coordinates: $f87d9fed9ae75f45$var$P(t, i, a * n / r),
                scale: [
                    1,
                    1,
                    1
                ],
                rotation: [
                    0,
                    0,
                    f
                ]
            };
            l.push(e);
        }
        else for(let n = e + 1; n <= s; n++){
            const e = {
                coordinates: $f87d9fed9ae75f45$var$P(t, i, a * (n - .5) / r),
                scale: [
                    1,
                    1,
                    1
                ],
                rotation: [
                    0,
                    0,
                    f
                ]
            };
            l.push(e);
        }
        if (n.scaleEndModel) {
            const e = (r - a * c) / a, s = {
                coordinates: $f87d9fed9ae75f45$var$P(t, i, (a * c + (r - a * c) / 2) / r),
                scale: [
                    e,
                    1,
                    1
                ],
                rotation: [
                    0,
                    0,
                    f
                ]
            };
            l.push(s);
        }
    } else if (n.scaleEndModel) {
        const e = r / a, s = {
            coordinates: $f87d9fed9ae75f45$var$P(t, i, .5),
            scale: [
                e,
                1,
                1
            ],
            rotation: [
                0,
                0,
                f
            ]
        };
        l.push(s);
    }
    return l;
}
function $f87d9fed9ae75f45$var$P(t, e, s) {
    const n = $f87d9fed9ae75f45$var$C(t.x, e.x, s), r = $f87d9fed9ae75f45$var$C(t.y, e.y, s);
    return new (0, $gP1US.Coordinate)(n, r);
}
function $f87d9fed9ae75f45$var$C(t, e, i) {
    return t + i * (e - t);
}
const $f87d9fed9ae75f45$var$L = {};
const $f87d9fed9ae75f45$var$I = "undefined" == typeof document ? null : document.createElement("canvas");
class $f87d9fed9ae75f45$var$F extends $gP1US.worker.Actor {
    constructor(t, e){
        super(t), this.mapId = e.getMap().id, this.i = e;
    }
    loadGLTF(t) {
        const e = function(t) {
            let e = document.createElement("a");
            return e.href = t, t = e.href, e = null, t;
        }(t), i = {
            url: e,
            referrer: window && window.location.href,
            fetchOptions: this.i.options.fetchOptions
        };
        return new Promise((t, e)=>{
            this.send(i, null, (i, s)=>{
                i ? e(i) : t(s);
            });
        });
    }
    sendImageData(t, e) {
        !function(t, e) {
            const i = new Image;
            i.onload = ()=>{
                if (!$f87d9fed9ae75f45$var$I) return void e(new Error("There is no canvas to draw image!"));
                $f87d9fed9ae75f45$var$I.width = i.width, $f87d9fed9ae75f45$var$I.height = i.height;
                const t = $f87d9fed9ae75f45$var$I.getContext("2d");
                t.drawImage(i, 0, 0, i.width, i.height);
                const s = t.getImageData(0, 0, i.width, i.height), n = {
                    width: i.width,
                    height: i.height,
                    data: new Uint8Array(s.data)
                };
                e(null, n, [
                    n.data.buffer
                ]);
            }, i.onerror = function(t) {
                e(t);
            }, i.src = t;
        }(t, (i, s)=>{
            i || this.isActive() && e(null, {
                result: s,
                imageUrl: t
            });
        });
    }
    addLayer(t, e, i) {
        const s = {
            actorId: this.actorId,
            mapId: this.mapId,
            layerId: t,
            command: "addLayer",
            params: {
                options: e
            }
        };
        this.broadcast(s, null, i);
    }
    removeLayer(t, e, i) {
        const s = {
            mapId: this.mapId,
            layerId: t,
            command: "removeLayer"
        };
        this.broadcast(s, null, i);
    }
}
/*!
 * @maptalks/gl v0.106.3
 * LICENSE : UNLICENSED
 * (c) 2016-2025 maptalks.com
 */ const $f87d9fed9ae75f45$var$D = function() {
    if ("undefined" != typeof globalThis) return globalThis;
    if ("undefined" != typeof self) return self;
    if ("undefined" != typeof window) return window;
    if ("undefined" != typeof $parcel$global) return $parcel$global;
    throw new Error("unable to locate global object");
}, $f87d9fed9ae75f45$var$G = $f87d9fed9ae75f45$var$D(), $f87d9fed9ae75f45$var$N = $f87d9fed9ae75f45$var$G.gl_trans__coders = $f87d9fed9ae75f45$var$G.gl_trans__coders || {};
$f87d9fed9ae75f45$var$N.inject = function(t) {
    const e = t.toString(), i = e.indexOf("{") + 1, s = e.substring(0, i), n = $f87d9fed9ae75f45$var$G.gl_trans__coders = $f87d9fed9ae75f45$var$G.gl_trans__coders || {};
    let r = `${s}\n    const _____getGlobal = ${$f87d9fed9ae75f45$var$D.toString()};\n    const g___lobals = _____getGlobal()\n    const tran_____scoders = g___lobals['gl_trans__coders'] = g___lobals['gl_trans__coders'] || {};`;
    for(const t in n)"inject" !== t && "getTranscoder" !== t && "registerTranscoder" !== t && (r += 'tran_____scoders["' + t + '"] =' + n[t].toString() + "\n;");
    return r += "\n(" + $f87d9fed9ae75f45$var$D().maptalks_gltf_loader_bundle.toString() + ")({});\n", r += "\n" + e.substring(s.length), r;
}, $f87d9fed9ae75f45$var$N.registerTranscoder = function(t, e) {
    $f87d9fed9ae75f45$var$N[t] = e;
}, $f87d9fed9ae75f45$var$N.getTranscoder = function(t) {
    return $f87d9fed9ae75f45$var$N[t];
};
const $f87d9fed9ae75f45$var$E = $f87d9fed9ae75f45$var$D().maptalks_gltf_loader, $f87d9fed9ae75f45$var$B = {
    "image/crn": $f87d9fed9ae75f45$var$N.crn && $f87d9fed9ae75f45$var$N.crn(),
    "image/ktx2": $f87d9fed9ae75f45$var$N.ktx2 && $f87d9fed9ae75f45$var$N.ktx2(),
    "image/cttf": $f87d9fed9ae75f45$var$N.ktx2 && $f87d9fed9ae75f45$var$N.ktx2(),
    "draco": $f87d9fed9ae75f45$var$N.draco && $f87d9fed9ae75f45$var$N.draco()
};
let $f87d9fed9ae75f45$var$R;
const $f87d9fed9ae75f45$var$j = {};
function $f87d9fed9ae75f45$var$U(t, e, i) {
    return new $f87d9fed9ae75f45$var$E.GLTFLoader(t, e, i).load({
        skipAttributeTransform: !0
    });
}
function $f87d9fed9ae75f45$var$z(t, e, i, s) {
    const n = e.lastIndexOf("/"), r = e.slice(0, n);
    s && (e = s(e));
    const o = (...e)=>$f87d9fed9ae75f45$var$J.call(this, t, ...e);
    return (function(t, e) {
        return $f87d9fed9ae75f45$var$E.Ajax.getArrayBuffer(t, e);
    })(e, i).then((t)=>{
        if (t.message) return t;
        const n = t.data;
        return new DataView(n, n.byteOffset, n.byteLength).getUint32(4, !0) > 2 ? (function(t, e) {
            return $f87d9fed9ae75f45$var$E.Ajax.getJSON(t, e);
        })(e, i).then((t)=>t.message ? t : $f87d9fed9ae75f45$var$U(r, t, {
                requestImage: o,
                decoders: $f87d9fed9ae75f45$var$B,
                transferable: !0,
                fetchOptions: i,
                urlModifier: s
            })) : $f87d9fed9ae75f45$var$U(r, {
            buffer: t.data,
            byteOffset: 0
        }, {
            requestImage: o,
            decoders: $f87d9fed9ae75f45$var$B,
            transferable: !0,
            fetchOptions: i,
            urlModifier: s
        });
    });
}
function $f87d9fed9ae75f45$var$J(t, e, i, s) {
    t ? $f87d9fed9ae75f45$var$j[e] ? $f87d9fed9ae75f45$var$j[e].push(s) : ($f87d9fed9ae75f45$var$j[e] = [
        s
    ], self.postMessage({
        type: "<request>",
        command: "sendImageData",
        actorId: t,
        workerId: $f87d9fed9ae75f45$var$R,
        params: e
    })) : function(t, e) {
        const i = new Image;
        i.onload = ()=>{
            if (!$f87d9fed9ae75f45$var$H) return void e(new Error("There is no canvas to draw image!"));
            $f87d9fed9ae75f45$var$H.width = i.width, $f87d9fed9ae75f45$var$H.height = i.height;
            const t = $f87d9fed9ae75f45$var$H.getContext("2d");
            t.drawImage(i, 0, 0, i.width, i.height);
            const s = t.getImageData(0, 0, i.width, i.height), n = {
                width: i.width,
                height: i.height,
                data: new Uint8Array(s.data)
            };
            e(null, n, [
                n.data.buffer
            ]);
        }, i.onerror = function(t) {
            e(t);
        }, i.src = t;
    }(e, s);
}
const $f87d9fed9ae75f45$var$H = "undefined" == typeof document ? null : document.createElement("canvas");
const $f87d9fed9ae75f45$var$V = [], $f87d9fed9ae75f45$var$Z = [], $f87d9fed9ae75f45$var$q = [], $f87d9fed9ae75f45$var$W = [], $f87d9fed9ae75f45$var$X = [
    1,
    1,
    1
], $f87d9fed9ae75f45$var$Y = [], $f87d9fed9ae75f45$var$$ = [], $f87d9fed9ae75f45$var$K = [
    1,
    1,
    1
], $f87d9fed9ae75f45$var$Q = [], $f87d9fed9ae75f45$var$tt = new (0, $2wazW).BoundingBox, $f87d9fed9ae75f45$var$et = function(t, e) {
    const i = [];
    return i[0] = t[0], i[1] = t[1], i[2] = t[2], i[3] = 0, i[4] = t[3], i[5] = t[4], i[6] = t[5], i[7] = 0, i[8] = t[6], i[9] = t[7], i[10] = t[8], i[11] = 0, i[12] = e[0], i[13] = e[1], i[14] = e[2], i[15] = 1, i;
}(function(t) {
    const e = Math.cos(t), i = Math.sin(t), s = [];
    return s[0] = 1, s[1] = 0, s[2] = 0, s[3] = 0, s[4] = e, s[5] = i, s[6] = 0, s[7] = -i, s[8] = e, s;
}(.5 * Math.PI), [
    0,
    0,
    0
]), $f87d9fed9ae75f45$var$it = new (0, $gP1US.Point)(0, 0), $f87d9fed9ae75f45$var$st = [
    186 / 255,
    186 / 255,
    186 / 255,
    1
], $f87d9fed9ae75f45$var$nt = {
    "lightAmbient": [
        1,
        1,
        1
    ],
    "lightDiffuse": [
        1,
        1,
        1
    ],
    "lightSpecular": [
        1,
        1,
        1
    ],
    "lightDirection": [
        1,
        1,
        1
    ]
}, $f87d9fed9ae75f45$var$rt = new Set([
    "url",
    "translationX",
    "translationY",
    "translationZ",
    "rotationX",
    "rotationY",
    "rotationZ",
    "scaleX",
    "scaleY",
    "scaleZ",
    "anchorZ",
    "markerPixelHeight",
    "modelHeight"
]), $f87d9fed9ae75f45$var$ot = [
    1,
    1,
    1,
    1,
    -1,
    1,
    -1,
    -1,
    1,
    -1,
    1,
    1,
    1,
    1,
    -1,
    1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1,
    -1
], $f87d9fed9ae75f45$var$ht = [
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    0,
    0,
    4,
    1,
    5,
    2,
    6,
    3,
    7,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    4
], $f87d9fed9ae75f45$var$at = [
    .8,
    .8,
    .1,
    1
];
class $f87d9fed9ae75f45$export$f502975d4e0f97bb extends (0, $gP1US.Marker) {
    constructor(t, i){
        const s = (0, $gP1US.Util).extend({}, i), n = s.symbol;
        super(t, s), this.options.symbol = n, this.o = !1, this.h = (0, $3iqbd).identity([]), this.l = "gltfmarker", this.u = !0, this.m = !0, this.p = {
            get translation () {
                return [
                    0,
                    0,
                    0
                ];
            },
            get rotation () {
                return [
                    0,
                    0,
                    0
                ];
            },
            get scale () {
                return [
                    1,
                    1,
                    1
                ];
            }
        }, this._();
    }
    static parseJSONData(t) {
        const e = $f87d9fed9ae75f45$export$f502975d4e0f97bb.fromJSON(t);
        return e.setZoomOnAdded(t.zoomOnAdded), e;
    }
    static fromJSON(t) {
        return new $f87d9fed9ae75f45$export$f502975d4e0f97bb(t.coordinates, t.options);
    }
    static getGLTFAnchorsAlongLineString(t, i, s, n) {
        const r = [];
        for(let o = 0; o < t.length - 1; o++){
            const h = $f87d9fed9ae75f45$var$k(t[o], t[o + 1], {
                map: s,
                bboxWidth: i,
                gapLength: n.gapLength || 0,
                count: n.count,
                rotateAlongLine: n.rotateAlongLine,
                snapToEndVertexes: n.snapToEndVertexes,
                scaleEndModel: n.scaleEndModel
            });
            (0, $gP1US.Util).pushIn(r, h);
        }
        return r;
    }
    static combineGLTFBoundingBox(t) {
        const e = [];
        for(let i = 0; i < t.length; i++){
            const s = t[i].getBoundingBox();
            e.push([
                s.min,
                s.max
            ]);
        }
        const i = e[0];
        if (!i) return null;
        const s = (0, $eIStk).copy([], i[0]), n = (0, $eIStk).copy([], i[1]);
        for(let t = 1; t < e.length; t++){
            const i = e[t], r = (0, $eIStk).copy([], i[0]), o = (0, $eIStk).copy([], i[1]);
            r[0] < s[0] && (s[0] = r[0]), r[1] < s[1] && (s[1] = r[1]), r[2] < s[2] && (s[2] = r[2]), o[0] > n[0] && (n[0] = o[0]), o[1] > n[1] && (n[1] = o[1]), o[2] > n[2] && (n[2] = o[2]);
        }
        return {
            min: s,
            max: n
        };
    }
    setTransformOrigin(t) {
        this.v = t;
    }
    getTransformOrigin() {
        return this.v || this.getCenter();
    }
    getMeshes(t, e, i) {
        let s = [];
        const n = this.getMap();
        if (e && (this.regl = e), this.getLayer().isVisible() && this.isVisible() && this.M()) {
            if (!this.S) return this.O(t, e), s;
            let r = this.isAnimated() || this.T() && n.isZooming() || this.m || "multigltfmarker" === this.getGLTFMarkerType() && this.u;
            if (!r) {
                const t = this.h;
                (0, $3iqbd).copy($f87d9fed9ae75f45$var$Y, t), this._(), r = !(0, $3iqbd).exactEquals(t, $f87d9fed9ae75f45$var$Y);
            }
            r && this.A(this.S, i), s = this.S.filter((t)=>!!((0, $9b5be2c4f6c5fa19$export$25ea4bdae27a952b)(n.projViewMatrix, t.getBoundingBox()) || t instanceof (0, $2wazW).InstancedMesh) && (this.k(t), this.P(t), !0)), this.C(!1);
        }
        return s;
    }
    getGLTFJSON() {
        return this.L;
    }
    getAllMeshes() {
        return this.S;
    }
    I() {
        return this.L;
    }
    F(t) {
        this.L = t;
    }
    D(t, e) {
        this._externSymbol = this._externSymbol || {}, this._externSymbol[t] = e, "uniforms" === t && (this.G = !0);
    }
    setUrl(t) {
        return this.updateSymbol({
            url: t
        }), this;
    }
    setSymbol(t) {
        const e = this.getUrl();
        super.setSymbol(t);
        const i = this.getShader(), s = this.N;
        s && t.url !== e && (s.logoutGLTF(e), this.B = !1, this.R(!1), delete this.S), this.j && this.j !== i && this.U(s, this.regl), this.j = i, this.G = !0, this.u = !0;
    }
    getCenter() {
        const t = this.getMap();
        if (!t) return null;
        const e = $f87d9fed9ae75f45$var$T(t, super.getCenter() || this.getCoordinates());
        if (!e) return null;
        const i = this.J(), s = new (0, $gP1US.Point)([
            e[0] + i[0],
            e[1] + i[1],
            e[2] + i[2]
        ]), r = t.getGLRes(), o = t.pointAtResToCoord(s, r);
        return o.z = s.z / t.altitudeToPoint(100, r) * 100, o;
    }
    getPointZ() {
        const t = this.getCoordinates(), e = this.getMap();
        if (!e || !t) return null;
        return e.altitudeToPoint(t.z || 0, e.getGLRes());
    }
    getUrl() {
        const t = this._getInternalSymbol();
        return t && t.url || "pyramid";
    }
    addTo(t) {
        if (this.getLayer()) throw new Error("GLTFMarker cannot be added to two or more layers at the same time.");
        return t.addGeometry(this), this;
    }
    O(t, e) {
        const i = this.getUrl();
        if (this.N = t, !this.B) {
            const e = this.getLayer().getRenderer();
            t.loginGLTF(i, (...t)=>e.H.apply(e, t)), this.B = !0;
        }
        const s = t.getGLTF(i);
        s && !s.then && (this.R(!0), this.V(s, t, e));
    }
    k(t, e) {
        "effectmarker" === this.getGLTFMarkerType() ? this.updateUV(e) : "glowmarker" === this.getGLTFMarkerType() && this.Z();
        const i = this.getUniforms();
        if (i && this.isDirty() && this.q()) for(const e in i)t.setUniform(e, i[e]);
        this.W() && (t.transparent = !0), t.setUniform("uPickingId", this.X()), t.properties.isAnimated = this.isAnimated();
    }
    P(t) {
        const e = this.getShader(), i = t.getDefines();
        let s = !1;
        if ("pbr" === e || "pbr-lite" === e) {
            const t = this.getLayer(), { iblTexes: e } = (0, $2wazW).pbr.PBRUtils.getIBLResOnCanvas(t.getRenderer().canvas);
            e ? i.HAS_IBL_LIGHTING || (i.HAS_IBL_LIGHTING = 1, s = !0) : i.HAS_IBL_LIGHTING && (s = !0, delete i.HAS_IBL_LIGHTING);
        }
        s && t.setDefines(i);
        const n = this.getLayer().getRenderer();
        n && n.updateMaskDefines(t);
    }
    U(t) {
        const e = this.getUrl(), i = this.S;
        if (!t || !i) return;
        if (t.isSimpleModel(e)) return void this.Y(i);
        t.getGLTF(e) && (i.forEach((t)=>{
            this.k(t);
        }), this.Y(i));
    }
    Y(t) {
        const e = this.getShader();
        t.forEach((t)=>{
            const i = this.$(t.properties.geometryResource);
            "wireframe" === e ? (t.properties.geometryResource && !t.properties.geometryResource.copyGeometry && t.properties.geometryResource.copyEdgeGeometry(), t.geometry = t.properties.geometryResource.copyGeometry) : t.geometry = t.properties.geometryResource.geometry, t.material = i;
        });
    }
    A(t, e) {
        (0, $eIStk).set($f87d9fed9ae75f45$var$X, 1, 1, 1);
        const i = (0, $3iqbd).identity($f87d9fed9ae75f45$var$Y), s = this.isAnimated();
        this._();
        const n = this.getModelMatrix(), { nodeMatrixMap: r, skinMap: o } = this.K(e);
        this.tt($f87d9fed9ae75f45$var$X);
        let h = 0;
        t.forEach((t)=>{
            const e = t.properties.geometryResource.nodeIndex, a = r[e], c = s && a ? a : t.nodeMatrix;
            (0, $3iqbd).scale(i, n, $f87d9fed9ae75f45$var$X), (0, $3iqbd).multiply(i, i, $f87d9fed9ae75f45$var$et), t.et = t.et || (0, $3iqbd).identity([]);
            const f = (0, $3iqbd).multiply($f87d9fed9ae75f45$var$Q, t.et, c);
            t instanceof (0, $2wazW).InstancedMesh ? (t.positionMatrix = (0, $3iqbd).multiply(t.positionMatrix, i, f), t.localTransform = this.it(), this.st(t)) : t.localTransform = (0, $3iqbd).multiply(t.localTransform, i, f);
            const d = t.geometry.boundingBox.copy($f87d9fed9ae75f45$var$tt);
            d.transform(t.positionMatrix, t.localTransform);
            const m = this.nt(d);
            if (Math.abs(m) > Math.abs(h) && (h = m), s) {
                const i = o[e];
                i && (t.material.set("skinAnimation", 1), t.material.set("jointTextureSize", i.jointTextureSize), t.material.set("numJoints", i.numJoints), t.material.set("jointTexture", i.jointTexture));
                const s = t.geometry.properties.morphWeights;
                s && this.rt(s, t.material);
            } else t.material.set("skinAnimation", 0);
        });
        const a = this.ot();
        if (a && ((0, $3iqbd).scale(i, n, $f87d9fed9ae75f45$var$X), (0, $3iqbd).multiply(i, i, $f87d9fed9ae75f45$var$et), this.ht.localTransform = (0, $3iqbd).multiply(this.ht.localTransform, i, this.ht.ct)), 0 !== h) {
            (0, $eIStk).set($f87d9fed9ae75f45$var$$, 0, 0, h);
            const e = (0, $3iqbd).fromTranslation($f87d9fed9ae75f45$var$Y, $f87d9fed9ae75f45$var$$);
            t.forEach((t)=>{
                if (t instanceof (0, $2wazW).InstancedMesh) t.positionMatrix = (0, $3iqbd).multiply(t.positionMatrix, e, t.positionMatrix), this.st(t);
                else {
                    const i = (0, $3iqbd).multiply(t.localTransform, e, t.localTransform);
                    t.localTransform = i;
                }
            }), a && (this.ht.localTransform = (0, $3iqbd).multiply(this.ht.localTransform, e, this.ht.localTransform));
        }
        t.forEach((t)=>{
            t instanceof (0, $2wazW).InstancedMesh && this.st(t);
        }), this.fire("updatematrix", {
            target: this
        });
    }
    getBoundingBoxCenter() {
        const t = this.lt, e = this.getMap();
        if (!t || !this.ht || !e) return null;
        const i = e.getGLRes(), { min: s, max: r } = t, o = (0, $eIStk).add([], s, r);
        (0, $eIStk).scale(o, o, .5), (0, $eIStk).transformMat4(o, o, this.ht.localTransform);
        const h = new (0, $gP1US.Point)(o), a = e.pointAtResToCoordinate(h, i);
        return a.z = 100 / e.altitudeToPoint(100, i) * o[2], a;
    }
    getBoundingBoxWidth(t) {
        const e = this.lt;
        if (!e) return 0;
        let i = 0;
        "x" === t ? i = 0 : "y" === t ? i = 2 : "z" === t && (i = 1);
        const { min: s, max: n } = e, r = this.ut()[i];
        return (n[i] - s[i]) * r;
    }
    getAxisXWidth() {
        return this.getBoundingBoxWidth("x");
    }
    getAxisYWidth() {
        return this.getBoundingBoxWidth("y");
    }
    getAxisZWidth() {
        return this.getBoundingBoxWidth("z");
    }
    tt(t) {
        const e = this.getMap(), i = e.getGLRes(), s = e.altitudeToPoint(100, i);
        return t[0] *= s / 100, t[1] *= s / 100, t[2] *= s / 100, t;
    }
    ft(t, e) {
        return this.gltfPack.calModelHeightScale(t, e);
    }
    dt(t, e) {
        const i = this.lt;
        if (!e || e < 0 || !i) return t;
        const s = this.getMap(), n = Math.abs(i.max[1] - i.min[1]), r = s.altitudeToPoint(n, s.getGLRes()), o = e * s.getGLScale() / r;
        return (0, $eIStk).set(t, o, o, o);
    }
    getCurrentPixelHeight() {
        const t = this.getBoundingBox();
        return Math.abs(t.max[2] - t.min[2]) / this.getMap().getGLScale();
    }
    getFitTranslate(t) {
        const e = this.lt, i = (0, $eIStk).set(t, (e.min[0] + e.max[0]) / 2, (e.min[1] + e.max[1]) / 2, (e.min[2] + e.max[2]) / 2);
        return (0, $eIStk).scale(i, i, -1);
    }
    nt(t) {
        const e = this.getSymbol(), i = e && e.anchorZ || "center";
        let s = 0;
        const n = t.max[2] - t.min[2];
        return "bottom" === i ? s = n / 2 : "top" === i && (s = -n / 2), s;
    }
    K(t) {
        const e = this.isAnimated(), i = this.gt(), s = {}, n = this._t();
        if (t && e && this.gltfPack && i) {
            const e = this.xt();
            if ($f87d9fed9ae75f45$var$O(e)) {
                this.yt(t);
                const i = this.vt(), r = this.isAnimationLooped(), o = this.getAnimationSpeed(), h = this.getSymbol(), a = h && h.animationNodes;
                for(let h = 0; h < e.length; h++)this.gltfPack.updateAnimation(t, r, o, e[h], i, s, n, a);
            } else console.warn("animation specified does not exist!");
        }
        return {
            nodeMatrixMap: s,
            skinMap: n
        };
    }
    V(t, e, i) {
        const s = this.getUrl();
        this.F(t.json), this.wt(s, e, i), this.U(e, i), this.createdBygltfmarker || (this.fire("load", {
            data: t.json
        }), this.fire("setUrl-debug"), this._fireEvent("meshcreate", {
            url: s
        }));
    }
    wt(t, e, i) {
        const s = [], n = this.getShader(), r = e.getGLTF(t);
        if (r && r.resources) {
            if (!r.resources.length) return void this._fireEvent("modelerror", {
                url: t,
                info: "there are no geomtries in the gltf model"
            });
            this.gltfPack = r.gltfPack, r.resources.forEach((t)=>{
                const e = this.bt(t, n, i);
                s.push(e);
            });
        }
        this.S = s, this.lt = this.Mt(), this.St(this.S), this.fire("createscene-debug", {
            meshes: this.S
        });
    }
    St(t) {
        this.A(t);
        const e = this.getBoundingBox();
        if (!e) return;
        const i = this.getMap(), { max: s, min: n } = e;
        (0, $eIStk).length([
            s[0] - n[0],
            s[1] - n[1],
            s[2] - n[2]
        ]) / i.getGLScale() < 20 && (console.warn("Model's size on screen is too small, try to increase its symbol.scaleX/Y/Z"), this.fire("smallonscreen"));
    }
    ot() {
        if (this.ht) return this.ht.material.set("lineColor", this.Ot || $f87d9fed9ae75f45$var$at), this.ht.material.set("lineOpacity", this.Tt || 1), this.ht;
        const t = this.lt;
        if (!t) return null;
        const { min: e, max: i } = t;
        $f87d9fed9ae75f45$var$ot[0] = i[0], $f87d9fed9ae75f45$var$ot[1] = e[1], $f87d9fed9ae75f45$var$ot[2] = i[2], $f87d9fed9ae75f45$var$ot[3] = i[0], $f87d9fed9ae75f45$var$ot[4] = i[1], $f87d9fed9ae75f45$var$ot[5] = i[2], $f87d9fed9ae75f45$var$ot[6] = e[0], $f87d9fed9ae75f45$var$ot[7] = i[1], $f87d9fed9ae75f45$var$ot[8] = i[2], $f87d9fed9ae75f45$var$ot[9] = e[0], $f87d9fed9ae75f45$var$ot[10] = e[1], $f87d9fed9ae75f45$var$ot[11] = i[2], $f87d9fed9ae75f45$var$ot[12] = i[0], $f87d9fed9ae75f45$var$ot[13] = e[1], $f87d9fed9ae75f45$var$ot[14] = e[2], $f87d9fed9ae75f45$var$ot[15] = i[0], $f87d9fed9ae75f45$var$ot[16] = i[1], $f87d9fed9ae75f45$var$ot[17] = e[2], $f87d9fed9ae75f45$var$ot[18] = e[0], $f87d9fed9ae75f45$var$ot[19] = i[1], $f87d9fed9ae75f45$var$ot[20] = e[2], $f87d9fed9ae75f45$var$ot[21] = e[0], $f87d9fed9ae75f45$var$ot[22] = e[1], $f87d9fed9ae75f45$var$ot[23] = e[2];
        const s = new (0, $2wazW).Geometry({
            POSITION: $f87d9fed9ae75f45$var$ot
        }, $f87d9fed9ae75f45$var$ht, 0, {
            primitive: "lines",
            positionAttribute: "POSITION"
        });
        s.generateBuffers(this.regl);
        const n = new (0, $2wazW).Mesh(s, new (0, $2wazW).Material({
            lineColor: this.Ot || $f87d9fed9ae75f45$var$at,
            lineOpacity: this.Tt || 1
        }));
        return this.ht = n, this.ht.ct = (0, $3iqbd).copy([], n.localTransform), n;
    }
    showBoundingBox(t) {
        this.options.showDebugBoundingBox = !0, this.Ot = t && t.lineColor, this.Tt = t && t.lineOpacity, this.u = !0;
    }
    hideBoundingBox() {
        this.options.showDebugBoundingBox = !1, this.u = !0;
    }
    getBoundingBox() {
        const t = this.S;
        if (!t || !t.length) return null;
        if (!this.m) return this.At;
        "multigltfmarker" === this.getGLTFMarkerType() && t.forEach((t)=>{
            this.st(t), t.updateBoundingBox();
        });
        const e = t[0].getBoundingBox(), i = (0, $eIStk).copy([], e[0]), s = (0, $eIStk).copy([], e[1]);
        for(let e = 1; e < t.length; e++){
            const n = t[e].getBoundingBox(), r = (0, $eIStk).copy([], n[0]), o = (0, $eIStk).copy([], n[1]);
            r[0] < i[0] && (i[0] = r[0]), r[1] < i[1] && (i[1] = r[1]), r[2] < i[2] && (i[2] = r[2]), o[0] > s[0] && (s[0] = o[0]), o[1] > s[1] && (s[1] = o[1]), o[2] > s[2] && (s[2] = o[2]);
        }
        const n = {
            min: i,
            max: s
        };
        return this.At = n, "multigltfmarker" === this.getGLTFMarkerType() ? this.kt.length && (this.m = !1) : this.m = !1, n;
    }
    Mt() {
        return this.gltfPack.getGLTFBBox();
    }
    bt(t, e, i) {
        const s = t, n = this.Pt(s, e, i), r = n.getDefines();
        return n instanceof (0, $2wazW).InstancedMesh ? (r.HAS_PICKING_ID = 1, r.HAS_INSTANCE_COLOR = 1) : r.HAS_PICKING_ID = 2, n.geometry.data.COLOR_0 && (r.HAS_COLOR0 = 1), r.HAS_MIN_ALTITUDE = 1, r.HAS_LAYER_OPACITY = 1, n.setDefines(r), n;
    }
    Pt(t, e, i) {
        const s = this.getGLTFMarkerType();
        let n = null;
        const r = this.$(t);
        let o = t.geometry;
        if ("wireframe" === e && (t.copyEdgeGeometry(), o = t.copyGeometry), i ? o.generateBuffers(i) : (this.Ct = this.Ct || [], this.Ct.push(o)), "multigltfmarker" === s) {
            this.Lt();
            const t = this.It((0, $3iqbd).identity($f87d9fed9ae75f45$var$W)), e = this.Ft();
            n = new (0, $2wazW).InstancedMesh(t.attributesData, e, o, r), n.setUniform("instance", 1), i ? n.generateInstancedBuffers(i) : (this.Dt = this.Dt || [], this.Dt.push(n));
        } else n = new (0, $2wazW).Mesh(o, r), n.setUniform("instance", 0);
        n.nodeMatrix = (0, $3iqbd).copy([], t.nodeMatrix), n.properties.geometryResource = t, n.properties.nodeIndex = t.nodeIndex, this.isBloom() && (n.bloom = 1), n.transparent = this.W();
        "BLEND" === t.extraInfo.alphaMode && (n.transparent = !0), n.properties.pickingId = this.X(), this.Gt(n);
        const h = this.getLayer();
        return Object.defineProperty(n.uniforms, "minAltitude", {
            enumerable: !0,
            get: ()=>h.options.altitude || 0
        }), n;
    }
    $(t) {
        let e = null;
        const i = this.getShader(), s = this.getUniforms() || {}, n = t.materialInfo || {}, r = this.getLayer().getRenderer();
        if ("phong" === i) {
            if ("pbrSpecularGlossiness" === n.name) e = new (0, $2wazW).PhongSpecularGlossinessMaterial(n);
            else {
                for(const t in $f87d9fed9ae75f45$var$nt)s[t] = s[t] || $f87d9fed9ae75f45$var$nt[t];
                e = new (0, $2wazW).PhongMaterial(n);
            }
        } else if ("pbr" === i) {
            if (e = "pbrSpecularGlossiness" === n.name ? new (0, $2wazW).pbr.StandardSpecularGlossinessMaterial(n) : new (0, $2wazW).pbr.StandardMaterial(n), r.regl && !(0, $2wazW).pbr.PBRUtils.isSupported(r.regl)) {
                e = (0, $2wazW).PhongMaterial.convertFrom(e);
                for(const t in $f87d9fed9ae75f45$var$nt)s[t] = s[t] || $f87d9fed9ae75f45$var$nt[t];
            }
        } else e = "pbr-lite" === i ? new (0, $2wazW).StandardLiteMaterial(n) : new (0, $2wazW).Material(n);
        const o = this.getSymbol(), h = o && o.doubleSided;
        $f87d9fed9ae75f45$var$O(h) && (e.doubleSided = h);
        for(const t in s)e.set(t, s[t]);
        return t.morphWeights && this.rt(t.morphWeights, e), t.skin && e.set("skinAnimation", 0), e;
    }
    rt(t, e) {
        const i = e.get("morphWeights1") || [], s = e.get("morphWeights2") || [];
        for(let e = 0; e < 4; e++)i[e] = t[e] || 0, s[e] = t[e + 4] || 0;
        e.set("morphWeights1", i), e.set("morphWeights2", s);
    }
    Gt(t) {
        const e = this.getSymbol();
        e && e.uniforms ? (t.setUniform("polygonFill", e.uniforms.polygonFill || $f87d9fed9ae75f45$var$st), t.setUniform("polygonOpacity", void 0 === e.uniforms.polygonOpacity ? 1 : e.uniforms.polygonOpacity), t.setUniform("lineColor", e.uniforms.lineColor || $f87d9fed9ae75f45$var$st), t.setUniform("lineOpacity", void 0 === e.uniforms.lineOpacity ? 1 : e.uniforms.lineOpacity)) : (t.setUniform("polygonFill", $f87d9fed9ae75f45$var$st), t.setUniform("polygonOpacity", 1), t.setUniform("lineColor", $f87d9fed9ae75f45$var$st), t.setUniform("lineOpacity", 1));
    }
    Nt() {
        const t = this.getLayer();
        if (!t) return null;
        const e = t.getMap();
        if (!e) return null;
        const i = this.getBoundingBox();
        if (!i) return null;
        const s = this.getPointZ() || 0, n = i.min, r = i.max, h = (0, $jxhwV).set($f87d9fed9ae75f45$var$Z, (n[0] + r[0]) / 2, (n[1] + r[1]) / 2, n[2] + s, 1), a = (0, $jxhwV).set($f87d9fed9ae75f45$var$q, (n[0] + r[0]) / 2, (n[1] + r[1]) / 2, r[2] + s, 1), c = (0, $jxhwV).transformMat4(h, h, e.projViewMatrix), l = (0, $jxhwV).transformMat4(a, a, e.projViewMatrix), u = (c[0] / c[3] + 1) * e.width / 2, f = (1 - c[1] / c[3]) * e.height / 2, m = (l[0] / l[3] + 1) * e.width / 2, g = (1 - l[1] / l[3]) * e.height / 2, p = Math.min(u, m), _ = Math.max(u, m), x = Math.min(f, g), y = Math.max(f, g);
        return new (0, $gP1US.Extent)({
            xmin: p,
            ymin: x,
            xmax: _,
            ymax: y
        });
    }
    onAdd() {
        const t = this.getLayer().getMap();
        if (t && !$f87d9fed9ae75f45$var$O(this.Et)) {
            const e = t.getZoom();
            this.Et = e;
        }
    }
    onRemove() {
        this.Bt();
    }
    remove() {
        const t = this.getUrl();
        if (this.N && (delete this.S, this.N.logoutGLTF(t), delete this.N), this.Rt) {
            for(const t in this.Rt)this.Rt[t] && this.Rt[t].jointTexture && this.Rt[t].jointTexture.destroy();
            delete this.Rt;
        }
        this.ht && (this.ht.geometry.dispose(), this.ht.dispose(), delete this.ht), this.S && this.S.forEach((t)=>{
            t.dispose(), t.properties.bloomMesh && (t.properties.bloomMesh.dispose(), delete t.properties.bloomMesh);
        }), this.B = !1, delete this.L, delete this.gltfPack, super.remove();
    }
    show() {
        return super.updateSymbol({
            visible: !0
        }), this;
    }
    hide() {
        super.updateSymbol({
            visible: !1
        });
    }
    setBloom(t) {
        return this.updateSymbol({
            bloom: t
        }), this;
    }
    isBloom() {
        const t = this._getInternalSymbol();
        return t && t.bloom;
    }
    setCastShadow(t) {
        return super.updateSymbol({
            shadow: t
        }), this;
    }
    isCastShadow() {
        const t = this._getInternalSymbol();
        return t && (t.shadow || void 0 === t.shadow);
    }
    outlineNodes(t) {
        const e = this.S;
        return e ? (e.forEach((e)=>{
            t.indexOf(e.properties.nodeIndex) > -1 && (e.properties.outline = !0);
        }), this.u = !0, this) : this;
    }
    outline() {
        this.updateSymbol({
            outline: !0
        });
        const t = this.S;
        return t ? (t.forEach((t)=>{
            t.properties.outline = !0;
        }), this.u = !0, this) : this;
    }
    cancelOutline(t) {
        this.updateSymbol({
            outline: !1
        });
        const e = this.S;
        return e ? (e.forEach((e)=>{
            t ? t.indexOf(e.properties.nodeIndex) > -1 && (e.properties.outline = !1) : e.properties.outline = !1;
        }), this.u = !0, this) : this;
    }
    isOutline() {
        const t = this._getInternalSymbol();
        return !(!t || !$f87d9fed9ae75f45$var$O(t.outline)) && t.outline;
    }
    isVisible() {
        const t = this._getInternalSymbol();
        return !t || !$f87d9fed9ae75f45$var$O(t.visible) || t.visible;
    }
    setCoordinates(t) {
        return super.setCoordinates(t), this.u = !0, this.m = !0, this;
    }
    copy() {
        const t = this.toJSON(), e = $f87d9fed9ae75f45$export$f502975d4e0f97bb.fromJSON(t);
        return e.setZoomOnAdded(this.Et), e;
    }
    setShader(t) {
        return super.updateSymbol({
            shader: t
        }), this;
    }
    getShader() {
        const t = this._getInternalSymbol();
        return t && t.shader || "pbr";
    }
    setUniforms(t) {
        return super.updateSymbol({
            uniforms: t
        }), this.G = !0, this;
    }
    getUniforms() {
        const t = this._getInternalSymbol();
        return t && t.uniforms;
    }
    setUniform(t, e) {
        const i = this.getUniforms() || {};
        return i[t] = e, super.updateSymbol({
            uniforms: i
        }), this.G = !0, this;
    }
    getUniform(t) {
        const e = this._getInternalSymbol();
        return e && e.uniforms && e.uniforms[t];
    }
    isAnimated() {
        const t = this._getInternalSymbol();
        return t && t.animation && this.L && this.L.animations;
    }
    isDashAnimated() {
        const t = this._getInternalSymbol();
        return t && t.uniforms && t.uniforms.dashEnabled && t.uniforms.dashAnimate;
    }
    setAnimation(t) {
        return super.updateSymbol({
            animation: t
        }), delete this.jt, this;
    }
    setAnimationLoop(t) {
        return super.updateSymbol({
            loop: t
        }), delete this.jt, this.u = !0, this;
    }
    isAnimationLooped() {
        const t = this._getInternalSymbol();
        return t && t.loop;
    }
    getAnimationSpeed() {
        const t = this._getInternalSymbol();
        return t && $f87d9fed9ae75f45$var$O(t.speed) ? t.speed : 1;
    }
    setAnimationSpeed(t) {
        return super.updateSymbol({
            speed: t
        }), this;
    }
    Ut(t) {
        const e = this.getMap();
        return e ? $f87d9fed9ae75f45$var$T(e, t || this.getCoordinates()) : null;
    }
    setTRS(t, e, i) {
        const s = t || this.p.translation;
        return this.updateSymbol({
            translationX: s[0],
            translationY: s[1],
            translationZ: s[2],
            rotationX: e[0],
            rotationY: e[1],
            rotationZ: e[2],
            scaleX: i[0],
            scaleY: i[1],
            scaleZ: i[2]
        }), this;
    }
    zt() {
        const t = this.J(), e = this.Ut();
        return e ? (0, $eIStk).add(t, t, e) : t;
    }
    updateSymbol(t) {
        for(const e in t)if ("bloom" === e && this.S && this.S.forEach((i)=>{
            i.bloom = +!!t[e];
        }), $f87d9fed9ae75f45$var$rt.has(e)) {
            this.m = !0;
            break;
        }
        return super.updateSymbol(t);
    }
    setTranslation(t, e, i) {
        return this.updateSymbol({
            translationX: t,
            translationY: e,
            translationZ: i
        }), this;
    }
    setRotation(t, e, i) {
        return this.updateSymbol({
            rotationX: t,
            rotationY: e,
            rotationZ: i
        }), this;
    }
    rotateAround(t, e) {
        const i = this.getMap();
        if (!i) return;
        const s = i.getGLRes();
        let n = this.getCoordinates();
        const r = i.coordinateToPointAtRes(n, s), o = i.coordinateToPointAtRes(t, s), h = r.x - o.x, a = r.y - o.y, c = 180 * Math.atan2(a, h) / Math.PI + e, l = Math.sqrt(h * h + a * a), u = Math.PI * c / 180, f = l * Math.cos(u) + o.x, d = l * Math.sin(u) + o.y;
        $f87d9fed9ae75f45$var$it.set(f, d), n = i.pointAtResToCoordinate($f87d9fed9ae75f45$var$it, s), this.setCoordinates(n), this.updateSymbol({
            rotationZ: c
        });
    }
    setScale(t, e, i) {
        return this.updateSymbol({
            scaleX: t,
            scaleY: e,
            scaleZ: i
        }), this;
    }
    getTranslation() {
        const t = this._getInternalSymbol(), e = t && t.translationX || 0, i = t && t.translationY || 0, s = t && t.translationZ || 0;
        return (0, $eIStk).set(this.p.translation, e, i, s);
    }
    J() {
        const t = this.getTranslation();
        return this.getMap() ? this.Jt(t) : this.p.translation;
    }
    Jt(t) {
        const e = this.getMap(), i = e.distanceToPointAtRes(t[0], t[1], e.getGLRes(), $f87d9fed9ae75f45$var$it), s = e.altitudeToPoint(t[2], e.getGLRes());
        return (0, $eIStk).set($f87d9fed9ae75f45$var$$, $f87d9fed9ae75f45$var$A(i.x, t[0]), $f87d9fed9ae75f45$var$A(i.y, t[1]), $f87d9fed9ae75f45$var$A(s, t[2]));
    }
    getRotation() {
        const t = this._getInternalSymbol(), e = t && t.rotationX || 0, i = t && t.rotationY || 0, s = t && t.rotationZ || 0;
        return (0, $eIStk).set(this.p.rotation, e, i, s);
    }
    getScale() {
        const t = this._getInternalSymbol();
        if (!t) return (0, $eIStk).set(this.p.scale, 1, 1, 1);
        const i = (0, $gP1US.Util).isNil(t.scaleX) ? 1 : t.scaleX, s = (0, $gP1US.Util).isNil(t.scaleY) ? 1 : t.scaleY, n = (0, $gP1US.Util).isNil(t.scaleZ) ? 1 : t.scaleZ;
        return (0, $eIStk).set(this.p.scale, i, s, n);
    }
    ut() {
        const t = this.getScale();
        if (this.lt) {
            const e = this.T(), i = this.getModelHeight();
            if (e && e > 0) {
                const i = this.dt($f87d9fed9ae75f45$var$K, e);
                return (0, $eIStk).multiply(i, i, t);
            }
            if (i) {
                const e = this.ft($f87d9fed9ae75f45$var$K, i);
                return (0, $eIStk).multiply(e, e, t);
            }
        }
        return t;
    }
    cancelMarkerPixelHeight() {
        return this.updateSymbol({
            markerPixelHeight: null
        });
    }
    setAnchorZ(t) {
        return this.updateSymbol({
            anchorZ: t
        }), this;
    }
    getAnchorZ() {
        const t = this._getInternalSymbol();
        return t && t.anchorZ || "bottom";
    }
    _setExternSymbol(t) {
        return this.u = !0, super._setExternSymbol(t);
    }
    Ht(t) {
        return (0, $14507960c5dac0fb$export$7359e25750286ba6)(t, ()=>{
            const t = this.getMap();
            if (t) return [
                t.getZoom()
            ];
            return null;
        });
    }
    _prepareSymbol(t) {
        super._prepareSymbol(t);
        const e = this.Ht(t);
        return e && e.uniforms && (e.uniforms = this.Ht(t.uniforms)), delete this.Vt, e;
    }
    hasFunctionDefinition() {
        if ($f87d9fed9ae75f45$var$O(this.Vt)) return this.Vt;
        const t = this._getInternalSymbol();
        return this.Vt = (0, $14507960c5dac0fb$export$3ab4b318ddeff41d)(t) || t && t.uniforms && (0, $14507960c5dac0fb$export$3ab4b318ddeff41d)(t.uniforms), this.Vt;
    }
    setModelMatrix(t) {
        const e = (0, $3iqbd).getTranslation(this.p.translation, t), i = (0, $3iqbd).getRotation(this.p.rotation, t), s = (0, $3iqbd).getScaling(this.p.scale, t);
        return this.setTranslation(e[0], e[1], e[2]), this.setRotation(i[0], i[1], i[2]), this.setScale(s[0], s[1], s[2]), this;
    }
    getModelMatrix() {
        return this.h;
    }
    _() {
        const t = this.zt(), e = this.getRotation(), i = (0, $k1dpP).fromEuler($f87d9fed9ae75f45$var$V, e[0], e[1], e[2]), s = this.ut();
        this.h = (0, $3iqbd).fromRotationTranslationScale(this.h, i, t, s);
    }
    isDirty() {
        return this.u;
    }
    C(t) {
        return this.u = t, this;
    }
    Zt() {
        const t = this.toJSON();
        return t.zoomOnAdded = this.Et, t;
    }
    toJSON() {
        const t = JSON.parse(JSON.stringify({
            coordinates: this.getCoordinates(),
            options: this.options || {},
            type: "GLTFMarker"
        })), i = this.getId();
        (0, $gP1US.Util).isNil(i) || (t.options.id = i);
        const s = this.getProperties();
        s && (t.options.properties = JSON.parse(JSON.stringify(s)));
        const n = this.getSymbol();
        return n && (t.options.symbol = JSON.parse(JSON.stringify(n))), t;
    }
    setZoomOnAdded(t) {
        this.Et = t;
    }
    getZoomOnAdded() {
        return this.Et;
    }
    W() {
        return this.M() < 1;
    }
    M() {
        const t = this.getUniforms(), e = this.getShader();
        return "pbr" === e || "phong" === e ? t && $f87d9fed9ae75f45$var$O(t.polygonOpacity) ? t.polygonOpacity : 1 : "wireframe" === e && t && $f87d9fed9ae75f45$var$O(t.lineOpacity) ? t.lineOpacity : 1;
    }
    R(t) {
        this.o = t;
    }
    isLoaded() {
        return this.o;
    }
    getGLTFMarkerType() {
        return this.l;
    }
    qt(t) {
        this.Wt = t;
    }
    X() {
        return this.Wt;
    }
    getCount() {
        return 1;
    }
    getContainerExtent() {
        return this.Nt();
    }
    getGLTFAsset() {
        return this.L && this.L.asset;
    }
    openInfoWindow(t) {
        this.L ? super.openInfoWindow(t) : this.once("load", ()=>{
            super.openInfoWindow(t);
        });
    }
    getAnimations() {
        if (!this.L) return null;
        const t = this.L, e = t.animations ? t.animations.map((t, e)=>({
                name: $f87d9fed9ae75f45$var$O(t.name) ? t.name : e
            })) : null;
        return e ? e.map((t, e)=>t.name || e) : null;
    }
    getCurrentAnimation() {
        const t = this._getInternalSymbol();
        return t && t.animationName;
    }
    xt() {
        const t = this.getAnimations();
        if (!t) return null;
        let e = this.getCurrentAnimation();
        if (!$f87d9fed9ae75f45$var$O(e)) return t.slice(0, 1);
        const i = [];
        e = Array.isArray(e) ? e : [
            e
        ];
        for(let s = 0; s < e.length; s++)t.indexOf(e[s]) > -1 && i.push(e[s]);
        return i.length ? i : null;
    }
    setCurrentAnimation(t) {
        this.updateSymbol({
            animationName: t
        });
    }
    yt(t) {
        $f87d9fed9ae75f45$var$O(this.jt) || (this.jt = t);
    }
    vt() {
        return this.jt || 0;
    }
    _t() {
        return this.Rt = this.Rt || {}, this.Rt;
    }
    T() {
        const t = this._getInternalSymbol();
        return t && t.markerPixelHeight;
    }
    setModelHeight(t) {
        return this.updateSymbol({
            modelHeight: t
        }), this;
    }
    getModelHeight() {
        const t = this._getInternalSymbol();
        return t && t.modelHeight;
    }
    getGLTFBBox() {
        return this.lt;
    }
    zoomTo(t = {
        animation: !0
    }, e) {
        const i = this.getBoundingBox(), s = this.getMap();
        if (!s || !i) return;
        const { min: n, max: r } = i;
        $f87d9fed9ae75f45$var$it.set((n[0] + r[0]) / 2, (n[1] + r[1]) / 2);
        const o = s.getGLRes(), h = s.pointAtResToCoordinate($f87d9fed9ae75f45$var$it, o);
        return h.z = (n[2] + r[2]) / 2 / s.altitudeToPoint(1, o), this.Xt(h, t, e);
    }
    Xt(t, e, i) {
        const s = this.getMap(), n = e.pitch || s.getPitch(), r = e.bearing || s.getBearing(), o = e.duration || 500, h = e.easing || "linear", a = this.Yt(e.heightOffset || 0) + (e.zoomOffset || 0);
        return e.animation || void 0 === e.animation ? s.animateTo({
            center: t,
            zoom: a,
            bearing: r,
            pitch: n
        }, {
            duration: o,
            easing: h
        }, i) : s.setView({
            center: t,
            zoom: a,
            bearing: r,
            pitch: n
        }), this;
    }
    Yt(t) {
        const e = this.getMap(), i = e.getGLRes(), s = e.distanceToPointAtRes(100, 0, i).x / 100, n = this.getBoundingBox(), { min: r, max: h } = n, a = h[2] / e.altitudeToPoint(1, i) + t, c = e.getFitZoomForAltitude(a * s);
        $f87d9fed9ae75f45$var$it.set(r[0], r[1]);
        const l = e.pointAtResToCoordinate($f87d9fed9ae75f45$var$it, e.getGLRes());
        $f87d9fed9ae75f45$var$it.set(h[0], h[1]);
        const u = e.pointAtResToCoordinate($f87d9fed9ae75f45$var$it, e.getGLRes()), f = new (0, $gP1US.Extent)(l, u), d = e.getFitZoom(f);
        return c < d ? c : d;
    }
    q() {
        return this.G;
    }
    $t() {
        this.G = !1;
    }
    setAnimationTimeframe(t) {
        const e = this.vt(), i = this._t();
        this.gltfPack.updateAnimation(t, this.isAnimationLooped(), this.getAnimationSpeed(), e, {}, i);
    }
    Bt() {
        delete this.At, delete this.Et;
    }
    gt() {
        return "effectmarker" !== this.getGLTFMarkerType() && "glowmarker" !== this.getGLTFMarkerType();
    }
    _onEvent(t, e) {
        const i = this.getLayer();
        if (!i) return;
        const s = i.getId();
        this.Kt = t.gltfPickingInfo && t.gltfPickingInfo[s] || {}, super._onEvent(t, e);
    }
    _fireEvent(t, e) {
        for(const t in this.Kt)e[t] = this.Kt[t];
        delete this.Kt, super._fireEvent(t, e);
    }
    Qt() {
        let t = [];
        return this.S && this.isVisible() && this.M() ? this.isOutline && this.isOutline() ? this.S : (t = this.S.filter((t)=>t.properties.outline), t) : t;
    }
    highlightNodes(t) {
        const e = this.S;
        e ? this.te(t, e) : this.once("load", ()=>{
            this.te(t, this.S);
        }, this);
    }
    te(t, e) {
        t.forEach((t)=>{
            e.forEach((e)=>{
                e.properties.nodeIndex === t.nodeIndex && this.ee(e, t.color, t.opacity, t.bloom);
            });
        }), this.u = !0;
    }
    highlight(t) {
        const { color: e, opacity: i, bloom: s } = t, n = this.S;
        n ? (n.forEach((t)=>{
            this.ee(t, e, i, s);
        }), this.u = !0) : this.once("load", ()=>{
            this.S.forEach((t)=>{
                this.ee(t, e, i, s);
            }), this.u = !0;
        }, this);
    }
    ee(t, e, i, s) {
        t.properties.polygonFill || (t.properties.polygonFill = t.getUniform("polygonFill") || $f87d9fed9ae75f45$var$st), t.properties.polygonOpacity || (t.properties.polygonOpacity = t.getUniform("polygonOpacity") || 1), t.setUniform("polygonFill", e || $f87d9fed9ae75f45$var$st), t.setUniform("polygonOpacity", i || 1), t.bloom = s;
    }
    ie() {
        if (this.se) {
            if (Array.isArray(this.se)) {
                const t = this.se.map((t)=>t.nodeIndex);
                this.cancelHighlight(t);
            } else this.cancelHighlight(this.se.nodeIndex);
        }
    }
    cancelHighlight(t) {
        const e = this.getLayer();
        if (!e) return;
        const i = e.getRenderer();
        if (!i) return;
        let s = this.S;
        if (s) {
            if (t) {
                let e = t;
                Array.isArray(e) || (e = [
                    e
                ]), s = s.filter((t)=>e.indexOf(t.properties.nodeIndex) > -1);
            }
            s.forEach((t)=>{
                const { polygonFill: e, polygonOpacity: i } = t.properties;
                t.setUniform("polygonFill", e), t.setUniform("polygonOpacity", i), t.bloom = !1;
            }), i.setToRedraw();
        }
    }
    setNodeTRS(t, e = {}) {
        const i = this.S;
        if (!i) return;
        const s = e.translation || this.p.translation, n = e.rotation || this.p.rotation, r = (0, $k1dpP).fromEuler($f87d9fed9ae75f45$var$V, n[0], n[1], n[2]), o = e.scale || this.p.scale;
        return i.forEach((e)=>{
            e.properties.nodeIndex === t && (e.et = (0, $3iqbd).fromRotationTranslationScale(e.et || [], r, s, o));
        }), this.A(i), this.u = !0, this;
    }
}
$f87d9fed9ae75f45$export$f502975d4e0f97bb.mergeOptions({
    symbol: null
}), $f87d9fed9ae75f45$export$f502975d4e0f97bb.registerJSONType("GLTFMarker");
const $f87d9fed9ae75f45$var$lt = [
    1,
    1,
    1,
    1
], $f87d9fed9ae75f45$var$ut = [], $f87d9fed9ae75f45$var$ft = [], $f87d9fed9ae75f45$var$dt = [
    1,
    1,
    1
], $f87d9fed9ae75f45$var$mt = new (0, $gP1US.Coordinate)(0, 0), $f87d9fed9ae75f45$var$gt = [
    1,
    1,
    1
], $f87d9fed9ae75f45$var$pt = [
    1,
    1,
    1
];
class $f87d9fed9ae75f45$export$78af3bedf0f65998 extends $f87d9fed9ae75f45$export$f502975d4e0f97bb {
    constructor(t, e){
        super(null, e), this.kt = t || [], this.ne = [], this.re = [
            0,
            0,
            0
        ], this.oe = (0, $3iqbd).identity([]), this.l = "multigltfmarker", this.he = [];
    }
    static fromJSON(t) {
        return new $f87d9fed9ae75f45$export$78af3bedf0f65998(t.data, t.options);
    }
    setCoordinates(t) {
        if (!Array.isArray(t)) {
            const e = this.getCenter(), s = t.sub(e);
            for(let t = 0; t < this.kt.length; t++)this.kt[t].coordinates instanceof (0, $gP1US.Coordinate) ? this.kt[t].coordinates = this.kt[t].coordinates.add(s) : (this.kt[t].coordinates[0] += s.x, this.kt[t].coordinates[1] += s.y);
            return this.u = !0, this;
        }
        return Array.isArray(t[0]) ? this.ae = t.map((t)=>new (0, $gP1US.Coordinate)(t)) : this.ae = t, this.updateAllData("coordinates", this.ae), this.u = !0, this;
    }
    getCoordinates(t) {
        if (t && this.kt && this.kt.length) {
            const e = t.index;
            return this.kt[e].coordinates;
        }
        return null;
    }
    addData(t) {
        this.kt || (this.kt = []), this.kt.push(t);
        const e = this.getLayer();
        return e && e.ce(), this.u = !0, this;
    }
    removeData(t) {
        this.kt.splice(t, 1), this.ne && this.ne.splice(t, 1);
        const e = this.getLayer();
        return e && e.ce(), this.u = !0, this;
    }
    getData(t) {
        return this.kt[t];
    }
    updateData(t, e, i) {
        return this.kt[t][e] = i, this.u = !0, this;
    }
    getAllData() {
        return this.kt;
    }
    updateAllData(t, e) {
        for(let i = 0; i < this.kt.length; i++)this.updateData(i, t, e[i]);
        return this;
    }
    removeAllData() {
        this.kt && (this.kt = [], this.ne = [], this.u = !0);
    }
    Lt() {
        const t = this.getMap();
        if (this.kt && t) {
            this.le(), this.ne = this.ne || [];
            for(let t = 0; t < this.kt.length; t++)if (!1 !== this.kt[t].visible) {
                const e = this.ue(t);
                this.ne[t] = e;
            }
        }
    }
    openInfoWindow(t) {
        let e = null;
        e = $f87d9fed9ae75f45$var$O(t) && this.kt[t] ? this.kt[t].coordinates : this.getCenter(), super.openInfoWindow(e);
    }
    getCenter() {
        let t = 0, e = 0, s = 0, n = 0;
        for(let r = 0, o = this.kt.length; r < o; r++){
            let o = this.kt[r].coordinates;
            o instanceof (0, $gP1US.Coordinate) && (o = o.toArray()), t += o[0], e += o[1], s += o[2] || 0, n++;
        }
        if (0 === n) return null;
        return $f87d9fed9ae75f45$var$mt.set(t / n, e / n, s / n);
    }
    getMap() {
        return super.getMap() || this.i && this.i.getMap();
    }
    fe(t) {
        this.i = t;
    }
    getLayer() {
        return super.getLayer() || this.i;
    }
    le() {
        const t = this.getMap(), e = this.getCenter();
        if (!e) return;
        this.re = $f87d9fed9ae75f45$var$T(t, e);
        const i = (0, $k1dpP).fromEuler($f87d9fed9ae75f45$var$ft, 0, 0, 0);
        (0, $3iqbd).fromRotationTranslationScale(this.oe, i, this.re, $f87d9fed9ae75f45$var$dt);
    }
    ue(t) {
        const e = this.kt[t], i = this.Ut(e.coordinates);
        if (!i) return null;
        const s = (0, $eIStk).sub($f87d9fed9ae75f45$var$ut, i, this.re), n = this.Jt(e.translation || this.p.translation), r = (0, $eIStk).add($f87d9fed9ae75f45$var$ut, n || this.p.translation, s || this.p.translation), o = e.rotation || this.p.rotation, h = this.de(t), a = (0, $k1dpP).fromEuler($f87d9fed9ae75f45$var$ft, o[0] || 0, o[1] || 0, o[2] || 0);
        return (0, $3iqbd).fromRotationTranslationScale(this.ne[t] || [], a, r, h);
    }
    de(t) {
        const e = this.kt[t], { modelHeight: i, markerPixelHeight: s } = e, n = e.scale || this.p.scale;
        if (this.lt) {
            if (s && s > 0) {
                const t = this.dt($f87d9fed9ae75f45$var$gt, s);
                return (0, $eIStk).multiply(t, t, n);
            }
            if (i) {
                const t = this.ft($f87d9fed9ae75f45$var$gt, i);
                return (0, $eIStk).multiply(t, t, n);
            }
        }
        return n;
    }
    R(t) {
        if (super.R(t), this.kt) for(let e = 0; e < this.kt.length; e++){
            const i = this.kt[e];
            i.target && i.target instanceof $f87d9fed9ae75f45$export$f502975d4e0f97bb && i.target.R(t);
        }
    }
    _() {
        super._(), this.Lt();
    }
    me() {
        this.ge = {
            "instance_vectorA": [],
            "instance_vectorB": [],
            "instance_vectorC": [],
            "instance_color": [],
            "aPickingId": [],
            "aOutline": [],
            "highlight_color": [],
            "aBloom": []
        }, this.pe = {
            "instance_vectorA": [],
            "instance_vectorB": [],
            "instance_vectorC": [],
            "instance_color": [],
            "aPickingId": [],
            "aOutline": [],
            "highlight_color": [],
            "aBloom": []
        };
        for(let t = 0; t < this.ne.length; t++){
            let e = this.ge;
            this.kt[t].bloom && (e = this.pe);
            const i = this.ne[t], s = e.instance_vectorA.length / 4;
            this._e(e, "instance_vectorA", s, i, 0), this._e(e, "instance_vectorB", s, i, 1), this._e(e, "instance_vectorC", s, i, 2);
            const n = this.kt[t].color || $f87d9fed9ae75f45$var$lt, r = this.kt[t].highlightColor || $f87d9fed9ae75f45$var$lt;
            e.instance_color[4 * s] = n[0], e.instance_color[4 * s + 1] = n[1], e.instance_color[4 * s + 2] = n[2], e.instance_color[4 * s + 3] = n[3], e.aPickingId[s] = this.X() + t, e.aOutline[s] = this.kt[t].outline ? 1 : 0, e.highlight_color[4 * s] = r[0], e.highlight_color[4 * s + 1] = r[1], e.highlight_color[4 * s + 2] = r[2], e.highlight_color[4 * s + 3] = r[3], e.aBloom[s] = this.kt[t].bloom ? 1 : 0;
        }
        return {
            attributesData: this.ge,
            bloomAttributesData: this.pe
        };
    }
    st(t) {
        const { attributesData: e, bloomAttributesData: i } = this.It();
        for(const i in e)t.updateInstancedData(i, e[i]);
        if (this.regl ? t.generateInstancedBuffers(this.regl) : (this.Dt = this.Dt || [], this.Dt.push(t)), t.instanceCount = this.ge.instance_vectorA.length / 4, this.xe()) {
            const e = i, s = e.aBloom.length;
            t.properties.bloomMesh = t.properties.bloomMesh || new (0, $2wazW).InstancedMesh(e, s, t.geometry, t.material);
            const n = t.properties.bloomMesh;
            n.positionMatrix = t.positionMatrix, n.localTransform = t.localTransform;
            for(const t in e)n.updateInstancedData(t, e[t]);
            n.generateInstancedBuffers(this.regl);
            const r = t.getDefines();
            n.setDefines(r), n.uniforms = t.uniforms, n.bloom = 1, n.instanceCount = s;
        } else t.properties.bloomMesh && (t.properties.bloomMesh.dispose(), delete t.properties.bloomMesh);
    }
    ye(t, e, i, s) {
        this.pe[t] && i && (this.pe[t][4 * e] = i[s], this.pe[t][4 * e + 1] = i[s + 4], this.pe[t][4 * e + 2] = i[s + 8], this.pe[t][4 * e + 3] = i[s + 12]);
    }
    xe() {
        return this.pe && this.pe.aBloom.length;
    }
    _e(t, e, i, s, n) {
        t[e] && s && (t[e][4 * i] = s[n], t[e][4 * i + 1] = s[n + 4], t[e][4 * i + 2] = s[n + 8], t[e][4 * i + 3] = s[n + 12]);
    }
    It(t) {
        return !this.u && this.ge ? {
            attributesData: this.ge,
            bloomAttributesData: this.pe
        } : this.me(t);
    }
    it() {
        return this.oe;
    }
    getCount() {
        return this.kt.length;
    }
    ve() {
        return this.Lt(), this.pe ? this.pe.aBloom.length : 0;
    }
    Ft() {
        return this.getCount() - this.ve();
    }
    toJSON() {
        const t = JSON.parse(JSON.stringify({
            data: this.kt,
            options: this.options,
            type: "MultiGLTFMarker"
        })), e = this.getProperties();
        return t.options && (t.options.properties = e), t;
    }
    getIndexByPickingId(t) {
        return t - this.X();
    }
    outline(t) {
        return $f87d9fed9ae75f45$var$O(t) && this.updateData(t, "outline", !0), this;
    }
    cancelOutline(t) {
        return $f87d9fed9ae75f45$var$O(t) && this.updateData(t, "outline", !1), this;
    }
    isOutline() {
        if (!this.kt || !this.kt.length) return !1;
        for(let t = 0; t < this.kt.length; t++)if (this.kt[t].outline) return !0;
        return !1;
    }
    W() {
        const t = this.getAllData();
        for(let e = 0; e < t.length; e++){
            const i = t[e].color;
            if (i && i[3] < 1) return !0;
        }
        return !1;
    }
    highlightNodes(t, e) {
        const i = this.S;
        if (!i) return;
        const s = this.kt[t];
        s && (e.forEach((t)=>{
            i.forEach((e)=>{
                if (e.properties.nodeIndex === t.nodeIndex) {
                    const { color: i, opacity: n, bloom: r } = t;
                    s.highlightColor = i || $f87d9fed9ae75f45$var$pt, s.highlightColor[3] = n || 1, s.highlightBloom = r;
                    const o = e.getDefines();
                    o.HAS_INSTANCE_HIGHLIGHT = 1, e.setDefines(o);
                }
            });
        }), this.u = !0);
    }
    highlight(t, e) {
        const { color: i, opacity: s, bloom: n } = e, r = this.S;
        if (!r) return;
        const o = this.kt[t];
        o && (o.highlightColor = i || $f87d9fed9ae75f45$var$pt, o.highlightColor[3] = s || 1, o.highlightBloom = n, r.forEach((t)=>{
            const e = t.getDefines();
            e.HAS_INSTANCE_HIGHLIGHT = 1, t.setDefines(e);
        }), this.u = !0);
    }
    cancelHighlight(t, e) {
        let i = this.S;
        if (!i) return;
        const s = this.kt[t];
        if (s) {
            if (e) {
                let t = e;
                Array.isArray(t) || (t = [
                    t
                ]), i = i.filter((e)=>t.indexOf(e.properties.nodeIndex) > -1);
            }
            i.forEach((t)=>{
                const e = t.getDefines();
                delete e.HAS_INSTANCE_HIGHLIGHT, t.setDefines(e), s.highlightColor = $f87d9fed9ae75f45$var$pt, s.highlightColor[3] = 1, s.highlightBloom = 0;
            }), this.u = !0;
        }
    }
    zoomAt(t, e = {
        animation: !0,
        zoomOffset: 0
    }, s) {
        const n = this.kt[t];
        if (!n) throw new Error("data item is not exist");
        const r = new (0, $gP1US.Coordinate)(n.coordinates);
        return this.Xt(r, e, s);
    }
}
$f87d9fed9ae75f45$export$78af3bedf0f65998.registerJSONType("MultiGLTFMarker");
const $f87d9fed9ae75f45$var$xt = [], $f87d9fed9ae75f45$var$yt = [], $f87d9fed9ae75f45$var$vt = [
    "points",
    "lines",
    "line strip",
    "line loop"
];
class $f87d9fed9ae75f45$var$wt extends (0, $9e7Ip.MaskRendererMixin)($gP1US.renderer.OverlayLayerCanvasRenderer) {
    constructor(t){
        super(t), this.we = {}, this.be = [], this.Me = {};
    }
    onAdd() {
        super.onAdd(), this.prepareWorker();
    }
    draw(t, e) {
        this.prepareCanvas(), this.Se(e, t);
    }
    drawOnInteracting(t, e, i) {
        this.Se(i, e);
    }
    Se(e, i) {
        this.Oe = e, this.Te = i;
        let s = 0;
        this.Ae(e), this.ke = {}, this.Pe(e);
        const n = this.Ce(e);
        this.Le(i);
        const r = e && e.renderTarget ? e.renderTarget.fbo : null;
        let o = 0;
        for(const i in this.we){
            if ("pointline" === i) continue;
            if (e) {
                const { newShader: s, uniforms: r } = this.Ie(e, i);
                this.we[i].shader = s, $gP1US.Util.extend(n, r);
            }
            const h = this.Fe(i), a = this.we[i].shader;
            a.filter = e && e.sceneFilter || null, o += this.renderer.render(a, n, h, r), s++;
        }
        const h = this.Fe("pointline");
        if (h.getMeshes().length) {
            n.pointSize = this.layer.options.pointSize || 1;
            const t = this.we.pointline.shader;
            t.filter = e && e.sceneFilter || null, o += this.renderer.render(t, n, h, r), s++;
        }
        this.De(n, r), o && this.layer.fire("canvasisdirty", {
            renderCount: o
        }), this.Ge = !0, this.completeRender(), this.layer.fire("rendercomplete-debug", {
            count: s
        });
    }
    De(t, e) {
        this.Ne || (this.Ne = new (0, $2wazW).Scene);
        const i = this.layer.getGeometries(), s = [];
        for(let t = 0; t < i.length; t++){
            if (!i[t].options.showDebugBoundingBox) continue;
            const e = i[t].ot();
            e && s.push(e);
        }
        s.length && (this.Ne.setMeshes(s), this.renderer.render(this.we.wireframe.shader, t, this.Ne, e));
    }
    Ee(t) {
        const e = t.getUniform("polygonFill") || [
            1,
            1,
            1,
            1
        ], i = t.getUniform("polygonOpacity") || 1;
        return e[3] = i, {
            coordinates: t.getCoordinates(),
            translation: t.getTranslation(),
            rotation: t.getRotation(),
            scale: t.getScale(),
            visible: t.isVisible(),
            color: e,
            bloom: t.isBloom(),
            outline: t.isOutline(),
            modelHeight: t.getModelHeight(),
            markerPixelHeight: t.T(),
            anchorZ: t.getAnchorZ(),
            pickingId: t.X(),
            target: t
        };
    }
    Be(t) {
        const e = this.Ee(t), i = new $f87d9fed9ae75f45$export$78af3bedf0f65998([
            e
        ], {
            symbol: {
                url: t.getUrl(),
                shader: t.getShader(),
                shadow: t.isCastShadow()
            }
        });
        return i.Re = i.Re || [], t.je = !0, i.Re.push(t), i.fe(t.getLayer()), i;
    }
    Ue() {
        for(const t in this.Me)this.Me[t].removeAllData();
    }
    ze(e, i) {
        const s = e.getMeshes(this.N, this.regl, i), n = e.getShader();
        if (s.length) {
            this.be.push(e), this.ke[n] = this.ke[n] || [], $gP1US.Util.pushIn(this.ke[n], s);
            for(let t = 0; t < s.length; t++)s[t].properties.bloomMesh && this.ke[n].push(s[t].properties.bloomMesh);
        }
    }
    Le(t) {
        this.be.length = 0;
        const e = this.layer.getGeometries();
        this.Je() && this.Ue();
        for(let i = 0; i < e.length; i++){
            const s = e[i], n = s.getUrl();
            if (s instanceof $f87d9fed9ae75f45$export$78af3bedf0f65998 || s.isAnimated() || !s.je) this.ze(s, t);
            else if (this.Je()) {
                const t = `${n}_${s.getShader()}_${s.isCastShadow() ? 1 : 0}`;
                this.Me[t] ? this.Me[t].addData(this.Ee(s)) : this.Me[t] = this.Be(s);
            }
        }
        for(const e in this.Me){
            const i = this.Me[e];
            i.createdBygltfmarker = !0, this.ze(i, t);
        }
    }
    Ce() {
        const e = {};
        this.He.outSize = [
            this.canvas.width,
            this.canvas.height
        ], this.He.halton = [
            0,
            0
        ];
        const i = this.canvas.gl && this.canvas.gl.wrap ? this.layer.options.opacity || 0 : 1;
        e.layerOpacity = i, $gP1US.Util.extend(e, this.He);
        const s = this.getMaskUniforms();
        return $gP1US.Util.extend(e, s), e;
    }
    Fe(t) {
        const e = [], i = [];
        if ("pointline" === t) {
            for(const t in this.ke){
                if ("wireframe" === t) continue;
                this.ke[t].forEach((t)=>{
                    $f87d9fed9ae75f45$var$vt.indexOf(t.geometry.desc.primitive) > -1 && e.push(t);
                });
            }
            const t = new (0, $2wazW).Scene(e);
            return t.sortMeshes(this.He.cameraPosition), t;
        }
        for(const e in this.ke){
            const s = this.ke[e];
            e === t && s.forEach((e)=>{
                ($f87d9fed9ae75f45$var$vt.indexOf(e.geometry.desc.primitive) < 0 || "wireframe" === t) && i.push(e);
            });
        }
        const s = this.Ve = this.Ve || new (0, $2wazW).Scene;
        return s.setMeshes(i), s.sortMeshes(this.He.cameraPosition), s;
    }
    needToRedraw() {
        return !!super.needToRedraw() || this.Je();
    }
    Je() {
        const t = this.layer.getGeometries();
        for(let e = 0; e < t.length; e++)if (this.be.indexOf(t[e]) > -1 && (t[e].isDirty() || t[e].isAnimated())) return !0;
        return !1;
    }
    onRemove() {
        this.workerConn && (this.workerConn.removeLayer(this.layer.getId(), (t)=>{
            if (t) throw t;
        }), this.workerConn.remove(), delete this.workerConn), super.onRemove();
    }
    hitDetect() {
        return !1;
    }
    createContext() {
        const t = this.canvas.gl && this.canvas.gl.wrap;
        if (t) this.gl = this.canvas.gl.wrap(), this.regl = this.canvas.gl.regl;
        else {
            const t = this.layer.options.glOptions || {
                alpha: !0,
                depth: !0,
                stencil: !0
            };
            this.glOptions = t, this.gl = this.gl || this.Ze(this.canvas, t), this.regl = (0, (/*@__PURE__*/$parcel$interopDefault($9I15V)))({
                gl: this.gl,
                optionalExtensions: [
                    "ANGLE_instanced_arrays",
                    "OES_element_index_uint",
                    "OES_standard_derivatives",
                    "OES_vertex_array_object",
                    "OES_texture_half_float",
                    "OES_texture_half_float_linear",
                    "OES_texture_float",
                    "OES_texture_float_linear",
                    "WEBGL_depth_texture",
                    "EXT_shader_texture_lod",
                    "WEBGL_compressed_texture_s3tc"
                ]
            });
        }
        t && (this.canvas.pickingFBO = this.canvas.pickingFBO || this.regl.framebuffer(this.canvas.width, this.canvas.height)), this.pickingFBO = this.canvas.pickingFBO || this.regl.framebuffer(this.canvas.width, this.canvas.height), this.N = this.regl.gltfManager = this.regl.gltfManager || this.qe(), this.We(), this.Dt && this.Dt.forEach((t)=>{
            t.generateInstancedBuffers(this.regl);
        }), this.Ct && this.Ct.forEach((t)=>{
            t.generateBuffers(this.regl);
        }), this.layer.fire("contextcreate", {
            regl: this.regl
        });
    }
    getGLTFManager() {
        return this.N;
    }
    qe() {
        return new (0, $2wazW).GLTFManager(this.regl);
    }
    We() {
        const t = this.layer.getMap(), e = new (0, $2wazW).Renderer(this.regl);
        this.renderer = e, this.He = {
            "projMatrix": t.projMatrix,
            "projViewMatrix": t.projViewMatrix,
            "viewMatrix": t.viewMatrix,
            "cameraPosition": t.cameraPosition,
            "altitudeScale": 1
        }, (0, $2wazW).pbr.PBRUtils.loginIBLResOnCanvas(this.canvas, this.regl, t), this.Xe = new (0, $2wazW).FBORayPicking(e, {
            vert: "#include <gl2_vert>\n\nattribute vec3 aPosition;\n\nuniform mat4 projMatrix;\n\nuniform mat4 modelMatrix;\n\nuniform mat4 positionMatrix;\n\nuniform mat4 modelViewMatrix;\n\nuniform float pointSize;\n\n#include <fbo_picking_vert>\n\n#include <get_output>\n\nvoid main()\n\n{\n\n    mat4 localPositionMatrix = getPositionMatrix();\n\n    gl_Position = projMatrix * modelViewMatrix * localPositionMatrix * getPosition(aPosition);\n\n    gl_PointSize = pointSize;\n\n    fbo_picking_setData(gl_Position.w, true);\n\n}\n\n",
            uniforms: [
                {
                    name: "modelViewMatrix",
                    type: "function",
                    fn: function(t, e) {
                        return (0, $3iqbd).multiply([], e.viewMatrix, e.modelMatrix);
                    }
                }
            ]
        }, this.pickingFBO, t);
    }
    prepareWorker() {
        this.workerConn || (this.workerConn = new $f87d9fed9ae75f45$var$F("@maptalks/gltf-layer", this.layer));
        const t = this.workerConn;
        if (!t.isActive()) return;
        const e = this.layer.options || {}, i = this.layer.getId();
        t.addLayer(i, {
            markerType: e.markerTypes,
            pointSize: e.pointSize
        }, (t)=>{
            if (t) throw t;
            this.layer && (this.ready = !0, this.layer.fire("workerready"));
        });
    }
    H(t) {
        let e;
        if (this.layer.getURLModifier()) {
            const i = this.layer.options.fetchOptions;
            e = $f87d9fed9ae75f45$var$z(null, t, i, (t)=>{
                const e = this.layer.getURLModifier();
                return e ? e(t) : t;
            });
        } else e = this.workerConn.loadGLTF(t);
        return e.then((t)=>(this.setToRedraw(), this.Ye = !0, t)).catch((e)=>{
            console.error(e), this.layer.fire("modelerror", {
                type: "modelerror",
                url: t,
                info: e
            });
        });
    }
    Pe(t) {
        const e = $f87d9fed9ae75f45$var$L;
        for(const i in e){
            if (this.we[i]) continue;
            const s = e[i];
            this.$e(t, s.name, s.type, s.config);
        }
    }
    $e(e, i, s, n) {
        this.viewport || (this.viewport = {
            x: 0,
            y: 0,
            width: ()=>this.canvas ? this.canvas.width : 1,
            height: ()=>this.canvas ? this.canvas.height : 1
        }), n.extraCommandProps || (n.extraCommandProps = {});
        const r = {};
        e && this.Ke(r, $f87d9fed9ae75f45$var$xt, e);
        const o = $gP1US.Util.extend({}, n);
        o.extraCommandProps = $gP1US.Util.extend({}, n.extraCommandProps), o.extraCommandProps.viewport = this.viewport, o.uniforms = $gP1US.Util.extend([], n.uniforms, $f87d9fed9ae75f45$var$xt), o.defines = $gP1US.Util.extend({}, o.defines, r), s.indexOf(".") > -1 ? (s = s.split("."), this.we[i] = {
            shader: new (0, $2wazW)[s[0]][s[1]](o),
            type: s
        }) : this.we[i] = {
            shader: new (0, $2wazW)[s](o),
            type: s
        };
    }
    remove() {
        this.Qe();
        const t = this.we;
        for(const e in t)t[e].shader.dispose();
        this.extentShader && this.extentShader.dispose(), super.remove();
    }
    clearCanvas() {
        this.canvas && (this.regl.clear({
            color: [
                0,
                0,
                0,
                0
            ],
            depth: 1,
            stencil: 0
        }), super.clearCanvas());
    }
    resizeCanvas(t) {
        super.resizeCanvas(t), this.pickingFBO && this.pickingFBO.resize(this.canvas.width, this.canvas.height), this.layer.fire("resizecanvas", {
            size: t
        });
    }
    getFrameTimestamp() {
        return this.Te;
    }
    getFrameContext() {
        return this.Oe;
    }
    needRetireFrames() {
        return this.Ye;
    }
    Ke(e, i, s) {
        const n = s && s.includes;
        if (n) for(const r in n)n[r] && (s[r].uniformDeclares && (i.length = 0, i.push(...s[r].uniformDeclares)), s[r].defines && $gP1US.Util.extend(e, s[r].defines));
    }
    ti(e, i) {
        const s = i && i.includes;
        if (s) for(const n in s)s[n] && i[n].renderUniforms && $gP1US.Util.extend(e, i[n].renderUniforms);
    }
    Ie(e, i) {
        const { shader: s, type: n } = this.we[i];
        let r = null;
        const o = {};
        if (this.ti(o, e), e.states.includesChanged) {
            const i = {};
            this.Ke(i, $f87d9fed9ae75f45$var$xt, e);
            const o = {
                vert: s.vert,
                frag: s.frag,
                uniforms: s.uniforms,
                extraCommandProps: s.extraCommandProps
            };
            o.defines = i, o.uniforms = $gP1US.Util.extend([], o.uniforms, $f87d9fed9ae75f45$var$xt), r = Array.isArray(n) ? new (0, $2wazW)[n[0]][n[1]](o) : new (0, $2wazW)[n](o), s.dispose();
        } else r = s;
        return {
            uniforms: o,
            newShader: r
        };
    }
    ei(e, i, s) {
        if (e.viewshed) {
            for(const t in e.viewshed.renderUniforms)s[t] = e.viewshed.renderUniforms[t];
            $gP1US.Util.extend(i.shaderDefines, e.viewshed.defines);
        }
        if (e.floodAnalysis) {
            for(const t in e.floodAnalysis.renderUniforms)s[t] = e.floodAnalysis.renderUniforms[t];
            $gP1US.Util.extend(i.shaderDefines, e.floodAnalysis.defines);
        }
        return s;
    }
    getShadowMeshes() {
        const e = [];
        if (!this.layer || !this.layer.isVisible() || !this.ke) return e;
        const i = this.layer.getGeometries();
        for(let s = 0; s < i.length; s++)if (i[s].isCastShadow() && i[s].isVisible() && i[s].M() && !i[s].je) {
            const n = i[s].S || [];
            $gP1US.Util.pushIn(e, n);
        }
        for(const i in this.Me){
            const s = this.Me[i];
            if (s.isCastShadow() && s.isVisible() && s.M()) {
                const i = s.S || [];
                $gP1US.Util.pushIn(e, i);
            }
        }
        return e;
    }
    ii() {
        const e = [];
        if (!this.ke || !Object.keys(this.ke).length) return e;
        for(const i in this.ke)$gP1US.Util.pushIn(e, this.ke[i]);
        return e;
    }
    getAnalysisMeshes() {
        return this.ii();
    }
    getRayCastData(t) {
        const e = this.layer.getGeometries();
        for(let i = 0; i < e.length; i++){
            const s = e[i].S;
            if (s && s.indexOf(t) > -1) return e[i];
        }
        return null;
    }
    drawOutline(t) {
        this.extentShader || (this.extentShader = new (0, $2wazW).MeshShader({
            vert: "attribute vec3 aPosition;\n\nattribute float aOutline;\n\nuniform mat4 projMatrix;\n\nuniform mat4 modelMatrix;\n\nuniform mat4 modelViewMatrix;\n\nuniform mat4 positionMatrix;\n\nuniform float instance;\n\n#include <get_output>\n\n\n\nvarying float vOutline;\n\nvoid main()\n\n{\n\n    mat4 localPositionMatrix = getPositionMatrix();\n\n    gl_Position = projMatrix * modelViewMatrix * localPositionMatrix * getPosition(aPosition);\n\n    if (instance == 0.0) {\n\n        vOutline = 1.0;\n\n    } else {\n\n        vOutline = aOutline;\n\n    }\n\n}\n\n",
            frag: "precision highp float;\n\nvarying float vOutline;\n\nvoid main() {\n\n    gl_FragColor = vec4(vOutline);\n\n}\n\n",
            uniforms: [
                {
                    name: "modelViewMatrix",
                    type: "function",
                    fn: (t, e)=>(0, $3iqbd).multiply([], e.viewMatrix, e.modelMatrix)
                }
            ],
            positionAttribute: "POSITION",
            extraCommandProps: {
                viewport: this.viewport,
                cull: {
                    enable: !1
                },
                blend: {
                    enable: !0,
                    func: {
                        src: "src alpha",
                        dst: "one minus src alpha"
                    },
                    equation: "add"
                }
            }
        }));
        const e = this.getOutlineMeshes();
        e.length && (this.si = this.si || new (0, $2wazW).Scene, this.si.setMeshes(e), this.renderer.render(this.extentShader, {
            "projMatrix": this.He.projMatrix,
            "viewMatrix": this.He.viewMatrix
        }, this.si, t));
    }
    getOutlineMeshes() {
        const e = [];
        if (!this.layer) return e;
        const i = this.layer.getGeometries();
        for(let s = 0; s < i.length; s++){
            if (i[s].je) continue;
            const n = i[s].Qt();
            $gP1US.Util.pushIn(e, n);
        }
        for(const i in this.Me){
            const s = this.Me[i].Qt();
            $gP1US.Util.pushIn(e, s);
        }
        return e;
    }
    Qe() {
        this.canvas && (0, $2wazW).pbr.PBRUtils.logoutIBLResOnCanvas(this.canvas, this.getMap());
    }
    Ae(e) {
        const i = this.layer.getMap(), { iblTexes: s, dfgLUT: n } = (0, $2wazW).pbr.PBRUtils.getIBLResOnCanvas(this.canvas);
        if (i && i.getLights()) {
            const r = (0, $2wazW).pbr.PBRUtils.getPBRUniforms(i, s, n, e && e.ssr, e && e.jitter), o = i.getLights(), h = o.ambient && o.ambient.color ? o.ambient.color : [
                .2,
                .2,
                .2
            ];
            this.He.ambientColor = h, r && $gP1US.Util.extend(this.He, r);
        } else {
            const s = (0, $2wazW).pbr.PBRUtils.getPBRUniforms(i, null, n, e && e.ssr, e && e.jitter);
            $gP1US.Util.extend(this.He, s);
        }
    }
    Ze(t, e) {
        const i = [
            "webgl",
            "experimental-webgl"
        ];
        let s = null;
        for(let n = 0; n < i.length; ++n){
            try {
                s = t.getContext(i[n], e);
            } catch (t) {}
            if (s) break;
        }
        return s;
    }
    ni(e, i, s = {}) {
        if (!this.Xe || !this.layer.isVisible()) return null;
        const n = this.layer.getMap(), r = this.canvas.gl && this.canvas.gl.wrap;
        if (this.Ge || r) {
            if (!this.ke || !Object.keys(this.ke).length) return null;
            const e = this.ii(), i = $gP1US.Util.extend({}, this.He);
            i.pointSize = this.layer.options.pointSize || 1, this.Xe.render(e, i, !0), this.Ge = !1;
        }
        const o = s.returnAll ? "pickAll" : "pick", h = this.Xe[o](e, i, s.tolerance || 3, {
            "projMatrix": n.projMatrix,
            "viewMatrix": n.viewMatrix,
            "pointSize": this.layer.options.pointSize || 1
        }, {
            viewMatrix: n.viewMatrix,
            projMatrix: n.projMatrix,
            returnPoint: !0
        });
        if (h.length) {
            const t = {}, e = [];
            for(let i = 0; i < h.length; i++)if (!t[h[i].pickingId]) {
                const s = this.ri(h[i]);
                t[h[i].pickingId] = !0, e.push(s);
            }
            return e;
        }
        return this.ri(h);
    }
    ri(t) {
        const { meshId: e, pickingId: i, point: s, coordinate: n } = t, r = this.ii()[e], o = this.oi(i);
        return {
            meshId: e,
            mesh: r,
            data: this.layer.hi()[o],
            pickingId: i,
            point: s,
            coordinate: n,
            index: i - o,
            nodeIndex: this.ai(e)
        };
    }
    ai(t) {
        const e = this.ii()[t];
        return e && e.properties.nodeIndex;
    }
    oi(t) {
        if (!$f87d9fed9ae75f45$var$O(t)) return null;
        if (this.layer.hi()[t]) return t;
        const e = Object.keys(this.layer.hi()), i = e.length;
        let s = 0, n = i - 1, r = Math.floor((s + n) / 2);
        for(; s <= i - 1 && n >= 0;){
            if (s === n) return e[s];
            if (e[r] <= t && t < e[r + 1]) return e[r];
            t < e[r] ? (n = r - 1, r = Math.floor((s + n) / 2)) : e[r + 1] < t && (s = r + 1, r = Math.floor((s + n) / 2));
        }
        return null;
    }
    isInFrustum(t) {
        const e = this.layer.getMap(), i = t.getBoundingBox();
        if (!i || "multigltfmarker" === t.getGLTFMarkerType()) return !0;
        const s = (0, $6BoVD).set($f87d9fed9ae75f45$var$yt, i.min, i.max);
        return !!(0, $9b5be2c4f6c5fa19$export$25ea4bdae27a952b)(e.projViewMatrix, s);
    }
    getRenderMeshesTest() {
        return this.ii();
    }
    isMarkerTransparent(t) {
        return t.W();
    }
    getMarkerFitSizeScale(t) {
        return t.ci();
    }
    getMarkerFitTranslate(t) {
        return t.li();
    }
    getFBORayPicking() {
        return this.Xe;
    }
    getShaderList() {
        return this.we;
    }
}
const $f87d9fed9ae75f45$var$bt = /\{ *([\w_]+) *\}/g;
class $f87d9fed9ae75f45$export$bceb52c6dc7707e8 extends $f87d9fed9ae75f45$export$f502975d4e0f97bb {
    constructor(t, e){
        super(t, e), this.l = "effectmarker";
    }
    static fromJSON(t) {
        return new $f87d9fed9ae75f45$export$bceb52c6dc7707e8(t.coordinates, t.options);
    }
    isAnimated() {
        const t = this._getInternalSymbol();
        return t && t.animation;
    }
    setTexture(t) {
        const e = this.getLayer() && this.getLayer().getRenderer();
        if (e) {
            const i = this.getTextureUrl();
            e.ui(i), e.fi(t);
        }
        return super.updateSymbol({
            textureUrl: t
        }), this;
    }
    di(t) {
        const e = this.getTextureUrl(), i = this.getLayer() && this.getLayer().getRenderer();
        if (i) {
            let s = e;
            const n = this.mi();
            if (n) {
                const i = this.isAnimationLooped(), r = this.getAnimationSpeed() || 1, o = i ? Math.floor(.01 * t * r) % n.length : Math.floor(.01 * t);
                s = e.replace($f87d9fed9ae75f45$var$bt, n[o]), this.setUniform("width", 1), this.setUniform("height", 1), this.setUniform("uvOffset", [
                    0,
                    0
                ]);
            }
            return i.gi(s, this.X());
        }
        return null;
    }
    mi() {
        const t = this._getInternalSymbol();
        return t && t.textureNames;
    }
    getTextureUrl() {
        const t = this._getInternalSymbol();
        return t && t.textureUrl || "default";
    }
    getUrl() {
        return "plane";
    }
    getShader() {
        return "effect";
    }
    setTransparent(t) {
        return this.options.symbol.transparent = t, this;
    }
    isTransparent() {
        return this.options.symbol.transparent;
    }
    updateUV(t) {
        const e = this.isAnimationLooped(), i = this.getAnimationSpeed() || 1, s = this.getUniforms() || {}, n = s.width || 1, r = s.height || 1;
        let o;
        const h = this.getEffectType();
        "uv" === h ? o = e ? .01 * t * i % (n * r) : .01 * t : "sequence" === h && (o = e ? Math.floor(.01 * t * i) % (n * r) : Math.floor(.01 * t));
        const a = Number(o % n), c = Math.floor(o / n), l = this.di(t);
        this._getSymbol() ? (this.setUniform("uvOffset", [
            a,
            c
        ]), this.setUniform("width", n), this.setUniform("height", r), this.setUniform("texture", l)) : this.D("uniforms", {
            uvOffset: [
                a,
                c
            ],
            width: n,
            height: r,
            texture: l
        });
    }
    _setExternSymbol(t) {
        super._setExternSymbol(t);
        const e = this.getLayer() && this.getLayer().getRenderer();
        if (e) {
            const t = this.getTextureUrl();
            e.fi(t);
        }
    }
    getEffectType() {
        const t = this._getInternalSymbol();
        return t && t.effect || "uv";
    }
    setEffectType(t) {
        return this._getInternalSymbol().effect = t, this;
    }
    remove() {
        const t = this.getLayer() && this.getLayer().getRenderer();
        if (t) {
            const e = this.getTextureUrl();
            t.ui(e);
        }
        super.remove();
    }
}
const $f87d9fed9ae75f45$var$St = [
    "Point",
    "Polygon",
    "LineString",
    "MultiPoint",
    "MultiPolygon",
    "MultiLineString",
    "GeometryCollection",
    "Feature",
    "FeatureCollection"
].reduce((t, e)=>(t[e] = !0, t), {}), $f87d9fed9ae75f45$var$Ot = {
    toGeometry: function(t, i) {
        if ((0, $gP1US.Util).isString(t) && (t = (0, $gP1US.Util).parseJSON(t)), Array.isArray(t)) {
            const s = [];
            for(let n = 0, r = t.length; n < r; n++){
                const r = $f87d9fed9ae75f45$var$Ot.pi(t[n], i);
                Array.isArray(r) ? (0, $gP1US.Util).pushIn(s, r) : s.push(r);
            }
            return s;
        }
        return $f87d9fed9ae75f45$var$Ot.pi(t, i);
    },
    pi: function(t, i) {
        if (!t || (0, $gP1US.Util).isNil(t.type)) return null;
        const s = t.type;
        if ("Feature" === s) {
            const e = t.geometry, s = $f87d9fed9ae75f45$var$Ot.pi(e, i);
            return s ? (s.setId(t.id), s.setProperties(t.properties), s) : null;
        }
        if ("FeatureCollection" === s) {
            const e = t.features;
            if (!e) return null;
            return $f87d9fed9ae75f45$var$Ot.toGeometry(e, i);
        }
        if ("Point" === s) return function(t, e) {
            if ("EffectLayer" === e) return new $f87d9fed9ae75f45$export$bceb52c6dc7707e8(t);
            return new $f87d9fed9ae75f45$export$f502975d4e0f97bb(t);
        }(t.coordinates, i);
        if ("GeometryCollection" === s) {
            const e = t.geometries, s = [], n = e.length;
            for(let t = 0; t < n; t++)s.push($f87d9fed9ae75f45$var$Ot.pi(e[t], i));
            return s;
        }
        throw new Error("geometry's type is invalid, only support type of Point");
    },
    isGeoJSON: function(t) {
        return !(!t || "object" != typeof t) && !!t.type && !!$f87d9fed9ae75f45$var$St[t.type] && !(t instanceof (0, $gP1US.Geometry));
    }
};
const $f87d9fed9ae75f45$var$Tt = /\{*(\$root)*\}/g;
class $f87d9fed9ae75f45$var$At extends $gP1US.OverlayLayer {
    constructor(e, i, s){
        !i || i instanceof $gP1US.Geometry || Array.isArray(i) || $f87d9fed9ae75f45$var$St[i.type] || (s = i, i = null), super(e, null, s), this.pickingId = 0, this._i = {}, this.xi = {}, this.yi = {};
        const n = s && s.style;
        this.setStyle(n), i && this.addGeometry(i);
    }
    static registerShader(t, e, i, s) {
        $f87d9fed9ae75f45$var$L[t] = {
            name: t,
            type: e,
            config: i,
            uniforms: s
        };
    }
    static removeShader(t) {
        delete $f87d9fed9ae75f45$var$L[t];
    }
    static getShaders() {
        const t = [];
        for(const e in $f87d9fed9ae75f45$var$L)t.push({
            shader: e,
            uniforms: $f87d9fed9ae75f45$var$L[e].uniforms
        });
        return t;
    }
    static getShaderMap() {
        return $f87d9fed9ae75f45$var$L;
    }
    addGeometry(t, e) {
        let i = $f87d9fed9ae75f45$var$Ot.isGeoJSON(t) ? $f87d9fed9ae75f45$var$Ot.toGeometry(t, this.getJSONType()) : t;
        i = Array.isArray(i) ? i : [
            i
        ];
        for(let t = 0; t < i.length; t++)if (!this.vi(i[t])) return void console.error("type of geometry is invalid");
        super.addGeometry(i, e), Array.isArray(i) && this.addMarker(i);
    }
    addMarker(t) {
        for(let e = 0; e < t.length; e++){
            const i = t[e];
            i.qt(this.pickingId), this._i[this.pickingId] = i;
            const s = i.getId();
            s && (this.yi[s] = i), i.fire("add", {
                type: "add",
                target: i,
                layer: this
            });
            const n = i.getUrl(), r = this.getRenderer();
            if (r && r.Me[n]) {
                const t = r.Me[n];
                i.fire("load", {
                    type: "load",
                    target: i,
                    data: t.I()
                });
            }
            if ("multigltfmarker" === i.getGLTFMarkerType()) {
                const t = i.getCount() || 1;
                this.pickingId += t;
            } else this.pickingId++;
        }
    }
    wi(t) {
        const e = this.getRenderer();
        e && e.loginGLTFMarker(t);
    }
    toJSON(t) {
        t || (t = {});
        const e = {
            "type": this.getJSONType(),
            "id": this.getId(),
            "options": this.config()
        };
        if (($f87d9fed9ae75f45$var$S(t.style) || t.style) && (e.style = this.getStyle()), $f87d9fed9ae75f45$var$S(t.geometries) || t.geometries) {
            const t = [], i = this._geoList;
            for(let e = 0; e < i.length; e++){
                const s = i[e].Zt();
                t.push(s);
            }
            e.geometries = t;
        }
        return e;
    }
    vi(t) {
        if (!t.getGLTFMarkerType) return !1;
        return this.options.markerTypes.indexOf(t.getGLTFMarkerType()) > -1;
    }
    setStyle(t) {
        return t ? (this.options.style = t, this.bi = JSON.parse(JSON.stringify(t)), this.Mi(), this.fire("setstyle", {
            target: this,
            style: this.bi
        }), this) : (delete this.bi, delete this.options.style, this);
    }
    getStyle() {
        return this.options.style;
    }
    updateSymbol(t, e) {
        const i = this.getStyle();
        this.Si(t, e, i), this.Si(t, e, this.bi), this.Mi(), this.fire("updatesymbol", {
            target: this,
            index: t,
            symbol: e
        });
    }
    Si(t, e, i) {
        if (!i) return;
        const s = (i.style ? i.style : i)[t].symbol || {};
        for(const t in e)s[t] = e[t];
    }
    Mi() {
        this._processRootUrl(this.bi);
        const t = this.bi.style ? this.bi.style : this.bi;
        this.Oi = (0, $b541c4b531a4f326$export$fe74925a79db722)(t);
        this._geoList.forEach(function(t) {
            this.Ti(t);
        }, this);
    }
    getGLTFUrls() {
        return Object.keys(this.xi);
    }
    _processRootUrl(e) {
        $gP1US.Util.isString(e.$root) && e.style.forEach((t)=>{
            const i = t.symbol.url;
            i && i.indexOf("{$root}") > -1 && (t.symbol.url = i.replace($f87d9fed9ae75f45$var$Tt, e.$root));
        });
    }
    Ti(t) {
        if (!this.Oi) return !1;
        for(let e = 0, i = this.Oi.length; e < i; e++)if (!0 === this.Oi[e].filter({
            properties: t.getProperties()
        })) {
            const i = this.Oi[e].symbol, s = i.url;
            return t.D("url", s), t.updateSymbol(i), !0;
        }
        return !1;
    }
    Ai(t) {
        if (this.Oi) for(let e = 0, i = this.Oi.length; e < i; e++)!0 === this.Oi[e].filter({
            properties: t.getProperties()
        }) && this.Oi[e].outline && t.outline();
    }
    ki(e) {
        const i = $gP1US.Util.isString(e) ? this.yi[e].X() : e.X(), s = this.getRenderer();
        s && s.Pi(i), delete this._i[i], delete this.yi[e];
    }
    clear() {
        return super.clear(), this._i = {}, this.yi = {}, this;
    }
    hi() {
        return this._i;
    }
    ni(t, e, i) {
        const s = this.getRenderer();
        return s ? s.ni(t, e, i) : null;
    }
    _isModelsLoadComplete() {
        const t = this._geoList;
        for(let e = 0; e < t.length; e++)if (!t[e].isLoaded()) return !1;
        return !0;
    }
    Nt(t) {
        const e = this.getRenderer();
        return e ? e.Nt(t) : null;
    }
    U(t) {
        const e = this.getRenderer();
        e && e.U(t);
    }
    outlineBatch(t) {
        const e = this.bi.style ? this.bi.style : this.bi;
        e[t].outline = !0, this.Oi = (0, $b541c4b531a4f326$export$fe74925a79db722)(e);
        this._geoList.forEach((t)=>{
            this.Ai(t);
        });
    }
    outlineAll() {
        this._geoList.forEach((t)=>{
            t.outline();
        });
    }
    cancelOutline() {
        if (this.bi) (this.bi.style ? this.bi.style : this.bi).forEach((t)=>{
            delete t.outline;
        });
        this._geoList.forEach((t)=>{
            t.cancelOutline();
        });
    }
}
$f87d9fed9ae75f45$var$At.mergeOptions({
    "renderer": "gl",
    "doubleBuffer": !1,
    "glOptions": null,
    "markerEvents": !0,
    "forceRenderOnZooming": !0,
    "forceRenderOnMoving": !0,
    "forceRenderOnRotating": !0
});
class $f87d9fed9ae75f45$export$444d0e1ec10e51d5 extends (0, $9e7Ip.MaskLayerMixin)($f87d9fed9ae75f45$var$At) {
    static initDefaultShader() {
        const t = function() {
            const t = {
                positionAttribute: "POSITION",
                normalAttribute: "NORMAL",
                extraCommandProps: {
                    blend: {
                        enable: !0,
                        func: {
                            src: "src alpha",
                            dst: "one minus src alpha"
                        },
                        equation: "add"
                    }
                }
            }, e = new (0, $2wazW).PhongMaterial;
            return {
                shader: t,
                material: e
            };
        }();
        $f87d9fed9ae75f45$export$444d0e1ec10e51d5.registerShader("phong", "PhongShader", t.shader, t.material.getUniforms());
        const e = function() {
            const t = {
                positionAttribute: "POSITION",
                normalAttribute: "NORMAL",
                tangentAttribute: "TANGENT",
                colorAttribute: "COLOR_0",
                uv0Attribute: "TEXCOORD_0",
                uv1Attribute: "TEXCOORD_1",
                extraCommandProps: {
                    cull: {
                        enable: !0
                    },
                    frontFace: "ccw",
                    blend: {
                        enable: (t, e)=>!!e.meshConfig.transparent,
                        func: {
                            srcRGB: "src alpha",
                            srcAlpha: 1,
                            dstRGB: "one minus src alpha",
                            dstAlpha: "one minus src alpha"
                        },
                        equation: "add"
                    }
                }
            }, e = new (0, $2wazW).pbr.StandardMaterial({});
            return {
                shader: t,
                material: e
            };
        }();
        $f87d9fed9ae75f45$export$444d0e1ec10e51d5.registerShader("pbr", "pbr.StandardShader", e.shader, e.material.getUniforms()), $f87d9fed9ae75f45$export$444d0e1ec10e51d5.registerShader("depth", "pbr.StandardDepthShader", e.shader, e.material.getUniforms());
        const i = function() {
            const t = {
                positionAttribute: "POSITION",
                color0Attribute: "COLOR_0",
                extraCommandProps: {
                    blend: {
                        enable: !1,
                        func: {
                            src: "src alpha",
                            dst: "one minus src alpha"
                        },
                        equation: "add"
                    }
                }
            }, e = new (0, $2wazW).Material;
            return {
                shader: t,
                material: e
            };
        }();
        $f87d9fed9ae75f45$export$444d0e1ec10e51d5.registerShader("pointline", "PointLineShader", i.shader, i.material.getUniforms());
        const s = function() {
            const t = {
                positionAttribute: "POSITION",
                extraCommandProps: {
                    blend: {
                        enable: !0,
                        func: {
                            srcRGB: "src alpha",
                            srcAlpha: 1,
                            dstRGB: "one minus src alpha",
                            dstAlpha: "one minus src alpha"
                        },
                        equation: "add"
                    }
                }
            }, e = new (0, $2wazW).Material({
                lineColor: [
                    0,
                    0,
                    0,
                    1
                ],
                lineOpacity: 1
            });
            return {
                shader: t,
                material: e
            };
        }();
        $f87d9fed9ae75f45$export$444d0e1ec10e51d5.registerShader("wireframe", "EdgeShader", s.shader, s.material.getUniforms());
        const n = function() {
            const t = {
                positionAttribute: "POSITION",
                normalAttribute: "NORMAL",
                extraCommandProps: {
                    blend: {
                        enable: !0,
                        func: {
                            src: "src alpha",
                            dst: "one minus src alpha"
                        },
                        equation: "add"
                    }
                }
            }, e = new (0, $2wazW).StandardLiteMaterial;
            return {
                shader: t,
                material: e
            };
        }();
        $f87d9fed9ae75f45$export$444d0e1ec10e51d5.registerShader("pbr-lite", "StandardLiteShader", n.shader, n.material.getUniforms());
    }
    static fromJSON(t) {
        if (!t || "GLTFLayer" !== t.type) return null;
        const e = new $f87d9fed9ae75f45$export$444d0e1ec10e51d5(t.id, t.options), i = t.geometries, s = [];
        for(let t = 0; t < i.length; t++){
            const e = i[t].type, n = $f87d9fed9ae75f45$export$f502975d4e0f97bb.getJSONClass(e);
            if (!n || !n.fromJSON) throw new Error("unsupported gltfmarker type:" + e);
            const r = n.fromJSON(i[t]);
            r && s.push(r);
        }
        return e.addGeometry(s), t.style && e.setStyle(t.style), e;
    }
    setURLModifier(t) {
        return this.Ci = t, this;
    }
    getURLModifier() {
        return this.Ci;
    }
    onAdd() {
        const t = this.getMap();
        this._geoList.forEach((e)=>{
            $f87d9fed9ae75f45$var$O(e.getZoomOnAdded()) || e.setZoomOnAdded(t.getZoom());
        }), super.onAdd();
    }
    onRemove() {
        super.onRemove(), this.clear();
    }
    identify(e, i) {
        const s = this.getMap();
        if (!s) return [];
        const n = s.coordinateToContainerPoint(new $gP1US.Coordinate(e));
        return this.identifyAtPoint(n, i);
    }
    identifyAtPoint(e, i = {}) {
        const s = [];
        if (!i.excludeMasks) {
            const n = this.identifyMask(e, i);
            n && n.length && $gP1US.Util.pushIn(s, n);
        }
        const n = this.getMap();
        if (!n) return [];
        const r = n.getDevicePixelRatio(), o = e.x * r, h = e.y * r, a = this.ni(o, h, i);
        if (a && (a.data || a.length)) {
            if (i.includeInternals && !i.excludeMasks) {
                s.push(a.data);
                const t = i.domEvent;
                t && (t.gltfPickingInfo = t.gltfPickingInfo || {}, t.gltfPickingInfo[this.getId()] = a);
            } else s.push(a);
        }
        return i && i.filter && !i.excludeMasks ? s.filter((t)=>i.filter(t.data || t)) : s;
    }
    ce() {
        this.pickingId = 0;
        const t = {};
        for(const e in this._i){
            const i = this._i[e];
            i.qt(this.pickingId), i.C(!0), t[this.pickingId] = i;
            const s = i.getCount() || 1;
            this.pickingId += s;
        }
        this._i = t;
    }
    _onGeometryEvent(t) {
        if (!t || !t.target) return;
        const e = t.type;
        if ("meshcreate" === e) this.Li(t);
        else if ("modelerror" === e) this.Ii(t);
        else if ("positionchange" === e) {
            const t = this.getRenderer();
            t && t.setToRedraw();
        }
        super._onGeometryEvent(t);
    }
    Ii(t) {
        const { url: e, info: i } = t;
        console.error(i), this.fire("modelerror", {
            type: "modelerror",
            url: e,
            info: i
        });
    }
    Li(t) {
        const e = t.url;
        this.xi[e] = 1, this.getRenderer().setToRedraw(), this._isModelsLoadComplete() && this.fire("modelload", {
            models: this.getGLTFUrls()
        });
    }
}
$f87d9fed9ae75f45$export$444d0e1ec10e51d5.initDefaultShader(), $f87d9fed9ae75f45$export$444d0e1ec10e51d5.mergeOptions({
    markerTypes: [
        "gltfmarker",
        "multigltfmarker"
    ],
    pointSize: 1
}), $f87d9fed9ae75f45$export$444d0e1ec10e51d5.registerJSONType("GLTFLayer"), $f87d9fed9ae75f45$export$444d0e1ec10e51d5.registerRenderer("gl", $f87d9fed9ae75f45$var$wt);
class $f87d9fed9ae75f45$export$5de0546b9ecaf154 extends $f87d9fed9ae75f45$export$f502975d4e0f97bb {
    tt(t) {
        const e = this.getMap(), i = e.getGLRes(), s = e.distanceToPointAtRes(100, 100, i, this.getCenter()), n = e.altitudeToPoint(100, i);
        return t[0] *= s.x / 100, t[1] *= s.y / 100, t[2] *= n / 100, t;
    }
}
const $f87d9fed9ae75f45$var$Ct = new (0, $gP1US.Coordinate)(0, 0), $f87d9fed9ae75f45$var$Lt = new (0, $gP1US.Point)(0, 0), $f87d9fed9ae75f45$var$It = new (0, $gP1US.Point)(0, 0), $f87d9fed9ae75f45$var$Ft = new (0, $gP1US.Point)(0, 0);
class $f87d9fed9ae75f45$export$d848cd550b0129fa extends $f87d9fed9ae75f45$export$f502975d4e0f97bb {
    tt(t) {
        const e = this.getMap(), i = e.getGLRes(), s = this.getCoordinates(), n = e.coordToPointAtRes(s, i, $f87d9fed9ae75f45$var$It), r = (0, $gP1US.projection).EPSG3857.project(s, $f87d9fed9ae75f45$var$Ct)._add(1, 1), o = (0, $gP1US.projection).EPSG3857.unproject(r, $f87d9fed9ae75f45$var$Lt), h = e.coordToPointAtRes(o, i, $f87d9fed9ae75f45$var$Ft), c = h.x - n.x, l = h.y - n.y, u = e.altitudeToPoint(100, i);
        return t[0] *= c, t[1] *= l, t[2] *= u / 100, t;
    }
}
const $f87d9fed9ae75f45$var$Gt = new (0, $gP1US.Coordinate)(0, 0), $f87d9fed9ae75f45$var$Nt = [], $f87d9fed9ae75f45$var$Et = new (0, $gP1US.Point)(0, 0), $f87d9fed9ae75f45$var$Bt = new (0, $gP1US.Point)(0, 0);
class $f87d9fed9ae75f45$export$c01f78c6719f5d29 extends $f87d9fed9ae75f45$export$78af3bedf0f65998 {
    constructor(t, e){
        super(null, e), this.on("load", ()=>{
            this.setCoordinates(t);
        });
    }
    static fromJSON(t) {
        return new $f87d9fed9ae75f45$export$c01f78c6719f5d29(t.data, t.options);
    }
    setCoordinates(t) {
        this.ae = t, this.Fi();
    }
    getCoordinates() {
        return this.ae;
    }
    toJSON() {
        const t = JSON.parse(JSON.stringify({
            coordinates: this.ae,
            options: this.options,
            type: "GLTFLineString"
        })), i = this.getId();
        (0, $gP1US.Util).isNil(i) || (t.options.id = i);
        const s = this.getProperties();
        return t.options && (t.options.properties = s), t;
    }
    Fi() {
        const t = this.ae;
        if (!t) return;
        this.removeAllData();
        const e = this.getMap(), i = e.getGLRes(), s = e.getProjection(), n = this.Di();
        for(let r = 0; r < t.length - 1; r++){
            const o = this.Gi(t[r]), h = this.Gi(t[r + 1]), a = e.coordinateToPointAtRes(o, i, $f87d9fed9ae75f45$var$Et), c = e.coordinateToPointAtRes(h, i, $f87d9fed9ae75f45$var$Bt), l = this.Ni(o, h), u = s.measureLenBetween(o, h);
            this.gltfPack.arrangeAlongLine(a, c, u, n, l, this.options).forEach((t)=>{
                t.coordinates = $f87d9fed9ae75f45$var$jt(o, h, t.t), this.addData(t);
            });
        }
        this.u = !0;
    }
    Di() {
        const t = [
            1,
            1,
            1
        ], i = this.getModelHeight();
        i && this.ft(t, i);
        const s = this.getSymbol();
        return (0, $eIStk).set($f87d9fed9ae75f45$var$Nt, (0, $gP1US.Util).isNil(s.scaleX) ? 1 : s.scaleX, (0, $gP1US.Util).isNil(s.scaleY) ? 1 : s.scaleY, (0, $gP1US.Util).isNil(s.scaleZ) ? 1 : s.scaleZ), (0, $eIStk).multiply(t, t, $f87d9fed9ae75f45$var$Nt);
    }
    Ni(t, e) {
        const i = this.getMap(), s = i.getGLRes();
        $f87d9fed9ae75f45$var$Gt.set(0, (t.y + e.y) / 2);
        return i.altitudeToPoint(100, s, $f87d9fed9ae75f45$var$Gt) / i.altitudeToPoint(100, s);
    }
    Gi(t) {
        return Array.isArray(t) ? new (0, $gP1US.Coordinate)(t) : t;
    }
}
function $f87d9fed9ae75f45$var$jt(t, e, i) {
    const s = $f87d9fed9ae75f45$var$Ut(t.x, e.x, i), n = $f87d9fed9ae75f45$var$Ut(t.y, e.y, i), r = $f87d9fed9ae75f45$var$Ut(t.z || 0, e.z || 0, i);
    return new t.constructor(s, n, r);
}
function $f87d9fed9ae75f45$var$Ut(t, e, i) {
    return t + i * (e - t);
}
$f87d9fed9ae75f45$export$c01f78c6719f5d29.mergeOptions({
    direction: 0,
    gapLength: 0,
    scaleVertex: !0
}), $f87d9fed9ae75f45$export$c01f78c6719f5d29.registerJSONType("GLTFLineString");
const $f87d9fed9ae75f45$var$zt = new (0, $2wazW).Texture2D({
    url: void 0,
    mag: "linear"
});
class $f87d9fed9ae75f45$var$Jt extends $f87d9fed9ae75f45$var$wt {
    constructor(t){
        super(t), this._textureMap = {};
    }
    gi(t) {
        return this.regl && this._textureMap[t] ? this._textureMap[t].texture.getREGLTexture(this.regl) : $f87d9fed9ae75f45$var$zt;
    }
    fi(t) {
        if (this._textureMap[t]) this._textureMap[t].count++;
        else {
            this.Ei = this.Ei || new (0, $2wazW).ResourceLoader;
            const e = "default" === t ? void 0 : t, i = new (0, $2wazW).Texture2D({
                url: e,
                mag: "linear"
            }, this.Ei);
            i.once("complete", ()=>{
                this.setToRedraw();
            }, this), this._textureMap[t] = {
                count: 1,
                texture: i
            };
        }
    }
    ui(t) {
        this._textureMap[t] && (this._textureMap[t].count--, this._textureMap[t].count < 1 && (this._textureMap[t].texture.dispose(), delete this._textureMap[t]));
    }
}
class $f87d9fed9ae75f45$export$12d066ea2d38fac7 extends $f87d9fed9ae75f45$var$At {
    static initDefaultShader() {
        const t = function() {
            const t = {
                vert: "\n        attribute vec3 aPosition;\n        attribute vec2 aTexCoord;\n        uniform mat4 projViewMatrix;\n        uniform mat4 modelMatrix;\n        uniform vec2 uvOffset;\n        uniform float width;\n        uniform float height;\n        varying vec2 vTexCoords;\n        void main()\n        {\n            gl_Position = projViewMatrix * modelMatrix * vec4(aPosition, 1.0);\n            vTexCoords = (uvOffset + aTexCoord) * vec2(1.0 / width, 1.0 / height);\n        }\n    ",
                frag: "\n        precision mediump float;\n        uniform sampler2D texture;\n\n        varying vec2 vTexCoords;\n        void main() {\n            vec4 color = texture2D(texture, vTexCoords);\n            gl_FragColor = vec4(color.rgb, color.a) * color.a;\n        }\n    ",
                positionAttribute: "POSITION",
                extraCommandProps: {
                    blend: {
                        enable: !0,
                        func: {
                            src: "one",
                            dst: "one minus src alpha"
                        },
                        equation: "add"
                    }
                }
            }, e = new (0, $2wazW).Material;
            return {
                shader: t,
                material: e
            };
        }();
        $f87d9fed9ae75f45$export$12d066ea2d38fac7.registerShader("effect", "MeshShader", t.shader, t.material.getUniforms());
    }
    onAddGeometry(t) {
        super.onAddGeometry(t);
        const e = t.getTextureUrl(), i = this.getRenderer();
        i ? i.fi(e) : this.on("renderercreate", (t)=>{
            t.renderer.fi(e);
        });
    }
    remove() {
        const t = this.getRenderer();
        t && this._geoList.forEach((e)=>{
            const i = e.getTextureUrl();
            t.ui(i);
        }), super.remove();
    }
    clear() {
        const t = this.getRenderer();
        t && this._geoList.forEach((e)=>{
            const i = e.getTextureUrl();
            t.ui(i);
        }), super.clear();
    }
    getTextureMapTest() {
        const t = this.getRenderer();
        return t ? t._textureMap : null;
    }
}
$f87d9fed9ae75f45$export$12d066ea2d38fac7.initDefaultShader(), $f87d9fed9ae75f45$export$12d066ea2d38fac7.mergeOptions({
    markerTypes: [
        "effectmarker"
    ]
}), $f87d9fed9ae75f45$export$12d066ea2d38fac7.registerJSONType("EffectLayer"), $f87d9fed9ae75f45$export$12d066ea2d38fac7.registerRenderer("gl", $f87d9fed9ae75f45$var$Jt);
class $f87d9fed9ae75f45$export$453b2355081703c2 extends $f87d9fed9ae75f45$export$f502975d4e0f97bb {
    constructor(t, e){
        super(t, e), this.l = "glowmarker";
    }
    static fromJSON(t) {
        return new $f87d9fed9ae75f45$export$453b2355081703c2(t.coordinates, t.options);
    }
    getUrl() {
        return "plane";
    }
    setSpeed(t) {
        this.setUniform("speed", t);
    }
    getSpeed() {
        return this._getInternalSymbol().uniforms.speed;
    }
    getShader() {
        return "glowmarker";
    }
    isAnimated() {
        const t = this._getInternalSymbol();
        return t && t.animation;
    }
    Z() {
        let t = this._getInternalSymbol().uniforms.time || 0;
        t += .01, this.setUniform("time", t);
    }
}
$f87d9fed9ae75f45$export$453b2355081703c2.mergeOptions({
    visible: !0
});
class $f87d9fed9ae75f45$export$22101854b30a18fd extends $f87d9fed9ae75f45$var$At {
    static initDefaultShader() {
        const t = function() {
            const t = {
                vert: "\n        #ifdef GL_ES\n            precision highp float;\n        #endif\n        attribute vec3 aPosition;\n        uniform mat4 projViewModelMatrix;\n        uniform mat4 modelMatrix;\n        uniform mat4 positionMatrix;\n        varying vec3 v_FragPos;\n        varying vec3 v_center;\n        #include <get_output>\n        void main(){\n            mat4 localPositionMatrix = getPositionMatrix();\n            vec4 localVertex = getPosition(aPosition);\n            vec4 position = localPositionMatrix * localVertex;\n            gl_Position = projViewModelMatrix * position;\n            vec4 worldPos = modelMatrix * position;\n            v_FragPos = worldPos.xyz;\n            v_center = (modelMatrix * vec4(0.0, 0.0, 0.0, 1.0)).xyz;\n        }\n    ",
                frag: "\n        #ifdef GL_ES\n            precision highp float;\n        #endif\n        #define pi 3.14159\n        const float dotsnb = 30.0; // Number of dots\n\n        varying vec3 v_FragPos;\n        varying vec3 v_center;\n        uniform float time;\n        uniform float radius;\n        uniform vec3 color;\n        uniform float speed;\n        vec3 hsb2rgb(in vec3 c)\n        {\n            vec3 rgb = clamp(abs(mod(c.x*6.0+vec3(0.0,4.0,2.0),6.0)-3.0)-1.0,0.0,1.0 );\n            rgb = rgb*rgb*(4.0-2.0*rgb);\n            return c.z * mix( vec3(1.0), rgb, c.y);\n        }\n\n        void main()\n        {\n            float r = length(v_FragPos - v_center);\n            r = r*2.-1.;\n            if(r>radius) {\n                gl_FragColor = vec4(1.0,1.0,1.0, 0.0);\n            } else {\n                //vec3 color = hsb2rgb(vec3(fract(time*.1),.7,.4));\n                vec3 color = color;\n                float s = abs(sin(pow(r+5.0, 1.5)-time*speed+sin(r*0.9))*sin(r+.99));\n                color *= (abs(1./(s*10.8))-.01);\n                gl_FragColor = vec4(color, (color.x + color.y + color.z) / 1.0);\n            }\n        }\n    ",
                uniforms: [
                    {
                        name: "projViewModelMatrix",
                        type: "function",
                        fn: function(t, e) {
                            return (0, $3iqbd).multiply([], e.projViewMatrix, e.modelMatrix);
                        }
                    }
                ],
                positionAttribute: "POSITION",
                extraCommandProps: {
                    blend: {
                        enable: !0,
                        func: {
                            srcRGB: "src alpha",
                            srcAlpha: 1,
                            dstRGB: "one",
                            dstAlpha: 1
                        },
                        equation: {
                            rgb: "add",
                            alpha: "add"
                        },
                        color: [
                            0,
                            0,
                            0,
                            0
                        ]
                    }
                }
            }, e = new (0, $2wazW).Material;
            return {
                shader: t,
                material: e
            };
        }();
        $f87d9fed9ae75f45$export$22101854b30a18fd.registerShader("glowmarker", "MeshShader", t.shader, t.material.getUniforms());
    }
}
$f87d9fed9ae75f45$export$22101854b30a18fd.initDefaultShader(), $f87d9fed9ae75f45$export$22101854b30a18fd.mergeOptions({
    markerTypes: [
        "glowmarker"
    ]
}), $f87d9fed9ae75f45$export$22101854b30a18fd.registerJSONType("GlowMarkerLayer"), $f87d9fed9ae75f45$export$22101854b30a18fd.registerRenderer("gl", $f87d9fed9ae75f45$var$wt);
const $f87d9fed9ae75f45$var$qt = {
    url: "plane",
    animation: !0,
    loop: !0,
    rotation: [
        0,
        0,
        0
    ],
    translation: [
        0,
        0,
        30
    ],
    scale: [
        1,
        1,
        30
    ]
}, $f87d9fed9ae75f45$var$Wt = {
    width: 1,
    height: 1,
    modelHeight: 60,
    startOpacity: 0,
    endOpacity: 1
};
class $f87d9fed9ae75f45$export$beb7768b14ffe1d0 extends $f87d9fed9ae75f45$export$bceb52c6dc7707e8 {
    constructor(t, i){
        super(t, i);
        const s = (0, $gP1US.Util).extend({}, $f87d9fed9ae75f45$var$qt, this.options.symbol);
        this.setSymbol(s);
        const n = (0, $gP1US.Util).extend({}, $f87d9fed9ae75f45$var$Wt, this.options.symbol.uniforms);
        this.setUniforms(n), this.setShader("effectline"), this.l = "effectmarker";
    }
    getEffectType() {
        return "sequence";
    }
    setTexture(t) {
        return this.setUniform("texture", t), this;
    }
    setHeight(t) {
        return this.setUniform("modelHeight", t), this;
    }
    setStartOpacity(t) {
        return this.setUniform("startOpacity", t), this;
    }
    setEndOpacity(t) {
        return this.setUniform("endOpacity", t), this;
    }
}
class $f87d9fed9ae75f45$export$1e45b0bf1907bf71 extends $f87d9fed9ae75f45$var$At {
    static initDefaultShader() {
        const t = function() {
            const t = {
                vert: "\n        attribute vec3 aPosition;\n        attribute vec2 aTexCoord;\n        uniform mat4 projViewMatrix;\n        uniform mat4 modelMatrix;\n        uniform vec2 uvOffset;\n        uniform float width;\n        uniform float height;\n        varying vec2 vTexCoords;\n        varying float vHeight;\n        void main()\n        {\n            vec4 worldPosition = modelMatrix * vec4(aPosition, 1.0);\n            gl_Position = projViewMatrix * worldPosition;\n            vHeight = worldPosition.z;\n            vTexCoords = (uvOffset + aTexCoord) * vec2(1.0 / width, 1.0 / height);\n        }\n    ",
                frag: "\n        precision mediump float;\n        uniform sampler2D texture;\n        uniform float modelHeight;\n        uniform float startOpacity;\n        uniform float endOpacity;\n        varying float vHeight;\n        varying vec2 vTexCoords;\n        void main() {\n            vec4 color = texture2D(texture, vTexCoords);\n            float opacity = (endOpacity - startOpacity) * (1.0 - vHeight / modelHeight);\n            gl_FragColor = vec4(color.rgb, color.a) * color.a * opacity;\n        }\n    ",
                positionAttribute: "POSITION",
                extraCommandProps: {
                    blend: {
                        enable: !0,
                        func: {
                            src: "one",
                            dst: "one minus src alpha"
                        },
                        equation: "add"
                    }
                }
            }, e = new (0, $2wazW).Material;
            return {
                shader: t,
                material: e
            };
        }();
        $f87d9fed9ae75f45$export$1e45b0bf1907bf71.registerShader("effectline", "MeshShader", t.shader);
    }
}
$f87d9fed9ae75f45$export$1e45b0bf1907bf71.initDefaultShader(), $f87d9fed9ae75f45$export$1e45b0bf1907bf71.mergeOptions({
    markerTypes: [
        "effectmarker"
    ]
}), $f87d9fed9ae75f45$export$1e45b0bf1907bf71.registerJSONType("EffectLineLayer"), $f87d9fed9ae75f45$export$1e45b0bf1907bf71.registerRenderer("gl", $f87d9fed9ae75f45$var$Jt);
const $f87d9fed9ae75f45$var$$t = {
    offsetX: 0,
    offsetY: 0,
    uReflectivity: .8,
    opacity: .9,
    color: [
        .9,
        0,
        0,
        1
    ]
};
class $f87d9fed9ae75f45$export$3802c41f905f21b0 extends $f87d9fed9ae75f45$export$f502975d4e0f97bb {
    constructor(t, i){
        super(t, i);
        const s = (0, $gP1US.Util).extend({}, $f87d9fed9ae75f45$var$$t, this.options.symbol.uniforms);
        this.setUniforms(s), this.setShader("effectring"), this.l = "effectring";
    }
}
class $f87d9fed9ae75f45$export$fe57657f86939a38 extends $f87d9fed9ae75f45$var$At {
    static initDefaultShader() {
        const t = function() {
            const t = {
                vert: "\n        attribute vec3 aPosition;\n        attribute vec2 aTexCoord;\n        attribute vec3 aNormal;\n        uniform mat4 projViewMatrix;\n        uniform mat4 modelMatrix;\n        uniform mat4 normalMatrix;\n        uniform float offsetX;\n        uniform float offsetY;\n        varying vec2 uv;\n        void main()\n        {\n            gl_Position = projViewMatrix * modelMatrix * vec4(aPosition, 1.0);\n            uv = vec2(aTexCoord.x + offsetX, aTexCoord.y + offsetY);\n        }\n    ",
                frag: "\n        precision mediump float;\n        uniform sampler2D effectTexture;\n        uniform vec3 uCameraPosition;\n        uniform mat4 viewMatrix;\n        uniform float uReflectivity;\n        uniform vec4 color;\n        uniform float opacity;\n\n        varying vec2 uv;\n\n        vec3 inverseTransformDirection(in vec3 dir, in mat4 matrix) {\n            return normalize((vec4(dir, 0.0) * matrix).xyz);\n        }\n\n        const float GAMMA_FACTOR = 2.0;\n        vec4 GammaToLinear(in vec4 value, in float gammaFactor) {\n            return vec4(pow(value.xyz, vec3(gammaFactor)), value.w);\n        }\n\n        vec4 mixTexelToLinear(vec4 value) {\n            return GammaToLinear(value, float(GAMMA_FACTOR));\n        }\n\n        void main() {\n            vec4 texColor = texture2D(effectTexture, uv);\n            if (color.a == 0.0) {\n                discard;\n            }\n            vec4 mixColor = mixTexelToLinear(color);\n            texColor.rgb += mixColor.xyz * uReflectivity;\n            texColor.a*= opacity;\n            gl_FragColor = texColor;\n        }\n    ",
                uniforms: [
                    {
                        name: "normalMatrix",
                        type: "function",
                        fn: function(t, e) {
                            const i = [];
                            return (0, $3iqbd).invert(i, e.modelMatrix), (0, $3iqbd).transpose(i, i), i;
                        }
                    }
                ],
                positionAttribute: "POSITION",
                extraCommandProps: {
                    depth: {
                        enable: !0,
                        mask: !1
                    },
                    blend: {
                        enable: !0,
                        func: {
                            src: "one",
                            dst: "one minus src alpha"
                        },
                        equation: "add"
                    }
                }
            }, e = new (0, $2wazW).Material;
            return {
                shader: t,
                material: e
            };
        }();
        $f87d9fed9ae75f45$export$fe57657f86939a38.registerShader("effectring", "MeshShader", t.shader);
    }
}
$f87d9fed9ae75f45$export$fe57657f86939a38.initDefaultShader(), $f87d9fed9ae75f45$export$fe57657f86939a38.mergeOptions({
    markerTypes: [
        "effectring"
    ]
}), $f87d9fed9ae75f45$export$fe57657f86939a38.registerJSONType("EffectRingLayer"), $f87d9fed9ae75f45$export$fe57657f86939a38.registerRenderer("gl", $f87d9fed9ae75f45$var$wt);
const $f87d9fed9ae75f45$var$te = {
    animation: !0,
    loop: !0,
    url: "plane",
    effect: "sequence",
    speed: 1,
    scale: [
        1,
        1,
        1
    ],
    rotation: [
        90,
        0,
        0
    ]
}, $f87d9fed9ae75f45$var$ee = {
    width: 9,
    height: 5
};
class $f87d9fed9ae75f45$export$85cfd773db9482a1 extends $f87d9fed9ae75f45$export$bceb52c6dc7707e8 {
    constructor(t, i){
        super(t, i);
        const s = (0, $gP1US.Util).extend({}, $f87d9fed9ae75f45$var$te, this.options.symbol);
        this.setSymbol(s);
        const n = (0, $gP1US.Util).extend({}, $f87d9fed9ae75f45$var$ee, this.options.symbol.uniforms);
        this.setUniforms(n);
    }
}
if ($9e7Ip.transcoders) {
    const e = $gP1US.Map.VERSION;
    if (e.indexOf("1.0.0-beta") >= 0 || e.indexOf("1.0.0-alpha") >= 0) {
        const e = $9e7Ip.transcoders.inject($f87d9fed9ae75f45$var$M);
        $gP1US.registerWorkerAdapter("@maptalks/gltf-layer", e);
    } else $gP1US.registerWorkerAdapter("@maptalks/gltf-layer", function() {
        return $9e7Ip.transcoders.inject($f87d9fed9ae75f45$var$M);
    });
} else $gP1US.registerWorkerAdapter("@maptalks/gltf-layer", $f87d9fed9ae75f45$var$M);
"undefined" != typeof console && console.log("@maptalks/gltf-layer v0.104.3");


/*!
 * @maptalks/transform-control v0.105.4
 * LICENSE : UNLICENSED
 * (c) 2016-2025 maptalks.org
 */ parcelRequire("9e7Ip");
var $3iqbd = parcelRequire("3iqbd");
var $k1dpP = parcelRequire("k1dpP");
var $2wazW = parcelRequire("2wazW");
var $6BoVD = parcelRequire("6BoVD");
var $eIStk = parcelRequire("eIStk");

var $gP1US = parcelRequire("gP1US");

const $0ff02aa1df83de88$var$c = {
    yuanhuan: {
        accessors: [
            {
                name: "\uFFFD\uFFFD\uFFFD\uFFFD\u0421\uFFFD\uFFFD_1_0_positions",
                componentType: 5126,
                count: 104,
                min: [
                    -5.407599925994873,
                    -5.404099941253662,
                    0
                ],
                max: [
                    5.405200004577637,
                    5.406300067901611,
                    0
                ],
                type: "VEC3",
                bufferView: 0,
                byteOffset: 0
            },
            {
                name: "\uFFFD\uFFFD\uFFFD\uFFFD\u0421\uFFFD\uFFFD_1_0_normals",
                componentType: 5126,
                count: 104,
                min: [
                    0,
                    0,
                    1
                ],
                max: [
                    0,
                    0,
                    1
                ],
                type: "VEC3",
                bufferView: 1,
                byteOffset: 0
            },
            {
                name: "\uFFFD\uFFFD\uFFFD\uFFFD\u0421\uFFFD\uFFFD_1_0_indices",
                componentType: 5123,
                count: 288,
                min: [
                    0
                ],
                max: [
                    103
                ],
                type: "SCALAR",
                bufferView: 2,
                byteOffset: 0
            }
        ],
        asset: {
            generator: "obj2gltf",
            version: "2.0"
        },
        buffers: [
            {
                name: "\u7F29\u653E\u5708-\u65B0",
                byteLength: 3072,
                uri: "data:application/octet-stream;base64,KVyjQLbzPT4AAAAAZvesQLbzPT4AAAAAhsmqQC7/YT8AAAAAZ0ShQDC7Vz8AAAAA+u2lwGKhxr8AAAAArK2cwLpJvL8AAAAAEFihwB04V78AAAAAXdyqwE7RYb8AAAAAat6lQEaUxj8AAAAAApqcQG+BvD8AAAAAB18EQFOWlcAAAAAA+u0LQLBynsAAAAAARPoxQNSalMAAAAAAJzEoQIxKjMAAAAAAQBNVQFyPiMAAAAAAIEFJQMDsgMAAAAAA0950QK36dMAAAAAAejZnQFRSZ8AAAAAAXdyAQBBYScAAAAAA+n6IQI0oVcAAAAAAcoqUQAMJMsAAAAAAKjqMQIlBKMAAAAAAXdyAQFdbSUAAAAAA+n6IQDsBVUAAAAAA0950QBTQdEAAAAAAejZnQA5PZ0AAAAAA+n6IwI0oVcAAAAAAwOyAwBBYScAAAAAAXkuMwIlBKMAAAAAA0ZGUwAMJMsAAAAAA5j+8P9ejnMAAAAAAkDFXP65HocAAAAAA1JrGPz7opcAAAAAA/7I7PvhTo8AAAAAA/7I7PmPurMAAAAAAM8RhP/vLqsAAAAAADwutwLbzPT4AAAAA0m+jwLbzPT4AAAAAEFihwDC7Vz8AAAAAXdyqwC7/YT8AAAAArK2cwG+BvD8AAAAA+u2lwEaUxj8AAAAADXGewN/gC0AAAAAAa5qVwIV8BEAAAAAAXkuMwAFNKEAAAAAA0ZGUwD7oMUAAAAAAlIeVQIV8BEAAAAAAlWWeQN/gC0AAAAAAcoqUQD7oMUAAAAAAKjqMQAFNKEAAAAAAQBNVQBB6iEAAAAAAIEFJQKfogEAAAAAAW9N0wK36dMAAAAAAsVBnwFRSZ8AAAAAAlWWeQM/3C8AAAAAAlIeVQNxoBMAAAAAA+n6IwDsBVUAAAAAAwOyAwFdbSUAAAAAAsVBnwA5PZ0AAAAAAW9N0wBTQdEAAAAAAd74LwLBynsAAAAAAkxi8v9ejnMAAAAAAwFsEwFOWlcAAAAAARpRWv65HocAAAAAAayvGvz7opcAAAAAA2c43vvhTo8AAAAAA2c43vmPurMAAAAAAt9Fgv/vLqsAAAAAAt9Fgv7fRqkAAAAAAayvGvybkpUAAAAAAd74LwAponkAAAAAA2c43vv5lo0AAAAAA2c43vmkArUAAAAAARpRWvzxOoUAAAAAAkxi8v9ejnEAAAAAAOdYxwHKKlEAAAAAAwFsEwDqSlUAAAAAA+zoowNBEjEAAAAAAJlNJwKfogEAAAAAAUPxUwBB6iEAAAAAAat6lQGKhxr8AAAAAApqcQLpJvL8AAAAAhsmqQE7RYb8AAAAAZ0ShQB04V78AAAAAZvesQP+yO74AAAAAKVyjQP+yO74AAAAAM8RhP7fRqkAAAAAA/7I7PmkArUAAAAAA/7I7Pv5lo0AAAAAA+u0LQAponkAAAAAA1JrGPybkpUAAAAAAkDFXPzxOoUAAAAAA5j+8P9ejnEAAAAAARPoxQHKKlEAAAAAAB18EQDqSlUAAAAAAJzEoQNBEjEAAAAAA+zoowIxKjMAAAAAAOdYxwNSalMAAAAAAUPxUwFyPiMAAAAAAJlNJwMDsgMAAAAAAa5qVwNxoBMAAAAAADXGewM/3C8AAAAAA0m+jwP+yO74AAAAADwutwP+yO74AAAAAAAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAABAAIAAAACAAMABAAFAAYABAAGAAcAAwACAAgAAwAIAAkACgALAAwACgAMAA0ADQAMAA4ADQAOAA8ADwAOABAADwAQABEAEgATABQAEgAUABUAFgAXABgAFgAYABkAGgAbABwAGgAcAB0AHgALAAoAHwALAB4AHwAgAAsAIQAgAB8AIgAjACAAIgAgACEAJAAlACYAJAAmACcAJwAmACgAJwAoACkAKgArACwAKgAsAC0ALgAvADAALgAwADEAGQAYADIAGQAyADMANAA1ABsANAAbABoAFQAUADYAFQA2ADcAOAA5ADoAOAA6ADsAPAA9AD4APAA/AD0AQAA/ADwAQABBAD8AQgBBAEAAQgBAAEMARABFAEYARABGAEcARABHAEgARgBJAEcARgBKAEkASwBKAEYASwBMAEoASwBNAEwACQAIAC8ACQAvAC4ALQAsADkALQA5ADgAOwA6AE4AOwBOAE8ATwBOAE0ATwBNAEsAKQAoACsAKQArACoANwA2AFAANwBQAFEAUQBQAFIAUQBSAFMAUwBSAFQAUwBUAFUAVgBXAFgAVgBYAFkAVgBZAFoAWwBZAFgAXABZAFsAXABdAFkAXgBdAFwAXwBdAF4APAA+AGAAPABgAGEAMQAwABcAMQAXABYAYgBjADUAYgA1ADQAYQBgAGMAYQBjAGIAMwAyAF0AMwBdAF8AHQAcAGQAHQBkAGUAZQBkAAUAZQAFAAQAZgBnAAcAZgAHAAYAEQAQABMAEQATABIA"
            }
        ],
        bufferViews: [
            {
                name: "bufferView_0",
                buffer: 0,
                byteLength: 1248,
                byteOffset: 0,
                byteStride: 12,
                target: 34962
            },
            {
                name: "bufferView_1",
                buffer: 0,
                byteLength: 1248,
                byteOffset: 1248,
                byteStride: 12,
                target: 34962
            },
            {
                name: "bufferView_2",
                buffer: 0,
                byteLength: 576,
                byteOffset: 2496,
                target: 34963
            }
        ],
        materials: [
            {
                name: "SVGMat_001",
                pbrMetallicRoughness: {
                    baseColorFactor: [
                        .5,
                        .5,
                        .5,
                        1
                    ],
                    metallicFactor: 0,
                    roughnessFactor: 1
                },
                emissiveFactor: [
                    0,
                    0,
                    0
                ],
                alphaMode: "OPAQUE",
                doubleSided: !1
            }
        ],
        meshes: [
            {
                name: "\uFFFD\uFFFD\uFFFD\uFFFD\u0421\uFFFD\uFFFD_1",
                primitives: [
                    {
                        attributes: {
                            POSITION: 0,
                            NORMAL: 1
                        },
                        indices: 2,
                        material: 0,
                        mode: 4
                    }
                ]
            }
        ],
        nodes: [
            {
                name: "\uFFFD\uFFFD\uFFFD\uFFFD\u0421\uFFFD\uFFFD",
                mesh: 0
            }
        ],
        scene: 0,
        scenes: [
            {
                nodes: [
                    0
                ]
            }
        ]
    },
    yuanhuan41: {
        accessors: [
            {
                name: "\u0532\uFFFD\uFFFD_1_0_positions",
                componentType: 5126,
                count: 39,
                min: [
                    0,
                    0,
                    0
                ],
                max: [
                    5.489999771118164,
                    0,
                    5.488900184631348
                ],
                type: "VEC3",
                bufferView: 0,
                byteOffset: 0
            },
            {
                name: "\u0532\uFFFD\uFFFD_1_0_normals",
                componentType: 5126,
                count: 39,
                min: [
                    0,
                    -0.999939501285553,
                    -1
                ],
                max: [
                    .13969914615154266,
                    1,
                    1
                ],
                type: "VEC3",
                bufferView: 1,
                byteOffset: 0
            },
            {
                name: "\u0532\uFFFD\uFFFD_1_0_indices",
                componentType: 5123,
                count: 105,
                min: [
                    0
                ],
                max: [
                    38
                ],
                type: "SCALAR",
                bufferView: 2,
                byteOffset: 0
            }
        ],
        asset: {
            generator: "obj2gltf",
            version: "2.0"
        },
        buffers: [
            {
                name: "yh41",
                byteLength: 1148,
                uri: "data:application/octet-stream;base64,8tKXQAAAAACoNU09FK6vQAAAAAB1Ako/FK6vQAAAAAAAAACATfOAQAAAAAACmkg+K4dWQAAAAAAIrNw+WvUtQAAAAABbsT8/X5gIQAAAAACMSpI/OUWbQAAAAAD0/VQ/LbKHQAAAAAD0/XQ/W0JqQAAAAAC6SZQ/dLXNPwAAAACfq80/H4VHQAAAAAB0JLc/ZognQAAAAAA1XuI/YVSSPwAAAAAukAhABaMKQAAAAAB4nApABcU/PwAAAACF6y1Aw2TiPwAAAACRfidASS63PwAAAABKe0dAJLncPgAAAACze1ZAj1OUPwAAAADjNmpAAppIPgAAAADu64BAnRF1PwAAAAD8qYdAqDVNPQAAAADBypdAgQRVPwAAAAAIPZtAAAAAAAAAAAASpa9AAwlKPwAAAAASpa9AJJd/PAAAAAASpa9AAwlKPwAAAAASpa9AAAAAAAAAAAASpa9Asp1vPQAAAAASpa9AJLn8PQAAAAASpa9AqoJRPgAAAAASpa9ARwOYPgAAAAASpa9AHhbKPgAAAAASpa9A2hv8PgAAAAASpa9A5q4VPwAAAAASpa9A+n4qPwAAAAASpa9AQxw7PwAAAAASpa9AwhdGPwAAAAASpa9AAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAJ5X/OwL+fz8AAACAAAAAAAAAAAAAAIA/AAAAAAAAAAAAAIC/Kzs0PAn8f78AAACApLK/PA7uf78AAACAeJkZPefRfz8AAACA+ZldPQSgf78AAACA6XSTPelVfz8AAACALLO3PdT3fr8AAACAfkjZPR2Ofr8AAACANf32Paohfj8AAACAeUYHPqDBfT8AAACASw0PPlt9fb8AAACAAAABAAIAAwABAAAABAABAAMABQABAAQABgAHAAUABwABAAUABgAIAAcABgAJAAgACgAJAAYACgALAAkACgAMAAsADQAMAAoADQAOAAwADwAOAA0ADwAQAA4ADwARABAAEgARAA8AEgATABEAFAATABIAFAAVABMAFgAVABQAFgAXABUAGAAXABYAGAAZABcAGgAbABwAHQAbABoAHgAbAB0AHwAbAB4AIAAbAB8AIQAbACAAIgAbACEAIwAbACIAJAAbACMAJQAbACQAJgAbACUAAAA="
            }
        ],
        bufferViews: [
            {
                name: "bufferView_0",
                buffer: 0,
                byteLength: 468,
                byteOffset: 0,
                byteStride: 12,
                target: 34962
            },
            {
                name: "bufferView_1",
                buffer: 0,
                byteLength: 468,
                byteOffset: 468,
                byteStride: 12,
                target: 34962
            },
            {
                name: "bufferView_2",
                buffer: 0,
                byteLength: 212,
                byteOffset: 936,
                target: 34963
            }
        ],
        materials: [
            {
                name: "SVGMat_002",
                pbrMetallicRoughness: {
                    baseColorFactor: [
                        .588,
                        .588,
                        .588,
                        1
                    ],
                    metallicFactor: 0,
                    roughnessFactor: .99
                },
                emissiveFactor: [
                    0,
                    0,
                    0
                ],
                alphaMode: "OPAQUE",
                doubleSided: !1
            }
        ],
        meshes: [
            {
                name: "\u0532\uFFFD\uFFFD_1",
                primitives: [
                    {
                        attributes: {
                            POSITION: 0,
                            NORMAL: 1
                        },
                        indices: 2,
                        material: 0,
                        mode: 4
                    }
                ]
            }
        ],
        nodes: [
            {
                name: "\u0532\uFFFD\uFFFD",
                mesh: 0
            }
        ],
        scene: 0,
        scenes: [
            {
                nodes: [
                    0
                ]
            }
        ]
    },
    yuanhuan411: {
        accessors: [
            {
                name: "\uFFFD\uFFFD\uFFFD\uFFFD\u0421\u0226_1_0_positions",
                componentType: 5126,
                count: 28,
                min: [
                    .026000000536441803,
                    -4.6834001541137695,
                    0
                ],
                max: [
                    4.696700096130371,
                    -0.014800000004470348,
                    0
                ],
                type: "VEC3",
                bufferView: 0,
                byteOffset: 0
            },
            {
                name: "\uFFFD\uFFFD\uFFFD\uFFFD\u0421\u0226_1_0_normals",
                componentType: 5126,
                count: 28,
                min: [
                    0,
                    0,
                    1
                ],
                max: [
                    0,
                    0,
                    1
                ],
                type: "VEC3",
                bufferView: 1,
                byteOffset: 0
            },
            {
                name: "\uFFFD\uFFFD\uFFFD\uFFFD\u0421\u0226_1_0_indices",
                componentType: 5123,
                count: 78,
                min: [
                    0
                ],
                max: [
                    27
                ],
                type: "SCALAR",
                bufferView: 2,
                byteOffset: 0
            }
        ],
        asset: {
            generator: "obj2gltf",
            version: "2.0"
        },
        buffers: [
            {
                name: "yuanhuan411",
                byteLength: 828,
                uri: "data:application/octet-stream;base64,ufwXQLN7Mr8AAAAAObRAQLFQK78AAAAA1ediQMWP8b4AAAAAGQQ6QCv2174AAAAAqFdeQHUCWr4AAAAA7FGCQL6fmr0AAAAAHHyDQDLmrr4AAAAAXkuWQJf/kL4AAAAAXkuWQLN7crwAAAAAMCrxP2RdhL8AAAAA/BgDQJeQn78AAAAADeARQAg9i78AAAAAukkIQISeXb8AAAAAZaogQH/Zbb8AAAAA7Q3ePr4wOcAAAAAA5IMuP9/gP8AAAAAAJQZxPwrXH8AAAAAAPZs1P6UsF8AAAAAAdy2hP0VHAsAAAAAAb/CFP5eQ778AAAAA0ES4P32utr8AAAAAAprQPyL9zr8AAAAAi/1lPqqCXcAAAAAA9dv3PtcSYsAAAAAADi2yPZvmgcAAAAAAYTK1PssQg8AAAAAA9P3UPGrelcAAAAAA4liXPmrelcAAAAAAAAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAABAAIAAAACAAMAAwACAAQABQAGAAcABQAHAAgABAACAAYABAAGAAUACQAKAAsACQALAAwAAAANAAEADgAPABAADgAQABEAEQAQABIAEQASABMAFAAVAAoAFAAKAAkADAALAA0ADAANAAAAFgAXAA8AFgAPAA4AGAAZABcAGAAXABYAGgAZABgAGgAbABkAEwASABUAEwAVABQA"
            }
        ],
        bufferViews: [
            {
                name: "bufferView_0",
                buffer: 0,
                byteLength: 336,
                byteOffset: 0,
                byteStride: 12,
                target: 34962
            },
            {
                name: "bufferView_1",
                buffer: 0,
                byteLength: 336,
                byteOffset: 336,
                byteStride: 12,
                target: 34962
            },
            {
                name: "bufferView_2",
                buffer: 0,
                byteLength: 156,
                byteOffset: 672,
                target: 34963
            }
        ],
        materials: [
            {
                name: "SVGMat",
                pbrMetallicRoughness: {
                    baseColorFactor: [
                        .588,
                        .588,
                        .588,
                        1
                    ],
                    metallicFactor: 0,
                    roughnessFactor: .99
                },
                emissiveFactor: [
                    0,
                    0,
                    0
                ],
                alphaMode: "OPAQUE",
                doubleSided: !1
            }
        ],
        meshes: [
            {
                name: "\uFFFD\uFFFD\uFFFD\uFFFD\u0421\u0226_1",
                primitives: [
                    {
                        attributes: {
                            POSITION: 0,
                            NORMAL: 1
                        },
                        indices: 2,
                        material: 0,
                        mode: 4
                    }
                ]
            }
        ],
        nodes: [
            {
                name: "\uFFFD\uFFFD\uFFFD\uFFFD\u0421\u0226",
                mesh: 0
            }
        ],
        scene: 0,
        scenes: [
            {
                nodes: [
                    0
                ]
            }
        ]
    },
    yuanpan: {
        accessors: [
            {
                name: "Circle001_1_0_positions",
                componentType: 5126,
                count: 28,
                min: [
                    -1.9510999917984009,
                    0,
                    -1.9510999917984009
                ],
                max: [
                    1.9510999917984009,
                    0,
                    1.9510999917984009
                ],
                type: "VEC3",
                bufferView: 0,
                byteOffset: 0
            },
            {
                name: "Circle001_1_0_normals",
                componentType: 5126,
                count: 28,
                min: [
                    0,
                    1,
                    0
                ],
                max: [
                    0,
                    1,
                    0
                ],
                type: "VEC3",
                bufferView: 1,
                byteOffset: 0
            },
            {
                name: "Circle001_1_0_indices",
                componentType: 5123,
                count: 78,
                min: [
                    0
                ],
                max: [
                    27
                ],
                type: "SCALAR",
                bufferView: 2,
                byteOffset: 0
            }
        ],
        asset: {
            generator: "obj2gltf",
            version: "2.0"
        },
        buffers: [
            {
                name: "yuanpan",
                byteLength: 828,
                uri: "data:application/octet-stream;base64,S+rkvgAAAADRIvM/AAAAAAAAAAClvfk/S+rkPgAAAADRIvM/0SLzvwAAAABL6uQ+MlXgvwAAAACsi1s/c9fCvwAAAACvJZw/pb35vwAAAAAAAAAA0SLzvwAAAABL6uS+MlXgvwAAAACsi1u/c9fCvwAAAACvJZy/ryWcvwAAAABz18K/rItbvwAAAAAyVeC/S+rkvgAAAADRIvO/AAAAgAAAAAClvfm/S+rkPgAAAADRIvO/rItbPwAAAAAyVeC/ryWcPwAAAABz18K/c9fCPwAAAACvJZy/MlXgPwAAAACsi1u/0SLzPwAAAABL6uS+pb35PwAAAAAAAACA0SLzPwAAAABL6uQ+MlXgPwAAAACsi1s/c9fCPwAAAACvJZw/ryWcvwAAAABz18I/ryWcPwAAAABz18I/rItbvwAAAAAyVeA/rItbPwAAAAAyVeA/AAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAAAAAAAgD8AAACAAAABAAIAAwAEAAUABgADAAUABwAGAAUACAAHAAUACQAIAAUACgAJAAUACwAKAAUADAALAAUADQAMAAUADgANAAUADwAOAAUAEAAPAAUAEQAQAAUAEgARAAUAEwASAAUAFAATAAUAFQAUAAUAFgAVAAUAFwAWAAUAFwAFABgAGQAXABgAGQAYABoAGwAZABoAAgAbABoAAAACABoA"
            }
        ],
        bufferViews: [
            {
                name: "bufferView_0",
                buffer: 0,
                byteLength: 336,
                byteOffset: 0,
                byteStride: 12,
                target: 34962
            },
            {
                name: "bufferView_1",
                buffer: 0,
                byteLength: 336,
                byteOffset: 336,
                byteStride: 12,
                target: 34962
            },
            {
                name: "bufferView_2",
                buffer: 0,
                byteLength: 156,
                byteOffset: 672,
                target: 34963
            }
        ],
        materials: [
            {
                name: "wire_008110135",
                pbrMetallicRoughness: {
                    baseColorFactor: [
                        .0314,
                        .4314,
                        .5294,
                        1
                    ],
                    metallicFactor: 0,
                    roughnessFactor: .968
                },
                emissiveFactor: [
                    0,
                    0,
                    0
                ],
                alphaMode: "OPAQUE",
                doubleSided: !1
            }
        ],
        meshes: [
            {
                name: "Circle001_1",
                primitives: [
                    {
                        attributes: {
                            POSITION: 0,
                            NORMAL: 1
                        },
                        indices: 2,
                        material: 0,
                        mode: 4
                    }
                ]
            }
        ],
        nodes: [
            {
                name: "Circle001",
                mesh: 0
            }
        ],
        scene: 0,
        scenes: [
            {
                nodes: [
                    0
                ]
            }
        ]
    },
    zzhou: {
        accessors: [
            {
                name: "Cube.001-Mesh_0_positions",
                componentType: 5126,
                count: 45,
                min: [
                    -0.2711470127105713,
                    -5.473427772521973,
                    -0.2711470127105713
                ],
                max: [
                    .2711470127105713,
                    .46298399567604065,
                    .2711470127105713
                ],
                type: "VEC3",
                bufferView: 0,
                byteOffset: 0
            },
            {
                name: "Cube.001-Mesh_0_normals",
                componentType: 5126,
                count: 45,
                min: [
                    -1,
                    -1,
                    -1
                ],
                max: [
                    1,
                    1,
                    1
                ],
                type: "VEC3",
                bufferView: 1,
                byteOffset: 0
            },
            {
                name: "Cube.001-Mesh_0_texcoords",
                componentType: 5126,
                count: 45,
                min: [
                    .125,
                    0
                ],
                max: [
                    .875,
                    1
                ],
                type: "VEC2",
                bufferView: 2,
                byteOffset: 0
            },
            {
                name: "Cube.001-Mesh_0_indices",
                componentType: 5123,
                count: 72,
                min: [
                    0
                ],
                max: [
                    44
                ],
                type: "SCALAR",
                bufferView: 3,
                byteOffset: 0
            }
        ],
        asset: {
            generator: "obj2gltf",
            version: "2.0"
        },
        buffers: [
            {
                name: "Z",
                byteLength: 1584,
                uri: "data:application/octet-stream;base64,/waNvZMdK77/Bo09/waNPZMdK77/Bo09/waNPR4Kr8D/Bo09l+KKPVImr8D/Bo09/waNvVImr8D/Bo09yNOKPsjTir7I04o+AAAAAD0M7T4AAAAAyNOKvsjTir7I04o+yNOKvsjTir7I04o+AAAAAD0M7T4AAAAAyNOKvsjTir7I04q+yNOKvsjTir7I04q+yNOKPsjTir7I04q+yNOKPsjTir7I04o+yNOKvsjTir7I04o+yNOKPsjTir7I04q+AAAAAD0M7T4AAAAAyNOKPsjTir7I04o+yNOKvsjTir7I04q+AAAAAD0M7T4AAAAAyNOKPsjTir7I04q+/waNPZMdK77/Bo09/waNPZMdK77/Bo29/waNPVImr8D/Bo29/waNPVImr8D/Bo09/waNPR4Kr8D/Bo09/waNvZMdK77/Bo09/waNvVImr8D/Bo09/waNvVImr8D/Bo29/waNvZMdK77/Bo29/waNvZMdK77/Bo29/waNvVImr8D/Bo29/waNPVImr8D/Bo29/waNPZMdK77/Bo29/waNPZMdK77/Bo09/waNvZMdK77/Bo09/waNvZMdK77/Bo29/waNPZMdK77/Bo29/waNvVImr8D/Bo09cooOO1Imr8BAMTI7/waNvVImr8D/Bo29/waNPVImr8D/Bo29/waNPVImr8D/Bo09l+KKPVImr8D/Bo09/waNPVImr8D/Bo09AAAAAAAAAAAAAIC/AAAAAAAAAAAAAIC/AAAAAAAAAAAAAIC/AAAAAAAAAAAAAIC/AAAAAAAAAAAAAIC/AAAAAFFmsT5wJHA/AAAAAFFmsT5wJHA/AAAAAFFmsT5wJHA/cCRwv1FmsT4AAAAAcCRwv1FmsT4AAAAAcCRwv1FmsT4AAAAAAAAAAAAAgL8AAAAAAAAAAAAAgL8AAAAAAAAAAAAAgL8AAAAAAAAAAAAAgL8AAAAAcCRwP1FmsT4AAAAAcCRwP1FmsT4AAAAAcCRwP1FmsT4AAAAAAAAAAFFmsT5wJHC/AAAAAFFmsT5wJHC/AAAAAFFmsT5wJHC/AACAvwAAAAAAAAAAAACAvwAAAAAAAAAAAACAvwAAAAAAAAAAAACAvwAAAAAAAAAAAACAvwAAAAAAAAAAAACAPwAAAAAAAAAAAACAPwAAAAAAAAAAAACAPwAAAAAAAAAAAACAPwAAAAAAAAAAAAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAgL8AAAAAAAAAAAAAgL8AAAAAAAAAAAAAgL8AAAAAAAAAAAAAgL8AAAAAAAAAAAAAgD8AAAAAAAAAAAAAgD8AAAAAAAAAAAAAgD8AAAAAAAAAAAAAgD8AAAAAAAAAAAAAAAAAAIC/AAAAAAAAgD8AAAAAAAAAAAAAgD8AAAAAAADAPgAAQD8AAMA+AACAP2L1Hz8AAIA/AAAgP3uDfz8AACA/AABAPwAAwD4AAIA+AAAgPwAAAAAAAMA+AAAAAAAAwD4AAIA/AAAgPwAAQD8AAMA+AABAPwAAAD4AAAA/AADAPgAAAD8AAMA+AACAPgAAAD4AAIA+AADAPgAAAD8AACA/AACAPgAAwD4AAIA+AADAPgAAQD8AACA/AAAAPwAAwD4AAAA/AADAPgAAAD8AAMA+AABAPwAAID8AAEA/AAAgPwAAAD9i9R8/AAAAPwAAwD4AAAA/AAAgPwAAAD8AACA/AACAPgAAwD4AAIA+AADAPgAAgD4AACA/AACAPgAAID8AAAAAAADAPgAAAAAAAAA+AAAAPwAAwD4AAAA/AADAPgAAgD4AAAA+AACAPgAAID8AAAA/vAJBP/mGwj4AACA/AACAPgAAYD8AAIA+AAAgPwAAgD97g18/AAAAPwAAYD8AAAA/AAABAAIAAgADAAQAAgAEAAAABQAGAAcACAAJAAoACwAMAA0ACwANAA4ADwAQABEAEgATABQAFQAWABcAFwAYABkAFwAZABUAGgAbABwAGgAcAB0AHgAfACAAHgAgACEAIgAjACQAIgAkACUAJgAnACgAKAAnACkAAwACACoAKQAnACsAKQArACwAJwAmACsA"
            }
        ],
        bufferViews: [
            {
                name: "bufferView_0",
                buffer: 0,
                byteLength: 540,
                byteOffset: 0,
                byteStride: 12,
                target: 34962
            },
            {
                name: "bufferView_1",
                buffer: 0,
                byteLength: 540,
                byteOffset: 540,
                byteStride: 12,
                target: 34962
            },
            {
                name: "bufferView_2",
                buffer: 0,
                byteLength: 360,
                byteOffset: 1080,
                byteStride: 8,
                target: 34962
            },
            {
                name: "bufferView_3",
                buffer: 0,
                byteLength: 144,
                byteOffset: 1440,
                target: 34963
            }
        ],
        materials: [
            {
                name: "Material.001",
                pbrMetallicRoughness: {
                    baseColorFactor: [
                        .8,
                        .8,
                        .8,
                        1
                    ],
                    metallicFactor: 0,
                    roughnessFactor: .676000006
                },
                emissiveFactor: [
                    0,
                    0,
                    0
                ],
                alphaMode: "OPAQUE",
                doubleSided: !1
            }
        ],
        meshes: [
            {
                name: "Cube.001-Mesh",
                primitives: [
                    {
                        attributes: {
                            POSITION: 0,
                            NORMAL: 1,
                            TEXCOORD_0: 2
                        },
                        indices: 3,
                        material: 0,
                        mode: 4
                    }
                ]
            }
        ],
        nodes: [
            {
                name: "Cube.001",
                mesh: 0
            }
        ],
        scene: 0,
        scenes: [
            {
                nodes: [
                    0
                ]
            }
        ]
    },
    jiantou: {
        accessors: [
            {
                name: "\uFFFD\uFFFD\u0377_1_0_positions",
                componentType: 5126,
                count: 7,
                min: [
                    -0.47690001130104065,
                    -0.8044000267982483,
                    0
                ],
                max: [
                    .47780001163482666,
                    0,
                    0
                ],
                type: "VEC3",
                bufferView: 0,
                byteOffset: 0
            },
            {
                name: "\uFFFD\uFFFD\u0377_1_0_normals",
                componentType: 5126,
                count: 7,
                min: [
                    0,
                    0,
                    1
                ],
                max: [
                    0,
                    0,
                    1
                ],
                type: "VEC3",
                bufferView: 1,
                byteOffset: 0
            },
            {
                name: "\uFFFD\uFFFD\u0377_1_0_indices",
                componentType: 5123,
                count: 15,
                min: [
                    0
                ],
                max: [
                    6
                ],
                type: "SCALAR",
                bufferView: 2,
                byteOffset: 0
            }
        ],
        asset: {
            generator: "obj2gltf",
            version: "2.0"
        },
        buffers: [
            {
                name: "jiantou",
                byteLength: 200,
                uri: "data:application/octet-stream;base64,bxIDOintTb8AAAAAH/RsvsKGp74AAAAAPSz0vsKGp74AAAAANs17PsKGp74AAAAANKL0PsKGp74AAAAANs17PgAAAAAAAAAAH/RsvgAAAAAAAAAAAAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAABAAIAAAADAAEAAAAEAAMAAQAFAAYAAQADAAUAAAA="
            }
        ],
        bufferViews: [
            {
                name: "bufferView_0",
                buffer: 0,
                byteLength: 84,
                byteOffset: 0,
                byteStride: 12,
                target: 34962
            },
            {
                name: "bufferView_1",
                buffer: 0,
                byteLength: 84,
                byteOffset: 84,
                byteStride: 12,
                target: 34962
            },
            {
                name: "bufferView_2",
                buffer: 0,
                byteLength: 32,
                byteOffset: 168,
                target: 34963
            }
        ],
        materials: [
            {
                name: "SVGMat_003",
                pbrMetallicRoughness: {
                    baseColorFactor: [
                        .588,
                        .588,
                        .588,
                        1
                    ],
                    metallicFactor: 0,
                    roughnessFactor: .99
                },
                emissiveFactor: [
                    0,
                    0,
                    0
                ],
                alphaMode: "OPAQUE",
                doubleSided: !1
            }
        ],
        meshes: [
            {
                name: "\uFFFD\uFFFD\u0377_1",
                primitives: [
                    {
                        attributes: {
                            POSITION: 0,
                            NORMAL: 1
                        },
                        indices: 2,
                        material: 0,
                        mode: 4
                    }
                ]
            }
        ],
        nodes: [
            {
                name: "\uFFFD\uFFFD\u0377",
                mesh: 0
            }
        ],
        scene: 0,
        scenes: [
            {
                nodes: [
                    0
                ]
            }
        ]
    },
    xuanzhuan: {
        accessors: [
            {
                name: "\uFFFD\uFFFD\u05EA001_1_0_positions",
                componentType: 5126,
                count: 369,
                min: [
                    -6.572299957275391,
                    -7.298999786376953,
                    0
                ],
                max: [
                    6.5742998123168945,
                    7.298299789428711,
                    0
                ],
                type: "VEC3",
                bufferView: 0,
                byteOffset: 0
            },
            {
                name: "\uFFFD\uFFFD\u05EA001_1_0_normals",
                componentType: 5126,
                count: 369,
                min: [
                    0,
                    -1,
                    0
                ],
                max: [
                    0,
                    0,
                    1
                ],
                type: "VEC3",
                bufferView: 1,
                byteOffset: 0
            },
            {
                name: "\uFFFD\uFFFD\u05EA001_1_0_indices",
                componentType: 5123,
                count: 1089,
                min: [
                    0
                ],
                max: [
                    368
                ],
                type: "SCALAR",
                bufferView: 2,
                byteOffset: 0
            }
        ],
        asset: {
            generator: "obj2gltf",
            version: "2.0"
        },
        buffers: [
            {
                name: "\u65CB\u8F6C-\u65B0",
                byteLength: 11036,
                uri: "data:application/octet-stream;base64,1zQDwHql3kAAAAAA48e4vgMJ1kAAAAAAQmD1v6yL6UAAAAAA2qxqv1Fr0EAAAAAAVHSkvnuD1UAAAAAAF7eRvjXv1EAAAAAAyeV/vqVO1EAAAAAA5INevsuh00AAAAAAW7E/vpHt0kAAAAAAZogjvoMv0kAAAAAAAwkKvrpr0UAAAAAA+aDnvTSi0EAAAAAAXCDBvWfVz0AAAAAAqoLZv4NRy0AAAAAALv+hvfcGz0AAAAAAAwmKvVg5zkAAAAAA/Yd0vYtszUAAAAAAak1zvSBBzUAAAAAA1xJyveQUzUAAAAAAIEFxvTLmzEAAAAAARdhwvd21zEAAAAAARdhwvbaEzEAAAAAAIEFxvb1SzEAAAAAAs3tyvSEfzEAAAAAARrZzvYXry0AAAAAAayt2vRe3y0AAAAAAkKB4vQaBy0AAAAAASFB8vfVKy0AAAAAAhXwcwLRZw0AAAAAAbjSAveQUy0AAAAAA3EaDvcX+ykAAAAAAb/CFvTLmykAAAAAAcM6IvRTQykAAAAAAcayLvSS5ykAAAAAAcoqOvQWjykAAAAAA4XqUvWx4ykAAAAAAUI2XvSBjykAAAAAACD2bvQFNykAAAAAAUrievbU3ykAAAAAAeJyivTojykAAAAAA5x2nve0NykAAAAAAMCqpvaMBykAAAAAAVp+rvVr1yUAAAAAAexSuvbPqyUAAAAAAxSCwvTvfyUAAAAAA6pWyvfLSyUAAAAAAoda0vUvIyUAAAAAAx0u3vQK8yUAAAAAAWvW5vVuxyUAAAAAA7Z68vYenyUAAAAAA7ny/veCcyUAAAAAAgSbCvQyTyUAAAAAAgQTFvQmKyUAAAAAA1CvlvRUdyUAAAAAAXW0FviS5yEAAAAAALNQavjVeyEAAAAAADi0yvqYKyEAAAAAAlkNLvki/x0AAAAAA5q5lvhx8x0AAAAAAZaqAvqs+x0AAAAAA4L6OvsgHx0AAAAAAyAedvnPXxkAAAAAAlkOrvqytxkAAAAAAEFi5vs6IxkAAAAAAH4XLvpVlxkAAAAAAAwnKvjhnxkAAAAAA54zIvjhnxkAAAAAAsAPHvgpoxkAAAAAAOwHNvsNkxkAAAAAAO3DOvvFjxkAAAAAA0ETYvpJcxkAAAAAAV+zPvk5ixkAAAAAAV1vRvtlfxkAAAAAAWMrSvgdfxkAAAAAAWDnUvmRdxkAAAAAAIo7VvpJcxkAAAAAA6+LWvpJcxkAAAAAAiIXavgRWxkAAAAAAJLncvkhQxkAAAAAA2/nevl5LxkAAAAAAkzrhvhdIxkAAAAAASnvjvtBExkAAAAAAMzPzvoY4xkAAAAAAArzlvrhAxkAAAAAAufznvkI+xkAAAAAAcT3qvs07xkAAAAAAKH7svlg5xkAAAAAAxLHuvoY4xkAAAAAAfPLwvoY4xkAAAAAA9Gz2vsoyxkAAAAAAtab5vj0sxkAAAAAAduD8vlInxkAAAAAAqRMAvzojxkAAAAAApb0Bv08exkAAAAAAE2EDvzcaxkAAAAAAnREFv00VxkAAAAAAC7UGvzQRxkAAAAAAlWUIv0oMxkAAAAAAHhYKv18HxkAAAAAAGsALv6MBxkAAAAAADk8Pv7n8xUAAAAAAgEgPv7n8xUAAAAAApHANv7n8xUAAAAAAUwWrv90kwkAAAAAASS4Pv7n8xUAAAAAApHANv7n8xUAAAAAAgEgPv7n8xUAAAAAA9wYPv7n8xUAAAAAAidIOv7n8xUAAAAAAG54Ov7n8xUAAAAAAIGMOv7n8xUAAAAAAJCgOv7n8xUAAAAAAKe0Nv7n8xUAAAAAASL8Nv7n8xUAAAAAA9pcNv7n8xUAAAAAAv30Nv7n8xUAAAAAABoFJwDm0uEAAAAAAZvcEwJtVu0AAAAAAwcoxwOzAsUAAAAAARiUFQFdbu8AAAAAAdZMcQM9mw8AAAAAA9pdJQIPAuMAAAAAAtvMxQEvIscAAAAAA2IFzQISeq8AAAAAAjLlbQECkpcAAAAAAZveMQPkxnMAAAAAAPQqBQNEil8AAAAAA+zqeQJOpisAAAAAAdk+SQPd1hsAAAAAAA3ihQFafZ8AAAAAAnl6tQN5xbsAAAAAAsi66QCEfRMAAAAAASFCuQLTIPsAAAAAA4XrEQPW5FsAAAAAAHqe4QJ/NEsAAAAAA1xLMQJhMzb8AAAAA6UjAQFInyL8AAAAAnMTQQM4ZUb8AAAAAsAPFQKMBTL8AAAAAduCMwKMjWcAAAAAA9P1wwOauOcAAAAAA6GqDwG1WGcAAAAAA46WZwA5PM8AAAAAANKLGQBe30TkAAAAAqmDSQBe30TkAAAAAdQLMwEYlzT8AAAAALUPAwAAAyD8AAAAAvp+4wFK4EkAAAAAArWnEwAWjFkAAAAAAF0iuwGizPkAAAAAATx66wI4GREAAAAAAXW2hwAmKZ0AAAAAAPE6twEtZbkAAAAAAW0KSwFFrhkAAAAAAayuewO2eikAAAAAAUPyAwPwYl0AAAAAA1eeMwK8lnEAAAAAAyJhbwA+cpUAAAAAAoWdzwDqSq0AAAAAA6GqrP8cpwsAAAAAA+zoQP6MBxsAAAAAAbqPZPxNhy8AAAAAAYHYPPxsNxsAAAAAAukkMPzQRxsAAAAAA0gAOPxsNxsAAAAAARPoNPxsNxsAAAAAAexQOPxsNxsAAAAAAPzUOPxsNxsAAAAAAIGMOPxsNxsAAAAAAcooOPxsNxsAAAAAAUrgOPxsNxsAAAAAAMuYOPxsNxsAAAAAAoBoPPxsNxsAAAAAAZDsPPxsNxsAAAAAAKVwPPxsNxsAAAAAA0m8PPxsNxsAAAAAAMZkKP00VxsAAAAAAp+gIPzcaxsAAAAAAqz4HPyEfxsAAAAAAIo4FP90kxsAAAAAAmN0DP2srxsAAAAAADi0CPycxxsAAAAAAhXwAP+M2xsAAAAAA9pf9PnE9xsAAAAAA/kP6PltCxsAAAAAA6+L2PqJFxsAAAAAA2IHzPulIxsAAAAAAc2jxPl5LxsAAAAAADk/vPtNNxsAAAAAAqDXtPkhQxsAAAAAAKA/rPr1SxsAAAAAAjNvoPmFUxsAAAAAAC7XmPjJVxsAAAAAAVHTkPgRWxsAAAAAA003iPnlYxsAAAAAAGw3gPh1axsAAAAAAZMzdPpJcxsAAAAAArIvbPgdfxsAAAAAA9UrZPnxhxsAAAAAA2c7XPvFjxsAAAAAA2V/WPpVlxsAAAAAA2PDUPgpoxsAAAAAA847TPn9qxsAAAAAA8x/SPiJsxsAAAAAA8rDQPvRsxsAAAAAA8kHPPphuxsAAAAAAKe3NPg1xxsAAAAAAKH7MPt5xxsAAAAAADALLPlR0xsAAAAAADJPJPsl2xsAAAAAA8BbIPj55xsAAAAAA4za6PryWxsAAAAAATRWsPvW5xsAAAAAASL+dPuvixsAAAAAAYHaPPp0Rx8AAAAAA5WGBPgtGx8AAAAAAi2xnPtiBx8AAAAAAOwFNPtbFx8AAAAAA6gQ0PmIQyMAAAAAAP8YcPiBjyMAAAAAA3pMHPrG/yMAAAAAAZ0TpPdEiycAAAAAAg1HJPcWPycAAAAAAy6HFPQ+cycAAAAAA7lrCPYenycAAAAAAEhS/PdCzycAAAAAAowG8PRrAycAAAAAAEFi5PZLLycAAAAAAfa62PdzXycAAAAAA6gS0PVTjycAAAAAAxY+xPZ7vycAAAAAADk+vPef7ycAAAAAA6NmsPV8HysAAAAAAn82qPakTysAAAAAAeVioPfMfysAAAAAAwaikPT81ysAAAAAA5WGhPYxKysAAAAAACRuePapgysAAAAAACD2bPcl2ysAAAAAAB1+YPbmNysAAAAAAdLWVPamkysAAAAAAvJaQPVvTysAAAAAABFaOPRzrysAAAAAA3+CLPd4Cy8AAAAAAldSJPXEby8AAAAAAcF+HPTMzy8AAAAAA3bWEPc9my8AAAAAALNRqP1Z90MAAAAAAuECCPciYy8AAAAAA3GiAPZLLy8AAAAAAtvN9PS7/y8AAAAAASFB8PScxzMAAAAAA/kN6PSBjzMAAAAAAI9t5PUaUzMAAAAAAI9t5PRHHzMAAAAAAI9t5PTj4zMAAAAAA/kN6PV8pzcAAAAAAkX57PYZazcAAAAAAJLl8PQmKzcAAAAAAcoqOPdZWzsAAAAAAMEymPaMjz8AAAAAAXW3FPZ7vz8AAAAAAjLnrPfW50MAAAAAAqz4DQN213sAAAAAAgy8MPmN/0cAAAAAA5q4lPrhA0sAAAAAAE/JBPn/70sAAAAAAnMRgPhSu08AAAAAAJQaBPnlY1MAAAAAAPL2SPpT21MAAAAAAeHqlPgmK1cAAAAAAhxa5Pr8O1sAAAAAA63P1P2iR6cAAAAAApb1Bv4xKsEAAAAAAMlVAP4xKsEAAAAAAw2QquxDpsUAAAAAAMne9v/OOq0AAAAAA3bW8P/OOq0AAAAAAYqEKwG/wo0AAAAAAcT0KQG/wo0AAAAAA/7IzwG6jmUAAAAAAak0zQG6jmUAAAAAA8IVZwAHejEAAAAAAHcklvw6+lkAAAAAAw2Qqu8UgmEAAAAAAxm0kPw6+lkAAAAAAuB5ZQAHejEAAAAAAc2ihP5aykkAAAAAA1xKiv5aykkAAAAAAKH7sP+AtjEAAAAAAjSjtv+AtjEAAAAAAuK97wBSue0AAAAAAOUV7QBSue0AAAAAAnl4ZQHBfg0AAAAAAdLUZwHBfg0AAAAAAXro5QGDlcEAAAAAA7Q06wGDlcEAAAAAAduCMwPCFWUAAAAAAZaqMQPCFWUAAAAAAqvFWQJAxV0AAAAAA3EZXwJAxV0AAAAAA46WZwEa2M0AAAAAA0m+ZQEa2M0AAAAAAHqdwQIv9OUAAAAAA9P1wwIv9OUAAAAAAIEGDQLWmGUAAAAAA6GqDwLWmGUAAAAAAnzyMwMZt7L8AAAAAiPSjwHE9CsAAAAAAIEGDQG1WGcAAAAAA0m+ZQA5PM8AAAAAA07yjQHE9CsAAAAAANBGMQMZt7L8AAAAA+1yrQAisvL8AAAAA6pWSQBBYob8AAAAAOpKrwAisvL8AAAAAVcGSwBBYob8AAAAA+8uWwI9TJL8AAAAA002wwG40QL8AAAAAYqGWQMbcJT8AAAAA8BawQPfkQT8AAAAA+1yrQE2EvT8AAAAA6pWSQJEPoj8AAAAAVTCYwInSXjsAAAAA+u2xwInSXjsAAAAA6gSYQInSXjsAAAAARraxQInSXjsAAAAAObTQwEXYUD8AAAAAIv3EwBrASz8AAAAAYqGWQI9TJL8AAAAA8BawQG40QL8AAAAA+8uWwMbcJT8AAAAA002wwPfkQT8AAAAAVcGSwJEPoj8AAAAAOpKrwE2EvT8AAAAAnzyMwOQU7T8AAAAAiPSjwEymCkAAAAAA07yjQEymCkAAAAAANBGMQOQU7T8AAAAAHqdwQOauOcAAAAAAZaqMQKMjWcAAAAAA3EZXwOviVsAAAAAAqvFWQOviVsAAAAAA7Q06wLyWcMAAAAAAXro5QLyWcMAAAAAAOUV7QMdLe8AAAAAAuK97wMdLe8AAAAAAdLUZwHo2g8AAAAAAnl4ZQHo2g8AAAAAAuB5ZQE+vjMAAAAAA8IVZwE+vjMAAAAAAjSjtv+oEjMAAAAAAKH7sP+oEjMAAAAAA1xKiv86IksAAAAAAc2ihP86IksAAAAAAak0zQGB2mcAAAAAA/7IzwGB2mcAAAAAAHcklv0aUlsAAAAAAxm0kP0aUlsAAAAAAw2Qqu/32l8AAAAAAcT0KQDPEo8AAAAAAYqEKwDPEo8AAAAAA3bW8P4hjq8AAAAAAMne9v4hjq8AAAAAAMlVAPyEfsMAAAAAApb1BvyEfsMAAAAAAw2Qqu3e+scAAAAAASFDSwG8Sg7oAAAAASZ3GwG8Sg7oAAAAAAAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAgL8AAAAAAAAAAAAAgL8AAAAAAAAAAAAAgL8AAAAAAAAAAAAAgL8AAAAAAAAAAAAAgL8AAAAAAAAAAAAAgL8AAAAAAAAAAAAAgL8AAAAAAAAAAAAAgL8AAAAAAAAAAAAAgL8AAAAAAAAAAAAAgL8AAAAAAAAAAAAAgL8AAAAAAAAAAAAAgL8AAAAAAAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAABAAIAAwABAAAAAwAEAAEAAwAFAAQAAwAGAAUAAwAHAAYAAwAIAAcAAwAJAAgAAwAKAAkAAwALAAoAAwAMAAsADQAMAAMADQAOAAwADQAPAA4ADQAQAA8ADQARABAADQASABEADQATABIADQAUABMADQAVABQADQAWABUADQAXABYADQAYABcADQAZABgADQAaABkADQAbABoAHAAbAA0AHAAdABsAHAAeAB0AHAAfAB4AHAAgAB8AHAAhACAAHAAiACEAHAAjACIAHAAkACMAHAAlACQAHAAmACUAHAAnACYAHAAoACcAHAApACgAHAAqACkAHAArACoAHAAsACsAHAAtACwAHAAuAC0AHAAvAC4AHAAwAC8AHAAxADAAHAAyADEAHAAzADIAHAA0ADMAHAA1ADQAHAA2ADUAHAA3ADYAHAA4ADcAHAA5ADgAHAA6ADkAHAA7ADoAHAA8ADsAHAA9ADwAHAA+AD0AHAA/AD4AHABAAD8AQABBAD8AQQBCAD8AQgBDAD8AHABAAEQAHABEAEUAHABGAEUARgBHAEUARgBIAEcARgBJAEgARgBKAEkARgBLAEoARgBMAEsAHABNAEYAHABOAE0AHABPAE4AHABQAE8AHABRAFAAHABSAFEAUgBTAFEAUgBUAFMAUgBVAFQAUgBWAFUAUgBXAFYAUgBYAFcAHABZAFIAHABaAFkAHABbAFoAHABcAFsAHABdAFwAHABeAF0AHABfAF4AHABgAF8AHABhAGAAHABiAGEAHABjAGIAHABjAGQAZABlAGMAZQBmAGMAHABnAGQAaABpAGoAawBpAGgAbABpAGsAbQBpAGwAbgBpAG0AbwBpAG4AcABpAG8AcQBpAHAAcgBpAHEAcwBpAHIAdABnABwAdAB1AGcAdAB2AHUAdwB4AHkAdwB5AHoAegB5AHsAegB7AHwAfAB7AH0AfAB9AH4AfgB9AH8AfgB/AIAAgQCCAIMAgQCDAIQAhACDAIUAhACFAIYAhgCFAIcAhgCHAIgAiACHAIkAiACJAIoAiwCMAI0AiwCNAI4AjwCKAJAAigCJAJAAkQCSAJMAkQCTAJQAlACTAJUAlACVAJYAlgCVAJcAlgCXAJgAgAB/AIIAgACCAIEAmACXAJkAmACZAJoAmgCZAJsAmgCbAJwAnACbAJ0AnACdAJ4AngCdAHYAngB2AHQAnwB4AHcAoAB4AJ8AoAChAHgAogChAKAAowCkAKUAowCmAKQAowCnAKYAowCoAKcAowCpAKgAowCqAKkAowCrAKoAowCsAKsAowCtAKwAowCuAK0AowCvAK4AowCiAK8AowChAKIAsAChAKMAsQChALAAsgChALEAswChALIAtAChALMAtQChALQAtgChALUAtwChALYAuAChALcAuQChALgAugChALkAuwChALoAvAChALsAvQChALwAvgChAL0AvwChAL4AwAChAL8AwQChAMAAwgChAMEAwwChAMIAxAChAMMAxQChAMQAxgChAMUAxwChAMYAyAChAMcAyQChAMgAygChAMkAywChAMoAzAChAMsAzQChAMwAzgChAM0AzwChAM4A0AChAM8A0QChANAA0gChANEA0wChANIA1AChANMA1QChANQA1gChANUA1wChANYA2AChANcA2QChANgA2gChANkA2wChANoA3AChANsA3QChANwA3gChAN0A3wChAN4A4AChAN8A4QChAOAA4gChAOEA4wChAOIA5AChAOMA5QChAOQA5gChAOUA5wChAOYA6AChAOcA6QChAOgA6gChAOkA6wChAOoA7AChAOsA7QChAOwA7gChAO0A7wChAO4A8AChAO8A8QChAO8A8gChAPEA8wChAPIA9AChAPMA9QChAPQA9gChAPUA9gD3AKEA+AD3APYA+QD3APgA+gD3APkA+wD3APoA/AD3APsA/QD3APwA/gD3AP0A/wD3AP4AAAH3AP8AAQH3AAABAgH3AAEBAwH3AAIBBAH3AAMBBQH3AAQBBgH3AAUBBgEHAfcACAEHAQYBCQEHAQgBCgEHAQkBCwEHAQoBDAEHAQsBDQEHAQwBDgEHAQ0BDwEHAQ4BEAEHAQ8BEQESARMBFAESAREBFAEVARIBFgEVARQBFgEXARUBGAEXARYBGAEZARcBGgEbARgBGwEcARgBHAEZARgBHAEdARkBHQEeARkBHwEeAR0BGgEgARsBIQEeAR8BGgEiASABIwEiARoBIQEkAR4BJQEkASEBIwEmASIBJwEkASUBIwEoASYBKQEoASMBJwEqASQBKwEqAScBKQEsASgBLQEsASkBKwEuASoBLwEuASsBLQEwASwBMQEuAS8BLQEyATABjgCNADMBjgAzATQBNQE2ATcBNQE3ATgBOAE3ATkBOAE5AToBOwE8AT0BOwE9AT4BPwFAAUEBPwFBAUIBPgE9AUMBPgFDAUQBRQFGAUABRQFAAT8BRwFIAZIARwGSAJEASQFKAUYBSQFGAUUBRAFDAUsBRAFLAUwBOgE5AUoBOgFKAUkBTAFLAU0BTAFNAU4BTgFNAU8BTgFPAVABQgFBAVEBQgFRAVIBUgFRAS4BUgEuATEBNAEzATwBNAE8ATsBUwFUATYBUwE2ATUBUAFPATIBUAEyAS0BiwBVAYwAVgFUAVMBiwBXAVUBWAFUAVYBWAFZAVQBWgFXAYsAWgFbAVcBXAFZAVgBXAFdAVkBXgFbAVoBXgFfAVsBYAFdAVwBXgFhAV8BYgFdAWABYgFjAV0BZAFhAV4BZAFlAWEBZgFjAWIBZAFnAWUBZwFjAWYBZAFjAWcBZAFoAWMBaQFoAWQBaQFqAWgBawFqAWkBawFsAWoBbQFsAWsBbQFuAWwBbwFwAUgBbwFIAUcBAAA="
            }
        ],
        bufferViews: [
            {
                name: "bufferView_0",
                buffer: 0,
                byteLength: 4428,
                byteOffset: 0,
                byteStride: 12,
                target: 34962
            },
            {
                name: "bufferView_1",
                buffer: 0,
                byteLength: 4428,
                byteOffset: 4428,
                byteStride: 12,
                target: 34962
            },
            {
                name: "bufferView_2",
                buffer: 0,
                byteLength: 2180,
                byteOffset: 8856,
                target: 34963
            }
        ],
        materials: [
            {
                name: "SVGMat",
                pbrMetallicRoughness: {
                    baseColorFactor: [
                        .5,
                        .5,
                        .5,
                        1
                    ],
                    metallicFactor: 0,
                    roughnessFactor: 1
                },
                emissiveFactor: [
                    0,
                    0,
                    0
                ],
                alphaMode: "OPAQUE",
                doubleSided: !1
            }
        ],
        meshes: [
            {
                name: "\uFFFD\uFFFD\u05EA001_1",
                primitives: [
                    {
                        attributes: {
                            POSITION: 0,
                            NORMAL: 1
                        },
                        indices: 2,
                        material: 0,
                        mode: 4
                    }
                ]
            }
        ],
        nodes: [
            {
                name: "\uFFFD\uFFFD\u05EA001",
                mesh: 0
            }
        ],
        scene: 0,
        scenes: [
            {
                nodes: [
                    0
                ]
            }
        ]
    },
    plane: {
        accessors: [
            {
                name: "Rectangle001_1_0_positions",
                componentType: 5126,
                count: 4,
                min: [
                    -5,
                    -5,
                    0
                ],
                max: [
                    5,
                    5,
                    0
                ],
                type: "VEC3",
                bufferView: 0,
                byteOffset: 0
            },
            {
                name: "Rectangle001_1_0_normals",
                componentType: 5126,
                count: 4,
                min: [
                    0,
                    0,
                    1
                ],
                max: [
                    0,
                    0,
                    1
                ],
                type: "VEC3",
                bufferView: 1,
                byteOffset: 0
            },
            {
                name: "Rectangle001_1_0_indices",
                componentType: 5123,
                count: 6,
                min: [
                    0
                ],
                max: [
                    3
                ],
                type: "SCALAR",
                bufferView: 2,
                byteOffset: 0
            }
        ],
        asset: {
            generator: "obj2gltf",
            version: "2.0"
        },
        buffers: [
            {
                name: "plane",
                byteLength: 108,
                uri: "data:application/octet-stream;base64,AACgQAAAoEAAAAAAAACgwAAAoEAAAAAAAACgwAAAoMAAAAAAAACgQAAAoMAAAAAAAAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAAAAAAAAAAAAIA/AAABAAIAAgADAAAA"
            }
        ],
        bufferViews: [
            {
                name: "bufferView_0",
                buffer: 0,
                byteLength: 48,
                byteOffset: 0,
                byteStride: 12,
                target: 34962
            },
            {
                name: "bufferView_1",
                buffer: 0,
                byteLength: 48,
                byteOffset: 48,
                byteStride: 12,
                target: 34962
            },
            {
                name: "bufferView_2",
                buffer: 0,
                byteLength: 12,
                byteOffset: 96,
                target: 34963
            }
        ],
        materials: [
            {
                name: "wire_225198087",
                pbrMetallicRoughness: {
                    baseColorFactor: [
                        .8824,
                        .7765,
                        .3412,
                        1
                    ],
                    metallicFactor: 0,
                    roughnessFactor: .968
                },
                emissiveFactor: [
                    0,
                    0,
                    0
                ],
                alphaMode: "OPAQUE",
                doubleSided: !1
            }
        ],
        meshes: [
            {
                name: "Rectangle001_1",
                primitives: [
                    {
                        attributes: {
                            POSITION: 0,
                            NORMAL: 1
                        },
                        indices: 2,
                        material: 0,
                        mode: 4
                    }
                ]
            }
        ],
        nodes: [
            {
                name: "Rectangle001",
                mesh: 0
            }
        ],
        scene: 0,
        scenes: [
            {
                nodes: [
                    0
                ]
            }
        ]
    },
    xyzScale: {
        asset: {
            generator: "Khronos glTF Blender I/O v1.6.16",
            version: "2.0"
        },
        scene: 0,
        scenes: [
            {
                name: "Scene",
                nodes: [
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6
                ]
            }
        ],
        nodes: [
            {
                mesh: 0,
                name: "Cube",
                scale: [
                    .7008190751075745,
                    .014999999664723873,
                    .014999999664723873
                ]
            },
            {
                mesh: 1,
                name: "Cube.001",
                scale: [
                    .10000000149011612,
                    .10000000149011612,
                    .10000000149011612
                ]
            },
            {
                mesh: 2,
                name: "Cube.004",
                rotation: [
                    0,
                    -0.7071068286895752,
                    0,
                    .7071068286895752
                ],
                scale: [
                    .7008190751075745,
                    .014999999664723873,
                    .014999999664723873
                ]
            },
            {
                mesh: 3,
                name: "Cube.003",
                rotation: [
                    0,
                    -0.7071068286895752,
                    0,
                    .7071068286895752
                ],
                scale: [
                    .10000000149011612,
                    .10000000149011612,
                    .10000000149011612
                ]
            },
            {
                mesh: 4,
                name: "Cube.006",
                rotation: [
                    0,
                    0,
                    .7071068286895752,
                    .7071068286895752
                ],
                scale: [
                    .7008190751075745,
                    .014999999664723873,
                    .014999999664723873
                ]
            },
            {
                mesh: 5,
                name: "Cube.005",
                rotation: [
                    0,
                    0,
                    .7071068286895752,
                    .7071068286895752
                ],
                scale: [
                    .10000000149011612,
                    .10000000149011612,
                    .10000000149011612
                ]
            },
            {
                mesh: 6,
                name: "Cube.002",
                scale: [
                    .10000000149011612,
                    .10000000149011612,
                    .10000000149011612
                ]
            }
        ],
        materials: [
            {
                doubleSided: !0,
                name: "Material",
                pbrMetallicRoughness: {
                    baseColorFactor: [
                        .6938720345497131,
                        .020288480445742607,
                        .011612260714173317,
                        1
                    ],
                    metallicFactor: 0,
                    roughnessFactor: .4000000059604645
                }
            },
            {
                doubleSided: !0,
                name: "Material.001",
                pbrMetallicRoughness: {
                    baseColorFactor: [
                        .6938720345497131,
                        .020288480445742607,
                        .011612260714173317,
                        1
                    ],
                    metallicFactor: 0,
                    roughnessFactor: .4000000059604645
                }
            },
            {
                doubleSided: !0,
                name: "Material.002",
                pbrMetallicRoughness: {
                    baseColorFactor: [
                        .626582869887352,
                        .626582869887352,
                        .626582869887352,
                        1
                    ],
                    metallicFactor: 0,
                    roughnessFactor: .4000000059604645
                }
            },
            {
                doubleSided: !0,
                name: "Material.006",
                pbrMetallicRoughness: {
                    baseColorFactor: [
                        .11193240433931351,
                        .5583405494689941,
                        .033104799687862396,
                        1
                    ],
                    metallicFactor: 0,
                    roughnessFactor: .4000000059604645
                }
            },
            {
                doubleSided: !0,
                name: "Material.005",
                pbrMetallicRoughness: {
                    baseColorFactor: [
                        .11193240433931351,
                        .5583405494689941,
                        .033104799687862396,
                        1
                    ],
                    metallicFactor: 0,
                    roughnessFactor: .4000000059604645
                }
            },
            {
                doubleSided: !0,
                name: "Material.010",
                pbrMetallicRoughness: {
                    baseColorFactor: [
                        .004391402006149292,
                        .21223078668117523,
                        .5209956169128418,
                        1
                    ],
                    metallicFactor: 0,
                    roughnessFactor: .4000000059604645
                }
            },
            {
                doubleSided: !0,
                name: "Material.009",
                pbrMetallicRoughness: {
                    baseColorFactor: [
                        .004391402006149292,
                        .21223078668117523,
                        .5209956169128418,
                        1
                    ],
                    metallicFactor: 0,
                    roughnessFactor: .4000000059604645
                }
            }
        ],
        meshes: [
            {
                name: "Cube",
                primitives: [
                    {
                        attributes: {
                            POSITION: 0,
                            NORMAL: 1,
                            TEXCOORD_0: 2
                        },
                        indices: 3,
                        material: 0
                    }
                ]
            },
            {
                name: "Cube.001",
                primitives: [
                    {
                        attributes: {
                            POSITION: 4,
                            NORMAL: 5,
                            TEXCOORD_0: 6
                        },
                        indices: 3,
                        material: 1
                    }
                ]
            },
            {
                name: "Cube.006",
                primitives: [
                    {
                        attributes: {
                            POSITION: 10,
                            NORMAL: 11,
                            TEXCOORD_0: 12
                        },
                        indices: 3,
                        material: 3
                    }
                ]
            },
            {
                name: "Cube.005",
                primitives: [
                    {
                        attributes: {
                            POSITION: 13,
                            NORMAL: 14,
                            TEXCOORD_0: 15
                        },
                        indices: 3,
                        material: 4
                    }
                ]
            },
            {
                name: "Cube.010",
                primitives: [
                    {
                        attributes: {
                            POSITION: 16,
                            NORMAL: 17,
                            TEXCOORD_0: 18
                        },
                        indices: 3,
                        material: 5
                    }
                ]
            },
            {
                name: "Cube.009",
                primitives: [
                    {
                        attributes: {
                            POSITION: 19,
                            NORMAL: 20,
                            TEXCOORD_0: 21
                        },
                        indices: 3,
                        material: 6
                    }
                ]
            },
            {
                name: "Cube.002",
                primitives: [
                    {
                        attributes: {
                            POSITION: 7,
                            NORMAL: 8,
                            TEXCOORD_0: 9
                        },
                        indices: 3,
                        material: 2
                    }
                ]
            }
        ],
        accessors: [
            {
                bufferView: 0,
                componentType: 5126,
                count: 24,
                max: [
                    2.0003609657287598,
                    1,
                    1
                ],
                min: [
                    .0003610849380493164,
                    -1,
                    -1
                ],
                type: "VEC3"
            },
            {
                bufferView: 1,
                componentType: 5126,
                count: 24,
                type: "VEC3"
            },
            {
                bufferView: 2,
                componentType: 5126,
                count: 24,
                type: "VEC2"
            },
            {
                bufferView: 3,
                componentType: 5123,
                count: 36,
                type: "SCALAR"
            },
            {
                bufferView: 4,
                componentType: 5126,
                count: 24,
                max: [
                    14.549108505249023,
                    1,
                    1
                ],
                min: [
                    12.549108505249023,
                    -1,
                    -1
                ],
                type: "VEC3"
            },
            {
                bufferView: 5,
                componentType: 5126,
                count: 24,
                type: "VEC3"
            },
            {
                bufferView: 6,
                componentType: 5126,
                count: 24,
                type: "VEC2"
            },
            {
                bufferView: 7,
                componentType: 5126,
                count: 24,
                max: [
                    1,
                    1,
                    1
                ],
                min: [
                    -1,
                    -1,
                    -1
                ],
                type: "VEC3"
            },
            {
                bufferView: 8,
                componentType: 5126,
                count: 24,
                type: "VEC3"
            },
            {
                bufferView: 9,
                componentType: 5126,
                count: 24,
                type: "VEC2"
            },
            {
                bufferView: 10,
                componentType: 5126,
                count: 24,
                max: [
                    2.0003609657287598,
                    1,
                    1
                ],
                min: [
                    .0003610849380493164,
                    -1,
                    -1
                ],
                type: "VEC3"
            },
            {
                bufferView: 11,
                componentType: 5126,
                count: 24,
                type: "VEC3"
            },
            {
                bufferView: 12,
                componentType: 5126,
                count: 24,
                type: "VEC2"
            },
            {
                bufferView: 13,
                componentType: 5126,
                count: 24,
                max: [
                    14.549108505249023,
                    1,
                    1
                ],
                min: [
                    12.549108505249023,
                    -1,
                    -1
                ],
                type: "VEC3"
            },
            {
                bufferView: 14,
                componentType: 5126,
                count: 24,
                type: "VEC3"
            },
            {
                bufferView: 15,
                componentType: 5126,
                count: 24,
                type: "VEC2"
            },
            {
                bufferView: 16,
                componentType: 5126,
                count: 24,
                max: [
                    2.0003609657287598,
                    1,
                    1
                ],
                min: [
                    .0003610849380493164,
                    -1,
                    -1
                ],
                type: "VEC3"
            },
            {
                bufferView: 17,
                componentType: 5126,
                count: 24,
                type: "VEC3"
            },
            {
                bufferView: 18,
                componentType: 5126,
                count: 24,
                type: "VEC2"
            },
            {
                bufferView: 19,
                componentType: 5126,
                count: 24,
                max: [
                    14.549108505249023,
                    1,
                    1
                ],
                min: [
                    12.549108505249023,
                    -1,
                    -1
                ],
                type: "VEC3"
            },
            {
                bufferView: 20,
                componentType: 5126,
                count: 24,
                type: "VEC3"
            },
            {
                bufferView: 21,
                componentType: 5126,
                count: 24,
                type: "VEC2"
            }
        ],
        bufferViews: [
            {
                buffer: 0,
                byteLength: 288,
                byteOffset: 0
            },
            {
                buffer: 0,
                byteLength: 288,
                byteOffset: 288
            },
            {
                buffer: 0,
                byteLength: 192,
                byteOffset: 576
            },
            {
                buffer: 0,
                byteLength: 72,
                byteOffset: 768
            },
            {
                buffer: 0,
                byteLength: 288,
                byteOffset: 840
            },
            {
                buffer: 0,
                byteLength: 288,
                byteOffset: 1128
            },
            {
                buffer: 0,
                byteLength: 192,
                byteOffset: 1416
            },
            {
                buffer: 0,
                byteLength: 288,
                byteOffset: 1608
            },
            {
                buffer: 0,
                byteLength: 288,
                byteOffset: 1896
            },
            {
                buffer: 0,
                byteLength: 192,
                byteOffset: 2184
            },
            {
                buffer: 0,
                byteLength: 288,
                byteOffset: 2376
            },
            {
                buffer: 0,
                byteLength: 288,
                byteOffset: 2664
            },
            {
                buffer: 0,
                byteLength: 192,
                byteOffset: 2952
            },
            {
                buffer: 0,
                byteLength: 288,
                byteOffset: 3144
            },
            {
                buffer: 0,
                byteLength: 288,
                byteOffset: 3432
            },
            {
                buffer: 0,
                byteLength: 192,
                byteOffset: 3720
            },
            {
                buffer: 0,
                byteLength: 288,
                byteOffset: 3912
            },
            {
                buffer: 0,
                byteLength: 288,
                byteOffset: 4200
            },
            {
                buffer: 0,
                byteLength: 192,
                byteOffset: 4488
            },
            {
                buffer: 0,
                byteLength: 288,
                byteOffset: 4680
            },
            {
                buffer: 0,
                byteLength: 288,
                byteOffset: 4968
            },
            {
                buffer: 0,
                byteLength: 192,
                byteOffset: 5256
            }
        ],
        buffers: [
            {
                byteLength: 5448,
                uri: "data:application/octet-stream;base64,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"
            }
        ]
    }
}, $0ff02aa1df83de88$var$Q = function() {
    if ("undefined" != typeof globalThis) return globalThis;
    if ("undefined" != typeof self) return self;
    if ("undefined" != typeof window) return window;
    if ("undefined" != typeof $parcel$global) return $parcel$global;
    throw new Error("unable to locate global object");
}, $0ff02aa1df83de88$var$f = $0ff02aa1df83de88$var$Q(), $0ff02aa1df83de88$var$l = $0ff02aa1df83de88$var$f.gl_trans__coders = $0ff02aa1df83de88$var$f.gl_trans__coders || {};
$0ff02aa1df83de88$var$l.inject = function(A) {
    const e = A.toString(), t = e.indexOf("{") + 1, s = e.substring(0, t), i = $0ff02aa1df83de88$var$f.gl_trans__coders = $0ff02aa1df83de88$var$f.gl_trans__coders || {};
    let n = `${s}\n    const _____getGlobal = ${$0ff02aa1df83de88$var$Q.toString()};\n    const g___lobals = _____getGlobal()\n    const tran_____scoders = g___lobals['gl_trans__coders'] = g___lobals['gl_trans__coders'] || {};`;
    for(const A in i)"inject" !== A && "getTranscoder" !== A && "registerTranscoder" !== A && (n += 'tran_____scoders["' + A + '"] =' + i[A].toString() + "\n;");
    return n += "\n(" + $0ff02aa1df83de88$var$Q().maptalks_gltf_loader_bundle.toString() + ")({});\n", n += "\n" + e.substring(s.length), n;
}, $0ff02aa1df83de88$var$l.registerTranscoder = function(A, e) {
    $0ff02aa1df83de88$var$l[A] = e;
}, $0ff02aa1df83de88$var$l.getTranscoder = function(A) {
    return $0ff02aa1df83de88$var$l[A];
};
const $0ff02aa1df83de88$var$P = $0ff02aa1df83de88$var$Q().maptalks_gltf_loader;
function $0ff02aa1df83de88$var$D(s, i, n, I, o, g) {
    const r = [], a = (0, $k1dpP).fromEuler([], n[0], n[1], n[2]), C = (0, $3iqbd).fromRotationTranslationScale([], a, i, I), h = function(A) {
        return new $0ff02aa1df83de88$var$P.GLTFLoader("", JSON.parse(JSON.stringify($0ff02aa1df83de88$var$c[A]))).load().then((A)=>A);
    }(s);
    return h.then((A)=>{
        (0, $2wazW).GLTFHelper.exportGLTFPack(A).getMeshesInfo().forEach((A, s)=>{
            const a = new (0, $2wazW).Material({
                color: o || A.materialInfo.baseColorFactor
            }), h = new (0, $2wazW).Mesh(A.geometry, a);
            h.setUniform("uPickingId", g + s);
            const w = h.getDefines();
            w.HAS_PICKING_ID = 2, h.setDefines(w), h.translate = i, h.rotation = n, h.scaling = I, (0, $3iqbd).multiply(h.localTransform, C, A.nodeMatrix), h.originTransform = (0, $3iqbd).copy([], h.localTransform), h.originColor = o || A.materialInfo.baseColorFactor, r.push(h);
        }), g > 100 && (r[0].properties.relatedMeshes = r.slice(1, 2), r[1].properties.relatedMeshes = r.slice(0, 1), r[2].properties.relatedMeshes = r.slice(3, 4), r[3].properties.relatedMeshes = r.slice(2, 3), r[4].properties.relatedMeshes = r.slice(5, 6), r[5].properties.relatedMeshes = r.slice(4, 5), r[6].properties.relatedMeshes = r.slice(0, 6));
    }), r;
}
function $0ff02aa1df83de88$var$u(A, e) {
    return Math.abs(A) * Math.sign(e);
}
function $0ff02aa1df83de88$var$m(A, e) {
    const t = A.getCoordinates(), i = e.coordinateToPointAtRes(t, e.getGLRes()), I = [
        i.x,
        i.y,
        0
    ], o = $0ff02aa1df83de88$var$b(e, A.getTranslation());
    (0, $eIStk).add(I, I, o);
    const g = function(A, e, t, s) {
        return A._pointAtResToContainerPoint(e, t, s);
    }(e, new $gP1US.Point(I[0], I[1]), e.getGLRes());
    g.x += 85;
    const r = function(A, e, t, s) {
        {
            const s = A.containerPointToCoordinate(e);
            return A.coordinateToPointAtRes(s, t);
        }
    }(e, g, e.getGLRes());
    return Math.sqrt(Math.pow(r.x - I[0], 2) + Math.pow(r.y - I[1], 2)) / 5.272881136101205;
}
function $0ff02aa1df83de88$var$b(A, e) {
    if (!A) return e;
    const t = A.distanceToPointAtRes(e[0], e[1], A.getGLRes()), i = A.altitudeToPoint(e[2], A.getGLRes());
    return (0, $eIStk).set([], $0ff02aa1df83de88$var$u(t.x, e[0]), $0ff02aa1df83de88$var$u(t.y, e[1]), $0ff02aa1df83de88$var$u(i, e[2]));
}
class $0ff02aa1df83de88$var$B {
    constructor(A){
        this.A = A, this._meshes = this.t();
    }
    setCoordinate(A) {
        this.A = A;
    }
    t() {
        const A = [], e = 340 / 177, t = $0ff02aa1df83de88$var$D("jiantou", [
            1.2 * e,
            0,
            0
        ], [
            0,
            0,
            90
        ], [
            e,
            e,
            e
        ], [
            89 / 255,
            206 / 255,
            147 / 255,
            0
        ], 7), s = $0ff02aa1df83de88$var$D("jiantou", [
            0,
            1.2 * e,
            0
        ], [
            0,
            0,
            180
        ], [
            e,
            e,
            e
        ], [
            89 / 255,
            206 / 255,
            147 / 255,
            0
        ], 8), i = $0ff02aa1df83de88$var$D("jiantou", [
            -1.2 * e,
            0,
            0
        ], [
            0,
            0,
            270
        ], [
            e,
            e,
            e
        ], [
            89 / 255,
            206 / 255,
            147 / 255,
            0
        ], 9), n = $0ff02aa1df83de88$var$D("jiantou", [
            0,
            -1.2 * e,
            0
        ], [
            0,
            0,
            0
        ], [
            e,
            e,
            e
        ], [
            89 / 255,
            206 / 255,
            147 / 255,
            0
        ], 10);
        return A.push(t, s, i, n), A;
    }
    getMeshes() {
        return this._meshes;
    }
}
class $0ff02aa1df83de88$var$y {
    constructor(A){
        this.A = A, this._meshes = this.t();
    }
    setCoordinate(A) {
        this.A = A;
    }
    t() {
        const A = [], e = 340 / 177, t = $0ff02aa1df83de88$var$D("xuanzhuan", [
            0,
            0,
            0
        ], [
            180,
            0,
            0
        ], [
            .5 * e,
            .5 * e,
            .5 * e
        ], [
            50 / 255,
            130 / 255,
            184 / 255,
            .8
        ], 11);
        return A.push(t), A;
    }
    getMeshes() {
        return this._meshes;
    }
}
class $0ff02aa1df83de88$var$p {
    constructor(A){
        this.A = A, this._meshes = this.t();
    }
    setCoordinate(A) {
        this.A = A;
    }
    t() {
        const A = [], e = 340 / 177, t = $0ff02aa1df83de88$var$D("yuanhuan", [
            0,
            0,
            0
        ], [
            0,
            0,
            0
        ], [
            .5 * e,
            .5 * e,
            .5 * e
        ], [
            149 / 255,
            179 / 255,
            199 / 255,
            .5
        ], 12);
        return A.push(t), A;
    }
    getMeshes() {
        return this._meshes;
    }
}
class $0ff02aa1df83de88$var$v {
    constructor(A){
        this.A = A, this._meshes = this.t();
    }
    setCoordinate(A) {
        this.A = A;
    }
    t() {
        const A = [], e = $0ff02aa1df83de88$var$D("plane", [
            0,
            0,
            0
        ], [
            0,
            0,
            0
        ], [
            10,
            10,
            10
        ], [
            1,
            0,
            0,
            .5
        ], 16);
        return A.push(e), A;
    }
    getMeshes() {
        return this._meshes;
    }
}
class $0ff02aa1df83de88$var$d {
    constructor(A){
        this.A = A, this._meshes = this.t();
    }
    setCoordinate(A) {
        this.A = A;
    }
    t() {
        const A = [], e = $0ff02aa1df83de88$var$D("xyzScale", [
            0,
            0,
            0
        ], [
            0,
            0,
            0
        ], [
            2,
            2,
            2
        ], null, 113);
        return A.push(e), A;
    }
    getMeshes() {
        return this._meshes;
    }
}
const $0ff02aa1df83de88$var$L = [], $0ff02aa1df83de88$var$M = [], $0ff02aa1df83de88$var$E = [], $0ff02aa1df83de88$var$O = [], $0ff02aa1df83de88$var$F = [], $0ff02aa1df83de88$var$x = [
    177 / 170,
    177 / 170,
    177 / 170
], $0ff02aa1df83de88$var$U = [], $0ff02aa1df83de88$var$V = [
    1,
    2,
    3,
    4,
    12
];
class $0ff02aa1df83de88$var$S {
    constructor(){
        this.translate = new $0ff02aa1df83de88$var$B, this.rotation = new $0ff02aa1df83de88$var$y, this.scaling = new $0ff02aa1df83de88$var$p, this.planeHelper = new $0ff02aa1df83de88$var$v, this.xyzScaleHelper = new $0ff02aa1df83de88$var$d, this._meshes = this.t(), this.i = !0;
    }
    t() {
        const A = {};
        A.translate = this.translate.getMeshes(), A.rotation = this.rotation.getMeshes(), A.scaling = this.scaling.getMeshes(), A.planeHelper = this.planeHelper.getMeshes(), A.xyzScale = this.xyzScaleHelper.getMeshes();
        const e = 340 / 177, t = $0ff02aa1df83de88$var$D("yuanhuan41", [
            -2.745 * e,
            2.745 * e,
            0
        ], [
            90,
            0,
            0
        ], [
            .5 * e,
            .5 * e,
            .5 * e
        ], [
            149 / 255,
            179 / 255,
            199 / 255,
            .6
        ], 1), s = $0ff02aa1df83de88$var$D("yuanhuan41", [
            2.745 * e,
            2.745 * e,
            0
        ], [
            -90,
            0,
            180
        ], [
            .5 * e,
            .5 * e,
            .5 * e
        ], [
            50 / 255,
            130 / 255,
            184 / 255,
            .5
        ], 2), i = $0ff02aa1df83de88$var$D("yuanhuan41", [
            2.745 * e,
            -2.745 * e,
            0
        ], [
            90,
            0,
            180
        ], [
            .5 * e,
            .5 * e,
            .5 * e
        ], [
            149 / 255,
            179 / 255,
            199 / 255,
            .6
        ], 3), n = $0ff02aa1df83de88$var$D("yuanhuan41", [
            -2.745 * e,
            -2.745 * e,
            0
        ], [
            -90,
            0,
            0
        ], [
            .5 * e,
            .5 * e,
            .5 * e
        ], [
            50 / 255,
            130 / 255,
            184 / 255,
            .5
        ], 4), I = $0ff02aa1df83de88$var$D("yuanpan", [
            0,
            0,
            0
        ], [
            90,
            0,
            0
        ], [
            .5 * e,
            .5 * e,
            .5 * e
        ], [
            89 / 255,
            206 / 255,
            147 / 255,
            .5
        ], 5), o = $0ff02aa1df83de88$var$D("zzhou", [
            0,
            0,
            6.5
        ], [
            90,
            0,
            0
        ], [
            1,
            1,
            1
        ], [
            14 / 255,
            127 / 255,
            191 / 255,
            1
        ], 6);
        return A.translate.push(t, s, i, n, I, o), A;
    }
    updateMatrix(t, i, n, I, o) {
        const g = i.getCoordinates(), r = t.coordinateToPointAtRes(g, t.getGLRes()), a = i.I();
        (0, $eIStk).set($0ff02aa1df83de88$var$M, r.x, r.y, a);
        const C = (0, $eIStk).copy($0ff02aa1df83de88$var$L, o), h = $0ff02aa1df83de88$var$b(t, i.getTranslation());
        (0, $eIStk).add($0ff02aa1df83de88$var$M, $0ff02aa1df83de88$var$M, h), (0, $eIStk).add($0ff02aa1df83de88$var$M, $0ff02aa1df83de88$var$M, C);
        for(const o in this._meshes)for(let g = 0; g < this._meshes[o].length; g++){
            const r = this._meshes[o][g];
            for(let g = 0; g < r.length; g++){
                const a = r[g], C = a.getUniform("uPickingId"), h = (0, $eIStk).copy($0ff02aa1df83de88$var$L, a.translate);
                let w = (0, $eIStk).copy($0ff02aa1df83de88$var$U, a.rotation);
                const c = a.scaling;
                if (11 === C && (this.i ? (w[2] += n, a.rotation[2] += n) : this.i || (w[2] += n, a.rotation[2] += n, w[0] = 360, w[2] -= 90)), C > 100 && 1 === i.getTargets().length && (w = i.getTargets()[0].getRotation()), $0ff02aa1df83de88$var$V.indexOf(C) > -1) {
                    if (12 !== C) c[0] += I, c[1] += I, c[2] += I;
                    else {
                        const A = this._meshes.translate[4][0];
                        c[0] = 1.2 * A.scaling[0], c[1] = 1.2 * A.scaling[0], c[2] = 1.2 * A.scaling[0];
                    }
                }
                let Q = $0ff02aa1df83de88$var$m(i, t);
                if (Q = (0, $eIStk).set($0ff02aa1df83de88$var$E, Q, Q, Q), (0, $eIStk).multiply(h, h, Q), (0, $eIStk).multiply(Q, Q, c), 1 === C || 2 === C || 3 === C || 4 === C) {
                    const A = (0, $eIStk).multiply($0ff02aa1df83de88$var$F, c, $0ff02aa1df83de88$var$x);
                    (0, $eIStk).multiply(h, h, A);
                }
                const f = (0, $k1dpP).fromEuler($0ff02aa1df83de88$var$O, w[0], w[1], w[2]);
                if ((0, $eIStk).add(h, h, $0ff02aa1df83de88$var$M), "xyzScale" === o) {
                    const A = (0, $3iqbd).fromRotationTranslationScale([], f, h, Q);
                    (0, $3iqbd).multiply(a.localTransform, A, a.originTransform);
                } else (0, $3iqbd).fromRotationTranslationScale(a.localTransform, f, h, Q);
            }
        }
    }
    getMeshes(A) {
        const e = {};
        return A ? ("xyzScale" === A ? e[A] = this._meshes[A] : (e.translate = this._meshes.translate, "translate" !== A && (e[A] = this._meshes[A])), e) : e;
    }
    o(A) {
        this.i = A;
    }
    dispose() {
        for(const A in this._meshes)for(let e = 0; e < this._meshes[A].length; e++){
            const t = this._meshes[A][e];
            for(let A = 0; A < t.length; A++){
                const e = t[A];
                e.geometry.dispose(), e.dispose();
            }
        }
    }
}
const $0ff02aa1df83de88$var$k = [], $0ff02aa1df83de88$var$T = [], $0ff02aa1df83de88$var$_ = [], $0ff02aa1df83de88$var$H = new (0, $gP1US.Point)(0, 0), $0ff02aa1df83de88$var$J = [], $0ff02aa1df83de88$var$N = [], $0ff02aa1df83de88$var$R = [], $0ff02aa1df83de88$var$K = [
    0,
    0,
    0
];
class $0ff02aa1df83de88$var$z {
    constructor(){
        this.C = [], this.h = [
            0,
            0,
            0
        ], this.l = [
            1,
            1,
            1
        ], this.P = [
            0,
            0,
            0
        ];
    }
    D(A) {
        Array.isArray(A) ? A.forEach((A)=>{
            this.D(A);
        }) : (A.on("remove", this.u, this), A.m = {
            coordinate: A.getCoordinates(),
            translation: A.getTranslation(),
            rotation: A.getRotation(),
            scale: A.getScale()
        }, this.C.push(A));
    }
    B() {
        this.C.forEach((A)=>{
            A.off("remove", this.u, this);
        }), this.C = [];
    }
    p(A, e, t, i, n, I, o) {
        for(let o = 0; o < this.C.length; o++){
            const g = this.C[o], r = g.getRotation(), a = g.getScale(), C = this.v(I, g, i, t, e);
            let h = null;
            h = i >= 0 ? i : i * (this.options && this.options.scaleStrength || 1);
            const w = (0, $eIStk).add($0ff02aa1df83de88$var$R, (0, $eIStk).set($0ff02aa1df83de88$var$k, h * a[0], h * a[1], h * a[2]), a), c = Math.min(...w);
            if (Math.abs(c) < n) {
                const A = Math.abs(c);
                w[0] = w[0] * (n / A), w[1] = w[1] * (n / A), w[2] = w[2] * (n / A);
            }
            const Q = (0, $eIStk).add(r, t, r);
            g.setCoordinates(C), this.L(A, w, a);
            const f = g.getTranslation();
            g.setTRS(f, Q, w);
        }
        (0, $eIStk).set($0ff02aa1df83de88$var$R, i, i, i), (0, $eIStk).add(this.P, t, this.P), (0, $eIStk).add(this.l, $0ff02aa1df83de88$var$R, this.l), (0, $eIStk).add(this.h, e, this.h), A.indexOf("translate") > -1 ? o.fire("positionchange", {
            action: A,
            type: "positionchange",
            transformtarget: this.C,
            center: this.getCoordinates(),
            scale: this.l,
            rotation: this.P,
            translation: this.h,
            deltaTranslate: e,
            deltaRotation: t,
            deltaScale: i
        }) : o.fire("transforming", {
            action: A,
            type: "transforming",
            transformtarget: this.C,
            center: this.C[0].getTransformOrigin(),
            scale: this.l,
            rotation: this.P,
            translation: this.h,
            deltaTranslate: e,
            deltaRotation: t,
            deltaScale: i
        });
    }
    v(t, i, n, I, o) {
        const g = i.getCenter(), r = i.getTransformOrigin(), a = t.getGLRes(), C = t.coordinateToPointAtRes(g, a, $0ff02aa1df83de88$var$H);
        C.z = t.altitudeToPoint(g.z, a), (0, $eIStk).set($0ff02aa1df83de88$var$J, C.x, C.y, C.z || 0);
        const h = t.coordinateToPointAtRes(r, a, $0ff02aa1df83de88$var$H);
        h.z = t.altitudeToPoint(r.z, a), (0, $eIStk).set($0ff02aa1df83de88$var$N, h.x, h.y, h.z || 0);
        const w = (0, $eIStk).sub($0ff02aa1df83de88$var$k, $0ff02aa1df83de88$var$J, $0ff02aa1df83de88$var$N), c = (0, $k1dpP).fromEuler($0ff02aa1df83de88$var$T, 0, 0, I[2]);
        (0, $eIStk).set($0ff02aa1df83de88$var$R, n + 1, n + 1, n + 1);
        const Q = (0, $3iqbd).fromRotationTranslationScale($0ff02aa1df83de88$var$_, c, o, $0ff02aa1df83de88$var$R);
        (0, $eIStk).transformMat4(w, w, Q), (0, $eIStk).add(w, w, $0ff02aa1df83de88$var$N), $0ff02aa1df83de88$var$H.set(w[0], w[1]);
        const f = t.pointAtResToCoordinate($0ff02aa1df83de88$var$H, a);
        return f.z = w[2] / t.altitudeToPoint(1, a), f;
    }
    L(A, e, t) {
        return "x-scale" === A && (e[1] = t[1], e[2] = t[2]), "y-scale" === A && (e[0] = t[0], e[2] = t[2]), "z-scale" === A && (e[0] = t[0], e[1] = t[1]), e;
    }
    M() {
        this.C.forEach((A)=>{
            if (A.m) {
                const { coordinate: e, translation: t, rotation: s, scale: i } = A.m;
                A.setCoordinates(e), A.setTRS(t, s, i);
            }
        });
    }
    getScale() {
        return this.l;
    }
    getTranslation() {
        return 1 === this.C.length && this.C[0].getTranslation() || $0ff02aa1df83de88$var$K;
    }
    getRotation() {
        return this.P;
    }
    O() {
        return this.C[0] ? this.C[0].getLayer() : null;
    }
    getCoordinates() {
        let A = 0, e = 0, t = 0;
        const s = this.C.length;
        if (!s) return null;
        for(let i = 0; i < s; i++){
            const s = this.C[i].getCenter();
            A += s.x, e += s.y, t += s.z || 0;
        }
        A /= s, e /= s, t /= s;
        const i = new (0, $gP1US.Coordinate)(A, e, t);
        for(let A = 0; A < s; A++)this.C[A].setTransformOrigin(i);
        return i;
    }
    u(A) {
        const e = A.target, t = this.C.indexOf(e);
        t > -1 && (delete e.m, this.C.splice(t, 1));
    }
    getTargets() {
        return this.C;
    }
    I() {
        let A = 0;
        const e = this.C.length;
        for(let t = 0; t < e; t++)A += this.C[t].getPointZ();
        return A /= e, A;
    }
    F() {
        for(let A = 0; A < this.C.length; A++)if (this.C[A].isVisible()) return !0;
        return !1;
    }
}
const $0ff02aa1df83de88$var$G = [
    5,
    6,
    7,
    8,
    9,
    10
], $0ff02aa1df83de88$var$j = [
    5,
    7,
    8,
    9,
    10
], $0ff02aa1df83de88$var$Z = [
    2,
    4,
    11
], $0ff02aa1df83de88$var$Y = [
    1,
    3,
    12
], $0ff02aa1df83de88$var$W = [
    12,
    16
], $0ff02aa1df83de88$var$q = [
    1,
    2,
    3,
    4
], $0ff02aa1df83de88$var$X = [
    1,
    2,
    3,
    4,
    12
], $0ff02aa1df83de88$var$$ = [], $0ff02aa1df83de88$var$AA = [], $0ff02aa1df83de88$var$eA = [], $0ff02aa1df83de88$var$tA = [], $0ff02aa1df83de88$var$sA = [], $0ff02aa1df83de88$var$iA = [], $0ff02aa1df83de88$var$nA = [];
class $0ff02aa1df83de88$export$6e0be10329607c45 extends (0, $gP1US.Eventable)((0, $gP1US.Handlerable)((0, $gP1US.Class))) {
    constructor(A = {}){
        super(A), this.options = A, this.mouseAction = "moving", this.U = this.options.mode || "translate", this.V = !0, this.TransformHelper = new $0ff02aa1df83de88$var$S, this.S = new $0ff02aa1df83de88$var$z, this.helperScene = new (0, $2wazW).Scene([]), this.addToMapCount = 0, this.k();
    }
    setCoordinates(A) {
        this.T.setCoordinates(A), this.transform(this.T);
    }
    enable() {
        return this.V = !0, this.layerRenderer && this.layerRenderer.setToRedraw(), this;
    }
    disable() {
        return this.V = !1, this.layerRenderer && this.layerRenderer.setToRedraw(), this.map && this.map.resetCursor(), this;
    }
    setMode(A) {
        this.U = A, this._(), this.layerRenderer && this.layerRenderer.setToRedraw(), this.fire("modechange", {
            mode: A,
            type: "modechange"
        });
    }
    getMode() {
        return this.U;
    }
    isEnable() {
        return this.V;
    }
    H(A) {
        $0ff02aa1df83de88$var$G.indexOf(A) > -1 ? this.U = "translate" : $0ff02aa1df83de88$var$Z.indexOf(A) > -1 ? this.U = "rotation" : $0ff02aa1df83de88$var$Y.indexOf(A) > -1 ? this.U = "scaling" : "xyzScale" !== this.U && (this.U = "translate");
    }
    J() {
        return this.U;
    }
    addTo(A) {
        if (this.map) return this.N(), void console.warn("transform control has been added to a map, it suggest remove from the map before");
        this.addToMapCount++, this.map = A, this.R.addTo(this.map), this.container = A.getContainer(), A.on("dom:mousemove", this.K, this), A.on("dom:mousedown", this.G, this), A.on("dom:mouseup", this.j, this), A.on("zooming moving dragrotating", this.Z, this), this.Y();
    }
    k() {
        this.R = new (0, $f87d9fed9ae75f45$export$444d0e1ec10e51d5)(`${(0, $gP1US.INTERNAL_LAYER_PREFIX)}_transformcontrol`), this.T = new (0, $f87d9fed9ae75f45$export$f502975d4e0f97bb)([
            0,
            0
        ], {
            symbol: {
                url: "cube",
                modelHeight: 1,
                uniforms: {
                    polygonOpacity: .01
                }
            }
        }).addTo(this.R);
    }
    remove() {
        this.map && (this.N(), this.TransformHelper.dispose(), this.R.remove(), this.layerRenderer && this.layerRenderer.setToRedraw(), delete this.T, delete this.R, delete this.map, delete this.layer, delete this.layerRenderer, delete this.container, delete this.S);
    }
    N() {
        this.container && this.map && (this.map.off("dom:mousemove", this.K, this), this.map.off("dom:mousedown", this.G, this), this.map.off("dom:mouseup", this.j, this), this.map.off("zooming moving dragrotating", this.Z, this), this.layer && this.layer.off("renderend", this.render, this));
    }
    K(A) {
        if (this.W()) {
            if (this.currentMousePosition = {
                x: A.containerPoint.x,
                y: A.containerPoint.y
            }, "moving" === this.mouseAction) {
                const A = this.q();
                this.currentPickingObject = this.X(this.currentMousePosition, A, "meshes"), this.currentPickingObject && null != this.currentPickingObject.pickingId ? (this.H(this.currentPickingObject.pickingId), 6 === this.currentPickingObject.pickingId ? this.$(!0) : this.$(!1)) : (this.$(!1), this.H()), this.AA();
            }
            this.eA(this.currentMousePosition);
        }
    }
    G(A) {
        if (!this.W() || 0 !== A.domEvent.button) return;
        const e = this.q();
        this.currentMousePosition = {
            x: A.containerPoint.x,
            y: A.containerPoint.y
        }, this.tA = !0, this.currentPickingObject = this.X(this.currentMousePosition, e, "meshes"), this.firstDownPoint = this.X(this.currentMousePosition, e, "meshes"), this.currentPickingObject && null != this.currentPickingObject.meshId ? (this.mouseAction = "transform", this.sA(this.currentPickingObject.pickingId), this.map.config("zoomable", !1), this.map.config("draggable", !1), this.layerRenderer && this.layerRenderer.setToRedraw()) : (this.mouseAction = "pan", this.map.config("zoomable", !0), this.map.config("draggable", !0), this._()), this.lastMousePosition = this.currentMousePosition, this.lastPickingObject = this.currentPickingObject, this.lastPickingMesh = e[this.currentPickingObject.meshId];
    }
    j() {
        "transform" === this.mouseAction && (this.firstDownPoint = null, this._(), this.tA = !0, this.fire("transformend", {
            action: this.iA,
            type: "transformend",
            transformtarget: this.S.getTargets()
        })), this.mouseAction = "moving", "xyzScale" !== this.U && (this.U = "translate"), this.map.config("zoomable", !0), this.map.config("draggable", !0), this.layerRenderer && this.layerRenderer.setToRedraw();
    }
    Z() {
        const A = this.TransformHelper.planeHelper.getMeshes()[0][0], e = this.map.getBearing();
        A.rotation[2] = -e, this.nA();
    }
    nA() {
        this.W() && (this.TransformHelper.updateMatrix(this.map, this.S, 0, 0, [
            0,
            0,
            0
        ]), this.tA = !0);
    }
    picked(A) {
        if (!this.layerRenderer) return !1;
        const e = this.q(), t = this.map;
        let s = A;
        A instanceof (0, $gP1US.Point) || (s = t.coordinateToContainerPoint(new (0, $gP1US.Coordinate)(A)));
        const i = this.X(s, e, "picked");
        return !(!i || null === i.meshId);
    }
    _() {
        const A = this.TransformHelper.getMeshes("scaling").scaling[0][0], e = 340 / 177;
        A.scaling = [
            .6 * e,
            .6 * e,
            .6 * e
        ], this.layerRenderer && (this.IA(A), this.oA());
    }
    oA() {
        this.TransformHelper._meshes.translate.forEach((A)=>{
            for(let e = 0; e < A.length; e++){
                const t = A[e];
                $0ff02aa1df83de88$var$q.indexOf(t.getUniform("uPickingId")) > -1 && t.material.set("color", t.originColor);
            }
        });
    }
    IA(t) {
        const i = this.S.getCoordinates(), n = this.map.coordinateToPointAtRes(i, this.map.getGLRes()), I = [
            n.x,
            n.y,
            0
        ], o = $0ff02aa1df83de88$var$b(this.map, this.S.getTranslation());
        (0, $eIStk).add(I, I, o);
        const g = (0, $eIStk).copy([], t.translate), r = t.scaling;
        let a = $0ff02aa1df83de88$var$m(this.S, this.map);
        a = (0, $eIStk).set([], a, a, a), (0, $eIStk).multiply(g, g, a), (0, $eIStk).multiply(a, a, r), (0, $eIStk).add(g, g, I), (0, $3iqbd).fromRotationTranslationScale(t.localTransform, [
            0,
            0,
            0,
            1
        ], g, a);
        this.q().forEach((t)=>{
            const i = t.getUniform("uPickingId");
            if (1 === i || 3 === i || 2 === i || 4 === i) {
                const i = (0, $eIStk).copy([], t.translate), n = 170 / 177;
                t.scaling = [
                    n,
                    n,
                    n
                ];
                const o = t.scaling, g = t.rotation;
                let r = $0ff02aa1df83de88$var$m(this.S, this.map);
                r = (0, $eIStk).set([], r, r, r), (0, $eIStk).multiply(i, i, r), (0, $eIStk).multiply(r, r, o), (0, $eIStk).add(i, i, I);
                const a = (0, $k1dpP).fromEuler([], g[0], g[1], g[2]);
                (0, $3iqbd).fromRotationTranslationScale(t.localTransform, a, i, r);
            }
        });
    }
    gA(A) {
        const e = this.map.containerPointToCoordinate(A), t = this.map.coordinateToPointAtRes(e, this.map.getGLRes());
        return {
            point: [
                t.x,
                t.y
            ]
        };
    }
    eA(A) {
        if ("transform" === this.mouseAction) {
            const A = this.J(), e = $0ff02aa1df83de88$var$b(this.map, this.S.getTranslation()), t = this.S.I();
            let s = null, n = null;
            if (e[2] + t < .01 && "z-translate" !== this.iA) s = this.gA(this.currentMousePosition), n = this.gA(this.lastMousePosition);
            else {
                const A = this.TransformHelper.planeHelper.getMeshes()[0];
                if (s = this.X(this.currentMousePosition, A, "plane"), n = this.X(this.lastMousePosition, A, "plane"), !s || null === s.meshId || !n || null === n.meshId) return;
            }
            const o = [
                0,
                0,
                0
            ], g = [
                0,
                0,
                0
            ];
            let r = 0, a = 0, C = 0;
            if ("translate" === A) {
                if ("xy-translate" === this.iA) {
                    const A = s.point[0] - n.point[0], e = s.point[1] - n.point[1];
                    o[0] = A, o[1] = e;
                } else if ("x-translate" === this.iA) {
                    const A = s.point[0] - n.point[0];
                    o[0] = A;
                } else if ("y-translate" === this.iA) {
                    const A = s.point[1] - n.point[1];
                    o[1] = A;
                } else if ("z-translate" === this.iA) {
                    let A = 0;
                    if (this.rA()) {
                        const e = this.map.getGLRes(), t = this.map._pointAtResToContainerPoint(new (0, $gP1US.Point)(n.point[0], n.point[1]), e), o = this.map._pointAtResToContainerPoint(new (0, $gP1US.Point)(s.point[0], s.point[1]), e), g = (0, $6BoVD).length((0, $6BoVD).set($0ff02aa1df83de88$var$tA, s.point[0] - n.point[0], s.point[1] - n.point[1]));
                        A = o.y < t.y ? g : -g;
                    } else A = s.point[2] - n.point[2];
                    o[2] = A;
                }
            } else if ("rotation" === A) a = this.aA(s.point, n.point), a >= 0 ? this.TransformHelper.o(!0) : this.TransformHelper.o(!1), g[2] += a;
            else if ("scaling" === A || "xyzScale" === A) {
                const A = this.CA(), e = (0, $6BoVD).length((0, $6BoVD).set($0ff02aa1df83de88$var$tA, this.firstDownPoint.point[0] - A[0], this.firstDownPoint.point[1] - A[1])), t = (0, $6BoVD).length((0, $6BoVD).set($0ff02aa1df83de88$var$tA, n.point[0] - A[0], n.point[1] - A[1]));
                r = this.hA(s.point, n.point, A, t), C = this.hA(s.point, n.point, A, e);
            }
            this.TransformHelper.updateMatrix(this.map, this.S, a, C, o), this.S.p(this.iA, o, g, r, .01, this.map, this);
        }
        this.lastMousePosition = A, this.lastPickingObject = this.currentPickingObject;
        const e = this.q();
        this.lastPickingMesh = e[this.currentPickingObject.meshId];
    }
    hA(A, e, t, s, n) {
        const I = ((0, $6BoVD).length((0, $6BoVD).set($0ff02aa1df83de88$var$tA, A[0] - t[0], A[1] - t[1])) - (0, $6BoVD).length((0, $6BoVD).set($0ff02aa1df83de88$var$tA, e[0] - t[0], e[1] - t[1]))) / s;
        return n ? (n[0] - .01) * I : I;
    }
    CA() {
        const A = this.map, e = this.S.getCoordinates(), t = A.coordinateToPointAtRes(e, A.getGLRes()), i = (0, $eIStk).set($0ff02aa1df83de88$var$sA, t.x, t.y, 0), n = $0ff02aa1df83de88$var$b(A, this.S.getTranslation());
        return (0, $eIStk).add(i, i, n), i;
    }
    $(t) {
        const i = this.TransformHelper.planeHelper.getMeshes()[0][0], n = (0, $3iqbd).getTranslation($0ff02aa1df83de88$var$eA, i.localTransform), I = (0, $3iqbd).getScaling($0ff02aa1df83de88$var$AA, i.localTransform);
        let o = (0, $k1dpP).fromEuler($0ff02aa1df83de88$var$$, 0, 0, 0);
        const g = this.map.getBearing();
        t && !this.rA() ? (o = (0, $k1dpP).fromEuler($0ff02aa1df83de88$var$$, 90, 0, -g), 0 === i.rotation[0] && (this.tA = !0), (0, $eIStk).set(i.rotation, 90, 0, -g)) : (90 === i.rotation[0] && (this.tA = !0), (0, $eIStk).set(i.rotation, 0, 0, -g)), (0, $3iqbd).fromRotationTranslationScale(i.localTransform, o, n, I);
    }
    rA() {
        if (this.map.getPitch()) return !1;
        const A = this.map.cameraPosition, e = this.map.coordinateToPointAtRes(this.map.getCenter(), this.map.getGLRes());
        (0, $eIStk).set(e, e.x, e.y, 0);
        const t = this.S.getCoordinates(), i = this.map.coordinateToPointAtRes(t, this.map.getGLRes()), n = $0ff02aa1df83de88$var$b(this.map, this.S.getTranslation()), I = (0, $eIStk).set($0ff02aa1df83de88$var$eA, i.x, i.y, 0), o = (0, $eIStk).add(I, I, n), g = (0, $eIStk).subtract([], A, o), r = (0, $eIStk).subtract([], A, e);
        return (0, $eIStk).angle(g, r) < 1 / 180 * Math.PI;
    }
    AA() {
        const A = this.q();
        if (this.currentPickingObject && null != this.currentPickingObject.meshId) {
            this.wA(), this.lastPickingObject && null != this.lastPickingObject.meshId && this.lastPickingObject.meshId !== this.currentPickingObject.meshId && this.cA();
            const e = A[this.currentPickingObject.meshId];
            if (e && $0ff02aa1df83de88$var$W.indexOf(this.currentPickingObject.pickingId) < 0) {
                if (this.currentPickingObject.pickingId > 100) this.QA(e);
                else {
                    const A = [
                        e.originColor[0],
                        e.originColor[1],
                        e.originColor[2],
                        .8
                    ];
                    e.material.set("color", A), this.fA(e, .5);
                }
            }
            this.layerRenderer.setToRedraw();
        } else this.lastPickingObject && null != this.lastPickingObject.meshId && (this.map.resetCursor(), this.cA(), this.layerRenderer.setToRedraw());
    }
    QA(A) {
        const e = [
            1,
            179 / 255,
            2 / 255,
            1
        ];
        A.material.set("color", e), A.properties.relatedMeshes && A.properties.relatedMeshes.forEach((A)=>{
            A.material.set("color", e);
        });
    }
    wA() {
        6 === this.currentPickingObject.pickingId ? this.map.setCursor("ns-resize") : $0ff02aa1df83de88$var$j.indexOf(this.currentPickingObject.pickingId) > -1 ? this.map.setCursor("move") : this.map.setCursor("pointer");
    }
    cA() {
        const A = this.lastPickingMesh;
        if (!A) return;
        const e = A.getUniform("uPickingId"), t = this.q();
        $0ff02aa1df83de88$var$j.indexOf(e) > -1 ? t.forEach((A)=>{
            $0ff02aa1df83de88$var$j.indexOf(A.getUniform("uPickingId")) > -1 && A.material.set("color", A.originColor);
        }) : $0ff02aa1df83de88$var$X.indexOf(e) > -1 ? t.forEach((A)=>{
            const e = A.getUniform("uPickingId");
            $0ff02aa1df83de88$var$q.indexOf(e) > -1 && A.material.set("color", A.originColor);
        }) : 11 === e && t.forEach((A)=>{
            $0ff02aa1df83de88$var$q.indexOf(A.getUniform("uPickingId")) > -1 && A.material.set("color", A.originColor);
        }), A.material.set("color", A.originColor), A.properties.relatedMeshes && A.properties.relatedMeshes.forEach((A)=>{
            A.material.set("color", A.originColor);
        });
    }
    fA(A, e) {
        const t = A.getUniform("uPickingId"), s = this.q();
        $0ff02aa1df83de88$var$j.indexOf(t) > -1 ? s.forEach((t)=>{
            if ($0ff02aa1df83de88$var$j.indexOf(t.getUniform("uPickingId")) > -1 && t.getUniform("uPickingId") !== A.getUniform("uPickingId")) {
                const A = [
                    t.originColor[0],
                    t.originColor[1],
                    t.originColor[2],
                    e
                ];
                t.material.set("color", A);
            }
        }) : "scaling" === this.U ? s.forEach((A)=>{
            const e = A.getUniform("uPickingId");
            if (1 === e || 3 === e || 2 === e || 4 === e) {
                const e = [
                    149 / 255,
                    179 / 255,
                    199 / 255,
                    .8
                ];
                A.material.set("color", e);
            }
        }) : "rotation" === this.U && s.forEach((A)=>{
            const e = A.getUniform("uPickingId");
            if (1 === e || 3 === e || 2 === e || 4 === e) {
                const e = A.originColor;
                A.material.set("color", [
                    e[0],
                    e[1],
                    e[2],
                    0
                ]);
            }
        });
    }
    reset() {
        this.map && this.S && (this.S.M(), this.TransformHelper.updateMatrix(this.map, this.S, 0, 0, [
            0,
            0,
            0
        ]));
    }
    aA(A, e) {
        const t = this.CA(), s = (0, $6BoVD).set($0ff02aa1df83de88$var$iA, e[0] - t[0], e[1] - t[1]), n = (0, $6BoVD).set($0ff02aa1df83de88$var$nA, A[0] - t[0], A[1] - t[1]), I = Math.atan2(s[1], s[0]);
        return (Math.atan2(n[1], n[0]) - I) / Math.PI * 180;
    }
    sA(A) {
        return this.iA = 113 === A || 114 === A ? "x-scale" : 115 === A || 116 === A ? "z-scale" : 117 === A || 118 === A ? "y-scale" : 119 === A ? "xyz-scale" : 5 === A ? "xy-translate" : 6 === A ? "z-translate" : 7 === A || 9 === A ? "x-translate" : 8 === A || 10 === A ? "y-translate" : 11 === A ? "z-rotate" : "scale", this.iA;
    }
    transform(A) {
        if (!A) return;
        if (this.layerRenderer && this.layerRenderer.layer && (this.layerRenderer.layer.off("renderend", this.render), this.layerRenderer.layer.off("resizeCanvas", this.lA)), !this.map) return void console.error("should add to a target first");
        if (this.S && (this.S.B(), this.S.D(A)), !this.S.getTargets().length) return;
        const e = this.map;
        this.TransformHelper.updateMatrix(e, this.S, 0, 0, [
            0,
            0,
            0
        ]), this.PA(), this.tA = !0;
    }
    getTransformTarget() {
        return this.S;
    }
    u() {
        delete this.S;
    }
    PA() {
        const A = this.S.O();
        A && (A.off("renderend", this.render), A.off("resizeCanvas", this.lA));
        const e = this.map, t = A.getRenderer();
        this.layerRenderer = t, this.regl = t.regl, this.renderer = t.renderer, this.DA = this.layerRenderer.getFBORayPicking(), this.uA = {
            projViewMatrix: e.projViewMatrix,
            projMatrix: e.projMatrix,
            viewMatrix: e.viewMatrix,
            pointSize: 1
        }, A.on("renderend", this.render, this), A.on("resizeCanvas", this.lA, this), t.setToRedraw();
    }
    lA() {
        this.DA.clear(), this.tA = !0;
    }
    X(A, e, t) {
        const s = this.map;
        if (!(s && this.DA && this.layerRenderer && this.layerRenderer.canvas)) return null;
        const i = s.getDevicePixelRatio(), n = A.x * i, I = A.y * i, o = this.uA, g = this.layerRenderer.canvas.gl && this.layerRenderer.canvas.gl.wrap;
        (this.tA || g || !this.mA || this.mA !== t) && (this.DA.render(e, o, !0), this.mA = t, this.tA = !1);
        return this.DA.pick(n, I, 10, o, {
            viewMatrix: this.map.viewMatrix,
            projMatrix: this.map.projMatrix,
            returnPoint: !0
        });
    }
    Y() {
        const A = this.map.getDevicePixelRatio(), s = {
            x: 0,
            y: 0,
            width: ()=>this.map ? this.map.width * A : 1,
            height: ()=>this.map ? this.map.height * A : 1
        };
        this.bA = new (0, $2wazW).MeshShader({
            vert: "attribute vec3 aPosition;\n\nuniform mat4 projViewModelMatrix;\n\n\n\nvoid main()\n\n{\n\n    gl_Position = projViewModelMatrix * vec4(aPosition, 1.0);\n\n\n\n}\n\n",
            frag: "precision mediump float;\n\nuniform vec4 color;\n\n\n\nvoid main() {\n\n    gl_FragColor = color;\n\n}\n\n",
            uniforms: [
                "color",
                {
                    name: "projViewModelMatrix",
                    type: "function",
                    fn: function(A, t) {
                        return (0, $3iqbd).multiply([], t.projViewMatrix, t.modelMatrix);
                    }
                }
            ],
            extraCommandProps: {
                viewport: s,
                depth: {
                    enable: !0,
                    func: "always",
                    mask: !0,
                    range: [
                        0,
                        0
                    ]
                },
                blend: {
                    enable: !0,
                    func: {
                        src: "src alpha",
                        dst: "one minus src alpha"
                    },
                    equation: "add"
                }
            },
            defines: {}
        });
    }
    render() {
        if (!this.W()) return;
        const A = this.q();
        this.helperScene.setMeshes(A);
        const e = this.layerRenderer.getFrameContext();
        if (e && e.renderTarget && this.layerRenderer.getFrameTimestamp() !== e.timestamp) return;
        this.nA(), this.bA.filter = e && e.sceneFilter;
        const t = e && e.renderTarget && e.renderTarget.fbo;
        this.renderer.render(this.bA, this.uA, this.helperScene, t);
    }
    q() {
        let A = [];
        const e = this.TransformHelper.getMeshes(this.U);
        for(const t in e){
            if ("translate" === t) continue;
            const s = e[t];
            for(let e = 0; e < s.length; e++)A = A.concat(s[e]);
        }
        const t = e.translate;
        if (t) for(let e = 0; e < t.length; e++)A = A.concat(t[e]);
        return A;
    }
    W() {
        const A = this.layerRenderer, e = A && A.layer;
        return A && this.S && e && e.isVisible() && this.S.F() && this.regl && this.V;
    }
}
$0ff02aa1df83de88$export$6e0be10329607c45.mergeOptions({
    scaleStrength: 2
});
"undefined" != typeof console && console.log("@maptalks/transform-control v0.105.4");


/*!
 * @maptalks/video-layer v0.102.3
 * LICENSE : UNLICENSED
 * (c) 2016-2025 maptalks.org
 */ 
var $gP1US = parcelRequire("gP1US");
parcelRequire("9e7Ip");
var $9I15V = parcelRequire("9I15V");
var $3iqbd = parcelRequire("3iqbd");
var $k1dpP = parcelRequire("k1dpP");
var $2wazW = parcelRequire("2wazW");
/*!
* Contains code from THREE.js
* MIT License
* https://github.com/mrdoob/three.js
*/ for(var $5984e8c1931379f1$var$c = [], $5984e8c1931379f1$var$u = 0; $5984e8c1931379f1$var$u < 6; $5984e8c1931379f1$var$u++)$5984e8c1931379f1$var$c[$5984e8c1931379f1$var$u] = [];
var $5984e8c1931379f1$var$p = [];
function $5984e8c1931379f1$var$f(t, e, i) {
    var s, r, o, n, a, h, l, d, u, f, _, g, x, w, y, b, O;
    r = (s = t)[0], o = s[1], n = s[2], a = s[3], h = s[4], l = s[5], d = s[6], u = s[7], f = s[8], _ = s[9], g = s[10], x = s[11], w = s[12], y = s[13], b = s[14], O = s[15], $5984e8c1931379f1$var$m($5984e8c1931379f1$var$c[0], a - r, u - h, x - f, O - w), $5984e8c1931379f1$var$m($5984e8c1931379f1$var$c[1], a + r, u + h, x + f, O + w), $5984e8c1931379f1$var$m($5984e8c1931379f1$var$c[2], a + o, u + l, x + _, O + y), $5984e8c1931379f1$var$m($5984e8c1931379f1$var$c[3], a - o, u - l, x - _, O - y), $5984e8c1931379f1$var$m($5984e8c1931379f1$var$c[4], a - n, u - d, x - g, O - b), $5984e8c1931379f1$var$m($5984e8c1931379f1$var$c[5], a + n, u + d, x + g, O + b);
    for(var S = 0; S < 6; S++){
        var T = $5984e8c1931379f1$var$c[S];
        if ($5984e8c1931379f1$var$p[0] = T[0] > 0 ? e[1][0] : e[0][0], $5984e8c1931379f1$var$p[1] = T[1] > 0 ? e[1][1] : e[0][1], $5984e8c1931379f1$var$p[2] = T[2] > 0 ? e[1][2] : e[0][2], $5984e8c1931379f1$var$v(T, $5984e8c1931379f1$var$p) < 0) return !1;
    }
    return !0;
}
function $5984e8c1931379f1$var$m(t, e, i, s, r) {
    var o = 1 / Math.sqrt(e * e + i * i + s * s);
    return t[0] = e * o, t[1] = i * o, t[2] = s * o, t[3] = r * o, t;
}
function $5984e8c1931379f1$var$v(t, e) {
    return t[0] * e[0] + t[1] * e[1] + t[2] * e[2] + t[3];
}
const $5984e8c1931379f1$var$_ = {
    vert: "\n    attribute vec3 aPosition;\n    attribute vec2 aTexCoord;\n    uniform mat4 projViewModelMatrix;\n    uniform mat4 positionMatrix;\n    uniform mat4 modelMatrix;\n    varying vec2 vTexCoords;\n    #include <get_output>\n    void main()\n    {\n        mat4 localPositionMatrix = getPositionMatrix();\n        vec4 localPosition = getPosition(aPosition);\n        gl_Position = projViewModelMatrix * localPositionMatrix * localPosition;\n        vTexCoords = aTexCoord;\n    }\n",
    frag: "\n    precision mediump float;\n    uniform sampler2D videoTexture;\n    uniform float opacity;\n\n    varying vec2 vTexCoords;\n    void main() {\n        vec4 color = texture2D(videoTexture, vTexCoords);\n        gl_FragColor = color * opacity;\n    }\n",
    uniforms: [
        {
            name: "projViewModelMatrix",
            type: "function",
            fn: (t, e)=>(0, $3iqbd).multiply([], e.projViewMatrix, e.modelMatrix)
        },
        "texture",
        "opacity"
    ],
    positionAttribute: "POSITION",
    extraCommandProps: {
        depth: {
            enable: !0,
            func: "always"
        },
        cull: {
            enable: !1,
            face: "back"
        },
        frontFace: "cw",
        blend: {
            enable: !0,
            func: {
                src: "src alpha",
                dst: "one minus src alpha"
            },
            equation: "add"
        }
    }
}, $5984e8c1931379f1$var$g = [
    1,
    0,
    3,
    3,
    2,
    1
];
class $5984e8c1931379f1$var$x extends $gP1US.renderer.CanvasRenderer {
    constructor(t){
        super(t), this.t = {};
    }
    draw(t, e) {
        this.prepareCanvas(), this.i(e);
    }
    drawOnInteracting(t, e, i) {
        this.i(i);
    }
    needToRedraw() {
        return !0;
    }
    hitDetect() {
        return !1;
    }
    createContext() {
        if (this.canvas.gl && this.canvas.gl.wrap) this.gl = this.canvas.gl.wrap(), this.regl = this.canvas.gl.regl;
        else {
            const t = this.layer.options.glOptions || {
                alpha: !0,
                depth: !0,
                stencil: !0
            };
            this.glOptions = t, this.gl = this.gl || this.o(this.canvas, t), this.regl = (0, (/*@__PURE__*/$parcel$interopDefault($9I15V)))({
                gl: this.gl,
                extensions: [
                    "ANGLE_instanced_arrays",
                    "OES_texture_float",
                    "OES_texture_half_float",
                    "OES_texture_float_linear",
                    "OES_texture_half_float_linear",
                    "EXT_shader_texture_lod",
                    "OES_element_index_uint",
                    "OES_standard_derivatives",
                    "WEBGL_depth_texture"
                ],
                optionalExtensions: this.layer.options.glExtensions || []
            });
        }
        this.h(), this.l();
        const t = this.layer.getVideoSurfaces();
        for(let e = 0; e < t.length; e++)this.u(t[e]);
    }
    o(t, e) {
        const i = [
            "webgl",
            "experimental-webgl"
        ];
        let s = null;
        for(let r = 0; r < i.length; ++r){
            try {
                s = t.getContext(i[r], e);
            } catch (t) {}
            if (s) break;
        }
        return s;
    }
    l() {
        const t = this.layer.getMap(), e = new (0, $2wazW).Renderer(this.regl);
        this.renderer = e, this.p = {
            projMatrix: t.projMatrix,
            projViewMatrix: t.projViewMatrix,
            viewMatrix: t.viewMatrix,
            halton: [
                .2107,
                -0.0202
            ],
            uHalton: [
                .2107,
                -0.0202
            ],
            uCameraPosition: t.cameraPosition,
            cameraPosition: t.cameraPosition,
            globalTexSize: [
                t.width,
                t.height
            ]
        };
    }
    m() {
        return this.regl;
    }
    h() {
        this.viewport = {
            x: 0,
            y: 0,
            width: ()=>this.canvas ? this.canvas.width : 1,
            height: ()=>this.canvas ? this.canvas.height : 1
        }, this.v();
    }
    v() {
        this._ && this._.dispose(), this.layer.options.showTopAlways ? ($5984e8c1931379f1$var$_.extraCommandProps.depth.mask = !1, $5984e8c1931379f1$var$_.extraCommandProps.depth.range = [
            0,
            0
        ]) : (delete $5984e8c1931379f1$var$_.extraCommandProps.depth.mask, delete $5984e8c1931379f1$var$_.extraCommandProps.depth.range), $5984e8c1931379f1$var$_.extraCommandProps.cull.enable = !this.layer.options.doubleSide, this._ = new (0, $2wazW).MeshShader($5984e8c1931379f1$var$_);
    }
    u(t) {
        const e = this.regl.texture(), i = new (0, $2wazW).Material({
            videoTexture: e,
            opacity: 1
        }), s = t.getCoordinates(), { worldCenter: r, points: o } = this.O(s), n = this.S(o), a = new (0, $2wazW).Mesh(n, i);
        this.T(a, r);
        const l = new (0, $2wazW).Scene(a), d = t.C();
        this.t[d] = l;
    }
    M(t) {
        const e = t.C(), i = this.t[e].getMeshes()[0], s = t.getCoordinates();
        i.geometry.dispose();
        const { worldCenter: r, points: o } = this.O(s), n = this.S(o);
        i.geometry = n, this.T(i, r);
    }
    i(t) {
        const e = this.layer.getVideoSurfaces().filter((t)=>t.isVisible());
        if (!e.length) return;
        const i = this.P(e);
        if (!i) return;
        let s = null;
        t && (s = t.renderTarget && t.renderTarget.fbo), this.renderer.render(this._, this.p, i, s);
    }
    S(t) {
        return new (0, $2wazW).Geometry({
            POSITION: t,
            TEXCOORD: [
                0,
                0,
                1,
                0,
                1,
                1,
                0,
                1
            ]
        }, $5984e8c1931379f1$var$g, 0, {
            primitive: "triangles",
            positionAttribute: "POSITION",
            uv0Attribute: "TEXCOORD",
            normalAttribute: "NORMAL",
            positionSize: 3
        });
    }
    O(e) {
        let i = [];
        const s = this.getMap(), r = new $gP1US.Polygon(e).getCenter(), o = $5984e8c1931379f1$var$w(s, r, 0);
        return this.V = o, s && e.forEach((e)=>{
            const r = new $gP1US.Coordinate(e[0], e[1]), n = s.altitudeToPoint(e[2] || 0, s.getGLRes()), a = $5984e8c1931379f1$var$w(s, r, n);
            a[0] = a[0] - o[0], a[1] = a[1] - o[1], i = i.concat(a);
        }), {
            worldCenter: o,
            points: i
        };
    }
    P(t) {
        const e = [], i = this.layer.getMap();
        for(let s = 0; s < t.length; s++){
            const r = t[s], o = this.t[r.C()];
            if (!o) continue;
            const n = o.getMeshes();
            for(let t = 0; t < n.length; t++){
                const s = n[t], o = s.getMaterial(), a = o.get("videoTexture");
                a && r.A() && (a(r.video), o.set("opacity", r.getOpacity())), $5984e8c1931379f1$var$f(i.projViewMatrix, s.getBoundingBox()) && e.push(s);
            }
        }
        return e.length ? new (0, $2wazW).Scene(e) : null;
    }
    T(t, e) {
        (0, $3iqbd).fromRotationTranslationScale(t.localTransform, (0, $k1dpP).fromEuler([], 0, 0, 0), e, [
            1,
            1,
            1
        ]);
    }
    remove() {
        this._ && this._.dispose(), super.remove();
    }
    clearCanvas() {
        this.canvas && (this.regl.clear({
            color: [
                0,
                0,
                0,
                0
            ],
            depth: 1,
            stencil: 0
        }), super.clearCanvas());
    }
    k(t) {
        const e = this.t[t];
        if (!e) return;
        e.getMeshes().forEach((t)=>{
            t.geometry.dispose(), t.material && t.material.dispose(), t.dispose();
        });
    }
}
function $5984e8c1931379f1$var$w(t, e, i) {
    if (!t) return null;
    const s = t.coordinateToPointAtRes(e, t.getGLRes());
    return [
        s.x,
        s.y,
        i
    ];
}
class $5984e8c1931379f1$export$ac68f9f86f2fdc8f extends (0, $gP1US.Eventable)((0, $gP1US.Handlerable)((0, $gP1US.Class))) {
    constructor(t, e){
        super(e), this.setCoordinates(t), this.I();
    }
    setCoordinates(t) {
        this.R = t;
    }
    getCoordinates() {
        return this.R;
    }
    setVideo(t) {
        this.D = "stop", this.options.url = t, delete this.options.elementId, this.I();
    }
    setElementId(t) {
        this.D = "stop", this.options.elementId = t, delete this.options.url, this.I();
    }
    I() {
        this.D = "stop";
        const t = this.options.url, e = this.options.elementId;
        let i = document.getElementById(e);
        if (t && (i = document.createElement("video"), i.src = t), !i) throw new Error("there is no element or url setting for video mask");
        i.autoplay = !0, i.loop = !0, i.muted = !0, i.play(), i.addEventListener("playing", ()=>{
            this.D = "playing", this.fire("playing", {
                state: this.D,
                url: t
            });
        }), i.addEventListener("pause", ()=>{
            this.D = "pause", this.fire("pause", {
                state: this.D,
                url: t
            });
        }), i.addEventListener("error", ()=>{
            throw this.D = "pause", this.fire("error", {
                state: this.D,
                url: t
            }), new Error("video resource load error");
        }), this.video = i;
    }
    getVideo() {
        return this.video;
    }
    L(t) {
        this.j = t;
    }
    C() {
        return this.j;
    }
    addTo(t) {
        if (this.F) throw new Error("VideoSurface cannot be added to two or more layers at the same time.");
        return t.addSurfaces(this), this;
    }
    show() {
        return this.options.visible = !0, this;
    }
    hide() {
        return this.options.visible = !1, this;
    }
    isVisible() {
        return this.options.visible;
    }
    play() {
        this.video && this.video.play();
    }
    pause() {
        this.video && this.video.pause();
    }
    setAudio(t) {
        this.video.muted = t;
    }
    setOpacity(t) {
        this.options.opacity = t;
    }
    getOpacity() {
        return this.options.opacity;
    }
    remove() {
        delete this.video;
        const t = this.getLayer();
        t && t.removeVideoSurfaces(this), this.endEdit();
    }
    getLayer() {
        return this.F;
    }
    A() {
        return "playing" === this.D;
    }
    startEdit() {
        const t = this.getLayer();
        if (!t) return void console.warn("videosurface should be added to a map before edit");
        const e = t.getMap();
        if (!e) return void console.warn("videosurface should be added to a map before edit");
        if (this.N(), !this.G) {
            const i = t.getId();
            this.G = new (0, $gP1US.VectorLayer)(`internal_${i}_edit`, {
                enableAltitude: !0
            }).addTo(e);
        }
        const i = this.getCoordinates();
        this.H = new (0, $gP1US.Polygon)(i, {
            symbol: {
                lineColor: "#34495e",
                lineWidth: 2,
                polygonFill: "rgb(135,196,240)",
                polygonOpacity: .1
            }
        }).addTo(this.G), this.H.startEdit({
            newVertexHandleSymbol: {
                polygonFill: "rgba(0, 0, 0, 0)",
                polygonOpacity: 0,
                markerType: "ellipse",
                markerWidth: 1,
                markerHeight: 1
            }
        }), this.H.on("shapechange", (e)=>{
            const i = e.target.getCoordinates()[0].slice(0, 4).map((t)=>[
                    t.x,
                    t.y,
                    0
                ]);
            this.setCoordinates(i);
            t.getRenderer().M(this);
        }, this);
    }
    endEdit() {
        this.G && (this.H.endEdit(), this.H.remove(), this.G.remove()), delete this.G, delete this.H;
    }
    N() {
        this.G && this.G.clear(), delete this.H;
    }
}
$5984e8c1931379f1$export$ac68f9f86f2fdc8f.mergeOptions({
    opacity: 1,
    visible: !0
});
class $5984e8c1931379f1$export$db95ebe82dfe7c3c extends (0, $gP1US.Layer) {
    constructor(t, e, i){
        !e || Array.isArray(e) || e instanceof $5984e8c1931379f1$export$ac68f9f86f2fdc8f || (i = e, e = null), super(t, i), this.W = {}, this.videoId = 0, this.W = {}, this.videoId = 0, e && this.addSurfaces(e);
    }
    addSurfaces(t) {
        if (t) {
            if (Array.isArray(t)) t.forEach((t)=>{
                this.addMarker(t);
            });
            else {
                t.F = this, this.W[this.videoId] = t, t.L(this.videoId);
                const e = this.getRenderer();
                e ? e.m() && e.u(t) : this.on("renderercreate", (e)=>{
                    e.renderer.m() && e.renderer.u(t);
                }), this.videoId++;
            }
        }
    }
    showTopAlways(t) {
        this.options.showTopAlways = t;
        const e = this.getRenderer();
        e && e.v();
    }
    setDoubleSide(t) {
        this.options.doubleSide = t;
        const e = this.getRenderer();
        e && e.v();
    }
    getVideoSurfaces() {
        const t = [];
        for(const e in this.W)t.push(this.W[e]);
        return t;
    }
    removeVideoSurfaces(t) {
        if (Array.isArray(t)) t.forEach((t)=>{
            this.removeVideoSurfaces(t);
        });
        else {
            const e = t.C(), i = this.getRenderer();
            i && i.k(e), delete this.W[e];
        }
    }
    remove() {
        this.clear(), super.remove();
    }
    clear() {
        const t = this.getVideoSurfaces();
        for(let e = 0; e < t.length; e++)t[e].remove();
    }
}
$5984e8c1931379f1$export$db95ebe82dfe7c3c.mergeOptions({
    renderer: "gl",
    doubleBuffer: !1,
    glOptions: null,
    markerEvents: !0,
    forceRenderOnZooming: !0,
    forceRenderOnMoving: !0,
    forceRenderOnRotating: !0,
    showTopAlways: !0,
    doubleSide: !0
}), $5984e8c1931379f1$export$db95ebe82dfe7c3c.registerJSONType("VideoLayer"), $5984e8c1931379f1$export$db95ebe82dfe7c3c.registerRenderer("gl", $5984e8c1931379f1$var$x);
"undefined" != typeof console && console.log("@maptalks/video-layer v0.102.3");


if (typeof window !== 'undefined') {
    // transcoders are registered at maptalksgl namespace
    // @ts-expect-error-error
    window.maptalksgl = window.maptalksgl || {};
    // @ts-expect-error-error
    window.maptalksgl.transcoders = window.maptalksgl.transcoders || (0, $9e7Ip.transcoders);
}
$parcel$exportWildcard($525e6c7d12a445be$exports, $gP1US);
$parcel$exportWildcard($525e6c7d12a445be$exports, $9e7Ip);


var $gP1US = parcelRequire("gP1US");
/**
 * Returns the first element that is a descendant of the root element
 * that matches the specified selector, or group of selectors.
 *
 * @param {string} s The selector to query the DOM with.
 * @return {HTMLElement|null} The first matching element or null if no element found.
 */ const $a305a376c9462dbd$export$2e6c959c16ff56b8 = (s)=>{
    if (!s) return console.warn("[select]: No selector provided.");
    return document.querySelector(s);
};
/**
 * Returns a NodeList of elements that are descendants of the root element
 * and match the specified selector, or group of selectors.
 *
 * @param {string} s The selector to query the DOM with.
 * @return {NodeList} A NodeList of matching elements.
 */ const $a305a376c9462dbd$export$90aca4adda6ff0f5 = (s)=>{
    if (!s) return console.warn("[selectAll]: No selector provided.");
    return document.querySelectorAll(s);
};
/**
 * Creates a new HTML element with the specified tag name.
 *
 * @param {string} element The tag name of the HTML element to create.
 * @param {Object} options An object containing the options for the new element.
 * @return {HTMLElement} The newly created HTML element.
 */ const $a305a376c9462dbd$export$185802fd694ee1f5 = (element, options)=>{
    if (!element) return console.warn("[create]: No element provided.");
    return document.createElement(element, options);
};
/**
 * Capitalizes the first character of a string.
 *
 * @param {string} str The string to capitalize.
 * @return {string} The string with the first character capitalized.
 */ function $a305a376c9462dbd$export$8e831c751a9f504f(str) {
    if (typeof str !== "string" || str.length === 0) return "";
    return str.charAt(0).toUpperCase() + str.slice(1);
}



class $ad50f79c8d07e42d$export$3b0d6d7590275603 {
    domElement;
    percentage;
    progressBar;
    animation;
    constructor(){
        this.domElement = (0, $a305a376c9462dbd$export$2e6c959c16ff56b8)(".loader__wrapper");
        this.percentage = (0, $a305a376c9462dbd$export$2e6c959c16ff56b8)(".loader__percentage");
        this.progressBar = (0, $a305a376c9462dbd$export$2e6c959c16ff56b8)("progress.loader__progress");
        if (!this.progressBar) {
            this.animation = (0, $357b3f2d5f2ec9d5$export$99ee26438460406a).timeline({
                paused: true
            });
            return;
        }
        this.animation = (0, $357b3f2d5f2ec9d5$export$99ee26438460406a).to(this.progressBar, {
            ease: "power1.inOut",
            duration: 10,
            paused: true,
            value: 100,
            onUpdate: ()=>{
                if (!this.percentage) return;
                this.percentage.textContent = `${Math.round(this.progressBar.value)}%`;
            }
        });
    }
    start() {
        this.animation.play();
    }
    end() {
        if (this.animation.isActive()) this.animation.duration(1);
    }
    hide() {
        if (!this.domElement) return;
        this.domElement.style.display = "none";
    }
}





/**
 * Swiper 11.2.10
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2025 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: June 28, 2025
 */ /**
 * SSR Window 5.0.1
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2025, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: June 27, 2025
 */ /* eslint-disable no-param-reassign */ function $0868fe5596dee114$var$isObject(obj) {
    return obj !== null && typeof obj === 'object' && 'constructor' in obj && obj.constructor === Object;
}
function $0868fe5596dee114$var$extend(target, src) {
    if (target === void 0) target = {};
    if (src === void 0) src = {};
    const noExtend = [
        '__proto__',
        'constructor',
        'prototype'
    ];
    Object.keys(src).filter((key)=>noExtend.indexOf(key) < 0).forEach((key)=>{
        if (typeof target[key] === 'undefined') target[key] = src[key];
        else if ($0868fe5596dee114$var$isObject(src[key]) && $0868fe5596dee114$var$isObject(target[key]) && Object.keys(src[key]).length > 0) $0868fe5596dee114$var$extend(target[key], src[key]);
    });
}
const $0868fe5596dee114$var$ssrDocument = {
    body: {},
    addEventListener () {},
    removeEventListener () {},
    activeElement: {
        blur () {},
        nodeName: ''
    },
    querySelector () {
        return null;
    },
    querySelectorAll () {
        return [];
    },
    getElementById () {
        return null;
    },
    createEvent () {
        return {
            initEvent () {}
        };
    },
    createElement () {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute () {},
            getElementsByTagName () {
                return [];
            }
        };
    },
    createElementNS () {
        return {};
    },
    importNode () {
        return null;
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: ''
    }
};
function $0868fe5596dee114$export$39b482c5e57630a8() {
    const doc = typeof document !== 'undefined' ? document : {};
    $0868fe5596dee114$var$extend(doc, $0868fe5596dee114$var$ssrDocument);
    return doc;
}
const $0868fe5596dee114$var$ssrWindow = {
    document: $0868fe5596dee114$var$ssrDocument,
    navigator: {
        userAgent: ''
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: ''
    },
    history: {
        replaceState () {},
        pushState () {},
        go () {},
        back () {}
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener () {},
    removeEventListener () {},
    getComputedStyle () {
        return {
            getPropertyValue () {
                return '';
            }
        };
    },
    Image () {},
    Date () {},
    screen: {},
    setTimeout () {},
    clearTimeout () {},
    matchMedia () {
        return {};
    },
    requestAnimationFrame (callback) {
        if (typeof setTimeout === 'undefined') {
            callback();
            return null;
        }
        return setTimeout(callback, 0);
    },
    cancelAnimationFrame (id) {
        if (typeof setTimeout === 'undefined') return;
        clearTimeout(id);
    }
};
function $0868fe5596dee114$export$407448d2b89b1813() {
    const win = typeof window !== 'undefined' ? window : {};
    $0868fe5596dee114$var$extend(win, $0868fe5596dee114$var$ssrWindow);
    return win;
}



function $f97f33853a605dba$export$35e795649ee09318(classes) {
    if (classes === void 0) classes = '';
    return classes.trim().split(' ').filter((c)=>!!c.trim());
}
function $f97f33853a605dba$export$4a5767248b18ef41(obj) {
    const object = obj;
    Object.keys(object).forEach((key)=>{
        try {
            object[key] = null;
        } catch (e) {
        // no getter for object
        }
        try {
            delete object[key];
        } catch (e) {
        // something got wrong
        }
    });
}
function $f97f33853a605dba$export$7ccc53e8f1e7dfc5(callback, delay) {
    if (delay === void 0) delay = 0;
    return setTimeout(callback, delay);
}
function $f97f33853a605dba$export$2d1720544b23b823() {
    return Date.now();
}
function $f97f33853a605dba$var$getComputedStyle(el) {
    const window1 = (0, $0868fe5596dee114$export$407448d2b89b1813)();
    let style;
    if (window1.getComputedStyle) style = window1.getComputedStyle(el, null);
    if (!style && el.currentStyle) style = el.currentStyle;
    if (!style) style = el.style;
    return style;
}
function $f97f33853a605dba$export$342063e11d6c3cad(el, axis) {
    if (axis === void 0) axis = 'x';
    const window1 = (0, $0868fe5596dee114$export$407448d2b89b1813)();
    let matrix;
    let curTransform;
    let transformMatrix;
    const curStyle = $f97f33853a605dba$var$getComputedStyle(el);
    if (window1.WebKitCSSMatrix) {
        curTransform = curStyle.transform || curStyle.webkitTransform;
        if (curTransform.split(',').length > 6) curTransform = curTransform.split(', ').map((a)=>a.replace(',', '.')).join(', ');
        // Some old versions of Webkit choke when 'none' is passed; pass
        // empty string instead in this case
        transformMatrix = new window1.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
    } else {
        transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
        matrix = transformMatrix.toString().split(',');
    }
    if (axis === 'x') {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m41;
        else if (matrix.length === 16) curTransform = parseFloat(matrix[12]);
        else curTransform = parseFloat(matrix[4]);
    }
    if (axis === 'y') {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m42;
        else if (matrix.length === 16) curTransform = parseFloat(matrix[13]);
        else curTransform = parseFloat(matrix[5]);
    }
    return curTransform || 0;
}
function $f97f33853a605dba$export$ae1af26003f05816(o) {
    return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}
function $f97f33853a605dba$var$isNode(node) {
    // eslint-disable-next-line
    if (typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined') return node instanceof HTMLElement;
    return node && (node.nodeType === 1 || node.nodeType === 11);
}
function $f97f33853a605dba$export$d141bba7fdc215a3() {
    const to = Object(arguments.length <= 0 ? undefined : arguments[0]);
    const noExtend = [
        '__proto__',
        'constructor',
        'prototype'
    ];
    for(let i = 1; i < arguments.length; i += 1){
        const nextSource = i < 0 || arguments.length <= i ? undefined : arguments[i];
        if (nextSource !== undefined && nextSource !== null && !$f97f33853a605dba$var$isNode(nextSource)) {
            const keysArray = Object.keys(Object(nextSource)).filter((key)=>noExtend.indexOf(key) < 0);
            for(let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1){
                const nextKey = keysArray[nextIndex];
                const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                if (desc !== undefined && desc.enumerable) {
                    if ($f97f33853a605dba$export$ae1af26003f05816(to[nextKey]) && $f97f33853a605dba$export$ae1af26003f05816(nextSource[nextKey])) {
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $f97f33853a605dba$export$d141bba7fdc215a3(to[nextKey], nextSource[nextKey]);
                    } else if (!$f97f33853a605dba$export$ae1af26003f05816(to[nextKey]) && $f97f33853a605dba$export$ae1af26003f05816(nextSource[nextKey])) {
                        to[nextKey] = {};
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $f97f33853a605dba$export$d141bba7fdc215a3(to[nextKey], nextSource[nextKey]);
                    } else to[nextKey] = nextSource[nextKey];
                }
            }
        }
    }
    return to;
}
function $f97f33853a605dba$export$407448d2b89b1813(el, varName, varValue) {
    el.style.setProperty(varName, varValue);
}
function $f97f33853a605dba$export$3b14a55fb2447963(_ref) {
    let { swiper: swiper, targetPosition: targetPosition, side: side } = _ref;
    const window1 = (0, $0868fe5596dee114$export$407448d2b89b1813)();
    const startPosition = -swiper.translate;
    let startTime = null;
    let time;
    const duration = swiper.params.speed;
    swiper.wrapperEl.style.scrollSnapType = 'none';
    window1.cancelAnimationFrame(swiper.cssModeFrameID);
    const dir = targetPosition > startPosition ? 'next' : 'prev';
    const isOutOfBound = (current, target)=>{
        return dir === 'next' && current >= target || dir === 'prev' && current <= target;
    };
    const animate = ()=>{
        time = new Date().getTime();
        if (startTime === null) startTime = time;
        const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
        const easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
        let currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
        if (isOutOfBound(currentPosition, targetPosition)) currentPosition = targetPosition;
        swiper.wrapperEl.scrollTo({
            [side]: currentPosition
        });
        if (isOutOfBound(currentPosition, targetPosition)) {
            swiper.wrapperEl.style.overflow = 'hidden';
            swiper.wrapperEl.style.scrollSnapType = '';
            setTimeout(()=>{
                swiper.wrapperEl.style.overflow = '';
                swiper.wrapperEl.scrollTo({
                    [side]: currentPosition
                });
            });
            window1.cancelAnimationFrame(swiper.cssModeFrameID);
            return;
        }
        swiper.cssModeFrameID = window1.requestAnimationFrame(animate);
    };
    animate();
}
function $f97f33853a605dba$export$39b482c5e57630a8(slideEl) {
    return slideEl.querySelector('.swiper-slide-transform') || slideEl.shadowRoot && slideEl.shadowRoot.querySelector('.swiper-slide-transform') || slideEl;
}
function $f97f33853a605dba$export$f1e1789686576879(element, selector) {
    if (selector === void 0) selector = '';
    const window1 = (0, $0868fe5596dee114$export$407448d2b89b1813)();
    const children = [
        ...element.children
    ];
    if (window1.HTMLSlotElement && element instanceof HTMLSlotElement) children.push(...element.assignedElements());
    if (!selector) return children;
    return children.filter((el)=>el.matches(selector));
}
function $f97f33853a605dba$var$elementIsChildOfSlot(el, slot) {
    // Breadth-first search through all parent's children and assigned elements
    const elementsQueue = [
        slot
    ];
    while(elementsQueue.length > 0){
        const elementToCheck = elementsQueue.shift();
        if (el === elementToCheck) return true;
        elementsQueue.push(...elementToCheck.children, ...elementToCheck.shadowRoot ? elementToCheck.shadowRoot.children : [], ...elementToCheck.assignedElements ? elementToCheck.assignedElements() : []);
    }
}
function $f97f33853a605dba$export$efccba1c4a2ef57b(el, parent) {
    const window1 = (0, $0868fe5596dee114$export$407448d2b89b1813)();
    let isChild = parent.contains(el);
    if (!isChild && window1.HTMLSlotElement && parent instanceof HTMLSlotElement) {
        const children = [
            ...parent.assignedElements()
        ];
        isChild = children.includes(el);
        if (!isChild) isChild = $f97f33853a605dba$var$elementIsChildOfSlot(el, parent);
    }
    return isChild;
}
function $f97f33853a605dba$export$90a7f3efeed30595(text) {
    try {
        console.warn(text);
        return;
    } catch (err) {
    // err
    }
}
function $f97f33853a605dba$export$db3b6bfb95261072(tag, classes) {
    if (classes === void 0) classes = [];
    const el = document.createElement(tag);
    el.classList.add(...Array.isArray(classes) ? classes : $f97f33853a605dba$export$35e795649ee09318(classes));
    return el;
}
function $f97f33853a605dba$export$4368d992c4eafac0(el) {
    const window1 = (0, $0868fe5596dee114$export$407448d2b89b1813)();
    const document1 = (0, $0868fe5596dee114$export$39b482c5e57630a8)();
    const box = el.getBoundingClientRect();
    const body = document1.body;
    const clientTop = el.clientTop || body.clientTop || 0;
    const clientLeft = el.clientLeft || body.clientLeft || 0;
    const scrollTop = el === window1 ? window1.scrollY : el.scrollTop;
    const scrollLeft = el === window1 ? window1.scrollX : el.scrollLeft;
    return {
        top: box.top + scrollTop - clientTop,
        left: box.left + scrollLeft - clientLeft
    };
}
function $f97f33853a605dba$export$625550452a3fa3ec(el, selector) {
    const prevEls = [];
    while(el.previousElementSibling){
        const prev = el.previousElementSibling; // eslint-disable-line
        if (selector) {
            if (prev.matches(selector)) prevEls.push(prev);
        } else prevEls.push(prev);
        el = prev;
    }
    return prevEls;
}
function $f97f33853a605dba$export$43caf9889c228507(el, selector) {
    const nextEls = [];
    while(el.nextElementSibling){
        const next = el.nextElementSibling; // eslint-disable-line
        if (selector) {
            if (next.matches(selector)) nextEls.push(next);
        } else nextEls.push(next);
        el = next;
    }
    return nextEls;
}
function $f97f33853a605dba$export$9e5f44173e64f162(el, prop) {
    const window1 = (0, $0868fe5596dee114$export$407448d2b89b1813)();
    return window1.getComputedStyle(el, null).getPropertyValue(prop);
}
function $f97f33853a605dba$export$23f2a1d2818174ef(el) {
    let child = el;
    let i;
    if (child) {
        i = 0;
        // eslint-disable-next-line
        while((child = child.previousSibling) !== null)if (child.nodeType === 1) i += 1;
        return i;
    }
    return undefined;
}
function $f97f33853a605dba$export$8b22cf2602fb60ce(el, selector) {
    const parents = []; // eslint-disable-line
    let parent = el.parentElement; // eslint-disable-line
    while(parent){
        if (selector) {
            if (parent.matches(selector)) parents.push(parent);
        } else parents.push(parent);
        parent = parent.parentElement;
    }
    return parents;
}
function $f97f33853a605dba$export$882b5998b3b9117c(el, callback) {
    function fireCallBack(e) {
        if (e.target !== el) return;
        callback.call(el, e);
        el.removeEventListener('transitionend', fireCallBack);
    }
    if (callback) el.addEventListener('transitionend', fireCallBack);
}
function $f97f33853a605dba$export$dda1d9f60106f0e9(el, size, includeMargins) {
    const window1 = (0, $0868fe5596dee114$export$407448d2b89b1813)();
    if (includeMargins) return el[size === 'width' ? 'offsetWidth' : 'offsetHeight'] + parseFloat(window1.getComputedStyle(el, null).getPropertyValue(size === 'width' ? 'margin-right' : 'margin-top')) + parseFloat(window1.getComputedStyle(el, null).getPropertyValue(size === 'width' ? 'margin-left' : 'margin-bottom'));
    return el.offsetWidth;
}
function $f97f33853a605dba$export$953cecd6e717a553(el) {
    return (Array.isArray(el) ? el : [
        el
    ]).filter((e)=>!!e);
}
function $f97f33853a605dba$export$ffb5f4729a158638(swiper) {
    return (v)=>{
        if (Math.abs(v) > 0 && swiper.browser && swiper.browser.need3dFix && Math.abs(v) % 90 === 0) return v + 0.001;
        return v;
    };
}
function $f97f33853a605dba$export$2408f22a0fab9ae5(el, html) {
    if (html === void 0) html = '';
    if (typeof trustedTypes !== 'undefined') el.innerHTML = trustedTypes.createPolicy('html', {
        createHTML: (s)=>s
    }).createHTML(html);
    else el.innerHTML = html;
}


let $1262f2e38e280703$var$support;
function $1262f2e38e280703$var$calcSupport() {
    const window1 = (0, $0868fe5596dee114$export$407448d2b89b1813)();
    const document1 = (0, $0868fe5596dee114$export$39b482c5e57630a8)();
    return {
        smoothScroll: document1.documentElement && document1.documentElement.style && 'scrollBehavior' in document1.documentElement.style,
        touch: !!('ontouchstart' in window1 || window1.DocumentTouch && document1 instanceof window1.DocumentTouch)
    };
}
function $1262f2e38e280703$var$getSupport() {
    if (!$1262f2e38e280703$var$support) $1262f2e38e280703$var$support = $1262f2e38e280703$var$calcSupport();
    return $1262f2e38e280703$var$support;
}
let $1262f2e38e280703$var$deviceCached;
function $1262f2e38e280703$var$calcDevice(_temp) {
    let { userAgent: userAgent } = _temp === void 0 ? {} : _temp;
    const support = $1262f2e38e280703$var$getSupport();
    const window1 = (0, $0868fe5596dee114$export$407448d2b89b1813)();
    const platform = window1.navigator.platform;
    const ua = userAgent || window1.navigator.userAgent;
    const device = {
        ios: false,
        android: false
    };
    const screenWidth = window1.screen.width;
    const screenHeight = window1.screen.height;
    const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
    let ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
    const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
    const windows = platform === 'Win32';
    let macos = platform === 'MacIntel';
    // iPadOs 13 fix
    const iPadScreens = [
        '1024x1366',
        '1366x1024',
        '834x1194',
        '1194x834',
        '834x1112',
        '1112x834',
        '768x1024',
        '1024x768',
        '820x1180',
        '1180x820',
        '810x1080',
        '1080x810'
    ];
    if (!ipad && macos && support.touch && iPadScreens.indexOf(`${screenWidth}x${screenHeight}`) >= 0) {
        ipad = ua.match(/(Version)\/([\d.]+)/);
        if (!ipad) ipad = [
            0,
            1,
            '13_0_0'
        ];
        macos = false;
    }
    // Android
    if (android && !windows) {
        device.os = 'android';
        device.android = true;
    }
    if (ipad || iphone || ipod) {
        device.os = 'ios';
        device.ios = true;
    }
    // Export object
    return device;
}
function $1262f2e38e280703$var$getDevice(overrides) {
    if (overrides === void 0) overrides = {};
    if (!$1262f2e38e280703$var$deviceCached) $1262f2e38e280703$var$deviceCached = $1262f2e38e280703$var$calcDevice(overrides);
    return $1262f2e38e280703$var$deviceCached;
}
let $1262f2e38e280703$var$browser;
function $1262f2e38e280703$var$calcBrowser() {
    const window1 = (0, $0868fe5596dee114$export$407448d2b89b1813)();
    const device = $1262f2e38e280703$var$getDevice();
    let needPerspectiveFix = false;
    function isSafari() {
        const ua = window1.navigator.userAgent.toLowerCase();
        return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
    }
    if (isSafari()) {
        const ua = String(window1.navigator.userAgent);
        if (ua.includes('Version/')) {
            const [major, minor] = ua.split('Version/')[1].split(' ')[0].split('.').map((num)=>Number(num));
            needPerspectiveFix = major < 16 || major === 16 && minor < 2;
        }
    }
    const isWebView = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window1.navigator.userAgent);
    const isSafariBrowser = isSafari();
    const need3dFix = isSafariBrowser || isWebView && device.ios;
    return {
        isSafari: needPerspectiveFix || isSafariBrowser,
        needPerspectiveFix: needPerspectiveFix,
        need3dFix: need3dFix,
        isWebView: isWebView
    };
}
function $1262f2e38e280703$var$getBrowser() {
    if (!$1262f2e38e280703$var$browser) $1262f2e38e280703$var$browser = $1262f2e38e280703$var$calcBrowser();
    return $1262f2e38e280703$var$browser;
}
function $1262f2e38e280703$var$Resize(_ref) {
    let { swiper: swiper, on: on, emit: emit } = _ref;
    const window1 = (0, $0868fe5596dee114$export$407448d2b89b1813)();
    let observer = null;
    let animationFrame = null;
    const resizeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit('beforeResize');
        emit('resize');
    };
    const createObserver = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        observer = new ResizeObserver((entries)=>{
            animationFrame = window1.requestAnimationFrame(()=>{
                const { width: width, height: height } = swiper;
                let newWidth = width;
                let newHeight = height;
                entries.forEach((_ref2)=>{
                    let { contentBoxSize: contentBoxSize, contentRect: contentRect, target: target } = _ref2;
                    if (target && target !== swiper.el) return;
                    newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
                    newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
                });
                if (newWidth !== width || newHeight !== height) resizeHandler();
            });
        });
        observer.observe(swiper.el);
    };
    const removeObserver = ()=>{
        if (animationFrame) window1.cancelAnimationFrame(animationFrame);
        if (observer && observer.unobserve && swiper.el) {
            observer.unobserve(swiper.el);
            observer = null;
        }
    };
    const orientationChangeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit('orientationchange');
    };
    on('init', ()=>{
        if (swiper.params.resizeObserver && typeof window1.ResizeObserver !== 'undefined') {
            createObserver();
            return;
        }
        window1.addEventListener('resize', resizeHandler);
        window1.addEventListener('orientationchange', orientationChangeHandler);
    });
    on('destroy', ()=>{
        removeObserver();
        window1.removeEventListener('resize', resizeHandler);
        window1.removeEventListener('orientationchange', orientationChangeHandler);
    });
}
function $1262f2e38e280703$var$Observer(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const observers = [];
    const window1 = (0, $0868fe5596dee114$export$407448d2b89b1813)();
    const attach = function(target, options) {
        if (options === void 0) options = {};
        const ObserverFunc = window1.MutationObserver || window1.WebkitMutationObserver;
        const observer = new ObserverFunc((mutations)=>{
            // The observerUpdate event should only be triggered
            // once despite the number of mutations.  Additional
            // triggers are redundant and are very costly
            if (swiper.__preventObserver__) return;
            if (mutations.length === 1) {
                emit('observerUpdate', mutations[0]);
                return;
            }
            const observerUpdate = function observerUpdate() {
                emit('observerUpdate', mutations[0]);
            };
            if (window1.requestAnimationFrame) window1.requestAnimationFrame(observerUpdate);
            else window1.setTimeout(observerUpdate, 0);
        });
        observer.observe(target, {
            attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
            childList: swiper.isElement || (typeof options.childList === 'undefined' ? true : options).childList,
            characterData: typeof options.characterData === 'undefined' ? true : options.characterData
        });
        observers.push(observer);
    };
    const init = ()=>{
        if (!swiper.params.observer) return;
        if (swiper.params.observeParents) {
            const containerParents = (0, $f97f33853a605dba$export$8b22cf2602fb60ce)(swiper.hostEl);
            for(let i = 0; i < containerParents.length; i += 1)attach(containerParents[i]);
        }
        // Observe container
        attach(swiper.hostEl, {
            childList: swiper.params.observeSlideChildren
        });
        // Observe wrapper
        attach(swiper.wrapperEl, {
            attributes: false
        });
    };
    const destroy = ()=>{
        observers.forEach((observer)=>{
            observer.disconnect();
        });
        observers.splice(0, observers.length);
    };
    extendParams({
        observer: false,
        observeParents: false,
        observeSlideChildren: false
    });
    on('init', init);
    on('destroy', destroy);
}
/* eslint-disable no-underscore-dangle */ var $1262f2e38e280703$var$eventsEmitter = {
    on (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        const method = priority ? 'unshift' : 'push';
        events.split(' ').forEach((event)=>{
            if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
            self.eventsListeners[event][method](handler);
        });
        return self;
    },
    once (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        function onceHandler() {
            self.off(events, onceHandler);
            if (onceHandler.__emitterProxy) delete onceHandler.__emitterProxy;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            handler.apply(self, args);
        }
        onceHandler.__emitterProxy = handler;
        return self.on(events, onceHandler, priority);
    },
    onAny (handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        const method = priority ? 'unshift' : 'push';
        if (self.eventsAnyListeners.indexOf(handler) < 0) self.eventsAnyListeners[method](handler);
        return self;
    },
    offAny (handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsAnyListeners) return self;
        const index = self.eventsAnyListeners.indexOf(handler);
        if (index >= 0) self.eventsAnyListeners.splice(index, 1);
        return self;
    },
    off (events, handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        events.split(' ').forEach((event)=>{
            if (typeof handler === 'undefined') self.eventsListeners[event] = [];
            else if (self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler, index)=>{
                if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) self.eventsListeners[event].splice(index, 1);
            });
        });
        return self;
    },
    emit () {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        let events;
        let data;
        let context;
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        if (typeof args[0] === 'string' || Array.isArray(args[0])) {
            events = args[0];
            data = args.slice(1, args.length);
            context = self;
        } else {
            events = args[0].events;
            data = args[0].data;
            context = args[0].context || self;
        }
        data.unshift(context);
        const eventsArray = Array.isArray(events) ? events : events.split(' ');
        eventsArray.forEach((event)=>{
            if (self.eventsAnyListeners && self.eventsAnyListeners.length) self.eventsAnyListeners.forEach((eventHandler)=>{
                eventHandler.apply(context, [
                    event,
                    ...data
                ]);
            });
            if (self.eventsListeners && self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler)=>{
                eventHandler.apply(context, data);
            });
        });
        return self;
    }
};
function $1262f2e38e280703$var$updateSize() {
    const swiper = this;
    let width;
    let height;
    const el = swiper.el;
    if (typeof swiper.params.width !== 'undefined' && swiper.params.width !== null) width = swiper.params.width;
    else width = el.clientWidth;
    if (typeof swiper.params.height !== 'undefined' && swiper.params.height !== null) height = swiper.params.height;
    else height = el.clientHeight;
    if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) return;
    // Subtract paddings
    width = width - parseInt((0, $f97f33853a605dba$export$9e5f44173e64f162)(el, 'padding-left') || 0, 10) - parseInt((0, $f97f33853a605dba$export$9e5f44173e64f162)(el, 'padding-right') || 0, 10);
    height = height - parseInt((0, $f97f33853a605dba$export$9e5f44173e64f162)(el, 'padding-top') || 0, 10) - parseInt((0, $f97f33853a605dba$export$9e5f44173e64f162)(el, 'padding-bottom') || 0, 10);
    if (Number.isNaN(width)) width = 0;
    if (Number.isNaN(height)) height = 0;
    Object.assign(swiper, {
        width: width,
        height: height,
        size: swiper.isHorizontal() ? width : height
    });
}
function $1262f2e38e280703$var$updateSlides() {
    const swiper = this;
    function getDirectionPropertyValue(node, label) {
        return parseFloat(node.getPropertyValue(swiper.getDirectionLabel(label)) || 0);
    }
    const params = swiper.params;
    const { wrapperEl: wrapperEl, slidesEl: slidesEl, size: swiperSize, rtlTranslate: rtl, wrongRTL: wrongRTL } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    const slides = (0, $f97f33853a605dba$export$f1e1789686576879)(slidesEl, `.${swiper.params.slideClass}, swiper-slide`);
    const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    let snapGrid = [];
    const slidesGrid = [];
    const slidesSizesGrid = [];
    let offsetBefore = params.slidesOffsetBefore;
    if (typeof offsetBefore === 'function') offsetBefore = params.slidesOffsetBefore.call(swiper);
    let offsetAfter = params.slidesOffsetAfter;
    if (typeof offsetAfter === 'function') offsetAfter = params.slidesOffsetAfter.call(swiper);
    const previousSnapGridLength = swiper.snapGrid.length;
    const previousSlidesGridLength = swiper.slidesGrid.length;
    let spaceBetween = params.spaceBetween;
    let slidePosition = -offsetBefore;
    let prevSlideSize = 0;
    let index = 0;
    if (typeof swiperSize === 'undefined') return;
    if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
    else if (typeof spaceBetween === 'string') spaceBetween = parseFloat(spaceBetween);
    swiper.virtualSize = -spaceBetween;
    // reset margins
    slides.forEach((slideEl)=>{
        if (rtl) slideEl.style.marginLeft = '';
        else slideEl.style.marginRight = '';
        slideEl.style.marginBottom = '';
        slideEl.style.marginTop = '';
    });
    // reset cssMode offsets
    if (params.centeredSlides && params.cssMode) {
        (0, $f97f33853a605dba$export$407448d2b89b1813)(wrapperEl, '--swiper-centered-offset-before', '');
        (0, $f97f33853a605dba$export$407448d2b89b1813)(wrapperEl, '--swiper-centered-offset-after', '');
    }
    const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
    if (gridEnabled) swiper.grid.initSlides(slides);
    else if (swiper.grid) swiper.grid.unsetSlides();
    // Calc slides
    let slideSize;
    const shouldResetSlideSize = params.slidesPerView === 'auto' && params.breakpoints && Object.keys(params.breakpoints).filter((key)=>{
        return typeof params.breakpoints[key].slidesPerView !== 'undefined';
    }).length > 0;
    for(let i = 0; i < slidesLength; i += 1){
        slideSize = 0;
        let slide;
        if (slides[i]) slide = slides[i];
        if (gridEnabled) swiper.grid.updateSlide(i, slide, slides);
        if (slides[i] && (0, $f97f33853a605dba$export$9e5f44173e64f162)(slide, 'display') === 'none') continue; // eslint-disable-line
        if (params.slidesPerView === 'auto') {
            if (shouldResetSlideSize) slides[i].style[swiper.getDirectionLabel('width')] = ``;
            const slideStyles = getComputedStyle(slide);
            const currentTransform = slide.style.transform;
            const currentWebKitTransform = slide.style.webkitTransform;
            if (currentTransform) slide.style.transform = 'none';
            if (currentWebKitTransform) slide.style.webkitTransform = 'none';
            if (params.roundLengths) slideSize = swiper.isHorizontal() ? (0, $f97f33853a605dba$export$dda1d9f60106f0e9)(slide, 'width', true) : (0, $f97f33853a605dba$export$dda1d9f60106f0e9)(slide, 'height', true);
            else {
                // eslint-disable-next-line
                const width = getDirectionPropertyValue(slideStyles, 'width');
                const paddingLeft = getDirectionPropertyValue(slideStyles, 'padding-left');
                const paddingRight = getDirectionPropertyValue(slideStyles, 'padding-right');
                const marginLeft = getDirectionPropertyValue(slideStyles, 'margin-left');
                const marginRight = getDirectionPropertyValue(slideStyles, 'margin-right');
                const boxSizing = slideStyles.getPropertyValue('box-sizing');
                if (boxSizing && boxSizing === 'border-box') slideSize = width + marginLeft + marginRight;
                else {
                    const { clientWidth: clientWidth, offsetWidth: offsetWidth } = slide;
                    slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
                }
            }
            if (currentTransform) slide.style.transform = currentTransform;
            if (currentWebKitTransform) slide.style.webkitTransform = currentWebKitTransform;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
        } else {
            slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
            if (slides[i]) slides[i].style[swiper.getDirectionLabel('width')] = `${slideSize}px`;
        }
        if (slides[i]) slides[i].swiperSlideSize = slideSize;
        slidesSizesGrid.push(slideSize);
        if (params.centeredSlides) {
            slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
            if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (Math.abs(slidePosition) < 0.001) slidePosition = 0;
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
        } else {
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
            slidePosition = slidePosition + slideSize + spaceBetween;
        }
        swiper.virtualSize += slideSize + spaceBetween;
        prevSlideSize = slideSize;
        index += 1;
    }
    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) wrapperEl.style.width = `${swiper.virtualSize + spaceBetween}px`;
    if (params.setWrapperSize) wrapperEl.style[swiper.getDirectionLabel('width')] = `${swiper.virtualSize + spaceBetween}px`;
    if (gridEnabled) swiper.grid.updateWrapperSize(slideSize, snapGrid);
    // Remove last grid elements depending on width
    if (!params.centeredSlides) {
        const newSlidesGrid = [];
        for(let i = 0; i < snapGrid.length; i += 1){
            let slidesGridItem = snapGrid[i];
            if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
            if (snapGrid[i] <= swiper.virtualSize - swiperSize) newSlidesGrid.push(slidesGridItem);
        }
        snapGrid = newSlidesGrid;
        if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) snapGrid.push(swiper.virtualSize - swiperSize);
    }
    if (isVirtual && params.loop) {
        const size = slidesSizesGrid[0] + spaceBetween;
        if (params.slidesPerGroup > 1) {
            const groups = Math.ceil((swiper.virtual.slidesBefore + swiper.virtual.slidesAfter) / params.slidesPerGroup);
            const groupSize = size * params.slidesPerGroup;
            for(let i = 0; i < groups; i += 1)snapGrid.push(snapGrid[snapGrid.length - 1] + groupSize);
        }
        for(let i = 0; i < swiper.virtual.slidesBefore + swiper.virtual.slidesAfter; i += 1){
            if (params.slidesPerGroup === 1) snapGrid.push(snapGrid[snapGrid.length - 1] + size);
            slidesGrid.push(slidesGrid[slidesGrid.length - 1] + size);
            swiper.virtualSize += size;
        }
    }
    if (snapGrid.length === 0) snapGrid = [
        0
    ];
    if (spaceBetween !== 0) {
        const key = swiper.isHorizontal() && rtl ? 'marginLeft' : swiper.getDirectionLabel('marginRight');
        slides.filter((_, slideIndex)=>{
            if (!params.cssMode || params.loop) return true;
            if (slideIndex === slides.length - 1) return false;
            return true;
        }).forEach((slideEl)=>{
            slideEl.style[key] = `${spaceBetween}px`;
        });
    }
    if (params.centeredSlides && params.centeredSlidesBounds) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize -= spaceBetween;
        const maxSnap = allSlidesSize > swiperSize ? allSlidesSize - swiperSize : 0;
        snapGrid = snapGrid.map((snap)=>{
            if (snap <= 0) return -offsetBefore;
            if (snap > maxSnap) return maxSnap + offsetAfter;
            return snap;
        });
    }
    if (params.centerInsufficientSlides) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize -= spaceBetween;
        const offsetSize = (params.slidesOffsetBefore || 0) + (params.slidesOffsetAfter || 0);
        if (allSlidesSize + offsetSize < swiperSize) {
            const allSlidesOffset = (swiperSize - allSlidesSize - offsetSize) / 2;
            snapGrid.forEach((snap, snapIndex)=>{
                snapGrid[snapIndex] = snap - allSlidesOffset;
            });
            slidesGrid.forEach((snap, snapIndex)=>{
                slidesGrid[snapIndex] = snap + allSlidesOffset;
            });
        }
    }
    Object.assign(swiper, {
        slides: slides,
        snapGrid: snapGrid,
        slidesGrid: slidesGrid,
        slidesSizesGrid: slidesSizesGrid
    });
    if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
        (0, $f97f33853a605dba$export$407448d2b89b1813)(wrapperEl, '--swiper-centered-offset-before', `${-snapGrid[0]}px`);
        (0, $f97f33853a605dba$export$407448d2b89b1813)(wrapperEl, '--swiper-centered-offset-after', `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
        const addToSnapGrid = -swiper.snapGrid[0];
        const addToSlidesGrid = -swiper.slidesGrid[0];
        swiper.snapGrid = swiper.snapGrid.map((v)=>v + addToSnapGrid);
        swiper.slidesGrid = swiper.slidesGrid.map((v)=>v + addToSlidesGrid);
    }
    if (slidesLength !== previousSlidesLength) swiper.emit('slidesLengthChange');
    if (snapGrid.length !== previousSnapGridLength) {
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        swiper.emit('snapGridLengthChange');
    }
    if (slidesGrid.length !== previousSlidesGridLength) swiper.emit('slidesGridLengthChange');
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    swiper.emit('slidesUpdated');
    if (!isVirtual && !params.cssMode && (params.effect === 'slide' || params.effect === 'fade')) {
        const backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`;
        const hasClassBackfaceClassAdded = swiper.el.classList.contains(backFaceHiddenClass);
        if (slidesLength <= params.maxBackfaceHiddenSlides) {
            if (!hasClassBackfaceClassAdded) swiper.el.classList.add(backFaceHiddenClass);
        } else if (hasClassBackfaceClassAdded) swiper.el.classList.remove(backFaceHiddenClass);
    }
}
function $1262f2e38e280703$var$updateAutoHeight(speed) {
    const swiper = this;
    const activeSlides = [];
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    let newHeight = 0;
    let i;
    if (typeof speed === 'number') swiper.setTransition(speed);
    else if (speed === true) swiper.setTransition(swiper.params.speed);
    const getSlideByIndex = (index)=>{
        if (isVirtual) return swiper.slides[swiper.getSlideIndexByData(index)];
        return swiper.slides[index];
    };
    // Find slides currently in view
    if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
        if (swiper.params.centeredSlides) (swiper.visibleSlides || []).forEach((slide)=>{
            activeSlides.push(slide);
        });
        else for(i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1){
            const index = swiper.activeIndex + i;
            if (index > swiper.slides.length && !isVirtual) break;
            activeSlides.push(getSlideByIndex(index));
        }
    } else activeSlides.push(getSlideByIndex(swiper.activeIndex));
    // Find new height from highest slide in view
    for(i = 0; i < activeSlides.length; i += 1)if (typeof activeSlides[i] !== 'undefined') {
        const height = activeSlides[i].offsetHeight;
        newHeight = height > newHeight ? height : newHeight;
    }
    // Update Height
    if (newHeight || newHeight === 0) swiper.wrapperEl.style.height = `${newHeight}px`;
}
function $1262f2e38e280703$var$updateSlidesOffset() {
    const swiper = this;
    const slides = swiper.slides;
    // eslint-disable-next-line
    const minusOffset = swiper.isElement ? swiper.isHorizontal() ? swiper.wrapperEl.offsetLeft : swiper.wrapperEl.offsetTop : 0;
    for(let i = 0; i < slides.length; i += 1)slides[i].swiperSlideOffset = (swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop) - minusOffset - swiper.cssOverflowAdjustment();
}
const $1262f2e38e280703$var$toggleSlideClasses$1 = (slideEl, condition, className)=>{
    if (condition && !slideEl.classList.contains(className)) slideEl.classList.add(className);
    else if (!condition && slideEl.classList.contains(className)) slideEl.classList.remove(className);
};
function $1262f2e38e280703$var$updateSlidesProgress(translate) {
    if (translate === void 0) translate = this && this.translate || 0;
    const swiper = this;
    const params = swiper.params;
    const { slides: slides, rtlTranslate: rtl, snapGrid: snapGrid } = swiper;
    if (slides.length === 0) return;
    if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();
    let offsetCenter = -translate;
    if (rtl) offsetCenter = translate;
    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];
    let spaceBetween = params.spaceBetween;
    if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiper.size;
    else if (typeof spaceBetween === 'string') spaceBetween = parseFloat(spaceBetween);
    for(let i = 0; i < slides.length; i += 1){
        const slide = slides[i];
        let slideOffset = slide.swiperSlideOffset;
        if (params.cssMode && params.centeredSlides) slideOffset -= slides[0].swiperSlideOffset;
        const slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
        const originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
        const slideBefore = -(offsetCenter - slideOffset);
        const slideAfter = slideBefore + swiper.slidesSizesGrid[i];
        const isFullyVisible = slideBefore >= 0 && slideBefore <= swiper.size - swiper.slidesSizesGrid[i];
        const isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
        if (isVisible) {
            swiper.visibleSlides.push(slide);
            swiper.visibleSlidesIndexes.push(i);
        }
        $1262f2e38e280703$var$toggleSlideClasses$1(slide, isVisible, params.slideVisibleClass);
        $1262f2e38e280703$var$toggleSlideClasses$1(slide, isFullyVisible, params.slideFullyVisibleClass);
        slide.progress = rtl ? -slideProgress : slideProgress;
        slide.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
    }
}
function $1262f2e38e280703$var$updateProgress(translate) {
    const swiper = this;
    if (typeof translate === 'undefined') {
        const multiplier = swiper.rtlTranslate ? -1 : 1;
        // eslint-disable-next-line
        translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
    }
    const params = swiper.params;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    let { progress: progress, isBeginning: isBeginning, isEnd: isEnd, progressLoop: progressLoop } = swiper;
    const wasBeginning = isBeginning;
    const wasEnd = isEnd;
    if (translatesDiff === 0) {
        progress = 0;
        isBeginning = true;
        isEnd = true;
    } else {
        progress = (translate - swiper.minTranslate()) / translatesDiff;
        const isBeginningRounded = Math.abs(translate - swiper.minTranslate()) < 1;
        const isEndRounded = Math.abs(translate - swiper.maxTranslate()) < 1;
        isBeginning = isBeginningRounded || progress <= 0;
        isEnd = isEndRounded || progress >= 1;
        if (isBeginningRounded) progress = 0;
        if (isEndRounded) progress = 1;
    }
    if (params.loop) {
        const firstSlideIndex = swiper.getSlideIndexByData(0);
        const lastSlideIndex = swiper.getSlideIndexByData(swiper.slides.length - 1);
        const firstSlideTranslate = swiper.slidesGrid[firstSlideIndex];
        const lastSlideTranslate = swiper.slidesGrid[lastSlideIndex];
        const translateMax = swiper.slidesGrid[swiper.slidesGrid.length - 1];
        const translateAbs = Math.abs(translate);
        if (translateAbs >= firstSlideTranslate) progressLoop = (translateAbs - firstSlideTranslate) / translateMax;
        else progressLoop = (translateAbs + translateMax - lastSlideTranslate) / translateMax;
        if (progressLoop > 1) progressLoop -= 1;
    }
    Object.assign(swiper, {
        progress: progress,
        progressLoop: progressLoop,
        isBeginning: isBeginning,
        isEnd: isEnd
    });
    if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);
    if (isBeginning && !wasBeginning) swiper.emit('reachBeginning toEdge');
    if (isEnd && !wasEnd) swiper.emit('reachEnd toEdge');
    if (wasBeginning && !isBeginning || wasEnd && !isEnd) swiper.emit('fromEdge');
    swiper.emit('progress', progress);
}
const $1262f2e38e280703$var$toggleSlideClasses = (slideEl, condition, className)=>{
    if (condition && !slideEl.classList.contains(className)) slideEl.classList.add(className);
    else if (!condition && slideEl.classList.contains(className)) slideEl.classList.remove(className);
};
function $1262f2e38e280703$var$updateSlidesClasses() {
    const swiper = this;
    const { slides: slides, params: params, slidesEl: slidesEl, activeIndex: activeIndex } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    const getFilteredSlide = (selector)=>{
        return (0, $f97f33853a605dba$export$f1e1789686576879)(slidesEl, `.${params.slideClass}${selector}, swiper-slide${selector}`)[0];
    };
    let activeSlide;
    let prevSlide;
    let nextSlide;
    if (isVirtual) {
        if (params.loop) {
            let slideIndex = activeIndex - swiper.virtual.slidesBefore;
            if (slideIndex < 0) slideIndex = swiper.virtual.slides.length + slideIndex;
            if (slideIndex >= swiper.virtual.slides.length) slideIndex -= swiper.virtual.slides.length;
            activeSlide = getFilteredSlide(`[data-swiper-slide-index="${slideIndex}"]`);
        } else activeSlide = getFilteredSlide(`[data-swiper-slide-index="${activeIndex}"]`);
    } else if (gridEnabled) {
        activeSlide = slides.find((slideEl)=>slideEl.column === activeIndex);
        nextSlide = slides.find((slideEl)=>slideEl.column === activeIndex + 1);
        prevSlide = slides.find((slideEl)=>slideEl.column === activeIndex - 1);
    } else activeSlide = slides[activeIndex];
    if (activeSlide) {
        if (!gridEnabled) {
            // Next Slide
            nextSlide = (0, $f97f33853a605dba$export$43caf9889c228507)(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
            if (params.loop && !nextSlide) nextSlide = slides[0];
            // Prev Slide
            prevSlide = (0, $f97f33853a605dba$export$625550452a3fa3ec)(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
            params.loop;
        }
    }
    slides.forEach((slideEl)=>{
        $1262f2e38e280703$var$toggleSlideClasses(slideEl, slideEl === activeSlide, params.slideActiveClass);
        $1262f2e38e280703$var$toggleSlideClasses(slideEl, slideEl === nextSlide, params.slideNextClass);
        $1262f2e38e280703$var$toggleSlideClasses(slideEl, slideEl === prevSlide, params.slidePrevClass);
    });
    swiper.emitSlidesClasses();
}
const $1262f2e38e280703$var$processLazyPreloader = (swiper, imageEl)=>{
    if (!swiper || swiper.destroyed || !swiper.params) return;
    const slideSelector = ()=>swiper.isElement ? `swiper-slide` : `.${swiper.params.slideClass}`;
    const slideEl = imageEl.closest(slideSelector());
    if (slideEl) {
        let lazyEl = slideEl.querySelector(`.${swiper.params.lazyPreloaderClass}`);
        if (!lazyEl && swiper.isElement) {
            if (slideEl.shadowRoot) lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
            else // init later
            requestAnimationFrame(()=>{
                if (slideEl.shadowRoot) {
                    lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
                    if (lazyEl) lazyEl.remove();
                }
            });
        }
        if (lazyEl) lazyEl.remove();
    }
};
const $1262f2e38e280703$var$unlazy = (swiper, index)=>{
    if (!swiper.slides[index]) return;
    const imageEl = swiper.slides[index].querySelector('[loading="lazy"]');
    if (imageEl) imageEl.removeAttribute('loading');
};
const $1262f2e38e280703$var$preload = (swiper)=>{
    if (!swiper || swiper.destroyed || !swiper.params) return;
    let amount = swiper.params.lazyPreloadPrevNext;
    const len = swiper.slides.length;
    if (!len || !amount || amount < 0) return;
    amount = Math.min(amount, len);
    const slidesPerView = swiper.params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : Math.ceil(swiper.params.slidesPerView);
    const activeIndex = swiper.activeIndex;
    if (swiper.params.grid && swiper.params.grid.rows > 1) {
        const activeColumn = activeIndex;
        const preloadColumns = [
            activeColumn - amount
        ];
        preloadColumns.push(...Array.from({
            length: amount
        }).map((_, i)=>{
            return activeColumn + slidesPerView + i;
        }));
        swiper.slides.forEach((slideEl, i)=>{
            if (preloadColumns.includes(slideEl.column)) $1262f2e38e280703$var$unlazy(swiper, i);
        });
        return;
    }
    const slideIndexLastInView = activeIndex + slidesPerView - 1;
    if (swiper.params.rewind || swiper.params.loop) for(let i = activeIndex - amount; i <= slideIndexLastInView + amount; i += 1){
        const realIndex = (i % len + len) % len;
        if (realIndex < activeIndex || realIndex > slideIndexLastInView) $1262f2e38e280703$var$unlazy(swiper, realIndex);
    }
    else {
        for(let i = Math.max(activeIndex - amount, 0); i <= Math.min(slideIndexLastInView + amount, len - 1); i += 1)if (i !== activeIndex && (i > slideIndexLastInView || i < activeIndex)) $1262f2e38e280703$var$unlazy(swiper, i);
    }
};
function $1262f2e38e280703$var$getActiveIndexByTranslate(swiper) {
    const { slidesGrid: slidesGrid, params: params } = swiper;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    let activeIndex;
    for(let i = 0; i < slidesGrid.length; i += 1){
        if (typeof slidesGrid[i + 1] !== 'undefined') {
            if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) activeIndex = i;
            else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) activeIndex = i + 1;
        } else if (translate >= slidesGrid[i]) activeIndex = i;
    }
    // Normalize slideIndex
    if (params.normalizeSlideIndex) {
        if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
    }
    return activeIndex;
}
function $1262f2e38e280703$var$updateActiveIndex(newActiveIndex) {
    const swiper = this;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    const { snapGrid: snapGrid, params: params, activeIndex: previousIndex, realIndex: previousRealIndex, snapIndex: previousSnapIndex } = swiper;
    let activeIndex = newActiveIndex;
    let snapIndex;
    const getVirtualRealIndex = (aIndex)=>{
        let realIndex = aIndex - swiper.virtual.slidesBefore;
        if (realIndex < 0) realIndex = swiper.virtual.slides.length + realIndex;
        if (realIndex >= swiper.virtual.slides.length) realIndex -= swiper.virtual.slides.length;
        return realIndex;
    };
    if (typeof activeIndex === 'undefined') activeIndex = $1262f2e38e280703$var$getActiveIndexByTranslate(swiper);
    if (snapGrid.indexOf(translate) >= 0) snapIndex = snapGrid.indexOf(translate);
    else {
        const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
        snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
    }
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    if (activeIndex === previousIndex && !swiper.params.loop) {
        if (snapIndex !== previousSnapIndex) {
            swiper.snapIndex = snapIndex;
            swiper.emit('snapIndexChange');
        }
        return;
    }
    if (activeIndex === previousIndex && swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) {
        swiper.realIndex = getVirtualRealIndex(activeIndex);
        return;
    }
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    // Get real index
    let realIndex;
    if (swiper.virtual && params.virtual.enabled && params.loop) realIndex = getVirtualRealIndex(activeIndex);
    else if (gridEnabled) {
        const firstSlideInColumn = swiper.slides.find((slideEl)=>slideEl.column === activeIndex);
        let activeSlideIndex = parseInt(firstSlideInColumn.getAttribute('data-swiper-slide-index'), 10);
        if (Number.isNaN(activeSlideIndex)) activeSlideIndex = Math.max(swiper.slides.indexOf(firstSlideInColumn), 0);
        realIndex = Math.floor(activeSlideIndex / params.grid.rows);
    } else if (swiper.slides[activeIndex]) {
        const slideIndex = swiper.slides[activeIndex].getAttribute('data-swiper-slide-index');
        if (slideIndex) realIndex = parseInt(slideIndex, 10);
        else realIndex = activeIndex;
    } else realIndex = activeIndex;
    Object.assign(swiper, {
        previousSnapIndex: previousSnapIndex,
        snapIndex: snapIndex,
        previousRealIndex: previousRealIndex,
        realIndex: realIndex,
        previousIndex: previousIndex,
        activeIndex: activeIndex
    });
    if (swiper.initialized) $1262f2e38e280703$var$preload(swiper);
    swiper.emit('activeIndexChange');
    swiper.emit('snapIndexChange');
    if (swiper.initialized || swiper.params.runCallbacksOnInit) {
        if (previousRealIndex !== realIndex) swiper.emit('realIndexChange');
        swiper.emit('slideChange');
    }
}
function $1262f2e38e280703$var$updateClickedSlide(el, path) {
    const swiper = this;
    const params = swiper.params;
    let slide = el.closest(`.${params.slideClass}, swiper-slide`);
    if (!slide && swiper.isElement && path && path.length > 1 && path.includes(el)) [
        ...path.slice(path.indexOf(el) + 1, path.length)
    ].forEach((pathEl)=>{
        if (!slide && pathEl.matches && pathEl.matches(`.${params.slideClass}, swiper-slide`)) slide = pathEl;
    });
    let slideFound = false;
    let slideIndex;
    if (slide) {
        for(let i = 0; i < swiper.slides.length; i += 1)if (swiper.slides[i] === slide) {
            slideFound = true;
            slideIndex = i;
            break;
        }
    }
    if (slide && slideFound) {
        swiper.clickedSlide = slide;
        if (swiper.virtual && swiper.params.virtual.enabled) swiper.clickedIndex = parseInt(slide.getAttribute('data-swiper-slide-index'), 10);
        else swiper.clickedIndex = slideIndex;
    } else {
        swiper.clickedSlide = undefined;
        swiper.clickedIndex = undefined;
        return;
    }
    if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) swiper.slideToClickedSlide();
}
var $1262f2e38e280703$var$update = {
    updateSize: $1262f2e38e280703$var$updateSize,
    updateSlides: $1262f2e38e280703$var$updateSlides,
    updateAutoHeight: $1262f2e38e280703$var$updateAutoHeight,
    updateSlidesOffset: $1262f2e38e280703$var$updateSlidesOffset,
    updateSlidesProgress: $1262f2e38e280703$var$updateSlidesProgress,
    updateProgress: $1262f2e38e280703$var$updateProgress,
    updateSlidesClasses: $1262f2e38e280703$var$updateSlidesClasses,
    updateActiveIndex: $1262f2e38e280703$var$updateActiveIndex,
    updateClickedSlide: $1262f2e38e280703$var$updateClickedSlide
};
function $1262f2e38e280703$var$getSwiperTranslate(axis) {
    if (axis === void 0) axis = this.isHorizontal() ? 'x' : 'y';
    const swiper = this;
    const { params: params, rtlTranslate: rtl, translate: translate, wrapperEl: wrapperEl } = swiper;
    if (params.virtualTranslate) return rtl ? -translate : translate;
    if (params.cssMode) return translate;
    let currentTranslate = (0, $f97f33853a605dba$export$342063e11d6c3cad)(wrapperEl, axis);
    currentTranslate += swiper.cssOverflowAdjustment();
    if (rtl) currentTranslate = -currentTranslate;
    return currentTranslate || 0;
}
function $1262f2e38e280703$var$setTranslate(translate, byController) {
    const swiper = this;
    const { rtlTranslate: rtl, params: params, wrapperEl: wrapperEl, progress: progress } = swiper;
    let x = 0;
    let y = 0;
    const z = 0;
    if (swiper.isHorizontal()) x = rtl ? -translate : translate;
    else y = translate;
    if (params.roundLengths) {
        x = Math.floor(x);
        y = Math.floor(y);
    }
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y;
    if (params.cssMode) wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
    else if (!params.virtualTranslate) {
        if (swiper.isHorizontal()) x -= swiper.cssOverflowAdjustment();
        else y -= swiper.cssOverflowAdjustment();
        wrapperEl.style.transform = `translate3d(${x}px, ${y}px, ${z}px)`;
    }
    // Check if we need to update progress
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== progress) swiper.updateProgress(translate);
    swiper.emit('setTranslate', swiper.translate, byController);
}
function $1262f2e38e280703$var$minTranslate() {
    return -this.snapGrid[0];
}
function $1262f2e38e280703$var$maxTranslate() {
    return -this.snapGrid[this.snapGrid.length - 1];
}
function $1262f2e38e280703$var$translateTo(translate, speed, runCallbacks, translateBounds, internal) {
    if (translate === void 0) translate = 0;
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    if (translateBounds === void 0) translateBounds = true;
    const swiper = this;
    const { params: params, wrapperEl: wrapperEl } = swiper;
    if (swiper.animating && params.preventInteractionOnTransition) return false;
    const minTranslate = swiper.minTranslate();
    const maxTranslate = swiper.maxTranslate();
    let newTranslate;
    if (translateBounds && translate > minTranslate) newTranslate = minTranslate;
    else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;
    else newTranslate = translate;
    // Update progress
    swiper.updateProgress(newTranslate);
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        if (speed === 0) wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
        else {
            if (!swiper.support.smoothScroll) {
                (0, $f97f33853a605dba$export$3b14a55fb2447963)({
                    swiper: swiper,
                    targetPosition: -newTranslate,
                    side: isH ? 'left' : 'top'
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? 'left' : 'top']: -newTranslate,
                behavior: 'smooth'
            });
        }
        return true;
    }
    if (speed === 0) {
        swiper.setTransition(0);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit('beforeTransitionStart', speed, internal);
            swiper.emit('transitionEnd');
        }
    } else {
        swiper.setTransition(speed);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit('beforeTransitionStart', speed, internal);
            swiper.emit('transitionStart');
        }
        if (!swiper.animating) {
            swiper.animating = true;
            if (!swiper.onTranslateToWrapperTransitionEnd) swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
                if (!swiper || swiper.destroyed) return;
                if (e.target !== this) return;
                swiper.wrapperEl.removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
                swiper.onTranslateToWrapperTransitionEnd = null;
                delete swiper.onTranslateToWrapperTransitionEnd;
                swiper.animating = false;
                if (runCallbacks) swiper.emit('transitionEnd');
            };
            swiper.wrapperEl.addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
        }
    }
    return true;
}
var $1262f2e38e280703$var$translate = {
    getTranslate: $1262f2e38e280703$var$getSwiperTranslate,
    setTranslate: $1262f2e38e280703$var$setTranslate,
    minTranslate: $1262f2e38e280703$var$minTranslate,
    maxTranslate: $1262f2e38e280703$var$maxTranslate,
    translateTo: $1262f2e38e280703$var$translateTo
};
function $1262f2e38e280703$var$setTransition(duration, byController) {
    const swiper = this;
    if (!swiper.params.cssMode) {
        swiper.wrapperEl.style.transitionDuration = `${duration}ms`;
        swiper.wrapperEl.style.transitionDelay = duration === 0 ? `0ms` : '';
    }
    swiper.emit('setTransition', duration, byController);
}
function $1262f2e38e280703$var$transitionEmit(_ref) {
    let { swiper: swiper, runCallbacks: runCallbacks, direction: direction, step: step } = _ref;
    const { activeIndex: activeIndex, previousIndex: previousIndex } = swiper;
    let dir = direction;
    if (!dir) {
        if (activeIndex > previousIndex) dir = 'next';
        else if (activeIndex < previousIndex) dir = 'prev';
        else dir = 'reset';
    }
    swiper.emit(`transition${step}`);
    if (runCallbacks && dir === 'reset') swiper.emit(`slideResetTransition${step}`);
    else if (runCallbacks && activeIndex !== previousIndex) {
        swiper.emit(`slideChangeTransition${step}`);
        if (dir === 'next') swiper.emit(`slideNextTransition${step}`);
        else swiper.emit(`slidePrevTransition${step}`);
    }
}
function $1262f2e38e280703$var$transitionStart(runCallbacks, direction) {
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    const { params: params } = swiper;
    if (params.cssMode) return;
    if (params.autoHeight) swiper.updateAutoHeight();
    $1262f2e38e280703$var$transitionEmit({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: 'Start'
    });
}
function $1262f2e38e280703$var$transitionEnd(runCallbacks, direction) {
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    const { params: params } = swiper;
    swiper.animating = false;
    if (params.cssMode) return;
    swiper.setTransition(0);
    $1262f2e38e280703$var$transitionEmit({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: 'End'
    });
}
var $1262f2e38e280703$var$transition = {
    setTransition: $1262f2e38e280703$var$setTransition,
    transitionStart: $1262f2e38e280703$var$transitionStart,
    transitionEnd: $1262f2e38e280703$var$transitionEnd
};
function $1262f2e38e280703$var$slideTo(index, speed, runCallbacks, internal, initial) {
    if (index === void 0) index = 0;
    if (runCallbacks === void 0) runCallbacks = true;
    if (typeof index === 'string') index = parseInt(index, 10);
    const swiper = this;
    let slideIndex = index;
    if (slideIndex < 0) slideIndex = 0;
    const { params: params, snapGrid: snapGrid, slidesGrid: slidesGrid, previousIndex: previousIndex, activeIndex: activeIndex, rtlTranslate: rtl, wrapperEl: wrapperEl, enabled: enabled } = swiper;
    if (!enabled && !internal && !initial || swiper.destroyed || swiper.animating && params.preventInteractionOnTransition) return false;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
    let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    const translate = -snapGrid[snapIndex];
    // Normalize slideIndex
    if (params.normalizeSlideIndex) for(let i = 0; i < slidesGrid.length; i += 1){
        const normalizedTranslate = -Math.floor(translate * 100);
        const normalizedGrid = Math.floor(slidesGrid[i] * 100);
        const normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
        if (typeof slidesGrid[i + 1] !== 'undefined') {
            if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) slideIndex = i;
            else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) slideIndex = i + 1;
        } else if (normalizedTranslate >= normalizedGrid) slideIndex = i;
    }
    // Directions locks
    if (swiper.initialized && slideIndex !== activeIndex) {
        if (!swiper.allowSlideNext && (rtl ? translate > swiper.translate && translate > swiper.minTranslate() : translate < swiper.translate && translate < swiper.minTranslate())) return false;
        if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
            if ((activeIndex || 0) !== slideIndex) return false;
        }
    }
    if (slideIndex !== (previousIndex || 0) && runCallbacks) swiper.emit('beforeSlideChangeStart');
    // Update progress
    swiper.updateProgress(translate);
    let direction;
    if (slideIndex > activeIndex) direction = 'next';
    else if (slideIndex < activeIndex) direction = 'prev';
    else direction = 'reset';
    // initial virtual
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    const isInitialVirtual = isVirtual && initial;
    // Update Index
    if (!isInitialVirtual && (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate)) {
        swiper.updateActiveIndex(slideIndex);
        // Update Height
        if (params.autoHeight) swiper.updateAutoHeight();
        swiper.updateSlidesClasses();
        if (params.effect !== 'slide') swiper.setTranslate(translate);
        if (direction !== 'reset') {
            swiper.transitionStart(runCallbacks, direction);
            swiper.transitionEnd(runCallbacks, direction);
        }
        return false;
    }
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        const t = rtl ? translate : -translate;
        if (speed === 0) {
            if (isVirtual) {
                swiper.wrapperEl.style.scrollSnapType = 'none';
                swiper._immediateVirtual = true;
            }
            if (isVirtual && !swiper._cssModeVirtualInitialSet && swiper.params.initialSlide > 0) {
                swiper._cssModeVirtualInitialSet = true;
                requestAnimationFrame(()=>{
                    wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
                });
            } else wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
            if (isVirtual) requestAnimationFrame(()=>{
                swiper.wrapperEl.style.scrollSnapType = '';
                swiper._immediateVirtual = false;
            });
        } else {
            if (!swiper.support.smoothScroll) {
                (0, $f97f33853a605dba$export$3b14a55fb2447963)({
                    swiper: swiper,
                    targetPosition: t,
                    side: isH ? 'left' : 'top'
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? 'left' : 'top']: t,
                behavior: 'smooth'
            });
        }
        return true;
    }
    const browser = $1262f2e38e280703$var$getBrowser();
    const isSafari = browser.isSafari;
    if (isVirtual && !initial && isSafari && swiper.isElement) swiper.virtual.update(false, false, slideIndex);
    swiper.setTransition(speed);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit('beforeTransitionStart', speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    if (speed === 0) swiper.transitionEnd(runCallbacks, direction);
    else if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onSlideToWrapperTransitionEnd) swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
            if (!swiper || swiper.destroyed) return;
            if (e.target !== this) return;
            swiper.wrapperEl.removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
            swiper.onSlideToWrapperTransitionEnd = null;
            delete swiper.onSlideToWrapperTransitionEnd;
            swiper.transitionEnd(runCallbacks, direction);
        };
        swiper.wrapperEl.addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
    }
    return true;
}
function $1262f2e38e280703$var$slideToLoop(index, speed, runCallbacks, internal) {
    if (index === void 0) index = 0;
    if (runCallbacks === void 0) runCallbacks = true;
    if (typeof index === 'string') {
        const indexAsNumber = parseInt(index, 10);
        index = indexAsNumber;
    }
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    const gridEnabled = swiper.grid && swiper.params.grid && swiper.params.grid.rows > 1;
    let newIndex = index;
    if (swiper.params.loop) {
        if (swiper.virtual && swiper.params.virtual.enabled) // eslint-disable-next-line
        newIndex = newIndex + swiper.virtual.slidesBefore;
        else {
            let targetSlideIndex;
            if (gridEnabled) {
                const slideIndex = newIndex * swiper.params.grid.rows;
                targetSlideIndex = swiper.slides.find((slideEl)=>slideEl.getAttribute('data-swiper-slide-index') * 1 === slideIndex).column;
            } else targetSlideIndex = swiper.getSlideIndexByData(newIndex);
            const cols = gridEnabled ? Math.ceil(swiper.slides.length / swiper.params.grid.rows) : swiper.slides.length;
            const { centeredSlides: centeredSlides } = swiper.params;
            let slidesPerView = swiper.params.slidesPerView;
            if (slidesPerView === 'auto') slidesPerView = swiper.slidesPerViewDynamic();
            else {
                slidesPerView = Math.ceil(parseFloat(swiper.params.slidesPerView, 10));
                if (centeredSlides && slidesPerView % 2 === 0) slidesPerView = slidesPerView + 1;
            }
            let needLoopFix = cols - targetSlideIndex < slidesPerView;
            if (centeredSlides) needLoopFix = needLoopFix || targetSlideIndex < Math.ceil(slidesPerView / 2);
            if (internal && centeredSlides && swiper.params.slidesPerView !== 'auto' && !gridEnabled) needLoopFix = false;
            if (needLoopFix) {
                const direction = centeredSlides ? targetSlideIndex < swiper.activeIndex ? 'prev' : 'next' : targetSlideIndex - swiper.activeIndex - 1 < swiper.params.slidesPerView ? 'next' : 'prev';
                swiper.loopFix({
                    direction: direction,
                    slideTo: true,
                    activeSlideIndex: direction === 'next' ? targetSlideIndex + 1 : targetSlideIndex - cols + 1,
                    slideRealIndex: direction === 'next' ? swiper.realIndex : undefined
                });
            }
            if (gridEnabled) {
                const slideIndex = newIndex * swiper.params.grid.rows;
                newIndex = swiper.slides.find((slideEl)=>slideEl.getAttribute('data-swiper-slide-index') * 1 === slideIndex).column;
            } else newIndex = swiper.getSlideIndexByData(newIndex);
        }
    }
    requestAnimationFrame(()=>{
        swiper.slideTo(newIndex, speed, runCallbacks, internal);
    });
    return swiper;
}
/* eslint no-unused-vars: "off" */ function $1262f2e38e280703$var$slideNext(speed, runCallbacks, internal) {
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    const { enabled: enabled, params: params, animating: animating } = swiper;
    if (!enabled || swiper.destroyed) return swiper;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    let perGroup = params.slidesPerGroup;
    if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) perGroup = Math.max(swiper.slidesPerViewDynamic('current', true), 1);
    const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding) return false;
        swiper.loopFix({
            direction: 'next'
        });
        // eslint-disable-next-line
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
        if (swiper.activeIndex === swiper.slides.length - 1 && params.cssMode) {
            requestAnimationFrame(()=>{
                swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
            });
            return true;
        }
    }
    if (params.rewind && swiper.isEnd) return swiper.slideTo(0, speed, runCallbacks, internal);
    return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $1262f2e38e280703$var$slidePrev(speed, runCallbacks, internal) {
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    const { params: params, snapGrid: snapGrid, slidesGrid: slidesGrid, rtlTranslate: rtlTranslate, enabled: enabled, animating: animating } = swiper;
    if (!enabled || swiper.destroyed) return swiper;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding) return false;
        swiper.loopFix({
            direction: 'prev'
        });
        // eslint-disable-next-line
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
    }
    const translate = rtlTranslate ? swiper.translate : -swiper.translate;
    function normalize(val) {
        if (val < 0) return -Math.floor(Math.abs(val));
        return Math.floor(val);
    }
    const normalizedTranslate = normalize(translate);
    const normalizedSnapGrid = snapGrid.map((val)=>normalize(val));
    const isFreeMode = params.freeMode && params.freeMode.enabled;
    let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
    if (typeof prevSnap === 'undefined' && (params.cssMode || isFreeMode)) {
        let prevSnapIndex;
        snapGrid.forEach((snap, snapIndex)=>{
            if (normalizedTranslate >= snap) // prevSnap = snap;
            prevSnapIndex = snapIndex;
        });
        if (typeof prevSnapIndex !== 'undefined') prevSnap = isFreeMode ? snapGrid[prevSnapIndex] : snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
    let prevIndex = 0;
    if (typeof prevSnap !== 'undefined') {
        prevIndex = slidesGrid.indexOf(prevSnap);
        if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
        if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
            prevIndex = prevIndex - swiper.slidesPerViewDynamic('previous', true) + 1;
            prevIndex = Math.max(prevIndex, 0);
        }
    }
    if (params.rewind && swiper.isBeginning) {
        const lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
    } else if (params.loop && swiper.activeIndex === 0 && params.cssMode) {
        requestAnimationFrame(()=>{
            swiper.slideTo(prevIndex, speed, runCallbacks, internal);
        });
        return true;
    }
    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $1262f2e38e280703$var$slideReset(speed, runCallbacks, internal) {
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $1262f2e38e280703$var$slideToClosest(speed, runCallbacks, internal, threshold) {
    if (runCallbacks === void 0) runCallbacks = true;
    if (threshold === void 0) threshold = 0.5;
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    let index = swiper.activeIndex;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
    const snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    if (translate >= swiper.snapGrid[snapIndex]) {
        // The current translate is on or after the current snap index, so the choice
        // is between the current index and the one after it.
        const currentSnap = swiper.snapGrid[snapIndex];
        const nextSnap = swiper.snapGrid[snapIndex + 1];
        if (translate - currentSnap > (nextSnap - currentSnap) * threshold) index += swiper.params.slidesPerGroup;
    } else {
        // The current translate is before the current snap index, so the choice
        // is between the current index and the one before it.
        const prevSnap = swiper.snapGrid[snapIndex - 1];
        const currentSnap = swiper.snapGrid[snapIndex];
        if (translate - prevSnap <= (currentSnap - prevSnap) * threshold) index -= swiper.params.slidesPerGroup;
    }
    index = Math.max(index, 0);
    index = Math.min(index, swiper.slidesGrid.length - 1);
    return swiper.slideTo(index, speed, runCallbacks, internal);
}
function $1262f2e38e280703$var$slideToClickedSlide() {
    const swiper = this;
    if (swiper.destroyed) return;
    const { params: params, slidesEl: slidesEl } = swiper;
    const slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    let slideToIndex = swiper.getSlideIndexWhenGrid(swiper.clickedIndex);
    let realIndex;
    const slideSelector = swiper.isElement ? `swiper-slide` : `.${params.slideClass}`;
    const isGrid = swiper.grid && swiper.params.grid && swiper.params.grid.rows > 1;
    if (params.loop) {
        if (swiper.animating) return;
        realIndex = parseInt(swiper.clickedSlide.getAttribute('data-swiper-slide-index'), 10);
        if (params.centeredSlides) swiper.slideToLoop(realIndex);
        else if (slideToIndex > (isGrid ? (swiper.slides.length - slidesPerView) / 2 - (swiper.params.grid.rows - 1) : swiper.slides.length - slidesPerView)) {
            swiper.loopFix();
            slideToIndex = swiper.getSlideIndex((0, $f97f33853a605dba$export$f1e1789686576879)(slidesEl, `${slideSelector}[data-swiper-slide-index="${realIndex}"]`)[0]);
            (0, $f97f33853a605dba$export$7ccc53e8f1e7dfc5)(()=>{
                swiper.slideTo(slideToIndex);
            });
        } else swiper.slideTo(slideToIndex);
    } else swiper.slideTo(slideToIndex);
}
var $1262f2e38e280703$var$slide = {
    slideTo: $1262f2e38e280703$var$slideTo,
    slideToLoop: $1262f2e38e280703$var$slideToLoop,
    slideNext: $1262f2e38e280703$var$slideNext,
    slidePrev: $1262f2e38e280703$var$slidePrev,
    slideReset: $1262f2e38e280703$var$slideReset,
    slideToClosest: $1262f2e38e280703$var$slideToClosest,
    slideToClickedSlide: $1262f2e38e280703$var$slideToClickedSlide
};
function $1262f2e38e280703$var$loopCreate(slideRealIndex, initial) {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (!params.loop || swiper.virtual && swiper.params.virtual.enabled) return;
    const initSlides = ()=>{
        const slides = (0, $f97f33853a605dba$export$f1e1789686576879)(slidesEl, `.${params.slideClass}, swiper-slide`);
        slides.forEach((el, index)=>{
            el.setAttribute('data-swiper-slide-index', index);
        });
    };
    const clearBlankSlides = ()=>{
        const slides = (0, $f97f33853a605dba$export$f1e1789686576879)(slidesEl, `.${params.slideBlankClass}`);
        slides.forEach((el)=>{
            el.remove();
        });
        if (slides.length > 0) {
            swiper.recalcSlides();
            swiper.updateSlides();
        }
    };
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    if (params.loopAddBlankSlides && (params.slidesPerGroup > 1 || gridEnabled)) clearBlankSlides();
    const slidesPerGroup = params.slidesPerGroup * (gridEnabled ? params.grid.rows : 1);
    const shouldFillGroup = swiper.slides.length % slidesPerGroup !== 0;
    const shouldFillGrid = gridEnabled && swiper.slides.length % params.grid.rows !== 0;
    const addBlankSlides = (amountOfSlides)=>{
        for(let i = 0; i < amountOfSlides; i += 1){
            const slideEl = swiper.isElement ? (0, $f97f33853a605dba$export$db3b6bfb95261072)('swiper-slide', [
                params.slideBlankClass
            ]) : (0, $f97f33853a605dba$export$db3b6bfb95261072)('div', [
                params.slideClass,
                params.slideBlankClass
            ]);
            swiper.slidesEl.append(slideEl);
        }
    };
    if (shouldFillGroup) {
        if (params.loopAddBlankSlides) {
            const slidesToAdd = slidesPerGroup - swiper.slides.length % slidesPerGroup;
            addBlankSlides(slidesToAdd);
            swiper.recalcSlides();
            swiper.updateSlides();
        } else (0, $f97f33853a605dba$export$90a7f3efeed30595)('Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)');
        initSlides();
    } else if (shouldFillGrid) {
        if (params.loopAddBlankSlides) {
            const slidesToAdd = params.grid.rows - swiper.slides.length % params.grid.rows;
            addBlankSlides(slidesToAdd);
            swiper.recalcSlides();
            swiper.updateSlides();
        } else (0, $f97f33853a605dba$export$90a7f3efeed30595)('Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)');
        initSlides();
    } else initSlides();
    swiper.loopFix({
        slideRealIndex: slideRealIndex,
        direction: params.centeredSlides ? undefined : 'next',
        initial: initial
    });
}
function $1262f2e38e280703$var$loopFix(_temp) {
    let { slideRealIndex: slideRealIndex, slideTo: slideTo = true, direction: direction, setTranslate: setTranslate, activeSlideIndex: activeSlideIndex, initial: initial, byController: byController, byMousewheel: byMousewheel } = _temp === void 0 ? {} : _temp;
    const swiper = this;
    if (!swiper.params.loop) return;
    swiper.emit('beforeLoopFix');
    const { slides: slides, allowSlidePrev: allowSlidePrev, allowSlideNext: allowSlideNext, slidesEl: slidesEl, params: params } = swiper;
    const { centeredSlides: centeredSlides, initialSlide: initialSlide } = params;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;
    if (swiper.virtual && params.virtual.enabled) {
        if (slideTo) {
            if (!params.centeredSlides && swiper.snapIndex === 0) swiper.slideTo(swiper.virtual.slides.length, 0, false, true);
            else if (params.centeredSlides && swiper.snapIndex < params.slidesPerView) swiper.slideTo(swiper.virtual.slides.length + swiper.snapIndex, 0, false, true);
            else if (swiper.snapIndex === swiper.snapGrid.length - 1) swiper.slideTo(swiper.virtual.slidesBefore, 0, false, true);
        }
        swiper.allowSlidePrev = allowSlidePrev;
        swiper.allowSlideNext = allowSlideNext;
        swiper.emit('loopFix');
        return;
    }
    let slidesPerView = params.slidesPerView;
    if (slidesPerView === 'auto') slidesPerView = swiper.slidesPerViewDynamic();
    else {
        slidesPerView = Math.ceil(parseFloat(params.slidesPerView, 10));
        if (centeredSlides && slidesPerView % 2 === 0) slidesPerView = slidesPerView + 1;
    }
    const slidesPerGroup = params.slidesPerGroupAuto ? slidesPerView : params.slidesPerGroup;
    let loopedSlides = centeredSlides ? Math.max(slidesPerGroup, Math.ceil(slidesPerView / 2)) : slidesPerGroup;
    if (loopedSlides % slidesPerGroup !== 0) loopedSlides += slidesPerGroup - loopedSlides % slidesPerGroup;
    loopedSlides += params.loopAdditionalSlides;
    swiper.loopedSlides = loopedSlides;
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    if (slides.length < slidesPerView + loopedSlides || swiper.params.effect === 'cards' && slides.length < slidesPerView + loopedSlides * 2) (0, $f97f33853a605dba$export$90a7f3efeed30595)('Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled or not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters');
    else if (gridEnabled && params.grid.fill === 'row') (0, $f97f33853a605dba$export$90a7f3efeed30595)('Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`');
    const prependSlidesIndexes = [];
    const appendSlidesIndexes = [];
    const cols = gridEnabled ? Math.ceil(slides.length / params.grid.rows) : slides.length;
    const isInitialOverflow = initial && cols - initialSlide < slidesPerView && !centeredSlides;
    let activeIndex = isInitialOverflow ? initialSlide : swiper.activeIndex;
    if (typeof activeSlideIndex === 'undefined') activeSlideIndex = swiper.getSlideIndex(slides.find((el)=>el.classList.contains(params.slideActiveClass)));
    else activeIndex = activeSlideIndex;
    const isNext = direction === 'next' || !direction;
    const isPrev = direction === 'prev' || !direction;
    let slidesPrepended = 0;
    let slidesAppended = 0;
    const activeColIndex = gridEnabled ? slides[activeSlideIndex].column : activeSlideIndex;
    const activeColIndexWithShift = activeColIndex + (centeredSlides && typeof setTranslate === 'undefined' ? -slidesPerView / 2 + 0.5 : 0);
    // prepend last slides before start
    if (activeColIndexWithShift < loopedSlides) {
        slidesPrepended = Math.max(loopedSlides - activeColIndexWithShift, slidesPerGroup);
        for(let i = 0; i < loopedSlides - activeColIndexWithShift; i += 1){
            const index = i - Math.floor(i / cols) * cols;
            if (gridEnabled) {
                const colIndexToPrepend = cols - index - 1;
                for(let i = slides.length - 1; i >= 0; i -= 1)if (slides[i].column === colIndexToPrepend) prependSlidesIndexes.push(i);
            // slides.forEach((slide, slideIndex) => {
            //   if (slide.column === colIndexToPrepend) prependSlidesIndexes.push(slideIndex);
            // });
            } else prependSlidesIndexes.push(cols - index - 1);
        }
    } else if (activeColIndexWithShift + slidesPerView > cols - loopedSlides) {
        slidesAppended = Math.max(activeColIndexWithShift - (cols - loopedSlides * 2), slidesPerGroup);
        if (isInitialOverflow) slidesAppended = Math.max(slidesAppended, slidesPerView - cols + initialSlide + 1);
        for(let i = 0; i < slidesAppended; i += 1){
            const index = i - Math.floor(i / cols) * cols;
            if (gridEnabled) slides.forEach((slide, slideIndex)=>{
                if (slide.column === index) appendSlidesIndexes.push(slideIndex);
            });
            else appendSlidesIndexes.push(index);
        }
    }
    swiper.__preventObserver__ = true;
    requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
    if (swiper.params.effect === 'cards' && slides.length < slidesPerView + loopedSlides * 2) {
        if (appendSlidesIndexes.includes(activeSlideIndex)) appendSlidesIndexes.splice(appendSlidesIndexes.indexOf(activeSlideIndex), 1);
        if (prependSlidesIndexes.includes(activeSlideIndex)) prependSlidesIndexes.splice(prependSlidesIndexes.indexOf(activeSlideIndex), 1);
    }
    if (isPrev) prependSlidesIndexes.forEach((index)=>{
        slides[index].swiperLoopMoveDOM = true;
        slidesEl.prepend(slides[index]);
        slides[index].swiperLoopMoveDOM = false;
    });
    if (isNext) appendSlidesIndexes.forEach((index)=>{
        slides[index].swiperLoopMoveDOM = true;
        slidesEl.append(slides[index]);
        slides[index].swiperLoopMoveDOM = false;
    });
    swiper.recalcSlides();
    if (params.slidesPerView === 'auto') swiper.updateSlides();
    else if (gridEnabled && (prependSlidesIndexes.length > 0 && isPrev || appendSlidesIndexes.length > 0 && isNext)) swiper.slides.forEach((slide, slideIndex)=>{
        swiper.grid.updateSlide(slideIndex, slide, swiper.slides);
    });
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    if (slideTo) {
        if (prependSlidesIndexes.length > 0 && isPrev) {
            if (typeof slideRealIndex === 'undefined') {
                const currentSlideTranslate = swiper.slidesGrid[activeIndex];
                const newSlideTranslate = swiper.slidesGrid[activeIndex + slidesPrepended];
                const diff = newSlideTranslate - currentSlideTranslate;
                if (byMousewheel) swiper.setTranslate(swiper.translate - diff);
                else {
                    swiper.slideTo(activeIndex + Math.ceil(slidesPrepended), 0, false, true);
                    if (setTranslate) {
                        swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
                        swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
                    }
                }
            } else if (setTranslate) {
                const shift = gridEnabled ? prependSlidesIndexes.length / params.grid.rows : prependSlidesIndexes.length;
                swiper.slideTo(swiper.activeIndex + shift, 0, false, true);
                swiper.touchEventsData.currentTranslate = swiper.translate;
            }
        } else if (appendSlidesIndexes.length > 0 && isNext) {
            if (typeof slideRealIndex === 'undefined') {
                const currentSlideTranslate = swiper.slidesGrid[activeIndex];
                const newSlideTranslate = swiper.slidesGrid[activeIndex - slidesAppended];
                const diff = newSlideTranslate - currentSlideTranslate;
                if (byMousewheel) swiper.setTranslate(swiper.translate - diff);
                else {
                    swiper.slideTo(activeIndex - slidesAppended, 0, false, true);
                    if (setTranslate) {
                        swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
                        swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
                    }
                }
            } else {
                const shift = gridEnabled ? appendSlidesIndexes.length / params.grid.rows : appendSlidesIndexes.length;
                swiper.slideTo(swiper.activeIndex - shift, 0, false, true);
            }
        }
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.controller && swiper.controller.control && !byController) {
        const loopParams = {
            slideRealIndex: slideRealIndex,
            direction: direction,
            setTranslate: setTranslate,
            activeSlideIndex: activeSlideIndex,
            byController: true
        };
        if (Array.isArray(swiper.controller.control)) swiper.controller.control.forEach((c)=>{
            if (!c.destroyed && c.params.loop) c.loopFix({
                ...loopParams,
                slideTo: c.params.slidesPerView === params.slidesPerView ? slideTo : false
            });
        });
        else if (swiper.controller.control instanceof swiper.constructor && swiper.controller.control.params.loop) swiper.controller.control.loopFix({
            ...loopParams,
            slideTo: swiper.controller.control.params.slidesPerView === params.slidesPerView ? slideTo : false
        });
    }
    swiper.emit('loopFix');
}
function $1262f2e38e280703$var$loopDestroy() {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (!params.loop || !slidesEl || swiper.virtual && swiper.params.virtual.enabled) return;
    swiper.recalcSlides();
    const newSlidesOrder = [];
    swiper.slides.forEach((slideEl)=>{
        const index = typeof slideEl.swiperSlideIndex === 'undefined' ? slideEl.getAttribute('data-swiper-slide-index') * 1 : slideEl.swiperSlideIndex;
        newSlidesOrder[index] = slideEl;
    });
    swiper.slides.forEach((slideEl)=>{
        slideEl.removeAttribute('data-swiper-slide-index');
    });
    newSlidesOrder.forEach((slideEl)=>{
        slidesEl.append(slideEl);
    });
    swiper.recalcSlides();
    swiper.slideTo(swiper.realIndex, 0);
}
var $1262f2e38e280703$var$loop = {
    loopCreate: $1262f2e38e280703$var$loopCreate,
    loopFix: $1262f2e38e280703$var$loopFix,
    loopDestroy: $1262f2e38e280703$var$loopDestroy
};
function $1262f2e38e280703$var$setGrabCursor(moving) {
    const swiper = this;
    if (!swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    const el = swiper.params.touchEventsTarget === 'container' ? swiper.el : swiper.wrapperEl;
    if (swiper.isElement) swiper.__preventObserver__ = true;
    el.style.cursor = 'move';
    el.style.cursor = moving ? 'grabbing' : 'grab';
    if (swiper.isElement) requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
}
function $1262f2e38e280703$var$unsetGrabCursor() {
    const swiper = this;
    if (swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    if (swiper.isElement) swiper.__preventObserver__ = true;
    swiper[swiper.params.touchEventsTarget === 'container' ? 'el' : 'wrapperEl'].style.cursor = '';
    if (swiper.isElement) requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
}
var $1262f2e38e280703$var$grabCursor = {
    setGrabCursor: $1262f2e38e280703$var$setGrabCursor,
    unsetGrabCursor: $1262f2e38e280703$var$unsetGrabCursor
};
// Modified from https://stackoverflow.com/questions/54520554/custom-element-getrootnode-closest-function-crossing-multiple-parent-shadowd
function $1262f2e38e280703$var$closestElement(selector, base) {
    if (base === void 0) base = this;
    function __closestFrom(el) {
        if (!el || el === (0, $0868fe5596dee114$export$39b482c5e57630a8)() || el === (0, $0868fe5596dee114$export$407448d2b89b1813)()) return null;
        if (el.assignedSlot) el = el.assignedSlot;
        const found = el.closest(selector);
        if (!found && !el.getRootNode) return null;
        return found || __closestFrom(el.getRootNode().host);
    }
    return __closestFrom(base);
}
function $1262f2e38e280703$var$preventEdgeSwipe(swiper, event, startX) {
    const window1 = (0, $0868fe5596dee114$export$407448d2b89b1813)();
    const { params: params } = swiper;
    const edgeSwipeDetection = params.edgeSwipeDetection;
    const edgeSwipeThreshold = params.edgeSwipeThreshold;
    if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window1.innerWidth - edgeSwipeThreshold)) {
        if (edgeSwipeDetection === 'prevent') {
            event.preventDefault();
            return true;
        }
        return false;
    }
    return true;
}
function $1262f2e38e280703$var$onTouchStart(event) {
    const swiper = this;
    const document1 = (0, $0868fe5596dee114$export$39b482c5e57630a8)();
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    const data = swiper.touchEventsData;
    if (e.type === 'pointerdown') {
        if (data.pointerId !== null && data.pointerId !== e.pointerId) return;
        data.pointerId = e.pointerId;
    } else if (e.type === 'touchstart' && e.targetTouches.length === 1) data.touchId = e.targetTouches[0].identifier;
    if (e.type === 'touchstart') {
        // don't proceed touch event
        $1262f2e38e280703$var$preventEdgeSwipe(swiper, e, e.targetTouches[0].pageX);
        return;
    }
    const { params: params, touches: touches, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && e.pointerType === 'mouse') return;
    if (swiper.animating && params.preventInteractionOnTransition) return;
    if (!swiper.animating && params.cssMode && params.loop) swiper.loopFix();
    let targetEl = e.target;
    if (params.touchEventsTarget === 'wrapper') {
        if (!(0, $f97f33853a605dba$export$efccba1c4a2ef57b)(targetEl, swiper.wrapperEl)) return;
    }
    if ('which' in e && e.which === 3) return;
    if ('button' in e && e.button > 0) return;
    if (data.isTouched && data.isMoved) return;
    // change target el for shadow root component
    const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== '';
    // eslint-disable-next-line
    const eventPath = e.composedPath ? e.composedPath() : e.path;
    if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) targetEl = eventPath[0];
    const noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`;
    const isTargetShadow = !!(e.target && e.target.shadowRoot);
    // use closestElement for shadow root element to get the actual closest for nested shadow root element
    if (params.noSwiping && (isTargetShadow ? $1262f2e38e280703$var$closestElement(noSwipingSelector, targetEl) : targetEl.closest(noSwipingSelector))) {
        swiper.allowClick = true;
        return;
    }
    if (params.swipeHandler) {
        if (!targetEl.closest(params.swipeHandler)) return;
    }
    touches.currentX = e.pageX;
    touches.currentY = e.pageY;
    const startX = touches.currentX;
    const startY = touches.currentY;
    // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore
    if (!$1262f2e38e280703$var$preventEdgeSwipe(swiper, e, startX)) return;
    Object.assign(data, {
        isTouched: true,
        isMoved: false,
        allowTouchCallbacks: true,
        isScrolling: undefined,
        startMoving: undefined
    });
    touches.startX = startX;
    touches.startY = startY;
    data.touchStartTime = (0, $f97f33853a605dba$export$2d1720544b23b823)();
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = undefined;
    if (params.threshold > 0) data.allowThresholdMove = false;
    let preventDefault = true;
    if (targetEl.matches(data.focusableElements)) {
        preventDefault = false;
        if (targetEl.nodeName === 'SELECT') data.isTouched = false;
    }
    if (document1.activeElement && document1.activeElement.matches(data.focusableElements) && document1.activeElement !== targetEl && (e.pointerType === 'mouse' || e.pointerType !== 'mouse' && !targetEl.matches(data.focusableElements))) document1.activeElement.blur();
    const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
    if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !targetEl.isContentEditable) e.preventDefault();
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) swiper.freeMode.onTouchStart();
    swiper.emit('touchStart', e);
}
function $1262f2e38e280703$var$onTouchMove(event) {
    const document1 = (0, $0868fe5596dee114$export$39b482c5e57630a8)();
    const swiper = this;
    const data = swiper.touchEventsData;
    const { params: params, touches: touches, rtlTranslate: rtl, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && event.pointerType === 'mouse') return;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (e.type === 'pointermove') {
        if (data.touchId !== null) return; // return from pointer if we use touch
        const id = e.pointerId;
        if (id !== data.pointerId) return;
    }
    let targetTouch;
    if (e.type === 'touchmove') {
        targetTouch = [
            ...e.changedTouches
        ].find((t)=>t.identifier === data.touchId);
        if (!targetTouch || targetTouch.identifier !== data.touchId) return;
    } else targetTouch = e;
    if (!data.isTouched) {
        if (data.startMoving && data.isScrolling) swiper.emit('touchMoveOpposite', e);
        return;
    }
    const pageX = targetTouch.pageX;
    const pageY = targetTouch.pageY;
    if (e.preventedByNestedSwiper) {
        touches.startX = pageX;
        touches.startY = pageY;
        return;
    }
    if (!swiper.allowTouchMove) {
        if (!e.target.matches(data.focusableElements)) swiper.allowClick = false;
        if (data.isTouched) {
            Object.assign(touches, {
                startX: pageX,
                startY: pageY,
                currentX: pageX,
                currentY: pageY
            });
            data.touchStartTime = (0, $f97f33853a605dba$export$2d1720544b23b823)();
        }
        return;
    }
    if (params.touchReleaseOnEdges && !params.loop) {
        if (swiper.isVertical()) // Vertical
        {
            if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
                data.isTouched = false;
                data.isMoved = false;
                return;
            }
        } else if (rtl && (pageX > touches.startX && -swiper.translate <= swiper.maxTranslate() || pageX < touches.startX && -swiper.translate >= swiper.minTranslate())) return;
        else if (!rtl && (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate())) return;
    }
    if (document1.activeElement && document1.activeElement.matches(data.focusableElements) && document1.activeElement !== e.target && e.pointerType !== 'mouse') document1.activeElement.blur();
    if (document1.activeElement) {
        if (e.target === document1.activeElement && e.target.matches(data.focusableElements)) {
            data.isMoved = true;
            swiper.allowClick = false;
            return;
        }
    }
    if (data.allowTouchCallbacks) swiper.emit('touchMove', e);
    touches.previousX = touches.currentX;
    touches.previousY = touches.currentY;
    touches.currentX = pageX;
    touches.currentY = pageY;
    const diffX = touches.currentX - touches.startX;
    const diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold) return;
    if (typeof data.isScrolling === 'undefined') {
        let touchAngle;
        if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) data.isScrolling = false;
        else // eslint-disable-next-line
        if (diffX * diffX + diffY * diffY >= 25) {
            touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
            data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
        }
    }
    if (data.isScrolling) swiper.emit('touchMoveOpposite', e);
    if (typeof data.startMoving === 'undefined') {
        if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) data.startMoving = true;
    }
    if (data.isScrolling || e.type === 'touchmove' && data.preventTouchMoveFromPointerMove) {
        data.isTouched = false;
        return;
    }
    if (!data.startMoving) return;
    swiper.allowClick = false;
    if (!params.cssMode && e.cancelable) e.preventDefault();
    if (params.touchMoveStopPropagation && !params.nested) e.stopPropagation();
    let diff = swiper.isHorizontal() ? diffX : diffY;
    let touchesDiff = swiper.isHorizontal() ? touches.currentX - touches.previousX : touches.currentY - touches.previousY;
    if (params.oneWayMovement) {
        diff = Math.abs(diff) * (rtl ? 1 : -1);
        touchesDiff = Math.abs(touchesDiff) * (rtl ? 1 : -1);
    }
    touches.diff = diff;
    diff *= params.touchRatio;
    if (rtl) {
        diff = -diff;
        touchesDiff = -touchesDiff;
    }
    const prevTouchesDirection = swiper.touchesDirection;
    swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
    swiper.touchesDirection = touchesDiff > 0 ? 'prev' : 'next';
    const isLoop = swiper.params.loop && !params.cssMode;
    const allowLoopFix = swiper.touchesDirection === 'next' && swiper.allowSlideNext || swiper.touchesDirection === 'prev' && swiper.allowSlidePrev;
    if (!data.isMoved) {
        if (isLoop && allowLoopFix) swiper.loopFix({
            direction: swiper.swipeDirection
        });
        data.startTranslate = swiper.getTranslate();
        swiper.setTransition(0);
        if (swiper.animating) {
            const evt = new window.CustomEvent('transitionend', {
                bubbles: true,
                cancelable: true,
                detail: {
                    bySwiperTouchMove: true
                }
            });
            swiper.wrapperEl.dispatchEvent(evt);
        }
        data.allowMomentumBounce = false;
        // Grab Cursor
        if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(true);
        swiper.emit('sliderFirstMove', e);
    }
    let loopFixed;
    new Date().getTime();
    if (params._loopSwapReset !== false && data.isMoved && data.allowThresholdMove && prevTouchesDirection !== swiper.touchesDirection && isLoop && allowLoopFix && Math.abs(diff) >= 1) {
        Object.assign(touches, {
            startX: pageX,
            startY: pageY,
            currentX: pageX,
            currentY: pageY,
            startTranslate: data.currentTranslate
        });
        data.loopSwapReset = true;
        data.startTranslate = data.currentTranslate;
        return;
    }
    swiper.emit('sliderMove', e);
    data.isMoved = true;
    data.currentTranslate = diff + data.startTranslate;
    let disableParentSwiper = true;
    let resistanceRatio = params.resistanceRatio;
    if (params.touchReleaseOnEdges) resistanceRatio = 0;
    if (diff > 0) {
        if (isLoop && allowLoopFix && !loopFixed && data.allowThresholdMove && data.currentTranslate > (params.centeredSlides ? swiper.minTranslate() - swiper.slidesSizesGrid[swiper.activeIndex + 1] - (params.slidesPerView !== 'auto' && swiper.slides.length - params.slidesPerView >= 2 ? swiper.slidesSizesGrid[swiper.activeIndex + 1] + swiper.params.spaceBetween : 0) - swiper.params.spaceBetween : swiper.minTranslate())) swiper.loopFix({
            direction: 'prev',
            setTranslate: true,
            activeSlideIndex: 0
        });
        if (data.currentTranslate > swiper.minTranslate()) {
            disableParentSwiper = false;
            if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + (-swiper.minTranslate() + data.startTranslate + diff) ** resistanceRatio;
        }
    } else if (diff < 0) {
        if (isLoop && allowLoopFix && !loopFixed && data.allowThresholdMove && data.currentTranslate < (params.centeredSlides ? swiper.maxTranslate() + swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] + swiper.params.spaceBetween + (params.slidesPerView !== 'auto' && swiper.slides.length - params.slidesPerView >= 2 ? swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] + swiper.params.spaceBetween : 0) : swiper.maxTranslate())) swiper.loopFix({
            direction: 'next',
            setTranslate: true,
            activeSlideIndex: swiper.slides.length - (params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : Math.ceil(parseFloat(params.slidesPerView, 10)))
        });
        if (data.currentTranslate < swiper.maxTranslate()) {
            disableParentSwiper = false;
            if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - (swiper.maxTranslate() - data.startTranslate - diff) ** resistanceRatio;
        }
    }
    if (disableParentSwiper) e.preventedByNestedSwiper = true;
    // Directions locks
    if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && !swiper.allowSlideNext) data.currentTranslate = data.startTranslate;
    // Threshold
    if (params.threshold > 0) {
        if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
            if (!data.allowThresholdMove) {
                data.allowThresholdMove = true;
                touches.startX = touches.currentX;
                touches.startY = touches.currentY;
                data.currentTranslate = data.startTranslate;
                touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
                return;
            }
        } else {
            data.currentTranslate = data.startTranslate;
            return;
        }
    }
    if (!params.followFinger || params.cssMode) return;
    // Update active index in free mode
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode) swiper.freeMode.onTouchMove();
    // Update progress
    swiper.updateProgress(data.currentTranslate);
    // Update translate
    swiper.setTranslate(data.currentTranslate);
}
function $1262f2e38e280703$var$onTouchEnd(event) {
    const swiper = this;
    const data = swiper.touchEventsData;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    let targetTouch;
    const isTouchEvent = e.type === 'touchend' || e.type === 'touchcancel';
    if (!isTouchEvent) {
        if (data.touchId !== null) return; // return from pointer if we use touch
        if (e.pointerId !== data.pointerId) return;
        targetTouch = e;
    } else {
        targetTouch = [
            ...e.changedTouches
        ].find((t)=>t.identifier === data.touchId);
        if (!targetTouch || targetTouch.identifier !== data.touchId) return;
    }
    if ([
        'pointercancel',
        'pointerout',
        'pointerleave',
        'contextmenu'
    ].includes(e.type)) {
        const proceed = [
            'pointercancel',
            'contextmenu'
        ].includes(e.type) && (swiper.browser.isSafari || swiper.browser.isWebView);
        if (!proceed) return;
    }
    data.pointerId = null;
    data.touchId = null;
    const { params: params, touches: touches, rtlTranslate: rtl, slidesGrid: slidesGrid, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && e.pointerType === 'mouse') return;
    if (data.allowTouchCallbacks) swiper.emit('touchEnd', e);
    data.allowTouchCallbacks = false;
    if (!data.isTouched) {
        if (data.isMoved && params.grabCursor) swiper.setGrabCursor(false);
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    // Return Grab Cursor
    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(false);
    // Time diff
    const touchEndTime = (0, $f97f33853a605dba$export$2d1720544b23b823)();
    const timeDiff = touchEndTime - data.touchStartTime;
    // Tap, doubleTap, Click
    if (swiper.allowClick) {
        const pathTree = e.path || e.composedPath && e.composedPath();
        swiper.updateClickedSlide(pathTree && pathTree[0] || e.target, pathTree);
        swiper.emit('tap click', e);
        if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) swiper.emit('doubleTap doubleClick', e);
    }
    data.lastClickTime = (0, $f97f33853a605dba$export$2d1720544b23b823)();
    (0, $f97f33853a605dba$export$7ccc53e8f1e7dfc5)(()=>{
        if (!swiper.destroyed) swiper.allowClick = true;
    });
    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 && !data.loopSwapReset || data.currentTranslate === data.startTranslate && !data.loopSwapReset) {
        data.isTouched = false;
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    let currentPos;
    if (params.followFinger) currentPos = rtl ? swiper.translate : -swiper.translate;
    else currentPos = -data.currentTranslate;
    if (params.cssMode) return;
    if (params.freeMode && params.freeMode.enabled) {
        swiper.freeMode.onTouchEnd({
            currentPos: currentPos
        });
        return;
    }
    // Find current slide
    const swipeToLast = currentPos >= -swiper.maxTranslate() && !swiper.params.loop;
    let stopIndex = 0;
    let groupSize = swiper.slidesSizesGrid[0];
    for(let i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup){
        const increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
        if (typeof slidesGrid[i + increment] !== 'undefined') {
            if (swipeToLast || currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment]) {
                stopIndex = i;
                groupSize = slidesGrid[i + increment] - slidesGrid[i];
            }
        } else if (swipeToLast || currentPos >= slidesGrid[i]) {
            stopIndex = i;
            groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
        }
    }
    let rewindFirstIndex = null;
    let rewindLastIndex = null;
    if (params.rewind) {
        if (swiper.isBeginning) rewindLastIndex = params.virtual && params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        else if (swiper.isEnd) rewindFirstIndex = 0;
    }
    // Find current slide size
    const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
    const increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (timeDiff > params.longSwipesMs) {
        // Long touches
        if (!params.longSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (swiper.swipeDirection === 'next') {
            if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);
            else swiper.slideTo(stopIndex);
        }
        if (swiper.swipeDirection === 'prev') {
            if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment);
            else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) swiper.slideTo(rewindLastIndex);
            else swiper.slideTo(stopIndex);
        }
    } else {
        // Short swipes
        if (!params.shortSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        const isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
        if (!isNavButtonTarget) {
            if (swiper.swipeDirection === 'next') swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
            if (swiper.swipeDirection === 'prev') swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
        } else if (e.target === swiper.navigation.nextEl) swiper.slideTo(stopIndex + increment);
        else swiper.slideTo(stopIndex);
    }
}
function $1262f2e38e280703$var$onResize() {
    const swiper = this;
    const { params: params, el: el } = swiper;
    if (el && el.offsetWidth === 0) return;
    // Breakpoints
    if (params.breakpoints) swiper.setBreakpoint();
    // Save locks
    const { allowSlideNext: allowSlideNext, allowSlidePrev: allowSlidePrev, snapGrid: snapGrid } = swiper;
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    // Disable locks on resize
    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateSlidesClasses();
    const isVirtualLoop = isVirtual && params.loop;
    if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides && !isVirtualLoop) swiper.slideTo(swiper.slides.length - 1, 0, false, true);
    else if (swiper.params.loop && !isVirtual) swiper.slideToLoop(swiper.realIndex, 0, false, true);
    else swiper.slideTo(swiper.activeIndex, 0, false, true);
    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
        clearTimeout(swiper.autoplay.resizeTimeout);
        swiper.autoplay.resizeTimeout = setTimeout(()=>{
            if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) swiper.autoplay.resume();
        }, 500);
    }
    // Return locks after resize
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
}
function $1262f2e38e280703$var$onClick(e) {
    const swiper = this;
    if (!swiper.enabled) return;
    if (!swiper.allowClick) {
        if (swiper.params.preventClicks) e.preventDefault();
        if (swiper.params.preventClicksPropagation && swiper.animating) {
            e.stopPropagation();
            e.stopImmediatePropagation();
        }
    }
}
function $1262f2e38e280703$var$onScroll() {
    const swiper = this;
    const { wrapperEl: wrapperEl, rtlTranslate: rtlTranslate, enabled: enabled } = swiper;
    if (!enabled) return;
    swiper.previousTranslate = swiper.translate;
    if (swiper.isHorizontal()) swiper.translate = -wrapperEl.scrollLeft;
    else swiper.translate = -wrapperEl.scrollTop;
    // eslint-disable-next-line
    if (swiper.translate === 0) swiper.translate = 0;
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== swiper.progress) swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
    swiper.emit('setTranslate', swiper.translate, false);
}
function $1262f2e38e280703$var$onLoad(e) {
    const swiper = this;
    $1262f2e38e280703$var$processLazyPreloader(swiper, e.target);
    if (swiper.params.cssMode || swiper.params.slidesPerView !== 'auto' && !swiper.params.autoHeight) return;
    swiper.update();
}
function $1262f2e38e280703$var$onDocumentTouchStart() {
    const swiper = this;
    if (swiper.documentTouchHandlerProceeded) return;
    swiper.documentTouchHandlerProceeded = true;
    if (swiper.params.touchReleaseOnEdges) swiper.el.style.touchAction = 'auto';
}
const $1262f2e38e280703$var$events = (swiper, method)=>{
    const document1 = (0, $0868fe5596dee114$export$39b482c5e57630a8)();
    const { params: params, el: el, wrapperEl: wrapperEl, device: device } = swiper;
    const capture = !!params.nested;
    const domMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
    const swiperMethod = method;
    if (!el || typeof el === 'string') return;
    // Touch Events
    document1[domMethod]('touchstart', swiper.onDocumentTouchStart, {
        passive: false,
        capture: capture
    });
    el[domMethod]('touchstart', swiper.onTouchStart, {
        passive: false
    });
    el[domMethod]('pointerdown', swiper.onTouchStart, {
        passive: false
    });
    document1[domMethod]('touchmove', swiper.onTouchMove, {
        passive: false,
        capture: capture
    });
    document1[domMethod]('pointermove', swiper.onTouchMove, {
        passive: false,
        capture: capture
    });
    document1[domMethod]('touchend', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('pointerup', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('pointercancel', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('touchcancel', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('pointerout', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('pointerleave', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('contextmenu', swiper.onTouchEnd, {
        passive: true
    });
    // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) el[domMethod]('click', swiper.onClick, true);
    if (params.cssMode) wrapperEl[domMethod]('scroll', swiper.onScroll);
    // Resize handler
    if (params.updateOnWindowResize) swiper[swiperMethod](device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', $1262f2e38e280703$var$onResize, true);
    else swiper[swiperMethod]('observerUpdate', $1262f2e38e280703$var$onResize, true);
    // Images loader
    el[domMethod]('load', swiper.onLoad, {
        capture: true
    });
};
function $1262f2e38e280703$var$attachEvents() {
    const swiper = this;
    const { params: params } = swiper;
    swiper.onTouchStart = $1262f2e38e280703$var$onTouchStart.bind(swiper);
    swiper.onTouchMove = $1262f2e38e280703$var$onTouchMove.bind(swiper);
    swiper.onTouchEnd = $1262f2e38e280703$var$onTouchEnd.bind(swiper);
    swiper.onDocumentTouchStart = $1262f2e38e280703$var$onDocumentTouchStart.bind(swiper);
    if (params.cssMode) swiper.onScroll = $1262f2e38e280703$var$onScroll.bind(swiper);
    swiper.onClick = $1262f2e38e280703$var$onClick.bind(swiper);
    swiper.onLoad = $1262f2e38e280703$var$onLoad.bind(swiper);
    $1262f2e38e280703$var$events(swiper, 'on');
}
function $1262f2e38e280703$var$detachEvents() {
    const swiper = this;
    $1262f2e38e280703$var$events(swiper, 'off');
}
var $1262f2e38e280703$var$events$1 = {
    attachEvents: $1262f2e38e280703$var$attachEvents,
    detachEvents: $1262f2e38e280703$var$detachEvents
};
const $1262f2e38e280703$var$isGridEnabled = (swiper, params)=>{
    return swiper.grid && params.grid && params.grid.rows > 1;
};
function $1262f2e38e280703$var$setBreakpoint() {
    const swiper = this;
    const { realIndex: realIndex, initialized: initialized, params: params, el: el } = swiper;
    const breakpoints = params.breakpoints;
    if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return;
    const document1 = (0, $0868fe5596dee114$export$39b482c5e57630a8)();
    // Get breakpoint for window/container width and update parameters
    const breakpointsBase = params.breakpointsBase === 'window' || !params.breakpointsBase ? params.breakpointsBase : 'container';
    const breakpointContainer = [
        'window',
        'container'
    ].includes(params.breakpointsBase) || !params.breakpointsBase ? swiper.el : document1.querySelector(params.breakpointsBase);
    const breakpoint = swiper.getBreakpoint(breakpoints, breakpointsBase, breakpointContainer);
    if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
    const breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
    const breakpointParams = breakpointOnlyParams || swiper.originalParams;
    const wasMultiRow = $1262f2e38e280703$var$isGridEnabled(swiper, params);
    const isMultiRow = $1262f2e38e280703$var$isGridEnabled(swiper, breakpointParams);
    const wasGrabCursor = swiper.params.grabCursor;
    const isGrabCursor = breakpointParams.grabCursor;
    const wasEnabled = params.enabled;
    if (wasMultiRow && !isMultiRow) {
        el.classList.remove(`${params.containerModifierClass}grid`, `${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    } else if (!wasMultiRow && isMultiRow) {
        el.classList.add(`${params.containerModifierClass}grid`);
        if (breakpointParams.grid.fill && breakpointParams.grid.fill === 'column' || !breakpointParams.grid.fill && params.grid.fill === 'column') el.classList.add(`${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    }
    if (wasGrabCursor && !isGrabCursor) swiper.unsetGrabCursor();
    else if (!wasGrabCursor && isGrabCursor) swiper.setGrabCursor();
    // Toggle navigation, pagination, scrollbar
    [
        'navigation',
        'pagination',
        'scrollbar'
    ].forEach((prop)=>{
        if (typeof breakpointParams[prop] === 'undefined') return;
        const wasModuleEnabled = params[prop] && params[prop].enabled;
        const isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;
        if (wasModuleEnabled && !isModuleEnabled) swiper[prop].disable();
        if (!wasModuleEnabled && isModuleEnabled) swiper[prop].enable();
    });
    const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
    const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
    const wasLoop = params.loop;
    if (directionChanged && initialized) swiper.changeDirection();
    (0, $f97f33853a605dba$export$d141bba7fdc215a3)(swiper.params, breakpointParams);
    const isEnabled = swiper.params.enabled;
    const hasLoop = swiper.params.loop;
    Object.assign(swiper, {
        allowTouchMove: swiper.params.allowTouchMove,
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev
    });
    if (wasEnabled && !isEnabled) swiper.disable();
    else if (!wasEnabled && isEnabled) swiper.enable();
    swiper.currentBreakpoint = breakpoint;
    swiper.emit('_beforeBreakpoint', breakpointParams);
    if (initialized) {
        if (needsReLoop) {
            swiper.loopDestroy();
            swiper.loopCreate(realIndex);
            swiper.updateSlides();
        } else if (!wasLoop && hasLoop) {
            swiper.loopCreate(realIndex);
            swiper.updateSlides();
        } else if (wasLoop && !hasLoop) swiper.loopDestroy();
    }
    swiper.emit('breakpoint', breakpointParams);
}
function $1262f2e38e280703$var$getBreakpoint(breakpoints, base, containerEl) {
    if (base === void 0) base = 'window';
    if (!breakpoints || base === 'container' && !containerEl) return undefined;
    let breakpoint = false;
    const window1 = (0, $0868fe5596dee114$export$407448d2b89b1813)();
    const currentHeight = base === 'window' ? window1.innerHeight : containerEl.clientHeight;
    const points = Object.keys(breakpoints).map((point)=>{
        if (typeof point === 'string' && point.indexOf('@') === 0) {
            const minRatio = parseFloat(point.substr(1));
            const value = currentHeight * minRatio;
            return {
                value: value,
                point: point
            };
        }
        return {
            value: point,
            point: point
        };
    });
    points.sort((a, b)=>parseInt(a.value, 10) - parseInt(b.value, 10));
    for(let i = 0; i < points.length; i += 1){
        const { point: point, value: value } = points[i];
        if (base === 'window') {
            if (window1.matchMedia(`(min-width: ${value}px)`).matches) breakpoint = point;
        } else if (value <= containerEl.clientWidth) breakpoint = point;
    }
    return breakpoint || 'max';
}
var $1262f2e38e280703$var$breakpoints = {
    setBreakpoint: $1262f2e38e280703$var$setBreakpoint,
    getBreakpoint: $1262f2e38e280703$var$getBreakpoint
};
function $1262f2e38e280703$var$prepareClasses(entries, prefix) {
    const resultClasses = [];
    entries.forEach((item)=>{
        if (typeof item === 'object') Object.keys(item).forEach((classNames)=>{
            if (item[classNames]) resultClasses.push(prefix + classNames);
        });
        else if (typeof item === 'string') resultClasses.push(prefix + item);
    });
    return resultClasses;
}
function $1262f2e38e280703$var$addClasses() {
    const swiper = this;
    const { classNames: classNames, params: params, rtl: rtl, el: el, device: device } = swiper;
    // prettier-ignore
    const suffixes = $1262f2e38e280703$var$prepareClasses([
        'initialized',
        params.direction,
        {
            'free-mode': swiper.params.freeMode && params.freeMode.enabled
        },
        {
            'autoheight': params.autoHeight
        },
        {
            'rtl': rtl
        },
        {
            'grid': params.grid && params.grid.rows > 1
        },
        {
            'grid-column': params.grid && params.grid.rows > 1 && params.grid.fill === 'column'
        },
        {
            'android': device.android
        },
        {
            'ios': device.ios
        },
        {
            'css-mode': params.cssMode
        },
        {
            'centered': params.cssMode && params.centeredSlides
        },
        {
            'watch-progress': params.watchSlidesProgress
        }
    ], params.containerModifierClass);
    classNames.push(...suffixes);
    el.classList.add(...classNames);
    swiper.emitContainerClasses();
}
function $1262f2e38e280703$var$removeClasses() {
    const swiper = this;
    const { el: el, classNames: classNames } = swiper;
    if (!el || typeof el === 'string') return;
    el.classList.remove(...classNames);
    swiper.emitContainerClasses();
}
var $1262f2e38e280703$var$classes = {
    addClasses: $1262f2e38e280703$var$addClasses,
    removeClasses: $1262f2e38e280703$var$removeClasses
};
function $1262f2e38e280703$var$checkOverflow() {
    const swiper = this;
    const { isLocked: wasLocked, params: params } = swiper;
    const { slidesOffsetBefore: slidesOffsetBefore } = params;
    if (slidesOffsetBefore) {
        const lastSlideIndex = swiper.slides.length - 1;
        const lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
        swiper.isLocked = swiper.size > lastSlideRightEdge;
    } else swiper.isLocked = swiper.snapGrid.length === 1;
    if (params.allowSlideNext === true) swiper.allowSlideNext = !swiper.isLocked;
    if (params.allowSlidePrev === true) swiper.allowSlidePrev = !swiper.isLocked;
    if (wasLocked && wasLocked !== swiper.isLocked) swiper.isEnd = false;
    if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? 'lock' : 'unlock');
}
var $1262f2e38e280703$var$checkOverflow$1 = {
    checkOverflow: $1262f2e38e280703$var$checkOverflow
};
var $1262f2e38e280703$export$4368d992c4eafac0 = {
    init: true,
    direction: 'horizontal',
    oneWayMovement: false,
    swiperElementNodeName: 'SWIPER-CONTAINER',
    touchEventsTarget: 'wrapper',
    initialSlide: 0,
    speed: 300,
    cssMode: false,
    updateOnWindowResize: true,
    resizeObserver: true,
    nested: false,
    createElements: false,
    eventsPrefix: 'swiper',
    enabled: true,
    focusableElements: 'input, select, option, textarea, button, video, label',
    // Overrides
    width: null,
    height: null,
    //
    preventInteractionOnTransition: false,
    // ssr
    userAgent: null,
    url: null,
    // To support iOS's swipe-to-go-back gesture (when being used in-app).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,
    // Autoheight
    autoHeight: false,
    // Set wrapper width
    setWrapperSize: false,
    // Virtual Translate
    virtualTranslate: false,
    // Effects
    effect: 'slide',
    // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
    // Breakpoints
    breakpoints: undefined,
    breakpointsBase: 'window',
    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: false,
    centeredSlides: false,
    centeredSlidesBounds: false,
    slidesOffsetBefore: 0,
    // in px
    slidesOffsetAfter: 0,
    // in px
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,
    // Disable swiper and hide navigation when container not overflow
    watchOverflow: true,
    // Round length
    roundLengths: false,
    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 5,
    touchMoveStopPropagation: false,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,
    // Unique Navigation Elements
    uniqueNavElements: true,
    // Resistance
    resistance: true,
    resistanceRatio: 0.85,
    // Progress
    watchSlidesProgress: false,
    // Cursor
    grabCursor: false,
    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,
    // loop
    loop: false,
    loopAddBlankSlides: true,
    loopAdditionalSlides: 0,
    loopPreventsSliding: true,
    // rewind
    rewind: false,
    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null,
    // '.swipe-handler',
    noSwiping: true,
    noSwipingClass: 'swiper-no-swiping',
    noSwipingSelector: null,
    // Passive Listeners
    passiveListeners: true,
    maxBackfaceHiddenSlides: 10,
    // NS
    containerModifierClass: 'swiper-',
    // NEW
    slideClass: 'swiper-slide',
    slideBlankClass: 'swiper-slide-blank',
    slideActiveClass: 'swiper-slide-active',
    slideVisibleClass: 'swiper-slide-visible',
    slideFullyVisibleClass: 'swiper-slide-fully-visible',
    slideNextClass: 'swiper-slide-next',
    slidePrevClass: 'swiper-slide-prev',
    wrapperClass: 'swiper-wrapper',
    lazyPreloaderClass: 'swiper-lazy-preloader',
    lazyPreloadPrevNext: 0,
    // Callbacks
    runCallbacksOnInit: true,
    // Internals
    _emitClasses: false
};
function $1262f2e38e280703$var$moduleExtendParams(params, allModulesParams) {
    return function extendParams(obj) {
        if (obj === void 0) obj = {};
        const moduleParamName = Object.keys(obj)[0];
        const moduleParams = obj[moduleParamName];
        if (typeof moduleParams !== 'object' || moduleParams === null) {
            (0, $f97f33853a605dba$export$d141bba7fdc215a3)(allModulesParams, obj);
            return;
        }
        if (params[moduleParamName] === true) params[moduleParamName] = {
            enabled: true
        };
        if (moduleParamName === 'navigation' && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].prevEl && !params[moduleParamName].nextEl) params[moduleParamName].auto = true;
        if ([
            'pagination',
            'scrollbar'
        ].indexOf(moduleParamName) >= 0 && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].el) params[moduleParamName].auto = true;
        if (!(moduleParamName in params && 'enabled' in moduleParams)) {
            (0, $f97f33853a605dba$export$d141bba7fdc215a3)(allModulesParams, obj);
            return;
        }
        if (typeof params[moduleParamName] === 'object' && !('enabled' in params[moduleParamName])) params[moduleParamName].enabled = true;
        if (!params[moduleParamName]) params[moduleParamName] = {
            enabled: false
        };
        (0, $f97f33853a605dba$export$d141bba7fdc215a3)(allModulesParams, obj);
    };
}
/* eslint no-param-reassign: "off" */ const $1262f2e38e280703$var$prototypes = {
    eventsEmitter: $1262f2e38e280703$var$eventsEmitter,
    update: $1262f2e38e280703$var$update,
    translate: $1262f2e38e280703$var$translate,
    transition: $1262f2e38e280703$var$transition,
    slide: $1262f2e38e280703$var$slide,
    loop: $1262f2e38e280703$var$loop,
    grabCursor: $1262f2e38e280703$var$grabCursor,
    events: $1262f2e38e280703$var$events$1,
    breakpoints: $1262f2e38e280703$var$breakpoints,
    checkOverflow: $1262f2e38e280703$var$checkOverflow$1,
    classes: $1262f2e38e280703$var$classes
};
const $1262f2e38e280703$var$extendedDefaults = {};
class $1262f2e38e280703$export$25ce5a424b770e84 {
    constructor(){
        let el;
        let params;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === 'Object') params = args[0];
        else [el, params] = args;
        if (!params) params = {};
        params = (0, $f97f33853a605dba$export$d141bba7fdc215a3)({}, params);
        if (el && !params.el) params.el = el;
        const document1 = (0, $0868fe5596dee114$export$39b482c5e57630a8)();
        if (params.el && typeof params.el === 'string' && document1.querySelectorAll(params.el).length > 1) {
            const swipers = [];
            document1.querySelectorAll(params.el).forEach((containerEl)=>{
                const newParams = (0, $f97f33853a605dba$export$d141bba7fdc215a3)({}, params, {
                    el: containerEl
                });
                swipers.push(new $1262f2e38e280703$export$25ce5a424b770e84(newParams));
            });
            // eslint-disable-next-line no-constructor-return
            return swipers;
        }
        // Swiper Instance
        const swiper = this;
        swiper.__swiper__ = true;
        swiper.support = $1262f2e38e280703$var$getSupport();
        swiper.device = $1262f2e38e280703$var$getDevice({
            userAgent: params.userAgent
        });
        swiper.browser = $1262f2e38e280703$var$getBrowser();
        swiper.eventsListeners = {};
        swiper.eventsAnyListeners = [];
        swiper.modules = [
            ...swiper.__modules__
        ];
        if (params.modules && Array.isArray(params.modules)) swiper.modules.push(...params.modules);
        const allModulesParams = {};
        swiper.modules.forEach((mod)=>{
            mod({
                params: params,
                swiper: swiper,
                extendParams: $1262f2e38e280703$var$moduleExtendParams(params, allModulesParams),
                on: swiper.on.bind(swiper),
                once: swiper.once.bind(swiper),
                off: swiper.off.bind(swiper),
                emit: swiper.emit.bind(swiper)
            });
        });
        // Extend defaults with modules params
        const swiperParams = (0, $f97f33853a605dba$export$d141bba7fdc215a3)({}, $1262f2e38e280703$export$4368d992c4eafac0, allModulesParams);
        // Extend defaults with passed params
        swiper.params = (0, $f97f33853a605dba$export$d141bba7fdc215a3)({}, swiperParams, $1262f2e38e280703$var$extendedDefaults, params);
        swiper.originalParams = (0, $f97f33853a605dba$export$d141bba7fdc215a3)({}, swiper.params);
        swiper.passedParams = (0, $f97f33853a605dba$export$d141bba7fdc215a3)({}, params);
        // add event listeners
        if (swiper.params && swiper.params.on) Object.keys(swiper.params.on).forEach((eventName)=>{
            swiper.on(eventName, swiper.params.on[eventName]);
        });
        if (swiper.params && swiper.params.onAny) swiper.onAny(swiper.params.onAny);
        // Extend Swiper
        Object.assign(swiper, {
            enabled: swiper.params.enabled,
            el: el,
            // Classes
            classNames: [],
            // Slides
            slides: [],
            slidesGrid: [],
            snapGrid: [],
            slidesSizesGrid: [],
            // isDirection
            isHorizontal () {
                return swiper.params.direction === 'horizontal';
            },
            isVertical () {
                return swiper.params.direction === 'vertical';
            },
            // Indexes
            activeIndex: 0,
            realIndex: 0,
            //
            isBeginning: true,
            isEnd: false,
            // Props
            translate: 0,
            previousTranslate: 0,
            progress: 0,
            velocity: 0,
            animating: false,
            cssOverflowAdjustment () {
                // Returns 0 unless `translate` is > 2**23
                // Should be subtracted from css values to prevent overflow
                return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
            },
            // Locks
            allowSlideNext: swiper.params.allowSlideNext,
            allowSlidePrev: swiper.params.allowSlidePrev,
            // Touch Events
            touchEventsData: {
                isTouched: undefined,
                isMoved: undefined,
                allowTouchCallbacks: undefined,
                touchStartTime: undefined,
                isScrolling: undefined,
                currentTranslate: undefined,
                startTranslate: undefined,
                allowThresholdMove: undefined,
                // Form elements to match
                focusableElements: swiper.params.focusableElements,
                // Last click time
                lastClickTime: 0,
                clickTimeout: undefined,
                // Velocities
                velocities: [],
                allowMomentumBounce: undefined,
                startMoving: undefined,
                pointerId: null,
                touchId: null
            },
            // Clicks
            allowClick: true,
            // Touches
            allowTouchMove: swiper.params.allowTouchMove,
            touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0
            },
            // Images
            imagesToLoad: [],
            imagesLoaded: 0
        });
        swiper.emit('_swiper');
        // Init
        if (swiper.params.init) swiper.init();
        // Return app instance
        // eslint-disable-next-line no-constructor-return
        return swiper;
    }
    getDirectionLabel(property) {
        if (this.isHorizontal()) return property;
        // prettier-ignore
        return ({
            'width': 'height',
            'margin-top': 'margin-left',
            'margin-bottom ': 'margin-right',
            'margin-left': 'margin-top',
            'margin-right': 'margin-bottom',
            'padding-left': 'padding-top',
            'padding-right': 'padding-bottom',
            'marginRight': 'marginBottom'
        })[property];
    }
    getSlideIndex(slideEl) {
        const { slidesEl: slidesEl, params: params } = this;
        const slides = (0, $f97f33853a605dba$export$f1e1789686576879)(slidesEl, `.${params.slideClass}, swiper-slide`);
        const firstSlideIndex = (0, $f97f33853a605dba$export$23f2a1d2818174ef)(slides[0]);
        return (0, $f97f33853a605dba$export$23f2a1d2818174ef)(slideEl) - firstSlideIndex;
    }
    getSlideIndexByData(index) {
        return this.getSlideIndex(this.slides.find((slideEl)=>slideEl.getAttribute('data-swiper-slide-index') * 1 === index));
    }
    getSlideIndexWhenGrid(index) {
        if (this.grid && this.params.grid && this.params.grid.rows > 1) {
            if (this.params.grid.fill === 'column') index = Math.floor(index / this.params.grid.rows);
            else if (this.params.grid.fill === 'row') index = index % Math.ceil(this.slides.length / this.params.grid.rows);
        }
        return index;
    }
    recalcSlides() {
        const swiper = this;
        const { slidesEl: slidesEl, params: params } = swiper;
        swiper.slides = (0, $f97f33853a605dba$export$f1e1789686576879)(slidesEl, `.${params.slideClass}, swiper-slide`);
    }
    enable() {
        const swiper = this;
        if (swiper.enabled) return;
        swiper.enabled = true;
        if (swiper.params.grabCursor) swiper.setGrabCursor();
        swiper.emit('enable');
    }
    disable() {
        const swiper = this;
        if (!swiper.enabled) return;
        swiper.enabled = false;
        if (swiper.params.grabCursor) swiper.unsetGrabCursor();
        swiper.emit('disable');
    }
    setProgress(progress, speed) {
        const swiper = this;
        progress = Math.min(Math.max(progress, 0), 1);
        const min = swiper.minTranslate();
        const max = swiper.maxTranslate();
        const current = (max - min) * progress + min;
        swiper.translateTo(current, typeof speed === 'undefined' ? 0 : speed);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    emitContainerClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const cls = swiper.el.className.split(' ').filter((className)=>{
            return className.indexOf('swiper') === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
        });
        swiper.emit('_containerClasses', cls.join(' '));
    }
    getSlideClasses(slideEl) {
        const swiper = this;
        if (swiper.destroyed) return '';
        return slideEl.className.split(' ').filter((className)=>{
            return className.indexOf('swiper-slide') === 0 || className.indexOf(swiper.params.slideClass) === 0;
        }).join(' ');
    }
    emitSlidesClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const updates = [];
        swiper.slides.forEach((slideEl)=>{
            const classNames = swiper.getSlideClasses(slideEl);
            updates.push({
                slideEl: slideEl,
                classNames: classNames
            });
            swiper.emit('_slideClass', slideEl, classNames);
        });
        swiper.emit('_slideClasses', updates);
    }
    slidesPerViewDynamic(view, exact) {
        if (view === void 0) view = 'current';
        if (exact === void 0) exact = false;
        const swiper = this;
        const { params: params, slides: slides, slidesGrid: slidesGrid, slidesSizesGrid: slidesSizesGrid, size: swiperSize, activeIndex: activeIndex } = swiper;
        let spv = 1;
        if (typeof params.slidesPerView === 'number') return params.slidesPerView;
        if (params.centeredSlides) {
            let slideSize = slides[activeIndex] ? Math.ceil(slides[activeIndex].swiperSlideSize) : 0;
            let breakLoop;
            for(let i = activeIndex + 1; i < slides.length; i += 1)if (slides[i] && !breakLoop) {
                slideSize += Math.ceil(slides[i].swiperSlideSize);
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
            for(let i = activeIndex - 1; i >= 0; i -= 1)if (slides[i] && !breakLoop) {
                slideSize += slides[i].swiperSlideSize;
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
        } else {
            // eslint-disable-next-line
            if (view === 'current') for(let i = activeIndex + 1; i < slides.length; i += 1){
                const slideInView = exact ? slidesGrid[i] + slidesSizesGrid[i] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i] - slidesGrid[activeIndex] < swiperSize;
                if (slideInView) spv += 1;
            }
            else // previous
            for(let i = activeIndex - 1; i >= 0; i -= 1){
                const slideInView = slidesGrid[activeIndex] - slidesGrid[i] < swiperSize;
                if (slideInView) spv += 1;
            }
        }
        return spv;
    }
    update() {
        const swiper = this;
        if (!swiper || swiper.destroyed) return;
        const { snapGrid: snapGrid, params: params } = swiper;
        // Breakpoints
        if (params.breakpoints) swiper.setBreakpoint();
        [
            ...swiper.el.querySelectorAll('[loading="lazy"]')
        ].forEach((imageEl)=>{
            if (imageEl.complete) $1262f2e38e280703$var$processLazyPreloader(swiper, imageEl);
        });
        swiper.updateSize();
        swiper.updateSlides();
        swiper.updateProgress();
        swiper.updateSlidesClasses();
        function setTranslate() {
            const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
            const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
            swiper.setTranslate(newTranslate);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
        let translated;
        if (params.freeMode && params.freeMode.enabled && !params.cssMode) {
            setTranslate();
            if (params.autoHeight) swiper.updateAutoHeight();
        } else {
            if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !params.centeredSlides) {
                const slides = swiper.virtual && params.virtual.enabled ? swiper.virtual.slides : swiper.slides;
                translated = swiper.slideTo(slides.length - 1, 0, false, true);
            } else translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
            if (!translated) setTranslate();
        }
        if (params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
        swiper.emit('update');
    }
    changeDirection(newDirection, needUpdate) {
        if (needUpdate === void 0) needUpdate = true;
        const swiper = this;
        const currentDirection = swiper.params.direction;
        if (!newDirection) // eslint-disable-next-line
        newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
        if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') return swiper;
        swiper.el.classList.remove(`${swiper.params.containerModifierClass}${currentDirection}`);
        swiper.el.classList.add(`${swiper.params.containerModifierClass}${newDirection}`);
        swiper.emitContainerClasses();
        swiper.params.direction = newDirection;
        swiper.slides.forEach((slideEl)=>{
            if (newDirection === 'vertical') slideEl.style.width = '';
            else slideEl.style.height = '';
        });
        swiper.emit('changeDirection');
        if (needUpdate) swiper.update();
        return swiper;
    }
    changeLanguageDirection(direction) {
        const swiper = this;
        if (swiper.rtl && direction === 'rtl' || !swiper.rtl && direction === 'ltr') return;
        swiper.rtl = direction === 'rtl';
        swiper.rtlTranslate = swiper.params.direction === 'horizontal' && swiper.rtl;
        if (swiper.rtl) {
            swiper.el.classList.add(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = 'rtl';
        } else {
            swiper.el.classList.remove(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = 'ltr';
        }
        swiper.update();
    }
    mount(element) {
        const swiper = this;
        if (swiper.mounted) return true;
        // Find el
        let el = element || swiper.params.el;
        if (typeof el === 'string') el = document.querySelector(el);
        if (!el) return false;
        el.swiper = swiper;
        if (el.parentNode && el.parentNode.host && el.parentNode.host.nodeName === swiper.params.swiperElementNodeName.toUpperCase()) swiper.isElement = true;
        const getWrapperSelector = ()=>{
            return `.${(swiper.params.wrapperClass || '').trim().split(' ').join('.')}`;
        };
        const getWrapper = ()=>{
            if (el && el.shadowRoot && el.shadowRoot.querySelector) {
                const res = el.shadowRoot.querySelector(getWrapperSelector());
                // Children needs to return slot items
                return res;
            }
            return (0, $f97f33853a605dba$export$f1e1789686576879)(el, getWrapperSelector())[0];
        };
        // Find Wrapper
        let wrapperEl = getWrapper();
        if (!wrapperEl && swiper.params.createElements) {
            wrapperEl = (0, $f97f33853a605dba$export$db3b6bfb95261072)('div', swiper.params.wrapperClass);
            el.append(wrapperEl);
            (0, $f97f33853a605dba$export$f1e1789686576879)(el, `.${swiper.params.slideClass}`).forEach((slideEl)=>{
                wrapperEl.append(slideEl);
            });
        }
        Object.assign(swiper, {
            el: el,
            wrapperEl: wrapperEl,
            slidesEl: swiper.isElement && !el.parentNode.host.slideSlots ? el.parentNode.host : wrapperEl,
            hostEl: swiper.isElement ? el.parentNode.host : el,
            mounted: true,
            // RTL
            rtl: el.dir.toLowerCase() === 'rtl' || (0, $f97f33853a605dba$export$9e5f44173e64f162)(el, 'direction') === 'rtl',
            rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || (0, $f97f33853a605dba$export$9e5f44173e64f162)(el, 'direction') === 'rtl'),
            wrongRTL: (0, $f97f33853a605dba$export$9e5f44173e64f162)(wrapperEl, 'display') === '-webkit-box'
        });
        return true;
    }
    init(el) {
        const swiper = this;
        if (swiper.initialized) return swiper;
        const mounted = swiper.mount(el);
        if (mounted === false) return swiper;
        swiper.emit('beforeInit');
        // Set breakpoint
        if (swiper.params.breakpoints) swiper.setBreakpoint();
        // Add Classes
        swiper.addClasses();
        // Update size
        swiper.updateSize();
        // Update slides
        swiper.updateSlides();
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        // Set Grab Cursor
        if (swiper.params.grabCursor && swiper.enabled) swiper.setGrabCursor();
        // Slide To Initial Slide
        if (swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) swiper.slideTo(swiper.params.initialSlide + swiper.virtual.slidesBefore, 0, swiper.params.runCallbacksOnInit, false, true);
        else swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
        // Create loop
        if (swiper.params.loop) swiper.loopCreate(undefined, true);
        // Attach events
        swiper.attachEvents();
        const lazyElements = [
            ...swiper.el.querySelectorAll('[loading="lazy"]')
        ];
        if (swiper.isElement) lazyElements.push(...swiper.hostEl.querySelectorAll('[loading="lazy"]'));
        lazyElements.forEach((imageEl)=>{
            if (imageEl.complete) $1262f2e38e280703$var$processLazyPreloader(swiper, imageEl);
            else imageEl.addEventListener('load', (e)=>{
                $1262f2e38e280703$var$processLazyPreloader(swiper, e.target);
            });
        });
        $1262f2e38e280703$var$preload(swiper);
        // Init Flag
        swiper.initialized = true;
        $1262f2e38e280703$var$preload(swiper);
        // Emit
        swiper.emit('init');
        swiper.emit('afterInit');
        return swiper;
    }
    destroy(deleteInstance, cleanStyles) {
        if (deleteInstance === void 0) deleteInstance = true;
        if (cleanStyles === void 0) cleanStyles = true;
        const swiper = this;
        const { params: params, el: el, wrapperEl: wrapperEl, slides: slides } = swiper;
        if (typeof swiper.params === 'undefined' || swiper.destroyed) return null;
        swiper.emit('beforeDestroy');
        // Init Flag
        swiper.initialized = false;
        // Detach events
        swiper.detachEvents();
        // Destroy loop
        if (params.loop) swiper.loopDestroy();
        // Cleanup styles
        if (cleanStyles) {
            swiper.removeClasses();
            if (el && typeof el !== 'string') el.removeAttribute('style');
            if (wrapperEl) wrapperEl.removeAttribute('style');
            if (slides && slides.length) slides.forEach((slideEl)=>{
                slideEl.classList.remove(params.slideVisibleClass, params.slideFullyVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass);
                slideEl.removeAttribute('style');
                slideEl.removeAttribute('data-swiper-slide-index');
            });
        }
        swiper.emit('destroy');
        // Detach emitter events
        Object.keys(swiper.eventsListeners).forEach((eventName)=>{
            swiper.off(eventName);
        });
        if (deleteInstance !== false) {
            if (swiper.el && typeof swiper.el !== 'string') swiper.el.swiper = null;
            (0, $f97f33853a605dba$export$4a5767248b18ef41)(swiper);
        }
        swiper.destroyed = true;
        return null;
    }
    static extendDefaults(newDefaults) {
        (0, $f97f33853a605dba$export$d141bba7fdc215a3)($1262f2e38e280703$var$extendedDefaults, newDefaults);
    }
    static get extendedDefaults() {
        return $1262f2e38e280703$var$extendedDefaults;
    }
    static get defaults() {
        return $1262f2e38e280703$export$4368d992c4eafac0;
    }
    static installModule(mod) {
        if (!$1262f2e38e280703$export$25ce5a424b770e84.prototype.__modules__) $1262f2e38e280703$export$25ce5a424b770e84.prototype.__modules__ = [];
        const modules = $1262f2e38e280703$export$25ce5a424b770e84.prototype.__modules__;
        if (typeof mod === 'function' && modules.indexOf(mod) < 0) modules.push(mod);
    }
    static use(module) {
        if (Array.isArray(module)) {
            module.forEach((m)=>$1262f2e38e280703$export$25ce5a424b770e84.installModule(m));
            return $1262f2e38e280703$export$25ce5a424b770e84;
        }
        $1262f2e38e280703$export$25ce5a424b770e84.installModule(module);
        return $1262f2e38e280703$export$25ce5a424b770e84;
    }
}
Object.keys($1262f2e38e280703$var$prototypes).forEach((prototypeGroup)=>{
    Object.keys($1262f2e38e280703$var$prototypes[prototypeGroup]).forEach((protoMethod)=>{
        $1262f2e38e280703$export$25ce5a424b770e84.prototype[protoMethod] = $1262f2e38e280703$var$prototypes[prototypeGroup][protoMethod];
    });
});
$1262f2e38e280703$export$25ce5a424b770e84.use([
    $1262f2e38e280703$var$Resize,
    $1262f2e38e280703$var$Observer
]);






function $91b4fe59f517404d$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    extendParams({
        virtual: {
            enabled: false,
            slides: [],
            cache: true,
            renderSlide: null,
            renderExternal: null,
            renderExternalUpdate: true,
            addSlidesBefore: 0,
            addSlidesAfter: 0
        }
    });
    let cssModeTimeout;
    const document = (0, $0868fe5596dee114$export$39b482c5e57630a8)();
    swiper.virtual = {
        cache: {},
        from: undefined,
        to: undefined,
        slides: [],
        offset: 0,
        slidesGrid: []
    };
    const tempDOM = document.createElement('div');
    function renderSlide(slide, index) {
        const params = swiper.params.virtual;
        if (params.cache && swiper.virtual.cache[index]) return swiper.virtual.cache[index];
        // eslint-disable-next-line
        let slideEl;
        if (params.renderSlide) {
            slideEl = params.renderSlide.call(swiper, slide, index);
            if (typeof slideEl === 'string') {
                (0, $f97f33853a605dba$export$2408f22a0fab9ae5)(tempDOM, slideEl);
                slideEl = tempDOM.children[0];
            }
        } else if (swiper.isElement) slideEl = (0, $f97f33853a605dba$export$db3b6bfb95261072)('swiper-slide');
        else slideEl = (0, $f97f33853a605dba$export$db3b6bfb95261072)('div', swiper.params.slideClass);
        slideEl.setAttribute('data-swiper-slide-index', index);
        if (!params.renderSlide) (0, $f97f33853a605dba$export$2408f22a0fab9ae5)(slideEl, slide);
        if (params.cache) swiper.virtual.cache[index] = slideEl;
        return slideEl;
    }
    function update(force, beforeInit, forceActiveIndex) {
        const { slidesPerView: slidesPerView, slidesPerGroup: slidesPerGroup, centeredSlides: centeredSlides, loop: isLoop, initialSlide: initialSlide } = swiper.params;
        if (beforeInit && !isLoop && initialSlide > 0) return;
        const { addSlidesBefore: addSlidesBefore, addSlidesAfter: addSlidesAfter } = swiper.params.virtual;
        const { from: previousFrom, to: previousTo, slides: slides, slidesGrid: previousSlidesGrid, offset: previousOffset } = swiper.virtual;
        if (!swiper.params.cssMode) swiper.updateActiveIndex();
        const activeIndex = typeof forceActiveIndex === 'undefined' ? swiper.activeIndex || 0 : forceActiveIndex;
        let offsetProp;
        if (swiper.rtlTranslate) offsetProp = 'right';
        else offsetProp = swiper.isHorizontal() ? 'left' : 'top';
        let slidesAfter;
        let slidesBefore;
        if (centeredSlides) {
            slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
            slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
        } else {
            slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesAfter;
            slidesBefore = (isLoop ? slidesPerView : slidesPerGroup) + addSlidesBefore;
        }
        let from = activeIndex - slidesBefore;
        let to = activeIndex + slidesAfter;
        if (!isLoop) {
            from = Math.max(from, 0);
            to = Math.min(to, slides.length - 1);
        }
        let offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
        if (isLoop && activeIndex >= slidesBefore) {
            from -= slidesBefore;
            if (!centeredSlides) offset += swiper.slidesGrid[0];
        } else if (isLoop && activeIndex < slidesBefore) {
            from = -slidesBefore;
            if (centeredSlides) offset += swiper.slidesGrid[0];
        }
        Object.assign(swiper.virtual, {
            from: from,
            to: to,
            offset: offset,
            slidesGrid: swiper.slidesGrid,
            slidesBefore: slidesBefore,
            slidesAfter: slidesAfter
        });
        function onRendered() {
            swiper.updateSlides();
            swiper.updateProgress();
            swiper.updateSlidesClasses();
            emit('virtualUpdate');
        }
        if (previousFrom === from && previousTo === to && !force) {
            if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) swiper.slides.forEach((slideEl)=>{
                slideEl.style[offsetProp] = `${offset - Math.abs(swiper.cssOverflowAdjustment())}px`;
            });
            swiper.updateProgress();
            emit('virtualUpdate');
            return;
        }
        if (swiper.params.virtual.renderExternal) {
            swiper.params.virtual.renderExternal.call(swiper, {
                offset: offset,
                from: from,
                to: to,
                slides: function getSlides() {
                    const slidesToRender = [];
                    for(let i = from; i <= to; i += 1)slidesToRender.push(slides[i]);
                    return slidesToRender;
                }()
            });
            if (swiper.params.virtual.renderExternalUpdate) onRendered();
            else emit('virtualUpdate');
            return;
        }
        const prependIndexes = [];
        const appendIndexes = [];
        const getSlideIndex = (index)=>{
            let slideIndex = index;
            if (index < 0) slideIndex = slides.length + index;
            else if (slideIndex >= slides.length) // eslint-disable-next-line
            slideIndex = slideIndex - slides.length;
            return slideIndex;
        };
        if (force) swiper.slides.filter((el)=>el.matches(`.${swiper.params.slideClass}, swiper-slide`)).forEach((slideEl)=>{
            slideEl.remove();
        });
        else {
            for(let i = previousFrom; i <= previousTo; i += 1)if (i < from || i > to) {
                const slideIndex = getSlideIndex(i);
                swiper.slides.filter((el)=>el.matches(`.${swiper.params.slideClass}[data-swiper-slide-index="${slideIndex}"], swiper-slide[data-swiper-slide-index="${slideIndex}"]`)).forEach((slideEl)=>{
                    slideEl.remove();
                });
            }
        }
        const loopFrom = isLoop ? -slides.length : 0;
        const loopTo = isLoop ? slides.length * 2 : slides.length;
        for(let i = loopFrom; i < loopTo; i += 1)if (i >= from && i <= to) {
            const slideIndex = getSlideIndex(i);
            if (typeof previousTo === 'undefined' || force) appendIndexes.push(slideIndex);
            else {
                if (i > previousTo) appendIndexes.push(slideIndex);
                if (i < previousFrom) prependIndexes.push(slideIndex);
            }
        }
        appendIndexes.forEach((index)=>{
            swiper.slidesEl.append(renderSlide(slides[index], index));
        });
        if (isLoop) for(let i = prependIndexes.length - 1; i >= 0; i -= 1){
            const index = prependIndexes[i];
            swiper.slidesEl.prepend(renderSlide(slides[index], index));
        }
        else {
            prependIndexes.sort((a, b)=>b - a);
            prependIndexes.forEach((index)=>{
                swiper.slidesEl.prepend(renderSlide(slides[index], index));
            });
        }
        (0, $f97f33853a605dba$export$f1e1789686576879)(swiper.slidesEl, '.swiper-slide, swiper-slide').forEach((slideEl)=>{
            slideEl.style[offsetProp] = `${offset - Math.abs(swiper.cssOverflowAdjustment())}px`;
        });
        onRendered();
    }
    function appendSlide(slides) {
        if (typeof slides === 'object' && 'length' in slides) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.push(slides[i]);
        } else swiper.virtual.slides.push(slides);
        update(true);
    }
    function prependSlide(slides) {
        const activeIndex = swiper.activeIndex;
        let newActiveIndex = activeIndex + 1;
        let numberOfNewSlides = 1;
        if (Array.isArray(slides)) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
            newActiveIndex = activeIndex + slides.length;
            numberOfNewSlides = slides.length;
        } else swiper.virtual.slides.unshift(slides);
        if (swiper.params.virtual.cache) {
            const cache = swiper.virtual.cache;
            const newCache = {};
            Object.keys(cache).forEach((cachedIndex)=>{
                const cachedEl = cache[cachedIndex];
                const cachedElIndex = cachedEl.getAttribute('data-swiper-slide-index');
                if (cachedElIndex) cachedEl.setAttribute('data-swiper-slide-index', parseInt(cachedElIndex, 10) + numberOfNewSlides);
                newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = cachedEl;
            });
            swiper.virtual.cache = newCache;
        }
        update(true);
        swiper.slideTo(newActiveIndex, 0);
    }
    function removeSlide(slidesIndexes) {
        if (typeof slidesIndexes === 'undefined' || slidesIndexes === null) return;
        let activeIndex = swiper.activeIndex;
        if (Array.isArray(slidesIndexes)) for(let i = slidesIndexes.length - 1; i >= 0; i -= 1){
            if (swiper.params.virtual.cache) {
                delete swiper.virtual.cache[slidesIndexes[i]];
                // shift cache indexes
                Object.keys(swiper.virtual.cache).forEach((key)=>{
                    if (key > slidesIndexes) {
                        swiper.virtual.cache[key - 1] = swiper.virtual.cache[key];
                        swiper.virtual.cache[key - 1].setAttribute('data-swiper-slide-index', key - 1);
                        delete swiper.virtual.cache[key];
                    }
                });
            }
            swiper.virtual.slides.splice(slidesIndexes[i], 1);
            if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        else {
            if (swiper.params.virtual.cache) {
                delete swiper.virtual.cache[slidesIndexes];
                // shift cache indexes
                Object.keys(swiper.virtual.cache).forEach((key)=>{
                    if (key > slidesIndexes) {
                        swiper.virtual.cache[key - 1] = swiper.virtual.cache[key];
                        swiper.virtual.cache[key - 1].setAttribute('data-swiper-slide-index', key - 1);
                        delete swiper.virtual.cache[key];
                    }
                });
            }
            swiper.virtual.slides.splice(slidesIndexes, 1);
            if (slidesIndexes < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        update(true);
        swiper.slideTo(activeIndex, 0);
    }
    function removeAllSlides() {
        swiper.virtual.slides = [];
        if (swiper.params.virtual.cache) swiper.virtual.cache = {};
        update(true);
        swiper.slideTo(0, 0);
    }
    on('beforeInit', ()=>{
        if (!swiper.params.virtual.enabled) return;
        let domSlidesAssigned;
        if (typeof swiper.passedParams.virtual.slides === 'undefined') {
            const slides = [
                ...swiper.slidesEl.children
            ].filter((el)=>el.matches(`.${swiper.params.slideClass}, swiper-slide`));
            if (slides && slides.length) {
                swiper.virtual.slides = [
                    ...slides
                ];
                domSlidesAssigned = true;
                slides.forEach((slideEl, slideIndex)=>{
                    slideEl.setAttribute('data-swiper-slide-index', slideIndex);
                    swiper.virtual.cache[slideIndex] = slideEl;
                    slideEl.remove();
                });
            }
        }
        if (!domSlidesAssigned) swiper.virtual.slides = swiper.params.virtual.slides;
        swiper.classNames.push(`${swiper.params.containerModifierClass}virtual`);
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
        update(false, true);
    });
    on('setTranslate', ()=>{
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode && !swiper._immediateVirtual) {
            clearTimeout(cssModeTimeout);
            cssModeTimeout = setTimeout(()=>{
                update();
            }, 100);
        } else update();
    });
    on('init update resize', ()=>{
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode) (0, $f97f33853a605dba$export$407448d2b89b1813)(swiper.wrapperEl, '--swiper-virtual-size', `${swiper.virtualSize}px`);
    });
    Object.assign(swiper.virtual, {
        appendSlide: appendSlide,
        prependSlide: prependSlide,
        removeSlide: removeSlide,
        removeAllSlides: removeAllSlides,
        update: update
    });
}




/* eslint-disable consistent-return */ function $2a1c43be64e359f8$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const document = (0, $0868fe5596dee114$export$39b482c5e57630a8)();
    const window = (0, $0868fe5596dee114$export$407448d2b89b1813)();
    swiper.keyboard = {
        enabled: false
    };
    extendParams({
        keyboard: {
            enabled: false,
            onlyInViewport: true,
            pageUpDown: true
        }
    });
    function handle(event) {
        if (!swiper.enabled) return;
        const { rtlTranslate: rtl } = swiper;
        let e = event;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        const kc = e.keyCode || e.charCode;
        const pageUpDown = swiper.params.keyboard.pageUpDown;
        const isPageUp = pageUpDown && kc === 33;
        const isPageDown = pageUpDown && kc === 34;
        const isArrowLeft = kc === 37;
        const isArrowRight = kc === 39;
        const isArrowUp = kc === 38;
        const isArrowDown = kc === 40;
        // Directions locks
        if (!swiper.allowSlideNext && (swiper.isHorizontal() && isArrowRight || swiper.isVertical() && isArrowDown || isPageDown)) return false;
        if (!swiper.allowSlidePrev && (swiper.isHorizontal() && isArrowLeft || swiper.isVertical() && isArrowUp || isPageUp)) return false;
        if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) return undefined;
        if (document.activeElement && (document.activeElement.isContentEditable || document.activeElement.nodeName && (document.activeElement.nodeName.toLowerCase() === 'input' || document.activeElement.nodeName.toLowerCase() === 'textarea'))) return undefined;
        if (swiper.params.keyboard.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
            let inView = false;
            // Check that swiper should be inside of visible area of window
            if ((0, $f97f33853a605dba$export$8b22cf2602fb60ce)(swiper.el, `.${swiper.params.slideClass}, swiper-slide`).length > 0 && (0, $f97f33853a605dba$export$8b22cf2602fb60ce)(swiper.el, `.${swiper.params.slideActiveClass}`).length === 0) return undefined;
            const el = swiper.el;
            const swiperWidth = el.clientWidth;
            const swiperHeight = el.clientHeight;
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;
            const swiperOffset = (0, $f97f33853a605dba$export$4368d992c4eafac0)(el);
            if (rtl) swiperOffset.left -= el.scrollLeft;
            const swiperCoord = [
                [
                    swiperOffset.left,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left,
                    swiperOffset.top + swiperHeight
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top + swiperHeight
                ]
            ];
            for(let i = 0; i < swiperCoord.length; i += 1){
                const point = swiperCoord[i];
                if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
                    if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line
                    inView = true;
                }
            }
            if (!inView) return undefined;
        }
        if (swiper.isHorizontal()) {
            if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if ((isPageDown || isArrowRight) && !rtl || (isPageUp || isArrowLeft) && rtl) swiper.slideNext();
            if ((isPageUp || isArrowLeft) && !rtl || (isPageDown || isArrowRight) && rtl) swiper.slidePrev();
        } else {
            if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if (isPageDown || isArrowDown) swiper.slideNext();
            if (isPageUp || isArrowUp) swiper.slidePrev();
        }
        emit('keyPress', kc);
        return undefined;
    }
    function enable() {
        if (swiper.keyboard.enabled) return;
        document.addEventListener('keydown', handle);
        swiper.keyboard.enabled = true;
    }
    function disable() {
        if (!swiper.keyboard.enabled) return;
        document.removeEventListener('keydown', handle);
        swiper.keyboard.enabled = false;
    }
    on('init', ()=>{
        if (swiper.params.keyboard.enabled) enable();
    });
    on('destroy', ()=>{
        if (swiper.keyboard.enabled) disable();
    });
    Object.assign(swiper.keyboard, {
        enable: enable,
        disable: disable
    });
}




/* eslint-disable consistent-return */ function $1e6c01efa040ca9a$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const window = (0, $0868fe5596dee114$export$407448d2b89b1813)();
    extendParams({
        mousewheel: {
            enabled: false,
            releaseOnEdges: false,
            invert: false,
            forceToAxis: false,
            sensitivity: 1,
            eventsTarget: 'container',
            thresholdDelta: null,
            thresholdTime: null,
            noMousewheelClass: 'swiper-no-mousewheel'
        }
    });
    swiper.mousewheel = {
        enabled: false
    };
    let timeout;
    let lastScrollTime = (0, $f97f33853a605dba$export$2d1720544b23b823)();
    let lastEventBeforeSnap;
    const recentWheelEvents = [];
    function normalize(e) {
        // Reasonable defaults
        const PIXEL_STEP = 10;
        const LINE_HEIGHT = 40;
        const PAGE_HEIGHT = 800;
        let sX = 0;
        let sY = 0; // spinX, spinY
        let pX = 0;
        let pY = 0; // pixelX, pixelY
        // Legacy
        if ('detail' in e) sY = e.detail;
        if ('wheelDelta' in e) sY = -e.wheelDelta / 120;
        if ('wheelDeltaY' in e) sY = -e.wheelDeltaY / 120;
        if ('wheelDeltaX' in e) sX = -e.wheelDeltaX / 120;
        // side scrolling on FF with DOMMouseScroll
        if ('axis' in e && e.axis === e.HORIZONTAL_AXIS) {
            sX = sY;
            sY = 0;
        }
        pX = sX * PIXEL_STEP;
        pY = sY * PIXEL_STEP;
        if ('deltaY' in e) pY = e.deltaY;
        if ('deltaX' in e) pX = e.deltaX;
        if (e.shiftKey && !pX) {
            // if user scrolls with shift he wants horizontal scroll
            pX = pY;
            pY = 0;
        }
        if ((pX || pY) && e.deltaMode) {
            if (e.deltaMode === 1) {
                // delta in LINE units
                pX *= LINE_HEIGHT;
                pY *= LINE_HEIGHT;
            } else {
                // delta in PAGE units
                pX *= PAGE_HEIGHT;
                pY *= PAGE_HEIGHT;
            }
        }
        // Fall-back if spin cannot be determined
        if (pX && !sX) sX = pX < 1 ? -1 : 1;
        if (pY && !sY) sY = pY < 1 ? -1 : 1;
        return {
            spinX: sX,
            spinY: sY,
            pixelX: pX,
            pixelY: pY
        };
    }
    function handleMouseEnter() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = true;
    }
    function handleMouseLeave() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = false;
    }
    function animateSlider(newEvent) {
        if (swiper.params.mousewheel.thresholdDelta && newEvent.delta < swiper.params.mousewheel.thresholdDelta) // Prevent if delta of wheel scroll delta is below configured threshold
        return false;
        if (swiper.params.mousewheel.thresholdTime && (0, $f97f33853a605dba$export$2d1720544b23b823)() - lastScrollTime < swiper.params.mousewheel.thresholdTime) // Prevent if time between scrolls is below configured threshold
        return false;
        // If the movement is NOT big enough and
        // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
        //   Don't go any further (avoid insignificant scroll movement).
        if (newEvent.delta >= 6 && (0, $f97f33853a605dba$export$2d1720544b23b823)() - lastScrollTime < 60) // Return false as a default
        return true;
        // If user is scrolling towards the end:
        //   If the slider hasn't hit the latest slide or
        //   if the slider is a loop and
        //   if the slider isn't moving right now:
        //     Go to next slide and
        //     emit a scroll event.
        // Else (the user is scrolling towards the beginning) and
        // if the slider hasn't hit the first slide or
        // if the slider is a loop and
        // if the slider isn't moving right now:
        //   Go to prev slide and
        //   emit a scroll event.
        if (newEvent.direction < 0) {
            if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
                swiper.slideNext();
                emit('scroll', newEvent.raw);
            }
        } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
            swiper.slidePrev();
            emit('scroll', newEvent.raw);
        }
        // If you got here is because an animation has been triggered so store the current time
        lastScrollTime = new window.Date().getTime();
        // Return false as a default
        return false;
    }
    function releaseScroll(newEvent) {
        const params = swiper.params.mousewheel;
        if (newEvent.direction < 0) {
            if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
            return true;
        } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
        return true;
        return false;
    }
    function handle(event1) {
        let e = event1;
        let disableParentSwiper = true;
        if (!swiper.enabled) return;
        // Ignore event if the target or its parents have the swiper-no-mousewheel class
        if (event1.target.closest(`.${swiper.params.mousewheel.noMousewheelClass}`)) return;
        const params = swiper.params.mousewheel;
        if (swiper.params.cssMode) e.preventDefault();
        let targetEl = swiper.el;
        if (swiper.params.mousewheel.eventsTarget !== 'container') targetEl = document.querySelector(swiper.params.mousewheel.eventsTarget);
        const targetElContainsTarget = targetEl && targetEl.contains(e.target);
        if (!swiper.mouseEntered && !targetElContainsTarget && !params.releaseOnEdges) return true;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        let delta = 0;
        const rtlFactor = swiper.rtlTranslate ? -1 : 1;
        const data = normalize(e);
        if (params.forceToAxis) {
            if (swiper.isHorizontal()) {
                if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;
                else return true;
            } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;
            else return true;
        } else delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
        if (delta === 0) return true;
        if (params.invert) delta = -delta;
        // Get the scroll positions
        let positions = swiper.getTranslate() + delta * params.sensitivity;
        if (positions >= swiper.minTranslate()) positions = swiper.minTranslate();
        if (positions <= swiper.maxTranslate()) positions = swiper.maxTranslate();
        // When loop is true:
        //     the disableParentSwiper will be true.
        // When loop is false:
        //     if the scroll positions is not on edge,
        //     then the disableParentSwiper will be true.
        //     if the scroll on edge positions,
        //     then the disableParentSwiper will be false.
        disableParentSwiper = swiper.params.loop ? true : !(positions === swiper.minTranslate() || positions === swiper.maxTranslate());
        if (disableParentSwiper && swiper.params.nested) e.stopPropagation();
        if (!swiper.params.freeMode || !swiper.params.freeMode.enabled) {
            // Register the new event in a variable which stores the relevant data
            const newEvent = {
                time: (0, $f97f33853a605dba$export$2d1720544b23b823)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta),
                raw: event1
            };
            // Keep the most recent events
            if (recentWheelEvents.length >= 2) recentWheelEvents.shift(); // only store the last N events
            const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
            recentWheelEvents.push(newEvent);
            // If there is at least one previous recorded event:
            //   If direction has changed or
            //   if the scroll is quicker than the previous one:
            //     Animate the slider.
            // Else (this is the first time the wheel is moved):
            //     Animate the slider.
            if (prevEvent) {
                if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) animateSlider(newEvent);
            } else animateSlider(newEvent);
            // If it's time to release the scroll:
            //   Return now so you don't hit the preventDefault.
            if (releaseScroll(newEvent)) return true;
        } else {
            // Freemode or scrollContainer:
            // If we recently snapped after a momentum scroll, then ignore wheel events
            // to give time for the deceleration to finish. Stop ignoring after 500 msecs
            // or if it's a new scroll (larger delta or inverse sign as last event before
            // an end-of-momentum snap).
            const newEvent = {
                time: (0, $f97f33853a605dba$export$2d1720544b23b823)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta)
            };
            const ignoreWheelEvents = lastEventBeforeSnap && newEvent.time < lastEventBeforeSnap.time + 500 && newEvent.delta <= lastEventBeforeSnap.delta && newEvent.direction === lastEventBeforeSnap.direction;
            if (!ignoreWheelEvents) {
                lastEventBeforeSnap = undefined;
                let position = swiper.getTranslate() + delta * params.sensitivity;
                const wasBeginning = swiper.isBeginning;
                const wasEnd = swiper.isEnd;
                if (position >= swiper.minTranslate()) position = swiper.minTranslate();
                if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
                swiper.setTransition(0);
                swiper.setTranslate(position);
                swiper.updateProgress();
                swiper.updateActiveIndex();
                swiper.updateSlidesClasses();
                if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) swiper.updateSlidesClasses();
                if (swiper.params.loop) swiper.loopFix({
                    direction: newEvent.direction < 0 ? 'next' : 'prev',
                    byMousewheel: true
                });
                if (swiper.params.freeMode.sticky) {
                    // When wheel scrolling starts with sticky (aka snap) enabled, then detect
                    // the end of a momentum scroll by storing recent (N=15?) wheel events.
                    // 1. do all N events have decreasing or same (absolute value) delta?
                    // 2. did all N events arrive in the last M (M=500?) msecs?
                    // 3. does the earliest event have an (absolute value) delta that's
                    //    at least P (P=1?) larger than the most recent event's delta?
                    // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
                    // If 1-4 are "yes" then we're near the end of a momentum scroll deceleration.
                    // Snap immediately and ignore remaining wheel events in this scroll.
                    // See comment above for "remaining wheel events in this scroll" determination.
                    // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
                    clearTimeout(timeout);
                    timeout = undefined;
                    if (recentWheelEvents.length >= 15) recentWheelEvents.shift(); // only store the last N events
                    const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
                    const firstEvent = recentWheelEvents[0];
                    recentWheelEvents.push(newEvent);
                    if (prevEvent && (newEvent.delta > prevEvent.delta || newEvent.direction !== prevEvent.direction)) // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
                    recentWheelEvents.splice(0);
                    else if (recentWheelEvents.length >= 15 && newEvent.time - firstEvent.time < 500 && firstEvent.delta - newEvent.delta >= 1 && newEvent.delta <= 6) {
                        // We're at the end of the deceleration of a momentum scroll, so there's no need
                        // to wait for more events. Snap ASAP on the next tick.
                        // Also, because there's some remaining momentum we'll bias the snap in the
                        // direction of the ongoing scroll because it's better UX for the scroll to snap
                        // in the same direction as the scroll instead of reversing to snap.  Therefore,
                        // if it's already scrolled more than 20% in the current direction, keep going.
                        const snapToThreshold = delta > 0 ? 0.8 : 0.2;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        timeout = (0, $f97f33853a605dba$export$7ccc53e8f1e7dfc5)(()=>{
                            if (swiper.destroyed || !swiper.params) return;
                            swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                        }, 0); // no delay; move on next tick
                    }
                    if (!timeout) // if we get here, then we haven't detected the end of a momentum scroll, so
                    // we'll consider a scroll "complete" when there haven't been any wheel events
                    // for 500ms.
                    timeout = (0, $f97f33853a605dba$export$7ccc53e8f1e7dfc5)(()=>{
                        if (swiper.destroyed || !swiper.params) return;
                        const snapToThreshold = 0.5;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                    }, 500);
                }
                // Emit event
                if (!ignoreWheelEvents) emit('scroll', e);
                // Stop autoplay
                if (swiper.params.autoplay && swiper.params.autoplay.disableOnInteraction) swiper.autoplay.stop();
                // Return page scroll on edge positions
                if (params.releaseOnEdges && (position === swiper.minTranslate() || position === swiper.maxTranslate())) return true;
            }
        }
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return false;
    }
    function events(method) {
        let targetEl = swiper.el;
        if (swiper.params.mousewheel.eventsTarget !== 'container') targetEl = document.querySelector(swiper.params.mousewheel.eventsTarget);
        targetEl[method]('mouseenter', handleMouseEnter);
        targetEl[method]('mouseleave', handleMouseLeave);
        targetEl[method]('wheel', handle);
    }
    function enable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.removeEventListener('wheel', handle);
            return true;
        }
        if (swiper.mousewheel.enabled) return false;
        events('addEventListener');
        swiper.mousewheel.enabled = true;
        return true;
    }
    function disable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.addEventListener(event, handle);
            return true;
        }
        if (!swiper.mousewheel.enabled) return false;
        events('removeEventListener');
        swiper.mousewheel.enabled = false;
        return true;
    }
    on('init', ()=>{
        if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) disable();
        if (swiper.params.mousewheel.enabled) enable();
    });
    on('destroy', ()=>{
        if (swiper.params.cssMode) enable();
        if (swiper.mousewheel.enabled) disable();
    });
    Object.assign(swiper.mousewheel, {
        enable: enable,
        disable: disable
    });
}



function $306a0aea613e7477$export$db3b6bfb95261072(swiper, originalParams, params, checkProps) {
    if (swiper.params.createElements) Object.keys(checkProps).forEach((key)=>{
        if (!params[key] && params.auto === true) {
            let element = (0, $f97f33853a605dba$export$f1e1789686576879)(swiper.el, `.${checkProps[key]}`)[0];
            if (!element) {
                element = (0, $f97f33853a605dba$export$db3b6bfb95261072)('div', checkProps[key]);
                element.className = checkProps[key];
                swiper.el.append(element);
            }
            params[key] = element;
            originalParams[key] = element;
        }
    });
    return params;
}



function $dc75855670d5bebb$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    extendParams({
        navigation: {
            nextEl: null,
            prevEl: null,
            hideOnClick: false,
            disabledClass: 'swiper-button-disabled',
            hiddenClass: 'swiper-button-hidden',
            lockClass: 'swiper-button-lock',
            navigationDisabledClass: 'swiper-navigation-disabled'
        }
    });
    swiper.navigation = {
        nextEl: null,
        prevEl: null
    };
    function getEl(el) {
        let res;
        if (el && typeof el === 'string' && swiper.isElement) {
            res = swiper.el.querySelector(el) || swiper.hostEl.querySelector(el);
            if (res) return res;
        }
        if (el) {
            if (typeof el === 'string') res = [
                ...document.querySelectorAll(el)
            ];
            if (swiper.params.uniqueNavElements && typeof el === 'string' && res && res.length > 1 && swiper.el.querySelectorAll(el).length === 1) res = swiper.el.querySelector(el);
            else if (res && res.length === 1) res = res[0];
        }
        if (el && !res) return el;
        // if (Array.isArray(res) && res.length === 1) res = res[0];
        return res;
    }
    function toggleEl(el, disabled) {
        const params = swiper.params.navigation;
        el = (0, $f97f33853a605dba$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            if (subEl) {
                subEl.classList[disabled ? 'add' : 'remove'](...params.disabledClass.split(' '));
                if (subEl.tagName === 'BUTTON') subEl.disabled = disabled;
                if (swiper.params.watchOverflow && swiper.enabled) subEl.classList[swiper.isLocked ? 'add' : 'remove'](params.lockClass);
            }
        });
    }
    function update() {
        // Update Navigation Buttons
        const { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        if (swiper.params.loop) {
            toggleEl(prevEl, false);
            toggleEl(nextEl, false);
            return;
        }
        toggleEl(prevEl, swiper.isBeginning && !swiper.params.rewind);
        toggleEl(nextEl, swiper.isEnd && !swiper.params.rewind);
    }
    function onPrevClick(e) {
        e.preventDefault();
        if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slidePrev();
        emit('navigationPrev');
    }
    function onNextClick(e) {
        e.preventDefault();
        if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slideNext();
        emit('navigationNext');
    }
    function init() {
        const params = swiper.params.navigation;
        swiper.params.navigation = (0, $306a0aea613e7477$export$db3b6bfb95261072)(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
            nextEl: 'swiper-button-next',
            prevEl: 'swiper-button-prev'
        });
        if (!(params.nextEl || params.prevEl)) return;
        let nextEl = getEl(params.nextEl);
        let prevEl = getEl(params.prevEl);
        Object.assign(swiper.navigation, {
            nextEl: nextEl,
            prevEl: prevEl
        });
        nextEl = (0, $f97f33853a605dba$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $f97f33853a605dba$export$953cecd6e717a553)(prevEl);
        const initButton = (el, dir)=>{
            if (el) el.addEventListener('click', dir === 'next' ? onNextClick : onPrevClick);
            if (!swiper.enabled && el) el.classList.add(...params.lockClass.split(' '));
        };
        nextEl.forEach((el)=>initButton(el, 'next'));
        prevEl.forEach((el)=>initButton(el, 'prev'));
    }
    function destroy() {
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        nextEl = (0, $f97f33853a605dba$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $f97f33853a605dba$export$953cecd6e717a553)(prevEl);
        const destroyButton = (el, dir)=>{
            el.removeEventListener('click', dir === 'next' ? onNextClick : onPrevClick);
            el.classList.remove(...swiper.params.navigation.disabledClass.split(' '));
        };
        nextEl.forEach((el)=>destroyButton(el, 'next'));
        prevEl.forEach((el)=>destroyButton(el, 'prev'));
    }
    on('init', ()=>{
        if (swiper.params.navigation.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            update();
        }
    });
    on('toEdge fromEdge lock unlock', ()=>{
        update();
    });
    on('destroy', ()=>{
        destroy();
    });
    on('enable disable', ()=>{
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        nextEl = (0, $f97f33853a605dba$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $f97f33853a605dba$export$953cecd6e717a553)(prevEl);
        if (swiper.enabled) {
            update();
            return;
        }
        [
            ...nextEl,
            ...prevEl
        ].filter((el)=>!!el).forEach((el)=>el.classList.add(swiper.params.navigation.lockClass));
    });
    on('click', (_s, e)=>{
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        nextEl = (0, $f97f33853a605dba$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $f97f33853a605dba$export$953cecd6e717a553)(prevEl);
        const targetEl = e.target;
        let targetIsButton = prevEl.includes(targetEl) || nextEl.includes(targetEl);
        if (swiper.isElement && !targetIsButton) {
            const path = e.path || e.composedPath && e.composedPath();
            if (path) targetIsButton = path.find((pathEl)=>nextEl.includes(pathEl) || prevEl.includes(pathEl));
        }
        if (swiper.params.navigation.hideOnClick && !targetIsButton) {
            if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
            let isHidden;
            if (nextEl.length) isHidden = nextEl[0].classList.contains(swiper.params.navigation.hiddenClass);
            else if (prevEl.length) isHidden = prevEl[0].classList.contains(swiper.params.navigation.hiddenClass);
            if (isHidden === true) emit('navigationShow');
            else emit('navigationHide');
            [
                ...nextEl,
                ...prevEl
            ].filter((el)=>!!el).forEach((el)=>el.classList.toggle(swiper.params.navigation.hiddenClass));
        }
    });
    const enable = ()=>{
        swiper.el.classList.remove(...swiper.params.navigation.navigationDisabledClass.split(' '));
        init();
        update();
    };
    const disable = ()=>{
        swiper.el.classList.add(...swiper.params.navigation.navigationDisabledClass.split(' '));
        destroy();
    };
    Object.assign(swiper.navigation, {
        enable: enable,
        disable: disable,
        update: update,
        init: init,
        destroy: destroy
    });
}


function $129272ba76d8b432$export$db3b6bfb95261072(classes) {
    if (classes === void 0) classes = '';
    return `.${classes.trim().replace(/([\.:!+\/()[\]])/g, '\\$1') // eslint-disable-line
    .replace(/ /g, '.')}`;
}




function $a65bf22b710e8cc3$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const pfx = 'swiper-pagination';
    extendParams({
        pagination: {
            el: null,
            bulletElement: 'span',
            clickable: false,
            hideOnClick: false,
            renderBullet: null,
            renderProgressbar: null,
            renderFraction: null,
            renderCustom: null,
            progressbarOpposite: false,
            type: 'bullets',
            // 'bullets' or 'progressbar' or 'fraction' or 'custom'
            dynamicBullets: false,
            dynamicMainBullets: 1,
            formatFractionCurrent: (number)=>number,
            formatFractionTotal: (number)=>number,
            bulletClass: `${pfx}-bullet`,
            bulletActiveClass: `${pfx}-bullet-active`,
            modifierClass: `${pfx}-`,
            currentClass: `${pfx}-current`,
            totalClass: `${pfx}-total`,
            hiddenClass: `${pfx}-hidden`,
            progressbarFillClass: `${pfx}-progressbar-fill`,
            progressbarOppositeClass: `${pfx}-progressbar-opposite`,
            clickableClass: `${pfx}-clickable`,
            lockClass: `${pfx}-lock`,
            horizontalClass: `${pfx}-horizontal`,
            verticalClass: `${pfx}-vertical`,
            paginationDisabledClass: `${pfx}-disabled`
        }
    });
    swiper.pagination = {
        el: null,
        bullets: []
    };
    let bulletSize;
    let dynamicBulletIndex = 0;
    function isPaginationDisabled() {
        return !swiper.params.pagination.el || !swiper.pagination.el || Array.isArray(swiper.pagination.el) && swiper.pagination.el.length === 0;
    }
    function setSideBullets(bulletEl, position) {
        const { bulletActiveClass: bulletActiveClass } = swiper.params.pagination;
        if (!bulletEl) return;
        bulletEl = bulletEl[`${position === 'prev' ? 'previous' : 'next'}ElementSibling`];
        if (bulletEl) {
            bulletEl.classList.add(`${bulletActiveClass}-${position}`);
            bulletEl = bulletEl[`${position === 'prev' ? 'previous' : 'next'}ElementSibling`];
            if (bulletEl) bulletEl.classList.add(`${bulletActiveClass}-${position}-${position}`);
        }
    }
    function getMoveDirection(prevIndex, nextIndex, length) {
        prevIndex = prevIndex % length;
        nextIndex = nextIndex % length;
        if (nextIndex === prevIndex + 1) return 'next';
        else if (nextIndex === prevIndex - 1) return 'previous';
        return;
    }
    function onBulletClick(e) {
        const bulletEl = e.target.closest((0, $129272ba76d8b432$export$db3b6bfb95261072)(swiper.params.pagination.bulletClass));
        if (!bulletEl) return;
        e.preventDefault();
        const index = (0, $f97f33853a605dba$export$23f2a1d2818174ef)(bulletEl) * swiper.params.slidesPerGroup;
        if (swiper.params.loop) {
            if (swiper.realIndex === index) return;
            const moveDirection = getMoveDirection(swiper.realIndex, index, swiper.slides.length);
            if (moveDirection === 'next') swiper.slideNext();
            else if (moveDirection === 'previous') swiper.slidePrev();
            else swiper.slideToLoop(index);
        } else swiper.slideTo(index);
    }
    function update() {
        // Render || Update Pagination bullets/items
        const rtl = swiper.rtl;
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        let el = swiper.pagination.el;
        el = (0, $f97f33853a605dba$export$953cecd6e717a553)(el);
        // Current/Total
        let current;
        let previousIndex;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        const total = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
        if (swiper.params.loop) {
            previousIndex = swiper.previousRealIndex || 0;
            current = swiper.params.slidesPerGroup > 1 ? Math.floor(swiper.realIndex / swiper.params.slidesPerGroup) : swiper.realIndex;
        } else if (typeof swiper.snapIndex !== 'undefined') {
            current = swiper.snapIndex;
            previousIndex = swiper.previousSnapIndex;
        } else {
            previousIndex = swiper.previousIndex || 0;
            current = swiper.activeIndex || 0;
        }
        // Types
        if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
            const bullets = swiper.pagination.bullets;
            let firstIndex;
            let lastIndex;
            let midIndex;
            if (params.dynamicBullets) {
                bulletSize = (0, $f97f33853a605dba$export$dda1d9f60106f0e9)(bullets[0], swiper.isHorizontal() ? 'width' : 'height', true);
                el.forEach((subEl)=>{
                    subEl.style[swiper.isHorizontal() ? 'width' : 'height'] = `${bulletSize * (params.dynamicMainBullets + 4)}px`;
                });
                if (params.dynamicMainBullets > 1 && previousIndex !== undefined) {
                    dynamicBulletIndex += current - (previousIndex || 0);
                    if (dynamicBulletIndex > params.dynamicMainBullets - 1) dynamicBulletIndex = params.dynamicMainBullets - 1;
                    else if (dynamicBulletIndex < 0) dynamicBulletIndex = 0;
                }
                firstIndex = Math.max(current - dynamicBulletIndex, 0);
                lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
                midIndex = (lastIndex + firstIndex) / 2;
            }
            bullets.forEach((bulletEl)=>{
                const classesToRemove = [
                    ...[
                        '',
                        '-next',
                        '-next-next',
                        '-prev',
                        '-prev-prev',
                        '-main'
                    ].map((suffix)=>`${params.bulletActiveClass}${suffix}`)
                ].map((s)=>typeof s === 'string' && s.includes(' ') ? s.split(' ') : s).flat();
                bulletEl.classList.remove(...classesToRemove);
            });
            if (el.length > 1) bullets.forEach((bullet)=>{
                const bulletIndex = (0, $f97f33853a605dba$export$23f2a1d2818174ef)(bullet);
                if (bulletIndex === current) bullet.classList.add(...params.bulletActiveClass.split(' '));
                else if (swiper.isElement) bullet.setAttribute('part', 'bullet');
                if (params.dynamicBullets) {
                    if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) bullet.classList.add(...`${params.bulletActiveClass}-main`.split(' '));
                    if (bulletIndex === firstIndex) setSideBullets(bullet, 'prev');
                    if (bulletIndex === lastIndex) setSideBullets(bullet, 'next');
                }
            });
            else {
                const bullet = bullets[current];
                if (bullet) bullet.classList.add(...params.bulletActiveClass.split(' '));
                if (swiper.isElement) bullets.forEach((bulletEl, bulletIndex)=>{
                    bulletEl.setAttribute('part', bulletIndex === current ? 'bullet-active' : 'bullet');
                });
                if (params.dynamicBullets) {
                    const firstDisplayedBullet = bullets[firstIndex];
                    const lastDisplayedBullet = bullets[lastIndex];
                    for(let i = firstIndex; i <= lastIndex; i += 1)if (bullets[i]) bullets[i].classList.add(...`${params.bulletActiveClass}-main`.split(' '));
                    setSideBullets(firstDisplayedBullet, 'prev');
                    setSideBullets(lastDisplayedBullet, 'next');
                }
            }
            if (params.dynamicBullets) {
                const dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
                const bulletsOffset = (bulletSize * dynamicBulletsLength - bulletSize) / 2 - midIndex * bulletSize;
                const offsetProp = rtl ? 'right' : 'left';
                bullets.forEach((bullet)=>{
                    bullet.style[swiper.isHorizontal() ? offsetProp : 'top'] = `${bulletsOffset}px`;
                });
            }
        }
        el.forEach((subEl, subElIndex)=>{
            if (params.type === 'fraction') {
                subEl.querySelectorAll((0, $129272ba76d8b432$export$db3b6bfb95261072)(params.currentClass)).forEach((fractionEl)=>{
                    fractionEl.textContent = params.formatFractionCurrent(current + 1);
                });
                subEl.querySelectorAll((0, $129272ba76d8b432$export$db3b6bfb95261072)(params.totalClass)).forEach((totalEl)=>{
                    totalEl.textContent = params.formatFractionTotal(total);
                });
            }
            if (params.type === 'progressbar') {
                let progressbarDirection;
                if (params.progressbarOpposite) progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
                else progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
                const scale = (current + 1) / total;
                let scaleX = 1;
                let scaleY = 1;
                if (progressbarDirection === 'horizontal') scaleX = scale;
                else scaleY = scale;
                subEl.querySelectorAll((0, $129272ba76d8b432$export$db3b6bfb95261072)(params.progressbarFillClass)).forEach((progressEl)=>{
                    progressEl.style.transform = `translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`;
                    progressEl.style.transitionDuration = `${swiper.params.speed}ms`;
                });
            }
            if (params.type === 'custom' && params.renderCustom) {
                (0, $f97f33853a605dba$export$2408f22a0fab9ae5)(subEl, params.renderCustom(swiper, current + 1, total));
                if (subElIndex === 0) emit('paginationRender', subEl);
            } else {
                if (subElIndex === 0) emit('paginationRender', subEl);
                emit('paginationUpdate', subEl);
            }
            if (swiper.params.watchOverflow && swiper.enabled) subEl.classList[swiper.isLocked ? 'add' : 'remove'](params.lockClass);
        });
    }
    function render() {
        // Render Container
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.grid && swiper.params.grid.rows > 1 ? swiper.slides.length / Math.ceil(swiper.params.grid.rows) : swiper.slides.length;
        let el = swiper.pagination.el;
        el = (0, $f97f33853a605dba$export$953cecd6e717a553)(el);
        let paginationHTML = '';
        if (params.type === 'bullets') {
            let numberOfBullets = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
            if (swiper.params.freeMode && swiper.params.freeMode.enabled && numberOfBullets > slidesLength) numberOfBullets = slidesLength;
            for(let i = 0; i < numberOfBullets; i += 1)if (params.renderBullet) paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
            else // prettier-ignore
            paginationHTML += `<${params.bulletElement} ${swiper.isElement ? 'part="bullet"' : ''} class="${params.bulletClass}"></${params.bulletElement}>`;
        }
        if (params.type === 'fraction') {
            if (params.renderFraction) paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
            else paginationHTML = `<span class="${params.currentClass}"></span>` + ' / ' + `<span class="${params.totalClass}"></span>`;
        }
        if (params.type === 'progressbar') {
            if (params.renderProgressbar) paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
            else paginationHTML = `<span class="${params.progressbarFillClass}"></span>`;
        }
        swiper.pagination.bullets = [];
        el.forEach((subEl)=>{
            if (params.type !== 'custom') (0, $f97f33853a605dba$export$2408f22a0fab9ae5)(subEl, paginationHTML || '');
            if (params.type === 'bullets') swiper.pagination.bullets.push(...subEl.querySelectorAll((0, $129272ba76d8b432$export$db3b6bfb95261072)(params.bulletClass)));
        });
        if (params.type !== 'custom') emit('paginationRender', el[0]);
    }
    function init() {
        swiper.params.pagination = (0, $306a0aea613e7477$export$db3b6bfb95261072)(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
            el: 'swiper-pagination'
        });
        const params = swiper.params.pagination;
        if (!params.el) return;
        let el;
        if (typeof params.el === 'string' && swiper.isElement) el = swiper.el.querySelector(params.el);
        if (!el && typeof params.el === 'string') el = [
            ...document.querySelectorAll(params.el)
        ];
        if (!el) el = params.el;
        if (!el || el.length === 0) return;
        if (swiper.params.uniqueNavElements && typeof params.el === 'string' && Array.isArray(el) && el.length > 1) {
            el = [
                ...swiper.el.querySelectorAll(params.el)
            ];
            // check if it belongs to another nested Swiper
            if (el.length > 1) el = el.find((subEl)=>{
                if ((0, $f97f33853a605dba$export$8b22cf2602fb60ce)(subEl, '.swiper')[0] !== swiper.el) return false;
                return true;
            });
        }
        if (Array.isArray(el) && el.length === 1) el = el[0];
        Object.assign(swiper.pagination, {
            el: el
        });
        el = (0, $f97f33853a605dba$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            if (params.type === 'bullets' && params.clickable) subEl.classList.add(...(params.clickableClass || '').split(' '));
            subEl.classList.add(params.modifierClass + params.type);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
            if (params.type === 'bullets' && params.dynamicBullets) {
                subEl.classList.add(`${params.modifierClass}${params.type}-dynamic`);
                dynamicBulletIndex = 0;
                if (params.dynamicMainBullets < 1) params.dynamicMainBullets = 1;
            }
            if (params.type === 'progressbar' && params.progressbarOpposite) subEl.classList.add(params.progressbarOppositeClass);
            if (params.clickable) subEl.addEventListener('click', onBulletClick);
            if (!swiper.enabled) subEl.classList.add(params.lockClass);
        });
    }
    function destroy() {
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        let el = swiper.pagination.el;
        if (el) {
            el = (0, $f97f33853a605dba$export$953cecd6e717a553)(el);
            el.forEach((subEl)=>{
                subEl.classList.remove(params.hiddenClass);
                subEl.classList.remove(params.modifierClass + params.type);
                subEl.classList.remove(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
                if (params.clickable) {
                    subEl.classList.remove(...(params.clickableClass || '').split(' '));
                    subEl.removeEventListener('click', onBulletClick);
                }
            });
        }
        if (swiper.pagination.bullets) swiper.pagination.bullets.forEach((subEl)=>subEl.classList.remove(...params.bulletActiveClass.split(' ')));
    }
    on('changeDirection', ()=>{
        if (!swiper.pagination || !swiper.pagination.el) return;
        const params = swiper.params.pagination;
        let { el: el } = swiper.pagination;
        el = (0, $f97f33853a605dba$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.classList.remove(params.horizontalClass, params.verticalClass);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        });
    });
    on('init', ()=>{
        if (swiper.params.pagination.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            render();
            update();
        }
    });
    on('activeIndexChange', ()=>{
        if (typeof swiper.snapIndex === 'undefined') update();
    });
    on('snapIndexChange', ()=>{
        update();
    });
    on('snapGridLengthChange', ()=>{
        render();
        update();
    });
    on('destroy', ()=>{
        destroy();
    });
    on('enable disable', ()=>{
        let { el: el } = swiper.pagination;
        if (el) {
            el = (0, $f97f33853a605dba$export$953cecd6e717a553)(el);
            el.forEach((subEl)=>subEl.classList[swiper.enabled ? 'remove' : 'add'](swiper.params.pagination.lockClass));
        }
    });
    on('lock unlock', ()=>{
        update();
    });
    on('click', (_s, e)=>{
        const targetEl = e.target;
        const el = (0, $f97f33853a605dba$export$953cecd6e717a553)(swiper.pagination.el);
        if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && el && el.length > 0 && !targetEl.classList.contains(swiper.params.pagination.bulletClass)) {
            if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
            const isHidden = el[0].classList.contains(swiper.params.pagination.hiddenClass);
            if (isHidden === true) emit('paginationShow');
            else emit('paginationHide');
            el.forEach((subEl)=>subEl.classList.toggle(swiper.params.pagination.hiddenClass));
        }
    });
    const enable = ()=>{
        swiper.el.classList.remove(swiper.params.pagination.paginationDisabledClass);
        let { el: el } = swiper.pagination;
        if (el) {
            el = (0, $f97f33853a605dba$export$953cecd6e717a553)(el);
            el.forEach((subEl)=>subEl.classList.remove(swiper.params.pagination.paginationDisabledClass));
        }
        init();
        render();
        update();
    };
    const disable = ()=>{
        swiper.el.classList.add(swiper.params.pagination.paginationDisabledClass);
        let { el: el } = swiper.pagination;
        if (el) {
            el = (0, $f97f33853a605dba$export$953cecd6e717a553)(el);
            el.forEach((subEl)=>subEl.classList.add(swiper.params.pagination.paginationDisabledClass));
        }
        destroy();
    };
    Object.assign(swiper.pagination, {
        enable: enable,
        disable: disable,
        render: render,
        update: update,
        init: init,
        destroy: destroy
    });
}






function $acf6379ef00d1b73$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const document = (0, $0868fe5596dee114$export$39b482c5e57630a8)();
    let isTouched = false;
    let timeout = null;
    let dragTimeout = null;
    let dragStartPos;
    let dragSize;
    let trackSize;
    let divider;
    extendParams({
        scrollbar: {
            el: null,
            dragSize: 'auto',
            hide: false,
            draggable: false,
            snapOnRelease: true,
            lockClass: 'swiper-scrollbar-lock',
            dragClass: 'swiper-scrollbar-drag',
            scrollbarDisabledClass: 'swiper-scrollbar-disabled',
            horizontalClass: `swiper-scrollbar-horizontal`,
            verticalClass: `swiper-scrollbar-vertical`
        }
    });
    swiper.scrollbar = {
        el: null,
        dragEl: null
    };
    function setTranslate() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar: scrollbar, rtlTranslate: rtl } = swiper;
        const { dragEl: dragEl, el: el } = scrollbar;
        const params = swiper.params.scrollbar;
        const progress = swiper.params.loop ? swiper.progressLoop : swiper.progress;
        let newSize = dragSize;
        let newPos = (trackSize - dragSize) * progress;
        if (rtl) {
            newPos = -newPos;
            if (newPos > 0) {
                newSize = dragSize - newPos;
                newPos = 0;
            } else if (-newPos + dragSize > trackSize) newSize = trackSize + newPos;
        } else if (newPos < 0) {
            newSize = dragSize + newPos;
            newPos = 0;
        } else if (newPos + dragSize > trackSize) newSize = trackSize - newPos;
        if (swiper.isHorizontal()) {
            dragEl.style.transform = `translate3d(${newPos}px, 0, 0)`;
            dragEl.style.width = `${newSize}px`;
        } else {
            dragEl.style.transform = `translate3d(0px, ${newPos}px, 0)`;
            dragEl.style.height = `${newSize}px`;
        }
        if (params.hide) {
            clearTimeout(timeout);
            el.style.opacity = 1;
            timeout = setTimeout(()=>{
                el.style.opacity = 0;
                el.style.transitionDuration = '400ms';
            }, 1000);
        }
    }
    function setTransition(duration) {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        swiper.scrollbar.dragEl.style.transitionDuration = `${duration}ms`;
    }
    function updateSize() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar: scrollbar } = swiper;
        const { dragEl: dragEl, el: el } = scrollbar;
        dragEl.style.width = '';
        dragEl.style.height = '';
        trackSize = swiper.isHorizontal() ? el.offsetWidth : el.offsetHeight;
        divider = swiper.size / (swiper.virtualSize + swiper.params.slidesOffsetBefore - (swiper.params.centeredSlides ? swiper.snapGrid[0] : 0));
        if (swiper.params.scrollbar.dragSize === 'auto') dragSize = trackSize * divider;
        else dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
        if (swiper.isHorizontal()) dragEl.style.width = `${dragSize}px`;
        else dragEl.style.height = `${dragSize}px`;
        if (divider >= 1) el.style.display = 'none';
        else el.style.display = '';
        if (swiper.params.scrollbar.hide) el.style.opacity = 0;
        if (swiper.params.watchOverflow && swiper.enabled) scrollbar.el.classList[swiper.isLocked ? 'add' : 'remove'](swiper.params.scrollbar.lockClass);
    }
    function getPointerPosition(e) {
        return swiper.isHorizontal() ? e.clientX : e.clientY;
    }
    function setDragPosition(e) {
        const { scrollbar: scrollbar, rtlTranslate: rtl } = swiper;
        const { el: el } = scrollbar;
        let positionRatio;
        positionRatio = (getPointerPosition(e) - (0, $f97f33853a605dba$export$4368d992c4eafac0)(el)[swiper.isHorizontal() ? 'left' : 'top'] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
        positionRatio = Math.max(Math.min(positionRatio, 1), 0);
        if (rtl) positionRatio = 1 - positionRatio;
        const position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
        swiper.updateProgress(position);
        swiper.setTranslate(position);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    function onDragStart(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar: scrollbar, wrapperEl: wrapperEl } = swiper;
        const { el: el, dragEl: dragEl } = scrollbar;
        isTouched = true;
        dragStartPos = e.target === dragEl ? getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? 'left' : 'top'] : null;
        e.preventDefault();
        e.stopPropagation();
        wrapperEl.style.transitionDuration = '100ms';
        dragEl.style.transitionDuration = '100ms';
        setDragPosition(e);
        clearTimeout(dragTimeout);
        el.style.transitionDuration = '0ms';
        if (params.hide) el.style.opacity = 1;
        if (swiper.params.cssMode) swiper.wrapperEl.style['scroll-snap-type'] = 'none';
        emit('scrollbarDragStart', e);
    }
    function onDragMove(e) {
        const { scrollbar: scrollbar, wrapperEl: wrapperEl } = swiper;
        const { el: el, dragEl: dragEl } = scrollbar;
        if (!isTouched) return;
        if (e.preventDefault && e.cancelable) e.preventDefault();
        else e.returnValue = false;
        setDragPosition(e);
        wrapperEl.style.transitionDuration = '0ms';
        el.style.transitionDuration = '0ms';
        dragEl.style.transitionDuration = '0ms';
        emit('scrollbarDragMove', e);
    }
    function onDragEnd(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar: scrollbar, wrapperEl: wrapperEl } = swiper;
        const { el: el } = scrollbar;
        if (!isTouched) return;
        isTouched = false;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style['scroll-snap-type'] = '';
            wrapperEl.style.transitionDuration = '';
        }
        if (params.hide) {
            clearTimeout(dragTimeout);
            dragTimeout = (0, $f97f33853a605dba$export$7ccc53e8f1e7dfc5)(()=>{
                el.style.opacity = 0;
                el.style.transitionDuration = '400ms';
            }, 1000);
        }
        emit('scrollbarDragEnd', e);
        if (params.snapOnRelease) swiper.slideToClosest();
    }
    function events(method) {
        const { scrollbar: scrollbar, params: params } = swiper;
        const el = scrollbar.el;
        if (!el) return;
        const target = el;
        const activeListener = params.passiveListeners ? {
            passive: false,
            capture: false
        } : false;
        const passiveListener = params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        if (!target) return;
        const eventMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
        target[eventMethod]('pointerdown', onDragStart, activeListener);
        document[eventMethod]('pointermove', onDragMove, activeListener);
        document[eventMethod]('pointerup', onDragEnd, passiveListener);
    }
    function enableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events('on');
    }
    function disableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events('off');
    }
    function init() {
        const { scrollbar: scrollbar, el: swiperEl } = swiper;
        swiper.params.scrollbar = (0, $306a0aea613e7477$export$db3b6bfb95261072)(swiper, swiper.originalParams.scrollbar, swiper.params.scrollbar, {
            el: 'swiper-scrollbar'
        });
        const params = swiper.params.scrollbar;
        if (!params.el) return;
        let el;
        if (typeof params.el === 'string' && swiper.isElement) el = swiper.el.querySelector(params.el);
        if (!el && typeof params.el === 'string') {
            el = document.querySelectorAll(params.el);
            if (!el.length) return;
        } else if (!el) el = params.el;
        if (swiper.params.uniqueNavElements && typeof params.el === 'string' && el.length > 1 && swiperEl.querySelectorAll(params.el).length === 1) el = swiperEl.querySelector(params.el);
        if (el.length > 0) el = el[0];
        el.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        let dragEl;
        if (el) {
            dragEl = el.querySelector((0, $129272ba76d8b432$export$db3b6bfb95261072)(swiper.params.scrollbar.dragClass));
            if (!dragEl) {
                dragEl = (0, $f97f33853a605dba$export$db3b6bfb95261072)('div', swiper.params.scrollbar.dragClass);
                el.append(dragEl);
            }
        }
        Object.assign(scrollbar, {
            el: el,
            dragEl: dragEl
        });
        if (params.draggable) enableDraggable();
        if (el) el.classList[swiper.enabled ? 'remove' : 'add'](...(0, $f97f33853a605dba$export$35e795649ee09318)(swiper.params.scrollbar.lockClass));
    }
    function destroy() {
        const params = swiper.params.scrollbar;
        const el = swiper.scrollbar.el;
        if (el) el.classList.remove(...(0, $f97f33853a605dba$export$35e795649ee09318)(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass));
        disableDraggable();
    }
    on('changeDirection', ()=>{
        if (!swiper.scrollbar || !swiper.scrollbar.el) return;
        const params = swiper.params.scrollbar;
        let { el: el } = swiper.scrollbar;
        el = (0, $f97f33853a605dba$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.classList.remove(params.horizontalClass, params.verticalClass);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        });
    });
    on('init', ()=>{
        if (swiper.params.scrollbar.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            updateSize();
            setTranslate();
        }
    });
    on('update resize observerUpdate lock unlock changeDirection', ()=>{
        updateSize();
    });
    on('setTranslate', ()=>{
        setTranslate();
    });
    on('setTransition', (_s, duration)=>{
        setTransition(duration);
    });
    on('enable disable', ()=>{
        const { el: el } = swiper.scrollbar;
        if (el) el.classList[swiper.enabled ? 'remove' : 'add'](...(0, $f97f33853a605dba$export$35e795649ee09318)(swiper.params.scrollbar.lockClass));
    });
    on('destroy', ()=>{
        destroy();
    });
    const enable = ()=>{
        swiper.el.classList.remove(...(0, $f97f33853a605dba$export$35e795649ee09318)(swiper.params.scrollbar.scrollbarDisabledClass));
        if (swiper.scrollbar.el) swiper.scrollbar.el.classList.remove(...(0, $f97f33853a605dba$export$35e795649ee09318)(swiper.params.scrollbar.scrollbarDisabledClass));
        init();
        updateSize();
        setTranslate();
    };
    const disable = ()=>{
        swiper.el.classList.add(...(0, $f97f33853a605dba$export$35e795649ee09318)(swiper.params.scrollbar.scrollbarDisabledClass));
        if (swiper.scrollbar.el) swiper.scrollbar.el.classList.add(...(0, $f97f33853a605dba$export$35e795649ee09318)(swiper.params.scrollbar.scrollbarDisabledClass));
        destroy();
    };
    Object.assign(swiper.scrollbar, {
        enable: enable,
        disable: disable,
        updateSize: updateSize,
        setTranslate: setTranslate,
        init: init,
        destroy: destroy
    });
}



function $9eab48129a718d0a$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        parallax: {
            enabled: false
        }
    });
    const elementsSelector = '[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]';
    const setTransform = (el, progress)=>{
        const { rtl: rtl } = swiper;
        const rtlFactor = rtl ? -1 : 1;
        const p = el.getAttribute('data-swiper-parallax') || '0';
        let x = el.getAttribute('data-swiper-parallax-x');
        let y = el.getAttribute('data-swiper-parallax-y');
        const scale = el.getAttribute('data-swiper-parallax-scale');
        const opacity = el.getAttribute('data-swiper-parallax-opacity');
        const rotate = el.getAttribute('data-swiper-parallax-rotate');
        if (x || y) {
            x = x || '0';
            y = y || '0';
        } else if (swiper.isHorizontal()) {
            x = p;
            y = '0';
        } else {
            y = p;
            x = '0';
        }
        if (x.indexOf('%') >= 0) x = `${parseInt(x, 10) * progress * rtlFactor}%`;
        else x = `${x * progress * rtlFactor}px`;
        if (y.indexOf('%') >= 0) y = `${parseInt(y, 10) * progress}%`;
        else y = `${y * progress}px`;
        if (typeof opacity !== 'undefined' && opacity !== null) {
            const currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
            el.style.opacity = currentOpacity;
        }
        let transform = `translate3d(${x}, ${y}, 0px)`;
        if (typeof scale !== 'undefined' && scale !== null) {
            const currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
            transform += ` scale(${currentScale})`;
        }
        if (rotate && typeof rotate !== 'undefined' && rotate !== null) {
            const currentRotate = rotate * progress * -1;
            transform += ` rotate(${currentRotate}deg)`;
        }
        el.style.transform = transform;
    };
    const setTranslate = ()=>{
        const { el: el, slides: slides, progress: progress, snapGrid: snapGrid, isElement: isElement } = swiper;
        const elements = (0, $f97f33853a605dba$export$f1e1789686576879)(el, elementsSelector);
        if (swiper.isElement) elements.push(...(0, $f97f33853a605dba$export$f1e1789686576879)(swiper.hostEl, elementsSelector));
        elements.forEach((subEl)=>{
            setTransform(subEl, progress);
        });
        slides.forEach((slideEl, slideIndex)=>{
            let slideProgress = slideEl.progress;
            if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
            slideProgress = Math.min(Math.max(slideProgress, -1), 1);
            slideEl.querySelectorAll(`${elementsSelector}, [data-swiper-parallax-rotate]`).forEach((subEl)=>{
                setTransform(subEl, slideProgress);
            });
        });
    };
    const setTransition = function(duration) {
        if (duration === void 0) duration = swiper.params.speed;
        const { el: el, hostEl: hostEl } = swiper;
        const elements = [
            ...el.querySelectorAll(elementsSelector)
        ];
        if (swiper.isElement) elements.push(...hostEl.querySelectorAll(elementsSelector));
        elements.forEach((parallaxEl)=>{
            let parallaxDuration = parseInt(parallaxEl.getAttribute('data-swiper-parallax-duration'), 10) || duration;
            if (duration === 0) parallaxDuration = 0;
            parallaxEl.style.transitionDuration = `${parallaxDuration}ms`;
        });
    };
    on('beforeInit', ()=>{
        if (!swiper.params.parallax.enabled) return;
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
    });
    on('init', ()=>{
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on('setTranslate', ()=>{
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on('setTransition', (_swiper, duration)=>{
        if (!swiper.params.parallax.enabled) return;
        setTransition(duration);
    });
}




function $5ce60fb5cd45355e$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const window = (0, $0868fe5596dee114$export$407448d2b89b1813)();
    extendParams({
        zoom: {
            enabled: false,
            limitToOriginalSize: false,
            maxRatio: 3,
            minRatio: 1,
            panOnMouseMove: false,
            toggle: true,
            containerClass: 'swiper-zoom-container',
            zoomedSlideClass: 'swiper-slide-zoomed'
        }
    });
    swiper.zoom = {
        enabled: false
    };
    let currentScale = 1;
    let isScaling = false;
    let isPanningWithMouse = false;
    let mousePanStart = {
        x: 0,
        y: 0
    };
    const mousePanSensitivity = -3; // Negative to invert pan direction
    let fakeGestureTouched;
    let fakeGestureMoved;
    const evCache = [];
    const gesture = {
        originX: 0,
        originY: 0,
        slideEl: undefined,
        slideWidth: undefined,
        slideHeight: undefined,
        imageEl: undefined,
        imageWrapEl: undefined,
        maxRatio: 3
    };
    const image = {
        isTouched: undefined,
        isMoved: undefined,
        currentX: undefined,
        currentY: undefined,
        minX: undefined,
        minY: undefined,
        maxX: undefined,
        maxY: undefined,
        width: undefined,
        height: undefined,
        startX: undefined,
        startY: undefined,
        touchesStart: {},
        touchesCurrent: {}
    };
    const velocity = {
        x: undefined,
        y: undefined,
        prevPositionX: undefined,
        prevPositionY: undefined,
        prevTime: undefined
    };
    let scale = 1;
    Object.defineProperty(swiper.zoom, 'scale', {
        get () {
            return scale;
        },
        set (value) {
            if (scale !== value) {
                const imageEl = gesture.imageEl;
                const slideEl = gesture.slideEl;
                emit('zoomChange', value, imageEl, slideEl);
            }
            scale = value;
        }
    });
    function getDistanceBetweenTouches() {
        if (evCache.length < 2) return 1;
        const x1 = evCache[0].pageX;
        const y1 = evCache[0].pageY;
        const x2 = evCache[1].pageX;
        const y2 = evCache[1].pageY;
        const distance = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
        return distance;
    }
    function getMaxRatio() {
        const params = swiper.params.zoom;
        const maxRatio = gesture.imageWrapEl.getAttribute('data-swiper-zoom') || params.maxRatio;
        if (params.limitToOriginalSize && gesture.imageEl && gesture.imageEl.naturalWidth) {
            const imageMaxRatio = gesture.imageEl.naturalWidth / gesture.imageEl.offsetWidth;
            return Math.min(imageMaxRatio, maxRatio);
        }
        return maxRatio;
    }
    function getScaleOrigin() {
        if (evCache.length < 2) return {
            x: null,
            y: null
        };
        const box = gesture.imageEl.getBoundingClientRect();
        return [
            (evCache[0].pageX + (evCache[1].pageX - evCache[0].pageX) / 2 - box.x - window.scrollX) / currentScale,
            (evCache[0].pageY + (evCache[1].pageY - evCache[0].pageY) / 2 - box.y - window.scrollY) / currentScale
        ];
    }
    function getSlideSelector() {
        return swiper.isElement ? `swiper-slide` : `.${swiper.params.slideClass}`;
    }
    function eventWithinSlide(e) {
        const slideSelector = getSlideSelector();
        if (e.target.matches(slideSelector)) return true;
        if (swiper.slides.filter((slideEl)=>slideEl.contains(e.target)).length > 0) return true;
        return false;
    }
    function eventWithinZoomContainer(e) {
        const selector = `.${swiper.params.zoom.containerClass}`;
        if (e.target.matches(selector)) return true;
        if ([
            ...swiper.hostEl.querySelectorAll(selector)
        ].filter((containerEl)=>containerEl.contains(e.target)).length > 0) return true;
        return false;
    }
    // Events
    function onGestureStart(e) {
        if (e.pointerType === 'mouse') evCache.splice(0, evCache.length);
        if (!eventWithinSlide(e)) return;
        const params = swiper.params.zoom;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        evCache.push(e);
        if (evCache.length < 2) return;
        fakeGestureTouched = true;
        gesture.scaleStart = getDistanceBetweenTouches();
        if (!gesture.slideEl) {
            gesture.slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
            if (!gesture.slideEl) gesture.slideEl = swiper.slides[swiper.activeIndex];
            let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
            if (imageEl) imageEl = imageEl.querySelectorAll('picture, img, svg, canvas, .swiper-zoom-target')[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, $f97f33853a605dba$export$8b22cf2602fb60ce)(gesture.imageEl, `.${params.containerClass}`)[0];
            else gesture.imageWrapEl = undefined;
            if (!gesture.imageWrapEl) {
                gesture.imageEl = undefined;
                return;
            }
            gesture.maxRatio = getMaxRatio();
        }
        if (gesture.imageEl) {
            const [originX, originY] = getScaleOrigin();
            gesture.originX = originX;
            gesture.originY = originY;
            gesture.imageEl.style.transitionDuration = '0ms';
        }
        isScaling = true;
    }
    function onGestureChange(e) {
        if (!eventWithinSlide(e)) return;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        const pointerIndex = evCache.findIndex((cachedEv)=>cachedEv.pointerId === e.pointerId);
        if (pointerIndex >= 0) evCache[pointerIndex] = e;
        if (evCache.length < 2) return;
        fakeGestureMoved = true;
        gesture.scaleMove = getDistanceBetweenTouches();
        if (!gesture.imageEl) return;
        zoom.scale = gesture.scaleMove / gesture.scaleStart * currentScale;
        if (zoom.scale > gesture.maxRatio) zoom.scale = gesture.maxRatio - 1 + (zoom.scale - gesture.maxRatio + 1) ** 0.5;
        if (zoom.scale < params.minRatio) zoom.scale = params.minRatio + 1 - (params.minRatio - zoom.scale + 1) ** 0.5;
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
    }
    function onGestureEnd(e) {
        if (!eventWithinSlide(e)) return;
        if (e.pointerType === 'mouse' && e.type === 'pointerout') return;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        const pointerIndex = evCache.findIndex((cachedEv)=>cachedEv.pointerId === e.pointerId);
        if (pointerIndex >= 0) evCache.splice(pointerIndex, 1);
        if (!fakeGestureTouched || !fakeGestureMoved) return;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        if (!gesture.imageEl) return;
        zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
        gesture.imageEl.style.transitionDuration = `${swiper.params.speed}ms`;
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
        currentScale = zoom.scale;
        isScaling = false;
        if (zoom.scale > 1 && gesture.slideEl) gesture.slideEl.classList.add(`${params.zoomedSlideClass}`);
        else if (zoom.scale <= 1 && gesture.slideEl) gesture.slideEl.classList.remove(`${params.zoomedSlideClass}`);
        if (zoom.scale === 1) {
            gesture.originX = 0;
            gesture.originY = 0;
            gesture.slideEl = undefined;
        }
    }
    let allowTouchMoveTimeout;
    function allowTouchMove() {
        swiper.touchEventsData.preventTouchMoveFromPointerMove = false;
    }
    function preventTouchMove() {
        clearTimeout(allowTouchMoveTimeout);
        swiper.touchEventsData.preventTouchMoveFromPointerMove = true;
        allowTouchMoveTimeout = setTimeout(()=>{
            if (swiper.destroyed) return;
            allowTouchMove();
        });
    }
    function onTouchStart(e) {
        const device = swiper.device;
        if (!gesture.imageEl) return;
        if (image.isTouched) return;
        if (device.android && e.cancelable) e.preventDefault();
        image.isTouched = true;
        const event = evCache.length > 0 ? evCache[0] : e;
        image.touchesStart.x = event.pageX;
        image.touchesStart.y = event.pageY;
    }
    function onTouchMove(e) {
        const isMouseEvent = e.pointerType === 'mouse';
        const isMousePan = isMouseEvent && swiper.params.zoom.panOnMouseMove;
        if (!eventWithinSlide(e) || !eventWithinZoomContainer(e)) return;
        const zoom = swiper.zoom;
        if (!gesture.imageEl) return;
        if (!image.isTouched || !gesture.slideEl) {
            if (isMousePan) onMouseMove(e);
            return;
        }
        if (isMousePan) {
            onMouseMove(e);
            return;
        }
        if (!image.isMoved) {
            image.width = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
            image.height = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
            image.startX = (0, $f97f33853a605dba$export$342063e11d6c3cad)(gesture.imageWrapEl, 'x') || 0;
            image.startY = (0, $f97f33853a605dba$export$342063e11d6c3cad)(gesture.imageWrapEl, 'y') || 0;
            gesture.slideWidth = gesture.slideEl.offsetWidth;
            gesture.slideHeight = gesture.slideEl.offsetHeight;
            gesture.imageWrapEl.style.transitionDuration = '0ms';
        }
        // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.touchesCurrent.x = evCache.length > 0 ? evCache[0].pageX : e.pageX;
        image.touchesCurrent.y = evCache.length > 0 ? evCache[0].pageY : e.pageY;
        const touchesDiff = Math.max(Math.abs(image.touchesCurrent.x - image.touchesStart.x), Math.abs(image.touchesCurrent.y - image.touchesStart.y));
        if (touchesDiff > 5) swiper.allowClick = false;
        if (!image.isMoved && !isScaling) {
            if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
                image.isTouched = false;
                allowTouchMove();
                return;
            }
            if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
                image.isTouched = false;
                allowTouchMove();
                return;
            }
        }
        if (e.cancelable) e.preventDefault();
        e.stopPropagation();
        preventTouchMove();
        image.isMoved = true;
        const scaleRatio = (zoom.scale - currentScale) / (gesture.maxRatio - swiper.params.zoom.minRatio);
        const { originX: originX, originY: originY } = gesture;
        image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX + scaleRatio * (image.width - originX * 2);
        image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY + scaleRatio * (image.height - originY * 2);
        if (image.currentX < image.minX) image.currentX = image.minX + 1 - (image.minX - image.currentX + 1) ** 0.8;
        if (image.currentX > image.maxX) image.currentX = image.maxX - 1 + (image.currentX - image.maxX + 1) ** 0.8;
        if (image.currentY < image.minY) image.currentY = image.minY + 1 - (image.minY - image.currentY + 1) ** 0.8;
        if (image.currentY > image.maxY) image.currentY = image.maxY - 1 + (image.currentY - image.maxY + 1) ** 0.8;
        // Velocity
        if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
        if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
        if (!velocity.prevTime) velocity.prevTime = Date.now();
        velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
        velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
        if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
        if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
        velocity.prevPositionX = image.touchesCurrent.x;
        velocity.prevPositionY = image.touchesCurrent.y;
        velocity.prevTime = Date.now();
        gesture.imageWrapEl.style.transform = `translate3d(${image.currentX}px, ${image.currentY}px,0)`;
    }
    function onTouchEnd() {
        const zoom = swiper.zoom;
        evCache.length = 0;
        if (!gesture.imageEl) return;
        if (!image.isTouched || !image.isMoved) {
            image.isTouched = false;
            image.isMoved = false;
            return;
        }
        image.isTouched = false;
        image.isMoved = false;
        let momentumDurationX = 300;
        let momentumDurationY = 300;
        const momentumDistanceX = velocity.x * momentumDurationX;
        const newPositionX = image.currentX + momentumDistanceX;
        const momentumDistanceY = velocity.y * momentumDurationY;
        const newPositionY = image.currentY + momentumDistanceY;
        // Fix duration
        if (velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
        if (velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
        const momentumDuration = Math.max(momentumDurationX, momentumDurationY);
        image.currentX = newPositionX;
        image.currentY = newPositionY;
        // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
        image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
        gesture.imageWrapEl.style.transitionDuration = `${momentumDuration}ms`;
        gesture.imageWrapEl.style.transform = `translate3d(${image.currentX}px, ${image.currentY}px,0)`;
    }
    function onTransitionEnd() {
        const zoom = swiper.zoom;
        if (gesture.slideEl && swiper.activeIndex !== swiper.slides.indexOf(gesture.slideEl)) {
            if (gesture.imageEl) gesture.imageEl.style.transform = 'translate3d(0,0,0) scale(1)';
            if (gesture.imageWrapEl) gesture.imageWrapEl.style.transform = 'translate3d(0,0,0)';
            gesture.slideEl.classList.remove(`${swiper.params.zoom.zoomedSlideClass}`);
            zoom.scale = 1;
            currentScale = 1;
            gesture.slideEl = undefined;
            gesture.imageEl = undefined;
            gesture.imageWrapEl = undefined;
            gesture.originX = 0;
            gesture.originY = 0;
        }
    }
    function onMouseMove(e) {
        // Only pan if zoomed in and mouse panning is enabled
        if (currentScale <= 1 || !gesture.imageWrapEl) return;
        if (!eventWithinSlide(e) || !eventWithinZoomContainer(e)) return;
        const currentTransform = window.getComputedStyle(gesture.imageWrapEl).transform;
        const matrix = new window.DOMMatrix(currentTransform);
        if (!isPanningWithMouse) {
            isPanningWithMouse = true;
            mousePanStart.x = e.clientX;
            mousePanStart.y = e.clientY;
            image.startX = matrix.e;
            image.startY = matrix.f;
            image.width = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
            image.height = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
            gesture.slideWidth = gesture.slideEl.offsetWidth;
            gesture.slideHeight = gesture.slideEl.offsetHeight;
            return;
        }
        const deltaX = (e.clientX - mousePanStart.x) * mousePanSensitivity;
        const deltaY = (e.clientY - mousePanStart.y) * mousePanSensitivity;
        const scaledWidth = image.width * currentScale;
        const scaledHeight = image.height * currentScale;
        const slideWidth = gesture.slideWidth;
        const slideHeight = gesture.slideHeight;
        const minX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
        const maxX = -minX;
        const minY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
        const maxY = -minY;
        const newX = Math.max(Math.min(image.startX + deltaX, maxX), minX);
        const newY = Math.max(Math.min(image.startY + deltaY, maxY), minY);
        gesture.imageWrapEl.style.transitionDuration = '0ms';
        gesture.imageWrapEl.style.transform = `translate3d(${newX}px, ${newY}px, 0)`;
        mousePanStart.x = e.clientX;
        mousePanStart.y = e.clientY;
        image.startX = newX;
        image.startY = newY;
        image.currentX = newX;
        image.currentY = newY;
    }
    function zoomIn(e) {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.slideEl) {
            if (e && e.target) gesture.slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
            if (!gesture.slideEl) {
                if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.slideEl = (0, $f97f33853a605dba$export$f1e1789686576879)(swiper.slidesEl, `.${swiper.params.slideActiveClass}`)[0];
                else gesture.slideEl = swiper.slides[swiper.activeIndex];
            }
            let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
            if (imageEl) imageEl = imageEl.querySelectorAll('picture, img, svg, canvas, .swiper-zoom-target')[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, $f97f33853a605dba$export$8b22cf2602fb60ce)(gesture.imageEl, `.${params.containerClass}`)[0];
            else gesture.imageWrapEl = undefined;
        }
        if (!gesture.imageEl || !gesture.imageWrapEl) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = 'hidden';
            swiper.wrapperEl.style.touchAction = 'none';
        }
        gesture.slideEl.classList.add(`${params.zoomedSlideClass}`);
        let touchX;
        let touchY;
        let offsetX;
        let offsetY;
        let diffX;
        let diffY;
        let translateX;
        let translateY;
        let imageWidth;
        let imageHeight;
        let scaledWidth;
        let scaledHeight;
        let translateMinX;
        let translateMinY;
        let translateMaxX;
        let translateMaxY;
        let slideWidth;
        let slideHeight;
        if (typeof image.touchesStart.x === 'undefined' && e) {
            touchX = e.pageX;
            touchY = e.pageY;
        } else {
            touchX = image.touchesStart.x;
            touchY = image.touchesStart.y;
        }
        const prevScale = currentScale;
        const forceZoomRatio = typeof e === 'number' ? e : null;
        if (currentScale === 1 && forceZoomRatio) {
            touchX = undefined;
            touchY = undefined;
            image.touchesStart.x = undefined;
            image.touchesStart.y = undefined;
        }
        const maxRatio = getMaxRatio();
        zoom.scale = forceZoomRatio || maxRatio;
        currentScale = forceZoomRatio || maxRatio;
        if (e && !(currentScale === 1 && forceZoomRatio)) {
            slideWidth = gesture.slideEl.offsetWidth;
            slideHeight = gesture.slideEl.offsetHeight;
            offsetX = (0, $f97f33853a605dba$export$4368d992c4eafac0)(gesture.slideEl).left + window.scrollX;
            offsetY = (0, $f97f33853a605dba$export$4368d992c4eafac0)(gesture.slideEl).top + window.scrollY;
            diffX = offsetX + slideWidth / 2 - touchX;
            diffY = offsetY + slideHeight / 2 - touchY;
            imageWidth = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
            imageHeight = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
            scaledWidth = imageWidth * zoom.scale;
            scaledHeight = imageHeight * zoom.scale;
            translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
            translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
            translateMaxX = -translateMinX;
            translateMaxY = -translateMinY;
            if (prevScale > 0 && forceZoomRatio && typeof image.currentX === 'number' && typeof image.currentY === 'number') {
                translateX = image.currentX * zoom.scale / prevScale;
                translateY = image.currentY * zoom.scale / prevScale;
            } else {
                translateX = diffX * zoom.scale;
                translateY = diffY * zoom.scale;
            }
            if (translateX < translateMinX) translateX = translateMinX;
            if (translateX > translateMaxX) translateX = translateMaxX;
            if (translateY < translateMinY) translateY = translateMinY;
            if (translateY > translateMaxY) translateY = translateMaxY;
        } else {
            translateX = 0;
            translateY = 0;
        }
        if (forceZoomRatio && zoom.scale === 1) {
            gesture.originX = 0;
            gesture.originY = 0;
        }
        image.currentX = translateX;
        image.currentY = translateY;
        gesture.imageWrapEl.style.transitionDuration = '300ms';
        gesture.imageWrapEl.style.transform = `translate3d(${translateX}px, ${translateY}px,0)`;
        gesture.imageEl.style.transitionDuration = '300ms';
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
    }
    function zoomOut() {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.slideEl) {
            if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.slideEl = (0, $f97f33853a605dba$export$f1e1789686576879)(swiper.slidesEl, `.${swiper.params.slideActiveClass}`)[0];
            else gesture.slideEl = swiper.slides[swiper.activeIndex];
            let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
            if (imageEl) imageEl = imageEl.querySelectorAll('picture, img, svg, canvas, .swiper-zoom-target')[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, $f97f33853a605dba$export$8b22cf2602fb60ce)(gesture.imageEl, `.${params.containerClass}`)[0];
            else gesture.imageWrapEl = undefined;
        }
        if (!gesture.imageEl || !gesture.imageWrapEl) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = '';
            swiper.wrapperEl.style.touchAction = '';
        }
        zoom.scale = 1;
        currentScale = 1;
        image.currentX = undefined;
        image.currentY = undefined;
        image.touchesStart.x = undefined;
        image.touchesStart.y = undefined;
        gesture.imageWrapEl.style.transitionDuration = '300ms';
        gesture.imageWrapEl.style.transform = 'translate3d(0,0,0)';
        gesture.imageEl.style.transitionDuration = '300ms';
        gesture.imageEl.style.transform = 'translate3d(0,0,0) scale(1)';
        gesture.slideEl.classList.remove(`${params.zoomedSlideClass}`);
        gesture.slideEl = undefined;
        gesture.originX = 0;
        gesture.originY = 0;
        if (swiper.params.zoom.panOnMouseMove) {
            mousePanStart = {
                x: 0,
                y: 0
            };
            if (isPanningWithMouse) {
                isPanningWithMouse = false;
                image.startX = 0;
                image.startY = 0;
            }
        }
    }
    // Toggle Zoom
    function zoomToggle(e) {
        const zoom = swiper.zoom;
        if (zoom.scale && zoom.scale !== 1) // Zoom Out
        zoomOut();
        else // Zoom In
        zoomIn(e);
    }
    function getListeners() {
        const passiveListener = swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        const activeListenerWithCapture = swiper.params.passiveListeners ? {
            passive: false,
            capture: true
        } : true;
        return {
            passiveListener: passiveListener,
            activeListenerWithCapture: activeListenerWithCapture
        };
    }
    // Attach/Detach Events
    function enable() {
        const zoom = swiper.zoom;
        if (zoom.enabled) return;
        zoom.enabled = true;
        const { passiveListener: passiveListener, activeListenerWithCapture: activeListenerWithCapture } = getListeners();
        // Scale image
        swiper.wrapperEl.addEventListener('pointerdown', onGestureStart, passiveListener);
        swiper.wrapperEl.addEventListener('pointermove', onGestureChange, activeListenerWithCapture);
        [
            'pointerup',
            'pointercancel',
            'pointerout'
        ].forEach((eventName)=>{
            swiper.wrapperEl.addEventListener(eventName, onGestureEnd, passiveListener);
        });
        // Move image
        swiper.wrapperEl.addEventListener('pointermove', onTouchMove, activeListenerWithCapture);
    }
    function disable() {
        const zoom = swiper.zoom;
        if (!zoom.enabled) return;
        zoom.enabled = false;
        const { passiveListener: passiveListener, activeListenerWithCapture: activeListenerWithCapture } = getListeners();
        // Scale image
        swiper.wrapperEl.removeEventListener('pointerdown', onGestureStart, passiveListener);
        swiper.wrapperEl.removeEventListener('pointermove', onGestureChange, activeListenerWithCapture);
        [
            'pointerup',
            'pointercancel',
            'pointerout'
        ].forEach((eventName)=>{
            swiper.wrapperEl.removeEventListener(eventName, onGestureEnd, passiveListener);
        });
        // Move image
        swiper.wrapperEl.removeEventListener('pointermove', onTouchMove, activeListenerWithCapture);
    }
    on('init', ()=>{
        if (swiper.params.zoom.enabled) enable();
    });
    on('destroy', ()=>{
        disable();
    });
    on('touchStart', (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchStart(e);
    });
    on('touchEnd', (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchEnd();
    });
    on('doubleTap', (_s, e)=>{
        if (!swiper.animating && swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) zoomToggle(e);
    });
    on('transitionEnd', ()=>{
        if (swiper.zoom.enabled && swiper.params.zoom.enabled) onTransitionEnd();
    });
    on('slideChange', ()=>{
        if (swiper.zoom.enabled && swiper.params.zoom.enabled && swiper.params.cssMode) onTransitionEnd();
    });
    Object.assign(swiper.zoom, {
        enable: enable,
        disable: disable,
        in: zoomIn,
        out: zoomOut,
        toggle: zoomToggle
    });
}



/* eslint no-bitwise: ["error", { "allow": [">>"] }] */ function $4ee670f8e74e92c5$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        controller: {
            control: undefined,
            inverse: false,
            by: 'slide' // or 'container'
        }
    });
    swiper.controller = {
        control: undefined
    };
    function LinearSpline(x, y) {
        const binarySearch = function search() {
            let maxIndex;
            let minIndex;
            let guess;
            return (array, val)=>{
                minIndex = -1;
                maxIndex = array.length;
                while(maxIndex - minIndex > 1){
                    guess = maxIndex + minIndex >> 1;
                    if (array[guess] <= val) minIndex = guess;
                    else maxIndex = guess;
                }
                return maxIndex;
            };
        }();
        this.x = x;
        this.y = y;
        this.lastIndex = x.length - 1;
        // Given an x value (x2), return the expected y2 value:
        // (x1,y1) is the known point before given value,
        // (x3,y3) is the known point after given value.
        let i1;
        let i3;
        this.interpolate = function interpolate(x2) {
            if (!x2) return 0;
            // Get the indexes of x1 and x3 (the array indexes before and after given x2):
            i3 = binarySearch(this.x, x2);
            i1 = i3 - 1;
            // We have our indexes i1 & i3, so we can calculate already:
            // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
            return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
        };
        return this;
    }
    function getInterpolateFunction(c) {
        swiper.controller.spline = swiper.params.loop ? new LinearSpline(swiper.slidesGrid, c.slidesGrid) : new LinearSpline(swiper.snapGrid, c.snapGrid);
    }
    function setTranslate(_t, byController) {
        const controlled = swiper.controller.control;
        let multiplier;
        let controlledTranslate;
        const Swiper = swiper.constructor;
        function setControlledTranslate(c) {
            if (c.destroyed) return;
            // this will create an Interpolate function based on the snapGrids
            // x is the Grid of the scrolled scroller and y will be the controlled scroller
            // it makes sense to create this only once and recall it for the interpolation
            // the function does a lot of value caching for performance
            const translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
            if (swiper.params.controller.by === 'slide') {
                getInterpolateFunction(c);
                // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
                // but it did not work out
                controlledTranslate = -swiper.controller.spline.interpolate(-translate);
            }
            if (!controlledTranslate || swiper.params.controller.by === 'container') {
                multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
                if (Number.isNaN(multiplier) || !Number.isFinite(multiplier)) multiplier = 1;
                controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
            }
            if (swiper.params.controller.inverse) controlledTranslate = c.maxTranslate() - controlledTranslate;
            c.updateProgress(controlledTranslate);
            c.setTranslate(controlledTranslate, swiper);
            c.updateActiveIndex();
            c.updateSlidesClasses();
        }
        if (Array.isArray(controlled)) {
            for(let i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTranslate(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTranslate(controlled);
    }
    function setTransition(duration, byController) {
        const Swiper = swiper.constructor;
        const controlled = swiper.controller.control;
        let i;
        function setControlledTransition(c) {
            if (c.destroyed) return;
            c.setTransition(duration, swiper);
            if (duration !== 0) {
                c.transitionStart();
                if (c.params.autoHeight) (0, $f97f33853a605dba$export$7ccc53e8f1e7dfc5)(()=>{
                    c.updateAutoHeight();
                });
                (0, $f97f33853a605dba$export$882b5998b3b9117c)(c.wrapperEl, ()=>{
                    if (!controlled) return;
                    c.transitionEnd();
                });
            }
        }
        if (Array.isArray(controlled)) {
            for(i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTransition(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTransition(controlled);
    }
    function removeSpline() {
        if (!swiper.controller.control) return;
        if (swiper.controller.spline) {
            swiper.controller.spline = undefined;
            delete swiper.controller.spline;
        }
    }
    on('beforeInit', ()=>{
        if (typeof window !== 'undefined' && // eslint-disable-line
        (typeof swiper.params.controller.control === 'string' || swiper.params.controller.control instanceof HTMLElement)) {
            const controlElements = typeof swiper.params.controller.control === 'string' ? [
                ...document.querySelectorAll(swiper.params.controller.control)
            ] : [
                swiper.params.controller.control
            ];
            controlElements.forEach((controlElement)=>{
                if (!swiper.controller.control) swiper.controller.control = [];
                if (controlElement && controlElement.swiper) swiper.controller.control.push(controlElement.swiper);
                else if (controlElement) {
                    const eventName = `${swiper.params.eventsPrefix}init`;
                    const onControllerSwiper = (e)=>{
                        swiper.controller.control.push(e.detail[0]);
                        swiper.update();
                        controlElement.removeEventListener(eventName, onControllerSwiper);
                    };
                    controlElement.addEventListener(eventName, onControllerSwiper);
                }
            });
            return;
        }
        swiper.controller.control = swiper.params.controller.control;
    });
    on('update', ()=>{
        removeSpline();
    });
    on('resize', ()=>{
        removeSpline();
    });
    on('observerUpdate', ()=>{
        removeSpline();
    });
    on('setTranslate', (_s, translate, byController)=>{
        if (!swiper.controller.control || swiper.controller.control.destroyed) return;
        swiper.controller.setTranslate(translate, byController);
    });
    on('setTransition', (_s, duration, byController)=>{
        if (!swiper.controller.control || swiper.controller.control.destroyed) return;
        swiper.controller.setTransition(duration, byController);
    });
    Object.assign(swiper.controller, {
        setTranslate: setTranslate,
        setTransition: setTransition
    });
}





function $9df471290665e5ad$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        a11y: {
            enabled: true,
            notificationClass: 'swiper-notification',
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
            firstSlideMessage: 'This is the first slide',
            lastSlideMessage: 'This is the last slide',
            paginationBulletMessage: 'Go to slide {{index}}',
            slideLabelMessage: '{{index}} / {{slidesLength}}',
            containerMessage: null,
            containerRoleDescriptionMessage: null,
            containerRole: null,
            itemRoleDescriptionMessage: null,
            slideRole: 'group',
            id: null,
            scrollOnFocus: true
        }
    });
    swiper.a11y = {
        clicked: false
    };
    let liveRegion = null;
    let preventFocusHandler;
    let focusTargetSlideEl;
    let visibilityChangedTimestamp = new Date().getTime();
    function notify(message) {
        const notification = liveRegion;
        if (notification.length === 0) return;
        (0, $f97f33853a605dba$export$2408f22a0fab9ae5)(notification, message);
    }
    function getRandomNumber(size) {
        if (size === void 0) size = 16;
        const randomChar = ()=>Math.round(16 * Math.random()).toString(16);
        return 'x'.repeat(size).replace(/x/g, randomChar);
    }
    function makeElFocusable(el) {
        el = (0, $f97f33853a605dba$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('tabIndex', '0');
        });
    }
    function makeElNotFocusable(el) {
        el = (0, $f97f33853a605dba$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('tabIndex', '-1');
        });
    }
    function addElRole(el, role) {
        el = (0, $f97f33853a605dba$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('role', role);
        });
    }
    function addElRoleDescription(el, description) {
        el = (0, $f97f33853a605dba$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('aria-roledescription', description);
        });
    }
    function addElControls(el, controls) {
        el = (0, $f97f33853a605dba$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('aria-controls', controls);
        });
    }
    function addElLabel(el, label) {
        el = (0, $f97f33853a605dba$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('aria-label', label);
        });
    }
    function addElId(el, id) {
        el = (0, $f97f33853a605dba$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('id', id);
        });
    }
    function addElLive(el, live) {
        el = (0, $f97f33853a605dba$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('aria-live', live);
        });
    }
    function disableEl(el) {
        el = (0, $f97f33853a605dba$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('aria-disabled', true);
        });
    }
    function enableEl(el) {
        el = (0, $f97f33853a605dba$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('aria-disabled', false);
        });
    }
    function onEnterOrSpaceKey(e) {
        if (e.keyCode !== 13 && e.keyCode !== 32) return;
        const params = swiper.params.a11y;
        const targetEl = e.target;
        if (swiper.pagination && swiper.pagination.el && (targetEl === swiper.pagination.el || swiper.pagination.el.contains(e.target))) {
            if (!e.target.matches((0, $129272ba76d8b432$export$db3b6bfb95261072)(swiper.params.pagination.bulletClass))) return;
        }
        if (swiper.navigation && swiper.navigation.prevEl && swiper.navigation.nextEl) {
            const prevEls = (0, $f97f33853a605dba$export$953cecd6e717a553)(swiper.navigation.prevEl);
            const nextEls = (0, $f97f33853a605dba$export$953cecd6e717a553)(swiper.navigation.nextEl);
            if (nextEls.includes(targetEl)) {
                if (!(swiper.isEnd && !swiper.params.loop)) swiper.slideNext();
                if (swiper.isEnd) notify(params.lastSlideMessage);
                else notify(params.nextSlideMessage);
            }
            if (prevEls.includes(targetEl)) {
                if (!(swiper.isBeginning && !swiper.params.loop)) swiper.slidePrev();
                if (swiper.isBeginning) notify(params.firstSlideMessage);
                else notify(params.prevSlideMessage);
            }
        }
        if (swiper.pagination && targetEl.matches((0, $129272ba76d8b432$export$db3b6bfb95261072)(swiper.params.pagination.bulletClass))) targetEl.click();
    }
    function updateNavigation() {
        if (swiper.params.loop || swiper.params.rewind || !swiper.navigation) return;
        const { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        if (prevEl) {
            if (swiper.isBeginning) {
                disableEl(prevEl);
                makeElNotFocusable(prevEl);
            } else {
                enableEl(prevEl);
                makeElFocusable(prevEl);
            }
        }
        if (nextEl) {
            if (swiper.isEnd) {
                disableEl(nextEl);
                makeElNotFocusable(nextEl);
            } else {
                enableEl(nextEl);
                makeElFocusable(nextEl);
            }
        }
    }
    function hasPagination() {
        return swiper.pagination && swiper.pagination.bullets && swiper.pagination.bullets.length;
    }
    function hasClickablePagination() {
        return hasPagination() && swiper.params.pagination.clickable;
    }
    function updatePagination() {
        const params = swiper.params.a11y;
        if (!hasPagination()) return;
        swiper.pagination.bullets.forEach((bulletEl)=>{
            if (swiper.params.pagination.clickable) {
                makeElFocusable(bulletEl);
                if (!swiper.params.pagination.renderBullet) {
                    addElRole(bulletEl, 'button');
                    addElLabel(bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, (0, $f97f33853a605dba$export$23f2a1d2818174ef)(bulletEl) + 1));
                }
            }
            if (bulletEl.matches((0, $129272ba76d8b432$export$db3b6bfb95261072)(swiper.params.pagination.bulletActiveClass))) bulletEl.setAttribute('aria-current', 'true');
            else bulletEl.removeAttribute('aria-current');
        });
    }
    const initNavEl = (el, wrapperId, message)=>{
        makeElFocusable(el);
        if (el.tagName !== 'BUTTON') {
            addElRole(el, 'button');
            el.addEventListener('keydown', onEnterOrSpaceKey);
        }
        addElLabel(el, message);
        addElControls(el, wrapperId);
    };
    const handlePointerDown = (e)=>{
        if (focusTargetSlideEl && focusTargetSlideEl !== e.target && !focusTargetSlideEl.contains(e.target)) preventFocusHandler = true;
        swiper.a11y.clicked = true;
    };
    const handlePointerUp = ()=>{
        preventFocusHandler = false;
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!swiper.destroyed) swiper.a11y.clicked = false;
            });
        });
    };
    const onVisibilityChange = (e)=>{
        visibilityChangedTimestamp = new Date().getTime();
    };
    const handleFocus = (e)=>{
        if (swiper.a11y.clicked || !swiper.params.a11y.scrollOnFocus) return;
        if (new Date().getTime() - visibilityChangedTimestamp < 100) return;
        const slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
        if (!slideEl || !swiper.slides.includes(slideEl)) return;
        focusTargetSlideEl = slideEl;
        const isActive = swiper.slides.indexOf(slideEl) === swiper.activeIndex;
        const isVisible = swiper.params.watchSlidesProgress && swiper.visibleSlides && swiper.visibleSlides.includes(slideEl);
        if (isActive || isVisible) return;
        if (e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents) return;
        if (swiper.isHorizontal()) swiper.el.scrollLeft = 0;
        else swiper.el.scrollTop = 0;
        requestAnimationFrame(()=>{
            if (preventFocusHandler) return;
            if (swiper.params.loop) swiper.slideToLoop(swiper.getSlideIndexWhenGrid(parseInt(slideEl.getAttribute('data-swiper-slide-index'))), 0);
            else swiper.slideTo(swiper.getSlideIndexWhenGrid(swiper.slides.indexOf(slideEl)), 0);
            preventFocusHandler = false;
        });
    };
    const initSlides = ()=>{
        const params = swiper.params.a11y;
        if (params.itemRoleDescriptionMessage) addElRoleDescription(swiper.slides, params.itemRoleDescriptionMessage);
        if (params.slideRole) addElRole(swiper.slides, params.slideRole);
        const slidesLength = swiper.slides.length;
        if (params.slideLabelMessage) swiper.slides.forEach((slideEl, index)=>{
            const slideIndex = swiper.params.loop ? parseInt(slideEl.getAttribute('data-swiper-slide-index'), 10) : index;
            const ariaLabelMessage = params.slideLabelMessage.replace(/\{\{index\}\}/, slideIndex + 1).replace(/\{\{slidesLength\}\}/, slidesLength);
            addElLabel(slideEl, ariaLabelMessage);
        });
    };
    const init = ()=>{
        const params = swiper.params.a11y;
        swiper.el.append(liveRegion);
        // Container
        const containerEl = swiper.el;
        if (params.containerRoleDescriptionMessage) addElRoleDescription(containerEl, params.containerRoleDescriptionMessage);
        if (params.containerMessage) addElLabel(containerEl, params.containerMessage);
        if (params.containerRole) addElRole(containerEl, params.containerRole);
        // Wrapper
        const wrapperEl = swiper.wrapperEl;
        const wrapperId = params.id || wrapperEl.getAttribute('id') || `swiper-wrapper-${getRandomNumber(16)}`;
        const live = swiper.params.autoplay && swiper.params.autoplay.enabled ? 'off' : 'polite';
        addElId(wrapperEl, wrapperId);
        addElLive(wrapperEl, live);
        // Slide
        initSlides();
        // Navigation
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation ? swiper.navigation : {};
        nextEl = (0, $f97f33853a605dba$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $f97f33853a605dba$export$953cecd6e717a553)(prevEl);
        if (nextEl) nextEl.forEach((el)=>initNavEl(el, wrapperId, params.nextSlideMessage));
        if (prevEl) prevEl.forEach((el)=>initNavEl(el, wrapperId, params.prevSlideMessage));
        // Pagination
        if (hasClickablePagination()) {
            const paginationEl = (0, $f97f33853a605dba$export$953cecd6e717a553)(swiper.pagination.el);
            paginationEl.forEach((el)=>{
                el.addEventListener('keydown', onEnterOrSpaceKey);
            });
        }
        // Tab focus
        const document = (0, $0868fe5596dee114$export$39b482c5e57630a8)();
        document.addEventListener('visibilitychange', onVisibilityChange);
        swiper.el.addEventListener('focus', handleFocus, true);
        swiper.el.addEventListener('focus', handleFocus, true);
        swiper.el.addEventListener('pointerdown', handlePointerDown, true);
        swiper.el.addEventListener('pointerup', handlePointerUp, true);
    };
    function destroy() {
        if (liveRegion) liveRegion.remove();
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation ? swiper.navigation : {};
        nextEl = (0, $f97f33853a605dba$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $f97f33853a605dba$export$953cecd6e717a553)(prevEl);
        if (nextEl) nextEl.forEach((el)=>el.removeEventListener('keydown', onEnterOrSpaceKey));
        if (prevEl) prevEl.forEach((el)=>el.removeEventListener('keydown', onEnterOrSpaceKey));
        // Pagination
        if (hasClickablePagination()) {
            const paginationEl = (0, $f97f33853a605dba$export$953cecd6e717a553)(swiper.pagination.el);
            paginationEl.forEach((el)=>{
                el.removeEventListener('keydown', onEnterOrSpaceKey);
            });
        }
        const document = (0, $0868fe5596dee114$export$39b482c5e57630a8)();
        document.removeEventListener('visibilitychange', onVisibilityChange);
        // Tab focus
        if (swiper.el && typeof swiper.el !== 'string') {
            swiper.el.removeEventListener('focus', handleFocus, true);
            swiper.el.removeEventListener('pointerdown', handlePointerDown, true);
            swiper.el.removeEventListener('pointerup', handlePointerUp, true);
        }
    }
    on('beforeInit', ()=>{
        liveRegion = (0, $f97f33853a605dba$export$db3b6bfb95261072)('span', swiper.params.a11y.notificationClass);
        liveRegion.setAttribute('aria-live', 'assertive');
        liveRegion.setAttribute('aria-atomic', 'true');
    });
    on('afterInit', ()=>{
        if (!swiper.params.a11y.enabled) return;
        init();
    });
    on('slidesLengthChange snapGridLengthChange slidesGridLengthChange', ()=>{
        if (!swiper.params.a11y.enabled) return;
        initSlides();
    });
    on('fromEdge toEdge afterInit lock unlock', ()=>{
        if (!swiper.params.a11y.enabled) return;
        updateNavigation();
    });
    on('paginationUpdate', ()=>{
        if (!swiper.params.a11y.enabled) return;
        updatePagination();
    });
    on('destroy', ()=>{
        if (!swiper.params.a11y.enabled) return;
        destroy();
    });
}



function $bdde5ed48a8716dc$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        history: {
            enabled: false,
            root: '',
            replaceState: false,
            key: 'slides',
            keepQuery: false
        }
    });
    let initialized = false;
    let paths = {};
    const slugify = (text)=>{
        return text.toString().replace(/\s+/g, '-').replace(/[^\w-]+/g, '').replace(/--+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
    };
    const getPathValues = (urlOverride)=>{
        const window = (0, $0868fe5596dee114$export$407448d2b89b1813)();
        let location;
        if (urlOverride) location = new URL(urlOverride);
        else location = window.location;
        const pathArray = location.pathname.slice(1).split('/').filter((part)=>part !== '');
        const total = pathArray.length;
        const key = pathArray[total - 2];
        const value = pathArray[total - 1];
        return {
            key: key,
            value: value
        };
    };
    const setHistory = (key, index)=>{
        const window = (0, $0868fe5596dee114$export$407448d2b89b1813)();
        if (!initialized || !swiper.params.history.enabled) return;
        let location;
        if (swiper.params.url) location = new URL(swiper.params.url);
        else location = window.location;
        const slide = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${index}"]`) : swiper.slides[index];
        let value = slugify(slide.getAttribute('data-history'));
        if (swiper.params.history.root.length > 0) {
            let root = swiper.params.history.root;
            if (root[root.length - 1] === '/') root = root.slice(0, root.length - 1);
            value = `${root}/${key ? `${key}/` : ''}${value}`;
        } else if (!location.pathname.includes(key)) value = `${key ? `${key}/` : ''}${value}`;
        if (swiper.params.history.keepQuery) value += location.search;
        const currentState = window.history.state;
        if (currentState && currentState.value === value) return;
        if (swiper.params.history.replaceState) window.history.replaceState({
            value: value
        }, null, value);
        else window.history.pushState({
            value: value
        }, null, value);
    };
    const scrollToSlide = (speed, value, runCallbacks)=>{
        if (value) for(let i = 0, length = swiper.slides.length; i < length; i += 1){
            const slide = swiper.slides[i];
            const slideHistory = slugify(slide.getAttribute('data-history'));
            if (slideHistory === value) {
                const index = swiper.getSlideIndex(slide);
                swiper.slideTo(index, speed, runCallbacks);
            }
        }
        else swiper.slideTo(0, speed, runCallbacks);
    };
    const setHistoryPopState = ()=>{
        paths = getPathValues(swiper.params.url);
        scrollToSlide(swiper.params.speed, paths.value, false);
    };
    const init = ()=>{
        const window = (0, $0868fe5596dee114$export$407448d2b89b1813)();
        if (!swiper.params.history) return;
        if (!window.history || !window.history.pushState) {
            swiper.params.history.enabled = false;
            swiper.params.hashNavigation.enabled = true;
            return;
        }
        initialized = true;
        paths = getPathValues(swiper.params.url);
        if (!paths.key && !paths.value) {
            if (!swiper.params.history.replaceState) window.addEventListener('popstate', setHistoryPopState);
            return;
        }
        scrollToSlide(0, paths.value, swiper.params.runCallbacksOnInit);
        if (!swiper.params.history.replaceState) window.addEventListener('popstate', setHistoryPopState);
    };
    const destroy = ()=>{
        const window = (0, $0868fe5596dee114$export$407448d2b89b1813)();
        if (!swiper.params.history.replaceState) window.removeEventListener('popstate', setHistoryPopState);
    };
    on('init', ()=>{
        if (swiper.params.history.enabled) init();
    });
    on('destroy', ()=>{
        if (swiper.params.history.enabled) destroy();
    });
    on('transitionEnd _freeModeNoMomentumRelease', ()=>{
        if (initialized) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
    on('slideChange', ()=>{
        if (initialized && swiper.params.cssMode) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
}




function $900bed1a87b88621$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, emit: emit, on: on } = _ref;
    let initialized = false;
    const document = (0, $0868fe5596dee114$export$39b482c5e57630a8)();
    const window = (0, $0868fe5596dee114$export$407448d2b89b1813)();
    extendParams({
        hashNavigation: {
            enabled: false,
            replaceState: false,
            watchState: false,
            getSlideIndex (_s, hash) {
                if (swiper.virtual && swiper.params.virtual.enabled) {
                    const slideWithHash = swiper.slides.find((slideEl)=>slideEl.getAttribute('data-hash') === hash);
                    if (!slideWithHash) return 0;
                    const index = parseInt(slideWithHash.getAttribute('data-swiper-slide-index'), 10);
                    return index;
                }
                return swiper.getSlideIndex((0, $f97f33853a605dba$export$f1e1789686576879)(swiper.slidesEl, `.${swiper.params.slideClass}[data-hash="${hash}"], swiper-slide[data-hash="${hash}"]`)[0]);
            }
        }
    });
    const onHashChange = ()=>{
        emit('hashChange');
        const newHash = document.location.hash.replace('#', '');
        const activeSlideEl = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${swiper.activeIndex}"]`) : swiper.slides[swiper.activeIndex];
        const activeSlideHash = activeSlideEl ? activeSlideEl.getAttribute('data-hash') : '';
        if (newHash !== activeSlideHash) {
            const newIndex = swiper.params.hashNavigation.getSlideIndex(swiper, newHash);
            if (typeof newIndex === 'undefined' || Number.isNaN(newIndex)) return;
            swiper.slideTo(newIndex);
        }
    };
    const setHash = ()=>{
        if (!initialized || !swiper.params.hashNavigation.enabled) return;
        const activeSlideEl = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${swiper.activeIndex}"]`) : swiper.slides[swiper.activeIndex];
        const activeSlideHash = activeSlideEl ? activeSlideEl.getAttribute('data-hash') || activeSlideEl.getAttribute('data-history') : '';
        if (swiper.params.hashNavigation.replaceState && window.history && window.history.replaceState) {
            window.history.replaceState(null, null, `#${activeSlideHash}` || '');
            emit('hashSet');
        } else {
            document.location.hash = activeSlideHash || '';
            emit('hashSet');
        }
    };
    const init = ()=>{
        if (!swiper.params.hashNavigation.enabled || swiper.params.history && swiper.params.history.enabled) return;
        initialized = true;
        const hash = document.location.hash.replace('#', '');
        if (hash) {
            const speed = 0;
            const index = swiper.params.hashNavigation.getSlideIndex(swiper, hash);
            swiper.slideTo(index || 0, speed, swiper.params.runCallbacksOnInit, true);
        }
        if (swiper.params.hashNavigation.watchState) window.addEventListener('hashchange', onHashChange);
    };
    const destroy = ()=>{
        if (swiper.params.hashNavigation.watchState) window.removeEventListener('hashchange', onHashChange);
    };
    on('init', ()=>{
        if (swiper.params.hashNavigation.enabled) init();
    });
    on('destroy', ()=>{
        if (swiper.params.hashNavigation.enabled) destroy();
    });
    on('transitionEnd _freeModeNoMomentumRelease', ()=>{
        if (initialized) setHash();
    });
    on('slideChange', ()=>{
        if (initialized && swiper.params.cssMode) setHash();
    });
}



/* eslint no-underscore-dangle: "off" */ /* eslint no-use-before-define: "off" */ function $ccf162aef171d9ed$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit, params: params } = _ref;
    swiper.autoplay = {
        running: false,
        paused: false,
        timeLeft: 0
    };
    extendParams({
        autoplay: {
            enabled: false,
            delay: 3000,
            waitForTransition: true,
            disableOnInteraction: false,
            stopOnLastSlide: false,
            reverseDirection: false,
            pauseOnMouseEnter: false
        }
    });
    let timeout;
    let raf;
    let autoplayDelayTotal = params && params.autoplay ? params.autoplay.delay : 3000;
    let autoplayDelayCurrent = params && params.autoplay ? params.autoplay.delay : 3000;
    let autoplayTimeLeft;
    let autoplayStartTime = new Date().getTime();
    let wasPaused;
    let isTouched;
    let pausedByTouch;
    let touchStartTimeout;
    let slideChanged;
    let pausedByInteraction;
    let pausedByPointerEnter;
    function onTransitionEnd(e) {
        if (!swiper || swiper.destroyed || !swiper.wrapperEl) return;
        if (e.target !== swiper.wrapperEl) return;
        swiper.wrapperEl.removeEventListener('transitionend', onTransitionEnd);
        if (pausedByPointerEnter || e.detail && e.detail.bySwiperTouchMove) return;
        resume();
    }
    const calcTimeLeft = ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (swiper.autoplay.paused) wasPaused = true;
        else if (wasPaused) {
            autoplayDelayCurrent = autoplayTimeLeft;
            wasPaused = false;
        }
        const timeLeft = swiper.autoplay.paused ? autoplayTimeLeft : autoplayStartTime + autoplayDelayCurrent - new Date().getTime();
        swiper.autoplay.timeLeft = timeLeft;
        emit('autoplayTimeLeft', timeLeft, timeLeft / autoplayDelayTotal);
        raf = requestAnimationFrame(()=>{
            calcTimeLeft();
        });
    };
    const getSlideDelay = ()=>{
        let activeSlideEl;
        if (swiper.virtual && swiper.params.virtual.enabled) activeSlideEl = swiper.slides.find((slideEl)=>slideEl.classList.contains('swiper-slide-active'));
        else activeSlideEl = swiper.slides[swiper.activeIndex];
        if (!activeSlideEl) return undefined;
        const currentSlideDelay = parseInt(activeSlideEl.getAttribute('data-swiper-autoplay'), 10);
        return currentSlideDelay;
    };
    const run = (delayForce)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        cancelAnimationFrame(raf);
        calcTimeLeft();
        let delay = typeof delayForce === 'undefined' ? swiper.params.autoplay.delay : delayForce;
        autoplayDelayTotal = swiper.params.autoplay.delay;
        autoplayDelayCurrent = swiper.params.autoplay.delay;
        const currentSlideDelay = getSlideDelay();
        if (!Number.isNaN(currentSlideDelay) && currentSlideDelay > 0 && typeof delayForce === 'undefined') {
            delay = currentSlideDelay;
            autoplayDelayTotal = currentSlideDelay;
            autoplayDelayCurrent = currentSlideDelay;
        }
        autoplayTimeLeft = delay;
        const speed = swiper.params.speed;
        const proceed = ()=>{
            if (!swiper || swiper.destroyed) return;
            if (swiper.params.autoplay.reverseDirection) {
                if (!swiper.isBeginning || swiper.params.loop || swiper.params.rewind) {
                    swiper.slidePrev(speed, true, true);
                    emit('autoplay');
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    swiper.slideTo(swiper.slides.length - 1, speed, true, true);
                    emit('autoplay');
                }
            } else {
                if (!swiper.isEnd || swiper.params.loop || swiper.params.rewind) {
                    swiper.slideNext(speed, true, true);
                    emit('autoplay');
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    swiper.slideTo(0, speed, true, true);
                    emit('autoplay');
                }
            }
            if (swiper.params.cssMode) {
                autoplayStartTime = new Date().getTime();
                requestAnimationFrame(()=>{
                    run();
                });
            }
        };
        if (delay > 0) {
            clearTimeout(timeout);
            timeout = setTimeout(()=>{
                proceed();
            }, delay);
        } else requestAnimationFrame(()=>{
            proceed();
        });
        // eslint-disable-next-line
        return delay;
    };
    const start = ()=>{
        autoplayStartTime = new Date().getTime();
        swiper.autoplay.running = true;
        run();
        emit('autoplayStart');
    };
    const stop = ()=>{
        swiper.autoplay.running = false;
        clearTimeout(timeout);
        cancelAnimationFrame(raf);
        emit('autoplayStop');
    };
    const pause = (internal, reset)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        clearTimeout(timeout);
        if (!internal) pausedByInteraction = true;
        const proceed = ()=>{
            emit('autoplayPause');
            if (swiper.params.autoplay.waitForTransition) swiper.wrapperEl.addEventListener('transitionend', onTransitionEnd);
            else resume();
        };
        swiper.autoplay.paused = true;
        if (reset) {
            if (slideChanged) autoplayTimeLeft = swiper.params.autoplay.delay;
            slideChanged = false;
            proceed();
            return;
        }
        const delay = autoplayTimeLeft || swiper.params.autoplay.delay;
        autoplayTimeLeft = delay - (new Date().getTime() - autoplayStartTime);
        if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop) return;
        if (autoplayTimeLeft < 0) autoplayTimeLeft = 0;
        proceed();
    };
    const resume = ()=>{
        if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop || swiper.destroyed || !swiper.autoplay.running) return;
        autoplayStartTime = new Date().getTime();
        if (pausedByInteraction) {
            pausedByInteraction = false;
            run(autoplayTimeLeft);
        } else run();
        swiper.autoplay.paused = false;
        emit('autoplayResume');
    };
    const onVisibilityChange = ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        const document = (0, $0868fe5596dee114$export$39b482c5e57630a8)();
        if (document.visibilityState === 'hidden') {
            pausedByInteraction = true;
            pause(true);
        }
        if (document.visibilityState === 'visible') resume();
    };
    const onPointerEnter = (e)=>{
        if (e.pointerType !== 'mouse') return;
        pausedByInteraction = true;
        pausedByPointerEnter = true;
        if (swiper.animating || swiper.autoplay.paused) return;
        pause(true);
    };
    const onPointerLeave = (e)=>{
        if (e.pointerType !== 'mouse') return;
        pausedByPointerEnter = false;
        if (swiper.autoplay.paused) resume();
    };
    const attachMouseEvents = ()=>{
        if (swiper.params.autoplay.pauseOnMouseEnter) {
            swiper.el.addEventListener('pointerenter', onPointerEnter);
            swiper.el.addEventListener('pointerleave', onPointerLeave);
        }
    };
    const detachMouseEvents = ()=>{
        if (swiper.el && typeof swiper.el !== 'string') {
            swiper.el.removeEventListener('pointerenter', onPointerEnter);
            swiper.el.removeEventListener('pointerleave', onPointerLeave);
        }
    };
    const attachDocumentEvents = ()=>{
        const document = (0, $0868fe5596dee114$export$39b482c5e57630a8)();
        document.addEventListener('visibilitychange', onVisibilityChange);
    };
    const detachDocumentEvents = ()=>{
        const document = (0, $0868fe5596dee114$export$39b482c5e57630a8)();
        document.removeEventListener('visibilitychange', onVisibilityChange);
    };
    on('init', ()=>{
        if (swiper.params.autoplay.enabled) {
            attachMouseEvents();
            attachDocumentEvents();
            start();
        }
    });
    on('destroy', ()=>{
        detachMouseEvents();
        detachDocumentEvents();
        if (swiper.autoplay.running) stop();
    });
    on('_freeModeStaticRelease', ()=>{
        if (pausedByTouch || pausedByInteraction) resume();
    });
    on('_freeModeNoMomentumRelease', ()=>{
        if (!swiper.params.autoplay.disableOnInteraction) pause(true, true);
        else stop();
    });
    on('beforeTransitionStart', (_s, speed, internal)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (internal || !swiper.params.autoplay.disableOnInteraction) pause(true, true);
        else stop();
    });
    on('sliderFirstMove', ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (swiper.params.autoplay.disableOnInteraction) {
            stop();
            return;
        }
        isTouched = true;
        pausedByTouch = false;
        pausedByInteraction = false;
        touchStartTimeout = setTimeout(()=>{
            pausedByInteraction = true;
            pausedByTouch = true;
            pause(true);
        }, 200);
    });
    on('touchEnd', ()=>{
        if (swiper.destroyed || !swiper.autoplay.running || !isTouched) return;
        clearTimeout(touchStartTimeout);
        clearTimeout(timeout);
        if (swiper.params.autoplay.disableOnInteraction) {
            pausedByTouch = false;
            isTouched = false;
            return;
        }
        if (pausedByTouch && swiper.params.cssMode) resume();
        pausedByTouch = false;
        isTouched = false;
    });
    on('slideChange', ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        slideChanged = true;
    });
    Object.assign(swiper.autoplay, {
        start: start,
        stop: stop,
        pause: pause,
        resume: resume
    });
}




function $8051f561d9b02add$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        thumbs: {
            swiper: null,
            multipleActiveThumbs: true,
            autoScrollOffset: 0,
            slideThumbActiveClass: 'swiper-slide-thumb-active',
            thumbsContainerClass: 'swiper-thumbs'
        }
    });
    let initialized = false;
    let swiperCreated = false;
    swiper.thumbs = {
        swiper: null
    };
    function onThumbClick() {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const clickedIndex = thumbsSwiper.clickedIndex;
        const clickedSlide = thumbsSwiper.clickedSlide;
        if (clickedSlide && clickedSlide.classList.contains(swiper.params.thumbs.slideThumbActiveClass)) return;
        if (typeof clickedIndex === 'undefined' || clickedIndex === null) return;
        let slideToIndex;
        if (thumbsSwiper.params.loop) slideToIndex = parseInt(thumbsSwiper.clickedSlide.getAttribute('data-swiper-slide-index'), 10);
        else slideToIndex = clickedIndex;
        if (swiper.params.loop) swiper.slideToLoop(slideToIndex);
        else swiper.slideTo(slideToIndex);
    }
    function init() {
        const { thumbs: thumbsParams } = swiper.params;
        if (initialized) return false;
        initialized = true;
        const SwiperClass = swiper.constructor;
        if (thumbsParams.swiper instanceof SwiperClass) {
            if (thumbsParams.swiper.destroyed) {
                initialized = false;
                return false;
            }
            swiper.thumbs.swiper = thumbsParams.swiper;
            Object.assign(swiper.thumbs.swiper.originalParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            Object.assign(swiper.thumbs.swiper.params, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper.update();
        } else if ((0, $f97f33853a605dba$export$ae1af26003f05816)(thumbsParams.swiper)) {
            const thumbsSwiperParams = Object.assign({}, thumbsParams.swiper);
            Object.assign(thumbsSwiperParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper = new SwiperClass(thumbsSwiperParams);
            swiperCreated = true;
        }
        swiper.thumbs.swiper.el.classList.add(swiper.params.thumbs.thumbsContainerClass);
        swiper.thumbs.swiper.on('tap', onThumbClick);
        return true;
    }
    function update(initial) {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const slidesPerView = thumbsSwiper.params.slidesPerView === 'auto' ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView;
        // Activate thumbs
        let thumbsToActivate = 1;
        const thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;
        if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) thumbsToActivate = swiper.params.slidesPerView;
        if (!swiper.params.thumbs.multipleActiveThumbs) thumbsToActivate = 1;
        thumbsToActivate = Math.floor(thumbsToActivate);
        thumbsSwiper.slides.forEach((slideEl)=>slideEl.classList.remove(thumbActiveClass));
        if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled) for(let i = 0; i < thumbsToActivate; i += 1)(0, $f97f33853a605dba$export$f1e1789686576879)(thumbsSwiper.slidesEl, `[data-swiper-slide-index="${swiper.realIndex + i}"]`).forEach((slideEl)=>{
            slideEl.classList.add(thumbActiveClass);
        });
        else {
            for(let i = 0; i < thumbsToActivate; i += 1)if (thumbsSwiper.slides[swiper.realIndex + i]) thumbsSwiper.slides[swiper.realIndex + i].classList.add(thumbActiveClass);
        }
        const autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
        const useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
        if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
            const currentThumbsIndex = thumbsSwiper.activeIndex;
            let newThumbsIndex;
            let direction;
            if (thumbsSwiper.params.loop) {
                const newThumbsSlide = thumbsSwiper.slides.find((slideEl)=>slideEl.getAttribute('data-swiper-slide-index') === `${swiper.realIndex}`);
                newThumbsIndex = thumbsSwiper.slides.indexOf(newThumbsSlide);
                direction = swiper.activeIndex > swiper.previousIndex ? 'next' : 'prev';
            } else {
                newThumbsIndex = swiper.realIndex;
                direction = newThumbsIndex > swiper.previousIndex ? 'next' : 'prev';
            }
            if (useOffset) newThumbsIndex += direction === 'next' ? autoScrollOffset : -1 * autoScrollOffset;
            if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
                if (thumbsSwiper.params.centeredSlides) {
                    if (newThumbsIndex > currentThumbsIndex) newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
                    else newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
                } else newThumbsIndex > currentThumbsIndex && thumbsSwiper.params.slidesPerGroup;
                thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
            }
        }
    }
    on('beforeInit', ()=>{
        const { thumbs: thumbs } = swiper.params;
        if (!thumbs || !thumbs.swiper) return;
        if (typeof thumbs.swiper === 'string' || thumbs.swiper instanceof HTMLElement) {
            const document = (0, $0868fe5596dee114$export$39b482c5e57630a8)();
            const getThumbsElementAndInit = ()=>{
                const thumbsElement = typeof thumbs.swiper === 'string' ? document.querySelector(thumbs.swiper) : thumbs.swiper;
                if (thumbsElement && thumbsElement.swiper) {
                    thumbs.swiper = thumbsElement.swiper;
                    init();
                    update(true);
                } else if (thumbsElement) {
                    const eventName = `${swiper.params.eventsPrefix}init`;
                    const onThumbsSwiper = (e)=>{
                        thumbs.swiper = e.detail[0];
                        thumbsElement.removeEventListener(eventName, onThumbsSwiper);
                        init();
                        update(true);
                        thumbs.swiper.update();
                        swiper.update();
                    };
                    thumbsElement.addEventListener(eventName, onThumbsSwiper);
                }
                return thumbsElement;
            };
            const watchForThumbsToAppear = ()=>{
                if (swiper.destroyed) return;
                const thumbsElement = getThumbsElementAndInit();
                if (!thumbsElement) requestAnimationFrame(watchForThumbsToAppear);
            };
            requestAnimationFrame(watchForThumbsToAppear);
        } else {
            init();
            update(true);
        }
    });
    on('slideChange update resize observerUpdate', ()=>{
        update();
    });
    on('setTransition', (_s, duration)=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        thumbsSwiper.setTransition(duration);
    });
    on('beforeDestroy', ()=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        if (swiperCreated) thumbsSwiper.destroy();
    });
    Object.assign(swiper.thumbs, {
        init: init,
        update: update
    });
}



function $83be9fecc6264cb2$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, emit: emit, once: once } = _ref;
    extendParams({
        freeMode: {
            enabled: false,
            momentum: true,
            momentumRatio: 1,
            momentumBounce: true,
            momentumBounceRatio: 1,
            momentumVelocityRatio: 1,
            sticky: false,
            minimumVelocity: 0.02
        }
    });
    function onTouchStart() {
        if (swiper.params.cssMode) return;
        const translate = swiper.getTranslate();
        swiper.setTranslate(translate);
        swiper.setTransition(0);
        swiper.touchEventsData.velocities.length = 0;
        swiper.freeMode.onTouchEnd({
            currentPos: swiper.rtl ? swiper.translate : -swiper.translate
        });
    }
    function onTouchMove() {
        if (swiper.params.cssMode) return;
        const { touchEventsData: data, touches: touches } = swiper;
        // Velocity
        if (data.velocities.length === 0) data.velocities.push({
            position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
            time: data.touchStartTime
        });
        data.velocities.push({
            position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
            time: (0, $f97f33853a605dba$export$2d1720544b23b823)()
        });
    }
    function onTouchEnd(_ref2) {
        let { currentPos: currentPos } = _ref2;
        if (swiper.params.cssMode) return;
        const { params: params, wrapperEl: wrapperEl, rtlTranslate: rtl, snapGrid: snapGrid, touchEventsData: data } = swiper;
        // Time diff
        const touchEndTime = (0, $f97f33853a605dba$export$2d1720544b23b823)();
        const timeDiff = touchEndTime - data.touchStartTime;
        if (currentPos < -swiper.minTranslate()) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (currentPos > -swiper.maxTranslate()) {
            if (swiper.slides.length < snapGrid.length) swiper.slideTo(snapGrid.length - 1);
            else swiper.slideTo(swiper.slides.length - 1);
            return;
        }
        if (params.freeMode.momentum) {
            if (data.velocities.length > 1) {
                const lastMoveEvent = data.velocities.pop();
                const velocityEvent = data.velocities.pop();
                const distance = lastMoveEvent.position - velocityEvent.position;
                const time = lastMoveEvent.time - velocityEvent.time;
                swiper.velocity = distance / time;
                swiper.velocity /= 2;
                if (Math.abs(swiper.velocity) < params.freeMode.minimumVelocity) swiper.velocity = 0;
                // this implies that the user stopped moving a finger then released.
                // There would be no events with distance zero, so the last event is stale.
                if (time > 150 || (0, $f97f33853a605dba$export$2d1720544b23b823)() - lastMoveEvent.time > 300) swiper.velocity = 0;
            } else swiper.velocity = 0;
            swiper.velocity *= params.freeMode.momentumVelocityRatio;
            data.velocities.length = 0;
            let momentumDuration = 1000 * params.freeMode.momentumRatio;
            const momentumDistance = swiper.velocity * momentumDuration;
            let newPosition = swiper.translate + momentumDistance;
            if (rtl) newPosition = -newPosition;
            let doBounce = false;
            let afterBouncePosition;
            const bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeMode.momentumBounceRatio;
            let needsLoopFix;
            if (newPosition < swiper.maxTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition + swiper.maxTranslate() < -bounceAmount) newPosition = swiper.maxTranslate() - bounceAmount;
                    afterBouncePosition = swiper.maxTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.maxTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (newPosition > swiper.minTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition - swiper.minTranslate() > bounceAmount) newPosition = swiper.minTranslate() + bounceAmount;
                    afterBouncePosition = swiper.minTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.minTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (params.freeMode.sticky) {
                let nextSlide;
                for(let j = 0; j < snapGrid.length; j += 1)if (snapGrid[j] > -newPosition) {
                    nextSlide = j;
                    break;
                }
                if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') newPosition = snapGrid[nextSlide];
                else newPosition = snapGrid[nextSlide - 1];
                newPosition = -newPosition;
            }
            if (needsLoopFix) once('transitionEnd', ()=>{
                swiper.loopFix();
            });
            // Fix duration
            if (swiper.velocity !== 0) {
                if (rtl) momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
                else momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
                if (params.freeMode.sticky) {
                    // If freeMode.sticky is active and the user ends a swipe with a slow-velocity
                    // event, then durations can be 20+ seconds to slide one (or zero!) slides.
                    // It's easy to see this when simulating touch with mouse events. To fix this,
                    // limit single-slide swipes to the default slide duration. This also has the
                    // nice side effect of matching slide speed if the user stopped moving before
                    // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
                    // For faster swipes, also apply limits (albeit higher ones).
                    const moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
                    const currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
                    if (moveDistance < currentSlideSize) momentumDuration = params.speed;
                    else if (moveDistance < 2 * currentSlideSize) momentumDuration = params.speed * 1.5;
                    else momentumDuration = params.speed * 2.5;
                }
            } else if (params.freeMode.sticky) {
                swiper.slideToClosest();
                return;
            }
            if (params.freeMode.momentumBounce && doBounce) {
                swiper.updateProgress(afterBouncePosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                swiper.animating = true;
                (0, $f97f33853a605dba$export$882b5998b3b9117c)(wrapperEl, ()=>{
                    if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
                    emit('momentumBounce');
                    swiper.setTransition(params.speed);
                    setTimeout(()=>{
                        swiper.setTranslate(afterBouncePosition);
                        (0, $f97f33853a605dba$export$882b5998b3b9117c)(wrapperEl, ()=>{
                            if (!swiper || swiper.destroyed) return;
                            swiper.transitionEnd();
                        });
                    }, 0);
                });
            } else if (swiper.velocity) {
                emit('_freeModeNoMomentumRelease');
                swiper.updateProgress(newPosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                if (!swiper.animating) {
                    swiper.animating = true;
                    (0, $f97f33853a605dba$export$882b5998b3b9117c)(wrapperEl, ()=>{
                        if (!swiper || swiper.destroyed) return;
                        swiper.transitionEnd();
                    });
                }
            } else swiper.updateProgress(newPosition);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        } else if (params.freeMode.sticky) {
            swiper.slideToClosest();
            return;
        } else if (params.freeMode) emit('_freeModeNoMomentumRelease');
        if (!params.freeMode.momentum || timeDiff >= params.longSwipesMs) {
            emit('_freeModeStaticRelease');
            swiper.updateProgress();
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
    }
    Object.assign(swiper, {
        freeMode: {
            onTouchStart: onTouchStart,
            onTouchMove: onTouchMove,
            onTouchEnd: onTouchEnd
        }
    });
}


function $ddd0c2ed1384f58e$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        grid: {
            rows: 1,
            fill: 'column'
        }
    });
    let slidesNumberEvenToRows;
    let slidesPerRow;
    let numFullColumns;
    let wasMultiRow;
    const getSpaceBetween = ()=>{
        let spaceBetween = swiper.params.spaceBetween;
        if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiper.size;
        else if (typeof spaceBetween === 'string') spaceBetween = parseFloat(spaceBetween);
        return spaceBetween;
    };
    const initSlides = (slides)=>{
        const { slidesPerView: slidesPerView } = swiper.params;
        const { rows: rows, fill: fill } = swiper.params.grid;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : slides.length;
        numFullColumns = Math.floor(slidesLength / rows);
        if (Math.floor(slidesLength / rows) === slidesLength / rows) slidesNumberEvenToRows = slidesLength;
        else slidesNumberEvenToRows = Math.ceil(slidesLength / rows) * rows;
        if (slidesPerView !== 'auto' && fill === 'row') slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, slidesPerView * rows);
        slidesPerRow = slidesNumberEvenToRows / rows;
    };
    const unsetSlides = ()=>{
        if (swiper.slides) swiper.slides.forEach((slide)=>{
            if (slide.swiperSlideGridSet) {
                slide.style.height = '';
                slide.style[swiper.getDirectionLabel('margin-top')] = '';
            }
        });
    };
    const updateSlide = (i, slide, slides)=>{
        const { slidesPerGroup: slidesPerGroup } = swiper.params;
        const spaceBetween = getSpaceBetween();
        const { rows: rows, fill: fill } = swiper.params.grid;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : slides.length;
        // Set slides order
        let newSlideOrderIndex;
        let column;
        let row;
        if (fill === 'row' && slidesPerGroup > 1) {
            const groupIndex = Math.floor(i / (slidesPerGroup * rows));
            const slideIndexInGroup = i - rows * slidesPerGroup * groupIndex;
            const columnsInGroup = groupIndex === 0 ? slidesPerGroup : Math.min(Math.ceil((slidesLength - groupIndex * rows * slidesPerGroup) / rows), slidesPerGroup);
            row = Math.floor(slideIndexInGroup / columnsInGroup);
            column = slideIndexInGroup - row * columnsInGroup + groupIndex * slidesPerGroup;
            newSlideOrderIndex = column + row * slidesNumberEvenToRows / rows;
            slide.style.order = newSlideOrderIndex;
        } else if (fill === 'column') {
            column = Math.floor(i / rows);
            row = i - column * rows;
            if (column > numFullColumns || column === numFullColumns && row === rows - 1) {
                row += 1;
                if (row >= rows) {
                    row = 0;
                    column += 1;
                }
            }
        } else {
            row = Math.floor(i / slidesPerRow);
            column = i - row * slidesPerRow;
        }
        slide.row = row;
        slide.column = column;
        slide.style.height = `calc((100% - ${(rows - 1) * spaceBetween}px) / ${rows})`;
        slide.style[swiper.getDirectionLabel('margin-top')] = row !== 0 ? spaceBetween && `${spaceBetween}px` : '';
        slide.swiperSlideGridSet = true;
    };
    const updateWrapperSize = (slideSize, snapGrid)=>{
        const { centeredSlides: centeredSlides, roundLengths: roundLengths } = swiper.params;
        const spaceBetween = getSpaceBetween();
        const { rows: rows } = swiper.params.grid;
        swiper.virtualSize = (slideSize + spaceBetween) * slidesNumberEvenToRows;
        swiper.virtualSize = Math.ceil(swiper.virtualSize / rows) - spaceBetween;
        if (!swiper.params.cssMode) swiper.wrapperEl.style[swiper.getDirectionLabel('width')] = `${swiper.virtualSize + spaceBetween}px`;
        if (centeredSlides) {
            const newSlidesGrid = [];
            for(let i = 0; i < snapGrid.length; i += 1){
                let slidesGridItem = snapGrid[i];
                if (roundLengths) slidesGridItem = Math.floor(slidesGridItem);
                if (snapGrid[i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
            }
            snapGrid.splice(0, snapGrid.length);
            snapGrid.push(...newSlidesGrid);
        }
    };
    const onInit = ()=>{
        wasMultiRow = swiper.params.grid && swiper.params.grid.rows > 1;
    };
    const onUpdate = ()=>{
        const { params: params, el: el } = swiper;
        const isMultiRow = params.grid && params.grid.rows > 1;
        if (wasMultiRow && !isMultiRow) {
            el.classList.remove(`${params.containerModifierClass}grid`, `${params.containerModifierClass}grid-column`);
            numFullColumns = 1;
            swiper.emitContainerClasses();
        } else if (!wasMultiRow && isMultiRow) {
            el.classList.add(`${params.containerModifierClass}grid`);
            if (params.grid.fill === 'column') el.classList.add(`${params.containerModifierClass}grid-column`);
            swiper.emitContainerClasses();
        }
        wasMultiRow = isMultiRow;
    };
    on('init', onInit);
    on('update', onUpdate);
    swiper.grid = {
        initSlides: initSlides,
        unsetSlides: unsetSlides,
        updateSlide: updateSlide,
        updateWrapperSize: updateWrapperSize
    };
}



function $f08f7df954f7b274$var$appendSlide(slides) {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (params.loop) swiper.loopDestroy();
    const appendElement = (slideEl)=>{
        if (typeof slideEl === 'string') {
            const tempDOM = document.createElement('div');
            (0, $f97f33853a605dba$export$2408f22a0fab9ae5)(tempDOM, slideEl);
            slidesEl.append(tempDOM.children[0]);
            (0, $f97f33853a605dba$export$2408f22a0fab9ae5)(tempDOM, '');
        } else slidesEl.append(slideEl);
    };
    if (typeof slides === 'object' && 'length' in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) appendElement(slides[i]);
    } else appendElement(slides);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
}
function $f08f7df954f7b274$var$prependSlide(slides) {
    const swiper = this;
    const { params: params, activeIndex: activeIndex, slidesEl: slidesEl } = swiper;
    if (params.loop) swiper.loopDestroy();
    let newActiveIndex = activeIndex + 1;
    const prependElement = (slideEl)=>{
        if (typeof slideEl === 'string') {
            const tempDOM = document.createElement('div');
            (0, $f97f33853a605dba$export$2408f22a0fab9ae5)(tempDOM, slideEl);
            slidesEl.prepend(tempDOM.children[0]);
            (0, $f97f33853a605dba$export$2408f22a0fab9ae5)(tempDOM, '');
        } else slidesEl.prepend(slideEl);
    };
    if (typeof slides === 'object' && 'length' in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) prependElement(slides[i]);
        newActiveIndex = activeIndex + slides.length;
    } else prependElement(slides);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    swiper.slideTo(newActiveIndex, 0, false);
}
function $f08f7df954f7b274$var$addSlide(index, slides) {
    const swiper = this;
    const { params: params, activeIndex: activeIndex, slidesEl: slidesEl } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.recalcSlides();
    }
    const baseLength = swiper.slides.length;
    if (index <= 0) {
        swiper.prependSlide(slides);
        return;
    }
    if (index >= baseLength) {
        swiper.appendSlide(slides);
        return;
    }
    let newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
    const slidesBuffer = [];
    for(let i = baseLength - 1; i >= index; i -= 1){
        const currentSlide = swiper.slides[i];
        currentSlide.remove();
        slidesBuffer.unshift(currentSlide);
    }
    if (typeof slides === 'object' && 'length' in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) slidesEl.append(slides[i]);
        newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
    } else slidesEl.append(slides);
    for(let i = 0; i < slidesBuffer.length; i += 1)slidesEl.append(slidesBuffer[i]);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}
function $f08f7df954f7b274$var$removeSlide(slidesIndexes) {
    const swiper = this;
    const { params: params, activeIndex: activeIndex } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
    }
    let newActiveIndex = activeIndexBuffer;
    let indexToRemove;
    if (typeof slidesIndexes === 'object' && 'length' in slidesIndexes) {
        for(let i = 0; i < slidesIndexes.length; i += 1){
            indexToRemove = slidesIndexes[i];
            if (swiper.slides[indexToRemove]) swiper.slides[indexToRemove].remove();
            if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        }
        newActiveIndex = Math.max(newActiveIndex, 0);
    } else {
        indexToRemove = slidesIndexes;
        if (swiper.slides[indexToRemove]) swiper.slides[indexToRemove].remove();
        if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        newActiveIndex = Math.max(newActiveIndex, 0);
    }
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}
function $f08f7df954f7b274$var$removeAllSlides() {
    const swiper = this;
    const slidesIndexes = [];
    for(let i = 0; i < swiper.slides.length; i += 1)slidesIndexes.push(i);
    swiper.removeSlide(slidesIndexes);
}
function $f08f7df954f7b274$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper } = _ref;
    Object.assign(swiper, {
        appendSlide: $f08f7df954f7b274$var$appendSlide.bind(swiper),
        prependSlide: $f08f7df954f7b274$var$prependSlide.bind(swiper),
        addSlide: $f08f7df954f7b274$var$addSlide.bind(swiper),
        removeSlide: $f08f7df954f7b274$var$removeSlide.bind(swiper),
        removeAllSlides: $f08f7df954f7b274$var$removeAllSlides.bind(swiper)
    });
}


function $e0e15645344c9e40$export$f1e1789686576879(params) {
    const { effect: effect, swiper: swiper, on: on, setTranslate: setTranslate, setTransition: setTransition, overwriteParams: overwriteParams, perspective: perspective, recreateShadows: recreateShadows, getEffectParams: getEffectParams } = params;
    on('beforeInit', ()=>{
        if (swiper.params.effect !== effect) return;
        swiper.classNames.push(`${swiper.params.containerModifierClass}${effect}`);
        if (perspective && perspective()) swiper.classNames.push(`${swiper.params.containerModifierClass}3d`);
        const overwriteParamsResult = overwriteParams ? overwriteParams() : {};
        Object.assign(swiper.params, overwriteParamsResult);
        Object.assign(swiper.originalParams, overwriteParamsResult);
    });
    on('setTranslate _virtualUpdated', ()=>{
        if (swiper.params.effect !== effect) return;
        setTranslate();
    });
    on('setTransition', (_s, duration)=>{
        if (swiper.params.effect !== effect) return;
        setTransition(duration);
    });
    on('transitionEnd', ()=>{
        if (swiper.params.effect !== effect) return;
        if (recreateShadows) {
            if (!getEffectParams || !getEffectParams().slideShadows) return;
            // remove shadows
            swiper.slides.forEach((slideEl)=>{
                slideEl.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach((shadowEl)=>shadowEl.remove());
            });
            // create new one
            recreateShadows();
        }
    });
    let requireUpdateOnVirtual;
    on('virtualUpdate', ()=>{
        if (swiper.params.effect !== effect) return;
        if (!swiper.slides.length) requireUpdateOnVirtual = true;
        requestAnimationFrame(()=>{
            if (requireUpdateOnVirtual && swiper.slides && swiper.slides.length) {
                setTranslate();
                requireUpdateOnVirtual = false;
            }
        });
    });
}



function $b53f154314d4e7c8$export$f1e1789686576879(effectParams, slideEl) {
    const transformEl = (0, $f97f33853a605dba$export$39b482c5e57630a8)(slideEl);
    if (transformEl !== slideEl) {
        transformEl.style.backfaceVisibility = 'hidden';
        transformEl.style['-webkit-backface-visibility'] = 'hidden';
    }
    return transformEl;
}



function $999496ad6a55bf28$export$f1e1789686576879(_ref) {
    let { swiper: swiper, duration: duration, transformElements: transformElements, allSlides: allSlides } = _ref;
    const { activeIndex: activeIndex } = swiper;
    const getSlide = (el)=>{
        if (!el.parentElement) {
            // assume shadow root
            const slide = swiper.slides.find((slideEl)=>slideEl.shadowRoot && slideEl.shadowRoot === el.parentNode);
            return slide;
        }
        return el.parentElement;
    };
    if (swiper.params.virtualTranslate && duration !== 0) {
        let eventTriggered = false;
        let transitionEndTarget;
        if (allSlides) transitionEndTarget = transformElements;
        else transitionEndTarget = transformElements.filter((transformEl)=>{
            const el = transformEl.classList.contains('swiper-slide-transform') ? getSlide(transformEl) : transformEl;
            return swiper.getSlideIndex(el) === activeIndex;
        });
        transitionEndTarget.forEach((el)=>{
            (0, $f97f33853a605dba$export$882b5998b3b9117c)(el, ()=>{
                if (eventTriggered) return;
                if (!swiper || swiper.destroyed) return;
                eventTriggered = true;
                swiper.animating = false;
                const evt = new window.CustomEvent('transitionend', {
                    bubbles: true,
                    cancelable: true
                });
                swiper.wrapperEl.dispatchEvent(evt);
            });
        });
    }
}



function $1aaae3023eb523a1$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        fadeEffect: {
            crossFade: false
        }
    });
    const setTranslate = ()=>{
        const { slides: slides } = swiper;
        const params = swiper.params.fadeEffect;
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = swiper.slides[i];
            const offset = slideEl.swiperSlideOffset;
            let tx = -offset;
            if (!swiper.params.virtualTranslate) tx -= swiper.translate;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
            }
            const slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(slideEl.progress), 0) : 1 + Math.min(Math.max(slideEl.progress, -1), 0);
            const targetEl = (0, $b53f154314d4e7c8$export$f1e1789686576879)(params, slideEl);
            targetEl.style.opacity = slideOpacity;
            targetEl.style.transform = `translate3d(${tx}px, ${ty}px, 0px)`;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $f97f33853a605dba$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
        });
        (0, $999496ad6a55bf28$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements,
            allSlides: true
        });
    };
    (0, $e0e15645344c9e40$export$f1e1789686576879)({
        effect: 'fade',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}




function $ae560e392d45c8b7$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        cubeEffect: {
            slideShadows: true,
            shadow: true,
            shadowOffset: 20,
            shadowScale: 0.94
        }
    });
    const createSlideShadows = (slideEl, progress, isHorizontal)=>{
        let shadowBefore = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-left') : slideEl.querySelector('.swiper-slide-shadow-top');
        let shadowAfter = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-right') : slideEl.querySelector('.swiper-slide-shadow-bottom');
        if (!shadowBefore) {
            shadowBefore = (0, $f97f33853a605dba$export$db3b6bfb95261072)('div', `swiper-slide-shadow-cube swiper-slide-shadow-${isHorizontal ? 'left' : 'top'}`.split(' '));
            slideEl.append(shadowBefore);
        }
        if (!shadowAfter) {
            shadowAfter = (0, $f97f33853a605dba$export$db3b6bfb95261072)('div', `swiper-slide-shadow-cube swiper-slide-shadow-${isHorizontal ? 'right' : 'bottom'}`.split(' '));
            slideEl.append(shadowAfter);
        }
        if (shadowBefore) shadowBefore.style.opacity = Math.max(-progress, 0);
        if (shadowAfter) shadowAfter.style.opacity = Math.max(progress, 0);
    };
    const recreateShadows = ()=>{
        // create new ones
        const isHorizontal = swiper.isHorizontal();
        swiper.slides.forEach((slideEl)=>{
            const progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows(slideEl, progress, isHorizontal);
        });
    };
    const setTranslate = ()=>{
        const { el: el, wrapperEl: wrapperEl, slides: slides, width: swiperWidth, height: swiperHeight, rtlTranslate: rtl, size: swiperSize, browser: browser } = swiper;
        const r = (0, $f97f33853a605dba$export$ffb5f4729a158638)(swiper);
        const params = swiper.params.cubeEffect;
        const isHorizontal = swiper.isHorizontal();
        const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        let wrapperRotate = 0;
        let cubeShadowEl;
        if (params.shadow) {
            if (isHorizontal) {
                cubeShadowEl = swiper.wrapperEl.querySelector('.swiper-cube-shadow');
                if (!cubeShadowEl) {
                    cubeShadowEl = (0, $f97f33853a605dba$export$db3b6bfb95261072)('div', 'swiper-cube-shadow');
                    swiper.wrapperEl.append(cubeShadowEl);
                }
                cubeShadowEl.style.height = `${swiperWidth}px`;
            } else {
                cubeShadowEl = el.querySelector('.swiper-cube-shadow');
                if (!cubeShadowEl) {
                    cubeShadowEl = (0, $f97f33853a605dba$export$db3b6bfb95261072)('div', 'swiper-cube-shadow');
                    el.append(cubeShadowEl);
                }
            }
        }
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            let slideIndex = i;
            if (isVirtual) slideIndex = parseInt(slideEl.getAttribute('data-swiper-slide-index'), 10);
            let slideAngle = slideIndex * 90;
            let round = Math.floor(slideAngle / 360);
            if (rtl) {
                slideAngle = -slideAngle;
                round = Math.floor(-slideAngle / 360);
            }
            const progress = Math.max(Math.min(slideEl.progress, 1), -1);
            let tx = 0;
            let ty = 0;
            let tz = 0;
            if (slideIndex % 4 === 0) {
                tx = -round * 4 * swiperSize;
                tz = 0;
            } else if ((slideIndex - 1) % 4 === 0) {
                tx = 0;
                tz = -round * 4 * swiperSize;
            } else if ((slideIndex - 2) % 4 === 0) {
                tx = swiperSize + round * 4 * swiperSize;
                tz = swiperSize;
            } else if ((slideIndex - 3) % 4 === 0) {
                tx = -swiperSize;
                tz = 3 * swiperSize + swiperSize * 4 * round;
            }
            if (rtl) tx = -tx;
            if (!isHorizontal) {
                ty = tx;
                tx = 0;
            }
            const transform = `rotateX(${r(isHorizontal ? 0 : -slideAngle)}deg) rotateY(${r(isHorizontal ? slideAngle : 0)}deg) translate3d(${tx}px, ${ty}px, ${tz}px)`;
            if (progress <= 1 && progress > -1) {
                wrapperRotate = slideIndex * 90 + progress * 90;
                if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
            }
            slideEl.style.transform = transform;
            if (params.slideShadows) createSlideShadows(slideEl, progress, isHorizontal);
        }
        wrapperEl.style.transformOrigin = `50% 50% -${swiperSize / 2}px`;
        wrapperEl.style['-webkit-transform-origin'] = `50% 50% -${swiperSize / 2}px`;
        if (params.shadow) {
            if (isHorizontal) cubeShadowEl.style.transform = `translate3d(0px, ${swiperWidth / 2 + params.shadowOffset}px, ${-swiperWidth / 2}px) rotateX(89.99deg) rotateZ(0deg) scale(${params.shadowScale})`;
            else {
                const shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
                const multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
                const scale1 = params.shadowScale;
                const scale2 = params.shadowScale / multiplier;
                const offset = params.shadowOffset;
                cubeShadowEl.style.transform = `scale3d(${scale1}, 1, ${scale2}) translate3d(0px, ${swiperHeight / 2 + offset}px, ${-swiperHeight / 2 / scale2}px) rotateX(-89.99deg)`;
            }
        }
        const zFactor = (browser.isSafari || browser.isWebView) && browser.needPerspectiveFix ? -swiperSize / 2 : 0;
        wrapperEl.style.transform = `translate3d(0px,0,${zFactor}px) rotateX(${r(swiper.isHorizontal() ? 0 : wrapperRotate)}deg) rotateY(${r(swiper.isHorizontal() ? -wrapperRotate : 0)}deg)`;
        wrapperEl.style.setProperty('--swiper-cube-translate-z', `${zFactor}px`);
    };
    const setTransition = (duration)=>{
        const { el: el, slides: slides } = swiper;
        slides.forEach((slideEl)=>{
            slideEl.style.transitionDuration = `${duration}ms`;
            slideEl.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach((subEl)=>{
                subEl.style.transitionDuration = `${duration}ms`;
            });
        });
        if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
            const shadowEl = el.querySelector('.swiper-cube-shadow');
            if (shadowEl) shadowEl.style.transitionDuration = `${duration}ms`;
        }
    };
    (0, $e0e15645344c9e40$export$f1e1789686576879)({
        effect: 'cube',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: ()=>swiper.params.cubeEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                resistanceRatio: 0,
                spaceBetween: 0,
                centeredSlides: false,
                virtualTranslate: true
            })
    });
}



function $0a10add51d1983e4$export$db3b6bfb95261072(suffix, slideEl, side) {
    const shadowClass = `swiper-slide-shadow${side ? `-${side}` : ''}${suffix ? ` swiper-slide-shadow-${suffix}` : ''}`;
    const shadowContainer = (0, $f97f33853a605dba$export$39b482c5e57630a8)(slideEl);
    let shadowEl = shadowContainer.querySelector(`.${shadowClass.split(' ').join('.')}`);
    if (!shadowEl) {
        shadowEl = (0, $f97f33853a605dba$export$db3b6bfb95261072)('div', shadowClass.split(' '));
        shadowContainer.append(shadowEl);
    }
    return shadowEl;
}






function $03034e94e938a55a$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        flipEffect: {
            slideShadows: true,
            limitRotation: true
        }
    });
    const createSlideShadows = (slideEl, progress)=>{
        let shadowBefore = swiper.isHorizontal() ? slideEl.querySelector('.swiper-slide-shadow-left') : slideEl.querySelector('.swiper-slide-shadow-top');
        let shadowAfter = swiper.isHorizontal() ? slideEl.querySelector('.swiper-slide-shadow-right') : slideEl.querySelector('.swiper-slide-shadow-bottom');
        if (!shadowBefore) shadowBefore = (0, $0a10add51d1983e4$export$db3b6bfb95261072)('flip', slideEl, swiper.isHorizontal() ? 'left' : 'top');
        if (!shadowAfter) shadowAfter = (0, $0a10add51d1983e4$export$db3b6bfb95261072)('flip', slideEl, swiper.isHorizontal() ? 'right' : 'bottom');
        if (shadowBefore) shadowBefore.style.opacity = Math.max(-progress, 0);
        if (shadowAfter) shadowAfter.style.opacity = Math.max(progress, 0);
    };
    const recreateShadows = ()=>{
        // Set shadows
        swiper.params.flipEffect;
        swiper.slides.forEach((slideEl)=>{
            let progress = slideEl.progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows(slideEl, progress);
        });
    };
    const setTranslate = ()=>{
        const { slides: slides, rtlTranslate: rtl } = swiper;
        const params = swiper.params.flipEffect;
        const rotateFix = (0, $f97f33853a605dba$export$ffb5f4729a158638)(swiper);
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            let progress = slideEl.progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min(slideEl.progress, 1), -1);
            const offset = slideEl.swiperSlideOffset;
            const rotate = -180 * progress;
            let rotateY = rotate;
            let rotateX = 0;
            let tx = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
                rotateX = -rotateY;
                rotateY = 0;
            } else if (rtl) rotateY = -rotateY;
            slideEl.style.zIndex = -Math.abs(Math.round(progress)) + slides.length;
            if (params.slideShadows) createSlideShadows(slideEl, progress);
            const transform = `translate3d(${tx}px, ${ty}px, 0px) rotateX(${rotateFix(rotateX)}deg) rotateY(${rotateFix(rotateY)}deg)`;
            const targetEl = (0, $b53f154314d4e7c8$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = transform;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $f97f33853a605dba$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, $999496ad6a55bf28$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements
        });
    };
    (0, $e0e15645344c9e40$export$f1e1789686576879)({
        effect: 'flip',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: ()=>swiper.params.flipEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}






function $f2ff8c65b6ddc62a$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            scale: 1,
            modifier: 1,
            slideShadows: true
        }
    });
    const setTranslate = ()=>{
        const { width: swiperWidth, height: swiperHeight, slides: slides, slidesSizesGrid: slidesSizesGrid } = swiper;
        const params = swiper.params.coverflowEffect;
        const isHorizontal = swiper.isHorizontal();
        const transform = swiper.translate;
        const center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
        const rotate = isHorizontal ? params.rotate : -params.rotate;
        const translate = params.depth;
        const r = (0, $f97f33853a605dba$export$ffb5f4729a158638)(swiper);
        // Each slide offset from center
        for(let i = 0, length = slides.length; i < length; i += 1){
            const slideEl = slides[i];
            const slideSize = slidesSizesGrid[i];
            const slideOffset = slideEl.swiperSlideOffset;
            const centerOffset = (center - slideOffset - slideSize / 2) / slideSize;
            const offsetMultiplier = typeof params.modifier === 'function' ? params.modifier(centerOffset) : centerOffset * params.modifier;
            let rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
            let rotateX = isHorizontal ? 0 : rotate * offsetMultiplier;
            // var rotateZ = 0
            let translateZ = -translate * Math.abs(offsetMultiplier);
            let stretch = params.stretch;
            // Allow percentage to make a relative stretch for responsive sliders
            if (typeof stretch === 'string' && stretch.indexOf('%') !== -1) stretch = parseFloat(params.stretch) / 100 * slideSize;
            let translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
            let translateX = isHorizontal ? stretch * offsetMultiplier : 0;
            let scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier);
            // Fix for ultra small values
            if (Math.abs(translateX) < 0.001) translateX = 0;
            if (Math.abs(translateY) < 0.001) translateY = 0;
            if (Math.abs(translateZ) < 0.001) translateZ = 0;
            if (Math.abs(rotateY) < 0.001) rotateY = 0;
            if (Math.abs(rotateX) < 0.001) rotateX = 0;
            if (Math.abs(scale) < 0.001) scale = 0;
            const slideTransform = `translate3d(${translateX}px,${translateY}px,${translateZ}px)  rotateX(${r(rotateX)}deg) rotateY(${r(rotateY)}deg) scale(${scale})`;
            const targetEl = (0, $b53f154314d4e7c8$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = slideTransform;
            slideEl.style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
            if (params.slideShadows) {
                // Set shadows
                let shadowBeforeEl = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-left') : slideEl.querySelector('.swiper-slide-shadow-top');
                let shadowAfterEl = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-right') : slideEl.querySelector('.swiper-slide-shadow-bottom');
                if (!shadowBeforeEl) shadowBeforeEl = (0, $0a10add51d1983e4$export$db3b6bfb95261072)('coverflow', slideEl, isHorizontal ? 'left' : 'top');
                if (!shadowAfterEl) shadowAfterEl = (0, $0a10add51d1983e4$export$db3b6bfb95261072)('coverflow', slideEl, isHorizontal ? 'right' : 'bottom');
                if (shadowBeforeEl) shadowBeforeEl.style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
                if (shadowAfterEl) shadowAfterEl.style.opacity = -offsetMultiplier > 0 ? -offsetMultiplier : 0;
            }
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $f97f33853a605dba$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
    };
    (0, $e0e15645344c9e40$export$f1e1789686576879)({
        effect: 'coverflow',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                watchSlidesProgress: true
            })
    });
}







function $2d1d46abc1b4e0b9$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        creativeEffect: {
            limitProgress: 1,
            shadowPerProgress: false,
            progressMultiplier: 1,
            perspective: true,
            prev: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            },
            next: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            }
        }
    });
    const getTranslateValue = (value)=>{
        if (typeof value === 'string') return value;
        return `${value}px`;
    };
    const setTranslate = ()=>{
        const { slides: slides, wrapperEl: wrapperEl, slidesSizesGrid: slidesSizesGrid } = swiper;
        const params = swiper.params.creativeEffect;
        const { progressMultiplier: multiplier } = params;
        const isCenteredSlides = swiper.params.centeredSlides;
        const rotateFix = (0, $f97f33853a605dba$export$ffb5f4729a158638)(swiper);
        if (isCenteredSlides) {
            const margin = slidesSizesGrid[0] / 2 - swiper.params.slidesOffsetBefore || 0;
            wrapperEl.style.transform = `translateX(calc(50% - ${margin}px))`;
        }
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            const slideProgress = slideEl.progress;
            const progress = Math.min(Math.max(slideEl.progress, -params.limitProgress), params.limitProgress);
            let originalProgress = progress;
            if (!isCenteredSlides) originalProgress = Math.min(Math.max(slideEl.originalProgress, -params.limitProgress), params.limitProgress);
            const offset = slideEl.swiperSlideOffset;
            const t = [
                swiper.params.cssMode ? -offset - swiper.translate : -offset,
                0,
                0
            ];
            const r = [
                0,
                0,
                0
            ];
            let custom = false;
            if (!swiper.isHorizontal()) {
                t[1] = t[0];
                t[0] = 0;
            }
            let data = {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                scale: 1,
                opacity: 1
            };
            if (progress < 0) {
                data = params.next;
                custom = true;
            } else if (progress > 0) {
                data = params.prev;
                custom = true;
            }
            // set translate
            t.forEach((value, index)=>{
                t[index] = `calc(${value}px + (${getTranslateValue(data.translate[index])} * ${Math.abs(progress * multiplier)}))`;
            });
            // set rotates
            r.forEach((value, index)=>{
                let val = data.rotate[index] * Math.abs(progress * multiplier);
                r[index] = val;
            });
            slideEl.style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const translateString = t.join(', ');
            const rotateString = `rotateX(${rotateFix(r[0])}deg) rotateY(${rotateFix(r[1])}deg) rotateZ(${rotateFix(r[2])}deg)`;
            const scaleString = originalProgress < 0 ? `scale(${1 + (1 - data.scale) * originalProgress * multiplier})` : `scale(${1 - (1 - data.scale) * originalProgress * multiplier})`;
            const opacityString = originalProgress < 0 ? 1 + (1 - data.opacity) * originalProgress * multiplier : 1 - (1 - data.opacity) * originalProgress * multiplier;
            const transform = `translate3d(${translateString}) ${rotateString} ${scaleString}`;
            // Set shadows
            if (custom && data.shadow || !custom) {
                let shadowEl = slideEl.querySelector('.swiper-slide-shadow');
                if (!shadowEl && data.shadow) shadowEl = (0, $0a10add51d1983e4$export$db3b6bfb95261072)('creative', slideEl);
                if (shadowEl) {
                    const shadowOpacity = params.shadowPerProgress ? progress * (1 / params.limitProgress) : progress;
                    shadowEl.style.opacity = Math.min(Math.max(Math.abs(shadowOpacity), 0), 1);
                }
            }
            const targetEl = (0, $b53f154314d4e7c8$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = transform;
            targetEl.style.opacity = opacityString;
            if (data.origin) targetEl.style.transformOrigin = data.origin;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $f97f33853a605dba$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll('.swiper-slide-shadow').forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, $999496ad6a55bf28$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements,
            allSlides: true
        });
    };
    (0, $e0e15645344c9e40$export$f1e1789686576879)({
        effect: 'creative',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>swiper.params.creativeEffect.perspective,
        overwriteParams: ()=>({
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}







function $ddebdb27567903ce$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        cardsEffect: {
            slideShadows: true,
            rotate: true,
            perSlideRotate: 2,
            perSlideOffset: 8
        }
    });
    const setTranslate = ()=>{
        const { slides: slides, activeIndex: activeIndex, rtlTranslate: rtl } = swiper;
        const params = swiper.params.cardsEffect;
        const { startTranslate: startTranslate, isTouched: isTouched } = swiper.touchEventsData;
        const currentTranslate = rtl ? -swiper.translate : swiper.translate;
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            const slideProgress = slideEl.progress;
            const progress = Math.min(Math.max(slideProgress, -4), 4);
            let offset = slideEl.swiperSlideOffset;
            if (swiper.params.centeredSlides && !swiper.params.cssMode) swiper.wrapperEl.style.transform = `translateX(${swiper.minTranslate()}px)`;
            if (swiper.params.centeredSlides && swiper.params.cssMode) offset -= slides[0].swiperSlideOffset;
            let tX = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let tY = 0;
            const tZ = -100 * Math.abs(progress);
            let scale = 1;
            let rotate = -params.perSlideRotate * progress;
            let tXAdd = params.perSlideOffset - Math.abs(progress) * 0.75;
            const slideIndex = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.from + i : i;
            const isSwipeToNext = (slideIndex === activeIndex || slideIndex === activeIndex - 1) && progress > 0 && progress < 1 && (isTouched || swiper.params.cssMode) && currentTranslate < startTranslate;
            const isSwipeToPrev = (slideIndex === activeIndex || slideIndex === activeIndex + 1) && progress < 0 && progress > -1 && (isTouched || swiper.params.cssMode) && currentTranslate > startTranslate;
            if (isSwipeToNext || isSwipeToPrev) {
                const subProgress = (1 - Math.abs((Math.abs(progress) - 0.5) / 0.5)) ** 0.5;
                rotate += -28 * progress * subProgress;
                scale += -0.5 * subProgress;
                tXAdd += 96 * subProgress;
                tY = `${-25 * subProgress * Math.abs(progress)}%`;
            }
            if (progress < 0) // next
            tX = `calc(${tX}px ${rtl ? '-' : '+'} (${tXAdd * Math.abs(progress)}%))`;
            else if (progress > 0) // prev
            tX = `calc(${tX}px ${rtl ? '-' : '+'} (-${tXAdd * Math.abs(progress)}%))`;
            else tX = `${tX}px`;
            if (!swiper.isHorizontal()) {
                const prevY = tY;
                tY = tX;
                tX = prevY;
            }
            const scaleString = progress < 0 ? `${1 + (1 - scale) * progress}` : `${1 - (1 - scale) * progress}`;
            /* eslint-disable */ const transform = `
        translate3d(${tX}, ${tY}, ${tZ}px)
        rotateZ(${params.rotate ? rtl ? -rotate : rotate : 0}deg)
        scale(${scaleString})
      `;
            /* eslint-enable */ if (params.slideShadows) {
                // Set shadows
                let shadowEl = slideEl.querySelector('.swiper-slide-shadow');
                if (!shadowEl) shadowEl = (0, $0a10add51d1983e4$export$db3b6bfb95261072)('cards', slideEl);
                if (shadowEl) shadowEl.style.opacity = Math.min(Math.max((Math.abs(progress) - 0.5) / 0.5, 0), 1);
            }
            slideEl.style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const targetEl = (0, $b53f154314d4e7c8$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = transform;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $f97f33853a605dba$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll('.swiper-slide-shadow').forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, $999496ad6a55bf28$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements
        });
    };
    (0, $e0e15645344c9e40$export$f1e1789686576879)({
        effect: 'cards',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                _loopSwapReset: false,
                watchSlidesProgress: true,
                loopAdditionalSlides: swiper.params.cardsEffect.rotate ? 3 : 2,
                centeredSlides: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}




var $4263edbfe9b8e435$exports = {};
$4263edbfe9b8e435$exports = JSON.parse('{"wow":{"title":"wow","description":"Gli strumenti della serie WOW prendono ispirazione dalla scuola di pensiero proveniente dal maestro Antonio Pioli detto Wandr\xe8 (Cavriago, Italia 1926-2004). Partendo dal meraviglioso modello \u201CBlue Jeans\u201D degli anni \'60, la serie WOW \xe8 stata sviluppata e messa a punto tra il 2017 e il 2022. WOW \xe8 caratterizzata da un manico basculante in alluminio a sezione ovale. L\'action \xe8 regolabile mediante una vite posta sul retro del corpo. Lo strumento \xe8 completamente disassemblabile e intercambiabile in ogni sua parte.","dataSheet":{"Disponibili al pubblico":"SI","Tecnologia Tarazum":"SI","Progettazione Tarazum":"SI","Disegno Tarazum":"SI","Finiture Tarazum":"SI"},"guitars":[{"klein":{"title":"klein","description":"La chitarra Tarazum WOW \xe8 uno strumento unico nel suo genere. Ispirato alle modalit\xe0 costruttive del maestro Wandr\xe8, questo strumento elimina la barra truss-rod di rinforzo per un unico elemento portante in alluminio a sezione ovale. La sua cavit\xe0 funge essa stessa da cassa di risonanza insieme alle camere tonali del body. Quest\'ultimo \xe8 concepito come un elemento unitario e plastico. Tutta la sezione elettronica \xe8 concentrata in un unico corpo in alluminio smontabile e sostituibile anche a corde montate. Con uno spessore di 25 mm ed un peso di soli 2,3kg. questo strumento porta all\'essenziale il concetto di chitarra elettrica. Suonare per credere!","dataSheet":{"Serie":"WOW","Anno":"2022","Costruzione":"bolt on \u2013 body con camere tonali","Manico":"alluminio sezione ovale","Body":"pioppo liscio + top in pioppo marezzato","Tastiera":"ovangkol","Capotasto":"alluminio","Scala":"24,75\'\'","Radius":"10\'\'","Scalatura corde":"0.10-0.46","Pickup bridge":"Goldo P90 Silverfoil","Pickup neck":"Goldo P90 Silverfoil","Bridge":"H\xf6fner H72/20-N Bridge","Regolazioni":{"Tono":"1 tono (250k log + condensatore carta/olio 0,033 uF)","Volume":"1 volume (250k log)"},"Meccaniche":"Fender Machine Heads SL-CHR","Tailpiece":"Artigianale in alluminio e acciaio armonico","Peso":"2,3 kg","Finitura body":"Coloritura con anilina Blu Klein + vernice di finitura trasparente all\'alcool","Finitura manico":"lucidatura a specchio","Status":"disponibile"}}}]},"slurp":{"title":"slurp","description":"Gli strumenti della serie SLURP sono caratterizzati da una costruzione tradizionale dello strumento unito ad un lavoro di progettazione e design ad hoc. Ogni strumento ha una sua precisa specificit\xe0 ed \xe8 stato creato con un concept chiaro e mirato. La lavorazione in resina della tastiera rappresenta uno dei punti di riconoscibilit\xe0 del marchio Tarazum ed e garantisce un alto grado di personalizzazione e customizzazione sulla base dell\'esigenza e gusto di ogni singolo musicista.","dataSheet":{"Disponibili al pubblico":"SI","Tecnologia Tarazum":"NO","Progettazione Tarazum":"SI","Disegno Tarazum":"SI","Finiture Tarazum":"SI"},"guitars":[{"mono":{"title":"mono","description":"Il basso Tarazum Mono \xe8 uno strumento sobrio ed elegante. E\' pensato per avere il massimo della semplicit\xe0 in termini di suonabilit\xe0 e gestione complessiva dello strumento specialmente per la dimensione \u201Clive\u201D. Con il peso di soli 3,1kg si attesta tra i bassi elettrici solid body pi\xf9 leggeri del mercato. La scelta dei materiali unita alla posizione e tipologia del pick-up conferisce allo strumento un timbro rotondo e nitido.","dataSheet":{"Serie":"SLURP","Anno":"2022","Costruzione":"manico incollato","Manico":"mogano","Body":"frassino termotrattato","Tastiera":"palissandro Santos","Capotasto":"corozo","Scala":"34\'\'","Radius":"10\'\'","Scalatura corde":"45-105 extra long scale","Bridge":"Torozo bridge (Hofner style)","Neck":"Hofner pickup H511-TAB","Regolazioni":{"Tono":"1 tono (250k log + condensatore carta/olio 0,033 uF)","Volume":"1 volume (250k log)"},"Meccaniche":"TK-7946 All parts","Tailpiece":"Artigianale in ebano con piastra metallica integrata per messa a terra","Peso":"3,1 kg","Finitura body":"verniciatura trasparente all\'alcool","Finitura manico":"verniciatura trasparente all\'alcool","Status":"disponibile"}}},{"pinderbass":{"title":"pinderbass","description":"Il basso Tarazum Pinderbass rappresenta un alter-ego del famoso basso Mucicman Stingray. Si tratta infatti di un basso attivo con humbuker in posizione centrale. I controlli di equalizzazione permettono l\'ottimale gestione delle tre principali categorie di frequenze: basse, medie, alte. Il basso \xe8 molto maneggevole e possiede un incredibile output sonoro. Preciso al tocco e dal timbro cordoso e nitido si presta perfettamente per ottenere registrazioni audio di alta qualit\xe0.","dataSheet":{"Serie":"SLURP","Anno":"2017","Costruzione":"manico avvitato","Manico":"acero liscio","Body":"frassino termotrattato","Tastiera":"palissandro India","Scala":"34\'\'","Radius":"piatto","Bridge":"-","Middle":"Seymour Duncan SMB-4A","Neck":"-","Regolazioni":{"Volume":"1 mater","Toni":["high","mid","low"]},"Finitura body":"gommalacca","Finitura manico":"gommalacca","Credits":"pictures by Ideo (www.ideo-lab.com)","Status":"Sold"}}},{"felipe":{"title":"felipe","description":"La chitarra Tarazum Felipe \xe8 caratterizzata da una costruzione neck thru body con ali in frassino termotrattato e corpo centrale in mogano. Questo strumento presenta delle cavit\xe0 trasversali all\'interno del body che fungono da camere tonali e alleggerimento del peso. Il progetto \xe8 stato sviluppato a partire dalle esigenze di Filippo Giovagnoni, proprietario dello strumento e chitarrista della band alternative rock No Pine Mall.","dataSheet":{"Serie":"SLURP","Anno":"2016","Costruzione":"neck-trough","Manico":"Mogano","Body":"Mogano / Frassino","Tastiera":"Palissandro India","Scala":"24,75\'\'","Radius":"7,25\'\'","Bridge":"DiMarzio DP155BC The Tone Zone","Middle":"none","Neck":"Seymour Duncan SJM-3N","Regolazioni":"2 volumi","Finitura body":"gommalacca","Finitura manico":"gommalacca"}}}]},"roar":{"title":"roar","description":"Gli strumenti della serie ROAR consistono in repliche dei modelli di chitarre e bassi che hanno fatto la storia della musica degli ultimi cento anni. Tali modelli non sono \u201Ccopie\u201D bens\xec repliche modificate in temini di componentistica, costruzione e finiture sulla base delle esigenze dello specifico musicista.","dataSheet":{"Disponibili al pubblico":"SI","Tecnologia Tarazum":"NO","Progettazione Tarazum":"NO","Disegno Tarazum":"NO","Finiture Tarazum":"SI"},"guitars":[{"tretrecinque":{"title":"tretrecinque","description":"La chitarra Tarazum TRETRECINQUE prende spunto dall\'omonimo modello Gibson. Risulta uno strumento molto maneggevole e pesa quasi un chilo meno del modello Gibson originale grazie all\'utlizzo del legno di pioppo. L\'idea estetica dello strumento \xe8 quella di essere monocromatica. Non pi\xf9 i tradizionali contrasti chiaro-scuro tra finitura, binding e segnatasti: TRETRECINQUE presenta un binding nero sul colore marrone scuro e dei segnatasti in ABS nera sulla tastiera in ebano. Una chitarra quindi per mani esperte. I due potenziometri push-pull dei toni permettono di attivare o disattivare i singoli pickup eliminando in questo modo il selettore a tre vie previsto nel modello Gibson. Il suono risulta caldo e corposo, particolarmente adatto a suonare Jazz.","dataSheet":{"Serie":"ROAR","Anno":"2023","Costruzione":"manico incollato - semihollow","Manico":"mogano","Body":"pioppo liscio + top in pioppo marezzato","Tastiera":"ebano","Capotasto":"osso","Scala":"24,75\'\'","Radius":"10\'\'","Scalatura corde":"0.10-0.52","Pickup bridge":"Tonerider Vintage 90 \u2013 Alnico II soapbar","Pickup neck":"Tonerider Vintage 90 \u2013 Alnico II soapbar","Bridge":"Tune \'o matic model","Regolazioni":"2 toni on-off (250k log + cond. carta/olio 0,033 uF), 1 volume (250k log)","Meccaniche":"Kluson M33VC Single Line Tulip","Tailpiece":"A trapezio","Peso":"3,2 kg","Finitura body":"Coloritura con anilina marrone + vernice di finitura gommalacca","Finitura manico":"Coloritura con anilina marrone + vernice di finitura gommalacca","Status":"disponibile"}}},{"venere":{"title":"venere","description":"Il modello Venere di Tarazum parte dall\'idea di poter far confluire il meglio di due marchi iconici del mondo della chitarra elettrica: Fender e Gibson. \u201CVenere\u201D ha una veste Fender (mod.Jazzmaster) e un\'anima Gibson (mod.Les Paul). Tutta la tecnologia costruttiva \xe8 ispirata a Gibson. In particolare: manico incollato al body per una migliore trasmissione delle vibrazioni; paletta inclinata per una migliore stabilit\xe0 delle corde; body e manico in mogano per una maggiore leggerezza e morbidezza; manico inclinato e tune o\'matic bridge (personale preferenza ai ponti montati da Fender). L\'attitudine \xe8 invece Fender: tailpiece lungo con vibrato, body con camere tonali in stile \u201Cthin line\u201D per una maggiore leggerezza e risonanza; formato del body nello stile unico del modello Jazzmaster. Suono caldo in stile Gibson e al contempo tagliente in stile Fender.","dataSheet":{"Serie":"ROAR","Anno":"2021","Costruzione":"manico incollato","Manico":"mogano Kaya","Body":"mogano Kaya","Tastiera":"ebano Makassar","Capotasto":"osso","Scala":"24,75\'\'","Radius":"12\'\'","Scalatura corde":"0.10-0.52","Bridge":"Seymour Duncan bridge quarter pound JM-PU","Neck":"Seymour Duncan neck quarter pound JM-PU","Regolazioni":{"VOL":"1 pot 500k","TON":"2 pot 250k push-pull (ON-OFF pickup)","CONDENSATORI":"n\xb02 carta olio da 0,0033 uF"},"Finitura body":"vernice naturale all\'alcool (poro aperto)","Finitura manico":"vernice naturale all\'alcool (poro aperto)","Status":"disponibile"}}},{"spring":{"title":"spring","description":"La chitarra Tarazum SLURP Spring \xe8 caratterizzata da un circuito elettronico molto speciale: oltre al classico switch a tre vie per la selezione del pick-up, presenta altri due switch che permettono di splittare i singoli avvolgimenti di ogni pickup (avvolti tre poli per volta). Questa caratteristica permette modalit\xe0 di impostazione del suono dello strumento molto particolari. I chitarristi che amano la ricerca sonora mediante l\'utilizzo di pedalini effetto potrebbero trovare nel modello SPRING un ottimo alleato. La chitarra ha finiture naturali che garantiscono il massimo in termini di risonanti e sustain. La stile \xe8 semplice e fresco come la primavera. I segna tasti in resina contengono una selezione di fiori primaverili essiccati tipici delle aree verdi presenti poco fuori dall\'hinterland milanese.","dataSheet":{"Serie":"ROAR","Anno":"2024","Costruzione":"manico incollato","Manico":"mogano kaya","Body":"Douglas","Tastiera":"Palissandro","Capotasto":"corian","Scala":"631mm","Radius":"14\'\'","Scalatura corde":"0.10-0.46","Pickup bridge":"Duesenberg PH9NN SingleTwin Domino","Pickup neck":"Duesenberg PH9NN SingleTwin Domino","Bridge":"Schaller STM TOM-Style Bridge N","Regolazioni":"1 tone (250k log + cond. carta/olio 0,033 uF), 1 vol (250k log), double switch","Meccaniche":"Kluson M33JP Double Line Junior Nickel","Tailpiece":"A trapezio in metallo (blocchetto in ebano)","Peso":"3,4 kg","Finitura body":"Cera d\'api naturale","Finitura manico":"Cera d\'api naturale","Status":"disponibile"}}}]},"boom":{"title":"boom","description":"Gli strumenti della serie BOOM sono concepiti come delle sculture sonore in cui sperimentazione e ricerca permettono lo sviluppo degli altri modelli Tarazum in commercio. Rappresentano quindi un punto di unione trasversale tra le arti. Scultura, pittura, liuteria, musica e poesia convergono per trasformarsi in manifesti tangibili del pensiero Tarazum.","dataSheet":{"Disponibili al pubblico":"NO","Tecnologia Tarazum":"SI","Progettazione Tarazum":"SI","Disegno Tarazum":"SI","Finiture Tarazum":"SI"},"guitars":[{"diapason":{"title":"diapason","description":"Il modello Diapason di Tarazum rappresenta il primo prototipo realizzato per la messa a punto degli strumenti della serie WOW. Diapason prende spunto dall\'esperienza costruttiva degli strumenti di Wandr\xe8. La costruzione \xe8 neck-thru body con un manico misto in alluminio ed ebano che termina con due corna a ricordare la forma di un diapason. Al centro vi \xe8 l\'alloggiamento dell\'elettronica concepita come una scatola esagonale che pu\xf2 essere sfilata dal retro dello strumento. Lo strumento \xe8 un prototipo e non \xe8 disponibile sul mercato. La sua presentazione \xe8 per\xf2 importante per comprendere l\'iter evolutivo di studio e messa a punto degli strumenti a marchio Tarazum. Ogni parte \xe8 attentamente studiata e migliorata per ottenere un\'esperienza sonora sempre di migliore qualit\xe0.","dataSheet":{"Serie":"BOOM","Anno":"2016","Costruzione":"neck-through / bolt-on","Manico":"alluminio e ebano","Body":"alluminio e frassino","Tastiera":"palissandro santos","Scala":"24,75\'\'","Radius":"7,25\'\'","Bridge":"pickup tipo Woolworth Top 20 (Robert Smith) - Anni \'70","Middle":"-","Neck":"pickup Meazzi anni \'70","Regolazioni":"2 interruttori on-off pickup, 1 tono, 1 volume","Meccaniche":"Gotoh Stealth","Finitura body":"gommalacca","Finitura manico":"olio di tung"}}},{"monoblocco":{"title":"monoblocco","description":"Il modello Monoblocco di Tarazum parte da un\'idea scultorea di ottenere una chitarra da un unico corpo solido in legno. Pertanto questo strumento non ha soluzione di continuit\xe0 nelle sue parti: la paletta, il manico, il corpo, la tastiera e il ponte sono ricavati dallo stesso pezzo di legno come se fosse un bassorilievo. Lo strumento monta corde in nylon con una spaziatura di corde da chitarra classica. L\'amplificazione \xe8 ottenuta mediante un ricettore piezoelettrico posto sotto l\'osso del ponticello che viene successivamente pre amplificato da un circuito contenuto all\'interno del corpo ed accessibile da uno sportello posto sul retro. Un sound e un\'esperienza di suonato unica nel suo genere.","dataSheet":{"Serie":"BOOM","Anno":"2015","Costruzione":"pezzo unico","Manico":"frassino termotrattato","Body":"frassino termotrattato","Tastiera":"frassino termotrattato","Scala":"24,75\'\'","Radius":"piatto","Bridge":"Piezo pre amplificato","Middle":"-","Neck":"-","Regolazioni":"1 tono, 1 volume","Meccaniche":"Schertler","Finitura body":"gommalacca","Finitura manico":"gommalacca","Status":"disponibile"}}}]},"filosofy":{"title":"filosofy","description":"Gli strumenti Tarazum sono realizzati esclusivamente con legnami di prima scelta a taglio radiale. La selezione del legno avviene presso fornitori specializzati leader nel settore. Tutti i legni impiegati rispettano i criteri Cites (Convenzione di Washington sul commercio internazionale delle specie di fauna e flora selvatiche minacciate di estinzione) in un\'ottica di ecosostenibilit\xe0.\\nCon la stessa sensibilit\xe0, gli scarti derivanti dalla lavorazione dei legni vengono avviati, ove possibile, a riutilizzo, recupero energetico e/o riciclo.\\nOgni parte di uno strumento viene accuratamente selezionata da Tarazum direttamente presso i fornitori mediante test di risonanza, verifica della fibra e della stagionatura.\\nLa stessa cura viene adottata per la scelta delle componenti meccaniche ed elettroniche. Questo perch\xe9 l\'eccellenza del prodotto viene considerata da Tarazum come caratteristica fondamentale per un buon strumento di liuteria.\\nTarazum ha deciso di non adottare nessuna lavorazione tramite CNC (controllo numerico computerizzato) per garantire la genuinit\xe0 del prodotto ed avere un controllo qualit\xe0 costante dei materiali durante tutte le fasi della realizzazione di uno strumento.\\nE\' altres\xec convinto che la finitura di uno strumento debba il pi\xf9 possibile garantirne le armoniche, il volume ed il sustain. Per questo non vengono impiegate finiture di forte spessore coprenti come la nitro o le vernici poliuretaniche ma soltanto finiture eco-sostenibili, reversibili e naturali legate alla tradizione del legno come vernici all\'alcool, gommalacca, olio e cera. Sebbene pi\xf9 delicate delle prime, esse favoriscono la risonanza dello strumento e dichiarano la sua vera natura sotto la pelle (da qui lo slogan quality beyond the surface)."},"concept":{"title":"concept","description":"Tarazum: onomatopea che rappresenta il suono tipico di una fanfara o di una banda.\\n\\n\\"Ogni strumento musicale artigianale ha dei caratteri unici ed irripetibili, come le persone: hanno la propria individualit\xe0, il proprio carattere, i propri tratti somatici, la propria voce, i propri pregi e difetti. Possono diventare anime gemelle, migliori amici, puoi invidiarle, possono generare antipatia, possono arrivare persino ad essere odiate. Questo perch\xe9 ogni persona cerca altre persone affini alla propria sensibilit\xe0 ed scaccia quelle in cui non si riconosce. Lo strumento musicale artigianale non \xe8 per tutti. E\' per chi interagendo con lui scopre un legame profondo.\\"\\n\\t\\t\\t\\t\\t\\t\\tPaolo Garzillo (Tarazum CEO)\\n\\nLa certezza che la bellezza e la qualit\xe0 di un prodotto derivino dalla sintesi di tradizione, conoscenza, energia, esperienza e rapporti umani fanno del laboratorio Tarazum il luogo dove tali caratteri possano confluire, essere amplificati e diventare progetti sonori. Gli strumenti Tarazum non ammiccano alle mode del mercato e non cercano il grande pubblico. Sono concepiti come essenze uniche, capaci di interagire con la sensibilit\xe0 del singolo musicista."},"quality":{"title":"quality","description":"Ogni strumento a marchio Tarazum \xe8 accompagnato da un certificato di autenticit\xe0 e una scheda tecnica completa in cui trovere tutte le caratteristiche dello strumento.\\nInoltre a partire dal 2025, ogni strumento Tarazum \xe8 dotato di un sensore NFC (Near Field Communication). Tramite l\'impiego di un comune smartphone, \xe8 pertanto possibile essere indirizzati direttamente sulla pagina anagrafica di uno specifico strumento tramite il sito Tarazum."},"paolo":{"title":"paolo","description":"Tarazum nasce da un\'idea di Paolo Garzillo (Milano, 1982), architetto, artista, musicista e artigiano italiano. Vive a Seregno ed opera presso Meda.\\nDopo essersi diplomato presso l\'Istituto Statale D\'Arte di Giussano, consegue la laurea in Architettura al Politecnico di Milano. Conosce e frequenta l\'atelier dell\'architetto Bruno Vaerini, grazie al quale ha l\'opportunit\xe0 di poter sviluppare un preciso pensiero poetico e progettuale.\\nLa sua visione poliedrica lo portano a diversi anni di ricerca e studio artistico negli ambiti dell\'architettura, dell\'artigianato e della musica. Realizza alcuni progetti di architettura di interni; prende parte, come bassista, al progetto rock alternativo NiCE col quale pubblica due dischi e diversi EP.\\nNel 2014 approccia al mondo della liuteria costruendo da autodidatta la sua prima chitarra elettrica (Pinder I).\\nNel 2015 incontra e frequenta Willy Davoli e Marco Ballestri, grazie ai quali conosce e si innamora degli strumenti del maestro Antonio Pioli detto Wandr\xe8.\\nDal 2018 frequenta il laboratorio di liuteria \\"La Stanza delle Arti\\" diretto dal maestro di liuteria Emanuele Vocale. Qui ha modo di oggettivare, apprendere e sviluppare le tecniche costruttive della liuteria moderna.\\nNel 2020 avvia il laboratorio Tarazum presso lo spazio \\"Formicaudio\\" di Meda dedicandosi all\'ideazione, progettazione e produzione di chitarre e bassi artigianali."}}');


var $6a59e2522d0a422e$exports = {};
$6a59e2522d0a422e$exports = new URL("diapason_cover.117f195f.jpg", import.meta.url).toString();


var $2ffa2c54c6a114ef$exports = {};
$2ffa2c54c6a114ef$exports = new URL("BOOM_DIAPASON_Pick-up a manico.39ea2f1b.jpg", import.meta.url).toString();


var $028532da9ff1f621$exports = {};
$028532da9ff1f621$exports = new URL("BOOM_DIAPASON_Ponte.94a2e26b.jpg", import.meta.url).toString();


var $217d47a239f32826$exports = {};
$217d47a239f32826$exports = new URL("BOOM_DIAPASON_Tastiera.0570cef4.jpg", import.meta.url).toString();


var $9f5eb8e9b32da6fa$exports = {};
$9f5eb8e9b32da6fa$exports = new URL("ROAR_TRETRECINQUE_principlale.c6469240.jpg", import.meta.url).toString();


var $e30b7a8a55b34f44$exports = {};
$e30b7a8a55b34f44$exports = new URL("ROAR_TRETRECINQUE_Segnatasti.666f9072.jpg", import.meta.url).toString();


var $59e791cdf70ee155$exports = {};
$59e791cdf70ee155$exports = new URL("ROAR_TRETRECINQUE_Pick up.6d7b9472.jpg", import.meta.url).toString();


var $9daaa99c344a467b$exports = {};
$9daaa99c344a467b$exports = new URL("ROAR_TRETRECINQUE_Ponte.32492f02.jpg", import.meta.url).toString();


var $6355f2d2c122bd0e$exports = {};
$6355f2d2c122bd0e$exports = new URL("ROAR_VENERE_principale.b5b22d6c.jpg", import.meta.url).toString();


var $f92d7402ec7b0c8f$exports = {};
$f92d7402ec7b0c8f$exports = new URL("ROAR VENERE_Ponte.4b59f31c.jpg", import.meta.url).toString();


var $784db09a50aa83e0$exports = {};
$784db09a50aa83e0$exports = new URL("ROAR_VENERE_Pickup.4589e534.jpg", import.meta.url).toString();


var $76d0faf7543367bf$exports = {};
$76d0faf7543367bf$exports = new URL("ROAR_VENERE_Segnatasti.e8a7ed58.jpg", import.meta.url).toString();


var $6ab5a020cddd3bdb$exports = {};
$6ab5a020cddd3bdb$exports = new URL("SLURP_MONO_principale.0334f7c2.jpg", import.meta.url).toString();


var $fea54437f50b2827$exports = {};
$fea54437f50b2827$exports = new URL("SLURP_MONO_pickup.6bface3f.jpg", import.meta.url).toString();


var $ebd9325ca325cc6e$exports = {};
$ebd9325ca325cc6e$exports = new URL("SLURP_MONO_Manico.3310c735.jpg", import.meta.url).toString();


var $4b46523206336629$exports = {};
$4b46523206336629$exports = new URL("SLURP_MONO_Marchio.b1633f1a.jpg", import.meta.url).toString();


var $f68aab68a9c28a83$exports = {};
$f68aab68a9c28a83$exports = new URL("SLURP_PINDERBASS_principale.99b5c778.jpg", import.meta.url).toString();


var $61f7e17d08c91c28$exports = {};
$61f7e17d08c91c28$exports = new URL("SLURP_PINDERBASS_Ponte.c9883e99.jpg", import.meta.url).toString();


var $dd09167f2e5e4e50$exports = {};
$dd09167f2e5e4e50$exports = new URL("SLURP_PINDERBASS_legni.8363dff6.jpg", import.meta.url).toString();


var $cb83cdc85070ffc3$exports = {};
$cb83cdc85070ffc3$exports = new URL("SLURP_PINDERBASS_Equalizzazione.b7063c7b.jpg", import.meta.url).toString();


var $93ef6dbac0b70550$exports = {};
$93ef6dbac0b70550$exports = new URL("WOW_KLEIN_principale.3eec29cf.jpg", import.meta.url).toString();


var $cdf0b31514d4242e$exports = {};
$cdf0b31514d4242e$exports = new URL("WOW_KLEIN_Pickup.4f17e2a6.jpg", import.meta.url).toString();


var $9dfba728f3ebdd23$exports = {};
$9dfba728f3ebdd23$exports = new URL("WOW_KLEIN_Ponte.fa600748.jpg", import.meta.url).toString();


var $8d5238aafb40a145$exports = {};
$8d5238aafb40a145$exports = new URL("WOW_KLEIN_Meccaniche e marchio.caf023bb.jpg", import.meta.url).toString();


var $7f5ea940fceaf31b$exports = {};
$7f5ea940fceaf31b$exports = new URL("ROAR_SPRING_principale.5ddd21df.jpg", import.meta.url).toString();


var $40c47754da9392d0$exports = {};
$40c47754da9392d0$exports = new URL("Meccaniche.c175c0ba.jpg", import.meta.url).toString();


var $b0bbc0267d9d0781$exports = {};
$b0bbc0267d9d0781$exports = new URL("Tailpiece.1a5da196.jpg", import.meta.url).toString();


var $b944daaa10d1601d$exports = {};
$b944daaa10d1601d$exports = new URL("Legni.6668b4b6.jpg", import.meta.url).toString();


var $c665b90645d240ca$exports = {};
$c665b90645d240ca$exports = new URL("SLURP_FELIPE_Principale.beb388c2.jpg", import.meta.url).toString();


var $57a0cff3c38f3494$exports = {};
$57a0cff3c38f3494$exports = new URL("Manico.854d2e80.jpg", import.meta.url).toString();


var $a128bc77d34f2927$exports = {};
$a128bc77d34f2927$exports = new URL("Nome.9c673b76.jpg", import.meta.url).toString();


var $0e80461ceea72951$exports = {};
$0e80461ceea72951$exports = new URL("Pickup ponte.6b975c63.jpg", import.meta.url).toString();


var $f04b9f58aa7e3aed$exports = {};
$f04b9f58aa7e3aed$exports = new URL("BOOM_MONOBLOCCO_principale.415211b7.jpg", import.meta.url).toString();


var $2f03e5c6f822fd5a$exports = {};
$2f03e5c6f822fd5a$exports = new URL("BOOM_MONOBLOCCO_Ponte.f094e07a.jpg", import.meta.url).toString();


var $05e5477acf4fda04$exports = {};
$05e5477acf4fda04$exports = new URL("BOOM_MONOBLOCCO_Giunzione manico.87efef98.jpg", import.meta.url).toString();


var $dbc1d20faf642973$exports = {};
$dbc1d20faf642973$exports = new URL("BOOM_MONOBLOCCO_Legni.00fd1a7d.jpg", import.meta.url).toString();


const $aa4966716cf79833$var$guitarCoverMap = {
    diapason: (/*@__PURE__*/$parcel$interopDefault($6a59e2522d0a422e$exports)),
    monoblocco: (/*@__PURE__*/$parcel$interopDefault($f04b9f58aa7e3aed$exports)),
    spring: (/*@__PURE__*/$parcel$interopDefault($7f5ea940fceaf31b$exports)),
    tretrecinque: (/*@__PURE__*/$parcel$interopDefault($9f5eb8e9b32da6fa$exports)),
    venere: (/*@__PURE__*/$parcel$interopDefault($6355f2d2c122bd0e$exports)),
    felipe: (/*@__PURE__*/$parcel$interopDefault($c665b90645d240ca$exports)),
    mono: (/*@__PURE__*/$parcel$interopDefault($6ab5a020cddd3bdb$exports)),
    pinderbass: (/*@__PURE__*/$parcel$interopDefault($f68aab68a9c28a83$exports)),
    klein: (/*@__PURE__*/$parcel$interopDefault($93ef6dbac0b70550$exports))
};
/**
 * Function to get guitar information based on the element name.
 * It retrieves the guitar data from the locale and constructs the necessary HTML elements.
 *
 * @param {string} elementName - The name of the guitar or series element.
 * @returns {object|null} - An object containing guitar information or null if not found.
 * @throws Will log a warning if no guitar is found for the given name.
 */ const $aa4966716cf79833$var$getInfo = (elementName)=>{
    let data = (0, (/*@__PURE__*/$parcel$interopDefault($4263edbfe9b8e435$exports)))[elementName];
    if (!data) for (const sectionKey of Object.keys((0, (/*@__PURE__*/$parcel$interopDefault($4263edbfe9b8e435$exports))))){
        const section = (0, (/*@__PURE__*/$parcel$interopDefault($4263edbfe9b8e435$exports)))[sectionKey];
        if (section.guitars && Array.isArray(section.guitars)) for (const guitarObj of section.guitars){
            const guitarKey = Object.keys(guitarObj)[0];
            if (guitarKey.toLowerCase() === elementName.toLowerCase()) {
                data = guitarObj[guitarKey];
                break;
            }
        }
        if (data) break;
    }
    if (!data) {
        console.warn("[openModal]: No guitar found.", {
            name: elementName,
            data: data
        });
        return null;
    }
    const images = [];
    let table = (0, $a305a376c9462dbd$export$185802fd694ee1f5)("table");
    switch(elementName){
        case "diapason":
            images.push((0, (/*@__PURE__*/$parcel$interopDefault($6a59e2522d0a422e$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($2ffa2c54c6a114ef$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($028532da9ff1f621$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($217d47a239f32826$exports))));
            break;
        case "tretrecinque":
            images.push((0, (/*@__PURE__*/$parcel$interopDefault($9f5eb8e9b32da6fa$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($e30b7a8a55b34f44$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($59e791cdf70ee155$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($9daaa99c344a467b$exports))));
            break;
        case "venere":
            images.push((0, (/*@__PURE__*/$parcel$interopDefault($6355f2d2c122bd0e$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($f92d7402ec7b0c8f$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($784db09a50aa83e0$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($76d0faf7543367bf$exports))));
            break;
        case "mono":
            images.push((0, (/*@__PURE__*/$parcel$interopDefault($6ab5a020cddd3bdb$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($fea54437f50b2827$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($ebd9325ca325cc6e$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($4b46523206336629$exports))));
            break;
        case "pinderbass":
            images.push((0, (/*@__PURE__*/$parcel$interopDefault($f68aab68a9c28a83$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($61f7e17d08c91c28$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($dd09167f2e5e4e50$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($cb83cdc85070ffc3$exports))));
            break;
        case "klein":
            images.push((0, (/*@__PURE__*/$parcel$interopDefault($93ef6dbac0b70550$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($cdf0b31514d4242e$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($9dfba728f3ebdd23$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($8d5238aafb40a145$exports))));
            break;
        case "felipe":
            images.push((0, (/*@__PURE__*/$parcel$interopDefault($c665b90645d240ca$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($57a0cff3c38f3494$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($a128bc77d34f2927$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($0e80461ceea72951$exports))));
            break;
        case "monoblocco":
            images.push((0, (/*@__PURE__*/$parcel$interopDefault($f04b9f58aa7e3aed$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($2f03e5c6f822fd5a$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($05e5477acf4fda04$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($dbc1d20faf642973$exports))));
            break;
        case "spring":
            images.push((0, (/*@__PURE__*/$parcel$interopDefault($7f5ea940fceaf31b$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($40c47754da9392d0$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($b0bbc0267d9d0781$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($b944daaa10d1601d$exports))));
            break;
        case "wow":
            images.push((0, (/*@__PURE__*/$parcel$interopDefault($93ef6dbac0b70550$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($cdf0b31514d4242e$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($9dfba728f3ebdd23$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($8d5238aafb40a145$exports))));
            break;
        case "roar":
            images.push((0, (/*@__PURE__*/$parcel$interopDefault($9f5eb8e9b32da6fa$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($40c47754da9392d0$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($6355f2d2c122bd0e$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($f92d7402ec7b0c8f$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($b944daaa10d1601d$exports))));
            break;
        case "boom":
            images.push((0, (/*@__PURE__*/$parcel$interopDefault($6a59e2522d0a422e$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($2ffa2c54c6a114ef$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($f04b9f58aa7e3aed$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($2f03e5c6f822fd5a$exports))));
            break;
        case "slurp":
            images.push((0, (/*@__PURE__*/$parcel$interopDefault($6ab5a020cddd3bdb$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($fea54437f50b2827$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($f68aab68a9c28a83$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($61f7e17d08c91c28$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($a128bc77d34f2927$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($57a0cff3c38f3494$exports))));
    }
    const swiper = new (0, $1262f2e38e280703$export$25ce5a424b770e84)(".mySwiper", {
        modules: [
            (0, $dc75855670d5bebb$export$2e2bcd8739ae039),
            (0, $a65bf22b710e8cc3$export$2e2bcd8739ae039)
        ],
        slidesPerView: "auto",
        spaceBetween: 20,
        centeredSlides: false,
        loop: true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
            enabled: false
        }
    });
    const swiperWrapper = (0, $a305a376c9462dbd$export$2e6c959c16ff56b8)(".swiper-wrapper");
    swiperWrapper.innerHTML = ""; // reset
    for (const image of images.slice(1)){
        const div = (0, $a305a376c9462dbd$export$185802fd694ee1f5)("div");
        div.classList.add("swiper-slide");
        const img = (0, $a305a376c9462dbd$export$185802fd694ee1f5)("img");
        img.src = image;
        img.alt = data.title;
        div.appendChild(img);
        swiperWrapper.appendChild(div);
    }
    swiper.update();
    Object.keys(data.dataSheet).forEach((key)=>{
        const tr = (0, $a305a376c9462dbd$export$185802fd694ee1f5)("tr");
        const th = (0, $a305a376c9462dbd$export$185802fd694ee1f5)("th");
        const td = (0, $a305a376c9462dbd$export$185802fd694ee1f5)("td");
        th.textContent = key;
        td.textContent = data.dataSheet[key];
        tr.appendChild(th);
        tr.appendChild(td);
        table.appendChild(tr);
    });
    return {
        title: data.title,
        description: data.description,
        dataSheet: data.dataSheet,
        images: images,
        table: table
    };
};
const $aa4966716cf79833$var$onOpenModal = (elName, options = {
    section: null,
    typology: null
})=>{
    if (!elName || !options || !options.section) return console.warn("[openModal]: No element or section provided.");
    const title = (0, $a305a376c9462dbd$export$2e6c959c16ff56b8)(".modal__title");
    const description = (0, $a305a376c9462dbd$export$2e6c959c16ff56b8)(".modal__description");
    const dataSheet = (0, $a305a376c9462dbd$export$2e6c959c16ff56b8)(".modal__data__sheet");
    const image = (0, $a305a376c9462dbd$export$2e6c959c16ff56b8)(".modal__image");
    const swiper = (0, $a305a376c9462dbd$export$2e6c959c16ff56b8)(".swiper");
    const seriesListContainer = (0, $a305a376c9462dbd$export$2e6c959c16ff56b8)(".modal__series-list");
    // always reset
    title.innerHTML = "";
    description.innerHTML = "";
    dataSheet.innerHTML = "";
    image.innerHTML = "";
    if (seriesListContainer) seriesListContainer.innerHTML = "";
    // then create elements
    const h2 = (0, $a305a376c9462dbd$export$185802fd694ee1f5)("h2");
    const p = (0, $a305a376c9462dbd$export$185802fd694ee1f5)("p");
    const table = (0, $a305a376c9462dbd$export$185802fd694ee1f5)("table");
    const img = (0, $a305a376c9462dbd$export$185802fd694ee1f5)("img");
    let element = null;
    switch(options.section){
        case "guitars":
            element = $aa4966716cf79833$var$getInfo(elName);
            break;
        case "about":
            element = (0, (/*@__PURE__*/$parcel$interopDefault($4263edbfe9b8e435$exports)))[elName] || (0, (/*@__PURE__*/$parcel$interopDefault($4263edbfe9b8e435$exports))).filosofy;
            break;
        default:
            console.warn("[openModal]: No section provided.");
            break;
    }
    if (!element) {
        console.warn("[openModal]: No element found for", elName);
        return;
    }
    h2.textContent = element.title ?? "";
    p.textContent = element.description ?? "";
    // Handle different data structures
    if (options.section === "about") {
        // For about section, hide data sheet, swiper and modal__image
        table.innerHTML = "";
        img.src = "";
        img.alt = element.title ?? "About Image";
        // Hide swiper and modal__image for about section
        if (swiper) swiper.style.display = "none";
        if (image) {
            image.style.display = "none";
            image.href = "#";
        }
    } else {
        // For guitars section
        table.innerHTML = element.table?.innerHTML ?? "";
        img.src = element.images?.[0] ?? "";
        img.alt = element.title ?? "Guitar Image";
        if (options.typology === "guitar") {
            // Hide swiper for individual guitars
            if (swiper) swiper.style.display = "none";
            if (image) {
                image.style.display = "";
                image.href = elName ? `./${elName}.html` : "#";
            }
        } else {
            // For series: hide modal__image, show swiper with cover images only
            if (image) {
                image.style.display = "none";
                image.style.cursor = "";
                image.onclick = null;
            }
            // Populate swiper with guitar cover images from the series
            const seriesKey = elName?.toLowerCase();
            const seriesData = (0, (/*@__PURE__*/$parcel$interopDefault($4263edbfe9b8e435$exports)))[seriesKey];
            if (seriesData?.guitars && Array.isArray(seriesData.guitars) && swiper) {
                swiper.style.display = "";
                const swiperWrapper = (0, $a305a376c9462dbd$export$2e6c959c16ff56b8)(".swiper-wrapper");
                if (swiperWrapper) {
                    swiperWrapper.innerHTML = "";
                    for (const guitarObj of seriesData.guitars){
                        const guitarKey = Object.keys(guitarObj)[0];
                        const cover = $aa4966716cf79833$var$guitarCoverMap[guitarKey];
                        if (cover) {
                            const div = (0, $a305a376c9462dbd$export$185802fd694ee1f5)("div");
                            div.classList.add("swiper-slide");
                            div.style.cursor = "pointer";
                            const coverImg = (0, $a305a376c9462dbd$export$185802fd694ee1f5)("img");
                            coverImg.src = cover;
                            coverImg.alt = guitarKey;
                            div.appendChild(coverImg);
                            // On click, dispatch custom event for app.js to handle map navigation
                            div.addEventListener("click", ()=>{
                                document.dispatchEvent(new CustomEvent("guitar-select", {
                                    detail: {
                                        guitarName: guitarKey
                                    }
                                }));
                            });
                            swiperWrapper.appendChild(div);
                        }
                    }
                    // Re-init swiper
                    const swiperInstance = new (0, $1262f2e38e280703$export$25ce5a424b770e84)(".mySwiper", {
                        modules: [
                            (0, $dc75855670d5bebb$export$2e2bcd8739ae039),
                            (0, $a65bf22b710e8cc3$export$2e2bcd8739ae039)
                        ],
                        slidesPerView: "auto",
                        spaceBetween: 20,
                        centeredSlides: true,
                        centeredSlidesBounds: true,
                        pagination: {
                            el: ".swiper-pagination",
                            clickable: true,
                            enabled: false
                        }
                    });
                    // Placeholder per swiper
                    for(let i = 0; i < 2; i++){
                        const placeholder = (0, $a305a376c9462dbd$export$185802fd694ee1f5)("div");
                        placeholder.classList.add("swiper-slide", "swiper-slide--placeholder");
                        swiperWrapper.appendChild(placeholder);
                    }
                    swiperInstance.update();
                }
            } else if (swiper) swiper.style.display = "none";
        }
    // if (options.typology === "series" && seriesListContainer) {
    //   console.log("entro", seriesListContainer);
    //   console.log("1. entro nel blocco series");
    //   const seriesKey = elName?.toLowerCase();
    //   const seriesData = locale[seriesKey];
    //   console.log("2. seriesData:", seriesData);
    //   if (seriesData?.guitars && Array.isArray(seriesData.guitars)) {
    //     console.log("3. guitars trovate:", seriesData.guitars.length);
    //     const wrapper = create("div");
    //     wrapper.classList.add("element__wrapper");
    //     const ul = create("ul");
    //     ul.classList.add("element__list");
    //     for (const guitarObj of seriesData.guitars) {
    //       const guitarKey = Object.keys(guitarObj)[0];
    //       const guitarData = guitarObj[guitarKey];
    //       const dataSheet = guitarData?.dataSheet || {};
    //       const a = create("a");
    //       a.href = `./${guitarKey}.html`;
    //       const li = create("li");
    //       li.classList.add("element__item");
    //       const summary = create("div");
    //       summary.classList.add("element__summary");
    //       const spanSeries = create("span");
    //       spanSeries.textContent = seriesKey;
    //       const spanTitle = create("span");
    //       spanTitle.textContent = guitarData?.title || guitarKey;
    //       const spanYear = create("span");
    //       spanYear.textContent = dataSheet.Anno || "";
    //       const cover = guitarCoverMap[guitarKey];
    //       if (cover) {
    //         const coverImg = create("img");
    //         coverImg.src = cover;
    //         coverImg.alt = guitarData?.title || guitarKey;
    //         summary.appendChild(spanSeries);
    //         summary.appendChild(spanTitle);
    //         summary.appendChild(spanYear);
    //         summary.appendChild(coverImg);
    //       } else {
    //         summary.appendChild(spanSeries);
    //         summary.appendChild(spanTitle);
    //         if (spanYear.textContent) summary.appendChild(spanYear);
    //       }
    //       li.appendChild(summary);
    //       a.appendChild(li);
    //       ul.appendChild(a);
    //     }
    //     // Placeholders for responsive design
    //     if (options.typology === "series") {
    //       for (let i = 0; i < 2; i++) {
    //         const placeholder = create("li");
    //         placeholder.classList.add(
    //           "element__item",
    //           "element__item--placeholder",
    //         );
    //         ul.appendChild(placeholder);
    //       }
    //     }
    //     wrapper.appendChild(ul);
    //     seriesListContainer.appendChild(wrapper);
    //     seriesListContainer.style.display = "none"; // Temporary hide
    //   }
    // }
    }
    title.appendChild(h2);
    description.appendChild(p);
    dataSheet.appendChild(table);
    image.appendChild(img);
};
var $aa4966716cf79833$export$2e2bcd8739ae039 = $aa4966716cf79833$var$onOpenModal;


// TODO: open modal for other sections
const $2d4978547e811d38$var$openModal = (elName, options = {
    section: null,
    typology: null
})=>{
    const { section: section, typology: typology } = options;
    try {
        (0, $aa4966716cf79833$export$2e2bcd8739ae039)(elName, {
            section: section,
            typology: typology
        });
        (0, $357b3f2d5f2ec9d5$export$99ee26438460406a).to(".overlay__modal", {
            opacity: 1,
            display: "block",
            transform: "translateX(0)",
            duration: 1,
            ease: "power3.inOut"
        });
    } catch (error) {
        console.error("[openModal]:", error);
    }
};
var $2d4978547e811d38$export$2e2bcd8739ae039 = $2d4978547e811d38$var$openModal;



const $9dac4c1a5bd2d9fc$var$closeModal = ()=>{
    (0, $357b3f2d5f2ec9d5$export$99ee26438460406a).to(".overlay__modal", {
        opacity: 1,
        transform: "translateX(100%)",
        duration: 1,
        ease: "power3.inOut"
    });
};
var $9dac4c1a5bd2d9fc$export$2e2bcd8739ae039 = $9dac4c1a5bd2d9fc$var$closeModal;


/*!
 * ScrollTrigger 3.12.5
 * https://gsap.com
 *
 * @license Copyright 2008-2024, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ function $d7385dda6eeeec57$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $d7385dda6eeeec57$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $d7385dda6eeeec57$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $d7385dda6eeeec57$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
/*!
 * Observer 3.12.5
 * https://gsap.com
 *
 * @license Copyright 2008-2024, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var $d7385dda6eeeec57$var$gsap, $d7385dda6eeeec57$var$_coreInitted, $d7385dda6eeeec57$var$_clamp, $d7385dda6eeeec57$var$_win, $d7385dda6eeeec57$var$_doc, $d7385dda6eeeec57$var$_docEl, $d7385dda6eeeec57$var$_body, $d7385dda6eeeec57$var$_isTouch, $d7385dda6eeeec57$var$_pointerType, $d7385dda6eeeec57$var$ScrollTrigger, $d7385dda6eeeec57$var$_root, $d7385dda6eeeec57$var$_normalizer, $d7385dda6eeeec57$var$_eventTypes, $d7385dda6eeeec57$var$_context, $d7385dda6eeeec57$var$_getGSAP = function _getGSAP() {
    return $d7385dda6eeeec57$var$gsap || typeof window !== "undefined" && ($d7385dda6eeeec57$var$gsap = window.gsap) && $d7385dda6eeeec57$var$gsap.registerPlugin && $d7385dda6eeeec57$var$gsap;
}, $d7385dda6eeeec57$var$_startup = 1, $d7385dda6eeeec57$var$_observers = [], $d7385dda6eeeec57$export$3cd1cee43d19b683 = [], $d7385dda6eeeec57$export$d8e56d510a804d0a = [], $d7385dda6eeeec57$var$_getTime = Date.now, $d7385dda6eeeec57$var$_bridge = function _bridge(name, value) {
    return value;
}, $d7385dda6eeeec57$var$_integrate = function _integrate() {
    var core = $d7385dda6eeeec57$var$ScrollTrigger.core, data = core.bridge || {}, scrollers = core._scrollers, proxies = core._proxies;
    scrollers.push.apply(scrollers, $d7385dda6eeeec57$export$3cd1cee43d19b683);
    proxies.push.apply(proxies, $d7385dda6eeeec57$export$d8e56d510a804d0a);
    $d7385dda6eeeec57$export$3cd1cee43d19b683 = scrollers;
    $d7385dda6eeeec57$export$d8e56d510a804d0a = proxies;
    $d7385dda6eeeec57$var$_bridge = function _bridge(name, value) {
        return data[name](value);
    };
}, $d7385dda6eeeec57$export$6078f1ef08b38af9 = function _getProxyProp(element, property) {
    return ~$d7385dda6eeeec57$export$d8e56d510a804d0a.indexOf(element) && $d7385dda6eeeec57$export$d8e56d510a804d0a[$d7385dda6eeeec57$export$d8e56d510a804d0a.indexOf(element) + 1][property];
}, $d7385dda6eeeec57$export$4330f3a92e5d2e94 = function _isViewport(el) {
    return !!~$d7385dda6eeeec57$var$_root.indexOf(el);
}, $d7385dda6eeeec57$var$_addListener = function _addListener(element, type, func, passive, capture) {
    return element.addEventListener(type, func, {
        passive: passive !== false,
        capture: !!capture
    });
}, $d7385dda6eeeec57$var$_removeListener = function _removeListener(element, type, func, capture) {
    return element.removeEventListener(type, func, !!capture);
}, $d7385dda6eeeec57$var$_scrollLeft = "scrollLeft", $d7385dda6eeeec57$var$_scrollTop = "scrollTop", $d7385dda6eeeec57$var$_onScroll = function _onScroll() {
    return $d7385dda6eeeec57$var$_normalizer && $d7385dda6eeeec57$var$_normalizer.isPressed || $d7385dda6eeeec57$export$3cd1cee43d19b683.cache++;
}, $d7385dda6eeeec57$var$_scrollCacheFunc = function _scrollCacheFunc(f, doNotCache) {
    var cachingFunc = function cachingFunc(value) {
        // since reading the scrollTop/scrollLeft/pageOffsetY/pageOffsetX can trigger a layout, this function allows us to cache the value so it only gets read fresh after a "scroll" event fires (or while we're refreshing because that can lengthen the page and alter the scroll position). when "soft" is true, that means don't actually set the scroll, but cache the new value instead (useful in ScrollSmoother)
        if (value || value === 0) {
            $d7385dda6eeeec57$var$_startup && ($d7385dda6eeeec57$var$_win.history.scrollRestoration = "manual"); // otherwise the new position will get overwritten by the browser onload.
            var isNormalizing = $d7385dda6eeeec57$var$_normalizer && $d7385dda6eeeec57$var$_normalizer.isPressed;
            value = cachingFunc.v = Math.round(value) || ($d7385dda6eeeec57$var$_normalizer && $d7385dda6eeeec57$var$_normalizer.iOS ? 1 : 0); //TODO: iOS Bug: if you allow it to go to 0, Safari can start to report super strange (wildly inaccurate) touch positions!
            f(value);
            cachingFunc.cacheID = $d7385dda6eeeec57$export$3cd1cee43d19b683.cache;
            isNormalizing && $d7385dda6eeeec57$var$_bridge("ss", value); // set scroll (notify ScrollTrigger so it can dispatch a "scrollStart" event if necessary
        } else if (doNotCache || $d7385dda6eeeec57$export$3cd1cee43d19b683.cache !== cachingFunc.cacheID || $d7385dda6eeeec57$var$_bridge("ref")) {
            cachingFunc.cacheID = $d7385dda6eeeec57$export$3cd1cee43d19b683.cache;
            cachingFunc.v = f();
        }
        return cachingFunc.v + cachingFunc.offset;
    };
    cachingFunc.offset = 0;
    return f && cachingFunc;
}, $d7385dda6eeeec57$export$b2cabb342cb0ebe1 = {
    s: $d7385dda6eeeec57$var$_scrollLeft,
    p: "left",
    p2: "Left",
    os: "right",
    os2: "Right",
    d: "width",
    d2: "Width",
    a: "x",
    sc: $d7385dda6eeeec57$var$_scrollCacheFunc(function(value) {
        return arguments.length ? $d7385dda6eeeec57$var$_win.scrollTo(value, $d7385dda6eeeec57$export$8e40fc98ff518e9d.sc()) : $d7385dda6eeeec57$var$_win.pageXOffset || $d7385dda6eeeec57$var$_doc[$d7385dda6eeeec57$var$_scrollLeft] || $d7385dda6eeeec57$var$_docEl[$d7385dda6eeeec57$var$_scrollLeft] || $d7385dda6eeeec57$var$_body[$d7385dda6eeeec57$var$_scrollLeft] || 0;
    })
}, $d7385dda6eeeec57$export$8e40fc98ff518e9d = {
    s: $d7385dda6eeeec57$var$_scrollTop,
    p: "top",
    p2: "Top",
    os: "bottom",
    os2: "Bottom",
    d: "height",
    d2: "Height",
    a: "y",
    op: $d7385dda6eeeec57$export$b2cabb342cb0ebe1,
    sc: $d7385dda6eeeec57$var$_scrollCacheFunc(function(value) {
        return arguments.length ? $d7385dda6eeeec57$var$_win.scrollTo($d7385dda6eeeec57$export$b2cabb342cb0ebe1.sc(), value) : $d7385dda6eeeec57$var$_win.pageYOffset || $d7385dda6eeeec57$var$_doc[$d7385dda6eeeec57$var$_scrollTop] || $d7385dda6eeeec57$var$_docEl[$d7385dda6eeeec57$var$_scrollTop] || $d7385dda6eeeec57$var$_body[$d7385dda6eeeec57$var$_scrollTop] || 0;
    })
}, $d7385dda6eeeec57$export$937374fea3f88711 = function _getTarget(t, self) {
    return (self && self._ctx && self._ctx.selector || $d7385dda6eeeec57$var$gsap.utils.toArray)(t)[0] || (typeof t === "string" && $d7385dda6eeeec57$var$gsap.config().nullTargetWarn !== false ? console.warn("Element not found:", t) : null);
}, $d7385dda6eeeec57$export$8665aac53dad5647 = function _getScrollFunc(element, _ref) {
    var s = _ref.s, sc = _ref.sc;
    // we store the scroller functions in an alternating sequenced Array like [element, verticalScrollFunc, horizontalScrollFunc, ...] so that we can minimize memory, maximize performance, and we also record the last position as a ".rec" property in order to revert to that after refreshing to ensure things don't shift around.
    $d7385dda6eeeec57$export$4330f3a92e5d2e94(element) && (element = $d7385dda6eeeec57$var$_doc.scrollingElement || $d7385dda6eeeec57$var$_docEl);
    var i = $d7385dda6eeeec57$export$3cd1cee43d19b683.indexOf(element), offset = sc === $d7385dda6eeeec57$export$8e40fc98ff518e9d.sc ? 1 : 2;
    !~i && (i = $d7385dda6eeeec57$export$3cd1cee43d19b683.push(element) - 1);
    $d7385dda6eeeec57$export$3cd1cee43d19b683[i + offset] || $d7385dda6eeeec57$var$_addListener(element, "scroll", $d7385dda6eeeec57$var$_onScroll); // clear the cache when a scroll occurs
    var prev = $d7385dda6eeeec57$export$3cd1cee43d19b683[i + offset], func = prev || ($d7385dda6eeeec57$export$3cd1cee43d19b683[i + offset] = $d7385dda6eeeec57$var$_scrollCacheFunc($d7385dda6eeeec57$export$6078f1ef08b38af9(element, s), true) || ($d7385dda6eeeec57$export$4330f3a92e5d2e94(element) ? sc : $d7385dda6eeeec57$var$_scrollCacheFunc(function(value) {
        return arguments.length ? element[s] = value : element[s];
    })));
    func.target = element;
    prev || (func.smooth = $d7385dda6eeeec57$var$gsap.getProperty(element, "scrollBehavior") === "smooth"); // only set it the first time (don't reset every time a scrollFunc is requested because perhaps it happens during a refresh() when it's disabled in ScrollTrigger.
    return func;
}, $d7385dda6eeeec57$export$5de019f4480f0f8d = function _getVelocityProp(value, minTimeRefresh, useDelta) {
    var v1 = value, v2 = value, t1 = $d7385dda6eeeec57$var$_getTime(), t2 = t1, min = minTimeRefresh || 50, dropToZeroTime = Math.max(500, min * 3), update = function update(value, force) {
        var t = $d7385dda6eeeec57$var$_getTime();
        if (force || t - t1 > min) {
            v2 = v1;
            v1 = value;
            t2 = t1;
            t1 = t;
        } else if (useDelta) v1 += value;
        else // not totally necessary, but makes it a bit more accurate by adjusting the v1 value according to the new slope. This way we're not just ignoring the incoming data. Removing for now because it doesn't seem to make much practical difference and it's probably not worth the kb.
        v1 = v2 + (value - v2) / (t - t2) * (t1 - t2);
    }, reset = function reset() {
        v2 = v1 = useDelta ? 0 : v1;
        t2 = t1 = 0;
    }, getVelocity = function getVelocity(latestValue) {
        var tOld = t2, vOld = v2, t = $d7385dda6eeeec57$var$_getTime();
        (latestValue || latestValue === 0) && latestValue !== v1 && update(latestValue);
        return t1 === t2 || t - t2 > dropToZeroTime ? 0 : (v1 + (useDelta ? vOld : -vOld)) / ((useDelta ? t : t1) - tOld) * 1000;
    };
    return {
        update: update,
        reset: reset,
        getVelocity: getVelocity
    };
}, $d7385dda6eeeec57$var$_getEvent = function _getEvent(e, preventDefault) {
    preventDefault && !e._gsapAllow && e.preventDefault();
    return e.changedTouches ? e.changedTouches[0] : e;
}, $d7385dda6eeeec57$var$_getAbsoluteMax = function _getAbsoluteMax(a) {
    var max = Math.max.apply(Math, a), min = Math.min.apply(Math, a);
    return Math.abs(max) >= Math.abs(min) ? max : min;
}, $d7385dda6eeeec57$var$_setScrollTrigger = function _setScrollTrigger() {
    $d7385dda6eeeec57$var$ScrollTrigger = $d7385dda6eeeec57$var$gsap.core.globals().ScrollTrigger;
    $d7385dda6eeeec57$var$ScrollTrigger && $d7385dda6eeeec57$var$ScrollTrigger.core && $d7385dda6eeeec57$var$_integrate();
}, $d7385dda6eeeec57$var$_initCore = function _initCore(core) {
    $d7385dda6eeeec57$var$gsap = core || $d7385dda6eeeec57$var$_getGSAP();
    if (!$d7385dda6eeeec57$var$_coreInitted && $d7385dda6eeeec57$var$gsap && typeof document !== "undefined" && document.body) {
        $d7385dda6eeeec57$var$_win = window;
        $d7385dda6eeeec57$var$_doc = document;
        $d7385dda6eeeec57$var$_docEl = $d7385dda6eeeec57$var$_doc.documentElement;
        $d7385dda6eeeec57$var$_body = $d7385dda6eeeec57$var$_doc.body;
        $d7385dda6eeeec57$var$_root = [
            $d7385dda6eeeec57$var$_win,
            $d7385dda6eeeec57$var$_doc,
            $d7385dda6eeeec57$var$_docEl,
            $d7385dda6eeeec57$var$_body
        ];
        $d7385dda6eeeec57$var$_clamp = $d7385dda6eeeec57$var$gsap.utils.clamp;
        $d7385dda6eeeec57$var$_context = $d7385dda6eeeec57$var$gsap.core.context || function() {};
        $d7385dda6eeeec57$var$_pointerType = "onpointerenter" in $d7385dda6eeeec57$var$_body ? "pointer" : "mouse"; // isTouch is 0 if no touch, 1 if ONLY touch, and 2 if it can accommodate touch but also other types like mouse/pointer.
        $d7385dda6eeeec57$var$_isTouch = $d7385dda6eeeec57$export$c1cbdee04e18ea8b.isTouch = $d7385dda6eeeec57$var$_win.matchMedia && $d7385dda6eeeec57$var$_win.matchMedia("(hover: none), (pointer: coarse)").matches ? 1 : "ontouchstart" in $d7385dda6eeeec57$var$_win || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0 ? 2 : 0;
        $d7385dda6eeeec57$var$_eventTypes = $d7385dda6eeeec57$export$c1cbdee04e18ea8b.eventTypes = ("ontouchstart" in $d7385dda6eeeec57$var$_docEl ? "touchstart,touchmove,touchcancel,touchend" : !("onpointerdown" in $d7385dda6eeeec57$var$_docEl) ? "mousedown,mousemove,mouseup,mouseup" : "pointerdown,pointermove,pointercancel,pointerup").split(",");
        setTimeout(function() {
            return $d7385dda6eeeec57$var$_startup = 0;
        }, 500);
        $d7385dda6eeeec57$var$_setScrollTrigger();
        $d7385dda6eeeec57$var$_coreInitted = 1;
    }
    return $d7385dda6eeeec57$var$_coreInitted;
};
$d7385dda6eeeec57$export$b2cabb342cb0ebe1.op = $d7385dda6eeeec57$export$8e40fc98ff518e9d;
$d7385dda6eeeec57$export$3cd1cee43d19b683.cache = 0;
var $d7385dda6eeeec57$export$c1cbdee04e18ea8b = /*#__PURE__*/ function() {
    function Observer(vars) {
        this.init(vars);
    }
    var _proto = Observer.prototype;
    _proto.init = function init(vars) {
        $d7385dda6eeeec57$var$_coreInitted || $d7385dda6eeeec57$var$_initCore($d7385dda6eeeec57$var$gsap) || console.warn("Please gsap.registerPlugin(Observer)");
        $d7385dda6eeeec57$var$ScrollTrigger || $d7385dda6eeeec57$var$_setScrollTrigger();
        var tolerance = vars.tolerance, dragMinimum = vars.dragMinimum, type = vars.type, target = vars.target, lineHeight = vars.lineHeight, debounce = vars.debounce, preventDefault = vars.preventDefault, onStop = vars.onStop, onStopDelay = vars.onStopDelay, ignore = vars.ignore, wheelSpeed = vars.wheelSpeed, event = vars.event, onDragStart = vars.onDragStart, onDragEnd = vars.onDragEnd, onDrag = vars.onDrag, onPress = vars.onPress, onRelease = vars.onRelease, onRight = vars.onRight, onLeft = vars.onLeft, onUp = vars.onUp, onDown = vars.onDown, onChangeX = vars.onChangeX, onChangeY = vars.onChangeY, onChange = vars.onChange, onToggleX = vars.onToggleX, onToggleY = vars.onToggleY, onHover = vars.onHover, onHoverEnd = vars.onHoverEnd, onMove = vars.onMove, ignoreCheck = vars.ignoreCheck, isNormalizer = vars.isNormalizer, onGestureStart = vars.onGestureStart, onGestureEnd = vars.onGestureEnd, onWheel = vars.onWheel, onEnable = vars.onEnable, onDisable = vars.onDisable, onClick = vars.onClick, scrollSpeed = vars.scrollSpeed, capture = vars.capture, allowClicks = vars.allowClicks, lockAxis = vars.lockAxis, onLockAxis = vars.onLockAxis;
        this.target = target = $d7385dda6eeeec57$export$937374fea3f88711(target) || $d7385dda6eeeec57$var$_docEl;
        this.vars = vars;
        ignore && (ignore = $d7385dda6eeeec57$var$gsap.utils.toArray(ignore));
        tolerance = tolerance || 1e-9;
        dragMinimum = dragMinimum || 0;
        wheelSpeed = wheelSpeed || 1;
        scrollSpeed = scrollSpeed || 1;
        type = type || "wheel,touch,pointer";
        debounce = debounce !== false;
        lineHeight || (lineHeight = parseFloat($d7385dda6eeeec57$var$_win.getComputedStyle($d7385dda6eeeec57$var$_body).lineHeight) || 22); // note: browser may report "normal", so default to 22.
        var id, onStopDelayedCall, dragged, moved, wheeled, locked, axis, self = this, prevDeltaX = 0, prevDeltaY = 0, passive = vars.passive || !preventDefault, scrollFuncX = $d7385dda6eeeec57$export$8665aac53dad5647(target, $d7385dda6eeeec57$export$b2cabb342cb0ebe1), scrollFuncY = $d7385dda6eeeec57$export$8665aac53dad5647(target, $d7385dda6eeeec57$export$8e40fc98ff518e9d), scrollX = scrollFuncX(), scrollY = scrollFuncY(), limitToTouch = ~type.indexOf("touch") && !~type.indexOf("pointer") && $d7385dda6eeeec57$var$_eventTypes[0] === "pointerdown", // for devices that accommodate mouse events and touch events, we need to distinguish.
        isViewport = $d7385dda6eeeec57$export$4330f3a92e5d2e94(target), ownerDoc = target.ownerDocument || $d7385dda6eeeec57$var$_doc, deltaX = [
            0,
            0,
            0
        ], // wheel, scroll, pointer/touch
        deltaY = [
            0,
            0,
            0
        ], onClickTime = 0, clickCapture = function clickCapture() {
            return onClickTime = $d7385dda6eeeec57$var$_getTime();
        }, _ignoreCheck = function _ignoreCheck(e, isPointerOrTouch) {
            return (self.event = e) && ignore && ~ignore.indexOf(e.target) || isPointerOrTouch && limitToTouch && e.pointerType !== "touch" || ignoreCheck && ignoreCheck(e, isPointerOrTouch);
        }, onStopFunc = function onStopFunc() {
            self._vx.reset();
            self._vy.reset();
            onStopDelayedCall.pause();
            onStop && onStop(self);
        }, update = function update() {
            var dx = self.deltaX = $d7385dda6eeeec57$var$_getAbsoluteMax(deltaX), dy = self.deltaY = $d7385dda6eeeec57$var$_getAbsoluteMax(deltaY), changedX = Math.abs(dx) >= tolerance, changedY = Math.abs(dy) >= tolerance;
            onChange && (changedX || changedY) && onChange(self, dx, dy, deltaX, deltaY); // in ScrollTrigger.normalizeScroll(), we need to know if it was touch/pointer so we need access to the deltaX/deltaY Arrays before we clear them out.
            if (changedX) {
                onRight && self.deltaX > 0 && onRight(self);
                onLeft && self.deltaX < 0 && onLeft(self);
                onChangeX && onChangeX(self);
                onToggleX && self.deltaX < 0 !== prevDeltaX < 0 && onToggleX(self);
                prevDeltaX = self.deltaX;
                deltaX[0] = deltaX[1] = deltaX[2] = 0;
            }
            if (changedY) {
                onDown && self.deltaY > 0 && onDown(self);
                onUp && self.deltaY < 0 && onUp(self);
                onChangeY && onChangeY(self);
                onToggleY && self.deltaY < 0 !== prevDeltaY < 0 && onToggleY(self);
                prevDeltaY = self.deltaY;
                deltaY[0] = deltaY[1] = deltaY[2] = 0;
            }
            if (moved || dragged) {
                onMove && onMove(self);
                if (dragged) {
                    onDrag(self);
                    dragged = false;
                }
                moved = false;
            }
            locked && (locked = false, true) && onLockAxis && onLockAxis(self);
            if (wheeled) {
                onWheel(self);
                wheeled = false;
            }
            id = 0;
        }, onDelta = function onDelta(x, y, index) {
            deltaX[index] += x;
            deltaY[index] += y;
            self._vx.update(x);
            self._vy.update(y);
            debounce ? id || (id = requestAnimationFrame(update)) : update();
        }, onTouchOrPointerDelta = function onTouchOrPointerDelta(x, y) {
            if (lockAxis && !axis) {
                self.axis = axis = Math.abs(x) > Math.abs(y) ? "x" : "y";
                locked = true;
            }
            if (axis !== "y") {
                deltaX[2] += x;
                self._vx.update(x, true); // update the velocity as frequently as possible instead of in the debounced function so that very quick touch-scrolls (flicks) feel natural. If it's the mouse/touch/pointer, force it so that we get snappy/accurate momentum scroll.
            }
            if (axis !== "x") {
                deltaY[2] += y;
                self._vy.update(y, true);
            }
            debounce ? id || (id = requestAnimationFrame(update)) : update();
        }, _onDrag = function _onDrag(e) {
            if (_ignoreCheck(e, 1)) return;
            e = $d7385dda6eeeec57$var$_getEvent(e, preventDefault);
            var x = e.clientX, y = e.clientY, dx = x - self.x, dy = y - self.y, isDragging = self.isDragging;
            self.x = x;
            self.y = y;
            if (isDragging || Math.abs(self.startX - x) >= dragMinimum || Math.abs(self.startY - y) >= dragMinimum) {
                onDrag && (dragged = true);
                isDragging || (self.isDragging = true);
                onTouchOrPointerDelta(dx, dy);
                isDragging || onDragStart && onDragStart(self);
            }
        }, _onPress = self.onPress = function(e) {
            if (_ignoreCheck(e, 1) || e && e.button) return;
            self.axis = axis = null;
            onStopDelayedCall.pause();
            self.isPressed = true;
            e = $d7385dda6eeeec57$var$_getEvent(e); // note: may need to preventDefault(?) Won't side-scroll on iOS Safari if we do, though.
            prevDeltaX = prevDeltaY = 0;
            self.startX = self.x = e.clientX;
            self.startY = self.y = e.clientY;
            self._vx.reset(); // otherwise the t2 may be stale if the user touches and flicks super fast and releases in less than 2 requestAnimationFrame ticks, causing velocity to be 0.
            self._vy.reset();
            $d7385dda6eeeec57$var$_addListener(isNormalizer ? target : ownerDoc, $d7385dda6eeeec57$var$_eventTypes[1], _onDrag, passive, true);
            self.deltaX = self.deltaY = 0;
            onPress && onPress(self);
        }, _onRelease = self.onRelease = function(e) {
            if (_ignoreCheck(e, 1)) return;
            $d7385dda6eeeec57$var$_removeListener(isNormalizer ? target : ownerDoc, $d7385dda6eeeec57$var$_eventTypes[1], _onDrag, true);
            var isTrackingDrag = !isNaN(self.y - self.startY), wasDragging = self.isDragging, isDragNotClick = wasDragging && (Math.abs(self.x - self.startX) > 3 || Math.abs(self.y - self.startY) > 3), // some touch devices need some wiggle room in terms of sensing clicks - the finger may move a few pixels.
            eventData = $d7385dda6eeeec57$var$_getEvent(e);
            if (!isDragNotClick && isTrackingDrag) {
                self._vx.reset();
                self._vy.reset(); //if (preventDefault && allowClicks && self.isPressed) { // check isPressed because in a rare edge case, the inputObserver in ScrollTrigger may stopPropagation() on the press/drag, so the onRelease may get fired without the onPress/onDrag ever getting called, thus it could trigger a click to occur on a link after scroll-dragging it.
                if (preventDefault && allowClicks) $d7385dda6eeeec57$var$gsap.delayedCall(0.08, function() {
                    // some browsers (like Firefox) won't trust script-generated clicks, so if the user tries to click on a video to play it, for example, it simply won't work. Since a regular "click" event will most likely be generated anyway (one that has its isTrusted flag set to true), we must slightly delay our script-generated click so that the "real"/trusted one is prioritized. Remember, when there are duplicate events in quick succession, we suppress all but the first one. Some browsers don't even trigger the "real" one at all, so our synthetic one is a safety valve that ensures that no matter what, a click event does get dispatched.
                    if ($d7385dda6eeeec57$var$_getTime() - onClickTime > 300 && !e.defaultPrevented) {
                        if (e.target.click) //some browsers (like mobile Safari) don't properly trigger the click event
                        e.target.click();
                        else if (ownerDoc.createEvent) {
                            var syntheticEvent = ownerDoc.createEvent("MouseEvents");
                            syntheticEvent.initMouseEvent("click", true, true, $d7385dda6eeeec57$var$_win, 1, eventData.screenX, eventData.screenY, eventData.clientX, eventData.clientY, false, false, false, false, 0, null);
                            e.target.dispatchEvent(syntheticEvent);
                        }
                    }
                });
            }
            self.isDragging = self.isGesturing = self.isPressed = false;
            onStop && wasDragging && !isNormalizer && onStopDelayedCall.restart(true);
            onDragEnd && wasDragging && onDragEnd(self);
            onRelease && onRelease(self, isDragNotClick);
        }, _onGestureStart = function _onGestureStart(e) {
            return e.touches && e.touches.length > 1 && (self.isGesturing = true) && onGestureStart(e, self.isDragging);
        }, _onGestureEnd = function _onGestureEnd() {
            return self.isGesturing = false, onGestureEnd(self);
        }, onScroll = function onScroll(e) {
            if (_ignoreCheck(e)) return;
            var x = scrollFuncX(), y = scrollFuncY();
            onDelta((x - scrollX) * scrollSpeed, (y - scrollY) * scrollSpeed, 1);
            scrollX = x;
            scrollY = y;
            onStop && onStopDelayedCall.restart(true);
        }, _onWheel = function _onWheel(e) {
            if (_ignoreCheck(e)) return;
            e = $d7385dda6eeeec57$var$_getEvent(e, preventDefault);
            onWheel && (wheeled = true);
            var multiplier = (e.deltaMode === 1 ? lineHeight : e.deltaMode === 2 ? $d7385dda6eeeec57$var$_win.innerHeight : 1) * wheelSpeed;
            onDelta(e.deltaX * multiplier, e.deltaY * multiplier, 0);
            onStop && !isNormalizer && onStopDelayedCall.restart(true);
        }, _onMove = function _onMove(e) {
            if (_ignoreCheck(e)) return;
            var x = e.clientX, y = e.clientY, dx = x - self.x, dy = y - self.y;
            self.x = x;
            self.y = y;
            moved = true;
            onStop && onStopDelayedCall.restart(true);
            (dx || dy) && onTouchOrPointerDelta(dx, dy);
        }, _onHover = function _onHover(e) {
            self.event = e;
            onHover(self);
        }, _onHoverEnd = function _onHoverEnd(e) {
            self.event = e;
            onHoverEnd(self);
        }, _onClick = function _onClick(e) {
            return _ignoreCheck(e) || $d7385dda6eeeec57$var$_getEvent(e, preventDefault) && onClick(self);
        };
        onStopDelayedCall = self._dc = $d7385dda6eeeec57$var$gsap.delayedCall(onStopDelay || 0.25, onStopFunc).pause();
        self.deltaX = self.deltaY = 0;
        self._vx = $d7385dda6eeeec57$export$5de019f4480f0f8d(0, 50, true);
        self._vy = $d7385dda6eeeec57$export$5de019f4480f0f8d(0, 50, true);
        self.scrollX = scrollFuncX;
        self.scrollY = scrollFuncY;
        self.isDragging = self.isGesturing = self.isPressed = false;
        $d7385dda6eeeec57$var$_context(this);
        self.enable = function(e) {
            if (!self.isEnabled) {
                $d7385dda6eeeec57$var$_addListener(isViewport ? ownerDoc : target, "scroll", $d7385dda6eeeec57$var$_onScroll);
                type.indexOf("scroll") >= 0 && $d7385dda6eeeec57$var$_addListener(isViewport ? ownerDoc : target, "scroll", onScroll, passive, capture);
                type.indexOf("wheel") >= 0 && $d7385dda6eeeec57$var$_addListener(target, "wheel", _onWheel, passive, capture);
                if (type.indexOf("touch") >= 0 && $d7385dda6eeeec57$var$_isTouch || type.indexOf("pointer") >= 0) {
                    $d7385dda6eeeec57$var$_addListener(target, $d7385dda6eeeec57$var$_eventTypes[0], _onPress, passive, capture);
                    $d7385dda6eeeec57$var$_addListener(ownerDoc, $d7385dda6eeeec57$var$_eventTypes[2], _onRelease);
                    $d7385dda6eeeec57$var$_addListener(ownerDoc, $d7385dda6eeeec57$var$_eventTypes[3], _onRelease);
                    allowClicks && $d7385dda6eeeec57$var$_addListener(target, "click", clickCapture, true, true);
                    onClick && $d7385dda6eeeec57$var$_addListener(target, "click", _onClick);
                    onGestureStart && $d7385dda6eeeec57$var$_addListener(ownerDoc, "gesturestart", _onGestureStart);
                    onGestureEnd && $d7385dda6eeeec57$var$_addListener(ownerDoc, "gestureend", _onGestureEnd);
                    onHover && $d7385dda6eeeec57$var$_addListener(target, $d7385dda6eeeec57$var$_pointerType + "enter", _onHover);
                    onHoverEnd && $d7385dda6eeeec57$var$_addListener(target, $d7385dda6eeeec57$var$_pointerType + "leave", _onHoverEnd);
                    onMove && $d7385dda6eeeec57$var$_addListener(target, $d7385dda6eeeec57$var$_pointerType + "move", _onMove);
                }
                self.isEnabled = true;
                e && e.type && _onPress(e);
                onEnable && onEnable(self);
            }
            return self;
        };
        self.disable = function() {
            if (self.isEnabled) {
                // only remove the _onScroll listener if there aren't any others that rely on the functionality.
                $d7385dda6eeeec57$var$_observers.filter(function(o) {
                    return o !== self && $d7385dda6eeeec57$export$4330f3a92e5d2e94(o.target);
                }).length || $d7385dda6eeeec57$var$_removeListener(isViewport ? ownerDoc : target, "scroll", $d7385dda6eeeec57$var$_onScroll);
                if (self.isPressed) {
                    self._vx.reset();
                    self._vy.reset();
                    $d7385dda6eeeec57$var$_removeListener(isNormalizer ? target : ownerDoc, $d7385dda6eeeec57$var$_eventTypes[1], _onDrag, true);
                }
                $d7385dda6eeeec57$var$_removeListener(isViewport ? ownerDoc : target, "scroll", onScroll, capture);
                $d7385dda6eeeec57$var$_removeListener(target, "wheel", _onWheel, capture);
                $d7385dda6eeeec57$var$_removeListener(target, $d7385dda6eeeec57$var$_eventTypes[0], _onPress, capture);
                $d7385dda6eeeec57$var$_removeListener(ownerDoc, $d7385dda6eeeec57$var$_eventTypes[2], _onRelease);
                $d7385dda6eeeec57$var$_removeListener(ownerDoc, $d7385dda6eeeec57$var$_eventTypes[3], _onRelease);
                $d7385dda6eeeec57$var$_removeListener(target, "click", clickCapture, true);
                $d7385dda6eeeec57$var$_removeListener(target, "click", _onClick);
                $d7385dda6eeeec57$var$_removeListener(ownerDoc, "gesturestart", _onGestureStart);
                $d7385dda6eeeec57$var$_removeListener(ownerDoc, "gestureend", _onGestureEnd);
                $d7385dda6eeeec57$var$_removeListener(target, $d7385dda6eeeec57$var$_pointerType + "enter", _onHover);
                $d7385dda6eeeec57$var$_removeListener(target, $d7385dda6eeeec57$var$_pointerType + "leave", _onHoverEnd);
                $d7385dda6eeeec57$var$_removeListener(target, $d7385dda6eeeec57$var$_pointerType + "move", _onMove);
                self.isEnabled = self.isPressed = self.isDragging = false;
                onDisable && onDisable(self);
            }
        };
        self.kill = self.revert = function() {
            self.disable();
            var i = $d7385dda6eeeec57$var$_observers.indexOf(self);
            i >= 0 && $d7385dda6eeeec57$var$_observers.splice(i, 1);
            $d7385dda6eeeec57$var$_normalizer === self && ($d7385dda6eeeec57$var$_normalizer = 0);
        };
        $d7385dda6eeeec57$var$_observers.push(self);
        isNormalizer && $d7385dda6eeeec57$export$4330f3a92e5d2e94(target) && ($d7385dda6eeeec57$var$_normalizer = self);
        self.enable(event);
    };
    $d7385dda6eeeec57$var$_createClass(Observer, [
        {
            key: "velocityX",
            get: function get() {
                return this._vx.getVelocity();
            }
        },
        {
            key: "velocityY",
            get: function get() {
                return this._vy.getVelocity();
            }
        }
    ]);
    return Observer;
}();
$d7385dda6eeeec57$export$c1cbdee04e18ea8b.version = "3.12.5";
$d7385dda6eeeec57$export$c1cbdee04e18ea8b.create = function(vars) {
    return new $d7385dda6eeeec57$export$c1cbdee04e18ea8b(vars);
};
$d7385dda6eeeec57$export$c1cbdee04e18ea8b.register = $d7385dda6eeeec57$var$_initCore;
$d7385dda6eeeec57$export$c1cbdee04e18ea8b.getAll = function() {
    return $d7385dda6eeeec57$var$_observers.slice();
};
$d7385dda6eeeec57$export$c1cbdee04e18ea8b.getById = function(id) {
    return $d7385dda6eeeec57$var$_observers.filter(function(o) {
        return o.vars.id === id;
    })[0];
};
$d7385dda6eeeec57$var$_getGSAP() && $d7385dda6eeeec57$var$gsap.registerPlugin($d7385dda6eeeec57$export$c1cbdee04e18ea8b);


var $daf8bee9365fb629$var$gsap, $daf8bee9365fb629$var$_coreInitted, $daf8bee9365fb629$var$_win, $daf8bee9365fb629$var$_doc, $daf8bee9365fb629$var$_docEl, $daf8bee9365fb629$var$_body, $daf8bee9365fb629$var$_root, $daf8bee9365fb629$var$_resizeDelay, $daf8bee9365fb629$var$_toArray, $daf8bee9365fb629$var$_clamp, $daf8bee9365fb629$var$_time2, $daf8bee9365fb629$var$_syncInterval, $daf8bee9365fb629$var$_refreshing, $daf8bee9365fb629$var$_pointerIsDown, $daf8bee9365fb629$var$_transformProp, $daf8bee9365fb629$var$_i, $daf8bee9365fb629$var$_prevWidth, $daf8bee9365fb629$var$_prevHeight, $daf8bee9365fb629$var$_autoRefresh, $daf8bee9365fb629$var$_sort, $daf8bee9365fb629$var$_suppressOverwrites, $daf8bee9365fb629$var$_ignoreResize, $daf8bee9365fb629$var$_normalizer, $daf8bee9365fb629$var$_ignoreMobileResize, $daf8bee9365fb629$var$_baseScreenHeight, $daf8bee9365fb629$var$_baseScreenWidth, $daf8bee9365fb629$var$_fixIOSBug, $daf8bee9365fb629$var$_context, $daf8bee9365fb629$var$_scrollRestoration, $daf8bee9365fb629$var$_div100vh, $daf8bee9365fb629$var$_100vh, $daf8bee9365fb629$var$_isReverted, $daf8bee9365fb629$var$_clampingMax, $daf8bee9365fb629$var$_limitCallbacks, // if true, we'll only trigger callbacks if the active state toggles, so if you scroll immediately past both the start and end positions of a ScrollTrigger (thus inactive to inactive), neither its onEnter nor onLeave will be called. This is useful during startup.
$daf8bee9365fb629$var$_startup = 1, $daf8bee9365fb629$var$_getTime = Date.now, $daf8bee9365fb629$var$_time1 = $daf8bee9365fb629$var$_getTime(), $daf8bee9365fb629$var$_lastScrollTime = 0, $daf8bee9365fb629$var$_enabled = 0, $daf8bee9365fb629$var$_parseClamp = function _parseClamp(value, type, self) {
    var clamp = $daf8bee9365fb629$var$_isString(value) && (value.substr(0, 6) === "clamp(" || value.indexOf("max") > -1);
    self["_" + type + "Clamp"] = clamp;
    return clamp ? value.substr(6, value.length - 7) : value;
}, $daf8bee9365fb629$var$_keepClamp = function _keepClamp(value, clamp) {
    return clamp && (!$daf8bee9365fb629$var$_isString(value) || value.substr(0, 6) !== "clamp(") ? "clamp(" + value + ")" : value;
}, $daf8bee9365fb629$var$_rafBugFix = function _rafBugFix() {
    return $daf8bee9365fb629$var$_enabled && requestAnimationFrame(_rafBugFix);
}, // in some browsers (like Firefox), screen repaints weren't consistent unless we had SOMETHING queued up in requestAnimationFrame()! So this just creates a super simple loop to keep it alive and smooth out repaints.
$daf8bee9365fb629$var$_pointerDownHandler = function _pointerDownHandler() {
    return $daf8bee9365fb629$var$_pointerIsDown = 1;
}, $daf8bee9365fb629$var$_pointerUpHandler = function _pointerUpHandler() {
    return $daf8bee9365fb629$var$_pointerIsDown = 0;
}, $daf8bee9365fb629$var$_passThrough = function _passThrough(v) {
    return v;
}, $daf8bee9365fb629$var$_round = function _round(value) {
    return Math.round(value * 100000) / 100000 || 0;
}, $daf8bee9365fb629$var$_windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, $daf8bee9365fb629$var$_getGSAP = function _getGSAP() {
    return $daf8bee9365fb629$var$gsap || $daf8bee9365fb629$var$_windowExists() && ($daf8bee9365fb629$var$gsap = window.gsap) && $daf8bee9365fb629$var$gsap.registerPlugin && $daf8bee9365fb629$var$gsap;
}, $daf8bee9365fb629$var$_isViewport = function _isViewport(e) {
    return !!~$daf8bee9365fb629$var$_root.indexOf(e);
}, $daf8bee9365fb629$var$_getViewportDimension = function _getViewportDimension(dimensionProperty) {
    return (dimensionProperty === "Height" ? $daf8bee9365fb629$var$_100vh : $daf8bee9365fb629$var$_win["inner" + dimensionProperty]) || $daf8bee9365fb629$var$_docEl["client" + dimensionProperty] || $daf8bee9365fb629$var$_body["client" + dimensionProperty];
}, $daf8bee9365fb629$var$_getBoundsFunc = function _getBoundsFunc(element) {
    return (0, $d7385dda6eeeec57$export$6078f1ef08b38af9)(element, "getBoundingClientRect") || ($daf8bee9365fb629$var$_isViewport(element) ? function() {
        $daf8bee9365fb629$var$_winOffsets.width = $daf8bee9365fb629$var$_win.innerWidth;
        $daf8bee9365fb629$var$_winOffsets.height = $daf8bee9365fb629$var$_100vh;
        return $daf8bee9365fb629$var$_winOffsets;
    } : function() {
        return $daf8bee9365fb629$var$_getBounds(element);
    });
}, $daf8bee9365fb629$var$_getSizeFunc = function _getSizeFunc(scroller, isViewport, _ref) {
    var d = _ref.d, d2 = _ref.d2, a = _ref.a;
    return (a = (0, $d7385dda6eeeec57$export$6078f1ef08b38af9)(scroller, "getBoundingClientRect")) ? function() {
        return a()[d];
    } : function() {
        return (isViewport ? $daf8bee9365fb629$var$_getViewportDimension(d2) : scroller["client" + d2]) || 0;
    };
}, $daf8bee9365fb629$var$_getOffsetsFunc = function _getOffsetsFunc(element, isViewport) {
    return !isViewport || ~(0, $d7385dda6eeeec57$export$d8e56d510a804d0a).indexOf(element) ? $daf8bee9365fb629$var$_getBoundsFunc(element) : function() {
        return $daf8bee9365fb629$var$_winOffsets;
    };
}, $daf8bee9365fb629$var$_maxScroll = function _maxScroll(element, _ref2) {
    var s = _ref2.s, d2 = _ref2.d2, d = _ref2.d, a = _ref2.a;
    return Math.max(0, (s = "scroll" + d2, a = (0, $d7385dda6eeeec57$export$6078f1ef08b38af9)(element, s)) ? a() - $daf8bee9365fb629$var$_getBoundsFunc(element)()[d] : $daf8bee9365fb629$var$_isViewport(element) ? ($daf8bee9365fb629$var$_docEl[s] || $daf8bee9365fb629$var$_body[s]) - $daf8bee9365fb629$var$_getViewportDimension(d2) : element[s] - element["offset" + d2]);
}, $daf8bee9365fb629$var$_iterateAutoRefresh = function _iterateAutoRefresh(func, events) {
    for(var i = 0; i < $daf8bee9365fb629$var$_autoRefresh.length; i += 3)(!events || ~events.indexOf($daf8bee9365fb629$var$_autoRefresh[i + 1])) && func($daf8bee9365fb629$var$_autoRefresh[i], $daf8bee9365fb629$var$_autoRefresh[i + 1], $daf8bee9365fb629$var$_autoRefresh[i + 2]);
}, $daf8bee9365fb629$var$_isString = function _isString(value) {
    return typeof value === "string";
}, $daf8bee9365fb629$var$_isFunction = function _isFunction(value) {
    return typeof value === "function";
}, $daf8bee9365fb629$var$_isNumber = function _isNumber(value) {
    return typeof value === "number";
}, $daf8bee9365fb629$var$_isObject = function _isObject(value) {
    return typeof value === "object";
}, $daf8bee9365fb629$var$_endAnimation = function _endAnimation(animation, reversed, pause) {
    return animation && animation.progress(reversed ? 0 : 1) && pause && animation.pause();
}, $daf8bee9365fb629$var$_callback = function _callback(self, func) {
    if (self.enabled) {
        var result = self._ctx ? self._ctx.add(function() {
            return func(self);
        }) : func(self);
        result && result.totalTime && (self.callbackAnimation = result);
    }
}, $daf8bee9365fb629$var$_abs = Math.abs, $daf8bee9365fb629$var$_left = "left", $daf8bee9365fb629$var$_top = "top", $daf8bee9365fb629$var$_right = "right", $daf8bee9365fb629$var$_bottom = "bottom", $daf8bee9365fb629$var$_width = "width", $daf8bee9365fb629$var$_height = "height", $daf8bee9365fb629$var$_Right = "Right", $daf8bee9365fb629$var$_Left = "Left", $daf8bee9365fb629$var$_Top = "Top", $daf8bee9365fb629$var$_Bottom = "Bottom", $daf8bee9365fb629$var$_padding = "padding", $daf8bee9365fb629$var$_margin = "margin", $daf8bee9365fb629$var$_Width = "Width", $daf8bee9365fb629$var$_Height = "Height", $daf8bee9365fb629$var$_px = "px", $daf8bee9365fb629$var$_getComputedStyle = function _getComputedStyle(element) {
    return $daf8bee9365fb629$var$_win.getComputedStyle(element);
}, $daf8bee9365fb629$var$_makePositionable = function _makePositionable(element) {
    // if the element already has position: absolute or fixed, leave that, otherwise make it position: relative
    var position = $daf8bee9365fb629$var$_getComputedStyle(element).position;
    element.style.position = position === "absolute" || position === "fixed" ? position : "relative";
}, $daf8bee9365fb629$var$_setDefaults = function _setDefaults(obj, defaults) {
    for(var p in defaults)p in obj || (obj[p] = defaults[p]);
    return obj;
}, $daf8bee9365fb629$var$_getBounds = function _getBounds(element, withoutTransforms) {
    var tween = withoutTransforms && $daf8bee9365fb629$var$_getComputedStyle(element)[$daf8bee9365fb629$var$_transformProp] !== "matrix(1, 0, 0, 1, 0, 0)" && $daf8bee9365fb629$var$gsap.to(element, {
        x: 0,
        y: 0,
        xPercent: 0,
        yPercent: 0,
        rotation: 0,
        rotationX: 0,
        rotationY: 0,
        scale: 1,
        skewX: 0,
        skewY: 0
    }).progress(1), bounds = element.getBoundingClientRect();
    tween && tween.progress(0).kill();
    return bounds;
}, $daf8bee9365fb629$var$_getSize = function _getSize(element, _ref3) {
    var d2 = _ref3.d2;
    return element["offset" + d2] || element["client" + d2] || 0;
}, $daf8bee9365fb629$var$_getLabelRatioArray = function _getLabelRatioArray(timeline) {
    var a = [], labels = timeline.labels, duration = timeline.duration(), p;
    for(p in labels)a.push(labels[p] / duration);
    return a;
}, $daf8bee9365fb629$var$_getClosestLabel = function _getClosestLabel(animation) {
    return function(value) {
        return $daf8bee9365fb629$var$gsap.utils.snap($daf8bee9365fb629$var$_getLabelRatioArray(animation), value);
    };
}, $daf8bee9365fb629$var$_snapDirectional = function _snapDirectional(snapIncrementOrArray) {
    var snap = $daf8bee9365fb629$var$gsap.utils.snap(snapIncrementOrArray), a = Array.isArray(snapIncrementOrArray) && snapIncrementOrArray.slice(0).sort(function(a, b) {
        return a - b;
    });
    return a ? function(value, direction, threshold) {
        if (threshold === void 0) threshold = 1e-3;
        var i;
        if (!direction) return snap(value);
        if (direction > 0) {
            value -= threshold; // to avoid rounding errors. If we're too strict, it might snap forward, then immediately again, and again.
            for(i = 0; i < a.length; i++){
                if (a[i] >= value) return a[i];
            }
            return a[i - 1];
        } else {
            i = a.length;
            value += threshold;
            while(i--){
                if (a[i] <= value) return a[i];
            }
        }
        return a[0];
    } : function(value, direction, threshold) {
        if (threshold === void 0) threshold = 1e-3;
        var snapped = snap(value);
        return !direction || Math.abs(snapped - value) < threshold || snapped - value < 0 === direction < 0 ? snapped : snap(direction < 0 ? value - snapIncrementOrArray : value + snapIncrementOrArray);
    };
}, $daf8bee9365fb629$var$_getLabelAtDirection = function _getLabelAtDirection(timeline) {
    return function(value, st) {
        return $daf8bee9365fb629$var$_snapDirectional($daf8bee9365fb629$var$_getLabelRatioArray(timeline))(value, st.direction);
    };
}, $daf8bee9365fb629$var$_multiListener = function _multiListener(func, element, types, callback) {
    return types.split(",").forEach(function(type) {
        return func(element, type, callback);
    });
}, $daf8bee9365fb629$var$_addListener = function _addListener(element, type, func, nonPassive, capture) {
    return element.addEventListener(type, func, {
        passive: !nonPassive,
        capture: !!capture
    });
}, $daf8bee9365fb629$var$_removeListener = function _removeListener(element, type, func, capture) {
    return element.removeEventListener(type, func, !!capture);
}, $daf8bee9365fb629$var$_wheelListener = function _wheelListener(func, el, scrollFunc) {
    scrollFunc = scrollFunc && scrollFunc.wheelHandler;
    if (scrollFunc) {
        func(el, "wheel", scrollFunc);
        func(el, "touchmove", scrollFunc);
    }
}, $daf8bee9365fb629$var$_markerDefaults = {
    startColor: "green",
    endColor: "red",
    indent: 0,
    fontSize: "16px",
    fontWeight: "normal"
}, $daf8bee9365fb629$var$_defaults = {
    toggleActions: "play",
    anticipatePin: 0
}, $daf8bee9365fb629$var$_keywords = {
    top: 0,
    left: 0,
    center: 0.5,
    bottom: 1,
    right: 1
}, $daf8bee9365fb629$var$_offsetToPx = function _offsetToPx(value, size) {
    if ($daf8bee9365fb629$var$_isString(value)) {
        var eqIndex = value.indexOf("="), relative = ~eqIndex ? +(value.charAt(eqIndex - 1) + 1) * parseFloat(value.substr(eqIndex + 1)) : 0;
        if (~eqIndex) {
            value.indexOf("%") > eqIndex && (relative *= size / 100);
            value = value.substr(0, eqIndex - 1);
        }
        value = relative + (value in $daf8bee9365fb629$var$_keywords ? $daf8bee9365fb629$var$_keywords[value] * size : ~value.indexOf("%") ? parseFloat(value) * size / 100 : parseFloat(value) || 0);
    }
    return value;
}, $daf8bee9365fb629$var$_createMarker = function _createMarker(type, name, container, direction, _ref4, offset, matchWidthEl, containerAnimation) {
    var startColor = _ref4.startColor, endColor = _ref4.endColor, fontSize = _ref4.fontSize, indent = _ref4.indent, fontWeight = _ref4.fontWeight;
    var e = $daf8bee9365fb629$var$_doc.createElement("div"), useFixedPosition = $daf8bee9365fb629$var$_isViewport(container) || (0, $d7385dda6eeeec57$export$6078f1ef08b38af9)(container, "pinType") === "fixed", isScroller = type.indexOf("scroller") !== -1, parent = useFixedPosition ? $daf8bee9365fb629$var$_body : container, isStart = type.indexOf("start") !== -1, color = isStart ? startColor : endColor, css = "border-color:" + color + ";font-size:" + fontSize + ";color:" + color + ";font-weight:" + fontWeight + ";pointer-events:none;white-space:nowrap;font-family:sans-serif,Arial;z-index:1000;padding:4px 8px;border-width:0;border-style:solid;";
    css += "position:" + ((isScroller || containerAnimation) && useFixedPosition ? "fixed;" : "absolute;");
    (isScroller || containerAnimation || !useFixedPosition) && (css += (direction === (0, $d7385dda6eeeec57$export$8e40fc98ff518e9d) ? $daf8bee9365fb629$var$_right : $daf8bee9365fb629$var$_bottom) + ":" + (offset + parseFloat(indent)) + "px;");
    matchWidthEl && (css += "box-sizing:border-box;text-align:left;width:" + matchWidthEl.offsetWidth + "px;");
    e._isStart = isStart;
    e.setAttribute("class", "gsap-marker-" + type + (name ? " marker-" + name : ""));
    e.style.cssText = css;
    e.innerText = name || name === 0 ? type + "-" + name : type;
    parent.children[0] ? parent.insertBefore(e, parent.children[0]) : parent.appendChild(e);
    e._offset = e["offset" + direction.op.d2];
    $daf8bee9365fb629$var$_positionMarker(e, 0, direction, isStart);
    return e;
}, $daf8bee9365fb629$var$_positionMarker = function _positionMarker(marker, start, direction, flipped) {
    var vars = {
        display: "block"
    }, side = direction[flipped ? "os2" : "p2"], oppositeSide = direction[flipped ? "p2" : "os2"];
    marker._isFlipped = flipped;
    vars[direction.a + "Percent"] = flipped ? -100 : 0;
    vars[direction.a] = flipped ? "1px" : 0;
    vars["border" + side + $daf8bee9365fb629$var$_Width] = 1;
    vars["border" + oppositeSide + $daf8bee9365fb629$var$_Width] = 0;
    vars[direction.p] = start + "px";
    $daf8bee9365fb629$var$gsap.set(marker, vars);
}, $daf8bee9365fb629$var$_triggers = [], $daf8bee9365fb629$var$_ids = {}, $daf8bee9365fb629$var$_rafID, $daf8bee9365fb629$var$_sync = function _sync() {
    return $daf8bee9365fb629$var$_getTime() - $daf8bee9365fb629$var$_lastScrollTime > 34 && ($daf8bee9365fb629$var$_rafID || ($daf8bee9365fb629$var$_rafID = requestAnimationFrame($daf8bee9365fb629$var$_updateAll)));
}, $daf8bee9365fb629$var$_onScroll = function _onScroll() {
    // previously, we tried to optimize performance by batching/deferring to the next requestAnimationFrame(), but discovered that Safari has a few bugs that make this unworkable (especially on iOS). See https://codepen.io/GreenSock/pen/16c435b12ef09c38125204818e7b45fc?editors=0010 and https://codepen.io/GreenSock/pen/JjOxYpQ/3dd65ccec5a60f1d862c355d84d14562?editors=0010 and https://codepen.io/GreenSock/pen/ExbrPNa/087cef197dc35445a0951e8935c41503?editors=0010
    if (!$daf8bee9365fb629$var$_normalizer || !$daf8bee9365fb629$var$_normalizer.isPressed || $daf8bee9365fb629$var$_normalizer.startX > $daf8bee9365fb629$var$_body.clientWidth) {
        // if the user is dragging the scrollbar, allow it.
        (0, $d7385dda6eeeec57$export$3cd1cee43d19b683).cache++;
        if ($daf8bee9365fb629$var$_normalizer) $daf8bee9365fb629$var$_rafID || ($daf8bee9365fb629$var$_rafID = requestAnimationFrame($daf8bee9365fb629$var$_updateAll));
        else $daf8bee9365fb629$var$_updateAll(); // Safari in particular (on desktop) NEEDS the immediate update rather than waiting for a requestAnimationFrame() whereas iOS seems to benefit from waiting for the requestAnimationFrame() tick, at least when normalizing. See https://codepen.io/GreenSock/pen/qBYozqO?editors=0110
        $daf8bee9365fb629$var$_lastScrollTime || $daf8bee9365fb629$var$_dispatch("scrollStart");
        $daf8bee9365fb629$var$_lastScrollTime = $daf8bee9365fb629$var$_getTime();
    }
}, $daf8bee9365fb629$var$_setBaseDimensions = function _setBaseDimensions() {
    $daf8bee9365fb629$var$_baseScreenWidth = $daf8bee9365fb629$var$_win.innerWidth;
    $daf8bee9365fb629$var$_baseScreenHeight = $daf8bee9365fb629$var$_win.innerHeight;
}, $daf8bee9365fb629$var$_onResize = function _onResize() {
    (0, $d7385dda6eeeec57$export$3cd1cee43d19b683).cache++;
    !$daf8bee9365fb629$var$_refreshing && !$daf8bee9365fb629$var$_ignoreResize && !$daf8bee9365fb629$var$_doc.fullscreenElement && !$daf8bee9365fb629$var$_doc.webkitFullscreenElement && (!$daf8bee9365fb629$var$_ignoreMobileResize || $daf8bee9365fb629$var$_baseScreenWidth !== $daf8bee9365fb629$var$_win.innerWidth || Math.abs($daf8bee9365fb629$var$_win.innerHeight - $daf8bee9365fb629$var$_baseScreenHeight) > $daf8bee9365fb629$var$_win.innerHeight * 0.25) && $daf8bee9365fb629$var$_resizeDelay.restart(true);
}, // ignore resizes triggered by refresh()
$daf8bee9365fb629$var$_listeners = {}, $daf8bee9365fb629$var$_emptyArray = [], $daf8bee9365fb629$var$_softRefresh = function _softRefresh() {
    return $daf8bee9365fb629$var$_removeListener($daf8bee9365fb629$export$875bcbe48555930, "scrollEnd", _softRefresh) || $daf8bee9365fb629$var$_refreshAll(true);
}, $daf8bee9365fb629$var$_dispatch = function _dispatch(type) {
    return $daf8bee9365fb629$var$_listeners[type] && $daf8bee9365fb629$var$_listeners[type].map(function(f) {
        return f();
    }) || $daf8bee9365fb629$var$_emptyArray;
}, $daf8bee9365fb629$var$_savedStyles = [], // when ScrollTrigger.saveStyles() is called, the inline styles are recorded in this Array in a sequential format like [element, cssText, gsCache, media]. This keeps it very memory-efficient and fast to iterate through.
$daf8bee9365fb629$var$_revertRecorded = function _revertRecorded(media) {
    for(var i = 0; i < $daf8bee9365fb629$var$_savedStyles.length; i += 5)if (!media || $daf8bee9365fb629$var$_savedStyles[i + 4] && $daf8bee9365fb629$var$_savedStyles[i + 4].query === media) {
        $daf8bee9365fb629$var$_savedStyles[i].style.cssText = $daf8bee9365fb629$var$_savedStyles[i + 1];
        $daf8bee9365fb629$var$_savedStyles[i].getBBox && $daf8bee9365fb629$var$_savedStyles[i].setAttribute("transform", $daf8bee9365fb629$var$_savedStyles[i + 2] || "");
        $daf8bee9365fb629$var$_savedStyles[i + 3].uncache = 1;
    }
}, $daf8bee9365fb629$var$_revertAll = function _revertAll(kill, media) {
    var trigger;
    for($daf8bee9365fb629$var$_i = 0; $daf8bee9365fb629$var$_i < $daf8bee9365fb629$var$_triggers.length; $daf8bee9365fb629$var$_i++){
        trigger = $daf8bee9365fb629$var$_triggers[$daf8bee9365fb629$var$_i];
        if (trigger && (!media || trigger._ctx === media)) {
            if (kill) trigger.kill(1);
            else trigger.revert(true, true);
        }
    }
    $daf8bee9365fb629$var$_isReverted = true;
    media && $daf8bee9365fb629$var$_revertRecorded(media);
    media || $daf8bee9365fb629$var$_dispatch("revert");
}, $daf8bee9365fb629$var$_clearScrollMemory = function _clearScrollMemory(scrollRestoration, force) {
    // zero-out all the recorded scroll positions. Don't use _triggers because if, for example, .matchMedia() is used to create some ScrollTriggers and then the user resizes and it removes ALL ScrollTriggers, and then go back to a size where there are ScrollTriggers, it would have kept the position(s) saved from the initial state.
    (0, $d7385dda6eeeec57$export$3cd1cee43d19b683).cache++;
    (force || !$daf8bee9365fb629$var$_refreshingAll) && (0, $d7385dda6eeeec57$export$3cd1cee43d19b683).forEach(function(obj) {
        return $daf8bee9365fb629$var$_isFunction(obj) && obj.cacheID++ && (obj.rec = 0);
    });
    $daf8bee9365fb629$var$_isString(scrollRestoration) && ($daf8bee9365fb629$var$_win.history.scrollRestoration = $daf8bee9365fb629$var$_scrollRestoration = scrollRestoration);
}, $daf8bee9365fb629$var$_refreshingAll, $daf8bee9365fb629$var$_refreshID = 0, $daf8bee9365fb629$var$_queueRefreshID, $daf8bee9365fb629$var$_queueRefreshAll = function _queueRefreshAll() {
    // we don't want to call _refreshAll() every time we create a new ScrollTrigger (for performance reasons) - it's better to batch them. Some frameworks dynamically load content and we can't rely on the window's "load" or "DOMContentLoaded" events to trigger it.
    if ($daf8bee9365fb629$var$_queueRefreshID !== $daf8bee9365fb629$var$_refreshID) {
        var id = $daf8bee9365fb629$var$_queueRefreshID = $daf8bee9365fb629$var$_refreshID;
        requestAnimationFrame(function() {
            return id === $daf8bee9365fb629$var$_refreshID && $daf8bee9365fb629$var$_refreshAll(true);
        });
    }
}, $daf8bee9365fb629$var$_refresh100vh = function _refresh100vh() {
    $daf8bee9365fb629$var$_body.appendChild($daf8bee9365fb629$var$_div100vh);
    $daf8bee9365fb629$var$_100vh = !$daf8bee9365fb629$var$_normalizer && $daf8bee9365fb629$var$_div100vh.offsetHeight || $daf8bee9365fb629$var$_win.innerHeight;
    $daf8bee9365fb629$var$_body.removeChild($daf8bee9365fb629$var$_div100vh);
}, $daf8bee9365fb629$var$_hideAllMarkers = function _hideAllMarkers(hide) {
    return $daf8bee9365fb629$var$_toArray(".gsap-marker-start, .gsap-marker-end, .gsap-marker-scroller-start, .gsap-marker-scroller-end").forEach(function(el) {
        return el.style.display = hide ? "none" : "block";
    });
}, $daf8bee9365fb629$var$_refreshAll = function _refreshAll(force, skipRevert) {
    if ($daf8bee9365fb629$var$_lastScrollTime && !force && !$daf8bee9365fb629$var$_isReverted) {
        $daf8bee9365fb629$var$_addListener($daf8bee9365fb629$export$875bcbe48555930, "scrollEnd", $daf8bee9365fb629$var$_softRefresh);
        return;
    }
    $daf8bee9365fb629$var$_refresh100vh();
    $daf8bee9365fb629$var$_refreshingAll = $daf8bee9365fb629$export$875bcbe48555930.isRefreshing = true;
    (0, $d7385dda6eeeec57$export$3cd1cee43d19b683).forEach(function(obj) {
        return $daf8bee9365fb629$var$_isFunction(obj) && ++obj.cacheID && (obj.rec = obj());
    }); // force the clearing of the cache because some browsers take a little while to dispatch the "scroll" event and the user may have changed the scroll position and then called ScrollTrigger.refresh() right away
    var refreshInits = $daf8bee9365fb629$var$_dispatch("refreshInit");
    $daf8bee9365fb629$var$_sort && $daf8bee9365fb629$export$875bcbe48555930.sort();
    skipRevert || $daf8bee9365fb629$var$_revertAll();
    (0, $d7385dda6eeeec57$export$3cd1cee43d19b683).forEach(function(obj) {
        if ($daf8bee9365fb629$var$_isFunction(obj)) {
            obj.smooth && (obj.target.style.scrollBehavior = "auto"); // smooth scrolling interferes
            obj(0);
        }
    });
    $daf8bee9365fb629$var$_triggers.slice(0).forEach(function(t) {
        return t.refresh();
    }); // don't loop with _i because during a refresh() someone could call ScrollTrigger.update() which would iterate through _i resulting in a skip.
    $daf8bee9365fb629$var$_isReverted = false;
    $daf8bee9365fb629$var$_triggers.forEach(function(t) {
        // nested pins (pinnedContainer) with pinSpacing may expand the container, so we must accommodate that here.
        if (t._subPinOffset && t.pin) {
            var prop = t.vars.horizontal ? "offsetWidth" : "offsetHeight", original = t.pin[prop];
            t.revert(true, 1);
            t.adjustPinSpacing(t.pin[prop] - original);
            t.refresh();
        }
    });
    $daf8bee9365fb629$var$_clampingMax = 1; // pinSpacing might be propping a page open, thus when we .setPositions() to clamp a ScrollTrigger's end we should leave the pinSpacing alone. That's what this flag is for.
    $daf8bee9365fb629$var$_hideAllMarkers(true);
    $daf8bee9365fb629$var$_triggers.forEach(function(t) {
        // the scroller's max scroll position may change after all the ScrollTriggers refreshed (like pinning could push it down), so we need to loop back and correct any with end: "max". Same for anything with a clamped end
        var max = $daf8bee9365fb629$var$_maxScroll(t.scroller, t._dir), endClamp = t.vars.end === "max" || t._endClamp && t.end > max, startClamp = t._startClamp && t.start >= max;
        (endClamp || startClamp) && t.setPositions(startClamp ? max - 1 : t.start, endClamp ? Math.max(startClamp ? max : t.start + 1, max) : t.end, true);
    });
    $daf8bee9365fb629$var$_hideAllMarkers(false);
    $daf8bee9365fb629$var$_clampingMax = 0;
    refreshInits.forEach(function(result) {
        return result && result.render && result.render(-1);
    }); // if the onRefreshInit() returns an animation (typically a gsap.set()), revert it. This makes it easy to put things in a certain spot before refreshing for measurement purposes, and then put things back.
    (0, $d7385dda6eeeec57$export$3cd1cee43d19b683).forEach(function(obj) {
        if ($daf8bee9365fb629$var$_isFunction(obj)) {
            obj.smooth && requestAnimationFrame(function() {
                return obj.target.style.scrollBehavior = "smooth";
            });
            obj.rec && obj(obj.rec);
        }
    });
    $daf8bee9365fb629$var$_clearScrollMemory($daf8bee9365fb629$var$_scrollRestoration, 1);
    $daf8bee9365fb629$var$_resizeDelay.pause();
    $daf8bee9365fb629$var$_refreshID++;
    $daf8bee9365fb629$var$_refreshingAll = 2;
    $daf8bee9365fb629$var$_updateAll(2);
    $daf8bee9365fb629$var$_triggers.forEach(function(t) {
        return $daf8bee9365fb629$var$_isFunction(t.vars.onRefresh) && t.vars.onRefresh(t);
    });
    $daf8bee9365fb629$var$_refreshingAll = $daf8bee9365fb629$export$875bcbe48555930.isRefreshing = false;
    $daf8bee9365fb629$var$_dispatch("refresh");
}, $daf8bee9365fb629$var$_lastScroll = 0, $daf8bee9365fb629$var$_direction = 1, $daf8bee9365fb629$var$_primary, $daf8bee9365fb629$var$_updateAll = function _updateAll(force) {
    if (force === 2 || !$daf8bee9365fb629$var$_refreshingAll && !$daf8bee9365fb629$var$_isReverted) {
        // _isReverted could be true if, for example, a matchMedia() is in the process of executing. We don't want to update during the time everything is reverted.
        $daf8bee9365fb629$export$875bcbe48555930.isUpdating = true;
        $daf8bee9365fb629$var$_primary && $daf8bee9365fb629$var$_primary.update(0); // ScrollSmoother uses refreshPriority -9999 to become the primary that gets updated before all others because it affects the scroll position.
        var l = $daf8bee9365fb629$var$_triggers.length, time = $daf8bee9365fb629$var$_getTime(), recordVelocity = time - $daf8bee9365fb629$var$_time1 >= 50, scroll = l && $daf8bee9365fb629$var$_triggers[0].scroll();
        $daf8bee9365fb629$var$_direction = $daf8bee9365fb629$var$_lastScroll > scroll ? -1 : 1;
        $daf8bee9365fb629$var$_refreshingAll || ($daf8bee9365fb629$var$_lastScroll = scroll);
        if (recordVelocity) {
            if ($daf8bee9365fb629$var$_lastScrollTime && !$daf8bee9365fb629$var$_pointerIsDown && time - $daf8bee9365fb629$var$_lastScrollTime > 200) {
                $daf8bee9365fb629$var$_lastScrollTime = 0;
                $daf8bee9365fb629$var$_dispatch("scrollEnd");
            }
            $daf8bee9365fb629$var$_time2 = $daf8bee9365fb629$var$_time1;
            $daf8bee9365fb629$var$_time1 = time;
        }
        if ($daf8bee9365fb629$var$_direction < 0) {
            $daf8bee9365fb629$var$_i = l;
            while($daf8bee9365fb629$var$_i-- > 0)$daf8bee9365fb629$var$_triggers[$daf8bee9365fb629$var$_i] && $daf8bee9365fb629$var$_triggers[$daf8bee9365fb629$var$_i].update(0, recordVelocity);
            $daf8bee9365fb629$var$_direction = 1;
        } else for($daf8bee9365fb629$var$_i = 0; $daf8bee9365fb629$var$_i < l; $daf8bee9365fb629$var$_i++)$daf8bee9365fb629$var$_triggers[$daf8bee9365fb629$var$_i] && $daf8bee9365fb629$var$_triggers[$daf8bee9365fb629$var$_i].update(0, recordVelocity);
        $daf8bee9365fb629$export$875bcbe48555930.isUpdating = false;
    }
    $daf8bee9365fb629$var$_rafID = 0;
}, $daf8bee9365fb629$var$_propNamesToCopy = [
    $daf8bee9365fb629$var$_left,
    $daf8bee9365fb629$var$_top,
    $daf8bee9365fb629$var$_bottom,
    $daf8bee9365fb629$var$_right,
    $daf8bee9365fb629$var$_margin + $daf8bee9365fb629$var$_Bottom,
    $daf8bee9365fb629$var$_margin + $daf8bee9365fb629$var$_Right,
    $daf8bee9365fb629$var$_margin + $daf8bee9365fb629$var$_Top,
    $daf8bee9365fb629$var$_margin + $daf8bee9365fb629$var$_Left,
    "display",
    "flexShrink",
    "float",
    "zIndex",
    "gridColumnStart",
    "gridColumnEnd",
    "gridRowStart",
    "gridRowEnd",
    "gridArea",
    "justifySelf",
    "alignSelf",
    "placeSelf",
    "order"
], $daf8bee9365fb629$var$_stateProps = $daf8bee9365fb629$var$_propNamesToCopy.concat([
    $daf8bee9365fb629$var$_width,
    $daf8bee9365fb629$var$_height,
    "boxSizing",
    "max" + $daf8bee9365fb629$var$_Width,
    "max" + $daf8bee9365fb629$var$_Height,
    "position",
    $daf8bee9365fb629$var$_margin,
    $daf8bee9365fb629$var$_padding,
    $daf8bee9365fb629$var$_padding + $daf8bee9365fb629$var$_Top,
    $daf8bee9365fb629$var$_padding + $daf8bee9365fb629$var$_Right,
    $daf8bee9365fb629$var$_padding + $daf8bee9365fb629$var$_Bottom,
    $daf8bee9365fb629$var$_padding + $daf8bee9365fb629$var$_Left
]), $daf8bee9365fb629$var$_swapPinOut = function _swapPinOut(pin, spacer, state) {
    $daf8bee9365fb629$var$_setState(state);
    var cache = pin._gsap;
    if (cache.spacerIsNative) $daf8bee9365fb629$var$_setState(cache.spacerState);
    else if (pin._gsap.swappedIn) {
        var parent = spacer.parentNode;
        if (parent) {
            parent.insertBefore(pin, spacer);
            parent.removeChild(spacer);
        }
    }
    pin._gsap.swappedIn = false;
}, $daf8bee9365fb629$var$_swapPinIn = function _swapPinIn(pin, spacer, cs, spacerState) {
    if (!pin._gsap.swappedIn) {
        var i = $daf8bee9365fb629$var$_propNamesToCopy.length, spacerStyle = spacer.style, pinStyle = pin.style, p;
        while(i--){
            p = $daf8bee9365fb629$var$_propNamesToCopy[i];
            spacerStyle[p] = cs[p];
        }
        spacerStyle.position = cs.position === "absolute" ? "absolute" : "relative";
        cs.display === "inline" && (spacerStyle.display = "inline-block");
        pinStyle[$daf8bee9365fb629$var$_bottom] = pinStyle[$daf8bee9365fb629$var$_right] = "auto";
        spacerStyle.flexBasis = cs.flexBasis || "auto";
        spacerStyle.overflow = "visible";
        spacerStyle.boxSizing = "border-box";
        spacerStyle[$daf8bee9365fb629$var$_width] = $daf8bee9365fb629$var$_getSize(pin, (0, $d7385dda6eeeec57$export$b2cabb342cb0ebe1)) + $daf8bee9365fb629$var$_px;
        spacerStyle[$daf8bee9365fb629$var$_height] = $daf8bee9365fb629$var$_getSize(pin, (0, $d7385dda6eeeec57$export$8e40fc98ff518e9d)) + $daf8bee9365fb629$var$_px;
        spacerStyle[$daf8bee9365fb629$var$_padding] = pinStyle[$daf8bee9365fb629$var$_margin] = pinStyle[$daf8bee9365fb629$var$_top] = pinStyle[$daf8bee9365fb629$var$_left] = "0";
        $daf8bee9365fb629$var$_setState(spacerState);
        pinStyle[$daf8bee9365fb629$var$_width] = pinStyle["max" + $daf8bee9365fb629$var$_Width] = cs[$daf8bee9365fb629$var$_width];
        pinStyle[$daf8bee9365fb629$var$_height] = pinStyle["max" + $daf8bee9365fb629$var$_Height] = cs[$daf8bee9365fb629$var$_height];
        pinStyle[$daf8bee9365fb629$var$_padding] = cs[$daf8bee9365fb629$var$_padding];
        if (pin.parentNode !== spacer) {
            pin.parentNode.insertBefore(spacer, pin);
            spacer.appendChild(pin);
        }
        pin._gsap.swappedIn = true;
    }
}, $daf8bee9365fb629$var$_capsExp = /([A-Z])/g, $daf8bee9365fb629$var$_setState = function _setState(state) {
    if (state) {
        var style = state.t.style, l = state.length, i = 0, p, value;
        (state.t._gsap || $daf8bee9365fb629$var$gsap.core.getCache(state.t)).uncache = 1; // otherwise transforms may be off
        for(; i < l; i += 2){
            value = state[i + 1];
            p = state[i];
            if (value) style[p] = value;
            else if (style[p]) style.removeProperty(p.replace($daf8bee9365fb629$var$_capsExp, "-$1").toLowerCase());
        }
    }
}, $daf8bee9365fb629$var$_getState = function _getState(element) {
    // returns an Array with alternating values like [property, value, property, value] and a "t" property pointing to the target (element). Makes it fast and cheap.
    var l = $daf8bee9365fb629$var$_stateProps.length, style = element.style, state = [], i = 0;
    for(; i < l; i++)state.push($daf8bee9365fb629$var$_stateProps[i], style[$daf8bee9365fb629$var$_stateProps[i]]);
    state.t = element;
    return state;
}, $daf8bee9365fb629$var$_copyState = function _copyState(state, override, omitOffsets) {
    var result = [], l = state.length, i = omitOffsets ? 8 : 0, // skip top, left, right, bottom if omitOffsets is true
    p;
    for(; i < l; i += 2){
        p = state[i];
        result.push(p, p in override ? override[p] : state[i + 1]);
    }
    result.t = state.t;
    return result;
}, $daf8bee9365fb629$var$_winOffsets = {
    left: 0,
    top: 0
}, // // potential future feature (?) Allow users to calculate where a trigger hits (scroll position) like getScrollPosition("#id", "top bottom")
// _getScrollPosition = (trigger, position, {scroller, containerAnimation, horizontal}) => {
// 	scroller = _getTarget(scroller || _win);
// 	let direction = horizontal ? _horizontal : _vertical,
// 		isViewport = _isViewport(scroller);
// 	_getSizeFunc(scroller, isViewport, direction);
// 	return _parsePosition(position, _getTarget(trigger), _getSizeFunc(scroller, isViewport, direction)(), direction, _getScrollFunc(scroller, direction)(), 0, 0, 0, _getOffsetsFunc(scroller, isViewport)(), isViewport ? 0 : parseFloat(_getComputedStyle(scroller)["border" + direction.p2 + _Width]) || 0, 0, containerAnimation ? containerAnimation.duration() : _maxScroll(scroller), containerAnimation);
// },
$daf8bee9365fb629$var$_parsePosition = function _parsePosition(value, trigger, scrollerSize, direction, scroll, marker, markerScroller, self, scrollerBounds, borderWidth, useFixedPosition, scrollerMax, containerAnimation, clampZeroProp) {
    $daf8bee9365fb629$var$_isFunction(value) && (value = value(self));
    if ($daf8bee9365fb629$var$_isString(value) && value.substr(0, 3) === "max") value = scrollerMax + (value.charAt(4) === "=" ? $daf8bee9365fb629$var$_offsetToPx("0" + value.substr(3), scrollerSize) : 0);
    var time = containerAnimation ? containerAnimation.time() : 0, p1, p2, element;
    containerAnimation && containerAnimation.seek(0);
    isNaN(value) || (value = +value); // convert a string number like "45" to an actual number
    if (!$daf8bee9365fb629$var$_isNumber(value)) {
        $daf8bee9365fb629$var$_isFunction(trigger) && (trigger = trigger(self));
        var offsets = (value || "0").split(" "), bounds, localOffset, globalOffset, display;
        element = (0, $d7385dda6eeeec57$export$937374fea3f88711)(trigger, self) || $daf8bee9365fb629$var$_body;
        bounds = $daf8bee9365fb629$var$_getBounds(element) || {};
        if ((!bounds || !bounds.left && !bounds.top) && $daf8bee9365fb629$var$_getComputedStyle(element).display === "none") {
            // if display is "none", it won't report getBoundingClientRect() properly
            display = element.style.display;
            element.style.display = "block";
            bounds = $daf8bee9365fb629$var$_getBounds(element);
            display ? element.style.display = display : element.style.removeProperty("display");
        }
        localOffset = $daf8bee9365fb629$var$_offsetToPx(offsets[0], bounds[direction.d]);
        globalOffset = $daf8bee9365fb629$var$_offsetToPx(offsets[1] || "0", scrollerSize);
        value = bounds[direction.p] - scrollerBounds[direction.p] - borderWidth + localOffset + scroll - globalOffset;
        markerScroller && $daf8bee9365fb629$var$_positionMarker(markerScroller, globalOffset, direction, scrollerSize - globalOffset < 20 || markerScroller._isStart && globalOffset > 20);
        scrollerSize -= scrollerSize - globalOffset; // adjust for the marker
    } else {
        containerAnimation && (value = $daf8bee9365fb629$var$gsap.utils.mapRange(containerAnimation.scrollTrigger.start, containerAnimation.scrollTrigger.end, 0, scrollerMax, value));
        markerScroller && $daf8bee9365fb629$var$_positionMarker(markerScroller, scrollerSize, direction, true);
    }
    if (clampZeroProp) {
        self[clampZeroProp] = value || -0.001;
        value < 0 && (value = 0);
    }
    if (marker) {
        var position = value + scrollerSize, isStart = marker._isStart;
        p1 = "scroll" + direction.d2;
        $daf8bee9365fb629$var$_positionMarker(marker, position, direction, isStart && position > 20 || !isStart && (useFixedPosition ? Math.max($daf8bee9365fb629$var$_body[p1], $daf8bee9365fb629$var$_docEl[p1]) : marker.parentNode[p1]) <= position + 1);
        if (useFixedPosition) {
            scrollerBounds = $daf8bee9365fb629$var$_getBounds(markerScroller);
            useFixedPosition && (marker.style[direction.op.p] = scrollerBounds[direction.op.p] - direction.op.m - marker._offset + $daf8bee9365fb629$var$_px);
        }
    }
    if (containerAnimation && element) {
        p1 = $daf8bee9365fb629$var$_getBounds(element);
        containerAnimation.seek(scrollerMax);
        p2 = $daf8bee9365fb629$var$_getBounds(element);
        containerAnimation._caScrollDist = p1[direction.p] - p2[direction.p];
        value = value / containerAnimation._caScrollDist * scrollerMax;
    }
    containerAnimation && containerAnimation.seek(time);
    return containerAnimation ? value : Math.round(value);
}, $daf8bee9365fb629$var$_prefixExp = /(webkit|moz|length|cssText|inset)/i, $daf8bee9365fb629$var$_reparent = function _reparent(element, parent, top, left) {
    if (element.parentNode !== parent) {
        var style = element.style, p, cs;
        if (parent === $daf8bee9365fb629$var$_body) {
            element._stOrig = style.cssText; // record original inline styles so we can revert them later
            cs = $daf8bee9365fb629$var$_getComputedStyle(element);
            for(p in cs)// must copy all relevant styles to ensure that nothing changes visually when we reparent to the <body>. Skip the vendor prefixed ones.
            if (!+p && !$daf8bee9365fb629$var$_prefixExp.test(p) && cs[p] && typeof style[p] === "string" && p !== "0") style[p] = cs[p];
            style.top = top;
            style.left = left;
        } else style.cssText = element._stOrig;
        $daf8bee9365fb629$var$gsap.core.getCache(element).uncache = 1;
        parent.appendChild(element);
    }
}, $daf8bee9365fb629$var$_interruptionTracker = function _interruptionTracker(getValueFunc, initialValue, onInterrupt) {
    var last1 = initialValue, last2 = last1;
    return function(value) {
        var current = Math.round(getValueFunc()); // round because in some [very uncommon] Windows environments, scroll can get reported with decimals even though it was set without.
        if (current !== last1 && current !== last2 && Math.abs(current - last1) > 3 && Math.abs(current - last2) > 3) {
            // if the user scrolls, kill the tween. iOS Safari intermittently misreports the scroll position, it may be the most recently-set one or the one before that! When Safari is zoomed (CMD-+), it often misreports as 1 pixel off too! So if we set the scroll position to 125, for example, it'll actually report it as 124.
            value = current;
            onInterrupt && onInterrupt();
        }
        last2 = last1;
        last1 = value;
        return value;
    };
}, $daf8bee9365fb629$var$_shiftMarker = function _shiftMarker(marker, direction, value) {
    var vars = {};
    vars[direction.p] = "+=" + value;
    $daf8bee9365fb629$var$gsap.set(marker, vars);
}, // _mergeAnimations = animations => {
// 	let tl = gsap.timeline({smoothChildTiming: true}).startTime(Math.min(...animations.map(a => a.globalTime(0))));
// 	animations.forEach(a => {let time = a.totalTime(); tl.add(a); a.totalTime(time); });
// 	tl.smoothChildTiming = false;
// 	return tl;
// },
// returns a function that can be used to tween the scroll position in the direction provided, and when doing so it'll add a .tween property to the FUNCTION itself, and remove it when the tween completes or gets killed. This gives us a way to have multiple ScrollTriggers use a central function for any given scroller and see if there's a scroll tween running (which would affect if/how things get updated)
$daf8bee9365fb629$var$_getTweenCreator = function _getTweenCreator(scroller, direction) {
    var getScroll = (0, $d7385dda6eeeec57$export$8665aac53dad5647)(scroller, direction), prop = "_scroll" + direction.p2, // add a tweenable property to the scroller that's a getter/setter function, like _scrollTop or _scrollLeft. This way, if someone does gsap.killTweensOf(scroller) it'll kill the scroll tween.
    getTween = function getTween(scrollTo, vars, initialValue, change1, change2) {
        var tween = getTween.tween, onComplete = vars.onComplete, modifiers = {};
        initialValue = initialValue || getScroll();
        var checkForInterruption = $daf8bee9365fb629$var$_interruptionTracker(getScroll, initialValue, function() {
            tween.kill();
            getTween.tween = 0;
        });
        change2 = change1 && change2 || 0; // if change1 is 0, we set that to the difference and ignore change2. Otherwise, there would be a compound effect.
        change1 = change1 || scrollTo - initialValue;
        tween && tween.kill();
        vars[prop] = scrollTo;
        vars.inherit = false;
        vars.modifiers = modifiers;
        modifiers[prop] = function() {
            return checkForInterruption(initialValue + change1 * tween.ratio + change2 * tween.ratio * tween.ratio);
        };
        vars.onUpdate = function() {
            (0, $d7385dda6eeeec57$export$3cd1cee43d19b683).cache++;
            getTween.tween && $daf8bee9365fb629$var$_updateAll(); // if it was interrupted/killed, like in a context.revert(), don't force an updateAll()
        };
        vars.onComplete = function() {
            getTween.tween = 0;
            onComplete && onComplete.call(tween);
        };
        tween = getTween.tween = $daf8bee9365fb629$var$gsap.to(scroller, vars);
        return tween;
    };
    scroller[prop] = getScroll;
    getScroll.wheelHandler = function() {
        return getTween.tween && getTween.tween.kill() && (getTween.tween = 0);
    };
    $daf8bee9365fb629$var$_addListener(scroller, "wheel", getScroll.wheelHandler); // Windows machines handle mousewheel scrolling in chunks (like "3 lines per scroll") meaning the typical strategy for cancelling the scroll isn't as sensitive. It's much more likely to match one of the previous 2 scroll event positions. So we kill any snapping as soon as there's a wheel event.
    $daf8bee9365fb629$export$875bcbe48555930.isTouch && $daf8bee9365fb629$var$_addListener(scroller, "touchmove", getScroll.wheelHandler);
    return getTween;
};
var $daf8bee9365fb629$export$875bcbe48555930 = /*#__PURE__*/ function() {
    function ScrollTrigger(vars, animation) {
        $daf8bee9365fb629$var$_coreInitted || ScrollTrigger.register($daf8bee9365fb629$var$gsap) || console.warn("Please gsap.registerPlugin(ScrollTrigger)");
        $daf8bee9365fb629$var$_context(this);
        this.init(vars, animation);
    }
    var _proto = ScrollTrigger.prototype;
    _proto.init = function init(vars, animation) {
        this.progress = this.start = 0;
        this.vars && this.kill(true, true); // in case it's being initted again
        if (!$daf8bee9365fb629$var$_enabled) {
            this.update = this.refresh = this.kill = $daf8bee9365fb629$var$_passThrough;
            return;
        }
        vars = $daf8bee9365fb629$var$_setDefaults($daf8bee9365fb629$var$_isString(vars) || $daf8bee9365fb629$var$_isNumber(vars) || vars.nodeType ? {
            trigger: vars
        } : vars, $daf8bee9365fb629$var$_defaults);
        var _vars = vars, onUpdate = _vars.onUpdate, toggleClass = _vars.toggleClass, id = _vars.id, onToggle = _vars.onToggle, onRefresh = _vars.onRefresh, scrub = _vars.scrub, trigger = _vars.trigger, pin = _vars.pin, pinSpacing = _vars.pinSpacing, invalidateOnRefresh = _vars.invalidateOnRefresh, anticipatePin = _vars.anticipatePin, onScrubComplete = _vars.onScrubComplete, onSnapComplete = _vars.onSnapComplete, once = _vars.once, snap = _vars.snap, pinReparent = _vars.pinReparent, pinSpacer = _vars.pinSpacer, containerAnimation = _vars.containerAnimation, fastScrollEnd = _vars.fastScrollEnd, preventOverlaps = _vars.preventOverlaps, direction = vars.horizontal || vars.containerAnimation && vars.horizontal !== false ? (0, $d7385dda6eeeec57$export$b2cabb342cb0ebe1) : (0, $d7385dda6eeeec57$export$8e40fc98ff518e9d), isToggle = !scrub && scrub !== 0, scroller = (0, $d7385dda6eeeec57$export$937374fea3f88711)(vars.scroller || $daf8bee9365fb629$var$_win), scrollerCache = $daf8bee9365fb629$var$gsap.core.getCache(scroller), isViewport = $daf8bee9365fb629$var$_isViewport(scroller), useFixedPosition = ("pinType" in vars ? vars.pinType : (0, $d7385dda6eeeec57$export$6078f1ef08b38af9)(scroller, "pinType") || isViewport && "fixed") === "fixed", callbacks = [
            vars.onEnter,
            vars.onLeave,
            vars.onEnterBack,
            vars.onLeaveBack
        ], toggleActions = isToggle && vars.toggleActions.split(" "), markers = "markers" in vars ? vars.markers : $daf8bee9365fb629$var$_defaults.markers, borderWidth = isViewport ? 0 : parseFloat($daf8bee9365fb629$var$_getComputedStyle(scroller)["border" + direction.p2 + $daf8bee9365fb629$var$_Width]) || 0, self = this, onRefreshInit = vars.onRefreshInit && function() {
            return vars.onRefreshInit(self);
        }, getScrollerSize = $daf8bee9365fb629$var$_getSizeFunc(scroller, isViewport, direction), getScrollerOffsets = $daf8bee9365fb629$var$_getOffsetsFunc(scroller, isViewport), lastSnap = 0, lastRefresh = 0, prevProgress = 0, scrollFunc = (0, $d7385dda6eeeec57$export$8665aac53dad5647)(scroller, direction), tweenTo, pinCache, snapFunc, scroll1, scroll2, start, end, markerStart, markerEnd, markerStartTrigger, markerEndTrigger, markerVars, executingOnRefresh, change, pinOriginalState, pinActiveState, pinState, spacer, offset, pinGetter, pinSetter, pinStart, pinChange, spacingStart, spacerState, markerStartSetter, pinMoves, markerEndSetter, cs, snap1, snap2, scrubTween, scrubSmooth, snapDurClamp, snapDelayedCall, prevScroll, prevAnimProgress, caMarkerSetter, customRevertReturn; // for the sake of efficiency, _startClamp/_endClamp serve like a truthy value indicating that clamping was enabled on the start/end, and ALSO store the actual pre-clamped numeric value. We tap into that in ScrollSmoother for speed effects. So for example, if start="clamp(top bottom)" results in a start of -100 naturally, it would get clamped to 0 but -100 would be stored in _startClamp.
        self._startClamp = self._endClamp = false;
        self._dir = direction;
        anticipatePin *= 45;
        self.scroller = scroller;
        self.scroll = containerAnimation ? containerAnimation.time.bind(containerAnimation) : scrollFunc;
        scroll1 = scrollFunc();
        self.vars = vars;
        animation = animation || vars.animation;
        if ("refreshPriority" in vars) {
            $daf8bee9365fb629$var$_sort = 1;
            vars.refreshPriority === -9999 && ($daf8bee9365fb629$var$_primary = self); // used by ScrollSmoother
        }
        scrollerCache.tweenScroll = scrollerCache.tweenScroll || {
            top: $daf8bee9365fb629$var$_getTweenCreator(scroller, (0, $d7385dda6eeeec57$export$8e40fc98ff518e9d)),
            left: $daf8bee9365fb629$var$_getTweenCreator(scroller, (0, $d7385dda6eeeec57$export$b2cabb342cb0ebe1))
        };
        self.tweenTo = tweenTo = scrollerCache.tweenScroll[direction.p];
        self.scrubDuration = function(value) {
            scrubSmooth = $daf8bee9365fb629$var$_isNumber(value) && value;
            if (!scrubSmooth) {
                scrubTween && scrubTween.progress(1).kill();
                scrubTween = 0;
            } else scrubTween ? scrubTween.duration(value) : scrubTween = $daf8bee9365fb629$var$gsap.to(animation, {
                ease: "expo",
                totalProgress: "+=0",
                inherit: false,
                duration: scrubSmooth,
                paused: true,
                onComplete: function onComplete() {
                    return onScrubComplete && onScrubComplete(self);
                }
            });
        };
        if (animation) {
            animation.vars.lazy = false;
            animation._initted && !self.isReverted || animation.vars.immediateRender !== false && vars.immediateRender !== false && animation.duration() && animation.render(0, true, true); // special case: if this ScrollTrigger gets re-initted, a from() tween with a stagger could get initted initially and then reverted on the re-init which means it'll need to get rendered again here to properly display things. Otherwise, See https://gsap.com/forums/topic/36777-scrollsmoother-splittext-nextjs/ and https://codepen.io/GreenSock/pen/eYPyPpd?editors=0010
            self.animation = animation.pause();
            animation.scrollTrigger = self;
            self.scrubDuration(scrub);
            snap1 = 0;
            id || (id = animation.vars.id);
        }
        if (snap) {
            // TODO: potential idea: use legitimate CSS scroll snapping by pushing invisible elements into the DOM that serve as snap positions, and toggle the document.scrollingElement.style.scrollSnapType onToggle. See https://codepen.io/GreenSock/pen/JjLrgWM for a quick proof of concept.
            if (!$daf8bee9365fb629$var$_isObject(snap) || snap.push) snap = {
                snapTo: snap
            };
            "scrollBehavior" in $daf8bee9365fb629$var$_body.style && $daf8bee9365fb629$var$gsap.set(isViewport ? [
                $daf8bee9365fb629$var$_body,
                $daf8bee9365fb629$var$_docEl
            ] : scroller, {
                scrollBehavior: "auto"
            }); // smooth scrolling doesn't work with snap.
            (0, $d7385dda6eeeec57$export$3cd1cee43d19b683).forEach(function(o) {
                return $daf8bee9365fb629$var$_isFunction(o) && o.target === (isViewport ? $daf8bee9365fb629$var$_doc.scrollingElement || $daf8bee9365fb629$var$_docEl : scroller) && (o.smooth = false);
            }); // note: set smooth to false on both the vertical and horizontal scroll getters/setters
            snapFunc = $daf8bee9365fb629$var$_isFunction(snap.snapTo) ? snap.snapTo : snap.snapTo === "labels" ? $daf8bee9365fb629$var$_getClosestLabel(animation) : snap.snapTo === "labelsDirectional" ? $daf8bee9365fb629$var$_getLabelAtDirection(animation) : snap.directional !== false ? function(value, st) {
                return $daf8bee9365fb629$var$_snapDirectional(snap.snapTo)(value, $daf8bee9365fb629$var$_getTime() - lastRefresh < 500 ? 0 : st.direction);
            } : $daf8bee9365fb629$var$gsap.utils.snap(snap.snapTo);
            snapDurClamp = snap.duration || {
                min: 0.1,
                max: 2
            };
            snapDurClamp = $daf8bee9365fb629$var$_isObject(snapDurClamp) ? $daf8bee9365fb629$var$_clamp(snapDurClamp.min, snapDurClamp.max) : $daf8bee9365fb629$var$_clamp(snapDurClamp, snapDurClamp);
            snapDelayedCall = $daf8bee9365fb629$var$gsap.delayedCall(snap.delay || scrubSmooth / 2 || 0.1, function() {
                var scroll = scrollFunc(), refreshedRecently = $daf8bee9365fb629$var$_getTime() - lastRefresh < 500, tween = tweenTo.tween;
                if ((refreshedRecently || Math.abs(self.getVelocity()) < 10) && !tween && !$daf8bee9365fb629$var$_pointerIsDown && lastSnap !== scroll) {
                    var progress = (scroll - start) / change, totalProgress = animation && !isToggle ? animation.totalProgress() : progress, velocity = refreshedRecently ? 0 : (totalProgress - snap2) / ($daf8bee9365fb629$var$_getTime() - $daf8bee9365fb629$var$_time2) * 1000 || 0, change1 = $daf8bee9365fb629$var$gsap.utils.clamp(-progress, 1 - progress, $daf8bee9365fb629$var$_abs(velocity / 2) * velocity / 0.185), naturalEnd = progress + (snap.inertia === false ? 0 : change1), endValue, endScroll, _snap = snap, onStart = _snap.onStart, _onInterrupt = _snap.onInterrupt, _onComplete = _snap.onComplete;
                    endValue = snapFunc(naturalEnd, self);
                    $daf8bee9365fb629$var$_isNumber(endValue) || (endValue = naturalEnd); // in case the function didn't return a number, fall back to using the naturalEnd
                    endScroll = Math.round(start + endValue * change);
                    if (scroll <= end && scroll >= start && endScroll !== scroll) {
                        if (tween && !tween._initted && tween.data <= $daf8bee9365fb629$var$_abs(endScroll - scroll)) // there's an overlapping snap! So we must figure out which one is closer and let that tween live.
                        return;
                        if (snap.inertia === false) change1 = endValue - progress;
                        tweenTo(endScroll, {
                            duration: snapDurClamp($daf8bee9365fb629$var$_abs(Math.max($daf8bee9365fb629$var$_abs(naturalEnd - totalProgress), $daf8bee9365fb629$var$_abs(endValue - totalProgress)) * 0.185 / velocity / 0.05 || 0)),
                            ease: snap.ease || "power3",
                            data: $daf8bee9365fb629$var$_abs(endScroll - scroll),
                            // record the distance so that if another snap tween occurs (conflict) we can prioritize the closest snap.
                            onInterrupt: function onInterrupt() {
                                return snapDelayedCall.restart(true) && _onInterrupt && _onInterrupt(self);
                            },
                            onComplete: function onComplete() {
                                self.update();
                                lastSnap = scrollFunc();
                                if (animation) // the resolution of the scrollbar is limited, so we should correct the scrubbed animation's playhead at the end to match EXACTLY where it was supposed to snap
                                scrubTween ? scrubTween.resetTo("totalProgress", endValue, animation._tTime / animation._tDur) : animation.progress(endValue);
                                snap1 = snap2 = animation && !isToggle ? animation.totalProgress() : self.progress;
                                onSnapComplete && onSnapComplete(self);
                                _onComplete && _onComplete(self);
                            }
                        }, scroll, change1 * change, endScroll - scroll - change1 * change);
                        onStart && onStart(self, tweenTo.tween);
                    }
                } else if (self.isActive && lastSnap !== scroll) snapDelayedCall.restart(true);
            }).pause();
        }
        id && ($daf8bee9365fb629$var$_ids[id] = self);
        trigger = self.trigger = (0, $d7385dda6eeeec57$export$937374fea3f88711)(trigger || pin !== true && pin); // if a trigger has some kind of scroll-related effect applied that could contaminate the "y" or "x" position (like a ScrollSmoother effect), we needed a way to temporarily revert it, so we use the stRevert property of the gsCache. It can return another function that we'll call at the end so it can return to its normal state.
        customRevertReturn = trigger && trigger._gsap && trigger._gsap.stRevert;
        customRevertReturn && (customRevertReturn = customRevertReturn(self));
        pin = pin === true ? trigger : (0, $d7385dda6eeeec57$export$937374fea3f88711)(pin);
        $daf8bee9365fb629$var$_isString(toggleClass) && (toggleClass = {
            targets: trigger,
            className: toggleClass
        });
        if (pin) {
            pinSpacing === false || pinSpacing === $daf8bee9365fb629$var$_margin || (pinSpacing = !pinSpacing && pin.parentNode && pin.parentNode.style && $daf8bee9365fb629$var$_getComputedStyle(pin.parentNode).display === "flex" ? false : $daf8bee9365fb629$var$_padding); // if the parent is display: flex, don't apply pinSpacing by default. We should check that pin.parentNode is an element (not shadow dom window)
            self.pin = pin;
            pinCache = $daf8bee9365fb629$var$gsap.core.getCache(pin);
            if (!pinCache.spacer) {
                // record the spacer and pinOriginalState on the cache in case someone tries pinning the same element with MULTIPLE ScrollTriggers - we don't want to have multiple spacers or record the "original" pin state after it has already been affected by another ScrollTrigger.
                if (pinSpacer) {
                    pinSpacer = (0, $d7385dda6eeeec57$export$937374fea3f88711)(pinSpacer);
                    pinSpacer && !pinSpacer.nodeType && (pinSpacer = pinSpacer.current || pinSpacer.nativeElement); // for React & Angular
                    pinCache.spacerIsNative = !!pinSpacer;
                    pinSpacer && (pinCache.spacerState = $daf8bee9365fb629$var$_getState(pinSpacer));
                }
                pinCache.spacer = spacer = pinSpacer || $daf8bee9365fb629$var$_doc.createElement("div");
                spacer.classList.add("pin-spacer");
                id && spacer.classList.add("pin-spacer-" + id);
                pinCache.pinState = pinOriginalState = $daf8bee9365fb629$var$_getState(pin);
            } else pinOriginalState = pinCache.pinState;
            vars.force3D !== false && $daf8bee9365fb629$var$gsap.set(pin, {
                force3D: true
            });
            self.spacer = spacer = pinCache.spacer;
            cs = $daf8bee9365fb629$var$_getComputedStyle(pin);
            spacingStart = cs[pinSpacing + direction.os2];
            pinGetter = $daf8bee9365fb629$var$gsap.getProperty(pin);
            pinSetter = $daf8bee9365fb629$var$gsap.quickSetter(pin, direction.a, $daf8bee9365fb629$var$_px); // pin.firstChild && !_maxScroll(pin, direction) && (pin.style.overflow = "hidden"); // protects from collapsing margins, but can have unintended consequences as demonstrated here: https://codepen.io/GreenSock/pen/1e42c7a73bfa409d2cf1e184e7a4248d so it was removed in favor of just telling people to set up their CSS to avoid the collapsing margins (overflow: hidden | auto is just one option. Another is border-top: 1px solid transparent).
            $daf8bee9365fb629$var$_swapPinIn(pin, spacer, cs);
            pinState = $daf8bee9365fb629$var$_getState(pin);
        }
        if (markers) {
            markerVars = $daf8bee9365fb629$var$_isObject(markers) ? $daf8bee9365fb629$var$_setDefaults(markers, $daf8bee9365fb629$var$_markerDefaults) : $daf8bee9365fb629$var$_markerDefaults;
            markerStartTrigger = $daf8bee9365fb629$var$_createMarker("scroller-start", id, scroller, direction, markerVars, 0);
            markerEndTrigger = $daf8bee9365fb629$var$_createMarker("scroller-end", id, scroller, direction, markerVars, 0, markerStartTrigger);
            offset = markerStartTrigger["offset" + direction.op.d2];
            var content = (0, $d7385dda6eeeec57$export$937374fea3f88711)((0, $d7385dda6eeeec57$export$6078f1ef08b38af9)(scroller, "content") || scroller);
            markerStart = this.markerStart = $daf8bee9365fb629$var$_createMarker("start", id, content, direction, markerVars, offset, 0, containerAnimation);
            markerEnd = this.markerEnd = $daf8bee9365fb629$var$_createMarker("end", id, content, direction, markerVars, offset, 0, containerAnimation);
            containerAnimation && (caMarkerSetter = $daf8bee9365fb629$var$gsap.quickSetter([
                markerStart,
                markerEnd
            ], direction.a, $daf8bee9365fb629$var$_px));
            if (!useFixedPosition && !((0, $d7385dda6eeeec57$export$d8e56d510a804d0a).length && (0, $d7385dda6eeeec57$export$6078f1ef08b38af9)(scroller, "fixedMarkers") === true)) {
                $daf8bee9365fb629$var$_makePositionable(isViewport ? $daf8bee9365fb629$var$_body : scroller);
                $daf8bee9365fb629$var$gsap.set([
                    markerStartTrigger,
                    markerEndTrigger
                ], {
                    force3D: true
                });
                markerStartSetter = $daf8bee9365fb629$var$gsap.quickSetter(markerStartTrigger, direction.a, $daf8bee9365fb629$var$_px);
                markerEndSetter = $daf8bee9365fb629$var$gsap.quickSetter(markerEndTrigger, direction.a, $daf8bee9365fb629$var$_px);
            }
        }
        if (containerAnimation) {
            var oldOnUpdate = containerAnimation.vars.onUpdate, oldParams = containerAnimation.vars.onUpdateParams;
            containerAnimation.eventCallback("onUpdate", function() {
                self.update(0, 0, 1);
                oldOnUpdate && oldOnUpdate.apply(containerAnimation, oldParams || []);
            });
        }
        self.previous = function() {
            return $daf8bee9365fb629$var$_triggers[$daf8bee9365fb629$var$_triggers.indexOf(self) - 1];
        };
        self.next = function() {
            return $daf8bee9365fb629$var$_triggers[$daf8bee9365fb629$var$_triggers.indexOf(self) + 1];
        };
        self.revert = function(revert, temp) {
            if (!temp) return self.kill(true);
             // for compatibility with gsap.context() and gsap.matchMedia() which call revert()
            var r = revert !== false || !self.enabled, prevRefreshing = $daf8bee9365fb629$var$_refreshing;
            if (r !== self.isReverted) {
                if (r) {
                    prevScroll = Math.max(scrollFunc(), self.scroll.rec || 0); // record the scroll so we can revert later (repositioning/pinning things can affect scroll position). In the static refresh() method, we first record all the scroll positions as a reference.
                    prevProgress = self.progress;
                    prevAnimProgress = animation && animation.progress();
                }
                markerStart && [
                    markerStart,
                    markerEnd,
                    markerStartTrigger,
                    markerEndTrigger
                ].forEach(function(m) {
                    return m.style.display = r ? "none" : "block";
                });
                if (r) {
                    $daf8bee9365fb629$var$_refreshing = self;
                    self.update(r); // make sure the pin is back in its original position so that all the measurements are correct. do this BEFORE swapping the pin out
                }
                if (pin && (!pinReparent || !self.isActive)) {
                    if (r) $daf8bee9365fb629$var$_swapPinOut(pin, spacer, pinOriginalState);
                    else $daf8bee9365fb629$var$_swapPinIn(pin, spacer, $daf8bee9365fb629$var$_getComputedStyle(pin), spacerState);
                }
                r || self.update(r); // when we're restoring, the update should run AFTER swapping the pin into its pin-spacer.
                $daf8bee9365fb629$var$_refreshing = prevRefreshing; // restore. We set it to true during the update() so that things fire properly in there.
                self.isReverted = r;
            }
        };
        self.refresh = function(soft, force, position, pinOffset) {
            // position is typically only defined if it's coming from setPositions() - it's a way to skip the normal parsing. pinOffset is also only from setPositions() and is mostly related to fancy stuff we need to do in ScrollSmoother with effects
            if (($daf8bee9365fb629$var$_refreshing || !self.enabled) && !force) return;
            if (pin && soft && $daf8bee9365fb629$var$_lastScrollTime) {
                $daf8bee9365fb629$var$_addListener(ScrollTrigger, "scrollEnd", $daf8bee9365fb629$var$_softRefresh);
                return;
            }
            !$daf8bee9365fb629$var$_refreshingAll && onRefreshInit && onRefreshInit(self);
            $daf8bee9365fb629$var$_refreshing = self;
            if (tweenTo.tween && !position) {
                // we skip this if a position is passed in because typically that's from .setPositions() and it's best to allow in-progress snapping to continue.
                tweenTo.tween.kill();
                tweenTo.tween = 0;
            }
            scrubTween && scrubTween.pause();
            invalidateOnRefresh && animation && animation.revert({
                kill: false
            }).invalidate();
            self.isReverted || self.revert(true, true);
            self._subPinOffset = false; // we'll set this to true in the sub-pins if we find any
            var size = getScrollerSize(), scrollerBounds = getScrollerOffsets(), max = containerAnimation ? containerAnimation.duration() : $daf8bee9365fb629$var$_maxScroll(scroller, direction), isFirstRefresh = change <= 0.01, offset = 0, otherPinOffset = pinOffset || 0, parsedEnd = $daf8bee9365fb629$var$_isObject(position) ? position.end : vars.end, parsedEndTrigger = vars.endTrigger || trigger, parsedStart = $daf8bee9365fb629$var$_isObject(position) ? position.start : vars.start || (vars.start === 0 || !trigger ? 0 : pin ? "0 0" : "0 100%"), pinnedContainer = self.pinnedContainer = vars.pinnedContainer && (0, $d7385dda6eeeec57$export$937374fea3f88711)(vars.pinnedContainer, self), triggerIndex = trigger && Math.max(0, $daf8bee9365fb629$var$_triggers.indexOf(self)) || 0, i = triggerIndex, cs, bounds, scroll, isVertical, override, curTrigger, curPin, oppositeScroll, initted, revertedPins, forcedOverflow, markerStartOffset, markerEndOffset;
            if (markers && $daf8bee9365fb629$var$_isObject(position)) {
                // if we alter the start/end positions with .setPositions(), it generally feeds in absolute NUMBERS which don't convey information about where to line up the markers, so to keep it intuitive, we record how far the trigger positions shift after applying the new numbers and then offset by that much in the opposite direction. We do the same to the associated trigger markers too of course.
                markerStartOffset = $daf8bee9365fb629$var$gsap.getProperty(markerStartTrigger, direction.p);
                markerEndOffset = $daf8bee9365fb629$var$gsap.getProperty(markerEndTrigger, direction.p);
            }
            while(i--){
                // user might try to pin the same element more than once, so we must find any prior triggers with the same pin, revert them, and determine how long they're pinning so that we can offset things appropriately. Make sure we revert from last to first so that things "rewind" properly.
                curTrigger = $daf8bee9365fb629$var$_triggers[i];
                curTrigger.end || curTrigger.refresh(0, 1) || ($daf8bee9365fb629$var$_refreshing = self); // if it's a timeline-based trigger that hasn't been fully initialized yet because it's waiting for 1 tick, just force the refresh() here, otherwise if it contains a pin that's supposed to affect other ScrollTriggers further down the page, they won't be adjusted properly.
                curPin = curTrigger.pin;
                if (curPin && (curPin === trigger || curPin === pin || curPin === pinnedContainer) && !curTrigger.isReverted) {
                    revertedPins || (revertedPins = []);
                    revertedPins.unshift(curTrigger); // we'll revert from first to last to make sure things reach their end state properly
                    curTrigger.revert(true, true);
                }
                if (curTrigger !== $daf8bee9365fb629$var$_triggers[i]) {
                    // in case it got removed.
                    triggerIndex--;
                    i--;
                }
            }
            $daf8bee9365fb629$var$_isFunction(parsedStart) && (parsedStart = parsedStart(self));
            parsedStart = $daf8bee9365fb629$var$_parseClamp(parsedStart, "start", self);
            start = $daf8bee9365fb629$var$_parsePosition(parsedStart, trigger, size, direction, scrollFunc(), markerStart, markerStartTrigger, self, scrollerBounds, borderWidth, useFixedPosition, max, containerAnimation, self._startClamp && "_startClamp") || (pin ? -0.001 : 0);
            $daf8bee9365fb629$var$_isFunction(parsedEnd) && (parsedEnd = parsedEnd(self));
            if ($daf8bee9365fb629$var$_isString(parsedEnd) && !parsedEnd.indexOf("+=")) {
                if (~parsedEnd.indexOf(" ")) parsedEnd = ($daf8bee9365fb629$var$_isString(parsedStart) ? parsedStart.split(" ")[0] : "") + parsedEnd;
                else {
                    offset = $daf8bee9365fb629$var$_offsetToPx(parsedEnd.substr(2), size);
                    parsedEnd = $daf8bee9365fb629$var$_isString(parsedStart) ? parsedStart : (containerAnimation ? $daf8bee9365fb629$var$gsap.utils.mapRange(0, containerAnimation.duration(), containerAnimation.scrollTrigger.start, containerAnimation.scrollTrigger.end, start) : start) + offset; // _parsePosition won't factor in the offset if the start is a number, so do it here.
                    parsedEndTrigger = trigger;
                }
            }
            parsedEnd = $daf8bee9365fb629$var$_parseClamp(parsedEnd, "end", self);
            end = Math.max(start, $daf8bee9365fb629$var$_parsePosition(parsedEnd || (parsedEndTrigger ? "100% 0" : max), parsedEndTrigger, size, direction, scrollFunc() + offset, markerEnd, markerEndTrigger, self, scrollerBounds, borderWidth, useFixedPosition, max, containerAnimation, self._endClamp && "_endClamp")) || -0.001;
            offset = 0;
            i = triggerIndex;
            while(i--){
                curTrigger = $daf8bee9365fb629$var$_triggers[i];
                curPin = curTrigger.pin;
                if (curPin && curTrigger.start - curTrigger._pinPush <= start && !containerAnimation && curTrigger.end > 0) {
                    cs = curTrigger.end - (self._startClamp ? Math.max(0, curTrigger.start) : curTrigger.start);
                    if ((curPin === trigger && curTrigger.start - curTrigger._pinPush < start || curPin === pinnedContainer) && isNaN(parsedStart)) // numeric start values shouldn't be offset at all - treat them as absolute
                    offset += cs * (1 - curTrigger.progress);
                    curPin === pin && (otherPinOffset += cs);
                }
            }
            start += offset;
            end += offset;
            self._startClamp && (self._startClamp += offset);
            if (self._endClamp && !$daf8bee9365fb629$var$_refreshingAll) {
                self._endClamp = end || -0.001;
                end = Math.min(end, $daf8bee9365fb629$var$_maxScroll(scroller, direction));
            }
            change = end - start || (start -= 0.01) && 0.001;
            if (isFirstRefresh) // on the very first refresh(), the prevProgress couldn't have been accurate yet because the start/end were never calculated, so we set it here. Before 3.11.5, it could lead to an inaccurate scroll position restoration with snapping.
            prevProgress = $daf8bee9365fb629$var$gsap.utils.clamp(0, 1, $daf8bee9365fb629$var$gsap.utils.normalize(start, end, prevScroll));
            self._pinPush = otherPinOffset;
            if (markerStart && offset) {
                // offset the markers if necessary
                cs = {};
                cs[direction.a] = "+=" + offset;
                pinnedContainer && (cs[direction.p] = "-=" + scrollFunc());
                $daf8bee9365fb629$var$gsap.set([
                    markerStart,
                    markerEnd
                ], cs);
            }
            if (pin && !($daf8bee9365fb629$var$_clampingMax && self.end >= $daf8bee9365fb629$var$_maxScroll(scroller, direction))) {
                cs = $daf8bee9365fb629$var$_getComputedStyle(pin);
                isVertical = direction === (0, $d7385dda6eeeec57$export$8e40fc98ff518e9d);
                scroll = scrollFunc(); // recalculate because the triggers can affect the scroll
                pinStart = parseFloat(pinGetter(direction.a)) + otherPinOffset;
                if (!max && end > 1) {
                    // makes sure the scroller has a scrollbar, otherwise if something has width: 100%, for example, it would be too big (exclude the scrollbar). See https://gsap.com/forums/topic/25182-scrolltrigger-width-of-page-increase-where-markers-are-set-to-false/
                    forcedOverflow = (isViewport ? $daf8bee9365fb629$var$_doc.scrollingElement || $daf8bee9365fb629$var$_docEl : scroller).style;
                    forcedOverflow = {
                        style: forcedOverflow,
                        value: forcedOverflow["overflow" + direction.a.toUpperCase()]
                    };
                    if (isViewport && $daf8bee9365fb629$var$_getComputedStyle($daf8bee9365fb629$var$_body)["overflow" + direction.a.toUpperCase()] !== "scroll") // avoid an extra scrollbar if BOTH <html> and <body> have overflow set to "scroll"
                    forcedOverflow.style["overflow" + direction.a.toUpperCase()] = "scroll";
                }
                $daf8bee9365fb629$var$_swapPinIn(pin, spacer, cs);
                pinState = $daf8bee9365fb629$var$_getState(pin); // transforms will interfere with the top/left/right/bottom placement, so remove them temporarily. getBoundingClientRect() factors in transforms.
                bounds = $daf8bee9365fb629$var$_getBounds(pin, true);
                oppositeScroll = useFixedPosition && (0, $d7385dda6eeeec57$export$8665aac53dad5647)(scroller, isVertical ? (0, $d7385dda6eeeec57$export$b2cabb342cb0ebe1) : (0, $d7385dda6eeeec57$export$8e40fc98ff518e9d))();
                if (pinSpacing) {
                    spacerState = [
                        pinSpacing + direction.os2,
                        change + otherPinOffset + $daf8bee9365fb629$var$_px
                    ];
                    spacerState.t = spacer;
                    i = pinSpacing === $daf8bee9365fb629$var$_padding ? $daf8bee9365fb629$var$_getSize(pin, direction) + change + otherPinOffset : 0;
                    if (i) {
                        spacerState.push(direction.d, i + $daf8bee9365fb629$var$_px); // for box-sizing: border-box (must include padding).
                        spacer.style.flexBasis !== "auto" && (spacer.style.flexBasis = i + $daf8bee9365fb629$var$_px);
                    }
                    $daf8bee9365fb629$var$_setState(spacerState);
                    if (pinnedContainer) // in ScrollTrigger.refresh(), we need to re-evaluate the pinContainer's size because this pinSpacing may stretch it out, but we can't just add the exact distance because depending on layout, it may not push things down or it may only do so partially.
                    $daf8bee9365fb629$var$_triggers.forEach(function(t) {
                        if (t.pin === pinnedContainer && t.vars.pinSpacing !== false) t._subPinOffset = true;
                    });
                    useFixedPosition && scrollFunc(prevScroll);
                } else {
                    i = $daf8bee9365fb629$var$_getSize(pin, direction);
                    i && spacer.style.flexBasis !== "auto" && (spacer.style.flexBasis = i + $daf8bee9365fb629$var$_px);
                }
                if (useFixedPosition) {
                    override = {
                        top: bounds.top + (isVertical ? scroll - start : oppositeScroll) + $daf8bee9365fb629$var$_px,
                        left: bounds.left + (isVertical ? oppositeScroll : scroll - start) + $daf8bee9365fb629$var$_px,
                        boxSizing: "border-box",
                        position: "fixed"
                    };
                    override[$daf8bee9365fb629$var$_width] = override["max" + $daf8bee9365fb629$var$_Width] = Math.ceil(bounds.width) + $daf8bee9365fb629$var$_px;
                    override[$daf8bee9365fb629$var$_height] = override["max" + $daf8bee9365fb629$var$_Height] = Math.ceil(bounds.height) + $daf8bee9365fb629$var$_px;
                    override[$daf8bee9365fb629$var$_margin] = override[$daf8bee9365fb629$var$_margin + $daf8bee9365fb629$var$_Top] = override[$daf8bee9365fb629$var$_margin + $daf8bee9365fb629$var$_Right] = override[$daf8bee9365fb629$var$_margin + $daf8bee9365fb629$var$_Bottom] = override[$daf8bee9365fb629$var$_margin + $daf8bee9365fb629$var$_Left] = "0";
                    override[$daf8bee9365fb629$var$_padding] = cs[$daf8bee9365fb629$var$_padding];
                    override[$daf8bee9365fb629$var$_padding + $daf8bee9365fb629$var$_Top] = cs[$daf8bee9365fb629$var$_padding + $daf8bee9365fb629$var$_Top];
                    override[$daf8bee9365fb629$var$_padding + $daf8bee9365fb629$var$_Right] = cs[$daf8bee9365fb629$var$_padding + $daf8bee9365fb629$var$_Right];
                    override[$daf8bee9365fb629$var$_padding + $daf8bee9365fb629$var$_Bottom] = cs[$daf8bee9365fb629$var$_padding + $daf8bee9365fb629$var$_Bottom];
                    override[$daf8bee9365fb629$var$_padding + $daf8bee9365fb629$var$_Left] = cs[$daf8bee9365fb629$var$_padding + $daf8bee9365fb629$var$_Left];
                    pinActiveState = $daf8bee9365fb629$var$_copyState(pinOriginalState, override, pinReparent);
                    $daf8bee9365fb629$var$_refreshingAll && scrollFunc(0);
                }
                if (animation) {
                    // the animation might be affecting the transform, so we must jump to the end, check the value, and compensate accordingly. Otherwise, when it becomes unpinned, the pinSetter() will get set to a value that doesn't include whatever the animation did.
                    initted = animation._initted; // if not, we must invalidate() after this step, otherwise it could lock in starting values prematurely.
                    $daf8bee9365fb629$var$_suppressOverwrites(1);
                    animation.render(animation.duration(), true, true);
                    pinChange = pinGetter(direction.a) - pinStart + change + otherPinOffset;
                    pinMoves = Math.abs(change - pinChange) > 1;
                    useFixedPosition && pinMoves && pinActiveState.splice(pinActiveState.length - 2, 2); // transform is the last property/value set in the state Array. Since the animation is controlling that, we should omit it.
                    animation.render(0, true, true);
                    initted || animation.invalidate(true);
                    animation.parent || animation.totalTime(animation.totalTime()); // if, for example, a toggleAction called play() and then refresh() happens and when we render(1) above, it would cause the animation to complete and get removed from its parent, so this makes sure it gets put back in.
                    $daf8bee9365fb629$var$_suppressOverwrites(0);
                } else pinChange = change;
                forcedOverflow && (forcedOverflow.value ? forcedOverflow.style["overflow" + direction.a.toUpperCase()] = forcedOverflow.value : forcedOverflow.style.removeProperty("overflow-" + direction.a));
            } else if (trigger && scrollFunc() && !containerAnimation) {
                // it may be INSIDE a pinned element, so walk up the tree and look for any elements with _pinOffset to compensate because anything with pinSpacing that's already scrolled would throw off the measurements in getBoundingClientRect()
                bounds = trigger.parentNode;
                while(bounds && bounds !== $daf8bee9365fb629$var$_body){
                    if (bounds._pinOffset) {
                        start -= bounds._pinOffset;
                        end -= bounds._pinOffset;
                    }
                    bounds = bounds.parentNode;
                }
            }
            revertedPins && revertedPins.forEach(function(t) {
                return t.revert(false, true);
            });
            self.start = start;
            self.end = end;
            scroll1 = scroll2 = $daf8bee9365fb629$var$_refreshingAll ? prevScroll : scrollFunc(); // reset velocity
            if (!containerAnimation && !$daf8bee9365fb629$var$_refreshingAll) {
                scroll1 < prevScroll && scrollFunc(prevScroll);
                self.scroll.rec = 0;
            }
            self.revert(false, true);
            lastRefresh = $daf8bee9365fb629$var$_getTime();
            if (snapDelayedCall) {
                lastSnap = -1; // just so snapping gets re-enabled, clear out any recorded last value
                // self.isActive && scrollFunc(start + change * prevProgress); // previously this line was here to ensure that when snapping kicks in, it's from the previous progress but in some cases that's not desirable, like an all-page ScrollTrigger when new content gets added to the page, that'd totally change the progress.
                snapDelayedCall.restart(true);
            }
            $daf8bee9365fb629$var$_refreshing = 0;
            animation && isToggle && (animation._initted || prevAnimProgress) && animation.progress() !== prevAnimProgress && animation.progress(prevAnimProgress || 0, true).render(animation.time(), true, true); // must force a re-render because if saveStyles() was used on the target(s), the styles could have been wiped out during the refresh().
            if (isFirstRefresh || prevProgress !== self.progress || containerAnimation || invalidateOnRefresh) {
                // ensures that the direction is set properly (when refreshing, progress is set back to 0 initially, then back again to wherever it needs to be) and that callbacks are triggered.
                animation && !isToggle && animation.totalProgress(containerAnimation && start < -0.001 && !prevProgress ? $daf8bee9365fb629$var$gsap.utils.normalize(start, end, 0) : prevProgress, true); // to avoid issues where animation callbacks like onStart aren't triggered.
                self.progress = isFirstRefresh || (scroll1 - start) / change === prevProgress ? 0 : prevProgress;
            }
            pin && pinSpacing && (spacer._pinOffset = Math.round(self.progress * pinChange));
            scrubTween && scrubTween.invalidate();
            if (!isNaN(markerStartOffset)) {
                // numbers were passed in for the position which are absolute, so instead of just putting the markers at the very bottom of the viewport, we figure out how far they shifted down (it's safe to assume they were originally positioned in closer relation to the trigger element with values like "top", "center", a percentage or whatever, so we offset that much in the opposite direction to basically revert them to the relative position thy were at previously.
                markerStartOffset -= $daf8bee9365fb629$var$gsap.getProperty(markerStartTrigger, direction.p);
                markerEndOffset -= $daf8bee9365fb629$var$gsap.getProperty(markerEndTrigger, direction.p);
                $daf8bee9365fb629$var$_shiftMarker(markerStartTrigger, direction, markerStartOffset);
                $daf8bee9365fb629$var$_shiftMarker(markerStart, direction, markerStartOffset - (pinOffset || 0));
                $daf8bee9365fb629$var$_shiftMarker(markerEndTrigger, direction, markerEndOffset);
                $daf8bee9365fb629$var$_shiftMarker(markerEnd, direction, markerEndOffset - (pinOffset || 0));
            }
            isFirstRefresh && !$daf8bee9365fb629$var$_refreshingAll && self.update(); // edge case - when you reload a page when it's already scrolled down, some browsers fire a "scroll" event before DOMContentLoaded, triggering an updateAll(). If we don't update the self.progress as part of refresh(), then when it happens next, it may record prevProgress as 0 when it really shouldn't, potentially causing a callback in an animation to fire again.
            if (onRefresh && !$daf8bee9365fb629$var$_refreshingAll && !executingOnRefresh) {
                // when refreshing all, we do extra work to correct pinnedContainer sizes and ensure things don't exceed the maxScroll, so we should do all the refreshes at the end after all that work so that the start/end values are corrected.
                executingOnRefresh = true;
                onRefresh(self);
                executingOnRefresh = false;
            }
        };
        self.getVelocity = function() {
            return (scrollFunc() - scroll2) / ($daf8bee9365fb629$var$_getTime() - $daf8bee9365fb629$var$_time2) * 1000 || 0;
        };
        self.endAnimation = function() {
            $daf8bee9365fb629$var$_endAnimation(self.callbackAnimation);
            if (animation) scrubTween ? scrubTween.progress(1) : !animation.paused() ? $daf8bee9365fb629$var$_endAnimation(animation, animation.reversed()) : isToggle || $daf8bee9365fb629$var$_endAnimation(animation, self.direction < 0, 1);
        };
        self.labelToScroll = function(label) {
            return animation && animation.labels && (start || self.refresh() || start) + animation.labels[label] / animation.duration() * change || 0;
        };
        self.getTrailing = function(name) {
            var i = $daf8bee9365fb629$var$_triggers.indexOf(self), a = self.direction > 0 ? $daf8bee9365fb629$var$_triggers.slice(0, i).reverse() : $daf8bee9365fb629$var$_triggers.slice(i + 1);
            return ($daf8bee9365fb629$var$_isString(name) ? a.filter(function(t) {
                return t.vars.preventOverlaps === name;
            }) : a).filter(function(t) {
                return self.direction > 0 ? t.end <= start : t.start >= end;
            });
        };
        self.update = function(reset, recordVelocity, forceFake) {
            if (containerAnimation && !forceFake && !reset) return;
            var scroll = $daf8bee9365fb629$var$_refreshingAll === true ? prevScroll : self.scroll(), p = reset ? 0 : (scroll - start) / change, clipped = p < 0 ? 0 : p > 1 ? 1 : p || 0, prevProgress = self.progress, isActive, wasActive, toggleState, action, stateChanged, toggled, isAtMax, isTakingAction;
            if (recordVelocity) {
                scroll2 = scroll1;
                scroll1 = containerAnimation ? scrollFunc() : scroll;
                if (snap) {
                    snap2 = snap1;
                    snap1 = animation && !isToggle ? animation.totalProgress() : clipped;
                }
            } // anticipate the pinning a few ticks ahead of time based on velocity to avoid a visual glitch due to the fact that most browsers do scrolling on a separate thread (not synced with requestAnimationFrame).
            if (anticipatePin && pin && !$daf8bee9365fb629$var$_refreshing && !$daf8bee9365fb629$var$_startup && $daf8bee9365fb629$var$_lastScrollTime) {
                if (!clipped && start < scroll + (scroll - scroll2) / ($daf8bee9365fb629$var$_getTime() - $daf8bee9365fb629$var$_time2) * anticipatePin) clipped = 0.0001;
                else if (clipped === 1 && end > scroll + (scroll - scroll2) / ($daf8bee9365fb629$var$_getTime() - $daf8bee9365fb629$var$_time2) * anticipatePin) clipped = 0.9999;
            }
            if (clipped !== prevProgress && self.enabled) {
                isActive = self.isActive = !!clipped && clipped < 1;
                wasActive = !!prevProgress && prevProgress < 1;
                toggled = isActive !== wasActive;
                stateChanged = toggled || !!clipped !== !!prevProgress; // could go from start all the way to end, thus it didn't toggle but it did change state in a sense (may need to fire a callback)
                self.direction = clipped > prevProgress ? 1 : -1;
                self.progress = clipped;
                if (stateChanged && !$daf8bee9365fb629$var$_refreshing) {
                    toggleState = clipped && !prevProgress ? 0 : clipped === 1 ? 1 : prevProgress === 1 ? 2 : 3; // 0 = enter, 1 = leave, 2 = enterBack, 3 = leaveBack (we prioritize the FIRST encounter, thus if you scroll really fast past the onEnter and onLeave in one tick, it'd prioritize onEnter.
                    if (isToggle) {
                        action = !toggled && toggleActions[toggleState + 1] !== "none" && toggleActions[toggleState + 1] || toggleActions[toggleState]; // if it didn't toggle, that means it shot right past and since we prioritize the "enter" action, we should switch to the "leave" in this case (but only if one is defined)
                        isTakingAction = animation && (action === "complete" || action === "reset" || action in animation);
                    }
                }
                preventOverlaps && (toggled || isTakingAction) && (isTakingAction || scrub || !animation) && ($daf8bee9365fb629$var$_isFunction(preventOverlaps) ? preventOverlaps(self) : self.getTrailing(preventOverlaps).forEach(function(t) {
                    return t.endAnimation();
                }));
                if (!isToggle) {
                    if (scrubTween && !$daf8bee9365fb629$var$_refreshing && !$daf8bee9365fb629$var$_startup) {
                        scrubTween._dp._time - scrubTween._start !== scrubTween._time && scrubTween.render(scrubTween._dp._time - scrubTween._start); // if there's a scrub on both the container animation and this one (or a ScrollSmoother), the update order would cause this one not to have rendered yet, so it wouldn't make any progress before we .restart() it heading toward the new progress so it'd appear stuck thus we force a render here.
                        if (scrubTween.resetTo) scrubTween.resetTo("totalProgress", clipped, animation._tTime / animation._tDur);
                        else {
                            // legacy support (courtesy), before 3.10.0
                            scrubTween.vars.totalProgress = clipped;
                            scrubTween.invalidate().restart();
                        }
                    } else if (animation) animation.totalProgress(clipped, !!($daf8bee9365fb629$var$_refreshing && (lastRefresh || reset)));
                }
                if (pin) {
                    reset && pinSpacing && (spacer.style[pinSpacing + direction.os2] = spacingStart);
                    if (!useFixedPosition) pinSetter($daf8bee9365fb629$var$_round(pinStart + pinChange * clipped));
                    else if (stateChanged) {
                        isAtMax = !reset && clipped > prevProgress && end + 1 > scroll && scroll + 1 >= $daf8bee9365fb629$var$_maxScroll(scroller, direction); // if it's at the VERY end of the page, don't switch away from position: fixed because it's pointless and it could cause a brief flash when the user scrolls back up (when it gets pinned again)
                        if (pinReparent) {
                            if (!reset && (isActive || isAtMax)) {
                                var bounds = $daf8bee9365fb629$var$_getBounds(pin, true), _offset = scroll - start;
                                $daf8bee9365fb629$var$_reparent(pin, $daf8bee9365fb629$var$_body, bounds.top + (direction === (0, $d7385dda6eeeec57$export$8e40fc98ff518e9d) ? _offset : 0) + $daf8bee9365fb629$var$_px, bounds.left + (direction === (0, $d7385dda6eeeec57$export$8e40fc98ff518e9d) ? 0 : _offset) + $daf8bee9365fb629$var$_px);
                            } else $daf8bee9365fb629$var$_reparent(pin, spacer);
                        }
                        $daf8bee9365fb629$var$_setState(isActive || isAtMax ? pinActiveState : pinState);
                        pinMoves && clipped < 1 && isActive || pinSetter(pinStart + (clipped === 1 && !isAtMax ? pinChange : 0));
                    }
                }
                snap && !tweenTo.tween && !$daf8bee9365fb629$var$_refreshing && !$daf8bee9365fb629$var$_startup && snapDelayedCall.restart(true);
                toggleClass && (toggled || once && clipped && (clipped < 1 || !$daf8bee9365fb629$var$_limitCallbacks)) && $daf8bee9365fb629$var$_toArray(toggleClass.targets).forEach(function(el) {
                    return el.classList[isActive || once ? "add" : "remove"](toggleClass.className);
                }); // classes could affect positioning, so do it even if reset or refreshing is true.
                onUpdate && !isToggle && !reset && onUpdate(self);
                if (stateChanged && !$daf8bee9365fb629$var$_refreshing) {
                    if (isToggle) {
                        if (isTakingAction) {
                            if (action === "complete") animation.pause().totalProgress(1);
                            else if (action === "reset") animation.restart(true).pause();
                            else if (action === "restart") animation.restart(true);
                            else animation[action]();
                        }
                        onUpdate && onUpdate(self);
                    }
                    if (toggled || !$daf8bee9365fb629$var$_limitCallbacks) {
                        // on startup, the page could be scrolled and we don't want to fire callbacks that didn't toggle. For example onEnter shouldn't fire if the ScrollTrigger isn't actually entered.
                        onToggle && toggled && $daf8bee9365fb629$var$_callback(self, onToggle);
                        callbacks[toggleState] && $daf8bee9365fb629$var$_callback(self, callbacks[toggleState]);
                        once && (clipped === 1 ? self.kill(false, 1) : callbacks[toggleState] = 0); // a callback shouldn't be called again if once is true.
                        if (!toggled) {
                            // it's possible to go completely past, like from before the start to after the end (or vice-versa) in which case BOTH callbacks should be fired in that order
                            toggleState = clipped === 1 ? 1 : 3;
                            callbacks[toggleState] && $daf8bee9365fb629$var$_callback(self, callbacks[toggleState]);
                        }
                    }
                    if (fastScrollEnd && !isActive && Math.abs(self.getVelocity()) > ($daf8bee9365fb629$var$_isNumber(fastScrollEnd) ? fastScrollEnd : 2500)) {
                        $daf8bee9365fb629$var$_endAnimation(self.callbackAnimation);
                        scrubTween ? scrubTween.progress(1) : $daf8bee9365fb629$var$_endAnimation(animation, action === "reverse" ? 1 : !clipped, 1);
                    }
                } else if (isToggle && onUpdate && !$daf8bee9365fb629$var$_refreshing) onUpdate(self);
            } // update absolutely-positioned markers (only if the scroller isn't the viewport)
            if (markerEndSetter) {
                var n = containerAnimation ? scroll / containerAnimation.duration() * (containerAnimation._caScrollDist || 0) : scroll;
                markerStartSetter(n + (markerStartTrigger._isFlipped ? 1 : 0));
                markerEndSetter(n);
            }
            caMarkerSetter && caMarkerSetter(-scroll / containerAnimation.duration() * (containerAnimation._caScrollDist || 0));
        };
        self.enable = function(reset, refresh) {
            if (!self.enabled) {
                self.enabled = true;
                $daf8bee9365fb629$var$_addListener(scroller, "resize", $daf8bee9365fb629$var$_onResize);
                isViewport || $daf8bee9365fb629$var$_addListener(scroller, "scroll", $daf8bee9365fb629$var$_onScroll);
                onRefreshInit && $daf8bee9365fb629$var$_addListener(ScrollTrigger, "refreshInit", onRefreshInit);
                if (reset !== false) {
                    self.progress = prevProgress = 0;
                    scroll1 = scroll2 = lastSnap = scrollFunc();
                }
                refresh !== false && self.refresh();
            }
        };
        self.getTween = function(snap) {
            return snap && tweenTo ? tweenTo.tween : scrubTween;
        };
        self.setPositions = function(newStart, newEnd, keepClamp, pinOffset) {
            // doesn't persist after refresh()! Intended to be a way to override values that were set during refresh(), like you could set it in onRefresh()
            if (containerAnimation) {
                // convert ratios into scroll positions. Remember, start/end values on ScrollTriggers that have a containerAnimation refer to the time (in seconds), NOT scroll positions.
                var st = containerAnimation.scrollTrigger, duration = containerAnimation.duration(), _change = st.end - st.start;
                newStart = st.start + _change * newStart / duration;
                newEnd = st.start + _change * newEnd / duration;
            }
            self.refresh(false, false, {
                start: $daf8bee9365fb629$var$_keepClamp(newStart, keepClamp && !!self._startClamp),
                end: $daf8bee9365fb629$var$_keepClamp(newEnd, keepClamp && !!self._endClamp)
            }, pinOffset);
            self.update();
        };
        self.adjustPinSpacing = function(amount) {
            if (spacerState && amount) {
                var i = spacerState.indexOf(direction.d) + 1;
                spacerState[i] = parseFloat(spacerState[i]) + amount + $daf8bee9365fb629$var$_px;
                spacerState[1] = parseFloat(spacerState[1]) + amount + $daf8bee9365fb629$var$_px;
                $daf8bee9365fb629$var$_setState(spacerState);
            }
        };
        self.disable = function(reset, allowAnimation) {
            if (self.enabled) {
                reset !== false && self.revert(true, true);
                self.enabled = self.isActive = false;
                allowAnimation || scrubTween && scrubTween.pause();
                prevScroll = 0;
                pinCache && (pinCache.uncache = 1);
                onRefreshInit && $daf8bee9365fb629$var$_removeListener(ScrollTrigger, "refreshInit", onRefreshInit);
                if (snapDelayedCall) {
                    snapDelayedCall.pause();
                    tweenTo.tween && tweenTo.tween.kill() && (tweenTo.tween = 0);
                }
                if (!isViewport) {
                    var i = $daf8bee9365fb629$var$_triggers.length;
                    while(i--){
                        if ($daf8bee9365fb629$var$_triggers[i].scroller === scroller && $daf8bee9365fb629$var$_triggers[i] !== self) return; //don't remove the listeners if there are still other triggers referencing it.
                    }
                    $daf8bee9365fb629$var$_removeListener(scroller, "resize", $daf8bee9365fb629$var$_onResize);
                    isViewport || $daf8bee9365fb629$var$_removeListener(scroller, "scroll", $daf8bee9365fb629$var$_onScroll);
                }
            }
        };
        self.kill = function(revert, allowAnimation) {
            self.disable(revert, allowAnimation);
            scrubTween && !allowAnimation && scrubTween.kill();
            id && delete $daf8bee9365fb629$var$_ids[id];
            var i = $daf8bee9365fb629$var$_triggers.indexOf(self);
            i >= 0 && $daf8bee9365fb629$var$_triggers.splice(i, 1);
            i === $daf8bee9365fb629$var$_i && $daf8bee9365fb629$var$_direction > 0 && $daf8bee9365fb629$var$_i--; // if we're in the middle of a refresh() or update(), splicing would cause skips in the index, so adjust...
            // if no other ScrollTrigger instances of the same scroller are found, wipe out any recorded scroll position. Otherwise, in a single page application, for example, it could maintain scroll position when it really shouldn't.
            i = 0;
            $daf8bee9365fb629$var$_triggers.forEach(function(t) {
                return t.scroller === self.scroller && (i = 1);
            });
            i || $daf8bee9365fb629$var$_refreshingAll || (self.scroll.rec = 0);
            if (animation) {
                animation.scrollTrigger = null;
                revert && animation.revert({
                    kill: false
                });
                allowAnimation || animation.kill();
            }
            markerStart && [
                markerStart,
                markerEnd,
                markerStartTrigger,
                markerEndTrigger
            ].forEach(function(m) {
                return m.parentNode && m.parentNode.removeChild(m);
            });
            $daf8bee9365fb629$var$_primary === self && ($daf8bee9365fb629$var$_primary = 0);
            if (pin) {
                pinCache && (pinCache.uncache = 1);
                i = 0;
                $daf8bee9365fb629$var$_triggers.forEach(function(t) {
                    return t.pin === pin && i++;
                });
                i || (pinCache.spacer = 0); // if there aren't any more ScrollTriggers with the same pin, remove the spacer, otherwise it could be contaminated with old/stale values if the user re-creates a ScrollTrigger for the same element.
            }
            vars.onKill && vars.onKill(self);
        };
        $daf8bee9365fb629$var$_triggers.push(self);
        self.enable(false, false);
        customRevertReturn && customRevertReturn(self);
        if (animation && animation.add && !change) {
            // if the animation is a timeline, it may not have been populated yet, so it wouldn't render at the proper place on the first refresh(), thus we should schedule one for the next tick. If "change" is defined, we know it must be re-enabling, thus we can refresh() right away.
            var updateFunc = self.update; // some browsers may fire a scroll event BEFORE a tick elapses and/or the DOMContentLoaded fires. So there's a chance update() will be called BEFORE a refresh() has happened on a Timeline-attached ScrollTrigger which means the start/end won't be calculated yet. We don't want to add conditional logic inside the update() method (like check to see if end is defined and if not, force a refresh()) because that's a function that gets hit a LOT (performance). So we swap out the real update() method for this one that'll re-attach it the first time it gets called and of course forces a refresh().
            self.update = function() {
                self.update = updateFunc;
                start || end || self.refresh();
            };
            $daf8bee9365fb629$var$gsap.delayedCall(0.01, self.update);
            change = 0.01;
            start = end = 0;
        } else self.refresh();
        pin && $daf8bee9365fb629$var$_queueRefreshAll(); // pinning could affect the positions of other things, so make sure we queue a full refresh()
    };
    ScrollTrigger.register = function register(core) {
        if (!$daf8bee9365fb629$var$_coreInitted) {
            $daf8bee9365fb629$var$gsap = core || $daf8bee9365fb629$var$_getGSAP();
            $daf8bee9365fb629$var$_windowExists() && window.document && ScrollTrigger.enable();
            $daf8bee9365fb629$var$_coreInitted = $daf8bee9365fb629$var$_enabled;
        }
        return $daf8bee9365fb629$var$_coreInitted;
    };
    ScrollTrigger.defaults = function defaults(config) {
        if (config) for(var p in config)$daf8bee9365fb629$var$_defaults[p] = config[p];
        return $daf8bee9365fb629$var$_defaults;
    };
    ScrollTrigger.disable = function disable(reset, kill) {
        $daf8bee9365fb629$var$_enabled = 0;
        $daf8bee9365fb629$var$_triggers.forEach(function(trigger) {
            return trigger[kill ? "kill" : "disable"](reset);
        });
        $daf8bee9365fb629$var$_removeListener($daf8bee9365fb629$var$_win, "wheel", $daf8bee9365fb629$var$_onScroll);
        $daf8bee9365fb629$var$_removeListener($daf8bee9365fb629$var$_doc, "scroll", $daf8bee9365fb629$var$_onScroll);
        clearInterval($daf8bee9365fb629$var$_syncInterval);
        $daf8bee9365fb629$var$_removeListener($daf8bee9365fb629$var$_doc, "touchcancel", $daf8bee9365fb629$var$_passThrough);
        $daf8bee9365fb629$var$_removeListener($daf8bee9365fb629$var$_body, "touchstart", $daf8bee9365fb629$var$_passThrough);
        $daf8bee9365fb629$var$_multiListener($daf8bee9365fb629$var$_removeListener, $daf8bee9365fb629$var$_doc, "pointerdown,touchstart,mousedown", $daf8bee9365fb629$var$_pointerDownHandler);
        $daf8bee9365fb629$var$_multiListener($daf8bee9365fb629$var$_removeListener, $daf8bee9365fb629$var$_doc, "pointerup,touchend,mouseup", $daf8bee9365fb629$var$_pointerUpHandler);
        $daf8bee9365fb629$var$_resizeDelay.kill();
        $daf8bee9365fb629$var$_iterateAutoRefresh($daf8bee9365fb629$var$_removeListener);
        for(var i = 0; i < (0, $d7385dda6eeeec57$export$3cd1cee43d19b683).length; i += 3){
            $daf8bee9365fb629$var$_wheelListener($daf8bee9365fb629$var$_removeListener, (0, $d7385dda6eeeec57$export$3cd1cee43d19b683)[i], (0, $d7385dda6eeeec57$export$3cd1cee43d19b683)[i + 1]);
            $daf8bee9365fb629$var$_wheelListener($daf8bee9365fb629$var$_removeListener, (0, $d7385dda6eeeec57$export$3cd1cee43d19b683)[i], (0, $d7385dda6eeeec57$export$3cd1cee43d19b683)[i + 2]);
        }
    };
    ScrollTrigger.enable = function enable() {
        $daf8bee9365fb629$var$_win = window;
        $daf8bee9365fb629$var$_doc = document;
        $daf8bee9365fb629$var$_docEl = $daf8bee9365fb629$var$_doc.documentElement;
        $daf8bee9365fb629$var$_body = $daf8bee9365fb629$var$_doc.body;
        if ($daf8bee9365fb629$var$gsap) {
            $daf8bee9365fb629$var$_toArray = $daf8bee9365fb629$var$gsap.utils.toArray;
            $daf8bee9365fb629$var$_clamp = $daf8bee9365fb629$var$gsap.utils.clamp;
            $daf8bee9365fb629$var$_context = $daf8bee9365fb629$var$gsap.core.context || $daf8bee9365fb629$var$_passThrough;
            $daf8bee9365fb629$var$_suppressOverwrites = $daf8bee9365fb629$var$gsap.core.suppressOverwrites || $daf8bee9365fb629$var$_passThrough;
            $daf8bee9365fb629$var$_scrollRestoration = $daf8bee9365fb629$var$_win.history.scrollRestoration || "auto";
            $daf8bee9365fb629$var$_lastScroll = $daf8bee9365fb629$var$_win.pageYOffset;
            $daf8bee9365fb629$var$gsap.core.globals("ScrollTrigger", ScrollTrigger); // must register the global manually because in Internet Explorer, functions (classes) don't have a "name" property.
            if ($daf8bee9365fb629$var$_body) {
                $daf8bee9365fb629$var$_enabled = 1;
                $daf8bee9365fb629$var$_div100vh = document.createElement("div"); // to solve mobile browser address bar show/hide resizing, we shouldn't rely on window.innerHeight. Instead, use a <div> with its height set to 100vh and measure that since that's what the scrolling is based on anyway and it's not affected by address bar showing/hiding.
                $daf8bee9365fb629$var$_div100vh.style.height = "100vh";
                $daf8bee9365fb629$var$_div100vh.style.position = "absolute";
                $daf8bee9365fb629$var$_refresh100vh();
                $daf8bee9365fb629$var$_rafBugFix();
                (0, $d7385dda6eeeec57$export$c1cbdee04e18ea8b).register($daf8bee9365fb629$var$gsap); // isTouch is 0 if no touch, 1 if ONLY touch, and 2 if it can accommodate touch but also other types like mouse/pointer.
                ScrollTrigger.isTouch = (0, $d7385dda6eeeec57$export$c1cbdee04e18ea8b).isTouch;
                $daf8bee9365fb629$var$_fixIOSBug = (0, $d7385dda6eeeec57$export$c1cbdee04e18ea8b).isTouch && /(iPad|iPhone|iPod|Mac)/g.test(navigator.userAgent); // since 2017, iOS has had a bug that causes event.clientX/Y to be inaccurate when a scroll occurs, thus we must alternate ignoring every other touchmove event to work around it. See https://bugs.webkit.org/show_bug.cgi?id=181954 and https://codepen.io/GreenSock/pen/ExbrPNa/087cef197dc35445a0951e8935c41503
                $daf8bee9365fb629$var$_ignoreMobileResize = (0, $d7385dda6eeeec57$export$c1cbdee04e18ea8b).isTouch === 1;
                $daf8bee9365fb629$var$_addListener($daf8bee9365fb629$var$_win, "wheel", $daf8bee9365fb629$var$_onScroll); // mostly for 3rd party smooth scrolling libraries.
                $daf8bee9365fb629$var$_root = [
                    $daf8bee9365fb629$var$_win,
                    $daf8bee9365fb629$var$_doc,
                    $daf8bee9365fb629$var$_docEl,
                    $daf8bee9365fb629$var$_body
                ];
                if ($daf8bee9365fb629$var$gsap.matchMedia) {
                    ScrollTrigger.matchMedia = function(vars) {
                        var mm = $daf8bee9365fb629$var$gsap.matchMedia(), p;
                        for(p in vars)mm.add(p, vars[p]);
                        return mm;
                    };
                    $daf8bee9365fb629$var$gsap.addEventListener("matchMediaInit", function() {
                        return $daf8bee9365fb629$var$_revertAll();
                    });
                    $daf8bee9365fb629$var$gsap.addEventListener("matchMediaRevert", function() {
                        return $daf8bee9365fb629$var$_revertRecorded();
                    });
                    $daf8bee9365fb629$var$gsap.addEventListener("matchMedia", function() {
                        $daf8bee9365fb629$var$_refreshAll(0, 1);
                        $daf8bee9365fb629$var$_dispatch("matchMedia");
                    });
                    $daf8bee9365fb629$var$gsap.matchMedia("(orientation: portrait)", function() {
                        // when orientation changes, we should take new base measurements for the ignoreMobileResize feature.
                        $daf8bee9365fb629$var$_setBaseDimensions();
                        return $daf8bee9365fb629$var$_setBaseDimensions;
                    });
                } else console.warn("Requires GSAP 3.11.0 or later");
                $daf8bee9365fb629$var$_setBaseDimensions();
                $daf8bee9365fb629$var$_addListener($daf8bee9365fb629$var$_doc, "scroll", $daf8bee9365fb629$var$_onScroll); // some browsers (like Chrome), the window stops dispatching scroll events on the window if you scroll really fast, but it's consistent on the document!
                var bodyStyle = $daf8bee9365fb629$var$_body.style, border = bodyStyle.borderTopStyle, AnimationProto = $daf8bee9365fb629$var$gsap.core.Animation.prototype, bounds, i;
                AnimationProto.revert || Object.defineProperty(AnimationProto, "revert", {
                    value: function value() {
                        return this.time(-0.01, true);
                    }
                }); // only for backwards compatibility (Animation.revert() was added after 3.10.4)
                bodyStyle.borderTopStyle = "solid"; // works around an issue where a margin of a child element could throw off the bounds of the _body, making it seem like there's a margin when there actually isn't. The border ensures that the bounds are accurate.
                bounds = $daf8bee9365fb629$var$_getBounds($daf8bee9365fb629$var$_body);
                (0, $d7385dda6eeeec57$export$8e40fc98ff518e9d).m = Math.round(bounds.top + (0, $d7385dda6eeeec57$export$8e40fc98ff518e9d).sc()) || 0; // accommodate the offset of the <body> caused by margins and/or padding
                (0, $d7385dda6eeeec57$export$b2cabb342cb0ebe1).m = Math.round(bounds.left + (0, $d7385dda6eeeec57$export$b2cabb342cb0ebe1).sc()) || 0;
                border ? bodyStyle.borderTopStyle = border : bodyStyle.removeProperty("border-top-style"); // TODO: (?) maybe move to leveraging the velocity mechanism in Observer and skip intervals.
                $daf8bee9365fb629$var$_syncInterval = setInterval($daf8bee9365fb629$var$_sync, 250);
                $daf8bee9365fb629$var$gsap.delayedCall(0.5, function() {
                    return $daf8bee9365fb629$var$_startup = 0;
                });
                $daf8bee9365fb629$var$_addListener($daf8bee9365fb629$var$_doc, "touchcancel", $daf8bee9365fb629$var$_passThrough); // some older Android devices intermittently stop dispatching "touchmove" events if we don't listen for "touchcancel" on the document.
                $daf8bee9365fb629$var$_addListener($daf8bee9365fb629$var$_body, "touchstart", $daf8bee9365fb629$var$_passThrough); //works around Safari bug: https://gsap.com/forums/topic/21450-draggable-in-iframe-on-mobile-is-buggy/
                $daf8bee9365fb629$var$_multiListener($daf8bee9365fb629$var$_addListener, $daf8bee9365fb629$var$_doc, "pointerdown,touchstart,mousedown", $daf8bee9365fb629$var$_pointerDownHandler);
                $daf8bee9365fb629$var$_multiListener($daf8bee9365fb629$var$_addListener, $daf8bee9365fb629$var$_doc, "pointerup,touchend,mouseup", $daf8bee9365fb629$var$_pointerUpHandler);
                $daf8bee9365fb629$var$_transformProp = $daf8bee9365fb629$var$gsap.utils.checkPrefix("transform");
                $daf8bee9365fb629$var$_stateProps.push($daf8bee9365fb629$var$_transformProp);
                $daf8bee9365fb629$var$_coreInitted = $daf8bee9365fb629$var$_getTime();
                $daf8bee9365fb629$var$_resizeDelay = $daf8bee9365fb629$var$gsap.delayedCall(0.2, $daf8bee9365fb629$var$_refreshAll).pause();
                $daf8bee9365fb629$var$_autoRefresh = [
                    $daf8bee9365fb629$var$_doc,
                    "visibilitychange",
                    function() {
                        var w = $daf8bee9365fb629$var$_win.innerWidth, h = $daf8bee9365fb629$var$_win.innerHeight;
                        if ($daf8bee9365fb629$var$_doc.hidden) {
                            $daf8bee9365fb629$var$_prevWidth = w;
                            $daf8bee9365fb629$var$_prevHeight = h;
                        } else if ($daf8bee9365fb629$var$_prevWidth !== w || $daf8bee9365fb629$var$_prevHeight !== h) $daf8bee9365fb629$var$_onResize();
                    },
                    $daf8bee9365fb629$var$_doc,
                    "DOMContentLoaded",
                    $daf8bee9365fb629$var$_refreshAll,
                    $daf8bee9365fb629$var$_win,
                    "load",
                    $daf8bee9365fb629$var$_refreshAll,
                    $daf8bee9365fb629$var$_win,
                    "resize",
                    $daf8bee9365fb629$var$_onResize
                ];
                $daf8bee9365fb629$var$_iterateAutoRefresh($daf8bee9365fb629$var$_addListener);
                $daf8bee9365fb629$var$_triggers.forEach(function(trigger) {
                    return trigger.enable(0, 1);
                });
                for(i = 0; i < (0, $d7385dda6eeeec57$export$3cd1cee43d19b683).length; i += 3){
                    $daf8bee9365fb629$var$_wheelListener($daf8bee9365fb629$var$_removeListener, (0, $d7385dda6eeeec57$export$3cd1cee43d19b683)[i], (0, $d7385dda6eeeec57$export$3cd1cee43d19b683)[i + 1]);
                    $daf8bee9365fb629$var$_wheelListener($daf8bee9365fb629$var$_removeListener, (0, $d7385dda6eeeec57$export$3cd1cee43d19b683)[i], (0, $d7385dda6eeeec57$export$3cd1cee43d19b683)[i + 2]);
                }
            }
        }
    };
    ScrollTrigger.config = function config(vars) {
        "limitCallbacks" in vars && ($daf8bee9365fb629$var$_limitCallbacks = !!vars.limitCallbacks);
        var ms = vars.syncInterval;
        ms && clearInterval($daf8bee9365fb629$var$_syncInterval) || ($daf8bee9365fb629$var$_syncInterval = ms) && setInterval($daf8bee9365fb629$var$_sync, ms);
        "ignoreMobileResize" in vars && ($daf8bee9365fb629$var$_ignoreMobileResize = ScrollTrigger.isTouch === 1 && vars.ignoreMobileResize);
        if ("autoRefreshEvents" in vars) {
            $daf8bee9365fb629$var$_iterateAutoRefresh($daf8bee9365fb629$var$_removeListener) || $daf8bee9365fb629$var$_iterateAutoRefresh($daf8bee9365fb629$var$_addListener, vars.autoRefreshEvents || "none");
            $daf8bee9365fb629$var$_ignoreResize = (vars.autoRefreshEvents + "").indexOf("resize") === -1;
        }
    };
    ScrollTrigger.scrollerProxy = function scrollerProxy(target, vars) {
        var t = (0, $d7385dda6eeeec57$export$937374fea3f88711)(target), i = (0, $d7385dda6eeeec57$export$3cd1cee43d19b683).indexOf(t), isViewport = $daf8bee9365fb629$var$_isViewport(t);
        if (~i) (0, $d7385dda6eeeec57$export$3cd1cee43d19b683).splice(i, isViewport ? 6 : 2);
        if (vars) isViewport ? (0, $d7385dda6eeeec57$export$d8e56d510a804d0a).unshift($daf8bee9365fb629$var$_win, vars, $daf8bee9365fb629$var$_body, vars, $daf8bee9365fb629$var$_docEl, vars) : (0, $d7385dda6eeeec57$export$d8e56d510a804d0a).unshift(t, vars);
    };
    ScrollTrigger.clearMatchMedia = function clearMatchMedia(query) {
        $daf8bee9365fb629$var$_triggers.forEach(function(t) {
            return t._ctx && t._ctx.query === query && t._ctx.kill(true, true);
        });
    };
    ScrollTrigger.isInViewport = function isInViewport(element, ratio, horizontal) {
        var bounds = ($daf8bee9365fb629$var$_isString(element) ? (0, $d7385dda6eeeec57$export$937374fea3f88711)(element) : element).getBoundingClientRect(), offset = bounds[horizontal ? $daf8bee9365fb629$var$_width : $daf8bee9365fb629$var$_height] * ratio || 0;
        return horizontal ? bounds.right - offset > 0 && bounds.left + offset < $daf8bee9365fb629$var$_win.innerWidth : bounds.bottom - offset > 0 && bounds.top + offset < $daf8bee9365fb629$var$_win.innerHeight;
    };
    ScrollTrigger.positionInViewport = function positionInViewport(element, referencePoint, horizontal) {
        $daf8bee9365fb629$var$_isString(element) && (element = (0, $d7385dda6eeeec57$export$937374fea3f88711)(element));
        var bounds = element.getBoundingClientRect(), size = bounds[horizontal ? $daf8bee9365fb629$var$_width : $daf8bee9365fb629$var$_height], offset = referencePoint == null ? size / 2 : referencePoint in $daf8bee9365fb629$var$_keywords ? $daf8bee9365fb629$var$_keywords[referencePoint] * size : ~referencePoint.indexOf("%") ? parseFloat(referencePoint) * size / 100 : parseFloat(referencePoint) || 0;
        return horizontal ? (bounds.left + offset) / $daf8bee9365fb629$var$_win.innerWidth : (bounds.top + offset) / $daf8bee9365fb629$var$_win.innerHeight;
    };
    ScrollTrigger.killAll = function killAll(allowListeners) {
        $daf8bee9365fb629$var$_triggers.slice(0).forEach(function(t) {
            return t.vars.id !== "ScrollSmoother" && t.kill();
        });
        if (allowListeners !== true) {
            var listeners = $daf8bee9365fb629$var$_listeners.killAll || [];
            $daf8bee9365fb629$var$_listeners = {};
            listeners.forEach(function(f) {
                return f();
            });
        }
    };
    return ScrollTrigger;
}();
$daf8bee9365fb629$export$875bcbe48555930.version = "3.12.5";
$daf8bee9365fb629$export$875bcbe48555930.saveStyles = function(targets) {
    return targets ? $daf8bee9365fb629$var$_toArray(targets).forEach(function(target) {
        // saved styles are recorded in a consecutive alternating Array, like [element, cssText, transform attribute, cache, matchMedia, ...]
        if (target && target.style) {
            var i = $daf8bee9365fb629$var$_savedStyles.indexOf(target);
            i >= 0 && $daf8bee9365fb629$var$_savedStyles.splice(i, 5);
            $daf8bee9365fb629$var$_savedStyles.push(target, target.style.cssText, target.getBBox && target.getAttribute("transform"), $daf8bee9365fb629$var$gsap.core.getCache(target), $daf8bee9365fb629$var$_context());
        }
    }) : $daf8bee9365fb629$var$_savedStyles;
};
$daf8bee9365fb629$export$875bcbe48555930.revert = function(soft, media) {
    return $daf8bee9365fb629$var$_revertAll(!soft, media);
};
$daf8bee9365fb629$export$875bcbe48555930.create = function(vars, animation) {
    return new $daf8bee9365fb629$export$875bcbe48555930(vars, animation);
};
$daf8bee9365fb629$export$875bcbe48555930.refresh = function(safe) {
    return safe ? $daf8bee9365fb629$var$_onResize() : ($daf8bee9365fb629$var$_coreInitted || $daf8bee9365fb629$export$875bcbe48555930.register()) && $daf8bee9365fb629$var$_refreshAll(true);
};
$daf8bee9365fb629$export$875bcbe48555930.update = function(force) {
    return ++(0, $d7385dda6eeeec57$export$3cd1cee43d19b683).cache && $daf8bee9365fb629$var$_updateAll(force === true ? 2 : 0);
};
$daf8bee9365fb629$export$875bcbe48555930.clearScrollMemory = $daf8bee9365fb629$var$_clearScrollMemory;
$daf8bee9365fb629$export$875bcbe48555930.maxScroll = function(element, horizontal) {
    return $daf8bee9365fb629$var$_maxScroll(element, horizontal ? (0, $d7385dda6eeeec57$export$b2cabb342cb0ebe1) : (0, $d7385dda6eeeec57$export$8e40fc98ff518e9d));
};
$daf8bee9365fb629$export$875bcbe48555930.getScrollFunc = function(element, horizontal) {
    return (0, $d7385dda6eeeec57$export$8665aac53dad5647)((0, $d7385dda6eeeec57$export$937374fea3f88711)(element), horizontal ? (0, $d7385dda6eeeec57$export$b2cabb342cb0ebe1) : (0, $d7385dda6eeeec57$export$8e40fc98ff518e9d));
};
$daf8bee9365fb629$export$875bcbe48555930.getById = function(id) {
    return $daf8bee9365fb629$var$_ids[id];
};
$daf8bee9365fb629$export$875bcbe48555930.getAll = function() {
    return $daf8bee9365fb629$var$_triggers.filter(function(t) {
        return t.vars.id !== "ScrollSmoother";
    });
}; // it's common for people to ScrollTrigger.getAll(t => t.kill()) on page routes, for example, and we don't want it to ruin smooth scrolling by killing the main ScrollSmoother one.
$daf8bee9365fb629$export$875bcbe48555930.isScrolling = function() {
    return !!$daf8bee9365fb629$var$_lastScrollTime;
};
$daf8bee9365fb629$export$875bcbe48555930.snapDirectional = $daf8bee9365fb629$var$_snapDirectional;
$daf8bee9365fb629$export$875bcbe48555930.addEventListener = function(type, callback) {
    var a = $daf8bee9365fb629$var$_listeners[type] || ($daf8bee9365fb629$var$_listeners[type] = []);
    ~a.indexOf(callback) || a.push(callback);
};
$daf8bee9365fb629$export$875bcbe48555930.removeEventListener = function(type, callback) {
    var a = $daf8bee9365fb629$var$_listeners[type], i = a && a.indexOf(callback);
    i >= 0 && a.splice(i, 1);
};
$daf8bee9365fb629$export$875bcbe48555930.batch = function(targets, vars) {
    var result = [], varsCopy = {}, interval = vars.interval || 0.016, batchMax = vars.batchMax || 1e9, proxyCallback = function proxyCallback(type, callback) {
        var elements = [], triggers = [], delay = $daf8bee9365fb629$var$gsap.delayedCall(interval, function() {
            callback(elements, triggers);
            elements = [];
            triggers = [];
        }).pause();
        return function(self) {
            elements.length || delay.restart(true);
            elements.push(self.trigger);
            triggers.push(self);
            batchMax <= elements.length && delay.progress(1);
        };
    }, p;
    for(p in vars)varsCopy[p] = p.substr(0, 2) === "on" && $daf8bee9365fb629$var$_isFunction(vars[p]) && p !== "onRefreshInit" ? proxyCallback(p, vars[p]) : vars[p];
    if ($daf8bee9365fb629$var$_isFunction(batchMax)) {
        batchMax = batchMax();
        $daf8bee9365fb629$var$_addListener($daf8bee9365fb629$export$875bcbe48555930, "refresh", function() {
            return batchMax = vars.batchMax();
        });
    }
    $daf8bee9365fb629$var$_toArray(targets).forEach(function(target) {
        var config = {};
        for(p in varsCopy)config[p] = varsCopy[p];
        config.trigger = target;
        result.push($daf8bee9365fb629$export$875bcbe48555930.create(config));
    });
    return result;
}; // to reduce file size. clamps the scroll and also returns a duration multiplier so that if the scroll gets chopped shorter, the duration gets curtailed as well (otherwise if you're very close to the top of the page, for example, and swipe up really fast, it'll suddenly slow down and take a long time to reach the top).
var $daf8bee9365fb629$var$_clampScrollAndGetDurationMultiplier = function _clampScrollAndGetDurationMultiplier(scrollFunc, current, end, max) {
    current > max ? scrollFunc(max) : current < 0 && scrollFunc(0);
    return end > max ? (max - current) / (end - current) : end < 0 ? current / (current - end) : 1;
}, $daf8bee9365fb629$var$_allowNativePanning = function _allowNativePanning(target, direction) {
    if (direction === true) target.style.removeProperty("touch-action");
    else target.style.touchAction = direction === true ? "auto" : direction ? "pan-" + direction + ((0, $d7385dda6eeeec57$export$c1cbdee04e18ea8b).isTouch ? " pinch-zoom" : "") : "none"; // note: Firefox doesn't support it pinch-zoom properly, at least in addition to a pan-x or pan-y.
    target === $daf8bee9365fb629$var$_docEl && _allowNativePanning($daf8bee9365fb629$var$_body, direction);
}, $daf8bee9365fb629$var$_overflow = {
    auto: 1,
    scroll: 1
}, $daf8bee9365fb629$var$_nestedScroll = function _nestedScroll(_ref5) {
    var event = _ref5.event, target = _ref5.target, axis = _ref5.axis;
    var node = (event.changedTouches ? event.changedTouches[0] : event).target, cache = node._gsap || $daf8bee9365fb629$var$gsap.core.getCache(node), time = $daf8bee9365fb629$var$_getTime(), cs;
    if (!cache._isScrollT || time - cache._isScrollT > 2000) {
        // cache for 2 seconds to improve performance.
        while(node && node !== $daf8bee9365fb629$var$_body && (node.scrollHeight <= node.clientHeight && node.scrollWidth <= node.clientWidth || !($daf8bee9365fb629$var$_overflow[(cs = $daf8bee9365fb629$var$_getComputedStyle(node)).overflowY] || $daf8bee9365fb629$var$_overflow[cs.overflowX])))node = node.parentNode;
        cache._isScroll = node && node !== target && !$daf8bee9365fb629$var$_isViewport(node) && ($daf8bee9365fb629$var$_overflow[(cs = $daf8bee9365fb629$var$_getComputedStyle(node)).overflowY] || $daf8bee9365fb629$var$_overflow[cs.overflowX]);
        cache._isScrollT = time;
    }
    if (cache._isScroll || axis === "x") {
        event.stopPropagation();
        event._gsapAllow = true;
    }
}, // capture events on scrollable elements INSIDE the <body> and allow those by calling stopPropagation() when we find a scrollable ancestor
$daf8bee9365fb629$var$_inputObserver = function _inputObserver(target, type, inputs, nested) {
    return (0, $d7385dda6eeeec57$export$c1cbdee04e18ea8b).create({
        target: target,
        capture: true,
        debounce: false,
        lockAxis: true,
        type: type,
        onWheel: nested = nested && $daf8bee9365fb629$var$_nestedScroll,
        onPress: nested,
        onDrag: nested,
        onScroll: nested,
        onEnable: function onEnable() {
            return inputs && $daf8bee9365fb629$var$_addListener($daf8bee9365fb629$var$_doc, (0, $d7385dda6eeeec57$export$c1cbdee04e18ea8b).eventTypes[0], $daf8bee9365fb629$var$_captureInputs, false, true);
        },
        onDisable: function onDisable() {
            return $daf8bee9365fb629$var$_removeListener($daf8bee9365fb629$var$_doc, (0, $d7385dda6eeeec57$export$c1cbdee04e18ea8b).eventTypes[0], $daf8bee9365fb629$var$_captureInputs, true);
        }
    });
}, $daf8bee9365fb629$var$_inputExp = /(input|label|select|textarea)/i, $daf8bee9365fb629$var$_inputIsFocused, $daf8bee9365fb629$var$_captureInputs = function _captureInputs(e) {
    var isInput = $daf8bee9365fb629$var$_inputExp.test(e.target.tagName);
    if (isInput || $daf8bee9365fb629$var$_inputIsFocused) {
        e._gsapAllow = true;
        $daf8bee9365fb629$var$_inputIsFocused = isInput;
    }
}, $daf8bee9365fb629$var$_getScrollNormalizer = function _getScrollNormalizer(vars) {
    $daf8bee9365fb629$var$_isObject(vars) || (vars = {});
    vars.preventDefault = vars.isNormalizer = vars.allowClicks = true;
    vars.type || (vars.type = "wheel,touch");
    vars.debounce = !!vars.debounce;
    vars.id = vars.id || "normalizer";
    var _vars2 = vars, normalizeScrollX = _vars2.normalizeScrollX, momentum = _vars2.momentum, allowNestedScroll = _vars2.allowNestedScroll, onRelease = _vars2.onRelease, self, maxY, target = (0, $d7385dda6eeeec57$export$937374fea3f88711)(vars.target) || $daf8bee9365fb629$var$_docEl, smoother = $daf8bee9365fb629$var$gsap.core.globals().ScrollSmoother, smootherInstance = smoother && smoother.get(), content = $daf8bee9365fb629$var$_fixIOSBug && (vars.content && (0, $d7385dda6eeeec57$export$937374fea3f88711)(vars.content) || smootherInstance && vars.content !== false && !smootherInstance.smooth() && smootherInstance.content()), scrollFuncY = (0, $d7385dda6eeeec57$export$8665aac53dad5647)(target, (0, $d7385dda6eeeec57$export$8e40fc98ff518e9d)), scrollFuncX = (0, $d7385dda6eeeec57$export$8665aac53dad5647)(target, (0, $d7385dda6eeeec57$export$b2cabb342cb0ebe1)), scale = 1, initialScale = ((0, $d7385dda6eeeec57$export$c1cbdee04e18ea8b).isTouch && $daf8bee9365fb629$var$_win.visualViewport ? $daf8bee9365fb629$var$_win.visualViewport.scale * $daf8bee9365fb629$var$_win.visualViewport.width : $daf8bee9365fb629$var$_win.outerWidth) / $daf8bee9365fb629$var$_win.innerWidth, wheelRefresh = 0, resolveMomentumDuration = $daf8bee9365fb629$var$_isFunction(momentum) ? function() {
        return momentum(self);
    } : function() {
        return momentum || 2.8;
    }, lastRefreshID, skipTouchMove, inputObserver = $daf8bee9365fb629$var$_inputObserver(target, vars.type, true, allowNestedScroll), resumeTouchMove = function resumeTouchMove() {
        return skipTouchMove = false;
    }, scrollClampX = $daf8bee9365fb629$var$_passThrough, scrollClampY = $daf8bee9365fb629$var$_passThrough, updateClamps = function updateClamps() {
        maxY = $daf8bee9365fb629$var$_maxScroll(target, (0, $d7385dda6eeeec57$export$8e40fc98ff518e9d));
        scrollClampY = $daf8bee9365fb629$var$_clamp($daf8bee9365fb629$var$_fixIOSBug ? 1 : 0, maxY);
        normalizeScrollX && (scrollClampX = $daf8bee9365fb629$var$_clamp(0, $daf8bee9365fb629$var$_maxScroll(target, (0, $d7385dda6eeeec57$export$b2cabb342cb0ebe1))));
        lastRefreshID = $daf8bee9365fb629$var$_refreshID;
    }, removeContentOffset = function removeContentOffset() {
        content._gsap.y = $daf8bee9365fb629$var$_round(parseFloat(content._gsap.y) + scrollFuncY.offset) + "px";
        content.style.transform = "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, " + parseFloat(content._gsap.y) + ", 0, 1)";
        scrollFuncY.offset = scrollFuncY.cacheID = 0;
    }, ignoreDrag = function ignoreDrag() {
        if (skipTouchMove) {
            requestAnimationFrame(resumeTouchMove);
            var offset = $daf8bee9365fb629$var$_round(self.deltaY / 2), scroll = scrollClampY(scrollFuncY.v - offset);
            if (content && scroll !== scrollFuncY.v + scrollFuncY.offset) {
                scrollFuncY.offset = scroll - scrollFuncY.v;
                var y = $daf8bee9365fb629$var$_round((parseFloat(content && content._gsap.y) || 0) - scrollFuncY.offset);
                content.style.transform = "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, " + y + ", 0, 1)";
                content._gsap.y = y + "px";
                scrollFuncY.cacheID = (0, $d7385dda6eeeec57$export$3cd1cee43d19b683).cache;
                $daf8bee9365fb629$var$_updateAll();
            }
            return true;
        }
        scrollFuncY.offset && removeContentOffset();
        skipTouchMove = true;
    }, tween, startScrollX, startScrollY, onStopDelayedCall, onResize = function onResize() {
        // if the window resizes, like on an iPhone which Apple FORCES the address bar to show/hide even if we event.preventDefault(), it may be scrolling too far now that the address bar is showing, so we must dynamically adjust the momentum tween.
        updateClamps();
        if (tween.isActive() && tween.vars.scrollY > maxY) scrollFuncY() > maxY ? tween.progress(1) && scrollFuncY(maxY) : tween.resetTo("scrollY", maxY);
    };
    content && $daf8bee9365fb629$var$gsap.set(content, {
        y: "+=0"
    }); // to ensure there's a cache (element._gsap)
    vars.ignoreCheck = function(e) {
        return $daf8bee9365fb629$var$_fixIOSBug && e.type === "touchmove" && ignoreDrag(e) || scale > 1.05 && e.type !== "touchstart" || self.isGesturing || e.touches && e.touches.length > 1;
    };
    vars.onPress = function() {
        skipTouchMove = false;
        var prevScale = scale;
        scale = $daf8bee9365fb629$var$_round(($daf8bee9365fb629$var$_win.visualViewport && $daf8bee9365fb629$var$_win.visualViewport.scale || 1) / initialScale);
        tween.pause();
        prevScale !== scale && $daf8bee9365fb629$var$_allowNativePanning(target, scale > 1.01 ? true : normalizeScrollX ? false : "x");
        startScrollX = scrollFuncX();
        startScrollY = scrollFuncY();
        updateClamps();
        lastRefreshID = $daf8bee9365fb629$var$_refreshID;
    };
    vars.onRelease = vars.onGestureStart = function(self, wasDragging) {
        scrollFuncY.offset && removeContentOffset();
        if (!wasDragging) onStopDelayedCall.restart(true);
        else {
            (0, $d7385dda6eeeec57$export$3cd1cee43d19b683).cache++; // make sure we're pulling the non-cached value
            // alternate algorithm: durX = Math.min(6, Math.abs(self.velocityX / 800)),	dur = Math.max(durX, Math.min(6, Math.abs(self.velocityY / 800))); dur = dur * (0.4 + (1 - _power4In(dur / 6)) * 0.6)) * (momentumSpeed || 1)
            var dur = resolveMomentumDuration(), currentScroll, endScroll;
            if (normalizeScrollX) {
                currentScroll = scrollFuncX();
                endScroll = currentScroll + dur * 0.05 * -self.velocityX / 0.227; // the constant .227 is from power4(0.05). velocity is inverted because scrolling goes in the opposite direction.
                dur *= $daf8bee9365fb629$var$_clampScrollAndGetDurationMultiplier(scrollFuncX, currentScroll, endScroll, $daf8bee9365fb629$var$_maxScroll(target, (0, $d7385dda6eeeec57$export$b2cabb342cb0ebe1)));
                tween.vars.scrollX = scrollClampX(endScroll);
            }
            currentScroll = scrollFuncY();
            endScroll = currentScroll + dur * 0.05 * -self.velocityY / 0.227; // the constant .227 is from power4(0.05)
            dur *= $daf8bee9365fb629$var$_clampScrollAndGetDurationMultiplier(scrollFuncY, currentScroll, endScroll, $daf8bee9365fb629$var$_maxScroll(target, (0, $d7385dda6eeeec57$export$8e40fc98ff518e9d)));
            tween.vars.scrollY = scrollClampY(endScroll);
            tween.invalidate().duration(dur).play(0.01);
            if ($daf8bee9365fb629$var$_fixIOSBug && tween.vars.scrollY >= maxY || currentScroll >= maxY - 1) // iOS bug: it'll show the address bar but NOT fire the window "resize" event until the animation is done but we must protect against overshoot so we leverage an onUpdate to do so.
            $daf8bee9365fb629$var$gsap.to({}, {
                onUpdate: onResize,
                duration: dur
            });
        }
        onRelease && onRelease(self);
    };
    vars.onWheel = function() {
        tween._ts && tween.pause();
        if ($daf8bee9365fb629$var$_getTime() - wheelRefresh > 1000) {
            // after 1 second, refresh the clamps otherwise that'll only happen when ScrollTrigger.refresh() is called or for touch-scrolling.
            lastRefreshID = 0;
            wheelRefresh = $daf8bee9365fb629$var$_getTime();
        }
    };
    vars.onChange = function(self, dx, dy, xArray, yArray) {
        $daf8bee9365fb629$var$_refreshID !== lastRefreshID && updateClamps();
        dx && normalizeScrollX && scrollFuncX(scrollClampX(xArray[2] === dx ? startScrollX + (self.startX - self.x) : scrollFuncX() + dx - xArray[1])); // for more precision, we track pointer/touch movement from the start, otherwise it'll drift.
        if (dy) {
            scrollFuncY.offset && removeContentOffset();
            var isTouch = yArray[2] === dy, y = isTouch ? startScrollY + self.startY - self.y : scrollFuncY() + dy - yArray[1], yClamped = scrollClampY(y);
            isTouch && y !== yClamped && (startScrollY += yClamped - y);
            scrollFuncY(yClamped);
        }
        (dy || dx) && $daf8bee9365fb629$var$_updateAll();
    };
    vars.onEnable = function() {
        $daf8bee9365fb629$var$_allowNativePanning(target, normalizeScrollX ? false : "x");
        $daf8bee9365fb629$export$875bcbe48555930.addEventListener("refresh", onResize);
        $daf8bee9365fb629$var$_addListener($daf8bee9365fb629$var$_win, "resize", onResize);
        if (scrollFuncY.smooth) {
            scrollFuncY.target.style.scrollBehavior = "auto";
            scrollFuncY.smooth = scrollFuncX.smooth = false;
        }
        inputObserver.enable();
    };
    vars.onDisable = function() {
        $daf8bee9365fb629$var$_allowNativePanning(target, true);
        $daf8bee9365fb629$var$_removeListener($daf8bee9365fb629$var$_win, "resize", onResize);
        $daf8bee9365fb629$export$875bcbe48555930.removeEventListener("refresh", onResize);
        inputObserver.kill();
    };
    vars.lockAxis = vars.lockAxis !== false;
    self = new (0, $d7385dda6eeeec57$export$c1cbdee04e18ea8b)(vars);
    self.iOS = $daf8bee9365fb629$var$_fixIOSBug; // used in the Observer getCachedScroll() function to work around an iOS bug that wreaks havoc with TouchEvent.clientY if we allow scroll to go all the way back to 0.
    $daf8bee9365fb629$var$_fixIOSBug && !scrollFuncY() && scrollFuncY(1); // iOS bug causes event.clientY values to freak out (wildly inaccurate) if the scroll position is exactly 0.
    $daf8bee9365fb629$var$_fixIOSBug && $daf8bee9365fb629$var$gsap.ticker.add($daf8bee9365fb629$var$_passThrough); // prevent the ticker from sleeping
    onStopDelayedCall = self._dc;
    tween = $daf8bee9365fb629$var$gsap.to(self, {
        ease: "power4",
        paused: true,
        inherit: false,
        scrollX: normalizeScrollX ? "+=0.1" : "+=0",
        scrollY: "+=0.1",
        modifiers: {
            scrollY: $daf8bee9365fb629$var$_interruptionTracker(scrollFuncY, scrollFuncY(), function() {
                return tween.pause();
            })
        },
        onUpdate: $daf8bee9365fb629$var$_updateAll,
        onComplete: onStopDelayedCall.vars.onComplete
    }); // we need the modifier to sense if the scroll position is altered outside of the momentum tween (like with a scrollTo tween) so we can pause() it to prevent conflicts.
    return self;
};
$daf8bee9365fb629$export$875bcbe48555930.sort = function(func) {
    return $daf8bee9365fb629$var$_triggers.sort(func || function(a, b) {
        return (a.vars.refreshPriority || 0) * -1000000 + a.start - (b.start + (b.vars.refreshPriority || 0) * -1000000);
    });
};
$daf8bee9365fb629$export$875bcbe48555930.observe = function(vars) {
    return new (0, $d7385dda6eeeec57$export$c1cbdee04e18ea8b)(vars);
};
$daf8bee9365fb629$export$875bcbe48555930.normalizeScroll = function(vars) {
    if (typeof vars === "undefined") return $daf8bee9365fb629$var$_normalizer;
    if (vars === true && $daf8bee9365fb629$var$_normalizer) return $daf8bee9365fb629$var$_normalizer.enable();
    if (vars === false) {
        $daf8bee9365fb629$var$_normalizer && $daf8bee9365fb629$var$_normalizer.kill();
        $daf8bee9365fb629$var$_normalizer = vars;
        return;
    }
    var normalizer = vars instanceof (0, $d7385dda6eeeec57$export$c1cbdee04e18ea8b) ? vars : $daf8bee9365fb629$var$_getScrollNormalizer(vars);
    $daf8bee9365fb629$var$_normalizer && $daf8bee9365fb629$var$_normalizer.target === normalizer.target && $daf8bee9365fb629$var$_normalizer.kill();
    $daf8bee9365fb629$var$_isViewport(normalizer.target) && ($daf8bee9365fb629$var$_normalizer = normalizer);
    return normalizer;
};
$daf8bee9365fb629$export$875bcbe48555930.core = {
    // smaller file size way to leverage in ScrollSmoother and Observer
    _getVelocityProp: (0, $d7385dda6eeeec57$export$5de019f4480f0f8d),
    _inputObserver: $daf8bee9365fb629$var$_inputObserver,
    _scrollers: (0, $d7385dda6eeeec57$export$3cd1cee43d19b683),
    _proxies: (0, $d7385dda6eeeec57$export$d8e56d510a804d0a),
    bridge: {
        // when normalizeScroll sets the scroll position (ss = setScroll)
        ss: function ss() {
            $daf8bee9365fb629$var$_lastScrollTime || $daf8bee9365fb629$var$_dispatch("scrollStart");
            $daf8bee9365fb629$var$_lastScrollTime = $daf8bee9365fb629$var$_getTime();
        },
        // a way to get the _refreshing value in Observer
        ref: function ref() {
            return $daf8bee9365fb629$var$_refreshing;
        }
    }
};
$daf8bee9365fb629$var$_getGSAP() && $daf8bee9365fb629$var$gsap.registerPlugin($daf8bee9365fb629$export$875bcbe48555930);



(0, $357b3f2d5f2ec9d5$export$99ee26438460406a).registerPlugin((0, $daf8bee9365fb629$export$875bcbe48555930), (0, $d7385dda6eeeec57$export$c1cbdee04e18ea8b));
// --- VARIABILI GLOBALI (Stato) ---
let $e73bf42412feb220$var$map = null;
let $e73bf42412feb220$var$loaderInstance = new (0, $ad50f79c8d07e42d$export$3b0d6d7590275603)();
let $e73bf42412feb220$var$isFirstLoad = true;
// Stato Memoria Mappa
let $e73bf42412feb220$var$savedMapState = null;
// Stato Modale e Navigazione
let $e73bf42412feb220$var$lastModalArgs = null;
let $e73bf42412feb220$var$isModalOpen = false;
let $e73bf42412feb220$var$restoreModal = false; // NUOVO: Flag per sapere se riaprire la modale al ritorno
let $e73bf42412feb220$var$autoOpenGallery = false; // Flag per aprire la gallery automaticamente sulla pagina prodotto
const $e73bf42412feb220$var$originalOpenModal = (0, $2d4978547e811d38$export$2e2bcd8739ae039);
const $e73bf42412feb220$var$originalCloseModal = (0, $9dac4c1a5bd2d9fc$export$2e2bcd8739ae039);
// --- FUNZIONI DI SUPPORTO UI ---
const $e73bf42412feb220$var$openModalTracked = (elName, options)=>{
    $e73bf42412feb220$var$lastModalArgs = {
        elName: elName,
        options: options
    };
    $e73bf42412feb220$var$isModalOpen = true;
    const arrowBtn = document.querySelector(".arrow__btn");
    if (arrowBtn) arrowBtn.classList.add("is-open");
    $e73bf42412feb220$var$originalOpenModal(elName, options);
};
const $e73bf42412feb220$var$closeModalTracked = ()=>{
    $e73bf42412feb220$var$isModalOpen = false;
    const arrowBtn = document.querySelector(".arrow__btn");
    if (arrowBtn) arrowBtn.classList.remove("is-open");
    $e73bf42412feb220$var$originalCloseModal();
};
const $e73bf42412feb220$var$initUIEvents = ()=>{
    const controlsDialog = (0, $a305a376c9462dbd$export$2e6c959c16ff56b8)(".controls__dialog");
    const controlsSpan = (0, $a305a376c9462dbd$export$2e6c959c16ff56b8)("#controls");
    const controlsCloseBtn = (0, $a305a376c9462dbd$export$2e6c959c16ff56b8)(".controls__dialog .close");
    const logo = (0, $a305a376c9462dbd$export$2e6c959c16ff56b8)(".logo");
    const arrowBtn = (0, $a305a376c9462dbd$export$2e6c959c16ff56b8)(".overlay__arrow");
    const onClickControls = ()=>{
        if (!controlsDialog) return;
        controlsDialog.style.display = "flex";
        (0, $357b3f2d5f2ec9d5$export$99ee26438460406a).to(controlsDialog, {
            duration: 0.3,
            opacity: 1
        });
    };
    const onClickCloseControls = ()=>{
        if (!controlsDialog) return;
        (0, $357b3f2d5f2ec9d5$export$99ee26438460406a).to(controlsDialog, {
            duration: 0.3,
            opacity: 0,
            onComplete: ()=>{
                controlsDialog.style.display = "none";
            }
        });
    };
    if (controlsCloseBtn) controlsCloseBtn.onclick = onClickCloseControls;
    if (controlsSpan) controlsSpan.onclick = onClickControls;
    if (arrowBtn) arrowBtn.onclick = ()=>{
        const modalElement = document.querySelector(".overlay__modal");
        const isVisible = modalElement && (modalElement.style.display === "block" || modalElement.style.transform === "translateX(0)");
        if (isVisible && $e73bf42412feb220$var$isModalOpen) $e73bf42412feb220$var$closeModalTracked();
        else if ($e73bf42412feb220$var$lastModalArgs) $e73bf42412feb220$var$openModalTracked($e73bf42412feb220$var$lastModalArgs.elName, $e73bf42412feb220$var$lastModalArgs.options);
    };
    const backBtn = document.querySelector(".back");
    if (backBtn && backBtn.tagName !== "A") backBtn.onclick = (e)=>{
        e.preventDefault();
        (0, (/*@__PURE__*/$parcel$interopDefault($f233fb7ce3af900a$exports))).go("index.html");
    };
    if (logo) logo.onclick = (e)=>{
        if ($e73bf42412feb220$var$map) {
            e.preventDefault();
            $e73bf42412feb220$var$map.animateTo({
                center: [
                    0,
                    0
                ],
                zoom: 3
            }, {
                duration: 800,
                easing: "out"
            });
        }
    };
};
// --- LOGICA MAPPA (HOME) ---
function $e73bf42412feb220$var$destroyMap() {
    if ($e73bf42412feb220$var$map) {
        $e73bf42412feb220$var$savedMapState = {
            center: $e73bf42412feb220$var$map.getCenter(),
            zoom: $e73bf42412feb220$var$map.getZoom(),
            pitch: $e73bf42412feb220$var$map.getPitch(),
            bearing: $e73bf42412feb220$var$map.getBearing()
        };
        $e73bf42412feb220$var$map.remove();
        $e73bf42412feb220$var$map = null;
    }
}
const $e73bf42412feb220$var$initHomeMap = ()=>{
    if ($e73bf42412feb220$var$map) return;
    const mapContainer = document.getElementById("map");
    if (!mapContainer) return;
    // Fade iniziale
    (0, $357b3f2d5f2ec9d5$export$99ee26438460406a).set(mapContainer, {
        opacity: 0
    });
    mapContainer.innerHTML = "";
    const viewConfig = $e73bf42412feb220$var$savedMapState ? $e73bf42412feb220$var$savedMapState : {
        center: [
            0,
            0
        ],
        zoom: 3
    };
    $e73bf42412feb220$var$map = new (0, $gP1US.Map)("map", {
        control: true,
        center: viewConfig.center,
        zoom: viewConfig.zoom,
        pitch: viewConfig.pitch || 0,
        bearing: viewConfig.bearing || 0,
        minZoom: 0,
        maxZoom: 10,
        attribution: false,
        baseLayer: new (0, $gP1US.TileLayer)("base", {
            renderer: "gl",
            opacity: 0
        })
    });
    setTimeout(()=>{
        if ($e73bf42412feb220$var$map) {
            $e73bf42412feb220$var$map.checkSize();
            $e73bf42412feb220$var$map.setView(viewConfig);
            // Fade in mappa
            (0, $357b3f2d5f2ec9d5$export$99ee26438460406a).to(mapContainer, {
                opacity: 1,
                duration: 1.2,
                ease: "power2.out",
                clearProps: "opacity"
            });
        }
    }, 200);
    const regionLayer = new (0, $gP1US.VectorLayer)("regionLayer").addTo($e73bf42412feb220$var$map);
    const cityLayer = new (0, $gP1US.VectorLayer)("cityLayer", {
        visible: false
    }).addTo($e73bf42412feb220$var$map);
    const comuneLayer = new (0, $gP1US.VectorLayer)("comuneLayer", {
        visible: false
    }).addTo($e73bf42412feb220$var$map);
    const regions = [
        {
            id: 1,
            name: "Contacts",
            center: [
                -54,
                28
            ],
            section: "contacts",
            geometry: new (0, $gP1US.Polygon)([
                [
                    [
                        -58,
                        32
                    ],
                    [
                        -54,
                        34
                    ],
                    [
                        -50,
                        32
                    ],
                    [
                        -48,
                        28
                    ],
                    [
                        -49,
                        24
                    ],
                    [
                        -52,
                        20
                    ],
                    [
                        -56,
                        18
                    ],
                    [
                        -58,
                        22
                    ],
                    [
                        -58,
                        28
                    ],
                    [
                        -58,
                        32
                    ]
                ]
            ]),
            cities: [
                {
                    id: "city1a",
                    name: "Porto Sereno",
                    coordinates: [
                        -55.2,
                        31.2
                    ],
                    geometry: new (0, $gP1US.Polygon)([
                        [
                            [
                                -57,
                                31.0
                            ],
                            [
                                -56,
                                30.5
                            ],
                            [
                                -54,
                                30.2
                            ],
                            [
                                -52.5,
                                31.0
                            ],
                            [
                                -52.2,
                                32.5
                            ],
                            [
                                -53,
                                33.0
                            ],
                            [
                                -55,
                                32.8
                            ],
                            [
                                -56.5,
                                32.5
                            ],
                            [
                                -57,
                                31.0
                            ]
                        ]
                    ])
                },
                {
                    id: "city1b",
                    name: "Valle Solare",
                    coordinates: [
                        -50.8,
                        26.8
                    ],
                    geometry: new (0, $gP1US.Polygon)([
                        [
                            [
                                -51.8,
                                25.5
                            ],
                            [
                                -50.5,
                                25.2
                            ],
                            [
                                -50,
                                26.5
                            ],
                            [
                                -49.8,
                                28.0
                            ],
                            [
                                -50.5,
                                28.5
                            ],
                            [
                                -51.2,
                                28.2
                            ],
                            [
                                -52,
                                27.5
                            ],
                            [
                                -51.8,
                                25.5
                            ]
                        ]
                    ])
                },
                {
                    id: "city1c",
                    name: "Monte Nebbioso",
                    coordinates: [
                        -55.4,
                        22.1
                    ],
                    geometry: new (0, $gP1US.Polygon)([
                        [
                            [
                                -58,
                                23.0
                            ],
                            [
                                -57,
                                24.5
                            ],
                            [
                                -55,
                                24.8
                            ],
                            [
                                -53,
                                23.5
                            ],
                            [
                                -52.5,
                                22.0
                            ],
                            [
                                -53.2,
                                21.5
                            ],
                            [
                                -55,
                                21.0
                            ],
                            [
                                -56.5,
                                20.5
                            ],
                            [
                                -57.5,
                                21.5
                            ],
                            [
                                -58,
                                23.0
                            ]
                        ]
                    ])
                },
                {
                    id: "city1d",
                    name: "Fiume Calmo",
                    coordinates: [
                        -52.3,
                        29.5
                    ],
                    geometry: new (0, $gP1US.Polygon)([
                        [
                            [
                                -53,
                                29.5
                            ],
                            [
                                -52.3,
                                30.2
                            ],
                            [
                                -50.5,
                                29.8
                            ],
                            [
                                -50.8,
                                28.5
                            ],
                            [
                                -51.5,
                                27.8
                            ],
                            [
                                -53,
                                29.5
                            ]
                        ]
                    ])
                }
            ]
        },
        {
            id: 2,
            name: "About",
            center: [
                -37.3,
                52.3
            ],
            section: "about",
            geometry: new (0, $gP1US.Polygon)([
                [
                    [
                        -42,
                        54
                    ],
                    [
                        -39,
                        57
                    ],
                    [
                        -35,
                        56
                    ],
                    [
                        -33,
                        53
                    ],
                    [
                        -34,
                        50
                    ],
                    [
                        -37,
                        48
                    ],
                    [
                        -40,
                        49
                    ],
                    [
                        -42,
                        52
                    ],
                    [
                        -42,
                        54
                    ]
                ]
            ]),
            cities: [
                {
                    id: "city2a",
                    name: "concept",
                    coordinates: [
                        -38.2,
                        56.1
                    ],
                    // Teardrop / leaf shape
                    geometry: new (0, $gP1US.Polygon)([
                        [
                            [
                                -38.2,
                                56.6
                            ],
                            [
                                -37.9,
                                56.5
                            ],
                            [
                                -37.6,
                                56.2
                            ],
                            [
                                -37.5,
                                55.9
                            ],
                            [
                                -37.6,
                                55.6
                            ],
                            [
                                -37.9,
                                55.4
                            ],
                            [
                                -38.2,
                                55.3
                            ],
                            [
                                -38.5,
                                55.4
                            ],
                            [
                                -38.8,
                                55.5
                            ],
                            [
                                -39,
                                55.8
                            ],
                            [
                                -38.9,
                                56.1
                            ],
                            [
                                -38.6,
                                56.4
                            ],
                            [
                                -38.2,
                                56.6
                            ]
                        ]
                    ])
                },
                {
                    id: "city2b",
                    name: "filosofy",
                    coordinates: [
                        -36.2,
                        53.6
                    ],
                    // Elongated horizontal crescent
                    geometry: new (0, $gP1US.Polygon)([
                        [
                            [
                                -36.8,
                                53.6
                            ],
                            [
                                -36.5,
                                53.9
                            ],
                            [
                                -36.1,
                                54.0
                            ],
                            [
                                -35.7,
                                53.9
                            ],
                            [
                                -35.4,
                                53.7
                            ],
                            [
                                -35.3,
                                53.4
                            ],
                            [
                                -35.5,
                                53.2
                            ],
                            [
                                -35.8,
                                53.1
                            ],
                            [
                                -36.2,
                                53.0
                            ],
                            [
                                -36.5,
                                53.1
                            ],
                            [
                                -36.8,
                                53.3
                            ],
                            [
                                -36.8,
                                53.6
                            ]
                        ]
                    ])
                },
                {
                    id: "city2c",
                    name: "quality",
                    coordinates: [
                        -37.8,
                        50.6
                    ],
                    // Compact star-like blob
                    geometry: new (0, $gP1US.Polygon)([
                        [
                            [
                                -37.8,
                                51.1
                            ],
                            [
                                -37.5,
                                51.0
                            ],
                            [
                                -37.3,
                                50.7
                            ],
                            [
                                -37.2,
                                50.4
                            ],
                            [
                                -37.4,
                                50.1
                            ],
                            [
                                -37.7,
                                49.9
                            ],
                            [
                                -38,
                                50.0
                            ],
                            [
                                -38.3,
                                50.2
                            ],
                            [
                                -38.4,
                                50.5
                            ],
                            [
                                -38.3,
                                50.8
                            ],
                            [
                                -38.1,
                                51.0
                            ],
                            [
                                -37.8,
                                51.1
                            ]
                        ]
                    ])
                },
                {
                    id: "city2d",
                    name: "paolo",
                    coordinates: [
                        -40.7,
                        51.6
                    ],
                    // Vertical bean shape
                    geometry: new (0, $gP1US.Polygon)([
                        [
                            [
                                -40.7,
                                52.2
                            ],
                            [
                                -40.4,
                                52.1
                            ],
                            [
                                -40.2,
                                51.8
                            ],
                            [
                                -40.1,
                                51.5
                            ],
                            [
                                -40.2,
                                51.2
                            ],
                            [
                                -40.3,
                                50.9
                            ],
                            [
                                -40.6,
                                50.7
                            ],
                            [
                                -40.9,
                                50.8
                            ],
                            [
                                -41.1,
                                51.0
                            ],
                            [
                                -41.2,
                                51.3
                            ],
                            [
                                -41.1,
                                51.7
                            ],
                            [
                                -41,
                                52.0
                            ],
                            [
                                -40.7,
                                52.2
                            ]
                        ]
                    ])
                }
            ]
        },
        {
            id: 3,
            name: "Guitars",
            center: [
                30,
                -40
            ],
            section: "guitars",
            geometry: new (0, $gP1US.Polygon)([
                [
                    [
                        22,
                        -33
                    ],
                    [
                        28,
                        -30
                    ],
                    [
                        35,
                        -32
                    ],
                    [
                        40,
                        -37
                    ],
                    [
                        42,
                        -43
                    ],
                    [
                        39,
                        -48
                    ],
                    [
                        33,
                        -50
                    ],
                    [
                        27,
                        -48
                    ],
                    [
                        23,
                        -43
                    ],
                    [
                        22,
                        -38
                    ],
                    [
                        22,
                        -33
                    ]
                ]
            ]),
            cities: [
                {
                    id: "city3a",
                    name: "boom",
                    coordinates: [
                        26,
                        -38
                    ],
                    geometry: new (0, $gP1US.Polygon)([
                        [
                            [
                                25.0,
                                -36.6
                            ],
                            [
                                25.8,
                                -36.4
                            ],
                            [
                                26.6,
                                -36.5
                            ],
                            [
                                27.4,
                                -36.9
                            ],
                            [
                                27.8,
                                -37.4
                            ],
                            [
                                27.6,
                                -38
                            ],
                            [
                                27.8,
                                -38.6
                            ],
                            [
                                27.2,
                                -39.2
                            ],
                            [
                                26.4,
                                -39.4
                            ],
                            [
                                25.2,
                                -39.2
                            ],
                            [
                                24.6,
                                -38.6
                            ],
                            [
                                24.4,
                                -37.8
                            ],
                            [
                                24.5,
                                -37.2
                            ],
                            [
                                25.0,
                                -36.6
                            ]
                        ]
                    ])
                },
                {
                    id: "city3b",
                    name: "roar",
                    coordinates: [
                        35,
                        -42
                    ],
                    geometry: new (0, $gP1US.Polygon)([
                        [
                            [
                                33.6,
                                -41.4
                            ],
                            [
                                34.0,
                                -40.8
                            ],
                            [
                                34.8,
                                -40.2
                            ],
                            [
                                35.6,
                                -40
                            ],
                            [
                                36.4,
                                -40.2
                            ],
                            [
                                37.2,
                                -40.6
                            ],
                            [
                                37.6,
                                -41.2
                            ],
                            [
                                37.4,
                                -41.8
                            ],
                            [
                                36.8,
                                -42
                            ],
                            [
                                37.0,
                                -42.6
                            ],
                            [
                                36.6,
                                -43.2
                            ],
                            [
                                35.8,
                                -43
                            ],
                            [
                                35.2,
                                -43.4
                            ],
                            [
                                34.6,
                                -43.2
                            ],
                            [
                                34.0,
                                -42.8
                            ],
                            [
                                33.6,
                                -42.6
                            ],
                            [
                                33.2,
                                -42
                            ],
                            [
                                33.6,
                                -41.4
                            ]
                        ]
                    ])
                },
                {
                    id: "city3c",
                    name: "slurp",
                    coordinates: [
                        31,
                        -36
                    ],
                    geometry: new (0, $gP1US.Polygon)([
                        [
                            [
                                30.0,
                                -34.2
                            ],
                            [
                                30.8,
                                -33.6
                            ],
                            [
                                31.6,
                                -33.8
                            ],
                            [
                                32.4,
                                -34
                            ],
                            [
                                33.2,
                                -34.6
                            ],
                            [
                                33.6,
                                -35.4
                            ],
                            [
                                33.4,
                                -36.2
                            ],
                            [
                                33.0,
                                -36.8
                            ],
                            [
                                32.6,
                                -37.4
                            ],
                            [
                                31.8,
                                -37.8
                            ],
                            [
                                31.0,
                                -38
                            ],
                            [
                                30.2,
                                -37.6
                            ],
                            [
                                29.4,
                                -37
                            ],
                            [
                                28.8,
                                -36.4
                            ],
                            [
                                28.6,
                                -35.6
                            ],
                            [
                                29.0,
                                -34.8
                            ],
                            [
                                29.6,
                                -34.4
                            ],
                            [
                                30.0,
                                -34.2
                            ]
                        ]
                    ])
                },
                {
                    id: "city3d",
                    name: "wow",
                    coordinates: [
                        29,
                        -44
                    ],
                    geometry: new (0, $gP1US.Polygon)([
                        [
                            [
                                28.4,
                                -42.4
                            ],
                            [
                                29.2,
                                -42.2
                            ],
                            [
                                30.0,
                                -42.6
                            ],
                            [
                                30.6,
                                -43.2
                            ],
                            [
                                30.8,
                                -43.8
                            ],
                            [
                                30.4,
                                -44.6
                            ],
                            [
                                30.6,
                                -45.2
                            ],
                            [
                                30.0,
                                -45.8
                            ],
                            [
                                29.2,
                                -45.6
                            ],
                            [
                                28.4,
                                -45.8
                            ],
                            [
                                27.6,
                                -45.2
                            ],
                            [
                                27.2,
                                -44.6
                            ],
                            [
                                27.0,
                                -43.8
                            ],
                            [
                                27.4,
                                -43.2
                            ],
                            [
                                27.8,
                                -42.8
                            ],
                            [
                                28.4,
                                -42.4
                            ]
                        ]
                    ])
                }
            ]
        }
    ];
    const comuniData = {
        city1a: [
            {
                name: "Email",
                coordinates: [
                    -55.6,
                    30.1
                ],
                tooltip: "info@tarazum.com",
                href: "mailto:info@tarazum.com"
            },
            {
                name: "Phone",
                coordinates: [
                    -52.8,
                    32.4
                ],
                tooltip: "+39 338 685 5006",
                href: "tel:+393386855006"
            }
        ],
        city1b: [
            {
                name: "Where",
                coordinates: [
                    -51.2,
                    26.4
                ],
                tooltip: "Via Ponchielli, Meda (MB), Italy",
                href: "#",
                target: "_blank"
            }
        ],
        city1c: [
            {
                name: "Facebook",
                coordinates: [
                    -57,
                    24
                ],
                tooltip: "Seguici su Facebook",
                href: "https://www.facebook.com/tarazumguitars",
                target: "_blank"
            },
            {
                name: "Instagram",
                coordinates: [
                    -55.8,
                    21.6
                ],
                tooltip: "Seguici su Instagram",
                href: "https://www.instagram.com/tarazumguitars",
                target: "_blank"
            },
            {
                name: "YouTube",
                coordinates: [
                    -53,
                    22.6
                ],
                tooltip: "Guarda i video su YouTube",
                href: "https://www.youtube.com/@tarazumguitars4421",
                target: "_blank"
            }
        ],
        city3a: [
            {
                name: "diapason",
                coordinates: [
                    26.5,
                    -37.2
                ],
                geometry: new (0, $gP1US.Polygon)([
                    [
                        [
                            26.6,
                            -37
                        ],
                        [
                            26.8,
                            -37.2
                        ],
                        [
                            26.7,
                            -37.5
                        ],
                        [
                            26.4,
                            -37.6
                        ],
                        [
                            26.2,
                            -37.4
                        ],
                        [
                            26.2,
                            -37.1
                        ],
                        [
                            26.5,
                            -37
                        ],
                        [
                            26.6,
                            -37
                        ]
                    ]
                ])
            },
            {
                name: "monoblocco",
                coordinates: [
                    25.5,
                    -38.5
                ],
                geometry: new (0, $gP1US.Polygon)([
                    [
                        [
                            25.2,
                            -38.3
                        ],
                        [
                            25.6,
                            -38.2
                        ],
                        [
                            25.9,
                            -38.4
                        ],
                        [
                            25.9,
                            -38.7
                        ],
                        [
                            25.5,
                            -38.9
                        ],
                        [
                            25.1,
                            -38.7
                        ],
                        [
                            25.1,
                            -38.5
                        ],
                        [
                            25.2,
                            -38.3
                        ]
                    ]
                ])
            }
        ],
        city3b: [
            {
                name: "spring",
                coordinates: [
                    35.8,
                    -41.1
                ],
                geometry: new (0, $gP1US.Polygon)([
                    [
                        [
                            35.5,
                            -40.8
                        ],
                        [
                            35.9,
                            -40.7
                        ],
                        [
                            36.2,
                            -41
                        ],
                        [
                            36.2,
                            -41.4
                        ],
                        [
                            35.8,
                            -41.5
                        ],
                        [
                            35.4,
                            -41.3
                        ],
                        [
                            35.4,
                            -41
                        ],
                        [
                            35.5,
                            -40.8
                        ]
                    ]
                ])
            },
            {
                name: "tretrecinque",
                coordinates: [
                    34.5,
                    -42.5
                ],
                geometry: new (0, $gP1US.Polygon)([
                    [
                        [
                            34.0,
                            -42.2
                        ],
                        [
                            34.5,
                            -42.1
                        ],
                        [
                            35.0,
                            -42.3
                        ],
                        [
                            35.0,
                            -42.7
                        ],
                        [
                            34.6,
                            -42.9
                        ],
                        [
                            34.1,
                            -42.8
                        ],
                        [
                            33.9,
                            -42.5
                        ],
                        [
                            34.0,
                            -42.2
                        ]
                    ]
                ])
            },
            {
                name: "venere",
                coordinates: [
                    36.5,
                    -41.8
                ],
                geometry: new (0, $gP1US.Polygon)([
                    [
                        [
                            36.2,
                            -41.5
                        ],
                        [
                            36.6,
                            -41.4
                        ],
                        [
                            36.9,
                            -41.6
                        ],
                        [
                            36.9,
                            -42
                        ],
                        [
                            36.6,
                            -42.2
                        ],
                        [
                            36.2,
                            -42
                        ],
                        [
                            36.1,
                            -41.7
                        ],
                        [
                            36.2,
                            -41.5
                        ]
                    ]
                ])
            }
        ],
        city3c: [
            {
                name: "felipe",
                coordinates: [
                    31.6,
                    -34.8
                ],
                geometry: new (0, $gP1US.Polygon)([
                    [
                        [
                            31.3,
                            -34.5
                        ],
                        [
                            31.7,
                            -34.4
                        ],
                        [
                            32.0,
                            -34.6
                        ],
                        [
                            32.1,
                            -35
                        ],
                        [
                            31.8,
                            -35.2
                        ],
                        [
                            31.4,
                            -35.1
                        ],
                        [
                            31.2,
                            -34.8
                        ],
                        [
                            31.3,
                            -34.5
                        ]
                    ]
                ])
            },
            {
                name: "mono",
                coordinates: [
                    30.2,
                    -36.5
                ],
                geometry: new (0, $gP1US.Polygon)([
                    [
                        [
                            30.3,
                            -36.2
                        ],
                        [
                            30.6,
                            -36.3
                        ],
                        [
                            30.7,
                            -36.6
                        ],
                        [
                            30.5,
                            -36.8
                        ],
                        [
                            30.1,
                            -36.9
                        ],
                        [
                            29.9,
                            -36.6
                        ],
                        [
                            30.0,
                            -36.3
                        ],
                        [
                            30.3,
                            -36.2
                        ]
                    ]
                ])
            },
            {
                name: "pinderbass",
                coordinates: [
                    32.5,
                    -34.8
                ],
                geometry: new (0, $gP1US.Polygon)([
                    [
                        [
                            32.3,
                            -34.4
                        ],
                        [
                            32.6,
                            -34.4
                        ],
                        [
                            32.8,
                            -34.7
                        ],
                        [
                            32.7,
                            -35.1
                        ],
                        [
                            32.5,
                            -35.3
                        ],
                        [
                            32.2,
                            -35.2
                        ],
                        [
                            32.1,
                            -34.9
                        ],
                        [
                            32.2,
                            -34.6
                        ],
                        [
                            32.3,
                            -34.4
                        ]
                    ]
                ])
            }
        ],
        city3d: [
            {
                name: "klein",
                coordinates: [
                    29.5,
                    -43.2
                ],
                geometry: new (0, $gP1US.Polygon)([
                    [
                        [
                            29.2,
                            -42.9
                        ],
                        [
                            29.6,
                            -42.8
                        ],
                        [
                            29.9,
                            -43
                        ],
                        [
                            30.0,
                            -43.3
                        ],
                        [
                            29.7,
                            -43.6
                        ],
                        [
                            29.3,
                            -43.5
                        ],
                        [
                            29.1,
                            -43.3
                        ],
                        [
                            29.2,
                            -42.9
                        ]
                    ]
                ])
            }
        ]
    };
    const backgroundPolygon = new (0, $gP1US.Polygon)([
        [
            [
                -90,
                45
            ],
            [
                -80,
                65
            ],
            [
                -55,
                75
            ],
            [
                -20,
                78
            ],
            [
                15,
                70
            ],
            [
                45,
                55
            ],
            [
                75,
                35
            ],
            [
                90,
                0
            ],
            [
                80,
                -40
            ],
            [
                55,
                -70
            ],
            [
                20,
                -80
            ],
            [
                -20,
                -78
            ],
            [
                -55,
                -70
            ],
            [
                -80,
                -40
            ],
            [
                -90,
                -5
            ],
            [
                -90,
                20
            ],
            [
                -90,
                45
            ]
        ]
    ], {
        symbol: {
            polygonFill: "#eeece2",
            polygonOpacity: 1,
            lineWidth: 10,
            lineColor: "#f7f5ee",
            lineOpacity: 1
        },
        cursor: "auto"
    });
    regionLayer.addGeometry(backgroundPolygon);
    let activeRegionId = null;
    function getRegionAtMapCenter() {
        const center = $e73bf42412feb220$var$map.getCenter();
        for (const region of regions){
            if (region.geometry.containsPoint(center)) return region.id;
        }
        return null;
    }
    function createComuneTooltip(comune) {
        if (!comune.tooltip) return null;
        let tooltipContent = comune.tooltip;
        if (comune.href) tooltipContent = `<a href="${comune.href}" class="tooltip-link" ${comune.target ? `target="${comune.target}"` : ""}>${comune.tooltip}</a>`;
        return new (0, $gP1US.ui).ToolTip(tooltipContent, {
            showTimeout: 200,
            animation: "fade",
            animationDuration: 200,
            animationOnHide: true,
            dx: 0,
            dy: 5,
            cssName: "custom-tooltip"
        });
    }
    function addComuniForCity(cityId) {
        const comuni = comuniData[cityId];
        for (const comune of comuni || []){
            const handleComuneClick = ()=>{
                if (comune.href) {
                    if (comune.target === "_blank") window.open(comune.href, "_blank", "noopener");
                    else window.location.href = comune.href;
                    return;
                }
                $e73bf42412feb220$var$openModalTracked(comune.name, {
                    section: "guitars",
                    typology: "guitar"
                });
                $e73bf42412feb220$var$map.animateTo({
                    center: comune.coordinates,
                    zoom: 10
                }, {
                    duration: 800,
                    easing: "out"
                });
            };
            if (comune.geometry) {
                comune.geometry.setSymbol({
                    polygonFill: "#d1cfc1",
                    polygonOpacity: 1,
                    lineWidth: 10,
                    lineColor: "#d1cfc1",
                    lineOpacity: 0.5
                });
                comune.geometry.setOptions({
                    cursor: "pointer"
                });
                comune.geometry.on("click", handleComuneClick);
                comuneLayer.addGeometry(comune.geometry);
            }
            const comuneMarker = new (0, $gP1US.Marker)(comune.coordinates, {
                symbol: {
                    markerWidth: 6,
                    markerHeight: 6,
                    markerType: "ellipse",
                    markerFill: "#333842",
                    markerLineWidth: 0
                }
            });
            const comuneNameLabel = new (0, $gP1US.Label)((0, $a305a376c9462dbd$export$8e831c751a9f504f)(comune.name), comune.coordinates, {
                textSymbol: {
                    textFaceName: "inter",
                    // textFaceName: "arimo",
                    textSize: 14,
                    textFill: "#333842",
                    textDy: 12
                },
                cursor: "pointer",
                boxStyle: {
                    padding: [
                        15,
                        15
                    ],
                    symbol: {
                        markerFill: "#d8d6cb",
                        markerLineWidth: 0,
                        markerFillOpacity: 0.01
                    }
                }
            });
            const tooltip = createComuneTooltip(comune);
            if (tooltip) tooltip.addTo(comuneNameLabel);
            comuneMarker.on("click", handleComuneClick);
            comuneNameLabel.on("click", handleComuneClick);
            comuneLayer.addGeometry(comuneMarker);
            comuneLayer.addGeometry(comuneNameLabel);
        }
    }
    function addComuniForRegion(region) {
        if (!region) return;
        for (const city of region.cities || [])addComuniForCity(city.id);
    }
    function addCitiesForRegion(regionId) {
        const region = regions.find((r)=>r.id === regionId);
        if (!region) return;
        for (const city of region.cities || []){
            const cityNameLabel = new (0, $gP1US.Label)(city.name.toUpperCase(), city.coordinates, {
                textSymbol: {
                    textFaceName: "inter",
                    textSize: 16,
                    textFill: "#636363",
                    textDy: 0,
                    textWeight: "bold"
                },
                cursor: "pointer",
                boxStyle: {
                    padding: [
                        15,
                        15
                    ],
                    symbol: {
                        markerFill: "#d8d6cb",
                        markerLineWidth: 0,
                        markerFillOpacity: 0.01
                    }
                }
            });
            cityNameLabel.on("click", ()=>{
                activeRegionId = regionId;
                $e73bf42412feb220$var$openModalTracked(city.name, {
                    section: region.section,
                    typology: region.section === "guitars" ? "series" : null
                });
                $e73bf42412feb220$var$map.animateTo({
                    center: city.coordinates,
                    zoom: 9
                }, {
                    duration: 1000,
                    easing: "out"
                });
            });
            // Setup city polygon styling and add to layer
            if (city.geometry) {
                city.geometry.setSymbol({
                    polygonFill: "#d8d6c9",
                    polygonOpacity: 1,
                    lineWidth: 10,
                    lineColor: "#d8d6c9",
                    lineOpacity: 0.5
                });
                city.geometry.setOptions({
                    cursor: "pointer"
                });
                city.geometry.on("click", ()=>{
                    activeRegionId = regionId;
                    $e73bf42412feb220$var$openModalTracked(city.name, {
                        section: region.section,
                        typology: region.section === "guitars" ? "series" : null
                    });
                    $e73bf42412feb220$var$map.animateTo({
                        center: city.coordinates,
                        zoom: 9
                    }, {
                        duration: 1000,
                        easing: "out"
                    });
                });
                cityLayer.addGeometry(city.geometry);
            }
            cityLayer.addGeometry(cityNameLabel);
        }
    }
    function updateLayerVisibility() {
        const currentZoom = $e73bf42412feb220$var$map.getZoom();
        cityLayer.clear();
        comuneLayer.clear();
        cityLayer.hide();
        comuneLayer.hide();
        const regionAtCenter = getRegionAtMapCenter();
        if (regionAtCenter && activeRegionId !== regionAtCenter) activeRegionId = regionAtCenter;
        else if (!regionAtCenter && activeRegionId) activeRegionId = null;
        if (activeRegionId) {
            const region = regions.find((r)=>r.id === activeRegionId);
            if (region) {
                const isContactsRegion = region.section === "contacts";
                if (currentZoom >= 5 && currentZoom < 8) {
                    if (isContactsRegion) {
                        addComuniForRegion(region);
                        comuneLayer.show();
                    } else {
                        addCitiesForRegion(region.id);
                        cityLayer.show();
                    }
                } else if (currentZoom >= 8) {
                    if (!isContactsRegion) {
                        addCitiesForRegion(region.id);
                        cityLayer.show();
                    }
                    addComuniForRegion(region);
                    comuneLayer.show();
                }
            }
        }
    }
    regions.forEach((region)=>{
        region.geometry.setId(region.id);
        region.geometry.setSymbol({
            polygonFill: "#e4e2d7",
            lineWidth: 5,
            lineColor: "#e4e2d7"
        });
        region.geometry._setOptions({
            cursor: "default"
        });
        const regionNameLabel = new (0, $gP1US.Label)(region.name, region.center, {
            textSymbol: {
                textFaceName: "inter",
                textSize: 28,
                textFill: "#636363",
                textHaloFill: "#333",
                textHaloRadius: 0,
                textWeight: "200"
            },
            cursor: "pointer"
        });
        const handleRegionClick = ()=>{
            activeRegionId = region.id;
            // 1. Prima chiudiamo la modale (animazione slide out)
            if ($e73bf42412feb220$var$isModalOpen) $e73bf42412feb220$var$closeModalTracked();
            // 2. Resettiamo la memoria e la freccia
            $e73bf42412feb220$var$lastModalArgs = null;
            const arrowBtn = document.querySelector(".arrow__btn");
            if (arrowBtn) arrowBtn.classList.remove("is-open");
            // 3. Nascondiamo tutto completamente dopo un breve delay per mostrare il movimento
            (0, $357b3f2d5f2ec9d5$export$99ee26438460406a).to(".overlay__modal", {
                delay: 0.4,
                opacity: 0,
                duration: 0.5,
                onComplete: ()=>{
                    const modalEl = document.querySelector(".overlay__modal");
                    if (modalEl) modalEl.style.display = "none";
                }
            });
            $e73bf42412feb220$var$map.animateTo({
                center: region.center,
                zoom: 6
            }, {
                duration: 1000,
                easing: "out"
            });
        };
        regionNameLabel.on("click", handleRegionClick);
        region.geometry.on("click", handleRegionClick);
        regionLayer.addGeometry(region.geometry);
        regionLayer.addGeometry(regionNameLabel);
    });
    $e73bf42412feb220$var$map.on("zoomend", updateLayerVisibility);
    $e73bf42412feb220$var$map.on("moveend", updateLayerVisibility);
    updateLayerVisibility();
    // Listen for guitar-select events from swiper slides in series modal
    document.addEventListener("guitar-select", (e)=>{
        const guitarName = e.detail?.guitarName;
        if (!guitarName || !$e73bf42412feb220$var$map) return;
        // Find the guitar's coordinates in comuniData
        let guitarCoordinates = null;
        for (const cityId of Object.keys(comuniData)){
            const comuni = comuniData[cityId];
            const found = comuni.find((c)=>c.name.toLowerCase() === guitarName.toLowerCase());
            if (found) {
                guitarCoordinates = found.coordinates;
                break;
            }
        }
        // Center the map on the guitar
        if (guitarCoordinates) $e73bf42412feb220$var$map.animateTo({
            center: guitarCoordinates,
            zoom: 10
        }, {
            duration: 800,
            easing: "out"
        });
    });
};
// --- LOGICA PAGINA PRODOTTO ---
function $e73bf42412feb220$var$initProductPage() {
    const overlay = (0, $a305a376c9462dbd$export$2e6c959c16ff56b8)(".overlay");
    const elImage = (0, $a305a376c9462dbd$export$2e6c959c16ff56b8)(".element__image__wrapper img");
    const closeOverlay = (0, $a305a376c9462dbd$export$2e6c959c16ff56b8)(".overlay__close");
    const count = (0, $a305a376c9462dbd$export$2e6c959c16ff56b8)(".count");
    const countOf = (0, $a305a376c9462dbd$export$2e6c959c16ff56b8)(".of");
    const bottomLeft = (0, $a305a376c9462dbd$export$2e6c959c16ff56b8)(".bottom__left");
    const imgWrapper = (0, $a305a376c9462dbd$export$2e6c959c16ff56b8)(".overlay__img__wrapper");
    const contentImages = (0, $a305a376c9462dbd$export$90aca4adda6ff0f5)(".element__content__image img");
    if (!imgWrapper) return;
    // --- Build slides from element__content__inner sections ---
    const details = (0, $357b3f2d5f2ec9d5$export$99ee26438460406a).utils.toArray(".element__content__inner");
    const slides = []; // { img: HTMLImageElement, caption: string }
    details.forEach((detail)=>{
        const detailImgs = detail.querySelectorAll(".element__content__image img");
        const detailTexts = detail.querySelectorAll(".element__content__text p:not(.english)");
        const captionHtml = detailTexts.length ? Array.from(detailTexts).map((p)=>p.outerHTML).join("") : "";
        detailImgs.forEach((srcImg)=>{
            const newImg = document.createElement("img");
            newImg.className = "image";
            newImg.src = srcImg.getAttribute("src");
            newImg.alt = srcImg.getAttribute("alt") || "";
            imgWrapper.appendChild(newImg);
            slides.push({
                img: newImg,
                caption: captionHtml
            });
        });
    });
    if (!slides.length) return;
    // Reverse to match original stacking order (last on top)
    slides.reverse();
    const images = slides.map((s)=>s.img);
    const captions = slides.map((s)=>s.caption);
    const wrap = (0, $357b3f2d5f2ec9d5$export$99ee26438460406a).utils.wrap(0, images.length);
    if (count) count.textContent = String(1);
    if (countOf) countOf.textContent = `0${images.length}`;
    const updateCaption = (index)=>{
        if (!bottomLeft) return;
        bottomLeft.innerHTML = captions[index] || "";
    };
    let animating = false;
    let currentIndex = 0;
    function gotoSection(index, direction) {
        if (!count) return;
        animating = true;
        index = wrap(index);
        const tl = (0, $357b3f2d5f2ec9d5$export$99ee26438460406a).timeline({
            defaults: {
                duration: 1,
                ease: "expo.inOut"
            },
            onComplete: ()=>{
                animating = false;
            }
        });
        tl.set(count, {
            textContent: String(`0${index + 1}`)
        }, 0.32).add(()=>updateCaption(index), 0.32).fromTo(images[index], {
            xPercent: 125 * direction,
            scaleX: 1.5,
            scaleY: 1.3
        }, {
            xPercent: 0,
            scaleX: 1,
            scaleY: 1,
            duration: 1
        }, 0).fromTo(images[currentIndex], {
            xPercent: 0,
            scaleX: 1,
            scaleY: 1
        }, {
            xPercent: -125 * direction,
            scaleX: 1.5,
            scaleY: 1.3
        }, 0).timeScale(0.8);
        currentIndex = index;
    }
    let observerInstance = null;
    (0, $d7385dda6eeeec57$export$c1cbdee04e18ea8b).create({
        id: "page-overlay",
        type: "wheel,touch,pointer",
        preventDefault: true,
        wheelSpeed: -1,
        onUp: ()=>{
            if (!animating) gotoSection(currentIndex + 1, 1);
        },
        onDown: ()=>{
            if (!animating) gotoSection(currentIndex - 1, -1);
        },
        tolerance: 10
    });
    observerInstance = (0, $d7385dda6eeeec57$export$c1cbdee04e18ea8b).getById("page-overlay");
    if (observerInstance) observerInstance.disable();
    const onKeydown = (e)=>{
        if (animating) return;
        if (e.key === "ArrowUp" || e.key === "ArrowLeft") gotoSection(currentIndex - 1, -1);
        if (e.key === "ArrowDown" || e.key === "ArrowRight" || e.key === "Enter") gotoSection(currentIndex + 1, 1);
    };
    // --- Funzione per aprire/chiudere la gallery ---
    const openGallery = ()=>{
        if (!elImage || !overlay) return;
        elImage.classList.add("active");
        overlay.classList.add("active");
        updateCaption(currentIndex);
        observerInstance?.enable();
        document.addEventListener("keydown", onKeydown);
    };
    const closeGallery = ()=>{
        if (!elImage || !overlay) return;
        elImage.classList.remove("active");
        overlay.classList.remove("active");
        observerInstance?.disable();
        document.removeEventListener("keydown", onKeydown);
    };
    if (elImage && overlay) elImage.addEventListener("click", ()=>{
        if (overlay.classList.contains("active")) closeGallery();
        else openGallery();
    });
    if (closeOverlay) closeOverlay.addEventListener("click", ()=>{
        closeGallery();
    });
    // --- Auto-open gallery all'arrivo sulla pagina prodotto ---
    const galleryDelay = 100;
    $e73bf42412feb220$var$autoOpenGallery = false;
    openGallery();
    // setTimeout(() => {
    //   openGallery();
    // }, galleryDelay);
    if (contentImages?.length) contentImages.forEach((img)=>{
        (0, $357b3f2d5f2ec9d5$export$99ee26438460406a).set(img, {
            opacity: 0,
            y: 30,
            scale: 0.95
        });
        const tl = (0, $357b3f2d5f2ec9d5$export$99ee26438460406a).timeline({
            paused: true,
            smoothChildTiming: true,
            onComplete: ()=>(0, $357b3f2d5f2ec9d5$export$99ee26438460406a).set(img, {
                    clearProps: "opacity,transform"
                }),
            onReverseComplete: ()=>(0, $357b3f2d5f2ec9d5$export$99ee26438460406a).set(img, {
                    opacity: 0,
                    y: 30,
                    scale: 0.95
                })
        });
        tl.to(img, {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: 1.2,
            ease: "power2.out"
        });
        (0, $daf8bee9365fb629$export$875bcbe48555930).create({
            animation: tl,
            trigger: img,
            start: "top 75%",
            end: "top 25%",
            scrub: true,
            fastScrollEnd: true
        });
    });
}
// --- LOGICA LOADER ---
const $e73bf42412feb220$var$initLoader = ()=>{
    $e73bf42412feb220$var$loaderInstance.start();
    $e73bf42412feb220$var$loaderInstance.end();
    $e73bf42412feb220$var$loaderInstance.animation.eventCallback("onComplete", ()=>{
        $e73bf42412feb220$var$loaderInstance.hide();
        const introWrapper = (0, $a305a376c9462dbd$export$2e6c959c16ff56b8)(".intro__wrapper");
        const enter = (0, $a305a376c9462dbd$export$2e6c959c16ff56b8)(".intro__enter");
        const overlay = (0, $a305a376c9462dbd$export$2e6c959c16ff56b8)(".overlay__loader");
        if (!introWrapper || !enter || !overlay) return;
        (0, $357b3f2d5f2ec9d5$export$99ee26438460406a).to(introWrapper, {
            duration: 1,
            display: "flex",
            opacity: 1
        });
        const introImages = (0, $a305a376c9462dbd$export$90aca4adda6ff0f5)(".intro__images__wrapper .intro__img");
        // Pause all videos, start only the active one
        // function syncVideos(index) {
        //   introImages.forEach((el, i) => {
        //     if (el.tagName === "VIDEO") {
        //       if (i === index) {
        //         el.play();
        //       } else {
        //         el.pause();
        //         el.currentTime = 0;
        //       }
        //     }
        //   });
        // }
        if (introImages.length) {
            const wrap = (0, $357b3f2d5f2ec9d5$export$99ee26438460406a).utils.wrap(0, introImages.length);
            let animating = false;
            let currentIndex = 0;
            // Headline
            const introHeadline = (0, $a305a376c9462dbd$export$2e6c959c16ff56b8)(".intro__headline");
            const introTexts = [
                "quality<br>beyond<br>the surface",
                "tarazum: onomatopoeia<br>representing the typical<br>sound of a fanfare or band.",
                "genuine<br>handcrafted<br>italian guitars"
            ];
            introImages.forEach((img, i)=>{
                (0, $357b3f2d5f2ec9d5$export$99ee26438460406a).set(img, {
                    xPercent: i === 0 ? 0 : 1,
                    scaleX: i === 0 ? 1 : 5,
                    scaleY: i === 0 ? 1 : 1.3,
                    opacity: i === 0 ? 1 : 0,
                    zIndex: introImages.length - i
                });
            });
            if (introHeadline) introHeadline.innerHTML = introTexts[0];
            // eslint-disable-next-line no-inner-declarations
            function gotoSection(index, direction) {
                animating = true;
                index = wrap(index);
                const tl = (0, $357b3f2d5f2ec9d5$export$99ee26438460406a).timeline({
                    defaults: {
                        duration: 5,
                        ease: "expo.inOut"
                    },
                    onComplete: ()=>{
                        animating = false;
                    }
                });
                tl.fromTo(introImages[index], {
                    xPercent: 125 * direction,
                    scaleX: 1.5,
                    scaleY: 1.3,
                    opacity: 0
                }, {
                    xPercent: 0,
                    scaleX: 1,
                    scaleY: 1,
                    opacity: 1,
                    duration: 5
                }, 0).fromTo(introImages[currentIndex], {
                    xPercent: 0,
                    scaleX: 1,
                    scaleY: 1,
                    opacity: 1
                }, {
                    xPercent: -125 * direction,
                    scaleX: 1.5,
                    scaleY: 1.3,
                    opacity: 0
                }, 0)// Fade out text
                .to(introHeadline, {
                    duration: 0.4,
                    opacity: 0,
                    ease: "power2.in",
                    delay: 0.4
                }, 0)// Text change
                .call(()=>{
                    introHeadline.innerHTML = introTexts[wrap(index) % introTexts.length];
                }, [], 4.2).to(introHeadline, {
                    duration: 0.6,
                    opacity: 1,
                    ease: "power2.out"
                }, 4.2).timeScale(0.8);
                currentIndex = index;
            }
            (0, $d7385dda6eeeec57$export$c1cbdee04e18ea8b).create({
                id: "intro-overlay",
                type: "wheel,touch,pointer",
                preventDefault: true,
                wheelSpeed: -1,
                onUp: ()=>{
                    if (!animating) gotoSection(currentIndex + 1, 1);
                },
                onDown: ()=>{
                    if (!animating) gotoSection(currentIndex - 1, -1);
                },
                tolerance: 10
            });
            // Autoplay
            (0, $357b3f2d5f2ec9d5$export$99ee26438460406a).delayedCall(3, function autoNext() {
                if (!animating) gotoSection(currentIndex + 1, 1);
                (0, $357b3f2d5f2ec9d5$export$99ee26438460406a).delayedCall(3, autoNext);
            });
        }
        enter.onclick = (e)=>{
            (0, $d7385dda6eeeec57$export$c1cbdee04e18ea8b).getById("intro-overlay").disable();
            e.preventDefault();
            (0, $357b3f2d5f2ec9d5$export$99ee26438460406a).to(overlay, {
                duration: 0.3,
                opacity: 0,
                onComplete: ()=>{
                    overlay.style.pointerEvents = "none";
                    overlay.style.zIndex = -1;
                }
            });
        };
    });
};
// --- BARBA JS CONFIG ---
(0, (/*@__PURE__*/$parcel$interopDefault($f233fb7ce3af900a$exports))).init({
    sync: true,
    debug: true,
    views: [
        {
            namespace: "home",
            beforeEnter () {
                const loader = document.querySelector(".overlay__loader");
                if (loader && !$e73bf42412feb220$var$isFirstLoad) (0, $357b3f2d5f2ec9d5$export$99ee26438460406a).set(loader, {
                    autoAlpha: 0,
                    zIndex: -1
                });
            },
            afterEnter () {
                $e73bf42412feb220$var$initHomeMap();
                $e73bf42412feb220$var$initUIEvents();
                // --- LOGICA RITORNO MODALE ---
                // Se siamo tornati da un prodotto via modale, riapriamo la modale
                if ($e73bf42412feb220$var$restoreModal && $e73bf42412feb220$var$lastModalArgs) {
                    // Usiamo un piccolo ritardo per assicurarci che il DOM e la Mappa siano pronti
                    setTimeout(()=>{
                        // Riaprendo la modale, openModal.js dovrebbe reinizializzare Swiper
                        $e73bf42412feb220$var$openModalTracked($e73bf42412feb220$var$lastModalArgs.elName, $e73bf42412feb220$var$lastModalArgs.options);
                    }, 300); // Ritardo leggero per sync con animazione
                    // Reset flag
                    $e73bf42412feb220$var$restoreModal = false;
                }
            },
            beforeLeave () {
                $e73bf42412feb220$var$destroyMap();
            }
        },
        {
            namespace: "product",
            afterEnter () {
                $e73bf42412feb220$var$initProductPage();
                $e73bf42412feb220$var$initUIEvents();
            },
            beforeLeave () {
                (0, $daf8bee9365fb629$export$875bcbe48555930).getAll().forEach((t)=>t.kill());
                const obs = (0, $d7385dda6eeeec57$export$c1cbdee04e18ea8b).getById("page-overlay");
                if (obs) obs.kill();
            }
        }
    ],
    transitions: [
        // TRANSITION 1: Home -> Product (Click su .modal__image)
        // Effetto: La modale diventa bianca, si espande a tutto schermo da DX a SX, poi fade-in pagina
        {
            name: "home-to-product",
            from: {
                namespace: "home"
            },
            to: {
                namespace: "product"
            },
            custom: ({ trigger: trigger })=>{
                return trigger.classList && trigger.classList.contains("modal__image");
            },
            leave (data) {
                // Flag per riaprire la modale al ritorno
                $e73bf42412feb220$var$restoreModal = true;
                // Flag per aprire automaticamente la gallery sulla pagina prodotto
                $e73bf42412feb220$var$autoOpenGallery = true;
                const done = this.async();
                // Selezioniamo la modale e il suo contenuto
                const modalDialog = data.current.container.querySelector(".overlay__modal");
                const modalContent = modalDialog ? modalDialog.children : [];
                const tl = (0, $357b3f2d5f2ec9d5$export$99ee26438460406a).timeline({
                    onComplete: done
                });
                if (modalDialog) {
                    // 1. Nascondiamo istantaneamente il contenuto della modale (testi, bottoni)
                    // lasciando solo il box bianco
                    tl.to(modalContent, {
                        opacity: 0,
                        duration: 0.2,
                        ease: "power1.out"
                    });
                    // 2. Espandiamo il box bianco da destra a sinistra
                    // Usiamo fromTo per forzare le coordinate di partenza corrette
                    tl.fromTo(modalDialog, {
                        maxWidth: "480px",
                        width: "33%",
                        backgroundColor: "#ffffff",
                        zIndex: 9999
                    }, {
                        width: "100%",
                        maxWidth: "100%",
                        duration: 0.8,
                        ease: "expo.inOut",
                        clearProps: "all"
                    }, "<");
                } else // Fallback di sicurezza se non trova la modale
                tl.to(data.current.container, {
                    opacity: 0,
                    duration: 0.5
                });
            },
            enter (data) {
                // La nuova pagina entra in Fade In sopra il box bianco espanso
                return (0, $357b3f2d5f2ec9d5$export$99ee26438460406a).from(data.next.container, {
                    opacity: 0,
                    duration: 0.6,
                    delay: 0.2,
                    ease: "power2.out",
                    zIndex: 10000,
                    clearProps: "all"
                });
            }
        },
        // TRANSITION 2: Product -> Home (Click su .back)
        // Manteniamo lo slide out verso destra che funzionava bene ed è coerente
        {
            name: "back-to-home",
            from: {
                namespace: "product"
            },
            to: {
                namespace: "home"
            },
            custom: ({ trigger: trigger })=>{
                return trigger.classList && trigger.classList.contains("back");
            },
            leave (data) {
                // Il Prodotto scivola via verso destra scoprendo la home sotto
                return (0, $357b3f2d5f2ec9d5$export$99ee26438460406a).to(data.current.container, {
                    x: "100%",
                    opacity: 1,
                    duration: 0.8,
                    ease: "expo.inOut",
                    zIndex: 1000
                });
            },
            enter (data) {
                // La Home appare sotto (statica o leggero fade)
                return (0, $357b3f2d5f2ec9d5$export$99ee26438460406a).from(data.next.container, {
                    opacity: 0.5,
                    duration: 0.8,
                    ease: "power2.out",
                    clearProps: "all"
                });
            }
        },
        // TRANSITION 3: Fallback generico
        {
            name: "default-fade",
            leave (data) {
                return (0, $357b3f2d5f2ec9d5$export$99ee26438460406a).to(data.current.container, {
                    opacity: 0,
                    duration: 0.5
                });
            },
            enter (data) {
                return (0, $357b3f2d5f2ec9d5$export$99ee26438460406a).from(data.next.container, {
                    opacity: 0,
                    duration: 0.5
                });
            }
        }
    ]
});
// Primo caricamento
window.addEventListener("DOMContentLoaded", ()=>{
    const container = document.querySelector('[data-barba="container"]');
    const ns = container.getAttribute("data-barba-namespace");
    if (ns === "home" && document.querySelector(".overlay__loader")) {
        $e73bf42412feb220$var$initLoader();
        $e73bf42412feb220$var$initHomeMap();
    } else if (ns === "product") {
        const l = document.querySelector(".overlay__loader");
        if (l) l.style.display = "none";
        $e73bf42412feb220$var$initProductPage();
    }
    $e73bf42412feb220$var$initUIEvents();
    $e73bf42412feb220$var$isFirstLoad = false;
});


//# sourceMappingURL=diapason.04cb2868.js.map
